// Copie de travail de la maquette v214 (maquette/app.js).
// Seules différences : React est importé (au lieu d'être chargé depuis cdnjs)
// et le montage de l'écran se fait dans main.jsx (pour que les tests puissent
// afficher le composant eux-mêmes).
import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  P_GERANT, P_ADMIN, P_ADV_SR, P_ADV_JR, P_PROD, P_BT, P_COM, P_AGENT, P_POSE, P_MKT, ONGLETS_ACCES, LIB_NIVEAU_ACCES, DROITS, ONG, DEFAULT_PROFILS, ORDRE_PROFILS, DEFAULT_COMPTES, construireUtilisateur,
} from "../../shared/droits.js";
import { EXTENSIONS_FICHIERS, TAILLE_MAX_FICHIER, TYPES_FICHIERS_LISIBLES, extensionFichier } from "../../shared/fichiers.js";
import { TYPES_CLIENT, normaliserClient } from "../../shared/clients.js";
import { lotUtilisableListello, quantiteListelloValide } from "../../shared/listello.js";
import { phraseArretee } from "../../shared/montant-en-lettres.js";
import { MOYEN_COMPOSITION_TYPE, PRORATA_DEFAUT, RETENUE_DEFAUT, conditionsMarche, moyensValidationDessin, deductionsFacture, montantsFactureAvance, prorataRegleParClient, sommeDeductions } from "../../shared/projets.js";

// ---- Palette Stone Concept ----
const ENCRE = "#281E1E";
const TAUPE = "#8C8282";
const PIERRE = "#F2EFED";
const ROUILLE = "#A8502F"; // accent alerte, ton "oxydation de pierre"
const VERT_OK = "#4B6B4F"; // stock sain, ton mousse discret
const OCRE = "#9C7A3C"; // accent réservation, ton "grès"

// Logo officiel Stone Concept (version principale Logo.jpg de la charte,
// détouré sur fond transparent — couleur et proportions préservées)
const LOGO_SRC =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWgAAAB5CAYAAAAUGLtfAABPEklEQVR42u29eZxcVZk3/n3Ocm91ls4CCAmgjiJi2gVxUHDUUWHcl3GpcsZXHZ3xTcaFQZIgEdJ963Z1Aph0h8y4Bbd5dfzNO1W4vjqOK7gzCsqoHVBxASEBhGyddNe995zz/P6493ZXd7qTTqeX6qSez6c+XV3LrXvOec73PPtDH9xyPaNFLWpRi1rUFMTsUPALODAw0KPqQ9HftqakRS1qUYuah6wxEg53tGaiRS1qUYualKharcrWNLSoRS1qUXNRf39/y/zcoha1qEVNK0FPxzWYGeVymcoAytmLO3fuJAAoZv/Xsue17P/imNfG+9xk3sMRXkMxe6UG9K9axQAQhmF+KnHDHEz1pKJisSgaf3fVqlUEwIVh6JiZyuWy7Ojo4FqtdtTxz8bcTMe10PB//6pVHIahmw5mDIJANP6/c+dOKh7hXqc6/snMDQ7jIwC1GlAsDks24/DStMxBR0cHNfLLTK5n4/soFlEqldyxjKdYLMrJ7MWp3vPY9QCAarXqiGi8eacgCKgjw56TFtSLxaK8OQhUEARqPg4gyO69Wq3KsaAwXQfccV53vs2nmOr38nWYr2MvFosy5ydmPl5gmHNgqRaLk1oLZqZpGO+UKfttGue1k1OCzk/2Uqlkx7zuLQSWC6CdhVgmFBZIQDkSBDu1m3LOkRCCx3ttvPcmvoZjdiKBlIdYiH0FFR141GOxp1QK47FMORVJMAgCsVipi4jNUiJlnHMspFzAwIPrNm68dVsQLDVaXEwEI5ygI41rOuZoMp9zzhEATOU3G0kIwYkxHoTYeWVn5x+YGUTEk9lYtVpNjOWjarUq7+nvP8VJuUQLsYStXUjCaUA1xUHnhGN2LvKUPFRPcBDWDqj2A3vXrds2NJ5EWarVpsT9fT3BBYnDSk0qnq2xCSHYGeNBugfXbgxvY2aaxFoSAGzbHD7TJDhVCpHMKFA5RywEE5EcpEO3XXPNtQ+P4TkCgBuC4Gwj5flScOIcEZpdhDTZ3wnu82i3n6rwqepjM1BqX6rU+Qz3bAaeAdDjAJwBwgICCsTwHCDADBKUb8qRC9LRzwRJItVeGj6bvyalOOqxwpx+jkGAYAu2hpwbiiIx9Mdf066+SvcfiPAzR/xDFbvbS2F4YFh6KBZRLBbdZMAmHQ/f4HuFC6M4Np6nlDFmAAKvvDkI1E+V/P/atH5pnCSOiIWU6RgaLzzea5Oho32PGj7X+Kn0e5jUbx5prRxbLFxQQH1oaC2AbbVaTQLjHsmUr0m5XJZEZADYIAjUEo3zGeLZcHjmH3+18xyp5UoBLAZbnwR5ICEApsnwzAyKamAAggkMYa1FogTqRLKOwWUP9VbK94DQT1C36iT5yWVhuKs2fOgUZak0OaAOgkCkZjG6ZlFb22vr9ToLIWhmhjR65a0zrD1FiTH3bdq06QIievhopr8gCCgMQ+cMeha0+ZdGcewIEDPl1WJJAJhJELVZ768AfLNWKg3zXLVaFaVSyVqlLmnz9SeiOIaQNI3GpxkieWQj2UQATUEQEAARhqGp1WrYEoYXkqA3EvFLGfwEz/MFmOGcSx/M4PRI42zSaAwj8DGoIZxxEh32Ghgp8h7tAswNOKWIeSkJsVQQrZBSPgPA6+IkgdHiV32V7m8w2U+XNoY/Rq2GHTt2aACTkggYiG0qpsI6PugIxfXXBN/p7Qk/VPC8l9ajKCEiwYAdbxV4ihx0tO/xOM+O9feOtFbMbJ1zElKao12mWCzKcrnMYRiaGzZtOt3Cvokcisx8vud5PhFgrQNn/MQAE4EB4vSnePbgOJXK3ATaJQHwCCgIQSAhzpBCPxVErzTGwCi5u7en+7tS4FOXX935VSqRDYJAhWFoJnsDAhSzcwyCZeaZ0h547EGcGOO0VmdRkrwIwGeqxaI8khaQrSdAHFnnGIDhEbiZkUOFiGCtBYSwmbqS+gVGTSAnzjnHyOev2RGajojQaqLJKJfLIgxD07s5OAdOdhFQ9LQuGGvhnLNRFCUgckiZSBBRo8Q19lfpqHcy+o7HAeZxXzvqNTLxi7MFg2OGsdaBiMEspZRPVEo9MY7jNX2V8LNOumDNmjW/LhaLsjYJNZUYjggkABhn3r6+s/y1vu5yRWvvHRk4y+x+56N9jI+wWZiZBdxRN5YgIsvM1K7FOx3bq3ytH+2YYYxxSZLEmUpNI3hBk+PeideejzqoDIgb1GQBQAgiQUSShAARjboB54YPEbbMBs45m84DpZYCscLX6g3G2Dfc0NPzrW0i7Lzi6uBHuXQ8qQknEAMEBoNmDF3oCC+/DsBnitWq43QteAKAzuZZgEb220zyOGcTTXyk485CQEIQkB2y82Xb0QQH9li8yWyEYRiard3dbyUnbvU9780AvCiOE+ecyXaRJEATkcx21HiLNN6i0VEeRwPsKV2DGh/pvSsignPOxHEcA5C+7/+NcPLW3krlH2q1mj2a46dcLjOIpVaKjOV3rO8s/0dfJVyvfW9jYkycgTPmKThPOM+UovNRxxQEgSAitz0I2m/YXKn52vsgET06iuPYGGMy3FPZPFHGj0fiowkfnGpwubg90fuOmV0GzlJKqX3P0wXf95SSKtMv9lnm31lr/scY86M4MT+IE/ODJDG3W2d/w473EJH10u/5UsoCEenswIrjOImdc0ZrdQlY3NzbE74nDEOXOUJpEkciU86xkxj3FB/jYoGx1jGJF2yvVB5PRFyr1cTR0IRSyQyzoeVQtnuP5j85kYKH1dhNUKvVqFQq2d4w3Kg9VTHGIMrU9AbAOVGIGoCBoziOiWiZVvJjvZXw7HWdQfn5z4fKTDaHrXutVhME8g8dGrxyfRB+bGul/A4h5RZjrMHMqafzZm7L5TIvBZYarb7U5nvPrdejONO21OSlumPYvKOv4TgVzZlTTUlKKSSRgEkSOOf2GmPvsTA7AfzCMe0UoN9KKR/aE8d7JzJLXHvttctkvX42A+eDcTGBL2aiJ/paFxhAkiQMIInjeAhEnq+9bVsrwYJSqbS5Wq3Ksc7RplksImLnbMH3l9bj+LUAtuzdu1dM4FeYI3dAGrlhs2Xu7+/P/RuUSfSYrO9oPgI0B0EgS6WS6esuX+4V/EocxyZj8pMh25AAKMecJMaw73nBlu7ywAteUO6daGP19/cvXKJw9fog/PrW7u63Kin+hZlNJk2c1ADNQUDlchntSny8zfeeOzRUrxORh+OLOz+ijTK3RAAQUggllIIgQpwkzjl7j7Xm5yToVjhxqzPu5+vD8OFG4FWufqaweFa7ohW93d3LIdAOwKPUDnLIsXsYSXI/PNz1q3vu+/cbb7zxUwBwQ3f3E6IkfjGYXwESz9JKLSUCksQgTpJIK6+nt6f7vlKp9KljMXfMAUjDOgdifn01CLaX1qxJ0KLmAOhisSjDMDTbNocXg8X1SZLY8WINTwKUlszs4iRJlJTXbatUbi+VSrdkIO3Q4Owsl8uDazvDr/f2dL9FCnFjFhvKJzs4B0GgKAxNX0/3ak/r1w5FUQzAz+Yuf0wHX9lctSYirZSClFIaY2CM3WWduR0C3yGI75x17rk/yw/Z668PVmoSz9ra032BYPd0Bj2BTHwmQ7QLLaUUekS9ytV3IiDzYSQJJ+c9+swH+7rLvyQhbnGw31i3MfwAgA9sDYJTE8JLiPEqZv4LKeVKT2s4a/95S6XynSs7O+/JHIe2CbVxaYxxIHr6fUJcCOAHk/XFzJVUedIAdLVadeVy2WOH92ut/DiOk5NEch6lQhERE5FgZqukVMaZa7dv3/78/v7+JAstYiB1kpTLZbtUy78H0Y2cRrK4TIU/6UD5tEzdzEwbdrnnnWbZXG2sZQIEGlTPzHHIU1wjBuAotUVqrRSss0gSc9AkyS8TY24RTF9TDy350eX/cnkEAB/YvPmc+39915v7KuFfMnABxfgzpdRiKVP2NsakkiPgEmMM0TjeuewkyPwtikicpXx1FgEviRNs7quEv2bCt9ji8wdi+3/DMPy33iuuaHNLl75wyA6+REj1Smnde4MguGzlypUZ3I83vswZljqxZ38PALbgebper782A2jUxkZKtGh2AbparUoislu7gxdJIZ8Tx7ElIjkmvolOJuAhIpkYk2itL7IH9788DMPPZZmTDgBlaqpoV+IdSkpprI2RhhnN14iNaaFqtSqIyPb2hG/wtfeYOEniRkHgOLO9nBRCaa1lBqr31aPohw78n1bzzRs2hPcCwPuD4Ax5xv7X9FbCS4hwYWzNeUorXwoBYy2stUiMsYkxjCxSoyE5gyZweGW+Uc7Mtc7FcexyXhFSnqeUOs8Y8652S7/rq4TfZcKXEl345lVXXfUVAJf1bg7O2fnznRSGYXIEFc6XUlJsDNGIHZ1mTStjFokxIKJXbd++PSyVSgdmyizVokkANDNTrVQCAAgSb5BSpmFogKSTTxTMw64o35JCEJKE/xbA58YIcgSA+3oqQ4IolxJPWmD+U0cHZ6YyV61W5X2/uuv1jvmww2oKknNuUmKtlDLW/DGK4y+D6Qv7jb0lDMO4Wq3KP9x550W9lcrbAXspgZ6qlV5IRHDWwliLJEmSJAVjagjra4xGmIwQ0sgahIY0A+eciaKIiUhIKR6npHwcM78Vcf2Rvp7KfxPcN5yhmy+66CJv1apVUW6HHpu1RyR+H8XxATAv9HxPEghJksA6F2c/Khs0CeTAPR3OsfwwsNZapeQ5yf79LwTwhTwJpFl4zZxE+0qUy2Uq1Wr2Q9deu4xBz8lOz5MSaCijBo6lJDEA8MwbNm06PQxDM45dXpzMEnMjZWF1/Pu77nocwOcbY3C8yRbMLJiZtdbKGPMl47lnrt3Y9U425rZ2KV+7raf73/74qzvv1pK+7/uq09PexSBamCSJiePYGGsNAJuFVsrMBDXd60XZdSUAcs6ZKI6TxBgjhDhFa/kyKdU2reUdGDrUG4ahy+uX5MCaA/bajZ3rRWzOVkwXJpF5YxTFH7DO/cH3PE8KoTk1ow3zamaSmzbpNo8Ll0KCBJeAVtnLOQXo/ASOOD5PEM7KGKAFOMgdRM4KEo+2HP8ZMBKgf6KF80wHdXR0EAD4gs+XSi3JgPF4w+cYeWahoFve+97wgb5K93bpqd9qLf9da/2/pJSPdcw2jpM4MSZBlsnawN80B/tKZWBtM6weyhDw0t7e3rYwDB0fHuuN3p7wdVbRK41SA6K9/XNrO7suO2Dck2KTvMc5d5/v+yqP6Z4hAQXMTIkxDOYXba1cc3bjgdKiWWak3bt3EwBYy4+TSilmtifrZIyxjzIzG609ycw3HEjw02YOkWqqeQSdI4WYNqMlAUZJRexwXrYw53uetzSxNoqSJLHW5geByswOzRJ9lEu5kgHPWOsIWI4oOjPjsEbtIytcg7csXLT43+DMz+zA/j/09YRfXKLU89Ze07V9f2KfFsfxJ5WUIgPSGdurzjnjef4pEoVXAMDKlStbjT3mAqBXrFjBACCJTsnTxPgkTrJoAGlb8H0/juPq2s6uKzo6OuzOkTqzLQ1jDPX391Pu7bfE52HCOIVjXg+jtW4bqtd3Wt8G1wbBY0nQk6I4NmBW1KS+krEaVl5yAMBycHImAJRKpcP2mSAaiOPYAvCJ6AytvVcJSV/b1lP5f4t9nLp2Y9ffG2veToLizORhAaS1JwDLDMvM6d9Uk7BIHduTrvPcOJ+O3OuLxaLctWuXbXH53Jg48mVZDBp2FJyU6ntuz2OG0Up5URx//1ePOuNNvT3BRff96ldX1Go1W0zr5R5eBepkmys0GBEyqlarqX3U8SkNiSNTPSQdANNWKHiJNXcgsa9csmTlIwUtPqqVOi2thwPiMdREB/1h95NWWZQExnJgpCD9GF5KU99TM4ZJkiS21hrP06+QrH7cWyn/w7rO8scT597IwAGlpNZaK9/T2ve0LvieLvi+9n1P+zolpZSSUubahWsA7QnXiIhEkiSOGBc/+2lPe8pMmDnymtKNj8l8T2Vuwo7MMT2d1242UitXrhzryeaG0J5ZZei8xkNexGbsaZ5P/AweIMzMTkqhTJLsthBvesbevQuGhK46674IDHdMOSzs6HinbLbmfDp+ZwR4CMxuLP8ARP5Uow2zS1sApLX26kn8ORnbt+0BYvzpoZuUVJfGSZIQkZiMNsPDhQ1nN0503N8iSsP6mBcAGL8aW2pgzmtxDBciq0dRIoRY4vv+x7ZVwrOv2BiUb+ju/nND/AREbikELydGO4ClDJwC5tOIxCKG8yCET4ylDJwhhViklcrDDdPaJGl0y9j5JADG9/22ehS9HsAduY9hHCCcFi1jEp/P+EMddp1qtdpQwHG4ANZcHdg8XZp20yTl5CogEVkAWgiRF7exjQkzMyrdZyF2BIIR9M4rr+m8p7dS/sKSxe1n7z80sH9coTltS2CAqZWHzGNc50JNZwYTwU1hgzFlIEok7Nh5IcAbEaDpWMCZAVglpeecS5I47lrbGWzuC4LHLfX0p5UUz46TJMEkHH+5JigABSGQSdwWc5nlmcdmAoUp8Il0ziVxnEAqFfR2lw8B+AI58TNveTLw7neHB492jQ9t2fKowWjw6Vy3L2eiS0D8JN/3tXMO1lows2HAUYOD1VgLAH8dBMHmUqk0OJ3mvZnSeBpq1PJRD83pJ8fp/hgpeDz2L8Z5jjFiX/a8mbImHQCltZZJkhxg5wZAdIrveYU4SdwMS875ClqttRcn8f9ZvzH4Qm93+X2e5796sF5nculcZWoVAeBSqSQuftqTlxR8XxFIkQBokvybXyRLuHBzgBVMRKS11qIxsrCBmyYaCwNg51DwfSRx3Hb4tY9pJzSyqvG09p119zLTP6zt7Ppmb0/4GoA+rJU8PcqyW0dwbmLziBBCCkEwxj5CzHUAj9JK6ThJ7DiFlWZPCCEC0dQK8WdjhzHWCiHe75hDZhtHe0XcWwkHANpLwEEGYhAfImAvGA8z8V6A9g8ODv7G+P6t6zds+BoAbO3ufkYcx68g4BJmfqrWegkJAWMMsprKzlgbSymeuEzgLwB8o1otilKpZsvlMsIwBNNwhiUfBr6pZM6jTu8RUB7mkjHlZof9QONUTWQiYmfdYfOXF04SQjClmabcoB3keQtZKVeeEbBmAEoIJVVDEcuGMgFHWNhhiWns86YAaGZmIYRg5qEkjrutcF+S0HuldGdESfIPUoh3OefsTG4qZmYSQidJsl8q19W7efM5xPbqJEkST2s9gQoDZt5+YGBgpSBK8lSzBqDihuQzgmiw/AkIgIfg6EVCypdmZVxny1Oe1wuJ4iT5Z8H8oCOS1GBmGv5kfs/ZX6b8PeGSgwcLTPK7AOhI9sCj4U6evu37vm+S+LuWxRvXdXbe37epspmADQAoaig9cJSD2koplXPuPpfwNWTd91nrCMCZsTHvVEr+nbXOYB6XgKUU9QyIfGIuUJr3flpWlDovyzm8yfPTzBgDYeKH+noqtzLZLyex/eqGrjAEEPb29JwZW/MCSvjFTPgLAj3W19pzzsH3fRw6dOgtAL7R37+KG7V34mFTwnDIbvrzI3lb+XGYW6XyOts0RjBgx2MsPZw1AnEMJsvMFgRxJNSyzmnf9wUDHlE6H7k2xy69XoM2lW/X6dBgnZJSWWM/b635FrMoCCGsy4oBkiOycJCZAmfhoIRid5Rigc1k4mB2ds3azvKnG17eDeDdfT2VutZ6XZJmjYgZugHnaS3jKPrqezaE9/ZWwo/6vr8oiuNBItLjfaNWq7larfbJ4/nZGzZ1KyXly2LnZsX2Tw0pc8ycGOO2XxWGu47nmkEQiGKx6KZ4UjARsdZax3H8yf2JXb0YdmlfT+UrvtYvi+LYZIXjJ7Pu+fwdYNji2q7w1ob37gfw42093UIr9ebYmJjmYd2dhsNJZPOXZr+moDOsjWX1TvKchpy1SBA9Sir1KoJ6Fbn4UF9P+DNmfIuZv75uY+dnCPRvAHBDGF6YIHkhA88wg0PnAHR+X0/PirUbN+4OgkCUywAQMgh+NueOmSMCDDMMCDYDQgPQIQLvZ7iDRDjEzHUC6iAaAPM+R7SfwIck8wBDHgRzxESDFqaunIhIyojZJSydVVbaZP/+XUjb8Y3wXBr+SkT0X4OD9ZdLwW0WdArYnMqgswk4HcBKEB4DoF1rvUBkNm1jLZx1lsHuONLqnZYSxppvrttY/tB0rfe01+Wd0sC0VklifrCus/zpIAhUR0cH9/f388qVK+WuXbvs0KHB63lB4c1CiEdlkubM3GMqcXwrCAKPCC9OjGFmlhNI3CAiLhaLctWqVeNKkP0jBYTG8zjL/v5+5xgLGtW62XRiEBGxlEuCIHgol5GPRRLOxufCMHR5Pd4pmLXI01pFcbxpXWewcVsQnE+++nel1Hn1tGuPPIYLO8/zdBRHX123Mbx1x+rVeteKFRYAVu7eLVffeKPpc9hirH0dAH8unOEzdeA27AmBEelUjBK7AbbOWTtSQ2ShVuo5QojnxEkSbOvpvqcP4Q8g+OuJFbdcubHz+vz727dv9y+//PIoNy+Vy2ViZrrh/ZV3J4ldSA5DsiBiE1O9TodiKZfEy4aGEqxcmayZfNlS+mQQ+A+2tfkFawtCtvnWOY+M8RNhfWGEjMGePVU/DGAwTxrLAwsAINH6IA0O/nS5fey+t4Vvq4/9gWoQePcDKyOHpwqBpwP8TGY8VUpxltaeTBID55xhwIFZjtWKJ1oD5lSVgKOFQRCo5cuXyxUrVpiZAOjZNW8ALIQAgF8AoJ07d3JWihHMzKVaTdRKpT/1VsIfKin/OnaOJylNHTOvO2aAcABAgRmLRtnGxPiSzFRLMVarVYRhaLf1dLu5wggGoJS1YVdoZjkJZ5jhBZGIomj9uq5y7/XdwctYiE9JIU+JomOvppirxQL4YdYZyK0plXL/hVkD8Cet/c0eEncrpZ5q0zTwkymmPWfnfF5tJoQwEUkp5GOUUo9xzG+EjQe2Vsq/IxK/JOC3ZmDfg32Vyq9rtdrN/f39XC6XOROvIkN135OersdxmwJOK6DgI44XDihaIh54YElfJWwHURsDBQFe6IClAJbBYQGI2oh4ATN8gLw94DYviZUFe2CrCVAQrDUkIEEkBJRZeAmAb2MkbBB570dlolcLrW7ciz8+0lsJhwA6AMIjBL6HGbvuBd+phL6zEMfffndX+KX88DEH913k6tErGXi5EOI8rRTiOLbMnBzJBJKXGM6CG6QgsmEYmmq1ytNRv2TuVTzmzB6FvNjOqPKGq1IpjcD4oxAij5aYCda1UggkCT85DMNqb0/3L5SUz07yqAGHVgbh9Nn7IYSwROQ5a969rqv8wS2V8tuUlB8Gw0+SJJoibwpjDBj4bRZ6NepngyAQbwvDem+l+49CiKdmpVBPZspz08BpF2Bj4pgp9XUv1lI/TUrxNAKBBKFej+r333XXBWEY3gVAhmFoeivdH2nzCi+O49hqkjK3OgstIISCIAESBAIh94Xn9bWZOa+vmkdepO+74WoTmX17pHkwWwsB4VKtdCcfLmURaV+3JXF8llQKea/U3D5vrIUxxsVaPtRbKf+eIG43A/u+jcR9Z20YfgfA+vdXghe52L0DwCsLvu+7HG94pOUyN7yGtHWelFKCEU0rpg5fzDEPF8Gd7XhR6xzYcQcA3rt3r2goCIMsvpEJ8Nra2pRzrGaiG71j1lprRHH0piAIymC+eeHCBc8bOHhItRUKiKJ4YQtajxuYsyQoYq21V4+i963vLH9wa0/3ai3lR7JQLztFcB4xV7AYyrSbiZjuUBbMPuux/uDmTGvKq/vRCP5Yay0ba3N7nvW1LsRx/BoAm/P8iUxyRJ4zlDVjZmstp8vJQFrtcWIzXgPgHMHUJ5DVAXeURXFMsLzWWmYgsdaK4XkfMakJAEoIcYZS3hlCiIudc+9OONnXWwm/TxDVZWeZ2tveFnx9SxheOBRF7xGgM0EsmUmnUjsrAkse0eQFmOxQfWgJQzwCjKqPPk0SNNFctbcRSZJYqeTFvT3h69asWfPZXbt25fdl80paDvTlAwcGBhy7OjJ7DwmA3cR/McFn0lO64bV0/BwnkSKI+u7du2X7o1f85/79A4scu4P7Bw4uZImbAVCrstcx7XpGFheKzFwkpVRKKUT1+pb1ncF1WyvlN0iij9i0xG3eLOG45lgKd2SbIVLvVXZgtNZpfMmas7h+zoCbXLowrwuCoG/16tXRmjVrUsxLI+pcQ37pWFv4kWOeM8m0oZQrxjE9Zecb03DgQ3F8kKYxzYIxvMWHTWYu69DOWcwyCSGWKilfwcAr9t7vNm2rhP+6QPu9azZs+F9TOIhp5OCaNhMHD/Cc7WNiZlaCxCf6KuUFDZEc1NHRQUEQiPVdXV8G8OVZvK0fZ4+xE98ydRx1QdP6EMRQSishhACYESeJscbudM59YG1n8OEtleCFUsiP5gXwx7M5TyX+3Rx5/6ZKcwuYJ4U1Y8xHjoietrSgLiKiW8ZgbK7EjJttiPG1FTfW9DVRx/hGHjhaV+8xHdH5CDI75T/qnLNxyoMkhDzb07rzYL3+d7094fcIdBCMiAixgzPEZJFils2Mnw5Elh2UVPzNWq324yAIJI7R6T4uQO/atSvPg92XqSNzwbnCOcdCiHYh5ad6K91vINA/7zfmm7mhvRoEXj+A3bt384oVK/h4B34kKpVKNnMyDbsG+/v7eUbAmZkcz3+hvGEDEYEWCykEJ7w3SczdRPxzB7pVOPxobVdXPwD0dXe/ngQ+DGBxFpmj0BBdMt7GPFapozbRNYiYZz83aDhRZZ6s57iA6nuejqL4dQBuQaYeIUsCngRvjCepT+rzjRK4Gd6Tq2iK4zgcqRsaMDjnzFC9zlLKR2ul/tdhiSZ53ats7JzGVmPRggXYe2D/QKlU+hGmqRu6yoGOIO+x1howzwkTUWpot2lMrHq5MeblS7T8UV9P978uLNjPldanHZir1apErYZSGnHAMww4rQpexzht1WpV3PfbX99Yryf3YoH78bp14R4gjZVeIuWT+rrLl0OIvyai56cqq0uISLbqa8+P9U2MYQa/ojcIgnVhuGfenDjHKDASEWxKbjJYwQAPHDokieklfT3dyxjwsgS8Yedo/jyLWsuep9agUVqDcyApGQBUblOVwK+N44eEECuZeeYSQiY02/Bws1VjjGFm0lpfzMwXH6rzhr5KeJMV6lOlUumX+ZfyHoHzvUbzicThmcZzY19PzwoMiYt7K+GFAvTnTHwegEd72teOOV/jk74D+nxjVWut1Vo/NmHzEgD/Tifw+o1pa9Zorjm8nCwAay2kki9WUr4Yk5QeabRZptFelErQYRjmcaIP9/WEdyilVsSJmW3QaLQzDturssxBFkL8mfb0lXEUvbOvp/I1wH1qf+K+FoZhHQBWr16tL92715WarD38JEd+IjmqODVfhB8huLeSkL7WGs5aOOdgnUWUJKahSeuMbG5zMjWtm21ZgsgJIoD4dQD+P86chJMxJ0ybZstzuV2PrOlZa00udR+jr3vcuVMAkNlaLUCfB/CyUUU75m4ikEtXzGyzDsoLtFavNca8tl3hp32buj/FLG5at3Hj/TcOq9hFUSrVZtT80aKjLt75Sik/TmsZj/Hqj/but2jeaXsiMYYBunRrpXI2yA2htZajzCONxZ6O+2KZWpoifmI/FyfJPUopwZmHdbYKoY8uMnRYqUABQDLg4jhOmNlopS7QSt9AsLf1Vbo/2NvT80wAXCrVLNKkBNVQYLxZWiBNLHbOFUUzsouHshobInvIMeFWrcNzHmO0YzYF32sXsK8CaCgtjtRC6UZzQJ4ifryk8jCmYrEo14Xhnr6e7h4pxEeNtWY6T4JJ2nsmUpV4rE3IWGvYWpYkztCefmcUx2/vq3R/C4xP2Lb9X73yyvAQkDoV+/v7qVwu26bkoeMoeD7Vg7BxHlTmjJiG6w6bqZghKctcaCysf7Lv4WZOVJnCWMBEr2LGodkcUopJ8zoS5tgl6MzMYVevXq2vuKbz41Ec39RW8D0ASRNLnoIA4ZhNFMcxAKW0fKnUsibq7f/dVwk39G4OzimVSjYMQ5NlJbYaXzZoE8TMRqmW5NOiY2UgGScJiPEXBDwvSZKWs3fGQK7B6L0iq/y1fFH7/47q8fcKvl/IMgxdk/b0yksDKmbmJDGJtdYoKTs8z7uWrPhx36bw41srleek5o80pjoIApWB9ckITpylU6eROhy1NtZsSlQnjhbhQLSACKegZbKaMRpV8yALVxNhGO7bFgSviog/5mn9uiRJHIhms6D8VNUJCQDWOWPSqnfLPKX/Pk6St/RVyj9wJP61kNib3h2m7YHy0qaZDf6EZLLGJsBpTwIhlZRSCIF6FA0QoRXz0KIpsxeykrGtqZgFgM5BulgsyivCcB+A1/d2d19FAht9rRfFSZJ3AxbNvCic1nF1zGyjOHZERG1tC/5yaKh+OoCberu7n6IA7/Kurtvz71SrRXkCRH+kJSayRqlp2qpQUkrILEg+SZL9iePbAP4vlvpL669+328ZIdE8jyVv0ZxqsS2aKRPHeC/WajWbRUDQuq6u6wn2uXGcfBaAyNo/UaYiu2Zqdd8gTWe1V9L6PMzMcZIw4HreVS4fYuJPsxI/3NbT/akbNoV/tXr1ap1Ff2C2TR9ZqEyaIN3YVn0kemZsU1c3/Hr63Da8JqWUyvc87XueVlIqx7wvScxP6vXog7Fxr3fGnbO2s+vStZ3BVjCLa69931Jqqaizt9zcmurjED5OutNgwrKOeXbejh079Jo1a+4A8PobNm26JDHJFcz8Es/zvLRUMpJMfxZN6qZnIlLG2v2JLny5d3P3Cz2lnpYY6zxPvzlJkjefd/aZt/b1dH+c2/Z+plQqDe3YsUOvXr3azGn68YhZgjNtIG87L4mIlFJobPaapI0+B6wx91tjfsfAT4TDf7NzP1kfpmnyvb1XtEle/qzenvJLienFYHu2cv5zAeyd5YL9LWpRi44HoHNavXq12bVrl9q5cye/55prvgXgW1srleckSfz3YLzC8/RpzjpkYXkWgGwmoGZmp5SSxpr7N2zYsL+vEj5LaMlkrckOGKGUuoiEuCgZWv6P23rCzjVr1nx1165dovHkno0bzRxITkmphJR5jUQQAdY6GGMAojqAA8Yk97PDn4hoJxP/RkixEyx/s3bjxvvzS27fHrTjAM7vq4TPYdBFNMgXkKQzfeWDHSM25qCzMmltgxa1aJ4CdCZFGgAoFouyWq06Ivo+gO9vqVT+jOLkNQx6o5TyGUpKxEkCZiR5E4MmMHdQFldmkLZmeBQR8gbWMpM+EwBQSj2DHb6yraf7+jPPPW9jsVikYrGI6Whdc0QbU9aFmZlZK6USa+4kZ3/PjIcI2M2Eh4joPoa4TzM/+IgxD4ZhONh4nX+5/vqVBvE5vT09ryHYp4LpKfYAP0FIeYqWqW/XWAub5qI6kfb6YzmS6deimSfRyrqb+lbOpSV1Eg36mMZaq9UsESGzT4srOzt/D6CvWq1+4P5f33lJ5OybwXiJ73nLrLUw1tqsROecR38wp23WBUGNtWTldmpjTEJEVPD9Dff96s6zisXiW/v7+2kqNYmPxf6SHSBOae0Za244+9wnrR97KHzs+usX743j5da5le2evLh3U/cKYnSA8VgQnxXH0QohaJGnBcACjLR4i3PORta6zD5CDdEuqaPXb+38FqWFM1vTMM8BOqeswFIenC5KxWICoq8C+OoN3d1PqCdRSYDeIKV8ipJSxkkCBpI5slNnmXNZLWcmPZGjJpOoeahejwuFwpvu+/Vdd4dhGHbs3CmRlh6l6TZ5cFYPWmtdSOL4/67tDK7Yuim8pG9Tzz+wcwtAOBXgUw/E9WWSaBFLWuApPbybGAxnHWzaIcLEcZJnXYLTZJ7hA2h4PhqsKmgh9MmNzCNFq2wLpE8QgG4wfaRxkGFIxWJRrlq1it/T1fUbAJt27Ai27f8T/spZ92YmvNj39CJjLJxzSYYVR+yU2/Abxy0apD+WVp1wYG8iU0jDUxFFUUJEG/vC8NulIPhebt7B6Mp706G3xb6n+dDg0J2JV1jd19NzgST+vOd5i03a1C19pACMrB6JzYuI0+juEaJxSmn88Y1MCxFmphhHiybg62ZL9SYiisD8CIjOBFqNkadljUe2H09xUfi4AXrsfdXSUp85UNOaNeEggC8C+OK27u4nRVH8BgIVpRSrhBTIJL0kqwMtsmiFaQPmUQMWAo5xIJu2BZP4imDmRCnpG3ZXB0HwcozUA5leCRpQ1jqC5X8cTAajJVp8Qkhv8eDQUJ2IZCYFc/bZvC6NHAHYFrVoipolIBxgQPQZAt4BYHELpI+bBOUdy6eokTSG1U63vZ1rtZpjZoRhSHlfriu6uu4EUL7++ut7YaKX2sS+mYBLfM9rS5IEjtlkoWTTHgEyUoEJD2f/F9IJOOrPqCQxVgjxwnYt/3zdxo0/zubLTPNqLjk0VP/MlUHwva2V8Drf859Wj+OYiLyG+6cpr3aLWjTB1mDAEbCICD9ix8/TWl+UGOPQ5NUfm9lcBIIZboY1RWGusazGTDhEh6ulhWFogLTdUUdHB5VKpQEAVQDV3mu7nxYlSRHs/kYp/XgCkBgzXCOCefwGlFM5jbJClw+nUiidkkW0HbVXGTNbT2uvHsevxpgGssdLw93Kie521m67YdOmpzLce6I4tmCWLen4BETEJqrFkaviSilYZ/7EwFeUUhfFScIz1UjhBAdn63uersfRBwW5zzgob9jvNWWpcpYiVvIECAboxtWr1bJLL3WlUul/APzPtiDYGnP8cmJ6Cwl6vu95XpZ0YTKzgjjOXZHZaenB9D9+lJtkw9CsTyLg+NlBEKhyuWzDMJy2OQmCQCyKzafXhOFgb6X8Kc/z/TiOIyLSLZZv0UyDc/YPyAlJzJ+N4yQYr7N6iyaFFQwiCCF/t/aaztum67pqIhF7JsLKCGDceKPhHTuGQ/Wymh+fAfCZLWF4YT2K/hZEr/GUfqxzFta5GCO1P2gKv4nEGAD8u+uuu64dJl7mUsfbUQV0ZhbWORDhCcs87xQiejAARDh9djqxJgwH+yrlN2vtXZIkiWltkGlgatWag0lJ83kZAaKFV3R2fre30v0zreSFxtrcN9SUalyzVfdKD7xMTwd7mR9OTsetqlE2qexgLZfLM15Evlwu512zxcrdu+WuFSv4yiD4CYCfbN26dXNSP/R6gN6ltX5ykiRmipGaDEBaax07+p0fxysd8ZLUskCTYmJrLRPRqcbaswA82FGtEkqladkjYRja7ds3nWYHTOCcGw44acFHi2aTrHMyFWb4c0KIC7nV1HGqhx6EI85qGdF0lE5oBOjGThs8Xar8JEHUAWmhom9+85ti/fr1DwP4yJYtWz7N0aEuAbGeiRzAx5Q0wswQRMIB+7SU9ybWXuwppRNj7GSlAyKyWinfWPMYALdP16Cr1aoolUrW7k/e6BUKj8/C+iRPRrRvUYumkYTIpDGm/xfF8TVEtJCZW9EczaAN5kVyrrvuuiUqGWj3PWXjRNMQBtEGAFiAIaRZxW3Z8zYsADAITBix1vje2M8NYii7Vv5cJZpsHCelUukhAJaZqVariVKpdAjAVb2VMPG0uiZOkmNqW0VELKSEs+bBf7r66odv2NT9OCEEjjG7MXXmObcEAPr7+6cVPJloSWYTpBY2n9jUbHHQzEycessdAOy39s4lWnzX0/plcZI0RQbwmH140u0OtXLlSgnAeUmyRsq298WxGwSsbIPvAIKAQ1uWbZY/F3BwKACwECA4cN6pOSuR6UPAZoZaH0SOkJlpmAvcBs6u4WMB4KDFAlbiZgCvC4JAZABqi8WiBADfuOtiSv5GSvF4a92kpV9mZikEjMU9RMR9Pd1PzWteTBYIs3gZgGjxTCyAFMJQK6SpRU1AYRi63krlJmZ+GVo82RzazYi4aX2t9VKAVwghTpdCrJCCVpCgFelzMfw8/TvyXAhxuhDidCI6Y+SzYoXIHkR0BglxBpE4Q466hlhBRGf6vrcMhKUZk3CDGcAtW7ZMZB1QblGp9+eYVC8SAkT4WQa3T8wiOCbPfJnEI0i0z8QCWOdE6v5s7YcWzQ2ZBokaRF+Pk+TBMeUBWjTXAE0QzjrLzBw7ZmOds5N9uIbHRK+P9751zjrmxBrDxJQ0ql65RH7ppZc6AMSg3xDoiJl8OUM1MpZzjuHEL3p7e9sAOsdaO/pgmpypBMzsA0BHRwc33uN0LACnfVAYrSyuE5qavSdhrVzW6zZuvJ+Bb2mliIhsE2H0cDW7k1OCxkgLkrzq2WwS0xEBjxl40Ka1KeSRNkDuZGNmS0SUJAkR80/tgQNPBHCKc85Nyc7L3IpNbtEJSXmkwO49eyjVFlHN6sBMe3GwFh0HQDe39IF6Zg/mo0gpDMBIIXTB9xUxfiqWLPmd0PICT+vGqnSTx+Z5NVMtatHUTByFJz/ZAYBM3M3O2ruVUnpOuwq1aIwEPVclHwgAH1msZee4sS7FOOQAxESkPK0969zv6kND71nwqNMvuvzyyyMBvmS4DudUdKuZMj4QsWjZn6eVrBN0VL7PmiTMJjVhNbtRtGzZMletVuXlYXiACV+RaaOHpjK7nWwHRvPIhcT6iIcDizZuEGjHML4FoDytC8z8QJIkGxb98f7z1naVtx/40wMv6uvp/jZAb4jjmCmt89GSCk48Ioy4HwQAFCfUiFimvc9bbDCaaqjVaqm0w+ILSRpqp1pmjpMcoLMkutN6e3sLY5khizsmknyWOvxENwC44PuagIE4jnspsU+6YmPX9YfOPvu5fZXub2upvqyUekGOydPl3JtWyarFh9M2lVIIEHAKAEJxFERTHiFEoCWtOZ8AorOywQeNudU5d4eSUqDlvJ6znSzGSBazjhcMkHMOxDhDJgdOC4JAlMtlwmhzBhPTk7NgB+KUYZxWyiMirsfxpw3T09Z2ButFQT6+ryf8Igl8S2v1AmetMcaYYV9k+qC5nfZR4j+daAI9UdpaYLazbpiZlVJwcB0AuCGpiKrVqgiCgLYHQTs7flwWbilmd16aO4oj1zmCIJBhGNaJ6AtCSnDDFuCUX+dsEM0oYGWhFWAGnJje+5v7pq4pQCda61NMLF8ShqFbuXKlrFarcseOHSoMQ9Pb03MmGC/MVC5opZQQQiUm+S8i+ex1G7veorW2fZvC/2MtbtVKv4qZTWJMXmip5eI7GWwcae0UEOhl1WpVhmFogiBQQRDI/v5+GYahi7V4rlLqMdZNPuHpZKPhUFKHL8RxfIiYdW47ajkNj20Oj5dU02ws51hKdPX29NyxZs2avPay3bx5wynk+ANSyVOYWXieJ+I4vo2ZwvVdwZe3B0H7ts3d17okepfv+4ujOHZxkiRZVbgWMM/l0Tv7JBJjEq3UM/7467s2B0HQGYZhnL+5rbv7SQy8H2CVd3lvrVMDCGT251Kp5IIgEAc6bf+SHvlj7XkvSBpSv1sgPaF4P5w2v3fvN0UQBDxtazPHJKxzVgpxJjn7zb6e8D8Z9HvheDFbusT39XnWOThr70osX7euM/g/ANC3qfsKy1hb0P5ZdRehHkUJ0pYz015D4Chx2lOm4fYVaQj3fJZeR9RgN6f3IY21Vgnx3naFF2zrqfyQCYPM7tHM/GIp5KlZt3kx+/uXR23iZoaa3bt3qxvpxqS3J7yJiF7QBG2/m70Wh4qThMF4Z19P+NcHH2LZrgUITAziPEyNQUxZ3+b0dYx8pnGSs+dNUzmXAFhrLQGLtNJvICIopcDMGByq/xrE/7JuY/ABAOjd1P0mMG/wtO4wiUE9iuIMmMVM8VFLajiW4xbx3AoyTNY5o5W8UEhxISHtERcnCYy1Zg47hmRJo645O/UWAaRCNF26d6+7EYBj8ZU4jkNBtDyrcNfSSifmOyelPEcIcQ5GWe5HAck4HHFsEjTN8CC40bSRJf7ZXKBkwFnntCDCoaHBOwF86OwnPunDpVLJbu0OXiVIXKOVfqZzDlEU5xLzzB80Dano0wnYIjssm9H5MRVgTJcUsSACA3MyqMy0LIy1ho3hPMG04RCfWzVYiKHcpDBTzTGmRLWRuyylNY3FlZ2d9/RWwlu01q+P49hipHnybC9t06d6Zz4Qa/OWTeOBb1o9cGQsR1Gb1VwNJD9xsmaxJITQnqeRxAmstbcxyQ+v2xh8AgB6u7tf1tvTfZUU4nlCCCRJkqCxu/XM3izADMe8H5j+cqMnEmXRN0zAwXze5lgpFTmONIM/kFJmhwUP5HhYbOL17OjoyNqE0GeZ+fUt6XnS2CbHlZbHO3GO8hk1crBTMkvHU54oYomgtNaKAERJvC+K468Su4+t6wy/DQC91/a8jqx9j5TiOYIEEmOMc84ys5rNE5yZIYn2ZEzbMnVMtKF37kx5TuCeVhLIOHwESDg3RIoeAoBVq1ZxM5vOiqWSAwBPqW/ESXKvlPLRWa/QFlDPloRx7rnnpgxCvG+GOYUzq4wRQoiC72sGDcVx9LUkjlYjcY9ftzF4ozS4ra9SuayvJ/y5Bt2klX6OMdYmxuRedz2b4JyGATKswEO5WjrNR+6Jg2RZYohz/Mc5UoOb2fzDMi0svqfuhh7INI6mWHszMe9ztVqVl1199SNE9BXdavY466RuueWWnIUedM7lm2q6nbbMzE4IobXWMorj3VES/atjsePKzvI9ALCtUnlebyV8swVe5fn6Uc5aJMYk2UaXmAMncmZDlcbZA1LjNwDQv2pVSzQ82ryRujsxhhvsqyc9UA9392HzwKmnPnZPs5hdJkuO+POJMWuYWWRnb2sfzIYEnavsWug7rTEDmP42Nw4A+b6vmfmRKI5DZdx5a68JrpbMi3p7unv7esJfk8B3fN9/OwnxqCiK4iTN/hNz2eWaAJZSEhh/WDBo/wiMbijQotHU39+f59PfxY73ilaH8lH7QErBAH6+Zs2apFqtSsyDLP9isegA0EDsfmCdvVNJKRqc+i2aaYAulUoWAB6Ooj+AxK+VlFM61htTQDMbs2PmREmpAFAcxx8v+G2r1nUGZadwQV9P+P8gcEfB99ZKIZ9gnbNRFCXMbIhIzWTI3DGppUKAmX+0JgwHgyCY/sIxJ0D0Rr7+2eFFv3nUH+9jwp1CypO2CcHYoHYGhHOOAPxw7LzNuRp9FMm/Wq2KMAwHicQXZBr62hJSZguggbSbdhiGMYO/JqTA8WyqRobzPc831v5SEP/V2o1db68PDZ3WW+n+ApO8WWvvFQBEFMWxdS6vldFU2X9ERMYYEOhLALB79+6WTfUIGxmpzVLcuObGhIFvKCnpZN3LY+zvLIhUHCf7WNhbRmkb80ozMl+I47ietcNqMf0sATTlCyAc/i2O40PAcfUjs0IIKaVQcZx8aOFpp1+wN3Y3922qXAeB23xPv5qZbZwkcfYbCs3pFXZSSmmt++kBa7/NzLRjxw7TYplJbWYSDjfFcXxICDEvVPmZ1CwAWKUUCHTzuqvD32YCkWs42JqawjB0zEz7E9wBx7eprB1Wi9tnB6A5DEMXBIG4oqvrTgY+5ntaIivlOVmBIYtGSLw0bO7hxJi/WdvZ9a6hhx561lKtfuprfRUAL4rjNBrjCK2rmmFfAXCpFERbwjCs10olMRObKS+td6I4XcIwdNVqVazt6up34M9prQWnXWxOVknaASBnrQPoIwD4tNNOI8wzx2mtVhNhGBpH+HyajTR3938yxZKMklyLxaKMhK7U42inVspn5smCNIPZFnzfM9bdzpaft76z/B/berqvYYFvSSmeFsVxnIGeyEt+NmkYFjOzKfi+Fyfx59d2dv5HEASilNbJbdHkpGhigDS5zUkcD4hUJT6p5i/XQJ1zzvc8bZytre3s/HoQBOL5z3++nW9aRa5lk3RfipNknxCtQv6zCtBhGLpVq1bR1Vdf/QhB/p1zbp9Wyp+E9OOY2fqep+M4+bIrPPLcfdbe39cTftHzdA8zqyxcLjdlNLWPgZmN73l+PYp+qYR+BzC78aonggMmDENbDgL5T9eEdzl2V2qtZdYZ/aTZ0FnOu/E9T0dxfK9S/npuUqnZTG5NXRAEYt3V4d1gfCeLiZ5TB/DJkDQmxiyCCYJArN248TZn3CvY8e8Knucxs80eOYhQ9mBmZq21jpL4w1ds7HwlHVr2uOW++oHn+a+qR0mSafFyDO/OOaNmYMENkScWgPF9349Ncodh+uv3XHPNgzNl2mi8j7S8/XBT9RmfGx62S83cT4RhaKrVqlzXWd5Rj6JrPc/TWfCsGQeoeb6Cd74HDn8NxtPac87ulhKvvXzDhvtqaTSEmyQ/zdjy5DyWs5o6Rrwg0OddmnU2XIJxvHmYiXseY3c5uUwcDSelWhsEPxiKkxdEcfI5KaXWSulsb5vMVGGJKFXfrL123cbgne+vBJeSwM0kxJOjKEqIMCcJJscI0gaA01prKYSXJObTNrYvfm9n52+DIFDFatXN0s3MigSdnUj5oQTAn7HfKpVKNggCtb4zuDqKoysIiLysC052ILpmOrSnih0N62aZ2QohZMH3PGPsT4zhF1/+vq7bd+zYoUtZ6nSzmF+mEOKXtqER4r+SJHlQEMm8EFUTmyxPLIDOJelqsSg3hOG9azd2vs46+1pjzXeJiHzP82Ta7ldk6ltl7TWdV2/r7n6tFuqzDJyaJCZCGsfs5uKRHeXc8L9FKrnZhs8JJaUq+L4GoJLE/Mg6+9dXXLPxLVeG4UN5R45Z0ocb759neb5m2tyRStIbgxsY4nmJSf6TASr4vpZpjDyY2WUP27hGDfH0kydg5DEi1R3OH5O4BkZfg8dcwzLDZk5ACCGkp7X2PU8DfH8Ux10LEvP8dV1dvwiCQK1Zs2Zy/hwi5pnaExPMxzGspSsWi/I911zzIAFf1WlMtEVahXLUnpvRRyby969aRROaXQHLWXXMyT4Om7MmeEyo3eTlBsthyLQx+HwQBF9s97znxlHyGgf+SynpvKgeb13XFXRtrZTfoTz9IQAwxkAI4Y/V0cZTq3mG9Lm8sndaTI2Qt4LL4iXgnIMxpm6t+4N10ffA7qZFj1p585o1a5JcqsjDiGY6uoKIpJJCGCH8rETnjM5Rfn1KqwL6s3H+lEolW61WZalUug3Ay7dUgudHUVxk8AsAepyntZ8LX455uLA9T2kWuKFQAY3zvcYZpiNqM+nbYvhpGtRDwzyVayFxHLNz7sE4Tn4K4i/ZxH3uyjB8CACCIBDHdNAzPCWlMMZ4Iv+NaeCBMUws83oOQggkbvKSdLFYRK1WI8f0WefcW6UQPmV8O8Nms2FKYjsqAkwIwV1dXSn/EMts/nyRrddwVcXGv8Dhz8dwyWheoJH/x7vmRO8Bx/b5Me+po52YZWZavWaNLpfLhoi+A+A7QRAsWCTw2Cu7wp19PVevYNDFSWK+xWwLBLGY4bxmKMDABAYjIaDOhIMEegTMdzP4NyDV75tk57vD8GC+kbL0WzerIW9Ee4bq0b3MPMAgORuOcSYwOauIMGjtoRmNrsjrcZRKJVetVmWtVsOVneEtAG75QBAsijRWGYMnM/G57PAEBi8jiAUEXgBAA6TQ0M2GHZBXdM6fc658C4C4Ye0av5d9Zmw16PGuh+FrMEAgBhwxLAgRIOpgHmTwfgL9AQJ/kAI7LcudazduvD+/bhAEaufOnZzHO0+eHfDAUD26l+EG2E1n2YXDj30msHW2IKQYnDRAp2Yatv7Ad+J48c0EfgwRoqxhCGaOfwlMzAR4yOpp505C5xzVarW8O8lAFMV3g/mQPcZQXgKBsxLmhOaox0jValXu3btXAMCuXbsmvKeVu3dTvaNDAMCePXtsGIZmx44dGrffjjU33pgAwPbt2/09e/botrY26Q8NUb1QIOzfjyVLlgxfZ//+/emT7LUlAPY3/tD+/el7Y/9O9F5+rXHeK/g+a8DYPXuSPcuXJ2M3SxAEYvny5Rq4G4X+yJ37tysYt6Tv3TJLC7Do4EH/4KJF/tKlS139wQep4Pucz1vjHA3P3TTMTaFeZywFsA/YBwzOpKnj+WPmcuXKlVSv13M+OmxNisWifNmqVfoQoBJAKd+XURQRAMS+z4sBDABYDCCOfPb87L0oYs/3aQCAF0UU+z6j4Xnj9/K/aLhG42sAEGXf86KICHACcBowf0p9FvF4wBsEgZeJ3G7l7t28a8WKY97jy4EFBlBiKVy9Ps7+wX4U6v7w+mFp9kb+fOzf4feWAvv2AUuXIuczLF2Ker1O3kMP1Q+0tyfHao9eCRRsoeBH9Tr7hQLtH28PT7Q/j3GvL2n44Qfr9SEAZvfu3bRixQpu5LHHAurBet2n5ctdYXCQAGBPOq+j/mLMa/UFC7gwOEiN7zW+tjx7fbxrHek9HOPnG987e8GCVhhji1rUohY1K9HWSvkNSumXO2tjTDHlmplHu29HqYlzbefg4fYyJODS2nrN421mZiKRqdezaFqZq98d1zpK4HxdRvGSGF7COVmvdF4aBOWRmBMG5WE303xvzISjrctxFlgaZdM+Hh7I7rVp9vq4o5wmq/00mZUm/swYTwMzsaC6kizOEcDzHajOyG0243PdcOfZlEcbPkJ53E4au8HHN0DOFrzxN7iBCegoHbbZYbgQftoCLJ0Gdtk1GBDDFrPR16Ks065ruH0xzq85xwQxck9i3PlqtIFOwMREmT+Aabw546My/zitgMcseD4Ho++DhrtvM48/Rp6tloLDt80jPpKM1wjc4IKa9dNzVOflxlls8CJNt6k1PbOO1IHveFelkaeYiabQ7W/Yh+tG7ocw2lcwsgfH38ej7kFMx3KN93tHGRiNwXI+fM8cF/vgyNfLP9P4fgrPIDDXWzpEi1rUohY1KwVBIFIReFLSEjXWfT6haSRbkubn7fPJs1YtavHXiUejCmq1JrlFLWpRi5oUoFvUoha1qEUtalGLWtSiFrWoRS1qUYta1KIWtahFLWpRi1rUoha1qEUtalGLWtSiFrWoRS1qUYta1KIWtWi+UCsQukUtmid7lY9SZJ1aXbZPTIBmZqrVaqK/vz8vMD4Z4J5vzEDVavWIY2QAtdGfmZcUBIHo6Og46hqeKOMsFovuKAUKc2jj+TrGUqlkcYJSsViUxWIRJyq/TnY/TvjlE/0QKhaLcgrzogDQPJsfyrrCHPM45+OmPtGlp8Yxbr/sMn97ELRff/31i8d7BMFl7XldnfkyPmam6jGu43xa9yAIxPHihwrD0PVeffWZ3uJF/+SI/9wmZtFEpTEJYCFJGMPvXN/VdXvWb801+SRRGIZ2y5YtC3Vcv0wI+UJjkiWHjZEAQSJRUvyhPhR99Mow/G4QBKpcLtswDOcLQ8hSqWTe3xOcX1D+3zvHj7bWCqKGLs5ELIViKWhXFJuPZ+uoZq1B7jQxfhiGdkvYeWHBb3unc+5x1jkfnFZuHS06MysphLX8SKK9v92wYcP+vAPcfBjj5iA4Z/EC/73Ououtc0t1EjHz6DESsT1t4UoZDcVvAXAzM4u8mW0zU7lclmGtZrZUKi/0FL2FHZY5tg0ATgRilkIxCbo7Hoo+cWUY7pwPuJORCMPQ9nZ3b/IL3lOiKHYAGvYjEUYqFbv89VEA3bt58zmC7VcWL150bhTHiEET1rNnZkilYJKh5QCwc+fOZj+tKWP2djE0+JXFS5c8xzmHev3wmv0MhhASCwqF5xDRG/sq5beu7Sx/GoBC2uZoPoCW6e0O3qJ14aPtCxd61lk4ZoxXilYpBQwMrN5SKf/vKzvLn5wvTF8sFmUYhravJ3y1p/R/LFy40B+KIghrxh0nM0NKibqLDllrvezFkeaczbuWbvumTascuW8vWrjo9IOHDsI6lwHy2DHCChISRG0AUKvVaL7w69YwuHphm7+pra0NxphxbFMMQQJCCBwkWrN1c/ffrr+668vzgV87du5Mu8ETv3rpkiUdg4NDEIIaRAdGYgwEiXQ/jidBszU3Ll686Ny9+/f91II3gNw9YAhp5WFobq0lKQ2f4tw9AKhWqzW1XaxarYpSqWR7K+F7ly1d+pz9B/bvts6t8yXfXm8Yo5WWQHAiwaKhofrqBQva1hCJD/ddG/xg7fvC3zc7M+T3d8OmTU9mcp+QguQje/d+TDB9xWaHixD56SxBzmkH9xfa89Z6Un+8t7v7p+u6uv6nWi3KUql51zQrbek2b958OjvzUeV5/iP79v0bkfwX4dx+IAbgHfa9SEbErKI4iR9JAY6aWXqmjp07qVqtynt/dddHli9tP33v/n1fY4urlLWPGK3ZJMlh91+PEj5g7SNA2kW9qfdlsShLqWT5soUL2zbVo2hgaGjoOsful4B0jbxqAUjn2iDw+gUL2t6QJMm/9vX0PGXtxo0PNPu+7F+1KpeU/+6hPz1yFjuXMCCEEATBERw/d+GCtvcdOjT0fUd8LRz5QvCotVNS0AsODQ3FiO0/rA/DO04gEx6VSiW3/bLLfEv06sQYxxb/tL6rfNNRvvePvT3hk5YtWfq8vfv2XgLgowAkZrCx6nSoUgCcZft3pyxdKvfs3fvJdZ3B/z7Kd77QVwmT5cuXv++RPXv/EcA7+vtXNbXkVS6XZRiGprcnfN6S9vbTDhwY+PmAcX8XhoE7UZi2WCyKUq1mtz591blSqOfuPzDwSKLs3191TbgLJxoR3u1pzYNDg+9d2xl85CifvmlbpfsJ7e2LLziwf99fALip2fdlGIYuCAKxvqvrdgC3j31/W08otfYk09Cu9RuDr40rQSulOI7ju8/u6PhF5jDCkQa9Mz3dXZNLIWBmEBEnj1m+WAzxioGBAVJSf69arcr+/n4ab4zLl+/R//RP/xz39XR/Q0rxXAjRDoy0d296fmc+hxnsmL8WBIFob2/3F/3qV2bXihXc0dHB2bixfPlyueL73zd/FPhaHMcbQHzufBonmBcppZiZvxOGodt+2WX+nuXLk507d9KqTGqZaMOgyaM5isUiarUa2OKMtgUFHBw89POrrjqxwLlUq9kgCASIH33g4EEyLL4RBIHqAEQ/4HI+PO20frrllrRT99vCMHKEbyqlns5Ey+bLERSGIY913O/e/T21YsVzzX133bWYmcHOedlnJIDREjQREUD1Y1GLiOaR038AgCYSRGz5kCqVSpaZabwDJggCS0TcV0k3MjueV2FZRMIwMzlmGYahq1arcWndOjsOCHCtVrNbnrqKmJkEUodSf3//fBpvqiYCtOK5zzWXl0qTlaSaeoy1Wm1YK0q9gWLB1k3BeWSlP1aocNIyAAgryUnJovDwb9eu21ZvZgdotveyBSRmZihlOOwMTbVYlFi1iovFYtanrwQGcOOOHRQEAREQp9+U8yWyisczOQVBQJdfXrK9PaGlzORWKpVstVo97LMinYiTo22N0fqEDuTP2w+JY9RuxkYFzBtyEDjBkjNyDUAIQVEcQ0rxrIJuu9MveHf4Be/njY823faLNt32C9/XP29v839Bg+1/QQBX50ko2timxP2rVnEYho6IOBOgmABes2ZNEoahc8wXWOeIgQMAsHL37hMetxROImLGpE5e1+qz1tzrSKkrvNnNbFOh4cgoA0hfIDFmXxxHvwRIUNoE+vAEKya2zoIID+dAN69AyKj8fsX27dv1nj17eM+ePbk5jlauXGkPPrT7Lb7vX3pgYCBWzLcBwDf37nUnOq8rMDNn8aPlNGaYJ9IDaR6pijlpzyPLFswMz2gbBIGo1WrEzG44XikLu6oBIggCIYVwGQ5Qpvq3ALuZbBvsOFsfZma68cYbRRAEDADljH8n4N2m59kigFoqQbP2NCeJuX1tZ3DpsUzPfMu240yTX6zo/2Lw4AXtWsVLTj9VII0Q5UMPP+j5nv+Ygu9jX71eXt9V/k2zRxxNG0Bb54gEnbMlCE4Pw/CBCcB4/m3iDHzb43hgjxZ/amsrLI3i+qPDMNwdBIEolUrc8OH0bxjGANDbHT6d0yj5egsOm48kqYPOWWLnnpFJ0Un+XniCjNEI8XAUxcSEJ+4IdixYE64ZnAzbz7t9CsAqk5p1IJ6ycEHbn0VRPOLnIoJzDta6e/YdOHDj+q7y5nT/hvZk4HVljLmjffHi8wf4UO/2ILgqXrRo78GDB2nRwYOHSxtnnIGDBw9yWC4PofnVS65Wq7JUKtX7Kt3fWti24IlDQ/UPbA2CNxeA+7Zs2cJ44IHhcQFAu7Vq0MSvk0q9ev+BAScgvpdbPVqwOPdUBlyZmbZfX/7v/fsHDvl+4S+3VcK1WOQ+sW8fzKJFi0bWNKP2RefygUUHyPM8c/nll0fNPsZSreaYmcrl8t2LlehfuqS948CBB/tu2LQpiJQaHBwc5EWLFo2z9x7Aj398b73ZcxPGkZ5hjCIAsKCXDAwMLknPWw0AsM4RAJhDh3634frr98+jLMKjH06O6GhHqmKIdw0NDX118aKFbzwwcPAVMhp6aIkWkpcuOZwJhgZ5me+hd9OmN60Dbm32ySoWiy4N5xE9e/fte8GS9vY/P3Bg4KcR8S4xNCiQjzEaJADuoMMC3/dW+L6PAwMDlXWdwc/zzLX5ozmMPJ/INJM7olTmgiAaVv1zp1tTHr4UhhwAMgzDe3t7wo1KyW1Ehd6hg/Ur2zUOUTQoxvLtQXqAdSyFrQ/+6brrrnvRhg0b9k8UxdMsmFUul0UYhvVtlcq760P1Ly9auHDNwMDBkmKzZ4kWgutDPBrk2BX808RFT25/e61WuzkTTOYNz6pMgr6ys/P3R9nP8kQBZwBgwQwe8aWMt1/V+s7OH/aG4atAQ71ayWcQUftEVQ0ZDCUV6vV4EdD8qd5ExEEQyLUbN+7eUrnmpUOD8gYS9Got1ePHO8kBwDH/6eDBg73rOoPrs7jw+WXPY0BCHvGeO7J1M9nYxkRxNLNmxDt37uRisSjXbQxu2FopR572rvK09xjObpsOmw+GUhL1ujvVuX3zwimeJzhc0dl5y9YwfI21bov29NMALBtvjM45+J6HOI4WzWfACoJAdezcyeM5OcMw5PmmHUyCUmdKFpQwXh7C/w+It8jaKDubSAAAAABJRU5ErkJggg==";

// Unités proposées à la création d'une catégorie
const UNITES_CATEGORIE_KEY = "erp:unites-categorie";
const DEFAULT_UNITES_CATEGORIE = ["m²", "tranche(s)", "pièce(s)"];
const UNITES = ["m²", "tranche(s)", "pièce(s)", "plaque(s)", "kg", "ml", "l"];


// gestion: "tranche" => matière en tranches (dimensions, épaisseur, chutes, et
//   nuances si le drapeau est mis). "piece" => article compté à la pièce
//   (évier, consommable) : ni tranche/chute, ni dimensions, ni épaisseur, ni nuance.
// nuances: true => catégorie codifiée en nuances (céramique uniquement).
const GESTION_TRANCHE = "tranche";
const GESTION_PIECE = "piece";
// Plus aucune catégorie précodée : à créer soi-même depuis "Gérer les
// catégories" (Stock) ou automatiquement par le Catalogue.
const DEFAULT_CATEGORIES = [];

// Plus aucun fournisseur précodé : à créer soi-même depuis Fournisseurs.
const DEFAULT_FOURNISSEURS = [];

const ORIGINES = ["Maroc", "Étranger"];

// Conditions de paiement — liste de départ, à compléter depuis l'app.
// Partagée entre Fournisseurs et Clients. Chaque condition porte un
// indicateur "vérifier paiement avant création BL", pour bloquer la
// transformation en BL tant que le paiement n'a pas été vérifié.
// Plus aucune condition de paiement précodée : à créer soi-même depuis
// "Gérer la liste" (devis, client ou fournisseur).
const DEFAULT_PAIEMENTS = [];

// Fiches Staff de départ (Step 17, j) : créées au 1er chargement ou après « Vider » du Staff.
// Simples valeurs initiales (nom, poste, service), modifiables ensuite dans Staff. Les droits
// ne viennent plus d'ici : ils viennent du profil de chaque compte (Paramétrage › Accès).
const FICHES_STAFF_DEPART = [
  { compte: "nils", nom: "Nils", poste: "Gérant", service: "Direction" },
  { compte: "ahmed", nom: "Ahmed", poste: "Production Manager", service: "Atelier" },
  { compte: "sawsan", nom: "Sawsan", poste: "Secrétaire de direction", service: "Secrétariat de direction" },
  { compte: "wissam", nom: "Wissam", poste: "Dessinateur AutoCAD", service: "Bureau technique" },
  { compte: "taha", nom: "Taha", poste: "Directeur commercial", service: "Commercial" },
  { compte: "karima", nom: "Karima", poste: "ADV senior", service: "ADV" },
  { compte: "souad", nom: "Souad", poste: "ADV junior", service: "ADV" },
  { compte: "chraa", nom: "Soufiane Chraa", poste: "Agent commercial", service: "Commercial", contrat: "Agent commercial" },
  { compte: "krim", nom: "Soufiane Krim", poste: "Chef poseur / métreur", service: "Pose", poseur: true },
];
// ---- Profils d'accès (validés par Nils le 02/10) ----
// Chaque compte a un profil (droits par onglet + actions) et, au besoin, des exceptions
// individuelles (droits ajoutés / retirés). Toi seul (Gérant) modifies profils et comptes,
// dans Paramétrage. Ce n'est toujours pas une sécurité tant qu'il n'y a pas de vraie connexion.
const ACCES_KEY = "erp:acces";
// ERP step 13 (as, Nils 04/10) : « Vider des données » par groupe. Un référentiel ne peut
// être vidé que si les groupes qui s'appuient dessus sont cochés aussi (pas d'auto-coche).
const GROUPES_VIDAGE = [
  { cle: "a", titre: "Devis et dossiers", detail: "Devis, dossiers BDC → facture, factures / BL de remplacement, factures d'avoir, projets immobiliers, planning, déplacements, tranches en exposition, commissions validées et payées, SAV, crédits clients affectés, visites, prospects et rapports commerciaux", ref: false },
  { cle: "b", titre: "Stock", detail: "Lots, arrivages, archives, mouvements, réservations, registre de crédit exo, inventaires, consommables en service, plans récupérés, incidents de production", ref: false },
  { cle: "c", titre: "Trésorerie", detail: "Opérations de tous les comptes, chèques, clôtures, relevés, prévisions, échéances récurrentes", ref: false },
  { cle: "d", titre: "Factures fournisseurs", detail: "Factures, devis fournisseurs et échéancier, registre transport international", ref: false },
  { cle: "e", titre: "Factures clients antérieures à l'ERP", detail: "Données de reprise", ref: false },
  { cle: "f", titre: "Pointage et primes de productivité", detail: "Grilles de pointage, mois validés, primes de productivité", ref: false },
  { cle: "g", titre: "Outillage et bureautique", detail: "Objets, remises, contrôles et inventaires", ref: false },
  { cle: "p", titre: "Véhicules et machines", detail: "Véhicules ajoutés, échéances, carnets, relevés km, tickets carburant, carnets des machines — retour aux 5 véhicules de départ", ref: false },
  { cle: "h", titre: "Alertes et tâches manuelles", detail: "Toutes les alertes, les tâches créées à la main, les bugs signalés, les communications et leurs lectures", ref: false },
  { cle: "i", titre: "Clients", detail: "Fiches clients", ref: true, requiert: ["a", "e"] },
  { cle: "j", titre: "Fournisseurs", detail: "Fiches fournisseurs et demandes de création", ref: true, requiert: ["d"] },
  { cle: "k", titre: "Catalogue d'articles", detail: "Articles, grille tarifaire, groupes couleur, matières ajoutées", ref: true, requiert: ["a", "l"] },
  { cle: "l", titre: "Produits et catégories du Stock", detail: "Produits, catégories, sous-catégories et leurs demandes", ref: true, requiert: ["b", "k"] },
  { cle: "m", titre: "Staff", detail: "Fiches, salaires, primes, suivi mensuel, signalements", ref: true, requiert: ["f", "g"] },
  { cle: "o", titre: "Marketing et échantillons", detail: "Time sheet marketing, échantillons (liste remise à la checklist d'origine), mouvements et demandes d'échantillons, matériel marketing, boîtes revendeurs et prêts", ref: false },
  { cle: "n", titre: "Paramétrage", detail: "Listes gérées, plan de postes, fériés, profils et comptes d'accès, comptes de trésorerie, machines et bureaux, barèmes de commission, coûts de revient (profils d'import, forfaits transport, estimations) — retour aux valeurs d'origine", ref: true, requiert: [] },
];
function manquantsVidage(coches) {
  const out = [];
  GROUPES_VIDAGE.forEach((g) => {
    if (!coches[g.cle] || !g.requiert) return;
    const manque = g.requiert.filter((r) => !coches[r]);
    if (manque.length) out.push({ g, manque: manque.map((r) => GROUPES_VIDAGE.find((x) => x.cle === r)) });
  });
  return out;
}
// ERP step 10 pt.11 (accord Nils du 24/09) — clients :
// - clientsAValider (Karima, Souad) : un client qu'elles créent reste "à
//   valider" jusqu'à la validation de Sawsan (ou Nils) ; tant qu'il ne l'est
//   pas, aucun devis de ce client ne peut passer en BDC.
// - clientsRestreintACommercial (Taha, Soufiane Chraa) : ne voient que leurs
//   clients (commercial SC = eux), en lecture seule ; peutProposerClient leur
//   permet de proposer un nouveau client, soumis à la même validation.
// ERP step 10 (accord Nils du 24/09) : validation en deux étapes — Sawsan
// d'abord, puis Nils. Tant que les deux ne sont pas faites, le client reste
// "à valider" (aValider) et bloque le BDC.
// Renvoie "etape1" (Administration), "etape2" (Gérant) ou null (client entièrement validé).
function etapeValidationClient(c) {
  if (!c || !c.aValider) return null;
  return c.validePar ? "etape2" : "etape1";
}
const FIABILITES = ["bonne", "moyenne", "problématique"];
const FONCTIONS = ["Commercial", "Comptabilité", "Direction", "Logistique", "Technique", "Autre"];
// Contacts d'un client qui peuvent être son « commercial » sur un devis :
// les commerciaux et la direction (Nils 02/10 : la direction vend aussi).
const FONCTIONS_VENDEUR = ["Commercial", "Direction"];
function contactsVendeurs(client) {
  return client ? (client.contacts || []).filter((c) => c && c.nom && FONCTIONS_VENDEUR.includes(c.fonction)) : [];
}
// Seul type dispensé d'ICE : un particulier n'en a pas.
const TYPE_SANS_ICE = "Divers Particulier";

// Notation client : 3 axes relationnels (lettres brutes A/B/C, sans score) +
// un axe paiement séparé, affiché en couleur car un mauvais payeur est un
// risque qui ne se compense pas.
const NOTES_LETTRES = ["A", "B", "C", "–"]; // – = non noté
const AXES_CLIENT = [
  { cle: "adv", label: "ADV", critere: "Demandes de devis claires, communication fluide, confirmations cachetées." },
  { cle: "prod", label: "Production", critere: "Infos chantier accessibles, cuisine prête pour le métré, pas de SAV abusif." },
  { cle: "com", label: "Commercial", critere: "Énergie de la relation, suivi commercial, réactivité." },
];
const PAIEMENTS_NIVEAUX = [
  { cle: "bon", label: "Bon payeur" },
  { cle: "lent", label: "Paiement lent" },
  { cle: "mauvais", label: "Mauvais payeur" },
  { cle: "", label: "Non évalué" },
];
// Motif exact poussé dans raisonsVerif par demanderConfirmationTransformation
// quand le client est répertorié "mauvais payeur" — partagé avec la modale de
// confirmation (Step 11) pour reconnaître ce cas précis et adapter le
// message affiché sans dupliquer la chaîne littérale.
const RAISON_MAUVAIS_PAYEUR = "ce client est répertorié comme mauvais payeur";
// Préfixe exact du motif poussé quand une condition de paiement exige un
// règlement à l'avance — reconnu par la modale de confirmation (Step 13)
// pour lui donner son propre message, distinct de "mauvais payeur" : un
// client qui doit payer à l'avance n'est pas forcément un mauvais payeur.
const RAISON_AVANCE_PREFIX = "la condition de paiement «";
// Nils 02/10 : « incident de paiement » = au moins une facture / un BLS avec plus de 7 jours de retard.
const JOURS_INCIDENT_PAIEMENT = 7;
// Anciens libellés -> nouveaux
// Validité de l'attestation de régularité fiscale
const CERTIF_VALIDITE_MOIS = 6;


// Listes de départ, modifiables depuis l'app (bouton « Gérer les formats »).
// Plus aucun format/épaisseur précodé : à créer soi-même depuis "Gérer les
// formats" (Stock).
const DEFAULT_DIMENSIONS = [];
const DEFAULT_EPAISSEURS = [];
// Un lot est soit une tranche entière (dimension standard du fournisseur),
// soit une chute issue d'une découpe (dimension unique, saisie libre).
const TYPE_TRANCHE = "tranche";
const TYPE_CHUTE = "chute";
// Nuances : codifiées uniquement en céramique (2 à 8 chez Infinity).
// Le quartz arrive par conteneur d'une même couleur : contrôle visuel, rien à saisir.
const NUANCES = ["2", "3", "4", "5", "6", "7", "8"];
const CHOIX = ["1er choix", "2e choix"];

const CAT_TONES = {
  "Céramique": "#B7A99A",
  "Quartz": "#9AA3A6",
  "Inox": "#8C8282",
  "Autre": "#C7BEB4",
};

// Les unités s'écrivent « tranche(s) » pour rester correctes au singulier
// comme au pluriel. Migre les anciennes valeurs sans (s).
const MIGRATION_UNITES = { tranche: "tranche(s)", pièce: "pièce(s)", unité: "pièce(s)", plaque: "plaque(s)" };
const DEVIS_KEY = "erp:devis";
const COMMANDES_KEY = "erp:commandes";
const ARTICLES_KEY = "erp:articles";
// Chantiers : version minimale (id + nom + client) le temps que le vrai module
// Chantiers soit reconstruit. À fusionner avec lui plus tard — même clé pour
// que les données ne soient pas perdues à l'intégration.
const CHANTIERS_KEY = "erp:chantiers";
const PRIX_GROUPES_TRANCHE_KEY = "erp:prix-groupes-tranche";
const PRIX_GROUPES_TRANCHE_2E_CHOIX_KEY = "erp:prix-groupes-tranche-2e-choix";
const CATEGORIES_ARTICLES_KEY = "erp:categories-articles";
const UNITES_ARTICLES_KEY = "erp:unites-articles";
const FINITIONS_ARTICLES_KEY = "erp:finitions-articles";
// Groupe de couleur (ERP step 7) : classement large des Tranches par teinte
// (Blancs, Gris, Noirs…), à ne pas confondre avec la "famille couleur"
// utilisée pour les réservations (identité précise fournisseur+code+finition,
// cf. familleArticle) — deux notions distinctes malgré le nom proche.
const GROUPES_COULEUR_ARTICLES_KEY = "erp:groupes-couleur-articles";
const DEFAULT_GROUPES_COULEUR_ARTICLE = [];
const APPORTEURS_AFFAIRE_KEY = "erp:apporteurs-affaire";

// Fiche de pose (ERP step 7, pt. fiche de pose) : rattachée au dossier, se
// remplit à partir du statut PL, reste modifiable même si le PL est refait,
// et bloque la transformation en Facture tant qu'elle n'est pas remplie.
// Ancienne liste manuelle des poseurs : reprise dans l'onglet Staff (case « Poseur ») au
// Step 12 ; la clé n'est plus lue que par cette reprise et l'export / import.
const POSEURS_KEY = "erp:poseurs";
// ERP step 10 pt.4 : valeur spéciale du sélecteur de PL de l'écran
// "Enregistrer des consommables" pour une consommation atelier hors dossier.
const CONSO_ATELIER = "__atelier__";
const DEFAULT_POSEURS = [];
// ERP step 10 : rappel de chargement (non bloquant) — ce qu'Ahmed remet aux
// poseurs au départ du chantier.
const CHARGEMENT_ITEMS = [
  { cle: "fichePose", label: "Fiche de pose à remplir" },
  { cle: "bl", label: "BL" },
  { cle: "dessinsProduction", label: "Dessins de production" },
  { cle: "dessinClient", label: "Dessin client" },
];
// Nils 04/10 (j) : 4e réponse « Partiellement ».
const ETATS_INTERVENTION_POSE = ["Sans", "Oui", "Non", "Partiellement"];
const FICHE_POSE_INTERVENTIONS = [
  "Plan", "Rehausse", "Crédence", "Ilot", "Joue Ilot", "Socle",
  "Siphon et bonde", "Evier", "Trou osmoseur", "Habillage Murale", "Habillage comptoir",
];
function ficheDePoseVide() {
  return {
    date: "",
    contactClient: "",
    // ERP step 10 (retour Nils du 24/09) : "Conf. commercial" supprimé ;
    // la clé `localisation` porte désormais la ville (libellé "Ville") ;
    // controleQualite / controleChargement / controlePose = nom du
    // responsable de chaque contrôle.
    localisation: "",
    etage: "",
    controleQualite: "",
    controleChargement: "",
    controlePose: "",
    poseurs: [],
    aidesPoseurs: [], // ERP step 10 pt.3 : autant d'aides-poseurs que voulu (facultatif)
    renforts: [], // Step 17 (Nils 14/10) : personnes du Staff non « Poseur » venues en renfort sur cette pose
    interventions: FICHE_POSE_INTERVENTIONS.map((label) => ({ label, nbrePcs: "", etat: "" })),
    problemesRencontres: "",
    remarque: "",
    modifiePar: "",
    modifieLe: "",
  };
}
// ERP step 10 (retour Nils du 24/09) : la pose peut durer plusieurs jours —
// date de début + date de fin (une ancienne fiche n'ayant que `date` la
// voit reprise comme date de début).
function dateDebutPose(fp) {
  return (fp && (fp.dateDebut || fp.date)) || "";
}
function datesPoseValides(fp) {
  const debut = dateDebutPose(fp);
  const fin = (fp && fp.dateFin) || "";
  return !!debut && !!fin && fin >= debut;
}
// "Remplie" = dates de début et de fin de pose (fin ≥ début) + 3 responsables de contrôle + au moins un
// poseur assigné + chaque ligne d'intervention a un état (Sans/Oui/Non)
// renseigné — utilisé pour bloquer la Facture. Remarque et signatures ne
// sont pas bloquantes.
// ERP step 10 (accord Nils du 24/09) : la fiche de pose n'est obligatoire
// (pour la Facture) que si le dossier contient au moins une ligne dont la
// désignation contient le mot « pose » (mot entier : « Pose plan de travail »
// oui ; « Dépose », « posé », « composé » non). Sinon (vente de tranches,
// plan ex-factory…), elle reste disponible mais facultative.
// ERP step 16 (Nils 12/10) : plus de lecture du mot « pose » — la nature d'un article est une case
// cochée par Nils sur sa fiche Catalogue (pose, façonnage, livraison, RDM). Une ligne libre (sans
// article) n'a aucun effet. La base d'usure ne sert plus qu'à l'usure des consommables.
const NATURES_ARTICLE = [
  { cle: "pose", label: "Article de pose", court: "Pose" },
  { cle: "faconnage", label: "Article de façonnage", court: "Façonnage" },
  { cle: "livraison", label: "Article de livraison", court: "Livraison" },
  { cle: "rdm", label: "Article de RDM", court: "RDM" },
  // Nils 12/10 (lot 2) : découpes comptées à l'unité (évier, plaque, robinet…) pour l'usure des fraises / forets.
  { cle: "decoupe", label: "Article de découpe unitaire", court: "Découpe unitaire" },
];
function natureArticle(a, cle) {
  return !!(a && a.natures && a.natures[cle]);
}
// Pré-cochage unique (mise en place du 12/10) d'après les anciens réglages.
function naturesInitialesArticle(a) {
  return {
    pose: a.baseUsure === "pose",
    faconnage: a.baseUsure === "transformation",
    livraison: a.categorie === "Logistique",
    rdm: /\brdm\b|releve/.test(normLib(a.designation || "")),
    decoupe: decoupeInitiale(a),
  };
}
function decoupeInitiale(a) {
  return a.documentRequis === "evier" || a.documentRequis === "plaque";
}
function lignesAvecNature(lignes, articles, cle) {
  return (lignes || []).some((l) => {
    if (l.type && l.type !== "facture") return false;
    const article = l.articleId ? (articles || []).find((a) => a.id === l.articleId) : null;
    return natureArticle(article, cle);
  });
}
function lignesContiennentPose(lignes, articles) {
  return lignesAvecNature(lignes, articles, "pose");
}
function fichePoseRemplie(fp) {
  if (!fp) return false;
  if (!datesPoseValides(fp)) return false;
  // ERP step 10 (accord Nils du 24/09) : les 3 responsables de contrôle
  // doivent être renseignés pour que la fiche soit considérée remplie.
  if (!(fp.controleQualite || "").trim() || !(fp.controleChargement || "").trim() || !(fp.controlePose || "").trim()) return false;
  if (!Array.isArray(fp.poseurs) || fp.poseurs.length === 0) return false;
  if (!Array.isArray(fp.interventions) || fp.interventions.length === 0) return false;
  return fp.interventions.every((it) => ETATS_INTERVENTION_POSE.includes(it.etat));
}

const TVA_TAUX = 0.20;

// Nils 28/10 : « Prêt pour envoi » entre Brouillon et Envoyé (la relance part toujours de « Envoyé »).
const STATUTS_DEVIS = ["Brouillon", "Prêt pour envoi", "Envoyé", "Confirmé", "Transformé en BDC", "Archivé"];
const STATUT_BG = {
  "Brouillon": "#EDEBE9",
  "Prêt pour envoi": "#E6E9EF",
  "Envoyé": "#F5EFE0",
  "Confirmé": "#E4EBE4",
  "Transformé en BDC": "#E4EBE4",
  "Archivé": "#F5E4DE",
};
const STATUT_FG = {
  "Brouillon": TAUPE,
  "Prêt pour envoi": "#4A5A78",
  "Envoyé": OCRE,
  "Confirmé": VERT_OK,
  "Transformé en BDC": VERT_OK,
  "Archivé": ROUILLE,
};

// Circuit commande à facturation (chapitre 1 du process Stone Concept) :
// BC → RDM → PL → BL → Facture.
const STATUTS_COMMANDE = [
  "BDC",
  "RDM",
  "PL",
  "BL",
  "Facture",
];
// Ce sur quoi bute le dossier pour passer à l'étape suivante, propre à
// chaque statut — liste fermée plutôt que texte libre.
const EN_ATTENTE_STATUT_KEY = "erp:en-attente-par-statut";
const DEFAULT_EN_ATTENTE_PAR_STATUT = {
  "BDC": ["Réservation matière", "Avance client", "Confirmation client pour RDM", "Envoi client", "Confirmation client", "Autorisation direction", "Autre"],
  "RDM": ["Passage chantier", "Dessin Bureau technique", "Envoi client", "Confirmation client", "Autorisation direction", "Autre"],
  "PL": ["Production", "Établissement du BL", "Autorisation direction", "Autre"],
  "BL": ["Vérification paiement", "Livraison / pose", "Facturation", "SAV clôturé", "Archivé", "Autorisation direction", "Autre"],
  "Facture": ["Envoi client par mail", "Remise original", "Circuit fermé", "Facturation", "Autorisation direction", "Autre"],
};
// ERP step 11 (demande Nils du 29/09) : qui peut CHOISIR chaque valeur de
// « En attente de », par statut. Jetons : "p:<profil>" (Step 17 : profils, plus de prénoms), id utilisateur, "@commercial"
// (commercial du dossier), "*" (tout le monde). Nils peut toujours tout
// choisir ; sortir de « Autorisation direction » est réservé à Nils.
// Réglable par Nils dans l'onglet Paramétrage (parametres.droitsEnAttente).
const DEFAULT_DROITS_EN_ATTENTE = {
  BDC: {
    "Réservation matière": ["p:" + P_ADV_SR, "p:" + P_ADV_JR],
    "Avance client": ["p:" + P_ADV_SR, "p:" + P_ADV_JR, "p:" + P_ADMIN, "@commercial"],
    "Confirmation client pour RDM": ["p:" + P_ADV_SR, "p:" + P_ADV_JR, "@commercial"],
    // ERP step 16 : dossier sans RDM — dessin technique envoyé au client dès le BDC.
    "Envoi client": ["p:" + P_BT, "p:" + P_ADV_SR, "p:" + P_ADV_JR],
    "Confirmation client": ["p:" + P_ADV_SR, "p:" + P_ADV_JR, "@commercial"],
    "Autorisation direction": ["*"],
    "Autre": ["*"],
  },
  RDM: {
    "Passage chantier": ["p:" + P_ADV_SR, "p:" + P_ADV_JR, "p:" + P_POSE, "p:" + P_PROD],
    "Dessin Bureau technique": ["p:" + P_POSE, "p:" + P_PROD, "p:" + P_BT],
    "Envoi client": ["p:" + P_BT, "p:" + P_ADV_SR, "p:" + P_ADV_JR],
    "Confirmation client": ["p:" + P_ADV_SR, "p:" + P_ADV_JR, "@commercial"],
    "Autorisation direction": ["*"],
    "Autre": ["*"],
  },
  PL: {
    "Production": ["p:" + P_PROD],
    "Établissement du BL": ["p:" + P_PROD],
    "Autorisation direction": ["*"],
    "Autre": ["*"],
  },
  BL: {
    "Vérification paiement": ["p:" + P_ADMIN, "p:" + P_PROD, "p:" + P_POSE],
    "Livraison / pose": ["p:" + P_ADMIN, "p:" + P_PROD, "p:" + P_POSE],
    "Facturation": ["p:" + P_ADMIN, "p:" + P_PROD, "p:" + P_POSE],
    // Nils 01/11 : dossier SAV — posé à la clôture du ticket (serveur), archivé par le Gérant seul.
    "SAV clôturé": [],
    "Archivé": [],
    "Autorisation direction": ["*"],
    "Autre": ["*"],
  },
  Facture: {
    "Facturation": ["p:" + P_ADMIN],
    "Envoi client par mail": ["p:" + P_ADMIN],
    "Remise original": ["p:" + P_ADMIN, "@commercial"],
    "Circuit fermé": ["p:" + P_ADMIN, "@commercial"],
    "Autorisation direction": ["*"],
    "Autre": ["*"],
  },
};
const STATUT_COMMANDE_BG = {
  "BDC": "#EDEBE9",
  "RDM": "#F5EFE0",
  "PL": "#E8E4DE",
  "BL": "#E4EBE4",
  "Facture": "#E4EBE4",
};
const STATUT_COMMANDE_FG = {
  "BDC": TAUPE,
  "RDM": OCRE,
  "PL": ENCRE,
  "BL": VERT_OK,
  "Facture": VERT_OK,
};

const DEFAULT_UNITES_ARTICLE = ["Unité", "Forfait", "ML"];
const DEFAULT_FINITIONS_ARTICLE = ["Mat", "Lucido", "Glam", "Poli", "Brillant", "Satinato"];
// Liste gérée par Nils lui-même, sans lien avec les utilisateurs de l'app :
// un apporteur d'affaire peut être externe à Stone Concept.
const DEFAULT_APPORTEURS_AFFAIRE = [];
const DEFAULT_CATEGORIES_ARTICLES = ["Tranche", "Majorations", "Éviers", "Accessoires", "Logistique", "Descriptifs"];
const MATIERES = ["Quartz", "Grès Cérame"];
// Matières de Tranche : les deux de base + celles ajoutées par Nils depuis la
// fiche article (clé erp:matieres, seulement les ajoutées). Chaque matière
// porte sa lettre de nomenclature, son mot de désignation, ses épaisseurs
// vendues et son mode de suivi des couleurs :
//  - "couleur" (comme le Quartz) : chaque couleur à part, couleur fournisseur
//    obligatoire, pas de nuances ;
//  - "famille" (comme le Grès Cérame) : couleurs regroupées en familles
//    (fournisseur + code + finition), nuances au Stock.
const MATIERES_KEY = "erp:matieres";
const MATIERES_DE_BASE = [
  { nom: "Quartz", lettre: "Q", libelle: "Quartz", epaisseurs: ["20mm"], mode: "couleur" },
  { nom: "Grès Cérame", lettre: "C", libelle: "Grès Cérame", epaisseurs: ["6mm", "12mm", "20mm"], mode: "famille" },
];
const MATIERE_MODE = { "Quartz": "couleur", "Grès Cérame": "famille" };
function modeMatiere(m) {
  return MATIERE_MODE[m] || "couleur";
}
// Catégories Catalogue qui ne représentent jamais de matière physique —
// aucun lien Stock n'est jamais proposé pour elles. Toutes les autres
// (Tranche, Éviers, Accessoires, ou une catégorie personnalisée créée par
// l'utilisateur) peuvent générer une fiche Produit dans le Stock.
const CATEGORIES_ARTICLES_SANS_STOCK = ["Logistique", "Majorations", "Descriptifs"];
// Lettre utilisée dans la nomenclature d'une Tranche (ex. TC12NU08S1)
const MATIERE_CODE_NOMENCLATURE = { "Quartz": "Q", "Grès Cérame": "C" };
// Mot court utilisé dans la désignation d'une Tranche (ex. "Tranche Céram Royal...")
const MATIERE_LABEL_DESIGNATION = { "Quartz": "Quartz", "Grès Cérame": "Grès Cérame" };
// Nils 21/10 : lettre(s) de chaque finition dans la nomenclature (1 ou 2 lettres, choisies à la
// création, uniques) — avant, la 1re lettre du nom : deux finitions en S donnaient le même code.
// Rechargé sur place par appliquerFinitions ; une finition absente garde sa 1re lettre.
const FINITION_CODE_NOMENCLATURE = {};
const lettresSansAccent = (x) => (x || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toUpperCase();
const lettreParDefautFinition = (nom) => lettresSansAccent(nom).charAt(0);
// erp:finitions-articles était une liste de noms : chaque nom devient { nom, lettre } avec sa
// 1re lettre, pour que les codes déjà générés ne changent pas.
function normaliserFinitions(liste) {
  return (Array.isArray(liste) ? liste : [])
    .map((f) => (typeof f === "string" ? { nom: f, lettre: lettreParDefautFinition(f) } : f))
    .filter((f) => f && f.nom);
}
function appliquerFinitions(liste) {
  Object.keys(FINITION_CODE_NOMENCLATURE).forEach((k) => delete FINITION_CODE_NOMENCLATURE[k]);
  normaliserFinitions(liste).forEach((f) => { FINITION_CODE_NOMENCLATURE[f.nom] = f.lettre || lettreParDefautFinition(f.nom); });
}

// "320 × 160 cm" -> "320*160"
function dimensionCourte(dim) {
  if (!dim) return "";
  return dim.replace(/\s*cm\s*$/i, "").replace(/\s*[×xX]\s*/g, "*").trim();
}

// "324 × 162 cm" -> 5.25 (m², arrondi à 2 décimales — c'est cette valeur arrondie
// qui sert ensuite à convertir un prix au m² en prix à la tranche).
function surfaceM2(dim) {
  if (!dim) return null;
  const nums = dim.match(/[\d.,]+/g);
  if (!nums || nums.length < 2) return null;
  const a = parseFloat(nums[0].replace(",", "."));
  const b = parseFloat(nums[1].replace(",", "."));
  if (!a || !b) return null;
  return Math.round(((a / 100) * (b / 100)) * 100) / 100;
}

// Nomenclature auto (Tranches uniquement) : T + Matière(1) + Épaisseur + CodeFournisseur + Finition(1 ou 2) + Choix(1)
// ex : Grès Cérame, 12mm, NU08, Satinato, 1er choix -> "TC12NU08S1"
function calculerNomenclatureTranche(a) {
  if (!a || !a.matiere || !a.epaisseurMatiere || !a.finition) return "";
  const m = MATIERE_CODE_NOMENCLATURE[a.matiere] || "";
  const ep = (a.epaisseurMatiere || "").replace(/mm$/i, "");
  const cf = (a.codeFournisseur || "").trim();
  const f = FINITION_CODE_NOMENCLATURE[a.finition] || lettreParDefautFinition(a.finition);
  const ch = (a.choix || "").charAt(0);
  return `T${m}${ep}${cf}${f}${ch}`;
}

// ERP step 9 (accord du 21/09) : dans la désignation uniquement, l'épaisseur
// s'exprime en cm décimal (6mm → 0.6, 12mm → 1.2, 20mm → 2) plutôt qu'en
// millimètres bruts — la nomenclature/code (calculerNomenclatureTranche) et
// les menus déroulants/filtres isolés gardent le mm ("6mm"/"12mm"/"20mm").
function epaisseurDecimaleDesignation(epaisseurMatiere) {
  const ep = (epaisseurMatiere || "").replace(/mm$/i, "").trim();
  const n = Number(ep);
  if (!n && n !== 0) return ep;
  return String(Number((n / 10).toFixed(2)));
}
// Désignation auto (Tranches uniquement) : Tranche + Matière + CouleurFournisseur + CodeFournisseur + Finition + Épaisseur*Dimension [+ Promo si 2e choix]
// ex : "Tranche Céram Royal NU08 Satinato 1.2*324*162"
// La nuance n'entre jamais dans ce calcul : au Catalogue, une couleur a un
// seul code, quelle que soit la nuance réelle du lot qui la servira — la
// nuance ne se précise qu'au moment de la réservation ou de la production.
function calculerDesignationTranche(a) {
  if (!a || !a.matiere || !a.epaisseurMatiere || !a.finition) return "";
  const m = MATIERE_LABEL_DESIGNATION[a.matiere] || a.matiere;
  const cf = (a.couleurFournisseur || "").trim();
  const code = (a.codeFournisseur || "").trim();
  const f = a.finition || "";
  const ep = epaisseurDecimaleDesignation(a.epaisseurMatiere);
  const dim = dimensionCourte(a.dimension);
  const epDim = dim ? `${ep}*${dim}` : ep;
  const promo = (a.choix || "").startsWith("2") ? "Promo" : "";
  return ["Tranche", m, cf, code, f, epDim, promo].filter(Boolean).join(" ");
}
const GROUPES = [1, 2, 3, 4, 5];
// Épaisseur de la MATIÈRE BRUTE (la tranche telle qu'elle arrive) — distincte
// de l'épaisseur du produit fini, qui peut être plus grande grâce au collage.
// Le 20mm est rarement importé (trop cher pour le marché) mais reste listé.
const EPAISSEURS_MATIERE = ["6mm", "12mm", "20mm"];
// Épaisseurs réellement vendues par matière — le Quartz n'existe chez Stone
// Concept qu'en 20mm, le Grès Cérame dans les trois épaisseurs.
const EPAISSEURS_PAR_MATIERE = { "Quartz": ["20mm"], "Grès Cérame": ["6mm", "12mm", "20mm"] };

// Articles "structurels" (facturés à la tranche, prix dépendant du Groupe
// tarifaire de la couleur choisie — cf. Tarif_PUBLIC_HT_PDT du 11/02/2025).
// null = groupe non disponible pour cet article ("nd" dans le tarif).
// Articles non-structurels (accessoires, forfaits) : prix fixe unique.

// Plus aucun client précodé : à créer soi-même depuis Clients.
const DEFAULT_CLIENTS = [];

// Prix par groupe tarifaire, propre aux articles Tranche : la tarification
// dépend à la fois du Groupe (1 à 5) ET de la combinaison Matière+Épaisseur
// (ex. Grès Cérame 12mm n'a pas les mêmes prix que Quartz 20mm).
// Clé de ligne : "Matière|Épaisseur" -> { 1: prix, 2: prix, ..., 5: prix }
function cleCombinaisonTranche(matiere, epaisseur) {
  return `${matiere}|${epaisseur}`;
}
const COMBINAISONS_PRIX_TRANCHE = MATIERES.flatMap((m) => (EPAISSEURS_PAR_MATIERE[m] || EPAISSEURS_MATIERE).map((ep) => ({ matiere: m, epaisseur: ep, cle: cleCombinaisonTranche(m, ep) })));
// Recharge les tables des matières (appelé au chargement et à chaque ajout ou
// suppression d'une matière) : les tableaux et objets ci-dessus sont modifiés
// sur place pour que toutes les fonctions qui les lisent voient la liste à jour.
function appliquerMatieres(perso) {
  const liste = [...MATIERES_DE_BASE, ...(perso || []).filter((m) => m && m.nom && !MATIERES_DE_BASE.some((b) => b.nom === m.nom))];
  MATIERES.splice(0, MATIERES.length, ...liste.map((m) => m.nom));
  [MATIERE_CODE_NOMENCLATURE, MATIERE_LABEL_DESIGNATION, EPAISSEURS_PAR_MATIERE, MATIERE_MODE].forEach((o) => Object.keys(o).forEach((k) => delete o[k]));
  liste.forEach((m) => {
    MATIERE_CODE_NOMENCLATURE[m.nom] = m.lettre || "";
    MATIERE_LABEL_DESIGNATION[m.nom] = m.libelle || m.nom;
    EPAISSEURS_PAR_MATIERE[m.nom] = (m.epaisseurs && m.epaisseurs.length) ? m.epaisseurs : EPAISSEURS_MATIERE;
    MATIERE_MODE[m.nom] = m.mode === "famille" ? "famille" : "couleur";
  });
  COMBINAISONS_PRIX_TRANCHE.splice(0, COMBINAISONS_PRIX_TRANCHE.length, ...MATIERES.flatMap((m) => EPAISSEURS_PAR_MATIERE[m].map((ep) => ({ matiere: m, epaisseur: ep, cle: cleCombinaisonTranche(m, ep) }))));
}
const DEFAULT_PRIX_GROUPES_TRANCHE = Object.fromEntries(
  COMBINAISONS_PRIX_TRANCHE.map(({ cle }) => [cle, { 1: null, 2: null, 3: null, 4: null, 5: null }])
);
// Grille tarifaire officielle 2026 (tarif public, prix HT/m², émise le
// 13 septembre 2026) — Tranches céramique, 1er choix.
const GRILLE_OFFICIELLE_2026_1ER_CHOIX = {
  [cleCombinaisonTranche("Grès Cérame", "6mm")]: { 1: 884.82, 2: 981.52, 3: 1102.40, 4: 1199.11, 5: 1319.99 },
  [cleCombinaisonTranche("Grès Cérame", "12mm")]: { 1: 1750.93, 2: 1920.17, 3: 1944.34, 4: 2137.75, 5: 2476.21 },
};
Object.entries(GRILLE_OFFICIELLE_2026_1ER_CHOIX).forEach(([cle, prix]) => {
  DEFAULT_PRIX_GROUPES_TRANCHE[cle] = { ...DEFAULT_PRIX_GROUPES_TRANCHE[cle], ...prix };
});

// Même grille officielle, 2e choix (déclassé) — mêmes combinaisons
// Matière+Épaisseur et mêmes 5 groupes, mais des prix distincts et
// généralement inférieurs à ceux du 1er choix.
const DEFAULT_PRIX_GROUPES_TRANCHE_2E_CHOIX = Object.fromEntries(
  COMBINAISONS_PRIX_TRANCHE.map(({ cle }) => [cle, { 1: null, 2: null, 3: null, 4: null, 5: null }])
);
const GRILLE_OFFICIELLE_2026_2E_CHOIX = {
  [cleCombinaisonTranche("Grès Cérame", "6mm")]: { 1: 601.40, 2: 601.40, 3: 718.56, 4: 718.56, 5: 783.65 },
  [cleCombinaisonTranche("Grès Cérame", "12mm")]: { 1: 1169.65, 2: 1169.65, 3: 1286.81, 4: 1286.81, 5: 1469.05 },
};
Object.entries(GRILLE_OFFICIELLE_2026_2E_CHOIX).forEach(([cle, prix]) => {
  DEFAULT_PRIX_GROUPES_TRANCHE_2E_CHOIX[cle] = { ...DEFAULT_PRIX_GROUPES_TRANCHE_2E_CHOIX[cle], ...prix };
});

function migrerUnite(u) {
  if (!u) return u;
  return MIGRATION_UNITES[u] || u;
}

function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
}

function formatDateHeure(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return `${d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" })} à ${d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}`;
}

// Nils 17/10 : hors de claude.ai (ERP sur son serveur), le navigateur télécharge lui-même le fichier.
const TYPES_TELECHARGEMENT = { html: "text/html;charset=utf-8", csv: "text/csv;charset=utf-8", json: "application/json", txt: "text/plain;charset=utf-8", xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", pdf: "application/pdf" };
function telechargerParNavigateur(nomFichier, data) {
  const ext = String(nomFichier).split(".").pop().toLowerCase();
  const blob = data instanceof Blob ? data : new Blob([data], { type: TYPES_TELECHARGEMENT[ext] || "application/octet-stream" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = nomFichier;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

function formatTaille(octets) {
  if (!octets) return "0 o";
  if (octets < 1024) return `${octets} o`;
  if (octets < 1024 * 1024) return `${Math.round(octets / 1024)} Ko`;
  return `${(octets / 1024 / 1024).toFixed(1)} Mo`;
}

// Ancienneté lisible, pour repérer d'un coup d'œil une réservation oubliée
function ancienneteTexte(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const jours = Math.floor((Date.now() - d.getTime()) / 86400000);
  if (jours < 1) return "aujourd'hui";
  if (jours < 30) return `il y a ${jours} j`;
  const mois = Math.floor(jours / 30);
  if (mois < 12) return `il y a ${mois} mois`;
  const ans = Math.floor(jours / 365);
  return `il y a ${ans} an${ans > 1 ? "s" : ""}`;
}

// Une livraison dont la date est passée signale une réservation à revoir :
// critère objectif, plutôt qu'un seuil d'ancienneté arbitraire.
function livraisonDepassee(iso) {
  if (!iso) return false;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return false;
  const auj = new Date();
  auj.setHours(0, 0, 0, 0);
  return d < auj;
}

function uid() {
  return Math.random().toString(36).slice(2, 10);
}

// Migration : plaque de cuisson / évier sont passés d'un champ simple
// (une seule référence) à une liste (plusieurs par devis/dossier possibles).
// S'applique aussi bien à un devis qu'à un dossier commande.
function migrerElementsTechniques(obj) {
  const out = { ...obj };
  if (!Array.isArray(out.plaquesCuisson)) {
    out.plaquesCuisson = out.plaqueCuissonPresente && out.plaqueCuissonReference ? [{ id: uid(), reference: out.plaqueCuissonReference }] : [];
  }
  if (!Array.isArray(out.eviers)) {
    out.eviers = out.evierPresent && out.evierReference ? [{ id: uid(), reference: out.evierReference, type: out.evierType || "" }] : [];
  }
  // "Sans poignée" renommé en "Avec gorge" (plus précis techniquement) ; le
  // débord n'existait pas avant, on le déduit du type déjà choisi si possible.
  if (out.porteCuisineType === "Sans poignée") out.porteCuisineType = "Avec gorge";
  if (out.porteCuisine && out.porteCuisineType && (out.porteCuisineDebord == null || out.porteCuisineDebord === "")) {
    out.porteCuisineDebord = out.porteCuisineType === "Avec poignée" ? 4 : out.porteCuisineType === "Avec gorge" ? 3 : "";
  }
  return out;
}

const STORAGE_KEY = "stock:references";
const CATEGORIES_KEY = "stock:categories";
const FOURNISSEURS_KEY = "stock:fournisseurs";
// ERP step 7 (pt.7) : demandes de création fournisseur, remplies par les
// utilisateurs en lecture seule (Ahmed, Wissam) — Nils les convertit en
// vrais fournisseurs ou les ignore depuis l'onglet Fournisseurs.
const DEMANDES_FOURNISSEURS_KEY = "stock:demandes-fournisseurs";
// ERP step 11 (accord Nils du 29/09) : demandes de création de sous-catégorie
// de consommable (Nils seul crée catégories et sous-catégories).
const DEMANDES_SOUSCAT_KEY = "stock:demandes-souscategories";
// ERP step 11 (accord Nils du 29/09) : deux vitesses seulement. Les
// anciennes valeurs « Lent » / « Très lent » valent « Lente ».
const VITESSES_CONSO = ["Rapide", "Lente"];
// Nils 03/10 (f) : rappel en gris sous le choix de la vitesse.
function RappelVitesse({ vitesse }) {
  const v = normaliserVitesse(vitesse);
  const ligne = (nom, texte) => (<div style={{ opacity: !v || v === nom ? 1 : 0.55 }}><strong style={{ fontWeight: 600 }}>{nom}</strong> : {texte}</div>);
  return (
    <div style={{ fontSize: 11, color: TAUPE, lineHeight: 1.5, marginTop: 5 }}>
      {ligne("Rapide", "consommé au fil des dossiers (colle, mastic, scotch…) — saisi sur le PL ou dans « Enregistrer une consommation › consommables », sort du stock tout de suite.")}
      {ligne("Lente", "dure plusieurs semaines (disques, meules, abrasifs diamantés…) — pas saisi par dossier : mis en service sur une machine ou une personne, puis hors service ; l'ERP mesure sa durée de vie.")}
    </div>
  );
}
function normaliserVitesse(v) {
  if (v === "Lent" || v === "Très lent" || v === "Lente") return "Lente";
  if (v === "Rapide") return "Rapide";
  return "";
}
const MOTIFS_HORS_SERVICE = ["Usure normale", "Casse", "Perte"];
// ERP step 11 : article du Catalogue qui appelle une fiche technique (une par unité).
const DOCUMENTS_REQUIS_ARTICLE = [
  { id: "", label: "Aucune" },
  { id: "evier", label: "Fiche technique évier" },
  { id: "plaque", label: "Fiche technique plaque de cuisson" },
];
function formatDH(n) {
  const v = Number(n);
  if (!isFinite(v)) return "—";
  return v.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " DH";
}
const MOUVEMENTS_KEY = "stock:mouvements";
const RESERVATIONS_KEY = "stock:reservations";
// Registre de crédit (ERP step 9, accord du 21/09) : crédit réutilisable par
// produit Stock exact (fini la notion de famille couleur/épaisseur) — généré
// quand un PL non-exo consomme moins de tranches que facturé, consommé
// uniquement à la création/transformation d'un BC exo.
const CREDITS_TRANCHES_KEY = "stock:credits-tranches-exonerables";
// Historique des mouvements du registre de crédit (Step 11, accord Nils du
// 21/09) : journal append-only, distinct du solde lui-même
// (creditsTranches) — consommerCreditListe/restituerCreditListe ne gardent
// aucune trace de leurs mouvements, ce journal comble ce manque. Nettoyage
// possible ligne par ligne uniquement (jamais un "vider tout").
const CREDITS_HISTORIQUE_KEY = "stock:credits-tranches-historique";
// Journal d'accès : connexions ("Je suis") et actions sensibles, visible
// uniquement par Nils. Le sélecteur "Je suis" n'étant pas une vraie
// authentification, ce journal reflète le profil déclaré, pas une identité
// vérifiée — utile pour savoir qui est passé sur l'app, pas un dispositif
// de sécurité.
const JOURNAL_ACCES_KEY = "erp:journal-acces";
// ERP step 11 (accord Nils du 29/09) : journal d'alertes pour Nils (actions
// sensibles), exporté avec les autres données.
const ALERTES_KEY = "erp:alertes";
const SEUIL_ECART_PRIX_PCT = 10; // valeur par défaut — réglable par Nils (onglet Alertes & tâches)
// ERP step 11 : paramètres réglables par Nils sans recoder.
const PARAMETRES_KEY = "erp:parametres";
// ERP step 11 (accord Nils du 29/09) : campagnes d'inventaire physique.
const CAMPAGNES_INVENTAIRE_KEY = "stock:campagnes-inventaire";
// ERP step 11 : consommables lents « en service » + affectations (machines / personnes).
const EN_SERVICE_KEY = "stock:en-service";
// ERP step 11 (accord Nils du 29/09) : un lot supprimé n'est plus effacé mais
// archivé ici (avec un instantané de son produit), pour l'inventaire à date.
const LOTS_ARCHIVES_KEY = "stock:lots-archives";
// Nils 01/11 : registre des plans récupérés (plans cassés ou erronés gardés pour être réutilisés).
// Chaque fiche porte le dessin de Wissam et des photos ; en stock, le plan est un lot « chute » à
// 0 DH (planRecupereId) qui sort par le PL d'un dossier, par recoupe en chute (Ahmed, Gérant) ou hors
// atelier (Gérant). Le statut d'une fiche se lit sur les mouvements de son lot.
const PLANS_RECUPERES_KEY = "stock:plans-recuperes";
const ETATS_PLAN_RECUPERE = ["Cassé", "Erroné", "Réutilisable en partie"];
const ORIGINES_PLAN_RECUPERE = ["SAV", "Incident de production", "Autre"];
const MOTIFS_HORS_ATELIER = ["Usage interne", "Exposition", "Don", "Mise au rebut"];
const NATURES_FICHIER_PLAN = [["dessin", "Dessin"], ["photo", "Photo"], ["autre", "Autre"]];
// Nils 01/11 (étape c) : incident de production — erreur ou casse avant livraison, déclarée sur le PL
// par Ahmed (ou le Gérant) : motif (liste des motifs SAV), photo, tranches sorties en plus sur le même
// PL (marquées « incident », référence « PL-…-INC-… »), pièce ratée au registre des plans récupérés,
// alerte au Gérant. Rien ne change pour le client.
const INCIDENTS_KEY = "erp:incidents-production";
// Nils 01/11 : onglet « Communication » — mémos (écrits dans l'ERP) et documents (PDF ou lien) publiés
// par le Gérant, pour tout le monde ou certains profils ; temps de lecture affiché ; « J'ai lu » par
// personne et par version ; pastille ⚠ tant qu'il reste quelque chose à lire ; lecture obligatoire
// (plein écran à l'ouverture de l'ERP) au cas par cas.
const COMMUNICATIONS_KEY = "erp:communications";
const LECTURES_COM_KEY = "erp:communications-lectures";
const CATEGORIES_DOCUMENTS_COM = ["Charte", "Modes d'emploi", "Procédures"];
const AFFECTATIONS_KEY = "erp:affectations";
const LIB_TYPE_AFFECTATION = { machine: "Machine", service: "Service", bureau: "Bureau" };
// ERP step 12 (validé Nils du 30/09) : onglet Staff — liste unique des
// personnes. Remplace la liste manuelle des poseurs et les affectations de
// type « personne » (machines et lieux restent dans erp:affectations).
// Gestion : Nils et Sawsan (intégralité) ; Ahmed en lecture, sans les
// fiches de la direction, du secrétariat (Sawsan), de l'ADV et des commerciaux.
const STAFF_KEY = "erp:staff";
const SERVICES_STAFF = ["Direction", "Secrétariat de direction", "ADV", "Commercial", "Bureau technique", "Atelier", "Pose", "Logistique", "Autre"];
const DEFAULT_TYPES_CONTRAT = ["CDI", "CDD", "ANAPEC", "Journalier", "Agent commercial"];
function normNomStaff(s) {
  return String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/\s+/g, " ").trim();
}
// Actif = pas de date de sortie, ou date de sortie encore à venir.
function staffActif(s) {
  return !!s && (!s.dateSortie || s.dateSortie > new Date().toISOString().slice(0, 10));
}
function ficheStaffVide() {
  return { id: "", prenom: "", nomFamille: "", nom: "", poste: "", service: "", contrat: "", dateEmbauche: "", dateSortie: "", telephonePro: "", telephonePerso: "", compte: "", poseur: false, detenteur: false, usure: false, baseUsure: "transformation", note: "", salaires: [], primes: [], evaluations: [], reportConges: {}, responsableId: "", adresse: "", urgenceNom: "", urgenceLien: "", urgenceTel: "", regime: "", soldeHeuresInitial: "", matricule: "", cnss: "", cin: "" };
}
// ERP step 12 (demande Nils du 30/09) : prénom et nom séparés ; `nom` garde
// le nom complet « Prénom Nom » (utilisé tel quel par la fiche de pose, les
// listes et l'historique). Deux téléphones : pro et perso.
function nomCompletStaff(prenom, nomFamille) {
  return `${String(prenom || "").trim()} ${String(nomFamille || "").trim()}`.trim();
}
function decouperNomStaff(nom) {
  const t = String(nom || "").trim().split(/\s+/).filter(Boolean);
  return { prenom: t[0] || "", nomFamille: t.slice(1).join(" ") };
}
// ERP step 13 (Nils 04/10) : les externes (agent commercial…) ne font pas partie du pointage.
function estExterneStaff(s) { return !!s && (s.externe === true || (s.externe === undefined && s.contrat === "Agent commercial")); }
function normaliserFicheStaff(s) {
  if (!s) return s;
  const f = { ...s };
  if (f.prenom === undefined && f.nomFamille === undefined) Object.assign(f, decouperNomStaff(f.nom));
  f.prenom = f.prenom || "";
  f.nomFamille = f.nomFamille || "";
  f.nom = nomCompletStaff(f.prenom, f.nomFamille) || f.nom || "";
  if (f.telephonePro === undefined) f.telephonePro = f.telephone || "";
  if (f.telephonePerso === undefined) f.telephonePerso = "";
  delete f.telephone;
  if (!Array.isArray(f.salaires)) f.salaires = [];
  if (!Array.isArray(f.evaluations)) f.evaluations = [];
  if (!f.reportConges || typeof f.reportConges !== "object") f.reportConges = {};
  if (!Array.isArray(f.primes)) f.primes = [];
  return f;
}
// ERP step 12 (validé Nils du 30/09) : suivi du personnel.
// - Sawsan saisit chaque mois, par personne, les jours de congés, récupération, absences…
// - Signalements : n'importe qui sur n'importe qui ; remontés à Nils (alerte) et historisés.
// - Évaluation semestrielle : l'encadrant propose (Sawsan, Ahmed dans son périmètre), Nils valide.
// Salaires, congés, signalements, évaluations visibles par Nils, Sawsan et Ahmed (son périmètre).
const SUIVI_MENSUEL_KEY = "erp:suivi-mensuel";
// Type d'une ligne de salaire (demande Nils du 30/09 : distinguer augmentation et ancienneté).
const TYPES_SALAIRE = ["Embauche", "Augmentation", "Ancienneté"];
// Primes (demande Nils du 30/09) : pour se rappeler combien on donne à chacun.
// Liste modifiable dans Paramétrage. La prime de productivité automatique
// (250 DH / semaine si target de CA atteint) est à définir.
const DEFAULT_TYPES_PRIMES = ["Aïd al-Fitr", "Aïd al-Adha", "Exceptionnelle"];
// Prime de productivité (règles Nils du 30/09) : chaque semaine (lundi → dimanche),
// CA facturé HT des dossiers contenant au moins un article « consommables de
// production » (article de nature « Façonnage »), lignes Tranche exclues ; si le
// target n'est pas atteint, on ajoute une part du CA Tranches livré (BL) dans la
// semaine. Calcul proposé le mardi ; Nils valide. Tout le monde sauf Nils et les
// commerciaux ; toute absence de la semaine supprime le droit (exceptions : Nils).
const PRIMES_PRODUCTIVITE_KEY = "erp:primes-productivite";
const TYPE_PRIME_PRODUCTIVITE = "Productivité";
// Nils 23/10 : primes versées par une caisse et lues dans la fiche Staff (la prime de
// déplacement garde son propre mécanisme : Caisse Nils, reliée aux mois).
// Nils 26/10 : un seul sous-poste « Primes » ; la productivité en est un type (fixe). L'ancien
// sous-poste « Prime de productivité » est migré par le serveur (primesProductiviteType) ;
// encore lu ici au cas où.
const SOUS_POSTE_PRIMES = "Primes";
const ANCIEN_SOUS_POSTE_PRODUCTIVITE = "Prime de productivité";
const SOUS_POSTES_PRIMES_VERSEES = [SOUS_POSTE_PRIMES, ANCIEN_SOUS_POSTE_PRODUCTIVITE];
const DEFAULT_PARAMS_PRODUCTIVITE = { target: 230000, montant: 250, partTranchesPct: 10 };
// ERP step 12 (Nils 30/09) : la date d'une facture peut être antidatée de quelques jours
// à la transformation (Sawsan facture souvent le lundi une vente du vendredi).
const JOURS_ANTIDATE_FACTURE = 7;
const CODES_ABSENCE_PRIME = ["A", "MC", "MS", "MP"];
function lundiDe(dateISO) {
  const d = new Date(`${dateISO}T12:00:00Z`);
  const j = d.getUTCDay();
  d.setUTCDate(d.getUTCDate() - (j === 0 ? 6 : j - 1));
  return d.toISOString().slice(0, 10);
}
function decalerJours(dateISO, n) {
  const d = new Date(`${dateISO}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}
const SIGNALEMENTS_KEY = "erp:signalements";
const COMPTEURS_MENSUELS = [
  { cle: "conges", label: "Congés" },
  { cle: "recuperation", label: "Récupération" },
  { cle: "absJustifiee", label: "Absence justifiée" },
  { cle: "absInjustifiee", label: "Absence injustifiée" },
  { cle: "maladie", label: "Maladie / accident" },
];
const TYPES_SIGNALEMENT = ["Conflit", "Retard / absence", "Comportement", "Sécurité", "Qualité du travail", "Plainte client", "Point positif", "Autre"];
const GRAVITES_SIGNALEMENT = ["Faible", "Moyenne", "Élevée"];
const CRITERES_EVALUATION = [
  { cle: "qualite", label: "Qualité du travail" },
  { cle: "productivite", label: "Productivité" },
  { cle: "assiduite", label: "Assiduité / ponctualité" },
  { cle: "equipe", label: "Esprit d'équipe" },
  { cle: "consignes", label: "Respect des consignes et de la sécurité" },
];
const NOTES_EVALUATION = ["A", "B", "C"];
function semestreDe(dateISO) {
  return `${dateISO.slice(0, 4)}-S${Number(dateISO.slice(5, 7)) <= 6 ? 1 : 2}`;
}
function semestrePrecedent(sem) {
  const [y, s] = sem.split("-S");
  return s === "1" ? `${Number(y) - 1}-S2` : `${y}-S1`;
}
function bornesSemestre(sem) {
  const [y, s] = sem.split("-S");
  return s === "1" ? [`${y}-01-01`, `${y}-06-30`] : [`${y}-07-01`, `${y}-12-31`];
}
function libSemestre(sem) {
  const [y, s] = sem.split("-S");
  return `${s === "1" ? "1er" : "2e"} semestre ${y}`;
}
function moisDecale(ym, delta) {
  const [y, m] = ym.split("-").map(Number);
  const d = new Date(Date.UTC(y, m - 1 + delta, 1));
  return d.toISOString().slice(0, 7);
}
function libMois(ym) {
  const [y, m] = ym.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, 15)).toLocaleDateString("fr-FR", { month: "long", year: "numeric", timeZone: "UTC" });
}
function finDeMois(ym) {
  const [y, m] = ym.split("-").map(Number);
  return new Date(Date.UTC(y, m, 0)).toISOString().slice(0, 10);
}
// Présent au moins un jour dans la période [debut, fin] (dates ISO).
function staffPresentSur(s, debut, fin) {
  return (!s.dateEmbauche || s.dateEmbauche <= fin) && (!s.dateSortie || s.dateSortie >= debut);
}
// Profils d'accès (Nils 02/10) : l'équipe d'un responsable = la chaîne des responsables (fiches Staff)
// qui remonte jusqu'à la fiche liée à son compte.
function dansPerimetre(s, staffListe, compteId) {
  if (!s || !compteId) return false;
  const vus = new Set();
  let r = s.responsableId;
  while (r && !vus.has(r)) {
    vus.add(r);
    const chef = (staffListe || []).find((x) => x.id === r);
    if (!chef) return false;
    if (chef.compte === compteId) return true;
    r = chef.responsableId;
  }
  return false;
}
// Fiche de Nils : masquée pour tout le monde (demande Nils du 30/09) — elle
// ne sert qu'à relier son compte ERP (profil Gérant).
// Step 17 (Nils 15/10) : rattaché au profil Gérant, plus au prénom (mis à jour par l'ERP au rendu).
let COMPTES_FICHE_MASQUEE = new Set(["nils"]);
function ficheStaffMasquee(s) {
  return !!s && COMPTES_FICHE_MASQUEE.has(s.compte);
}
// Services dont les personnes sont rattachées à Ahmed par défaut (modifiable fiche par fiche).
const SERVICES_SOUS_AHMED = ["Atelier", "Pose", "Logistique", "Bureau technique", "Autre"];
const DEFAULT_PARAMS_CONGES = { joursParMois: 1.5, bonusParTranche: 1.5, trancheAnnees: 5, plafond: 30 };
// Congés (Code du travail marocain, à faire valider par le comptable) :
// 1,5 jour ouvrable par mois de service, + 1,5 jour par tranche de 5 ans
// d'ancienneté, plafonné à 30 jours par an.
function droitCongesAnnuelPlein(s, annee, params) {
  const p = { ...DEFAULT_PARAMS_CONGES, ...(params || {}) };
  const fin = `${annee}-12-31`;
  const ans = s.dateEmbauche ? Math.max(0, (new Date(fin) - new Date(s.dateEmbauche)) / (365.25 * 86400000)) : 0;
  const tranches = p.trancheAnnees > 0 ? Math.floor(ans / p.trancheAnnees) : 0;
  return Math.min(p.plafond, p.joursParMois * 12 + p.bonusParTranche * tranches);
}
function congesAcquisADate(s, annee, aujourdhui, params) {
  const debutAnnee = `${annee}-01-01`;
  const debut = s.dateEmbauche && s.dateEmbauche > debutAnnee ? s.dateEmbauche : debutAnnee;
  let fin = aujourdhui < `${annee}-12-31` ? aujourdhui : `${annee}-12-31`;
  if (s.dateSortie && s.dateSortie < fin) fin = s.dateSortie;
  if (fin < debut) return 0;
  const mois = Math.min(12, (new Date(fin) - new Date(debut)) / 86400000 / 30.44);
  return Math.round((droitCongesAnnuelPlein(s, annee, params) * mois / 12) * 2) / 2;
}
// ---- ERP step 12 (validé Nils du 30/09) : pointage mensuel ----
// Remplace le fichier Excel (Ahmed → Sawsan → comptable). Une case vide =
// présent aux heures dues ; on ne saisit que les exceptions.
const POINTAGE_KEY = "erp:pointage";
// Heures dues par jour de la semaine (index 0 = dimanche … 6 = samedi).
const DEFAULT_REGIMES_HORAIRES = {
  usine: { label: "Usine", heures: [0, 9, 9, 9, 9, 8, 0], pointageHeures: true },
  // Nils 04/10 (y) : bureau de Marrakech — accord 40 h, jamais d'heures sup. (heures en plus ignorées).
  bureau: { label: "Bureau Marrakech", heures: [0, 8, 8, 8, 8, 8, 0], pointageHeures: true, sansHS: true },
  // Nils 06/10 : heures pointées aussi pour les commerciaux (Taha).
  commercial: { label: "Commercial", heures: [0, 8.8, 8.8, 8.8, 8.8, 8.8, 0], pointageHeures: true },
};
const JOURS_SEMAINE_COURTS = ["D", "L", "M", "M", "J", "V", "S"];
const JOURS_SEMAINE_LONGS = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
function regimeDefautService(service) {
  if (service === "ADV" || service === "Secrétariat de direction") return "bureau";
  if (service === "Commercial") return "commercial";
  return "usine";
}
// Codes d'une journée. Effets (décisions Nils du 30/09) :
// C congé → −1 j de congé ; F férié → rien ; R récupération, AJ, AI, MS →
// heures dues retirées du compteur (AJ peut être imputée sur les congés) ;
// MC maladie / accident avec certificat → jour retiré de la paie (CNSS).
const CODES_POINTAGE = [
  { code: "C", label: "Congé", couleur: "#DCE6F2" },
  { code: "F", label: "Jour férié", couleur: "#E8E3DF" },
  { code: "R", label: "Récupération", couleur: "#E4EBE4" },
  // Nils 06/10 : « Absence justifiée » supprimée ; « Absence injustifiée » devient « Absence » (A). Anciennes cases AJ / AI = A.
  { code: "A", label: "Absence", couleur: "#F5E4DE" },
  { code: "RT", label: "Récup. retour tardif (½ j comptée présente)", couleur: "#E4EBE4" },
  { code: "MC", label: "Maladie / accident avec certificat", couleur: "#EDE3F0" },
  // Nils 06/10 : mise à pied — jour non payé, saisi par Sawsan ou Nils.
  { code: "MP", label: "Mise à pied", couleur: "#E9D3D3" },
];
// Jours fériés civils fixes du Maroc (les fêtes religieuses changent chaque année : à saisir).
const FERIES_FIXES_MAROC = [
  ["01-01", "Nouvel an"],
  ["01-11", "Manifeste de l'indépendance"],
  ["01-14", "Nouvel an amazigh"],
  ["05-01", "Fête du travail"],
  ["07-30", "Fête du Trône"],
  ["08-14", "Allégeance Oued Ed-Dahab"],
  ["08-20", "Révolution du Roi et du Peuple"],
  ["08-21", "Fête de la Jeunesse"],
  ["11-06", "Marche verte"],
  ["11-18", "Fête de l'Indépendance"],
];
function joursDuMois(ym) {
  const [y, m] = ym.split("-").map(Number);
  const n = new Date(Date.UTC(y, m, 0)).getUTCDate();
  return Array.from({ length: n }, (_, i) => {
    const d = i + 1;
    const date = `${ym}-${String(d).padStart(2, "0")}`;
    return { d, cle: String(d).padStart(2, "0"), date, jourSemaine: new Date(Date.UTC(y, m - 1, d)).getUTCDay() };
  });
}
function arrondiH(x) {
  return Math.round((Number(x) || 0) * 100) / 100;
}
function formatH(x) {
  const v = arrondiH(x);
  return `${v > 0 ? "+" : ""}${String(v).replace(".", ",")} h`;
}
// Nils 05/10 : ramadan — heures offertes par jour selon l'horaire (usine 2 h — atelier, poseurs,
// Ahmed, Wissam ; bureau Marrakech 1 h ; commerciaux 2 h). Les heures faites entre l'horaire
// réduit et l'horaire normal ne comptent jamais comme heures sup. (ni au compteur).
// Nils 06/10 : correction — pendant le ramadan, chaque employé doit un nombre fixe d'heures par jour
// (7 h, vendredi inclus), réglable par horaire ; les heures offertes = horaire normal − ce nombre.
const DEFAULT_RAMADAN_DUES = { usine: 7, bureau: 7, commercial: 7 };
function enRamadan(regime, date) {
  const r = regime && regime.ramadan;
  return !!r && (r.periodes || []).some((p) => p.debut && p.fin && date >= p.debut && date <= p.fin);
}
// Heures dues d'un jour : normales (horaire) et réelles (ramadan).
function duesDuJour(regime, date, jourSemaine) {
  const normal = Number(regime.heures[jourSemaine]) || 0;
  if (!(normal > 0) || !enRamadan(regime, date)) return { normal, dues: normal, offert: 0 };
  const r = regime.ramadan;
  // Ancien format (heures offertes) toléré pour les mois figés avant le 06/10.
  const duesR = r.dues !== undefined && r.dues !== "" ? Number(r.dues) : Math.max(0, normal - (Number(r.offert) || 0));
  const dues = Math.min(normal, Math.max(0, duesR));
  return { normal, dues, offert: normal - dues };
}
// Calcul d'un mois pour une personne. `regime` = { heures[7], pointageHeures } ;
// `speciaux` = { "AAAA-MM-JJ": { type: "ferie"|"conge", libelle } } ;
// `jours` = saisies { "JJ": { code, demi, heures, surConges, note } }.
// Nils 06/10 : congés spéciaux (paternité, maternité…) saisis sur la fiche Staff ; types modifiables dans Paramétrage.
// prise : "employeur" (jour payé normalement) ou "cnss" (retiré de la paie, indemnisé par la CNSS). À confirmer avec le comptable.
// Nils 06/10 : outils réservés à la phase de développement (bouton « ⚡ » du pointage) — passer à false avant la mise en production (OVH).
// Étape h : réglé au démarrage d'après le serveur (GET /api/config) — en production, plus de bouton ⚡
// de développement, plus d'import ni de « Vider les données ».
let MODE_DEV = true;
let EN_PRODUCTION = false;
export function reglerModeProduction(production) {
  EN_PRODUCTION = !!production;
  MODE_DEV = !production;
}
const DEFAULT_TYPES_CONGES_SPECIAUX = [
  { id: "paternite", libelle: "Congé de paternité", code: "CP", prise: "employeur", jours: 3 },
  { id: "maternite", libelle: "Congé de maternité", code: "CMa", prise: "cnss", jours: 98 },
];
function congeSpecialDu(s, date, types) {
  const c = ((s && s.congesSpeciaux) || []).find((x) => x.debut <= date && x.fin >= date);
  if (!c) return null;
  const type = (types || DEFAULT_TYPES_CONGES_SPECIAUX).find((t) => t.id === c.typeId) || { id: c.typeId, libelle: c.libelle || "Congé spécial", code: "CS", prise: "employeur" };
  return { conge: c, type };
}
// Nils 09/10 : MS (maladie sans certificat) supprimé → lu comme A (absence), comme AJ / AI le 06/10.
function codeNorm(c) {
  return c === "AI" || c === "AJ" || c === "MS" ? "A" : c;
}
function code2Saisie(x) {
  const c2 = x && x.demi && x.code2 ? codeNorm(x.code2) : "";
  return c2 && c2 !== "F" && c2 !== codeNorm(x.code) ? c2 : "";
}
// Codes d'une case : [{ code, frac }] (une ou deux demi-journées).
function codesSaisie(x) {
  if (!x || !x.code) return [];
  const c2 = code2Saisie(x);
  const c1 = codeNorm(x.code);
  return c2 ? [{ code: c1, frac: 0.5 }, { code: c2, frac: 0.5 }] : [{ code: c1, frac: x.demi ? 0.5 : 1 }];
}
function texteCodeSaisie(x) {
  const c2 = code2Saisie(x);
  return c2 ? `${codeNorm(x.code)}/${c2}` : `${x.demi ? "½" : ""}${codeNorm(x.code)}`;
}
function calculPointageMois(s, ym, regime, speciaux, jours, typesCS) {
  const r = { dues: 0, ouvres: 0, presents: 0, congesJ: 0, feriesJ: 0, recupH: 0, aH: 0, mcJ: 0, mcH: 0, msJ: 0, msH: 0, supH: 0, moinsH: 0, ecart: 0, ferieH: 0, ferieRecupH: 0, ferieADecider: 0, ramadanH: 0, mpJ: 0, csJ: 0, csCnssJ: 0, csEmployeurJ: 0 };
  // Nils 04/10 (y) : bureau sans heures sup. ; férié travaillé = « payer » (colonne à part) ou « récupérer » (compteur), au cas par cas.
  const sansHS = !!(regime && (regime.sansHS || regime.cle === "bureau"));
  const ferieTravaille = (saisie) => {
    const h = Number(saisie && saisie.heures) || 0;
    if (!regime.pointageHeures || h <= 0) return;
    if (saisie.ferie === "payer") r.ferieH += h;
    else if (saisie.ferie === "recuperer") { r.ferieRecupH += h; r.supH += h; r.ecart += h; }
    else r.ferieADecider += h;
  };
  joursDuMois(ym).forEach((j) => {
    if (s.dateEmbauche && j.date < s.dateEmbauche) return;
    if (s.dateSortie && j.date > s.dateSortie) return;
    const sp = speciaux[j.date];
    // Congé spécial (fiche Staff) : hors compteur et hors congés annuels.
    const cs = congeSpecialDu(s, j.date, typesCS);
    if (cs) {
      const d0 = duesDuJour(regime, j.date, j.jourSemaine);
      if (!(sp && sp.type === "ferie") && d0.dues > 0) { r.ouvres += 1; r.dues += d0.dues; r.csJ += 1; if (cs.type.prise === "cnss") r.csCnssJ += 1; else r.csEmployeurJ += 1; }
      return;
    }
    const saisie = (jours || {})[j.cle] || null;
    const code = saisie && saisie.code !== undefined ? codeNorm(saisie.code) : sp ? (sp.type === "ferie" ? "F" : "C") : "";
    const dj = duesDuJour(regime, j.date, j.jourSemaine);
    const duesJour = code === "F" || (sp && sp.type === "ferie") ? 0 : dj.dues;
    const normalJour = code === "F" || (sp && sp.type === "ferie") ? 0 : dj.normal;
    if (duesJour > 0 && dj.offert > 0) r.ramadanH += Math.min(dj.offert, normalJour);
    const frac = saisie && saisie.demi ? 0.5 : 1;
    if (duesJour > 0) { r.ouvres += 1; r.dues += duesJour; }
    if (!code) {
      if (duesJour > 0) r.presents += 1;
      if (sp && sp.type === "ferie") { r.feriesJ += 1; if (saisie) ferieTravaille(saisie); return; }
      if (regime.pointageHeures && saisie && saisie.heures !== undefined && saisie.heures !== "" && saisie.heures !== null) {
        let e = (Number(saisie.heures) || 0) - duesJour;
        // Ramadan : les heures entre l'horaire réduit et l'horaire normal sont neutres.
        if (e > 0 && normalJour > duesJour) e = Math.max(0, (Number(saisie.heures) || 0) - normalJour);
        if (e > 0 && sansHS) e = 0;
        if (e > 0) r.supH += e; else r.moinsH += -e;
        r.ecart += e;
      }
      return;
    }
    if (code === "F") {
      r.feriesJ += 1;
      if (saisie) ferieTravaille(saisie);
      return;
    }
    // Nils 06/10 : une demi-journée peut avoir un autre code sur l'autre moitié (code2 ; vide = présent).
    const effet = (cd, fr) => {
      const h = duesJour * fr;
      if (cd === "C") r.congesJ += fr;
      else if (cd === "R") { r.recupH += h; r.ecart -= h; }
      else if (cd === "A") { r.aH += h; r.ecart -= h; }
      // Nils 09/10 : RT = récupération retour tardif (après 22 h) — comptée comme présence, sans toucher au compteur.
      else if (cd === "RT") { r.presents += fr; r.rtJ = (r.rtJ || 0) + fr; }
      else if (cd === "MC") { r.mcJ += fr; r.mcH += h; }
      else if (cd === "MP") r.mpJ += fr;
    };
    effet(code, frac);
    const code2 = frac < 1 ? code2Saisie(saisie) : "";
    if (code2) effet(code2, 0.5);
    else if (frac < 1 && duesJour > 0) r.presents += 0.5;
  });
  Object.keys(r).forEach((k) => { r[k] = arrondiH(r[k]); });
  return r;
}
// ---- ERP step 12 (validé Nils du 30/09) : Comptabilité — phase 1 : trésorerie ----
// Un compte par caisse + la banque CFG ; un journal unique Entrée / Sortie ;
// plan de postes unifié (fusion des 6 fichiers 2026) ; transferts confirmés
// par le receveur ; encaissements toujours liés à un dossier (facture, BLS
// pour les ventes exo, BC pour une avance).
const TRESORERIE_KEY = "erp:tresorerie";
const COMPTES_TRESORERIE_KEY = "erp:comptes-tresorerie";
const DEFAULT_COMPTES_TRESORERIE = [
  { id: "caisse-nils", nom: "Caisse Nils", type: "caisse", responsables: ["nils"], soldeOuverture: 0, dateOuverture: "2026-01-01", negatifAutorise: true, debitEstEntree: false, lecteurs: [] },
  { id: "caisse-bureau", nom: "Caisse Bureau", type: "caisse", responsables: ["sawsan"], soldeOuverture: 0, dateOuverture: "2026-01-01", negatifAutorise: false, debitEstEntree: true, lecteurs: [] },
  { id: "caisse-usine", nom: "Caisse Usine", type: "caisse", responsables: ["wissam"], soldeOuverture: 0, dateOuverture: "2026-01-01", negatifAutorise: false, debitEstEntree: false, lecteurs: ["sawsan"] },
  { id: "caisse-taha", nom: "Caisse Taha", type: "caisse", responsables: ["taha"], soldeOuverture: 0, dateOuverture: "2026-01-01", negatifAutorise: false, debitEstEntree: false, lecteurs: ["sawsan"] },
  { id: "caisse-chraa", nom: "Caisse Chraa", type: "caisse", responsables: ["chraa"], soldeOuverture: 0, dateOuverture: "2026-01-01", negatifAutorise: false, debitEstEntree: false, lecteurs: ["sawsan"] },
  { id: "banque-cfg", nom: "CFG Bank", type: "banque", responsables: ["nils", "sawsan"], soldeOuverture: 0, dateOuverture: "2026-01-01", negatifAutorise: false, debitEstEntree: false, lecteurs: [] },
  // Nils 08/10 : sous-compte de la CFG en euros (e-commerce, carte à l'étranger), alimenté par transfert depuis la CFG.
  { id: "dotation-devises", nom: "Dotation devises (CFG)", type: "devises", devise: "EUR", parentId: "banque-cfg", responsables: ["nils", "sawsan"], soldeOuverture: 0, soldeOuvertureDevise: 0, dateOuverture: "2026-01-01", negatifAutorise: false, debitEstEntree: false, lecteurs: [] },
  { id: "caisse-generale", nom: "Caisse générale", type: "caisse", generale: true, responsables: ["nils", "sawsan"], soldeOuverture: 0, dateOuverture: "2026-01-01", negatifAutorise: false, debitEstEntree: false, lecteurs: [] },
  { id: "portefeuille-cheques", nom: "Portefeuille chèques", type: "portefeuille", responsables: ["nils", "sawsan", "wissam", "taha", "chraa"], soldeOuverture: 0, dateOuverture: "2026-01-01", negatifAutorise: false, debitEstEntree: false, lecteurs: [] },
];
// Nils 03/10 : les chèques et effets reçus ne vont pas dans une caisse (ils sont
// détenus par une personne) : portefeuille, puis dépôt à la CFG.
const PORTEFEUILLE_ID = "portefeuille-cheques";
// Nils 03/10 : « caisse générale » = la caisse traçable (comptable). Elle reçoit
// automatiquement des copies liées des opérations des autres caisses :
// dépenses en espèces avec facture (sortie), encaissements en espèces reliés à
// une facture non exo (entrée), retraits d'espèces CFG faits pour elle (entrée).
// Alerte à Nils sous 5 000 DH.
const CAISSE_GENERALE_ID = "caisse-generale";
const SEUIL_CAISSE_GENERALE = 5000;
// Nils 03/10 : un chèque est valable un an après sa date ; alerte 30 jours avant.
const JOURS_ALERTE_EXPIRATION_CHEQUE = 30;
const POSTE_ENCAISSEMENT = "Encaissements clients";
const POSTE_A_DEFINIR = "À définir";
// sens : "entree", "sortie" ou "les deux" (choix proposés selon le sens de l'opération).
const DEFAULT_PLAN_POSTES = [
  { poste: "Encaissements clients", sens: "entree", sous: ["Encaissements clients"] },
  { poste: "Approvisionnement", sens: "sortie", sous: ["Matières", "Déchargement", "Transitaire"] },
  { poste: "Pose & Production", sens: "sortie", sous: ["Carburant", "Péage (Jawaz)", "Caisse poseurs", "Consommables", "Livraison", "Maintenance", "Maintenance véhicule", "Parking", "Pose", "Production", "Leasing", "Voiture", "Location de matériel"] },
  { poste: "Frais de fonctionnement", sens: "sortie", sous: ["Loyer", "Eau & électricité", "Télécoms", "Assurance", "Bureautique & fournitures", "Carburant", "Déplacements", "Repas & bouche", "Maintenance", "Fiduciaire", "Frais bancaires", "Recrutement", "Divers fonctionnement"] },
  { poste: "Frais salariaux", sens: "sortie", sous: ["Salaires", "Primes", "Prime de déplacement", "Avances & acomptes", "Remboursements de frais"] },
  { poste: "Frais commerciaux", sens: "sortie", sous: ["Carburant", "Péage (Jawaz)", "Déplacements", "Hébergement", "Repas & bouche", "Voiture commerciale", "Leasing commercial", "Divers commercial"] },
  { poste: "Commissions", sens: "les deux", sous: ["Commissions versées", "Avances sur commissions", "Remboursement d'avances"] },
  { poste: "Marketing", sens: "sortie", sous: ["Marketing & communication", "Community management"] },
  { poste: "Investissements", sens: "sortie", sous: ["Travaux & équipements"] },
  { poste: "Charges fiscales & sociales", sens: "sortie", sous: ["CNSS", "IR", "IS & taxes", "TVA"] },
  { poste: "Compte associé", sens: "les deux", sous: ["Apport", "Remboursement"] },
  { poste: "Dividendes", sens: "sortie", sous: ["Dividendes"] },
  { poste: "Opérations exceptionnelles", sens: "les deux", sous: ["Prêt court terme client", "Remboursement reçu", "Cession de matériel", "Écart de caisse", "Retour d'avance de déplacement"] },
  { poste: "À définir", sens: "les deux", sous: ["À définir"] },
];
const SOUS_POSTE_AVANCES = "Avances & acomptes";
const MODES_PAIEMENT = ["Espèces", "Chèque", "Virement", "Prélèvement", "Effet / LCN", "Carte", "Application bancaire", "Compensation"];
// ERP step 12 (Nils 30/09) : fichier TVA mensuel du comptable (PROJET_COMPTABILITE).
// Mode ERP → colonne « MODE PAIEMENT » du comptable ; carte et application bancaire = AUTRE.
const MODE_COMPTABLE = { "Espèces": "ESPECES", "Chèque": "CHEQUE", "Virement": "VIREMENT", "Prélèvement": "PRELEVEMENT", "Effet / LCN": "EFFET", "Carte": "AUTRE", "Application bancaire": "AUTRE", "Compensation": "COMPENSATION" };
const TAUX_TVA = [0.2, 0.18, 0.16, 0.14, 0.13, 0.12, 0.1, 0.08, 0.07, 0];
// Tiers d'une opération (Nils 30/09) : entrée = client, fournisseur (remboursement) associé (apport), employé (remboursement d'avance) ou État (remboursement) — Nils 01/10 ;
// sortie = fournisseur, employé, État ou associé. Listes État / associés dans Paramétrage.
const TYPES_TIERS = { client: "Client", fournisseur: "Fournisseur", employe: "Employé", etat: "État / organisme", associe: "Associé", banque: "Banque" };
const TIERS_PAR_SENS = { entree: ["client", "fournisseur", "associe", "employe", "etat", "banque"], sortie: ["fournisseur", "employe", "etat", "associe", "banque"] };
const DEFAULT_ORGANISMES_ETAT = ["DGI (impôts)", "CNSS", "Douane", "Trésorerie générale", "Commune"];
const DEFAULT_ASSOCIES = ["Nils Fernagu"];
// ---- Factures fournisseurs & échéancier (validé Nils 30/09) ----
// Loi 69-21 : 60 jours date de facture, 120 jours maximum avec convention écrite ;
// au-delà, amende au Trésor ≈ taux directeur BAM le 1er mois + 0,85 % par mois
// suivant, sur le TTC non payé (estimation, à faire confirmer par le comptable).
const FACTURES_FOURNISSEURS_KEY = "erp:factures-fournisseurs";
// ERP step 12 (Nils 01/10) : factures clients antérieures à l'ERP (sans description), pour l'état client.
const FACTURES_ANTERIEURES_KEY = "erp:factures-clients-anterieures";
// Nils 29/10 : factures d'avance des projets immobiliers (une par projet), séries FA / FAS.
const FACTURES_AVANCE_KEY = "erp:factures-avance";
// Nils 03/10 : factures / BL de remplacement (client comptoir) qui reprennent le
// numéro et la date d'un document annulé, pour ne pas casser la séquence.
const REMPLACEMENTS_KEY = "erp:documents-remplacement";
// ERP step 14 (Nils 05/10) : ligne fixe des documents de remplacement + encaissement
// automatique en caisse générale (facture), daté du jour de la facture d'origine.
const DESIGNATION_REMPLACEMENT = "Frais de RDM — Casablanca";
const HT_REMPLACEMENT = 250;
// ---- ERP step 14 (Nils 05/10) : calcul des coûts de revient (ai) ----
// Visible par Nils seul (gérant). Reprend l'artefact « Calcul de tarification »
// généralisé en profils d'import ; les arrivages import portent le coût réel.
const COUTS_REVIENT_KEY = "erp:couts-revient";
// ERP step 14 (aj, Nils 05/10) : commissions — barèmes versionnés (date d'effet) + validations.
// Une commission n'est due que sur une commande ENTIÈREMENT encaissée (période = date du solde) ;
// le seuil se calcule sur le CA HT des commandes soldées dans la période (Nils 08/10). Taux par ligne selon la remise de la ligne.
const COMMISSIONS_KEY = "erp:commissions";
// ERP step 14 (d, Nils 05/10) : registre des déplacements (coût transport réel des dossiers).
const DEPLACEMENTS_KEY = "erp:deplacements";
// ERP step 15 (Nils 08/10) : registre des tranches posées en exposition chez un client — le fournisseur
// fait un avoir du montant de la tranche. Saisie manuelle (Nils, Sawsan), suivi de la demande d'avoir.
const EXPOSITIONS_KEY = "erp:expositions";
// Step 17 (Nils 15/10) : factures d'avoir clients — AV-AAAA-NNNN, AVS-AAAA-NNNN pour les factures exo ;
// partiel (lignes ou montant) ; l'avoir devient un crédit client, affecté à la main (Sawsan).
const AVOIRS_KEY = "erp:avoirs";
// ERP step 15 (ak, Nils 08/10) : véhicules et machines lourdes — fiches, conducteurs, échéances, carnet,
// relevé km du vendredi + tickets carburant (litres, DH, km), carnet des machines (historique).
const VEHICULES_KEY = "erp:vehicules";
const TYPES_ECHEANCE_VEHICULE = [["assurance", "Assurance"], ["vignette", "Vignette"], ["visite", "Visite technique"], ["leasing", "Leasing / crédit"], ["gps", "Abonnement GPS"]];
const SOUS_POSTES_VEHICULE = ["Carburant", "Péage (Jawaz)", "Maintenance véhicule", "Voiture", "Leasing", "Voiture commerciale", "Leasing commercial"];
const SOUS_POSTE_PEAGE = "Péage (Jawaz)";
// Nils 08/10 : les débiteuses réelles sont la Terzago et la Tecno MBM (créées par Nils) — plus de « Débiteuse 1 / 2 ».
const MACHINES_DEPART = ["Sagomatrice", "Banc de coupe diamanté", "Water jet"];
const TYPES_CARNET_MACHINE = ["Entretien", "Panne", "Réparation"];
function vehiculesDepart(dateISO) {
  const v = (id, nom, type, conducteurs) => ({ id, nom, immat: "", type, conducteurs, gps: false, actif: true, creeLe: dateISO, echeances: {}, carnet: [] });
  return [
    v("veh-movano", "Opel Movano", "livraison", []),
    v("veh-h100", "Hyundai H100", "livraison", []),
    v("veh-clio1", "Clio 1", "rdm", ["krim", "nils"]),
    v("veh-clio2", "Clio 2", "rdm", ["taha", "nils"]),
    v("veh-sandero", "Dacia Sandero", "rdm", ["wissam"]),
  ];
}
// Vendredi de la semaine en cours (ou dernier vendredi passé) pour une date ISO.
function vendrediDe(dateISO) {
  const j = new Date(`${dateISO}T12:00:00Z`).getUTCDay(); // 0 dim … 5 ven
  return decalerJours(dateISO, -((j - 5 + 7) % 7));
}
const STATUTS_AVOIR_EXPO = [["a_demander", "À demander"], ["demande", "Demandé"], ["recu", "Reçu"]];
const TYPES_DEPLACEMENT = ["Livraison", "RDM", "Pose", "SAV", "Autre"];
// ERP step 15 (al, Nils 08/10) : départ / retour, avance de frais (caisse usine) soldée au retour, jours au pointage,
// validation par Nils (statut « en cours » → « à valider » → « validée » ; fiche sans statut = ancienne, validée).
const CAISSE_AVANCE_DEPL = "caisse-usine";
const SOUS_POSTE_RETOUR_AVANCE = "Retour d'avance de déplacement";
const DEPL_POSE_DEPUIS = "2026-10-08";
function nbJoursPeriode(debut, fin) {
  if (!debut) return 0;
  const f = fin && fin >= debut ? fin : debut;
  return Math.round((new Date(`${f}T12:00:00Z`) - new Date(`${debut}T12:00:00Z`)) / 86400000) + 1;
}
const DEFAULT_COMMISSIONS = {
  versions: [{
    id: "v-2026", dateEffet: "2026-01-01",
    personnes: [
      { id: "chraa", nom: "Soufiane Chraa", remiseMax: 32, caisses: ["caisse-chraa", "caisse-nils"], regles: [
        { id: "r-chraa", libelle: "Commission", type: "remise", periode: "mois", clientsDe: ["chraa"], paliers: [{ sous: 26, taux: 10 }, { sous: 32, taux: 7 }, { sous: null, taux: 5 }] },
      ] },
      { id: "taha", nom: "Taha", caisses: ["caisse-taha", "caisse-nils"], regles: [
        { id: "r-taha-1", libelle: "Com1", type: "client", periode: "trimestre", clientsDe: ["nils", "taha"], tauxDirectionnel: 2.5, tauxNonDirectionnel: 3, seuil: { montant: 1800000, clientsDe: ["nils", "taha"], mode: "tout" } },
        { id: "r-taha-2", libelle: "Com2", type: "remise", periode: "mois", clientsDe: ["taha"], paliers: [{ sous: 21, taux: 7 }, { sous: 26, taux: 5 }, { sous: 31, taux: 3 }, { sous: null, taux: 0 }] },
      ] },
    ],
  }],
  validations: {},
  caissesApporteurs: ["caisse-nils"],
};
// Nils 05/10 (m) : source du client et budget marketing / community management.
const DEFAULT_SOURCES_CLIENT = ["Instagram", "Page web", "Recherche Google", "Facebook", "Digital", "Showroom", "Bouche à oreille", "Apporteur", "Commercial", "Réseau", "Événement", "Relance", "Autre"];
const DEFAULT_MARKETING_BUDGET = { taux: 5, sources: ["Instagram", "Page web", "Recherche Google"] };
const CAISSES_COMMISSION_DEFAUT = { taha: ["caisse-taha", "caisse-nils"], chraa: ["caisse-chraa", "caisse-nils"] };
function tauxPalier(paliers, remise) {
  const r = Number(remise) || 0;
  const p = (paliers || []).find((x) => x.sous === null || x.sous === "" || r < Number(x.sous));
  return p ? Number(p.taux) || 0 : 0;
}
function periodeDe(dateISO, type) {
  const ym = String(dateISO || "").slice(0, 7);
  if (type !== "trimestre") return ym;
  return `${ym.slice(0, 4)}-T${Math.ceil(Number(ym.slice(5, 7)) / 3)}`;
}
function bornesPeriode(per) {
  if (/-T\d$/.test(per)) { const y = per.slice(0, 4), t = Number(per.slice(-1)); const m1 = String((t - 1) * 3 + 1).padStart(2, "0"); const m3 = (t - 1) * 3 + 3; const fin = new Date(Date.UTC(Number(y), m3, 0)).toISOString().slice(0, 10); return [`${y}-${m1}-01`, fin]; }
  const [y, m] = per.split("-").map(Number);
  return [`${per}-01`, new Date(Date.UTC(y, m, 0)).toISOString().slice(0, 10)];
}
function libPeriode(per) {
  if (/-T\d$/.test(per)) return `${per.slice(-1)}e trimestre ${per.slice(0, 4)}`.replace(/^1e/, "1er");
  const [y, m] = per.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, 15)).toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
}
const ARRIVAGES_IMPORT_KEY = "erp:arrivages-import";
const ARRIVAGES_LOCAUX_KEY = "erp:arrivages-locaux";
// Nils 14/10 (k) : filtres de l'onglet Tranche du catalogue (champ de l'article, libellé).
const FILTRES_TRANCHE_CATALOGUE = [["matiere", "Matière"], ["epaisseurMatiere", "Épaisseur"], ["dimension", "Dimension"], ["finition", "Finition"], ["groupeCouleur", "Groupe de couleur"], ["choix", "Choix"], ["fournisseur", "Fournisseur"]];
// Nils 08/10 : registre « Transport international » (une ligne par conteneur importé).
// Les encadrés Conteneur 20 / 40 du Calcul de revient prennent la moyenne des 12 derniers
// mois par taille + pays + incoterm ; tant qu'il n'y a aucune ligne, valeur de départ saisie par Nils.
const TRANSPORT_INTL_KEY = "erp:transport-international";
const TRANSPORT_INTL_VIDE = { lignes: [], ignores: [] };
const INCOTERMS = ["EXW", "FCA", "FAS", "FOB", "CFR", "CIF", "CPT", "CIP", "DAP", "DPU", "DDP"];
const SOUS_POSTE_TRANSITAIRE = "Transitaire";
const DEBUT_REGISTRE_TRANSPORT = "2026-10-09"; // paiements transitaire suivis à partir de cette date
const PROVENANCES = ["Importé", "Local"];
const CATEGORIES_AVEC_PROVENANCE = ["Tranche", "Éviers", "Accessoires"];
const DEVISES_IMPORT = ["EUR", "USD", "MAD"];
function nouveauProfilTranches(id, nom, matiere) {
  const eps = EPAISSEURS_PAR_MATIERE[matiere] || EPAISSEURS_MATIERE;
  const baseM2 = { "6mm": 24, "12mm": 30, "20mm": 42 };
  return {
    id, type: "tranches", nom, fournisseur: "", matiere, devise: "EUR", taux: 10.85,
    groupes: [1, 2, 3, 4, 5].map((g) => ({ nom: `Groupe ${g}`, groupeERP: g })),
    // prix[indexGroupe][épaisseur][1|2] : prix d'achat au m² dans la devise du profil.
    prix: [0, 1, 2, 3, 4].map((i) => Object.fromEntries(eps.map((ep) => [ep, { 1: Math.round((baseM2[ep] || 30) * (1 + 0.17 * i)), 2: Math.round((baseM2[ep] || 30) * (1 + 0.17 * i) * 0.84) }]))),
    surfaces: Object.fromEntries(eps.map((ep) => [ep, ep === "6mm" ? 5.12 : 5.25])),
    tranchesParChevalet: Object.fromEntries(eps.map((ep) => [ep, ep === "6mm" ? 42 : ep === "12mm" ? 22 : 12])),
    coutChevalet: 295,
    logistique: { 20: { chevalets: 3, transport: 34720, dedouanement: 18500, dechargement: 1200 }, 40: { chevalets: 7, transport: 52000, dedouanement: 27000, dechargement: 1800 } },
    conteneur: 20,
    marges: {}, margeDefaut1: 30, margeDefaut2: 35, remiseRef: 35,
    simu: { remise: 10, commVendeur: 3, commApporteur: 2 },
  };
}
const DEFAULT_COUTS_REVIENT = {
  profils: [{
    ...nouveauProfilTranches("profil-ceramique", "Grès Cérame — import", "Grès Cérame"),
    // Valeurs d'exemple reprises de l'artefact « Calcul de tarification » (Nils 05/10 : c8).
    prix: [
      { "6mm": { 1: 24, 2: 20 }, "12mm": { 1: 30, 2: 25 }, "20mm": { 1: 42, 2: 36 } },
      { "6mm": { 1: 28, 2: 23 }, "12mm": { 1: 35, 2: 29 }, "20mm": { 1: 48, 2: 41 } },
      { "6mm": { 1: 33, 2: 27 }, "12mm": { 1: 41, 2: 34 }, "20mm": { 1: 56, 2: 47 } },
      { "6mm": { 1: 39, 2: 32 }, "12mm": { 1: 49, 2: 41 }, "20mm": { 1: 66, 2: 56 } },
      { "6mm": { 1: 46, 2: 38 }, "12mm": { 1: 58, 2: 49 }, "20mm": { 1: 78, 2: 66 } },
    ],
  }],
};
function nombreOuZero(v) {
  const n = Number(String(v ?? "").replace(/\s/g, "").replace(",", "."));
  return isFinite(n) ? n : 0;
}
function versMAD(montant, devise, taux) {
  return devise === "MAD" ? nombreOuZero(montant) : nombreOuZero(montant) * nombreOuZero(taux);
}
function choixNum(choix) {
  return String(choix || "").startsWith("2") ? 2 : 1;
}
// Coût standard d'UNE tranche (MAD HT) pour une typologie d'un profil d'import.
// Même méthode que l'artefact : (achat/m² × surface standard) + emballage
// (chevalet ÷ tranches par chevalet) + logistique (conteneur ÷ tranches du conteneur).
function coutStandardTrancheProfil(profil, gIdx, ep, ch) {
  if (!profil || profil.type !== "tranches") return null;
  const surface = nombreOuZero((profil.surfaces || {})[ep]);
  const prixM2 = nombreOuZero((((profil.prix || [])[gIdx] || {})[ep] || {})[ch]);
  if (!(surface > 0) || !(prixM2 > 0)) return null;
  const parChev = nombreOuZero((profil.tranchesParChevalet || {})[ep]);
  const achat = versMAD(prixM2 * surface, profil.devise, profil.taux);
  const emballage = parChev > 0 ? versMAD(profil.coutChevalet, profil.devise, profil.taux) / parChev : 0;
  const lg = (profil.logistique || {})[profil.conteneur === 40 ? 40 : 20] || {};
  const totalLog = nombreOuZero(lg.transport) + nombreOuZero(lg.dedouanement) + nombreOuZero(lg.transportLocal) + nombreOuZero(lg.dechargement);
  const tranchesConteneur = nombreOuZero(lg.chevalets) * parChev;
  const logistique = tranchesConteneur > 0 ? totalLog / tranchesConteneur : 0;
  const total = achat + emballage + logistique;
  return { surface, prixM2, achat, achatDevise: prixM2 * surface, emballage, logistique, total, totalM2: total / surface };
}
// Prix de vente d'une typologie (même formule que l'artefact) — tout en HT.
function prixVenteProfil(profil, coutTranche, margePct) {
  const surface = coutTranche.surface;
  const m = Math.min(Math.max(nombreOuZero(margePct), 0), 99) / 100;
  const rr = Math.min(Math.max(nombreOuZero(profil.remiseRef), 0), 99) / 100;
  const rem = Math.min(Math.max(nombreOuZero((profil.simu || {}).remise), 0), 99) / 100;
  const publicTranche = coutTranche.total / (1 - m) / (1 - rr);
  const remiseTranche = publicTranche * (1 - rem);
  const commV = remiseTranche * nombreOuZero((profil.simu || {}).commVendeur) / 100;
  const commA = remiseTranche * nombreOuZero((profil.simu || {}).commApporteur) / 100;
  const margeBrute = remiseTranche - coutTranche.total - commV - commA;
  return { publicM2: publicTranche / surface, publicTranche, remiseM2: remiseTranche / surface, remiseTranche, commV, commA, margeBrute, margeBrutePct: remiseTranche > 0 ? (margeBrute / remiseTranche) * 100 : 0 };
}
function margeProfil(profil, gIdx, ep, ch) {
  const k = `${gIdx}|${ep}|${ch}`;
  const v = (profil.marges || {})[k];
  return v === undefined || v === "" ? (ch === 2 ? profil.margeDefaut2 : profil.margeDefaut1) : v;
}
// Surface d'une tranche à partir des dimensions du lot (« 320 × 160 cm »), sinon null.
function surfaceDimensions(dim) {
  const m = String(dim || "").replace(",", ".").match(/(\d+(?:\.\d+)?)\s*[x×*]\s*(\d+(?:\.\d+)?)/i);
  if (!m) return null;
  const a = Number(m[1]), b = Number(m[2]);
  if (!(a > 0 && b > 0)) return null;
  const cm = a > 20 || b > 20; // en cm (sinon en m)
  return cm ? (a * b) / 10000 : a * b;
}
// Nils 03/10 (r2) : un trop-perçu client reste en crédit, affecté plus tard à une autre facture.
const AFFECTATIONS_CREDIT_KEY = "erp:affectations-credit";
// Nils 03/10 : prévisions de trésorerie saisies à la main (investissements, douane d'un arrivage…).
const PREVISIONS_KEY = "erp:previsions-tresorerie";
// Nils 04/10 (x) : échéances récurrentes du prévisionnel (IS trimestriel, taxe professionnelle, leasings…).
const RECURRENTES_KEY = "erp:echeances-recurrentes";
// Nils 04/10 (z) : tâches manuelles créées par Nils.
const TACHES_MANUELLES_KEY = "erp:taches-manuelles";
// Nils 04/10 (aa) : bugs signalés par l'équipe.
const BUGS_KEY = "erp:bugs";
// Nils 04/10 (ad) : marketing — time sheet (lignes de l'externe marketing), réglages dans parametres.marketing
// ({ taux: { [userId]: [{ dateEffet, taux }] }, moisValides: { [userId]: { [ym]: { heures, montant, le, par } } }, booster: [...] }).
const MKT_TIMESHEET_KEY = "erp:marketing-timesheet";
const TYPES_ACTIVITE_MKT = ["Publication réseaux", "Shooting photo", "Visite chantier / réalisation", "Salon / événement", "Rédaction / création", "Réunion", "Autre"];
const JOURS_VERROU_TIMESHEET = 7;
const JOUR_PAIEMENT_MKT = 15;
const COMPTE_PAIEMENT_MKT = "caisse-nils";
// Nils 04/10 (ad / am) : échantillons — liste de référence (checklist de la boîte Infinity), deux formats, demandes.
const ECHANTILLONS_KEY = "erp:echantillons";
const ECH_MOUVEMENTS_KEY = "erp:echantillons-mouvements";
const DEMANDES_ECH_KEY = "erp:demandes-echantillons";
const FORMATS_ECH = [{ cle: "grand", lib: "Grand" }, { cle: "petit", lib: "Petit" }];
const MOTIFS_ENTREE_ECH = ["Réception fournisseur", "Retour", "Ajustement d'inventaire"];
// ERP step 15 (am, Nils 08/10) : matériel marketing (même liste que les échantillons, type « materiel », stock à l'unité,
// tenu par Ahmed) ; boîtes revendeurs (contenu variable, checklist imprimable, contrôle → demande de complément,
// rappel au commercial) ; matériel prêté (présentoir, kakémono…) suivi jusqu'à sa récupération.
const ECH_SUIVI_KEY = "erp:echantillons-suivi";
// ERP step 15 (ar, Nils 08/10) : planning par dossier — RDM (demi-journée), débit (date, débiteuse(s), heures),
// finition (date, finisseurs, heures), pose (demi-journée, poseurs). Géré par Ahmed et Nils, visible par tous.
const PLANNING_KEY = "erp:planning";
// ERP step 15 (ao, Nils 08/10) : barre de gauche en rubriques (même ordre pour tous ; rubrique vide masquée).
const RUBRIQUES_NAV = [
  ["", ["alertes"]],
  ["Ventes", ["clients", "devis", "projets", "commandes", "catalogue", "rapportCommercial", "marketing"]],
  ["Production", ["planning", "stock"]],
  ["Achats", ["fournisseurs", "facturesF", "transportIntl"]],
  ["Moyens", ["flotte", "outillage"]],
  ["", ["staff"]],
  ["", ["compta"]],
  ["Gestion", ["grilleTarifaire", "commissions", "statistiques", "parametrage"]],
];
const TYPES_PLAN = { rdm: { lib: "RDM", coul: "#E4EBE4" }, debit: { lib: "Débit", coul: "#E8E3DF" }, finition: { lib: "Finition", coul: "#F3ECDD" }, pose: { lib: "Pose", coul: "#DCE6F2" } };
const DEMIS_PLAN = [["matin", "Matin"], ["apresmidi", "Après-midi"], ["journee", "Journée"]];
const PLANNING_VIDE = { items: [], notifs: [], prodTerminee: {}, engagements: {}, alertesEnvoyees: {}, sansFinition: {} };
const FORMAT_MAT = { cle: "unite", lib: "Unité" };
function estMatEch(e) {
  return !!e && e.type === "materiel";
}
function formatsRefEch(e) {
  return estMatEch(e) ? [FORMAT_MAT] : FORMATS_ECH;
}
const ECHANTILLONS_DEPART = [{"id":"ech-001","gamme":"Infinity","couleur":"Absolute Black","finition":"Satinato","lancement":"","epaisseurs":"12 mm","horsProduction":false,"ordre":1},{"id":"ech-002","gamme":"Infinity","couleur":"Absolute White","finition":"Lucido","lancement":"","epaisseurs":"12 mm","horsProduction":false,"ordre":2},{"id":"ech-003","gamme":"Infinity","couleur":"Absolute White","finition":"Matte","lancement":"","epaisseurs":"6 mm","horsProduction":false,"ordre":3},{"id":"ech-004","gamme":"Infinity","couleur":"Absolute White","finition":"Satinato","lancement":"","epaisseurs":"12, 20 mm","horsProduction":false,"ordre":4},{"id":"ech-005","gamme":"Infinity","couleur":"Andromeda","finition":"Lucido","lancement":"2024","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":5},{"id":"ech-006","gamme":"Infinity","couleur":"Andromeda","finition":"Patinato","lancement":"2024","epaisseurs":"12 mm","horsProduction":false,"ordre":6},{"id":"ech-007","gamme":"Infinity","couleur":"Antibes","finition":"Satinato","lancement":"2025","epaisseurs":"12 mm","horsProduction":false,"ordre":7},{"id":"ech-008","gamme":"Infinity","couleur":"Arabescato Diva","finition":"Lucido","lancement":"2025","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":8},{"id":"ech-009","gamme":"Infinity","couleur":"Atlantis Grey","finition":"Matte","lancement":"2021","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":9},{"id":"ech-010","gamme":"Infinity","couleur":"Bercy","finition":"Satinato","lancement":"2025","epaisseurs":"12 mm","horsProduction":false,"ordre":10},{"id":"ech-011","gamme":"Infinity","couleur":"Buxi Select","finition":"Matte","lancement":"","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":11},{"id":"ech-012","gamme":"Infinity","couleur":"Calacatta Brazile","finition":"Satinato","lancement":"2024","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":12},{"id":"ech-013","gamme":"Infinity","couleur":"Calacatta Glory / Lincoln","finition":"Lucido","lancement":"","epaisseurs":"12 mm","horsProduction":false,"ordre":13},{"id":"ech-014","gamme":"Infinity","couleur":"Calacatta Hermitage","finition":"Lucido","lancement":"2021","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":14},{"id":"ech-015","gamme":"Infinity","couleur":"Calacatta Hermitage","finition":"Satinato","lancement":"2021","epaisseurs":"12, 20 mm","horsProduction":false,"ordre":15},{"id":"ech-016","gamme":"Infinity","couleur":"Calacatta Magnifico","finition":"Lucido","lancement":"2020","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":16},{"id":"ech-017","gamme":"Infinity","couleur":"Calacatta Magnifico","finition":"Satinato","lancement":"2020","epaisseurs":"12, 20 mm","horsProduction":false,"ordre":17},{"id":"ech-018","gamme":"Infinity","couleur":"Calacatta Oro","finition":"Lucido","lancement":"","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":18},{"id":"ech-019","gamme":"Infinity","couleur":"Calacatta Oro","finition":"Satinato","lancement":"","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":19},{"id":"ech-020","gamme":"Infinity","couleur":"Calacatta Viola","finition":"Lucido","lancement":"2022","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":20},{"id":"ech-021","gamme":"Infinity","couleur":"Cammeo Glam","finition":"Glam","lancement":"2024","epaisseurs":"6 mm","horsProduction":false,"ordre":21},{"id":"ech-022","gamme":"Infinity","couleur":"Ceppo Romano","finition":"Matte","lancement":"2023","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":22},{"id":"ech-023","gamme":"Infinity","couleur":"Chianca di Ostuni","finition":"Matte","lancement":"2022","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":23},{"id":"ech-024","gamme":"Infinity","couleur":"Classic Statuario","finition":"Lucido","lancement":"","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":24},{"id":"ech-025","gamme":"Infinity","couleur":"Classic Statuario","finition":"Satinato","lancement":"","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":25},{"id":"ech-026","gamme":"Infinity","couleur":"Concrete Grey","finition":"Matte","lancement":"","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":26},{"id":"ech-027","gamme":"Infinity","couleur":"Concrete Light","finition":"Matte","lancement":"","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":27},{"id":"ech-028","gamme":"Infinity","couleur":"Cristal Ice","finition":"Lucido","lancement":"2023","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":28},{"id":"ech-029","gamme":"Infinity","couleur":"Crystal Clear","finition":"Lucido","lancement":"2025","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":29},{"id":"ech-030","gamme":"Infinity","couleur":"Défense","finition":"Satinato","lancement":"2024","epaisseurs":"12 mm","horsProduction":false,"ordre":30},{"id":"ech-031","gamme":"Infinity","couleur":"Extra Statuario","finition":"Lucido","lancement":"","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":31},{"id":"ech-032","gamme":"Infinity","couleur":"Extra Statuario","finition":"Satinato","lancement":"","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":32},{"id":"ech-033","gamme":"Infinity","couleur":"Fossil","finition":"Matte","lancement":"2023","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":33},{"id":"ech-034","gamme":"Infinity","couleur":"Fossil Row","finition":"Matte","lancement":"2023","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":34},{"id":"ech-035","gamme":"Infinity","couleur":"Fossil Tartan","finition":"Matte","lancement":"2023","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":35},{"id":"ech-036","gamme":"Infinity","couleur":"Fragmentis Burn","finition":"Matte","lancement":"2026","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":36},{"id":"ech-037","gamme":"Infinity","couleur":"Fragmentis Row","finition":"Matte","lancement":"2026","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":37},{"id":"ech-038","gamme":"Infinity","couleur":"Ginza Doro","finition":"3D","lancement":"2024","epaisseurs":"6 mm","horsProduction":false,"ordre":38},{"id":"ech-039","gamme":"Infinity","couleur":"Ginza Midori","finition":"3D","lancement":"2024","epaisseurs":"6 mm","horsProduction":false,"ordre":39},{"id":"ech-040","gamme":"Infinity","couleur":"Ginza Sorairo","finition":"3D","lancement":"2024","epaisseurs":"6 mm","horsProduction":false,"ordre":40},{"id":"ech-041","gamme":"Infinity","couleur":"Gordes","finition":"Satinato","lancement":"2025","epaisseurs":"12 mm","horsProduction":false,"ordre":41},{"id":"ech-042","gamme":"Infinity","couleur":"Holos Aegean Blue","finition":"3D","lancement":"2023","epaisseurs":"6 mm","horsProduction":false,"ordre":42},{"id":"ech-043","gamme":"Infinity","couleur":"Holos Andaman Emerald","finition":"3D","lancement":"2023","epaisseurs":"6 mm","horsProduction":false,"ordre":43},{"id":"ech-044","gamme":"Infinity","couleur":"Holos Hyams White","finition":"3D","lancement":"2023","epaisseurs":"6 mm","horsProduction":false,"ordre":44},{"id":"ech-045","gamme":"Infinity","couleur":"Holos Vik Black","finition":"3D","lancement":"2024","epaisseurs":"6 mm","horsProduction":false,"ordre":45},{"id":"ech-046","gamme":"Infinity","couleur":"Iconic Cipollino","finition":"Lucido","lancement":"2023","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":46},{"id":"ech-047","gamme":"Infinity","couleur":"Magellano","finition":"Lucido","lancement":"2021","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":47},{"id":"ech-048","gamme":"Infinity","couleur":"Metal Corten","finition":"Matte","lancement":"","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":48},{"id":"ech-049","gamme":"Infinity","couleur":"Metal Dark","finition":"Matte","lancement":"","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":49},{"id":"ech-050","gamme":"Infinity","couleur":"Milan Stone","finition":"Matte","lancement":"","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":50},{"id":"ech-051","gamme":"Infinity","couleur":"Nero Marquina","finition":"Lucido","lancement":"","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":51},{"id":"ech-052","gamme":"Infinity","couleur":"Nero Marquina","finition":"Satinato","lancement":"","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":52},{"id":"ech-053","gamme":"Infinity","couleur":"Ocean Blue","finition":"Lucido","lancement":"2020","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":53},{"id":"ech-054","gamme":"Infinity","couleur":"Onyx White","finition":"Lucido","lancement":"2023","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":54},{"id":"ech-055","gamme":"Infinity","couleur":"Orobico Lux","finition":"Lucido","lancement":"2021","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":55},{"id":"ech-056","gamme":"Infinity","couleur":"Palladium Ivory","finition":"Matte","lancement":"2023","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":56},{"id":"ech-057","gamme":"Infinity","couleur":"Panda White","finition":"Lucido","lancement":"2023","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":57},{"id":"ech-058","gamme":"Infinity","couleur":"Pietra Grey","finition":"Satinato","lancement":"","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":58},{"id":"ech-059","gamme":"Infinity","couleur":"Pigalle","finition":"Patinato","lancement":"2022","epaisseurs":"12, 20 mm","horsProduction":false,"ordre":59},{"id":"ech-060","gamme":"Infinity","couleur":"Plaster Ash","finition":"Matte","lancement":"2025","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":60},{"id":"ech-061","gamme":"Infinity","couleur":"Plaster Bone","finition":"Matte","lancement":"2025","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":61},{"id":"ech-062","gamme":"Infinity","couleur":"Plaster Ground","finition":"Matte","lancement":"2026","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":62},{"id":"ech-063","gamme":"Infinity","couleur":"Plaster Sand","finition":"Matte","lancement":"2026","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":63},{"id":"ech-064","gamme":"Infinity","couleur":"Plaster Snow","finition":"Matte","lancement":"2025","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":64},{"id":"ech-065","gamme":"Infinity","couleur":"Plaster Warm","finition":"Matte","lancement":"2025","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":65},{"id":"ech-066","gamme":"Infinity","couleur":"Precious Sodalite","finition":"Lucido","lancement":"","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":66},{"id":"ech-067","gamme":"Infinity","couleur":"Provençale","finition":"Matte","lancement":"2024","epaisseurs":"12 mm","horsProduction":false,"ordre":67},{"id":"ech-068","gamme":"Infinity","couleur":"Pulpis Brown","finition":"Lucido","lancement":"","epaisseurs":"12 mm","horsProduction":false,"ordre":68},{"id":"ech-069","gamme":"Infinity","couleur":"Pulpis Brown","finition":"Satinato","lancement":"","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":69},{"id":"ech-070","gamme":"Infinity","couleur":"Renoir","finition":"Lucido","lancement":"","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":70},{"id":"ech-071","gamme":"Infinity","couleur":"Rosso Domus","finition":"Lucido","lancement":"2024","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":71},{"id":"ech-072","gamme":"Infinity","couleur":"Royal","finition":"Satinato","lancement":"2023","epaisseurs":"12 mm","horsProduction":false,"ordre":72},{"id":"ech-073","gamme":"Infinity","couleur":"Royal Peacock","finition":"Lucido","lancement":"2021","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":73},{"id":"ech-074","gamme":"Infinity","couleur":"Sahara Noir","finition":"Lucido","lancement":"","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":74},{"id":"ech-075","gamme":"Infinity","couleur":"Sahara Noir","finition":"Satinato","lancement":"","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":75},{"id":"ech-076","gamme":"Infinity","couleur":"Sandstone Dune","finition":"Matte","lancement":"2026","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":76},{"id":"ech-077","gamme":"Infinity","couleur":"Sandstone Gray","finition":"Matte","lancement":"2024","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":77},{"id":"ech-078","gamme":"Infinity","couleur":"Sandstone Light","finition":"Matte","lancement":"2024","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":78},{"id":"ech-079","gamme":"Infinity","couleur":"Sandstone Silver","finition":"Matte","lancement":"2026","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":79},{"id":"ech-080","gamme":"Infinity","couleur":"Sandstone Warm","finition":"Matte","lancement":"2024","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":80},{"id":"ech-081","gamme":"Infinity","couleur":"Santos Glam","finition":"Glam","lancement":"2023","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":81},{"id":"ech-082","gamme":"Infinity","couleur":"Skov","finition":"Matte","lancement":"2023","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":82},{"id":"ech-083","gamme":"Infinity","couleur":"Statuario Principe","finition":"Lucido","lancement":"2022","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":83},{"id":"ech-084","gamme":"Infinity","couleur":"Statuario Principe","finition":"Satinato","lancement":"2022","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":84},{"id":"ech-085","gamme":"Infinity","couleur":"Taj Mahal","finition":"Lucido","lancement":"2024","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":85},{"id":"ech-086","gamme":"Infinity","couleur":"Taj Mahal","finition":"Satinato","lancement":"2024","epaisseurs":"12, 20 mm","horsProduction":false,"ordre":86},{"id":"ech-087","gamme":"Infinity","couleur":"Terrazzo White","finition":"Matte","lancement":"","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":87},{"id":"ech-088","gamme":"Infinity","couleur":"Thunderstorm","finition":"Lucido","lancement":"2022","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":88},{"id":"ech-089","gamme":"Infinity","couleur":"Total Black","finition":"Satinato","lancement":"","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":89},{"id":"ech-090","gamme":"Infinity","couleur":"Total Grey","finition":"Satinato","lancement":"","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":90},{"id":"ech-091","gamme":"Infinity","couleur":"Total White","finition":"Satinato","lancement":"","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":91},{"id":"ech-092","gamme":"Infinity","couleur":"Travertino Bianco","finition":"Matte","lancement":"2024","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":92},{"id":"ech-093","gamme":"Infinity","couleur":"Travertino Chiaro","finition":"Matte","lancement":"2022","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":93},{"id":"ech-094","gamme":"Infinity","couleur":"Travertino Grey","finition":"Matte","lancement":"","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":94},{"id":"ech-095","gamme":"Infinity","couleur":"Travertino Trilogy","finition":"Matte","lancement":"2025","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":95},{"id":"ech-096","gamme":"Infinity","couleur":"Tundra Select","finition":"Lucido","lancement":"","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":96},{"id":"ech-097","gamme":"Infinity","couleur":"Verde France","finition":"Lucido","lancement":"2020","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":97},{"id":"ech-098","gamme":"Infinity","couleur":"White Macaubas","finition":"Lucido","lancement":"2024","epaisseurs":"6, 12 mm","horsProduction":false,"ordre":98},{"id":"ech-099","gamme":"Infinity","couleur":"White Macaubas","finition":"Satinato","lancement":"2024","epaisseurs":"6, 12, 20 mm","horsProduction":false,"ordre":99},{"id":"ech-hp01","gamme":"Infinity","couleur":"Calacatta Arabescato","finition":"Lucido","lancement":"","epaisseurs":"","horsProduction":true,"ordre":100},{"id":"ech-hp02","gamme":"Infinity","couleur":"Concrete Black","finition":"Matte","lancement":"","epaisseurs":"","horsProduction":true,"ordre":101},{"id":"ech-hp03","gamme":"Infinity","couleur":"Cristal Amber","finition":"Lucido","lancement":"","epaisseurs":"","horsProduction":true,"ordre":102},{"id":"ech-hp04","gamme":"Infinity","couleur":"Kind of Blue","finition":"Lucido","lancement":"","epaisseurs":"","horsProduction":true,"ordre":103},{"id":"ech-hp05","gamme":"Infinity","couleur":"Marfil Select","finition":"Lucido","lancement":"","epaisseurs":"","horsProduction":true,"ordre":104},{"id":"ech-hp06","gamme":"Infinity","couleur":"Metal Silver","finition":"Matte","lancement":"","epaisseurs":"","horsProduction":true,"ordre":105},{"id":"ech-hp07","gamme":"Infinity","couleur":"Nero Granit","finition":"Bocciardato","lancement":"","epaisseurs":"","horsProduction":true,"ordre":106},{"id":"ech-hp08","gamme":"Infinity","couleur":"Pierre Bleue","finition":"Matte","lancement":"","epaisseurs":"","horsProduction":true,"ordre":107},{"id":"ech-hp09","gamme":"Infinity","couleur":"Terazzo Beige","finition":"Matte","lancement":"","epaisseurs":"","horsProduction":true,"ordre":108},{"id":"ech-hp10","gamme":"Infinity","couleur":"Terazzo Black","finition":"Matte","lancement":"","epaisseurs":"","horsProduction":true,"ordre":109},{"id":"ech-hp11","gamme":"Infinity","couleur":"Terrazo Grey","finition":"Matte","lancement":"","epaisseurs":"","horsProduction":true,"ordre":110}];
const GRAVITES_BUG = ["Bloquant", "Gênant", "Suggestion"];
const STATUTS_BUG = ["nouveau", "en cours", "corrigé", "rejeté"];
// ERP step 13 (Nils 04/10, ac) : liste des alertes et des tâches automatiques, et qui les reçoit.
// Alertes : toujours vers ceux qui voient les alertes (droit « taches.voirTout », Nils).
// Destinataires des tâches : "p:<profil>" ou jeton spécial (@commercial, @responsablesCompte, @detenteur, @pilote, @chefs, @choisis, @declarant, @document).
const CATALOGUE_NOTIFS = [
  // ---- Alertes ----
  ["Alerte", "Ventes", "Suppression de devis", "Un devis est supprimé"],
  ["Alerte", "Ventes", "Remise au-delà de la fiche client", "Remise saisie supérieure à la remise de la fiche client"],
  ["Alerte", "Ventes", "Livraison sans pose ni transformation", "Devis transformé en BDC avec de la logistique mais sans pose ni transformation"],
  ["Alerte", "Ventes", "Commande exonérée", "Dossier passé en exonération de TVA"],
  ["Alerte", "Ventes", "Mauvais payeur en PL", "Passage en PL d'un client signalé mauvais payeur"],
  ["Alerte", "Ventes", "Passage forcé malgré le paiement", "Étape franchie sans le paiement attendu"],
  ["Alerte", "Ventes", "Suppression de dossier", "Un dossier (BDC → facture) est supprimé"],
  ["Alerte", "Ventes", "Rapport commercial non soumis", "Rapport commercial de la semaine non soumis à temps"],
  ["Alerte", "Ventes", "Remontées terrain", "Remontée terrain saisie dans un rapport commercial"],
  ["Alerte", "SAV", "SAV ouvert", "Un ticket SAV est ouvert"],
  ["Alerte", "SAV", "SAV en retard", "Ticket SAV sans intervention au-delà du délai (une fois par ticket)"],
  ["Alerte", "Production", "PL annulé", "Annulation d'un PL"],
  ["Alerte", "Production", "Consommables de PL annulés", "Consommables d'un PL annulé remis en stock ou sortis"],
  ["Alerte", "Production", "Book-match non respecté au PL", "Tranches A / B ne respectant pas le book-match demandé"],
  ["Alerte", "Production", "Chute vendue non respectée au PL", "Chute vendue au devis, sortie sur autre chose qu'un lot « chute » du même produit"],
  ["Alerte", "Production", "Chute non valorisée", "Chute déclarée au PL dont le lot d'origine n'a pas de prix (calcul du serveur)"],
  ["Alerte", "Production", "Incident de production", "Erreur ou casse avant livraison déclarée sur un PL (motif, tranches sorties en plus)"],
  ["Alerte", "Production", "Sortie supérieure au facturé", "PL confirmé avec plus de matière sortie que facturé (au-delà du facturé arrondi à la tranche supérieure)"],
  ["Alerte", "Production", "Aucun consommable", "« Aucun consommable » déclaré sur un PL ou une pose"],
  ["Alerte", "Production", "Consommable atelier hors dossier", "Sortie de consommable non rattachée à un dossier"],
  ["Alerte", "Production", "Consommable lent / Usure anormale", "Durée de vie d'un consommable hors de la normale"],
  ["Alerte", "Stock", "Ajustement / mouvement d'inventaire", "Écart d'inventaire ou mouvement manuel de stock"],
  ["Alerte", "Stock", "Suppression / modification de lot", "Lot supprimé, modifié ou fournisseur du lot changé"],
  ["Alerte", "Stock", "Arrivage supprimé / réception différente", "Arrivage supprimé ou réception différente de l'arrivage"],
  ["Alerte", "Stock", "Prix d'achat au-dessus du target", "Lot enregistré à un prix d'achat supérieur au target"],
  ["Alerte", "Outillage", "Outil remis / incident / sorti du parc", "Remise d'un outil, perte, casse, sortie du parc"],
  ["Alerte", "Outillage", "Contrôle outillage / inventaire bureautique : manquants", "Objets manquants à la clôture du contrôle"],
  ["Alerte", "Outillage", "Demande de catégorie d'outil", "Une nouvelle catégorie d'outil est demandée"],
  ["Alerte", "Trésorerie", "Solde négatif / opération supprimée / à classer", "Compte en négatif, opération supprimée ou « À définir »"],
  ["Alerte", "Trésorerie", "Caisse générale sous 5 000 DH", "Solde de la caisse générale sous le seuil"],
  ["Alerte", "Trésorerie", "Clôture de caisse : écart / clôture en retard", "Écart au comptage ou clôture mensuelle non faite"],
  ["Alerte", "Trésorerie", "Transfert refusé / écart à la réception", "Transfert entre comptes refusé ou reçu avec un écart"],
  ["Alerte", "Trésorerie", "Paiement rejeté", "Chèque ou effet rejeté"],
  ["Alerte", "Trésorerie", "Chèque bientôt périmé", "Chèque proche de sa date de validité (1 an)"],
  ["Alerte", "Trésorerie", "Rapprochement bancaire : écarts", "Écart de montant ou opération pas passée sur le relevé"],
  ["Alerte", "Trésorerie", "Échéance récurrente (J-7 / dépassée)", "Échéance récurrente dans 7 jours ou dépassée"],
  ["Alerte", "Ventes", "Facture de retenue de garantie (J-10 / délai légal dépassé)", "Facture de retenue non réglée 10 jours avant les 60 jours de la loi 69-21, puis dépassée"],
  ["Alerte", "Fournisseurs", "Facture fournisseur non payée à l'échéance", "Échéance d'une facture fournisseur dépassée"],
  ["Alerte", "Fournisseurs", "Limite légale proche / dépassée", "Délai légal de paiement proche ou dépassé"],
  ["Alerte", "Fournisseurs", "Conditions de paiement au-delà de la loi", "Conditions saisies au-delà du délai légal"],
  ["Alerte", "Staff", "Pointage : absence / maladie / HS / férié travaillé", "Saisie au pointage par quelqu'un d'autre que le Gérant"],
  ["Alerte", "Staff", "Pointage à valider", "Pointage du mois transmis"],
  ["Alerte", "Staff", "Prime de productivité", "Target de la semaine atteint ou non"],
  ["Alerte", "Staff", "Évaluation à valider / signalement", "Évaluation faite ou signalement sur une personne"],
  ["Alerte", "Staff", "Staff : reprise automatique", "Reprise automatique de données du staff"],
  ["Alerte", "Staff", "Salaires bruts non vérifiés", "Contrôle semestriel non fait 30 jours après le début du semestre"],
  ["Alerte", "Équipe", "Tâche en retard / tâche faite", "Tâche manuelle en retard ou marquée faite"],
  ["Alerte", "Équipe", "Bug signalé", "Quelqu'un signale un bug"],
  ["Alerte", "Marketing", "Prospect", "Un prospect est saisi par quelqu'un d'autre que le Gérant (marketing ou ADV)"],
  ["Alerte", "Marketing", "Ajustement / inventaire d'échantillons", "Ajustement ou écarts d'inventaire du stock d'échantillons"],
  ["Alerte", "Équipe", "Droits ajoutés aux profils", "Mise à jour unique des profils personnalisés"],
  // Step 17 (audit, Nils 15/10) : alertes émises qui manquaient au catalogue.
  ["Alerte", "Stock", "Arrivage modifié", "Un arrivage est modifié par quelqu'un d'autre que le Gérant"],
  ["Alerte", "Stock", "Réception book-match différente de l'arrivage", "Répartition A / B reçue différente de l'arrivage"],
  ["Alerte", "Production", "Consommation atelier annulée", "Une consommation atelier (hors PL) est annulée"],
  ["Alerte", "Production", "Réservation dépassée", "Matière réservée dont la date de livraison prévue est dépassée"],
  ["Alerte", "Véhicules", "Coût au km : écart avec la prévision", "Coût réel au km éloigné des paramètres du véhicule"],
  ["Alerte", "Fournisseurs", "Fournisseur blacklisté", "Opération ou facture enregistrée avec un fournisseur blacklisté"],
  ["Alerte", "Trésorerie", "Montant corrigé au pointage du relevé", "Montant d'une opération corrigé en la pointant sur le relevé bancaire"],
  ["Alerte", "Staff", "Congé spécial", "Congé spécial (paternité, maternité…) saisi sur une fiche Staff"],
  ["Alerte", "Ventes", "Avoir sur un dossier déjà commissionné", "Facture d'avoir sur un dossier dont une commission est déjà validée"],
  // ---- Tâches ----
  ["Tâche", "Ventes", "Devis en brouillon à finaliser", "Devis resté en brouillon", ["p:" + P_ADV_SR, "p:" + P_ADV_JR]],
  ["Tâche", "Ventes", "Devis prêt — à envoyer au client", "Devis au statut « Prêt pour envoi »", ["@commercial", "p:" + P_ADV_SR, "p:" + P_ADV_JR]],
  ["Tâche", "Ventes", "Relancer le client", "Devis envoyé sans réponse", ["@commercial"]],
  ["Tâche", "Ventes", "Devis confirmé — transformer en BDC", "Devis confirmé par le client", ["p:" + P_ADV_SR, "p:" + P_ADV_JR]],
  ["Tâche", "Ventes", "Réservation dépassée", "Date de pose de la réservation dépassée", ["@commercial", "p:" + P_GERANT]],
  ["Tâche", "Ventes", "Budget de projet immo dépassé", "Tranches sorties d'une phase au-delà du budget, ou plus de livraisons que prévu", ["p:" + P_GERANT]],
  ["Tâche", "Ventes", "Natures d'articles à vérifier", "Cases pose / façonnage / livraison / RDM pré-cochées automatiquement (12/10)", ["p:" + P_GERANT]],
  ["Tâche", "Ventes", "Contact / téléphone sur place manquant", "Dossier sans contact sur place (bloque le BPRDM)", ["p:" + P_ADV_SR, "p:" + P_ADV_JR]],
  ["Tâche", "Ventes", "Client à valider", "Nouveau client (1re étape : Administration, 2e : Gérant)", ["p:" + P_ADMIN, "p:" + P_GERANT]],
  ["Tâche", "Ventes", "Soumettre le rapport commercial", "Chaque semaine", ["@commercial"]],
  ["Tâche", "Ventes", "Lire le rapport commercial", "Rapport soumis", ["p:" + P_GERANT]],
  ["Tâche", "Ventes", "Action commerciale prévue", "Action notée lors d'une visite", ["@commercial"]],
  ["Tâche", "Ventes", "Fixer le taux de commission d'un apporteur", "Prospect apporté par un apporteur", ["p:" + P_GERANT]],
  ["Tâche", "Ventes", "Affecter le crédit d'une facture d'avoir", "Avoir dont le crédit n'est pas entièrement affecté à une facture", ["p:" + P_ADMIN]],
  ["Tâche", "Ventes", "Fixer le taux de l'apporteur sur un devis", "Devis avec apporteur d'affaires sans taux", ["p:" + P_GERANT]],
  ["Tâche", "Planning", "RDM non fait", "Date du RDM passée sans « fait » : marquer fait ou replanifier (raison)", ["p:" + P_PROD]],
  ["Tâche", "Planning", "Retard de planning (avec « Vu »)", "RDM non fait, RDM / production / pose repoussé, production non terminée à la date prévue", ["p:" + P_PROD, "p:" + P_GERANT, "@commercial", "p:" + P_POSE]],
  ["Tâche", "Planning", "📣 Alerte du Production Manager (avec « Vu »)", "Message envoyé depuis le planning", ["@commercial", "p:" + P_GERANT]],
  ["Tâche", "Échantillons", "Contrôler une boîte revendeur", "Tous les 6 mois (réglable) après la remise ou le dernier contrôle", ["@commercial"]],
  ["Tâche", "Échantillons", "Matériel marketing à réapprovisionner", "Stock au seuil ou en dessous", ["p:" + P_PROD]],
  ["Tâche", "Déplacements", "Clôturer un déplacement", "Date de retour passée, fiche encore « en cours »", ["p:" + P_PROD]],
  ["Tâche", "Déplacements", "Solder l'avance d'un déplacement", "Retour passé, avance de la caisse usine pas encore soldée", ["@responsablesCompte"]],
  ["Tâche", "Déplacements", "Valider une fiche de déplacement", "Fiche envoyée par le Production Manager ou le bureau technique", ["p:" + P_GERANT]],
  ["Tâche", "Déplacements", "Fiche de déplacement à faire", "Pose hors Casablanca sans fiche de déplacement « Pose »", ["p:" + P_PROD]],
  ["Tâche", "Véhicules", "Relevé km et tickets de la semaine", "Chaque vendredi, par véhicule", ["@conducteurs", "p:" + P_PROD]],
  ["Tâche", "Véhicules", "Échéance véhicule à renouveler", "30 jours avant l'assurance, la vignette, la visite technique, le leasing, le GPS", ["p:" + P_ADMIN]],
  ["Alerte", "Véhicules", "Relevé km non fait", "Relevé du vendredi pas fait le lundi"],
  ["Alerte", "Véhicules", "Consommation anormale", "Consommation du mois au-dessus de la moyenne des 12 mois (+20 % réglable)"],
  ["Tâche", "Dossiers", "Demander les avoirs des tranches en exposition", "En décembre, s'il reste des lignes « À demander » au registre", ["p:" + P_GERANT]],
  ["Alerte", "Ventes", "Remise au-delà du maximum du commercial", "Devis enregistré avec une remise supérieure au maximum autorisé (Soufiane Chraa : 32 %)"],
  ["Tâche", "Dossiers", "Dossier en attente de…", "Champ « en attente de » du dossier (selon l'étape)", ["@document"]],
  ["Tâche", "Dossiers", "Document manquant", "Document requis non fourni", ["@document"]],
  ["Tâche", "Dossiers", "Article à valider", "Article non validé dans un dossier (bloque le PL)", ["p:" + P_GERANT]],
  ["Tâche", "Dossiers", "Enregistrer la matière au Stock", "PL sans matière enregistrée (bloque le BL)", ["p:" + P_PROD]],
  ["Tâche", "Dossiers", "Saisir les consommables de production / de pose", "PL ou pose sans consommables (bloque BL / facture)", ["p:" + P_BT]],
  ["Tâche", "Dossiers", "Chargement incomplet", "Éléments du dossier pas tous chargés", ["p:" + P_PROD]],
  ["Tâche", "Dossiers", "Faire signer le BL", "BL établi non signé", ["p:" + P_PROD, "@commercial"]],
  ["Tâche", "Dossiers", "Fiche de pose à remplir", "Pose sans fiche (bloque la facture)", ["p:" + P_POSE]],
  ["Tâche", "Dossiers", "BL à établir / facture à établir", "Dossier prêt", ["p:" + P_ADMIN]],
  ["Tâche", "Dossiers", "Encaisser la facture de remplacement", "Facture de remplacement non encaissée", ["p:" + P_GERANT]],
  ["Tâche", "SAV", "SAV à traiter / à clôturer", "Ticket SAV ouvert", ["@pilote"]],
  ["Tâche", "Stock", "Inventaire en cours : lots à compter", "Inventaire lancé", ["p:" + P_PROD]],
  ["Tâche", "Stock", "Inventaire à valider ou annuler", "Inventaire lancé", ["p:" + P_GERANT]],
  ["Tâche", "Stock", "Demande de sous-catégorie / sous-catégorie sans fournisseur", "Demande ou paramétrage manquant", ["p:" + P_GERANT]],
  ["Tâche", "Outillage", "Contrôle mensuel de l'outillage", "Chaque mois", ["p:" + P_PROD]],
  ["Tâche", "Outillage", "Inventaire semestriel du matériel bureautique", "Chaque semestre", ["p:" + P_ADMIN]],
  ["Tâche", "Outillage", "Catégorie d'outil demandée", "Demande en attente", ["p:" + P_GERANT]],
  ["Tâche", "Trésorerie", "Transfert à confirmer", "Transfert reçu", ["@responsablesCompte"]],
  ["Tâche", "Trésorerie", "Clôturer le mois (caisse / banque)", "Fin de mois", ["@responsablesCompte"]],
  ["Tâche", "Trésorerie", "Valider la clôture", "Clôture demandée", ["p:" + P_ADMIN, "p:" + P_GERANT]],
  ["Tâche", "Trésorerie", "Clôture en retard", "Clôture du mois non validée", ["p:" + P_GERANT]],
  ["Tâche", "Trésorerie", "Opérations pas passées sur le relevé", "Opérations anciennes non rapprochées", ["p:" + P_GERANT, "p:" + P_ADMIN]],
  ["Tâche", "Trésorerie", "Paiement rejeté", "Chèque ou effet rejeté", ["@commercial", "p:" + P_GERANT]],
  ["Tâche", "Trésorerie", "Confirmer la réception d'un chèque", "Chèque passé à un nouveau détenteur", ["@detenteur"]],
  ["Tâche", "Trésorerie", "Chèque bientôt périmé / déposer à la CFG", "Chèque proche de sa date", ["@detenteur", "p:" + P_GERANT]],
  ["Tâche", "Trésorerie", "Mouvements importés / opérations à classer", "Opérations à rapprocher ou « À définir »", ["p:" + P_GERANT]],
  ["Tâche", "Trésorerie", "Encaissements à relier à un dossier", "Encaissement sans dossier", ["@responsablesCompte", "p:" + P_GERANT]],
  ["Tâche", "Trésorerie", "Caisse générale sous le seuil", "Solde sous 5 000 DH", ["p:" + P_GERANT]],
  ["Tâche", "Fournisseurs", "Factures fournisseurs à contrôler", "Facture saisie par le Production Manager ou le bureau technique", ["p:" + P_ADMIN]],
  ["Tâche", "Fournisseurs", "Échéances / retards / délai légal fournisseurs", "Échéancier fournisseurs", ["p:" + P_GERANT, "p:" + P_ADMIN]],
  ["Tâche", "Fournisseurs", "Demande de fournisseur", "Création de fournisseur demandée", ["p:" + P_GERANT, "p:" + P_ADMIN]],
  ["Tâche", "Staff", "Pointage du mois à compléter et transmettre", "Début de mois", ["@chefs"]],
  ["Tâche", "Staff", "Pointage à vérifier / compléter et valider", "Pointage transmis ou à faire", ["p:" + P_ADMIN]],
  ["Tâche", "Staff", "Décisions de fin de mois du pointage", "Pointage validé", ["p:" + P_GERANT]],
  ["Tâche", "Staff", "Évaluations du semestre à faire", "Fin de semestre", ["@chefs", "p:" + P_GERANT]],
  ["Tâche", "Staff", "Vérifier / ajuster les salaires bruts", "Chaque semestre (le Gérant prévenu après 30 jours)", ["p:" + P_ADMIN]],
  ["Tâche", "Staff", "Évaluations à valider / signalements à traiter / prime à valider", "Validation", ["p:" + P_GERANT]],
  ["Tâche", "Trésorerie", "Précision demandée sur une opération", "Le Gérant ou l'Administration pose une question (❓)", ["@responsablesCompte"]],
  ["Tâche", "Trésorerie", "Réponse à une demande de précision", "Le responsable de la caisse a répondu", ["@demandeur"]],
  ["Alerte", "Trésorerie", "Dépense signalée", "L'Administration signale une opération (⚑)", ["p:" + P_GERANT]],
  ["Tâche", "Achats", "Paiement transitaire à rattacher au registre transport international", "Sortie CFG au sous-poste Transitaire", ["p:" + P_ADMIN]],
  ["Tâche", "Équipe", "Tâche manuelle", "Créée par le Gérant", ["@choisis"]],
  ["Tâche", "Équipe", "Réponse à un bug signalé", "Bug corrigé ou rejeté", ["@declarant"]],
  ["Tâche", "Marketing", "Prospects à affecter", "Prospect saisi (marketing ou ADV)", ["p:" + P_GERANT]],
  ["Tâche", "Marketing", "Prospect à contacter", "Prospect affecté par le Gérant", ["@choisis"]],
  ["Tâche", "Marketing", "Time sheet du mois à valider", "Mois précédent non validé", ["p:" + P_GERANT]],
  ["Tâche", "Échantillons", "Préparer / remettre les échantillons", "Demande d'un commercial", ["p:" + P_PROD]],
  ["Tâche", "Échantillons", "Reste à donner", "Remise partielle, couleur revenue en stock", ["p:" + P_PROD]],
  ["Tâche", "Échantillons", "Échantillons prêts à l'usine", "Demande marquée prête", ["@commercial"]],
].map(([genre, domaine, nom, declencheur, dest]) => ({ genre, domaine, nom, declencheur, dest: dest || ["@alertes"] }));
const LIB_JETON_NOTIF = { "@commercial": "Commercial du dossier", "@responsablesCompte": "Responsables du compte", "@detenteur": "Détenteur du chèque", "@pilote": "Pilote du SAV (commercial du dossier, sinon ADV)", "@chefs": "Chefs d'équipe", "@choisis": "Personnes choisies par le Gérant", "@declarant": "Personne qui a signalé", "@document": "Selon l'étape / le document", "@alertes": "Qui voit les alertes", "@conducteurs": "Conducteurs habituels du véhicule" };
const FREQUENCES_RECURRENTES = [{ cle: "mensuelle", lib: "Mensuelle", mois: 1 }, { cle: "trimestrielle", lib: "Trimestrielle", mois: 3 }, { cle: "semestrielle", lib: "Semestrielle", mois: 6 }, { cle: "annuelle", lib: "Annuelle", mois: 12 }];
const JOURS_ALERTE_RECURRENTE = 7;
function ajouterMoisISO(dateISO, n, jourCible) {
  const [y, m] = dateISO.split("-").map(Number);
  const t = new Date(Date.UTC(y, m - 1 + n, 1, 12));
  const dernier = new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth() + 1, 0, 12)).getUTCDate();
  t.setUTCDate(Math.min(jourCible, dernier));
  return t.toISOString().slice(0, 10);
}
// ERP step 13 (ah, validé Nils 04/10) : rapport commercial — visites saisies au fil de la
// semaine, prospects, rapport hebdomadaire assemblé (lundi → dimanche), soumis par le
// commercial, lu par Nils. Accès : droit « commercial.rapport » (Commercial, Agent commercial, Gérant).
const VISITES_KEY = "erp:visites";
const PROSPECTS_KEY = "erp:prospects";
const RAPPORTS_COM_KEY = "erp:rapports-commerciaux";
const TYPES_VISITE = ["Courtoisie", "RDM", "Devis", "SAV"];
const TEMPERATURES_PROSPECT = ["Froid", "Tiède", "Chaud", "Confirmé"];
const COULEUR_TEMPERATURE = { Froid: "#5B7A99", Tiède: "#9C7A3C", Chaud: "#A8502F", Confirmé: "#4B6B4F" };
const SOURCES_B2C = ["Apporteur", "Instagram", "Digital", "Bouche à oreille", "Réseau", "Showroom", "Événement", "Relance"];
const MIN_VISITES_CHANTIER = 2;
const RAPPORT_COM_DEPUIS = "2026-10-05";
const NOTE_RAPPORT_COM = "Ce rapport est avant tout un outil à ton service. Il te permet de structurer ta semaine, de ne rien oublier, et de mettre en valeur ton travail auprès de la direction. Les informations que tu partages ici nous permettent de mieux te soutenir — en matière de stock, de pricing, d'échantillons ou de priorités — et de reconnaître ta contribution concrète aux résultats de Stone Concept. Plus il est rempli avec soin, plus nous pouvons t'accompagner vers la réussite de tes objectifs, et in fine, vers une rémunération à la hauteur de tes efforts.";
const CONSIGNE_CHANTIER = "Minimum 2 visites chantier par semaine avec photos. Photos en format VERTICAL (portrait) depuis le téléphone — obligatoire pour Instagram. Privilégier poses finies, détails matière et ambiances complètes. Envoyer les photos via WhatsApp au responsable marketing avant vendredi 17h.";
const RUBRIQUES_RC = [
  { cle: "elevage", titre: "1 · Élevage — comptes actifs à entretenir" },
  { cle: "b2b", titre: "2 · Chasse B2B — nouveaux prospects professionnels" },
  { cle: "b2c", titre: "3 · Chasse B2C — particuliers" },
];
function semaineISO(lundi) {
  const t = new Date(`${lundi}T12:00:00Z`);
  t.setUTCDate(t.getUTCDate() + 3); // jeudi de la semaine
  const y = t.getUTCFullYear();
  const j4 = new Date(Date.UTC(y, 0, 4, 12));
  const lundiS1 = new Date(j4);
  lundiS1.setUTCDate(j4.getUTCDate() - ((j4.getUTCDay() + 6) % 7));
  return { annee: y, num: 1 + Math.round((new Date(`${lundi}T12:00:00Z`) - lundiS1) / (7 * 86400000)) };
}
function libelleSemaine(lundi) {
  const s = semaineISO(lundi);
  return `S${String(s.num).padStart(2, "0")} — du ${formatDate(lundi)} au ${formatDate(decalerJours(lundi, 6))}`;
}
function prospectParticulier(p) {
  return !!p && p.type === TYPE_SANS_ICE;
}
const CATEGORIES_PREVISION = ["Investissement", "Douane / transit", "Leasing", "Impôts & taxes", "Remboursement d'emprunt", "Honoraires / prestataires", "Autre"];
// Nils 03/10 (r1) : opération CFG pas encore passée sur le relevé → alerte après 30 jours.
const JOURS_ALERTE_NON_PASSEE = 30;
// Qui a signé un BL (liste extensible).
const SIGNATAIRES_BL_KEY = "erp:signataires-bl";
const DEFAULT_SIGNATAIRES_BL = ["Transporteur", "Usager final", "Client"];
const NOM_CLIENT_COMPTOIR = "Client comptoir";
const DATE_REPRISE_CAISSES = "2026-01-01";
const DELAI_LEGAL_JOURS = 60;
const DELAI_CONVENTION_MAX = 120;
const JOURS_ALERTE_DEVIS = 45;
const JOURS_ALERTE_ECHEANCE = 7;
// Nils 02/10 : alerte quand la limite légale de paiement (loi 69-21) approche.
const JOURS_ALERTE_LIMITE_LEGALE = 10;
const AMENDE_TAUX_1ER_MOIS = 0.0225;
const AMENDE_TAUX_MOIS_SUIVANT = 0.0085;
// ---- Clôture mensuelle (Nils 01/10) : le responsable demande, Sawsan valide ; mois verrouillé ensuite. ----
const CLOTURE_DEPUIS_DEFAUT = "2026-09";
const JOURS_ALERTE_CLOTURE = 7;
const SOUS_POSTE_ECART_CAISSE = "Écart de caisse";
const POSTE_PAR_TIERS = { client: "Encaissements clients", employe: "Frais salariaux", etat: "Charges fiscales & sociales", associe: "Compte associé" };
const MOIS_COMPTABLE = ["JANVIER", "FEVRIER", "MARS", "AVRIL", "MAI", "JUIN", "JUILLET", "AOUT", "SEPTEMBRE", "OCTOBRE", "NOVEMBRE", "DECEMBRE"];
// Sorties qui n'ont normalement pas de facture fournisseur (pas signalées au contrôle TVA).
const POSTES_SANS_FACTURE = ["Frais salariaux", "Commissions", "Compte associé", "Dividendes", "Charges fiscales & sociales", "À définir"];
// Anciens libellés des fichiers 2026 → plan unifié (import). Clés normalisées.
const CORRESPONDANCES_IMPORT = {
  "paiement|paiement": ["Encaissements clients", "Encaissements clients"],
  "frais de deplacement": "Déplacements",
  "investissement|investissement": ["Investissements", "Travaux & équipements"],
  "investissements|investissements": ["Investissements", "Travaux & équipements"],
  "investissements|travaux & equipements": ["Investissements", "Travaux & équipements"],
  "remb. frais medicaux": ["Frais salariaux", "Remboursements de frais"],
  "remboursements": ["Frais salariaux", "Remboursements de frais"],
  "prime de productivite": ["Frais salariaux", "Primes", "Productivité"],
  "commissions|commissions": ["Commissions", "Commissions versées"],
  "commissions versees": ["Commissions", "Commissions versées"],
  "avance sur commissions": ["Commissions", "Avances sur commissions"],
  "remboursement commissions": ["Commissions", "Remboursement d'avances"],
  "remboursement|remboursement": ["Opérations exceptionnelles", "Remboursement reçu"],
  "carburant & deplacements": ["Frais de fonctionnement", "Carburant"],
  "remboursement c.a": ["Compte associé", "Remboursement"],
  "compte associe|compte associe": ["Compte associé", "Apport"],
  "approvisionnement matieres": ["Approvisionnement", "Matières"],
  "marketing|marketing": ["Marketing", "Marketing & communication"],
  "charges sociales": ["Charges fiscales & sociales", "CNSS"],
  "dividendes|dividendes": ["Dividendes", "Dividendes"],
  "pose & production|pose & production": ["Pose & Production", "Pose"],
};
// Nils 02/10 : tout article créé par quelqu'un d'autre que Nils passe par sa validation.
function articleAValider(a) {
  return !!a && !!a.creePar && a.valideParNils === false;
}
// Nils 01/10 : nom des fichiers de la procédure = n° du document + client + réf. contremarque.
function morceauNomFichier(x) {
  return String(x || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^A-Za-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 40);
}
// Montant tapé à la française : « 1 250 000,50 », « 1.250.000,50 », « 1250000.5 ».
function parseMontantSaisi(x) {
  let t = String(x ?? "").replace(/[\s\u00a0\u202f]/g, "").replace(/(DH|MAD)$/i, "");
  if (!t) return NaN;
  const iv = t.lastIndexOf(","), ip = t.lastIndexOf(".");
  if (iv >= 0 && ip >= 0) t = iv > ip ? t.replace(/\./g, "").replace(",", ".") : t.replace(/,/g, "");
  else if (iv >= 0) t = (t.match(/,/g) || []).length > 1 ? t.replace(/,/g, "") : t.replace(",", ".");
  else if ((t.match(/\./g) || []).length > 1) t = t.replace(/\./g, "");
  return /^-?\d+(\.\d+)?$/.test(t) ? Number(t) : NaN;
}
function nomFichierDocument(...morceaux) {
  return morceaux.map(morceauNomFichier).filter(Boolean).join("_");
}
// Nils 02/11 : saisie numérique sans zéro de tête (« 0100 » → « 100 » ; « 0,5 » et « 0.5 » gardés).
function sansZeroTete(v) {
  return String(v ?? "").replace(/^(-?)0+(?=\d)/, "$1");
}
function normLib(s) {
  return String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[’']/g, "'").replace(/\s+/g, " ").trim();
}
// Fiches de départ : les 9 comptes ERP.
function staffParDefaut() {
  const le = new Date().toISOString();
  return FICHES_STAFF_DEPART.map((u) => ({
    ...ficheStaffVide(),
    ...decouperNomStaff(u.nom),
    id: `staff-${u.compte}`,
    nom: u.nom,
    poste: u.poste,
    service: u.service,
    contrat: u.contrat || "",
    compte: u.compte,
    poseur: !!u.poseur,
    creePar: "Reprise automatique",
    creeLe: le,
  }));
}
// Intègre dans Staff les personnes encore enregistrées à l'ancienne (liste
// des poseurs, affectations de type « personne ») : au 1er chargement, ou
// après l'import d'une ancienne sauvegarde. L'id de l'affectation est
// conservé (références : consommables en service, outillage). Même nom =
// même fiche ; noms proches (ex. « Krim » / « Soufiane Krim ») signalés.
function integrerPersonnesHeritees(staffIn, affIn, posIn, enServiceIn, outilsIn) {
  let staff = (staffIn || []).map((s) => ({ ...s }));
  const crees = [];
  const rattaches = [];
  const reference = (id) =>
    (enServiceIn || []).some((e) => e.affectationId === id) ||
    (outilsIn || []).some((o) => o.detenteurId === id || (o.historique || []).some((h) => h.vers === id || h.de === id || h.detenteur === id || h.imputeA === id));
  (affIn || []).filter((a) => a.type === "personne").forEach((a) => {
    if (staff.some((s) => s.id === a.id)) return;
    const patch = { usure: a.actif !== false, detenteur: a.actif !== false, baseUsure: a.base === "pose" ? "pose" : "transformation" };
    const ex = staff.find((s) => normNomStaff(s.nom) === normNomStaff(a.nom));
    if (ex && String(ex.id).startsWith("staff-") && !reference(ex.id)) {
      Object.assign(ex, patch, { id: a.id, dateEmbauche: ex.dateEmbauche || a.dateEmbauche || "" });
      rattaches.push(ex.nom);
    } else {
      const f = { ...ficheStaffVide(), ...patch, ...decouperNomStaff(a.nom), id: a.id, nom: a.nom, dateEmbauche: a.dateEmbauche || "", creePar: "Reprise automatique", creeLe: new Date().toISOString() };
      staff.push(f);
      crees.push(f.nom);
    }
  });
  (posIn || []).forEach((nom) => {
    if (!String(nom || "").trim()) return;
    const ex = staff.find((s) => normNomStaff(s.nom) === normNomStaff(nom));
    if (ex) {
      if (!ex.poseur) { ex.poseur = true; rattaches.push(ex.nom); }
    } else {
      staff.push({ ...ficheStaffVide(), ...decouperNomStaff(nom), id: uid(), nom: String(nom).trim(), service: "Pose", poseur: true, creePar: "Reprise automatique", creeLe: new Date().toISOString() });
      crees.push(String(nom).trim());
    }
  });
  const nouveaux = new Set(crees.map(normNomStaff));
  const doublons = [];
  for (let i = 0; i < staff.length; i++) {
    for (let j = i + 1; j < staff.length; j++) {
      const a = normNomStaff(staff[i].nom), b = normNomStaff(staff[j].nom);
      if (!nouveaux.has(a) && !nouveaux.has(b)) continue;
      const ta = a.split(" "), tb = b.split(" ");
      const [court, long] = ta.length <= tb.length ? [ta, tb] : [tb, ta];
      if (a === b || court.every((t) => long.includes(t))) doublons.push(`${staff[i].nom} / ${staff[j].nom}`);
    }
  }
  return {
    staff,
    affectations: (affIn || []).filter((a) => a.type !== "personne"),
    crees,
    rattaches: [...new Set(rattaches)],
    doublons,
  };
}
// ERP step 11 (validé Nils du 29/09) : SAV — tickets de suivi, rattachés au
// dossier d'origine ; le travail réel passe par un devis / dossier SAV.
const SAV_KEY = "erp:sav";
// Nils 01/11 (étape b) : dossier SAV dont le ticket est clôturé, puis archivé par le Gérant.
const EA_SAV_CLOTURE = "SAV clôturé";
const EA_ARCHIVE = "Archivé";
// Nils 02/11 : motifs d'une gratuité (dossier archivé au PL / BL sans contrepartie).
const MOTIFS_GRATUITE = ["Geste commercial", "Cadeau client", "Autre"];
const DEFAULT_MOTIFS_SAV = [
  "Erreur de production",
  "Erreur de dessin",
  "Erreur de relevé / métré",
  "Erreur ADV",
  "Erreur commercial",
  "Erreur de pose",
  "Matière première défectueuse",
  "Accessoire / électroménager défectueux",
  "Casse au transport / livraison",
  "Dégât causé par un tiers",
  "Mauvaise utilisation / entretien client",
  "Geste commercial",
];
const DELAI_SAV_JOURS = 7;
// ERP step 11 (validé Nils du 29/09) : outillage suivi un par un.
const OUTILLAGE_KEY = "erp:outillage";
const CONTROLES_OUTILLAGE_KEY = "erp:controles-outillage";
const ETAT_SORTI_PARC = "Sorti du parc";
const ETATS_OUTIL = ["En service", "En réparation", "Hors service", "Perdu / volé", ETAT_SORTI_PARC];
// Nils 04/10 (h) : sortie définitive et volontaire du parc (le numéro n'est jamais réutilisé).
const MOTIFS_SORTIE_PARC = ["Cassé irréparable", "Usé", "Vendu", "Donné", "Jeté"];
const TYPES_INCIDENT_OUTIL = ["Casse", "Panne", "Perte", "Vol"];
const CATEGORIES_OUTIL = ["Meuleuse", "Polisseuse", "Scie / rainureuse", "Perceuse / visseuse", "Ventouse", "Niveau / laser", "Aspirateur", "Serre-joint / outillage à main", "Autre"];
const PERIODE_CONTROLE_OUTILLAGE_JOURS = 30;
// Nils 03/10 (i) : bureautique — catégories propres (Sawsan les complète), inventaire tous les six mois.
const CATEGORIES_BUREAUTIQUE = ["Ordinateur portable", "Ordinateur fixe", "Écran", "Imprimante", "Téléphone", "Tablette", "Onduleur", "Réseau (box, routeur)", "Autre"];
const PERIODE_INVENTAIRE_BUREAUTIQUE_JOURS = 182;
function familleOutil(o) {
  return o && o.famille === "bureautique" ? "bureautique" : "outillage";
}
const SEUIL_USURE_ANORMALE_PCT = 50; // défaut, réglable par Nils
// Liste partagée entre Fournisseurs et (à venir) Clients : préfixe erp: volontaire
const PAIEMENTS_KEY = "erp:conditions-paiement";
const PRODUITS_KEY = "stock:produits";
// Clients : préfixe erp: car l'entité dépasse le stock (commandes, caisses à venir)
const CLIENTS_KEY = "erp:clients";
const DIMENSIONS_KEY = "stock:dimensions";
const EPAISSEURS_KEY = "stock:epaisseurs";

const SEED_PRODUITS = [
  { id: "p-calacatta", nom: "Calacatta", categorie: "Quartz", seuil: 5, correspondances: [{ fournisseur: "Guidoni Quartz", nomFournisseur: "Calacatta" }] },
  { id: "p-pietragrey", nom: "Pietra Grey", categorie: "Céramique", seuil: 6, correspondances: [{ fournisseur: "Infinity", nomFournisseur: "Pietra Grey" }] },
  { id: "p-inox30", nom: "Profilé inox brossé 30mm", categorie: "Inox", seuil: 50, correspondances: [] },
  { id: "p-colle", nom: "Colle carrelage flex C2", categorie: "Autre", seuil: 10, correspondances: [] },
];

const SEED = [
  { id: "seed-quartz", produitId: "p-calacatta", fournisseur: "Guidoni Quartz", dimensions: "306 × 141 cm", epaisseur: "20mm", nuance: "", choix: "", stockReel: 14, arrivages: 0, unite: "tranche(s)" },
  { id: "seed-ceramique", produitId: "p-pietragrey", fournisseur: "Infinity", dimensions: "320 × 160 cm", epaisseur: "12mm", nuance: "4", choix: "1er choix", stockReel: 8, arrivages: 0, unite: "tranche(s)" },
  { id: "seed-inox", produitId: "p-inox30", fournisseur: "InoxMaroc", dimensions: "", epaisseur: "", nuance: "", choix: "", stockReel: 120, arrivages: 0, unite: "pièce(s)" },
  { id: "seed-colle", produitId: "p-colle", fournisseur: "Weber", dimensions: "", epaisseur: "", nuance: "", choix: "", stockReel: 6, arrivages: 0, unite: "pièce(s)" },
];

const SEED_RESERVATIONS = [
  { id: uid(), itemId: "seed-quartz", bc: "BC-2026-0087", client: "Villa El Kabbaj", quantite: 3, note: "", statut: "active", creeLe: new Date().toISOString() },
  { id: uid(), itemId: "seed-ceramique", bc: "BC-2026-0091", client: "Résidence Anfa Place", quantite: 6, note: "", statut: "active", creeLe: new Date().toISOString() },
];

function today() {
  return new Date().toISOString().slice(0, 10);
}

// Échappement HTML — nécessaire pour insérer en sécurité du texte saisi par
// l'utilisateur (désignations libres, adresses…) dans le document imprimable
// généré comme chaîne de caractères (voir imprimerDevis).
function escapeHtml(s) {
  return String(s == null ? "" : s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function fmtMAD(n) {
  const v = Number(n) || 0;
  return v.toLocaleString("fr-FR", { maximumFractionDigits: 2 });
}

// Step 12 pt.3 (accord Nils du 21/09) : tri alphabétique appliqué aux menus
// déroulants qui listent des entités libres/gérées par l'utilisateur
// (fournisseurs, produits, catégories, finitions, groupes couleur,
// conditions de paiement, dimensions, épaisseurs…). `numeric: true` fait
// trier "6mm" avant "12mm" au lieu de l'ordre lexical pur. `cle` est le nom
// du champ texte à comparer pour un tableau d'objets ; omis pour un tableau
// de chaînes simples. Volontairement PAS appliqué aux énumérations à ordre
// fonctionnel fixe (statuts BDC/RDM/PL/BL/Facture, matières, niveaux de
// paiement, types client…), qui perdraient leur sens si triées.
function trierAlpha(liste, cle) {
  return [...(liste || [])].sort((a, b) => {
    const av = cle ? (a ? a[cle] : "") : a;
    const bv = cle ? (b ? b[cle] : "") : b;
    return String(av || "").localeCompare(String(bv || ""), "fr", { numeric: true, sensitivity: "base" });
  });
}

// Pour chaque statut du circuit : le champ qui porte son numéro, le libellé
// affiché, et le préfixe de numérotation. Sert à la fois à afficher le bon
// numéro en titre de fiche et à construire le "circuit documentaire" en
// dessous (tous les numéros des étapes déjà passées).
const ETAPES_COMMANDE = [
  { statut: "BDC", champ: "numero", label: "BC", prefixe: "BC" },
  { statut: "RDM", champ: "numeroRDM", label: "RDM", prefixe: "RDM" },
  { statut: "PL", champ: "numeroPL", label: "PL", prefixe: "PL" },
  { statut: "BL", champ: "numeroBL", label: "BL", prefixe: "BL" },
  { statut: "Facture", champ: "numeroFacture", label: "Facture", prefixe: "FA" },
];
// Qui a déclenché chaque étape et quand — distinct de modifiePar/modifieLe,
// qui reflète le tout dernier enregistrement (n'importe quel champ), pas la
// transformation elle-même.
const AUTEURS_ETAPES_COMMANDE = [
  { statut: "BDC", label: "Créé", champDate: "creeLe", champPar: "creePar" },
  { statut: "RDM", label: "Transformé en RDM", champDate: "dateRDM", champPar: "parRDM" },
  { statut: "PL", label: "Transformé en PL", champDate: "datePL", champPar: "parPL" },
  { statut: "BL", label: "Transformé en BL", champDate: "dateBL", champPar: "parBL" },
  { statut: "Facture", label: "Transformé en Facture", champDate: "dateFacture", champPar: "parFacture" },
];

function calcLigne(l) {
  const prixPublic = Number(l.prixPublic) || 0;
  const remise = Number(l.remise) || 0;
  const qte = Number(l.qte) || 0;
  const prixRevise = prixPublic * (1 - remise / 100);
  const montantHT = prixRevise * qte;
  return { prixRevise, montantHT };
}

function calcTotaux(devis) {
  const totalHT = (devis.lignes || []).reduce((s, l) => s + calcLigne(l).montantHT, 0);
  const totalTVA = devis.exonereTVA ? 0 : totalHT * TVA_TAUX;
  const totalTTC = totalHT + totalTVA;
  return { totalHT, totalTVA, totalTTC };
}

// Petite pause entre deux écritures — utile pour les imports/exports en
// masse (plusieurs dizaines de clés d'affilée), pour ne pas déclencher la
// limite de débit de la plateforme sur des écritures trop rapprochées.
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function loadKey(key, fallback) {
  try {
    const res = await window.storage.get(key, true);
    return res && res.value ? JSON.parse(res.value) : fallback;
  } catch (e) {
    return fallback;
  }
}

// ERP step 11 (demande Nils du 29/09) : toute écriture de données passe par
// ecrireStockage ; une fois l'ERP chargé, le composant y branche un crochet
// qui compare avant / après et l'inscrit au Journal d'accès.
let crochetEcritureJournal = null;
// Étape d : avec le serveur (window.storage.journalServeur), le crochet renvoie la ligne de
// journal au lieu de l'écrire ; elle part avec l'enregistrement et le serveur ne l'ajoute que
// si l'enregistrement réussit, avec l'identité de la personne connectée.
// Étape f : « Importer » et « Vider des données » (Gérant) marquent leurs écritures ; le serveur
// les dispense des contrôles de numérotation et d'irréversibilité jusqu'à la mise en ligne (étape h).
let operationGerant = null;
async function avecOperationGerant(operation, fn) {
  operationGerant = operation;
  try {
    return await fn();
  } finally {
    operationGerant = null;
  }
}
async function ecrireStockage(key, str, shared) {
  const operation = operationGerant;
  let journal = null;
  if (crochetEcritureJournal) {
    try {
      journal = await crochetEcritureJournal(key, str);
    } catch (e) {
      console.error("Journal automatique : échec", e);
    }
  }
  const options = { ...(journal ? { journal } : {}), ...(operation ? { operation } : {}) };
  return window.storage.set(key, str, shared, Object.keys(options).length ? options : undefined);
}
// Données suivies par le journal automatique (clé -> libellé).
const DONNEES_JOURNALISEES = {
  "erp:devis": "Devis",
  "erp:commandes": "Dossiers",
  "erp:articles": "Catalogue",
  "erp:clients": "Clients",
  "erp:chantiers": "Projets immobiliers",
  "erp:prix-groupes-tranche": "Prix tranches",
  "erp:prix-groupes-tranche-2e-choix": "Prix tranches 2e choix",
  "erp:categories-articles": "Catégories catalogue",
  "erp:unites-articles": "Unités catalogue",
  "erp:finitions-articles": "Finitions",
  "erp:groupes-couleur-articles": "Groupes couleur",
  "erp:apporteurs-affaire": "Apporteurs d'affaire",
  "erp:poseurs": "Poseurs",
  "erp:en-attente-par-statut": "Listes « En attente de »",
  "erp:unites-categorie": "Unités par catégorie",
  "erp:parametres": "Réglages",
  "erp:affectations": "Affectations",
  "erp:staff": "Staff",
  "erp:suivi-mensuel": "Suivi mensuel du personnel",
  "erp:signalements": "Signalements",
  "erp:pointage": "Pointage",
  "erp:primes-productivite": "Primes de productivité",
  "erp:tresorerie": "Trésorerie",
  "erp:comptes-tresorerie": "Comptes de trésorerie",
  "erp:factures-fournisseurs": "Factures fournisseurs",
  "erp:factures-clients-anterieures": "Factures clients antérieures à l'ERP",
  "erp:factures-avance": "Factures d'avance (projets immobiliers)",
  "erp:documents-remplacement": "Factures / BL de remplacement",
  "erp:couts-revient": "Coûts de revient (profils d'import)",
  "erp:commissions": "Commissions (barèmes et validations)",
  "erp:deplacements": "Déplacements (livraison, RDM, pose, SAV)",
  "erp:expositions": "Tranches en exposition (avoirs fournisseurs)",
  "erp:avoirs": "Factures d'avoir clients",
  "erp:echantillons-suivi": "Boîtes revendeurs et matériel prêté",
  "erp:planning": "Planning (RDM, production, pose)",
  "erp:vehicules": "Véhicules et machines (fiches, relevés, tickets, carnets)",
  "erp:arrivages-import": "Arrivages import",
  "erp:arrivages-locaux": "Arrivages locaux",
  "erp:transport-international": "Registre transport international",
  "erp:affectations-credit": "Affectations de crédit client",
  "erp:previsions-tresorerie": "Prévisions de trésorerie",
  "erp:echeances-recurrentes": "Échéances récurrentes",
  "erp:taches-manuelles": "Tâches manuelles",
  "erp:bugs": "Bugs signalés",
  "erp:marketing-timesheet": "Time sheet marketing",
  "erp:echantillons": "Échantillons (liste)",
  "erp:echantillons-mouvements": "Mouvements d'échantillons",
  "erp:demandes-echantillons": "Demandes d'échantillons",
  "erp:visites": "Visites commerciales",
  "erp:prospects": "Prospects",
  "erp:rapports-commerciaux": "Rapports commerciaux",
  "erp:signataires-bl": "Signataires des BL",
  "erp:acces": "Profils d'accès et comptes",
  "erp:sav": "SAV",
  "erp:outillage": "Outillage et bureautique",
  "erp:controles-outillage": "Contrôles outillage",
  "erp:conditions-paiement": "Conditions de paiement",
  "stock:references": "Lots",
  "stock:categories": "Catégories stock",
  "stock:fournisseurs": "Fournisseurs",
  "stock:demandes-fournisseurs": "Demandes fournisseurs",
  "stock:demandes-souscategories": "Demandes de sous-catégories",
  "stock:mouvements": "Mouvements de stock",
  "stock:reservations": "Réservations",
  "stock:credits-tranches-exonerables": "Crédits tranches exonérables",
  "stock:credits-tranches-historique": "Historique crédits exonérables",
  "stock:campagnes-inventaire": "Inventaire",
  "stock:en-service": "Consommables en service",
  "stock:lots-archives": "Lots archivés",
  "stock:produits": "Produits stock",
  "stock:dimensions": "Dimensions",
  "stock:epaisseurs": "Épaisseurs",
};
const CHAMPS_IGNORES_JOURNAL = new Set(["modifiePar", "modifieLe"]);
const LIBELLES_CHAMPS_JOURNAL = {
  statut: "Statut", enAttenteDe: "En attente de", clientId: "Client", produitId: "Produit", articleId: "Article", itemId: "Lot",
  numero: "N°", numeroRDM: "N° RDM", numeroPL: "N° PL", numeroBL: "N° BL", numeroFacture: "N° facture",
  dateRDM: "Date RDM", datePL: "Date PL", dateBL: "Date BL", dateFacture: "Date facture",
  parRDM: "Par (RDM)", parPL: "Par (PL)", parBL: "Par (BL)", parFacture: "Par (facture)",
  lignes: "Lignes", quantite: "Qté", qte: "Qté", prix: "Prix", prixUnitaire: "Prix unitaire", remise: "Remise", designation: "Désignation",
  nom: "Nom", fournisseur: "Fournisseur", stockReel: "Stock réel", categorie: "Catégorie", unite: "Unité",
  exonereTVA: "Exonéré TVA", commercialSC: "Commercial", etage: "Étage", documents: "Documents", documentsLibres: "Autres documents",
  plaquesCuisson: "Plaques de cuisson", eviers: "Éviers", contactSurPlace: "Contact sur place", telephoneSurPlace: "Tél. sur place",
  prixAchatHT: "Prix d'achat HT", blFournisseur: "BL fournisseur", actif: "Actif", aValider: "À valider",
  prenom: "Prénom", nomFamille: "Nom de famille", telephonePro: "Tél. pro", telephonePerso: "Tél. perso", anciensNoms: "Anciens noms",
  poste: "Poste", service: "Service", contrat: "Contrat", dateEmbauche: "Date d'embauche", dateSortie: "Date de sortie", telephone: "Téléphone",
  compte: "Compte ERP", regime: "Horaire", soldeHeuresInitial: "Solde d'heures de départ", responsableId: "Responsable", adresse: "Adresse", urgenceNom: "Contact d'urgence", urgenceLien: "Lien (urgence)", urgenceTel: "Tél. urgence", matricule: "Matricule", cnss: "N° CNSS", cin: "CIN", salaires: "Salaires", primes: "Primes", evaluations: "Évaluations", reportConges: "Report de congés", poseur: "Poseur", detenteur: "Détenteur d'outillage", usure: "Usure des consommables", baseUsure: "Base d'usure",
};
function libelleChampJournal(k) {
  return LIBELLES_CHAMPS_JOURNAL[k] || k.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase();
}
// Résolution des identifiants (client, produit…) en noms — branchée par le composant.
let resoudreIdJournal = null;
function valeurCourteJournal(v, champ) {
  if (v === undefined || v === null || v === "") return "—";
  if (champ && resoudreIdJournal && typeof v === "string") {
    const r = resoudreIdJournal(champ, v);
    if (r) return r;
  }
  if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(v)) {
    const d = new Date(v);
    if (!isNaN(d)) return `${d.toLocaleDateString("fr-FR")} ${d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}`;
  }
  if (v === true) return "Oui";
  if (v === false) return "Non";
  if (Array.isArray(v)) return v.every((x) => typeof x !== "object" || x === null) ? (v.length ? v.join(", ") : "—") : `${v.length} élément(s)`;
  if (typeof v === "object") return "{…}";
  const t = String(v);
  return t.length > 70 ? t.slice(0, 67) + "…" : t;
}
function estObjetSimple(v) {
  return v && typeof v === "object" && !Array.isArray(v);
}
// Différences champ par champ entre deux objets (un niveau de détail dans
// les sous-objets et les sous-listes, ex. lignes d'un dossier).
function diffChampsJournal(a, b, libelle) {
  const out = [];
  const cles = new Set([...Object.keys(a || {}), ...Object.keys(b || {})]);
  cles.forEach((k) => {
    if (CHAMPS_IGNORES_JOURNAL.has(k)) return;
    const va = (a || {})[k];
    const vb = (b || {})[k];
    if (JSON.stringify(va) === JSON.stringify(vb)) return;
    if (Array.isArray(va) && Array.isArray(vb) && [...va, ...vb].some((x) => estObjetSimple(x) && x.id)) {
      const ma = new Map(va.filter((x) => x && x.id).map((x) => [x.id, x]));
      const mb = new Map(vb.filter((x) => x && x.id).map((x) => [x.id, x]));
      const parts = [];
      mb.forEach((x, id) => { if (!ma.has(id)) parts.push(`+ ${libelle(x)}`); });
      ma.forEach((x, id) => { if (!mb.has(id)) parts.push(`− ${libelle(x)}`); });
      mb.forEach((x, id) => {
        if (ma.has(id) && JSON.stringify(ma.get(id)) !== JSON.stringify(x)) {
          const sous = diffChampsJournal(ma.get(id), x, libelle).filter((l) => !l.includes("{…}"));
          parts.push(`${libelle(x)} (${sous.join(", ") || "modifié"})`);
        }
      });
      if (va.length === vb.length && parts.length === 0) parts.push("ordre modifié");
      out.push(`${libelleChampJournal(k)} : ${parts.join(" ; ")}`);
    } else if (estObjetSimple(va) && estObjetSimple(vb)) {
      const sous = [];
      new Set([...Object.keys(va), ...Object.keys(vb)]).forEach((sk) => {
        if (JSON.stringify(va[sk]) !== JSON.stringify(vb[sk])) sous.push(`${sk} ${valeurCourteJournal(estObjetSimple(va[sk]) ? (va[sk].lien || va[sk].nom || JSON.stringify(va[sk])) : va[sk])} → ${valeurCourteJournal(estObjetSimple(vb[sk]) ? (vb[sk].lien || vb[sk].nom || JSON.stringify(vb[sk])) : vb[sk])}`);
      });
      out.push(`${libelleChampJournal(k)} : ${sous.join(", ")}`);
    } else {
      out.push(`${libelleChampJournal(k)} : ${valeurCourteJournal(va, k)} → ${valeurCourteJournal(vb, k)}`);
    }
  });
  return out;
}
// Différences entre deux versions d'une donnée (liste d'objets à id, liste
// de valeurs, ou objet de réglages).
function diffDonneesJournal(avant, apres, libelle) {
  if (Array.isArray(avant) || Array.isArray(apres)) {
    const a = Array.isArray(avant) ? avant : [];
    const b = Array.isArray(apres) ? apres : [];
    const avecId = [...a, ...b].some((x) => estObjetSimple(x) && x.id);
    if (!avecId) {
      const k = (x) => (typeof x === "object" ? JSON.stringify(x) : String(x));
      const sa = new Set(a.map(k));
      const sb = new Set(b.map(k));
      const lignes = [];
      b.forEach((x) => { if (!sa.has(k(x))) lignes.push(`+ ${estObjetSimple(x) ? libelle(x) : valeurCourteJournal(x)}`); });
      a.forEach((x) => { if (!sb.has(k(x))) lignes.push(`− ${estObjetSimple(x) ? libelle(x) : valeurCourteJournal(x)}`); });
      return lignes;
    }
    const ma = new Map(a.filter((x) => x && x.id).map((x) => [x.id, x]));
    const mb = new Map(b.filter((x) => x && x.id).map((x) => [x.id, x]));
    const lignes = [];
    mb.forEach((x, id) => { if (!ma.has(id)) lignes.push(`+ ${libelle(x)}`); });
    ma.forEach((x, id) => { if (!mb.has(id)) lignes.push(`− ${libelle(x)}`); });
    mb.forEach((x, id) => {
      if (ma.has(id) && JSON.stringify(ma.get(id)) !== JSON.stringify(x)) {
        const champs = diffChampsJournal(ma.get(id), x, libelle);
        if (champs.length > 0) lignes.push(`${libelle(x)} : ${champs.join(" ; ")}`);
      }
    });
    return lignes;
  }
  if (estObjetSimple(avant) || estObjetSimple(apres)) return diffChampsJournal(avant || {}, apres || {}, libelle);
  return JSON.stringify(avant) === JSON.stringify(apres) ? [] : [`${valeurCourteJournal(avant)} → ${valeurCourteJournal(apres)}`];
}

async function saveKey(key, value) {
  try {
    await ecrireStockage(key, JSON.stringify(value), true);
    return true;
  } catch (e) {
    console.error(`Erreur de sauvegarde (${key})`, e);
    return false;
  }
}

function Th({ children }) {
  return <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.6 }}>{children}</div>;
}

// compteConnecte : compte de la personne connectée, donné par le serveur ({ id, nom, profil }) ;
// session : fonctions de connexion (client/src/session.js). Sans eux (tests), l'ERP s'ouvre en Gérant.
function ERP({ compteConnecte = null, session = null } = {}) {
  const [items, setItems] = useState(null); // lots
  const [produits, setProduits] = useState(null);
  const [clients, setClients] = useState(null);
  const [showClientFiche, setShowClientFiche] = useState(false);
  const [clientEditing, setClientEditing] = useState(null);
  const [clientError, setClientError] = useState("");
  const [clientQuery, setClientQuery] = useState("");
  const [dimensionsList, setDimensionsList] = useState(null);
  const [epaisseursList, setEpaisseursList] = useState(null);
  const [showFormatManager, setShowFormatManager] = useState(false);
  const [newDim, setNewDim] = useState("");
  const [newEp, setNewEp] = useState("");
  const [formatError, setFormatError] = useState("");
  const [afficherChutes, setAfficherChutes] = useState(false);
  const [categories, setCategories] = useState(null);
  const [unitesCategorie, setUnitesCategorie] = useState(null);
  const [showUniteCategorieManager, setShowUniteCategorieManager] = useState(false);
  const [newUniteCategorieInput, setNewUniteCategorieInput] = useState("");
  const [fournisseurs, setFournisseurs] = useState(null);
  const [loading, setLoading] = useState(true);

  const [query, setQuery] = useState("");
  const [filterCat, setFilterCat] = useState("Toutes");
  const [filterEpaisseur, setFilterEpaisseur] = useState("Toutes");
  // ERP step 9 (demande Nils du 24/09) : filtre Stock par groupe de couleur
  // — lit le groupe de couleur ET le groupe de couleur secondaire de
  // l'article Catalogue lié, sans distinguer les deux (une seule liste de
  // couleurs, un produit matche si l'une ou l'autre correspond).
  const [filterGroupeCouleur, setFilterGroupeCouleur] = useState("Toutes");
  // Step 12 pt.8 (accord Nils du 21/09) : "Alerte seulement" et "2e choix
  // seulement" (anciennement deux cases à cocher) et "Consommable"
  // (nouveau) sont regroupés dans un seul filtre "Autre".
  const [filterAutre, setFilterAutre] = useState("Toutes");
  const [ouverts, setOuverts] = useState({}); // produits dépliés

  const [showForm, setShowForm] = useState(false);
  const [showReception, setShowReception] = useState(false);
  const [receptionLot, setReceptionLot] = useState(null);
  const [receptionQuantite, setReceptionQuantite] = useState("");
  const [receptionBM, setReceptionBM] = useState({ a: "", b: "", s: "" });
  // Nils 04/10 (o) : répartir un lot existant en A / B, ou corriger un marquage.
  const [repartitionBM, setRepartitionBM] = useState(null);
  const [receptionResteAnnule, setReceptionResteAnnule] = useState(false);
  const [receptionError, setReceptionError] = useState("");
  const [formError, setFormError] = useState("");
  const [lotCategorie, setLotCategorie] = useState("");
  const [lotRechercheDesignation, setLotRechercheDesignation] = useState("");
  const [lotFiltreDimension, setLotFiltreDimension] = useState("");
  const [lotFiltreEpaisseur, setLotFiltreEpaisseur] = useState("");
  const [lotFiltreGroupeCouleur, setLotFiltreGroupeCouleur] = useState("");
  const [showProduit, setShowProduit] = useState(false);
  const [prodEditing, setProdEditing] = useState(null);
  const [prodError, setProdError] = useState("");
  const [editing, setEditing] = useState(null);

  const [showCatManager, setShowCatManager] = useState(false);
  const [catEditingId, setCatEditingId] = useState(null); // nom d'origine de la catégorie en cours de modification
  const [newCatName, setNewCatName] = useState("");
  const [newCatUnite, setNewCatUnite] = useState(DEFAULT_UNITES_CATEGORIE[0]);
  const [catError, setCatError] = useState("");
  const [catSuccess, setCatSuccess] = useState("");
  const catListRef = useRef(null);
  const importFileRef = useRef(null);
  // ERP step 8 : snapshot pris à l'ouverture de chacune des trois
  // sous-fenêtres du dossier (Modifier le bon de commande, Éléments
  // techniques, Fiche de pose) — ces sous-fenêtres modifient directement
  // `commandeEditing`/`draft` au fil de la saisie (pas de brouillon séparé),
  // donc un clic en dehors doit restaurer cet instantané pour ne rien
  // garder, plutôt que de fermer en laissant les modifications en mémoire
  // (accord du 21/09 avec Nils : seul le bouton "Enregistrer" de la
  // sous-fenêtre valide, plus de bouton "Annuler" séparé).
  const commandeEditingSnapshotRef = useRef(null);
  const draftLignesSnapshotRef = useRef(null);
  const [showVidage, setShowVidage] = useState(false);
  // ERP step 13 (as, Nils 04/10) : groupes de données cochés dans « Vider des données ».
  const [vidageGroupes, setVidageGroupes] = useState({});
  const [vidageConfirmationTexte, setVidageConfirmationTexte] = useState("");
  const [storageOk, setStorageOk] = useState(null); // null = test en cours, true/false = résultat

  // Test au montage : écrit puis relit une valeur test pour vérifier que le
  // stockage persistant fonctionne réellement dans cet artefact (et pas
  // seulement en apparence via l'état React de la page). Rend visible tout
  // de suite un problème qui, sinon, ne se découvre qu'après coup.
  useEffect(() => {
    (async () => {
      try {
        // Étape c : sur le serveur, la vérification porte sur le serveur et sa base (une valeur
        // test commune à tous les postes se ferait écraser par un collègue qui démarre en même temps).
        if (window.storage.verifier) {
          setStorageOk(await window.storage.verifier());
          return;
        }
        const valeurTest = `test-${Date.now()}`;
        await window.storage.set("erp:_test_stockage", valeurTest, true);
        const res = await window.storage.get("erp:_test_stockage", true);
        setStorageOk(!!res && res.value === valeurTest);
      } catch (e) {
        setStorageOk(false);
        console.error("Test de stockage échoué", e);
      }
    })();
  }, []);

  // Temps 1, étape c (Nils 15/10) : données sur le serveur. Écriture refusée parce qu'un
  // collègue a enregistré entre-temps, ou serveur injoignable : message, puis rechargement
  // (pour ne jamais laisser croire qu'une modification non enregistrée l'a été).
  useEffect(() => {
    let dejaAffiche = false;
    async function prevenir(message) {
      if (dejaAffiche) return;
      dejaAffiche = true;
      await demander(message, { info: true });
      window.location.reload();
    }
    const surConflit = () => prevenir("Un collègue vient de modifier ces données. Elles vont être rechargées : refais ta dernière modification.");
    const surErreur = () => prevenir("Le serveur de l'ERP ne répond pas : ta dernière modification n'a pas été enregistrée. La page va être rechargée.");
    // Étape d : session expirée (12 h sans activité) ou compte désactivé.
    const surSession = () => prevenir("Ta connexion a expiré (12 h sans activité) ou ton compte a été désactivé. Reconnecte-toi.");
    // Étape e : modification refusée par le serveur (droits du profil).
    const surRefus = (e) => prevenir(`${(e.detail && e.detail.message) || "Modification refusée."} Elle n'a pas été enregistrée ; la page va être rechargée.`);
    window.addEventListener("erp:stockage-conflit", surConflit);
    window.addEventListener("erp:stockage-erreur", surErreur);
    window.addEventListener("erp:session-expiree", surSession);
    window.addEventListener("erp:stockage-refus", surRefus);
    return () => {
      window.removeEventListener("erp:stockage-conflit", surConflit);
      window.removeEventListener("erp:stockage-erreur", surErreur);
      window.removeEventListener("erp:session-expiree", surSession);
      window.removeEventListener("erp:stockage-refus", surRefus);
    };
  }, []);

  // Nils 30/10 : page d'accueil = « Alertes & tâches » pour tout le monde.
  const [activeTab, setActiveTab] = useState("alertes");
  // Nils 20/10 (a à d) : actualisation de ce que les collègues ont enregistré — au changement d'onglet,
  // au retour sur la page et toutes les 2 minutes. Seules les données modifiées sont relues (les
  // chargements ci-dessous se relancent, le reste vient de la mémoire du poste), et jamais pendant une
  // saisie : fenêtre ouverte ou champ en cours de frappe.
  const [rechargement, setRechargement] = useState(0);
  const chargementsRef = useRef(0);
  const actualisationRef = useRef(false);
  function debutUnChargement() {
    chargementsRef.current += 1;
  }
  function finUnChargement() {
    chargementsRef.current = Math.max(0, chargementsRef.current - 1);
    if (chargementsRef.current === 0 && actualisationRef.current) {
      actualisationRef.current = false;
      if (window.storage.finActualisation) window.storage.finActualisation();
    }
  }
  function saisieEnCours() {
    if (document.querySelector("[data-fenetre]")) return true;
    const a = document.activeElement;
    return !!a && ["INPUT", "TEXTAREA", "SELECT"].includes(a.tagName);
  }
  async function actualiserDonnees() {
    if (loading || actualisationRef.current || chargementsRef.current > 0 || !window.storage.clesChangees || saisieEnCours()) return;
    const cles = await window.storage.clesChangees();
    if (!cles || !cles.length || actualisationRef.current || chargementsRef.current > 0 || saisieEnCours()) return;
    actualisationRef.current = true;
    window.storage.debutActualisation(cles);
    setRechargement((n) => n + 1);
  }
  const actualiserRef = useRef(actualiserDonnees);
  actualiserRef.current = actualiserDonnees;
  const ongletPrecedentRef = useRef(activeTab);
  useEffect(() => {
    if (ongletPrecedentRef.current === activeTab) return;
    ongletPrecedentRef.current = activeTab;
    actualiserRef.current();
  }, [activeTab]);
  useEffect(() => {
    const surRetour = () => {
      if (document.visibilityState === "visible") actualiserRef.current();
    };
    document.addEventListener("visibilitychange", surRetour);
    const minuteur = setInterval(surRetour, 120000);
    // Nils 28/10 : un enregistrement vient d'être fusionné avec celui d'un collègue → l'écran relit
    // la clé dès que possible (pas pendant une saisie), pour afficher aussi ses changements.
    const surFusion = () => setTimeout(() => actualiserRef.current(), 300);
    window.addEventListener("erp:stockage-fusion", surFusion);
    return () => {
      document.removeEventListener("visibilitychange", surRetour);
      window.removeEventListener("erp:stockage-fusion", surFusion);
      clearInterval(minuteur);
    };
  }, []);
  // Étape d : le compte vient de la connexion (« Je suis » a disparu).
  const [currentUser] = useState(compteConnecte ? compteConnecte.id : DEFAULT_COMPTES.find((c) => c.profil === P_GERANT).id);
  const [acces, setAcces] = useState(null); // { profils, comptes } — Paramétrage › Profils d'accès
  const [compteEdit, setCompteEdit] = useState(null);
  const [nouveauCompte, setNouveauCompte] = useState({ nom: "", profil: P_ADV_JR });
  // Message de blocage affiché dans l'app (les alertes natives sont bloquées ici)
  const [notice, setNotice] = useState("");
  // Fenêtre de confirmation propre à l'ERP : window.confirm / window.prompt sont
  // bloqués dans la page publiée (ils renvoient « non » sans rien afficher).
  // demander(message) -> Promise<boolean> ; demander(message, { saisie: true }) -> Promise<string|null>.
  const [dialogue, setDialogue] = useState(null);
  function demander(message, opts) {
    // Les fenêtres natives (alert / confirm / prompt) sont bloquées dans l'artefact : toujours passer par ici.
    // opts.valeur : texte pré-rempli (saisie) ; opts.info : simple message avec un seul bouton « OK ».
    return new Promise((resolve) => setDialogue({ message, saisie: !!(opts && opts.saisie), valeur: (opts && opts.valeur) || "", danger: !!(opts && opts.danger), info: !!(opts && opts.info), resolve }));
  }
  function fermerDialogue(ok) {
    const d = dialogue;
    if (!d) return;
    setDialogue(null);
    d.resolve(d.saisie ? (ok ? d.valeur : null) : !!ok);
  }

  const [paiements, setPaiements] = useState(null);
  const [showPaiementManager, setShowPaiementManager] = useState(false);
  const [newPaiement, setNewPaiement] = useState("");
  const [newPaiementVerifierAvantBL, setNewPaiementVerifierAvantBL] = useState(false);
  const [paiementError, setPaiementError] = useState("");
  const [paiementSuccess, setPaiementSuccess] = useState("");

  const [showFourFiche, setShowFourFiche] = useState(false);
  const [fourEditing, setFourEditing] = useState(null);
  const [fourError, setFourError] = useState("");
  const [fourQuery, setFourQuery] = useState("");

  // ERP step 7 (pt.7) : demandes de création fournisseur
  // Step 12 pt.6 (accord Nils du 21/09) : la demande utilise désormais le
  // formulaire complet (fourEditing/showFourFiche) — fourEstDemande indique
  // si la fiche ouverte doit être enregistrée comme demande en attente
  // plutôt que comme fournisseur réel.
  const [demandesFournisseurs, setDemandesFournisseurs] = useState(null);
  const [demandesSousCat, setDemandesSousCat] = useState(null);
  const [demandeSousCat, setDemandeSousCat] = useState(null); // brouillon de la fenêtre de demande
  const [demandeSousCatEnCours, setDemandeSousCatEnCours] = useState(null); // id de la demande en cours de conversion
  const [fourEstDemande, setFourEstDemande] = useState(false);
  const [demandeFourEnCours, setDemandeFourEnCours] = useState(null);

  const [mouvements, setMouvements] = useState(null);

  // Bon de production (PL) : consomme plusieurs lots + génère des chutes
  const [showPL, setShowPL] = useState(false);
  const [showAnnulerPL, setShowAnnulerPL] = useState(false);
  const [annulPLChoix, setAnnulPLChoix] = useState(null);
  const [ajustementPL, setAjustementPL] = useState("");
  const [ajustementLot, setAjustementLot] = useState(null);
  const [ajustementNouvelleQte, setAjustementNouvelleQte] = useState("");
  const [ajustementRaison, setAjustementRaison] = useState("");
  const [ajustementError, setAjustementError] = useState("");
  const [showRegistreCredit, setShowRegistreCredit] = useState(false);
  const [confirmationAnnulerBDC, setConfirmationAnnulerBDC] = useState(null); // la commande à annuler, si confirmation en attente
  const [confirmationSupprimerDevis, setConfirmationSupprimerDevis] = useState(null);
  const [popupEtage, setPopupEtage] = useState(false); // ERP step 10 : alerte étage manquant avant BDC
  const [popupEtageValeur, setPopupEtageValeur] = useState(""); // ERP step 10 : le devis à supprimer, si confirmation en attente
  const [showConsommation, setShowConsommation] = useState(false);
  const [choixEnregPL, setChoixEnregPL] = useState(false);
  const [plFicheConso, setPlFicheConso] = useState(""); // Nils 08/10 (f) : choix du type d'enregistrement
  const [consommationDate, setConsommationDate] = useState("");
  const [consommationLignes, setConsommationLignes] = useState([]);
  const [consommationError, setConsommationError] = useState("");
  // Step 13 (retour Nils du 21/09) : rattachement facultatif à un PL.
  const [consommationPL, setConsommationPL] = useState("");
  // ERP step 10 pt.4 : motif obligatoire pour une consommation "Atelier (hors dossier)".
  const [consommationMotif, setConsommationMotif] = useState("");
  // ERP step 11 (accord Nils du 29/09) : type de consommation choisi à chaque
  // saisie — "production" (atelier) ou "pose" (chantier).
  const [consommationUsage, setConsommationUsage] = useState("");
  // ERP step 11 (accord Nils du 29/09) : Nils peut rouvrir l'en-tête d'un
  // devis déjà transformé en dossier (id du devis déverrouillé, sinon null).
  const [enteteNilsDevisId, setEnteteNilsDevisId] = useState(null);
  const [enteteDossierModal, setEnteteDossierModal] = useState(null);
  // ERP step 11 : saisie des liens « documents importants » (clé -> texte).
  const [liensDocsSaisis, setLiensDocsSaisis] = useState({});
  const [validationDessinSaisie, setValidationDessinSaisie] = useState({}); // ERP step 16 : { date, moyen, recuPar }
  const [elemTechOuvert, setElemTechOuvert] = useState(false);
  const [elemTechDevisOuvert, setElemTechDevisOuvert] = useState(false);
  const [docLibreSaisi, setDocLibreSaisi] = useState({ label: "", lien: "" });
  const [reportEdit, setReportEdit] = useState(null); // { devisId, jours, note }
  const [delaiRelanceSaisi, setDelaiRelanceSaisi] = useState("");
  // ERP step 11 (point 13) : filtres du Journal d'accès.
  const [confirmViderJournal, setConfirmViderJournal] = useState(false);
  const [journalFiltre, setJournalFiltre] = useState({ utilisateur: "", type: "", du: "", au: "", q: "", sansConnexions: false, doc: "", sansDetail: false });
  // ERP step 11 : rappel non bloquant des éléments techniques au passage en PL.
  const [rappelTechnique, setRappelTechnique] = useState(null);
  const [plDoc, setPlDoc] = useState("");
  const [plDate, setPlDate] = useState("");
  const [plClient, setPlClient] = useState("");
  const [plConsos, setPlConsos] = useState([]); // { id, lotId, quantite }
  const [plChutes, setPlChutes] = useState([]); // { id, produitId, dimensions, epaisseur, quantite }
  const [plError, setPlError] = useState("");

  const [showHistory, setShowHistory] = useState(false);
  const [historyItem, setHistoryItem] = useState(null);

  const [reservations, setReservations] = useState(null);
  const [creditsTranches, setCreditsTranches] = useState(null);
  const [creditsHistorique, setCreditsHistorique] = useState(null);
  // Ajout manuel d'un crédit dans le registre — réservé à Nils (Step 9).
  const [showAjoutCreditManuel, setShowAjoutCreditManuel] = useState(false);
  const [creditManuelForm, setCreditManuelForm] = useState(null);
  const [creditManuelError, setCreditManuelError] = useState("");
  const [journalAcces, setJournalAcces] = useState(null);
  const [alertes, setAlertes] = useState(null);
  const alertesRef = useRef(null);
  // Référence tenue à jour par persistAlertes (et au chargement) seulement : la
  // recopier à chaque rendu pouvait écraser une alerte ajoutée entre deux rendus
  // (deux alertes successives → une perdue ; bug trouvé le 30/09).
  if (alertesRef.current === null && alertes !== null) alertesRef.current = alertes;
  // Journal : référence toujours à jour, pour que deux traces successives
  // ne s'écrasent pas (bug corrigé le 29/09).
  const journalRef = useRef(null);
  journalRef.current = journalAcces;
  const utilisateurRef = useRef(null);
  const [alertesFiltre, setAlertesFiltre] = useState("nonvues");
  const [parametres, setParametres] = useState(null);
  const [campagnesInventaire, setCampagnesInventaire] = useState(null);
  const [enService, setEnService] = useState(null);
  const [plansRecuperes, setPlansRecuperes] = useState(null);
  const [planRecupEdit, setPlanRecupEdit] = useState(null);
  const [planRecoupe, setPlanRecoupe] = useState(null);
  const [planHorsAtelier, setPlanHorsAtelier] = useState(null);
  const [depotPlan, setDepotPlan] = useState("");
  const [plansFiltre, setPlansFiltre] = useState("stock");
  const [plansRecherche, setPlansRecherche] = useState("");
  const [communications, setCommunications] = useState(null);
  const [lecturesCom, setLecturesCom] = useState(null);
  const [comEdit, setComEdit] = useState(null);
  const [comLecteursOuverts, setComLecteursOuverts] = useState("");
  const [comRetiresVisibles, setComRetiresVisibles] = useState(false);
  const [depotCom, setDepotCom] = useState(false);
  const [incidents, setIncidents] = useState(null);
  const [incidentEdit, setIncidentEdit] = useState(null);
  const [depotIncident, setDepotIncident] = useState(false);
  const [lotsArchives, setLotsArchives] = useState(null);
  // ERP step 12 : les personnes vivent dans Staff ; erp:affectations ne garde
  // que machines et lieux. `affectations` (plus bas) = vue fusionnée.
  const [affectationsBrutes, setAffectations] = useState(null);
  const [staff, setStaff] = useState(null);
  const [staffAMigrer, setStaffAMigrer] = useState(false);
  const migrationStaffRef = useRef(false);
  const derniersStaffRef = useRef({});
  const [filtreStaff, setFiltreStaff] = useState({ q: "", service: "", contrat: "", statut: "actifs", role: "" });
  const [staffEdit, setStaffEdit] = useState(null);
  const [confirmSupprStaff, setConfirmSupprStaff] = useState(false);
  const [showTypesContrat, setShowTypesContrat] = useState(false);
  const [nouveauTypeContrat, setNouveauTypeContrat] = useState("");
  const [typeContratEdition, setTypeContratEdition] = useState(null); // { ancien, valeur }
  const [suiviMensuel, setSuiviMensuel] = useState(null);
  const [signalements, setSignalements] = useState(null);
  const [vueStaff, setVueStaff] = useState("fiches"); // fiches | mensuel | signalements | evaluations
  const [ongletFicheStaff, setOngletFicheStaff] = useState("identite");
  const [moisSaisie, setMoisSaisie] = useState(() => moisDecale(new Date().toISOString().slice(0, 7), -1));
  const [saisieMensuelle, setSaisieMensuelle] = useState({}); // staffId -> { cle: valeur, note }
  const [salaireSaisie, setSalaireSaisie] = useState({ dateEffet: "", net: "", brut: "", motif: "", type: "" });
  const [importStaff, setImportStaff] = useState(null); // aperçu de l'import Excel
  const [dateFactureChoisie, setDateFactureChoisie] = useState("");
  const dateFactureRef = useRef("");
  const [primeSaisie, setPrimeSaisie] = useState({ date: "", type: "", montant: "", commentaire: "" });
  const [primesGroupees, setPrimesGroupees] = useState({ date: "", type: "", commentaire: "", montants: {} });
  const [nouveauTypePrime, setNouveauTypePrime] = useState("");
  const [primesProductivite, setPrimesProductivite] = useState(null);
  // Comptabilité (trésorerie)
  const [operations, setOperations] = useState(null);
  const [facturesF, setFacturesF] = useState(null);
  const [facturesAnt, setFacturesAnt] = useState(null);
  const [facturesAvance, setFacturesAvance] = useState([]);
  const [remplacements, setRemplacements] = useState([]);
  // ERP step 14 (ai) : coûts de revient (profils d'import) et arrivages import — Nils seul.
  const [coutsRevient, setCoutsRevient] = useState(DEFAULT_COUTS_REVIENT);
  const [commissions, setCommissions] = useState(DEFAULT_COMMISSIONS);
  const [comVersionId, setComVersionId] = useState("");
  const [comMois, setComMois] = useState(() => new Date().toISOString().slice(0, 7));
  const [budgetCMOuvert, setBudgetCMOuvert] = useState(false);
  const [comDetail, setComDetail] = useState("");
  const [paiementCom, setPaiementCom] = useState(null);
  const [deplacements, setDeplacements] = useState([]);
  const [expositions, setExpositions] = useState([]);
  const [avoirs, setAvoirs] = useState([]);
  const [avoirEdit, setAvoirEdit] = useState(null);
  const [rembAvoir, setRembAvoir] = useState(null); // Step 17 (Nils 15/10) : remboursement d'un avoir
  const [flotte, setFlotte] = useState(null); // { vehicules, releves, tickets, carnetsMachines, seuilConsoPct, alertesEnvoyees, init }
  const [vehEdit, setVehEdit] = useState(null);
  const [releveEdit, setReleveEdit] = useState(null);
  const [machineCarnet, setMachineCarnet] = useState(null);
  const [showExpo, setShowExpo] = useState(false);
  const [expoEdit, setExpoEdit] = useState(null);
  const [expoFiltreF, setExpoFiltreF] = useState("");
  const [expoFiltreStatut, setExpoFiltreStatut] = useState("");
  const [expoSel, setExpoSel] = useState([]);
  const [expoDateDemande, setExpoDateDemande] = useState(() => new Date().toISOString().slice(0, 10));
  const [showDeplacements, setShowDeplacements] = useState(false);
  const [deplEdit, setDeplEdit] = useState(null);
  const [deplAvance, setDeplAvance] = useState(null);
  const [deplMois, setDeplMois] = useState(() => new Date().toISOString().slice(0, 7));
  const [margeOuverte, setMargeOuverte] = useState("");
  const [arrivagesImport, setArrivagesImport] = useState([]);
  const [arrivagesLocaux, setArrivagesLocaux] = useState([]);
  const [listeArrivages, setListeArrivages] = useState(null); // { onglet, recherche, annee }
  const [transportIntl, setTransportIntl] = useState(TRANSPORT_INTL_VIDE);
  const [ligneTransportEdit, setLigneTransportEdit] = useState(null);
  const [mesSignalementsOuverts, setMesSignalementsOuverts] = useState(false);
  const [questionOp, setQuestionOp] = useState(null); // Nils 08/10 (i/j) : { opId, mode: question|signal|fil, texte }
  const [profilRevientId, setProfilRevientId] = useState("");
  const [apercuGrille, setApercuGrille] = useState(null);
  const [choixArrivage, setChoixArrivage] = useState(false);
  const [arrivageLots, setArrivageLots] = useState(null);
  const [stockDepart, setStockDepart] = useState(null); // Nils 26/10 : saisie du stock de départ (Gérant)
  const [arrivageEdit, setArrivageEdit] = useState(null);
  const [exportGrille, setExportGrille] = useState(null);
  // Nils 05/10 : « Prix et coûts » en sections repliables (toutes fermées à l'ouverture).
  const [pcOuverts, setPcOuverts] = useState({});
  const [ramadanSaisie, setRamadanSaisie] = useState({ debut: "", fin: "" });
  const [finMoisVue, setFinMoisVue] = useState(null);
  const [congeSpecialSaisie, setCongeSpecialSaisie] = useState({ typeId: "", debut: "", fin: "", note: "" });
  const [affectationsCredit, setAffectationsCredit] = useState([]);
  const [previsions, setPrevisions] = useState([]);
  // ERP step 13 (ah) : rapport commercial.
  const [visites, setVisites] = useState([]);
  const [prospects, setProspects] = useState([]);
  const [rapportsCom, setRapportsCom] = useState([]);
  const [rcVue, setRcVue] = useState("semaine");
  const [rcCom, setRcCom] = useState("");
  const [rcLundi, setRcLundi] = useState("");
  const [rcCommentaireLu, setRcCommentaireLu] = useState("");
  const [rcFiltreProspects, setRcFiltreProspects] = useState({ statut: "actif", com: "" });
  const [visiteEdit, setVisiteEdit] = useState(null);
  const [visiteErreur, setVisiteErreur] = useState("");
  const [prospectEdit, setProspectEdit] = useState(null);
  const [prospectErreur, setProspectErreur] = useState("");
  const [previsionEdit, setPrevisionEdit] = useState(null);
  const [recurrentes, setRecurrentes] = useState([]);
  const [tachesManuelles, setTachesManuelles] = useState([]);
  const [tacheEdit, setTacheEdit] = useState(null);
  const [tacheFaite, setTacheFaite] = useState(null);
  const [bugs, setBugs] = useState([]);
  const [bugEdit, setBugEdit] = useState(null); // signalement en cours
  const [bugsTexte, setBugsTexte] = useState(null); // texte « copier pour Claude » (repli si le presse-papiers est refusé)
  const [notifPersonne, setNotifPersonne] = useState("");
  const [bugsTous, setBugsTous] = useState(false);
  // Nils 04/10 (ad) : marketing et échantillons.
  const [timesheet, setTimesheet] = useState([]);
  const [tsEdit, setTsEdit] = useState(null);
  const [mktPersonne, setMktPersonne] = useState("");
  const [mktMois, setMktMois] = useState("");
  const [mktTauxSaisi, setMktTauxSaisi] = useState({ taux: "", dateEffet: "" });
  const [boosterEdit, setBoosterEdit] = useState(null);
  const [prospectMkt, setProspectMkt] = useState(null);
  const [echantillons, setEchantillons] = useState(ECHANTILLONS_DEPART);
  const [echMouvements, setEchMouvements] = useState([]);
  const [demandesEch, setDemandesEch] = useState([]);
  const [echSuivi, setEchSuivi] = useState({ boites: [], prets: [], delaiControleMois: 6 });
  const [planning, setPlanning] = useState(PLANNING_VIDE);
  const [planLundi, setPlanLundi] = useState(() => lundiDe(new Date().toISOString().slice(0, 10)));
  const [planEdit, setPlanEdit] = useState(null);
  const [planDossierEdit, setPlanDossierEdit] = useState(null); // Nils 13/10 : planifier tout le dossier en une fois
  const [planDossier, setPlanDossier] = useState(null);
  const [planNotifEdit, setPlanNotifEdit] = useState(null);
  const [navReplie, setNavReplie] = useState([]);
  // Nils 03/11 : bloc « Électroménager standard » d'un projet déplié ou non (mémorisé sur ce poste).
  const [electroOuvert, setElectroOuvert] = useState(() => { try { return localStorage.getItem("erp-electro-ouvert") === "1"; } catch (e) { return false; } });
  useEffect(() => {
    try { const v = JSON.parse(localStorage.getItem(`erp-nav-replie:${currentUser}`) || "[]"); setNavReplie(Array.isArray(v) ? v : []); } catch (e) { setNavReplie([]); }
  }, [currentUser]);
  const [echTypeModal, setEchTypeModal] = useState("ech");
  const [matEdit, setMatEdit] = useState(null);
  const [boiteVue, setBoiteVue] = useState(null);
  const [controleBoite, setControleBoite] = useState(null);
  const [stockVue, setStockVue] = useState("stock");
  const [demandeEchEdit, setDemandeEchEdit] = useState(null);
  const [remiseEch, setRemiseEch] = useState(null);
  const [entreeEch, setEntreeEch] = useState(null);
  const [refEchEdit, setRefEchEdit] = useState(null);
  const [echRecherche, setEchRecherche] = useState("");
  const [echRechercheModal, setEchRechercheModal] = useState("");
  const [echVoirHP, setEchVoirHP] = useState(false);
  const [apercuDoc, setApercuDoc] = useState(null);
  const [statsPer, setStatsPer] = useState({ type: "mois" });
  const [inventaireEch, setInventaireEch] = useState(null);
  const [echGamme, setEchGamme] = useState("");
  const [echAvecTranches, setEchAvecTranches] = useState(false);
  const [relierProspect, setRelierProspect] = useState(null);
  const [recurrenteEdit, setRecurrenteEdit] = useState(null);
  const [detailDepensesCaisse, setDetailDepensesCaisse] = useState(null);
  const [affectCredit, setAffectCredit] = useState(null);
  const [pointSaisie, setPointSaisie] = useState({});
  const [signatairesBL, setSignatairesBL] = useState(DEFAULT_SIGNATAIRES_BL);
  const [annulationDoc, setAnnulationDoc] = useState(null);
  const [rempFiche, setRempFiche] = useState(null);
  const [nouveauSignataire, setNouveauSignataire] = useState(null);
  const [antOuvert, setAntOuvert] = useState(false);
  const [antSaisie, setAntSaisie] = useState(null);
  const [etatClientModal, setEtatClientModal] = useState(null); // { clientId, exo, au, avecSoldes }
  const [factFEdit, setFactFEdit] = useState(null);
  const [filtreEcheancier, setFiltreEcheancier] = useState("apayer");
  const [fournisseurEcheancier, setFournisseurEcheancier] = useState("");
  const [rappro, setRappro] = useState(null);
  const [clotureForm, setClotureForm] = useState({}); // compteId|mois -> { reel, explication }
  const [refusCloture, setRefusCloture] = useState(null); // { compteId, mois, motif } // { compteId, du, au, solde } — rapprochement bancaire (Nils 01/10) // apayer | retard | controler | payees | toutes
  const [comptesTreso, setComptesTreso] = useState(null);
  // Nils 28/10 : comptes des autres, reçus par leur seul nom (« nomSeul ») pour le choix du compte qui
  // reçoit un transfert ; gardés hors de comptesTreso (soldes, clôtures, alertes ne les voient pas).
  const comptesNomSeulRef = useRef([]);
  const [compteActif, setCompteActif] = useState("");
  const [moisTreso, setMoisTreso] = useState(() => new Date().toISOString().slice(0, 7));
  const [opEdit, setOpEdit] = useState(null);
  const [transfertEdit, setTransfertEdit] = useState(null);
  const [receptionEdit, setReceptionEdit] = useState(null); // { id, montant, note }
  const [importTreso, setImportTreso] = useState(null);
  const [importsTresoCompte, setImportsTresoCompte] = useState(null); // compte dont on affiche les imports (annulation)
  // Nils 29/10 : échéance récurrente cochée « Réalisée » — relier une sortie de la CFG ({ r, o, cands }).
  const [relierEcheance, setRelierEcheance] = useState(null);
  // Nils 29/10 : facture d'avance d'un projet, antérieure à l'ERP ({ chId, numero, date, ht, rembourseHT }).
  const [avanceAntEdit, setAvanceAntEdit] = useState(null);
  // Nils 30/10 : logements faits avant l'ERP ({ chId, factureAntId, datePose, ids }).
  const [avantErpEdit, setAvantErpEdit] = useState(null);
  // Nils 02/11 : acompte facturé avant l'ERP sur certains logements ({ chId, factureAntId, montants: { logementId: HT }, erreur }).
  const [acompteAntEdit, setAcompteAntEdit] = useState(null);
  // Nils 29/10 : émission de la facture d'avance d'un projet ({ chId, marcheHT, pct, ht, designation, date, exo }).
  const [avanceEmission, setAvanceEmission] = useState(null);
  const [versementPrimes, setVersementPrimes] = useState(null); // versement groupé de primes depuis une caisse (Nils 23/10, e)
  const importTresoRef = useRef(null);
  const importFournisseursRef = useRef(null);
  const [nouveauSousPoste, setNouveauSousPoste] = useState({});
  const [sousPosteEdition, setSousPosteEdition] = useState(null); // { poste, ancien, valeur }
  const [nouveauTiersParam, setNouveauTiersParam] = useState({});
  const [nouveauPoste, setNouveauPoste] = useState({ nom: "", sens: "sortie" });
  const [nouveauTypeTiers, setNouveauTypeTiers] = useState({ libelle: "", sens: "entree" });
  const [gestionCompta, setGestionCompta] = useState(null); // { type: "postes" | "fournisseur" | "etat" | "associe", nom?, ice? }
  // Nils 26/10 : filtres d'une caisse (recherche, poste, sens, période) — oubliés au changement de compte.
  const [filtresCaisse, setFiltresCaisse] = useState(null);
  // Nils 28/10 : recherche d'article dans le devis projet.
  const [rechercheArticleDP, setRechercheArticleDP] = useState("");
  const [filtreTreso, setFiltreTreso] = useState("mois"); // "mois" | "atraiter" | "rapprocher"
  const [rapprochementChoix, setRapprochementChoix] = useState({}); // opId -> id de la contrepartie choisie
  const [exceptionsProductivite, setExceptionsProductivite] = useState({}); // lundi -> { staffId: true/false }
  const [paramsProdSaisis, setParamsProdSaisis] = useState({ target: "", montant: "", partTranchesPct: "" });
  const creationSemaineRef = useRef(false);
  const importStaffRef = useRef(null);
  const [reportSaisi, setReportSaisi] = useState("");
  const [signalementEdit, setSignalementEdit] = useState(null);
  const [filtreSignalements, setFiltreSignalements] = useState("ouverts");
  const [suiviSignalement, setSuiviSignalement] = useState(null); // { id, texte }
  const [evaluationEdit, setEvaluationEdit] = useState(null);
  const [nouveauCritere, setNouveauCritere] = useState("");
  const [pointage, setPointage] = useState(null);
  const [moisPointage, setMoisPointage] = useState(() => moisDecale(new Date().toISOString().slice(0, 7), -1));
  const [celluleEdit, setCelluleEdit] = useState(null); // { staffId, cle, date, code, demi, heures, surConges, note }
  const [nouveauJourSpecial, setNouveauJourSpecial] = useState({ date: "", libelle: "", type: "ferie" });
  const [regimesSaisis, setRegimesSaisis] = useState(null);
  const [soldeHeuresSaisi, setSoldeHeuresSaisi] = useState("");
  const [critereEdition, setCritereEdition] = useState(null); // { cle, valeur }
  const [cartesParamOuvertes, setCartesParamOuvertes] = useState({});
  const [congesSaisis, setCongesSaisis] = useState({ joursParMois: "", bonusParTranche: "", trancheAnnees: "", plafond: "" });
  const [semestreEval, setSemestreEval] = useState(() => semestrePrecedent(semestreDe(new Date().toISOString().slice(0, 10))));
  // Vue fusionnée utilisée partout (mise en service, outillage) : machines et
  // lieux d'erp:affectations + une entrée « personne » par fiche Staff.
  const affectations = useMemo(() => {
    if (affectationsBrutes === null) return null;
    const st = Array.isArray(staff) ? staff : [];
    const ids = new Set(st.map((s) => s.id));
    return [
      ...affectationsBrutes.filter((a) => a.type !== "personne" || !ids.has(a.id)),
      ...st.map((s) => ({
        id: s.id,
        nom: s.nom,
        type: "personne",
        base: s.baseUsure === "pose" ? "pose" : "transformation",
        actif: staffActif(s),
        usure: !!s.usure,
        detenteur: !!s.detenteur,
        dateEmbauche: s.dateEmbauche || "",
        staff: true,
      })),
    ];
  }, [affectationsBrutes, staff]);
  const [savListe, setSavListe] = useState(null);
  const [outils, setOutils] = useState(null);
  const [controlesOutillage, setControlesOutillage] = useState(null);
  const [outilEdit, setOutilEdit] = useState(null);
  const [outilAction, setOutilAction] = useState(null); // { type: "transfert"|"incident"|"retour"|"rebut", ... }
  const [vueOutillage, setVueOutillage] = useState("registre");
  const [familleOutillage, setFamilleOutillage] = useState("outillage");
  const [filtreOutils, setFiltreOutils] = useState({ q: "", detenteur: "", etat: "actifs" });
  const [personneFiche, setPersonneFiche] = useState("");
  const [showCategoriesOutil, setShowCategoriesOutil] = useState(false);
  // Nils 04/10 : bureaux et machines gérés aussi depuis l'outillage ; création rapide depuis « Remis à ».
  const [showDetenteursOutil, setShowDetenteursOutil] = useState(false);
  const [detenteurRapide, setDetenteurRapide] = useState(null);
  const [listeTechEdit, setListeTechEdit] = useState(null); // "eviers" | "plaquesCuisson"
  const [nouvelleRefTech, setNouvelleRefTech] = useState("");
  const [nouveauTypeEvier, setNouveauTypeEvier] = useState("");
  const [nouvelleCategorieOutil, setNouvelleCategorieOutil] = useState("");
  const [categorieOutilEdition, setCategorieOutilEdition] = useState(null); // { ancien, valeur }
  const [savEdit, setSavEdit] = useState(null);
  const [savFiltre, setSavFiltre] = useState("ouverts");
  const [savStats, setSavStats] = useState({ du: "", au: "" });
  const [savLienSaisi, setSavLienSaisi] = useState({ label: "", lien: "" });
  const [nouveauMotifSav, setNouveauMotifSav] = useState("");
  const [delaiSavSaisi, setDelaiSavSaisi] = useState("");
  const [showEnService, setShowEnService] = useState(false);
  const [miseEnService, setMiseEnService] = useState({ produitId: "", lotId: "", quantite: "1", affectationId: "", date: "" });
  const [horsServiceEdit, setHorsServiceEdit] = useState(null); // { id, date, motif }
  const [plMachines, setPlMachines] = useState([]);
  const [nouvelleAffectation, setNouvelleAffectation] = useState({ nom: "", type: "machine", base: "transformation" });
  const [seuilUsureSaisi, setSeuilUsureSaisi] = useState("");
  const [showInventaire, setShowInventaire] = useState(null); // null | "valorise" | "campagne"
  const [comptagesSaisis, setComptagesSaisis] = useState({}); // lotId -> valeur saisie (non encore enregistrée)
  const [validationInventaire, setValidationInventaire] = useState(null);
  const [inventaireDate, setInventaireDate] = useState(""); // "" = aujourd'hui // { retenus: {lotId: bool} }
  const [seuilPrixSaisi, setSeuilPrixSaisi] = useState("");
  const [showJournalAcces, setShowJournalAcces] = useState(false);
  const [showReservation, setShowReservation] = useState(false);
  const [reservationItem, setReservationItem] = useState(null);
  const [showReservationCommande, setShowReservationCommande] = useState(false);
  const [reservationCommandeCible, setReservationCommandeCible] = useState(null);
  const [reservationLignes, setReservationLignes] = useState([]);
  const [reservationError, setReservationError] = useState("");
  const [reservationPourLe, setReservationPourLe] = useState(""); // date approximative de pose (Nils 01/10)
  const [reportReservation, setReportReservation] = useState(null); // { commandeId, date, note }
  const [resBc, setResBc] = useState("");
  const [resClientId, setResClientId] = useState("");
  const [resContact, setResContact] = useState("");
  const [resEditingId, setResEditingId] = useState(null);
  const [afficherReservationsLevees, setAfficherReservationsLevees] = useState(false);
  const [resNouveauLotId, setResNouveauLotId] = useState("");
  const [showAffectation, setShowAffectation] = useState(false);
  const [affectationProduit, setAffectationProduit] = useState(null);
  const [affectationChoix, setAffectationChoix] = useState({}); // { [reservationId]: lotId }
  const [resQty, setResQty] = useState("");
  const [resNote, setResNote] = useState("");
  const [resLivraison, setResLivraison] = useState("");
  const [resError, setResError] = useState("");
  // Pré-remplissage transmis depuis un dossier commande (BC + client) — consommé
  // par le prochain openReservation() puis remis à zéro.
  const [pendingReservationPrefill, setPendingReservationPrefill] = useState(null);

  // Un lot = un produit chez un fournisseur, dans une dimension/épaisseur donnée,
  // et pour la céramique une nuance + un choix. Deux nuances = deux lots.
  function normalizeItem(it) {
    // migration : ancienne référence à plat -> lot (le produit est créé à part)
    let dimensions = it.dimensions;
    let epaisseur = it.epaisseur;
    if (dimensions === undefined && it.format) {
      const m = String(it.format).match(/^(.*?)\s*[—-]\s*(\d+\s*mm)$/i);
      if (m) {
        dimensions = m[1].trim();
        epaisseur = m[2].replace(/\s/g, "").toLowerCase();
      } else {
        dimensions = String(it.format);
        epaisseur = "";
      }
    }
    return {
      id: it.id || uid(),
      produitId: it.produitId || "",
      type: it.type || TYPE_TRANCHE,
      fournisseur: it.fournisseur || "",
      dimensions: dimensions || "",
      epaisseur: epaisseur || "",
      nuance: it.nuance || "",
      choix: it.choix || "",
      unite: migrerUnite(it.unite) || "pièce(s)",
      stockReel: Number(it.stockReel !== undefined ? it.stockReel : it.quantite !== undefined ? it.quantite : 0) || 0,
      arrivages: Number(it.arrivages !== undefined ? it.arrivages : 0) || 0,
      // ERP step 11 (bug trouvé le 29/09) : ces deux champs étaient perdus à
      // chaque rechargement de la page (non repris par la normalisation).
      blFournisseur: it.blFournisseur || "",
      // Nils 04/10 (o) : book-match — tranche A ou B (céramique), arrivage prévu A / B, lot d'origine.
      bm: it.bm === "A" || it.bm === "B" ? it.bm : "",
      ...(it.arrivageA !== undefined && it.arrivageA !== "" ? { arrivageA: Number(it.arrivageA) || 0 } : {}),
      ...(it.arrivageB !== undefined && it.arrivageB !== "" ? { arrivageB: Number(it.arrivageB) || 0 } : {}),
      ...(it.lotOrigineId ? { lotOrigineId: it.lotOrigineId } : {}),
      // Nils 01/11 : lot d'origine d'une chute (perdu jusqu'ici au rechargement) et lien avec le
      // registre des plans récupérés.
      ...(it.lotSourceId ? { lotSourceId: it.lotSourceId } : {}),
      ...(it.planRecupereId ? { planRecupereId: it.planRecupereId } : {}),
      ...(it.prixAchatHT !== undefined && it.prixAchatHT !== null && it.prixAchatHT !== "" ? { prixAchatHT: Number(it.prixAchatHT) } : {}),
      // ERP step 14 (ai) : coût de revient — arrivage import, coût standard, transport d'approche, quantité reçue.
      ...(it.arrivageImportId ? { arrivageImportId: it.arrivageImportId } : {}),
      ...(it.coutStandardHT !== undefined && it.coutStandardHT !== null && it.coutStandardHT !== "" ? { coutStandardHT: Number(it.coutStandardHT) } : {}),
      ...(it.transportApprocheHT !== undefined && it.transportApprocheHT !== null && it.transportApprocheHT !== "" ? { transportApprocheHT: Number(it.transportApprocheHT) } : {}),
      ...(it.qteBase !== undefined && it.qteBase !== null && it.qteBase !== "" ? { qteBase: Number(it.qteBase) } : {}),
      _legacyReservation: Number(it.reservation !== undefined ? it.reservation : 0) || 0,
      _legacyDesignation: it.designation || "",
      _legacyCategorie: it.categorie || "",
      _legacySeuil: Number(it.seuil !== undefined ? it.seuil : 0) || 0,
    };
  }

  const [articles, setArticles] = useState(null);
  const [devisListe, setDevisListe] = useState(null);
  const [commandesListe, setCommandesListe] = useState(null);
  const [enAttenteParStatut, setEnAttenteParStatut] = useState(null);
  const [showEnAttenteManager, setShowEnAttenteManager] = useState(false);
  const [newOptionEnAttente, setNewOptionEnAttente] = useState("");
  const [nouvellesOptionsEA, setNouvellesOptionsEA] = useState({});
  const [chantiers, setChantiers] = useState(null);
  const [prixGroupesTranche, setPrixGroupesTranche] = useState(null);
  const [prixGroupesTranche2eChoix, setPrixGroupesTranche2eChoix] = useState(null);
  const [categoriesArticles, setCategoriesArticles] = useState(null);
  const [unitesArticles, setUnitesArticles] = useState(null);
  const [finitionsArticles, setFinitionsArticles] = useState(null);
  const [groupesCouleurArticles, setGroupesCouleurArticles] = useState(null);
  const [apporteursAffaire, setApporteursAffaire] = useState(null);
  const [poseurs, setPoseurs] = useState(null);
  const [renfortFP, setRenfortFP] = useState({ nom: "", role: "aidesPoseurs" }); // Step 17 (Nils 14/10) : renfort exceptionnel sur une fiche de pose

  // Liste des devis : filtres
  const [devisQuery, setDevisQuery] = useState("");
  const [filterStatut, setFilterStatut] = useState("Tous");

  // Devis ouvert (fiche détail / édition). null = on est sur la liste.
  const [openId, setOpenId] = useState(null);
  const [draft, setDraft] = useState(null); // copie de travail du devis ouvert
  const [draftError, setDraftError] = useState("");

  // Ajout de ligne
  const [ligneQuery, setLigneQuery] = useState("");
  const [ligneFiltreCat, setLigneFiltreCat] = useState("Toutes");
  // Nils 01/10 : la liste des articles ne s'ouvre qu'au clic (et se ferme après un ajout ou un clic ailleurs).
  const [listeArticlesOuverte, setListeArticlesOuverte] = useState(false);
  const zoneArticlesRef = useRef(null);
  useEffect(() => {
    if (!listeArticlesOuverte) return undefined;
    const fermer = (e) => { if (zoneArticlesRef.current && !zoneArticlesRef.current.contains(e.target)) setListeArticlesOuverte(false); };
    const echap = (e) => { if (e.key === "Escape") setListeArticlesOuverte(false); };
    document.addEventListener("mousedown", fermer);
    document.addEventListener("keydown", echap);
    return () => { document.removeEventListener("mousedown", fermer); document.removeEventListener("keydown", echap); };
  }, [listeArticlesOuverte]);
  // Zone d'ajout dédiée aux descriptifs — indépendante de celle des éléments
  // facturés ci-dessus : la liste s'ouvre entière au focus et se filtre à la frappe.
  const [descriptifQuery, setDescriptifQuery] = useState("");
  const [descriptifDropdownOpen, setDescriptifDropdownOpen] = useState(false);

  // ---------- Commandes ----------
  const [commandeFiltreStatut, setCommandeFiltreStatut] = useState("Toutes");
  // Nils 02/11 : gratuité (archivage d'un dossier au PL / BL sans contrepartie) — formulaire en cours.
  const [gratuiteForm, setGratuiteForm] = useState(null);
  // Nils 02/11 : recherche libre dans les dossiers (n°, client, projet, référence, couleur / article).
  const [commandeRecherche, setCommandeRecherche] = useState("");
  const [commandeEditing, setCommandeEditing] = useState(null);
  const [showCommandeFiche, setShowCommandeFiche] = useState(false);
  const [commandeFicheMessage, setCommandeFicheMessage] = useState("");
  // Sous-formulaires de la fiche dossier (ERP step 7) : chacun s'ouvre dans
  // sa propre fenêtre plutôt que d'être affiché en permanence dans la fiche.
  const [showModifierLignesModal, setShowModifierLignesModal] = useState(false);
  const [showElementsTechniquesModal, setShowElementsTechniquesModal] = useState(false);
  const [showFichePoseModal, setShowFichePoseModal] = useState(false);
  // Nils 17/10 : facture groupée en préparation { chantierId, ids, date, erreur }.
  const [factGroupe, setFactGroupe] = useState(null);
  // Étape g : dépôt d'un fichier en cours (clé du document concerné, ou "libre").
  const [depotEnCours, setDepotEnCours] = useState("");
  // Étape g (Nils 17/10, l) : fichiers retirés depuis moins de 30 jours (Paramétrage, Gérant).
  const [fichiersRetires, setFichiersRetires] = useState(null);
  // Étape h : état des numéros de départ des séries (Paramétrage, Gérant).
  const [departsSeries, setDepartsSeries] = useState(null);
  // Confirmation obligatoire avant une transformation irréversible (BL, Facture)
  const [confirmationTransformation, setConfirmationTransformation] = useState(null); // { label, action }
  const [confirmationVerifPaiement, setConfirmationVerifPaiement] = useState(false);
  // ERP step 8 : la ligne libre n'existe plus que dans la partie descriptive
  // (texte sans prix ni quantité) — plus de ligne libre facturée, pour
  // qu'un montant ne puisse plus jamais être ajouté à un devis/BC sans
  // passer par un article du Catalogue (accord du 21/09 avec Nils, valable
  // sur tous les devis, exonérés ou non).
  const [showLigneLibre, setShowLigneLibre] = useState(false);
  const [ligneLibreForm, setLigneLibreForm] = useState({ designation: "" });

  const [showCategorieManager, setShowCategorieManager] = useState(false);
  const [newCategorie, setNewCategorie] = useState("");
  const [showUniteManager, setShowUniteManager] = useState(false);
  const [newUnite, setNewUnite] = useState("");
  const [showFinitionManager, setShowFinitionManager] = useState(false);
  const [matieresPerso, setMatieresPerso] = useState([]);
  const [showMatiereManager, setShowMatiereManager] = useState(false);
  const [nouvelleMatiere, setNouvelleMatiere] = useState({ nom: "", lettre: "", libelle: "", epaisseurs: [], autre: "", mode: "couleur" });
  const [matiereError, setMatiereError] = useState("");
  const [newFinition, setNewFinition] = useState("");
  const [newFinitionLettre, setNewFinitionLettre] = useState("");
  const [lettresFinitionsSaisies, setLettresFinitionsSaisies] = useState({}); // nom -> lettre en cours de saisie
  const [finitionError, setFinitionError] = useState("");
  const [showGroupeCouleurManager, setShowGroupeCouleurManager] = useState(false);
  const [newGroupeCouleur, setNewGroupeCouleur] = useState("");
  const [showApporteurManager, setShowApporteurManager] = useState(false);
  const [newApporteur, setNewApporteur] = useState("");
  const [apporteurEdition, setApporteurEdition] = useState(null); // { ancien, valeur } | null

  // Nouveau chantier depuis la fiche devis
  // ERP step 16 (lot 2) : onglet Projets immo.
  const [projetOuvert, setProjetOuvert] = useState(null); // id du projet affiché
  const [projetEdit, setProjetEdit] = useState(null); // formulaire création / modification
  const [projetsFiltre, setProjetsFiltre] = useState({ statut: "en cours", client: "", q: "" });
  const [devisProjetEdit, setDevisProjetEdit] = useState(null); // ERP step 16 (lot 3) : version en cours de saisie (Nils)
  const [devisProjetVue, setDevisProjetVue] = useState({}); // { [projetId]: id de version affichée }
  const [logementSaisie, setLogementSaisie] = useState(null); // ERP step 16 (lot 4a) : { projetId, mode: "un" | "serie", ... }

  // Catalogue d'articles
  const [catQuery, setCatQuery] = useState("");
  const [catalogueFiltreCat, setCatalogueFiltreCat] = useState("Toutes");
  const [catalogueFiltreExo, setCatalogueFiltreExo] = useState("Tous"); // "Tous" | "Exo" | "Non exo"
  const [catalogueFiltreNature, setCatalogueFiltreNature] = useState("Toutes");
  const [catFiltresTranche, setCatFiltresTranche] = useState({}); // Nils 14/10 (k) : filtres des tranches, comme dans le Stock // ERP step 16 : "Toutes" | cle | "aucune" | "averifier"
  const [showArticleForm, setShowArticleForm] = useState(false);
  const [articleEditing, setArticleEditing] = useState(null);
  const [articleCopieDe, setArticleCopieDe] = useState(""); // Nils 20/10 : désignation de l'article copié (titre du formulaire)
  const [articleFormError, setArticleFormError] = useState("");

  useEffect(() => {
    (async () => {
      debutUnChargement();
      try {
      let normalized = null;
      let loadedBrut = null;
      try {
        const res = await window.storage.get(STORAGE_KEY, true);
        const loaded = res && res.value ? JSON.parse(res.value) : SEED;
        loadedBrut = loaded;
        normalized = loaded.map(normalizeItem);
      } catch (e) {
        normalized = SEED.map(normalizeItem);
      }
      try {
        const resCat = await window.storage.get(CATEGORIES_KEY, true);
        const rawCats = resCat && resCat.value ? JSON.parse(resCat.value) : DEFAULT_CATEGORIES;
        const normCats = rawCats.map((c) => {
          // Catégories enregistrées avant l'ajout du réglage des nuances :
          // on retombe sur la valeur par défaut du même nom plutôt que sur false,
          // sinon la céramique perdrait ses nuances en silence.
          const defaut = DEFAULT_CATEGORIES.find((d) => d.name === c.name);
          const unite = migrerUnite(c.unite) || "pièce(s)";
          // Mode de gestion : explicite si déjà là ; sinon on le déduit —
          // valeur par défaut du même nom, ou à partir de l'unité (tranche => tranche).
          let gestion = c.gestion;
          if (gestion !== GESTION_TRANCHE && gestion !== GESTION_PIECE) {
            if (defaut) gestion = defaut.gestion;
            else gestion = /tranche|m²/.test(unite) ? GESTION_TRANCHE : GESTION_PIECE;
          }
          return {
            name: c.name,
            unite,
            gestion,
            // La nuance n'a de sens qu'en gestion tranche.
            nuances: gestion === GESTION_TRANCHE ? (c.nuances !== undefined ? !!c.nuances : defaut ? defaut.nuances : false) : false,
          };
        });
        setCategories(normCats);
        if (JSON.stringify(normCats) !== JSON.stringify(rawCats)) {
          await window.storage.set(CATEGORIES_KEY, JSON.stringify(normCats), true);
        }
      } catch (e) {
        setCategories(DEFAULT_CATEGORIES);
      }
      try {
        const resUniteCat = await window.storage.get(UNITES_CATEGORIE_KEY, true);
        setUnitesCategorie(resUniteCat && resUniteCat.value ? JSON.parse(resUniteCat.value) : DEFAULT_UNITES_CATEGORIE);
        if (!resUniteCat || !resUniteCat.value) await window.storage.set(UNITES_CATEGORIE_KEY, JSON.stringify(DEFAULT_UNITES_CATEGORIE), true);
      } catch (e) {
        setUnitesCategorie(DEFAULT_UNITES_CATEGORIE);
      }
      try {
        const resFour = await window.storage.get(FOURNISSEURS_KEY, true);
        const rawFour = resFour && resFour.value ? JSON.parse(resFour.value) : DEFAULT_FOURNISSEURS;
        // migration : ancien format = tableau de chaînes
        const normFour = rawFour.map((f) =>
          typeof f === "string"
            ? { id: uid(), nom: f, origine: "Maroc", fiabilite: "bonne", contacts: [], ice: "", paiement: "", certifFourni: false, certifDate: "", notes: "" }
            : {
                // Bug corrigé 03/10 : les autres champs (convention de paiement, ICE…) étaient perdus à chaque chargement.
                ...f,
                id: f.id || uid(),
                nom: f.nom || "",
                origine: f.origine || "Maroc",
                fiabilite: f.fiabilite || "bonne",
                contacts: Array.isArray(f.contacts) ? f.contacts : [],
                ice: f.ice || "",
                paiement: f.paiement || "",
                certifFourni: !!f.certifFourni,
                certifDate: f.certifDate || "",
                notes: f.notes || "",
              }
        );
        setFournisseurs(normFour);
        if (JSON.stringify(normFour) !== JSON.stringify(rawFour)) {
          await window.storage.set(FOURNISSEURS_KEY, JSON.stringify(normFour), true);
        }
      } catch (e) {
        setFournisseurs(DEFAULT_FOURNISSEURS);
      }
      try {
        const resDemSC = await window.storage.get(DEMANDES_SOUSCAT_KEY, true);
        setDemandesSousCat(resDemSC && resDemSC.value ? JSON.parse(resDemSC.value) : []);
      } catch (e) {
        setDemandesSousCat([]);
      }
      try {
        const resDemFour = await window.storage.get(DEMANDES_FOURNISSEURS_KEY, true);
        setDemandesFournisseurs(resDemFour && resDemFour.value ? JSON.parse(resDemFour.value) : []);
        if (!resDemFour || !resDemFour.value) await window.storage.set(DEMANDES_FOURNISSEURS_KEY, JSON.stringify([]), true);
      } catch (e) {
        setDemandesFournisseurs([]);
      }
      try {
        const resMov = await window.storage.get(MOUVEMENTS_KEY, true);
        setMouvements(resMov && resMov.value ? JSON.parse(resMov.value) : []);
        if (!resMov || !resMov.value) await window.storage.set(MOUVEMENTS_KEY, JSON.stringify([]), true);
      } catch (e) {
        setMouvements([]);
      }
      try {
        const resPai = await window.storage.get(PAIEMENTS_KEY, true);
        const rawPai = resPai && resPai.value ? JSON.parse(resPai.value) : DEFAULT_PAIEMENTS;
        // Migration : l'ancien format était une simple liste de textes.
        const normPai = rawPai.map((p) => (typeof p === "string" ? { label: p, verifierAvantBL: false } : p));
        setPaiements(normPai);
        if (JSON.stringify(normPai) !== JSON.stringify(rawPai)) {
          await window.storage.set(PAIEMENTS_KEY, JSON.stringify(normPai), true);
        }
      } catch (e) {
        setPaiements(DEFAULT_PAIEMENTS);
      }

      try {
        const resDim = await window.storage.get(DIMENSIONS_KEY, true);
        setDimensionsList(resDim && resDim.value ? JSON.parse(resDim.value) : DEFAULT_DIMENSIONS);
        if (!resDim || !resDim.value) await window.storage.set(DIMENSIONS_KEY, JSON.stringify(DEFAULT_DIMENSIONS), true);
      } catch (e) {
        setDimensionsList(DEFAULT_DIMENSIONS);
      }
      try {
        const resEp = await window.storage.get(EPAISSEURS_KEY, true);
        setEpaisseursList(resEp && resEp.value ? JSON.parse(resEp.value) : DEFAULT_EPAISSEURS);
        if (!resEp || !resEp.value) await window.storage.set(EPAISSEURS_KEY, JSON.stringify(DEFAULT_EPAISSEURS), true);
      } catch (e) {
        setEpaisseursList(DEFAULT_EPAISSEURS);
      }

      try {
        const resCli = await window.storage.get(CLIENTS_KEY, true);
        const rawCli = resCli && resCli.value ? JSON.parse(resCli.value) : DEFAULT_CLIENTS;
        // Nils 28/10 : même normalisation que le serveur (shared/clients.js).
        setClients(rawCli.map((c) => normaliserClient(c, uid)));
      } catch (e) {
        setClients(DEFAULT_CLIENTS);
      }

      // Produits : chargement, ou reconstruction depuis les anciennes références à plat
      let loadedProduits = null;
      try {
        const resProd = await window.storage.get(PRODUITS_KEY, true);
        loadedProduits = resProd && resProd.value ? JSON.parse(resProd.value) : null;
      } catch (e) {
        loadedProduits = null;
      }
      if (loadedProduits === null) {
        const aMigrer = (normalized || []).some((it) => !it.produitId && it._legacyDesignation);
        if (aMigrer) {
          // une désignation libre devient un produit ; le lot s'y rattache
          const parNom = new Map();
          (normalized || []).forEach((it) => {
            const nom = it._legacyDesignation.trim();
            if (!nom) return;
            const cle = nom.toLowerCase();
            if (!parNom.has(cle)) {
              parNom.set(cle, {
                id: uid(),
                nom,
                categorie: it._legacyCategorie,
                seuil: it._legacySeuil,
                correspondances: it.fournisseur ? [{ fournisseur: it.fournisseur, nomFournisseur: nom }] : [],
              });
            }
            it.produitId = parNom.get(cle).id;
          });
          loadedProduits = Array.from(parNom.values());
        } else {
          loadedProduits = SEED_PRODUITS;
        }
        try {
          await window.storage.set(PRODUITS_KEY, JSON.stringify(loadedProduits), true);
        } catch (e) {}
      }
      setProduits(loadedProduits);

      // Réservations : chargement + migration one-shot des anciennes valeurs figées
      let loadedReservations = null;
      try {
        const resRes = await window.storage.get(RESERVATIONS_KEY, true);
        loadedReservations = resRes && resRes.value ? JSON.parse(resRes.value) : null;
      } catch (e) {
        loadedReservations = null;
      }
      if (loadedReservations === null) {
        // première initialisation : convertir les réservations héritées en lignes rattachées à un BC "existant"
        const migrated = [];
        (normalized || []).forEach((it) => {
          if (it._legacyReservation > 0) {
            migrated.push({
              id: uid(),
              itemId: it.id,
              bc: "(à renseigner)",
              client: "Réservation existante",
              quantite: it._legacyReservation,
              note: "Migrée depuis l'ancien format",
              statut: "active",
              creeLe: new Date().toISOString(),
            });
          }
        });
        const initial = migrated.length > 0 ? migrated : SEED_RESERVATIONS;
        loadedReservations = initial;
        try {
          await window.storage.set(RESERVATIONS_KEY, JSON.stringify(initial), true);
        } catch (e) {}
      }
      setReservations(loadedReservations);

      try {
        const resCredits = await window.storage.get(CREDITS_TRANCHES_KEY, true);
        if (resCredits && resCredits.value) {
          setCreditsTranches(JSON.parse(resCredits.value));
        } else {
          setCreditsTranches([]);
          await window.storage.set(CREDITS_TRANCHES_KEY, JSON.stringify([]), true);
        }
      } catch (e) {
        setCreditsTranches([]);
      }

      try {
        const resCreditsHistorique = await window.storage.get(CREDITS_HISTORIQUE_KEY, true);
        if (resCreditsHistorique && resCreditsHistorique.value) {
          setCreditsHistorique(JSON.parse(resCreditsHistorique.value));
        } else {
          setCreditsHistorique([]);
          await window.storage.set(CREDITS_HISTORIQUE_KEY, JSON.stringify([]), true);
        }
      } catch (e) {
        setCreditsHistorique([]);
      }

      try {
        const resLA = await window.storage.get(LOTS_ARCHIVES_KEY, true);
        setLotsArchives(resLA && resLA.value ? JSON.parse(resLA.value) : []);
      } catch (e) {
        setLotsArchives([]);
      }
      try {
        const resES = await window.storage.get(EN_SERVICE_KEY, true);
        setEnService(resES && resES.value ? JSON.parse(resES.value) : []);
      } catch (e) {
        setEnService([]);
      }
      try {
        const resCom = await window.storage.get(COMMUNICATIONS_KEY, true);
        setCommunications(resCom && resCom.value ? JSON.parse(resCom.value) : []);
      } catch (e) {
        setCommunications([]);
      }
      try {
        const resLec = await window.storage.get(LECTURES_COM_KEY, true);
        setLecturesCom(resLec && resLec.value ? JSON.parse(resLec.value) : []);
      } catch (e) {
        setLecturesCom([]);
      }
      try {
        const resInc = await window.storage.get(INCIDENTS_KEY, true);
        setIncidents(resInc && resInc.value ? JSON.parse(resInc.value) : []);
      } catch (e) {
        setIncidents([]);
      }
      try {
        const resPR = await window.storage.get(PLANS_RECUPERES_KEY, true);
        setPlansRecuperes(resPR && resPR.value ? JSON.parse(resPR.value) : []);
      } catch (e) {
        setPlansRecuperes([]);
      }
      try {
        const resAff = await window.storage.get(AFFECTATIONS_KEY, true);
        setAffectations(resAff && resAff.value ? JSON.parse(resAff.value) : []);
      } catch (e) {
        setAffectations([]);
      }
      try {
        const resStaff = await window.storage.get(STAFF_KEY, true);
        if (resStaff && resStaff.value) {
          setStaff((JSON.parse(resStaff.value) || []).map(normaliserFicheStaff));
        } else {
          setStaff([]);
          setStaffAMigrer(true);
        }
      } catch (e) {
        setStaff([]);
      }
      try {
        const resSM = await window.storage.get(SUIVI_MENSUEL_KEY, true);
        setSuiviMensuel(resSM && resSM.value ? JSON.parse(resSM.value) : []);
      } catch (e) {
        setSuiviMensuel([]);
      }
      try {
        const resOp = await window.storage.get(TRESORERIE_KEY, true);
        // Nils 03/10 : les chèques / effets reçus saisis dans une caisse passent au portefeuille (détenteur = responsable de la caisse).
        setOperations(resOp && resOp.value ? JSON.parse(resOp.value).map((o) => (o.sens === "entree" && ["Chèque", "Effet / LCN"].includes(o.mode) && !o.miroirDe && !o.extourneDe && ["caisse-nils", "caisse-bureau", "caisse-usine", "caisse-taha", "caisse-chraa"].includes(o.compteId) && o.type === "normal" ? { ...o, compteId: PORTEFEUILLE_ID, detenteur: o.detenteur || ({ "caisse-nils": "nils", "caisse-bureau": "sawsan", "caisse-usine": "wissam", "caisse-taha": "taha", "caisse-chraa": "chraa" })[o.compteId], ancienCompte: o.compteId } : o)) : []);
        const resFF = await window.storage.get(FACTURES_FOURNISSEURS_KEY, true);
        setFacturesF(resFF && resFF.value ? JSON.parse(resFF.value) : []);
      } catch (e) {
        setOperations([]);
        setFacturesF([]);
      }
      try {
        const resAC = await window.storage.get(ACCES_KEY, true);
        setAcces(resAC && resAC.value ? JSON.parse(resAC.value) : null);
      } catch (e) {
        setAcces(null);
      }
      try {
        const resFA = await window.storage.get(FACTURES_ANTERIEURES_KEY, true);
        setFacturesAnt(resFA && resFA.value ? JSON.parse(resFA.value) : []);
      } catch (e) {
        setFacturesAnt([]);
      }
      try {
        const resFAv = await window.storage.get(FACTURES_AVANCE_KEY, true);
        const l = resFAv && resFAv.value ? JSON.parse(resFAv.value) : [];
        setFacturesAvance(Array.isArray(l) ? l : []);
      } catch (e) {
        setFacturesAvance([]);
      }
      try {
        const resPV = await window.storage.get(PREVISIONS_KEY, true);
        setPrevisions(resPV && resPV.value ? JSON.parse(resPV.value) : []);
      } catch (e) {
        setPrevisions([]);
      }
      for (const [cle, setter] of [[VISITES_KEY, setVisites], [PROSPECTS_KEY, setProspects], [RAPPORTS_COM_KEY, setRapportsCom], [RECURRENTES_KEY, setRecurrentes], [TACHES_MANUELLES_KEY, setTachesManuelles], [BUGS_KEY, setBugs], [MKT_TIMESHEET_KEY, setTimesheet], [ECH_MOUVEMENTS_KEY, setEchMouvements], [DEMANDES_ECH_KEY, setDemandesEch]]) {
        try {
          const res = await window.storage.get(cle, true);
          setter(res && res.value ? JSON.parse(res.value) : []);
        } catch (e) {
          setter([]);
        }
      }
      try {
        const resE = await window.storage.get(ECHANTILLONS_KEY, true);
        setEchantillons(resE && resE.value ? JSON.parse(resE.value) : ECHANTILLONS_DEPART);
      } catch (e) {
        setEchantillons(ECHANTILLONS_DEPART);
      }
      try {
        const resAF = await window.storage.get(AFFECTATIONS_CREDIT_KEY, true);
        setAffectationsCredit(resAF && resAF.value ? JSON.parse(resAF.value) : []);
      } catch (e) {
        setAffectationsCredit([]);
      }
      try {
        const resRP = await window.storage.get(REMPLACEMENTS_KEY, true);
        setRemplacements(resRP && resRP.value ? JSON.parse(resRP.value) : []);
      } catch (e) {
        setRemplacements([]);
      }
      try {
        const resCR = await window.storage.get(COUTS_REVIENT_KEY, true);
        const cr = resCR && resCR.value ? JSON.parse(resCR.value) : null;
        // Nils 02/11 : hors Gérant, le serveur n'envoie que la rubrique transport (zones des déplacements).
        setCoutsRevient(cr && Array.isArray(cr.profils) ? cr : { ...DEFAULT_COUTS_REVIENT, ...(cr && cr.transport ? { transport: cr.transport } : {}) });
      } catch (e) {
        setCoutsRevient(DEFAULT_COUTS_REVIENT);
      }
      try {
        const resDp = await window.storage.get(DEPLACEMENTS_KEY, true);
        setDeplacements(resDp && resDp.value ? JSON.parse(resDp.value) : []);
      } catch (e) {
        setDeplacements([]);
      }
      try {
        const resPl = await window.storage.get(PLANNING_KEY, true);
        const pl = resPl && resPl.value ? JSON.parse(resPl.value) : null;
        setPlanning({ ...PLANNING_VIDE, ...(pl || {}) });
      } catch (e) {
        setPlanning(PLANNING_VIDE);
      }
      try {
        const resSu = await window.storage.get(ECH_SUIVI_KEY, true);
        const su = resSu && resSu.value ? JSON.parse(resSu.value) : null;
        setEchSuivi({ boites: [], prets: [], delaiControleMois: 6, ...(su || {}) });
      } catch (e) {
        setEchSuivi({ boites: [], prets: [], delaiControleMois: 6 });
      }
      try {
        const resVh = await window.storage.get(VEHICULES_KEY, true);
        const vh = resVh && resVh.value ? JSON.parse(resVh.value) : null;
        setFlotte(vh && Array.isArray(vh.vehicules) ? { releves: [], tickets: [], carnetsMachines: {}, alertesEnvoyees: {}, seuilConsoPct: 20, ...vh } : { vehicules: vehiculesDepart(new Date().toISOString().slice(0, 10)), releves: [], tickets: [], carnetsMachines: {}, alertesEnvoyees: {}, seuilConsoPct: 20, init: false });
      } catch (e) {
        setFlotte({ vehicules: vehiculesDepart(new Date().toISOString().slice(0, 10)), releves: [], tickets: [], carnetsMachines: {}, alertesEnvoyees: {}, seuilConsoPct: 20, init: false });
      }
      try {
        const resAv = await window.storage.get(AVOIRS_KEY, true);
        setAvoirs(resAv && resAv.value ? JSON.parse(resAv.value) : []);
      } catch (e) {
        setAvoirs([]);
      }
      try {
        const resEx = await window.storage.get(EXPOSITIONS_KEY, true);
        setExpositions(resEx && resEx.value ? JSON.parse(resEx.value) : []);
      } catch (e) {
        setExpositions([]);
      }
      try {
        const resCo = await window.storage.get(COMMISSIONS_KEY, true);
        const co = resCo && resCo.value ? JSON.parse(resCo.value) : null;
        setCommissions(co && Array.isArray(co.versions) && co.versions.length ? { validations: {}, ...co } : DEFAULT_COMMISSIONS);
      } catch (e) {
        setCommissions(DEFAULT_COMMISSIONS);
      }
      try {
        const resAI = await window.storage.get(ARRIVAGES_IMPORT_KEY, true);
        setArrivagesImport(resAI && resAI.value ? JSON.parse(resAI.value) : []);
      } catch (e) {
        setArrivagesImport([]);
      }
      try {
        const resAL = await window.storage.get(ARRIVAGES_LOCAUX_KEY, true);
        setArrivagesLocaux(resAL && resAL.value ? JSON.parse(resAL.value) : []);
      } catch (e) {
        setArrivagesLocaux([]);
      }
      try {
        const resTI = await window.storage.get(TRANSPORT_INTL_KEY, true);
        setTransportIntl({ ...TRANSPORT_INTL_VIDE, ...(resTI && resTI.value ? JSON.parse(resTI.value) : {}) });
      } catch (e) {
        setTransportIntl(TRANSPORT_INTL_VIDE);
      }
      try {
        const resSB = await window.storage.get(SIGNATAIRES_BL_KEY, true);
        setSignatairesBL(resSB && resSB.value ? JSON.parse(resSB.value) : DEFAULT_SIGNATAIRES_BL);
      } catch (e) {
        setSignatairesBL(DEFAULT_SIGNATAIRES_BL);
      }
      try {
        const resCT = await window.storage.get(COMPTES_TRESORERIE_KEY, true);
        // Nils 30/09 : Sawsan saisit aussi sur la CFG (migration unique des comptes déjà enregistrés).
        setComptesTreso(resCT && resCT.value ? (() => { const tous = JSON.parse(resCT.value); comptesNomSeulRef.current = tous.filter((c) => c && c.nomSeul); const l = tous.filter((c) => !(c && c.nomSeul)).map((c) => (c.id === "banque-cfg" && !c.cfgSawsan ? { ...c, cfgSawsan: true, responsables: [...new Set([...(c.responsables || []), "sawsan"])] } : c)); return [CAISSE_GENERALE_ID, PORTEFEUILLE_ID, "dotation-devises"].reduce((acc, id) => (acc.some((c) => c.id === id) || comptesNomSeulRef.current.some((c) => c.id === id) ? acc : [...acc, DEFAULT_COMPTES_TRESORERIE.find((c) => c.id === id)]), l); })() : DEFAULT_COMPTES_TRESORERIE);
      } catch (e) {
        setComptesTreso(DEFAULT_COMPTES_TRESORERIE);
      }
      try {
        const resPP = await window.storage.get(PRIMES_PRODUCTIVITE_KEY, true);
        setPrimesProductivite(resPP && resPP.value ? JSON.parse(resPP.value) : []);
      } catch (e) {
        setPrimesProductivite([]);
      }
      try {
        const resPt = await window.storage.get(POINTAGE_KEY, true);
        setPointage(resPt && resPt.value ? JSON.parse(resPt.value) : []);
      } catch (e) {
        setPointage([]);
      }
      try {
        const resSig = await window.storage.get(SIGNALEMENTS_KEY, true);
        setSignalements(resSig && resSig.value ? JSON.parse(resSig.value) : []);
      } catch (e) {
        setSignalements([]);
      }
      try {
        const resOut = await window.storage.get(OUTILLAGE_KEY, true);
        setOutils(resOut && resOut.value ? JSON.parse(resOut.value) : []);
      } catch (e) {
        setOutils([]);
      }
      try {
        const resCO = await window.storage.get(CONTROLES_OUTILLAGE_KEY, true);
        setControlesOutillage(resCO && resCO.value ? JSON.parse(resCO.value) : []);
      } catch (e) {
        setControlesOutillage([]);
      }
      try {
        const resSav = await window.storage.get(SAV_KEY, true);
        setSavListe(resSav && resSav.value ? JSON.parse(resSav.value) : []);
      } catch (e) {
        setSavListe([]);
      }
      try {
        const resCI = await window.storage.get(CAMPAGNES_INVENTAIRE_KEY, true);
        setCampagnesInventaire(resCI && resCI.value ? JSON.parse(resCI.value) : []);
      } catch (e) {
        setCampagnesInventaire([]);
      }
      try {
        const resPar = await window.storage.get(PARAMETRES_KEY, true);
        setParametres(resPar && resPar.value ? JSON.parse(resPar.value) : {});
      } catch (e) {
        setParametres({});
      }
      try {
        const resAl = await window.storage.get(ALERTES_KEY, true);
        setAlertes(resAl && resAl.value ? JSON.parse(resAl.value) : []);
      } catch (e) {
        setAlertes([]);
      }
      try {
        const resJournal = await window.storage.get(JOURNAL_ACCES_KEY, true);
        if (resJournal && resJournal.value) {
          setJournalAcces(JSON.parse(resJournal.value));
        } else {
          setJournalAcces([]);
          await window.storage.set(JOURNAL_ACCES_KEY, JSON.stringify([]), true);
        }
      } catch (e) {
        setJournalAcces([]);
      }

      // nettoyer la valeur héritée avant de stocker les items
      const cleaned = (normalized || []).map(({ _legacyReservation, _legacyDesignation, _legacyCategorie, _legacySeuil, ...rest }) => rest);
      setItems(cleaned);
      if (JSON.stringify(cleaned) !== JSON.stringify(loadedBrut)) {
        try {
          await window.storage.set(STORAGE_KEY, JSON.stringify(cleaned), true);
        } catch (e) {}
      }

      setLoading(false);
      } finally {
        finUnChargement();
      }
    })();
  }, [rechargement]);

  useEffect(() => {
    (async () => {
      debutUnChargement();
      try {
      const [a, d, c, ca, un, fi, gc, pg, pg2, cmd, eas, appAff, pos, mat] = await Promise.all([
        loadKey(ARTICLES_KEY, []),
        loadKey(DEVIS_KEY, []),
        loadKey(CHANTIERS_KEY, []),
        loadKey(CATEGORIES_ARTICLES_KEY, DEFAULT_CATEGORIES_ARTICLES),
        loadKey(UNITES_ARTICLES_KEY, DEFAULT_UNITES_ARTICLE),
        loadKey(FINITIONS_ARTICLES_KEY, DEFAULT_FINITIONS_ARTICLE),
        loadKey(GROUPES_COULEUR_ARTICLES_KEY, DEFAULT_GROUPES_COULEUR_ARTICLE),
        loadKey(PRIX_GROUPES_TRANCHE_KEY, DEFAULT_PRIX_GROUPES_TRANCHE),
        loadKey(PRIX_GROUPES_TRANCHE_2E_CHOIX_KEY, DEFAULT_PRIX_GROUPES_TRANCHE_2E_CHOIX),
        loadKey(COMMANDES_KEY, []),
        loadKey(EN_ATTENTE_STATUT_KEY, DEFAULT_EN_ATTENTE_PAR_STATUT),
        loadKey(APPORTEURS_AFFAIRE_KEY, DEFAULT_APPORTEURS_AFFAIRE),
        loadKey(POSEURS_KEY, DEFAULT_POSEURS),
        loadKey(MATIERES_KEY, []),
      ]);
      appliquerMatieres(mat || []);
      setMatieresPerso(mat || []);
      setArticles(a);
      setDevisListe(
        (d || []).map((x) => {
          const migre = x.statut === "Expiré" || x.statut === "Refusé" ? { ...x, statut: "Archivé" } : x;
          // Un devis Confirmé qui a déjà un dossier lié a bien été transformé
          // en BDC avant l'introduction de ce statut explicite — on le
          // rattrape ici pour qu'il apparaisse correctement archivé.
          const avecBDC =
            migre.statut === "Confirmé" && (cmd || []).some((c) => c.devisId === migre.id)
              ? { ...migre, statut: "Transformé en BDC" }
              : migre;
          return migrerElementsTechniques(avecBDC);
        })
      );
      setChantiers(c);
      // Correction d'ordre : Majorations doit suivre immédiatement Tranche
      // (demandé par Nils le 19/09), quel que soit l'ordre déjà enregistré.
      // Appliquée seulement à l'affichage (pas de ré-écriture automatique au
      // chargement, pour ne pas ajouter une écriture de stockage de plus au
      // démarrage) : elle se figera d'elle-même au prochain ajout/suppression
      // de catégorie, via persistCategoriesArticles.
      const caOrdonnee = (() => {
        const liste = ca || DEFAULT_CATEGORIES_ARTICLES;
        if (!liste.includes("Tranche") || !liste.includes("Majorations")) return liste;
        const idxTranche = liste.indexOf("Tranche");
        if (liste[idxTranche + 1] === "Majorations") return liste; // déjà en place
        const sansMajorations = liste.filter((x) => x !== "Majorations");
        const idxTrancheSansMajorations = sansMajorations.indexOf("Tranche");
        return [...sansMajorations.slice(0, idxTrancheSansMajorations + 1), "Majorations", ...sansMajorations.slice(idxTrancheSansMajorations + 1)];
      })();
      setCategoriesArticles(caOrdonnee);
      setUnitesArticles(un);
      appliquerFinitions(fi);
      setFinitionsArticles(normaliserFinitions(fi));
      setGroupesCouleurArticles(gc);
      setPrixGroupesTranche(pg);
      setPrixGroupesTranche2eChoix(pg2);
      // Nils 03/10 : « Circuit fermé » (original remis au client) ajouté aux factures.
      // ERP step 16 (Nils 12/10) : « Envoi client » / « Confirmation client » aussi en BDC (dossier sans RDM).
      const eas2 = eas && eas.BDC && !eas.BDC.includes("Envoi client") ? { ...eas, BDC: [...eas.BDC.filter((x) => !["Autorisation direction", "Autre"].includes(x)), "Envoi client", "Confirmation client", ...eas.BDC.filter((x) => ["Autorisation direction", "Autre"].includes(x))] } : eas;
      const eas3 = eas2 && eas2.Facture && !eas2.Facture.includes("Circuit fermé") ? { ...eas2, Facture: ["Envoi client par mail", "Remise original", "Circuit fermé", ...eas2.Facture.filter((x) => !["Envoi client par mail", "Remise original"].includes(x))] } : eas2;
      // Nils 01/11 : « SAV clôturé » et « Archivé » ajoutés aux BL (dossiers SAV).
      setEnAttenteParStatut(eas3 && eas3.BL && !eas3.BL.includes(EA_ARCHIVE) ? { ...eas3, BL: [...eas3.BL.filter((x) => !["Autorisation direction", "Autre", EA_SAV_CLOTURE].includes(x)), EA_SAV_CLOTURE, EA_ARCHIVE, ...eas3.BL.filter((x) => ["Autorisation direction", "Autre"].includes(x))] } : eas3);
      setApporteursAffaire(appAff);
      setPoseurs(pos);
      // Migrations : intitulés de statuts renommés depuis leur introduction,
      // et éléments techniques passés d'un champ simple à une liste.
      setCommandesListe(
        (cmd || []).map((c) => {
          let next = c;
          if (next.statut === "BC confirmé") next = { ...next, statut: "BDC" };
          if (next.statut === "RDM à faire") next = { ...next, statut: "RDM" };
          if (next.statut === "RDM attente confirmation" || next.statut === "RDM archive") {
            next = { ...next, statut: "RDM", enAttenteDe: DEFAULT_EN_ATTENTE_PAR_STATUT["RDM"][0] };
          }
          if (next.statut === "PL à produire") next = { ...next, statut: "PL" };
          if (next.statut === "PL à BLiser") next = { ...next, statut: "PL", enAttenteDe: DEFAULT_EN_ATTENTE_PAR_STATUT["PL"][0] };
          if (next.statut === "BL à livrer") next = { ...next, statut: "BL" };
          if (next.statut === "BL à facturer" || next.statut === "BL archive") {
            next = { ...next, statut: "Facture", enAttenteDe: DEFAULT_EN_ATTENTE_PAR_STATUT["Facture"][0] };
          }
          if (next.enAttenteDe === "Prêt pour RDM") next = { ...next, enAttenteDe: "Confirmation client pour RDM" };
          if (next.enAttenteDe === "Passage chantier (Soufiane Krim)") next = { ...next, enAttenteDe: "Passage chantier" };
          if (next.enAttenteDe === "Production (Ahmed)") next = { ...next, enAttenteDe: "Production" };
          if (next.enAttenteDe === "Établissement du BL (Sawsan)") next = { ...next, enAttenteDe: "Établissement du BL" };
          if (next.enAttenteDe === "Priorité direction") next = { ...next, enAttenteDe: "Autorisation direction" };
          if (next.enAttenteDe === "Vérification paiement (Sawsan)") next = { ...next, enAttenteDe: "Vérification paiement" };
          if (next.enAttenteDe === "Livraison / pose (Ahmed)") next = { ...next, enAttenteDe: "Livraison / pose" };
          if (next.enAttenteDe === "Facturation (Sawsan)") next = { ...next, enAttenteDe: "Facturation" };
          // Migration architecture pt.17/18 : avant, le dossier n'avait pas ses
          // propres lignes et relisait celles du devis d'origine à chaque
          // ouverture. On rattrape ici les dossiers déjà enregistrés en leur
          // copiant une fois pour toutes les lignes du devis lié — ensuite
          // elles vivent indépendamment (voir lignesDuDossier / enregistrerCommande).
          if (!Array.isArray(next.lignes)) {
            const devisOrigineMigration = (d || []).find((dv) => dv.id === next.devisId);
            next = { ...next, lignes: devisOrigineMigration ? JSON.parse(JSON.stringify(devisOrigineMigration.lignes || [])) : [] };
          }
          return migrerElementsTechniques(next);
        })
      );
      } finally {
        finUnChargement();
      }
    })();
  }, [rechargement]);

  async function persist(next) {
    setItems(next);
    try {
      await ecrireStockage(STORAGE_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde du stock", e);
      return false;
    }
  }

  async function persistCategories(next) {
    setCategories(next);
    try {
      return (await ecrireStockage(CATEGORIES_KEY, JSON.stringify(next), true)) !== false;
    } catch (e) {
      console.error("Erreur de sauvegarde des catégories", e);
      return false;
    }
  }
  async function persistUnitesCategorie(next) {
    setUnitesCategorie(next);
    return await saveKey(UNITES_CATEGORIE_KEY, next);
  }
  function ajouterUniteCategorie(valeur) {
    const v = valeur.trim();
    const liste = unitesCategorie || DEFAULT_UNITES_CATEGORIE;
    if (!v || liste.some((u) => u.toLowerCase() === v.toLowerCase())) return;
    persistUnitesCategorie([...liste, v]);
  }
  function supprimerUniteCategorie(valeur) {
    const enUsage = (categories || []).some((c) => c.unite === valeur);
    if (enUsage) {
      setNotice(`Impossible de supprimer « ${valeur} » : au moins une catégorie l'utilise encore.`);
      return;
    }
    const liste = unitesCategorie || DEFAULT_UNITES_CATEGORIE;
    persistUnitesCategorie(liste.filter((u) => u !== valeur));
  }

  async function persistFournisseurs(next) {
    setFournisseurs(next);
    try {
      await ecrireStockage(FOURNISSEURS_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde des fournisseurs", e);
      return false;
    }
  }

  async function persistDemandesSousCat(next) {
    setDemandesSousCat(next);
    try {
      await ecrireStockage(DEMANDES_SOUSCAT_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde des demandes de sous-catégorie", e);
      return false;
    }
  }

  async function persistDemandesFournisseurs(next) {
    setDemandesFournisseurs(next);
    try {
      await ecrireStockage(DEMANDES_FOURNISSEURS_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde des demandes fournisseur", e);
      return false;
    }
  }
  // Step 12 pt.6 (accord Nils du 21/09) : Ahmed/Wissam remplissent le même
  // formulaire complet que Sawsan/Nils (fourEditing/showFourFiche), mais en
  // mode "demande" — voir saveFournisseur.
  function ouvrirDemandeFour() {
    setFourEditing({
      id: null,
      nom: "",
      origine: "Maroc",
      fiabilite: "bonne",
      contacts: [],
      ice: "",
      paiement: "",
      certifFourni: false,
      certifDate: "",
      notes: "",
    });
    setFourError("");
    setFourEstDemande(true);
    setShowFourFiche(true);
  }
  // Ouvre la fiche complète préremplie avec les informations déjà saisies par
  // le demandeur — la demande n'est marquée traitée qu'une fois le fournisseur
  // réellement enregistré (voir saveFournisseur), pour ne pas la perdre si
  // Nils/Sawsan annule en route.
  function convertirDemandeFour(d) {
    if (!peutEcrireFour) return;
    setFourEditing({
      id: null,
      nom: d.nom || "",
      origine: d.origine || "Maroc",
      fiabilite: d.fiabilite || "bonne",
      contacts: (d.contacts || []).map((c) => ({ ...c, id: c.id || uid() })),
      ice: d.ice || "",
      paiement: d.paiement || "",
      certifFourni: d.certifFourni || false,
      certifDate: d.certifDate || "",
      notes: d.notes || (d.note ? `Demande de ${d.demandePar} : ${d.note}` : ""),
    });
    setFourError("");
    setFourEstDemande(false);
    setShowFourFiche(true);
    setDemandeFourEnCours(d.id);
  }
  function ignorerDemandeFour(id) {
    if (!peutEcrireFour) return;
    persistDemandesFournisseurs((demandesFournisseurs || []).map((d) => (d.id === id ? { ...d, traite: true } : d)));
  }

  async function persistProduits(next) {
    setProduits(next);
    try {
      await ecrireStockage(PRODUITS_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde des produits", e);
      return false;
    }
  }

  async function persistDimensions(next) {
    setDimensionsList(next);
    try {
      await ecrireStockage(DIMENSIONS_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur sauvegarde dimensions", e);
      return false;
    }
  }

  async function persistEpaisseurs(next) {
    setEpaisseursList(next);
    try {
      await ecrireStockage(EPAISSEURS_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur sauvegarde épaisseurs", e);
      return false;
    }
  }

  function addDim() {
    const d = newDim.trim();
    if (!d) {
      setFormatError("Indique une dimension.");
      return;
    }
    if ((dimensionsList || []).some((x) => x.toLowerCase() === d.toLowerCase())) {
      setFormatError("Cette dimension existe déjà.");
      return;
    }
    persistDimensions([...(dimensionsList || []), d]);
    setNewDim("");
    setFormatError("");
  }

  function removeDim(d) {
    // seules les tranches puisent dans la liste : les chutes ont une dimension libre
    const lots = (items || []).filter((it) => it.type === TYPE_TRANCHE && it.dimensions === d);
    if (lots.length > 0) {
      setNotice(`Impossible de supprimer « ${d} » : ${lots.length} lot(s) de tranches utilisent cette dimension.`);
      return;
    }
    // Le Catalogue puise aussi dans cette liste (formulaire d'article, champ
    // Dimension) — une dimension encore choisie par un article ne doit pas
    // pouvoir disparaître, même sans lot de Stock qui l'utilise.
    const articlesConcernes = (articles || []).filter((a) => a.dimension === d);
    if (articlesConcernes.length > 0) {
      setNotice(`Impossible de supprimer « ${d} » : ${articlesConcernes.length} article(s) du Catalogue utilisent cette dimension.`);
      return;
    }
    persistDimensions((dimensionsList || []).filter((x) => x !== d));
  }

  function addEp() {
    const e = newEp.trim();
    if (!e) {
      setFormatError("Indique une épaisseur.");
      return;
    }
    if ((epaisseursList || []).some((x) => x.toLowerCase() === e.toLowerCase())) {
      setFormatError("Cette épaisseur existe déjà.");
      return;
    }
    persistEpaisseurs([...(epaisseursList || []), e]);
    setNewEp("");
    setFormatError("");
  }

  function removeEp(ep) {
    const lots = (items || []).filter((it) => it.epaisseur === ep);
    if (lots.length > 0) {
      setNotice(`Impossible de supprimer « ${ep} » : ${lots.length} lot(s) utilisent cette épaisseur.`);
      return;
    }
    persistEpaisseurs((epaisseursList || []).filter((x) => x !== ep));
  }

  async function persistClients(next) {
    setClients(next);
    try {
      await ecrireStockage(CLIENTS_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde des clients", e);
      return false;
    }
  }

  // ---- Clients ----
  function clientDe(id) {
    return (clients || []).find((c) => c.id === id) || null;
  }

  // ERP step 7 (pt.14) : rappel des conditions de paiement du client à
  // chaque transformation de document. Purement informatif pour l'instant —
  // le plafond d'exposition n'est pas comparé à un encours réel (rien ne
  // calcule encore l'encours facturé/impayé d'un client), donc pas de
  // blocage, juste un rappel visible à chaque étape.
  function rappelConditionsPaiement(clientId) {
    const c = clientDe(clientId);
    if (!c) return "";
    const niveau = PAIEMENTS_NIVEAUX.find((n) => n.cle === (c.paiement_niveau || "")) || PAIEMENTS_NIVEAUX[PAIEMENTS_NIVEAUX.length - 1];
    let msg = `Conditions de paiement — ${c.nom} : ${niveau.label}.`;
    if (c.paiement) msg += ` Modalité : ${c.paiement}.`;
    if (c.plafondExposition) msg += ` Plafond d'exposition : ${fmtMAD(Number(c.plafondExposition))}.`;
    return msg;
  }

  // Contacts commerciaux du client : alimentent le menu du formulaire de réservation
  function contactsDuClient(id) {
    const c = clientDe(id);
    return c ? c.contacts || [] : [];
  }

  function clientAlertes(c) {
    const a = [];
    if (c.type !== TYPE_SANS_ICE && !(c.ice || "").trim()) a.push("ICE manquant");
    if (c.type !== TYPE_SANS_ICE && !(c.raisonSociale || "").trim()) a.push("Raison sociale manquante");
    if (!(c.commercialSC || "").trim()) a.push("Commercial non attribué");
    if (!(c.paiement || "").trim()) a.push("Paiement non renseigné");
    if ((c.contacts || []).length === 0) a.push("Aucun contact");
    return a;
  }

  function openClientNew() {
    setClientEditing({ id: null, nom: "", raisonSociale: "", commercialSC: "", apporteurAffaire: "", type: TYPES_CLIENT[0], notes_adv: "–", notes_prod: "–", notes_com: "–", paiement_niveau: "", ice: "", paiement: "", remise: "", plafondExposition: "", contacts: [], adresse: "", codePostal: "", ville: "", adressesSupp: [], notes: "" });
    setClientError("");
    setShowClientFiche(true);
  }

  function openClientEdit(c) {
    setClientEditing({ ...c, contacts: (c.contacts || []).map((x) => ({ ...x })), adressesSupp: (c.adressesSupp || []).map((x) => ({ ...x })) });
    setClientError("");
    setShowClientFiche(true);
  }

  function addClientContact() {
    setClientEditing((prev) => ({
      ...prev,
      contacts: [...(prev.contacts || []), { id: uid(), nom: "", fonction: FONCTIONS[0], tel: "", email: "" }],
    }));
  }

  function updateClientContact(cid, champ, valeur) {
    setClientEditing((prev) => ({
      ...prev,
      contacts: prev.contacts.map((c) => (c.id === cid ? { ...c, [champ]: valeur } : c)),
    }));
  }

  function removeClientContact(cid) {
    setClientEditing((prev) => ({ ...prev, contacts: prev.contacts.filter((c) => c.id !== cid) }));
  }

  function addClientAdresse() {
    setClientEditing((prev) => ({
      ...prev,
      adressesSupp: [...(prev.adressesSupp || []), { id: uid(), libelle: "", adresse: "", codePostal: "", ville: "" }],
    }));
  }

  function updateClientAdresse(aid, champ, valeur) {
    setClientEditing((prev) => ({
      ...prev,
      adressesSupp: prev.adressesSupp.map((a) => (a.id === aid ? { ...a, [champ]: valeur } : a)),
    }));
  }

  function removeClientAdresse(aid) {
    setClientEditing((prev) => ({ ...prev, adressesSupp: prev.adressesSupp.filter((a) => a.id !== aid) }));
  }

  // ERP step 10 (demande Nils du 24/09) : fiche de demande d'ouverture de
  // compte imprimable — tous les éléments de la fiche client, même mise en
  // page que la fiche de pose (charte Stone Concept, encadrés arrondis, pas
  // de fond gris). Vierge (c = null) pour la remettre à un prospect, ou
  // pré-remplie depuis une fiche client.
  function imprimerFicheOuvertureCompte(c) {
    // ERP step 10 (accord Nils du 24/09) : une fiche pré-remplie expose des
    // données client — impression réservée à Nils. La fiche vierge reste
    // accessible à tous ceux qui voient l'onglet Clients.
    if (c && !peut("clients.ficheOuverturePreRemplie")) return;
    const cl = c || {};
    const e = escapeHtml;
    const bloc = (label, valeur, style) => `<div class="bloc"${style ? ` style="${style}"` : ""}><div class="lbl">${e(label)}</div><div class="val">${e(valeur || "") || "&nbsp;"}</div></div>`;
    const coche = (ok) => `<span class="case">${ok ? "✕" : ""}</span>`;
    const contacts = (cl.contacts || []).filter((x) => (x.nom || "").trim());
    const nbLignesContacts = Math.max(6, contacts.length);
    const lignesContacts = Array.from({ length: nbLignesContacts }, (_, i) => contacts[i] || {}).map((x) => `<tr><td>${e(x.nom || "")}</td><td>${e(x.fonction || "")}</td><td>${e(x.tel || "")}</td><td>${e(x.email || "")}</td></tr>`).join("");
    const adressesSupp = (cl.adressesSupp || []).filter((x) => (x.adresse || "").trim());
    const nbLignesAdr = Math.max(2, adressesSupp.length);
    const lignesAdr = Array.from({ length: nbLignesAdr }, (_, i) => adressesSupp[i] || {}).map((x) => `<tr><td>${e(x.libelle || "")}</td><td>${e(x.adresse || "")}</td><td>${e(x.codePostal || "")}</td><td>${e(x.ville || "")}</td></tr>`).join("");
    const typeCoches = TYPES_CLIENT.map((t) => `<span style="margin-right:14px;white-space:nowrap;">${coche(cl.type === t && !!c)} ${e(t)}</span>`).join("");
    const html = `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="UTF-8" />
<title>Demande d'ouverture de compte${cl.nom ? " — " + e(cl.nom) : ""}</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600&family=DM+Sans:wght@400;500;600&display=swap" rel="stylesheet">
<style>
  * { box-sizing: border-box; }
  @page { size: A4 portrait; margin: 1.2cm; }
  body { font-family: "DM Sans", Arial, Helvetica, sans-serif; color: #281E1E; font-size: 11px; line-height: 1.4; margin: 0; padding: 0; background: #fff; }
  .entete { display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #8C8282; padding-bottom: 10px; margin-bottom: 12px; }
  .titre { font-family: "Cormorant Garamond", Georgia, serif; font-size: 24px; font-weight: 600; }
  .sousTitre { font-size: 10px; color: #8C8282; text-transform: uppercase; letter-spacing: .6px; }
  h2 { font-family: "Cormorant Garamond", Georgia, serif; font-size: 15px; font-weight: 600; margin: 8px 0 6px; }
  .grille { display: grid; gap: 8px; margin-bottom: 8px; }
  .g2 { grid-template-columns: 1fr 1fr; }
  .g3 { grid-template-columns: 1fr 1fr 1fr; }
  .g4 { grid-template-columns: 2fr 0.8fr 1.2fr 1fr; }
  .bloc { border: 1px solid #8C8282; border-radius: 10px; padding: 5px 10px; min-height: 38px; }
  .lbl { font-size: 8.5px; color: #8C8282; text-transform: uppercase; letter-spacing: .6px; margin-bottom: 2px; }
  .val { font-size: 11.5px; font-weight: 600; }
  .cadre { border: 1px solid #8C8282; border-radius: 10px; padding: 8px 12px; margin-bottom: 8px; }
  table.lignes { width: 100%; border-collapse: collapse; font-size: 10.5px; }
  table.lignes th { font-size: 8px; color: #8C8282; text-transform: uppercase; letter-spacing: .5px; font-weight: 500; text-align: left; padding: 2px 4px; border-bottom: 1px solid #8C8282; }
  table.lignes td { padding: 0 4px; height: 22px; border-bottom: 1px solid #ddd6d2; }
  .case { display: inline-block; width: 10px; height: 10px; border: 1px solid #281E1E; border-radius: 3px; font-size: 8px; line-height: 9px; text-align: center; vertical-align: -1px; }
  .reserve { border: 1px dashed #8C8282; border-radius: 10px; padding: 8px 12px; margin-top: 4px; }
  .sign { border: 1px solid #8C8282; border-radius: 10px; padding: 5px 10px; height: 78px; }
  .pied { font-size: 8.5px; color: #8C8282; text-align: center; margin-top: 10px; }
</style>
</head>
<body>
  <div class="entete">
    <div>
      <div class="titre">Demande d'ouverture de compte</div>
      <div class="sousTitre">Fiche client${c && c.id ? "" : " — à remplir par le client"}</div>
    </div>
    <img src="${LOGO_SRC}" alt="Stone Concept" style="height:40px;" />
  </div>

  <h2>Identité</h2>
  <div class="grille g2">
    ${bloc("Nom commercial", cl.nom)}
    ${bloc("Raison sociale (facturation)", cl.raisonSociale)}
  </div>
  <div class="grille g2">
    ${bloc("ICE (15 chiffres — sauf particulier)", cl.ice)}
    <div class="bloc"><div class="lbl">Type</div><div style="font-size:10.5px;margin-top:3px;">${typeCoches}</div></div>
  </div>

  <h2>Adresse</h2>
  <div class="grille g3" style="grid-template-columns:2fr 0.7fr 1fr;">
    ${bloc("Adresse", cl.adresse)}
    ${bloc("Code postal", cl.codePostal)}
    ${bloc("Ville", cl.ville)}
  </div>
  <div class="cadre">
    <div class="lbl" style="margin-bottom:2px;">Adresses supplémentaires (showroom, dépôt…)</div>
    <table class="lignes">
      <tr><th style="width:22%;">Libellé</th><th>Adresse</th><th style="width:14%;">Code postal</th><th style="width:20%;">Ville</th></tr>
      ${lignesAdr}
    </table>
  </div>

  <h2>Contacts chez le client</h2>
  <div class="cadre">
    <table class="lignes">
      <tr><th style="width:28%;">Nom</th><th style="width:18%;">Fonction</th><th style="width:20%;">Téléphone</th><th>Email</th></tr>
      ${lignesContacts}
    </table>
    <div style="font-size:8.5px;color:#8C8282;margin-top:4px;">Fonctions : ${e(FONCTIONS.join(", "))}.</div>
  </div>

  <div class="grille g2" style="margin-top:6px;">
    <div class="sign"><div class="lbl">Date, signature et cachet du client</div></div>
    <div class="sign"><div class="lbl">Notes / conditions particulières</div><div style="font-size:10.5px;white-space:pre-wrap;">${e(cl.notes || "")}</div></div>
  </div>

  <h2>Réservé à Stone Concept</h2>
  <div class="reserve">
    <div class="grille g3">
      ${bloc("Commercial Stone Concept", cl.commercialSC)}
      ${bloc("Apporteur d'affaire", cl.apporteurAffaire)}
      ${bloc("Conditions de paiement", cl.paiement)}
    </div>
    <div class="grille g3">
      ${bloc("Remise habituelle (%)", cl.remise !== undefined && cl.remise !== "" ? String(cl.remise) : "")}
      ${bloc("Plafond d'exposition (MAD)", cl.plafondExposition ? fmtMAD(Number(cl.plafondExposition)) : "")}
      ${bloc("Paiement (comptabilité)", c && cl.paiement_niveau ? paiementLabel(cl.paiement_niveau) : "")}
    </div>
    <div class="grille g4" style="grid-template-columns:repeat(${AXES_CLIENT.length}, 1fr) 1.4fr;margin-bottom:0;">
      ${AXES_CLIENT.map((axe) => bloc(`Évaluation ${axe.label}`, c ? (cl[`notes_${axe.cle}`] && cl[`notes_${axe.cle}`] !== "–" ? cl[`notes_${axe.cle}`] : "") : "")).join("")}
      ${bloc("Validé par le Gérant — date", cl.valideNilsPar ? `${cl.valideNilsPar}${cl.valideNilsLe ? " — " + formatDate(cl.valideNilsLe) : ""}` : "")}
    </div>
  </div>

  <div class="pied">Stone Concept Sarl — imprimé le ${e(formatDate(new Date().toISOString()))}${cl.creePar ? ` — fiche créée par ${e(cl.creePar)}` : ""}</div>
</body>
</html>`;
    const nomFichier = `ouverture-compte-${(cl.nom || "vierge").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "vierge"}`;
    telechargerDocument(html, nomFichier, "fiche d'ouverture de compte");
  }

  async function saveClient() {
    const c = clientEditing;
    // ERP step 10 pt.11 : un utilisateur sans écriture Clients (commercial)
    // peut seulement créer une fiche, jamais modifier une fiche existante.
    if (c.id && !peutEcrireClient) {
      setClientError("Tu n'as pas le droit de modifier une fiche client.");
      return;
    }
    const nom = (c.nom || "").trim();
    if (!nom) {
      setClientError("Indique le nom du client.");
      return;
    }
    if ((clients || []).some((x) => x.nom.toLowerCase() === nom.toLowerCase() && x.id !== c.id)) {
      setClientError("Ce client existe déjà.");
      return;
    }
    // ICE obligatoire côté client (contrairement aux fournisseurs),
    // sauf pour un particulier qui n'en a pas.
    if (c.type !== TYPE_SANS_ICE && !(c.ice || "").trim()) {
      setClientError(`L'ICE est obligatoire pour un client de type « ${c.type} ».`);
      return;
    }
    if (c.type !== TYPE_SANS_ICE && (c.ice || "").trim()) {
      const iceDigits = c.ice.replace(/\D/g, "");
      if (iceDigits.length !== 15) {
        setClientError("L'ICE doit contenir exactement 15 chiffres.");
        return;
      }
    }
    if (c.remise !== "" && c.remise !== undefined) {
      const r = Number(c.remise);
      if (isNaN(r) || r < 0 || r > 100) {
        setClientError("La remise doit être un pourcentage entre 0 et 100.");
        return;
      }
    }
    // ERP step 14 (Nils 05/10) : commercial obligatoire pour une nouvelle fiche
    // (les fiches existantes sans commercial s'enregistrent comme avant).
    if (!c.id && !user.clientsRestreintACommercial && !(c.commercialSC || "").trim()) {
      setClientError("Choisis le commercial Stone Concept.");
      return;
    }
    if (c.plafondExposition !== "" && c.plafondExposition !== undefined) {
      const pe = Number(c.plafondExposition);
      if (isNaN(pe) || pe < 0) {
        setClientError("Le plafond d'exposition doit être un montant positif.");
        return;
      }
    }
    try {
      const clean = {
        ...c,
        nom,
        raisonSociale: (c.raisonSociale || "").trim(),
        ice: (c.ice || "").trim(),
        remise: c.remise === "" || c.remise === undefined ? "" : String(Number(c.remise)),
        plafondExposition: c.plafondExposition === "" || c.plafondExposition === undefined ? "" : String(Number(c.plafondExposition)),
        contacts: (c.contacts || []).filter((x) => (x.nom || "").trim()),
        adresse: (c.adresse || "").trim(),
        codePostal: (c.codePostal || "").trim(),
        ville: (c.ville || "").trim(),
        adressesSupp: (c.adressesSupp || []).filter((x) => (x.adresse || "").trim()).map((x) => ({ ...x, codePostal: (x.codePostal || "").trim(), ville: (x.ville || "").trim() })),
      };
      const list = clients || [];
      if (!c.id) {
        // ERP step 10 pt.11 : création par Karima/Souad ou par un commercial
        // → client "à valider" par Sawsan (ou Nils), bloquant pour le BDC.
        // Profils (Nils 02/10) : tout client créé par quelqu'un d'autre que le Gérant passe par sa
        // validation ; créé par l'Administration, la 1re étape est faite d'office.
        const soumisAValidation = !peut("clients.validerEtape2");
        clean.aValider = soumisAValidation;
        if (soumisAValidation && peut("clients.validerEtape1")) { clean.validePar = user.nom; clean.valideLe = new Date().toISOString(); }
        clean.creePar = user.nom;
        clean.creeLe = new Date().toISOString();
        if (user.clientsRestreintACommercial) clean.commercialSC = user.nom;
      }
      // ERP step 13 (ah3) : client créé à partir d'un prospect → le prospect passe « devenu client ».
      const depuisProspectId = clean.depuisProspectId;
      delete clean.depuisProspectId;
      const nouvelId = c.id || uid();
      await persistClients(c.id ? list.map((x) => (x.id === c.id ? clean : x)) : [...list, { ...clean, id: nouvelId }]);
      if (!c.id && depuisProspectId) {
        await persistProspects((prospects || []).map((x) => (x.id === depuisProspectId ? { ...x, statut: "converti", clientId: nouvelId, convertiLe: new Date().toISOString(), convertiPar: user.nom } : x)));
        await tracerAcces("prospect devenu client", `${nom} (créé par ${user.nom})`);
      }
      if (!c.id && clean.aValider) {
        setNotice(`Client « ${nom} » créé — en attente de validation par l'Administration, puis par le Gérant. Tant qu'il n'est pas validé par les deux, ses devis ne peuvent pas passer en BDC.`);
        await tracerAcces("création client à valider", `Client ${nom} créé par ${user.nom}, en attente de validation`);
      }
      setShowClientFiche(false);
      setClientEditing(null);
      setClientError("");
    } catch (err) {
      console.error("Erreur client", err);
      setClientError("Impossible d'enregistrer. Réessaie.");
    }
  }

  async function validerClient(c) {
    if (!c || !peutValiderClient(c)) return;
    const etape = etapeValidationClient(c);
    const maintenant = new Date().toISOString();
    if (etape === "etape1" && peut("clients.validerEtape2")) {
      // Nils valide à la place de Sawsan : les deux étapes d'un coup.
      await persistClients((clients || []).map((x) => (x.id === c.id ? { ...x, aValider: false, validePar: user.nom, valideLe: maintenant, valideNilsPar: user.nom, valideNilsLe: maintenant } : x)));
      await tracerAcces("validation client (Gérant, à la place de l'Administration)", `Client ${c.nom} validé définitivement par le Gérant sans validation préalable de l'Administration${c.creePar ? ` (créé par ${c.creePar})` : ""}`);
      setNotice(`Client « ${c.nom} » validé définitivement (à la place de l'Administration).`);
    } else if (etape === "etape1") {
      await persistClients((clients || []).map((x) => (x.id === c.id ? { ...x, validePar: user.nom, valideLe: maintenant } : x)));
      await tracerAcces("validation client (Administration)", `Client ${c.nom} validé par ${user.nom} — en attente de validation par le Gérant${c.creePar ? ` (créé par ${c.creePar})` : ""}`);
      setNotice(`Client « ${c.nom} » validé par l'Administration — reste la validation du Gérant avant tout BDC.`);
    } else if (etape === "etape2") {
      await persistClients((clients || []).map((x) => (x.id === c.id ? { ...x, aValider: false, valideNilsPar: user.nom, valideNilsLe: maintenant } : x)));
      await tracerAcces("validation client (Gérant)", `Client ${c.nom} validé définitivement${c.creePar ? ` (créé par ${c.creePar})` : ""}`);
      setNotice(`Client « ${c.nom} » validé définitivement.`);
    }
  }

  function removeClient(c) {
    const res = (reservations || []).filter((r) => r.clientId === c.id && r.statut === "active");
    if (res.length > 0) {
      setNotice(`Impossible de supprimer « ${c.nom} » : ${res.length} réservation(s) active(s) lui sont rattachées.`);
      return;
    }
    persistClients((clients || []).filter((x) => x.id !== c.id));
  }

  async function persistPaiements(next) {
    setPaiements(next);
    try {
      await ecrireStockage(PAIEMENTS_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde des conditions de paiement", e);
      return false;
    }
  }

  function addPaiement() {
    const p = newPaiement.trim();
    setPaiementSuccess("");
    if (!p) {
      setPaiementError("Indique une condition de paiement.");
      return;
    }
    const list = paiements || [];
    if (list.some((x) => x.label.toLowerCase() === p.toLowerCase())) {
      setPaiementError("Cette condition existe déjà.");
      return;
    }
    persistPaiements([...list, { label: p, verifierAvantBL: newPaiementVerifierAvantBL }]);
    setNewPaiement("");
    setNewPaiementVerifierAvantBL(false);
    setPaiementError("");
    setPaiementSuccess(`« ${p} » ajoutée.`);
  }

  function removePaiement(label) {
    const users = (fournisseurs || []).filter((f) => f.paiement === label).map((f) => f.nom);
    if (users.length > 0) {
      setNotice(
        `Impossible de supprimer la condition « ${label} » : elle est utilisée par ${users.length > 1 ? "les fournisseurs" : "le fournisseur"} ${users.join(", ")}. Change leur condition de paiement avant de la supprimer.`
      );
      return;
    }
    persistPaiements((paiements || []).filter((x) => x.label !== label));
    setNotice("");
  }

  function toggleVerifierAvantBL(label) {
    persistPaiements((paiements || []).map((x) => (x.label === label ? { ...x, verifierAvantBL: !x.verifierAvantBL } : x)));
  }

  // Vrai si la condition de paiement du devis exige une vérification avant
  // de pouvoir créer le BL — repli sur false si la condition est introuvable
  // (supprimée depuis, ou devis ancien avec un texte libre).
  function paiementNecessiteVerifAvantBL(label) {
    const cond = (paiements || []).find((p) => p.label === label);
    return cond ? !!cond.verifierAvantBL : false;
  }

  // Droits (maquette d'ergonomie, pas une sécurité)
  // Profils d'accès (Nils 02/10) : comptes et profils stockés (erp:acces), valeurs par défaut sinon.
  const comptesAcces = (() => {
    const l = acces && Array.isArray(acces.comptes) && acces.comptes.length ? acces.comptes : DEFAULT_COMPTES;
    // Nils 04/10 (ad) : compte de Salwa (marketing) ajouté aux comptes déjà enregistrés.
    return l.some((c) => c.id === "salwa") ? l : [...l, DEFAULT_COMPTES.find((c) => c.id === "salwa")];
  })();
  const profilsAcces = { ...DEFAULT_PROFILS, ...((acces && acces.profils) || {}) };
  COMPTES_FICHE_MASQUEE = new Set(comptesAcces.filter((c) => c.profil === P_GERANT).map((c) => c.id));
  const utilisateurs = comptesAcces.map((c) => construireUtilisateur(c, profilsAcces));
  // Compte connecté absent de la liste (erp:acces) : on se fie au profil donné par le serveur,
  // jamais au Gérant par défaut.
  const user =
    utilisateurs.find((u) => u.id === currentUser) ||
    (compteConnecte
      ? construireUtilisateur({ id: compteConnecte.id, nom: compteConnecte.nom, profil: compteConnecte.profil, actif: true, ajouts: [], retraits: [], onglets: {} }, profilsAcces)
      : utilisateurs.find((u) => u.profil === P_GERANT) || utilisateurs[0]);
  const peut = (cle) => user.droits.has(cle);
  const estGerant = user.profil === P_GERANT;
  function qui(...profils) {
    return utilisateurs.filter((u) => u.actif && profils.includes(u.profil)).map((u) => u.id);
  }
  function droitsDe(id) {
    const u = utilisateurs.find((x) => x.id === id);
    return u ? u.droits : new Set();
  }
  function compteUtilisateurDe(id) {
    return comptesAcces.find((c) => c.id === id) || null;
  }
  function profilsListe() {
    const autres = Object.keys(profilsAcces).filter((k) => !ORDRE_PROFILS.includes(k));
    return [...ORDRE_PROFILS, ...autres].filter((k) => profilsAcces[k]).map((k) => ({ id: k, ...profilsAcces[k] }));
  }
  async function persistAcces(next) {
    setAcces(next);
    return await saveKey(ACCES_KEY, next);
  }
  // ---- Profils d'accès et comptes (Paramétrage, Gérant seul) ----
  // Étape d : code de connexion provisoire (72 h), créé par le serveur, à transmettre à la personne.
  async function donnerCodeConnexion(c) {
    if (!session || !peut("admin.comptes")) return;
    const ok = await demander(`Créer un code de connexion pour ${c.nom} ? Avec ce code, ${c.nom} choisira un nouveau mot de passe et installera la double authentification. Son accès actuel reste valable tant que le code n'a pas servi.`);
    if (!ok) return;
    try {
      const r = await session.genererCode(c.id, c.nom, c.profil);
      await demander(`Code de connexion pour ${c.nom} : ${r.code} — valable jusqu'au ${new Date(r.expire).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}. À transmettre à ${c.nom} (WhatsApp, de vive voix) : ce code se saisit à la place du mot de passe, avec l'identifiant « ${c.id} ». Il ne sera plus affiché.`, { info: true });
    } catch (e) {
      setNotice(e.message);
    }
  }
  async function majAcces(next, trace, detail) {
    if (!peut("admin.comptes")) return false;
    // Nils 16/10 (h) : on garde les autres champs d'erp:acces (repères migrationDroits…), sinon les
    // mises à jour automatiques de droits se relançaient et rajoutaient des droits retirés par Nils.
    await persistAcces({ ...(acces || {}), profils: (acces && acces.profils) || {}, comptes: comptesAcces, ...next });
    await tracerAcces(trace, detail);
    return true;
  }
  async function majProfil(profilId, patch, detail) {
    if (profilId === P_GERANT) { setNotice("Le profil Gérant a toujours tous les droits."); return; }
    const profils = { ...((acces && acces.profils) || {}) };
    profils[profilId] = { ...(profils[profilId] || DEFAULT_PROFILS[profilId]), ...patch };
    await majAcces({ profils }, "profil d'accès modifié", `${profilsAcces[profilId].label} — ${detail}`);
  }
  async function basculerDroitProfil(profilId, cle) {
    const d = new Set(profilsAcces[profilId].droits || []);
    const avait = d.has(cle);
    if (avait) d.delete(cle); else d.add(cle);
    await majProfil(profilId, { droits: [...d] }, `${avait ? "retiré" : "ajouté"} : ${(DROITS.find((x) => x.cle === cle) || {}).label || cle}`);
  }
  async function changerOngletProfil(profilId, onglet, niveau) {
    await majProfil(profilId, { onglets: { ...ONG({}), ...(profilsAcces[profilId].onglets || {}), [onglet]: niveau } }, `onglet ${(ONGLETS_ACCES.find((x) => x.cle === onglet) || {}).label} : ${LIB_NIVEAU_ACCES[niveau]}`);
  }
  async function reinitialiserProfil(profilId) {
    if (!await demander(`Remettre le profil « ${profilsAcces[profilId].label} » à ses droits d'origine ?`)) return;
    const profils = { ...((acces && acces.profils) || {}) };
    delete profils[profilId];
    await majAcces({ profils }, "profil d'accès réinitialisé", profilsAcces[profilId].label);
  }
  function gerantsActifs(comptes) {
    return comptes.filter((c) => c.actif !== false && c.profil === P_GERANT);
  }
  async function modifierCompte(id, patch) {
    const avant = comptesAcces.find((c) => c.id === id);
    if (!avant) return;
    const next = comptesAcces.map((c) => (c.id === id ? { ...c, ...patch } : c));
    if (gerantsActifs(next).length === 0) { setNotice("Il faut garder au moins un compte Gérant actif."); return; }
    const quoi = [];
    if (patch.profil && patch.profil !== avant.profil) quoi.push(`profil : ${profilsAcces[avant.profil].label} → ${profilsAcces[patch.profil].label}`);
    if (patch.actif !== undefined && patch.actif !== (avant.actif !== false)) quoi.push(patch.actif ? "réactivé" : "désactivé");
    if (patch.ajouts) quoi.push(`droits ajoutés : ${patch.ajouts.length}`);
    if (patch.retraits) quoi.push(`droits retirés : ${patch.retraits.length}`);
    if (patch.onglets) quoi.push(`onglets : ${ONGLETS_ACCES.filter((o) => patch.onglets[o.cle] !== undefined).map((o) => `${o.label} ${LIB_NIVEAU_ACCES[patch.onglets[o.cle]].toLowerCase()}`).join(", ") || "comme le profil"}`);
    await majAcces({ comptes: next }, "compte utilisateur modifié", `${avant.nom} — ${quoi.join(", ") || "modifié"}`);
  }
  async function creerCompte() {
    const nom = (nouveauCompte.nom || "").trim().replace(/\s+/g, " ");
    if (!nom) { setNotice("Indique le prénom (et le nom si besoin) de la personne."); return; }
    if (comptesAcces.some((c) => normLib(c.nom) === normLib(nom))) { setNotice("Un compte porte déjà ce nom."); return; }
    const base = normLib(nom).replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") || "compte";
    let id = base, i = 2;
    while (comptesAcces.some((c) => c.id === id)) id = `${base}-${i++}`;
    const compte = { id, nom, profil: nouveauCompte.profil || P_ADV_JR, actif: true, ajouts: [], retraits: [], onglets: {} };
    const ok = await majAcces({ comptes: [...comptesAcces, compte] }, "compte utilisateur créé", `${nom} — ${profilsAcces[compte.profil].label}`);
    if (ok) { setNouveauCompte({ nom: "", profil: compte.profil }); setNotice(`Compte « ${nom} » créé (${profilsAcces[compte.profil].label}). Relie-le à sa fiche dans Staff (champ « Compte ERP lié »).`); }
  }


  // ---------- Journal d'accès ----------
  async function tracerAcces(type, detail, auto) {
    const u = utilisateurRef.current || user;
    const entree = {
      id: uid(),
      utilisateur: u.nom,
      role: u.role,
      type,
      detail: detail || "",
      date: new Date().toISOString(),
    };
    if (auto) entree.auto = true;
    await persistJournalAcces([...(journalRef.current || []), entree]);
  }
  utilisateurRef.current = user;
  // Phase de développement (demande Nils du 29/09) : vider le journal. Nils
  // seul ; une entrée « journal vidé » reste pour garder la trace du vidage.
  async function viderJournal() {
    if (!peut("admin.donnees")) return;
    const nb = (journalRef.current || []).length;
    await persistJournalAcces([]);
    await tracerAcces("journal vidé", `${nb} entrée(s) effacée(s) — phase de développement`);
    setConfirmViderJournal(false);
    setNotice(`Journal vidé (${nb} entrée(s)).`);
  }
  // ---- Journal automatique (demande Nils du 29/09 : toute action tracée) ----
  // Libellé d'un élément dans le détail : numéros (pour le filtre « tout un
  // dossier »), sinon nom / désignation.
  function libelleElementJournal(cle, o) {
    if (!estObjetSimple(o)) return valeurCourteJournal(o);
    if (cle === "erp:commandes") return [o.numero, o.numeroRDM, o.numeroPL, o.numeroBL, o.numeroFacture].filter(Boolean).join(" / ") || o.id;
    if (cle === "stock:mouvements") {
      let lot = (items || []).find((it) => it.id === o.itemId);
      if (!lot) {
        try {
          lot = (JSON.parse(cacheEcrituresRef.current["stock:references"] || "[]") || []).find((it) => it.id === o.itemId);
        } catch (e) {
          lot = null;
        }
      }
      return `${o.type || "mouvement"} ${o.quantite ?? ""} ${o.unite || ""} ${lot ? nomProduit(lot.produitId) : ""}${o.pl ? ` — ${o.pl}` : ""}`.replace(/\s+/g, " ").trim();
    }
    if (cle === "stock:references" || cle === "stock:lots-archives") return `${nomProduit(o.produitId)}${o.fournisseur ? ` — ${o.fournisseur}` : ""}${o.blFournisseur ? ` (BL ${o.blFournisseur})` : ""}`;
    if (cle === "erp:outillage") return `${o.numero || ""} ${o.designation || ""}`.trim() || o.id;
    if (cle === "erp:sav") {
      const co = (commandesListe || []).find((c) => c.id === o.commandeOrigineId);
      return `${o.numero || "SAV"}${co ? ` (origine ${[co.numero, co.numeroBL, co.numeroFacture].filter(Boolean).join(" / ")})` : ""}`;
    }
    if (cle === "stock:reservations") return `${nomProduit(o.produitId)} ${o.quantite ?? ""}${o.bc ? ` — ${o.bc}` : ""}`.trim();
    // Nils 30/10 : catégories du stock (champ « name »).
    const base = o.numero || o.nom || o.name || o.designation || o.libelle || o.label || o.reference || o.texte || "";
    const extra = [o.pl, o.plNumero, o.bc].filter(Boolean).join(" ");
    return valeurCourteJournal(`${base}${extra ? ` (${extra})` : ""}`.trim() || o.id || "élément");
  }
  const cacheEcrituresRef = useRef({});
  async function crochetJournal(key, str) {
    const nom = DONNEES_JOURNALISEES[key];
    if (!nom) return;
    const cache = cacheEcrituresRef.current;
    let avantStr = cache[key];
    if (avantStr === undefined) {
      try {
        // Étape c : simple lecture pour comparer, sans reprendre la version du serveur
        // (sinon l'écriture qui suit écraserait la modification d'un collègue).
        const r = await window.storage.get(key, true, { pourComparer: true });
        avantStr = r && r.value ? r.value : "null";
      } catch (e) {
        avantStr = "null";
      }
    }
    cache[key] = str;
    if (avantStr === str) return;
    let lignes;
    try {
      lignes = diffDonneesJournal(JSON.parse(avantStr), JSON.parse(str), (o) => libelleElementJournal(key, o));
    } catch (e) {
      lignes = ["modification"];
    }
    if (lignes.length === 0) return;
    let detail = lignes.join(" | ");
    if (detail.length > 1500) detail = detail.slice(0, 1480) + `… (${lignes.length} changement(s))`;
    if (window.storage.journalServeur) return { type: `données · ${nom}`, detail };
    await tracerAcces(`données · ${nom}`, detail, true);
  }
  const crochetJournalRef = useRef(null);
  crochetJournalRef.current = crochetJournal;
  const resoudreIdRef = useRef(null);
  resoudreIdRef.current = (champ, id) => {
    if (champ === "clientId") { const c = (clients || []).find((x) => x.id === id); return c ? c.nom : null; }
    if (champ === "produitId") { const n = nomProduit(id); return n && n !== "—" ? n : null; }
    if (champ === "articleId") { const a = (articles || []).find((x) => x.id === id); return a ? a.designation || a.nom || null : null; }
    if (champ === "itemId") { const lot = (items || []).find((x) => x.id === id); return lot ? nomProduit(lot.produitId) : null; }
    if (champ === "compte") { const u = utilisateurs.find((x) => x.id === id); return u ? u.nom : null; }
    if (["affectationId", "detenteurId", "vers", "de", "detenteur", "imputeA"].includes(champ)) { const a = (affectations || []).find((x) => x.id === id); return a ? a.nom : null; }
    return null;
  };
  useEffect(() => {
    if (loading) return undefined;
    crochetEcritureJournal = (k, str) => crochetJournalRef.current(k, str);
    resoudreIdJournal = (c, id) => resoudreIdRef.current(c, id);
    return () => {
      crochetEcritureJournal = null;
      resoudreIdJournal = null;
    };
  }, [loading]);
  const dernierUtilisateurTraceRef = useRef(null);
  useEffect(() => {
    if (journalAcces === null) return; // journal pas encore chargé
    if (dernierUtilisateurTraceRef.current === null) {
      dernierUtilisateurTraceRef.current = currentUser;
      tracerAcces("connexion", "Ouverture de l'application");
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, journalAcces]);

  const onglets = [
    { id: "clients", label: "Clients" },
    { id: "fournisseurs", label: "Fournisseurs" },
    { id: "devis", label: "Devis" },
    { id: "commandes", label: "Commandes" },
    { id: "stock", label: "Stock" },
    { id: "catalogue", label: "Catalogue d'articles" },
    { id: "grilleTarifaire", label: "Prix et coûts" },
  ].filter((t) => (t.id === "grilleTarifaire" ? estGerant : user.acces[t.id])); // Nils 05/10 (h5) : onglet réservé à Nils
  // ERP step 11 : onglet « Alertes & tâches », visible par tous.
  onglets.unshift({ id: "alertes", label: "Alertes & tâches" });
  // ERP step 16 (Nils 12/10, lot 2) : projets immobiliers — consultables par qui voit les devis ou les dossiers.
  if (user.acces.devis || user.acces.commandes) onglets.push({ id: "projets", label: "Projets immo" });
  // ERP step 15 (ar) : planning — visible par tous ; Step 17 (Nils 14/10) : sauf sans accès Commandes ni Devis (Salwa).
  if (user.acces.devis || user.acces.commandes) onglets.push({ id: "planning", label: "Planning" });
  // ERP step 15 (ao, Nils 08/10) : le SAV devient un sous-onglet de Commandes (plus d'onglet à part).
  // ERP step 13 (ah) : rapport commercial (commerciaux, Gérant).
  if (peut("commercial.rapport")) onglets.push({ id: "rapportCommercial", label: "Rapport commercial" });
  // Nils 04/10 (ad) : onglet Marketing & community management (Salwa, Gérant).
  if (peut("marketing.acces") || peut("prospects.saisir")) onglets.push({ id: "marketing", label: "Community management" });
  // Nils 04/10 (ae / af) : statistiques (Nils).
  if (peut("stats.voir")) onglets.push({ id: "statistiques", label: "Statistiques" });
  // ERP step 11 : outillage (Nils, Ahmed, Wissam, Soufiane Krim).
  // ERP step 12 (Nils 30/09) : registre d'outillage géré par Nils, Ahmed et Wissam seulement.
  // Nils 03/10 (i) : « Outillage et bureautique » — outillage géré par Ahmed, bureautique par Sawsan.
  if (user.acces.outillage) onglets.push({ id: "outillage", label: "Outillage et bureautique" });
  // ERP step 15 (ak) : véhicules et machines — gestion (Nils, Ahmed, Sawsan) ou conducteur d'un véhicule.
  if (peut("vehicules.gerer") || ((flotte && flotte.vehicules) || []).some((v) => v.actif !== false && (v.conducteurs || []).includes(user.id))) onglets.push({ id: "flotte", label: "Véhicules et machines" });
  // ERP step 12 (validé Nils du 30/09) : Staff — Nils, Sawsan ; Ahmed en lecture partielle.
  if (user.acces.staff) onglets.push({ id: "staff", label: "Staff" });
  // ERP step 11 (demande Nils du 29/09) : réglages regroupés, Nils seul.
  if (peut("admin.parametrage")) onglets.push({ id: "parametrage", label: "Paramétrage" });
  // ERP step 12 (validé Nils du 30/09) : Comptabilité — chacun voit sa caisse, Nils tout.
  // Nils 08/10 (b) : Factures fournisseurs sort de Comptabilité et passe dans Achats.
  if (user.acces.compta && user.acces.compta !== "factures") onglets.push({ id: "compta", label: "Comptabilité" });
  if (user.acces.compta && peut("compta.facturesF.saisir")) onglets.push({ id: "facturesF", label: "Factures fournisseurs" });
  if (peut("achats.transportIntl")) onglets.push({ id: "transportIntl", label: "Transport international" });
  if (estGerant) onglets.push({ id: "commissions", label: "Commissions" });
  const ongletsAVenir = [];
  // Commandes reste surligné sur le sous-onglet SAV.
  function estOngletActif(id) {
    return activeTab === id || (id === "commandes" && activeTab === "sav");
  }
  function basculerRubriqueNav(titre) {
    const next = navReplie.includes(titre) ? navReplie.filter((x) => x !== titre) : [...navReplie, titre];
    setNavReplie(next);
    try { localStorage.setItem(`erp-nav-replie:${user.id}`, JSON.stringify(next)); } catch (e) { /* stockage indisponible */ }
  }
  const peutEcrireStock = user.acces.stock === "ecriture";
  // ERP step 11 (accord Nils du 29/09) : Wissam gère les consommables — lui
  // (et Nils) seuls les enregistrent, production comme pose. Les cases
  // « Aucun consommable » du dossier : Nils, Ahmed, Wissam.
  const peutEnregistrerConso = peut("stock.consommables");
  const peutCocherAucunConso = peut("commandes.aucunConso");
  // Step 12 pt.15 (accord Nils du 21/09) : "+ Nouveau lot", "+ Nouveau
  // consommable" et "Gérer les catégories" n'avaient aucune protection —
  // désormais réservés à l'écriture Stock, sauf cas particulier de Wissam qui
  // garde consommables + catégories mais pas les lots (jamais aux articles Catalogue).
  // ERP step 11 (accord Nils du 29/09) : catégories et sous-catégories de
  // consommables créées/modifiées par Nils seul (les autres font une demande) ;
  // lots de consommables créés par Nils, Ahmed et Wissam ; prix d'achat et
  // target prices visibles par Nils, Wissam et Ahmed seulement.
  const peutGererConsommablesEtCategories = peut("stock.parametrer");
  const peutCreerLot = peutEcrireStock || peut("stock.creerLot");
  const peutDemanderSousCat = !peutGererConsommablesEtCategories && peut("stock.demanderSousCat");
  const peutVoirPrixConso = peut("stock.prixConso");
  const peutEcrireFour = user.acces.fournisseurs === "ecriture";
  // Step 11 (accord Nils du 21/09) : le Registre de crédit n'est plus lié à
  // l'accès Stock — accès en lecture nommé pour nils, taha et Soufiane Chraa
  // (ahmed n'y a plus accès du tout) ; écriture (ajout manuel, suppression
  // d'une entrée, nettoyage de l'historique) réservée à Nils seul.
  const peutVoirRegistreCredit = peut("credit.voir");
  const peutTransformerRDMPL = peut("commandes.transformerRDMPL"); // Step 17 : Nils + ADV
  const voitTauxApporteur = peut("prospects.voirTauxApporteur"); // Step 17 : Nils + ADV senior
  const peutEcrireRegistreCredit = peut("credit.ecrire");
  // ERP step 7 (pt.25) : jusqu'ici le Catalogue était en tout-ou-rien (tab
  // visible = édition complète) — avec l'introduction d'un vrai niveau
  // "lecture" (Taha, Souad, Chraa), les actions d'édition doivent
  // maintenant être filtrées comme elles le sont déjà pour Fournisseurs.
  const peutEcrireCatalogue = user.acces.catalogue === "ecriture";
  const peutEcrireClient = user.acces.clients === "ecriture";
  // ERP step 10 pt.11 : les commerciaux (lecture seule) peuvent proposer un
  // nouveau client, soumis à validation ; ils ne peuvent rien modifier.
  const peutCreerClient = peutEcrireClient || !!user.peutProposerClient;
  // Sawsan valide la 1re étape, Nils la 2de (uniquement après Sawsan).
  const peutValiderClient = (c) => {
    const etape = etapeValidationClient(c);
    // ERP step 10 (accord Nils du 24/09) : Nils peut valider à la place de Sawsan.
    return (etape === "etape1" && (peut("clients.validerEtape1") || peut("clients.validerEtape2"))) || (etape === "etape2" && peut("clients.validerEtape2"));
  };
  // Un commercial restreint ne voit que les clients dont il est le commercial SC.
  const clientVisiblePourUser = (c) => !user.clientsRestreintACommercial || (c && c.commercialSC === user.nom);
  const clientAlertCount = (clients || []).filter((c) => clientVisiblePourUser(c) && clientAlertes(c).length > 0).length;
  const clientsFiltres = useMemo(() => {
    if (!clients) return [];
    const q = clientQuery.trim().toLowerCase();
    // On cherche sur les deux noms : « Mao » doit trouver « Carrera ».
    const filtres = clients.filter(
      (c) => clientVisiblePourUser(c) && (!q || c.nom.toLowerCase().includes(q) || (c.raisonSociale || "").toLowerCase().includes(q))
    );
    // Step 12 pt.11 (accord Nils du 21/09) : clients triés par ordre alphabétique.
    return trierAlpha(filtres, "nom");
  }, [clients, clientQuery, user]);

  async function persistMouvements(next) {
    setMouvements(next);
    try {
      await ecrireStockage(MOUVEMENTS_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde des mouvements", e);
      return false;
    }
  }

  async function persistReservations(next) {
    setReservations(next);
    try {
      await ecrireStockage(RESERVATIONS_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde des réservations", e);
      return false;
    }
  }

  async function persistCreditsTranches(next) {
    setCreditsTranches(next);
    try {
      await ecrireStockage(CREDITS_TRANCHES_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde du registre des tranches exonérables", e);
      return false;
    }
  }

  async function persistCreditsHistorique(next) {
    setCreditsHistorique(next);
    try {
      await ecrireStockage(CREDITS_HISTORIQUE_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde de l'historique du registre de crédit", e);
      return false;
    }
  }
  // Journalise un ou plusieurs mouvements du registre de crédit (Step 11) —
  // à appeler juste après chaque persistCreditsTranches(...) qui modifie
  // effectivement le solde, avec un mouvement par entrée créditée/débitée.
  // `mouvements`: [{ produitId, libelle, sens: "credit"|"debit", quantite, origine }]
  async function journaliserMouvementsCredit(mouvements) {
    const liste = (mouvements || []).filter((m) => m && Number(m.quantite) > 0);
    if (liste.length === 0) return;
    const nouvelles = liste.map((m) => ({
      id: uid(),
      produitId: m.produitId,
      libelle: m.libelle || nomProduit(m.produitId),
      sens: m.sens,
      quantite: Number(Number(m.quantite).toFixed(2)),
      origine: m.origine || "",
      creePar: user.nom,
      creeLe: new Date().toISOString(),
    }));
    await persistCreditsHistorique([...(creditsHistorique || []), ...nouvelles]);
  }

  async function persistLotsArchives(next) {
    setLotsArchives(next);
    try {
      await ecrireStockage(LOTS_ARCHIVES_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde des lots archivés", e);
      return false;
    }
  }
  async function archiverLots(lots, motif) {
    if (!lots || lots.length === 0) return;
    const maintenant = new Date().toISOString();
    const nouveaux = lots.map((l) => {
      const p = produitDe(l.produitId) || {};
      return { ...l, archiveLe: maintenant, archivePar: user.nom, motifArchive: motif, produitSnapshot: { nom: p.nom || "", categorie: p.categorie || "" } };
    });
    await persistLotsArchives([...(lotsArchives || []), ...nouveaux]);
  }

  async function persistCommunications(next) {
    setCommunications(next);
    return await saveKey(COMMUNICATIONS_KEY, next);
  }
  async function persistLecturesCom(next) {
    setLecturesCom(next);
    return await saveKey(LECTURES_COM_KEY, next);
  }
  async function persistIncidents(next) {
    setIncidents(next);
    try {
      await ecrireStockage(INCIDENTS_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde des incidents de production", e);
      return false;
    }
  }
  async function persistPlansRecuperes(next) {
    setPlansRecuperes(next);
    try {
      await ecrireStockage(PLANS_RECUPERES_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde du registre des plans récupérés", e);
      return false;
    }
  }
  async function persistEnService(next) {
    setEnService(next);
    try {
      await ecrireStockage(EN_SERVICE_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde des articles en service", e);
      return false;
    }
  }
  async function persistAffectations(next) {
    derniersStaffRef.current.valeurs = { ...(derniersStaffRef.current.valeurs || {}), affectationsBrutes: next };
    setAffectations(next);
    try {
      await ecrireStockage(AFFECTATIONS_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde des affectations", e);
      return false;
    }
  }
  // ---- ERP step 11 : consommables à consommation lente (« en service ») ----
  function estConsoLent(produit) {
    return !!produit && estCategorieConsommable(produit.categorie) && normaliserVitesse(produit.vitesse) === "Lente";
  }
  function seuilUsureAnormalePct() {
    const v = parametres && parametres.seuilUsureAnormalePct;
    return v !== undefined && v !== null && v !== "" && isFinite(Number(v)) ? Number(v) : SEUIL_USURE_ANORMALE_PCT;
  }
  // Date à laquelle la matière du PL a été enregistrée au Stock (= date de production retenue).
  function dateEnregistrementPL(numeroPL) {
    let d = null;
    (mouvements || []).forEach((m) => {
      if (m.pl === numeroPL && !estMouvementConsommable(m) && m.creeLe && (!d || m.creeLe < d)) d = m.creeLe;
    });
    return d;
  }
  // ERP step 16 (Nils 12/10) : usure d'un consommable en service, mesurée selon le réglage « Usure comptée »
  // de sa sous-catégorie :
  // - à la tranche (défaut) : tranches réellement sorties sur les PL — une machine (base transformation)
  //   compte les dossiers avec un article de façonnage, un poseur (base pose) ceux avec un article de pose
  //   où il figure sur la fiche de pose ; seules les matières traitées par la sous-catégorie comptent ;
  // - à la découpe : quantités des articles de découpe unitaire cochés sur la sous-catégorie.
  // Machines : PL où Ahmed l'a cochée (plusieurs : parts égales ; aucune : partage entre les machines
  // qui ont ce consommable en service ce jour-là) — inchangé depuis le 04/10.
  function usureCompteeDe(produitId) {
    const p = (produits || []).find((x) => x.id === produitId);
    return p && p.usureComptee === "decoupe" ? "decoupe" : "tranche";
  }
  function baseUsureEntre(base, debutISO, finISO, e) {
    if (!base) return 0;
    const produit = e ? (produits || []).find((x) => x.id === e.produitId) : null;
    const matieres = produit && Array.isArray(produit.matieresTraitees) ? produit.matieresTraitees : [];
    const aLaDecoupe = !!produit && produit.usureComptee === "decoupe";
    const artsDecoupe = produit && Array.isArray(produit.articlesDecoupe) ? produit.articlesDecoupe : [];
    const aff = e ? (affectations || []).find((a) => a.id === e.affectationId) : null;
    const estMachine = e && (e.affectationType === "machine" || (aff && aff.type === "machine"));
    // Nils 30/10 : un service (équipe, ex. Service finition) compte toutes les tranches de sa base, sans partage ni poseur.
    const estService = e && (e.affectationType === "service" || (aff && aff.type === "service"));
    const estPoseur = e && !estMachine && !estService && base === "pose";
    let total = 0;
    (commandesListe || []).forEach((c) => {
      if (!c.numeroPL) return;
      const d = dateEnregistrementPL(c.numeroPL);
      if (!d || d < debutISO || (finISO && d > finISO)) return;
      let qte = 0;
      if (aLaDecoupe) {
        qte = (lignesDuDossier(c) || []).filter((l) => (!l.type || l.type === "facture") && l.articleId && artsDecoupe.includes(l.articleId)).reduce((n, l) => n + (Number(l.qte) || 0), 0);
      } else {
        if (!dossierNature(c, base === "pose" ? "pose" : "faconnage")) return;
        qte = (mouvements || []).filter((m) => m.type === "sortie" && plDuDossier(c, m) && !estMouvementConsommable(m) && !m.enService).reduce((n, m) => {
          const lot = lotParId(m.itemId);
          if (!lot || !estLotTranche(lot)) return n;
          const pr = produitDe(lot.produitId) || lot.produitSnapshot || {};
          if (matieres.length && !matieres.includes(pr.categorie)) return n;
          return n + (Number(m.quantite) || 0);
        }, 0);
      }
      if (!qte) return;
      let facteur = 1;
      if (estMachine) {
        const coches = Array.isArray(c.machinesPL) ? c.machinesPL : [];
        if (coches.length) facteur *= coches.includes(e.affectationId) ? 1 / coches.length : 0;
        else {
          const jour = d.slice(0, 10);
          const machines = new Set((enService || []).filter((x) => x.produitId === e.produitId && (x.affectationType === "machine" || ((affectations || []).find((a) => a.id === x.affectationId) || {}).type === "machine") && x.misEnServiceLe <= jour && (x.statut !== "hors service" || !x.finLe || x.finLe >= jour)).map((x) => x.affectationId));
          machines.add(e.affectationId);
          facteur *= 1 / machines.size;
        }
      }
      if (estPoseur) {
        const nom = normNomStaff(e.affectationNom || (aff && aff.nom) || "");
        const poseurs = ((c.fichePose && c.fichePose.poseurs) || []).map(normNomStaff);
        if (!poseurs.includes(nom)) facteur = 0;
      }
      total += qte * facteur;
    });
    return Number(total.toFixed(2));
  }
  function joursEntre(debutISO, finISO) {
    const d1 = new Date(debutISO).getTime();
    const d2 = finISO ? new Date(finISO).getTime() : Date.now();
    return Math.max(0, Math.round((d2 - d1) / 86400000));
  }
  function statsArticleEnService(e) {
    const fin = e.statut === "hors service" ? e.finLe : null;
    const finIso = fin ? `${fin}T23:59:59.999Z` : null;
    const debutIso = `${e.misEnServiceLe}T00:00:00.000Z`;
    const tranches = baseUsureEntre(e.base, debutIso, finIso, e);
    const jours = joursEntre(debutIso, finIso);
    const coutParTranche = tranches > 0 && e.prixUnitaireHT ? e.prixUnitaireHT / tranches : null;
    // ERP step 16 : « tranches » = quantité dans l'unité d'usure de la sous-catégorie (tranches ou découpes).
    const unite = usureCompteeDe(e.produitId) === "decoupe" ? "déc." : "tr.";
    return { tranches, jours, coutParTranche, unite };
  }
  const peutGererEnService = peut("stock.consommables");
  async function enregistrerMiseEnService() {
    if (!peutGererEnService) return;
    if (bloqueParInventaire()) return;
    const m = miseEnService;
    const lot = (items || []).find((it) => it.id === m.lotId);
    const aff = (affectations || []).find((a) => a.id === m.affectationId);
    const q = Math.round(Number(m.quantite));
    if (!lot || !aff || !q || q < 1) {
      setNotice("Choisis la sous-catégorie, le lot, la quantité (entier ≥ 1) et l'affectation.");
      return;
    }
    if (q > (Number(lot.stockReel) || 0)) {
      setNotice(`Stock insuffisant sur ce lot : ${lot.stockReel} ${lot.unite} disponible(s).`);
      return;
    }
    const date = m.date || todayISO();
    const horodatage = new Date().toISOString();
    await persist((items || []).map((it) => (it.id === lot.id ? { ...it, stockReel: Number(((Number(it.stockReel) || 0) - q).toFixed(2)) } : it)));
    await persistMouvements([
      ...(mouvements || []),
      { id: uid(), itemId: lot.id, type: "sortie", quantite: q, unite: lot.unite, doc: "", date, note: `Mise en service — ${aff.nom}`, pl: "", enService: true, creeLe: horodatage },
    ]);
    const nouveaux = Array.from({ length: q }, () => ({
      id: uid(),
      lotId: lot.id,
      produitId: lot.produitId,
      prixUnitaireHT: lot.prixAchatHT !== undefined && lot.prixAchatHT !== null && lot.prixAchatHT !== "" ? Number(lot.prixAchatHT) : null,
      affectationId: aff.id,
      affectationNom: aff.nom,
      affectationType: aff.type,
      base: aff.base,
      misEnServiceLe: date,
      par: user.nom,
      statut: "en service",
    }));
    await persistEnService([...(enService || []), ...nouveaux]);
    await tracerAcces("mise en service", `${q} × ${nomProduit(lot.produitId)} → ${aff.nom}`);
    setMiseEnService({ produitId: "", lotId: "", quantite: "1", affectationId: "", date: "" });
    setNotice(`${q} × ${nomProduit(lot.produitId)} mis en service (${aff.nom}).`);
  }
  async function confirmerHorsService() {
    if (!peutGererEnService || !horsServiceEdit) return;
    const e = (enService || []).find((x) => x.id === horsServiceEdit.id);
    if (!e) return;
    const motif = horsServiceEdit.motif;
    const finLe = horsServiceEdit.date || todayISO();
    if (!motif) {
      setNotice("Indique le motif de mise hors service.");
      return;
    }
    if (finLe < e.misEnServiceLe) {
      setNotice("La date de fin ne peut pas précéder la mise en service.");
      return;
    }
    const maj = { ...e, statut: "hors service", finLe, motif, finPar: user.nom };
    await persistEnService((enService || []).map((x) => (x.id === e.id ? maj : x)));
    const st = statsArticleEnService(maj);
    const lib = `${nomProduit(e.produitId)} (${e.affectationNom})`;
    if (motif !== "Usure normale") {
      await alerter(`Consommable lent : ${motif.toLowerCase()}`, `${lib} déclaré « ${motif} » après ${st.jours} jour(s)${e.prixUnitaireHT ? ` — valeur ${formatDH(e.prixUnitaireHT)} HT` : ""}`, { kind: "onglet", id: "stock" });
    } else {
      const precedents = (enService || []).filter((x) => x.id !== e.id && x.produitId === e.produitId && x.statut === "hors service" && x.motif === "Usure normale");
      if (precedents.length >= 2) {
        const moyenne = precedents.reduce((s2, x) => s2 + statsArticleEnService(x).jours, 0) / precedents.length;
        if (moyenne > 0 && st.jours < moyenne * (seuilUsureAnormalePct() / 100)) {
          await alerter("Usure anormale", `${lib} usé en ${st.jours} jour(s) pour une moyenne de ${Math.round(moyenne)} jour(s) (seuil ${seuilUsureAnormalePct()} %)`, { kind: "onglet", id: "stock" });
        }
      }
    }
    await tracerAcces("mise hors service", `${lib} — ${motif} — ${st.jours} jour(s), ${st.tranches} ${st.unite === "déc." ? "découpe(s)" : "tranche(s)"}`);
    setHorsServiceEdit(null);
  }
  // ERP step 12 : ici, machines et lieux seulement — les personnes se gèrent
  // dans l'onglet Staff.
  // Nils 04/10 : machines = Nils + Ahmed ; bureaux = aussi les gestionnaires d'outillage / de bureautique.
  // Nils 30/10 : services (équipes, ex. Service finition) — même droit que les machines ; consommables en service, pas d'outils.
  function peutGererAffectationType(type) {
    if (peut("stock.parametrer")) return true;
    return type === "machine" || type === "service" ? peut("affectations.machines") : type === "bureau" ? peut("affectations.bureaux") : false;
  }
  function typesAffectationGerables() {
    return ["machine", "service", "bureau"].filter(peutGererAffectationType);
  }
  // Création rapide depuis « Remis à » (outillage / bureautique) : renvoie l'id créé.
  async function creerDetenteurRapide(nomSaisi, type) {
    const nom = (nomSaisi || "").trim();
    if (!nom || !peutGererAffectationType(type)) return null;
    if ((affectations || []).some((a) => a.nom.toLowerCase() === nom.toLowerCase())) { setNotice("Ce nom existe déjà parmi les détenteurs."); return null; }
    const nouv = { id: uid(), nom, type, base: "transformation", actif: true, creePar: user.nom, creeLe: new Date().toISOString() };
    await persistAffectations([...(affectationsBrutes || []), nouv]);
    await tracerAcces(`${LIB_TYPE_AFFECTATION[type].toLowerCase()} créé${type === "machine" ? "e" : ""}`, nom);
    return nouv.id;
  }
  async function ajouterAffectation(typeForce) {
    const typeA = typeForce || nouvelleAffectation.type;
    if (!peutGererAffectationType(typeA)) return;
    const nom = (nouvelleAffectation.nom || "").trim();
    if (!nom) return;
    if (nouvelleAffectation.type === "personne") {
      setNotice("Les personnes se gèrent dans l'onglet Staff (case « Usure des consommables »).");
      return;
    }
    if ((affectations || []).some((a) => a.nom.toLowerCase() === nom.toLowerCase())) {
      setNotice("Cette affectation existe déjà.");
      return;
    }
    await persistAffectations([...(affectationsBrutes || []), { id: uid(), nom, type: typeA, base: nouvelleAffectation.base || "transformation", actif: true, creePar: user.nom, creeLe: new Date().toISOString() }]);
    await tracerAcces(`${LIB_TYPE_AFFECTATION[typeA].toLowerCase()} créé${typeA === "machine" ? "e" : ""}`, nom);
    setNouvelleAffectation({ nom: "", type: typeA, base: "transformation" });
  }
  async function basculerAffectation(id) {
    const a = (affectationsBrutes || []).find((x) => x.id === id);
    if (!a || !peutGererAffectationType(a.type)) return; // personne : onglet Staff
    // Nils 04/10 (d) : pas de désactivation tant que des consommables en service ou des outils y sont affectés.
    if (a.actif) {
      const enCours = affectationOccupee(id);
      if (enCours.length) { setNotice(`Impossible de désactiver « ${a.nom} » : ${enCours.join(", ")}. Mets-les hors service ou transfère-les d'abord.`); return; }
    }
    await persistAffectations((affectationsBrutes || []).map((x) => (x.id === id ? { ...x, actif: !x.actif } : x)));
    await tracerAcces(a.actif ? "affectation désactivée" : "affectation réactivée", a.nom);
  }
  // Liste des machines et bureaux (Stock › Consommables en service, et Outillage et bureautique).
  function blocMachinesBureaux(typesVus) {
    const types = typesVus || ["machine", "service", "bureau"];
    const gerables = typesAffectationGerables().filter((t) => types.includes(t));
    const typeNouveau = gerables.includes(nouvelleAffectation.type) ? nouvelleAffectation.type : gerables[0];
    return (
      <>
        <div style={{ fontSize: 12, color: TAUPE, marginBottom: 6 }}>Les personnes se gèrent dans l'onglet Staff. Une machine reçoit des consommables en service et des outils ; {types.includes("service") && "un service (équipe, ex. Service finition) reçoit des consommables en service, pas d'outils ; "}un bureau reçoit des outils et du matériel bureautique partagés entre plusieurs personnes (pas de consommables).</div>
        {(affectationsBrutes || []).filter((a) => types.includes(a.type)).map((a) => {
          const ok = peutGererAffectationType(a.type);
          return (
            <div key={a.id} style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 13, padding: "3px 0", opacity: a.actif ? 1 : 0.5 }}>
              <span style={{ flex: 1 }}>{iconeAffectation(a)}{a.nom} <span style={{ color: TAUPE }}>{a.type === "bureau" ? "— bureau (outillage, bureautique)" : `— ${a.type === "service" ? "service" : "machine"}, base ${a.base === "pose" ? "pose" : "transformation"}`}</span></span>
              {ok && <button type="button" className="sc-btn" onClick={() => renommerAffectation(a)} style={{ ...iconBtnStyle }} title="Renommer">✎</button>}
              {ok && !affectationAServi(a.id) && <button type="button" className="sc-btn" onClick={() => supprimerAffectation(a)} style={{ ...iconBtnStyle }} title="Supprimer (jamais utilisée)">✕</button>}
              {ok && <button type="button" className="sc-btn" onClick={() => basculerAffectation(a.id)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 0" }}>{a.actif ? "Désactiver" : "Réactiver"}</button>}
            </div>
          );
        })}
        {gerables.length > 0 && (
          <div style={{ display: "flex", gap: 8, marginTop: 6, flexWrap: "wrap" }}>
            <input className="sc-input" value={nouvelleAffectation.nom} onChange={(e) => setNouvelleAffectation({ ...nouvelleAffectation, nom: e.target.value })} placeholder={typeNouveau === "bureau" ? "ex. Bureau Marrakech (Sidi Ghanem), Bureau usine" : typeNouveau === "service" ? "ex. Service finition, Service pose" : "ex. Débiteuse 1, Camion 1"} style={{ ...inputStyle(280) }} />
            <select className="sc-select" value={typeNouveau} onChange={(e) => setNouvelleAffectation({ ...nouvelleAffectation, type: e.target.value, base: "transformation" })} style={{ ...selectStyle, width: 130 }}>
              {gerables.map((t) => <option key={t} value={t}>{LIB_TYPE_AFFECTATION[t]}</option>)}
            </select>
            {typeNouveau === "service" && (
              <select className="sc-select" value={nouvelleAffectation.base === "pose" ? "pose" : "transformation"} onChange={(e) => setNouvelleAffectation({ ...nouvelleAffectation, type: "service", base: e.target.value })} style={{ ...selectStyle, width: 190 }} title="Tranches comptées pour l'usure">
                <option value="transformation">Base transformation</option>
                <option value="pose">Base pose</option>
              </select>
            )}
            <button type="button" className="sc-btn" onClick={() => { if (nouvelleAffectation.type !== typeNouveau) setNouvelleAffectation({ ...nouvelleAffectation, type: typeNouveau }); ajouterAffectation(typeNouveau); }} style={ghostBtnStyle}>+ Ajouter</button>
          </div>
        )}
      </>
    );
  }
  // Nils 04/10 (b, c) : renommer une machine / un bureau ; supprimer seulement s'il n'a jamais servi.
  function affectationAServi(id) {
    return (enService || []).some((e) => e.affectationId === id) ||
      (outils || []).some((o) => o.detenteurId === id || (o.historique || []).some((h) => h.vers === id || h.de === id || h.detenteur === id || h.imputeA === id)) ||
      (mouvements || []).some((m) => m.affectationId === id);
  }
  function affectationOccupee(id) {
    const r = [];
    const nbConso = (enService || []).filter((e) => e.affectationId === id && e.statut === "en service").length;
    if (nbConso) r.push(`${nbConso} consommable(s) en service`);
    const nbOutils = (outils || []).filter((o) => o.detenteurId === id && o.etat !== ETAT_SORTI_PARC).length;
    if (nbOutils) r.push(`${nbOutils} outil(s) / matériel(s) détenu(s)`);
    return r;
  }
  async function renommerAffectation(a) {
    if (!a || !peutGererAffectationType(a.type)) return;
    const nom = await demander(`Nouveau nom pour « ${a.nom} » :`, { saisie: true });
    const n = (nom || "").trim();
    if (!n || n === a.nom) return;
    if ((affectations || []).some((x) => x.id !== a.id && x.nom.toLowerCase() === n.toLowerCase())) { setNotice("Ce nom est déjà utilisé."); return; }
    await persistAffectations((affectationsBrutes || []).map((x) => (x.id === a.id ? { ...x, nom: n } : x)));
    await tracerAcces("affectation renommée", `${a.nom} → ${n}`);
  }
  async function supprimerAffectation(a) {
    if (!a || !peutGererAffectationType(a.type)) return;
    if (affectationAServi(a.id)) { setNotice(`« ${a.nom} » a déjà servi (consommables ou outils) : on ne peut que la désactiver, pour garder l'historique.`); return; }
    if (!await demander(`Supprimer « ${a.nom} » ?`)) return;
    await persistAffectations((affectationsBrutes || []).filter((x) => x.id !== a.id));
    await tracerAcces("affectation supprimée", a.nom);
  }

  // ---- ERP step 12 : Staff ----
  const peutGererStaff = peut("staff.gerer");
  const peutVoirStaff = peutGererStaff || peut("staff.equipe");
  function staffVisible(s) {
    if (ficheStaffMasquee(s)) return false;
    if (peutGererStaff) return true;
    if (!peut("staff.equipe")) return false;
    return s.compte === user.id || dansPerimetre(s, staff, user.id);
  }
  function paramsConges() {
    return { ...DEFAULT_PARAMS_CONGES, ...((parametres && parametres.conges) || {}) };
  }
  async function persistStaff(next) {
    const n = (next || []).map(normaliserFicheStaff);
    derniersStaffRef.current.valeurs = { ...(derniersStaffRef.current.valeurs || {}), staff: n };
    setStaff(n);
    return await saveKey(STAFF_KEY, n);
  }
  function typesContrat() {
    const t = parametres && parametres.typesContrat;
    return trierAlpha(Array.isArray(t) ? t : DEFAULT_TYPES_CONTRAT);
  }
  async function ajouterTypeContrat() {
    if (!peutGererStaff) return;
    const v = nouveauTypeContrat.trim();
    if (!v) return;
    if (typesContrat().some((x) => x.toLowerCase() === v.toLowerCase())) { setNotice("Ce type de contrat existe déjà."); return; }
    await persistParametres({ ...(parametres || {}), typesContrat: [...typesContrat(), v] });
    await tracerAcces("type de contrat ajouté", v);
    setNouveauTypeContrat("");
  }
  async function supprimerTypeContrat(t) {
    if (!peutGererStaff) return;
    const utilise = (staff || []).filter((s) => s.contrat === t);
    if (utilise.length > 0) { setNotice(`Impossible de supprimer « ${t} » : ${utilise.length} fiche(s) l'utilisent (${utilise.slice(0, 5).map((s) => s.nom).join(", ")}${utilise.length > 5 ? "…" : ""}). Change d'abord leur contrat.`); return; }
    await persistParametres({ ...(parametres || {}), typesContrat: typesContrat().filter((x) => x !== t) });
    await tracerAcces("type de contrat supprimé", t);
  }
  async function renommerTypeContrat(ancien, nouveau) {
    if (!peutGererStaff) return;
    const v = (nouveau || "").trim();
    if (!v || v === ancien) return;
    if (typesContrat().some((x) => x.toLowerCase() === v.toLowerCase())) { setNotice("Ce type de contrat existe déjà."); return; }
    await persistParametres({ ...(parametres || {}), typesContrat: typesContrat().map((x) => (x === ancien ? v : x)) });
    if ((staff || []).some((s) => s.contrat === ancien)) await persistStaff((staff || []).map((s) => (s.contrat === ancien ? { ...s, contrat: v } : s)));
    await tracerAcces("type de contrat renommé", `${ancien} → ${v}`);
  }
  // Ce qui rattache une fiche à l'historique (empêche sa suppression).
  function referencesStaff(s) {
    const refs = [];
    const nbService = (enService || []).filter((e) => e.affectationId === s.id).length;
    if (nbService) refs.push(`${nbService} consommable(s) mis en service`);
    const nbOutils = (outils || []).filter((o) => o.detenteurId === s.id || (o.historique || []).some((h) => h.vers === s.id || h.de === s.id || h.detenteur === s.id || h.imputeA === s.id)).length;
    if (nbOutils) refs.push(`${nbOutils} outil(s) (détenus ou historique)`);
    const noms = new Set([s.nom, ...(s.anciensNoms || [])].map(normNomStaff));
    const nbPose = (commandesListe || []).filter((c) => {
      const fp = c.fichePose;
      if (!fp) return false;
      return [...(fp.poseurs || []), ...(fp.aidesPoseurs || []), fp.controleQualite, fp.controleChargement, fp.controlePose].some((x) => x && noms.has(normNomStaff(x)));
    }).length;
    if (nbPose) refs.push(`${nbPose} fiche(s) de pose`);
    return refs;
  }
  function anciennete(dateDebut, dateFin) {
    if (!dateDebut) return "";
    const fin = dateFin && dateFin < todayISO() ? new Date(dateFin) : new Date();
    const j = Math.max(0, Math.round((fin - new Date(dateDebut)) / 86400000));
    const ans = j / 365.25;
    return ans >= 1 ? `${ans.toFixed(1).replace(".", ",")} an(s)` : `${Math.max(0, Math.floor(j / 30.44))} mois`;
  }
  function ficheStaffIncomplete(s) {
    const manque = [];
    if (!s.service) manque.push("service");
    if (!s.contrat) manque.push("contrat");
    if (!s.dateEmbauche) manque.push("date d'embauche");
    if (!s.nomFamille) manque.push("nom");
    return manque;
  }
  async function enregistrerFicheStaff() {
    if (!peutGererStaff || !staffEdit) return;
    const f = { ...staffEdit, prenom: (staffEdit.prenom || "").trim(), nomFamille: (staffEdit.nomFamille || "").trim(), poste: (staffEdit.poste || "").trim(), telephonePro: (staffEdit.telephonePro || "").trim(), telephonePerso: (staffEdit.telephonePerso || "").trim(), note: (staffEdit.note || "").trim() };
    f.nom = nomCompletStaff(f.prenom, f.nomFamille);
    if (!f.prenom) { setNotice("Indique le prénom de la personne."); return; }
    const autre = (staff || []).find((s) => s.id !== f.id && normNomStaff(s.nom) === normNomStaff(f.nom));
    if (autre) { setNotice(`Une fiche « ${autre.nom} » existe déjà.`); return; }
    if (f.compte) {
      const dejaLie = (staff || []).find((s) => s.id !== f.id && s.compte === f.compte);
      if (dejaLie) { setNotice(`Le compte ERP ${(utilisateurs.find((u) => u.id === f.compte) || {}).nom || f.compte} est déjà lié à la fiche « ${dejaLie.nom} ».`); return; }
    }
    if (f.dateSortie && f.dateEmbauche && f.dateSortie < f.dateEmbauche) { setNotice("La date de sortie ne peut pas être avant la date d'embauche."); return; }
    const maintenant = new Date().toISOString();
    const existe = !!f.id && (staff || []).some((s) => s.id === f.id);
    const avant = existe ? (staff || []).find((s) => s.id === f.id) : null;
    if (avant && avant.nom && avant.nom !== f.nom) f.anciensNoms = [...new Set([...(avant.anciensNoms || []), avant.nom])];
    const toSave = existe ? { ...f, modifiePar: user.nom, modifieLe: maintenant } : { ...f, id: uid(), creePar: user.nom, creeLe: maintenant };
    await persistStaff(existe ? (staff || []).map((s) => (s.id === toSave.id ? toSave : s)) : [...(staff || []), toSave]);
    if (!existe) {
      await tracerAcces("fiche staff créée", `${toSave.nom}${toSave.service ? ` — ${toSave.service}` : ""}`);
    } else if (avant && !avant.dateSortie && toSave.dateSortie) {
      await tracerAcces("fiche staff : sortie", `${toSave.nom} — sortie le ${formatDate(toSave.dateSortie)}`);
    } else {
      await tracerAcces("fiche staff modifiée", toSave.nom);
    }
    setStaffEdit(null);
    setNotice(`Fiche « ${toSave.nom} » enregistrée.`);
  }
  async function supprimerFicheStaff() {
    if (!peutGererStaff || !staffEdit || !staffEdit.id) return;
    const s = (staff || []).find((x) => x.id === staffEdit.id);
    if (!s) return;
    const refs = referencesStaff(s);
    if (refs.length > 0) {
      setConfirmSupprStaff(false);
      setNotice(`Impossible de supprimer « ${s.nom} » : ${refs.join(", ")}. Indique plutôt une date de sortie (la fiche passe en « Sortis » et disparaît des listes de choix).`);
      return;
    }
    await persistStaff((staff || []).filter((x) => x.id !== s.id));
    await tracerAcces("fiche staff supprimée", s.nom);
    setConfirmSupprStaff(false);
    setStaffEdit(null);
    setNotice(`Fiche « ${s.nom} » supprimée.`);
  }
  // ---- ERP step 12 : suivi du personnel ----
  async function persistSuiviMensuel(next) {
    setSuiviMensuel(next);
    return await saveKey(SUIVI_MENSUEL_KEY, next);
  }
  async function persistSignalements(next) {
    setSignalements(next);
    return await saveKey(SIGNALEMENTS_KEY, next);
  }
  function nomStaff(id) {
    const s = (staff || []).find((x) => x.id === id);
    return s ? s.nom : "—";
  }
  function salaireActuel(s) {
    const l = [...(s.salaires || [])].filter((x) => x.dateEffet <= todayISO()).sort((a, b) => (a.dateEffet < b.dateEffet ? 1 : -1))[0];
    return l ? Number(l.net) || 0 : null;
  }
  // Nils 05/10 (h3) : salaire brut (CNSS et AMO compris) — base du coût de main-d'œuvre.
  function salaireBrutAu(s, dateISO) {
    const l = [...(s.salaires || [])].filter((x) => x.dateEffet <= (dateISO || todayISO())).sort((a, b) => (a.dateEffet < b.dateEffet ? 1 : -1))[0];
    return l && nombreOuZero(l.brut) > 0 ? nombreOuZero(l.brut) : null;
  }
  async function majBrutSalaire(staffId, ligneId, valeur) {
    if (!peutGererStaff) return;
    const s = (staff || []).find((x) => x.id === staffId);
    const l = s && (s.salaires || []).find((x) => x.id === ligneId);
    if (!l) return;
    const v = String(valeur ?? "").trim() === "" ? "" : nombreOuZero(valeur);
    if (String(l.brut ?? "") === String(v)) return;
    const maj = { ...s, salaires: s.salaires.map((x) => (x.id === ligneId ? { ...x, brut: v, brutModifiePar: user.nom, brutModifieLe: new Date().toISOString() } : x)) };
    await persistStaff((staff || []).map((x) => (x.id === s.id ? maj : x)));
    await tracerAcces("salaire brut modifié", `${s.nom} — ligne du ${formatDate(l.dateEffet)} : brut ${l.brut ? formatDH(Number(l.brut)) : "—"} → ${v === "" ? "—" : formatDH(v)}`);
    if (staffEdit && staffEdit.id === s.id) setStaffEdit({ ...staffEdit, salaires: maj.salaires });
  }
  // Contrôle semestriel des bruts (Sawsan), alerte à Nils si non fait 30 jours après le début du semestre.
  function controleBrutDuSemestre(sem) {
    return ((parametres && parametres.controlesBrut) || {})[sem] || null;
  }
  async function validerControleBrut() {
    if (!peutGererStaff || !parametres) return;
    const sem = semestreDe(todayISO());
    await persistParametres({ ...parametres, controlesBrut: { ...(parametres.controlesBrut || {}), [sem]: { par: user.nom, le: new Date().toISOString() } } });
    await tracerAcces("salaires bruts vérifiés", libSemestre(sem));
    setNotice(`Salaires bruts vérifiés pour le ${libSemestre(sem)}.`);
  }
  useEffect(() => {
    if (loading || !parametres) return;
    const sem = semestreDe(todayISO());
    if (controleBrutDuSemestre(sem) || ((parametres.alertesBrut || {})[sem])) return;
    const debut = new Date(`${bornesSemestre(sem)[0]}T00:00:00`);
    if ((Date.now() - debut.getTime()) / 86400000 <= 30) return;
    (async () => {
      await persistParametres({ ...parametres, alertesBrut: { ...(parametres.alertesBrut || {}), [sem]: new Date().toISOString() } });
      await alerter("Salaires bruts non vérifiés", `Le contrôle semestriel des salaires bruts (${libSemestre(sem)}) n'a pas été fait par Sawsan après 30 jours.`, { kind: "onglet", id: "staff" });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, parametres]);
  async function ajouterSalaire() {
    if (!peutGererStaff || !staffEdit || !staffEdit.id) return;
    const net = Number(String(salaireSaisie.net).replace(",", "."));
    const brut = Number(String(salaireSaisie.brut).replace(",", "."));
    if (!salaireSaisie.dateEffet) { setNotice("Indique la date d'effet."); return; }
    if (!isFinite(net) || net <= 0) { setNotice("Indique un salaire net valide."); return; }
    if (!isFinite(brut) || brut <= 0) { setNotice("Indique le salaire brut (CNSS et AMO compris)."); return; }
    if (brut < net) { setNotice("Le brut ne peut pas être inférieur au net."); return; }
    const s = (staff || []).find((x) => x.id === staffEdit.id);
    if (!s) return;
    const precedent = [...(s.salaires || [])].filter((x) => x.dateEffet < salaireSaisie.dateEffet).sort((a, b) => (a.dateEffet < b.dateEffet ? 1 : -1))[0];
    const type = salaireSaisie.type || (precedent ? "Augmentation" : "Embauche");
    const ligne = { id: uid(), dateEffet: salaireSaisie.dateEffet, net, brut, type, motif: (salaireSaisie.motif || "").trim(), par: user.nom, le: new Date().toISOString() };
    const maj = { ...s, salaires: [...(s.salaires || []), ligne] };
    await persistStaff((staff || []).map((x) => (x.id === s.id ? maj : x)));
    await tracerAcces("salaire enregistré", `${s.nom} — ${formatDH(net)} net au ${formatDate(ligne.dateEffet)}${precedent ? ` (précédent ${formatDH(Number(precedent.net) || 0)})` : ""}`);
    setStaffEdit({ ...staffEdit, salaires: maj.salaires });
    setSalaireSaisie({ dateEffet: "", net: "", brut: "", motif: "", type: "" });
  }
  // ---- ERP step 12 (Nils 30/09) : primes ----
  function typesPrimes() {
    const t = parametres && parametres.typesPrimes;
    return Array.isArray(t) && t.length ? t : DEFAULT_TYPES_PRIMES;
  }
  // Types proposés au versement par une caisse : la productivité (fixe) puis la liste de Paramétrage.
  function typesPrimesVersees() {
    return [TYPE_PRIME_PRODUCTIVITE, ...typesPrimes().filter((t) => normLib(t) !== normLib(TYPE_PRIME_PRODUCTIVITE))];
  }
  // Dernière prime d'un type : accordée dans la fiche ou versée par une caisse (Nils 23/10).
  function dernierePrime(s, type) {
    return [...(s.primes || []), ...versementsPrimesDe(s)].filter((p) => p.type === type).sort((a, b) => (a.date < b.date ? 1 : -1))[0] || null;
  }
  // ---- Nils 23/10 (a-d) : primes versées par les caisses, lues dans la fiche Staff (rien n'est recopié) ----
  function estVersementPrime(o) {
    return !!o && !o.miroirDe && o.type !== "transfert" && o.sens === "sortie" && o.tiersType === "employe" && SOUS_POSTES_PRIMES_VERSEES.includes(o.sousPoste);
  }
  function fichesStaffDuNom(nom) {
    const n = normNomStaff(nom);
    return n ? (staff || []).filter((x) => [x.nom, ...(x.anciensNoms || [])].some((y) => normNomStaff(y) === n)) : [];
  }
  // Fiche gardée sur la sortie à l'enregistrement ; sinon par le nom, seulement s'il est porté par une seule fiche.
  function staffIdVersement(o) {
    if (o.staffId) return o.staffId;
    const fs = fichesStaffDuNom(o.tiers);
    return fs.length === 1 ? fs[0].id : null;
  }
  function versementsPrimesDe(s) {
    return (s && versementsPrimes.parStaff[s.id]) || [];
  }
  function totalVersesAnnee(s, annee) {
    return versementsPrimesDe(s).filter((v) => (v.date || "").startsWith(`${annee}-`)).reduce((n, v) => n + v.montant, 0);
  }
  // Productivité : accordée (semaines validées) − versée (caisses).
  function resteProductivite(s) {
    const accorde = (s.primes || []).filter((p) => p.type === TYPE_PRIME_PRODUCTIVITE).reduce((n, p) => n + (Number(p.montant) || 0), 0);
    const verse = versementsPrimesDe(s).filter((v) => v.type === TYPE_PRIME_PRODUCTIVITE).reduce((n, v) => n + v.montant, 0);
    return arrondiH(accorde - verse);
  }
  // ---- Nils 23/10 (e) : versement groupé de primes depuis une caisse (une sortie par personne) ----
  function personnesVersementPrimes() {
    return trierAlpha((staff || []).filter((x) => staffActif(x) && !ficheStaffMasquee(x)), "nom");
  }
  function montantsVersementPrimes(typePrime) {
    const m = {};
    personnesVersementPrimes().forEach((x) => {
      if (typePrime === TYPE_PRIME_PRODUCTIVITE && peut("staff.primes")) { const r = resteProductivite(x); if (r > 0) m[x.id] = String(r); return; }
      const d = typePrime ? dernierePrime(x, typePrime) : null;
      if (d) m[x.id] = String(Number(d.montant) || "");
    });
    return m;
  }
  function ouvrirVersementPrimes(compteId) {
    setVersementPrimes({ compteId, date: todayISO(), typePrime: TYPE_PRIME_PRODUCTIVITE, designation: "", montants: montantsVersementPrimes(TYPE_PRIME_PRODUCTIVITE) });
  }
  async function enregistrerVersementPrimes() {
    const v = versementPrimes;
    const compte = v && compteDe(v.compteId);
    if (!compte || !peutSaisirCompte(compte)) return;
    if (!v.date) { setNotice("Indique la date du versement."); return; }
    if (!v.typePrime) { setNotice("Choisis le type de prime."); return; }
    if (!(v.designation || "").trim()) { setNotice("Indique la désignation (ex. S2 et S3 septembre)."); return; }
    if (moisVerrouille(compte.id, v.date)) { setNotice(`${libMois(v.date.slice(0, 7))} est clôturé sur ${compte.nom}.`); return; }
    const lignes = personnesVersementPrimes().map((x) => ({ x, m: Number(String((v.montants || {})[x.id] ?? "").replace(/\s/g, "").replace(",", ".")) })).filter((l) => isFinite(l.m) && l.m > 0);
    if (!lignes.length) { setNotice("Indique au moins un montant."); return; }
    const total = arrondiH(lignes.reduce((n, l) => n + l.m, 0));
    if (!await demander(`Créer ${lignes.length} sortie(s) dans ${compte.nom}, Primes (${v.typePrime}), pour un total de ${formatDH(total)} ?`)) return;
    const maintenant = new Date().toISOString();
    const nouvelles = lignes.map(({ x, m }) => ({
      id: uid(), compteId: compte.id, date: v.date, sens: "sortie", montant: arrondiH(m), type: "normal", tiersType: "employe", tiers: x.nom, staffId: x.id,
      designation: v.designation.trim(), poste: POSTE_PAR_TIERS.employe, sousPoste: SOUS_POSTE_PRIMES, typePrime: v.typePrime,
      mode: compte.type === "banque" ? "Virement" : "Espèces", piece: "", dossierId: "", par: user.nom, le: maintenant,
    }));
    const next = [...(operations || []), ...nouvelles];
    await persistOperations(next);
    await tracerAcces("primes versées", `${compte.nom} — Primes (${v.typePrime}) — ${nouvelles.length} personne(s), ${formatDH(total)} — ${v.designation.trim()}`);
    const solde = (compte.soldeOuverture || 0) + next.filter((o) => o.compteId === compte.id && opCompte(o)).reduce((n, o) => n + montantEffectif(o), 0);
    if (solde < 0 && !compte.negatifAutorise) await alerter("Trésorerie : solde négatif", `${compte.nom} : solde ${formatDH(solde)} après le versement de primes (par ${user.nom})`, { kind: "onglet", id: "compta" });
    setVersementPrimes(null);
    setNotice(`${nouvelles.length} prime(s) versée(s) depuis ${compte.nom} : ${formatDH(total)}.`);
  }
  function totalPrimesAnnee(s, annee) {
    return (s.primes || []).filter((p) => (p.date || "").startsWith(`${annee}-`)).reduce((n, p) => n + (Number(p.montant) || 0), 0);
  }
  async function ajouterPrime() {
    if (!peut("staff.primes") || !staffEdit || !staffEdit.id) return;
    const p = primeSaisie;
    const montant = Number(String(p.montant).replace(",", "."));
    if (!p.date || !p.type) { setNotice("Indique la date et le type de prime."); return; }
    if (!isFinite(montant) || montant <= 0) { setNotice("Indique un montant valide."); return; }
    const s = (staff || []).find((x) => x.id === staffEdit.id);
    if (!s) return;
    const ligne = { id: uid(), date: p.date, type: p.type, montant, commentaire: (p.commentaire || "").trim(), par: user.nom, le: new Date().toISOString() };
    const maj = { ...s, primes: [...(s.primes || []), ligne] };
    await persistStaff((staff || []).map((x) => (x.id === s.id ? maj : x)));
    await tracerAcces("prime enregistrée", `${s.nom} — ${p.type} ${formatDH(montant)} (${formatDate(p.date)})`);
    setStaffEdit({ ...staffEdit, primes: maj.primes });
    setPrimeSaisie({ date: "", type: p.type, montant: "", commentaire: "" });
  }
  async function supprimerPrime(id) {
    if (!peut("staff.primes") || !staffEdit) return;
    const s = (staff || []).find((x) => x.id === staffEdit.id);
    if (!s) return;
    const l = (s.primes || []).find((x) => x.id === id);
    const maj = { ...s, primes: (s.primes || []).filter((x) => x.id !== id) };
    await persistStaff((staff || []).map((x) => (x.id === s.id ? maj : x)));
    await tracerAcces("prime supprimée", `${s.nom}${l ? ` — ${l.type} ${formatDH(Number(l.montant) || 0)} (${formatDate(l.date)})` : ""}`);
    setStaffEdit({ ...staffEdit, primes: maj.primes });
  }
  // Saisie groupée (ex. prime d'Aïd pour tout le monde), montants pré-remplis
  // avec la dernière prime du même type de chaque personne.
  function preparerPrimesGroupees(type, date) {
    const montants = {};
    (staff || []).filter((x) => staffActif(x) && !ficheStaffMasquee(x) && !estCommercialStaff(x)).forEach((x) => {
      const d = dernierePrime(x, type);
      montants[x.id] = d ? String(d.montant) : "";
    });
    setPrimesGroupees({ date: date || todayISO(), type, commentaire: "", montants });
  }
  async function enregistrerPrimesGroupees() {
    if (!peut("staff.primes")) return;
    const g = primesGroupees;
    if (!g.type || !g.date) { setNotice("Choisis le type et la date."); return; }
    const lignes = [];
    for (const [id, v] of Object.entries(g.montants || {})) {
      const brut = String(v ?? "").replace(",", ".").trim();
      if (brut === "") continue;
      const m = Number(brut);
      if (!isFinite(m) || m < 0) { setNotice(`Montant invalide pour ${nomStaff(id)}.`); return; }
      if (m > 0) lignes.push([id, m]);
    }
    if (!lignes.length) { setNotice("Aucun montant saisi."); return; }
    const maintenant = new Date().toISOString();
    const parId = Object.fromEntries(lignes);
    await persistStaff((staff || []).map((x) => (parId[x.id] ? { ...x, primes: [...(x.primes || []), { id: uid(), date: g.date, type: g.type, montant: parId[x.id], commentaire: (g.commentaire || "").trim(), par: user.nom, le: maintenant }] } : x)));
    const total = lignes.reduce((n, [, m]) => n + m, 0);
    await tracerAcces("primes enregistrées", `${g.type} du ${formatDate(g.date)} — ${lignes.length} personne(s), total ${formatDH(total)}`);
    setNotice(`Primes « ${g.type} » enregistrées : ${lignes.length} personne(s), ${formatDH(total)}.`);
    setPrimesGroupees({ date: "", type: "", commentaire: "", montants: {} });
  }
  // ---- ERP step 12 : Comptabilité (trésorerie) ----
  async function persistOperations(next) {
    setOperations(next);
    return await saveKey(TRESORERIE_KEY, next);
  }
  // ---- Nils 08/10 (i/j) : demande de précision / signalement sur une opération (Nils, Sawsan) ----
  function opSource(o) {
    return o && o.miroirDe ? (operations || []).find((x) => x.id === o.miroirDe) || o : o;
  }
  async function majOperation(id, fn) {
    const next = (operations || []).map((x) => (x.id === id ? fn(x) : x));
    await persistOperations(next);
    return next.find((x) => x.id === id);
  }
  async function poserQuestionOp(opId, texte) {
    const t = String(texte || "").trim();
    if (!t) { setNotice("Écris ta question."); return false; }
    const o = await majOperation(opId, (x) => ({ ...x, questions: [...(x.questions || []), { id: uid(), par: user.id, parNom: user.nom, le: new Date().toISOString(), texte: t }] }));
    await tracerAcces("précision demandée sur une opération", `${(compteDe(o.compteId) || {}).nom} — ${o.designation} — ${t}`);
    setNotice("Question envoyée au responsable de la caisse.");
    return true;
  }
  async function repondreQuestionOp(opId, qid, texte) {
    const t = String(texte || "").trim();
    if (!t) { setNotice("Écris ta réponse."); return false; }
    const o = await majOperation(opId, (x) => ({ ...x, questions: (x.questions || []).map((q) => (q.id === qid ? { ...q, reponse: t, reponduPar: user.nom, reponduLe: new Date().toISOString() } : q)) }));
    await tracerAcces("précision donnée sur une opération", `${(compteDe(o.compteId) || {}).nom} — ${o.designation} — ${t}`);
    return true;
  }
  async function marquerLuQuestionOp(opId, qid) {
    await majOperation(opId, (x) => ({ ...x, questions: (x.questions || []).map((q) => (q.id === qid ? { ...q, lu: new Date().toISOString() } : q)) }));
  }
  async function signalerOp(opId, motif) {
    const m = String(motif || "").trim();
    if (!m) { setNotice("Indique ce qui te semble anormal."); return false; }
    const o = await majOperation(opId, (x) => ({ ...x, signale: { par: user.nom, parId: user.id, le: new Date().toISOString(), motif: m } }));
    const c = compteDe(o.compteId) || {};
    if (!estGerant) await alerter("Dépense signalée", `${c.nom} — ${formatDate(o.date)} — ${o.designation} — ${formatDH(Number(o.montant) || 0)} : « ${m} » (par ${user.nom})`, { kind: "onglet", id: "compta" });
    await tracerAcces("opération signalée", `${c.nom} — ${o.designation} — ${m}`);
    return true;
  }
  async function leverSignalementOp(opId) {
    const o = await majOperation(opId, (x) => ({ ...x, signale: { ...(x.signale || {}), leve: new Date().toISOString(), levePar: user.nom } }));
    await tracerAcces("signalement levé", `${(compteDe(o.compteId) || {}).nom} — ${o.designation}`);
  }
  function questionsOuvertesOp(o) {
    return (o.questions || []).filter((q) => !q.reponse);
  }
  async function persistComptesTreso(next) {
    setComptesTreso(next);
    // Les comptes reçus par leur seul nom repartent tels quels (le serveur refuserait leur disparition).
    return await saveKey(COMPTES_TRESORERIE_KEY, [...next, ...comptesNomSeulRef.current.filter((c) => !next.some((x) => x.id === c.id))]);
  }
  function planPostes() {
    const p = parametres && parametres.planPostes;
    if (!(Array.isArray(p) && p.length)) return DEFAULT_PLAN_POSTES;
    // ERP step 15 (ak / al) : sous-postes « Péage (Jawaz) » et « Retour d'avance de déplacement » ajoutés aux plans déjà personnalisés.
    let q = p;
    if (!q.some((x) => (x.sous || []).includes(SOUS_POSTE_PEAGE))) q = q.map((x) => (["Pose & Production", "Frais commerciaux"].includes(x.poste) ? { ...x, sous: [...(x.sous || []), SOUS_POSTE_PEAGE] } : x));
    if (!q.some((x) => (x.sous || []).includes(SOUS_POSTE_RETOUR_AVANCE))) q = q.map((x) => (x.poste === "Opérations exceptionnelles" ? { ...x, sous: [...(x.sous || []), SOUS_POSTE_RETOUR_AVANCE] } : x));
    return q;
  }
  function postesPourSens(sens) {
    return planPostes().filter((p) => p.sens === "les deux" || p.sens === sens);
  }
  // Consultation seule (Nils 30/09 : Sawsan voit toutes les caisses sauf celle de Nils).
  // Comptes enregistrés avant ce champ : on reprend la valeur par défaut.
  // Nils 16/10 (recensement des tâches, T4) : compte tenu par le seul Gérant (ex. Caisse Nils) —
  // sa clôture ne passe pas par la validation de l'Administration.
  function compteTenuParGerantSeul(c) {
    const r = (c && c.responsables) || [];
    return r.length > 0 && r.every((id) => (utilisateurs.find((u) => u.id === id) || {}).profil === P_GERANT);
  }
  function lecteursCompte(c) {
    if (Array.isArray(c.lecteurs)) return c.lecteurs;
    const d = DEFAULT_COMPTES_TRESORERIE.find((x) => x.id === c.id);
    return (d && d.lecteurs) || [];
  }
  const comptesVisibles = (comptesTreso || []).filter((c) => peut("compta.voirToutesCaisses") || (c.responsables || []).includes(user.id) || lecteursCompte(c).includes(user.id));
  function peutSaisirCompte(c) {
    return !!c && (peut("compta.voirToutesCaisses") || (c.responsables || []).includes(user.id));
  }
  function compteDe(id) {
    return (comptesTreso || []).find((c) => c.id === id) || comptesNomSeulRef.current.find((c) => c.id === id) || null;
  }
  // Une opération compte dans le solde sauf une entrée de transfert non encore confirmée (ou refusée).
  function opCompte(o) {
    return !(o.type === "transfert" && o.sens === "entree" && o.statutTransfert !== "confirmé");
  }
  function montantEffectif(o) {
    const m = o.type === "transfert" && o.sens === "entree" && o.montantRecu !== undefined && o.montantRecu !== "" ? Number(o.montantRecu) : Number(o.montant);
    return (o.sens === "entree" ? 1 : -1) * (Number(m) || 0);
  }
  function soldeCompteAu(compteId, dateExclue) {
    // Portefeuille : total des chèques / effets en main (pas encore déposés, pas impayés).
    if (compteId === PORTEFEUILLE_ID) return arrondiH(chequesEnMain().filter((o) => !dateExclue || o.date < dateExclue).reduce((n, o) => n + (Number(o.montant) || 0), 0));
    const c = compteDe(compteId);
    const base = Number(c && c.soldeOuverture) || 0;
    return base + (operations || []).filter((o) => o.compteId === compteId && opCompte(o) && (!dateExclue || o.date < dateExclue)).reduce((n, o) => n + montantEffectif(o), 0);
  }
  // ---- Nils 08/10 : compte en devises (Dotation devises, EUR) ----
  // Chaque opération garde « montant » = contre-valeur en dirhams (statistiques, postes, tableau de bord)
  // et « montantDevise » = montant en euros (solde du compte, clôture).
  function estCompteDevises(c) {
    return !!c && !!c.devise && c.devise !== "MAD";
  }
  function montantDeviseOp(o) {
    const m = o.type === "transfert" && o.sens === "entree" && o.montantRecuDevise !== undefined && o.montantRecuDevise !== "" ? Number(o.montantRecuDevise) : Number(o.montantDevise);
    return (o.sens === "entree" ? 1 : -1) * (Number(m) || 0);
  }
  function soldeDevisesAu(compteId, dateExclue, saufId) {
    const c = compteDe(compteId);
    return (Number(c && c.soldeOuvertureDevise) || 0) + (operations || []).filter((o) => o.compteId === compteId && o.id !== saufId && opCompte(o) && (!dateExclue || o.date < dateExclue)).reduce((n, o) => n + montantDeviseOp(o), 0);
  }
  // Solde « naturel » du compte : euros pour un compte en devises, dirhams sinon.
  function soldeCompteVue(compteId, dateExclue) {
    return estCompteDevises(compteDe(compteId)) ? soldeDevisesAu(compteId, dateExclue) : soldeCompteAu(compteId, dateExclue);
  }
  function montantVue(o, c) {
    return estCompteDevises(c) ? montantDeviseOp(o) : montantEffectif(o);
  }
  function fmtCompte(c, n) {
    if (!estCompteDevises(c)) return formatDH(n);
    const v = Number(n);
    return `${(isFinite(v) ? v : 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${c.devise === "EUR" ? "€" : c.devise}`;
  }
  // Taux moyen (DH par unité de devise) des devises présentes sur le compte à une date : dirhams ÷ devises
  // (les sorties sont valorisées à ce même taux) ; à défaut, le taux du dernier transfert reçu.
  function tauxMoyenDevises(compteId, date, saufId) {
    const fin = date ? decalerJours(date, 1) : undefined;
    const dev = soldeDevisesAu(compteId, fin, saufId);
    const mad = (Number((compteDe(compteId) || {}).soldeOuverture) || 0) + (operations || []).filter((o) => o.compteId === compteId && o.id !== saufId && opCompte(o) && (!fin || o.date < fin)).reduce((n, o) => n + montantEffectif(o), 0);
    if (dev > 0.004 && mad > 0) return mad / dev;
    const tr = (operations || []).filter((o) => o.compteId === compteId && o.sens === "entree" && nombreOuZero(o.montantDevise) > 0 && (!date || o.date <= date)).sort((a, b) => (a.date < b.date ? 1 : -1))[0];
    return tr ? nombreOuZero(o_mad(tr)) / nombreOuZero(tr.montantDevise) : null;
  }
  function o_mad(o) {
    return Math.abs(montantEffectif(o));
  }
  // ---- État client (Nils 01/10) : les factures antérieures à l'ERP deviennent des
  // pseudo-dossiers « ant:<id> » (facturés), reliables aux encaissements comme une facture.
  // Nils 28/10 : avoirs émis avant l'ERP — lignes de la même liste (type « avoir »), montant positif,
  // rattachés à leur facture antérieure (factureAntId) dont ils réduisent le reste dû (comme un règlement).
  function avoirsAntDe(dossierId) {
    const id = String(dossierId || "");
    return id.startsWith("ant:") ? (facturesAnt || []).filter((x) => x.type === "avoir" && x.factureAntId === id.slice(4)) : [];
  }
  function dossiersAnterieurs() {
    return (facturesAnt || []).filter((x) => x.type !== "avoir").map((x) => ({ id: `ant:${x.id}`, anterieure: true, antId: x.id, clientId: x.clientId, statut: "Facture", numero: x.numero, numeroFacture: x.numero, dateFacture: x.date, creeLe: x.date, reference: x.reference || "", ttcAnt: Number(x.ttc) || 0, exoAnt: !!x.exo, dejaRegle: Number(x.dejaRegle) || 0, chantierIdAnt: x.chantierId || "" }));
  }
  // Factures de remplacement (client comptoir) : pseudo-dossiers « rep:<id> »,
  // facturés, reliables aux encaissements comme une facture antérieure.
  function dossiersRemplacement() {
    return (remplacements || []).filter((r) => r.type === "Facture").map((r) => ({ id: `rep:${r.id}`, anterieure: true, remplacement: true, repId: r.id, clientId: r.clientId, statut: "Facture", numero: r.numero, numeroFacture: r.numero, dateFacture: r.date, creeLe: r.date, reference: r.designation || "", ttcAnt: Number(r.ttc) || 0, exoAnt: false, dejaRegle: 0, chantierIdAnt: "" }));
  }
  // Nils 29/10 : factures d'avance des projets : pseudo-dossiers « avp:<id> », facturés, reliables aux
  // encaissements comme une facture (état client, relances, fichier TVA).
  function dossiersAvance() {
    return (facturesAvance || []).map((f) => ({ id: `avp:${f.id}`, anterieure: true, avanceProjet: true, retenueProjet: f.nature === "retenue", avpId: f.id, clientId: f.clientId, statut: "Facture", numero: f.numero, numeroFacture: f.numero, dateFacture: f.date, creeLe: f.date, reference: f.designation || "", ttcAnt: Number(f.ttc) || 0, exoAnt: !!f.exo, dejaRegle: 0, chantierIdAnt: f.chantierId || "" }));
  }
  function factureAvanceDe(id) {
    const s = String(id || "");
    return s.startsWith("avp:") ? (facturesAvance || []).find((f) => f.id === s.slice(4)) || null : null;
  }
  function tousDossiers() {
    return [...(commandesListe || []), ...dossiersAnterieurs(), ...dossiersRemplacement(), ...dossiersAvance()];
  }
  function dossierParId(id) {
    if (!id) return null;
    if (String(id).startsWith("ant:")) return dossiersAnterieurs().find((x) => x.id === id) || null;
    if (String(id).startsWith("rep:")) return dossiersRemplacement().find((x) => x.id === id) || null;
    if (String(id).startsWith("avp:")) return dossiersAvance().find((x) => x.id === id) || null;
    return (commandesListe || []).find((x) => x.id === id) || null;
  }
  function devisDuDossier(c) {
    return c && !c.anterieure ? (devisListe || []).find((x) => x.id === c.devisId) || null : null;
  }
  function exoDossier(c) {
    return c.anterieure ? !!c.exoAnt : !!(devisDuDossier(c) || {}).exonereTVA;
  }
  function chantierDuDossier(c) {
    return c.anterieure ? c.chantierIdAnt || "" : (devisDuDossier(c) || {}).chantierId || "";
  }
  async function persistFacturesAnt(next) {
    setFacturesAnt(next);
    return await saveKey(FACTURES_ANTERIEURES_KEY, next);
  }
  async function persistFacturesAvance(next) {
    setFacturesAvance(next);
    return await saveKey(FACTURES_AVANCE_KEY, next);
  }
  async function persistPrevisions(next) {
    setPrevisions(next);
    return await saveKey(PREVISIONS_KEY, next);
  }
  // ---------- ERP step 13 (ah) : rapport commercial ----------
  async function persistVisites(next) {
    setVisites(next);
    return await saveKey(VISITES_KEY, next);
  }
  async function persistProspects(next) {
    setProspects(next);
    return await saveKey(PROSPECTS_KEY, next);
  }
  async function persistRapportsCom(next) {
    setRapportsCom(next);
    return await saveKey(RAPPORTS_COM_KEY, next);
  }
  // Commerciaux qui font un rapport (le Gérant les voit tous ; il peut aussi saisir les siens).
  function commerciauxRapport() {
    return utilisateurs.filter((u) => u.actif && u.droits.has("commercial.rapport"));
  }
  function commerciauxAvecTache() {
    return commerciauxRapport().filter((u) => u.profil !== P_GERANT);
  }
  function rapportComDe(comId, lundi) {
    return (rapportsCom || []).find((r) => r.commercialId === comId && r.lundi === lundi) || null;
  }
  function rapportComFige(comId, lundi) {
    const r = rapportComDe(comId, lundi);
    return !!r && (r.statut === "soumis" || r.statut === "lu");
  }
  function prospectDe(id) {
    return (prospects || []).find((p) => p.id === id) || null;
  }
  function compteVisite(v) {
    if (v.compteType === "client") return clientDe(v.compteId);
    return prospectDe(v.compteId);
  }
  function nomCompteVisite(v) {
    const c = compteVisite(v);
    return c ? c.nom : v.compteNom || "compte supprimé";
  }
  function rubriqueVisite(v) {
    if (v.compteType === "client") return "elevage";
    const p = prospectDe(v.compteId);
    return prospectParticulier(p) || v.rubrique === "b2c" ? "b2c" : "b2b";
  }
  function visitesSemaine(comId, lundi) {
    const fin = decalerJours(lundi, 6);
    return (visites || []).filter((v) => v.commercialId === comId && v.date >= lundi && v.date <= fin).sort((a, b) => `${a.date} ${a.heure || ""}`.localeCompare(`${b.date} ${b.heure || ""}`));
  }
  function visitesDuClient(clientId) {
    const ids = new Set([clientId, ...(prospects || []).filter((p) => p.clientId === clientId).map((p) => p.id)]);
    return (visites || []).filter((v) => ids.has(v.compteId)).sort((a, b) => `${b.date} ${b.heure || ""}`.localeCompare(`${a.date} ${a.heure || ""}`));
  }
  function docsChantierRapportCom(comId) {
    const nomCl = (id) => (clientDe(id) || {}).nom || "?";
    const duCom = (d) => d && idCommercialDuDevis(d) === comId;
    const limite = decalerJours(todayISO(), -60);
    const devisEnCours = (devisListe || []).filter((d) => d.numero && !estHorsVueActive(d) && duCom(d)).map((d) => ({ val: `devis:${d.id}`, kind: "devis", id: d.id, lib: `${d.numero}${d.reference ? ` — ${d.reference}` : ""} (${nomCl(d.clientId)}) — devis ${d.statut.toLowerCase()}`, nom: `${d.reference || d.numero} (${nomCl(d.clientId)})` }));
    const cmd = (commandesListe || []).filter((c) => duCom((devisListe || []).find((d) => d.id === c.devisId)) && ((!c.numeroFacture && !c.fasMasque) || (c.dateFacture || "") >= limite)).map((c) => ({ val: `commande:${c.id}`, kind: "commande", id: c.id, lib: `${c.numeroFacture || c.numeroBL || c.numeroPL || c.numeroRDM || c.numero}${c.reference ? ` — ${c.reference}` : ""} (${nomCl(c.clientId)}) — ${c.statut}`, nom: `${c.reference || c.numero} (${nomCl(c.clientId)})` }));
    return [...cmd, ...devisEnCours].sort((a, b) => a.lib.localeCompare(b.lib, "fr"));
  }
  function libDocChantier(lien) {
    if (!lien) return "";
    if (lien.kind === "devis") { const d = (devisListe || []).find((x) => x.id === lien.id); return d ? `${d.numero}${d.reference ? ` — ${d.reference}` : ""} (devis)` : "devis supprimé"; }
    const c = (commandesListe || []).find((x) => x.id === lien.id);
    return c ? `${c.numeroFacture || c.numeroBL || c.numeroPL || c.numeroRDM || c.numero}${c.reference ? ` — ${c.reference}` : ""} (${c.statut})` : "dossier supprimé";
  }
  function htDossier(c) {
    const d = (devisListe || []).find((x) => x.id === c.devisId);
    return calcTotaux({ ...(d || {}), exonereTVA: !!c.exonereTVA, lignes: lignesDuDossier(c) || [] }).totalHT || 0;
  }
  // ah1 (Nils 04/10) : CA facturé HT et transformations en BDC, deux indicateurs séparés.
  function indicateursRapportCom(comId, lundi) {
    const fin = decalerJours(lundi, 6);
    const dans = (d) => !!d && d.slice(0, 10) >= lundi && d.slice(0, 10) <= fin;
    const devisDuCom = (d) => d && idCommercialDuDevis(d) === comId;
    // Devis émis : nouveaux numéros ; une copie d'un devis du même client (actualisation) ne compte pas.
    const devisEmis = (devisListe || []).filter((d) => d.numero && devisDuCom(d) && dans(d.date || d.creeLe) && !(d.dupliqueDe && d.dupliqueDeClient === d.clientId));
    const bdc = (commandesListe || []).filter((c) => dans(c.creeLe) && devisDuCom((devisListe || []).find((d) => d.id === c.devisId)));
    const factures = (commandesListe || []).filter((c) => c.numeroFacture && dans(c.dateFacture) && devisDuCom((devisListe || []).find((d) => d.id === c.devisId)));
    return {
      visites: visitesSemaine(comId, lundi).length,
      devisEmis: devisEmis.length,
      devisListe: devisEmis.map((d) => d.numero),
      bdc: bdc.length,
      bdcHT: bdc.reduce((n, c) => n + htDossier(c), 0),
      bdcListe: bdc.map((c) => c.numero),
      factures: factures.length,
      caFactureHT: factures.reduce((n, c) => n + htDossier(c), 0) - avoirsEntre(lundi, fin).filter((a) => { const c = commandeParIdAvoir(a); return c && devisDuCom((devisListe || []).find((d) => d.id === c.devisId)); }).reduce((n, a) => n + (Number(a.ht) || 0), 0),
      facturesListe: factures.map((c) => c.numeroFacture),
    };
  }
  async function majRapportCom(comId, lundi, patch) {
    const existant = rapportComDe(comId, lundi);
    if (existant && (existant.statut === "soumis" || existant.statut === "lu") && !patch.statut) return;
    const base = existant || { id: uid(), commercialId: comId, lundi, chantiers: [], difficultes: "", signaux: "", statut: "brouillon", creeLe: new Date().toISOString() };
    const next = { ...base, ...patch, modifieLe: new Date().toISOString(), modifiePar: user.nom };
    await persistRapportsCom(existant ? (rapportsCom || []).map((r) => (r.id === existant.id ? next : r)) : [...(rapportsCom || []), next]);
    return next;
  }
  async function soumettreRapportCom(comId, lundi) {
    if (comId !== user.id && !estGerant) return;
    const r = rapportComDe(comId, lundi) || {};
    const ind = indicateursRapportCom(comId, lundi);
    if (!ind.visites && !(r.chantiers || []).length && !(r.difficultes || "").trim() && !(r.signaux || "").trim()) {
      if (!await demander("Aucune visite ni information saisie pour cette semaine. Soumettre quand même un rapport vide ?")) return;
    }
    const nbChantiers = (r.chantiers || []).filter((x) => (x.nom || "").trim()).length;
    if (nbChantiers < MIN_VISITES_CHANTIER && !await demander(`Seulement ${nbChantiers} visite(s) chantier sur ${MIN_VISITES_CHANTIER} demandées. Soumettre quand même ?`)) return;
    await majRapportCom(comId, lundi, { statut: "soumis", soumisLe: new Date().toISOString(), soumisPar: user.nom, indicateurs: ind });
    const nom = nomUtilisateur(comId) || comId;
    const sem = libelleSemaine(lundi);
    if ((r.difficultes || "").trim() || (r.signaux || "").trim()) {
      await alerter("Remontées terrain", `Rapport ${sem} de ${nom} : ${[(r.difficultes || "").trim() ? `difficultés — ${r.difficultes.trim()}` : "", (r.signaux || "").trim() ? `signaux marché — ${r.signaux.trim()}` : ""].filter(Boolean).join(" · ")}`, { kind: "rapportCom", com: comId, lundi });
    }
    await tracerAcces("rapport commercial soumis", `${nom} — ${sem}`);
    setNotice(`Rapport ${sem} soumis — le Gérant sera prévenu.`);
  }
  async function marquerRapportComLu(comId, lundi, commentaire) {
    if (!estGerant) return;
    await majRapportCom(comId, lundi, { statut: "lu", luPar: user.nom, luLe: new Date().toISOString(), commentaireNils: commentaire || "" });
    await tracerAcces("rapport commercial lu", `${nomUtilisateur(comId) || comId} — ${libelleSemaine(lundi)}`);
  }
  async function rouvrirRapportCom(comId, lundi) {
    if (!estGerant) return;
    if (!await demander("Rouvrir ce rapport ? Le commercial pourra de nouveau modifier ses visites de la semaine, puis devra le soumettre à nouveau.")) return;
    await majRapportCom(comId, lundi, { statut: "brouillon", rouvertLe: new Date().toISOString(), rouvertPar: user.nom });
    await tracerAcces("rapport commercial rouvert", `${nomUtilisateur(comId) || comId} — ${libelleSemaine(lundi)}`);
  }
  function nouvelleVisite(comId, lundi) {
    const aujourdhui = todayISO();
    const fin = decalerJours(lundi, 6);
    const date = aujourdhui >= lundi && aujourdhui <= fin ? aujourdhui : lundi;
    const h = new Date();
    return { id: null, commercialId: comId, date, heure: `${String(h.getHours()).padStart(2, "0")}:${String(h.getMinutes()).padStart(2, "0")}`, compteType: "client", compteId: "", typeVisite: TYPES_VISITE[0], devisId: "", synthese: "", actions: [], echantillonsControle: false, echantillonsManquants: false, temperature: "", caPotentiel: "", remise: "" };
  }
  function ouvrirVisite(v) {
    const p = v.compteType === "prospect" ? prospectDe(v.compteId) : null;
    setVisiteEdit({ ...v, actions: (v.actions || []).map((a) => ({ ...a })), temperature: v.temperature || (p && p.temperature) || "", caPotentiel: v.caPotentiel ?? (p && p.caPotentiel) ?? "", remise: v.remise ?? (p && p.remise) ?? "" });
    setVisiteErreur("");
  }
  async function enregistrerVisite() {
    const v = visiteEdit;
    if (!v) return;
    if (v.commercialId !== user.id && !estGerant) { setVisiteErreur("Tu ne peux saisir que tes propres visites."); return; }
    if (!v.date || v.date > todayISO()) { setVisiteErreur("Indique la date de la visite (pas dans le futur)."); return; }
    if (rapportComFige(v.commercialId, lundiDe(v.date))) { setVisiteErreur(`Le rapport ${libelleSemaine(lundiDe(v.date))} est déjà soumis — ${estGerant ? "rouvre-le d'abord" : "demande au Gérant de le rouvrir"}.`); return; }
    if (v.id) {
      const avant = (visites || []).find((x) => x.id === v.id);
      if (avant && avant.date !== v.date && rapportComFige(avant.commercialId, lundiDe(avant.date))) { setVisiteErreur("Cette visite appartient à un rapport déjà soumis."); return; }
    }
    if (!v.compteId) { setVisiteErreur(v.compteType === "client" ? "Choisis le client." : "Choisis le prospect (ou crée-le)."); return; }
    if (!(v.synthese || "").trim()) { setVisiteErreur("Écris la synthèse de la visite."); return; }
    const ca = String(v.caPotentiel ?? "").trim() ? parseMontantSaisi(String(v.caPotentiel)) : "";
    if (ca !== "" && (ca === null || isNaN(ca) || ca < 0)) { setVisiteErreur("CA potentiel : montant invalide."); return; }
    const remise = String(v.remise ?? "").trim() ? Number(String(v.remise).replace(",", ".")) : "";
    if (remise !== "" && (isNaN(remise) || remise < 0 || remise > 100)) { setVisiteErreur("Remise envisagée : pourcentage entre 0 et 100."); return; }
    const actions = (v.actions || []).filter((a) => (a.texte || "").trim()).map((a) => ({ id: a.id || uid(), texte: a.texte.trim(), echeance: a.echeance || "", faite: !!a.faite, faiteLe: a.faiteLe || "" }));
    const estProspect = v.compteType === "prospect";
    const propre = {
      ...v,
      id: v.id || uid(),
      synthese: v.synthese.trim(),
      devisId: estProspect ? "" : v.devisId || "",
      actions,
      temperature: estProspect ? v.temperature || "" : "",
      caPotentiel: estProspect ? ca : "",
      remise: estProspect ? remise : "",
      compteNom: (compteVisite(v) || {}).nom || "",
      rubrique: rubriqueVisite(v),
      creePar: v.creePar || user.nom,
      creeLe: v.creeLe || new Date().toISOString(),
      modifiePar: user.nom,
      modifieLe: new Date().toISOString(),
    };
    await persistVisites(v.id ? (visites || []).map((x) => (x.id === v.id ? propre : x)) : [...(visites || []), propre]);
    // La température, le CA potentiel et la remise envisagée du prospect suivent sa dernière visite (historique gardé).
    if (estProspect) {
      const p = prospectDe(v.compteId);
      // Nils 04/10 : un prospect Instagram affecté passe en « contacté » dès sa première visite / appel.
      const contact = p && p.origineMkt && p.affecteLe && !p.contacteLe ? { contacteLe: new Date().toISOString(), contactePar: user.nom, contacteVisiteId: propre.id } : null;
      if (p && (contact || p.temperature !== propre.temperature || String(p.caPotentiel ?? "") !== String(propre.caPotentiel) || String(p.remise ?? "") !== String(propre.remise))) {
        const histo = [...(p.historique || []), { le: new Date().toISOString(), par: user.nom, visiteId: propre.id, temperature: propre.temperature, caPotentiel: propre.caPotentiel, remise: propre.remise }];
        await persistProspects((prospects || []).map((x) => (x.id === p.id ? { ...x, temperature: propre.temperature, caPotentiel: propre.caPotentiel, remise: propre.remise, historique: histo, ...(contact || {}) } : x)));
      }
    }
    setVisiteEdit(null);
  }
  async function supprimerVisite(v) {
    if (!v || (v.commercialId !== user.id && !estGerant)) return;
    if (rapportComFige(v.commercialId, lundiDe(v.date))) { setNotice("Cette visite appartient à un rapport déjà soumis."); return; }
    if (!await demander(`Supprimer la visite du ${formatDate(v.date)} chez ${nomCompteVisite(v)} ?`)) return;
    await persistVisites((visites || []).filter((x) => x.id !== v.id));
    setVisiteEdit(null);
  }
  async function cocherActionVisite(visiteId, actionId, faite) {
    const v = (visites || []).find((x) => x.id === visiteId);
    if (!v || (v.commercialId !== user.id && !estGerant)) return;
    await persistVisites((visites || []).map((x) => (x.id === visiteId ? { ...x, actions: (x.actions || []).map((a) => (a.id === actionId ? { ...a, faite, faiteLe: faite ? new Date().toISOString() : "" } : a)) } : x)));
  }
  function nouveauProspect(comId) {
    return { id: null, commercialId: comId, nom: "", type: TYPES_CLIENT[0], ville: "", contact: "", telephone: "", email: "", source: "", apporteur: "", apporteurLibre: false, commissionConvenue: null, tauxCommission: "", temperature: "", caPotentiel: "", remise: "", note: "", statut: "actif" };
  }
  async function enregistrerProspect() {
    const p = prospectEdit;
    if (!p) return;
    if (p.commercialId !== user.id && !estGerant) { setProspectErreur("Tu ne peux modifier que tes prospects."); return; }
    const nom = (p.nom || "").trim();
    if (!nom) { setProspectErreur("Indique le nom du prospect."); return; }
    if ((prospects || []).some((x) => x.id !== p.id && x.statut === "actif" && x.nom.trim().toLowerCase() === nom.toLowerCase())) { setProspectErreur("Un prospect actif porte déjà ce nom."); return; }
    if (!p.id && (clients || []).some((c) => c.nom.trim().toLowerCase() === nom.toLowerCase())) { setProspectErreur("Un client porte déjà ce nom — saisis la visite sur le client."); return; }
    const particulier = prospectParticulier(p);
    if (particulier && !p.source) { setProspectErreur("Indique la source (particulier)."); return; }
    if (particulier && p.source === "Apporteur" && !(p.apporteur || "").trim()) { setProspectErreur("Indique le nom de l'apporteur."); return; }
    const ca = String(p.caPotentiel ?? "").trim() ? parseMontantSaisi(String(p.caPotentiel)) : "";
    if (ca !== "" && (ca === null || isNaN(ca) || ca < 0)) { setProspectErreur("CA potentiel : montant invalide."); return; }
    const remise = String(p.remise ?? "").trim() ? Number(String(p.remise).replace(",", ".")) : "";
    if (remise !== "" && (isNaN(remise) || remise < 0 || remise > 100)) { setProspectErreur("Remise envisagée : pourcentage entre 0 et 100."); return; }
    const avant = p.id ? prospectDe(p.id) : null;
    let taux = avant ? avant.tauxCommission ?? "" : "";
    if (estGerant) {
      taux = String(p.tauxCommission ?? "").trim() ? Number(String(p.tauxCommission).replace(",", ".")) : "";
      if (taux !== "" && (isNaN(taux) || taux < 0 || taux > 100)) { setProspectErreur("Taux de commission : pourcentage entre 0 et 100."); return; }
    }
    const avecApporteur = particulier && p.source === "Apporteur";
    const propre = {
      ...p,
      id: p.id || uid(),
      nom,
      ville: (p.ville || "").trim(),
      contact: (p.contact || "").trim(),
      telephone: (p.telephone || "").trim(),
      email: (p.email || "").trim(),
      source: particulier ? p.source : "",
      apporteur: avecApporteur ? (p.apporteur || "").trim() : "",
      apporteurLibre: avecApporteur ? !!p.apporteurLibre : false,
      commissionConvenue: avecApporteur ? p.commissionConvenue : null,
      tauxCommission: avecApporteur && p.commissionConvenue === true ? taux : "",
      caPotentiel: ca,
      remise,
      creePar: p.creePar || user.nom,
      creeLe: p.creeLe || new Date().toISOString(),
      modifiePar: user.nom,
      modifieLe: new Date().toISOString(),
    };
    if (!avant || avant.temperature !== propre.temperature || String(avant.caPotentiel ?? "") !== String(propre.caPotentiel) || String(avant.remise ?? "") !== String(propre.remise)) {
      propre.historique = [...((avant && avant.historique) || []), { le: new Date().toISOString(), par: user.nom, temperature: propre.temperature, caPotentiel: propre.caPotentiel, remise: propre.remise }];
    }
    await persistProspects(p.id ? (prospects || []).map((x) => (x.id === p.id ? propre : x)) : [...(prospects || []), propre]);
    if (avant && estGerant && String(avant.tauxCommission ?? "") !== String(propre.tauxCommission ?? "")) await tracerAcces("taux de commission apporteur", `${nom} — ${propre.apporteur} : ${propre.tauxCommission === "" ? "—" : `${propre.tauxCommission} %`}`);
    // Créé depuis la fiche visite : on le choisit directement.
    if (!p.id && visiteEdit) setVisiteEdit({ ...visiteEdit, compteType: "prospect", compteId: propre.id, temperature: propre.temperature, caPotentiel: propre.caPotentiel, remise: propre.remise });
    setProspectEdit(null);
  }
  async function marquerProspectPerdu(p, perdu) {
    if (!p || (p.commercialId !== user.id && !estGerant)) return;
    if (perdu && !await demander(`Classer « ${p.nom} » comme prospect perdu ? (Il sort de la liste des prospects actifs ; ses visites restent.)`)) return;
    await persistProspects((prospects || []).map((x) => (x.id === p.id ? { ...x, statut: perdu ? "perdu" : "actif", perduLe: perdu ? new Date().toISOString() : "" } : x)));
  }
  // ah3 (Nils 04/10) : le client se crée à partir du prospect (circuit de validation habituel).
  function convertirProspectEnClient(p) {
    if (!p || (p.commercialId !== user.id && !estGerant)) return;
    if (!peut("clients.creer") && user.acces.clients !== "ecriture") { setNotice("Tu n'as pas le droit de créer un client."); return; }
    const com = utilisateurs.find((u) => u.id === p.commercialId);
    setClientEditing({
      id: null, nom: p.nom, raisonSociale: "", commercialSC: com ? com.nom : "", apporteurAffaire: p.apporteur || "", type: p.type || TYPES_CLIENT[0],
      notes_adv: "–", notes_prod: "–", notes_com: "–", paiement_niveau: "", ice: "", paiement: "", remise: p.remise === "" || p.remise === undefined ? "" : String(p.remise), plafondExposition: "",
      contacts: p.contact || p.telephone || p.email ? [{ id: uid(), nom: p.contact || p.nom, fonction: prospectParticulier(p) ? "Autre" : "Direction", tel: p.telephone || "", email: p.email || "" }] : [],
      adresse: "", codePostal: "", ville: p.ville || "", adressesSupp: [], notes: p.note || "", depuisProspectId: p.id, source: p.source || "",
    });
    setClientError("");
    setShowClientFiche(true);
  }
  function telechargerRapportCom(comId, lundi) {
    const e = escapeHtml;
    const r = rapportComDe(comId, lundi) || { chantiers: [], difficultes: "", signaux: "" };
    const ind = r.indicateurs && (r.statut === "soumis" || r.statut === "lu") ? r.indicateurs : indicateursRapportCom(comId, lundi);
    const vs = visitesSemaine(comId, lundi);
    const nom = nomUtilisateur(comId) || comId;
    const tuile = (lib, val, sous) => `<td class="k"><div class="kl">${e(lib)}</div><div class="kv">${val}</div>${sous ? `<div class="ks">${e(sous)}</div>` : ""}</td>`;
    const coche = (b) => (b ? "☑" : "☐");
    const blocVisite = (v) => {
      const c = compteVisite(v) || {};
      const p = v.compteType === "prospect" ? c : null;
      const d = v.devisId ? (devisListe || []).find((x) => x.id === v.devisId) : null;
      const rows = [
        `<tr><th>Compte / Client</th><td>${e(nomCompteVisite(v))}</td><th>Type de client</th><td>${e(c.type || "")}</td></tr>`,
        `<tr><th>Ville</th><td>${e(c.ville || "")}</td><th>Visite</th><td>${e(formatDate(v.date))}${v.heure ? ` à ${e(v.heure)}` : ""} — ${e(v.typeVisite || "")}${d ? ` — devis ${e(d.numero)}` : ""}</td></tr>`,
      ];
      if (p && prospectParticulier(p)) {
        rows.push(`<tr><th>Source</th><td>${e(p.source || "")}</td><th>Apporteur</th><td>${p.source === "Apporteur" ? `${e(p.apporteur || "")} — commission convenue : ${p.commissionConvenue === true ? "oui" : p.commissionConvenue === false ? "non" : "?"}${p.commissionConvenue === true && voitTauxApporteur ? ` — taux : ${p.tauxCommission === "" || p.tauxCommission === undefined ? "à définir par la direction" : `${e(String(p.tauxCommission))} %`}` : ""}` : "—"}</td></tr>`);
      }
      if (p) rows.push(`<tr><th>CA potentiel</th><td>${v.caPotentiel === "" || v.caPotentiel === undefined ? "—" : `${e(formatDH(v.caPotentiel))} HT`}${v.remise === "" || v.remise === undefined ? "" : ` — remise envisagée ${e(String(v.remise))} %`}</td><th>Température</th><td>${e(v.temperature || "—")}</td></tr>`);
      rows.push(`<tr><th>Synthèse</th><td colspan="3">${e(v.synthese || "").replace(/\n/g, "<br>")}</td></tr>`);
      rows.push(`<tr><th>Actions / suivi</th><td colspan="3">${(v.actions || []).length ? (v.actions || []).map((a) => `${coche(a.faite)} ${e(a.texte)}${a.echeance ? ` (pour le ${e(formatDate(a.echeance))})` : ""}`).join("<br>") : "—"}</td></tr>`);
      if (v.compteType === "client" || !prospectParticulier(p)) rows.push(`<tr><th>Échantillons</th><td colspan="3">${coche(v.echantillonsControle)} Contrôle effectué avec la liste de référence &nbsp;&nbsp; ${coche(v.echantillonsManquants)} Liste des manquants transmise à l'administration des ventes</td></tr>`);
      return `<table class="v">${rows.join("")}</table>`;
    };
    const section = (rb) => {
      const l = vs.filter((v) => rubriqueVisite(v) === rb.cle);
      return `<h2>${e(rb.titre)}</h2>${l.length ? l.map(blocVisite).join("") : `<p class="vide">Aucune visite.</p>`}`;
    };
    const ch = (r.chantiers || []).filter((x) => (x.nom || "").trim());
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>Rapport</title><style>
      body{font-family:'DM Sans',Arial,sans-serif;color:#281E1E;font-size:11px;margin:24px}
      h1{font-family:'Cormorant Garamond',Georgia,serif;font-size:22px;margin:6px 0 2px}
      h2{font-size:12px;text-transform:uppercase;letter-spacing:.5px;background:#281E1E;color:#fff;padding:5px 8px;margin:16px 0 6px}
      table{border-collapse:collapse;width:100%}
      .id td{padding:3px 6px} .k{border:1px solid #ccc;padding:6px;text-align:center;width:20%}
      .kl{font-size:9px;text-transform:uppercase;color:#8C8282}.kv{font-size:16px;font-weight:600}.ks{font-size:9px;color:#8C8282}
      table.v{margin-bottom:8px;page-break-inside:avoid} table.v th{background:#F2EFED;text-align:left;width:16%;padding:4px 6px;border:1px solid #ddd;font-weight:600}
      table.v td{padding:4px 6px;border:1px solid #ddd;vertical-align:top}
      .vide{color:#8C8282;font-style:italic}.note{margin-top:18px;font-size:10px;color:#8C8282;border-top:1px solid #ccc;padding-top:8px}
      .rouge{color:#A8502F;font-weight:600}
    </style></head><body>
      <img src="${LOGO_SRC}" alt="Stone Concept" style="height:40px" />
      <h1>Rapport commercial hebdomadaire</h1>
      <table class="id"><tr><td><b>Commercial(e) :</b> ${e(nom)}</td><td><b>Semaine :</b> ${e(libelleSemaine(lundi))}</td><td><b>Statut :</b> ${r.statut === "lu" ? `lu par ${e(r.luPar || "")} le ${e(formatDate((r.luLe || "").slice(0, 10)))}` : r.statut === "soumis" ? `soumis le ${e(formatDate((r.soumisLe || "").slice(0, 10)))}` : "brouillon"}</td></tr></table>
      <h2>Résumé · indicateurs clés de la semaine</h2>
      <table><tr>${tuile("Visites réalisées", ind.visites)}${tuile("Devis émis *", ind.devisEmis)}${tuile("Transformations en BDC", ind.bdc, `${formatDH(ind.bdcHT)} HT`)}${tuile("CA facturé (MAD HT)", e(formatDH(ind.caFactureHT)), `${ind.factures} facture(s)`)}</tr></table>
      <p style="font-size:9px;color:#8C8282">* Devis émis : nouveaux devis uniquement (une copie actualisée d'un devis du même client ne compte pas).</p>
      ${RUBRIQUES_RC.map(section).join("")}
      <h2>4 · Visites chantier — contenu Instagram</h2>
      ${ch.length ? `<table class="v"><tr><th>Chantier / client</th><th>Devis / commande</th><th style="width:12%">Photos</th><th>Commentaire</th></tr>${ch.map((x) => `<tr><td>${e(x.nom)}</td><td>${e(libDocChantier(x.lien) || "—")}</td><td>${x.photos === true ? "Oui" : x.photos === false ? "Non" : "—"}</td><td>${e(x.commentaire || "")}</td></tr>`).join("")}</table>` : `<p class="vide">Aucune visite chantier.</p>`}
      <p class="${ch.length < MIN_VISITES_CHANTIER ? "rouge" : ""}">${ch.length} / ${MIN_VISITES_CHANTIER} minimum. ${e(CONSIGNE_CHANTIER)}</p>
      <h2>5 · Problématiques & remontées terrain</h2>
      <table class="v"><tr><th>Difficultés rencontrées</th><td>${e(r.difficultes || "—").replace(/\n/g, "<br>")}</td></tr><tr><th>Signaux marché / concurrence</th><td>${e(r.signaux || "—").replace(/\n/g, "<br>")}</td></tr></table>
      ${r.commentaireNils ? `<h2>Commentaire de la direction</h2><p>${e(r.commentaireNils).replace(/\n/g, "<br>")}</p>` : ""}
      <div class="note">${e(NOTE_RAPPORT_COM)}</div>
    </body></html>`;
    const s = semaineISO(lundi);
    telechargerDocument(html, `Rapport-commercial_${nom.replace(/\s+/g, "-")}_S${String(s.num).padStart(2, "0")}-${s.annee}`, "rapport commercial");
  }
  async function enregistrerPrevision() {
    const f = previsionEdit;
    if (!f || !peut("compta.previsions")) return;
    const montant = parseMontantSaisi(f.montant);
    if (!f.date) { setNotice("Indique la date prévue."); return; }
    if (!(f.libelle || "").trim()) { setNotice("Indique le libellé."); return; }
    if (!isFinite(montant) || montant <= 0) { setNotice("Indique un montant valide."); return; }
    const x = { ...f, libelle: f.libelle.trim(), montant, modifiePar: user.nom, modifieLe: new Date().toISOString() };
    if (!x.id) { x.id = uid(); x.par = user.nom; x.le = x.modifieLe; }
    const existe = (previsions || []).some((p) => p.id === x.id);
    await persistPrevisions(existe ? (previsions || []).map((p) => (p.id === x.id ? x : p)) : [...(previsions || []), x]);
    await tracerAcces(existe ? "prévision modifiée" : "prévision ajoutée", `${x.libelle} — ${x.sens === "entree" ? "+" : "−"}${formatDH(montant)} le ${formatDate(x.date)}`);
    setPrevisionEdit(null);
  }
  // ---- Nils 04/10 (aa) : déclaration de bug ----
  async function persistBugs(next) {
    setBugs(next);
    return await saveKey(BUGS_KEY, next);
  }
  async function signalerBug() {
    const f = bugEdit;
    if (!f) return;
    const description = (f.description || "").trim();
    if (!description) { setNotice("Décris le problème."); return; }
    // Nils 28/10 : numéro attribué par le serveur (chacun ne voit que ses bugs).
    const numero = await numeroDocument("BUG");
    if (!numero) return;
    const b = { id: uid(), numero, par: user.nom, parId: user.id, le: new Date().toISOString(), onglet: f.onglet || "", gravite: f.gravite || "Gênant", description, statut: "nouveau", reponse: "", declarantVu: true };
    await persistBugs([...(bugs || []), b]);
    if (!estGerant) await alerter("Bug signalé", `${b.numero} — ${b.gravite} — onglet ${b.onglet || "?"} — ${b.par} : ${description}`, { kind: "onglet", id: "alertes" });
    setBugEdit(null);
    setNotice(`${b.numero} envoyé, merci.`);
  }
  async function majBug(id, patch) {
    await persistBugs((bugs || []).map((b) => {
      if (b.id !== id) return b;
      const n = { ...b, ...patch, majLe: new Date().toISOString(), majPar: user.nom };
      if (patch.statut && patch.statut !== b.statut && ["corrigé", "rejeté"].includes(patch.statut) && b.parId !== user.id) n.declarantVu = false;
      return n;
    }));
  }
  function texteBugsPourClaude() {
    const ouverts = (bugs || []).filter((b) => !["corrigé", "rejeté"].includes(b.statut));
    return [`Bugs ouverts ERP Stone Concept — ${ouverts.length} (au ${formatDate(todayISO())})`, ...ouverts.map((b) => `- ${b.numero} [${b.gravite}] onglet « ${b.onglet || "?"} » — ${b.par}, ${formatDateHeure(b.le)} — ${b.statut}\n  ${b.description}${b.reponse ? `\n  Note du Gérant : ${b.reponse}` : ""}`)].join("\n");
  }
  async function copierBugsPourClaude() {
    const t = texteBugsPourClaude();
    try { await navigator.clipboard.writeText(t); setNotice("Liste copiée — colle-la dans la conversation avec Claude."); }
    catch (e) { setBugsTexte(t); }
  }
  // ---- Nils 04/10 (ad) : marketing — time sheet, taux horaire, prévision de paiement ----
  async function persistTimesheet(next) {
    setTimesheet(next);
    return await saveKey(MKT_TIMESHEET_KEY, next);
  }
  const reglagesMkt = (parametres && parametres.marketing) || {};
  async function majReglagesMkt(patch) {
    await persistParametres({ ...(parametres || {}), marketing: { ...((parametres && parametres.marketing) || {}), ...patch } });
  }
  function personnesMarketing() {
    return utilisateurs.filter((u) => u.droits.has("marketing.acces") && u.profil !== P_GERANT && (u.actif || (timesheet || []).some((l) => l.parId === u.id)));
  }
  function tauxMktAu(personneId, dateISO) {
    const l = ((reglagesMkt.taux || {})[personneId] || []).filter((t) => t.dateEffet <= dateISO).sort((a, b) => (a.dateEffet < b.dateEffet ? 1 : -1));
    return l.length ? Number(l[0].taux) || 0 : 0;
  }
  function moisValideMkt(personneId, ym) {
    return ((reglagesMkt.moisValides || {})[personneId] || {})[ym] || null;
  }
  function ligneTsVerrouillee(l) {
    if (estGerant) return false;
    if (moisValideMkt(l.parId, l.date.slice(0, 7))) return true;
    return l.date < decalerJours(todayISO(), -JOURS_VERROU_TIMESHEET);
  }
  function totauxMoisMkt(personneId, ym) {
    const l = (timesheet || []).filter((x) => x.parId === personneId && x.date.slice(0, 7) === ym);
    const heures = arrondiH(l.reduce((n, x) => n + (Number(x.duree) || 0), 0));
    const montant = Math.round(l.reduce((n, x) => n + (Number(x.duree) || 0) * tauxMktAu(personneId, x.date), 0) * 100) / 100;
    return { heures, montant, lignes: l };
  }
  async function enregistrerLigneTs() {
    const f = tsEdit;
    if (!f) return;
    const duree = Number(String(f.duree || "").replace(",", "."));
    if (!f.date) { setNotice("Indique la date."); return; }
    if (f.date > todayISO()) { setNotice("Pas de date dans le futur."); return; }
    if (!isFinite(duree) || duree <= 0 || duree > 24) { setNotice("Durée : entre 0 et 24 heures."); return; }
    if (!f.type) { setNotice("Choisis le type d'activité."); return; }
    if (!(f.description || "").trim()) { setNotice("Décris l'activité."); return; }
    const parId = f.parId || user.id;
    if (!estGerant && (f.date < decalerJours(todayISO(), -JOURS_VERROU_TIMESHEET) || moisValideMkt(parId, f.date.slice(0, 7)))) { setNotice(`Ligne verrouillée : plus de ${JOURS_VERROU_TIMESHEET} jours ou mois validé — demande au Gérant.`); return; }
    const avant = f.id ? (timesheet || []).find((x) => x.id === f.id) : null;
    if (avant && ligneTsVerrouillee(avant)) { setNotice("Ligne verrouillée — demande au Gérant."); return; }
    const x = { ...f, parId, duree: arrondiH(duree), description: f.description.trim(), lien: (f.lien || "").trim(), id: f.id || uid(), par: f.par || user.nom, le: f.le || new Date().toISOString(), modifiePar: user.nom, modifieLe: new Date().toISOString() };
    await persistTimesheet(avant ? (timesheet || []).map((y) => (y.id === x.id ? x : y)) : [...(timesheet || []), x]);
    setTsEdit(null);
  }
  async function supprimerLigneTs(l) {
    if (ligneTsVerrouillee(l)) { setNotice("Ligne verrouillée — demande au Gérant."); return; }
    if (!(await demander(`Supprimer la ligne du ${formatDate(l.date)} (${String(l.duree).replace(".", ",")} h) ?`))) return;
    await persistTimesheet((timesheet || []).filter((y) => y.id !== l.id));
  }
  async function enregistrerTauxMkt(personneId) {
    if (!estGerant) return;
    const taux = Number(String(mktTauxSaisi.taux || "").replace(",", "."));
    const dateEffet = mktTauxSaisi.dateEffet || `${todayISO().slice(0, 7)}-01`;
    if (!isFinite(taux) || taux <= 0) { setNotice("Taux horaire invalide."); return; }
    const t = { ...(reglagesMkt.taux || {}) };
    t[personneId] = [...(t[personneId] || []).filter((x) => x.dateEffet !== dateEffet), { dateEffet, taux, par: user.nom, le: new Date().toISOString() }].sort((a, b) => (a.dateEffet < b.dateEffet ? -1 : 1));
    await majReglagesMkt({ taux: t });
    await tracerAcces("taux horaire marketing", `${nomUtilisateur(personneId)} : ${formatDH(taux)} / h à partir du ${formatDate(dateEffet)}`);
    setMktTauxSaisi({ taux: "", dateEffet: "" });
  }
  async function validerMoisMkt(personneId, ym, valider) {
    if (!estGerant) return;
    const mv = { ...(reglagesMkt.moisValides || {}) };
    const p = { ...(mv[personneId] || {}) };
    if (valider) {
      const t = totauxMoisMkt(personneId, ym);
      if (!(await demander(`Valider ${libMois(ym)} — ${nomUtilisateur(personneId)} : ${String(t.heures).replace(".", ",")} h, ${formatDH(t.montant)} ? Le montant de la prévision (Caisse Nils, le ${JOUR_PAIEMENT_MKT}) sera figé et les lignes verrouillées.`))) return;
      p[ym] = { heures: t.heures, montant: t.montant, le: new Date().toISOString(), par: user.nom };
    } else delete p[ym];
    mv[personneId] = p;
    await majReglagesMkt({ moisValides: mv });
  }
  // Prévision « honoraires marketing » : une par personne et par mois, payée le 15 du mois suivant par la Caisse Nils.
  // Recalculée tant que le mois n'est pas validé ; figée au montant validé ensuite. Une prévision réalisée n'est plus touchée.
  const idPrevisionMkt = (personneId, ym) => `mkt-${personneId}-${ym}`;
  const majPrevMktRef = useRef("");
  useEffect(() => {
    if (loading || !Array.isArray(previsions) || !Array.isArray(timesheet) || !parametres) return;
    const voulues = [];
    const moisParPersonne = {};
    (timesheet || []).forEach((l) => { (moisParPersonne[l.parId] = moisParPersonne[l.parId] || new Set()).add(l.date.slice(0, 7)); });
    Object.entries(reglagesMkt.moisValides || {}).forEach(([pid, m]) => Object.keys(m || {}).forEach((ym) => (moisParPersonne[pid] = moisParPersonne[pid] || new Set()).add(ym)));
    Object.entries(moisParPersonne).forEach(([pid, set]) => set.forEach((ym) => {
      const v = moisValideMkt(pid, ym);
      const montant = v ? Number(v.montant) || 0 : totauxMoisMkt(pid, ym).montant;
      if (montant > 0) voulues.push({ id: idPrevisionMkt(pid, ym), date: ajouterMoisISO(`${ym}-01`, 1, JOUR_PAIEMENT_MKT), libelle: `${nomUtilisateur(pid) || pid} — marketing ${libMois(ym)}`, categorie: "Honoraires / prestataires", sens: "sortie", montant, compteId: COMPTE_PAIEMENT_MKT, note: `Caisse Nils · ${v ? "mois validé" : "provisoire — suit la time sheet"}`, auto: "marketing", lotId: "" });
    }));
    const existantes = (previsions || []).filter((x) => x.auto === "marketing");
    let next = (previsions || []).filter((x) => x.auto !== "marketing" || x.realiseeLe);
    voulues.forEach((v) => { const ex = existantes.find((x) => x.id === v.id); if (ex && ex.realiseeLe) return; next.push(ex ? { ...ex, ...v } : { ...v, par: "ERP", le: new Date().toISOString() }); });
    const cle = JSON.stringify(next.filter((x) => x.auto === "marketing").map((x) => [x.id, x.montant, x.date, x.note, x.libelle, x.realiseeLe || ""]).sort());
    const avant = JSON.stringify(existantes.map((x) => [x.id, x.montant, x.date, x.note, x.libelle, x.realiseeLe || ""]).sort());
    if (cle === avant || majPrevMktRef.current === cle) return;
    majPrevMktRef.current = cle;
    persistPrevisions(next);
  }, [loading, timesheet, previsions, parametres, utilisateurs.length]);
  // ---- Prospects (saisis par le marketing ou l'ADV, affectés par Nils) ----
  async function enregistrerProspectMkt(force) {
    const f = prospectMkt;
    if (!f) return;
    const nom = (f.nom || "").trim();
    if (!nom) { setNotice("Indique le nom du prospect."); return; }
    if (!(f.source || "").trim()) { setNotice("Indique la source : comment le prospect nous a connus."); return; }
    if (!(f.recuPar || "").trim()) { setNotice("Indique comment le prospect nous a contactés (message, mail, appel)."); return; }
    if (!(f.telephone || "").trim() && !(f.email || "").trim() && !(f.lien || "").trim()) { setNotice("Indique au moins un téléphone, un mail ou le lien du message."); return; }
    if (force !== true) {
      const doub = doublonsProspect(f);
      if (doub.length) { setProspectMkt({ ...f, doublons: doub.map((p) => p.id) }); return; }
    }
    const avant = f.id ? prospectDe(f.id) : null;
    if (avant && avant.commercialId && !estGerant) { setNotice("Prospect déjà affecté — seul le Gérant peut le modifier."); return; }
    const x = {
      type: TYPE_SANS_ICE, temperature: "Tiède", statut: "actif", caPotentiel: "", remise: "", contact: "", commercialId: "",
      ...(avant || {}), ...f,
      id: f.id || uid(), nom, telephone: (f.telephone || "").trim(), email: (f.email || "").trim(), ville: (f.ville || "").trim(), projet: (f.projet || "").trim(), produitInteret: (f.produitInteret || "").trim(), lien: (f.lien || "").trim(),
      source: f.source.trim(), recuPar: f.recuPar, origineMkt: true, dateContact: f.dateContact || todayISO(),
      creePar: (avant && avant.creePar) || user.nom, creeParId: (avant && avant.creeParId) || user.id, creeLe: (avant && avant.creeLe) || new Date().toISOString(), modifiePar: user.nom, modifieLe: new Date().toISOString(),
    };
    delete x.doublons;
    await persistProspects(avant ? (prospects || []).map((y) => (y.id === x.id ? x : y)) : [...(prospects || []), x]);
    if (!avant && !estGerant) await alerter("Prospect", `${nom}${x.ville ? ` (${x.ville})` : ""}${x.produitInteret ? ` — ${x.produitInteret}` : ""} — source ${x.source} — saisi par ${user.nom}, à affecter`, { kind: "onglet", id: "marketing" });
    setProspectMkt(null);
  }
  // Nils 12/10 : doublon = même téléphone (chiffres, 9 derniers) ou même mail qu'un prospect / client existant.
  function doublonsProspect(f) {
    const tel = (t) => String(t || "").replace(/\D/g, "").slice(-9);
    const t = tel(f.telephone), m = String(f.email || "").trim().toLowerCase();
    if (t.length < 9 && !m) return [];
    return (prospects || []).filter((p) => p.id !== f.id && ((t.length >= 9 && tel(p.telephone) === t) || (m && String(p.email || "").trim().toLowerCase() === m)));
  }
  // Nils 12/10 (g) : sources attribuées à Salwa (stats et liste des prospects) — Paramétrage, défaut : toutes sauf Bouche à oreille.
  function sourcesSalwa() {
    const l = parametres && parametres.budgetMarketing && parametres.budgetMarketing.sourcesSalwa;
    return Array.isArray(l) ? l : sourcesClient().filter((x) => normLib(x) !== normLib("Bouche à oreille"));
  }
  const RECU_PAR_PROSPECT = ["Message (Instagram, Facebook…)", "Mail", "Appel"];
  async function affecterProspectMkt(p, commercialId) {
    if (!estGerant) return;
    await persistProspects((prospects || []).map((y) => (y.id === p.id ? { ...y, commercialId, affecteLe: commercialId ? new Date().toISOString() : "", affectePar: commercialId ? user.nom : "", contacteLe: "" } : y)));
  }
  async function marquerProspectContacte(id) {
    await persistProspects((prospects || []).map((y) => (y.id === id ? { ...y, contacteLe: new Date().toISOString(), contactePar: user.nom } : y)));
  }
  async function enregistrerBooster() {
    const f = boosterEdit;
    if (!f || !estGerant) return;
    if (!(f.produit || "").trim()) { setNotice("Indique le produit ou la couleur."); return; }
    if (f.du && f.au && f.au < f.du) { setNotice("La fin est avant le début."); return; }
    const x = { ...f, produit: f.produit.trim(), consigne: (f.consigne || "").trim(), id: f.id || uid(), par: user.nom, le: new Date().toISOString() };
    const l = reglagesMkt.booster || [];
    await majReglagesMkt({ booster: l.some((y) => y.id === x.id) ? l.map((y) => (y.id === x.id ? x : y)) : [...l, x] });
    setBoosterEdit(null);
  }
  async function supprimerBooster(id) {
    if (!estGerant) return;
    await majReglagesMkt({ booster: (reglagesMkt.booster || []).filter((y) => y.id !== id) });
  }
  const boostersActifs = (reglagesMkt.booster || []).filter((b) => (!b.du || b.du <= todayISO()) && (!b.au || b.au >= todayISO()));
  // ---- Échantillons : stock par référence et format, demandes (commercial → Ahmed) ----
  async function persistEchantillons(next) {
    setEchantillons(next);
    return await saveKey(ECHANTILLONS_KEY, next);
  }
  async function persistEchMouvements(next) {
    setEchMouvements(next);
    return await saveKey(ECH_MOUVEMENTS_KEY, next);
  }
  async function persistDemandesEch(next) {
    setDemandesEch(next);
    return await saveKey(DEMANDES_ECH_KEY, next);
  }
  const planningRef = useRef(null);
  planningRef.current = planning;
  async function persistPlanning(next) {
    planningRef.current = next;
    setPlanning(next);
    return await saveKey(PLANNING_KEY, next);
  }
  const echSuiviRef = useRef(null);
  echSuiviRef.current = echSuivi;
  async function persistEchSuivi(next) {
    echSuiviRef.current = next;
    setEchSuivi(next);
    return await saveKey(ECH_SUIVI_KEY, next);
  }
  function stockEch(refId, format) {
    return (echMouvements || []).filter((m) => m.refId === refId && m.format === format).reduce((n, m) => n + (Number(m.qte) || 0), 0);
  }
  function refEch(id) {
    return (echantillons || []).find((e) => e.id === id) || null;
  }
  const libRefEch = (e) => (e ? (estMatEch(e) ? e.designation || e.couleur : `${e.couleur}${e.code ? ` [${e.code}]` : ""} — ${e.finition}`) : "référence supprimée");
  const libFormatEch = (f) => ([...FORMATS_ECH, FORMAT_MAT].find((x) => x.cle === f) || {}).lib || f;
  function compteDemandeEch(d) {
    if (d.compteType === "client") return (clientDe(d.compteId) || {}).nom || "client supprimé";
    if (d.compteType === "prospect") return (prospectDe(d.compteId) || {}).nom || "prospect supprimé";
    return d.compteLibre || "—";
  }
  async function enregistrerEntreeEch() {
    const f = entreeEch;
    if (!f || !peut("echantillons.preparer")) return;
    const lignes = Object.entries(f.lignes || {}).flatMap(([refId, q]) => formatsRefEch(refEch(refId)).map((fm) => ({ refId, format: fm.cle, qte: Math.round(Number(String((q || {})[fm.cle] || "").replace(",", "."))) }))).filter((l) => l.qte);
    if (!lignes.length) { setNotice("Indique au moins une quantité."); return; }
    if (lignes.some((l) => !isFinite(l.qte) || (f.motif !== "Ajustement d'inventaire" && l.qte < 0))) { setNotice("Quantités invalides (négatif seulement en ajustement d'inventaire)."); return; }
    if (lignes.some((l) => stockEch(l.refId, l.format) + l.qte < 0)) { setNotice("Un ajustement rendrait le stock négatif."); return; }
    const maintenant = new Date().toISOString();
    await persistEchMouvements([...(echMouvements || []), ...lignes.map((l) => ({ id: uid(), refId: l.refId, format: l.format, qte: l.qte, motif: f.motif, note: (f.note || "").trim(), date: todayISO(), par: user.nom, le: maintenant }))]);
    if (f.motif === "Ajustement d'inventaire" && !estGerant) await alerter("Ajustement d'échantillons", lignes.map((l) => `${libRefEch(refEch(l.refId))} ${libFormatEch(l.format).toLowerCase()} : ${l.qte > 0 ? "+" : ""}${l.qte}`).join(" ; ") + ` (${user.nom})`, { kind: "onglet", id: "stock" });
    setEntreeEch(null);
  }
  async function enregistrerRefEch() {
    const f = refEchEdit;
    if (!f || !(estGerant || peut("echantillons.preparer"))) return;
    if (!(f.couleur || "").trim() || !(f.finition || "").trim()) { setNotice("Couleur et finition obligatoires."); return; }
    const x = { ...f, couleur: f.couleur.trim(), finition: f.finition.trim(), code: (f.code || "").trim(), gamme: (f.gamme || "").trim() || "Infinity", id: f.id || uid(), ordre: f.ordre || (echantillons || []).length + 1 };
    if (x.code && (echantillons || []).some((e) => e.id !== x.id && (e.gamme || "").toLowerCase() === x.gamme.toLowerCase() && String(e.code || "").trim().toLowerCase() === x.code.toLowerCase() && (e.finition || "").toLowerCase() === x.finition.toLowerCase())) { setNotice(`Le code ${x.code} (${x.finition}) existe déjà chez ${x.gamme}.`); return; }
    if ((echantillons || []).some((e) => e.id !== x.id && e.couleur.toLowerCase() === x.couleur.toLowerCase() && e.finition.toLowerCase() === x.finition.toLowerCase() && e.gamme === x.gamme)) { setNotice("Cette couleur / finition existe déjà."); return; }
    await persistEchantillons((echantillons || []).some((e) => e.id === x.id) ? (echantillons || []).map((e) => (e.id === x.id ? x : e)) : [...(echantillons || []), x]);
    setRefEchEdit(null);
  }
  function nouvelleDemandeEch(depuis) {
    return { compteType: "client", compteId: "", compteLibre: "", visiteId: "", note: "", commercialId: estGerant && depuis && depuis.commercialId ? depuis.commercialId : user.id, lignes: {}, ...(depuis || {}) };
  }
  async function enregistrerDemandeEch() {
    const f = demandeEchEdit;
    if (!f || !peut("echantillons.demander")) return;
    if (f.compteType === "libre" ? !(f.compteLibre || "").trim() : !f.compteId) { setNotice("Indique le client ou le prospect."); return; }
    const lignes = Object.entries(f.lignes || {}).flatMap(([refId, q]) => formatsRefEch(refEch(refId)).map((fm) => ({ refId, format: fm.cle, qte: Math.round(Number(String((q || {})[fm.cle] || "").replace(",", "."))) || 0 }))).filter((l) => l.qte > 0);
    if (!lignes.length) { setNotice("Indique au moins un échantillon ou un article de matériel."); return; }
    if (f.boite && lignes.some((l) => estMatEch(refEch(l.refId)))) { setNotice("Une boîte revendeur ne contient que des échantillons : fais une demande séparée pour le matériel."); return; }
    const numeroEch = await numeroDocument("ECH");
    if (!numeroEch) return;
    const d = { id: uid(), numero: numeroEch, commercialId: f.commercialId || user.id, compteType: f.compteType, compteId: f.compteType === "libre" ? "" : f.compteId, compteLibre: f.compteType === "libre" ? f.compteLibre.trim() : "", visiteId: f.visiteId || "", note: (f.note || "").trim(), lignes, statut: "demandée", demandeLe: new Date().toISOString(), demandePar: user.nom };
    // Nouvelle boîte revendeur : la demande prépare la boîte ; son contenu est mémorisé pour les contrôles.
    let boite = null;
    if (f.boite) {
      const su = echSuiviRef.current || echSuivi;
      const numeroBox = await numeroDocument("BOX");
      if (!numeroBox) return;
      boite = { id: uid(), numero: numeroBox, commercialId: d.commercialId, compteType: d.compteType, compteId: d.compteId, compteLibre: d.compteLibre, contenu: lignes.map((l) => ({ refId: l.refId, format: l.format, qte: l.qte })), demandeId: d.id, controles: [], active: true, creeLe: d.demandeLe, creePar: user.nom };
      d.boiteId = boite.id;
      d.note = [`Boîte ${boite.numero}`, d.note].filter(Boolean).join(" — ");
    }
    await persistDemandesEch([...(demandesEch || []), d]);
    if (boite) await persistEchSuivi({ ...(echSuiviRef.current || echSuivi), boites: [...((echSuiviRef.current || echSuivi).boites || []), boite] });
    setDemandeEchEdit(null);
    setEchTypeModal("ech");
    setNotice(boite ? `Boîte ${boite.numero} créée : demande ${d.numero} envoyée à la production.` : `Demande ${d.numero} envoyée à la production.`);
  }
  async function marquerDemandeEchPrete(d) {
    if (!peut("echantillons.preparer")) return;
    await persistDemandesEch((demandesEch || []).map((x) => (x.id === d.id ? { ...x, statut: "prête", preteLe: new Date().toISOString(), pretePar: user.nom } : x)));
  }
  async function annulerDemandeEch(d) {
    if (!(estGerant || d.commercialId === user.id)) return;
    if (!(await demander(`Annuler la demande ${d.numero} ?`))) return;
    await persistDemandesEch((demandesEch || []).map((x) => (x.id === d.id ? { ...x, statut: "annulée", annuleeLe: new Date().toISOString(), annuleePar: user.nom } : x)));
  }
  // Ahmed coche « Échantillons donnés au commercial » : sortie du stock (quantités données, ≤ stock).
  async function remettreDemandeEch() {
    const f = remiseEch;
    if (!f || !peut("echantillons.preparer")) return;
    const d = (demandesEch || []).find((x) => x.id === f.id);
    if (!d || !demandeEchOuverte(d)) return;
    const lignes = d.lignes.map((l, i) => { const reste = resteLigneEch(l); const dft = Math.min(reste, Math.max(0, stockEch(l.refId, l.format))); return { ...l, donne: Number(l.donne ?? l.qteDonnee) || 0, maintenant: Math.round(Number(String(f.qtes[i] ?? dft).replace(",", "."))) }; });
    if (lignes.some((l) => !isFinite(l.maintenant) || l.maintenant < 0 || l.maintenant > resteLigneEch(l))) { setNotice("Quantités données invalides (au plus le reste à donner)."); return; }
    const besoin = {};
    lignes.forEach((l) => { const k = `${l.refId}|${l.format}`; besoin[k] = (besoin[k] || 0) + l.maintenant; });
    const manque = Object.entries(besoin).filter(([k, q]) => { const [r, fm] = k.split("|"); return stockEch(r, fm) < q; });
    if (manque.length) { setNotice(`Stock insuffisant : ${manque.map(([k]) => { const [r, fm] = k.split("|"); return `${libRefEch(refEch(r))} ${libFormatEch(fm).toLowerCase()} (${stockEch(r, fm)} en stock)`; }).join(", ")}. Baisse la quantité donnée.`); return; }
    if (!lignes.some((l) => l.maintenant > 0)) { setNotice("Aucun échantillon donné."); return; }
    const maintenant = new Date().toISOString();
    const nouvelles = lignes.map(({ maintenant: m, qteDonnee, ...l }) => ({ ...l, donne: l.donne + m }));
    const reste = nouvelles.some((l) => resteLigneEch(l) > 0);
    await persistEchMouvements([...(echMouvements || []), ...lignes.filter((l) => l.maintenant > 0).map((l) => ({ id: uid(), refId: l.refId, format: l.format, qte: -l.maintenant, motif: `Demande ${d.numero} — ${nomUtilisateur(d.commercialId)} pour ${compteDemandeEch(d)}`, demandeId: d.id, date: todayISO(), par: user.nom, le: maintenant }))]);
    await persistDemandesEch((demandesEch || []).map((x) => (x.id === d.id ? { ...x, lignes: nouvelles, statut: reste ? "partielle" : "remise", partielle: reste || !!x.partielle, remises: [...(x.remises || []), { le: maintenant, par: user.nom, lignes: lignes.filter((l) => l.maintenant > 0).map((l) => ({ refId: l.refId, format: l.format, qte: l.maintenant })) }], ...(reste ? {} : { remiseLe: maintenant, remisePar: user.nom }) } : x)));
    // Matériel prêtable (présentoir, kakémono…) : suivi « prêté à … » jusqu'à sa récupération.
    const pretes = lignes.filter((l) => l.maintenant > 0 && (refEch(l.refId) || {}).pretable);
    if (pretes.length) {
      const su = echSuiviRef.current || echSuivi;
      await persistEchSuivi({ ...su, prets: [...(su.prets || []), ...pretes.map((l) => ({ id: uid(), refId: l.refId, qte: l.maintenant, demandeId: d.id, commercialId: d.commercialId, chez: compteDemandeEch(d), depuis: todayISO(), par: user.nom }))] });
    }
    setRemiseEch(null);
  }
  // ---- Nils 04/10 : suivi des prospects affectés (rapport de la semaine, report, documents liés) ----
  function semaineProspect(p) {
    return p.semaineReport || lundiDe((p.affecteLe || new Date().toISOString()).slice(0, 10));
  }
  function prospectsATraiter(comId, lundi) {
    const lundiCourant = lundiDe(todayISO());
    return (prospects || []).filter((p) => p.origineMkt && p.statut === "actif" && p.commercialId === comId && p.affecteLe && !p.contacteLe && (semaineProspect(p) === lundi || (lundi === lundiCourant && semaineProspect(p) < lundi)));
  }
  async function reporterProspect(p) {
    if (p.commercialId !== user.id && !estGerant) return;
    const de = semaineProspect(p) < lundiDe(todayISO()) ? lundiDe(todayISO()) : semaineProspect(p);
    const vers = decalerJours(de, 7);
    await persistProspects((prospects || []).map((x) => (x.id === p.id ? { ...x, semaineReport: vers, reports: [...(x.reports || []), { le: new Date().toISOString(), par: user.nom, de, vers }] } : x)));
  }
  // Documents liés : devis du client issu du prospect (depuis le premier contact) et dossiers qui en découlent.
  function docsProspect(p) {
    if (!p || !p.clientId) return null;
    const depuis = (p.dateContact || p.creeLe || "").slice(0, 10);
    const devis = (devisListe || []).filter((d) => d.clientId === p.clientId && d.numero && (d.date || d.creeLe || "").slice(0, 10) >= depuis).sort((a, b) => ((a.date || a.creeLe) < (b.date || b.creeLe) ? -1 : 1));
    const ids = new Set(devis.map((d) => d.id));
    const dossiers = (commandesListe || []).filter((c) => ids.has(c.devisId));
    const etape = dossiers.some((c) => c.numeroFacture) ? "Facturé" : dossiers.some((c) => c.numeroBL) ? "BL" : dossiers.some((c) => c.numeroPL) ? "PL" : dossiers.length ? "BDC" : devis.length ? "Devis" : "Client créé";
    const dernier = devis[devis.length - 1];
    return {
      devis, dossiers, etape,
      devisHT: dernier ? calcTotaux(dernier).totalHT || 0 : 0,
      bdcHT: dossiers.reduce((n, c) => n + htDossier(c), 0),
      factureHT: dossiers.filter((c) => c.numeroFacture).reduce((n, c) => n + htDossier(c), 0),
    };
  }
  // Aperçu en lecture seule (même rendu que le document imprimé).
  function apercuDevis(d) {
    setApercuDoc({ titre: `Devis ${d.numero}`, html: construireHtmlDocument(d, { titre: "DEVIS", numeroAffiche: d.numero, elementsSupplementaires: elementsDescriptifsTechniques(d) }) });
  }
  function apercuDossier(c) {
    const src = (devisListe || []).find((d) => d.id === c.devisId);
    if (!src) { setNotice("Devis d'origine introuvable."); return; }
    const base = devisPourImpression(c, src);
    const el = elementsDescriptifsTechniques(c);
    let o;
    if (c.numeroFacture) o = { lib: `Facture ${c.numeroFacture}`, opts: { titre: "FACTURE", numeroAffiche: c.numeroFacture, dateDocument: c.dateFacture } };
    else if (c.numeroBL) o = { lib: `BL ${c.numeroBL}`, opts: { titre: src.exonereTVA ? "BON DE LIVRAISON (BLS)" : "BON DE LIVRAISON", numeroAffiche: c.numeroBL, masquerFinance: true, elementsSupplementaires: el, nombreColis: c.nombreColis, avecSignatures: true, dateDocument: c.dateBL, mention: mentionSavBL(c) } };
    else if (c.numeroPL) o = { lib: `PL ${c.numeroPL}`, opts: { titre: "BON POUR PRODUCTION", numeroAffiche: c.numeroPL, masquerFinance: true, elementsSupplementaires: el, dateDocument: c.datePL, mention: mentionGratuite(c) } };
    else o = { lib: `BDC ${c.numero}`, opts: { titre: "BON DE COMMANDE", numeroAffiche: c.numero, elementsSupplementaires: el, dateDocument: c.creeLe } };
    setApercuDoc({ titre: o.lib, html: construireHtmlDocument(base, o.opts) });
  }
  async function relierProspectClient() {
    const f = relierProspect;
    if (!f || !f.clientId) { setNotice("Choisis le client."); return; }
    const p = prospectDe(f.id);
    if (!p || (p.commercialId !== user.id && !estGerant)) return;
    await persistProspects((prospects || []).map((x) => (x.id === p.id ? { ...x, statut: "converti", clientId: f.clientId, convertiLe: new Date().toISOString(), convertiPar: user.nom, relieManuellement: true, contacteLe: x.contacteLe || new Date().toISOString() } : x)));
    setRelierProspect(null);
  }
  function suiviProspect(p) {
    const s = docsProspect(p);
    if (!s) return null;
    const lien = { background: "none", border: "none", padding: 0, color: ENCRE, textDecoration: "underline", cursor: "pointer", fontSize: 12 };
    return (
      <div style={{ fontSize: 12, marginTop: 4 }}>
        <span style={{ fontWeight: 600, color: s.etape === "Facturé" ? VERT_OK : ENCRE }}>{s.etape}</span>
        {s.devis.length > 0 && <span> · {s.devis.length} devis, dernier {formatDH(s.devisHT)} HT</span>}
        {s.dossiers.length > 0 && <span> · BDC {formatDH(s.bdcHT)} HT</span>}
        {s.factureHT > 0 && <span> · facturé {formatDH(s.factureHT)} HT</span>}
        {(s.devis.length > 0 || s.dossiers.length > 0) && (
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 2 }}>
            {s.devis.map((d) => (<button key={d.id} type="button" className="sc-btn" onClick={() => apercuDevis(d)} style={lien} title="Aperçu (lecture seule)">👁 {d.numero}</button>))}
            {s.dossiers.map((c) => (<button key={c.id} type="button" className="sc-btn" onClick={() => apercuDossier(c)} style={lien} title="Aperçu (lecture seule)">👁 {c.numeroFacture || c.numeroBL || c.numeroPL || c.numero}</button>))}
          </div>
        )}
      </div>
    );
  }
  // Nils 09/10 : lot d'origine resté vide après une répartition book-match A / B = lot « orphelin ».
  // Il est gardé dans les données (lien avec l'arrivage import, historique) mais masqué dans le Stock.
  function lotOrphelinBM(x, liste) {
    return !!x && !x.bm && !(Number(x.stockReel) > 0) && !(Number(x.arrivages) > 0) && !(reservations || []).some((r) => r.itemId === x.id)
      && (liste || items || []).some((y) => y.id !== x.id && y.lotOrigineId === x.id);
  }
  // ERP step 16 (Nils 12/10) : pré-cochage unique des natures d'article (pose, façonnage, livraison, RDM)
  // d'après les anciens réglages ; les articles concernés (hors Tranche et Descriptifs) restent
  // « à vérifier » par Nils jusqu'à ce qu'il les enregistre ou clique « ✓ Natures vérifiées ».
  const migrationNaturesRef = useRef(false);
  useEffect(() => {
    if (loading || migrationNaturesRef.current || !Array.isArray(articles)) return;
    if (!articles.some((a) => !a.natures || a.natures.decoupe === undefined)) return;
    migrationNaturesRef.current = true;
    persistArticles(articles.map((a) => {
      if (!a.natures) return { ...a, natures: naturesInitialesArticle(a), naturesAVerifier: a.categorie !== "Tranche" && a.categorie !== "Descriptifs" };
      if (a.natures.decoupe !== undefined) return a;
      // Lot 2 (12/10) : 5e case « découpe unitaire » ajoutée aux articles déjà réglés.
      const dec = decoupeInitiale(a);
      return { ...a, natures: { ...a.natures, decoupe: dec }, naturesAVerifier: a.naturesAVerifier || dec };
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, articles]);
  // ERP step 15 (Nils 08/10) : nouveaux droits ajoutés une fois aux profils déjà personnalisés.
  const migrationDroits1008Ref = useRef(false);
  useEffect(() => {
    // Étape d : erp:acces ne s'écrit que par le Gérant (refusé par le serveur sinon).
    if (loading || !estGerant || migrationDroits1008Ref.current || !acces || !acces.profils || !acces.migrationDroits20261004) return;
    const ETAPES = [
      ["migrationDroits20261008", { [P_ADMIN]: ["expo.gerer"] }],
      ["migrationDroits20261008b", { [P_ADMIN]: ["vehicules.gerer"], [P_PROD]: ["vehicules.gerer"] }],
      ["migrationDroits20261008c", { [P_PROD]: ["planning.gerer"] }],
      ["migrationDroits20261009", { [P_ADMIN]: ["achats.transportIntl", "compta.questionner"] }],
      ["migrationDroits20261012", { [P_ADV_SR]: ["prospects.saisir"], [P_ADV_JR]: ["prospects.saisir"] }],
      // Step 17 (audit, Nils 14/10) : BPRDM / PL réservés à Nils et à l'ADV ; taux des apporteurs : Nils et ADV senior.
      ["migrationDroits20261015", { [P_ADMIN]: ["commandes.avoirs"] }],
      ["migrationDroits20261014", { [P_ADV_SR]: ["commandes.transformerRDMPL", "prospects.voirTauxApporteur"], [P_ADV_JR]: ["commandes.transformerRDMPL"] }],
      // Nils 29/10 : facture d'avance des projets — Nils et Sawsan (Administration).
      ["migrationDroits20261029", { [P_ADMIN]: ["projets.factureAvance"] }],
    ].filter(([flag]) => !acces[flag]);
    if (!ETAPES.length) return;
    migrationDroits1008Ref.current = true;
    const profils = { ...acces.profils };
    const faits = [];
    const flags = {};
    ETAPES.forEach(([flag, ajouts]) => {
      flags[flag] = new Date().toISOString();
      Object.entries(ajouts).forEach(([pid, droits]) => {
        const pr = profils[pid];
        if (!pr) return;
        const manquants = droits.filter((d) => !(pr.droits || []).includes(d));
        if (!manquants.length) return;
        profils[pid] = { ...pr, droits: [...(pr.droits || []), ...manquants] };
        faits.push(`${pr.label || pid} : ${manquants.map((d) => (DROITS.find((x) => x.cle === d) || {}).label || d).join(", ")}`);
      });
    });
    (async () => {
      await persistAcces({ ...acces, profils, ...flags });
      if (faits.length) await alerter("Droits ajoutés aux profils", `Nouveaux droits ajoutés à tes profils personnalisés (tu peux les décocher dans Paramétrage › Profils d'accès) — ${faits.join(" ; ")}`, { kind: "onglet", id: "parametrage" });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, acces]);
  // Nils 27/10 (b) : lots de stock de départ saisis sans prix (hors Gérant) — coût standard des articles
  // importés complété par le navigateur du Gérant (seul à connaître les coûts).
  const stockDepartPrixRef = useRef(false);
  useEffect(() => {
    if (loading || !estGerant || stockDepartPrixRef.current || !Array.isArray(items)) return;
    const sansPrix = (it) => it.stockDepart && (it.prixAchatHT === undefined || it.prixAchatHT === null || it.prixAchatHT === "");
    const complets = new Map();
    items.filter((it) => sansPrix(it) && it.type !== TYPE_CHUTE && articleImporte(articleDuProduit(it.produitId))).forEach((it) => { const std = coutStandardLot(it); if (std !== null) complets.set(it.id, std); });
    if (!complets.size) return;
    stockDepartPrixRef.current = true;
    (async () => {
      await persist(items.map((it) => (complets.has(it.id) ? { ...it, coutStandardHT: complets.get(it.id), prixAchatHT: complets.get(it.id) } : it)));
      await tracerAcces("stock de départ", `coût standard complété sur ${complets.size} lot(s) saisi(s) sans prix`, true);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, items]);
  // Nils 04/10 (a) : ajout unique des nouveaux droits dans les profils déjà personnalisés.
  const migrationDroitsRef = useRef(false);
  useEffect(() => {
    // Étape d : erp:acces ne s'écrit que par le Gérant (refusé par le serveur sinon).
    if (loading || !estGerant || migrationDroitsRef.current || !acces || !acces.profils || acces.migrationDroits20261004) return;
    migrationDroitsRef.current = true;
    const AJOUTS = { [P_PROD]: ["echantillons.preparer", "affectations.machines", "affectations.bureaux"], [P_COM]: ["echantillons.demander", "commercial.rapport"], [P_AGENT]: ["echantillons.demander", "commercial.rapport"], [P_ADMIN]: ["affectations.bureaux"] };
    const profils = { ...acces.profils };
    const faits = [];
    Object.entries(AJOUTS).forEach(([pid, droits]) => {
      const pr = profils[pid];
      if (!pr) return;
      const manquants = droits.filter((d) => !(pr.droits || []).includes(d));
      if (!manquants.length) return;
      profils[pid] = { ...pr, droits: [...(pr.droits || []), ...manquants] };
      faits.push(`${pr.label || pid} : ${manquants.map((d) => (DROITS.find((x) => x.cle === d) || {}).label || d).join(", ")}`);
    });
    (async () => {
      await persistAcces({ ...acces, profils, migrationDroits20261004: new Date().toISOString() });
      if (faits.length) await alerter("Droits ajoutés aux profils", `Nouveaux droits ajoutés à tes profils personnalisés (tu peux les décocher dans Paramétrage › Profils d'accès) — ${faits.join(" ; ")}`, { kind: "onglet", id: "parametrage" });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, acces]);
  // ---- Nils 04/10 : échantillons — code couleur, lien avec le stock de tranches, reste à donner ----
  function produitsLiesEch(e) {
    if (!e) return [];
    if (Array.isArray(e.produitIds)) return e.produitIds;
    return produitsParCodeEch(e.code);
  }
  function produitsParCodeEch(code) {
    const c = String(code || "").trim().toLowerCase();
    if (!c) return [];
    return [...new Set((articles || []).filter((a) => a.categorie === "Tranche" && String(a.codeFournisseur || "").trim().toLowerCase() === c && a.produitStockId).map((a) => a.produitStockId))];
  }
  function tranchesEnStockEch(e) {
    const ids = new Set(produitsLiesEch(e));
    if (!ids.size) return null;
    const lots = (items || []).filter((it) => ids.has(it.produitId) && it.type !== TYPE_CHUTE);
    const reel = lots.reduce((n, l) => n + (Number(l.stockReel) || 0), 0);
    const reserve = lots.reduce((n, l) => n + reservedFor(l.id), 0);
    return { reel, libre: reel - reserve };
  }
  const resteLigneEch = (l) => Math.max(0, (Number(l.qte) || 0) - (Number(l.donne ?? l.qteDonnee) || 0));
  const demandeEchOuverte = (d) => d.statut === "demandée" || d.statut === "prête" || d.statut === "partielle";
  async function cloturerDemandeEchSansReste(d) {
    if (!(estGerant || d.commercialId === user.id)) return;
    if (!(await demander(`Clôturer ${d.numero} sans donner le reste ?`))) return;
    await persistDemandesEch((demandesEch || []).map((x) => (x.id === d.id ? { ...x, statut: "remise", clotureSansReste: true, clotureLe: new Date().toISOString(), cloturePar: user.nom } : x)));
  }
  async function supprimerRefEch(e) {
    if (!(estGerant || peut("echantillons.preparer"))) return;
    const t = tranchesEnStockEch(e);
    if (t && t.reel > 0) { setNotice(`Suppression impossible : ${t.reel} tranche(s) de cette couleur en stock. Passe-la en « hors production » si besoin.`); return; }
    const pieces = formatsRefEch(e).reduce((n, f) => n + stockEch(e.id, f.cle), 0);
    const ouvertes = (demandesEch || []).filter((d) => demandeEchOuverte(d) && d.lignes.some((l) => l.refId === e.id && resteLigneEch(l) > 0));
    if (!(await demander(`Supprimer « ${libRefEch(e)} »${pieces ? ` (${pieces} échantillon(s) encore en stock)` : ""}${ouvertes.length ? ` — attendue sur ${ouvertes.map((d) => d.numero).join(", ")}` : ""} ? L'historique des mouvements reste.`))) return;
    await persistEchantillons((echantillons || []).filter((x) => x.id !== e.id));
    setRefEchEdit(null);
  }
  // ---------- ERP step 15 (am) : matériel marketing, prêts, boîtes revendeurs ----------
  async function enregistrerMatEch() {
    const f = matEdit;
    if (!f || !(estGerant || peut("echantillons.preparer"))) return;
    const designation = String(f.designation || "").trim();
    if (!designation) { setNotice("Indique la désignation de l'article."); return; }
    if ((echantillons || []).some((e) => estMatEch(e) && e.id !== f.id && normLib(e.designation || "") === normLib(designation))) { setNotice("Cet article existe déjà."); return; }
    const x = { ...f, type: "materiel", designation, couleur: designation, finition: "", gamme: "Matériel marketing", code: "", seuil: Math.max(0, Math.round(nombreOuZero(f.seuil))), pretable: !!f.pretable, horsProduction: !!f.horsProduction, id: f.id || uid() };
    await persistEchantillons((echantillons || []).some((e) => e.id === x.id) ? (echantillons || []).map((e) => (e.id === x.id ? x : e)) : [...(echantillons || []), x]);
    await tracerAcces(f.id ? "matériel marketing modifié" : "matériel marketing créé", designation);
    setMatEdit(null);
  }
  async function supprimerMatEch(e) {
    if (!(estGerant || peut("echantillons.preparer"))) return;
    const st = stockEch(e.id, FORMAT_MAT.cle);
    const prete = ((echSuivi && echSuivi.prets) || []).some((p) => p.refId === e.id && !p.recupereLe);
    if (prete) { setNotice("Cet article est encore prêté : marque-le récupéré d'abord, ou désactive-le."); return; }
    if (!(await demander(`Supprimer « ${libRefEch(e)} »${st ? ` (${st} en stock)` : ""} ? L'historique reste.`))) return;
    await persistEchantillons((echantillons || []).filter((x) => x.id !== e.id));
    setMatEdit(null);
  }
  async function recupererPret(p) {
    if (!(estGerant || peut("echantillons.preparer"))) return;
    if (!(await demander(`${libRefEch(refEch(p.refId))} × ${p.qte} récupéré chez ${p.chez} : le remettre en stock ?`))) return;
    const maintenant = new Date().toISOString();
    await persistEchMouvements([...(echMouvements || []), { id: uid(), refId: p.refId, format: FORMAT_MAT.cle, qte: p.qte, motif: "Retour de prêt", note: p.chez, date: todayISO(), par: user.nom, le: maintenant }]);
    const su = echSuiviRef.current || echSuivi;
    await persistEchSuivi({ ...su, prets: (su.prets || []).map((x) => (x.id === p.id ? { ...x, recupereLe: todayISO(), recuperePar: user.nom } : x)) });
  }
  function demandeDeBoite(b) {
    return (demandesEch || []).find((d) => d.id === b.demandeId) || null;
  }
  function dateRemiseBoite(b) {
    const d = demandeDeBoite(b);
    if (!d) return "";
    const r = (d.remises || [])[0];
    return ((r && r.le) || d.remiseLe || "").slice(0, 10);
  }
  function dernierControleBoite(b) {
    const c = [...(b.controles || [])].sort((x, y) => (x.date < y.date ? 1 : -1))[0];
    return c ? c.date : "";
  }
  function prochainControleBoite(b) {
    const base = dernierControleBoite(b) || dateRemiseBoite(b);
    if (!base) return "";
    const d = new Date(`${base}T12:00:00Z`);
    d.setUTCMonth(d.getUTCMonth() + (Math.round(nombreOuZero(echSuivi && echSuivi.delaiControleMois)) || 6));
    return d.toISOString().slice(0, 10);
  }
  function peutBoite(b) {
    return estGerant || peut("echantillons.preparer") || (b && b.commercialId === user.id);
  }
  // Contrôle d'une boîte : les manquants deviennent une demande de complément (même circuit que les échantillons).
  async function enregistrerControleBoite() {
    const f = controleBoite;
    const su = echSuiviRef.current || echSuivi;
    const b = f && (su.boites || []).find((x) => x.id === f.boiteId);
    if (!b || !(estGerant || b.commercialId === user.id)) return;
    if (!f.date) { setNotice("Indique la date du contrôle."); return; }
    const manquants = (b.contenu || []).map((l, i) => ({ refId: l.refId, format: l.format, qte: Math.round(nombreOuZero(f.manquants[i])) })).filter((l) => l.qte > 0);
    const trop = manquants.find((m) => m.qte > ((b.contenu || []).find((l) => l.refId === m.refId && l.format === m.format) || {}).qte);
    if (trop) { setNotice(`${libRefEch(refEch(trop.refId))} : plus de manquants que dans la boîte.`); return; }
    let demande = null;
    if (manquants.length) {
      const numeroEch = await numeroDocument("ECH");
      if (!numeroEch) return;
      demande = { id: uid(), numero: numeroEch, commercialId: b.commercialId, compteType: b.compteType, compteId: b.compteId, compteLibre: b.compteLibre, visiteId: "", note: `Complément boîte ${b.numero} (contrôle du ${formatDate(f.date)})`, lignes: manquants, statut: "demandée", demandeLe: new Date().toISOString(), demandePar: user.nom, boiteId: b.id };
      await persistDemandesEch([...(demandesEch || []), demande]);
    }
    const controle = { id: uid(), date: f.date, par: user.nom, manquants, demandeId: demande ? demande.id : "", note: String(f.note || "").trim() };
    await persistEchSuivi({ ...su, boites: (su.boites || []).map((x) => (x.id === b.id ? { ...x, controles: [...(x.controles || []), controle] } : x)) });
    await tracerAcces("contrôle boîte revendeur", `${b.numero} — ${manquants.length} manquant(s)`);
    setControleBoite(null);
    setNotice(demande ? `Contrôle enregistré : demande ${demande.numero} de complément envoyée à la production.` : "Contrôle enregistré : boîte complète.");
  }
  async function retirerBoite(b) {
    if (!(estGerant || peut("echantillons.preparer") || b.commercialId === user.id)) return;
    if (!(await demander(`Marquer la boîte ${b.numero} comme récupérée chez ${compteDemandeEch(b)} ?`))) return;
    const remettre = (estGerant || peut("echantillons.preparer")) && (await demander(`Remettre son contenu en stock (${(b.contenu || []).reduce((n, l) => n + l.qte, 0)} pièce(s), moins les manquants que tu corrigeras par un ajustement) ?`));
    const maintenant = new Date().toISOString();
    if (remettre) await persistEchMouvements([...(echMouvements || []), ...(b.contenu || []).map((l) => ({ id: uid(), refId: l.refId, format: l.format, qte: l.qte, motif: "Retour de boîte", note: `${b.numero} — ${compteDemandeEch(b)}`, date: todayISO(), par: user.nom, le: maintenant }))]);
    const su = echSuiviRef.current || echSuivi;
    await persistEchSuivi({ ...su, boites: (su.boites || []).map((x) => (x.id === b.id ? { ...x, active: false, retireeLe: todayISO(), retireePar: user.nom, retourStock: !!remettre } : x)) });
    setBoiteVue(null);
  }
  async function imprimerChecklistBoite(b) {
    const lignes = [...(b.contenu || [])].map((l) => ({ ...l, e: refEch(l.refId) })).sort((x, y) => String((x.e || {}).couleur || "").localeCompare(String((y.e || {}).couleur || ""), "fr"));
    const rows = lignes.map((l) => `<tr><td class="cb">☐</td><td>${escapeHtml((l.e && l.e.code) || "")}</td><td>${escapeHtml(l.e ? l.e.couleur : "?")}</td><td>${escapeHtml(l.e ? l.e.finition : "")}</td><td>${escapeHtml(libFormatEch(l.format))}</td><td class="n">${l.qte}</td><td class="m"></td></tr>`).join("");
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>Boite_${b.numero}</title><style>
  @page { size: A4 portrait; margin: 14mm; }
  body { font-family: "DM Sans", Arial, sans-serif; color: #281E1E; font-size: 10pt; }
  h1 { font-family: "Cormorant Garamond", Georgia, serif; font-size: 20pt; margin: 0 0 4px; }
  .meta { color: #8C8282; margin-bottom: 12px; }
  table { border-collapse: collapse; width: 100%; }
  th, td { border-bottom: 1px solid #E6E0DB; padding: 4px 6px; text-align: left; }
  th { font-size: 8pt; color: #8C8282; text-transform: uppercase; }
  .cb { width: 18px; font-size: 13pt; } .n { text-align: center; width: 40px; } .m { width: 90px; }
  .sig { margin-top: 28px; display: flex; gap: 60px; } .sig div { border-top: 1px solid #281E1E; width: 220px; padding-top: 4px; font-size: 9pt; }
</style></head><body>
<h1>Boîte d'échantillons ${escapeHtml(b.numero)}</h1>
<div class="meta">${escapeHtml(compteDemandeEch(b))} · commercial : ${escapeHtml(nomUtilisateur(b.commercialId) || "")} · remise le ${dateRemiseBoite(b) ? formatDate(dateRemiseBoite(b)) : "—"} · contrôle du ____/____/______</div>
<table><thead><tr><th></th><th>Code</th><th>Couleur</th><th>Finition</th><th>Format</th><th class="n">Qté</th><th class="m">Manquants</th></tr></thead><tbody>${rows}</tbody></table>
<div class="sig"><div>Stone Concept</div><div>Revendeur</div></div>
</body></html>`;
    await telechargerDocument(html, `Boite_${b.numero}`, "checklist");
  }
  function renderMaterielMkt() {
    const gere = estGerant || peut("echantillons.preparer");
    const q = echRecherche.trim().toLowerCase();
    const arts = (echantillons || []).filter((e) => estMatEch(e) && (echVoirHP || !e.horsProduction) && (!q || normLib(e.designation || "").includes(normLib(q)))).sort((a, b) => String(a.designation || "").localeCompare(String(b.designation || ""), "fr"));
    const prets = ((echSuivi && echSuivi.prets) || []).filter((p) => !p.recupereLe && (gere || p.commercialId === user.id)).sort((a, b) => (a.depuis < b.depuis ? -1 : 1));
    const th = { padding: 6, textAlign: "left" };
    return (
      <div>
        <div style={{ display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap", marginBottom: 12 }}>
          <FiltreChamp label="Rechercher">
            <input className="sc-input" value={echRecherche} onChange={(e) => setEchRecherche(e.target.value)} placeholder="Catalogue, kakémono…" style={inputStyle(230)} />
          </FiltreChamp>
          <FiltreChamp label="Catégorie">
            {selecteurVueStock("__mat")}
          </FiltreChamp>
          <label style={{ fontSize: 12, display: "flex", gap: 4, alignItems: "center", paddingBottom: 8 }}><input type="checkbox" checked={echVoirHP} onChange={(e) => setEchVoirHP(e.target.checked)} /> Inactifs</label>
          <span style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
            {peut("echantillons.demander") && <button type="button" className="sc-btn" onClick={() => { setEchTypeModal("mat"); setDemandeEchEdit(nouvelleDemandeEch()); }} style={primaryBtnStyle}>🎁 Demande de matériel</button>}
            {peut("echantillons.preparer") && <button type="button" className="sc-btn" onClick={() => ouvrirTypeArrivage("mat")} style={ghostBtnStyle}>📥 Arrivage</button>}
            {peut("echantillons.preparer") && <button type="button" className="sc-btn" onClick={() => { setEchTypeModal("mat"); setEchRechercheModal(""); setEntreeEch({ motif: "Retour", note: "", lignes: {} }); }} style={ghostBtnStyle}>Retour / ajustement</button>}
            {peut("echantillons.preparer") && <button type="button" className="sc-btn" onClick={() => { setEchTypeModal("mat"); setEchRechercheModal(""); setInventaireEch({ note: "", lignes: {} }); }} style={ghostBtnStyle}>Inventaire</button>}
            {gere && <button type="button" className="sc-btn" onClick={() => setMatEdit({ designation: "", seuil: "", pretable: false, horsProduction: false })} style={ghostBtnStyle}>+ Article</button>}
          </span>
        </div>
        {!!prets.length && (
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 12, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 6 }}>Matériel prêté — {prets.length}</div>
            {prets.map((p) => (
              <div key={p.id} style={{ background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "6px 12px", marginBottom: 4, display: "flex", gap: 12, alignItems: "center", fontSize: 13 }}>
                <strong>{libRefEch(refEch(p.refId))} × {p.qte}</strong>
                <span>chez {p.chez}</span>
                <span style={{ color: TAUPE, fontSize: 12 }}>{nomUtilisateur(p.commercialId)} · depuis le {formatDate(p.depuis)}</span>
                {gere && <button type="button" className="sc-btn" onClick={() => recupererPret(p)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 8px", marginLeft: "auto" }}>Récupéré</button>}
              </div>
            ))}
          </div>
        )}
        <div style={{ background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden" }}>
          <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 13 }}>
            <thead><tr style={{ color: TAUPE, fontSize: 11, background: PIERRE }}><th style={th}>Article</th><th style={{ ...th, textAlign: "center" }}>Stock</th><th style={{ ...th, textAlign: "center" }}>Seuil</th><th style={th}>Prêtable</th><th style={th}>Prêté</th><th style={th}></th></tr></thead>
            <tbody>
              {arts.map((e) => {
                const st = stockEch(e.id, FORMAT_MAT.cle);
                const bas = nombreOuZero(e.seuil) > 0 && st <= nombreOuZero(e.seuil);
                const prete = ((echSuivi && echSuivi.prets) || []).filter((p) => p.refId === e.id && !p.recupereLe).reduce((n, p) => n + p.qte, 0);
                return (
                  <tr key={e.id} style={{ borderTop: `1px solid ${PIERRE}`, opacity: e.horsProduction ? 0.6 : 1 }}>
                    <td style={{ padding: "5px 6px" }}>{libRefEch(e)}{e.horsProduction ? <span style={{ color: TAUPE, fontSize: 11 }}> · inactif</span> : null}</td>
                    <td style={{ padding: "5px 6px", textAlign: "center", fontWeight: 600, color: bas || st <= 0 ? ROUILLE : ENCRE }}>{st}</td>
                    <td style={{ padding: "5px 6px", textAlign: "center", color: TAUPE }}>{nombreOuZero(e.seuil) || "—"}</td>
                    <td style={{ padding: "5px 6px", color: TAUPE }}>{e.pretable ? "oui" : ""}</td>
                    <td style={{ padding: "5px 6px" }}>{prete || ""}</td>
                    <td style={{ padding: "5px 6px", textAlign: "right" }}>{gere && <button type="button" className="sc-btn" onClick={() => setMatEdit({ ...e, seuil: String(e.seuil ?? "") })} style={iconBtnStyle} title="Modifier">✎</button>}</td>
                  </tr>
                );
              })}
              {!arts.length && <tr><td colSpan={6} style={{ padding: 12, color: TAUPE }}>Aucun article. {gere ? "« + Article » pour créer catalogues, flyers, kakémonos, présentoirs…" : ""}</td></tr>}
            </tbody>
          </table>
        </div>
        <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Le commercial (ou le Gérant) demande, la production prépare et remet ; le matériel sort du stock à la remise. Matériel prêtable : suivi « prêté chez … » jusqu'à sa récupération (retour en stock). Seuil : tâche au Production Manager quand le stock l'atteint.</div>
      </div>
    );
  }
  function renderModalesEch() {
    const su = echSuivi || {};
    const b = boiteVue ? (su.boites || []).find((x) => x.id === boiteVue) : null;
    return (
      <>
        {matEdit && (estGerant || peut("echantillons.preparer")) && (
          <Overlay onClose={() => setMatEdit(null)} zIndex={1450}>
            <div style={modalStyle(460)}>
              <div style={modalTitleStyle}>{matEdit.id ? "Article de matériel marketing" : "Nouvel article de matériel marketing"}</div>
              <Field label="Désignation"><input className="sc-input" value={matEdit.designation || ""} onChange={(e) => setMatEdit({ ...matEdit, designation: e.target.value })} style={inputStyle("100%")} /></Field>
              <Field label="Seuil d'alerte (0 = aucun)"><input type="number" min="0" className="sc-input" value={matEdit.seuil ?? ""} onChange={(e) => setMatEdit({ ...matEdit, seuil: e.target.value })} style={inputStyle(100)} /></Field>
              <label style={{ fontSize: 13, display: "flex", gap: 6, alignItems: "center", marginBottom: 6 }}><input type="checkbox" checked={!!matEdit.pretable} onChange={(e) => setMatEdit({ ...matEdit, pretable: e.target.checked })} /> Prêté (présentoir, kakémono…) : suivi jusqu'à sa récupération</label>
              <label style={{ fontSize: 13, display: "flex", gap: 6, alignItems: "center", marginBottom: 12 }}><input type="checkbox" checked={!!matEdit.horsProduction} onChange={(e) => setMatEdit({ ...matEdit, horsProduction: e.target.checked })} /> Inactif (plus proposé dans les demandes)</label>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                {matEdit.id && <button type="button" className="sc-btn" onClick={() => supprimerMatEch(matEdit)} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>Supprimer</button>}
                <button type="button" className="sc-btn" onClick={() => setMatEdit(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={enregistrerMatEch} style={primaryBtnStyle}>Enregistrer</button>
              </div>
            </div>
          </Overlay>
        )}
        {b && peutBoite(b) && (() => {
          const d0 = demandeDeBoite(b);
          const ctrl = [...(b.controles || [])].sort((x, y) => (x.date < y.date ? 1 : -1));
          const pc = prochainControleBoite(b);
          return (
            <Overlay onClose={() => setBoiteVue(null)} zIndex={1450}>
              <div style={{ ...modalStyle(720), maxHeight: "90vh", overflowY: "auto" }}>
                <div style={modalTitleStyle}>Boîte {b.numero} — {compteDemandeEch(b)}</div>
                <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 10 }}>{nomUtilisateur(b.commercialId)} · demande {d0 ? `${d0.numero} (${d0.statut})` : "?"} · {dateRemiseBoite(b) ? `remise le ${formatDate(dateRemiseBoite(b))}` : "pas encore remise"}{b.active === false ? ` · récupérée le ${formatDate(b.retireeLe)}${b.retourStock ? " (contenu remis en stock)" : ""}` : pc ? ` · prochain contrôle le ${formatDate(pc)}` : ""}</div>
                <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Contenu</div>
                <div style={{ fontSize: 12, marginBottom: 10 }}>{(b.contenu || []).map((l, i) => <span key={i} style={{ display: "inline-block", background: PIERRE, borderRadius: 6, padding: "2px 8px", margin: "0 6px 6px 0" }}>{libRefEch(refEch(l.refId))} · {libFormatEch(l.format).toLowerCase()} × {l.qte}</span>)}</div>
                <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Contrôles</div>
                {!ctrl.length && <div style={{ fontSize: 12, color: TAUPE, marginBottom: 8 }}>Aucun contrôle.</div>}
                {ctrl.map((c) => { const dc = (demandesEch || []).find((x) => x.id === c.demandeId); return (
                  <div key={c.id} style={{ fontSize: 12, marginBottom: 4 }}>{formatDate(c.date)} ({c.par}) : {c.manquants.length ? `${c.manquants.map((m) => `${libRefEch(refEch(m.refId))} ${libFormatEch(m.format).toLowerCase()} × ${m.qte}`).join(", ")} → ${dc ? `${dc.numero} (${dc.statut})` : "demande"}` : "complète"}{c.note ? ` — ${c.note}` : ""}</div>
                ); })}
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 14, flexWrap: "wrap" }}>
                  {b.active !== false && <button type="button" className="sc-btn" onClick={() => retirerBoite(b)} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>Boîte récupérée</button>}
                  <button type="button" className="sc-btn" onClick={() => imprimerChecklistBoite(b)} style={ghostBtnStyle}>🖨 Checklist</button>
                  <button type="button" className="sc-btn" onClick={() => setBoiteVue(null)} style={ghostBtnStyle}>Fermer</button>
                  {b.active !== false && (estGerant || b.commercialId === user.id) && <button type="button" className="sc-btn" onClick={() => setControleBoite({ boiteId: b.id, date: todayISO(), manquants: {}, note: "" })} style={primaryBtnStyle}>Contrôler la boîte</button>}
                </div>
              </div>
            </Overlay>
          );
        })()}
        {controleBoite && (() => {
          const bc = (su.boites || []).find((x) => x.id === controleBoite.boiteId);
          if (!bc) return null;
          const setC = (patch) => setControleBoite({ ...controleBoite, ...patch });
          return (
            <Overlay onClose={() => setControleBoite(null)} zIndex={1460}>
              <div style={{ ...modalStyle(640), maxHeight: "90vh", display: "flex", flexDirection: "column" }}>
                <div style={modalTitleStyle}>Contrôle de la boîte {bc.numero}</div>
                <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 8 }}>Indique les pièces manquantes : elles deviennent une demande de complément pour la production.</div>
                <Field label="Date du contrôle"><input type="date" className="sc-input" value={controleBoite.date} max={todayISO()} onChange={(e) => setC({ date: e.target.value })} style={inputStyle(150)} /></Field>
                <div style={{ overflowY: "auto", flex: 1, border: `1px solid ${PIERRE}`, borderRadius: 8 }}>
                  <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 12 }}>
                    <thead style={{ position: "sticky", top: 0, background: "#fff" }}><tr style={{ color: TAUPE, textAlign: "left" }}><th style={{ padding: 4 }}>Échantillon</th><th style={{ padding: 4 }}>Format</th><th style={{ padding: 4, textAlign: "center" }}>Dans la boîte</th><th style={{ padding: 4, textAlign: "center" }}>Manquants</th></tr></thead>
                    <tbody>
                      {(bc.contenu || []).map((l, i) => (
                        <tr key={i} style={{ borderTop: `1px solid ${PIERRE}`, background: nombreOuZero(controleBoite.manquants[i]) > 0 ? "#F5EFE0" : "transparent" }}>
                          <td style={{ padding: "3px 4px" }}>{libRefEch(refEch(l.refId))}</td>
                          <td style={{ padding: "3px 4px" }}>{libFormatEch(l.format)}</td>
                          <td style={{ padding: "3px 4px", textAlign: "center" }}>{l.qte}</td>
                          <td style={{ padding: "3px 4px", textAlign: "center" }}><input className="sc-input" value={controleBoite.manquants[i] || ""} onChange={(e) => setC({ manquants: { ...controleBoite.manquants, [i]: e.target.value } })} style={{ ...inputStyle(48), padding: "2px 4px", fontSize: 12, textAlign: "center" }} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <Field label="Note (facultatif)" style={{ marginTop: 8 }}><input className="sc-input" value={controleBoite.note} onChange={(e) => setC({ note: e.target.value })} style={inputStyle("100%")} /></Field>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                  <button type="button" className="sc-btn" onClick={() => setControleBoite(null)} style={ghostBtnStyle}>Annuler</button>
                  <button type="button" className="sc-btn" onClick={enregistrerControleBoite} style={primaryBtnStyle}>Enregistrer le contrôle</button>
                </div>
              </div>
            </Overlay>
          );
        })()}
      </>
    );
  }
  async function enregistrerInventaireEch() {
    const f = inventaireEch;
    if (!f || !peut("echantillons.preparer")) return;
    const ecarts = [];
    Object.entries(f.lignes || {}).forEach(([refId, q]) => formatsRefEch(refEch(refId)).forEach((fm) => {
      const v = String((q || {})[fm.cle] ?? "").trim();
      if (v === "") return;
      const compte = Math.round(Number(v.replace(",", ".")));
      if (!isFinite(compte) || compte < 0) return;
      const diff = compte - stockEch(refId, fm.cle);
      if (diff) ecarts.push({ refId, format: fm.cle, qte: diff, compte });
    }));
    if (!Object.keys(f.lignes || {}).length) { setNotice("Saisis au moins un comptage."); return; }
    const maintenant = new Date().toISOString();
    if (ecarts.length) {
      await persistEchMouvements([...(echMouvements || []), ...ecarts.map((x) => ({ id: uid(), refId: x.refId, format: x.format, qte: x.qte, motif: "Inventaire", note: `compté ${x.compte}`, date: todayISO(), par: user.nom, le: maintenant }))]);
      if (!estGerant) await alerter("Inventaire d'échantillons : écarts", ecarts.map((x) => `${libRefEch(refEch(x.refId))} ${libFormatEch(x.format).toLowerCase()} : ${x.qte > 0 ? "+" : ""}${x.qte}`).join(" ; ") + ` (${user.nom})`, { kind: "echantillons" });
    }
    setInventaireEch(null);
    setNotice(ecarts.length ? `Inventaire enregistré : ${ecarts.length} écart(s) corrigé(s).` : "Inventaire enregistré : aucun écart.");
  }
  // ---- Nils 04/10 (ae / af) : statistiques ----
  // Famille de versions d'un devis : « Dupliquer » pour le même client (dupliqueDe) ou « Nouvelle version de… » (versionDe).
  function parentDevis(d) {
    if (!d) return null;
    if (d.versionDe) return (devisListe || []).find((x) => x.id === d.versionDe) || null;
    if (d.dupliqueDe && d.dupliqueDeClient === d.clientId) return (devisListe || []).find((x) => x.numero === d.dupliqueDe && x.clientId === d.clientId) || null;
    return null;
  }
  function racineDevis(d) {
    let cur = d;
    const vus = new Set();
    while (cur && !vus.has(cur.id)) { vus.add(cur.id); const p = parentDevis(cur); if (!p) break; cur = p; }
    return cur;
  }
  function famillesDevis() {
    const f = new Map();
    (devisListe || []).filter((d) => d.numero).forEach((d) => { const r = racineDevis(d) || d; if (!f.has(r.id)) f.set(r.id, []); f.get(r.id).push(d); });
    return [...f.entries()].map(([id, l]) => {
      const tri = [...l].sort((a, b) => ((a.date || a.creeLe || "") < (b.date || b.creeLe || "") ? -1 : 1));
      const ids = new Set(l.map((d) => d.id));
      const dossiers = (commandesListe || []).filter((c) => ids.has(c.devisId) && !c.anterieure);
      const transfo = dossiers.length ? dossiers.sort((a, b) => (a.creeLe < b.creeLe ? -1 : 1))[0] : null;
      const ref = transfo ? (devisListe || []).find((d) => d.id === transfo.devisId) : tri[tri.length - 1];
      return { id, devis: tri, premier: (tri[0].date || tri[0].creeLe || "").slice(0, 10), transfo, dateTransfo: transfo ? String(transfo.creeLe || "").slice(0, 10) : "", montant: calcTotaux(ref).totalHT || 0, racine: tri.find((d) => d.id === id) || tri[0] };
    });
  }
  const typeVenteDossier = (c) => {
    const arts = (lignesDuDossier(c) || []).map((l) => (articles || []).find((a) => a.id === l.articleId)).filter(Boolean);
    const t = arts.some((a) => natureArticle(a, "faconnage")), p = arts.some((a) => natureArticle(a, "pose"));
    return [...(t ? ["Avec transformation"] : []), ...(p ? ["Avec pose"] : []), ...(!t && !p ? ["Fourniture seule"] : [])];
  };
  function statsPeriode(du, au, delaiEnCours) {
    const dans = (d) => !!d && String(d).slice(0, 10) >= du && String(d).slice(0, 10) <= au;
    const dossiers = (commandesListe || []).filter((c) => !c.anterieure);
    const devisDe = (c) => (devisListe || []).find((d) => d.id === c.devisId) || {};
    const factures = dossiers.filter((c) => c.numeroFacture && dans(c.dateFacture));
    const bdc = dossiers.filter((c) => dans(c.creeLe));
    const ht = new Map();
    const htD = (c) => { if (!ht.has(c.id)) ht.set(c.id, htDossier(c)); return ht.get(c.id); };
    const ajout = (m, k, champ, v) => { const o = m.get(k) || { ca: 0, pc: 0, nbF: 0, nbB: 0 }; o[champ] += v; m.set(k, o); };
    const parClient = new Map(), parCom = new Map(), parCat = new Map(), parType = new Map();
    factures.forEach((c) => {
      const v = htD(c), cl = clientDe(c.clientId) || {};
      ajout(parClient, c.clientId || "?", "ca", v); ajout(parClient, c.clientId || "?", "nbF", 1);
      ajout(parCom, idCommercialDuDevis(devisDe(c)) || "—", "ca", v);
      ajout(parCat, cl.type || "Non renseigné", "ca", v);
      typeVenteDossier(c).forEach((t) => ajout(parType, t, "ca", v));
    });
    bdc.forEach((c) => {
      const v = htD(c), cl = clientDe(c.clientId) || {};
      ajout(parClient, c.clientId || "?", "pc", v); ajout(parClient, c.clientId || "?", "nbB", 1);
      ajout(parCom, idCommercialDuDevis(devisDe(c)) || "—", "pc", v);
      ajout(parCat, cl.type || "Non renseigné", "pc", v);
      typeVenteDossier(c).forEach((t) => ajout(parType, t, "pc", v));
    });
    // Taux de transformation (af) : familles dont le premier devis est dans la période.
    const limiteEnCours = decalerJours(todayISO(), -(delaiEnCours || 30));
    const fam = famillesDevis().filter((f) => dans(f.premier));
    const enCours = fam.filter((f) => !f.transfo && f.premier > limiteEnCours);
    const comptees = fam.filter((f) => f.transfo || f.premier <= limiteEnCours);
    const transfo = comptees.filter((f) => f.transfo);
    const delais = transfo.map((f) => ecartJours(f.premier, f.dateTransfo)).filter((x) => isFinite(x) && x >= 0);
    const tauxPar = (cle) => {
      const m = new Map();
      comptees.forEach((f) => { const k = cle(f); const o = m.get(k) || { n: 0, t: 0, mt: 0, mtT: 0 }; o.n++; o.mt += f.montant; if (f.transfo) { o.t++; o.mtT += f.montant; } m.set(k, o); });
      return m;
    };
    // Tranches vendues (sorties de PL, hors chutes) et consommables.
    const lots = new Map([...(lotsArchives || []), ...(items || [])].map((it) => [it.id, it]));
    const mvts = (mouvements || []).filter((m) => dans(m.date));
    const tranchesCouleur = new Map(), tranchesMatiere = new Map(), conso = new Map();
    mvts.forEach((m) => {
      const it = lots.get(m.itemId);
      if (!it) return;
      const p = produitDe(it.produitId) || it.produitSnapshot || {};
      const q = (Number(m.quantite) || 0) * (m.type === "sortie" ? 1 : -1);
      if (estMouvementConsommable(m)) {
        if (m.type !== "sortie") return;
        const k = p.nom || "?";
        const o = conso.get(k) || { qte: 0, unite: it.unite || "", cout: 0, categorie: p.categorie || "" };
        o.qte += Number(m.quantite) || 0; o.cout += valeurLotHT(it, Number(m.quantite) || 0) || 0; conso.set(k, o);
        return;
      }
      if (!m.pl || it.type === TYPE_CHUTE || familleInventaire(p.categorie) !== "Tranches" || m.repartitionBM || m.enService) return;
      const m2 = (surfaceM2(it.dimensions) || 0) * q;
      [[tranchesCouleur, p.nom || "?"], [tranchesMatiere, p.categorie || "?"]].forEach(([map, k]) => { const o = map.get(k) || { n: 0, m2: 0 }; o.n += q; o.m2 += m2; map.set(k, o); });
    });
    // Nils 26/10 (d) : chutes vendues (lignes « chute » des factures de la période), à part des tranches.
    const chutesVendues = new Map();
    factures.forEach((c) => (lignesDuDossier(c) || []).filter((l) => l.chute && l.type === "facture").forEach((l) => {
      const a = (articles || []).find((x) => x.id === l.articleId) || {};
      const k = a.produitStockId ? nomProduit(a.produitStockId) : l.designation || "?";
      const o = chutesVendues.get(k) || { n: 0, m2: 0, ht: 0 };
      const q = Number(l.qte) || 0;
      o.n += q; o.m2 += (surfaceDimensions(l.chuteDimensions) || 0) * q; o.ht += calcLigne(l).montantHT || 0;
      chutesVendues.set(k, o);
    }));
    const somme = (l) => l.reduce((n, c) => n + htD(c), 0);
    // Step 17 : avoirs de la période (à leur date) déduits du CA facturé.
    const avP = avoirsEntre(du, au);
    avP.forEach((a) => {
      const c = dossierParId(a.factureId) || {};
      const cl = clientDe(a.clientId) || {};
      ajout(parClient, a.clientId || "?", "ca", -a.ht);
      ajout(parCom, c.anterieure ? "—" : idCommercialDuDevis(devisDe(c)) || "—", "ca", -a.ht);
      ajout(parCat, cl.type || "Non renseigné", "ca", -a.ht);
      if (!c.anterieure && c.id) typeVenteDossier(c).forEach((t) => ajout(parType, t, "ca", -a.ht));
    });
    return {
      caFact: somme(factures) - avP.reduce((n, a) => n + (Number(a.ht) || 0), 0), avoirsHT: avP.reduce((n, a) => n + (Number(a.ht) || 0), 0), nbAvoirs: avP.length, pc: somme(bdc), nbFact: factures.length, nbBdc: bdc.length,
      parClient, parCom, parCat, parType,
      fam: comptees.length, famTransfo: transfo.length, mtFam: comptees.reduce((n, f) => n + f.montant, 0), mtTransfo: transfo.reduce((n, f) => n + f.montant, 0), enCours, delaiMoyen: delais.length ? delais.reduce((a, b) => a + b, 0) / delais.length : null,
      tauxCom: tauxPar((f) => idCommercialDuDevis(f.racine) || "—"), tauxCat: tauxPar((f) => (clientDe(f.racine.clientId) || {}).type || "Non renseigné"),
      docs: {
        Devis: (devisListe || []).filter((d) => d.numero && dans(d.date || d.creeLe)).length,
        BDC: bdc.length,
        PL: dossiers.filter((c) => c.numeroPL && dans(c.datePL)).length,
        BL: dossiers.filter((c) => c.numeroBL && dans(c.dateBL)).length,
        Factures: factures.length,
        SAV: (savListe || []).filter((x) => dans(x.dateReclamation)).length,
        "Demandes d'échantillons": (demandesEch || []).filter((x) => dans(x.demandeLe)).length,
      },
      tranchesCouleur, tranchesMatiere, conso, chutesVendues,
    };
  }
  // Retards clients (i) : à aujourd'hui, d'après l'état de compte (exo et non exo).
  function retardsClients() {
    const out = [];
    (clients || []).forEach((cl) => {
      let echu = 0, retardMax = 0, du = 0;
      const delais = [];
      [false, true].forEach((exo) => {
        const et = etatCompteClient(cl.id, exo, todayISO(), false);
        du += et.totalDu || 0;
        (et.blocs || []).forEach((b) => (b.docs || []).forEach((d) => {
          if (d.retard > 0) { echu += d.reste; retardMax = Math.max(retardMax, d.retard); }
          if (d.reste <= 0.01 && (d.regs || []).length && !d.anterieure) { const der = [...d.regs].sort((a, b) => (a.date < b.date ? 1 : -1))[0]; const j = ecartJours(d.date, der.date); if (isFinite(j) && j >= 0) delais.push(j); }
        }));
      });
      if (echu > 0.01 || delais.length) out.push({ client: cl, du, echu, retardMax, delaiMoyen: delais.length ? delais.reduce((a, b) => a + b, 0) / delais.length : null });
    });
    return out.sort((a, b) => b.echu - a.echu);
  }
  // ---- Nils 04/10 (ac) : destinataires des alertes / tâches ----
  function destinatairesNotif(jeton) {
    const actifs = utilisateurs.filter((u) => u.actif);
    if (jeton.startsWith("p:")) return qui(jeton.slice(2));
    if (jeton === "@alertes") return actifs.filter((u) => u.droits.has("taches.voirTout")).map((u) => u.id);
    if (jeton === "@commercial") return actifs.filter((u) => u.droits.has("ventes.estCommercial")).map((u) => u.id);
    if (jeton === "@pilote") return [...new Set([...actifs.filter((u) => u.droits.has("ventes.estCommercial")).map((u) => u.id), ...qui(P_ADV_SR, P_ADV_JR)])];
    if (jeton === "@responsablesCompte") return [...new Set((comptesTreso || []).flatMap((c) => c.responsables || []))].filter((id) => actifs.some((u) => u.id === id));
    if (jeton === "@detenteur") return ((compteDe(PORTEFEUILLE_ID) || {}).responsables || []).filter((id) => actifs.some((u) => u.id === id));
    if (jeton === "@conducteurs") return [...new Set(((flotte && flotte.vehicules) || []).flatMap((v) => v.conducteurs || []))].filter((id) => actifs.some((u) => u.id === id && u.profil !== P_GERANT));
    if (jeton === "@chefs") return actifs.filter((u) => u.droits.has("staff.equipe") && !u.droits.has("staff.voirTout")).map((u) => u.id);
    return actifs.map((u) => u.id); // @choisis, @declarant, @document : selon le cas
  }
  // ---- Nils 04/10 (z) : tâches manuelles ----
  async function persistTachesManuelles(next) {
    setTachesManuelles(next);
    return await saveKey(TACHES_MANUELLES_KEY, next);
  }
  async function enregistrerTacheManuelle() {
    const f = tacheEdit;
    if (!f || !estGerant) return;
    if (!(f.titre || "").trim()) { setNotice("Indique le titre de la tâche."); return; }
    if (!(f.qui || []).length) { setNotice("Choisis au moins une personne."); return; }
    const x = { ...f, titre: f.titre.trim(), detail: (f.detail || "").trim(), modifiePar: user.nom, modifieLe: new Date().toISOString() };
    if (!x.id) { x.id = uid(); x.creePar = user.nom; x.creeLe = x.modifieLe; }
    const existe = (tachesManuelles || []).some((t) => t.id === x.id);
    await persistTachesManuelles(existe ? (tachesManuelles || []).map((t) => (t.id === x.id ? x : t)) : [...(tachesManuelles || []), x]);
    await tracerAcces(existe ? "tâche manuelle modifiée" : "tâche manuelle créée", `${x.titre} → ${(x.qui || []).map(nomUtilisateur).join(", ")}${x.echeance ? ` (pour le ${formatDate(x.echeance)})` : ""}`);
    setTacheEdit(null);
  }
  async function supprimerTacheManuelle(t) {
    if (!estGerant || !(await demander(`Supprimer la tâche « ${t.titre} » ?`))) return;
    await persistTachesManuelles((tachesManuelles || []).filter((x) => x.id !== t.id));
    setTacheEdit(null);
  }
  async function marquerTacheManuelleFaite(id, commentaire) {
    const t = (tachesManuelles || []).find((x) => x.id === id);
    if (!t || (!t.qui.includes(user.id) && !estGerant)) return;
    await persistTachesManuelles((tachesManuelles || []).map((x) => (x.id === id ? { ...x, faiteLe: new Date().toISOString(), faitePar: user.nom, commentaireFait: (commentaire || "").trim() } : x)));
    if (!estGerant) await alerter("Tâche faite", `${user.nom} : « ${t.titre} »${(commentaire || "").trim() ? ` — ${commentaire.trim()}` : ""}`, t.lien || { kind: "onglet", id: "alertes" });
    setTacheFaite(null);
  }
  // ---- Nils 04/10 (x) : échéances récurrentes ----
  async function persistRecurrentes(next) {
    setRecurrentes(next);
    return await saveKey(RECURRENTES_KEY, next);
  }
  // Occurrences d'une échéance entre deux dates (incluses) : { date, montant, realiseeLe, ajuste }.
  function occurrencesRecurrente(r, du, au) {
    if (!r || !r.debut) return [];
    const pas = (FREQUENCES_RECURRENTES.find((f) => f.cle === r.frequence) || FREQUENCES_RECURRENTES[0]).mois;
    const jour = Number(r.debut.slice(8, 10)) || 1;
    const out = [];
    for (let k = 0; k < 600; k++) {
      const d = ajouterMoisISO(r.debut, k * pas, jour);
      if (r.finType === "date" && r.finDate && d > r.finDate) break;
      if (r.finType === "nombre" && Number(r.nombre) > 0 && k >= Number(r.nombre)) break;
      if (au && d > au) break;
      if (du && d < du) continue;
      const o = (r.occurrences || {})[d] || {};
      out.push({ date: d, montant: o.montant !== undefined && o.montant !== "" ? Number(o.montant) : Number(r.montant) || 0, ajuste: o.montant !== undefined && o.montant !== "", realiseeLe: o.realiseeLe || "", realiseePar: o.realiseePar || "", opId: o.opId || "" });
    }
    return out;
  }
  // Ce qui reste dû (non réalisé) : à partir du 1er du mois de création — l'historique antérieur n'est pas « en retard ».
  function occurrencesDues(r, au) {
    if (!r || r.active === false) return [];
    const depuis = (r.le || "").slice(0, 7) ? `${(r.le || "").slice(0, 7)}-01` : r.debut;
    return occurrencesRecurrente(r, depuis < r.debut ? r.debut : depuis, au).filter((o) => !o.realiseeLe);
  }
  async function enregistrerRecurrente() {
    const f = recurrenteEdit;
    if (!f || !peut("compta.previsions")) return;
    const montant = parseMontantSaisi(f.montant);
    if (!(f.libelle || "").trim()) { setNotice("Indique le libellé."); return; }
    if (!f.debut) { setNotice("Indique la date de la 1re échéance."); return; }
    if (!isFinite(montant) || montant <= 0) { setNotice("Indique un montant valide."); return; }
    if (f.finType === "date" && (!f.finDate || f.finDate < f.debut)) { setNotice("Date de fin invalide."); return; }
    if (f.finType === "nombre" && !(Number(f.nombre) > 0)) { setNotice("Indique le nombre d'échéances."); return; }
    const x = { ...f, libelle: f.libelle.trim(), montant, modifiePar: user.nom, modifieLe: new Date().toISOString() };
    if (x.sens !== "sortie" || !x.fournisseur) { x.fournisseur = undefined; x.contrat = undefined; x.tauxTVA = undefined; }
    else { x.contrat = (x.contrat || "").trim(); x.tauxTVA = x.tauxTVA ?? 0.2; }
    if (!x.id) { x.id = uid(); x.par = user.nom; x.le = x.modifieLe; x.occurrences = {}; x.active = true; }
    const existe = (recurrentes || []).some((r) => r.id === x.id);
    await persistRecurrentes(existe ? (recurrentes || []).map((r) => (r.id === x.id ? x : r)) : [...(recurrentes || []), x]);
    await tracerAcces(existe ? "échéance récurrente modifiée" : "échéance récurrente ajoutée", `${x.libelle} — ${formatDH(montant)} ${x.frequence}`);
    setRecurrenteEdit(null);
  }
  async function majOccurrence(rId, date, patch) {
    if (!peut("compta.previsions")) return;
    await persistRecurrentes((recurrentes || []).map((r) => (r.id === rId ? { ...r, occurrences: { ...(r.occurrences || {}), [date]: { ...((r.occurrences || {})[date] || {}), ...patch } } } : r)));
  }
  // Nils 29/10 (a-d) : « Réalisée » relie l'échéance à une sortie de la CFG — une opération existante de même
  // montant à 10 jours près (prélèvement importé du relevé), sinon une nouvelle sortie pré-remplie.
  const JOURS_RAPPROCHEMENT_ECHEANCE = 10;
  function compteEcheances() {
    return compteDe("banque-cfg") || (comptesTreso || []).find((c) => c.type === "banque") || null;
  }
  function candidatsEcheance(r, o) {
    const cfg = compteEcheances();
    if (!cfg) return [];
    const relies = new Set((recurrentes || []).flatMap((x) => Object.values(x.occurrences || {}).map((y) => y && y.opId).filter(Boolean)));
    return (operations || [])
      .filter((op) => op.compteId === cfg.id && op.sens === r.sens && !op.miroirDe && op.type !== "transfert" && !relies.has(op.id) && Math.abs((Number(op.montant) || 0) - o.montant) <= 0.01 && Math.abs(ecartJours(op.date, o.date)) <= JOURS_RAPPROCHEMENT_ECHEANCE)
      .sort((a, b) => ((a.sousPoste === r.sousPoste) === (b.sousPoste === r.sousPoste) ? Math.abs(ecartJours(a.date, o.date)) - Math.abs(ecartJours(b.date, o.date)) : a.sousPoste === r.sousPoste ? -1 : 1));
  }
  // Nils 29/10 : facture fournisseur d'une échéance (leasing : tableau d'amortissement, pas de facture), créée une
  // seule fois — reprise si elle existe déjà (sortie annulée puis recommencée).
  async function factureEcheance(r, o) {
    if (!r.fournisseur || !nomsTiers("fournisseur").some((n) => normLib(n) === normLib(r.fournisseur))) return null;
    const deja = (facturesF || []).find((fa) => fa.depuisEcheance && fa.depuisEcheance.rId === r.id && fa.depuisEcheance.date === o.date);
    if (deja) return deja;
    const maintenant = new Date().toISOString();
    const fa = {
      id: uid(), tiersType: "fournisseur", fournisseur: r.fournisseur, type: "facture",
      numero: `${r.contrat || r.libelle} — échéance du ${formatDate(o.date)}`, date: o.date,
      lignes: [{ taux: Number(r.tauxTVA ?? 0.2), ttc: arrondiH(o.montant) }], note: `Créée depuis l'échéance récurrente « ${r.libelle} » (tableau d'amortissement)`,
      confirmeBL: true, controle: "contrôlée", depuisEcheance: { rId: r.id, date: o.date }, par: user.nom, parId: user.id, le: maintenant,
    };
    await persistFacturesF([...(facturesF || []), fa]);
    await tracerAcces("facture fournisseur saisie", `Facture ${fa.numero} — ${fa.fournisseur} — ${formatDate(fa.date)} — ${formatDH(o.montant)} (échéance récurrente)`);
    return fa;
  }
  async function ouvrirSortieEcheance(r, o) {
    const cfg = compteEcheances();
    if (!cfg || !peutSaisirCompte(cfg)) return false;
    const auj = todayISO();
    const fa = await factureEcheance(r, o);
    setOpEdit({ ...nouvelleOperation(cfg.id, r.sens), date: o.date <= auj ? o.date : auj, montant: String(o.montant), designation: `${r.libelle} — ${libMois(o.date.slice(0, 7))}`, poste: r.poste || "", sousPoste: r.sousPoste || "", ...(fa ? { tiersType: "fournisseur", tiers: fa.fournisseur, reglements: [{ factureId: fa.id, montant: String(arrondiH(o.montant)) }] } : {}), _recurrence: { rId: r.id, date: o.date } });
    return true;
  }
  async function cocherEcheance(r, o) {
    if (!peut("compta.previsions")) return;
    const cands = candidatsEcheance(r, o);
    const cfg = compteEcheances();
    if (cands.length || !cfg || !peutSaisirCompte(cfg)) { setRelierEcheance({ r, o, cands }); return; }
    ouvrirSortieEcheance(r, o);
  }
  async function marquerEcheance(r, o, opId) {
    // Échéance avec fournisseur : le prélèvement relié devient le paiement de sa facture (TVA).
    const op = opId ? (operations || []).find((x) => x.id === opId) : null;
    if (op && r.fournisseur && !(op.reglements || []).length && !op.factureFournisseur) {
      const fa = await factureEcheance(r, o);
      if (fa) {
        await persistOperations((operations || []).map((x) => (x.id === op.id ? { ...x, tiersType: "fournisseur", tiers: fa.fournisseur, reglements: [{ factureId: fa.id, montant: arrondiH(Number(op.montant) || 0) }], modifiePar: user.nom, modifieLe: new Date().toISOString() } : x)));
        await tracerAcces("opération de trésorerie modifiée", `${(compteDe(op.compteId) || {}).nom || "?"} — ${formatDH(Number(op.montant) || 0)} rattachée à la facture ${fa.numero}`);
      }
    }
    await majOccurrence(r.id, o.date, { realiseeLe: todayISO(), realiseePar: user.nom, opId: opId || "" });
    setRelierEcheance(null);
  }
  async function basculerRecurrente(r) {
    if (!peut("compta.previsions")) return;
    await persistRecurrentes((recurrentes || []).map((x) => (x.id === r.id ? { ...x, active: x.active === false } : x)));
    await tracerAcces(r.active === false ? "échéance récurrente réactivée" : "échéance récurrente arrêtée", r.libelle);
  }
  async function supprimerRecurrente(r) {
    if (!peut("compta.previsions") || !(await demander(`Supprimer l'échéance récurrente « ${r.libelle} » ?`))) return;
    await persistRecurrentes((recurrentes || []).filter((x) => x.id !== r.id));
    await tracerAcces("échéance récurrente supprimée", r.libelle);
  }
  // Nils 04/10 (g) : TVA due au mois m = TVA collectée − TVA déductible du mois précédent, d'après le fichier TVA (≥ 0).
  function tvaNetteMois(m) {
    const ops = opsPourTVA().filter((o) => (o.date || "").slice(0, 7) === m);
    const ded = ops.filter((o) => o.sens === "sortie" && (o.factureFournisseur || (o.reglements || []).length)).flatMap(lignesTVAAchat).reduce((n, l) => n + l.tva, 0);
    const col = ops.filter((o) => o.poste === POSTE_ENCAISSEMENT).flatMap(lignesTVAEncaissement).reduce((n, l) => n + l.tva, 0);
    return arrondiH(col - ded);
  }
  // Nils 04/10 (w) : dépense moyenne mensuelle d'une caisse sur les 6 derniers mois complets (vraies sorties seulement).
  function sortiesCaisseMois(compteId, m) {
    return (operations || []).filter((o) => o.compteId === compteId && o.sens === "sortie" && o.type === "normal" && !o.miroirDe && !o.extourneDe && (o.date || "").slice(0, 7) === m);
  }
  function depensesCaisse(compteId) {
    const m0 = todayISO().slice(0, 7);
    const mois = [];
    for (let m = moisAvant(m0), k = 0; k < 6; k++, m = moisAvant(m)) mois.push(m);
    const premiere = (operations || []).filter((o) => o.compteId === compteId).map((o) => (o.date || "").slice(0, 7)).filter(Boolean).sort()[0];
    const moisUtiles = premiere ? mois.filter((m) => m >= premiere) : [];
    const total = moisUtiles.reduce((n, m) => n + sortiesCaisseMois(compteId, m).reduce((x, o) => x + (Number(o.montant) || 0), 0), 0);
    const moyenne = moisUtiles.length ? arrondiH(total / moisUtiles.length) : 0;
    const enCours = arrondiH(sortiesCaisseMois(compteId, m0).reduce((x, o) => x + (Number(o.montant) || 0), 0));
    const parPoste = {};
    moisUtiles.forEach((m) => sortiesCaisseMois(compteId, m).forEach((o) => { const k = o.poste || "—"; parPoste[k] = parPoste[k] || { moy: 0, cours: 0 }; parPoste[k].moy += (Number(o.montant) || 0) / moisUtiles.length; }));
    sortiesCaisseMois(compteId, m0).forEach((o) => { const k = o.poste || "—"; parPoste[k] = parPoste[k] || { moy: 0, cours: 0 }; parPoste[k].cours += Number(o.montant) || 0; });
    return { moyenne, enCours, nbMois: moisUtiles.length, parPoste };
  }
  async function supprimerPrevision(id) {
    const x = (previsions || []).find((p) => p.id === id);
    if (!x || !(await demander(`Supprimer la prévision « ${x.libelle} » ?`))) return;
    await persistPrevisions((previsions || []).filter((p) => p.id !== id));
    await tracerAcces("prévision supprimée", `${x.libelle} — ${formatDH(x.montant)}`);
  }
  async function marquerPrevisionRealisee(id, v) {
    await persistPrevisions((previsions || []).map((p) => (p.id === id ? { ...p, realiseeLe: v ? todayISO() : "", realiseePar: v ? user.nom : "" } : p)));
  }
  async function persistAffectationsCredit(next) {
    setAffectationsCredit(next);
    return await saveKey(AFFECTATIONS_CREDIT_KEY, next);
  }
  // Étape f : le numéro d'un nouveau document est attribué par le serveur, sur toutes les données
  // (deux postes n'obtiennent jamais le même). null si le serveur ne répond pas : rien n'est créé.
  async function numeroDocument(serie, annee) {
    let r = window.storage && window.storage.numero ? await window.storage.numero(serie, annee) : null;
    // Étape h (Nils 17/10) : premier document de la série en production — le Gérant saisit le dernier
    // numéro émis avant l'ERP, au fur et à mesure ; les autres attendent qu'il l'ait fait.
    if (r && r.depart) {
      if (!estGerant) {
        setNotice(`Premier document ${serie} dans l'ERP : le Gérant doit d'abord saisir le dernier numéro ${serie} émis avant l'ERP. Il vient d'être prévenu ; réessaie ensuite. Rien n'a été créé.`);
        await alerter("Numéro de départ à saisir", `${user.nom} veut créer le premier document ${serie} : saisis le dernier numéro ${serie} émis avant l'ERP (Paramétrage › Numéros de départ).`, { kind: "onglet", id: "parametrage" });
        return null;
      }
      const ok = await saisirNumeroDepart(serie, annee);
      if (!ok) return null;
      r = await window.storage.numero(serie, annee);
    }
    if (!r || !r.numero) {
      setNotice(`Numéro ${serie} indisponible (serveur injoignable ou droit manquant) : rien n'a été créé. Réessaie dans un instant.`);
      return null;
    }
    return r.numero;
  }
  // Saisie du numéro de départ d'une série par le Gérant ; vrai si enregistré.
  async function saisirNumeroDepart(serie, annee) {
    const v = await demander(`Premier document ${serie} dans l'ERP.\n\nQuel est le dernier numéro ${serie} émis avant l'ERP ? (ex. ${serie}-${annee || new Date().getFullYear()}-0412, ou 412 ; 0 si aucun)\n\nIl ne pourra plus être changé.`, { saisie: true });
    if (v === null) return false;
    const chiffres = (String(v).match(/(\d+)\s*$/) || [])[1];
    if (chiffres === undefined) { setNotice("Numéro de départ illisible : indique le dernier numéro émis (ex. 412), ou 0."); return false; }
    const r = await window.storage.saisirDepart(serie, Number(chiffres), annee);
    if (r.erreur) { setNotice(r.erreur); return false; }
    return true;
  }
  async function persistRemplacements(next) {
    setRemplacements(next);
    return await saveKey(REMPLACEMENTS_KEY, next);
  }
  async function persistCoutsRevient(next) {
    setCoutsRevient(next);
    return await saveKey(COUTS_REVIENT_KEY, next);
  }
  async function persistDeplacements(next) {
    setDeplacements(next);
    return await saveKey(DEPLACEMENTS_KEY, next);
  }
  const flotteRef = useRef(null);
  flotteRef.current = flotte;
  async function persistFlotte(next) {
    flotteRef.current = next;
    setFlotte(next);
    return await saveKey(VEHICULES_KEY, next);
  }
  async function persistAvoirs(next) {
    setAvoirs(next);
    return await saveKey(AVOIRS_KEY, next);
  }
  async function persistExpositions(next) {
    setExpositions(next);
    return await saveKey(EXPOSITIONS_KEY, next);
  }
  async function persistCommissions(next) {
    setCommissions(next);
    return await saveKey(COMMISSIONS_KEY, next);
  }
  async function persistTransportIntl(next) {
    setTransportIntl(next);
    return await saveKey(TRANSPORT_INTL_KEY, next);
  }
  async function persistArrivagesImport(next) {
    setArrivagesImport(next);
    return await saveKey(ARRIVAGES_IMPORT_KEY, next);
  }
  async function persistArrivagesLocaux(next) {
    setArrivagesLocaux(next);
    return await saveKey(ARRIVAGES_LOCAUX_KEY, next);
  }
  async function persistSignatairesBL(next) {
    setSignatairesBL(next);
    return await saveKey(SIGNATAIRES_BL_KEY, next);
  }
  // Sawsan relie aussi les encaissements des caisses qu'elle consulte (Nils 01/10).
  function peutRelierEncaissement(c) {
    return !!c && (peutSaisirCompte(c) || (peut("compta.relierLecteur") && lecteursCompte(c).includes(user.id)));
  }
  // ---- État client (validé Nils 01/10) ----
  // Deux états séparés : non exo (factures) et exo (BLS) — jamais mélangés.
  // Documents émis regroupés par projet (chantier) puis « commandes particuliers » (pas un projet immo) ;
  // commandes en cours (BC → BL non facturé) dans un bloc à part, sans distinguer les projets.
  function peutVoirEtatClient(c) {
    return peut("clients.etat") || (!!user.commercial && !!c && !!c.commercialSC && c.commercialSC === user.nom);
  }
  // Encours d'un client (Nils 02/10) : reste dû sur factures / BLS + reste des commandes en cours, exo et non exo.
  function encoursClient(clientId) {
    const au = todayISO();
    return arrondiH([false, true].reduce((n, exo) => { const et = etatCompteClient(clientId, exo, au, false); return n + et.totalDu + et.enCoursReste; }, 0));
  }
  function aVentesExo(clientId) {
    return tousDossiers().some((c) => c.clientId === clientId && exoDossier(c));
  }
  function encaissementsNonRelies(client) {
    if (!client) return [];
    return (operations || []).filter((o) => !o.miroirDe && o.poste === POSTE_ENCAISSEMENT && !o.dossierId && !(o.repartition || []).length && normLib(o.tiers || "") === normLib(client.nom));
  }
  function reglementsDossier(id, au) {
    const out = [];
    (operations || []).filter((o) => !o.miroirDe && o.poste === POSTE_ENCAISSEMENT && (o.date || "") <= au).forEach((o) => {
      const parts = partsDossiers(o);
      parts.filter((x) => x.dossierId === id).forEach((x) => out.push({ date: o.date, mode: o.mode || "", piece: o.piece || "", montant: (o.sens === "entree" ? 1 : -1) * x.montant, total: Number(o.montant) || 0, partage: parts.length > 1, echeance: o.echeanceCheque || "", opId: o.id }));
    });
    (affectationsCredit || []).filter((a) => (a.date || "") <= au && (a.vers === id || a.de === id)).forEach((a) => {
      const idAutre = a.vers === id ? a.de : a.vers;
      const avAutre = String(idAutre || "").startsWith("av:") ? (avoirs || []).find((x) => `av:${x.id}` === idAutre) : null;
      const autre = avAutre ? { numero: avAutre.numero } : dossierParId(idAutre) || {};
      out.push({ date: a.date, mode: a.vers === id ? (avAutre ? "Avoir affecté" : "Crédit client affecté") : "Crédit transféré", piece: `${a.vers === id ? "depuis" : "vers"} ${autre.numeroFacture || autre.numeroBL || autre.numero || "?"}`, montant: (a.vers === id ? 1 : -1) * (Number(a.montant) || 0), total: Number(a.montant) || 0 });
    });
    avoirsAntDe(id).filter((x) => (x.date || "") <= au).forEach((x) => out.push({ date: x.date, mode: "Avoir antérieur à l'ERP", piece: x.numero, montant: Number(x.ttc) || 0 }));
    // Nils 29/10 : compte prorata d'un dossier de projet, déduit par le client.
    {
      const fav = factureAvanceDe(id);
      const c = fav || String(id).startsWith("ant:") || String(id).startsWith("rep:") ? null : (commandesListe || []).find((x) => x.id === id);
      const dp = fav || (c ? deductionsDossier(c) : null);
      const dt = fav ? fav.date : c ? String(c.dateFacture || "").slice(0, 10) || todayISO() : "";
      // Factures émises avant le 30/10 seulement (depuis, le prorata est déduit du HT, avant la TVA).
      if (prorataRegleParClient(dp) > 0 && dt <= au) out.push({ date: dt, mode: "Compte prorata (déduit par le client)", piece: `${String(dp.prorataPct).replace(".", ",")} % du HT net`, montant: prorataRegleParClient(dp) });
    }
    return out.sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0));
  }
  // Trop-perçus d'un client : dossiers où l'encaissé dépasse le montant TTC.
  function creditsClient(clientId) {
    const tp = tousDossiers().filter((c) => c.clientId === clientId).map((c) => ({ c, excedent: arrondiH(encaisseDossier(c.id) - totalDossierTTC(c)) })).filter((x) => x.excedent > 0.01);
    // Step 17 : chaque facture d'avoir est un crédit, consommé par les affectations « de: av:<id> ».
    const av = (avoirs || []).filter((a) => a.clientId === clientId).map((a) => ({ c: { id: `av:${a.id}`, numero: a.numero, numeroFacture: a.numero, clientId, avoir: a }, excedent: creditRestantAvoir(a) })).filter((x) => x.excedent > 0.01);
    return [...tp, ...av];
  }
  async function enregistrerAffectationCredit() {
    const a = affectCredit;
    if (!a || !peut("clients.affecterCredit")) return;
    const src = creditsClient(a.clientId).find((x) => x.c.id === a.de);
    const v = parseMontantSaisi(a.montant);
    const dst = dossierParId(a.vers);
    if (!src || !dst) { setNotice("Choisis le crédit et la facture à régler."); return; }
    if (src.c.avoir && !!src.c.avoir.exo !== !!exoDossier(dst)) { setNotice(`L'avoir ${src.c.numero} est ${src.c.avoir.exo ? "exo" : "non exo"} : il ne s'affecte qu'à ${src.c.avoir.exo ? "une vente exo" : "une facture non exo"}.`); return; }
    const resteDst = arrondiH(totalDossierTTC(dst) - encaisseDossier(dst.id));
    if (!isFinite(v) || v <= 0 || v > src.excedent + 0.01 || v > resteDst + 0.01) { setNotice(`Montant invalide (au plus ${formatDH(Math.min(src.excedent, resteDst))}).`); return; }
    await persistAffectationsCredit([...(affectationsCredit || []), { id: uid(), clientId: a.clientId, de: a.de, vers: a.vers, montant: v, date: todayISO(), par: user.nom, le: new Date().toISOString() }]);
    await tracerAcces("crédit client affecté", `${(clientDe(a.clientId) || {}).nom} — ${formatDH(v)} de ${src.c.numeroFacture || src.c.numero} vers ${dst.numeroFacture || dst.numeroBL || dst.numero}`);
    setAffectCredit(null);
    setNotice(`Crédit de ${formatDH(v)} affecté à ${dst.numeroFacture || dst.numeroBL || dst.numero}.`);
  }
  const LIB_ETAPE_ETAT = { BDC: "Commande confirmée", RDM: "Relevé de mesures", PL: "En production", BL: "Livré", Facture: "Facturé" };
  function etatCompteClient(clientId, exo, au, avecSoldes) {
    const cl = clientDe(clientId) || {};
    const jCond = joursCondition(cl.paiement);
    const nomProjet = (id) => ((chantiers || []).find((x) => x.id === id) || {}).nom || "Projet";
    const emis = (c) => c.anterieure || (exo ? ["BL", "Facture"].includes(c.statut) : c.statut === "Facture");
    const dateDoc = (c) => String((exo && !c.anterieure ? c.dateBL || c.dateFacture : c.dateFacture) || c.creeLe || "").slice(0, 10);
    const numDoc = (c) => (exo && !c.anterieure ? c.numeroBL || c.numero : c.numeroFacture || c.numero);
    const docs = [];
    const enCours = [];
    // Nils 02/11 : une gratuité archivée n'est jamais due par le client.
    tousDossiers().filter((c) => c.clientId === clientId && exoDossier(c) === exo && !dossierGratuite(c)).forEach((c) => {
      const regs = reglementsDossier(c.id, au);
      const regle = arrondiH(regs.reduce((n, r) => n + r.montant, 0) + (c.anterieure ? c.dejaRegle : 0));
      const ttc = arrondiH(totalDossierTTC(c));
      const projetId = chantierDuDossier(c);
      if (emis(c) && dateDoc(c) <= au) {
        const reste = arrondiH(ttc - regle);
        if (!avecSoldes && Math.abs(reste) <= 0.01) return;
        const d = dateDoc(c);
        const echeance = echeanceCondition(d, cl.paiement);
        const retard = reste > 0.01 && echeance < au ? Math.round(ecartJours(echeance, au)) : 0;
        docs.push({ c, projetId, date: d, numero: numDoc(c), bc: c.anterieure ? "" : c.numero, reference: c.reference || "", ttc, regle, reste, echeance, retard, regs, anterieure: !!c.anterieure, dejaRegle: c.anterieure ? c.dejaRegle : 0 });
      } else if (!c.anterieure && !dossierArchive(c) && String(c.creeLe || "").slice(0, 10) <= au) {
        const etape = c.statut === "BL" && dossierSavGratuit(c) ? "Remplacement gratuit (SAV) — sans facture" : emis(c) || (c.statut === "BL" && !exo) ? "Livré — en instance de facturation" : LIB_ETAPE_ETAT[c.statut] || c.statut;
        enCours.push({ c, date: String(c.creeLe || "").slice(0, 10), bc: c.numero, reference: c.reference || "", projet: projetId ? nomProjet(projetId) : "", etape, ttc, regle, reste: arrondiH(ttc - regle), regs });
      }
    });
    const parBloc = new Map();
    docs.sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0)).forEach((d) => {
      if (!parBloc.has(d.projetId)) parBloc.set(d.projetId, []);
      parBloc.get(d.projetId).push(d);
    });
    const somme = (l, k) => arrondiH(l.reduce((n, x) => n + x[k], 0));
    const blocs = [...parBloc.entries()]
      .map(([pid, l]) => ({ projetId: pid, titre: pid ? `Projet ${nomProjet(pid)}` : "Commandes particuliers", docs: l, ttc: somme(l, "ttc"), regle: somme(l, "regle"), reste: somme(l, "reste"), echu: arrondiH(l.filter((x) => x.retard > 0).reduce((n, x) => n + x.reste, 0)) }))
      .sort((a, b) => (!a.projetId ? 1 : !b.projetId ? -1 : a.titre.localeCompare(b.titre, "fr")));
    enCours.sort((a, b) => (a.date < b.date ? -1 : 1));
    return {
      client: cl, exo, au, avecSoldes, conditions: cl.paiement || "", jCond, blocs, enCours,
      totalDu: somme(docs, "reste"), totalEchu: arrondiH(blocs.reduce((n, b) => n + b.echu, 0)),
      enCoursTTC: somme(enCours, "ttc"), enCoursRegle: somme(enCours, "regle"), enCoursReste: somme(enCours, "reste"),
      nonRelies: encaissementsNonRelies(cl).filter((o) => (o.date || "") <= au),
    };
  }
  function imprimerEtatClient(clientId, exo, au, avecSoldes) {
    const et = etatCompteClient(clientId, exo, au, avecSoldes);
    const e = (x) => String(x ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;");
    const m = (x) => e(formatDH(x));
    const lib = exo ? "BLS" : "Facture";
    const tabDocs = (b) => `<table><tr><th>Date</th><th>${lib}</th><th>Réf. contremarque</th><th>BC</th><th class="n">Montant TTC</th><th class="n">Réglé</th><th class="n">Reste dû</th><th>Échéance</th><th class="n">Retard</th></tr>
${b.docs.map((d) => `<tr><td>${e(formatDate(d.date))}</td><td>${e(d.numero)}</td><td${d.reference ? "" : ' class="ko"'}>${e(d.reference || "à compléter")}</td><td>${e(d.bc)}</td><td class="n">${m(d.ttc)}</td><td class="n">${m(d.regle)}</td><td class="n"><strong>${m(d.reste)}</strong></td><td>${e(formatDate(d.echeance))}</td><td class="n${d.retard ? " ko" : ""}">${d.retard ? `${d.retard} j` : ""}</td></tr>`).join("")}
<tr class="tot"><td colspan="4">Solde — ${e(b.titre)}</td><td class="n">${m(b.ttc)}</td><td class="n">${m(b.regle)}</td><td class="n">${m(b.reste)}</td><td colspan="2">${b.echu ? `dont échu : ${m(b.echu)}` : ""}</td></tr></table>`;
    const tabRegs = (b) => {
      const l = b.docs.flatMap((d) => [...(d.dejaRegle ? [{ date: "", mode: "Réglé avant le " + formatDate(DATE_REPRISE_CAISSES), piece: "", montant: d.dejaRegle, numero: d.numero }] : []), ...d.regs.map((r) => ({ ...r, numero: d.numero }))].map((r) => ({ ...r, numero: d.reference ? `${r.numero} — ${d.reference}` : r.numero })));
      if (!l.length) return "";
      return `<div class="st">Règlements reçus</div><table><tr><th>Date</th><th>Mode</th><th>Réf. (chèque, virement…)</th><th>Sur</th><th class="n">Montant</th></tr>${l.map((r) => `<tr><td>${e(r.date ? formatDate(r.date) : "")}</td><td>${e(r.mode)}${r.echeance ? ` (échéance ${e(formatDate(r.echeance))})` : ""}</td><td>${e(r.piece)}</td><td>${e(r.numero)}${r.partage ? ` <span class="petit">(part d'un règlement de ${m(r.total)})</span>` : ""}</td><td class="n">${m(r.montant)}</td></tr>`).join("")}</table>`;
    };
    const tabEnCours = et.enCours.length ? `<h2>Commandes en cours${exo ? "" : " et en instance de facturation"}</h2>
<table><tr><th>BC</th><th>Date</th><th>Réf. contremarque</th><th>Projet</th><th>Étape</th><th class="n">Montant TTC</th><th class="n">Acomptes reçus</th><th class="n">Reste</th></tr>
${et.enCours.map((x) => `<tr><td>${e(x.bc)}</td><td>${e(formatDate(x.date))}</td><td${x.reference ? "" : ' class="ko"'}>${e(x.reference || "à compléter")}</td><td>${e(x.projet)}</td><td>${e(x.etape)}</td><td class="n">${m(x.ttc)}</td><td class="n">${m(x.regle)}</td><td class="n">${m(x.reste)}</td></tr>`).join("")}
<tr class="tot"><td colspan="5">Total des commandes en cours</td><td class="n">${m(et.enCoursTTC)}</td><td class="n">${m(et.enCoursRegle)}</td><td class="n">${m(et.enCoursReste)}</td></tr></table>` : "";
    const resume = `<table class="res">${et.blocs.map((b) => `<tr><td>${e(b.titre)}</td><td class="n">${m(b.reste)}</td></tr>`).join("")}
<tr class="tot"><td>Total dû${et.totalEchu ? ` (dont échu : ${m(et.totalEchu)})` : ""}</td><td class="n">${m(et.totalDu)}</td></tr>
${et.enCours.length ? `<tr><td>Commandes en cours — reste à régler (${et.enCours.length})</td><td class="n">${m(et.enCoursReste)}</td></tr>` : ""}</table>`;
    const entete = exo ? "" : `<div class="ent"><img src="${LOGO_SRC}" alt="Stone Concept" style="height:42px" /></div>`;
    const pied = exo ? "" : `<div class="pied">Stone Concept Sarl Patente 45193146 IF 06527382 ICE 000073605 0000 01 RC 54585<br/>Commune rurale de Soualem, douar Lakhlayf<br/>Hot Line : 06 61 26 49 31 · commandes : sales@stoneconcept.ma<br/><strong>RIB : 050 450 007 0107 797 362 001 60 / CODE SWIFT : CAFGMAMC / CFG BANK</strong></div>`;
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>État de compte — ${e(et.client.nom)}</title><style>
body{font-family:Arial,sans-serif;font-size:11.5px;margin:28px;color:#222}h1{font-size:17px;margin:0 0 4px}h2{font-size:13px;margin:20px 0 6px;border-bottom:1px solid #999;padding-bottom:3px}
.st{font-size:11px;font-weight:bold;margin:8px 0 2px;color:#555}table{width:100%;border-collapse:collapse;margin-top:4px}td,th{border:1px solid #bbb;padding:3px 6px;text-align:left;vertical-align:top}th{background:#f0ede9}
.n{text-align:right;white-space:nowrap}.tot td{font-weight:bold;background:#faf8f6}.ko{color:#A8502F}.petit{font-size:9.5px;color:#666}.res{width:60%}.ent{margin-bottom:16px}.pied{font-size:9px;color:#8C8282;text-align:center;margin-top:28px;line-height:1.5}
</style></head><body>
${entete}
<h1>État de compte client</h1>
<div><strong>${e(et.client.raisonSociale || et.client.nom)}</strong>${et.client.ice ? ` — ICE ${e(et.client.ice)}` : ""}</div>
<div>Arrêté au ${e(formatDate(au))} · conditions de paiement : ${e(et.conditions || "non renseignées (échéance = date du document)")}${avecSoldes ? " · documents soldés inclus" : ""}</div>
<h2>Résumé</h2>${resume}
${et.blocs.map((b) => `<h2>${e(b.titre)}</h2>${tabDocs(b)}${tabRegs(b)}`).join("")}
${!et.blocs.length ? `<p>Aucun ${exo ? "BLS" : "facture"} ${avecSoldes ? "" : "non soldé"} à cette date.</p>` : ""}
${tabEnCours}
<p class="petit" style="margin-top:24px">Sauf erreur ou omission. Édité le ${e(formatDate(todayISO()))}.</p>
${pied}
</body></html>`;
    tracerAcces("état client imprimé", `${et.client.nom} — ${exo ? "exo" : "non exo"} — au ${formatDate(au)} — dû ${formatDH(et.totalDu)}`);
    telechargerDocument(html, `etat-client-${normLib(et.client.nom).replace(/[^a-z0-9]+/g, "-")}-${exo ? "exo-" : ""}${au}`, "état client");
  }
  async function exporterEtatClient(clientId, exo, au, avecSoldes) {
    let XLSX;
    try { XLSX = await chargerSheetJS(); } catch (err) { setNotice(err.message); return; }
    const et = etatCompteClient(clientId, exo, au, avecSoldes);
    const d = (iso) => (iso ? new Date(`${iso}T00:00:00`) : "");
    const r = [[`État de compte client — ${et.client.raisonSociale || et.client.nom}${exo ? " (exo)" : ""}`], [`Arrêté au ${formatDate(au)} — conditions : ${et.conditions || "non renseignées"}`], []];
    r.push(["Résumé"]);
    et.blocs.forEach((b) => r.push([b.titre, "", "", "", "", b.reste]));
    r.push(["Total dû", "", "", "", "", et.totalDu, "dont échu", et.totalEchu]);
    if (et.enCours.length) r.push(["Commandes en cours — reste", "", "", "", "", et.enCoursReste]);
    et.blocs.forEach((b) => {
      r.push([], [b.titre], ["Date", exo ? "BLS" : "Facture", "Réf. contremarque", "BC", "Montant TTC", "Réglé", "Reste dû", "Échéance", "Retard"]);
      b.docs.forEach((x) => r.push([d(x.date), x.numero, x.reference || "à compléter", x.bc, x.ttc, x.regle, x.reste, d(x.echeance), x.retard ? `${x.retard} j` : ""]));
      r.push([`Solde — ${b.titre}`, "", "", "", b.ttc, b.regle, b.reste]);
      const regs = b.docs.flatMap((x) => [...(x.dejaRegle ? [["", `Réglé avant le ${formatDate(DATE_REPRISE_CAISSES)}`, "", x.numero, x.dejaRegle]] : []), ...x.regs.map((g) => [d(g.date), g.mode, g.piece, x.reference ? `${x.numero} — ${x.reference}` : x.numero, g.montant])]);
      if (regs.length) r.push(["Règlements reçus"], ["Date", "Mode", "Réf. paiement", "Sur", "Montant"], ...regs);
    });
    if (et.enCours.length) {
      r.push([], ["Commandes en cours"], ["BC", "Date", "Réf. contremarque", "Projet", "Étape", "Montant TTC", "Acomptes reçus", "Reste"]);
      et.enCours.forEach((x) => r.push([x.bc, d(x.date), x.reference || "à compléter", x.projet, x.etape, x.ttc, x.regle, x.reste]));
      r.push(["Total des commandes en cours", "", "", "", "", et.enCoursTTC, et.enCoursRegle, et.enCoursReste]);
    }
    const ws = XLSX.utils.aoa_to_sheet(r, { cellDates: true });
    Object.keys(ws).forEach((k) => { if (k[0] === "!") return; const c = ws[k]; if (c.t === "n") c.z = "#,##0.00"; if (c.t === "d") c.z = "dd/mm/yyyy"; });
    ws["!cols"] = [14, 18, 26, 16, 14, 14, 14, 14, 10].map((w) => ({ wch: w }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, exo ? "État exo" : "État");
    const ok = await proposerTelechargement(`etat-client-${normLib(et.client.nom).replace(/[^a-z0-9]+/g, "-")}-${exo ? "exo-" : ""}${au}.xlsx`, XLSX.write(wb, { bookType: "xlsx", type: "array" }));
    if (ok) await tracerAcces("état client exporté (Excel)", `${et.client.nom} — ${exo ? "exo" : "non exo"} — au ${formatDate(au)}`);
  }
  // ---- Factures clients antérieures à l'ERP (Nils 01/10 : Sawsan prépare un Excel) ----
  const peutGererFacturesAnt = peut("clients.facturesAnterieures");
  function clientParNomOuIce(nom, ice) {
    const i = String(ice || "").replace(/\D/g, "");
    if (i) { const c = (clients || []).find((x) => String(x.ice || "").replace(/\D/g, "") === i); if (c) return c; }
    const n = normLib(nom);
    return (clients || []).find((x) => normLib(x.nom) === n || normLib(x.raisonSociale || "") === n) || null;
  }
  function chantierPourImport(clientId, nom, nouveaux) {
    const n = normLib(nom);
    if (!n) return "";
    const ex = [...(chantiers || []), ...nouveaux].find((x) => x.clientId === clientId && normLib(x.nom) === n);
    if (ex) return ex.id;
    const c = { id: uid(), nom: String(nom).trim(), clientId };
    nouveaux.push(c);
    return c.id;
  }
  function antReliee(id) {
    return (operations || []).some((o) => partsDossiers(o).some((x) => x.dossierId === `ant:${id}`));
  }
  async function telechargerModeleFacturesAnt() {
    let XLSX;
    try { XLSX = await chargerSheetJS(); } catch (err) { setNotice(err.message); return; }
    const ws = XLSX.utils.aoa_to_sheet([
      ["Client *", "ICE (facultatif)", "N° facture / BLS *", "Date *", "Réf. contremarque *", "Montant TTC *", "Exo (Oui / Non)", "Projet immobilier (facultatif)", `Déjà réglé avant le ${formatDate(DATE_REPRISE_CAISSES)}`, "Remarque", "Type (Facture / Avoir)", "Facture d'origine (pour un avoir)"],
      ["Exemple SARL", "", "FA-2025-0123", new Date("2025-11-15T00:00:00"), "Villa Dassouli", 48000, "Non", "Résidence Les Jardins", 20000, "Ligne d'exemple — ignorée à l'import", "Facture", ""],
    ], { cellDates: true });
    if (ws.D2) ws.D2.z = "dd/mm/yyyy";
    ws["!cols"] = [26, 18, 18, 12, 22, 14, 12, 26, 18, 30, 16, 24].map((w) => ({ wch: w }));
    const wsC = XLSX.utils.aoa_to_sheet([["Clients de l'ERP (nom à recopier tel quel)", "ICE"], ...(clients || []).filter((c) => !c.archive).map((c) => [c.nom, c.ice || ""]).sort((a, b) => a[0].localeCompare(b[0], "fr"))]);
    wsC["!cols"] = [{ wch: 36 }, { wch: 18 }];
    const wsI = XLSX.utils.aoa_to_sheet([
      ["Factures (et BLS exo) émises AVANT l'ERP — à remplir par l'Administration"],
      ["Une ligne par facture ou BLS non soldé (on peut aussi mettre les soldés pour l'historique). Pas de description."],
      ["Client : nom exact de l'ERP (onglet « Clients ERP ») ; l'ICE aide à le reconnaître. Un client absent doit d'abord être créé dans l'ERP."],
      ["Exo : « Oui » pour une vente exonérée (BLS) — elle n'apparaîtra que sur l'état exo du client."],
      ["Réf. contremarque : obligatoire (ex. Villa Dassouli) — elle figure sur chaque ligne de l'état client."],
      ["Projet immobilier : seulement pour un projet immo ; les factures d'un même projet sont regroupées sur l'état client. Vide = commande particulier."],
      [`Déjà réglé avant le ${formatDate(DATE_REPRISE_CAISSES)} : ce que le client avait payé avant la reprise des caisses dans l'ERP. Les paiements reçus depuis sont dans les caisses : on les relie à la facture dans Comptabilité.`],
      ["Avoir d'avant l'ERP : « Avoir » dans la colonne Type, son n° dans « N° facture / BLS », le montant en POSITIF dans « Montant TTC », et le n° de la facture qu'il corrige dans « Facture d'origine » (facture du même client, dans ce fichier ou déjà dans l'ERP). Exo, projet et référence sont repris de la facture."],
      ["La ligne « Exemple » est ignorée."],
    ]);
    wsI["!cols"] = [{ wch: 130 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsI, "À lire");
    XLSX.utils.book_append_sheet(wb, ws, "Factures");
    XLSX.utils.book_append_sheet(wb, wsC, "Clients ERP");
    await proposerTelechargement("Factures-clients-avant-ERP-a-remplir.xlsx", XLSX.write(wb, { bookType: "xlsx", type: "array" }));
  }
  async function importerFacturesAnt(fichier) {
    if (!fichier || !peutGererFacturesAnt) return;
    let XLSX;
    try { XLSX = await chargerSheetJS(); } catch (err) { setNotice(err.message); return; }
    let wb;
    try { wb = XLSX.read(await fichier.arrayBuffer(), { type: "array" }); } catch (err) { setNotice("Fichier illisible."); return; }
    const sn = wb.SheetNames.find((n) => normLib(n).startsWith("factures")) || wb.SheetNames[0];
    const rows = XLSX.utils.sheet_to_json(wb.Sheets[sn], { header: 1, raw: true, defval: "" });
    const H = (rows[0] || []).map((h) => normLib(String(h)).replace(/\*/g, "").trim());
    const col = (t) => H.findIndex(t);
    const C = { type: col((h) => h.startsWith("type")), origine: col((h) => h.includes("origine")), client: col((h) => h.startsWith("client")), ice: col((h) => h.startsWith("ice")), numero: col((h) => h.startsWith("n") && (h.includes("facture") || h.includes("bls"))), date: col((h) => h.startsWith("date")), ttc: col((h) => h.includes("ttc")), exo: col((h) => h.startsWith("exo")), projet: col((h) => h.startsWith("projet")), ref: col((h) => h.startsWith("ref")), regle: col((h) => h.includes("regle")), rem: col((h) => h.startsWith("remarque")) };
    if (C.client < 0 || C.numero < 0 || C.date < 0 || C.ttc < 0) { setNotice("Colonnes « Client », « N° facture / BLS », « Date » et « Montant TTC » introuvables (utilise le modèle)."); return; }
    const txt = (v) => (v === null || v === undefined ? "" : String(v).trim());
    const num = (v) => { if (v === "" || v === null || v === undefined) return 0; const n = Number(String(v).replace(/\s/g, "").replace(",", ".")); return isFinite(n) ? n : NaN; };
    const date = (v) => {
      if (typeof v === "number") { const p = XLSX.SSF.parse_date_code(v); return p ? `${p.y}-${String(p.m).padStart(2, "0")}-${String(p.d).padStart(2, "0")}` : ""; }
      const m = txt(v).match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{2,4})$/);
      if (m) return `${m[3].length === 2 ? `20${m[3]}` : m[3]}-${m[2].padStart(2, "0")}-${m[1].padStart(2, "0")}`;
      return /^\d{4}-\d{2}-\d{2}/.test(txt(v)) ? txt(v).slice(0, 10) : "";
    };
    const erreurs = [];
    const nouveauxChantiers = [];
    let liste = [...(facturesAnt || [])];
    let crees = 0, maj = 0;
    const estAvoirLigne = (r) => C.type >= 0 && normLib(txt(r[C.type])).startsWith("avoir");
    // Factures d'abord, puis les avoirs (leur facture d'origine peut être dans le même fichier).
    const lignesF = rows.slice(1).map((r, i) => [r, i]);
    [...lignesF.filter(([r]) => !estAvoirLigne(r)), ...lignesF.filter(([r]) => estAvoirLigne(r))].forEach(([r, i]) => {
      const nomC = txt(r[C.client]);
      const numero = txt(r[C.numero]);
      if (!nomC && !numero) return;
      if (normLib(nomC).startsWith("exemple")) return;
      if (estAvoirLigne(r)) {
        const ouA = `ligne ${i + 2} (avoir ${nomC} ${numero})`;
        const clA = clientParNomOuIce(nomC, C.ice >= 0 ? r[C.ice] : "");
        if (!clA) { erreurs.push(`${ouA} : client inconnu dans l'ERP`); return; }
        const dA = date(r[C.date]), ttcA = num(r[C.ttc]), orig = C.origine >= 0 ? txt(r[C.origine]) : "";
        if (!numero) { erreurs.push(`${ouA} : n° manquant`); return; }
        if (!dA) { erreurs.push(`${ouA} : date illisible`); return; }
        if (isNaN(ttcA) || ttcA <= 0) { erreurs.push(`${ouA} : montant invalide (en positif)`); return; }
        const fa = liste.find((x) => x.type !== "avoir" && x.clientId === clA.id && normLib(x.numero) === normLib(orig));
        if (!fa) { erreurs.push(`${ouA} : facture d'origine « ${orig} » introuvable pour ce client`); return; }
        const exA = liste.find((x) => x.clientId === clA.id && normLib(x.numero) === normLib(numero));
        if (exA && exA.type !== "avoir") { erreurs.push(`${ouA} : ce n° est déjà une facture de ce client`); return; }
        const autres = liste.filter((x) => x.type === "avoir" && x.factureAntId === fa.id && (!exA || x.id !== exA.id)).reduce((n, x) => n + (Number(x.ttc) || 0), 0);
        if (autres + ttcA > Number(fa.ttc) + 0.01) { erreurs.push(`${ouA} : les avoirs dépasseraient la facture ${fa.numero} (${formatDH(Number(fa.ttc))})`); return; }
        const ficheA = { type: "avoir", factureAntId: fa.id, clientId: clA.id, numero, date: dA, reference: txt(C.ref >= 0 ? r[C.ref] : "") || fa.reference || "", ttc: ttcA, exo: !!fa.exo, chantierId: fa.chantierId || "", dejaRegle: 0, remarque: C.rem >= 0 ? txt(r[C.rem]) : "" };
        if (exA) { liste = liste.map((x) => (x.id === exA.id ? { ...x, ...ficheA, modifiePar: user.nom, modifieLe: new Date().toISOString() } : x)); maj += 1; }
        else { liste.push({ id: uid(), ...ficheA, par: `${user.nom} (import Excel)`, le: new Date().toISOString() }); crees += 1; }
        return;
      }
      const ou = `ligne ${i + 2} (${nomC} ${numero})`;
      const cl = clientParNomOuIce(nomC, C.ice >= 0 ? r[C.ice] : "");
      if (!cl) { erreurs.push(`${ou} : client inconnu dans l'ERP`); return; }
      const d = date(r[C.date]);
      const ttc = num(r[C.ttc]);
      const regle = C.regle >= 0 ? num(r[C.regle]) : 0;
      if (!numero) { erreurs.push(`${ou} : n° manquant`); return; }
      const reference = C.ref >= 0 ? txt(r[C.ref]) : "";
      if (!reference) { erreurs.push(`${ou} : réf. contremarque manquante`); return; }
      if (!d) { erreurs.push(`${ou} : date illisible`); return; }
      if (isNaN(ttc) || ttc <= 0) { erreurs.push(`${ou} : montant TTC invalide`); return; }
      if (isNaN(regle) || regle < 0 || regle > ttc + 0.01) { erreurs.push(`${ou} : « déjà réglé » invalide`); return; }
      const exo = C.exo >= 0 && /^(o|oui|y|yes|x|1)$/i.test(normLib(txt(r[C.exo])));
      const chantierId = C.projet >= 0 ? chantierPourImport(cl.id, txt(r[C.projet]), nouveauxChantiers) : "";
      const fiche = { clientId: cl.id, numero, date: d, reference, ttc, exo, chantierId, dejaRegle: regle, remarque: C.rem >= 0 ? txt(r[C.rem]) : "" };
      const ex = liste.find((x) => x.clientId === cl.id && normLib(x.numero) === normLib(numero));
      if (ex && ex.type === "avoir") { erreurs.push(`${ou} : ce n° est déjà un avoir de ce client`); return; }
      const avoirsEx = ex ? liste.filter((x) => x.type === "avoir" && x.factureAntId === ex.id).reduce((n, x) => n + (Number(x.ttc) || 0), 0) : 0;
      if (ex && avoirsEx > ttc + 0.01) { erreurs.push(`${ou} : montant inférieur à ses avoirs (${formatDH(avoirsEx)})`); return; }
      if (ex) {
        if (antReliee(ex.id) && (Number(ex.ttc) !== ttc || !!ex.exo !== exo)) { erreurs.push(`${ou} : déjà importée et reliée à des encaissements — montant / exo non modifiés`); return; }
        liste = liste.map((x) => (x.id === ex.id ? { ...x, ...fiche, modifiePar: user.nom, modifieLe: new Date().toISOString() } : x));
        maj += 1;
      } else {
        liste.push({ id: uid(), ...fiche, par: `${user.nom} (import Excel)`, le: new Date().toISOString() });
        crees += 1;
      }
    });
    if (!crees && !maj) { setNotice(`Aucune facture importée.${erreurs.length ? ` ${erreurs.slice(0, 5).join(" ; ")}${erreurs.length > 5 ? "…" : ""}` : ""}`); return; }
    if (!await demander(`Factures antérieures : ${crees} à créer, ${maj} à mettre à jour${nouveauxChantiers.length ? `, ${nouveauxChantiers.length} projet(s) créé(s)` : ""}${erreurs.length ? `, ${erreurs.length} ligne(s) refusée(s) :\n${erreurs.slice(0, 8).join("\n")}${erreurs.length > 8 ? "\n…" : ""}` : ""}\n\nContinuer ?`)) return;
    if (nouveauxChantiers.length) await persistChantiers([...(chantiers || []), ...nouveauxChantiers]);
    await persistFacturesAnt(liste);
    await tracerAcces("factures clients antérieures importées", `${fichier.name} — ${crees} créée(s), ${maj} mise(s) à jour${erreurs.length ? ` ; refusées : ${erreurs.join(" ; ")}` : ""}`);
    setNotice(`Factures antérieures : ${crees} créée(s), ${maj} mise(s) à jour${erreurs.length ? `, ${erreurs.length} refusée(s) (voir le journal)` : ""}.`);
  }
  async function enregistrerFactureAnt() {
    const f = antSaisie;
    if (!f || !peutGererFacturesAnt) return;
    if (f.type === "avoir") { await enregistrerAvoirAnt(f); return; }
    const ttc = Number(String(f.ttc).replace(/\s/g, "").replace(",", "."));
    const regle = Number(String(f.dejaRegle || 0).replace(/\s/g, "").replace(",", "."));
    if (!f.clientId) { setNotice("Choisis le client."); return; }
    if (!(f.numero || "").trim()) { setNotice("Indique le n° de facture / BLS."); return; }
    if (!f.date) { setNotice("Indique la date."); return; }
    if (!(f.reference || "").trim()) { setNotice("Indique la référence de la contremarque."); return; }
    if (!isFinite(ttc) || ttc <= 0) { setNotice("Indique le montant TTC."); return; }
    if (!isFinite(regle) || regle < 0 || regle > ttc + 0.01) { setNotice("« Déjà réglé » doit être entre 0 et le TTC."); return; }
    if ((facturesAnt || []).some((x) => x.id !== f.id && x.clientId === f.clientId && normLib(x.numero) === normLib(f.numero))) { setNotice("Ce n° existe déjà pour ce client."); return; }
    const totAvoirs = f.id ? avoirsAntDe(`ant:${f.id}`).reduce((n, x) => n + (Number(x.ttc) || 0), 0) : 0;
    if (totAvoirs > ttc + 0.01) { setNotice(`Cette facture porte ${formatDH(totAvoirs)} d'avoirs antérieurs : le montant ne peut pas être inférieur.`); return; }
    if (f.id && antReliee(f.id)) {
      const old = (facturesAnt || []).find((x) => x.id === f.id) || {};
      if (old.clientId !== f.clientId || Math.abs((Number(old.ttc) || 0) - ttc) > 0.001 || !!old.exo !== !!f.exo) { setNotice("Facture reliée à des encaissements : client, montant et exo ne sont plus modifiables."); return; }
    }
    let chantierId = f.chantierId || "";
    if (f.id && chantierId !== (((facturesAnt || []).find((x) => x.id === f.id) || {}).chantierId || "") && logementsAvantERPDe(f.id).length) { setNotice("Cette facture est rattachée à des logements (fait avant l'ERP ou acompte) : son projet ne peut plus changer (retire d'abord le rattachement dans le suivi de chantier)."); return; }
    const nouveaux = [];
    if (chantierId === "__nouveau") chantierId = chantierPourImport(f.clientId, f.nouveauProjet || "", nouveaux);
    if (nouveaux.length) await persistChantiers([...(chantiers || []), ...nouveaux]);
    const retenueHT = chantierId && String(f.retenueHT ?? "").trim() ? parseMontantSaisi(f.retenueHT) : 0;
    if (!isFinite(retenueHT) || retenueHT < 0) { setNotice("Retenue de garantie invalide."); return; }
    const fiche = { clientId: f.clientId, numero: f.numero.trim(), date: f.date, reference: f.reference.trim(), ttc, exo: !!f.exo, chantierId, dejaRegle: regle, remarque: (f.remarque || "").trim(), retenueHT: retenueHT ? arrondiH(retenueHT) : undefined };
    const nouvelId = f.id ? null : uid();
    const next = f.id ? (facturesAnt || []).map((x) => (x.id === f.id ? { ...x, ...fiche, modifiePar: user.nom, modifieLe: new Date().toISOString() } : x)) : [...(facturesAnt || []), { id: nouvelId, ...fiche, par: user.nom, le: new Date().toISOString() }];
    const ok = await persistFacturesAnt(next);
    await tracerAcces(f.id ? "facture antérieure modifiée" : "facture antérieure ajoutée", `${(clientDe(f.clientId) || {}).nom} — ${fiche.numero} — ${formatDH(ttc)}${fiche.exo ? " (exo)" : ""}`);
    // Nils 30/10 : ajoutée depuis un encaissement (CFG / caisse) — rattachée aussitôt à l'entrée en cours.
    if (f._pourOp && nouvelId && ok !== false && opEdit) {
      const dossierId = `ant:${nouvelId}`;
      const reste = arrondiH(ttc - regle);
      const parts = Array.isArray(opEdit.repartition) && opEdit.repartition.length ? opEdit.repartition : opEdit.dossierId ? [{ dossierId: opEdit.dossierId, montant: opEdit.montant }] : [];
      const cl = clientDe(f.clientId) || {};
      if (!parts.length) setOpEdit({ ...opEdit, tiersType: "client", tiers: opEdit.tiers || cl.nom || "", dossierId, _q: "", _ajout: false, designation: opEdit.designation || `Encaissement ${fiche.numero}`, ...(Number(opEdit.montant) > 0 ? {} : { montant: String(reste) }) });
      else setOpEdit({ ...opEdit, repartition: [...parts, { dossierId, montant: String(Math.max(0, arrondiH((Number(opEdit.montant) || 0) - parts.reduce((n, x) => n + (Number(String(x.montant).replace(",", ".")) || 0), 0)))) }], _q: "", _ajout: false });
    }
    setAntSaisie(null);
  }
  async function enregistrerAvoirAnt(f) {
    const ttc = Number(String(f.ttc).replace(/\s/g, "").replace(",", "."));
    const fa = (facturesAnt || []).find((x) => x.id === f.factureAntId && x.type !== "avoir");
    if (!f.clientId) { setNotice("Choisis le client."); return; }
    if (!fa || fa.clientId !== f.clientId) { setNotice("Choisis la facture d'origine (facture antérieure de ce client)."); return; }
    if (!(f.numero || "").trim()) { setNotice("Indique le n° de l'avoir."); return; }
    if (!f.date) { setNotice("Indique la date."); return; }
    if (!isFinite(ttc) || ttc <= 0) { setNotice("Indique le montant de l'avoir (en positif)."); return; }
    if ((facturesAnt || []).some((x) => x.id !== f.id && x.clientId === f.clientId && normLib(x.numero) === normLib(f.numero))) { setNotice("Ce n° existe déjà pour ce client."); return; }
    const autres = avoirsAntDe(`ant:${fa.id}`).filter((x) => x.id !== f.id).reduce((n, x) => n + (Number(x.ttc) || 0), 0);
    if (autres + ttc > Number(fa.ttc) + 0.01) { setNotice(`Les avoirs dépasseraient la facture ${fa.numero} (${formatDH(Number(fa.ttc))}).`); return; }
    const fiche = { type: "avoir", factureAntId: fa.id, clientId: fa.clientId, numero: f.numero.trim(), date: f.date, reference: (f.reference || "").trim() || fa.reference || "", ttc, exo: !!fa.exo, chantierId: fa.chantierId || "", dejaRegle: 0, remarque: (f.remarque || "").trim() };
    const next = f.id ? (facturesAnt || []).map((x) => (x.id === f.id ? { ...x, ...fiche, modifiePar: user.nom, modifieLe: new Date().toISOString() } : x)) : [...(facturesAnt || []), { id: uid(), ...fiche, par: user.nom, le: new Date().toISOString() }];
    await persistFacturesAnt(next);
    await tracerAcces(f.id ? "avoir antérieur modifié" : "avoir antérieur ajouté", `${(clientDe(f.clientId) || {}).nom} — ${fiche.numero} — ${formatDH(ttc)} sur ${fa.numero}${fiche.exo ? " (exo)" : ""}`);
    setAntSaisie(null);
  }
  async function supprimerFactureAnt(id) {
    if (avoirsAntDe(`ant:${id}`).length) { setNotice("Cette facture porte un avoir antérieur : supprime d'abord l'avoir."); return; }
    if (avoirsDeFacture(`ant:${id}`).length) { setNotice("Cette facture porte un avoir : elle ne peut plus être supprimée."); return; }
    if (!peutGererFacturesAnt) return;
    if (antReliee(id)) { setNotice("Des encaissements sont reliés à cette facture : délie-les d'abord (Comptabilité)."); return; }
    if (logementsAvantERPDe(id).length) { setNotice(`Cette facture est rattachée à ${logementsAvantERPDe(id).length} logement(s) (fait avant l'ERP ou acompte) : retire d'abord le rattachement (projet › Suivi de chantier).`); return; }
    const x = (facturesAnt || []).find((y) => y.id === id);
    await persistFacturesAnt((facturesAnt || []).filter((y) => y.id !== id));
    await tracerAcces("facture antérieure supprimée", x ? `${(clientDe(x.clientId) || {}).nom} — ${x.numero}` : id);
  }
  // ---- Nils 29/10 : projets immobiliers — avance, retenue de garantie, compte prorata (shared/projets.js) ----
  function projetDuDossier(c) {
    const id = c ? chantierDuDossier(c) : "";
    return id ? (chantiers || []).find((x) => x.id === id) || null : null;
  }
  // Avance HT du projet : factures d'avance antérieures à l'ERP (l'étape 2 y ajoutera celles de l'ERP).
  function avanceProjetHT(ch) {
    if (!ch) return 0;
    const ant = ((ch.marche && ch.marche.avancesAnterieures) || []).reduce((n, a) => n + (Number(a.ht) || 0), 0);
    const erp = (facturesAvance || []).filter((f) => f.chantierId === ch.id && f.nature !== "retenue").reduce((n, f) => n + (Number(f.ht) || 0), 0);
    return arrondiH(ant + erp);
  }
  // Déjà remboursé : avant l'ERP (saisi sur l'avance) + factures émises par l'ERP (déductions figées).
  function avanceRembourseeHT(ch, saufIds) {
    if (!ch) return 0;
    const ant = ((ch.marche && ch.marche.avancesAnterieures) || []).reduce((n, a) => n + (Number(a.rembourseHT) || 0), 0);
    const erp = (commandesListe || []).filter((c) => c.deductionsProjet && !(saufIds && saufIds.has(c.id)) && chantierDuDossier(c) === ch.id).reduce((n, c) => n + (Number(c.deductionsProjet.avance) || 0), 0);
    return arrondiH(ant + erp);
  }
  async function enregistrerAvanceAnterieure() {
    const f = avanceAntEdit;
    const ch = f && (chantiers || []).find((x) => x.id === f.chId);
    if (!ch || !estGerant) return;
    const ht = parseMontantSaisi(f.ht), remb = String(f.rembourseHT || "").trim() ? parseMontantSaisi(f.rembourseHT) : 0;
    if (!(f.numero || "").trim()) { setAvanceAntEdit({ ...f, erreur: "Indique le n° de la facture d'avance." }); return; }
    if (!f.date) { setAvanceAntEdit({ ...f, erreur: "Indique la date de la facture d'avance." }); return; }
    if (!isFinite(ht) || ht <= 0) { setAvanceAntEdit({ ...f, erreur: "Indique le montant HT de l'avance." }); return; }
    if (!isFinite(remb) || remb < 0 || remb > ht + 0.01) { setAvanceAntEdit({ ...f, erreur: "Le déjà remboursé doit être entre 0 et le HT de l'avance." }); return; }
    const a = { id: uid(), numero: f.numero.trim(), date: f.date, ht: arrondiH(ht), rembourseHT: arrondiH(remb), par: user.nom, le: new Date().toISOString() };
    const m = ch.marche || {};
    await persistChantiers((chantiers || []).map((x) => (x.id === ch.id ? { ...x, marche: { ...m, avancesAnterieures: [...(m.avancesAnterieures || []), a] } } : x)));
    await tracerAcces("facture d'avance antérieure à l'ERP", `${ch.nom} — ${a.numero} du ${formatDate(a.date)} — ${formatDH(a.ht)} HT, déjà remboursé ${formatDH(a.rembourseHT)} HT`);
    setAvanceAntEdit(null);
  }
  // ---- Nils 29/10 : facture d'avance émise par l'ERP (une par projet ; Nils et Sawsan, droit projets.factureAvance) ----
  const peutFactureAvance = estGerant || peut("projets.factureAvance");
  function projetAUneAvance(ch) {
    return !!ch && ((((ch.marche || {}).avancesAnterieures || []).length > 0) || (facturesAvance || []).some((f) => f.chantierId === ch.id && f.nature !== "retenue"));
  }
  function ouvrirFactureAvance(ch) {
    const cond = conditionsMarche(ch);
    const vs = versionsDevisProjet(ch);
    const v = vs[vs.length - 1];
    const marcheHT = v ? arrondiH(calculDevisProjet(v, ch).totalHT || 0) : 0;
    const pctA = cond ? cond.avancePct : 0;
    setAvanceEmission({ chId: ch.id, marcheHT: marcheHT ? String(marcheHT) : "", pct: String(pctA || ""), ht: marcheHT && pctA ? String(arrondiH((marcheHT * pctA) / 100)) : "", designation: `Avance de démarrage — ${String(pctA || "").replace(".", ",")} % du marché ${ch.nom}`, date: todayISO(), exo: devisDuProjet(ch.id).some((d) => d.exonereTVA), erreur: "" });
  }
  async function emettreFactureAvance() {
    const f = avanceEmission;
    const ch = f && (chantiers || []).find((x) => x.id === f.chId);
    if (!ch || !peutFactureAvance) return;
    const err = (m) => setAvanceEmission({ ...f, erreur: m });
    if (projetAUneAvance(ch)) return err("Ce projet a déjà sa facture d'avance (une seule par projet).");
    const ht = parseMontantSaisi(f.ht);
    if (!isFinite(ht) || ht <= 0) return err("Indique le montant HT de l'avance.");
    if (!(f.designation || "").trim()) return err("Indique la désignation.");
    const date = f.date || todayISO();
    const pfx = f.exo ? "FAS" : "FA";
    const annee = Number(date.slice(0, 4));
    const derniere = derniereDateFacture(annee, pfx);
    if (date > todayISO()) return err("La date de la facture ne peut pas être dans le futur.");
    if (date < decalerJours(todayISO(), -JOURS_ANTIDATE_FACTURE)) return err(`La facture ne peut pas être datée de plus de ${JOURS_ANTIDATE_FACTURE} jours en arrière.`);
    if (derniere && date < derniere) return err(`La dernière facture ${pfx} de ${annee} est datée du ${formatDate(derniere)} : une nouvelle facture ne peut pas être antérieure.`);
    const cond = conditionsMarche(ch) || { prorataPct: 0 };
    const mt = montantsFactureAvance({ ht, tauxTVA: f.exo ? 0 : TVA_TAUX, prorataPct: cond.prorataPct });
    if (!(await demander(`Émettre la facture d'avance du projet « ${ch.nom} » (${pfx}) datée du ${formatDate(date)} ?\n\nAvance HT ${formatDH(mt.htTravaux)}${mt.prorata ? ` — prorata ${formatDH(mt.prorata)} = HT net ${formatDH(mt.htNet)}` : ""} — TVA ${formatDH(mt.tva)} — TTC à payer ${formatDH(mt.ttc)}.\n\nC'est irréversible, comme une facture.`))) return;
    const numero = await numeroDocument(pfx, annee);
    if (!numero) return;
    const marcheHT = String(f.marcheHT || "").trim() ? parseMontantSaisi(f.marcheHT) : 0;
    const fa = { id: uid(), chantierId: ch.id, clientId: ch.clientId, numero, date, exo: !!f.exo, marcheHT: isFinite(marcheHT) ? arrondiH(marcheHT) : 0, pct: String(f.pct || "").trim(), ht: mt.htTravaux, htNet: mt.htNet, prorataAvantTVA: true, tva: mt.tva, ttc: mt.ttc, prorataPct: mt.prorataPct, prorata: mt.prorata, net: mt.net, designation: f.designation.trim(), par: user.nom, parId: user.id, le: new Date().toISOString() };
    const ok = await persistFacturesAvance([...(facturesAvance || []), fa]);
    if (ok === false) return;
    await tracerAcces("facture d'avance", `${numero} — ${ch.nom} — ${formatDH(fa.ht)} HT, net à payer ${formatDH(fa.net)}`);
    setAvanceEmission(null);
    setNotice(`Facture d'avance ${numero} émise (${formatDH(fa.ttc)} TTC, net à payer ${formatDH(fa.net)}).${rappelConditionsPaiement(ch.clientId) ? ` ${rappelConditionsPaiement(ch.clientId)}` : ""}`);
  }
  function imprimerFactureAvance(fa) {
    const ch = (chantiers || []).find((x) => x.id === fa.chantierId) || {};
    const retenue = fa.nature === "retenue";
    // Facture de retenue : une ligne par facture d'origine (retenue de garantie HT déduite à l'époque).
    const lignes = retenue
      ? (fa.sources || []).map((x, i) => ({ id: `r${i}`, type: "facture", designation: `Retenue de garantie — facture ${x.numero} du ${formatDate(x.date)}${x.reference ? ` (${x.reference})` : ""}`, prixPublic: x.ht, qte: 1, remise: 0, unite: "" }))
      : [{ id: "avance", type: "facture", designation: fa.designation, prixPublic: fa.ht, qte: 1, remise: 0, unite: "" }];
    const source = { clientId: fa.clientId, reference: retenue ? fa.designation : ch.nom || "", date: fa.date, chantierId: fa.chantierId, exonereTVA: !!fa.exo, remiseGlobale: 0, notes: [], lignes, conditionsPaiement: retenue && fa.echeanceLegale ? `au plus tard le ${formatDate(fa.echeanceLegale)} (${JOURS_LEGAUX_RETENUE} jours, loi 69-21)` : "" };
    const deductions = { htTravaux: fa.ht, avance: 0, retenue: 0, htNet: fa.htNet ?? fa.ht, tauxTVA: fa.exo ? 0 : TVA_TAUX, tva: fa.tva, ttc: fa.ttc, prorataPct: fa.prorataPct, prorata: fa.prorata, prorataAvantTVA: !!fa.prorataAvantTVA, net: fa.net, libelleHT: retenue ? "Retenues de garantie HT" : "Avance HT" };
    const html = construireHtmlDocument(source, { titre: retenue ? "FACTURE — RETENUE DE GARANTIE" : "FACTURE D'AVANCE", numeroAffiche: fa.numero, dateDocument: fa.date, deductions });
    telechargerDocument(html, nomFichierDocument(fa.numero, (clientDe(fa.clientId) || {}).nom, ch.nom || "", retenue ? "Retenue de garantie" : "Avance"), "facture");
  }
  async function majFactureAvance(fa, patch, lib) {
    await persistFacturesAvance((facturesAvance || []).map((x) => (x.id === fa.id ? { ...x, ...patch, modifiePar: user.nom, modifieLe: new Date().toISOString() } : x)));
    await tracerAcces("facture d'avance", `${fa.numero} — ${lib}`);
  }
  async function supprimerFactureAvance(fa) {
    if (!estGerant || fa.envoyeeClientLe || fa.transmiseComptableLe) return;
    if (!estDernierNumero("numeroFacture", fa.numero)) { setNotice(`${fa.numero} n'est pas la dernière facture de sa série : elle ne peut plus être supprimée (pas de trou de numérotation).`); return; }
    if (encaisseDossier(`avp:${fa.id}`) - (Number(fa.prorata) || 0) > 0.01) { setNotice("Cette facture d'avance a déjà des encaissements : retire-les d'abord."); return; }
    const lib = fa.nature === "retenue" ? "la facture de retenue de garantie" : "la facture d'avance";
    if (!(await demander(`Supprimer ${lib} ${fa.numero} ? Son numéro sera repris par la prochaine facture.${fa.nature === "retenue" ? " Ses retenues redeviennent à facturer." : ""}`, { danger: true }))) return;
    await persistFacturesAvance((facturesAvance || []).filter((x) => x.id !== fa.id));
    await tracerAcces(fa.nature === "retenue" ? "facture de retenue supprimée" : "facture d'avance supprimée", fa.numero);
  }
  // ---- Nils 29/10 : étape 3 — facture de retenue de garantie (au cas par cas, en bloc ; suivi des 60 jours) ----
  const JOURS_LEGAUX_RETENUE = 60, JOURS_ALERTE_RETENUE = 10;
  // Retenues d'un projet : factures de l'ERP (déductions figées) et factures antérieures à l'ERP.
  function retenuesProjet(ch) {
    if (!ch) return [];
    const erp = (commandesListe || []).filter((c) => c.deductionsProjet && Number(c.deductionsProjet.retenue) > 0 && chantierDuDossier(c) === ch.id).map((c) => ({ cle: c.id, numero: c.numeroFacture, date: String(c.dateFacture || "").slice(0, 10), reference: c.reference || "", ht: arrondiH(Number(c.deductionsProjet.retenue) || 0) }));
    const ant = (facturesAnt || []).filter((x) => x.type !== "avoir" && x.chantierId === ch.id && Number(x.retenueHT) > 0).map((x) => ({ cle: `ant:${x.id}`, numero: x.numero, date: x.date, reference: x.reference || "", ht: arrondiH(Number(x.retenueHT) || 0), anterieure: true }));
    return [...ant, ...erp].sort((a, b) => String(a.date).localeCompare(String(b.date)));
  }
  function retenuesAFacturer(ch) {
    const deja = new Set((facturesAvance || []).filter((f) => f.nature === "retenue" && f.chantierId === (ch || {}).id).flatMap((f) => (f.sources || []).map((x) => x.cle)));
    return retenuesProjet(ch).filter((x) => !deja.has(x.cle));
  }
  const [retenueEmission, setRetenueEmission] = useState(null);
  function ouvrirFactureRetenue(ch) {
    const l = retenuesAFacturer(ch);
    setRetenueEmission({ chId: ch.id, cles: l.map((x) => x.cle), designation: `Retenue de garantie — ${ch.nom}`, date: todayISO(), exo: devisDuProjet(ch.id).some((d) => d.exonereTVA), erreur: "" });
  }
  async function emettreFactureRetenue() {
    const f = retenueEmission;
    const ch = f && (chantiers || []).find((x) => x.id === f.chId);
    if (!ch || !peutFactureAvance) return;
    const err = (m) => setRetenueEmission({ ...f, erreur: m });
    const sources = retenuesAFacturer(ch).filter((x) => f.cles.includes(x.cle));
    if (!sources.length) return err("Coche au moins une retenue à facturer.");
    if (!(f.designation || "").trim()) return err("Indique la désignation.");
    const date = f.date || todayISO();
    const pfx = f.exo ? "FAS" : "FA";
    const annee = Number(date.slice(0, 4));
    const derniere = derniereDateFacture(annee, pfx);
    if (date > todayISO()) return err("La date de la facture ne peut pas être dans le futur.");
    if (date < decalerJours(todayISO(), -JOURS_ANTIDATE_FACTURE)) return err(`La facture ne peut pas être datée de plus de ${JOURS_ANTIDATE_FACTURE} jours en arrière.`);
    if (derniere && date < derniere) return err(`La dernière facture ${pfx} de ${annee} est datée du ${formatDate(derniere)} : une nouvelle facture ne peut pas être antérieure.`);
    const cond = conditionsMarche(ch) || { prorataPct: 0 };
    const ht = arrondiH(sources.reduce((n, x) => n + x.ht, 0));
    const mt = montantsFactureAvance({ ht, tauxTVA: f.exo ? 0 : TVA_TAUX, prorataPct: cond.prorataPct });
    const echeance = decalerJours(date, JOURS_LEGAUX_RETENUE);
    if (!(await demander(`Facturer ${sources.length} retenue(s) de garantie du projet « ${ch.nom} » (${pfx}) datée du ${formatDate(date)} ?\n\nHT ${formatDH(mt.htTravaux)}${mt.prorata ? ` — prorata ${formatDH(mt.prorata)} = HT net ${formatDH(mt.htNet)}` : ""} — TVA ${formatDH(mt.tva)} — TTC à payer ${formatDH(mt.ttc)}.\n\nDélai légal de paiement (loi 69-21) : ${JOURS_LEGAUX_RETENUE} jours, soit le ${formatDate(echeance)}. C'est irréversible, comme une facture.`))) return;
    const numero = await numeroDocument(pfx, annee);
    if (!numero) return;
    const fa = { id: uid(), nature: "retenue", chantierId: ch.id, clientId: ch.clientId, numero, date, exo: !!f.exo, ht: mt.htTravaux, htNet: mt.htNet, prorataAvantTVA: true, tva: mt.tva, ttc: mt.ttc, prorataPct: mt.prorataPct, prorata: mt.prorata, net: mt.net, designation: f.designation.trim(), sources: sources.map(({ cle, numero: n, date: d, reference, ht: h }) => ({ cle, numero: n, date: d, reference, ht: h })), echeanceLegale: echeance, par: user.nom, parId: user.id, le: new Date().toISOString() };
    const ok = await persistFacturesAvance([...(facturesAvance || []), fa]);
    if (ok === false) return;
    await tracerAcces("facture de retenue de garantie", `${numero} — ${ch.nom} — ${sources.length} retenue(s), ${formatDH(fa.ht)} HT, net à payer ${formatDH(fa.net)}, échéance légale ${formatDate(echeance)}`);
    setRetenueEmission(null);
    setNotice(`Facture de retenue ${numero} émise (net à payer ${formatDH(fa.net)}, échéance légale le ${formatDate(echeance)}).`);
  }
  async function supprimerAvanceAnterieure(ch, a) {
    if (!estGerant || !(await demander(`Retirer la facture d'avance ${a.numero} (${formatDH(a.ht)} HT) du projet « ${ch.nom} » ?`))) return;
    const m = ch.marche || {};
    await persistChantiers((chantiers || []).map((x) => (x.id === ch.id ? { ...x, marche: { ...m, avancesAnterieures: (m.avancesAnterieures || []).filter((y) => y.id !== a.id) } } : x)));
    await tracerAcces("facture d'avance antérieure retirée", `${ch.nom} — ${a.numero}`);
  }
  // Nils 29/10 : estimation sur un devis / BC de projet (même calcul que la facture, avec le solde d'avance du jour).
  function deductionsDevis(src, chantierId) {
    const id = chantierId || (src && src.chantierId) || "";
    const ch = id ? (chantiers || []).find((x) => x.id === id) : null;
    const cond = conditionsMarche(ch);
    if (!src || !cond) return null;
    const t = calcTotaux(src);
    return deductionsFacture({ htTravaux: t.totalHT, tauxTVA: src.exonereTVA ? 0 : TVA_TAUX, conditions: cond, soldeAvance: avanceProjetHT(ch) - avanceRembourseeHT(ch) });
  }
  // Déductions de la facture d'un dossier de projet : figées à la facturation, sinon calculées (aperçu).
  // solde : HT d'avance restant (facture groupée : décompté dossier après dossier).
  function deductionsDossier(c, solde) {
    if (!c || c.anterieure) return null;
    if (c.deductionsProjet) return c.deductionsProjet;
    const ch = projetDuDossier(c);
    const cond = conditionsMarche(ch);
    if (!cond) return null;
    const d = devisDuDossier(c);
    if (!d) return null;
    const t = calcTotaux({ ...d, lignes: lignesDuDossier(c) });
    const soldeAvance = solde !== undefined ? solde : avanceProjetHT(ch) - avanceRembourseeHT(ch);
    return deductionsFacture({ htTravaux: t.totalHT, tauxTVA: d.exonereTVA ? 0 : TVA_TAUX, conditions: cond, soldeAvance, solder: !!c.solderAvance });
  }
  function totalDossierTTC(c) {
    if (c.anterieure) return c.ttcAnt;
    const dp = deductionsDossier(c);
    if (dp) return dp.ttc;
    const d = (devisListe || []).find((x) => x.id === c.devisId) || {};
    return calcTotaux({ ...d, lignes: lignesDuDossier(c) }).totalTTC || 0;
  }
  // Un encaissement peut couvrir plusieurs factures (un chèque pour N factures) : `repartition`.
  function partsDossiers(o) {
    if (Array.isArray(o.repartition) && o.repartition.length) return o.repartition.map((x) => ({ dossierId: x.dossierId, montant: Number(x.montant) || 0 }));
    return o.dossierId ? [{ dossierId: o.dossierId, montant: Number(o.montant) || 0 }] : [];
  }
  function netAffectationsCredit(dossierId) {
    return (affectationsCredit || []).reduce((n, a) => n + (a.vers === dossierId ? Number(a.montant) || 0 : 0) - (a.de === dossierId ? Number(a.montant) || 0 : 0), 0);
  }
  function encaisseDossier(dossierId) {
    // Nils 29/10 : le compte prorata, déduit par le client, compte comme réglé.
    const fav = factureAvanceDe(dossierId);
    const dp = fav ? fav : String(dossierId).startsWith("ant:") || String(dossierId).startsWith("rep:") ? null : deductionsDossier((commandesListe || []).find((x) => x.id === dossierId));
    return prorataRegleParClient(dp) + netAffectationsCredit(dossierId) + (String(dossierId).startsWith("ant:") ? ((dossierParId(dossierId) || {}).dejaRegle || 0) + avoirsAntDe(dossierId).reduce((n, x) => n + (Number(x.ttc) || 0), 0) : 0) + (operations || []).filter((o) => o.poste === POSTE_ENCAISSEMENT).reduce((n, o) => n + (o.sens === "entree" ? 1 : -1) * partsDossiers(o).filter((x) => x.dossierId === dossierId).reduce((m, x) => m + x.montant, 0), 0);
  }
  function libDossierTreso(c) {
    if (!c) return "—";
    const exo = exoDossier(c);
    const doc = c.numeroFacture || c.numeroBL || c.numero;
    const cl = clientDe(c.clientId);
    return `${doc}${cl ? ` — ${cl.nom}` : ""}${exo ? " (exo)" : ""}${c.retenueProjet ? " (facture de retenue de garantie)" : c.avanceProjet ? " (facture d'avance)" : c.remplacement ? " (facture de remplacement)" : c.anterieure ? " (antérieure à l'ERP)" : ""}`;
  }
  function nouvelleOperation(compteId, sens) {
    if (compteId === PORTEFEUILLE_ID) return { compteId, date: todayISO(), sens: "entree", montant: "", tiersType: "client", tiers: "", designation: "", poste: POSTE_ENCAISSEMENT, sousPoste: "Encaissements clients", mode: "Chèque", piece: "", dossierId: "", detenteur: user.id };
    return { compteId, date: todayISO(), sens: sens || "sortie", montant: "", tiersType: "", tiers: "", designation: "", poste: "", sousPoste: "", mode: compteDe(compteId) && compteDe(compteId).type === "banque" ? "Virement" : estCompteDevises(compteDe(compteId)) ? "Carte" : "Espèces", piece: "", dossierId: "" };
  }
  async function enregistrerOperation() {
    if (!opEdit) return;
    const { _q, _passerA, _depotLe, _recurrence, ...f } = opEdit;
    const compte = compteDe(f.compteId);
    if (!peutSaisirCompte(compte)) {
      // Relier seulement (Sawsan sur les caisses qu'elle consulte) : rien d'autre ne doit changer.
      const av = f.id ? (operations || []).find((o) => o.id === f.id) : null;
      if (!av || av.poste !== POSTE_ENCAISSEMENT || !peutRelierEncaissement(compte)) return;
      const libres = new Set(["dossierId", "repartition", "tiersType", "tiers", "designation", "_ajout"]);
      const diff = Object.keys({ ...av, ...f }).filter((k) => !libres.has(k) && JSON.stringify(av[k]) !== JSON.stringify(f[k]));
      if (diff.length) { setNotice("Sur ce compte, tu peux seulement relier l'encaissement à un dossier (facture, BLS ou BC) — les autres changements sont pour le responsable de la caisse."); return; }
    }
    // Nils 08/10 : compte en devises — saisie en euros ; « montant » = contre-valeur en dirhams (taux moyen ou saisie).
    if (estCompteDevises(compte) && f.type !== "transfert") {
      const dev = nombreOuZero(f.montantDevise);
      if (!(dev > 0)) { setNotice(`Indique le montant en ${compte.devise === "EUR" ? "euros" : compte.devise}.`); return; }
      const saisie = f._mad !== undefined ? (String(f._mad).trim() === "" ? null : nombreOuZero(f._mad)) : f.madManuel ? Number(f.montant) : null;
      const t = tauxMoyenDevises(compte.id, f.date || todayISO(), f.id);
      if (saisie === null && !t) { setNotice("Aucun taux connu sur ce compte : indique la contre-valeur en dirhams."); return; }
      f.montantDevise = Math.round(dev * 100) / 100;
      f.montant = saisie !== null ? saisie : Math.round(dev * t * 100) / 100;
      f.madManuel = saisie !== null;
      f.devise = compte.devise;
    }
    delete f._mad;
    const montant = Number(String(f.montant).replace(/\s/g, "").replace(",", "."));
    if (!f.date) { setNotice("Indique la date."); return; }
    if (f.date > todayISO()) { setNotice("La date ne peut pas être dans le futur."); return; }
    const avantVerrou = f.id ? (operations || []).find((o) => o.id === f.id) : null;
    if (moisVerrouille(compte.id, f.date) || (avantVerrou && moisVerrouille(avantVerrou.compteId, avantVerrou.date))) { setNotice(`${libMois(String(moisVerrouille(compte.id, f.date) ? f.date : avantVerrou.date).slice(0, 7))} est clôturé sur ${compte.nom} : opération impossible (le Gérant peut rouvrir le mois).`); return; }
    if (compte && compte.type === "caisse" && f.sens === "entree" && ["Chèque", "Effet / LCN"].includes(f.mode) && !f.id) { setNotice("Un chèque ou un effet reçu ne va pas dans une caisse : enregistre-le dans le « Portefeuille chèques » (il est détenu par une personne, puis déposé à la CFG)."); return; }
    if (compte && compte.id === PORTEFEUILLE_ID && !(f.sens === "entree" && ["Chèque", "Effet / LCN"].includes(f.mode))) { setNotice("Le portefeuille ne reçoit que des chèques et des effets."); return; }
    if (!(f.sens === "entree" && ["Chèque", "Effet / LCN"].includes(f.mode))) { f.echeanceCheque = undefined; f.sansVisibilite = undefined; f.detenteur = undefined; f.encaissementPrevu = undefined; }
    // Nils 03/10 (t) : date du chèque obligatoire (valable un an), case « pas de visibilité ».
    if (f.sens === "entree" && ["Chèque", "Effet / LCN"].includes(f.mode) && !f.echeanceCheque) { setNotice("Indique la date du chèque (ou de l'effet)."); return; }
    if (f.encaissementPrevu && f.echeanceCheque && f.encaissementPrevu < f.echeanceCheque) { setNotice("La date prévue d'encaissement ne peut pas être avant la date du chèque."); return; }
    if (f.encaissementPrevu && f.echeanceCheque && f.encaissementPrevu > expirationCheque(f.echeanceCheque)) { setNotice(`Le chèque n'est valable que jusqu'au ${formatDate(expirationCheque(f.echeanceCheque))} : la date prévue d'encaissement doit être avant.`); return; }
    // Nils 03/10 (s) : le chèque est détenu par une personne (par défaut celui qui le saisit).
    if (f.sens === "entree" && ["Chèque", "Effet / LCN"].includes(f.mode) && !f.detenteur) f.detenteur = user.id;
    if (!isFinite(montant) || montant <= 0) { setNotice(f.factureFournisseur ? "Indique le montant payé (case « Montant payé » en haut) — il peut être différent du TTC de la facture en cas de paiement partiel." : "Indique le montant (case « Montant » en haut)."); return; }
    if (!f.poste || !f.sousPoste) { setNotice("Choisis le poste et le sous-poste."); return; }
    // Avances sur salaire : toujours payées depuis la CFG (Nils 01/10) — sinon absentes des éléments de paie.
    if (f.sens === "sortie" && f.sousPoste === SOUS_POSTE_AVANCES && compte.type !== "banque" && !f.importe && !(avantVerrou && avantVerrou.sousPoste === SOUS_POSTE_AVANCES && avantVerrou.compteId === f.compteId)) { setNotice("Les avances et acomptes aux salariés se paient uniquement depuis la banque CFG."); return; }
    if (!(f.designation || "").trim()) { setNotice("Indique la désignation."); return; }
    // Nils 26/10 (g) : sans dossier seulement si la case « à relier plus tard » est cochée.
    if (f.poste !== POSTE_ENCAISSEMENT || f.dossierId) f.aRelierPlusTard = undefined;
    if (f.poste === POSTE_ENCAISSEMENT && !f.dossierId && !f.importe && !f.aRelierPlusTard) { setNotice("Un encaissement client doit être lié à un dossier (facture, BLS exo ou BC pour une avance) — ou coche « Facture pas encore dans l'ERP — à relier plus tard »."); return; }
    if (f.poste !== POSTE_ENCAISSEMENT || !Array.isArray(f.repartition) || f.repartition.length < 2) { f.repartition = undefined; }
    else {
      const parts = f.repartition.map((x) => ({ dossierId: x.dossierId, montant: Number(String(x.montant).replace(/\s/g, "").replace(",", ".")) }));
      if (parts.some((x) => !isFinite(x.montant) || x.montant <= 0)) { setNotice("Indique le montant de chaque facture de la répartition."); return; }
      if (Math.abs(parts.reduce((n, x) => n + x.montant, 0) - montant) > 0.01) { setNotice(`La répartition (${formatDH(parts.reduce((n, x) => n + x.montant, 0))}) doit être égale au montant encaissé (${formatDH(montant)}).`); return; }
      f.repartition = parts;
      f.dossierId = parts[0].dossierId;
    }
    delete f._ajout;
    // Nils 03/10 (r2) : un encaissement peut dépasser le reste dû — l'excédent reste en crédit client.
    if (f.poste === POSTE_ENCAISSEMENT && f.sens === "entree" && f.dossierId) {
      const avantOp = f.id ? (operations || []).find((o) => o.id === f.id) : null;
      const partsEnc = f.repartition || [{ dossierId: f.dossierId, montant }];
      const excedents = partsEnc.map((x) => {
        const d = dossierParId(x.dossierId);
        if (!d) return null;
        const dejaCetteOp = avantOp && avantOp.poste === POSTE_ENCAISSEMENT ? partsDossiers(avantOp).filter((y) => y.dossierId === x.dossierId).reduce((n, y) => n + y.montant, 0) : 0;
        const reste = arrondiH(totalDossierTTC(d) - encaisseDossier(d.id) + dejaCetteOp);
        return x.montant > reste + 0.01 ? { d, reste, exc: arrondiH(x.montant - Math.max(0, reste)) } : null;
      }).filter(Boolean);
      if (excedents.length && !(await demander(`Le montant dépasse le reste dû : ${excedents.map((x) => `${x.d.numeroFacture || x.d.numeroBL || x.d.numero} (reste ${formatDH(Math.max(0, x.reste))})`).join(", ")}.\n\nL'excédent de ${formatDH(excedents.reduce((n, x) => n + x.exc, 0))} restera en crédit client, à affecter plus tard à une autre facture (état de compte du client). Enregistrer ?`))) return;
    }
    // Primes de déplacement groupées (toute l'équipe) : pas de tiers individuel.
    if (f.sens === "sortie" && f.sousPoste === "Prime de déplacement" && (f.primesDeplMois || []).length) { f.tiersType = "employe"; f.tiers = "Équipe (primes de déplacement)"; }
    else if (!f.importe || f.tiersType) {
      if (!f.tiersType || !typesTiersPour(f.sens).includes(f.tiersType)) { setNotice(`Choisis le type de tiers (${typesTiersPour(f.sens).map(libelleTypeTiers).join(", ")}).`); return; }
      if (!(f.tiers || "").trim()) { setNotice("Choisis le tiers."); return; }
      const connus = nomsTiers(f.tiersType).map(normLib);
      if (!connus.includes(normLib(f.tiers)) && !f.importe) { setNotice(f.tiersType === "client" ? "Client inconnu : crée-le d'abord dans l'onglet Clients." : f.tiersType === "fournisseur" ? "Fournisseur inconnu : demande sa création (onglet Fournisseurs)." : "Choisis le tiers dans la liste (Paramétrage pour ajouter un organisme ou un associé)."); return; }
    }
    // Nils 23/10 (d) : la sortie garde la fiche Staff de l'employé quand son nom n'est porté que par une fiche ;
    // (c) une prime « Primes » à un employé porte son type (Aïd, exceptionnelle…).
    if (f.tiersType === "employe") { const fs = fichesStaffDuNom(f.tiers); f.staffId = fs.length === 1 ? fs[0].id : undefined; } else f.staffId = undefined;
    if (f.sens === "sortie" && f.tiersType === "employe" && f.sousPoste === SOUS_POSTE_PRIMES) { if (!f.typePrime && !f.importe) { setNotice("Choisis le type de prime."); return; } } else f.typePrime = undefined;
    // Factures fournisseurs réglées (registre) : obligatoire sur la banque pour un fournisseur.
    if (f.sens !== "sortie" || !["fournisseur", "etat"].includes(f.tiersType)) f.reglements = undefined;
    else {
      const parts = (f.reglements || []).map((x) => ({ factureId: x.factureId, montant: (f.reglements || []).length === 1 ? montant : Number(String(x.montant).replace(/\s/g, "").replace(",", ".")) }));
      if (!parts.length && compte.type === "banque" && f.tiersType === "fournisseur" && !f.factureFournisseur) { setNotice("Sur la banque, un paiement fournisseur doit être rattaché à une facture (ou un devis / une proforma) du registre — « + Saisir une facture » si elle n'y est pas encore."); return; }
      if (parts.some((x) => !isFinite(x.montant) || x.montant <= 0)) { setNotice("Indique le montant réglé sur chaque facture."); return; }
      if (parts.length > 1 && Math.abs(parts.reduce((n, x) => n + x.montant, 0) - montant) > 0.01) { setNotice(`La répartition sur les factures (${formatDH(parts.reduce((n, x) => n + x.montant, 0))}) doit être égale au montant payé (${formatDH(montant)}).`); return; }
      const avantOp = f.id ? (operations || []).find((o) => o.id === f.id) : null;
      for (const x of parts) {
        const fa = (facturesF || []).find((y) => y.id === x.factureId);
        if (!fa || normLib(fa.fournisseur) !== normLib(f.tiers)) { setNotice("Une facture rattachée n'appartient pas à ce fournisseur."); return; }
        const dejaCetteOp = avantOp ? (avantOp.reglements || []).filter((r) => r.factureId === fa.id).reduce((n, r) => n + (Number(r.montant) || 0), 0) : 0;
        if (x.montant > resteFactureF(fa) + dejaCetteOp + 0.01) { setNotice(`Le montant réglé sur ${fa.numero || "le devis"} (${formatDH(x.montant)}) dépasse le reste à payer (${formatDH(resteFactureF(fa) + dejaCetteOp)}).`); return; }
      }
      f.reglements = parts.length ? parts : undefined;
    }
    // Facture fournisseur (TVA) — ancienne saisie directe sur l'opération (conservée pour les opérations déjà saisies).
    if (f.sens !== "sortie" || !f.factureFournisseur || !["fournisseur", "etat"].includes(f.tiersType)) f.factureFournisseur = undefined;
    else {
      const ff = { ...f.factureFournisseur, fournisseur: (f.tiers || "").trim() };
      if (!(ff.fournisseur || "").trim()) { setNotice("Facture fournisseur : indique le fournisseur (ou décoche « Facture fournisseur »)."); return; }
      if (ff.douane) {
        const tva = Number(String(ff.tvaQuittance).replace(/\s/g, "").replace(",", "."));
        if (!isFinite(tva) || tva < 0) { setNotice("Douane : indique la TVA de la quittance."); return; }
        if (tva * 6 > montant + 0.01) { setNotice("Douane : la TVA saisie est trop élevée par rapport au montant payé — vérifie la quittance."); return; }
        f.factureFournisseur = { ...ff, fournisseur: ff.fournisseur.trim(), numero: (ff.numero || "").trim(), tvaQuittance: tva, lignes: [] };
      } else {
        const lignes = (ff.lignes || []).map((l) => ({ taux: Number(l.taux), ttc: Number(String(l.ttc).replace(/\s/g, "").replace(",", ".")) })).filter((l) => l.ttc);
        if (!lignes.length || lignes.some((l) => !isFinite(l.ttc) || l.ttc < 0)) { setNotice("Facture fournisseur : indique le TTC de la facture (une ligne par taux)."); return; }
        f.factureFournisseur = { ...ff, fournisseur: ff.fournisseur.trim(), numero: (ff.numero || "").trim(), lignes, tvaQuittance: undefined };
      }
      if (f.tiersType === "fournisseur") await enregistrerFournisseurCompta(f.factureFournisseur.fournisseur, (ff.ice || "").trim());
      delete f.factureFournisseur.ice;
    }
    // Nils 05/10 : commission versée — reliée à une commission validée, caisse autorisée, pas plus que le reste.
    if (f.sens === "sortie" && f.poste === "Commissions" && f.sousPoste === "Commissions versées") {
      const ancienne = f.id && (operations || []).some((o) => o.id === f.id);
      // Nils 26/10 : commission d'avant l'ERP — sans commission validée, tiers et montant libres (Gérant).
      if (!estGerant || f.commissionCle) f.commissionAnterieure = undefined;
      if (!f.commissionCle) {
        // Anciennes opérations (importées / d'avant l'ERP) : pas de commission à relier.
        if (!ancienne && !f.importe && !f.commissionAnterieure) { setNotice(`Choisis la commission versée (commissions validées)${estGerant ? " — ou coche « Commission antérieure à l'ERP »" : ""}.`); return; }
      } else {
        const cm = commissionsMaturees("", f.id).find((x) => x.cle === f.commissionCle);
        if (!cm) { setNotice("Cette commission est déjà entièrement versée."); return; }
        if (!caissesCommission(cm.personneId).includes(f.compteId)) { setNotice(`La commission de ${cm.nom} ne se paie pas depuis ce compte.`); return; }
        if (montant > cm.reste + 0.01) { setNotice(`Le montant dépasse le reste à verser (${formatDH(cm.reste)}).`); return; }
      }
    } else { if (f.commissionCle) f.commissionCle = undefined; f.commissionAnterieure = undefined; }
    // ERP step 15 (ak, Nils 08/10) : carburant, Jawaz, entretien, leasing… répartis par véhicule (obligatoire pour une nouvelle opération).
    if (f.sens === "sortie" && SOUS_POSTES_VEHICULE.includes(f.sousPoste)) {
      const ancienne = f.id && (operations || []).some((o) => o.id === f.id && !(o.vehicules || []).length);
      const lignes = (f.vehicules || []).filter((x) => x.vehiculeId);
      if (!lignes.length) {
        if (!ancienne && !f.importe) { setNotice(`${f.sousPoste} : indique le ou les véhicules concernés (ou « Hors flotte »).`); return; }
        f.vehicules = undefined;
      } else {
        const parts = lignes.map((x) => ({ vehiculeId: x.vehiculeId, montant: lignes.length === 1 ? montant : nombreOuZero(x.montant) }));
        if (new Set(parts.map((x) => x.vehiculeId)).size !== parts.length) { setNotice("Un même véhicule apparaît deux fois dans la répartition."); return; }
        if (parts.some((x) => !(x.montant > 0))) { setNotice("Indique le montant de chaque véhicule."); return; }
        const somme = parts.reduce((n, x) => n + x.montant, 0);
        if (Math.abs(somme - montant) > 0.01) { setNotice(`La répartition par véhicule (${formatDH(somme)}) doit être égale au montant payé (${formatDH(montant)}).`); return; }
        f.vehicules = parts;
      }
    } else if (f.vehicules) f.vehicules = undefined;
    // Nils 05/10 : primes de déplacement — versées depuis la caisse Nils, reliées au(x) mois indemnisé(s), montant = total des fiches.
    if (f.sens === "sortie" && f.sousPoste === "Prime de déplacement") {
      const ancienne = f.id && (operations || []).some((o) => o.id === f.id && !(o.primesDeplMois || []).length);
      // Nils 26/10 (c) : paiement d'avant les fiches de déplacement — sans mois, au nom de l'employé (Gérant).
      if (!estGerant || (f.primesDeplMois || []).length) f.primeDeplAnterieure = undefined;
      const mois = f.primesDeplMois || [];
      if (!mois.length) {
        if (!ancienne && !f.importe && !f.primeDeplAnterieure) { setNotice(`Choisis le ou les mois de déplacement indemnisés${estGerant ? " — ou coche « Paiement antérieur aux fiches de déplacement »" : ""}.`); return; }
      } else {
        if (f.compteId !== "caisse-nils") { setNotice("Les primes de déplacement se versent depuis la Caisse Nils."); return; }
        const deja = mois.find((ym) => versementsPrimesDepl(ym, f.id).length);
        if (deja) { setNotice(`Les primes de ${libPeriode(deja)} ont déjà été versées.`); return; }
        const du = mois.reduce((n, ym) => n + primesDeplacementDues(ym).total, 0);
        if (Math.abs(montant - du) > 0.01) { setNotice(`Le montant doit correspondre aux fiches de déplacement : ${formatDH(du)}. Corrige les fiches si besoin.`); return; }
      }
    } else { if (f.primesDeplMois) f.primesDeplMois = undefined; f.primeDeplAnterieure = undefined; }
    const existe = !!f.id && (operations || []).some((o) => o.id === f.id);
    if (!existe && f.tiersType === "fournisseur" && !(await confirmerFournisseurBlackliste(f.tiers, "un paiement"))) return;
    const maintenant = new Date().toISOString();
    const op = { ...f, montant, designation: f.designation.trim(), tiers: (f.tiers || "").trim(), piece: (f.piece || "").trim(), type: "normal", ...(f.sansContrepartie ? { sansContrepartie: undefined, reclasseDepuis: "mouvement de caisse importé" } : {}), ...(existe ? { modifiePar: user.nom, modifieLe: maintenant } : { id: uid(), par: user.nom, le: maintenant }) };
    const next = existe ? (operations || []).map((o) => (o.id === op.id ? op : o)) : [...(operations || []), op];
    await persistOperations(next);
    await tracerAcces(existe ? "opération de trésorerie modifiée" : "opération de trésorerie", `${compte.nom} — ${op.sens === "entree" ? "entrée" : "sortie"} ${formatDH(montant)} — ${op.poste} › ${op.sousPoste} — ${op.designation}`);
    if (op.poste === POSTE_A_DEFINIR && !estGerant) await alerter("Trésorerie : opération à classer", `${compte.nom} — ${formatDH(montant)} — ${op.designation} (par ${user.nom})`, { kind: "onglet", id: "compta" });
    const solde = (compte.soldeOuverture || 0) + next.filter((o) => o.compteId === compte.id && opCompte(o)).reduce((n, o) => n + montantEffectif(o), 0);
    if (solde < 0 && !compte.negatifAutorise) await alerter("Trésorerie : solde négatif", `${compte.nom} : solde ${formatDH(solde)} après « ${op.designation} » (par ${user.nom})`, { kind: "onglet", id: "compta" });
    // Nils 29/10 : sortie créée depuis une échéance récurrente — l'échéance passe « Réalisée », reliée.
    if (_recurrence && !existe) await majOccurrence(_recurrence.rId, _recurrence.date, { realiseeLe: todayISO(), realiseePar: user.nom, opId: op.id });
    setOpEdit(null);
  }
  async function supprimerOperation(id) {
    const o = (operations || []).find((x) => x.id === id);
    if (!o) return;
    const compte = compteDe(o.compteId);
    if (!peutSaisirCompte(compte)) return;
    if (moisVerrouille(o.compteId, o.date) || (o.transfertId && (operations || []).some((x) => x.transfertId === o.transfertId && moisVerrouille(x.compteId, x.date)))) { setNotice("Mois clôturé : suppression impossible (le Gérant peut rouvrir le mois)."); return; }
    if (o.type === "transfert") { if (!peut("compta.supprimerTransfert")) { setNotice("Un transfert ne se supprime pas ici : demande au Gérant."); return; } }
    if (o.compteId === PORTEFEUILLE_ID && o.depotId && (operations || []).some((x) => x.id === o.depotId)) { setNotice("Ce chèque a été déposé à la CFG : supprime d'abord la remise à la CFG."); return; }
    if (o.depotDe) {
      await persistOperations((operations || []).filter((x) => x.id !== id).map((x) => (x.id === o.depotDe ? { ...x, chequeRemisLe: undefined, chequeRemisPar: undefined, depotId: undefined } : x)));
      await tracerAcces("remise de chèque supprimée", `${o.designation} — ${formatDH(Number(o.montant) || 0)} (le chèque revient au portefeuille)`);
      setOpEdit(null);
      return;
    }
    const ids = o.type === "transfert" && o.transfertId ? (operations || []).filter((x) => x.transfertId === o.transfertId).map((x) => x.id) : [id];
    await persistOperations((operations || []).filter((x) => !ids.includes(x.id)).map((x) => (ids.includes(x.rapprocheAvec) ? { ...x, rapprocheAvec: undefined, contrepartieId: undefined, rapprochePar: undefined, rapprocheLe: undefined } : x)));
    await tracerAcces("opération de trésorerie supprimée", `${compte ? compte.nom : ""} — ${o.sens === "entree" ? "entrée" : "sortie"} ${formatDH(Number(o.montant) || 0)} — ${o.designation}`);
    if (!estGerant) await alerter("Trésorerie : opération supprimée", `${compte ? compte.nom : ""} — ${formatDH(Number(o.montant) || 0)} — ${o.designation} (par ${user.nom})`, { kind: "onglet", id: "compta" });
    setOpEdit(null);
  }
  async function enregistrerTransfert() {
    const t0 = transfertEdit;
    if (!t0) return;
    const t = t0.destination === "__cg" ? { ...t0, destination: "caisse-nils", pourCaisseGenerale: true, mode: "Espèces" } : t0;
    const src = compteDe(t.source), dst = compteDe(t.destination);
    if (src && src.type === "banque" && dst && dst.id !== "caisse-nils" && !(estCompteDevises(dst) && dst.parentId === src.id)) { setNotice("Depuis la CFG, un transfert ne va qu'à la caisse générale, à la Caisse Nils ou à la dotation devises."); return; }
    if (estCompteDevises(src) || (estCompteDevises(dst) && !(src && src.type === "banque"))) { setNotice("La dotation devises ne s'alimente que depuis la CFG."); return; }
    const recuDevise = dst && estCompteDevises(dst) ? nombreOuZero(t.montantDevise) : 0;
    if (dst && estCompteDevises(dst) && !(recuDevise > 0)) { setNotice(`Indique les ${dst.devise === "EUR" ? "euros" : dst.devise} reçus sur ${dst.nom}.`); return; }
    if (!peutSaisirCompte(src)) return;
    const montant = Number(String(t.montant).replace(/\s/g, "").replace(",", "."));
    if (!dst || dst.id === src.id) { setNotice("Choisis le compte qui reçoit."); return; }
    if (!isFinite(montant) || montant <= 0) { setNotice("Indique un montant valide."); return; }
    if (!t.date || t.date > todayISO()) { setNotice("Date invalide."); return; }
    if (moisVerrouille(src.id, t.date) || moisVerrouille(dst.id, t.date)) { setNotice(`${libMois(t.date.slice(0, 7))} est clôturé sur ${moisVerrouille(src.id, t.date) ? src.nom : dst.nom} : transfert impossible à cette date.`); return; }
    const transfertId = uid();
    const maintenant = new Date().toISOString();
    const des = (t.note || "").trim();
    if (dst.id === CAISSE_GENERALE_ID || src.id === CAISSE_GENERALE_ID) { setNotice("La caisse générale ne reçoit pas de transfert : utilise « Retrait d'espèces pour la caisse générale » (CFG → Caisse Nils)."); return; }
    const pourCG = !!t.pourCaisseGenerale && src.type === "banque" && dst.id === "caisse-nils";
    const sortie = { id: uid(), compteId: src.id, date: t.date, sens: "sortie", montant, type: "transfert", transfertId, contrepartieId: dst.id, poste: "Transfert", sousPoste: `vers ${dst.nom}`, designation: des || (pourCG ? "Retrait d'espèces pour la caisse générale" : `Transfert vers ${dst.nom}`), tiers: dst.nom, mode: pourCG ? "Espèces" : t.mode || "Espèces", piece: "", par: user.nom, le: maintenant, ...(pourCG ? { pourCaisseGenerale: true } : {}) };
    const entree = { id: uid(), compteId: dst.id, date: t.date, sens: "entree", montant, type: "transfert", transfertId, contrepartieId: src.id, poste: "Transfert", sousPoste: `depuis ${src.nom}`, designation: des || `Transfert depuis ${src.nom}`, tiers: src.nom, mode: t.mode || "Espèces", piece: "", statutTransfert: "en attente", par: user.nom, le: maintenant, ...(recuDevise > 0 ? { montantDevise: Math.round(recuDevise * 100) / 100, devise: dst.devise, statutTransfert: "confirmé", confirmePar: user.nom, confirmeLe: maintenant } : {}) };
    await persistOperations([...(operations || []), sortie, entree]);
    await tracerAcces("transfert de trésorerie", `${src.nom} → ${dst.nom} — ${formatDH(montant)}${recuDevise > 0 ? ` → ${fmtCompte(dst, recuDevise)} (taux ${(montant / recuDevise).toFixed(4).replace(".", ",")})` : ""}${des ? ` — ${des}` : ""}`);
    setTransfertEdit(null);
    setNotice(recuDevise > 0 ? `Alimentation enregistrée : ${formatDH(montant)} débités de ${src.nom}, ${fmtCompte(dst, recuDevise)} crédités (taux ${(montant / recuDevise).toFixed(4).replace(".", ",")}).` : `Transfert enregistré — ${dst.nom} doit confirmer la réception.`);
  }
  async function confirmerReceptionTransfert(refuser) {
    const r = receptionEdit;
    if (!r) return;
    const o = (operations || []).find((x) => x.id === r.id);
    if (!o) return;
    const dst = compteDe(o.compteId), src = compteDe(o.contrepartieId);
    if (!peutSaisirCompte(dst)) return;
    if (moisVerrouille(dst.id, o.date)) { setNotice(`${libMois(o.date.slice(0, 7))} est clôturé sur ${dst.nom} : demande au Gérant de rouvrir le mois.`); return; }
    const recu = refuser ? 0 : Number(String(r.montant).replace(/\s/g, "").replace(",", "."));
    if (!refuser && (!isFinite(recu) || recu < 0)) { setNotice("Indique le montant reçu."); return; }
    const maintenant = new Date().toISOString();
    const maj = { ...o, statutTransfert: refuser ? "refusé" : "confirmé", montantRecu: refuser ? "" : recu, receptionNote: (r.note || "").trim(), confirmePar: user.nom, confirmeLe: maintenant };
    await persistOperations((operations || []).map((x) => (x.id === o.id ? maj : x)));
    const ecart = refuser ? null : arrondiH(recu - Number(o.montant));
    await tracerAcces(refuser ? "transfert refusé" : "transfert reçu", `${src ? src.nom : "?"} → ${dst.nom} — envoyé ${formatDH(Number(o.montant))}${refuser ? "" : `, reçu ${formatDH(recu)}`}${maj.receptionNote ? ` — ${maj.receptionNote}` : ""}`);
    if (refuser || ecart) await alerter(refuser ? "Transfert refusé" : "Transfert : écart à la réception", `${src ? src.nom : "?"} → ${dst.nom} — envoyé ${formatDH(Number(o.montant))}${refuser ? " — refusé" : `, reçu ${formatDH(recu)} (écart ${formatDH(ecart)})`}${maj.receptionNote ? ` — ${maj.receptionNote}` : ""} (par ${user.nom})`, { kind: "onglet", id: "compta" });
    setReceptionEdit(null);
  }
  // ---- TVA : factures fournisseurs, encaissements, fichier du comptable (Nils 30/09) ----
  function organismesEtat() {
    const l = parametres && parametres.organismesEtat;
    return Array.isArray(l) ? l : DEFAULT_ORGANISMES_ETAT;
  }
  function associes() {
    const l = parametres && parametres.associes;
    return Array.isArray(l) ? l : DEFAULT_ASSOCIES;
  }
  // Types de tiers ajoutés à la main par Nils (Nils 01/10) : { id: "perso:…", libelle, sens, noms[] }.
  function typesTiersPerso() {
    const l = parametres && parametres.typesTiersPerso;
    return Array.isArray(l) ? l : [];
  }
  function typesTiersPour(sens) {
    return [...(TIERS_PAR_SENS[sens] || []), ...typesTiersPerso().filter((t) => t.sens === "les deux" || t.sens === sens).map((t) => t.id)];
  }
  function libelleTypeTiers(t) {
    if (TYPES_TIERS[t]) return TYPES_TIERS[t];
    const x = typesTiersPerso().find((y) => y.id === t);
    return x ? x.libelle : "Tiers";
  }
  async function persistTypesTiersPerso(next, trace) {
    if (!peut("compta.parametrer")) return;
    await persistParametres({ ...(parametres || {}), typesTiersPerso: next });
    if (trace) await tracerAcces("comptabilité : types de tiers", trace);
  }
  // Noms proposés pour un type de tiers.
  function nomsTiers(type) {
    if (String(type || "").startsWith("perso:")) { const x = typesTiersPerso().find((y) => y.id === type); return x ? [...(x.noms || [])].sort((a, b) => a.localeCompare(b, "fr")) : []; }
    if (type === "client") return (clients || []).map((c) => c.nom).filter(Boolean).sort((a, b) => a.localeCompare(b, "fr"));
    if (type === "fournisseur") return (fournisseurs || []).map((f) => f.nom).filter(Boolean).sort((a, b) => a.localeCompare(b, "fr"));
    if (type === "employe") return (staff || []).filter((x) => staffActif(x) && !ficheStaffMasquee(x)).map((x) => x.nom).filter(Boolean).sort((a, b) => a.localeCompare(b, "fr"));
    if (type === "etat") return organismesEtat();
    if (type === "associe") return associes();
    // Nils 03/10 : frais bancaires, agios, intérêts — la banque comme tiers.
    if (type === "banque") return (comptesTreso || []).filter((c) => c.type === "banque").map((c) => c.nom);
    return [];
  }
  // Nils 06/10 : fournisseurs blacklistés — alerte (confirmation + alerte à Nils) à chaque saisie.
  function fournisseurBlackliste(nom) {
    const f = (fournisseurs || []).find((x) => normLib(x.nom) === normLib(nom));
    return f && f.blacklist ? f : null;
  }
  async function confirmerFournisseurBlackliste(nom, quoi) {
    const f = fournisseurBlackliste(nom);
    if (!f) return true;
    if (!(await demander(`⛔ ${f.nom} est blacklisté${f.blacklist.motif ? ` (${f.blacklist.motif})` : ""} depuis le ${formatDate(String(f.blacklist.le).slice(0, 10))}.\n\nEnregistrer quand même ${quoi} ?`, { danger: true }))) return false;
    if (!estGerant) await alerter("Fournisseur blacklisté", `${user.nom} a enregistré ${quoi} avec ${f.nom} (blacklisté)`, { kind: "onglet", id: "fournisseurs" });
    await tracerAcces("fournisseur blacklisté utilisé", `${f.nom} — ${quoi}`);
    return true;
  }
  async function basculerBlacklist(f) {
    if (!estGerant) return;
    if (f.blacklist) {
      if (!(await demander(`Retirer ${f.nom} de la blacklist ?`))) return;
      await persistFournisseurs((fournisseurs || []).map((x) => (x.id === f.id ? { ...x, blacklist: null } : x)));
      await tracerAcces("fournisseur retiré de la blacklist", f.nom);
      return;
    }
    const motif = await demander(`Blacklister ${f.nom} : motif ?`, { saisie: true });
    if (motif === null) return;
    await persistFournisseurs((fournisseurs || []).map((x) => (x.id === f.id ? { ...x, blacklist: { le: new Date().toISOString(), par: user.nom, motif: motif.trim() } } : x)));
    await tracerAcces("fournisseur blacklisté", `${f.nom}${motif.trim() ? ` — ${motif.trim()}` : ""}`);
  }
  function bandeauBlacklist(nom) {
    const f = fournisseurBlackliste(nom);
    if (!f) return null;
    return <div style={{ background: "#F5E4DE", color: ROUILLE, borderRadius: 8, padding: "8px 12px", fontSize: 13, fontWeight: 600, marginBottom: 10 }}>⛔ {f.nom} est blacklisté{f.blacklist.motif ? ` — ${f.blacklist.motif}` : ""} (par {f.blacklist.par}, le {formatDate(String(f.blacklist.le).slice(0, 10))}).</div>;
  }
  function fournisseurParNom(nom) {
    const k = normLib(nom);
    return k ? (fournisseurs || []).find((x) => normLib(x.nom) === k) || null : null;
  }
  function iceValide(ice) {
    return String(ice || "").replace(/\D/g, "").length === 15;
  }
  // Crée le fournisseur (ou complète son ICE) si l'utilisateur a le droit d'écrire les fournisseurs.
  async function enregistrerFournisseurCompta(nom, ice) {
    if (!nom || !peutEcrireFour) return;
    const f = fournisseurParNom(nom);
    if (f) {
      if (ice && !f.ice) await persistFournisseurs((fournisseurs || []).map((x) => (x.id === f.id ? { ...x, ice } : x)));
      return;
    }
  }
  function factureVide(o) {
    return { fournisseur: o.tiers || "", ice: "", numero: "", date: o.date || "", lignes: [{ taux: 0.2, ttc: o.montant || "" }], douane: /douane/i.test(o.tiers || ""), tvaQuittance: "" };
  }

  // Lignes du fichier comptable pour une sortie avec facture : une par taux.
  // Douane : TVA de la quittance × 6 à 20 %, le reste du paiement (droits) à 0 %.
  // Nils 03/10 : le fichier TVA part de la CFG et de la caisse générale seulement
  // (pas des autres caisses). Une copie de la caisse générale est lue comme son
  // opération d'origine (facture, dossier), mais datée et classée dans la caisse générale.
  function opsPourTVA() {
    const parId = Object.fromEntries((operations || []).map((o) => [o.id, o]));
    return (operations || []).map((o) => {
      const c = compteDe(o.compteId);
      if (!c) return null;
      if (o.miroirDe) { const src = parId[o.miroirDe]; return src && src.type !== "transfert" ? { ...src, id: o.id, compteId: o.compteId, date: o.date, mode: o.mode } : null; }
      // CFG : seulement les opérations pointées sur le relevé, à leur date de passage (Nils 03/10).
      // Une remise de chèque se lit comme le chèque d'origine (client, facture).
      if (c.type === "banque" && o.depotDe) { const src = parId[o.depotDe]; return o.releveLe && src ? { ...src, id: o.id, compteId: o.compteId, date: o.releveLe, mode: o.mode, sens: o.sens, montant: o.montant } : null; }
      if (c.type === "banque") return o.releveLe ? { ...o, date: o.releveLe } : null;
      if (c.id === CAISSE_GENERALE_ID) return o;
      return null;
    }).filter(Boolean);
  }
  function lignesTVAAchat(o) {
    if (!o.factureFournisseur && (o.reglements || []).length) {
      return o.reglements.flatMap((r) => {
        const fa = (facturesF || []).find((x) => x.id === r.factureId);
        if (!fa || fa.type === "devis") return [];
        const lg = lignesFactureF(fa), tot = lg.reduce((n, l) => n + l.ttc, 0);
        return lg.map((l) => {
          const ht = l.ttc / (1 + l.taux);
          return { date: fa.date, fournisseur: fa.fournisseur, numero: fa.numero, designation: o.sousPoste || o.designation, taux: l.taux, ht, tva: ht * l.taux, ttc: l.ttc, regle: tot ? ((Number(r.montant) || 0) * l.ttc) / tot : 0, mode: MODE_COMPTABLE[o.mode] || "AUTRE", datePaiement: o.date, remarque: [fa.douane ? "Douane : TVA de la quittance" : "", (compteDe(o.compteId) || {}).nom].filter(Boolean).join(" — "), opId: o.id };
        });
      });
    }
    const ff = o.factureFournisseur;
    if (!ff) return [];
    const paye = Number(o.montant) || 0;
    const brutes = ff.douane ? [{ taux: 0.2, ttc: arrondiH(Number(ff.tvaQuittance) * 6) }, { taux: 0, ttc: arrondiH(paye - Number(ff.tvaQuittance) * 6) }].filter((l) => l.ttc > 0) : ff.lignes;
    const totalFacture = brutes.reduce((n, l) => n + l.ttc, 0);
    return brutes.map((l) => {
      const ht = l.ttc / (1 + l.taux);
      return { date: ff.date, fournisseur: ff.fournisseur, numero: ff.numero, designation: o.sousPoste || o.designation, taux: l.taux, ht, tva: ht * l.taux, ttc: l.ttc, regle: totalFacture ? (paye * l.ttc) / totalFacture : 0, mode: MODE_COMPTABLE[o.mode] || "AUTRE", datePaiement: o.date, remarque: [ff.douane ? "Douane : TVA de la quittance" : "", (compteDe(o.compteId) || {}).nom].filter(Boolean).join(" — "), opId: o.id };
    });
  }
  function tvaDossier(c) {
    if (c.avanceProjet) { const f = factureAvanceDe(c.id) || {}; return { ttc: Number(f.ttc) || 0, tva: Number(f.tva) || 0, exo: !!f.exo, prorata: prorataRegleParClient(f) }; }
    if (c.anterieure) return { ttc: c.ttcAnt, tva: c.exoAnt ? 0 : c.ttcAnt / 6, exo: !!c.exoAnt };
    const d = (devisListe || []).find((x) => x.id === c.devisId) || {};
    const dp = deductionsDossier(c);
    if (dp) return { ttc: dp.ttc, tva: dp.tva, exo: !!d.exonereTVA, prorata: prorataRegleParClient(dp) };
    const t = calcTotaux({ ...d, lignes: lignesDuDossier(c) });
    return { ttc: t.totalTTC || 0, tva: (t.totalTTC || 0) - (t.totalHT || 0), exo: !!d.exonereTVA };
  }
  // Lignes « ENCAISSEMENT » : une par facture couverte ; ventes exo (BLS) exclues.
  function lignesTVAEncaissement(o) {
    // Step 17 : remboursement d'un avoir = encaissement négatif (rien pour un avoir exo).
    if (o.avoirId) {
      const a = (avoirs || []).find((x) => x.id === o.avoirId);
      if (!a || a.exo) return [];
      const ttc = (o.sens === "entree" ? 1 : -1) * (Number(o.montant) || 0);
      const tva = ttc / (1 + TVA_TAUX) * TVA_TAUX;
      return [{ date: o.date, client: (clientDe(a.clientId) || {}).nom || o.tiers || "", numero: a.numero, releve: ttc, ttc, tva, ht: ttc - tva, mode: MODE_COMPTABLE[o.mode] || o.mode || "" }];
    }
    return partsDossiers(o).map((p, i) => {
      const c = dossierParId(p.dossierId);
      if (!c) return null;
      const t = tvaDossier(c);
      if (t.exo) return null;
      const signe = o.sens === "entree" ? 1 : -1;
      // Nils 29/10 : le compte prorata est réglé par compensation — le TTC encaissé inclut sa part.
      const brut = t.prorata && t.ttc > t.prorata ? t.ttc / (t.ttc - t.prorata) : 1;
      const ttc = signe * p.montant * brut;
      const tva = t.ttc ? (ttc * t.tva) / t.ttc : ttc / 6;
      return { date: o.date, client: (clientDe(c.clientId) || {}).nom || o.tiers || "", numero: c.numeroFacture || `Avance ${c.numero}`, releve: i === 0 ? signe * (Number(o.montant) || 0) : "", ttc, tva, ht: ttc - tva, mode: MODE_COMPTABLE[o.mode] || "AUTRE", opId: o.id };
    }).filter(Boolean).reduce((acc, l) => {
      // Nils 17/10 : facture groupée — un numéro, un total (ses dossiers fusionnés en une ligne).
      const meme = acc.find((x) => x.numero === l.numero && !String(l.numero).startsWith("Avance"));
      if (meme) { meme.ttc += l.ttc; meme.tva += l.tva; meme.ht += l.ht; } else acc.push(l);
      return acc;
    }, []);
  }
  async function exporterFichierTVA(mois) {
    if (!peut("compta.tva")) return;
    let XLSX;
    try { XLSX = await chargerSheetJS(); } catch (e) { setNotice(e.message); return; }
    const [an, m] = mois.split("-");
    const ops = opsPourTVA().filter((o) => (o.date || "").slice(0, 7) === mois);
    const achats = ops.filter((o) => o.sens === "sortie" && (o.factureFournisseur || (o.reglements || []).length)).sort((a, b) => (a.date < b.date ? -1 : 1)).flatMap(lignesTVAAchat);
    const encs = ops.filter((o) => o.poste === POSTE_ENCAISSEMENT).sort((a, b) => (a.date < b.date ? -1 : 1)).flatMap(lignesTVAEncaissement);
    const d = (iso) => (iso ? new Date(`${iso}T00:00:00`) : "");
    const r2 = (x) => Math.round(x * 100) / 100;
    const nomFeuille = `${MOIS_COMPTABLE[Number(m) - 1]}-${an}`;
    const wsA = XLSX.utils.aoa_to_sheet([["DATE DE FACTURE", "FOURNISSEUR", "N° DE FACTURE", "DESIGNATION", "TAUX TVA", "MONTANT HT", "MONTANT TVA", "MONTANT TTC", "MONTANT REGLE", "MODE PAIEMENT", "DATE PAIEMENT", "POURCENTAGE DE PAIEMENT", "REMARQUE"],
      ...achats.map((l) => [d(l.date), l.fournisseur, l.numero, l.designation, l.taux, r2(l.ht), r2(l.tva), r2(l.ttc), r2(l.regle), l.mode, d(l.datePaiement), l.ttc ? l.regle / l.ttc : 0, l.remarque])], { cellDates: true });
    achats.forEach((l, i) => {
      const r = i + 2;
      // Nature TVA supprimée (accord du comptable, 01/10) : colonnes décalées d'un cran.
      wsA[`F${r}`] = { t: "n", v: r2(l.ht), f: `H${r}/(1+E${r})`, z: "#,##0.00" };
      wsA[`G${r}`] = { t: "n", v: r2(l.tva), f: `F${r}*E${r}`, z: "#,##0.00" };
      wsA[`L${r}`] = { t: "n", v: l.ttc ? l.regle / l.ttc : 0, f: `I${r}/H${r}`, z: "0%" };
      ["A", "K"].forEach((c) => { if (wsA[`${c}${r}`]) wsA[`${c}${r}`].z = "dd/mm/yyyy"; });
      if (wsA[`E${r}`]) wsA[`E${r}`].z = "0%";
      ["H", "I"].forEach((c) => { if (wsA[`${c}${r}`]) wsA[`${c}${r}`].z = "#,##0.00"; });
    });
    wsA["!cols"] = [12, 28, 20, 24, 8, 12, 12, 12, 12, 14, 12, 10, 30].map((w) => ({ wch: w }));
    const wsE = XLSX.utils.aoa_to_sheet([["DATE DE PAIEMENT", "CLIENT", "N° FACTURE", "MONTANT AU RELEVE", "MONTANT TTC", "MONTANT TVA", "MANTANT HT", "MODE DE PAIEMENT"],
      ...encs.map((l) => [d(l.date), l.client, l.numero, l.releve === "" ? "" : r2(l.releve), r2(l.ttc), r2(l.tva), r2(l.ht), l.mode])], { cellDates: true });
    encs.forEach((l, i) => { const r = i + 2; if (wsE[`A${r}`]) wsE[`A${r}`].z = "dd/mm/yyyy"; ["D", "E", "F", "G"].forEach((c) => { if (wsE[`${c}${r}`]) wsE[`${c}${r}`].z = "#,##0.00"; }); });
    wsE["!cols"] = [12, 28, 20, 14, 12, 12, 12, 14].map((w) => ({ wch: w }));
    // Fournisseurs des factures de l'année jusqu'au mois exporté.
    const nomsF = [...new Set(opsPourTVA().filter((o) => (o.date || "") >= `${an}-01-01` && (o.date || "").slice(0, 7) <= mois).flatMap((o) => lignesTVAAchat(o).map((l) => l.fournisseur)))].sort((a, b) => a.localeCompare(b, "fr"));
    const wsF = XLSX.utils.aoa_to_sheet([["FOURNISSEUR", "ICE"], ...nomsF.map((n) => { const f = fournisseurParNom(n); return [n, f && f.ice ? String(f.ice) : ""]; })]);
    wsF["!cols"] = [{ wch: 34 }, { wch: 18 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsA, nomFeuille);
    XLSX.utils.book_append_sheet(wb, wsE, "ENCAISSEMENT");
    XLSX.utils.book_append_sheet(wb, wsF, "LISTE FOURNISSEUR");
    // Step 17 : factures d'avoir du mois (pour le comptable). Pas de ligne dans ENCAISSEMENT :
    // l'avoir est un crédit, pas un mouvement d'argent — la TVA sur encaissements reste juste.
    const avM = (avoirs || []).filter((a) => String(a.date || "").slice(0, 7) === mois).sort((a, b) => (a.date < b.date ? -1 : 1));
    if (avM.length) {
      const wsV = XLSX.utils.aoa_to_sheet([["DATE", "CLIENT", "N° AVOIR", "FACTURE D'ORIGINE", "MOTIF", "MONTANT HT", "MONTANT TVA", "MONTANT TTC"], ...avM.map((a) => [d(a.date), (clientDe(a.clientId) || {}).nom || "", a.numero, a.factureNumero, a.motif, -r2(a.ht), -r2(a.tva), -r2(a.ttc)])], { cellDates: true });
      avM.forEach((a, i) => { const r = i + 2; if (wsV[`A${r}`]) wsV[`A${r}`].z = "dd/mm/yyyy"; ["F", "G", "H"].forEach((c) => { if (wsV[`${c}${r}`]) wsV[`${c}${r}`].z = "#,##0.00"; }); });
      wsV["!cols"] = [12, 28, 16, 16, 34, 14, 14, 14].map((w) => ({ wch: w }));
      XLSX.utils.book_append_sheet(wb, wsV, "AVOIRS");
    }
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const ok = await proposerTelechargement(`TVA-Stone-Concept-${nomFeuille}.xlsx`, buf);
    if (ok) await tracerAcces("fichier TVA exporté", `${nomFeuille} — ${achats.length} ligne(s) d'achat, ${encs.length} encaissement(s)`);
  }
  // Import de la « LISTE FOURNISSEUR » du comptable : nom + ICE (IF / RC ignorés).
  async function importerFournisseursComptable(fichier) {
    if (!fichier || !peutEcrireFour) return;
    let XLSX;
    try { XLSX = await chargerSheetJS(); } catch (e) { setNotice(e.message); return; }
    let wb;
    try { wb = XLSX.read(await fichier.arrayBuffer(), { type: "array" }); } catch (e) { setNotice("Fichier illisible."); return; }
    const sn = wb.SheetNames.find((n) => normLib(n).includes("fournisseur"));
    if (!sn) { setNotice("Aucun onglet « LISTE FOURNISSEUR » dans ce fichier."); return; }
    const rows = XLSX.utils.sheet_to_json(wb.Sheets[sn], { header: 1, raw: false, defval: "" });
    const h = rows.findIndex((r) => r.some((c) => normLib(c) === "fournisseur"));
    if (h < 0) { setNotice("En-tête « FOURNISSEUR » introuvable."); return; }
    const H = rows[h].map((c) => normLib(c));
    const cN = H.indexOf("fournisseur"), cI = H.indexOf("ice");
    let next = [...(fournisseurs || [])];
    let crees = 0, completes = 0;
    const conflits = [];
    rows.slice(h + 1).forEach((r) => {
      const nom = String(r[cN] || "").trim();
      if (!nom) return;
      const ice = cI >= 0 ? String(r[cI] || "").trim() : "";
      const ex = next.find((x) => normLib(x.nom) === normLib(nom));
      if (!ex) { next.push({ id: uid(), nom, origine: "Maroc", fiabilite: "bonne", contacts: [], ice, paiement: "", certifFourni: false, certifDate: "", notes: "Importé de la liste du comptable" }); crees += 1; }
      else if (ice && !ex.ice) { next = next.map((x) => (x.id === ex.id ? { ...x, ice } : x)); completes += 1; }
      else if (ice && ex.ice && ex.ice.replace(/\D/g, "") !== ice.replace(/\D/g, "")) conflits.push(`${nom} (ERP ${ex.ice} / fichier ${ice})`);
    });
    if (!await demander(`Liste du comptable : ${crees} fournisseur(s) à créer, ${completes} ICE à compléter${conflits.length ? `, ${conflits.length} ICE différent(s) — l'ERP garde le sien` : ""}. Continuer ?`)) return;
    await persistFournisseurs(next);
    await tracerAcces("fournisseurs importés (liste du comptable)", `${fichier.name} — ${crees} créé(s), ${completes} ICE complété(s)${conflits.length ? ` ; ICE différents : ${conflits.join(" ; ")}` : ""}`);
    setNotice(`Fournisseurs : ${crees} créé(s), ${completes} ICE complété(s)${conflits.length ? `, ${conflits.length} ICE différent(s) conservé(s) (voir le journal)` : ""}.`);
  }
  // ---- Factures fournisseurs & échéancier ----
  async function persistFacturesF(next) {
    setFacturesF(next);
    return await saveKey(FACTURES_FOURNISSEURS_KEY, next);
  }
  const peutSaisirFactureF = peut("compta.facturesF.saisir");
  const peutControlerFactureF = peut("compta.facturesF.controler");
  function joursCondition(label) {
    const c = (paiements || []).find((x) => x.label === label);
    if (c && c.jours !== undefined && c.jours !== "" && c.jours !== null && isFinite(Number(c.jours))) return Number(c.jours);
    const m = String(label || "").match(/(\d+)\s*j/i);
    if (m) return Number(m[1]);
    if (/comptant|r[ée]ception|avance|imm[ée]diat/i.test(label || "")) return 0;
    return null;
  }
  // Nils 08/10 : « 30 jours fin de mois » côté clients = fin du mois de (date + 30 j),
  // comme pour les fournisseurs (avant : 30 j secs).
  function echeanceCondition(base, label, defaut) {
    const j = joursCondition(label);
    if (j === null && defaut === undefined) return base;
    let d = decalerJours(base, j === null ? defaut : j);
    if (/fin\s*de\s*mois|\bfdm\b/i.test(String(label || "")) && d) d = finDeMois(d.slice(0, 7));
    return d;
  }
  // Délai appliqué : condition du fournisseur, plafonnée à 60 j (120 j avec convention).
  function delaiFournisseur(nom) {
    const f = fournisseurParNom(nom);
    const cond = f ? joursCondition(f.paiement) : null;
    // Nils 03/10 (u) : la loi 69-21 ne s'applique pas aux fournisseurs étrangers.
    if (f && f.origine === "Étranger") return { jours: cond === null ? DELAI_LEGAL_JOURS : cond, max: null, condition: f.paiement || "", joursCondition: cond, depasse: false, convention: false, etranger: true };
    const conv = !!(f && f.convention && f.convention.active);
    const max = conv ? Math.min(Number(f.convention.jours) || DELAI_CONVENTION_MAX, DELAI_CONVENTION_MAX) : DELAI_LEGAL_JOURS;
    return { jours: cond === null ? max : Math.min(cond, max), max, condition: f ? f.paiement || "" : "", joursCondition: cond, depasse: cond !== null && cond > max, convention: conv };
  }
  function lignesFactureF(fa) {
    if (fa.douane) {
      const tva = Number(fa.tvaQuittance) || 0, tot = Number(fa.montantQuittance) || 0;
      return [{ taux: 0.2, ttc: arrondiH(tva * 6) }, { taux: 0, ttc: arrondiH(tot - tva * 6) }].filter((l) => l.ttc > 0);
    }
    return (fa.lignes || []).map((l) => ({ taux: Number(l.taux), ttc: Number(l.ttc) || 0 }));
  }
  function ttcFactureF(fa) {
    return fa.douane ? Number(fa.montantQuittance) || 0 : lignesFactureF(fa).reduce((n, l) => n + l.ttc, 0);
  }
  function reglementsDeFacture(faId) {
    const r = [];
    (operations || []).forEach((o) => (o.reglements || []).forEach((x) => { if (x.factureId === faId) r.push({ op: o, montant: (o.sens === "sortie" ? 1 : -1) * (Number(x.montant) || 0) }); }));
    return r.sort((a, b) => (a.op.date < b.op.date ? -1 : 1));
  }
  function regleFactureF(faId) {
    return reglementsDeFacture(faId).reduce((n, x) => n + x.montant, 0);
  }
  function resteFactureF(fa) {
    return arrondiH(ttcFactureF(fa) - regleFactureF(fa.id));
  }
  function ajouterJours(iso, j) {
    return iso ? decalerJours(iso, j) : "";
  }
  // Nils 03/10 (v) : « 60/90/120 » = 1/3 à 60 j, 1/3 à 90 j, 1/3 à 120 j ;
  // « 30 jours fin de mois » = fin du mois de (date + 30 j). Chaque tranche est
  // plafonnée à la limite légale du fournisseur.
  function tranchesCondition(label) {
    const t = String(label || "");
    const finMois = /fin\s*de\s*mois|\bfdm\b/i.test(t);
    const multi = t.match(/(\d+)\s*(?:j(?:ours?)?)?\s*\/\s*(\d+)(?:\s*(?:j(?:ours?)?)?\s*\/\s*(\d+))?(?:\s*(?:j(?:ours?)?)?\s*\/\s*(\d+))?/i);
    if (multi) {
      const js = multi.slice(1).filter(Boolean).map(Number);
      return js.map((j) => ({ jours: j, part: 1 / js.length, finMois }));
    }
    const j = joursCondition(label);
    return j === null ? null : [{ jours: j, part: 1, finMois }];
  }
  function echeancesFactureF(fa) {
    if (fa.type === "devis") return [];
    const ttc = ttcFactureF(fa);
    if (fa.tiersType === "etat") return [{ date: fa.date, montant: ttc }];
    const d = delaiFournisseur(fa.fournisseur);
    const f = fournisseurParNom(fa.fournisseur);
    const tranches = (f && tranchesCondition(f.paiement)) || [{ jours: d.jours, part: 1, finMois: false }];
    const lim = d.max === null ? "" : ajouterJours(fa.date, d.max);
    let cumul = 0;
    return tranches.map((t, i) => {
      let date = ajouterJours(fa.date, d.max === null ? t.jours : Math.min(t.jours, d.max));
      if (t.finMois && date) date = finDeMois(date.slice(0, 7));
      if (lim && date > lim) date = lim;
      const montant = i === tranches.length - 1 ? arrondiH(ttc - cumul) : arrondiH(ttc * t.part);
      cumul += montant;
      return { date, montant };
    });
  }
  // Tranches avec leur reste dû (les règlements soldent les premières tranches d'abord).
  function echeancesRestantesF(fa) {
    let paye = regleFactureF(fa.id);
    return echeancesFactureF(fa).map((e) => { const p = Math.min(e.montant, Math.max(0, paye)); paye -= p; return { ...e, reste: arrondiH(e.montant - p) }; });
  }
  // Prochaine échéance non soldée (sinon la dernière).
  function echeanceFactureF(fa) {
    if (fa.type === "devis") return "";
    const l = echeancesRestantesF(fa);
    if (!l.length) return "";
    const ouverte = l.find((e) => e.reste > 0.01);
    return (ouverte || l[l.length - 1]).date;
  }
  function limiteLegaleFactureF(fa) {
    if (fa.type === "devis" || fa.tiersType === "etat") return "";
    if (delaiFournisseur(fa.fournisseur).etranger) return "";
    return ajouterJours(fa.date, delaiFournisseur(fa.fournisseur).max);
  }
  function tauxAmende(joursRetard) {
    const mois = Math.max(1, Math.ceil(joursRetard / 30));
    return AMENDE_TAUX_1ER_MOIS + AMENDE_TAUX_MOIS_SUIVANT * (mois - 1);
  }
  // Amende estimée : reste dû après la limite légale + parts payées après la limite.
  function amendeFactureF(fa) {
    const lim = limiteLegaleFactureF(fa);
    if (!lim) return 0;
    const auj = todayISO();
    let a = 0;
    reglementsDeFacture(fa.id).forEach((x) => { if (x.op.date > lim) a += x.montant * tauxAmende(ecartJours(x.op.date, lim)); });
    const reste = resteFactureF(fa);
    if (reste > 0.01 && auj > lim) a += reste * tauxAmende(ecartJours(auj, lim));
    return arrondiH(a);
  }
  // Jours restants avant la limite légale d'une facture encore due (null si
  // payée, remplacée, sans limite ou déjà dépassée).
  function joursAvantLimiteLegale(fa) {
    if (!fa || fa.type === "devis" || fa.remplaceePar) return null;
    const lim = limiteLegaleFactureF(fa), auj = todayISO();
    if (!lim || auj > lim || resteFactureF(fa) <= 0.01) return null;
    return Math.round(ecartJours(lim, auj));
  }
  function statutFactureF(fa) {
    if (fa.type === "devis") {
      if (fa.remplaceePar) return { code: "remplace", libelle: "remplacé par la facture", couleur: TAUPE };
      const r = reglementsDeFacture(fa.id);
      if (r.length && ecartJours(todayISO(), r[0].op.date) > JOURS_ALERTE_DEVIS) return { code: "devis-retard", libelle: `acompte payé il y a ${Math.round(ecartJours(todayISO(), r[0].op.date))} j — facture à obtenir`, couleur: ROUILLE };
      return { code: "devis", libelle: r.length ? "acompte payé — facture attendue" : "devis / proforma", couleur: OCRE };
    }
    const reste = resteFactureF(fa), auj = todayISO(), ech = echeanceFactureF(fa), lim = limiteLegaleFactureF(fa);
    if (reste <= 0.01) return amendeFactureF(fa) > 0 ? { code: "payee-tard", libelle: "payée hors délai légal", couleur: ROUILLE } : { code: "payee", libelle: "payée", couleur: VERT_OK };
    if (lim && auj > lim) return { code: "legal", libelle: `délai légal dépassé de ${Math.round(ecartJours(auj, lim))} j`, couleur: ROUILLE };
    const jl = lim ? Math.round(ecartJours(lim, auj)) : null;
    const suffixeLegal = jl !== null && jl <= JOURS_ALERTE_LIMITE_LEGALE && lim !== ech ? ` · limite légale ${jl === 0 ? "aujourd'hui" : `dans ${jl} j`}` : "";
    if (ech && auj > ech) return { code: "retard", libelle: `en retard de ${Math.round(ecartJours(auj, ech))} j${suffixeLegal}`, couleur: ROUILLE };
    const j = ech ? Math.round(ecartJours(ech, auj)) : null;
    return { code: j !== null && j <= JOURS_ALERTE_ECHEANCE ? "bientot" : "apayer", libelle: (j === null ? "à payer" : j === 0 ? "échéance aujourd'hui" : `échéance dans ${j} j`) + suffixeLegal, couleur: j !== null && j <= JOURS_ALERTE_ECHEANCE ? OCRE : ENCRE };
  }
  // Nils 28/10 : « Régler » depuis la liste des factures fournisseurs (Gérant) : la fenêtre de sortie de
  // la CFG, avec le fournisseur, la facture et le reste à payer déjà remplis.
  function reglerFactureF(fa) {
    const cfg = compteDe("banque-cfg");
    if (!estGerant || !cfg) return;
    const reste = Math.round(resteFactureF(fa) * 100) / 100;
    setOpEdit({ ...nouvelleOperation(cfg.id, "sortie"), tiersType: fa.tiersType || "fournisseur", tiers: fa.fournisseur, montant: String(reste), reglements: [{ factureId: fa.id, montant: String(reste) }] });
  }
  function nouvelleFactureF(tiersType, fournisseur, type) {
    return { tiersType: tiersType || "fournisseur", fournisseur: fournisseur || "", type: type || "facture", numero: "", date: todayISO(), lignes: [{ taux: 0.2, ttc: "" }], douane: tiersType === "etat" && /douane/i.test(fournisseur || ""), tvaQuittance: "", montantQuittance: "", note: "" };
  }
  async function enregistrerFactureF() {
    if (!factFEdit || !peutSaisirFactureF) return;
    const { _pourOp, ...fa } = factFEdit;
    const existe = !!fa.id && (facturesF || []).some((x) => x.id === fa.id);
    const avant = existe ? (facturesF || []).find((x) => x.id === fa.id) : null;
    if (avant && !(peutControlerFactureF || (avant.parId === user.id && avant.controle !== "contrôlée"))) { setNotice("Cette facture ne peut plus être modifiée que par le Gérant ou l'Administration."); return; }
    if (!fa.fournisseur || !nomsTiers(fa.tiersType).some((n) => normLib(n) === normLib(fa.fournisseur))) { setNotice("Choisis le fournisseur dans la liste."); return; }
    if (!fa.date || fa.date > todayISO()) { setNotice("Date de facture invalide (pas dans le futur)."); return; }
    if (fa.type === "facture" && !(fa.numero || "").trim()) { setNotice("Indique le n° de la facture."); return; }
    if (fa.type === "facture" && fa.tiersType === "fournisseur" && !fa.confirmeBL) { setNotice("Coche la confirmation : la facture correspond bien au bon de livraison."); return; }
    if (!existe && !(await confirmerFournisseurBlackliste(fa.fournisseur, fa.type === "devis" ? "un devis / proforma" : "une facture"))) return;
    const num = (v) => Number(String(v ?? "").replace(/\s/g, "").replace(",", "."));
    let propre;
    if (fa.douane) {
      const tva = num(fa.tvaQuittance), tot = num(fa.montantQuittance);
      if (!isFinite(tot) || tot <= 0) { setNotice("Indique le montant total de la quittance."); return; }
      if (!isFinite(tva) || tva < 0 || tva * 6 > tot + 0.01) { setNotice("TVA de la quittance invalide ou trop élevée par rapport au total."); return; }
      propre = { ...fa, tvaQuittance: tva, montantQuittance: tot, lignes: [] };
    } else {
      const lignes = (fa.lignes || []).map((l) => ({ taux: Number(l.taux), ttc: num(l.ttc) })).filter((l) => l.ttc);
      if (!lignes.length || lignes.some((l) => !isFinite(l.ttc) || l.ttc <= 0)) { setNotice("Indique le TTC (une ligne par taux de TVA)."); return; }
      propre = { ...fa, lignes, tvaQuittance: undefined, montantQuittance: undefined };
    }
    if (existe && ttcFactureF(propre) + 0.01 < regleFactureF(propre.id)) { setNotice("Le TTC ne peut pas être inférieur à ce qui a déjà été payé."); return; }
    const doublon = (facturesF || []).find((x) => x.id !== propre.id && x.type === "facture" && propre.type === "facture" && normLib(x.fournisseur) === normLib(propre.fournisseur) && normLib(x.numero) === normLib(propre.numero));
    if (doublon) { setNotice(`La facture ${propre.numero} de ${propre.fournisseur} est déjà enregistrée.`); return; }
    const maintenant = new Date().toISOString();
    const blNouveau = propre.confirmeBL && !(avant && avant.confirmeBL);
    const final = { ...propre, ...(blNouveau ? { confirmeBLPar: user.nom, confirmeBLLe: new Date().toISOString() } : {}), numero: (propre.numero || "").trim(), note: (propre.note || "").trim(), ...(existe ? { modifiePar: user.nom, modifieLe: maintenant } : { id: propre.id || uid(), par: user.nom, parId: user.id, le: maintenant, controle: peutControlerFactureF ? "contrôlée" : "à contrôler", ...(peutControlerFactureF ? { controlePar: user.nom, controleLe: maintenant } : {}) }) };
    let next = existe ? (facturesF || []).map((x) => (x.id === final.id ? final : x)) : [...(facturesF || []), final];
    // Facture qui remplace un devis / proforma : les acomptes passent sur la facture.
    if (!existe && final.remplace) {
      next = next.map((x) => (x.id === final.remplace ? { ...x, remplaceePar: final.id } : x));
      if ((operations || []).some((o) => (o.reglements || []).some((r) => r.factureId === final.remplace))) await persistOperations((operations || []).map((o) => ((o.reglements || []).some((r) => r.factureId === final.remplace) ? { ...o, reglements: o.reglements.map((r) => (r.factureId === final.remplace ? { ...r, factureId: final.id } : r)) } : o)));
    }
    await persistFacturesF(next);
    await tracerAcces(existe ? "facture fournisseur modifiée" : "facture fournisseur saisie", `${final.type === "devis" ? "Devis/proforma" : "Facture"} ${final.numero || "sans n°"} — ${final.fournisseur} — ${formatDate(final.date)} — ${formatDH(ttcFactureF(final))}${final.remplace ? " (remplace un devis)" : ""}`);
    const dl = final.tiersType === "fournisseur" ? delaiFournisseur(final.fournisseur) : null;
    if (!existe && dl && dl.depasse) await alerter("Conditions de paiement au-delà de la loi", `${final.fournisseur} : « ${dl.condition} » dépasse ${dl.max} j — échéance ramenée à ${dl.max} j pour la facture ${final.numero}`, { kind: "onglet", id: "facturesF" });
    if (_pourOp && opEdit) {
      const parts = opEdit.reglements || [];
      setOpEdit({ ...opEdit, reglements: [...parts, { factureId: final.id, montant: String(resteFactureF(final)) }], ...(String(opEdit.montant) === "" && !parts.length ? { montant: String(ttcFactureF(final)) } : {}) });
    }
    setFactFEdit(null);
  }
  // Nils 30/10 : pièces jointes d'une facture fournisseur (factures et BL du fournisseur). Le fichier
  // part tout de suite au serveur ; il n'est rattaché qu'à l'enregistrement de la facture.
  const [depotPieceF, setDepotPieceF] = useState("");
  async function joindrePiecesFactureF(nature, files) {
    if (!factFEdit) return;
    if (!window.storage || !window.storage.deposerFichier) { setNotice("Le dépôt de fichiers n'est possible qu'avec l'ERP sur son serveur."); return; }
    const element = factFEdit.id || uid();
    const ajouts = [];
    setDepotPieceF(nature);
    try {
      for (const file of files) {
        if (!EXTENSIONS_FICHIERS.includes(extensionFichier(file.name))) { setNotice(`« ${file.name} » : type de fichier non accepté. Acceptés : ${TYPES_FICHIERS_LISIBLES}.`); continue; }
        if (file.size > TAILLE_MAX_FICHIER) { setNotice(`« ${file.name} » (${formatTaille(file.size)}) dépasse la limite de 25 Mo.`); continue; }
        const r = await window.storage.deposerFichier(null, file, { cle: FACTURES_FOURNISSEURS_KEY, element });
        if (r.erreur) { setNotice(r.erreur); continue; }
        ajouts.push({ ...r.fichier, nature, par: user.nom, le: new Date().toISOString() });
      }
    } finally {
      setDepotPieceF("");
    }
    if (ajouts.length) setFactFEdit((prev) => (prev ? { ...prev, id: prev.id || element, piecesJointes: [...(prev.piecesJointes || []), ...ajouts] } : prev));
  }
  async function supprimerFactureF(id) {
    const fa = (facturesF || []).find((x) => x.id === id);
    if (!fa) return;
    if (!(peutControlerFactureF || (fa.parId === user.id && fa.controle !== "contrôlée"))) return;
    if (reglementsDeFacture(id).length) { setNotice("Impossible : des paiements sont rattachés à cette facture."); return; }
    if (!await demander(`Supprimer ${fa.type === "devis" ? "le devis" : "la facture"} ${fa.numero || ""} de ${fa.fournisseur} ?`)) return;
    await persistFacturesF((facturesF || []).filter((x) => x.id !== id).map((x) => (x.remplaceePar === id ? { ...x, remplaceePar: undefined } : x)));
    await tracerAcces("facture fournisseur supprimée", `${fa.numero || "sans n°"} — ${fa.fournisseur} — ${formatDH(ttcFactureF(fa))}`);
    setFactFEdit(null);
  }
  async function controlerFactureF(id) {
    if (!peutControlerFactureF) return;
    const fa = (facturesF || []).find((x) => x.id === id);
    if (!fa) return;
    await persistFacturesF((facturesF || []).map((x) => (x.id === id ? { ...x, controle: "contrôlée", controlePar: user.nom, controleLe: new Date().toISOString() } : x)));
    await tracerAcces("facture fournisseur contrôlée", `${fa.numero || "sans n°"} — ${fa.fournisseur} — saisie par ${fa.par}`);
    setFactFEdit(null);
  }
  // ---- Clôture mensuelle des comptes (Nils 01/10) ----
  function clotureDepuis() {
    return (parametres && parametres.clotureDepuis) || CLOTURE_DEPUIS_DEFAUT;
  }
  function clotureDe(compteId, mois) {
    const c = compteDe(compteId);
    return ((c && c.clotures) || []).find((x) => x.mois === mois) || null;
  }
  function moisVerrouille(compteId, date) {
    const cl = date ? clotureDe(compteId, String(date).slice(0, 7)) : null;
    return !!cl && cl.statut === "validée";
  }
  function moisAvant(ym) {
    const [y, m] = ym.split("-").map(Number);
    return m === 1 ? `${y - 1}-12` : `${y}-${String(m - 1).padStart(2, "0")}`;
  }
  // Mois terminés à clôturer pour un compte (depuis le début du suivi).
  function moisACloturer(c) {
    const fin = moisAvant(todayISO().slice(0, 7));
    const debut = [clotureDepuis(), (c.dateOuverture || "").slice(0, 7)].sort().reverse()[0] || clotureDepuis();
    const l = [];
    for (let m = fin; m >= debut; m = moisAvant(m)) l.push(m);
    return l.reverse();
  }
  async function ecrireClotures(compteId, f) {
    await persistComptesTreso((comptesTreso || []).map((x) => (x.id === compteId ? { ...x, clotures: f((x.clotures || []).slice()) } : x)));
  }
  async function demanderCloture(compteId, mois) {
    const c = compteDe(compteId);
    const fmtC = (n) => fmtCompte(c, n);
    if (!c || !peutSaisirCompte(c)) return;
    const fin = finDeMois(mois);
    if (fin >= todayISO()) { setNotice("Un mois ne se clôture qu'une fois terminé."); return; }
    const deja = clotureDe(compteId, mois);
    if (deja && (deja.statut === "validée" || deja.statut === "demandée")) return;
    const attente = (operations || []).filter((o) => o.compteId === compteId && o.type === "transfert" && o.sens === "entree" && o.statutTransfert === "en attente" && o.date <= fin);
    if (attente.length) { setNotice(`Confirme d'abord ${attente.length} transfert(s) reçu(s) en attente sur ${c.nom}.`); return; }
    const soldeERP = arrondiH(soldeCompteVue(compteId, decalerJours(fin, 1)));
    const k = `${compteId}|${mois}`;
    const form = clotureForm[k] || {};
    let reel;
    if (c.type === "banque") {
      const r = calculRapprochement(compteId, `${mois}-01`, fin);
      if (!r.releve) { setNotice(`Enregistre d'abord le solde du relevé au ${formatDate(fin)} (Pointage du relevé).`); return; }
      if (Math.abs(r.ecart) > 0.01) { setNotice(`Le rapprochement bancaire au ${formatDate(fin)} présente un écart de ${fmtC(r.ecart)} : à régler avant la clôture.`); return; }
      reel = soldeERP;
    } else {
      reel = Number(String(form.reel ?? "").replace(/\s/g, "").replace(",", "."));
      if (form.reel === undefined || form.reel === "" || !isFinite(reel)) { setNotice("Indique l'argent réellement compté dans la caisse au dernier jour du mois."); return; }
    }
    const ecart = arrondiH(reel - soldeERP);
    if (Math.abs(ecart) > 0.01 && !(form.explication || "").trim()) { setNotice(`Écart de ${fmtC(ecart)} : explique-le avant d'envoyer la demande.`); return; }
    const maintenant = new Date().toISOString();
    // Nils 16/10 (T4) : sa propre caisse, sans écart, est validée d'office (pas de validation par l'Administration).
    if (estGerant && compteTenuParGerantSeul(c) && Math.abs(ecart) <= 0.01) {
      await ecrireClotures(compteId, (l) => [...l.filter((x) => x.mois !== mois), { mois, statut: "validée", soldeReel: reel, soldeERP, ecart, explication: (form.explication || "").trim(), demandePar: user.nom, demandeParId: user.id, demandeLe: maintenant, validePar: user.nom, valideLe: maintenant, opEcartId: "", historique: [...((deja && deja.historique) || [])] }]);
      await tracerAcces("clôture validée", `${c.nom} — ${libMois(mois)} — compté ${fmtC(reel)}, sans écart (compte tenu par le Gérant)`);
      setClotureForm({ ...clotureForm, [k]: {} });
      setNotice(`Clôture de ${libMois(mois)} validée pour ${c.nom}.`);
      return;
    }
    await ecrireClotures(compteId, (l) => [...l.filter((x) => x.mois !== mois), { mois, statut: "demandée", soldeReel: reel, soldeERP, ecart, explication: (form.explication || "").trim(), demandePar: user.nom, demandeParId: user.id, demandeLe: maintenant, historique: [...((deja && deja.historique) || []), ...(deja ? [{ statut: deja.statut, par: deja.validePar || deja.refusePar || "", le: deja.valideLe || deja.refuseLe || "", motif: deja.motifRefus || "" }] : [])] }]);
    await tracerAcces("clôture demandée", `${c.nom} — ${libMois(mois)} — compté ${fmtC(reel)}, ERP ${fmtC(soldeERP)}${ecart ? `, écart ${fmtC(ecart)} (${(form.explication || "").trim()})` : ""}`);
    if (Math.abs(ecart) > 0.01) await alerter("Clôture de caisse : écart", `${c.nom} — ${libMois(mois)} : compté ${fmtC(reel)}, ERP ${fmtC(soldeERP)} — écart ${fmtC(ecart)} — « ${(form.explication || "").trim()} » (par ${user.nom})`, { kind: "onglet", id: "compta" });
    setClotureForm({ ...clotureForm, [k]: {} });
    setNotice(`Demande de clôture de ${libMois(mois)} envoyée pour ${c.nom} — l'Administration la valide.`);
  }
  async function validerCloture(compteId, mois) {
    const c = compteDe(compteId), cl = clotureDe(compteId, mois);
    const fmtC = (n) => fmtCompte(c, n);
    if (!c || !cl || cl.statut !== "demandée" || !peut("compta.cloture.valider")) return;
    if (cl.demandeParId === user.id && !estGerant) { setNotice("Tu ne peux pas valider ta propre demande de clôture : Le Gérant la valide."); return; }
    const fin = finDeMois(mois);
    const soldeERP = arrondiH(soldeCompteVue(compteId, decalerJours(fin, 1)));
    const ecart = arrondiH(cl.soldeReel - soldeERP);
    if (Math.abs(soldeERP - cl.soldeERP) > 0.01 && !await demander(`Des opérations de ${libMois(mois)} ont changé depuis la demande : solde ERP ${fmtC(soldeERP)} (au lieu de ${fmtC(cl.soldeERP)}), écart ${fmtC(ecart)}. Valider quand même ?`)) return;
    const maintenant = new Date().toISOString();
    let opEcartId = "";
    if (Math.abs(ecart) > 0.01) {
      const plan = planPostes();
      if (!plan.find((p) => p.poste === "Opérations exceptionnelles" && p.sous.includes(SOUS_POSTE_ECART_CAISSE))) await persistParametres({ ...(parametres || {}), planPostes: plan.map((p) => (p.poste === "Opérations exceptionnelles" ? { ...p, sous: [...p.sous, SOUS_POSTE_ECART_CAISSE] } : p)) });
      opEcartId = uid();
      const tauxE = estCompteDevises(c) ? tauxMoyenDevises(compteId, fin) || 0 : 0;
      await persistOperations([...(operations || []), { id: opEcartId, compteId, date: fin, sens: ecart > 0 ? "entree" : "sortie", montant: estCompteDevises(c) ? Math.round(Math.abs(ecart) * tauxE * 100) / 100 : Math.abs(ecart), ...(estCompteDevises(c) ? { montantDevise: Math.abs(ecart), devise: c.devise } : {}), tiersType: "", tiers: "", designation: `Écart de caisse — clôture ${libMois(mois)}${cl.explication ? ` (${cl.explication})` : ""}`, poste: "Opérations exceptionnelles", sousPoste: SOUS_POSTE_ECART_CAISSE, mode: "Espèces", piece: "", dossierId: "", type: "ecart-cloture", par: user.nom, le: maintenant }]);
    }
    await ecrireClotures(compteId, (l) => l.map((x) => (x.mois === mois ? { ...x, statut: "validée", soldeERP, ecart, validePar: user.nom, valideLe: maintenant, opEcartId } : x)));
    await tracerAcces("clôture validée", `${c.nom} — ${libMois(mois)} — solde ${fmtC(cl.soldeReel)}${Math.abs(ecart) > 0.01 ? ` — écart ${fmtC(ecart)} passé en « ${SOUS_POSTE_ECART_CAISSE} »` : ""} — mois verrouillé`);
    setNotice(`${c.nom} : ${libMois(mois)} clôturé et verrouillé.`);
  }
  async function refuserCloture() {
    const r = refusCloture;
    if (!r || !peut("compta.cloture.valider")) return;
    const c = compteDe(r.compteId);
    if (!(r.motif || "").trim()) { setNotice("Indique le motif du refus."); return; }
    { const clR = clotureDe(r.compteId, r.mois); if (clR && clR.demandeParId === user.id && !estGerant) { setNotice("Tu ne peux pas traiter ta propre demande de clôture : Le Gérant s'en charge."); return; } }
    await ecrireClotures(r.compteId, (l) => l.map((x) => (x.mois === r.mois ? { ...x, statut: "refusée", refusePar: user.nom, refuseLe: new Date().toISOString(), motifRefus: r.motif.trim() } : x)));
    await tracerAcces("clôture refusée", `${c ? c.nom : ""} — ${libMois(r.mois)} — ${r.motif.trim()}`);
    setRefusCloture(null);
  }
  async function rouvrirCloture(compteId, mois) {
    if (!peut("compta.cloture.rouvrir")) return;
    const c = compteDe(compteId), cl = clotureDe(compteId, mois);
    if (!cl || cl.statut !== "validée") return;
    const motif = await demander(`Rouvrir ${libMois(mois)} sur ${c.nom} — motif ?`, { saisie: true });
    if (!motif || !motif.trim()) return;
    await ecrireClotures(compteId, (l) => l.map((x) => (x.mois === mois ? { ...x, statut: "rouverte", rouvertPar: user.nom, rouvertLe: new Date().toISOString(), motifReouverture: motif.trim(), historique: [...(x.historique || []), { statut: "validée", par: x.validePar, le: x.valideLe }] } : x)));
    await tracerAcces("clôture rouverte", `${c.nom} — ${libMois(mois)} — ${motif.trim()}${cl.opEcartId ? " (l'opération d'écart reste en place : à supprimer si besoin)" : ""}`);
  }
  // ---- Chèques / effets reçus à échéance (Nils 01/10) : en portefeuille jusqu'à leur date. ----
  // Nils 03/10 : date prévue d'encaissement (facultative) ; à défaut, la date du chèque.
  function dateEncaissementCheque(o) {
    return o.encaissementPrevu || o.echeanceCheque || "";
  }
  function chequesEnPortefeuille() {
    return chequesEnMain().filter((o) => !o.sansVisibilite).sort((a, b) => (dateEncaissementCheque(a) < dateEncaissementCheque(b) ? -1 : 1));
  }
  async function majEncaissementPrevu(opId, date) {
    const o = (operations || []).find((x) => x.id === opId);
    if (!o || o.compteId !== PORTEFEUILLE_ID || o.chequeRemisLe) return;
    if (!(estGerant || user.profil === P_ADMIN || detenteurCheque(o) === user.id)) return;
    if (date && o.echeanceCheque && date < o.echeanceCheque) { setNotice(`Le chèque est daté du ${formatDate(o.echeanceCheque)} : il ne peut pas être encaissé avant.`); return; }
    if (date && o.echeanceCheque && date > expirationCheque(o.echeanceCheque)) { setNotice(`Le chèque n'est valable que jusqu'au ${formatDate(expirationCheque(o.echeanceCheque))}.`); return; }
    await persistOperations((operations || []).map((x) => (x.id === opId ? { ...x, encaissementPrevu: date || undefined, ...(date ? { sansVisibilite: undefined } : {}) } : x)));
    await tracerAcces("chèque : date prévue d'encaissement", `${o.mode} ${o.piece || ""} de ${o.tiers || "?"} — ${formatDH(Number(o.montant))} : ${date ? formatDate(date) : "retirée (date du chèque)"}`);
  }
  // Chèques / effets encore en main (portefeuille : pas déposés, pas impayés).
  function chequesEnMain() {
    return (operations || []).filter((o) => o.compteId === PORTEFEUILLE_ID && o.sens === "entree" && !o.extourneDe && !o.chequeRemisLe && !o.impaye);
  }
  // Dépôt à la CFG : crée l'entrée à la CFG (en attente de passage sur le relevé) ;
  // c'est son pointage qui la fait entrer dans le fichier TVA (Nils 03/10).
  async function deposerCheque(opId, date) {
    const o = (operations || []).find((x) => x.id === opId);
    if (!o || o.compteId !== PORTEFEUILLE_ID || o.chequeRemisLe) return;
    if (!(estGerant || user.profil === P_ADMIN || detenteurCheque(o) === user.id)) { setNotice("Seul le détenteur du chèque (ou le Gérant / l'Administration) le dépose."); return; }
    const d = date || todayISO();
    const maintenant = new Date().toISOString();
    const depot = { id: uid(), compteId: "banque-cfg", date: d, sens: "entree", montant: Number(o.montant) || 0, type: "normal", tiersType: o.tiersType || "client", tiers: o.tiers || "", designation: `Remise ${o.mode === "Chèque" ? "chèque" : "effet"} ${o.piece || ""} — ${o.tiers || ""}`.trim(), poste: "Remise de chèques", sousPoste: o.mode, mode: o.mode, piece: o.piece || "", depotDe: o.id, par: user.nom, le: maintenant };
    await persistOperations([...(operations || []).map((x) => (x.id === o.id ? { ...x, chequeRemisLe: d, chequeRemisPar: user.nom, depotId: depot.id } : x)), depot]);
    if (opEdit && opEdit.id === o.id) setOpEdit(null);
    await tracerAcces("chèque déposé à la CFG", `${o.mode} ${o.piece || ""} de ${o.tiers || "?"} — ${formatDH(Number(o.montant))}`);
    setNotice("Chèque déposé : il apparaît à la CFG en attente de passage sur le relevé.");
  }
  function expirationCheque(dateCheque) {
    if (!dateCheque) return "";
    const d = new Date(`${dateCheque}T12:00:00Z`); d.setUTCFullYear(d.getUTCFullYear() + 1);
    return d.toISOString().slice(0, 10);
  }
  function detenteurCheque(o) {
    if (o.detenteur) return o.detenteur;
    const c = compteDe(o.compteId);
    return (c && (c.responsables || [])[0]) || "";
  }
  function nomUtilisateur(id) {
    return ((utilisateurs || []).find((u) => u.id === id) || {}).nom || "";
  }
  async function passerCheque(opId, aId) {
    const o = (operations || []).find((x) => x.id === opId);
    if (!o || !aId) return;
    const prop = { id: aId, par: user.nom, parId: user.id, le: new Date().toISOString() };
    await persistOperations((operations || []).map((x) => (x.id === opId ? { ...x, detenteurPropose: prop } : x)));
    if (opEdit && opEdit.id === opId) setOpEdit({ ...opEdit, detenteurPropose: prop, _passerA: "" });
    await tracerAcces("chèque passé", `${o.mode} ${o.piece || ""} de ${o.tiers || "?"} — ${formatDH(Number(o.montant))} : ${nomUtilisateur(detenteurCheque(o))} → ${nomUtilisateur(aId)} (à confirmer)`);
    setNotice(`${nomUtilisateur(aId)} doit confirmer la réception du chèque (tâche).`);
  }
  async function confirmerReceptionCheque(opId) {
    const o = (operations || []).find((x) => x.id === opId);
    if (!o || !o.detenteurPropose || (o.detenteurPropose.id !== user.id && !estGerant)) return;
    const histo = [...(o.historiqueDetenteurs || []), { de: detenteurCheque(o), a: o.detenteurPropose.id, par: o.detenteurPropose.par, le: o.detenteurPropose.le, confirmeLe: new Date().toISOString(), confirmePar: user.nom }];
    await persistOperations((operations || []).map((x) => (x.id === opId ? { ...x, detenteur: o.detenteurPropose.id, detenteurPropose: null, historiqueDetenteurs: histo } : x)));
    await tracerAcces("chèque reçu", `${o.mode} ${o.piece || ""} de ${o.tiers || "?"} — ${formatDH(Number(o.montant))} : désormais détenu par ${nomUtilisateur(o.detenteurPropose.id)}`);
  }
  async function marquerChequeRemis(opId) {
    const o0 = (operations || []).find((x) => x.id === opId);
    if (o0 && o0.compteId === PORTEFEUILLE_ID) return deposerCheque(opId, todayISO());
    const o = (operations || []).find((x) => x.id === opId);
    if (!o || !peutSaisirCompte(compteDe(o.compteId))) return;
    await persistOperations((operations || []).map((x) => (x.id === opId ? { ...x, chequeRemisLe: todayISO(), chequeRemisPar: user.nom } : x)));
    await tracerAcces("chèque remis en banque", `${(compteDe(o.compteId) || {}).nom} — ${o.mode} ${o.piece || ""} — ${formatDH(Number(o.montant))} — ${o.tiers || ""}`);
  }
  // ---- Tableau de bord trésorerie (Nils) ----
  // ---- Caisse générale : copies liées (Nils 03/10) ----
  function caisseGeneraleActive() {
    const cg = compteDe(CAISSE_GENERALE_ID);
    return !!cg && ((Number(cg.soldeOuverture) || 0) !== 0 || (operations || []).some((o) => o.compteId === CAISSE_GENERALE_ID));
  }
  function miroirsCaisseGenerale(ops) {
    const res = [];
    (ops || []).forEach((o) => {
      if (o.miroirDe || o.compteId === CAISSE_GENERALE_ID) return;
      const cpt = compteDe(o.compteId);
      if (!cpt) return;
      const base = { id: `cg-${o.id}`, miroirDe: o.id, compteId: CAISSE_GENERALE_ID, date: o.date, type: "normal", tiersType: o.tiersType || "", tiers: o.tiers || "", mode: "Espèces", par: "copie auto", le: o.le || "" };
      // Retrait d'espèces CFG fait pour la caisse générale → entrée.
      if (o.type === "transfert" && o.sens === "sortie" && o.pourCaisseGenerale) {
        res.push({ ...base, sens: "entree", montant: Number(o.montant) || 0, poste: "Transfert", sousPoste: "Retrait d'espèces CFG", designation: `Retrait d'espèces CFG${o.designation && o.designation !== "Retrait d'espèces pour la caisse générale" ? " — " + o.designation : ""}`, piece: o.piece || "" });
        return;
      }
      if (cpt.type === "banque" || estCompteDevises(cpt) || o.mode !== "Espèces" || o.type !== "normal") return;
      // Dépense en espèces avec justificatif (facture) → sortie.
      if (o.sens === "sortie" && (o.factureFournisseur || (o.reglements || []).length)) {
        const num = o.factureFournisseur ? o.factureFournisseur.numero : (o.reglements || []).map((r) => ((facturesF || []).find((f) => f.id === r.factureId) || {}).numero).filter(Boolean).join(", ");
        res.push({ ...base, sens: "sortie", montant: Number(o.montant) || 0, poste: o.poste || "", sousPoste: o.sousPoste || "", designation: `${o.designation || ""} — copie auto (${cpt.nom})`, piece: num ? `fact. ${num}` : "" });
        return;
      }
      // Step 17 : remboursement d'un avoir non exo en espèces → sortie.
      if (o.avoirId) {
        const a = (avoirs || []).find((x) => x.id === o.avoirId);
        if (a && !a.exo && o.sens === "sortie") res.push({ ...base, sens: "sortie", montant: Number(o.montant) || 0, poste: o.poste, sousPoste: o.sousPoste || "", designation: `${o.designation || ""} — copie auto (${cpt.nom})`, piece: a.numero });
        return;
      }
      // Encaissement en espèces relié à une facture non exo → entrée (part des factures non exo).
      if (o.sens === "entree" && o.poste === POSTE_ENCAISSEMENT) {
        const parts = partsDossiers(o).filter((x) => { const c = dossierParId(x.dossierId); return c && (c.anterieure || c.statut === "Facture") && !exoDossier(c); });
        const m = Math.round(parts.reduce((n, x) => n + x.montant, 0) * 100) / 100;
        if (m > 0) res.push({ ...base, sens: "entree", montant: m, poste: o.poste, sousPoste: o.sousPoste || "", designation: `${o.designation || ""} — copie auto (${cpt.nom})`, piece: parts.map((x) => (dossierParId(x.dossierId) || {}).numeroFacture).filter(Boolean).join(", ") });
      }
    });
    return res;
  }
  function encaissementsAttendus() {
    const auj = todayISO();
    return tousDossiers().filter((c) => ["Facture", "BL"].includes(c.statut)).map((c) => {
      const reste = arrondiH(totalDossierTTC(c) - encaisseDossier(c.id));
      if (reste <= 0.01) return null;
      const cl = clientDe(c.clientId) || {};
      const base = (c.dateFacture || c.dateBL || c.creeLe || auj).slice(0, 10);
      const prevu = echeanceCondition(base, cl.paiement, 30);
      return { c, reste, prevu, retard: prevu < auj };
    }).filter(Boolean).sort((a, b) => (a.prevu < b.prevu ? -1 : 1));
  }
  // ---- Rapprochement bancaire (Nils 01/10) ----
  // Chaque opération de la banque se pointe « vue sur le relevé » avec sa date
  // de passage (releveLe). État au jour J : solde du relevé + sorties pas
  // encore débitées − entrées pas encore créditées = solde de l'ERP.
  function estPointee(o, fin) {
    return !!o.releveLe && o.releveLe <= fin;
  }
  function calculRapprochement(compteId, du, au) {
    const ops = (operations || []).filter((o) => o.compteId === compteId && opCompte(o) && o.date <= au).sort((a, b) => (a.date === b.date ? ((a.le || "") < (b.le || "") ? -1 : 1) : a.date < b.date ? -1 : 1));
    const m = (o) => Math.abs(montantEffectif(o));
    const soldeERP = soldeCompteAu(compteId, decalerJours(au, 1));
    const nonPointees = ops.filter((o) => !estPointee(o, au));
    const sortiesNP = nonPointees.filter((o) => o.sens === "sortie"), entreesNP = nonPointees.filter((o) => o.sens === "entree");
    const totSortiesNP = sortiesNP.reduce((n, o) => n + m(o), 0), totEntreesNP = entreesNP.reduce((n, o) => n + m(o), 0);
    const pointeesPeriode = ops.filter((o) => estPointee(o, au) && o.releveLe >= du);
    const compte = compteDe(compteId);
    const releve = ((compte && compte.releves) || []).find((r) => r.date === au);
    const soldeTheorique = arrondiH(soldeERP + totSortiesNP - totEntreesNP);
    return { ops, soldeERP, sortiesNP, entreesNP, totSortiesNP, totEntreesNP, pointeesPeriode, soldeTheorique, releve, ecart: releve ? arrondiH(Number(releve.solde) - soldeTheorique) : null, m };
  }
  // Nils 03/10 : pointage du relevé — date de passage et, si besoin, montant corrigé (alerte à Nils).
  async function pointerOperation(opId, releveLe, montantSaisi) {
    const o = (operations || []).find((x) => x.id === opId);
    if (!o || !peutSaisirCompte(compteDe(o.compteId))) return false;
    let patch = { releveLe: releveLe || undefined, pointePar: releveLe ? user.nom : undefined, pointeLe: releveLe ? new Date().toISOString() : undefined };
    let corrige = null;
    if (releveLe && montantSaisi !== undefined && montantSaisi !== null && String(montantSaisi).trim() !== "") {
      const v = parseMontantSaisi(montantSaisi);
      if (!isFinite(v) || v <= 0) { setNotice("Montant du relevé invalide."); return false; }
      if (Math.abs(v - Number(o.montant)) > 0.009) {
        if (Array.isArray(o.repartition) && o.repartition.length > 1) { setNotice("Cette opération est répartie sur plusieurs factures : corrige d'abord la répartition dans la fiche de l'opération."); return false; }
        if ((o.reglements || []).length > 1) { setNotice("Cette sortie règle plusieurs factures : corrige d'abord les règlements dans la fiche de l'opération."); return false; }
        corrige = { avant: Number(o.montant), apres: v };
        patch = { ...patch, montant: v, montantSaisi: Number(o.montant), ...((o.reglements || []).length === 1 && v < Number(o.reglements[0].montant) ? { reglements: [{ ...o.reglements[0], montant: v }] } : {}) };
      }
    }
    await persistOperations((operations || []).map((x) => (x.id === opId ? { ...x, ...patch } : x)));
    if (corrige) {
      await tracerAcces("montant corrigé au pointage", `${(compteDe(o.compteId) || {}).nom} — ${o.designation} : ${formatDH(corrige.avant)} → ${formatDH(corrige.apres)}`);
      if (!estGerant) await alerter("Montant corrigé au pointage du relevé", `${(compteDe(o.compteId) || {}).nom} — ${formatDate(o.date)} — ${o.designation} : saisi ${formatDH(corrige.avant)}, relevé ${formatDH(corrige.apres)} (par ${user.nom})`, { kind: "onglet", id: "compta" });
    }
    return true;
  }
  function soldeBanqueAu(compteId, au) {
    const c = compteDe(compteId);
    return arrondiH((Number(c && c.soldeOuverture) || 0) + (operations || []).filter((o) => o.compteId === compteId && opCompte(o) && o.releveLe && o.releveLe <= au).reduce((n, o) => n + montantEffectif(o), 0));
  }
  function opsNonPassees(compteId) {
    return (operations || []).filter((o) => o.compteId === compteId && opCompte(o) && !o.releveLe);
  }
  // Paiement rejeté (chèque, effet, prélèvement…) : extourne = même montant en sens inverse,
  // mêmes liens (la facture redevient due). Alerte à Nils ; tâche au commercial.
  async function rejeterOperation(opId) {
    const o = (operations || []).find((x) => x.id === opId);
    if (!o || o.rejete || o.extourneDe || !peutSaisirCompte(compteDe(o.compteId))) return;
    const motif = await demander(`Paiement rejeté : ${o.designation} — ${formatDH(Number(o.montant))}.\nUne extourne (même montant, sens inverse) sera créée et ${o.poste === POSTE_ENCAISSEMENT ? "la facture redeviendra due" : "les liens seront annulés"}.\n\nMotif (impayé, provision insuffisante…) :`, { saisie: true });
    if (motif === null) return;
    const maintenant = new Date().toISOString();
    const ext = { ...o, id: uid(), date: todayISO(), sens: o.sens === "entree" ? "sortie" : "entree", designation: `Extourne — rejet : ${o.designation}`, extourneDe: o.id, releveLe: undefined, pointePar: undefined, pointeLe: undefined, rejete: undefined, par: user.nom, le: maintenant, modifiePar: undefined, modifieLe: undefined };
    delete ext.montantSaisi;
    // Chèque déposé et rejeté : il revient « impayé » au portefeuille et la facture redevient due.
    const cheque = o.depotDe ? (operations || []).find((x) => x.id === o.depotDe) : null;
    const extCheque = cheque ? { ...cheque, id: uid(), date: todayISO(), sens: "sortie", designation: `Chèque impayé — ${cheque.designation}`, extourneDe: cheque.id, chequeRemisLe: undefined, depotId: undefined, detenteurPropose: undefined, par: user.nom, le: maintenant } : null;
    await persistOperations([...(operations || []).map((x) => (x.id === o.id ? { ...x, rejete: { le: maintenant, par: user.nom, motif: motif || "", extourneId: ext.id } } : cheque && x.id === cheque.id ? { ...x, impaye: { le: maintenant, motif: motif || "", par: user.nom } } : x)), ext, ...(extCheque ? [extCheque] : [])]);
    await tracerAcces("paiement rejeté", `${(compteDe(o.compteId) || {}).nom} — ${o.designation} — ${formatDH(Number(o.montant))}${motif ? ` (${motif})` : ""}`);
    await alerter("Paiement rejeté", `${o.tiers || ""} — ${o.designation} — ${formatDH(Number(o.montant))}${motif ? ` : ${motif}` : ""} (extourne créée par ${user.nom})`, { kind: "onglet", id: "compta" });
    setNotice("Extourne créée : à pointer quand elle apparaît sur le relevé.");
  }
  async function marquerRejetTraite(opId) {
    await persistOperations((operations || []).map((x) => (x.id === opId && x.rejete ? { ...x, rejete: { ...x.rejete, traiteLe: new Date().toISOString(), traitePar: user.nom } } : x)));
  }
  async function enregistrerSoldeReleve(compteId, date, solde) {
    const c = compteDe(compteId);
    if (!c || !peutSaisirCompte(c)) return;
    const v = parseMontantSaisi(solde);
    if (!date || !isFinite(v)) { setNotice("Indique la date et le solde du relevé (ex. 1 250 000,50)."); return false; }
    const releves = [...(c.releves || []).filter((r) => r.date !== date), { date, solde: v, par: user.nom, le: new Date().toISOString() }].sort((a, b) => (a.date < b.date ? -1 : 1));
    await persistComptesTreso((comptesTreso || []).map((x) => (x.id === compteId ? { ...x, releves } : x)));
    await tracerAcces("solde de relevé bancaire", `${c.nom} — relevé au ${formatDate(date)} : ${formatDH(v)}`);
    const r = calculRapprochement(compteId, date, date);
    const ecart = arrondiH(v - r.soldeTheorique);
    setNotice(`Solde du relevé au ${formatDate(date)} enregistré : ${formatDH(v)}.`);
    if (Math.abs(ecart) > 0.01) await alerter("Rapprochement bancaire : écart", `${c.nom} au ${formatDate(date)} : relevé ${formatDH(v)}, solde attendu d'après l'ERP ${formatDH(r.soldeTheorique)} — écart ${formatDH(ecart)} (par ${user.nom})`, { kind: "onglet", id: "compta" });
  }
  function imprimerRapprochement(compteId, du, au) {
    const c = compteDe(compteId);
    const r = calculRapprochement(compteId, du, au);
    const e = (x) => String(x ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;");
    const ligne = (o) => `<tr><td>${e(formatDate(o.date))}</td><td>${e(o.designation)}</td><td>${e(o.tiers || "")}</td><td>${e(o.mode || "")}</td><td>${e(o.piece || "")}</td><td class="n">${e(formatDH(r.m(o)))}</td></tr>`;
    const tableOps = (titre, liste, total) => `<h2>${titre} (${liste.length})</h2>${liste.length ? `<table><tr><th>Date</th><th>Désignation</th><th>Tiers</th><th>Mode</th><th>Réf. paiement</th><th class="n">Montant</th></tr>${liste.map(ligne).join("")}<tr><td colspan="5" style="text-align:right"><strong>Total</strong></td><td class="n"><strong>${e(formatDH(total))}</strong></td></tr></table>` : `<p class="petit">Aucune.</p>`}`;
    const debitsP = r.pointeesPeriode.filter((o) => o.sens === "sortie"), creditsP = r.pointeesPeriode.filter((o) => o.sens === "entree");
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>État de rapprochement bancaire</title><style>
body{font-family:Arial,sans-serif;font-size:12px;margin:28px;color:#222}h1{font-size:17px;margin:0 0 4px}h2{font-size:13px;margin:18px 0 6px}
table{width:100%;border-collapse:collapse;margin-top:6px}td,th{border:1px solid #999;padding:4px 6px;text-align:left;vertical-align:top}th{background:#f0ede9}.n{text-align:right;white-space:nowrap}
.res td{font-size:13px}.ok{color:#4B6B4F}.ko{color:#A8502F}.petit{font-size:10px;color:#666}.sig{display:flex;justify-content:space-between;gap:30px;margin-top:36px}.sig div{flex:1;border-top:1px solid #999;padding-top:6px;min-height:60px}
</style></head><body>
<h1>Stone Concept — État de rapprochement bancaire</h1>
<div>${e(c ? c.nom : "")} — période du ${e(formatDate(du))} au ${e(formatDate(au))}</div>
<div class="petit">Édité le ${e(formatDate(todayISO()))} par ${e(user.nom)}</div>
<h2>Rapprochement au ${e(formatDate(au))}</h2>
<table class="res">
<tr><td>Solde du relevé bancaire au ${e(formatDate(au))}</td><td class="n">${r.releve ? e(formatDH(Number(r.releve.solde))) : "<em>non saisi</em>"}</td></tr>
<tr><td>− Sorties enregistrées, pas encore débitées par la banque (${r.sortiesNP.length})</td><td class="n">− ${e(formatDH(r.totSortiesNP))}</td></tr>
<tr><td>+ Entrées enregistrées, pas encore créditées par la banque (${r.entreesNP.length})</td><td class="n">+ ${e(formatDH(r.totEntreesNP))}</td></tr>
<tr><td><strong>= Solde du relevé rapproché</strong></td><td class="n"><strong>${r.releve ? e(formatDH(Number(r.releve.solde) - r.totSortiesNP + r.totEntreesNP)) : "—"}</strong></td></tr>
<tr><td><strong>Solde de l'ERP au ${e(formatDate(au))}</strong></td><td class="n"><strong>${e(formatDH(r.soldeERP))}</strong></td></tr>
<tr><td><strong>Écart</strong></td><td class="n ${r.ecart === null ? "" : Math.abs(r.ecart) <= 0.01 ? "ok" : "ko"}"><strong>${r.ecart === null ? "—" : e(formatDH(r.ecart))}</strong></td></tr>
</table>
${tableOps("Sorties pas encore débitées (chèques, effets, virements en cours…)", r.sortiesNP, r.totSortiesNP)}
${tableOps("Entrées pas encore créditées (remises de chèques, virements attendus…)", r.entreesNP, r.totEntreesNP)}
${tableOps(`Débits pointés sur le relevé du ${formatDate(du)} au ${formatDate(au)}`, debitsP, debitsP.reduce((n, o) => n + r.m(o), 0))}
${tableOps(`Crédits pointés sur le relevé du ${formatDate(du)} au ${formatDate(au)}`, creditsP, creditsP.reduce((n, o) => n + r.m(o), 0))}
<div class="sig"><div>Établi par — date et signature</div><div>Vérifié par — date et signature</div></div>
</body></html>`;
    tracerAcces("état de rapprochement imprimé", `${c ? c.nom : ""} — du ${formatDate(du)} au ${formatDate(au)}${r.ecart !== null ? ` — écart ${formatDH(r.ecart)}` : " — solde du relevé non saisi"}`);
    telechargerDocument(html, `rapprochement-${compteId}-${du}-au-${au}`, "état de rapprochement");
  }
  // ---- Rapprochement des mouvements de caisse importés (validé Nils 30/09) ----
  function aRapprocher(o) {
    return o.type === "transfert-importé" && !o.rapprocheAvec;
  }
  function ecartJours(a, b) {
    return Math.abs((new Date(`${a}T12:00:00Z`) - new Date(`${b}T12:00:00Z`)) / 86400000);
  }
  // Lignes importées non rapprochées d'un autre compte, de sens opposé, à `jours` près ; montant le plus proche d'abord.
  function candidatsRapprochement(o, jours) {
    return (operations || [])
      .filter((x) => x.id !== o.id && aRapprocher(x) && x.compteId !== o.compteId && x.sens !== o.sens && ecartJours(x.date, o.date) <= jours)
      .sort((a, b) => Math.abs(Number(a.montant) - Number(o.montant)) - Math.abs(Number(b.montant) - Number(o.montant)) || ecartJours(a.date, o.date) - ecartJours(b.date, o.date));
  }
  async function lierMouvements(idA, idB) {
    if (!peut("compta.rapprochementCaisses")) return;
    const a = (operations || []).find((x) => x.id === idA), b2 = (operations || []).find((x) => x.id === idB);
    if (!a || !b2 || !aRapprocher(a) || !aRapprocher(b2)) return;
    const maintenant = new Date().toISOString();
    await persistOperations((operations || []).map((x) => (x.id === a.id ? { ...x, rapprocheAvec: b2.id, contrepartieId: b2.compteId, rapprochePar: user.nom, rapprocheLe: maintenant } : x.id === b2.id ? { ...x, rapprocheAvec: a.id, contrepartieId: a.compteId, rapprochePar: user.nom, rapprocheLe: maintenant } : x)));
    const [sortie, entree] = a.sens === "sortie" ? [a, b2] : [b2, a];
    const ecart = arrondiH(Number(entree.montant) - Number(sortie.montant));
    const lib = `${(compteDe(sortie.compteId) || {}).nom} (${formatDate(sortie.date)}, ${formatDH(Number(sortie.montant))}) → ${(compteDe(entree.compteId) || {}).nom} (${formatDate(entree.date)}, ${formatDH(Number(entree.montant))})`;
    await tracerAcces("mouvements de caisse rapprochés", lib);
    if (ecart) await alerter("Rapprochement : écart de montant", `${lib} — écart ${formatDH(ecart)}`, { kind: "onglet", id: "compta" });
    setRapprochementChoix({ ...rapprochementChoix, [idA]: "" });
  }
  async function delierMouvement(id) {
    if (!peut("compta.rapprochementCaisses")) return;
    const o = (operations || []).find((x) => x.id === id);
    if (!o || !o.rapprocheAvec) return;
    const ids = [o.id, o.rapprocheAvec];
    await persistOperations((operations || []).map((x) => (ids.includes(x.id) ? { ...x, rapprocheAvec: undefined, contrepartieId: undefined, rapprochePar: undefined, rapprocheLe: undefined } : x)));
    await tracerAcces("rapprochement annulé", `${(compteDe(o.compteId) || {}).nom} — ${formatDate(o.date)} — ${formatDH(Number(o.montant))}`);
    setOpEdit(null);
  }
  // Nils 26/10 : mouvement importé dont l'autre compte n'a pas la ligne — on la crée, liée d'office.
  function comptesPourContrepartie(o) {
    return (comptesTreso || []).filter((c) => c.id !== o.compteId && c.id !== CAISSE_GENERALE_ID && c.id !== PORTEFEUILLE_ID && !estCompteDevises(c) && peutSaisirCompte(c));
  }
  async function creerContrepartie(id, compteId, date) {
    if (!peut("compta.rapprochementCaisses")) return;
    const o = (operations || []).find((x) => x.id === id);
    if (!o || !aRapprocher(o)) return;
    const src = compteDe(o.compteId), dst = compteDe(compteId);
    if (!dst || !comptesPourContrepartie(o).some((c) => c.id === dst.id)) { setNotice("Choisis le compte d'en face."); return; }
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date || "") || date > todayISO()) { setNotice("Date invalide."); return; }
    if (moisVerrouille(o.compteId, o.date)) { setNotice(`${libMois(o.date.slice(0, 7))} est clôturé sur ${src.nom} : contrepartie impossible.`); return; }
    if (moisVerrouille(dst.id, date)) { setNotice(`${libMois(date.slice(0, 7))} est clôturé sur ${dst.nom} : contrepartie impossible à cette date.`); return; }
    const existante = candidatsRapprochement(o, 7).find((x) => x.compteId === dst.id && Number(x.montant) === Number(o.montant));
    if (existante) { setNotice(`${dst.nom} a déjà une ligne importée qui correspond (${formatDate(existante.date)}, ${formatDH(Number(existante.montant))}, « ${existante.designation} ») : utilise « Lier » dans Comptabilité › Mouvements de caisse à rapprocher plutôt que de créer un doublon.`); return; }
    const maintenant = new Date().toISOString();
    const sens = o.sens === "entree" ? "sortie" : "entree";
    const nouvelle = {
      id: uid(), compteId: dst.id, date, sens, montant: Number(o.montant), type: "transfert-importé", contrepartieCreee: true,
      poste: "Transfert", sousPoste: `${sens === "entree" ? "depuis" : "vers"} ${src.nom}`, designation: o.designation || `Transfert ${sens === "entree" ? "depuis" : "vers"} ${src.nom}`,
      tiers: src.nom, mode: o.mode || "Espèces", piece: "", dossierId: "", par: user.nom, le: maintenant,
      rapprocheAvec: o.id, contrepartieId: src.id, rapprochePar: user.nom, rapprocheLe: maintenant,
    };
    await persistOperations([...(operations || []).map((x) => (x.id === o.id ? { ...x, rapprocheAvec: nouvelle.id, contrepartieId: dst.id, rapprochePar: user.nom, rapprocheLe: maintenant } : x)), nouvelle]);
    await tracerAcces("contrepartie créée", `${src.nom} (${formatDate(o.date)}, ${o.sens === "entree" ? "+" : "−"}${formatDH(Number(o.montant))}) → ${dst.nom} (${formatDate(date)}, ${sens === "entree" ? "+" : "−"}${formatDH(Number(o.montant))}) — ${nouvelle.designation}`);
    setRapprochementChoix({ ...rapprochementChoix, [o.id]: "" });
    setOpEdit(null);
    setNotice(`Contrepartie créée dans ${dst.nom} et rapprochée.`);
  }
  // Nils 23/10 (c) : corriger la date d'un mouvement de caisse importé tant qu'il n'est pas rapproché
  // (ex. ligne datée du 1er du mois dans le fichier) ; la date du fichier reste dans « importe ».
  async function changerDateMouvementImporte(id, date) {
    const o = (operations || []).find((x) => x.id === id);
    const compte = o && compteDe(o.compteId);
    if (!o || o.type !== "transfert-importé" || o.rapprocheAvec || !compte || !peutSaisirCompte(compte)) return;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date || "") || date > todayISO()) { setNotice("Date invalide."); return; }
    if (date === o.date) return;
    const clos = [o.date, date].find((d) => moisVerrouille(o.compteId, d));
    if (clos) { setNotice(`${libMois(clos.slice(0, 7))} est clôturé sur ${compte.nom} : date non modifiable.`); return; }
    await persistOperations((operations || []).map((x) => (x.id === id ? { ...x, date, importe: { ...(x.importe || {}), dateFichier: (x.importe && x.importe.dateFichier) || o.date }, modifiePar: user.nom, modifieLe: new Date().toISOString() } : x)));
    await tracerAcces("mouvement importé redaté", `${compte.nom} — ${formatDH(Number(o.montant))} — ${o.designation} : ${formatDate(o.date)} → ${formatDate(date)}`);
    setOpEdit(null);
    setNotice(`Date corrigée : ${formatDate(date)}. Tu peux maintenant le rapprocher.`);
  }
  // ---- Import des fichiers de caisse (Excel / ODS, formats 2026) ----
  function convertirLibelles(poste, sous) {
    const p = normLib(poste), s2 = normLib(sous);
    if (p.startsWith("mouvement de caisse") || s2.startsWith("alimentation caisse") || s2 === "transfert de caisse") return { transfert: true, contrepartie: sous || poste };
    const direct = CORRESPONDANCES_IMPORT[`${p}|${s2}`] || CORRESPONDANCES_IMPORT[s2];
    const plan = planPostes();
    if (Array.isArray(direct)) return { poste: direct[0], sousPoste: direct[1], ...(direct[2] ? { typePrime: direct[2] } : {}) };
    const sousCible = typeof direct === "string" ? direct : sous;
    const posteCible = plan.find((x) => normLib(x.poste) === p || normLib(x.poste) === normLib(poste.replace("Frais de Fonctionnement", "Frais de fonctionnement")));
    if (posteCible) {
      const ss = posteCible.sous.find((x) => normLib(x) === normLib(sousCible));
      if (ss) return { poste: posteCible.poste, sousPoste: ss };
    }
    for (const x of plan) {
      const ss = x.sous.find((y) => normLib(y) === normLib(sousCible));
      if (ss && (!posteCible || x.poste === posteCible.poste)) return { poste: x.poste, sousPoste: ss };
    }
    return { poste: POSTE_A_DEFINIR, sousPoste: POSTE_A_DEFINIR, origine: [poste, sous].filter(Boolean).join(" › ") };
  }
  async function analyserImportTreso(fichier, compteId) {
    const compte = compteDe(compteId);
    if (!fichier || !compte || !peutSaisirCompte(compte)) return;
    // Step 17 (Nils 15/10) : la caisse générale se remplit seule (copies des autres caisses) — jamais d'import.
    if (compte.id === CAISSE_GENERALE_ID || compte.id === PORTEFEUILLE_ID) { setNotice(`Pas d'import possible sur ${compte.nom} : elle se remplit automatiquement.`); return; }
    let XLSX;
    try { XLSX = await chargerSheetJS(); } catch (e) { setNotice(e.message); return; }
    let wb;
    try { wb = XLSX.read(await fichier.arrayBuffer(), { type: "array" }); } catch (e) { setNotice("Fichier illisible."); return; }
    const lignes = [];
    let soldeOuvertureFichier = null;
    const dateIso = (v) => {
      if (v instanceof Date && !isNaN(v)) return `${v.getFullYear()}-${String(v.getMonth() + 1).padStart(2, "0")}-${String(v.getDate()).padStart(2, "0")}`;
      if (typeof v === "number" && v > 20000) { const d = XLSX.SSF.parse_date_code(v); return d ? `${d.y}-${String(d.m).padStart(2, "0")}-${String(d.d).padStart(2, "0")}` : ""; }
      const m = String(v || "").trim().match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/);
      return m ? `${m[3]}-${m[2].padStart(2, "0")}-${m[1].padStart(2, "0")}` : "";
    };
    const num = (v) => { if (v === "" || v === null || v === undefined) return 0; const n = typeof v === "number" ? v : Number(String(v).replace(/\s/g, "").replace(",", ".")); return isFinite(n) ? n : 0; };
    wb.SheetNames.forEach((sn, iSheet) => {
      const rows = XLSX.utils.sheet_to_json(wb.Sheets[sn], { header: 1, raw: true, defval: "" });
      const h = rows.findIndex((r) => r.some((c) => normLib(c) === "date") && r.some((c) => /^(debit|credit|sortie|entree)/.test(normLib(c))));
      if (h < 0) return;
      const H = rows[h].map((c) => normLib(c));
      const col = (t) => H.findIndex(t);
      const C = { date: col((x) => x === "date"), tiers: col((x) => x.startsWith("tiers")), des: col((x) => x.startsWith("designation")), poste: col((x) => x === "poste" || x.startsWith("poste ")), sous: col((x) => x.startsWith("sous-poste")), piece: col((x) => x.startsWith("justif") || x.startsWith("piece")), debit: col((x) => x.startsWith("debit")), credit: col((x) => x.startsWith("credit")), sortie: col((x) => x.startsWith("sortie")), entree: col((x) => x.startsWith("entree")), solde: col((x) => x.startsWith("solde")) };
      rows.slice(h + 1).forEach((r, i) => {
        const d = dateIso(r[C.date]);
        const texte = r.map((c) => normLib(c)).join(" ");
        if (!d) {
          if (iSheet <= 2 && soldeOuvertureFichier === null && /solde/.test(texte) && C.solde >= 0 && r[C.solde] !== "" && typeof r[C.solde] === "number") soldeOuvertureFichier = r[C.solde];
          return;
        }
        let entree = 0, sortie = 0;
        if (C.sortie >= 0 || C.entree >= 0) { sortie = num(r[C.sortie]); entree = num(r[C.entree]); }
        else { const db = num(r[C.debit]), cr = num(r[C.credit]); if (compte.debitEstEntree) { entree = db; sortie = cr; } else { sortie = db; entree = cr; } }
        if (!entree && !sortie) return;
        const poste = C.poste >= 0 ? String(r[C.poste] || "").trim() : "";
        const sous = C.sous >= 0 ? String(r[C.sous] || "").trim() : "";
        const conv = convertirLibelles(poste, sous);
        const base = { date: d, tiers: C.tiers >= 0 ? String(r[C.tiers] || "").trim() : "", designation: C.des >= 0 ? String(r[C.des] || "").trim() : "", piece: C.piece >= 0 ? String(r[C.piece] || "").trim() : "", feuille: sn, ligne: h + i + 2, origine: [poste, sous].filter(Boolean).join(" › ") };
        [["entree", entree], ["sortie", sortie]].forEach(([sens, m]) => {
          if (!m) return;
          if (conv.transfert) lignes.push({ ...base, sens, montant: m, poste: "Transfert", sousPoste: `${sens === "entree" ? "depuis" : "vers"} (importé) ${conv.contrepartie}`, transfertImporte: true });
          else lignes.push({ ...base, sens, montant: m, poste: conv.poste, sousPoste: conv.sousPoste, ...(conv.typePrime ? { typePrime: conv.typePrime } : {}) });
        });
      });
    });
    const existants = new Set((operations || []).filter((o) => o.compteId === compte.id).map((o) => `${o.date}|${o.sens}|${Number(o.montant)}|${normLib(o.designation)}`));
    lignes.forEach((l) => { l.doublon = existants.has(`${l.date}|${l.sens}|${Number(l.montant)}|${normLib(l.designation)}`); });
    // Step 17 (Nils 15/10) : lignes datées à partir du démarrage de la saisie dans l'ERP → refusées.
    const demarrage = compte.dateDemarrageERP || "";
    lignes.forEach((l) => { l.apresDemarrage = !!demarrage && !l.doublon && l.date >= demarrage; });
    // Doublon probable : opération déjà dans l'ERP sur ce compte, même sens, même montant, à 3 jours près → décochée par défaut.
    const opsCompte = (operations || []).filter((o) => o.compteId === compte.id && !o.miroirDe);
    lignes.forEach((l) => {
      if (l.doublon || l.apresDemarrage) return;
      const x = opsCompte.find((o) => o.sens === l.sens && Math.abs(Number(o.montant) - Number(l.montant)) < 0.005 && ecartJours(o.date, l.date) <= 3);
      if (x) { l.doublonProbable = { id: x.id, date: x.date, designation: x.designation || "" }; l.importerQuandMeme = false; }
    });
    // Rapprochement proposé : ligne importée d'un autre compte, sens opposé, même montant, à 3 jours près, correspondance unique.
    const prises = new Set();
    lignes.filter((l) => l.transfertImporte && !l.doublon && !l.apresDemarrage && !l.doublonProbable).forEach((l) => {
      const c = candidatsRapprochement({ compteId: compte.id, sens: l.sens, montant: l.montant, date: l.date }, 3).filter((x) => Number(x.montant) === Number(l.montant) && !prises.has(x.id));
      if (c.length === 1) { l.rapprocherAvec = c[0].id; l.rapprocher = true; prises.add(c[0].id); }
    });
    setImportTreso({ fichier: fichier.name, compteId: compte.id, lignes, soldeOuvertureFichier, utiliserSolde: soldeOuvertureFichier !== null && !(operations || []).some((o) => o.compteId === compte.id) });
  }
  async function confirmerImportTreso() {
    const im = importTreso;
    if (!im) return;
    const compte = compteDe(im.compteId);
    if (!peutSaisirCompte(compte)) return;
    const maintenant = new Date().toISOString();
    const retenue = (l) => !l.doublon && !l.apresDemarrage && (!l.doublonProbable || l.importerQuandMeme);
    const verrouillees = im.lignes.filter((l) => retenue(l) && moisVerrouille(compte.id, l.date)).length;
    if (verrouillees && !await demander(`${verrouillees} ligne(s) tombent dans un mois clôturé et seront ignorées. Continuer ?`)) return;
    const nouvelles = im.lignes.filter((l) => retenue(l) && !moisVerrouille(compte.id, l.date)).map((l) => ({
      ...(l.transfertImporte && l.rapprocher && l.rapprocherAvec ? { rapprocheAvec: l.rapprocherAvec, contrepartieId: ((operations || []).find((x) => x.id === l.rapprocherAvec) || {}).compteId, rapprochePar: user.nom, rapprocheLe: maintenant } : {}),
      id: uid(), compteId: compte.id, date: l.date, sens: l.sens, montant: l.montant, tiers: l.tiers, designation: l.designation || l.origine || "(sans désignation)", piece: l.piece, mode: "Espèces",
      poste: l.poste, sousPoste: l.sousPoste, ...(l.typePrime ? { typePrime: l.typePrime } : {}), dossierId: "", type: l.transfertImporte ? "transfert-importé" : "normal",
      importe: { fichier: im.fichier, feuille: l.feuille, ligne: l.ligne, origine: l.origine }, par: `${user.nom} (import)`, le: maintenant,
    }));
    const liens = Object.fromEntries(nouvelles.filter((o) => o.rapprocheAvec).map((o) => [o.rapprocheAvec, o]));
    await persistOperations([...(operations || []).map((x) => (liens[x.id] ? { ...x, rapprocheAvec: liens[x.id].id, contrepartieId: compte.id, rapprochePar: user.nom, rapprocheLe: maintenant } : x)), ...nouvelles]);
    if (im.utiliserSolde && im.soldeOuvertureFichier !== null) await persistComptesTreso((comptesTreso || []).map((c) => (c.id === compte.id ? { ...c, soldeOuverture: im.soldeOuvertureFichier } : c)));
    const nbDef = nouvelles.filter((o) => o.poste === POSTE_A_DEFINIR).length;
    const nbEnc = nouvelles.filter((o) => o.poste === POSTE_ENCAISSEMENT).length;
    const nbLies = Object.keys(liens).length, nbMvt = nouvelles.filter((o) => o.type === "transfert-importé").length;
    await tracerAcces("import de caisse", `${compte.nom} — ${im.fichier} — ${nouvelles.length} opération(s)${nbDef ? `, ${nbDef} à classer` : ""}${nbEnc ? `, ${nbEnc} encaissement(s) à relier` : ""}${nbMvt ? `, ${nbMvt} mouvement(s) de caisse dont ${nbLies} rapproché(s)` : ""}`);
    setImportTreso(null);
    setNotice(`Import terminé : ${nouvelles.length} opération(s) dans ${compte.nom}.`);
  }
  // Nils 21/10 : imports d'un compte (un import = un fichier + l'heure de l'import, toutes ses feuilles)
  // et leur annulation. Seules les opérations encore présentes sont comptées ; les copies de la
  // caisse générale suivent seules (synchronisation des copies liées).
  function importsDuCompte(compteId) {
    const parCle = {};
    (operations || []).filter((o) => o.compteId === compteId && o.importe && !o.miroirDe).forEach((o) => {
      const cle = `${o.importe.fichier}|${o.le}`;
      (parCle[cle] = parCle[cle] || { cle, fichier: o.importe.fichier, le: o.le, par: String(o.par || "").replace(/ \(import\)$/, ""), ops: [] }).ops.push(o);
    });
    return Object.values(parCle).sort((a, b) => String(b.le).localeCompare(String(a.le)));
  }
  const moisDesOps = (ops) => [...new Set(ops.map((o) => String(o.date || "").slice(0, 7)).filter(Boolean))].sort();
  async function annulerImportsTreso(compteId, imports) {
    const compte = compteDe(compteId);
    if (!compte || !peutSaisirCompte(compte) || !imports.length) return;
    const ops = imports.flatMap((im) => im.ops);
    if (!ops.length) return;
    // Tout ou rien : une ligne dans un mois clôturé bloque l'annulation entière.
    const clos = moisDesOps(ops.filter((o) => moisVerrouille(compteId, o.date)));
    if (clos.length) { setNotice(`Annulation impossible : ${clos.map(libMois).join(", ")} ${clos.length > 1 ? "sont clôturés" : "est clôturé"} sur ${compte.nom}. Le Gérant doit d'abord rouvrir ${clos.length > 1 ? "ces mois" : "ce mois"}.`); return; }
    const mois = moisDesOps(ops);
    const periode = mois.length > 1 ? `de ${libMois(mois[0])} à ${libMois(mois[mois.length - 1])}` : libMois(mois[0]);
    const total = (sens) => ops.filter((o) => o.sens === sens).reduce((n, o) => n + (Number(o.montant) || 0), 0);
    const retouchees = ops.filter((o) => o.modifieLe || o.dossierId || (o.repartition || []).length || o.factureFournisseur || o.avoirId || o.rapprocheAvec).length;
    const message = `Supprimer ${ops.length} opération(s) importée(s) de ${compte.nom}, ${periode} ?\nEntrées ${formatDH(total("entree"))} · sorties ${formatDH(total("sortie"))}.`
      + (retouchees ? `\n\n${retouchees} ont été retouchées depuis l'import (reclassées, rattachées à une facture ou un encaissement, ou rapprochées avec une autre caisse) : ce travail sera à refaire après le réimport.` : "")
      + "\n\nLes opérations saisies à la main ne sont pas touchées.";
    if (!await demander(message, { danger: true })) return;
    const ids = new Set(ops.map((o) => o.id));
    await persistOperations((operations || []).filter((x) => !ids.has(x.id)).map((x) => (ids.has(x.rapprocheAvec) ? { ...x, rapprocheAvec: undefined, contrepartieId: undefined, rapprochePar: undefined, rapprocheLe: undefined } : x)));
    const detail = `${compte.nom} — ${imports.map((im) => `${im.fichier} (importé le ${new Date(im.le).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })})`).join(", ")} — ${ops.length} opération(s) supprimée(s), ${periode}`;
    await tracerAcces("import de caisse annulé", detail);
    if (!estGerant) await alerter("Trésorerie : import annulé", `${detail} (par ${user.nom})`, { kind: "onglet", id: "compta" });
    setNotice(`Import annulé : ${ops.length} opération(s) supprimée(s) de ${compte.nom}. Tu peux réimporter le fichier corrigé.`);
  }
  async function modifierCompteTreso(id, patch) {
    if (!peut("admin.parametrage")) return;
    const avant = compteDe(id);
    await persistComptesTreso((comptesTreso || []).map((c) => (c.id === id ? { ...c, ...patch } : c)));
    await tracerAcces("compte de trésorerie modifié", `${avant ? avant.nom : id} — ${Object.entries(patch).map(([k, v]) => `${k} : ${Array.isArray(v) ? v.join(", ") : v}`).join(" ; ")}`);
  }
  async function ajouterSousPoste(poste) {
    if (!peut("compta.parametrer")) return;
    const v = (nouveauSousPoste[poste] || "").trim();
    if (!v) return;
    const plan = planPostes();
    const p = plan.find((x) => x.poste === poste);
    if (!p || p.sous.some((x) => normLib(x) === normLib(v))) { setNotice("Ce sous-poste existe déjà."); return; }
    await persistParametres({ ...(parametres || {}), planPostes: plan.map((x) => (x.poste === poste ? { ...x, sous: [...x.sous, v] } : x)) });
    await tracerAcces("plan de postes : sous-poste ajouté", `${poste} › ${v}`);
    setNouveauSousPoste({ ...nouveauSousPoste, [poste]: "" });
  }
  async function renommerSousPoste(poste, ancien, nouveau) {
    if (!peut("compta.parametrer")) return;
    const v = (nouveau || "").trim();
    if (!v || v === ancien) return;
    const plan = planPostes();
    if (plan.find((x) => x.poste === poste).sous.some((x) => normLib(x) === normLib(v))) { setNotice("Ce sous-poste existe déjà."); return; }
    await persistParametres({ ...(parametres || {}), planPostes: plan.map((x) => (x.poste === poste ? { ...x, sous: x.sous.map((y) => (y === ancien ? v : y)) } : x)) });
    if ((operations || []).some((o) => o.poste === poste && o.sousPoste === ancien)) await persistOperations((operations || []).map((o) => (o.poste === poste && o.sousPoste === ancien ? { ...o, sousPoste: v } : o)));
    await tracerAcces("plan de postes : sous-poste renommé", `${poste} › ${ancien} → ${v}`);
  }
  async function supprimerSousPoste(poste, sp) {
    if (!peut("compta.parametrer")) return;
    const n = (operations || []).filter((o) => o.poste === poste && o.sousPoste === sp).length;
    if (n) { setNotice(`Impossible : ${n} opération(s) utilisent « ${sp} ». Renomme-le ou reclasse-les d'abord.`); return; }
    const plan = planPostes();
    if (plan.find((x) => x.poste === poste).sous.length <= 1) { setNotice("Un poste doit garder au moins un sous-poste."); return; }
    await persistParametres({ ...(parametres || {}), planPostes: plan.map((x) => (x.poste === poste ? { ...x, sous: x.sous.filter((y) => y !== sp) } : x)) });
    await tracerAcces("plan de postes : sous-poste supprimé", `${poste} › ${sp}`);
  }
  // ---- Écran « Factures fournisseurs & échéancier » (Comptabilité ; seul écran compta d'Ahmed) ----
  function libelleArrivage(lotId) {
    const it = (items || []).find((x) => x.id === lotId);
    if (!it) return "lot supprimé";
    return `${nomProduit(it.produitId)}${it.fournisseur ? " — " + it.fournisseur : ""}${Number(it.arrivages) > 0 ? ` (arrivage ${it.arrivages} ${it.unite})` : " (réceptionné)"}`;
  }
  function rendrePrevisions() {
    const liste = [...(previsions || [])].sort((a, b) => (!!a.realiseeLe === !!b.realiseeLe ? (a.date < b.date ? -1 : 1) : a.realiseeLe ? 1 : -1));
    const arrivages = (items || []).filter((it) => Number(it.arrivages) > 0);
    const g = "0.8fr 2fr 1.1fr 1fr 1.6fr 0.9fr 70px";
    return (
      <div>
        <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 12 }}>
          <button type="button" className="sc-btn" onClick={() => setPrevisionEdit({ date: "", libelle: "", categorie: CATEGORIES_PREVISION[0], sens: "sortie", montant: "", lotId: "", note: "" })} style={{ ...primaryBtnStyle, fontSize: 12, padding: "6px 14px", whiteSpace: "nowrap", flexShrink: 0 }}>+ Prévision</button>
          <span style={{ fontSize: 12, color: TAUPE }}>Dépenses ou rentrées prévues (investissements, douane d'un arrivage, leasing…) : comptées dans le tableau de bord au mois prévu tant qu'elles ne sont pas « réalisées » (une prévision passée non réalisée compte dans le mois en cours).</span>
        </div>
        <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden" }}>
          <div style={{ display: "grid", gridTemplateColumns: g, padding: "9px 14px", background: PIERRE, gap: 8 }}>
            <Th>Date prévue</Th><Th>Libellé</Th><Th>Catégorie</Th><Th>Montant</Th><Th>Arrivage lié</Th><Th>Réalisée</Th><Th></Th>
          </div>
          {liste.length === 0 && <div style={{ padding: 14, fontSize: 13, color: TAUPE }}>Aucune prévision.</div>}
          {liste.map((x) => (
            <div key={x.id} style={{ display: "grid", gridTemplateColumns: g, padding: "8px 14px", gap: 8, alignItems: "center", borderBottom: `1px solid ${PIERRE}`, fontSize: 13, opacity: x.realiseeLe ? 0.55 : 1, background: !x.realiseeLe && x.date < todayISO() ? "#FBF6EC" : "transparent" }}>
              <div>{formatDate(x.date)}</div>
              <div>{x.libelle}{x.note ? <div style={{ fontSize: 11, color: TAUPE }}>{x.note}</div> : null}</div>
              <div style={{ fontSize: 12 }}>{x.categorie}</div>
              <div style={{ fontWeight: 600, color: x.sens === "entree" ? VERT_OK : ROUILLE }}>{x.sens === "entree" ? "+" : "−"} {formatDH(x.montant)}</div>
              <div style={{ fontSize: 12, color: TAUPE }}>{x.lotId ? libelleArrivage(x.lotId) : "—"}</div>
              <div><label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 12 }}><input type="checkbox" checked={!!x.realiseeLe} onChange={(e) => marquerPrevisionRealisee(x.id, e.target.checked)} />{x.realiseeLe ? formatDate(x.realiseeLe) : ""}</label></div>
              <div style={{ display: "flex", gap: 2 }}>
                <button type="button" className="sc-btn" onClick={() => setPrevisionEdit({ ...x, montant: String(x.montant).replace(".", ",") })} style={iconBtnStyle} title="Modifier">✎</button>
                <button type="button" className="sc-btn" onClick={() => supprimerPrevision(x.id)} style={iconBtnStyle} title="Supprimer">✕</button>
              </div>
            </div>
          ))}
        </div>
        {previsionEdit && (() => {
          const f = previsionEdit;
          const set = (patch) => setPrevisionEdit({ ...f, ...patch });
          return (
            <Overlay onClose={() => setPrevisionEdit(null)}>
              <div style={modalStyle(500)}>
                <div style={modalTitleStyle}>{f.id ? "Modifier la prévision" : "Nouvelle prévision"}</div>
                <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
                  {[["sortie", "Dépense"], ["entree", "Rentrée"]].map(([v, l]) => (<button key={v} type="button" className="sc-btn" onClick={() => set({ sens: v })} style={{ padding: "6px 14px", borderRadius: 6, fontSize: 13, background: f.sens === v ? (v === "entree" ? VERT_OK : ROUILLE) : PIERRE, color: f.sens === v ? "#fff" : ENCRE }}>{l}</button>))}
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                  <Field label="Date prévue"><input type="date" className="sc-input" value={f.date} onChange={(e) => set({ date: e.target.value })} style={{ ...inputStyle("100%"), background: "#fff" }} /></Field>
                  <Field label="Montant (DH)"><input className="sc-input" inputMode="decimal" value={f.montant} onChange={(e) => set({ montant: e.target.value })} style={{ ...inputStyle("100%"), background: "#fff" }} /></Field>
                </div>
                <Field label="Libellé"><input className="sc-input" value={f.libelle} onChange={(e) => set({ libelle: e.target.value })} placeholder="ex. Pont roulant, douane conteneur Infinity" style={{ ...inputStyle("100%"), background: "#fff" }} /></Field>
                <Field label="Catégorie">
                  <select className="sc-select" value={f.categorie} onChange={(e) => set({ categorie: e.target.value })} style={{ ...selectStyle, background: "#fff" }}>
                    {CATEGORIES_PREVISION.map((c) => (<option key={c} value={c}>{c}</option>))}
                  </select>
                </Field>
                <Field label="Arrivage lié (facultatif — ex. douane de la marchandise en arrivage)">
                  <select className="sc-select" value={f.lotId || ""} onChange={(e) => set({ lotId: e.target.value, ...(e.target.value && f.categorie === CATEGORIES_PREVISION[0] ? { categorie: "Douane / transit" } : {}) })} style={{ ...selectStyle, background: "#fff" }}>
                    <option value="">— Aucun —</option>
                    {f.lotId && !arrivages.some((it) => it.id === f.lotId) && <option value={f.lotId}>{libelleArrivage(f.lotId)}</option>}
                    {arrivages.map((it) => (<option key={it.id} value={it.id}>{libelleArrivage(it.id)}</option>))}
                  </select>
                </Field>
                <Field label="Note (facultatif)"><input className="sc-input" value={f.note || ""} onChange={(e) => set({ note: e.target.value })} style={{ ...inputStyle("100%"), background: "#fff" }} /></Field>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                  <button type="button" className="sc-btn" onClick={() => setPrevisionEdit(null)} style={ghostBtnStyle}>Annuler</button>
                  <button type="button" className="sc-btn" onClick={enregistrerPrevision} style={primaryBtnStyle}>Enregistrer</button>
                </div>
              </div>
            </Overlay>
          );
        })()}
      </div>
    );
  }
  function rendreRecurrentes() {
    const auj = todayISO();
    const horizon = ajouterMoisISO(auj, 3, Number(auj.slice(8, 10)));
    const liste = [...(recurrentes || [])].sort((a, b) => ((a.active === false) === (b.active === false) ? a.libelle.localeCompare(b.libelle, "fr") : a.active === false ? 1 : -1));
    const lib = (cle) => (FREQUENCES_RECURRENTES.find((f) => f.cle === cle) || {}).lib || cle;
    const plan = planPostes();
    return (
      <div>
        <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 12 }}>
          <button type="button" className="sc-btn" onClick={() => setRecurrenteEdit({ libelle: "", categorie: "Impôts & taxes", sens: "sortie", montant: "", frequence: "mensuelle", debut: "", finType: "jamais", finDate: "", nombre: "", poste: "", sousPoste: "", note: "" })} style={{ ...primaryBtnStyle, fontSize: 12, padding: "6px 14px", whiteSpace: "nowrap", flexShrink: 0 }}>+ Échéance récurrente</button>
          <span style={{ fontSize: 12, color: TAUPE }}>IS (acomptes), taxe professionnelle, leasings, loyers… : chaque échéance non réalisée compte dans le tableau de bord à sa date (en retard : dans le mois en cours). Alerte {JOURS_ALERTE_RECURRENTE} jours avant et si elle est dépassée. « Réalisée » relie la sortie de la CFG (prélèvement déjà importé, ou nouvelle sortie pré-remplie), ou se coche sans lien.</span>
        </div>
        {liste.length === 0 && <div style={{ fontSize: 13, color: TAUPE }}>Aucune échéance récurrente.</div>}
        {liste.map((r) => {
          // Nils 29/10 (d) : les échéances réalisées du dernier mois restent affichées, avec la sortie reliée.
          const occ = r.active === false ? [] : [...occurrencesRecurrente(r, decalerJours(auj, -31), auj).filter((o) => o.realiseeLe && o.date < auj), ...occurrencesDues(r, auj).filter((o) => o.date < auj), ...occurrencesRecurrente(r, auj, horizon)].sort((a, b) => (a.date < b.date ? -1 : 1));
          const vues = occ.filter((o, i) => occ.findIndex((x) => x.date === o.date) === i);
          return (
            <div key={r.id} style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: "10px 14px", marginBottom: 10, opacity: r.active === false ? 0.55 : 1 }}>
              <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                <strong style={{ fontSize: 14 }}>{r.libelle}</strong>
                <span style={{ fontSize: 12, color: TAUPE }}>{r.categorie} · {lib(r.frequence)} · {r.sens === "entree" ? "+" : "−"}{formatDH(Number(r.montant))} · depuis le {formatDate(r.debut)}{r.finType === "date" ? ` jusqu'au ${formatDate(r.finDate)}` : r.finType === "nombre" ? ` · ${r.nombre} échéance(s)` : ""}{r.sousPoste ? ` · ${r.poste} › ${r.sousPoste}` : ""}{r.active === false ? " · arrêtée" : ""}</span>
                <span style={{ marginLeft: "auto", display: "flex", gap: 2 }}>
                  <button type="button" className="sc-btn" onClick={() => setRecurrenteEdit({ ...r, montant: String(r.montant).replace(".", ",") })} style={iconBtnStyle} title="Modifier">✎</button>
                  <button type="button" className="sc-btn" onClick={() => basculerRecurrente(r)} style={{ ...ghostBtnStyle, fontSize: 11, padding: "2px 6px" }}>{r.active === false ? "Réactiver" : "Arrêter"}</button>
                  <button type="button" className="sc-btn" onClick={() => supprimerRecurrente(r)} style={iconBtnStyle} title="Supprimer">✕</button>
                </span>
              </div>
              {r.note && <div style={{ fontSize: 11, color: TAUPE }}>{r.note}</div>}
              {vues.length > 0 && (
                <div style={{ marginTop: 6 }}>
                  {vues.map((o) => (
                    <div key={o.date} style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 12, padding: "3px 0", borderTop: `1px solid ${PIERRE}`, color: !o.realiseeLe && o.date < auj ? ROUILLE : ENCRE }}>
                      <span style={{ width: 90 }}>{formatDate(o.date)}</span>
                      <input className="sc-input" inputMode="decimal" defaultValue={o.ajuste ? String(o.montant).replace(".", ",") : ""} placeholder={String(r.montant).replace(".", ",")} onBlur={(e) => { const v = e.target.value.trim(); const n = v ? parseMontantSaisi(v) : ""; if (v && !isFinite(n)) return; if (String(n) !== String(o.ajuste ? o.montant : "")) majOccurrence(r.id, o.date, { montant: n }); }} style={{ ...inputStyle(110), padding: "2px 6px", fontSize: 12 }} title="Montant de cette échéance (vide = montant habituel)" />
                      <label style={{ display: "flex", gap: 4, alignItems: "center", cursor: "pointer" }}>
                        <input type="checkbox" checked={!!o.realiseeLe} onChange={(e) => (e.target.checked ? cocherEcheance(r, o) : majOccurrence(r.id, o.date, { realiseeLe: "", realiseePar: "", opId: "" }))} />
                        Réalisée{o.realiseeLe ? ` le ${formatDate(o.realiseeLe)} (${o.realiseePar})` : ""}
                      </label>
                      {o.realiseeLe && o.opId && (() => {
                        const op = (operations || []).find((x) => x.id === o.opId);
                        return <span style={{ color: op ? VERT_OK : ROUILLE }}>{op ? `↔ ${(compteDe(op.compteId) || {}).nom || "?"} du ${formatDate(op.date)} — ${formatDH(Number(op.montant) || 0)}` : "↔ opération supprimée"}</span>;
                      })()}
                      {!o.realiseeLe && o.date < auj && <span style={{ fontWeight: 600 }}>en retard</span>}
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
        {relierEcheance && (() => {
          const { r, o, cands } = relierEcheance;
          const cfg = compteEcheances();
          const peutCreer = !!cfg && peutSaisirCompte(cfg);
          return (
            <Overlay onClose={() => setRelierEcheance(null)}>
              <div style={modalStyle(560)}>
                <div style={modalTitleStyle}>Échéance réalisée — {r.libelle}</div>
                <div style={{ fontSize: 13, marginBottom: 12 }}>Échéance du {formatDate(o.date)} — {r.sens === "entree" ? "+" : "−"}{formatDH(o.montant)}</div>
                {cands.length > 0 ? (
                  <>
                    <div style={{ fontSize: 12, color: TAUPE, marginBottom: 6 }}>Opération(s) de {cfg ? cfg.nom : "la banque"} de même montant, à {JOURS_RAPPROCHEMENT_ECHEANCE} jours près :</div>
                    {cands.map((op) => (
                      <div key={op.id} style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 12, background: PIERRE, borderRadius: 6, padding: "6px 10px", marginBottom: 4 }}>
                        <span style={{ flex: 1 }}>{formatDate(op.date)} — {formatDH(Number(op.montant) || 0)} — {op.poste} › {op.sousPoste}{op.designation ? ` — ${op.designation}` : ""}{op.importe ? " (importée)" : ""}</span>
                        <button type="button" className="sc-btn" onClick={() => marquerEcheance(r, o, op.id)} style={{ ...primaryBtnStyle, fontSize: 12, padding: "4px 12px" }}>Relier</button>
                      </div>
                    ))}
                  </>
                ) : <div style={{ fontSize: 12, color: TAUPE, marginBottom: 6 }}>Aucune opération de même montant à {JOURS_RAPPROCHEMENT_ECHEANCE} jours près{cfg ? ` sur ${cfg.nom}` : ""}.</div>}
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 14, flexWrap: "wrap" }}>
                  <button type="button" className="sc-btn" onClick={() => setRelierEcheance(null)} style={ghostBtnStyle}>Annuler</button>
                  <button type="button" className="sc-btn" onClick={() => marquerEcheance(r, o, "")} style={ghostBtnStyle}>Cocher sans relier</button>
                  {peutCreer && <button type="button" className="sc-btn" onClick={() => { setRelierEcheance(null); ouvrirSortieEcheance(r, o); }} style={ghostBtnStyle}>Créer la sortie sur {cfg.nom}</button>}
                </div>
              </div>
            </Overlay>
          );
        })()}
        {recurrenteEdit && (() => {
          const f = recurrenteEdit;
          const set = (patch) => setRecurrenteEdit({ ...f, ...patch });
          const postes = plan.filter((x) => x.sens === "les deux" || (f.sens === "entree" ? x.sens === "entree" : x.sens === "sortie"));
          const sous = (plan.find((x) => x.poste === f.poste) || { sous: [] }).sous;
          return (
            <Overlay onClose={() => setRecurrenteEdit(null)}>
              <div style={modalStyle(540)}>
                <div style={modalTitleStyle}>{f.id ? "Modifier l'échéance récurrente" : "Nouvelle échéance récurrente"}</div>
                <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
                  {[["sortie", "Dépense"], ["entree", "Rentrée"]].map(([v, l]) => (<button key={v} type="button" className="sc-btn" onClick={() => set({ sens: v, poste: "", sousPoste: "" })} style={{ padding: "6px 14px", borderRadius: 6, fontSize: 13, background: f.sens === v ? (v === "entree" ? VERT_OK : ROUILLE) : PIERRE, color: f.sens === v ? "#fff" : ENCRE }}>{l}</button>))}
                </div>
                <Field label="Libellé"><input className="sc-input" value={f.libelle} onChange={(e) => set({ libelle: e.target.value })} placeholder="ex. IS — acompte, Taxe professionnelle, Leasing camion" style={{ ...inputStyle("100%"), background: "#fff" }} /></Field>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                  <Field label="Montant (DH)"><input className="sc-input" inputMode="decimal" value={f.montant} onChange={(e) => set({ montant: e.target.value })} style={{ ...inputStyle("100%"), background: "#fff" }} /></Field>
                  <Field label="Fréquence">
                    <select className="sc-select" value={f.frequence} onChange={(e) => set({ frequence: e.target.value })} style={{ ...selectStyle, background: "#fff" }}>{FREQUENCES_RECURRENTES.map((x) => (<option key={x.cle} value={x.cle}>{x.lib}</option>))}</select>
                  </Field>
                  <Field label="1re échéance"><input type="date" className="sc-input" value={f.debut} onChange={(e) => set({ debut: e.target.value })} style={{ ...inputStyle("100%"), background: "#fff" }} /></Field>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                  <Field label="Fin">
                    <select className="sc-select" value={f.finType} onChange={(e) => set({ finType: e.target.value })} style={{ ...selectStyle, background: "#fff" }}>
                      <option value="jamais">Pas de fin</option>
                      <option value="date">À une date</option>
                      <option value="nombre">Après N échéances</option>
                    </select>
                  </Field>
                  {f.finType === "date" && <Field label="Dernière échéance au plus tard le"><input type="date" className="sc-input" value={f.finDate || ""} onChange={(e) => set({ finDate: e.target.value })} style={{ ...inputStyle("100%"), background: "#fff" }} /></Field>}
                  {f.finType === "nombre" && <Field label="Nombre d'échéances"><input type="number" min="1" className="sc-input" value={f.nombre || ""} onChange={(e) => set({ nombre: e.target.value })} style={{ ...inputStyle("100%"), background: "#fff" }} /></Field>}
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                  <Field label="Catégorie">
                    <select className="sc-select" value={f.categorie} onChange={(e) => set({ categorie: e.target.value })} style={{ ...selectStyle, background: "#fff" }}>{CATEGORIES_PREVISION.map((c) => (<option key={c} value={c}>{c}</option>))}</select>
                  </Field>
                  <Field label="Poste (comptabilité)">
                    <select className="sc-select" value={f.poste || ""} onChange={(e) => set({ poste: e.target.value, sousPoste: "" })} style={{ ...selectStyle, background: "#fff" }}>
                      <option value="">—</option>
                      {postes.map((x) => (<option key={x.poste} value={x.poste}>{x.poste}</option>))}
                    </select>
                  </Field>
                  <Field label="Sous-poste">
                    <select className="sc-select" value={f.sousPoste || ""} onChange={(e) => set({ sousPoste: e.target.value })} disabled={!f.poste} style={{ ...selectStyle, background: "#fff" }}>
                      <option value="">—</option>
                      {sous.map((x) => (<option key={x} value={x}>{x}</option>))}
                    </select>
                  </Field>
                </div>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: -8, marginBottom: 12 }}>Le sous-poste sert à ne pas compter deux fois : s'il est couvert ici (ex. IS & taxes, CNSS, TVA), il sort de la moyenne du tableau de bord.</div>
                {f.sens === "sortie" && (
                  <>
                    {/* Nils 29/10 : leasing sans facture (tableau d'amortissement) — chaque échéance réalisée crée la facture du fournisseur (TVA). */}
                    <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr 0.7fr", gap: 12 }}>
                      <Field label="Fournisseur (facture à chaque échéance)">
                        <select className="sc-select" value={f.fournisseur || ""} onChange={(e) => set({ fournisseur: e.target.value })} style={{ ...selectStyle, background: "#fff" }}>
                          <option value="">— Aucun —</option>
                          {nomsTiers("fournisseur").map((n) => (<option key={n} value={n}>{n}</option>))}
                        </select>
                      </Field>
                      <Field label="N° de contrat"><input className="sc-input" value={f.contrat || ""} onChange={(e) => set({ contrat: e.target.value })} disabled={!f.fournisseur} style={{ ...inputStyle("100%"), background: "#fff" }} /></Field>
                      <Field label="TVA">
                        <select className="sc-select" value={String(f.tauxTVA ?? 0.2)} onChange={(e) => set({ tauxTVA: Number(e.target.value) })} disabled={!f.fournisseur} style={{ ...selectStyle, background: "#fff" }}>
                          {[0.2, 0.14, 0.1, 0.07, 0].map((t) => (<option key={t} value={String(t)}>{Math.round(t * 100)} %</option>))}
                        </select>
                      </Field>
                    </div>
                    <div style={{ fontSize: 11, color: TAUPE, marginTop: -8, marginBottom: 12 }}>Ex. leasing (tableau d'amortissement, pas de facture) : « Réalisée » crée la facture fournisseur de l'échéance (TTC = montant de l'échéance), rattachée à la sortie de la CFG — sa TVA entre dans le fichier TVA du mois.</div>
                  </>
                )}
                <Field label="Note (facultatif)"><input className="sc-input" value={f.note || ""} onChange={(e) => set({ note: e.target.value })} style={{ ...inputStyle("100%"), background: "#fff" }} /></Field>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                  <button type="button" className="sc-btn" onClick={() => setRecurrenteEdit(null)} style={ghostBtnStyle}>Annuler</button>
                  <button type="button" className="sc-btn" onClick={enregistrerRecurrente} style={primaryBtnStyle}>Enregistrer</button>
                </div>
              </div>
            </Overlay>
          );
        })()}
      </div>
    );
  }
  // ---- Nils 08/10 : écran « Transport international » (Achats ; Nils + Sawsan) ----
  function nouvelleLigneTransport(patch) {
    return { id: "", date: todayISO(), fournisseur: "", pays: "", incoterm: "", taille: 40, arrivageId: "", transport: "", transitaireTotal: "", transportLocal: "", surestaries: "", autresTransitaire: "", droits: "", tvaImport: "", autresTaxes: "", dechargement: "", note: "", operationIds: [], ...(patch || {}) };
  }
  async function enregistrerLigneTransport() {
    const f = ligneTransportEdit;
    if (!f) return;
    if (!f.date || !f.fournisseur || !String(f.pays || "").trim() || !f.incoterm || ![20, 40].includes(Number(f.taille))) { setNotice("Date, fournisseur, pays, incoterm et taille du conteneur sont obligatoires."); return; }
    { const pl = postesLigneTransport(f); if (pl.honoraires !== null && pl.honoraires < -0.005) { setNotice("Facture du transitaire : transport local + surestaries + autres frais dépassent le total HT de la facture."); return; } }
    const ti = transportIntl || TRANSPORT_INTL_VIDE;
    const ligne = { ...f, pays: String(f.pays).trim(), taille: Number(f.taille), id: f.id || uid(), ...(f.id ? { modifiePar: user.nom, modifieLe: new Date().toISOString() } : { creePar: user.nom, creeLe: new Date().toISOString() }) };
    await persistTransportIntl({ ...ti, lignes: f.id ? ti.lignes.map((x) => (x.id === f.id ? ligne : x)) : [...(ti.lignes || []), ligne] });
    await tracerAcces(f.id ? "transport international : ligne modifiée" : "transport international : conteneur ajouté", `${ligne.fournisseur} — ${ligne.taille}' — ${formatDate(ligne.date)}`);
    setLigneTransportEdit(null);
    setNotice("Conteneur enregistré dans le registre transport international.");
  }
  async function supprimerLigneTransport(l) {
    if (!(await demander(`Supprimer la ligne ${l.fournisseur} du ${formatDate(l.date)} ?`, { danger: true }))) return;
    const ti = transportIntl || TRANSPORT_INTL_VIDE;
    await persistTransportIntl({ ...ti, lignes: ti.lignes.filter((x) => x.id !== l.id) });
    await tracerAcces("transport international : ligne supprimée", `${l.fournisseur} — ${formatDate(l.date)}`);
  }
  async function rattacherPaiementTransport(opId, ligneId) {
    const ti = transportIntl || TRANSPORT_INTL_VIDE;
    if (ligneId === "__ignore") { await persistTransportIntl({ ...ti, ignores: [...(ti.ignores || []), opId] }); return; }
    await persistTransportIntl({ ...ti, lignes: ti.lignes.map((x) => (x.id === ligneId ? { ...x, operationIds: [...new Set([...(x.operationIds || []), opId])] } : x)) });
  }
  function rendreTransportIntl() {
    const ti = transportIntl || TRANSPORT_INTL_VIDE;
    const lignes = [...(ti.lignes || [])].sort((a, b) => (a.date < b.date ? 1 : -1));
    const aRattacher = paiementsTransitaireARattacher();
    const deb = decalerJours(todayISO(), -365);
    const groupes = new Map();
    lignes.filter((l) => l.date >= deb).forEach((l) => { const k = `${l.pays}|${l.incoterm}|${l.taille}`; if (!groupes.has(k)) groupes.set(k, { pays: l.pays, incoterm: l.incoterm, taille: l.taille }); });
    const th = { fontSize: 10, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.4, textAlign: "left", padding: "6px 8px", borderBottom: `1px solid ${PIERRE}`, whiteSpace: "nowrap" };
    const td = { fontSize: 12, padding: "6px 8px", borderBottom: `1px solid ${PIERRE}`, whiteSpace: "nowrap" };
    const n = (v) => (v === "" || v === null || v === undefined ? "—" : formatDH(Number(v)));
    const arr = (id) => { const a = (arrivagesImport || []).find((x) => x.id === id); return a ? a.numero || a.numeroFacture || "arrivage" : ""; };
    const carte = { background: "#fff", borderRadius: 10, padding: 16, marginBottom: 18 };
    return (
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 6 }}>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, fontWeight: 600 }}>Transport international</div>
          <button type="button" className="sc-btn" onClick={() => setLigneTransportEdit(nouvelleLigneTransport())} style={{ ...primaryBtnStyle, marginLeft: "auto" }}>+ Conteneur</button>
        </div>
        <div style={{ fontSize: 12, color: TAUPE, marginBottom: 16, lineHeight: 1.5 }}>Une ligne par conteneur importé. Les encadrés « Conteneur 20 / 40 pieds » du Calcul de revient (Prix et coûts) prennent la moyenne des 12 derniers mois par taille, pays et incoterm ; sans ligne, ils gardent la valeur de départ saisie par le Gérant.</div>

        {aRattacher.length > 0 && (
          <div style={{ ...carte, border: `1px solid ${OCRE}` }}>
            <div style={{ fontSize: 11, color: OCRE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 8 }}>Paiements transitaire (CFG) à rattacher — {aRattacher.length}</div>
            {aRattacher.map((o) => (
              <div key={o.id} style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", fontSize: 13, padding: "6px 0", borderBottom: `1px solid ${PIERRE}` }}>
                <span style={{ width: 90 }}>{formatDate(o.date)}</span>
                <span style={{ flex: 1, minWidth: 200 }}>{o.tiers ? <strong>{o.tiers}</strong> : null}{o.tiers ? " — " : ""}{o.designation}</span>
                <span style={{ fontWeight: 600 }}>{formatDH(Number(o.montant) || 0)}</span>
                <button type="button" className="sc-btn" onClick={() => setLigneTransportEdit(nouvelleLigneTransport({ date: o.date, operationIds: [o.id], note: o.designation || "" }))} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 10px" }}>+ Nouveau conteneur</button>
                <select className="sc-select" aria-label="Rattacher le paiement" value="" onChange={(e) => e.target.value && rattacherPaiementTransport(o.id, e.target.value)} style={{ ...selectStyle, width: 230, padding: "4px 6px", fontSize: 12, background: "#fff" }}>
                  <option value="">Rattacher à un conteneur…</option>
                  {lignes.slice(0, 30).map((l) => <option key={l.id} value={l.id}>{formatDate(l.date)} — {l.fournisseur} {l.taille}'</option>)}
                  <option value="__ignore">Pas lié à un conteneur</option>
                </select>
              </div>
            ))}
          </div>
        )}

        <div style={carte}>
          <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Moyennes sur 12 mois glissants (utilisées dans le coût de revient)</div>
          {groupes.size === 0 ? <div style={{ fontSize: 13, color: TAUPE }}>Aucun conteneur sur les 12 derniers mois.</div> : (
            <table style={{ borderCollapse: "collapse", width: "100%" }}>
              <thead><tr>{["Pays", "Incoterm", "Taille", "Conteneurs", "Fret", "Dédouanement", "Transp. local", "Déchargement", "Total HT"].map((h) => <th key={h} style={th}>{h}</th>)}</tr></thead>
              <tbody>{[...groupes.values()].sort((a, b) => (a.pays + a.incoterm + a.taille).localeCompare(b.pays + b.incoterm + b.taille, "fr")).map((g) => {
                const m = moyenneTransport(g.taille, g.pays, g.incoterm);
                const tot = POSTES_LOGI.reduce((x, k) => x + (m[k] || 0), 0);
                return <tr key={`${g.pays}${g.incoterm}${g.taille}`}><td style={td}>{g.pays}</td><td style={td}>{g.incoterm}</td><td style={td}>{g.taille} pieds</td><td style={td}>{m.n}</td><td style={td}>{n(m.transport)}</td><td style={td}>{n(m.dedouanement)}</td><td style={td}>{n(m.transportLocal)}</td><td style={td}>{n(m.dechargement)}</td><td style={{ ...td, fontWeight: 600 }}>{formatDH(tot)}</td></tr>;
              })}</tbody>
            </table>
          )}
        </div>

        <div style={carte}>
          <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Conteneurs ({lignes.length})</div>
          {lignes.length === 0 ? <div style={{ fontSize: 13, color: TAUPE }}>Aucun conteneur saisi.</div> : (
            <div style={{ overflowX: "auto" }}>
              <table style={{ borderCollapse: "collapse", width: "100%" }}>
                <thead><tr>{["Date", "Fournisseur", "Pays", "Incoterm", "Taille", "Arrivage", "Fret", "Dédouanement", "Transp. local", "Déchargement", "Total HT", "Paiements", ""].map((h, i) => <th key={i} style={th}>{h}</th>)}</tr></thead>
                <tbody>{lignes.map((l0) => {
                  const pl = postesLigneTransport(l0);
                  const l = { ...l0, ...pl };
                  const tot = POSTES_LOGI.reduce((x, k) => x + nombreOuZero(pl[k]), 0);
                  const hors = l.date < deb;
                  return (
                    <tr key={l.id} style={{ opacity: hors ? 0.55 : 1 }} title={hors ? "Plus de 12 mois : hors moyenne" : ""}>
                      <td style={td}>{formatDate(l.date)}</td><td style={td}>{l.fournisseur}</td><td style={td}>{l.pays}</td><td style={td}>{l.incoterm}</td><td style={td}>{l.taille}'</td><td style={td}>{arr(l.arrivageId) || "—"}</td>
                      <td style={td}>{n(l.transport)}</td><td style={td} title={pl.honoraires !== null ? `honoraires ${formatDH(pl.honoraires)} · surestaries ${formatDH(nombreOuZero(l0.surestaries))} · autres frais ${formatDH(nombreOuZero(l0.autresTransitaire))} · droits ${formatDH(nombreOuZero(l0.droits))} · autres taxes ${formatDH(nombreOuZero(l0.autresTaxes))}${nombreOuZero(l0.tvaImport) ? ` · TVA import ${formatDH(nombreOuZero(l0.tvaImport))} (hors coût)` : ""}` : ""}>{n(l.dedouanement)}</td><td style={td}>{n(l.transportLocal)}</td><td style={td}>{n(l.dechargement)}</td><td style={{ ...td, fontWeight: 600 }}>{formatDH(tot)}</td>
                      <td style={td}>{(l.operationIds || []).length || "—"}</td>
                      <td style={td}>
                        <button type="button" className="sc-btn" onClick={() => setLigneTransportEdit({ ...nouvelleLigneTransport(), ...l0 })} style={iconBtnStyle} title="Modifier">✎</button>
                        <button type="button" className="sc-btn" onClick={() => supprimerLigneTransport(l0)} style={iconBtnStyle} title="Supprimer">✕</button>
                      </td>
                    </tr>
                  );
                })}</tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    );
  }
  function rendreModaleTransport() {
    const f = ligneTransportEdit;
    if (!f) return null;
    const set = (patch) => setLigneTransportEdit({ ...f, ...patch });
    const etrangers = (fournisseurs || []).filter((x) => x.origine === "Étranger").sort((a, b) => a.nom.localeCompare(b.nom, "fr"));
    const arrivages = (arrivagesImport || []).filter((a) => !f.fournisseur || normLib(a.fournisseur) === normLib(f.fournisseur)).slice().sort((a, b) => ((a.creeLe || "") < (b.creeLe || "") ? 1 : -1));
    const ops = (f.operationIds || []).map((id) => (operations || []).find((o) => o.id === id)).filter(Boolean);
    const num = (k, lib) => (
      <Field label={`${lib} (DH)`} style={{ flex: 1 }}>
        <input type="number" min="0" step="0.01" className="sc-input" value={f[k] ?? ""} onChange={(e) => set({ [k]: e.target.value })} style={inputStyle("100%")} />
      </Field>
    );
    return (
      <Overlay onClose={() => setLigneTransportEdit(null)}>
        <div style={modalStyle(620)}>
          <div style={modalTitleStyle}>{f.id ? "Modifier le conteneur" : "Nouveau conteneur"}</div>
          <div style={{ display: "flex", gap: 10 }}>
            <Field label="Date" style={{ flex: 1 }}><input type="date" className="sc-input" value={f.date || ""} onChange={(e) => set({ date: e.target.value })} style={inputStyle("100%")} /></Field>
            <Field label="Fournisseur" style={{ flex: 2 }}>
              <select className="sc-select" value={f.fournisseur} onChange={(e) => { const pi = paysIncotermFournisseur(e.target.value); set({ fournisseur: e.target.value, pays: pi.pays || f.pays, incoterm: pi.incoterm || f.incoterm, arrivageId: "" }); }} style={selectStyle}>
                <option value="">— Choisir —</option>
                {etrangers.map((x) => <option key={x.id} value={x.nom}>{x.nom}</option>)}
              </select>
            </Field>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <Field label="Pays d'import" style={{ flex: 1 }}><input className="sc-input" value={f.pays || ""} onChange={(e) => set({ pays: e.target.value })} style={inputStyle("100%")} /></Field>
            <Field label="Incoterm" style={{ flex: 1 }}>
              <select className="sc-select" value={f.incoterm || ""} onChange={(e) => set({ incoterm: e.target.value })} style={selectStyle}>
                <option value="">—</option>
                {INCOTERMS.map((x) => <option key={x} value={x}>{x}</option>)}
              </select>
            </Field>
            <Field label="Conteneur" style={{ flex: 1 }}>
              <select className="sc-select" value={f.taille} onChange={(e) => set({ taille: Number(e.target.value) })} style={selectStyle}>
                <option value={20}>20 pieds</option>
                <option value={40}>40 pieds</option>
              </select>
            </Field>
          </div>
          {f.fournisseur && !paysIncotermFournisseur(f.fournisseur).incoterm && <div style={{ fontSize: 11, color: OCRE, marginTop: -6, marginBottom: 10 }}>Pays / incoterm habituels pas encore renseignés sur la fiche de ce fournisseur (onglet Fournisseurs).</div>}
          <Field label="Arrivage import (facultatif)">
            <select className="sc-select" value={f.arrivageId || ""} onChange={(e) => set({ arrivageId: e.target.value })} style={selectStyle}>
              <option value="">— Aucun —</option>
              {arrivages.map((a) => <option key={a.id} value={a.id}>{a.numero || "Arrivage"}{a.fournisseur ? ` — ${a.fournisseur}` : ""}{a.numeroFacture ? ` (fact. ${a.numeroFacture})` : ""}</option>)}
            </select>
          </Field>
          {(() => {
            const pl = postesLigneTransport(f);
            const bloc = { border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "8px 12px", marginBottom: 10 };
            const titre = (t, aide) => <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 2 }}>{t} <span style={{ fontWeight: 400, color: TAUPE }}>— {aide}</span></div>;
            const ancien = String(f.dedouanement ?? "").trim() !== "" && ["transitaireTotal", "droits", "autresTaxes", "surestaries", "transportLocal", "autresTransitaire"].every((k) => String(f[k] ?? "").trim() === "");
            return (
              <>
                <div style={{ fontSize: 12, background: "#F4ECD8", borderRadius: 8, padding: "8px 12px", marginBottom: 10, lineHeight: 1.5 }}>
                  <b>Règles de saisie :</b> tous les montants <b>HT, en DH</b> · une facture = un bloc · la TVA n'est jamais un coût (TVA à l'importation : suivie seulement).
                </div>
                <div style={bloc}>
                  {titre("1. Fret", "facture du transporteur maritime (selon l'incoterm)")}
                  {num("transport", "Transport international HT")}
                </div>
                <div style={bloc}>
                  {titre("2. Facture du transitaire", "saisis le total HT, puis ce qu'il contient ; les honoraires = le reste")}
                  <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                    {num("transitaireTotal", "Total HT de la facture")}
                    {num("transportLocal", "dont transport local (port → atelier)")}
                    {num("surestaries", "dont surestaries")}
                    {num("autresTransitaire", "dont autres frais")}
                  </div>
                  <div style={{ fontSize: 12, color: pl.honoraires !== null && pl.honoraires < 0 ? ROUILLE : ENCRE }}>
                    Honoraires du transitaire (calculés) : <b>{pl.honoraires !== null ? formatDH(pl.honoraires) : "—"}</b>
                    {pl.honoraires !== null && pl.honoraires < 0 ? " — les « dont » dépassent le total de la facture" : ""}
                  </div>
                </div>
                <div style={bloc}>
                  {titre("3. Quittance de douane", "droits et taxes payés à la douane")}
                  <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                    {num("droits", "Droits de douane")}
                    {num("autresTaxes", "Autres taxes")}
                    {num("tvaImport", "TVA à l'importation (hors coût)")}
                  </div>
                </div>
                <div style={bloc}>
                  {titre("4. Déchargement", "à l'atelier")}
                  {num("dechargement", "Déchargement HT")}
                </div>
                {ancien && <div style={{ fontSize: 11, color: OCRE, marginBottom: 8 }}>Ancienne saisie : dédouanement global {formatDH(nombreOuZero(f.dedouanement))} (gardé tant que le détail n'est pas saisi).</div>}
                <div style={{ fontSize: 12, marginBottom: 10 }}>
                  Coût du conteneur (hors TVA) : fret {formatDH(nombreOuZero(pl.transport))} + dédouanement {formatDH(nombreOuZero(pl.dedouanement))} + transport local {formatDH(nombreOuZero(pl.transportLocal))} + déchargement {formatDH(nombreOuZero(pl.dechargement))} = <b>{formatDH(POSTES_LOGI.reduce((n, k) => n + nombreOuZero(pl[k]), 0))}</b>
                </div>
              </>
            );
          })()}
          <Field label="Note"><input className="sc-input" value={f.note || ""} onChange={(e) => set({ note: e.target.value })} style={inputStyle("100%")} /></Field>
          {ops.length > 0 && (
            <div style={{ fontSize: 12, color: TAUPE, marginBottom: 10 }}>
              Paiements CFG rattachés : {ops.map((o) => `${formatDate(o.date)} ${formatDH(Number(o.montant) || 0)}`).join(" · ")}
            </div>
          )}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
            <button type="button" className="sc-btn" onClick={() => setLigneTransportEdit(null)} style={ghostBtnStyle}>Annuler</button>
            <button type="button" className="sc-btn" onClick={enregistrerLigneTransport} style={primaryBtnStyle}>Enregistrer</button>
          </div>
        </div>
      </Overlay>
    );
  }
  function rendreEcheancier() {
    const auj = todayISO();
    const toutes = (facturesF || []).map((fa) => ({ fa, st: statutFactureF(fa), reste: resteFactureF(fa), ech: echeanceFactureF(fa), ttc: ttcFactureF(fa), regle: regleFactureF(fa.id) }));
    const ouvertes = toutes.filter((y) => y.reste > 0.01 && !y.fa.remplaceePar);
    const somme = (l) => l.reduce((n, y) => n + y.reste, 0);
    const enRetard = ouvertes.filter((y) => y.st.code === "retard" || y.st.code === "legal");
    const legal = ouvertes.filter((y) => y.st.code === "legal");
    const legalProche = ouvertes.filter((y) => { const j = joursAvantLimiteLegale(y.fa); return j !== null && j <= JOURS_ALERTE_LIMITE_LEGALE; });
    const dans = (j) => ouvertes.filter((y) => y.fa.type !== "devis" && y.ech && y.ech >= auj && ecartJours(y.ech, auj) <= j);
    const nbControle = toutes.filter((y) => y.fa.controle === "à contrôler").length;
    const liste = toutes
      .filter((y) => !fournisseurEcheancier || y.fa.fournisseur === fournisseurEcheancier)
      .filter((y) => filtreEcheancier === "toutes" || (filtreEcheancier === "apayer" && y.reste > 0.01 && !y.fa.remplaceePar) || (filtreEcheancier === "retard" && (y.st.code === "retard" || y.st.code === "legal" || y.st.code === "devis-retard")) || (filtreEcheancier === "controler" && y.fa.controle === "à contrôler") || (filtreEcheancier === "payees" && (y.reste <= 0.01 || y.fa.remplaceePar)))
      .sort((a, b) => ((a.ech || a.fa.date) < (b.ech || b.fa.date) ? -1 : (a.ech || a.fa.date) > (b.ech || b.fa.date) ? 1 : 0));
    const parFournisseur = Object.entries(ouvertes.reduce((m, y) => { m[y.fa.fournisseur] = (m[y.fa.fournisseur] || 0) + y.reste; return m; }, {})).sort((a, b) => b[1] - a[1]);
    const grille = "0.9fr 0.9fr 1.5fr 1.3fr 1fr 1fr 1fr 1.6fr 0.9fr";
    let moisCourant = null;
    const tuile = (titre, val, sous, couleur) => (
      <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: "8px 14px", minWidth: 150 }}>
        <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>{titre}</div>
        <div style={{ fontSize: 16, fontWeight: 600, color: couleur || ENCRE }}>{val}</div>
        {sous && <div style={{ fontSize: 11, color: TAUPE }}>{sous}</div>}
      </div>
    );
    return (
      <div>
        {/* Nils 09/10 : tuiles de montants masquées pour Ahmed et Wissam (saisie seule). */}
        {peut("compta.facturesF.controler") && <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 14 }}>
          {tuile("Total dû", formatDH(somme(ouvertes)), `${ouvertes.length} pièce(s)`)}
          {tuile("À payer sous 7 j", formatDH(somme(dans(JOURS_ALERTE_ECHEANCE))), `${dans(JOURS_ALERTE_ECHEANCE).length} facture(s)`, dans(JOURS_ALERTE_ECHEANCE).length ? OCRE : ENCRE)}
          {tuile("À payer sous 30 j", formatDH(somme(dans(30))), `${dans(30).length} facture(s)`)}
          {tuile("En retard", formatDH(somme(enRetard)), `${enRetard.length} facture(s)`, enRetard.length ? ROUILLE : ENCRE)}
          {tuile(`Limite légale sous ${JOURS_ALERTE_LIMITE_LEGALE} j`, formatDH(somme(legalProche)), legalProche.length ? `${legalProche.length} facture(s) — à payer avant le ${formatDate(legalProche.map((y) => limiteLegaleFactureF(y.fa)).sort()[0])}` : "aucune", legalProche.length ? OCRE : VERT_OK)}
          {tuile("Délai légal dépassé", formatDH(somme(legal)), legal.length ? `amende estimée ${formatDH(legal.reduce((n, y) => n + amendeFactureF(y.fa), 0))}` : "aucune", legal.length ? ROUILLE : VERT_OK)}
          {nbControle > 0 && tuile("À contrôler (Administration)", String(nbControle), "saisies du Production Manager / bureau technique", OCRE)}
        </div>}
        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 12 }}>
          <select className="sc-select" value={filtreEcheancier} onChange={(e) => setFiltreEcheancier(e.target.value)} style={{ ...selectStyle, width: "auto" }}>
            <option value="apayer">À payer</option>
            <option value="retard">En retard</option>
            <option value="controler">À contrôler ({nbControle})</option>
            <option value="payees">Payées</option>
            <option value="toutes">Toutes</option>
          </select>
          <select className="sc-select" value={fournisseurEcheancier} onChange={(e) => setFournisseurEcheancier(e.target.value)} style={{ ...selectStyle, width: "auto" }}>
            <option value="">Tous les fournisseurs</option>
            {[...new Set(toutes.map((y) => y.fa.fournisseur))].sort((a, b) => a.localeCompare(b, "fr")).map((n) => (<option key={n} value={n}>{n}</option>))}
          </select>
          {peutSaisirFactureF && (
            <>
              <button type="button" className="sc-btn" onClick={() => setFactFEdit(nouvelleFactureF("fournisseur", fournisseurEcheancier, "facture"))} style={{ ...primaryBtnStyle, fontSize: 12, padding: "6px 14px" }}>+ Facture fournisseur</button>
              <button type="button" className="sc-btn" onClick={() => setFactFEdit(nouvelleFactureF("fournisseur", fournisseurEcheancier, "devis"))} style={{ ...ghostBtnStyle, fontSize: 12 }}>+ Devis / proforma (acompte)</button>
            </>
          )}
        </div>
        <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden", marginBottom: 14 }}>
          <div style={{ display: "grid", gridTemplateColumns: grille, padding: "10px 16px", background: PIERRE, gap: 8 }}>
            <Th>Échéance</Th><Th>Limite légale</Th><Th>Fournisseur</Th><Th>Pièce</Th><Th>TTC</Th><Th>Payé</Th><Th>Reste</Th><Th>Statut</Th><Th>Contrôle</Th>
          </div>
          {liste.length === 0 && <div style={{ padding: 16, fontSize: 13, color: TAUPE }}>Aucune facture.</div>}
          {liste.map((y) => {
            const m = (y.ech || y.fa.date || "").slice(0, 7);
            const entete = filtreEcheancier === "apayer" && m !== moisCourant;
            if (entete) moisCourant = m;
            const duMois = entete ? liste.filter((z) => (z.ech || z.fa.date || "").slice(0, 7) === m).reduce((n, z) => n + z.reste, 0) : 0;
            return (
              <React.Fragment key={y.fa.id}>
                {entete && <div style={{ padding: "6px 16px", fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, borderBottom: `1px solid ${PIERRE}`, display: "flex", justifyContent: "space-between" }}><span>{m ? `${MOIS_COMPTABLE[Number(m.slice(5, 7)) - 1]} ${m.slice(0, 4)}` : "—"}</span><span>{formatDH(duMois)}</span></div>}
                <div className="sc-row" onClick={() => setFactFEdit({ ...y.fa })} style={{ display: "grid", gridTemplateColumns: grille, padding: "9px 16px", gap: 8, alignItems: "center", borderBottom: `1px solid ${PIERRE}`, fontSize: 13, cursor: "pointer" }}>
                  <div>{y.ech ? formatDate(y.ech) : "—"}</div>
                  {(() => { const lim = limiteLegaleFactureF(y.fa), jl = joursAvantLimiteLegale(y.fa); return <div style={{ color: y.st.code === "legal" ? ROUILLE : jl !== null && jl <= JOURS_ALERTE_LIMITE_LEGALE ? OCRE : TAUPE, fontWeight: jl !== null && jl <= JOURS_ALERTE_LIMITE_LEGALE ? 600 : 400 }}>{lim ? formatDate(lim) : "—"}</div>; })()}
                  <div>{y.fa.fournisseur}</div>
                  <div>{y.fa.type === "devis" ? "Devis" : "Fact."} {y.fa.numero || "sans n°"}{(y.fa.piecesJointes || []).length > 0 && <span title={`Pièces jointes : ${(y.fa.piecesJointes || []).map((x) => x.nom).join(", ")}`} style={{ marginLeft: 6, fontSize: 12 }}>📎{(y.fa.piecesJointes || []).length > 1 ? (y.fa.piecesJointes || []).length : ""}</span>}<div style={{ fontSize: 11, color: TAUPE }}>du {formatDate(y.fa.date)}</div></div>
                  <div>{formatDH(y.ttc)}</div>
                  <div>{y.regle ? formatDH(y.regle) : "—"}</div>
                  <div style={{ fontWeight: 600 }}>{y.reste > 0.01 && !y.fa.remplaceePar ? formatDH(y.reste) : "—"}{estGerant && y.reste > 0.01 && !y.fa.remplaceePar && compteDe("banque-cfg") && <div><button type="button" className="sc-btn" onClick={(e) => { e.stopPropagation(); reglerFactureF(y.fa); }} title="Enregistrer le paiement sur la CFG" style={{ ...ghostBtnStyle, fontSize: 11, padding: "2px 0", color: ROUILLE }}>Régler</button></div>}</div>
                  <div style={{ fontSize: 12, color: y.st.couleur }}>{y.st.libelle}{amendeFactureF(y.fa) > 0 ? <div style={{ fontSize: 11 }}>amende estimée {formatDH(amendeFactureF(y.fa))}</div> : null}</div>
                  <div style={{ fontSize: 11, color: y.fa.controle === "à contrôler" ? OCRE : TAUPE }}>{y.fa.controle === "à contrôler" ? `à contrôler (${y.fa.par})` : "✓"}</div>
                </div>
              </React.Fragment>
            );
          })}
        </div>
        {parFournisseur.length > 0 && (
          <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: "10px 16px", marginBottom: 12 }}>
            <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Dû par fournisseur</div>
            {parFournisseur.map(([n, v]) => (
              <div key={n} className="sc-row" onClick={() => setFournisseurEcheancier(n)} style={{ display: "flex", justifyContent: "space-between", fontSize: 12, padding: "3px 0", borderBottom: `1px solid ${PIERRE}`, cursor: "pointer" }}><span>{n}</span><strong>{formatDH(v)}</strong></div>
            ))}
          </div>
        )}
        <div style={{ fontSize: 11, color: TAUPE, lineHeight: 1.6 }}>Limite légale = date au-delà de laquelle l'amende court (alerte et tâche {JOURS_ALERTE_LIMITE_LEGALE} jours avant). Échéance = date de facture + délai des conditions de paiement du fournisseur, plafonné à {DELAI_LEGAL_JOURS} j (loi 69-21) ou {DELAI_CONVENTION_MAX} j avec une convention de paiement cochée sur sa fiche. Au-delà, amende au Trésor estimée à {(AMENDE_TAUX_1ER_MOIS * 100).toLocaleString("fr-FR")} % le 1er mois + {(AMENDE_TAUX_MOIS_SUIVANT * 100).toLocaleString("fr-FR")} % par mois suivant sur le TTC non payé — estimation, à faire confirmer par le comptable. Les paiements se rattachent aux factures dans la saisie d'une sortie (obligatoire sur la banque). Factures saisies par le Production Manager ou le bureau technique : contrôle par l'Administration.</div>
      </div>
    );
  }
  // Blocs de gestion réutilisés dans Paramétrage et directement dans la saisie (Nils 30/09).
  function blocPlanPostes() {
    return (
              <>
                {planPostes().map((p) => (
                  <div key={p.poste} style={{ padding: "8px 0", borderBottom: `1px solid ${PIERRE}` }}>
                    <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6, display: "flex", alignItems: "center", gap: 6 }}>{p.poste} <span style={{ fontSize: 11, color: TAUPE, fontWeight: 400 }}>— {p.sens === "entree" ? "entrées" : p.sens === "sortie" ? "sorties" : "entrées et sorties"}</span>{p.poste !== POSTE_ENCAISSEMENT && p.poste !== POSTE_A_DEFINIR && <button type="button" className="sc-btn" onClick={() => supprimerPoste(p.poste)} style={{ ...iconBtnStyle, fontSize: 11 }} title="Supprimer le poste">✕</button>}</div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center" }}>
                      {p.sous.map((sp) => (
                        sousPosteEdition && sousPosteEdition.poste === p.poste && sousPosteEdition.ancien === sp ? (
                          <span key={sp} style={{ display: "flex", gap: 4, alignItems: "center" }}>
                            <input className="sc-input" autoFocus value={sousPosteEdition.valeur} onChange={(e) => setSousPosteEdition({ ...sousPosteEdition, valeur: e.target.value })} onKeyDown={async (e) => { if (e.key === "Enter") { await renommerSousPoste(p.poste, sp, sousPosteEdition.valeur); setSousPosteEdition(null); } if (e.key === "Escape") setSousPosteEdition(null); }} style={{ ...inputStyle(180), padding: "3px 8px", fontSize: 12 }} />
                            <button type="button" className="sc-btn" onClick={async () => { await renommerSousPoste(p.poste, sp, sousPosteEdition.valeur); setSousPosteEdition(null); }} style={iconBtnStyle} title="Valider">✓</button>
                            <button type="button" className="sc-btn" onClick={() => setSousPosteEdition(null)} style={iconBtnStyle} title="Annuler">↩</button>
                          </span>
                        ) : (
                          <span key={sp} style={{ fontSize: 12, background: PIERRE, borderRadius: 14, padding: "3px 6px 3px 10px", display: "flex", alignItems: "center", gap: 2 }}>
                            {sp}
                            {p.poste !== POSTE_ENCAISSEMENT && p.poste !== POSTE_A_DEFINIR && (
                              <>
                                <button type="button" className="sc-btn" onClick={() => setSousPosteEdition({ poste: p.poste, ancien: sp, valeur: sp })} style={{ ...iconBtnStyle, fontSize: 11 }} title="Renommer">✎</button>
                                <button type="button" className="sc-btn" onClick={() => supprimerSousPoste(p.poste, sp)} style={{ ...iconBtnStyle, fontSize: 11 }} title="Supprimer">✕</button>
                              </>
                            )}
                          </span>
                        )
                      ))}
                      {p.poste !== POSTE_ENCAISSEMENT && p.poste !== POSTE_A_DEFINIR && (
                        <span style={{ display: "flex", gap: 4 }}>
                          <input className="sc-input" value={nouveauSousPoste[p.poste] || ""} onChange={(e) => setNouveauSousPoste({ ...nouveauSousPoste, [p.poste]: e.target.value })} onKeyDown={(e) => { if (e.key === "Enter") ajouterSousPoste(p.poste); }} placeholder="+ sous-poste" style={{ ...inputStyle(140), padding: "3px 8px", fontSize: 12 }} />
                          {(nouveauSousPoste[p.poste] || "").trim() && <button type="button" className="sc-btn" onClick={() => ajouterSousPoste(p.poste)} style={iconBtnStyle} title="Ajouter">✓</button>}
                        </span>
                      )}
                    </div>
                  </div>
                ))}
                <div style={{ display: "flex", gap: 6, alignItems: "center", marginTop: 10, flexWrap: "wrap" }}>
                  <input className="sc-input" value={nouveauPoste.nom} onChange={(e) => setNouveauPoste({ ...nouveauPoste, nom: e.target.value })} onKeyDown={(e) => { if (e.key === "Enter") ajouterPoste(); }} placeholder="Nouveau poste" style={{ ...inputStyle(220), padding: "4px 8px", fontSize: 12 }} />
                  <select className="sc-select" value={nouveauPoste.sens} onChange={(e) => setNouveauPoste({ ...nouveauPoste, sens: e.target.value })} style={{ ...selectStyle, width: "auto", fontSize: 12 }}>
                    <option value="sortie">sorties</option><option value="entree">entrées</option><option value="les deux">entrées et sorties</option>
                  </select>
                  <button type="button" className="sc-btn" onClick={ajouterPoste} disabled={!nouveauPoste.nom.trim()} style={{ ...ghostBtnStyle, fontSize: 12, opacity: nouveauPoste.nom.trim() ? 1 : 0.5 }}>Ajouter le poste</button>
                </div>
              </>
    );
  }
  function blocTiersEtatAssocies(cles) {
    return (
              <>
                {[["organismesEtat", "Organismes de l'État", organismesEtat()], ["associes", "Associés", associes()]].filter(([cle]) => cles.includes(cle)).map(([cle, titre, liste]) => (
                  <div key={cle} style={{ marginBottom: 12 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>{titre}</div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center" }}>
                      {liste.map((n) => (
                        <span key={n} style={{ fontSize: 12, background: PIERRE, borderRadius: 14, padding: "3px 6px 3px 10px", display: "flex", alignItems: "center", gap: 4 }}>
                          {n}
                          <button type="button" className="sc-btn" onClick={async () => { const nb = (operations || []).filter((o) => o.tiersType === (cle === "associes" ? "associe" : "etat") && o.tiers === n).length; if (nb) { setNotice(`Impossible : ${nb} opération(s) utilisent « ${n} ».`); return; } await persistParametres({ ...(parametres || {}), [cle]: liste.filter((x) => x !== n) }); await tracerAcces(`comptabilité : ${titre.toLowerCase()} modifiés`, `retiré : ${n}`); }} style={{ ...iconBtnStyle, fontSize: 11 }} title="Retirer">✕</button>
                        </span>
                      ))}
                      <input className="sc-input" value={nouveauTiersParam[cle] || ""} onChange={(e) => setNouveauTiersParam({ ...nouveauTiersParam, [cle]: e.target.value })} onKeyDown={async (e) => { if (e.key !== "Enter") return; const v = (nouveauTiersParam[cle] || "").trim(); if (!v || liste.some((x) => normLib(x) === normLib(v))) return; await persistParametres({ ...(parametres || {}), [cle]: [...liste, v] }); await tracerAcces(`comptabilité : ${titre.toLowerCase()} modifiés`, `ajouté : ${v}`); setNouveauTiersParam({ ...nouveauTiersParam, [cle]: "" }); }} placeholder="+ ajouter (Entrée)" style={{ ...inputStyle(180), padding: "3px 8px", fontSize: 12 }} />
                    </div>
                  </div>
                ))}
              </>
    );
  }
  function blocTypesTiers() {
    const liste = typesTiersPerso();
    const utilise = (id, nom) => (operations || []).filter((o) => o.tiersType === id && (nom === undefined || o.tiers === nom)).length;
    const majType = (id, patch, trace) => persistTypesTiersPerso(liste.map((t) => (t.id === id ? { ...t, ...patch } : t)), trace);
    return (
      <>
        <div style={{ fontSize: 12, color: TAUPE, marginBottom: 10 }}>Types fixes : Client, Fournisseur, Employé (Staff), État / organisme, Associé, Banque (les comptes bancaires : frais, agios, intérêts). Ajoute ici d'autres types (ex. « Leasing », « Assurance — remboursement »), avec leurs noms.</div>
        {liste.length === 0 && <div style={{ fontSize: 13, color: TAUPE, marginBottom: 10 }}>Aucun type ajouté.</div>}
        {liste.map((t) => (
          <div key={t.id} style={{ padding: "8px 0", borderBottom: `1px solid ${PIERRE}` }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6, flexWrap: "wrap" }}>
              <strong style={{ fontSize: 13 }}>{t.libelle}</strong>
              <select className="sc-select" value={t.sens} onChange={(e) => majType(t.id, { sens: e.target.value }, `${t.libelle} : ${e.target.value}`)} style={{ ...selectStyle, width: "auto", fontSize: 12 }}>
                <option value="entree">entrées</option><option value="sortie">sorties</option><option value="les deux">entrées et sorties</option>
              </select>
              <button type="button" className="sc-btn" onClick={async () => { const n = utilise(t.id); if (n) { setNotice(`Impossible : ${n} opération(s) utilisent le type « ${t.libelle} ».`); return; } if (await demander(`Supprimer le type « ${t.libelle} » ?`)) await persistTypesTiersPerso(liste.filter((x) => x.id !== t.id), `supprimé : ${t.libelle}`); }} style={{ ...iconBtnStyle, fontSize: 11 }} title="Supprimer le type">✕</button>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center" }}>
              {(t.noms || []).map((n) => (
                <span key={n} style={{ fontSize: 12, background: PIERRE, borderRadius: 14, padding: "3px 6px 3px 10px", display: "flex", alignItems: "center", gap: 4 }}>
                  {n}
                  <button type="button" className="sc-btn" onClick={async () => { const k = utilise(t.id, n); if (k) { setNotice(`Impossible : ${k} opération(s) utilisent « ${n} ».`); return; } await majType(t.id, { noms: (t.noms || []).filter((x) => x !== n) }, `${t.libelle} : retiré ${n}`); }} style={{ ...iconBtnStyle, fontSize: 11 }} title="Retirer">✕</button>
                </span>
              ))}
              <input className="sc-input" value={nouveauTiersParam[t.id] || ""} onChange={(e) => setNouveauTiersParam({ ...nouveauTiersParam, [t.id]: e.target.value })} onKeyDown={async (e) => { if (e.key !== "Enter") return; const v = (nouveauTiersParam[t.id] || "").trim(); if (!v || (t.noms || []).some((x) => normLib(x) === normLib(v))) return; await majType(t.id, { noms: [...(t.noms || []), v] }, `${t.libelle} : ajouté ${v}`); setNouveauTiersParam({ ...nouveauTiersParam, [t.id]: "" }); }} placeholder="+ nom (Entrée)" style={{ ...inputStyle(180), padding: "3px 8px", fontSize: 12 }} />
            </div>
          </div>
        ))}
        <div style={{ display: "flex", gap: 6, alignItems: "center", marginTop: 12, flexWrap: "wrap" }}>
          <input className="sc-input" value={nouveauTypeTiers.libelle} onChange={(e) => setNouveauTypeTiers({ ...nouveauTypeTiers, libelle: e.target.value })} placeholder="Nouveau type de tiers" style={{ ...inputStyle(220), padding: "4px 8px", fontSize: 12 }} />
          <select className="sc-select" value={nouveauTypeTiers.sens} onChange={(e) => setNouveauTypeTiers({ ...nouveauTypeTiers, sens: e.target.value })} style={{ ...selectStyle, width: "auto", fontSize: 12 }}>
            <option value="entree">entrées</option><option value="sortie">sorties</option><option value="les deux">entrées et sorties</option>
          </select>
          <button type="button" className="sc-btn" disabled={!nouveauTypeTiers.libelle.trim()} onClick={async () => { const v = nouveauTypeTiers.libelle.trim(); if (!v) return; if ([...Object.values(TYPES_TIERS), ...liste.map((x) => x.libelle)].some((x) => normLib(x) === normLib(v))) { setNotice("Ce type existe déjà."); return; } await persistTypesTiersPerso([...liste, { id: `perso:${uid()}`, libelle: v, sens: nouveauTypeTiers.sens, noms: [] }], `ajouté : ${v} (${nouveauTypeTiers.sens})`); setNouveauTypeTiers({ libelle: "", sens: "entree" }); }} style={{ ...ghostBtnStyle, fontSize: 12, opacity: nouveauTypeTiers.libelle.trim() ? 1 : 0.5 }}>Ajouter le type</button>
        </div>
      </>
    );
  }
  async function ajouterPoste() {
    if (!peut("compta.parametrer")) return;
    const v = (nouveauPoste.nom || "").trim();
    if (!v) return;
    const plan = planPostes();
    if (plan.some((x) => normLib(x.poste) === normLib(v)) || normLib(v) === "transfert") { setNotice("Ce poste existe déjà."); return; }
    const i = plan.findIndex((x) => x.poste === POSTE_A_DEFINIR);
    const nouveau = { poste: v, sens: nouveauPoste.sens, sous: [v] };
    await persistParametres({ ...(parametres || {}), planPostes: i >= 0 ? [...plan.slice(0, i), nouveau, ...plan.slice(i)] : [...plan, nouveau] });
    await tracerAcces("plan de postes : poste ajouté", `${v} (${nouveauPoste.sens}) — sous-poste « ${v} » créé, renommable`);
    setNouveauPoste({ nom: "", sens: "sortie" });
  }
  async function supprimerPoste(poste) {
    if (!peut("compta.parametrer") || poste === POSTE_ENCAISSEMENT || poste === POSTE_A_DEFINIR) return;
    const n = (operations || []).filter((o) => o.poste === poste).length;
    if (n) { setNotice(`Impossible : ${n} opération(s) utilisent le poste « ${poste} ».`); return; }
    if (!await demander(`Supprimer le poste « ${poste} » et ses sous-postes ?`)) return;
    await persistParametres({ ...(parametres || {}), planPostes: planPostes().filter((x) => x.poste !== poste) });
    await tracerAcces("plan de postes : poste supprimé", poste);
  }
  async function creerFournisseurRapide() {
    if (!peut("compta.parametrer") || !gestionCompta) return;
    const nom = (gestionCompta.nom || "").trim(), ice = (gestionCompta.ice || "").trim();
    if (!nom) { setNotice("Indique le nom du fournisseur."); return; }
    if (fournisseurParNom(nom)) { setNotice("Ce fournisseur existe déjà — choisis-le dans la liste."); return; }
    if (ice && !iceValide(ice)) { setNotice("L'ICE doit comporter 15 chiffres (ou laisse vide)."); return; }
    await persistFournisseurs([...(fournisseurs || []), { id: uid(), nom, origine: "Maroc", fiabilite: "bonne", contacts: [], ice, paiement: "", certifFourni: false, certifDate: "", notes: "Créé depuis la comptabilité" }]);
    await tracerAcces("fournisseur créé (comptabilité)", `${nom}${ice ? ` — ICE ${ice}` : ""}`);
    if (opEdit) setOpEdit({ ...opEdit, tiersType: "fournisseur", tiers: nom });
    setGestionCompta(null);
  }
  // ---- Prime de productivité ----
  function estCommercialStaff(x) {
    return x.service === "Commercial" || regimeDe(x).cle === "commercial";
  }
  function paramsProductivite() {
    return { ...DEFAULT_PARAMS_PRODUCTIVITE, ...((parametres && parametres.primeProductivite) || {}) };
  }
  async function persistPrimesProductivite(next) {
    setPrimesProductivite(next);
    return await saveKey(PRIMES_PRODUCTIVITE_KEY, next);
  }
  function calculProductivite(lundi) {
    const fin = decalerJours(lundi, 6);
    const dansSemaine = (d) => !!d && d.slice(0, 10) >= lundi && d.slice(0, 10) <= fin;
    const art = (l) => (l.articleId ? (articles || []).find((x) => x.id === l.articleId) : null);
    const estTranche = (l) => { const a = art(l); return !!a && a.categorie === "Tranche"; };
    let caProd = 0, caTranches = 0;
    const dossiersProd = [], dossiersTranches = [];
    (commandesListe || []).forEach((c) => {
      const lignes = lignesDuDossier(c) || [];
      if (c.numeroFacture && dansSemaine(c.dateFacture) && lignes.some((l) => natureArticle(art(l), "faconnage"))) {
        const m = lignes.filter((l) => !estTranche(l)).reduce((n, l) => n + calcLigne(l).montantHT, 0);
        caProd += m;
        dossiersProd.push({ numero: c.numeroFacture, montant: m });
      }
      // Nils 30/09 : uniquement les factures, jamais les BL (un BL du vendredi peut être chargé la semaine suivante).
      if (c.numeroFacture && dansSemaine(c.dateFacture)) {
        const m = lignes.filter(estTranche).reduce((n, l) => n + calcLigne(l).montantHT, 0);
        if (m > 0) { caTranches += m; dossiersTranches.push({ numero: c.numeroFacture, montant: m }); }
      }
    });
    // Step 17 : avoirs de la semaine déduits (lignes : tranche / hors tranche ; montant : au prorata de la facture).
    avoirsEntre(lundi, fin).forEach((a) => {
      const c = commandeParIdAvoir(a);
      if (!c) return;
      const lignes = lignesDuDossier(c) || [];
      const prod = lignes.some((l) => natureArticle(art(l), "faconnage"));
      let hors = 0, tr = 0;
      if (a.mode === "lignes") (a.lignes || []).forEach((l) => { const v = l.qte * l.prixHT; if (estTranche(l)) tr += v; else hors += v; });
      else {
        const totH = lignes.filter((l) => !estTranche(l)).reduce((n, l) => n + calcLigne(l).montantHT, 0), totT = lignes.filter(estTranche).reduce((n, l) => n + calcLigne(l).montantHT, 0);
        const tot = totH + totT;
        if (tot > 0) { hors = (a.ht * totH) / tot; tr = (a.ht * totT) / tot; }
      }
      if (prod && hors) { caProd -= hors; dossiersProd.push({ numero: a.numero, montant: -hors }); }
      if (tr) { caTranches -= tr; dossiersTranches.push({ numero: a.numero, montant: -tr }); }
    });
    const pp = paramsProductivite();
    const retenu = caProd + (caProd < pp.target ? caTranches * (pp.partTranchesPct / 100) : 0);
    // Éligibles : présents, hors Nils et commerciaux ; toute absence pointée dans la semaine supprime le droit.
    const eligibles = (staff || []).filter((x) => !ficheStaffMasquee(x) && !estCommercialStaff(x) && staffPresentSur(x, lundi, fin)).map((x) => {
      const absences = [];
      let pointe = false;
      for (let i = 0; i < 7; i++) {
        const d = decalerJours(lundi, i);
        const rec = recPointage(d.slice(0, 7));
        if (rec) pointe = true;
        const j = rec && rec.lignes && rec.lignes[x.id] && rec.lignes[x.id].jours ? rec.lignes[x.id].jours[d.slice(8, 10)] : null;
        if (j && codesSaisie(j).some((x) => CODES_ABSENCE_PRIME.includes(x.code))) absences.push(`${texteCodeSaisie(j)} le ${formatDate(d)}`);
      }
      return { id: x.id, nom: x.nom, droit: absences.length === 0, raison: absences.length ? `absence : ${absences.join(", ")}` : pointe ? "" : "semaine pas encore pointée" };
    }).sort((a, b) => a.nom.localeCompare(b.nom, "fr", { sensitivity: "base" }));
    return { lundi, fin, caProd, caTranches, retenu, target: pp.target, partTranchesPct: pp.partTranchesPct, montant: pp.montant, atteint: caProd >= pp.target, atteintAvecTranches: retenu >= pp.target, dossiersProd, dossiersTranches, eligibles };
  }
  // Le mardi (ou après), la semaine précédente est proposée à Nils (alerte + tâche).
  useEffect(() => {
    if (loading || primesProductivite === null || commandesListe === null || staff === null || parametres === null || alertes === null || creationSemaineRef.current) return;
    const auj = todayISO();
    const lundiCourant = lundiDe(auj);
    if (auj < decalerJours(lundiCourant, 1)) return; // pas avant mardi
    const lundi = decalerJours(lundiCourant, -7);
    if ((primesProductivite || []).some((x) => x.lundi === lundi)) return;
    creationSemaineRef.current = true;
    (async () => {
      try {
        const c = calculProductivite(lundi);
        await persistPrimesProductivite([...(primesProductivite || []), { id: lundi, lundi, fin: c.fin, statut: "à valider", creeLe: new Date().toISOString() }]);
        const nb = c.eligibles.filter((e) => e.droit).length;
        await alerter(c.atteintAvecTranches ? "Prime de productivité : target atteint" : "Prime de productivité : target non atteint", `Semaine du ${formatDate(lundi)} au ${formatDate(c.fin)} — CA production ${formatDH(c.caProd)}${!c.atteint ? ` + ${c.partTranchesPct} % des tranches facturées (${formatDH(c.caTranches)}) = ${formatDH(c.retenu)}` : ""} pour un target de ${formatDH(c.target)}${c.atteintAvecTranches ? ` → prime ${formatDH(c.montant)} × ${nb} personne(s) = ${formatDH(c.montant * nb)}, à valider` : ` — il manque ${formatDH(c.target - c.retenu)}`}`, { kind: "onglet", id: "staff" });
      } finally {
        creationSemaineRef.current = false;
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, primesProductivite, commandesListe, staff, parametres, alertes]);
  async function validerPrimeProductivite(lundi, accorder) {
    if (!peut("staff.primes")) return;
    const c = calculProductivite(lundi);
    const ex = exceptionsProductivite[lundi] || {};
    const beneficiaires = accorder ? c.eligibles.filter((e) => (ex[e.id] !== undefined ? ex[e.id] : e.droit)) : [];
    const maintenant = new Date().toISOString();
    const com = `Semaine du ${formatDate(lundi)} au ${formatDate(c.fin)}`;
    if (beneficiaires.length) {
      const ids = new Set(beneficiaires.map((e) => e.id));
      await persistStaff((staff || []).map((x) => (ids.has(x.id) ? { ...x, primes: [...(x.primes || []), { id: uid(), date: c.fin, type: TYPE_PRIME_PRODUCTIVITE, montant: c.montant, commentaire: com, semaine: lundi, par: user.nom, le: maintenant }] } : x)));
    }
    const snapshot = { caProd: c.caProd, caTranches: c.caTranches, retenu: c.retenu, target: c.target, partTranchesPct: c.partTranchesPct, montant: c.montant, atteint: c.atteintAvecTranches, beneficiaires: beneficiaires.map((e) => e.id), exclus: c.eligibles.filter((e) => !beneficiaires.some((b) => b.id === e.id)).map((e) => ({ id: e.id, raison: e.raison })) };
    const liste = [...(primesProductivite || [])];
    const i = liste.findIndex((x) => x.lundi === lundi);
    const rec = { ...(i >= 0 ? liste[i] : { id: lundi, lundi, fin: c.fin }), statut: accorder ? "accordée" : "non accordée", ...snapshot, valideePar: user.nom, valideeLe: maintenant };
    if (i >= 0) liste[i] = rec; else liste.push(rec);
    await persistPrimesProductivite(liste);
    await tracerAcces(accorder ? "prime de productivité accordée" : "prime de productivité non accordée", `${com} — CA production ${formatDH(c.caProd)}, tranches ${formatDH(c.caTranches)}, target ${formatDH(c.target)}${accorder ? ` — ${beneficiaires.length} × ${formatDH(c.montant)}` : ""}`);
    setNotice(accorder ? `Prime de productivité accordée : ${beneficiaires.length} personne(s), ${formatDH(beneficiaires.length * c.montant)}.` : "Semaine clôturée sans prime.");
  }
  // Nils 01/11 : annuler la décision d'une semaine (accordée ou non) — la semaine repasse « à valider ».
  // Accordée : les primes de productivité de la semaine sont retirées des fiches ; si des versements en
  // caisse dépassent alors l'accordé, le détail est montré avant confirmation (pas de blocage).
  async function annulerDecisionPrime(lundi) {
    if (!peut("staff.primes")) return;
    const liste = [...(primesProductivite || [])];
    const i = liste.findIndex((x) => x.lundi === lundi);
    if (i < 0 || liste[i].statut === "à valider") return;
    const w = liste[i];
    const com = `Semaine du ${formatDate(lundi)} au ${formatDate(w.fin)}`;
    const aRetirer = (staff || []).map((x) => ({ x, ps: (x.primes || []).filter((p) => p.type === TYPE_PRIME_PRODUCTIVITE && p.semaine === lundi) })).filter((e) => e.ps.length);
    // Nils 01/11 : plus de blocage — si des versements de productivité dépassent ce qui resterait accordé,
    // le détail (accordé, versé, versements) est montré et le Gérant confirme.
    const total = aRetirer.reduce((n, e) => n + e.ps.reduce((k, p) => k + (Number(p.montant) || 0), 0), 0);
    const ecarts = aRetirer
      .map((e) => {
        const retire = e.ps.reduce((n, p) => n + (Number(p.montant) || 0), 0);
        const accorde = (e.x.primes || []).filter((p) => p.type === TYPE_PRIME_PRODUCTIVITE).reduce((n, p) => n + (Number(p.montant) || 0), 0);
        const vs = versementsPrimesDe(e.x).filter((v) => v.type === TYPE_PRIME_PRODUCTIVITE);
        const verse = vs.reduce((n, v) => n + v.montant, 0);
        return { nom: e.x.nom, accorde, verse, apres: arrondiH(accorde - retire - verse), vs };
      })
      .filter((e) => e.apres < -0.01);
    const detailEcarts = ecarts.length
      ? `\n\n⚠ Versements de productivité déjà enregistrés en caisse pour ${ecarts.length} personne(s) — après annulation, le versé dépassera l'accordé :\n${ecarts.map((e) => `• ${e.nom} : accordé ${formatDH(e.accorde)}, versé ${formatDH(e.verse)} (${e.vs.map((v) => `${formatDate(v.date)} ${(compteDe(v.compteId) || {}).nom || ""}`.trim()).join(", ")})`).join("\n")}\n\nSi ces versements correspondent à une autre semaine (ou à un essai), tu peux annuler quand même.`
      : "";
    if (!(await demander(`Annuler la décision « ${w.statut} » pour la ${com.toLowerCase()} ?${aRetirer.length ? `\n\nPrimes retirées des fiches : ${aRetirer.length} personne(s), ${formatDH(total)}.` : ""}\n\nLa semaine repasse « à valider ».${detailEcarts}`, ecarts.length ? { danger: true } : undefined))) return;
    if (aRetirer.length) {
      const ids = new Set(aRetirer.map((e) => e.x.id));
      await persistStaff((staff || []).map((x) => (ids.has(x.id) ? { ...x, primes: (x.primes || []).filter((p) => !(p.type === TYPE_PRIME_PRODUCTIVITE && p.semaine === lundi)) } : x)));
    }
    liste[i] = { id: w.id || lundi, lundi, fin: w.fin, creeLe: w.creeLe, statut: "à valider", historique: [...(w.historique || []), { statut: w.statut, valideePar: w.valideePar, valideeLe: w.valideeLe, annuleePar: user.nom, annuleeLe: new Date().toISOString() }] };
    await persistPrimesProductivite(liste);
    await tracerAcces("prime de productivité : décision annulée", `${com} — « ${w.statut} » annulée${aRetirer.length ? ` — retirée des fiches : ${aRetirer.map((e) => e.x.nom).join(", ")} (${formatDH(total)})` : ""}`);
    setNotice(`Décision annulée : la ${com.toLowerCase()} est de nouveau à valider.`);
  }
  async function ajouterTypePrime() {
    if (!peut("staff.primes")) return;
    const v = nouveauTypePrime.trim();
    if (!v) return;
    if (typesPrimesVersees().some((x) => normLib(x) === normLib(v))) { setNotice("Ce type existe déjà."); return; }
    await persistParametres({ ...(parametres || {}), typesPrimes: [...typesPrimes(), v] });
    await tracerAcces("type de prime ajouté", v);
    setNouveauTypePrime("");
  }
  async function supprimerTypePrime(t) {
    if (!peut("staff.primes")) return;
    const n = (staff || []).reduce((k, x) => k + (x.primes || []).filter((p) => p.type === t).length, 0);
    if (n > 0) { setNotice(`Impossible de supprimer « ${t} » : ${n} prime(s) enregistrée(s) avec ce type.`); return; }
    await persistParametres({ ...(parametres || {}), typesPrimes: typesPrimes().filter((x) => x !== t) });
    await tracerAcces("type de prime supprimé", t);
  }
  // ---- ERP step 12 (Nils 30/09) : import du fichier Excel Staff rempli par Sawsan ----
  async function chargerSheetJS() {
    if (window.XLSX) return window.XLSX;
    await new Promise((ok, ko) => {
      const sc = document.createElement("script");
      sc.src = "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";
      sc.onload = ok;
      sc.onerror = () => ko(new Error("Impossible de charger le lecteur Excel."));
      document.head.appendChild(sc);
    });
    return window.XLSX;
  }
  // Nils 05/10 : fichier à remplir pour Sawsan (fiches + salaires bruts), réimporté par « ⬆ Importer le fichier Excel ».
  async function exporterFichierStaff() {
    if (!peutGererStaff) return;
    let XLSX;
    try { XLSX = await chargerSheetJS(); } catch (e) { setNotice(e.message); return; }
    const actifs = (staff || []).filter((x) => !ficheStaffMasquee(x) && staffActif(x)).sort((a, b) => a.nom.localeCompare(b.nom, "fr", { sensitivity: "base" }));
    const dateFr = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : "");
    const manque = (x) => {
      const m = [...ficheStaffIncomplete(x)];
      [["matricule", "matricule"], ["cnss", "n° CNSS"], ["cin", "CIN"], ["telephonePerso", "téléphone perso"], ["adresse", "adresse"], ["urgenceNom", "contact d'urgence"], ["urgenceTel", "téléphone d'urgence"]].forEach(([k, lib]) => { if (!String(x[k] || "").trim()) m.push(lib); });
      if (salaireActuel(x) === null) m.push("salaire");
      else if (salaireBrutAu(x) === null) m.push("salaire brut");
      return m.join(", ");
    };
    const P = [["Prénom", "Nom", "Poste", "Service", "Contrat", "Date d'embauche", "Horaire", "Téléphone pro", "Téléphone perso", "Adresse", "Contact d'urgence", "Lien", "Téléphone d'urgence", "Matricule", "N° CNSS", "CIN", "À COMPLÉTER (info, ne pas modifier)"]];
    actifs.forEach((x) => P.push([x.prenom || "", x.nomFamille || "", x.poste || "", x.service || "", x.contrat || "", dateFr(x.dateEmbauche), x.regime ? (regimesHoraires()[x.regime] || {}).label || "" : "", x.telephonePro || "", x.telephonePerso || "", x.adresse || "", x.urgenceNom || "", x.urgenceLien || "", x.urgenceTel || "", x.matricule || "", x.cnss || "", x.cin || "", manque(x)]));
    const S = [["Prénom", "Nom", "Date d'effet", "Salaire net", "Salaire brut (CNSS et AMO compris)", "Type", "Commentaire"]];
    actifs.forEach((x) => {
      const l = [...(x.salaires || [])].filter((y) => y.dateEffet <= todayISO()).sort((a, b) => (a.dateEffet < b.dateEffet ? 1 : -1))[0];
      S.push([x.prenom || "", x.nomFamille || "", l ? dateFr(l.dateEffet) : "", l ? Number(l.net) || "" : "", l && l.brut ? Number(l.brut) : "", l ? l.type || "" : "Embauche", ""]);
    });
    const I = [
      ["Fichier du personnel à compléter — Stone Concept"],
      [`Exporté le ${dateFr(todayISO())} par ${user.nom}.`],
      [],
      ["Onglet « Personnel » : une ligne par personne active. Compléter les cases vides (voir la colonne « À COMPLÉTER »). Ne pas changer Prénom / Nom (ils servent à retrouver la fiche)."],
      ["Onglet « Salaires » : le salaire actuel de chaque personne. Compléter le SALAIRE BRUT (CNSS et AMO compris) sur la même ligne, sans changer la date ni le net."],
      ["   Pour une augmentation : ajouter une NOUVELLE ligne (même prénom / nom, nouvelle date d'effet, nouveau net et brut, type « Augmentation » ou « Ancienneté »)."],
      ["Horaire : laisser vide pour l'horaire par défaut du service (Usine / Bureau Marrakech / Commercial)."],
      ["Dates au format jj/mm/aaaa. Services possibles : " + SERVICES_STAFF.join(", ") + ". Contrats : " + typesContrat().join(", ") + "."],
      ["Une fois rempli : Staff › Fiches › « ⬆ Importer le fichier Excel » (aperçu avant enregistrement)."],
    ];
    const wb = XLSX.utils.book_new();
    const wsI = XLSX.utils.aoa_to_sheet(I); wsI["!cols"] = [{ wch: 140 }];
    const wsP = XLSX.utils.aoa_to_sheet(P); wsP["!cols"] = P[0].map((h, i) => ({ wch: i === P[0].length - 1 ? 50 : Math.max(12, h.length + 2) }));
    const wsS = XLSX.utils.aoa_to_sheet(S); wsS["!cols"] = S[0].map((h) => ({ wch: Math.max(12, h.length + 2) }));
    XLSX.utils.book_append_sheet(wb, wsI, "À lire");
    XLSX.utils.book_append_sheet(wb, wsP, "Personnel");
    XLSX.utils.book_append_sheet(wb, wsS, "Salaires");
    const ok = await proposerTelechargement(`Personnel-a-completer-${todayISO()}.xlsx`, XLSX.write(wb, { bookType: "xlsx", type: "array" }));
    if (ok) setNotice("Fichier du personnel téléchargé : à faire compléter par l'Administration, puis à réimporter avec « ⬆ Importer le fichier Excel ».");
  }
  async function analyserImportStaff(fichier) {
    if (!peutGererStaff || !fichier) return;
    let XLSX;
    try { XLSX = await chargerSheetJS(); } catch (e) { setNotice(e.message); return; }
    let wb;
    try { wb = XLSX.read(await fichier.arrayBuffer(), { type: "array", cellDates: true }); } catch (e) { setNotice("Fichier illisible — vérifie qu'il s'agit bien du fichier Excel du personnel."); return; }
    const feuille = (nom) => { const k = wb.SheetNames.find((x) => normNomStaff(x) === normNomStaff(nom)); return k ? XLSX.utils.sheet_to_json(wb.Sheets[k], { header: 1, raw: true, defval: "" }) : null; };
    const P = feuille("Personnel");
    const S = feuille("Salaires");
    if (!P) { setNotice("Onglet « Personnel » introuvable dans ce fichier."); return; }
    const erreurs = [];
    const avert = [];
    const txt = (v) => (v === null || v === undefined ? "" : String(v).trim());
    const date = (v, ou) => {
      if (v === "" || v === null || v === undefined) return "";
      if (v instanceof Date && !isNaN(v)) return `${v.getFullYear()}-${String(v.getMonth() + 1).padStart(2, "0")}-${String(v.getDate()).padStart(2, "0")}`;
      if (typeof v === "number") { const d = XLSX.SSF.parse_date_code(v); return d ? `${d.y}-${String(d.m).padStart(2, "0")}-${String(d.d).padStart(2, "0")}` : ""; }
      const m = String(v).trim().match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{2,4})$/);
      if (m) { const y = m[3].length === 2 ? `20${m[3]}` : m[3]; return `${y}-${m[2].padStart(2, "0")}-${m[1].padStart(2, "0")}`; }
      if (/^\d{4}-\d{2}-\d{2}/.test(String(v))) return String(v).slice(0, 10);
      erreurs.push(`${ou} : date « ${v} » illisible (format jj/mm/aaaa)`);
      return "";
    };
    const tel = (v) => { let t = txt(v); if (typeof v === "number" && t.length === 9) t = `0${t}`; return t; };
    const num = (v) => { if (v === "" || v === null || v === undefined) return null; const n = Number(String(v).replace(/\s/g, "").replace(",", ".")); return isFinite(n) ? n : NaN; };
    // Colonnes repérées par leur titre (l'ordre peut changer).
    const entetes = (P[0] || []).map((h) => normNomStaff(h).replace(/\*/g, "").trim());
    const col = (test) => entetes.findIndex(test);
    const C = {
      prenom: col((h) => h.startsWith("prenom")), nom: col((h) => h === "nom" || h.startsWith("nom ")), poste: col((h) => h.startsWith("poste")),
      service: col((h) => h.startsWith("service")), contrat: col((h) => h.startsWith("contrat")), embauche: col((h) => h.includes("embauche")),
      horaire: col((h) => h.startsWith("horaire")), telPro: col((h) => h.includes("telephone pro")), telPerso: col((h) => h.includes("telephone perso")),
      adresse: col((h) => h.includes("adresse")), urgNom: col((h) => h.startsWith("contact d")), lien: col((h) => h === "lien"),
      urgTel: col((h) => h.includes("telephone d")), reliquat: col((h) => h.includes("reliquat")),
      matricule: col((h) => h.startsWith("matricule")), cnss: col((h) => h.includes("cnss")), cin: col((h) => h === "cin" || h.startsWith("cin ") || h.startsWith("cin(")),
    };
    if (C.prenom < 0 || C.nom < 0) { setNotice("Colonnes « Prénom » et « Nom » introuvables dans l'onglet Personnel."); return; }
    const anneeReliquat = (() => { const h = C.reliquat >= 0 ? String(P[0][C.reliquat]) : ""; const m = h.match(/(20\d\d)/); return m ? m[1] : todayISO().slice(0, 4); })();
    const horaireCle = (v) => { const n = normNomStaff(v); if (!n) return ""; const e = Object.entries(regimesHoraires()).find(([k, r]) => normNomStaff(r.label) === n || k === n); return e ? e[0] : null; };
    let liste = (staff || []).map((x) => ({ ...x }));
    const trouver = (prenom, nom) => {
      const complet = normNomStaff(`${prenom} ${nom}`);
      const exact = liste.filter((x) => !ficheStaffMasquee(x) && [x.nom, ...(x.anciensNoms || [])].some((n) => normNomStaff(n) === complet));
      if (exact.length === 1) return exact[0];
      const parPrenom = liste.filter((x) => !ficheStaffMasquee(x) && normNomStaff(x.prenom) === normNomStaff(prenom) && (!x.nomFamille || normNomStaff(x.nomFamille) === normNomStaff(nom)));
      if (parPrenom.length === 1) return parPrenom[0];
      if (parPrenom.length > 1) return "ambigu";
      return null;
    };
    const lignes = [];
    P.slice(1).forEach((r, i) => {
      const prenom = txt(r[C.prenom]);
      const nom = C.nom >= 0 ? txt(r[C.nom]) : "";
      if (!prenom && !nom) return;
      if (normNomStaff(prenom) === "exemple") return;
      const ou = `Personnel, ligne ${i + 2} (${prenom} ${nom})`;
      if (!prenom) { erreurs.push(`${ou} : prénom manquant`); return; }
      const v = (k) => (C[k] >= 0 ? r[C[k]] : "");
      const patch = {};
      const poser = (champ, val) => { if (val !== "" && val !== null && val !== undefined) patch[champ] = val; };
      poser("poste", txt(v("poste")));
      const serv = txt(v("service"));
      if (serv) { const sv = SERVICES_STAFF.find((x) => normNomStaff(x) === normNomStaff(serv)); if (sv) patch.service = sv; else avert.push(`${ou} : service « ${serv} » inconnu, ignoré`); }
      const ctr = txt(v("contrat"));
      if (ctr) { const cv = typesContrat().find((x) => normNomStaff(x) === normNomStaff(ctr)); if (cv) patch.contrat = cv; else avert.push(`${ou} : contrat « ${ctr} » inconnu (à créer dans Staff › Gérer les types de contrat), ignoré`); }
      poser("dateEmbauche", date(v("embauche"), ou));
      const h = txt(v("horaire"));
      if (h) { const hc = horaireCle(h); if (hc) patch.regime = hc; else avert.push(`${ou} : horaire « ${h} » inconnu, ignoré`); }
      poser("telephonePro", tel(v("telPro")));
      poser("telephonePerso", tel(v("telPerso")));
      poser("adresse", txt(v("adresse")));
      poser("urgenceNom", txt(v("urgNom")));
      poser("urgenceLien", txt(v("lien")));
      poser("urgenceTel", tel(v("urgTel")));
      poser("matricule", txt(v("matricule")));
      poser("cnss", txt(v("cnss")).replace(/\s/g, ""));
      poser("cin", txt(v("cin")).replace(/\s/g, "").toUpperCase());
      const rel = num(v("reliquat"));
      if (rel !== null) { if (isNaN(rel) || rel < 0) erreurs.push(`${ou} : reliquat de congés invalide`); else patch.reliquat = rel; }
      const ex = trouver(prenom, nom);
      if (ex === "ambigu") { erreurs.push(`${ou} : plusieurs fiches « ${prenom} » dans l'ERP — indiquer le nom de famille`); return; }
      const { reliquat, ...champs } = patch;
      if (ex) {
        const maj = { ...ex, ...champs };
        if (nom && !ex.nomFamille) maj.nomFamille = nom;
        if (!ex.prenom) maj.prenom = prenom;
        if (reliquat !== undefined) maj.reportConges = { ...(ex.reportConges || {}), [anneeReliquat]: reliquat };
        const n2 = normaliserFicheStaff(maj);
        const change = Object.keys(n2).filter((k) => JSON.stringify(n2[k]) !== JSON.stringify(ex[k]) && !["modifieLe", "modifiePar", "nom", "anciensNoms"].includes(k));
        if (n2.nom !== ex.nom && ex.nom) n2.anciensNoms = [...new Set([...(ex.anciensNoms || []), ex.nom])];
        liste = liste.map((x) => (x.id === ex.id ? { ...n2, modifiePar: `${user.nom} (import Excel)`, modifieLe: new Date().toISOString() } : x));
        lignes.push({ action: change.length ? "mise à jour" : "inchangée", nom: n2.nom, detail: change.map((k) => libelleChampJournal(k)).join(", ") });
      } else {
        const f = normaliserFicheStaff({ ...ficheStaffVide(), ...champs, prenom, nomFamille: nom, id: uid(), creePar: `${user.nom} (import Excel)`, creeLe: new Date().toISOString(), reportConges: reliquat !== undefined ? { [anneeReliquat]: reliquat } : {} });
        liste.push(f);
        lignes.push({ action: "création", nom: f.nom, detail: "" });
      }
    });
    const salaires = [];
    if (S) {
      const eS = (S[0] || []).map((h) => normNomStaff(h).replace(/\*/g, "").trim());
      const cs = (t) => eS.findIndex(t);
      const CS = { prenom: cs((h) => h.startsWith("prenom")), nom: cs((h) => h === "nom" || h.startsWith("nom ")), date: cs((h) => h.includes("date")), net: cs((h) => h.includes("salaire") && h.includes("net")) >= 0 ? cs((h) => h.includes("salaire") && h.includes("net")) : cs((h) => h.includes("salaire") && !h.includes("brut")), brut: cs((h) => h.includes("brut")), type: cs((h) => h.startsWith("type")), com: cs((h) => h.startsWith("commentaire")) };
      S.slice(1).forEach((r, i) => {
        const prenom = txt(r[CS.prenom]);
        const nom = CS.nom >= 0 ? txt(r[CS.nom]) : "";
        if (!txt(r[CS.net]) && !(CS.brut >= 0 && txt(r[CS.brut])) && !txt(r[CS.date])) return; // ligne vide (personne sans salaire connu)
        if (normNomStaff(prenom) === "exemple") return;
        const ou = `Salaires, ligne ${i + 2} (${prenom} ${nom})`;
        const f = trouver(prenom, nom);
        if (!f || f === "ambigu") { erreurs.push(`${ou} : personne introuvable dans l'onglet Personnel / l'ERP`); return; }
        const d = date(r[CS.date], ou);
        const net = num(r[CS.net]);
        const typeBrut = CS.type >= 0 ? txt(r[CS.type]) : "";
        const type = TYPES_SALAIRE.find((t) => normNomStaff(t) === normNomStaff(typeBrut));
        if (!d) { erreurs.push(`${ou} : date d'effet manquante`); return; }
        if (net === null || isNaN(net) || net <= 0) { erreurs.push(`${ou} : salaire net invalide`); return; }
        if (!type) { erreurs.push(`${ou} : type « ${typeBrut} » — choisir Embauche, Augmentation ou Ancienneté`); return; }
        // Nils 05/10 (h3) : salaire brut (CNSS et AMO compris).
        const brut = CS.brut >= 0 ? num(r[CS.brut]) : null;
        if (brut !== null && (isNaN(brut) || brut < net)) { erreurs.push(`${ou} : salaire brut invalide (inférieur au net ?)`); return; }
        const fActuel = liste.find((x) => x.id === f.id) || f;
        const existante = (fActuel.salaires || []).find((x) => x.dateEffet === d && Number(x.net) === net);
        if (existante) {
          if (brut !== null && Number(existante.brut || 0) !== brut) {
            liste = liste.map((x) => (x.id === f.id ? { ...x, salaires: (x.salaires || []).map((y) => (y.id === existante.id ? { ...y, brut, brutModifiePar: `${user.nom} (import Excel)`, brutModifieLe: new Date().toISOString() } : y)) } : x));
            salaires.push({ nom: f.nom, d, net, type: existante.type || type, brut, brutMaj: true });
          } else salaires.push({ nom: f.nom, d, net, type, doublon: true });
          return;
        }
        if (brut === null) avert.push(`${ou} : salaire brut non renseigné`);
        const ligne = { id: uid(), dateEffet: d, net, ...(brut !== null ? { brut } : {}), type, motif: CS.com >= 0 ? txt(r[CS.com]) : "", par: `${user.nom} (import Excel)`, le: new Date().toISOString() };
        liste = liste.map((x) => (x.id === f.id ? { ...x, salaires: [...(x.salaires || []), ligne] } : x));
        salaires.push({ nom: f.nom, d, net, type });
      });
    }
    setImportStaff({ fichier: fichier.name, liste, lignes, salaires, erreurs, avert, anneeReliquat });
  }
  async function confirmerImportStaff() {
    if (!peutGererStaff || !importStaff) return;
    const im = importStaff;
    const ok = await persistStaff(im.liste);
    if (!ok) { setNotice("Échec de l'enregistrement — réessaie."); return; }
    const nbC = im.lignes.filter((l) => l.action === "création").length;
    const nbM = im.lignes.filter((l) => l.action === "mise à jour").length;
    const nbS = im.salaires.filter((x) => !x.doublon).length;
    await tracerAcces("import Excel du personnel", `${im.fichier} — ${nbC} fiche(s) créée(s), ${nbM} mise(s) à jour, ${nbS} ligne(s) de salaire${im.erreurs.length ? `, ${im.erreurs.length} ligne(s) en erreur ignorée(s)` : ""}`);
    setImportStaff(null);
    setNotice(`Import terminé : ${nbC} fiche(s) créée(s), ${nbM} mise(s) à jour, ${nbS} salaire(s) ajouté(s).`);
  }
  async function supprimerSalaire(ligneId) {
    if (!peutGererStaff || !staffEdit) return;
    const s = (staff || []).find((x) => x.id === staffEdit.id);
    if (!s) return;
    const l = (s.salaires || []).find((x) => x.id === ligneId);
    const maj = { ...s, salaires: (s.salaires || []).filter((x) => x.id !== ligneId) };
    await persistStaff((staff || []).map((x) => (x.id === s.id ? maj : x)));
    await tracerAcces("salaire supprimé", `${s.nom}${l ? ` — ligne du ${formatDate(l.dateEffet)} (${formatDH(Number(l.net) || 0)})` : ""}`);
    setStaffEdit({ ...staffEdit, salaires: maj.salaires });
  }
  async function enregistrerReportConges(annee) {
    if (!peutGererStaff || !staffEdit) return;
    const v = Number(String(reportSaisi).replace(",", "."));
    if (!isFinite(v) || v < 0) { setNotice("Indique un nombre de jours valide (0 ou plus)."); return; }
    const s = (staff || []).find((x) => x.id === staffEdit.id);
    if (!s) return;
    const maj = { ...s, reportConges: { ...(s.reportConges || {}), [annee]: v } };
    await persistStaff((staff || []).map((x) => (x.id === s.id ? maj : x)));
    await tracerAcces("report de congés", `${s.nom} — ${v} j reportés sur ${annee}`);
    setStaffEdit({ ...staffEdit, reportConges: maj.reportConges });
    setReportSaisi("");
  }
  function lignesMensuelles(staffId, annee) {
    return (suiviMensuel || []).filter((x) => x.staffId === staffId && (!annee || x.mois.startsWith(`${annee}-`)));
  }
  function totauxAnnee(staffId, annee) {
    const t = {};
    COMPTEURS_MENSUELS.forEach((c) => { t[c.cle] = 0; });
    lignesMensuelles(staffId, annee).forEach((x) => COMPTEURS_MENSUELS.forEach((c) => { t[c.cle] += Number(x[c.cle]) || 0; }));
    return t;
  }
  function soldeConges(s, annee) {
    const report = Number((s.reportConges || {})[annee]) || 0;
    const acquis = congesAcquisADate(s, annee, todayISO(), paramsConges());
    const pris = congesPrisAnnee(s, annee);
    return { report, acquis, pris, plein: droitCongesAnnuelPlein(s, annee, paramsConges()), reliquat: Math.round((report + acquis - pris) * 2) / 2 };
  }
  // Nils 06/10 : solde de congés sur l'année civile entière (droit de l'année au prorata des mois de contrat).
  function soldeCongesAnnuel(s, annee) {
    const report = Number((s.reportConges || {})[annee]) || 0;
    const droit = congesAcquisADate(s, annee, `${annee}-12-31`, paramsConges());
    const pris = congesPrisAnnee(s, annee);
    return { report, droit, pris, reste: Math.round((report + droit - pris) * 2) / 2 };
  }
  // Personnes concernées par la saisie d'un mois : présentes ce mois-là.
  function staffDuMois(ym) {
    return (staff || []).filter((s) => !ficheStaffMasquee(s) && staffPresentSur(s, `${ym}-01`, finDeMois(ym))).sort((a, b) => a.nom.localeCompare(b.nom, "fr", { sensitivity: "base" }));
  }
  function ouvrirSaisieMensuelle(ym) {
    const d = {};
    staffDuMois(ym).forEach((s) => {
      const l = (suiviMensuel || []).find((x) => x.staffId === s.id && x.mois === ym);
      d[s.id] = l ? { ...l } : {};
    });
    setMoisSaisie(ym);
    setSaisieMensuelle(d);
  }
  async function enregistrerSaisieMensuelle() {
    if (!peutGererStaff) return;
    const ym = moisSaisie;
    let liste = [...(suiviMensuel || [])];
    let n = 0;
    for (const s of staffDuMois(ym)) {
      const v = saisieMensuelle[s.id] || {};
      const valeurs = {};
      let invalide = false;
      COMPTEURS_MENSUELS.forEach((c) => {
        const brut = String(v[c.cle] ?? "").replace(",", ".").trim();
        const x = brut === "" ? 0 : Number(brut);
        if (!isFinite(x) || x < 0 || x > 31) invalide = true;
        valeurs[c.cle] = isFinite(x) ? x : 0;
      });
      if (invalide) { setNotice(`${s.nom} : nombre de jours invalide (entre 0 et 31).`); return; }
      const existant = liste.find((x) => x.staffId === s.id && x.mois === ym);
      const ligne = { ...(existant || { id: uid() }), staffId: s.id, mois: ym, ...valeurs, note: (v.note || "").trim(), par: user.nom, le: new Date().toISOString() };
      const change = !existant || COMPTEURS_MENSUELS.some((c) => (Number(existant[c.cle]) || 0) !== valeurs[c.cle]) || (existant.note || "") !== ligne.note;
      if (!change) continue;
      liste = existant ? liste.map((x) => (x.id === existant.id ? ligne : x)) : [...liste, ligne];
      n += 1;
    }
    if (n > 0) {
      await persistSuiviMensuel(liste);
      await tracerAcces("saisie mensuelle du personnel", `${libMois(ym)} — ${n} fiche(s) enregistrée(s)`);
    }
    ouvrirSaisieMensuelleApres(ym, liste);
    setNotice(n > 0 ? `Saisie de ${libMois(ym)} enregistrée (${n} fiche(s)).` : "Rien de modifié.");
  }
  function ouvrirSaisieMensuelleApres(ym, liste) {
    const d = {};
    staffDuMois(ym).forEach((s) => {
      const l = liste.find((x) => x.staffId === s.id && x.mois === ym);
      d[s.id] = l ? { ...l } : {};
    });
    setSaisieMensuelle(d);
  }
  function moisSaisiPour(staffId, ym) {
    return (suiviMensuel || []).some((x) => x.staffId === staffId && x.mois === ym);
  }
  // Signalements : visibles par Nils ; par leur auteur ; par Sawsan / Ahmed
  // dans leur périmètre — jamais par la personne visée elle-même.
  function signalementVisible(sg) {
    if (peut("signalements.voirTout")) return true;
    if (sg.auteurId === user.id) return true;
    if (!peutGererStaff && !peut("staff.equipe")) return false;
    const personnes = (sg.personnes || []).map((id) => (staff || []).find((s) => s.id === id)).filter(Boolean);
    if (personnes.some((s) => s.compte === user.id)) return false;
    return personnes.some(staffVisible);
  }
  const peutTraiterSignalement = peutGererStaff;
  async function enregistrerSignalement() {
    const f = signalementEdit;
    if (!f) return;
    if (!(f.personnes || []).length) { setNotice("Choisis au moins une personne concernée."); return; }
    if (!f.type) { setNotice("Choisis le type de signalement."); return; }
    if (!(f.description || "").trim()) { setNotice("Décris ce qui s'est passé."); return; }
    const sg = { id: uid(), date: f.date || todayISO(), personnes: f.personnes, type: f.type, gravite: f.gravite || "Moyenne", description: f.description.trim(), auteur: user.nom, auteurId: user.id, le: new Date().toISOString(), statut: "Ouvert", suivis: [] };
    await persistSignalements([...(signalements || []), sg]);
    const noms = sg.personnes.map(nomStaff).join(", ");
    await alerter(`Signalement : ${sg.type.toLowerCase()}`, `${noms} — gravité ${sg.gravite.toLowerCase()} — ${sg.description.slice(0, 200)}${sg.description.length > 200 ? "…" : ""} (par ${user.nom})`, { kind: "onglet", id: "staff" });
    await tracerAcces("signalement", `${sg.type} — ${noms}`);
    setSignalementEdit(null);
    setNotice("Signalement enregistré et transmis au Gérant.");
  }
  async function ajouterSuiviSignalement(cloturer) {
    if (!peutTraiterSignalement || !suiviSignalement) return;
    const sg = (signalements || []).find((x) => x.id === suiviSignalement.id);
    if (!sg) return;
    const texte = (suiviSignalement.texte || "").trim();
    if (!texte && cloturer) { setNotice("Indique l'action prise avant de clôturer."); return; }
    if (!texte) return;
    const maj = { ...sg, suivis: [...(sg.suivis || []), { texte, par: user.nom, le: new Date().toISOString() }], ...(cloturer ? { statut: "Clos", closLe: new Date().toISOString(), closPar: user.nom } : {}) };
    await persistSignalements((signalements || []).map((x) => (x.id === sg.id ? maj : x)));
    await tracerAcces(cloturer ? "signalement clos" : "suivi de signalement", `${sg.type} — ${(sg.personnes || []).map(nomStaff).join(", ")} — ${texte}`);
    setSuiviSignalement(null);
  }
  function renderSignalementLigne(sg) {
    const couleurGravite = sg.gravite === "Élevée" ? ROUILLE : sg.gravite === "Moyenne" ? OCRE : TAUPE;
    const enSuivi = suiviSignalement && suiviSignalement.id === sg.id;
    return (
      <div key={sg.id} style={{ background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "10px 12px", opacity: sg.statut === "Clos" ? 0.7 : 1 }}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap" }}>
          <div style={{ fontSize: 13 }}>
            <strong>{sg.type}</strong> — {(sg.personnes || []).map(nomStaff).join(", ")}
            <span style={{ fontSize: 11, color: couleurGravite, fontWeight: 700, marginLeft: 8, textTransform: "uppercase" }}>{sg.gravite}</span>
          </div>
          <div style={{ fontSize: 11, color: TAUPE }}>{formatDate(sg.date)} · par {sg.auteur} · <span style={{ color: sg.statut === "Clos" ? VERT_OK : OCRE, fontWeight: 600 }}>{sg.statut}</span></div>
        </div>
        <div style={{ fontSize: 13, marginTop: 4, whiteSpace: "pre-wrap" }}>{sg.description}</div>
        {(sg.suivis || []).map((x, i) => (
          <div key={i} style={{ fontSize: 12, color: TAUPE, marginTop: 4, paddingLeft: 10, borderLeft: `2px solid ${PIERRE}` }}>↳ {x.texte} <span style={{ fontSize: 11 }}>— {x.par}, {formatDateHeure(x.le)}</span></div>
        ))}
        {peutTraiterSignalement && sg.statut !== "Clos" && !enSuivi && (
          <button type="button" className="sc-btn" onClick={() => setSuiviSignalement({ id: sg.id, texte: "" })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0", marginTop: 4 }}>Ajouter un suivi / clôturer…</button>
        )}
        {peut("signalements.rouvrir") && sg.statut === "Clos" && (
          <button type="button" className="sc-btn" onClick={() => rouvrirSignalement(sg.id)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0", marginTop: 4 }}>Rouvrir</button>
        )}
        {enSuivi && (
          <div style={{ display: "flex", gap: 8, marginTop: 6, flexWrap: "wrap" }}>
            <input className="sc-input" autoFocus value={suiviSignalement.texte} onChange={(e) => setSuiviSignalement({ ...suiviSignalement, texte: e.target.value })} placeholder="Action prise (ex. entretien avec les deux finisseurs le 02/10)" style={{ ...inputStyle(320), padding: "5px 8px", flex: 1 }} />
            <button type="button" className="sc-btn" onClick={() => ajouterSuiviSignalement(false)} style={{ ...ghostBtnStyle, fontSize: 12 }}>Ajouter</button>
            <button type="button" className="sc-btn" onClick={() => ajouterSuiviSignalement(true)} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 10px" }}>Ajouter et clôturer</button>
            <button type="button" className="sc-btn" onClick={() => setSuiviSignalement(null)} style={{ ...ghostBtnStyle, fontSize: 12 }}>Annuler</button>
          </div>
        )}
      </div>
    );
  }
  async function rouvrirSignalement(id) {
    if (!peut("signalements.rouvrir")) return;
    const sg = (signalements || []).find((x) => x.id === id);
    if (!sg) return;
    await persistSignalements((signalements || []).map((x) => (x.id === id ? { ...x, statut: "Ouvert", closLe: "", closPar: "" } : x)));
    await tracerAcces("signalement rouvert", `${sg.type} — ${(sg.personnes || []).map(nomStaff).join(", ")}`);
  }
  // Évaluations semestrielles : Nils, Sawsan, Ahmed (son périmètre) ; pas
  // sur sa propre fiche. Validée quand Nils l'a faite ou validée.
  function peutEvaluer(s) {
    if (!s || s.compte === user.id) return false;
    return peut("evaluations.faire") && (peut("staff.voirTout") || dansPerimetre(s, staff, user.id));
  }
  function evaluationDe(s, periode) {
    return (s.evaluations || []).find((e) => e.periode === periode) || null;
  }
  async function enregistrerEvaluation() {
    const f = evaluationEdit;
    if (!f) return;
    const s = (staff || []).find((x) => x.id === f.staffId);
    if (!peutEvaluer(s)) return;
    const criteres = criteresEvaluation();
    if (criteres.some((c) => !(f.notes || {})[c.cle])) { setNotice("Note chaque critère (A, B ou C)."); return; }
    const notesRetenues = {};
    criteres.forEach((c) => { notesRetenues[c.cle] = f.notes[c.cle]; });
    // Lignes ajoutées (critères libres) : les lignes vides sont ignorées.
    const lignesSup = (f.lignesSup || []).map((l) => ({ libelle: (l.libelle || "").trim(), note: l.note || "" })).filter((l) => l.libelle || l.note);
    if (lignesSup.some((l) => !l.libelle || !l.note)) { setNotice("Chaque ligne ajoutée doit avoir un intitulé et une note."); return; }
    const avant = evaluationDe(s, f.periode);
    const valideeParNils = peut("evaluations.valider");
    const ev = { id: avant ? avant.id : uid(), periode: f.periode, criteres: criteres.map((c) => ({ cle: c.cle, label: c.label })), notes: notesRetenues, lignesSup, commentaire: (f.commentaire || "").trim(), objectifs: (f.objectifs || "").trim(), par: user.nom, le: new Date().toISOString(), validee: valideeParNils, valideePar: valideeParNils ? user.nom : "", valideeLe: valideeParNils ? new Date().toISOString() : "" };
    const maj = { ...s, evaluations: avant ? (s.evaluations || []).map((e) => (e.id === avant.id ? ev : e)) : [...(s.evaluations || []), ev] };
    await persistStaff((staff || []).map((x) => (x.id === s.id ? maj : x)));
    await tracerAcces(avant ? "évaluation modifiée" : "évaluation", `${s.nom} — ${libSemestre(f.periode)} — ${[...criteres.map((c) => f.notes[c.cle]), ...lignesSup.map((l) => l.note)].join("")}${valideeParNils ? " (validée)" : " (à valider par le Gérant)"}`);
    if (!valideeParNils) await alerter("Évaluation à valider", `${s.nom} — ${libSemestre(f.periode)} (par ${user.nom})`, { kind: "onglet", id: "staff" });
    if (staffEdit && staffEdit.id === s.id) setStaffEdit({ ...staffEdit, evaluations: maj.evaluations });
    setEvaluationEdit(null);
    setNotice(`Évaluation de ${s.nom} enregistrée${valideeParNils ? "" : " — le Gérant doit la valider"}.`);
  }
  async function validerEvaluation(staffId, periode) {
    if (!peut("evaluations.valider")) return;
    const s = (staff || []).find((x) => x.id === staffId);
    if (!s) return;
    const maj = { ...s, evaluations: (s.evaluations || []).map((e) => (e.periode === periode ? { ...e, validee: true, valideePar: user.nom, valideeLe: new Date().toISOString() } : e)) };
    await persistStaff((staff || []).map((x) => (x.id === s.id ? maj : x)));
    await tracerAcces("évaluation validée", `${s.nom} — ${libSemestre(periode)}`);
    if (staffEdit && staffEdit.id === s.id) setStaffEdit({ ...staffEdit, evaluations: maj.evaluations });
  }
  // Critères d'évaluation : liste gérée par Nils (Paramétrage). Chaque
  // évaluation garde une copie des critères utilisés (historique exact).
  function criteresEvaluation() {
    const c = parametres && parametres.criteresEvaluation;
    return Array.isArray(c) && c.length > 0 ? c : CRITERES_EVALUATION;
  }
  async function ajouterCritereEvaluation() {
    if (!peut("admin.parametrage")) return;
    const v = nouveauCritere.trim();
    if (!v) return;
    if (criteresEvaluation().some((c) => c.label.toLowerCase() === v.toLowerCase())) { setNotice("Ce critère existe déjà."); return; }
    await persistParametres({ ...(parametres || {}), criteresEvaluation: [...criteresEvaluation(), { cle: `c-${uid()}`, label: v }] });
    await tracerAcces("critère d'évaluation ajouté", v);
    setNouveauCritere("");
  }
  async function renommerCritereEvaluation(cle, nouveau) {
    if (!peut("admin.parametrage")) return;
    const v = (nouveau || "").trim();
    const c = criteresEvaluation().find((x) => x.cle === cle);
    if (!c || !v || v === c.label) return;
    if (criteresEvaluation().some((x) => x.cle !== cle && x.label.toLowerCase() === v.toLowerCase())) { setNotice("Ce critère existe déjà."); return; }
    await persistParametres({ ...(parametres || {}), criteresEvaluation: criteresEvaluation().map((x) => (x.cle === cle ? { ...x, label: v } : x)) });
    await tracerAcces("critère d'évaluation renommé", `${c.label} → ${v}`);
  }
  async function supprimerCritereEvaluation(cle) {
    if (!peut("admin.parametrage")) return;
    const liste = criteresEvaluation();
    if (liste.length <= 1) { setNotice("Il faut garder au moins un critère."); return; }
    const c = liste.find((x) => x.cle === cle);
    await persistParametres({ ...(parametres || {}), criteresEvaluation: liste.filter((x) => x.cle !== cle) });
    await tracerAcces("critère d'évaluation supprimé", c ? c.label : cle);
  }
  // ---- ERP step 12 : pointage ----
  async function persistPointage(next) {
    setPointage(next);
    return await saveKey(POINTAGE_KEY, next);
  }
  function typesCongesSpeciaux() {
    const l = parametres && parametres.typesCongesSpeciaux;
    return Array.isArray(l) && l.length ? l : DEFAULT_TYPES_CONGES_SPECIAUX;
  }
  async function majTypesCongesSpeciaux(liste, trace) {
    await persistParametres({ ...(parametres || {}), typesCongesSpeciaux: liste });
    if (trace) await tracerAcces("réglage congés spéciaux", trace);
  }
  async function ajouterCongeSpecial() {
    if (!peutGererStaff || !staffEdit || !staffEdit.id) return;
    const c = congeSpecialSaisie;
    const type = typesCongesSpeciaux().find((t) => t.id === c.typeId);
    if (!type || !c.debut || !c.fin || c.fin < c.debut) { setNotice("Indique le type, la date de début et la date de fin."); return; }
    const s = (staff || []).find((x) => x.id === staffEdit.id);
    if (!s) return;
    if ((s.congesSpeciaux || []).some((x) => !(c.fin < x.debut || c.debut > x.fin))) { setNotice("Ces dates chevauchent un congé spécial déjà saisi."); return; }
    const valide = (pointage || []).find((r) => r.statut === "validé" && r.mois >= c.debut.slice(0, 7) && r.mois <= c.fin.slice(0, 7));
    if (valide) { setNotice(`Le pointage de ${libMois(valide.mois)} est déjà validé : Le Gérant doit le rouvrir d'abord.`); return; }
    const ligne = { id: uid(), typeId: type.id, libelle: type.libelle, debut: c.debut, fin: c.fin, note: (c.note || "").trim(), par: user.nom, le: new Date().toISOString() };
    const maj = { ...s, congesSpeciaux: [...(s.congesSpeciaux || []), ligne].sort((a, b) => (a.debut < b.debut ? -1 : 1)) };
    await persistStaff((staff || []).map((x) => (x.id === s.id ? maj : x)));
    await tracerAcces("congé spécial enregistré", `${s.nom} — ${type.libelle} du ${formatDate(c.debut)} au ${formatDate(c.fin)}`);
    if (!estGerant) await alerter("Staff : congé spécial", `${s.nom} — ${type.libelle} du ${formatDate(c.debut)} au ${formatDate(c.fin)} (saisi par ${user.nom})`, { kind: "onglet", id: "staff" });
    setStaffEdit({ ...staffEdit, congesSpeciaux: maj.congesSpeciaux });
    setCongeSpecialSaisie({ typeId: "", debut: "", fin: "", note: "" });
  }
  async function supprimerCongeSpecial(id) {
    if (!peutGererStaff || !staffEdit) return;
    const s = (staff || []).find((x) => x.id === staffEdit.id);
    const l = s && (s.congesSpeciaux || []).find((x) => x.id === id);
    if (!l) return;
    if ((pointage || []).some((r) => r.statut === "validé" && r.mois >= l.debut.slice(0, 7) && r.mois <= l.fin.slice(0, 7))) { setNotice("Un mois concerné est déjà validé : Le Gérant doit le rouvrir d'abord."); return; }
    if (!(await demander(`Supprimer ${l.libelle} du ${formatDate(l.debut)} au ${formatDate(l.fin)} ?`))) return;
    const maj = { ...s, congesSpeciaux: (s.congesSpeciaux || []).filter((x) => x.id !== id) };
    await persistStaff((staff || []).map((x) => (x.id === s.id ? maj : x)));
    await tracerAcces("congé spécial supprimé", `${s.nom} — ${l.libelle} du ${formatDate(l.debut)} au ${formatDate(l.fin)}`);
    setStaffEdit({ ...staffEdit, congesSpeciaux: maj.congesSpeciaux });
  }
  function regimesHoraires() {
    const r = (parametres && parametres.regimesHoraires) || {};
    const out = {};
    Object.keys(DEFAULT_REGIMES_HORAIRES).forEach((k) => { out[k] = { ...DEFAULT_REGIMES_HORAIRES[k], ...(r[k] || {}), pointageHeures: true }; });
    return out;
  }
  function ramadanParams() {
    const r = (parametres && parametres.ramadan) || {};
    return { periodes: Array.isArray(r.periodes) ? r.periodes : [], dues: { ...DEFAULT_RAMADAN_DUES, ...(r.dues || {}) } };
  }
  function regimeDe(s) {
    const cle = s.regime || regimeDefautService(s.service);
    const rp = ramadanParams();
    return { cle, ...(regimesHoraires()[cle] || DEFAULT_REGIMES_HORAIRES.usine), ramadan: { periodes: rp.periodes, dues: rp.dues[cle] ?? 7 } };
  }
  async function majRamadan(patch, trace) {
    const rp = ramadanParams();
    await persistParametres({ ...(parametres || {}), ramadan: { ...rp, ...patch } });
    if (trace) await tracerAcces("réglage ramadan", trace);
  }
  function joursSpeciaux() {
    const l = parametres && parametres.joursSpeciaux;
    return Array.isArray(l) ? l : [];
  }
  function speciauxDuMois(ym, rec) {
    const liste = rec && rec.speciaux ? rec.speciaux : joursSpeciaux().filter((x) => x.date.startsWith(`${ym}-`));
    const m = {};
    liste.forEach((x) => { m[x.date] = x; });
    return m;
  }
  function recPointage(ym) {
    return (pointage || []).find((x) => x.mois === ym) || null;
  }
  // ERP step 12 (Nils 30/09) : dès la transmission (ou la validation), le mois
  // garde les horaires et les jours fériés de ce moment-là (plus de recalcul).
  function regimePointage(s, rec) {
    if (!(rec && rec.regimes && rec.regimes[s.id])) return regimeDe(s);
    // Nils 06/10 : les dates du ramadan saisies après la transmission s'appliquent tant que le mois n'est pas validé.
    const f = { ...rec.regimes[s.id], pointageHeures: true };
    if (rec.statut !== "validé") f.ramadan = regimeDe(s).ramadan;
    return f;
  }
  // Nils 01/11 : transmettre une partie (usine, ou bureau et commerciaux) ne fige que les personnes de
  // CETTE partie ; avant, la transmission de l'usine figeait aussi le bureau et les commerciaux avec
  // l'horaire de leur fiche à ce moment-là (ex. « Usine » pour une fiche pas encore complétée).
  // Nils 01/11 : horaire figé qui ne correspond plus à la fiche (mois pas encore validé).
  function ecartHoraire(s, rec) {
    if (!rec || rec.statut === "validé" || !(rec.regimes && rec.regimes[s.id])) return null;
    const fige = rec.regimes[s.id], fiche = regimeDe(s);
    const cleFige = fige.cle || Object.keys(regimesHoraires()).find((k) => regimesHoraires()[k].label === fige.label);
    return cleFige === fiche.cle ? null : { fige: fige.label || cleFige, fiche: fiche.label };
  }
  async function reprendreHorairesFiche(ym, ids) {
    if (!peut("pointage.decisions")) return;
    const rec = recPointage(ym);
    const cibles = (staff || []).filter((x) => ids.includes(x.id) && ecartHoraire(x, rec));
    if (!cibles.length) return;
    const detail = cibles.map((x) => { const e = ecartHoraire(x, rec); return `${x.nom} : ${e.fige} → ${e.fiche}`; }).join("\n");
    if (!(await demander(`Reprendre l'horaire de la fiche pour ${libMois(ym)} ?\n\n${detail}\n\nLes heures déjà saisies sont gardées ; les heures dues sont recalculées.`))) return;
    await majRecPointage(ym, (r) => {
      const regimes = { ...(r.regimes || {}) };
      cibles.forEach((x) => { regimes[x.id] = regimeDe(x); });
      return { ...r, regimes };
    });
    await tracerAcces("pointage : horaire repris de la fiche", `${libMois(ym)} — ${detail.replace(/\n/g, " ; ")}`);
    setNotice(`Horaire repris de la fiche pour ${cibles.length} personne(s).`);
  }
  function figerMois(rec, ym, part) {
    const regimes = { ...(rec.regimes || {}) };
    (staff || []).filter((x) => staffPresentSur(x, `${ym}-01`, finDeMois(ym))).forEach((x) => {
      if (regimes[x.id]) return;
      // Fiche reçue sans service ni horaire (ex. Ahmed ne reçoit que l'annuaire hors de son équipe) :
      // horaire inconnu ici, donc pas figé par cette transmission (il le sera par celle de sa partie ou
      // à la validation par le Gérant).
      if (part && !x.regime && !x.service) return;
      if (part && (regimeDe(x).cle === "usine" ? "usine" : "bureau") !== part) return;
      regimes[x.id] = regimeDe(x);
    });
    return { ...rec, regimes, speciaux: rec.speciaux || joursSpeciaux().filter((x) => x.date.startsWith(`${ym}-`)), figeLe: rec.figeLe || new Date().toISOString() };
  }
  function calculPersonneMois(s, ym) {
    const rec = recPointage(ym);
    return calculPointageMois(s, ym, regimePointage(s, rec), speciauxDuMois(ym, rec), rec && rec.lignes && rec.lignes[s.id] ? rec.lignes[s.id].jours : {}, typesCongesSpeciaux());
  }
  // ---- Nils 06/10 : fin de mois par rubrique (choix séparés, décidés par Nils seul) ----
  // Mois validés avant ce changement : ancien calcul (compteur net + décision globale).
  const CHOIX_FIN_MOIS_DEFAUT = { report: "reporter", hs: "reporter", manq: "reporter", ferie: "reporter", recup: "reporter", abs: "reporter", ms: "reporter", mc: "retirer" };
  const MAJORATION_HS_COMPTEUR = 1.25;
  function methodeV2(rec) {
    return !rec || rec.methode === 2 || rec.statut !== "validé";
  }
  function choixFinMois(rec, sid) {
    return { ...CHOIX_FIN_MOIS_DEFAUT, ...((rec && rec.lignes && rec.lignes[sid] && rec.lignes[sid].choix) || {}) };
  }
  function rubriquesMois(s, rec, c, debut) {
    const ch = choixFinMois(rec, s.id);
    // Heures sup. et heures manquantes des jours travaillés se compensent dans le mois (base 44 h / semaine).
    const net = arrondiH((c.supH - (c.ferieRecupH || 0)) - c.moinsH);
    const R = (cle, lib, h, opts, extra) => ({ cle, lib, h: arrondiH(h), choix: ch[cle], options: opts, ...(extra || {}) });
    const lignes = [
      R("report", "Solde reporté des mois précédents", debut, debut >= 0 ? [["reporter", "Reporter"], ["regulariser", "Payer (heures déjà majorées, taux normal)"]] : [["reporter", "Reporter"], ["regulariser", "Retrancher du salaire"]]),
      R("hs", "Heures sup.", net > 0 ? net : 0, [["reporter", `Reporter (×${String(MAJORATION_HS_COMPTEUR).replace(".", ",")} au compteur)`], ["payer", "Payer à 25 %"]]),
      R("manq", "Heures manquantes", net < 0 ? -net : 0, [["reporter", "Reporter"], ["retrancher", "Retrancher du salaire"]]),
      // Nils 06/10 : férié travaillé — plus de choix jour par jour, une rubrique du mois.
      R("ferie", "Férié travaillé", (c.ferieH || 0) + (c.ferieRecupH || 0) + (c.ferieADecider || 0), [["reporter", "Reporter au compteur"], ["payer", "Payer (colonne férié travaillé)"]]),
      // Nils 06/10 : récupération — plus de report automatique, choix comme les autres rubriques.
      R("recup", "Récupération", c.recupH, [["reporter", "Reporter"], ["retrancher", "Retrancher du salaire"]]),
      R("abs", "Absences", c.aH, [["reporter", "Reporter"], ["retrancher", "Retrancher du salaire"]]),
      R("ms", "Maladie sans certificat", c.msH, [["reporter", "Reporter"], ["retrancher", "Retirer du salaire"]]),
      R("mc", "Maladie avec certificat", c.mcH, [["retirer", "Retirer (jours CNSS)"], ["reporter", "Reporter au compteur"]], { j: c.mcJ }),
    ].filter((l) => Math.abs(l.h) > 0.001 || (l.cle === "mc" && l.j > 0));
    let fin = 0, h25 = 0, hNormal = 0, hDeduire = 0, cnssJ = 0, ferieP = 0;
    const detail = [];
    lignes.forEach((l) => {
      if (l.cle === "report") { if (l.choix === "regulariser") { if (l.h > 0) hNormal += l.h; else { hDeduire += -l.h; detail.push(`solde reporté ${String(arrondiH(-l.h)).replace(".", ",")} h`); } } else fin += l.h; }
      else if (l.cle === "hs") { if (l.choix === "payer") h25 += l.h; else fin += l.h * MAJORATION_HS_COMPTEUR; }
      else if (l.cle === "ferie") { if (l.choix === "payer") ferieP += l.h; else fin += l.h; }
      else if (l.cle === "mc") { if (l.choix === "reporter") fin -= l.h; else cnssJ += l.j || 0; }
      else if (l.choix === "retrancher") { hDeduire += l.h; detail.push(`${l.lib.toLowerCase()} ${String(l.h).replace(".", ",")} h`); }
      else fin -= l.h;
    });
    // Automatique : récupérations (toujours reportées) et férié travaillé « récupérer ».
    const auto = [];
    return { lignes, auto, fin: arrondiH(fin), ferieP: arrondiH(ferieP), h25: arrondiH(h25), hNormal: arrondiH(hNormal), hDeduire: arrondiH(hDeduire), cnssJ, detail };
  }
  // Solde du compteur d'heures : départ (fiche) + mois pointés.
  function soldeHeuresMois(s, ym) {
    const recs = [...(pointage || [])].filter((x) => x.mois <= ym).sort((a, b) => (a.mois < b.mois ? -1 : 1));
    let solde = Number(String(s.soldeHeuresInitial || "").replace(",", ".")) || 0;
    for (const rec of recs) {
      if (!staffPresentSur(s, `${rec.mois}-01`, finDeMois(rec.mois))) continue;
      const c = calculPersonneMois(s, rec.mois);
      const debut = solde;
      if (!methodeV2(rec)) {
        const fin = arrondiH(debut + c.ecart);
        if (rec.mois === ym) return { debut: arrondiH(debut), ecart: c.ecart, fin, calc: c, ancien: true };
        const d = rec.lignes && rec.lignes[s.id] ? rec.lignes[s.id].decision : "";
        solde = d === "regulariser" && rec.decisionsValideesLe ? 0 : fin;
      } else {
        const rb = rubriquesMois(s, rec, c, arrondiH(debut));
        if (rec.mois === ym) return { debut: arrondiH(debut), ecart: arrondiH(rb.fin - debut), fin: rb.fin, calc: c, rub: rb };
        solde = rb.fin;
      }
    }
    if (!recs.some((x) => x.mois === ym)) {
      const c = calculPersonneMois(s, ym);
      const rb = rubriquesMois(s, null, c, arrondiH(solde));
      return { debut: arrondiH(solde), ecart: arrondiH(rb.fin - solde), fin: rb.fin, calc: c, rub: rb };
    }
    return { debut: arrondiH(solde), ecart: 0, fin: arrondiH(solde), calc: null };
  }
  function resumeFinMois(sh) {
    if (!sh || !sh.rub) return "";
    const lib = { reporter: "rep.", payer: "payer", retrancher: "retr.", regulariser: "régul.", retirer: "retirer" };
    return sh.rub.lignes.map((l) => `${({ report: "Solde", hs: "HS", manq: "Manq.", ferie: "Férié", recup: "Récup.", abs: "Abs.", ms: "MS", mc: "MC" })[l.cle]} ${l.cle === "mc" && l.choix === "retirer" ? `${String(l.j).replace(".", ",")} j` : formatH(["hs", "report", "ferie"].includes(l.cle) ? l.h : -l.h)} → ${lib[l.choix] || l.choix}`).join(" · ");
  }
  async function changerChoixFinMois(staffId, cle, val) {
    const rec = recPointage(moisPointage);
    if (!peut("pointage.decisions") || (rec && rec.statut === "validé")) return;
    await majRecPointage(moisPointage, (r) => ({ ...r, lignes: { ...r.lignes, [staffId]: { ...(r.lignes[staffId] || {}), choix: { ...choixFinMois(r, staffId), [cle]: val } } } }));
  }
  function soldeHeuresActuel(s) {
    const recs = [...(pointage || [])].sort((a, b) => (a.mois < b.mois ? 1 : -1));
    if (!recs.length) return Number(String(s.soldeHeuresInitial || "").replace(",", ".")) || 0;
    // Solde à la fin du dernier mois pointé.
    return soldeHeuresMois(s, recs[0].mois).fin;
  }
  // Congés pris sur l'année : mois pointés (calendrier) + anciens mois saisis à la main.
  function congesPrisAnnee(s, annee) {
    let total = 0;
    for (let m = 1; m <= 12; m++) {
      const ym = `${annee}-${String(m).padStart(2, "0")}`;
      if (recPointage(ym)) {
        if (staffPresentSur(s, `${ym}-01`, finDeMois(ym))) total += calculPersonneMois(s, ym).congesJ;
      } else {
        const l = (suiviMensuel || []).find((x) => x.staffId === s.id && x.mois === ym);
        if (l) total += Number(l.conges) || 0;
      }
    }
    return arrondiH(total);
  }
  function personnesPointage(ym) {
    return (staff || [])
      .filter((s) => !ficheStaffMasquee(s) && !estExterneStaff(s) && staffPresentSur(s, `${ym}-01`, finDeMois(ym)))
      .filter((s) => peutGererStaff || (peut("staff.equipe") && (s.compte === user.id || dansPerimetre(s, staff, user.id))))
      .sort((a, b) => {
        // Nils 06/10 : bureau Marrakech, puis commerciaux (Taha juste après Souad), puis usine.
        const rang = (x) => ({ bureau: 0, commercial: 1, usine: 2 })[regimeDe(x).cle] ?? 3;
        const ra = rang(a), rb = rang(b);
        return ra !== rb ? ra - rb : a.nom.localeCompare(b.nom, "fr", { sensitivity: "base" });
      });
  }
  // Nils 06/10 : deux parties — Usine (Ahmed) et Bureau Marrakech + commerciaux (Sawsan) ; Nils valide.
  function partiePointage(s, rec) {
    return regimePointage(s, rec).cle === "usine" ? "usine" : "bureau";
  }
  function partTransmise(rec, part) {
    if (!rec) return null;
    if (rec.transmis && rec.transmis[part]) return rec.transmis[part];
    if (part === "usine" && rec.statut === "transmis") return { par: rec.transmisPar || "Production Manager", le: rec.transmisLe || "" };
    return null;
  }
  function peutEditerPointage(s, rec) {
    if (rec && rec.statut === "validé") return false;
    if (peut("pointage.saisir")) return true;
    if (peut("staff.equipe")) return partiePointage(s, rec) === "usine" && !partTransmise(rec, "usine") && (s.compte === user.id || dansPerimetre(s, staff, user.id));
    return false;
  }
  async function majRecPointage(ym, fn) {
    const liste = [...(pointage || [])];
    const i = liste.findIndex((x) => x.mois === ym);
    const base = i >= 0 ? liste[i] : { id: ym, mois: ym, statut: "en cours", lignes: {} };
    const maj = fn({ ...base, lignes: { ...(base.lignes || {}) } });
    if (i >= 0) liste[i] = maj; else liste.push(maj);
    await persistPointage(liste);
    return maj;
  }
  async function enregistrerCellule(reinitialiser) {
    const c = celluleEdit;
    if (!c) return;
    const s = (staff || []).find((x) => x.id === c.staffId);
    if (!s || !peutEditerPointage(s, recPointage(moisPointage))) return;
    const heures = String(c.heures ?? "").replace(",", ".").trim();
    if (heures !== "" && (!isFinite(Number(heures)) || Number(heures) < 0 || Number(heures) > 24)) { setNotice("Heures : entre 0 et 24."); return; }
    const demi = !!c.demi && !!c.code && c.code !== "F";
    const code2 = demi && c.code2 && c.code2 !== c.code && c.code2 !== "F" ? c.code2 : "";
    // Nils 01/11 : déplacement sans fiche (avant l'ERP, ou fiche non saisie) — jour « D* », compté dans les primes.
    const dm = c.code === "" && c.deplManuel ? c.deplManuel : null;
    if (!reinitialiser && dm && !(dm.lieu || "").trim()) { setNotice("Déplacement sans fiche : indique le lieu (ou la zone)."); return; }
    const valeur = reinitialiser ? null : { code: c.code, demi, ...(code2 ? { code2 } : {}), heures: heures === "" || (c.code !== "" && c.code !== "F") ? "" : Number(heures), surConges: false, ...(c.code === "F" && Number(heures) > 0 && c.ferie ? { ferie: c.ferie } : {}), ...(dm ? { deplManuel: { lieu: dm.lieu.trim(), dossier: (dm.dossier || "").trim(), jours: Number(dm.jours) === 0.5 ? 0.5 : 1 } } : {}), note: (c.note || "").trim(), par: user.nom, le: new Date().toISOString() };
    // ERP step 12 (Nils 30/09) : alerte à Nils dès la saisie — heures sup., absences, maladie.
    const recAv = recPointage(moisPointage);
    const avant = recAv && recAv.lignes && recAv.lignes[s.id] && recAv.lignes[s.id].jours ? recAv.lignes[s.id].jours[c.cle] || null : null;
    // Nils 06/10 : congés épuisés — contrôle sur le droit de l'année civile entière (congés donnés en avance possibles).
    {
      const jC = (v) => codesSaisie(v).reduce((n, x) => n + (x.code === "C" ? x.frac : 0), 0);
      const delta = jC(valeur) - jC(avant);
      if (delta > 0) {
        const sc = soldeCongesAnnuel(s, c.date.slice(0, 4));
        if (sc.reste - delta < 0) {
          const msg = `Congés épuisés pour ${s.nom} : reste ${String(sc.reste).replace(".", ",")} j sur ${c.date.slice(0, 4)} (droit ${String(sc.droit).replace(".", ",")} j${sc.report ? ` + report ${String(sc.report).replace(".", ",")} j` : ""}, déjà pris ${String(sc.pris).replace(".", ",")} j).`;
          if (!estGerant) { setNotice(`${msg} Demande au Gérant.`); return; }
          if (!(await demander(`${msg}\n\nEnregistrer quand même ?`))) return;
        }
      }
    }
    const regAl = regimePointage(s, recAv);
    const nature = (v) => {
      if (!v) return null;
      if (codeNorm(v.code) === "A") return { type: "Pointage : absence", lib: `absence${v.demi ? " (demi-journée)" : ""}` };
      if (v.code === "MP") return { type: "Pointage : mise à pied", lib: `mise à pied${v.demi ? " (demi-journée)" : ""}` };
      if (v.code === "MC" || v.code === "MS") return { type: "Pointage : maladie / accident", lib: `maladie / accident ${v.code === "MC" ? "avec" : "sans"} certificat${v.demi ? " (demi-journée)" : ""}` };
      const h = v.heures === "" || v.heures === undefined || v.heures === null ? null : Number(v.heures);
      const sp = speciauxDuMois(moisPointage, recAv)[c.date];
      // Ramadan : seuil des heures sup. = horaire normal (pas l'horaire réduit).
      const dues = v.code === "F" || (sp && sp.type === "ferie") ? 0 : duesDuJour(regAl, c.date, c.jourSemaine).normal;
      if (dues === 0 && (v.code === "F" || (sp && sp.type === "ferie")) && h > 0) return { type: "Pointage : jour férié travaillé", lib: `${String(h).replace(".", ",")} h — payer ou reporter : décidé par le Gérant en fin de mois` };
      if ((regAl.sansHS || regAl.cle === "bureau") && h !== null && h > dues) return null;
      if ((v.code === "" || v.code === "F") && h !== null && h > dues) return { type: "Pointage : heures supplémentaires", lib: `${String(h).replace(".", ",")} h faites pour ${String(dues).replace(".", ",")} h dues (+${String(arrondiH(h - dues)).replace(".", ",")} h)` };
      return null;
    };
    const moitie2 = (v) => (v && code2Saisie(v) ? { ...v, code: code2Saisie(v), demi: true } : null);
    for (const [nAv, nAp] of [[nature(avant), nature(valeur)], [nature(moitie2(avant)), nature(moitie2(valeur))]]) {
      if (nAp && !estGerant && (!nAv || nAv.lib !== nAp.lib)) {
        await alerter(nAp.type, `${s.nom} — ${JOURS_SEMAINE_LONGS[c.jourSemaine].toLowerCase()} ${formatDate(c.date)} : ${nAp.lib}${valeur.note ? ` — ${valeur.note}` : ""} (saisi par ${user.nom})`, { kind: "onglet", id: "staff" });
      }
    }
    await majRecPointage(moisPointage, (rec) => {
      const ligne = { ...(rec.lignes[s.id] || {}), jours: { ...((rec.lignes[s.id] || {}).jours || {}) } };
      if (valeur === null) delete ligne.jours[c.cle]; else ligne.jours[c.cle] = valeur;
      return { ...rec, lignes: { ...rec.lignes, [s.id]: ligne } };
    });
    setCelluleEdit(null);
  }
  async function transmettrePointage(part) {
    if (part === "usine" ? !peut("pointage.transmettre") : !peut("pointage.saisir")) return;
    const ym = moisPointage;
    const lib = part === "usine" ? "usine" : "bureau Marrakech et commerciaux";
    // Nils 20/10 (b) : un clic transmettait sans prévenir ; la saisie est ensuite verrouillée.
    if (!(await demander(`Transmettre le pointage ${lib} de ${libMois(ym)} au Gérant ?\n\nTa saisie de ce mois sera verrouillée. Vérifie d'abord que tout le mois est rempli.`))) return;
    await majRecPointage(ym, (rec) => {
      const f = figerMois(rec, ym, part);
      const transmis = { ...(f.transmis || {}) };
      if (f.statut === "transmis" && !transmis.usine) transmis.usine = { par: f.transmisPar || "Production Manager", le: f.transmisLe || "" };
      transmis[part] = { par: user.nom, le: new Date().toISOString() };
      return { ...f, statut: "en cours", transmis };
    });
    await tracerAcces("pointage transmis", `${libMois(ym)} — ${lib} — transmis au Gérant`);
    if (!estGerant) await alerter("Pointage transmis", `${libMois(ym)} — ${lib} transmis par ${user.nom}`, { kind: "onglet", id: "staff" });
    setNotice(`Pointage ${lib} de ${libMois(ym)} transmis au Gérant.`);
  }
  // Nils 20/10 (a) : l'Administration ou le Gérant rend la main au Production Manager tant que le mois n'est pas validé.
  async function rendreMainUsine() {
    const ym = moisPointage;
    const rec = recPointage(ym);
    if (!peut("pointage.saisir") || !rec || rec.statut === "validé" || !partTransmise(rec, "usine")) return;
    if (!(await demander(`Rendre la main pour le pointage usine de ${libMois(ym)} ?\n\nLa transmission est annulée : le Production Manager pourra de nouveau saisir, puis transmettre.`))) return;
    await majRecPointage(ym, (r) => {
      const transmis = { ...(r.transmis || {}) };
      delete transmis.usine;
      return { ...r, statut: r.statut === "transmis" ? "en cours" : r.statut, transmis };
    });
    await tracerAcces("pointage rendu", `${libMois(ym)} — usine — transmission annulée, saisie rendue au Production Manager`);
    setNotice(`Pointage usine de ${libMois(ym)} : la main est rendue au Production Manager.`);
  }
  async function validerPointage() {
    if (!peut("pointage.decisions")) return;
    const ym = moisPointage;
    const personnes = personnesPointage(ym);
    {
      const recV = recPointage(ym);
      const parts = [...new Set(personnes.map((x) => partiePointage(x, recV)))];
      const manquent = parts.filter((p) => !partTransmise(recV, p)).map((p) => (p === "usine" ? "usine (Production Manager)" : "bureau et commerciaux (Administration)"));
      if (manquent.length && !(await demander(`Pas encore transmis : ${manquent.join(", ")}.\n\nValider le mois quand même ?`))) return;
    }
    {
      const aDecider = personnes.filter((s) => calculPersonneMois(s, ym).ferieADecider > 0).map((s) => s.nom);
      if (aDecider.length && !methodeV2(null)) { setNotice(`Jour férié travaillé : « payer » ou « récupérer » à choisir avant de valider (${aDecider.join(", ")}).`); return; }
    }
    const regul = [];
    const maj = await majRecPointage(ym, (rec) => {
      const lignes = { ...rec.lignes };
      personnes.forEach((s) => {
        const l = { ...(lignes[s.id] || {}) };
        l.choix = choixFinMois(rec, s.id);
        if (Object.entries(l.choix).some(([k, v]) => v !== CHOIX_FIN_MOIS_DEFAUT[k])) regul.push(s.nom);
        lignes[s.id] = l;
      });
      const parNils = peut("pointage.decisions");
      // Nils 06/10 : à la validation, les horaires figés reprennent le ramadan actuel (sinon les dates saisies après la transmission étaient perdues).
      const fm = figerMois(rec, ym);
      const regimesV = { ...(fm.regimes || {}) };
      Object.keys(regimesV).forEach((id) => { const st = (staff || []).find((x) => x.id === id); if (st) regimesV[id] = { ...regimesV[id], ramadan: regimeDe(st).ramadan }; });
      return { ...fm, regimes: regimesV, lignes, methode: 2, statut: "validé", validePar: user.nom, valideLe: new Date().toISOString(), ...(parNils ? { decisionsValideesPar: user.nom, decisionsValideesLe: new Date().toISOString() } : {}) };
    });
    await tracerAcces("pointage validé", `${libMois(ym)} — ${personnes.length} personne(s)${regul.length ? ` — régularisation : ${regul.join(", ")}` : ""}`);
    setNotice(`Pointage de ${libMois(ym)} validé${maj.decisionsValideesLe ? " — l'Administration a la tâche de le transmettre au comptable" : ""}.`);
  }
  async function validerDecisionsHeures() {
    if (!peut("pointage.decisions")) return;
    const ym = moisPointage;
    await majRecPointage(ym, (rec) => ({ ...rec, decisionsValideesPar: user.nom, decisionsValideesLe: new Date().toISOString() }));
    await tracerAcces("décisions d'heures validées", libMois(ym));
  }
  async function rouvrirPointage() {
    if (!peut("pointage.decisions")) return;
    const ym = moisPointage;
    await majRecPointage(ym, (rec) => ({ ...rec, statut: "en cours", validePar: "", valideLe: "", decisionsValideesPar: "", decisionsValideesLe: "" }));
    await tracerAcces("pointage rouvert", libMois(ym));
  }
  // Nils 06/10 : bouton « ⚡ » (phase de développement uniquement) — remplit les jours ouvrables vides : présent, heures normales.
  async function remplirPresentDev(s) {
    const ym = moisPointage;
    const rec = recPointage(ym);
    if (!MODE_DEV || !peutEditerPointage(s, rec)) return;
    const reg = regimePointage(s, rec);
    const sp = speciauxDuMois(ym, rec);
    const deja = rec && rec.lignes && rec.lignes[s.id] ? rec.lignes[s.id].jours || {} : {};
    const ajout = {};
    joursDuMois(ym).forEach((j) => {
      if ((s.dateEmbauche && j.date < s.dateEmbauche) || (s.dateSortie && j.date > s.dateSortie)) return;
      if (deja[j.cle] || sp[j.date] || congeSpecialDu(s, j.date, typesCongesSpeciaux())) return;
      const d = duesDuJour(reg, j.date, j.jourSemaine);
      if (!(d.dues > 0)) return;
      ajout[j.cle] = { code: "", demi: false, heures: d.dues, surConges: false, note: "", par: user.nom, le: new Date().toISOString() };
    });
    if (!Object.keys(ajout).length) { setNotice("Aucun jour ouvrable vide à remplir."); return; }
    await majRecPointage(ym, (r) => ({ ...r, lignes: { ...r.lignes, [s.id]: { ...(r.lignes[s.id] || {}), jours: { ...((r.lignes[s.id] || {}).jours || {}), ...ajout } } } }));
    setNotice(`${s.nom} : ${Object.keys(ajout).length} jour(s) remplis (présent, heures normales).`);
  }
  // Nils 06/10 : impression du pointage du mois (ce que l'utilisateur voit), A4 paysage.
  async function imprimerPointage() {
    const ym = moisPointage;
    const rec = recPointage(ym);
    const jours = joursDuMois(ym);
    const sp = speciauxDuMois(ym, rec);
    const personnes = personnesPointage(ym);
    const fh = (h) => (h ? `${h > 0 ? "+" : ""}${String(arrondiH(h)).replace(".", ",")} h` : "0");
    const coul = Object.fromEntries(CODES_POINTAGE.map((c) => [c.code, c.couleur]));
    const statut = !rec ? "En cours de saisie" : rec.statut === "validé" ? `Validé par ${rec.validePar || "Gérant"} le ${rec.valideLe ? formatDate(rec.valideLe.slice(0, 10)) : "—"}` : [partTransmise(rec, "usine") ? `Usine transmise par ${partTransmise(rec, "usine").par}` : "Usine en saisie", partTransmise(rec, "bureau") ? `bureau et commerciaux transmis par ${partTransmise(rec, "bureau").par}` : "bureau et commerciaux en saisie"].join(" · ") + " — non validé";
    const tete = `<tr><th class="nom">Personne</th>${jours.map((j) => `<th class="${j.jourSemaine === 0 || j.jourSemaine === 6 || sp[j.date] ? "off" : ""}">${JOURS_SEMAINE_COURTS[j.jourSemaine]}<br>${j.d}</th>`).join("")}<th>Écart</th><th>Solde fin</th><th>Congés mois</th><th>Reste congés ${ym.slice(0, 4)}</th><th>Fin de mois</th></tr>`;
    const lignes = personnes.map((s) => {
      const reg = regimePointage(s, rec);
      const saisies = rec && rec.lignes && rec.lignes[s.id] ? rec.lignes[s.id].jours || {} : {};
      const c = calculPersonneMois(s, ym);
      const sh = soldeHeuresMois(s, ym);
      const sc = soldeCongesAnnuel(s, ym.slice(0, 4));
      const dec = rec && rec.lignes && rec.lignes[s.id] ? rec.lignes[s.id].decision || "reporter" : "reporter";
      const cases = jours.map((j) => {
        if ((s.dateEmbauche && j.date < s.dateEmbauche) || (s.dateSortie && j.date > s.dateSortie)) return `<td class="hors"></td>`;
        const csj = congeSpecialDu(s, j.date, typesCongesSpeciaux());
        if (csj) return `<td style="background:#E3E0F0">${escapeHtml(csj.type.code)}</td>`;
        const x = saisies[j.cle] || null;
        const p = sp[j.date];
        const code = x && x.code !== undefined ? codeNorm(x.code) : p ? (p.type === "ferie" ? "F" : "C") : "";
        let t = code ? (x && x.code ? texteCodeSaisie(x) : code) : "";
        if (!code && x && x.heures !== "" && x.heures !== undefined && x.heures !== null) t = String(x.heures).replace(".", ",");
        if (code === "F" && x && Number(x.heures) > 0) t = `F+${String(x.heures).replace(".", ",")}`;
        if (!code && x && x.deplacementId) t = `D ${t}`.trim();
        if (!code && x && x.deplManuel && !x.deplacementId) t = `D* ${t}`.trim();
        const off = j.jourSemaine === 0 || j.jourSemaine === 6;
        return `<td style="background:${code ? coul[code] || "#fff" : off ? "#E6E0DB" : "#fff"}">${escapeHtml(t)}</td>`;
      }).join("");
      return `<tr><td class="nom"><b>${escapeHtml(s.nom)}</b><br><span class="reg">${escapeHtml(reg.label || "")}</span></td>${cases}<td class="n">${fh(sh.ecart)}</td><td class="n"><b>${fh(sh.fin)}</b></td><td class="n">${c.congesJ ? `${String(c.congesJ).replace(".", ",")} j` : "—"}</td><td class="n${sc.reste < 0 ? " neg" : ""}">${String(sc.reste).replace(".", ",")} j</td><td class="n fm">${sh.rub ? escapeHtml(resumeFinMois(sh) || "—") : sh.fin === 0 ? "—" : dec === "regulariser" ? (sh.fin > 0 ? "Payer" : "Déduire") : "Reporter"}</td></tr>`;
    }).join("");
    const legende = `Case vide = présent aux heures dues · chiffre = heures réellement faites · ½ = demi-journée · X/Y = deux demi-journées · D = déplacement (présent, journée normale) · ${[...CODES_POINTAGE.map((c) => `<span class="code" style="background:${c.couleur}">${c.code}</span> ${escapeHtml(c.label)}`), ...typesCongesSpeciaux().map((t) => `<span class="code" style="background:#E3E0F0">${escapeHtml(t.code)}</span> ${escapeHtml(t.libelle)}`)].join(" · ")}`;
    const html = `<!DOCTYPE html><html lang="fr"><head><meta charset="UTF-8"><title>Pointage</title>
<style>
  @page { size: A4 landscape; margin: 0.8cm; }
  * { box-sizing: border-box; }
  body { margin: 0; font-family: "DM Sans", Arial, sans-serif; color: #281E1E; font-size: 7.5pt; }
  .tete { display: flex; justify-content: space-between; align-items: flex-end; padding-bottom: 8px; border-bottom: 2px solid #281E1E; margin-bottom: 8px; }
  .tete img { height: 40px; }
  h1 { font-family: "Cormorant Garamond", Georgia, serif; font-weight: 400; font-size: 18pt; margin: 0; text-transform: capitalize; }
  .statut { font-size: 8pt; text-align: right; }
  table { width: 100%; border-collapse: collapse; table-layout: fixed; }
  th, td { border: 1px solid #ddd8d6; text-align: center; padding: 3px 1px; overflow: hidden; }
  th { font-size: 6.5pt; background: #F2EFED; }
  th.off { color: #8C8282; }
  th.nom, td.nom { width: 110px; text-align: left; padding-left: 4px; }
  td.n { font-size: 7pt; white-space: nowrap; }
  td.neg { color: #A8502F; font-weight: 700; }
  td.fm { white-space: normal; font-size: 6pt; width: 120px; text-align: left; }
  td.hors { background: #F7F5F3; }
  .reg { color: #8C8282; font-size: 6.5pt; }
  .legende { margin-top: 8px; font-size: 6.8pt; color: #555; line-height: 1.8; }
  .code { padding: 0 4px; border-radius: 3px; font-weight: 700; }
  .sign { margin-top: 16px; display: flex; gap: 60px; font-size: 8pt; }
  tr { page-break-inside: avoid; }
</style></head><body>
<div class="tete"><img src="${LOGO_SRC}" alt="Stone Concept"><div><h1>Pointage — ${escapeHtml(libMois(ym))}</h1><div class="statut">${escapeHtml(statut)}<br>Imprimé par ${escapeHtml(user.nom)} le ${formatDate(todayISO())}</div></div></div>
<table><thead>${tete}</thead><tbody>${lignes || `<tr><td colspan="${jours.length + 6}">Personne en poste ce mois-là.</td></tr>`}</tbody></table>
<div class="legende">${legende}</div>
<div class="sign"><div>Saisi par : ____________________</div><div>Validé par (Gérant) : ____________________</div></div>
</body></html>`;
    await telechargerDocument(html, `Pointage_${ym}`, "pointage");
    await tracerAcces("pointage imprimé", libMois(ym));
  }
  // ---- ERP step 12 (Nils 01/10) : éléments de paie pour le comptable (remplace le CSV) ----
  // Heures sup. payées uniquement si la décision validée par Nils est « régulariser »
  // (reporter = récupérées) : 25 % ; jours fériés travaillés à part. Jamais de travail
  // le dimanche (Nils 14/10). Primes : seulement celles versées depuis la banque
  // (les autres, Nils les envoie lui-même).
  function elementsPaie(s, ym) {
    const rec = recPointage(ym);
    const sh = soldeHeuresMois(s, ym);
    const c = sh.calc || calculPersonneMois(s, ym);
    const decision = rec && rec.lignes && rec.lignes[s.id] ? rec.lignes[s.id].decision || "reporter" : "reporter";
    if (sh.rub) return { sh, c, h25: sh.rub.h25, hNormal: sh.rub.hNormal, ferieH: sh.rub.ferieP, hDeduire: sh.rub.hDeduire, cnssJ: arrondiH(sh.rub.cnssJ + (c.csCnssJ || 0)), reporte: sh.fin, detail: sh.rub.detail };
    // Ancien calcul (mois validés avant le 06/10) : un solde positif payé part en heures sup. à 25 %.
    let h25 = 0, hDeduire = 0, reporte = 0;
    if (decision === "regulariser") {
      if (sh.fin > 0) h25 = sh.fin;
      else hDeduire = arrondiH(-sh.fin);
    } else reporte = sh.fin;
    return { sh, c, decision, h25: arrondiH(h25), hNormal: 0, ferieH: arrondiH(c.ferieH || 0), hDeduire, cnssJ: arrondiH((c.mcJ || 0) + (c.csCnssJ || 0)), reporte: arrondiH(reporte), detail: [] };
  }
  async function exporterElementsPaie() {
    if (!peutGererStaff) return;
    const ym = moisPointage;
    const rec = recPointage(ym);
    if (!rec || rec.statut !== "validé" || !rec.decisionsValideesLe) { setNotice("Le mois doit être validé et les décisions d'heures validées par le Gérant avant l'envoi au comptable."); return; }
    let XLSX;
    try { XLSX = await chargerSheetJS(); } catch (e) { setNotice(e.message); return; }
    const debut = `${ym}-01`, fin = finDeMois(ym);
    const [an, m] = ym.split("-").map(Number);
    const d = (iso) => (iso ? new Date(`${iso}T00:00:00`) : "");
    const r2 = (x) => Math.round((Number(x) || 0) * 100) / 100;
    const num = (v) => Number(String(v ?? "").replace(/\s/g, "").replace(",", ".")) || 0;
    const jj = (iso) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;
    const SOUS_POSTES_PRIMES = ["Primes", "Prime de productivité", "Prime de déplacement"];
    const estTiers = (o, s) => o.tiersType === "employe" && [s.nom, ...(s.anciensNoms || [])].some((n) => normNomStaff(n) === normNomStaff(o.tiers));
    const opsMois = (operations || []).filter((o) => !o.miroirDe && (o.date || "") >= debut && (o.date || "") <= fin && o.tiersType === "employe");
    const salaireAu = (s, date) => { const l = [...(s.salaires || [])].filter((x) => x.dateEffet <= date).sort((a, b) => (a.dateEffet < b.dateEffet ? 1 : -1))[0]; return l ? Number(l.net) || 0 : ""; };
    const congesPrisJusqua = (s) => {
      let t = 0;
      for (let k = 1; k <= m; k++) {
        const y = `${an}-${String(k).padStart(2, "0")}`;
        if (recPointage(y)) { if (staffPresentSur(s, `${y}-01`, finDeMois(y))) t += calculPersonneMois(s, y).congesJ; }
        else { const l = (suiviMensuel || []).find((x) => x.staffId === s.id && x.mois === y); if (l) t += Number(l.conges) || 0; }
      }
      return t;
    };
    const personnes = personnesPointage(ym).filter((s) => s.contrat !== "Agent commercial").sort((a, b) => a.nom.localeCompare(b.nom, "fr", { sensitivity: "base" }));
    const mouvements = [];
    const lignes = personnes.map((s) => {
      const e = elementsPaie(s, ym);
      const jours = rec.lignes && rec.lignes[s.id] ? rec.lignes[s.id].jours || {} : {};
      const parCode = {};
      Object.keys(jours).sort().forEach((cle) => {
        const x = jours[cle];
        if (!x || !x.code || x.code === "F") return;
        const date = `${ym}-${cle}`;
        if ((s.dateEmbauche && date < s.dateEmbauche) || (s.dateSortie && date > s.dateSortie)) return;
        codesSaisie(x).forEach((k) => { (parCode[k.code] = parCode[k.code] || []).push(`${jj(date)}${k.frac < 1 ? " (½)" : ""}`); });
      });
      const primes = opsMois.filter((o) => o.sens === "sortie" && SOUS_POSTES_PRIMES.includes(o.sousPoste) && (compteDe(o.compteId) || {}).type === "banque" && estTiers(o, s));
      // Avances : toujours payées depuis la CFG (Nils 01/10).
      const avances = opsMois.filter((o) => o.sens === "sortie" && o.sousPoste === SOUS_POSTE_AVANCES && (compteDe(o.compteId) || {}).type === "banque" && estTiers(o, s));
      const rembts = opsMois.filter((o) => o.sens === "entree" && estTiers(o, s));
      const totPrimes = primes.reduce((t, o) => t + num(o.montant), 0);
      const totAv = Math.max(0, avances.reduce((t, o) => t + num(o.montant), 0) - rembts.reduce((t, o) => t + num(o.montant), 0));
      primes.forEach((o) => mouvements.push([d(o.date), s.nom, `Prime versée par ${(compteDe(o.compteId) || {}).nom || "banque"}`, `${o.sousPoste}${o.designation ? ` — ${o.designation}` : ""}`, r2(num(o.montant))]));
      avances.forEach((o) => mouvements.push([d(o.date), s.nom, "Avance / acompte versé", `${(compteDe(o.compteId) || {}).nom || ""}${o.designation ? ` — ${o.designation}` : ""}`, r2(num(o.montant))]));
      rembts.forEach((o) => mouvements.push([d(o.date), s.nom, "Remboursement reçu de l'employé", `${(compteDe(o.compteId) || {}).nom || ""}${o.designation ? ` — ${o.designation}` : ""}`, -r2(num(o.montant))]));
      if (s.dateEmbauche && s.dateEmbauche >= debut && s.dateEmbauche <= fin) mouvements.push([d(s.dateEmbauche), s.nom, "Entrée", [s.contrat, s.poste].filter(Boolean).join(" — "), ""]);
      if (s.dateSortie && s.dateSortie >= debut && s.dateSortie <= fin) mouvements.push([d(s.dateSortie), s.nom, "Sortie", "Dernier jour travaillé", ""]);
      (s.salaires || []).filter((x) => x.dateEffet >= debut && x.dateEffet <= fin).forEach((x) => mouvements.push([d(x.dateEffet), s.nom, `Salaire — ${x.type || "changement"}`, `Nouveau salaire net${x.commentaire ? ` — ${x.commentaire}` : ""}`, r2(x.net)]));
      const obs = [];
      const libCodes = { MP: "Mise à pied", C: "Congés", MC: "Maladie avec certificat", MS: "Maladie sans certificat", A: "Absence", R: "Récupération" };
      if ((e.detail || []).length) obs.push(`Heures à déduire : ${e.detail.join(" + ")}`);
      if (e.sh && e.sh.rub && e.sh.rub.lignes.some((l) => l.cle === "mc" && l.choix === "reporter")) obs.push("Maladie avec certificat reportée au compteur (pas de jours CNSS)");
      ["MP", "MC", "MS", "A", "C", "R"].forEach((k) => { if (parCode[k]) obs.push(`${libCodes[k]} : ${parCode[k].join(", ")}`); });
      (s.congesSpeciaux || []).filter((x) => x.debut <= fin && x.fin >= debut).forEach((x) => { const t = typesCongesSpeciaux().find((y) => y.id === x.typeId) || { libelle: x.libelle, prise: "employeur" }; obs.push(`${t.libelle} du ${formatDate(x.debut)} au ${formatDate(x.fin)} (${t.prise === "cnss" ? "CNSS — retiré de la paie" : "payé par l'employeur"})`); });
      if (s.dateEmbauche && s.dateEmbauche >= debut && s.dateEmbauche <= fin) obs.push(`Entrée le ${formatDate(s.dateEmbauche)}`);
      if (s.dateSortie && s.dateSortie >= debut && s.dateSortie <= fin) obs.push(`Sortie le ${formatDate(s.dateSortie)}`);
      const soldeC = Math.round(((Number((s.reportConges || {})[String(an)]) || 0) + congesAcquisADate(s, String(an), fin < todayISO() ? fin : todayISO(), paramsConges()) - congesPrisJusqua(s)) * 2) / 2;
      return {
        s, e, obs, totPrimes, totAv,
        row: [s.matricule || "", s.cnss || "", s.cin || "", s.nomFamille || "", s.prenom || "", s.poste || "", s.service || "", s.contrat || "", d(s.dateEmbauche), d(s.dateSortie && s.dateSortie <= fin ? s.dateSortie : ""), salaireAu(s, fin),
          e.h25, e.hNormal, e.ferieH, e.hDeduire, e.cnssJ, e.c.mpJ || 0, r2(totPrimes), r2(totAv),
          e.c.ouvres, e.c.presents, e.c.congesJ, e.c.feriesJ, e.c.aH, e.c.recupH, e.reporte, soldeC, obs.join(" · ")],
      };
    });
    const entetes = ["Matricule", "N° CNSS", "CIN", "Nom", "Prénom", "Fonction", "Service", "Contrat", "Date d'embauche", "Date de sortie", "Salaire net de base (DH)",
      "Heures sup. à 25 % (h)", "Heures du compteur à payer — taux normal, déjà majorées (h)", "Heures de jour férié travaillé — à payer (h)", "Heures à déduire (h)", "Jours CNSS — maladie avec certificat, maternité… (j)", "Mise à pied — jours non payés (j)", "Primes versées par banque (DH)", "Avances à retenir (DH)",
      "Jours ouvrés", "Jours travaillés", "Congés pris (j)", "Jours fériés (j)", "Absences (h)", "Récupérations (h)", "Compteur d'heures reporté (h)", "Solde de congés fin de mois (j)", "Observations"];
    const L0 = 5; // première ligne de données (1-indexée)
    const aoa = [
      [`Stone Concept — Éléments de paie — ${libMois(ym)}`],
      [`Pointage validé par ${rec.validePar || "—"} le ${rec.valideLe ? formatDate(rec.valideLe.slice(0, 10)) : "—"} · décisions d'heures validées par ${rec.decisionsValideesPar || "Gérant"} le ${formatDate(rec.decisionsValideesLe.slice(0, 10))} · fichier établi par ${user.nom} le ${formatDate(todayISO())}`],
      ["IDENTIFICATION", "", "", "", "", "", "", "", "", "", "", "À APPLIQUER SUR LA PAIE", "", "", "", "", "", "", "", "POUR INFORMATION (déjà pris en compte dans le compteur d'heures ou les congés)"],
      entetes,
      ...lignes.map((l) => l.row),
    ];
    const nL = lignes.length;
    const lt = L0 + nL; // ligne des totaux
    aoa.push(["TOTAL"]);
    const ws = XLSX.utils.aoa_to_sheet(aoa, { cellDates: true });
    const colL = (i) => XLSX.utils.encode_col(i);
    for (let i = 0; i < nL; i++) {
      const r = L0 + i;
      ["I", "J"].forEach((c) => { if (ws[`${c}${r}`]) ws[`${c}${r}`].z = "dd/mm/yyyy"; });
      ["K", "R", "S"].forEach((c) => { if (ws[`${c}${r}`] && ws[`${c}${r}`].t === "n") ws[`${c}${r}`].z = "#,##0.00"; });
      ["A", "B", "C"].forEach((c) => { if (ws[`${c}${r}`]) { ws[`${c}${r}`].t = "s"; ws[`${c}${r}`].v = String(ws[`${c}${r}`].v ?? ""); } });
    }
    if (nL) {
      for (let i = 11; i <= 27; i++) {
        const c = colL(i);
        ws[`${c}${lt}`] = { t: "n", v: r2(lignes.reduce((t, l) => t + (Number(l.row[i]) || 0), 0)), f: `SUM(${c}${L0}:${c}${lt - 1})`, ...(i === 17 || i === 18 ? { z: "#,##0.00" } : {}) };
      }
    }
    ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 10 } }, { s: { r: 1, c: 0 }, e: { r: 1, c: 28 } }, { s: { r: 2, c: 0 }, e: { r: 2, c: 10 } }, { s: { r: 2, c: 11 }, e: { r: 2, c: 18 } }, { s: { r: 2, c: 19 }, e: { r: 2, c: 28 } }];
    ws["!cols"] = [10, 12, 11, 16, 13, 20, 16, 11, 11, 11, 12, 10, 14, 12, 10, 12, 12, 12, 12, 8, 9, 9, 8, 10, 10, 11, 11, 11, 60].map((w) => ({ wch: w }));
    ws["!ref"] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: lt - 1, c: entetes.length - 1 } });
    // Détail jour par jour (codes et heures saisis).
    const jours = joursDuMois(ym);
    const sp = speciauxDuMois(ym, rec);
    const det = [["Nom", ...jours.map((j) => `${JOURS_SEMAINE_COURTS[j.jourSemaine]} ${j.d}`)]];
    det.push(["Jour férié / congé collectif", ...jours.map((j) => (sp[j.date] ? sp[j.date].libelle || (sp[j.date].type === "ferie" ? "Férié" : "Congé") : ""))]);
    personnes.forEach((s) => {
      const js = rec.lignes && rec.lignes[s.id] ? rec.lignes[s.id].jours || {} : {};
      det.push([s.nom, ...jours.map((j) => {
        if ((s.dateEmbauche && j.date < s.dateEmbauche) || (s.dateSortie && j.date > s.dateSortie)) return "—";
        const x = js[j.cle];
        if (!x) return "";
        const h = x.heures === "" || x.heures === undefined || x.heures === null ? "" : `${String(x.heures).replace(".", ",")} h`;
        return [x.code ? codesSaisie(x).map((k) => `${k.code}${k.frac < 1 ? " ½" : ""}`).join(" + ") : "", h].filter(Boolean).join(" ");
      })]);
    });
    const wsD = XLSX.utils.aoa_to_sheet(det);
    wsD["!cols"] = [{ wch: 26 }, ...jours.map(() => ({ wch: 6 }))];
    const wsM = XLSX.utils.aoa_to_sheet([["Date", "Nom", "Mouvement", "Détail", "Montant (DH)"], ...mouvements.sort((a, b) => (a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0))], { cellDates: true });
    mouvements.forEach((_, i) => { const r = i + 2; if (wsM[`A${r}`]) wsM[`A${r}`].z = "dd/mm/yyyy"; if (wsM[`E${r}`] && wsM[`E${r}`].t === "n") wsM[`E${r}`].z = "#,##0.00"; });
    wsM["!cols"] = [12, 24, 30, 50, 14].map((w) => ({ wch: w }));
    const notes = [
      ["Comment lire ce fichier"],
      [""],
      ["Heures sup. à 25 % : heures sup. du mois que la direction a choisi de payer (les autres sont reportées au compteur, comptées ×1,25)."],
      ["Heures du compteur à payer : solde positif reporté des mois précédents que la direction a choisi de payer ; déjà majorées, à payer au taux normal."],
      ["   Chaque rubrique (heures sup., heures manquantes, absences, maladie) est décidée séparément par la direction : reportée au compteur, ou payée / retranchée."],
      ["   Compteur mensuel sur la base de 44 h / semaine (usine) : les semaines se compensent dans le mois. Pas d'heures de nuit. Bureau de Marrakech (accord 40 h) : pas d'heures sup."],
      ["Heures de jour férié travaillé : le férié est déjà payé dans le salaire mensuel ; ce sont les heures faites ce jour-là, à ajouter (celles récupérées sont exclues, elles sont au compteur)."],
      ["Heures à déduire : rubriques que la direction a choisi de retrancher (heures manquantes, absences, maladie sans certificat, solde négatif) ; détail dans « Observations »."],
      ["Jours CNSS : maladie avec certificat retirée (choix de la direction) et congés spéciaux pris en charge par la CNSS (maternité…), à retirer de la paie du mois ; détail dans « Observations »."],
      ["Congés spéciaux payés par l'employeur (paternité…) : payés normalement, indiqués dans « Observations » pour information."],
      ["Mise à pied : jours non payés (sanction), à retirer de la paie du mois ; dates dans « Observations »."],
      ["Primes : uniquement celles versées par la banque CFG ce mois-ci (détail dans l'onglet « Mouvements ») ; les autres sont transmises séparément par la direction."],
      ["Avances à retenir : avances / acomptes versés par la banque CFG dans le mois, moins les remboursements reçus de l'employé."],
      ["Colonnes « pour information » : déjà prises en compte dans le compteur d'heures ou le solde de congés — ne pas les déduire une seconde fois."],
      ["Salaire net de base : salaire net mensuel en vigueur au dernier jour du mois."],
      ["Agents commerciaux (commission) : hors de ce fichier."],
      [""],
      ["Document confidentiel — ne pas diffuser."],
    ];
    const wsN = XLSX.utils.aoa_to_sheet(notes);
    wsN["!cols"] = [{ wch: 140 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Synthèse");
    XLSX.utils.book_append_sheet(wb, wsD, "Détail jours");
    XLSX.utils.book_append_sheet(wb, wsM, "Mouvements");
    XLSX.utils.book_append_sheet(wb, wsN, "À lire");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const nomF = `Elements-de-paie-Stone-Concept-${MOIS_COMPTABLE[m - 1]}-${an}.xlsx`;
    const ok = await proposerTelechargement(nomF, buf);
    if (ok) {
      await majRecPointage(ym, (r) => ({ ...r, paieExporteePar: user.nom, paieExporteeLe: new Date().toISOString() }));
      await tracerAcces("éléments de paie exportés", `${libMois(ym)} — ${personnes.length} personne(s)`);
      setNotice(`Éléments de paie de ${libMois(ym)} exportés.`);
    }
  }
  async function ajouterJourSpecial() {
    if (!peut("admin.parametrage")) return; // Nils 02/10 : seul Nils déclare les jours fériés (Paramétrage).
    const j = nouveauJourSpecial;
    if (!j.date || !(j.libelle || "").trim()) { setNotice("Indique la date et le libellé."); return; }
    if (joursSpeciaux().some((x) => x.date === j.date)) { setNotice("Ce jour est déjà déclaré."); return; }
    await persistParametres({ ...(parametres || {}), joursSpeciaux: [...joursSpeciaux(), { date: j.date, libelle: j.libelle.trim(), type: j.type }].sort((a, b) => (a.date < b.date ? -1 : 1)) });
    await tracerAcces("jour férié / congé collectif ajouté", `${formatDate(j.date)} — ${j.libelle.trim()} (${j.type === "ferie" ? "férié" : "congé collectif"})`);
    setNouveauJourSpecial({ date: "", libelle: "", type: j.type });
  }
  async function supprimerJourSpecial(date) {
    if (!peut("admin.parametrage")) return;
    await persistParametres({ ...(parametres || {}), joursSpeciaux: joursSpeciaux().filter((x) => x.date !== date) });
    await tracerAcces("jour férié / congé collectif supprimé", formatDate(date));
  }
  async function ajouterFeriesFixes(annee) {
    if (!peut("admin.parametrage")) return;
    const existants = new Set(joursSpeciaux().map((x) => x.date));
    const ajouts = FERIES_FIXES_MAROC.map(([md, lib]) => ({ date: `${annee}-${md}`, libelle: lib, type: "ferie" })).filter((x) => !existants.has(x.date));
    if (!ajouts.length) { setNotice(`Les jours fériés fixes de ${annee} sont déjà là.`); return; }
    await persistParametres({ ...(parametres || {}), joursSpeciaux: [...joursSpeciaux(), ...ajouts].sort((a, b) => (a.date < b.date ? -1 : 1)) });
    await tracerAcces("jours fériés fixes ajoutés", `${annee} — ${ajouts.length} jour(s)`);
  }
  async function enregistrerRegimes() {
    if (!peut("admin.parametrage") || !regimesSaisis) return;
    const out = {};
    for (const k of Object.keys(regimesSaisis)) {
      const h = regimesSaisis[k].map((v) => Number(String(v).replace(",", ".")));
      if (h.some((v) => !isFinite(v) || v < 0 || v > 24)) { setNotice("Heures par jour : entre 0 et 24."); return; }
      out[k] = { heures: h };
    }
    await persistParametres({ ...(parametres || {}), regimesHoraires: out });
    await tracerAcces("horaires modifiés", Object.keys(out).map((k) => `${regimesHoraires()[k].label} : ${out[k].heures.slice(1, 6).join("/")} (sam. ${out[k].heures[6]}, dim. ${out[k].heures[0]})`).join(" ; "));
    setRegimesSaisis(null);
    setNotice("Horaires enregistrés.");
  }
  async function enregistrerSoldeHeuresInitial() {
    if (!peutGererStaff || !staffEdit) return;
    const v = String(soldeHeuresSaisi).replace(",", ".").trim();
    if (v === "" || !isFinite(Number(v))) { setNotice("Indique un nombre d'heures (négatif si l'employé doit des heures)."); return; }
    const s = (staff || []).find((x) => x.id === staffEdit.id);
    if (!s) return;
    const maj = { ...s, soldeHeuresInitial: Number(v) };
    await persistStaff((staff || []).map((x) => (x.id === s.id ? maj : x)));
    await tracerAcces("solde d'heures de départ", `${s.nom} — ${formatH(Number(v))}`);
    setStaffEdit({ ...staffEdit, soldeHeuresInitial: Number(v) });
    setSoldeHeuresSaisi("");
  }
  // Personnes à évaluer pour un semestre (présentes pendant ce semestre, hors Nils).
  function staffAEvaluer(periode) {
    const [debut, fin] = bornesSemestre(periode);
    return (staff || []).filter((s) => !ficheStaffMasquee(s) && staffPresentSur(s, debut, fin));
  }

  // Reprise automatique : 1er chargement (fiches des comptes ERP + poseurs +
  // personnes des affectations), puis toute personne arrivée par l'import
  // d'une ancienne sauvegarde.
  // Valeurs les plus récentes (mises à jour aussi par les persist*), pour ne
  // jamais travailler sur un état périmé si l'effet se déclenche en retard.
  useEffect(() => {
    if (loading || staff === null || affectationsBrutes === null || poseurs === null || enService === null || outils === null || alertes === null || journalAcces === null) return;
    if (migrationStaffRef.current) return;
    const L = { staff, affectationsBrutes, poseurs, ...derniersStaffRef.current.valeurs };
    const aMigrer = staffAMigrer && !derniersStaffRef.current.initialeFaite;
    const personnesHeritees = (L.affectationsBrutes || []).some((a) => a.type === "personne");
    const poseursHerites = (L.poseurs || []).length > 0;
    if (!aMigrer && !personnesHeritees && !poseursHerites) return;
    migrationStaffRef.current = true;
    // Fiches par défaut seulement si aucune fiche de compte ERP n'existe encore.
    const initiale = aMigrer && !(L.staff || []).some((s) => s.compte);
    derniersStaffRef.current.initialeFaite = true;
    setStaffAMigrer(false);
    if (!initiale && !personnesHeritees && !poseursHerites) {
      migrationStaffRef.current = false;
      return;
    }
    (async () => {
      try {
        const base = initiale ? [...staffParDefaut(), ...(L.staff || [])] : L.staff || [];
        const r = integrerPersonnesHeritees(base, L.affectationsBrutes, L.poseurs, enService, outils);
        const ok = await persistStaff(r.staff);
        if (!ok) return;
        if (personnesHeritees) await persistAffectations(r.affectations);
        if (poseursHerites) await persistPoseurs([]);
        if (!initiale && !r.crees.length && !r.rattaches.length) return;
        const detail = [
          initiale ? `${staffParDefaut().length} fiche(s) créée(s) pour les comptes ERP` : "",
          r.crees.length ? `${r.crees.length} fiche(s) reprise(s) des poseurs / affectations : ${r.crees.join(", ")}` : "",
          r.rattaches.length ? `rattaché(s) à une fiche existante : ${r.rattaches.join(", ")}` : "",
          r.doublons.length ? `⚠ doublons possibles à vérifier : ${r.doublons.join(" ; ")}` : "",
          "à compléter : service, contrat, date d'embauche",
        ].filter(Boolean).join(" — ");
        await alerter("Staff : reprise automatique", detail, { kind: "onglet", id: "staff" });
        await tracerAcces("staff : reprise automatique", detail);
      } finally {
        migrationStaffRef.current = false;
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, staff, affectationsBrutes, poseurs, enService, outils, alertes, journalAcces, staffAMigrer]);
  // ERP step 12 (Nils 30/09) : rattachement initial à Ahmed (une seule fois) des
  // personnes des services atelier, pose, logistique, bureau technique, autre
  // qui n'ont pas encore de responsable. Modifiable ensuite fiche par fiche.
  useEffect(() => {
    if (loading || staffAMigrer || migrationStaffRef.current || !Array.isArray(staff) || staff.length === 0 || parametres === null) return;
    if (parametres && parametres.responsablesInitialises) return;
    const liste = (derniersStaffRef.current.valeurs && derniersStaffRef.current.valeurs.staff) || staff;
    const ahmed = liste.find((x) => x.compte && (compteUtilisateurDe(x.compte) || {}).profil === P_PROD); // Step 17 : profil, plus le prénom
    (async () => {
      await persistParametres({ ...(parametres || {}), responsablesInitialises: new Date().toISOString() });
      if (!ahmed) return;
      const cibles = liste.filter((x) => !x.responsableId && x.id !== ahmed.id && SERVICES_SOUS_AHMED.includes(x.service) && !ficheStaffMasquee(x));
      if (cibles.length === 0) return;
      await persistStaff(liste.map((x) => (cibles.includes(x) ? { ...x, responsableId: ahmed.id } : x)));
      await tracerAcces("staff : responsables initialisés", `${cibles.length} fiche(s) rattachée(s) à ${ahmed.nom} : ${cibles.map((x) => x.nom).join(", ")}`);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, staffAMigrer, staff, parametres]);
  // ERP step 12 (Nils 30/09) : alerte (une fois par facture) dès qu'une facture fournisseur
  // passe en retard, puis au-delà du délai légal (loi 69-21).
  const alertesFactFRef = useRef(false);
  useEffect(() => {
    if (loading || !Array.isArray(facturesF) || !Array.isArray(operations) || !paiements || !fournisseurs || alertesFactFRef.current) return;
    const maj = [];
    facturesF.forEach((fa) => {
      const st = statutFactureF(fa);
      const jl = joursAvantLimiteLegale(fa);
      if (st.code === "legal" && !fa.alerteLegaleLe) maj.push({ fa, type: "legal" });
      else if ((st.code === "retard" || st.code === "legal") && !fa.alerteRetardLe) maj.push({ fa, type: "retard" });
      else if (jl !== null && jl <= JOURS_ALERTE_LIMITE_LEGALE && !fa.alerteLegaleProcheLe) maj.push({ fa, type: "proche" });
    });
    if (!maj.length) return;
    alertesFactFRef.current = true;
    (async () => {
      const maintenant = new Date().toISOString();
      for (const { fa, type } of maj) {
        if (type === "legal") await alerter("Délai légal de paiement dépassé", `${fa.fournisseur} — facture ${fa.numero} du ${formatDate(fa.date)} : ${formatDH(resteFactureF(fa))} non payés au-delà de ${delaiFournisseur(fa.fournisseur).max} j — amende estimée ${formatDH(amendeFactureF(fa))} (loi 69-21)`, { kind: "onglet", id: "facturesF" });
        else if (type === "proche") await alerter("Limite légale de paiement proche", `${fa.fournisseur} — facture ${fa.numero} du ${formatDate(fa.date)} : ${formatDH(resteFactureF(fa))} à payer au plus tard le ${formatDate(limiteLegaleFactureF(fa))} (loi 69-21), sinon amende`, { kind: "onglet", id: "facturesF" });
        else await alerter("Facture fournisseur non payée à l'échéance", `${fa.fournisseur} — facture ${fa.numero} du ${formatDate(fa.date)} : ${formatDH(resteFactureF(fa))} dus depuis le ${formatDate(echeanceFactureF(fa))}`, { kind: "onglet", id: "facturesF" });
      }
      const ids = Object.fromEntries(maj.map((m) => [m.fa.id, m.type]));
      await persistFacturesF(facturesF.map((x) => (ids[x.id] === "legal" ? { ...x, alerteLegaleLe: maintenant, alerteRetardLe: x.alerteRetardLe || maintenant } : ids[x.id] === "retard" ? { ...x, alerteRetardLe: maintenant } : ids[x.id] === "proche" ? { ...x, alerteLegaleProcheLe: maintenant } : x)));
      alertesFactFRef.current = false;
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, facturesF, operations, paiements, fournisseurs]);
  // Nils 04/10 (f) : purge unique et forcée de l'outillage et de la bureautique (base propre) —
  // outils, historiques, contrôles et inventaires ; anciens « lieux » ; catégorie « Bureautique » retirée de l'outillage.
  const purgeOutillageRef = useRef(false);
  useEffect(() => {
    if (loading || purgeOutillageRef.current || !parametres || !Array.isArray(outils) || !Array.isArray(controlesOutillage) || !Array.isArray(affectationsBrutes)) return;
    if (parametres.purgeOutillage20261004) return;
    purgeOutillageRef.current = true;
    (async () => {
      const nbO = outils.length, nbC = controlesOutillage.length, lieux = affectationsBrutes.filter((a) => a.type === "lieu");
      const cats = Array.isArray(parametres.categoriesOutil) ? parametres.categoriesOutil.filter((c) => String(c).trim().toLowerCase() !== "bureautique") : parametres.categoriesOutil;
      if (nbO) await persistOutils([]);
      if (nbC) await persistControlesOutillage([]);
      if (lieux.length) await persistAffectations(affectationsBrutes.filter((a) => a.type !== "lieu"));
      await persistParametres({ ...parametres, ...(cats !== undefined ? { categoriesOutil: cats } : {}), purgeOutillage20261004: new Date().toISOString() });
      if (nbO || nbC || lieux.length) {
        await tracerAcces("outillage et bureautique remis à zéro", `${nbO} objet(s), ${nbC} contrôle(s), ${lieux.length} lieu(x) supprimés`);
        await alerter("Outillage et bureautique remis à zéro", `Base propre (Nils 04/10) : ${nbO} outil(s) / matériel(s) avec leurs historiques, ${nbC} contrôle(s) / inventaire(s) et ${lieux.length} lieu(x) supprimés. Crée tes bureaux dans Stock › Consommables en service › Machines et bureaux.`, { kind: "onglet", id: "outillage" });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, parametres, outils, controlesOutillage, affectationsBrutes]);
  // Nils 04/10 (z) : tâche manuelle dont l'échéance est dépassée → alerte (une fois).
  const alertesTachesRef = useRef(false);
  useEffect(() => {
    if (loading || !Array.isArray(tachesManuelles) || !Array.isArray(alertes) || alertesTachesRef.current) return;
    const deja = new Set((alertesRef.current || []).map((a) => a.lien && a.lien.ref).filter(Boolean));
    const auj = todayISO();
    const enRetard = tachesManuelles.filter((x) => !x.faiteLe && x.echeance && x.echeance < auj && !deja.has(`tache-retard:${x.id}`));
    if (!enRetard.length) return;
    alertesTachesRef.current = true;
    (async () => {
      for (const x of enRetard) await alerter("Tâche en retard", `« ${x.titre} » — ${(x.qui || []).map(nomUtilisateur).join(", ")} — prévue pour le ${formatDate(x.echeance)}`, { ...(x.lien || { kind: "onglet", id: "alertes" }), ref: `tache-retard:${x.id}` });
      alertesTachesRef.current = false;
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, tachesManuelles, alertes]);
  // Nils 04/10 (x, j) : échéance récurrente — alerte 7 jours avant, et alerte si dépassée sans être « réalisée ».
  const alertesRecRef = useRef(false);
  useEffect(() => {
    if (loading || !Array.isArray(recurrentes) || !Array.isArray(alertes) || alertesRecRef.current) return;
    const deja = new Set((alertesRef.current || []).map((a) => a.lien && a.lien.ref).filter(Boolean));
    const auj = todayISO();
    const aEnvoyer = [];
    recurrentes.forEach((r) => occurrencesDues(r, decalerJours(auj, JOURS_ALERTE_RECURRENTE)).forEach((o) => {
      const retard = o.date < auj;
      const ref = `${retard ? "rec-retard" : "rec-j7"}:${r.id}:${o.date}`;
      if (!deja.has(ref)) aEnvoyer.push({ r, o, retard, ref });
    }));
    if (!aEnvoyer.length) return;
    alertesRecRef.current = true;
    (async () => {
      for (const x of aEnvoyer) await alerter(x.retard ? "Échéance récurrente dépassée" : "Échéance récurrente dans 7 jours", `${x.r.libelle} — ${x.r.sens === "entree" ? "+" : "−"}${formatDH(x.o.montant)} le ${formatDate(x.o.date)}${x.retard ? " — pas encore marquée réalisée" : ""}`, { kind: "onglet", id: "compta", ref: x.ref });
      alertesRecRef.current = false;
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, recurrentes, alertes]);
  // Nils 29/10 : facture de retenue de garantie — alerte 10 jours avant le délai légal (60 jours) et s'il est dépassé.
  const alertesRetRef = useRef(false);
  useEffect(() => {
    if (loading || !estGerant || !Array.isArray(alertes) || alertesRetRef.current) return;
    const deja = new Set((alertesRef.current || []).map((a) => a.lien && a.lien.ref).filter(Boolean));
    const auj = todayISO();
    const aEnvoyer = [];
    (facturesAvance || []).filter((fa) => fa.nature === "retenue" && fa.echeanceLegale).forEach((fa) => {
      if (Number(fa.ttc) - encaisseDossier(`avp:${fa.id}`) <= 0.01) return;
      const retard = auj > fa.echeanceLegale;
      if (!retard && auj < decalerJours(fa.echeanceLegale, -JOURS_ALERTE_RETENUE)) return;
      const ref = `${retard ? "ret-retard" : "ret-j10"}:${fa.id}`;
      if (!deja.has(ref)) aEnvoyer.push({ fa, retard, ref });
    });
    if (!aEnvoyer.length) return;
    alertesRetRef.current = true;
    (async () => {
      for (const x of aEnvoyer) await alerter(x.retard ? "Facture de retenue : délai légal dépassé" : "Facture de retenue : délai légal dans 10 jours", `${x.fa.numero} — ${nomProjetDe(x.fa.chantierId)} — reste dû ${formatDH(arrondiH(Number(x.fa.ttc) - encaisseDossier(`avp:${x.fa.id}`)))} — délai légal le ${formatDate(x.fa.echeanceLegale)} (loi 69-21)`, { kind: "onglet", id: "projets", ref: x.ref });
      alertesRetRef.current = false;
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, facturesAvance, alertes, operations]);
  // ERP step 13 (ah7) : rapport non soumis le lundi → alerte à Nils (une fois par commercial et par semaine).
  const alertesRapportComRef = useRef(false);
  useEffect(() => {
    if (loading || !Array.isArray(rapportsCom) || !Array.isArray(alertes) || alertesRapportComRef.current) return;
    const deja = new Set((alertesRef.current || []).map((a) => a.lien && a.lien.ref).filter(Boolean));
    const auj = todayISO();
    const manquants = [];
    commerciauxAvecTache().forEach((u) => {
      for (let l = lundiDe(RAPPORT_COM_DEPUIS); decalerJours(l, 7) <= auj; l = decalerJours(l, 7)) {
        const ref = `rapport-retard:${u.id}:${l}`;
        if (!rapportComFige(u.id, l) && !deja.has(ref)) manquants.push({ u, l, ref });
      }
    });
    if (!manquants.length) return;
    alertesRapportComRef.current = true;
    (async () => {
      for (const m of manquants) await alerter("Rapport commercial non soumis", `${m.u.nom} n'a pas soumis son rapport ${libelleSemaine(m.l)}`, { kind: "rapportCom", com: m.u.id, lundi: m.l, ref: m.ref });
      alertesRapportComRef.current = false;
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, rapportsCom, alertes, acces]);
  // Caisse générale : synchronise les copies liées avec les opérations d'origine.
  const syncCGRef = useRef(false);
  useEffect(() => {
    if (loading || !Array.isArray(operations) || !Array.isArray(comptesTreso) || !commandesListe || !facturesAnt || syncCGRef.current) return;
    if (!compteDe(CAISSE_GENERALE_ID)) return;
    const voulus = miroirsCaisseGenerale(operations);
    const actuels = operations.filter((o) => o.miroirDe);
    const cle = (l) => JSON.stringify(l.map((o) => [o.id, o.date, o.sens, Number(o.montant), o.designation, o.poste, o.sousPoste, o.piece, o.tiers]).sort());
    if (cle(voulus) === cle(actuels)) return;
    syncCGRef.current = true;
    (async () => {
      await persistOperations([...operations.filter((o) => !o.miroirDe), ...voulus]);
      syncCGRef.current = false;
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, operations, comptesTreso, commandesListe, facturesAnt, remplacements, facturesF]);
  // Nils 03/10 (t) : alerte (une fois par chèque) 30 jours avant la fin de validité d'un chèque en main.
  // Dédoublonnage par la liste des alertes (référence du chèque dans le lien) : aucune écriture sur les opérations.
  const alertesChequesRef = useRef(false);
  useEffect(() => {
    if (loading || !Array.isArray(operations) || !comptesTreso || alertesChequesRef.current) return;
    const deja = new Set((alertesRef.current || []).map((a) => a.lien && a.lien.ref).filter(Boolean));
    const proches = chequesEnMain().filter((o) => { const exp = expirationCheque(o.echeanceCheque); return exp && !deja.has(`cheque-exp:${o.id}`) && ecartJours(exp, todayISO()) <= JOURS_ALERTE_EXPIRATION_CHEQUE; });
    if (!proches.length) return;
    alertesChequesRef.current = true;
    (async () => {
      for (const o of proches) await alerter("Chèque bientôt périmé", `${o.mode} ${o.piece || ""} de ${o.tiers || "?"} — ${formatDH(Number(o.montant))} (date ${formatDate(o.echeanceCheque)}) : valable jusqu'au ${formatDate(expirationCheque(o.echeanceCheque))} — détenu par ${nomUtilisateur(detenteurCheque(o)) || "?"}`, { kind: "onglet", id: "compta", ref: `cheque-exp:${o.id}` });
      alertesChequesRef.current = false;
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, operations, comptesTreso, alertes]);
  // Nils 03/10 (r1) : alerte unique par opération CFG pas passée sur le relevé après 30 jours.
  const alertesNonPasseesRef = useRef(false);
  useEffect(() => {
    if (loading || !Array.isArray(operations) || !comptesTreso || alertesNonPasseesRef.current) return;
    const deja = new Set((alertesRef.current || []).map((a) => a.lien && a.lien.ref).filter(Boolean));
    const l = (comptesTreso || []).filter((c) => c.type === "banque").flatMap((c) => opsNonPassees(c.id)).filter((o) => o.date && ecartJours(todayISO(), o.date) > JOURS_ALERTE_NON_PASSEE && !deja.has(`nonpassee:${o.id}`));
    if (!l.length) return;
    alertesNonPasseesRef.current = true;
    (async () => {
      for (const o of l) await alerter("Opération pas passée sur le relevé", `${(compteDe(o.compteId) || {}).nom} — ${formatDate(o.date)} — ${o.designation} — ${formatDH(Number(o.montant))} : toujours pas sur le relevé après ${JOURS_ALERTE_NON_PASSEE} jours`, { kind: "onglet", id: "compta", ref: `nonpassee:${o.id}` });
      alertesNonPasseesRef.current = false;
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, operations, comptesTreso, alertes]);
  // Caisse générale : alerte à Nils (une fois) quand elle passe sous 5 000 DH.
  useEffect(() => {
    if (loading || !Array.isArray(operations) || !comptesTreso || !parametres || !caisseGeneraleActive()) return;
    const sous = soldeCompteAu(CAISSE_GENERALE_ID) < SEUIL_CAISSE_GENERALE;
    if (sous === !!parametres.cgSousSeuil) return;
    (async () => {
      await persistParametres({ ...parametres, cgSousSeuil: sous });
      if (sous) await alerter("Caisse générale sous 5 000 DH", `Solde : ${formatDH(soldeCompteAu(CAISSE_GENERALE_ID))} — à alimenter (retrait d'espèces CFG pour la caisse générale).`, { kind: "onglet", id: "compta" });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, operations, comptesTreso, parametres]);
  // Nils 01/10 : alerte à Nils (une fois par compte et par mois) quand une clôture est en retard (> 7 j).
  const alertesClotRef = useRef(false);
  useEffect(() => {
    if (loading || !Array.isArray(comptesTreso) || alertesClotRef.current) return;
    const cibles = [];
    comptesTreso.forEach((c) => moisACloturer(c).forEach((m) => {
      const cl = clotureDe(c.id, m);
      if (ecartJours(todayISO(), finDeMois(m)) > JOURS_ALERTE_CLOTURE && (!cl || cl.statut !== "validée") && !(c.alertesCloture || []).includes(m)) cibles.push({ c, m, cl });
    }));
    if (!cibles.length) return;
    alertesClotRef.current = true;
    (async () => {
      for (const { c, m, cl } of cibles) await alerter("Clôture mensuelle en retard", `${c.nom} — ${libMois(m)} : ${cl ? `clôture ${cl.statut}` : "pas encore demandée"} plus de ${JOURS_ALERTE_CLOTURE} jours après la fin du mois`, { kind: "onglet", id: "compta" });
      await persistComptesTreso((comptesTreso || []).map((c) => { const ms = cibles.filter((x) => x.c.id === c.id).map((x) => x.m); return ms.length ? { ...c, alertesCloture: [...(c.alertesCloture || []), ...ms] } : c; }));
      alertesClotRef.current = false;
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, comptesTreso, operations]);
  // Nils 01/10 : alerte (une fois par date) quand la date de pose prévue d'une réservation est dépassée.
  const alertesResaRef = useRef(false);
  useEffect(() => {
    if (loading || !Array.isArray(commandesListe) || !Array.isArray(reservations) || alertesResaRef.current) return;
    const cibles = dossiersReservationDepassee().filter((c) => c.alerteReservationPour !== c.reservationPourLe);
    if (!cibles.length) return;
    alertesResaRef.current = true;
    (async () => {
      for (const c of cibles) await alerter("Réservation dépassée", `${c.numero}${c.reference ? ` — ${c.reference}` : ""} (${(clientDe(c.clientId) || {}).nom || "client ?"}) : matière réservée pour le ${formatDate(c.reservationPourLe)} — poser, reporter ou lever la réservation`, { kind: "commande", id: c.id });
      const ids = new Set(cibles.map((c) => c.id));
      await persistCommandes((commandesListe || []).map((c) => (ids.has(c.id) ? { ...c, alerteReservationPour: c.reservationPourLe } : c)));
      alertesResaRef.current = false;
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, commandesListe, reservations]);
  async function enregistrerSeuilUsure() {
    if (!peut("stock.parametrer")) return;
    const v = Number(String(seuilUsureSaisi).replace(",", "."));
    if (!isFinite(v) || v < 0) {
      setNotice("Indique un pourcentage valide (0 ou plus).");
      return;
    }
    const avant = seuilUsureAnormalePct();
    await persistParametres({ ...(parametres || {}), seuilUsureAnormalePct: v });
    await tracerAcces("réglage seuil usure anormale", `${avant} % → ${v} %`);
    setSeuilUsureSaisi("");
    setNotice(`Seuil d'usure anormale réglé à ${v} % de la durée moyenne.`);
  }

  async function persistCampagnesInventaire(next) {
    setCampagnesInventaire(next);
    try {
      await ecrireStockage(CAMPAGNES_INVENTAIRE_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde des campagnes d'inventaire", e);
      return false;
    }
  }
  // ---- ERP step 11 : inventaire ----
  const campagneOuverte = (campagnesInventaire || []).find((c) => c.statut === "ouverte") || null;
  // Pendant une campagne ouverte, tout mouvement de stock est bloqué (accord Nils).
  function bloqueParInventaire() {
    if (!campagneOuverte) return false;
    setNotice(`⚠ Inventaire en cours (ouvert le ${formatDateHeure(campagneOuverte.ouverteLe)} par ${campagneOuverte.ouvertePar}) : aucun mouvement de stock possible tant que le Gérant ne l'a pas validé ou annulé.`);
    return true;
  }
  const peutSaisirComptage = peut("stock.inventaireCompter");
  function lotsInventaire() {
    // « Tout ce qui est en stock » : lots avec un stock réel > 0, plus ceux
    // déjà comptés dans la campagne ouverte.
    const comptes = (campagneOuverte && campagneOuverte.lignes) || {};
    return (items || [])
      .filter((it) => (Number(it.stockReel) || 0) > 0 || comptes[it.id])
      .sort((a, b) => {
        const pa = produitDe(a.produitId) || {};
        const pb = produitDe(b.produitId) || {};
        return (pa.categorie || "").localeCompare(pb.categorie || "", "fr") || (pa.nom || "").localeCompare(pb.nom || "", "fr");
      });
  }
  async function lancerCampagneInventaire() {
    if (!peut("stock.inventaireLancer") || campagneOuverte) return;
    const c = { id: uid(), statut: "ouverte", perimetre: "Tout le stock", ouverteLe: new Date().toISOString(), ouvertePar: user.nom, lignes: {} };
    await persistCampagnesInventaire([...(campagnesInventaire || []), c]);
    await tracerAcces("inventaire lancé", "Campagne d'inventaire ouverte — mouvements de stock bloqués");
    setComptagesSaisis({});
    setNotice("Campagne d'inventaire ouverte : les mouvements de stock sont bloqués jusqu'à sa validation.");
  }
  async function enregistrerComptages() {
    if (!campagneOuverte || !peutSaisirComptage) return;
    const lignes = { ...(campagneOuverte.lignes || {}) };
    let n = 0;
    for (const [lotId, val] of Object.entries(comptagesSaisis)) {
      if (val === "" || val === undefined) continue;
      const q = Number(String(val).replace(",", "."));
      if (!isFinite(q) || q < 0) {
        setNotice("Une quantité comptée n'est pas valide (nombre positif attendu).");
        return;
      }
      const lot = (items || []).find((it) => it.id === lotId);
      lignes[lotId] = { compte: q, stockAuComptage: lot ? Number(lot.stockReel) || 0 : 0, saisiPar: user.nom, saisiLe: new Date().toISOString() };
      n++;
    }
    if (n === 0) {
      setNotice("Aucune quantité saisie.");
      return;
    }
    await persistCampagnesInventaire((campagnesInventaire || []).map((c) => (c.id === campagneOuverte.id ? { ...c, lignes } : c)));
    setComptagesSaisis({});
    setNotice(`${n} comptage(s) enregistré(s).`);
  }
  // ERP step 11 (demande Nils du 29/09) : familles d'inventaire et droits de
  // voir / saisir les prix d'achat — consommables et accessoires : Nils, Ahmed,
  // Wissam ; éviers et tranches : Nils seul.
  function familleInventaire(categorie) {
    if (!categorie) return "Autres";
    if (MATIERES.includes(categorie)) return "Tranches";
    if (categorie === "Éviers") return "Éviers";
    if (categorie === "Accessoires") return "Accessoires";
    if (estCategorieConsommable(categorie)) return "Consommables";
    return "Autres";
  }
  function peutVoirPrixFamille(famille) {
    if (famille === "Consommables" || famille === "Accessoires") return peutVoirPrixConso;
    if (famille === "Éviers" || famille === "Tranches") return peut("stock.prixTranches");
    return false;
  }
  function peutVoirPrixCategorie(categorie) {
    return peutVoirPrixFamille(familleInventaire(categorie));
  }
  function valeurLotHT(lot, quantite) {
    const p = produitDe(lot.produitId) || lot.produitSnapshot;
    if (!p || !peutVoirPrixCategorie(p.categorie)) return null;
    if (lot.prixAchatHT === undefined || lot.prixAchatHT === null || lot.prixAchatHT === "") return null;
    return Number(lot.prixAchatHT) * quantite;
  }
  async function validerCampagneInventaire() {
    if (!peut("stock.inventaireLancer") || !campagneOuverte || !validationInventaire) return;
    const lignes = campagneOuverte.lignes || {};
    const horodatage = new Date().toISOString();
    const dateCampagne = formatDate(campagneOuverte.ouverteLe.slice(0, 10));
    let nextItems = [...(items || [])];
    const nouveauxMvts = [];
    const appliques = [];
    let ecartValeur = 0;
    Object.entries(lignes).forEach(([lotId, l]) => {
      if (!validationInventaire.retenus[lotId]) return;
      const lot = nextItems.find((it) => it.id === lotId);
      if (!lot) return;
      const ecart = Number((l.compte - (Number(l.stockAuComptage) || 0)).toFixed(2));
      if (ecart === 0) return;
      const nouveau = Number(((Number(lot.stockReel) || 0) + ecart).toFixed(2));
      nextItems = nextItems.map((it) => (it.id === lotId ? { ...it, stockReel: Math.max(0, nouveau) } : it));
      nouveauxMvts.push({
        id: uid(),
        itemId: lotId,
        type: ecart > 0 ? "entree" : "sortie",
        quantite: Math.abs(ecart),
        unite: lot.unite,
        doc: "",
        date: todayISO(),
        note: `Inventaire du ${dateCampagne} (${l.stockAuComptage} → ${l.compte} ${lot.unite}) — validé par ${user.nom}`,
        pl: "",
        inventaire: campagneOuverte.id,
        creeLe: horodatage,
      });
      const v = valeurLotHT(lot, ecart);
      if (v !== null) ecartValeur += v;
      appliques.push(`${libelleLot({ ...lot, stockReel: l.compte })} : ${ecart > 0 ? "+" : ""}${ecart}`);
    });
    if (nouveauxMvts.length > 0) {
      await persist(nextItems);
      await persistMouvements([...(mouvements || []), ...nouveauxMvts]);
    }
    const nbComptes = Object.keys(lignes).length;
    const cloturee = {
      ...campagneOuverte,
      statut: "cloturee",
      clotureeLe: horodatage,
      clotureePar: user.nom,
      nbComptes,
      nbAjustements: nouveauxMvts.length,
      ecartValeurHT: Number(ecartValeur.toFixed(2)),
      lotsRetenus: Object.keys(validationInventaire.retenus).filter((k) => validationInventaire.retenus[k]),
    };
    await persistCampagnesInventaire((campagnesInventaire || []).map((c) => (c.id === campagneOuverte.id ? cloturee : c)));
    if (nouveauxMvts.length > 0) {
      await alerter("Mouvement d'inventaire", `Inventaire du ${dateCampagne} : ${nouveauxMvts.length} ajustement(s)${peutVoirPrixConso ? `, écart valorisé ${ecartValeur >= 0 ? "+" : ""}${formatDH(ecartValeur)} HT` : ""} — ${appliques.slice(0, 6).join(" ; ")}${appliques.length > 6 ? " ; …" : ""}`, { kind: "onglet", id: "stock" });
    }
    await tracerAcces("inventaire validé", `Campagne du ${dateCampagne} : ${nbComptes} lot(s) comptés, ${nouveauxMvts.length} ajustement(s)`);
    setValidationInventaire(null);
    setNotice(`Inventaire clôturé : ${nouveauxMvts.length} ajustement(s) appliqué(s). Les mouvements de stock sont de nouveau possibles.`);
  }
  async function annulerCampagneInventaire() {
    if (!peut("stock.inventaireLancer") || !campagneOuverte) return;
    await persistCampagnesInventaire((campagnesInventaire || []).map((c) => (c.id === campagneOuverte.id ? { ...c, statut: "annulee", annuleeLe: new Date().toISOString(), annuleePar: user.nom } : c)));
    await tracerAcces("inventaire annulé", "Campagne d'inventaire annulée sans ajustement");
    setValidationInventaire(null);
    setComptagesSaisis({});
    setNotice("Campagne d'inventaire annulée — aucun ajustement, mouvements de nouveau possibles.");
  }
  function imprimerFicheComptage() {
    const e = (x) => String(x ?? "").replace(/[&<>]/g, (ch) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[ch]));
    const lignes = lotsInventaire().map((it) => {
      const p = produitDe(it.produitId) || {};
      return `<tr><td>${e(p.categorie || "")}</td><td>${e(p.nom || "")}</td><td>${e([it.type === TYPE_CHUTE ? "chute" : "", it.dimensions, it.epaisseur, it.nuance ? "n" + it.nuance : "", it.choix, it.fournisseur, it.blFournisseur ? "BL " + it.blFournisseur : ""].filter(Boolean).join(" · "))}</td><td>${e(it.unite)}</td><td style="width:90px"></td></tr>`;
    }).join("");
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>Fiche de comptage</title>
<style>body{font-family:'DM Sans',Arial,sans-serif;color:#281E1E;margin:24px;font-size:11px}h1{font-family:'Cormorant Garamond',Georgia,serif;font-size:22px;margin:0 0 4px}
table{width:100%;border-collapse:collapse;margin-top:12px}th,td{border:1px solid #8C8282;padding:5px 7px;text-align:left}th{font-size:10px;text-transform:uppercase;color:#8C8282;font-weight:600}
.meta{color:#8C8282;font-size:11px}</style></head><body>
<h1>Fiche de comptage — inventaire</h1><div class="meta">Campagne ouverte le ${e(campagneOuverte ? formatDateHeure(campagneOuverte.ouverteLe) : "")} — compté par : ____________________ — le : ____________</div>
<table><thead><tr><th>Catégorie</th><th>Produit / sous-catégorie</th><th>Lot</th><th>Unité</th><th>Quantité comptée</th></tr></thead><tbody>${lignes}</tbody></table>
</body></html>`;
    telechargerDocument(html, `fiche-comptage-${todayISO()}`, "fiche de comptage");
  }
  const ORDRE_FAMILLES = ["Consommables", "Accessoires", "Éviers", "Tranches"];
  // ERP step 11 (demande Nils du 29/09) : stock d'un lot à une date passée,
  // reconstitué en annulant les mouvements datés après cette date (fin de
  // journée incluse). Date d'un mouvement = sa date métier, sinon sa création.
  function stockAuDate(lot, dateISO) {
    const actuel = Number(lot.stockReel) || 0;
    if (!dateISO || dateISO >= todayISO()) return actuel;
    let delta = 0;
    (mouvements || []).forEach((m) => {
      if (m.itemId !== lot.id) return;
      const d = (m.date || (m.creeLe || "").slice(0, 10) || "").slice(0, 10);
      if (!d || d <= dateISO) return;
      const q = Number(m.quantite) || 0;
      if (m.type === "entree") delta -= q;
      else if (m.type === "sortie") delta += q;
    });
    return Number((actuel + delta).toFixed(2));
  }
  function lignesInventaireValorise(dateISO) {
    // Lots actifs + lots archivés (supprimés depuis) : un lot archivé a 0 en
    // stock aujourd'hui, il ne réapparaît que pour une date passée.
    return [...(items || []), ...(lotsArchives || [])]
      .map((it) => ({ it, qte: stockAuDate(it, dateISO) }))
      .filter(({ qte }) => qte > 0)
      .map(({ it, qte }) => { const p = produitDe(it.produitId) || it.produitSnapshot || {}; return { it, qte, p, famille: familleInventaire(p.categorie) }; })
      .filter(({ famille }) => ORDRE_FAMILLES.includes(famille) && peutVoirPrixFamille(famille))
      .map((l) => ({ ...l, valeur: valeurLotHT(l.it, l.qte), m2: l.famille === "Tranches" && l.it.type !== TYPE_CHUTE ? (surfaceM2(l.it.dimensions) || 0) * l.qte : null }))
      .sort((a, b) => ORDRE_FAMILLES.indexOf(a.famille) - ORDRE_FAMILLES.indexOf(b.famille) || (a.p.categorie || "").localeCompare(b.p.categorie || "", "fr") || (a.p.nom || "").localeCompare(b.p.nom || "", "fr"));
  }
  async function exporterInventaireValoriseCSV() {
    const lignes = lignesInventaireValorise(inventaireDate);
    const q = (x) => `"${String(x ?? "").replace(/"/g, '""')}"`;
    const num = (n) => (n === null || n === undefined ? "" : String(Number(n).toFixed(2)).replace(".", ","));
    const rows = [["Famille", "Catégorie", "Produit / sous-catégorie", "Fournisseur", "BL fournisseur", "Quantité", "Unité", "m²", "Prix d'achat HT", "Valeur HT"].map(q).join(";")];
    lignes.forEach(({ it, qte, p, famille, valeur, m2 }) => {
      rows.push([q(famille), q(p.categorie), q(p.nom), q(it.fournisseur), q(it.blFournisseur), num(qte), q(it.unite), m2 === null ? "" : num(m2), num(it.prixAchatHT), valeur === null ? q("non valorisé") : num(valeur)].join(";"));
    });
    const total = lignes.reduce((s2, l) => s2 + (l.valeur || 0), 0);
    rows.push(["", "", "", "", "", "", "", "", q("TOTAL"), num(total)].join(";"));
    const dateInv = inventaireDate && inventaireDate < todayISO() ? inventaireDate : todayISO();
    rows.unshift(q(`Inventaire valorisé au ${formatDate(dateInv)}`));
    const ok = await proposerTelechargement(`inventaire-valorise-au-${dateInv}.csv`, "\ufeff" + rows.join("\r\n"));
    if (ok) setNotice("Inventaire valorisé exporté (CSV, séparateur « ; » pour Excel).");
  }

  async function persistParametres(next) {
    setParametres(next);
    try {
      await ecrireStockage(PARAMETRES_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde des paramètres", e);
      return false;
    }
  }
  function seuilEcartPrixPct() {
    const v = parametres && parametres.seuilEcartPrixPct;
    return v !== undefined && v !== null && v !== "" && isFinite(Number(v)) ? Number(v) : SEUIL_ECART_PRIX_PCT;
  }
  async function enregistrerSeuilPrix() {
    if (!peut("stock.parametrer")) return;
    const v = Number(String(seuilPrixSaisi).replace(",", "."));
    if (!isFinite(v) || v < 0) {
      setNotice("Indique un pourcentage valide (0 ou plus).");
      return;
    }
    const avant = seuilEcartPrixPct();
    await persistParametres({ ...(parametres || {}), seuilEcartPrixPct: v });
    await tracerAcces("réglage seuil alerte prix", `${avant} % → ${v} %`);
    setSeuilPrixSaisi("");
    setNotice(`Seuil d'alerte prix d'achat réglé à ${v} %.`);
  }

  async function persistAlertes(next) {
    alertesRef.current = next;
    setAlertes(next);
    try {
      await ecrireStockage(ALERTES_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde des alertes", e);
      return false;
    }
  }
  // Enregistre une alerte pour Nils. `lien` = { kind: "commande"|"devis"|"client"|"article"|"produit"|"onglet", id }.
  async function alerter(type, message, lien) {
    const entree = { id: uid(), type, message, lien: lien || null, par: user.nom, le: new Date().toISOString(), vu: false };
    await persistAlertes([...(alertesRef.current || []), entree]);
  }

  async function persistJournalAcces(next) {
    journalRef.current = next;
    setJournalAcces(next);
    try {
      await ecrireStockage(JOURNAL_ACCES_KEY, JSON.stringify(next), true);
      return true;
    } catch (e) {
      console.error("Erreur de sauvegarde du journal d'accès", e);
      return false;
    }
  }

  // Réservation totale active d'une référence = somme des réservations actives
  // Réservations dont la date de livraison est passée : candidates à la levée
  function reservationsDepassees(itemId) {
    return (reservations || []).filter(
      (r) => r.itemId === itemId && r.statut === "active" && livraisonDepassee(r.livraison)
    ).length;
  }

  function reservedFor(itemId) {
    return (reservations || [])
      .filter((r) => r.itemId === itemId && r.statut === "active")
      .reduce((sum, r) => sum + (Number(r.quantite) || 0), 0);
  }
  // Réservations qui portent sur le produit mais n'ont pas encore de lot
  // précis — en attente d'affectation depuis le Stock.
  function reservationsNonAffectees(produitId) {
    return (reservations || []).filter((r) => r.produitId === produitId && r.statut === "active" && !r.itemId);
  }
  function ouvrirAffectationReservations(produit) {
    setAffectationProduit(produit);
    setAffectationChoix({});
    setShowAffectation(true);
  }
  async function validerAffectationReservations() {
    const choix = Object.entries(affectationChoix).filter(([, lotId]) => lotId);
    if (choix.length === 0) {
      setShowAffectation(false);
      return;
    }
    const maj = new Map(choix);
    {
      const err = erreurNuanceBookMatch((reservations || []).map((r) => (maj.has(r.id) ? { ...r, itemId: maj.get(r.id) } : r)));
      if (err) { setNotice(err); return; }
    }
    await persistReservations(
      (reservations || []).map((r) => {
        if (!maj.has(r.id)) return r;
        const lotId = maj.get(r.id);
        // Le lot choisi peut appartenir à un autre produit de la même
        // famille couleur (substitution épaisseur/choix) — la réservation
        // doit alors pointer vers ce produit-là, pas rester sur l'ancien.
        const lot = (items || []).find((it) => it.id === lotId);
        const produitReel = lot ? lot.produitId : r.produitId;
        return { ...r, itemId: lotId, produitId: produitReel, modifiePar: user.nom, modifieLe: new Date().toISOString() };
      })
    );
    setShowAffectation(false);
    setAffectationProduit(null);
    setAffectationChoix({});
    setNotice(`${choix.length} réservation(s) affectée(s) à un lot.`);
  }

  function openReservation(item) {
    setReservationItem(item);
    setResEditingId(null);
    setResBc(pendingReservationPrefill ? pendingReservationPrefill.bc : "");
    setResClientId(pendingReservationPrefill ? pendingReservationPrefill.clientId : "");
    setResContact("");
    setResQty("");
    setResNote("");
    setResLivraison("");
    setResError("");
    setShowReservation(true);
    if (pendingReservationPrefill) setPendingReservationPrefill(null);
  }

  function openResEdit(r) {
    setResEditingId(r.id);
    setResBc(r.bc || "");
    setResClientId(r.clientId || "");
    setResContact(r.contact || "");
    setResQty(String(r.quantite || ""));
    setResNote(r.note || "");
    setResLivraison(r.livraison || "");
    setResNouveauLotId(r.itemId || "");
    setResError("");
  }

  function resetResForm() {
    setResEditingId(null);
    setResBc("");
    setResClientId("");
    setResContact("");
    setResQty("");
    setResNote("");
    setResLivraison("");
    setResNouveauLotId("");
    setResError("");
  }

  async function addReservation() {
    // La création se fait désormais uniquement depuis un dossier
    // (Commandes) — ici, on ne fait que modifier une réservation
    // existante, y compris la déplacer vers un autre lot du même produit.
    if (!resEditingId) return;
    const qty = Number(resQty);
    if (!resBc.trim()) {
      setResError("Indique le n° de BC.");
      return;
    }
    if (!resClientId) {
      setResError("Choisis le client.");
      return;
    }
    if (!qty || qty <= 0) {
      setResError("Indique une quantité valide.");
      return;
    }
    try {
      const champs = {
        bc: resBc.trim(),
        clientId: resClientId,
        client: clientDe(resClientId)?.nom || "",
        contact: resContact,
        quantite: qty,
        note: resNote.trim(),
        livraison: resLivraison || "",
        modifiePar: user.nom,
        modifieLe: new Date().toISOString(),
      };
      // Modification : on conserve date de création, auteur et statut d'origine.
      // Le lot choisi peut appartenir à un autre produit de la même famille
      // couleur (substitution épaisseur/choix) — la réservation doit alors
      // suivre ce produit-là.
      const nouveauLot = resNouveauLotId ? (items || []).find((it) => it.id === resNouveauLotId) : null;
      {
        const rAvant = (reservations || []).find((r) => r.id === resEditingId);
        if (rAvant && rAvant.bm && nouveauLot && nouveauLot.bm !== rAvant.bm) { setResError(`Cette réservation est la part ${rAvant.bm} d'un book-match : choisis un lot ${rAvant.bm}.`); return; }
        if (rAvant && rAvant.chute && nouveauLot && (nouveauLot.type !== TYPE_CHUTE || nouveauLot.produitId !== rAvant.produitId)) { setResError("Cette réservation est une chute vendue : choisis un lot « chute » du même produit."); return; }
        const err = erreurNuanceBookMatch((reservations || []).map((r) => (r.id === resEditingId ? { ...r, itemId: resNouveauLotId || r.itemId } : r)));
        if (err) { setResError(err); return; }
      }
      await persistReservations(
        (reservations || []).map((r) =>
          r.id === resEditingId
            ? {
                ...r,
                ...champs,
                itemId: resNouveauLotId || r.itemId,
                produitId: nouveauLot ? nouveauLot.produitId : r.produitId,
              }
            : r
        )
      );
      resetResForm();
    } catch (err) {
      console.error("Erreur réservation", err);
      setResError("Impossible d'enregistrer la réservation. Réessaie.");
    }
  }

  // Deux façons de clore une réservation. ERP step 8 (accord du 21/09) :
  // le crédit du registre des tranches exonérables n'est plus lié à la
  // réservation — il est déduit à la transformation en BDC et vit sur le
  // dossier (commande.creditsConsommes, voir creerCommandeDepuisDevis /
  // sauvegarderCommandeEnCours), qu'il y ait ou non une réservation. Lever
  // une réservation, avec ou sans production, ne touche donc plus jamais au
  // registre.
  async function leverReservationProduction(reservationId) {
    await persistReservations(
      (reservations || []).map((r) =>
        r.id === reservationId
          ? { ...r, statut: "levee", motifLevee: "production", leveeLe: new Date().toISOString(), leveePar: user.nom, modifiePar: user.nom, modifieLe: new Date().toISOString() }
          : r
      )
    );
  }
  async function annulerReservation(reservationId) {
    await persistReservations(
      (reservations || []).map((x) =>
        x.id === reservationId
          ? { ...x, statut: "levee", motifLevee: "annulee", leveeLe: new Date().toISOString(), leveePar: user.nom, modifiePar: user.nom, modifieLe: new Date().toISOString() }
          : x
      )
    );
  }

  // ---- Produits ----
  function produitDe(id) {
    return (produits || []).find((p) => p.id === id) || null;
  }
  function nomProduit(id) {
    const p = produitDe(id);
    return p ? p.nom : "—";
  }
  // Nom du produit chez ce fournisseur (Easy Grey -> « City » chez Guidoni)
  function nomChezFournisseur(produitId, fournisseur) {
    const p = produitDe(produitId);
    if (!p) return "";
    const c = (p.correspondances || []).find((c) => c.fournisseur === fournisseur);
    return c ? c.nomFournisseur : "";
  }
  function lotsDuProduit(produitId) {
    return (items || []).filter((it) => it.produitId === produitId);
  }

  // ---- Famille couleur (accord du 19/09 avec Nils) ----
  // Deux articles Tranche appartiennent à la même famille quand ils partagent
  // le même fournisseur, le même code fournisseur (ex. NU08) et la même
  // finition — l'épaisseur, le choix et la dimension sont libres au sein
  // d'une famille. Le code fournisseur et la finition n'existent qu'au
  // niveau du Catalogue, jamais sur le produit Stock ni sur le lot : pour
  // remonter à la famille d'un produit ou d'un lot, il faut donc repartir de
  // l'article Catalogue qui l'a créé.
  function articleDuProduit(produitId) {
    if (!produitId) return null;
    return (articles || []).find((a) => a.produitStockId === produitId) || null;
  }
  // ---------- ERP step 14 (ai) : coûts de revient — Nils seul ----------
  // ---- Nils 08/10 : registre transport international ----
  function paysIncotermFournisseur(nom) {
    const f = fournisseurParNom(nom);
    return { pays: (f && f.pays) || "", incoterm: (f && f.incoterm) || "" };
  }
  // Nils 10/10 (d) : postes détaillés d'un conteneur (HT). Anciennes lignes : dedouanement global.
  // Dédouanement = honoraires transitaire + surestaries + autres frais transitaire + droits + autres taxes ; TVA import hors coût.
  const POSTES_LOGI = ["transport", "dedouanement", "transportLocal", "dechargement"];
  function postesLigneTransport(l) {
    const detaille = ["transitaireTotal", "droits", "autresTaxes", "surestaries", "transportLocal", "autresTransitaire"].some((k) => String(l[k] ?? "").trim() !== "");
    const vide = (k) => String(l[k] ?? "").trim() === "";
    const honoraires = detaille ? nombreOuZero(l.transitaireTotal) - nombreOuZero(l.transportLocal) - nombreOuZero(l.surestaries) - nombreOuZero(l.autresTransitaire) : 0;
    const dedouanement = detaille ? (vide("transitaireTotal") && vide("droits") && vide("autresTaxes") ? "" : honoraires + nombreOuZero(l.surestaries) + nombreOuZero(l.autresTransitaire) + nombreOuZero(l.droits) + nombreOuZero(l.autresTaxes)) : l.dedouanement;
    return { transport: l.transport, dedouanement, transportLocal: detaille ? l.transportLocal : "", dechargement: l.dechargement, honoraires: detaille ? honoraires : null };
  }
  function moyenneTransport(taille, pays, incoterm, au) {
    if (!pays || !incoterm) return null;
    const fin = au || todayISO(), deb = decalerJours(fin, -365);
    const l = ((transportIntl && transportIntl.lignes) || []).filter((x) => Number(x.taille) === Number(taille) && normLib(x.pays) === normLib(pays) && x.incoterm === incoterm && x.date >= deb && x.date <= fin).map(postesLigneTransport).filter((x) => POSTES_LOGI.some((k) => x[k] !== "" && x[k] !== null && x[k] !== undefined));
    if (!l.length) return null;
    const moy = (k) => {
      const v = l.map((x) => x[k]).filter((v) => v !== "" && v !== null && v !== undefined && isFinite(Number(v))).map(Number);
      return v.length ? v.reduce((a, b) => a + b, 0) / v.length : null;
    };
    return { n: l.length, transport: moy("transport"), dedouanement: moy("dedouanement"), transportLocal: moy("transportLocal"), dechargement: moy("dechargement") };
  }
  // Profil d'import avec la logistique conteneur remplacée par la moyenne du registre (quand il y en a une).
  function profilEffectif(p) {
    if (!p || p.type !== "tranches") return p;
    const { pays, incoterm } = paysIncotermFournisseur(p.fournisseur);
    const lg = { ...(p.logistique || {}) };
    [20, 40].forEach((t) => {
      const m = moyenneTransport(t, pays, incoterm);
      if (!m) return;
      const base = { ...(lg[t] || {}) };
      POSTES_LOGI.forEach((k) => { if (m[k] !== null) base[k] = Math.round(m[k]); });
      lg[t] = base;
    });
    return { ...p, logistique: lg };
  }
  function coutTrancheProfil(p, ...args) {
    return coutStandardTrancheProfil(profilEffectif(p), ...args);
  }
  function paiementsTransitaireARattacher() {
    const ti = transportIntl || TRANSPORT_INTL_VIDE;
    const lies = new Set((ti.lignes || []).flatMap((l) => l.operationIds || []));
    const ign = new Set(ti.ignores || []);
    return (operations || []).filter((o) => o.compteId === "banque-cfg" && o.sens === "sortie" && o.sousPoste === SOUS_POSTE_TRANSITAIRE && !o.miroirDe && o.type !== "transfert" && String(o.date || "") >= DEBUT_REGISTRE_TRANSPORT && !lies.has(o.id) && !ign.has(o.id))
      .sort((a, b) => (a.date < b.date ? -1 : 1));
  }
  function profilsRevient() {
    return (coutsRevient && coutsRevient.profils) || [];
  }
  function profilTranchesPour(fournisseur, matiere) {
    return profilsRevient().find((p) => p.type === "tranches" && p.fournisseur && normLib(p.fournisseur) === normLib(fournisseur) && p.matiere === matiere) || null;
  }
  function profilUnitairePour(fournisseur) {
    return profilsRevient().find((p) => p.type === "unitaire" && p.fournisseur && normLib(p.fournisseur) === normLib(fournisseur)) || null;
  }
  function articleImporte(a) {
    return !!a && a.provenance === "Importé";
  }
  // Détail du coût standard pour un article (et l'épaisseur / le choix / le fournisseur d'un lot).
  function coutStandardDetail(article, lot) {
    if (!article || !articleImporte(article)) return null;
    const l = lot || {};
    if (article.categorie === "Tranche") {
      const profil = profilTranchesPour(article.fournisseur, article.matiere);
      if (!profil || article.groupeFournisseur === undefined || article.groupeFournisseur === null || article.groupeFournisseur === "") return null;
      const c = coutTrancheProfil(profil, Number(article.groupeFournisseur), l.epaisseur || article.epaisseurMatiere, choixNum(l.choix || article.choix));
      return c ? { ...c, profil, unitaire: false } : null;
    }
    const profil = profilUnitairePour(l.fournisseur || article.fournisseur);
    if (!profil) return null;
    const prix = nombreOuZero((profil.prixArticles || {})[article.id]);
    if (!(prix > 0)) return null;
    const achat = versMAD(prix, profil.devise, profil.taux);
    // Nils 05/10 (f1) : coût d'import par pièce saisi en MAD (plus de pourcentage).
    const importPiece = nombreOuZero((profil.importArticles || {})[article.id]);
    return { achat, achatDevise: prix, approche: importPiece, total: achat + importPiece, profil, unitaire: true };
  }
  function coutStandardLot(lot) {
    const d = coutStandardDetail(articleDuProduit(lot && lot.produitId), lot);
    return d ? Math.round(d.total * 100) / 100 : null;
  }
  // Coût de revient unitaire d'un lot (HT) : prix du lot (réel après arrivage,
  // sinon pré-rempli au standard) + transport d'approche réparti (achat local) ;
  // à défaut de prix, le coût standard.
  function coutRevientUnitaireLot(lot) {
    if (!lot) return null;
    const p = lot.prixAchatHT === undefined || lot.prixAchatHT === null || lot.prixAchatHT === "" ? null : Number(lot.prixAchatHT);
    const base = p !== null && isFinite(p) ? p : coutStandardLot(lot);
    if (base === null) return null;
    const tr = nombreOuZero(lot.transportApprocheHT), q = nombreOuZero(lot.qteBase);
    return base + (tr > 0 && q > 0 ? tr / q : 0);
  }
  // Nils 05/10 (e) : un arrivage = un fournisseur, saisi ligne par ligne (article, qté, tonalité,
  // A/B prévus, remise extra de la ligne) ; chaque ligne crée son lot « en arrivage ».
  // Répartition : facture nette (avoirs déduits) au prorata de la valeur grille × (1 − remise de la
  // ligne) ; frais au prorata de la place sur chevalet (tranches) / de la valeur (éviers, accessoires).
  // Nils 09/10 : logistique d'un arrivage import. À la saisie, on ne connaît pas encore les frais :
  // estimation = moyenne du registre transport international (pays + incoterm du fournisseur, taille
  // choisie) × nombre de conteneurs, à défaut la valeur de départ du profil d'import. Dès qu'une ligne du
  // registre est rattachée à l'arrivage, ce sont les frais réels. Anciens arrivages : frais saisis à la main.
  function logistiqueArrivage(arr) {
    const reelles = arr && arr.id ? ((transportIntl && transportIntl.lignes) || []).filter((l) => l.arrivageId === arr.id) : [];
    const somme = (o) => nombreOuZero(o.transport) + nombreOuZero(o.dedouanement) + nombreOuZero(o.transportLocal) + nombreOuZero(o.dechargement);
    if (reelles.length) return { source: "reel", montant: reelles.reduce((n, l) => n + somme(postesLigneTransport(l)), 0), lib: `frais réels du registre transport international (${reelles.length} conteneur(s))` };
    const taille = Number(arr && arr.conteneur);
    if (taille === 20 || taille === 40) {
      const nbC = Math.max(1, nombreOuZero(arr.nbConteneurs) || 1);
      const pi = paysIncotermFournisseur(arr.fournisseur);
      const m = moyenneTransport(taille, pi.pays, pi.incoterm);
      if (m) return { source: "moyenne", montant: somme(m) * nbC, lib: `moyenne de ${m.n} conteneur(s) ${taille}' sur 12 mois — ${pi.pays}, ${pi.incoterm}` };
      const pr = profilsRevient().find((p) => p.type === "tranches" && p.fournisseur && normLib(p.fournisseur) === normLib(arr.fournisseur) && (p.logistique || {})[taille]);
      if (pr) return { source: "depart", montant: somme(pr.logistique[taille]) * nbC, lib: `valeur de départ du profil « ${pr.nom || pr.fournisseur} »${!pi.pays || !pi.incoterm ? " (pays / incoterm manquants sur la fiche fournisseur)" : " (aucun conteneur dans le registre sur 12 mois)"}` };
      return { source: "aucun", montant: 0, lib: "aucune donnée : ni conteneur dans le registre, ni valeur de départ dans un profil d'import de ce fournisseur" };
    }
    const f = (arr && arr.frais) || {};
    const manuel = somme(f);
    return manuel > 0 ? { source: "manuel", montant: manuel, lib: "frais saisis à la main (ancien arrivage)" } : { source: "aucun", montant: 0, lib: "choisis la taille du conteneur" };
  }
  function calculArrivage(arr) {
    const taux = nombreOuZero(arr.taux) || 1;
    const avoirs = (arr.avoirs || []).reduce((n, a) => n + nombreOuZero(a.montantDevise), 0);
    const brutSaisi = nombreOuZero(arr.factureDevise);
    const f = arr.frais || {};
    const logi = logistiqueArrivage(arr);
    // Emballage : les chevalets sont désormais sur la facture fournisseur (ligne « Chevalets ») ; l'ancien champ reste compté s'il existe.
    const fraisMAD = logi.montant + nombreOuZero(f.emballage) + nombreOuZero(f.autres);
    const chev = arr.chevalets || {};
    let attenduDevise = nombreOuZero(chev.qte) * nombreOuZero(chev.prixDevise), attenduComplet = true;
    const lignes = (arr.lignes || []).filter((l) => l.articleId && nombreOuZero(l.qte) > 0).map((l) => {
      const art = (articles || []).find((a) => a.id === l.articleId) || null;
      const lot = l.lotId ? (items || []).find((it) => it.id === l.lotId) || null : null;
      const qte = nombreOuZero(l.qte);
      const r = Math.min(Math.max(nombreOuZero(l.remisePct), 0), 100) / 100;
      const pseudo = { epaisseur: art ? art.epaisseurMatiere : "", choix: art ? art.choix : "", fournisseur: arr.fournisseur };
      const det = coutStandardDetail(art, pseudo);
      if (det) attenduDevise += det.achatDevise * qte * (1 - r); else attenduComplet = false;
      let place, secours;
      if (art && art.categorie === "Tranche") {
        const profil = profilTranchesPour(art.fournisseur, art.matiere);
        const ep = art.epaisseurMatiere;
        const parChev = profil ? nombreOuZero((profil.tranchesParChevalet || {})[ep]) : 0;
        const surf = surfaceDimensions(art.dimension) || (profil ? nombreOuZero((profil.surfaces || {})[ep]) : 0) || 1;
        place = parChev > 0 ? qte / parChev : surf * qte;
        secours = surf * qte;
      } else {
        place = null;
        secours = qte;
      }
      return { ligne: l, art, lot, qte, r, valeur: det ? det.achat * qte * (1 - r) : 0, secours, place, standard: det ? det.total : null, standardNet: det ? det.total - det.achat * r : null };
    });
    const sansStandard = lignes.some((l) => l.standard === null);
    // Arrivage mixte (tranches + éviers / accessoires) : la place sur chevalet n'a pas de sens
    // pour tout le monde — les frais suivent alors la valeur pour toutes les lignes.
    const mixte = lignes.some((l) => l.place === null) && lignes.some((l) => l.place !== null);
    lignes.forEach((l) => {
      if (sansStandard) l.valeur = l.secours;
      if (l.place === null || mixte) l.place = l.valeur;
    });
    const sV = lignes.reduce((n, l) => n + l.valeur, 0), sP = lignes.reduce((n, l) => n + l.place, 0);
    // Nils 09/10 : facture brute facultative — vide, on répartit la facture attendue (grille, remises, chevalets).
    const attendu = attenduComplet && lignes.length ? attenduDevise : null;
    const factureEstimee = !(brutSaisi > 0) && attendu !== null;
    const brut = brutSaisi > 0 ? brutSaisi : attendu || 0;
    const netDevise = brut - avoirs;
    const factureMAD = versMAD(netDevise, arr.devise, taux);
    lignes.forEach((l) => {
      l.partFacture = sV > 0 ? (factureMAD * l.valeur) / sV : 0;
      l.partFrais = sP > 0 ? (fraisMAD * l.place) / sP : 0;
      l.coutUnitaire = l.qte > 0 ? (l.partFacture + l.partFrais) / l.qte : null;
      l.ecart = l.coutUnitaire !== null && l.standard !== null ? l.coutUnitaire - l.standard : null;
    });
    return { lignes, netDevise, factureMAD, fraisMAD, logi, total: factureMAD + fraisMAD, avoirs, sansStandard, mixte, attenduDevise: attendu, factureEstimee };
  }
  function statutArrivage(a) {
    const lots = (a.lignes || []).map((l) => (items || []).find((it) => it.id === l.lotId)).filter(Boolean);
    if (a.calculeLe) return { lib: `coûts appliqués le ${formatDate(a.calculeLe)}`, couleur: VERT_OK };
    if (lots.length && lots.every((it) => !(Number(it.arrivages) > 0))) return { lib: "reçu — coûts à appliquer", couleur: OCRE };
    return { lib: "en route", couleur: TAUPE };
  }
  // Renvoie null quand l'article n'a pas de quoi identifier une famille
  // fiable (fournisseur ou code fournisseur manquant) — l'article reste
  // alors isolé, comme avant cette évolution.
  // La famille couleur ne s'applique qu'au Grès Cérame — pour le Quartz,
  // chaque tranche reste isolée (accord du 20/09 avec Nils : substitution
  // par famille non pertinente pour le Quartz).
  function familleArticle(a) {
    if (!a) return null;
    if (modeMatiere(a.matiere) !== "famille") return null;
    const fournisseur = (a.fournisseur || "").trim().toLowerCase();
    const code = (a.codeFournisseur || "").trim().toLowerCase();
    if (!fournisseur || !code) return null;
    const finition = (a.finition || "").trim().toLowerCase();
    const matiere = (a.matiere || "").trim().toLowerCase();
    return `${matiere}|${fournisseur}|${code}|${finition}`;
  }
  function familleDuProduit(produitId) {
    return familleArticle(articleDuProduit(produitId));
  }
  // Tous les produits Stock de la même famille couleur qu'un produit donné
  // (lui-même inclus). Sans famille identifiable, ne renvoie que lui-même.
  function produitsDeLaFamille(produitId) {
    const famille = familleDuProduit(produitId);
    if (!famille) return (produits || []).filter((p) => p.id === produitId);
    return (produits || []).filter((p) => familleDuProduit(p.id) === famille);
  }
  // Tous les lots des produits de la même famille qu'un produit donné.
  function lotsDeLaFamille(produitId) {
    return produitsDeLaFamille(produitId).flatMap((p) => lotsDuProduit(p.id));
  }
  // ---- Nils 04/10 (o) : book-match (céramique) ----
  function produitBookMatch(produitId) {
    if (!produitId) return false;
    const ids = new Set((produitsDeLaFamille(produitId) || []).map((p) => p.id).concat([produitId]));
    return (articles || []).some((a) => a.bookmatch && a.produitStockId && ids.has(a.produitStockId));
  }
  // Nils 09/10 : book-match « A et B vendus séparément » (quantités connues à la commande) ou « aléatoire ».
  function bookMatchSepare(produitId) {
    if (!produitBookMatch(produitId)) return false;
    const ids = new Set((produitsDeLaFamille(produitId) || []).map((p) => p.id).concat([produitId]));
    return (articles || []).some((a) => a.bookmatch && a.bookmatchMode === "separe" && a.produitStockId && ids.has(a.produitStockId));
  }
  function pairesParNuance(produitId) {
    const parN = {};
    lotsDuProduit(produitId).filter((it) => it.type !== TYPE_CHUTE && it.bm).forEach((it) => {
      const k = it.nuance || "";
      parN[k] = parN[k] || { nuance: k, a: 0, b: 0 };
      if (it.bm === "A") parN[k].a += Number(it.stockReel) || 0; else parN[k].b += Number(it.stockReel) || 0;
    });
    return Object.values(parN).sort((x, y) => String(x.nuance).localeCompare(String(y.nuance)));
  }
  // Toutes les parts A / B affectées d'une même ligne book-match doivent avoir la même nuance.
  function erreurNuanceBookMatch(listeRes) {
    const groupes = {};
    (listeRes || []).filter((r) => r.statut === "active" && r.bmGroupe && r.itemId).forEach((r) => {
      const lot = (items || []).find((it) => it.id === r.itemId);
      if (!lot) return;
      if (r.bm && lot.bm !== r.bm) groupes[r.bmGroupe] = { ...(groupes[r.bmGroupe] || {}), erreurBM: `la part ${r.bm} est sur un lot ${lot.bm || "sans marquage"}` };
      (groupes[r.bmGroupe] = groupes[r.bmGroupe] || {}).nuances = [...new Set([...((groupes[r.bmGroupe] || {}).nuances || []), lot.nuance || ""])];
    });
    for (const [g, v] of Object.entries(groupes)) {
      if (v.erreurBM) return `Book-match ${g} : ${v.erreurBM}.`;
      if ((v.nuances || []).length > 1) return `Book-match ${g.split(":")[0]} : les tranches A et B doivent être de la même nuance (ici ${v.nuances.map((n) => n || "sans nuance").join(" et ")}).`;
    }
    return "";
  }
  // Un lot A (ou B) sans surplus dans sa nuance : le prendre hors book-match casse une paire.
  function casseUnePaire(lot) {
    if (!lot || !lot.bm) return false;
    const memes = lotsDeLaFamille(lot.produitId).filter((x) => x.type !== TYPE_CHUTE && (x.nuance || "") === (lot.nuance || ""));
    const dispo = (bm) => memes.filter((x) => x.bm === bm).reduce((n, x) => n + (Number(x.stockReel) || 0) - reservedFor(x.id), 0);
    return lot.bm === "A" ? dispo("A") <= dispo("B") : dispo("B") <= dispo("A");
  }

  // ---------- Registre des tranches exonérables (crédit par famille + épaisseur) ----------
  // ERP step 8 (accord du 21/09 avec Nils) : le Quartz entre lui aussi dans
  // le registre des crédits (et donc dans le calcul des écarts, qui partage
  // la même clé) — mais avec une clé différente de celle du Grès Cérame, qui
  // reste fournisseur + code fournisseur + finition (familleArticle
  // ci-dessus, réservée à la SUBSTITUTION réservation/PL, jamais étendue au
  // Quartz : familleArticle continue de renvoyer null pour le Quartz).
  // Pour le Quartz, on travaille avec la couleur fournisseur plutôt que le
  // code : fournisseur + couleur fournisseur. Le Quartz n'existant qu'en
  // 20mm (EPAISSEURS_PAR_MATIERE), la distinction famille/épaisseur du Grès
  // Cérame n'a ici aucun effet pratique — la clé crédit et le regroupement
  // écart se confondent naturellement.
  function clefCreditArticle(a) {
    if (!a) return null;
    if (!a.matiere) return null;
    if (modeMatiere(a.matiere) === "famille") return familleArticle(a);
    {
      const fournisseur = (a.fournisseur || "").trim().toLowerCase();
      const couleur = (a.couleurFournisseur || "").trim().toLowerCase().replace(/\s+/g, " ");
      if (!fournisseur || !couleur) return null;
      return `${a.matiere.trim().toLowerCase()}|${fournisseur}|${couleur}`;
    }
  }
  function clefCreditDuProduit(produitId) {
    return clefCreditArticle(articleDuProduit(produitId));
  }
  // Libellé lisible d'une famille (casse d'origine), à partir de n'importe
  // quel article qui y correspond — utilisé par comparerFactureEtConsomme
  // (plafond anti-sur-consommation uniquement depuis le Step 9).
  function libelleFamilleSeule(article) {
    if (!article) return "";
    if (article.matiere && modeMatiere(article.matiere) === "couleur") {
      return `${article.matiere} ${article.fournisseur || ""} ${article.couleurFournisseur || ""}`.replace(/\s+/g, " ").trim();
    }
    return `${article.matiere || ""} ${article.fournisseur || ""} ${article.codeFournisseur || ""}${article.finition ? " " + article.finition : ""}`.replace(/\s+/g, " ").trim();
  }
  // Contrairement à la substitution de réservation/PL (famille seule, toute
  // épaisseur et tout choix confondus, Grès Cérame seulement), le crédit
  // d'exonération distingue l'épaisseur — seul le choix reste indifférent.
  // Renvoie null si l'article n'est pas une Tranche ou n'a pas de clé/
  // épaisseur identifiable : dans ce cas il n'est jamais éligible au
  // registre.
  function familleEpaisseurDeArticle(a) {
    if (!a || a.categorie !== "Tranche") return null;
    const famille = clefCreditArticle(a);
    if (!famille) return null;
    const epaisseur = (a.epaisseurMatiere || "").trim().toLowerCase();
    if (!epaisseur) return null;
    return { famille, epaisseur, cle: `${famille}||${epaisseur}` };
  }
  // Même clé, mais à partir d'un lot physique (Stock) — utilise l'épaisseur
  // réelle du lot plutôt que l'épaisseur nominale de l'article Catalogue,
  // et la clé crédit du produit auquel le lot appartient.
  // Bug corrigé le 20/09 : la catégorie Stock d'un produit Tranche vaut sa
  // matière ("Grès Cérame"/"Quartz" — voir categorieStockPourArticle), elle
  // ne vaut jamais littéralement "Tranche". Le test précédent comparait
  // produit.categorie à "Tranche" et échouait donc systématiquement, ce qui
  // rendait consommeParCle toujours vide dans submitPL() : un crédit exo
  // était généré pour la totalité de chaque tranche facturée, quelle que
  // soit la quantité réellement consommée. On identifie maintenant la
  // Tranche via l'article Catalogue d'origine, comme familleEpaisseurDeArticle.
  function familleEpaisseurDeLot(lot) {
    if (!lot) return null;
    const article = articleDuProduit(lot.produitId);
    if (!article || article.categorie !== "Tranche") return null;
    const famille = clefCreditDuProduit(lot.produitId);
    if (!famille) return null;
    const epaisseur = (lot.epaisseur || "").trim().toLowerCase();
    if (!epaisseur) return null;
    return { famille, epaisseur, cle: `${famille}||${epaisseur}` };
  }
  // Compare, pour un PL, la quantité facturée (lignes du dossier) à la
  // quantité réellement déclarée comme consommée, par famille couleur
  // (fournisseur+code+finition, toutes épaisseurs confondues) pour les
  // Tranches, et par produit exact pour tout le reste (Éviers,
  // Accessoires...). Sert désormais uniquement au plafond anti-sur-
  // consommation de submitPL (accord du 20-21/09) : une substitution
  // d'épaisseur au sein d'une même famille ne doit jamais, à elle seule,
  // être bloquée — seul un vrai manque de quantité (facturé > consommé,
  // toutes épaisseurs de la famille additionnées) doit l'être. Depuis le
  // Step 9, le registre de crédit ne réutilise plus ce calcul par famille :
  // voir besoinsCreditParProduit, keyed produit exact.
  function comparerFactureEtConsomme(lignesPL, consos) {
    const totauxFamille = new Map();
    const groupesProduit = new Map();
    for (const l of lignesPL || []) {
      if (l.type !== "facture" || !l.articleId) continue;
      const article = (articles || []).find((a) => a.id === l.articleId);
      if (!article) continue;
      const fe = article.categorie === "Tranche" ? familleEpaisseurDeArticle(article) : null;
      if (fe) {
        const tf = totauxFamille.get(fe.famille) || { cle: fe.famille, type: "famille", famille: fe.famille, libelle: libelleFamilleSeule(article), quantiteFacturee: 0, quantiteConsommee: 0 };
        tf.quantiteFacturee += Number(l.qte) || 0;
        totauxFamille.set(fe.famille, tf);
      } else if (article.produitStockId) {
        const g = groupesProduit.get(article.produitStockId) || { cle: article.produitStockId, type: "produit", produitId: article.produitStockId, libelle: nomProduit(article.produitStockId), quantiteFacturee: 0, quantiteConsommee: 0 };
        g.quantiteFacturee += Number(l.qte) || 0;
        groupesProduit.set(article.produitStockId, g);
      }
    }
    for (const c of consos || []) {
      const lot = (items || []).find((it) => it.id === c.lotId);
      if (!lot) continue;
      const fe = familleEpaisseurDeLot(lot);
      if (fe) {
        const articleLot = articleDuProduit(lot.produitId);
        const tf = totauxFamille.get(fe.famille) || { cle: fe.famille, type: "famille", famille: fe.famille, libelle: articleLot ? libelleFamilleSeule(articleLot) : fe.famille, quantiteFacturee: 0, quantiteConsommee: 0 };
        tf.quantiteConsommee += Number(c.quantite) || 0;
        totauxFamille.set(fe.famille, tf);
      } else if (lot.produitId) {
        const g = groupesProduit.get(lot.produitId) || { cle: lot.produitId, type: "produit", produitId: lot.produitId, libelle: nomProduit(lot.produitId), quantiteFacturee: 0, quantiteConsommee: 0 };
        g.quantiteConsommee += Number(c.quantite) || 0;
        groupesProduit.set(lot.produitId, g);
      }
    }
    const arrondir = (g) => ({ ...g, quantiteFacturee: Number(g.quantiteFacturee.toFixed(2)), quantiteConsommee: Number(g.quantiteConsommee.toFixed(2)) });
    const groupesEcarts = [...totauxFamille.values(), ...groupesProduit.values()].map(arrondir);
    return { groupesEcarts };
  }
  // ---------- ERP step 9 : registre de crédit — clé = produit Stock exact
  // (accord du 21/09, remplace la clé famille+épaisseur du Step 8). Seules
  // les Tranches liées au Stock sont éligibles. ----------
  function produitCreditDeArticle(a) {
    if (!a || a.categorie !== "Tranche" || !a.produitStockId) return null;
    return { produitId: a.produitStockId, cle: a.produitStockId, libelle: nomProduit(a.produitStockId) };
  }
  function produitCreditDeLot(lot) {
    if (!lot || !lot.produitId) return null;
    const article = articleDuProduit(lot.produitId);
    if (!article || article.categorie !== "Tranche") return null;
    return { produitId: lot.produitId, cle: lot.produitId, libelle: nomProduit(lot.produitId) };
  }
  // À l'enregistrement d'un PL NON-exo (accord du 21/09) : regroupe, par
  // produit Stock exact, la quantité facturée sur le dossier et la quantité
  // réellement déclarée consommée sur ce PL. Un manque (facturé > consommé)
  // sur un produit devient une entrée de crédit pour cet exact produit — un
  // PL exo n'appelle jamais cette fonction (aucune interaction avec le
  // registre) et une substitution vers un autre produit ne compense jamais
  // un manque sur le produit réellement commandé.
  function besoinsCreditParProduit(lignesPL, consos) {
    const facture = new Map();
    const consomme = new Map();
    const libelles = new Map();
    for (const l of lignesPL || []) {
      if (l.type !== "facture" || !l.articleId || l.chute) continue; // Nils 26/10 (f) : une chute vendue reste hors registre
      const article = (articles || []).find((a) => a.id === l.articleId);
      const pc = produitCreditDeArticle(article);
      if (!pc) continue;
      facture.set(pc.produitId, (facture.get(pc.produitId) || 0) + (Number(l.qte) || 0));
      libelles.set(pc.produitId, pc.libelle);
    }
    for (const c of consos || []) {
      const lot = (items || []).find((it) => it.id === c.lotId);
      const pc = produitCreditDeLot(lot);
      if (!pc) continue;
      consomme.set(pc.produitId, (consomme.get(pc.produitId) || 0) + (Number(c.quantite) || 0));
    }
    const manques = [];
    facture.forEach((qFacturee, produitId) => {
      const qConsommee = consomme.get(produitId) || 0;
      const manque = Number((qFacturee - qConsommee).toFixed(2));
      if (manque > 0.004) manques.push({ produitId, quantite: manque, libelle: libelles.get(produitId) || nomProduit(produitId) });
    });
    return manques;
  }
  function creditDisponible(cle) {
    return (creditsTranches || [])
      .filter((c) => c.cle === cle)
      .reduce((s, c) => s + (Number(c.quantite) || 0), 0);
  }
  // Consomme `quantite` de crédit pour `cle` en épuisant les entrées les plus
  // anciennes en premier. Renvoie la nouvelle liste ; n'échoue jamais mais
  // peut laisser un solde négatif si l'appelant n'a pas vérifié avant (les
  // deux points d'appel vérifient toujours la disponibilité avant d'appeler).
  function consommerCreditListe(liste, cle, quantite) {
    let reste = quantite;
    const next = [];
    const tries = [...(liste || [])].sort((a, b) => (a.creeLe || "").localeCompare(b.creeLe || ""));
    for (const entree of tries) {
      if (entree.cle !== cle || reste <= 0) {
        next.push(entree);
        continue;
      }
      if (entree.quantite <= reste) {
        reste = Number((reste - entree.quantite).toFixed(2));
        // entrée totalement consommée : on ne la garde pas.
      } else {
        next.push({ ...entree, quantite: Number((entree.quantite - reste).toFixed(2)) });
        reste = 0;
      }
    }
    return next;
  }
  function restituerCreditListe(liste, produitId, quantite, origine) {
    if (!quantite || quantite <= 0) return liste || [];
    return [
      ...(liste || []),
      {
        id: uid(),
        produitId,
        cle: produitId,
        libelle: nomProduit(produitId),
        quantite: Number(quantite.toFixed(2)),
        origine: origine || "Réservation annulée",
        creeLe: new Date().toISOString(),
      },
    ];
  }
  // ---------- ERP step 8 : crédit déduit au BDC (accord du 21/09), keyed
  // produit exact depuis le Step 9 ----------
  // Regroupe, pour un ensemble de lignes (devis ou dossier), le besoin en
  // crédit du registre par produit Stock exact — utilisé à la
  // transformation en BDC et à chaque sauvegarde de "Modifier le bon de
  // commande".
  function besoinsCreditPourLignes(lignes) {
    const besoins = new Map();
    for (const l of lignes || []) {
      if (l.type !== "facture" || !l.articleId || l.chute) continue; // chute vendue : hors registre (Nils 26/10, f)
      const article = (articles || []).find((a) => a.id === l.articleId);
      const pc = produitCreditDeArticle(article);
      if (!pc) continue;
      const cur = besoins.get(pc.produitId) || { cle: pc.produitId, produitId: pc.produitId, libelle: pc.libelle, quantite: 0 };
      cur.quantite = Number((cur.quantite + (Number(l.qte) || 0)).toFixed(2));
      besoins.set(pc.produitId, cur);
    }
    return besoins;
  }
  // Quantité de crédit qu'un dossier (BC) détient déjà pour une clé donnée
  // (consommée au registre depuis la transformation en BDC, voir
  // creerCommandeDepuisDevis / sauvegarderCommandeEnCours).
  function commandeCreditPourCle(commande, cle) {
    if (!commande || !Array.isArray(commande.creditsConsommes)) return 0;
    const e = commande.creditsConsommes.find((c) => c.cle === cle);
    return e ? Number(e.quantite) || 0 : 0;
  }
  // Dossiers (BC) détenant actuellement du crédit pour une clé donnée —
  // sert à nommer le(s) BC à modifier quand un crédit manque (transformation
  // en BDC bloquée, PL exo bloqué…).
  function commandesDetenantCredit(cle) {
    return (commandesListe || []).filter(
      (c) => Array.isArray(c.creditsConsommes) && c.creditsConsommes.some((cc) => cc.cle === cle && Number(cc.quantite) > 0)
    );
  }
  // Le dossier actuellement en cours d'édition de ses lignes via "Modifier
  // le bon de commande" (draft.lignes partagé avec commandeEditing.lignes),
  // ou null si on édite un devis pas encore transformé en BDC — dans ce
  // dernier cas, aucun crédit n'est encore consommé pour ces lignes.
  function commandeEnEditionDesLignes() {
    if (commandeEditing && draft && draft.id === commandeEditing.devisId && commandeLignesEditables(commandeEditing.statut)) {
      return commandeEditing;
    }
    return null;
  }
  // Vérifie si un ensemble de lignes facturées peut être exonéré : les
  // lignes non-Tranche doivent référencer un article coché "TVA exonérable" ;
  // les lignes Tranche sont regroupées par famille + épaisseur (le choix ne
  // compte pas) et comparées au crédit disponible dans le registre.
  function verifierExonerationLignes(lignes) {
    const lignesBloquantes = [];
    const besoinsTranche = new Map();
    for (const l of lignes || []) {
      // Nils 26/10 (f) : toute chute vendue s'exonère, sans crédit du registre.
      if (l.type !== "facture" || !l.articleId || l.chute) continue;
      const article = (articles || []).find((a) => a.id === l.articleId);
      if (!article) continue;
      if (article.categorie === "Tranche") {
        const pc = produitCreditDeArticle(article);
        if (!pc) {
          lignesBloquantes.push(l);
          continue;
        }
        const cur = besoinsTranche.get(pc.cle) || { produitId: pc.produitId, quantite: 0, designations: [] };
        cur.quantite += Number(l.qte) || 0;
        cur.designations.push(l.designation);
        besoinsTranche.set(pc.cle, cur);
      } else if (!article.exonerable) {
        lignesBloquantes.push(l);
      }
    }
    const groupesInsuffisants = [];
    besoinsTranche.forEach((v, cle) => {
      const dispo = creditDisponible(cle);
      if (v.quantite > dispo) groupesInsuffisants.push({ cle, ...v, disponible: dispo });
    });
    return { lignesBloquantes, groupesInsuffisants, ok: lignesBloquantes.length === 0 && groupesInsuffisants.length === 0 };
  }
  function messageRefusExoneration(verif) {
    const parts = [];
    if (verif.lignesBloquantes.length > 0) {
      parts.push(`${verif.lignesBloquantes.length} ligne(s) non exonérable(s) — ${verif.lignesBloquantes.map((l) => l.designation).join(", ")}`);
    }
    if (verif.groupesInsuffisants.length > 0) {
      parts.push(
        verif.groupesInsuffisants
          .map((g) => `${g.designations.join(", ")} : ${g.quantite} demandée(s), ${g.disponible} crédit(s) disponible(s) dans le registre des tranches exonérables`)
          .join(" ; ")
      );
    }
    return `Impossible de marquer ce devis exonéré : ${parts.join(" — ")}.`;
  }

  function categorieUnite(nom) {
    const c = (categories || []).find((c) => c.name === nom);
    return c ? c.unite : null;
  }
  function categorieNuances(nom) {
    const c = (categories || []).find((c) => c.name === nom);
    return c ? !!c.nuances : false;
  }
  function categorieGestion(nom) {
    const c = (categories || []).find((c) => c.name === nom);
    return c && c.gestion ? c.gestion : GESTION_TRANCHE;
  }
  // Vrai si la catégorie est gérée à la pièce (évier, consommable) : formulaire réduit.
  function categorieEstPiece(nom) {
    return categorieGestion(nom) === GESTION_PIECE;
  }

  function openCatEdit(c) {
    setCatEditingId(c.name);
    setNewCatName(c.name);
    setNewCatUnite(c.unite);
    setCatError("");
    setCatSuccess("");
  }

  function resetCatForm() {
    setCatEditingId(null);
    setNewCatName("");
    setNewCatUnite((unitesCategorie || DEFAULT_UNITES_CATEGORIE)[0]);
    setCatError("");
  }

  async function addCategory() {
    const name = newCatName.trim();
    setCatSuccess("");
    if (!name) {
      setCatError("Indique un nom de catégorie.");
      return;
    }
    const list = categories || [];
    if (list.some((c) => c.name.toLowerCase() === name.toLowerCase() && c.name !== catEditingId)) {
      setCatError("Cette catégorie existe déjà.");
      return;
    }
    try {
      // Toute catégorie créable ici est un consommable/outillage — les
      // matières en tranche (Quartz, Grès Cérame) n'existent plus que via
      // le Catalogue, qui les crée directement avec le bon mode de gestion.
      const fiche = { name, unite: newCatUnite, gestion: GESTION_PIECE, nuances: false };

      if (catEditingId) {
        const ancienne = list.find((c) => c.name === catEditingId);
        await persistCategories(list.map((c) => (c.name === catEditingId ? fiche : c)));
        const produitsCategorie = (produits || []).filter((p) => p.categorie === catEditingId);
        // renommage : répercuter sur les références rattachées
        if (catEditingId !== name) {
          await persistProduits((produits || []).map((p) => (p.categorie === catEditingId ? { ...p, categorie: name } : p)));
        }
        // unité corrigée : répercuter sur les lots déjà créés sous cette
        // catégorie — sinon ils garderaient l'ancienne unité pour toujours,
        // puisque chaque lot enregistre sa propre unité au moment de sa
        // création plutôt que de la relire en direct depuis la catégorie.
        if (ancienne && ancienne.unite !== fiche.unite && produitsCategorie.length > 0) {
          const idsProduits = produitsCategorie.map((p) => p.id);
          await persist((items || []).map((it) => (idsProduits.includes(it.produitId) ? { ...it, unite: fiche.unite } : it)));
        }
        setCatSuccess(`« ${name} » modifiée.`);
      } else {
        await persistCategories([...list, fiche]);
        setCatSuccess(`« ${name} » ajoutée.`);
        requestAnimationFrame(() => {
          if (catListRef.current) catListRef.current.scrollTop = catListRef.current.scrollHeight;
        });
      }
      resetCatForm();
    } catch (err) {
      console.error("Erreur enregistrement catégorie", err);
      setCatError("Impossible d'enregistrer la catégorie. Réessaie.");
    }
  }

  // Aligne les catégories Stock sur celles du Catalogue (Grès Cérame, Éviers,
  // Accessoires — les mêmes noms que les matières/catégories du Catalogue),
  // migre les produits de l'ancienne catégorie "Céramique" vers "Grès
  // Cérame", puis supprime "Céramique" devenue inutile.
  // Une seule action de réalignement Catalogue ↔ Stock, qui enchaîne les
  // trois corrections sur des variables locales (pas sur l'état React) pour
  // que chaque étape voie bien le résultat de la précédente :
  // 1. catégories réservées créées + migration/suppression de "Céramique"
  // 2. produits Stock manquants créés pour les articles jamais liés
  // 3. catégorie corrigée sur les produits déjà liés mais désalignés
  // Sauvegarde complète : dépose l'état actuel de toutes les clés
  // connues dans un fichier JSON téléchargeable. Ne couvre pas les
  // fichiers déposés dans les documents des devis (étape g : rangés dans le
  // stockage objet du serveur, seule leur référence est dans les devis).
  async function exporterToutesLesDonnees() {
    tracerAcces("export des données", "Téléchargement d'un export complet");
    const donnees = {
      exporteLe: new Date().toISOString(),
      exportePar: user.nom,
      note: "Les fichiers déposés dans les documents des devis ne sont pas inclus dans cet export (seule leur référence l'est).",
      "erp:devis": devisListe,
      "erp:commandes": commandesListe,
      "erp:articles": articles,
      "erp:chantiers": chantiers,
      "erp:prix-groupes-tranche": prixGroupesTranche,
      "erp:prix-groupes-tranche-2e-choix": prixGroupesTranche2eChoix,
      "erp:categories-articles": categoriesArticles,
      "erp:unites-articles": unitesArticles,
      "erp:finitions-articles": finitionsArticles,
      "erp:matieres": matieresPerso,
      "erp:groupes-couleur-articles": groupesCouleurArticles,
      "erp:apporteurs-affaire": apporteursAffaire,
      "erp:poseurs": poseurs,
      "erp:en-attente-par-statut": enAttenteParStatut,
      "erp:acces": acces,
      "erp:unites-categorie": unitesCategorie,
      "erp:conditions-paiement": paiements,
      "erp:clients": clients,
      "stock:references": items,
      "stock:categories": categories,
      "stock:fournisseurs": fournisseurs,
      "stock:mouvements": mouvements,
      "stock:reservations": reservations,
      "stock:produits": produits,
      "stock:dimensions": dimensionsList,
      "stock:epaisseurs": epaisseursList,
      "stock:credits-tranches-exonerables": creditsTranches,
      // ERP step 10 : historique du registre de crédit, jusqu'ici absent de l'export.
      [CREDITS_HISTORIQUE_KEY]: creditsHistorique,
      "erp:journal-acces": journalAcces,
      [ALERTES_KEY]: alertes,
      [PARAMETRES_KEY]: parametres,
      [CAMPAGNES_INVENTAIRE_KEY]: campagnesInventaire,
      [EN_SERVICE_KEY]: enService,
      [PLANS_RECUPERES_KEY]: plansRecuperes,
      [INCIDENTS_KEY]: incidents,
      [COMMUNICATIONS_KEY]: communications,
      [LECTURES_COM_KEY]: lecturesCom,
      [LOTS_ARCHIVES_KEY]: lotsArchives,
      [AFFECTATIONS_KEY]: affectationsBrutes,
      [STAFF_KEY]: staff,
      [SUIVI_MENSUEL_KEY]: suiviMensuel,
      [SIGNALEMENTS_KEY]: signalements,
      [POINTAGE_KEY]: pointage,
      [PRIMES_PRODUCTIVITE_KEY]: primesProductivite,
      [TRESORERIE_KEY]: operations,
      [FACTURES_FOURNISSEURS_KEY]: facturesF,
      [FACTURES_ANTERIEURES_KEY]: facturesAnt,
      [REMPLACEMENTS_KEY]: remplacements,
      [COUTS_REVIENT_KEY]: coutsRevient,
      [COMMISSIONS_KEY]: commissions,
      [DEPLACEMENTS_KEY]: deplacements,
      [EXPOSITIONS_KEY]: expositions,
      [AVOIRS_KEY]: avoirs,
      [VEHICULES_KEY]: flotte,
      [ECH_SUIVI_KEY]: echSuivi,
      [PLANNING_KEY]: planning,
      [ARRIVAGES_IMPORT_KEY]: arrivagesImport,
      [ARRIVAGES_LOCAUX_KEY]: arrivagesLocaux,
      [TRANSPORT_INTL_KEY]: transportIntl,
      [AFFECTATIONS_CREDIT_KEY]: affectationsCredit,
      [PREVISIONS_KEY]: previsions,
      [VISITES_KEY]: visites,
      [RECURRENTES_KEY]: recurrentes,
      [TACHES_MANUELLES_KEY]: tachesManuelles,
      [BUGS_KEY]: bugs,
      [MKT_TIMESHEET_KEY]: timesheet,
      [ECHANTILLONS_KEY]: echantillons,
      [ECH_MOUVEMENTS_KEY]: echMouvements,
      [DEMANDES_ECH_KEY]: demandesEch,
      [PROSPECTS_KEY]: prospects,
      [RAPPORTS_COM_KEY]: rapportsCom,
      [SIGNATAIRES_BL_KEY]: signatairesBL,
      [COMPTES_TRESORERIE_KEY]: comptesTreso,
      [SAV_KEY]: savListe,
      [OUTILLAGE_KEY]: outils,
      [CONTROLES_OUTILLAGE_KEY]: controlesOutillage,
    };
    const nomFichier = `stone-concept-export-${new Date().toISOString().slice(0, 10)}.json`;
    // ERP step 9 : un téléchargement déclenché par la page (<a download>)
    // est bloqué dans cet artefact — on passe par la capacité de
    // téléchargement de l'environnement, qui demande une confirmation
    // explicite au viewer avant d'enregistrer le fichier.
    try {
      const downloads = window.claude && (await window.claude.use("downloads"));
      if (!downloads) {
        telechargerParNavigateur(nomFichier, JSON.stringify(donnees, null, 2));
        setNotice("Export téléchargé — pense à le conserver en lieu sûr.");
        return;
      }
      const resultat = await downloads.save({ filename: nomFichier, data: JSON.stringify(donnees, null, 2) });
      setNotice(resultat.status === "delivered" ? "Export envoyé." : "Export téléchargé — pense à le conserver en lieu sûr.");
    } catch (err) {
      if (err && err.code === "declined") {
        setNotice("Export annulé.");
      } else {
        console.error("Export échoué", err);
        setNotice("Impossible de télécharger l'export — réessaie dans un instant.");
      }
    }
  }

  // Fusionne une liste existante avec une liste importée, sans jamais
  // écraser ce qui existe déjà — n'ajoute que les éléments réellement
  // nouveaux. Par défaut, la correspondance se fait par id technique ; pour
  // certaines entités (article, client, fournisseur, produit) créées
  // séparément sur deux liens différents, l'id diffère alors qu'il s'agit
  // du même élément — on peut fournir une clé de correspondance métier
  // (code article, ICE client, nom...) pour les reconnaître correctement
  // et éviter de les dupliquer.
  function fusionnerListe(actuelle, importee, cleCorrespondance) {
    const liste = actuelle || [];
    const cle = cleCorrespondance || ((item) => item && item.id);
    const clesExistantes = new Set(liste.map(cle).filter(Boolean));
    const nouveaux = (importee || []).filter((item) => {
      if (typeof item === "string") return !liste.includes(item);
      const k = cle(item);
      if (!k) return false;
      return !clesExistantes.has(k);
    });
    return { fusion: [...liste, ...nouveaux], ajoutes: nouveaux.length };
  }

  // Import depuis un fichier exporté (ce même bouton, ou le script de
  // secours pour un ancien lien) — fusion uniquement, jamais de
  // remplacement : ce qui existe déjà ici reste intact, seul ce qui manque
  // est ajouté.
  function importerDonnees(fichier) {
    return avecOperationGerant("import", () => importerDonneesFichier(fichier));
  }
  async function importerDonneesFichier(fichier) {
    try {
      const texte = await fichier.text();
      const donnees = JSON.parse(texte);
      const listes = {
        "erp:devis": [devisListe, persistDevis],
        "erp:commandes": [commandesListe, persistCommandes],
        "erp:articles": [articles, persistArticles],
        "erp:chantiers": [chantiers, persistChantiers],
        "erp:categories-articles": [categoriesArticles, persistCategoriesArticles],
        "erp:unites-articles": [unitesArticles, persistUnitesArticles],
        "erp:finitions-articles": [finitionsArticles, persistFinitionsArticles],
        "erp:matieres": [matieresPerso, persistMatieres],
        "erp:groupes-couleur-articles": [groupesCouleurArticles, persistGroupesCouleurArticles],
        "erp:apporteurs-affaire": [apporteursAffaire, persistApporteursAffaire],
        "erp:poseurs": [poseurs, persistPoseurs],
        "erp:unites-categorie": [unitesCategorie, persistUnitesCategorie],
        "erp:conditions-paiement": [paiements, persistPaiements],
        "erp:clients": [clients, persistClients],
        "stock:references": [items, persist],
        "stock:categories": [categories, persistCategories],
        "stock:fournisseurs": [fournisseurs, persistFournisseurs],
        "stock:mouvements": [mouvements, persistMouvements],
        "stock:reservations": [reservations, persistReservations],
        "stock:produits": [produits, persistProduits],
        "stock:dimensions": [dimensionsList, persistDimensions],
        "stock:epaisseurs": [epaisseursList, persistEpaisseurs],
        "stock:credits-tranches-exonerables": [creditsTranches, persistCreditsTranches],
        // ERP step 10 : historique du registre de crédit (fusion par id).
        [CREDITS_HISTORIQUE_KEY]: [creditsHistorique, persistCreditsHistorique],
        "erp:journal-acces": [journalAcces, persistJournalAcces],
        [ALERTES_KEY]: [alertes, persistAlertes],
        [CAMPAGNES_INVENTAIRE_KEY]: [campagnesInventaire, persistCampagnesInventaire],
        [EN_SERVICE_KEY]: [enService, persistEnService],
        [PLANS_RECUPERES_KEY]: [plansRecuperes, persistPlansRecuperes],
        [INCIDENTS_KEY]: [incidents, persistIncidents],
        [COMMUNICATIONS_KEY]: [communications, persistCommunications],
        [LECTURES_COM_KEY]: [lecturesCom, persistLecturesCom],
        [LOTS_ARCHIVES_KEY]: [lotsArchives, persistLotsArchives],
        [AFFECTATIONS_KEY]: [affectationsBrutes, persistAffectations],
        [STAFF_KEY]: [staff, persistStaff],
        [SUIVI_MENSUEL_KEY]: [suiviMensuel, persistSuiviMensuel],
        [SIGNALEMENTS_KEY]: [signalements, persistSignalements],
        [POINTAGE_KEY]: [pointage, persistPointage],
        [PRIMES_PRODUCTIVITE_KEY]: [primesProductivite, persistPrimesProductivite],
        [TRESORERIE_KEY]: [operations, persistOperations],
        [FACTURES_FOURNISSEURS_KEY]: [facturesF, persistFacturesF],
        [FACTURES_ANTERIEURES_KEY]: [facturesAnt, persistFacturesAnt],
        [REMPLACEMENTS_KEY]: [remplacements, persistRemplacements],
        [ARRIVAGES_IMPORT_KEY]: [arrivagesImport, persistArrivagesImport],
        [ARRIVAGES_LOCAUX_KEY]: [arrivagesLocaux, persistArrivagesLocaux],
        [DEPLACEMENTS_KEY]: [deplacements, persistDeplacements],
        [EXPOSITIONS_KEY]: [expositions, persistExpositions],
        [AVOIRS_KEY]: [avoirs, persistAvoirs],
        [AFFECTATIONS_CREDIT_KEY]: [affectationsCredit, persistAffectationsCredit],
        [PREVISIONS_KEY]: [previsions, persistPrevisions],
        [VISITES_KEY]: [visites, persistVisites],
        [RECURRENTES_KEY]: [recurrentes, persistRecurrentes],
        [TACHES_MANUELLES_KEY]: [tachesManuelles, persistTachesManuelles],
        [BUGS_KEY]: [bugs, persistBugs],
        [MKT_TIMESHEET_KEY]: [timesheet, persistTimesheet],
        [ECHANTILLONS_KEY]: [echantillons, persistEchantillons],
        [ECH_MOUVEMENTS_KEY]: [echMouvements, persistEchMouvements],
        [DEMANDES_ECH_KEY]: [demandesEch, persistDemandesEch],
        [PROSPECTS_KEY]: [prospects, persistProspects],
        [RAPPORTS_COM_KEY]: [rapportsCom, persistRapportsCom],
        [SIGNATAIRES_BL_KEY]: [signatairesBL, persistSignatairesBL],
        [COMPTES_TRESORERIE_KEY]: [comptesTreso, persistComptesTreso],
        [SAV_KEY]: [savListe, persistSav],
        [OUTILLAGE_KEY]: [outils, persistOutils],
        [CONTROLES_OUTILLAGE_KEY]: [controlesOutillage, persistControlesOutillage],
      };
      // Clé de correspondance métier — l'id technique diffère forcément
      // entre deux artefacts créés séparément, ces champs non.
      const clesCorrespondance = {
        "erp:articles": (a) => (a.code || "").trim().toLowerCase() || (a.designation || "").trim().toLowerCase() || a.id,
        "erp:clients": (c) => (c.ice || "").trim() || (c.nom || "").trim().toLowerCase() || c.id,
        "stock:fournisseurs": (f) => (f.nom || "").trim().toLowerCase() || f.id,
        "stock:produits": (p) => (p.nom || "").trim().toLowerCase() || p.id,
        "erp:conditions-paiement": (p) => (typeof p === "string" ? p : (p && p.label) || "").trim().toLowerCase(),
        "stock:categories": (c) => ((c && c.name) || "").trim().toLowerCase(),
      };
      const objets = {
        "erp:prix-groupes-tranche": [prixGroupesTranche, persistPrixGroupesTranche],
        "erp:prix-groupes-tranche-2e-choix": [prixGroupesTranche2eChoix, persistPrixGroupesTranche2eChoix],
        "erp:en-attente-par-statut": [enAttenteParStatut, persistEnAttenteParStatut],
        [PARAMETRES_KEY]: [parametres, persistParametres],
        [COUTS_REVIENT_KEY]: [coutsRevient, persistCoutsRevient],
        [COMMISSIONS_KEY]: [commissions, persistCommissions],
        [VEHICULES_KEY]: [flotte, persistFlotte],
        [ECH_SUIVI_KEY]: [echSuivi, persistEchSuivi],
        [PLANNING_KEY]: [planning, persistPlanning],
        [TRANSPORT_INTL_KEY]: [transportIntl, persistTransportIntl],
      };
      const resume = [];
      const echecs = [];
      for (const cle of Object.keys(listes)) {
        const importee = donnees[cle];
        if (!Array.isArray(importee) || importee.length === 0) continue;
        const [actuelle, fn] = listes[cle];
        const { fusion, ajoutes } = fusionnerListe(actuelle, importee, clesCorrespondance[cle]);
        if (ajoutes > 0) {
          const ok = await fn(fusion);
          if (ok === false) {
            echecs.push(cle);
          } else {
            resume.push(`${cle} : ${ajoutes} ajouté(s)`);
          }
          // Laisse le temps à l'écriture précédente de bien se terminer
          // côté plateforme avant d'enchaîner la suivante.
          await sleep(400);
        }
      }
      for (const cle of Object.keys(objets)) {
        const importee = donnees[cle];
        if (!importee || typeof importee !== "object") continue;
        const [actuelle, fn] = objets[cle];
        const estVide = !actuelle || Object.keys(actuelle).length === 0 || (cle === TRANSPORT_INTL_KEY && !(actuelle.lignes || []).length);
        if (estVide) {
          const ok = await fn(importee);
          if (ok === false) {
            echecs.push(cle);
          } else {
            resume.push(`${cle} : adopté (était vide)`);
          }
          await sleep(400);
        }
      }
      if (echecs.length > 0) {
        setNotice(
          `${resume.length > 0 ? `Import partiel : ${resume.join(", ")}. ` : ""}Échec sur ${echecs.join(", ")} — réessaie l'import, ces clés-là n'ont pas été enregistrées.`
        );
        await tracerAcces("import de données", `Échec sur ${echecs.join(", ")}${resume.length > 0 ? ` · Partiel : ${resume.join(", ")}` : ""}`);
      } else if (resume.length === 0) {
        setNotice("Import terminé — rien de nouveau à ajouter, tout existait déjà ici.");
        await tracerAcces("import de données", "Rien de nouveau à ajouter");
      } else {
        setNotice(`Import terminé : ${resume.join(", ")}.`);
        await tracerAcces("import de données", resume.join(", "));
      }
    } catch (err) {
      console.error("Erreur import", err);
      setNotice("Impossible de lire ce fichier — vérifie qu'il s'agit bien d'un export JSON valide.");
    }
  }

  // Remise à zéro complète — irréversible. Les données transactionnelles
  // (devis, commandes, clients, stock, historique...) repartent à vide ; les
  // listes de configuration (catégories, fournisseurs, unités...) reviennent
  // à leurs valeurs par défaut plutôt qu'à rien, pour que l'app reste
  // utilisable immédiatement après.
  function viderToutesLesDonnees() {
    return avecOperationGerant("vidage", viderGroupesChoisis);
  }
  async function viderGroupesChoisis() {
    const g = vidageGroupes || {};
    const choisis = GROUPES_VIDAGE.filter((x) => g[x.cle]);
    if (!choisis.length || manquantsVidage(g).length) return;
    await tracerAcces("vidage des données", `Groupes vidés : ${choisis.map((x) => x.titre).join(", ")}`);
    if (g.a) {
      await persistDevis([]);
      await persistCommandes([]);
      await persistRemplacements([]);
      await persistSav([]);
      await persistAffectationsCredit([]);
      await persistVisites([]);
      await persistProspects([]);
      await persistRapportsCom([]);
      // Step 17 (Nils 15/10) : données ajoutées depuis la création du bouton.
      await persistChantiers([]);
      await persistPlanning(PLANNING_VIDE);
      await persistDeplacements([]);
      await persistExpositions([]);
      await persistAvoirs([]);
      if (!g.n) await persistCommissions({ ...(commissions || DEFAULT_COMMISSIONS), validations: {} });
    }
    if (g.b) {
      await persist([]);
      await persistArrivagesImport([]);
      await persistArrivagesLocaux([]);
      await persistLotsArchives([]);
      await persistMouvements([]);
      await persistReservations([]);
      await persistCreditsTranches([]);
      await persistCreditsHistorique([]);
      await persistCampagnesInventaire([]);
      await persistEnService([]);
      await persistPlansRecuperes([]);
      await persistIncidents([]);
    }
    if (g.c) {
      await persistOperations([]);
      await persistPrevisions([]);
      await persistRecurrentes([]);
      if (!g.n) await persistComptesTreso((comptesTreso || DEFAULT_COMPTES_TRESORERIE).map((c) => ({ ...c, clotures: [], releves: [] })));
    }
    if (g.d) { await persistFacturesF([]); await persistTransportIntl(TRANSPORT_INTL_VIDE); }
    if (g.e) await persistFacturesAnt([]);
    if (g.f) {
      await persistPointage([]);
      await persistPrimesProductivite([]);
    }
    if (g.g) {
      await persistOutils([]);
      await persistControlesOutillage([]);
    }
    if (g.h) { await persistAlertes([]); await persistTachesManuelles([]); await persistBugs([]); await persistCommunications([]); await persistLecturesCom([]); }
    if (g.o) { await persistTimesheet([]); await persistEchantillons(ECHANTILLONS_DEPART); await persistEchMouvements([]); await persistDemandesEch([]); await persistEchSuivi({ boites: [], prets: [], delaiControleMois: 6 }); }
    if (g.p) await persistFlotte({ vehicules: vehiculesDepart(todayISO()), releves: [], tickets: [], carnetsMachines: {}, alertesEnvoyees: {}, seuilConsoPct: 20, init: false });
    if (g.i) {
      await persistClients([]);
    }
    if (g.j) {
      await persistFournisseurs(DEFAULT_FOURNISSEURS);
      await persistDemandesFournisseurs([]);
    }
    if (g.k) {
      await persistArticles([]);
      await persistPrixGroupesTranche({});
      await persistPrixGroupesTranche2eChoix({});
      await persistGroupesCouleurArticles(DEFAULT_GROUPES_COULEUR_ARTICLE);
      await persistMatieres([]);
    }
    if (g.l) {
      await persistProduits([]);
      await persistCategories(DEFAULT_CATEGORIES);
      await persistDemandesSousCat([]);
    }
    if (g.m) {
      await persistStaff(staffParDefaut());
      setStaffAMigrer(false);
      await persistSuiviMensuel([]);
      await persistSignalements([]);
    }
    if (g.n) {
      await persistPaiements(DEFAULT_PAIEMENTS);
      await persistUnitesCategorie(DEFAULT_UNITES_CATEGORIE);
      await persistDimensions(DEFAULT_DIMENSIONS);
      await persistEpaisseurs(DEFAULT_EPAISSEURS);
      await persistCategoriesArticles(DEFAULT_CATEGORIES_ARTICLES);
      await persistUnitesArticles(DEFAULT_UNITES_ARTICLE);
      await persistFinitionsArticles(DEFAULT_FINITIONS_ARTICLE);
      await persistApporteursAffaire(DEFAULT_APPORTEURS_AFFAIRE);
      await persistPoseurs(DEFAULT_POSEURS);
      await persistEnAttenteParStatut(DEFAULT_EN_ATTENTE_PAR_STATUT);
      await persistSignatairesBL(DEFAULT_SIGNATAIRES_BL);
      await persistParametres({});
      await persistAffectations([]);
      await persistAcces(null);
      await persistComptesTreso(DEFAULT_COMPTES_TRESORERIE);
      await persistCoutsRevient(DEFAULT_COUTS_REVIENT);
      await persistCommissions(g.a ? DEFAULT_COMMISSIONS : { ...DEFAULT_COMMISSIONS, validations: (commissions && commissions.validations) || {} });
    }
    setShowVidage(false);
    setVidageGroupes({});
    setNotice(`Données vidées : ${choisis.map((x) => x.titre).join(", ")}.`);
  }

  async function realignerCatalogueEtStock() {
    let categoriesActuelles = categories || [];
    let produitsActuels = produits || [];
    let articlesActuels = articles || [];

    // 1. Catégories réservées + migration Céramique -> Grès Cérame
    const manquantes = [];
    if (!categoriesActuelles.some((c) => c.name === "Grès Cérame")) {
      manquantes.push({ name: "Grès Cérame", unite: "tranche(s)", gestion: GESTION_TRANCHE, nuances: true });
    }
    if (!categoriesActuelles.some((c) => c.name === "Éviers")) {
      manquantes.push({ name: "Éviers", unite: "pièce(s)", gestion: GESTION_PIECE, nuances: false });
    }
    if (!categoriesActuelles.some((c) => c.name === "Accessoires")) {
      manquantes.push({ name: "Accessoires", unite: "pièce(s)", gestion: GESTION_PIECE, nuances: false });
    }
    if (manquantes.length > 0) categoriesActuelles = [...categoriesActuelles, ...manquantes];
    const nbMigres = produitsActuels.filter((p) => p.categorie === "Céramique").length;
    if (nbMigres > 0) {
      produitsActuels = produitsActuels.map((p) => (p.categorie === "Céramique" ? { ...p, categorie: "Grès Cérame" } : p));
    }
    categoriesActuelles = categoriesActuelles.filter((c) => c.name !== "Céramique");

    // 2. Produits Stock manquants pour des articles jamais liés
    const aTraiter = articlesActuels.filter((a) => {
      if (a.lierAuStock === false) return false;
      if (!categorieStockPourArticle(a)) return false;
      if (a.produitStockId && produitsActuels.some((p) => p.id === a.produitStockId)) return false;
      return true;
    });
    let nbCrees = 0;
    for (const a of aTraiter) {
      const cible = categorieStockPourArticle(a);
      const nom = (a.designation || "").trim();
      if (!nom) continue;
      if (!categoriesActuelles.some((c) => c.name === cible)) {
        const defauts =
          MATIERES.includes(cible) && modeMatiere(cible) === "famille"
            ? { unite: "tranche(s)", gestion: GESTION_TRANCHE, nuances: true }
            : MATIERES.includes(cible)
            ? { unite: "tranche(s)", gestion: GESTION_TRANCHE, nuances: false }
            : { unite: "pièce(s)", gestion: GESTION_PIECE, nuances: false };
        categoriesActuelles = [...categoriesActuelles, { name: cible, ...defauts }];
      }
      const doublon = produitsActuels.find((p) => p.nom.toLowerCase() === nom.toLowerCase());
      if (doublon) {
        // Un produit du même nom existe déjà (créé autrement) — on relie
        // l'article dessus plutôt que d'en créer un second en double.
        articlesActuels = articlesActuels.map((x) => (x.id === a.id ? { ...x, produitStockId: doublon.id } : x));
        continue;
      }
      const nouveauProduit = { id: uid(), nom, categorie: cible, seuil: 0, correspondances: [] };
      produitsActuels = [...produitsActuels, nouveauProduit];
      articlesActuels = articlesActuels.map((x) => (x.id === a.id ? { ...x, produitStockId: nouveauProduit.id } : x));
      nbCrees++;
    }

    // 3. Catégorie corrigée sur les produits déjà liés mais désalignés
    const corrections = [];
    articlesActuels.forEach((a) => {
      if (!a.produitStockId) return;
      const cible = categorieStockPourArticle(a);
      if (!cible) return;
      const produit = produitsActuels.find((p) => p.id === a.produitStockId);
      if (produit && produit.categorie !== cible) corrections.push({ produitId: produit.id, categorie: cible });
    });
    if (corrections.length > 0) {
      const categoriesManquantes = [...new Set(corrections.map((c) => c.categorie))].filter(
        (nom) => !categoriesActuelles.some((c) => c.name === nom)
      );
      if (categoriesManquantes.length > 0) {
        categoriesActuelles = [
          ...categoriesActuelles,
          ...categoriesManquantes.map((nom) => ({ name: nom, unite: "pièce(s)", gestion: GESTION_PIECE, nuances: false })),
        ];
      }
      produitsActuels = produitsActuels.map((p) => {
        const correction = corrections.find((c) => c.produitId === p.id);
        return correction ? { ...p, categorie: correction.categorie } : p;
      });
    }

    await persistCategories(categoriesActuelles);
    await persistProduits(produitsActuels);
    await persistArticles(articlesActuels);

    const parts = [];
    if (nbMigres > 0) parts.push(`${nbMigres} produit(s) migré(s) depuis « Céramique »`);
    if (nbCrees > 0) parts.push(`${nbCrees} produit(s) créé(s) pour des articles jamais liés`);
    if (corrections.length > 0) parts.push(`${corrections.length} catégorie(s) de produit corrigée(s)`);
    setNotice(parts.length > 0 ? `Catalogue et Stock réalignés : ${parts.join(", ")}.` : "Tout était déjà aligné — aucune correction nécessaire.");
  }


  function removeCategory(name) {
    const refs = (produits || []).filter((p) => p.categorie === name).map((p) => p.nom);
    if (refs.length > 0) {
      const liste = refs.slice(0, 3).join(", ") + (refs.length > 3 ? `, et ${refs.length - 3} autre(s)` : "");
      setNotice(
        `Impossible de supprimer la catégorie « ${name} » : ${refs.length} produit(s) y sont rattachés (${liste}). Change leur catégorie ou supprime-les d'abord.`
      );
      return;
    }
    persistCategories((categories || []).filter((c) => c.name !== name));
    setNotice("");
  }

  // ---- Fournisseurs (annuaire) ----

  // Recense ce qui manque ou a expiré sur une fiche : sert d'alerte dans l'annuaire
  function fournisseurAlertes(f) {
    const a = [];
    if (f.origine === "Maroc" && !(f.ice || "").trim()) a.push("ICE manquant");
    if (!(f.paiement || "").trim()) a.push("Paiement non renseigné");
    const cs = certifStatut(f);
    if (cs && cs.code !== "ok") a.push(cs.label);
    return a;
  }

  function certifStatut(f) {
    if (f.origine !== "Maroc") return null;
    if (!f.certifFourni) return { code: "absent", label: "Certificat non fourni" };
    if (!f.certifDate) return { code: "absent", label: "Certificat sans date" };
    const emis = new Date(f.certifDate);
    if (isNaN(emis.getTime())) return { code: "absent", label: "Certificat sans date" };
    const limite = new Date(emis);
    limite.setMonth(limite.getMonth() + CERTIF_VALIDITE_MOIS);
    if (new Date() > limite) return { code: "perime", label: "Certificat périmé" };
    return { code: "ok", label: "Certificat à jour" };
  }

  // Matières fournies : déduites des catégories rattachées au fournisseur
  function matieresFournies(nom) {
    // déduit des produits réellement achetés chez ce fournisseur (correspondances + lots)
    const parCorresp = (produits || [])
      .filter((p) => (p.correspondances || []).some((c) => c.fournisseur === nom))
      .map((p) => p.categorie);
    const parLot = (items || []).filter((it) => it.fournisseur === nom).map((it) => produitDe(it.produitId)?.categorie);
    return [...new Set([...parCorresp, ...parLot].filter(Boolean))];
  }

  function openFourNew() {
    setFourEditing({
      id: null,
      nom: "",
      origine: "Maroc",
      fiabilite: "bonne",
      contacts: [],
      ice: "",
      paiement: "",
      certifFourni: false,
      certifDate: "",
      notes: "",
    });
    setFourError("");
    setFourEstDemande(false);
    setDemandeFourEnCours(null);
    setShowFourFiche(true);
  }

  function openFourEdit(f) {
    setFourEditing({ ...f, contacts: (f.contacts || []).map((c) => ({ ...c })) });
    setFourError("");
    setFourEstDemande(false);
    setDemandeFourEnCours(null);
    setShowFourFiche(true);
  }

  function addContact() {
    setFourEditing((prev) => ({
      ...prev,
      contacts: [...(prev.contacts || []), { id: uid(), nom: "", fonction: FONCTIONS[0], tel: "", email: "" }],
    }));
  }

  function updateContact(cid, champ, valeur) {
    setFourEditing((prev) => ({
      ...prev,
      contacts: prev.contacts.map((c) => (c.id === cid ? { ...c, [champ]: valeur } : c)),
    }));
  }

  function removeContact(cid) {
    setFourEditing((prev) => ({ ...prev, contacts: prev.contacts.filter((c) => c.id !== cid) }));
  }

  async function saveFournisseur() {
    const f = fourEditing;
    const nom = (f.nom || "").trim();
    if (!nom) {
      setFourError("Indique le nom du fournisseur.");
      return;
    }
    const list = fournisseurs || [];
    if (list.some((x) => x.nom.toLowerCase() === nom.toLowerCase() && x.id !== f.id)) {
      setFourError("Ce fournisseur existe déjà.");
      return;
    }
    // ICE : non obligatoire pour un fournisseur, seulement signalé comme manquant
    // dans l'annuaire (il sera en revanche obligatoire pour les clients).
    // Les conditions de paiement ne sont exigées qu'à la création.
    const creation = !f.id;
    if (creation && !(f.paiement || "").trim()) {
      setFourError("Indique les conditions de paiement.");
      return;
    }
    if (f.convention && f.convention.active && !(Number(f.convention.jours) > 0 && Number(f.convention.jours) <= DELAI_CONVENTION_MAX)) {
      setFourError(`Convention de paiement : indique un délai entre 1 et ${DELAI_CONVENTION_MAX} jours (maximum légal).`);
      return;
    }
    if (f.origine === "Maroc" && f.certifFourni && !f.certifDate) {
      setFourError("Indique la date d'émission du certificat.");
      return;
    }
    const clean = {
      ...f,
      nom,
      ice: f.origine === "Maroc" ? (f.ice || "").trim() : "",
      certifFourni: f.origine === "Maroc" ? f.certifFourni : false,
      certifDate: f.origine === "Maroc" && f.certifFourni ? f.certifDate : "",
      contacts: (f.contacts || []).filter((c) => (c.nom || "").trim()),
    };

    // Step 12 pt.6 (accord Nils du 21/09) : Ahmed/Wissam remplissent le
    // formulaire complet, mais leur saisie reste une simple demande en
    // attente — le fournisseur n'existe réellement qu'une fois que Nils ou
    // Sawsan l'a explicitement créé depuis cette demande.
    if (fourEstDemande) {
      try {
        const { id: _ignoreId, ...draft } = clean;
        const nouvelle = {
          id: uid(),
          ...draft,
          demandePar: user.nom,
          demandeLe: new Date().toISOString(),
          traite: false,
        };
        await persistDemandesFournisseurs([...(demandesFournisseurs || []), nouvelle]);
        setShowFourFiche(false);
        setFourEditing(null);
        setFourEstDemande(false);
        setFourError("");
        setNotice(`Demande de création envoyée pour « ${nom} ». Le Gérant ou l'Administration la traitera depuis l'onglet Fournisseurs.`);
      } catch (err) {
        console.error("Erreur enregistrement demande fournisseur", err);
        setFourError("Impossible d'enregistrer la demande. Réessaie.");
      }
      return;
    }

    try {
      const ancienNom = f.id ? list.find((x) => x.id === f.id)?.nom : null;
      const next = f.id ? list.map((x) => (x.id === f.id ? clean : x)) : [...list, { ...clean, id: uid() }];
      await persistFournisseurs(next);
      // Créé depuis la saisie d'une facture fournisseur : on le choisit directement.
      if (!f.id && factFEdit && factFEdit.tiersType === "fournisseur" && !factFEdit.fournisseur) setFactFEdit({ ...factFEdit, fournisseur: nom });

      // renommage : répercuter sur les catégories et références liées
      if (ancienNom && ancienNom !== nom) {
        await persist((items || []).map((it) => (it.fournisseur === ancienNom ? { ...it, fournisseur: nom } : it)));
        if ((facturesF || []).some((x) => x.fournisseur === ancienNom)) await persistFacturesF((facturesF || []).map((x) => (x.fournisseur === ancienNom ? { ...x, fournisseur: nom } : x)));
        if ((operations || []).some((o) => o.tiersType === "fournisseur" && o.tiers === ancienNom)) await persistOperations((operations || []).map((o) => (o.tiersType === "fournisseur" && o.tiers === ancienNom ? { ...o, tiers: nom } : o)));
      }
      // Si cette création vient d'une demande (pt.7), la demande est
      // marquée traitée maintenant que le fournisseur est réellement créé.
      if (demandeFourEnCours) {
        await persistDemandesFournisseurs((demandesFournisseurs || []).map((d) => (d.id === demandeFourEnCours ? { ...d, traite: true } : d)));
        setDemandeFourEnCours(null);
      }
      setShowFourFiche(false);
      setFourEditing(null);
      setFourError("");
    } catch (err) {
      console.error("Erreur enregistrement fournisseur", err);
      setFourError("Impossible d'enregistrer. Réessaie.");
    }
  }

  // Step 13 (retour Nils du 21/09, pt.6) : Sawsan/Nils peuvent corriger la
  // saisie d'Ahmed/Wissam avant de trancher — sans que cela crée déjà le
  // fournisseur. La demande reste en attente (traite: false), simplement
  // mise à jour avec les champs corrigés.
  async function enregistrerModifsDemande() {
    const f = fourEditing;
    const nom = (f.nom || "").trim();
    if (!nom) {
      setFourError("Indique le nom du fournisseur.");
      return;
    }
    if (!demandeFourEnCours) return;
    const clean = {
      nom,
      origine: f.origine,
      fiabilite: f.fiabilite,
      contacts: (f.contacts || []).filter((c) => (c.nom || "").trim()),
      ice: f.origine === "Maroc" ? (f.ice || "").trim() : "",
      paiement: f.paiement || "",
      certifFourni: f.origine === "Maroc" ? f.certifFourni : false,
      certifDate: f.origine === "Maroc" && f.certifFourni ? f.certifDate : "",
      notes: f.notes || "",
    };
    try {
      await persistDemandesFournisseurs((demandesFournisseurs || []).map((d) => (d.id === demandeFourEnCours ? { ...d, ...clean } : d)));
      setShowFourFiche(false);
      setFourEditing(null);
      setDemandeFourEnCours(null);
      setFourError("");
      setNotice(`Demande de « ${nom} » mise à jour, sans créer le fournisseur.`);
    } catch (err) {
      console.error("Erreur mise à jour demande fournisseur", err);
      setFourError("Impossible d'enregistrer les modifications. Réessaie.");
    }
  }

  function removeFournisseur(f) {
    // Un fournisseur est retenu par deux choses : des lots en stock,
    // ou une correspondance de nom sur une fiche produit.
    const refs = (items || []).filter((it) => it.fournisseur === f.nom).map((it) => nomProduit(it.produitId));
    const prods = (produits || [])
      .filter((p) => (p.correspondances || []).some((c) => c.fournisseur === f.nom))
      .map((p) => p.nom);

    if (refs.length > 0 || prods.length > 0) {
      const motifs = [];
      if (refs.length > 0) {
        const liste = refs.slice(0, 3).join(", ") + (refs.length > 3 ? `, et ${refs.length - 3} autre(s)` : "");
        motifs.push(`${refs.length} lot(s) en stock (${liste})`);
      }
      if (prods.length > 0) {
        const liste = prods.slice(0, 3).join(", ") + (prods.length > 3 ? `, et ${prods.length - 3} autre(s)` : "");
        motifs.push(`la correspondance de nom de ${prods.length} produit(s) (${liste})`);
      }
      setNotice(
        `Impossible de supprimer « ${f.nom} » : il est encore rattaché à ${motifs.join(" et à ")}. Retire ces rattachements avant de le supprimer.`
      );
      return;
    }
    persistFournisseurs((fournisseurs || []).filter((x) => x.id !== f.id));
    setNotice("");
  }


  function openProduitNew() {
    setDemandeSousCatEnCours(null);
    // ERP step 11 (bug signalé par Nils le 29/09) : la catégorie par défaut
    // se prend dans la même liste que celle affichée dans le menu
    // (categoriesStockDisponibles), sinon le menu montrait une catégorie
    // alors que la fiche n'en avait aucune (« Choisis une catégorie » +
    // champs target price / fournisseurs autorisés absents).
    const categorieLibre = categoriesStockDisponibles.find((nom) => !estCategorieStockReservee(nom));
    const defaut = lotCategorie && !estCategorieStockReservee(lotCategorie) && categoriesStockDisponibles.includes(lotCategorie) ? lotCategorie : "";
    setProdEditing({ id: null, nom: "", categorie: defaut || categorieLibre || "", seuil: 0, fournisseur: "", vitesse: "", targetPrice: "", correspondances: [] });
    setProdError("");
    setShowProduit(true);
  }

  function openProduitEdit(p) {
    setProdEditing({ ...p, correspondances: (p.correspondances || []).map((c) => ({ ...c })) });
    setProdError("");
    setShowProduit(true);
  }

  // Step 12 pt.10 (accord Nils du 21/09) : la section "Nom chez chaque
  // fournisseur" est retirée du formulaire consommable (création ET
  // modification) — les correspondances déjà enregistrées restent utilisées
  // ailleurs (recherche Stock, fiche fournisseur), simplement non modifiables
  // depuis cet écran.

  async function saveProduit() {
    const p = prodEditing;
    const nom = (p.nom || "").trim();
    if (!nom) {
      setProdError("Indique le nom Stone Concept du produit.");
      return;
    }
    if ((produits || []).some((x) => x.nom.toLowerCase() === nom.toLowerCase() && x.id !== p.id)) {
      setProdError("Ce produit existe déjà.");
      return;
    }
    if (!p.categorie) {
      setProdError("Choisis une catégorie.");
      return;
    }
    if (!p.id && estCategorieStockReservee(p.categorie)) {
      setProdError(`« ${p.categorie} » se crée uniquement depuis le Catalogue, pas ici — crée l'article correspondant dans le Catalogue, sa fiche Stock sera générée automatiquement.`);
      return;
    }
    const estConso = estCategorieConsommable(p.categorie);
    if (estConso && !peutGererConsommablesEtCategories) {
      setProdError("Seul le Gérant crée ou modifie les sous-catégories de consommables.");
      return;
    }
    if (estConso && fournisseursAutorises(p).length === 0) {
      setProdError("Ajoute au moins un fournisseur autorisé (avec son target price).");
      return;
    }
    if (estConso) {
      const vus = new Set();
      for (const c of fournisseursAutorises(p)) {
        if (vus.has(c.fournisseur)) {
          setProdError(`« ${c.fournisseur} » figure deux fois dans les fournisseurs autorisés.`);
          return;
        }
        vus.add(c.fournisseur);
      }
    }
    try {
      const clean = {
        ...p,
        nom,
        seuil: Number(p.seuil) || 0,
        // ERP step 11 : pour un consommable, les correspondances sont les
        // fournisseurs autorisés (nom chez le fournisseur facultatif, target
        // price HT) ; pour les autres fiches, règle inchangée.
        correspondances: estConso
          ? fournisseursAutorises(p).map((c) => ({ fournisseur: c.fournisseur, nomFournisseur: (c.nomFournisseur || "").trim(), targetPrice: c.targetPrice === "" || c.targetPrice === undefined ? "" : Number(c.targetPrice) }))
          : (p.correspondances || []).filter((c) => c.fournisseur && (c.nomFournisseur || "").trim()),
        ...(estConso ? { vitesse: p.vitesse || "", targetPrice: p.targetPrice === "" || p.targetPrice === undefined ? "" : Number(p.targetPrice) } : {}),
      };
      const list = produits || [];
      await persistProduits(p.id ? list.map((x) => (x.id === p.id ? clean : x)) : [...list, { ...clean, id: uid() }]);
      if (estConso) {
        await tracerAcces(p.id ? "modification sous-catégorie" : "création sous-catégorie", `${p.categorie} › ${nom}`);
      }
      if (!p.id && demandeSousCatEnCours) {
        await persistDemandesSousCat((demandesSousCat || []).map((x) => (x.id === demandeSousCatEnCours ? { ...x, traite: true } : x)));
        setDemandeSousCatEnCours(null);
      }
      setShowProduit(false);
      setProdEditing(null);
      setProdError("");
    } catch (err) {
      console.error("Erreur produit", err);
      setProdError("Impossible d'enregistrer. Réessaie.");
    }
  }

  function removeProduit(p) {
    // Priorité absolue : tant qu'un article Catalogue pointe vers ce produit,
    // le lien doit tenir — sinon un devis/BC/RDM/PL/BL/Facture en cours qui
    // utilise cet article perdrait silencieusement sa correspondance Stock.
    const articleLie = (articles || []).find((a) => a.produitStockId === p.id);
    if (articleLie) {
      setNotice(`Impossible de supprimer « ${p.nom} » : l'article Catalogue « ${articleLie.designation} » y est toujours relié. Supprime ou modifie cet article d'abord.`);
      return;
    }
    const lots = lotsDuProduit(p.id);
    const lotsAvecStock = lots.filter((l) => (Number(l.stockReel) || 0) > 0 || (Number(l.arrivages) || 0) > 0);
    if (lotsAvecStock.length > 0) {
      setNotice(`Impossible de supprimer « ${p.nom} » : ${lotsAvecStock.length} lot(s) ont encore du stock réel ou des arrivages en cours. Vide-les d'abord.`);
      return;
    }
    // Les lots à 0 stock et 0 arrivage n'ont plus de valeur d'inventaire —
    // on les supprime avec le produit plutôt que de laisser des lots
    // orphelins (rattachés à un produit qui n'existe plus).
    if (lots.length > 0) {
      persist((items || []).filter((it) => it.produitId !== p.id));
      archiverLots(lots, `suppression du produit « ${p.nom} »`);
    }
    persistProduits((produits || []).filter((x) => x.id !== p.id));
  }

  // Un lot se crée toujours sous un produit existant.
  function openNew() {
    setLotCategorie("");
    setLotRechercheDesignation("");
    setLotFiltreDimension("");
    setLotFiltreEpaisseur("");
    setLotFiltreGroupeCouleur("");
    setEditing({
      id: null,
      produitId: "",
      type: TYPE_TRANCHE,
      fournisseur: "",
      dimensions: "",
      epaisseur: "",
      nuance: "",
      choix: "",
      stockReel: 0,
      arrivages: 0,
      unite: "pièce(s)",
      blFournisseur: "",
    });
    setFormError("");
    setShowForm(true);
  }

  // Le choix de la catégorie restreint la liste des produits : avec des dizaines
  // de couleurs, une liste unique serait ingérable.
  function onChangeCategorieDuLot(cat) {
    setLotCategorie(cat);
    const piece = categorieEstPiece(cat);
    setEditing((prev) => ({
      ...prev,
      produitId: "",
      unite: categorieUnite(cat) || "pièce(s)",
      fournisseur: "",
      // Un article à la pièce n'a ni type chute, ni dimensions, ni épaisseur, ni nuance.
      type: TYPE_TRANCHE,
      dimensions: piece ? "" : prev.dimensions,
      epaisseur: piece ? "" : prev.epaisseur,
      nuance: "",
      choix: "",
    }));
  }

  function onChangeProduitDuLot(produitId) {
    const p = produitDe(produitId);
    // Si le produit vient du Catalogue (Tranche/Éviers), dimensions/épaisseur/
    // choix/fournisseur sont déjà connus — on les reprend directement, plus
    // la peine de les ressaisir. Une couleur ou un évier n'a qu'un seul
    // fournisseur fixe (contrairement à un consommable, qui peut varier).
    const articleLie = (articles || []).find((a) => a.produitStockId === produitId);
    setEditing((prev) => ({
      ...prev,
      produitId,
      unite: p ? categorieUnite(p.categorie) || "pièce(s)" : prev.unite,
      nuance: p && categorieNuances(p.categorie) ? prev.nuance : "",
      choix: articleLie ? (articleLie.choix || "") : p && categorieNuances(p.categorie) ? prev.choix : "",
      // Une chute garde une dimension libre (elle varie selon la découpe) —
      // seule une tranche entière reprend la dimension nominale de l'article.
      // L'épaisseur, elle, est toujours celle de l'article : une chute vient
      // forcément de la même matière brute.
      dimensions: articleLie && prev.type !== TYPE_CHUTE ? (articleLie.dimension || "") : prev.dimensions,
      epaisseur: articleLie ? (articleLie.epaisseurMatiere || "") : prev.epaisseur,
      // ERP step 11 : consommable → uniquement un fournisseur autorisé (pré-choisi s'il est seul).
      fournisseur: articleLie && articleLie.fournisseur
        ? articleLie.fournisseur
        : p && estCategorieConsommable(p.categorie)
        ? (fournisseursAutorises(p).length === 1 ? fournisseursAutorises(p)[0].fournisseur : "")
        : p && p.fournisseur ? p.fournisseur : prev.fournisseur,
    }));
  }


  // Step 11 (accord Nils du 29/09) : un lot « a de l'activité » dès qu'il a
  // un mouvement autre que sa création (ou une fusion à la création), ou une
  // réservation (quel que soit son statut). Dès lors, produit, catégorie,
  // type de lot et fournisseur sont verrouillés dans « Modifier le lot » :
  // les changer réécrirait l'historique (sorties PL, registre de crédit).
  // ---- ERP step 11 : sous-catégories de consommables ----
  function estCategorieConsommable(nomCat) {
    return !!nomCat && !estCategorieStockReservee(nomCat);
  }
  // Fournisseurs autorisés d'une sous-catégorie = ses correspondances
  // (fournisseur, nom chez le fournisseur, target price HT).
  function fournisseursAutorises(produit) {
    return ((produit && produit.correspondances) || []).filter((c) => c.fournisseur);
  }
  function targetPriceDe(produit, fournisseur) {
    const c = fournisseursAutorises(produit).find((x) => x.fournisseur === fournisseur);
    const v = c && c.targetPrice !== undefined && c.targetPrice !== "" ? Number(c.targetPrice) : produit && produit.targetPrice !== undefined && produit.targetPrice !== "" ? Number(produit.targetPrice) : NaN;
    return isFinite(v) && v > 0 ? v : null;
  }
  function ouvrirDemandeSousCat() {
    const catConso = categoriesStockDisponibles.filter((n) => estCategorieConsommable(n));
    setDemandeSousCat({ categorie: catConso[0] || "", nouvelleCategorie: "", nom: "", fournisseur: "", targetPrice: "", vitesse: "", note: "", erreur: "" });
  }
  async function envoyerDemandeSousCat() {
    const d = demandeSousCat;
    if (!d) return;
    const categorie = (d.categorie === "__nouvelle__" ? d.nouvelleCategorie : d.categorie || "").trim();
    if (!categorie || !(d.nom || "").trim()) {
      setDemandeSousCat({ ...d, erreur: "Indique la catégorie et le nom de la sous-catégorie demandée." });
      return;
    }
    const nouvelle = {
      id: uid(),
      categorie,
      nouvelleCategorie: d.categorie === "__nouvelle__",
      nom: d.nom.trim(),
      fournisseur: d.fournisseur || "",
      targetPrice: d.targetPrice || "",
      vitesse: d.vitesse || "",
      note: (d.note || "").trim(),
      demandePar: user.nom,
      demandeLe: new Date().toISOString(),
      traite: false,
    };
    await persistDemandesSousCat([...(demandesSousCat || []), nouvelle]);
    await tracerAcces("demande de sous-catégorie", `${nouvelle.categorie} › ${nouvelle.nom}${nouvelle.nouvelleCategorie ? " (nouvelle catégorie)" : ""}`);
    setDemandeSousCat(null);
    setNotice("Demande envoyée au Gérant.");
  }
  async function convertirDemandeSousCat(d) {
    if (!peutGererConsommablesEtCategories) return;
    // Nils 30/10 : une demande qui propose une nouvelle catégorie la crée (avec ses réglages) à la validation.
    if (!(categories || []).some((c) => c.name === d.categorie)) {
      const nom = String(d.categorie || "").trim();
      if (!nom) { setNotice("La demande n'indique pas de catégorie."); return; }
      if (estCategorieStockReservee(nom)) { setNotice(`« ${nom} » se gère depuis le Catalogue.`); return; }
      if (!(await demander(`La catégorie « ${nom} » n'existe pas encore.\n\nLa créer maintenant (unité : pièce(s), gestion à la pièce — modifiable ensuite dans Gérer les catégories) ?`))) return;
      const ok = await persistCategories([...(categories || []), { name: nom, unite: "pièce(s)", gestion: GESTION_PIECE, nuances: false }]);
      if (ok === false) return;
      await tracerAcces("catégorie créée (demande de sous-catégorie)", `${nom} — demande de ${d.demandePar || "?"}`);
    }
    setProdEditing({
      id: null,
      nom: d.nom,
      categorie: d.categorie,
      seuil: 0,
      fournisseur: "",
      vitesse: d.vitesse || "",
      targetPrice: d.targetPrice || "",
      correspondances: d.fournisseur ? [{ fournisseur: d.fournisseur, nomFournisseur: "", targetPrice: d.targetPrice || "" }] : [],
    });
    setProdError("");
    setDemandeSousCatEnCours(d.id);
    setShowProduit(true);
  }
  async function ignorerDemandeSousCat(id) {
    if (!peutGererConsommablesEtCategories) return;
    await persistDemandesSousCat((demandesSousCat || []).map((x) => (x.id === id ? { ...x, traite: true } : x)));
  }

  function lotADeLActivite(lotId) {
    if (!lotId) return false;
    const mvts = (mouvements || []).filter(
      (m) => m.itemId === lotId && !(m.type === "entree" && /^(Nouveau lot créé|Ajout fusionné)/.test(m.note || ""))
    );
    if (mvts.length > 0) return true;
    return (reservations || []).some((r) => r.itemId === lotId);
  }

  function openEdit(item) {
    const p = produitDe(item.produitId);
    setLotCategorie(p ? p.categorie : "");
    setLotRechercheDesignation("");
    setLotFiltreDimension("");
    setLotFiltreEpaisseur("");
    setLotFiltreGroupeCouleur("");
    setEditing({ blFournisseur: "", ...item });
    setFormError("");
    setShowForm(true);
  }

  function saveEditing(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (!editing.id && bloqueParInventaire()) return;
    if (!lotCategorie) {
      setFormError("Choisis d'abord une catégorie.");
      return;
    }
    if (!editing.produitId) {
      setFormError("Choisis le produit de ce lot.");
      return;
    }
    if (!editing.fournisseur) {
      setFormError("Choisis un fournisseur.");
      return;
    }
    // ERP step 14 (Nils 05/10 : e1) : un lot d'article importé se crée par l'arrivage (ligne par ligne).
    if (!editing.id && editing.type !== TYPE_CHUTE && articleImporte(articleDuProduit(editing.produitId))) {
      setFormError(estGerant ? "Article importé : ses lots se créent par « 📥 Arrivage » › importés (barre du Stock), ligne par ligne." : "Article importé : ses lots sont créés par le Gérant à l'arrivage.");
      return;
    }
    // Step 11 (accord Nils du 29/09) : « Modifier le lot » ne touche plus
    // jamais aux quantités. Stock réel et arrivages sont repris du lot
    // enregistré (valeur à jour, même si un PL est passé entre-temps) ;
    // toute variation passe par ⚖ Ajustement d'inventaire (justification
    // obligatoire) ou par Réceptionner. Produit / type / fournisseur sont
    // verrouillés dès que le lot a de l'activité.
    const original = editing.id ? (items || []).find((it) => it.id === editing.id) : null;
    // ERP step 11 : lot de consommable — sous-catégorie existante, fournisseur
    // autorisé, prix d'achat HT obligatoire à la création.
    const lotConso = estCategorieConsommable(lotCategorie);
    if (lotConso) {
      const prod = produitDe(editing.produitId);
      const autorises = fournisseursAutorises(prod);
      const fournisseurInchange = original && original.fournisseur === editing.fournisseur;
      if (!fournisseurInchange && !autorises.some((c) => c.fournisseur === editing.fournisseur)) {
        setFormError("Ce fournisseur n'est pas autorisé pour cette sous-catégorie.");
        return;
      }
      if (!editing.id && peutVoirPrixConso) {
        const prix = Number(editing.prixAchatHT);
        if (editing.prixAchatHT === "" || editing.prixAchatHT === undefined || !isFinite(prix) || prix <= 0) {
          setFormError("Indique le prix d'achat unitaire HT du lot.");
          return;
        }
      }
    }
    if (editing.id && !original) {
      setFormError("Ce lot n'existe plus (supprimé entre-temps). Ferme la fenêtre.");
      return;
    }
    // Nils 14/10 (k) : un lot issu d'un arrivage se change par la fiche de l'arrivage (arrivage et stock toujours identiques).
    const faEdit = original ? ficheArrivageDuLot(original) : null;
    if (faEdit && (editing.produitId !== original.produitId || editing.fournisseur !== original.fournisseur || (editing.type || TYPE_TRANCHE) !== (original.type || TYPE_TRANCHE))) {
      setFormError(`Lot de l'arrivage ${faEdit.a.numero} : change l'article ou le fournisseur dans la fiche de l'arrivage.`);
      return;
    }
    if (original && lotADeLActivite(original.id)) {
      const typeOrig = original.type || TYPE_TRANCHE;
      const typeNouv = editing.type || TYPE_TRANCHE;
      // ERP step 11 (accord Nils du 29/09) : pour un consommable, le
      // fournisseur reste modifiable (vers un fournisseur autorisé, contrôlé
      // plus haut) — il n'entre ni dans une famille couleur ni dans le registre.
      const fournisseurVerrouille = !lotConso && editing.fournisseur !== original.fournisseur;
      if (editing.produitId !== original.produitId || fournisseurVerrouille || typeNouv !== typeOrig || (editing.unite || "") !== (original.unite || "")) {
        setFormError("Ce lot a déjà des mouvements ou des réservations : produit, type de lot, fournisseur et unité ne sont plus modifiables. Crée un nouveau lot si besoin.");
        return;
      }
    }
    if (!editing.id) {
      const enStockDirect = lotConso || editing.type === TYPE_CHUTE;
      const q = Number(enStockDirect ? editing.stockReel : editing.arrivages);
      if (!isFinite(q) || q <= 0) { setFormError(enStockDirect ? "Indique la quantité." : "Indique la quantité en arrivage."); return; }
      if (!enStockDirect && !peut("stock.creerArrivage")) { setFormError("Seul le Gérant crée un arrivage (nouveau lot de tranches, éviers, accessoires)."); return; }
    }
    try {
      const clean = {
        id: editing.id || uid(),
        produitId: editing.produitId,
        type: editing.type || TYPE_TRANCHE,
        fournisseur: editing.fournisseur,
        dimensions: (editing.dimensions || "").trim(),
        epaisseur: editing.epaisseur || "",
        nuance: editing.nuance || "",
        choix: editing.choix || "",
        // Nils 28/10 : une chute se compte à la pièce.
        unite: editing.type === TYPE_CHUTE ? "pièce(s)" : editing.unite || "pièce(s)",
        stockReel: original ? Number(original.stockReel) || 0 : (lotConso || editing.type === TYPE_CHUTE) ? Number(editing.stockReel) || 0 : 0,
        arrivages: original ? Number(original.arrivages) || 0 : (lotConso || editing.type === TYPE_CHUTE) ? 0 : Number(editing.arrivages) || 0,
        blFournisseur: (editing.blFournisseur || "").trim(),
        bm: original ? original.bm || "" : "",
        ...(original && original.lotOrigineId ? { lotOrigineId: original.lotOrigineId } : {}),
      };
      // Nils 04/10 (o) : arrivage book-match — A / B prévus (facultatif), repris à la réception.
      if (!original && produitBookMatch(editing.produitId) && editing.type !== TYPE_CHUTE) {
        const pa = String(editing.arrivageA ?? "").trim(), pb = String(editing.arrivageB ?? "").trim();
        if (pa !== "") clean.arrivageA = Number(pa) || 0;
        if (pb !== "") clean.arrivageB = Number(pb) || 0;
        if ((Number(pa) || 0) + (Number(pb) || 0) > (Number(clean.arrivages) || 0)) { setFormError("A + B prévus dépassent la quantité en arrivage."); return; }
      } else if (original) {
        if (original.arrivageA !== undefined) clean.arrivageA = original.arrivageA;
        if (original.arrivageB !== undefined) clean.arrivageB = original.arrivageB;
      }
      {
        // Seuls ceux qui voient les prix de cette famille peuvent le fixer ;
        // sinon on garde l'existant (jamais effacé par quelqu'un qui ne le voit pas).
        const prixSaisi = editing.prixAchatHT === "" || editing.prixAchatHT === undefined || editing.prixAchatHT === null ? null : Number(editing.prixAchatHT);
        if (peutVoirPrixCategorie(lotCategorie)) clean.prixAchatHT = prixSaisi !== null && isFinite(prixSaisi) ? prixSaisi : null;
        else if (original && original.prixAchatHT !== undefined) clean.prixAchatHT = original.prixAchatHT;
      }
      // ERP step 14 (Nils 05/10 : c4, c6b) : lot d'un article importé → prix pré-rempli au coût
      // standard (corrigeable) ; achat local → transport d'approche facultatif (Nils seul).
      {
        const artLot = articleDuProduit(clean.produitId);
        if (!original) {
          clean.qteBase = Number(clean.stockReel) + Number(clean.arrivages);
          const std = articleImporte(artLot) && clean.type !== TYPE_CHUTE ? coutStandardLot(clean) : null;
          if (std !== null) {
            clean.coutStandardHT = std;
            if (clean.prixAchatHT === null || clean.prixAchatHT === undefined) clean.prixAchatHT = std;
          }
        }
        else if (!nombreOuZero(original.qteBase)) clean.qteBase = nombreOuZero(original.stockReel) + nombreOuZero(original.arrivages);
        if (estGerant && artLot && artLot.provenance === "Local") {
          const tr = editing.transportApprocheHT === "" || editing.transportApprocheHT === undefined || editing.transportApprocheHT === null ? null : Number(editing.transportApprocheHT);
          clean.transportApprocheHT = tr !== null && isFinite(tr) && tr > 0 ? tr : null;
        }
      }

      // À la création (jamais à l'édition), on cherche un lot strictement
      // identique — même produit, même fournisseur, et pour les tranches
      // mêmes dimensions/épaisseur/nuance/choix (seule la quantité diffère).
      // Si trouvé, on fusionne la quantité dedans plutôt que de créer un
      // doublon. L'ajout reste tout de même tracé comme un événement propre
      // dans l'historique des mouvements, même une fois fusionné.
      if (!editing.id && !articleImporte(articleDuProduit(clean.produitId))) {
        const identique = (items || []).find(
          (it) =>
            it.produitId === clean.produitId &&
            it.type === clean.type &&
            it.fournisseur === clean.fournisseur &&
            it.dimensions === clean.dimensions &&
            it.epaisseur === clean.epaisseur &&
            it.nuance === clean.nuance &&
            it.choix === clean.choix &&
            (it.bm || "") === (clean.bm || "") &&
            // ERP step 11 : un arrivage à un autre prix forme un lot distinct.
            (clean.prixAchatHT === undefined || clean.prixAchatHT === null ? it.prixAchatHT === undefined || it.prixAchatHT === null : Number(it.prixAchatHT) === Number(clean.prixAchatHT))
        );
        if (identique) {
          const fusionne = {
            ...identique,
            stockReel: (Number(identique.stockReel) || 0) + clean.stockReel,
            arrivages: (Number(identique.arrivages) || 0) + clean.arrivages,
          };
          persist(items.map((it) => (it.id === identique.id ? fusionne : it)));
          persistMouvements([
            ...(mouvements || []),
            {
              id: uid(),
              itemId: identique.id,
              type: "entree",
              quantite: clean.stockReel + clean.arrivages,
              unite: clean.unite,
              doc: "",
              date: today(),
              note: `Ajout fusionné avec le lot existant (${nomProduit(clean.produitId)}${clean.fournisseur ? " — " + clean.fournisseur : ""})`,
              pl: "",
              creeLe: new Date().toISOString(),
            },
          ]);
          setShowForm(false);
          setEditing(null);
          setFormError("");
          setNotice(`Fusionné avec un lot existant du même fournisseur — total désormais ${fusionne.stockReel} ${fusionne.unite}${fusionne.arrivages ? ` (+ ${fusionne.arrivages} en arrivage)` : ""}.`);
          return;
        }
      }

      if (lotConso && clean.prixAchatHT !== null && clean.prixAchatHT !== undefined) {
        const prodP = produitDe(clean.produitId);
        const t = targetPriceDe(prodP, clean.fournisseur);
        const prixAvant = original ? original.prixAchatHT : undefined;
        if (t !== null && clean.prixAchatHT > t * (1 + seuilEcartPrixPct() / 100) && Number(prixAvant) !== Number(clean.prixAchatHT)) {
          const pct = ((clean.prixAchatHT - t) / t) * 100;
          alerter("Prix d'achat au-dessus du target", `${nomProduit(clean.produitId)} chez ${clean.fournisseur} : ${formatHTTTC(clean.prixAchatHT)} pour un target de ${formatHTTTC(t)} (+${pct.toFixed(1).replace(".", ",")} %)`, { kind: "produit", id: clean.produitId });
        }
      }
      if (editing.id) {
        // Les champs non gérés par ce formulaire sont conservés.
        const misAJour = { ...original, ...clean };
        const CHAMPS_TRACES = [
          ["produitId", "Produit", (v) => nomProduit(v) || "—"],
          ["type", "Type", (v) => (v === TYPE_CHUTE ? "Chute" : "Tranche entière")],
          ["fournisseur", "Fournisseur", (v) => v || "—"],
          ["dimensions", "Dimensions", (v) => v || "—"],
          ["epaisseur", "Épaisseur", (v) => v || "—"],
          ["nuance", "Nuance", (v) => v || "—"],
          ["choix", "Choix", (v) => v || "—"],
          ["unite", "Unité", (v) => v || "—"],
          ["blFournisseur", "BL fournisseur", (v) => v || "—"],
          ["prixAchatHT", "Prix d'achat HT", (v) => (v === null || v === undefined || v === "" ? "—" : formatDH(v))],
        ];
        const changements = CHAMPS_TRACES.filter(([k]) => (original[k] || "") !== (misAJour[k] || "")).map(
          ([k, lib, fmt]) => `${lib} : ${fmt(original[k])} → ${fmt(misAJour[k])}`
        );
        persist(items.map((it) => (it.id === editing.id ? misAJour : it)));
        if (changements.length > 0) {
          alerter(original.fournisseur !== misAJour.fournisseur ? "Fournisseur de lot modifié" : "Lot modifié", `${nomProduit(original.produitId)}${original.fournisseur ? " — " + original.fournisseur : ""} : ${changements.join(" ; ")} (par ${user.nom})`, { kind: "produit", id: original.produitId });
          tracerAcces("modification de lot", `Lot ${nomProduit(original.produitId)}${original.fournisseur ? " — " + original.fournisseur : ""} : ${changements.join(" ; ")}`);
        }
      } else {
        persist([...items, clean]);
        persistMouvements([
          ...(mouvements || []),
          {
            id: uid(),
            itemId: clean.id,
            type: "entree",
            quantite: clean.stockReel + clean.arrivages,
            unite: clean.unite,
            doc: "",
            date: today(),
            note: `Nouveau lot créé (${nomProduit(clean.produitId)}${clean.fournisseur ? " — " + clean.fournisseur : ""})`,
            pl: "",
            creeLe: new Date().toISOString(),
          },
        ]);
      }
      setShowForm(false);
      setEditing(null);
      setFormError("");
    } catch (err) {
      console.error("Erreur enregistrement lot", err);
      setFormError("Impossible d'enregistrer. Réessaie.");
    }
  }

  // ---------- ERP step 15 (Nils 08/10) : bouton unique « 📥 Arrivage » ----------
  // Types : import (arrivages import, Nils), local (tranches / éviers / accessoires, Nils), consommables
  // (création de lots, directement en stock), matériel marketing et échantillons (entrée de stock).
  function typesArrivagePermis() {
    const t = [];
    if (estGerant) t.push(["import", "Tranches, éviers, accessoires — importés", "plusieurs lignes, coûts réels de l'import"]);
    if (peut("stock.creerArrivage")) t.push(["local", "Tranches, éviers, accessoires — achat local", "en arrivage, réception par le Production Manager"]);
    if (peutCreerLot) t.push(["conso", "Consommables", "directement en stock"]);
    if (peut("echantillons.preparer")) { t.push(["mat", "Matériel marketing", "directement en stock"]); t.push(["ech", "Échantillons", "directement en stock"]); }
    return t;
  }
  function ouvrirTypeArrivage(type) {
    setChoixArrivage(false);
    if (bloqueParInventaire()) return;
    if (type === "import") { setListeArrivages({ onglet: "traiter", recherche: "", annee: "" }); return; }
    if (type === "mat" || type === "ech") { setStockVue(type === "mat" ? "materiel" : "echantillons"); setEchTypeModal(type); setEchRechercheModal(""); setEntreeEch({ motif: "Réception fournisseur", note: "", lignes: {}, arrivage: true }); return; }
    if (type === "chute") { openNew(); setEditing((e) => ({ ...e, type: TYPE_CHUTE })); return; }
    setArrivageLots({ type, fournisseur: "", date: todayISO(), bl: "", transport: "", lignes: [{ categorie: "", produitId: "", qte: "", prix: "", nuance: "", a: "", b: "" }], erreur: "" });
  }
  function produitsArrivage(type, fournisseur, categorie) {
    return (produits || []).filter((p) => {
      if (categorie && p.categorie !== categorie) return false;
      if (type === "conso") return estCategorieConsommable(p.categorie) && (!fournisseur || fournisseursAutorises(p).some((c) => c.fournisseur === fournisseur));
      if (!estCategorieStockReservee(p.categorie)) return false;
      const a = articleDuProduit(p.id);
      if (a && articleImporte(a)) return false;
      if (a && a.fournisseur && fournisseur && normLib(a.fournisseur) !== normLib(fournisseur)) return false;
      return true;
    }).sort((x, y) => String(x.nom).localeCompare(String(y.nom), "fr"));
  }
  function categoriesArrivage(type) {
    return categoriesStockDisponibles.filter((c) => (type === "conso" ? estCategorieConsommable(c) : estCategorieStockReservee(c)));
  }
  // ---- Nils 26/10 (a-f) : stock de départ — lots créés directement en stock réel (ni arrivage, ni réception) ----
  const ligneStockDepartVide = () => ({ id: uid(), categorie: "", produitId: "", quantite: "", nuance: "", bm: "", chute: false, dimensions: "", fournisseur: "", prix: "" });
  function ouvrirStockDepart() {
    if (!peut("stock.stockDepart") || bloqueParInventaire()) return;
    setChoixArrivage(false);
    setStockDepart({ date: todayISO(), lignes: [ligneStockDepartVide()], erreur: "" });
  }
  function produitsStockDepart(categorie) {
    return trierAlpha((produits || []).filter((p) => (!categorie || p.categorie === categorie) && (estCategorieStockReservee(p.categorie) || estCategorieConsommable(p.categorie))), "nom");
  }
  const lotsStockDepart = () => (items || []).filter((it) => it.stockDepart);
  async function enregistrerStockDepart() {
    const f = stockDepart;
    if (!f || !peut("stock.stockDepart") || bloqueParInventaire()) return;
    const err = (m) => setStockDepart({ ...f, erreur: m });
    if (!f.date || f.date > todayISO()) { err("Date du stock de départ invalide (pas dans le futur)."); return; }
    const lignes = f.lignes.filter((l) => l.produitId || String(l.quantite).trim() !== "");
    if (!lignes.length) { err("Ajoute au moins une ligne."); return; }
    const nouveaux = [];
    for (const [i, l] of lignes.entries()) {
      const n = `Ligne ${i + 1}`;
      const p = produitDe(l.produitId);
      if (!p) { err(`${n} : choisis l'article.`); return; }
      const q = Number(String(l.quantite).replace(",", "."));
      if (!(q > 0)) { err(`${n} : indique la quantité.`); return; }
      const conso = estCategorieConsommable(p.categorie), piece = categorieEstPiece(p.categorie);
      if (l.chute && (conso || piece)) { err(`${n} : une chute n'existe que pour une tranche.`); return; }
      if (l.chute && !surfaceDimensions(l.dimensions)) { err(`${n} : indique les dimensions de la chute en cm (ex. 160 × 90).`); return; }
      // Nils 27/10 (b) : hors Gérant, pas de prix (il ne voit pas les prix d'achat) ; le coût standard
      // des articles importés est complété à la prochaine ouverture de l'ERP par le Gérant.
      const prix = !estGerant || String(l.prix ?? "").trim() === "" ? null : Number(String(l.prix).replace(",", "."));
      if (prix !== null && !(prix >= 0)) { err(`${n} : prix de revient invalide.`); return; }
      const art = articleDuProduit(p.id);
      const fournisseur = String(l.fournisseur || "").trim() || (art && art.fournisseur) || (conso ? ((fournisseursAutorises(p)[0] || {}).fournisseur || "") : "");
      const lot = {
        id: uid(), produitId: p.id, type: l.chute ? TYPE_CHUTE : TYPE_TRANCHE, fournisseur,
        dimensions: l.chute ? String(l.dimensions).trim() : art && !piece ? art.dimension || "" : "",
        epaisseur: art && !piece ? art.epaisseurMatiere || "" : "",
        nuance: categorieNuances(p.categorie) ? String(l.nuance || "").trim() : "", choix: art ? art.choix || "" : "",
        unite: categorieUnite(p.categorie) || "pièce(s)",
        stockReel: q, arrivages: 0, qteBase: q, blFournisseur: "", bm: !l.chute && produitBookMatch(p.id) ? l.bm || "" : "",
        stockDepart: true, stockDepartLe: f.date,
      };
      if (prix !== null) lot.prixAchatHT = prix;
      else if (estGerant && articleImporte(art) && !l.chute) { const std = coutStandardLot(lot); if (std !== null) { lot.coutStandardHT = std; lot.prixAchatHT = std; } }
      nouveaux.push(lot);
    }
    const maintenant = new Date().toISOString();
    await persist([...(items || []), ...nouveaux]);
    await persistMouvements([...(mouvements || []), ...nouveaux.map((lot) => ({ id: uid(), itemId: lot.id, type: "entree", quantite: lot.stockReel, unite: lot.unite, doc: "Stock de départ", date: f.date, note: "Stock de départ", stockDepart: true, pl: "", creeLe: maintenant }))]);
    const detailSD = `${nouveaux.length} lot(s) au ${formatDate(f.date)} : ${nouveaux.map((lot) => `${nomProduit(lot.produitId)} ${lot.stockReel}${lot.type === TYPE_CHUTE ? ` (chute ${lot.dimensions})` : ""}`).join(", ")}`;
    await tracerAcces("stock de départ", detailSD);
    // Nils 27/10 (c) : saisie par quelqu'un d'autre que le Gérant → alerte (lots sans prix).
    if (!estGerant) await alerter("Stock de départ saisi", `Par ${user.nom} — ${detailSD}. Lots sans prix : coût standard complété à ta prochaine ouverture pour les articles importés ; prix à saisir sur le lot pour les autres.`, { kind: "onglet", id: "stock" });
    setStockDepart({ date: f.date, lignes: [ligneStockDepartVide()], erreur: "" });
    setNotice(`Stock de départ : ${nouveaux.length} lot(s) créé(s) en stock.`);
  }
  async function enregistrerArrivageLots() {
    const f = arrivageLots;
    if (!f) return;
    if (f.id) return enregistrerModifArrivageLocal();
    const err = (m) => setArrivageLots({ ...f, erreur: m });
    if (bloqueParInventaire()) return;
    const local = f.type === "local";
    if (local ? !peut("stock.creerArrivage") : !peutCreerLot) return;
    if (!f.fournisseur) { err("Choisis le fournisseur."); return; }
    if (!f.date || f.date > todayISO()) { err("Date d'arrivage invalide (pas dans le futur)."); return; }
    const lignes = (f.lignes || []).filter((l) => l.produitId || String(l.qte || "").trim());
    if (!lignes.length) { err("Ajoute au moins une ligne."); return; }
    const prepares = [];
    for (const [i, l] of lignes.entries()) {
      const n = `Ligne ${i + 1}`;
      const p = produitDe(l.produitId);
      if (!p) { err(`${n} : choisis l'article.`); return; }
      const q = nombreOuZero(l.qte);
      if (!(q > 0)) { err(`${n} : indique la quantité.`); return; }
      const art = articleDuProduit(p.id);
      if (local && art && articleImporte(art)) { err(`${n} : article importé, il passe par « Tranches… importés ».`); return; }
      if (!local && !fournisseursAutorises(p).some((c) => c.fournisseur === f.fournisseur)) { err(`${n} : ${f.fournisseur} n'est pas autorisé pour ${p.nom}.`); return; }
      const voitPrix = local ? peutVoirPrixCategorie(p.categorie) : peutVoirPrixConso;
      const prix = String(l.prix ?? "").trim() === "" ? null : nombreOuZero(l.prix);
      if (!local && voitPrix && !(prix > 0)) { err(`${n} : indique le prix d'achat unitaire HT.`); return; }
      const piece = categorieEstPiece(p.categorie);
      const clean = {
        id: uid(), produitId: p.id, type: TYPE_TRANCHE, fournisseur: f.fournisseur,
        dimensions: art && !piece ? art.dimension || "" : "", epaisseur: art && !piece ? art.epaisseurMatiere || "" : "",
        nuance: categorieNuances(p.categorie) ? String(l.nuance || "").trim() : "", choix: art ? art.choix || "" : "",
        unite: categorieUnite(p.categorie) || "pièce(s)",
        stockReel: local ? 0 : q, arrivages: local ? q : 0, blFournisseur: String(f.bl || "").trim(), bm: "", qteBase: q,
      };
      if (voitPrix) clean.prixAchatHT = prix !== null && prix > 0 ? prix : null;
      if (local && produitBookMatch(p.id)) {
        const pa = String(l.a ?? "").trim(), pb = String(l.b ?? "").trim();
        if (pa !== "") clean.arrivageA = nombreOuZero(pa);
        if (pb !== "") clean.arrivageB = nombreOuZero(pb);
        if (nombreOuZero(pa) + nombreOuZero(pb) > q) { err(`${n} : A + B prévus dépassent la quantité.`); return; }
      }
      prepares.push({ clean, p, art });
    }
    if (!(await confirmerFournisseurBlackliste(f.fournisseur, "un arrivage"))) return;
    // Transport d'approche (achat local, Nils) : réparti au prorata de la valeur (à défaut, de la quantité).
    const tr = local && estGerant ? nombreOuZero(f.transport) : 0;
    if (tr > 0) {
      const poids = prepares.map((x) => (nombreOuZero(x.clean.prixAchatHT) > 0 ? nombreOuZero(x.clean.prixAchatHT) * x.clean.qteBase : 0));
      const tot = poids.reduce((a, b) => a + b, 0);
      const totQ = prepares.reduce((a, x) => a + x.clean.qteBase, 0);
      prepares.forEach((x, i) => { x.clean.transportApprocheHT = Math.round((tot > 0 ? tr * poids[i] / tot : tr * x.clean.qteBase / totQ) * 100) / 100; });
    }
    let lots = [...(items || [])];
    const mvts = [...(mouvements || [])];
    const maintenant = new Date().toISOString();
    // Nils 14/10 (d) : un achat local devient une fiche ARR-L-AAAA-NNN qui regroupe ses lignes.
    const numeroArrL = local ? await numeroDocument("ARR-L", Number(String(f.date || todayISO()).slice(0, 4))) : null;
    if (local && !numeroArrL) return;
    const ficheL = local ? { id: uid(), numero: numeroArrL, fournisseur: f.fournisseur, date: f.date, bl: String(f.bl || "").trim(), transport: tr > 0 ? tr : "", lignes: [], creeLe: maintenant, par: user.nom } : null;
    if (ficheL) prepares.forEach((x, i) => { const lid = uid(); x.clean.arrivageLocalId = ficheL.id; ficheL.lignes.push({ id: lid, produitId: x.clean.produitId, qte: x.clean.qteBase, nuance: x.clean.nuance, a: x.clean.arrivageA ?? "", b: x.clean.arrivageB ?? "", prix: x.clean.prixAchatHT ?? "", lotId: x.clean.id }); });
    const ref = `${ficheL ? `Arrivage ${ficheL.numero} — ${f.fournisseur}` : `Arrivage ${f.fournisseur}`}${f.bl ? ` — BL ${String(f.bl).trim()}` : ""}`;
    let fusions = 0;
    for (const { clean, p } of prepares) {
      // Consommables : fusion avec un lot identique (même fournisseur, même prix), comme « + Nouveau lot ».
      const identique = !local && lots.find((it) => it.produitId === clean.produitId && (it.type || TYPE_TRANCHE) === clean.type && it.fournisseur === clean.fournisseur && (it.dimensions || "") === clean.dimensions && (it.epaisseur || "") === clean.epaisseur && (it.nuance || "") === clean.nuance && (it.choix || "") === clean.choix && (it.bm || "") === "" && (clean.prixAchatHT === undefined || clean.prixAchatHT === null ? it.prixAchatHT === undefined || it.prixAchatHT === null : Number(it.prixAchatHT) === Number(clean.prixAchatHT)));
      if (identique) {
        lots = lots.map((it) => (it.id === identique.id ? { ...it, stockReel: (Number(it.stockReel) || 0) + clean.stockReel } : it));
        mvts.push({ id: uid(), itemId: identique.id, type: "entree", quantite: clean.stockReel, unite: clean.unite, doc: String(f.bl || "").trim(), date: f.date, note: `Ajout fusionné avec le lot existant — ${ref}`, pl: "", creeLe: maintenant });
        fusions++;
      } else {
        lots.push(clean);
        mvts.push({ id: uid(), itemId: clean.id, type: "entree", quantite: clean.stockReel + clean.arrivages, unite: clean.unite, doc: String(f.bl || "").trim(), date: f.date, note: `Nouveau lot créé (${nomProduit(clean.produitId)} — ${clean.fournisseur}) — ${ref}${local ? " (en arrivage)" : ""}`, pl: "", creeLe: maintenant });
      }
      if (!local && clean.prixAchatHT) {
        const t = targetPriceDe(p, clean.fournisseur);
        if (t !== null && clean.prixAchatHT > t * (1 + seuilEcartPrixPct() / 100)) await alerter("Prix d'achat au-dessus du target", `${nomProduit(clean.produitId)} chez ${clean.fournisseur} : ${formatHTTTC(clean.prixAchatHT)} pour un target de ${formatHTTTC(t)} (+${(((clean.prixAchatHT - t) / t) * 100).toFixed(1).replace(".", ",")} %)`, { kind: "produit", id: clean.produitId });
      }
    }
    await persist(lots);
    await persistMouvements(mvts);
    if (ficheL) await persistArrivagesLocaux([...(arrivagesLocaux || []), ficheL]);
    await tracerAcces("arrivage", `${local ? `Achat local ${ficheL.numero}` : "Consommables"} — ${f.fournisseur} — ${prepares.length} ligne(s)${f.bl ? ` — BL ${f.bl}` : ""}`);
    setArrivageLots(null);
    setNotice(local ? `Arrivage ${ficheL.numero} enregistré : ${prepares.length} lot(s) en arrivage, à réceptionner par la production.` : `Arrivage enregistré : ${prepares.length} ligne(s) en stock${fusions ? ` (${fusions} fusionnée(s) avec un lot existant)` : ""}.`);
  }

  // ---------- Nils 14/10 : arrivages — fiche locale, liste unifiée, modification malgré réservation, annulation de réception ----------
  // Un arrivage arrive toujours en entier : un lot est « en route » (arrivages > 0) ou « reçu ».
  function lotRecu(lot) { return !!lot && !(Number(lot.arrivages) > 0); }
  function reservationsActivesLot(lotId) { return (reservations || []).filter((r) => r.itemId === lotId && r.statut === "active"); }
  function libReservations(rs) { return rs.map((r) => `${r.bc || "sans BC"}${r.client ? ` (${r.client})` : ""} : ${r.quantite}`).join(", "); }
  function journaliserLot(lot, texte, quand) { return { ...lot, journal: [...(lot.journal || []), { le: quand || new Date().toISOString(), par: user.nom, texte }] }; }
  function ficheArrivageDuLot(lot) {
    if (!lot) return null;
    const idImp = lot.arrivageImportId, idLoc = lot.arrivageLocalId;
    if (idImp) { const a = (arrivagesImport || []).find((x) => x.id === idImp); if (a) return { type: "import", a }; }
    if (idLoc) { const a = (arrivagesLocaux || []).find((x) => x.id === idLoc); if (a) return { type: "local", a }; }
    // Le lien est d'abord cherché sur le lot, puis dans les lignes des fiches (source de vérité).
    const parLigne = (arrivagesLocaux || []).find((x) => (x.lignes || []).some((l) => l.lotId === lot.id));
    if (parLigne) return { type: "local", a: parLigne };
    const parLigneI = (arrivagesImport || []).find((x) => (x.lignes || []).some((l) => l.lotId === lot.id));
    if (parLigneI) return { type: "import", a: parLigneI };
    return null;
  }
  function etatArrivage(a, type) {
    const lots = (a.lignes || []).map((l) => (items || []).find((it) => it.id === l.lotId)).filter(Boolean);
    const recu = lots.length > 0 && lots.every(lotRecu);
    const coutsOk = type !== "import" || !!a.calculeLe;
    return { recu, coutsOk, termine: recu && coutsOk };
  }
  function ouvrirFicheArrivage(type, a) {
    if (type === "import") { if (estGerant) ouvrirArrivageImport(a); return; }
    ouvrirArrivageLocal(a);
  }
  function ouvrirArrivageLocal(a) {
    if (!peut("stock.creerArrivage")) return;
    const lignes = (a.lignes || []).map((l) => {
      const lot = (items || []).find((it) => it.id === l.lotId);
      const pid = lot ? lot.produitId : l.produitId;
      const p = produitDe(pid);
      const q = lot && !lotRecu(lot) ? lot.arrivages : l.qte;
      return { id: l.id, lotId: l.lotId || "", categorie: p ? p.categorie : "", produitId: pid, qte: String(q ?? ""), nuance: lot ? lot.nuance || "" : l.nuance || "", a: String((lot ? lot.arrivageA : l.a) ?? ""), b: String((lot ? lot.arrivageB : l.b) ?? ""), prix: String((lot ? lot.prixAchatHT : l.prix) ?? "") };
    });
    setArrivageLots({ type: "local", id: a.id, numero: a.numero, fournisseur: a.fournisseur, date: a.date, bl: a.bl || "", transport: a.transport ?? "", lignes, erreur: "" });
  }
  async function enregistrerModifArrivageLocal() {
    const f = arrivageLots;
    const fiche = (arrivagesLocaux || []).find((x) => x.id === f.id);
    if (!f || !fiche || !peut("stock.creerArrivage")) return;
    const err = (m) => setArrivageLots({ ...f, erreur: m });
    if (bloqueParInventaire()) return;
    if (!f.date || f.date > todayISO()) { err("Date d'arrivage invalide (pas dans le futur)."); return; }
    const lignes = (f.lignes || []).filter((l) => l.lotId || l.produitId || String(l.qte || "").trim());
    if (!lignes.length) { err("Un arrivage garde au moins une ligne (pour l'annuler entièrement, supprime chaque lot depuis « Réceptionner »)."); return; }
    const maintenant = new Date().toISOString();
    const avertir = [];
    const plan = [];
    for (const [i, l] of lignes.entries()) {
      const n = `Ligne ${i + 1}`;
      const lot = l.lotId ? (items || []).find((it) => it.id === l.lotId) : null;
      if (lot && lotRecu(lot)) { plan.push({ l, lot, garde: true }); continue; }
      const p = produitDe(l.produitId);
      if (!p) { err(`${n} : choisis l'article.`); return; }
      const q = nombreOuZero(l.qte);
      if (!(q > 0)) { err(`${n} : indique la quantité (pour retirer la ligne, utilise ✕).`); return; }
      const art = articleDuProduit(p.id);
      if (art && articleImporte(art)) { err(`${n} : article importé, il passe par l'arrivage import.`); return; }
      if (produitBookMatch(p.id) && nombreOuZero(l.a) + nombreOuZero(l.b) > q) { err(`${n} : A + B prévus dépassent la quantité.`); return; }
      if (lot) {
        const rs = reservationsActivesLot(lot.id);
        const res = rs.reduce((t, r) => t + nombreOuZero(r.quantite), 0);
        if (rs.length && lot.produitId !== p.id) avertir.push(`${nomProduit(lot.produitId)} → ${p.nom} : article changé alors que le lot est réservé (${libReservations(rs)}).`);
        else if (rs.length && categorieNuances(p.categorie) && (lot.nuance || "") !== String(l.nuance || "").trim()) avertir.push(`${p.nom} : nuance changée alors que le lot est réservé (${libReservations(rs)}).`);
        if (rs.length && q < res) avertir.push(`${p.nom} : ${q} prévus pour ${res} réservés (${libReservations(rs)}).`);
      }
      plan.push({ l, lot, p, art, q });
    }
    const gardes = new Set(plan.map((x) => x.lot && x.lot.id).filter(Boolean));
    const retires = (fiche.lignes || []).map((x) => (items || []).find((it) => it.id === x.lotId)).filter((lot) => lot && !gardes.has(lot.id));
    for (const lot of retires) {
      if (lotRecu(lot)) { err(`${nomProduit(lot.produitId)} est déjà reçu : la ligne ne peut pas être retirée (annule d'abord la réception).`); return; }
      const rs = reservationsActivesLot(lot.id);
      if (rs.length) { err(`${nomProduit(lot.produitId)} est réservé (${libReservations(rs)}) : déplace d'abord ces réservations avant de retirer la ligne.`); return; }
    }
    if (avertir.length && !(await demander(`Réservations concernées :\n\n${avertir.map((a) => `• ${a}`).join("\n")}\n\nLes réservations restent sur leur lot : à toi de les déplacer si besoin. Enregistrer quand même ?`))) return;
    let next = [...(items || [])];
    const mvts = [];
    const lignesFiche = [];
    const changes = [];
    for (const x of plan) {
      const { l, lot } = x;
      if (x.garde) { const old = (fiche.lignes || []).find((y) => y.lotId === lot.id) || {}; lignesFiche.push({ ...old, id: old.id || l.id || uid(), lotId: lot.id }); continue; }
      const { p, art, q } = x;
      const piece = categorieEstPiece(p.categorie);
      const voitPrix = peutVoirPrixCategorie(p.categorie);
      const prix = String(l.prix ?? "").trim() === "" ? null : nombreOuZero(l.prix);
      const bm = produitBookMatch(p.id);
      const memeProd = !!lot && lot.produitId === p.id;
      const champs = {
        produitId: p.id, dimensions: art && !piece ? art.dimension || "" : memeProd ? lot.dimensions || "" : "", epaisseur: art && !piece ? art.epaisseurMatiere || "" : memeProd ? lot.epaisseur || "" : "",
        nuance: categorieNuances(p.categorie) ? String(l.nuance || "").trim() : memeProd ? lot.nuance || "" : "", choix: art ? art.choix || "" : memeProd ? lot.choix || "" : "", unite: memeProd && lot.unite ? lot.unite : categorieUnite(p.categorie) || "pièce(s)",
        arrivages: q, qteBase: q, blFournisseur: String(f.bl || "").trim(), arrivageLocalId: fiche.id,
        ...(voitPrix ? { prixAchatHT: prix !== null && prix > 0 ? prix : null } : {}),
      };
      if (lot) {
        const diff = [];
        if (lot.produitId !== p.id) diff.push(`article ${nomProduit(lot.produitId)} → ${p.nom}`);
        if (Number(lot.arrivages) !== q) diff.push(`quantité ${lot.arrivages} → ${q}`);
        if ((lot.nuance || "") !== champs.nuance) diff.push(`nuance ${lot.nuance || "—"} → ${champs.nuance || "—"}`);
        if (voitPrix && Number(lot.prixAchatHT || 0) !== Number(champs.prixAchatHT || 0)) diff.push(`prix ${lot.prixAchatHT || "—"} → ${champs.prixAchatHT || "—"}`);
        let maj = { ...lot, ...champs };
        delete maj.arrivageA; delete maj.arrivageB;
        if (bm && String(l.a ?? "").trim() !== "") maj.arrivageA = nombreOuZero(l.a);
        if (bm && String(l.b ?? "").trim() !== "") maj.arrivageB = nombreOuZero(l.b);
        if (diff.length) { maj = journaliserLot(maj, `Arrivage ${fiche.numero} modifié : ${diff.join(" ; ")}`, maintenant); changes.push(`${p.nom} : ${diff.join(" ; ")}`); }
        next = next.map((it) => (it.id === lot.id ? maj : it));
        lignesFiche.push({ id: l.id || uid(), produitId: p.id, qte: q, nuance: champs.nuance, a: maj.arrivageA ?? "", b: maj.arrivageB ?? "", prix: champs.prixAchatHT ?? "", lotId: lot.id });
      } else {
        const nouv = { id: uid(), type: TYPE_TRANCHE, fournisseur: fiche.fournisseur, ...champs, stockReel: 0, bm: "" };
        if (bm && String(l.a ?? "").trim() !== "") nouv.arrivageA = nombreOuZero(l.a);
        if (bm && String(l.b ?? "").trim() !== "") nouv.arrivageB = nombreOuZero(l.b);
        next.push(nouv);
        mvts.push({ id: uid(), itemId: nouv.id, type: "entree", quantite: q, unite: nouv.unite, doc: nouv.blFournisseur, date: f.date, note: `Nouveau lot créé (${p.nom} — ${fiche.fournisseur}) — Arrivage ${fiche.numero} (en arrivage, ligne ajoutée)`, pl: "", creeLe: maintenant });
        lignesFiche.push({ id: l.id || uid(), produitId: p.id, qte: q, nuance: nouv.nuance, a: nouv.arrivageA ?? "", b: nouv.arrivageB ?? "", prix: nouv.prixAchatHT ?? "", lotId: nouv.id });
        changes.push(`ligne ajoutée : ${q} ${nouv.unite} ${p.nom}`);
      }
    }
    for (const lot of retires) { next = next.filter((it) => it.id !== lot.id); changes.push(`ligne retirée : ${lot.arrivages} ${lot.unite} ${nomProduit(lot.produitId)}`); }
    if (retires.length) archiverLots(retires, `ligne retirée de l'arrivage ${fiche.numero}`);
    // Transport d'approche (Nils) : réparti à nouveau sur toutes les lignes de la fiche.
    const tr = estGerant ? nombreOuZero(f.transport) : nombreOuZero(fiche.transport);
    const lotsF = lignesFiche.map((x) => next.find((it) => it.id === x.lotId)).filter(Boolean);
    if (tr > 0 || nombreOuZero(fiche.transport) > 0) {
      const poids = lotsF.map((it) => (nombreOuZero(it.prixAchatHT) > 0 ? nombreOuZero(it.prixAchatHT) * nombreOuZero(it.qteBase) : 0));
      const tot = poids.reduce((a, b) => a + b, 0), totQ = lotsF.reduce((a, it) => a + nombreOuZero(it.qteBase), 0);
      next = next.map((it) => { const k = lotsF.findIndex((x) => x.id === it.id); return k < 0 ? it : { ...it, transportApprocheHT: tr > 0 ? Math.round((tot > 0 ? tr * poids[k] / tot : tr * nombreOuZero(it.qteBase) / (totQ || 1)) * 100) / 100 : 0 }; });
    }
    const ficheMaj = { ...fiche, date: f.date, bl: String(f.bl || "").trim(), transport: tr > 0 ? tr : "", lignes: lignesFiche, modifieLe: maintenant, modifiePar: user.nom };
    await persist(next);
    if (mvts.length) await persistMouvements([...(mouvements || []), ...mvts]);
    await persistArrivagesLocaux((arrivagesLocaux || []).map((x) => (x.id === fiche.id ? ficheMaj : x)));
    await tracerAcces("arrivage local modifié", `${fiche.numero} — ${fiche.fournisseur}${changes.length ? ` — ${changes.join(" ; ")}` : ""}`);
    if (!estGerant && changes.length) await alerter("Arrivage modifié", `${fiche.numero} — ${fiche.fournisseur} : ${changes.join(" ; ")} (par ${user.nom})`, { kind: "onglet", id: "stock" });
    setArrivageLots(null);
    setNotice(`Arrivage ${fiche.numero} enregistré${changes.length ? ` : ${changes.length} changement(s)` : " (aucun changement)"}.`);
  }
  // h. Annuler une réception faite par erreur (Nils) : le stock réel repasse en arrivage, si rien n'est sorti depuis.
  function receptionAnnulable(lot) {
    if (!lot || !lotRecu(lot)) return { ok: false };
    const freres = (items || []).filter((x) => x.lotOrigineId === lot.id);
    const ids = new Set([lot.id, ...freres.map((x) => x.id)]);
    const mv = (mouvements || []).filter((m) => ids.has(m.itemId));
    const rec = mv.filter((m) => m.type === "entree" && /^Réception d'arrivage/.test(m.note || ""));
    if (!rec.length) return { ok: false, raison: "aucune réception enregistrée sur ce lot" };
    const autres = mv.filter((m) => !rec.includes(m) && !(m.type === "entree" && /^(Nouveau lot créé|Ajout fusionné)/.test(m.note || "")));
    if (autres.length) return { ok: false, raison: "des tranches sont déjà sorties ou ont bougé depuis la réception" };
    return { ok: true, rec, freres };
  }
  async function annulerReception(lot) {
    if (!estGerant || bloqueParInventaire()) return;
    const v = receptionAnnulable(lot);
    if (!v.ok) { setNotice(`Réception non annulable : ${v.raison || "lot non reçu"}.`); return; }
    const raison = await demander(`Annuler la réception de ${nomProduit(lot.produitId)} (${v.rec.reduce((t, m) => t + nombreOuZero(m.quantite), 0)} ${lot.unite}) ? Les tranches repassent en arrivage. Raison :`, { saisie: true });
    if (!raison || !String(raison).trim()) return;
    const maintenant = new Date().toISOString();
    const qDe = (id) => v.rec.filter((m) => m.itemId === id).reduce((t, m) => t + nombreOuZero(m.quantite), 0);
    const qA = v.freres.filter((x) => x.bm === "A").reduce((t, x) => t + qDe(x.id), 0), qB = v.freres.filter((x) => x.bm === "B").reduce((t, x) => t + qDe(x.id), 0);
    const total = v.rec.reduce((t, m) => t + nombreOuZero(m.quantite), 0);
    let next = (items || []).map((it) => {
      if (it.id === lot.id) {
        let maj = { ...it, stockReel: Math.max(0, Number(((Number(it.stockReel) || 0) - qDe(it.id)).toFixed(2))), arrivages: total };
        if (qA || qB || it.arrivageA !== undefined || it.arrivageB !== undefined) { maj.arrivageA = qA; maj.arrivageB = qB; }
        return journaliserLot(maj, `Réception annulée (${total} ${it.unite} repassent en arrivage) — ${String(raison).trim()}`, maintenant);
      }
      const fr = v.freres.find((x) => x.id === it.id);
      return fr ? { ...it, stockReel: Math.max(0, Number(((Number(it.stockReel) || 0) - qDe(it.id)).toFixed(2))) } : it;
    });
    // Lots A / B vides : retirés ; leurs réservations reviennent sur le lot d'origine.
    const vides = v.freres.filter((x) => !(Number((next.find((it) => it.id === x.id) || {}).stockReel) > 0));
    if (vides.length) {
      const idsV = new Set(vides.map((x) => x.id));
      next = next.filter((it) => !idsV.has(it.id));
      if ((reservations || []).some((r) => idsV.has(r.itemId))) await persistReservations((reservations || []).map((r) => (idsV.has(r.itemId) ? { ...r, itemId: lot.id } : r)));
    }
    await persist(next);
    const idsRec = new Set(v.rec.map((m) => m.id));
    await persistMouvements((mouvements || []).filter((m) => !idsRec.has(m.id)));
    const fa = ficheArrivageDuLot(lot);
    await tracerAcces("réception annulée", `${nomProduit(lot.produitId)}${fa ? ` — ${fa.a.numero}` : ""} — ${total} ${lot.unite} — ${String(raison).trim()}`);
    setNotice(`Réception annulée : ${total} ${lot.unite} de ${nomProduit(lot.produitId)} repassent en arrivage${fa ? ` (${fa.a.numero}, ligne de nouveau modifiable)` : ""}.`);
  }
  // d. Reconstitution des fiches pour les achats locaux encore en route, saisis avant les fiches (une saisie = même horodatage).
  const reconstitutionArrLocRef = useRef(false);
  useEffect(() => {
    if (loading || reconstitutionArrLocRef.current || !Array.isArray(items) || !Array.isArray(mouvements) || !Array.isArray(arrivagesLocaux)) return;
    if (!(estGerant || peut("stock.creerArrivage"))) return;
    const dejaFiche = new Set([...arrivagesLocaux, ...(arrivagesImport || [])].flatMap((a) => (a.lignes || []).map((l) => l.lotId)));
    const orphelins = items.filter((it) => Number(it.arrivages) > 0 && !it.arrivageImportId && !it.arrivageLocalId && !it.bm && !dejaFiche.has(it.id));
    const groupes = {};
    orphelins.forEach((it) => {
      const m = mouvements.find((x) => x.itemId === it.id && x.type === "entree" && /^Nouveau lot créé/.test(x.note || "") && /\(en arrivage\)/.test(x.note || ""));
      if (!m) return;
      const k = `${m.creeLe}|${it.fournisseur || ""}`;
      (groupes[k] = groupes[k] || { m, lots: [] }).lots.push(it);
    });
    const ks = Object.keys(groupes).sort();
    reconstitutionArrLocRef.current = true;
    if (!ks.length) return;
    const fiches = [];
    let liste = [...arrivagesLocaux];
    ks.forEach((k) => {
      const { m, lots } = groupes[k];
      const date = m.date || String(m.creeLe || "").slice(0, 10) || todayISO();
      const an = String(date).slice(0, 4);
      const max = [...liste, ...fiches].filter((a) => String(a.numero || "").startsWith(`ARR-L-${an}-`)).reduce((mx, a) => Math.max(mx, parseInt(String(a.numero).slice(-3), 10) || 0), 0);
      const fiche = { id: uid(), numero: `ARR-L-${an}-${String(max + 1).padStart(3, "0")}`, fournisseur: lots[0].fournisseur || "", date, bl: lots[0].blFournisseur || m.doc || "", transport: "", lignes: lots.map((it) => ({ id: uid(), produitId: it.produitId, qte: it.arrivages, nuance: it.nuance || "", a: it.arrivageA ?? "", b: it.arrivageB ?? "", prix: it.prixAchatHT ?? "", lotId: it.id })), creeLe: m.creeLe || new Date().toISOString(), par: "reconstitué", reconstitue: true };
      fiches.push(fiche);
    });
    liste = [...liste, ...fiches];
    // Le lien lot → fiche passe par les lignes de la fiche (pas de réécriture du stock au chargement).
    persistArrivagesLocaux(liste);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, items, mouvements, arrivagesLocaux]);
  function removeItem(id) {
    if (bloqueParInventaire()) return;
    const resActives = (reservations || []).filter((r) => r.itemId === id && r.statut === "active");
    if (resActives.length > 0) {
      setNotice(`Impossible de supprimer ce lot : ${resActives.length} réservation(s) active(s) dessus. Déplace-les d'abord vers un autre lot.`);
      return;
    }
    const lot = (items || []).find((it) => it.id === id);
    if (lot && (Number(lot.stockReel) || 0) > 0) {
      setNotice(`Impossible de supprimer ce lot : il a encore ${lot.stockReel} ${lot.unite} de stock réel. Fais-le sortir via "Enregistrer une consommation" avant de le supprimer — jamais en supprimant directement le lot.`);
      return;
    }
    persist(items.filter((it) => it.id !== id));
    if (lot) archiverLots([lot], "suppression du lot");
    if (lot) alerter("Suppression de lot", `Lot supprimé : ${libelleLot(lot)}${lot.fournisseur ? " — " + lot.fournisseur : ""}`, { kind: "produit", id: lot.produitId });
  }

  // ---------- Ajustement d'inventaire ----------
  // Seule façon légitime de corriger un écart de stock sans PL réel (erreur
  // de comptage, casse constatée en inventaire, etc.) — toujours avec une
  // justification obligatoire et une trace claire dans l'historique,
  // distincte d'une sortie PL normale.
  function openAjustement(item) {
    setAjustementLot(item);
    setAjustementNouvelleQte(String(item.stockReel));
    setAjustementRaison("");
    setAjustementError("");
    setAjustementPL("");
  }
  async function submitAjustement() {
    if (!ajustementLot) return;
    if (bloqueParInventaire()) return;
    const nouvelle = Number(ajustementNouvelleQte);
    if (isNaN(nouvelle) || nouvelle < 0) {
      setAjustementError("Indique une quantité valide.");
      return;
    }
    const raison = ajustementRaison.trim();
    if (!peutEcrireStock && !ajustementPL) {
      setAjustementError("Indique le PL concerné.");
      return;
    }
    if (!raison) {
      setAjustementError("Indique la raison de cet ajustement — obligatoire, puisqu'il n'y a pas de PL derrière.");
      return;
    }
    const ancienne = Number(ajustementLot.stockReel) || 0;
    const ecart = Number((nouvelle - ancienne).toFixed(2));
    if (ecart === 0) {
      setAjustementError("La quantité est identique à l'actuelle — rien à ajuster.");
      return;
    }
    const horodatage = new Date().toISOString();
    await persist((items || []).map((it) => (it.id === ajustementLot.id ? { ...it, stockReel: nouvelle } : it)));
    await persistMouvements([
      ...(mouvements || []),
      {
        id: uid(),
        itemId: ajustementLot.id,
        type: ecart > 0 ? "entree" : "sortie",
        quantite: Math.abs(ecart),
        unite: ajustementLot.unite,
        doc: "",
        date: todayISO(),
        note: `Ajustement d'inventaire (${ancienne} → ${nouvelle} ${ajustementLot.unite})${ajustementPL ? ` — PL ${ajustementPL} mal enregistré` : ""} — ${raison} — par ${user.nom}`,
        pl: "",
        plRef: ajustementPL || "",
        creeLe: horodatage,
      },
    ]);
    await alerter("Ajustement d'inventaire", `${nomProduit(ajustementLot.produitId)} : ${ancienne} → ${nouvelle} ${ajustementLot.unite}${ajustementPL ? ` — lié au PL ${ajustementPL}` : ""} — ${raison} (par ${user.nom})`, { kind: "produit", id: ajustementLot.produitId });
    setAjustementPL("");
    setNotice(`Ajustement enregistré : ${nomProduit(ajustementLot.produitId)} passe de ${ancienne} à ${nouvelle} ${ajustementLot.unite}.`);
    setAjustementLot(null);
  }

  // ---------- Réception d'un arrivage ----------
  // Fait passer tout ou partie d'un arrivage vers le stock réel. Si la
  // quantité reçue est inférieure à l'arrivage prévu, on demande
  // explicitement ce qu'il advient du reste : encore à venir (le solde
  // reste en arrivage), ou annulé (le solde disparaît, il ne viendra pas).
  function openReception(it) {
    setReceptionLot(it);
    setReceptionQuantite(String(it.arrivages));
    {
      const a = it.arrivageA !== undefined ? Number(it.arrivageA) || 0 : null, b = it.arrivageB !== undefined ? Number(it.arrivageB) || 0 : null;
      setReceptionBM({ a: a === null ? "" : String(a), b: b === null ? "" : String(b), s: a === null && b === null ? "" : String(Math.max(0, (Number(it.arrivages) || 0) - (a || 0) - (b || 0)) || "") });
      if (a !== null || b !== null) setReceptionQuantite(String((a || 0) + (b || 0) + Math.max(0, (Number(it.arrivages) || 0) - (a || 0) - (b || 0))));
    }
    setReceptionResteAnnule(false);
    setReceptionError("");
    setShowReception(true);
  }
  function confirmerReception() {
    if (bloqueParInventaire()) return;
    const it = receptionLot;
    const q = Number(receptionQuantite);
    if (!q || q <= 0) {
      setReceptionError("Indique une quantité reçue supérieure à 0.");
      return;
    }
    // Nils 03/10 (p) : Ahmed peut recevoir plus ou moins que prévu — alerte à Nils.
    // Nils 14/10 (e) : un arrivage arrive toujours en entier — réception en une fois, plus de solde en arrivage.
    const resteAvantAnnulation = 0;
    const nouvelArrivage = 0;
    // Nils 04/10 (o) : book-match — au déchargement, Ahmed répartit la réception en A / B / sans marquage ;
    // A et B vont dans des lots frères (même produit, nuance, épaisseur, fournisseur, prix).
    const estBM = produitBookMatch(it.produitId) && it.type !== TYPE_CHUTE && !it.bm;
    const qA = estBM ? Number(receptionBM.a) || 0 : 0, qB = estBM ? Number(receptionBM.b) || 0 : 0;
    const qSans = estBM ? q - qA - qB : q;
    if (estBM && (qA < 0 || qB < 0 || qSans < 0)) { setReceptionError("Quantités A / B / sans marquage invalides."); return; }
    // Nils 09/10 : A et B vendus séparément → écart avec la prévision de l'arrivage signalé à Nils.
    if (estBM && bookMatchSepare(it.produitId) && (it.arrivageA !== undefined || it.arrivageB !== undefined) && (qA !== nombreOuZero(it.arrivageA) || qB !== nombreOuZero(it.arrivageB)) && !estGerant) {
      alerter("Réception book-match différente de l'arrivage", `${nomProduit(it.produitId)}${it.nuance ? ` n${it.nuance}` : ""} : reçu A ${qA} / B ${qB}${qSans ? ` / sans marquage ${qSans}` : ""} pour A ${nombreOuZero(it.arrivageA)} / B ${nombreOuZero(it.arrivageB)} prévus (par ${user.nom})`, { kind: "produit", id: it.produitId });
    }
    const misAJour = { ...it, stockReel: (Number(it.stockReel) || 0) + qSans, arrivages: nouvelArrivage };
    let nouveauxItems = items.map((x) => (x.id === it.id ? misAJour : x));
    const entreesBM = [];
    for (const [part, qp] of [["A", qA], ["B", qB]]) {
      if (!qp) continue;
      const frere = nouveauxItems.find((x) => x.lotOrigineId === it.id && x.bm === part);
      if (frere) {
        nouveauxItems = nouveauxItems.map((x) => (x.id === frere.id ? { ...x, stockReel: (Number(x.stockReel) || 0) + qp } : x));
        entreesBM.push({ lotId: frere.id, q: qp, part });
      } else {
        const nouv = { ...it, id: uid(), bm: part, stockReel: qp, arrivages: 0, lotOrigineId: it.id };
        delete nouv.arrivageA; delete nouv.arrivageB;
        nouveauxItems = [...nouveauxItems, nouv];
        entreesBM.push({ lotId: nouv.id, q: qp, part });
      }
    }
    persist(nouveauxItems);
    // La fiche d'arrivage prend la quantité réellement reçue.
    const faRec = q !== Number(it.arrivages) ? ficheArrivageDuLot(it) : null;
    if (faRec && faRec.type === "import") persistArrivagesImport((arrivagesImport || []).map((a) => (a.id === faRec.a.id ? { ...a, lignes: (a.lignes || []).map((l) => (l.lotId === it.id ? { ...l, qte: String(q) } : l)) } : a)));
    if (faRec && faRec.type === "local") persistArrivagesLocaux((arrivagesLocaux || []).map((a) => (a.id === faRec.a.id ? { ...a, lignes: (a.lignes || []).map((l) => (l.lotId === it.id ? { ...l, qte: q } : l)) } : a)));
    const noteReste =
      resteAvantAnnulation === 0
        ? ""
        : receptionResteAnnule
        ? ` — solde de ${resteAvantAnnulation} annulé (ne viendra pas)`
        : ` — solde de ${resteAvantAnnulation} toujours en arrivage`;
    persistMouvements([
      ...(mouvements || []),
      ...(qSans > 0 || !estBM ? [{
        id: uid(),
        itemId: it.id,
        type: "entree",
        quantite: qSans,
        unite: it.unite,
        doc: "",
        date: today(),
        note: `Réception d'arrivage (${nomProduit(it.produitId)}${it.fournisseur ? " — " + it.fournisseur : ""})${estBM ? " — sans marquage A/B" : ""}${noteReste}`,
        pl: "",
        creeLe: new Date().toISOString(),
      }] : []),
      ...entreesBM.map((x) => ({
        id: uid(),
        itemId: x.lotId,
        type: "entree",
        quantite: x.q,
        unite: it.unite,
        doc: "",
        date: today(),
        note: `Réception d'arrivage (${nomProduit(it.produitId)}${it.fournisseur ? " — " + it.fournisseur : ""}) — book-match ${x.part}${noteReste}`,
        pl: "",
        creeLe: new Date().toISOString(),
      })),
    ]);
    if (q !== Number(it.arrivages) && !estGerant) {
      alerter("Réception différente de l'arrivage", `${nomProduit(it.produitId)}${it.fournisseur ? " — " + it.fournisseur : ""} : ${q} ${it.unite} reçu(s) pour ${it.arrivages} prévu(s) — l'arrivage prend la quantité reçue (par ${user.nom})`, { kind: "produit", id: it.produitId });
    }
    setShowReception(false);
    setReceptionLot(null);
    setNotice(
      `${q} ${it.unite} réceptionné(s)${estBM ? ` (A ${qA} · B ${qB} · sans marquage ${qSans})` : ` — stock réel désormais ${misAJour.stockReel}`}.` +
        (resteAvantAnnulation > 0
          ? receptionResteAnnule
            ? ` Le solde de ${resteAvantAnnulation} a été annulé.`
            : ` Le solde de ${resteAvantAnnulation} reste en arrivage.`
          : "")
    );
  }

  // Nils 10/10 (b) : annuler une consommation atelier (hors dossier) — une saisie = mouvements de même horodatage.
  async function annulerConsoAtelier(creeLe) {
    if (bloqueParInventaire()) return false;
    const mvts = (mouvements || []).filter((m) => m.atelier && m.creeLe === creeLe && m.type === "sortie");
    if (!mvts.length) { setNotice("Consommation atelier introuvable."); return false; }
    let nextItems = [...(items || [])];
    mvts.forEach((m) => { nextItems = nextItems.map((it) => (it.id === m.itemId ? { ...it, stockReel: Number(((Number(it.stockReel) || 0) + (Number(m.quantite) || 0)).toFixed(2)) } : it)); });
    await persist(nextItems);
    await persistMouvements((mouvements || []).filter((m) => !mvts.some((x) => x.id === m.id)));
    const lib = mvts.map((m) => `${m.quantite} ${m.unite} ${nomProduit(((items || []).find((it) => it.id === m.itemId) || {}).produitId)}`).join(", ");
    await tracerAcces("consommation atelier annulée", `${formatDate(String(creeLe).slice(0, 10))} — ${lib}`);
    if (!estGerant) await alerter("Consommation atelier annulée", `${formatDate(String(creeLe).slice(0, 10))} : ${lib} (par ${user.nom})`, { kind: "onglet", id: "stock" });
    setNotice(`Consommation atelier annulée : ${lib} — rendu au stock.`);
    return true;
  }
  // Nils 04/10 (o) : répartition book-match d'un lot existant (ou correction) — le stock total ne bouge pas.
  async function appliquerRepartitionBM() {
    if (bloqueParInventaire() || !repartitionBM || !peutEcrireStock) return;
    const src = (items || []).find((x) => x.id === repartitionBM.lot.id);
    if (!src) return;
    const cibles = src.bm ? [[src.bm === "A" ? "B" : "A", Number(repartitionBM.a) || 0], ["", Number(repartitionBM.s) || 0]] : [["A", Number(repartitionBM.a) || 0], ["B", Number(repartitionBM.b) || 0]];
    const total = cibles.reduce((n, [, q]) => n + q, 0);
    const dispo = (Number(src.stockReel) || 0) - reservedFor(src.id);
    if (cibles.some(([, q]) => q < 0) || total <= 0) { setRepartitionBM({ ...repartitionBM, err: "Indique au moins une quantité à déplacer." }); return; }
    if (total > dispo) { setRepartitionBM({ ...repartitionBM, err: `Seulement ${dispo} ${src.unite} disponible(s) sur ce lot (le reste est réservé).` }); return; }
    const origine = src.lotOrigineId || src.id;
    let liste = (items || []).map((x) => (x.id === src.id ? { ...x, stockReel: (Number(x.stockReel) || 0) - total } : x));
    const mvts = [];
    const horodatage = new Date().toISOString();
    const lib = (bm) => (bm ? `book-match ${bm}` : "sans marquage");
    for (const [bm, q] of cibles) {
      if (!q) continue;
      let cible = liste.find((x) => x.id !== src.id && x.produitId === src.produitId && (x.bm || "") === bm && (x.nuance || "") === (src.nuance || "") && (x.epaisseur || "") === (src.epaisseur || "") && (x.fournisseur || "") === (src.fournisseur || "") && (x.choix || "") === (src.choix || "") && (x.dimensions || "") === (src.dimensions || "") && x.type === src.type && ((x.lotOrigineId || x.id) === origine || x.id === origine));
      if (cible) liste = liste.map((x) => (x.id === cible.id ? { ...x, stockReel: (Number(x.stockReel) || 0) + q } : x));
      else {
        cible = { ...src, id: uid(), bm, stockReel: q, arrivages: 0, lotOrigineId: origine };
        delete cible.arrivageA; delete cible.arrivageB;
        liste = [...liste, cible];
      }
      const note = `Répartition book-match : ${lib(src.bm)} → ${lib(bm)}`;
      mvts.push({ id: uid(), itemId: src.id, type: "sortie", quantite: q, unite: src.unite, doc: "", date: today(), note, pl: "", repartitionBM: true, creeLe: horodatage });
      mvts.push({ id: uid(), itemId: cible.id, type: "entree", quantite: q, unite: src.unite, doc: "", date: today(), note, pl: "", repartitionBM: true, creeLe: horodatage });
    }
    await persist(liste);
    await persistMouvements([...(mouvements || []), ...mvts]);
    await tracerAcces("répartition book-match", `${nomProduit(src.produitId)}${src.nuance ? ` n${src.nuance}` : ""} — ${lib(src.bm)} : ${cibles.filter(([, q]) => q).map(([bm, q]) => `${q} → ${lib(bm)}`).join(", ")}`);
    setRepartitionBM(null);
    setNotice(`Répartition enregistrée : ${cibles.filter(([, q]) => q).map(([bm, q]) => `${q} → ${lib(bm)}`).join(", ")}.`);
  }
  // Nils 03/10 (p) : supprimer un arrivage (ne viendra pas) — alerte à Nils.
  async function supprimerArrivage() {
    if (bloqueParInventaire()) return;
    const it = receptionLot;
    if (!it || !(Number(it.arrivages) > 0)) return;
    if (!(await demander(`Supprimer l'arrivage de ${it.arrivages} ${it.unite} — ${nomProduit(it.produitId)}${it.fournisseur ? " (" + it.fournisseur + ")" : ""} ?`))) return;
    const vide = !(Number(it.stockReel) > 0) && !lotADeLActivite(it.id);
    if (vide) {
      await persist((items || []).filter((x) => x.id !== it.id));
      archiverLots([it], "arrivage supprimé");
    } else {
      await persist((items || []).map((x) => (x.id === it.id ? { ...x, arrivages: 0 } : x)));
    }
    const rsS = reservationsActivesLot(it.id);
    if (rsS.length) await demander(`Attention : ce lot était réservé (${libReservations(rsS)}). Déplace ces réservations.`, { info: true });
    const faSup = ficheArrivageDuLot(it);
    if (faSup && faSup.type === "import") await persistArrivagesImport((arrivagesImport || []).map((a) => (a.id === faSup.a.id ? { ...a, lignes: (a.lignes || []).filter((l) => l.lotId !== it.id) } : a)));
    if (faSup && faSup.type === "local") await persistArrivagesLocaux((arrivagesLocaux || []).map((a) => (a.id === faSup.a.id ? { ...a, lignes: (a.lignes || []).filter((l) => l.lotId !== it.id) } : a)));
    await tracerAcces("arrivage supprimé", `${nomProduit(it.produitId)} — ${it.arrivages} ${it.unite}${it.fournisseur ? " — " + it.fournisseur : ""}`);
    if (!estGerant) await alerter("Arrivage supprimé", `${nomProduit(it.produitId)}${it.fournisseur ? " — " + it.fournisseur : ""} : arrivage de ${it.arrivages} ${it.unite} supprimé par ${user.nom}`, { kind: "produit", id: it.produitId });
    setShowReception(false);
    setReceptionLot(null);
    setNotice(`Arrivage supprimé${vide ? " (le lot, vide, est retiré du stock)" : ""}.`);
  }

  // Libellé riche d'un lot pour les menus du PL (nuance, épaisseur, fournisseur, stock)
  function libelleLot(it) {
    const bits = [nomProduit(it.produitId)];
    if (it.type === TYPE_CHUTE) bits.push((it.planRecupereId ? "plan récupéré" : "chute") + (it.dimensions ? ` ${it.dimensions}` : ""));
    if (it.epaisseur) bits.push(it.epaisseur);
    if (it.nuance) bits.push(`n${it.nuance}`);
    if (it.bm) bits.push(it.bm);
    if (it.choix) bits.push(it.choix);
    if (it.fournisseur) bits.push(it.fournisseur);
    return `${bits.join(" · ")} — stock ${it.stockReel}`;
  }

  // Fiche d'une chute gardée sur sa sortie (sans prix : les mouvements sont lus par l'atelier).
  function ficheChute(lot) {
    const garder = ["produitId", "type", "lotSourceId", "planRecupereId", "fournisseur", "dimensions", "epaisseur", "nuance", "choix", "unite", "bm"];
    return Object.fromEntries(garder.filter((k) => lot[k] !== undefined && lot[k] !== "").map((k) => [k, lot[k]]));
  }
  // ---- Nils 01/11 : registre des plans récupérés ----
  const peutGererPlans = estGerant || user.profil === P_PROD;
  function lotDuPlan(p) {
    return p && p.lotId ? (items || []).find((it) => it.id === p.lotId) || null : null;
  }
  function sortieDuPlan(p) {
    if (!p || !p.lotId) return null;
    const ms = (mouvements || []).filter((m) => m.itemId === p.lotId && m.type === "sortie");
    return ms.length ? ms[ms.length - 1] : null;
  }
  function statutPlan(p) {
    const lot = lotDuPlan(p);
    if (lot && (Number(lot.stockReel) || 0) > 0) return { code: "stock", lib: "En stock" };
    const m = sortieDuPlan(p);
    if (!m) return { code: "sorti", lib: "Sorti du stock" };
    if (m.pl) return { code: "pl", lib: `Réutilisé — PL ${m.pl}`, date: m.date };
    if (m.recoupe) return { code: "recoupe", lib: "Recoupé en chute", date: m.date };
    return { code: "hors", lib: `Hors atelier — ${m.motifHorsAtelier || "motif non précisé"}`, date: m.date };
  }
  function libelleOriginePlan(p) {
    const ref = (p.origineRef || "").trim();
    const base = p.origineType === "SAV" ? ref || "SAV" : p.origineType === "Incident de production" ? `Incident${ref ? ` — ${ref}` : ""}` : ref ? `Autre — ${ref}` : "Autre";
    return base + (p.dossierNumero ? ` — dossier ${p.dossierNumero}` : "");
  }
  // Produits proposés : ceux des tranches (matières).
  const produitsPourPlans = (produits || []).filter((p) => familleInventaire(p.categorie) === "Tranches").sort((a, b) => String(a.nom || "").localeCompare(String(b.nom || ""), "fr"));
  function nouveauPlanRecupere(init) {
    if (!peutGererPlans) return;
    setPlanRecupEdit({ id: "", produitId: "", epaisseur: "", dimensions: "", etat: "", origineType: "", origineRef: "", dossierNumero: "", emplacement: "", note: "", fichiers: [], ...(init || {}) });
  }
  async function joindreFichiersPlan(nature, files) {
    if (!planRecupEdit) return;
    if (!window.storage || !window.storage.deposerFichier) { setNotice("Le dépôt de fichiers n'est possible qu'avec l'ERP sur son serveur."); return; }
    const element = planRecupEdit.id || uid();
    const ajouts = [];
    setDepotPlan(nature);
    try {
      for (const file of files) {
        if (!EXTENSIONS_FICHIERS.includes(extensionFichier(file.name))) { setNotice(`« ${file.name} » : type de fichier non accepté. Acceptés : ${TYPES_FICHIERS_LISIBLES}.`); continue; }
        if (file.size > TAILLE_MAX_FICHIER) { setNotice(`« ${file.name} » (${formatTaille(file.size)}) dépasse la limite de 25 Mo.`); continue; }
        const r = await window.storage.deposerFichier(null, file, { cle: PLANS_RECUPERES_KEY, element });
        if (r.erreur) { setNotice(r.erreur); continue; }
        ajouts.push({ ...r.fichier, nature, par: user.nom, le: new Date().toISOString() });
      }
    } finally {
      setDepotPlan("");
    }
    if (ajouts.length) setPlanRecupEdit((prev) => (prev ? { ...prev, id: prev.id || element, fichiers: [...(prev.fichiers || []), ...ajouts] } : prev));
  }
  async function enregistrerPlanRecupere() {
    const p = planRecupEdit;
    if (!p || !peutGererPlans) return;
    const existe = !!p.id && (plansRecuperes || []).some((x) => x.id === p.id);
    const avant = existe ? (plansRecuperes || []).find((x) => x.id === p.id) : null;
    const lotAvant = avant ? lotDuPlan(avant) : null;
    const modifiableStock = !existe || (lotAvant && (Number(lotAvant.stockReel) || 0) > 0);
    if (!p.produitId) { setNotice("Choisis le produit (matière) du plan."); return; }
    if (!surfaceDimensions(p.dimensions)) { setNotice("Indique les dimensions principales au format longueur × largeur en cm (ex. 240 × 65)."); return; }
    if (!p.etat) { setNotice("Indique l'état du plan."); return; }
    if (!p.origineType) { setNotice("Indique l'origine du plan (SAV, incident de production, autre)."); return; }
    if (p.origineType !== "Autre" && !(p.origineRef || "").trim()) { setNotice(`Indique le n° ${p.origineType === "SAV" ? "du ticket SAV" : "du PL de l'incident"}.`); return; }
    if (!existe && !(p.fichiers || []).some((f) => f.nature === "dessin")) {
      if (!(await demander("Aucun dessin joint. Le dessin de Wissam permet de savoir exactement ce que nous avons. Enregistrer quand même ? (Tu pourras l'ajouter plus tard.)"))) return;
    }
    const maintenant = new Date().toISOString();
    const id = p.id || uid();
    const fiche = {
      ...p,
      id,
      dimensions: p.dimensions.trim(),
      origineRef: (p.origineRef || "").trim(),
      dossierNumero: (p.dossierNumero || "").trim(),
      emplacement: (p.emplacement || "").trim(),
      note: (p.note || "").trim(),
      ...(existe ? { modifiePar: user.nom, modifieLe: maintenant } : { lotId: uid(), creePar: user.nom, creeParId: user.id, creeLe: maintenant }),
    };
    const okFiche = await persistPlansRecuperes(existe ? (plansRecuperes || []).map((x) => (x.id === id ? fiche : x)) : [...(plansRecuperes || []), fiche]);
    if (!okFiche) { setNotice("Enregistrement refusé ou impossible : le registre n'a pas été modifié."); return; }
    if (!existe) {
      const lot = { id: fiche.lotId, produitId: fiche.produitId, type: TYPE_CHUTE, planRecupereId: id, fournisseur: "", dimensions: fiche.dimensions, epaisseur: fiche.epaisseur || "", nuance: "", choix: "", unite: "pièce(s)", stockReel: 1, arrivages: 0 };
      await persist([...(items || []), lot]);
      await persistMouvements([...(mouvements || []), { id: uid(), itemId: lot.id, type: "entree", quantite: 1, unite: lot.unite, doc: "Plan récupéré", date: todayISO(), note: `Plan récupéré — ${libelleOriginePlan(fiche)}`, creeLe: maintenant }]);
      await tracerAcces("plan récupéré inscrit", `${nomProduit(fiche.produitId)} ${fiche.dimensions} — ${fiche.etat} — ${libelleOriginePlan(fiche)}`);
      setNotice("Plan récupéré inscrit au registre et entré en stock (0 DH).");
    } else {
      if (modifiableStock && lotAvant && (lotAvant.produitId !== fiche.produitId || lotAvant.dimensions !== fiche.dimensions || (lotAvant.epaisseur || "") !== (fiche.epaisseur || ""))) {
        await persist((items || []).map((it) => (it.id === lotAvant.id ? { ...it, produitId: fiche.produitId, dimensions: fiche.dimensions, epaisseur: fiche.epaisseur || "" } : it)));
      }
      await tracerAcces("plan récupéré modifié", `${nomProduit(fiche.produitId)} ${fiche.dimensions}`);
      setNotice("Plan récupéré enregistré.");
    }
    setPlanRecupEdit(null);
  }
  async function recouperPlanEnChutes() {
    const r = planRecoupe;
    if (!r || !peutGererPlans) return;
    const fiche = (plansRecuperes || []).find((x) => x.id === r.planId);
    const lot = fiche ? lotDuPlan(fiche) : null;
    if (!lot || !((Number(lot.stockReel) || 0) > 0)) { setNotice("Ce plan n'est plus en stock."); return; }
    const lignes = (r.lignes || []).filter((l) => (l.dimensions || "").trim() || String(l.quantite || "").trim());
    if (!lignes.length) { setNotice("Indique au moins une chute."); return; }
    const sp = surfaceDimensions(lot.dimensions);
    for (const l of lignes) {
      const sc = surfaceDimensions(l.dimensions);
      if (!sc) { setNotice("Chaque chute : dimension au format longueur × largeur en cm (ex. 120 × 60)."); return; }
      if (sp && sc > sp + 1e-9) { setNotice(`Chute ${l.dimensions.trim()} plus grande que le plan (${lot.dimensions}) : vérifie la dimension.`); return; }
      const q = Number(l.quantite);
      if (!(q >= 1) || !Number.isInteger(q)) { setNotice("Nombre de chutes : un entier, 1 ou plus."); return; }
    }
    if (!(await demander(`Recouper ce plan (${libelleLot(lot)}) en ${lignes.reduce((n, l) => n + Number(l.quantite), 0)} chute(s) ? Le plan sort du stock ; les chutes y entrent à 0 DH.`))) return;
    const date = todayISO();
    const maintenant = new Date().toISOString();
    const chutes = lignes.map((l) => ({ id: uid(), produitId: lot.produitId, type: TYPE_CHUTE, lotSourceId: lot.id, fournisseur: lot.fournisseur || "", dimensions: l.dimensions.trim(), epaisseur: lot.epaisseur || "", nuance: lot.nuance || "", choix: lot.choix || "", unite: "pièce(s)", stockReel: Number(l.quantite), arrivages: 0 }));
    const ok = await persist([...(items || []).filter((it) => it.id !== lot.id), ...chutes]);
    if (!ok) { setNotice("Recoupe refusée ou impossible : rien n'a été modifié."); return; }
    await persistMouvements([
      ...(mouvements || []),
      { id: uid(), itemId: lot.id, type: "sortie", quantite: Number(lot.stockReel) || 1, unite: lot.unite, doc: "Recoupe", date, note: "Plan récupéré recoupé en chute", recoupe: true, creeLe: maintenant },
      ...chutes.map((c) => ({ id: uid(), itemId: c.id, type: "entree", quantite: c.stockReel, unite: c.unite, doc: "Recoupe", date, note: "Chute générée — recoupe d'un plan récupéré", creeLe: maintenant })),
    ]);
    await tracerAcces("plan récupéré recoupé en chute", `${nomProduit(lot.produitId)} ${lot.dimensions} → ${chutes.map((c) => `${c.stockReel} × ${c.dimensions}`).join(", ")}`);
    setNotice(`Plan recoupé : ${chutes.length} ligne(s) de chutes entrées en stock.`);
    setPlanRecoupe(null);
  }
  async function sortirPlanHorsAtelier() {
    const h = planHorsAtelier;
    if (!h || !estGerant) return;
    const fiche = (plansRecuperes || []).find((x) => x.id === h.planId);
    const lot = fiche ? lotDuPlan(fiche) : null;
    if (!lot || !((Number(lot.stockReel) || 0) > 0)) { setNotice("Ce plan n'est plus en stock."); return; }
    if (!h.motif) { setNotice("Choisis le motif de la sortie."); return; }
    const ok = await persist((items || []).filter((it) => it.id !== lot.id));
    if (!ok) { setNotice("Sortie refusée ou impossible : rien n'a été modifié."); return; }
    const note = (h.note || "").trim();
    await persistMouvements([...(mouvements || []), { id: uid(), itemId: lot.id, type: "sortie", quantite: Number(lot.stockReel) || 1, unite: lot.unite, doc: "Hors atelier", date: todayISO(), note: `Plan récupéré — hors atelier : ${h.motif}${note ? ` (${note})` : ""}`, horsAtelier: true, motifHorsAtelier: h.motif, creeLe: new Date().toISOString() }]);
    await tracerAcces("plan récupéré sorti hors atelier", `${nomProduit(lot.produitId)} ${lot.dimensions} — ${h.motif}${note ? ` (${note})` : ""}`);
    setNotice(`Plan sorti du stock : ${h.motif}.`);
    setPlanHorsAtelier(null);
  }
  // Plans récupérés en stock pour les produits d'un dossier (proposés au PL).
  function plansDisponiblesPourDossier(commande) {
    if (!commande) return [];
    const { familles, produitsExacts } = familleEtProduitsAutorisesPL(commande);
    if (!familles.size && !produitsExacts.size) return [];
    return (plansRecuperes || []).filter((p) => {
      const lot = lotDuPlan(p);
      if (!lot || !((Number(lot.stockReel) || 0) > 0)) return false;
      const fam = clefCreditDuProduit(lot.produitId);
      return (fam && familles.has(fam)) || produitsExacts.has(lot.produitId);
    });
  }

  function selecteurVueStock(valeur) {
    return (
      <select
        className="sc-select"
        value={valeur}
        onChange={(e) => {
          const v = e.target.value;
          if (v === valeur) return;
          if (v === "__ech") { setStockVue("echantillons"); return; }
          if (v === "__mat") { setStockVue("materiel"); return; }
          if (v === "__plans") { setStockVue("plans"); return; }
          if (v === "__incidents") { setStockVue("incidents"); return; }
          setStockVue("stock");
          setFilterCat(v);
        }}
        style={{ ...selectStyle, width: "auto", minWidth: 130 }}
      >
        <option>Toutes</option>
        {categoriesStockDisponibles.map((nom) => (<option key={nom}>{nom}</option>))}
        <option value="__plans">Plans récupérés</option>
        <option value="__incidents">Incidents de production</option>
        <option value="__ech">Échantillons</option>
        <option value="__mat">Matériel marketing</option>
      </select>
    );
  }
  function renderPlansRecuperes() {
    const lien = (x) => (window.storage && window.storage.lienFichier ? window.storage.lienFichier(x.id) : null);
    const q = normLib(plansRecherche || "");
    const liste = (plansRecuperes || [])
      .map((p) => ({ p, st: statutPlan(p) }))
      .filter(({ st }) => plansFiltre === "tous" || (plansFiltre === "stock" ? st.code === "stock" : st.code !== "stock"))
      .filter(({ p }) => !q || normLib([nomProduit(p.produitId), p.dimensions, p.epaisseur, p.etat, libelleOriginePlan(p), p.emplacement, p.note].join(" ")).includes(q))
      .sort((a, b) => ((a.p.creeLe || "") < (b.p.creeLe || "") ? 1 : -1));
    const th = { padding: "6px 8px", textAlign: "left", fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, whiteSpace: "nowrap" };
    const td = { padding: "8px", verticalAlign: "top", borderTop: `1px solid ${PIERRE}` };
    const btn = { ...ghostBtnStyle, fontSize: 12, padding: "2px 0", display: "block" };
    const enStock = (plansRecuperes || []).filter((p) => statutPlan(p).code === "stock").length;
    return (
      <div>
        <div style={{ display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap", marginBottom: 12 }}>
          <FiltreChamp label="Rechercher">
            <input className="sc-input" value={plansRecherche} onChange={(e) => setPlansRecherche(e.target.value)} placeholder="Produit, dimensions, n° SAV…" style={inputStyle(230)} />
          </FiltreChamp>
          <FiltreChamp label="Catégorie">{selecteurVueStock("__plans")}</FiltreChamp>
          <FiltreChamp label="Statut">
            <select className="sc-select" value={plansFiltre} onChange={(e) => setPlansFiltre(e.target.value)} style={{ ...selectStyle, width: "auto", minWidth: 120 }}>
              <option value="stock">En stock</option>
              <option value="sortis">Sortis</option>
              <option value="tous">Tous</option>
            </select>
          </FiltreChamp>
          {peutGererPlans && (
            <button type="button" className="sc-btn" onClick={() => nouveauPlanRecupere()} style={{ ...primaryBtnStyle, marginLeft: "auto" }}>+ Inscrire un plan récupéré</button>
          )}
        </div>
        <div style={{ fontSize: 12, color: TAUPE, marginBottom: 12 }}>
          Plans de travail cassés ou erronés gardés à l'atelier ({enStock} en stock). Valeur 0 DH : leur coût est compté dans l'incident ou le SAV d'origine. Ils sortent par le PL d'un dossier, par recoupe en chute (Production, Gérant) ou hors atelier (Gérant).
        </div>
        {liste.length === 0 ? (
          <div style={{ fontSize: 13, color: TAUPE, padding: "20px 0" }}>Aucun plan récupéré{plansFiltre === "stock" ? " en stock" : ""}.</div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr>
                  <th style={th}>Inscrit le</th><th style={th}>Produit</th><th style={th}>Dimensions</th><th style={th}>État</th><th style={th}>Origine</th><th style={th}>Emplacement</th><th style={th}>Fichiers</th><th style={th}>Statut</th><th style={th}></th>
                </tr>
              </thead>
              <tbody>
                {liste.map(({ p, st }) => (
                  <tr key={p.id}>
                    <td style={td}>{p.creeLe ? formatDate(p.creeLe.slice(0, 10)) : ""}<div style={{ fontSize: 11, color: TAUPE }}>{p.creePar || ""}</div></td>
                    <td style={td}>{nomProduit(p.produitId)}{p.epaisseur ? <div style={{ fontSize: 11, color: TAUPE }}>{p.epaisseur}</div> : null}</td>
                    <td style={{ ...td, whiteSpace: "nowrap" }}>{p.dimensions}</td>
                    <td style={td}>{p.etat}</td>
                    <td style={td}>{libelleOriginePlan(p)}{p.note ? <div style={{ fontSize: 11, color: TAUPE }}>{p.note}</div> : null}</td>
                    <td style={td}>{p.emplacement || ""}</td>
                    <td style={td}>
                      {(p.fichiers || []).length === 0 && <span style={{ fontSize: 12, color: OCRE }}>Aucun</span>}
                      {(p.fichiers || []).map((f) => (
                        <div key={f.id} style={{ fontSize: 12 }}>
                          {lien(f) ? <a href={lien(f)} target="_blank" rel="noopener noreferrer" style={{ color: ENCRE }}>📎 {(NATURES_FICHIER_PLAN.find((n) => n[0] === f.nature) || [, "Fichier"])[1]}</a> : <span>📎 {f.nom}</span>}
                        </div>
                      ))}
                    </td>
                    <td style={td}><span style={{ color: st.code === "stock" ? VERT_OK : TAUPE, fontWeight: st.code === "stock" ? 600 : 400 }}>{st.lib}</span>{st.date ? <div style={{ fontSize: 11, color: TAUPE }}>{formatDate(st.date)}</div> : null}</td>
                    <td style={{ ...td, whiteSpace: "nowrap" }}>
                      {peutGererPlans && <button type="button" className="sc-btn" onClick={() => setPlanRecupEdit(JSON.parse(JSON.stringify(p)))} style={btn}>Modifier</button>}
                      {peutGererPlans && st.code === "stock" && <button type="button" className="sc-btn" onClick={() => setPlanRecoupe({ planId: p.id, lignes: [{ id: uid(), dimensions: "", quantite: "1" }] })} style={btn}>✂ Recouper en chute</button>}
                      {estGerant && st.code === "stock" && <button type="button" className="sc-btn" onClick={() => setPlanHorsAtelier({ planId: p.id, motif: "", note: "" })} style={btn}>Sortie hors atelier</button>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

      </div>
    );
  }

  // ---- Nils 01/11 : onglet « Communication » ----
  function comPourMoi(c) {
    return !!c && !c.retireLe && (!!c.tous || (Array.isArray(c.profils) && c.profils.includes(user.profil)));
  }
  function lectureCom(c, compteId) {
    return (lecturesCom || []).find((l) => l.communicationId === c.id && l.compteId === compteId && Number(l.version) === Number(c.version || 1)) || null;
  }
  // Le Gérant publie : rien « à lire » pour lui.
  const comALire = estGerant ? [] : (communications || []).filter((c) => comPourMoi(c) && !lectureCom(c, user.id)).sort((a, b) => ((a.versionLe || "") < (b.versionLe || "") ? -1 : 1));
  const comObligatoire = comALire.find((c) => c.obligatoire) || null;
  function destinatairesCom(c) {
    return utilisateurs.filter((u) => u.actif && u.profil !== P_GERANT && (c.tous || (c.profils || []).includes(u.profil)));
  }
  function tempsLectureAuto(texte) {
    const mots = String(texte || "").trim().split(/\s+/).filter(Boolean).length;
    return Math.max(1, Math.ceil(mots / 200));
  }
  // Nils 01/11 (a) : temps de lecture d'un PDF estimé d'après son nombre de pages (≈ 2 min / page),
  // lu dans le fichier au moment du dépôt ; modifiable. Nombre de pages illisible : saisie à la main.
  const MINUTES_PAR_PAGE = 2;
  async function pagesPdf(file) {
    if (extensionFichier(file.name) !== "pdf" || !file.arrayBuffer) return 0;
    try {
      const txt = new TextDecoder("latin1").decode(new Uint8Array(await file.arrayBuffer()));
      const pages = (txt.match(/\/Type\s*\/Page(?![a-zA-Z])/g) || []).length;
      const comptes = [...txt.matchAll(/\/Type\s*\/Pages[^>]*?\/Count\s+(\d+)|\/Count\s+(\d+)[^>]*?\/Type\s*\/Pages/g)].map((m) => Number(m[1] || m[2]) || 0);
      return Math.max(pages, ...comptes, 0);
    } catch (e) {
      return 0;
    }
  }
  function libTempsLecture(c) {
    const m = Number(c.minutesLecture) || 0;
    return m ? `⏱ ${m} min de lecture` : "";
  }
  async function marquerComLue(c) {
    if (!c || lectureCom(c, user.id)) return;
    await persistLecturesCom([...(lecturesCom || []), { id: uid(), communicationId: c.id, version: Number(c.version || 1), compteId: user.id, nom: user.nom, le: new Date().toISOString() }]);
  }
  function lienDocumentCom(c) {
    if (c.fichier && c.fichier.id && window.storage && window.storage.lienFichier) return window.storage.lienFichier(c.fichier.id);
    return c.lien || "";
  }
  function nouvelleCom(type) {
    if (!estGerant) return;
    setComEdit({ id: "", type, titre: "", texte: "", categorie: type === "document" ? CATEGORIES_DOCUMENTS_COM[0] : "", fichier: null, lien: "", tous: true, profils: [], minutesLecture: "", obligatoire: false, nouvelleLecture: false });
  }
  async function joindreDocumentCom(file) {
    if (!comEdit) return;
    if (!window.storage || !window.storage.deposerFichier) { setNotice("Le dépôt de fichiers n'est possible qu'avec l'ERP sur son serveur."); return; }
    if (!EXTENSIONS_FICHIERS.includes(extensionFichier(file.name))) { setNotice(`« ${file.name} » : type de fichier non accepté. Acceptés : ${TYPES_FICHIERS_LISIBLES}.`); return; }
    if (file.size > TAILLE_MAX_FICHIER) { setNotice(`« ${file.name} » (${formatTaille(file.size)}) dépasse la limite de 25 Mo.`); return; }
    const element = comEdit.id || uid();
    setDepotCom(true);
    try {
      const pages = await pagesPdf(file);
      const r = await window.storage.deposerFichier(null, file, { cle: COMMUNICATIONS_KEY, element });
      if (r.erreur) { setNotice(r.erreur); return; }
      setComEdit((prev) => (prev ? { ...prev, id: prev.id || element, fichier: { ...r.fichier, par: user.nom, le: new Date().toISOString() }, lien: "", pages, ...(pages ? { minutesLecture: String(pages * MINUTES_PAR_PAGE) } : {}) } : prev));
    } finally {
      setDepotCom(false);
    }
  }
  async function enregistrerCom() {
    const f = comEdit;
    if (!f || !estGerant) return;
    const avant = f.id ? (communications || []).find((x) => x.id === f.id) : null;
    if (!(f.titre || "").trim()) { setNotice("Indique le titre."); return; }
    if (f.type === "memo" && !(f.texte || "").trim()) { setNotice("Écris le texte du mémo."); return; }
    // Nils 01/11 : un document est toujours un fichier déposé sur le serveur (plus de lien).
    if (f.type === "document" && !f.fichier) { setNotice("Joins le document (PDF de préférence)."); return; }
    if (!f.tous && !(f.profils || []).length) { setNotice("Choisis les destinataires (tout le monde, ou au moins un profil)."); return; }
    const minutes = String(f.minutesLecture).trim() === "" ? (f.type === "memo" ? tempsLectureAuto(f.texte) : 0) : Math.round(Number(String(f.minutesLecture).replace(",", ".")));
    if (!(minutes >= 1)) { setNotice("Indique le temps de lecture (en minutes)."); return; }
    const maintenant = new Date().toISOString();
    // Nouvelle version (« à lire » à nouveau) : document remplacé, ou mémo modifié avec « demander une nouvelle lecture ».
    const docChange = avant && f.type === "document" && (avant.fichier || {}).id !== (f.fichier || {}).id;
    const nouvelleVersion = !!avant && (docChange || (f.type === "memo" && f.nouvelleLecture));
    const base = {
      id: f.id || uid(),
      type: f.type,
      titre: f.titre.trim(),
      ...(f.type === "memo" ? { texte: f.texte.trim() } : { categorie: f.categorie, fichier: f.fichier || null, lien: "" }),
      tous: !!f.tous,
      profils: f.tous ? [] : f.profils,
      minutesLecture: minutes,
      obligatoire: !!f.obligatoire,
    };
    let fiche;
    if (!avant) fiche = { ...base, version: 1, versionLe: maintenant, creePar: user.nom, creeLe: maintenant, versions: [] };
    else {
      const versions = Array.isArray(avant.versions) ? avant.versions : [];
      fiche = {
        ...avant, ...base, modifiePar: user.nom, modifieLe: maintenant,
        ...(nouvelleVersion ? { version: Number(avant.version || 1) + 1, versionLe: maintenant, versions: [...versions, { version: Number(avant.version || 1), le: avant.versionLe, ...(avant.type === "memo" ? { texte: avant.texte } : { fichier: avant.fichier || null, lien: avant.lien || "" }) }] } : {}),
      };
    }
    await persistCommunications(avant ? (communications || []).map((x) => (x.id === fiche.id ? fiche : x)) : [...(communications || []), fiche]);
    await tracerAcces(avant ? (nouvelleVersion ? "communication : nouvelle version" : "communication modifiée") : "communication publiée", `${fiche.type === "memo" ? "Mémo" : `Document (${fiche.categorie})`} « ${fiche.titre} »${nouvelleVersion ? ` — version ${fiche.version}` : ""}`);
    setNotice(!avant || nouvelleVersion ? `« ${fiche.titre} » publié : à lire pour ${destinatairesCom(fiche).length} personne(s).` : `« ${fiche.titre} » enregistré.`);
    setComEdit(null);
  }
  async function retirerCom(c) {
    if (!estGerant || !c) return;
    if (!(await demander(`Retirer « ${c.titre} » ? Plus personne ne le verra ; il reste dans « Retirés » pour toi.`))) return;
    await persistCommunications((communications || []).map((x) => (x.id === c.id ? { ...x, retireLe: new Date().toISOString(), retirePar: user.nom } : x)));
    await tracerAcces("communication retirée", `« ${c.titre} »`);
  }
  async function remettreCom(c) {
    if (!estGerant || !c) return;
    await persistCommunications((communications || []).map((x) => (x.id === c.id ? { ...x, retireLe: "", retirePar: "" } : x)));
    await tracerAcces("communication remise en ligne", `« ${c.titre} »`);
  }
  // Une communication (carte) : mémo en entier, document à ouvrir ; état de lecture.
  function renderCarteCom(c, opts) {
    const lu = estGerant ? null : lectureCom(c, user.id);
    const lien = c.type === "document" ? lienDocumentCom(c) : "";
    const dest = destinatairesCom(c);
    const lecteurs = dest.filter((u) => lectureCom(c, u.id));
    const ouvert = comLecteursOuverts === c.id;
    return (
      <div key={c.id} style={{ background: "#fff", border: `1px solid ${opts && opts.aLire ? ROUILLE : PIERRE}`, borderRadius: 10, padding: "12px 14px", marginBottom: 10 }}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap", alignItems: "baseline" }}>
          <div style={{ fontSize: 15, fontWeight: 600 }}>{c.type === "memo" ? "📝" : "📄"} {c.titre}{c.obligatoire ? <span style={{ fontSize: 11, color: ROUILLE, fontWeight: 600 }}> · lecture obligatoire</span> : null}</div>
          <div style={{ fontSize: 12, color: TAUPE }}>{libTempsLecture(c)}</div>
        </div>
        <div style={{ fontSize: 11, color: TAUPE, marginTop: 2 }}>
          {c.type === "document" ? `${c.categorie} · ` : ""}{formatDate(String(c.versionLe || c.creeLe || "").slice(0, 10))}{Number(c.version || 1) > 1 ? ` · version ${c.version}` : ""} · {c.tous ? "tout le monde" : (c.profils || []).map((pid) => (profilsAcces[pid] || {}).label || pid).join(", ")}
        </div>
        {c.type === "memo" && <div style={{ fontSize: 13, whiteSpace: "pre-wrap", marginTop: 8, lineHeight: 1.5 }}>{c.texte}</div>}
        {c.type === "document" && lien && (
          <a href={lien} target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", marginTop: 8, fontSize: 13, color: ENCRE, fontWeight: 600 }}>{c.fichier ? `📎 Ouvrir « ${c.fichier.nom} »` : "🔗 Ouvrir le document"}</a>
        )}
        <div style={{ display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap", marginTop: 10 }}>
          {!estGerant && (lu ? <span style={{ fontSize: 12, color: VERT_OK }}>✓ Lu le {formatDate(lu.le.slice(0, 10))}</span> : <button type="button" className="sc-btn" onClick={() => marquerComLue(c)} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 14px" }}>J'ai lu</button>)}
          {estGerant && <button type="button" className="sc-btn" onClick={() => setComLecteursOuverts(ouvert ? "" : c.id)} style={{ ...ghostBtnStyle, fontSize: 12, padding: 0, color: lecteurs.length < dest.length ? OCRE : VERT_OK }}>Lu par {lecteurs.length} / {dest.length} {ouvert ? "▴" : "▾"}</button>}
          {estGerant && !c.retireLe && <button type="button" className="sc-btn" onClick={() => setComEdit({ ...JSON.parse(JSON.stringify(c)), minutesLecture: String(c.minutesLecture || ""), nouvelleLecture: false })} style={{ ...ghostBtnStyle, fontSize: 12, padding: 0 }}>Modifier</button>}
          {estGerant && !c.retireLe && <button type="button" className="sc-btn" onClick={() => retirerCom(c)} style={{ ...ghostBtnStyle, fontSize: 12, padding: 0, color: ROUILLE }}>Retirer</button>}
          {estGerant && c.retireLe && <button type="button" className="sc-btn" onClick={() => remettreCom(c)} style={{ ...ghostBtnStyle, fontSize: 12, padding: 0 }}>Remettre en ligne</button>}
        </div>
        {estGerant && ouvert && (
          <div style={{ marginTop: 8, fontSize: 12, borderTop: `1px solid ${PIERRE}`, paddingTop: 6 }}>
            {dest.length === 0 && <div style={{ color: TAUPE }}>Aucun destinataire actif.</div>}
            {dest.map((u) => { const l = lectureCom(c, u.id); return (<div key={u.id} style={{ display: "flex", justifyContent: "space-between", padding: "2px 0" }}><span>{u.nom}</span><span style={{ color: l ? VERT_OK : OCRE }}>{l ? `lu le ${formatDateHeure(l.le)}` : "pas encore lu"}</span></div>); })}
            {Array.isArray(c.versions) && c.versions.length > 0 && <div style={{ color: TAUPE, marginTop: 6 }}>Versions précédentes : {c.versions.map((v) => `v${v.version} du ${formatDate(String(v.le || "").slice(0, 10))}`).join(", ")}</div>}
          </div>
        )}
      </div>
    );
  }
  function renderCommunication() {
    const visibles = (communications || []).filter((c) => (estGerant ? !c.retireLe : comPourMoi(c)));
    const idsALire = new Set(comALire.map((c) => c.id));
    const memos = visibles.filter((c) => c.type === "memo" && !idsALire.has(c.id)).sort((a, b) => ((a.versionLe || "") < (b.versionLe || "") ? 1 : -1));
    const docs = visibles.filter((c) => c.type === "document" && !idsALire.has(c.id));
    const retires = estGerant ? (communications || []).filter((c) => c.retireLe) : [];
    const titre = (t, n) => <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, margin: "18px 0 8px" }}>{t}{n !== undefined ? ` (${n})` : ""}</div>;
    return (
      <div style={{ maxWidth: 820 }}>
        {estGerant && (
          <div style={{ display: "flex", gap: 10, marginBottom: 8, flexWrap: "wrap" }}>
            <button type="button" className="sc-btn" onClick={() => nouvelleCom("memo")} style={primaryBtnStyle}>+ Mémo</button>
            <button type="button" className="sc-btn" onClick={() => nouvelleCom("document")} style={ghostBtnStyle}>+ Document</button>
          </div>
        )}
        {!visibles.length && !retires.length && <div style={{ fontSize: 13, color: TAUPE, padding: "20px 0" }}>Aucune communication pour l'instant.</div>}
        {comALire.length > 0 && (<>{titre("⚠ À lire", comALire.length)}{comALire.map((c) => renderCarteCom(c, { aLire: true }))}</>)}
        {memos.length > 0 && (<>{titre("Mémos", memos.length)}{memos.map((c) => renderCarteCom(c))}</>)}
        {docs.length > 0 && CATEGORIES_DOCUMENTS_COM.map((cat) => {
          const l = docs.filter((c) => c.categorie === cat).sort((a, b) => String(a.titre).localeCompare(String(b.titre), "fr"));
          return l.length ? <React.Fragment key={cat}>{titre(cat, l.length)}{l.map((c) => renderCarteCom(c))}</React.Fragment> : null;
        })}
        {retires.length > 0 && (
          <>
            <button type="button" className="sc-btn" onClick={() => setComRetiresVisibles(!comRetiresVisibles)} style={{ ...ghostBtnStyle, fontSize: 12, padding: 0, marginTop: 18 }}>Retirés ({retires.length}) {comRetiresVisibles ? "▴" : "▾"}</button>
            {comRetiresVisibles && <div style={{ marginTop: 8, opacity: 0.7 }}>{retires.map((c) => renderCarteCom(c))}</div>}
          </>
        )}
      </div>
    );
  }
  function renderModaleCom() {
    if (!comEdit) return null;
    const f = comEdit;
    const set = (patch) => setComEdit({ ...f, ...patch });
    const avant = f.id ? (communications || []).find((x) => x.id === f.id) : null;
    const memo = f.type === "memo";
    const auto = memo ? tempsLectureAuto(f.texte) : null;
    return (
      <Overlay onClose={() => setComEdit(null)}>
        <div style={modalStyle(640)}>
          <div style={modalTitleStyle}>{avant ? (memo ? "Modifier le mémo" : "Modifier le document") : memo ? "Nouveau mémo" : "Nouveau document"}</div>
          <Field label="Titre">
            <input className="sc-input" value={f.titre} onChange={(e) => set({ titre: e.target.value })} placeholder={memo ? "ex. Casse : photo obligatoire le jour même" : "ex. Mode d'emploi — Production"} style={inputStyle("100%")} />
          </Field>
          {memo ? (
            <Field label="Texte">
              <textarea className="sc-input" value={f.texte} onChange={(e) => set({ texte: e.target.value })} rows={8} style={{ ...inputStyle("100%"), resize: "vertical" }} />
            </Field>
          ) : (
            <>
              <Field label="Catégorie">
                <select className="sc-select" value={f.categorie} onChange={(e) => set({ categorie: e.target.value })} style={selectStyle}>
                  {CATEGORIES_DOCUMENTS_COM.map((x) => (<option key={x}>{x}</option>))}
                </select>
              </Field>
              <Field label="Document (PDF de préférence)">
                {f.fichier ? (
                  <div style={{ fontSize: 13, display: "flex", gap: 8, alignItems: "center" }}>📎 {f.fichier.nom} <span style={{ color: TAUPE }}>({formatTaille(f.fichier.taille)})</span><span title="Retirer" onClick={() => set({ fichier: null })} style={{ cursor: "pointer", color: ROUILLE }}>✕</span></div>
                ) : (
                  <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                    <label className="sc-btn" style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 0", cursor: "pointer", display: "inline-block" }}>
                      {depotCom ? "Envoi en cours…" : "📎 Joindre le fichier"}
                      <input type="file" accept={EXTENSIONS_FICHIERS.map((e) => `.${e}`).join(",")} style={{ display: "none" }} disabled={depotCom} onChange={(e) => { const fl = (e.target.files || [])[0]; e.target.value = ""; if (fl) joindreDocumentCom(fl); }} />
                    </label>
                  </div>
                )}
                {avant && <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Remplacer le fichier crée une nouvelle version : elle redevient « à lire » pour les destinataires.</div>}
              </Field>
            </>
          )}
          <Field label="Destinataires">
            <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13, cursor: "pointer", marginBottom: 6 }}>
              <input type="checkbox" checked={!!f.tous} onChange={(e) => set({ tous: e.target.checked })} /> Tout le monde
            </label>
            {!f.tous && (
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap", fontSize: 13 }}>
                {profilsListe().filter((x) => x.id !== P_GERANT).map((x) => (
                  <label key={x.id} style={{ display: "flex", gap: 6, alignItems: "center", cursor: "pointer" }}>
                    <input type="checkbox" checked={(f.profils || []).includes(x.id)} onChange={(e) => set({ profils: e.target.checked ? [...(f.profils || []), x.id] : (f.profils || []).filter((y) => y !== x.id) })} /> {x.label}
                  </label>
                ))}
              </div>
            )}
          </Field>
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "flex-end" }}>
            <Field label="Temps de lecture (minutes)" style={{ width: 200 }}>
              <input type="number" min="1" step="1" className="sc-input" value={f.minutesLecture} onChange={(e) => set({ minutesLecture: e.target.value })} placeholder={memo ? `${auto} (calculé)` : "ex. 10"} style={inputStyle("100%")} />
              {!memo && f.pages ? <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Estimé : {f.pages} page{f.pages > 1 ? "s" : ""} × {MINUTES_PAR_PAGE} min</div> : null}
              {!memo && f.fichier && !f.pages && extensionFichier(f.fichier.nom || "") === "pdf" ? <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Nombre de pages illisible : indique le temps à la main.</div> : null}
            </Field>
            <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13, cursor: "pointer", paddingBottom: 18 }}>
              <input type="checkbox" checked={!!f.obligatoire} onChange={(e) => set({ obligatoire: e.target.checked })} /> Lecture obligatoire (plein écran à l'ouverture de l'ERP)
            </label>
          </div>
          {avant && memo && (
            <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13, cursor: "pointer", marginBottom: 12 }}>
              <input type="checkbox" checked={!!f.nouvelleLecture} onChange={(e) => set({ nouvelleLecture: e.target.checked })} /> Changement important : demander une nouvelle lecture à tous
            </label>
          )}
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <button type="button" className="sc-btn" onClick={() => setComEdit(null)} style={ghostBtnStyle}>Annuler</button>
            <button type="button" className="sc-btn" onClick={enregistrerCom} disabled={depotCom} style={primaryBtnStyle}>{avant ? "Enregistrer" : "Publier"}</button>
          </div>
        </div>
      </Overlay>
    );
  }
  // Lecture obligatoire : plein écran à l'ouverture de l'ERP, jusqu'à « J'ai lu ».
  function renderComObligatoire() {
    const c = comObligatoire;
    if (!c || loading) return null;
    const lien = c.type === "document" ? lienDocumentCom(c) : "";
    return (
      <div data-fenetre="" style={{ position: "fixed", inset: 0, background: "rgba(40,30,30,0.55)", zIndex: 3000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
        <div style={{ ...modalStyle(680), maxHeight: "90vh", overflowY: "auto" }}>
          <div style={{ fontSize: 11, color: ROUILLE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 700, marginBottom: 6 }}>⚠ Lecture obligatoire{comALire.filter((x) => x.obligatoire).length > 1 ? ` — 1 sur ${comALire.filter((x) => x.obligatoire).length}` : ""}</div>
          <div style={modalTitleStyle}>{c.titre}</div>
          <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 14 }}>{libTempsLecture(c)}</div>
          {c.type === "memo" && <div style={{ fontSize: 14, whiteSpace: "pre-wrap", lineHeight: 1.55, marginBottom: 16 }}>{c.texte}</div>}
          {c.type === "document" && lien && <a href={lien} target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", fontSize: 14, color: ENCRE, fontWeight: 600, marginBottom: 16 }}>{c.fichier ? `📎 Ouvrir « ${c.fichier.nom} »` : "🔗 Ouvrir le document"}</a>}
          <div style={{ fontSize: 12, color: TAUPE, marginBottom: 12 }}>L'ERP reste bloqué tant que tu n'as pas confirmé ta lecture.</div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button type="button" className="sc-btn" onClick={() => marquerComLue(c)} style={primaryBtnStyle}>J'ai lu</button>
          </div>
        </div>
      </div>
    );
  }

  // ---- Nils 01/11 (étape c) : incidents de production ----
  const peutDeclarerIncident = estGerant || user.profil === P_PROD;
  const refPLIncident = (i) => `${i.pl}-${i.numero}`;
  function incidentsDuDossier(c) {
    return c && c.numeroPL ? (incidents || []).filter((i) => i.pl === c.numeroPL) : [];
  }
  // Libellé d'une sortie d'incident (lot encore en stock, ou chute épuisée d'après sa fiche).
  function libelleSortieIncident(m) {
    const lot = lotParId(m.itemId) || (m.lotChute ? { ...m.lotChute, id: m.itemId } : null);
    if (!lot) return `${m.quantite} × lot`;
    return `${m.quantite} × ${nomProduit(lot.produitId)}${lot.type === TYPE_CHUTE ? ` (${lot.planRecupereId ? "plan récupéré" : "chute"} ${lot.dimensions || ""})`.replace(" )", ")") : ""}`;
  }
  function sortiesIncident(i) {
    return (mouvements || []).filter((m) => m.type === "sortie" && m.incidentId === i.id);
  }
  // Coût de l'incident (Gérant : les coûts mémorisés sur les sorties ne sont envoyés qu'à lui).
  function coutIncident(i) {
    return sortiesIncident(i).reduce((n, m) => n + (Number(m.quantite) || 0) * (Number(m.coutUnitaire) || 0), 0);
  }
  // Lots proposés : tranches, chutes et plans récupérés en stock.
  const lotsPourIncident = (items || []).filter((it) => (Number(it.stockReel) || 0) > 0 && (it.type === TYPE_CHUTE || estLotTranche(it)));
  function nouvelIncident(commande) {
    if (!peutDeclarerIncident) return;
    setIncidentEdit({ id: "", pl: commande && commande.numeroPL ? commande.numeroPL : "", date: todayISO(), motif: "", description: "", fichiers: [], sorties: [{ id: uid(), lotId: "", quantite: "" }], registre: true });
  }
  async function joindrePhotosIncident(files) {
    if (!incidentEdit) return;
    if (!window.storage || !window.storage.deposerFichier) { setNotice("Le dépôt de fichiers n'est possible qu'avec l'ERP sur son serveur."); return; }
    const element = incidentEdit.id || uid();
    const ajouts = [];
    setDepotIncident(true);
    try {
      for (const file of files) {
        if (!EXTENSIONS_FICHIERS.includes(extensionFichier(file.name))) { setNotice(`« ${file.name} » : type de fichier non accepté. Acceptés : ${TYPES_FICHIERS_LISIBLES}.`); continue; }
        if (file.size > TAILLE_MAX_FICHIER) { setNotice(`« ${file.name} » (${formatTaille(file.size)}) dépasse la limite de 25 Mo.`); continue; }
        const r = await window.storage.deposerFichier(null, file, { cle: INCIDENTS_KEY, element });
        if (r.erreur) { setNotice(r.erreur); continue; }
        ajouts.push({ ...r.fichier, nature: "photo", par: user.nom, le: new Date().toISOString() });
      }
    } finally {
      setDepotIncident(false);
    }
    if (ajouts.length) setIncidentEdit((prev) => (prev ? { ...prev, id: prev.id || element, fichiers: [...(prev.fichiers || []), ...ajouts] } : prev));
  }
  async function enregistrerIncident() {
    const f = incidentEdit;
    if (!f || !peutDeclarerIncident) return;
    const existe = !!f.id && (incidents || []).some((x) => x.id === f.id);
    const commande = (commandesListe || []).find((c) => c.numeroPL && c.numeroPL === f.pl);
    if (!commande) { setNotice("Choisis le PL concerné."); return; }
    if (!f.motif) { setNotice("Choisis le motif de l'incident."); return; }
    if (!(f.description || "").trim()) { setNotice("Décris ce qui s'est passé."); return; }
    const maintenant = new Date().toISOString();
    if (existe) {
      const avant = (incidents || []).find((x) => x.id === f.id);
      if (avant.annuleLe) return;
      const maj = { ...avant, motif: f.motif, description: f.description.trim(), fichiers: f.fichiers || [], modifiePar: user.nom, modifieLe: maintenant };
      await persistIncidents((incidents || []).map((x) => (x.id === f.id ? maj : x)));
      await tracerAcces("incident de production modifié", `${maj.numero} — ${maj.pl}`);
      setNotice(`Incident ${maj.numero} enregistré.`);
      setIncidentEdit(null);
      return;
    }
    // Tranches sorties en plus : entières (comme au PL), stock suffisant.
    const lignes = (f.sorties || []).filter((l) => l.lotId || String(l.quantite || "").trim());
    const besoin = {};
    for (const l of lignes) {
      const lot = (items || []).find((it) => it.id === l.lotId);
      const q = Number(String(l.quantite).replace(",", "."));
      if (!lot) { setNotice("Chaque ligne de sortie : choisis le lot."); return; }
      if (!(q > 0) || !Number.isInteger(q)) { setNotice(`« ${libelleLot(lot)} » : quantité entière (tranches et chutes sortent en entier).`); return; }
      besoin[lot.id] = (besoin[lot.id] || 0) + q;
    }
    for (const [lotId, q] of Object.entries(besoin)) {
      const lot = (items || []).find((it) => it.id === lotId);
      if (q > (Number(lot.stockReel) || 0)) { setNotice(`Stock insuffisant sur « ${libelleLot(lot)} » : ${q} demandé, ${lot.stockReel} disponible.`); return; }
    }
    if (!(f.fichiers || []).length && !(await demander("Aucune photo jointe. Enregistrer quand même l'incident ?"))) return;
    const numero = await numeroDocument("INC", new Date().getFullYear());
    if (!numero) return;
    const id = f.id || uid();
    const fiche = { id, numero, pl: f.pl, commandeId: commande.id, date: f.date || todayISO(), motif: f.motif, description: f.description.trim(), fichiers: f.fichiers || [], creePar: user.nom, creeParId: user.id, creeLe: maintenant };
    await persistIncidents([...(incidents || []), fiche]);
    if (lignes.length) {
      const ref = refPLIncident(fiche);
      let nextItems = [...(items || [])];
      const nextMvts = [...(mouvements || [])];
      for (const l of lignes) {
        const lot = nextItems.find((it) => it.id === l.lotId);
        const q = Number(String(l.quantite).replace(",", "."));
        nextItems = nextItems.map((it) => (it.id === lot.id ? { ...it, stockReel: Number(((Number(it.stockReel) || 0) - q).toFixed(2)) } : it));
        nextMvts.push({
          id: uid(), itemId: lot.id, type: "sortie", quantite: q, unite: lot.unite, doc: ref, date: fiche.date,
          note: `Incident ${numero} (${f.motif}) — PL ${f.pl}`, pl: ref, incidentId: id, creeLe: maintenant,
          ...(lot.type === TYPE_CHUTE && (Number(lot.stockReel) || 0) - q <= 0 ? { lotChute: ficheChute(lot) } : {}),
        });
      }
      nextItems = nextItems.filter((it) => !(it.type === TYPE_CHUTE && (Number(it.stockReel) || 0) <= 0));
      await persist(nextItems);
      await persistMouvements(nextMvts);
    }
    const detail = lignes.map((l) => `${l.quantite} × ${libelleLot((items || []).find((it) => it.id === l.lotId)).split(" — ")[0]}`).join(", ");
    await alerter("Incident de production", `${numero} — PL ${f.pl}${commande.reference ? ` (${commande.reference})` : ""} : ${f.motif}. ${f.description.trim().slice(0, 200).replace(/[.!?…]?$/, ".")}${detail ? ` Sorti en plus : ${detail}.` : ""}`, { kind: "commande", id: commande.id });
    await tracerAcces("incident de production déclaré", `${numero} — PL ${f.pl} — ${f.motif}${detail ? ` — ${detail}` : ""}`);
    setIncidentEdit(null);
    setNotice(`Incident ${numero} déclaré${detail ? " ; tranches sorties sur le PL" : ""}. Le Gérant est prévenu.`);
    if (f.registre && peutGererPlans) nouveauPlanRecupere({ origineType: "Incident de production", origineRef: numero, dossierNumero: commande.numero, etat: f.motif === "Casse au transport / livraison" || f.motif === "Matière première défectueuse" ? "Cassé" : "Erroné" });
  }
  // Nils 01/11 : annulation d'un incident (Gérant seul) — tranches remises en stock (lot recréé s'il
  // était épuisé), sorties effacées ; la fiche reste, « Annulé », avec le motif ; numéro non réutilisé.
  async function annulerIncident(i) {
    if (!estGerant || !i || i.annuleLe) return;
    const sorties = sortiesIncident(i);
    let nextItems = [...(items || [])];
    for (const m of sorties) {
      const q = Number(m.quantite) || 0;
      if (nextItems.some((it) => it.id === m.itemId)) {
        nextItems = nextItems.map((it) => (it.id === m.itemId ? { ...it, stockReel: Number(((Number(it.stockReel) || 0) + q).toFixed(2)) } : it));
      } else if (m.lotChute) {
        nextItems.push({ ...m.lotChute, id: m.itemId, stockReel: q, arrivages: 0 });
      } else {
        setNotice(`Annulation impossible : un lot sorti par l'incident ${i.numero} n'existe plus dans le stock. Corrige par un ajustement d'inventaire (⚖).`);
        return;
      }
    }
    const plans = (plansRecuperes || []).filter((p) => p.origineType === "Incident de production" && p.origineRef === i.numero);
    const resume = sorties.length ? sorties.map(libelleSortieIncident).join(", ") : "aucune tranche";
    const motif = await demander(`Annuler l'incident ${i.numero} ? Remis en stock : ${resume}.${plans.length ? `\n\n${plans.length} plan(s) au registre lié(s) à cet incident : il(s) reste(nt) au registre, à vérifier.` : ""}\n\nMotif de l'annulation :`, { saisie: true });
    if (motif === null || motif === undefined || motif === false) return;
    if (!String(motif).trim()) { setNotice("Indique le motif de l'annulation."); return; }
    const ids = new Set(sorties.map((m) => m.id));
    if (sorties.length) {
      await persist(nextItems);
      await persistMouvements((mouvements || []).filter((m) => !ids.has(m.id)));
    }
    const maj = { ...i, annuleLe: new Date().toISOString(), annulePar: user.nom, motifAnnulation: String(motif).trim() };
    await persistIncidents((incidents || []).map((x) => (x.id === i.id ? maj : x)));
    await tracerAcces("incident de production annulé", `${i.numero} — PL ${i.pl} — ${maj.motifAnnulation}${sorties.length ? ` — remis en stock : ${resume}` : ""}`);
    setIncidentEdit(null);
    setNotice(`Incident ${i.numero} annulé${sorties.length ? ` ; remis en stock : ${resume}` : ""}.`);
  }
  function renderModaleIncident() {
    if (!incidentEdit) return null;
    const f = incidentEdit;
    const set = (patch) => setIncidentEdit({ ...f, ...patch });
    const existe = !!f.id && (incidents || []).some((x) => x.id === f.id);
    const avantIds = new Set((((incidents || []).find((x) => x.id === f.id) || {}).fichiers || []).map((x) => x.id));
    const lien = (x) => (window.storage && window.storage.lienFichier ? window.storage.lienFichier(x.id) : null);
    const plsPossibles = (commandesListe || []).filter((c) => c.numeroPL && (c.statut === "PL" || c.numeroPL === f.pl)).sort((a, b) => (a.numeroPL < b.numeroPL ? 1 : -1));
    const setLigne = (id, patch) => set({ sorties: f.sorties.map((l) => (l.id === id ? { ...l, ...patch } : l)) });
    const motifs = motifsSav().filter((m) => !["Mauvaise utilisation / entretien client", "Geste commercial", "Erreur de pose"].includes(m));
    return (
      <Overlay onClose={() => setIncidentEdit(null)}>
        <div style={modalStyle(640)}>
          <div style={modalTitleStyle}>{existe ? `Incident ${f.numero}${f.annuleLe ? " — annulé" : ""}` : "Déclarer un incident de production"}</div>
          {f.annuleLe && <div style={{ fontSize: 13, background: PIERRE, borderRadius: 8, padding: 10, marginBottom: 12 }}>Annulé le {formatDateHeure(f.annuleLe)} par {f.annulePar} — {f.motifAnnulation}</div>}
          <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 16 }}>
            Erreur ou casse avant la livraison. Les tranches refaites sortent sur le même PL, marquées « incident » ; rien ne change pour le client. Après la livraison, c'est un SAV.
          </div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <Field label="PL concerné" style={{ flex: 2, minWidth: 240 }}>
              <select className="sc-select" value={f.pl} disabled={existe} onChange={(e) => set({ pl: e.target.value })} style={selectStyle}>
                <option value="">— Choisir —</option>
                {plsPossibles.map((c) => (<option key={c.id} value={c.numeroPL}>{c.numeroPL} — {(clientDe(c.clientId) || {}).nom || ""}{c.reference ? ` (${c.reference})` : ""}</option>))}
              </select>
            </Field>
            <Field label="Date" style={{ flex: 1, minWidth: 140 }}>
              <input type="date" className="sc-input" value={f.date} disabled={existe} onChange={(e) => set({ date: e.target.value })} style={inputStyle("100%")} />
            </Field>
          </div>
          <Field label="Motif">
            <select className="sc-select" value={f.motif} onChange={(e) => set({ motif: e.target.value })} style={selectStyle}>
              <option value="">— Choisir —</option>
              {motifs.map((m) => (<option key={m}>{m}</option>))}
            </select>
          </Field>
          <Field label="Ce qui s'est passé">
            <textarea className="sc-input" value={f.description} onChange={(e) => set({ description: e.target.value })} rows={2} placeholder="ex. plan fissuré à la découpe de l'évier" style={{ ...inputStyle("100%"), resize: "vertical" }} />
          </Field>
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Photos</div>
            {(f.fichiers || []).map((x) => (
              <div key={x.id} style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 12, padding: "2px 0" }}>
                {lien(x) && avantIds.has(x.id) ? <a href={lien(x)} target="_blank" rel="noopener noreferrer" style={{ color: ENCRE }}>📎 {x.nom}</a> : <span>📎 {x.nom}</span>}
                <span style={{ color: TAUPE }}>({formatTaille(x.taille)})</span>
                <span title="Retirer" onClick={() => set({ fichiers: (f.fichiers || []).filter((y) => y.id !== x.id) })} style={{ cursor: "pointer", color: ROUILLE }}>✕</span>
              </div>
            ))}
            <label className="sc-btn" style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 0", cursor: "pointer", display: "inline-block" }}>
              {depotIncident ? "Envoi en cours…" : "📎 Joindre une photo"}
              <input type="file" multiple accept={EXTENSIONS_FICHIERS.map((e) => `.${e}`).join(",")} style={{ display: "none" }} disabled={depotIncident} onChange={(e) => { const fs = [...(e.target.files || [])]; e.target.value = ""; if (fs.length) joindrePhotosIncident(fs); }} />
            </label>
          </div>
          {!existe ? (
            <div style={{ background: "#F7EEEA", borderRadius: 8, padding: 12, marginBottom: 12 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                <div style={{ fontSize: 11, color: ROUILLE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 }}>Tranches sorties en plus (pour refaire)</div>
                <button type="button" className="sc-btn" onClick={() => set({ sorties: [...(f.sorties || []), { id: uid(), lotId: "", quantite: "" }] })} style={movBtnStyle}>+ Ligne</button>
              </div>
              {(f.sorties || []).map((l) => (
                <div key={l.id} style={{ display: "flex", gap: 8, marginBottom: 8, alignItems: "center" }}>
                  <select className="sc-select" value={l.lotId} onChange={(e) => setLigne(l.id, { lotId: e.target.value })} style={{ ...selectStyle, background: "#fff", flex: 2 }}>
                    <option value="">— Lot —</option>
                    {lotsPourIncident.map((it) => (<option key={it.id} value={it.id}>{libelleLot(it)}</option>))}
                  </select>
                  <input type="number" min="1" step="1" className="sc-input" value={l.quantite} onChange={(e) => setLigne(l.id, { quantite: e.target.value })} placeholder="Qté" style={{ ...inputStyle("100%"), background: "#fff", flex: 0.6 }} />
                  <button type="button" className="sc-btn" onClick={() => set({ sorties: f.sorties.filter((x) => x.id !== l.id) })} style={{ ...iconBtnStyle, background: "transparent" }} title="Retirer">✕</button>
                </div>
              ))}
              <div style={{ fontSize: 11, color: TAUPE }}>Vide si rien n'a été refait (ex. erreur rattrapée sans matière). Les sorties s'enregistrent tout de suite, sur le PL, et ne valent pas enregistrement de la matière du PL.</div>
            </div>
          ) : (
            <div style={{ fontSize: 12, marginBottom: 12 }}>
              <span style={{ color: TAUPE }}>Sorti en plus : </span>{sortiesIncident(f).length ? sortiesIncident(f).map(libelleSortieIncident).join(", ") : "rien"}
            </div>
          )}
          {!existe && peutGererPlans && (
            <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13, marginBottom: 12, cursor: "pointer" }}>
              <input type="checkbox" checked={!!f.registre} onChange={(e) => set({ registre: e.target.checked })} /> Ensuite, inscrire la pièce ratée au registre des plans récupérés
            </label>
          )}
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", flexWrap: "wrap" }}>
            {existe && estGerant && !f.annuleLe && <button type="button" className="sc-btn" onClick={() => annulerIncident((incidents || []).find((x) => x.id === f.id))} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>Annuler l'incident</button>}
            <button type="button" className="sc-btn" onClick={() => setIncidentEdit(null)} style={ghostBtnStyle}>Fermer</button>
            {!f.annuleLe && <button type="button" className="sc-btn" onClick={enregistrerIncident} disabled={depotIncident} style={primaryBtnStyle}>{existe ? "Enregistrer" : "Déclarer l'incident"}</button>}
          </div>
        </div>
      </Overlay>
    );
  }
  function renderIncidents() {
    const lien = (x) => (window.storage && window.storage.lienFichier ? window.storage.lienFichier(x.id) : null);
    const liste = [...(incidents || [])].sort((a, b) => ((a.creeLe || "") < (b.creeLe || "") ? 1 : -1));
    const th = { padding: "6px 8px", textAlign: "left", fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, whiteSpace: "nowrap" };
    const td = { padding: "8px", verticalAlign: "top", borderTop: `1px solid ${PIERRE}` };
    return (
      <div>
        <div style={{ display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap", marginBottom: 12 }}>
          <FiltreChamp label="Catégorie">{selecteurVueStock("__incidents")}</FiltreChamp>
          {peutDeclarerIncident && <button type="button" className="sc-btn" onClick={() => nouvelIncident()} style={{ ...primaryBtnStyle, marginLeft: "auto" }}>⚠ Déclarer un incident</button>}
        </div>
        <div style={{ fontSize: 12, color: TAUPE, marginBottom: 12 }}>Erreurs et casses avant livraison, déclarées sur le PL. Les tranches refaites sortent sur le PL du dossier, marquées « incident ».{estGerant ? " Coût : tranches sorties en plus (prix de revient)." : ""}</div>
        {liste.length === 0 ? (
          <div style={{ fontSize: 13, color: TAUPE, padding: "20px 0" }}>Aucun incident de production.</div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead><tr><th style={th}>N°</th><th style={th}>Date</th><th style={th}>PL / dossier</th><th style={th}>Motif</th><th style={th}>Sorti en plus</th><th style={th}>Photos</th><th style={th}>Pièce au registre</th>{estGerant && <th style={th}>Coût</th>}<th style={th}></th></tr></thead>
              <tbody>
                {liste.map((i) => {
                  const c = (commandesListe || []).find((x) => x.id === i.commandeId);
                  const plans = (plansRecuperes || []).filter((p) => p.origineType === "Incident de production" && p.origineRef === i.numero);
                  return (
                    <tr key={i.id}>
                      <td style={{ ...td, fontWeight: 600, whiteSpace: "nowrap" }}>{i.numero}{i.annuleLe && <div style={{ fontSize: 11, fontWeight: 400, color: ROUILLE }}>Annulé</div>}</td>
                      <td style={td}>{formatDate(i.date)}<div style={{ fontSize: 11, color: TAUPE }}>{i.creePar}</div></td>
                      <td style={td}>{i.pl}{c ? <div style={{ fontSize: 11, color: TAUPE }}>{(clientDe(c.clientId) || {}).nom || ""}{c.reference ? ` — ${c.reference}` : ""}</div> : null}</td>
                      <td style={td}>{i.motif}<div style={{ fontSize: 11, color: TAUPE }}>{i.description}</div></td>
                      <td style={td}>{sortiesIncident(i).map((m) => (<div key={m.id}>{libelleSortieIncident(m)}</div>))}{!sortiesIncident(i).length && <span style={{ color: TAUPE }}>—</span>}</td>
                      <td style={td}>{(i.fichiers || []).map((x) => (<div key={x.id} style={{ fontSize: 12 }}>{lien(x) ? <a href={lien(x)} target="_blank" rel="noopener noreferrer" style={{ color: ENCRE }}>📎 Photo</a> : "📎"}</div>))}{!(i.fichiers || []).length && <span style={{ fontSize: 12, color: OCRE }}>Aucune</span>}</td>
                      <td style={td}>{plans.map((p) => (<div key={p.id} style={{ fontSize: 12 }}>♻ {p.dimensions} ({statutPlan(p).lib})</div>))}{!plans.length && peutGererPlans && !i.annuleLe && <button type="button" className="sc-btn" onClick={() => nouveauPlanRecupere({ origineType: "Incident de production", origineRef: i.numero, dossierNumero: c ? c.numero : "" })} style={{ ...ghostBtnStyle, fontSize: 12, padding: 0 }}>♻ Inscrire</button>}</td>
                      {estGerant && <td style={{ ...td, whiteSpace: "nowrap" }}>{i.annuleLe ? "—" : formatDH(coutIncident(i))}</td>}
                      <td style={td}>{peutDeclarerIncident && <button type="button" className="sc-btn" onClick={() => setIncidentEdit(JSON.parse(JSON.stringify(i)))} style={{ ...ghostBtnStyle, fontSize: 12, padding: 0 }}>{i.annuleLe ? "Voir" : "Ouvrir"}</button>}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }

  // Fenêtres du registre (ouvertes depuis le Stock ou depuis un ticket SAV).
  function renderModalesPlans() {
    const lien = (x) => (window.storage && window.storage.lienFichier ? window.storage.lienFichier(x.id) : null);
    return (
      <>
        {planRecupEdit && (() => {
          const p = planRecupEdit;
          const set = (patch) => setPlanRecupEdit({ ...p, ...patch });
          const existante = (plansRecuperes || []).find((x) => x.id === p.id);
          const avantIds = new Set(((existante && existante.fichiers) || []).map((x) => x.id));
          const lotAvant = existante ? lotDuPlan(existante) : null;
          const stockFige = !!existante && !(lotAvant && (Number(lotAvant.stockReel) || 0) > 0);
          return (
            <Overlay onClose={() => setPlanRecupEdit(null)}>
              <div style={modalStyle(600)}>
                <div style={modalTitleStyle}>{existante ? "Plan récupéré" : "Inscrire un plan récupéré"}</div>
                <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 16 }}>
                  Plan cassé ou erroné rapporté à l'atelier. Joins le dessin de Wissam et une photo : on sait ainsi exactement ce que nous avons. Il entre en stock à 0 DH.
                </div>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  <Field label="Produit (matière)" style={{ flex: 2, minWidth: 220 }}>
                    <select className="sc-select" value={p.produitId} disabled={stockFige} onChange={(e) => set({ produitId: e.target.value })} style={selectStyle}>
                      <option value="">— Choisir —</option>
                      {produitsPourPlans.map((pr) => (<option key={pr.id} value={pr.id}>{pr.nom}</option>))}
                    </select>
                  </Field>
                  <Field label="Épaisseur" style={{ flex: 1, minWidth: 110 }}>
                    <select className="sc-select" value={p.epaisseur || ""} disabled={stockFige} onChange={(e) => set({ epaisseur: e.target.value })} style={selectStyle}>
                      <option value="">—</option>
                      {trierAlpha(epaisseursList || []).map((ep) => (<option key={ep}>{ep}</option>))}
                    </select>
                  </Field>
                </div>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  <Field label="Dimensions principales (cm)" style={{ flex: 1, minWidth: 180 }}>
                    <input className="sc-input" value={p.dimensions} disabled={stockFige} onChange={(e) => set({ dimensions: e.target.value })} placeholder="ex. 240 × 65" style={inputStyle("100%")} />
                  </Field>
                  <Field label="État" style={{ flex: 1, minWidth: 180 }}>
                    <select className="sc-select" value={p.etat} onChange={(e) => set({ etat: e.target.value })} style={selectStyle}>
                      <option value="">— Choisir —</option>
                      {ETATS_PLAN_RECUPERE.map((x) => (<option key={x}>{x}</option>))}
                    </select>
                  </Field>
                </div>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  <Field label="Origine" style={{ flex: 1, minWidth: 160 }}>
                    <select className="sc-select" value={p.origineType} onChange={(e) => set({ origineType: e.target.value })} style={selectStyle}>
                      <option value="">— Choisir —</option>
                      {ORIGINES_PLAN_RECUPERE.map((x) => (<option key={x}>{x}</option>))}
                    </select>
                  </Field>
                  <Field label={p.origineType === "SAV" ? "N° du ticket SAV" : p.origineType === "Incident de production" ? "N° du PL" : "Référence (facultatif)"} style={{ flex: 1, minWidth: 140 }}>
                    <input className="sc-input" list="plans-origines" value={p.origineRef} onChange={(e) => set({ origineRef: e.target.value })} placeholder={p.origineType === "SAV" ? "SAV-2026-…" : p.origineType === "Incident de production" ? "PL-2026-…" : ""} style={inputStyle("100%")} />
                    <datalist id="plans-origines">
                      {p.origineType === "SAV" && (savListe || []).map((t) => (<option key={t.id} value={t.numero} />))}
                      {p.origineType === "Incident de production" && (commandesListe || []).filter((c) => c.numeroPL).map((c) => (<option key={c.id} value={c.numeroPL} />))}
                    </datalist>
                  </Field>
                  <Field label="Dossier concerné (facultatif)" style={{ flex: 1, minWidth: 140 }}>
                    <input className="sc-input" list="plans-dossiers" value={p.dossierNumero} onChange={(e) => set({ dossierNumero: e.target.value })} placeholder="BC-2026-…" style={inputStyle("100%")} />
                    <datalist id="plans-dossiers">
                      {(commandesListe || []).map((c) => (<option key={c.id} value={c.numero} />))}
                    </datalist>
                  </Field>
                </div>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  <Field label="Emplacement à l'atelier" style={{ flex: 1, minWidth: 180 }}>
                    <input className="sc-input" value={p.emplacement} onChange={(e) => set({ emplacement: e.target.value })} placeholder="ex. Rack 3, fond de l'atelier" style={inputStyle("100%")} />
                  </Field>
                  <Field label="Remarque" style={{ flex: 2, minWidth: 220 }}>
                    <input className="sc-input" value={p.note} onChange={(e) => set({ note: e.target.value })} placeholder="ex. fissure côté évier, découpe plaque de cuisson faite" style={inputStyle("100%")} />
                  </Field>
                </div>
                {stockFige && <div style={{ fontSize: 11, color: TAUPE, marginBottom: 10 }}>Plan sorti du stock : produit, épaisseur et dimensions ne se modifient plus.</div>}
                <div style={{ marginBottom: 12 }}>
                  <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Fichiers</div>
                  {(p.fichiers || []).length === 0 && <div style={{ fontSize: 12, color: OCRE, marginBottom: 6 }}>Aucun fichier : joins au moins le dessin de Wissam.</div>}
                  {(p.fichiers || []).map((x) => (
                    <div key={x.id} style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 12, padding: "2px 0" }}>
                      <span style={{ color: TAUPE, minWidth: 52 }}>{(NATURES_FICHIER_PLAN.find((n) => n[0] === x.nature) || [, "Fichier"])[1]}</span>
                      {lien(x) && avantIds.has(x.id) ? <a href={lien(x)} target="_blank" rel="noopener noreferrer" style={{ color: ENCRE }}>📎 {x.nom}</a> : <span>📎 {x.nom}</span>}
                      <span style={{ color: TAUPE }}>({formatTaille(x.taille)})</span>
                      <span title="Retirer" onClick={() => set({ fichiers: (p.fichiers || []).filter((y) => y.id !== x.id) })} style={{ cursor: "pointer", color: ROUILLE }}>✕</span>
                    </div>
                  ))}
                  <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginTop: 4 }}>
                    {NATURES_FICHIER_PLAN.map(([nature, lib]) => (
                      <label key={nature} className="sc-btn" style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 0", cursor: "pointer", display: "inline-block" }}>
                        {depotPlan === nature ? "Envoi en cours…" : `📎 Joindre ${nature === "dessin" ? "le dessin" : nature === "photo" ? "une photo" : "un autre fichier"}`}
                        <input type="file" multiple accept={EXTENSIONS_FICHIERS.map((e) => `.${e}`).join(",")} style={{ display: "none" }} disabled={!!depotPlan} onChange={(e) => { const fs = [...(e.target.files || [])]; e.target.value = ""; if (fs.length) joindreFichiersPlan(nature, fs); }} />
                      </label>
                    ))}
                  </div>
                  {(p.fichiers || []).some((x) => !avantIds.has(x.id)) && <div style={{ fontSize: 11, color: OCRE, marginTop: 6 }}>Fichiers ajoutés : ils ne sont rattachés qu'en enregistrant.</div>}
                </div>
                <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                  <button type="button" className="sc-btn" onClick={() => setPlanRecupEdit(null)} style={ghostBtnStyle}>Annuler</button>
                  <button type="button" className="sc-btn" onClick={enregistrerPlanRecupere} disabled={!!depotPlan} style={primaryBtnStyle}>Enregistrer</button>
                </div>
              </div>
            </Overlay>
          );
        })()}

        {planRecoupe && (() => {
          const r = planRecoupe;
          const fiche = (plansRecuperes || []).find((x) => x.id === r.planId);
          const lot = fiche ? lotDuPlan(fiche) : null;
          const setLigne = (id, patch) => setPlanRecoupe({ ...r, lignes: r.lignes.map((l) => (l.id === id ? { ...l, ...patch } : l)) });
          return (
            <Overlay onClose={() => setPlanRecoupe(null)}>
              <div style={modalStyle(520)}>
                <div style={modalTitleStyle}>Recouper en chute</div>
                <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 16 }}>
                  {lot ? libelleLot(lot) : ""}. Le plan sort du stock et du registre ; chaque chute entre en stock à 0 DH, avec ce plan pour origine.
                </div>
                {r.lignes.map((l) => (
                  <div key={l.id} style={{ display: "flex", gap: 8, marginBottom: 8, alignItems: "center" }}>
                    <input className="sc-input" value={l.dimensions} onChange={(e) => setLigne(l.id, { dimensions: e.target.value })} placeholder="Dimension (ex. 120 × 60)" style={{ ...inputStyle("100%"), flex: 2 }} />
                    <input type="number" min="1" step="1" className="sc-input" value={l.quantite} onChange={(e) => setLigne(l.id, { quantite: e.target.value })} placeholder="Nb" style={{ ...inputStyle("100%"), flex: 0.6 }} />
                    <span style={{ fontSize: 11, color: TAUPE }}>pièce(s)</span>
                    {r.lignes.length > 1 && <button type="button" className="sc-btn" onClick={() => setPlanRecoupe({ ...r, lignes: r.lignes.filter((x) => x.id !== l.id) })} style={{ ...iconBtnStyle, background: "transparent" }} title="Retirer">✕</button>}
                  </div>
                ))}
                <button type="button" className="sc-btn" onClick={() => setPlanRecoupe({ ...r, lignes: [...r.lignes, { id: uid(), dimensions: "", quantite: "1" }] })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 0", marginBottom: 12 }}>+ Autre dimension</button>
                <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                  <button type="button" className="sc-btn" onClick={() => setPlanRecoupe(null)} style={ghostBtnStyle}>Annuler</button>
                  <button type="button" className="sc-btn" onClick={recouperPlanEnChutes} style={primaryBtnStyle}>Recouper</button>
                </div>
              </div>
            </Overlay>
          );
        })()}

        {planHorsAtelier && (() => {
          const h = planHorsAtelier;
          const fiche = (plansRecuperes || []).find((x) => x.id === h.planId);
          const lot = fiche ? lotDuPlan(fiche) : null;
          return (
            <Overlay onClose={() => setPlanHorsAtelier(null)}>
              <div style={modalStyle(480)}>
                <div style={modalTitleStyle}>Sortie hors atelier</div>
                <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 16 }}>{lot ? libelleLot(lot) : ""}. Le plan sort du stock ; la fiche reste au registre avec le motif.</div>
                <Field label="Motif">
                  <select className="sc-select" value={h.motif} onChange={(e) => setPlanHorsAtelier({ ...h, motif: e.target.value })} style={selectStyle}>
                    <option value="">— Choisir —</option>
                    {MOTIFS_HORS_ATELIER.map((m) => (<option key={m}>{m}</option>))}
                  </select>
                </Field>
                <Field label="Précision (facultatif)">
                  <input className="sc-input" value={h.note} onChange={(e) => setPlanHorsAtelier({ ...h, note: e.target.value })} placeholder="ex. table du showroom, donné à…" style={inputStyle("100%")} />
                </Field>
                <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                  <button type="button" className="sc-btn" onClick={() => setPlanHorsAtelier(null)} style={ghostBtnStyle}>Annuler</button>
                  <button type="button" className="sc-btn" onClick={sortirPlanHorsAtelier} style={primaryBtnStyle}>Sortir du stock</button>
                </div>
              </div>
            </Overlay>
          );
        })()}
      </>
    );
  }

  // Retrouve un PL déjà enregistré (via les mouvements) pour prévenir Ahmed
  // s'il ressaisit un numéro existant, et récupérer son client / réf.
  function plExistant(numero) {
    const n = (numero || "").trim().toLowerCase();
    if (!n) return null;
    // ERP step 11 : les consommables rattachés au PL ne comptent pas comme
    // un enregistrement du PL (Wissam peut les saisir avant ou après).
    const mvs = (mouvements || []).filter((m) => (m.pl || "").trim().toLowerCase() === n && !estMouvementConsommable(m));
    if (mvs.length === 0) return null;
    // le client est stocké dans la note "PL <client>"
    const avecClient = mvs.find((m) => m.note && m.note.startsWith("PL "));
    const client = avecClient ? avecClient.note.replace(/^PL\s+/, "").replace(/^Chute générée — PL\s+/, "") : "";
    return { count: mvs.length, client, date: mvs[0].date };
  }


  // Défait un PL : rend aux lots consommés leur quantité, retire les chutes
  // qu'il a générées, et efface ses mouvements de l'historique.
  // ERP step 9 : plus de distinction "PL exo" — un PL exo s'enregistre et
  // s'annule exactement comme un PL normal (il n'a jamais touché le
  // registre de crédit à l'enregistrement, donc rien à restituer pour lui).
  // Nils 03/10 (q) : n'importe quel PL (plus seulement le dernier), et au choix
  // la matière (articles du catalogue), les consommables de production, de pose.
  // Matière et production : pas après le BL. Pose : jusqu'à la facture.
  async function annulerPL(plNumero, opts) {
    if (bloqueParInventaire()) return false;
    const o = opts || { matiere: true, prod: true, pose: true };
    {
      const dossierPL = dossierDuPL(plNumero);
      const st = dossierPL ? dossierPL.statut : "";
      if (st === "Facture" || ((o.matiere || o.prod) && st === "BL")) {
        setNotice(`Impossible d'annuler ${o.matiere || o.prod ? "la matière ou les consommables de production de" : "les consommables de pose de"} « ${plNumero} » : le dossier est déjà en ${st === "Facture" ? "Facture (figé)" : "BL (marchandise livrée)"}. Utilise un ajustement d'inventaire (⚖) qui cite le PL.`);
        return false;
      }
    }
    if (!o.matiere) {
      const consos = (mouvements || []).filter((m) => m.pl === plNumero && estMouvementConsommable(m) && ((o.prod && usageConsommable(m) === "production") || (o.pose && usageConsommable(m) === "pose")));
      if (consos.length === 0) { setNotice(`Rien à annuler sur « ${plNumero} ».`); return false; }
      let nextItems = [...(items || [])];
      consos.forEach((m) => { nextItems = nextItems.map((it) => (it.id === m.itemId ? { ...it, stockReel: Number((it.stockReel + (Number(m.quantite) || 0)).toFixed(2)) } : it)); });
      const ids = new Set(consos.map((m) => m.id));
      await persist(nextItems);
      await persistMouvements((mouvements || []).filter((m) => !ids.has(m.id)));
      const quoi = [o.prod ? "production" : "", o.pose ? "pose" : ""].filter(Boolean).join(" et ");
      await tracerAcces("consommables du PL annulés", `${plNumero} : consommables de ${quoi} (${consos.length} ligne(s)) rendus au stock`);
      const dPL = dossierDuPL(plNumero);
      if (!estGerant) await alerter("Consommables de PL annulés", `PL ${plNumero} : consommables de ${quoi} annulés (${consos.length} ligne(s)) par ${user.nom}`, dPL ? { kind: "commande", id: dPL.id } : { kind: "onglet", id: "stock" });
      setNotice(`Consommables de ${quoi} du PL « ${plNumero} » annulés — rendus au stock.`);
      return true;
    }
    // ERP step 11 (accord Nils du 29/09) : seul un « Enregistrer un PL »
    // (matière) rend le PL annulable ; mais l'annulation emporte aussi les
    // consommables (production et pose) saisis sur ce PL — rendus au stock
    // et effacés, voir plus bas.
    const mvs = (mouvements || []).filter((m) => m.pl === plNumero && !estMouvementConsommable(m));
    const consosDuPL = (mouvements || []).filter((m) => m.pl === plNumero && estMouvementConsommable(m) && ((o.prod && usageConsommable(m) === "production") || (o.pose && usageConsommable(m) === "pose")));
    if (mvs.length === 0) {
      setNotice(`Aucun mouvement trouvé pour le PL « ${plNumero} ».`);
      return false;
    }
    // ERP step 17 (audit, Nils 14/10) : les chutes créées par ce PL sont retirées à
    // l'annulation — on refuse si l'une d'elles a servi depuis (sortie par un autre PL,
    // ajustement, consommation) ou est réservée, sinon le stock deviendrait incohérent.
    {
      const idsChutes = new Set(mvs.filter((m) => m.type === "entree").map((m) => m.itemId));
      if (idsChutes.size) {
        const autresMvts = (mouvements || []).filter((m) => idsChutes.has(m.itemId) && m.pl !== plNumero);
        const resChutes = (reservations || []).filter((r) => idsChutes.has(r.itemId) && r.statut === "active");
        if (autresMvts.length || resChutes.length) {
          const refs = [...new Set(autresMvts.map((m) => (m.pl ? m.pl : m.motif || m.reference || "un mouvement de stock")))];
          const bcs = [...new Set(resChutes.map((r) => r.bc || "un dossier"))];
          const parts = [refs.length ? `utilisée par ${refs.join(", ")}` : "", bcs.length ? `réservée pour ${bcs.join(", ")}` : ""].filter(Boolean).join(" et ");
          setNotice(`Impossible d'annuler la matière de « ${plNumero} » : une chute créée par ce PL a déjà été ${parts}. Annule d'abord ${refs.length ? "ces sorties" : "ces réservations"}, ou corrige par un ajustement d'inventaire (⚖).`);
          return false;
        }
      }
    }
    // Crédit généré par ce PL (s'il était non-exo et sous-consommé) : on
    // refuse l'annulation si ce crédit a déjà été entamé (consommé, en tout
    // ou partie, par un BC exo — le crédit se consomme à la transformation
    // en BDC) — sinon on créerait un manque de crédit invisible. Un crédit
    // intact a encore `quantite === quantiteOrigine` ; un crédit totalement
    // consommé n'existe simplement plus dans la liste.
    const creditsDuPL = (creditsTranches || []).filter((c) => c.plNumero === plNumero);
    const creditsEntames = creditsDuPL.filter((c) => Number(c.quantite) !== Number(c.quantiteOrigine));
    const quantiteGeneree = creditsDuPL.reduce((s, c) => s + (Number(c.quantiteOrigine) || 0), 0);
    const quantiteRestante = creditsDuPL.reduce((s, c) => s + (Number(c.quantite) || 0), 0);
    if (creditsEntames.length > 0 || quantiteRestante < quantiteGeneree) {
      const detenteurs = [...new Set(creditsDuPL.flatMap((c) => commandesDetenantCredit(c.cle).map((cmd) => cmd.numero)))];
      setNotice(
        `Impossible d'annuler « ${plNumero} » : le crédit qu'il a généré (${creditsDuPL
          .map((c) => c.libelle || nomProduit(c.produitId))
          .join(", ")}) a déjà été consommé, en tout ou partie, par ${detenteurs.length > 0 ? `le(s) dossier(s) ${detenteurs.join(", ")}` : "un dossier exonéré"}. Modifie d'abord ce BC.`
      );
      return false;
    }
    if (creditsDuPL.length > 0) {
      await persistCreditsTranches((creditsTranches || []).filter((c) => c.plNumero !== plNumero));
      await journaliserMouvementsCredit(
        creditsDuPL.map((c) => ({
          produitId: c.produitId,
          libelle: c.libelle,
          sens: "debit",
          quantite: c.quantite,
          origine: `PL ${plNumero} annulé — crédit retiré`,
        }))
      );
    }
    let nextItems = [...(items || [])];
    // Nils 01/11 : une chute (ou un plan récupéré) entièrement sortie par ce PL n'est plus dans le
    // stock ; on recrée son lot (même identifiant) d'après la fiche gardée sur la sortie, ou celle du
    // registre des plans récupérés. Sa valeur est reprise par le serveur.
    const introuvables = [];
    mvs
      .filter((m) => m.type === "sortie" && !nextItems.some((it) => it.id === m.itemId))
      .forEach((m) => {
        const fiche = (plansRecuperes || []).find((p) => p.lotId === m.itemId);
        if (m.lotChute) nextItems.push({ ...m.lotChute, id: m.itemId, stockReel: 0, arrivages: 0 });
        else if (fiche) nextItems.push({ id: fiche.lotId, produitId: fiche.produitId, type: TYPE_CHUTE, planRecupereId: fiche.id, fournisseur: "", dimensions: fiche.dimensions, epaisseur: fiche.epaisseur || "", nuance: "", choix: "", unite: m.unite || "pièce(s)", stockReel: 0, arrivages: 0 });
        else introuvables.push(m);
      });
    if (introuvables.length) {
      if (!(await demander(`${introuvables.length} lot(s) sorti(s) par ce PL n'existe(nt) plus dans le stock (chute épuisée avant la mise à jour du 01/11) : ${introuvables.length > 1 ? "ils ne seront pas remis" : "il ne sera pas remis"} en stock. Corrige ensuite par une « Chute hors PL ». Continuer l'annulation ?`))) return false;
    }
    // Les sorties (consommations) : on rend la quantité au lot d'origine.
    mvs
      .filter((m) => m.type === "sortie")
      .forEach((m) => {
        nextItems = nextItems.map((it) => (it.id === m.itemId ? { ...it, stockReel: Number((it.stockReel + m.quantite).toFixed(2)) } : it));
      });
    // Les consommables saisis sur ce PL : rendus au stock eux aussi.
    consosDuPL.forEach((m) => {
      nextItems = nextItems.map((it) => (it.id === m.itemId ? { ...it, stockReel: Number((it.stockReel + (Number(m.quantite) || 0)).toFixed(2)) } : it));
    });
    // Les entrées (chutes générées par ce PL) : on retire le lot créé.
    const idsChutesAAnnuler = mvs.filter((m) => m.type === "entree").map((m) => m.itemId);
    nextItems = nextItems.filter((it) => !idsChutesAAnnuler.includes(it.id));
    await persist(nextItems);
    {
      const idsConsos = new Set(consosDuPL.map((m) => m.id));
      await persistMouvements((mouvements || []).filter((m) => !(m.pl === plNumero && (!estMouvementConsommable(m) || idsConsos.has(m.id)))));
    }
    await tracerAcces("PL annulé", `${plNumero} : stock restauré`);
    if (consosDuPL.length > 0) {
      await tracerAcces("consommables annulés avec le PL", `${plNumero} : ${consosDuPL.length} saisie(s) de consommables rendue(s) au stock et effacée(s)`);
    }
    {
      const dPL = dossierDuPL(plNumero);
      await alerter("PL annulé", `PL ${plNumero} annulé${consosDuPL.length > 0 ? `, ${consosDuPL.length} ligne(s) de consommables comprises` : ""}`, dPL ? { kind: "commande", id: dPL.id } : { kind: "onglet", id: "stock" });
    }
    setNotice(`PL « ${plNumero} » annulé — le stock a été restauré${consosDuPL.length > 0 ? `, consommables compris (${consosDuPL.length} ligne(s))` : ""}.`);
    return true;
  }
  // ERP step 11 : retour PL → RDM d'un dossier dont le PL n'a jamais été
  // enregistré côté matière, mais qui a déjà des consommables saisis : ils
  // disparaissent aussi (rendus au stock, effacés).
  async function annulerConsommablesDuPL(plNumero) {
    const consos = (mouvements || []).filter((m) => m.pl === plNumero && estMouvementConsommable(m));
    if (consos.length === 0) return;
    let nextItems = [...(items || [])];
    consos.forEach((m) => {
      nextItems = nextItems.map((it) => (it.id === m.itemId ? { ...it, stockReel: Number((it.stockReel + (Number(m.quantite) || 0)).toFixed(2)) } : it));
    });
    await persist(nextItems);
    await persistMouvements((mouvements || []).filter((m) => !(m.pl === plNumero && estMouvementConsommable(m))));
    await tracerAcces("consommables annulés avec le PL", `${plNumero} : ${consos.length} saisie(s) de consommables rendue(s) au stock et effacée(s)`);
  }

  // ---- Consommation de consommables (hors Catalogue) ----
  // Pour tout ce qui n'a pas de commande en face (contrairement aux
  // tranches, toujours couvertes par un BC même en cas de casse) : usage
  // quotidien, une ligne par personne/consommable/quantité.
  function ouvrirConsommation(usage, pl) {
    setConsommationDate(todayISO());
    setConsommationLignes([{ id: uid(), lotId: "", quantite: "", demandePar: "" }]);
    setConsommationError("");
    setConsommationPL(pl || "");
    setConsommationMotif("");
    setConsommationUsage(typeof usage === "string" ? usage : "");
    setShowConsommation(true);
  }
  function ajouterLigneConsommation() {
    setConsommationLignes((prev) => [...prev, { id: uid(), lotId: "", quantite: "", demandePar: "" }]);
  }
  function retirerLigneConsommation(id) {
    setConsommationLignes((prev) => prev.filter((l) => l.id !== id));
  }
  function modifierLigneConsommation(id, champ, valeur) {
    setConsommationLignes((prev) => prev.map((l) => (l.id === id ? { ...l, [champ]: valeur } : l)));
    if (consommationError) setConsommationError("");
  }
  // Step 12 pt.7 (accord Nils du 21/09) : fonctionne désormais comme le PL —
  // chaque ligne désigne un lot précis (pas seulement un produit avec
  // prélèvement FIFO automatique) ; aucune interaction avec le registre des
  // exo/crédits, qui ne concerne que les Tranches du Catalogue.
  async function submitConsommation() {
    if (bloqueParInventaire()) return;
    // Step 13 (retour Nils du 22/09, pt.5) : le rattachement à un PL,
    // d'abord facultatif, devient obligatoire — chaque consommation doit
    // être imputée à un PL précis.
    if (!(consommationPL || "").trim()) {
      setConsommationError("Choisis le PL auquel rattacher cette consommation, ou « Atelier (hors dossier) ».");
      return;
    }
    // ERP step 10 pt.4 (accord Nils du 24/09) : consommation atelier sans
    // dossier possible, mais uniquement avec un motif écrit — tracée dans le
    // Journal d'accès pour que Nils la voie (en attendant le futur journal
    // d'alertes), et marquée "atelier" sur le mouvement pour le futur coût
    // de revient (frais d'atelier).
    if (!peutEnregistrerConso) {
      setConsommationError("Seuls le bureau technique et le Gérant peuvent enregistrer des consommables.");
      return;
    }
    const estAtelier = consommationPL === CONSO_ATELIER;
    const motifAtelier = (consommationMotif || "").trim();
    // ERP step 11 : type obligatoire (atelier = production d'office) ;
    // aucun consommable sur un dossier facturé (dossier figé).
    const usage = estAtelier ? "production" : consommationUsage;
    if (!usage) {
      setConsommationError("Choisis le type : consommables de production ou de pose.");
      return;
    }
    if (!estAtelier) {
      const dossierConso = (commandesListe || []).find((c) => c.numeroPL === consommationPL);
      if (dossierConso && dossierConso.statut === "Facture") {
        setConsommationError("Ce dossier est facturé : plus aucun consommable ne peut y être enregistré.");
        return;
      }
    }
    // Nils 28/10 : lignes de listello (tranche cochée au Catalogue, chute < 1 m²), atelier seulement.
    const lignesListello = consommationLignes.filter((l) => l.lotId && lotListello((items || []).find((it) => it.id === l.lotId)));
    if (lignesListello.length && !estAtelier) {
      setConsommationError("Les listellos se sortent par « Atelier (hors dossier) ».");
      return;
    }
    for (const l of lignesListello) {
      const lot = (items || []).find((it) => it.id === l.lotId);
      if (Number(l.quantite) > 0 && !quantiteListelloValide(lot, l.quantite)) {
        setConsommationError(lot.type === TYPE_CHUTE ? `Chute « ${libelleLot(lot)} » : quantité en pièces entières.` : `Tranche « ${libelleLot(lot)} » : quantité au quart de tranche (0,25 ; 0,5 ; 1…).`);
        return;
      }
    }
    const motifAtelierFinal = motifAtelier || (lignesListello.length ? "Listello" : "");
    if (estAtelier && !motifAtelierFinal) {
      setConsommationError("Indique le motif de cette consommation atelier (hors dossier).");
      return;
    }
    // ERP step 10 pt.1 : le client est celui du PL choisi, jamais saisi.
    const libClientConso = estAtelier ? "" : libelleClientDuPL(consommationPL);
    const lignes = consommationLignes.filter((l) => l.lotId && Number(l.quantite) > 0);
    if (lignes.length === 0) {
      setConsommationError("Ajoute au moins une ligne avec un lot et une quantité.");
      return;
    }
    // Vérifier le stock de chaque lot consommé (en cumulant les lignes d'un même lot)
    const besoin = {};
    for (const l of lignes) besoin[l.lotId] = (besoin[l.lotId] || 0) + Number(l.quantite);
    for (const lotId of Object.keys(besoin)) {
      const lot = (items || []).find((it) => it.id === lotId);
      if (!lot) {
        setConsommationError("Un lot consommé est introuvable.");
        return;
      }
      if (besoin[lotId] > (Number(lot.stockReel) || 0)) {
        setConsommationError(`Stock insuffisant sur « ${libelleLot(lot)} » : ${besoin[lotId]} demandé, ${lot.stockReel} disponible.`);
        return;
      }
    }
    const date = consommationDate || todayISO();
    const horodatage = new Date().toISOString();
    let nextItems = [...(items || [])];
    const nextMouvements = [...(mouvements || [])];
    for (const l of lignes) {
      const q = Number(l.quantite);
      const lot = nextItems.find((it) => it.id === l.lotId);
      nextItems = nextItems.map((it) => (it.id === l.lotId ? { ...it, stockReel: Number((it.stockReel - q).toFixed(2)) } : it));
      const listello = estAtelier && lignesListello.some((x) => x.id === l.id);
      nextMouvements.push({
        id: uid(),
        itemId: l.lotId,
        type: "sortie",
        quantite: q,
        unite: lot.unite,
        doc: "",
        date,
        note: [
          listello ? `Listello (hors dossier) — motif : ${motifAtelierFinal}` : estAtelier ? `Consommable atelier (hors dossier) — motif : ${motifAtelierFinal}` : `Consommable de ${usage}${libClientConso ? ` — ${libClientConso}` : ""}`,
          l.demandePar.trim() ? `demandé par ${l.demandePar.trim()}` : "",
        ].filter(Boolean).join(" — "),
        pl: estAtelier ? "" : (consommationPL || "").trim(),
        atelier: estAtelier || undefined,
        listello: listello || undefined,
        consommable: true,
        usage,
        creeLe: horodatage,
      });
    }
    await persist(nextItems);
    await persistMouvements(nextMouvements);
    if (estAtelier) {
      await alerter("Consommable atelier hors dossier", `${lignes.map((l) => { const lot = (items || []).find((it) => it.id === l.lotId); return `${Number(l.quantite)} ${lot ? lot.unite : ""} ${lot ? libelleLot(lot) : ""}`.replace(/\s+/g, " ").trim(); }).join(" ; ")} — motif : ${motifAtelierFinal}`, { kind: "onglet", id: "stock" });
      await tracerAcces(
        "consommable atelier hors dossier",
        `${lignes.map((l) => { const lot = (items || []).find((it) => it.id === l.lotId); return `${Number(l.quantite)} ${lot ? lot.unite : ""} ${lot ? libelleLot(lot) : ""}`.replace(/\s+/g, " ").trim(); }).join(" ; ")} — motif : ${motifAtelierFinal}`
      );
    }
    if (!estAtelier) {
      await tracerAcces(
        `consommables de ${usage}`,
        `${(consommationPL || "").trim()} : ${lignes.map((l) => { const lot = (items || []).find((it) => it.id === l.lotId); return `${Number(l.quantite)} ${lot ? lot.unite : ""} ${lot ? libelleLot(lot) : ""}`.replace(/\s+/g, " ").trim(); }).join(" ; ")}`
      );
    }
    setShowConsommation(false);
    setConsommationError("");
    setNotice(`${lignes.length} consommation(s) enregistrée(s).`);
  }

  // ---- Bon de production (PL) ----
  function openPL() {
    setPlMachines([]);
    setPlDoc("");
    setPlDate(todayISO());
    setPlClient("");
    setPlConsos([]);
    setPlChutes([]);
    setPlError("");
    setShowPL(true);
  }

  function addPlConso() {
    setPlConsos((prev) => [...prev, { id: uid(), lotId: "", quantite: "" }]);
  }
  function updatePlConso(id, champ, valeur) {
    setPlConsos((prev) => prev.map((c) => (c.id === id ? { ...c, [champ]: valeur } : c)));
  }
  function removePlConso(id) {
    setPlConsos((prev) => prev.filter((c) => c.id !== id));
  }

  function addPlChute() {
    setPlChutes((prev) => [...prev, { id: uid(), lotSource: "", dimensions: "", quantite: "1" }]);
  }
  function updatePlChute(id, champ, valeur) {
    setPlChutes((prev) => prev.map((c) => (c.id === id ? { ...c, [champ]: valeur } : c)));
  }
  function removePlChute(id) {
    setPlChutes((prev) => prev.filter((c) => c.id !== id));
  }

  // ERP step 10 pt.1 (accord Nils du 24/09) : le client d'un PL n'est plus
  // saisi à la main — il est toujours celui du dossier dont le PL est issu
  // (nom client — référence), recalculé ici au moment de l'enregistrement.
  function libelleClientDuPL(numeroPL) {
    const commande = (commandesListe || []).find((c) => c.numeroPL === (numeroPL || "").trim());
    if (!commande) return "";
    const client = (clients || []).find((x) => x.id === commande.clientId);
    return [client ? client.nom : "", commande.reference].filter(Boolean).join(" — ");
  }
  async function submitPL() {
    if (bloqueParInventaire()) return;
    if (!plDoc.trim()) {
      setPlError("Indique le n° de PL.");
      return;
    }
    if (!(commandesListe || []).some((c) => c.numeroPL === plDoc)) {
      setPlError("Ce n° de PL ne correspond à aucun dossier réellement transformé en PL depuis Commandes.");
      return;
    }
    if (dossierFacture(dossierDuPL(plDoc))) {
      setPlError("Ce dossier est facturé : il est figé, aucun PL ne peut plus y être enregistré.");
      return;
    }
    // Un PL ne s'enregistre qu'une seule fois — la ressaisie accidentelle
    // décompterait le stock deux fois, dupliquerait les écarts et les
    // crédits exo (accord du 21/09 avec Nils). Pour corriger un PL déjà
    // enregistré, il faut d'abord l'annuler via "↺ Annuler un PL".
    if (plExistant(plDoc)) {
      setPlError(`Le PL ${plDoc.trim()} a déjà été enregistré — impossible de l'enregistrer une seconde fois. Utilise "↺ Annuler une consommation" dans le Stock si tu dois le corriger.`);
      return;
    }
    // Step 12 pt.2 (accord Nils du 21/09) : un article créé par Karima et
    // pas encore validé par Nils ne doit jamais partir en production sans
    // que Nils l'ait vu — on bloque l'enregistrement du PL et on nomme le ou
    // les articles en cause plutôt que de laisser passer silencieusement.
    // (Step 13 : le même blocage existe désormais aussi plus tôt, au moment
    // de la transformation du dossier en PL — voir demanderConfirmationTransformation.
    // Celui-ci reste en place en filet de sécurité, ex. pour un dossier déjà
    // passé en PL avant ce correctif.)
    {
      const commandePLDoc = (commandesListe || []).find((c) => c.numeroPL === plDoc);
      const articlesNonValides = articlesNonValidesDuDossier(commandePLDoc);
      if (articlesNonValides.length > 0) {
        setPlError(`Impossible d'enregistrer ce PL : ${articlesNonValides.join(", ")} — n'a/n'ont pas encore été validé(s) par le Gérant dans le Catalogue (tout article créé par quelqu'un d'autre que le Gérant doit l'être).`);
        return;
      }
    }
    const consos = plConsos.filter((c) => c.lotId && Number(c.quantite) > 0);
    const chutes = plChutes.filter((c) => c.lotSource && Number(c.quantite) > 0);
    if (consos.length === 0 && chutes.length === 0) {
      setPlError("Ajoute au moins une ligne de consommation ou de chute générée.");
      return;
    }
    // Nils 17/10 : les tranches sortent du stock en entier (pas de tranche fantôme) ; pour un article
    // vendable au quart de tranche, Ahmed déclare en plus ce qu'il a réellement consommé, au quart près.
    for (const c of consos) {
      const lot = (items || []).find((it) => it.id === c.lotId);
      const pas = pasConsommationLot(lot);
      if (pas === null) continue;
      const q = Number(c.quantite);
      if (!estMultipleDe(q, 1)) {
        // Nils 03/11 : pour un article non vendable au quart, le champ « Réellement consommé » n'existe pas.
        setPlError(pas === 1
          ? `« ${nomProduit(lot.produitId)} » : les tranches sortent du stock en entier (${c.quantite} saisi). Saisis des tranches entières (ex. 1) ; s'il reste un morceau, déclare-le en chute ci-dessous.`
          : `« ${nomProduit(lot.produitId)} » : les tranches sortent du stock en entier (${c.quantite} saisi). Saisis les tranches sorties en entier (ex. 1) dans la première case, et la part réellement consommée (ex. ${c.quantite}) dans « Réellement consommé » ; le reste se déclare en chute ci-dessous.`);
        return;
      }
      if (pas < 1 && String(c.consomme ?? "").trim() !== "") {
        const r = Number(String(c.consomme).replace(",", "."));
        if (!(r > 0) || r > q || !estMultipleDe(r, pas)) {
          setPlError(`« ${nomProduit(lot.produitId)} » : « Réellement consommé » doit être un quart de tranche (0,25 ; 0,5 ; 0,75…), supérieur à 0 et au plus ${q} (tranches sorties).`);
          return;
        }
      }
    }
    // Nils 17/10 (d) : la dimension d'une chute est obligatoire et contrôlée.
    for (const ch of chutes) {
      const src = (items || []).find((it) => it.id === ch.lotSource);
      const sc = surfaceDimensions(ch.dimensions);
      if (!sc) {
        setPlError(`Chute${src ? ` de « ${nomProduit(src.produitId)} »` : ""} : indique sa dimension au format longueur × largeur en cm (ex. 160 × 90).`);
        return;
      }
      const ss = src ? surfaceLot(src) : 0;
      if (ss && sc > ss + 1e-9) {
        setPlError(`Chute de « ${nomProduit(src.produitId)} » : ${ch.dimensions.trim()} est plus grande que la tranche d'origine — vérifie la dimension.`);
        return;
      }
    }
    // Vérifier le stock de chaque lot consommé (en cumulant les lignes d'un même lot)
    const besoin = {};
    for (const c of consos) besoin[c.lotId] = (besoin[c.lotId] || 0) + Number(c.quantite);
    for (const lotId of Object.keys(besoin)) {
      const lot = (items || []).find((it) => it.id === lotId);
      if (!lot) {
        setPlError("Un lot consommé est introuvable.");
        return;
      }
      if (besoin[lotId] > (Number(lot.stockReel) || 0)) {
        setPlError(`Stock insuffisant sur « ${nomProduit(lot.produitId)} » : ${besoin[lotId]} demandé, ${lot.stockReel} disponible.`);
        return;
      }
    }
    // Sortie supérieure au facturé, par famille couleur pour les tranches (toutes épaisseurs confondues)
    // et par produit exact pour les éviers et accessoires. Nils 17/10 : plus de blocage (une erreur de
    // devis ne doit pas empêcher la production) ; jusqu'au facturé arrondi à la tranche entière supérieure
    // (vente au quart : 1,75 facturée → 2 sorties), rien ; au-delà, Ahmed confirme et le Gérant est alerté.
    let sortieAuDelaFacture = "";
    {
      const commandePLPourVerif = (commandesListe || []).find((c) => c.numeroPL === plDoc);
      const lignesPLPourVerif = commandePLPourVerif ? lignesDuDossier(commandePLPourVerif) : [];
      const { groupesEcarts: groupesPourVerif } = comparerFactureEtConsomme(lignesPLPourVerif, consos);
      const depassements = groupesPourVerif.filter((g) => (g.type === "famille" || g.type === "produit") && g.quantiteConsommee > Math.ceil(g.quantiteFacturee - 1e-9));
      if (depassements.length > 0) {
        sortieAuDelaFacture = depassements.map((g) => `${g.libelle} : ${g.quantiteConsommee} sorti(s) pour ${g.quantiteFacturee} facturé(s)`).join(" ; ");
        if (!(await demander(`⚠ Tu sors plus que ce qui est facturé sur ce PL :\n${sortieAuDelaFacture}.\n\nConfirmer quand même l'enregistrement du PL ? Le Gérant sera prévenu.`))) return;
      }
    }
    // Nils 04/10 (o) : dossier book-match — la sortie doit contenir les A et les B demandés, de la même nuance.
    // Sinon : fenêtre de confirmation pour Ahmed (casse, impossibilité…) et alerte à Nils.
    let anomalieBookMatch = "";
    {
      const cmd = (commandesListe || []).find((c) => c.numeroPL === plDoc);
      const lignesBM = (cmd ? lignesDuDossier(cmd) : []).filter((l) => l.bookmatch && ((articles || []).find((a) => a.id === l.articleId) || {}).bookmatch);
      if (lignesBM.length) {
        const expA = lignesBM.reduce((n, l) => n + (l.qteA === undefined || l.qteA === "" ? Math.ceil((Number(l.qte) || 0) / 2) : Number(l.qteA) || 0), 0);
        const expB = lignesBM.reduce((n, l) => n + (l.qteB === undefined || l.qteB === "" ? Math.floor((Number(l.qte) || 0) / 2) : Number(l.qteB) || 0), 0);
        let cA = 0, cB = 0;
        const nuances = new Set();
        consos.forEach((c) => {
          const lot = (items || []).find((it) => it.id === c.lotId);
          if (!lot || !lot.bm) return;
          if (lot.bm === "A") cA += Number(c.quantite) || 0; else cB += Number(c.quantite) || 0;
          nuances.add(lot.nuance || "");
        });
        const pbs = [];
        if (cA < expA) pbs.push(`A sortis ${cA} / ${expA} demandés`);
        if (cB < expB) pbs.push(`B sortis ${cB} / ${expB} demandés`);
        if (nuances.size > 1) pbs.push(`nuances différentes (${[...nuances].map((n) => n || "sans nuance").join(", ")})`);
        if (pbs.length) {
          anomalieBookMatch = pbs.join(" ; ");
          if (!(await demander(`⚠ Book-match demandé sur ce dossier (A × ${expA}, B × ${expB}, même nuance) :\n${anomalieBookMatch}.\n\nConfirmer quand même l'enregistrement du PL ? Le Gérant sera prévenu.`))) return;
        }
      }
    }
    // Nils 26/10 (c) : chute vendue — la sortie se fait sur des lots « chute » du même produit.
    let anomalieChute = "";
    {
      const cmd = (commandesListe || []).find((c) => c.numeroPL === plDoc);
      const attendu = new Map();
      (cmd ? lignesDuDossier(cmd) : []).filter((l) => l.chute && l.type === "facture").forEach((l) => {
        const a = (articles || []).find((x) => x.id === l.articleId);
        if (a && a.produitStockId) attendu.set(a.produitStockId, (attendu.get(a.produitStockId) || 0) + (Number(l.qte) || 0));
      });
      const pbs = [];
      attendu.forEach((q, produitId) => {
        const sortis = consos.reduce((n, c) => { const lot = (items || []).find((it) => it.id === c.lotId); return lot && lot.type === TYPE_CHUTE && lot.produitId === produitId ? n + (Number(c.quantite) || 0) : n; }, 0);
        if (sortis < q) pbs.push(`${nomProduit(produitId)} : ${sortis} chute(s) sortie(s) / ${q} vendue(s)`);
      });
      if (pbs.length) {
        anomalieChute = pbs.join(" ; ");
        if (!(await demander(`⚠ Chute vendue sur ce dossier, à sortir sur un lot « chute » du même produit :\n${anomalieChute}.\n\nConfirmer quand même l'enregistrement du PL ? Le Gérant sera prévenu.`))) return;
      }
    }
    const libClientPL = libelleClientDuPL(plDoc);
    try {
      const date = plDate || todayISO();
      const horodatage = new Date().toISOString();
      let nextItems = [...(items || [])];
      const nextMouvements = [...(mouvements || [])];

      // 1) consommations : décrémentent les lots, tracent un mouvement sortie
      for (const c of consos) {
        const q = Number(c.quantite);
        const lot = nextItems.find((it) => it.id === c.lotId);
        nextItems = nextItems.map((it) => (it.id === c.lotId ? { ...it, stockReel: Number((it.stockReel - q).toFixed(2)) } : it));
        // ERP step 14 (d) : coût unitaire mémorisé (une chute consommée disparaît du stock).
        const cuSortie = coutRevientUnitaireLot(lot);
        nextMouvements.push({
          id: uid(),
          itemId: c.lotId,
          type: "sortie",
          quantite: q,
          unite: lot.unite,
          doc: plDoc.trim(),
          date,
          note: libClientPL ? `PL ${libClientPL}` : "",
          pl: plDoc.trim(),
          creeLe: horodatage,
          ...(cuSortie !== null ? { coutUnitaire: Math.round(cuSortie * 100) / 100 } : {}),
          // Nils 17/10 : article vendable au quart de tranche — consommation réelle déclarée (coût de revient).
          ...(pasConsommationLot(lot) === 0.25 ? { consommeDeclare: String(c.consomme ?? "").trim() !== "" ? Number(String(c.consomme).replace(",", ".")) : q } : {}),
          // Nils 01/11 : une chute qui sort entièrement quitte le stock ; sa fiche (sans prix) est gardée
          // sur la sortie pour la recréer si le PL est annulé.
          ...(lot.type === TYPE_CHUTE && (Number(lot.stockReel) || 0) - q <= 0 ? { lotChute: ficheChute(lot) } : {}),
        });
      }

      // 2) chutes générées : nouveaux lots type chute, hérités d'un lot source
      // (pour conserver produit, nuance, choix, épaisseur, fournisseur)
      for (const ch of chutes) {
        const q = Number(ch.quantite);
        const src = (items || []).find((it) => it.id === ch.lotSource);
        const prod = src ? produitDe(src.produitId) : null;
        const nouveauLot = {
          id: uid(),
          produitId: src ? src.produitId : "",
          type: TYPE_CHUTE,
          // Nils 17/10 : le serveur valorise la chute d'après son lot d'origine (prix invisibles à l'atelier).
          ...(src ? { lotSourceId: src.id } : {}),
          fournisseur: src ? src.fournisseur : "",
          dimensions: (ch.dimensions || "").trim(),
          epaisseur: src ? src.epaisseur : "",
          nuance: src ? src.nuance : "",
          choix: src ? src.choix : "",
          // Nils 28/10 : une chute se compte à la pièce.
          unite: "pièce(s)",
          stockReel: q,
          arrivages: 0,
        };
        // ERP step 14 (ch1, Nils 05/10) : la chute vaut (surface chute ÷ surface du lot d'origine) × coût du lot d'origine.
        const valChute = valeurChute(src, nouveauLot.dimensions);
        if (valChute !== null) nouveauLot.prixAchatHT = valChute;
        nextItems.push(nouveauLot);
        nextMouvements.push({
          id: uid(),
          itemId: nouveauLot.id,
          type: "entree",
          quantite: q,
          unite: nouveauLot.unite,
          doc: plDoc.trim(),
          date,
          note: `Chute générée — PL ${plDoc.trim()}`,
          pl: plDoc.trim(),
          creeLe: horodatage,
          ...(valChute !== null ? { valeurUnitaire: valChute } : {}),
        });
      }

      // Nettoyage : une chute descendue à 0 ne doit pas rester en stock.
      // (Les tranches à 0 sont conservées : le lot garde son historique.)
      nextItems = nextItems.filter((it) => !(it.type === TYPE_CHUTE && (Number(it.stockReel) || 0) <= 0));

      await persist(nextItems);
      await persistMouvements(nextMouvements);

      // 3) une fois la matière enregistrée en production, la réservation qui
      // la retenait n'a plus lieu d'être — on la lève automatiquement, par
      // produit, sur le BC du dossier concerné (pas la peine de vérifier la
      // quantité : le rôle de la réservation s'arrête dès que la production
      // a eu lieu, qu'elle ait consommé exactement ce qui était réservé ou non).
      const commandePL = (commandesListe || []).find((c) => c.numeroPL === plDoc);
      const consoParProduit = {};
      for (const c of consos) {
        const lot = (items || []).find((it) => it.id === c.lotId);
        if (!lot) continue;
        consoParProduit[lot.produitId] = (consoParProduit[lot.produitId] || 0) + Number(c.quantite);
      }
      if (commandePL) {
        const aLever = (reservations || []).filter(
          (r) => r.bc === commandePL.numero && r.statut === "active" && consoParProduit[r.produitId] !== undefined
        );
        if (aLever.length > 0) {
          await persistReservations(
            (reservations || []).map((r) =>
              aLever.some((rl) => rl.id === r.id)
                ? { ...r, statut: "levee", motifLevee: "production", leveeLe: horodatage, leveePar: user.nom, modifiePar: user.nom, modifieLe: horodatage }
                : r
            )
          );
        }
      }

      // ERP step 7 : quantité commandée = lignes actuelles du dossier
      // (commande.lignes, éventuellement ajustées depuis le BDC/RDM/PL) —
      // le devis d'origine est figé depuis la transformation en BDC et ne
      // reflète donc plus forcément ce qui a réellement été commandé.
      const lignesPL = commandePL ? lignesDuDossier(commandePL) : [];

      // ERP step 9 (accord du 21/09) : le registre des écarts disparaît.
      // Seul reste le registre de crédit, keyed par produit Stock exact
      // (plus de notion de famille/épaisseur) : l'enregistrement d'un PL
      // NON-exo qui consomme moins que ce qui est facturé sur un produit
      // ajoute un crédit pour cet exact produit. Un PL exo n'a lui aucune
      // interaction avec ce registre — tout le crédit exo se joue à la
      // création/transformation du BC exo (voir besoinsCreditPourLignes).
      if (commandePL) {
        const devisPL = (devisListe || []).find((d) => d.id === commandePL.devisId);
        const estExoPL = !!(devisPL && devisPL.exonereTVA);
        if (!estExoPL) {
          const manques = besoinsCreditParProduit(lignesPL, consos);
          if (manques.length > 0) {
            const nouveauxCredits = manques.map((m) => ({
              id: uid(),
              produitId: m.produitId,
              cle: m.produitId,
              libelle: m.libelle,
              quantite: m.quantite,
              // quantiteOrigine ne bouge jamais après création : comparé à
              // `quantite` (qui diminue à la consommation), il permet à
              // annulerPL de détecter qu'un crédit a déjà été entamé.
              quantiteOrigine: m.quantite,
              plNumero: plDoc.trim(),
              bc: commandePL.numero,
              origine: `PL ${plDoc.trim()} — BC ${commandePL.numero}${libClientPL ? ` (${libClientPL})` : ""}`,
              creeLe: horodatage,
              creePar: user.nom,
            }));
            await persistCreditsTranches([...(creditsTranches || []), ...nouveauxCredits]);
            await journaliserMouvementsCredit(
              nouveauxCredits.map((c) => ({
                produitId: c.produitId,
                libelle: c.libelle,
                sens: "credit",
                quantite: c.quantite,
                origine: c.origine,
              }))
            );
          }
        }
      }

      // Nils 04/10 (b) : machines utilisées pour ce PL (calcul d'usure des consommables en service).
      {
        const machinesPL = (plMachines || []).filter((id) => (affectations || []).some((a) => a.id === id && a.type === "machine"));
        await persistCommandes((commandesListe || []).map((c) => (c.numeroPL === plDoc.trim() ? { ...c, machinesPL } : c)));
      }
      if (sortieAuDelaFacture && !estGerant) {
        const devisAlerte = commandePL ? (devisListe || []).find((d) => d.id === commandePL.devisId) : null;
        await alerter("Sortie supérieure au facturé", `${plDoc.trim()}${commandePL ? ` — dossier ${commandePL.numero}${commandePL.reference ? ` (${commandePL.reference})` : ""}` : ""}${devisAlerte && devisAlerte.exonereTVA ? " — dossier exonéré" : ""} : ${sortieAuDelaFacture}.`, commandePL ? { kind: "commande", id: commandePL.id } : null);
      }
      if (anomalieChute && !estGerant) await alerter("Chute vendue non respectée au PL", `${plDoc.trim()}${commandePL ? ` — dossier ${commandePL.numero}${commandePL.reference ? ` (${commandePL.reference})` : ""}` : ""} : ${anomalieChute} — confirmé par ${user.nom}`, commandePL ? { kind: "commande", id: commandePL.id } : { kind: "onglet", id: "stock" });
      if (anomalieBookMatch && !estGerant) await alerter("Book-match non respecté au PL", `${plDoc.trim()}${commandePL ? ` — dossier ${commandePL.numero}${commandePL.reference ? ` (${commandePL.reference})` : ""}` : ""} : ${anomalieBookMatch} — confirmé par ${user.nom}`, commandePL ? { kind: "commande", id: commandePL.id } : { kind: "onglet", id: "stock" });
      await tracerAcces("PL enregistré (stock)", `${plDoc.trim()}${commandePL ? ` — Dossier ${commandePL.numero}` : ""}`);
      setShowPL(false);
      setPlError("");
    } catch (err) {
      console.error("Erreur enregistrement PL", err);
      setPlError("Impossible d'enregistrer le PL. Réessaie.");
    }
  }

  // ---- Ajout manuel d'un crédit dans le registre — réservé à Nils ----
  function ouvrirAjoutCreditManuel() {
    if (!peutEcrireRegistreCredit) return;
    setCreditManuelForm({ produitId: "", quantite: "", note: "" });
    setCreditManuelError("");
    setShowAjoutCreditManuel(true);
  }
  async function submitCreditManuel() {
    if (!peutEcrireRegistreCredit || !creditManuelForm) return;
    const f = creditManuelForm;
    if (!f.produitId) {
      setCreditManuelError("Sélectionne un produit.");
      return;
    }
    const q = Number(f.quantite) || 0;
    if (!(q > 0)) {
      setCreditManuelError("La quantité doit être supérieure à 0.");
      return;
    }
    const entree = {
      id: uid(),
      produitId: f.produitId,
      cle: f.produitId,
      libelle: nomProduit(f.produitId),
      quantite: Number(q.toFixed(2)),
      quantiteOrigine: Number(q.toFixed(2)),
      plNumero: null,
      origine: `Ajout manuel${f.note.trim() ? ` — ${f.note.trim()}` : ""}`,
      creeLe: new Date().toISOString(),
      creePar: user.nom,
    };
    await persistCreditsTranches([...(creditsTranches || []), entree]);
    await journaliserMouvementsCredit([
      { produitId: entree.produitId, libelle: entree.libelle, sens: "credit", quantite: entree.quantite, origine: entree.origine },
    ]);
    setShowAjoutCreditManuel(false);
  }

  function todayISO() {
    return new Date().toISOString().slice(0, 10);
  }

  function openHistory(item) {
    setHistoryItem(item);
    setShowHistory(true);
  }

  // Step 12 pt.12 (accord Nils du 21/09) : un seuil à 0 ne doit pas déclencher
  // d'alerte simplement parce que le stock est aussi à 0 (cas normal d'un
  // produit qu'on ne réapprovisionne pas en continu) — seul un stock
  // théorique NÉGATIF doit alors alerter. Un seuil strictement positif garde
  // l'ancienne règle (alerte dès que le théorique descend à son niveau).
  function estEnAlerte(g) {
    const seuil = Number(g.produit.seuil) || 0;
    if (seuil > 0) return g.theorique <= seuil;
    return g.theorique < 0;
  }

  // Le stock se lit par produit : « Easy Grey — 13 tranches », déplié en lots.
  // Le filtre épaisseur affine sans casser le regroupement (une crédence peut
  // se faire en 6 comme en 12 selon le stock ou le budget).
  const groupes = useMemo(() => {
    if (!items || !produits) return [];
    const q = query.trim().toLowerCase();
    const normaliserEpaisseur = (s) => (s || "").replace(/\s+/g, "").toLowerCase();
    // L'épaisseur d'un produit est une caractéristique du produit lui-même
    // (celle de l'article Catalogue lié), pas de ses lots — un produit sans
    // aucun lot doit quand même pouvoir être filtré par son épaisseur, et un
    // produit dont l'épaisseur ne correspond pas doit disparaître même s'il
    // a des lots ailleurs. Repli sur le premier lot trouvé si le produit
    // n'est relié à aucun article (créé manuellement dans le Stock).
    function epaisseurNominaleProduit(p, lots) {
      const articleLie = (articles || []).find((a) => a.produitStockId === p.id);
      if (articleLie && articleLie.epaisseurMatiere) return articleLie.epaisseurMatiere;
      const premierAvecEpaisseur = lots.find((l) => l.epaisseur);
      return premierAvecEpaisseur ? premierAvecEpaisseur.epaisseur : null;
    }
    // Même logique que l'épaisseur, pour le choix (1er/2e) — caractéristique
    // du produit (via l'article Catalogue lié), avec repli sur le premier lot.
    function choixNominalProduit(p, lots) {
      const articleLie = (articles || []).find((a) => a.produitStockId === p.id);
      if (articleLie && articleLie.choix) return articleLie.choix;
      const premierAvecChoix = lots.find((l) => l.choix);
      return premierAvecChoix ? premierAvecChoix.choix : null;
    }
    // ERP step 9 : groupe(s) de couleur nominal(aux) d'un produit — comme
    // pour l'épaisseur et le choix, caractéristique du produit via l'article
    // Catalogue lié (Groupe de couleur + Groupe de couleur secondaire), pas
    // des lots. Retourne les deux valeurs sans les distinguer côté filtre.
    function groupesCouleurNominauxProduit(p) {
      const articleLie = (articles || []).find((a) => a.produitStockId === p.id);
      if (!articleLie) return [];
      return [articleLie.groupeCouleur, articleLie.groupeCouleur2].filter(Boolean);
    }
    return produits
      .map((p) => {
        // Nils 09/10 : lot d'origine vidé par la répartition book-match A / B masqué.
        const tous = lotsDuProduit(p.id).filter((l, _, arr) => !lotOrphelinBM(l, arr));
        const geree = categorieGestion(p.categorie);
        const epaisseurApplicable = geree === GESTION_TRANCHE;
        const epaisseurNominale = epaisseurApplicable ? epaisseurNominaleProduit(p, tous) : null;
        const choixNominal = epaisseurApplicable ? choixNominalProduit(p, tous) : null;
        const groupesCouleurNominaux = epaisseurApplicable ? groupesCouleurNominauxProduit(p) : [];
        const tranches = tous.filter((l) => l.type !== TYPE_CHUTE);
        const chutes = tous.filter((l) => l.type === TYPE_CHUTE);
        // Les chutes ne gonflent ni le stock théorique ni le seuil : on ne
        // commande pas de la matière neuve sur la foi de chutes.
        const reel = tranches.reduce((s, l) => s + l.stockReel, 0);
        const reserve = tranches.reduce((s, l) => s + reservedFor(l.id), 0);
        const arrivages = tranches.reduce((s, l) => s + l.arrivages, 0);
        const nbChutes = chutes.reduce((s, l) => s + l.stockReel, 0);
        const lots = afficherChutes ? [...tranches, ...chutes] : tranches;
        return { produit: p, lots, tranches, chutes, reel, reserve, theorique: reel - reserve + arrivages, arrivages, nbChutes, epaisseurApplicable, epaisseurNominale, choixNominal, groupesCouleurNominaux };
      })
      .filter((g) => {
        if (filterCat !== "Toutes" && g.produit.categorie !== filterCat) return false;
        if (filterAutre === "Alerte seulement" && !estEnAlerte(g)) return false;
        if (filterAutre === "Consommable" && estCategorieStockReservee(g.produit.categorie)) return false;
        if (q) {
          const dansNom = g.produit.nom.toLowerCase().includes(q);
          // on cherche aussi sur le nom du fournisseur (« City ») et le fournisseur lui-même
          const dansCorresp = (g.produit.correspondances || []).some(
            (c) => c.nomFournisseur.toLowerCase().includes(q) || c.fournisseur.toLowerCase().includes(q)
          );
          const dansLots = g.lots.some((l) => l.fournisseur.toLowerCase().includes(q));
          if (!dansNom && !dansCorresp && !dansLots) return false;
        }
        // Un filtre épaisseur actif ne montre que les produits gérés en
        // tranche, et parmi eux seulement ceux dont l'épaisseur nominale
        // correspond — les produits à la pièce (Éviers, Accessoires...)
        // n'ont aucune épaisseur, ils disparaissent donc aussi.
        if (filterEpaisseur !== "Toutes") {
          if (!g.epaisseurApplicable) return false;
          if (normaliserEpaisseur(g.epaisseurNominale) !== normaliserEpaisseur(filterEpaisseur)) return false;
        }
        // ERP step 9 : même principe que l'épaisseur — un produit à la
        // pièce (Éviers, Accessoires...) n'a pas de groupe de couleur, il
        // disparaît donc aussi quand ce filtre est actif. Le filtre ne
        // distingue pas groupe principal / secondaire : match si l'un des
        // deux correspond à la couleur choisie.
        if (filterGroupeCouleur !== "Toutes") {
          if (!g.epaisseurApplicable) return false;
          if (!g.groupesCouleurNominaux.includes(filterGroupeCouleur)) return false;
        }
        if (filterAutre === "2e choix seulement") {
          if (!g.epaisseurApplicable) return false;
          if (g.choixNominal !== "2e choix") return false;
        }
        return true;
      })
      .sort((a, b) => a.produit.nom.localeCompare(b.produit.nom, "fr"));
  }, [items, produits, articles, categories, filterCat, filterEpaisseur, filterGroupeCouleur, filterAutre, query, reservations, afficherChutes]);

  const alertCount = groupes.filter((g) => estEnAlerte(g)).length;

  // Catégories proposées au filtre Stock : la liste `stock:categories` gérée
  // à part, complétée par celles réellement portées par les produits liés au
  // Catalogue (synchronisation automatique à la sauvegarde d'un article) —
  // pour que le filtre reste utilisable même quand la liste gérée n'a pas
  // été tenue à jour pour d'anciens produits.
  const categoriesStockDisponibles = useMemo(() => {
    const noms = new Set((categories || []).map((c) => c.name));
    (produits || []).forEach((p) => { if (p.categorie) noms.add(p.categorie); });
    return Array.from(noms).sort((a, b) => a.localeCompare(b, "fr"));
  }, [categories, produits]);

  const fournisseursFiltres = useMemo(() => {
    if (!fournisseurs) return [];
    const q = fourQuery.trim().toLowerCase();
    return fournisseurs.filter((f) => !q || f.nom.toLowerCase().includes(q));
  }, [fournisseurs, fourQuery]);

  const certifAlertCount = (fournisseurs || []).filter((f) => fournisseurAlertes(f).length > 0).length;

  const produitsDeCategorie = useMemo(() => {
    let liste = (produits || []).filter((p) => p.categorie === lotCategorie);
    if (lotRechercheDesignation.trim()) {
      const q = lotRechercheDesignation.trim().toLowerCase();
      liste = liste.filter((p) => p.nom.toLowerCase().includes(q));
    }
    if (lotFiltreDimension || lotFiltreEpaisseur || lotFiltreGroupeCouleur) {
      liste = liste.filter((p) => {
        const article = (articles || []).find((a) => a.produitStockId === p.id);
        // Un produit sans article Catalogue lié n'a pas de dimension/épaisseur
        // à comparer — on le garde plutôt que de le faire disparaître à tort.
        if (!article) return true;
        if (lotFiltreDimension && article.dimension !== lotFiltreDimension) return false;
        if (lotFiltreEpaisseur && article.epaisseurMatiere !== lotFiltreEpaisseur) return false;
        // Groupe de couleur : uniquement pertinent pour les Tranches (ERP step 7).
        if (lotFiltreGroupeCouleur && article.categorie === "Tranche" && article.groupeCouleur !== lotFiltreGroupeCouleur && article.groupeCouleur2 !== lotFiltreGroupeCouleur) return false;
        return true;
      });
    }
    return liste;
  }, [produits, lotCategorie, lotRechercheDesignation, lotFiltreDimension, lotFiltreEpaisseur, lotFiltreGroupeCouleur, articles]);

  // Avertissement (jamais un blocage) : le BC saisi réserve déjà un autre lot
  // du même produit — donc potentiellement une autre nuance.
  const melangeBc = useMemo(() => {
    if (!reservationItem || !resBc.trim()) return null;
    const p = produitDe(reservationItem.produitId);
    if (!p || !categorieNuances(p.categorie)) return null;
    const autresLots = lotsDuProduit(p.id).filter((l) => l.id !== reservationItem.id).map((l) => l.id);
    const conflit = (reservations || []).some(
      (r) => r.statut === "active" && r.bc.trim().toLowerCase() === resBc.trim().toLowerCase() && autresLots.includes(r.itemId)
    );
    return conflit ? resBc.trim() : null;
  }, [reservationItem, resBc, reservations, items, produits, categories]);

  async function persistDevis(next) {
    setDevisListe(next);
    return await saveKey(DEVIS_KEY, next);
  }
  async function persistCommandes(next) {
    setCommandesListe(next);
    return await saveKey(COMMANDES_KEY, next);
  }
  async function persistEnAttenteParStatut(next) {
    setEnAttenteParStatut(next);
    return await saveKey(EN_ATTENTE_STATUT_KEY, next);
  }
  // Gère la liste "En attente de" propre à un statut donné — chaque statut a
  // sa propre liste indépendante (BDC, RDM, PL, BL, Facture).
  function ajouterOptionEnAttente(statut, valeur) {
    const v = valeur.trim();
    const listeActuelle = (enAttenteParStatut || DEFAULT_EN_ATTENTE_PAR_STATUT)[statut] || [];
    if (!v) { setNotice(`Écris d'abord la nouvelle option dans le champ « Nouvelle option pour ${statut} », puis clique sur « + Ajouter » (ou Entrée).`); return false; }
    if (listeActuelle.includes(v)) { setNotice(`« ${v} » existe déjà pour ${statut}.`); return false; }
    persistEnAttenteParStatut({ ...(enAttenteParStatut || DEFAULT_EN_ATTENTE_PAR_STATUT), [statut]: [...listeActuelle, v] });
  }
  function supprimerOptionEnAttente(statut, valeur) {
    const utiliseePar = (commandesListe || []).filter((c) => c.statut === statut && c.enAttenteDe === valeur);
    if (utiliseePar.length > 0) {
      setNotice(`Impossible de supprimer « ${valeur} » : ${utiliseePar.length} dossier(s) au statut ${statut} l'utilisent. Change leur "En attente de" avant de la supprimer.`);
      return;
    }
    const listeActuelle = (enAttenteParStatut || DEFAULT_EN_ATTENTE_PAR_STATUT)[statut] || [];
    persistEnAttenteParStatut({ ...(enAttenteParStatut || DEFAULT_EN_ATTENTE_PAR_STATUT), [statut]: listeActuelle.filter((x) => x !== valeur) });
  }
  // ---- ERP step 11 : outillage ----
  const peutGererOutillage = peut("outillage.gerer") || peut("outillage.bureautique");
  function peutGererFamille(f) {
    return f === "bureautique" ? peut("outillage.bureautique") : peut("outillage.gerer");
  }
  // Famille affichée : celle choisie si l'utilisateur la gère, sinon la sienne.
  const familleVue = peutGererFamille(familleOutillage) ? familleOutillage : peut("outillage.gerer") ? "outillage" : "bureautique";
  const estBureautique = familleVue === "bureautique";
  const peutCategoriesFamille = estBureautique ? peut("outillage.bureautique") : peut("outillage.categories");
  async function persistOutils(next) {
    setOutils(next);
    return await saveKey(OUTILLAGE_KEY, next);
  }
  async function persistControlesOutillage(next) {
    setControlesOutillage(next);
    return await saveKey(CONTROLES_OUTILLAGE_KEY, next);
  }
  function nomAffectation(id) {
    const a = (affectations || []).find((x) => x.id === id);
    return a ? a.nom : "—";
  }
  function iconeAffectation(a) {
    return !a ? "" : a.type === "machine" ? "⚙ " : a.type === "service" ? "👥 " : a.type === "bureau" ? "🏢 " : a.type === "lieu" ? "📍 " : "👤 ";
  }
  function prochainNumeroOutil(f) {
    const prefixe = f === "bureautique" ? "BUR-" : "OUT-";
    let max = 0;
    (outils || []).forEach((o) => {
      if (!String(o.numero || "").startsWith(prefixe)) return;
      const n = parseInt(String(o.numero || "").slice(prefixe.length), 10);
      if (!isNaN(n) && n > max) max = n;
    });
    return `${prefixe}${String(max + 1).padStart(3, "0")}`;
  }
  // Catégories d'outils : liste gérée (Nils, Ahmed, Wissam, Krim), comme les
  // conditions de paiement ; suppression impossible si un outil l'utilise.
  // Nils 03/10 (i) : la bureautique a sa propre liste (parametres.categoriesBureautique).
  function categoriesOutil(f = familleVue) {
    const c = parametres && (f === "bureautique" ? parametres.categoriesBureautique : parametres.categoriesOutil);
    const l = trierAlpha(Array.isArray(c) ? c : f === "bureautique" ? CATEGORIES_BUREAUTIQUE : CATEGORIES_OUTIL);
    return [...l.filter((x) => x !== "Autre"), ...l.filter((x) => x === "Autre")];
  }
  const cleCategoriesFamille = estBureautique ? "categoriesBureautique" : "categoriesOutil";
  async function ajouterCategorieOutil() {
    if (!peutCategoriesFamille) return;
    const v = nouvelleCategorieOutil.trim();
    if (!v) return;
    if (categoriesOutil().some((x) => x.toLowerCase() === v.toLowerCase())) { setNotice("Cette catégorie existe déjà."); return; }
    await persistParametres({ ...(parametres || {}), [cleCategoriesFamille]: [...categoriesOutil(), v] });
    await tracerAcces(`catégorie ${estBureautique ? "bureautique" : "d'outil"} ajoutée`, v);
    setNouvelleCategorieOutil("");
  }
  async function supprimerCategorieOutil(cat) {
    if (!peutCategoriesFamille) return;
    const utilisee = (outils || []).filter((o) => familleOutil(o) === familleVue && o.categorie === cat);
    if (utilisee.length > 0) { setNotice(`Impossible de supprimer « ${cat} » : ${utilisee.length} objet(s) l'utilisent (${utilisee.slice(0, 5).map((o) => o.numero).join(", ")}${utilisee.length > 5 ? "…" : ""}). Change d'abord leur catégorie.`); return; }
    await persistParametres({ ...(parametres || {}), [cleCategoriesFamille]: categoriesOutil().filter((x) => x !== cat) });
  }
  async function renommerCategorieOutil(ancien, nouveau) {
    if (!peutCategoriesFamille) return;
    const v = (nouveau || "").trim();
    if (!v || v === ancien) return;
    if (categoriesOutil().some((x) => x.toLowerCase() === v.toLowerCase())) { setNotice("Cette catégorie existe déjà."); return; }
    await persistParametres({ ...(parametres || {}), [cleCategoriesFamille]: categoriesOutil().map((x) => (x === ancien ? v : x)) });
    if ((outils || []).some((o) => familleOutil(o) === familleVue && o.categorie === ancien)) await persistOutils((outils || []).map((o) => (familleOutil(o) === familleVue && o.categorie === ancien ? { ...o, categorie: v } : o)));
  }
  // ERP step 12 (Nils 30/09) : Ahmed et Wissam demandent une catégorie, Nils valide
  // (comme les demandes de fournisseur / d'article).
  function demandesCategoriesOutil() {
    const d = parametres && parametres.demandesCategoriesOutil;
    return Array.isArray(d) ? d : [];
  }
  async function demanderCategorieOutil() {
    if (!peut("outillage.gerer") || peut("outillage.categories") || estBureautique) return;
    const v = nouvelleCategorieOutil.trim();
    if (!v) return;
    if (categoriesOutil().some((x) => x.toLowerCase() === v.toLowerCase())) { setNotice("Cette catégorie existe déjà."); return; }
    if (demandesCategoriesOutil().some((x) => x.statut === "en attente" && x.nom.toLowerCase() === v.toLowerCase())) { setNotice("Cette catégorie est déjà demandée."); return; }
    await persistParametres({ ...(parametres || {}), demandesCategoriesOutil: [...demandesCategoriesOutil(), { id: uid(), nom: v, par: user.nom, le: new Date().toISOString(), statut: "en attente" }] });
    await alerter("Demande de catégorie d'outil", `« ${v} » demandée par ${user.nom}`, { kind: "onglet", id: "outillage" });
    await tracerAcces("demande de catégorie d'outil", v);
    setNouvelleCategorieOutil("");
    setNotice(`Catégorie « ${v} » demandée — le Gérant doit la valider.`);
  }
  async function traiterDemandeCategorieOutil(id, accepter) {
    if (!peut("outillage.categories")) return;
    const d = demandesCategoriesOutil().find((x) => x.id === id);
    if (!d) return;
    const cats = accepter && !categoriesOutil().some((x) => x.toLowerCase() === d.nom.toLowerCase()) ? [...categoriesOutil(), d.nom] : categoriesOutil();
    await persistParametres({ ...(parametres || {}), categoriesOutil: cats, demandesCategoriesOutil: demandesCategoriesOutil().map((x) => (x.id === id ? { ...x, statut: accepter ? "créée" : "refusée", traitePar: user.nom, traiteLe: new Date().toISOString() } : x)) });
    await tracerAcces(accepter ? "catégorie d'outil créée (demande)" : "demande de catégorie d'outil refusée", `${d.nom} (demandée par ${d.par})`);
  }
  function outilActif(o) {
    return o.etat === "En service" || o.etat === "En réparation";
  }
  function coutReparationsOutil(o) {
    return (o.historique || []).filter((h) => h.type === "retour réparation").reduce((n, h) => n + (Number(h.cout) || 0), 0);
  }
  async function enregistrerOutil() {
    if (!outilEdit || !peutGererFamille(familleOutil(outilEdit))) return;
    const o = outilEdit;
    if (!(o.designation || "").trim()) { setNotice(familleOutil(o) === "bureautique" ? "Indique la désignation du matériel." : "Indique la désignation de l'outil."); return; }
    const maintenant = new Date().toISOString();
    const existe = !!o.id && (outils || []).some((x) => x.id === o.id);
    let toSave = { ...o, designation: o.designation.trim(), modifiePar: user.nom, modifieLe: maintenant };
    if (!peutVoirCoutsOutillage) {
      const avant = (outils || []).find((x) => x.id === o.id);
      toSave.prixAchatHT = avant ? avant.prixAchatHT : "";
    }
    if (!existe) {
      toSave = {
        ...toSave,
        id: uid(),
        numero: prochainNumeroOutil(familleOutil(toSave)),
        etat: "En service",
        creePar: user.nom,
        creeLe: maintenant,
        historique: toSave.detenteurId ? [{ id: uid(), type: "affectation", date: todayISO(), vers: toSave.detenteurId, note: "Mise en service", par: user.nom, le: maintenant }] : [],
      };
      await persistOutils([...(outils || []), toSave]);
      await tracerAcces("outil créé", `${toSave.numero} ${toSave.designation}${toSave.detenteurId ? ` → ${nomAffectation(toSave.detenteurId)}` : ""}`);
      if (toSave.detenteurId) await alerter("Outil remis", `${toSave.numero} ${toSave.designation} (neuf) remis à ${nomAffectation(toSave.detenteurId)} par ${user.nom}`, { kind: "onglet", id: "outillage" });
    } else {
      await persistOutils((outils || []).map((x) => (x.id === toSave.id ? toSave : x)));
    }
    setOutilEdit(toSave);
    setNotice(`Outil ${toSave.numero} enregistré.`);
  }
  const peutVoirCoutsOutillage = peutGererFamille(familleVue);
  // Action sur un outil : transfert, incident, retour de réparation, mise au rebut.
  async function appliquerActionOutil() {
    if (!outilAction || !outilEdit || !peutGererFamille(familleOutil(outilEdit))) return;
    const a = outilAction;
    const o = (outils || []).find((x) => x.id === outilEdit.id);
    if (!o) return;
    const maintenant = new Date().toISOString();
    const date = a.date || todayISO();
    let patch = {};
    let h = { id: uid(), date, par: user.nom, le: maintenant, note: (a.note || "").trim() };
    if (a.type === "transfert") {
      if (!a.vers || a.vers === o.detenteurId) { setNotice("Choisis à qui / où l'outil est remis."); return; }
      h = { ...h, type: "affectation", de: o.detenteurId || "", vers: a.vers };
      patch = { detenteurId: a.vers };
    } else if (a.type === "incident") {
      if (!a.incident) { setNotice("Choisis le type d'incident."); return; }
      const suite = a.incident === "Perte" || a.incident === "Vol" ? "Perdu / volé" : a.suite === "reparation" ? "En réparation" : "Hors service";
      h = { ...h, type: "incident", incident: a.incident, detenteur: o.detenteurId || "", imputeA: a.imputeA || "", reparateur: suite === "En réparation" ? (a.reparateur || "").trim() : "", suite };
      patch = { etat: suite };
    } else if (a.type === "retour") {
      h = { ...h, type: "retour réparation", cout: a.cout === "" || a.cout === undefined ? "" : Number(a.cout) };
      patch = { etat: "En service" };
    } else if (a.type === "rebut") {
      h = { ...h, type: "rebut" };
      patch = { etat: "Hors service" };
    } else if (a.type === "sortie") {
      if (!a.motif) { setNotice("Choisis le motif de la sortie du parc."); return; }
      if (!a.date) { setNotice("Indique la date de sortie."); return; }
      h = { ...h, type: "sortie", motif: a.motif, detenteur: o.detenteurId || "" };
      patch = { etat: ETAT_SORTI_PARC, detenteurId: "", sortieParc: { date, motif: a.motif, par: user.nom } };
    }
    const maj = { ...o, ...patch, historique: [...(o.historique || []), h], modifiePar: user.nom, modifieLe: maintenant };
    await persistOutils((outils || []).map((x) => (x.id === o.id ? maj : x)));
    if (a.type === "transfert") {
      await alerter("Outil remis", `${o.numero} ${o.designation} remis à ${nomAffectation(a.vers)}${o.detenteurId ? ` (avant : ${nomAffectation(o.detenteurId)})` : ""} par ${user.nom}`, { kind: "onglet", id: "outillage" });
    }
    if (a.type === "sortie" && !estGerant) {
      await alerter("Sorti du parc", `${o.numero} ${o.designation} — ${a.motif}${o.detenteurId ? ` (détenu par ${nomAffectation(o.detenteurId)})` : ""} — par ${user.nom}${h.note ? ` — ${h.note}` : ""}`, { kind: "onglet", id: "outillage" });
    }
    if (a.type === "incident") {
      await alerter(`Outil : ${a.incident.toLowerCase()}`, `${o.numero} ${o.designation} — détenteur : ${nomAffectation(o.detenteurId)}${a.imputeA ? ` — imputé à ${nomAffectation(a.imputeA)}` : ""}${h.note ? ` — ${h.note}` : ""}`, { kind: "onglet", id: "outillage" });
    }
    await tracerAcces(`outil : ${h.type}${h.incident ? ` (${h.incident})` : ""}`, `${o.numero} ${o.designation}${h.vers ? ` → ${nomAffectation(h.vers)}` : ""}`);
    setOutilEdit(maj);
    setOutilAction(null);
    setNotice(`${o.numero} mis à jour.`);
  }
  // Nils 04/10 (g) : suppression d'une erreur de saisie — jamais remis à quelqu'un d'autre, jamais réparé ni sorti.
  function outilSupprimable(o) {
    if (!o || !o.id) return false;
    const h = o.historique || [];
    return h.every((x) => x.type === "affectation" && x.note === "Mise en service") && h.length <= 1 && o.etat === "En service";
  }
  async function supprimerOutil(o) {
    if (!o || !peutGererFamille(familleOutil(o))) return;
    if (!outilSupprimable(o)) { setNotice(`${o.numero} a déjà un historique : utilise « Sortir du parc » plutôt que la suppression.`); return; }
    if (!await demander(`Supprimer ${o.numero} — ${o.designation} ? (erreur de saisie)`)) return;
    await persistOutils((outils || []).filter((x) => x.id !== o.id));
    await tracerAcces("outil supprimé (erreur de saisie)", `${o.numero} ${o.designation}`);
    setOutilEdit(null);
    setOutilAction(null);
    setNotice(`${o.numero} supprimé.`);
  }
  // Contrôle mensuel : « qui a quoi ? ».
  // Nils 03/10 (i) : un contrôle par famille — outillage tous les mois (Ahmed),
  // bureautique tous les six mois (inventaire, Sawsan). Les anciens contrôles = outillage.
  function controleOuvert(f) {
    return (controlesOutillage || []).find((c) => !c.clotureLe && (c.famille || "outillage") === f) || null;
  }
  const controleOutillageOuvert = controleOuvert("outillage");
  function dernierControle(f) {
    return (controlesOutillage || []).filter((c) => c.clotureLe && (c.famille || "outillage") === f).sort((a, b) => (a.clotureLe < b.clotureLe ? 1 : -1))[0] || null;
  }
  function periodeControle(f) {
    return f === "bureautique" ? PERIODE_INVENTAIRE_BUREAUTIQUE_JOURS : PERIODE_CONTROLE_OUTILLAGE_JOURS;
  }
  function controleDu(f) {
    const d = dernierControle(f);
    if (!d) return (outils || []).some((o) => outilActif(o) && familleOutil(o) === f);
    return joursDepuis(d.clotureLe) >= periodeControle(f);
  }
  function controleOutillageDu() {
    return controleDu("outillage");
  }
  function peutLancerControle(f) {
    return f === "bureautique" ? peut("outillage.bureautique") : peut("outillage.controle");
  }
  const libControle = (f) => (f === "bureautique" ? "inventaire bureautique" : "contrôle outillage");
  async function lancerControle(f) {
    if (!peutLancerControle(f) || controleOuvert(f)) return;
    const lignes = {};
    (outils || []).filter((o) => outilActif(o) && familleOutil(o) === f).forEach((o) => { lignes[o.id] = { detenteurId: o.detenteurId || "", resultat: "" }; });
    await persistControlesOutillage([...(controlesOutillage || []), { id: uid(), famille: f, ouvertLe: new Date().toISOString(), ouvertPar: user.nom, lignes }]);
    await tracerAcces(`${libControle(f)} lancé`, `${Object.keys(lignes).length} objet(s)`);
    setVueOutillage("controle");
  }
  async function pointerOutil(f, outilId, resultat) {
    const c = controleOuvert(f);
    if (!peutGererFamille(f) || !c) return;
    const maj = { ...c, lignes: { ...c.lignes, [outilId]: { ...(c.lignes[outilId] || {}), resultat, par: user.nom, le: new Date().toISOString() } } };
    await persistControlesOutillage((controlesOutillage || []).map((x) => (x.id === c.id ? maj : x)));
  }
  async function cloturerControle(f) {
    const c = controleOuvert(f);
    if (!peutLancerControle(f) || !c) return;
    const nonPointes = Object.values(c.lignes).filter((l) => !l.resultat).length;
    if (nonPointes > 0) { setNotice(`${nonPointes} objet(s) pas encore pointé(s) — pointe-les « présent » ou « manquant » avant de clôturer.`); return; }
    const manquants = Object.entries(c.lignes).filter(([, l]) => l.resultat === "manquant").map(([id, l]) => { const o = (outils || []).find((x) => x.id === id); return o ? `${o.numero} ${o.designation} (${nomAffectation(l.detenteurId)})` : id; });
    await persistControlesOutillage((controlesOutillage || []).map((x) => (x.id === c.id ? { ...x, clotureLe: new Date().toISOString(), cloturePar: user.nom, nbManquants: manquants.length } : x)));
    if (manquants.length > 0) await alerter(f === "bureautique" ? "Inventaire bureautique : matériel manquant" : "Contrôle outillage : outils manquants", manquants.join(" ; "), { kind: "onglet", id: "outillage" });
    await tracerAcces(`${libControle(f)} clôturé`, `${Object.keys(c.lignes).length} objet(s), ${manquants.length} manquant(s)`);
    setNotice(`${f === "bureautique" ? "Inventaire" : "Contrôle"} clôturé — ${manquants.length} manquant(s).`);
  }
  // Fiche de remise imprimable (outils détenus par une personne / un lieu).
  // ERP step 12 (Nils 30/09) : fiche de remise et d'engagement de responsabilité,
  // à faire signer à l'employé. `outilIds` : seulement ces outils (bon d'une remise).
  function imprimerRemiseOutils(affId, outilIds) {
    const a = (affectations || []).find((x) => x.id === affId);
    const fiche = (staff || []).find((x) => x.id === affId);
    const liste = (outils || []).filter((o) => o.detenteurId === affId && outilActif(o) && (outilIds ? outilIds.includes(o.id) : familleOutil(o) === familleVue));
    const bur = liste.length > 0 ? familleOutil(liste[0]) === "bureautique" : estBureautique;
    const motMat = bur ? "le matériel bureautique" : "l'outillage";
    const e = (x) => String(x ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;");
    const avecValeur = peutVoirCoutsOutillage;
    const total = liste.reduce((n, o) => n + (Number(o.prixAchatHT) || 0), 0);
    const depuis = (o) => { const h = [...(o.historique || [])].filter((x) => x.type === "affectation" && x.vers === affId).sort((x, y) => ((x.date || "") < (y.date || "") ? 1 : -1))[0]; return h ? formatDate(h.date) : ""; };
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>${bur ? "Remise de matériel bureautique" : "Remise d'outillage"}</title><style>
body{font-family:Arial,sans-serif;font-size:12px;margin:28px;color:#222}h1{font-size:17px;margin:0 0 4px}h2{font-size:13px;margin:18px 0 6px}
table{width:100%;border-collapse:collapse;margin-top:8px}td,th{border:1px solid #999;padding:5px 6px;text-align:left;vertical-align:top}th{background:#f0ede9}
.id td{border:none;padding:2px 12px 2px 0}.sig{display:flex;justify-content:space-between;gap:30px;margin-top:36px}.sig div{flex:1;border-top:1px solid #999;padding-top:6px;min-height:70px}
ol{padding-left:18px;line-height:1.5}.petit{font-size:10px;color:#666}
</style></head><body>
<h1>Stone Concept — Fiche de remise ${bur ? "de matériel bureautique" : "d'outillage"} et engagement de responsabilité</h1>
<div class="petit">Document établi le ${e(formatDate(todayISO()))}</div>
<h2>Salarié</h2>
<table class="id"><tr><td>Nom et prénom : <strong>${e(fiche ? fiche.nom : a ? a.nom : "—")}</strong></td><td>Poste : ${e(fiche ? fiche.poste || "—" : "—")}</td><td>Service : ${e(fiche ? fiche.service || "—" : "—")}</td></tr></table>
<h2>${bur ? "Matériel remis" : "Outillage remis"} (${liste.length})</h2>
<table><tr><th>N°</th><th>Désignation</th><th>Marque / modèle</th><th>N° de série</th><th>Remis le</th><th>État à la remise</th>${avecValeur ? "<th>Valeur d'achat HT</th>" : ""}</tr>
${liste.map((o) => `<tr><td>${e(o.numero)}</td><td>${e(o.designation)}</td><td>${e([o.marque, o.modele].filter(Boolean).join(" "))}</td><td>${e(o.serie)}</td><td>${e(depuis(o))}</td><td>${e(o.etat === "En service" ? "Bon état de fonctionnement" : o.etat)}</td>${avecValeur ? `<td>${o.prixAchatHT !== "" && o.prixAchatHT !== undefined ? e(formatDH(Number(o.prixAchatHT) || 0)) : "—"}</td>` : ""}</tr>`).join("")}
${avecValeur ? `<tr><td colspan="6" style="text-align:right"><strong>Valeur totale</strong></td><td><strong>${e(formatDH(total))}</strong></td></tr>` : ""}
</table>
<h2>Engagement du salarié</h2>
<p>Je soussigné(e) reconnais avoir reçu de la société Stone Concept ${motMat} listé ci-dessus, en bon état de fonctionnement, et je m'engage à :</p>
<ol>
<li>l'utiliser exclusivement pour mon travail ${bur ? "au service de Stone Concept" : "à l'atelier ou sur les chantiers de Stone Concept"} ;</li>
<li>l'utiliser conformément aux consignes et aux règles de sécurité, en prendre soin et le ranger après usage ;</li>
<li>signaler immédiatement à mon responsable toute casse, panne, perte ou vol ;</li>
<li>ne pas le prêter ni le confier à un tiers sans l'accord de mon responsable ;</li>
<li>le restituer sur simple demande, et au plus tard à mon départ de l'entreprise, dans l'état où je l'ai reçu (usure normale exceptée) ;</li>
<li>accepter que ma responsabilité puisse être engagée en cas de perte, de vol ou de dégradation résultant d'une négligence ou d'une mauvaise utilisation, conformément au règlement intérieur et à la législation du travail en vigueur.</li>
</ol>
<p>Cette fiche est conservée dans mon dossier. ${bur ? "Un inventaire du matériel bureautique est effectué tous les six mois." : "Un contrôle de l'outillage est effectué chaque mois."}</p>
<div class="sig"><div>Le salarié — « Lu et approuvé », date et signature</div><div>Pour Stone Concept — Nom : ____________________<br>Date et signature</div></div>
</body></html>`;
    telechargerDocument(html, `${bur ? "remise-bureautique" : "remise-outillage"}-${(fiche ? fiche.nom : a ? a.nom : "detenteur").replace(/[^A-Za-z0-9]+/g, "-")}-${todayISO()}`, "fiche de remise outillage");
  }
  // Fiche personne : outils détenus, incidents, consommables lents mis en service.
  function fichePersonne(affId) {
    const a = (affectations || []).find((x) => x.id === affId);
    if (!a) return null;
    const detenus = (outils || []).filter((o) => o.detenteurId === affId && outilActif(o));
    const incidents = [];
    (outils || []).forEach((o) => (o.historique || []).forEach((h) => {
      if (h.type === "incident" && (h.detenteur === affId || h.imputeA === affId)) incidents.push({ o, h });
    }));
    const conso = (enService || []).filter((x) => x.affectationId === affId);
    const debut = a.dateEmbauche || (conso.length ? conso.map((x) => x.misEnServiceLe).sort()[0] : null);
    const annees = debut ? Math.max(joursDepuis(debut) / 365.25, 1 / 12) : null;
    const parProduit = new Map();
    conso.forEach((x) => {
      const k = nomProduit(x.produitId);
      const v = parProduit.get(k) || { n: 0, cout: 0, sansPrix: 0 };
      v.n += 1;
      if (x.prixUnitaireHT === null || x.prixUnitaireHT === undefined) v.sansPrix += 1;
      else v.cout += Number(x.prixUnitaireHT) || 0;
      parProduit.set(k, v);
    });
    return { a, detenus, incidents, parProduit: [...parProduit.entries()], debut, annees };
  }
  async function enregistrerDateEmbauche(affId, date) {
    if (!peut("staff.gerer")) return;
    // ERP step 12 : la date d'embauche vit sur la fiche Staff.
    if ((staff || []).some((s) => s.id === affId)) {
      await persistStaff((staff || []).map((s) => (s.id === affId ? { ...s, dateEmbauche: date, modifiePar: user.nom, modifieLe: new Date().toISOString() } : s)));
      return;
    }
    await persistAffectations((affectationsBrutes || []).map((x) => (x.id === affId ? { ...x, dateEmbauche: date } : x)));
  }

  // ---- ERP step 11 : SAV ----
  async function persistSav(next) {
    setSavListe(next);
    return await saveKey(SAV_KEY, next);
  }
  function motifsSav() {
    const m = parametres && parametres.motifsSAV;
    return Array.isArray(m) && m.length > 0 ? m : DEFAULT_MOTIFS_SAV;
  }
  function delaiSavJours() {
    const v = parametres && parametres.delaiSAVJours;
    return typeof v === "number" && v >= 0 ? v : DELAI_SAV_JOURS;
  }
  function commandeOrigineSav(t) {
    return (commandesListe || []).find((c) => c.id === (t && t.commandeOrigineId)) || null;
  }
  function devisDeCommande(c) {
    return c ? (devisListe || []).find((d) => d.id === c.devisId) || null : null;
  }
  // Nils 02/11 : SAV d'une commande antérieure à l'ERP — origine saisie (facture antérieure ou n° libre).
  function origineAnterieureSav(t) {
    return t && !t.commandeOrigineId && t.origineAnterieure ? t.origineAnterieure : null;
  }
  function idCommercialDuClient(clientId) {
    const cl = clientDe(clientId);
    if (!cl) return null;
    if (cl.commercialId) return cl.commercialId;
    const u = utilisateurs.find((x) => x.nom === cl.commercialSC);
    return u ? u.id : null;
  }
  function libOrigineSav(t, court) {
    const co = commandeOrigineSav(t);
    if (co) return court ? co.numeroFacture || co.numeroBL || co.numero : [co.numero, co.numeroBL, co.numeroFacture].filter(Boolean).join(" / ");
    const a = origineAnterieureSav(t);
    if (!a) return "";
    return `${a.numero || "?"} (avant l'ERP${a.date && !court ? `, du ${formatDate(a.date)}` : ""})`;
  }
  function peutOuvrirSavClient(clientId) {
    if (!clientId) return peut("sav.gerer");
    return peut("sav.gerer") || idCommercialDuClient(clientId) === user.id;
  }
  function nouveauTicketSavAnterieur() {
    setSavLienSaisi({ label: "", lien: "" });
    setSavEdit({ id: "", numero: "", commandeOrigineId: "", clientId: "", origineAnterieure: { factureAntId: "", numero: "", date: "", description: "" }, motif: "", description: "", dateReclamation: todayISO(), liens: [], statut: "Ouvert", intervention: { date: "", intervenant: "", compteRendu: "" }, couts: { mainOeuvre: "", deplacement: "", autre: "" }, devisSavId: "" });
  }
  // Pilote = commercial du dossier d'origine (avant l'ERP : celui de la fiche client) ; à défaut Karima et Souad.
  function pilotesSav(t) {
    const co = commandeOrigineSav(t);
    const com = co ? idCommercialDuDevis(devisDeCommande(co)) : origineAnterieureSav(t) ? idCommercialDuClient(t.clientId) : null;
    return com ? [com] : qui(P_ADV_SR, P_ADV_JR);
  }
  function nomsUtilisateurs(ids) {
    return ids.map((id) => (utilisateurs.find((u) => u.id === id) || {}).nom || id).join(", ");
  }
  function peutOuvrirSav(commande) {
    if (!commande) return false;
    if (peut("sav.gerer")) return true;
    return idCommercialDuDevis(devisDeCommande(commande)) === user.id;
  }
  function peutGererSav(t) {
    if (!t) return false;
    if (peut("sav.gerer")) return true;
    return pilotesSav(t).includes(user.id);
  }
  function devisSavDe(t) {
    return t && t.devisSavId ? (devisListe || []).find((d) => d.id === t.devisSavId) || null : null;
  }
  function commandeSavDe(t) {
    const d = devisSavDe(t);
    return d ? (commandesListe || []).find((c) => c.devisId === d.id) || null : null;
  }
  function joursDepuis(dateISO) {
    if (!dateISO) return 0;
    const d0 = new Date(`${dateISO.slice(0, 10)}T00:00:00`);
    const d1 = new Date(`${todayISO()}T00:00:00`);
    return Math.round((d1 - d0) / 86400000);
  }
  // Intervenu = intervention notée sur le ticket, ou dossier SAV livré (BL / Facture).
  function savIntervenu(t) {
    if (t.statut === "Intervenu" || t.statut === "Clôturé") return true;
    const c = commandeSavDe(t);
    return !!(c && ["BL", "Facture"].includes(c.statut));
  }
  function savEnRetard(t) {
    return t.statut !== "Clôturé" && !savIntervenu(t) && joursDepuis(t.dateReclamation) > delaiSavJours();
  }
  function statutAfficheSav(t) {
    if (t.statut === "Clôturé") return "Clôturé";
    if (t.statut === "Intervenu") return "Intervenu — à clôturer";
    const c = commandeSavDe(t);
    if (c) return `Dossier SAV : ${c.statut}${["BL", "Facture"].includes(c.statut) ? " — à clôturer" : ""}`;
    if (devisSavDe(t)) return "Devis SAV en cours";
    return "Ouvert";
  }
  // Coût matière : sorties + consommables du PL du dossier SAV, plus les
  // consommables « atelier » dont le motif cite le n° du ticket.
  function coutMatiereSav(t) {
    const c = commandeSavDe(t);
    const pl = c && c.numeroPL;
    const mvts = (mouvements || []).filter((m) => m.type === "sortie" && ((pl && m.pl === pl) || (m.atelier && t.numero && String(m.motif || "").includes(t.numero))));
    let montant = 0;
    let nonValorises = 0;
    mvts.forEach((m) => {
      const lot = (items || []).find((it) => it.id === m.itemId) || (lotsArchives || []).find((it) => it.id === m.itemId);
      const p = lot && lot.prixAchatHT !== undefined && lot.prixAchatHT !== null && lot.prixAchatHT !== "" ? Number(lot.prixAchatHT) : null;
      if (p === null || isNaN(p)) nonValorises += 1;
      else montant += p * (Number(m.quantite) || 0);
    });
    return { montant, nonValorises, nbMouvements: mvts.length };
  }
  function coutTotalSav(t) {
    const k = t.couts || {};
    const mat = coutMatiereSav(t);
    const autres = (Number(k.mainOeuvre) || 0) + (Number(k.deplacement) || 0) + (Number(k.autre) || 0);
    return { matiere: mat.montant, nonValorises: mat.nonValorises, autres, total: mat.montant + autres };
  }
  function montantFactureSav(t) {
    const c = commandeSavDe(t);
    const d = devisSavDe(t);
    if (!c || c.statut !== "Facture" || !d) return 0;
    return calcTotaux({ ...d, lignes: lignesDuDossier(c) }).totalHT || 0;
  }
  // Nils 01/11 (étape b) : dossier SAV (devis créé depuis un ticket), gratuit s'il ne facture rien,
  // archivé par le Gérant une fois le SAV clôturé.
  function ticketSavDuDossier(c) {
    const d = c ? devisDeCommande(c) : null;
    return d && d.savId ? (savListe || []).find((t) => t.id === d.savId) || null : null;
  }
  function dossierSavGratuit(c) {
    const d = c ? devisDeCommande(c) : null;
    return !!(d && d.savId) && Math.abs(totalDossierTTC(c) || 0) < 0.01;
  }
  function dossierArchive(c) {
    return !!c && c.enAttenteDe === EA_ARCHIVE;
  }
  // Nils 02/11 : gratuité — dossier archivé au PL ou au BL par le Gérant, rien à demander au client.
  function dossierGratuite(c) {
    return dossierArchive(c) && !!c.gratuite;
  }
  function motifGratuite(g) {
    return !g ? "" : g.motif === "Autre" ? (g.precision || "").trim() || "Autre" : g.motif;
  }
  function mentionGratuite(c) {
    return c && dossierGratuite(c) ? `Remise gracieuse — ${motifGratuite(c.gratuite)} — sans facturation` : "";
  }
  async function archiverGratuite() {
    const f = gratuiteForm;
    const c = f && (commandesListe || []).find((x) => x.id === f.id);
    if (!c || !estGerant) return;
    if (!["PL", "BL"].includes(c.statut)) { setNotice("Une gratuité s'archive au stade PL ou BL."); return; }
    if (!f.motif || (f.motif === "Autre" && !(f.precision || "").trim())) { setNotice("Choisis le motif de la gratuité (et précise-le pour « Autre »)."); return; }
    const enc = arrondiH(encaisseDossier(c.id));
    if (enc > 0.01) { setNotice(`Un paiement de ${formatDH(enc)} est affecté au dossier ${c.numero} : déplace-le ou rembourse-le avant de l'archiver en gratuité.`); return; }
    const g = { motif: f.motif, precision: f.motif === "Autre" ? f.precision.trim() : "", le: new Date().toISOString(), par: user.nom, parId: user.id, valeurTTC: arrondiH(totalDossierTTC(c) || 0) };
    const doc = c.numeroBL ? `BL ${c.numeroBL}` : `PL ${c.numeroPL || c.numero}`;
    if (!(await demander(`Archiver le dossier ${c.numero} (${doc}) comme gratuité « ${motifGratuite(g)} » ?\n\nValeur offerte : ${formatDH(g.valeurTTC)} TTC. Rien ne sera demandé au client : le dossier sort des listes de travail, des relances et de son compte, sans facture${c.statut === "PL" ? " ni BL" : ""}. Le ${c.statut === "PL" ? "PL" : "BL"} s'imprimera avec la mention « Remise gracieuse — sans facturation ».`))) return;
    await majDossierDirect(c.id, { enAttenteDe: EA_ARCHIVE, enAttenteAvantGratuite: c.enAttenteDe || "", gratuite: g }, "dossier archivé (gratuité)", `${motifGratuite(g)} — ${formatDH(g.valeurTTC)} TTC`);
    setGratuiteForm(null);
    setNotice(`Dossier ${c.numero} archivé : gratuité « ${motifGratuite(g)} ».`);
  }
  async function desarchiverGratuite(c) {
    if (!c || !estGerant || !dossierGratuite(c)) return;
    if (!(await demander(`Désarchiver le dossier ${c.numero} ?\n\nLa gratuité est annulée : le dossier reprend sa place au stade ${c.statut} et redevient dû par le client.`))) return;
    const { gratuite, enAttenteAvantGratuite, ...reste } = c;
    const annulee = { ...gratuite, annuleeLe: new Date().toISOString(), annuleePar: user.nom };
    const toSave = { ...reste, enAttenteDe: enAttenteAvantGratuite || "", gratuitesAnnulees: [...(c.gratuitesAnnulees || []), annulee], modifiePar: user.nom, modifieLe: new Date().toISOString() };
    await persistCommandes((commandesListe || []).map((x) => (x.id === c.id ? toSave : x)));
    if (commandeEditing && commandeEditing.id === c.id) setCommandeEditing(toSave);
    await tracerAcces("gratuité annulée", `${c.numero} — ${motifGratuite(gratuite)}`);
  }
  // Nils 02/11 : liste des gratuités (Gérant seul) — valeur offerte et coût matière sorti au PL.
  function gratuitesDe(clientId) {
    return (commandesListe || []).filter((c) => dossierGratuite(c) && (!clientId || c.clientId === clientId)).map((c) => {
      const m = estGerant ? margeDossier(c) : null;
      return { c, date: String(c.gratuite.le || "").slice(0, 10), motif: motifGratuite(c.gratuite), valeurTTC: Number(c.gratuite.valeurTTC) || 0, coutMatiere: m ? m.matiere + m.conso : null };
    }).sort((a, b) => (a.date < b.date ? 1 : -1));
  }
  // Mention imprimée sur le BL d'un remplacement gratuit (procédure du 01/11, contrôle fiscal).
  function mentionSavBL(c) {
    if (dossierGratuite(c)) return mentionGratuite(c);
    if (!dossierSavGratuit(c)) return "";
    const t = ticketSavDuDossier(c);
    const co = t ? commandeOrigineSav(t) : null;
    const ant = origineAnterieureSav(t);
    const origine = co ? [co.numeroBL ? `BL n° ${co.numeroBL}` : "", co.numeroFacture ? `FA n° ${co.numeroFacture}` : ""].filter(Boolean).join(" / ") || `BC n° ${co.numero}` : ant ? `${ant.numero} (avant l'ERP)` : "";
    return `Remplacement gratuit au titre de la garantie — SAV n° ${t ? t.numero : "?"} — sans facturation${origine ? ` — dossier d'origine ${origine}` : ""}`;
  }
  function nouveauTicketSav(commande) {
    if (!peutOuvrirSav(commande)) return;
    setSavLienSaisi({ label: "", lien: "" });
    setSavEdit({
      id: "",
      numero: "",
      commandeOrigineId: commande.id,
      clientId: commande.clientId,
      motif: "",
      description: "",
      dateReclamation: todayISO(),
      liens: [],
      statut: "Ouvert",
      intervention: { date: "", intervenant: "", compteRendu: "" },
      couts: { mainOeuvre: "", deplacement: "", autre: "" },
      devisSavId: "",
    });
  }
  function ouvrirTicketSav(id) {
    const t = (savListe || []).find((x) => x.id === id);
    if (!t) return;
    setSavLienSaisi({ label: "", lien: "" });
    setSavEdit(JSON.parse(JSON.stringify({ intervention: { date: "", intervenant: "", compteRendu: "" }, couts: { mainOeuvre: "", deplacement: "", autre: "" }, liens: [], ...t })));
  }
  async function enregistrerTicketSav(patch, message) {
    const base = { ...savEdit, ...(patch || {}) };
    const ant = origineAnterieureSav(base);
    if (!base.commandeOrigineId && !ant) { setNotice("Choisis le dossier d'origine."); return null; }
    if (ant && !base.clientId) { setNotice("Choisis le client."); return null; }
    if (ant && !(ant.numero || "").trim()) { setNotice("Indique le n° de la facture ou du BL d'avant l'ERP."); return null; }
    if (!base.motif) { setNotice("Choisis le motif du SAV (un seul motif par ticket — au besoin, ouvre plusieurs tickets)."); return null; }
    if (!(base.description || "").trim()) { setNotice("Décris la réclamation."); return null; }
    const existe = !!base.id && (savListe || []).some((t) => t.id === base.id);
    if (existe && !peutGererSav(base)) return null;
    if (!existe && !(ant ? peutOuvrirSavClient(base.clientId) : peutOuvrirSav(commandeOrigineSav(base)))) return null;
    const maintenant = new Date().toISOString();
    let toSave = { ...base, modifiePar: user.nom, modifieLe: maintenant };
    // Coûts : Nils seul — sinon on garde ceux déjà enregistrés.
    if (!peut("sav.couts")) {
      const avant = (savListe || []).find((t) => t.id === base.id);
      toSave.couts = (avant && avant.couts) || { mainOeuvre: "", deplacement: "", autre: "" };
    }
    if (!existe) {
      const numeroSav = await numeroDocument("SAV", new Date().getFullYear());
      if (!numeroSav) return null;
      toSave = { ...toSave, id: toSave.id || uid(), numero: numeroSav, creePar: user.nom, creeLe: maintenant };
      await persistSav([...(savListe || []), toSave]);
      await tracerAcces("SAV ouvert", `${toSave.numero} — origine ${libOrigineSav(toSave) || "?"} — ${toSave.motif}`);
      await alerter("SAV ouvert", `${toSave.numero} (${(clientDe(toSave.clientId) || {}).nom || "client ?"}) — ${toSave.motif}`, { kind: "sav", id: toSave.id });
    } else {
      await persistSav((savListe || []).map((t) => (t.id === toSave.id ? toSave : t)));
    }
    setSavEdit(toSave);
    setNotice(message || `SAV ${toSave.numero} enregistré.`);
    return toSave;
  }
  async function creerDevisSav() {
    let t = savEdit;
    if (!t || !peutGererSav(t) || t.devisSavId) return;
    if (!t.id) { t = await enregistrerTicketSav(); if (!t) return; }
    const co = commandeOrigineSav(t);
    const ant = origineAnterieureSav(t);
    // Avant l'ERP : pas de devis d'origine — commercial de la fiche client.
    const dOrig = devisDeCommande(co) || (ant ? { reference: `${ant.numero} (avant l'ERP)`, commercialSC: (clientDe(t.clientId) || {}).commercialSC || "" } : {});
    const maintenant = new Date().toISOString();
    const numeroDev = await numeroDocument("DEV", new Date().getFullYear());
    if (!numeroDev) return;
    const nouveau = {
      id: uid(),
      numero: numeroDev,
      reference: `SAV ${t.numero}${dOrig.reference ? ` — ${dOrig.reference}` : ""}`,
      etage: dOrig.etage || "",
      date: today(),
      clientId: t.clientId,
      chantierId: dOrig.chantierId || "",
      commercialSC: dOrig.commercialSC || "",
      apporteurAffaire: "",
      commercialClient: dOrig.commercialClient || "",
      statut: "Brouillon",
      conditionsPaiement: dOrig.conditionsPaiement || "",
      remiseGlobale: 0,
      exonereTVA: false,
      adresseLivraison: dOrig.adresseLivraison || "",
      poseurMeuble: dOrig.poseurMeuble || "",
      contactSurPlace: dOrig.contactSurPlace || "",
      telephoneSurPlace: dOrig.telephoneSurPlace || "",
      plaquesCuisson: [],
      eviers: [],
      lignes: [],
      notes: [`SAV ${t.numero} — ${t.motif} : ${t.description}`],
      savId: t.id,
      creePar: user.nom,
      creeLe: maintenant,
      modifiePar: user.nom,
      modifieLe: maintenant,
    };
    await persistDevis([...(devisListe || []), nouveau]);
    const tMaj = { ...t, devisSavId: nouveau.id, modifiePar: user.nom, modifieLe: maintenant };
    await persistSav((savListe || []).some((x) => x.id === tMaj.id) ? (savListe || []).map((x) => (x.id === tMaj.id ? tMaj : x)) : [...(savListe || []), tMaj]);
    await tracerAcces("devis SAV créé", `${t.numero} → Devis ${nouveau.numero}`);
    setSavEdit(null);
    setActiveTab("devis");
    setDraft(JSON.parse(JSON.stringify(nouveau)));
    setOpenId(nouveau.id);
    setDraftError("");
    setNotice(`Devis SAV ${nouveau.numero} créé (brouillon) — ajoute les lignes (à 0 DH ou facturées), puis circuit normal.`);
  }
  // Nils 01/11 : photos et documents du ticket déposés sur le serveur (plus de lien Dropbox).
  const [depotSav, setDepotSav] = useState(false);
  async function joindreFichiersSav(files) {
    if (!savEdit) return;
    if (!window.storage || !window.storage.deposerFichier) { setNotice("Le dépôt de fichiers n'est possible qu'avec l'ERP sur son serveur."); return; }
    const element = savEdit.id || uid();
    const ajouts = [];
    setDepotSav(true);
    try {
      for (const file of files) {
        if (!EXTENSIONS_FICHIERS.includes(extensionFichier(file.name))) { setNotice(`« ${file.name} » : type de fichier non accepté. Acceptés : ${TYPES_FICHIERS_LISIBLES}.`); continue; }
        if (file.size > TAILLE_MAX_FICHIER) { setNotice(`« ${file.name} » (${formatTaille(file.size)}) dépasse la limite de 25 Mo.`); continue; }
        const r = await window.storage.deposerFichier(null, file, { cle: SAV_KEY, element });
        if (r.erreur) { setNotice(r.erreur); continue; }
        ajouts.push({ ...r.fichier, par: user.nom, le: new Date().toISOString() });
      }
    } finally {
      setDepotSav(false);
    }
    if (ajouts.length) setSavEdit((prev) => (prev ? { ...prev, id: prev.id || element, fichiers: [...(prev.fichiers || []), ...ajouts] } : prev));
  }
  // Nils 01/11 (étape b) : clôture seulement une fois le BL du dossier SAV établi (le serveur le
  // vérifie aussi) ; le serveur passe alors le dossier en « SAV clôturé » et prévient le Gérant.
  function clotureSavBloquee(t) {
    if (!t || !t.devisSavId) return "";
    const c = commandeSavDe(t);
    if (c && ["BL", "Facture"].includes(c.statut)) return "";
    return `Clôture possible une fois le BL du dossier SAV établi (${c ? `dossier ${c.numero} au statut ${c.statut}` : "devis SAV pas encore transformé en dossier"}).`;
  }
  async function cloturerSav() {
    if (!savEdit || !peutGererSav(savEdit)) return;
    if (!(savEdit.clotureNote || "").trim()) { setNotice("Indique en une phrase ce qui a été fait / la cause retenue avant de clôturer."); return; }
    const bloque = clotureSavBloquee(savEdit);
    if (bloque) { setNotice(bloque); return; }
    const c = commandeSavDe(savEdit);
    const t = await enregistrerTicketSav({ statut: "Clôturé", clotureLe: new Date().toISOString(), cloturePar: user.nom }, c && c.statut === "BL" ? `SAV clôturé. Le dossier ${c.numero} passe en « SAV clôturé » ; le Gérant est prévenu (coûts, archivage).` : "SAV clôturé.");
    if (t && t.statut === "Clôturé") {
      await tracerAcces("SAV clôturé", `${t.numero} — ${t.motif}`);
      setSavEdit(null);
      setTimeout(() => actualiserRef.current(), 300);
    }
  }
  async function marquerSavIntervenu() {
    if (!savEdit || !peutGererSav(savEdit)) return;
    const iv = savEdit.intervention || {};
    if (!iv.date) { setNotice("Indique la date de l'intervention."); return; }
    await enregistrerTicketSav({ statut: "Intervenu" }, "Intervention enregistrée — il reste à clôturer le SAV.");
  }
  async function rouvrirSav() {
    if (!savEdit || !peut("sav.couts")) return;
    const c = commandeSavDe(savEdit);
    if (dossierArchive(c)) { setNotice(`Le dossier SAV ${c.numero} est archivé : désarchive-le d'abord (« En attente de » → « ${EA_SAV_CLOTURE} »).`); return; }
    const t = await enregistrerTicketSav({ statut: "Ouvert", clotureLe: "", cloturePar: "" }, "SAV rouvert.");
    if (t && t.statut === "Ouvert") {
      await tracerAcces("SAV rouvert", t.numero);
      setSavEdit(null);
      setTimeout(() => actualiserRef.current(), 300);
    }
  }
  // Alerte (une fois) quand un SAV dépasse le délai sans intervention.
  useEffect(() => {
    if (loading || !savListe) return;
    const enRetard = savListe.filter((t) => savEnRetard(t) && !t.alerteRetard);
    if (enRetard.length === 0) return;
    (async () => {
      for (const t of enRetard) {
        await alerter("SAV en retard", `${t.numero} (${(clientDe(t.clientId) || {}).nom || "client ?"}) — ${joursDepuis(t.dateReclamation)} j sans intervention (délai ${delaiSavJours()} j) — pilote : ${nomsUtilisateurs(pilotesSav(t))}`, { kind: "sav", id: t.id });
      }
      const ids = new Set(enRetard.map((t) => t.id));
      await persistSav(savListe.map((t) => (ids.has(t.id) ? { ...t, alerteRetard: true } : t)));
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, savListe, commandesListe]);

  // ---- Droits « En attente de » (Paramétrage) ----
  function droitsEnAttentePour(statut, valeur) {
    const perso = ((parametres && parametres.droitsEnAttente) || {})[statut] || {};
    const def = (DEFAULT_DROITS_EN_ATTENTE[statut] || {})[valeur];
    const brut = Array.isArray(perso[valeur]) ? perso[valeur] : Array.isArray(def) ? def : ["*"]; // nouvelle option : tout le monde tant que non réglée
    // Profils (Nils 02/10) : un ancien jeton « personne » devient le jeton de son profil.
    return [...new Set(brut.map((j) => (j === "*" || j === "@commercial" || String(j).startsWith("p:") ? j : `p:${(compteUtilisateurDe(j) || {}).profil || j}`)))];
  }
  // enBase = dossier tel qu'enregistré (valeur actuelle de référence).
  function peutChoisirEnAttente(enBase, valeur) {
    // Nils 02/11 : gratuité archivée — seulement par le bouton « Désarchiver ».
    if (enBase && dossierGratuite(enBase) && (enBase.enAttenteDe || "") !== (valeur || "")) return false;
    // Nils 01/11 : dossier SAV clôturé / archivé — le Gérant seul, « Archivé » seulement après
    // « SAV clôturé » (contrôlé aussi par le serveur).
    if (enBase && (enBase.enAttenteDe || "") !== (valeur || "") && ([EA_SAV_CLOTURE, EA_ARCHIVE].includes(enBase.enAttenteDe) || [EA_SAV_CLOTURE, EA_ARCHIVE].includes(valeur))) {
      if (!estGerant) return false;
      if (valeur === EA_ARCHIVE && enBase.enAttenteDe !== EA_SAV_CLOTURE) return false;
      if (valeur === EA_SAV_CLOTURE && enBase.enAttenteDe !== EA_ARCHIVE) return false;
      return true;
    }
    if (peut("commandes.enAttenteTout")) return true;
    if (!enBase) return true;
    if ((enBase.enAttenteDe || "") === (valeur || "")) return true;
    if (enBase.enAttenteDe === "Autorisation direction") return false;
    const jetons = droitsEnAttentePour(enBase.statut, valeur);
    if (jetons.includes("*") || jetons.includes(user.id) || jetons.includes(`p:${user.profil}`)) return true;
    if (jetons.includes("@commercial")) {
      const d = (devisListe || []).find((x) => x.id === enBase.devisId);
      return idCommercialDuDevis(d) === user.id;
    }
    return false;
  }
  async function basculerDroitEnAttente(statut, valeur, jeton) {
    if (!peut("admin.parametrage")) return;
    const actuel = droitsEnAttentePour(statut, valeur);
    let next;
    if (jeton === "*") next = actuel.includes("*") ? [] : ["*"];
    else next = actuel.includes(jeton) ? actuel.filter((x) => x !== jeton) : [...actuel.filter((x) => x !== "*"), jeton];
    const tous = (parametres && parametres.droitsEnAttente) || {};
    await persistParametres({ ...(parametres || {}), droitsEnAttente: { ...tous, [statut]: { ...(tous[statut] || {}), [valeur]: next } } });
  }

  // ERP step 10 : depuis la sortie de l'éditeur natif claude.ai, un
  // téléchargement déclenché par la page (<a download>) est bloqué — comme
  // pour l'export JSON (Step 9), tous les téléchargements (pièces jointes,
  // devis, BC, BPRDM, PL, BL, facture) passent par la capacité "downloads"
  // de l'environnement, qui demande une confirmation au viewer.
  // Renvoie true si le fichier a été accepté par le viewer.
  async function proposerTelechargement(nomFichier, data) {
    try {
      const downloads = window.claude && (await window.claude.use("downloads"));
      if (downloads) await downloads.save({ filename: nomFichier, data });
      else telechargerParNavigateur(nomFichier, data);
      await tracerAcces("téléchargement / impression", nomFichier);
      return true;
    } catch (err) {
      const code = err && err.code;
      if (code === "declined") setNotice("Téléchargement annulé.");
      else if (code === "rate_limited") setNotice("Une demande de téléchargement est déjà ouverte — valide-la ou attends quelques secondes.");
      else if (code === "rejected_extension" || code === "extension_not_enabled") setNotice(`Ce type de fichier ne peut pas être téléchargé depuis cette page (« ${nomFichier} »). Formats acceptés : pdf, images (jpg, png, gif, webp, svg), docx, xlsx, pptx, csv, txt, html, zip, mp4.`);
      else {
        console.error("Téléchargement échoué", err);
        setNotice("Impossible de télécharger ce fichier — réessaie dans un instant.");
      }
      return false;
    }
  }
  // Fiche de pose — visible dans la fiche dossier à partir du statut PL,
  // reste affichée et modifiable ensuite (BL, Facture inclus), même si le PL
  // est refait : c'est toujours la même fiche, jamais recréée. Modifiable
  // uniquement par Soufiane Krim, Ahmed et Nils ; visible en lecture par
  // tout le monde (comme le reste de la fiche dossier).
  // ERP step 10 pt.3 (accord Nils du 24/09) : informations de la commande
  // affichées automatiquement en tête de la fiche de pose (jamais saisies) —
  // réf. dossier, client (revendeur), couleurs des tranches. Les couleurs
  // sont celles réellement sorties du stock sur le PL du dossier (lots
  // Tranche/chute consommés) ; tant que le PL n'est pas enregistré, on
  // affiche à défaut les Tranches prévues sur les lignes du dossier.
  // ERP step 10 : étage du dossier (copié du devis au BDC ; pour un dossier
  // plus ancien, relu sur le devis d'origine).
  // ERP step 10 (demande Nils du 24/09) : contact + téléphone sur place,
  // saisis sur le devis, copiés sur le dossier au BDC et modifiables sur le
  // dossier pendant toute la procédure ; obligatoires pour passer en BPRDM
  // (ou directement en PL depuis BDC). Dossier plus ancien : relus sur le devis.
  function fichePoseRequise(commande) {
    return lignesContiennentPose(lignesDuDossier(commande), articles);
  }
  // Nils 04/10 (i) : sans article de pose, pas de « Fiche de pose à remplir » au chargement.
  function itemsChargement(commande) {
    return fichePoseRequise(commande) ? CHARGEMENT_ITEMS : CHARGEMENT_ITEMS.filter((it) => it.cle !== "fichePose");
  }
  // ---- ERP step 11 (accord Nils du 29/09) : dossier facturé = figé ----
  // Plus rien ne se modifie une fois le dossier en Facture : fiche dossier,
  // fiche de pose, pièces jointes (portées par le devis d'origine), PL
  // (enregistrement / annulation), consommables. Seul « En attente de »
  // (suivi d'envoi de la facture) reste modifiable.
  function dossierFacture(commande) {
    return !!commande && commande.statut === "Facture";
  }
  function devisAvecDossierFacture(devisId) {
    return !!devisId && (commandesListe || []).some((c) => c.devisId === devisId && c.statut === "Facture");
  }

  // ---- ERP step 11 (accord Nils du 29/09) : documents importants ----
  // Chaque document attendu est « fourni » quand un fichier est déposé sur le serveur
  // (Nils 01/11 : plus de lien ni de chemin Dropbox ; les liens déjà déclarés restent affichés).
  // Jamais bloquant ; chaque document manquant devient une tâche.
  // Documents rattachés au DEVIS (devis.documents[cle]) : déclarables dès le
  // devis, avant même d'être requis ; repris tels quels par le dossier. Une
  // tâche n'apparaît que lorsque le document est requis (étape atteinte +
  // condition remplie). Clés des plaques / éviers par position (les ids sont
  // régénérés à la création du dossier).
  function idCommercialDuDevis(d) {
    const u = utilisateurs.find((x) => x.nom === (d && d.commercialSC));
    return u ? u.id : null;
  }
  // devis obligatoire ; commande = dossier lié (ou null au stade devis).
  function documentsImportants(devis, commande) {
    if (!devis) return [];
    const statut = commande ? commande.statut : null;
    const idx = statut ? STATUTS_COMMANDE.indexOf(statut) : -1;
    const des = (st) => idx >= STATUTS_COMMANDE.indexOf(st);
    const src = commande || devis;
    const lignes = commande ? lignesDuDossier(commande) : devis.lignes || [];
    const commercial = idCommercialDuDevis(devis);
    const avecCommercial = (ids) => (commercial && !ids.includes(commercial) ? [...ids, commercial] : ids);
    const fournis = { ...((commande && commande.documents) || {}), ...(devis.documents || {}) };
    const liste = [];
    const avecTransformation = lignesAvecNature(lignes, articles, "faconnage");
    // ERP step 11 (Nils 29/09) : dessin client seulement si la commande contient
    // une transformation (article de nature « Façonnage »).
    // Step 17 (Nils 15/10) : facultatif — on le joint si le client en fournit un, sans jamais le réclamer.
    if (avecTransformation) liste.push({ cle: "dessinClient", label: "Dessin client", resp: qui(P_ADV_SR, P_ADV_JR), requisDes: null, facultatif: true });
    if (devis.chantierId) liste.push({ cle: "planMasse", label: "Plan de masse (projet immobilier)", resp: avecCommercial(qui(P_ADV_SR, P_ADV_JR)), requisDes: "BDC" });
    // Nombre de fiches = max(éléments techniques saisis, unités des lignes dont
    // l'article Catalogue appelle cette fiche — ex. découpe évier sous plan).
    const unitesLignes = (type) => lignes.reduce((n, l) => {
      const a = l.articleId ? (articles || []).find((x) => x.id === l.articleId) : null;
      return a && a.documentRequis === type ? n + Math.max(1, Math.round(Number(l.qte) || 1)) : n;
    }, 0);
    const plaquesET = src.plaquesCuisson || [];
    const nbPlaques = Math.max(plaquesET.length, unitesLignes("plaque"));
    for (let i = 0; i < nbPlaques; i++) {
      const ref = plaquesET[i] && plaquesET[i].reference;
      liste.push({ cle: `plaque:${i}`, label: `Fiche technique plaque de cuisson${nbPlaques > 1 ? ` n°${i + 1}` : ""}${ref ? ` (${ref})` : ""}`, resp: qui(P_ADV_SR, P_ADV_JR), requisDes: "RDM" });
    }
    const eviersET = src.eviers || [];
    const nbEviers = Math.max(eviersET.length, unitesLignes("evier"));
    for (let i = 0; i < nbEviers; i++) {
      const e = eviersET[i];
      liste.push({ cle: `evier:${i}`, label: `Fiche technique évier${nbEviers > 1 ? ` n°${i + 1}` : ""}${e && e.reference ? ` (${e.reference})` : ""}`, resp: qui(P_ADV_SR, P_ADV_JR), requisDes: "RDM" });
    }
    const avecTransfo = lignesAvecNature(lignes, articles, "faconnage");
    // ERP step 16 (Nils 12/10) : avec façonnage, le dessin technique Stone Concept ET sa validation par le
    // client bloquent le PL (même si le client a fourni son dessin de production). Sans article de RDM,
    // ils sont requis dès le BDC.
    if (avecTransfo) {
      const des0 = lignesAvecNature(lignes, articles, "rdm") ? "RDM" : "BDC";
      // Nils 17/10 : sans relevé de mesure (ex. une table), le bureau technique n'a pas encore accès au
      // dossier : l'ADV lui demande le dessin et le déclare à sa place.
      liste.push({ cle: "dessinTechnique", label: "Dessin technique Stone Concept", resp: des0 === "RDM" ? qui(P_BT) : qui(P_ADV_SR, P_ADV_JR), requisDes: des0 });
      liste.push({ cle: "dessinValideClient", label: "Dessin validé par le client", resp: avecCommercial(qui(P_ADV_SR, P_ADV_JR)), requisDes: des0, validation: true });
    }
    if (lignesContiennentPose(lignes, articles)) {
      liste.push({ cle: "photosAvant", label: "Photos avant pose", resp: avecCommercial(qui(P_POSE)), requisDes: "BL" });
      liste.push({ cle: "photosApres", label: "Photos après pose", resp: avecCommercial(qui(P_POSE)), requisDes: "Facture" });
    }
    return liste.map((x) => ({ ...x, requis: x.facultatif ? false : des(x.requisDes), fourni: fournis[x.cle] || null }));
  }
  // ERP step 16 : ce qui manque pour le PL d'un dossier avec façonnage ("" si rien).
  function dessinPLManquant(c) {
    const docs = documentsAttendus(c);
    const dt = docs.find((x) => x.cle === "dessinTechnique"), vc = docs.find((x) => x.cle === "dessinValideClient");
    if (!dt) return "";
    if (!dt.fourni) return "dessin technique Stone Concept pas encore déclaré";
    if (!vc || !vc.fourni) return "validation du dessin par le client pas encore déclarée";
    return "";
  }
  function documentsAttendus(c) {
    const d = (devisListe || []).find((x) => x.id === (c && c.devisId));
    return documentsImportants(d, c);
  }
  function commandeDuDevis(devisId) {
    return (commandesListe || []).find((c) => c.devisId === devisId) || null;
  }
  // Étape g (Nils 17/10, a) : un document se déclare par un lien OU par un fichier déposé
  // (fichier = { id, nom, taille, type } renvoyé par le serveur).
  // Nils 28/10 : plusieurs fichiers par document — « fichier » peut être une liste ; le 1er reste dans
  // doc.fichier, les suivants (et ceux ajoutés ensuite) dans doc.fichiers [{ …fichier, par, le }].
  async function declarerDocument(devisId, cle, lien, validation, fichierOuListe) {
    const listeF = Array.isArray(fichierOuListe) ? fichierOuListe.filter(Boolean) : fichierOuListe ? [fichierOuListe] : [];
    const fichier = listeF[0] || null;
    const devis = (devisListe || []).find((x) => x.id === devisId);
    const commande = commandeDuDevis(devisId);
    // Déclarer un lien reste possible en Facture (photos après pose requises à
    // ce stade) : ce n'est pas le contenu du dossier. Le retrait, lui, est figé.
    if (!devis) return;
    let val = fichier ? fichier.nom : (lien || "").trim();
    const doc = documentsImportants(devis, commande).find((x) => x.cle === cle);
    if (!doc || !(peut("devis.documentsTous") || doc.resp.includes(user.id))) return;
    const fournisAvant = { ...((commande && commande.documents) || {}), ...(devis.documents || {}) };
    let extra = {};
    if (doc.validation) {
      // ERP step 16 : validation du dessin par le client = date, moyen, reçu par.
      const v = validation || {};
      if (!fournisAvant.dessinTechnique) { setNotice("Déclare d'abord le dessin technique Stone Concept : le client valide notre dessin."); return; }
      // Nils 03/11 : projet immobilier — « Composition type validée » : pas d'accord du client à recevoir.
      const compo = v.moyen === MOYEN_COMPOSITION_TYPE;
      if (compo && !devis.chantierId) { setNotice(`« ${MOYEN_COMPOSITION_TYPE} » n'est possible que pour un devis rattaché à un projet immobilier.`); return; }
      const recuPar = compo ? user.nom : (v.recuPar || "").trim();
      if (!v.date || !v.moyen || !recuPar) { setNotice("Indique la date, le moyen (mail, WhatsApp, signature) et qui a reçu la validation du client."); return; }
      extra = { date: v.date, moyen: v.moyen, recuPar, dessinLe: fournisAvant.dessinTechnique.le };
      val = compo ? `Validé le ${formatDate(v.date)} — composition type validée (projet immobilier) — déclaré par ${recuPar}` : `Validé le ${formatDate(v.date)} par ${v.moyen.toLowerCase()} — reçu par ${recuPar}`;
    }
    if (!val) {
      setNotice("Dépose le fichier du document.");
      return;
    }
    const maintenantDoc = new Date().toISOString();
    const existant = !doc.validation && listeF.length ? fournisAvant[cle] : null;
    const ajoutF = (l) => l.map((f) => ({ ...f, par: user.nom, le: maintenantDoc }));
    const entree = existant
      ? { ...existant, fichiers: [...(existant.fichiers || []), ...ajoutF(listeF)] }
      : { lien: val, par: user.nom, le: maintenantDoc, ...extra, ...(fichier ? { fichier } : {}), ...(listeF.length > 1 ? { fichiers: ajoutF(listeF.slice(1)) } : {}) };
    if (listeF.length > 1 || existant) val = listeF.map((f) => f.nom).join(", ");
    const documents = { ...(devis.documents || {}), [cle]: entree };
    // ERP step 16 : nouveau dessin technique → la validation client tombe (le client n'a pas vu ce dessin).
    const validationTombee = cle === "dessinTechnique" && !!documents.dessinValideClient;
    // (vaut aussi pour un fichier ajouté au dessin : le client ne l'a pas vu — Nils 28/10, c)
    if (validationTombee) delete documents.dessinValideClient;
    await persistDevis((devisListe || []).map((d) => (d.id === devisId ? { ...d, documents } : d)));
    if (draft && draft.id === devisId) setDraft((prev) => (prev && prev.id === devisId ? { ...prev, documents } : prev));
    setLiensDocsSaisis((prev) => ({ ...prev, [cle]: "" }));
    await tracerAcces(existant ? "fichier(s) ajouté(s) au document" : "document déclaré fourni", `${commande ? `Dossier ${commande.numero}` : `Devis ${devis.numero || ""}`} : ${doc.label} → ${val}`);
    if (validationTombee) {
      await tracerAcces("validation client retirée", `${commande ? `Dossier ${commande.numero}` : `Devis ${devis.numero || ""}`} : nouveau dessin technique`);
      setNotice(existant ? "Fichier ajouté au dessin technique : la validation du client est retirée — le client doit valider le dessin complet." : "Nouveau dessin technique déclaré : la validation du client est retirée — le client doit valider ce nouveau dessin.");
    }
    // ERP step 11 (accord Nils du 29/09) : dessin technique déposé pendant le
    // RDM → « En attente de » passe automatiquement à « Envoi client ».
    // ERP step 16 : aussi en BDC (dossier sans article de RDM).
    if (cle === "dessinTechnique" && commande && (commande.statut === "RDM" || commande.statut === "BDC")) {
      const options = (enAttenteParStatut || DEFAULT_EN_ATTENTE_PAR_STATUT)[commande.statut] || [];
      if (options.includes("Envoi client") && commande.enAttenteDe !== "Envoi client") {
        await persistCommandes((commandesListe || []).map((c) => (c.id === commande.id ? { ...c, enAttenteDe: "Envoi client" } : c)));
        if (commandeEditing && commandeEditing.id === commande.id) setCommandeEditing((prev) => (prev ? { ...prev, enAttenteDe: "Envoi client" } : prev));
        await tracerAcces("en attente de (auto)", `Dossier ${commande.numero} : « Envoi client » après dépôt du dessin technique`);
        setNotice(`Dessin technique déclaré — le dossier ${commande.numero} passe « En attente de : Envoi client ».`);
      }
    }
  }
  async function retirerDocument(devisId, cle) {
    const devis = (devisListe || []).find((x) => x.id === devisId);
    const commande = commandeDuDevis(devisId);
    if (!devis || dossierFacture(commande)) return;
    const fournis = { ...((commande && commande.documents) || {}), ...(devis.documents || {}) };
    const actuel = fournis[cle];
    if (!actuel || !(peut("devis.documentsTous") || actuel.par === user.nom)) return;
    const documents = { ...(devis.documents || {}) };
    delete documents[cle];
    // ERP step 16 : sans dessin technique, plus de validation client.
    if (cle === "dessinTechnique") delete documents.dessinValideClient;
    await persistDevis((devisListe || []).map((d) => (d.id === devisId ? { ...d, documents } : d)));
    if (draft && draft.id === devisId) setDraft((prev) => (prev && prev.id === devisId ? { ...prev, documents } : prev));
    if (commande && commande.documents && commande.documents[cle]) {
      const docsCmd = { ...commande.documents };
      delete docsCmd[cle];
      await persistCommandes((commandesListe || []).map((c) => (c.id === commande.id ? { ...c, documents: docsCmd } : c)));
      if (commandeEditing && commandeEditing.id === commande.id) setCommandeEditing({ ...commandeEditing, documents: docsCmd });
    }
    await tracerAcces("document retiré", `${commande ? `Dossier ${commande.numero}` : `Devis ${devis.numero || ""}`} : ${cle}`);
  }
  // ---- Étape g (Nils 17/10, a) : fichier déposé à la place d'un lien ----
  // Le fichier part au serveur, qui vérifie droits, taille et type puis le range dans le
  // stockage objet ; le devis ne garde que sa référence. Renvoie la fiche, ou null (message affiché).
  // Nils 28/10 (a, d) : retirer un seul fichier d'un document qui en a plusieurs (la validation du
  // client ne tombe pas) ; le dernier fichier retire le document entier.
  async function retirerFichierDocument(devisId, cle, fichierId) {
    const devis = (devisListe || []).find((x) => x.id === devisId);
    const commande = commandeDuDevis(devisId);
    if (!devis || dossierFacture(commande)) return;
    const actuel = { ...((commande && commande.documents) || {}), ...(devis.documents || {}) }[cle];
    if (!actuel) return;
    const autres = actuel.fichiers || [];
    const cible = actuel.fichier && actuel.fichier.id === fichierId ? { ...actuel.fichier, par: actuel.par } : autres.find((f) => f.id === fichierId);
    if (!cible || !(peut("devis.documentsTous") || cible.par === user.nom)) return;
    if (!autres.length) { await retirerDocument(devisId, cle); return; }
    let maj;
    if (actuel.fichier && actuel.fichier.id === fichierId) {
      const [premier, ...reste] = autres;
      const { par, le, ...f } = premier;
      maj = { ...actuel, fichier: f, lien: f.nom, par, le, fichiers: reste };
    } else maj = { ...actuel, fichiers: autres.filter((f) => f.id !== fichierId) };
    if (!maj.fichiers.length) delete maj.fichiers;
    const documents = { ...(devis.documents || {}), [cle]: maj };
    await persistDevis((devisListe || []).map((d) => (d.id === devisId ? { ...d, documents } : d)));
    if (draft && draft.id === devisId) setDraft((prev) => (prev && prev.id === devisId ? { ...prev, documents } : prev));
    await tracerAcces("fichier retiré du document", `${commande ? `Dossier ${commande.numero}` : `Devis ${devis.numero || ""}`} : ${cle} — ${cible.nom}`);
  }
  async function envoyerFichierDevis(devisId, file, repere) {
    if (!window.storage || !window.storage.deposerFichier) {
      setNotice("Le dépôt de fichiers n'est possible qu'avec l'ERP sur son serveur.");
      return null;
    }
    if (!EXTENSIONS_FICHIERS.includes(extensionFichier(file.name))) {
      setNotice(`« ${file.name} » : type de fichier non accepté. Acceptés : ${TYPES_FICHIERS_LISIBLES}.`);
      return null;
    }
    if (file.size > TAILLE_MAX_FICHIER) {
      setNotice(`« ${file.name} » (${formatTaille(file.size)}) dépasse la limite de 25 Mo.`);
      return null;
    }
    setDepotEnCours(repere);
    try {
      const r = await window.storage.deposerFichier(devisId, file);
      if (r.erreur) {
        setNotice(r.erreur);
        return null;
      }
      return r.fichier;
    } finally {
      setDepotEnCours("");
    }
  }
  // Nils 28/10 (b) : plusieurs fichiers d'un coup ; ajoutés au document s'il est déjà fourni.
  async function deposerDocument(devisId, cle, files) {
    const fichiers = [];
    for (const file of Array.isArray(files) ? files : [files]) {
      const f = await envoyerFichierDevis(devisId, file, cle);
      if (f) fichiers.push(f);
    }
    if (fichiers.length) await declarerDocument(devisId, cle, "", undefined, fichiers);
  }
  async function deposerDocumentLibre(devisId, file) {
    if (!(docLibreSaisi.label || "").trim()) {
      setNotice("Indique d'abord un libellé pour ce document.");
      return;
    }
    const fichier = await envoyerFichierDevis(devisId, file, "libre");
    if (fichier) await ajouterDocumentLibre(devisId, fichier);
  }
  async function chargerFichiersRetires() {
    const liste = window.storage && window.storage.fichiersRetires ? await window.storage.fichiersRetires() : null;
    setFichiersRetires(liste || []);
    if (!liste) setNotice("Liste des fichiers retirés indisponible (serveur injoignable).");
  }
  async function restaurerFichier(f) {
    const factureF = !!f.cle && f.cle !== "erp:devis";
    const ok = await demander(factureF ? `Restaurer « ${f.nom} » ? Il revient dans les pièces jointes de : ${f.libelle}.` : `Restaurer « ${f.nom} » ? Il revient dans « Autres documents » du devis ${f.devisNumero || ""}${f.dossierNumero ? ` (dossier ${f.dossierNumero})` : ""}.`);
    if (!ok) return;
    const r = await window.storage.restaurerFichier(f.id);
    if (r.erreur) {
      setNotice(r.erreur);
      return;
    }
    if (factureF) {
      if (f.cle === PLANS_RECUPERES_KEY) setPlansRecuperes(await loadKey(PLANS_RECUPERES_KEY, plansRecuperes));
      else setFacturesF(await loadKey(FACTURES_FOURNISSEURS_KEY, facturesF));
      setNotice(`« ${f.nom} » restauré dans les pièces jointes de : ${f.libelle}.`);
      await chargerFichiersRetires();
      return;
    }
    // Le serveur a modifié les devis : on les relit (sinon le prochain enregistrement serait en conflit).
    setDevisListe(await loadKey(DEVIS_KEY, devisListe));
    setNotice(`« ${f.nom} » restauré dans « Autres documents » du devis ${f.devisNumero || ""}.`);
    await chargerFichiersRetires();
  }
  // Lien d'un document : fichier déposé (ouvert par le serveur, droits revérifiés) ou lien / chemin saisi.
  function renderLienDocument(d) {
    // Nils 01/11 : fiche technique standard du projet (fichier rangé sur la fiche projet).
    if (d.fichierProjet) {
      const href = window.storage && window.storage.lienFichier ? window.storage.lienFichier(d.fichierProjet.id) : null;
      const texte = `📎 ${d.fichierProjet.nom} — standard du projet`;
      return href ? <a href={href} target="_blank" rel="noopener noreferrer" style={{ color: ENCRE }}>{texte}</a> : <span style={{ color: ENCRE }}>{texte}</span>;
    }
    if (d.fichier) {
      const href = window.storage && window.storage.lienFichier ? window.storage.lienFichier(d.fichier.id) : null;
      const texte = `📎 ${d.fichier.nom} (${formatTaille(d.fichier.taille)})`;
      return href ? <a href={href} target="_blank" rel="noopener noreferrer" style={{ color: ENCRE }}>{texte}</a> : <span style={{ color: ENCRE }}>{texte}</span>;
    }
    return /^https?:\/\//i.test(d.lien) ? <a href={d.lien} target="_blank" rel="noopener noreferrer" style={{ color: ENCRE }}>{d.lien}</a> : <span style={{ color: ENCRE }}>{d.lien}</span>;
  }
  // Bouton « Déposer un fichier » (sélecteur de fichier caché).
  // plusieurs : sélection de plusieurs fichiers, onFichier reçoit alors la liste.
  function renderBoutonDepot(repere, onFichier, { plusieurs = false, libelle = "📎 Déposer un fichier" } = {}) {
    const occupe = !!depotEnCours;
    return (
      <label className="sc-btn" style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 10px", flexShrink: 0, cursor: occupe ? "default" : "pointer", opacity: occupe ? 0.6 : 1 }} title={`Fichier de 25 Mo au plus : ${TYPES_FICHIERS_LISIBLES}`}>
        {depotEnCours === repere ? "Envoi…" : libelle}
        <input
          type="file"
          style={{ display: "none" }}
          disabled={occupe}
          multiple={plusieurs}
          accept={EXTENSIONS_FICHIERS.map((e) => `.${e}`).join(",")}
          onChange={(e) => {
            const fs = Array.from(e.target.files || []);
            e.target.value = "";
            if (fs.length) onFichier(plusieurs ? fs : fs[0]);
          }}
        />
      </label>
    );
  }
  // ERP step 11 (Nils 29/09) : documents libres (lien + libellé), sans alerte ;
  // remplacent l'ancien bloc « Pièces jointes » (fichiers).
  async function ajouterDocumentLibre(devisId, fichier) {
    const devis = (devisListe || []).find((x) => x.id === devisId);
    if (!devis) return;
    const label = (docLibreSaisi.label || "").trim();
    // Nils 01/11 : plus de lien ni de chemin (Dropbox) — toujours un fichier déposé.
    const lien = fichier ? fichier.nom : "";
    if (!label || !lien) {
      setNotice("Indique un libellé et dépose le fichier.");
      return;
    }
    const documentsLibres = [...(devis.documentsLibres || []), { id: uid(), label, lien, par: user.nom, le: new Date().toISOString(), ...(fichier ? { fichier } : {}) }];
    await persistDevis((devisListe || []).map((d) => (d.id === devisId ? { ...d, documentsLibres } : d)));
    if (draft && draft.id === devisId) setDraft((prev) => (prev && prev.id === devisId ? { ...prev, documentsLibres } : prev));
    setDocLibreSaisi({ label: "", lien: "" });
    await tracerAcces("document libre ajouté", `Devis ${devis.numero || ""} : ${label} → ${lien}`);
  }
  async function retirerDocumentLibre(devisId, id) {
    const devis = (devisListe || []).find((x) => x.id === devisId);
    if (!devis || dossierFacture(commandeDuDevis(devisId))) return;
    const d = (devis.documentsLibres || []).find((x) => x.id === id);
    if (!d || !(peut("devis.documentsTous") || d.par === user.nom)) return;
    const documentsLibres = (devis.documentsLibres || []).filter((x) => x.id !== id);
    await persistDevis((devisListe || []).map((x) => (x.id === devisId ? { ...x, documentsLibres } : x)));
    if (draft && draft.id === devisId) setDraft((prev) => (prev && prev.id === devisId ? { ...prev, documentsLibres } : prev));
    await tracerAcces("document libre retiré", `Devis ${devis.numero || ""} : ${d.label}`);
  }
  // ---- Relance des devis envoyés (Nils 29/09) ----
  function delaiRelanceDevisJours() {
    const v = parametres && parametres.delaiRelanceDevisJours;
    return v !== undefined && v !== null && v !== "" && isFinite(Number(v)) ? Number(v) : 7;
  }
  async function enregistrerDelaiRelance() {
    if (!peut("admin.parametrage")) return;
    const v = Math.round(Number(delaiRelanceSaisi));
    if (!isFinite(v) || v < 0) {
      setNotice("Indique un nombre de jours valide.");
      return;
    }
    const avant = delaiRelanceDevisJours();
    await persistParametres({ ...(parametres || {}), delaiRelanceDevisJours: v });
    await tracerAcces("réglage délai relance devis", `${avant} j → ${v} j`);
    setDelaiRelanceSaisi("");
  }
  function ajouterJoursISO(n) {
    const d = new Date();
    d.setDate(d.getDate() + n);
    return d.toISOString().slice(0, 10);
  }
  // Nils 01/10 : réservation dont la date de pose prévue est dépassée → reporter.
  function dossiersReservationDepassee() {
    const auj = todayISO();
    return (commandesListe || []).filter((c) => c.reservationPourLe && c.reservationPourLe < auj && (reservations || []).some((r) => r.statut === "active" && r.bc === c.numero));
  }
  async function reporterReservation() {
    const r = reportReservation;
    if (!r) return;
    const c = (commandesListe || []).find((x) => x.id === r.commandeId);
    if (!c) return;
    if (!r.date || r.date < todayISO()) { setNotice("Choisis une nouvelle date (aujourd'hui ou plus tard)."); return; }
    const note = (r.note || "").trim();
    const maj = { ...c, reservationPourLe: r.date, alerteReservationPour: "", reservationNote: note, modifiePar: user.nom, modifieLe: new Date().toISOString() };
    await persistCommandes((commandesListe || []).map((x) => (x.id === c.id ? maj : x)));
    if (commandeEditing && commandeEditing.id === c.id) setCommandeEditing(maj);
    await persistReservations((reservations || []).map((x) => (x.statut === "active" && x.bc === c.numero ? { ...x, pourLe: r.date, modifiePar: user.nom, modifieLe: new Date().toISOString() } : x)));
    await tracerAcces("réservation reportée", `${c.numero} : pose prévue le ${formatDate(r.date)} (avant ${formatDate(c.reservationPourLe)})${note ? ` — ${note}` : ""}`);
    setReportReservation(null);
    setNotice(`Réservation ${c.numero} reportée au ${formatDate(r.date)}.`);
  }
  async function reporterRelanceDevis() {
    if (!reportEdit) return;
    const devis = (devisListe || []).find((x) => x.id === reportEdit.devisId);
    const n = Math.round(Number(reportEdit.jours));
    if (!devis || !isFinite(n) || n < 1) {
      setNotice("Indique un nombre de jours (1 ou plus).");
      return;
    }
    const relanceLe = ajouterJoursISO(n);
    const relanceNote = (reportEdit.note || "").trim();
    await persistDevis((devisListe || []).map((d) => (d.id === devis.id ? { ...d, relanceLe, relanceNote, relancePar: user.nom } : d)));
    await tracerAcces("relance devis programmée", `Devis ${devis.numero} : relance le ${formatDate(relanceLe)}${relanceNote ? ` — ${relanceNote}` : ""}`);
    setReportEdit(null);
    setNotice(`Relance du devis ${devis.numero} programmée le ${formatDate(relanceLe)}.`);
  }

  function renderDocumentsImportants(devis, commande) {
    if (!devis) return null;
    const docs = documentsImportants(devis, commande);
    const fige = dossierFacture(commande);
    const requis = docs.filter((x) => x.requis);
    const nbOk = requis.filter((x) => x.fourni).length;
    return (
      <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 12, marginBottom: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>Documents importants</div>
          <div style={{ fontSize: 12, fontWeight: 600, color: nbOk === requis.length ? VERT_OK : OCRE }}>{requis.length > 0 ? `${nbOk}/${requis.length} requis` : "aucun encore requis"}</div>
        </div>
        {docs.map((x) => {
          const peutFournir = !!devis.id && (peut("devis.documentsTous") || x.resp.includes(user.id));
          const pastille = x.fourni
            ? { t: "✓ Fourni", c: VERT_OK, bg: "#E4EBE4" }
            : x.requis
            ? { t: "⚠ Manquant", c: OCRE, bg: "#F5EFE0" }
            : x.facultatif
            ? { t: "Facultatif", c: TAUPE, bg: PIERRE }
            : { t: `Requis dès ${x.requisDes}`, c: TAUPE, bg: PIERRE };
          return (
            <div key={x.cle} style={{ padding: "5px 0", borderBottom: `1px solid ${PIERRE}` }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 13, fontWeight: 600 }}>{x.label}</span>
                <span style={{ fontSize: 10, fontWeight: 600, padding: "2px 8px", borderRadius: 10, color: pastille.c, background: pastille.bg, flexShrink: 0 }}>{pastille.t}</span>
              </div>
              {x.fourni ? (
                <div style={{ fontSize: 12, color: TAUPE }}>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                    {renderLienDocument(x.fourni)}
                    <span>— {x.fourni.par}, {formatDateHeure(x.fourni.le)}</span>
                    {!fige && (peut("devis.documentsTous") || x.fourni.par === user.nom) && (
                      <button type="button" className="sc-btn" onClick={() => (x.fourni.fichier && (x.fourni.fichiers || []).length ? retirerFichierDocument(devis.id, x.cle, x.fourni.fichier.id) : retirerDocument(devis.id, x.cle))} style={{ ...ghostBtnStyle, fontSize: 11, padding: "0 4px" }} title="Retirer">✕</button>
                    )}
                  </div>
                  {(x.fourni.fichiers || []).map((f) => (
                    <div key={f.id} style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                      {renderLienDocument({ lien: f.nom, fichier: f })}
                      <span>— {f.par}, {formatDateHeure(f.le)}</span>
                      {!fige && (peut("devis.documentsTous") || f.par === user.nom) && (
                        <button type="button" className="sc-btn" onClick={() => retirerFichierDocument(devis.id, x.cle, f.id)} style={{ ...ghostBtnStyle, fontSize: 11, padding: "0 4px" }} title="Retirer ce fichier">✕</button>
                      )}
                    </div>
                  ))}
                  {peutFournir && !x.validation && <div style={{ marginTop: 4 }}>{renderBoutonDepot(x.cle, (fs) => deposerDocument(devis.id, x.cle, fs), { plusieurs: true, libelle: "+ Ajouter un ou plusieurs fichiers" })}</div>}
                </div>
              ) : peutFournir && x.validation ? (
                (() => {
                  const v = { date: todayISO(), moyen: "", recuPar: user.nom, ...validationDessinSaisie };
                  const dessinOK = docs.some((y) => y.cle === "dessinTechnique" && y.fourni);
                  return dessinOK ? (
                    <div style={{ display: "flex", gap: 6, marginTop: 4, flexWrap: "wrap", alignItems: "center" }}>
                      <input type="date" className="sc-input" value={v.date} onChange={(e) => setValidationDessinSaisie({ ...v, date: e.target.value })} style={{ ...inputStyle(140), padding: "5px 8px", fontSize: 12 }} />
                      <select className="sc-select" value={v.moyen} onChange={(e) => setValidationDessinSaisie({ ...v, moyen: e.target.value })} style={{ ...selectStyle, padding: "5px 8px", fontSize: 12 }}>
                        <option value="">— Moyen —</option>
                        {moyensValidationDessin(!!devis.chantierId).map((m) => (<option key={m} value={m}>{m}</option>))}
                      </select>
                      {v.moyen !== MOYEN_COMPOSITION_TYPE && <input className="sc-input" value={v.recuPar} onChange={(e) => setValidationDessinSaisie({ ...v, recuPar: e.target.value })} placeholder="Reçu par" style={{ ...inputStyle(150), padding: "5px 8px", fontSize: 12 }} />}
                      <button type="button" className="sc-btn" onClick={async () => { await declarerDocument(devis.id, x.cle, "", v); setValidationDessinSaisie({}); }} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 10px", flexShrink: 0 }}>Déclarer la validation</button>
                    </div>
                  ) : (
                    <div style={{ fontSize: 11, color: TAUPE }}>Le client valide notre dessin : déclare d'abord le dessin technique Stone Concept.</div>
                  );
                })()
              ) : peutFournir ? (
                // Nils 01/11 : plus de lien ni de chemin (Dropbox) — le document est toujours un fichier déposé.
                <div style={{ display: "flex", gap: 6, marginTop: 4, flexWrap: "wrap" }}>
                  {renderBoutonDepot(x.cle, (fs) => deposerDocument(devis.id, x.cle, fs), { plusieurs: true, libelle: "📎 Déposer un ou plusieurs fichiers" })}
                </div>
              ) : (
                <div style={{ fontSize: 11, color: TAUPE }}>{!devis.id ? "Enregistre d'abord le devis." : `À fournir par : ${x.resp.map((id) => (utilisateurs.find((u) => u.id === id) || {}).nom || id).join(", ")}`}</div>
              )}
            </div>
          );
        })}
        {docs.length > 0 && <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Déclarables à tout moment ; un document n'apparaît dans les tâches du responsable qu'une fois requis.{docs.some((y) => y.validation) ? " Le dessin technique et sa validation par le client bloquent le PL ; un nouveau dessin annule la validation." : " Non bloquant."}{fige ? " Dossier facturé : les documents déjà déposés ne peuvent plus être retirés." : ""}</div>}
        <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, margin: "12px 0 6px" }}>Autres documents (libres, sans alerte)</div>
        {(devis.documentsLibres || []).length === 0 && <div style={{ fontSize: 12, color: TAUPE }}>Aucun.</div>}
        {(devis.documentsLibres || []).map((d) => (
          <div key={d.id} style={{ fontSize: 12, color: TAUPE, display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", padding: "3px 0" }}>
            <strong style={{ color: ENCRE }}>{d.label}</strong>
            {renderLienDocument(d)}
            <span>— {d.par}, {formatDateHeure(d.le)}</span>
            {!fige && (peut("devis.documentsTous") || d.par === user.nom) && (
              <button type="button" className="sc-btn" onClick={() => retirerDocumentLibre(devis.id, d.id)} style={{ ...ghostBtnStyle, fontSize: 11, padding: "0 4px" }} title="Retirer">✕</button>
            )}
          </div>
        ))}
        {devis.id ? (
          <div style={{ display: "flex", gap: 6, marginTop: 6, flexWrap: "wrap" }}>
            <input className="sc-input" value={docLibreSaisi.label} onChange={(e) => setDocLibreSaisi({ ...docLibreSaisi, label: e.target.value })} placeholder="Libellé (ex. Mail client du 12/09)" style={{ ...inputStyle(260), padding: "5px 8px", fontSize: 12, flex: 1 }} />
            {renderBoutonDepot("libre", (f) => deposerDocumentLibre(devis.id, f))}
          </div>
        ) : (
          <div style={{ fontSize: 11, color: TAUPE }}>Enregistre d'abord le devis.</div>
        )}
      </div>
    );
  }

  // ---- ERP step 11 : consommables de production / de pose par dossier ----
  // Un mouvement de consommable porte `consommable: true` et `usage`
  // ("production" | "pose") depuis le Step 11. Les saisies antérieures
  // (note « Consommable… », sans usage) comptent comme production.
  // Nils 28/10 : sortie de listellos (renforts des plans de 4 cm), consommation atelier hors dossier.
  function estMouvementListello(m) {
    return !!m && m.type === "sortie" && m.listello === true;
  }
  // Lot de tranche (ou chute) qu'on peut sortir en listello (shared/listello.js).
  function lotListello(it) {
    const p = it && (produits || []).find((pp) => pp.id === it.produitId);
    return !!p && estCategorieStockReservee(p.categorie) && lotUtilisableListello(it, articles);
  }
  function estMouvementConsommable(m) {
    return !!m && m.type === "sortie" && (m.consommable === true || /^Consommable/.test(m.note || ""));
  }
  function usageConsommable(m) {
    return m.usage === "pose" ? "pose" : "production";
  }
  function consommablesDuDossier(commande, usage) {
    if (!commande || !commande.numeroPL) return [];
    return (mouvements || []).filter(
      (m) => m.pl === commande.numeroPL && estMouvementConsommable(m) && (!usage || usageConsommable(m) === usage)
    );
  }
  // Nils 30/10 : consommables de production exigés seulement si le dossier a du façonnage (article « Façonnage »).
  function consoProductionRequise(commande) {
    return !!commande && dossierTransfo(commande);
  }
  function consoProductionOK(commande) {
    if (commande && !consoProductionRequise(commande)) return true;
    return consommablesDuDossier(commande, "production").length > 0 || !!(commande && commande.aucunConsoProduction);
  }
  function consoPoseOK(commande) {
    if (!commande || !fichePoseRequise(commande)) return true;
    return consommablesDuDossier(commande, "pose").length > 0 || !!commande.aucunConsoPose;
  }
  // Case « Aucun consommable » : enregistrée immédiatement (pas besoin du
  // bouton Enregistrer du dossier), tracée au Journal d'accès.
  // Nils 04/10 (k) : « aucun consommable de production » se déclare à l'enregistrement des consommables du PL.
  // Nils 09/10 : idem pour la pose — se déclare dans « Consommables de pose d'un PL », plus sur le dossier.
  async function declarerAucunConsoPL(numeroPL, usage, coche) {
    const c = (commandesListe || []).find((x) => x.numeroPL === numeroPL);
    if (!c || !peutCocherAucunConso || c.statut === "Facture") return;
    const cle = usage === "pose" ? "aucunConsoPose" : "aucunConsoProduction";
    if (coche && consommablesDuDossier(c, usage).length) { setNotice(`Des consommables de ${usage} sont déjà enregistrés sur ce PL.`); return; }
    const valeur = coche ? { par: user.nom, le: new Date().toISOString() } : null;
    await persistCommandes((commandesListe || []).map((x) => (x.id === c.id ? { ...x, [cle]: valeur } : x)));
    if (commandeEditing && commandeEditing.id === c.id) setCommandeEditing({ ...commandeEditing, [cle]: valeur });
    if (coche) await alerter("Aucun consommable", `Dossier ${c.numero} (${numeroPL}) : « Aucun consommable de ${usage} » déclaré par ${user.nom}`, { kind: "commande", id: c.id });
    await tracerAcces(coche ? `aucun consommable de ${usage} (déclaré au PL)` : `aucun consommable de ${usage} (annulé)`, `Dossier ${c.numero} · ${numeroPL}`);
    setNotice(coche ? `${numeroPL} : aucun consommable de ${usage} déclaré.` : `${numeroPL} : déclaration « aucun consommable de ${usage} » annulée.`);
  }
  function contactSurPlaceDuDossier(commande) {
    if (!commande) return { nom: "", tel: "" };
    const d = (devisListe || []).find((x) => x.id === commande.devisId) || {};
    return {
      nom: (commande.contactSurPlace !== undefined ? commande.contactSurPlace : d.contactSurPlace || "") || "",
      tel: (commande.telephoneSurPlace !== undefined ? commande.telephoneSurPlace : d.telephoneSurPlace || "") || "",
    };
  }
  function etageDuDossier(commande) {
    if (!commande) return "";
    if ((commande.etage || "").trim()) return commande.etage.trim();
    const d = (devisListe || []).find((x) => x.id === commande.devisId);
    return d && d.etage ? String(d.etage).trim() : "";
  }
  // ERP step 10 (demande Nils du 24/09) : impression de la fiche de pose —
  // même principe que les autres documents (fichier HTML à ouvrir puis
  // Ctrl+P → Enregistrer en PDF / Imprimer).
  function imprimerFichePose(commande) {
    if (!commande) return;
    // Nils 09/10 : une fiche créée par le planning (dates seules) est complétée par les valeurs vides.
    const fpBrut = { ...ficheDePoseVide(), ...(commande.fichePose || {}) };
    // Nils 09/10 : « troue osmoseur » → « Trou osmoseur » (fiches déjà enregistrées comprises).
    const fp = { ...fpBrut, interventions: (fpBrut.interventions || []).map((it) => (/^troue osmoseur$/i.test(it.label || "") ? { ...it, label: "Trou osmoseur" } : it)) };
    const client = (clients || []).find((x) => x.id === commande.clientId);
    const couleurs = couleursTranchesFichePose(commande);
    const e = escapeHtml;
    // ERP step 10 (retour Nils du 24/09) : mise en page calquée sur la fiche
    // en ligne, charte Stone Concept (Cormorant Garamond / DM Sans, encre
    // #281E1E, taupe #8C8282), encadrés à bords arrondis, AUCUN fond gris
    // (réservé au formulaire en ligne), tableau Sans/Oui/Non compact pour
    // laisser la place à la remarque.
    const bloc = (label, valeur, extra) => `<div class="bloc"${extra ? ` style="${extra}"` : ""}><div class="lbl">${e(label)}</div><div class="val">${e(valeur || "") || "&nbsp;"}</div></div>`;
    const coche = (ok) => `<span class="case">${ok ? "✕" : ""}</span>`;
    const listeInterv = fp.interventions || [];
    const moitie = Math.ceil(listeInterv.length / 2);
    const tableInterv = (items) => `<table class="interv">
      <tr><th style="text-align:left;">Intervention</th><th>Sans</th><th>Oui</th><th>Non</th><th>Partiel.</th></tr>
      ${items.map((it) => `<tr><td>${e(it.label)}</td>${ETATS_INTERVENTION_POSE.map((v) => `<td class="c">${coche(it.etat === v)}</td>`).join("")}</tr>`).join("")}
    </table>`;
    const html = `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="UTF-8" />
<title>Fiche de pose ${e(commande.numero || "")}</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600&family=DM+Sans:wght@400;500;600&display=swap" rel="stylesheet">
<style>
  * { box-sizing: border-box; }
  @page { size: A4 portrait; margin: 1.2cm; }
  body { font-family: "DM Sans", Arial, Helvetica, sans-serif; color: #281E1E; font-size: 11px; line-height: 1.4; margin: 0; padding: 0; background: #fff; }
  .entete { display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #8C8282; padding-bottom: 10px; margin-bottom: 14px; }
  .titre { font-family: "Cormorant Garamond", Georgia, serif; font-size: 24px; font-weight: 600; }
  .sousTitre { font-size: 10px; color: #8C8282; text-transform: uppercase; letter-spacing: .6px; }
  .cadre { border: 1px solid #8C8282; border-radius: 10px; padding: 10px 12px; margin-bottom: 10px; }
  .grille { display: grid; gap: 10px; margin-bottom: 10px; }
  .g4 { grid-template-columns: 1fr 1fr 1fr 0.6fr; }
  .g4b { grid-template-columns: 0.8fr 1fr 1fr 1fr; }
  .g2 { grid-template-columns: 1fr 1fr; }
  .g3 { grid-template-columns: 1fr 1fr 1fr; }
  .bloc { border: 1px solid #8C8282; border-radius: 10px; padding: 6px 10px; min-height: 42px; }
  .cadre .bloc { border: none; padding: 0; min-height: 0; }
  .lbl { font-size: 8.5px; color: #8C8282; text-transform: uppercase; letter-spacing: .6px; margin-bottom: 2px; }
  .val { font-size: 11.5px; font-weight: 600; }
  .note { font-size: 8.5px; color: #8C8282; margin-top: 6px; }
  h2 { font-family: "Cormorant Garamond", Georgia, serif; font-size: 15px; font-weight: 600; margin: 4px 0 6px; }
  table.interv { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 9px; }
  table.interv th { font-size: 8px; color: #8C8282; text-transform: uppercase; letter-spacing: .5px; font-weight: 500; padding: 2px 4px; border-bottom: 1px solid #8C8282; }
  table.interv td { padding: 2px 4px; border-bottom: 1px solid #ddd6d2; }
  table.interv td.c, table.interv th:not(:first-child) { text-align: center; width: 34px; }
  .case { display: inline-block; width: 10px; height: 10px; border: 1px solid #281E1E; border-radius: 3px; font-size: 8px; line-height: 9px; text-align: center; }
  .remarque { border: 1px solid #8C8282; border-radius: 10px; padding: 8px 10px; min-height: 250px; white-space: pre-wrap; font-size: 11px; }
  .sign { border: 1px solid #8C8282; border-radius: 10px; padding: 6px 10px; height: 90px; }
  .pied { font-size: 8.5px; color: #8C8282; text-align: center; margin-top: 12px; }
</style>
</head>
<body>
  <div class="entete">
    <div>
      <div class="titre">Fiche de pose</div>
      <div class="sousTitre">Dossier ${e([commande.numero, commande.numeroPL].filter(Boolean).join(" · "))}</div>
    </div>
    <img src="${LOGO_SRC}" alt="Stone Concept" style="height:40px;" />
  </div>

  <div class="cadre">
    <div class="grille g4" style="margin-bottom:8px;">
      ${bloc("Réf. dossier", [commande.numero, commande.numeroPL].filter(Boolean).join(" · "))}
      ${bloc("Référence", commande.reference)}
      ${bloc("Client (revendeur)", client ? client.nom : "")}
      ${bloc("Étage", etageDuDossier(commande))}
    </div>
    <div class="grille ${nomProjetDe(chantierDuDossier(commande)) ? "g3" : "g2"}" style="margin-bottom:8px;">
      ${nomProjetDe(chantierDuDossier(commande)) ? bloc("Projet", nomProjetDe(chantierDuDossier(commande))) : ""}
      ${bloc("Contact sur place", contactSurPlaceDuDossier(commande).nom)}
      ${bloc("Téléphone sur place", contactSurPlaceDuDossier(commande).tel)}
    </div>
    ${bloc(couleurs.source === "pl" ? "Couleurs des tranches utilisées (sorties sur le PL)" : "Couleurs des tranches prévues au dossier", couleurs.liste.join(" ; "))}
  </div>

  <div class="grille g4b">
    ${bloc("Pose", dateDebutPose(fp) ? `du ${formatDate(dateDebutPose(fp))}${fp.dateFin ? ` au ${formatDate(fp.dateFin)}` : ""}` : "")}
    ${bloc("Responsable contrôle qualité", fp.controleQualite)}
    ${bloc("Responsable contrôle chargement", fp.controleChargement)}
    ${bloc("Responsable contrôle de pose", fp.controlePose)}
  </div>

  <div class="grille g2">
    ${bloc("Poseurs", (fp.poseurs || []).map((n) => ((fp.renforts || []).includes(n) ? `${n} (renfort)` : n)).join(", "))}
    ${bloc("Aides-poseurs", (fp.aidesPoseurs || []).map((n) => ((fp.renforts || []).includes(n) ? `${n} (renfort)` : n)).join(", "))}
  </div>

  <div class="cadre">
    <div class="grille g2" style="margin-bottom:0;gap:18px;">
      ${tableInterv(listeInterv.slice(0, moitie))}
      ${tableInterv(listeInterv.slice(moitie))}
    </div>
  </div>

  <div class="cadre" style="padding:6px 12px;">
    <div class="lbl" style="margin-bottom:4px;">Remis aux poseurs au chargement</div>
    <div style="display:flex;gap:18px;flex-wrap:wrap;font-size:10.5px;">${CHARGEMENT_ITEMS.map((it) => `<span>${coche(!!(commande.chargement || {})[it.cle])} ${e(it.label)}</span>`).join("")}</div>
  </div>

  <h2>Remarque</h2>
  <div class="remarque">${e(fp.remarque || "")}</div>

  <div class="grille g2" style="margin-top:12px;">
    <div class="sign"><div class="lbl">Signature chef poseur</div></div>
    <div class="sign"><div class="lbl">Signature client</div></div>
  </div>

  <div class="pied">Stone Concept Sarl — imprimé le ${e(formatDate(new Date().toISOString()))}${fp.modifiePar ? ` — dernière modification : ${e(fp.modifiePar)}` : ""}</div>
</body>
</html>`;
    telechargerDocument(html, nomFichierDocument("Fiche-pose", commande.numeroPL || commande.numero || "dossier", (clientDe(commande.clientId) || {}).nom, nomProjetDe(chantierDuDossier(commande)), commande.reference), "fiche de pose");
  }
  // Nils 08/10 (p) : fiche papier des consommables d'un PL (remplie à l'atelier,
  // saisie ensuite par Wissam) : les consommables les plus utilisés sur 12 mois
  // + lignes vides pour en ajouter.
  function consommablesCourants(max, usage) {
    const depuis = decalerJours(todayISO(), -365);
    const freq = new Map();
    (mouvements || []).filter((m) => estMouvementConsommable(m) && (!usage || usageConsommable(m) === usage) && String(m.creeLe || m.date || "").slice(0, 10) >= depuis).forEach((m) => {
      const lot = (items || []).find((it) => it.id === m.itemId);
      if (lot) freq.set(lot.produitId, (freq.get(lot.produitId) || 0) + 1);
    });
    const eligibles = (produits || []).filter((p) => estCategorieConsommable(p.categorie) && !estConsoLent(p) && !articleDuProduit(p.id));
    const tries = [...eligibles].sort((a, b) => (freq.get(b.id) || 0) - (freq.get(a.id) || 0) || nomProduit(a.id).localeCompare(nomProduit(b.id), "fr"));
    return tries.slice(0, max).map((p) => ({ nom: nomProduit(p.id), unite: (((items || []).find((it) => it.produitId === p.id) || {}).unite) || p.unite || "" }));
  }
  // Nils 09/10 : une fiche pour l'atelier (production) et une pour la pose.
  function imprimerFicheConsommables(commande, usage) {
    const e = escapeHtml;
    const u = usage === "pose" ? "pose" : "production";
    const titreFiche = u === "pose" ? "Fiche consommables — pose" : "Fiche consommables — atelier";
    const client = commande ? clientDe(commande.clientId) : null;
    const lignes = consommablesCourants(20, u);
    const vides = 8;
    const ligne = (nom, unite) => `<tr><td>${e(nom)}</td><td class="c">${e(unite)}</td><td></td></tr>`;
    const html = `<!DOCTYPE html>
<html lang="fr"><head><meta charset="UTF-8" />
<title>${e(titreFiche)} ${e((commande && commande.numeroPL) || "")}</title>
<link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600&family=DM+Sans:wght@400;500;600&display=swap" rel="stylesheet">
<style>
  * { box-sizing: border-box; }
  @page { size: A4 portrait; margin: 1.2cm; }
  body { font-family: "DM Sans", Arial, sans-serif; color: #281E1E; font-size: 11px; margin: 0; }
  h1 { font-family: "Cormorant Garamond", serif; font-size: 24px; font-weight: 600; margin: 0 0 4px; }
  .sous { color: #8C8282; margin-bottom: 12px; }
  .entete { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-bottom: 12px; }
  .bloc { border: 1px solid #8C8282; border-radius: 8px; padding: 6px 10px; min-height: 40px; }
  .lbl { font-size: 9px; color: #8C8282; text-transform: uppercase; letter-spacing: .5px; }
  .val { font-size: 12px; font-weight: 600; }
  table { width: 100%; border-collapse: collapse; }
  th { font-size: 9px; color: #8C8282; text-transform: uppercase; letter-spacing: .4px; text-align: left; border-bottom: 1px solid #281E1E; padding: 5px 6px; }
  td { border-bottom: 1px solid #CFC5BF; padding: 0 6px; height: 24px; }
  td.c, th.c { text-align: center; }
  th.q, td:nth-child(3) { width: 26%; border-left: 1px solid #CFC5BF; }
  .pied { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-top: 14px; }
</style></head><body>
<h1>${e(titreFiche)}</h1>
<div class="sous">${u === "pose" ? "À remplir par l'équipe de pose" : "À remplir à l'atelier"}, puis à remettre au bureau technique pour la saisie dans l'ERP (Stock › Enregistrer une consommation › consommables de ${u}).</div>
<div class="entete">
  <div class="bloc"><div class="lbl">N° PL</div><div class="val">${e((commande && commande.numeroPL) || "") || "&nbsp;"}</div></div>
  <div class="bloc"><div class="lbl">Client</div><div class="val">${e((client && client.nom) || "") || "&nbsp;"}</div></div>
  <div class="bloc"><div class="lbl">Référence</div><div class="val">${e((commande && commande.reference) || "") || "&nbsp;"}</div></div>
</div>
<table>
  <tr><th>Consommable</th><th class="c">Unité</th><th class="q c">Quantité utilisée</th></tr>
  ${lignes.map((l) => ligne(l.nom, l.unite)).join("")}
  ${Array.from({ length: vides }, () => ligne("", "")).join("")}
</table>
<div class="pied">
  <div class="bloc"><div class="lbl">Rempli par — date</div></div>
  <div class="bloc"><div class="lbl">Saisi dans l'ERP par le bureau technique — date</div></div>
</div>
</body></html>`;
    telechargerDocument(html, nomFichierDocument(u === "pose" ? "Fiche-consommables-pose" : "Fiche-consommables-atelier", (commande && (commande.numeroPL || commande.numero)) || "vierge", client ? client.nom : "", commande ? nomProjetDe(chantierDuDossier(commande)) : "", commande ? commande.reference : ""), "fiche consommables");
  }
  function couleursTranchesFichePose(commande) {
    const numeroPL = (commande.numeroPL || "").trim();
    const reelles = [];
    if (numeroPL) {
      (mouvements || [])
        .filter((m) => m.type === "sortie" && m.pl === numeroPL && !estMouvementConsommable(m))
        .forEach((m) => {
          const lot = (items || []).find((it) => it.id === m.itemId);
          if (!lot) return;
          const article = articleDuProduit(lot.produitId);
          if (!article || article.categorie !== "Tranche") return;
          const lib = [nomProduit(lot.produitId), lot.epaisseur, lot.type === TYPE_CHUTE ? "chute" : ""].filter(Boolean).join(" · ");
          if (!reelles.includes(lib)) reelles.push(lib);
        });
    }
    if (reelles.length > 0) return { source: "pl", liste: reelles };
    const prevues = [];
    lignesDuDossier(commande).forEach((l) => {
      if (l.type !== "facture" || !l.articleId) return;
      const article = (articles || []).find((a) => a.id === l.articleId);
      if (!article || article.categorie !== "Tranche") return;
      const lib = article.designation || libelleFamilleSeule(article);
      if (lib && !prevues.includes(lib)) prevues.push(lib);
    });
    return { source: "dossier", liste: prevues };
  }
  function renderFichePose() {
    const commande = commandeEditing;
    if (!commande || !["PL", "BL", "Facture"].includes(commande.statut)) return null;
    // Nils 09/10 : une fiche créée par le planning (dates seules) est complétée par les valeurs vides.
    const fpBrut = { ...ficheDePoseVide(), ...(commande.fichePose || {}) };
    // Nils 09/10 : « troue osmoseur » → « Trou osmoseur » (fiches déjà enregistrées comprises).
    const fp = { ...fpBrut, interventions: (fpBrut.interventions || []).map((it) => (/^troue osmoseur$/i.test(it.label || "") ? { ...it, label: "Trou osmoseur" } : it)) };
    const fichePoseFigee = commande.statut === "Facture";
    const peutModifierFichePose = peut("commandes.fichePose") && !fichePoseFigee;
    const setFP = (patch) => {
      setCommandeEditing({
        ...commande,
        fichePose: { ...fp, ...patch, modifiePar: user.nom, modifieLe: new Date().toISOString() },
      });
    };
    const setLigneIntervention = (idx, patch) => {
      setFP({ interventions: fp.interventions.map((it, i) => (i === idx ? { ...it, ...patch } : it)) });
    };
    // Une même personne est soit poseur, soit aide-poseur sur une fiche —
    // la cocher dans un rôle la retire de l'autre.
    const toggleRole = (role, nom) => {
      const autre = role === "poseurs" ? "aidesPoseurs" : "poseurs";
      const liste = fp[role] || [];
      const dejaLa = liste.includes(nom);
      const nouvelle = dejaLa ? liste.filter((p) => p !== nom) : [...liste, nom];
      const nouvelleAutre = (fp[autre] || []).filter((p) => p !== nom);
      setFP({
        [role]: nouvelle,
        [autre]: nouvelleAutre,
        renforts: (fp.renforts || []).filter((p) => nouvelle.includes(p) || nouvelleAutre.includes(p)),
      });
    };
    const remplie = fichePoseRemplie(fp);
    // ERP step 12 : listes tirées de l'onglet Staff (fiches actives) ; les
    // noms déjà saisis sur la fiche restent affichés même si la personne est sortie.
    const staffActifs = (staff || []).filter(staffActif);
    const personnelFichePose = trierAlpha([...new Set(staffActifs.map((s) => s.nom))].map((nom) => ({ nom })), "nom").map((x) => x.nom);
    const poseursFichePose = trierAlpha([...new Set([...staffActifs.filter((s) => s.poseur).map((s) => s.nom), ...(fp.poseurs || []), ...(fp.aidesPoseurs || [])])].map((nom) => ({ nom })), "nom").map((x) => x.nom);
    const clientFP = (clients || []).find((x) => x.id === commande.clientId);
    const couleursFP = couleursTranchesFichePose(commande);
    const infoAuto = (label, valeur) => (
      <div>
        <div style={{ fontSize: 10, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 2 }}>{label}</div>
        <div style={{ fontSize: 13, fontWeight: 600 }}>{valeur || "—"}</div>
      </div>
    );
    const blocRole = (role, titre, obligatoire) => (
      <div style={{ marginBottom: 10 }}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>
          {titre} {obligatoire ? <span style={{ fontSize: 11, fontWeight: 400, color: TAUPE }}>(au moins un)</span> : <span style={{ fontSize: 11, fontWeight: 400, color: TAUPE }}>(facultatif)</span>}
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
          {poseursFichePose.length === 0 && <div style={{ fontSize: 12, color: TAUPE }}>Aucun poseur actif — coche « Poseur » sur la fiche de la personne (onglet Staff).</div>}
          {poseursFichePose.map((p) => (
            <label key={p} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}>
              <input type="checkbox" checked={(fp[role] || []).includes(p)} onChange={() => toggleRole(role, p)} />
              {p}{(fp.renforts || []).includes(p) && <span style={{ fontSize: 11, color: TAUPE }}>(renfort)</span>}
            </label>
          ))}
        </div>
      </div>
    );
    return (
      <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: 14, marginBottom: 20 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, flexWrap: "wrap", gap: 8 }}>
          <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>Fiche de pose</div>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <button type="button" className="sc-btn" onClick={() => imprimerFichePose(commande)} style={{ ...ghostBtnStyle, padding: "4px 10px", fontSize: 12 }}>🖨 Imprimer la fiche de pose</button>
            <div style={{ fontSize: 12, fontWeight: 600, color: remplie ? "#3D7A4D" : ROUILLE }}>
              {remplie ? "✓ Remplie" : fichePoseRequise(commande) ? "⚠ Incomplète — bloque la Facture" : "Facultative — aucun article de pose dans la commande"}
            </div>
          </div>
        </div>
        <div style={{ background: PIERRE, borderRadius: 8, padding: 12, marginBottom: 14 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 0.6fr", gap: 12, marginBottom: 10 }}>
            {infoAuto("Réf. dossier", [commande.numero, commande.numeroPL].filter(Boolean).join(" · "))}
            {infoAuto("Référence", commande.reference)}
            {infoAuto("Client (revendeur)", clientFP ? clientFP.nom : "")}
            {infoAuto("Étage", etageDuDossier(commande))}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 0.6fr", gap: 12, marginBottom: 10 }}>
            {infoAuto("Contact sur place", contactSurPlaceDuDossier(commande).nom)}
            {infoAuto("Téléphone sur place", contactSurPlaceDuDossier(commande).tel)}
          </div>
          <div style={{ fontSize: 10, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 2 }}>
            Couleurs des tranches {couleursFP.source === "pl" ? "utilisées (sorties sur le PL)" : "prévues au dossier (PL pas encore enregistré)"}
          </div>
          <div style={{ fontSize: 13, fontWeight: 600 }}>{couleursFP.liste.length > 0 ? couleursFP.liste.join(" ; ") : "—"}</div>
          <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>Informations reprises automatiquement de la commande — non modifiables ici.</div>
        </div>
        <fieldset disabled={!peutModifierFichePose} style={{ border: "none", padding: 0, margin: 0 }}>
          {/* ERP step 10 (retour Nils du 24/09) : Contact client, Ville et Étage
              retirés de la fiche (les anciennes valeurs restent en base, non affichées). */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 2fr", gap: 12, marginBottom: 4 }}>
            <Field label="Début de pose (obligatoire)"><input type="date" className="sc-input" value={dateDebutPose(fp)} onChange={(e) => setFP({ dateDebut: e.target.value })} style={inputStyle("100%")} /></Field>
            <Field label="Fin de pose (obligatoire)"><input type="date" className="sc-input" value={fp.dateFin || ""} min={dateDebutPose(fp) || undefined} onChange={(e) => setFP({ dateFin: e.target.value })} style={inputStyle("100%")} /></Field>
            <div />
          </div>
          {dateDebutPose(fp) && fp.dateFin && fp.dateFin < dateDebutPose(fp) && (
            <div style={{ fontSize: 12, color: ROUILLE, marginBottom: 8 }}>La fin de pose ne peut pas être avant le début.</div>
          )}
          {/* Responsables choisis parmi les fiches actives de l'onglet Staff. */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 14, marginTop: 8 }}>
            {[["controleQualite", "Responsable contrôle qualité (obligatoire)"], ["controleChargement", "Responsable contrôle chargement (obligatoire)"], ["controlePose", "Responsable contrôle de pose (obligatoire)"]].map(([cle, label]) => (
              <Field key={cle} label={label}>
                <select className="sc-select" value={fp[cle] || ""} onChange={(e) => setFP({ [cle]: e.target.value })} style={selectStyle}>
                  <option value="">— Choisir —</option>
                  {[...new Set([...personnelFichePose, ...(fp[cle] ? [fp[cle]] : [])])].map((n) => (<option key={n} value={n}>{n}</option>))}
                </select>
              </Field>
            ))}
          </div>

          <div style={{ marginBottom: 14 }}>
            {blocRole("poseurs", "Poseurs", true)}
            {blocRole("aidesPoseurs", "Aides-poseurs", false)}
            {/* Step 17 (Nils 14/10) : renfort exceptionnel — une personne active du Staff
                non cochée « Poseur » (ex. un finisseur) ajoutée à cette fiche seulement ;
                sa fiche Staff ne change pas, il compte dans les intervenants de la pose. */}
            {(() => {
              const dejaSurFiche = new Set([...(fp.poseurs || []), ...(fp.aidesPoseurs || [])]);
              const candidats = trierAlpha(staffActifs.filter((s) => !s.poseur && s.nom && !dejaSurFiche.has(s.nom)).map((s) => ({ nom: s.nom })), "nom").map((x) => x.nom);
              if (!candidats.length) return null;
              const nomChoisi = candidats.includes(renfortFP.nom) ? renfortFP.nom : "";
              return (
                <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginTop: 4, marginBottom: 6 }}>
                  <span style={{ fontSize: 12, fontWeight: 600 }}>+ Renfort</span>
                  <select className="sc-select" value={nomChoisi} onChange={(e) => setRenfortFP({ ...renfortFP, nom: e.target.value })} style={{ ...selectStyle, width: "auto", padding: "5px 8px" }}>
                    <option value="">— Personne du Staff —</option>
                    {candidats.map((n) => (<option key={n} value={n}>{n}</option>))}
                  </select>
                  <select className="sc-select" value={renfortFP.role} onChange={(e) => setRenfortFP({ ...renfortFP, role: e.target.value })} style={{ ...selectStyle, width: "auto", padding: "5px 8px" }}>
                    <option value="aidesPoseurs">aide-poseur</option>
                    <option value="poseurs">poseur</option>
                  </select>
                  <button type="button" className="sc-btn" disabled={!nomChoisi} onClick={() => {
                    if (!nomChoisi) return;
                    const role = renfortFP.role === "poseurs" ? "poseurs" : "aidesPoseurs";
                    setFP({ [role]: [...(fp[role] || []), nomChoisi], renforts: [...(fp.renforts || []).filter((p) => p !== nomChoisi), nomChoisi] });
                    setRenfortFP({ nom: "", role });
                  }} style={{ ...ghostBtnStyle, padding: "4px 10px", fontSize: 12 }}>Ajouter</button>
                  <span style={{ fontSize: 11, color: TAUPE, width: "100%" }}>Renfort exceptionnel (ex. un finisseur) : pour cette pose seulement, sa fiche Staff ne change pas.</span>
                </div>
              );
            })()}
            <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
              Liste tirée de l'onglet Staff (fiches actives, case « Poseur »){peutGererStaff ? " — à gérer dans cet onglet." : ". Un poseur manque ? Demande au Gérant ou à l'Administration de cocher « Poseur » sur sa fiche."}
            </div>
          </div>

          {/* ERP step 10 (accord Nils du 24/09) : éléments remis aux poseurs au
              chargement — mêmes cases que sur la fiche dossier (commande.chargement),
              cochables par le Production Manager et le Gérant. N'entrent PAS dans fichePoseRemplie. */}
          {(() => {
            const ch = commande.chargement || {};
            const peutCocher = peut("commandes.chargement");
            return (
              <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 12, marginBottom: 14 }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Remis aux poseurs au chargement <span style={{ textTransform: "none", letterSpacing: 0 }}>(non bloquant)</span></div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
                  {CHARGEMENT_ITEMS.map((it) => (
                    <label key={it.cle} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13 }}>
                      <input
                        type="checkbox"
                        disabled={!peutCocher}
                        checked={!!ch[it.cle]}
                        onChange={(e) => setCommandeEditing({ ...commande, chargement: { ...ch, [it.cle]: e.target.checked, modifiePar: user.nom, modifieLe: new Date().toISOString() } })}
                      />
                      {it.label}
                    </label>
                  ))}
                </div>
              </div>
            );
          })()}

          <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, overflow: "hidden", marginBottom: 14 }}>
            {/* ERP step 10 (retour Nils du 24/09) : colonne "Nbre de pcs" retirée. */}
            <div style={{ display: "grid", gridTemplateColumns: "2fr 0.6fr 0.6fr 0.6fr 0.9fr", padding: "8px 12px", background: PIERRE, fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>
              <div>Intervention</div><div style={{ textAlign: "center" }}>Sans</div><div style={{ textAlign: "center" }}>Oui</div><div style={{ textAlign: "center" }}>Non</div><div style={{ textAlign: "center" }}>Partiellement</div>
            </div>
            {fp.interventions.map((it, idx) => (
              <div key={it.label} style={{ display: "grid", gridTemplateColumns: "2fr 0.6fr 0.6fr 0.6fr 0.9fr", padding: "6px 12px", alignItems: "center", borderTop: `1px solid ${PIERRE}`, fontSize: 13 }}>
                <div>{it.label}</div>
                {ETATS_INTERVENTION_POSE.map((v) => (
                  <div key={v} style={{ textAlign: "center" }}>
                    <input type="radio" name={`intervention-${commande.id}-${idx}`} checked={it.etat === v} onChange={() => setLigneIntervention(idx, { etat: v })} />
                  </div>
                ))}
              </div>
            ))}
          </div>

          {/* ERP step 10 (retour Nils du 24/09) : "Problèmes rencontrés" retiré
              (anciennes valeurs conservées en base, non affichées). */}
          <Field label="Remarque">
            <textarea className="sc-input" value={fp.remarque || ""} onChange={(e) => setFP({ remarque: e.target.value })} style={{ ...inputStyle("100%"), minHeight: 90, resize: "vertical", fontFamily: "'DM Sans', sans-serif" }} />
          </Field>
        </fieldset>
        {!peutModifierFichePose && (
          <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>{fichePoseFigee ? "Lecture seule — dossier facturé, fiche de pose figée." : "Lecture seule — seuls le chef poseur, le Production Manager et le Gérant peuvent modifier la fiche de pose."}</div>
        )}
      </div>
    );
  }

  // Crée le dossier de commande — appelée uniquement depuis le bouton
  // "Transformer en BDC", jamais automatiquement au changement de statut.
  // Ne crée jamais de doublon pour un même devis. `creditsConsommesInit`
  // (ERP step 8) : le crédit du registre des tranches exonérables déjà
  // vérifié et déduit par transformerEnBDC pour ce devis, à porter par le
  // nouveau dossier (commande.creditsConsommes) — vide/absent pour un devis
  // non exonéré.
  // ERP step 11 : remise du document supérieure à celle de la fiche client
  // (remise globale ou remise d'une ligne). Renvoie la remise max, ou null.
  function remiseAuDelaFicheClient(devis) {
    if (!devis) return null;
    const client = (clients || []).find((c) => c.id === devis.clientId);
    const remiseClient = client && client.remise !== "" && client.remise !== undefined && client.remise !== null ? Number(client.remise) || 0 : 0;
    const max = Math.max(Number(devis.remiseGlobale) || 0, ...((devis.lignes || []).map((l) => Number(l.remise) || 0)));
    return max > remiseClient ? { max, remiseClient, client: client ? client.nom : "" } : null;
  }

  async function creerCommandeDepuisDevis(devis, creditsConsommesInit) {
    const dejaExiste = (commandesListe || []).some((c) => c.devisId === devis.id);
    if (dejaExiste) return;
    const annee = new Date().getFullYear();
    const numero = await numeroDocument("BC", annee);
    if (!numero) return;
    const statutInitial = STATUTS_COMMANDE[0];
    const creditsConsommes = Array.isArray(creditsConsommesInit) ? creditsConsommesInit : [];
    const nouvelle = {
      id: uid(),
      numero,
      numeroRDM: "",
      numeroPL: "",
      numeroBL: "",
      numeroFacture: "",
      dateRDM: "",
      datePL: "",
      dateBL: "",
      dateFacture: "",
      reference: devis.reference || "",
      etage: (devis.etage || "").trim(), // ERP step 10
      contactSurPlace: (devis.contactSurPlace || "").trim(), // ERP step 10 — modifiable sur le dossier
      telephoneSurPlace: (devis.telephoneSurPlace || "").trim(),
      devisId: devis.id,
      // ERP step 7 (pt.17/18) : le dossier reçoit sa propre copie des
      // lignes à la transformation — le devis, lui, reste figé tel qu'il
      // était au moment de cette transformation.
      lignes: JSON.parse(JSON.stringify(devis.lignes || [])),
      clientId: devis.clientId,
      statut: statutInitial,
      enAttenteDe: ((enAttenteParStatut || DEFAULT_EN_ATTENTE_PAR_STATUT)[statutInitial] || [])[0] || "",
      commentaireDessin: "",
      nombreColis: "",
      poseurMeuble: devis.poseurMeuble || "",
      plaquesCuisson: (devis.plaquesCuisson || []).map((p) => ({ ...p, id: uid() })),
      eviers: (devis.eviers || []).map((e) => ({ ...e, id: uid() })),
      reservationVidangeAutomatique: devis.reservationVidangeAutomatique || false,
      reservationVidangeAutomatiqueDiametre: devis.reservationVidangeAutomatiqueDiametre || "",
      reservationOsmoseur: devis.reservationOsmoseur || false,
      reservationOsmoseurDiametre: devis.reservationOsmoseurDiametre || "",
      laveVaisselle: devis.laveVaisselle ?? null, // ERP step 11 : Oui / Non / non renseigné
      laveVaisselleType: devis.laveVaisselleType || "",
      laveLinge: devis.laveLinge ?? null,
      laveLingeType: devis.laveLingeType || "",
      porteCuisine: devis.porteCuisine ?? null,
      porteCuisineType: devis.porteCuisineType || "",
      porteCuisineDebord: devis.porteCuisineDebord || "",
      jambage: devis.jambage || false,
      jambageType: devis.jambageType || "",
      socle: devis.socle || "",
      creditsConsommes,
      creePar: user.nom,
      creeLe: new Date().toISOString(),
      modifiePar: user.nom,
      modifieLe: new Date().toISOString(),
    };
    if (creditsConsommes.length > 0) {
      let creditsMaj = [...(creditsTranches || [])];
      creditsConsommes.forEach((c) => {
        creditsMaj = consommerCreditListe(creditsMaj, c.cle, c.quantite);
      });
      await persistCreditsTranches(creditsMaj);
      await journaliserMouvementsCredit(
        creditsConsommes.map((c) => ({
          produitId: c.produitId,
          libelle: c.libelle,
          sens: "debit",
          quantite: c.quantite,
          origine: `Exonération BC ${numero}`,
        }))
      );
    }
    await persistCommandes([...(commandesListe || []), nouvelle]);
    if (devis.exonereTVA) {
      await alerter("Commande exonérée", `BC ${numero} (devis ${devis.numero}) créé avec exonération de TVA — client ${(clientDe(devis.clientId) || {}).nom || "?"}`, { kind: "commande", id: nouvelle.id });
    }
    {
      const r = remiseAuDelaFicheClient(devis);
      if (r) await alerter("Remise au-delà de la fiche client", `BC ${numero} : remise ${r.max} % pour ${r.client} (fiche client : ${r.remiseClient} %)`, { kind: "commande", id: nouvelle.id });
    }
    const rappelBDC = rappelConditionsPaiement(devis.clientId);
    await tracerAcces("transformation BDC", `Devis ${devis.numero} → Dossier ${numero}`);
    setNotice(`Dossier ${numero} créé depuis le devis ${devis.numero}.${rappelBDC ? ` ${rappelBDC}` : ""}`);
  }
  async function persistArticles(next) {
    setArticles(next);
    return await saveKey(ARTICLES_KEY, next);
  }
  // Nils 08/10 (t) : marge d'un projet immo = somme des marges de ses dossiers, figée à la clôture (Nils).
  function margeProjet(chantierId, cache) {
    const ds = (commandesListe || []).filter((c) => !c.anterieure && chantierDuDossier(c) === chantierId);
    const o = { n: ds.length, nonFactures: ds.filter((c) => c.statut !== "Facture").length, ca: 0, coutA: 0, margeA: 0, margeB: 0, sansMarge: 0 };
    ds.forEach((c) => {
      const r = c.statut !== "BDC" ? margeDossier(c, cache) : null;
      if (!r) { o.sansMarge += 1; return; }
      o.ca += r.ca; o.coutA += r.coutA; o.margeA += r.margeA; o.margeB += r.margeB;
    });
    o.pctA = o.ca ? (o.margeA / o.ca) * 100 : 0;
    o.pctB = o.ca ? (o.margeB / o.ca) * 100 : 0;
    return o;
  }
  async function cloturerProjet(ch) {
    if (!estGerant) return;
    const m = margeProjet(ch.id, {});
    if (m.nonFactures > 0 && !(await demander(`${m.nonFactures} dossier(s) de « ${ch.nom} » ne sont pas encore facturés. Clôturer quand même ?`))) return;
    const cloture = { le: new Date().toISOString(), par: user.nom, marge: { n: m.n, ca: m.ca, coutA: m.coutA, margeA: m.margeA, margeB: m.margeB, pctA: m.pctA, pctB: m.pctB, nonFactures: m.nonFactures } };
    await persistChantiers((chantiers || []).map((x) => (x.id === ch.id ? { ...x, cloture } : x)));
    await tracerAcces("projet clôturé", `${ch.nom} — marge A ${formatDH(m.margeA)} (${Math.round(m.pctA * 10) / 10} %)`);
    setNotice(`Projet « ${ch.nom} » clôturé : marge figée.`);
  }
  async function rouvrirProjet(ch) {
    if (!estGerant) return;
    await persistChantiers((chantiers || []).map((x) => (x.id === ch.id ? { ...x, cloture: null } : x)));
    await tracerAcces("projet rouvert", ch.nom);
  }
  // Onglet « Projets immo » : liste, fiche, formulaire (Nils 12/10, lot 2).
  function renderProjets() {
    const ch = projetOuvert ? (chantiers || []).find((x) => x.id === projetOuvert) : null;
    const pill = (statut) => (
      <span style={{ fontSize: 10, fontWeight: 600, padding: "2px 8px", borderRadius: 10, background: statut === "terminé" ? PIERRE : "#E4EBE4", color: statut === "terminé" ? TAUPE : VERT_OK }}>{statut || "en cours"}</span>
    );
    const formulaire = projetEdit && (
      <Overlay onClose={() => setProjetEdit(null)}>
        <div style={modalStyle(620)}>
          <div style={modalTitleStyle}>{projetEdit.id ? "Modifier le projet" : "Nouveau projet immobilier"}</div>
          <Field label="Nom du projet"><input className="sc-input" value={projetEdit.nom} onChange={(e) => setProjetEdit({ ...projetEdit, nom: e.target.value, erreur: "" })} placeholder="ex. Bay View Dar Bouazza" style={inputStyle("100%")} autoFocus /></Field>
          <Field label="Client facturé">
            <select className="sc-select" value={projetEdit.clientId} onChange={(e) => { const c = clientDe(e.target.value); setProjetEdit({ ...projetEdit, clientId: e.target.value, commercialClient: contactsVendeurs(c).length === 1 ? contactsVendeurs(c)[0].nom : "", erreur: "" }); }} style={selectStyle}>
              <option value="">— Choisir —</option>
              {clientsActifs.map((c) => (<option key={c.id} value={c.id}>{c.nom}</option>))}
            </select>
          </Field>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <Field label="Promoteur"><input className="sc-input" value={projetEdit.promoteur} onChange={(e) => setProjetEdit({ ...projetEdit, promoteur: e.target.value, erreur: "" })} style={inputStyle("100%")} /></Field>
            <Field label="Architecte"><input className="sc-input" value={projetEdit.architecte} onChange={(e) => setProjetEdit({ ...projetEdit, architecte: e.target.value })} style={inputStyle("100%")} /></Field>
          </div>
          <Field label="Commercial du client">
            <select className="sc-select" value={projetEdit.commercialClient || ""} onChange={(e) => setProjetEdit({ ...projetEdit, commercialClient: e.target.value })} style={selectStyle} disabled={!projetEdit.clientId}>
              <option value="">— Non renseigné —</option>
              {trierAlpha(contactsVendeurs(clientDe(projetEdit.clientId)), "nom").map((c) => (<option key={c.id || c.nom} value={c.nom}>{c.nom}{c.fonction === "Direction" ? " (Direction)" : ""}</option>))}
            </select>
          </Field>
          <Field label="Adresse du site"><input className="sc-input" value={projetEdit.adresse} onChange={(e) => setProjetEdit({ ...projetEdit, adresse: e.target.value })} style={inputStyle("100%")} /></Field>
          {/* Nils 02/11 : plusieurs contacts sur place, chacun pour les bâtiments cochés. */}
          {(() => {
            const cs = projetEdit.contacts || [];
            const bats = batimentsDuProjet(projetEdit);
            const setC = (id, patch) => setProjetEdit({ ...projetEdit, contacts: cs.map((c) => (c.id === id ? { ...c, ...patch } : c)) });
            return (
              <div style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Contacts sur place</div>
                {cs.length === 0 && <div style={{ fontSize: 12, color: TAUPE, marginBottom: 6 }}>Aucun contact.</div>}
                {cs.map((c) => (
                  <div key={c.id} style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: 8, marginBottom: 6 }}>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                      <input className="sc-input" value={c.nom} onChange={(e) => setC(c.id, { nom: e.target.value })} placeholder="Nom et fonction — ex. Rochdi (assistant project manager)" style={{ ...inputStyle("100%"), flex: 2, minWidth: 200 }} />
                      <input className="sc-input" value={c.tel} onChange={(e) => setC(c.id, { tel: e.target.value })} placeholder="Téléphone" style={{ ...inputStyle("100%"), flex: 1, minWidth: 140 }} />
                      <button type="button" className="sc-btn" onClick={() => setProjetEdit({ ...projetEdit, contacts: cs.filter((x) => x.id !== c.id) })} style={iconBtnStyle} title="Retirer">✕</button>
                    </div>
                    <div style={{ display: "flex", gap: 12, flexWrap: "wrap", fontSize: 12, marginTop: 6, alignItems: "center" }}>
                      <span style={{ color: TAUPE }}>Bâtiments :</span>
                      {bats.length === 0 && <span style={{ color: TAUPE }}>aucun logement encore — le contact vaut pour tout le projet</span>}
                      {bats.map((b) => (
                        <label key={b} style={{ display: "flex", gap: 4, alignItems: "center", cursor: "pointer" }}>
                          <input type="checkbox" checked={(c.batiments || []).includes(b)} onChange={(e) => setC(c.id, { batiments: e.target.checked ? [...(c.batiments || []), b] : (c.batiments || []).filter((x) => x !== b) })} /> {libBatiment(b)}
                        </label>
                      ))}
                      {bats.length > 0 && !(c.batiments || []).length && <span style={{ color: TAUPE }}>(aucun coché = tous les bâtiments)</span>}
                    </div>
                  </div>
                ))}
                <button type="button" className="sc-btn" onClick={() => setProjetEdit({ ...projetEdit, contacts: [...cs, { id: uid(), nom: "", tel: "", batiments: [] }] })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 0" }}>+ Ajouter un contact</button>
              </div>
            );
          })()}
          <div style={{ fontSize: 11, color: TAUPE, marginTop: -8, marginBottom: 12 }}>Commercial du client et contact sur place sont repris dans chaque nouveau devis de cuisine (modifiables ensuite) ; les devis déjà créés ne changent pas.</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
            <Field label="Début prévu"><input type="date" className="sc-input" value={projetEdit.dateDebut} onChange={(e) => setProjetEdit({ ...projetEdit, dateDebut: e.target.value, erreur: "" })} style={inputStyle("100%")} /></Field>
            <Field label="Fin prévue"><input type="date" className="sc-input" value={projetEdit.dateFin} onChange={(e) => setProjetEdit({ ...projetEdit, dateFin: e.target.value, erreur: "" })} style={inputStyle("100%")} /></Field>
            <Field label="Statut">
              <select className="sc-select" value={projetEdit.statut} onChange={(e) => setProjetEdit({ ...projetEdit, statut: e.target.value })} style={selectStyle}>
                {STATUTS_PROJET.map((x) => (<option key={x} value={x}>{x}</option>))}
              </select>
            </Field>
          </div>
          {(() => {
            const m = projetEdit.marche || {};
            const setM = (patch) => setProjetEdit({ ...projetEdit, marche: { ...m, ...patch }, erreur: "" });
            return (
              <div style={{ background: PIERRE, borderRadius: 8, padding: 10, marginBottom: 12 }}>
                <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>Conditions du marché (sur chaque facture des dossiers du projet)</div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                  <Field label="Avance (%)" style={{ marginBottom: 0 }}><input className="sc-input" inputMode="decimal" value={m.avancePct ?? ""} onChange={(e) => setM({ avancePct: e.target.value })} placeholder="ex. 20" style={{ ...inputStyle("100%"), background: "#fff" }} /></Field>
                  <Field label="Retenue de garantie (%)" style={{ marginBottom: 0 }}><input className="sc-input" inputMode="decimal" value={m.retenuePct ?? ""} onChange={(e) => setM({ retenuePct: e.target.value })} style={{ ...inputStyle("100%"), background: "#fff" }} /></Field>
                  <Field label="Compte prorata (%)" style={{ marginBottom: 0 }}><input className="sc-input" inputMode="decimal" value={m.prorataPct ?? ""} onChange={(e) => setM({ prorataPct: e.target.value })} style={{ ...inputStyle("100%"), background: "#fff" }} /></Field>
                </div>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 6, lineHeight: 1.5 }}>Facture : HT des travaux − avance (même %, jusqu'à épuisement) − retenue (% du HT des travaux) = HT net → TVA → TTC − compte prorata (% du HT net) = net à payer. Laisser vide si le projet n'a pas ces conditions. Un changement vaut pour les factures suivantes, pas pour celles déjà émises.</div>
              </div>
            );
          })()}
          {projetEdit.erreur && <div style={{ color: ROUILLE, fontSize: 13, fontWeight: 600, marginBottom: 10 }}>{projetEdit.erreur}</div>}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
            <button type="button" className="sc-btn" onClick={() => setProjetEdit(null)} style={ghostBtnStyle}>Annuler</button>
            <button type="button" className="sc-btn" onClick={enregistrerProjet} style={primaryBtnStyle}>Enregistrer</button>
          </div>
        </div>
      </Overlay>
    );
    if (ch && projetVisible(ch)) {
      if (devisProjetEdit && devisProjetEdit.projetId === ch.id) return <div>{renderEditeurDevisProjet(ch)}{renderFicheProjet(ch)}</div>;
      return renderFicheProjet(ch);
    }
    return renderListeProjets();
    function renderFicheProjet(ch) {
      const ds = dossiersDuProjet(ch.id);
      const chiffres = chiffresProjet(ch.id);
      const cl = clientDe(ch.clientId) || {};
      const etapes = [
        ["BDC", ds.filter((c) => !c.anterieure && c.statut === "BDC")],
        ["RDM", ds.filter((c) => !c.anterieure && c.statut === "RDM")],
        ["PL", ds.filter((c) => !c.anterieure && c.statut === "PL")],
        ["BL", ds.filter((c) => !c.anterieure && c.statut === "BL" && !dossierEmisProjet(c) && !dossierArchive(c))],
        ["Facturés", ds.filter(dossierEmisProjet)],
      ];
      const m = estGerant ? (ch.cloture && ch.cloture.marge ? ch.cloture.marge : margeProjet(ch.id, {})) : null;
      const info = (lib, val) => (
        <div><div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>{lib}</div><div style={{ fontSize: 14, marginTop: 2 }}>{val || <span style={{ color: TAUPE }}>—</span>}</div></div>
      );
      const bloc = (titre, contenu) => (
        <div style={{ background: "#fff", borderRadius: 10, border: `1px solid ${PIERRE}`, padding: 16, marginBottom: 16 }}>
          <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 10 }}>{titre}</div>
          {contenu}
        </div>
      );
      return (
        <div>
          {formulaire}
          {factGroupe && factGroupe.chantierId === ch.id && (() => {
            const f = factGroupe;
            const bls = blFacturablesDuProjet(ch);
            const coches = bls.filter((c) => f.ids.includes(c.id));
            const basculer = (id) => setFactGroupe({ ...f, ids: f.ids.includes(id) ? f.ids.filter((x) => x !== id) : [...f.ids, id], erreur: "" });
            return (
              <Overlay onClose={() => setFactGroupe(null)}>
                <div style={modalStyle(720)}>
                  <div style={modalTitleStyle}>Facturer plusieurs BL — {ch.nom}</div>
                  <div style={{ fontSize: 12, color: TAUPE, marginBottom: 10 }}>Une seule facture, une ligne par BL (n° de BL, projet – bâtiment – étage – appartement, montant HT). Référence : « {ch.nom} {facturesGroupeesDuProjet(ch).reduce((m, g) => Math.max(m, Number(g[0].ordreFactureGroupee) || 0), 0) + 1} ».</div>
                  {bls.map((c) => (
                    <label key={c.id} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 13, padding: "6px 0", borderBottom: `1px solid ${PIERRE}`, cursor: "pointer" }}>
                      <input type="checkbox" checked={f.ids.includes(c.id)} onChange={() => basculer(c.id)} />
                      <strong style={{ minWidth: 110 }}>{c.numeroBL}</strong>
                      <span style={{ flex: 1 }}>{libLigneFactureGroupee(c)}{prefixeFacture(c) === "FAS" ? " (exonéré)" : ""}</span>
                      <span style={{ color: TAUPE }}>{formatDate(String(c.dateBL || "").slice(0, 10))}</span>
                      <span style={{ minWidth: 110, textAlign: "right" }}>{formatDH(htDossier(c))} HT</span>
                    </label>
                  ))}
                  <div style={{ display: "flex", alignItems: "center", gap: 16, marginTop: 12, flexWrap: "wrap" }}>
                    <Field label="Date de la facture" style={{ marginBottom: 0 }}>
                      <input type="date" className="sc-input" value={f.date} max={todayISO()} min={decalerJours(todayISO(), -JOURS_ANTIDATE_FACTURE)} onChange={(e) => setFactGroupe({ ...f, date: e.target.value, erreur: "" })} style={inputStyle(170)} />
                    </Field>
                    <span style={{ flex: 1 }} />
                    <strong>{coches.length} BL · {formatDH(coches.reduce((n, c) => n + htDossier(c), 0))} HT</strong>
                  </div>
                  {f.erreur && <div style={{ color: ROUILLE, fontSize: 13, fontWeight: 600, marginTop: 10 }}>{f.erreur}</div>}
                  <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 14 }}>
                    <button type="button" className="sc-btn" onClick={() => setFactGroupe(null)} style={ghostBtnStyle}>Annuler</button>
                    <button type="button" className="sc-btn" onClick={facturerPlusieursBL} style={primaryBtnStyle}>Facturer</button>
                  </div>
                </div>
              </Overlay>
            );
          })()}
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
            <button type="button" className="sc-btn" onClick={() => setProjetOuvert(null)} style={{ ...ghostBtnStyle, padding: "4px 0" }}>← Tous les projets</button>
            <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 600 }}>{ch.nom}</div>
            {pill(ch.statut)}
            {ch.cloture && <span style={{ fontSize: 12, color: VERT_OK }}>🔒 clôturé le {formatDate(ch.cloture.le.slice(0, 10))}</span>}
            <div style={{ flex: 1 }} />
            {estGerant && <button type="button" className="sc-btn" onClick={() => setProjetEdit({ ...nouveauProjet(), ...ch, contacts: contactsDuProjet(ch).map((c) => ({ ...c, batiments: [...(c.batiments || [])] })), marche: ch.marche || { avancePct: "", retenuePct: "", prorataPct: "" } })} style={ghostBtnStyle}>✎ Modifier</button>}
            {estGerant && <button type="button" className="sc-btn" onClick={() => supprimerProjet(ch)} style={{ ...ghostBtnStyle, color: ROUILLE }}>Supprimer</button>}
          </div>
          {bloc("Informations", (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 14 }}>
              {info("Client facturé", cl.nom)}
              {info("Promoteur", ch.promoteur)}
              {info("Architecte", ch.architecte)}
              {info("Adresse du site", ch.adresse)}
              {info("Zone de livraison", (zoneProjet(ch) || {}).nom || "")}
              {info("Commercial du client", ch.commercialClient)}
              {info(contactsDuProjet(ch).length > 1 ? "Contacts sur place" : "Contact sur place", contactsDuProjet(ch).length ? <span>{contactsDuProjet(ch).map((c) => (<span key={c.id} style={{ display: "block" }}>{[c.nom, c.tel].filter(Boolean).join(" · ")}{(c.batiments || []).length ? <span style={{ color: TAUPE }}> — {c.batiments.map(libBatiment).join(", ")}</span> : null}</span>))}</span> : "")}
              {info("Début prévu", ch.dateDebut ? formatDate(ch.dateDebut) : "")}
              {info("Fin prévue", ch.dateFin ? formatDate(ch.dateFin) : "")}
            </div>
          ))}
          {bloc("Devis projet", renderDevisProjet(ch))}
          {bloc("Électroménager standard par typologie", renderElectroProjet(ch))}
          {bloc(`Phases et logements (${(ch.logements || []).length})`, renderLogementsProjet(ch))}
          {bloc("Budgets réels", renderBudgetsReels(ch))}
          {bloc("Suivi de chantier", renderSuiviChantier(ch))}
          {bloc(`Dossiers du projet (${ds.length})`, ds.length ? (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 10 }}>
              {etapes.map(([lib, l]) => (
                <div key={lib} style={{ background: PIERRE, borderRadius: 8, padding: 10, minHeight: 60 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 6 }}>{lib} <span style={{ color: TAUPE, fontWeight: 500 }}>({l.length})</span></div>
                  {l.map((c) => (
                    <div key={c.id} style={{ fontSize: 12, padding: "3px 0", borderTop: `1px solid #fff` }}>
                      {c.anterieure ? <span>{c.numeroFacture || c.numero}</span> : (
                        <button type="button" className="sc-btn" onClick={() => { setActiveTab("commandes"); ouvrirCommande(c.id); }} style={{ ...ghostBtnStyle, padding: 0, fontSize: 12, textDecoration: "underline" }}>{c.numeroFacture || c.numeroBL || c.numeroPL || c.numeroRDM || c.numero}</button>
                      )}
                      {c.reference && <div style={{ color: TAUPE }}>{c.reference}</div>}
                      {montantsProjetVisibles && <div style={{ color: TAUPE }}>{formatDH(htDossierProjet(c))} HT</div>}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ) : <div style={{ fontSize: 13, color: TAUPE }}>Aucun dossier pour l'instant. Les devis de chaque cuisine se rattachent au projet depuis le champ « Projet immobilier » du devis.</div>)}
          {(montantsProjetVisibles || !(user.commandesSansTransformBLFacture || user.commandesSansBDCFacture)) && bloc("Factures groupées", (() => {
            // Nils 17/10 : plusieurs BL du projet sur une même facture (une ligne par BL).
            const groupes = facturesGroupeesDuProjet(ch);
            const peutFacturer = !(user.commandesSansTransformBLFacture || user.commandesSansBDCFacture);
            const nbBL = blFacturablesDuProjet(ch).length;
            return (
              <div>
                {groupes.length === 0 && <div style={{ fontSize: 13, color: TAUPE, marginBottom: 8 }}>Aucune facture groupée pour ce projet.</div>}
                {groupes.map((g) => (
                  <div key={g[0].factureGroupeeId} style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", fontSize: 13, padding: "6px 0", borderBottom: `1px solid ${PIERRE}` }}>
                    <strong>{g[0].numeroFacture}</strong>
                    <span>« {g[0].refFactureGroupee} »</span>
                    <span style={{ color: TAUPE }}>{formatDate(String(g[0].dateFacture || "").slice(0, 10))} · {g.length} BL ({g.map((x) => x.numeroBL).join(", ")})</span>
                    {montantsProjetVisibles && <span style={{ color: TAUPE }}>{formatDH(g.reduce((n, x) => n + htDossier(x), 0))} HT</span>}
                    <span style={{ flex: 1 }} />
                    {montantsProjetVisibles && <button type="button" className="sc-btn" onClick={() => imprimerFactureGroupee(g[0])} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0" }}>⬇ Facture</button>}
                  </div>
                ))}
                {peutFacturer && (
                  <button type="button" className="sc-btn" disabled={nbBL < 2} onClick={() => ouvrirFactureGroupee(ch)} style={{ ...ghostBtnStyle, marginTop: 10, opacity: nbBL < 2 ? 0.5 : 1 }} title={nbBL < 2 ? "Il faut au moins deux dossiers au stade BL, pas encore facturés." : ""}>
                    🧾 Facturer plusieurs BL ({nbBL} à facturer)
                  </button>
                )}
              </div>
            );
          })())}
          {montantsProjetVisibles && bloc("Chiffres", (
            <div style={{ display: "flex", gap: 32 }}>
              {info("CA facturé HT", formatDH(chiffres.caFacture))}
              {info("Reste dû (encours)", <span style={{ color: chiffres.resteDu > 0 ? OCRE : VERT_OK, fontWeight: 600 }}>{formatDH(chiffres.resteDu)}</span>)}
              {info("Devis rattachés", String(devisDuProjet(ch.id).length))}
            </div>
          ))}
          {montantsProjetVisibles && (conditionsMarche(ch) || projetAUneAvance(ch)) && bloc("Avance, retenues de garantie et compte prorata", (() => {
            const cond = conditionsMarche(ch) || { avancePct: 0, retenuePct: 0, prorataPct: 0 };
            const ants = (ch.marche || {}).avancesAnterieures || [];
            const total = avanceProjetHT(ch), remb = avanceRembourseeHT(ch), solde = arrondiH(total - remb);
            const factures = ds.filter((c) => !c.anterieure && c.deductionsProjet);
            const retErp = arrondiH(factures.reduce((n, c) => n + (Number(c.deductionsProjet.retenue) || 0), 0));
            const retAnt = arrondiH((facturesAnt || []).filter((x) => x.type !== "avoir" && x.chantierId === ch.id).reduce((n, x) => n + (Number(x.retenueHT) || 0), 0));
            const retAF = retenuesAFacturer(ch);
            const facturesRet = (facturesAvance || []).filter((fa) => fa.chantierId === ch.id && fa.nature === "retenue");
            const retFacturees = arrondiH(facturesRet.reduce((n, fa) => n + (Number(fa.ht) || 0), 0));
            const prorata = arrondiH(factures.reduce((n, c) => n + (Number(c.deductionsProjet.prorata) || 0), 0) + (facturesAvance || []).filter((fa) => fa.chantierId === ch.id).reduce((n, fa) => n + (Number(fa.prorata) || 0), 0));
            const resteAFacturer = ds.filter((c) => !c.anterieure && !c.deductionsProjet && !dossierEmisProjet(c)).length;
            const p = (x) => String(x).replace(".", ",");
            return (
              <div style={{ fontSize: 13 }}>
                <div style={{ color: TAUPE, marginBottom: 10 }}>Avance {p(cond.avancePct)} % · retenue de garantie {p(cond.retenuePct)} % du HT des travaux · compte prorata {p(cond.prorataPct)} % du HT net{estGerant ? " — modifiables par ✎ Modifier" : ""}</div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 14, marginBottom: 12 }}>
                  {info("Avance facturée (HT)", formatDH(total))}
                  {info("Avance remboursée (HT)", formatDH(remb))}
                  {info("Solde de l'avance (HT)", <span style={{ color: solde > 0.01 ? OCRE : VERT_OK, fontWeight: 600 }}>{formatDH(solde)}</span>)}
                  {info("Compte prorata déduit", formatDH(prorata))}
                  {info("Retenues de garantie (HT)", formatDH(arrondiH(retErp + retAnt)))}
                  {info("dont déjà facturées", formatDH(retFacturees))}
                  {info("Retenues à facturer (HT)", <span style={{ fontWeight: 600, color: retAF.length ? OCRE : VERT_OK }}>{formatDH(arrondiH(retAF.reduce((n, x) => n + x.ht, 0)))}</span>)}
                </div>
                {solde > 0.01 && !resteAFacturer && ds.length > 0 && <div style={{ color: ROUILLE, fontWeight: 600, marginBottom: 8 }}>Il reste {formatDH(solde)} HT d'avance à rembourser et plus aucun dossier à facturer : coche « Dernière facture du projet » sur le dernier dossier, ou vérifie les avances saisies.</div>}
                <div style={{ fontSize: 12, fontWeight: 600, margin: "6px 0" }}>Facture d'avance (une par projet)</div>
                {!projetAUneAvance(ch) && <div style={{ fontSize: 12, color: TAUPE }}>Aucune pour l'instant.</div>}
                {ants.map((a) => (
                  <div key={a.id} style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 12, padding: "3px 0", borderTop: `1px solid ${PIERRE}` }}>
                    <span style={{ flex: 1 }}><strong>{a.numero}</strong> du {formatDate(a.date)} (antérieure à l'ERP) — {formatDH(a.ht)} HT — déjà remboursé avant l'ERP {formatDH(a.rembourseHT || 0)} HT</span>
                    {estGerant && <button type="button" className="sc-btn" onClick={() => supprimerAvanceAnterieure(ch, a)} style={iconBtnStyle} title="Retirer">✕</button>}
                  </div>
                ))}
                {(facturesAvance || []).filter((fa) => fa.chantierId === ch.id && fa.nature !== "retenue").map((fa) => {
                  const reste = arrondiH(totalDossierTTC({ anterieure: true, ttcAnt: fa.ttc }) - encaisseDossier(`avp:${fa.id}`));
                  return (
                    <div key={fa.id} style={{ fontSize: 12, padding: "6px 0", borderTop: `1px solid ${PIERRE}` }}>
                      <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                        <span style={{ flex: 1 }}><strong>Facture d'avance {fa.numero}</strong> du {formatDate(fa.date)} — {formatDH(fa.ht)} HT · TTC {formatDH(fa.ttc)}{fa.prorata ? ` · prorata ${formatDH(fa.prorata)}` : ""} · net à payer {formatDH(fa.net)} · <span style={{ color: reste > 0.01 ? OCRE : VERT_OK }}>{reste > 0.01 ? `reste dû ${formatDH(reste)}` : "réglée"}</span></span>
                        <button type="button" className="sc-btn" onClick={() => imprimerFactureAvance(fa)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 6px" }}>⬇ Télécharger la facture</button>
                        {estGerant && !fa.envoyeeClientLe && !fa.transmiseComptableLe && <button type="button" className="sc-btn" onClick={() => supprimerFactureAvance(fa)} style={iconBtnStyle} title="Supprimer (dernière de la série, non envoyée)">✕</button>}
                      </div>
                      {peutFactureAvance && (
                        <div style={{ display: "flex", gap: 14, marginTop: 4, color: TAUPE }}>
                          <label style={{ display: "flex", gap: 4, alignItems: "center", cursor: "pointer" }}><input type="checkbox" checked={!!fa.envoyeeClientLe} disabled={!!fa.transmiseComptableLe} onChange={(e) => majFactureAvance(fa, e.target.checked ? { envoyeeClientLe: todayISO(), envoyeeClientPar: user.nom } : { envoyeeClientLe: "", envoyeeClientPar: "" }, e.target.checked ? "envoyée au client" : "envoi décoché")} /> Envoyée au client{fa.envoyeeClientLe ? ` le ${formatDate(fa.envoyeeClientLe)}` : ""}</label>
                          <label style={{ display: "flex", gap: 4, alignItems: "center", cursor: fa.transmiseComptableLe ? "default" : "pointer" }}><input type="checkbox" checked={!!fa.transmiseComptableLe} disabled={!!fa.transmiseComptableLe} onChange={async (e) => { if (e.target.checked && (await demander(`Transmettre ${fa.numero} au comptable ? C'est définitif.`))) await majFactureAvance(fa, { transmiseComptableLe: todayISO(), transmiseComptablePar: user.nom }, "transmise au comptable"); }} /> Transmise au comptable{fa.transmiseComptableLe ? ` le ${formatDate(fa.transmiseComptableLe)} (définitif)` : ""}</label>
                        </div>
                      )}
                    </div>
                  );
                })}
                {!projetAUneAvance(ch) && (
                  <div style={{ display: "flex", gap: 16, marginTop: 6, flexWrap: "wrap" }}>
                    {peutFactureAvance && cond.avancePct > 0 && <button type="button" className="sc-btn" onClick={() => ouvrirFactureAvance(ch)} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 12px" }}>Émettre la facture d'avance</button>}
                    {estGerant && <button type="button" className="sc-btn" onClick={() => setAvanceAntEdit({ chId: ch.id, numero: "", date: "", ht: "", rembourseHT: "" })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0" }}>+ Facture d'avance antérieure à l'ERP</button>}
                  </div>
                )}
                {avanceEmission && avanceEmission.chId === ch.id && (() => {
                  const f = avanceEmission;
                  const set = (patch) => setAvanceEmission({ ...f, ...patch, erreur: "" });
                  const recalcul = (marche, pc) => { const m2 = parseMontantSaisi(marche), q = Number(String(pc).replace(",", ".")); return isFinite(m2) && m2 > 0 && q > 0 ? String(arrondiH((m2 * q) / 100)) : f.ht; };
                  const htN = parseMontantSaisi(f.ht);
                  const mt = isFinite(htN) && htN > 0 ? montantsFactureAvance({ ht: htN, tauxTVA: f.exo ? 0 : TVA_TAUX, prorataPct: cond.prorataPct }) : null;
                  return (
                    <Overlay onClose={() => setAvanceEmission(null)}>
                      <div style={modalStyle(560)}>
                        <div style={modalTitleStyle}>Facture d'avance — {ch.nom}</div>
                        <div style={{ display: "grid", gridTemplateColumns: "1.3fr 0.7fr 1fr", gap: 12 }}>
                          <Field label="Montant du marché HT"><input className="sc-input" inputMode="decimal" value={f.marcheHT} onChange={(e) => set({ marcheHT: e.target.value, ht: recalcul(e.target.value, f.pct) })} style={inputStyle("100%")} /></Field>
                          <Field label="Avance (%)"><input className="sc-input" inputMode="decimal" value={f.pct} onChange={(e) => set({ pct: e.target.value, ht: recalcul(f.marcheHT, e.target.value) })} style={inputStyle("100%")} /></Field>
                          <Field label="Avance HT"><input className="sc-input" inputMode="decimal" value={f.ht} onChange={(e) => set({ ht: e.target.value })} style={inputStyle("100%")} /></Field>
                        </div>
                        <div style={{ fontSize: 11, color: TAUPE, marginTop: -8, marginBottom: 10 }}>Marché pré-rempli avec le HT de la dernière version du devis projet ; tout reste modifiable.</div>
                        <Field label="Désignation"><input className="sc-input" value={f.designation} onChange={(e) => set({ designation: e.target.value })} style={inputStyle("100%")} /></Field>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, alignItems: "end" }}>
                          <Field label="Date de la facture"><input type="date" className="sc-input" value={f.date} max={todayISO()} min={decalerJours(todayISO(), -JOURS_ANTIDATE_FACTURE)} onChange={(e) => set({ date: e.target.value })} style={inputStyle("100%")} /></Field>
                          <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13, marginBottom: 16 }}><input type="checkbox" checked={!!f.exo} onChange={(e) => set({ exo: e.target.checked })} /> Exonérée de TVA (série FAS)</label>
                        </div>
                        {mt && (
                          <div style={{ background: PIERRE, borderRadius: 8, padding: "8px 12px", fontSize: 13, marginBottom: 12 }}>
                            <div style={{ display: "flex", justifyContent: "space-between" }}><span>Avance HT</span><span>{formatDH(mt.htTravaux)}</span></div>
                            {mt.prorata ? <div style={{ display: "flex", justifyContent: "space-between" }}><span>− Compte prorata ({String(mt.prorataPct).replace(".", ",")} % du HT)</span><span>− {formatDH(mt.prorata)}</span></div> : null}
                            <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700 }}><span>HT net</span><span>{formatDH(mt.htNet)}</span></div>
                            <div style={{ display: "flex", justifyContent: "space-between" }}><span>TVA</span><span>{formatDH(mt.tva)}</span></div>
                            <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700 }}><span>Net à payer (TTC)</span><span>{formatDH(mt.ttc)}</span></div>
                          </div>
                        )}
                        {f.erreur && <div style={{ color: ROUILLE, fontSize: 13, fontWeight: 600, marginBottom: 10 }}>{f.erreur}</div>}
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                          <button type="button" className="sc-btn" onClick={() => setAvanceEmission(null)} style={ghostBtnStyle}>Annuler</button>
                          <button type="button" className="sc-btn" onClick={emettreFactureAvance} style={primaryBtnStyle}>Émettre la facture d'avance</button>
                        </div>
                      </div>
                    </Overlay>
                  );
                })()}
                <div style={{ fontSize: 12, fontWeight: 600, margin: "12px 0 6px" }}>Retenues de garantie</div>
                {facturesRet.map((fa) => {
                  const reste = arrondiH(Number(fa.ttc) - encaisseDossier(`avp:${fa.id}`));
                  const retard = reste > 0.01 && fa.echeanceLegale && todayISO() > fa.echeanceLegale;
                  return (
                    <div key={fa.id} style={{ fontSize: 12, padding: "6px 0", borderTop: `1px solid ${PIERRE}` }}>
                      <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                        <span style={{ flex: 1 }}><strong>Facture de retenue {fa.numero}</strong> du {formatDate(fa.date)} — {(fa.sources || []).length} retenue(s), {formatDH(fa.ht)} HT · TTC {formatDH(fa.ttc)}{fa.prorata ? ` · prorata ${formatDH(fa.prorata)}` : ""} · net à payer {formatDH(fa.net)} · échéance légale {fa.echeanceLegale ? formatDate(fa.echeanceLegale) : "—"} · <span style={{ color: reste <= 0.01 ? VERT_OK : retard ? ROUILLE : OCRE, fontWeight: retard ? 600 : 400 }}>{reste <= 0.01 ? "réglée" : `${retard ? "en retard — " : ""}reste dû ${formatDH(reste)}`}</span></span>
                        <button type="button" className="sc-btn" onClick={() => imprimerFactureAvance(fa)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 6px" }}>⬇ Télécharger la facture</button>
                        {estGerant && !fa.envoyeeClientLe && !fa.transmiseComptableLe && <button type="button" className="sc-btn" onClick={() => supprimerFactureAvance(fa)} style={iconBtnStyle} title="Supprimer (dernière de la série, non envoyée)">✕</button>}
                      </div>
                      {peutFactureAvance && (
                        <div style={{ display: "flex", gap: 14, marginTop: 4, color: TAUPE }}>
                          <label style={{ display: "flex", gap: 4, alignItems: "center", cursor: "pointer" }}><input type="checkbox" checked={!!fa.envoyeeClientLe} disabled={!!fa.transmiseComptableLe} onChange={(e) => majFactureAvance(fa, e.target.checked ? { envoyeeClientLe: todayISO(), envoyeeClientPar: user.nom } : { envoyeeClientLe: "", envoyeeClientPar: "" }, e.target.checked ? "envoyée au client" : "envoi décoché")} /> Envoyée au client{fa.envoyeeClientLe ? ` le ${formatDate(fa.envoyeeClientLe)}` : ""}</label>
                          <label style={{ display: "flex", gap: 4, alignItems: "center", cursor: fa.transmiseComptableLe ? "default" : "pointer" }}><input type="checkbox" checked={!!fa.transmiseComptableLe} disabled={!!fa.transmiseComptableLe} onChange={async (e) => { if (e.target.checked && (await demander(`Transmettre ${fa.numero} au comptable ? C'est définitif.`))) await majFactureAvance(fa, { transmiseComptableLe: todayISO(), transmiseComptablePar: user.nom }, "transmise au comptable"); }} /> Transmise au comptable{fa.transmiseComptableLe ? ` le ${formatDate(fa.transmiseComptableLe)} (définitif)` : ""}</label>
                        </div>
                      )}
                    </div>
                  );
                })}
                {retAF.length > 0 && <div style={{ fontSize: 12, color: TAUPE, marginTop: 4 }}>À facturer : {retAF.map((x) => `${x.numero} (${formatDH(x.ht)})`).join(" · ")}</div>}
                {!retAF.length && !facturesRet.length && <div style={{ fontSize: 12, color: TAUPE }}>Aucune retenue pour l'instant.</div>}
                {peutFactureAvance && retAF.length > 0 && <button type="button" className="sc-btn" onClick={() => ouvrirFactureRetenue(ch)} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 12px", marginTop: 6 }}>Facturer les retenues de garantie</button>}
                {retenueEmission && retenueEmission.chId === ch.id && (() => {
                  const f = retenueEmission;
                  const set = (patch) => setRetenueEmission({ ...f, ...patch, erreur: "" });
                  const coches = retAF.filter((x) => f.cles.includes(x.cle));
                  const mt = coches.length ? montantsFactureAvance({ ht: arrondiH(coches.reduce((n, x) => n + x.ht, 0)), tauxTVA: f.exo ? 0 : TVA_TAUX, prorataPct: cond.prorataPct }) : null;
                  return (
                    <Overlay onClose={() => setRetenueEmission(null)}>
                      <div style={modalStyle(620)}>
                        <div style={modalTitleStyle}>Facture de retenue de garantie — {ch.nom}</div>
                        <div style={{ fontSize: 12, color: TAUPE, marginBottom: 8 }}>Retenues encore à facturer (décoche celles que le client ne libère pas encore) :</div>
                        {retAF.map((x) => (
                          <label key={x.cle} style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 13, padding: "4px 0", borderBottom: `1px solid ${PIERRE}`, cursor: "pointer" }}>
                            <input type="checkbox" checked={f.cles.includes(x.cle)} onChange={() => set({ cles: f.cles.includes(x.cle) ? f.cles.filter((k) => k !== x.cle) : [...f.cles, x.cle] })} />
                            <span style={{ flex: 1 }}>{x.numero} du {formatDate(x.date)}{x.reference ? ` — ${x.reference}` : ""}{x.anterieure ? " (antérieure à l'ERP)" : ""}</span>
                            <span>{formatDH(x.ht)} HT</span>
                          </label>
                        ))}
                        <div style={{ height: 10 }} />
                        <Field label="Désignation"><input className="sc-input" value={f.designation} onChange={(e) => set({ designation: e.target.value })} style={inputStyle("100%")} /></Field>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, alignItems: "end" }}>
                          <Field label="Date de la facture"><input type="date" className="sc-input" value={f.date} max={todayISO()} min={decalerJours(todayISO(), -JOURS_ANTIDATE_FACTURE)} onChange={(e) => set({ date: e.target.value })} style={inputStyle("100%")} /></Field>
                          <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13, marginBottom: 16 }}><input type="checkbox" checked={!!f.exo} onChange={(e) => set({ exo: e.target.checked })} /> Exonérée de TVA (série FAS)</label>
                        </div>
                        {mt && (
                          <div style={{ background: PIERRE, borderRadius: 8, padding: "8px 12px", fontSize: 13, marginBottom: 12 }}>
                            <div style={{ display: "flex", justifyContent: "space-between" }}><span>Retenues de garantie HT</span><span>{formatDH(mt.htTravaux)}</span></div>
                            {mt.prorata ? <div style={{ display: "flex", justifyContent: "space-between" }}><span>− Compte prorata ({String(mt.prorataPct).replace(".", ",")} % du HT)</span><span>− {formatDH(mt.prorata)}</span></div> : null}
                            <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700 }}><span>HT net</span><span>{formatDH(mt.htNet)}</span></div>
                            <div style={{ display: "flex", justifyContent: "space-between" }}><span>TVA</span><span>{formatDH(mt.tva)}</span></div>
                            <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700 }}><span>Net à payer (TTC)</span><span>{formatDH(mt.ttc)}</span></div>
                            <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Délai légal de paiement : {JOURS_LEGAUX_RETENUE} jours après la date de la facture (loi 69-21), soit le {formatDate(decalerJours(f.date || todayISO(), JOURS_LEGAUX_RETENUE))}. Alerte {JOURS_ALERTE_RETENUE} jours avant et si elle est dépassée.</div>
                          </div>
                        )}
                        {f.erreur && <div style={{ color: ROUILLE, fontSize: 13, fontWeight: 600, marginBottom: 10 }}>{f.erreur}</div>}
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                          <button type="button" className="sc-btn" onClick={() => setRetenueEmission(null)} style={ghostBtnStyle}>Annuler</button>
                          <button type="button" className="sc-btn" onClick={emettreFactureRetenue} style={primaryBtnStyle}>Émettre la facture de retenue</button>
                        </div>
                      </div>
                    </Overlay>
                  );
                })()}
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 8, lineHeight: 1.5 }}>Retenues des factures d'avant l'ERP : champ « Retenue de garantie » des factures antérieures. Une retenue n'est facturée qu'une fois.</div>
                {avanceAntEdit && avanceAntEdit.chId === ch.id && (
                  <Overlay onClose={() => setAvanceAntEdit(null)}>
                    <div style={modalStyle(520)}>
                      <div style={modalTitleStyle}>Facture d'avance antérieure à l'ERP — {ch.nom}</div>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                        <Field label="N° de la facture d'avance"><input className="sc-input" value={avanceAntEdit.numero} onChange={(e) => setAvanceAntEdit({ ...avanceAntEdit, numero: e.target.value, erreur: "" })} style={inputStyle("100%")} /></Field>
                        <Field label="Date"><input type="date" className="sc-input" value={avanceAntEdit.date} max={todayISO()} onChange={(e) => setAvanceAntEdit({ ...avanceAntEdit, date: e.target.value, erreur: "" })} style={inputStyle("100%")} /></Field>
                        <Field label="Montant HT de l'avance"><input className="sc-input" inputMode="decimal" value={avanceAntEdit.ht} onChange={(e) => setAvanceAntEdit({ ...avanceAntEdit, ht: e.target.value, erreur: "" })} style={inputStyle("100%")} /></Field>
                        <Field label="Déjà remboursé avant l'ERP (HT)"><input className="sc-input" inputMode="decimal" value={avanceAntEdit.rembourseHT} onChange={(e) => setAvanceAntEdit({ ...avanceAntEdit, rembourseHT: e.target.value, erreur: "" })} placeholder="0" style={inputStyle("100%")} /></Field>
                      </div>
                      <div style={{ fontSize: 11, color: TAUPE, marginBottom: 10 }}>Total des remboursements d'avance déjà déduits sur les factures émises avant l'ERP. Le reste sera déduit des prochaines factures du projet ({p(cond.avancePct)} % du HT des travaux).</div>
                      {avanceAntEdit.erreur && <div style={{ color: ROUILLE, fontSize: 13, fontWeight: 600, marginBottom: 10 }}>{avanceAntEdit.erreur}</div>}
                      <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                        <button type="button" className="sc-btn" onClick={() => setAvanceAntEdit(null)} style={ghostBtnStyle}>Annuler</button>
                        <button type="button" className="sc-btn" onClick={enregistrerAvanceAnterieure} style={primaryBtnStyle}>Enregistrer</button>
                      </div>
                    </div>
                  </Overlay>
                )}
              </div>
            );
          })())}
          {estGerant && m && bloc("Marge (Gérant)", (
            <div>
              <div style={{ display: "flex", gap: 32, flexWrap: "wrap" }}>
                {info("CA HT", formatDH(m.ca))}
                {info("Marge A (mois réel)", `${formatDH(m.margeA)} · ${Math.round(m.pctA * 10) / 10} %`)}
                {info("Marge B (moy. 12 mois)", `${formatDH(m.margeB)} · ${Math.round(m.pctB * 10) / 10} %`)}
                {info("Non facturés", String(m.nonFactures || 0))}
              </div>
              <div style={{ marginTop: 12, display: "flex", gap: 10, alignItems: "center" }}>
                {ch.cloture
                  ? <><span style={{ fontSize: 12, color: TAUPE }}>Marge figée au jour de la clôture.</span><button type="button" className="sc-btn" onClick={() => rouvrirProjet(ch)} style={ghostBtnStyle}>Rouvrir (recalculer)</button></>
                  : <><span style={{ fontSize: 12, color: TAUPE }}>Marge provisoire, recalculée à chaque ouverture.</span><button type="button" className="sc-btn" onClick={() => cloturerProjet(ch)} style={primaryBtnStyle}>Clôturer le projet</button></>}
              </div>
            </div>
          ))}
        </div>
      );
    }
    function renderListeProjets() {
    const q = normLib(projetsFiltre.q || "");
    const liste = (chantiers || []).filter(projetVisible)
      .filter((x) => projetsFiltre.statut === "tous" || (x.statut || "en cours") === projetsFiltre.statut)
      .filter((x) => !projetsFiltre.client || x.clientId === projetsFiltre.client)
      .filter((x) => !q || normLib(`${x.nom} ${x.promoteur || ""} ${(clientDe(x.clientId) || {}).nom || ""}`).includes(q))
      .sort((a, b) => a.nom.localeCompare(b.nom, "fr"));
    const clientsAvecProjet = clientsActifs.filter((c) => (chantiers || []).some((x) => x.clientId === c.id) && clientVisiblePourUser(c));
    const cols = montantsProjetVisibles ? "2fr 1.4fr 1.4fr 0.8fr 0.6fr 1fr" : "2fr 1.4fr 1.4fr 0.8fr 0.6fr";
    return (
      <div>
        {formulaire}
        <div style={{ display: "flex", gap: 14, alignItems: "flex-end", marginBottom: 16, justifyContent: "space-between" }}>
          <div style={{ display: "flex", gap: 14, alignItems: "flex-end" }}>
            <FiltreChamp label="Rechercher"><input className="sc-input" value={projetsFiltre.q} onChange={(e) => setProjetsFiltre({ ...projetsFiltre, q: e.target.value })} placeholder="Projet, client, promoteur…" style={inputStyle(240)} /></FiltreChamp>
            <FiltreChamp label="Statut">
              <select className="sc-select" value={projetsFiltre.statut} onChange={(e) => setProjetsFiltre({ ...projetsFiltre, statut: e.target.value })} style={selectStyle}>
                <option value="en cours">En cours</option>
                <option value="terminé">Terminés</option>
                <option value="tous">Tous</option>
              </select>
            </FiltreChamp>
            <FiltreChamp label="Client">
              <select className="sc-select" value={projetsFiltre.client} onChange={(e) => setProjetsFiltre({ ...projetsFiltre, client: e.target.value })} style={selectStyle}>
                <option value="">Tous</option>
                {clientsAvecProjet.map((c) => (<option key={c.id} value={c.id}>{c.nom}</option>))}
              </select>
            </FiltreChamp>
          </div>
          {estGerant && <button type="button" className="sc-btn" onClick={() => setProjetEdit(nouveauProjet())} style={primaryBtnStyle}>+ Nouveau projet</button>}
        </div>
        <div style={{ background: "#fff", borderRadius: 10, overflow: "hidden", border: `1px solid ${PIERRE}` }}>
          <div style={{ display: "grid", gridTemplateColumns: cols, padding: "12px 16px", borderBottom: `1px solid ${PIERRE}` }}>
            <Th>Projet</Th><Th>Client facturé</Th><Th>Promoteur</Th><Th>Statut</Th><Th>Dossiers</Th>{montantsProjetVisibles && <Th>CA facturé HT</Th>}
          </div>
          {liste.length === 0 && <div style={{ padding: 20, fontSize: 13, color: TAUPE }}>Aucun projet{projetsFiltre.statut !== "tous" ? " avec ce statut" : ""}.{estGerant ? " « + Nouveau projet » pour en créer un." : ""}</div>}
          {liste.map((x) => {
            const c = chiffresProjet(x.id);
            return (
              <div key={x.id} className="sc-row" onClick={() => setProjetOuvert(x.id)} style={{ display: "grid", gridTemplateColumns: cols, padding: "12px 16px", alignItems: "center", borderBottom: `1px solid ${PIERRE}`, fontSize: 13, cursor: "pointer" }}>
                <div style={{ fontWeight: 600 }}>{x.nom}{x.cloture ? " 🔒" : ""}</div>
                <div>{(clientDe(x.clientId) || {}).nom || "—"}</div>
                <div>{x.promoteur || <span style={{ color: TAUPE }}>à renseigner</span>}</div>
                <div>{pill(x.statut)}</div>
                <div>{c.n}</div>
                {montantsProjetVisibles && <div>{formatDH(c.caFacture)}</div>}
              </div>
            );
          })}
        </div>
      </div>
    );
    }
  }
  // ---------- ERP step 16 (Nils 12/10, lot 4a) : phases, logements, budgets réels ----------
  // ch.phases = [{ id, nom }] ; ch.logements = [{ id, batiment, etage, appart, typologieId, phaseId }].
  // Le devis d'une cuisine porte logementId / projetTypologieId / signatureTypologie (devis créé depuis le logement).
  const peutGererLogements = estGerant || user.profil === P_ADV_SR;
  const peutCreerDevisLogement = estGerant || user.profil === P_ADV_SR || user.profil === P_ADV_JR;
  function libLogement(l) {
    return [l.batiment, l.etage !== "" && l.etage != null ? `Ét. ${l.etage}` : "", l.appart ? `Apt ${l.appart}` : ""].filter(Boolean).join(" – ");
  }
  function derniereVersionDP(ch) {
    const vs = versionsDevisProjet(ch);
    return vs.length ? vs[vs.length - 1] : null;
  }
  function devisDuLogement(l) {
    return (devisListe || []).filter((d) => d.logementId === l.id).sort((a, b) => String(b.creeLe || "").localeCompare(String(a.creeLe || "")))[0] || null;
  }
  function dossierDuDevisLogement(d) {
    return d ? (commandesListe || []).find((c) => c.devisId === d.id) || null : null;
  }
  // Lignes d'une cuisine d'après sa typologie, aux prix du devis projet (livraison : part par cuisine).
  function lignesTypologie(ch, v, typoId) {
    const t = (v.typologies || []).find((x) => x.id === typoId);
    if (!t) return [];
    const k = calculDevisProjet(v, ch);
    const ligne = (x, qte, prixPublic) => {
      const a = (articles || []).find((y) => y.id === x.articleId) || {};
      return { id: uid(), type: "facture", articleId: x.articleId, designation: a.designation || "", qte, unite: a.unite || "", prixPublic, remise: Number(x.remise) || 0, groupe: a.structurel ? a.groupe : null };
    };
    const out = [];
    (v.articles || []).forEach((x) => {
      if (x.articleId === v.articleLivraisonId) {
        if (k.nbCuisines && k.nbLivraisons) out.push(ligne(x, 1, Math.round(((Number(x.prix) || 0) * k.nbLivraisons / k.nbCuisines) * 100) / 100));
      } else if (x.articleId === v.articleRDMId) {
        out.push({ ...ligne(x, 1, Number(x.prix) || 0), remise: 100 });
      } else {
        const q = Number((t.qtes || {})[x.articleId]) || 0;
        if (q > 0) out.push(ligne(x, q, Number(x.prix) || 0));
      }
    });
    return out;
  }
  function signatureLignes(lignes) {
    return JSON.stringify((lignes || []).filter((l) => !l.type || l.type === "facture").map((l) => [l.articleId || l.designation, Number(l.qte) || 0, Number(l.prixPublic) || 0, Number(l.remise) || 0]).sort());
  }
  function devisModifieTypologie(d) {
    return !!d && !!d.signatureTypologie && d.signatureTypologie !== signatureLignes(d.lignes);
  }
  function creerDevisLogement(ch, l) {
    if (!peutCreerDevisLogement) return;
    const v = derniereVersionDP(ch);
    if (!v) { setNotice("Pas encore de devis projet : Le Gérant doit d'abord le créer."); return; }
    const t = (v.typologies || []).find((x) => x.id === l.typologieId);
    if (!t) { setNotice("Ce logement n'a pas de typologie (ou elle n'existe plus dans le devis projet)."); return; }
    if (devisDuLogement(l)) { setNotice("Ce logement a déjà un devis."); return; }
    const c = clientDe(ch.clientId) || {};
    const lignes = lignesTypologie(ch, v, t.id);
    // Nils 02/11 : acompte facturé avant l'ERP — déduit sur ce devis, la facture ERP vaut le solde.
    const ac = l.acompteAvantERP;
    if (ac && Number(ac.ht) > 0) lignes.push({ id: uid(), type: "facture", designation: `Acompte facturé avant l'ERP — facture ${ac.numero}${ac.date ? ` du ${formatDate(ac.date)}` : ""}`, qte: 1, unite: "", prixPublic: -arrondiH(Number(ac.ht)), remise: 0, deductionAcompte: true });
    nouveauDevis();
    setDraft((prev) => ({
      ...prev,
      clientId: ch.clientId,
      chantierId: ch.id,
      // Nils 30/10 : le projet figure déjà dans la case Projet — la référence ne porte que le logement.
      reference: [libBatiment(l.batiment), l.etage !== "" && l.etage != null ? `Ét. ${l.etage}` : "", l.appart ? `Apt ${l.appart}` : ""].filter(Boolean).join(" – "),
      etage: l.etage !== undefined && l.etage !== null ? String(l.etage) : "",
      conditionsPaiement: c.paiement || prev.conditionsPaiement,
      commercialSC: c.commercialSC || prev.commercialSC,
      apporteurAffaire: c.apporteurAffaire || prev.apporteurAffaire,
      commercialClient: ch.commercialClient || (contactsVendeurs(c).length === 1 ? contactsVendeurs(c)[0].nom : ""),
      // Nils 02/11 : contact sur place du bâtiment du logement.
      contactSurPlace: (contactPourLogement(ch, l) || {}).nom || "",
      telephoneSurPlace: (contactPourLogement(ch, l) || {}).tel || "",
      remiseGlobale: 0,
      adresseLivraison: ch.adresse || "",
      lignes,
      logementId: l.id,
      projetTypologieId: t.id,
      devisProjetVersion: v.version,
      signatureTypologie: signatureLignes(lignes),
    }));
    setActiveTab("devis");
  }
  async function majProjet(ch, patch, trace) {
    await persistChantiers((chantiers || []).map((x) => (x.id === ch.id ? { ...x, ...patch } : x)));
    if (trace) await tracerAcces(trace[0], `${ch.nom} — ${trace[1]}`);
  }
  async function ajouterPhase(ch) {
    if (!peutGererLogements) return;
    const ph = ch.phases || [];
    const nom = ((await demander("Nom de la phase", { saisie: true, valeur: `Phase ${ph.length + 1}` })) || "").trim();
    if (!nom) return;
    if (ph.some((x) => normLib(x.nom) === normLib(nom))) { setNotice(`La phase « ${nom} » existe déjà.`); return; }
    await majProjet(ch, { phases: [...ph, { id: uid(), nom }] }, ["phase ajoutée", nom]);
  }
  async function renommerPhase(ch, p) {
    if (!peutGererLogements) return;
    const nom = ((await demander("Nouveau nom de la phase", { saisie: true, valeur: p.nom })) || "").trim();
    if (!nom || nom === p.nom) return;
    await majProjet(ch, { phases: (ch.phases || []).map((x) => (x.id === p.id ? { ...x, nom } : x)) }, ["phase renommée", `${p.nom} → ${nom}`]);
  }
  async function supprimerPhase(ch, p) {
    if (!peutGererLogements) return;
    if ((ch.logements || []).some((l) => l.phaseId === p.id)) { setNotice(`Impossible de supprimer « ${p.nom} » : des logements y sont affectés.`); return; }
    await majProjet(ch, { phases: (ch.phases || []).filter((x) => x.id !== p.id) }, ["phase supprimée", p.nom]);
  }
  async function enregistrerLogements() {
    if (!peutGererLogements || !logementSaisie) return;
    const f = logementSaisie;
    const ch = (chantiers || []).find((x) => x.id === f.projetId);
    if (!ch) return;
    const err = (m) => setLogementSaisie({ ...f, erreur: m });
    if (!(f.batiment || "").trim()) return err("Indique le bâtiment ou la villa.");
    if (!f.typologieId) return err("Choisis la typologie.");
    if (!f.phaseId) return err("Choisis la phase.");
    const cle = (l) => `${normLib(l.batiment)}|${normLib(String(l.etage || ""))}|${normLib(String(l.appart || ""))}`;
    // Nils 13/10 : modification d'un logement ; étage et appartement facultatifs (villas).
    if (f.mode === "edit") {
      const avant = (ch.logements || []).find((x) => x.id === f.id);
      if (!avant) return;
      const d = devisDuLogement(avant);
      const maj = { ...avant, batiment: f.batiment.trim(), etage: (f.etage || "").trim(), appart: (f.appart || "").trim(), typologieId: d ? avant.typologieId : f.typologieId, phaseId: f.phaseId };
      if ((ch.logements || []).some((x) => x.id !== avant.id && cle(x) === cle(maj))) return err(`Logement déjà présent : ${libLogement(maj)}`);
      await majProjet(ch, { logements: (ch.logements || []).map((x) => (x.id === avant.id ? maj : x)) }, ["logement modifié", `${libLogement(avant)} → ${libLogement(maj)}`]);
      // Contremarque automatique du devis et du dossier (pas une fois le dossier facturé).
      if (d && libLogement(maj) !== libLogement(avant)) {
        const c = dossierDuDevisLogement(d);
        if (!dossierFacture(c)) {
          const ref = `${ch.nom} — ${libLogement(maj)}`;
          await persistDevis((devisListe || []).map((x) => (x.id === d.id ? { ...x, reference: ref, etage: maj.etage || x.etage } : x)));
          if (c) await persistCommandes((commandesListe || []).map((x) => (x.id === c.id ? { ...x, reference: ref, etage: maj.etage || x.etage } : x)));
          setNotice(`Logement modifié — référence contremarque mise à jour : « ${ref} ».`);
        } else setNotice("Logement modifié — dossier déjà facturé : la référence contremarque n'a pas été changée.");
      }
      setLogementSaisie(null);
      return;
    }
    let nouveaux = [];
    if (f.mode === "serie") {
      const de = Number(f.etageDe), a = Number(f.etageA), n = Math.round(Number(f.parEtage));
      if (!Number.isFinite(de) || !Number.isFinite(a) || a < de || !(n > 0) || n > 50) return err("Indique les étages (de … à …) et le nombre d'appartements par étage.");
      for (let e = de; e <= a; e++) for (let i = 1; i <= n; i++) nouveaux.push({ batiment: f.batiment.trim(), etage: e === 0 ? "RDC" : String(e), appart: String(i) });
    } else {
      nouveaux.push({ batiment: f.batiment.trim(), etage: (f.etage || "").trim(), appart: (f.appart || "").trim() });
    }
    const existants = new Set((ch.logements || []).map(cle));
    const doublons = nouveaux.filter((l) => existants.has(cle(l)));
    if (doublons.length) return err(`Logement(s) déjà présent(s) : ${doublons.slice(0, 5).map(libLogement).join(", ")}${doublons.length > 5 ? "…" : ""}`);
    nouveaux = nouveaux.map((l) => ({ id: uid(), ...l, typologieId: f.typologieId, phaseId: f.phaseId }));
    await majProjet(ch, { logements: [...(ch.logements || []), ...nouveaux] }, ["logements ajoutés", `${nouveaux.length}`]);
    setLogementSaisie(f.mode === "serie" ? null : { ...f, appart: "", erreur: "" });
  }
  async function majLogement(ch, l, patch) {
    if (!peutGererLogements) return;
    await majProjet(ch, { logements: (ch.logements || []).map((x) => (x.id === l.id ? { ...x, ...patch } : x)) });
  }
  async function supprimerLogement(ch, l) {
    if (!peutGererLogements) return;
    if (devisDuLogement(l)) { setNotice("Impossible de supprimer ce logement : il a un devis."); return; }
    if (!(await demander(`Supprimer le logement ${libLogement(l)} ?`, { danger: true }))) return;
    await majProjet(ch, { logements: (ch.logements || []).filter((x) => x.id !== l.id) }, ["logement supprimé", libLogement(l)]);
  }
  // Budgets réels : tranches par phase (budget = Σ qté / cuisine des logements de la phase ; sorti = sorties des
  // PL des dossiers de ces logements, par produit Stock de l'article) ; livraisons faites = dates de BL distinctes.
  function budgetsReelsProjet(ch) {
    const v = derniereVersionDP(ch);
    const logs = ch.logements || [];
    const phases = [...(ch.phases || []), ...(logs.some((l) => !(ch.phases || []).some((p) => p.id === l.phaseId)) ? [{ id: "", nom: "Sans phase" }] : [])];
    // Nils 13/10 : un logement qui a un devis compte les quantités de son dossier (avenant compris), à défaut
    // de son devis ; sans devis (ou devis refusé), celles de sa typologie au devis projet.
    const lignesLogement = (l) => {
      const d = devisDuLogement(l);
      if (!d || /refus|annul/i.test(d.statut || "")) return null;
      const c = dossierDuDevisLogement(d);
      return (c ? lignesDuDossier(c) : d.lignes || []).filter((x) => !x.type || x.type === "facture");
    };
    const idsTranches = new Set(v ? (v.articles || []).map((x) => x.articleId) : []);
    logs.forEach((l) => (lignesLogement(l) || []).forEach((x) => x.articleId && idsTranches.add(x.articleId)));
    const tranches = [...idsTranches].map((id) => (articles || []).find((a) => a.id === id)).filter((a) => a && a.categorie === "Tranche");
    const sortiesDossier = (c) => {
      const m = {};
      (mouvements || []).filter((mv) => mv.type === "sortie" && plDuDossier(c, mv) && !estMouvementConsommable(mv) && !mv.enService).forEach((mv) => {
        const lot = lotParId(mv.itemId);
        if (lot) m[lot.produitId] = (m[lot.produitId] || 0) + (Number(mv.quantite) || 0);
      });
      return m;
    };
    const parPhase = phases.map((p) => {
      const lp = logs.filter((l) => (p.id ? l.phaseId === p.id : !(ch.phases || []).some((x) => x.id === l.phaseId)));
      const sorti = {};
      lp.forEach((l) => { const c = dossierDuDevisLogement(devisDuLogement(l)); if (c) Object.entries(sortiesDossier(c)).forEach(([k2, q]) => { sorti[k2] = (sorti[k2] || 0) + q; }); });
      const lignes = tranches.map((a) => {
        const budget = lp.reduce((n, l) => {
          const ll = lignesLogement(l);
          if (ll) return n + ll.filter((x) => x.articleId === a.id).reduce((m, x) => m + (Number(x.qte) || 0), 0);
          const t = v && (v.typologies || []).find((x) => x.id === l.typologieId);
          return n + (t ? Number((t.qtes || {})[a.id]) || 0 : 0);
        }, 0);
        const reel = a.produitStockId ? sorti[a.produitStockId] || 0 : 0;
        return { a, budget: Math.round(budget * 100) / 100, sorti: Math.round(reel * 100) / 100 };
      });
      return { p, n: lp.length, lignes };
    });
    const k = v ? calculDevisProjet(v, ch) : null;
    const datesBL = new Set(dossiersDuProjet(ch.id).filter((c) => !c.anterieure && c.dateBL).map((c) => String(c.dateBL).slice(0, 10)));
    return { v, parPhase, livPrevues: k ? k.nbLivraisons : 0, livFaites: datesBL.size };
  }
  // ---------- ERP step 16 (Nils 12/10, lot 3) : devis projet ----------
  // Stocké sur le projet : ch.devisProjet = [versions] ; version = { id, version, date, colonnes (pièces),
  // articles [{ articleId, prix, remise }], typologies [{ id, nom, nbCuisines, pieces {col: cotes}, qtes {articleId: qté/cuisine} }],
  // cuisinesParLivraison, articleLivraisonId, articleRDMId }. Seule la dernière version se modifie.
  const COLONNES_PIECES_DEFAUT = ["Plan de travail", "Crédence", "Bandes socle"];
  function prixReferenceArticle(a) {
    if (!a) return null;
    const p = a.structurel ? prixGroupeArticle(a, a.groupe) : a.prixPublic;
    return p == null || p === "" ? null : Number(p) || 0;
  }
  function articlesNature(cle) {
    return trierAlpha((articles || []).filter((a) => a.actif !== false && natureArticle(a, cle)), "designation");
  }
  function versionsDevisProjet(ch) {
    return (ch && Array.isArray(ch.devisProjet) ? ch.devisProjet : []).slice().sort((a, b) => a.version - b.version);
  }
  function nouvelleVersionVide() {
    const liv = articlesNature("livraison")[0], rdm = articlesNature("rdm")[0];
    const v = { id: uid(), version: 1, date: todayISO(), colonnes: [...COLONNES_PIECES_DEFAUT], articles: [], typologies: [], cuisinesParLivraison: 4, articleLivraisonId: liv ? liv.id : "", articleRDMId: rdm ? rdm.id : "", creePar: user.nom, creeLe: new Date().toISOString() };
    return synchroArticlesAuto(v);
  }
  // Livraison et RDM sont toujours dans la liste des articles (RDM offert : remise 100 %).
  function synchroArticlesAuto(v) {
    let arts = (v.articles || []).filter((x) => x.auto !== true || x.articleId === v.articleLivraisonId || x.articleId === v.articleRDMId);
    [["articleLivraisonId", 0], ["articleRDMId", 100]].forEach(([k, remise]) => {
      const id = v[k];
      if (!id) return;
      const ex = arts.find((x) => x.articleId === id);
      if (!ex) arts = [...arts, { articleId: id, prix: prixReferenceArticle((articles || []).find((a) => a.id === id)) || 0, remise, auto: true }];
      else if (k === "articleRDMId") arts = arts.map((x) => (x.articleId === id ? { ...x, remise: 100 } : x));
    });
    // Nils 02/11 : relevé de mesure et livraison toujours en tête ; les autres dans l'ordre choisi (flèches).
    const estAuto = (x) => x.articleId === v.articleRDMId || x.articleId === v.articleLivraisonId;
    arts = [...arts.filter((x) => x.articleId === v.articleRDMId), ...arts.filter((x) => x.articleId === v.articleLivraisonId && x.articleId !== v.articleRDMId), ...arts.filter((x) => !estAuto(x))];
    return { ...v, articles: arts };
  }
  // Nils 12/10 : code couleur d'une typologie = Code Fournisseur des tranches qu'elle utilise (une valeur par
  // code), modifiable à la main (t.codeCouleur) — certaines couleurs n'ont pas de code fournisseur.
  function codeCouleurAuto(v, t) {
    const codes = (v.articles || []).filter((x) => Number((t.qtes || {})[x.articleId]) > 0).map((x) => (articles || []).find((a) => a.id === x.articleId)).filter((a) => a && a.categorie === "Tranche").map((a) => (a.codeFournisseur || "").trim()).filter(Boolean);
    return [...new Set(codes)].join(" / ");
  }
  function codeCouleurTypo(v, t) {
    return (t.codeCouleur || "").trim() || codeCouleurAuto(v, t);
  }
  function zoneDevisProjet(v) {
    const a = v && v.articleLivraisonId ? (articles || []).find((x) => x.id === v.articleLivraisonId) : null;
    return a && a.zoneLivraison ? zoneDe(a.zoneLivraison) : null;
  }
  function zoneProjet(ch) {
    const vs = versionsDevisProjet(ch);
    return vs.length ? zoneDevisProjet(vs[vs.length - 1]) : null;
  }
  function numeroDP(ch, v) {
    return `${ch.numeroDevisProjet || "DP (non enregistré)"}-V${v.version}`;
  }
  function calculDevisProjet(v, ch) {
    const net = (aid) => { const x = (v.articles || []).find((y) => y.articleId === aid); return x ? (Number(x.prix) || 0) * (1 - (Number(x.remise) || 0) / 100) : 0; };
    const nbCuisines = (v.typologies || []).reduce((n, t) => n + (Number(t.nbCuisines) || 0), 0);
    const parLiv = Math.max(1, Number(v.cuisinesParLivraison) || 1);
    const nbLivraisons = nbCuisines ? Math.ceil(nbCuisines / parLiv) : 0;
    const livParCuisine = nbCuisines && v.articleLivraisonId ? (net(v.articleLivraisonId) * nbLivraisons) / nbCuisines : 0;
    const saisis = (v.articles || []).filter((x) => x.articleId !== v.articleLivraisonId && x.articleId !== v.articleRDMId);
    const parTypo = (v.typologies || []).map((t) => {
      const mat = saisis.reduce((n, x) => n + (Number((t.qtes || {})[x.articleId]) || 0) * net(x.articleId), 0);
      const rdm = v.articleRDMId ? net(v.articleRDMId) : 0;
      const parCuisine = mat + rdm + livParCuisine;
      return { t, parCuisine, total: parCuisine * (Number(t.nbCuisines) || 0) };
    });
    const totalHT = parTypo.reduce((n, x) => n + x.total, 0);
    const budgets = saisis.map((x) => {
      const a = (articles || []).find((y) => y.id === x.articleId);
      return { a, qte: (v.typologies || []).reduce((n, t) => n + (Number((t.qtes || {})[x.articleId]) || 0) * (Number(t.nbCuisines) || 0), 0) };
    });
    // Nils 12/10 : la zone vient de l'article de livraison choisi (champ « Zone » de sa fiche Catalogue).
    const zone = zoneDevisProjet(v);
    const coutLivraisons = zone ? nbLivraisons * forfaitTransport(zone, "livraison").total : null;
    return { net, nbCuisines, nbLivraisons, livParCuisine, saisis, parTypo, totalHT, totalTTC: totalHT * 1.2, budgetsTranches: budgets.filter((b) => b.a && b.a.categorie === "Tranche"), budgetsAutres: budgets.filter((b) => !b.a || b.a.categorie !== "Tranche"), zone, coutLivraisons };
  }
  async function enregistrerDevisProjet() {
    if (!estGerant || !devisProjetEdit) return;
    const { projetId, v } = devisProjetEdit;
    const ch = (chantiers || []).find((x) => x.id === projetId);
    if (!ch) return;
    if (!(v.typologies || []).length) { setDevisProjetEdit({ ...devisProjetEdit, erreur: "Ajoute au moins une typologie." }); return; }
    const sansNom = (v.typologies || []).find((t) => !(t.nom || "").trim());
    if (sansNom) { setDevisProjetEdit({ ...devisProjetEdit, erreur: "Chaque typologie doit avoir un nom." }); return; }
    if (!(Number(v.cuisinesParLivraison) > 0)) { setDevisProjetEdit({ ...devisProjetEdit, erreur: "Indique le nombre moyen de cuisines par livraison." }); return; }
    const versions = versionsDevisProjet(ch);
    const propre = { ...synchroArticlesAuto(v), modifiePar: user.nom, modifieLe: new Date().toISOString() };
    delete propre.erreur;
    const next = versions.some((x) => x.id === v.id) ? versions.map((x) => (x.id === v.id ? propre : x)) : [...versions, propre];
    const numero = ch.numeroDevisProjet || (await numeroDocument("DP", new Date().getFullYear()));
    if (!numero) return;
    await persistChantiers((chantiers || []).map((x) => (x.id === ch.id ? { ...x, devisProjet: next, numeroDevisProjet: numero } : x)));
    await tracerAcces("devis projet enregistré", `${ch.nom} — ${numero}-V${propre.version}`);
    setDevisProjetVue({ ...devisProjetVue, [ch.id]: propre.id });
    setDevisProjetEdit(null);
  }
  function ouvrirNouvelleVersion(ch) {
    const versions = versionsDevisProjet(ch);
    const der = versions[versions.length - 1];
    const v = der ? { ...JSON.parse(JSON.stringify(der)), id: uid(), version: der.version + 1, date: todayISO(), creePar: user.nom, creeLe: new Date().toISOString() } : nouvelleVersionVide();
    setDevisProjetEdit({ projetId: ch.id, v });
  }
  // Nils 12/10 : même charte que les devis de l'ERP (construireHtmlDocument) — en-tête logo, cartouche,
  // encadré client, tableaux arrondis, pied de page société — en A4 paysage (tableau des typologies).
  // Nils 12–13/10 : trois documents — « client » (Devis…), « adv » (Doc ADV…, avec prix), « production »
  // (Doc production…, sans prix de vente : Ahmed, et Nils / ADV pour le lui remettre).
  function imprimerDevisProjet(ch, v, mode) {
    if (!["client", "adv", "production"].includes(mode)) return;
    if (mode !== "production" && !montantsProjetVisibles) mode = "production";
    const interne = mode !== "client";
    const e = escapeHtml;
    const k = calculDevisProjet(v, ch);
    const avecPrix = mode !== "production" && montantsProjetVisibles;
    const client = clientDe(ch.clientId);
    const nomArt = (id) => ((articles || []).find((a) => a.id === id) || {}).designation || "?";
    const n2 = (x) => (Math.round((Number(x) || 0) * 100) / 100).toLocaleString("fr-FR");
    const cols = v.colonnes || [];
    const numero = numeroDP(ch, v);
    const titre = { client: "DEVIS PROJET", adv: "DOC ADV", production: "DOC PRODUCTION" }[mode];
    const b = "border:1px solid #999;padding:5px 8px;";
    // Tableau à coins arrondis (même rendu que les lignes du devis).
    const tableau = (entetes, lignes, aligns) => {
      const th = entetes.map((h, x) => `<th style="${b}text-align:${aligns[x] || "left"};${x === 0 ? "border-top-left-radius:8px;" : ""}${x === entetes.length - 1 ? "border-top-right-radius:8px;" : ""}">${h}</th>`).join("");
      const tr = lignes.map((l, y) => `<tr>${l.map((c, x) => {
        const der = y === lignes.length - 1;
        return `<td style="${b}text-align:${aligns[x] || "left"};${der && x === 0 ? "border-bottom-left-radius:8px;" : ""}${der && x === l.length - 1 ? "border-bottom-right-radius:8px;" : ""}${c && c.gras ? "font-weight:700;" : ""}">${c && c.v !== undefined ? c.v : c}</td>`;
      }).join("")}</tr>`).join("");
      return `<table style="width:100%;border-collapse:separate;border-spacing:0;margin-bottom:16px;"><thead><tr>${th}</tr></thead><tbody>${tr}</tbody></table>`;
    };
    const tranches = k.budgetsTranches.map((x) => x.a);
    const materiaux = tranches.length ? tableau(["Couleur", "Code fournisseur", "Matière", "Épaisseur", "Finition"], tranches.map((a) => [e(a.designation), e(a.codeFournisseur || ""), e(a.matiere || ""), e(a.epaisseurMatiere || ""), e(a.finition || "")]), []) : "";
    const zone = k.zone ? k.zone.nom : "";
    // Nils 12/10 : Typologie, Cuisines, Code couleur, pièces (sans « cm »), puis prix.
    const entT = ["Typologie", "Cuisines", "Code couleur", ...cols.map((c) => e(c)), ...(interne ? k.saisis.map((x) => `${e(nomArt(x.articleId))} / cuisine`) : []), ...(avecPrix ? ["P.U. HT / cuisine", "Montant HT"] : [])];
    const alT = ["left", "right", "left", ...cols.map(() => "left"), ...(interne ? k.saisis.map(() => "right") : []), ...(avecPrix ? ["right", "right"] : [])];
    const lignesT = k.parTypo.map(({ t, parCuisine, total }) => [{ v: e(t.nom), gras: true }, n2(t.nbCuisines), e(codeCouleurTypo(v, t)), ...cols.map((c) => e((t.pieces || {})[c] || "")), ...(interne ? k.saisis.map((x) => n2((t.qtes || {})[x.articleId])) : []), ...(avecPrix ? [fmtMAD(parCuisine), fmtMAD(total)] : [])]);
    lignesT.push([{ v: "Total", gras: true }, { v: n2(k.nbCuisines), gras: true }, "", ...cols.map(() => ""), ...(interne ? k.saisis.map(() => "") : []), ...(avecPrix ? ["", { v: fmtMAD(k.totalHT), gras: true }] : [])]);
    const totaux = avecPrix ? `<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-top:4px;">
      <div style="max-width:60%;">${interne ? "" : `Prix par cuisine incluant la livraison${v.articleRDMId ? " ; relevé de mesures offert" : ""}. Cotes indicatives des pièces prévues, confirmées au relevé de mesures de chaque cuisine.`}</div>
      <table style="border-collapse:separate;border-spacing:0;"><tr><th style="${b}border-top-left-radius:8px;">Total HT</th><th style="${b}">Total TVA</th><th style="${b}border-top-right-radius:8px;">Total TTC</th></tr>
      <tr><td style="${b}border-bottom-left-radius:8px;">${fmtMAD(k.totalHT)}</td><td style="${b}">${fmtMAD(k.totalTTC - k.totalHT)}</td><td style="${b}font-weight:700;border-bottom-right-radius:8px;">${fmtMAD(k.totalTTC)}</td></tr></table>
    </div>` : "";
    const interneHtml = interne ? `
      <div style="font-weight:700;margin:18px 0 6px;">Articles du projet</div>
      ${tableau(["Article", ...(avecPrix ? ["P.U. HT", "Remise", "P.U. net HT"] : [])], (v.articles || []).map((x) => [e(nomArt(x.articleId)) + (x.articleId === v.articleLivraisonId ? " (livraison)" : x.articleId === v.articleRDMId ? " (RDM offert)" : ""), ...(avecPrix ? [fmtMAD(x.prix), `${n2(x.remise)} %`, fmtMAD(k.net(x.articleId))] : [])]), ["left", "right", "right", "right"])}
      <div style="font-weight:700;margin:18px 0 6px;">Budget tranches</div>
      ${tableau(["Tranche", "Quantité (tranches)"], k.budgetsTranches.length ? k.budgetsTranches.map((x) => [e(x.a.designation), n2(x.qte)]) : [["Aucune tranche saisie.", ""]], ["left", "right"])}
      <div style="font-weight:700;margin:18px 0 6px;">Budget livraison</div>
      ${tableau(["", ""], [["Cuisines par livraison (moyenne)", n2(v.cuisinesParLivraison)], ["Nombre de livraisons prévues", String(k.nbLivraisons)], [`Coût des livraisons (forfait ${e(zone || "zone non réglée")})`, k.coutLivraisons === null ? "—" : fmtMAD(k.coutLivraisons)], ...(avecPrix ? [["Livraison facturée par cuisine", fmtMAD(k.livParCuisine)]] : [])], ["left", "right"])}` : "";
    const html = `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="UTF-8" />
<title>${e(titre)} ${e(numero)}</title>
<style>
  * { box-sizing: border-box; }
  body { font-family: Arial, Helvetica, sans-serif; color: #000; font-size: 11px; line-height: 1.5; margin: 0; padding: 0; }
  table { border-collapse: collapse; }
  @page {
    size: A4 landscape;
    margin: 1.3cm;
    @bottom-right { content: "Page " counter(page); font-family: Arial, Helvetica, sans-serif; font-size: 9px; color: #000; }
  }
  .doc-header { position: fixed; top: 0; left: 0; right: 0; background: #fff; padding-bottom: 10px; border-bottom: 1px solid #ccc; }
  .doc-footer { position: fixed; bottom: 0; left: 0; right: 0; background: #fff; text-align: center; border-top: 1px solid #999; padding-top: 8px; font-size: 9px; }
  /* Nils 03/11 : même correction que les devis (28/10) — la place de l'en-tête et du pied fixes est réservée
     sur CHAQUE page par un tableau de mise en page, sinon des typologies passaient sous l'en-tête de la page 2. */
  table.mise-en-page { width: 100%; border-collapse: collapse; }
  table.mise-en-page > thead > tr > td, table.mise-en-page > tfoot > tr > td, table.mise-en-page > tbody > tr > td { padding: 0; border: 0; }
  .esp-haut { height: 165px; }
  .esp-bas { height: 100px; }
  main { padding: 0 4px; }
  thead { display: table-header-group; }
  tfoot { display: table-footer-group; }
  tr { page-break-inside: avoid; }
</style>
</head>
<body>
  <div class="doc-header">
    <div style="text-align:center;margin-bottom:10px;"><img src="${LOGO_SRC}" alt="Stone Concept" style="height:50px;" /></div>
    <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:20px;">
      <div>
        <div style="font-size:16px;font-weight:700;margin-bottom:6px;">${e(titre)}</div>
        <table style="border-collapse:separate;border-spacing:0;">
          <tr><th style="border:1px solid #999;padding:4px 10px;font-size:9px;border-top-left-radius:8px;">Numéro</th><th style="border:1px solid #999;padding:4px 10px;font-size:9px;">Projet</th><th style="border:1px solid #999;padding:4px 10px;font-size:9px;">Promoteur</th><th style="border:1px solid #999;padding:4px 10px;font-size:9px;">Zone de livraison</th><th style="border:1px solid #999;padding:4px 10px;font-size:9px;border-top-right-radius:8px;">Date</th></tr>
          <tr><td style="border:1px solid #999;padding:4px 10px;font-weight:700;border-bottom-left-radius:8px;">${e(numero)}</td><td style="border:1px solid #999;padding:4px 10px;">${e(ch.nom)}</td><td style="border:1px solid #999;padding:4px 10px;">${e(ch.promoteur || "")}</td><td style="border:1px solid #999;padding:4px 10px;">${e(zone)}</td><td style="border:1px solid #999;padding:4px 10px;border-bottom-right-radius:8px;">${e(formatDate(v.date))}</td></tr>
        </table>
      </div>
      <div style="border:1px solid #999;border-radius:8px;padding:6px 14px;min-width:200px;">
        <div style="font-weight:700;">${client ? e(client.raisonSociale || client.nom) : "—"}</div>
        ${client && client.ice ? `<div>ICE ${e(client.ice)}</div>` : ""}
        ${client && client.ville ? `<div>${e(client.ville)}</div>` : ""}
        ${ch.adresse ? `<div>Site : ${e(ch.adresse)}</div>` : ""}
      </div>
    </div>
  </div>
  <table class="mise-en-page">
  <thead><tr><td><div class="esp-haut"></div></td></tr></thead>
  <tfoot><tr><td><div class="esp-bas"></div></td></tr></tfoot>
  <tbody><tr><td>
  <main>
    ${materiaux ? `<div style="font-weight:700;margin-bottom:6px;">Couleurs</div>${materiaux}` : ""}
    <div style="font-weight:700;margin-bottom:6px;">Typologies</div>
    ${tableau(entT, lignesT, alT)}
    ${totaux}
    ${(v.texteLibre || "").trim() ? `<div style="margin-top:16px;border:1px solid #999;border-radius:8px;padding:8px 14px;white-space:pre-wrap;page-break-inside:avoid;">${e(v.texteLibre.trim())}</div>` : ""}
    ${interneHtml}
  </main>
  </td></tr></tbody>
  </table>
  <div class="doc-footer">
    Stone Concept Sarl Patente 45193146 IF 06527382 ICE 000073605 0000 01 RC 54585<br/>
    Commune rurale de Soualem, douar Lakhlayf<br/>
    Hot Line: 06 61 26 49 31 commandes: sales@stoneconcept.ma<br/>
    <br/>
    <strong>RIB : 050 450 007 0107 797 362 001 60 / CODE SWIFT : CAFGMAMC / CFG BANK</strong>
  </div>
</body>
</html>`;
    telechargerDocument(html, nomFichierDocument({ client: "Devis", adv: "Doc ADV", production: "Doc production" }[mode], numero, client && client.nom, ch.nom), "devis projet");
  }
  // ---------- ERP step 16 (Nils 12/10, lot 4b) : regroupement des livraisons, suivi de chantier ----------
  function datePoseDossier(c, items) {
    const its = (items || (planning && planning.items) || []).filter((x) => x.dossierId === c.id && x.type === "pose").map((x) => x.date).sort();
    return its[0] || (c.fichePose && c.fichePose.dateDebut) || "";
  }
  // Alerte non bloquante : moins de cuisines du projet que la moyenne prévue le même jour de pose.
  function alerteRegroupement(c, items) {
    const chId = c ? chantierDuDossier(c) : "";
    const ch = chId ? (chantiers || []).find((x) => x.id === chId) : null;
    const v = ch ? derniereVersionDP(ch) : null;
    const N = v ? Math.round(Number(v.cuisinesParLivraison) || 0) : 0;
    if (!ch || N < 2) return "";
    const date = datePoseDossier(c, items);
    if (!date) return `Projet ${ch.nom} : nous livrons environ ${N} cuisines à la fois. Aucune date de pose n'est encore prévue pour ce dossier.`;
    const X = dossiersDuProjet(ch.id).filter((d) => !d.anterieure && datePoseDossier(d, items) === date).length;
    if (X >= N) return "";
    return `Attention : pour le projet ${ch.nom}, nous livrons environ ${N} cuisines à la fois. Seulement ${X} ${X > 1 ? "sont prévues" : "est prévue"} en pose le ${formatDate(date)}.`;
  }
  // Suivi d'un logement : RDM / production / pose — prévu (Planning) et fait (dossier, Planning, fiche de pose).
  function suiviLogement(l) {
    const d = devisDuLogement(l);
    const c = dossierDuDevisLogement(d);
    const vide = { date: "", statut: "" };
    // Nils 30/10 : logement fait avant l'ERP, rattaché à une facture antérieure (un dossier ERP reste prioritaire).
    if (!c && l.avantERP) return { c: null, d, avantERP: l.avantERP, rdm: { date: "", statut: "FAIT" }, prod: { date: "", statut: "FAIT" }, pose: { date: l.avantERP.datePose || "", statut: "FAIT" }, reportee: "", sav: [] };
    if (!c) return { c: null, d, rdm: vide, prod: vide, pose: { date: "", statut: "Non posé" }, reportee: "", sav: [] };
    const idx = (st) => STATUTS_COMMANDE.indexOf(st);
    const its = ((planning && planning.items) || []).filter((x) => x.dossierId === c.id);
    const dates = (types) => its.filter((x) => types.includes(x.type)).sort((a, b) => (a.date < b.date ? -1 : 1));
    let rdm = vide;
    if (!dossierAvecRDM(c)) rdm = { date: "", statut: "Sans RDM" };
    else {
      const r = dates(["rdm"]);
      const fait = r.find((x) => x.fait);
      if (fait) rdm = { date: fait.date, statut: "FAIT" };
      else if (idx(c.statut) >= idx("PL")) rdm = { date: c.dateRDM ? String(c.dateRDM).slice(0, 10) : "", statut: "FAIT" };
      else if (r.length) rdm = { date: r[r.length - 1].date, statut: "Prév" };
    }
    let prod = vide;
    const pr = dates(["debit", "finition"]);
    const pt = ((planning && planning.prodTerminee) || {})[c.id];
    if (pt) prod = { date: String(pt.le || "").slice(0, 10), statut: "FAIT" };
    else if (idx(c.statut) >= idx("BL")) prod = { date: pr.length ? pr[pr.length - 1].date : "", statut: "FAIT" };
    else if (pr.length) prod = { date: pr[pr.length - 1].date, statut: dossierTransfo(c) && !productionPlanifiee(c, its) ? "Prév (incomplet)" : "Prév" };
    let pose;
    const po = dates(["pose"]);
    const fp = c.fichePose;
    if (fichePoseRemplie(fp)) pose = { date: fp.dateFin || fp.dateDebut || "", statut: "FAIT" };
    else if (idx(c.statut) >= idx("BL") && dossierPose(c)) pose = { date: c.dateBL ? String(c.dateBL).slice(0, 10) : "", statut: "Livré non posé" };
    else if (idx(c.statut) >= idx("BL")) pose = { date: c.dateBL ? String(c.dateBL).slice(0, 10) : "", statut: "Livré" };
    else if (po.length) pose = { date: po[0].date, statut: "Prév" };
    else pose = { date: "", statut: "Non posé" };
    const poseRepoussee = po.find((x) => (x.historique || []).length);
    const reportee = pose.statut !== "FAIT" && poseRepoussee ? poseRepoussee.date : "";
    const sav = (savListe || []).filter((t) => t.commandeOrigineId === c.id);
    return { c, d, rdm, prod, pose, reportee, sav };
  }
  const peutSaisirBloquants = estGerant || peut("planning.gerer");
  async function majBloquant(ch, l, texte) {
    if (!peutSaisirBloquants) return;
    const t = (texte || "").trim();
    if (t === (l.bloquant || "")) return;
    await majProjet(ch, { logements: (ch.logements || []).map((x) => (x.id === l.id ? { ...x, bloquant: t, bloquantPar: user.nom, bloquantLe: new Date().toISOString() } : x)) }, ["éléments bloquants", `${libLogement(l)} : ${t || "(effacé)"}`]);
  }
  // ---- Nils 30/10 : logements faits avant l'ERP, rattachés à une facture antérieure (Nils, Sawsan) ----
  function logementsAvantERPDe(antId) {
    // Nils 02/11 : logements faits avant l'ERP, ou portant un acompte facturé avant l'ERP.
    return (chantiers || []).flatMap((ch) => (ch.logements || []).filter((l) => (l.avantERP && l.avantERP.factureAntId === antId) || (l.acompteAvantERP && l.acompteAvantERP.factureAntId === antId)).map((l) => ({ ch, l })));
  }
  // ---- Nils 02/11 : acompte facturé avant l'ERP sur certains logements (la facture ERP du logement = le solde) ----
  function htFactureAnt(fa) {
    const ttc = Number(fa && fa.ttc) || 0;
    return arrondiH(fa && fa.exo ? ttc : ttc / (1 + TVA_TAUX));
  }
  function ouvrirAcompteAnt(ch, factureAntId) {
    const montants = {};
    (ch.logements || []).forEach((l) => { if (factureAntId && l.acompteAvantERP && l.acompteAvantERP.factureAntId === factureAntId) montants[l.id] = String(l.acompteAvantERP.ht); });
    setAcompteAntEdit({ chId: ch.id, factureAntId: factureAntId || "", montants, erreur: "" });
  }
  async function enregistrerAcompteAnt(ch) {
    const f = acompteAntEdit;
    if (!f || !peutGererFacturesAnt) return;
    const fa = facturesAntDuProjet(ch).find((x) => x.id === f.factureAntId);
    if (!fa) { setAcompteAntEdit({ ...f, erreur: "Choisis la facture antérieure." }); return; }
    const ids = Object.keys(f.montants || {});
    const mauvais = ids.filter((id) => !(Number(String(f.montants[id]).replace(",", ".")) > 0));
    if (mauvais.length) { setAcompteAntEdit({ ...f, erreur: "Indique un montant HT positif pour chaque logement coché." }); return; }
    const total = arrondiH(ids.reduce((n, id) => n + Number(String(f.montants[id]).replace(",", ".")), 0));
    if (total > htFactureAnt(fa) + 0.01) { setAcompteAntEdit({ ...f, erreur: `Le total réparti (${formatDH(total)} HT) dépasse le HT de la facture ${fa.numero} (${formatDH(htFactureAnt(fa))}).` }); return; }
    const ajoutes = [], retires = [];
    const logements = (ch.logements || []).map((l) => {
      const avait = !!(l.acompteAvantERP && l.acompteAvantERP.factureAntId === fa.id);
      if (ids.includes(l.id)) {
        if (devisDuLogement(l) && !avait) return l; // devis déjà créé sans la déduction
        if (l.avantERP || (l.acompteAvantERP && !avait)) return l;
        const ht = arrondiH(Number(String(f.montants[l.id]).replace(",", ".")));
        if (!avait || Number(l.acompteAvantERP.ht) !== ht) ajoutes.push(`${libLogement(l)} (${formatDH(ht)} HT)`);
        return { ...l, acompteAvantERP: { factureAntId: fa.id, numero: fa.numero, date: fa.date || "", ht, par: user.nom, le: new Date().toISOString() } };
      }
      if (avait) {
        if (devisDuLogement(l)) return l; // déjà déduit dans un devis : on garde la trace
        retires.push(libLogement(l));
        const x = { ...l }; delete x.acompteAvantERP; return x;
      }
      return l;
    });
    if (!ids.length && !retires.length) { setAcompteAntEdit({ ...f, erreur: "Coche au moins un logement." }); return; }
    await majProjet(ch, { logements }, ["acompte facturé avant l'ERP", `facture ${fa.numero}${ajoutes.length ? ` — ${ajoutes.join(", ")}` : ""}${retires.length ? ` — retirés : ${retires.join(", ")}` : ""}`]);
    setAcompteAntEdit(null);
  }
  function renderAcompteAnt(ch, logs) {
    const f = acompteAntEdit;
    const fas = facturesAntDuProjet(ch);
    const fa = fas.find((x) => x.id === f.factureAntId);
    const coches = Object.keys(f.montants || {});
    const set = (patch) => setAcompteAntEdit({ ...f, ...patch, erreur: "" });
    const bloqueDe = (l) => {
      const avait = !!(l.acompteAvantERP && l.acompteAvantERP.factureAntId === f.factureAntId);
      if (l.avantERP) return `fait avant l'ERP (${l.avantERP.numero})`;
      if (l.acompteAvantERP && !avait) return `acompte de la facture ${l.acompteAvantERP.numero}`;
      if (devisDuLogement(l)) return avait ? "devis déjà créé (déduction faite)" : `devis ${devisDuLogement(l).numero || ""} déjà créé`;
      return "";
    };
    const libres = logs.filter((l) => !bloqueDe(l));
    // Répartition à parts égales du HT de la facture entre les logements cochés.
    // Les logements dont le devis est déjà créé gardent leur montant ; le reste est réparti entre les autres.
    const estFige = (id) => { const l = logs.find((x) => x.id === id); return !!(l && devisDuLogement(l)); };
    const repartir = (ids) => {
      if (!fa || !ids.length) return {};
      const figes = ids.filter(estFige), autres = ids.filter((id) => !estFige(id));
      const reste = htFactureAnt(fa) - figes.reduce((n, id) => n + (Number(String(f.montants[id]).replace(",", ".")) || 0), 0);
      const part = autres.length ? Math.max(0, Math.floor((reste / autres.length) * 100) / 100) : 0;
      return Object.fromEntries([...figes.map((id) => [id, f.montants[id]]), ...autres.map((id) => [id, String(part)])]);
    };
    const total = arrondiH(coches.reduce((n, id) => n + (Number(String(f.montants[id]).replace(",", ".")) || 0), 0));
    return (
      <Overlay onClose={() => setAcompteAntEdit(null)}>
        <div style={modalStyle(680)}>
          <div style={modalTitleStyle}>Acompte facturé avant l'ERP — {ch.nom}</div>
          {!fas.length ? (
            <div style={{ fontSize: 13, color: TAUPE, lineHeight: 1.6, marginBottom: 12 }}>Aucune facture antérieure n'est rattachée à ce projet. Saisis-la d'abord dans Clients › 📂 Factures antérieures à l'ERP, en choisissant ce projet dans « Projet immobilier ».</div>
          ) : (
            <>
              <Field label="Facture d'acompte antérieure">
                <select className="sc-select" value={f.factureAntId} onChange={(e) => ouvrirAcompteAnt(ch, e.target.value)} style={selectStyle}>
                  <option value="">— Choisir —</option>
                  {fas.map((x) => (<option key={x.id} value={x.id}>{x.numero} — {formatDate(x.date)} — {formatDH(htFactureAnt(x))} HT{x.reference ? ` — ${x.reference}` : ""}</option>))}
                </select>
              </Field>
              {fa && (
                <>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, margin: "4px 0 6px" }}>
                    <span style={{ color: TAUPE }}>Logements couverts ({coches.length}) — réparti {formatDH(total)} HT sur {formatDH(htFactureAnt(fa))}</span>
                    <button type="button" className="sc-btn" onClick={() => set({ montants: repartir(coches) })} disabled={!coches.length} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 8px", marginLeft: "auto" }}>Répartir à parts égales</button>
                  </div>
                  <div style={{ maxHeight: 340, overflowY: "auto", border: `1px solid ${PIERRE}`, borderRadius: 6, padding: "4px 8px", marginBottom: 10 }}>
                    {logs.map((l) => {
                      const bloque = bloqueDe(l);
                      const fige = bloque && !(l.acompteAvantERP && l.acompteAvantERP.factureAntId === f.factureAntId && !devisDuLogement(l));
                      const coche = coches.includes(l.id);
                      return (
                        <div key={l.id} style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13, padding: "3px 0", color: fige ? TAUPE : ENCRE }}>
                          <input type="checkbox" disabled={!!fige} checked={coche} onChange={(e) => { const ids = e.target.checked ? [...coches, l.id] : coches.filter((x) => x !== l.id); const m = repartir(ids); set({ montants: m }); }} />
                          <span style={{ flex: 1 }}>{libLogement(l)}{bloque && <span style={{ fontSize: 11 }}> — {bloque}</span>}</span>
                          {coche && <input className="sc-input" inputMode="decimal" value={f.montants[l.id]} disabled={!!fige} onChange={(e) => set({ montants: { ...f.montants, [l.id]: sansZeroTete(e.target.value) } })} style={{ ...inputStyle(110), padding: "3px 6px", fontSize: 12 }} />}
                          {coche && <span style={{ fontSize: 11, color: TAUPE }}>HT</span>}
                        </div>
                      );
                    })}
                  </div>
                  {libres.length === 0 && !coches.length && <div style={{ fontSize: 12, color: TAUPE, marginBottom: 8 }}>Aucun logement disponible (devis déjà créé, ou fait avant l'ERP).</div>}
                </>
              )}
              <div style={{ fontSize: 11, color: TAUPE, marginBottom: 10, lineHeight: 1.5 }}>Le devis créé ensuite depuis chacun de ces logements reprend toute la typologie et déduit l'acompte (ligne « Acompte facturé avant l'ERP ») : la facture ERP vaut le solde. Cocher un logement répartit le HT de la facture à parts égales ; chaque montant reste modifiable. Un logement dont le devis est déjà créé ne peut plus être coché.</div>
            </>
          )}
          {f.erreur && <div style={{ color: ROUILLE, fontSize: 13, fontWeight: 600, marginBottom: 10 }}>{f.erreur}</div>}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
            <button type="button" className="sc-btn" onClick={() => setAcompteAntEdit(null)} style={ghostBtnStyle}>{fas.length ? "Annuler" : "Fermer"}</button>
            {fas.length > 0 && <button type="button" className="sc-btn" onClick={() => enregistrerAcompteAnt(ch)} style={primaryBtnStyle}>Enregistrer</button>}
          </div>
        </div>
      </Overlay>
    );
  }
  function facturesAntDuProjet(ch) {
    return (facturesAnt || []).filter((x) => x.type !== "avoir" && x.chantierId === ch.id).sort((a, b) => (a.date < b.date ? -1 : 1));
  }
  // Logements déjà rattachés à cette facture (et leur date de pose) : la fenêtre permet d'en ajouter ou d'en retirer.
  function ouvrirAvantERP(ch, factureAntId) {
    const lies = factureAntId ? (ch.logements || []).filter((l) => l.avantERP && l.avantERP.factureAntId === factureAntId) : [];
    setAvantErpEdit({ chId: ch.id, factureAntId: factureAntId || "", datePose: lies.length ? lies[0].avantERP.datePose || "" : "", ids: lies.map((l) => l.id), erreur: "" });
  }
  async function enregistrerAvantERP(ch) {
    const f = avantErpEdit;
    if (!f || !peutGererFacturesAnt) return;
    const fa = facturesAntDuProjet(ch).find((x) => x.id === f.factureAntId);
    if (!fa) { setAvantErpEdit({ ...f, erreur: "Choisis la facture antérieure." }); return; }
    if (f.datePose && f.datePose > todayISO()) { setAvantErpEdit({ ...f, erreur: "La date de pose ne peut pas être dans le futur." }); return; }
    const ids = new Set(f.ids || []);
    const marque = { factureAntId: fa.id, numero: fa.numero, datePose: f.datePose || "", par: user.nom, le: new Date().toISOString() };
    const ajoutes = [], retires = [];
    const logements = (ch.logements || []).map((l) => {
      const avait = !!(l.avantERP && l.avantERP.factureAntId === fa.id);
      if (ids.has(l.id)) {
        if (dossierDuDevisLogement(devisDuLogement(l))) return l; // un dossier ERP existe : il reste prioritaire
        if (l.avantERP && l.avantERP.factureAntId !== fa.id) return l; // déjà rattaché à une autre facture
        if (!avait) ajoutes.push(libLogement(l));
        return { ...l, avantERP: marque };
      }
      if (avait) { retires.push(libLogement(l)); const x = { ...l }; delete x.avantERP; return x; }
      return l;
    });
    if (!ids.size && !retires.length) { setAvantErpEdit({ ...f, erreur: "Coche au moins un logement." }); return; }
    await majProjet(ch, { logements }, ["logements faits avant l'ERP", `facture ${fa.numero}${f.datePose ? ` — posé le ${formatDate(f.datePose)}` : ""}${ajoutes.length ? ` — ajoutés : ${ajoutes.join(", ")}` : ""}${retires.length ? ` — retirés : ${retires.join(", ")}` : ""}`]);
    setAvantErpEdit(null);
  }
  async function retirerAvantERP(ch, l) {
    if (!peutGererFacturesAnt || !l.avantERP) return;
    if (!await demander(`Retirer le marquage « fait avant l'ERP » du logement ${libLogement(l)} (facture ${l.avantERP.numero}) ?`)) return;
    const x = { ...l }; delete x.avantERP;
    await majProjet(ch, { logements: (ch.logements || []).map((y) => (y.id === l.id ? x : y)) }, ["logements faits avant l'ERP", `${libLogement(l)} : marquage retiré (facture ${l.avantERP.numero})`]);
  }
  function logementsTries(ch) {
    return (ch.logements || []).slice().sort((a, b) => `${a.batiment}|${String(a.etage).padStart(4, "0")}|${String(a.appart).padStart(4, "0")}`.localeCompare(`${b.batiment}|${String(b.etage).padStart(4, "0")}|${String(b.appart).padStart(4, "0")}`, "fr", { numeric: true }));
  }
  const COULEUR_STATUT_SUIVI = { FAIT: VERT_OK, "Prév": OCRE, "Prév (incomplet)": ROUILLE, "Livré non posé": ROUILLE, "Livré": OCRE, "Non posé": TAUPE, "Sans RDM": TAUPE };
  // Nils 14/10 (i) : colonnes libres du suivi de chantier, propres au projet, saisies à la main.
  async function ajouterColonneSuivi(ch) {
    if (!peutSaisirBloquants) return;
    const lib = await demander("Nom de la nouvelle colonne (ex. Réf. évier) :", { saisie: true });
    if (!lib || !String(lib).trim()) return;
    await majProjet(ch, { colonnesSuivi: [...(ch.colonnesSuivi || []), { id: uid(), lib: String(lib).trim() }] }, ["suivi de chantier", `colonne ajoutée : ${String(lib).trim()}`]);
  }
  async function renommerColonneSuivi(ch, col) {
    if (!peutSaisirBloquants) return;
    const lib = await demander("Nouveau nom de la colonne :", { saisie: true, valeur: col.lib });
    if (!lib || !String(lib).trim() || String(lib).trim() === col.lib) return;
    await majProjet(ch, { colonnesSuivi: (ch.colonnesSuivi || []).map((c) => (c.id === col.id ? { ...c, lib: String(lib).trim() } : c)) }, ["suivi de chantier", `colonne renommée : ${col.lib} → ${String(lib).trim()}`]);
  }
  async function supprimerColonneSuivi(ch, col) {
    if (!peutSaisirBloquants) return;
    if (!(await demander(`Supprimer la colonne « ${col.lib} » et ce qui y est saisi ?`, { danger: true }))) return;
    await majProjet(ch, { colonnesSuivi: (ch.colonnesSuivi || []).filter((c) => c.id !== col.id), logements: (ch.logements || []).map((l) => { if (!l.valeursSuivi || !(col.id in l.valeursSuivi)) return l; const vs = { ...l.valeursSuivi }; delete vs[col.id]; return { ...l, valeursSuivi: vs }; }) }, ["suivi de chantier", `colonne supprimée : ${col.lib}`]);
  }
  async function majValeurSuivi(ch, l, col, texte) {
    if (!peutSaisirBloquants) return;
    const t = (texte || "").trim();
    if (t === ((l.valeursSuivi || {})[col.id] || "")) return;
    await majProjet(ch, { logements: (ch.logements || []).map((x) => (x.id === l.id ? { ...x, valeursSuivi: { ...(x.valeursSuivi || {}), [col.id]: t } } : x)) }, ["suivi de chantier", `${libLogement(l)} — ${col.lib} : ${t || "(effacé)"}`]);
  }
  const libBatiment = (b) => (/^(villa|b[aâ]t)/i.test(String(b || "")) ? b : b ? `Bât. ${b}` : "");
  // Nils 02/11 : plusieurs contacts sur place par projet, chacun pour certains bâtiments (cochés).
  // Ancien projet (un seul contact) : lu comme une liste d'un contact, pour tous les bâtiments.
  function contactsDuProjet(ch) {
    if (ch && Array.isArray(ch.contactsSurPlace) && ch.contactsSurPlace.length) return ch.contactsSurPlace;
    return ch && (ch.contactSurPlace || ch.telephoneSurPlace) ? [{ id: "principal", nom: ch.contactSurPlace || "", tel: ch.telephoneSurPlace || "", batiments: [] }] : [];
  }
  function batimentsDuProjet(ch) {
    return [...new Set(((ch && ch.logements) || []).map((l) => String(l.batiment || "").trim()).filter(Boolean))].sort((a, b) => a.localeCompare(b, "fr", { numeric: true }));
  }
  // Contact d'un logement : celui dont les bâtiments cochés contiennent le sien ; sinon un contact
  // « tous bâtiments » ; sinon le premier.
  // Choix rapide parmi les contacts du projet (devis et dossier d'un projet) : remplit nom et téléphone.
  function choixContactProjet(chantierId, onChoix) {
    const ch = chantierId ? (chantiers || []).find((x) => x.id === chantierId) : null;
    const cs = ch ? contactsDuProjet(ch) : [];
    if (cs.length < 2) return null;
    return (
      <select className="sc-select" value="" onChange={(e) => { const c = cs.find((x) => x.id === e.target.value); if (c) onChoix(c); }} style={{ ...selectStyle, marginTop: 6, fontSize: 12, padding: "4px 8px" }}>
        <option value="">Choisir parmi les contacts du projet…</option>
        {cs.map((c) => (<option key={c.id} value={c.id}>{[c.nom, c.tel].filter(Boolean).join(" · ")}{(c.batiments || []).length ? ` — ${c.batiments.map(libBatiment).join(", ")}` : ""}</option>))}
      </select>
    );
  }
  function contactPourLogement(ch, l) {
    const cs = contactsDuProjet(ch);
    const b = String((l && l.batiment) || "").trim();
    return cs.find((c) => (c.batiments || []).includes(b)) || cs.find((c) => !(c.batiments || []).length) || cs[0] || null;
  }
  // Nils 14/10 : colonnes du suivi déplaçables (◀ ▶), « Bâtiment / villa » fixée en 1re position ; ordre propre au projet, repris sur le PDF.
  const COLONNES_SUIVI_BASE = [["etage", "Étage"], ["apt", "N° appart."], ["typo", "Typologie"], ["rdm", "RDM"], ["prod", "Prod"], ["pose", "Pose"], ["reportee", "Pose retardée au"], ["bloquant", "Éléments bloquants"]];
  function colonnesSuiviOrdonnees(ch, logs) {
    const avecEtage = logs.some((l) => String(l.etage || "").trim()), avecApt = logs.some((l) => String(l.appart || "").trim());
    const libres = (ch.colonnesSuivi || []).map((c) => [`c:${c.id}`, c.lib, c]);
    const defaut = [...COLONNES_SUIVI_BASE.slice(0, 7), ...libres, COLONNES_SUIVI_BASE[7]];
    const dispo = new Map(defaut.map((x) => [x[0], x]));
    const ordre = (ch.ordreColonnesSuivi || []).filter((k) => dispo.has(k));
    defaut.forEach(([k], idx) => {
      if (ordre.includes(k)) return;
      const avant = defaut.slice(0, idx).reverse().find(([k2]) => ordre.includes(k2));
      ordre.splice(avant ? ordre.indexOf(avant[0]) + 1 : 0, 0, k);
    });
    return ordre.map((k) => dispo.get(k)).filter(([k]) => (k !== "etage" || avecEtage) && (k !== "apt" || avecApt)).map(([k, lib, col]) => ({ k, lib, col }));
  }
  async function deplacerColonneSuivi(ch, cols, k, sens) {
    if (!peutSaisirBloquants) return;
    const idx = cols.findIndex((c) => c.k === k), cible = idx + sens;
    if (idx < 0 || cible < 0 || cible >= cols.length) return;
    const vis = cols.map((c) => c.k);
    [vis[idx], vis[cible]] = [vis[cible], vis[idx]];
    // Les colonnes masquées (étage / appart. vides) gardent leur place relative.
    const complet = colonnesSuiviOrdonnees({ ...ch, ordreColonnesSuivi: ch.ordreColonnesSuivi }, [{ etage: "x", appart: "x" }]).map((c) => c.k);
    const caches = complet.filter((x) => !vis.includes(x));
    const ordre = [...vis];
    caches.forEach((x) => { const pos = complet.indexOf(x); const avant = complet.slice(0, pos).reverse().find((y) => ordre.includes(y)); ordre.splice(avant ? ordre.indexOf(avant) + 1 : 0, 0, x); });
    await majProjet(ch, { ordreColonnesSuivi: ordre }, null);
  }
  function renderSuiviChantier(ch) {
    const logs = logementsTries(ch);
    if (!logs.length) return <div style={{ fontSize: 13, color: TAUPE }}>Aucun logement.</div>;
    const v = derniereVersionDP(ch);
    const nomTypo = (id) => ((v && v.typologies) || []).find((t) => t.id === id)?.nom || "—";
    const cols = colonnesSuiviOrdonnees(ch, logs);
    const cell = { padding: "4px 6px", borderBottom: `1px solid ${PIERRE}`, fontSize: 12, verticalAlign: "top" };
    const th = { ...cell, textAlign: "left", fontSize: 10, color: TAUPE, textTransform: "uppercase", whiteSpace: "nowrap" };
    const fl = { cursor: "pointer", color: ENCRE, padding: "0 2px", userSelect: "none" };
    const etape = (x) => <span>{x.date ? formatDate(x.date) : ""}{x.statut && <span style={{ marginLeft: x.date ? 6 : 0, fontWeight: 600, color: COULEUR_STATUT_SUIVI[x.statut] || ENCRE }}>{x.statut}</span>}</span>;
    const contenu = (k, col, l, sv) => {
      if (k === "etage") return l.etage;
      if (k === "apt") return l.acompteAvantERP ? <span>{l.appart} <span style={{ fontSize: 11, color: TAUPE, whiteSpace: "nowrap" }}>acompte avant ERP · {l.acompteAvantERP.numero}</span></span> : l.appart;
      if (k === "typo") return nomTypo(l.typologieId);
      if (k === "pose" && sv.avantERP) return <span>{etape(sv.pose)} <span style={{ color: TAUPE, whiteSpace: "nowrap" }}>avant ERP · {sv.avantERP.numero}</span>{peutGererFacturesAnt && <span title="Retirer le marquage « fait avant l'ERP »" onClick={() => retirerAvantERP(ch, l)} style={{ cursor: "pointer", color: ROUILLE, marginLeft: 6 }}>✕</span>}</span>;
      if (k === "rdm" || k === "prod" || k === "pose") return etape(sv[k]);
      if (k === "reportee") return <span style={{ color: ROUILLE }}>{sv.reportee ? formatDate(sv.reportee) : ""}</span>;
      if (k === "bloquant") return peutSaisirBloquants ? (
        <input key={`${l.id}-${l.bloquant || ""}`} className="sc-input" defaultValue={l.bloquant || ""} placeholder="ex. meuble pas posé" onBlur={(e) => majBloquant(ch, l, e.target.value)} style={{ ...inputStyle(200), padding: "3px 6px", fontSize: 12 }} />
      ) : (l.bloquant || "");
      return peutSaisirBloquants ? (
        <input key={`${l.id}-${col.id}-${(l.valeursSuivi || {})[col.id] || ""}`} className="sc-input" defaultValue={(l.valeursSuivi || {})[col.id] || ""} onBlur={(e) => majValeurSuivi(ch, l, col, e.target.value)} style={{ ...inputStyle(110), padding: "3px 6px", fontSize: 12 }} />
      ) : ((l.valeursSuivi || {})[col.id] || "");
    };
    return (
      <div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 6 }}>
          {peutGererFacturesAnt && <button type="button" className="sc-btn" onClick={() => ouvrirAvantERP(ch, "")} style={ghostBtnStyle} title="Logements posés avant l'ERP, rattachés à une facture antérieure">Fait avant l'ERP…</button>}
          {peutGererFacturesAnt && <button type="button" className="sc-btn" onClick={() => ouvrirAcompteAnt(ch, "")} style={ghostBtnStyle} title="Logements dont une partie (ex. 50 %) a été facturée avant l'ERP : la facture ERP sera le solde">Acompte avant l'ERP…</button>}
          {peutSaisirBloquants && <button type="button" className="sc-btn" onClick={() => ajouterColonneSuivi(ch)} style={ghostBtnStyle}>+ Colonne</button>}
          <button type="button" className="sc-btn" onClick={() => imprimerSuiviChantier(ch)} style={ghostBtnStyle}>🖨 Suivi de chantier</button>
        </div>
        {avantErpEdit && avantErpEdit.chId === ch.id && renderAvantERP(ch, logs)}
        {acompteAntEdit && acompteAntEdit.chId === ch.id && renderAcompteAnt(ch, logs)}
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead><tr>
              <th style={th}>Bâtiment / villa</th>
              {cols.map(({ k, lib, col }, idx) => (
                <th key={k} style={th}>
                  {peutSaisirBloquants && idx > 0 && <span title="Déplacer à gauche" onClick={() => deplacerColonneSuivi(ch, cols, k, -1)} style={fl}>◀</span>}
                  {lib}
                  {peutSaisirBloquants && idx < cols.length - 1 && <span title="Déplacer à droite" onClick={() => deplacerColonneSuivi(ch, cols, k, 1)} style={fl}>▶</span>}
                  {col && peutSaisirBloquants && <> <span title="Renommer" onClick={() => renommerColonneSuivi(ch, col)} style={{ cursor: "pointer" }}>✎</span> <span title="Supprimer" onClick={() => supprimerColonneSuivi(ch, col)} style={{ cursor: "pointer", color: ROUILLE }}>✕</span></>}
                </th>
              ))}
            </tr></thead>
            <tbody>
              {logs.map((l) => {
                const sv = suiviLogement(l);
                return (
                  <tr key={l.id}>
                    <td style={{ ...cell, fontWeight: 600, whiteSpace: "nowrap" }}>{libBatiment(l.batiment)}</td>
                    {cols.map(({ k, col }) => (<td key={k} style={cell}>{contenu(k, col, l, sv)}</td>))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
  function renderAvantERP(ch, logs) {
    const f = avantErpEdit;
    const fas = facturesAntDuProjet(ch);
    const ids = new Set(f.ids || []);
    const libres = logs.filter((l) => !dossierDuDevisLogement(devisDuLogement(l)) && (!l.avantERP || l.avantERP.factureAntId === f.factureAntId));
    const set = (patch) => setAvantErpEdit({ ...f, ...patch, erreur: "" });
    return (
      <Overlay onClose={() => setAvantErpEdit(null)}>
        <div style={modalStyle(620)}>
          <div style={modalTitleStyle}>Logements faits avant l'ERP — {ch.nom}</div>
          {!fas.length ? (
            <div style={{ fontSize: 13, color: TAUPE, lineHeight: 1.6, marginBottom: 12 }}>Aucune facture antérieure n'est rattachée à ce projet. Saisis-la d'abord dans Clients › 📂 Factures antérieures à l'ERP, en choisissant ce projet dans « Projet immobilier ».</div>
          ) : (
            <>
              <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 12 }}>
                <Field label="Facture antérieure">
                  <select className="sc-select" value={f.factureAntId} onChange={(e) => ouvrirAvantERP(ch, e.target.value)} style={selectStyle}>
                    <option value="">— Choisir —</option>
                    {fas.map((x) => (<option key={x.id} value={x.id}>{x.numero} — {formatDate(x.date)}{x.reference ? ` — ${x.reference}` : ""}</option>))}
                  </select>
                </Field>
                <Field label="Date de pose (facultative)"><input type="date" className="sc-input" value={f.datePose} max={todayISO()} onChange={(e) => set({ datePose: e.target.value })} style={inputStyle("100%")} /></Field>
              </div>
              {f.factureAntId && (
                <>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, margin: "4px 0 6px" }}>
                    <span style={{ color: TAUPE }}>Logements posés couverts par cette facture ({ids.size})</span>
                    <button type="button" className="sc-btn" onClick={() => set({ ids: libres.map((l) => l.id) })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 8px", marginLeft: "auto" }}>Tout cocher</button>
                    <button type="button" className="sc-btn" onClick={() => set({ ids: [] })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 8px" }}>Tout décocher</button>
                  </div>
                  <div style={{ maxHeight: 320, overflowY: "auto", border: `1px solid ${PIERRE}`, borderRadius: 6, padding: "4px 8px", marginBottom: 10 }}>
                    {logs.map((l) => {
                      const dossier = dossierDuDevisLogement(devisDuLogement(l));
                      const autre = l.avantERP && l.avantERP.factureAntId !== f.factureAntId ? l.avantERP.numero : "";
                      const bloque = !!dossier || !!autre;
                      return (
                        <label key={l.id} style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13, padding: "3px 0", color: bloque ? TAUPE : ENCRE }}>
                          <input type="checkbox" disabled={bloque} checked={ids.has(l.id)} onChange={(e) => set({ ids: e.target.checked ? [...ids, l.id] : [...ids].filter((x) => x !== l.id) })} />
                          {libLogement(l)}
                          {dossier && <span style={{ fontSize: 11 }}>— dossier ERP {dossier.numeroFacture || dossier.numeroBL || dossier.numero}</span>}
                          {autre && <span style={{ fontSize: 11 }}>— déjà rattaché à la facture {autre}</span>}
                        </label>
                      );
                    })}
                  </div>
                </>
              )}
              <div style={{ fontSize: 11, color: TAUPE, marginBottom: 10, lineHeight: 1.5 }}>Les logements cochés passent en relevé de mesure, production et pose « FAIT » dans le suivi de chantier. Une facture rattachée à des logements ne peut plus être supprimée ni changer de projet.</div>
            </>
          )}
          {f.erreur && <div style={{ color: ROUILLE, fontSize: 13, fontWeight: 600, marginBottom: 10 }}>{f.erreur}</div>}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
            <button type="button" className="sc-btn" onClick={() => setAvantErpEdit(null)} style={ghostBtnStyle}>{fas.length ? "Annuler" : "Fermer"}</button>
            {fas.length > 0 && <button type="button" className="sc-btn" onClick={() => enregistrerAvantERP(ch)} style={primaryBtnStyle}>Enregistrer</button>}
          </div>
        </div>
      </Overlay>
    );
  }
  function imprimerSuiviChantier(ch) {
    const e = escapeHtml;
    const logs = logementsTries(ch);
    const v = derniereVersionDP(ch);
    const client = clientDe(ch.clientId);
    const nomTypo = (id) => ((v && v.typologies) || []).find((t) => t.id === id)?.nom || "";
    const cols = colonnesSuiviOrdonnees(ch, logs);
    const b = "border:1px solid #999;padding:3px 5px;";
    const bloc = (k) => k === "rdm" || k === "prod" || k === "pose";
    const etape = (x, avant) => `<td style="${b}">${e(x.date ? formatDate(x.date) : "")}</td><td style="${b}${x.statut === "FAIT" ? "font-weight:700;" : ""}">${e(x.statut || "")}${avant ? `<span style="font-weight:400;"> (avant ERP · ${e(avant.numero)})</span>` : ""}</td>`;
    const tdDe = (k, col, l, sv) => {
      if (bloc(k)) return etape(sv[k], k === "pose" ? sv.avantERP : null);
      const val = k === "etage" ? l.etage : k === "apt" ? l.appart : k === "typo" ? nomTypo(l.typologieId) : k === "reportee" ? (sv.reportee ? formatDate(sv.reportee) : "") : k === "bloquant" ? l.bloquant || "" : (l.valeursSuivi || {})[col.id] || "";
      return `<td style="${b}">${e(val)}</td>`;
    };
    // Nils 14/10 (g) : un seul tableau, colonne Bâtiment / villa, titres de colonnes répétés en haut de chaque page (thead).
    const corps = `
      <table style="width:100%;border-collapse:collapse;margin-bottom:10px;">
        <thead>
        <tr><th style="${b}" rowspan="2">Bâtiment / villa</th>${cols.map(({ k, lib }) => (bloc(k) ? `<th style="${b}" colspan="2">${e(lib)}</th>` : `<th style="${b}" rowspan="2">${e(lib)}</th>`)).join("")}</tr>
        <tr>${cols.filter(({ k }) => bloc(k)).map(() => `<th style="${b}">Date</th><th style="${b}">Statut</th>`).join("")}</tr>
        </thead>
        <tbody>
        ${logs.map((l) => {
          const sv = suiviLogement(l);
          return `<tr><td style="${b}font-weight:700;white-space:nowrap;">${e(libBatiment(l.batiment))}</td>${cols.map(({ k, col }) => tdDe(k, col, l, sv)).join("")}</tr>`;
        }).join("")}
        </tbody>
      </table>`;
    // Nils 14/10 : plus de tableau SAV, géré par les colonnes libres.
    // Nils 14/10 (h) : en-tête et pied réduits pour gagner de la place.
    const html = `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="UTF-8" />
<title>Suivi de chantier ${e(ch.nom)}</title>
<style>
  * { box-sizing: border-box; }
  body { font-family: Arial, Helvetica, sans-serif; color: #000; font-size: 10px; line-height: 1.3; margin: 0; padding: 0; }
  table { border-collapse: collapse; }
  thead { display: table-header-group; }
  th { font-size: 9px; background: #F2EFED; }
  @page { size: A4 landscape; margin: 0.8cm 0.8cm 1.2cm; @bottom-left { content: "Stone Concept Sarl — ICE 000073605 0000 01 — Hot Line 06 61 26 49 31 — sales@stoneconcept.ma"; font-family: Arial, Helvetica, sans-serif; font-size: 8px; color: #555; } @bottom-right { content: "Page " counter(page) " / " counter(pages); font-family: Arial, Helvetica, sans-serif; font-size: 8px; color: #000; } }
  .doc-header { padding-bottom: 6px; margin-bottom: 8px; border-bottom: 1px solid #ccc; }
  tr { page-break-inside: avoid; }
</style>
</head>
<body>
  <div class="doc-header">
    <div style="display:flex;justify-content:space-between;align-items:center;gap:16px;">
      <img src="${LOGO_SRC}" alt="Stone Concept" style="height:30px;" />
      <div style="font-size:14px;font-weight:700;">SUIVI DE CHANTIER — ${e(ch.nom)}</div>
      <div style="text-align:right;font-size:9px;">
        ${ch.promoteur ? `<div>Promoteur : <b>${e(ch.promoteur)}</b></div>` : ""}
        <div>${client ? e(client.raisonSociale || client.nom) : ""}${ch.adresse ? ` — ${e(ch.adresse)}` : ""}</div>
        <div>Le ${e(formatDate(todayISO()))}</div>
      </div>
    </div>
  </div>
  <main>${corps}</main>
</body>
</html>`;
    telechargerDocument(html, `Suivi-chantier_${ch.nom}_${todayISO()}`.replace(/[\\/:*?"<>|]+/g, "-"), "suivi de chantier");
  }
  // ---- Nils 01/11 : électroménager standard par typologie (plaque, évier, fiches techniques) ----
  function projetActuel(ch) {
    return (chantiers || []).find((x) => x.id === ch.id) || ch;
  }
  async function majElectroProjet(ch0, typoId, k, patch, trace) {
    const ch = projetActuel(ch0);
    const et = { ...(ch.electroTypologies || {}) };
    const cur = { ...(et[typoId] || {}) };
    cur[k] = { ...(cur[k] || {}), ...patch };
    et[typoId] = cur;
    await majProjet(ch, { electroTypologies: et }, trace);
  }
  // Nils 03/11 : la référence (et la fiche) d'une typologie appliquée à toutes les typologies du projet.
  async function appliquerElectroATous(ch0, typoId, k) {
    const ch = projetActuel(ch0);
    const v = derniereVersionDP(ch);
    const typos = v ? v.typologies || [] : [];
    const et = { ...(ch.electroTypologies || {}) };
    const src = (et[typoId] || {})[k] || {};
    if (!src.reference) return;
    const lib = k === "plaque" ? "plaque" : "évier";
    const descr = (x) => (x && x.reference ? `${x.reference}${k === "evier" && x.type ? ` (${x.type.toLowerCase()})` : ""}` : "");
    const autres = typos.filter((t) => t.id !== typoId && descr((et[t.id] || {})[k]) && descr((et[t.id] || {})[k]) !== descr(src));
    const nom = descr(src);
    const q = autres.length
      ? `${autres.length} typologie(s) ont un autre ${lib === "plaque" ? "plaque" : "évier"} : ${autres.map((t) => `${t.nom} — ${descr((et[t.id] || {})[k])}`).join(" ; ")}.\n\nLes remplacer par ${nom}${src.fichier ? " (avec sa fiche technique)" : ""} ?`
      : `Appliquer ${nom}${src.fichier ? " (avec sa fiche technique)" : ""} à toutes les typologies du projet ?`;
    if (!(await demander(q))) return;
    // Fiches remplacées : gardées (des devis déjà créés les référencent peut-être).
    const anciens = [];
    typos.forEach((t) => {
      if (t.id === typoId) return;
      const cur = { ...(et[t.id] || {}) };
      const f = cur[k] && cur[k].fichier;
      if (f && (!src.fichier || f.id !== src.fichier.id)) anciens.push(f);
      cur[k] = { ...src };
      et[t.id] = cur;
    });
    const encore = new Set(Object.values(et).flatMap((x) => ["plaque", "evier"].map((kk) => x && x[kk] && x[kk].fichier && x[kk].fichier.id).filter(Boolean)));
    const aGarder = anciens.filter((f, i) => !encore.has(f.id) && anciens.findIndex((g) => g.id === f.id) === i);
    await majProjet(ch, { electroTypologies: et, ...(aGarder.length ? { electroFichiersAnciens: [...(ch.electroFichiersAnciens || []), ...aGarder] } : {}) }, [`${lib} standard appliqué à tout le projet`, nom]);
  }
  async function deposerFicheElectro(ch0, typoId, k, file) {
    if (!window.storage || !window.storage.deposerFichier) { setNotice("Le dépôt de fichiers n'est possible qu'avec l'ERP sur son serveur."); return; }
    if (!EXTENSIONS_FICHIERS.includes(extensionFichier(file.name))) { setNotice(`« ${file.name} » : type de fichier non accepté. Acceptés : ${TYPES_FICHIERS_LISIBLES}.`); return; }
    if (file.size > TAILLE_MAX_FICHIER) { setNotice(`« ${file.name} » (${formatTaille(file.size)}) dépasse la limite de 25 Mo.`); return; }
    setDepotEnCours(`electro:${typoId}:${k}`);
    try {
      const r = await window.storage.deposerFichier(null, file, { cle: "erp:chantiers", element: ch0.id });
      if (r.erreur) { setNotice(r.erreur); return; }
      const ch = projetActuel(ch0);
      const et = { ...(ch.electroTypologies || {}) };
      const cur = { ...(et[typoId] || {}) };
      const ancien = cur[k] && cur[k].fichier;
      cur[k] = { ...(cur[k] || {}), fichier: { ...r.fichier, par: user.nom, le: new Date().toISOString() } };
      et[typoId] = cur;
      // L'ancienne fiche reste rangée : des devis déjà créés la référencent peut-être.
      await majProjet(ch, { electroTypologies: et, ...(ancien ? { electroFichiersAnciens: [...(ch.electroFichiersAnciens || []), ancien] } : {}) }, ["fiche technique standard déposée", `${k === "plaque" ? "plaque" : "évier"} — ${file.name}`]);
    } finally {
      setDepotEnCours("");
    }
  }
  function renderElectroProjet(ch) {
    const v = derniereVersionDP(ch);
    const typos = v ? v.typologies || [] : [];
    if (!typos.length) return <div style={{ fontSize: 12, color: TAUPE }}>Les typologies viennent du devis projet : crée d'abord le devis projet.</div>;
    // Nils 01/11 : Ahmed (Production) renseigne aussi l'électroménager standard (références et fiches).
    const modifiable = peutGererLogements || user.profil === P_PROD;
    const fichesModifiables = modifiable;
    const et = ch.electroTypologies || {};
    const lienF = (f) => (f && window.storage && window.storage.lienFichier ? window.storage.lienFichier(f.id) : null);
    const fiche = (t, k) => {
      const f = ((et[t.id] || {})[k] || {}).fichier;
      return (
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginTop: 4 }}>
          {f ? (lienF(f) ? <a href={lienF(f)} target="_blank" rel="noopener noreferrer" style={{ color: ENCRE, fontSize: 12 }}>📎 {f.nom}</a> : <span style={{ fontSize: 12 }}>📎 {f.nom}</span>) : <span style={{ fontSize: 12, color: fichesModifiables ? OCRE : TAUPE }}>Fiche technique : aucune</span>}
          {fichesModifiables && renderBoutonDepot(`electro:${t.id}:${k}`, (file) => deposerFicheElectro(ch, t.id, k, file), { libelle: f ? "Remplacer la fiche" : "📎 Déposer la fiche technique" })}
        </div>
      );
    };
    const cell = { padding: "8px", borderTop: `1px solid ${PIERRE}`, verticalAlign: "top", fontSize: 13 };
    // Nils 03/11 : bloc repliable, avec un résumé.
    const resume = (k) => {
      const refs = typos.map((t) => (et[t.id] || {})[k] || {}).filter((x) => x.reference);
      const diff = [...new Set(refs.map((x) => `${x.reference}${k === "evier" && x.type ? ` ${x.type.toLowerCase()}` : ""}`))];
      return `${k === "plaque" ? "plaque" : "évier"} : ${diff.length === 1 ? diff[0] : diff.length ? `${diff.length} références` : "aucune"} (${refs.length}/${typos.length})`;
    };
    const nbFiches = typos.reduce((n, t) => n + ["plaque", "evier"].filter((k) => ((et[t.id] || {})[k] || {}).fichier).length, 0);
    const basculer = () => { const o = !electroOuvert; setElectroOuvert(o); try { localStorage.setItem("erp-electro-ouvert", o ? "1" : "0"); } catch (e) { /* stockage indisponible */ } };
    const entete = (
      <button type="button" className="sc-btn" onClick={basculer} aria-expanded={electroOuvert} style={{ ...ghostBtnStyle, display: "flex", gap: 8, alignItems: "center", padding: "2px 0", fontSize: 12, textAlign: "left", marginBottom: electroOuvert ? 8 : 0 }}>
        <span>{electroOuvert ? "▾" : "▸"}</span>
        <span>{typos.length} typologie{typos.length > 1 ? "s" : ""} — {resume("plaque")} · {resume("evier")} · fiches : {nbFiches}/{typos.length * 2}</span>
      </button>
    );
    if (!electroOuvert) return entete;
    const boutonTous = (t, k) => modifiable && typos.length > 1 && ((et[t.id] || {})[k] || {}).reference ? (
      <button type="button" className="sc-btn" onClick={() => appliquerElectroATous(ch, t.id, k)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 0", marginTop: 4, display: "block" }}>⇉ Appliquer à toutes les typologies</button>
    ) : null;
    return (
      <div>
        {entete}
        <div style={{ fontSize: 12, color: TAUPE, marginBottom: 8 }}>Repris sur un devis de logement quand l'ADV coche « Oui, ce sont bien les électros standard du projet ». Changer le standard ne modifie pas les devis déjà créés.</div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead><tr>{["Typologie", "Plaque de cuisson", "Évier"].map((h) => <th key={h} style={{ padding: "6px 8px", textAlign: "left", fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>{h}</th>)}</tr></thead>
            <tbody>
              {typos.map((t) => {
                const pl = (et[t.id] || {}).plaque || {};
                const ev = (et[t.id] || {}).evier || {};
                return (
                  <tr key={t.id}>
                    <td style={{ ...cell, fontWeight: 600, whiteSpace: "nowrap" }}>{t.nom || "—"}</td>
                    <td style={{ ...cell, minWidth: 260 }}>
                      {modifiable ? champReferenceTech("plaquesCuisson", pl, (patch) => majElectroProjet(ch, t.id, "plaque", patch, ["plaque standard", `${t.nom} — ${patch.reference || ""}`])) : <span>{pl.reference || <span style={{ color: TAUPE }}>—</span>}</span>}
                      {fiche(t, "plaque")}
                      {boutonTous(t, "plaque")}
                    </td>
                    <td style={{ ...cell, minWidth: 260 }}>
                      {modifiable ? (
                        <>
                          <div style={{ display: "flex", gap: 12, marginBottom: 6, fontSize: 12 }}>
                            {TYPES_EVIER.map((ty) => (<label key={ty} style={{ display: "flex", gap: 4, alignItems: "center" }}><input type="radio" name={`ev-${ch.id}-${t.id}`} checked={ev.type === ty} onChange={() => majElectroProjet(ch, t.id, "evier", { type: ty })} /> {ty}</label>))}
                          </div>
                          {champReferenceTech("eviers", ev, (patch) => majElectroProjet(ch, t.id, "evier", patch, ["évier standard", `${t.nom} — ${patch.reference || ""}`]))}
                        </>
                      ) : <span>{ev.reference ? `${ev.reference}${ev.type ? ` (${ev.type.toLowerCase()})` : ""}` : <span style={{ color: TAUPE }}>—</span>}</span>}
                      {fiche(t, "evier")}
                      {boutonTous(t, "evier")}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
  // Électroménager standard applicable à un devis (ou au dossier) créé depuis un logement.
  function electroStandardDe(source) {
    const d = source && source.devisId ? devisDeCommande(source) : source;
    if (!d || !d.chantierId || !d.projetTypologieId) return null;
    const ch = (chantiers || []).find((x) => x.id === d.chantierId);
    const std = ch && ch.electroTypologies ? ch.electroTypologies[d.projetTypologieId] : null;
    if (!std || !((std.plaque && std.plaque.reference) || (std.evier && std.evier.reference))) return null;
    const v = derniereVersionDP(ch);
    const t = v && (v.typologies || []).find((x) => x.id === d.projetTypologieId);
    return { ch, std, typoNom: t ? t.nom : "" };
  }
  async function basculerElectroStandard(source, onChange, coche) {
    const info = electroStandardDe(source);
    const docs = { ...(source.documents || {}) };
    const maintenant = new Date().toISOString();
    if (!coche) {
      ["plaque:0", "evier:0"].forEach((k) => { if (docs[k] && docs[k].standardProjet) delete docs[k]; });
      onChange({ ...source, electroStandard: null, plaquesCuisson: (source.plaquesCuisson || []).filter((x) => !x.standardProjet), eviers: (source.eviers || []).filter((x) => !x.standardProjet), documents: docs });
      return;
    }
    if (!info) return;
    const saisies = [...(source.plaquesCuisson || []), ...(source.eviers || [])].filter((x) => (x.reference || "").trim() && !x.standardProjet);
    if (saisies.length && !(await demander(`Remplacer la plaque et l'évier saisis (${saisies.map((x) => x.reference).join(", ")}) par le standard de la typologie ${info.typoNom} ?`))) return;
    const { plaque = {}, evier = {} } = info.std;
    const docProjet = (f, label) => (f ? { lien: `${f.nom} (standard du projet)`, fichierProjet: { id: f.id, nom: f.nom, taille: f.taille, type: f.type, chantierId: info.ch.id }, standardProjet: true, par: user.nom, le: maintenant, label } : null);
    const dP = docProjet(plaque.reference ? plaque.fichier : null, "plaque");
    const dE = docProjet(evier.reference ? evier.fichier : null, "evier");
    if (dP) docs["plaque:0"] = dP;
    if (dE) docs["evier:0"] = dE;
    onChange({
      ...source,
      electroStandard: { typologieId: (source.devisId ? devisDeCommande(source) || {} : source).projetTypologieId, le: maintenant, par: user.nom },
      plaquesCuisson: plaque.reference ? [{ id: uid(), reference: plaque.reference, commentaire: "", standardProjet: true }] : (source.plaquesCuisson || []).filter((x) => !x.standardProjet),
      eviers: evier.reference ? [{ id: uid(), reference: evier.reference, type: evier.type || typeEvierRef(evier.reference) || "", commentaire: "", standardProjet: true }] : (source.eviers || []).filter((x) => !x.standardProjet),
      documents: docs,
    });
  }
  // Bloc « Phases et logements » de la fiche projet (lot 4a).
  function renderLogementsProjet(ch) {
    const v = derniereVersionDP(ch);
    const typos = v ? v.typologies || [] : [];
    const phases = ch.phases || [];
    const logs = (ch.logements || []).slice().sort((a, b) => `${a.batiment}|${String(a.etage).padStart(4, "0")}|${String(a.appart).padStart(4, "0")}`.localeCompare(`${b.batiment}|${String(b.etage).padStart(4, "0")}|${String(b.appart).padStart(4, "0")}`, "fr", { numeric: true }));
    const cell = { padding: "5px 8px", borderBottom: `1px solid ${PIERRE}`, fontSize: 12, verticalAlign: "middle" };
    const sel = { ...selectStyle, padding: "3px 6px", fontSize: 12 };
    const nomTypo = (id) => (typos.find((t) => t.id === id) || {}).nom || "—";
    const ecarts = typos.map((t) => ({ t, n: logs.filter((l) => l.typologieId === t.id).length })).filter((x) => x.n !== (Number(x.t.nbCuisines) || 0));
    const f = logementSaisie && logementSaisie.projetId === ch.id ? logementSaisie : null;
    const setF = (patch) => setLogementSaisie({ ...f, ...patch, erreur: "" });
    return (
      <div>
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
          <span style={{ fontSize: 12, color: TAUPE }}>Phases :</span>
          {phases.length === 0 && <span style={{ fontSize: 12, color: TAUPE }}>aucune</span>}
          {phases.map((p) => (
            <span key={p.id} style={{ background: PIERRE, borderRadius: 12, padding: "3px 10px", fontSize: 12 }}>
              {p.nom} <span style={{ color: TAUPE }}>({logs.filter((l) => l.phaseId === p.id).length})</span>
              {peutGererLogements && <button type="button" className="sc-btn" onClick={() => renommerPhase(ch, p)} style={{ ...ghostBtnStyle, padding: "0 3px", fontSize: 11 }} title="Renommer">✎</button>}
              {peutGererLogements && <button type="button" className="sc-btn" onClick={() => supprimerPhase(ch, p)} style={{ ...ghostBtnStyle, padding: "0 3px", fontSize: 11 }} title="Supprimer">✕</button>}
            </span>
          ))}
          {peutGererLogements && <button type="button" className="sc-btn" onClick={() => ajouterPhase(ch)} style={{ ...ghostBtnStyle, fontSize: 12 }}>+ Phase</button>}
          <div style={{ flex: 1 }} />
          {peutGererLogements && v && phases.length > 0 && <>
            <button type="button" className="sc-btn" onClick={() => setLogementSaisie({ projetId: ch.id, mode: "un", batiment: "", etage: "", appart: "", typologieId: "", phaseId: phases[0].id })} style={ghostBtnStyle}>+ Logement</button>
            <button type="button" className="sc-btn" onClick={() => setLogementSaisie({ projetId: ch.id, mode: "serie", batiment: "", etageDe: "0", etageA: "4", parEtage: "2", typologieId: "", phaseId: phases[0].id })} style={ghostBtnStyle}>+ Logements en série</button>
          </>}
        </div>
        {!v && <div style={{ fontSize: 12, color: OCRE, marginBottom: 8 }}>Les logements se rattachent aux typologies du devis projet : crée d'abord le devis projet.</div>}
        {v && phases.length === 0 && peutGererLogements && <div style={{ fontSize: 12, color: OCRE, marginBottom: 8 }}>Crée au moins une phase avant d'ajouter des logements.</div>}
        {ecarts.length > 0 && logs.length > 0 && <div style={{ fontSize: 12, color: OCRE, marginBottom: 8 }}>Logements ≠ cuisines du devis projet : {ecarts.map((x) => `${x.t.nom} ${x.n} / ${Number(x.t.nbCuisines) || 0}`).join(" · ")}</div>}
        {f && (
          <div style={{ background: PIERRE, borderRadius: 8, padding: 10, marginBottom: 10, display: "flex", gap: 8, alignItems: "flex-end", flexWrap: "wrap" }}>
            <Field label="Bâtiment / villa"><input className="sc-input" value={f.batiment} onChange={(e) => setF({ batiment: e.target.value })} placeholder="N2, Villa 12…" style={inputStyle(110)} /></Field>
            {f.mode === "serie" ? <>
              <Field label="Étages de (0 = RDC)"><input type="number" className="sc-input" value={f.etageDe} onChange={(e) => setF({ etageDe: e.target.value })} style={inputStyle(70)} /></Field>
              <Field label="à"><input type="number" className="sc-input" value={f.etageA} onChange={(e) => setF({ etageA: e.target.value })} style={inputStyle(70)} /></Field>
              <Field label="Appartements / étage"><input type="number" className="sc-input" value={f.parEtage} onChange={(e) => setF({ parEtage: e.target.value })} style={inputStyle(70)} /></Field>
            </> : <>
              <Field label="Étage (facultatif)"><input className="sc-input" value={f.etage} onChange={(e) => setF({ etage: e.target.value })} placeholder="RDC, 1, 2…" style={inputStyle(80)} /></Field>
              <Field label="N° appartement (facultatif)"><input className="sc-input" value={f.appart} onChange={(e) => setF({ appart: e.target.value })} style={inputStyle(80)} /></Field>
            </>}
            <Field label={f.verrouTypo ? "Typologie (figée : devis créé)" : "Typologie"}>
              <select className="sc-select" value={f.typologieId} disabled={!!f.verrouTypo} onChange={(e) => setF({ typologieId: e.target.value })} style={selectStyle}>
                <option value="">— Choisir —</option>
                {typos.map((t) => (<option key={t.id} value={t.id}>{t.nom}</option>))}
              </select>
            </Field>
            <Field label="Phase">
              <select className="sc-select" value={f.phaseId} onChange={(e) => setF({ phaseId: e.target.value })} style={selectStyle}>
                {phases.map((p) => (<option key={p.id} value={p.id}>{p.nom}</option>))}
              </select>
            </Field>
            <button type="button" className="sc-btn" onClick={enregistrerLogements} style={{ ...primaryBtnStyle, marginBottom: 14 }}>{f.mode === "serie" ? "Créer les logements" : f.mode === "edit" ? "Enregistrer" : "Ajouter"}</button>
            <button type="button" className="sc-btn" onClick={() => setLogementSaisie(null)} style={{ ...ghostBtnStyle, marginBottom: 14 }}>Fermer</button>
            {f.erreur && <div style={{ width: "100%", color: ROUILLE, fontSize: 12, fontWeight: 600 }}>{f.erreur}</div>}
          </div>
        )}
        {logs.length === 0 ? <div style={{ fontSize: 13, color: TAUPE }}>Aucun logement.</div> : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead><tr>{["Bâtiment / villa", "Étage", "Appart.", "Typologie", "Phase", "Devis / dossier", ""].map((h) => (<th key={h} style={{ ...cell, textAlign: "left", fontSize: 10, color: TAUPE, textTransform: "uppercase" }}>{h}</th>))}</tr></thead>
            <tbody>
              {logs.map((l) => {
                const d = devisDuLogement(l);
                const c = dossierDuDevisLogement(d);
                return (
                  <tr key={l.id}>
                    <td style={cell}>{l.batiment}</td>
                    <td style={cell}>{l.etage}</td>
                    <td style={cell}>{l.appart}</td>
                    <td style={cell}>{peutGererLogements && !d ? (
                      <select className="sc-select" value={l.typologieId || ""} onChange={(e) => majLogement(ch, l, { typologieId: e.target.value })} style={sel}>
                        <option value="">—</option>
                        {typos.map((t) => (<option key={t.id} value={t.id}>{t.nom}</option>))}
                      </select>
                    ) : nomTypo(l.typologieId)}</td>
                    <td style={cell}>{peutGererLogements ? (
                      <select className="sc-select" value={l.phaseId || ""} onChange={(e) => majLogement(ch, l, { phaseId: e.target.value })} style={sel}>
                        {phases.map((p) => (<option key={p.id} value={p.id}>{p.nom}</option>))}
                      </select>
                    ) : (phases.find((p) => p.id === l.phaseId) || {}).nom || "—"}</td>
                    <td style={cell}>
                      {c ? (
                        <button type="button" className="sc-btn" onClick={() => { setActiveTab("commandes"); ouvrirCommande(c.id); }} style={{ ...ghostBtnStyle, padding: 0, fontSize: 12, textDecoration: "underline" }}>{c.numeroFacture || c.numeroBL || c.numeroPL || c.numeroRDM || c.numero} ({c.statut})</button>
                      ) : d ? (
                        <button type="button" className="sc-btn" onClick={() => { setActiveTab("devis"); ouvrirDevis(d.id); }} style={{ ...ghostBtnStyle, padding: 0, fontSize: 12, textDecoration: "underline" }}>{d.numero || "devis brouillon"} ({d.statut})</button>
                      ) : peutCreerDevisLogement && v ? (
                        <button type="button" className="sc-btn" onClick={() => creerDevisLogement(ch, l)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 8px" }}>Créer le devis</button>
                      ) : <span style={{ color: TAUPE }}>—</span>}
                      {devisModifieTypologie(d) && <span style={{ marginLeft: 6, fontSize: 10, color: OCRE, fontWeight: 600 }}>modifié / typologie</span>}
                    </td>
                    <td style={{ ...cell, whiteSpace: "nowrap" }}>
                      {peutGererLogements && <button type="button" className="sc-btn" onClick={() => setLogementSaisie({ projetId: ch.id, mode: "edit", id: l.id, batiment: l.batiment || "", etage: l.etage || "", appart: l.appart || "", typologieId: l.typologieId || "", phaseId: l.phaseId || (phases[0] || {}).id || "", verrouTypo: !!d })} style={iconBtnStyle} title="Modifier">✎</button>}
                      {peutGererLogements && !d && <button type="button" className="sc-btn" onClick={() => supprimerLogement(ch, l)} style={iconBtnStyle} title="Supprimer">✕</button>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    );
  }
  // Bloc « Budgets réels » (lot 4a) : tranches par phase et livraisons.
  function renderBudgetsReels(ch) {
    const b = budgetsReelsProjet(ch);
    if (!b.v) return <div style={{ fontSize: 13, color: TAUPE }}>Pas encore de devis projet.</div>;
    const cell = { padding: "5px 8px", borderBottom: `1px solid ${PIERRE}`, fontSize: 12 };
    const num = { ...cell, textAlign: "right" };
    const n2 = (x) => (Math.round((Number(x) || 0) * 100) / 100).toLocaleString("fr-FR");
    return (
      <div>
        <div style={{ fontSize: 13, marginBottom: 10 }}>
          Livraisons : <strong style={{ color: b.livFaites > b.livPrevues ? ROUILLE : ENCRE }}>{b.livFaites}</strong> faite(s) sur <strong>{b.livPrevues}</strong> prévue(s)
          {b.livFaites > b.livPrevues && <span style={{ color: ROUILLE, fontWeight: 600 }}> — budget livraison dépassé</span>}
        </div>
        {b.parPhase.length === 0 ? <div style={{ fontSize: 13, color: TAUPE }}>Aucune phase.</div> : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead><tr>{["Phase", "Logements", "Tranche", "Budget", "Sorti (PL)", "Reste"].map((h, i) => (<th key={h} style={{ ...(i >= 3 ? num : cell), fontSize: 10, color: TAUPE, textTransform: "uppercase" }}>{h}</th>))}</tr></thead>
            <tbody>
              {b.parPhase.map(({ p, n, lignes }) => (lignes.length ? lignes : [{ a: { id: "-", designation: "—" }, budget: 0, sorti: 0 }]).map((x, i) => {
                const depasse = x.sorti > x.budget + 0.001;
                return (
                  <tr key={`${p.id}-${x.a.id}`}>
                    <td style={{ ...cell, fontWeight: 600 }}>{i === 0 ? p.nom : ""}</td>
                    <td style={cell}>{i === 0 ? n : ""}</td>
                    <td style={cell}>{x.a.designation}</td>
                    <td style={num}>{n2(x.budget)}</td>
                    <td style={{ ...num, color: depasse ? ROUILLE : ENCRE, fontWeight: depasse ? 700 : 400 }}>{n2(x.sorti)}</td>
                    <td style={{ ...num, color: depasse ? ROUILLE : TAUPE }}>{n2(x.budget - x.sorti)}</td>
                  </tr>
                );
              }))}
            </tbody>
          </table>
        )}
        <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Budget d'une phase = pour chaque logement, les quantités de sa commande (avenant compris) ou de son devis ; sans devis, celles de sa typologie au devis projet en vigueur. Sorti = tranches sorties sur les PL des dossiers de ces logements.</div>
      </div>
    );
  }
  // Bloc « Devis projet » de la fiche projet (lecture ; Nils : créer, modifier la dernière version, nouvelle version).
  function renderDevisProjet(ch) {
    const versions = versionsDevisProjet(ch);
    if (!versions.length) {
      return (
        <div style={{ fontSize: 13, color: TAUPE, display: "flex", gap: 12, alignItems: "center" }}>
          Pas encore de devis projet.
          {estGerant && <button type="button" className="sc-btn" onClick={() => setDevisProjetEdit({ projetId: ch.id, v: nouvelleVersionVide() })} style={primaryBtnStyle}>Créer le devis projet</button>}
        </div>
      );
    }
    const der = versions[versions.length - 1];
    const v = versions.find((x) => x.id === devisProjetVue[ch.id]) || der;
    const k = calculDevisProjet(v, ch);
    const n2 = (x) => (Math.round((Number(x) || 0) * 100) / 100).toLocaleString("fr-FR");
    const cell = { padding: "6px 8px", borderBottom: `1px solid ${PIERRE}`, fontSize: 13 };
    const num = { ...cell, textAlign: "right", whiteSpace: "nowrap" };
    return (
      <div>
        <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 10, flexWrap: "wrap" }}>
          <select className="sc-select" value={v.id} onChange={(e) => setDevisProjetVue({ ...devisProjetVue, [ch.id]: e.target.value })} style={{ ...selectStyle, padding: "4px 8px", fontSize: 12 }}>
            {versions.slice().reverse().map((x) => (<option key={x.id} value={x.id}>{numeroDP(ch, x)} du {formatDate(x.date)}{x.id === der.id ? " (en vigueur)" : ""}</option>))}
          </select>
          {v.id !== der.id && <span style={{ fontSize: 12, color: OCRE }}>Ancienne version (lecture seule)</span>}
          <div style={{ flex: 1 }} />
          {estGerant && v.id === der.id && <button type="button" className="sc-btn" onClick={() => setDevisProjetEdit({ projetId: ch.id, v: JSON.parse(JSON.stringify(der)) })} style={ghostBtnStyle}>✎ Modifier V{der.version}</button>}
          {estGerant && <button type="button" className="sc-btn" onClick={() => ouvrirNouvelleVersion(ch)} style={ghostBtnStyle}>+ Nouvelle version</button>}
          {montantsProjetVisibles && <button type="button" className="sc-btn" onClick={() => imprimerDevisProjet(ch, v, "client")} style={ghostBtnStyle}>🖨 Devis client</button>}
          {montantsProjetVisibles && <button type="button" className="sc-btn" onClick={() => imprimerDevisProjet(ch, v, "adv")} style={ghostBtnStyle}>🖨 Doc ADV</button>}
          <button type="button" className="sc-btn" onClick={() => imprimerDevisProjet(ch, v, "production")} style={ghostBtnStyle}>🖨 Doc production</button>
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead><tr>
            <th style={{ ...cell, textAlign: "left", fontSize: 11, color: TAUPE }}>Typologie</th>
            <th style={{ ...num, fontSize: 11, color: TAUPE }}>Cuisines</th>
            <th style={{ ...cell, textAlign: "left", fontSize: 11, color: TAUPE }}>Code couleur</th>
            {(v.colonnes || []).map((c) => (<th key={c} style={{ ...cell, textAlign: "left", fontSize: 11, color: TAUPE }}>{c}</th>))}
            {montantsProjetVisibles && <th style={{ ...num, fontSize: 11, color: TAUPE }}>Prix / cuisine HT</th>}
            {montantsProjetVisibles && <th style={{ ...num, fontSize: 11, color: TAUPE }}>Total HT</th>}
          </tr></thead>
          <tbody>
            {k.parTypo.map(({ t, parCuisine, total }) => (
              <tr key={t.id}>
                <td style={{ ...cell, fontWeight: 600 }}>{t.nom}</td>
                <td style={num}>{n2(t.nbCuisines)}</td>
                <td style={cell}>{codeCouleurTypo(v, t)}</td>
                {(v.colonnes || []).map((c) => (<td key={c} style={{ ...cell, color: TAUPE }}>{(t.pieces || {})[c] || ""}</td>))}
                {montantsProjetVisibles && <td style={num}>{formatDH(parCuisine)}</td>}
                {montantsProjetVisibles && <td style={num}>{formatDH(total)}</td>}
              </tr>
            ))}
            <tr>
              <td style={{ ...cell, fontWeight: 700 }}>Total</td>
              <td style={{ ...num, fontWeight: 700 }}>{n2(k.nbCuisines)}</td>
              <td style={cell} colSpan={1 + (v.colonnes || []).length} />
              {montantsProjetVisibles && <td style={num} />}
              {montantsProjetVisibles && <td style={{ ...num, fontWeight: 700 }}>{formatDH(k.totalHT)}</td>}
            </tr>
          </tbody>
        </table>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginTop: 12 }}>
          <div>
            <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>Budget tranches</div>
            {k.budgetsTranches.length ? k.budgetsTranches.map((b) => (<div key={b.a.id} style={{ fontSize: 13 }}>{b.a.designation} : <strong>{n2(b.qte)}</strong> tranche(s)</div>)) : <div style={{ fontSize: 13, color: TAUPE }}>Aucune tranche saisie.</div>}
          </div>
          <div>
            <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>Budget livraison</div>
            <div style={{ fontSize: 13 }}>{n2(v.cuisinesParLivraison)} cuisines par livraison en moyenne → <strong>{k.nbLivraisons}</strong> livraison(s)</div>
            <div style={{ fontSize: 13 }}>Coût : {k.coutLivraisons === null ? <span style={{ color: OCRE }}>zone non réglée sur l'article de livraison</span> : <strong>{formatDH(k.coutLivraisons)}</strong>}{k.zone ? ` (forfait ${k.zone.nom})` : ""}</div>
            {montantsProjetVisibles && <div style={{ fontSize: 13, color: TAUPE }}>Facturée {formatDH(k.livParCuisine)} HT par cuisine</div>}
          </div>
        </div>
      </div>
    );
  }
  // Éditeur du devis projet (Nils seul).
  function renderEditeurDevisProjet(ch) {
    if (!estGerant || !devisProjetEdit) return null;
    const v = devisProjetEdit.v;
    const setV = (patch) => setDevisProjetEdit({ ...devisProjetEdit, v: synchroArticlesAuto({ ...v, ...patch }), erreur: "" });
    const k = calculDevisProjet(v, ch);
    const nomArt = (id) => ((articles || []).find((a) => a.id === id) || {}).designation || "?";
    const majArticle = (aid, patch) => setV({ articles: v.articles.map((x) => (x.articleId === aid ? { ...x, ...patch } : x)) });
    // Nils 02/11 : ordre d'affichage des articles (flèches) — relevé de mesure et livraison restent en tête.
    const estAutoDP = (x) => x.articleId === v.articleLivraisonId || x.articleId === v.articleRDMId;
    const deplacerArticle = (aid, sens) => {
      const autres = v.articles.filter((x) => !estAutoDP(x));
      const i = autres.findIndex((x) => x.articleId === aid), j = i + sens;
      if (i < 0 || j < 0 || j >= autres.length) return;
      const l = [...autres];
      [l[i], l[j]] = [l[j], l[i]];
      setV({ articles: [...v.articles.filter(estAutoDP), ...l] });
    };
    const majTypo = (id, patch) => setV({ typologies: v.typologies.map((t) => (t.id === id ? { ...t, ...patch } : t)) });
    const dispo = trierAlpha((articles || []).filter((a) => a.actif !== false && a.categorie !== "Descriptifs" && !v.articles.some((x) => x.articleId === a.id)), "designation");
    const petit = { padding: "4px 6px", fontSize: 12 };
    const cell = { padding: "4px 6px", borderBottom: `1px solid ${PIERRE}`, fontSize: 12, verticalAlign: "middle" };
    const titre = (t) => <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, margin: "16px 0 6px" }}>{t}</div>;
    return (
      <Overlay onClose={() => setDevisProjetEdit(null)}>
        <div style={{ ...modalStyle(1300), maxWidth: "96vw" }}>
          <div style={modalTitleStyle}>Devis projet — {ch.nom} — V{v.version}</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 2fr 2fr", gap: 12 }}>
            <Field label="Date"><input type="date" className="sc-input" value={v.date} onChange={(e) => setV({ date: e.target.value })} style={inputStyle("100%")} /></Field>
            <Field label="Cuisines par livraison (moyenne)"><input type="number" min="1" step="0.5" className="sc-input" value={v.cuisinesParLivraison} onChange={(e) => setV({ cuisinesParLivraison: e.target.value })} style={inputStyle("100%")} /></Field>
            <Field label="Article de livraison">
              <select className="sc-select" value={v.articleLivraisonId || ""} onChange={(e) => setV({ articleLivraisonId: e.target.value })} style={selectStyle}>
                <option value="">— Aucun —</option>
                {articlesNature("livraison").map((a) => (<option key={a.id} value={a.id}>{a.designation}</option>))}
              </select>
            </Field>
            <Field label="Article de RDM (offert)">
              <select className="sc-select" value={v.articleRDMId || ""} onChange={(e) => setV({ articleRDMId: e.target.value })} style={selectStyle}>
                <option value="">— Aucun —</option>
                {articlesNature("rdm").map((a) => (<option key={a.id} value={a.id}>{a.designation}</option>))}
              </select>
            </Field>
          </div>
          {v.articleLivraisonId && !zoneDevisProjet(v) && <div style={{ fontSize: 12, color: OCRE }}>L'article de livraison n'a pas de zone (fiche Catalogue › Zone de livraison) : le coût des livraisons ne peut pas être calculé.</div>}
          {zoneDevisProjet(v) && <div style={{ fontSize: 12, color: TAUPE }}>Zone de livraison : {zoneDevisProjet(v).nom}</div>}

          {titre("Articles facturés — prix négociés pour tout le projet")}
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead><tr>{["Article", "Prix grille", "Prix négocié HT", "Remise %", "Prix net HT", ""].map((h) => (<th key={h} style={{ ...cell, textAlign: "left", fontSize: 10, color: TAUPE, textTransform: "uppercase" }}>{h}</th>))}</tr></thead>
            <tbody>
              {v.articles.map((x) => {
                const a = (articles || []).find((y) => y.id === x.articleId);
                const ref = prixReferenceArticle(a);
                const autresDP = v.articles.filter((y) => !estAutoDP(y));
                const rang = autresDP.findIndex((y) => y.articleId === x.articleId);
                const auto = x.articleId === v.articleLivraisonId ? "livraison — quantité calculée" : x.articleId === v.articleRDMId ? "RDM offert — 1 par cuisine" : "";
                return (
                  <tr key={x.articleId}>
                    <td style={cell}>{nomArt(x.articleId)}{auto && <span style={{ color: TAUPE }}> ({auto})</span>}</td>
                    <td style={{ ...cell, color: TAUPE }}>{ref === null ? "—" : formatDH(ref)}</td>
                    <td style={cell}><input type="number" step="0.01" className="sc-input" value={x.prix} onChange={(e) => majArticle(x.articleId, { prix: sansZeroTete(e.target.value) })} style={{ ...inputStyle(120), ...petit }} /></td>
                    <td style={cell}><input type="number" step="0.1" className="sc-input" value={x.remise} disabled={x.articleId === v.articleRDMId} onChange={(e) => majArticle(x.articleId, { remise: sansZeroTete(e.target.value) })} style={{ ...inputStyle(80), ...petit }} /></td>
                    <td style={cell}>{formatDH(k.net(x.articleId))}</td>
                    <td style={{ ...cell, whiteSpace: "nowrap" }}>{!auto && <><button type="button" className="sc-btn" disabled={rang <= 0} onClick={() => deplacerArticle(x.articleId, -1)} style={{ ...iconBtnStyle, opacity: rang <= 0 ? 0.3 : 1 }} title="Monter">↑</button><button type="button" className="sc-btn" disabled={rang >= autresDP.length - 1} onClick={() => deplacerArticle(x.articleId, 1)} style={{ ...iconBtnStyle, opacity: rang >= autresDP.length - 1 ? 0.3 : 1 }} title="Descendre">↓</button></>}{!auto && <button type="button" className="sc-btn" onClick={() => setV({ articles: v.articles.filter((y) => y.articleId !== x.articleId), typologies: v.typologies.map((t) => { const q = { ...(t.qtes || {}) }; delete q[x.articleId]; return { ...t, qtes: q }; }) })} style={iconBtnStyle} title="Retirer">✕</button>}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {(() => {
            const q = normLib(rechercheArticleDP.trim());
            const trouves = q ? dispo.filter((a) => normLib([a.code, a.designation, a.categorie].filter(Boolean).join(" ")).includes(q)) : dispo;
            return (
              <div style={{ display: "flex", gap: 6, marginTop: 6, flexWrap: "wrap" }}>
                <input className="sc-input" value={rechercheArticleDP} onChange={(e) => setRechercheArticleDP(e.target.value)} placeholder="Rechercher un article (code, désignation, catégorie)…" style={{ ...inputStyle(280), padding: "6px 8px", fontSize: 12 }} />
                <select className="sc-select" value="" onChange={(e) => { const a = (articles || []).find((y) => y.id === e.target.value); if (a) { setV({ articles: [...v.articles, { articleId: a.id, prix: prixReferenceArticle(a) || 0, remise: 0 }] }); setRechercheArticleDP(""); } }} style={{ ...selectStyle, flex: 1, minWidth: 240, fontSize: 12 }}>
                  <option value="">{q ? `+ Ajouter un article — ${trouves.length} trouvé(s)` : "+ Ajouter un article (tranche, évier, pose, façonnage…)"}</option>
                  {trouves.map((a) => (<option key={a.id} value={a.id}>{a.designation} — {a.categorie}</option>))}
                </select>
              </div>
            );
          })()}

          {titre("Pièces (colonnes de cotes)")}
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
            {(v.colonnes || []).map((c, i) => (
              <span key={c} style={{ background: PIERRE, borderRadius: 12, padding: "3px 10px", fontSize: 12 }}>
                <button type="button" className="sc-btn" disabled={i === 0} onClick={() => { const cs = [...v.colonnes]; [cs[i - 1], cs[i]] = [cs[i], cs[i - 1]]; setV({ colonnes: cs }); }} style={{ ...ghostBtnStyle, padding: "0 3px", fontSize: 11, opacity: i === 0 ? 0.3 : 1 }} title="Vers la gauche">←</button>
                {c}
                <button type="button" className="sc-btn" disabled={i === v.colonnes.length - 1} onClick={() => { const cs = [...v.colonnes]; [cs[i + 1], cs[i]] = [cs[i], cs[i + 1]]; setV({ colonnes: cs }); }} style={{ ...ghostBtnStyle, padding: "0 3px", fontSize: 11, opacity: i === v.colonnes.length - 1 ? 0.3 : 1 }} title="Vers la droite">→</button>
                <button type="button" className="sc-btn" onClick={async () => {
                  const nv = ((await demander("Nouveau nom de la colonne", { saisie: true, valeur: c })) || "").trim();
                  if (!nv || nv === c) return;
                  if (v.colonnes.includes(nv)) { setDevisProjetEdit({ ...devisProjetEdit, erreur: `La colonne « ${nv} » existe déjà.` }); return; }
                  setV({ colonnes: v.colonnes.map((y) => (y === c ? nv : y)), typologies: v.typologies.map((t) => { const pc = { ...(t.pieces || {}) }; if (c in pc) { pc[nv] = pc[c]; delete pc[c]; } return { ...t, pieces: pc }; }) });
                }} style={{ ...ghostBtnStyle, padding: "0 3px", fontSize: 11 }} title="Renommer">✎</button>
                <button type="button" className="sc-btn" onClick={() => setV({ colonnes: v.colonnes.filter((y) => y !== c) })} style={{ ...ghostBtnStyle, padding: "0 2px", fontSize: 11 }} title="Retirer la colonne">✕</button></span>
            ))}
            <input className="sc-input" placeholder="+ Colonne (ex. Joue de finition), Entrée" onKeyDown={(e) => { const val = e.target.value.trim(); if (e.key === "Enter" && val && !(v.colonnes || []).includes(val)) { setV({ colonnes: [...(v.colonnes || []), val] }); e.target.value = ""; } }} style={{ ...inputStyle(260), ...petit }} />
          </div>

          {titre("Typologies")}
          <div style={{ overflowX: "auto" }}>
            <table style={{ borderCollapse: "collapse", minWidth: "100%" }}>
              <thead><tr>
                {["Typologie", "Cuisines", "Code couleur", ...(v.colonnes || []), ...k.saisis.map((x) => `${nomArt(x.articleId)} / cuisine`), "Prix / cuisine HT", "Total HT", ""].map((h, i) => (<th key={`${h}-${i}`} style={{ ...cell, textAlign: "left", fontSize: 10, color: TAUPE, textTransform: "uppercase", whiteSpace: "nowrap" }}>{h}</th>))}
              </tr></thead>
              <tbody>
                {v.typologies.map((t) => {
                  const r = k.parTypo.find((y) => y.t.id === t.id) || { parCuisine: 0, total: 0 };
                  return (
                    <tr key={t.id}>
                      <td style={cell}><input className="sc-input" value={t.nom} onChange={(e) => majTypo(t.id, { nom: e.target.value })} placeholder="A1 A2" style={{ ...inputStyle(90), ...petit }} /></td>
                      <td style={cell}><input type="number" min="0" className="sc-input" value={t.nbCuisines} onChange={(e) => majTypo(t.id, { nbCuisines: e.target.value })} style={{ ...inputStyle(60), ...petit }} /></td>
                      <td style={cell}><input className="sc-input" value={t.codeCouleur || ""} placeholder={codeCouleurAuto(v, t) || "code"} title="Vide = Code Fournisseur des tranches de la typologie" onChange={(e) => majTypo(t.id, { codeCouleur: e.target.value })} style={{ ...inputStyle(110), ...petit }} /></td>
                      {(v.colonnes || []).map((c) => (<td key={c} style={cell}><input className="sc-input" value={(t.pieces || {})[c] || ""} onChange={(e) => majTypo(t.id, { pieces: { ...(t.pieces || {}), [c]: e.target.value } })} style={{ ...inputStyle(120), ...petit }} /></td>))}
                      {k.saisis.map((x) => (<td key={x.articleId} style={cell}><input type="number" min="0" step="0.01" className="sc-input" value={(t.qtes || {})[x.articleId] ?? ""} onChange={(e) => majTypo(t.id, { qtes: { ...(t.qtes || {}), [x.articleId]: e.target.value } })} style={{ ...inputStyle(70), ...petit }} /></td>))}
                      <td style={{ ...cell, whiteSpace: "nowrap" }}>{formatDH(r.parCuisine)}</td>
                      <td style={{ ...cell, whiteSpace: "nowrap", fontWeight: 600 }}>{formatDH(r.total)}</td>
                      <td style={cell}><button type="button" className="sc-btn" onClick={() => setV({ typologies: v.typologies.filter((y) => y.id !== t.id) })} style={iconBtnStyle} title="Retirer">✕</button></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <button type="button" className="sc-btn" onClick={() => setV({ typologies: [...v.typologies, { id: uid(), nom: "", nbCuisines: 1, pieces: {}, qtes: {} }] })} style={{ ...ghostBtnStyle, marginTop: 6 }}>+ Typologie</button>

          {titre("Texte libre (imprimé sur le devis client et le document interne)")}
          <textarea className="sc-input" value={v.texteLibre || ""} onChange={(e) => setV({ texteLibre: e.target.value })} rows={3} placeholder="Conditions, délais, précisions…" style={{ ...inputStyle("100%"), fontFamily: "inherit", resize: "vertical" }} />
          {titre("Récapitulatif")}
          <div style={{ display: "flex", gap: 28, flexWrap: "wrap", fontSize: 13 }}>
            <div>Cuisines : <strong>{k.nbCuisines}</strong></div>
            <div>Livraisons prévues : <strong>{k.nbLivraisons}</strong> {k.coutLivraisons !== null && <span style={{ color: TAUPE }}>(coût {formatDH(k.coutLivraisons)})</span>}</div>
            <div>Livraison facturée / cuisine : <strong>{formatDH(k.livParCuisine)}</strong></div>
            <div>Total HT : <strong>{formatDH(k.totalHT)}</strong></div>
            <div>Total TTC : <strong>{formatDH(k.totalTTC)}</strong></div>
          </div>
          <div style={{ fontSize: 13, marginTop: 6 }}>Budget tranches : {k.budgetsTranches.length ? k.budgetsTranches.map((b) => `${b.a.designation} ${Math.round(b.qte * 100) / 100}`).join(" · ") : <span style={{ color: TAUPE }}>aucune tranche</span>}</div>
          {devisProjetEdit.erreur && <div style={{ color: ROUILLE, fontSize: 13, fontWeight: 600, marginTop: 10 }}>{devisProjetEdit.erreur}</div>}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 16 }}>
            <button type="button" className="sc-btn" onClick={() => setDevisProjetEdit(null)} style={ghostBtnStyle}>Annuler</button>
            <button type="button" className="sc-btn" onClick={enregistrerDevisProjet} style={primaryBtnStyle}>Enregistrer V{v.version}</button>
          </div>
        </div>
      </Overlay>
    );
  }
  // ---------- ERP step 16 (Nils 12/10, lot 2) : projets immobiliers ----------
  const STATUTS_PROJET = ["en cours", "terminé"];
  // Montants de vente visibles : profils avec les Devis (ou l'état client) — pas Ahmed / bureau technique / pose.
  const montantsProjetVisibles = estGerant || !!user.acces.devis || peut("clients.etat");
  function projetVisible(ch) {
    return !!ch && clientVisiblePourUser(clientDe(ch.clientId));
  }
  function dossiersDuProjet(id) {
    return tousDossiers().filter((c) => chantierDuDossier(c) === id);
  }
  function devisDuProjet(id) {
    return (devisListe || []).filter((d) => d.chantierId === id);
  }
  function htDossierProjet(c) {
    if (c.avanceProjet) return Number((factureAvanceDe(c.id) || {}).ht) || 0;
    if (c.anterieure) return exoDossier(c) ? Number(c.ttcAnt) || 0 : (Number(c.ttcAnt) || 0) / 1.2;
    return htDossier(c);
  }
  function dossierEmisProjet(c) {
    return c.anterieure || (exoDossier(c) ? ["BL", "Facture"].includes(c.statut) : c.statut === "Facture");
  }
  function chiffresProjet(id) {
    const ds = dossiersDuProjet(id);
    // Nils 29/10 : la facture d'avance n'entre pas dans le CA du projet (remboursée sur les factures des dossiers).
    const facture = ds.filter((c) => dossierEmisProjet(c) && !c.avanceProjet);
    return {
      n: ds.length,
      caFacture: arrondiH(facture.reduce((n, c) => n + htDossierProjet(c), 0) - (avoirs || []).filter((a) => ds.some((c) => c.id === a.factureId)).reduce((n, a) => n + (Number(a.ht) || 0), 0)),
      resteDu: arrondiH(ds.reduce((n, c) => n + Math.max(0, totalDossierTTC(c) - encaisseDossier(c.id)), 0)),
    };
  }
  function distanceNoms(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 3;
    const dp = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
    for (let j = 1; j <= b.length; j++) dp[0][j] = j;
    for (let i = 1; i <= a.length; i++) for (let j = 1; j <= b.length; j++) dp[i][j] = Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1, dp[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    return dp[a.length][b.length];
  }
  // Projets au nom proche chez le même client (même nom, l'un contient l'autre, ou 2 lettres d'écart).
  function projetsProches(nom, clientId, exceptId) {
    const n = normLib(nom).replace(/[^a-z0-9]/g, "");
    if (!n) return [];
    return (chantiers || []).filter((x) => x.id !== exceptId && x.clientId === clientId).filter((x) => {
      const m = normLib(x.nom).replace(/[^a-z0-9]/g, "");
      return m === n || (m.length >= 4 && n.length >= 4 && (m.includes(n) || n.includes(m))) || distanceNoms(m, n) <= 2;
    });
  }
  function nouveauProjet() {
    return { id: null, nom: "", clientId: "", promoteur: "", architecte: "", adresse: "", commercialClient: "", contactSurPlace: "", telephoneSurPlace: "", contacts: [], dateDebut: "", dateFin: "", statut: "en cours", marche: { avancePct: "", retenuePct: String(RETENUE_DEFAUT), prorataPct: String(PRORATA_DEFAUT) } };
  }
  async function enregistrerProjet() {
    if (!estGerant || !projetEdit) return;
    const f = projetEdit;
    const nom = (f.nom || "").trim();
    if (!nom) { setProjetEdit({ ...f, erreur: "Indique le nom du projet." }); return; }
    if (!f.clientId) { setProjetEdit({ ...f, erreur: "Choisis le client facturé." }); return; }
    if (!(f.promoteur || "").trim()) { setProjetEdit({ ...f, erreur: "Indique le promoteur (même quand on vend au revendeur)." }); return; }
    if (f.dateDebut && f.dateFin && f.dateFin < f.dateDebut) { setProjetEdit({ ...f, erreur: "La date de fin prévue précède la date de début." }); return; }
    const avant = f.id ? (chantiers || []).find((x) => x.id === f.id) : null;
    if (avant && avant.clientId !== f.clientId && (devisDuProjet(f.id).length || dossiersDuProjet(f.id).length)) {
      setProjetEdit({ ...f, erreur: "Le client ne peut plus changer : le projet a déjà des devis ou des dossiers." });
      return;
    }
    if (!avant || normLib(avant.nom) !== normLib(nom) || avant.clientId !== f.clientId) {
      const proches = projetsProches(nom, f.clientId, f.id);
      if (proches.length && !(await demander(`Projet au nom proche chez ce client : ${proches.map((x) => `« ${x.nom} »`).join(", ")}. Enregistrer quand même ?`))) return;
    }
    const champs = { nom, clientId: f.clientId, promoteur: (f.promoteur || "").trim(), architecte: (f.architecte || "").trim(), adresse: (f.adresse || "").trim(), commercialClient: f.commercialClient || "", ...(() => {
      // Nils 02/11 : liste des contacts ; le premier reste aussi dans les anciens champs (compatibilité).
      const cs = (f.contacts || []).map((c) => ({ id: c.id && c.id !== "principal" ? c.id : uid(), nom: (c.nom || "").trim(), tel: (c.tel || "").trim(), batiments: c.batiments || [] })).filter((c) => c.nom || c.tel);
      return { contactsSurPlace: cs, contactSurPlace: cs[0] ? cs[0].nom : "", telephoneSurPlace: cs[0] ? cs[0].tel : "" };
    })(), dateDebut: f.dateDebut || "", dateFin: f.dateFin || "", statut: STATUTS_PROJET.includes(f.statut) ? f.statut : "en cours" };
    // Nils 29/10 : conditions du marché (avance, retenue de garantie, compte prorata) ; avances d'avant l'ERP gardées.
    {
      const m = f.marche || {};
      const tx = (v) => String(v ?? "").trim().replace(",", ".");
      const bad = ["avancePct", "retenuePct", "prorataPct"].find((k) => tx(m[k]) !== "" && !(Number(tx(m[k])) >= 0 && Number(tx(m[k])) < 100));
      if (bad) { setProjetEdit({ ...f, erreur: "Taux du marché invalide (entre 0 et 100 %)." }); return; }
      champs.marche = { ...((avant && avant.marche) || {}), avancePct: tx(m.avancePct), retenuePct: tx(m.retenuePct), prorataPct: tx(m.prorataPct) };
      const ancien = conditionsMarche(avant), nouveau = conditionsMarche({ marche: champs.marche });
      if (avant && JSON.stringify(ancien) !== JSON.stringify(nouveau)) await tracerAcces("conditions du marché modifiées", `${nom} — avance ${champs.marche.avancePct || 0} %, retenue ${champs.marche.retenuePct || 0} %, prorata ${champs.marche.prorataPct || 0} %`);
    }
    if (avant) {
      await persistChantiers((chantiers || []).map((x) => (x.id === avant.id ? { ...x, ...champs, modifiePar: user.nom, modifieLe: new Date().toISOString() } : x)));
      await tracerAcces("projet modifié", nom);
      setProjetOuvert(avant.id);
    } else {
      const id = uid();
      await persistChantiers([...(chantiers || []), { id, ...champs, creePar: user.nom, creeLe: new Date().toISOString() }]);
      await tracerAcces("projet créé", nom);
      setProjetOuvert(id);
    }
    setProjetEdit(null);
  }
  async function supprimerProjet(ch) {
    if (!estGerant || !ch) return;
    const nd = devisDuProjet(ch.id).length, nc = dossiersDuProjet(ch.id).length;
    if (nd || nc) { setNotice(`Impossible de supprimer « ${ch.nom} » : ${nd} devis et ${nc} dossier(s) y sont rattachés.`); return; }
    if (!(await demander(`Supprimer le projet « ${ch.nom} » ?`, { danger: true }))) return;
    await persistChantiers((chantiers || []).filter((x) => x.id !== ch.id));
    await tracerAcces("projet supprimé", ch.nom);
    setProjetOuvert(null);
  }
  async function persistChantiers(next) {
    setChantiers(next);
    return await saveKey(CHANTIERS_KEY, next);
  }
  async function persistPrixGroupesTranche(next) {
    setPrixGroupesTranche(next);
    return await saveKey(PRIX_GROUPES_TRANCHE_KEY, next);
  }
  async function persistPrixGroupesTranche2eChoix(next) {
    setPrixGroupesTranche2eChoix(next);
    return await saveKey(PRIX_GROUPES_TRANCHE_2E_CHOIX_KEY, next);
  }
  // Applique la grille tarifaire officielle 2026 (tarif public, émise le
  // 13 septembre 2026) par-dessus les prix déjà enregistrés — ne touche que
  // les combinaisons Grès Cérame 6mm/12mm couvertes par cette grille,
  // laisse le reste (Quartz, autres épaisseurs) tel quel.
  async function chargerGrilleOfficielle2026() {
    const next1er = { ...prixGroupesTranche };
    Object.entries(GRILLE_OFFICIELLE_2026_1ER_CHOIX).forEach(([cle, prix]) => {
      next1er[cle] = { ...next1er[cle], ...prix };
    });
    await persistPrixGroupesTranche(next1er);
    const next2e = { ...prixGroupesTranche2eChoix };
    Object.entries(GRILLE_OFFICIELLE_2026_2E_CHOIX).forEach(([cle, prix]) => {
      next2e[cle] = { ...next2e[cle], ...prix };
    });
    await persistPrixGroupesTranche2eChoix(next2e);
    setNotice("Grille tarifaire officielle 2026 appliquée (Grès Cérame 6mm/12mm, 1er et 2e choix).");
  }
  async function persistCategoriesArticles(next) {
    setCategoriesArticles(next);
    return await saveKey(CATEGORIES_ARTICLES_KEY, next);
  }
  async function persistUnitesArticles(next) {
    setUnitesArticles(next);
    return await saveKey(UNITES_ARTICLES_KEY, next);
  }
  async function persistMatieres(next) {
    appliquerMatieres(next);
    setMatieresPerso(next);
    return await saveKey(MATIERES_KEY, next);
  }
  async function persistFinitionsArticles(next) {
    const liste = normaliserFinitions(next);
    appliquerFinitions(liste);
    setFinitionsArticles(liste);
    return await saveKey(FINITIONS_ARTICLES_KEY, liste);
  }
  async function persistGroupesCouleurArticles(next) {
    setGroupesCouleurArticles(next);
    return await saveKey(GROUPES_COULEUR_ARTICLES_KEY, next);
  }

  async function persistApporteursAffaire(next) {
    setApporteursAffaire(next);
    return await saveKey(APPORTEURS_AFFAIRE_KEY, next);
  }

  async function persistPoseurs(next) {
    derniersStaffRef.current.valeurs = { ...(derniersStaffRef.current.valeurs || {}), poseurs: next };
    setPoseurs(next);
    return await saveKey(POSEURS_KEY, next);
  }


  // Step 12 pt.11 (accord Nils du 21/09) : clients triés par ordre alphabétique
  // — utilisé partout, y compris dans les menus déroulants (ex. devis).
  const clientsActifs = trierAlpha(clients || [], "nom");
  const articlesActifs = (articles || []).filter((a) => a.actif);

  // "Transformé en BDC" a son propre statut directement filtrable — pas la
  // peine de le dupliquer sous "Archivés" en plus. Il reste néanmoins exclu
  // de "Tous" (la vue de travail active), au même titre qu'"Archivé".
  function estHorsVueActive(d) {
    return d.statut === "Archivé" || d.statut === "Transformé en BDC" || (commandesListe || []).some((c) => c.devisId === d.id);
  }
  // "Archivés" ne regroupe plus que les devis au statut Archivé — un devis
  // transformé en BDC se retrouve via son propre filtre de statut, pas ici.
  // "Archivé" couvre aussi bien un devis refusé par le client qu'une
  // variante devenue inutile (doublon écarté au profit d'une autre) — pas
  // besoin de préciser la raison.
  function estArchiveDevis(d) {
    return d.statut === "Archivé";
  }
  const devisFiltres = useMemo(() => {
    if (!devisListe) return [];
    const q = devisQuery.trim().toLowerCase();
    return devisListe
      .filter((d) => {
        if (!user.devisRestreintACommercial) return true;
        return d.commercialSC === user.nom;
      })
      .filter((d) => {
        if (filterStatut === "Archivés") return estArchiveDevis(d);
        if (filterStatut === "Tous") return !estHorsVueActive(d);
        return d.statut === filterStatut;
      })
      .filter((d) => {
        if (!q) return true;
        const client = clientsActifs.find((c) => c.id === d.clientId);
        return (
          d.numero.toLowerCase().includes(q) ||
          (d.reference || "").toLowerCase().includes(q) ||
          (client && client.nom.toLowerCase().includes(q))
        );
      })
      .sort((x, y) => (x.date < y.date ? 1 : -1));
  }, [devisListe, devisQuery, filterStatut, clients, commandesListe, user]);

  // Un devis Confirmé mais sans dossier BDC lié est un oubli potentiel — les
  // deux actions sont volontairement découplées (voir transformerEnBDC), donc
  // rien n'empêche ce cas, d'où le besoin de le signaler.
  function estConfirmeSansBDC(d) {
    return d.statut === "Confirmé" && !(commandesListe || []).some((c) => c.devisId === d.id);
  }
  const devisConfirmesSansBDC = useMemo(() => {
    if (!devisListe) return [];
    return devisListe.filter(estConfirmeSansBDC);
  }, [devisListe, commandesListe]);

  const commandesFiltrees = useMemo(() => {
    if (!commandesListe) return [];
    return commandesListe
      // Nils 01/11 : dossiers SAV archivés seulement dans le filtre « Archivés ».
      .filter((c) => (commandeFiltreStatut === EA_ARCHIVE ? dossierArchive(c) : !dossierArchive(c) && (commandeFiltreStatut === "Toutes" || c.statut === commandeFiltreStatut)))
      .filter((c) => {
        if (!user.commandesRestreintACommercial) return true;
        const devisOrigine = (devisListe || []).find((d) => d.id === c.devisId);
        return devisOrigine && devisOrigine.commercialSC === user.nom;
      })
      .filter((c) => correspondRechercheDossier(c, commandeRecherche))
      .sort((x, y) => (x.creeLe < y.creeLe ? 1 : -1));
    // correspondRechercheDossier ne lit que des données déjà listées ici.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commandesListe, commandeFiltreStatut, commandeRecherche, devisListe, clients, articles, chantiers, user]);
  function correspondRechercheDossier(c, q) {
    const mots = normLib(q).split(" ").filter(Boolean);
    if (!mots.length) return true;
    const d = (devisListe || []).find((x) => x.id === c.devisId);
    const textes = [c.numero, c.numeroRDM, c.numeroPL, c.numeroBL, c.numeroFacture, c.reference, d && d.numero, d && d.reference, (clientDe(c.clientId) || {}).nom, nomProjetDe(chantierDuDossier(c))];
    lignesDuDossier(c).forEach((l) => {
      const a = l.articleId ? (articles || []).find((x) => x.id === l.articleId) : null;
      textes.push(l.designation, a && a.designation, a && a.code, a && a.couleurFournisseur, a && a.matiere);
    });
    const tout = normLib(textes.filter(Boolean).join(" "));
    return mots.every((m) => tout.includes(m));
  }

  // Documents de remplacement affichés dans la liste des dossiers (Nils 03/10).
  const remplacementsFiltres = (remplacements || [])
    .filter((r) => commandeFiltreStatut === "Toutes" || commandeFiltreStatut === r.type)
    .filter((r) => !user.commandesRestreintACommercial)
    .filter((r) => !(user.commandesSansBDCFacture && r.type === "Facture"))
    .filter((r) => { const mots = normLib(commandeRecherche).split(" ").filter(Boolean); const tout = normLib([r.numero, r.designation, (clientDe(r.clientId) || {}).nom].filter(Boolean).join(" ")); return mots.every((m) => tout.includes(m)); });
  const kpiTotalConfirmes = useMemo(() => {
    return (devisListe || [])
      .filter((d) => d.statut === "Confirmé" || d.statut === "Transformé en BDC")
      .reduce((s, d) => s + calcTotaux(d).totalTTC, 0);
  }, [devisListe]);

  // ---------- Devis : ouverture / création ----------
  function ouvrirDevis(id) {
    const d = devisListe.find((x) => x.id === id);
    if (!d) return;
    if (user.devisRestreintACommercial && d.commercialSC !== user.nom) return;
    const copie = JSON.parse(JSON.stringify(d));
    // Rattrapage pour les devis ouverts avant l'ajout de ce champ (ou dont le
    // client a été choisi avant que sa fiche ait un commercial attitré) :
    // on ne pré-remplit que si le champ est encore vide, jamais en écrasant
    // un choix déjà fait sur ce devis.
    if (!copie.commercialSC && copie.clientId) {
      const c = clientsActifs.find((x) => x.id === copie.clientId);
      if (c && c.commercialSC) copie.commercialSC = c.commercialSC;
    }
    if (!copie.apporteurAffaire && copie.clientId) {
      const c = clientsActifs.find((x) => x.id === copie.clientId);
      if (c && c.apporteurAffaire) copie.apporteurAffaire = c.apporteurAffaire;
    }
    setDraft(copie);
    setOpenId(id);
    setDraftError("");
  }

  function nouveauDevis() {
    // Le numéro n'est plus attribué ici : un brouillon peut rester ouvert
    // longtemps (le temps de discuter avec un client) sans réserver un
    // numéro pendant tout ce temps — il est calculé à l'enregistrement réel
    // (enregistrerDevis / transformerEnBDC), au plus près de l'écriture.
    const nouveau = {
      id: uid(),
      numero: "",
      reference: "",
      etage: "", // ERP step 10 : obligatoire pour transformer en BDC
      date: today(),
      clientId: "",
      chantierId: "",
      commercialSC: "",
      apporteurAffaire: "",
      commercialClient: "",
      statut: "Brouillon",
      conditionsPaiement: "",
      remiseGlobale: 0,
      exonereTVA: false,
      adresseLivraison: "",
      poseurMeuble: "",
      contactSurPlace: "",
      telephoneSurPlace: "", // ERP step 10
      plaquesCuisson: [],
      eviers: [],
      reservationVidangeAutomatique: false,
      reservationVidangeAutomatiqueDiametre: "",
      reservationOsmoseur: false,
      reservationOsmoseurDiametre: "",
      laveVaisselle: null,
      laveVaisselleType: "",
      laveLinge: null,
      laveLingeType: "",
      porteCuisine: null,
      porteCuisineType: "",
      porteCuisineDebord: "",
      jambage: false,
      jambageType: "",
      socle: "",
      lignes: [],
      notes: [],
      creePar: user.nom,
      creeLe: new Date().toISOString(),
      modifiePar: user.nom,
      modifieLe: new Date().toISOString(),
    };
    setDraft(nouveau);
    setOpenId("__new__");
    setDraftError("");
  }

  // Duplique un devis existant : nouveau numéro, statut remis à Brouillon,
  // date du jour, lignes recopiées avec de nouveaux id. Ouvre directement le
  // duplicata dans l'éditeur, pas encore enregistré tant qu'on ne valide pas.
  function dupliquerDevis(id) {
    const d = devisListe.find((x) => x.id === id);
    if (!d) return;
    const copie = JSON.parse(JSON.stringify(d));
    copie.id = uid();
    // ERP step 16 (lot 4a) : un duplicata n'est rattaché à aucun logement de projet.
    delete copie.logementId; delete copie.projetTypologieId; delete copie.signatureTypologie; delete copie.devisProjetVersion;
    // Même principe que pour un nouveau devis : pas de numéro tant que la
    // copie n'est pas réellement enregistrée.
    copie.numero = "";
    copie.statut = "Brouillon";
    copie.date = today();
    // ERP step 13 (ah1) : une copie d'un devis du même client ne compte pas comme « devis émis ».
    copie.dupliqueDe = d.numero;
    copie.dupliqueDeClient = d.clientId;
    copie.creePar = user.nom;
    copie.creeLe = new Date().toISOString();
    copie.modifiePar = user.nom;
    copie.modifieLe = new Date().toISOString();
    copie.lignes = (copie.lignes || []).map((l) => ({ ...l, id: uid() }));
    setDraft(copie);
    setOpenId("__new__");
    setDraftError("");
    setNotice(`Devis ${d.numero} dupliqué — vérifie puis enregistre pour obtenir un nouveau numéro.`);
  }

  function fermerFiche() {
    setEnteteNilsDevisId(null);
    setOpenId(null);
    setDraft(null);
    setDraftError("");
    setShowLigneLibre(false);
    setLigneQuery("");
  }

  // Génère le devis en document HTML autonome et le propose au téléchargement.
  // window.print() et window.open() (fenêtre séparée) sont tous les deux
  // bloqués dans le sandbox de l'app Claude Desktop — le téléchargement de
  // fichier est une fonction plus basique, avec de meilleures chances de
  // passer. Le fichier s'ouvre ensuite dans un vrai navigateur, où Ctrl+P /
  // « Enregistrer en PDF » fonctionne normalement, hors de toute contrainte
  // liée à l'artefact.
  // Construit le document HTML (devis ou bon de commande — contenu identique,
  // seuls le titre et le numéro affiché changent) à partir d'un objet devis.
  // parBL (Nils 17/10, facture groupée) : tableau réduit à N° BL, désignation, montant HT.
  function construireHtmlDocument(devisSource, { titre, numeroAffiche, masquerFinance, elementsSupplementaires, nombreColis, avecSignatures, dateDocument, parBL, deductions, mention }) {
    // Notes de page du devis (« Mention à afficher en bas du devis ») : sur le devis et le BC (même document).
    const notesDoc = /^(DEVIS|BON DE COMMANDE|FACTURE D'AVOIR)/i.test(String(titre || "")) ? (devisSource.notes || []).map((n) => String(n || "").trim()).filter(Boolean) : [];
    const notesDocHtml = notesDoc.length ? `<div style="margin-top:18px;font-size:10.5px;line-height:1.5;page-break-inside:avoid;">${notesDoc.map((n) => `<div>${escapeHtml(n)}</div>`).join("")}</div>` : "";
    const client = clientsActifs.find((x) => x.id === devisSource.clientId);
    const projetDoc = nomProjetDe(devisSource.chantierId); // Nils 03/10 : le projet entre Référence et Date
    const t = calcTotaux(devisSource);
    // Nils 29/10 : devis et BC d'un projet — estimation des déductions (avance, retenue, prorata).
    const estimation = !deductions && /^(DEVIS|BON DE COMMANDE)$/i.test(String(titre || "")) ? deductionsDevis(devisSource) : null;
    if (estimation) deductions = estimation;
    const codeDe = (l) => {
      if (!l.articleId) return "";
      const art = (articles || []).find((a) => a.id === l.articleId);
      return art ? art.code : "";
    };
    const elementsTechniquesHtml = (elementsSupplementaires || [])
      .map((texte) => `<div style="padding:6px 0;border-bottom:1px solid #ddd;">${escapeHtml(texte)}</div>`)
      .join("");
    const descriptifHtml = devisSource.lignes
      .filter((l) => l.type === "descriptif")
      .map((l) => `<div style="padding:3px 0;font-style:italic;">${escapeHtml(l.designation)}</div>`)
      .join("");
    // Nils 02/11 : la déduction d'un acompte d'avant l'ERP n'apparaît que sur les documents chiffrés.
    const lignesArr = devisSource.lignes.filter((l) => l.type !== "descriptif" && !(masquerFinance && l.deductionAcompte));
    const lignesHtml = lignesArr
      .map((l, i) => {
        const { prixRevise, montantHT } = calcLigne(l);
        const isLast = i === lignesArr.length - 1;
        const brBL = isLast ? "border-bottom-left-radius:8px;" : "";
        const brBR = isLast ? "border-bottom-right-radius:8px;" : "";
        if (parBL) return `<tr>
          <td style="border:1px solid #999;padding:5px 8px;white-space:nowrap;${brBL}">${escapeHtml(l.numeroBL || "")}</td>
          <td style="border:1px solid #999;padding:5px 8px;">${escapeHtml(l.designation)}</td>
          <td style="border:1px solid #999;padding:5px 8px;text-align:right;${brBR}">${fmtMAD(montantHT)}</td>
        </tr>`;
        const colonnesFinance = masquerFinance ? "" : `
          <td style="border:1px solid #999;padding:5px 8px;text-align:right;">${fmtMAD(l.prixPublic)}</td>
          <td style="border:1px solid #999;padding:5px 8px;text-align:right;">${Number(l.remise) || 0}%</td>
          <td style="border:1px solid #999;padding:5px 8px;text-align:right;">${fmtMAD(prixRevise)}</td>`;
        return `<tr>
          <td style="border:1px solid #999;padding:5px 8px;${brBL}">${escapeHtml(codeDe(l))}</td>
          <td style="border:1px solid #999;padding:5px 8px;">${escapeHtml(l.designation)}${l.chute ? ` — chute ${escapeHtml(String(l.chuteDimensions || ""))} cm` : ""}${l.bookmatch ? `<br><span style="font-size:10px;font-weight:600;">Book-match — A × ${escapeHtml(String(l.qteA ?? ""))} / B × ${escapeHtml(String(l.qteB ?? ""))}</span>` : ""}</td>
          <td style="border:1px solid #999;padding:5px 8px;text-align:right;">${escapeHtml(l.qte)}</td>
          <td style="border:1px solid #999;padding:5px 8px;${masquerFinance ? brBR : ""}">${escapeHtml(l.unite)}</td>${colonnesFinance}${masquerFinance ? "" : `
          <td style="border:1px solid #999;padding:5px 8px;text-align:right;${brBR}">${fmtMAD(montantHT)}</td>`}
        </tr>`;
      })
      .join("");

    return `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="UTF-8" />
<title>${escapeHtml(titre)} ${escapeHtml(numeroAffiche)}</title>
<style>
  * { box-sizing: border-box; }
  body { font-family: Arial, Helvetica, sans-serif; color: #000; font-size: 11px; line-height: 1.5; margin: 0; padding: 0; }
  table { border-collapse: collapse; }
  table.items { width: 100%; }
  @page {
    size: A4 portrait;
    margin: 1.3cm;
    @bottom-right {
      content: "Page " counter(page);
      font-family: Arial, Helvetica, sans-serif;
      font-size: 9px;
      color: #000;
    }
  }
  .doc-header { position: fixed; top: 0; left: 0; right: 0; background: #fff; padding-bottom: 10px; border-bottom: 1px solid #ccc; }
  .doc-footer { position: fixed; bottom: 0; left: 0; right: 0; background: #fff; text-align: center; border-top: 1px solid #999; padding-top: 8px; font-size: 9px; }
  /* Nils 28/10 : en-tête et pied fixes répétés sur chaque page ; la place est réservée sur CHAQUE page
     par l'en-tête et le pied d'un tableau de mise en page (répétés par le navigateur à l'impression),
     sinon le contenu de la page 2 passait sous l'en-tête blanc (page « vide », totaux cachés). */
  table.mise-en-page { width: 100%; border-collapse: collapse; }
  table.mise-en-page > thead > tr > td, table.mise-en-page > tfoot > tr > td, table.mise-en-page > tbody > tr > td { padding: 0; }
  .esp-haut { height: 165px; }
  .esp-bas { height: 100px; }
  main, .elements-techniques { padding: 0 4px; }
</style>
</head>
<body>
  <div class="doc-header">
    <div style="text-align:center;margin-bottom:10px;">
      <img src="${LOGO_SRC}" alt="Stone Concept" style="height:50px;" />
    </div>
    <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:20px;">
      <div>
        <div style="font-size:16px;font-weight:700;margin-bottom:6px;">${escapeHtml(titre)}</div>
        <table style="border-collapse:separate;border-spacing:0;">
          <tr>
            <th style="border:1px solid #999;padding:4px 10px;font-size:9px;border-top-left-radius:8px;">Numéro</th>
            <th style="border:1px solid #999;padding:4px 10px;font-size:9px;">Référence</th>${projetDoc ? `
            <th style="border:1px solid #999;padding:4px 10px;font-size:9px;">Projet</th>` : ""}
            <th style="border:1px solid #999;padding:4px 10px;font-size:9px;border-top-right-radius:8px;">Date</th>
          </tr>
          <tr>
            <td style="border:1px solid #999;padding:4px 10px;font-weight:700;border-bottom-left-radius:8px;">${escapeHtml(numeroAffiche)}</td>
            <td style="border:1px solid #999;padding:4px 10px;">${escapeHtml(devisSource.reference || "")}</td>${projetDoc ? `
            <td style="border:1px solid #999;padding:4px 10px;">${escapeHtml(projetDoc)}</td>` : ""}
            <td style="border:1px solid #999;padding:4px 10px;border-bottom-right-radius:8px;">${escapeHtml(formatDate(dateDocument || devisSource.date))}</td>
          </tr>
        </table>
      </div>
      <div style="border:1px solid #999;border-radius:8px;padding:6px 14px;min-width:200px;">
        <div style="font-weight:700;">${client ? escapeHtml(client.raisonSociale || client.nom) : "—"}</div>
        ${client && client.ice ? `<div>ICE ${escapeHtml(client.ice)}</div>` : ""}
        ${client && client.ville ? `<div>${escapeHtml(client.ville)}</div>` : ""}
      </div>
    </div>
  </div>

  <table class="mise-en-page">
  <thead><tr><td><div class="esp-haut"></div></td></tr></thead>
  <tfoot><tr><td><div class="esp-bas"></div></td></tr></tfoot>
  <tbody><tr><td>
  <main>
    ${(devisSource.commercialSC || devisSource.commercialClient) ? `<div style="margin-bottom:16px;font-size:10px;color:#555;">
      ${devisSource.commercialSC ? `Commercial Stone Concept : ${escapeHtml(devisSource.commercialSC)}` : ""}${devisSource.commercialSC && devisSource.commercialClient ? " · " : ""}${devisSource.commercialClient ? `Commercial client : ${escapeHtml(devisSource.commercialClient)}` : ""}
    </div>` : ""}

    ${descriptifHtml ? `<div style="border:1px solid #999;border-radius:8px;padding:10px 14px;margin-bottom:16px;"><div style="font-weight:700;margin-bottom:6px;">Description des morceaux</div>${descriptifHtml}</div>` : ""}

    <table class="items" style="border-collapse:separate;border-spacing:0;">
      <thead>${parBL ? `
        <tr>
          <th style="border:1px solid #999;padding:6px 8px;text-align:left;border-top-left-radius:8px;">N° BL</th>
          <th style="border:1px solid #999;padding:6px 8px;text-align:left;">Désignation</th>
          <th style="border:1px solid #999;padding:6px 8px;text-align:right;border-top-right-radius:8px;">Montant HT</th>
        </tr>` : `
        <tr>
          <th style="border:1px solid #999;padding:6px 8px;text-align:left;border-top-left-radius:8px;${lignesArr.length === 0 ? "border-bottom-left-radius:8px;" : ""}">Code</th>
          <th style="border:1px solid #999;padding:6px 8px;text-align:left;">Désignation</th>
          <th style="border:1px solid #999;padding:6px 8px;text-align:right;">Qté</th>
          <th style="border:1px solid #999;padding:6px 8px;text-align:left;${masquerFinance ? "border-top-right-radius:8px;" + (lignesArr.length === 0 ? "border-bottom-right-radius:8px;" : "") : ""}">Unité</th>
          ${masquerFinance ? "" : `<th style="border:1px solid #999;padding:6px 8px;text-align:right;">P.U.HT</th>
          <th style="border:1px solid #999;padding:6px 8px;text-align:right;">Remise</th>
          <th style="border:1px solid #999;padding:6px 8px;text-align:right;">P.U.rev</th>
          <th style="border:1px solid #999;padding:6px 8px;text-align:right;border-top-right-radius:8px;${lignesArr.length === 0 ? "border-bottom-right-radius:8px;" : ""}">Montant HT</th>`}
        </tr>`}
      </thead>
      <tbody>${lignesHtml}</tbody>
    </table>

    ${masquerFinance ? `<div style="margin-top:20px;">
      <div><strong>Adresse de livraison :</strong> ${escapeHtml(devisSource.adresseLivraison || "")}${devisSource.etage ? ` — <strong>Étage :</strong> ${escapeHtml(devisSource.etage)}` : ""}</div>
      ${devisSource.contactSurPlace || devisSource.telephoneSurPlace ? `<div style="margin-top:6px;"><strong>Contact sur place :</strong> ${escapeHtml([devisSource.contactSurPlace, devisSource.telephoneSurPlace].filter((x) => (x || "").trim()).join(" — "))}</div>` : ""}
      ${nombreColis ? `<div style="margin-top:6px;"><strong>Nombre de colis :</strong> ${escapeHtml(nombreColis)}</div>` : ""}
    </div>` : `<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-top:20px;">
      <div>
        <div><strong>Conditions de paiement :</strong> ${escapeHtml(devisSource.conditionsPaiement || "")}</div>
        <div style="margin-top:6px;"><strong>Adresse de livraison :</strong> ${escapeHtml(devisSource.adresseLivraison || "")}${devisSource.etage ? ` — <strong>Étage :</strong> ${escapeHtml(devisSource.etage)}` : ""}</div>
        ${devisSource.contactSurPlace || devisSource.telephoneSurPlace ? `<div style="margin-top:6px;"><strong>Contact sur place :</strong> ${escapeHtml([devisSource.contactSurPlace, devisSource.telephoneSurPlace].filter((x) => (x || "").trim()).join(" — "))}</div>` : ""}
        ${devisSource.exonereTVA ? `<div style="margin-top:12px;font-size:11px;">${escapeHtml(devisSource.mentionExonerationTVA || "Exonéré de la TVA.")}</div>` : ""}
      </div>
      ${deductions ? (() => {
        // Nils 29/10 : facture d'un dossier de projet immobilier — avance, retenue, prorata.
        const p = (x) => String(x).replace(".", ",");
        const l = (lib, v, fort) => `<tr><td style="border:1px solid #999;padding:4px 12px;${fort ? "font-weight:700;" : ""}">${lib}</td><td style="border:1px solid #999;padding:4px 12px;text-align:right;white-space:nowrap;${fort ? "font-weight:700;" : ""}">${v}</td></tr>`;
        return `<table style="border-collapse:collapse;min-width:330px;">
          ${estimation ? `<tr><td colspan="2" style="padding:0 0 4px;font-size:10px;">Estimation — avance, retenue et prorata du projet, calculés à la facturation</td></tr>` : ""}
          ${l(deductions.libelleHT || "Total HT des travaux", fmtMAD(deductions.htTravaux), !(deductions.avance || deductions.retenue))}
          ${deductions.avance ? l(`− Remboursement de l'avance (${p(deductions.avancePct)} %)`, `− ${fmtMAD(deductions.avance)}`) : ""}
          ${deductions.retenue ? l(`− Retenue de garantie (${p(deductions.retenuePct)} %)`, `− ${fmtMAD(deductions.retenue)}`) : ""}
          ${deductions.prorataAvantTVA && deductions.prorata ? l(`− Compte prorata (${p(deductions.prorataPct)} %)`, `− ${fmtMAD(deductions.prorata)}`) : ""}
          ${deductions.avance || deductions.retenue || (deductions.prorataAvantTVA && deductions.prorata) ? l("Total HT net", fmtMAD(deductions.htNet), true) : ""}
          ${l(devisSource.exonereTVA ? "TVA (exonérée)" : `TVA ${p(Math.round((deductions.tauxTVA || 0) * 100))} %`, fmtMAD(deductions.tva))}
          ${l("Total TTC", fmtMAD(deductions.ttc), true)}
          ${deductions.prorata && !deductions.prorataAvantTVA ? l(`− Compte prorata (${p(deductions.prorataPct)} % du HT${deductions.avance || deductions.retenue ? " net" : ""})`, `− ${fmtMAD(deductions.prorata)}`) : ""}
          ${l(estimation ? "Net à payer (estimation)" : "Net à payer", fmtMAD(deductions.net), true)}
        </table>`;
      })() : `<table style="border-collapse:separate;border-spacing:0;">
        <tr>
          <th style="border:1px solid #999;padding:5px 12px;border-top-left-radius:8px;">Total HT</th>
          <th style="border:1px solid #999;padding:5px 12px;text-align:center;">${devisSource.exonereTVA ? "TVA (exonérée)" : "Total TVA"}</th>
          <th style="border:1px solid #999;padding:5px 12px;border-top-right-radius:8px;">Total TTC</th>
        </tr>
        <tr>
          <td style="border:1px solid #999;padding:5px 12px;border-bottom-left-radius:8px;">${fmtMAD(t.totalHT)}</td>
          <td style="border:1px solid #999;padding:5px 12px;text-align:center;">${fmtMAD(t.totalTVA)}</td>
          <td style="border:1px solid #999;padding:5px 12px;font-weight:700;border-bottom-right-radius:8px;">${fmtMAD(t.totalTTC)}</td>
        </tr>
      </table>`}
    </div>`}
    ${!masquerFinance && /^FACTURE/i.test(String(titre || "")) ? `<div style="margin-top:14px;font-size:11px;page-break-inside:avoid;">${escapeHtml(phraseArretee({ montant: deductions ? deductions.net : t.totalTTC, avoir: /AVOIR/i.test(String(titre)), exonere: !!devisSource.exonereTVA }))}</div>` : ""}

    ${notesDocHtml}
    ${mention ? `<div style="margin-top:18px;padding:8px 12px;border:1px solid #000;font-size:11px;font-weight:700;page-break-inside:avoid;">${escapeHtml(mention)}</div>` : ""}
    ${avecSignatures ? `<div style="display:flex;justify-content:space-between;margin-top:60px;">
      <div style="width:45%;">
        <div style="height:60px;"></div>
        <div style="border-top:1px solid #000;padding-top:4px;font-size:11px;">Signature du transporteur</div>
      </div>
      <div style="width:45%;">
        <div style="height:60px;"></div>
        <div style="border-top:1px solid #000;padding-top:4px;font-size:11px;text-align:right;">Signature et cachet du destinataire</div>
      </div>
    </div>` : ""}
  </main>
  </td></tr>
  ${elementsTechniquesHtml ? `<tr style="page-break-before: always; break-before: page;"><td><div class="elements-techniques">
    <div style="font-size:20px;font-weight:700;margin-bottom:20px;">ÉLÉMENTS TECHNIQUES</div>
    <div>${elementsTechniquesHtml}</div>
  </div></td></tr>` : ""}
  </tbody>
  </table>

  <div class="doc-footer">
    Stone Concept Sarl Patente 45193146 IF 06527382 ICE 000073605 0000 01 RC 54585<br/>
    Commune rurale de Soualem, douar Lakhlayf<br/>
    Hot Line: 06 61 26 49 31 commandes: sales@stoneconcept.ma<br/>
    <br/>
    <strong>RIB : 050 450 007 0107 797 362 001 60 / CODE SWIFT : CAFGMAMC / CFG BANK</strong>
  </div>
</body>
</html>`;
  }

  // Télécharge un document HTML déjà construit (devis ou BC).
  function nomProjetDe(chantierId) {
    return chantierId ? ((chantiers || []).find((c) => c.id === chantierId) || {}).nom || "" : "";
  }
  async function telechargerDocument(html, nomFichier, libelleNotice) {
    try {
      // Le navigateur nomme le PDF (Ctrl+P → Enregistrer en PDF) d'après le
      // <title> de la page : on y met le même nom que le fichier.
      html = String(html).replace(/<title>[\s\S]*?<\/title>/i, `<title>${escapeHtml(nomFichier)}</title>`);
      const ok = await proposerTelechargement(`${nomFichier}.html`, html);
      if (!ok) return;
      setNotice(`Fichier ${nomFichier}.html téléchargé. Ouvre-le avec ton navigateur habituel (double-clic, ou clic droit → Ouvrir avec → Chrome/Edge), puis Ctrl+P → « Enregistrer en PDF ».`);
    } catch (e) {
      setNotice("Échec du téléchargement — voir la console pour le détail.");
      console.error(`Erreur téléchargement ${libelleNotice}`, e);
    }
  }

  function imprimerDevis() {
    if (!draft) return;
    if (!draft.numero) {
      setNotice("Enregistre le devis avant de l'imprimer — le numéro n'est attribué qu'à l'enregistrement.");
      return;
    }
    const html = construireHtmlDocument(draft, { titre: "DEVIS", numeroAffiche: draft.numero, elementsSupplementaires: elementsDescriptifsTechniques(draft) });
    telechargerDocument(html, nomFichierDocument(draft.numero, (clientDe(draft.clientId) || {}).nom, nomProjetDe(draft.chantierId), draft.reference), "devis");
  }

  // Le BC est exactement le même document que le devis d'origine — seuls le
  // titre ("BON DE COMMANDE" au lieu de "DEVIS") et le numéro affiché (celui
  // du BC) changent. Le contenu (lignes, totaux, client…) vient du devis lié.

  // Reprend les éléments techniques (plaques de cuisson, éviers — en listes,
  // plusieurs possibles — et les 5 éléments simples) sur un devis ou un
  // dossier, même structure des deux côtés, et les transforme en lignes
  // descriptives pour les documents.
  function elementsDescriptifsTechniques(source) {
    const extra = [];
    if (source.poseurMeuble) extra.push(`Poseur Meuble : ${source.poseurMeuble}`);
    (source.plaquesCuisson || []).forEach((p) => {
      if (p.reference) {
        const commentaire = p.commentaire ? ` (${p.commentaire})` : "";
        extra.push(`Réservation pour plaque de cuisson : ${p.reference}${commentaire}`);
      }
    });
    (source.eviers || []).forEach((e) => {
      if (e.reference) {
        const type = e.type ? `${e.type.toLowerCase()} ` : "";
        const commentaire = e.commentaire ? ` (${e.commentaire})` : "";
        extra.push(`Découpe ${type}évier ${e.reference}${commentaire}`);
      }
    });
    if (source.reservationVidangeAutomatique) {
      const diametre = source.reservationVidangeAutomatiqueDiametre ? ` ${source.reservationVidangeAutomatiqueDiametre}` : "";
      extra.push(`Réservation vidange automatique${diametre}`);
    }
    if (source.reservationOsmoseur) {
      const diametre = source.reservationOsmoseurDiametre ? ` ${source.reservationOsmoseurDiametre}` : "";
      extra.push(`Réservation osmoseur${diametre}`);
    }
    if (source.socle === "Oui") extra.push("Commande avec socle");
    if (source.socle === "Non") extra.push("Commande sans socle");
    // Sans socle, pas d'encastrement possible : ces deux questions n'ont plus
    // lieu d'être, même si elles avaient été renseignées avant coup.
    if (source.socle !== "Non") {
      if (source.laveVaisselle) extra.push(`Lave-vaisselle${source.laveVaisselleType ? ` ${source.laveVaisselleType.toLowerCase()}` : ""}`);
      if (source.laveLinge) extra.push(`Lave-linge${source.laveLingeType ? ` ${source.laveLingeType.toLowerCase()}` : ""}`);
    }
    if (source.porteCuisine) {
      const type = source.porteCuisineType ? ` ${source.porteCuisineType.toLowerCase()}` : "";
      const debord = source.porteCuisineDebord ? `, débord plan de travail ${source.porteCuisineDebord}cm` : "";
      extra.push(`Porte cuisine${type}${debord}`);
    }
    if (source.jambage) extra.push(`Jambage${source.jambageType ? ` ${source.jambageType.toLowerCase()}` : ""}`);
    return extra;
  }

  // Bloc "Contenu du devis" (description, lignes facturées, ajout d'article,
  // notes de page, totaux) — partagé entre la fiche devis et la fiche
  // dossier (statut BDC/RDM/PL), pour pouvoir ajuster consommation/
  // description en fonction du dessin technique et des commentaires de
  // Wissam sans quitter le dossier.
  // Fonctionne toujours sur `draft` : le devis lui-même est figé dès qu'un
  // dossier existe (voir commandeLieeAuDevis / enregistrerDevis), et quand
  // appelé depuis le dossier, `draft` porte les lignes propres au dossier
  // (commande.lignes), chargées à l'ouverture — plus celles du devis
  // d'origine, qui ne bougent plus après la transformation.
  function renderContenuLignesDevis() {
    return (
      <>
          {/* Descriptif — texte de présentation, sans prix */}
          <div style={{ marginTop: 24, marginBottom: 10, fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, fontSize: 18 }}>Description des morceaux</div>

          {lignesDescriptives.length > 0 && (
            <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, overflow: "hidden", marginBottom: 12, background: "#FBFAF9" }}>
              {lignesDescriptives.map((l, idx) => (
                <div key={l.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 14px", borderTop: idx === 0 ? "none" : `1px solid ${PIERRE}`, fontSize: 13 }}>
                  <input
                    className="sc-input"
                    value={l.designation}
                    onChange={(e) => updateLigne(l.id, { designation: e.target.value })}
                    style={{ ...inputStyle("100%"), padding: "5px 8px", background: "#fff", border: `1px solid ${TAUPE}44`, fontStyle: "italic" }}
                  />
                  <button type="button" className="sc-btn" onClick={() => deplacerLigne(l.id, -1)} disabled={idx === 0} style={{ ...iconBtnStyle, opacity: idx === 0 ? 0.3 : 1 }} title="Monter">↑</button>
                  <button type="button" className="sc-btn" onClick={() => deplacerLigne(l.id, 1)} disabled={idx === lignesDescriptives.length - 1} style={{ ...iconBtnStyle, opacity: idx === lignesDescriptives.length - 1 ? 0.3 : 1 }} title="Descendre">↓</button>
                  <button type="button" className="sc-btn" onClick={() => supprimerLigne(l.id)} style={iconBtnStyle} title="Supprimer">✕</button>
                </div>
              ))}
            </div>
          )}

          {/* Ajout d'un descriptif — zone dédiée, indépendante de celle des
              éléments facturés plus bas : liste entière au focus, filtrée à
              la frappe. */}
          <div style={{ marginBottom: 20, position: "relative" }}>
            <input
              className="sc-input"
              placeholder="Ajouter un descriptif du catalogue…"
              value={descriptifQuery}
              onChange={(e) => setDescriptifQuery(e.target.value)}
              onFocus={() => setDescriptifDropdownOpen(true)}
              onBlur={() => setTimeout(() => setDescriptifDropdownOpen(false), 150)}
              style={inputStyle("100%")}
            />
            {descriptifDropdownOpen && (
              <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 8, marginTop: 4, zIndex: 10, boxShadow: "0 8px 24px rgba(40,30,30,0.12)", maxHeight: 240, overflowY: "auto" }}>
                {descriptifsFiltres.length === 0 ? (
                  <div style={{ padding: 12, fontSize: 13, color: TAUPE }}>Aucun élément descriptif ne correspond. Ajoute-le au Catalogue (catégorie Descriptifs).</div>
                ) : (
                  descriptifsFiltres.map((a) => (
                    <div key={a.id} className="sc-row" onMouseDown={() => ajouterLigneArticle(a)} style={{ padding: "10px 14px", cursor: "pointer", borderBottom: `1px solid ${PIERRE}`, fontSize: 13, fontStyle: "italic" }}>
                      {a.designation}
                    </div>
                  ))
                )}
              </div>
            )}
          </div>

          <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
            <button type="button" className="sc-btn" onClick={() => setShowLigneLibre(true)} style={ghostBtnStyle}>+ Ligne libre</button>
          </div>

          {showLigneLibre && (
            <div style={{ background: PIERRE, borderRadius: 8, padding: 16, marginBottom: 20 }}>
              <div style={{ marginBottom: 10 }}>
                <input
                  className="sc-input"
                  placeholder="Texte de la ligne (apparaît dans la description des morceaux, sans prix)"
                  value={ligneLibreForm.designation}
                  onChange={(e) => setLigneLibreForm({ designation: e.target.value })}
                  style={inputStyle("100%")}
                />
              </div>
              <button type="button" className="sc-btn" onClick={ajouterLigneLibre} style={primaryBtnStyle}>Ajouter la ligne</button>
              <button type="button" className="sc-btn" onClick={() => { setShowLigneLibre(false); setLigneLibreForm({ designation: "" }); }} style={{ ...ghostBtnStyle, marginLeft: 8 }}>Annuler</button>
            </div>
          )}

          {/* Éléments facturés — table chiffrée, nettement distincte du descriptif au-dessus */}
          <div style={{ marginTop: 24, marginBottom: 10, fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, fontSize: 18, paddingTop: 16, borderTop: `2px solid ${ENCRE}` }}>Éléments facturés</div>

          {lignesFacturables.length > 0 && (
            <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, overflow: "hidden", marginBottom: 12 }}>
              <div style={{ display: "grid", gridTemplateColumns: "2.2fr 0.7fr 0.8fr 0.9fr 0.7fr 0.9fr 90px", padding: "10px 14px", background: PIERRE, fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>
                <div>Désignation</div><div>Qté</div><div>Unité</div><div>P.U. HT</div><div>Remise %</div><div>Montant HT</div><div></div>
              </div>
              {lignesFacturables.map((l, idx) => {
                const { montantHT } = calcLigne(l);
                return (
                  <div key={l.id} style={{ display: "grid", gridTemplateColumns: "2.2fr 0.7fr 0.8fr 0.9fr 0.7fr 0.9fr 90px", padding: "8px 14px", alignItems: "center", borderTop: `1px solid ${PIERRE}`, fontSize: 13 }}>
                    {l.articleId ? (
                      <div>
                        {l.designation}
                        {(() => {
                          // Nils 26/10 : vente d'une chute — dimensions, prix pré-rempli au prorata de la surface (modifiable).
                          const art = (articles || []).find((x) => x.id === l.articleId);
                          if (!art || art.categorie !== "Tranche") return null;
                          const sc = l.chute ? surfaceDimensions(l.chuteDimensions) : null;
                          return (
                            <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", fontSize: 12, marginTop: 4 }}>
                              <label style={{ display: "flex", gap: 4, alignItems: "center", cursor: "pointer" }}>
                                <input type="checkbox" checked={!!l.chute} onChange={(e) => updateLigne(l.id, e.target.checked ? { chute: true, chuteDimensions: "", qte: 1, unite: "chute", bookmatch: false, qteA: "", qteB: "" } : { chute: false, chuteDimensions: "", unite: art.unite, prixPublic: prixTrancheArticle(art) ?? l.prixPublic })} />
                                Chute
                              </label>
                              {l.chute && (
                                <>
                                  <input className="sc-input" value={l.chuteDimensions || ""} placeholder="160 × 90" onChange={(e) => { const px = prixChute(art, e.target.value); updateLigne(l.id, { chuteDimensions: e.target.value, ...(px !== null ? { prixPublic: px } : {}) }); }} style={{ ...inputStyle(110), padding: "3px 6px" }} /> cm
                                  {sc ? <span style={{ color: TAUPE }}>{String(Math.round(sc * 100) / 100).replace(".", ",")} m²</span> : <span style={{ color: ROUILLE, fontWeight: 600 }}>dimensions L × l en cm</span>}
                                </>
                              )}
                            </div>
                          );
                        })()}
                        {(() => {
                          // Nils 04/10 (o) : book-match demandé sur la ligne, répartition A / B libre (ex. 3 A + 1 B).
                          const art = (articles || []).find((x) => x.id === l.articleId);
                          if (!art || !art.bookmatch || l.chute) return null;
                          const q = Number(l.qte) || 0;
                          const a = l.qteA === undefined || l.qteA === "" ? Math.ceil(q / 2) : Number(l.qteA) || 0;
                          const b = l.qteB === undefined || l.qteB === "" ? Math.floor(q / 2) : Number(l.qteB) || 0;
                          return (
                            <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", fontSize: 12, marginTop: 4 }}>
                              <label style={{ display: "flex", gap: 4, alignItems: "center", cursor: "pointer" }}>
                                <input type="checkbox" checked={!!l.bookmatch} onChange={(e) => updateLigne(l.id, e.target.checked ? { bookmatch: true, qteA: Math.ceil(q / 2), qteB: Math.floor(q / 2) } : { bookmatch: false, qteA: "", qteB: "" })} />
                                Book-match demandé
                              </label>
                              {l.bookmatch && (
                                <>
                                  A <input type="number" min="0" className="sc-input" value={l.qteA ?? a} onChange={(e) => updateLigne(l.id, { qteA: e.target.value })} style={{ ...inputStyle(52), padding: "3px 6px" }} />
                                  B <input type="number" min="0" className="sc-input" value={l.qteB ?? b} onChange={(e) => updateLigne(l.id, { qteB: e.target.value })} style={{ ...inputStyle(52), padding: "3px 6px" }} />
                                  {a + b !== q && <span style={{ color: ROUILLE, fontWeight: 600 }}>A + B ≠ {q}</span>}
                                </>
                              )}
                            </div>
                          );
                        })()}
                      </div>
                    ) : (
                      <input className="sc-input" value={l.designation} onChange={(e) => updateLigne(l.id, { designation: e.target.value })} style={{ ...inputStyle("100%"), padding: "5px 8px", background: "#fff", border: `1px solid ${TAUPE}44` }} />
                    )}
                    <input type="number" step={l.chute ? 1 : (!draft.chantierId && pasVenteTranche(l.articleId ? (articles || []).find((a) => a.id === l.articleId) : null)) || "any"} className="sc-input" value={l.qte} onChange={(e) => updateLigne(l.id, { qte: e.target.value })} style={{ ...inputStyle("100%"), padding: "5px 8px" }} />
                    {l.articleId ? (
                      <div>{l.unite}</div>
                    ) : (
                      <select className="sc-select" value={l.unite} onChange={(e) => updateLigne(l.id, { unite: e.target.value })} style={{ ...selectStyle, padding: "5px 6px" }}>
                        {(unitesArticles || DEFAULT_UNITES_ARTICLE).map((u) => (<option key={u} value={u}>{u}</option>))}
                      </select>
                    )}
                    {l.articleId ? (
                      <div>{fmtMAD(l.prixPublic)}</div>
                    ) : (
                      <input type="number" className="sc-input" value={l.prixPublic} onChange={(e) => updateLigne(l.id, { prixPublic: sansZeroTete(e.target.value) })} style={{ ...inputStyle("100%"), padding: "5px 8px" }} />
                    )}
                    <input type="number" className="sc-input" value={l.remise} onChange={(e) => updateLigne(l.id, { remise: sansZeroTete(e.target.value) })} style={{ ...inputStyle("100%"), padding: "5px 8px" }} />
                    <div style={{ fontWeight: 600 }}>{fmtMAD(montantHT)}</div>
                    <div style={{ display: "flex", gap: 2 }}>
                      <button type="button" className="sc-btn" onClick={() => deplacerLigne(l.id, -1)} disabled={idx === 0} style={{ ...iconBtnStyle, opacity: idx === 0 ? 0.3 : 1 }} title="Monter">↑</button>
                      <button type="button" className="sc-btn" onClick={() => deplacerLigne(l.id, 1)} disabled={idx === lignesFacturables.length - 1} style={{ ...iconBtnStyle, opacity: idx === lignesFacturables.length - 1 ? 0.3 : 1 }} title="Descendre">↓</button>
                      <button type="button" className="sc-btn" onClick={() => supprimerLigne(l.id)} style={iconBtnStyle} title="Supprimer la ligne">✕</button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Ajout de ligne depuis le catalogue — les Descriptifs ont leur
              propre zone d'ajout au-dessus et n'apparaissent pas ici */}
          <div ref={zoneArticlesRef} style={{ marginBottom: 10 }}>
            <div style={{ display: "flex", gap: 4, marginBottom: 8, flexWrap: "wrap" }}>
              {(categoriesArticles || DEFAULT_CATEGORIES_ARTICLES).filter((c) => c !== "Descriptifs").map((cat) => (
                <button key={cat} type="button" className="sc-btn" onClick={() => { setLigneFiltreCat(cat); setListeArticlesOuverte(true); }}
                  style={{ padding: "6px 12px", borderRadius: 20, fontSize: 11, fontWeight: 600, background: ligneFiltreCat === cat ? ENCRE : PIERRE, color: ligneFiltreCat === cat ? PIERRE : TAUPE }}>
                  {cat}
                </button>
              ))}
            </div>
            <div style={{ position: "relative" }}>
              <input className="sc-input" placeholder="Rechercher un article du catalogue (code ou désignation)…" value={ligneQuery} onChange={(e) => { setLigneQuery(e.target.value); setListeArticlesOuverte(true); }} onClick={() => setListeArticlesOuverte(true)} onFocus={() => setListeArticlesOuverte(true)} style={inputStyle("100%")} />
              {listeArticlesOuverte && (ligneQuery.trim() || ligneFiltreCat !== "Toutes") && (
                <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 8, marginTop: 4, zIndex: 10, boxShadow: "0 8px 24px rgba(40,30,30,0.12)", maxHeight: 240, overflowY: "auto" }}>
                  {articlesFiltres.length === 0 ? (
                    <div style={{ padding: 12, fontSize: 13, color: TAUPE }}>Aucun article ne correspond. Ajoute l'article au catalogue si besoin.</div>
                  ) : (
                    articlesFiltres.map((a) => {
                      const feExo = draft && draft.exonereTVA && a.categorie === "Tranche" ? produitCreditDeArticle(a) : null;
                      const creditRestant = feExo ? Number((creditUtilisablePourCle(feExo.cle) - creditEngageDraft(feExo.cle)).toFixed(2)) : null;
                      return (
                      <div key={a.id} className="sc-row" onClick={() => { ajouterLigneArticle(a); setListeArticlesOuverte(false); }} style={{ padding: "10px 14px", cursor: "pointer", borderBottom: `1px solid ${PIERRE}`, fontSize: 13 }}>
                        <div style={{ fontWeight: 600, fontStyle: a.categorie === "Descriptifs" ? "italic" : "normal" }}>{a.designation}</div>
                        <div style={{ fontSize: 11, color: TAUPE, marginTop: 2 }}>
                          {a.categorie === "Descriptifs" ? "Élément descriptif — sans prix" : `${a.code} · ${a.structurel ? "prix selon groupe tarifaire" : `${fmtMAD(a.prixPublic)} / ${a.unite}`}`}
                          {creditRestant != null ? ` · crédit exo : ${creditRestant}${creditRestant <= 0.004 ? " (chute seulement)" : ""}` : ""}
                        </div>
                      </div>
                      );
                    })
                  )}
                </div>
              )}
            </div>
          </div>

          <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
            <button type="button" className="sc-btn" onClick={mettreAJourPrix} style={ghostBtnStyle}>↻ Mettre à jour les prix (catalogue)</button>
          </div>
      </>
    );
  }

  // Bloc "Totaux" (HT / TVA ou mention d'exonération / TTC) — partagé lui
  // aussi entre devis et BDC, pour voir l'effet d'un ajustement de ligne
  // sans avoir à ouvrir le devis.
  function renderTotauxDevis() {
    return (
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <div style={{ width: 280 }}>
          <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontSize: 14 }}><span style={{ color: TAUPE }}>Total HT</span><span>{fmtMAD(totaux.totalHT)}</span></div>
          <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontSize: 14 }}><span style={{ color: TAUPE }}>{draft.exonereTVA ? "TVA (exonérée)" : "TVA (20%)"}</span><span>{fmtMAD(totaux.totalTVA)}</span></div>
          <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", fontSize: 18, fontWeight: 600, borderTop: `1px solid ${PIERRE}`, marginTop: 4 }}><span>Total TTC</span><span>{fmtMAD(totaux.totalTTC)}</span></div>
          {(() => {
            // Nils 29/10 : projet immobilier — estimation de la facture (avance, retenue, prorata).
            const dp = deductionsDevis(draft, draft.chantierId || (commandeEditing ? chantierDuDossier(commandeEditing) : ""));
            if (!dp) return null;
            const p = (x) => String(x).replace(".", ",");
            const r = (lib, v, fort) => (<div style={{ display: "flex", justifyContent: "space-between", padding: "3px 0", fontSize: 13, fontWeight: fort ? 700 : 400 }}><span style={{ color: fort ? ENCRE : TAUPE }}>{lib}</span><span>{v}</span></div>);
            return (
              <div style={{ marginTop: 8, padding: "8px 10px", background: PIERRE, borderRadius: 8 }}>
                <div style={{ fontSize: 11, color: TAUPE, marginBottom: 4 }}>Facture du projet — estimation (figée à la facturation)</div>
                {dp.avance ? r(`− Avance (${p(dp.avancePct)} %)`, `− ${fmtMAD(dp.avance)}`) : null}
                {dp.retenue ? r(`− Retenue de garantie (${p(dp.retenuePct)} %)`, `− ${fmtMAD(dp.retenue)}`) : null}
                {dp.prorata ? r(`− Compte prorata (${p(dp.prorataPct)} %)`, `− ${fmtMAD(dp.prorata)}`) : null}
                {r("Total HT net", fmtMAD(dp.htNet), true)}
                {r("TVA", fmtMAD(dp.tva))}
                {r("Net à payer (TTC)", fmtMAD(dp.net), true)}
              </div>
            );
          })()}
        </div>
      </div>
    );
  }

  // Bloc "Éléments techniques" partagé entre la fiche devis et la fiche
  // dossier — même structure de champs des deux côtés. `source` est le
  // draft/commandeEditing en cours, `onChange` son setter, `note` un texte
  // optionnel affiché en bas (utilisé côté devis pour prévenir du report
  // automatique vers le dossier).
  // Nils 03/10 (h) : références d'éviers / plaques en menu déroulant, liste gérée
  // (droit devis.listesTechniques, Nils par défaut). « Autre (saisie libre) » reste
  // possible ; les références saisies hors liste se retrouvent dans « Gérer la liste ».
  function referencesConnues(champ) {
    const m = new Map();
    [...(devisListe || []), ...(commandesListe || [])].forEach((d) => (d[champ] || []).forEach((x) => { const r = String(x.reference || "").trim(); if (r && !m.has(normLib(r))) m.set(normLib(r), r); }));
    return [...m.values()].sort((a, b) => a.localeCompare(b, "fr"));
  }
  const CLE_LISTE_TECH = { eviers: "listeEviers", plaquesCuisson: "listePlaques" };
  function listeReferencesTech(champ) {
    const l = parametres && parametres[CLE_LISTE_TECH[champ]];
    return Array.isArray(l) ? [...l].sort((a, b) => a.localeCompare(b, "fr")) : referencesConnues(champ);
  }
  async function majListeTech(champ, liste, trace) {
    if (!peut("devis.listesTechniques")) return;
    await persistParametres({ ...(parametres || {}), [CLE_LISTE_TECH[champ]]: liste });
    await tracerAcces(`liste ${champ === "eviers" ? "des éviers" : "des plaques de cuisson"} modifiée`, trace);
  }
  // Nils 08/10 (s) : chaque référence d'évier a un type (sous plan / encastrable),
  // stocké à part (parametres.typesEviers, clé = libellé normalisé).
  const TYPES_EVIER = ["Sous plan", "Encastrable"];
  function typeEvierRef(r) {
    return ((parametres && parametres.typesEviers) || {})[normLib(r)] || "";
  }
  async function setTypeEvierRef(r, t) {
    if (!peut("devis.listesTechniques")) return;
    await persistParametres({ ...(parametres || {}), typesEviers: { ...((parametres && parametres.typesEviers) || {}), [normLib(r)]: t } });
  }
  async function ajouterRefTech(champ, valeur) {
    const v = String(valeur || "").trim();
    if (!v) return false;
    if (champ === "eviers" && !TYPES_EVIER.includes(nouveauTypeEvier)) { setNotice("Indique d'abord si l'évier est sous plan ou encastrable."); return false; }
    const l = listeReferencesTech(champ);
    if (l.some((x) => normLib(x) === normLib(v))) { setNotice("Cette référence est déjà dans la liste."); return false; }
    if (champ === "eviers") {
      await persistParametres({ ...(parametres || {}), [CLE_LISTE_TECH[champ]]: [...l, v], typesEviers: { ...((parametres && parametres.typesEviers) || {}), [normLib(v)]: nouveauTypeEvier } });
      await tracerAcces("liste des éviers modifiée", `ajoutée : ${v} (${nouveauTypeEvier})`);
      return true;
    }
    await majListeTech(champ, [...l, v], `ajoutée : ${v}`);
    return true;
  }
  function champReferenceTech(champ, item, majItem) {
    const refs = listeReferencesTech(champ);
    const v = item.reference || "";
    const horsListe = !!v && !refs.some((r) => normLib(r) === normLib(v));
    const libre = !!item.saisieLibre || horsListe;
    const lib = champ === "eviers" ? "l'évier" : "la plaque de cuisson";
    // Éviers : seulement les références du type choisi (+ celles dont le type n'est pas encore renseigné).
    const typeVoulu = champ === "eviers" ? item.type || "" : "";
    const refsType = typeVoulu ? refs.filter((r) => typeEvierRef(r) === typeVoulu) : refs;
    const refsSansType = typeVoulu ? refs.filter((r) => !typeEvierRef(r)) : [];
    const choisir = (r) => {
      const t = champ === "eviers" && !item.type ? typeEvierRef(r) : "";
      majItem({ reference: r, saisieLibre: false, ...(t ? { type: t } : {}) });
    };
    return (
      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <select className="sc-select" aria-label={`Référence de ${lib}`} value={libre ? "__libre" : v} onChange={(e) => (e.target.value === "__libre" ? majItem({ saisieLibre: true }) : choisir(e.target.value))} style={{ ...selectStyle, flex: 1 }}>
            <option value="">— Référence de {lib}{typeVoulu ? ` (${typeVoulu.toLowerCase()})` : ""} —</option>
            <option value="__libre">Autre (saisie libre)…</option>
            {refsType.map((r) => (<option key={r} value={r}>{r}{champ === "eviers" && !typeVoulu && typeEvierRef(r) ? ` — ${typeEvierRef(r).toLowerCase()}` : ""}</option>))}
            {refsSansType.length > 0 && (<optgroup label="Type non renseigné">{refsSansType.map((r) => (<option key={r} value={r}>{r}</option>))}</optgroup>)}
            {v && !libre && typeVoulu && !refsType.includes(v) && !refsSansType.includes(v) && <option value={v}>{v} (autre type)</option>}
          </select>
          {peut("devis.listesTechniques") && <button type="button" className="sc-btn" title={champ === "eviers" ? "Gérer la liste des éviers" : "Gérer la liste des plaques de cuisson"} onClick={() => { setNouvelleRefTech(""); setListeTechEdit(champ); }} style={{ ...linkBtnStyle, fontSize: 12, whiteSpace: "nowrap" }}>Gérer la liste</button>}
        </div>
        {libre && <input className="sc-input" autoFocus={!v} value={v} onChange={(e) => majItem({ reference: e.target.value, saisieLibre: true })} placeholder={`Référence de ${lib} (hors liste)`} style={inputStyle("100%")} />}
      </div>
    );
  }
  function renderElementsTechniques(source, onChange, note, repliable) {
    // ERP step 11 (accord Nils du 29/09) : lave-vaisselle, lave-linge et porte
    // cuisine passent d'une case à cocher à un choix explicite Oui / Non
    // (true / false), pour distinguer « Non » de « pas encore renseigné ».
    const ouiNonTechnique = (champ) => (
      <div style={{ display: "flex", gap: 16, marginBottom: 8, marginLeft: 0 }}>
        {[["Oui", true], ["Non", false]].map(([lib, val]) => (
          <label key={lib} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}>
            <input type="radio" name={`${champ}-${source.id}`} checked={source[champ] === val} onChange={() => onChange({ ...source, [champ]: val })} />
            {lib}
          </label>
        ))}
      </div>
    );
    const radioType = (valeur, champ, options) => (
      <div style={{ display: "flex", gap: 16, marginBottom: 8, marginLeft: 24 }}>
        {options.map((o) => (
          <label key={o} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}>
            <input type="radio" name={`${champ}-${source.id}`} checked={valeur === o} onChange={() => onChange({ ...source, [champ]: o })} />
            {o}
          </label>
        ))}
      </div>
    );
    // ERP step 11 (demande Nils du 29/09) : sur le devis, encadré repliable.
    if (repliable && !elemTechDevisOuvert) {
      return (
        <div onClick={() => setElemTechDevisOuvert(true)} style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "12px 14px", marginBottom: 20, cursor: "pointer" }}>
          <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>▸ Éléments techniques ({elementsDescriptifsTechniques(source).length})</div>
          {elementsDescriptifsTechniques(source).length > 0 && (
            <div style={{ fontSize: 12, color: TAUPE, marginTop: 4 }}>{elementsDescriptifsTechniques(source).join(" · ")}</div>
          )}
        </div>
      );
    }
    return (
      <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: 14, marginBottom: 20 }}>
        <div onClick={repliable ? () => setElemTechDevisOuvert(false) : undefined} style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 10, cursor: repliable ? "pointer" : "default" }}>{repliable ? "▾ " : ""}Éléments techniques</div>
        {/* Nils 01/11 : électroménager standard de la typologie (devis créé depuis un logement de projet). */}
        {(() => {
          const info = electroStandardDe(source);
          if (!info && !source.electroStandard) return null;
          const { plaque = {}, evier = {} } = info ? info.std : {};
          return (
            <label style={{ display: "flex", gap: 8, alignItems: "flex-start", fontSize: 13, background: source.electroStandard ? "#E4EBE4" : PIERRE, borderRadius: 6, padding: "8px 10px", marginBottom: 12, cursor: "pointer" }}>
              <input type="checkbox" checked={!!source.electroStandard} onChange={(e) => basculerElectroStandard(source, onChange, e.target.checked)} style={{ marginTop: 2 }} />
              <span>
                <strong>Oui, ce sont bien les électros standard du projet</strong>{info && info.typoNom ? ` (typologie ${info.typoNom})` : ""}
                {info && <div style={{ fontSize: 12, color: TAUPE }}>{[plaque.reference ? `Plaque : ${plaque.reference}${plaque.fichier ? " + fiche technique" : ""}` : "", evier.reference ? `Évier : ${evier.reference}${evier.fichier ? " + fiche technique" : ""}` : ""].filter(Boolean).join(" · ")}</div>}
              </span>
            </label>
          );
        })()}

        <Field label="Poseur Meuble">
          <input className="sc-input" value={source.poseurMeuble || ""} onChange={(e) => onChange({ ...source, poseurMeuble: e.target.value })} style={inputStyle("100%")} />
        </Field>

        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>Fiche technique plaque de cuisson</div>
          {(source.plaquesCuisson || []).map((p) => (
            <div key={p.id} style={{ border: `1px solid ${PIERRE}`, borderRadius: 6, padding: 8, marginBottom: 6 }}>
              <div style={{ display: "flex", gap: 8, marginBottom: 6 }}>
                {champReferenceTech("plaquesCuisson", p, (patch) => onChange({ ...source, plaquesCuisson: source.plaquesCuisson.map((x) => (x.id === p.id ? { ...x, ...patch } : x)) }))}
                <button type="button" className="sc-btn" onClick={() => onChange({ ...source, plaquesCuisson: source.plaquesCuisson.filter((x) => x.id !== p.id) })} style={iconBtnStyle}>✕</button>
              </div>
              <input
                className="sc-input"
                value={p.commentaire || ""}
                onChange={(e) => onChange({ ...source, plaquesCuisson: source.plaquesCuisson.map((x) => (x.id === p.id ? { ...x, commentaire: e.target.value } : x)) })}
                style={inputStyle("100%")}
                placeholder="Commentaire (ex. sur meuble de 80cm)"
              />
            </div>
          ))}
          <button type="button" className="sc-btn" onClick={() => onChange({ ...source, plaquesCuisson: [...(source.plaquesCuisson || []), { id: uid(), reference: "", commentaire: "" }] })} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>+ Ajouter une plaque de cuisson</button>
        </div>

        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>Fiche technique évier</div>
          {(source.eviers || []).map((ev) => (
            <div key={ev.id} style={{ border: `1px solid ${PIERRE}`, borderRadius: 6, padding: 8, marginBottom: 6 }}>
              <div style={{ display: "flex", gap: 16, marginBottom: 6 }}>
                <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12 }}>
                  <input type="radio" name={`evierType-${ev.id}`} checked={ev.type === "Sous plan"} onChange={() => onChange({ ...source, eviers: source.eviers.map((x) => (x.id === ev.id ? { ...x, type: "Sous plan" } : x)) })} />
                  Sous plan
                </label>
                <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12 }}>
                  <input type="radio" name={`evierType-${ev.id}`} checked={ev.type === "Encastrable"} onChange={() => onChange({ ...source, eviers: source.eviers.map((x) => (x.id === ev.id ? { ...x, type: "Encastrable" } : x)) })} />
                  Encastrable
                </label>
              </div>
              <div style={{ display: "flex", gap: 8, marginBottom: 6 }}>
                {champReferenceTech("eviers", ev, (patch) => onChange({ ...source, eviers: source.eviers.map((x) => (x.id === ev.id ? { ...x, ...patch } : x)) }))}
                <button type="button" className="sc-btn" onClick={() => onChange({ ...source, eviers: source.eviers.filter((x) => x.id !== ev.id) })} style={iconBtnStyle}>✕</button>
              </div>
              <input
                className="sc-input"
                value={ev.commentaire || ""}
                onChange={(e) => onChange({ ...source, eviers: source.eviers.map((x) => (x.id === ev.id ? { ...x, commentaire: e.target.value } : x)) })}
                style={inputStyle("100%")}
                placeholder="Commentaire (ex. égouttoir à gauche)"
              />
            </div>
          ))}
          <button type="button" className="sc-btn" onClick={() => onChange({ ...source, eviers: [...(source.eviers || []), { id: uid(), reference: "", type: "", commentaire: "" }] })} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>+ Ajouter un évier</button>
        </div>

        <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, marginBottom: 6 }}>
          <input type="checkbox" checked={!!source.reservationVidangeAutomatique} onChange={(e) => onChange({ ...source, reservationVidangeAutomatique: e.target.checked })} />
          Réservation vidange automatique
        </label>
        {source.reservationVidangeAutomatique && (
          <input
            className="sc-input"
            value={source.reservationVidangeAutomatiqueDiametre || ""}
            onChange={(e) => onChange({ ...source, reservationVidangeAutomatiqueDiametre: e.target.value })}
            style={{ ...inputStyle("100%"), marginLeft: 24, width: "calc(100% - 24px)", marginBottom: 10 }}
            placeholder="Diamètre (ex. Ø 32mm)"
          />
        )}

        <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, marginBottom: 6 }}>
          <input type="checkbox" checked={!!source.reservationOsmoseur} onChange={(e) => onChange({ ...source, reservationOsmoseur: e.target.checked })} />
          Réservation osmoseur
        </label>
        {source.reservationOsmoseur && (
          <input
            className="sc-input"
            value={source.reservationOsmoseurDiametre || ""}
            onChange={(e) => onChange({ ...source, reservationOsmoseurDiametre: e.target.value })}
            style={{ ...inputStyle("100%"), marginLeft: 24, width: "calc(100% - 24px)", marginBottom: 10 }}
            placeholder="Diamètre (ex. Ø 12mm)"
          />
        )}

        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>Socle</div>
        {radioType(source.socle, "socle", ["Oui", "Non"])}

        {source.socle !== "Non" && (
          <>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>Lave-vaisselle</div>
            {ouiNonTechnique("laveVaisselle")}
            {source.laveVaisselle && radioType(source.laveVaisselleType, "laveVaisselleType", ["Encastrable", "Pose libre"])}

            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>Lave-linge</div>
            {ouiNonTechnique("laveLinge")}
            {source.laveLinge && radioType(source.laveLingeType, "laveLingeType", ["Encastrable", "Pose libre"])}
          </>
        )}

        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>Porte cuisine</div>
        {ouiNonTechnique("porteCuisine")}
        {source.porteCuisine && (
          <>
            <div style={{ display: "flex", gap: 16, marginBottom: 8, marginLeft: 24 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}>
                <input
                  type="radio"
                  name={`porteCuisineType-${source.id}`}
                  checked={source.porteCuisineType === "Avec poignée"}
                  onChange={() => onChange({ ...source, porteCuisineType: "Avec poignée", porteCuisineDebord: 4 })}
                />
                Avec poignée
              </label>
              <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}>
                <input
                  type="radio"
                  name={`porteCuisineType-${source.id}`}
                  checked={source.porteCuisineType === "Avec gorge"}
                  onChange={() => onChange({ ...source, porteCuisineType: "Avec gorge", porteCuisineDebord: 3 })}
                />
                Avec gorge
              </label>
            </div>
            {source.porteCuisineType && (
              <div style={{ marginLeft: 24, marginBottom: 8 }}>
                <label style={{ fontSize: 12, color: TAUPE, display: "block", marginBottom: 4 }}>
                  Débord du plan de travail (cm) — déduit automatiquement, modifiable si le client demande plus ou moins
                </label>
                <input
                  type="number"
                  className="sc-input"
                  value={source.porteCuisineDebord ?? ""}
                  onChange={(e) => onChange({ ...source, porteCuisineDebord: e.target.value })}
                  style={inputStyle(100)}
                />
              </div>
            )}
          </>
        )}

        <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, marginBottom: 6 }}>
          <input type="checkbox" checked={!!source.jambage} onChange={(e) => onChange({ ...source, jambage: e.target.checked })} />
          Jambage
        </label>
        {source.jambage && radioType(source.jambageType, "jambageType", ["Coupe 45", "Coupe 90"])}

        {note && <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>{note}</div>}
      </div>
    );
  }

  // Tous les documents imprimés (BC, BPRDM, PL, BL, Facture) reprennent les
  // infos d'en-tête du devis d'origine (client, adresse, conditions...) mais
  // JAMAIS ses lignes : depuis la transformation en BDC (pt.17/18), le devis
  // est figé et seul le dossier (commande.lignes, via lignesDuDossier) reflète
  // ce qui a réellement été commandé/modifié. Bug corrigé le 21/09 : ces 5
  // fonctions imprimaient encore les lignes du devis figé, donc toute
  // marchandise ajoutée depuis "Modifier le bon de commande" n'apparaissait
  // jamais sur aucun document imprimé (elle était pourtant bien enregistrée
  // sur le dossier — la réservation, qui lit déjà lignesDuDossier, la voyait).
  function devisPourImpression(commande, devisSource) {
    // ERP step 10 : le contact sur place imprimé est celui du dossier (à jour).
    const cs = contactSurPlaceDuDossier(commande);
    // Nils 27/10 : la référence imprimée est celle du dossier (l'atelier ne reçoit pas celle du devis).
    return { ...devisSource, reference: commande.reference || devisSource.reference || "", lignes: lignesDuDossier(commande), contactSurPlace: cs.nom, telephoneSurPlace: cs.tel, etage: etageDuDossier(commande) };
  }

  function imprimerCommande(commande) {
    const devisSource = (devisListe || []).find((d) => d.id === commande.devisId);
    if (!devisSource) {
      setNotice("Impossible de générer le BC : le devis d'origine est introuvable.");
      return;
    }
    const html = construireHtmlDocument(devisPourImpression(commande, devisSource), { titre: "BON DE COMMANDE", numeroAffiche: commande.numero, elementsSupplementaires: elementsDescriptifsTechniques(commande), dateDocument: commande.creeLe });
    telechargerDocument(html, nomFichierDocument(commande.numero, (clientDe(commande.clientId) || {}).nom, nomProjetDe(chantierDuDossier(commande)), commande.reference || devisSource.reference), "bon de commande");
  }

  // Le BPRDM est le même document que le BC, mais sans la partie financière
  // (colonnes prix, totaux, conditions de paiement) — seule l'adresse de
  // livraison reste utile pour organiser le relevé de mesure.
  function imprimerBPRDM(commande) {
    const devisSource = (devisListe || []).find((d) => d.id === commande.devisId);
    if (!devisSource) {
      setNotice("Impossible de générer le BPRDM : le devis d'origine est introuvable.");
      return;
    }
    const numeroAffiche = commande.numeroRDM || commande.numero;
    const html = construireHtmlDocument(devisPourImpression(commande, devisSource), { titre: "BON POUR RELEVÉ DE MESURE", numeroAffiche, masquerFinance: true, elementsSupplementaires: elementsDescriptifsTechniques(commande), dateDocument: commande.dateRDM });
    telechargerDocument(html, nomFichierDocument(numeroAffiche, (clientDe(commande.clientId) || {}).nom, nomProjetDe(chantierDuDossier(commande)), commande.reference || devisSource.reference), "BPRDM");
  }

  // Le PL est le même document que le BPRDM (même mise en page, sans partie
  // financière), seule la mention change.
  function imprimerPL(commande) {
    const devisSource = (devisListe || []).find((d) => d.id === commande.devisId);
    if (!devisSource) {
      setNotice("Impossible de générer le PL : le devis d'origine est introuvable.");
      return;
    }
    const numeroAffiche = commande.numeroPL || commande.numero;
    const html = construireHtmlDocument(devisPourImpression(commande, devisSource), { titre: "BON POUR PRODUCTION", numeroAffiche, masquerFinance: true, elementsSupplementaires: elementsDescriptifsTechniques(commande), dateDocument: commande.datePL, mention: mentionGratuite(commande) });
    telechargerDocument(html, nomFichierDocument(numeroAffiche, (clientDe(commande.clientId) || {}).nom, nomProjetDe(chantierDuDossier(commande)), commande.reference || devisSource.reference), "PL");
  }

  // Le BL est aussi le même document que le BPRDM, avec en plus le nombre
  // de colis (utile pour la livraison) s'il est renseigné.
  function imprimerBL(commande) {
    const devisSource = (devisListe || []).find((d) => d.id === commande.devisId);
    if (!devisSource) {
      setNotice("Impossible de générer le BL : le devis d'origine est introuvable.");
      return;
    }
    const numeroAffiche = commande.numeroBL || commande.numero;
    const titre = devisSource.exonereTVA ? "BON DE LIVRAISON (BLS)" : "BON DE LIVRAISON";
    const html = construireHtmlDocument(devisPourImpression(commande, devisSource), { titre, numeroAffiche, masquerFinance: true, elementsSupplementaires: elementsDescriptifsTechniques(commande), nombreColis: commande.nombreColis, avecSignatures: true, dateDocument: commande.dateBL, mention: mentionSavBL(commande) });
    telechargerDocument(html, nomFichierDocument(numeroAffiche, (clientDe(commande.clientId) || {}).nom, nomProjetDe(chantierDuDossier(commande)), commande.reference || devisSource.reference), "BL");
  }

  // La Facture est le même document que le BC (avec la partie financière),
  // seule la mention change.
  function imprimerFacture(commande) {
    if (commande && commande.factureGroupeeId && commande.numeroFacture) return imprimerFactureGroupee(commande);
    const devisSource = (devisListe || []).find((d) => d.id === commande.devisId);
    if (!devisSource) {
      setNotice("Impossible de générer la facture : le devis d'origine est introuvable.");
      return;
    }
    const numeroAffiche = commande.numeroFacture || commande.numero;
    const html = construireHtmlDocument(devisPourImpression(commande, devisSource), { titre: "FACTURE", numeroAffiche, dateDocument: commande.dateFacture, deductions: deductionsDossier(commande) });
    telechargerDocument(html, nomFichierDocument(numeroAffiche, (clientDe(commande.clientId) || {}).nom, nomProjetDe(chantierDuDossier(commande)), commande.reference || devisSource.reference), "facture");
  }


  // ERP step 11 (accord Nils du 29/09) : modification de l'en-tête d'un devis
  // déjà transformé, réservée à Nils. Seuls les champs d'en-tête sont repris
  // du formulaire (jamais les lignes, le statut ni l'exonération de TVA) ;
  // client et remise restent bloqués une fois le dossier facturé. Les champs
  // recopiés sur le dossier (référence, étage, contact/téléphone sur place,
  // client) y sont mis à jour. Chaque changement est tracé.
  const CHAMPS_ENTETE_NILS = [
    ["reference", "Référence"],
    ["etage", "Étage"],
    ["date", "Date"],
    ["clientId", "Client"],
    ["chantierId", "Projet immobilier"],
    ["commercialSC", "Commercial Stone Concept"],
    ["apporteurAffaire", "Apporteur d'affaire"],
    ["commercialClient", "Commercial du client"],
    ["conditionsPaiement", "Conditions de paiement"],
    ["adresseLivraison", "Adresse de livraison"],
    ["contactSurPlace", "Contact sur place"],
    ["telephoneSurPlace", "Téléphone sur place"],
    ["remiseGlobale", "Remise (%)"],
    ["notes", "Mentions"],
  ];
  // Valeurs d'en-tête « en vigueur » d'un dossier : celles du devis, sauf
  // référence / étage / contact / téléphone / client, portés par le dossier.
  function valeursEnteteDuDossier(commande) {
    const d = (devisListe || []).find((x) => x.id === commande.devisId) || {};
    const cs = contactSurPlaceDuDossier(commande);
    const v = Object.fromEntries(CHAMPS_ENTETE_NILS.map(([cle]) => [cle, d[cle]]));
    return {
      ...v,
      reference: commande.reference || d.reference || "",
      etage: etageDuDossier(commande),
      contactSurPlace: cs.nom,
      telephoneSurPlace: cs.tel,
      clientId: commande.clientId || d.clientId,
      notes: Array.isArray(d.notes) ? [...d.notes] : [],
    };
  }
  // Cœur commun (écran devis et fiche dossier) : applique les valeurs
  // d'en-tête au devis d'origine ET au dossier — tous les documents (devis,
  // BC, BPRDM, PL, BL, facture) se régénèrent depuis ces deux sources.
  // Renvoie un message d'erreur, ou null si c'est fait.
  async function appliquerEnteteNils(commande, valeurs) {
    if (!peut("devis.modifierEnteteFige") || !commande) return "Réservé au Gérant.";
    const enBase = (devisListe || []).find((d) => d.id === commande.devisId);
    if (!enBase) return "Devis d'origine introuvable.";
    const avantVals = valeursEnteteDuDossier(commande);
    if (commande.statut === "Facture" && (valeurs.clientId !== avantVals.clientId || String(valeurs.remiseGlobale ?? "") !== String(avantVals.remiseGlobale ?? ""))) {
      return "Dossier facturé : le client et la remise ne peuvent plus être modifiés (passer par un avoir).";
    }
    // Step 17 (audit, Nils 15/10) : facture envoyée, remise ou transmise au comptable → les champs
    // imprimés sur la facture sont figés (une facture retéléchargée doit rester identique à l'envoyée).
    if (commande.statut === "Facture" && factureTransmise(commande)) {
      const FIGES = [["reference", "Référence"], ["etage", "Étage"], ["adresseLivraison", "Adresse de livraison"], ["conditionsPaiement", "Conditions de paiement"], ["contactSurPlace", "Contact sur place"], ["telephoneSurPlace", "Téléphone sur place"], ["commercialClient", "Commercial du client"]];
      const touches = FIGES.filter(([cle]) => JSON.stringify(avantVals[cle] ?? "") !== JSON.stringify(valeurs[cle] ?? ""));
      if (touches.length) return `Facture déjà envoyée ou transmise : ces champs sont imprimés sur la facture et ne se modifient plus — ${touches.map(([, l]) => l.toLowerCase()).join(", ")}. Passer par un avoir.`;
    }
    if (!valeurs.clientId) return "Sélectionne un client.";
    const affiche = (cle, v) => {
      if (cle === "clientId") return (clientDe(v) || {}).nom || "—";
      if (cle === "notes") return (v || []).filter(Boolean).join(" / ") || "—";
      return v === undefined || v === null || v === "" ? "—" : String(v);
    };
    const changements = [];
    const patch = {};
    CHAMPS_ENTETE_NILS.forEach(([cle, lib]) => {
      const avant = avantVals[cle];
      const apres = valeurs[cle];
      if (JSON.stringify(avant ?? "") !== JSON.stringify(apres ?? "")) {
        patch[cle] = apres;
        changements.push(`${lib} : ${affiche(cle, avant)} → ${affiche(cle, apres)}`);
      }
    });
    if (changements.length === 0) {
      setNotice("Aucun changement dans l'en-tête.");
      return null;
    }
    const maintenant = new Date().toISOString();
    const devisMaj = { ...enBase, ...patch, modifiePar: user.nom, modifieLe: maintenant };
    await persistDevis((devisListe || []).map((d) => (d.id === devisMaj.id ? devisMaj : d)));
    const patchDossier = {};
    if ("reference" in patch) patchDossier.reference = patch.reference || "";
    if ("etage" in patch) patchDossier.etage = (patch.etage || "").trim();
    if ("contactSurPlace" in patch) patchDossier.contactSurPlace = (patch.contactSurPlace || "").trim();
    if ("telephoneSurPlace" in patch) patchDossier.telephoneSurPlace = (patch.telephoneSurPlace || "").trim();
    if ("clientId" in patch) patchDossier.clientId = patch.clientId;
    if (Object.keys(patchDossier).length > 0) {
      await persistCommandes(
        (commandesListe || []).map((c) => (c.id === commande.id ? { ...c, ...patchDossier, modifiePar: user.nom, modifieLe: maintenant } : c))
      );
      // Fiche dossier ouverte : on n'y reporte que les champs modifiés, sans
      // écraser ce qui est en cours d'édition ailleurs sur la fiche.
      if (commandeEditing && commandeEditing.id === commande.id) {
        setCommandeEditing((prev) => (prev && prev.id === commande.id ? { ...prev, ...patchDossier } : prev));
      }
    }
    if (draft && draft.id === devisMaj.id) {
      setDraft((prev) => (prev && prev.id === devisMaj.id ? { ...prev, ...patch } : prev));
    }
    await tracerAcces("modification en-tête (Gérant)", `${enBase.numero} / dossier ${commande.numero} (${commande.statut}) : ${changements.join(" ; ")}`);
    setNotice(`En-tête mis à jour — repris sur tous les documents du dossier ${commande.numero} et sur le devis ${enBase.numero}.`);
    return null;
  }
  async function enregistrerEnteteNils() {
    if (!commandeLieeAuDevis || enteteNilsDevisId !== draft.id) return;
    const valeurs = Object.fromEntries(CHAMPS_ENTETE_NILS.map(([cle]) => [cle, draft[cle]]));
    const erreur = await appliquerEnteteNils(commandeLieeAuDevis, valeurs);
    if (erreur) {
      setDraftError(erreur);
      return;
    }
    setEnteteNilsDevisId(null);
    setDraftError("");
  }
  function ouvrirEnteteNilsDevis() {
    // On part des valeurs en vigueur sur le dossier (contact / étage / … ont
    // pu y être modifiés depuis la transformation).
    if (commandeLieeAuDevis) setDraft({ ...draft, ...valeursEnteteDuDossier(commandeLieeAuDevis) });
    setEnteteNilsDevisId(draft.id);
  }
  // Fenêtre « Modifier l'en-tête » depuis la fiche dossier (n'importe quel
  // statut) — même cœur que l'écran devis.
  function ouvrirEnteteNilsDossier() {
    if (!commandeEditing) return;
    setEnteteDossierModal({ valeurs: valeursEnteteDuDossier(commandeEditing), erreur: "" });
  }
  async function enregistrerEnteteNilsDossier() {
    if (!enteteDossierModal || !commandeEditing) return;
    const erreur = await appliquerEnteteNils(commandeEditing, enteteDossierModal.valeurs);
    if (erreur) {
      setEnteteDossierModal({ ...enteteDossierModal, erreur });
      return;
    }
    setEnteteDossierModal(null);
  }
  function annulerEnteteNils() {
    const enBase = (devisListe || []).find((d) => d.id === draft.id);
    if (enBase) setDraft({ ...draft, ...Object.fromEntries(CHAMPS_ENTETE_NILS.map(([cle]) => [cle, enBase[cle]])) });
    setEnteteNilsDevisId(null);
    setDraftError("");
  }

  // Nils 30/10 : une ligne facturée (pas descriptive) doit avoir une quantité strictement positive.
  function erreurQuantitesLignes(lignes) {
    const l = (lignes || []).find((x) => x.type !== "descriptif" && !(Number(String(x.qte ?? "").replace(/\s/g, "").replace(",", ".")) > 0));
    return l ? `« ${l.designation || "ligne sans désignation"} » : indique une quantité supérieure à 0 (saisie : ${String(l.qte ?? "").trim() || "vide"}).` : "";
  }
  async function enregistrerDevis() {
    if (commandeLieeAuDevis) {
      // Garde-fou : le devis est figé dès qu'un dossier existe (voir pt.17/18).
      // La modification passe désormais par la fiche dossier (statut BDC/RDM/PL).
      setNotice("Ce devis est figé — il a déjà été transformé en dossier. Modifie le dossier directement.");
      return;
    }
    if (!draft.clientId) {
      setDraftError("Sélectionne un client avant d'enregistrer.");
      return;
    }
    // ERP step 12 (Nils 01/10) : la référence de la contremarque est obligatoire sur tout devis.
    if (!(draft.reference || "").trim()) {
      setDraftError("Indique la référence de la contremarque (ex. Villa Dassouli) avant d'enregistrer.");
      return;
    }
    if (draft.lignes.length === 0) {
      setDraftError("Ajoute au moins une ligne avant d'enregistrer.");
      return;
    }
    {
      const err = erreurQuantitesLignes(draft.lignes);
      if (err) { setDraftError(err); return; }
    }
    // Nils 17/10 : une ligne de tranches se vend à la tranche entière, ou au quart de tranche si l'article
    // est coché « Vendable au quart de tranche ». Contrôle sur les lignes ajoutées ou modifiées seulement :
    // un devis déjà enregistré n'est pas remis en cause par un changement de la case.
    // Nils 27/10 : devis d'un projet immobilier — quantité libre sur les tranches (chutes inchangées).
    {
      const avant = (devisListe || []).find((d) => d.id === draft.id);
      const lignesAvant = new Map(((avant && avant.lignes) || []).map((l) => [l.id, l]));
      for (const l of draft.lignes) {
        const a = l.articleId ? (articles || []).find((x) => x.id === l.articleId) : null;
        // Nils 26/10 : chute vendue — nombre entier de chutes et dimensions obligatoires.
        if (l.chute && a) {
          const q = Number(String(l.qte).replace(",", "."));
          if (!(q > 0) || !estMultipleDe(q, 1)) { setDraftError(`« ${a.designation} » (chute) : indique un nombre entier de chutes — quantité saisie : ${l.qte || "vide"}.`); return; }
          if (!surfaceDimensions(l.chuteDimensions)) { setDraftError(`« ${a.designation} » (chute) : indique ses dimensions en cm (ex. 160 × 90).`); return; }
          continue;
        }
        const pas = pasVenteTranche(a);
        if (pas === null) continue;
        if (draft.chantierId) {
          if (!(Number(String(l.qte).replace(",", ".")) > 0)) { setDraftError(`« ${a.designation} » : indique une quantité — quantité saisie : ${l.qte || "vide"}.`); return; }
          continue;
        }
        const la = lignesAvant.get(l.id);
        if (la && la.articleId === l.articleId && String(la.qte) === String(l.qte)) continue;
        const q = Number(String(l.qte).replace(",", "."));
        if (!(q > 0) || !estMultipleDe(q, pas)) {
          setDraftError(`« ${a.designation} » : ${pas === 1 ? "cet article se vend à la tranche entière (1, 2, 3…)" : "cet article se vend au quart de tranche (0,25 ; 0,5 ; 1,75…)"} — quantité saisie : ${l.qte || "vide"}.`);
          return;
        }
      }
    }
    const toSave = { ...draft, reference: draft.reference.trim(), modifiePar: user.nom, modifieLe: new Date().toISOString() };
    // ERP step 11 : date d'envoi mémorisée au passage au statut « Envoyé » (relances).
    {
      const avant = (devisListe || []).find((d) => d.id === draft.id);
      if (toSave.statut === "Envoyé" && (!avant || avant.statut !== "Envoyé")) toSave.envoyeLe = todayISO();
    }
    // Numéro attribué ici, au tout dernier moment avant écriture — pas à
    // l'ouverture du formulaire — pour réduire la fenêtre de collision entre
    // deux personnes qui enregistrent un devis au même moment.
    if (!toSave.numero) {
      toSave.numero = await numeroDocument("DEV", new Date().getFullYear());
      if (!toSave.numero) return;
    }
    const existe = devisListe.some((d) => d.id === toSave.id);
    const precedent = existe ? devisListe.find((d) => d.id === toSave.id) : null;
    const next = existe ? devisListe.map((d) => (d.id === toSave.id ? toSave : d)) : [...devisListe, toSave];
    await persistDevis(next);
    {
      // ERP step 11 : alerte seulement si la remise dépasse la fiche client ET
      // qu'elle est nouvelle (devis créé ou remise modifiée depuis).
      const r = remiseAuDelaFicheClient(toSave);
      const rAvant = precedent ? remiseAuDelaFicheClient(precedent) : null;
      if (r && (!rAvant || rAvant.max !== r.max || precedent.clientId !== toSave.clientId)) {
        await alerter("Remise au-delà de la fiche client", `Devis ${toSave.numero} : remise ${r.max} % pour ${r.client} (fiche client : ${r.remiseClient} %)`, { kind: "devis", id: toSave.id });
      }
      // ERP step 14 (aj15) : remise au-delà du maximum autorisé du commercial (Soufiane Chraa : 32 %).
      const com = idCommercialDuDevis(toSave);
      const pMax = (versionCommissionAu(todayISO()).personnes || []).find((x) => x.id === com && x.remiseMax !== undefined && x.remiseMax !== "");
      if (pMax) {
        const maxL = (d) => Math.max(0, ...((d && d.lignes) || []).filter((l) => l.type !== "descriptif").map((l) => Number(l.remise) || 0));
        const m = maxL(toSave);
        if (m > Number(pMax.remiseMax) && (!precedent || maxL(precedent) !== m || idCommercialDuDevis(precedent) !== com)) {
          await alerter("Remise au-delà du maximum du commercial", `Devis ${toSave.numero} (${(clientDe(toSave.clientId) || {}).nom || ""}) : remise ${m} % — ${pMax.nom} n'est pas autorisé au-delà de ${pMax.remiseMax} %`, { kind: "devis", id: toSave.id });
        }
      }
    }
    await tracerAcces(
      precedent ? "devis modifié" : "devis créé",
      `Devis ${toSave.numero}${precedent && precedent.statut !== toSave.statut ? ` : statut ${precedent.statut} → ${toSave.statut}` : ` (${toSave.statut})`}`
    );
    setDraft(toSave);
    setNotice(`Devis ${toSave.numero} enregistré.`);
    fermerFiche();
  }

  // ERP step 10 (accord Nils du 24/09) : même garde que supprimerCommande.
  // Un devis déjà transformé en dossier ne peut jamais être supprimé — il
  // laisserait un dossier orphelin (devisId pointant vers rien) et, sur un
  // devis exonéré, un crédit d'exonération impossible à restituer. Pour s'en
  // débarrasser, il faut d'abord supprimer le dossier (possible seulement au
  // statut BDC), ce qui fait repasser le devis à "Confirmé". Dans tous les
  // autres cas, la suppression passe par une confirmation explicite.
  function dossierLieAuDevis(d) {
    return (commandesListe || []).find((c) => c.devisId === d.id) || null;
  }
  function supprimerDevis(id) {
    const d = (devisListe || []).find((x) => x.id === id);
    if (!d) return;
    const dossier = dossierLieAuDevis(d);
    if (dossier || d.statut === "Transformé en BDC") {
      setNotice(
        dossier
          ? `Impossible de supprimer le devis ${d.numero || ""} : il est lié au dossier ${dossier.numero} (statut ${dossier.statut}). Supprime d'abord le dossier (possible seulement au statut BDC — sinon utilise "Annuler" pour le redescendre), le devis repassera alors à Confirmé.`
          : `Impossible de supprimer le devis ${d.numero || ""} : il est au statut "Transformé en BDC".`
      );
      return;
    }
    setConfirmationSupprimerDevis(d);
  }
  function confirmerSupprimerDevis() {
    const d = confirmationSupprimerDevis;
    setConfirmationSupprimerDevis(null);
    if (!d) return;
    // Revérification au moment de confirmer : un dossier a pu être créé
    // entre l'ouverture de la confirmation et le clic.
    if (dossierLieAuDevis(d)) {
      setNotice(`Suppression annulée : le devis ${d.numero || ""} vient d'être lié à un dossier.`);
      return;
    }
    persistDevis((devisListe || []).filter((x) => x.id !== d.id));
    tracerAcces("suppression devis", `Devis ${d.numero} supprimé (statut ${d.statut})`);
    alerter("Suppression de devis", `Devis ${d.numero} supprimé (statut ${d.statut})`, null);
    setNotice(`Devis ${d.numero} supprimé.`);
    if (openId === d.id) fermerFiche();
  }

  function changerStatutRapide(id, statut) {
    const avantRapide = (devisListe || []).find((d) => d.id === id);
    persistDevis(devisListe.map((d) => (d.id === id ? { ...d, statut, modifiePar: user.nom, modifieLe: new Date().toISOString() } : d)));
    if (avantRapide && avantRapide.statut !== statut) tracerAcces("devis modifié", `Devis ${avantRapide.numero || ""} : statut ${avantRapide.statut} → ${statut}`);
  }

  // Action explicite et volontaire : contrairement à avant, changer le statut
  // en Confirmé ne crée plus le dossier tout seul — il faut cliquer ici.
  // Marque aussi le devis Confirmé au passage, s'il ne l'était pas déjà.
  // ERP step 8 (accord du 21/09) : pour un devis exonéré, le crédit du
  // registre des tranches exonérables est vérifié et déduit ICI, à la
  // transformation en BDC (plus à la réservation) — la transformation est
  // refusée si le crédit manque pour l'une des tranches du devis.
  async function transformerEnBDC() {
    if (!draft.clientId) {
      setDraftError("Sélectionne un client avant de transformer en BDC.");
      return;
    }
    if (!(draft.reference || "").trim()) {
      setDraftError("Indique la référence de la contremarque avant de transformer en BDC.");
      return;
    }
    // ERP step 10 (demande Nils du 24/09) : l'étage est obligatoire pour le BDC.
    // Nils 08/10 : l'étage n'est obligatoire que s'il y a de la pose.
    if (!(draft.etage || "").trim() && lignesContiennentPose(draft.lignes, articles)) {
      setPopupEtageValeur("");
      setPopupEtage(true);
      return;
    }
    // ERP step 10 pt.11 : un client pas encore validé par Sawsan bloque le BDC.
    {
      const clientBDC = (clients || []).find((x) => x.id === draft.clientId);
      if (clientBDC && clientBDC.aValider) {
        setDraftError(`Impossible de transformer en BDC : le client « ${clientBDC.nom} » est en attente de validation par ${etapeValidationClient(clientBDC) === "etape2" ? "Gérant" : "Administration (puis Gérant)"} (onglet Clients).`);
        return;
      }
    }
    if (draft.lignes.length === 0) {
      setDraftError("Ajoute au moins une ligne avant de transformer en BDC.");
      return;
    }
    let creditsConsommesInit = null;
    if (draft.exonereTVA) {
      const besoins = besoinsCreditPourLignes(draft.lignes);
      const manques = [];
      besoins.forEach((v, cle) => {
        const dispo = creditDisponible(cle);
        if (v.quantite > dispo) manques.push({ ...v, disponible: dispo });
      });
      if (manques.length > 0) {
        setDraftError(
          `Impossible de transformer en BDC : crédit insuffisant dans le registre des tranches exonérables pour ${manques
            .map((m) => `${m.libelle} — ${m.quantite} demandée(s), ${m.disponible} disponible(s)`)
            .join(" ; ")}.`
        );
        return;
      }
      creditsConsommesInit = [...besoins.values()];
    }
    const toSave = { ...draft, statut: "Transformé en BDC", modifiePar: user.nom, modifieLe: new Date().toISOString() };
    if (!toSave.numero) {
      toSave.numero = await numeroDocument("DEV", new Date().getFullYear());
      if (!toSave.numero) return;
    }
    const existe = devisListe.some((d) => d.id === toSave.id);
    const next = existe ? devisListe.map((d) => (d.id === toSave.id ? toSave : d)) : [...devisListe, toSave];
    await persistDevis(next);
    setDraft(toSave);
    setDraftError("");
    await creerCommandeDepuisDevis(toSave, creditsConsommesInit);
  }

  // ---------- Fiche commande ----------
  function ouvrirCommande(id) {
    const c = (commandesListe || []).find((x) => x.id === id);
    if (!c) return;
    // Nils 17/10 : production, bureau technique et pose voient les dossiers au BDC dans la liste, sans
    // pouvoir les ouvrir (le serveur ne leur en envoie que la ligne de liste).
    if (user.commandesSansBDCFacture && c.statut === "BDC") {
      setNotice(`Dossier ${c.numero} au stade BDC : il s'ouvre à partir du RDM.`);
      return;
    }
    if (user.commandesRestreintACommercial) {
      const devisOrigine = (devisListe || []).find((d) => d.id === c.devisId);
      if (!devisOrigine || devisOrigine.commercialSC !== user.nom) return;
    }
    setAfficherReservationsLevees(false);
    setCommandeFicheMessage("");
    let commande = { ...c };
    // Rattrapage : un dossier déjà à une étape (PL, BL…) mais sans numéro
    // dédié — parce qu'il y est arrivé via une migration d'ancien statut,
    // pas via le bouton "Transformer en...", qui est le seul endroit qui
    // génère normalement ce numéro. On le génère maintenant, une bonne
    // fois pour toutes, et on l'enregistre pour que ça reste stable ensuite.
    const etapeActuelle = ETAPES_COMMANDE.find((e) => e.statut === commande.statut);
    // Étape f : le numéro est demandé au serveur ; la fiche s'ouvre tout de suite et le reçoit ensuite.
    // Nils 30/10 : numéro BLS / FAS seulement masqué (réservé au Gérant et à l'Administration) : il existe.
    const numeroMasque = (etapeActuelle && etapeActuelle.champ === "numeroBL" && commande.blsMasque) || (etapeActuelle && etapeActuelle.champ === "numeroFacture" && commande.fasMasque);
    if (etapeActuelle && etapeActuelle.champ !== "numero" && !commande[etapeActuelle.champ] && !numeroMasque) {
      const annee = new Date().getFullYear();
      const exoR = !!((devisListe || []).find((x) => x.id === commande.devisId) || {}).exonereTVA;
      const pfxR = exoR && etapeActuelle.statut === "Facture" ? "FAS" : exoR && etapeActuelle.statut === "BL" ? "BLS" : etapeActuelle.prefixe;
      const sansNumero = commande;
      (async () => {
        const nouveauNumero = await numeroDocument(pfxR, annee);
        if (!nouveauNumero) return;
        const numerotee = { ...sansNumero, [etapeActuelle.champ]: nouveauNumero, modifiePar: user.nom, modifieLe: new Date().toISOString() };
        persistCommandes((commandesListe || []).map((x) => (x.id === numerotee.id ? numerotee : x)));
        setCommandeEditing((ce) => (ce && ce.id === numerotee.id && !ce[etapeActuelle.champ] ? { ...ce, [etapeActuelle.champ]: nouveauNumero } : ce));
      })();
    }
    setCommandeEditing(commande);
    setShowCommandeFiche(true);
    // ERP step 7 (pt.17/18) : tant que le dossier est à un statut où ses
    // lignes restent modifiables (BDC/RDM/PL), on réutilise le même éditeur
    // de lignes que le devis — mais sur un `draft` reconstruit à partir des
    // lignes propres au dossier (commande.lignes), jamais depuis le devis
    // d'origine, désormais figé. `draft.id` reprend le devisId pour rester
    // compatible avec les gardes déjà en place (draft.id === commandeEditing.devisId).
    if (commandeLignesEditables(commande.statut)) {
      const devisOrigine = (devisListe || []).find((d) => d.id === commande.devisId);
      setDraft({
        id: commande.devisId,
        lignes: JSON.parse(JSON.stringify(commande.lignes || [])),
        exonereTVA: !!(devisOrigine && devisOrigine.exonereTVA),
        mentionExonerationTVA: devisOrigine ? devisOrigine.mentionExonerationTVA || "" : "",
      });
    } else {
      setDraft(null);
    }
  }
  function fermerCommandeFiche() {
    setShowCommandeFiche(false);
    setCommandeEditing(null);
    setShowModifierLignesModal(false);
    setShowElementsTechniquesModal(false);
    setShowFichePoseModal(false);
  }
  // Réservation manuelle depuis le dossier : ne réserve rien automatiquement,
  // ça se fait toujours à la main dans le Stock — on transmet juste le BC et
  // le client pour éviter d'avoir à les retaper, et on emmène l'utilisateur
  // choisir lui-même l'article à réserver.
  // Repère, parmi les lignes du devis d'origine, celles dont l'article est
  // relié au Stock (Tranches/Éviers/Accessoires liés) — seules celles-là
  // peuvent donner lieu à une réservation.
  function demarrerReservationDepuisCommande(commande) {
    if (commande && ["BL", "Facture"].includes(commande.statut)) return; // ERP step 10
    const lignes = lignesDuDossier(commande)
      .flatMap((l) => {
        const article = (articles || []).find((a) => a.id === l.articleId);
        if (!article || !article.produitStockId) return [];
        const produit = (produits || []).find((p) => p.id === article.produitStockId);
        if (!produit) return [];
        // Nils 04/10 (o) : une ligne « book-match demandé » se réserve en deux parts, A et B.
        const parts = article.bookmatch && l.bookmatch
          ? [["A", l.qteA === undefined || l.qteA === "" ? Math.ceil((Number(l.qte) || 0) / 2) : Number(l.qteA) || 0], ["B", l.qteB === undefined || l.qteB === "" ? Math.floor((Number(l.qte) || 0) / 2) : Number(l.qteB) || 0]]
          : [["", l.qte]];
        return parts.map(([bm, qte]) => {
          // Une réservation déjà faite pour cette ligne (même BC, même
          // origine) est reprise ici, pour permettre de la modifier plutôt
          // que d'en recréer une en double.
          const resExistante = (reservations || []).find(
            (r) => r.bc === commande.numero && r.ligneId === l.id && r.statut === "active" && (r.bm || "") === bm
          );
          return {
            ligneId: l.id,
            bm,
            designation: bm ? `${l.designation} — book-match ${bm}` : l.chute ? `${l.designation} — chute ${l.chuteDimensions || ""} cm` : l.designation,
            ...(l.chute ? { chute: true, chuteDimensions: l.chuteDimensions || "" } : {}),
            produitId: produit.id,
            produitNom: produit.nom,
            qte: resExistante ? resExistante.quantite : qte,
            reserver: !!resExistante,
            reservationId: resExistante ? resExistante.id : null,
          };
        });
      });
    if (lignes.length === 0) {
      setNotice("Aucun article de ce devis n'est relié au Stock — rien à réserver.");
      return;
    }
    setReservationCommandeCible(commande);
    setReservationPourLe(commande.reservationPourLe || "");
    setReservationLignes(lignes);
    setReservationError("");
    setShowReservationCommande(true);
  }
  // On réserve le produit, pas un lot précis — l'affectation à un lot se
  // fait ensuite depuis le Stock, par qui veut (accès écriture Stock),
  // quand la matière est là. Ça évite d'avoir à créer un lot fictif à 0
  // juste pour pouvoir réserver dessus.
  async function validerReservationCommande() {
    const commande = reservationCommandeCible;
    const aReserver = reservationLignes.filter((l) => l.reserver);
    const aLever = reservationLignes.filter((l) => !l.reserver && l.reservationId);
    if (aReserver.length === 0 && aLever.length === 0) {
      setReservationError("Coche au moins une ligne à réserver.");
      return;
    }
    // Nils 01/10 : toute réservation porte une date approximative de pose.
    if (aReserver.length > 0 && !reservationPourLe) {
      setReservationError("Indique la date approximative de pose (« Réservation pour le… »).");
      return;
    }
    if (aReserver.length > 0 && reservationPourLe < todayISO() && reservationPourLe !== commande.reservationPourLe) {
      setReservationError("La date de pose prévue ne peut pas être dans le passé.");
      return;
    }
    const client = clientDe(commande.clientId);
    const aCreer = aReserver.filter((l) => !l.reservationId);
    const aModifier = aReserver.filter((l) => l.reservationId);

    // ERP step 8 (accord du 21/09) : la réservation ne touche plus jamais au
    // registre des tranches exonérables — ce crédit est désormais déduit à
    // la transformation en BDC et vit sur le dossier (voir
    // creerCommandeDepuisDevis / sauvegarderCommandeEnCours).
    const nouvelles = aCreer.map((l) => ({
      id: uid(),
      itemId: null,
      produitId: l.produitId,
      ligneId: l.ligneId,
      ...(l.bm ? { bm: l.bm, bmGroupe: `${commande.numero}:${l.ligneId}` } : {}),
      // Nils 26/10 (b) : chute vendue — ne s'affecte qu'à un lot « chute » du même produit.
      ...(l.chute ? { chute: true, chuteDimensions: l.chuteDimensions } : {}),
      bc: commande.numero,
      clientId: commande.clientId,
      client: client?.nom || "",
      contact: "",
      chantier: commande.reference || "",
      quantite: Number(l.qte) || 0,
      note: `Réservé depuis le dossier ${commande.numero} (${l.designation})`,
      livraison: "",
      auteur: user.nom,
      modifiePar: user.nom,
      modifieLe: new Date().toISOString(),
      statut: "active",
      creeLe: new Date().toISOString(),
      pourLe: reservationPourLe,
    }));
    let toutes = (reservations || []).map((r) => {
      const modif = aModifier.find((l) => l.reservationId === r.id);
      if (modif) {
        return { ...r, quantite: Number(modif.qte) || 0, pourLe: reservationPourLe, modifiePar: user.nom, modifieLe: new Date().toISOString() };
      }
      const leve = aLever.find((l) => l.reservationId === r.id);
      if (leve) return { ...r, statut: "levee", motifLevee: "annulee", leveeLe: new Date().toISOString(), leveePar: user.nom, modifiePar: user.nom, modifieLe: new Date().toISOString() };
      return r;
    });
    toutes = [...toutes, ...nouvelles];

    await persistReservations(toutes);
    // Une fois la matière réservée, l'étape suivante logique est d'attendre
    // la confirmation du client — on la propose automatiquement, uniquement
    // si le dossier est encore au statut BDC (sinon on ne touche à rien).
    const passeConfirmation = aReserver.length > 0 && commande.statut === "BDC" && commande.enAttenteDe !== "Confirmation client pour RDM";
    const changeDate = aReserver.length > 0 && reservationPourLe !== commande.reservationPourLe;
    if (passeConfirmation || changeDate) {
      const commandeMaj = { ...commande, ...(passeConfirmation ? { enAttenteDe: "Confirmation client pour RDM" } : {}), ...(changeDate ? { reservationPourLe, alerteReservationPour: "" } : {}), modifiePar: user.nom, modifieLe: new Date().toISOString() };
      await persistCommandes((commandesListe || []).map((c) => (c.id === commande.id ? commandeMaj : c)));
      if (commandeEditing && commandeEditing.id === commande.id) setCommandeEditing(commandeMaj);
      if (changeDate) await tracerAcces("réservation : date de pose prévue", `${commande.numero} — réservation pour le ${formatDate(reservationPourLe)}${commande.reservationPourLe ? ` (avant : ${formatDate(commande.reservationPourLe)})` : ""}`);
    }
    setShowReservationCommande(false);
    setReservationError("");
    const parts = [];
    if (nouvelles.length > 0) parts.push(`${nouvelles.length} créée(s)`);
    if (aModifier.length > 0) parts.push(`${aModifier.length} modifiée(s)`);
    if (aLever.length > 0) parts.push(`${aLever.length} levée(s)`);
    setNotice(`Réservations pour ${commande.numero} : ${parts.join(", ")}.`);
  }
  // Action explicite : fait passer le dossier de BDC à RDM, et
  // enregistre tout de suite (contrairement au menu Statut, qui ne fait que
  // modifier le brouillon local tant qu'on n'a pas cliqué "Enregistrer").
  // Si le dossier avait déjà eu un numéro RDM (aller-retour via "Revenir à
  // l'étape précédente"), on le réutilise plutôt que d'en émettre un nouveau
  // — aucun numéro n'est jamais perdu, donc aucun trou dans la séquence.
  async function transformerEnBPRDM() {
    const nouveauStatut = "RDM";
    const annee = new Date().getFullYear();
    const numeroRDM = commandeEditing.numeroRDM || (await numeroDocument("RDM", annee));
    if (!numeroRDM) return;
    const dateRDM = commandeEditing.dateRDM || new Date().toISOString();
    const parRDM = commandeEditing.parRDM || user.nom;
    const toSave = {
      ...commandeEditing,
      statut: nouveauStatut,
      enAttenteDe: ((enAttenteParStatut || DEFAULT_EN_ATTENTE_PAR_STATUT)[nouveauStatut] || [])[0] || "",
      numeroRDM,
      dateRDM,
      parRDM,
      modifiePar: user.nom,
      modifieLe: new Date().toISOString(),
    };
    persistCommandes((commandesListe || []).map((c) => (c.id === toSave.id ? toSave : c)));
    setCommandeEditing(toSave);
    const rappelRDM = rappelConditionsPaiement(toSave.clientId);
    tracerAcces("transformation RDM", `Dossier ${toSave.numero} → RDM (${numeroRDM})`);
    const msgRDM = `Dossier transformé en BPRDM (${numeroRDM}).${rappelRDM ? ` ${rappelRDM}` : ""}`;
    setNotice(msgRDM);
    setCommandeFicheMessage(msgRDM);
  }
  // Action explicite : fait passer le dossier de RDM à PL. Même principe de
  // réutilisation du numéro déjà émis, s'il y en a un.
  async function transformerEnPL() {
    const nouveauStatut = "PL";
    {
      const cl = clientDe(commandeEditing.clientId);
      if (cl && cl.paiement_niveau === "mauvais") {
        alerter("Mauvais payeur en PL", `Dossier ${commandeEditing.numero} passé en PL — client ${cl.nom} classé mauvais payeur`, { kind: "commande", id: commandeEditing.id });
      }
    }
    const annee = new Date().getFullYear();
    const numeroPL = commandeEditing.numeroPL || (await numeroDocument("PL", annee));
    if (!numeroPL) return;
    const datePL = commandeEditing.datePL || new Date().toISOString();
    const parPL = commandeEditing.parPL || user.nom;
    const toSave = {
      ...commandeEditing,
      statut: nouveauStatut,
      enAttenteDe: ((enAttenteParStatut || DEFAULT_EN_ATTENTE_PAR_STATUT)[nouveauStatut] || [])[0] || "",
      numeroPL,
      datePL,
      parPL,
      modifiePar: user.nom,
      modifieLe: new Date().toISOString(),
    };
    persistCommandes((commandesListe || []).map((c) => (c.id === toSave.id ? toSave : c)));
    setCommandeEditing(toSave);
    const rappelPL = rappelConditionsPaiement(toSave.clientId);
    tracerAcces("transformation PL", `Dossier ${toSave.numero} → PL (${numeroPL})`);
    const msgPL = `Dossier transformé en PL (${numeroPL}).${rappelPL ? ` ${rappelPL}` : ""}`;
    setNotice(msgPL);
    setCommandeFicheMessage(msgPL);
  }
  // Action explicite : fait passer le dossier de PL à BL. Même principe de
  // réutilisation — indispensable ici, pas de trou toléré sur le BL.
  async function transformerEnBL() {
    const nouveauStatut = "BL";
    const annee = new Date().getFullYear();
    // Un BL sur une commande exonérée de TVA porte le sigle "BLS" (terme déjà
    // en usage) — même étape, même circuit, mais une numérotation qui lui
    // est propre : le serveur compte séparément par préfixe (étape f), donc
    // BLS-2026-XXXX et BL-2026-XXXX avancent chacun de leur côté.
    const devisOrigine = (devisListe || []).find((d) => d.id === commandeEditing.devisId);
    const exonere = !!(devisOrigine && devisOrigine.exonereTVA);
    const prefixeBL = exonere ? "BLS" : "BL";
    const numeroBL = commandeEditing.numeroBL || (await numeroDocument(prefixeBL, annee));
    if (!numeroBL) return;
    const dateBL = commandeEditing.dateBL || new Date().toISOString();
    const parBL = commandeEditing.parBL || user.nom;
    const toSave = {
      ...commandeEditing,
      statut: nouveauStatut,
      enAttenteDe: ((enAttenteParStatut || DEFAULT_EN_ATTENTE_PAR_STATUT)[nouveauStatut] || [])[0] || "",
      numeroBL,
      dateBL,
      parBL,
      modifiePar: user.nom,
      modifieLe: new Date().toISOString(),
    };
    persistCommandes((commandesListe || []).map((c) => (c.id === toSave.id ? toSave : c)));
    setCommandeEditing(toSave);
    tracerAcces(`transformation ${prefixeBL}`, `Dossier ${toSave.numero} → ${prefixeBL} (${numeroBL})`);
    const rappelBL = rappelConditionsPaiement(toSave.clientId);
    const msgBL = `Dossier transformé en ${prefixeBL} (${numeroBL}).${rappelBL ? ` ${rappelBL}` : ""}`;
    setNotice(msgBL);
    setCommandeFicheMessage(msgBL);
  }
  // Action explicite : fait passer le dossier de BL à Facture. Même
  // principe de réutilisation — indispensable ici aussi, pas de trou toléré.
  async function transformerEnFacture() {
    const nouveauStatut = "Facture";
    // Date choisie dans la confirmation (aujourd'hui par défaut, jusqu'à JOURS_ANTIDATE_FACTURE jours en arrière).
    const choisie = dateFactureRef.current;
    const antidatee = !!choisie && choisie < todayISO();
    const annee = antidatee ? Number(choisie.slice(0, 4)) : new Date().getFullYear();
    const pfxFA = prefixeFacture(commandeEditing);
    if (!commandeEditing.numeroFacture) {
      const derniere = derniereDateFacture(annee, pfxFA);
      const dateVoulue = antidatee ? choisie : todayISO();
      const dateBLd = commandeEditing.dateBL ? String(commandeEditing.dateBL).slice(0, 10) : "";
      if (dateBLd && dateVoulue < dateBLd) { setNotice(`Impossible : la facture ne peut pas être datée avant le BL (${formatDate(dateBLd)}).`); dateFactureRef.current = ""; return; }
      if (derniere && dateVoulue < derniere) { setNotice(`Impossible : la dernière facture de ${annee} est datée du ${formatDate(derniere)}. Une nouvelle facture ne peut pas être antérieure (la numérotation suit l'ordre des dates).`); dateFactureRef.current = ""; return; }
    }
    const numeroFacture = commandeEditing.numeroFacture || (await numeroDocument(pfxFA, annee));
    if (!numeroFacture) { dateFactureRef.current = ""; return; }
    const dateFacture = commandeEditing.dateFacture || (antidatee ? `${choisie}T12:00:00.000Z` : new Date().toISOString());
    const parFacture = commandeEditing.parFacture || user.nom;
    const toSave = {
      ...commandeEditing,
      statut: nouveauStatut,
      // Nils 03/10 : chaque facture créée part « en attente de : Envoi client par mail » (tâche Sawsan).
      enAttenteDe: "Envoi client par mail",
      numeroFacture,
      dateFacture,
      parFacture,
      // Nils 29/10 : déductions du projet (avance, retenue, prorata) figées sur la facture.
      ...(deductionsDossier(commandeEditing) ? { deductionsProjet: deductionsDossier(commandeEditing) } : {}),
      modifiePar: user.nom,
      modifieLe: new Date().toISOString(),
    };
    persistCommandes((commandesListe || []).map((c) => (c.id === toSave.id ? toSave : c)));
    setCommandeEditing(toSave);
    tracerAcces("transformation Facture", `Dossier ${toSave.numero} → Facture (${numeroFacture})${antidatee ? ` — datée du ${formatDate(choisie)} (saisie le ${formatDate(todayISO())})` : ""}`);
    dateFactureRef.current = "";
    const rappelFA = rappelConditionsPaiement(toSave.clientId);
    const msgFA = `Dossier transformé en Facture (${numeroFacture}).${rappelFA ? ` ${rappelFA}` : ""}`;
    setNotice(msgFA);
    setCommandeFicheMessage(msgFA);
  }
  // ---------- Nils 17/10 : facture groupée — plusieurs BL d'un même projet immobilier ----------
  // Un seul numéro FA (ou FAS) porté par tous les dossiers du groupe (factureGroupeeId) ; chaque
  // dossier garde sa marge, ses paiements et ses avoirs. Référence de la facture : nom du projet +
  // numéro d'ordre (« La Maalif 1 »). Une ligne par BL : n° de BL, projet – bâtiment – étage –
  // appartement, montant HT. Envoi, remise, transmission et annulation valent pour tout le groupe.
  function dossiersDuGroupe(c) {
    if (!c) return [];
    if (!c.factureGroupeeId) return [c];
    return (commandesListe || []).filter((x) => x.factureGroupeeId === c.factureGroupeeId);
  }
  function dossiersErpDuProjet(ch) {
    return (commandesListe || []).filter((c) => !c.anterieure && chantierDuDossier(c) === ch.id);
  }
  function blFacturablesDuProjet(ch) {
    return dossiersErpDuProjet(ch).filter((c) => c.statut === "BL" && c.numeroBL && !c.numeroFacture).sort((a, b) => String(a.numeroBL).localeCompare(String(b.numeroBL)));
  }
  function facturesGroupeesDuProjet(ch) {
    const groupes = new Map();
    dossiersErpDuProjet(ch).filter((c) => c.factureGroupeeId && c.numeroFacture).forEach((c) => groupes.set(c.factureGroupeeId, [...(groupes.get(c.factureGroupeeId) || []), c]));
    return [...groupes.values()].sort((a, b) => (Number(a[0].ordreFactureGroupee) || 0) - (Number(b[0].ordreFactureGroupee) || 0));
  }
  function libLigneFactureGroupee(c) {
    const ch = (chantiers || []).find((x) => x.id === chantierDuDossier(c));
    const d = devisDuDossier(c) || {};
    const l = ch && d.logementId ? (ch.logements || []).find((x) => x.id === d.logementId) : null;
    const lieu = l
      ? [libBatiment(l.batiment), l.etage !== "" && l.etage != null ? `Ét. ${l.etage}` : "", l.appart ? `Apt ${l.appart}` : ""]
      : [c.reference || d.reference || "", c.etage || d.etage ? `Ét. ${c.etage || d.etage}` : ""];
    return [ch ? ch.nom : "", ...lieu].filter(Boolean).join(" – ");
  }
  function ouvrirFactureGroupee(ch) {
    if (user.commandesSansTransformBLFacture || user.commandesSansBDCFacture) { setNotice("La facturation est réservée au Gérant et à l'Administration."); return; }
    setFactGroupe({ chantierId: ch.id, ids: [], date: todayISO(), erreur: "" });
  }
  async function facturerPlusieursBL() {
    const f = factGroupe;
    if (!f) return;
    const err = (m) => setFactGroupe({ ...f, erreur: m });
    if (user.commandesSansTransformBLFacture || user.commandesSansBDCFacture) return err("La facturation est réservée au Gérant et à l'Administration.");
    const ch = (chantiers || []).find((x) => x.id === f.chantierId);
    if (!ch) return err("Projet introuvable.");
    const sel = blFacturablesDuProjet(ch).filter((c) => f.ids.includes(c.id));
    if (sel.length < 2) return err("Coche au moins deux BL (pour un seul BL, facture le dossier depuis sa fiche).");
    if (new Set(sel.map((c) => c.clientId)).size > 1) return err("Les BL cochés n'ont pas tous le même client facturé.");
    const pfx = prefixeFacture(sel[0]);
    if (sel.some((c) => prefixeFacture(c) !== pfx)) return err("Les BL cochés mélangent des dossiers exonérés et non exonérés : une facture FA et une facture FAS ne se regroupent pas.");
    for (const c of sel) {
      if (!consoPoseOK(c)) return err(`${c.numeroBL} : aucun consommable de pose enregistré (ou « aucun consommable de pose » à déclarer).`);
      if (fichePoseRequise(c) && !fichePoseRemplie(c.fichePose)) return err(`${c.numeroBL} : la fiche de pose n'est pas remplie.`);
    }
    const date = f.date || todayISO();
    const annee = Number(date.slice(0, 4));
    const blMax = sel.map((c) => String(c.dateBL || "").slice(0, 10)).sort().slice(-1)[0] || "";
    const derniere = derniereDateFacture(annee, pfx);
    const d7 = decalerJours(todayISO(), -JOURS_ANTIDATE_FACTURE);
    if (date > todayISO()) return err("La date de la facture ne peut pas être dans le futur.");
    if (date < d7) return err(`La facture ne peut pas être datée de plus de ${JOURS_ANTIDATE_FACTURE} jours en arrière.`);
    if (blMax && date < blMax) return err(`La facture ne peut pas être datée avant le BL le plus récent (${formatDate(blMax)}).`);
    if (derniere && date < derniere) return err(`La dernière facture ${pfx} de ${annee} est datée du ${formatDate(derniere)} : une nouvelle facture ne peut pas être antérieure.`);
    const ordre = facturesGroupeesDuProjet(ch).reduce((m, g) => Math.max(m, Number(g[0].ordreFactureGroupee) || 0), 0) + 1;
    const ref = `${ch.nom} ${ordre}`;
    const totalHT = sel.reduce((n, c) => n + htDossier(c), 0);
    if (!(await demander(`Facturer ${sel.length} BL sur une seule facture « ${ref} » (${formatDH(totalHT)} HT), datée du ${formatDate(date)} ?\n\n${sel.map((c) => `${c.numeroBL} — ${libLigneFactureGroupee(c)}`).join("\n")}\n\nC'est irréversible, comme une facture simple.`))) return;
    const numeroFacture = await numeroDocument(pfx, annee);
    if (!numeroFacture) return;
    const dateFacture = date < todayISO() ? `${date}T12:00:00.000Z` : new Date().toISOString();
    const gid = uid();
    const maintenant = new Date().toISOString();
    const ids = new Set(sel.map((c) => c.id));
    // Nils 29/10 : déductions du projet figées, l'avance décomptée BL après BL.
    const deds = {};
    {
      let solde = avanceProjetHT(ch) - avanceRembourseeHT(ch);
      for (const c of sel.slice().sort((a, b) => String(a.numeroBL).localeCompare(String(b.numeroBL)))) {
        const dp = deductionsDossier(c, solde);
        if (dp) { deds[c.id] = dp; solde = arrondiH(solde - dp.avance); }
      }
    }
    const ok = await persistCommandes((commandesListe || []).map((c) => (ids.has(c.id)
      ? { ...c, statut: "Facture", enAttenteDe: "Envoi client par mail", numeroFacture, dateFacture, parFacture: user.nom, factureGroupeeId: gid, refFactureGroupee: ref, ordreFactureGroupee: ordre, ...(deds[c.id] ? { deductionsProjet: deds[c.id] } : {}), modifiePar: user.nom, modifieLe: maintenant }
      : c)));
    if (ok === false) return;
    await tracerAcces("facture groupée", `${numeroFacture} « ${ref} » — ${sel.map((c) => c.numeroBL).join(", ")} — ${formatDH(totalHT)} HT`);
    setFactGroupe(null);
    const rappel = rappelConditionsPaiement(sel[0].clientId);
    setNotice(`Facture groupée ${numeroFacture} « ${ref} » créée (${sel.length} BL).${rappel ? ` ${rappel}` : ""}`);
  }
  function imprimerFactureGroupee(c) {
    const groupe = dossiersDuGroupe(c).slice().sort((a, b) => String(a.numeroBL).localeCompare(String(b.numeroBL)));
    const d0 = devisDuDossier(c) || {};
    const lignes = groupe.map((x) => ({ id: x.id, numeroBL: x.numeroBL, designation: libLigneFactureGroupee(x), prixPublic: Math.round(htDossier(x) * 100) / 100, qte: 1, remise: 0, unite: "", type: "facture" }));
    const source = { clientId: c.clientId, reference: c.refFactureGroupee || "", date: String(c.dateFacture || "").slice(0, 10), lignes, remiseGlobale: 0, exonereTVA: !!d0.exonereTVA, chantierId: chantierDuDossier(c), notes: [] };
    const html = construireHtmlDocument(source, { titre: "FACTURE", numeroAffiche: c.numeroFacture, dateDocument: c.dateFacture, parBL: true, deductions: sommeDeductions(groupe.map((x) => deductionsDossier(x))) });
    telechargerDocument(html, nomFichierDocument(c.numeroFacture, (clientDe(c.clientId) || {}).nom, c.refFactureGroupee), "facture");
  }

  // ---------- Nils 03/10 : annulation d'une facture ou d'un BL (m) ----------
  // Numéros déjà pris : dossiers + documents de remplacement.
  function listeNumerotation() {
    return [...(commandesListe || []), ...(remplacements || []).map((r) => (r.type === "Facture" ? { numeroFacture: r.numero } : { numeroBL: r.numero })), ...(facturesAvance || []).map((f) => ({ numeroFacture: f.numero }))];
  }
  // Vrai si ce numéro est le plus haut de sa série (préfixe + année).
  function estDernierNumero(champ, numero) {
    const m = String(numero || "").match(/^(.*-\d{4}-)(\d+)$/);
    if (!m) return true;
    const n = Number(m[2]);
    return !listeNumerotation().some((c) => { const x = String(c[champ] || ""); return x.startsWith(m[1]) && Number(x.slice(m[1].length)) > n; });
  }
  // Step 17 (audit, Nils 15/10) : date de la dernière facture émise dans la série FA-AAAA
  // (dossiers + factures de remplacement) — une nouvelle facture ne peut pas être antérieure.
  function prefixeFacture(c) {
    const d = c ? (devisListe || []).find((x) => x.id === c.devisId) : null;
    return d && d.exonereTVA ? "FAS" : "FA"; // Step 17 (Nils 15/10) : série à part pour les factures exo
  }
  function derniereDateFacture(annee, prefixe) {
    const pfx = `${prefixe || "FA"}-${annee}-`;
    let max = "";
    (commandesListe || []).forEach((c) => { if (String(c.numeroFacture || "").startsWith(pfx) && c.dateFacture) { const d = String(c.dateFacture).slice(0, 10); if (d > max) max = d; } });
    (remplacements || []).forEach((r) => { if (r.type === "Facture" && String(r.numero || "").startsWith(pfx) && r.date) { const d = String(r.date).slice(0, 10); if (d > max) max = d; } });
    (facturesAvance || []).forEach((f) => { if (String(f.numero || "").startsWith(pfx) && f.date) { const d = String(f.date).slice(0, 10); if (d > max) max = d; } });
    return max;
  }
  function minDateFacture(c) {
    const d7 = decalerJours(todayISO(), -JOURS_ANTIDATE_FACTURE);
    const der = derniereDateFacture(new Date().getFullYear(), prefixeFacture(c));
    const bl = c && c.dateBL ? String(c.dateBL).slice(0, 10) : ""; // Step 17 : jamais avant le BL
    return [d7, der, bl].filter(Boolean).sort().slice(-1)[0];
  }
  // ---------- Step 17 (Nils 15/10) : factures d'avoir clients ----------
  function exoFactureAvoir(c) {
    return c && c.anterieure ? !!c.exoAnt : !!tvaDossier(c).exo;
  }
  function serieAvoir(exo) {
    return exo ? "AVS" : "AV";
  }
  function derniereDateAvoir(serie, annee) {
    const pfx = `${serie}-${annee}-`;
    return (avoirs || []).filter((a) => String(a.numero || "").startsWith(pfx)).reduce((m, a) => (String(a.date || "") > m ? String(a.date) : m), "");
  }
  function minDateAvoir(serie) {
    const d7 = decalerJours(todayISO(), -JOURS_ANTIDATE_FACTURE);
    const der = derniereDateAvoir(serie, new Date().getFullYear());
    return der && der > d7 ? der : d7;
  }
  function avoirsDeFacture(factureId) {
    return (avoirs || []).filter((a) => a.factureId === factureId);
  }
  function remboursementsAvoir(a) {
    return (operations || []).filter((o) => o.avoirId === a.id && !o.miroirDe && o.sens === "sortie");
  }
  function creditRestantAvoir(a) {
    const pris = (affectationsCredit || []).filter((x) => x.de === `av:${a.id}`).reduce((n, x) => n + (Number(x.montant) || 0), 0);
    const rembourse = remboursementsAvoir(a).reduce((n, o) => n + (Number(o.montant) || 0), 0);
    return arrondiH((Number(a.ttc) || 0) - pris - rembourse);
  }
  function comptesRemboursement() {
    return (comptesTreso || []).filter((c) => peutSaisirCompte(c) && c.id !== CAISSE_GENERALE_ID && c.id !== PORTEFEUILLE_ID && !estCompteDevises(c));
  }
  function ouvrirRemboursementAvoir(a) {
    if (!a || !peut("commandes.avoirs")) return;
    const cpts = comptesRemboursement();
    const cfg = cpts.find((c) => c.type === "banque");
    setRembAvoir({ avoirId: a.id, compteId: (cfg || cpts[0] || {}).id || "", date: todayISO(), mode: "Virement", piece: "", montant: String(creditRestantAvoir(a)).replace(".", ","), erreur: "" });
  }
  async function enregistrerRemboursementAvoir() {
    const r = rembAvoir;
    if (!r || !peut("commandes.avoirs")) return;
    const a = (avoirs || []).find((x) => x.id === r.avoirId);
    const err = (m) => setRembAvoir({ ...r, erreur: m });
    if (!a) return err("Avoir introuvable.");
    const compte = compteDe(r.compteId);
    if (!compte || !comptesRemboursement().some((c) => c.id === compte.id)) return err("Choisis le compte qui rembourse.");
    const v = parseMontantSaisi(String(r.montant || ""));
    const reste = creditRestantAvoir(a);
    if (!isFinite(v) || v <= 0 || v > reste + 0.01) return err(`Montant invalide : au plus ${formatDH(reste)} (crédit restant de l'avoir).`);
    if (!r.date || r.date > todayISO()) return err("Indique une date (pas dans le futur).");
    if (moisVerrouille(compte.id, r.date)) return err(`Le mois du ${formatDate(r.date)} est clôturé pour ${compte.nom}.`);
    const cl = clientDe(a.clientId) || {};
    const op = { id: uid(), compteId: compte.id, date: r.date, sens: "sortie", montant: arrondiH(v), type: "normal", tiersType: "client", tiers: cl.nom || "", designation: `Remboursement avoir ${a.numero} (facture ${a.factureNumero})`, piece: String(r.piece || "").trim(), mode: r.mode || "Virement", poste: POSTE_ENCAISSEMENT, sousPoste: POSTE_ENCAISSEMENT, dossierId: `av:${a.id}`, avoirId: a.id, par: user.nom, le: new Date().toISOString() };
    await persistOperations([...(operations || []), op]);
    await tracerAcces("avoir remboursé", `${a.numero} — ${cl.nom || ""} — ${formatDH(op.montant)} depuis ${compte.nom} (${op.mode})`);
    setRembAvoir(null);
    setNotice(`Remboursement de ${formatDH(op.montant)} enregistré dans ${compte.nom} — crédit restant de ${a.numero} : ${formatDH(creditRestantAvoir(a) - op.montant)}.`);
  }
  // Lignes de la facture qui peuvent faire l'objet d'un avoir, avec la quantité déjà reprise.
  function lignesAvoirables(c) {
    if (!c || c.anterieure) return [];
    const deja = {};
    avoirsDeFacture(c.id).forEach((a) => (a.lignes || []).forEach((l) => { deja[l.ligneId] = (deja[l.ligneId] || 0) + (Number(l.qte) || 0); }));
    return (lignesDuDossier(c) || []).filter((l) => l.type !== "descriptif" && Number(l.qte) > 0).map((l) => ({ l, prixHT: calcLigne(l).prixRevise, deja: deja[l.id] || 0, reste: arrondiH((Number(l.qte) || 0) - (deja[l.id] || 0)) }));
  }
  function calculAvoir(e, c) {
    const exo = exoFactureAvoir(c);
    let lignes = [], ht = 0;
    if (e.mode === "lignes") {
      lignesAvoirables(c).forEach(({ l, prixHT }) => {
        const q = parseMontantSaisi(String((e.qtes || {})[l.id] ?? ""));
        if (isFinite(q) && q > 0) lignes.push({ ligneId: l.id, articleId: l.articleId || "", designation: l.designation, unite: l.unite || "", qte: q, prixHT });
      });
      ht = lignes.reduce((n, l) => n + l.qte * l.prixHT, 0);
    } else {
      const v = parseMontantSaisi(String(e.montantHT || ""));
      ht = isFinite(v) ? v : 0;
    }
    ht = arrondiH(ht);
    const tva = exo ? 0 : arrondiH(ht * TVA_TAUX);
    return { exo, lignes, ht, tva, ttc: arrondiH(ht + tva) };
  }
  function ouvrirNouvelAvoir(c) {
    if (!c || !peut("commandes.avoirs")) return;
    setAvoirEdit({ factureId: c.id, mode: c.anterieure ? "montant" : "lignes", qtes: {}, montantHT: "", motif: "", date: todayISO(), erreur: "" });
  }
  async function enregistrerAvoir() {
    const e = avoirEdit;
    if (!e || !peut("commandes.avoirs")) return;
    const c = dossierParId(e.factureId);
    const err = (m) => setAvoirEdit({ ...e, erreur: m });
    if (!c || !c.numeroFacture) return err("Facture introuvable.");
    const motif = String(e.motif || "").trim();
    if (!motif) return err("Indique le motif de l'avoir.");
    const calc = calculAvoir(e, c);
    if (e.mode === "lignes") {
      const trop = lignesAvoirables(c).find(({ l, reste }) => { const q = parseMontantSaisi(String((e.qtes || {})[l.id] ?? "")); return isFinite(q) && q > reste + 0.0001; });
      if (trop) return err(`« ${trop.l.designation} » : au plus ${String(trop.reste).replace(".", ",")} (quantité facturée moins les avoirs déjà faits).`);
      if (!calc.lignes.length) return err("Indique au moins une quantité.");
    }
    if (!(calc.ht > 0)) return err("Le montant de l'avoir doit être positif.");
    const ttcFacture = arrondiH(totalDossierTTC(c));
    const dejaTTC = arrondiH(avoirsDeFacture(c.id).reduce((n, a) => n + (Number(a.ttc) || 0), 0));
    if (calc.ttc > ttcFacture - dejaTTC + 0.01) return err(`Trop élevé : la facture fait ${formatDH(ttcFacture)} TTC${dejaTTC ? `, dont ${formatDH(dejaTTC)} déjà repris en avoir` : ""} — au plus ${formatDH(ttcFacture - dejaTTC)} TTC.`);
    const serie = serieAvoir(calc.exo);
    const date = e.date || todayISO();
    if (date > todayISO()) return err("La date ne peut pas être dans le futur.");
    const annee = Number(date.slice(0, 4));
    const der = derniereDateAvoir(serie, annee);
    if (date < decalerJours(todayISO(), -JOURS_ANTIDATE_FACTURE) || (der && date < der)) return err(`Date trop ancienne : au plus ${JOURS_ANTIDATE_FACTURE} jours en arrière${der ? `, et jamais avant le dernier avoir ${serie} (${formatDate(der)})` : ""}.`);
    const numero = await numeroDocument(serie, annee);
    if (!numero) return;
    if (!(await demander(`Créer l'avoir ${numero} de ${formatDH(calc.ttc)} TTC sur la facture ${c.numeroFacture} ?\n\nLe montant devient un crédit sur le compte du client, à affecter ensuite à une facture.`))) return;
    const av = { id: uid(), numero, serie, date, factureId: c.id, factureNumero: c.numeroFacture, factureDate: String(c.dateFacture || "").slice(0, 10), clientId: c.clientId, exo: calc.exo, mode: e.mode, lignes: calc.lignes, motif, ht: calc.ht, tva: calc.tva, ttc: calc.ttc, par: user.nom, le: new Date().toISOString() };
    await persistAvoirs([...(avoirs || []), av]);
    await tracerAcces("facture d'avoir créée", `${numero} — ${(clientDe(c.clientId) || {}).nom || ""} — sur ${c.numeroFacture} — ${formatDH(calc.ttc)} TTC — ${motif}`);
    const commissionVue = Object.values((commissions && commissions.validations) || {}).some((v) => (v.dossiers || []).includes(c.id));
    if (commissionVue) await alerter("Avoir sur un dossier déjà commissionné", `${numero} (${formatDH(calc.ht)} HT) sur ${c.numeroFacture} : une commission a déjà été validée sur ce dossier — à régulariser si besoin.`, c.anterieure ? { kind: "onglet", id: "commissions" } : { kind: "commande", id: c.id });
    setAvoirEdit(null);
    setNotice(`Avoir ${numero} créé : ${formatDH(calc.ttc)} TTC en crédit sur le compte du client.`);
  }
  async function annulerAvoir(a) {
    if (!a || !peut("commandes.avoirs")) return;
    const pfx = `${a.serie}-${String(a.date).slice(0, 4)}-`;
    const plusRecent = (avoirs || []).some((x) => String(x.numero).startsWith(pfx) && x.numero > a.numero);
    if (a.envoyeClientLe || a.transmisComptableLe) { setNotice(`L'avoir ${a.numero} a déjà été ${a.transmisComptableLe ? "transmis au comptable" : "envoyé au client"} : il ne s'annule plus.`); return; }
    if (plusRecent) { setNotice(`L'avoir ${a.numero} n'est pas le dernier de sa série : il ne s'annule plus (pas de trou de numérotation).`); return; }
    if (creditRestantAvoir(a) < (Number(a.ttc) || 0) - 0.01) { setNotice(`Le crédit de l'avoir ${a.numero} a déjà été affecté : retire d'abord l'affectation.`); return; }
    if (!(await demander(`Annuler l'avoir ${a.numero} (${formatDH(a.ttc)} TTC) ? Son numéro sera réutilisé.`, { danger: true }))) return;
    await persistAvoirs((avoirs || []).filter((x) => x.id !== a.id));
    await tracerAcces("facture d'avoir annulée", `${a.numero} — sur ${a.factureNumero}`);
    setNotice(`Avoir ${a.numero} annulé.`);
  }
  async function cocherSuiviAvoir(a, champ, coche) {
    if (!a || !peut("commandes.suiviFacture")) return;
    const maintenant = new Date().toISOString();
    let patch;
    if (champ === "comptable") {
      if (!coche) { if (a.transmisComptableLe) setNotice(`L'avoir ${a.numero} a été transmis au comptable : c'est définitif.`); return; }
      if (!(await demander(`Marquer l'avoir ${a.numero} comme transmis au comptable ?\n\nC'est définitif.`))) return;
      patch = { transmisComptableLe: maintenant, transmisComptablePar: user.nom };
    } else patch = coche ? { envoyeClientLe: maintenant, envoyeClientPar: user.nom } : { envoyeClientLe: "", envoyeClientPar: "" };
    await persistAvoirs((avoirs || []).map((x) => (x.id === a.id ? { ...x, ...patch } : x)));
    await tracerAcces("suivi avoir", `${a.numero} — ${coche ? "" : "décoché : "}${champ === "comptable" ? "transmis au comptable" : "envoyé au client"}`);
  }
  function imprimerAvoir(a) {
    const c = dossierParId(a.factureId);
    const d = c && !c.anterieure ? (devisListe || []).find((x) => x.id === c.devisId) || {} : {};
    const base = c && !c.anterieure ? devisPourImpression(c, d) : { clientId: a.clientId, chantierId: c ? c.chantierId || "" : "", reference: c ? c.reference || "" : "" };
    const lignes = a.mode === "lignes"
      ? (a.lignes || []).map((l) => ({ id: l.ligneId, type: "facture", articleId: l.articleId || "", designation: l.designation, unite: l.unite, qte: l.qte, prixPublic: l.prixHT, remise: 0 }))
      : [{ id: "m", type: "facture", articleId: "", designation: a.motif, unite: "forfait", qte: 1, prixPublic: a.ht, remise: 0 }];
    const source = { ...base, clientId: a.clientId, lignes, exonereTVA: !!a.exo, remiseGlobale: 0, notes: [`Avoir sur la facture ${a.factureNumero}${a.factureDate ? ` du ${formatDate(a.factureDate)}` : ""}.`, `Motif : ${a.motif}`, "Montant porté au crédit de votre compte client."] };
    const html = construireHtmlDocument(source, { titre: "FACTURE D'AVOIR", numeroAffiche: a.numero, dateDocument: a.date });
    telechargerDocument(html, nomFichierDocument(a.numero, (clientDe(a.clientId) || {}).nom, a.factureNumero), "facture d'avoir");
  }
  // Effets des avoirs sur le CA (Nils 15/10) : CA facturé diminué à la date de l'avoir.
  function renderAvoirsFacture(c) {
    if (!c || !c.numeroFacture) return null;
    // Montants : mêmes personnes que pour les montants des projets (pas la production).
    if (!(estGerant || user.acces.devis || peut("clients.etat"))) return null;
    const liste = avoirsDeFacture(c.id).sort((a, b) => (a.numero < b.numero ? -1 : 1));
    const peutAv = peut("commandes.avoirs");
    if (!liste.length && !peutAv) return null;
    const peutSuivi = peut("commandes.suiviFacture");
    return (
      <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "10px 14px", marginBottom: 14 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: liste.length ? 6 : 0 }}>
          <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>Factures d'avoir{liste.length ? ` (${liste.length})` : ""}</div>
          {peutAv && <button type="button" className="sc-btn" onClick={() => ouvrirNouvelAvoir(c)} style={{ ...ghostBtnStyle, padding: "4px 10px", fontSize: 12 }}>+ Créer un avoir</button>}
        </div>
        {liste.map((a) => {
          const reste = creditRestantAvoir(a);
          return (
            <div key={a.id} style={{ borderTop: `1px solid ${PIERRE}`, padding: "6px 0", fontSize: 13 }}>
              <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                <strong>{a.numero}</strong>
                <span style={{ color: TAUPE }}>{formatDate(a.date)}</span>
                <span>{formatDH(a.ttc)} TTC</span>
                <span style={{ color: TAUPE, flex: 1, minWidth: 120 }}>{a.motif}</span>
                <span style={{ fontSize: 12, color: reste > 0.01 ? OCRE : VERT_OK }}>{reste > 0.01 ? `crédit à affecter : ${formatDH(reste)}` : "crédit soldé"}</span>
                {peutAv && reste > 0.01 && comptesRemboursement().length > 0 && <button type="button" className="sc-btn" onClick={() => ouvrirRemboursementAvoir(a)} style={{ ...ghostBtnStyle, padding: "2px 8px", fontSize: 11 }} title="Le client avait déjà payé : rembourser tout ou partie de l'avoir">Rembourser</button>}
                <button type="button" className="sc-btn" onClick={() => imprimerAvoir(a)} style={iconBtnStyle} title="Télécharger la facture d'avoir">🖨</button>
                {peutAv && !a.envoyeClientLe && !a.transmisComptableLe && <button type="button" className="sc-btn" onClick={() => annulerAvoir(a)} style={{ ...iconBtnStyle, color: ROUILLE }} title="Annuler l'avoir (seulement le dernier de sa série, avant envoi)">⊘</button>}
              </div>
              {remboursementsAvoir(a).map((o) => <div key={o.id} style={{ fontSize: 12, color: TAUPE }}>Remboursé {formatDH(o.montant)} le {formatDate(o.date)} — {(compteDe(o.compteId) || {}).nom} · {o.mode}{o.piece ? ` · ${o.piece}` : ""}</div>)}
              <div style={{ display: "flex", gap: 16, fontSize: 12, marginTop: 2, flexWrap: "wrap" }}>
                <label style={{ display: "flex", alignItems: "center", gap: 6, opacity: peutSuivi || a.envoyeClientLe ? 1 : 0.6 }}>
                  <input type="checkbox" checked={!!a.envoyeClientLe} disabled={!peutSuivi || !!a.transmisComptableLe} onChange={(e) => cocherSuiviAvoir(a, "envoye", e.target.checked)} />
                  Envoyé au client{a.envoyeClientLe ? <span style={{ color: TAUPE }}> — le {formatDate(a.envoyeClientLe)} par {a.envoyeClientPar}</span> : null}
                </label>
                <label style={{ display: "flex", alignItems: "center", gap: 6, opacity: peutSuivi || a.transmisComptableLe ? 1 : 0.6 }}>
                  <input type="checkbox" checked={!!a.transmisComptableLe} disabled={!peutSuivi || !!a.transmisComptableLe} onChange={(e) => cocherSuiviAvoir(a, "comptable", e.target.checked)} />
                  Transmis au comptable{a.transmisComptableLe ? <span style={{ color: TAUPE }}> — le {formatDate(a.transmisComptableLe)} par {a.transmisComptablePar}</span> : <span style={{ color: TAUPE }}> — définitif une fois coché</span>}
                </label>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
  function commandeParIdAvoir(a) {
    return (commandesListe || []).find((c) => c.id === a.factureId) || null;
  }
  function avoirsEntre(du, au) {
    return (avoirs || []).filter((a) => a.date >= du && a.date <= au);
  }
  function factureTransmise(c) {
    return !!(c && (c.envoyeeClientLe || c.remiseClientLe || c.transmiseComptableLe));
  }
  async function demanderAnnulationDocument(type) {
    const c = commandeEditing;
    if (!c || !peut("commandes.annulerFactureBL")) return;
    const champ = type === "Facture" ? "numeroFacture" : "numeroBL";
    const numero = c[champ];
    if (!numero) return;
    if (type === "BL" && c.statut !== "BL") { setNotice("Annule d'abord la facture : le BL d'un dossier facturé ne s'annule pas directement."); return; }
    // ERP step 14 (Nils 05/10) : BLS (exo) — seul Nils annule ; jamais de remplacement, trou de numérotation accepté.
    const bls = type === "BL" && String(numero).startsWith("BLS");
    if (bls && !estGerant) { setNotice("Seul le Gérant peut annuler un BLS."); return; }
    // ERP step 14 (Nils 05/10) : facture transmise au comptable → annulation impossible, même pour Nils.
    // Nils 17/10 : une facture groupée s'annule en entier ; un avoir sur l'une de ses lignes l'en empêche.
    const avoirsFacture = type === "Facture" ? dossiersDuGroupe(c).flatMap((x) => avoirsDeFacture(x.id)) : [];
    if (avoirsFacture.length) { setNotice(`La facture ${numero} porte ${avoirsFacture.length} avoir(s) (${avoirsFacture.map((a) => a.numero).join(", ")}) : elle ne peut plus être annulée.`); return; }
    if (type === "Facture" && dossiersDuGroupe(c).length > 1 && !(await demander(`La facture ${numero} est une facture groupée (« ${c.refFactureGroupee || ""} ») : l'annulation porte sur toute la facture, ses ${dossiersDuGroupe(c).length} dossiers reviennent au BL. Continuer ?`))) return;
    if (type === "Facture" && c.transmiseComptableLe) { setNotice(`La facture ${numero} a été transmise au comptable le ${formatDate(c.transmiseComptableLe)} : elle ne peut plus être annulée (passer par un avoir avec le comptable).`); return; }
    if (type === "Facture" && factureTransmise(c)) {
      const ok = await demander(`⚠ La facture ${numero} a déjà été transmise au client.\n\nUne facture transmise s'annule normalement par un avoir (à voir avec le comptable). Annuler quand même ?`);
      if (!ok) return;
    }
    // Step 17 (audit, Nils 15/10) : une facture déjà envoyée garde toujours son numéro (facture de remplacement), même si c'est la dernière.
    const dernier = bls ? true : type === "Facture" && factureTransmise(c) ? false : estDernierNumero(champ, numero);
    const dateDoc = (type === "Facture" ? c.dateFacture : c.dateBL) || new Date().toISOString();
    if (type === "Facture" && !dernier && moisVerrouille(CAISSE_GENERALE_ID, String(dateDoc).slice(0, 10))) { setNotice(`Le mois de la facture ${numero} est clôturé dans la caisse générale : l'encaissement de la facture de remplacement ne peut pas y être daté. Rouvre d'abord le mois.`); return; }
    setAnnulationDoc({ type, commandeId: c.id, numero, date: dateDoc, dernier, bls, dejaEnvoyee: type === "Facture" && factureTransmise(c) && estDernierNumero(champ, numero), motif: "", clientNom: NOM_CLIENT_COMPTOIR, erreur: "" });
  }
  async function confirmerAnnulationDocument() {
    const a = annulationDoc;
    if (!a) return;
    const c = (commandesListe || []).find((x) => x.id === a.commandeId);
    if (!c) { setAnnulationDoc(null); return; }
    const motif = (a.motif || "").trim();
    let rempl = null;
    if (!a.dernier) {
      const nomCl = (a.clientNom || "").trim() || NOM_CLIENT_COMPTOIR;
      let client = (clients || []).find((x) => normLib(x.nom) === normLib(nomCl));
      if (!client) {
        client = { id: uid(), nom: nomCl, raisonSociale: "", commercialSC: "", apporteurAffaire: "", type: TYPE_SANS_ICE, notes_adv: "–", notes_prod: "–", notes_com: "–", paiement_niveau: "", ice: "", paiement: "", remise: "", plafondExposition: "", contacts: [], adresse: "", codePostal: "", ville: "", adressesSupp: [], notes: "Client créé pour les documents de remplacement (annulation).", creePar: user.nom, creeLe: new Date().toISOString() };
        await persistClients([...(clients || []), client]);
      }
      const ht = HT_REMPLACEMENT;
      rempl = { id: uid(), type: a.type, numero: a.numero, date: a.date, clientId: client.id, designation: DESIGNATION_REMPLACEMENT, ht, ttc: a.type === "Facture" ? Math.round(ht * (1 + TVA_TAUX) * 100) / 100 : 0, remplace: { dossierId: c.id, dossier: c.numero, motif, ...(a.type === "Facture" && dossiersDuGroupe(c).length > 1 ? { dossierIds: dossiersDuGroupe(c).map((x) => x.id), factureGroupee: c.refFactureGroupee || "" } : {}) }, par: user.nom, le: new Date().toISOString() };
      await persistRemplacements([...(remplacements || []), rempl]);
      // Facture de remplacement : encaissée d'office en caisse générale, à la date de la facture d'origine.
      if (a.type === "Facture") {
        const opEnc = { id: uid(), compteId: CAISSE_GENERALE_ID, date: String(a.date || "").slice(0, 10), sens: "entree", montant: rempl.ttc, type: "normal", poste: POSTE_ENCAISSEMENT, sousPoste: POSTE_ENCAISSEMENT, designation: `Encaissement facture de remplacement ${a.numero} (dossier d'origine ${c.numero})`, tiersType: "client", tiers: client.nom, mode: "Espèces", piece: a.numero, dossierId: `rep:${rempl.id}`, remplacementId: rempl.id, par: user.nom, le: new Date().toISOString() };
        await persistOperations([...(operations || []), opEnc]);
        await tracerAcces("opération de trésorerie", `Caisse générale — entrée ${formatDH(opEnc.montant)} — ${opEnc.designation} (automatique)`);
      }
    }
    const versStatut = a.type === "Facture" ? "BL" : "PL";
    const raz = a.type === "Facture"
      ? { numeroFacture: "", dateFacture: "", parFacture: "", envoyeeClientLe: "", envoyeeClientPar: "", remiseClientLe: "", remiseClientPar: "", transmiseComptableLe: "", transmiseComptablePar: "", deductionsProjet: undefined }
      : { numeroBL: "", dateBL: "", parBL: "", blSigne: null };
    // Nils 17/10 : facture groupée — tous ses dossiers reviennent au BL ensemble.
    const groupe = a.type === "Facture" ? dossiersDuGroupe(c) : [c];
    const annuler = (x) => ({
      ...x,
      ...raz,
      ...(a.type === "Facture" ? { factureGroupeeId: "", refFactureGroupee: "", ordreFactureGroupee: "" } : {}),
      statut: versStatut,
      enAttenteDe: ((enAttenteParStatut || DEFAULT_EN_ATTENTE_PAR_STATUT)[versStatut] || [])[0] || "",
      annulations: [...(x.annulations || []), { type: a.type, numero: a.numero, date: a.date, motif: motif || "", par: user.nom, le: new Date().toISOString(), remplacementId: rempl ? rempl.id : null, ...(groupe.length > 1 ? { factureGroupee: c.refFactureGroupee || "" } : {}) }],
      modifiePar: user.nom,
      modifieLe: new Date().toISOString(),
    });
    const toSave = annuler(c);
    const idsGroupe = new Set(groupe.map((x) => x.id));
    await persistCommandes((commandesListe || []).map((x) => (x.id === c.id ? toSave : idsGroupe.has(x.id) ? annuler(x) : x)));
    if (commandeEditing && commandeEditing.id === c.id) setCommandeEditing(toSave);
    await tracerAcces(`annulation ${a.type === "Facture" ? "facture" : "BL"}`, `Dossier ${c.numero} — ${a.numero} annulé(e)${motif ? ` (${motif})` : ""}${rempl ? ` — remplacé(e) par un document « ${rempl.designation} » au nom de ${(clientDe(rempl.clientId) || {}).nom || NOM_CLIENT_COMPTOIR}${rempl.ttc ? `, ${formatDH(rempl.ttc)} TTC encaissés en caisse générale` : ""}` : a.bls ? " — BLS, numéro libéré sans remplacement" : " — dernier de la série, numéro libéré"}`);
    setAnnulationDoc(null);
    const msg = `${a.type === "Facture" ? "Facture" : "BL"} ${a.numero} annulé(e) — dossier revenu au statut ${versStatut}.${rempl ? ` Le n° ${a.numero} est repris par le document de remplacement « ${DESIGNATION_REMPLACEMENT} »${rempl.ttc ? ` (${formatDH(rempl.ttc)} TTC, encaissés d'office en caisse générale au ${formatDate(rempl.date)})` : ""}.` : a.bls ? " Numéro libéré (BLS : pas de document de remplacement)." : " Numéro libéré (c'était le dernier)."}`;
    setNotice(msg);
    setCommandeFicheMessage(msg);
  }
  function imprimerRemplacement(r) {
    if (!r) return;
    const lignes = [{ id: "r1", designation: r.designation, prixPublic: r.type === "Facture" ? r.ht : 0, qte: 1, remise: 0, unite: "Unité", type: "facture" }];
    const source = { clientId: r.clientId, reference: r.designation, date: String(r.date || "").slice(0, 10), lignes, chantierId: "", notes: [] };
    const html = construireHtmlDocument(source, { titre: r.type === "Facture" ? "FACTURE" : "BON DE LIVRAISON", numeroAffiche: r.numero, masquerFinance: r.type !== "Facture", dateDocument: r.date, avecSignatures: r.type !== "Facture" });
    telechargerDocument(html, nomFichierDocument(r.numero, (clientDe(r.clientId) || {}).nom, r.designation), r.type === "Facture" ? "facture" : "BL");
  }
  async function majRemplacement(id, patch, trace, detail) {
    const r = (remplacements || []).find((x) => x.id === id);
    if (!r) return;
    await persistRemplacements((remplacements || []).map((x) => (x.id === id ? { ...x, ...patch } : x)));
    if (trace) await tracerAcces(trace, `${r.numero} (remplacement) — ${detail}`);
  }
  // ---------- Nils 03/10 : suivi de la facture (l) et signature du BL (n) ----------
  async function majDossierDirect(id, patch, trace, detail) {
    const c = (commandesListe || []).find((x) => x.id === id);
    if (!c) return;
    const toSave = { ...c, ...patch, modifiePar: user.nom, modifieLe: new Date().toISOString() };
    await persistCommandes((commandesListe || []).map((x) => (x.id === id ? toSave : x)));
    if (commandeEditing && commandeEditing.id === id) setCommandeEditing({ ...commandeEditing, ...patch, modifiePar: toSave.modifiePar, modifieLe: toSave.modifieLe });
    if (trace) await tracerAcces(trace, `${c.numeroFacture || c.numeroBL || c.numero} — ${detail}`);
  }
  function estCommercialDuDossier(c) {
    return !!c && idCommercialDuDevis((devisListe || []).find((d) => d.id === c.devisId) || {}) === user.id;
  }
  async function cocherSuiviFacture(champ, coche) {
    const c = commandeEditing;
    if (!c || c.statut !== "Facture") return;
    const maintenant = new Date().toISOString();
    const att = c.enAttenteDe || "";
    let patch = {};
    if (champ === "envoyee") {
      if (!peut("commandes.suiviFacture")) return;
      patch = coche
        ? { envoyeeClientLe: maintenant, envoyeeClientPar: user.nom, ...(["", "Envoi client par mail", "Facturation"].includes(att) ? { enAttenteDe: "Remise original" } : {}) }
        : { envoyeeClientLe: "", envoyeeClientPar: "", ...(att === "Remise original" ? { enAttenteDe: "Envoi client par mail" } : {}) };
    } else if (champ === "remise") {
      if (!(peut("commandes.suiviFacture") || estCommercialDuDossier(c))) return;
      patch = coche
        ? { remiseClientLe: maintenant, remiseClientPar: user.nom, ...(att !== "Autorisation direction" ? { enAttenteDe: "Circuit fermé" } : {}) }
        : { remiseClientLe: "", remiseClientPar: "", ...(att === "Circuit fermé" ? { enAttenteDe: c.envoyeeClientLe ? "Remise original" : "Envoi client par mail" } : {}) };
    } else if (champ === "comptable") {
      if (!peut("commandes.suiviFacture")) return;
      // Step 17 (audit, Nils 15/10) : la transmission au comptable est définitive — jamais décochée.
      if (!coche) { if (c.transmiseComptableLe) setNotice(`La facture ${c.numeroFacture} a été transmise au comptable le ${formatDate(c.transmiseComptableLe)} : c'est définitif.`); return; }
      if (!(await demander(`Marquer la facture ${c.numeroFacture} comme transmise au comptable ?\n\nC'est définitif : la case ne pourra plus être décochée et la facture ne pourra plus jamais être annulée (seul un avoir sera possible).`))) return;
      patch = { transmiseComptableLe: maintenant, transmiseComptablePar: user.nom };
    }
    const lib = { envoyee: "envoyée au client", remise: "original remis au client", comptable: "transmise au comptable" }[champ];
    // Nils 17/10 : facture groupée — le suivi vaut pour tous ses dossiers, en un seul enregistrement.
    const groupe = dossiersDuGroupe(c);
    if (groupe.length > 1) {
      const ids = new Set(groupe.map((x) => x.id));
      const maintenant2 = new Date().toISOString();
      await persistCommandes((commandesListe || []).map((x) => (ids.has(x.id) ? { ...x, ...patch, modifiePar: user.nom, modifieLe: maintenant2 } : x)));
      if (commandeEditing && ids.has(commandeEditing.id)) setCommandeEditing({ ...commandeEditing, ...patch, modifiePar: user.nom, modifieLe: maintenant2 });
      await tracerAcces("suivi facture", `${c.numeroFacture} (facture groupée « ${c.refFactureGroupee || ""} », ${groupe.length} dossiers) — ${coche ? "" : "décoché : "}${lib}`);
      return;
    }
    await majDossierDirect(c.id, patch, "suivi facture", `${coche ? "" : "décoché : "}${lib}`);
  }
  function peutSignerBL(c) {
    return peut("commandes.signatureBL") || estCommercialDuDossier(c);
  }
  async function cocherBLSigne(coche, signataire) {
    const c = commandeEditing;
    if (!c || !c.numeroBL || !peutSignerBL(c)) return;
    if (coche && !signataire) { setNotice("Choisis qui a signé le BL."); return; }
    const patch = coche ? { blSigne: { le: new Date().toISOString(), par: user.nom, signataire } } : { blSigne: null };
    await majDossierDirect(c.id, patch, "BL signé", coche ? `signé par : ${signataire}` : "décoché");
  }
  async function ajouterSignataireBL(nom) {
    const v = String(nom || "").trim();
    if (!v) return null;
    const existe = (signatairesBL || []).find((x) => normLib(x) === normLib(v));
    if (existe) return existe;
    await persistSignatairesBL([...(signatairesBL || []), v]);
    return v;
  }

  // Retour manuel à l'étape précédente — au cas où un document aurait été
  // créé par erreur. Marche pour RDM et PL (où un trou dans la numérotation
  // n'a pas de conséquence). Interdit depuis BL et Facture : reprendre ces
  // étapes plus tard réutiliserait leur ancien numéro (voir transformerEnBL),
  // ce qui casserait la chronologie — un numéro antérieur se retrouverait
  // avec une date d'émission postérieure à des numéros plus élevés déjà
  // émis entre-temps par d'autres dossiers. Sur BL/Facture, la numérotation
  // doit rester strictement séquentielle et irréversible.
  async function retournerEtapePrecedente() {
    if (commandeEditing.statut === "BL" || commandeEditing.statut === "Facture") return;
    if (!peutTransformerRDMPL) { setNotice("Revenir à l'étape précédente est réservé au Gérant et à l'ADV."); return; }
    if (commandeEditing.statut === "PL" && bloqueParInventaire()) return;
    const indexActuel = ETAPES_COMMANDE.findIndex((e) => e.statut === commandeEditing.statut);
    if (indexActuel <= 0) return;
    // Redescendre depuis PL ne doit jamais laisser en place le stock
    // consommé ni les crédits d'exonération générés par ce PL — s'il a été
    // réellement "enregistré" (submitPL), on le défait d'abord via
    // annulerPL, qui referme proprement stock/mouvements/crédits et refuse
    // tout seul s'il n'est pas le dernier PL enregistré ou si son crédit a
    // déjà été consommé ailleurs (message déjà affiché dans ce cas).
    if (commandeEditing.statut === "PL" && plEstEnregistre(commandeEditing)) {
      const ok = await annulerPL(commandeEditing.numeroPL);
      if (!ok) return;
    } else if (commandeEditing.statut === "PL" && commandeEditing.numeroPL) {
      await annulerConsommablesDuPL(commandeEditing.numeroPL);
    }
    const etapePrecedente = ETAPES_COMMANDE[indexActuel - 1];
    const toSave = {
      ...commandeEditing,
      statut: etapePrecedente.statut,
      enAttenteDe: ((enAttenteParStatut || DEFAULT_EN_ATTENTE_PAR_STATUT)[etapePrecedente.statut] || [])[0] || "",
      modifiePar: user.nom,
      modifieLe: new Date().toISOString(),
    };
    persistCommandes((commandesListe || []).map((c) => (c.id === toSave.id ? toSave : c)));
    setCommandeEditing(toSave);
    await tracerAcces("retour étape précédente", `Dossier ${toSave.numero} : ${commandeEditing.statut} → ${etapePrecedente.statut}`);
    setNotice(`Dossier ramené au statut ${etapePrecedente.statut}.`);
  }
  // Passage obligé avant BL/Facture : ces transformations sont irréversibles
  // (voir retournerEtapePrecedente), donc on demande toujours confirmation
  // avant. BPRDM/PL restent réversibles (retour en arrière possible) : pas de
  // confirmation générique pour elles, SAUF si la vérification paiement
  // ci-dessous s'applique — même système partout (accord du 21/09 avec Nils),
  // plus seulement pour le BL. La vérification paiement se déclenche pour
  // TOUTE transformation dès que le client est répertorié comme mauvais
  // payeur, OU que son statut de paiement n'est simplement pas renseigné
  // (on ne veut plus qu'un client jamais évalué passe inaperçu). Pour le BL
  // spécifiquement, s'y ajoute la condition de paiement du devis si elle
  // l'exige.
  // ERP step 11 (liste choisie par Nils le 29/09 : points 1, 2, 6, 13 à 20) :
  // éléments techniques non renseignés, rappelés au passage en PL — jamais
  // bloquant.
  function elementsTechniquesManquants(c) {
    if (!c) return [];
    const m = [];
    if (!(c.poseurMeuble || "").trim()) m.push("Poseur meuble");
    const plaques = c.plaquesCuisson || [];
    if (plaques.length === 0) m.push("Plaque de cuisson : aucune renseignée");
    plaques.forEach((p, i) => { if (!(p.reference || "").trim()) m.push(`Plaque de cuisson${plaques.length > 1 ? ` n°${i + 1}` : ""} : référence`); });
    const eviers = c.eviers || [];
    if (eviers.length === 0) m.push("Évier : aucun renseigné");
    eviers.forEach((e, i) => { if (!(e.reference || "").trim()) m.push(`Évier${eviers.length > 1 ? ` n°${i + 1}` : ""} : référence`); });
    if (c.socle !== "Oui" && c.socle !== "Non") m.push("Socle (oui / non)");
    if (c.socle !== "Non") {
      if (c.laveVaisselle !== true && c.laveVaisselle !== false) m.push("Lave-vaisselle (oui / non)");
      else if (c.laveVaisselle === true && !c.laveVaisselleType) m.push("Lave-vaisselle : encastrable ou pose libre");
      if (c.laveLinge !== true && c.laveLinge !== false) m.push("Lave-linge (oui / non)");
      else if (c.laveLinge === true && !c.laveLingeType) m.push("Lave-linge : encastrable ou pose libre");
    }
    if (c.porteCuisine !== true && c.porteCuisine !== false) m.push("Porte cuisine (oui / non)");
    else if (c.porteCuisine === true) {
      if (!c.porteCuisineType) m.push("Porte cuisine : avec poignée ou avec gorge");
      if (c.porteCuisineDebord === undefined || c.porteCuisineDebord === null || String(c.porteCuisineDebord).trim() === "") m.push("Porte cuisine : débord");
    }
    return m;
  }

  function demanderConfirmationTransformation(label, action, options = {}) {
    // Step 17 (audit, Nils 14/10) : BPRDM et PL par Nils et l'ADV ; BL, BLS et facture par Nils et Sawsan.
    if ((label === "BPRDM" || label === "PL") && !peutTransformerRDMPL) { setNotice(`La transformation en ${label} est réservée au Gérant et à l'ADV.`); return; }
    if ((label === "BL" || label === "BLS" || label === "Facture") && (user.commandesSansTransformBLFacture || (label === "Facture" && user.commandesSansBDCFacture))) { setNotice(`La transformation en ${label === "Facture" ? "facture" : label} est réservée au Gérant et à l'Administration.`); return; }
    // ERP step 16 (Nils 12/10) : avec un article de RDM, BPRDM obligatoire ; sans, pas de BPRDM.
    if (commandeEditing && commandeEditing.statut === "BDC" && label === "BPRDM" && !dossierAvecRDM(commandeEditing)) {
      setNotice("⚠ Ce dossier ne contient aucun article de RDM : pas de BPRDM, transforme-le directement en PL.");
      return;
    }
    if (commandeEditing && commandeEditing.statut === "BDC" && label === "PL" && dossierAvecRDM(commandeEditing) && !commandeEditing.numeroRDM) {
      setNotice("⚠ Ce dossier contient un article de RDM : il doit passer par le BPRDM avant le PL.");
      return;
    }
    // ERP step 16 (Nils 12/10) : avec façonnage, pas de PL sans notre dessin technique validé par le client.
    if (commandeEditing && label === "PL" && dossierNature(commandeEditing, "faconnage")) {
      const manque = dessinPLManquant(commandeEditing);
      if (manque) {
        setNotice(`⚠ Impossible de transformer en PL : ${manque} (Documents importants du dossier). L'atelier travaille sur notre dessin, validé par le client.`);
        return;
      }
    }
    // Fiche de pose obligatoire avant Facture (bloquant, pas une simple case
    // à cocher comme la vérif. paiement ci-dessous) — voir ficheDePoseVide /
    // fichePoseRemplie, et le bloc "Fiche de pose" de la fiche dossier.
    // ERP step 10 (demande Nils du 24/09) : contact + téléphone sur place
    // obligatoires pour faire le RDM (et pour un passage direct BDC → PL).
    // Nils 08/10 (o) : seulement s'il y a de la logistique (pas de livraison = pas de RDM).
    if (commandeEditing && dossierAvecLogistique(commandeEditing) && (label === "BPRDM" || (label === "PL" && commandeEditing.statut === "BDC"))) {
      const cs = contactSurPlaceDuDossier(commandeEditing);
      if (!cs.nom.trim() || !cs.tel.trim()) {
        setNotice("⚠ Impossible de passer à l'étape suivante : renseigne le contact ET le téléphone sur place du dossier (fiche dossier), puis enregistre.");
        return;
      }
    }
    // ERP step 10 : étage manquant → pop-up devant le formulaire, avant même
    // la fenêtre de confirmation du BDC.
    if (label === "BDC" && draft && !(draft.reference || "").trim()) {
      setDraftError("Indique la référence de la contremarque avant de transformer en BDC.");
      return;
    }
    if (label === "BDC" && draft && !(draft.etage || "").trim() && lignesContiennentPose(draft.lignes, articles)) {
      setPopupEtageValeur("");
      setPopupEtage(true);
      return;
    }
    // ERP step 11 (accord Nils du 29/09) : consommables de production avant
    // le BL ; consommables de pose (commande avec pose) avant la Facture.
    // Les consommables de pose sont saisis après le BL : ils ne bloquent
    // jamais le BL.
    if ((label === "BL" || label === "BLS") && commandeEditing && !consoProductionOK(commandeEditing)) {
      setNotice("⚠ Impossible de passer en BL : aucun consommable de production enregistré sur ce PL. Le bureau technique doit les saisir (Stock → Enregistrer une consommation › consommables), ou déclarer « Aucun consommable de production » au même endroit.");
      return;
    }
    if (label === "Facture" && commandeEditing && !consoPoseOK(commandeEditing)) {
      setNotice("⚠ Impossible de facturer : aucun consommable de pose enregistré sur ce dossier. Le bureau technique doit les saisir (Stock → Enregistrer une consommation › consommables de pose), ou y déclarer « aucun consommable de pose ».");
      return;
    }
    if (label === "Facture" && commandeEditing && fichePoseRequise(commandeEditing) && !fichePoseRemplie(commandeEditing.fichePose)) {
      setNotice("⚠ Impossible de facturer : la fiche de pose de ce dossier n'est pas remplie (dates de début et de fin de pose, 3 responsables de contrôle, poseur(s), toutes les lignes d'intervention renseignées).");
      return;
    }
    // Step 13 (retour Nils du 22/09) : le blocage des articles Karima non
    // validés (Step 12 pt.2) ne portait jusqu'ici que sur "Enregistrer un
    // PL" (l'étape Stock) — un dossier pouvait déjà être transformé en
    // statut PL avant même d'en arriver là. On bloque désormais la
    // transformation elle-même, au même titre que la fiche de pose pour
    // Facture ci-dessus.
    if (label === "PL" && commandeEditing) {
      const articlesNonValides = articlesNonValidesDuDossier(commandeEditing);
      if (articlesNonValides.length > 0) {
        setNotice(`⚠ Impossible de transformer en PL : ${articlesNonValides.join(", ")} — n'a/n'ont pas encore été validé(s) par le Gérant dans le Catalogue (tout article créé par quelqu'un d'autre que le Gérant doit l'être).`);
        return;
      }
      // ERP step 11 : rappel (non bloquant) des éléments techniques manquants.
      if (!options.ignorerRappelTechnique) {
        const manquants = elementsTechniquesManquants(commandeEditing);
        if (manquants.length > 0) {
          setRappelTechnique({ manquants, continuer: () => demanderConfirmationTransformation(label, action, { ...options, ignorerRappelTechnique: true }) });
          return;
        }
      }
    }
    // BDC se déclenche depuis la fiche devis, avant qu'aucun dossier
    // n'existe : commandeEditing est alors vide, on regarde le client du
    // devis en cours d'édition (draft) à la place.
    // ERP step 12 (Nils 01/10) : trois cas, chacun avec son message et sa case à cocher :
    // 1. paiement à l'avance exigé, 2. incident de paiement (factures / BLS échus non réglés),
    // 3. client répertorié mauvais payeur (+ statut non renseigné, conservé).
    let exigeVerifPaiement = false;
    let raisonsVerif = [];
    let exigeAvance = false;
    const casPaiement = [];
    let clientVerif = null;
    if (commandeEditing || (label === "BDC" && draft)) {
      // Step 12 pt.4 (accord Nils du 21/09) : la même vérification de
      // condition de paiement (ex. avance exigée) s'applique désormais
      // aussi au passage en BDC, pas seulement à BL/Facture — mais reste
      // réversible pour ce statut (voir `irreversible` plus bas).
      // Nils 02/10 : contrôles de paiement à toutes les étapes (BDC, BPRDM, PL, BL, facture).
      {
        const conditionsPaiement = commandeEditing
          ? ((devisListe || []).find((d) => d.id === commandeEditing.devisId) || {}).conditionsPaiement
          : draft.conditionsPaiement;
        if (paiementNecessiteVerifAvantBL(conditionsPaiement)) {
          raisonsVerif.push(`${RAISON_AVANCE_PREFIX} ${conditionsPaiement} » l'exige`);
          exigeAvance = true;
          casPaiement.push({ cle: "avance", titre: "Paiement à l'avance", detail: `La condition de paiement « ${conditionsPaiement} » exige que le client ait payé avant le passage en ${label}. Vérifie que l'encaissement est bien reçu.`, coche: `Je confirme que le paiement est reçu — ou je décide de passer quand même en ${label}.` });
        }
      }
      const clientIdAVerifier = commandeEditing ? commandeEditing.clientId : draft.clientId;
      const client = clientDe(clientIdAVerifier);
      clientVerif = client;
      if (client) {
        const etN = etatCompteClient(client.id, false, todayISO(), false);
        const etE = etatCompteClient(client.id, true, todayISO(), false);
        const echus = [...etN.blocs, ...etE.blocs].flatMap((b) => b.docs).filter((d) => d.retard > JOURS_INCIDENT_PAIEMENT);
        if (echus.length) {
          const montant = arrondiH(echus.reduce((n, d) => n + d.reste, 0));
          const plusVieux = Math.max(...echus.map((d) => d.retard));
          raisonsVerif.push("incident de paiement");
          casPaiement.push({ cle: "incident", titre: "Incident de paiement", detail: `Ce client a ${echus.length} facture(s) / BLS non réglé(e)s avec plus de ${JOURS_INCIDENT_PAIEMENT} jours de retard${peutVoirEtatClient(client) ? ` : ${formatDH(montant)}` : ""} (le plus ancien : ${plusVieux} jours).`, coche: `Je décide de passer en ${label} malgré l'incident de paiement.` });
        }
        // Plafond d'exposition (Nils 02/10) : encours = factures / BLS non soldés + reste des
        // commandes en cours (exo + non exo) ; au BDC on y ajoute la commande en cours de création.
        const plafond = Number(String(client.plafondExposition || "").replace(/\s/g, "").replace(",", "."));
        if (plafond > 0) {
          const encours = encoursClient(client.id);
          const cetteCommande = label === "BDC" && draft && !commandeEditing ? arrondiH(calcTotaux(draft).totalTTC || 0) : 0;
          const apres = arrondiH(encours + cetteCommande);
          if (apres > plafond + 0.01) {
            const dejaDepasse = encours > plafond + 0.01;
            const voit = peutVoirEtatClient(client);
            raisonsVerif.push("plafond d'exposition dépassé");
            casPaiement.push({
              cle: "plafond",
              titre: dejaDepasse ? "Plafond d'exposition dépassé" : "Plafond d'exposition dépassé avec cette commande",
              detail: voit
                ? `Plafond ${formatDH(plafond)} — encours actuel ${formatDH(encours)}${cetteCommande ? ` + cette commande ${formatDH(cetteCommande)} = ${formatDH(apres)}` : ""}, soit ${formatDH(arrondiH(apres - plafond))} au-dessus du plafond.`
                : dejaDepasse ? "L'encours de ce client dépasse déjà son plafond d'exposition." : "Avec cette commande, l'encours de ce client dépassera son plafond d'exposition.",
              coche: `Je décide de passer en ${label} malgré le dépassement du plafond d'exposition.`,
            });
          }
        }
      }
      if (client && client.paiement_niveau === "mauvais") {
        raisonsVerif.push(RAISON_MAUVAIS_PAYEUR);
        casPaiement.push({ cle: "mauvais", titre: "Client répertorié mauvais payeur", detail: "La fiche client le classe « Mauvais payeur ».", coche: `Je décide de passer en ${label} malgré le statut de mauvais payeur.` });
      } else if (!client || !client.paiement_niveau) {
        raisonsVerif.push("le statut de paiement de ce client n'est pas renseigné dans sa fiche");
        casPaiement.push({ cle: "nonrenseigne", titre: "Statut de paiement non renseigné", detail: "Le statut de paiement (bon / lent / mauvais payeur) n'est pas renseigné dans la fiche client.", coche: `Je décide de passer en ${label} sans statut de paiement renseigné.` });
      }
      exigeVerifPaiement = casPaiement.length > 0;
    }
    // ERP step 13 (ar, Nils 04/10) : au passage en BDC, un devis avec un article de la
    // catégorie Logistique mais aucun article de pose ni de transformation demande une
    // confirmation, et Nils est alerté. ERP step 16 : cases « Nature de l'article » (livraison, pose, façonnage).
    if (label === "BDC" && draft) {
      const artsLignes = (draft.lignes || []).map((l) => (l.articleId ? (articles || []).find((x) => x.id === l.articleId) : null)).filter(Boolean);
      const avecLogistique = artsLignes.some((a) => natureArticle(a, "livraison"));
      const avecPoseOuTransfo = artsLignes.some((a) => natureArticle(a, "pose") || natureArticle(a, "faconnage"));
      if (avecLogistique && !avecPoseOuTransfo) {
        casPaiement.push({ cle: "logistique", titre: "Livraison sans pose ni transformation", detail: "Ce devis contient un article de livraison mais aucun article de pose ni de façonnage. Vérifie que c'est bien voulu (ex. vente de tranches ou d'éviers livrés).", coche: "Je confirme : livraison sans pose ni transformation." });
        exigeVerifPaiement = true;
      }
    }
    const irreversible = label === "BL" || label === "BLS" || label === "Facture";
    if (!exigeVerifPaiement && !irreversible) {
      // Rien à vérifier et transformation réversible (BPRDM/PL) : on
      // transforme directement, sans étape de confirmation superflue.
      action();
      return;
    }
    setConfirmationVerifPaiement({});
    if (label === "Facture") { setDateFactureChoisie(todayISO()); dateFactureRef.current = todayISO(); }
    const docLib = commandeEditing ? `dossier ${commandeEditing.numero}${commandeEditing.reference ? ` (${commandeEditing.reference})` : ""}` : `devis ${draft.numero || "non enregistré"}${draft.reference ? ` (${draft.reference})` : ""}`;
    const lien = commandeEditing ? { kind: "commande", id: commandeEditing.id } : draft && draft.id ? { kind: "devis", id: draft.id } : null;
    // ERP step 16 (lot 4b) : passage en PL / BL d'une cuisine de projet immo — rappel du regroupement (non bloquant).
    if (commandeEditing && ["PL", "BL", "BLS"].includes(label)) {
      const msgRegroupement = alerteRegroupement(commandeEditing);
      if (msgRegroupement) demander(msgRegroupement, { info: true });
    }
    setConfirmationTransformation({ label, action, exigeVerifPaiement, raisonsVerif, irreversible, exigeAvance, casPaiement, clientId: clientVerif ? clientVerif.id : "", docLib, lien });
  }
  function confirmerTransformation() {
    const ct = confirmationTransformation;
    if (ct) {
      ct.action();
      // Nils 01/10 : alerte dès que quelqu'un passe outre une vérification de paiement.
      const cas = (ct.casPaiement || []).filter((c) => c.cle !== "nonrenseigne" && c.cle !== "logistique");
      if ((ct.casPaiement || []).some((c) => c.cle === "logistique") && !estGerant) {
        const clL = clientDe(ct.clientId);
        alerter("Livraison sans pose ni transformation", `${user.nom} a transformé en ${ct.label} — ${ct.docLib} — client ${clL ? clL.nom : "?"} : article de logistique sans article de pose ni de transformation`, ct.lien || { kind: "onglet", id: "commandes" });
      }
      if (cas.length && !estGerant) {
        const cl = clientDe(ct.clientId);
        alerter("Passage forcé malgré le paiement", `${user.nom} a confirmé le passage en ${ct.label} — ${ct.docLib} — client ${cl ? cl.nom : "?"} : ${cas.map((c) => c.titre.toLowerCase()).join(", ")}`, ct.lien || { kind: "onglet", id: "commandes" });
      }
    }
    setConfirmationTransformation(null);
  }
  // ERP step 8 : ouverture des trois sous-fenêtres du dossier — chacune
  // prend un instantané de ce qu'elle va modifier, pour pouvoir tout
  // restaurer si on ferme sans passer par son propre "Enregistrer" (clic en
  // dehors de la fenêtre). Voir fermerModifierLignesModal /
  // fermerElementsTechniquesModal / fermerFichePoseModal ci-dessous.
  function ouvrirModifierLignesModal() {
    draftLignesSnapshotRef.current = draft ? JSON.parse(JSON.stringify(draft.lignes)) : null;
    setShowModifierLignesModal(true);
  }
  function fermerModifierLignesModal() {
    if (draftLignesSnapshotRef.current && draft) {
      setDraft({ ...draft, lignes: draftLignesSnapshotRef.current });
    }
    draftLignesSnapshotRef.current = null;
    setShowModifierLignesModal(false);
  }
  function ouvrirElementsTechniquesModal() {
    commandeEditingSnapshotRef.current = commandeEditing ? JSON.parse(JSON.stringify(commandeEditing)) : null;
    setShowElementsTechniquesModal(true);
  }
  function fermerElementsTechniquesModal() {
    if (commandeEditingSnapshotRef.current) setCommandeEditing(commandeEditingSnapshotRef.current);
    commandeEditingSnapshotRef.current = null;
    setShowElementsTechniquesModal(false);
  }
  function ouvrirFichePoseModal() {
    commandeEditingSnapshotRef.current = commandeEditing ? JSON.parse(JSON.stringify(commandeEditing)) : null;
    setShowFichePoseModal(true);
  }
  function fermerFichePoseModal() {
    if (commandeEditingSnapshotRef.current) setCommandeEditing(commandeEditingSnapshotRef.current);
    commandeEditingSnapshotRef.current = null;
    setShowFichePoseModal(false);
  }
  // Sauvegarde effective du dossier en cours d'édition, sans refermer sa
  // fiche — utilisée par le bouton "Enregistrer" général ET par chacun des
  // sous-formulaires (Modifier le bon de commande, Éléments techniques,
  // Fiche de pose) depuis leur propre bouton "Enregistrer et fermer" (ERP
  // step 7). Avant cette extraction, fermer un sous-formulaire ne
  // sauvegardait rien tant qu'on ne cliquait pas ensuite sur "Enregistrer"
  // dans la fiche principale, restée cachée derrière — un dossier pouvait
  // donc sembler "figé" alors que la modification était simplement perdue.
  // ERP step 8 : renvoie null (et affiche un message) sans rien enregistrer
  // si les nouvelles lignes demandent plus de crédit d'exonération que ce
  // qu'il reste au registre — l'appelant doit alors garder la fiche/la
  // sous-fenêtre ouverte plutôt que de la refermer.
  async function sauvegarderCommandeEnCours() {
    {
      const enBaseEA = (commandesListe || []).find((c) => c.id === commandeEditing.id);
      if (enBaseEA && (enBaseEA.enAttenteDe || "") !== (commandeEditing.enAttenteDe || "") && !peutChoisirEnAttente(enBaseEA, commandeEditing.enAttenteDe)) {
        setNotice(enBaseEA.enAttenteDe === "Autorisation direction"
          ? "Ce dossier est « En attente de : Autorisation direction » — seul le Gérant peut changer cette valeur."
          : `Tu n'as pas le droit de mettre ce dossier « En attente de : ${commandeEditing.enAttenteDe} » (réglé par le Gérant dans Paramétrage).`);
        return null;
      }
    }
    // ERP step 11 : dossier facturé figé — seul « En attente de » est repris
    // de l'édition, tout le reste vient de la version enregistrée.
    if (dossierFacture(commandeEditing)) {
      const enBase = (commandesListe || []).find((c) => c.id === commandeEditing.id) || commandeEditing;
      const figee = { ...enBase, enAttenteDe: commandeEditing.enAttenteDe, modifiePar: user.nom, modifieLe: new Date().toISOString() };
      await persistCommandes((commandesListe || []).map((c) => (c.id === figee.id ? figee : c)));
      if ((enBase.enAttenteDe || "") !== (figee.enAttenteDe || "")) await tracerAcces("en attente de", `Dossier ${figee.numero} (${figee.statut}) : « ${enBase.enAttenteDe || "—"} » → « ${figee.enAttenteDe || "—"} »`);
      setCommandeEditing(figee);
      return figee;
    }
    const toSave = { ...commandeEditing, modifiePar: user.nom, modifieLe: new Date().toISOString() };
    // ERP step 7 (pt.17/18) : tant que le dossier est à un statut où ses
    // lignes sont éditables (BDC/RDM/PL), le contenu affiché vient de
    // `draft` (même éditeur que le devis) — mais se sauvegarde désormais sur
    // la commande elle-même, jamais sur le devis d'origine, figé depuis la
    // transformation en BDC.
    if (commandeLignesEditables(commandeEditing.statut) && draft && draft.id === commandeEditing.devisId) {
      const errQte = erreurQuantitesLignes(draft.lignes);
      if (errQte) { setNotice(errQte); return null; }
      // ERP step 8 (accord du 21/09) : le crédit du registre des tranches
      // exonérables, déduit à la transformation en BDC, est réajusté ici à
      // chaque modification des lignes ("Modifier le bon de commande"),
      // jusqu'au PL — en plus (consomme du crédit) ou en moins (le restitue).
      if (draft.exonereTVA) {
        const besoinsNouveaux = besoinsCreditPourLignes(draft.lignes);
        const dejaDetenu = new Map((commandeEditing.creditsConsommes || []).map((c) => [c.cle, c]));
        const cles = new Set([...besoinsNouveaux.keys(), ...dejaDetenu.keys()]);
        const deltas = new Map();
        cles.forEach((cle) => {
          const nouv = besoinsNouveaux.get(cle);
          const anc = dejaDetenu.get(cle);
          const delta = Number(((nouv ? nouv.quantite : 0) - (anc ? anc.quantite : 0)).toFixed(2));
          if (delta !== 0) {
            deltas.set(cle, { produitId: (nouv || anc).produitId, libelle: (nouv || anc).libelle, delta });
          }
        });
        const manques = [];
        deltas.forEach((v, cle) => {
          if (v.delta > 0) {
            const dispo = creditDisponible(cle);
            if (v.delta > dispo) manques.push({ ...v, requis: v.delta, disponible: dispo });
          }
        });
        if (manques.length > 0) {
          setNotice(
            `Impossible d'enregistrer : crédit insuffisant dans le registre des tranches exonérables pour ${manques
              .map((m) => `${m.libelle} — ${m.requis} de plus demandé(s), ${m.disponible} disponible(s)`)
              .join(" ; ")}.`
          );
          return null;
        }
        if (deltas.size > 0) {
          let creditsMaj = [...(creditsTranches || [])];
          const mouvements = [];
          deltas.forEach((v, cle) => {
            if (v.delta > 0) {
              creditsMaj = consommerCreditListe(creditsMaj, cle, v.delta);
              mouvements.push({ produitId: v.produitId, libelle: v.libelle, sens: "debit", quantite: v.delta, origine: `Lignes du BC ${commandeEditing.numero} modifiées` });
            } else {
              creditsMaj = restituerCreditListe(creditsMaj, v.produitId, -v.delta, `Lignes du BC ${commandeEditing.numero} modifiées`);
              mouvements.push({ produitId: v.produitId, libelle: v.libelle, sens: "credit", quantite: -v.delta, origine: `Lignes du BC ${commandeEditing.numero} modifiées` });
            }
          });
          await persistCreditsTranches(creditsMaj);
          await journaliserMouvementsCredit(mouvements);
        }
        toSave.creditsConsommes = [...besoinsNouveaux.values()];
      } else if ((commandeEditing.creditsConsommes || []).length > 0) {
        // Défense en profondeur (Step 10) : si le dossier détient encore du
        // crédit consommé alors que draft.exonereTVA est désormais faux, on
        // le restitue intégralement plutôt que de le laisser bloqué au
        // registre — ne devrait normalement plus arriver depuis que la
        // bascule exo (toggleExonerationDossier) gère elle-même sa propre
        // restitution, mais on ne veut jamais perdre de crédit en silence.
        let creditsMaj = [...(creditsTranches || [])];
        (commandeEditing.creditsConsommes || []).forEach((c) => {
          creditsMaj = restituerCreditListe(creditsMaj, c.produitId, c.quantite, `Lignes du BC ${commandeEditing.numero} modifiées`);
        });
        await persistCreditsTranches(creditsMaj);
        await journaliserMouvementsCredit(
          (commandeEditing.creditsConsommes || []).map((c) => ({
            produitId: c.produitId,
            libelle: c.libelle,
            sens: "credit",
            quantite: c.quantite,
            origine: `Lignes du BC ${commandeEditing.numero} modifiées`,
          }))
        );
        toSave.creditsConsommes = [];
      }
      toSave.lignes = draft.lignes;
    }
    await persistCommandes((commandesListe || []).map((c) => (c.id === toSave.id ? toSave : c)));
    {
      const enBaseAv = (commandesListe || []).find((c) => c.id === toSave.id) || {};
      if ((enBaseAv.enAttenteDe || "") !== (toSave.enAttenteDe || "")) {
        await tracerAcces("en attente de", `Dossier ${toSave.numero} (${toSave.statut}) : « ${enBaseAv.enAttenteDe || "—"} » → « ${toSave.enAttenteDe || "—"} »`);
      }
      await tracerAcces("dossier enregistré", `Dossier ${toSave.numero} (${toSave.statut})`);
    }
    setCommandeEditing(toSave);
    return toSave;
  }
  async function enregistrerCommande() {
    const toSave = await sauvegarderCommandeEnCours();
    if (!toSave) return;
    setNotice(`Dossier ${toSave.numero} mis à jour.`);
    fermerCommandeFiche();
  }
  // Bascule "Commande exonérée de TVA" depuis la fiche dossier (accord Nils
  // du 21/09, Step 10) — seule brèche ouverte dans le gel du devis d'origine
  // une fois transformé en BDC : exonereTVA (et sa mention légale) reste
  // piloté depuis le devis, seul ce champ précis redevient modifiable, et
  // seulement jusqu'au BL/Facture (verrouillé ensuite comme les lignes).
  // Cocher revérifie l'éligibilité + la suffisance du crédit sur les lignes
  // actuelles du dossier (verifierExonerationLignes, même contrôle qu'à la
  // création d'un devis exo) et consomme le crédit nécessaire si c'est bon.
  // Décocher restitue intégralement le crédit déjà consommé par ce dossier.
  // Effet immédiat (pas de bouton "Enregistrer" séparé) : une bascule qui
  // touche au registre de crédit ne doit jamais rester en suspens si la
  // fiche se ferme sans sauvegarde explicite.
  async function toggleExonerationDossier(nouvelleValeur) {
    const devisOrigine = (devisListe || []).find((d) => d.id === commandeEditing.devisId);
    if (!devisOrigine) return;
    if (nouvelleValeur) {
      await alerter("Commande exonérée", `Dossier ${commandeEditing.numero} passé en exonération de TVA`, { kind: "commande", id: commandeEditing.id });
    }
    const lignes = lignesDuDossier(commandeEditing);
    if (nouvelleValeur) {
      const verif = verifierExonerationLignes(lignes);
      if (!verif.ok) {
        setNotice(messageRefusExoneration(verif));
        return;
      }
      const besoins = besoinsCreditPourLignes(lignes);
      let creditsMaj = [...(creditsTranches || [])];
      besoins.forEach((v, cle) => {
        creditsMaj = consommerCreditListe(creditsMaj, cle, v.quantite);
      });
      await persistCreditsTranches(creditsMaj);
      await journaliserMouvementsCredit(
        [...besoins.values()].map((v) => ({
          produitId: v.produitId,
          libelle: v.libelle,
          sens: "debit",
          quantite: v.quantite,
          origine: `Exonération cochée sur le BC ${commandeEditing.numero}`,
        }))
      );
      const toSaveCommande = { ...commandeEditing, creditsConsommes: [...besoins.values()], modifiePar: user.nom, modifieLe: new Date().toISOString() };
      await persistCommandes((commandesListe || []).map((c) => (c.id === toSaveCommande.id ? toSaveCommande : c)));
      setCommandeEditing(toSaveCommande);
      const toSaveDevis = { ...devisOrigine, exonereTVA: true, modifiePar: user.nom, modifieLe: new Date().toISOString() };
      await persistDevis((devisListe || []).map((d) => (d.id === toSaveDevis.id ? toSaveDevis : d)));
      setNotice(`Dossier ${commandeEditing.numero} marqué exonéré de TVA — crédit déduit du registre.`);
    } else {
      const dejaDetenu = commandeEditing.creditsConsommes || [];
      if (dejaDetenu.length > 0) {
        let creditsMaj = [...(creditsTranches || [])];
        dejaDetenu.forEach((c) => {
          creditsMaj = restituerCreditListe(creditsMaj, c.produitId, c.quantite, `Exonération annulée sur le BC ${commandeEditing.numero}`);
        });
        await persistCreditsTranches(creditsMaj);
        await journaliserMouvementsCredit(
          dejaDetenu.map((c) => ({
            produitId: c.produitId,
            libelle: c.libelle,
            sens: "credit",
            quantite: c.quantite,
            origine: `Exonération annulée sur le BC ${commandeEditing.numero}`,
          }))
        );
      }
      const toSaveCommande = { ...commandeEditing, creditsConsommes: [], modifiePar: user.nom, modifieLe: new Date().toISOString() };
      await persistCommandes((commandesListe || []).map((c) => (c.id === toSaveCommande.id ? toSaveCommande : c)));
      setCommandeEditing(toSaveCommande);
      const toSaveDevis = { ...devisOrigine, exonereTVA: false, modifiePar: user.nom, modifieLe: new Date().toISOString() };
      await persistDevis((devisListe || []).map((d) => (d.id === toSaveDevis.id ? toSaveDevis : d)));
      setNotice(`Dossier ${commandeEditing.numero} n'est plus exonéré de TVA — crédit restitué au registre.`);
    }
  }
  // Interdit une fois BL ou Facture atteint : supprimer le dossier ferait
  // disparaître son numéro sans aucune trace, ce qui casse la même garantie
  // de séquence que "Revenir à l'étape précédente" (voir plus haut).
  function supprimerCommande(id) {
    const c = (commandesListe || []).find((x) => x.id === id);
    if (!c) return;
    // Suppression directe réservée au statut BDC pur : à partir de RDM, du
    // stock a pu être mouvementé et des réservations/crédits engagés — seul
    // "Annuler" (qui redescend étape par étape en libérant correctement tout
    // ça) peut faire redescendre le dossier jusqu'à BDC, où la suppression
    // redevient possible.
    if (c.statut !== "BDC") {
      setNotice(`Impossible de supprimer le dossier ${c.numero} : il est au statut ${c.statut}. Utilise "Annuler" pour redescendre étape par étape jusqu'à BDC, où la suppression redevient possible.`);
      return;
    }
    persistCommandes((commandesListe || []).filter((x) => x.id !== id));
    tracerAcces("suppression dossier", `Dossier ${c.numero} supprimé (statut ${c.statut})`);
    alerter("Suppression de dossier", `Dossier ${c.numero} supprimé (statut ${c.statut})`, null);
    // La suppression d'un dossier ne doit jamais laisser le devis d'origine
    // bloqué sur "Transformé en BDC" alors que le dossier n'existe plus.
    const devisOrigine = (devisListe || []).find((d) => d.id === c.devisId);
    const devisARepasser = devisOrigine && devisOrigine.statut === "Transformé en BDC";
    if (devisARepasser) {
      persistDevis((devisListe || []).map((d) => (d.id === devisOrigine.id ? { ...d, statut: "Confirmé", modifiePar: user.nom, modifieLe: new Date().toISOString() } : d)));
    }
    setNotice(`Dossier ${c.numero} supprimé.${devisARepasser ? " Le devis d'origine repasse au statut Confirmé." : ""}`);
    if (showCommandeFiche && commandeEditing && commandeEditing.id === id) fermerCommandeFiche();
  }
  // Retour en arrière depuis BDC : il n'y a pas d'étape "commande"
  // antérieure, donc "revenir" veut dire annuler le dossier et laisser le
  // devis repasser à Confirmé — supprimerCommande s'en charge déjà. On
  // passe par une confirmation, qui avertit si de la matière est déjà
  // réservée sous ce BC puis la libère automatiquement une fois confirmé.
  function demanderAnnulerBDC(commande) {
    if (!peut("devis.transformerBDC")) { setNotice("Annuler un BDC est réservé à ceux qui peuvent le créer (Gérant, Administration, ADV)."); return; } // Step 17
    setConfirmationAnnulerBDC(commande);
  }
  async function confirmerAnnulerBDC() {
    if (!confirmationAnnulerBDC) return;
    const commande = confirmationAnnulerBDC;
    const resActives = (reservations || []).filter((r) => r.bc === commande.numero && r.statut === "active");
    if (resActives.length > 0) {
      // Annuler tout le dossier lève ses réservations avant toute
      // production. ERP step 8 : leur éventuel crédit consommé a disparu
      // (déduit désormais au BDC, plus à la réservation) — voir plus bas
      // pour la restitution, portée par le dossier lui-même.
      await persistReservations(
        (reservations || []).map((r) =>
          resActives.some((ra) => ra.id === r.id)
            ? { ...r, statut: "levee", motifLevee: "annulee", leveeLe: new Date().toISOString(), leveePar: user.nom, modifiePar: user.nom, modifieLe: new Date().toISOString() }
            : r
        )
      );
    }
    // ERP step 8 (accord du 21/09) : restitue le crédit que ce dossier
    // détenait pour son exonération, s'il en détenait.
    if (Array.isArray(commande.creditsConsommes) && commande.creditsConsommes.length > 0) {
      let creditsMaj = [...(creditsTranches || [])];
      commande.creditsConsommes.forEach((c) => {
        if (Number(c.quantite) > 0) creditsMaj = restituerCreditListe(creditsMaj, c.produitId, c.quantite, `Dossier ${commande.numero} annulé`);
      });
      await persistCreditsTranches(creditsMaj);
      await journaliserMouvementsCredit(
        commande.creditsConsommes
          .filter((c) => Number(c.quantite) > 0)
          .map((c) => ({
            produitId: c.produitId,
            libelle: c.libelle,
            sens: "credit",
            quantite: c.quantite,
            origine: `Dossier ${commande.numero} annulé`,
          }))
      );
    }
    supprimerCommande(commande.id);
    setConfirmationAnnulerBDC(null);
  }
  // Prix d'un article structurel pour un groupe donné : table centrale pour
  // les Tranches (indexée par Matière+Épaisseur, puis par groupe) — stockée en
  // prix au m², convertie ici en prix à la tranche via la surface de l'article
  // (les tranches ne se vendent pas au m²). Grille propre à l'article pour
  // les autres catégories structurelles (déjà un prix final, pas de conversion).
  function prixGroupeArticle(art, g) {
    if (!art || !g) return null;
    if (art.categorie === "Tranche") {
      // Le 2e choix (déclassé) a sa propre grille de prix, distincte du 1er
      // choix — généralement moins chère, jamais la même valeur.
      const est2eChoix = (art.choix || "").startsWith("2");
      const table = est2eChoix ? prixGroupesTranche2eChoix : prixGroupesTranche;
      if (!table || !art.matiere || !art.epaisseurMatiere) return null;
      const ligne = table[cleCombinaisonTranche(art.matiere, art.epaisseurMatiere)];
      const prixM2 = ligne ? ligne[g] : null;
      if (prixM2 == null) return null;
      const surface = surfaceM2(art.dimension);
      if (!surface) return null;
      return Math.round(prixM2 * surface * 100) / 100;
    }
    return art.prixParGroupe[g];
  }

  // ---------- Lignes ----------
  function ajouterLigneArticle(article) {
    // Un article Descriptifs n'a ni prix ni quantité : c'est une ligne de
    // texte pure, insérée dans le bloc "Description des morceaux" du devis.
    if (article.categorie === "Descriptifs") {
      const ligne = { id: uid(), type: "descriptif", articleId: article.id, designation: article.designation };
      setDraft({ ...draft, lignes: [...draft.lignes, ligne] });
      setDescriptifQuery("");
      setDescriptifDropdownOpen(false);
      return;
    }
    // Un article Tranche porte déjà tout ce qu'il faut (sa couleur, son
    // groupe fixe, son prix calculé) — l'ajout est donc direct, comme pour
    // n'importe quel autre article.
    const prix = article.structurel ? prixGroupeArticle(article, article.groupe) : article.prixPublic;
    if (article.structurel && prix == null) {
      setNotice("Impossible d'ajouter cette ligne : le prix n'est pas encore défini pour ce groupe (Prix et coûts → Grille de vente).");
      return;
    }
    // ERP step 8 (accord du 21/09) : sur un devis exonéré, un article
    // Tranche ne s'ajoute que s'il reste du crédit dans le registre des
    // tranches exonérables (cumulé avec les autres lignes déjà présentes
    // sur ce même devis pour la même clé) ; un article non-Tranche doit être
    // coché "TVA exonérable" au Catalogue. articlesFiltres masque déjà ces
    // cas en amont — cette vérification reste un filet de sécurité.
    let chuteSansCredit = false;
    if (draft.exonereTVA) {
      if (article.categorie === "Tranche") {
        const fe = produitCreditDeArticle(article);
        if (!fe) {
          setNotice(`Impossible d'ajouter « ${article.designation} » : cet article n'est pas lié à un produit du Stock (à faire au Catalogue).`);
          return;
        }
        const restant = Number((creditUtilisablePourCle(fe.cle) - creditEngageDraft(fe.cle)).toFixed(2));
        if (restant <= 0.004) {
          // Nils 26/10 (f) : plus de crédit — la tranche ne s'ajoute qu'en chute (toujours exonérable).
          chuteSansCredit = true;
          setNotice(`Plus de crédit exo pour ${fe.libelle} : « ${article.designation} » est ajouté comme chute. Indique ses dimensions.`);
        }
      } else if (!article.exonerable) {
        setNotice(`Impossible d'ajouter « ${article.designation} » : ce devis est marqué exonéré et cet article n'est pas coché « TVA exonérable » au Catalogue.`);
        return;
      }
    }
    const ligne = {
      id: uid(),
      type: "facture",
      articleId: article.id,
      designation: article.designation,
      qte: 1,
      unite: article.unite,
      prixPublic: prix,
      remise: Number(draft.remiseGlobale) || 0,
      groupe: article.structurel ? article.groupe : null,
      ...(chuteSansCredit ? { chute: true, chuteDimensions: "", unite: "chute" } : {}),
    };
    setDraft({ ...draft, lignes: [...draft.lignes, ligne] });
    setLigneQuery("");
  }


  // ERP step 8 : une ligne libre est désormais une ligne de texte pure dans
  // la Description des morceaux — sans prix ni quantité, comme un élément
  // Descriptifs du Catalogue, mais sans passer par le Catalogue. Tout ce qui
  // se facture doit maintenant exister comme article (Catalogue), pour
  // qu'on repère immédiatement une tentative de facturer hors catalogue.
  function ajouterLigneLibre() {
    if (!ligneLibreForm.designation.trim()) return;
    const ligne = {
      id: uid(),
      type: "descriptif",
      articleId: null,
      designation: ligneLibreForm.designation.trim(),
    };
    setDraft({ ...draft, lignes: [...draft.lignes, ligne] });
    setLigneLibreForm({ designation: "" });
    setShowLigneLibre(false);
  }

  // ERP step 8 (accord du 21/09) : sur un devis exonéré, la quantité d'une
  // ligne Tranche ne peut jamais dépasser le crédit disponible pour sa clé
  // (registre + ce que le dossier détient déjà, moins les autres lignes du
  // même devis sur cette clé) — la modification est plafonnée plutôt que
  // refusée, pour rester fluide à la saisie.
  function updateLigne(id, patch) {
    let finalPatch = patch;
    if (draft.exonereTVA && patch.qte !== undefined) {
      const ligne = draft.lignes.find((l) => l.id === id);
      const art = ligne && ligne.type === "facture" && ligne.articleId ? (articles || []).find((a) => a.id === ligne.articleId) : null;
      const fe = art && art.categorie === "Tranche" && !(patch.chute ?? ligne.chute) ? produitCreditDeArticle(art) : null;
      if (fe) {
        const plafond = Math.max(0, Number((creditUtilisablePourCle(fe.cle) - creditEngageDraft(fe.cle, id)).toFixed(2)));
        const demande = Number(patch.qte) || 0;
        if (demande > plafond) {
          setNotice(`Quantité limitée au crédit disponible dans le registre de crédit pour ${fe.libelle} : ${plafond}.`);
          finalPatch = { ...patch, qte: plafond };
        }
      }
    }
    setDraft({ ...draft, lignes: draft.lignes.map((l) => (l.id === id ? { ...l, ...finalPatch } : l)) });
  }

  function supprimerLigne(id) {
    setDraft({ ...draft, lignes: draft.lignes.filter((l) => l.id !== id) });
  }

  // Déplace une ligne d'un cran, seulement parmi les lignes de sa propre
  // section (descriptif ou facturé) — les deux sections gardent chacune leur
  // propre ordre, indépendamment l'une de l'autre.
  function deplacerLigne(id, direction) {
    const lignes = draft.lignes;
    const iActuelGlobal = lignes.findIndex((l) => l.id === id);
    if (iActuelGlobal === -1) return;
    const estDescriptif = lignes[iActuelGlobal].type === "descriptif";
    const indicesMemeSection = lignes
      .map((l, i) => i)
      .filter((i) => (lignes[i].type === "descriptif") === estDescriptif);
    const pos = indicesMemeSection.indexOf(iActuelGlobal);
    const posCible = pos + direction;
    if (posCible < 0 || posCible >= indicesMemeSection.length) return;
    const iCibleGlobal = indicesMemeSection[posCible];
    const next = [...lignes];
    [next[iActuelGlobal], next[iCibleGlobal]] = [next[iCibleGlobal], next[iActuelGlobal]];
    setDraft({ ...draft, lignes: next });
  }

  function mettreAJourPrix() {
    const next = draft.lignes.map((l) => {
      if (l.type === "descriptif") return l; // texte laissé tel quel, jamais écrasé
      if (!l.articleId) return l; // lignes libres : jamais touchées
      const art = (articles || []).find((a) => a.id === l.articleId);
      if (!art) return l;
      // Chute vendue : prix recalculé au prorata de sa surface (inchangé si la surface est inconnue).
      if (l.chute) { const px = prixChute(art, l.chuteDimensions); return px === null ? l : { ...l, prixPublic: px }; }
      if (art.structurel) {
        // Prix par groupe : on recalcule seulement le prix du groupe déjà
        // choisi sur la ligne, la désignation (couleur/# précisée) ne bouge pas.
        const prix = prixGroupeArticle(art, l.groupe);
        return prix == null ? l : { ...l, prixPublic: prix };
      }
      return { ...l, prixPublic: art.prixPublic, unite: art.unite, designation: art.designation };
    });
    setDraft({ ...draft, lignes: next });
    setNotice("Prix mis à jour depuis le catalogue sur toutes les lignes concernées.");
  }

  // ---------- Notes de page ----------
  function ajouterNote() {
    setDraft({ ...draft, notes: [...(draft.notes || []), ""] });
  }
  function updateNote(i, texte) {
    const notes = [...draft.notes];
    notes[i] = texte;
    setDraft({ ...draft, notes });
  }
  function supprimerNote(i) {
    setDraft({ ...draft, notes: draft.notes.filter((_, idx) => idx !== i) });
  }




  // ---------- Nils 05/10 (h4) : forfaits transport (livraison / RDM) — simulateur ----------
  const TRANSPORT_DEFAUT = {
    prixCarburant: 12.5,
    vehicules: { livraison: { nom: "Camion de livraison", conso: 18, usureKm: 1.5, fixe: 0 }, rdm: { nom: "Véhicule léger (RDM)", conso: 7, usureKm: 0.6, fixe: 0 } },
    zones: [
      { id: "z-casa", nom: "Casablanca", km: 70, peage: 0 },
      { id: "z-rabat", nom: "Rabat", km: 220, peage: 60 },
      { id: "z-marrakech", nom: "Marrakech", km: 440, peage: 160 },
    ],
  };
  function transportCouts() {
    return (coutsRevient && coutsRevient.transport) || TRANSPORT_DEFAUT;
  }
  // Nils 08/10 (r) : péage par zone selon le véhicule (camion pour la livraison, voiture pour le RDM).
  function peageZone(zone, typeVeh) {
    const k = typeVeh === "livraison" ? "peageCamion" : "peageVoiture";
    return zone[k] !== undefined && zone[k] !== "" ? nombreOuZero(zone[k]) : nombreOuZero(zone.peage);
  }
  // Coût réel au km (carburant + entretien / leasing, 12 mois) : livraison = moyenne Movano + H100 ;
  // RDM = 75 % Clio (diesel) + 25 % Sandero (essence). null tant qu'il n'y a pas assez de km relevés.
  function coutKmFlotte(typeVeh) {
    const vehs = ((flotte && flotte.vehicules) || []).filter((v) => v.actif !== false && (v.type || "rdm") === typeVeh);
    const reel = (liste) => {
      const th = liste.map((v) => coutKmTheorique(v, todayISO())).filter(Boolean);
      if (th.length) return { carb: th.reduce((n, x) => n + x.carbKm, 0) / th.length, autres: th.reduce((n, x) => n + x.amortKm, 0) / th.length };
      const c = liste.map((v) => coutsVehicule12(v.id)).filter((x) => x.fiable);
      return c.length ? { carb: c.reduce((n, x) => n + x.carbKm, 0) / c.length, autres: c.reduce((n, x) => n + x.autresKm, 0) / c.length } : null;
    };
    if (typeVeh === "livraison") return reel(vehs);
    const clio = reel(vehs.filter((v) => /clio/i.test(v.nom || "")));
    const sandero = reel(vehs.filter((v) => /sandero/i.test(v.nom || "")));
    if (clio && sandero) return { carb: 0.75 * clio.carb + 0.25 * sandero.carb, autres: 0.75 * clio.autres + 0.25 * sandero.autres };
    return clio || sandero || reel(vehs);
  }
  function forfaitTransport(zone, typeVeh) {
    const km = nombreOuZero(zone.km);
    const peage = peageZone(zone, typeVeh);
    const r = coutKmFlotte(typeVeh);
    if (r) {
      const carburant = km * r.carb, usure = km * r.autres;
      return { carburant, usure, peage, fixe: 0, total: carburant + usure + peage, reel: true };
    }
    return forfaitTransportManuel(zone, typeVeh);
  }
  // Paramètres manuels seuls (sans la flotte) — utilisés aussi en secours par le coût théorique d'un véhicule.
  function forfaitTransportManuel(zone, typeVeh) {
    const t = transportCouts();
    const v = (t.vehicules || {})[typeVeh] || {};
    const km = nombreOuZero(zone.km);
    const peage = peageZone(zone, typeVeh);
    // Paramètres manuels (en attendant assez de km relevés) : diesel pour la livraison, 75 % diesel / 25 % essence pour le RDM.
    const diesel = nombreOuZero(t.prixDiesel !== undefined && t.prixDiesel !== "" ? t.prixDiesel : t.prixCarburant);
    const essence = t.prixEssence !== undefined && t.prixEssence !== "" ? nombreOuZero(t.prixEssence) : diesel;
    const prix = typeVeh === "livraison" ? diesel : 0.75 * diesel + 0.25 * essence;
    const carburant = km * nombreOuZero(v.conso) / 100 * prix;
    const usure = km * nombreOuZero(v.usureKm);
    return { carburant, usure, peage, fixe: 0, total: carburant + usure + peage, reel: false };
  }
  async function majTransport(patch) {
    await persistCoutsRevient({ ...coutsRevient, transport: { ...transportCouts(), ...patch } });
  }
  function titrePC(id, titre, resume) {
    const ouvert = !!pcOuverts[id];
    return (
      <button type="button" className="sc-btn" onClick={() => setPcOuverts({ ...pcOuverts, [id]: !ouvert })} style={{ display: "flex", alignItems: "baseline", gap: 10, width: "100%", background: "transparent", padding: 0, textAlign: "left", cursor: "pointer", color: ENCRE }}>
        <span style={{ fontSize: 13, color: TAUPE, width: 14, display: "inline-block" }}>{ouvert ? "▾" : "▸"}</span>
        <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontWeight: 600 }}>{titre}</span>
        {resume && <span style={{ fontSize: 12, color: TAUPE, fontWeight: 400 }}>{resume}</span>}
      </button>
    );
  }
  function renderForfaitsTransport() {
    const t = transportCouts();
    const carte = { background: "#fff", border: `1px solid ${OCRE}`, borderRadius: 10, padding: 16, marginBottom: 20 };
    const titre = { fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 };
    const num = (v, set, w) => <input type="number" min="0" className="sc-input" value={v ?? ""} onChange={(e) => set(e.target.value)} style={{ ...inputStyle(w || 90), padding: "5px 6px", textAlign: "right" }} />;
    const th = { fontSize: 10, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.4, textAlign: "right", padding: "6px 8px", borderBottom: `1px solid ${PIERRE}`, whiteSpace: "nowrap" };
    const td = { fontSize: 12, textAlign: "right", padding: "5px 8px", borderBottom: `1px solid ${PIERRE}`, whiteSpace: "nowrap" };
    const setVeh = (k, patch) => majTransport({ vehicules: { ...t.vehicules, [k]: { ...(t.vehicules[k] || {}), ...patch } } });
    const setZone = (id, patch) => majTransport({ zones: t.zones.map((z) => (z.id === id ? { ...z, ...patch } : z)) });
    return (
      <div style={carte}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: pcOuverts.transport ? 10 : 0 }}>
          {titrePC("transport", "Forfaits transport — livraison et RDM", `${t.zones.length} zone(s)`)}
        </div>
        {pcOuverts.transport && (<>
        <div style={{ fontSize: 11, color: TAUPE, marginBottom: 12, lineHeight: 1.5 }}>Le carburant et le péage (cartes, Jawaz) ne se rattachent pas à un dossier : chaque dossier recevra le forfait de sa zone (livraison) et un forfait RDM par passage. Forfait = km aller-retour × coût réel au km des 12 derniers mois (carburant + entretien / leasing, module Véhicules : livraison = moyenne Movano + H100, RDM = 75 % Clio + 25 % Sandero) + péage aller-retour (camion pour la livraison, voiture pour le RDM). Tant qu'un type n'a pas 1 000 km relevés, les paramètres manuels ci-dessous servent. Pas de « fixe » : le temps des livreurs (les poseurs) est déjà dans le coût de pose.</div>
        <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 14 }}>
          <Field label="Prix du diesel (DH / L)" style={{ marginBottom: 0 }}>{num(t.prixDiesel !== undefined ? t.prixDiesel : t.prixCarburant, (v) => majTransport({ prixDiesel: v }))}</Field>
          <Field label="Prix de l'essence (DH / L)" style={{ marginBottom: 0 }}>{num(t.prixEssence, (v) => majTransport({ prixEssence: v }))}</Field>
          {[["livraison", "Livraison"], ["rdm", "RDM"]].map(([k, lib]) => {
            const v = t.vehicules[k] || {};
            return (
              <div key={k} style={{ background: PIERRE, borderRadius: 8, padding: 10 }}>
                <div style={titre}>{lib} {coutKmFlotte(k) ? <span style={{ color: VERT_OK, textTransform: "none", letterSpacing: 0 }}>— coût réel utilisé : {fmtMAD(coutKmFlotte(k).carb + coutKmFlotte(k).autres)} DH/km</span> : <span style={{ textTransform: "none", letterSpacing: 0 }}>— paramètres manuels (pas encore assez de km relevés)</span>}</div>
                <input className="sc-input" value={v.nom || ""} onChange={(e) => setVeh(k, { nom: e.target.value })} style={{ ...inputStyle(200), padding: "5px 6px", marginBottom: 6 }} />
                <div style={{ display: "flex", gap: 8, fontSize: 12, alignItems: "center", flexWrap: "wrap" }}>
                  Conso (L/100 km) {num(v.conso, (x) => setVeh(k, { conso: x }), 70)}
                  Usure (DH/km) {num(v.usureKm, (x) => setVeh(k, { usureKm: x }), 70)}
                </div>
              </div>
            );
          })}
        </div>
        <table style={{ borderCollapse: "collapse", minWidth: 640 }}>
          <thead><tr>{["Zone", "km aller-retour", "Péage camion A/R", "Péage voiture A/R", "Forfait livraison", "Forfait RDM", ""].map((h, i) => <th key={h + i} style={{ ...th, textAlign: i === 0 ? "left" : "right" }}>{h}</th>)}</tr></thead>
          <tbody>
            {t.zones.map((z) => {
              const fl = forfaitTransport(z, "livraison"), fr = forfaitTransport(z, "rdm");
              return (
                <tr key={z.id}>
                  <td style={{ ...td, textAlign: "left" }}><input className="sc-input" value={z.nom} onChange={(e) => setZone(z.id, { nom: e.target.value })} style={{ ...inputStyle(160), padding: "5px 6px" }} /></td>
                  <td style={td}>{num(z.km, (v) => setZone(z.id, { km: v }), 80)}</td>
                  <td style={td}>{num(z.peageCamion !== undefined ? z.peageCamion : z.peage, (v) => setZone(z.id, { peageCamion: v }), 80)}</td>
                  <td style={td}>{num(z.peageVoiture !== undefined ? z.peageVoiture : z.peage, (v) => setZone(z.id, { peageVoiture: v }), 80)}</td>
                  <td style={{ ...td, fontWeight: 700 }} title={`carburant ${fmtMAD(fl.carburant)} + usure ${fmtMAD(fl.usure)} + péage ${fmtMAD(fl.peage)}${fl.reel ? " (coût réel)" : ""}`}>{formatDH(fl.total)}</td>
                  <td style={{ ...td, fontWeight: 700 }} title={`carburant ${fmtMAD(fr.carburant)} + usure ${fmtMAD(fr.usure)} + péage ${fmtMAD(fr.peage)}${fr.reel ? " (coût réel)" : ""}`}>{formatDH(fr.total)}</td>
                  <td style={td}><button type="button" className="sc-btn" onClick={() => majTransport({ zones: t.zones.filter((x) => x.id !== z.id) })} style={iconBtnStyle}>✕</button></td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <button type="button" className="sc-btn" onClick={() => majTransport({ zones: [...t.zones, { id: uid(), nom: "Nouvelle zone", km: "", peage: "" }] })} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>+ Ajouter une zone</button>
        <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Valeurs de départ indicatives (km depuis l'usine de Had Soualem) : à remplacer par les tiennes.</div>
        <div style={{ background: PIERRE, borderRadius: 8, padding: 10, marginTop: 14 }}>
          <div style={titre}>Coûts réels des véhicules — 12 derniers mois</div>
          <table style={{ borderCollapse: "collapse", minWidth: 640 }}>
            <thead><tr>{["Véhicule", "Km", "L/100", "Carburant", "Entretien, leasing…", "Carburant / km", "Autres / km", "Forfaits"].map((h, i) => <th key={h} style={{ ...th, textAlign: i === 0 ? "left" : "right" }}>{h}</th>)}</tr></thead>
            <tbody>
              {vehiculesFlotte().filter((v) => v.actif !== false).map((v) => { const c = coutsVehicule12(v.id); return (
                <tr key={v.id}>
                  <td style={{ ...td, textAlign: "left" }}>{v.nom}</td>
                  <td style={td}>{c.km ? c.km.toLocaleString("fr-FR") : "—"}</td>
                  <td style={td}>{c.l100 ? c.l100.toFixed(1).replace(".", ",") : "—"}</td>
                  <td style={td}>{formatDH(c.carburant)}</td>
                  <td style={td}>{formatDH(c.autres)}</td>
                  <td style={td}>{c.km ? fmtMAD(c.carbKm) : "—"}</td>
                  <td style={td}>{c.km ? fmtMAD(c.autresKm) : "—"}</td>
                  <td style={{ ...td, color: c.fiable ? VERT_OK : TAUPE }}>{c.fiable ? "coût réel" : "forfait du type (< 1 000 km)"}</td>
                </tr>
              ); })}
            </tbody>
          </table>
          <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Carburant = tickets payés par la société (hors carte personnelle exclue). Autres = sorties de trésorerie réparties sur le véhicule (entretien, voiture, leasing). Le péage est celui de la zone, camion ou voiture selon le type du véhicule. Dès 1 000 km sur 12 mois, une fiche de déplacement qui choisit ce véhicule prend son coût réel au km ; avant, le forfait du type ci-dessus.</div>
        </div>
        <div style={{ background: PIERRE, borderRadius: 8, padding: 10, marginTop: 14 }}>
          <div style={titre}>Prime de déplacement (par personne et par jour)</div>
          {[...primesDeplacementVersions()].sort((a, b) => (a.dateEffet < b.dateEffet ? -1 : 1)).map((v, i, arr) => (
            <div key={i} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, marginBottom: 4 }}>
              à partir du <input type="date" className="sc-input" value={v.dateEffet} onChange={(e) => e.target.value && majTransport({ primesDeplacement: arr.map((y, j) => (j === i ? { ...y, dateEffet: e.target.value } : y)) })} style={{ ...inputStyle(150), padding: "5px 6px" }} />
              {num(v.montant, (x) => majTransport({ primesDeplacement: arr.map((y, j) => (j === i ? { ...y, montant: x } : y)) }), 80)} DH
              {arr.length > 1 && <button type="button" className="sc-btn" onClick={() => majTransport({ primesDeplacement: arr.filter((_, j) => j !== i) })} style={iconBtnStyle}>✕</button>}
            </div>
          ))}
          <button type="button" className="sc-btn" onClick={() => majTransport({ primesDeplacement: [...primesDeplacementVersions(), { dateEffet: todayISO(), montant: String(tauxPrimeDeplacementAu(todayISO())) }] })} style={{ ...ghostBtnStyle, padding: "2px 0", fontSize: 12 }}>+ Nouveau montant (daté)</button>
          <div style={{ fontSize: 11, color: TAUPE }}>Appliquée automatiquement à chaque personne d'une fiche de déplacement (× nombre de jours). Un nouveau montant ne change pas les déplacements antérieurs à sa date.</div>
        </div>
        </>)}
      </div>
    );
  }
  // ---------- Nils 05/10 (h5) : export PDF de la grille tarifaire (tranches brutes) ----------
  function ouvrirExportGrille() {
    const matieres = MATIERES.filter((m) => (EPAISSEURS_PAR_MATIERE[m] || []).some((ep) => { const l = (prixGroupesTranche || {})[cleCombinaisonTranche(m, ep)] || {}; return GROUPES.some((g) => nombreOuZero(l[g]) > 0); }));
    const matiere = matieres.includes("Grès Cérame") ? "Grès Cérame" : matieres[0] || MATIERES[0];
    const profil = profilsRevient().find((p) => p.type === "tranches" && p.matiere === matiere);
    const surfaces = Object.fromEntries((EPAISSEURS_PAR_MATIERE[matiere] || []).map((ep) => [ep, profil && nombreOuZero((profil.surfaces || {})[ep]) ? String(profil.surfaces[ep]) : ep === "6mm" ? "5.12" : "5.25"]));
    setExportGrille({ matiere, remise: "0", date: todayISO(), surfaces });
  }
  function htmlGrilleTarifaire(e) {
    const r = Math.min(Math.max(nombreOuZero(e.remise), 0), 99) / 100;
    const fmt = (n) => `${(Math.round(n * 100) / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} MAD`;
    const tva = 1 + TVA_TAUX;
    const eps = (EPAISSEURS_PAR_MATIERE[e.matiere] || []);
    let rows = "";
    GROUPES.forEach((g) => {
      const lignes = [];
      eps.forEach((ep) => [1, 2].forEach((ch) => {
        const table = ch === 2 ? prixGroupesTranche2eChoix : prixGroupesTranche;
        const pm2 = nombreOuZero(((table || {})[cleCombinaisonTranche(e.matiere, ep)] || {})[g]);
        if (!(pm2 > 0)) return;
        const ht = pm2 * (1 - r);
        const surf = nombreOuZero(e.surfaces[ep]);
        lignes.push(`<tr><td class="typo">${escapeHtml(ep.replace("mm", " mm"))} · ${ch === 2 ? "2e" : "1er"} choix</td><td class="n">${fmt(ht)}</td><td class="n">${fmt(ht * tva)}</td><td class="n">${surf ? fmt(ht * surf) : "—"}</td><td class="n">${surf ? fmt(ht * surf * tva) : "—"}</td></tr>`);
      }));
      if (lignes.length) rows += `<tr class="grp"><td colspan="5">Groupe ${g}</td></tr>${lignes.join("")}`;
    });
    const dateTxt = new Date(`${e.date}T12:00:00`).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
    const badge = r > 0 ? `Tarif remisé — remise appliquée : ${(r * 100).toFixed(2).replace(".", ",")}%` : "Tarif public (aucune remise)";
    const libMat = e.matiere === "Grès Cérame" ? "céramique" : String(e.matiere).toLowerCase();
    return `<!DOCTYPE html><html lang="fr"><head><meta charset="UTF-8"><title>Grille tarifaire</title>
<link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400&family=DM+Sans:wght@400;500;700&family=IBM+Plex+Mono:wght@400&display=swap" rel="stylesheet">
<style>
  @page { size: A4 portrait; margin: 1.2cm 1.2cm 1.4cm; }
  * { box-sizing: border-box; }
  body { margin: 0; font-family: "DM Sans", Arial, sans-serif; color: #281E1E; font-size: 9.5pt; }
  .tete { display: flex; justify-content: space-between; align-items: flex-end; padding-bottom: 12px; border-bottom: 2.5px solid #281E1E; }
  .tete img { height: 58px; }
  .droite { text-align: right; }
  h1 { font-family: "Cormorant Garamond", Georgia, serif; font-weight: 300; font-size: 24pt; margin: 0 0 4px; letter-spacing: 0.2px; }
  .emise { font-size: 9pt; margin-bottom: 8px; }
  .badge { display: inline-block; border: 1px solid #8C8282; border-radius: 4px; padding: 4px 10px; font-weight: 700; font-size: 9pt; }
  table { width: 100%; border-collapse: collapse; margin-top: 14px; }
  th { text-align: left; font-size: 7.5pt; font-weight: 700; letter-spacing: 0.7px; text-transform: uppercase; color: #9a9393; padding: 10px 6px 8px; }
  td { padding: 8px 6px; border-bottom: 1px solid #ddd8d6; }
  tr.grp td { font-size: 8pt; letter-spacing: 1px; text-transform: uppercase; color: #9a9393; font-weight: 700; padding-top: 12px; }
  td.typo { font-weight: 700; }
  td.n { font-family: "IBM Plex Mono", Consolas, monospace; font-size: 8.8pt; white-space: nowrap; }
  .pied { margin-top: 28px; font-size: 7.5pt; color: #b3adab; line-height: 1.6; }
  tr { page-break-inside: avoid; }
</style></head><body>
<div class="tete"><img src="${LOGO_SRC}" alt="Stone Concept"><div class="droite"><h1>Grille tarifaire — Tranches ${escapeHtml(libMat)}</h1><div class="emise">Émise le ${escapeHtml(dateTxt)}</div><span class="badge">${escapeHtml(badge)}</span></div></div>
<table><thead><tr><th style="width:24%">Typologie</th><th>Prix HT / m²</th><th>Prix TTC / m²</th><th>Prix HT / tranche</th><th>Prix TTC / tranche</th></tr></thead><tbody>${rows || `<tr><td colspan="5">Aucun prix pour ${escapeHtml(e.matiere)}.</td></tr>`}</tbody></table>
<div class="pied">Stone Concept Sarl · Patente 45193146 · IF 06527382 · ICE 000073605 0000 01 · RC 54585<br>Commune rurale de Soualem, douar Lakhlayf<br>Hot Line : 06 61 26 49 31 · commandes : sales@stoneconcept.ma</div>
</body></html>`;
  }
  async function exporterGrille() {
    const e = exportGrille;
    if (!e) return;
    const r = nombreOuZero(e.remise);
    const nom = `Grille_tarifaire_${e.date.slice(0, 4)}_${e.matiere === "Grès Cérame" ? "" : e.matiere.replace(/\s+/g, "_") + "_"}${r > 0 ? String(r).replace(".", ",") : "Prix_public"}`;
    await telechargerDocument(htmlGrilleTarifaire(e), nom, "grille tarifaire");
    await tracerAcces("grille tarifaire exportée", `${e.matiere} — ${r > 0 ? `remise ${r} %` : "prix public"}`);
    setExportGrille(null);
  }
  // ---------- ERP step 14 (d) : marge par dossier — Nils seul ----------
  function lotParId(id) {
    return (items || []).find((it) => it.id === id) || (lotsArchives || []).find((it) => it.id === id) || null;
  }
  // Surface d'une pièce d'un lot (m²) : dimensions du lot, sinon format standard du profil d'import, sinon de l'article.
  function surfaceLot(lot) {
    if (!lot) return 0;
    const s1 = surfaceDimensions(lot.dimensions);
    if (s1) return s1;
    const art = articleDuProduit(lot.produitId);
    const s2 = art ? surfaceDimensions(art.dimension) : null;
    if (s2) return s2;
    const prof = art ? profilTranchesPour(art.fournisseur, art.matiere) : null;
    return prof ? nombreOuZero((prof.surfaces || {})[lot.epaisseur || art.epaisseurMatiere]) : 0;
  }
  // Nils 17/10 : un article en tranches se vend à la tranche entière, ou au quart de tranche si le
  // Gérant a coché « Vendable au quart de tranche » dans le Catalogue. Pas de saisie : 1 ou 0,25 ;
  // null pour un article qui n'est pas en tranches. La case vaut au moment de la saisie.
  function pasVenteTranche(article) {
    if (!article || article.categorie !== "Tranche") return null;
    return article.vendableQuartTranche ? 0.25 : 1;
  }
  // Nils 26/10 : vente de chutes — prix de la tranche entière (grille) et prix d'une chute au prorata de sa
  // surface (null si la surface de la tranche ou de la chute est inconnue : prix à saisir).
  function prixTrancheArticle(a) {
    if (!a) return null;
    const p = a.structurel ? prixGroupeArticle(a, a.groupe) : a.prixPublic;
    return p === undefined ? null : p;
  }
  function surfaceTrancheArticle(a) {
    if (!a) return 0;
    const s = surfaceM2(a.dimension); // même surface que la grille de vente (prixGroupeArticle)
    if (s) return s;
    const prof = profilTranchesPour(a.fournisseur, a.matiere);
    return prof ? nombreOuZero((prof.surfaces || {})[a.epaisseurMatiere]) : 0;
  }
  function prixChute(a, dimensions) {
    const sc = surfaceDimensions(dimensions), st = surfaceTrancheArticle(a), p = prixTrancheArticle(a);
    if (!sc || !st || p === null || !isFinite(Number(p))) return null;
    return Math.round(Number(p) * Math.min(1, sc / st) * 100) / 100;
  }
  function estMultipleDe(q, pas) {
    return Math.abs(q / pas - Math.round(q / pas)) < 1e-9;
  }
  // Lot de tranche (pas une chute) : sortie en tranches entières, consommation au pas de l'article.
  function pasConsommationLot(lot) {
    if (!lot || lot.type === TYPE_CHUTE || !estLotTranche(lot)) return null;
    return pasVenteTranche(articleDuProduit(lot.produitId)) || 1;
  }
  function valeurChute(src, dimensions) {
    if (!src) return null;
    const sc = surfaceDimensions(dimensions), ss = surfaceLot(src), cu = coutRevientUnitaireLot(src);
    if (!sc || !ss || cu === null) return null;
    return Math.round(cu * Math.min(1, sc / ss) * 100) / 100;
  }
  function plDuDossier(c, m) {
    return !!(c && c.numeroPL && m.pl && (m.pl === c.numeroPL || String(m.pl).startsWith(`${c.numeroPL}-`)));
  }
  function dossierDuPL(pl) {
    if (!pl) return null;
    return (commandesListe || []).find((c) => c.numeroPL && (pl === c.numeroPL || String(pl).startsWith(`${c.numeroPL}-`))) || null;
  }
  function estLotTranche(lot) {
    const p = lot ? produitDe(lot.produitId) || lot.produitSnapshot || {} : {};
    return familleInventaire(p.categorie) === "Tranches";
  }
  function dossierTransfo(c) { return typeVenteDossier(c).includes("Avec transformation"); }
  // ERP step 16 (Nils 12/10, u) : plus d'exception « fiche de pose datée » — seule la case « Article de pose » compte.
  function dossierPose(c) { return typeVenteDossier(c).includes("Avec pose"); }
  // m² de tranches (et chutes) sortis sur les PL d'un dossier (hors tranches refaites après un incident :
  // leur coût est compté à part, Nils 01/11).
  function m2SortisDossier(c) {
    return (mouvements || []).filter((m) => m.type === "sortie" && plDuDossier(c, m) && !estMouvementConsommable(m) && !m.enService && !m.incidentId).reduce((n, m) => {
      const lot = lotParId(m.itemId);
      return lot && estLotTranche(lot) ? n + (Number(m.quantite) || 0) * surfaceLot(lot) : n;
    }, 0);
  }
  function datePLDossier(c) {
    const ds = (mouvements || []).filter((m) => m.type === "sortie" && plDuDossier(c, m)).map((m) => m.date).sort();
    return ds[0] || (c.datePL || "").slice(0, 10) || "";
  }
  function nbPoseursDossier(c) {
    const fp = c.fichePose || {};
    return (fp.poseurs || []).filter(Boolean).length + (fp.aidesPoseurs || []).filter(Boolean).length;
  }
  // Masse salariale brute d'un mois : atelier (service Atelier sans Ahmed ni Wissam ni poseurs) / pose (poseurs).
  function masseSalarialeMois(ym, groupe) {
    const [deb, fin] = bornesPeriode(ym);
    let total = 0, manquants = 0;
    (staff || []).filter((x) => !ficheStaffMasquee(x) && staffPresentSur(x, deb, fin)).forEach((x) => {
      const poseur = !!x.poseur || x.service === "Pose";
      const dansAtelier = x.service === "Atelier" && !poseur && ![P_PROD, P_BT].includes((compteUtilisateurDe(x.compte) || {}).profil);
      if ((groupe === "pose" && !poseur) || (groupe === "atelier" && !dansAtelier)) return;
      const b = salaireBrutAu(x, fin);
      if (b === null) { manquants++; total += salaireActuel(x) || 0; } else total += b;
    });
    return { total, manquants };
  }
  // Nils 28/10 : quantité des majorations « Demande des listellos » d'un dossier (tranches façonnées à 45°).
  function qteMajListelloDossier(c) {
    const coches = new Set((articles || []).filter((a) => a.demandeListello).map((a) => a.id));
    if (!coches.size) return 0;
    return (lignesDuDossier(c) || []).filter((l) => (!l.type || l.type === "facture") && l.articleId && coches.has(l.articleId)).reduce((n, l) => n + (Number(l.qte) || 0), 0);
  }
  // Données d'un mois pour les taux (mémoïsées par rendu).
  function donneesTauxMois(ym, cache) {
    if (cache && cache[ym]) return cache[ym];
    const [deb, fin] = bornesPeriode(ym);
    let m2Transfo = 0, m2PoseurPose = 0, consoAtelier = 0;
    (commandesListe || []).forEach((c) => {
      if (c.anterieure) return;
      const dpl = datePLDossier(c);
      if (dpl >= deb && dpl <= fin && dossierTransfo(c)) m2Transfo += m2SortisDossier(c);
      const dp = c.fichePose ? dateDebutPose(c.fichePose) : "";
      if (dp >= deb && dp <= fin && dossierPose(c)) m2PoseurPose += m2SortisDossier(c) * Math.max(1, nbPoseursDossier(c));
    });
    // Nils 28/10 : les listellos sortent du coût atelier ; leur valeur se répartit sur les dossiers du mois
    // selon la quantité des majorations cochées « Demande des listellos » (tranches façonnées à 45°).
    let listelloValeur = 0, listelloTranches = 0, listelloChutes = 0, listelloChutesM2 = 0, listelloSansPrix = 0, qteMajListello = 0;
    (mouvements || []).filter((m) => m.type === "sortie" && m.date >= deb && m.date <= fin && (m.enService || (estMouvementConsommable(m) && !m.pl))).forEach((m) => {
      const lot = lotParId(m.itemId);
      if (estMouvementListello(m)) {
        // Coût de revient mémorisé par le serveur sur la sortie, sinon celui du lot.
        const cu = m.coutUnitaire !== undefined && m.coutUnitaire !== null ? Number(m.coutUnitaire) : coutRevientUnitaireLot(lot);
        if (cu === null || !isFinite(cu)) listelloSansPrix++;
        else listelloValeur += cu * (Number(m.quantite) || 0);
        if (lot && lot.type === TYPE_CHUTE) { listelloChutes += Number(m.quantite) || 0; listelloChutesM2 += (surfaceM2(lot.dimensions) || 0) * (Number(m.quantite) || 0); } else listelloTranches += Number(m.quantite) || 0;
        return;
      }
      consoAtelier += lot ? valeurLotHT(lot, Number(m.quantite) || 0) || 0 : 0;
    });
    (commandesListe || []).forEach((c) => {
      if (c.anterieure) return;
      const dpl = datePLDossier(c);
      if (dpl >= deb && dpl <= fin) qteMajListello += qteMajListelloDossier(c);
    });
    const at = masseSalarialeMois(ym, "atelier"), po = masseSalarialeMois(ym, "pose");
    // ERP step 15 (ak) : entretien / réparations des machines lourdes (carnet) dans le coût atelier.
    const entretienMachines = entretienMachinesMois(ym);
    const r = { ym, m2Transfo, m2PoseurPose, coutAtelier: at.total + consoAtelier + entretienMachines, consoAtelier, entretienMachines, massePose: po.total, manquants: at.manquants + po.manquants, listelloValeur, listelloTranches, listelloChutes, listelloChutesM2, listelloSansPrix, qteMajListello };
    if (cache) cache[ym] = r;
    return r;
  }
  // Taux atelier (DH / m²) et pose (DH / m² × poseur) : mois réel (A) et moyenne des 12 mois précédents (B).
  function tauxMarge(ym, cache) {
    const est = (coutsRevient && coutsRevient.estimations) || {};
    const d = donneesTauxMois(ym, cache);
    const prev = Array.from({ length: 12 }, (_, i) => donneesTauxMois(moisDecale(ym, -(i + 1)), cache));
    const sA = prev.reduce((n, x) => n + x.coutAtelier, 0), mA = prev.reduce((n, x) => n + x.m2Transfo, 0);
    const sP = prev.reduce((n, x) => n + x.massePose, 0), mP = prev.reduce((n, x) => n + x.m2PoseurPose, 0);
    const sL = prev.reduce((n, x) => n + x.listelloValeur, 0), qL = prev.reduce((n, x) => n + x.qteMajListello, 0);
    const estA = nombreOuZero(est.atelierM2), estP = nombreOuZero(est.poseM2);
    return {
      atelierA: d.m2Transfo > 0 ? d.coutAtelier / d.m2Transfo : estA, atelierB: mA > 0 ? sA / mA : estA,
      poseA: d.m2PoseurPose > 0 ? d.massePose / d.m2PoseurPose : estP, poseB: mP > 0 ? sP / mP : estP,
      // Coût des listellos par tranche façonnée (majoration cochée) : mois réel (A), 12 mois précédents (B).
      listelloA: d.qteMajListello > 0 ? d.listelloValeur / d.qteMajListello : 0, listelloB: qL > 0 ? sL / qL : 0,
      estimeA: !(d.m2Transfo > 0), estimeB: !(mA > 0), manquants: d.manquants, d,
    };
  }
  // ---------- déplacements ----------
  function zoneDe(id) {
    return (transportCouts().zones || []).find((z) => z.id === id) || null;
  }
  // Nils 05/10 : prime de déplacement fixe (80 DH) par personne et par jour de déplacement, montant daté.
  function primesDeplacementVersions() {
    const v = transportCouts().primesDeplacement;
    return Array.isArray(v) && v.length ? v : [{ dateEffet: "2000-01-01", montant: 80 }];
  }
  function tauxPrimeDeplacementAu(date) {
    const vs = [...primesDeplacementVersions()].sort((a, b) => (a.dateEffet < b.dateEffet ? 1 : -1));
    const v = vs.find((x) => x.dateEffet <= (date || "")) || vs[vs.length - 1];
    return v ? nombreOuZero(v.montant) : 0;
  }
  // Nils 09/10 (d) : jours par demi-journée (0,5 ; 1 ; 1,5…), prime au prorata.
  function joursPrime(x) {
    if (!x || x.sansPrime) return 0;
    return x.jours === undefined ? 1 : Math.max(0, Math.round(nombreOuZero(x.jours) * 2) / 2);
  }
  function primeParticipant(dep, x) {
    return joursPrime(x) * tauxPrimeDeplacementAu(dep.date);
  }
  function joursCouvertsPrime(dep, x) {
    return Array.from({ length: Math.ceil(joursPrime(x)) }, (_, i) => decalerJours(dep.date, i));
  }
  // Primes dues d'un mois (fiches datées dans le mois), par personne.
  function primesDeplacementDues(ym) {
    const parPers = {};
    const pers = (sid) => parPers[sid] || (parPers[sid] = { nom: ((staff || []).find((y) => y.id === sid) || {}).nom || "?", jours: 0, montant: 0 });
    (deplacements || []).filter((d) => String(d.date).startsWith(ym) && statutDepl(d) === "validée").forEach((d) => (d.participants || []).forEach((x) => {
      if (!x.staffId) return;
      const p = pers(x.staffId);
      p.jours += joursPrime(x); p.montant += primeParticipant(d, x);
    }));
    // Nils 01/11 : jours « déplacement sans fiche » saisis au pointage (D*).
    const rec = recPointage(ym);
    Object.entries((rec && rec.lignes) || {}).forEach(([sid, l]) => Object.entries((l && l.jours) || {}).forEach(([cle, c]) => {
      if (!c || !c.deplManuel || c.deplacementId || c.code) return;
      const j = Number(c.deplManuel.jours) === 0.5 ? 0.5 : 1;
      const p = pers(sid);
      p.jours += j; p.montant += j * tauxPrimeDeplacementAu(`${ym}-${String(cle).padStart(2, "0")}`);
    }));
    return { parPers, total: Object.values(parPers).reduce((n, p) => n + p.montant, 0) };
  }
  // Versements de primes de déplacement (caisse Nils) reliés à des mois.
  function versementsPrimesDepl(ym, saufOpId) {
    return (operations || []).filter((o) => o.id !== saufOpId && (o.primesDeplMois || []).includes(ym));
  }
  function moisPrimesAIndemniser(saufOpId) {
    const moisManuels = (pointage || []).filter((r) => Object.values(r.lignes || {}).some((l) => Object.values((l && l.jours) || {}).some((c) => c && c.deplManuel && !c.deplacementId && !c.code))).map((r) => r.mois);
    const mois = [...new Set([...(deplacements || []).map((d) => String(d.date).slice(0, 7)), ...moisManuels])].sort();
    return mois.filter((ym) => primesDeplacementDues(ym).total > 0 && !versementsPrimesDepl(ym, saufOpId).length);
  }
  function coutDeplacement(dep) {
    const z = zoneDe(dep.zoneId) || { km: 0, peage: 0 };
    // ERP step 15 (ak) : véhicule réel → coût réel au km sur 12 mois ; anciennes fiches (type × nombre) → forfait du type.
    const veh = (dep.vehicules || []).reduce((n, v) => n + coutVehiculeDepl(dep, z, v).total, 0);
    const primes = (dep.participants || []).reduce((n, x) => n + primeParticipant(dep, x), 0);
    const frais = depensesDepl(dep).reduce((n, x) => n + nombreOuZero(x.montant), 0);
    return { veh, primes, frais, total: veh + primes + frais };
  }
  // Nils 09/10 (f) : km réellement parcourus saisis sur la fiche → km × coût au km du véhicule (+ péage de la zone).
  function coutVehiculeDepl(dep, z, v) {
    if (v.vehiculeId) {
      const veh = vehiculeParId(v.vehiculeId);
      const km = nombreOuZero(v.km);
      if (km > 0) {
        const c = coutAuKmVehicule(veh, dep.date);
        const peage = peageZone(z, (veh && veh.type) || "rdm");
        return { total: km * (c.carb + c.autres) + peage, km, parKm: c.carb + c.autres, peage, source: c.source, reel: true };
      }
      const f = forfaitVehicule(z, veh, dep.date);
      return { ...f, source: f.theorique ? "theorique" : f.reel ? "reel12" : "type" };
    }
    return { total: forfaitTransport(z, v.type).total * Math.max(1, nombreOuZero(v.nb) || 1), source: "type" };
  }
  // Nils 09/10 (a, c) : dépenses réelles en liste libre ; anciennes fiches (hôtel / repas / carburant / autres) converties à la lecture.
  const TYPES_DEPENSE_DEPL = ["Hôtel", "Parking", "Carburant hors carte", "Repas", "Autre"];
  function depensesDepl(dep) {
    if (Array.isArray(dep.depenses)) return dep.depenses;
    const f = dep.frais || {};
    return [["hotel", "Hôtel"], ["repas", "Repas"], ["carburant", "Carburant hors carte"], ["autres", "Autre"]]
      .filter(([k]) => nombreOuZero(f[k]) > 0).map(([k, t]) => ({ id: `old-${k}`, type: t, libelle: "", montant: f[k] }));
  }
  function deplacementsDuDossier(id) {
    return (deplacements || []).filter((d) => (d.dossiers || []).includes(id));
  }
  // Transport d'un dossier : sa part des déplacements saisis ; sinon estimation (articles livraison / RDM facturés).
  function transportDossier(c) {
    const deps = deplacementsDuDossier(c.id);
    if (deps.length) return { total: deps.reduce((n, d) => n + coutDeplacement(d).total / Math.max(1, (d.dossiers || []).length), 0), estime: false, nb: deps.length };
    const cl = clientDe(c.clientId) || {};
    const zones = transportCouts().zones || [];
    const z = zoneDe(c.zoneTransport) || zones.find((x) => normLib(x.nom) === normLib(cl.ville)) || zones[0];
    if (!z) return { total: 0, estime: true, nb: 0 };
    let n = 0;
    lignesDuDossier(c).forEach((l) => {
      const a = l.articleId ? (articles || []).find((x) => x.id === l.articleId) : null;
      const q = Math.max(1, Math.round(Number(l.qte) || 1));
      // ERP step 16 : cases « Article de RDM » / « Article de livraison » (plus de lecture du texte).
      if (natureArticle(a, "rdm")) n += q * forfaitTransport(z, "rdm").total;
      if (natureArticle(a, "livraison")) n += q * forfaitTransport(z, "livraison").total;
    });
    return { total: n, estime: true, nb: 0, zone: z.nom };
  }
  // ---------- commission estimée d'un dossier (seuil Com1 supposé atteint) ----------
  function commissionEstimeeDossier(c, d) {
    const ver = versionCommissionAu(todayISO());
    const lignes = lignesDuDossier(c).filter((l) => l.type !== "descriptif").map((l) => {
      const a = l.articleId ? (articles || []).find((x) => x.id === l.articleId) : null;
      return { ht: calcLigne(l).montantHT, remise: Number(l.remise) || 0, exclue: !!(a && a.exclureCommission) };
    }).filter((l) => !l.exclue);
    const base = lignes.reduce((n, l) => n + l.ht, 0);
    const apporteur = apporteurEffectif(d), commercial = idCommercialDuDevis(d);
    let total = 0;
    const detail = [];
    (ver.personnes || []).forEach((p) => p.regles.forEach((r) => {
      let m = 0;
      if (r.type === "remise" && (r.clientsDe || []).includes(apporteur)) m = lignes.reduce((n, l) => n + l.ht * tauxPalier(r.paliers, l.remise) / 100, 0);
      if (r.type === "client") { const t = tauxRegleClient(r, commercial, c.clientId); if (t !== null) m = base * t / 100; }
      if (m > 0) { total += m; detail.push(`${p.nom} ${r.libelle} ${formatDH(m)}`); }
    }));
    if (String(apporteur || "").startsWith("app:")) { const m = base * nombreOuZero(d.tauxApporteur) / 100; total += m; detail.push(`${apporteur.slice(4)} (apporteur) ${formatDH(m)}`); }
    return { total, detail };
  }
  // ---------- marge ----------
  function margeDossier(c, cache) {
    const d = devisDuDossier(c);
    if (!d) return null;
    const alertes = [];
    // Step 17 (Nils 15/10) : les factures d'avoir du dossier sont déduites du CA de la marge.
    const avoirsHT = arrondiH(avoirsDeFacture(c.id).reduce((n, a) => n + (Number(a.ht) || 0), 0));
    // Nils 02/11 : l'acompte facturé avant l'ERP (ligne de déduction) fait partie du CA du logement pour la marge.
    const caFacture = calcTotaux({ ...d, lignes: lignesDuDossier(c).filter((l) => !l.deductionAcompte) }).totalHT;
    const acompteAvantErpHT = arrondiH(-calcTotaux({ lignes: lignesDuDossier(c).filter((l) => l.deductionAcompte) }).totalHT);
    const ca = caFacture - avoirsHT;
    // Matière (tranches, éviers, accessoires). Nils 17/10 : aucune déduction pour les chutes produites
    // (leur valeur ne compte que dans le dossier qui les réutilise) ; pour un article vendable au quart de
    // tranche, la consommation réelle déclarée au PL, sinon les tranches entières sorties.
    let matiere = 0, conso = 0, incidentsCout = 0;
    (mouvements || []).filter((m) => plDuDossier(c, m)).forEach((m) => {
      const lot = lotParId(m.itemId);
      const sortie = Number(m.quantite) || 0;
      const q = m.consommeDeclare !== undefined && m.consommeDeclare !== null ? Number(m.consommeDeclare) || 0 : sortie;
      if (m.type !== "sortie") return;
      if (estMouvementConsommable(m)) { conso += lot ? valeurLotHT(lot, q) || 0 : 0; return; }
      const cu = lot && lot.type !== TYPE_CHUTE ? coutRevientUnitaireLot(lot) : null;
      const val = cu !== null ? cu : (m.coutUnitaire !== undefined ? Number(m.coutUnitaire) : (lot ? coutRevientUnitaireLot(lot) : null));
      if (val === null) { alertes.push(`${lot ? libelleLot(lot) : "lot"} sans prix`); return; }
      // Nils 01/11 (étape c) : tranches refaites après un incident de production — coût de l'erreur, à part.
      if (m.incidentId) { incidentsCout += q * val; return; }
      matiere += q * val;
    });
    // Nils 09/10 : tant que la matière n'est pas sortie au PL, les réservations actives (attribuées à un lot)
    // comptent au coût de revient du lot ; la sortie réelle du PL prend le relais (même si c'est un autre lot).
    let matiereReservee = 0;
    const matiereSortie = (mouvements || []).some((m) => plDuDossier(c, m) && m.type === "sortie" && !estMouvementConsommable(m));
    (matiereSortie ? [] : reservations || []).filter((r) => r.statut === "active" && c.numero && r.bc === c.numero && r.itemId).forEach((r) => {
      const lot = lotParId(r.itemId);
      const cu = lot ? coutRevientUnitaireLot(lot) : null;
      if (cu === null) { alertes.push(`${lot ? libelleLot(lot) : "lot réservé"} sans prix`); return; }
      matiereReservee += (Number(r.quantite) || 0) * cu;
    });
    matiere += matiereReservee;
    const sortiePL = (mouvements || []).some((m) => plDuDossier(c, m));
    if (!sortiePL) alertes.push(matiereReservee > 0 ? "matière estimée sur les réservations (pas encore de sortie de PL)" : "aucune sortie de PL enregistrée");
    const m2 = m2SortisDossier(c);
    const ym = (datePLDossier(c) || todayISO()).slice(0, 7);
    const t = tauxMarge(ym, cache);
    if (t.estimeA) alertes.push(`taux atelier / pose de ${libPeriode(ym)} estimé`);
    if (t.estimeB) alertes.push("pas encore de mois mesuré pour la moyenne 12 mois (colonne B sur le taux estimé)");
    if (t.manquants) alertes.push(`${t.manquants} salaire(s) brut(s) manquant(s)`);
    const transfo = dossierTransfo(c);
    const atelierA = transfo ? m2 * t.atelierA : 0, atelierB = transfo ? m2 * t.atelierB : 0;
    let poseA = 0, poseB = 0;
    if (dossierPose(c)) {
      const yp = (c.fichePose && dateDebutPose(c.fichePose)) ? dateDebutPose(c.fichePose).slice(0, 7) : ym;
      const tp = yp === ym ? t : tauxMarge(yp, cache);
      const nb = Math.max(1, nbPoseursDossier(c));
      poseA = m2 * nb * tp.poseA; poseB = m2 * nb * tp.poseB;
      if (!nbPoseursDossier(c)) alertes.push("fiche de pose sans poseur");
    }
    const tr = transportDossier(c);
    if (tr.estime) alertes.push("transport estimé (aucun déplacement saisi)");
    if (deplacementsDuDossier(c.id).some((d) => statutDepl(d) !== "validée")) alertes.push("fiche de déplacement pas encore validée");
    const com = commissionEstimeeDossier(c, d);
    const ouverte = (commandesListe || []).length && encaisseDossier(c.id) < totalDossierTTC(c) - 0.01;
    if (ouverte) alertes.push("commande pas entièrement payée");
    const qteListello = qteMajListelloDossier(c);
    const listelloA = qteListello * t.listelloA, listelloB = qteListello * t.listelloB;
    // Nils 29/10 : compte prorata du projet (facture d'avance, factures, facture de retenue : % du HT des travaux).
    const dpm = deductionsDossier(c);
    const prorata = dpm ? arrondiH((dpm.htTravaux * dpm.prorataPct) / 100) : 0;
    const fixes = matiere + conso + incidentsCout + tr.total + com.total + prorata;
    const coutA = fixes + atelierA + poseA + listelloA, coutB = fixes + atelierB + poseB + listelloB;
    return { ca, caFacture, avoirsHT, acompteAvantErpHT, matiere, conso, incidentsCout, m2, atelierA, atelierB, poseA, poseB, qteListello, listelloA, listelloB, prorata, prorataPct: dpm ? dpm.prorataPct : 0, transport: tr, commission: com, coutA, coutB, margeA: ca - coutA, margeB: ca - coutB, pctA: ca ? ((ca - coutA) / ca) * 100 : 0, pctB: ca ? ((ca - coutB) / ca) * 100 : 0, alertes, ym, taux: t };
  }
  // Nils 29/10 : facture d'un dossier de projet immobilier — déductions (aperçu, puis figées à la facturation).
  function renderDeductionsDossier(c) {
    const dp = deductionsDossier(c);
    if (!dp) return null;
    const fige = !!c.deductionsProjet;
    const ch = projetDuDossier(c);
    const modifiable = !fige && c.statut !== "Facture" && (estGerant || peut("commandes.transformerBLFacture"));
    const basculer = async (v) => {
      const toSave = { ...c, solderAvance: v || undefined, modifiePar: user.nom, modifieLe: new Date().toISOString() };
      await persistCommandes((commandesListe || []).map((x) => (x.id === c.id ? toSave : x)));
      setCommandeEditing(toSave);
      await tracerAcces("dernière facture du projet", `Dossier ${c.numero} — ${v ? "solde de l'avance déduit" : "décoché"}`);
    };
    const p = (x) => String(x).replace(".", ",");
    const l = (lib, v, fort) => (<div style={{ display: "flex", justifyContent: "space-between", gap: 16, fontWeight: fort ? 700 : 400 }}><span>{lib}</span><span>{v}</span></div>);
    return (
      <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "8px 12px", margin: "12px 0", fontSize: 13, maxWidth: 520 }}>
        <div style={{ fontWeight: 600, marginBottom: 6 }}>Facture du projet {ch ? `« ${ch.nom} »` : ""} — {fige ? "déductions figées à la facturation" : "aperçu (figé à la facturation)"}</div>
        {l("Total HT des travaux", formatDH(dp.htTravaux))}
        {dp.avance ? l(`− Remboursement de l'avance (${p(dp.avancePct)} %)`, `− ${formatDH(dp.avance)}`) : null}
        {dp.retenue ? l(`− Retenue de garantie (${p(dp.retenuePct)} %)`, `− ${formatDH(dp.retenue)}`) : null}
        {dp.prorataAvantTVA && dp.prorata ? l(`− Compte prorata (${p(dp.prorataPct)} %)`, `− ${formatDH(dp.prorata)}`) : null}
        {l("Total HT net", formatDH(dp.htNet), true)}
        {l("TVA", formatDH(dp.tva))}
        {l("Total TTC", formatDH(dp.ttc), true)}
        {!dp.prorataAvantTVA && dp.prorata ? l(`− Compte prorata (${p(dp.prorataPct)} % du HT net)`, `− ${formatDH(dp.prorata)}`) : null}
        {l("Net à payer", formatDH(dp.net), true)}
        {!fige && ch && (
          <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Solde de l'avance du projet : {formatDH(arrondiH(avanceProjetHT(ch) - avanceRembourseeHT(ch)))} HT</div>
        )}
        {modifiable && avanceProjetHT(ch) > 0 && (
          <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 12, marginTop: 6, cursor: "pointer" }}>
            <input type="checkbox" checked={!!c.solderAvance} onChange={(e) => basculer(e.target.checked)} /> Dernière facture du projet : déduire tout le solde de l'avance
          </label>
        )}
      </div>
    );
  }
  function renderMargeDossier(c) {
    const r = margeDossier(c, {});
    if (!r) return null;
    const ouvert = margeOuverte === c.id;
    const ligne = (lib, a, b, info) => (
      <tr><td style={{ padding: "3px 8px" }}>{lib}{info ? <div style={{ fontSize: 10, color: TAUPE }}>{info}</div> : null}</td><td style={{ padding: "3px 8px", textAlign: "right" }}>{formatDH(a + 0)}</td><td style={{ padding: "3px 8px", textAlign: "right" }}>{formatDH((b === undefined ? a : b) + 0)}</td></tr>
    );
    const coul = (x) => (x >= 0 ? VERT_OK : ROUILLE);
    return (
      <div style={{ border: `1px solid ${OCRE}`, borderRadius: 8, padding: "8px 12px", margin: "12px 0" }}>
        <div onClick={() => setMargeOuverte(ouvert ? "" : c.id)} style={{ display: "flex", gap: 14, flexWrap: "wrap", alignItems: "baseline", cursor: "pointer", fontSize: 13 }}>
          <b>{ouvert ? "▾" : "▸"} Marge (Gérant)</b>
          <span>CA HT {formatDH(r.ca)}{r.acompteAvantErpHT ? <span style={{ color: TAUPE }}> (dont acompte facturé avant l'ERP {formatDH(r.acompteAvantErpHT)})</span> : null}{r.avoirsHT ? <span style={{ color: TAUPE }}> (facturé {formatDH(r.caFacture)} − avoirs {formatDH(r.avoirsHT)})</span> : null}</span>
          <span style={{ color: coul(r.margeA), fontWeight: 700 }}>A (mois réel) : {formatDH(r.margeA)} · {r.pctA.toFixed(1).replace(".", ",")} %</span>
          <span style={{ color: coul(r.margeB), fontWeight: 700 }}>B (moy. 12 mois) : {formatDH(r.margeB)} · {r.pctB.toFixed(1).replace(".", ",")} %</span>
          {!!r.alertes.length && <span style={{ color: OCRE, fontSize: 12 }}>provisoire</span>}
        </div>
        {ouvert && (
          <div style={{ marginTop: 8 }}>
            <table style={{ borderCollapse: "collapse", fontSize: 12, width: "100%", maxWidth: 640 }}>
              <thead><tr><th style={{ textAlign: "left", fontSize: 10, color: TAUPE, padding: "3px 8px" }}>Poste</th><th style={{ textAlign: "right", fontSize: 10, color: TAUPE, padding: "3px 8px" }}>A — {libPeriode(r.ym)}</th><th style={{ textAlign: "right", fontSize: 10, color: TAUPE, padding: "3px 8px" }}>B — moyenne 12 mois</th></tr></thead>
              <tbody>
                {ligne("CA HT", r.ca)}
                {ligne("Matière (coût de revient des lots)", -r.matiere)}
                {ligne("Consommables (PL et pose)", -r.conso)}
                {r.incidentsCout ? ligne("Incidents de production (tranches refaites)", -r.incidentsCout, undefined, incidentsDuDossier(c).map((i) => `${i.numero} — ${i.motif}`).join(" · ")) : null}
                {ligne("Atelier (main-d'œuvre + consommables lents)", -r.atelierA, -r.atelierB, `${r.m2.toFixed(2).replace(".", ",")} m² × ${fmtMAD(r.taux.atelierA)} / ${fmtMAD(r.taux.atelierB)} DH/m²`)}
                {r.prorata ? ligne("Compte prorata", -r.prorata, undefined, `${String(r.prorataPct).replace(".", ",")} % du HT des travaux (projet immobilier)`) : null}
                {r.qteListello ? ligne("Listellos", -r.listelloA, -r.listelloB, `${String(r.qteListello).replace(".", ",")} tranche(s) façonnée(s) × ${fmtMAD(r.taux.listelloA)} / ${fmtMAD(r.taux.listelloB)} DH`) : null}
                {(r.poseA || r.poseB) ? ligne("Pose", -r.poseA, -r.poseB, `${r.m2.toFixed(2).replace(".", ",")} m² × ${Math.max(1, nbPoseursDossier(c))} poseur(s)`) : null}
                {ligne("Transport", -r.transport.total, undefined, r.transport.estime ? `estimation${r.transport.zone ? ` (zone ${r.transport.zone})` : ""}` : `${r.transport.nb} déplacement(s) saisi(s)`)}
                {ligne("Commissions (estimées)", -r.commission.total, undefined, r.commission.detail.join(" · "))}
                <tr style={{ borderTop: `2px solid ${ENCRE}` }}><td style={{ padding: "4px 8px", fontWeight: 700 }}>Marge</td><td style={{ padding: "4px 8px", textAlign: "right", fontWeight: 700, color: coul(r.margeA) }}>{formatDH(r.margeA)}</td><td style={{ padding: "4px 8px", textAlign: "right", fontWeight: 700, color: coul(r.margeB) }}>{formatDH(r.margeB)}</td></tr>
              </tbody>
            </table>
            {!!r.alertes.length && <div style={{ fontSize: 11, color: OCRE, marginTop: 6 }}>Provisoire : {[...new Set(r.alertes)].join(" · ")}</div>}
            <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Coûts directs seulement (frais généraux exclus). A : taux atelier / pose du mois réel ; B : moyenne des 12 mois précédents. Commissions : seuil Com1 supposé atteint.</div>
          </div>
        )}
      </div>
    );
  }
  // ---------- registre des déplacements (UI) ----------
  function nouveauDeplacement(dossierId) {
    const zones = transportCouts().zones || [];
    const vl = vehiculesFlotte().find((v) => v.actif !== false && v.type === "livraison");
    return { id: null, date: todayISO(), dateFin: todayISO(), statut: "en cours", type: "Livraison", zoneId: (zones[0] || {}).id || "", vehicules: [vl ? { vehiculeId: vl.id } : { type: "livraison", nb: 1 }], dossiers: dossierId ? [dossierId] : [], participants: [], depenses: [], note: "" };
  }
  // ---------- ERP step 15 (al, Nils 08/10) : fiches de déplacement complètes ----------
  function statutDepl(d) {
    return (d && d.statut) || "validée"; // fiche sans statut = d'avant le 08/10, considérée validée
  }
  function joursDeplacement(d) {
    const n = nbJoursPeriode(d.date, d.dateFin || d.date);
    return Array.from({ length: n }, (_, i) => decalerJours(d.date, i));
  }
  function opsDepl(d, role) {
    return d && d.id ? (operations || []).filter((o) => o.deplacementId === d.id && (!role || o.deplRole === role)) : [];
  }
  function avanceDepl(d) {
    return opsDepl(d, "avance")[0] || null;
  }
  function reglementDepl(d) {
    return opsDepl(d, "retour")[0] || opsDepl(d, "complement")[0] || (d && d.avanceSoldeeSansMouvement ? { montant: 0, date: d.avanceSoldeeLe } : null);
  }
  function totalFraisDepl(d) {
    return d ? depensesDepl(d).reduce((n, x) => n + nombreOuZero(x.montant), 0) : 0;
  }
  function peutCaisseAvance() {
    const c = compteDe(CAISSE_AVANCE_DEPL);
    return estGerant || !!(c && (c.responsables || []).includes(user.id));
  }
  // Jours ouvrés du déplacement à porter au pointage (journée normale) pour une personne.
  function joursPointageDepl(d, st) {
    const out = [];
    joursDeplacement(d).forEach((date) => {
      const ym = date.slice(0, 7);
      const rec = recPointage(ym);
      if ((st.dateEmbauche && date < st.dateEmbauche) || (st.dateSortie && date > st.dateSortie)) return;
      const sp = speciauxDuMois(ym, rec)[date];
      if (sp || congeSpecialDu(st, date, typesCongesSpeciaux())) return;
      const js = new Date(`${date}T12:00:00Z`).getUTCDay();
      const due = duesDuJour(regimePointage(st, rec), date, js);
      if (!(due.dues > 0)) return;
      out.push({ date, ym, cle: date.slice(8, 10), heures: due.dues });
    });
    return out;
  }
  function conflitsPointageDepl(d) {
    const out = [];
    (d.participants || []).filter((x) => x.staffId).forEach((x) => {
      const st = (staff || []).find((y) => y.id === x.staffId);
      if (!st) return;
      joursPointageDepl(d, st).forEach((j) => {
        const rec = recPointage(j.ym);
        const c = rec && rec.lignes && rec.lignes[st.id] && (rec.lignes[st.id].jours || {})[j.cle];
        if (c && c.code && c.deplacementId !== d.id) out.push({ nom: st.nom, date: j.date, lib: (CODES_POINTAGE.find((x) => x.code === codeNorm(c.code)) || {}).label || c.code });
      });
    });
    return out;
  }
  // Porte les jours de déplacement au pointage (présent, heures normales, marqués « D ») et retire ceux de l'ancienne version.
  // Une case déjà saisie à la main n'est jamais modifiée ; un mois validé ou une partie transmise n'est pas touché.
  async function syncPointageDeplacement(avant, apres) {
    const bloques = [];
    const retirer = {}, ajouter = {};
    const touche = (m, ym, sid, cle, v) => { ((m[ym] = m[ym] || {})[sid] = m[ym][sid] || {})[cle] = v; };
    if (avant && avant.id) {
      (pointage || []).forEach((rec) => Object.entries(rec.lignes || {}).forEach(([sid, l]) => Object.entries(l.jours || {}).forEach(([cle, c]) => { if (c && c.deplacementId === avant.id) touche(retirer, rec.mois, sid, cle, true); })));
    }
    if (apres) {
      (apres.participants || []).filter((x) => x.staffId).forEach((x) => {
        const st = (staff || []).find((y) => y.id === x.staffId);
        if (!st) return;
        joursPointageDepl(apres, st).forEach((j) => touche(ajouter, j.ym, st.id, j.cle, j.heures));
      });
    }
    const mois = [...new Set([...Object.keys(retirer), ...Object.keys(ajouter)])];
    let liste = [...(pointage || [])];
    let change = false;
    mois.forEach((ym) => {
      const i = liste.findIndex((x) => x.mois === ym);
      const base = i >= 0 ? liste[i] : { id: ym, mois: ym, statut: "en cours", lignes: {} };
      const lignes = { ...(base.lignes || {}) };
      const sids = [...new Set([...Object.keys(retirer[ym] || {}), ...Object.keys(ajouter[ym] || {})])];
      let modif = false;
      sids.forEach((sid) => {
        const st = (staff || []).find((y) => y.id === sid);
        const fige = base.statut === "validé" || (st && partTransmise(base, partiePointage(st, base)));
        const jours = { ...((lignes[sid] || {}).jours || {}) };
        let m = false;
        Object.keys((retirer[ym] || {})[sid] || {}).forEach((cle) => {
          if ((ajouter[ym] || {})[sid] && ajouter[ym][sid][cle] !== undefined) return; // toujours couvert
          if (fige) { bloques.push(st ? st.nom : sid); return; }
          delete jours[cle]; m = true;
        });
        Object.entries((ajouter[ym] || {})[sid] || {}).forEach(([cle, h]) => {
          const c = jours[cle];
          if (c && c.deplacementId === (apres && apres.id)) return;
          // Saisi à la main — sauf un « déplacement sans fiche » (D*), que la fiche remplace (Nils 01/11).
          if (c && !c.deplManuel && (c.code || (c.heures !== "" && c.heures !== undefined && c.heures !== null))) return;
          if (fige) { bloques.push(st ? st.nom : sid); return; }
          jours[cle] = { code: "", demi: false, heures: h, surConges: false, note: `Déplacement ${(zoneDe(apres.zoneId) || {}).nom || ""}`.trim(), deplacementId: apres.id, par: user.nom, le: new Date().toISOString() };
          m = true;
        });
        if (m) { lignes[sid] = { ...(lignes[sid] || {}), jours }; modif = true; }
      });
      if (modif) { const maj = { ...base, lignes }; if (i >= 0) liste[i] = maj; else liste.push(maj); change = true; }
    });
    if (change) await persistPointage(liste);
    return { bloques };
  }
  async function remettreAvanceDepl() {
    const f = deplAvance;
    const d = f && (deplacements || []).find((x) => x.id === f.depId);
    if (!d || !peutCaisseAvance()) return;
    if (avanceDepl(d)) { setNotice("Une avance a déjà été remise sur ce déplacement."); return; }
    const montant = nombreOuZero(f.montant);
    if (!(montant > 0)) { setNotice("Indique le montant de l'avance."); return; }
    if (!f.beneficiaireId || !(d.participants || []).some((x) => x.staffId === f.beneficiaireId)) { setNotice("Choisis le poseur qui reçoit l'avance (parmi les personnes du déplacement)."); return; }
    if (!f.date) { setNotice("Indique la date de remise."); return; }
    if (moisVerrouille(CAISSE_AVANCE_DEPL, f.date)) { setNotice("Ce mois est clôturé dans la caisse usine."); return; }
    const nom = ((staff || []).find((y) => y.id === f.beneficiaireId) || {}).nom || "?";
    const op = { id: uid(), compteId: CAISSE_AVANCE_DEPL, date: f.date, sens: "sortie", montant, type: "normal", poste: "Pose & Production", sousPoste: "Caisse poseurs", designation: `Avance déplacement du ${formatDate(d.date)} — ${(zoneDe(d.zoneId) || {}).nom || ""} — ${nom}`, tiersType: "employe", tiers: nom, mode: "Espèces", piece: "", deplacementId: d.id, deplRole: "avance", par: user.nom, le: new Date().toISOString() };
    await persistOperations([...(operations || []), op]);
    await persistDeplacements((deplacements || []).map((x) => (x.id === d.id ? { ...x, avanceA: f.beneficiaireId } : x)));
    await tracerAcces("avance de déplacement", `${formatDate(d.date)} — ${nom} — ${formatDH(montant)}`);
    setDeplAvance(null);
    setNotice(`Avance de ${formatDH(montant)} remise à ${nom} : sortie enregistrée en caisse usine.`);
  }
  // Au retour : dépenses justifiées saisies sur la fiche ; l'écart avec l'avance est rendu (entrée) ou remboursé (sortie).
  async function solderAvanceDepl(d) {
    const av = avanceDepl(d);
    if (!av || reglementDepl(d) || !peutCaisseAvance()) return;
    const depenses = totalFraisDepl(d);
    if (!(depenses > 0) && !(await demander("Aucune dépense saisie sur la fiche : l'avance sera entièrement rendue. Continuer ?"))) return;
    const ecart = Math.round((nombreOuZero(av.montant) - depenses) * 100) / 100;
    const date = todayISO();
    if (Math.abs(ecart) > 0.004 && moisVerrouille(CAISSE_AVANCE_DEPL, date)) { setNotice("Ce mois est clôturé dans la caisse usine."); return; }
    const nom = av.tiers || "?";
    const msg = ecart > 0 ? `${nom} rend ${formatDH(ecart)} (avance ${formatDH(av.montant)} − dépenses ${formatDH(depenses)}). Enregistrer l'entrée en caisse usine ?` : ecart < 0 ? `On doit ${formatDH(-ecart)} à ${nom} (dépenses ${formatDH(depenses)} − avance ${formatDH(av.montant)}). Enregistrer le remboursement en caisse usine ?` : `Dépenses = avance (${formatDH(depenses)}) : rien à rendre. Solder ?`;
    if (!(await demander(msg))) return;
    const base = { id: uid(), compteId: CAISSE_AVANCE_DEPL, date, type: "normal", tiersType: "employe", tiers: nom, mode: "Espèces", piece: "", deplacementId: d.id, par: user.nom, le: new Date().toISOString() };
    if (ecart > 0) await persistOperations([...(operations || []), { ...base, sens: "entree", montant: ecart, poste: "Opérations exceptionnelles", sousPoste: SOUS_POSTE_RETOUR_AVANCE, designation: `Retour d'avance — déplacement du ${formatDate(d.date)} — ${nom}`, deplRole: "retour" }]);
    else if (ecart < 0) await persistOperations([...(operations || []), { ...base, sens: "sortie", montant: -ecart, poste: "Frais salariaux", sousPoste: "Remboursements de frais", designation: `Complément de frais — déplacement du ${formatDate(d.date)} — ${nom}`, deplRole: "complement" }]);
    else await persistDeplacements((deplacements || []).map((x) => (x.id === d.id ? { ...x, avanceSoldeeSansMouvement: true, avanceSoldeeLe: date } : x)));
    await tracerAcces("avance de déplacement soldée", `${formatDate(d.date)} — ${nom} — avance ${formatDH(av.montant)}, dépenses ${formatDH(depenses)}`);
    setNotice("Avance soldée.");
  }
  async function changerStatutDepl(d, statut) {
    const fiche = (deplacements || []).find((x) => x.id === d.id);
    if (!fiche) return;
    if (statut === "à valider") {
      if (!peut("deplacements.saisir")) return;
      if ((fiche.dateFin || fiche.date) > todayISO()) { setNotice("Le déplacement n'est pas encore terminé (date de retour à venir)."); return; }
      if (avanceDepl(fiche) && !reglementDepl(fiche)) { setNotice("L'avance n'est pas encore soldée (caisse usine)."); return; }
    } else if (!estGerant) return;
    await persistDeplacements((deplacements || []).map((x) => (x.id === d.id ? { ...x, statut, ...(statut === "validée" ? { validePar: user.nom, valideLe: new Date().toISOString() } : {}), ...(statut === "à valider" ? { envoyePar: user.nom, envoyeLe: new Date().toISOString() } : {}) } : x)));
    await tracerAcces(`déplacement ${statut === "validée" ? "validé" : statut === "à valider" ? "envoyé au Gérant" : "rouvert"}`, `${formatDate(fiche.date)} — ${fiche.type} — ${(zoneDe(fiche.zoneId) || {}).nom || ""}`);
    if (deplEdit && deplEdit.id === d.id) setDeplEdit({ ...deplEdit, statut });
  }
  // Zone d'un dossier : zone de transport du dossier, sinon ville du client.
  function zoneDuDossier(c) {
    const cl = clientDe(c.clientId) || {};
    return zoneDe(c.zoneTransport) || (transportCouts().zones || []).find((x) => normLib(x.nom) === normLib(cl.ville)) || null;
  }
  function horsCasablanca(c) {
    const z = zoneDuDossier(c);
    if (z) return !normLib(z.nom).includes("casablanca");
    const v = normLib((clientDe(c.clientId) || {}).ville || "");
    return !!v && !v.includes("casablanca");
  }
  async function enregistrerDeplacement() {
    const d = deplEdit;
    if (!d) return;
    if (!d.date || !d.zoneId) { setNotice("Indique la date de départ et la zone."); return; }
    if (d.dateFin && d.dateFin < d.date) { setNotice("La date de retour est avant la date de départ."); return; }
    if (nbJoursPeriode(d.date, d.dateFin) > 31) { setNotice("Un déplacement de plus de 31 jours : vérifie les dates."); return; }
    if (statutDepl(d) === "validée" && !estGerant) { setNotice("Fiche validée par le Gérant : demande-lui de la rouvrir pour la modifier."); return; }
    if (!(d.vehicules || []).length) { setNotice("Ajoute au moins un véhicule."); return; }
    if ((d.vehicules || []).some((v) => !v.vehiculeId && !v.type)) { setNotice("Choisis chaque véhicule."); return; }
    if (new Set((d.vehicules || []).filter((v) => v.vehiculeId).map((v) => v.vehiculeId)).size !== (d.vehicules || []).filter((v) => v.vehiculeId).length) { setNotice("Un même véhicule apparaît deux fois."); return; }
    if (d.type !== "Autre" && !(d.dossiers || []).length) { setNotice("Indique le ou les dossiers servis."); return; }
    const parts = (d.participants || []).filter((x) => x.staffId);
    const nomDe = (id) => ((staff || []).find((y) => y.id === id) || {}).nom || "?";
    const vus = new Set();
    for (const x of parts) {
      if (vus.has(x.staffId)) { setNotice(`${nomDe(x.staffId)} apparaît deux fois sur ce déplacement.`); return; }
      vus.add(x.staffId);
      if (!x.sansPrime && !(joursPrime(x) > 0)) { setNotice(`${nomDe(x.staffId)} : indique le nombre de jours de déplacement (0,5 au minimum), ou coche « sans prime ».`); return; }
      // Une seule prime par personne et par jour.
      const mesJours = new Set(joursCouvertsPrime(d, x));
      for (const autre of (deplacements || []).filter((y) => y.id !== d.id)) {
        const px = (autre.participants || []).find((y) => y.staffId === x.staffId);
        if (!px) continue;
        const commun = joursCouvertsPrime(autre, px).find((j) => mesJours.has(j));
        if (commun) { setNotice(`${nomDe(x.staffId)} a déjà une prime de déplacement le ${formatDate(commun)} (déplacement du ${formatDate(autre.date)}). Une seule prime par personne et par jour : coche « sans prime » ou corrige le nombre de jours.`); return; }
      }
    }
    // Mois déjà indemnisé : seul Nils peut encore modifier.
    const avantDep = d.id ? (deplacements || []).find((x) => x.id === d.id) : null;
    const moisTouches = [...new Set([d.date, avantDep && avantDep.date].filter(Boolean).map((x) => String(x).slice(0, 7)))];
    const moisPaye = moisTouches.find((ym) => versementsPrimesDepl(ym).length);
    if (moisPaye && !estGerant) { setNotice(`Les primes de déplacement de ${libPeriode(moisPaye)} ont déjà été versées : demande au Gérant pour modifier.`); return; }
    if (moisPaye && estGerant && !(await demander(`Les primes de ${libPeriode(moisPaye)} ont déjà été versées. Un changement créera un écart avec le versement : continuer ?`))) return;
    const maintenant = new Date().toISOString();
    const depensesOk = depensesDepl(d).filter((x) => nombreOuZero(x.montant) > 0 || String(x.libelle || "").trim()).map((x) => ({ id: x.id && !String(x.id).startsWith("old-") ? x.id : uid(), type: x.type || "Autre", libelle: String(x.libelle || "").trim(), montant: x.montant }));
    const fiche = { ...d, depenses: depensesOk, frais: undefined, vehicules: (d.vehicules || []).map((v) => (v.vehiculeId && String(v.km ?? "").trim() !== "" ? { ...v, km: nombreOuZero(v.km) } : v)), id: d.id || uid(), dateFin: d.dateFin && d.dateFin >= d.date ? d.dateFin : d.date, statut: d.statut || (d.id ? "validée" : "en cours"), participants: parts.map((x) => ({ staffId: x.staffId, jours: x.sansPrime ? 0 : joursPrime(x), sansPrime: !!x.sansPrime, ...(x.joursAuto === false ? { joursAuto: false } : {}) })), ...(d.id ? { modifiePar: user.nom, modifieLe: maintenant } : { par: user.nom, le: maintenant }) };
    // Conflits avec le pointage (congé, absence, maladie… sur un jour de déplacement) : confirmation.
    const conflits = conflitsPointageDepl(fiche);
    if (conflits.length && !(await demander(`Pointage déjà saisi sur des jours de déplacement :\n${conflits.slice(0, 8).map((c) => `• ${c.nom} : ${c.lib} le ${formatDate(c.date)}`).join("\n")}${conflits.length > 8 ? `\n… et ${conflits.length - 8} autre(s)` : ""}\n\nCes jours ne seront pas changés au pointage. Enregistrer quand même ?`))) return;
    await persistDeplacements(d.id ? (deplacements || []).map((x) => (x.id === d.id ? fiche : x)) : [...(deplacements || []), fiche]);
    const sync = await syncPointageDeplacement(avantDep, fiche);
    if (sync.bloques.length) setNotice(`Pointage non mis à jour pour ${[...new Set(sync.bloques)].join(", ")} (mois transmis ou validé) : à corriger à la main si besoin.`);
    await tracerAcces(d.id ? "déplacement modifié" : "déplacement saisi", `${formatDate(fiche.date)} — ${fiche.type} — ${(zoneDe(fiche.zoneId) || {}).nom || ""} — ${(fiche.dossiers || []).map((id) => (dossierParId(id) || {}).numero || "?").join(", ")}`);
    setDeplEdit(null);
  }
  async function supprimerDeplacement(d) {
    const paye = versementsPrimesDepl(String(d.date).slice(0, 7)).length > 0;
    if (paye && !estGerant) { setNotice("Les primes de ce mois ont déjà été versées : demande au Gérant pour supprimer."); return; }
    if (!(await demander(paye ? "Les primes de ce mois ont déjà été versées : la suppression créera un écart. Supprimer ce déplacement ?" : "Supprimer ce déplacement ?"))) return;
    if (avanceDepl(d) && !estGerant) { setNotice("Une avance a été remise sur ce déplacement : seul le Gérant peut le supprimer."); return; }
    await persistDeplacements((deplacements || []).filter((x) => x.id !== d.id));
    await syncPointageDeplacement(d, null);
    await tracerAcces("déplacement supprimé", `${formatDate(d.date)} — ${d.type}`);
    setDeplEdit(null);
  }
  // ---------- ERP step 15 (Nils 08/10) : tranches en exposition ----------
  // Nils 10/10 (c) : client de l'exposition (nom + adresse) pour la demande d'avoir — repris du dossier, modifiable.
  function clientExpo(e) {
    const c = dossierParId(e.dossierId);
    const cl = c ? clientDe(c.clientId) || {} : {};
    const d = c ? devisDuDossier(c) || {} : {};
    return {
      nom: e.clientNom !== undefined && e.clientNom !== "" ? e.clientNom : cl.nom || "",
      adresse: e.clientAdresse !== undefined && e.clientAdresse !== "" ? e.clientAdresse : [d.adresseLivraison || cl.adresse || "", cl.ville || ""].filter(Boolean).join(", "),
    };
  }
  function imprimerDemandeAvoirExpo(ids) {
    const liste = (expositions || []).filter((e) => ids.includes(e.id)).sort((a, b) => (a.date < b.date ? -1 : 1));
    if (!liste.length) { setNotice("Coche les lignes à mettre dans la demande d'avoir."); return; }
    const fours = [...new Set(liste.map((e) => e.fournisseur))];
    if (fours.length > 1) { setNotice(`Une demande d'avoir par fournisseur : tu as coché ${fours.join(", ")}. Filtre sur un fournisseur.`); return; }
    const esc = escapeHtml;
    let totalDev = 0, devise = "";
    const lignesHtml = liste.map((e) => {
      const c = dossierParId(e.dossierId);
      const ci = clientExpo(e);
      const av = avoirAttenduExpo(e);
      if (av.devise && av.devise !== "mixte") { devise = devise || av.devise; totalDev += av.dev || 0; }
      const tr = (e.lignes || []).filter((l) => l.articleId).map((l) => { const a = (articles || []).find((x) => x.id === l.articleId) || {}; return `${String(l.qte).replace(".", ",")} × ${esc(a.designation || a.nom || "")}${a.codeFournisseur ? ` (${esc(a.codeFournisseur)})` : ""}`; }).join("<br>");
      return `<tr><td>${esc(formatDate(e.date))}</td><td>${esc(c ? c.numeroFacture || c.numeroBL || c.numero : "")}${c && c.reference ? `<br><span class="g">${esc(c.reference)}</span>` : ""}</td><td><b>${esc(ci.nom)}</b><br>${esc(ci.adresse)}</td><td>${tr}</td><td class="n">${av.dev > 0 && av.devise && av.devise !== "mixte" ? `${av.dev.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${esc(av.devise)}` : "—"}</td></tr>`;
    }).join("");
    const html = `<!DOCTYPE html><html lang="fr"><head><meta charset="UTF-8" /><title>Demande d'avoir exposition</title>
<link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600&family=DM+Sans:wght@400;500;600&display=swap" rel="stylesheet">
<style>* { box-sizing: border-box; } @page { size: A4 portrait; margin: 1.4cm; }
body { font-family: "DM Sans", Arial, sans-serif; color: #281E1E; font-size: 11px; margin: 0; }
h1 { font-family: "Cormorant Garamond", serif; font-size: 24px; margin: 0 0 4px; } .g { color: #8C8282; }
table { width: 100%; border-collapse: collapse; margin-top: 14px; } th { text-align: left; font-size: 9px; color: #8C8282; text-transform: uppercase; letter-spacing: .4px; border-bottom: 1px solid #281E1E; padding: 6px; }
td { border-bottom: 1px solid #CFC5BF; padding: 6px; vertical-align: top; } td.n, th.n { text-align: right; white-space: nowrap; }
.tot td { border: none; font-weight: 600; } .bloc { border: 1px solid #8C8282; border-radius: 8px; padding: 8px 10px; margin-top: 16px; }</style></head><body>
<h1>Demande d'avoir — tranches en exposition</h1>
<div class="g">Stone Concept · ${esc(formatDate(todayISO()))}</div>
<div class="bloc"><b>Fournisseur :</b> ${esc(fours[0])}<br>Nous vous remercions de bien vouloir établir un avoir pour les tranches ci-dessous, posées en exposition chez nos clients.</div>
<table><tr><th>Date d'exposition</th><th>Commande</th><th>Client exposant</th><th>Tranches</th><th class="n">Montant attendu</th></tr>${lignesHtml}
${totalDev > 0 ? `<tr class="tot"><td colspan="4" style="text-align:right">Total</td><td class="n">${totalDev.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${esc(devise)}</td></tr>` : ""}</table>
<div class="bloc">Photos de l'exposition : jointes à l'envoi.</div>
</body></html>`;
    telechargerDocument(html, nomFichierDocument("Demande-avoir-exposition", fours[0], todayISO()), "demande d'avoir exposition");
  }
  function nouvelleExpo() {
    return { id: "", date: todayISO(), dossierId: "", fournisseur: "", lignes: [{ articleId: "", qte: 1 }], statutAvoir: "a_demander", dateDemande: "", dateRecu: "", montantRecu: "", note: "" };
  }
  function tranchesExpoDispo(fournisseur) {
    return (articles || []).filter((a) => a.categorie === "Tranche" && (!fournisseur || normLib(a.fournisseur || "") === normLib(fournisseur))).sort((a, b) => String(a.designation || "").localeCompare(String(b.designation || ""), "fr"));
  }
  // Avoir attendu = prix d'achat fournisseur de la tranche (coût standard, part achat seule — hors emballage,
  // logistique et frais d'import) × quantité. Montant en MAD, et en devise du profil d'import.
  function avoirAttenduExpo(e) {
    let mad = 0, dev = 0, devise = "", manquants = 0;
    (e.lignes || []).filter((l) => l.articleId).forEach((l) => {
      const a = (articles || []).find((x) => x.id === l.articleId);
      const det = coutStandardDetail(a, null);
      const q = nombreOuZero(l.qte);
      if (!det || !(det.achat > 0)) { manquants++; return; }
      mad += det.achat * q;
      dev += nombreOuZero(det.achatDevise) * q;
      const dv = (det.profil && det.profil.devise) || "MAD";
      devise = devise && devise !== dv ? "mixte" : dv;
    });
    return { mad, dev, devise, manquants };
  }
  function libStatutAvoirExpo(e) {
    if (e.statutAvoir === "recu") return `Reçu${e.dateRecu ? ` le ${formatDate(e.dateRecu)}` : ""}`;
    if (e.statutAvoir === "demande") return `Demandé${e.dateDemande ? ` le ${formatDate(e.dateDemande)}` : ""}`;
    return "À demander";
  }
  async function enregistrerExpo() {
    const e = expoEdit;
    if (!e) return;
    if (!e.date) { setNotice("Indique la date de pose en exposition."); return; }
    if (!e.dossierId) { setNotice("Choisis la commande liée."); return; }
    if (!e.fournisseur) { setNotice("Choisis le fournisseur."); return; }
    const lignes = (e.lignes || []).filter((l) => l.articleId);
    if (!lignes.length) { setNotice("Ajoute au moins une tranche."); return; }
    if (lignes.some((l) => !(nombreOuZero(l.qte) > 0))) { setNotice("Chaque tranche doit avoir une quantité supérieure à 0."); return; }
    if (e.statutAvoir === "demande" && !e.dateDemande) { setNotice("Indique la date de la demande d'avoir."); return; }
    if (e.statutAvoir === "recu" && (!e.dateRecu || String(e.montantRecu ?? "").trim() === "")) { setNotice("Indique la date et le montant de l'avoir reçu."); return; }
    const c = dossierParId(e.dossierId);
    const maintenant = new Date().toISOString();
    const fiche = { ...e, id: e.id || uid(), clientId: (c && c.clientId) || e.clientId || "", lignes: lignes.map((l) => ({ articleId: l.articleId, qte: nombreOuZero(l.qte) })), ...(e.id ? { modifiePar: user.nom, modifieLe: maintenant } : { par: user.nom, le: maintenant }) };
    await persistExpositions(e.id ? (expositions || []).map((x) => (x.id === e.id ? fiche : x)) : [...(expositions || []), fiche]);
    await tracerAcces(e.id ? "exposition modifiée" : "exposition saisie", `${formatDate(fiche.date)} — ${c ? c.numero : "?"} — ${fiche.fournisseur} — ${libStatutAvoirExpo(fiche)}`);
    setExpoEdit(null);
  }
  async function supprimerExpo(e) {
    if (!(await demander("Supprimer cette ligne du registre des expositions ?"))) return;
    await persistExpositions((expositions || []).filter((x) => x.id !== e.id));
    setExpoSel((expoSel || []).filter((id) => id !== e.id));
    await tracerAcces("exposition supprimée", `${formatDate(e.date)} — ${e.fournisseur}`);
    setExpoEdit(null);
  }
  async function marquerExposDemandees() {
    const ids = (expoSel || []).filter((id) => { const e = (expositions || []).find((x) => x.id === id); return e && e.statutAvoir === "a_demander"; });
    if (!ids.length) { setNotice("Coche les lignes « À demander » concernées."); return; }
    if (!expoDateDemande) { setNotice("Indique la date de la demande."); return; }
    if (!(await demander(`Marquer ${ids.length} ligne(s) comme « Demandé le ${formatDate(expoDateDemande)} » ?`))) return;
    const maintenant = new Date().toISOString();
    await persistExpositions((expositions || []).map((x) => (ids.includes(x.id) ? { ...x, statutAvoir: "demande", dateDemande: expoDateDemande, modifiePar: user.nom, modifieLe: maintenant } : x)));
    await tracerAcces("avoirs exposition demandés", `${ids.length} ligne(s) — ${formatDate(expoDateDemande)}`);
    setExpoSel([]);
  }
  // ---------- ERP step 15 (ak, Nils 08/10) : véhicules et machines lourdes ----------
  const peutGererVehicules = peut("vehicules.gerer");
  function vehiculesFlotte() {
    return (flotte && flotte.vehicules) || [];
  }
  function vehiculeParId(id) {
    return vehiculesFlotte().find((v) => v.id === id) || null;
  }
  function estConducteur(v, userId) {
    return !!v && (v.conducteurs || []).includes(userId);
  }
  function peutReleverVehicule(v) {
    return !!v && (peutGererVehicules || estConducteur(v, user.id));
  }
  function mesVehicules() {
    return vehiculesFlotte().filter((v) => v.actif !== false && peutReleverVehicule(v));
  }
  async function majFlotte(patch) {
    return await persistFlotte({ ...(flotteRef.current || flotte), ...patch });
  }
  function relevesVehicule(vid) {
    return ((flotte && flotte.releves) || []).filter((r) => r.vehiculeId === vid);
  }
  function ticketsVehicule(vid) {
    return ((flotte && flotte.tickets) || []).filter((t) => t.vehiculeId === vid);
  }
  // Points kilométriques connus (relevés du vendredi + km des tickets), triés par date.
  function pointsKm(vid, saufReleveId) {
    return [
      ...relevesVehicule(vid).filter((r) => r.id !== saufReleveId).map((r) => ({ date: r.date, km: nombreOuZero(r.km), src: "relevé" })),
      ...ticketsVehicule(vid).filter((t) => !saufReleveId || t.releveId !== saufReleveId).map((t) => ({ date: t.date, km: nombreOuZero(t.km), src: "ticket" })),
    ].filter((x) => x.km > 0).sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : a.km - b.km));
  }
  function kmAu(vid, dateISO, saufReleveId) {
    const pts = pointsKm(vid, saufReleveId).filter((x) => x.date <= dateISO);
    return pts.length ? pts.reduce((m, x) => (x.km > m.km ? x : m), pts[0]) : null;
  }
  function kmApres(vid, dateISO, saufReleveId) {
    const pts = pointsKm(vid, saufReleveId).filter((x) => x.date > dateISO);
    return pts.length ? pts.reduce((m, x) => (x.km < m.km ? x : m), pts[0]) : null;
  }
  // Carte qui a payé un ticket : celle du véhicule, celle d'un autre véhicule, ou aucune (hors carte).
  function cartePayeur(t) {
    if (!t || t.carte === "hors") return null;
    return !t.carte || t.carte === "propre" ? t.vehiculeId : t.carte;
  }
  // Consommation sur une période : km parcourus (relevés + tickets), litres et DH des tickets du véhicule.
  function consoPeriode(vid, deb, fin) {
    const avant = kmAu(vid, decalerJours(deb, -1));
    const dans = pointsKm(vid).filter((x) => x.date >= deb && x.date <= fin);
    const kmFin = dans.length ? Math.max(...dans.map((x) => x.km)) : null;
    const kmDeb = avant ? avant.km : dans.length ? Math.min(...dans.map((x) => x.km)) : null;
    const km = kmFin !== null && kmDeb !== null ? Math.max(0, kmFin - kmDeb) : 0;
    const tk = ticketsVehicule(vid).filter((t) => t.date >= deb && t.date <= fin);
    const pp = pleinAPlein(ticketsVehicule(vid), deb, fin);
    const dh = tk.reduce((n, t) => n + nombreOuZero(t.montant), 0);
    const dhSociete = tk.filter((t) => t.carte !== "hors").reduce((n, t) => n + nombreOuZero(t.montant), 0);
    return { km, litres: pp.litres, dh, dhSociete, nbTickets: tk.length, l100: pp.l100, dh100: pp.dh100 };
  }
  // Consommation « plein à plein » : litres des pleins de la période ÷ km entre le plein précédent et le dernier
  // plein de la période. Sans plein précédent, le premier plein de la période sert de point de départ (ses litres
  // ont été consommés avant) et n'est pas compté.
  function pleinAPlein(tickets, deb, fin) {
    const tri = (tickets || []).filter((t) => nombreOuZero(t.km) > 0).slice().sort((a, b) => nombreOuZero(a.km) - nombreOuZero(b.km) || (a.date < b.date ? -1 : 1));
    const dans = tri.filter((t) => t.date >= deb && t.date <= fin);
    if (!dans.length) return { litres: 0, km: 0, l100: null, dh100: null };
    const avant = tri.filter((t) => t.date < deb);
    const prev = avant.length ? avant[avant.length - 1] : null;
    const compte = prev ? dans : dans.slice(1);
    const depart = prev ? nombreOuZero(prev.km) : nombreOuZero(dans[0].km);
    const km = Math.max(0, nombreOuZero(dans[dans.length - 1].km) - depart);
    const litres = compte.reduce((n, t) => n + nombreOuZero(t.litres), 0);
    const dhc = compte.reduce((n, t) => n + nombreOuZero(t.montant), 0);
    return { litres, km, l100: km > 0 && litres > 0 ? (litres / km) * 100 : null, dh100: km > 0 && dhc > 0 ? (dhc / km) * 100 : null };
  }
  function consoMoisVeh(vid, ym) {
    const [d, f] = bornesPeriode(ym);
    return consoPeriode(vid, d, f);
  }
  function conso3MoisVeh(vid, ym) {
    return consoPeriode(vid, bornesPeriode(moisDecale(ym, -2))[0], bornesPeriode(ym)[1]);
  }
  function consoMoyenne12Veh(vid, ym) {
    return consoPeriode(vid, bornesPeriode(moisDecale(ym, -12))[0], bornesPeriode(moisDecale(ym, -1))[1]);
  }
  // Répartition par véhicule des sorties de trésorerie (carburant, péage, entretien, leasing…).
  function sortiesVehicule(vid, sousPostes, deb, fin) {
    let t = 0;
    (operations || []).filter((o) => o.sens === "sortie" && (!sousPostes || sousPostes.includes(o.sousPoste)) && (!deb || o.date >= deb) && (!fin || o.date <= fin)).forEach((o) => {
      (o.vehicules || []).forEach((x) => { if (x.vehiculeId === vid) t += nombreOuZero(x.montant); });
    });
    return t;
  }
  // Solde théorique de la carte carburant : recharges réparties sur le véhicule − tickets payés avec sa carte.
  function soldeCarteVeh(vid) {
    const recharges = sortiesVehicule(vid, ["Carburant"]);
    const tickets = ((flotte && flotte.tickets) || []).filter((t) => cartePayeur(t) === vid).reduce((n, t) => n + nombreOuZero(t.montant), 0);
    return { recharges, tickets, solde: recharges - tickets };
  }
  // Coûts réels sur 12 mois (pour les forfaits) : carburant des tickets payés par la société, autres postes répartis.
  function coutsVehicule12(vid, dateISO) {
    const fin = dateISO || todayISO();
    const deb = decalerJours(fin, -365);
    const c = consoPeriode(vid, deb, fin);
    const autres = sortiesVehicule(vid, SOUS_POSTES_VEHICULE.filter((x) => x !== "Carburant" && x !== SOUS_POSTE_PEAGE), deb, fin);
    const fiable = c.km >= 1000;
    return { km: c.km, carburant: c.dhSociete, autres, l100: c.l100, carbKm: c.km > 0 ? c.dhSociete / c.km : 0, autresKm: c.km > 0 ? autres / c.km : 0, fiable };
  }
  // ---- Nils 09/10 (g) : coût au km théorique d'un véhicule (méthode Nils, « valeur actuelle ») ----
  // amortissement / km = (valeur actuelle − revente prévue + coûts annuels prévus × années restantes) ÷ km restants ;
  // carburant / km = DH de carburant ÷ km depuis l'entrée du véhicule dans l'ERP. Paramètres datés : un dossier /
  // déplacement garde le coût en vigueur à sa date. Leasing : traites et rachat ne comptent pas.
  function paramsCoutVehicule(veh, dateISO) {
    const vs = [...((veh && veh.coutKm) || [])].filter((x) => x.dateEffet).sort((a, b) => (a.dateEffet < b.dateEffet ? 1 : -1));
    return vs.find((x) => x.dateEffet <= (dateISO || todayISO())) || null;
  }
  function amortKmVehicule(p) {
    if (!p) return null;
    const kmRest = nombreOuZero(p.kmRevente) - nombreOuZero(p.kmActuels);
    if (!(kmRest > 0)) return null;
    const annees = p.dateRevente && p.dateRevente > p.dateEffet ? ecartJours(p.dateEffet, p.dateRevente) / 365.25 : 0;
    const total = nombreOuZero(p.valeurActuelle) - nombreOuZero(p.revente) + nombreOuZero(p.coutsAnnuels) * annees;
    return { parKm: total / kmRest, total, kmRest, annees };
  }
  function carburantKmVehicule(veh) {
    if (!veh) return null;
    const c = consoPeriode(veh.id, veh.creeLe || "2000-01-01", todayISO());
    return c.km >= 300 && c.dhSociete > 0 ? c.dhSociete / c.km : null;
  }
  function coutKmTheorique(veh, dateISO) {
    const a = amortKmVehicule(paramsCoutVehicule(veh, dateISO));
    if (!a) return null;
    let carb = carburantKmVehicule(veh);
    let carbEstime = false;
    if (carb === null) {
      carb = forfaitTransportManuel({ km: 1, peage: 0, peageCamion: 0, peageVoiture: 0 }, veh.type || "rdm").carburant;
      carbEstime = true;
    }
    return { amortKm: a.parKm, carbKm: carb, total: a.parKm + carb, carbEstime };
  }
  // Coût au km d'un véhicule à une date : théorique (paramètres) → réel 12 mois (≥ 1 000 km) → paramètres du type.
  function coutAuKmVehicule(veh, dateISO) {
    const th = veh ? coutKmTheorique(veh, dateISO) : null;
    if (th) return { carb: th.carbKm, autres: th.amortKm, source: "theorique" };
    const c = veh ? coutsVehicule12(veh.id, dateISO) : null;
    if (c && c.fiable) return { carb: c.carbKm, autres: c.autresKm, source: "reel12" };
    const tp = (veh && veh.type) || "livraison";
    const r = coutKmFlotte(tp);
    if (r) return { carb: r.carb, autres: r.autres, source: "flotte" };
    const f = forfaitTransportManuel({ km: 1, peage: 0, peageCamion: 0, peageVoiture: 0 }, tp);
    return { carb: f.carburant, autres: f.usure, source: "type" };
  }
  // Contrôle annuel : dépenses réelles (hors carburant / péage) et km réels depuis la date des paramètres, comparés au prévu.
  function controleCoutVehicule(veh) {
    const p = paramsCoutVehicule(veh, todayISO());
    const a = amortKmVehicule(p);
    if (!p || !a) return null;
    const auj = todayISO();
    const jours = Math.max(1, ecartJours(p.dateEffet, auj));
    const depReelles = sortiesVehicule(veh.id, SOUS_POSTES_VEHICULE.filter((x) => x !== "Carburant" && x !== SOUS_POSTE_PEAGE && x !== "Leasing" && x !== "Leasing commercial"), p.dateEffet, auj);
    const depPrevues = nombreOuZero(p.coutsAnnuels) * jours / 365.25;
    const kmReels = consoPeriode(veh.id, p.dateEffet, auj).km;
    const kmPrevus = a.annees > 0 ? a.kmRest * Math.min(1, jours / 365.25 / a.annees) : null;
    const pct = (r, pr) => (pr > 0 ? ((r - pr) / pr) * 100 : null);
    return { p, jours, depReelles, depPrevues, ecartDepPct: pct(depReelles, depPrevues), kmReels, kmPrevus, ecartKmPct: kmPrevus ? pct(kmReels, kmPrevus) : null };
  }
  // Forfait d'un trajet pour un véhicule réel : coût théorique (paramètres) ou réel au km (12 mois) si assez de km, sinon paramètres du type.
  function forfaitVehicule(zone, veh, dateISO) {
    if (!veh) return forfaitTransport(zone, "livraison");
    {
      const th = coutKmTheorique(veh, dateISO);
      if (th) {
        const km = nombreOuZero(zone.km);
        const carburant = km * th.carbKm, usure = km * th.amortKm, peage = peageZone(zone, veh.type || "rdm");
        return { carburant, usure, peage, fixe: 0, total: carburant + usure + peage, reel: true, theorique: true };
      }
    }
    const c = coutsVehicule12(veh.id, dateISO);
    if (!c.fiable) return { ...forfaitTransport(zone, veh.type || "rdm"), reel: false };
    const km = nombreOuZero(zone.km);
    const carburant = km * c.carbKm, usure = km * c.autresKm, peage = peageZone(zone, veh.type || "rdm");
    return { carburant, usure, peage, fixe: 0, total: carburant + usure + peage, reel: true };
  }
  function releveCouvert(vid, vendredi) {
    const d = decalerJours(vendredi, -1), f = decalerJours(vendredi, 6);
    return relevesVehicule(vid).some((r) => r.date >= d && r.date <= f);
  }
  function nouveauReleve(vid) {
    return { id: "", vehiculeId: vid, date: todayISO(), km: "", tickets: [] };
  }
  async function enregistrerReleve() {
    const r = releveEdit;
    const v = r && vehiculeParId(r.vehiculeId);
    if (!v || !peutReleverVehicule(v)) return;
    if (!r.date) { setNotice("Indique la date du relevé."); return; }
    if (r.date > todayISO()) { setNotice("Le relevé ne peut pas être daté dans le futur."); return; }
    const km = Math.round(nombreOuZero(r.km));
    if (!(km > 0)) { setNotice("Indique le kilométrage du compteur."); return; }
    const prec = kmAu(v.id, r.date, r.id || "__");
    if (prec && km < prec.km) { setNotice(`${km.toLocaleString("fr-FR")} km est inférieur au dernier km connu (${prec.km.toLocaleString("fr-FR")} km, ${prec.src} du ${formatDate(prec.date)}).`); return; }
    const suiv = kmApres(v.id, r.date, r.id || "__");
    if (suiv && km > suiv.km) { setNotice(`${km.toLocaleString("fr-FR")} km est supérieur au km d'un ${suiv.src} plus récent (${suiv.km.toLocaleString("fr-FR")} km le ${formatDate(suiv.date)}).`); return; }
    const tickets = [];
    for (const t of r.tickets || []) {
      const litres = nombreOuZero(t.litres), montant = nombreOuZero(t.montant), tkm = Math.round(nombreOuZero(t.km));
      if (!t.date || !(litres > 0) || !(montant > 0) || !(tkm > 0)) { setNotice("Chaque ticket doit avoir sa date, ses litres, son montant et le km indiqué sur le ticket."); return; }
      if (t.date > r.date) { setNotice(`Un ticket du ${formatDate(t.date)} est postérieur au relevé.`); return; }
      if (tkm > km) { setNotice(`Le ticket du ${formatDate(t.date)} indique ${tkm.toLocaleString("fr-FR")} km, plus que le compteur relevé (${km.toLocaleString("fr-FR")} km).`); return; }
      const pt = kmAu(v.id, t.date, r.id || "__");
      if (pt && tkm < pt.km) { setNotice(`Le ticket du ${formatDate(t.date)} indique ${tkm.toLocaleString("fr-FR")} km, moins que le km déjà connu (${pt.km.toLocaleString("fr-FR")} km le ${formatDate(pt.date)}).`); return; }
      if (t.carte && t.carte !== "propre" && t.carte !== "hors" && !vehiculeParId(t.carte)) { setNotice("Carte d'un véhicule inconnu sur un ticket."); return; }
      tickets.push({ id: t.id || uid(), vehiculeId: v.id, date: t.date, litres, montant, km: tkm, carte: t.carte === v.id ? "propre" : t.carte || "propre" });
    }
    const prix = tickets.filter((t) => t.montant / t.litres < 6 || t.montant / t.litres > 25);
    if (prix.length && !(await demander(`Prix au litre inhabituel sur ${prix.length} ticket(s) (${prix.map((t) => `${(t.montant / t.litres).toFixed(2).replace(".", ",")} DH/L`).join(", ")}). Vérifie litres et montant. Enregistrer quand même ?`))) return;
    if (prec && km - prec.km > 3000 && !(await demander(`${(km - prec.km).toLocaleString("fr-FR")} km depuis le ${formatDate(prec.date)} : c'est beaucoup. Confirmer le kilométrage ?`))) return;
    const f = flotteRef.current || flotte;
    const maintenant = new Date().toISOString();
    const id = r.id || uid();
    const releve = { id, vehiculeId: v.id, date: r.date, km, ...(r.id ? { modifiePar: user.nom, modifieLe: maintenant, par: r.par, parId: r.parId, le: r.le } : { par: user.nom, parId: user.id, le: maintenant }) };
    const tks = tickets.map((t) => ({ ...t, releveId: id, ...(t.par ? {} : { par: user.nom, le: maintenant }) }));
    const next = {
      ...f,
      releves: [...(f.releves || []).filter((x) => x.id !== id), releve],
      tickets: [...(f.tickets || []).filter((x) => x.releveId !== id), ...tks],
    };
    // Alerte consommation (Nils) : mois du relevé au-dessus de la moyenne des 12 mois précédents.
    const ym = r.date.slice(0, 7);
    const cle = `conso|${v.id}|${ym}`;
    await persistFlotte(next);
    const m = consoPeriodeDans(next, v.id, ...bornesPeriode(ym));
    const moy = consoPeriodeDans(next, v.id, bornesPeriode(moisDecale(ym, -12))[0], bornesPeriode(moisDecale(ym, -1))[1]);
    const seuil = nombreOuZero(next.seuilConsoPct) || 20;
    if (m.l100 && moy.l100 && m.km >= 300 && moy.km >= 1000 && m.l100 > moy.l100 * (1 + seuil / 100) && !(next.alertesEnvoyees || {})[cle]) {
      await alerter("Consommation anormale", `${v.nom} : ${m.l100.toFixed(1).replace(".", ",")} L/100 en ${libMois(ym)} pour une moyenne de ${moy.l100.toFixed(1).replace(".", ",")} L/100 sur les 12 mois précédents (+${Math.round((m.l100 / moy.l100 - 1) * 100)} %).`, { kind: "vehicule", id: v.id });
      await persistFlotte({ ...next, alertesEnvoyees: { ...(next.alertesEnvoyees || {}), [cle]: maintenant } });
    }
    await tracerAcces(r.id ? "relevé km modifié" : "relevé km", `${v.nom} — ${formatDate(r.date)} — ${km} km — ${tks.length} ticket(s)`);
    setReleveEdit(null);
  }
  // Consommation sur un état de flotte donné (juste après un enregistrement, avant le rendu).
  function consoPeriodeDans(f, vid, deb, fin) {
    const pp = pleinAPlein((f.tickets || []).filter((t) => t.vehiculeId === vid), deb, fin);
    return { km: pp.km, litres: pp.litres, l100: pp.l100 };
  }
  async function supprimerReleve(r) {
    if (!peutGererVehicules) return;
    if (!(await demander("Supprimer ce relevé et ses tickets ?"))) return;
    const f = flotteRef.current || flotte;
    await persistFlotte({ ...f, releves: (f.releves || []).filter((x) => x.id !== r.id), tickets: (f.tickets || []).filter((x) => x.releveId !== r.id) });
    await tracerAcces("relevé km supprimé", `${(vehiculeParId(r.vehiculeId) || {}).nom || "?"} — ${formatDate(r.date)}`);
  }
  async function enregistrerVehicule() {
    const v = vehEdit;
    if (!v || !peutGererVehicules) return;
    const nom = String(v.nom || "").trim();
    if (!nom) { setNotice("Indique le nom du véhicule."); return; }
    if (vehiculesFlotte().some((x) => x.id !== v.id && normLib(x.nom) === normLib(nom))) { setNotice("Un véhicule porte déjà ce nom."); return; }
    const f = flotteRef.current || flotte;
    const fiche = { ...v, nom, immat: String(v.immat || "").trim().toUpperCase(), id: v.id || uid(), creeLe: v.creeLe || todayISO() };
    delete fiche._nouveau;
    delete fiche._nk;
    await persistFlotte({ ...f, vehicules: v.id && !v._nouveau ? (f.vehicules || []).map((x) => (x.id === v.id ? fiche : x)) : [...(f.vehicules || []), fiche] });
    await tracerAcces(v.id && !v._nouveau ? "véhicule modifié" : "véhicule créé", nom);
    setVehEdit(null);
  }
  // Échéance renouvelée : l'ancienne date passe dans l'historique, la nouvelle (par défaut + 1 an) la remplace.
  function renouvelerEcheance(k) {
    const v = vehEdit;
    const e = (v.echeances || {})[k] || {};
    if (!e.date) return;
    const d = new Date(`${e.date}T12:00:00Z`); d.setUTCFullYear(d.getUTCFullYear() + 1);
    const histo = [...(e.historique || []), { date: e.date, montant: e.montant || "", renouveleLe: todayISO(), par: user.nom }];
    setVehEdit({ ...v, echeances: { ...(v.echeances || {}), [k]: { ...e, date: d.toISOString().slice(0, 10), historique: histo } } });
  }
  function entretienMachinesMois(ym) {
    const [deb, fin] = bornesPeriode(ym);
    return Object.values((flotte && flotte.carnetsMachines) || {}).flat().filter((x) => x.date >= deb && x.date <= fin).reduce((n, x) => n + nombreOuZero(x.cout), 0);
  }
  async function ajouterCarnetMachine(machineId, entree) {
    if (!peutGererVehicules) return false;
    if (!entree.date || !String(entree.description || "").trim()) { setNotice("Indique la date et ce qui a été fait."); return false; }
    const f = flotteRef.current || flotte;
    const liste = ((f.carnetsMachines || {})[machineId] || []);
    const e = { id: uid(), date: entree.date, type: entree.type || "Entretien", description: String(entree.description).trim(), intervenant: String(entree.intervenant || "").trim(), cout: String(entree.cout ?? "").trim() === "" ? "" : nombreOuZero(entree.cout), par: user.nom, le: new Date().toISOString() };
    await persistFlotte({ ...f, carnetsMachines: { ...(f.carnetsMachines || {}), [machineId]: [...liste, e] } });
    await tracerAcces("carnet machine", `${((affectations || []).find((a) => a.id === machineId) || {}).nom || "?"} — ${e.type} — ${formatDate(e.date)}`);
    return true;
  }
  async function supprimerCarnetMachine(machineId, id) {
    if (!peutGererVehicules || !(await demander("Supprimer cette ligne du carnet ?"))) return;
    const f = flotteRef.current || flotte;
    await persistFlotte({ ...f, carnetsMachines: { ...(f.carnetsMachines || {}), [machineId]: ((f.carnetsMachines || {})[machineId] || []).filter((x) => x.id !== id) } });
  }
  // Première ouverture : enregistre la flotte de départ et crée les machines lourdes manquantes.
  const initFlotteRef = useRef(false);
  useEffect(() => {
    if (loading || initFlotteRef.current || !flotte || flotte.init || affectationsBrutes === null) return;
    initFlotteRef.current = true;
    (async () => {
      const existantes = (affectationsBrutes || []).filter((a) => a.type === "machine").map((a) => normLib(a.nom));
      const manquantes = MACHINES_DEPART.filter((n) => !existantes.includes(normLib(n)));
      if (manquantes.length) await persistAffectations([...(affectationsBrutes || []), ...manquantes.map((nom) => ({ id: uid(), nom, type: "machine", base: "transformation", actif: true, creePar: "ERP", creeLe: new Date().toISOString() }))]);
      await persistFlotte({ ...flotte, init: true });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, flotte, affectationsBrutes]);
  // Nils 08/10 : suppression unique des « Débiteuse 1 / 2 » créées par l'ERP (si rien n'y est affecté).
  const purgeDebRef = useRef(false);
  useEffect(() => {
    if (loading || purgeDebRef.current || !flotte || !flotte.init || flotte.purgeDebiteuses || affectationsBrutes === null) return;
    purgeDebRef.current = true;
    (async () => {
      const cibles = (affectationsBrutes || []).filter((a) => a.type === "machine" && a.creePar === "ERP" && ["debiteuse 1", "debiteuse 2"].includes(normLib(a.nom)) && !affectationOccupee(a.id).length && !(((flotte.carnetsMachines || {})[a.id] || []).length));
      if (cibles.length) {
        const ids = new Set(cibles.map((a) => a.id));
        await persistAffectations((affectationsBrutes || []).filter((a) => !ids.has(a.id)));
        const P = planningRef.current || planning;
        if ((P.items || []).some((x) => (x.machines || []).some((m) => ids.has(m.id)))) await persistPlanning({ ...P, items: (P.items || []).map((x) => (x.machines ? { ...x, machines: x.machines.filter((m) => !ids.has(m.id)) } : x)) });
      }
      await persistFlotte({ ...(flotteRef.current || flotte), purgeDebiteuses: new Date().toISOString() });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, flotte, affectationsBrutes]);
  // Relevé du vendredi pas fait le lundi : une alerte à Nils par semaine (tous véhicules regroupés).
  const alerteReleveRef = useRef(false);
  useEffect(() => {
    if (loading || alerteReleveRef.current || !flotte || !flotte.init) return;
    alerteReleveRef.current = true;
    const auj = new Date().toISOString().slice(0, 10);
    let F = vendrediDe(auj);
    if (auj < decalerJours(F, 3)) F = decalerJours(F, -7);
    const manquants = (flotte.vehicules || []).filter((v) => v.actif !== false && (v.creeLe || "") <= F && !releveCouvert(v.id, F) && !(flotte.alertesEnvoyees || {})[`releve|${v.id}|${F}`]);
    if (!manquants.length) return;
    (async () => {
      await alerter("Relevé km non fait", `Relevé km du vendredi ${formatDate(F)} non fait : ${manquants.map((v) => v.nom).join(", ")}.`, { kind: "onglet", id: "flotte" });
      const f = flotteRef.current || flotte;
      await persistFlotte({ ...f, alertesEnvoyees: { ...(f.alertesEnvoyees || {}), ...Object.fromEntries(manquants.map((v) => [`releve|${v.id}|${F}`, new Date().toISOString()])) } });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, flotte]);
  // Nils 09/10 (g) : contrôle annuel du coût théorique (à chaque anniversaire des paramètres) — alerte à Nils si écart > 20 %.
  const alerteCoutVehRef = useRef(false);
  useEffect(() => {
    if (loading || alerteCoutVehRef.current || !flotte || !flotte.init) return;
    alerteCoutVehRef.current = true;
    const auj = todayISO();
    const aEnvoyer = [];
    (flotte.vehicules || []).filter((v) => v.actif !== false).forEach((v) => {
      const ctl = controleCoutVehicule(v);
      if (!ctl || ctl.jours < 365) return;
      const n = Math.floor(ctl.jours / 365.25);
      const cle = `coutKm|${v.id}|${ctl.p.dateEffet}|${n}`;
      if ((flotte.alertesEnvoyees || {})[cle]) return;
      const ecarts = [];
      if (ctl.ecartDepPct !== null && Math.abs(ctl.ecartDepPct) > 20) ecarts.push(`dépenses ${formatDH(ctl.depReelles)} pour ${formatDH(ctl.depPrevues)} prévues`);
      if (ctl.ecartKmPct !== null && Math.abs(ctl.ecartKmPct) > 20) ecarts.push(`${Math.round(ctl.kmReels)} km pour ${Math.round(ctl.kmPrevus)} prévus`);
      aEnvoyer.push({ v, cle, ecarts });
    });
    if (!aEnvoyer.length) return;
    (async () => {
      for (const x of aEnvoyer.filter((y) => y.ecarts.length)) await alerter("Coût au km : écart avec la prévision", `${x.v.nom} : ${x.ecarts.join(" ; ")} — réajuste les paramètres de coût (fiche du véhicule).`, { kind: "onglet", id: "flotte" });
      const f = flotteRef.current || flotte;
      await persistFlotte({ ...f, alertesEnvoyees: { ...(f.alertesEnvoyees || {}), ...Object.fromEntries(aEnvoyer.map((x) => [x.cle, auj])) } });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, flotte]);
  function libCarteTicket(t) {
    if (t.carte === "hors") return "hors carte";
    if (!t.carte || t.carte === "propre") return "sa carte";
    return `carte ${(vehiculeParId(t.carte) || {}).nom || "?"}`;
  }
  function prochaineEcheance(v) {
    const l = TYPES_ECHEANCE_VEHICULE.map(([k, lib]) => ({ k, lib, date: ((v.echeances || {})[k] || {}).date })).filter((x) => x.date).sort((a, b) => (a.date < b.date ? -1 : 1));
    return l[0] || null;
  }
  function fmtL100(x) {
    return x === null || x === undefined ? "—" : `${x.toFixed(1).replace(".", ",")} L`;
  }
  function renderFlotte() {
    const auj = todayISO();
    const ym = auj.slice(0, 7);
    const F = vendrediDe(auj);
    const vs = (peutGererVehicules ? vehiculesFlotte() : mesVehicules()).slice().sort((a, b) => (a.actif === false) - (b.actif === false) || a.nom.localeCompare(b.nom, "fr"));
    const th = { textAlign: "left", fontSize: 10, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.4, padding: "8px 8px", borderBottom: `1px solid ${PIERRE}`, whiteSpace: "nowrap" };
    const td = { fontSize: 13, padding: "8px 8px", borderBottom: `1px solid ${PIERRE}`, verticalAlign: "top" };
    const carte = { background: "#fff", borderRadius: 10, padding: 16, marginBottom: 20 };
    const machines = (affectations || []).filter((a) => a.type === "machine").sort((a, b) => a.nom.localeCompare(b.nom, "fr"));
    const relevesRecents = ((flotte && flotte.releves) || []).filter((r) => vs.some((v) => v.id === r.vehiculeId)).sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : (a.le || "") < (b.le || "") ? 1 : -1)).slice(0, 15);
    if (!flotte) return <div style={{ padding: 24, color: TAUPE }}>Chargement…</div>;
    return (
      <div>
        <div style={carte}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", marginBottom: 10 }}>
            <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 24, fontWeight: 600 }}>Véhicules</div>
            {estGerant && (
              <span style={{ fontSize: 12, color: TAUPE, display: "inline-flex", gap: 6, alignItems: "center" }}>Alerte consommation au-delà de la moyenne de
                <input type="number" min="1" className="sc-input" value={flotte.seuilConsoPct ?? 20} onChange={(e) => setFlotte({ ...flotte, seuilConsoPct: e.target.value })} onBlur={(e) => majFlotte({ seuilConsoPct: nombreOuZero(e.target.value) || 20 })} style={{ ...inputStyle(60), padding: "4px 6px" }} /> %</span>
            )}
            {peutGererVehicules && <button type="button" className="sc-btn" onClick={() => setVehEdit({ id: uid(), _nouveau: true, nom: "", immat: "", type: "rdm", conducteurs: [], gps: false, actif: true, echeances: {}, carnet: [] })} style={{ ...primaryBtnStyle, marginLeft: "auto" }}>+ Nouveau véhicule</button>}
          </div>
          {!vs.length && <div style={{ fontSize: 13, color: TAUPE }}>Aucun véhicule.</div>}
          {!!vs.length && (
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead><tr>{["Véhicule", "Conducteurs", "Dernier km", `Relevé du ${formatDate(F)}`, `L/100 ${libMois(ym)}`, "L/100 sur 3 mois", ...(peutGererVehicules ? ["Solde carte", "Prochaine échéance"] : []), ""].map((h, i) => <th key={i} style={th}>{h}</th>)}</tr></thead>
                <tbody>
                  {vs.map((v) => {
                    const dk = kmAu(v.id, auj);
                    const m = consoMoisVeh(v.id, ym), m3 = conso3MoisVeh(v.id, ym), moy = consoMoyenne12Veh(v.id, ym);
                    const haut = m.l100 && moy.l100 && m.km >= 300 && moy.km >= 1000 && m.l100 > moy.l100 * (1 + (nombreOuZero(flotte.seuilConsoPct) || 20) / 100);
                    const sc = soldeCarteVeh(v.id);
                    const pe = prochaineEcheance(v);
                    const fait = releveCouvert(v.id, F);
                    return (
                      <tr key={v.id} style={{ opacity: v.actif === false ? 0.5 : 1 }}>
                        <td style={td}><b>{v.nom}</b>{v.actif === false && " (inactif)"}<div style={{ fontSize: 11, color: TAUPE }}>{v.immat || "immatriculation ?"} · {v.type === "livraison" ? "livraison" : "léger"}{v.gps ? " · GPS" : ""}</div></td>
                        <td style={td}>{(v.conducteurs || []).map((id) => nomUtilisateur(id) || id).join(", ") || <span style={{ color: TAUPE }}>poseurs (saisie par le Production Manager)</span>}</td>
                        <td style={td}>{dk ? <>{dk.km.toLocaleString("fr-FR")} km<div style={{ fontSize: 11, color: TAUPE }}>{formatDate(dk.date)}</div></> : "—"}</td>
                        <td style={{ ...td, color: (v.creeLe || "") > F ? TAUPE : fait ? VERT_OK : ROUILLE, fontWeight: 600 }}>{(v.creeLe || "") > F ? "—" : fait ? "✓ fait" : "à faire"}</td>
                        <td style={{ ...td, color: haut ? ROUILLE : ENCRE, fontWeight: haut ? 700 : 400 }}>{fmtL100(m.l100)}<div style={{ fontSize: 11, color: TAUPE }}>{m.km ? `${m.km.toLocaleString("fr-FR")} km` : ""}</div></td>
                        <td style={td}>{fmtL100(m3.l100)}{moy.l100 && <div style={{ fontSize: 11, color: TAUPE }}>moy. 12 mois {fmtL100(moy.l100)}</div>}</td>
                        {peutGererVehicules && <td style={{ ...td, color: sc.solde < -0.01 ? ROUILLE : ENCRE }} title={`recharges ${formatDH(sc.recharges)} − tickets ${formatDH(sc.tickets)}`}>{formatDH(sc.solde)}{sc.solde < -0.01 && <div style={{ fontSize: 11 }}>tickets sans recharge</div>}</td>}
                        {peutGererVehicules && <td style={{ ...td, color: pe && pe.date < auj ? ROUILLE : pe && pe.date <= decalerJours(auj, 30) ? OCRE : ENCRE }}>{pe ? <>{pe.lib}<div style={{ fontSize: 11 }}>{formatDate(pe.date)}</div></> : <span style={{ color: TAUPE }}>—</span>}</td>}
                        <td style={{ ...td, whiteSpace: "nowrap", textAlign: "right" }}>
                          {v.actif !== false && <button type="button" className="sc-btn" onClick={() => setReleveEdit(nouveauReleve(v.id))} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 8px" }}>Relevé</button>}
                          {peutGererVehicules && <button type="button" className="sc-btn" onClick={() => setVehEdit(JSON.parse(JSON.stringify(v)))} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 8px" }}>Fiche</button>}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          <div style={{ fontSize: 11, color: TAUPE, marginTop: 8, lineHeight: 1.5 }}>Chaque vendredi : km du compteur et tickets de la semaine (litres, DH, km du ticket). Consommation = litres des tickets ÷ km parcourus. Le carburant payé hors carte (usage personnel) doit être déclaré, sinon la consommation est faussée. Solde carte = recharges réparties en trésorerie − tickets payés avec la carte. Photos des tickets : à la mise en ligne.</div>
        </div>

        <div style={carte}>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 600, marginBottom: 8 }}>Derniers relevés</div>
          {!relevesRecents.length && <div style={{ fontSize: 13, color: TAUPE }}>Aucun relevé.</div>}
          {!!relevesRecents.length && (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr>{["Date", "Véhicule", "Km", "Tickets", "Saisi par", ""].map((h, i) => <th key={i} style={th}>{h}</th>)}</tr></thead>
              <tbody>
                {relevesRecents.map((r) => {
                  const tks = ((flotte && flotte.tickets) || []).filter((t) => t.releveId === r.id);
                  const v = vehiculeParId(r.vehiculeId);
                  return (
                    <tr key={r.id}>
                      <td style={td}>{formatDate(r.date)}</td>
                      <td style={td}>{(v || {}).nom || "?"}</td>
                      <td style={td}>{nombreOuZero(r.km).toLocaleString("fr-FR")} km</td>
                      <td style={td}>{tks.length ? tks.map((t) => <div key={t.id} style={{ fontSize: 12 }}>{formatDate(t.date)} · {String(t.litres).replace(".", ",")} L · {formatDH(t.montant)} · {nombreOuZero(t.km).toLocaleString("fr-FR")} km{t.carte && t.carte !== "propre" ? <span style={{ color: OCRE }}> · {libCarteTicket(t)}</span> : ""}</div>) : <span style={{ color: TAUPE }}>aucun</span>}</td>
                      <td style={td}>{r.par}</td>
                      <td style={{ ...td, textAlign: "right", whiteSpace: "nowrap" }}>
                        {(peutGererVehicules || r.parId === user.id) && <button type="button" className="sc-btn" onClick={() => setReleveEdit({ ...r, km: String(r.km), tickets: tks.map((t) => ({ ...t, litres: String(t.litres), montant: String(t.montant), km: String(t.km) })) })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 8px" }}>Modifier</button>}
                        {peutGererVehicules && <button type="button" className="sc-btn" onClick={() => supprimerReleve(r)} style={iconBtnStyle} title="Supprimer">✕</button>}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

        {peutGererVehicules && (
          <div style={carte}>
            <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 24, fontWeight: 600, marginBottom: 8 }}>Machines lourdes</div>
            {!machines.length && <div style={{ fontSize: 13, color: TAUPE }}>Aucune machine (Stock › Consommables en service › Machines et bureaux).</div>}
            {!!machines.length && (
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead><tr>{["Machine", "Dernière intervention", "Pannes sur 12 mois", "Coût sur 12 mois", ""].map((h, i) => <th key={i} style={th}>{h}</th>)}</tr></thead>
                <tbody>
                  {machines.map((m) => {
                    const c = ((flotte.carnetsMachines || {})[m.id] || []).slice().sort((a, b) => (a.date < b.date ? 1 : -1));
                    const d12 = decalerJours(auj, -365);
                    const c12 = c.filter((x) => x.date >= d12);
                    return (
                      <tr key={m.id} style={{ opacity: m.actif === false ? 0.5 : 1 }}>
                        <td style={td}><b>{m.nom}</b></td>
                        <td style={td}>{c[0] ? <>{c[0].type} — {c[0].description}<div style={{ fontSize: 11, color: TAUPE }}>{formatDate(c[0].date)}</div></> : <span style={{ color: TAUPE }}>—</span>}</td>
                        <td style={td}>{c12.filter((x) => x.type === "Panne").length}</td>
                        <td style={td}>{formatDH(c12.reduce((n, x) => n + nombreOuZero(x.cout), 0))}</td>
                        <td style={{ ...td, textAlign: "right" }}><button type="button" className="sc-btn" onClick={() => setMachineCarnet({ machineId: m.id, nouvelle: { date: auj, type: "Entretien", description: "", intervenant: "", cout: "" } })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 8px" }}>Carnet</button></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
            <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>Historique des entretiens, pannes et réparations. Le coût saisi entre dans le taux atelier du mois (marge par dossier).</div>
          </div>
        )}
      </div>
    );
  }
  function renderModalesFlotte() {
    const auj = todayISO();
    return (
      <>
        {vehEdit && peutGererVehicules && (() => {
          const v = vehEdit;
          const set = (patch) => setVehEdit({ ...v, ...patch });
          const setEch = (k, patch) => set({ echeances: { ...(v.echeances || {}), [k]: { ...((v.echeances || {})[k] || {}), ...patch } } });
          const nc = v._nc || { date: auj, km: "", nature: "", garage: "", montant: "", note: "" };
          const ajouterCarnet = () => {
            if (!nc.date || !String(nc.nature || "").trim()) { setNotice("Carnet : indique la date et la nature de l'intervention."); return; }
            set({ carnet: [...(v.carnet || []), { id: uid(), date: nc.date, km: nc.km, nature: String(nc.nature).trim(), garage: String(nc.garage || "").trim(), montant: nc.montant, note: nc.note, par: user.nom }], _nc: null });
          };
          const mois = Array.from({ length: 6 }, (_, i) => moisDecale(auj.slice(0, 7), -i));
          const sc = soldeCarteVeh(v.id);
          const tks = ticketsVehicule(v.id).slice().sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 10);
          const autresCartes = ((flotte && flotte.tickets) || []).filter((t) => t.vehiculeId !== v.id && cartePayeur(t) === v.id);
          const utilisateursActifs = utilisateurs.filter((u) => u.actif).sort((a, b) => a.nom.localeCompare(b.nom, "fr"));
          const sTitre = { fontSize: 12, fontWeight: 600, margin: "12px 0 6px" };
          return (
            <Overlay onClose={() => setVehEdit(null)} zIndex={1450}>
              <div style={modalStyle(860)}>
                <div style={modalTitleStyle}>{v._nouveau ? "Nouveau véhicule" : v.nom}</div>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  <Field label="Nom"><input className="sc-input" value={v.nom} onChange={(e) => set({ nom: e.target.value })} style={inputStyle(200)} /></Field>
                  <Field label="Immatriculation"><input className="sc-input" value={v.immat || ""} onChange={(e) => set({ immat: e.target.value })} style={inputStyle(150)} /></Field>
                  <Field label="Type">
                    <select className="sc-select" value={v.type} onChange={(e) => set({ type: e.target.value })} style={{ ...selectStyle, width: 150 }}><option value="livraison">Livraison</option><option value="rdm">Léger (RDM)</option></select>
                  </Field>
                  <label style={{ fontSize: 13, display: "inline-flex", gap: 6, alignItems: "center", marginTop: 14 }}><input type="checkbox" checked={!!v.gps} onChange={(e) => set({ gps: e.target.checked })} /> GPS</label>
                  <label style={{ fontSize: 13, display: "inline-flex", gap: 6, alignItems: "center", marginTop: 14 }}><input type="checkbox" checked={v.actif !== false} onChange={(e) => set({ actif: e.target.checked })} /> Actif</label>
                </div>
                <div style={sTitre}>Conducteurs habituels (reçoivent la tâche du vendredi avec le Production Manager)</div>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {utilisateursActifs.map((u) => (
                    <label key={u.id} style={{ fontSize: 12, background: PIERRE, borderRadius: 6, padding: "4px 8px", display: "inline-flex", gap: 6, alignItems: "center", cursor: "pointer" }}>
                      <input type="checkbox" checked={(v.conducteurs || []).includes(u.id)} onChange={(e) => set({ conducteurs: e.target.checked ? [...(v.conducteurs || []), u.id] : (v.conducteurs || []).filter((x) => x !== u.id) })} /> {u.nom}
                    </label>
                  ))}
                </div>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Le Gérant ne reçoit pas la tâche, seulement l'alerte du lundi si le relevé n'est pas fait.</div>

                {estGerant && !v._nouveau && (() => {
                  // Nils 09/10 (g) : coût au km théorique (valeur actuelle − revente + coûts prévus) ÷ km restants ; paramètres datés.
                  const vs = [...(v.coutKm || [])].sort((a, b) => (a.dateEffet < b.dateEffet ? 1 : -1));
                  const kmJ = kmAu(v.id, todayISO());
                  const nk = v._nk || { dateEffet: todayISO(), valeurActuelle: "", revente: "", kmActuels: kmJ ? String(kmJ.km) : "", kmRevente: "", dateRevente: "", coutsAnnuels: "" };
                  const setNk = (patch) => set({ _nk: { ...nk, ...patch } });
                  const apercu = amortKmVehicule(nk);
                  const th = coutKmTheorique(v, todayISO());
                  const ctl = controleCoutVehicule(v);
                  const champ = (k, lib, w, type) => (
                    <Field label={lib} style={{ marginBottom: 6 }}><input type={type || "number"} min="0" className="sc-input" value={nk[k] ?? ""} onChange={(e) => setNk({ [k]: e.target.value })} style={{ ...inputStyle(w || 130), padding: "5px 6px" }} /></Field>
                  );
                  const ajouter = () => {
                    if (!nk.dateEffet || !(nombreOuZero(nk.kmRevente) > nombreOuZero(nk.kmActuels)) || !nk.dateRevente || nk.dateRevente <= nk.dateEffet) { setNotice("Coût au km : indique la date d'effet, le km à la revente (supérieur au km actuel) et la date de revente prévue."); return; }
                    const { _nk, ...reste } = v;
                    setVehEdit({ ...reste, coutKm: [...(v.coutKm || []).filter((x) => x.dateEffet !== nk.dateEffet), { ...nk, saisiPar: user.nom, saisiLe: new Date().toISOString() }] });
                  };
                  return (
                    <>
                      <div style={sTitre}>Coût au km (Gérant)</div>
                      <div style={{ fontSize: 12, background: PIERRE, borderRadius: 6, padding: "6px 10px", marginBottom: 8 }}>
                        {th ? <>Coût actuel : <b>{fmtMAD(th.total)} DH / km</b> = amortissement et frais {fmtMAD(th.amortKm)} + carburant {fmtMAD(th.carbKm)}{th.carbEstime ? " (estimé : pas encore 300 km relevés)" : " (moyenne depuis l'entrée dans l'ERP)"}.</> : "Pas encore de paramètres : le coût au km vient des dépenses réelles des 12 derniers mois (dès 1 000 km relevés), sinon des paramètres du type."}
                      </div>
                      {vs.map((x) => { const a = amortKmVehicule(x); return (
                        <div key={x.dateEffet} style={{ fontSize: 12, display: "flex", gap: 8, alignItems: "center", padding: "3px 0" }}>
                          <span style={{ flex: 1 }}>à partir du <b>{formatDate(x.dateEffet)}</b> : valeur {formatDH(nombreOuZero(x.valeurActuelle))} → revente {formatDH(nombreOuZero(x.revente))} le {formatDate(x.dateRevente)} · {nombreOuZero(x.kmActuels).toLocaleString("fr-FR")} → {nombreOuZero(x.kmRevente).toLocaleString("fr-FR")} km · coûts {formatDH(nombreOuZero(x.coutsAnnuels))} / an{a ? <> → <b>{fmtMAD(a.parKm)} DH / km</b></> : ""}</span>
                          <button type="button" className="sc-btn" onClick={() => set({ coutKm: (v.coutKm || []).filter((y) => y.dateEffet !== x.dateEffet) })} style={iconBtnStyle}>✕</button>
                        </div>
                      ); })}
                      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "flex-end", marginTop: 6 }}>
                        {champ("dateEffet", "À partir du", 140, "date")}
                        {champ("valeurActuelle", "Valeur actuelle (DH)", 120)}
                        {champ("revente", "Revente prévue (DH)", 120)}
                        {champ("kmActuels", "Km aujourd'hui", 110)}
                        {champ("kmRevente", "Km à la revente", 110)}
                        {champ("dateRevente", "Date de revente", 140, "date")}
                        {champ("coutsAnnuels", "Coûts prévus / an (DH)", 130)}
                        <button type="button" className="sc-btn" onClick={ajouter} style={{ ...ghostBtnStyle, fontSize: 12, marginBottom: 6 }}>+ Enregistrer ces paramètres</button>
                      </div>
                      <div style={{ fontSize: 11, color: TAUPE }}>
                        Coûts prévus / an : assurance, vignette, entretien, réparations (sans le carburant ni le leasing : les traites et le rachat ne comptent pas, la valeur actuelle les remplace). {apercu ? `Aperçu : ${fmtMAD(apercu.parKm)} DH / km d'amortissement et frais sur ${Math.round(apercu.kmRest).toLocaleString("fr-FR")} km.` : ""} Un dossier ou un déplacement garde le coût en vigueur à sa date.
                      </div>
                      {ctl && (
                        <div style={{ fontSize: 12, marginTop: 6, color: (Math.abs(ctl.ecartDepPct || 0) > 20 || Math.abs(ctl.ecartKmPct || 0) > 20) ? ROUILLE : TAUPE }}>
                          Contrôle depuis le {formatDate(ctl.p.dateEffet)} ({Math.round(ctl.jours)} j) : dépenses réelles {formatDH(ctl.depReelles)} pour {formatDH(ctl.depPrevues)} prévues{ctl.ecartDepPct !== null ? ` (${ctl.ecartDepPct > 0 ? "+" : ""}${Math.round(ctl.ecartDepPct)} %)` : ""} · km {Math.round(ctl.kmReels).toLocaleString("fr-FR")}{ctl.kmPrevus ? ` pour ${Math.round(ctl.kmPrevus).toLocaleString("fr-FR")} prévus (${ctl.ecartKmPct > 0 ? "+" : ""}${Math.round(ctl.ecartKmPct)} %)` : ""}.
                        </div>
                      )}
                    </>
                  );
                })()}

                <div style={sTitre}>Échéances (tâche à l'Administration 30 jours avant)</div>
                {TYPES_ECHEANCE_VEHICULE.map(([k, lib]) => {
                  const e = (v.echeances || {})[k] || {};
                  return (
                    <div key={k} style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 6, flexWrap: "wrap" }}>
                      <span style={{ width: 130, fontSize: 13 }}>{lib}</span>
                      <input type="date" className="sc-input" value={e.date || ""} onChange={(ev) => setEch(k, { date: ev.target.value })} style={{ ...inputStyle(150), padding: "5px 6px", borderColor: e.date && e.date < auj ? ROUILLE : undefined }} />
                      <input type="number" min="0" className="sc-input" placeholder="montant (DH)" value={e.montant ?? ""} onChange={(ev) => setEch(k, { montant: ev.target.value })} style={{ ...inputStyle(120), padding: "5px 6px" }} />
                      <input className="sc-input" placeholder="note (assureur, contrat…)" value={e.note || ""} onChange={(ev) => setEch(k, { note: ev.target.value })} style={{ ...inputStyle(200), padding: "5px 6px" }} />
                      {e.date && <button type="button" className="sc-btn" onClick={() => renouvelerEcheance(k)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 6px" }} title="L'échéance actuelle passe dans l'historique ; nouvelle date à + 1 an (modifiable)">✓ Renouvelée</button>}
                      {!!(e.historique || []).length && <span style={{ fontSize: 11, color: TAUPE }}>précédentes : {(e.historique || []).slice(-3).map((h) => formatDate(h.date)).join(", ")}</span>}
                    </div>
                  );
                })}

                <div style={sTitre}>Carnet d'entretien et de réparations</div>
                {[...(v.carnet || [])].sort((a, b) => (a.date < b.date ? 1 : -1)).map((c) => (
                  <div key={c.id} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, background: PIERRE, borderRadius: 6, padding: "4px 8px", marginBottom: 4 }}>
                    <span style={{ flex: 1 }}>{formatDate(c.date)}{c.km ? ` · ${nombreOuZero(c.km).toLocaleString("fr-FR")} km` : ""} · <b>{c.nature}</b>{c.garage ? ` · ${c.garage}` : ""}{String(c.montant ?? "") !== "" ? ` · ${formatDH(nombreOuZero(c.montant))}` : ""}{c.note ? ` · ${c.note}` : ""}</span>
                    <button type="button" className="sc-btn" onClick={() => set({ carnet: (v.carnet || []).filter((x) => x.id !== c.id) })} style={iconBtnStyle}>✕</button>
                  </div>
                ))}
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
                  <input type="date" className="sc-input" value={nc.date} onChange={(e) => set({ _nc: { ...nc, date: e.target.value } })} style={{ ...inputStyle(140), padding: "5px 6px" }} />
                  <input type="number" min="0" className="sc-input" placeholder="km" value={nc.km} onChange={(e) => set({ _nc: { ...nc, km: e.target.value } })} style={{ ...inputStyle(90), padding: "5px 6px" }} />
                  <input className="sc-input" placeholder="nature (vidange, pneus, freins…)" value={nc.nature} onChange={(e) => set({ _nc: { ...nc, nature: e.target.value } })} style={{ ...inputStyle(200), padding: "5px 6px" }} />
                  <input className="sc-input" placeholder="garage" value={nc.garage} onChange={(e) => set({ _nc: { ...nc, garage: e.target.value } })} style={{ ...inputStyle(130), padding: "5px 6px" }} />
                  <input type="number" min="0" className="sc-input" placeholder="montant (info)" value={nc.montant} onChange={(e) => set({ _nc: { ...nc, montant: e.target.value } })} style={{ ...inputStyle(110), padding: "5px 6px" }} />
                  <button type="button" className="sc-btn" onClick={ajouterCarnet} style={{ ...ghostBtnStyle, fontSize: 12 }}>+ Ajouter</button>
                </div>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Le montant du carnet est indicatif : le coût réel du véhicule vient de la trésorerie (sorties réparties sur le véhicule) et des tickets.</div>

                {!v._nouveau && (<>
                  <div style={sTitre}>Consommation</div>
                  <table style={{ borderCollapse: "collapse", fontSize: 12 }}>
                    <thead><tr>{["Mois", "Km", "Litres", "L/100", "Carburant (tickets)", "DH / 100 km"].map((h) => <th key={h} style={{ textAlign: "right", fontSize: 10, color: TAUPE, padding: "4px 10px", borderBottom: `1px solid ${PIERRE}` }}>{h}</th>)}</tr></thead>
                    <tbody>
                      {mois.map((m) => { const c = consoMoisVeh(v.id, m); return (
                        <tr key={m}>{[libMois(m), c.km ? c.km.toLocaleString("fr-FR") : "—", c.litres ? c.litres.toFixed(1).replace(".", ",") : "—", fmtL100(c.l100), c.dh ? formatDH(c.dh) : "—", c.dh100 ? formatDH(c.dh100) : "—"].map((x, i) => <td key={i} style={{ textAlign: i ? "right" : "left", padding: "4px 10px" }}>{x}</td>)}</tr>
                      ); })}
                    </tbody>
                  </table>
                  <div style={sTitre}>Carte carburant</div>
                  <div style={{ fontSize: 12, background: PIERRE, borderRadius: 6, padding: "6px 10px" }}>
                    Recharges réparties sur ce véhicule {formatDH(sc.recharges)} − tickets payés avec sa carte {formatDH(sc.tickets)} = <b style={{ color: sc.solde < -0.01 ? ROUILLE : ENCRE }}>solde théorique {formatDH(sc.solde)}</b>
                    {!!autresCartes.length && <div style={{ color: OCRE, marginTop: 2 }}>Sa carte a payé {autresCartes.length} plein(s) d'autres véhicules : {autresCartes.map((t) => `${(vehiculeParId(t.vehiculeId) || {}).nom || "?"} ${formatDate(t.date)} ${formatDH(t.montant)}`).join(", ")}.</div>}
                  </div>
                  {!!tks.length && <div style={{ fontSize: 12, marginTop: 6 }}>Derniers tickets : {tks.map((t) => `${formatDate(t.date)} ${String(t.litres).replace(".", ",")} L ${formatDH(t.montant)}${t.carte && t.carte !== "propre" ? ` (${libCarteTicket(t)})` : ""}`).join(" · ")}</div>}
                </>)}

                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 14 }}>
                  <button type="button" className="sc-btn" onClick={() => setVehEdit(null)} style={ghostBtnStyle}>Fermer</button>
                  <button type="button" className="sc-btn" onClick={enregistrerVehicule} style={primaryBtnStyle}>Enregistrer</button>
                </div>
              </div>
            </Overlay>
          );
        })()}
        {releveEdit && (() => {
          const r = releveEdit;
          const set = (patch) => setReleveEdit({ ...r, ...patch });
          const v = vehiculeParId(r.vehiculeId);
          const choix = (peutGererVehicules ? vehiculesFlotte().filter((x) => x.actif !== false || x.id === r.vehiculeId) : mesVehicules());
          const prec = v ? kmAu(v.id, r.date || auj, r.id || "__") : null;
          const setT = (i, patch) => set({ tickets: (r.tickets || []).map((t, j) => (j === i ? { ...t, ...patch } : t)) });
          const kmNum = nombreOuZero(r.km);
          return (
            <Overlay onClose={() => setReleveEdit(null)} zIndex={1460}>
              <div style={modalStyle(760)}>
                <div style={modalTitleStyle}>{r.id ? "Modifier le relevé" : "Relevé km et tickets de la semaine"}</div>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  <Field label="Véhicule">
                    <select className="sc-select" value={r.vehiculeId} disabled={!!r.id} onChange={(e) => set({ vehiculeId: e.target.value })} style={{ ...selectStyle, width: 200 }}>
                      {choix.map((x) => (<option key={x.id} value={x.id}>{x.nom}</option>))}
                    </select>
                  </Field>
                  <Field label="Date du relevé"><input type="date" className="sc-input" value={r.date} max={auj} onChange={(e) => set({ date: e.target.value })} style={inputStyle(150)} /></Field>
                  <Field label="Km au compteur"><input type="number" min="0" className="sc-input" value={r.km} onChange={(e) => set({ km: e.target.value })} style={inputStyle(130)} /></Field>
                </div>
                <div style={{ fontSize: 12, color: TAUPE, marginTop: -4, marginBottom: 8 }}>{prec ? `Dernier km connu : ${prec.km.toLocaleString("fr-FR")} km (${prec.src} du ${formatDate(prec.date)})${kmNum > prec.km ? ` — soit ${(kmNum - prec.km).toLocaleString("fr-FR")} km depuis` : ""}.` : "Premier relevé de ce véhicule."}</div>
                <div style={{ fontSize: 12, fontWeight: 600, margin: "6px 0" }}>Tickets de la semaine (un par plein)</div>
                {(r.tickets || []).map((t, i) => (
                  <div key={i} style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap", marginBottom: 6, background: PIERRE, borderRadius: 6, padding: "6px 8px" }}>
                    <input type="date" className="sc-input" value={t.date} max={r.date || auj} onChange={(e) => setT(i, { date: e.target.value })} style={{ ...inputStyle(140), padding: "5px 6px" }} />
                    <input type="number" min="0" step="0.01" className="sc-input" placeholder="litres" value={t.litres} onChange={(e) => setT(i, { litres: e.target.value })} style={{ ...inputStyle(80), padding: "5px 6px" }} /> L
                    <input type="number" min="0" step="0.01" className="sc-input" placeholder="DH" value={t.montant} onChange={(e) => setT(i, { montant: e.target.value })} style={{ ...inputStyle(90), padding: "5px 6px" }} /> DH
                    <input type="number" min="0" className="sc-input" placeholder="km du ticket" value={t.km} onChange={(e) => setT(i, { km: e.target.value })} style={{ ...inputStyle(110), padding: "5px 6px" }} /> km
                    <select className="sc-select" value={t.carte || "propre"} onChange={(e) => setT(i, { carte: e.target.value })} style={{ ...selectStyle, width: 200, padding: "4px 6px" }}>
                      <option value="propre">Payé avec sa carte</option>
                      {vehiculesFlotte().filter((x) => x.id !== r.vehiculeId).map((x) => (<option key={x.id} value={x.id}>Carte de {x.nom}</option>))}
                      <option value="hors">Payé hors carte (personnel)</option>
                    </select>
                    <button type="button" className="sc-btn" onClick={() => set({ tickets: (r.tickets || []).filter((_, j) => j !== i) })} style={iconBtnStyle}>✕</button>
                  </div>
                ))}
                <button type="button" className="sc-btn" onClick={() => set({ tickets: [...(r.tickets || []), { date: r.date || auj, litres: "", montant: "", km: "", carte: "propre" }] })} style={{ ...ghostBtnStyle, padding: "2px 0", fontSize: 12 }}>+ Ajouter un ticket</button>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 6, lineHeight: 1.5 }}>Recopie le ticket Total : litres, montant et km déclarés. Carburant mis à tes frais (usage personnel) : ajoute-le comme ticket « payé hors carte », sinon la consommation est faussée. Photo du ticket : à la mise en ligne.</div>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 12 }}>
                  <button type="button" className="sc-btn" onClick={() => setReleveEdit(null)} style={ghostBtnStyle}>Fermer</button>
                  <button type="button" className="sc-btn" onClick={enregistrerReleve} style={primaryBtnStyle}>Enregistrer</button>
                </div>
              </div>
            </Overlay>
          );
        })()}
        {machineCarnet && peutGererVehicules && (() => {
          const mc = machineCarnet;
          const m = (affectations || []).find((a) => a.id === mc.machineId);
          const n = mc.nouvelle;
          const setN = (patch) => setMachineCarnet({ ...mc, nouvelle: { ...n, ...patch } });
          const liste = (((flotte && flotte.carnetsMachines) || {})[mc.machineId] || []).slice().sort((a, b) => (a.date < b.date ? 1 : -1));
          return (
            <Overlay onClose={() => setMachineCarnet(null)} zIndex={1450}>
              <div style={modalStyle(760)}>
                <div style={modalTitleStyle}>Carnet — {(m || {}).nom || "?"}</div>
                {!liste.length && <div style={{ fontSize: 13, color: TAUPE, marginBottom: 8 }}>Aucune intervention enregistrée.</div>}
                {liste.map((x) => (
                  <div key={x.id} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, background: PIERRE, borderRadius: 6, padding: "5px 8px", marginBottom: 4 }}>
                    <span style={{ flex: 1 }}>{formatDate(x.date)} · <b style={{ color: x.type === "Panne" ? ROUILLE : ENCRE }}>{x.type}</b> · {x.description}{x.intervenant ? ` · ${x.intervenant}` : ""}{x.cout !== "" && x.cout !== undefined ? ` · ${formatDH(nombreOuZero(x.cout))}` : ""}<span style={{ color: TAUPE }}> — {x.par}</span></span>
                    <button type="button" className="sc-btn" onClick={() => supprimerCarnetMachine(mc.machineId, x.id)} style={iconBtnStyle}>✕</button>
                  </div>
                ))}
                <div style={{ fontSize: 12, fontWeight: 600, margin: "10px 0 6px" }}>Nouvelle intervention</div>
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
                  <input type="date" className="sc-input" value={n.date} max={todayISO()} onChange={(e) => setN({ date: e.target.value })} style={{ ...inputStyle(140), padding: "5px 6px" }} />
                  <select className="sc-select" value={n.type} onChange={(e) => setN({ type: e.target.value })} style={{ ...selectStyle, width: 130, padding: "4px 6px" }}>{TYPES_CARNET_MACHINE.map((t) => (<option key={t} value={t}>{t}</option>))}</select>
                  <input className="sc-input" placeholder="ce qui a été fait / la panne" value={n.description} onChange={(e) => setN({ description: e.target.value })} style={{ ...inputStyle(240), padding: "5px 6px" }} />
                  <input className="sc-input" placeholder="intervenant" value={n.intervenant} onChange={(e) => setN({ intervenant: e.target.value })} style={{ ...inputStyle(130), padding: "5px 6px" }} />
                  <input type="number" min="0" className="sc-input" placeholder="coût (DH)" value={n.cout} onChange={(e) => setN({ cout: e.target.value })} style={{ ...inputStyle(100), padding: "5px 6px" }} />
                </div>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Le coût entre dans le taux atelier du mois. Ne le saisis pas aussi comme consommable.</div>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 12 }}>
                  <button type="button" className="sc-btn" onClick={() => setMachineCarnet(null)} style={ghostBtnStyle}>Fermer</button>
                  <button type="button" className="sc-btn" onClick={async () => { if (await ajouterCarnetMachine(mc.machineId, n)) setMachineCarnet({ ...mc, nouvelle: { date: todayISO(), type: "Entretien", description: "", intervenant: "", cout: "" } }); }} style={primaryBtnStyle}>Ajouter au carnet</button>
                </div>
              </div>
            </Overlay>
          );
        })()}
      </>
    );
  }
  // ---------- ERP step 15 (ar, Nils 08/10) : planning ----------
  const peutPlanifier = peut("planning.gerer");
  function itemsPlan(dossierId) {
    return ((planning && planning.items) || []).filter((x) => !dossierId || x.dossierId === dossierId);
  }
  // Nils 02/11 : numéro du document selon le stade du dossier (PL au PL, BL au BL…), pas celui du BC.
  function numeroStadeDossier(c) {
    return c ? c.numeroFacture || c.numeroBL || c.numeroPL || c.numeroRDM || c.numero : "";
  }
  function libDossierPlan(c) {
    if (!c) return "dossier supprimé";
    const ref = refDossierPlan(c);
    return `${numeroStadeDossier(c)} — ${(clientDe(c.clientId) || {}).nom || ""}${ref ? ` — ${ref}` : ""}`;
  }
  function refDossierPlan(c) {
    const d = devisDuDossier(c) || {};
    return String((c && c.reference) || d.reference || "").trim();
  }
  function commercialClientPlan(c) {
    const d = devisDuDossier(c) || {};
    return String((c && c.commercialClient) || d.commercialClient || "").trim();
  }
  function commercialDuDossierPlan(c) {
    return c ? idCommercialDuDevis(devisDuDossier(c)) : null;
  }
  function debiteusesPlan() {
    return (affectations || []).filter((a) => a.type === "machine" && a.actif !== false && normLib(a.nom).includes("debiteuse")).sort((a, b) => a.nom.localeCompare(b.nom, "fr"));
  }
  function capaciteDebiteuse(date) {
    const js = new Date(`${date}T12:00:00Z`).getUTCDay();
    if (speciauxDuMois(date.slice(0, 7), recPointage(date.slice(0, 7)))[date]) return 0;
    return duesDuJour(regimeDe({ regime: "usine" }), date, js).dues || 0;
  }
  // Présence d'une personne un jour donné (1, 0,5 ou 0) — indicatif : congés, absences, fériés, congés spéciaux.
  function presencePlan(st, date) {
    if (!staffActif(st) && st.dateSortie && st.dateSortie <= date) return 0;
    if ((st.dateEmbauche && date < st.dateEmbauche) || (st.dateSortie && date > st.dateSortie)) return 0;
    const ym = date.slice(0, 7), rec = recPointage(ym);
    if (speciauxDuMois(ym, rec)[date]) return 0;
    if (congeSpecialDu(st, date, typesCongesSpeciaux())) return 0;
    const x = rec && rec.lignes && rec.lignes[st.id] && (rec.lignes[st.id].jours || {})[date.slice(8, 10)];
    if (!x || !x.code) return 1;
    const codes = codesSaisie(x);
    return Math.max(0, 1 - codes.reduce((n, k) => n + k.frac, 0));
  }
  function finisseursPlan() {
    return (staff || []).filter((st) => normLib(st.poste || "").includes("finisseur"));
  }
  function poseursPlan() {
    return (staff || []).filter((st) => st.poseur || st.service === "Pose");
  }
  function capaciteFinition(date) {
    const js = new Date(`${date}T12:00:00Z`).getUTCDay();
    return finisseursPlan().reduce((n, st) => n + presencePlan(st, date) * (duesDuJour(regimePointage(st, recPointage(date.slice(0, 7))), date, js).dues || 0), 0);
  }
  function poseursPresents(date) {
    return poseursPlan().reduce((n, st) => n + presencePlan(st, date), 0);
  }
  // Charge planifiée un jour donné (hors un élément, pour l'édition).
  function chargePlan(date, saufId) {
    const its = itemsPlan().filter((x) => x.date === date && x.id !== saufId);
    const deb = {};
    its.filter((x) => x.type === "debit").forEach((x) => (x.machines || []).forEach((m) => { deb[m.id] = (deb[m.id] || 0) + nombreOuZero(m.heures); }));
    const fin = its.filter((x) => x.type === "finition").reduce((n, x) => n + nombreOuZero(x.finisseurs) * nombreOuZero(x.heures), 0);
    const pose = { matin: 0, apresmidi: 0 };
    its.filter((x) => x.type === "pose").forEach((x) => { if (x.demi !== "apresmidi") pose.matin += nombreOuZero(x.poseurs); if (x.demi !== "matin") pose.apresmidi += nombreOuZero(x.poseurs); });
    const rdm = its.filter((x) => x.type === "rdm").length;
    return { deb, fin, pose, rdm };
  }
  // Ce qui manque encore au dossier pour une étape (indicatif, ne bloque pas).
  function manquantsPlan(c, type) {
    if (!c) return [];
    const out = [];
    const d = devisDuDossier(c);
    const docs = documentsImportants(d, c).filter((x) => !x.fourni && !x.facultatif);
    const idx = (st) => STATUTS_COMMANDE.indexOf(st);
    const cs = contactSurPlaceDuDossier(c);
    if (type === "rdm" || type === "pose") {
      if (!(cs.nom || "").trim() || !(cs.tel || "").trim()) out.push("contact / téléphone sur place");
    }
    if (type === "rdm") docs.filter((x) => idx(x.requisDes) <= idx("BDC")).forEach((x) => out.push(x.label));
    if (type === "debit" || type === "finition") {
      const rdmFait = !dossierAvecRDM(c) || itemsPlan(c.id).some((x) => x.type === "rdm" && x.fait) || idx(c.statut) >= idx("PL");
      if (!rdmFait) out.push("RDM pas encore fait");
      articlesNonValidesDuDossier(c).forEach((a) => out.push(`article à valider : ${a}`));
      docs.filter((x) => idx(x.requisDes) <= idx("RDM")).forEach((x) => out.push(x.label));
    }
    if (type === "pose") {
      if (dossierTransfo(c) && !productionPlanifiee(c)) out.push(sansFinitionDossier(c) || itemsPlan(c.id).some((x) => x.type === "finition") ? "débit pas encore planifié" : "finition pas encore planifiée");
      if (!(planning.prodTerminee || {})[c.id] && (dossierTransfo(c) || itemsPlan(c.id).some((x) => x.type === "debit" || x.type === "finition"))) out.push("production pas encore terminée");
      docs.filter((x) => idx(x.requisDes) <= idx("BL") && x.cle === "photosAvant").forEach((x) => out.push(x.label));
    }
    if (c.enAttenteDe && !/^(rien|aucun)/i.test(c.enAttenteDe)) out.push(`en attente de : ${c.enAttenteDe}`);
    return out;
  }
  function nouvelElementPlan(type, dossierId, date) {
    return { id: "", dossierId: dossierId || "", type: type || "rdm", date: date || todayISO(), demi: "matin", machines: {}, finisseurs: "", heures: "", poseurs: "", note: "", raison: "" };
  }
  function destinatairesPlan(c, avecMetreur) {
    const ids = [...qui(P_PROD), ...qui(P_GERANT)];
    const com = commercialDuDossierPlan(c);
    if (com) ids.push(com);
    if (avecMetreur) ids.push(...qui(P_POSE));
    return [...new Set(ids)].filter((id) => utilisateurs.some((u) => u.id === id && u.actif));
  }
  // Step 17 (Nils 15/10) : le commercial du dossier est prévenu de chaque changement du planning
  // (création, date avancée ou déplacée, suppression) ; les reports passent déjà par notifPlan.
  function quandPlan(x) {
    const d = x && x.demi && (x.type === "rdm" || x.type === "pose") ? (DEMIS_PLAN.find((y) => y[0] === x.demi) || [, ""])[1].toLowerCase() : "";
    return x ? `${formatDate(x.date)}${d ? ` (${d})` : ""}` : "";
  }
  function notifCommercialPlan(c, item, quoi, detail) {
    const com = commercialDuDossierPlan(c);
    if (!c || !com || com === user.id || !utilisateurs.some((u) => u.id === com && u.actif)) return null;
    const lib = TYPES_PLAN[item.type].lib;
    const fem = item.type === "finition" || item.type === "pose" ? "e" : "";
    return { id: uid(), type: "info", dossierId: c.id, texte: `${lib} ${quoi}${fem} — ${libDossierPlan(c)}`, detail: detail || "", pour: [com], vus: {}, le: new Date().toISOString(), par: user.nom };
  }
  function notifsChangementPlan(c, avant, item) {
    if (avant && item.date > avant.date) return []; // report : déjà notifié (Ahmed, Nils, commercial)
    if (!avant) return [notifCommercialPlan(c, item, "planifié", `le ${quandPlan(item)}`)].filter(Boolean);
    if (avant.date !== item.date || (avant.demi || "") !== (item.demi || "")) return [notifCommercialPlan(c, item, item.date < avant.date ? "avancé" : "déplacé", `du ${quandPlan(avant)} au ${quandPlan(item)}`)].filter(Boolean);
    return [];
  }
  function notifPlan(c, type, texte, detail, avecMetreur, sansAuteur) {
    return { id: uid(), type, dossierId: c ? c.id : "", texte, detail: detail || "", pour: destinatairesPlan(c, avecMetreur).filter((id) => !sansAuteur || id !== user.id), vus: {}, le: new Date().toISOString(), par: user.nom };
  }
  async function enregistrerElementPlan() {
    const f = planEdit;
    if (!f || !peutPlanifier) return;
    const err = (m) => setPlanEdit({ ...f, erreur: m });
    const c = dossierParId(f.dossierId);
    if (!c) { err("Choisis le dossier."); return; }
    if (!f.date) { err("Indique la date."); return; }
    const base = { id: f.id || uid(), dossierId: c.id, type: f.type, date: f.date, note: String(f.note || "").trim() };
    if (f.type === "rdm" || f.type === "pose") base.demi = f.demi || "matin";
    if (f.type === "debit") {
      const machines = Object.entries(f.machines || {}).map(([id, h]) => ({ id, heures: nombreOuZero(h) })).filter((m) => m.heures > 0);
      if (!machines.length) { err("Choisis au moins une débiteuse et ses heures."); return; }
      base.machines = machines;
    }
    if (f.type === "finition") {
      if (!(nombreOuZero(f.finisseurs) > 0) || !(nombreOuZero(f.heures) > 0)) { err("Indique le nombre de finisseurs et les heures."); return; }
      base.finisseurs = nombreOuZero(f.finisseurs); base.heures = nombreOuZero(f.heures);
    }
    if (f.type === "pose") {
      if (!(nombreOuZero(f.poseurs) > 0)) { err("Indique le nombre de poseurs."); return; }
      base.poseurs = Math.round(nombreOuZero(f.poseurs));
    }
    const P = planningRef.current || planning;
    const avant = f.id ? (P.items || []).find((x) => x.id === f.id) : null;
    // Nils 08/10 : ordre obligatoire RDM → production (débit, finition) → pose (le même jour est accepté).
    {
      const autres = (P.items || []).filter((x) => x.dossierId === c.id && x.id !== f.id);
      const dates = (types) => autres.filter((x) => types.includes(x.type)).map((x) => x.date).sort();
      const prod = ["debit", "finition"];
      const rdmMax = dates(["rdm"]).slice(-1)[0], prodMin = dates(prod)[0], prodMax = dates(prod).slice(-1)[0], poseMin = dates(["pose"])[0];
      if (prod.includes(f.type) && rdmMax && f.date < rdmMax) { err(`La production ne peut pas être avant le RDM (${formatDate(rdmMax)}).`); return; }
      // Nils 13/10 : finition jamais avant le débit (le même jour est accepté).
      const debitMin = dates(["debit"])[0], finitionMax = dates(["finition"]).slice(-1)[0];
      if (f.type === "finition" && debitMin && f.date < debitMin) { err(`La finition ne peut pas être avant le débit (${formatDate(debitMin)}).`); return; }
      if (f.type === "debit" && finitionMax && f.date > finitionMax) { err(`Le débit ne peut pas être après la finition (${formatDate(finitionMax)}) : déplace d'abord la finition.`); return; }
      if (prod.includes(f.type) && poseMin && f.date > poseMin) { err(`La production ne peut pas être après la pose (${formatDate(poseMin)}) : déplace d'abord la pose.`); return; }
      if (f.type === "pose" && prodMax && f.date < prodMax) { err(`La pose ne peut pas être avant la fin de la production (${formatDate(prodMax)}).`); return; }
      if (f.type === "pose" && !prodMax && rdmMax && f.date < rdmMax) { err(`La pose ne peut pas être avant le RDM (${formatDate(rdmMax)}).`); return; }
      if (f.type === "rdm" && prodMin && f.date > prodMin) { err(`Le RDM ne peut pas être après la production (${formatDate(prodMin)}) : déplace d'abord la production.`); return; }
      if (f.type === "rdm" && !prodMin && poseMin && f.date > poseMin) { err(`Le RDM ne peut pas être après la pose (${formatDate(poseMin)}).`); return; }
    }
    const repousse = avant && f.date > avant.date;
    if (repousse && !String(f.raison || "").trim()) { err("Date repoussée : indique la raison."); return; }
    const maintenant = new Date().toISOString();
    const item = { ...(avant || {}), ...base, historique: [...((avant && avant.historique) || []), ...(avant && (avant.date !== f.date || (avant.demi || "") !== (base.demi || "")) ? [{ le: maintenant, par: user.nom, de: `${avant.date}${avant.demi ? ` ${avant.demi}` : ""}`, vers: `${f.date}${base.demi ? ` ${base.demi}` : ""}`, raison: String(f.raison || "").trim() }] : [])], ...(avant ? { modifiePar: user.nom, modifieLe: maintenant } : { creePar: user.nom, creeLe: maintenant }) };
    if (avant && avant.type === "rdm" && repousse) item.fait = false;
    const notifs = [];
    if (repousse) {
      const eng = (P.engagements || {})[c.id];
      const depasse = f.type === "pose" && eng && eng.date && f.date > eng.date;
      notifs.push(notifPlan(c, "retard", `${depasse ? "⚠ Engagement client dépassé — " : ""}${TYPES_PLAN[f.type].lib} repoussé${f.type === "finition" || f.type === "pose" ? "e" : ""} — ${libDossierPlan(c)}`, `du ${formatDate(avant.date)} au ${formatDate(f.date)} : ${String(f.raison).trim()}${depasse ? ` (date engagée : ${formatDate(eng.date)})` : ""}`, f.type === "rdm", true));
    }
    notifs.push(...notifsChangementPlan(c, avant, item));
    let next = { ...P, items: avant ? (P.items || []).map((x) => (x.id === item.id ? item : x)) : [...(P.items || []), item], notifs: [...(P.notifs || []), ...notifs] };
    await persistPlanning(next);
    if (f.type === "pose") await lierPosePlan(c, next);
    // ERP step 16 (lot 4b) : regroupement des cuisines d'un projet immo (alerte non bloquante).
    if (f.type === "pose" && dossierTransfo(c) && !sansFinitionDossier(c) && !(next.items || []).some((x) => x.dossierId === c.id && x.type === "finition")) await demander(`Attention : aucune finition n'est planifiée pour ${libDossierPlan(c)} avant cette pose. Planifie la finition, ou coche « Sans finition » dans la fiche planning du dossier si c'est un débit seul.`, { info: true });
    if (f.type === "pose") { const msg = alerteRegroupement(c, next.items); if (msg) await demander(msg, { info: true }); }
    // Poseurs prévus au-delà des poseurs présents : avertissement (non bloquant).
    if (f.type === "pose") {
      const ch = chargePlan(f.date);
      const pres = poseursPresents(f.date);
      const max = Math.max(base.demi !== "apresmidi" ? ch.pose.matin : 0, base.demi !== "matin" ? ch.pose.apresmidi : 0);
      if (max > pres) setNotice(`Attention : ${max} poseurs prévus le ${formatDate(f.date)} pour ${String(pres).replace(".", ",")} présent(s).`);
    }
    await tracerAcces(avant ? "planning modifié" : "planning ajouté", `${TYPES_PLAN[f.type].lib} — ${libDossierPlan(c)} — ${formatDate(f.date)}`);
    setPlanEdit(null);
  }
  // Pose planifiée → dates de la fiche de pose ; pose hors Casablanca → fiche de déplacement « en cours ».
  async function lierPosePlan(c, P) {
    const poses = (P.items || []).filter((x) => x.dossierId === c.id && x.type === "pose").sort((a, b) => (a.date < b.date ? -1 : 1));
    if (!poses.length) return;
    const debut = poses[0].date, fin = poses[poses.length - 1].date;
    const fp = c.fichePose || {};
    if (fp.dateDebut !== debut || fp.dateFin !== fin) await persistCommandes((commandesListe || []).map((x) => (x.id === c.id ? { ...x, fichePose: { ...ficheDePoseVide(), ...(x.fichePose || {}), dateDebut: debut, dateFin: fin } } : x)));
    if (!horsCasablanca(c)) return;
    const existante = (deplacements || []).find((d) => d.type === "Pose" && (d.dossiers || []).includes(c.id) && statutDepl(d) === "en cours");
    const z = zoneDuDossier(c);
    const nb = Math.max(...poses.map((x) => nombreOuZero(x.poseurs)), 0);
    if (existante) {
      if (existante.date !== debut || (existante.dateFin || existante.date) !== fin) {
        const maj = { ...existante, date: debut, dateFin: fin, modifiePar: user.nom, modifieLe: new Date().toISOString() };
        await persistDeplacements((deplacements || []).map((d) => (d.id === existante.id ? maj : d)));
        await syncPointageDeplacement(existante, maj);
      }
      return;
    }
    if ((deplacements || []).some((d) => d.type === "Pose" && (d.dossiers || []).includes(c.id))) return;
    const dep = { id: uid(), date: debut, dateFin: fin, statut: "en cours", type: "Pose", zoneId: z ? z.id : ((transportCouts().zones || [])[0] || {}).id || "", vehicules: [], dossiers: [c.id], participants: [], depenses: [], note: `Créée par le planning (${nb} poseur(s) prévu(s)) — à compléter : personnes et véhicules`, par: user.nom, le: new Date().toISOString(), depuisPlanning: true };
    await persistDeplacements([...(deplacements || []), dep]);
    setNotice("Pose hors Casablanca : fiche de déplacement créée (en cours) — ajoute les personnes et les véhicules.");
  }
  // ---------- Nils 13/10 : « Planifier le dossier » — RDM, débit, finition, pose dans une seule fenêtre ----------
  function chargePlanSauf(date, ids) {
    const its = itemsPlan().filter((x) => x.date === date && !ids.has(x.id));
    const deb = {};
    its.filter((x) => x.type === "debit").forEach((x) => (x.machines || []).forEach((m) => { deb[m.id] = (deb[m.id] || 0) + nombreOuZero(m.heures); }));
    const fin = its.filter((x) => x.type === "finition").reduce((n, x) => n + nombreOuZero(x.finisseurs) * nombreOuZero(x.heures), 0);
    const pose = { matin: 0, apresmidi: 0 };
    its.filter((x) => x.type === "pose").forEach((x) => { if (x.demi !== "apresmidi") pose.matin += nombreOuZero(x.poseurs); if (x.demi !== "matin") pose.apresmidi += nombreOuZero(x.poseurs); });
    return { deb, fin, pose, rdm: its.filter((x) => x.type === "rdm").length };
  }
  function ligneDepuisElement(x) {
    return { key: uid(), id: x.id, type: x.type, date: x.date, demi: x.demi || "matin", machines: Object.fromEntries((x.machines || []).map((m) => [m.id, String(m.heures)])), finisseurs: String(x.finisseurs ?? ""), heures: String(x.heures ?? ""), poseurs: String(x.poseurs ?? ""), note: x.note || "", raison: "" };
  }
  // Une ligne déjà planifiée et non modifiée n'est pas revalidée (ex. ancien débit sans débiteuse).
  function signaturePlanLigne(l) {
    const m = Object.entries(l.machines || {}).map(([id, h]) => [id, nombreOuZero(h)]).filter((x) => x[1] > 0).sort();
    return JSON.stringify([l.type, l.date, l.type === "rdm" || l.type === "pose" ? l.demi || "matin" : "", m, nombreOuZero(l.finisseurs), nombreOuZero(l.heures), nombreOuZero(l.poseurs), String(l.note || "").trim()]);
  }
  function ligneVidePlan(type) {
    return { key: uid(), id: "", type, date: "", demi: type === "pose" ? "journee" : "matin", machines: {}, finisseurs: "", heures: "", poseurs: "", note: "", raison: "" };
  }
  function ouvrirPlanDossier(c) {
    if (!c || !peutPlanifier) return;
    const its = itemsPlan(c.id);
    const types = [...(dossierAvecRDM(c) ? ["rdm"] : []), ...(dossierTransfo(c) ? ["debit", ...(sansFinitionDossier(c) ? [] : ["finition"])] : []), ...(dossierPose(c) ? ["pose"] : [])];
    const lignes = [];
    Object.keys(TYPES_PLAN).forEach((t) => {
      const ex = its.filter((x) => x.type === t).sort((a, b) => (a.date < b.date ? -1 : 1));
      if (ex.length) ex.forEach((x) => lignes.push(ligneDepuisElement(x)));
      else if (types.includes(t)) lignes.push(ligneVidePlan(t));
    });
    setPlanDossier(null);
    setPlanDossierEdit({ dossierId: c.id, lignes, erreur: "", erreurKey: "" });
  }
  async function enregistrerPlanDossier() {
    const F = planDossierEdit;
    if (!F || !peutPlanifier) return;
    const c = dossierParId(F.dossierId);
    if (!c) return;
    const err = (m, key) => setPlanDossierEdit({ ...F, erreur: m, erreurKey: key || "" });
    const P = planningRef.current || planning;
    const actives = F.lignes.filter((l) => l.date || l.id);
    const finaux = [];
    for (const l of actives) {
      const lib = TYPES_PLAN[l.type].lib;
      const avant0 = l.id ? (P.items || []).find((x) => x.id === l.id) : null;
      if (avant0 && signaturePlanLigne(l) === signaturePlanLigne(ligneDepuisElement(avant0))) { finaux.push({ l, base: avant0, avant: avant0, inchange: true }); continue; }
      if (!l.date) return err(`${lib} : indique la date (pour retirer un élément déjà planifié, utilise ✎ dans la fiche planning).`, l.key);
      const base = { id: l.id || uid(), dossierId: c.id, type: l.type, date: l.date, note: String(l.note || "").trim() };
      if (l.type === "rdm" || l.type === "pose") base.demi = l.demi || "matin";
      if (l.type === "debit") {
        const machines = Object.entries(l.machines || {}).map(([id, h]) => ({ id, heures: nombreOuZero(h) })).filter((m) => m.heures > 0);
        if (!machines.length) return err("Débit : choisis au moins une débiteuse et ses heures.", l.key);
        base.machines = machines;
      }
      if (l.type === "finition") {
        if (!(nombreOuZero(l.finisseurs) > 0) || !(nombreOuZero(l.heures) > 0)) return err("Finition : indique le nombre de finisseurs et les heures.", l.key);
        base.finisseurs = nombreOuZero(l.finisseurs); base.heures = nombreOuZero(l.heures);
      }
      if (l.type === "pose") {
        if (!(nombreOuZero(l.poseurs) > 0)) return err("Pose : indique le nombre de poseurs.", l.key);
        base.poseurs = Math.round(nombreOuZero(l.poseurs));
      }
      const avant = l.id ? (P.items || []).find((x) => x.id === l.id) : null;
      if (avant && l.date > avant.date && !String(l.raison || "").trim()) return err(`${lib} repoussé${l.type === "finition" || l.type === "pose" ? "e" : ""} : indique la raison du report.`, l.key);
      finaux.push({ l, base, avant });
    }
    if (!finaux.length) return err("Rien à planifier : indique au moins une date.");
    // Ordre RDM → débit → finition → pose sur l'ensemble (le même jour est accepté).
    const ids = new Set(finaux.map((x) => x.base.id));
    const tous = [...(P.items || []).filter((x) => x.dossierId === c.id && !ids.has(x.id)), ...finaux.map((x) => x.base)];
    const dates = (types) => tous.filter((x) => types.includes(x.type)).map((x) => x.date).sort();
    const rdmMax = dates(["rdm"]).slice(-1)[0], debMin = dates(["debit"])[0], debMax = dates(["debit"]).slice(-1)[0], finMax = dates(["finition"]).slice(-1)[0], finMin = dates(["finition"])[0];
    const prodMin = dates(["debit", "finition"])[0], prodMax = dates(["debit", "finition"]).slice(-1)[0], poseMin = dates(["pose"])[0];
    const fautive = (types, cond) => finaux.find((x) => types.includes(x.base.type) && cond(x.base.date)) || finaux.find((x) => types.includes(x.base.type));
    if (rdmMax && prodMin && prodMin < rdmMax) return err(`La production ne peut pas être avant le RDM (${formatDate(rdmMax)}).`, (fautive(["debit", "finition"], (d) => d < rdmMax) || {}).l?.key);
    if (debMin && finMin && finMin < debMin) return err(`La finition ne peut pas être avant le débit (${formatDate(debMin)}).`, (fautive(["finition"], (d) => d < debMin) || {}).l?.key);
    if (debMax && finMax && debMax > finMax) return err(`Le débit ne peut pas être après la finition (${formatDate(finMax)}).`, (fautive(["debit"], (d) => d > finMax) || {}).l?.key);
    if (prodMax && poseMin && poseMin < prodMax) return err(`La pose ne peut pas être avant la fin de la production (${formatDate(prodMax)}).`, (fautive(["pose"], (d) => d < prodMax) || {}).l?.key);
    if (!prodMax && rdmMax && poseMin && poseMin < rdmMax) return err(`La pose ne peut pas être avant le RDM (${formatDate(rdmMax)}).`, (fautive(["pose"], (d) => d < rdmMax) || {}).l?.key);
    // Enregistrement unique (seules les lignes nouvelles ou modifiées sont écrites).
    const modifs = finaux.filter((x) => !x.inchange);
    if (!modifs.length) { setPlanDossierEdit(null); setNotice("Planning du dossier : aucune modification."); return; }
    const maintenant = new Date().toISOString();
    const notifs = [];
    let items = [...(P.items || [])];
    modifs.forEach(({ l, base, avant }) => {
      const repousse = avant && l.date > avant.date;
      const item = { ...(avant || {}), ...base, historique: [...((avant && avant.historique) || []), ...(avant && (avant.date !== l.date || (avant.demi || "") !== (base.demi || "")) ? [{ le: maintenant, par: user.nom, de: `${avant.date}${avant.demi ? ` ${avant.demi}` : ""}`, vers: `${l.date}${base.demi ? ` ${base.demi}` : ""}`, raison: String(l.raison || "").trim() }] : [])], ...(avant ? { modifiePar: user.nom, modifieLe: maintenant } : { creePar: user.nom, creeLe: maintenant }) };
      if (avant && avant.type === "rdm" && repousse) item.fait = false;
      if (repousse) {
        const eng = (P.engagements || {})[c.id];
        const depasse = l.type === "pose" && eng && eng.date && l.date > eng.date;
        notifs.push(notifPlan(c, "retard", `${depasse ? "⚠ Engagement client dépassé — " : ""}${TYPES_PLAN[l.type].lib} repoussé${l.type === "finition" || l.type === "pose" ? "e" : ""} — ${libDossierPlan(c)}`, `du ${formatDate(avant.date)} au ${formatDate(l.date)} : ${String(l.raison).trim()}${depasse ? ` (date engagée : ${formatDate(eng.date)})` : ""}`, l.type === "rdm", true));
      }
      notifs.push(...notifsChangementPlan(c, avant, item));
      items = avant ? items.map((x) => (x.id === item.id ? item : x)) : [...items, item];
    });
    const next = { ...P, items, notifs: [...(P.notifs || []), ...notifs] };
    await persistPlanning(next);
    const avecPose = modifs.some((x) => x.base.type === "pose");
    if (avecPose) await lierPosePlan(c, next);
    await tracerAcces("planning du dossier", `${libDossierPlan(c)} — ${modifs.map((x) => `${TYPES_PLAN[x.base.type].lib} ${formatDate(x.base.date)}`).join(", ")}`);
    setPlanDossierEdit(null);
    // Avertissements, une seule fois à la fin.
    const avert = [];
    if (avecPose && dossierTransfo(c) && !sansFinitionDossier(c) && !items.some((x) => x.dossierId === c.id && x.type === "finition")) avert.push(`Aucune finition n'est planifiée avant la pose. Planifie-la, ou coche « Sans finition » dans la fiche planning du dossier si c'est un débit seul.`);
    if (avecPose) {
      const msg = alerteRegroupement(c, items);
      if (msg) avert.push(msg);
      modifs.filter((x) => x.base.type === "pose").forEach(({ base }) => {
        const chg = chargePlan(base.date);
        const pres = poseursPresents(base.date);
        const max = Math.max(base.demi !== "apresmidi" ? chg.pose.matin : 0, base.demi !== "matin" ? chg.pose.apresmidi : 0);
        if (max > pres) avert.push(`${max} poseurs prévus le ${formatDate(base.date)} pour ${String(pres).replace(".", ",")} présent(s).`);
      });
    }
    if (avert.length) await demander(`Planning enregistré.\n\n${avert.map((a) => `• ${a}`).join("\n")}`, { info: true });
    else setNotice(`Planning enregistré : ${modifs.length} élément(s) pour ${libDossierPlan(c)}.`);
  }
  async function supprimerElementPlan(it) {
    if (!peutPlanifier || !(await demander(`Supprimer ${TYPES_PLAN[it.type].lib} du ${formatDate(it.date)} ?`))) return;
    const P = planningRef.current || planning;
    const cSup = dossierParId(it.dossierId);
    const nSup = notifCommercialPlan(cSup, it, "supprimé", `était prévu${it.type === "finition" || it.type === "pose" ? "e" : ""} le ${quandPlan(it)}`);
    await persistPlanning({ ...P, items: (P.items || []).filter((x) => x.id !== it.id), notifs: [...(P.notifs || []), ...(nSup ? [nSup] : [])] });
    setPlanEdit(null);
  }
  async function marquerRdmFait(it, fait) {
    if (!peutPlanifier && !qui(P_POSE).includes(user.id)) return;
    const P = planningRef.current || planning;
    await persistPlanning({ ...P, items: (P.items || []).map((x) => (x.id === it.id ? { ...x, fait, faitLe: fait ? new Date().toISOString() : "", faitPar: fait ? user.nom : "" } : x)) });
  }
  async function basculerProdTerminee(c) {
    if (!peutPlanifier) return;
    const P = planningRef.current || planning;
    const pt = { ...(P.prodTerminee || {}) };
    if (pt[c.id]) delete pt[c.id]; else pt[c.id] = { le: new Date().toISOString(), par: user.nom };
    await persistPlanning({ ...P, prodTerminee: pt });
  }
  // Nils 13/10 : cas rare d'un débit seul — la finition n'est alors ni demandée ni attendue.
  async function basculerSansFinition(c) {
    if (!peutPlanifier) return;
    const P = planningRef.current || planning;
    const sf = { ...(P.sansFinition || {}) };
    if (sf[c.id]) delete sf[c.id]; else sf[c.id] = { le: new Date().toISOString(), par: user.nom };
    await persistPlanning({ ...P, sansFinition: sf });
  }
  function sansFinitionDossier(c) {
    return !!((planning && planning.sansFinition) || {})[c.id];
  }
  // Production planifiée = débit + finition (sauf « sans finition ») pour un dossier avec façonnage.
  function productionPlanifiee(c, its) {
    const l = its || itemsPlan(c.id);
    return l.some((x) => x.type === "debit") && (sansFinitionDossier(c) || l.some((x) => x.type === "finition"));
  }
  async function majEngagement(c, date) {
    if (!peutPlanifier) return;
    const P = planningRef.current || planning;
    const e = { ...(P.engagements || {}) };
    if (date) e[c.id] = { date, par: user.nom, le: new Date().toISOString() }; else delete e[c.id];
    await persistPlanning({ ...P, engagements: e });
    await tracerAcces("engagement client", `${libDossierPlan(c)} — ${date ? formatDate(date) : "retiré"}`);
  }
  async function envoyerAlertePlan() {
    const f = planNotifEdit;
    if (!f) return;
    const c = dossierParId(f.dossierId);
    if (!c) { setNotice("Choisis le dossier."); return; }
    if (!String(f.message || "").trim()) { setNotice("Écris le message."); return; }
    // Nils 09/10 : destinataires supplémentaires choisis dans la fenêtre.
    const pour = [...new Set([...destinatairesAlertePlan(c), ...(f.extra || [])])].filter((id) => id !== user.id);
    if (!pour.length) { setNotice("Aucun autre destinataire pour ce dossier."); return; }
    const P = planningRef.current || planning;
    await persistPlanning({ ...P, notifs: [...(P.notifs || []), { id: uid(), type: "message", dossierId: c.id, texte: `📣 Planning — ${libDossierPlan(c)}`, detail: `${String(f.message).trim()} (${user.nom})`, pour, vus: {}, le: new Date().toISOString(), par: user.nom }] });
    setPlanNotifEdit(null);
    setNotice(`Alerte envoyée à ${pour.map((id) => nomUtilisateur(id)).join(", ")}.`);
  }
  // 📣 : commercial du dossier + Nils (+ Ahmed quand c'est Nils qui écrit), sans l'auteur.
  function destinatairesAlertePlan(c) {
    if (!c) return [];
    const ids = [commercialDuDossierPlan(c), ...qui(P_GERANT)];
    if (user.profil === P_GERANT || !qui(P_PROD).includes(user.id)) ids.push(...qui(P_PROD));
    return [...new Set(ids.filter(Boolean))].filter((id) => id !== user.id && utilisateurs.some((u) => u.id === id && u.actif));
  }
  async function marquerNotifPlanVue(id) {
    const P = planningRef.current || planning;
    await persistPlanning({ ...P, notifs: (P.notifs || []).map((n) => (n.id === id ? { ...n, vus: { ...(n.vus || {}), [user.id]: new Date().toISOString() } } : n)) });
  }
  // Retards détectés à l'ouverture : RDM non fait, production non terminée à la date prévue (une fois chacun).
  const retardsPlanRef = useRef(false);
  useEffect(() => {
    if (loading || retardsPlanRef.current || !planning || commandesListe === null || !Array.isArray(staff)) return;
    retardsPlanRef.current = true;
    const auj = new Date().toISOString().slice(0, 10);
    const P = planning;
    const env = { ...(P.alertesEnvoyees || {}) };
    const notifs = [];
    (P.items || []).filter((x) => x.type === "rdm" && !x.fait && x.date < auj).forEach((x) => {
      const k = `rdm|${x.id}|${x.date}`;
      if (env[k]) return;
      const c = dossierParId(x.dossierId);
      if (!c) return;
      env[k] = auj;
      notifs.push(notifPlan(c, "retard", `RDM non fait — ${libDossierPlan(c)}`, `prévu le ${formatDate(x.date)} (${(DEMIS_PLAN.find((d) => d[0] === x.demi) || [, ""])[1].toLowerCase()})`, true, false));
    });
    const parDossier = {};
    (P.items || []).filter((x) => x.type === "debit" || x.type === "finition").forEach((x) => { if (!parDossier[x.dossierId] || x.date > parDossier[x.dossierId]) parDossier[x.dossierId] = x.date; });
    Object.entries(parDossier).forEach(([id, d]) => {
      if (d >= auj || (P.prodTerminee || {})[id]) return;
      const k = `prod|${id}|${d}`;
      if (env[k]) return;
      const c = dossierParId(id);
      if (!c) return;
      env[k] = auj;
      const eng = (P.engagements || {})[id];
      notifs.push(notifPlan(c, "retard", `Production en retard — ${libDossierPlan(c)}`, `non terminée au ${formatDate(d)}${eng ? ` · engagement client le ${formatDate(eng.date)}` : ""}`, false, false));
    });
    if (!notifs.length) return;
    (async () => { await persistPlanning({ ...(planningRef.current || P), alertesEnvoyees: env, notifs: [...((planningRef.current || P).notifs || []), ...notifs] }); })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, planning, commandesListe, staff]);
  function texteElementPlan(x) {
    const demi = x.demi ? (DEMIS_PLAN.find((d) => d[0] === x.demi) || [, ""])[1].toLowerCase() : "";
    const h = (v) => `${String(v).replace(".", ",")} h`;
    if (x.type === "rdm") return `RDM · ${demi}${x.fait ? " ✓" : ""}`;
    if (x.type === "debit") return `Débit · ${(x.machines || []).length ? x.machines.map((m) => `${((affectations || []).find((a) => a.id === m.id) || {}).nom || "?"} ${h(m.heures)}`).join(", ") : "débiteuse à choisir"}`;
    if (x.type === "finition") return `Finition · ${x.finisseurs} × ${h(x.heures)}`;
    return `Pose · ${demi} · ${x.poseurs} p.`;
  }
  function ouvrirElementPlan(x) {
    setPlanEdit({ ...x, machines: Object.fromEntries((x.machines || []).map((m) => [m.id, String(m.heures)])), finisseurs: String(x.finisseurs ?? ""), heures: String(x.heures ?? ""), poseurs: String(x.poseurs ?? ""), raison: "", erreur: "" });
  }
  function aPlanifierListe() {
    const idx = (st) => STATUTS_COMMANDE.indexOf(st);
    const out = [];
    (commandesListe || []).filter((c) => !c.anterieure && idx(c.statut) >= 0 && idx(c.statut) <= idx("PL")).forEach((c) => {
      const its = itemsPlan(c.id);
      // ERP step 16 (Nils 12/10) : « RDM à planifier » seulement pour un dossier avec un article de RDM.
      const avecRDM = dossierAvecRDM(c);
      const rdmFait = !avecRDM || its.some((x) => x.type === "rdm" && x.fait) || idx(c.statut) >= idx("RDM");
      if (c.statut === "BDC" && avecRDM && !its.some((x) => x.type === "rdm")) out.push({ c, type: "rdm", lib: "RDM à planifier" });
      else if (rdmFait && dossierTransfo(c) && !its.some((x) => x.type === "debit" || x.type === "finition")) out.push({ c, type: "debit", lib: "Production à planifier" });
      // Nils 13/10 : débit et finition tous deux attendus (sauf « sans finition »).
      else if (rdmFait && dossierTransfo(c) && !its.some((x) => x.type === "debit")) out.push({ c, type: "debit", lib: "Débit à planifier" });
      else if (rdmFait && dossierTransfo(c) && !sansFinitionDossier(c) && !its.some((x) => x.type === "finition")) out.push({ c, type: "finition", lib: "Finition à planifier" });
      else if (dossierPose(c) && !its.some((x) => x.type === "pose") && (its.some((x) => x.type === "debit" || x.type === "finition") || idx(c.statut) >= idx("PL"))) out.push({ c, type: "pose", lib: "Pose à planifier" });
    });
    return out;
  }
  function renderPlanning() {
    const auj = todayISO();
    const jours = Array.from({ length: 6 }, (_, i) => decalerJours(planLundi, i));
    const its = itemsPlan().filter((x) => x.date >= jours[0] && x.date <= jours[5]);
    const ids = [...new Set(its.map((x) => x.dossierId))];
    const lignes = ids.map((id) => dossierParId(id)).filter(Boolean).sort((a, b) => String(a.numero).localeCompare(String(b.numero)));
    const debs = debiteusesPlan();
    const aPlanifier = aPlanifierListe();
    const JS = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
    const th = { fontSize: 11, color: TAUPE, textAlign: "left", padding: "6px 6px", borderBottom: `1px solid ${PIERRE}`, whiteSpace: "nowrap" };
    const td = { padding: "4px 4px", borderBottom: `1px solid ${PIERRE}`, borderLeft: `1px solid ${PIERRE}`, verticalAlign: "top", minWidth: 120 };
    const horsEngagement = (x) => { const e = x.type === "pose" && (planning.engagements || {})[x.dossierId]; return !!(e && e.date && x.date > e.date); };
    const chip = (x) => (
      <div key={x.id} onClick={() => (peutPlanifier ? ouvrirElementPlan(x) : setPlanDossier(x.dossierId))} title={[x.note, ...(x.historique || []).map((h) => `${formatDate(h.de.slice(0, 10))} → ${formatDate(h.vers.slice(0, 10))}${h.raison ? ` : ${h.raison}` : ""}`)].filter(Boolean).join("\n")} style={{ background: TYPES_PLAN[x.type].coul, borderRadius: 5, padding: "3px 6px", fontSize: 11, marginBottom: 3, cursor: "pointer", fontWeight: 600, color: (x.type === "rdm" && !x.fait && x.date < auj) || horsEngagement(x) ? ROUILLE : ENCRE, border: (x.historique || []).length ? `1px dashed ${OCRE}` : "none" }}>{horsEngagement(x) ? "⚠ " : ""}{texteElementPlan(x)}</div>
    );
    return (
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 14 }}>
          <button type="button" className="sc-btn" onClick={() => setPlanLundi(decalerJours(planLundi, -7))} style={ghostBtnStyle}>‹</button>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 24, fontWeight: 600 }}>Semaine du {formatDate(jours[0])}</div>
          <button type="button" className="sc-btn" onClick={() => setPlanLundi(decalerJours(planLundi, 7))} style={ghostBtnStyle}>›</button>
          <button type="button" className="sc-btn" onClick={() => setPlanLundi(lundiDe(auj))} style={{ ...ghostBtnStyle, fontSize: 12 }}>Aujourd'hui</button>
          <span style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
            {peutPlanifier && <button type="button" className="sc-btn" onClick={() => setPlanNotifEdit({ dossierId: "", message: "" })} style={ghostBtnStyle}>📣 Envoyer une alerte</button>}
            {peutPlanifier && <button type="button" className="sc-btn" onClick={() => setPlanEdit({ ...nouvelElementPlan("rdm", "", jours.includes(auj) ? auj : jours[0]), erreur: "" })} style={primaryBtnStyle}>+ Planifier</button>}
          </span>
        </div>
        <div style={{ display: "flex", gap: 16, alignItems: "flex-start", flexWrap: "wrap" }}>
          <div style={{ flex: 1, minWidth: 700, background: "#fff", borderRadius: 10, overflowX: "auto" }}>
            <table style={{ borderCollapse: "collapse", width: "100%" }}>
              <thead><tr><th style={{ ...th, minWidth: 190 }}>Dossier</th>{jours.map((d, i) => <th key={d} style={{ ...th, borderLeft: `1px solid ${PIERRE}`, background: d === auj ? "#F5EFE0" : "transparent" }}>{JS[i]} {d.slice(8, 10)}/{d.slice(5, 7)}</th>)}</tr></thead>
              <tbody>
                {!lignes.length && <tr><td colSpan={7} style={{ padding: 16, color: TAUPE, fontSize: 13 }}>Rien de planifié cette semaine.</td></tr>}
                {lignes.map((c) => {
                  const eng = (planning.engagements || {})[c.id];
                  const manq = ["rdm", "debit", "pose"].some((t) => itemsPlan(c.id).some((x) => (x.type === t || (t === "debit" && x.type === "finition")) && x.date >= auj) && manquantsPlan(c, t).length);
                  const pt = (planning.prodTerminee || {})[c.id];
                  return (
                    <tr key={c.id}>
                      <td style={{ ...td, borderLeft: "none", cursor: "pointer" }} onClick={() => setPlanDossier(c.id)}>
                        <div style={{ fontSize: 12, fontWeight: 700 }}>{numeroStadeDossier(c)}{manq && <span title="Éléments manquants" style={{ display: "inline-block", width: 8, height: 8, borderRadius: 4, background: OCRE, marginLeft: 6 }} />}</div>
                        <div style={{ fontSize: 11, color: TAUPE }}>{(clientDe(c.clientId) || {}).nom || ""}{refDossierPlan(c) ? <> · <b style={{ color: ENCRE }}>{refDossierPlan(c)}</b></> : ""}</div>
                        <div style={{ fontSize: 11, color: TAUPE }}>SC : {nomUtilisateur(commercialDuDossierPlan(c)) || "—"}{commercialClientPlan(c) ? ` · client : ${commercialClientPlan(c)}` : ""}</div>
                        {eng && <div style={{ fontSize: 10, color: ROUILLE, fontWeight: 700 }}>🤝 engagement {formatDate(eng.date)}</div>}
                        {pt && <div style={{ fontSize: 10, color: VERT_OK }}>✓ production terminée</div>}
                        {sansFinitionDossier(c) && <div style={{ fontSize: 10, color: TAUPE }}>sans finition</div>}
                      </td>
                      {jours.map((d) => <td key={d} style={{ ...td, background: d === auj ? "#FBF8F1" : "transparent" }}>{its.filter((x) => x.dossierId === c.id && x.date === d).sort((a, b) => Object.keys(TYPES_PLAN).indexOf(a.type) - Object.keys(TYPES_PLAN).indexOf(b.type)).map(chip)}</td>)}
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <td style={{ ...td, borderLeft: "none", fontSize: 11, color: TAUPE, fontWeight: 600 }}>Charge du jour</td>
                  {jours.map((d) => {
                    const ch = chargePlan(d), capD = capaciteDebiteuse(d), capF = capaciteFinition(d), pp = poseursPresents(d);
                    const l = (txt, rouge) => <div style={{ fontSize: 10, color: rouge ? ROUILLE : TAUPE, fontWeight: rouge ? 700 : 400 }}>{txt}</div>;
                    const fh = (v) => String(Math.round(v * 10) / 10).replace(".", ",");
                    return (
                      <td key={d} style={{ ...td, background: PIERRE }}>
                        {debs.map((m) => l(`${m.nom} : ${fh(ch.deb[m.id] || 0)}/${fh(capD)} h`, (ch.deb[m.id] || 0) > capD))}
                        {l(`Finition : ${fh(ch.fin)}/${fh(capF)} h`, ch.fin > capF)}
                        {l(`Poseurs : ${ch.pose.matin}·${ch.pose.apresmidi} / ${fh(pp)}`, Math.max(ch.pose.matin, ch.pose.apresmidi) > pp)}
                        {l(`RDM : ${ch.rdm}`)}
                      </td>
                    );
                  })}
                </tr>
              </tfoot>
            </table>
          </div>
          <div style={{ width: 280, background: "#fff", borderRadius: 10, padding: 12 }}>
            <div style={{ fontSize: 12, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 8 }}>À planifier — {aPlanifier.length}</div>
            {!aPlanifier.length && <div style={{ fontSize: 12, color: TAUPE }}>Rien.</div>}
            {aPlanifier.map((a) => (
              <div key={a.c.id + a.type} onClick={() => (peutPlanifier ? ouvrirPlanDossier(a.c) : setPlanDossier(a.c.id))} style={{ fontSize: 12, padding: "6px 8px", borderRadius: 6, background: PIERRE, marginBottom: 5, cursor: "pointer" }}>
                <b>{numeroStadeDossier(a.c)}</b> — {(clientDe(a.c.clientId) || {}).nom || ""}
                <div style={{ fontSize: 11, color: OCRE }}>{a.lib}</div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ fontSize: 11, color: TAUPE, marginTop: 8, lineHeight: 1.5 }}>Charge : heures planifiées / capacité (débiteuse = horaire usine du jour ; finition = heures dues des finisseurs présents — poste « finisseur » sur la fiche Staff ; poseurs = matin · après-midi / poseurs présents). Indicatif, sans blocage. Pastille orange = éléments manquants dans le dossier. Cadre pointillé = date déjà déplacée (survol : historique).</div>
      </div>
    );
  }
  function renderModalesPlanning() {
    const auj = todayISO();
    return (
      <>
        {planEdit && peutPlanifier && (() => {
          const f = planEdit;
          const set = (patch) => setPlanEdit({ ...f, ...patch, erreur: "" });
          const c = dossierParId(f.dossierId);
          const avant = f.id ? itemsPlan().find((x) => x.id === f.id) : null;
          const repousse = avant && f.date > avant.date;
          const dossiers = (commandesListe || []).filter((x) => !x.anterieure && x.statut !== "Facture").sort((a, b) => String(b.numero).localeCompare(String(a.numero)));
          const ch = chargePlan(f.date, f.id);
          const capD = capaciteDebiteuse(f.date), capF = capaciteFinition(f.date), pp = poseursPresents(f.date);
          const manq = c ? manquantsPlan(c, f.type) : [];
          const fh = (v) => String(Math.round(v * 10) / 10).replace(".", ",");
          const libre = (v, cap) => <span style={{ fontSize: 12, color: cap - v < 0 ? ROUILLE : VERT_OK, fontWeight: 600 }}>{fh(cap - v)} h libres sur {fh(cap)}</span>;
          return (
            <Overlay onClose={() => setPlanEdit(null)} zIndex={1450}>
              <div style={{ ...modalStyle(680), maxHeight: "90vh", overflowY: "auto" }}>
                <div style={modalTitleStyle}>{f.id ? "Modifier le planning" : "Planifier"}</div>
                <Field label="Dossier">
                  <select className="sc-select" value={f.dossierId} disabled={!!f.id} onChange={(e) => set({ dossierId: e.target.value })} style={{ ...selectStyle, width: "100%" }}>
                    <option value="">— Dossier —</option>
                    {dossiers.map((x) => (<option key={x.id} value={x.id}>{libDossierPlan(x)} ({x.statut})</option>))}
                  </select>
                </Field>
                <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
                  {Object.entries(TYPES_PLAN).map(([k, t]) => (
                    <button key={k} type="button" className="sc-btn" disabled={!!f.id} onClick={() => set({ type: k })} style={{ padding: "6px 14px", borderRadius: 16, fontSize: 12, fontWeight: 600, background: f.type === k ? ENCRE : t.coul, color: f.type === k ? PIERRE : ENCRE, opacity: f.id && f.type !== k ? 0.4 : 1 }}>{t.lib}</button>
                  ))}
                </div>
                {c && !!manq.length && (
                  <div style={{ background: "#FFF6E5", border: `1px solid ${OCRE}`, borderRadius: 8, padding: "8px 12px", marginBottom: 10, fontSize: 12 }}>
                    <b style={{ color: OCRE }}>Manque encore dans le dossier pour {TYPES_PLAN[f.type].lib.toLowerCase()} :</b>
                    <ul style={{ margin: "4px 0 0 18px", padding: 0 }}>{manq.map((m, i) => <li key={i}>{m}</li>)}</ul>
                  </div>
                )}
                {c && !manq.length && <div style={{ fontSize: 12, color: VERT_OK, marginBottom: 10 }}>✓ Rien ne manque dans le dossier pour cette étape.</div>}
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end" }}>
                  <Field label="Date" style={{ marginBottom: 0 }}><input type="date" className="sc-input" value={f.date} onChange={(e) => set({ date: e.target.value })} style={inputStyle(150)} /></Field>
                  {(f.type === "rdm" || f.type === "pose") && (
                    <Field label="Moment" style={{ marginBottom: 0 }}>
                      <select className="sc-select" value={f.demi} onChange={(e) => set({ demi: e.target.value })} style={{ ...selectStyle, width: 140 }}>{DEMIS_PLAN.map(([k, l]) => (<option key={k} value={k}>{l}</option>))}</select>
                    </Field>
                  )}
                  {f.type === "pose" && <Field label="Poseurs" style={{ marginBottom: 0 }}><input type="number" min="1" className="sc-input" value={f.poseurs} onChange={(e) => set({ poseurs: e.target.value })} style={inputStyle(80)} /></Field>}
                  {f.type === "finition" && <Field label="Finisseurs" style={{ marginBottom: 0 }}><input type="number" min="1" className="sc-input" value={f.finisseurs} onChange={(e) => set({ finisseurs: e.target.value })} style={inputStyle(80)} /></Field>}
                  {f.type === "finition" && <Field label="Heures (par finisseur)" style={{ marginBottom: 0 }}><input type="number" min="0" step="0.5" className="sc-input" value={f.heures} onChange={(e) => set({ heures: e.target.value })} style={inputStyle(90)} /></Field>}
                </div>
                {f.type === "debit" && (
                  <div style={{ marginTop: 10 }}>
                    {!debiteusesPlan().length && <div style={{ fontSize: 12, color: ROUILLE }}>Aucune machine « Débiteuse » (Véhicules et machines / Stock › Machines).</div>}
                    {debiteusesPlan().map((m) => (
                      <div key={m.id} style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 6 }}>
                        <span style={{ width: 120, fontSize: 13 }}>{m.nom}</span>
                        <input type="number" min="0" step="0.5" className="sc-input" placeholder="heures" value={(f.machines || {})[m.id] || ""} onChange={(e) => set({ machines: { ...(f.machines || {}), [m.id]: e.target.value } })} style={{ ...inputStyle(80), padding: "5px 6px" }} /> h
                        {libre((ch.deb[m.id] || 0) + nombreOuZero((f.machines || {})[m.id]), capD)}
                      </div>
                    ))}
                  </div>
                )}
                {f.type === "finition" && <div style={{ marginTop: 8 }}>Finisseurs ce jour-là : {libre(ch.fin + nombreOuZero(f.finisseurs) * nombreOuZero(f.heures), capF)} <span style={{ fontSize: 11, color: TAUPE }}>({finisseursPlan().length} finisseur(s) sur les fiches Staff)</span></div>}
                {f.type === "pose" && (() => { const m = (f.demi !== "apresmidi" ? ch.pose.matin : 0) + (f.demi !== "apresmidi" ? nombreOuZero(f.poseurs) : 0); const a = (f.demi !== "matin" ? ch.pose.apresmidi + nombreOuZero(f.poseurs) : 0); const max = Math.max(m, a); return <div style={{ marginTop: 8, fontSize: 12, color: max > pp ? ROUILLE : VERT_OK, fontWeight: 600 }}>{max} poseur(s) prévus sur ce moment pour {String(pp).replace(".", ",")} présent(s){max > pp ? " — pas assez de poseurs" : ""}</div>; })()}
                {f.type === "rdm" && <div style={{ marginTop: 8, fontSize: 12, color: TAUPE }}>{ch.rdm} autre(s) RDM ce jour-là.</div>}
                {avant && avant.type === "rdm" && (
                  <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13, marginTop: 10 }}><input type="checkbox" checked={!!avant.fait} onChange={(e) => marquerRdmFait(avant, e.target.checked)} /> RDM fait{avant.faitPar ? ` (${avant.faitPar})` : ""}</label>
                )}
                {repousse && <Field label="Raison du report (obligatoire)" style={{ marginTop: 10 }}><input className="sc-input" value={f.raison} onChange={(e) => set({ raison: e.target.value })} style={inputStyle("100%")} /></Field>}
                <Field label="Note" style={{ marginTop: 10 }}><input className="sc-input" value={f.note || ""} onChange={(e) => set({ note: e.target.value })} style={inputStyle("100%")} /></Field>
                {!!(avant && (avant.historique || []).length) && <div style={{ fontSize: 11, color: TAUPE, marginBottom: 8 }}>Historique : {(avant.historique || []).map((h) => `${h.de} → ${h.vers}${h.raison ? ` (${h.raison})` : ""}`).join(" ; ")}</div>}
                {f.erreur && <div style={{ fontSize: 12, color: ROUILLE, marginBottom: 8 }}>{f.erreur}</div>}
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                  {avant && <button type="button" className="sc-btn" onClick={() => supprimerElementPlan(avant)} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>Supprimer</button>}
                  <button type="button" className="sc-btn" onClick={() => setPlanEdit(null)} style={ghostBtnStyle}>Annuler</button>
                  <button type="button" className="sc-btn" onClick={enregistrerElementPlan} style={primaryBtnStyle}>Enregistrer</button>
                </div>
              </div>
            </Overlay>
          );
        })()}
        {planDossierEdit && peutPlanifier && (() => {
          const F = planDossierEdit;
          const c = dossierParId(F.dossierId);
          if (!c) return null;
          const setL = (key, patch) => setPlanDossierEdit({ ...F, lignes: F.lignes.map((l) => (l.key === key ? { ...l, ...patch } : l)), erreur: "", erreurKey: "" });
          const ids = new Set(F.lignes.filter((l) => l.id).map((l) => l.id));
          const fh = (v) => String(Math.round(v * 10) / 10).replace(".", ",");
          const libre = (v, cap) => <span style={{ fontSize: 11, color: cap - v < 0 ? ROUILLE : VERT_OK, fontWeight: 600 }}>{fh(cap - v)} h libres / {fh(cap)}</span>;
          const autresLignes = (l, type) => F.lignes.filter((x) => x.key !== l.key && x.type === type && x.date === l.date);
          return (
            <Overlay onClose={() => setPlanDossierEdit(null)} zIndex={1450}>
              <div style={{ ...modalStyle(900), maxHeight: "92vh", overflowY: "auto" }}>
                <div style={modalTitleStyle}>Planifier le dossier — {libDossierPlan(c)}</div>
                <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 12 }}>Toutes les étapes du dossier en une fois. Une ligne sans date n'est pas planifiée. L'ordre RDM → débit → finition → pose est vérifié à l'enregistrement.</div>
                {F.lignes.map((l) => {
                  const avant = l.id ? itemsPlan().find((x) => x.id === l.id) : null;
                  const repousse = avant && l.date && l.date > avant.date;
                  const ch = l.date ? chargePlanSauf(l.date, ids) : null;
                  const enErreur = F.erreurKey === l.key;
                  return (
                    <div key={l.key} style={{ background: TYPES_PLAN[l.type].coul, borderRadius: 8, padding: "8px 12px", marginBottom: 8, border: enErreur ? `2px solid ${ROUILLE}` : "2px solid transparent" }}>
                      <div style={{ display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap" }}>
                        <div style={{ width: 70, fontWeight: 700, fontSize: 13, paddingBottom: 8 }}>{TYPES_PLAN[l.type].lib}{avant ? <div style={{ fontSize: 10, color: TAUPE, fontWeight: 400 }}>planifié</div> : null}</div>
                        <Field label="Date" style={{ marginBottom: 0 }}><input type="date" className="sc-input" value={l.date} onChange={(e) => setL(l.key, { date: e.target.value })} style={{ ...inputStyle(150), background: "#fff" }} /></Field>
                        {(l.type === "rdm" || l.type === "pose") && (
                          <Field label="Moment" style={{ marginBottom: 0 }}><select className="sc-select" value={l.demi} onChange={(e) => setL(l.key, { demi: e.target.value })} style={{ ...selectStyle, width: 130, background: "#fff" }}>{DEMIS_PLAN.map(([k, lb]) => (<option key={k} value={k}>{lb}</option>))}</select></Field>
                        )}
                        {l.type === "pose" && <Field label="Poseurs" style={{ marginBottom: 0 }}><input type="number" min="1" className="sc-input" value={l.poseurs} onChange={(e) => setL(l.key, { poseurs: e.target.value })} style={{ ...inputStyle(70), background: "#fff" }} /></Field>}
                        {l.type === "finition" && <Field label="Finisseurs" style={{ marginBottom: 0 }}><input type="number" min="1" className="sc-input" value={l.finisseurs} onChange={(e) => setL(l.key, { finisseurs: e.target.value })} style={{ ...inputStyle(70), background: "#fff" }} /></Field>}
                        {l.type === "finition" && <Field label="Heures / finisseur" style={{ marginBottom: 0 }}><input type="number" min="0" step="0.5" className="sc-input" value={l.heures} onChange={(e) => setL(l.key, { heures: e.target.value })} style={{ ...inputStyle(80), background: "#fff" }} /></Field>}
                        {l.type === "debit" && debiteusesPlan().map((m) => (
                          <Field key={m.id} label={m.nom} style={{ marginBottom: 0 }}>
                            <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                              <input type="number" min="0" step="0.5" className="sc-input" placeholder="h" value={(l.machines || {})[m.id] || ""} onChange={(e) => setL(l.key, { machines: { ...(l.machines || {}), [m.id]: e.target.value } })} style={{ ...inputStyle(60), background: "#fff" }} />
                              {ch && libre((ch.deb[m.id] || 0) + autresLignes(l, "debit").reduce((n, x) => n + nombreOuZero((x.machines || {})[m.id]), 0) + nombreOuZero((l.machines || {})[m.id]), capaciteDebiteuse(l.date))}
                            </div>
                          </Field>
                        ))}
                        {l.type === "debit" && !debiteusesPlan().length && <span style={{ fontSize: 12, color: ROUILLE }}>Aucune débiteuse déclarée.</span>}
                        {l.type === "finition" && ch && <div style={{ paddingBottom: 10 }}>{libre(ch.fin + autresLignes(l, "finition").reduce((n, x) => n + nombreOuZero(x.finisseurs) * nombreOuZero(x.heures), 0) + nombreOuZero(l.finisseurs) * nombreOuZero(l.heures), capaciteFinition(l.date))}</div>}
                        {l.type === "pose" && ch && (() => { const pp = poseursPresents(l.date); const prevus = (l.demi !== "apresmidi" ? ch.pose.matin : ch.pose.apresmidi) + autresLignes(l, "pose").reduce((n, x) => n + nombreOuZero(x.poseurs), 0) + nombreOuZero(l.poseurs); return <div style={{ paddingBottom: 10, fontSize: 11, fontWeight: 600, color: prevus > pp ? ROUILLE : VERT_OK }}>{prevus} prévu(s) / {String(pp).replace(".", ",")} présent(s)</div>; })()}
                        {l.type === "rdm" && ch && <div style={{ paddingBottom: 10, fontSize: 11, color: TAUPE }}>{ch.rdm} autre(s) RDM ce jour-là</div>}
                        {l.type === "pose" && !l.id && F.lignes.filter((x) => x.type === "pose").length > 1 && (
                          <button type="button" className="sc-btn" onClick={() => setPlanDossierEdit({ ...F, lignes: F.lignes.filter((x) => x.key !== l.key) })} style={{ ...iconBtnStyle, marginBottom: 6 }} title="Retirer ce jour">✕</button>
                        )}
                      </div>
                      {repousse && <Field label="Raison du report (obligatoire)" style={{ marginTop: 8, marginBottom: 0 }}><input className="sc-input" value={l.raison} onChange={(e) => setL(l.key, { raison: e.target.value })} style={{ ...inputStyle("100%"), background: "#fff" }} /></Field>}
                    </div>
                  );
                })}
                {(dossierPose(c) || F.lignes.some((l) => l.type === "pose")) && (
                  <button type="button" className="sc-btn" onClick={() => { const der = F.lignes.filter((l) => l.type === "pose").slice(-1)[0]; const nl = { ...ligneVidePlan("pose"), poseurs: der ? der.poseurs : "", demi: der ? der.demi : "journee", date: der && der.date ? decalerJours(der.date, 1) : "" }; setPlanDossierEdit({ ...F, lignes: [...F.lignes, nl] }); }} style={{ ...ghostBtnStyle, fontSize: 12 }}>+ jour de pose</button>
                )}
                {["rdm", "debit", "pose"].map((t) => { const m = manquantsPlan(c, t); return m.length ? <div key={t} style={{ fontSize: 12, color: OCRE, marginTop: 6 }}>Manque pour {t === "debit" ? "la production" : t === "rdm" ? "le RDM" : "la pose"} : {m.join(", ")}</div> : null; })}
                {F.erreur && <div style={{ fontSize: 13, color: ROUILLE, fontWeight: 600, marginTop: 10 }}>{F.erreur}</div>}
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 14 }}>
                  <button type="button" className="sc-btn" onClick={() => setPlanDossierEdit(null)} style={ghostBtnStyle}>Annuler</button>
                  <button type="button" className="sc-btn" onClick={enregistrerPlanDossier} style={primaryBtnStyle}>Enregistrer tout</button>
                </div>
              </div>
            </Overlay>
          );
        })()}
        {planDossier && !planEdit && (() => {
          const c = dossierParId(planDossier);
          if (!c) return null;
          const its = itemsPlan(c.id).sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : Object.keys(TYPES_PLAN).indexOf(a.type) - Object.keys(TYPES_PLAN).indexOf(b.type)));
          const eng = (planning.engagements || {})[c.id];
          const pt = (planning.prodTerminee || {})[c.id];
          return (
            <Overlay onClose={() => setPlanDossier(null)} zIndex={1440}>
              <div style={{ ...modalStyle(700), maxHeight: "90vh", overflowY: "auto" }}>
                <div style={modalTitleStyle}>Planning — {libDossierPlan(c)}</div>
                <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 10 }}>{c.statut}{refDossierPlan(c) ? ` · réf. ${refDossierPlan(c)}` : ""} · commercial Stone Concept : {nomUtilisateur(commercialDuDossierPlan(c)) || "—"} · commercial du client : {commercialClientPlan(c) || "non renseigné"}</div>
                <div style={{ display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap", background: PIERRE, borderRadius: 8, padding: "8px 12px", marginBottom: 12, fontSize: 13 }}>
                  <span>🤝 Date engagée avec le client :</span>
                  {peutPlanifier ? <input type="date" className="sc-input" value={eng ? eng.date : ""} onChange={(e) => majEngagement(c, e.target.value)} style={{ ...inputStyle(150), padding: "4px 6px", background: "#fff" }} /> : <b>{eng ? formatDate(eng.date) : "aucune"}</b>}
                  {eng && <span style={{ fontSize: 11, color: TAUPE }}>fixée par {eng.par}</span>}
                  {dossierTransfo(c) && <label style={{ display: "flex", gap: 6, alignItems: "center", marginLeft: "auto" }} title="Cas rare : débit seul, sans finition"><input type="checkbox" checked={sansFinitionDossier(c)} disabled={!peutPlanifier} onChange={() => basculerSansFinition(c)} /> Sans finition</label>}
                  <label style={{ display: "flex", gap: 6, alignItems: "center", marginLeft: dossierTransfo(c) ? 0 : "auto" }}><input type="checkbox" checked={!!pt} disabled={!peutPlanifier} onChange={() => basculerProdTerminee(c)} /> Production terminée{pt ? ` (${pt.par}, ${formatDate(pt.le.slice(0, 10))})` : ""}</label>
                </div>
                {!its.length && <div style={{ fontSize: 13, color: TAUPE, marginBottom: 10 }}>Rien de planifié.</div>}
                {its.map((x) => (
                  <div key={x.id} style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 13, padding: "6px 10px", borderRadius: 6, background: TYPES_PLAN[x.type].coul, marginBottom: 5 }}>
                    <span style={{ width: 90 }}>{formatDate(x.date)}</span>
                    <b style={{ flex: 1 }}>{texteElementPlan(x)}</b>
                    {x.type === "rdm" && x.date < auj && !x.fait && <span style={{ color: ROUILLE, fontSize: 12, fontWeight: 700 }}>non fait</span>}
                    {!!(x.historique || []).length && <span style={{ fontSize: 11, color: OCRE }} title={(x.historique || []).map((h) => `${h.de} → ${h.vers}${h.raison ? ` : ${h.raison}` : ""}`).join("\n")}>déplacé ×{x.historique.length}</span>}
                    {peutPlanifier && <button type="button" className="sc-btn" onClick={() => ouvrirElementPlan(x)} style={iconBtnStyle}>✎</button>}
                  </div>
                ))}
                {["rdm", "debit", "pose"].map((t) => { const m = manquantsPlan(c, t); return m.length ? <div key={t} style={{ fontSize: 12, color: OCRE, marginTop: 6 }}>Manque pour {t === "debit" ? "la production" : t === "rdm" ? "le RDM" : "la pose"} : {m.join(", ")}</div> : null; })}
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 14, flexWrap: "wrap" }}>
                  {peutPlanifier && <button type="button" className="sc-btn" onClick={() => setPlanNotifEdit({ dossierId: c.id, message: "" })} style={{ ...ghostBtnStyle, marginRight: "auto" }}>📣 Envoyer une alerte</button>}
                  <button type="button" className="sc-btn" onClick={() => { setPlanDossier(null); ouvrirLienAlerte({ kind: "commande", id: c.id }); }} style={ghostBtnStyle}>Ouvrir le dossier</button>
                  <button type="button" className="sc-btn" onClick={() => setPlanDossier(null)} style={ghostBtnStyle}>Fermer</button>
                  {peutPlanifier && <button type="button" className="sc-btn" onClick={() => setPlanEdit({ ...nouvelElementPlan("rdm", c.id, auj), erreur: "" })} style={ghostBtnStyle}>+ Un élément</button>}
                  {peutPlanifier && <button type="button" className="sc-btn" onClick={() => ouvrirPlanDossier(c)} style={primaryBtnStyle}>Planifier le dossier</button>}
                </div>
              </div>
            </Overlay>
          );
        })()}
        {planNotifEdit && (() => {
          const f = planNotifEdit;
          const c = dossierParId(f.dossierId);
          const dossiers = (commandesListe || []).filter((x) => !x.anterieure && x.statut !== "Facture").sort((a, b) => String(b.numero).localeCompare(String(a.numero)));
          return (
            <Overlay onClose={() => setPlanNotifEdit(null)} zIndex={1470}>
              <div style={modalStyle(520)}>
                <div style={modalTitleStyle}>📣 Envoyer une alerte</div>
                <Field label="Dossier">
                  <select className="sc-select" value={f.dossierId} onChange={(e) => setPlanNotifEdit({ ...f, dossierId: e.target.value })} style={{ ...selectStyle, width: "100%" }}>
                    <option value="">— Dossier —</option>
                    {dossiers.map((x) => (<option key={x.id} value={x.id}>{libDossierPlan(x)}</option>))}
                  </select>
                </Field>
                <div style={{ fontSize: 12, color: TAUPE, marginBottom: 6 }}>À : {c ? destinatairesAlertePlan(c).map((id) => nomUtilisateur(id)).join(", ") || "—" : "commercial du dossier et le Gérant"}</div>
                {(() => {
                  const auto = c ? destinatairesAlertePlan(c) : [];
                  const extra = f.extra || [];
                  const dispo = utilisateurs.filter((u) => u.actif && u.id !== user.id && !auto.includes(u.id) && !extra.includes(u.id)).sort((a, b) => a.nom.localeCompare(b.nom, "fr"));
                  return (
                    <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center", marginBottom: 10 }}>
                      {extra.map((id) => (<span key={id} style={{ fontSize: 12, background: PIERRE, borderRadius: 12, padding: "3px 10px" }}>+ {nomUtilisateur(id)} <button type="button" className="sc-btn" onClick={() => setPlanNotifEdit({ ...f, extra: extra.filter((x) => x !== id) })} style={{ ...iconBtnStyle, width: 16, height: 16, fontSize: 11 }}>✕</button></span>))}
                      {dispo.length > 0 && (
                        <select className="sc-select" aria-label="Ajouter une personne à l'alerte" value="" onChange={(e) => e.target.value && setPlanNotifEdit({ ...f, extra: [...extra, e.target.value] })} style={{ ...selectStyle, width: "auto", padding: "4px 8px", fontSize: 12, background: "#fff" }}>
                          <option value="">+ Ajouter une personne…</option>
                          {dispo.map((u) => <option key={u.id} value={u.id}>{u.nom}</option>)}
                        </select>
                      )}
                    </div>
                  );
                })()}
                <Field label="Message"><textarea className="sc-input" value={f.message} onChange={(e) => setPlanNotifEdit({ ...f, message: e.target.value })} rows={4} style={{ ...inputStyle("100%"), resize: "vertical" }} /></Field>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                  <button type="button" className="sc-btn" onClick={() => setPlanNotifEdit(null)} style={ghostBtnStyle}>Annuler</button>
                  <button type="button" className="sc-btn" onClick={envoyerAlertePlan} style={primaryBtnStyle}>Envoyer</button>
                </div>
              </div>
            </Overlay>
          );
        })()}
      </>
    );
  }
  // ---------- ERP step 14 (aj) : commissions — Nils seul ----------
  // Nils 17/10 : règle « selon le client » (Com1) — taux « client directionnel » (case de la fiche client,
  // ou client suivi par le Gérant) ou « client non directionnel », pour les clients des commerciaux de la
  // règle. Ancien format (taux par commercial) : le taux du Gérant vaut taux directionnel.
  function regleClientNormalisee(r) {
    if (r.tauxDirectionnel !== undefined || !r.tauxParCommercial) return { ...r, clientsDe: r.clientsDe || [] };
    const ids = Object.keys(r.tauxParCommercial);
    const gerantId = ids.find((id) => estCompteGerant(id));
    const autre = ids.find((id) => id !== gerantId);
    return { ...r, clientsDe: ids, tauxDirectionnel: gerantId ? r.tauxParCommercial[gerantId] : "", tauxNonDirectionnel: autre ? r.tauxParCommercial[autre] : "" };
  }
  function estCompteGerant(id) {
    return ((utilisateurs || []).find((u) => u.id === id) || {}).profil === P_GERANT;
  }
  // Taux Com1 d'un dossier (commercial du devis, client facturé) ; null si la règle ne le concerne pas.
  function tauxRegleClient(r, commercial, clientId) {
    const n = regleClientNormalisee(r);
    if (!n.clientsDe.includes(commercial)) return null;
    const directionnel = estCompteGerant(commercial) || !!(clientDe(clientId) || {}).clientDirectionnel;
    return nombreOuZero(directionnel ? n.tauxDirectionnel : n.tauxNonDirectionnel);
  }
  function versionCommissionAu(dateISO) {
    const vs = [...((commissions && commissions.versions) || [])].sort((a, b) => (a.dateEffet < b.dateEffet ? 1 : -1));
    return vs.find((v) => v.dateEffet <= dateISO) || vs[vs.length - 1] || DEFAULT_COMMISSIONS.versions[0];
  }
  // Mouvements d'encaissement d'un dossier (encaissements, remboursements, crédits affectés), datés.
  function mouvementsEncaissement(id) {
    const m = [];
    (operations || []).filter((o) => o.poste === POSTE_ENCAISSEMENT).forEach((o) => partsDossiers(o).filter((x) => x.dossierId === id).forEach((x) => m.push({ date: o.date, montant: (o.sens === "entree" ? 1 : -1) * x.montant })));
    (affectationsCredit || []).forEach((a) => { if (a.vers === id) m.push({ date: a.date, montant: Number(a.montant) || 0 }); if (a.de === id) m.push({ date: a.date, montant: -(Number(a.montant) || 0) }); });
    return m.sort((a, b) => (a.date < b.date ? -1 : 1));
  }
  // Nils 05/10 : l'apporteur d'un devis est soit un apporteur d'affaires externe (« app:Nom »), soit un
  // commercial interne indiqué comme apporteur, soit — devis sans apporteur — le commercial du client.
  function apporteurEffectif(d) {
    const a = String((d && d.apporteurAffaire) || "").trim();
    if (!a) return idCommercialDuDevis(d);
    const u = utilisateurs.find((x) => normLib(x.nom) === normLib(a));
    return u ? u.id : `app:${a}`;
  }
  // Créneau d'une règle : un dossier ne se commissionne qu'une fois par créneau (« apport » =
  // commission de l'apporteur ou du vendeur apporteur ; « client:… » = règle selon le client, ex. Com1).
  function creneauRegle(regle) {
    return regle.type === "client" ? `client:${regle.id}` : "apport";
  }
  // Dossiers déjà figés (validés) dans un créneau, hors une clé donnée.
  function dossiersDejaCommissionnes(creneau, saufCle) {
    const m = {};
    Object.entries((commissions && commissions.validations) || {}).forEach(([k, v]) => {
      if (k === saufCle || (v.creneau || "") !== creneau) return;
      (v.dossiers || []).forEach((id) => { m[id] = { cle: k, nom: v.nom || k.split("|")[0], libelle: v.libelle || "" }; });
    });
    return m;
  }
  // Dossiers entièrement encaissés, avec la date du solde et les lignes commissionnables.
  function dossiersSoldes() {
    const out = [];
    (commandesListe || []).forEach((c) => {
      const d = devisDuDossier(c);
      if (!d) return;
      const ttc = totalDossierTTC(c);
      if (!(ttc > 0) || encaisseDossier(c.id) < ttc - 0.01) return;
      let cumul = 0, dateSolde = "";
      for (const mv of mouvementsEncaissement(c.id)) { cumul += mv.montant; if (cumul >= ttc - 0.01) { dateSolde = mv.date; break; } }
      if (!dateSolde) return;
      const lignes = lignesDuDossier(c).filter((l) => l.type !== "descriptif").map((l) => {
        const art = l.articleId ? (articles || []).find((a) => a.id === l.articleId) : null;
        return { designation: l.designation, ht: calcLigne(l).montantHT, remise: Number(l.remise) || 0, exclue: !!(art && art.exclureCommission) };
      });
      const base = lignes.filter((l) => !l.exclue).reduce((n, l) => n + l.ht, 0);
      out.push({ c, d, dateSolde, commercial: idCommercialDuDevis(d), apporteur: apporteurEffectif(d), lignes, base, exo: !!d.exonereTVA });
    });
    return out;
  }
  // Seuil (Nils 08/10) : CA HT TOTAL des commandes ENTIÈREMENT encaissées dont le solde tombe dans la
  // période, sur les clients de certains commerciaux. Une avance de mars soldée en juin compte toute en juin ;
  // une commande pas encore soldée ne compte pas. Même liste de commandes que la base des commissions.
  function encaisseHTPeriode(per, commerciaux, soldes) {
    const [deb, fin] = bornesPeriode(per);
    return (soldes || dossiersSoldes())
      .filter((x) => x.dateSolde >= deb && x.dateSolde <= fin && commerciaux.includes(x.commercial))
      .reduce((n, x) => n + totalDossierTTC(x.c) / (x.exo ? 1 : 1 + TVA_TAUX), 0);
  }
  // Commission d'une règle sur une période.
  function calculRegleCommission(regle, per, soldes, cle, filtreApporteur) {
    const [deb, fin] = bornesPeriode(per);
    const deja = dossiersDejaCommissionnes(creneauRegle(regle), cle);
    const exclus = [];
    const dans = (soldes || dossiersSoldes()).filter((x) => x.dateSolde >= deb && x.dateSolde <= fin);
    const lignes = [];
    const garder = (x) => { if (deja[x.c.id]) { exclus.push({ x, deja: deja[x.c.id] }); return false; } return true; };
    if (regle.type === "remise") {
      // Nils 05/10 : commission du vendeur seulement s'il est l'apporteur du devis (pas d'apporteur externe).
      dans.filter((x) => (regle.clientsDe || []).includes(x.apporteur)).filter(garder).forEach((x) => {
        const m = x.lignes.filter((l) => !l.exclue).reduce((n, l) => n + l.ht * tauxPalier(regle.paliers, l.remise) / 100, 0);
        lignes.push({ x, base: x.base, montant: m, taux: x.base ? (m / x.base) * 100 : 0 });
      });
    } else if (regle.type === "client") {
      dans.filter((x) => tauxRegleClient(regle, x.commercial, x.c.clientId) !== null).filter(garder).forEach((x) => {
        const taux = tauxRegleClient(regle, x.commercial, x.c.clientId);
        lignes.push({ x, base: x.base, montant: x.base * taux / 100, taux });
      });
    } else if (regle.type === "apporteur") {
      dans.filter((x) => String(x.apporteur || "").startsWith("app:") && (!filtreApporteur || x.apporteur === `app:${filtreApporteur}`)).filter(garder).forEach((x) => {
        const taux = nombreOuZero(x.d.tauxApporteur);
        lignes.push({ x, base: x.base, montant: x.base * taux / 100, taux, apporteur: x.d.apporteurAffaire, sansTaux: String(x.d.tauxApporteur ?? "").trim() === "" });
      });
    }
    const brut = lignes.reduce((n, l) => n + l.montant, 0);
    let coef = 1, seuilInfo = null;
    if (regle.seuil && nombreOuZero(regle.seuil.montant) > 0) {
      const enc = encaisseHTPeriode(per, regle.seuil.clientsDe || [], soldes);
      const s = nombreOuZero(regle.seuil.montant);
      coef = enc >= s ? (regle.seuil.mode === "dessus" ? (enc - s) / enc : 1) : 0;
      seuilInfo = { enc, seuil: s, atteint: enc >= s };
    }
    lignes.forEach((l) => { l.montant *= coef; });
    return { lignes, total: brut * coef, seuilInfo, exclus };
  }
  function cleValidationCom(personneId, regleId, per) {
    return `${personneId}|${regleId}|${per}`;
  }
  async function validerCommission(personne, regle, per, total, calc) {
    const k = cleValidationCom(personne.id, regle.id, per);
    await persistCommissions({ ...commissions, validations: { ...(commissions.validations || {}), [k]: { montant: Math.round(total * 100) / 100, nom: personne.nom, libelle: regle.libelle, per, personneId: personne.id, creneau: creneauRegle(regle), dossiers: ((calc && calc.lignes) || []).filter((l) => l.montant > 0).map((l) => l.x.c.id), par: user.nom, le: new Date().toISOString() } } });
    await tracerAcces("commission validée", `${personne.nom} — ${regle.libelle} — ${libPeriode(per)} : ${formatDH(total)}`);
  }
  function sourcesClient() {
    const l = parametres && parametres.sourcesClient;
    return Array.isArray(l) && l.length ? l : DEFAULT_SOURCES_CLIENT;
  }
  function budgetMarketing() {
    return { ...DEFAULT_MARKETING_BUDGET, ...((parametres && parametres.budgetMarketing) || {}) };
  }
  // Budget marketing du mois : X % du CA HT des commandes entièrement payées (mois du solde) des clients venus par une source marketing.
  function calculBudgetMarketing(ym, soldes) {
    const bm = budgetMarketing();
    const [deb, fin] = bornesPeriode(ym);
    const lignes = (soldes || dossiersSoldes()).filter((x) => x.dateSolde >= deb && x.dateSolde <= fin && bm.sources.includes((clientDe(x.c.clientId) || {}).source)).map((x) => {
      const base = calcTotaux(x.d).totalHT;
      return { x, base, montant: base * nombreOuZero(bm.taux) / 100 };
    });
    const timesheetMois = personnesMarketing().reduce((n, u) => n + totauxMoisMkt(u.id, ym).montant, 0);
    const depenses = (operations || []).filter((o) => o.poste === "Marketing" && o.sousPoste === "Community management" && o.date >= deb && o.date <= fin && !o.miroirDe).reduce((n, o) => n + (o.sens === "sortie" ? 1 : -1) * (Number(o.montant) || 0), 0);
    return { lignes, base: lignes.reduce((n, l) => n + l.base, 0), total: lignes.reduce((n, l) => n + l.montant, 0), timesheetMois, depenses, taux: nombreOuZero(bm.taux) };
  }
  // Nils 05/10 : le budget marketing s'accumule ; les dépenses consomment les crédits les plus anciens ;
  // un crédit non dépensé disparaît au bout de 12 mois (crédit de janvier utilisable jusqu'en décembre).
  function soldeBudgetMarketing(ymFin, soldes) {
    const so = soldes || dossiersSoldes();
    const bm = budgetMarketing();
    const debutMois = [
      ...so.filter((x) => bm.sources.includes((clientDe(x.c.clientId) || {}).source)).map((x) => x.dateSolde.slice(0, 7)),
      ...(operations || []).filter((o) => o.poste === "Marketing" && o.sousPoste === "Community management" && !o.miroirDe).map((o) => String(o.date).slice(0, 7)),
    ].filter(Boolean).sort()[0];
    if (!debutMois || debutMois > ymFin) return { solde: 0, lots: [], expires: 0, deficit: 0, expireBientot: 0, mois: [] };
    let lots = [], expires = 0, deficit = 0;
    const mois = [];
    for (let m = debutMois; m <= ymFin; m = moisDecale(m, 1)) {
      // Expiration : crédits de plus de 12 mois.
      lots = lots.filter((l) => { if (moisDecale(l.mois, 12) <= m) { expires += l.restant; return false; } return true; });
      const credit = calculBudgetMarketing(m, so).total;
      let restantCredit = credit;
      if (deficit > 0) { const u = Math.min(deficit, restantCredit); deficit -= u; restantCredit -= u; }
      if (restantCredit > 0) lots.push({ mois: m, credit, restant: restantCredit });
      const [deb, fin] = bornesPeriode(m);
      let dep = (operations || []).filter((o) => o.poste === "Marketing" && o.sousPoste === "Community management" && o.date >= deb && o.date <= fin && !o.miroirDe).reduce((n, o) => n + (o.sens === "sortie" ? 1 : -1) * (Number(o.montant) || 0), 0);
      const depMois = dep;
      for (const l of lots) { if (dep <= 0) break; const u = Math.min(l.restant, dep); l.restant -= u; dep -= u; }
      lots = lots.filter((l) => l.restant > 0.005);
      if (dep > 0) deficit += dep;
      mois.push({ m, credit, depense: depMois, solde: lots.reduce((n, l) => n + l.restant, 0) - deficit });
    }
    const suivant = moisDecale(ymFin, 1);
    const expireBientot = lots.filter((l) => moisDecale(l.mois, 12) <= suivant).reduce((n, l) => n + l.restant, 0);
    return { solde: lots.reduce((n, l) => n + l.restant, 0) - deficit, lots, expires, deficit, expireBientot, mois };
  }
  function apporteursExternes() {
    const noms = new Set();
    (devisListe || []).forEach((d) => { const a = apporteurEffectif(d); if (String(a || "").startsWith("app:")) noms.add(a.slice(4)); });
    return [...noms].sort((a, b) => a.localeCompare(b, "fr"));
  }
  function caissesCommission(personneId) {
    if (String(personneId).startsWith("app:")) return (commissions && commissions.caissesApporteurs) || ["caisse-nils"];
    const p = (versionCommissionAu(todayISO()).personnes || []).find((x) => x.id === personneId);
    return (p && p.caisses) || CAISSES_COMMISSION_DEFAUT[personneId] || ["caisse-nils"];
  }
  // Commissions validées et pas entièrement versées (pour le menu de la caisse).
  function commissionsMaturees(compteId, saufOpId) {
    return Object.entries((commissions && commissions.validations) || {}).map(([k, v]) => {
      const verse = (operations || []).filter((o) => o.commissionCle === k && o.id !== saufOpId).reduce((n, o) => n + (o.sens === "sortie" ? 1 : -1) * (Number(o.montant) || 0), 0);
      const personneId = v.personneId || k.split("|")[0];
      return { cle: k, nom: v.nom || personneId, libelle: v.libelle || k.split("|")[1], per: v.per || k.split("|")[2], personneId, montant: Number(v.montant) || 0, reste: Math.round(((Number(v.montant) || 0) - verse) * 100) / 100 };
    }).filter((x) => x.reste > 0.01 && (!compteId || caissesCommission(x.personneId).includes(compteId)));
  }
  function versementsCommission(k) {
    return (operations || []).filter((o) => o.commissionCle === k).reduce((n, o) => n + (o.sens === "sortie" ? 1 : -1) * (Number(o.montant) || 0), 0);
  }
  async function payerCommission() {
    const f = paiementCom;
    if (!f) return;
    const montant = nombreOuZero(f.montant);
    if (!(montant > 0)) { setNotice("Indique le montant versé."); return; }
    if (!f.compteId) { setNotice("Choisis la caisse ou la banque."); return; }
    if (!caissesCommission(f.personneId).includes(f.compteId)) { setNotice("Cette commission ne se paie pas depuis ce compte."); return; }
    if (montant > f.reste + 0.01) { setNotice(`Le montant dépasse le reste à verser (${formatDH(f.reste)}).`); return; }
    if (moisVerrouille(f.compteId, f.date)) { setNotice("Mois clôturé sur ce compte."); return; }
    const estStaff = (staff || []).some((x) => normLib(x.nom) === normLib(f.nom));
    const op = { id: uid(), compteId: f.compteId, date: f.date, sens: "sortie", montant, type: "normal", poste: "Commissions", sousPoste: "Commissions versées", designation: `Commission ${f.libelle} — ${libPeriode(f.per)} — ${f.nom}`, tiersType: estStaff ? "employe" : "", tiers: f.nom, mode: f.mode || "Virement", piece: "", commissionCle: f.cle, par: user.nom, le: new Date().toISOString() };
    await persistOperations([...(operations || []), op]);
    await tracerAcces("commission versée", `${f.nom} — ${f.libelle} — ${libPeriode(f.per)} : ${formatDH(montant)} (${(compteDe(f.compteId) || {}).nom || ""})`);
    setPaiementCom(null);
    setNotice(`Versement de ${formatDH(montant)} enregistré en trésorerie (${(compteDe(f.compteId) || {}).nom || ""}, poste Commissions).`);
  }
  async function devaliderCommission(personne, regle, per) {
    if (Math.abs(versementsCommission(cleValidationCom(personne.id, regle.id, per))) > 0.01) { setNotice("Des versements existent pour cette commission : supprime-les d'abord en trésorerie pour la rouvrir."); return; }
    const v = { ...(commissions.validations || {}) };
    delete v[cleValidationCom(personne.id, regle.id, per)];
    await persistCommissions({ ...commissions, validations: v });
    await tracerAcces("commission rouverte", `${personne.nom} — ${regle.libelle} — ${libPeriode(per)}`);
  }
  async function majVersionCommission(id, patch) {
    await persistCommissions({ ...commissions, versions: commissions.versions.map((v) => (v.id === id ? { ...v, ...patch } : v)) });
  }
  async function nouvelleVersionCommission(base) {
    const date = await demander("Date d'effet de la nouvelle version (AAAA-MM-JJ) :", { saisie: true, valeur: todayISO() });
    if (!date || !/^\d{4}-\d{2}-\d{2}$/.test(date)) return;
    if (commissions.versions.some((v) => v.dateEffet === date)) { setNotice("Une version existe déjà à cette date."); return; }
    const nv = { ...JSON.parse(JSON.stringify(base)), id: uid(), dateEffet: date };
    await persistCommissions({ ...commissions, versions: [...commissions.versions, nv] });
    setComVersionId(nv.id);
    await tracerAcces("barème de commissions", `nouvelle version au ${formatDate(date)}`);
  }
  async function exporterCommissions(per, resultats) {
    let XLSX;
    try { XLSX = await chargerSheetJS(); } catch (e) { setNotice(e.message); return; }
    const rows = [["Personne", "Règle", "Période", "Dossier", "Client", "Soldé le", "Base HT", "Taux moyen %", "Commission"]];
    resultats.forEach((r) => r.calc.lignes.forEach((l) => rows.push([r.personne.nom, r.regle.libelle, libPeriode(r.per), l.x.c.numeroFacture || l.x.c.numeroBL || l.x.c.numero, (clientDe(l.x.c.clientId) || {}).nom || "", formatDate(l.x.dateSolde), Math.round(l.base * 100) / 100, Math.round(l.taux * 100) / 100, Math.round(l.montant * 100) / 100])));
    const ws = XLSX.utils.aoa_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Commissions");
    await proposerTelechargement(`Commissions-${per}.xlsx`, XLSX.write(wb, { bookType: "xlsx", type: "array" }));
  }
  // Nils 09/10 : Commissions = onglet de la rubrique Gestion (avant : section de Prix et coûts).
  // Nils 10/10 (10:33) : budget community management dans l'onglet Community management (mensuel cumulé, inchangé) ;
  // visible par le Gérant et le compte Marketing, détail des dossiers / clients compris (transparence).
  function renderBudgetCM(ym) {
    const soldes = dossiersSoldes();
    const bm = calculBudgetMarketing(ym, soldes);
    const sb = soldeBudgetMarketing(ym, soldes);
    const douze = sb.mois.slice(-12);
    const ouvert = budgetCMOuvert;
    const regles = budgetMarketing();
    return (
      <div style={{ background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 14, marginBottom: 16 }}>
        <div style={{ fontSize: 12, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 10 }}>Budget community management — {libPeriode(ym)}</div>
        <div style={{ display: "flex", gap: 14, flexWrap: "wrap", alignItems: "baseline", fontSize: 13 }}>
          <span>crédit du mois : {formatDH(bm.base)} × {String(bm.taux).replace(".", ",")} % = <b>{formatDH(bm.total)}</b></span>
          <span>dépensé ce mois : <b>{formatDH(bm.depenses)}</b></span>
          <span style={{ color: sb.solde >= 0 ? VERT_OK : ROUILLE, fontWeight: 700 }}>disponible fin {libPeriode(ym)} : {formatDH(sb.solde)}</span>
          {sb.expireBientot > 0.01 && <span style={{ color: OCRE }}>dont {formatDH(sb.expireBientot)} perdus le mois prochain s'ils ne sont pas dépensés</span>}
        </div>
        <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>12 derniers mois : crédits {formatDH(douze.reduce((n, x) => n + x.credit, 0))} · dépensé {formatDH(douze.reduce((n, x) => n + x.depense, 0))} · crédits expirés depuis le début {formatDH(sb.expires)}{estGerant ? ` · time sheet de ${libPeriode(ym)} ${formatDH(bm.timesheetMois)} (pour info : compté quand il est payé en trésorerie)` : ""}</div>
        {!!douze.length && (
          <table style={{ borderCollapse: "collapse", marginTop: 8, fontSize: 12 }}>
            <thead><tr>{["Mois", "Crédit", "Dépensé", "Disponible fin de mois"].map((h, i) => <th key={h} style={{ fontSize: 10, color: TAUPE, textAlign: i ? "right" : "left", padding: "3px 10px" }}>{h}</th>)}</tr></thead>
            <tbody>{douze.map((x) => (<tr key={x.m}><td style={{ padding: "2px 10px" }}>{libPeriode(x.m)}</td><td style={{ padding: "2px 10px", textAlign: "right" }}>{formatDH(x.credit)}</td><td style={{ padding: "2px 10px", textAlign: "right" }}>{formatDH(x.depense)}</td><td style={{ padding: "2px 10px", textAlign: "right", fontWeight: 600, color: x.solde >= 0 ? ENCRE : ROUILLE }}>{formatDH(x.solde)}</td></tr>))}</tbody>
          </table>
        )}
        <div onClick={() => setBudgetCMOuvert(!ouvert)} style={{ fontSize: 12, fontWeight: 600, cursor: "pointer", marginTop: 10 }}>{ouvert ? "▾" : "▸"} Dossiers qui ont généré le crédit de {libPeriode(ym)} ({bm.lignes.length})</div>
        {ouvert && (
          <div style={{ marginTop: 6 }}>
            {!bm.lignes.length ? <div style={{ fontSize: 12, color: TAUPE }}>Aucun dossier soldé ce mois pour des clients venus par : {regles.sources.join(", ")}.</div> : bm.lignes.map((l) => (
              <div key={l.x.c.id} style={{ fontSize: 12, display: "flex", gap: 12, padding: "3px 0", borderBottom: `1px solid ${PIERRE}` }}>
                <span style={{ width: 120 }}>{l.x.c.numeroFacture || l.x.c.numero}</span>
                <span style={{ flex: 1 }}>{(clientDe(l.x.c.clientId) || {}).nom || ""} — source {(clientDe(l.x.c.clientId) || {}).source}</span>
                <span>soldé le {formatDate(l.x.dateSolde)}</span>
                <span style={{ width: 120, textAlign: "right" }}>CA HT {formatDH(l.base)}</span>
                <span style={{ width: 110, textAlign: "right", fontWeight: 600 }}>{formatDH(l.montant)}</span>
              </div>
            ))}
          </div>
        )}
        <div style={{ fontSize: 11, color: TAUPE, marginTop: 8, lineHeight: 1.5 }}>
          <b>Comment un client entre dans le calcul :</b> sur la fiche client, la « Source — comment le client nous a connus » est l'une de : {regles.sources.join(", ")} (un prospect transformé en client garde sa source). Le dossier compte le mois où il est <b>entièrement payé</b> (dernier encaissement), pour {String(regles.taux).replace(".", ",")} % de son CA HT.<br />
          Le budget s'accumule mois après mois ; chaque dépense saisie en trésorerie au sous-poste Marketing › Community management consomme d'abord les crédits les plus anciens ; un crédit non dépensé disparaît au bout de 12 mois. C'est un budget, pas un versement.{estGerant ? " Taux et sources : Paramétrage › « Budget community management »." : ""}
        </div>
      </div>
    );
  }
  function renderCommissions(pleinePage) {
    const ouvertC = !!pleinePage || !!ouvertC;
    const carte = { background: "#fff", border: `1px solid ${OCRE}`, borderRadius: 10, padding: 16, marginBottom: 20 };
    const versions = [...(commissions.versions || [])].sort((a, b) => (a.dateEffet < b.dateEffet ? -1 : 1));
    const ver = versions.find((v) => v.id === comVersionId) || versionCommissionAu(todayISO());
    const nomU = (id) => (utilisateurs.find((u) => u.id === id) || {}).nom || id;
    const num = (v, set, w) => <input type="number" step="0.1" className="sc-input" value={v ?? ""} onChange={(e) => set(e.target.value)} style={{ ...inputStyle(w || 70), padding: "4px 6px", textAlign: "right" }} />;
    const setRegle = (pid, rid, patch) => majVersionCommission(ver.id, { personnes: ver.personnes.map((p) => (p.id !== pid ? p : { ...p, regles: p.regles.map((r) => (r.id === rid ? { ...r, ...patch } : r)) })) });
    const setPers = (pid, patch) => majVersionCommission(ver.id, { personnes: ver.personnes.map((p) => (p.id === pid ? { ...p, ...patch } : p)) });
    // Tableau : le mois choisi (règles mensuelles) et son trimestre (règles trimestrielles) ; apporteurs mensuels.
    const soldes = dossiersSoldes();
    const resultats = [];
    ver.personnes.forEach((personne) => personne.regles.forEach((regle) => {
      const per = periodeDe(`${comMois}-01`, regle.periode);
      const vAu = versionCommissionAu(bornesPeriode(per)[0]);
      const pV = (vAu.personnes || []).find((x) => x.id === personne.id);
      const rV = pV && pV.regles.find((x) => x.id === regle.id);
      if (!rV) return;
      resultats.push({ personne, regle: rV, per, calc: calculRegleCommission(rV, per, soldes, cleValidationCom(personne.id, rV.id, per)) });
    }));
    // Apporteurs d'affaires externes : une ligne par apporteur cité sur au moins un devis (même à 0).
    const regleApporteurs = { id: "apporteurs", libelle: "Apporteur d'affaires", type: "apporteur", periode: "mois" };
    const nomsApp = new Set(apporteursExternes());
    Object.values(commissions.validations || {}).forEach((v) => { if (String(v.personneId || "").startsWith("app:") && v.per === comMois) nomsApp.add(v.personneId.slice(4)); });
    [...nomsApp].sort((a, b) => a.localeCompare(b, "fr")).forEach((nom) => {
      const per = comMois;
      resultats.push({ personne: { id: `app:${nom}`, nom }, regle: regleApporteurs, per, calc: calculRegleCommission(regleApporteurs, per, soldes, cleValidationCom(`app:${nom}`, "apporteurs", per), nom) });
    });
    const th = { fontSize: 10, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.4, textAlign: "right", padding: "6px 8px", borderBottom: `1px solid ${PIERRE}`, whiteSpace: "nowrap" };
    const td = { fontSize: 12, textAlign: "right", padding: "6px 8px", borderBottom: `1px solid ${PIERRE}`, whiteSpace: "nowrap" };
    return (
      <div style={carte}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: ouvertC ? 12 : 0 }}>
          {pleinePage ? <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, fontWeight: 600 }}>Commissions <span style={{ fontSize: 13, fontFamily: "inherit", color: TAUPE, fontWeight: 400 }}>barèmes et tableau mensuel</span></div> : titrePC("commissions", "Commissions", "barèmes et tableau mensuel")}
        </div>
        {ouvertC && (<>
          <div style={{ fontSize: 11, color: TAUPE, marginBottom: 12, lineHeight: 1.5 }}>Une commission n'est due que sur une commande <b>entièrement encaissée</b> : elle tombe dans la période (mois / trimestre) du dernier encaissement. Rien si le client ne paie qu'une partie. Taux « selon la remise » : remise de chaque ligne du devis. Lignes d'articles « Exclure des commissions » hors base. Base = HT (ventes exo comprises). Seuil : CA HT total des commandes entièrement encaissées dont le solde tombe dans la période, sur les clients indiqués (avances comprises, comptées au mois du solde ; commandes non soldées exclues).</div>

          <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
            <span style={{ fontSize: 12, fontWeight: 600 }}>Tableau du mois</span>
            <input type="month" className="sc-input" value={comMois} onChange={(e) => e.target.value && setComMois(e.target.value)} style={{ ...inputStyle(160), padding: "5px 8px" }} />
            <span style={{ fontSize: 11, color: TAUPE }}>(règles trimestrielles : {libPeriode(periodeDe(`${comMois}-01`, "trimestre"))})</span>
            <button type="button" className="sc-btn" onClick={() => exporterCommissions(comMois, resultats)} style={{ ...ghostBtnStyle, marginLeft: "auto", fontSize: 12 }}>⬇ Export Excel</button>
          </div>
          <table style={{ borderCollapse: "collapse", width: "100%", minWidth: 720, marginBottom: 6 }}>
            <thead><tr>{["Personne", "Règle", "Période", "Dossiers soldés", "Base HT", "Commission", "Seuil", "Versé", "État", ""].map((h, i) => <th key={h + i} style={{ ...th, textAlign: i < 3 ? "left" : "right" }}>{h}</th>)}</tr></thead>
            <tbody>
              {resultats.map((r) => {
                const k = cleValidationCom(r.personne.id, r.regle.id, r.per);
                const val = (commissions.validations || {})[k];
                const base = r.calc.lignes.reduce((n, l) => n + l.base, 0);
                const ouvert = comDetail === k;
                const verse = versementsCommission(k);
                const du = val ? val.montant : r.calc.total;
                const etat = !val ? { lib: "à valider", c: OCRE } : verse >= du - 0.01 ? { lib: du > 0 ? "versée" : "rien à verser", c: VERT_OK } : verse > 0.01 ? { lib: `reste ${formatDH(du - verse)}`, c: OCRE } : { lib: "validée — à verser", c: ROUILLE };
                return (
                  <React.Fragment key={k}>
                    <tr onClick={() => setComDetail(ouvert ? "" : k)} style={{ cursor: "pointer" }}>
                      <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>{ouvert ? "▾ " : "▸ "}{r.personne.nom}</td>
                      <td style={{ ...td, textAlign: "left" }}>{r.regle.libelle}</td>
                      <td style={{ ...td, textAlign: "left" }}>{libPeriode(r.per)}</td>
                      <td style={td}>{r.calc.lignes.length}</td>
                      <td style={td}>{formatDH(base)}</td>
                      <td style={{ ...td, fontWeight: 700 }}>{formatDH(val ? val.montant : r.calc.total)}{val && Math.abs(val.montant - r.calc.total) > 0.01 ? <div style={{ fontSize: 10, color: ROUILLE }}>recalcul : {formatDH(r.calc.total)}</div> : null}</td>
                      <td style={{ ...td, color: r.calc.seuilInfo ? (r.calc.seuilInfo.atteint ? VERT_OK : ROUILLE) : TAUPE }}>{r.calc.seuilInfo ? `${formatDH(r.calc.seuilInfo.enc)} / ${formatDH(r.calc.seuilInfo.seuil)}` : "—"}</td>
                      <td style={td}>{verse ? formatDH(verse) : "—"}</td>
                      <td style={{ ...td, color: etat.c, fontWeight: 600 }}>{etat.lib}</td>
                      <td style={td} onClick={(e) => e.stopPropagation()}>
                        {!val && <button type="button" className="sc-btn" onClick={() => validerCommission(r.personne, r.regle, r.per, r.calc.total, r.calc)} style={{ ...primaryBtnStyle, fontSize: 11, padding: "3px 8px" }}>Valider</button>}
                        {val && du - verse > 0.01 && <button type="button" className="sc-btn" onClick={() => setPaiementCom({ cle: k, personneId: r.personne.id, nom: r.personne.nom, libelle: r.regle.libelle, per: r.per, reste: Math.round((du - verse) * 100) / 100, montant: String(Math.round((du - verse) * 100) / 100), date: todayISO(), compteId: caissesCommission(r.personne.id)[0] || "", mode: "Espèces" })} style={{ ...primaryBtnStyle, fontSize: 11, padding: "3px 8px", marginRight: 4 }}>Verser…</button>}
                        {val && <button type="button" className="sc-btn" onClick={() => devaliderCommission(r.personne, r.regle, r.per)} style={{ ...ghostBtnStyle, fontSize: 11, padding: "2px 6px" }}>Rouvrir</button>}
                      </td>
                    </tr>
                    {ouvert && (
                      <tr><td colSpan={10} style={{ background: PIERRE, padding: "6px 10px" }}>
                        {!!(r.calc.exclus || []).length && <div style={{ fontSize: 11, color: OCRE, marginBottom: 4 }}>Déjà commissionné ailleurs (non repris, pas de double paiement) : {r.calc.exclus.map((e) => `${e.x.c.numeroFacture || e.x.c.numero} → ${e.deja.nom}${e.deja.libelle ? ` (${e.deja.libelle})` : ""}`).join(" ; ")}</div>}
                        {!r.calc.lignes.length ? <div style={{ fontSize: 12, color: TAUPE }}>Aucun dossier soldé sur la période.</div> : (
                          <table style={{ borderCollapse: "collapse", width: "100%" }}>
                            <tbody>
                              {r.calc.lignes.map((l) => (
                                <tr key={l.x.c.id}>
                                  <td style={{ ...td, textAlign: "left" }}>{l.x.c.numeroFacture || l.x.c.numeroBL || l.x.c.numero}</td>
                                  <td style={{ ...td, textAlign: "left" }}>{(clientDe(l.x.c.clientId) || {}).nom || ""}{l.x.d.reference ? ` — ${l.x.d.reference}` : ""}</td>
                                  <td style={td}>soldé le {formatDate(l.x.dateSolde)}</td>
                                  <td style={td}>{formatDH(l.base)}</td>
                                  <td style={td}>{l.sansTaux ? <span style={{ color: ROUILLE }}>taux à fixer sur le devis</span> : `${String(Math.round(l.taux * 100) / 100).replace(".", ",")} %`}</td>
                                  <td style={{ ...td, fontWeight: 600 }}>{formatDH(l.montant)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </td></tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
          <div style={{ fontSize: 11, color: TAUPE, marginBottom: 16 }}>Clique sur une ligne pour voir le détail par dossier. « Valider » fige le montant (un recalcul différent est signalé) ; « Verser… » enregistre le paiement en trésorerie (poste Commissions › Commissions versées), relié à cette commission — la colonne Versé et l'état se mettent à jour. Pour rouvrir une commission déjà versée, supprime d'abord le versement en trésorerie.</div>

          <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 8 }}>
            <span style={{ fontSize: 12, fontWeight: 600 }}>Barèmes</span>
            <select className="sc-select" value={ver.id} onChange={(e) => setComVersionId(e.target.value)} style={{ ...selectStyle, width: "auto" }}>
              {versions.map((v) => (<option key={v.id} value={v.id}>en vigueur à partir du {formatDate(v.dateEffet)}</option>))}
            </select>
            <button type="button" className="sc-btn" onClick={() => nouvelleVersionCommission(ver)} style={{ ...ghostBtnStyle, fontSize: 12 }}>+ Nouvelle version (date d'effet)…</button>
          </div>
          <div style={{ fontSize: 11, color: TAUPE, marginBottom: 8 }}>Modifier une version change le calcul de toutes ses périodes non validées ; pour un changement de règle, crée une nouvelle version datée.</div>
          {ver.personnes.map((pers) => (
            <div key={pers.id} style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: 12, marginBottom: 12 }}>
              <div style={{ display: "flex", alignItems: "baseline", gap: 12, flexWrap: "wrap", marginBottom: 8 }}>
                <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 19, fontWeight: 600 }}>{pers.nom}</span>
                <span style={{ fontSize: 12, color: TAUPE }}>Payée depuis : {caissesCommission(pers.id).map((id) => (compteDe(id) || {}).nom || id).join(" ou ")}</span>
                {pers.remiseMax !== undefined && <span style={{ fontSize: 12, color: TAUPE, display: "inline-flex", gap: 6, alignItems: "center" }}>Remise maximum autorisée : {num(pers.remiseMax, (v) => setPers(pers.id, { remiseMax: v }), 60)} % <span style={{ fontSize: 11 }}>(au-delà : alerte au Gérant)</span></span>}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 10 }}>
                {pers.regles.map((r) => (
                  <div key={r.id} style={{ background: PIERRE, borderRadius: 8, padding: 10 }}>
                    <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 6 }}>
                      <input className="sc-input" value={r.libelle} onChange={(e) => setRegle(pers.id, r.id, { libelle: e.target.value })} style={{ ...inputStyle(110), padding: "4px 6px", fontWeight: 700, background: "#fff" }} />
                      <select className="sc-select" value={r.periode} onChange={(e) => setRegle(pers.id, r.id, { periode: e.target.value })} style={{ ...selectStyle, width: "auto", padding: "4px 6px", background: "#fff" }}><option value="mois">calcul mensuel</option><option value="trimestre">calcul trimestriel</option></select>
                    </div>
                    <div style={{ fontSize: 12, color: TAUPE, marginBottom: 6 }}>
                      {r.type === "remise" ? <>Sur les dossiers apportés par <b style={{ color: ENCRE }}>{(r.clientsDe || []).map(nomU).join(", ")}</b> (devis sans apporteur d'affaires sur ses clients, ou {(r.clientsDe || []).map(nomU).join(", ")} indiqué comme apporteur) — taux selon la remise de chaque ligne du devis. Pas de commission si un apporteur externe est sur le devis.</> : <>Sur les dossiers des clients de <b style={{ color: ENCRE }}>{regleClientNormalisee(r).clientsDe.map(nomU).join(" et ")}</b> — taux selon que le client est directionnel ou non.</>}
                    </div>
                    <table style={{ borderCollapse: "collapse", width: "100%", background: "#fff", borderRadius: 6 }}>
                      <thead><tr><th style={{ ...th, textAlign: "left" }}>{r.type === "remise" ? "Remise de la ligne" : "Client"}</th><th style={th}>Commission</th></tr></thead>
                      <tbody>
                        {r.type === "remise" && (r.paliers || []).map((pa, k) => {
                          const prec = k === 0 ? 0 : r.paliers[k - 1].sous;
                          const dernier = pa.sous === null || pa.sous === "";
                          return (
                            <tr key={k}>
                              <td style={{ ...td, textAlign: "left" }}>
                                {dernier ? <>{prec} % et plus</> : <span style={{ display: "inline-flex", gap: 4, alignItems: "center" }}>de {prec} % à moins de {num(pa.sous, (v) => setRegle(pers.id, r.id, { paliers: r.paliers.map((x, q) => (q === k ? { ...x, sous: v } : x)) }), 56)} %</span>}
                              </td>
                              <td style={td}><span style={{ display: "inline-flex", gap: 4, alignItems: "center" }}>{num(pa.taux, (v) => setRegle(pers.id, r.id, { paliers: r.paliers.map((x, q) => (q === k ? { ...x, taux: v } : x)) }), 56)} %</span></td>
                            </tr>
                          );
                        })}
                        {r.type === "client" && (() => {
                          const n = regleClientNormalisee(r);
                          const maj = (champ) => (v) => setRegle(pers.id, r.id, { clientsDe: n.clientsDe, tauxDirectionnel: n.tauxDirectionnel, tauxNonDirectionnel: n.tauxNonDirectionnel, tauxParCommercial: undefined, [champ]: v });
                          return [["tauxDirectionnel", "Client directionnel (case de la fiche client, ou client du Gérant)"], ["tauxNonDirectionnel", "Client non directionnel"]].map(([champ, lib]) => (
                            <tr key={champ}>
                              <td style={{ ...td, textAlign: "left" }}>{lib}</td>
                              <td style={td}><span style={{ display: "inline-flex", gap: 4, alignItems: "center" }}>{num(n[champ], maj(champ), 56)} %</span></td>
                            </tr>
                          ));
                        })()}
                      </tbody>
                    </table>
                    {r.seuil && (
                      <div style={{ fontSize: 12, marginTop: 8, lineHeight: 1.8 }}>
                        <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}><b>Seuil</b> : {num(r.seuil.montant, (v) => setRegle(pers.id, r.id, { seuil: { ...r.seuil, montant: v } }), 110)} DH HT de commandes soldées par {r.periode === "trimestre" ? "trimestre" : "mois"}</div>
                        <div style={{ color: TAUPE }}>calculé sur les clients de {(r.seuil.clientsDe || []).map(nomU).join(" + ")}</div>
                        <div style={{ display: "flex", gap: 6, alignItems: "center" }}>Seuil non atteint :
                          <select className="sc-select" value={r.seuil.mode || "tout"} onChange={(e) => setRegle(pers.id, r.id, { seuil: { ...r.seuil, mode: e.target.value } })} style={{ ...selectStyle, width: "auto", padding: "3px 6px", background: "#fff" }}><option value="tout">aucune commission</option><option value="dessus">commission sur la part au-dessus seulement</option></select>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
          <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: 12 }}>
            <div style={{ display: "flex", alignItems: "baseline", gap: 12, flexWrap: "wrap", marginBottom: 6 }}>
              <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 19, fontWeight: 600 }}>Apporteurs d'affaires</span>
              <span style={{ fontSize: 12, color: TAUPE }}>Payée depuis : {caissesCommission("app:").map((id) => (compteDe(id) || {}).nom || id).join(" ou ")}</span>
            </div>
            <div style={{ fontSize: 12, color: TAUPE, marginBottom: 8 }}>Taux fixé par le Gérant sur chaque devis ; dû à chaque devis où l'apporteur est mentionné, sur la base HT, une fois la commande entièrement encaissée. Un commercial interne (Taha, Soufiane Chraa) choisi comme apporteur relève de son propre barème.</div>
            {(() => {
              const liste = (devisListe || []).filter((d) => String(apporteurEffectif(d) || "").startsWith("app:") && !estHorsVueActive(d)).sort((a, b) => String(b.numero).localeCompare(String(a.numero)));
              if (!liste.length) return <div style={{ fontSize: 12, color: TAUPE }}>Aucun devis avec un apporteur externe.</div>;
              return (
                <table style={{ borderCollapse: "collapse", width: "100%", background: "#fff" }}>
                  <thead><tr>{["Devis", "Client", "Apporteur", "Montant HT", "Taux"].map((h, i) => <th key={h} style={{ ...th, textAlign: i < 3 ? "left" : "right" }}>{h}</th>)}</tr></thead>
                  <tbody>
                    {liste.map((d) => (
                      <tr key={d.id}>
                        <td style={{ ...td, textAlign: "left" }}>{d.numero}</td>
                        <td style={{ ...td, textAlign: "left" }}>{(clientDe(d.clientId) || {}).nom || ""}</td>
                        <td style={{ ...td, textAlign: "left" }}>{d.apporteurAffaire}</td>
                        <td style={td}>{formatDH(calcTotaux(d).totalHT)}</td>
                        <td style={td}><span style={{ display: "inline-flex", gap: 4, alignItems: "center" }}><input type="number" min="0" max="100" step="0.1" className="sc-input" defaultValue={d.tauxApporteur ?? ""} key={`${d.id}-${d.tauxApporteur ?? ""}`} onBlur={(e) => { const v = e.target.value; if (String(v) === String(d.tauxApporteur ?? "")) return; persistDevis((devisListe || []).map((x) => (x.id === d.id ? { ...x, tauxApporteur: v } : x))); tracerAcces("taux apporteur", `Devis ${d.numero} — ${d.apporteurAffaire} : ${v === "" ? "—" : v + " %"}`); }} style={{ ...inputStyle(70), padding: "4px 6px", textAlign: "right", borderColor: String(d.tauxApporteur ?? "") === "" ? ROUILLE : undefined }} /> %</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              );
            })()}
          </div>
        </>)}
      </div>
    );
  }
  // ---------- ERP step 14 (ai) : Calcul de revient (Grille tarifaire, Nils seul) ----------
  async function majProfilRevient(id, patch) {
    await persistCoutsRevient({ ...coutsRevient, profils: profilsRevient().map((p) => (p.id === id ? { ...p, ...patch } : p)) });
  }
  async function ajouterProfilRevient(type) {
    const id = uid();
    const p = type === "tranches"
      ? nouveauProfilTranches(id, "Nouveau profil tranches", MATIERES[0])
      : { id, type: "unitaire", nom: "Nouveau profil éviers / accessoires", fournisseur: "", devise: "EUR", taux: 10.85, prixArticles: {}, importArticles: {}, minArticles: {} };
    await persistCoutsRevient({ ...coutsRevient, profils: [...profilsRevient(), p] });
    setProfilRevientId(id);
  }
  // Nils 25/10 : copie d'un profil, fournisseur à choisir (un article prend le profil de son fournisseur
  // et de sa matière : deux profils identiques sur ce point seraient ambigus).
  async function copierProfilRevient(p) {
    const id = uid();
    const copie = { ...JSON.parse(JSON.stringify(p)), id, nom: `${p.nom} (copie)`, fournisseur: "" };
    await persistCoutsRevient({ ...coutsRevient, profils: [...profilsRevient(), copie] });
    setProfilRevientId(id);
    setNotice(`Profil copié : « ${copie.nom} ». Choisis son fournisseur.`);
  }
  // Nils 25/10 (a) : au changement de matière, les colonnes d'épaisseur suivent les épaisseurs vendues de la
  // matière ; une épaisseur commune garde ses valeurs, une nouvelle reçoit les valeurs de départ.
  async function changerMatiereProfil(p, matiere) {
    const eps = EPAISSEURS_PAR_MATIERE[matiere] || EPAISSEURS_MATIERE;
    const depart = nouveauProfilTranches(p.id, p.nom, matiere);
    const aligner = (obj, def) => Object.fromEntries(eps.map((ep) => [ep, obj && obj[ep] !== undefined ? obj[ep] : def[ep]]));
    await majProfilRevient(p.id, {
      matiere,
      prix: (p.prix || []).map((ligne, i) => aligner(ligne, depart.prix[Math.min(i, depart.prix.length - 1)])),
      surfaces: aligner(p.surfaces, depart.surfaces),
      tranchesParChevalet: aligner(p.tranchesParChevalet, depart.tranchesParChevalet),
    });
  }
  async function supprimerProfilRevient(p) {
    if (!(await demander(`Supprimer le profil « ${p.nom} » ? Les coûts standard qui en dépendent ne seront plus calculables.`))) return;
    await persistCoutsRevient({ ...coutsRevient, profils: profilsRevient().filter((x) => x.id !== p.id) });
    setProfilRevientId("");
  }
  function typologiesProfil(p) {
    const eps = Object.keys(((p.prix || [])[0]) || p.surfaces || {});
    const out = [];
    (p.groupes || []).forEach((g, gi) => eps.forEach((ep) => [1, 2].forEach((ch) => out.push({ gi, ep, ch, g }))));
    return out;
  }
  function preparerApercuGrille(p) {
    const lignes = [];
    typologiesProfil(p).forEach(({ gi, ep, ch, g }) => {
      const c = coutTrancheProfil(p, gi, ep, ch);
      const gERP = Number(g.groupeERP);
      if (!c || !GROUPES.includes(gERP)) return;
      const cle = cleCombinaisonTranche(p.matiere, ep);
      if (!COMBINAISONS_PRIX_TRANCHE.some((x) => x.cle === cle)) return;
      const nouveau = Math.round(prixVenteProfil(p, c, margeProfil(p, gi, ep, ch)).publicM2 * 100) / 100;
      const table = ch === 2 ? prixGroupesTranche2eChoix : prixGroupesTranche;
      const actuel = table && table[cle] && table[cle][gERP] != null && table[cle][gERP] !== "" ? Number(table[cle][gERP]) : null;
      lignes.push({ cle, matiere: p.matiere, ep, ch, gERP, actuel, nouveau });
    });
    // Deux groupes fournisseur envoyés vers le même groupe tarifaire : le dernier l'emporte — signalé.
    const vus = {};
    lignes.forEach((l) => { const k = `${l.cle}|${l.ch}|${l.gERP}`; l.doublon = !!vus[k]; vus[k] = true; });
    setApercuGrille({ profilId: p.id, lignes });
  }
  async function appliquerApercuGrille() {
    const a = apercuGrille;
    if (!a) return;
    const n1 = { ...prixGroupesTranche }, n2 = { ...prixGroupesTranche2eChoix };
    a.lignes.forEach((l) => {
      const t = l.ch === 2 ? n2 : n1;
      t[l.cle] = { ...(t[l.cle] || { 1: null, 2: null, 3: null, 4: null, 5: null }), [l.gERP]: l.nouveau };
    });
    await persistPrixGroupesTranche(n1);
    await persistPrixGroupesTranche2eChoix(n2);
    const p = profilsRevient().find((x) => x.id === a.profilId) || {};
    await tracerAcces("grille tarifaire appliquée", `Calcul de revient « ${p.nom || ""} » → ${a.lignes.length} prix publics au m² mis à jour`);
    setApercuGrille(null);
    setNotice(`Grille tarifaire mise à jour : ${a.lignes.length} prix au m² (profil « ${p.nom || ""} »).`);
  }
  function renderCalculRevient() {
    const profils = profilsRevient();
    const p = profils.find((x) => x.id === profilRevientId) || profils[0] || null;
    const carte = { background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 16, marginBottom: 20 };
    const titre = { fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 10 };
    const petit = { ...inputStyle(90), padding: "5px 6px", textAlign: "right" };
    const num = (v, set, w) => <input type="number" className="sc-input" value={v ?? ""} onChange={(e) => set(e.target.value)} style={{ ...petit, width: w || 90 }} />;
    const th = { fontSize: 10, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.4, textAlign: "right", padding: "6px 8px", whiteSpace: "nowrap", borderBottom: `1px solid ${PIERRE}` };
    const td = { fontSize: 12, textAlign: "right", padding: "5px 8px", whiteSpace: "nowrap", borderBottom: `1px solid ${PIERRE}` };
    const set = (patch) => p && majProfilRevient(p.id, patch);
    return (
      <div style={{ ...carte, border: `1px solid ${OCRE}` }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: pcOuverts.revient ? 12 : 0 }}>
          <div style={{ flex: "1 1 260px" }}>{titrePC("revient", "Calcul de revient", `${profils.length} profil(s) d'import`)}</div>
          {pcOuverts.revient && (<>
          <select className="sc-select" value={p ? p.id : ""} onChange={(e) => setProfilRevientId(e.target.value)} style={{ ...selectStyle, width: "auto", marginLeft: "auto" }}>
            {profils.map((x) => (<option key={x.id} value={x.id}>{x.nom}{x.fournisseur ? ` — ${x.fournisseur}` : " — fournisseur à choisir"}</option>))}
          </select>
          {p && <button type="button" className="sc-btn" onClick={() => copierProfilRevient(p)} style={ghostBtnStyle}>⧉ Copier ce profil</button>}
          <button type="button" className="sc-btn" onClick={() => ajouterProfilRevient("tranches")} style={ghostBtnStyle}>+ Profil tranches</button>
          <button type="button" className="sc-btn" onClick={() => ajouterProfilRevient("unitaire")} style={ghostBtnStyle}>+ Profil éviers / accessoires</button>
          </>)}
        </div>
        {pcOuverts.revient && !p && <div style={{ fontSize: 13, color: TAUPE }}>Aucun profil d'import.</div>}
        {pcOuverts.revient && p && (
          <>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))", gap: 12, marginBottom: 14 }}>
              <Field label="Nom du profil"><input className="sc-input" value={p.nom} onChange={(e) => set({ nom: e.target.value })} style={inputStyle("100%")} /></Field>
              <Field label="Fournisseur">
                <select className="sc-select" value={p.fournisseur || ""} onChange={(e) => set({ fournisseur: e.target.value })} style={selectStyle}>
                  <option value="">— Choisir —</option>
                  {trierAlpha(fournisseurs || [], "nom").map((f) => (<option key={f.id} value={f.nom}>{f.nom}</option>))}
                </select>
                {p.fournisseur && profils.some((x) => x.id !== p.id && x.type === p.type && normLib(x.fournisseur || "") === normLib(p.fournisseur) && (p.type !== "tranches" || x.matiere === p.matiere)) && <div style={{ fontSize: 11, color: ROUILLE, marginTop: 4 }}>Un autre profil a déjà ce fournisseur{p.type === "tranches" ? " et cette matière" : ""} : les articles ne prendront que l'un des deux.</div>}
              </Field>
              {p.type === "tranches" && (
                <Field label="Matière">
                  <select className="sc-select" value={p.matiere} onChange={(e) => changerMatiereProfil(p, e.target.value)} style={selectStyle}>
                    {MATIERES.map((m) => (<option key={m} value={m}>{m}</option>))}
                  </select>
                </Field>
              )}
              <Field label="Devise">
                <select className="sc-select" value={p.devise} onChange={(e) => set({ devise: e.target.value })} style={selectStyle}>
                  {DEVISES_IMPORT.map((d) => (<option key={d} value={d}>{d}</option>))}
                </select>
              </Field>
              {p.devise !== "MAD" && <Field label={`Taux : 1 ${p.devise} =`}>{num(p.taux, (v) => set({ taux: v }), 110)} <span style={{ fontSize: 12 }}>MAD</span></Field>}
            </div>

            {p.type === "tranches" && (() => {
              const eps = Object.keys(((p.prix || [])[0]) || p.surfaces || {});
              const majPrix = (gi, ep, ch, v) => set({ prix: (p.prix || []).map((row, i) => (i === gi ? { ...row, [ep]: { ...(row[ep] || {}), [ch]: v } } : row)) });
              const lg = p.logistique || {};
              const setLg = (size, k, v) => set({ logistique: { ...lg, [size]: { ...(lg[size] || {}), [k]: v } } });
              return (
                <>
                  <div style={titre}>Grille d'achat fournisseur — prix au m² en {p.devise}</div>
                  <div style={{ overflowX: "auto", marginBottom: 14 }}>
                    <table style={{ borderCollapse: "collapse", minWidth: 640 }}>
                      <thead><tr>
                        <th style={{ ...th, textAlign: "left" }}>Groupe fournisseur</th>
                        <th style={th}>→ Groupe tarifaire</th>
                        {eps.map((ep) => <th key={ep} style={th} colSpan={2}>{ep} (1er / 2e)</th>)}
                        <th style={th} />
                      </tr></thead>
                      <tbody>
                        {(p.groupes || []).map((g, gi) => (
                          <tr key={gi}>
                            <td style={{ ...td, textAlign: "left" }}><input className="sc-input" value={g.nom} onChange={(e) => set({ groupes: p.groupes.map((x, i) => (i === gi ? { ...x, nom: e.target.value } : x)) })} style={{ ...inputStyle(130), padding: "5px 6px" }} /></td>
                            <td style={td}>
                              <select className="sc-select" value={g.groupeERP ?? ""} onChange={(e) => set({ groupes: p.groupes.map((x, i) => (i === gi ? { ...x, groupeERP: Number(e.target.value) || "" } : x)) })} style={{ ...selectStyle, width: 90, padding: "5px 6px" }}>
                                <option value="">—</option>
                                {GROUPES.map((x) => (<option key={x} value={x}>Groupe {x}</option>))}
                              </select>
                            </td>
                            {eps.map((ep) => [1, 2].map((ch) => (
                              <td key={ep + ch} style={td}>{num((((p.prix || [])[gi] || {})[ep] || {})[ch], (v) => majPrix(gi, ep, ch, v), 70)}</td>
                            )))}
                            <td style={td}>{(p.groupes || []).length > 1 && <button type="button" className="sc-btn" onClick={() => set({ groupes: p.groupes.filter((_, i) => i !== gi), prix: (p.prix || []).filter((_, i) => i !== gi), marges: {} })} style={iconBtnStyle}>✕</button>}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <button type="button" className="sc-btn" onClick={() => set({ groupes: [...(p.groupes || []), { nom: `Groupe ${(p.groupes || []).length + 1}`, groupeERP: "" }], prix: [...(p.prix || []), Object.fromEntries(eps.map((ep) => [ep, { 1: "", 2: "" }]))] })} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>+ Ajouter un groupe fournisseur</button>
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 14, marginBottom: 14 }}>
                    <div style={{ background: PIERRE, borderRadius: 8, padding: 12 }}>
                      <div style={titre}>Format et emballage</div>
                      {eps.map((ep) => (
                        <div key={ep} style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 6, fontSize: 12 }}>
                          <span style={{ width: 44, fontWeight: 600 }}>{ep}</span>
                          {num((p.surfaces || {})[ep], (v) => set({ surfaces: { ...(p.surfaces || {}), [ep]: v } }), 70)}<span>m²/tranche</span>
                          {num((p.tranchesParChevalet || {})[ep], (v) => set({ tranchesParChevalet: { ...(p.tranchesParChevalet || {}), [ep]: v } }), 56)}<span>/chevalet</span>
                        </div>
                      ))}
                      <div style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, marginTop: 8 }}>Coût d'un chevalet {num(p.coutChevalet, (v) => set({ coutChevalet: v }), 80)} {p.devise}</div>
                    </div>
                    {[20, 40].map((size) => {
                      // Nils 08/10 : moyenne du registre transport international (12 mois, pays + incoterm du fournisseur) si disponible.
                      const pi = paysIncotermFournisseur(p.fournisseur);
                      const moy = moyenneTransport(size, pi.pays, pi.incoterm);
                      const l = (profilEffectif(p).logistique || {})[size] || {};
                      const tot = nombreOuZero(l.transport) + nombreOuZero(l.dedouanement) + nombreOuZero(l.transportLocal) + nombreOuZero(l.dechargement);
                      return (
                        <div key={size} style={{ background: PIERRE, borderRadius: 8, padding: 12, outline: (p.conteneur === 40 ? 40 : 20) === size ? `2px solid ${OCRE}` : "none" }}>
                          <div style={{ ...titre, display: "flex", justifyContent: "space-between" }}>
                            <span>Conteneur {size} pieds (MAD)</span>
                            <label style={{ textTransform: "none", letterSpacing: 0, cursor: "pointer" }}><input type="radio" checked={(p.conteneur === 40 ? 40 : 20) === size} onChange={() => set({ conteneur: size })} /> utilisé</label>
                          </div>
                          {[["chevalets", "Chevalets"], ["transport", "Transport international"], ["dedouanement", "Dédouanement"], ["transportLocal", "Transport local"], ["dechargement", "Déchargement"]].map(([k, lib]) => (
                            <div key={k} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12, marginBottom: 5 }}>{lib} {moy && k !== "chevalets" && moy[k] !== null ? <span title={`Valeur de départ : ${formatDH(nombreOuZero((lg[size] || {})[k]))}`} style={{ fontWeight: 600 }}>{formatDH(l[k])}</span> : num((lg[size] || {})[k], (v) => setLg(size, k, v), 100)}</div>
                          ))}
                          <div style={{ fontSize: 12, fontWeight: 600, marginTop: 6 }}>Total logistique : {formatDH(tot)}</div>
                          <div style={{ fontSize: 11, color: moy ? VERT_OK : TAUPE, marginTop: 4, lineHeight: 1.4 }}>
                            {!p.fournisseur ? "Choisis le fournisseur du profil." : !pi.pays || !pi.incoterm ? `Pays / incoterm à renseigner sur la fiche fournisseur « ${p.fournisseur} » : valeurs de départ utilisées.` : moy ? `Moyenne de ${moy.n} conteneur(s) sur 12 mois — ${pi.pays}, ${pi.incoterm} (registre transport international).` : `Valeur de départ (aucun conteneur ${size}' ${pi.pays} ${pi.incoterm} dans le registre sur 12 mois).`}
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div style={{ display: "flex", gap: 14, flexWrap: "wrap", alignItems: "flex-end", marginBottom: 10, fontSize: 12 }}>
                    <Field label="Remise de référence (%)" style={{ marginBottom: 0 }}>{num(p.remiseRef, (v) => set({ remiseRef: v }), 70)}</Field>
                    <Field label="Marge cible 1er / 2e choix (%)" style={{ marginBottom: 0 }}><span style={{ display: "flex", gap: 4 }}>{num(p.margeDefaut1, (v) => set({ margeDefaut1: v }), 60)}{num(p.margeDefaut2, (v) => set({ margeDefaut2: v }), 60)}</span></Field>
                    <Field label="Simulation : remise accordée (%)" style={{ marginBottom: 0 }}>{num((p.simu || {}).remise, (v) => set({ simu: { ...(p.simu || {}), remise: v } }), 70)}</Field>
                    <Field label="Commission vendeur (%)" style={{ marginBottom: 0 }}>{num((p.simu || {}).commVendeur, (v) => set({ simu: { ...(p.simu || {}), commVendeur: v } }), 70)}</Field>
                    <Field label="Commission apporteur (%)" style={{ marginBottom: 0 }}>{num((p.simu || {}).commApporteur, (v) => set({ simu: { ...(p.simu || {}), commApporteur: v } }), 70)}</Field>
                  </div>

                  <div style={titre}>Coût de revient et prix de vente (MAD HT)</div>
                  <div style={{ overflowX: "auto" }}>
                    <table style={{ borderCollapse: "collapse", minWidth: 980, width: "100%" }}>
                      <thead><tr>
                        {["Typologie", "Achat / tr.", "Emballage / tr.", "Logistique / tr.", "Coût / tranche", "Coût / m²", "Marge cible %", "Prix public / m²", "Prix remisé / m²", "Comm. vendeur", "Comm. apporteur", "Marge brute / tr."].map((h, i) => <th key={h} style={{ ...th, textAlign: i === 0 ? "left" : "right" }}>{h}</th>)}
                      </tr></thead>
                      <tbody>
                        {typologiesProfil(p).map(({ gi, ep, ch, g }) => {
                          const c = coutTrancheProfil(p, gi, ep, ch);
                          const k = `${gi}|${ep}|${ch}`;
                          const mg = margeProfil(p, gi, ep, ch);
                          const v = c ? prixVenteProfil(p, c, mg) : null;
                          return (
                            <tr key={k}>
                              <td style={{ ...td, textAlign: "left" }}>{g.nom} · {ep} · {ch === 2 ? "2e" : "1er"} choix{g.groupeERP ? <span style={{ color: TAUPE }}> → G{g.groupeERP}</span> : ""}</td>
                              {c ? (
                                <>
                                  <td style={td}>{fmtMAD(c.achat)}</td>
                                  <td style={td}>{fmtMAD(c.emballage)}</td>
                                  <td style={td}>{fmtMAD(c.logistique)}</td>
                                  <td style={{ ...td, fontWeight: 700 }}>{fmtMAD(c.total)}</td>
                                  <td style={td}>{fmtMAD(c.totalM2)}</td>
                                  <td style={td}><input type="number" className="sc-input" value={(p.marges || {})[k] ?? ""} placeholder={String(ch === 2 ? p.margeDefaut2 : p.margeDefaut1)} onChange={(e) => set({ marges: { ...(p.marges || {}), [k]: e.target.value } })} style={{ ...petit, width: 60 }} /></td>
                                  <td style={{ ...td, fontWeight: 700 }}>{fmtMAD(v.publicM2)}</td>
                                  <td style={td}>{fmtMAD(v.remiseM2)}</td>
                                  <td style={td}>{fmtMAD(v.commV)}</td>
                                  <td style={td}>{fmtMAD(v.commA)}</td>
                                  <td style={{ ...td, color: v.margeBrute < 0 ? ROUILLE : ENCRE }}>{fmtMAD(v.margeBrute)} ({v.margeBrutePct.toFixed(1).replace(".", ",")} %)</td>
                                </>
                              ) : <td style={{ ...td, textAlign: "left", color: TAUPE }} colSpan={11}>prix d'achat ou surface manquant</td>}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div style={{ fontSize: 11, color: TAUPE, margin: "8px 0 12px", lineHeight: 1.5 }}>
                    Coût / tranche = (achat/m² × surface standard) + chevalet ÷ tranches par chevalet + logistique du conteneur utilisé ÷ tranches qu'il contient, converti au taux saisi. Prix public = coût ÷ (1 − marge cible) ÷ (1 − remise de référence). Prix remisé, commissions et marge brute : simulation avec la remise et les taux ci-dessus (les commissions réelles viendront du tableau des commissions).
                  </div>
                  <button type="button" className="sc-btn" onClick={() => preparerApercuGrille(p)} style={primaryBtnStyle}>Appliquer à la Grille tarifaire…</button>
                </>
              );
            })()}

            {p.type === "unitaire" && (() => {
              const arts = (articles || []).filter((a) => ["Éviers", "Accessoires"].includes(a.categorie) && a.provenance === "Importé" && (a.categorie === "Accessoires" || !a.fournisseur || !p.fournisseur || normLib(a.fournisseur) === normLib(p.fournisseur))).sort((a, b) => a.designation.localeCompare(b.designation, "fr"));
              return (
                <>
                  <div style={titre}>Articles importés (Éviers{p.fournisseur ? ` de ${p.fournisseur}` : ""}, Accessoires) — prix d'achat en {p.devise}, coût d'import par pièce en MAD</div>
                  {!arts.length && <div style={{ fontSize: 12, color: TAUPE }}>Aucun article Éviers / Accessoires avec la provenance « Importé ».</div>}
                  {!!arts.length && (
                    <table style={{ borderCollapse: "collapse", minWidth: 680 }}>
                      <thead><tr>{["Article", `Prix achat (${p.devise})`, "Achat MAD", "Import / pièce (MAD)", "Coût standard", "Qté min. import"].map((h, i) => <th key={h} style={{ ...th, textAlign: i === 0 ? "left" : "right" }}>{h}</th>)}</tr></thead>
                      <tbody>
                        {arts.map((a) => {
                          const prix = (p.prixArticles || {})[a.id];
                          const achat = versMAD(prix, p.devise, p.taux);
                          const imp = nombreOuZero((p.importArticles || {})[a.id]);
                          return (
                            <tr key={a.id}>
                              <td style={{ ...td, textAlign: "left" }}>{a.designation}</td>
                              <td style={td}>{num(prix, (v) => set({ prixArticles: { ...(p.prixArticles || {}), [a.id]: v } }), 90)}</td>
                              <td style={td}>{nombreOuZero(prix) > 0 ? fmtMAD(achat) : "—"}</td>
                              <td style={td}>{num((p.importArticles || {})[a.id], (v) => set({ importArticles: { ...(p.importArticles || {}), [a.id]: v } }), 90)}</td>
                              <td style={{ ...td, fontWeight: 700 }}>{nombreOuZero(prix) > 0 ? fmtMAD(achat + imp) : "—"}</td>
                              <td style={td}>{num((p.minArticles || {})[a.id], (v) => set({ minArticles: { ...(p.minArticles || {}), [a.id]: v } }), 70)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Coût standard = prix d'achat × taux + coût d'import par pièce. La quantité minimum est un rappel : une ligne d'arrivage en dessous affiche un avertissement.</div>
                </>
              );
            })()}

            <div style={{ marginTop: 14, textAlign: "right" }}>
              <button type="button" className="sc-btn" onClick={() => supprimerProfilRevient(p)} style={{ ...ghostBtnStyle, color: ROUILLE }}>Supprimer ce profil</button>
            </div>
          </>
        )}
      </div>
    );
  }


  // ---------- ERP step 14 (e, Nils 05/10) : arrivages import ligne par ligne — Nils seul ----------
  function nouvelleLigneArrivage() {
    return { id: uid(), articleId: "", qte: "", nuance: "", arrivageA: "", arrivageB: "", remisePct: "", lotId: "" };
  }
  function nouvelArrivageImport() {
    const an = new Date().getFullYear();
    const n = (arrivagesImport || []).filter((a) => String(a.numero || "").startsWith(`ARR-${an}-`)).length + 1;
    setArrivageEdit({ id: null, numero: `ARR-${an}-${String(n).padStart(3, "0")}`, date: todayISO(), fournisseur: "", devise: "EUR", taux: "", numeroFacture: "", factureDevise: "", avoirs: [], frais: { transport: "", dedouanement: "", dechargement: "", emballage: "", autres: "" }, conteneur: "", nbConteneurs: 1, chevalets: { qte: "", prixDevise: "" }, notes: "", lignes: [nouvelleLigneArrivage()] });
  }
  function ouvrirArrivageImport(a) {
    setArrivageEdit({ ...a, avoirs: [...(a.avoirs || [])], frais: { ...(a.frais || {}) }, lignes: (a.lignes || []).map((l) => ({ ...l })) });
  }
  function articlesPourArrivage(fournisseur) {
    return (articles || []).filter((a) => a.actif !== false && articleImporte(a) && a.produitStockId && (a.categorie === "Accessoires" || (a.fournisseur && normLib(a.fournisseur) === normLib(fournisseur)))).sort((a, b) => a.designation.localeCompare(b.designation, "fr"));
  }
  function qteMinImport(art, fournisseur) {
    if (!art || art.categorie === "Tranche") return null;
    const profil = profilUnitairePour(fournisseur || art.fournisseur);
    const m = profil ? nombreOuZero((profil.minArticles || {})[art.id]) : 0;
    return m > 0 ? m : null;
  }
  async function enregistrerArrivageImport(appliquer) {
    let a = arrivageEdit;
    if (!a) return;
    if (!a.fournisseur) { setNotice("Choisis le fournisseur de l'arrivage."); return; }
    if (!a.id && !(await confirmerFournisseurBlackliste(a.fournisseur, "un arrivage"))) return;
    const lignes = (a.lignes || []).filter((l) => l.articleId || String(l.qte || "").trim());
    for (const l of lignes) {
      const art = (articles || []).find((x) => x.id === l.articleId);
      if (!art) { setNotice("Choisis l'article de chaque ligne."); return; }
      if (!(nombreOuZero(l.qte) > 0)) { setNotice(`Indique la quantité de « ${art.designation} ».`); return; }
      if (bookMatchSepare(art.produitStockId) && (String(l.arrivageA ?? "").trim() === "" || String(l.arrivageB ?? "").trim() === "" || nombreOuZero(l.arrivageA) + nombreOuZero(l.arrivageB) !== nombreOuZero(l.qte))) { setNotice(`« ${art.designation} » : A et B vendus séparément — indique A et B prévus, avec A + B = quantité.`); return; }
      if (produitBookMatch(art.produitStockId) && nombreOuZero(l.arrivageA) + nombreOuZero(l.arrivageB) > nombreOuZero(l.qte)) { setNotice(`« ${art.designation} » : A + B prévus dépassent la quantité.`); return; }
    }
    if (!lignes.length) { setNotice("Ajoute au moins une ligne."); return; }
    if (appliquer && a.devise !== "MAD" && !(nombreOuZero(a.taux) > 0)) { setNotice("Indique le taux de change réel."); return; }
    // Étape f : à la création, numéro attribué par le serveur (celui de la fiche n'était qu'un aperçu).
    if (!a.id) {
      const numeroArr = await numeroDocument("ARR", Number(String(a.date || todayISO()).slice(0, 4)));
      if (!numeroArr) return;
      a = { ...a, numero: numeroArr };
    }
    // Lignes supprimées / modifiées dont le lot a déjà bougé : interdit.
    const avant = a.id ? (arrivagesImport || []).find((x) => x.id === a.id) : null;
    const lotsAvant = new Set(((avant && avant.lignes) || []).map((l) => l.lotId).filter(Boolean));
    const lotsGardes = new Set(lignes.map((l) => l.lotId).filter(Boolean));
    // Nils 14/10 (f, g) : seule une ligne reçue est verrouillée ; une ligne réservée reste modifiable (confirmation).
    const lotDe = (id) => (items || []).find((it) => it.id === id);
    for (const lotId of lotsAvant) {
      if (lotsGardes.has(lotId)) continue;
      const lot = lotDe(lotId);
      if (lot && lotRecu(lot)) { setNotice("Une ligne supprimée correspond à un lot déjà reçu : annule d'abord la réception."); return; }
      const rs = reservationsActivesLot(lotId);
      if (rs.length) { setNotice(`Une ligne supprimée correspond à un lot réservé (${libReservations(rs)}) : déplace d'abord ces réservations.`); return; }
    }
    const avertirImp = [];
    for (const l of lignes) {
      const ancienne = ((avant && avant.lignes) || []).find((x) => x.id === l.id);
      if (!ancienne || !ancienne.lotId) continue;
      const change = ancienne.articleId !== l.articleId || String(ancienne.qte) !== String(l.qte) || (ancienne.nuance || "") !== (l.nuance || "");
      const lot = lotDe(ancienne.lotId);
      if (change && lot && lotRecu(lot)) { setNotice("Une ligne déjà reçue ne peut plus changer d'article, de quantité ni de tonalité : annule d'abord la réception."); return; }
      const rs = reservationsActivesLot(ancienne.lotId);
      if (!change || !rs.length) continue;
      const res = rs.reduce((t, r) => t + nombreOuZero(r.quantite), 0);
      const art = (articles || []).find((x) => x.id === l.articleId);
      const lib = art ? art.designation : "ligne";
      if (ancienne.articleId !== l.articleId) avertirImp.push(`${lib} : article changé alors que le lot est réservé (${libReservations(rs)}).`);
      else if ((ancienne.nuance || "") !== (l.nuance || "")) avertirImp.push(`${lib} : tonalité changée alors que le lot est réservé (${libReservations(rs)}).`);
      if (nombreOuZero(l.qte) < res) avertirImp.push(`${lib} : ${nombreOuZero(l.qte)} prévus pour ${res} réservés (${libReservations(rs)}).`);
    }
    if (avertirImp.length && !(await demander(`Réservations concernées :\n\n${avertirImp.map((x) => `• ${x}`).join("\n")}\n\nLes réservations restent sur leur lot : à toi de les déplacer si besoin. Enregistrer quand même ?`))) return;
    const id = a.id || uid();
    const maintenant = new Date().toISOString();
    const calc = calculArrivage({ ...a, lignes });
    if (appliquer && !(calc.total > 0)) { setNotice("Rien à répartir : indique le montant de la facture et les frais."); return; }
    // Nils 09/10 : jamais de coûts appliqués sans la matière (facture vide et facture attendue incalculable).
    if (appliquer && !(calc.factureMAD > 0)) { setNotice("Facture à répartir nulle : saisis la facture brute (la facture attendue ne peut pas être calculée — coût standard manquant sur une ligne). Sans elle, les lots ne recevraient que les frais de transport."); return; }
    // Création / mise à jour des lots « en arrivage ».
    let nextItems = [...(items || [])];
    const nouveauxMvts = [];
    const lignesFinales = lignes.map((l) => {
      const art = (articles || []).find((x) => x.id === l.articleId);
      const c = calc.lignes.find((x) => x.ligne.id === l.id);
      const p = produitDe(art.produitStockId);
      const bm = bookMatchSepare(art.produitStockId);
      const prixProvisoire = c && c.standardNet !== null ? Math.round(c.standardNet * 100) / 100 : null;
      const base = {
        produitId: art.produitStockId, type: TYPE_TRANCHE, fournisseur: a.fournisseur,
        dimensions: art.dimension || "", epaisseur: art.epaisseurMatiere || "", nuance: (l.nuance || "").trim(), choix: art.choix || "",
        unite: p ? categorieUnite(p.categorie) || "pièce(s)" : "pièce(s)", blFournisseur: (a.numeroFacture || "").trim(),
        arrivageImportId: id, qteBase: nombreOuZero(l.qte),
        ...(c && c.standard !== null ? { coutStandardHT: Math.round(c.standard * 100) / 100 } : {}),
        ...(appliquer && c && c.coutUnitaire !== null ? { prixAchatHT: Math.round(c.coutUnitaire * 100) / 100 } : {}),
      };
      const existant = l.lotId ? nextItems.find((it) => it.id === l.lotId) : null;
      if (existant) {
        const actif = lotRecu(existant);
        const ancienneL = ((avant && avant.lignes) || []).find((x) => x.id === l.id);
        const diffL = !actif && ancienneL ? [...(ancienneL.articleId !== l.articleId ? [`article ${nomProduit(existant.produitId)} → ${nomProduit(art.produitStockId)}`] : []), ...(String(ancienneL.qte) !== String(l.qte) ? [`quantité ${ancienneL.qte} → ${l.qte}`] : []), ...((ancienneL.nuance || "") !== (l.nuance || "") ? [`tonalité ${ancienneL.nuance || "—"} → ${l.nuance || "—"}`] : [])] : [];
        const maj = actif ? { ...existant, arrivageImportId: id, ...(base.prixAchatHT !== undefined ? { prixAchatHT: base.prixAchatHT } : {}), ...(base.coutStandardHT !== undefined ? { coutStandardHT: base.coutStandardHT } : {}) }
          : { ...existant, ...base, arrivages: nombreOuZero(l.qte), stockReel: 0, ...(bm && String(l.arrivageA ?? "").trim() !== "" ? { arrivageA: nombreOuZero(l.arrivageA) } : {}), ...(bm && String(l.arrivageB ?? "").trim() !== "" ? { arrivageB: nombreOuZero(l.arrivageB) } : {}), ...(base.prixAchatHT === undefined && !existant.prixAchatHT && prixProvisoire !== null ? { prixAchatHT: prixProvisoire } : {}) };
        nextItems = nextItems.map((it) => (it.id === existant.id ? (diffL.length ? journaliserLot(maj, `Arrivage ${a.numero} modifié : ${diffL.join(" ; ")}`, maintenant) : maj) : it));
        // Nils 09/10 : les lots book-match A / B issus de ce lot reçoivent aussi le prix de revient.
        if (base.prixAchatHT !== undefined || base.coutStandardHT !== undefined) {
          nextItems = nextItems.map((it) => (it.lotOrigineId === existant.id ? { ...it, ...(base.prixAchatHT !== undefined ? { prixAchatHT: base.prixAchatHT } : {}), ...(base.coutStandardHT !== undefined ? { coutStandardHT: base.coutStandardHT } : {}), arrivageImportId: id } : it));
        }
        return { ...l, lotId: existant.id };
      }
      const lot = { id: uid(), ...base, stockReel: 0, arrivages: nombreOuZero(l.qte), bm: "", ...(base.prixAchatHT === undefined && prixProvisoire !== null ? { prixAchatHT: prixProvisoire } : {}), ...(bm && String(l.arrivageA ?? "").trim() !== "" ? { arrivageA: nombreOuZero(l.arrivageA) } : {}), ...(bm && String(l.arrivageB ?? "").trim() !== "" ? { arrivageB: nombreOuZero(l.arrivageB) } : {}) };
      nextItems.push(lot);
      nouveauxMvts.push({ id: uid(), itemId: lot.id, type: "entree", quantite: lot.arrivages, unite: lot.unite, doc: "", date: today(), note: `Nouveau lot créé (${nomProduit(lot.produitId)} — ${a.fournisseur}) — arrivage ${a.numero}`, pl: "", creeLe: maintenant });
      return { ...l, lotId: lot.id };
    });
    // Lots des lignes supprimées (sans activité) : supprimés.
    const supprimes = [...lotsAvant].filter((lotId) => !lignesFinales.some((l) => l.lotId === lotId));
    nextItems = nextItems.filter((it) => !supprimes.includes(it.id));
    await persist(nextItems);
    if (nouveauxMvts.length) await persistMouvements([...(mouvements || []), ...nouveauxMvts]);
    const fiche = { ...a, id, lignes: lignesFinales, ...(a.id ? { modifieLe: maintenant } : { creeLe: maintenant, par: user.nom }), ...(appliquer ? { calculeLe: maintenant, totalRevient: Math.round(calc.total * 100) / 100 } : {}) };
    await persistArrivagesImport(a.id ? (arrivagesImport || []).map((x) => (x.id === id ? fiche : x)) : [...(arrivagesImport || []), fiche]);
    await tracerAcces(a.id ? "arrivage import modifié" : "arrivage import créé", `${fiche.numero} — ${fiche.fournisseur} — ${lignesFinales.length} ligne(s)${nouveauxMvts.length ? `, ${nouveauxMvts.length} lot(s) créé(s)` : ""}${appliquer ? ` — coût de revient appliqué (${formatDH(calc.total)})` : ""}`);
    setArrivageEdit(null);
    setNotice(appliquer ? `Arrivage ${fiche.numero} : prix de revient réel appliqué aux ${lignesFinales.length} lot(s).` : `Arrivage ${fiche.numero} enregistré${nouveauxMvts.length ? ` — ${nouveauxMvts.length} lot(s) en arrivage créé(s) dans le Stock` : ""}.`);
  }
  async function supprimerArrivageImport(a) {
    const lotIds = (a.lignes || []).map((l) => l.lotId).filter(Boolean);
    if (lotIds.some((x) => lotRecu((items || []).find((it) => it.id === x)) || reservationsActivesLot(x).length)) { setNotice(`L'arrivage ${a.numero} a des lots déjà reçus ou réservés : il ne peut plus être supprimé.`); return; }
    if (!(await demander(`Supprimer l'arrivage ${a.numero} et ses ${lotIds.length} lot(s) en arrivage ?`))) return;
    await persistArrivagesImport((arrivagesImport || []).filter((x) => x.id !== a.id));
    await persist((items || []).filter((it) => !lotIds.includes(it.id)));
    await tracerAcces("arrivage import supprimé", `${a.numero} — ${a.fournisseur} — ${lotIds.length} lot(s) supprimé(s)`);
    setArrivageEdit(null);
  }
  // ---------- Catalogue d'articles ----------
  function ouvrirNouvelArticle() {
    setArticleCopieDe("");
    const cat = catalogueFiltreCat !== "Toutes" ? catalogueFiltreCat : "";
    const epaisseursValides = EPAISSEURS_PAR_MATIERE[MATIERES[0]] || EPAISSEURS_MATIERE;
    setArticleEditing({ id: null, code: "", designation: "", unite: (unitesArticles && unitesArticles[0]) || DEFAULT_UNITES_ARTICLE[0], categorie: cat, structurel: cat === "Tranche" ? true : false, prixPublic: 0, matiere: MATIERES[0], epaisseurMatiere: epaisseursValides.length === 1 ? epaisseursValides[0] : "", epaisseurFinie: "", finition: "", dimension: "", choix: "", couleurFournisseur: "", codeFournisseur: "", fournisseur: "", groupe: null, prixParGroupe: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }, produitStockId: "", lierAuStock: true, actif: true, exonerable: false,
      // ERP step 7 : exclusion des commissions, groupe de couleur (Tranche)
      // et statut de validation (pour les articles créés par Karima).
      exclureCommission: false, groupeCouleur: "", creePar: user.id, valideParNils: peut("catalogue.validerArticles"),
      // ERP step 16 (Nils 12/10) : natures cochées par Nils ; « livraison » pré-cochée pour la catégorie Logistique.
      natures: { pose: false, faconnage: false, livraison: cat === "Logistique", rdm: false, decoupe: false } });
    setArticleFormError("");
    setShowArticleForm(true);
  }
  // Nils 20/10 : copie d'un article — tout est repris sauf l'identifiant, le code (unique)
  // et le lien au Stock (sinon l'enregistrement renommerait la fiche Stock de l'original).
  function copierArticle(a) {
    setArticleEditing({ ...a, id: null, code: "", produitStockId: "", actif: true, naturesAVerifier: false, creePar: user.id, valideParNils: peut("catalogue.validerArticles"), ...(estGerant ? {} : { vendableQuartTranche: false }) });
    setArticleCopieDe(a.designation || a.code || "");
    setArticleFormError("");
    setShowArticleForm(true);
  }
  function ouvrirArticle(a) {
    setArticleCopieDe("");
    setArticleEditing({ ...a });
    setArticleFormError("");
    setShowArticleForm(true);
  }
  // ---------- Lien Catalogue -> Stock ----------
  // Tranche, Éviers et Accessoires génèrent chacun une fiche Produit dans le
  // Stock (jamais de lot — pas de quantité réelle à ce stade). Le lien est
  // conservé sur l'article pour ne jamais dupliquer, et le produit est
  // renommé si la désignation de l'article change plus tard.
  // Vrai si une catégorie du Stock n'existe que parce qu'un article
  // Catalogue la génère — Tranche -> matières (Quartz/Grès Cérame), et
  // toute autre catégorie Catalogue (Éviers, Accessoires, ou une catégorie
  // personnalisée comme "zarbi") sous son propre nom, sauf celles qui ne
  // représentent jamais de matière physique (Logistique, Majorations,
  // Descriptifs). Dynamique : dépend des catégories Catalogue existantes,
  // pas d'une liste figée.
  function estCategorieStockReservee(nomCategorieStock) {
    if (MATIERES.includes(nomCategorieStock)) return true;
    return (categoriesArticles || []).some(
      (catArticle) => catArticle === nomCategorieStock && !CATEGORIES_ARTICLES_SANS_STOCK.includes(catArticle)
    );
  }
  function categorieStockPourArticle(article) {
    if (CATEGORIES_ARTICLES_SANS_STOCK.includes(article.categorie)) return null;
    if (article.categorie === "Tranche") return article.matiere || null; // "Quartz" ou "Grès Cérame"
    return article.categorie || null; // Éviers, Accessoires, ou une catégorie personnalisée
  }
  // ERP step 7 (pt.17/18) : depuis la transformation en BDC, le dossier est
  // propriétaire de ses propres lignes (commande.lignes), indépendantes du
  // devis d'origine (désormais figé). lignesDuDossier() est le point d'accès
  // unique aux lignes d'un dossier — avec repli sur le devis d'origine pour
  // les dossiers anciens qu'une migration au chargement n'aurait pas
  // couverts (défense en profondeur, ne devrait normalement jamais servir).
  // Nils 08/10 (n, o) : articles du catalogue des lignes facturées d'un dossier.
  // ERP step 16 (Nils 12/10) : contact / téléphone sur place obligatoires s'il y a un article de livraison OU de RDM.
  function dossierAvecLogistique(commande) {
    return dossierNature(commande, "livraison") || dossierNature(commande, "rdm");
  }
  function dossierNature(commande, cle) {
    return lignesAvecNature(lignesDuDossier(commande), articles, cle);
  }
  // Sans article de RDM : pas de BPRDM, passage direct BDC → PL. Avec : BPRDM obligatoire.
  function dossierAvecRDM(commande) {
    return dossierNature(commande, "rdm");
  }

  function lignesDuDossier(commande) {
    if (commande && Array.isArray(commande.lignes)) return commande.lignes;
    const devisOrigine = (devisListe || []).find((d) => d.id === commande?.devisId);
    return devisOrigine ? (devisOrigine.lignes || []) : [];
  }
  // Step 13 (retour Nils du 22/09) : extrait de submitPL pour être réutilisé
  // aussi au moment de la transformation du dossier en PL elle-même — le
  // blocage ne servait à rien tant qu'il ne s'appliquait qu'à
  // "Enregistrer un PL" (l'étape Stock), un dossier pouvait déjà être passé
  // en statut PL avec un article Karima non validé.
  function articlesNonValidesDuDossier(commande) {
    if (!commande) return [];
    return Array.from(
      new Set(
        lignesDuDossier(commande)
          .filter((l) => l.type === "facture" && l.articleId)
          .map((l) => (articles || []).find((a) => a.id === l.articleId))
          .filter((a) => a && articleAValider(a))
          .map((a) => a.designation)
      )
    );
  }
  // Restriction restaurée sur "Enregistrer un PL" (accord Nils du 21/09,
  // Step 10) : le menu "Lot consommé" ne doit proposer que les produits
  // présents sur ce PL et leur famille — Tranches : même fournisseur + code
  // + finition, toutes épaisseurs confondues (substitution d'épaisseur
  // tolérée, comme pour le plafond anti-sur-consommation) ; hors Tranches :
  // produit exact seulement. Les filtres manuels "par catégorie/produit" du
  // Step 9 restent supprimés, seule cette restriction automatique revient.
  function familleEtProduitsAutorisesPL(commande) {
    const familles = new Set();
    const produitsExacts = new Set();
    lignesDuDossier(commande).forEach((l) => {
      if (l.type !== "facture" || !l.articleId) return;
      const article = (articles || []).find((a) => a.id === l.articleId);
      if (!article) return;
      if (article.categorie === "Tranche") {
        const fam = clefCreditArticle(article);
        if (fam) familles.add(fam);
      } else if (article.produitStockId) {
        produitsExacts.add(article.produitStockId);
      }
    });
    return { familles, produitsExacts };
  }
  // Vrai si `lot` peut être choisi comme matière consommée sur le PL
  // actuellement sélectionné dans "Enregistrer un PL" — voir
  // familleEtProduitsAutorisesPL ci-dessus. Sans PL sélectionné, ou si le
  // dossier ne référence aucun article identifiable, on n'affiche aucune
  // restriction plutôt que de tout masquer.
  function lotAutorisePourPL(lot, commandePL) {
    if (!commandePL) return true;
    const { familles, produitsExacts } = familleEtProduitsAutorisesPL(commandePL);
    if (familles.size === 0 && produitsExacts.size === 0) return true;
    const famLot = clefCreditDuProduit(lot.produitId);
    if (famLot && familles.has(famLot)) return true;
    return produitsExacts.has(lot.produitId);
  }
  // Vrai si un dossier peut encore avoir ses lignes modifiées depuis
  // l'écran du dossier.
  // Accord Nils du 21/09 : la description de la commande et la facturation
  // (lignes, quantités, prix) ne sont plus modifiables une fois le dossier
  // passé en RDM — seuls les éléments techniques, pièces jointes, fiche de
  // pose, nombre de colis et commentaire dessin restent éditables à partir
  // de là (chacun avec sa propre condition d'affichage, indépendante de
  // celle-ci). Pour corriger une ligne à ce stade, il faut revenir en BDC.
  function commandeLignesEditables(statut) {
    return statut === "BDC";
  }
  // Vrai si au moins une ligne du dossier référence un article lié au Stock
  // — sert à savoir si "Enregistrer un PL" est réellement nécessaire avant
  // de pouvoir transformer en BL (rien à sortir du Stock sinon, pas la peine
  // de l'exiger).
  function commandeADesArticlesStock(commande) {
    return lignesDuDossier(commande).some((l) => {
      const article = (articles || []).find((a) => a.id === l.articleId);
      return article && article.produitStockId;
    });
  }
  // Vrai si ce PL a déjà fait l'objet d'un "Enregistrer un PL" côté Stock
  // (au moins un mouvement tracé sous ce numéro).
  function plEstEnregistre(commande) {
    if (!commande.numeroPL) return false;
    // ERP step 11 : un consommable saisi sur ce PL ne vaut pas enregistrement du PL.
    return (mouvements || []).some((m) => m.pl === commande.numeroPL && !estMouvementConsommable(m));
  }
  async function synchroniserProduitStock(article) {
    const nomCategorieStock = categorieStockPourArticle(article);
    if (!nomCategorieStock) return article;
    // Contrôle explicite : l'utilisateur peut décocher la liaison au Stock
    // à la création, plutôt que ce soit toujours automatique.
    if (article.lierAuStock === false) return article;

    if (!(categories || []).some((c) => c.name === nomCategorieStock)) {
      const defauts = MATIERES.includes(nomCategorieStock) && modeMatiere(nomCategorieStock) === "famille"
        ? { unite: "tranche(s)", gestion: "tranche", nuances: true }
        : MATIERES.includes(nomCategorieStock)
        ? { unite: "tranche(s)", gestion: "tranche", nuances: false }
        : { unite: "pièce(s)", gestion: "piece", nuances: false };
      await persistCategories([...(categories || []), { name: nomCategorieStock, ...defauts }]);
    }

    const nom = (article.designation || "").trim();
    if (!nom) return article;

    if (article.produitStockId) {
      const existant = (produits || []).find((p) => p.id === article.produitStockId);
      if (existant) {
        const patch = {};
        if (existant.nom !== nom) patch.nom = nom;
        // La matière (donc la catégorie Stock) d'un article peut changer
        // après coup — sans ça, le produit lié reste bloqué sur l'ancienne
        // catégorie indéfiniment.
        if (existant.categorie !== nomCategorieStock) patch.categorie = nomCategorieStock;
        if (Object.keys(patch).length > 0) {
          await persistProduits((produits || []).map((p) => (p.id === article.produitStockId ? { ...p, ...patch } : p)));
        }
      }
      return article;
    }

    if ((produits || []).some((p) => p.nom.toLowerCase() === nom.toLowerCase())) {
      setNotice(`Un produit Stock nommé « ${nom} » existe déjà — l'article n'a pas été relié automatiquement. Relie-le depuis le Stock si besoin.`);
      return article;
    }
    const nouveauProduit = { id: uid(), nom, categorie: nomCategorieStock, seuil: 0, correspondances: [] };
    await persistProduits([...(produits || []), nouveauProduit]);
    return { ...article, produitStockId: nouveauProduit.id };
  }

  async function enregistrerArticle() {
    if (!articleEditing.categorie) {
      setArticleFormError("Choisis une catégorie.");
      return;
    }
    if (!articleEditing.designation.trim()) {
      setArticleFormError("Renseigne la désignation.");
      return;
    }
    if (articleEditing.categorie === "Tranche") {
      if (!articleEditing.matiere) {
        setArticleFormError("Choisis la matière.");
        return;
      }
      if (!articleEditing.epaisseurMatiere) {
        setArticleFormError("Choisis l'épaisseur de la matière brute.");
        return;
      }
      if (!articleEditing.finition) {
        setArticleFormError("Choisis la finition.");
        return;
      }
      if (!articleEditing.dimension) {
        setArticleFormError("Choisis la dimension.");
        return;
      }
      if (!articleEditing.choix) {
        setArticleFormError("Choisis le choix (1er ou 2e).");
        return;
      }
      // Une tranche vient toujours d'un fournisseur connu — obligatoire
      // dans tous les cas, y compris quand l'article n'est pas lié au Stock.
      if (!articleEditing.fournisseur) {
        setArticleFormError("Choisis le fournisseur.");
        return;
      }
      // ERP step 8 : le Quartz entre dans le registre des crédits de
      // tranches exonérables via la clé fournisseur + couleur fournisseur —
      // sans couleur fournisseur renseignée, l'article resterait hors
      // registre (accord du 21/09 avec Nils : obligatoire pour le Quartz
      // uniquement, toujours facultatif pour le Grès Cérame).
      if (modeMatiere(articleEditing.matiere) === "couleur" && !(articleEditing.couleurFournisseur || "").trim()) {
        setArticleFormError(`Renseigne la couleur fournisseur (obligatoire pour une Tranche ${articleEditing.matiere}).`);
        return;
      }
      if (!articleEditing.groupe) {
        setArticleFormError("Choisis le groupe tarifaire.");
        return;
      }
    }
    // Pour les autres catégories, le fournisseur n'est obligatoire que pour
    // les articles réellement liés au Stock (case "Lier cet article au
    // Stock" cochée) — sans lien, il n'y a rien à fixer côté Stock.
    if (
      articleEditing.categorie !== "Tranche" &&
      categorieStockPourArticle(articleEditing) &&
      articleEditing.lierAuStock !== false &&
      !articleEditing.fournisseur
    ) {
      setArticleFormError("Choisis le fournisseur (obligatoire pour un article lié au Stock).");
      return;
    }
    // ERP step 14 (Nils 05/10 : c6a) : provenance obligatoire pour un nouvel article Tranche / Éviers / Accessoires.
    if (!articleEditing.id && CATEGORIES_AVEC_PROVENANCE.includes(articleEditing.categorie) && !PROVENANCES.includes(articleEditing.provenance)) {
      setArticleFormError("Choisis la provenance (importé ou acheté localement).");
      return;
    }
    // ERP step 17 (Nils 14/10) : un code (nomenclature) ne peut pas être porté par deux articles —
    // il sert de clé de rapprochement à l'import. Comparaison sans casse ni espaces de bord ; code vide accepté.
    const codeSaisi = (articleEditing.code || "").trim();
    if (codeSaisi) {
      const memeCode = (articles || []).find((a) => a.id !== articleEditing.id && (a.code || "").trim().toLowerCase() === codeSaisi.toLowerCase());
      if (memeCode) {
        setArticleFormError(`Le code « ${codeSaisi} » est déjà utilisé par l'article « ${memeCode.designation} ». Choisis un autre code.`);
        return;
      }
    }
    const doublon = (articles || []).find(
      (a) => a.id !== articleEditing.id && a.designation.trim().toLowerCase() === articleEditing.designation.trim().toLowerCase()
    );
    const articleAvecStock = await synchroniserProduitStock(peut("catalogue.reglagesArticle") && articleEditing.naturesAVerifier ? { ...articleEditing, naturesAVerifier: false } : articleEditing);
    const existe = (articles || []).some((a) => a.id === articleAvecStock.id);
    const next = existe
      ? articles.map((a) => (a.id === articleAvecStock.id ? articleAvecStock : a))
      : [...(articles || []), { ...articleAvecStock, id: uid() }];
    persistArticles(next);
    {
      // Nils 17/10 : la vente au quart de tranche se coche / décoche par le Gérant seul ; chaque changement est tracé.
      const avant = (articles || []).find((a) => a.id === articleAvecStock.id);
      if (!!(avant && avant.vendableQuartTranche) !== !!articleAvecStock.vendableQuartTranche) {
        await tracerAcces("vente au quart de tranche", `${articleAvecStock.designation} : ${articleAvecStock.vendableQuartTranche ? "cochée" : "décochée"}`);
      }
      // Nils 28/10 : listellos (renforts des plans de 4 cm), cases du Gérant seul, tracées de même.
      if (!!(avant && avant.utilisableListello) !== !!articleAvecStock.utilisableListello) {
        await tracerAcces("tranche utilisable en listello", `${articleAvecStock.designation} : ${articleAvecStock.utilisableListello ? "cochée" : "décochée"}`);
      }
      if (!!(avant && avant.demandeListello) !== !!articleAvecStock.demandeListello) {
        await tracerAcces("majoration demandant des listellos", `${articleAvecStock.designation} : ${articleAvecStock.demandeListello ? "cochée" : "décochée"}`);
      }
    }
    setShowArticleForm(false);
    setArticleEditing(null);
    setArticleFormError("");
    if (doublon) {
      setNotice(`Attention : un autre article a déjà exactement la même désignation « ${doublon.designation} » (code ${doublon.code || "—"}). Enregistré quand même — vérifie que ce n'est pas un doublon involontaire.`);
    }
  }
  function toggleArticleActif(id) {
    persistArticles(articles.map((a) => (a.id === id ? { ...a, actif: !a.actif } : a)));
  }
  function supprimerArticle(id) {
    const enUsage = (devisListe || []).some((d) => (d.lignes || []).some((l) => l.articleId === id));
    if (enUsage) {
      setNotice("Impossible de supprimer cet article : il est utilisé sur au moins un devis. Désactive-le plutôt (bouton actif/inactif).");
      return;
    }
    const article = (articles || []).find((a) => a.id === id);
    if (article && article.produitStockId) {
      const lots = (items || []).filter((it) => it.produitId === article.produitStockId);
      const lotsAvecStock = lots.filter((it) => (Number(it.stockReel) || 0) > 0 || (Number(it.arrivages) || 0) > 0);
      if (lotsAvecStock.length > 0) {
        const produitLie = (produits || []).find((p) => p.id === article.produitStockId);
        setNotice(`Impossible de supprimer cet article : le produit Stock « ${produitLie ? produitLie.nom : "lié"} » a encore ${lotsAvecStock.length} lot(s) avec du stock réel ou des arrivages en cours. Vide-les d'abord depuis le Stock.`);
        return;
      }
    }
    persistArticles(articles.filter((a) => a.id !== id));
    if (article && article.produitStockId) {
      const produitLie = (produits || []).find((p) => p.id === article.produitStockId);
      setNotice(`Article supprimé. Le produit Stock « ${produitLie ? produitLie.nom : "lié"} » reste dans le Stock, mais n'est plus relié à aucun article Catalogue — pense à le vérifier si besoin.`);
    } else {
      setNotice("Article supprimé.");
    }
  }

  // ---------- Catégories d'articles ----------
  function ajouterCategorie() {
    const v = newCategorie.trim();
    if (!v || categoriesArticles.includes(v)) return;
    persistCategoriesArticles([...categoriesArticles, v]);
    setNewCategorie("");
  }
  function supprimerCategorie(cat) {
    const utiliseePar = (articles || []).filter((a) => a.categorie === cat);
    if (utiliseePar.length > 0) {
      setNotice(`Impossible de supprimer « ${cat} » : ${utiliseePar.length} article(s) l'utilisent. Change leur catégorie avant de la supprimer.`);
      return;
    }
    persistCategoriesArticles(categoriesArticles.filter((x) => x !== cat));
  }

  // ---------- Unités d'articles ----------
  function ajouterUnite() {
    const v = newUnite.trim();
    if (!v || unitesArticles.includes(v)) return;
    persistUnitesArticles([...unitesArticles, v]);
    setNewUnite("");
  }
  function supprimerUnite(u) {
    const utiliseePar = (articles || []).filter((a) => a.unite === u);
    if (utiliseePar.length > 0) {
      setNotice(`Impossible de supprimer « ${u} » : ${utiliseePar.length} article(s) l'utilisent. Change leur unité avant de la supprimer.`);
      return;
    }
    persistUnitesArticles(unitesArticles.filter((x) => x !== u));
  }

  // ---------- Matières de Tranche (ajoutées par Nils) ----------
  const peutGererMatieres = estGerant; // Nils 05/10 (h5) : « Prix et coûts » réservé à Nils
  async function ajouterMatiere() {
    const nm = nouvelleMatiere;
    const nom = (nm.nom || "").trim().replace(/\s+/g, " ");
    const lettre = (nm.lettre || "").trim().toUpperCase();
    const autres = (nm.autre || "").split(/[,;\s]+/).map((x) => x.replace(/mm$/i, "").trim()).filter((x) => /^\d+$/.test(x)).map((x) => `${Number(x)}mm`);
    const epaisseurs = [...new Set([...EPAISSEURS_MATIERE.filter((e) => nm.epaisseurs.includes(e)), ...autres])].sort((x, y) => parseInt(x, 10) - parseInt(y, 10));
    if (!nom) { setMatiereError("Indique le nom de la matière (ex. Marbre)."); return; }
    if (MATIERES.some((m) => normLib(m) === normLib(nom)) || (categoriesArticles || []).some((c) => normLib(c) === normLib(nom))) { setMatiereError(`« ${nom} » existe déjà.`); return; }
    if (!/^[A-Z]$/.test(lettre)) { setMatiereError("La lettre de nomenclature est une seule lettre (ex. M pour Marbre)."); return; }
    if (Object.entries(MATIERE_CODE_NOMENCLATURE).some(([, l]) => l === lettre)) { setMatiereError(`La lettre ${lettre} est déjà prise par une autre matière.`); return; }
    if (!epaisseurs.length) { setMatiereError("Coche au moins une épaisseur vendue."); return; }
    const m = { nom, lettre, libelle: (nm.libelle || "").trim() || nom, epaisseurs, mode: nm.mode === "famille" ? "famille" : "couleur", creePar: user.nom, creeLe: new Date().toISOString() };
    await persistMatieres([...(matieresPerso || []), m]);
    await tracerAcces("matière ajoutée", `${nom} (${lettre}, ${epaisseurs.join("/")})`);
    setNouvelleMatiere({ nom: "", lettre: "", libelle: "", epaisseurs: [], autre: "", mode: "couleur" });
    setMatiereError("");
    if (articleEditing && articleEditing.categorie === "Tranche") {
      setArticleEditing({ ...articleEditing, matiere: nom, epaisseurMatiere: epaisseurs.length === 1 ? epaisseurs[0] : "" });
    }
    setShowMatiereManager(false);
    setNotice(`Matière « ${nom} » ajoutée. Pense à saisir ses prix au m² dans Prix et coûts.`);
  }
  async function supprimerMatiere(nom) {
    const n = (articles || []).filter((a) => a.categorie === "Tranche" && a.matiere === nom).length;
    if (n > 0) { setMatiereError(`Impossible de supprimer « ${nom} » : ${n} article(s) l'utilisent.`); return; }
    if ((produits || []).some((p) => p.categorie === nom)) { setMatiereError(`Impossible de supprimer « ${nom} » : des produits du Stock sont rangés dans cette catégorie.`); return; }
    if (!await demander(`Supprimer la matière « ${nom} » ?`)) return;
    await persistMatieres((matieresPerso || []).filter((m) => m.nom !== nom));
    await tracerAcces("matière supprimée", nom);
    setMatiereError("");
  }

  // ---------- Finitions d'articles ----------
  const finitionsListe = normaliserFinitions(finitionsArticles || DEFAULT_FINITIONS_ARTICLE);
  // Nils 21/10 : 1 ou 2 lettres, sans accent, non prises par une autre finition.
  function verifierLettreFinition(lettre, nom) {
    if (!/^[A-Z]{1,2}$/.test(lettre)) return "La lettre de nomenclature fait 1 ou 2 lettres (ex. S ou ST).";
    const prise = finitionsListe.find((f) => f.nom !== nom && f.lettre === lettre);
    return prise ? `La lettre ${lettre} est déjà prise par la finition « ${prise.nom} ».` : "";
  }
  async function ajouterFinition() {
    const v = newFinition.trim().replace(/\s+/g, " ");
    if (!v) return;
    if (finitionsListe.some((f) => normLib(f.nom) === normLib(v))) { setFinitionError(`« ${v} » existe déjà.`); return; }
    const lettre = lettresSansAccent(newFinitionLettre) || lettreParDefautFinition(v);
    const erreur = verifierLettreFinition(lettre, v);
    if (erreur) { setFinitionError(erreur); return; }
    await persistFinitionsArticles([...finitionsListe, { nom: v, lettre }]);
    await tracerAcces("finition ajoutée", `${v} (${lettre})`);
    setNewFinition("");
    setNewFinitionLettre("");
    setFinitionError("");
  }
  // Les articles existants gardent leur code : seule une nouvelle génération de la nomenclature prend la nouvelle lettre.
  async function changerLettreFinition(nom) {
    const saisie = lettresFinitionsSaisies[nom];
    const { [nom]: _, ...autres } = lettresFinitionsSaisies;
    setLettresFinitionsSaisies(autres);
    if (saisie === undefined) return;
    const lettre = lettresSansAccent(saisie);
    const actuelle = (finitionsListe.find((f) => f.nom === nom) || {}).lettre;
    if (lettre === actuelle) return;
    const erreur = verifierLettreFinition(lettre, nom);
    if (erreur) { setFinitionError(erreur); return; }
    await persistFinitionsArticles(finitionsListe.map((f) => (f.nom === nom ? { ...f, lettre } : f)));
    await tracerAcces("finition modifiée", `${nom} : lettre ${actuelle} → ${lettre}`);
    setFinitionError("");
  }
  function supprimerFinition(f) {
    const utiliseePar = (articles || []).filter((a) => a.finition === f);
    if (utiliseePar.length > 0) {
      setNotice(`Impossible de supprimer « ${f} » : ${utiliseePar.length} article(s) l'utilisent. Change leur finition avant de la supprimer.`);
      return;
    }
    persistFinitionsArticles(finitionsListe.filter((x) => x.nom !== f));
  }

  // ---------- Groupes de couleur d'articles (ERP step 7) ----------
  // Classement large (Blancs, Gris, Noirs…) sur les Tranches, distinct de la
  // "famille couleur" utilisée pour les réservations — cf. commentaire sur
  // GROUPES_COULEUR_ARTICLES_KEY.
  function ajouterGroupeCouleur() {
    const v = newGroupeCouleur.trim();
    if (!v || (groupesCouleurArticles || []).includes(v)) return;
    persistGroupesCouleurArticles([...(groupesCouleurArticles || []), v]);
    setNewGroupeCouleur("");
  }
  function supprimerGroupeCouleur(g) {
    const utiliseePar = (articles || []).filter((a) => a.groupeCouleur === g || a.groupeCouleur2 === g);
    if (utiliseePar.length > 0) {
      setNotice(`Impossible de supprimer « ${g} » : ${utiliseePar.length} article(s) l'utilisent. Change leur groupe de couleur avant de la supprimer.`);
      return;
    }
    persistGroupesCouleurArticles((groupesCouleurArticles || []).filter((x) => x !== g));
  }

  // ---------- Validation Nils des articles créés par Karima (ERP step 7) ----------
  // Seul Nils peut valider — pas Karima elle-même, même si elle a l'accès en
  // écriture au Catalogue qui lui permet de créer l'article (accord du 21/09).
  // ERP step 16 (Nils 12/10) : fin de la vérification des natures pré-cochées.
  async function marquerNaturesVerifiees() {
    if (!peut("catalogue.reglagesArticle")) return;
    const n = (articles || []).filter((a) => a.naturesAVerifier).length;
    if (!n || !(await demander(`Marquer les natures de ${n} article(s) comme vérifiées ?`))) return;
    await persistArticles((articles || []).map((a) => (a.naturesAVerifier ? { ...a, naturesAVerifier: false } : a)));
    setNotice(`${n} article(s) : natures vérifiées.`);
  }
  function validerArticleParNils(id) {
    if (!peut("catalogue.validerArticles")) return;
    persistArticles((articles || []).map((a) => (a.id === id ? { ...a, valideParNils: true } : a)));
  }

  // ---------- Apporteurs d'affaire ----------
  // Liste gérée par Nils, indépendante des utilisateurs de l'app (un
  // apporteur peut être externe à Stone Concept).
  function ajouterApporteur() {
    const v = newApporteur.trim();
    if (!v || (apporteursAffaire || []).includes(v)) return;
    persistApporteursAffaire([...(apporteursAffaire || []), v]);
    setNewApporteur("");
  }
  function supprimerApporteur(nomApporteur) {
    const clientsConcernes = (clients || []).filter((c) => c.apporteurAffaire === nomApporteur);
    const devisConcernes = (devisListe || []).filter((d) => d.apporteurAffaire === nomApporteur);
    if (clientsConcernes.length > 0 || devisConcernes.length > 0) {
      setNotice(`Impossible de supprimer « ${nomApporteur} » : utilisé sur ${clientsConcernes.length} fiche(s) client et ${devisConcernes.length} devis. Change l'apporteur sur ces fiches avant de le supprimer.`);
      return;
    }
    persistApporteursAffaire((apporteursAffaire || []).filter((x) => x !== nomApporteur));
  }
  function commencerEditionApporteur(nomApporteur) {
    setApporteurEdition({ ancien: nomApporteur, valeur: nomApporteur });
  }
  function annulerEditionApporteur() {
    setApporteurEdition(null);
  }
  async function validerEditionApporteur() {
    if (!apporteurEdition) return;
    const ancien = apporteurEdition.ancien;
    const nouveau = apporteurEdition.valeur.trim();
    if (!nouveau) return;
    if (nouveau === ancien) {
      setApporteurEdition(null);
      return;
    }
    if ((apporteursAffaire || []).includes(nouveau)) {
      setNotice(`« ${nouveau} » existe déjà dans la liste des apporteurs d'affaire.`);
      return;
    }
    await persistApporteursAffaire((apporteursAffaire || []).map((x) => (x === ancien ? nouveau : x)));
    const clientsConcernes = (clients || []).filter((c) => c.apporteurAffaire === ancien);
    const devisConcernes = (devisListe || []).filter((d) => d.apporteurAffaire === ancien);
    if (clientsConcernes.length > 0) {
      await persistClients((clients || []).map((c) => (c.apporteurAffaire === ancien ? { ...c, apporteurAffaire: nouveau } : c)));
    }
    if (devisConcernes.length > 0) {
      await persistDevis((devisListe || []).map((d) => (d.apporteurAffaire === ancien ? { ...d, apporteurAffaire: nouveau } : d)));
    }
    setApporteurEdition(null);
    const propage = clientsConcernes.length + devisConcernes.length;
    setNotice(`Apporteur renommé en « ${nouveau} »${propage > 0 ? ` — répercuté sur ${clientsConcernes.length} fiche(s) client et ${devisConcernes.length} devis` : ""}.`);
  }

  // ERP step 8 (accord du 21/09) : crédit total utilisable, pour une clé
  // donnée, par le brouillon actuellement ouvert — ce qui reste au registre,
  // plus ce que CE dossier détient déjà s'il s'agit d'un BC en cours
  // d'édition (son propre crédit ne doit pas compter contre lui-même, sinon
  // "Modifier le bon de commande" ne pourrait jamais que réduire une ligne).
  function creditUtilisablePourCle(cle) {
    return Number((creditDisponible(cle) + commandeCreditPourCle(commandeEnEditionDesLignes(), cle)).toFixed(2));
  }
  // Quantité déjà demandée, dans le brouillon en cours (toutes lignes
  // confondues, ou en ignorant une ligne précise), pour une clé donnée —
  // permet de plafonner l'ensemble des lignes d'un même devis/BC sur le
  // crédit total utilisable (cumul par clé au sein d'un même dossier).
  function creditEngageDraft(cle, ignorerLigneId) {
    if (!draft) return 0;
    return draft.lignes.reduce((s, l) => {
      if (l.id === ignorerLigneId || l.type !== "facture" || !l.articleId || l.chute) return s;
      const art = (articles || []).find((a) => a.id === l.articleId);
      if (!art || art.categorie !== "Tranche") return s;
      const fe = produitCreditDeArticle(art);
      if (!fe || fe.cle !== cle) return s;
      return s + (Number(l.qte) || 0);
    }, 0);
  }
  const articlesFiltres = useMemo(() => {
    const q = ligneQuery.trim().toLowerCase();
    // Les Descriptifs ont leur propre zone d'ajout (voir descriptifsFiltres) :
    // ils ne doivent jamais apparaître dans les éléments facturés.
    const base = articlesActifs.filter((a) => a.categorie !== "Descriptifs" && (ligneFiltreCat === "Toutes" || a.categorie === ligneFiltreCat));
    const filtresRecherche = q ? base.filter((a) => a.designation.toLowerCase().includes(q) || a.code.toLowerCase().includes(q)) : base;
    // ERP step 9 : sur un devis/BC marqué exonéré, seuls les articles
    // réellement exonérables restent proposés — Tranches avec du crédit
    // encore disponible dans le registre de crédit pour ce produit exact
    // (masquées à 0, plus de tolérance de famille), et articles non-Tranche
    // cochés "TVA exonérable". Les articles Tranche non liés à un produit du
    // Stock ne sont jamais éligibles au registre, donc jamais proposés ici.
    const filtresExo = draft && draft.exonereTVA
      ? filtresRecherche.filter((a) => {
          // Nils 26/10 (f) : sans crédit, une tranche reste proposée — elle s'ajoute alors en chute.
          if (a.categorie === "Tranche") return !!produitCreditDeArticle(a);
          return !!a.exonerable;
        })
      : filtresRecherche;
    // Sans recherche ni famille choisie, on ne montre qu'un aperçu (8) pour ne
    // pas afficher tout le catalogue par défaut ; dès qu'on cherche ou qu'on
    // choisit une famille, la liste s'ouvre plus large (jusqu'à 40).
    const plafond = q || ligneFiltreCat !== "Toutes" ? 40 : 8;
    // Step 13 (retour Nils du 21/09) : liste triée par ordre alphabétique
    // (désignation) avant troncature, au lieu de l'ordre de création.
    return trierAlpha(filtresExo, "designation").slice(0, plafond);
  }, [articlesActifs, ligneQuery, ligneFiltreCat, draft, creditsTranches, commandeEditing, articles, commandesListe]);

  // Zone d'ajout des descriptifs : liste entière au focus, filtrée à la
  // frappe, quel que soit le nombre d'articles de la catégorie.
  const descriptifsFiltres = useMemo(() => {
    const q = descriptifQuery.trim().toLowerCase();
    const base = articlesActifs.filter((a) => a.categorie === "Descriptifs");
    const filtres = q ? base.filter((a) => a.designation.toLowerCase().includes(q) || a.code.toLowerCase().includes(q)) : base;
    return filtres.slice(0, 60);
  }, [articlesActifs, descriptifQuery]);
  // Nils 23/10 (a) : primes versées par les caisses, par fiche Staff ; celles qu'on ne rattache à aucune
  // fiche (nom inconnu ou porté par deux fiches) sont signalées dans Staff › Primes.
  const versementsPrimes = useMemo(() => {
    const parStaff = {}, nonRattaches = [];
    (operations || []).filter(estVersementPrime).forEach((o) => {
      const id = staffIdVersement(o);
      const v = { id: o.id, date: o.date, montant: Number(o.montant) || 0, type: o.sousPoste === ANCIEN_SOUS_POSTE_PRODUCTIVITE ? TYPE_PRIME_PRODUCTIVITE : o.typePrime || "", compteId: o.compteId, designation: o.designation || "", tiers: o.tiers || "", verse: true };
      if (id) (parStaff[id] = parStaff[id] || []).push(v);
      else nonRattaches.push(v);
    });
    return { parStaff, nonRattaches };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operations, staff]);

  const catalogueFiltre = useMemo(() => {
    const q = catQuery.trim().toLowerCase();
    return (articles || [])
      .filter((a) => catalogueFiltreCat === "Toutes" || a.categorie === catalogueFiltreCat)
      .filter((a) => catalogueFiltreExo === "Tous" || (catalogueFiltreExo === "Exo" ? !!a.exonerable : !a.exonerable))
      .filter((a) => catalogueFiltreNature === "Toutes" ? true
        : catalogueFiltreNature === "averifier" ? !!a.naturesAVerifier
        : catalogueFiltreNature === "aucune" ? !NATURES_ARTICLE.some((n) => natureArticle(a, n.cle))
        : natureArticle(a, catalogueFiltreNature))
      .filter((a) => catalogueFiltreCat !== "Tranche" || FILTRES_TRANCHE_CATALOGUE.every(([k]) => !catFiltresTranche[k] || String(a[k] || "") === catFiltresTranche[k]))
      .filter((a) => !q || a.designation.toLowerCase().includes(q) || a.code.toLowerCase().includes(q))
      .sort((a, b) => a.designation.localeCompare(b.designation, "fr"));
  }, [articles, catQuery, catalogueFiltreCat, catalogueFiltreExo, catalogueFiltreNature, catFiltresTranche]);

  const totaux = draft ? calcTotaux(draft) : null;
  const draftClient = draft ? clientsActifs.find((c) => c.id === draft.clientId) : null;
  const commandeLieeAuDevis = draft ? (commandesListe || []).find((c) => c.devisId === draft.id) : null;
  // Dossier ciblé par le PL en cours d'enregistrement (modale "Enregistrer un
  // PL") — sert à restreindre le menu "Lot consommé" (lotAutorisePourPL).
  const commandePLSelectionnee = plDoc ? (commandesListe || []).find((c) => c.numeroPL === plDoc) : null;
  const chantiersDuClient = draft ? (chantiers || []).filter((c) => c.clientId === draft.clientId) : [];
  const lignesDescriptives = draft ? draft.lignes.filter((l) => l.type === "descriptif") : [];
  const lignesFacturables = draft ? draft.lignes.filter((l) => l.type !== "descriptif") : [];

  // ---------- ERP step 11 : tâches par personne (calculées en direct) ----------
  // Chaque point bloquant est attribué à la personne qui en a la
  // responsabilité (accord Nils du 29/09). Une tâche disparaît d'elle-même
  // dès que la condition est levée.
  const tachesEquipe = (() => {
    const t = [];
    const ajout = (qui, texte, bloque, lien, extra) => t.push({ qui, texte, bloque: bloque || "", lien, ...(extra || {}) });
    const nomClient = (id) => (clientDe(id) || {}).nom || "client ?";
    const libDossier = (c) => `${c.numeroFacture || c.numeroBL || c.numeroPL || c.numeroRDM || c.numero}${c.reference ? ` — ${c.reference}` : ""} (${nomClient(c.clientId)})`;
    // ERP step 11 (accord Nils du 29/09) : tâches liées aux statuts.
    const lienDevisCommande = (c) => (devisListe || []).find((d) => d.id === c.devisId) || {};
    (devisListe || []).filter((d) => !estHorsVueActive(d)).forEach((d) => {
      if (d.statut === "Brouillon") ajout(qui(P_ADV_SR, P_ADV_JR), `Devis ${d.numero || "(non numéroté)"} en brouillon — à finaliser`, "", { kind: "devis", id: d.id });
      // Nils 28/10 (b3) : prêt pour envoi → le commercial du devis et l'ADV.
      if (d.statut === "Prêt pour envoi") {
        const com = d.commercialId || idCommercialDuDevis(d);
        ajout([...new Set([...qui(P_ADV_SR, P_ADV_JR), ...(com ? [com] : [])])], `Devis ${d.numero || "(non numéroté)"} prêt — à envoyer au client (${nomClient(d.clientId)})`, "", { kind: "devis", id: d.id });
      }
      if (d.statut === "Envoyé") {
        const envoi = d.envoyeLe || d.date || (d.creeLe || "").slice(0, 10);
        const echeance = d.relanceLe || (envoi ? (() => { const x = new Date(envoi); x.setDate(x.getDate() + delaiRelanceDevisJours()); return x.toISOString().slice(0, 10); })() : todayISO());
        if (todayISO() >= echeance) {
          const com = idCommercialDuDevis(d);
          const jours = envoi ? joursEntre(`${envoi}T00:00:00.000Z`, null) : null;
          ajout(com ? [com] : qui(P_ADV_SR, P_ADV_JR), `Relancer le client — devis ${d.numero} (${(clientDe(d.clientId) || {}).nom || "client ?"})`, [jours !== null ? `envoyé il y a ${jours} j` : "", d.relanceNote ? `relance prévue : ${d.relanceNote}` : ""].filter(Boolean).join(" — "), { kind: "devis", id: d.id }, { relanceDevisId: d.id });
        }
      }
    });
    // Nils 01/10 : réservation dont la date de pose prévue est dépassée.
    dossiersReservationDepassee().forEach((c) => {
      const d = lienDevisCommande(c);
      const com = d && d.id ? idCommercialDuDevis(d) : null;
      ajout([...new Set([...(com ? [com] : qui(P_ADV_SR, P_ADV_JR)), ...qui(P_GERANT)])], `Réservation dépassée — ${libDossier(c)} : matière réservée pour le ${formatDate(c.reservationPourLe)}`, [`dépassée de ${joursEntre(`${c.reservationPourLe}T00:00:00.000Z`, null)} j`, c.reservationNote ? `note : ${c.reservationNote}` : ""].filter(Boolean).join(" — "), { kind: "commande", id: c.id }, { reportReservationId: c.id });
    });
    const RESP_EN_ATTENTE = {
      BDC: { "Réservation matière": qui(P_ADV_SR, P_ADV_JR), "Avance client": [...qui(P_ADMIN), "@commercial"], "Confirmation client pour RDM": ["@commercial", ...qui(P_ADV_SR, P_ADV_JR)], "Envoi client": qui(P_ADV_SR, P_ADV_JR), "Confirmation client": ["@commercial", ...qui(P_ADV_SR, P_ADV_JR)] },
      RDM: { "Passage chantier": qui(P_POSE, P_PROD), "Dessin Bureau technique": qui(P_BT), "Envoi client": qui(P_ADV_SR, P_ADV_JR), "Confirmation client": ["@commercial", ...qui(P_ADV_SR, P_ADV_JR)] },
      PL: { "Production": qui(P_PROD), "Établissement du BL": qui(P_ADMIN) },
      BL: { "Vérification paiement": qui(P_ADMIN), "Livraison / pose": qui(P_PROD, P_POSE), "Facturation": qui(P_ADMIN) },
      Facture: { "Facturation": qui(P_ADMIN), "Envoi client par mail": qui(P_ADMIN), "Remise original": [...qui(P_ADMIN), "@commercial"] },
    };
    const groupesVus = new Set();
    (commandesListe || []).forEach((c) => {
      const att = c.enAttenteDe || "";
      if (!att || att === "Autre") return;
      let resp = att === "Autorisation direction" ? qui(P_GERANT) : ((RESP_EN_ATTENTE[c.statut] || {})[att] || null);
      if (!resp) return;
      // Nils 17/10 : facture groupée — une seule tâche par facture (envoi, remise), pas une par dossier.
      const groupee = c.statut === "Facture" && c.factureGroupeeId;
      if (groupee) {
        if (groupesVus.has(c.factureGroupeeId)) return;
        groupesVus.add(c.factureGroupeeId);
      }
      const com = idCommercialDuDevis(lienDevisCommande(c));
      resp = [...new Set(resp.flatMap((r) => (r === "@commercial" ? (com ? [com] : []) : [r])))];
      const lib = groupee ? `Facture ${c.numeroFacture} « ${c.refFactureGroupee || ""} » (${dossiersDuGroupe(c).length} BL) — ${nomClient(c.clientId)}` : libDossier(c);
      if (resp.length) ajout(resp, `${lib} — en attente : ${att}`, "", { kind: "commande", id: c.id });
    });
    // Nils 03/10 : BL à faire signer (Ahmed + commercial du dossier).
    (commandesListe || []).filter((c) => c.numeroBL && ["BL", "Facture"].includes(c.statut) && !c.blSigne).forEach((c) => {
      const com = idCommercialDuDevis(lienDevisCommande(c));
      ajout([...new Set([...qui(P_PROD), ...(com ? [com] : [])])], `Faire signer le ${c.numeroBL} — ${libDossier(c)}`, "", { kind: "commande", id: c.id });
    });
    // Factures de remplacement à encaisser (caisse traçable).
    dossiersRemplacement().filter((d) => totalDossierTTC(d) - encaisseDossier(d.id) > 0.01).forEach((d) => {
      ajout(qui(P_GERANT), `Encaisser la facture de remplacement ${d.numeroFacture} (${formatDH(totalDossierTTC(d) - encaisseDossier(d.id))}) — caisse générale`, "", { kind: "onglet", id: "compta" });
    });
    // Caisse générale sous le seuil (Nils 03/10).
    { const cg = compteDe(CAISSE_GENERALE_ID); if (cg && caisseGeneraleActive()) { const sg = soldeCompteAu(CAISSE_GENERALE_ID); if (sg < SEUIL_CAISSE_GENERALE) ajout(qui(P_GERANT), `Caisse générale sous ${formatDH(SEUIL_CAISSE_GENERALE)} : ${formatDH(sg)} — à alimenter (retrait d'espèces CFG pour la caisse générale)`, "", { kind: "onglet", id: "compta" }); } }
    // ERP step 11 : contrôle mensuel de l'outillage → Ahmed (et Nils).
    if (controleOutillageOuvert) {
      const reste = Object.values(controleOutillageOuvert.lignes || {}).filter((l) => !l.resultat).length;
      ajout(qui(P_PROD), `Contrôle de l'outillage en cours — ${reste} outil(s) à pointer`, "", { kind: "onglet", id: "outillage" });
    } else if (controleOutillageDu()) {
      ajout(qui(P_PROD), "Contrôle mensuel de l'outillage à lancer (qui a quoi ?)", "", { kind: "onglet", id: "outillage" });
    }
    // Nils 03/10 (i) : inventaire semestriel de la bureautique → Sawsan.
    // Nils 05/10 (h3) : contrôle semestriel des salaires bruts — Sawsan ; Nils si pas fait sous 30 jours.
    if (parametres) {
      const semB = semestreDe(todayISO());
      if (!controleBrutDuSemestre(semB)) {
        ajout(qui(P_ADMIN), `Vérifier / ajuster les salaires bruts des fiches Staff — ${libSemestre(semB)}`, "", { kind: "onglet", id: "staff" });
        if (joursEntre(`${bornesSemestre(semB)[0]}T00:00:00.000Z`, null) > 30) ajout(qui(P_GERANT), `Salaires bruts du ${libSemestre(semB)} toujours pas vérifiés par Sawsan`, "", { kind: "onglet", id: "staff" });
      }
    }
    { const cb = controleOuvert("bureautique");
      if (cb) {
        const reste = Object.values(cb.lignes || {}).filter((l) => !l.resultat).length;
        ajout(qui(P_ADMIN), `Inventaire du matériel bureautique en cours — ${reste} objet(s) à pointer`, "", { kind: "onglet", id: "outillage" });
      } else if (controleDu("bureautique")) {
        const d = dernierControle("bureautique");
        ajout(qui(P_ADMIN), "Inventaire semestriel du matériel bureautique à faire (qui a quoi ?)", d ? `dernier le ${formatDate(d.clotureLe.slice(0, 10))}` : "premier inventaire", { kind: "onglet", id: "outillage" });
      } }
    // ERP step 12 : trésorerie.
    (operations || []).filter((o) => o.type === "transfert" && o.sens === "entree" && o.statutTransfert === "en attente").forEach((o) => {
      const dst = compteDe(o.compteId), src = compteDe(o.contrepartieId);
      if (dst) ajout(dst.responsables || [], `Transfert à confirmer : ${formatDH(Number(o.montant))} de ${src ? src.nom : "?"} vers ${dst.nom} (${formatDate(o.date)})`, "", { kind: "onglet", id: "compta" });
    });
    // ERP step 12 : factures fournisseurs — contrôle (Sawsan), échéances et délai légal (Nils, Sawsan).
    const aControler = (facturesF || []).filter((x) => x.controle === "à contrôler");
    if (aControler.length) ajout(qui(P_ADMIN), `Factures fournisseurs à contrôler : ${aControler.length} (saisies par ${[...new Set(aControler.map((x) => x.par))].join(", ")})`, "", { kind: "onglet", id: "facturesF" });
    const stF = (facturesF || []).map((x) => ({ x, st: statutFactureF(x) }));
    const nLegal = stF.filter((y) => y.st.code === "legal"), nRetard = stF.filter((y) => y.st.code === "retard"), nBientot = stF.filter((y) => y.st.code === "bientot"), nDevis = stF.filter((y) => y.st.code === "devis-retard");
    if (nLegal.length) ajout(qui(P_GERANT, P_ADMIN), `⚠ ${nLegal.length} facture(s) fournisseur au-delà du délai légal — ${formatDH(nLegal.reduce((n, y) => n + resteFactureF(y.x), 0))} dus, amende estimée ${formatDH(nLegal.reduce((n, y) => n + amendeFactureF(y.x), 0))}`, "", { kind: "onglet", id: "compta" });
    const nProche = stF.filter((y) => { const j = joursAvantLimiteLegale(y.x); return j !== null && j <= JOURS_ALERTE_LIMITE_LEGALE; });
    if (nProche.length) ajout(qui(P_GERANT, P_ADMIN), `${nProche.length} facture(s) fournisseur à payer avant la limite légale (sous ${JOURS_ALERTE_LIMITE_LEGALE} j, la 1re le ${formatDate(nProche.map((y) => limiteLegaleFactureF(y.x)).sort()[0])}) — ${formatDH(nProche.reduce((n, y) => n + resteFactureF(y.x), 0))}`, "", { kind: "onglet", id: "compta" });
    if (nRetard.length) ajout(qui(P_GERANT, P_ADMIN), `${nRetard.length} facture(s) fournisseur en retard de paiement — ${formatDH(nRetard.reduce((n, y) => n + resteFactureF(y.x), 0))}`, "", { kind: "onglet", id: "compta" });
    if (nBientot.length) ajout(qui(P_GERANT, P_ADMIN), `${nBientot.length} échéance(s) fournisseur dans les ${JOURS_ALERTE_ECHEANCE} jours — ${formatDH(nBientot.reduce((n, y) => n + resteFactureF(y.x), 0))}`, "", { kind: "onglet", id: "facturesF" });
    if (nDevis.length) ajout(qui(P_GERANT, P_ADMIN), `${nDevis.length} acompte(s) sur devis sans facture depuis plus de ${JOURS_ALERTE_DEVIS} jours`, "", { kind: "onglet", id: "facturesF" });
    // Nils 08/10 (i/j) : précisions demandées sur une opération de caisse.
    (operations || []).filter((o) => !o.miroirDe && (o.questions || []).length).forEach((o) => {
      const c = compteDe(o.compteId) || {};
      (o.questions || []).forEach((q) => {
        if (!q.reponse) {
          const resp = (c.responsables || []).filter((id) => id !== q.par);
          ajout(resp.length ? resp : qui(P_ADMIN).filter((id) => id !== q.par), `Précision demandée par ${q.parNom} — ${c.nom} : ${o.designation} (${formatDH(Number(o.montant) || 0)}, ${formatDate(o.date)})`, `« ${q.texte} »`, { kind: "onglet", id: "compta" });
        } else if (!q.lu) {
          ajout([q.par], `Réponse sur ${c.nom} : ${o.designation} (${formatDate(o.date)})`, `${q.reponduPar} : « ${q.reponse} »`, { kind: "onglet", id: "compta" });
        }
      });
    });
    // Nils 08/10 : paiement CFG au sous-poste Transitaire → Sawsan complète le registre transport international.
    {
      const nTi = paiementsTransitaireARattacher().length;
      if (nTi) ajout(qui(P_ADMIN), `Registre transport international : ${nTi} paiement(s) transitaire (CFG) à rattacher à un conteneur`, "", { kind: "onglet", id: "transportIntl" });
    }
    // Clôtures mensuelles (Nils 01/10).
    (comptesTreso || []).forEach((c) => {
      if (c.id === CAISSE_GENERALE_ID && !caisseGeneraleActive()) return;
      // Nils 04/10 : le portefeuille de chèques n'est pas une caisse — pas de clôture mensuelle.
      if (c.id === PORTEFEUILLE_ID) return;
      moisACloturer(c).forEach((m) => {
        const cl = clotureDe(c.id, m);
        const retard = ecartJours(todayISO(), finDeMois(m)) > JOURS_ALERTE_CLOTURE;
        if (!cl || cl.statut === "refusée" || cl.statut === "rouverte") ajout(c.responsables || [], `Clôturer ${libMois(m)} — ${c.nom}${c.type === "banque" ? " (rapprochement bancaire puis demande)" : " (compter la caisse)"}`, [cl && cl.statut === "refusée" ? `refusée par ${cl.refusePar} : ${cl.motifRefus}` : "", retard ? "en retard" : ""].filter(Boolean).join(" — "), { kind: "onglet", id: "compta" });
        if (cl && cl.statut === "demandée") ajout(!compteTenuParGerantSeul(c) && qui(P_ADMIN).filter((id) => id !== cl.demandeParId).length ? qui(P_ADMIN).filter((id) => id !== cl.demandeParId) : qui(P_GERANT), `Valider la clôture ${libMois(m)} — ${c.nom}${Math.abs(cl.ecart) > 0.01 ? ` (écart ${formatDH(cl.ecart)})` : ""}`, `demandée par ${cl.demandePar}`, { kind: "onglet", id: "compta" });
        if (retard && (!cl || cl.statut !== "validée")) ajout(qui(P_GERANT), `Clôture en retard : ${libMois(m)} — ${c.nom}`, cl ? `statut : ${cl.statut}` : "pas encore demandée", { kind: "onglet", id: "compta" });
      });
    });
    // Chèques / effets reçus arrivés à échéance dans une caisse : à remettre en banque.
    // Nils 03/10 : CFG — opérations pas encore passées sur le relevé après 30 j ; paiements rejetés à traiter.
    (comptesTreso || []).filter((c) => c.type === "banque").forEach((c) => {
      const vieilles = opsNonPassees(c.id).filter((o) => o.date && ecartJours(todayISO(), o.date) > JOURS_ALERTE_NON_PASSEE);
      if (vieilles.length) ajout(qui(P_GERANT, P_ADMIN), `${c.nom} : ${vieilles.length} opération(s) saisie(s) pas encore passée(s) sur le relevé depuis plus de ${JOURS_ALERTE_NON_PASSEE} jours`, vieilles.slice(0, 3).map((o) => `${formatDate(o.date)} ${o.designation} ${formatDH(Number(o.montant))}`).join(" · "), { kind: "onglet", id: "compta" });
    });
    (operations || []).filter((o) => o.rejete && !o.rejete.traiteLe).forEach((o) => {
      const src = o.depotDe ? (operations || []).find((x) => x.id === o.depotDe) || o : o;
      const coms = partsDossiers(src).map((x) => { const d = dossierParId(x.dossierId); return d && !d.anterieure ? idCommercialDuDevis((devisListe || []).find((v) => v.id === d.devisId) || {}) : null; }).filter(Boolean);
      ajout([...new Set([...coms, ...qui(P_GERANT)])], `Paiement rejeté : ${o.tiers || "?"} — ${formatDH(Number(o.montant))} — ${o.designation}`, o.rejete.motif ? `motif : ${o.rejete.motif}` : "relancer le client", { kind: "onglet", id: "compta" }, { rejetTraiteId: o.id });
    });
    // Nils 03/10 (s, t) : chèque passé à quelqu'un → il confirme la réception ; expiration proche → détenteur + Nils.
    chequesEnMain().forEach((o) => {
      const lib = `${o.mode.toLowerCase()} ${o.piece || ""} de ${o.tiers || "?"} — ${formatDH(Number(o.montant))}`;
      if (o.detenteurPropose) ajout([o.detenteurPropose.id], `Confirmer la réception : ${lib}`, `passé par ${o.detenteurPropose.par}`, { kind: "onglet", id: "compta" }, { chequeConfirmId: o.id });
      const exp = expirationCheque(o.echeanceCheque);
      if (exp && ecartJours(exp, todayISO()) <= JOURS_ALERTE_EXPIRATION_CHEQUE) ajout([...new Set([detenteurCheque(o), ...qui(P_GERANT)].filter(Boolean))], `Chèque bientôt périmé : ${lib} (date ${formatDate(o.echeanceCheque)})`, exp < todayISO() ? `périmé depuis le ${formatDate(exp)}` : `valable jusqu'au ${formatDate(exp)}`, { kind: "onglet", id: "compta" });
    });
    chequesEnMain().filter((o) => dateEncaissementCheque(o) && dateEncaissementCheque(o) <= todayISO() && !o.sansVisibilite).forEach((o) => {
      ajout([detenteurCheque(o)].filter(Boolean), `Déposer à la CFG : ${o.mode.toLowerCase()} ${o.piece || ""} de ${o.tiers || "?"} — ${formatDH(Number(o.montant))} (date ${formatDate(o.echeanceCheque)}${o.encaissementPrevu ? `, encaissement prévu le ${formatDate(o.encaissementPrevu)}` : ""})`, "portefeuille chèques", { kind: "onglet", id: "compta" }, { chequeOpId: o.id });
    });
    const nbMvt = (operations || []).filter(aRapprocher).length;
    if (nbMvt) ajout(qui(P_GERANT), `Trésorerie : ${nbMvt} mouvement(s) de caisse importé(s) à rapprocher`, "", { kind: "onglet", id: "compta" });
    // ERP step 16 (lot 4a) : budgets de projet dépassés (tranches par phase, livraisons).
    (chantiers || []).filter((ch) => (ch.statut || "en cours") !== "terminé" && (ch.logements || []).length).forEach((ch) => {
      const b = budgetsReelsProjet(ch);
      b.parPhase.forEach(({ p, lignes }) => lignes.filter((x) => x.sorti > x.budget + 0.001).forEach((x) => ajout(qui(P_GERANT), `Projet ${ch.nom} — ${p.nom} : budget tranches dépassé (${x.a.designation} ${x.sorti} / ${x.budget})`, "", { kind: "onglet", id: "projets" })));
      if (b.livFaites > b.livPrevues) ajout(qui(P_GERANT), `Projet ${ch.nom} : budget livraison dépassé (${b.livFaites} livraisons / ${b.livPrevues} prévues)`, "", { kind: "onglet", id: "projets" });
    });
    { const nNat = (articles || []).filter((a) => a.naturesAVerifier).length; if (nNat) ajout(qui(P_GERANT), `Catalogue : natures de ${nNat} article(s) pré-cochées à vérifier`, "pose / façonnage / livraison / RDM — filtre « Nature › Pré-cochées à vérifier »", { kind: "onglet", id: "catalogue" }); }
    const aClasser = (operations || []).filter((o) => !o.miroirDe && o.poste === POSTE_A_DEFINIR);
    if (aClasser.length) ajout(qui(P_GERANT), `Trésorerie : ${aClasser.length} opération(s) « À définir » à classer`, "", { kind: "onglet", id: "compta" });
    (comptesTreso || []).forEach((c) => {
      const n = (operations || []).filter((o) => !o.miroirDe && o.compteId === c.id && o.poste === POSTE_ENCAISSEMENT && !o.dossierId).length;
      if (n) ajout([...new Set([...(c.responsables || []), ...qui(P_GERANT), ...lecteursCompte(c).filter((id) => droitsDe(id).has("compta.relierLecteur"))])], `${c.nom} : ${n} encaissement(s) à relier à un dossier`, "", { kind: "onglet", id: "compta" });
    });
    // ERP step 12 : primes de productivité à valider → Nils.
    (primesProductivite || []).filter((x) => x.statut === "à valider").forEach((x) => ajout(qui(P_GERANT), `Prime de productivité — semaine du ${formatDate(x.lundi)} au ${formatDate(x.fin)} à valider`, "", { kind: "onglet", id: "staff" }));
    // ERP step 12 : demandes de catégorie d'outil → Nils.
    const demCat = demandesCategoriesOutil().filter((x) => x.statut === "en attente");
    if (demCat.length) ajout(qui(P_GERANT), `Catégorie(s) d'outil demandée(s) : ${demCat.map((x) => x.nom).join(", ")}`, "", { kind: "onglet", id: "outillage" });
    // ERP step 12 : suivi du personnel.
    if (Array.isArray(staff) && staff.length > 0) {
      const moisPrec = moisDecale(todayISO().slice(0, 7), -1);
      // Pointage du mois écoulé : Ahmed transmet, Sawsan valide, Nils valide les décisions d'heures.
      const recPrec = recPointage(moisPrec);
      // Profils (Nils 02/10) : chaque responsable d'équipe (droit « son équipe ») transmet le pointage de son équipe.
      const chefsEquipe = utilisateurs.filter((u) => u.actif && u.droits.has("staff.equipe") && !u.droits.has("staff.voirTout"));
      const chefsAvecEquipe = chefsEquipe.filter((m) => (staff || []).some((x) => dansPerimetre(x, staff, m.id) && staffPresentSur(x, `${moisPrec}-01`, finDeMois(moisPrec))));
      const equipeAhmed = chefsAvecEquipe.length > 0;
      // Nils 06/10 : Ahmed → usine, Sawsan → bureau + commerciaux, chacun transmet à Nils ; Nils valide ; Sawsan transmet au comptable.
      const nonValide = !recPrec || recPrec.statut !== "validé";
      if (nonValide && equipeAhmed && !partTransmise(recPrec, "usine")) ajout(chefsAvecEquipe.map((m) => m.id), `Pointage usine de ${libMois(moisPrec)} à compléter et transmettre à Nils`, "", { kind: "onglet", id: "staff" });
      if (nonValide && !partTransmise(recPrec, "bureau")) ajout(qui(P_ADMIN), `Pointage de ${libMois(moisPrec)} — bureau Marrakech et commerciaux à compléter et transmettre à Nils`, "", { kind: "onglet", id: "staff" });
      if (nonValide && recPrec && (partTransmise(recPrec, "usine") || partTransmise(recPrec, "bureau"))) ajout(qui(P_GERANT), `Pointage de ${libMois(moisPrec)} à valider (usine ${partTransmise(recPrec, "usine") ? "transmise" : "pas encore transmise"}, bureau ${partTransmise(recPrec, "bureau") ? "transmis" : "pas encore transmis"})`, "", { kind: "onglet", id: "staff" });
      (pointage || []).filter((r) => r.statut === "validé" && r.decisionsValideesLe && !r.paieExporteeLe).forEach((r) => ajout(qui(P_ADMIN), `Transmettre le pointage de ${libMois(r.mois)} au comptable (Staff › Pointage › éléments de paie)`, `validé par ${r.validePar || "Nils"}`, { kind: "onglet", id: "staff" }));
      if (recPrec && recPrec.statut === "validé" && !recPrec.decisionsValideesLe) ajout(qui(P_GERANT), `Pointage de ${libMois(moisPrec)} — décisions de fin de mois (reporter / régulariser les heures) à valider`, "", { kind: "onglet", id: "staff" });
      const semPrec = semestrePrecedent(semestreDe(todayISO()));
      const aFaire = staffAEvaluer(semPrec).filter((s) => !evaluationDe(s, semPrec));
      const pourAhmed = aFaire.filter((s) => chefsEquipe.some((m) => dansPerimetre(s, staff, m.id)));
      const pourNils = aFaire.filter((s) => !pourAhmed.includes(s));
      chefsEquipe.forEach((m) => { const n = aFaire.filter((s) => dansPerimetre(s, staff, m.id)).length; if (n) ajout([m.id], `Évaluations du ${libSemestre(semPrec)} à faire — ${n} personne(s)`, "", { kind: "onglet", id: "staff" }); });
      if (pourNils.length) ajout(qui(P_GERANT), `Évaluations du ${libSemestre(semPrec)} à faire — ${pourNils.length} personne(s)`, "", { kind: "onglet", id: "staff" });
      const aValiderEval = (staff || []).reduce((n, s) => n + (s.evaluations || []).filter((e) => !e.validee).length, 0);
      if (aValiderEval) ajout(qui(P_GERANT), `${aValiderEval} évaluation(s) à valider`, "", { kind: "onglet", id: "staff" });
    }
    const sigOuverts = (signalements || []).filter((x) => x.statut !== "Clos");
    if (sigOuverts.length) ajout(qui(P_GERANT), `${sigOuverts.length} signalement(s) ouvert(s) — à traiter`, "", { kind: "onglet", id: "staff" });
    // ERP step 11 : SAV non clôturés → pilote (commercial du dossier d'origine).
    (savListe || []).filter((x) => x.statut !== "Clôturé").forEach((x) => {
      const cl = nomClient(x.clientId);
      const aCloturer = savIntervenu(x);
      const retard = savEnRetard(x);
      ajout(pilotesSav(x), `SAV ${x.numero} (${cl}) — ${aCloturer ? "à clôturer" : "à traiter"}`, retard ? `en retard : ${joursDepuis(x.dateReclamation)} j sans intervention` : "", { kind: "sav", id: x.id });
    });
    // Devis confirmés sans BDC — ADV
    (devisListe || []).filter(estConfirmeSansBDC).forEach((d) => {
      const raisons = [];
      if (!(d.reference || "").trim()) raisons.push("réf. contremarque manquante");
      if (!(d.etage || "").trim() && lignesContiennentPose(d.lignes, articles)) raisons.push("étage manquant");
      const cl = clientDe(d.clientId);
      if (cl && cl.aValider) raisons.push(`client à valider (${etapeValidationClient(cl) === "etape2" ? "Gérant" : "Administration"})`);
      ajout(qui(P_ADV_SR, P_ADV_JR), `Devis ${d.numero} confirmé — transformer en BDC`, raisons.join(", "), { kind: "devis", id: d.id });
    });
    (commandesListe || []).forEach((c) => {
      if (c.statut === "BDC") {
        const cs = contactSurPlaceDuDossier(c);
        if (dossierAvecLogistique(c) && (!cs.nom.trim() || !cs.tel.trim())) ajout(qui(P_ADV_SR, P_ADV_JR), `Dossier ${libDossier(c)} : contact / téléphone sur place manquant`, "bloque le BPRDM", { kind: "commande", id: c.id });
      }
      if (c.statut === "RDM" || c.statut === "BDC") {
        const nonValides = articlesNonValidesDuDossier(c);
        if (nonValides.length > 0) ajout(qui(P_GERANT), `Dossier ${libDossier(c)} : article(s) à valider — ${nonValides.join(", ")}`, "bloque le PL", { kind: "commande", id: c.id });
      }
      if (c.statut === "PL") {
        if (commandeADesArticlesStock(c) && !plEstEnregistre(c)) ajout(qui(P_PROD), `PL ${c.numeroPL} : enregistrer la matière au Stock`, "bloque le BL", { kind: "commande", id: c.id });
        if (!consoProductionOK(c)) ajout(qui(P_BT), `PL ${c.numeroPL} : saisir les consommables de production (ou « Aucun »)`, "bloque le BL", { kind: "commande", id: c.id });
        if (c.enAttenteDe === "Établissement du BL") {
          const bloq = [];
          if (commandeADesArticlesStock(c) && !plEstEnregistre(c)) bloq.push("matière non enregistrée (Production Manager)");
          if (!consoProductionOK(c)) bloq.push("consommables de production (bureau technique)");
          ajout(qui(P_ADMIN), `BL à établir — ${libDossier(c)}`, bloq.length ? `en attente : ${bloq.join(", ")}` : "", { kind: "commande", id: c.id });
        }
      }
      if ((c.statut === "PL" || c.statut === "BL") && !dossierArchive(c)) {
        const ch = c.chargement || {};
        const itemsCh = itemsChargement(c);
        const nb = itemsCh.filter((it) => ch[it.cle]).length;
        if (nb < itemsCh.length) ajout(qui(P_PROD), `${libDossier(c)} : chargement ${nb}/${itemsCh.length}`, "", { kind: "commande", id: c.id });
      }
      // Nils 01/11 : dossier SAV clôturé → à archiver par le Gérant ; archivé → plus aucune tâche.
      if (c.statut === "BL" && c.enAttenteDe === EA_SAV_CLOTURE) ajout(qui(P_GERANT), `Dossier SAV ${libDossier(c)} : coûts à saisir, puis à archiver`, "SAV clôturé", { kind: "commande", id: c.id });
      if (c.statut === "BL" && !dossierArchive(c)) {
        const poseReq = fichePoseRequise(c);
        const ficheOK = !poseReq || fichePoseRemplie(c.fichePose);
        if (!ficheOK) ajout(qui(P_POSE), `${libDossier(c)} : fiche de pose à remplir`, "bloque la Facture", { kind: "commande", id: c.id });
        if (!consoPoseOK(c)) ajout(qui(P_BT), `${libDossier(c)} : saisir les consommables de pose (ou « Aucun »)`, "bloque la Facture", { kind: "commande", id: c.id });
        const bloq = [];
        if (!ficheOK) bloq.push("fiche de pose (chef poseur)");
        if (!consoPoseOK(c)) bloq.push("consommables de pose (bureau technique)");
        if (!dossierSavGratuit(c)) ajout(qui(P_ADMIN), `Facture à établir — ${libDossier(c)}`, bloq.length ? `en attente : ${bloq.join(", ")}` : "", { kind: "commande", id: c.id });
      }
    });
    // Validations
    // Documents importants manquants (dossiers non facturés).
    (commandesListe || []).filter((c) => !dossierArchive(c)).forEach((c) => {
      documentsAttendus(c).filter((x) => x.requis && !x.fourni).forEach((x) => {
        ajout(x.resp, `${libDossier(c)} : document manquant — ${x.label}`, "", { kind: "commande", id: c.id });
      });
    });
    (clients || []).filter((c) => c.aValider).forEach((c) => {
      const etape = etapeValidationClient(c);
      ajout(etape === "etape2" ? qui(P_GERANT) : qui(P_ADMIN), `Client ${c.nom} à valider${etape === "etape2" ? " (2ᵉ étape)" : ""}`, "bloque le BDC", { kind: "client", id: c.id });
    });
    (articles || []).filter((a) => articleAValider(a)).forEach((a) => {
      ajout(qui(P_GERANT), `Article Catalogue ${a.code ? a.code + " — " : ""}${a.designation} à valider`, "bloque le PL des dossiers qui l'utilisent", { kind: "article", id: a.id });
    });
    (demandesSousCat || []).filter((d) => !d.traite).forEach((d) => {
      ajout(qui(P_GERANT), `Demande de sous-catégorie : ${d.categorie} › ${d.nom} (${d.demandePar})`, "", { kind: "onglet", id: "stock" });
    });
    (demandesFournisseurs || []).filter((d) => !d.traite).forEach((d) => {
      ajout(qui(P_GERANT, P_ADMIN), `Demande de fournisseur : ${d.nom} (${d.demandePar})`, "", { kind: "onglet", id: "fournisseurs" });
    });
    if (campagneOuverte) {
      const nbLots = lotsInventaire().length;
      const nbComptes = Object.keys(campagneOuverte.lignes || {}).length;
      if (nbComptes < nbLots) ajout(qui(P_PROD), `Inventaire en cours : ${nbLots - nbComptes} lot(s) à compter`, "bloque tous les mouvements de stock", { kind: "onglet", id: "stock" });
      ajout(qui(P_GERANT), `Inventaire en cours (${nbComptes}/${nbLots} lots comptés) : valider ou annuler`, "bloque tous les mouvements de stock", { kind: "onglet", id: "stock" });
    }
    (produits || []).filter((p) => estCategorieConsommable(p.categorie) && fournisseursAutorises(p).length === 0).forEach((p) => {
      ajout(qui(P_GERANT), `Sous-catégorie ${p.nom} : aucun fournisseur autorisé`, "bloque l'enregistrement de lots", { kind: "produit", id: p.id });
    });
    // Nils 04/10 (z) : tâches manuelles (non faites).
    (tachesManuelles || []).filter((x) => !x.faiteLe).forEach((x) => {
      const retard = x.echeance && x.echeance < todayISO();
      ajout(x.qui || [], x.titre, [x.detail, x.echeance ? `${retard ? "en retard — " : ""}pour le ${formatDate(x.echeance)}` : "", `demandé par ${x.creePar}`].filter(Boolean).join(" — "), x.lien || null, { tacheManuelleId: x.id });
    });
    // Nils 04/10 (ad) : marketing — prospects Instagram, time sheet à valider ; échantillons.
    {
      const aAffecter = (prospects || []).filter((p) => p.origineMkt && p.statut === "actif" && !p.commercialId);
      if (aAffecter.length) ajout(qui(P_GERANT), `Prospects à affecter : ${aAffecter.length}`, aAffecter.slice(0, 3).map((p) => p.nom).join(", "), { kind: "onglet", id: "marketing" });
      (prospects || []).filter((p) => p.origineMkt && p.statut === "actif" && p.commercialId && p.affecteLe && !p.contacteLe && semaineProspect(p) <= lundiDe(todayISO())).forEach((p) => ajout([p.commercialId], `Prospect à contacter : ${p.nom}${p.ville ? ` (${p.ville})` : ""}`, [p.telephone, p.email, p.produitInteret, p.projet, `source ${p.source || "Instagram"}${p.recuPar ? ` (${p.recuPar})` : ""}, saisi par ${p.creePar || "?"}`, (p.reports || []).length ? `reporté ${(p.reports || []).length} fois` : ""].filter(Boolean).join(" — "), droitsDe(p.commercialId).has("commercial.rapport") ? { kind: "rapportCom", com: p.commercialId, lundi: lundiDe(todayISO()) } : { kind: "onglet", id: "alertes" }, { prospectContacteId: p.id }));
      const moisPrecMkt = ajouterMoisISO(`${todayISO().slice(0, 7)}-01`, -1, 1).slice(0, 7);
      personnesMarketing().forEach((u) => { const t = totauxMoisMkt(u.id, moisPrecMkt); if (t.heures > 0 && !moisValideMkt(u.id, moisPrecMkt)) ajout(qui(P_GERANT), `Time sheet de ${libMois(moisPrecMkt)} — ${u.nom} à valider (${String(t.heures).replace(".", ",")} h, ${formatDH(t.montant)})`, `paiement prévu le ${formatDate(ajouterMoisISO(`${moisPrecMkt}-01`, 1, JOUR_PAIEMENT_MKT))} — Caisse Nils`, { kind: "onglet", id: "marketing" }); });
      (demandesEch || []).filter((d) => d.statut === "partielle").forEach((d) => {
        const dispo = d.lignes.filter((l) => resteLigneEch(l) > 0 && stockEch(l.refId, l.format) > 0);
        if (dispo.length) ajout(qui(P_PROD), `Reste à donner ${d.numero} — ${nomUtilisateur(d.commercialId)} pour ${compteDemandeEch(d)}`, `maintenant en stock : ${dispo.map((l) => `${libRefEch(refEch(l.refId))} ${libFormatEch(l.format).toLowerCase()} ×${Math.min(resteLigneEch(l), stockEch(l.refId, l.format))}`).join(", ")}`, { kind: "echantillons" });
      });
      (demandesEch || []).filter((d) => d.statut === "demandée" || d.statut === "prête").forEach((d) => {
        const lib = `${d.numero} — ${nomUtilisateur(d.commercialId)} pour ${compteDemandeEch(d)} (${d.lignes.reduce((n, l) => n + l.qte, 0)} échantillon(s))`;
        ajout(qui(P_PROD), d.statut === "demandée" ? `Préparer les échantillons ${lib}` : `Remettre les échantillons ${lib}`, d.statut === "prête" ? "prêts — cocher « donnés au commercial » à la remise" : "", { kind: "echantillons" });
        if (d.statut === "prête") ajout([d.commercialId], `Échantillons ${d.numero} prêts à l'usine — pour ${compteDemandeEch(d)}`, "", { kind: "echantillons" });
      });
    }
    // Nils 04/10 (aa) : réponse à un bug signalé → tâche « Vu » pour le déclarant.
    (bugs || []).filter((b) => b.declarantVu === false && b.parId).forEach((b) => {
      ajout([b.parId], `Bug ${b.numero} ${b.statut} — ${b.description.length > 70 ? b.description.slice(0, 70) + "…" : b.description}`, b.reponse ? `réponse : ${b.reponse}` : "", null, { bugVuId: b.id });
    });
    // ERP step 13 (ah7) : rapport commercial — à soumettre dès le vendredi, à lire par Nils,
    // actions datées des visites, taux de commission d'apporteur à fixer.
    {
      const auj = todayISO();
      const depuis = lundiDe(RAPPORT_COM_DEPUIS);
      commerciauxAvecTache().forEach((u) => {
        for (let l = depuis; decalerJours(l, 4) <= auj; l = decalerJours(l, 7)) {
          if (!rapportComFige(u.id, l)) ajout([u.id], `Soumettre le rapport commercial ${libelleSemaine(l)}`, decalerJours(l, 6) < auj ? "en retard" : "", { kind: "rapportCom", com: u.id, lundi: l });
        }
      });
      (rapportsCom || []).filter((r) => r.statut === "soumis").forEach((r) => {
        ajout(qui(P_GERANT), `Lire le rapport commercial ${libelleSemaine(r.lundi)} — ${nomUtilisateur(r.commercialId) || r.commercialId}`, "", { kind: "rapportCom", com: r.commercialId, lundi: r.lundi });
      });
      (visites || []).forEach((v) => {
        (v.actions || []).filter((a) => !a.faite && a.echeance && a.echeance <= auj).forEach((a) => {
          ajout([v.commercialId], `Action commerciale — ${nomCompteVisite(v)} : ${a.texte}`, `prévue le ${formatDate(a.echeance)}`, { kind: "rapportCom", com: v.commercialId, lundi: lundiDe(v.date) });
        });
      });
      (prospects || []).filter((p) => (p.statut || "actif") !== "perdu" && prospectParticulier(p) && p.source === "Apporteur" && p.commissionConvenue === true && (p.tauxCommission === "" || p.tauxCommission === undefined)).forEach((p) => {
        ajout(qui(P_GERANT), `Fixer le taux de commission — apporteur ${p.apporteur} (prospect ${p.nom}, ${nomUtilisateur(p.commercialId)})`, "", { kind: "rapportCom", com: p.commercialId, prospects: true });
      });
      // Step 17 : crédit des factures d'avoir à affecter (Sawsan, à la main).
      (avoirs || []).filter((a) => creditRestantAvoir(a) > 0.01).forEach((a) => {
        ajout(qui(P_ADMIN), `Affecter le crédit de l'avoir ${a.numero} — ${(clientDe(a.clientId) || {}).nom || ""}`, `${formatDH(creditRestantAvoir(a))} à affecter (État de compte du client › Affecter)`, { kind: "client", id: a.clientId });
      });
      // ERP step 15 (ar) : planning — alertes ciblées (retards, messages d'Ahmed) avec « Vu », RDM passé non fait.
      ((planning && planning.notifs) || []).forEach((n) => {
        const pour = (n.pour || []).filter((id) => !(n.vus || {})[id]);
        if (pour.length) ajout(pour, n.texte, n.detail, n.dossierId ? { kind: "planning", id: n.dossierId } : { kind: "onglet", id: "planning" }, { planNotifId: n.id });
      });
      ((planning && planning.items) || []).filter((x) => x.type === "rdm" && !x.fait && x.date < auj).forEach((x) => {
        const c = dossierParId(x.dossierId);
        if (c) ajout(qui(P_PROD), `RDM du ${formatDate(x.date)} non fait — ${libDossierPlan(c)}`, "marquer fait, ou replanifier avec la raison", { kind: "planning", id: c.id });
      });
      // ERP step 15 (am) : contrôle des boîtes revendeurs (commercial), matériel marketing sous le seuil (Ahmed).
      ((echSuivi && echSuivi.boites) || []).filter((b) => b.active !== false).forEach((b) => {
        const pc = prochainControleBoite(b);
        if (pc && pc <= auj && utilisateurs.some((u) => u.id === b.commercialId && u.actif)) ajout([b.commercialId], `Contrôler la boîte ${b.numero} chez ${compteDemandeEch(b)}`, `prévu le ${formatDate(pc)}`, { kind: "echantillons" });
      });
      (echantillons || []).filter((e) => estMatEch(e) && !e.horsProduction && nombreOuZero(e.seuil) > 0 && stockEch(e.id, FORMAT_MAT.cle) <= nombreOuZero(e.seuil)).forEach((e) => {
        ajout(qui(P_PROD), `Matériel marketing à réapprovisionner : ${libRefEch(e)}`, `${stockEch(e.id, FORMAT_MAT.cle)} en stock (seuil ${e.seuil})`, { kind: "echantillons" });
      });
      // ERP step 15 (al) : fiches de déplacement — clôture au retour (Ahmed), avance à solder (caisse usine), validation (Nils).
      (deplacements || []).filter((d) => d.statut).forEach((d) => {
        const lib = `déplacement du ${formatDate(d.date)}${d.dateFin && d.dateFin > d.date ? ` au ${formatDate(d.dateFin)}` : ""} — ${(zoneDe(d.zoneId) || {}).nom || ""}`;
        const fin = d.dateFin || d.date;
        if (d.statut === "en cours" && fin < auj) ajout(qui(P_PROD), `Clôturer le ${lib}`, "dépenses, avance, puis « Retour terminé — envoyer au Gérant »", { kind: "deplacement", id: d.id });
        if (d.statut !== "validée" && fin < auj && avanceDepl(d) && !reglementDepl(d)) {
          const resp = ((compteDe(CAISSE_AVANCE_DEPL) || {}).responsables || []).filter((id) => utilisateurs.some((u) => u.id === id && u.actif));
          if (resp.length) ajout(resp, `Solder l'avance du ${lib}`, `${formatDH(nombreOuZero(avanceDepl(d).montant))} remis à ${avanceDepl(d).tiers}`, { kind: "deplacement", id: d.id });
        }
        if (d.statut === "à valider") ajout(qui(P_GERANT), `Valider la fiche du ${lib}`, d.envoyePar ? `envoyée par ${d.envoyePar}` : "", { kind: "deplacement", id: d.id });
      });
      // Pose hors Casablanca sans fiche de déplacement « Pose » : tâche à Ahmed.
      (commandesListe || []).filter((c) => !c.anterieure && c.fichePose && dossierPose(c)).forEach((c) => {
        const dp = dateDebutPose(c.fichePose);
        if (!dp || dp < DEPL_POSE_DEPUIS || !horsCasablanca(c)) return;
        if (deplacementsDuDossier(c.id).some((d) => d.type === "Pose")) return;
        const z = zoneDuDossier(c);
        ajout(qui(P_PROD), `Fiche de déplacement à faire — pose ${c.numero}${z ? ` (${z.nom})` : ""}`, `pose du ${formatDate(dp)}`, { kind: "commande", id: c.id });
      });
      // ERP step 15 (ak) : relevé km + tickets du vendredi (conducteurs habituels + Ahmed ; Nils reçoit l'alerte du lundi).
      if (flotte && flotte.init) {
        const F = vendrediDe(auj);
        vehiculesFlotte().filter((v) => v.actif !== false && (v.creeLe || "") <= F && !releveCouvert(v.id, F)).forEach((v) => {
          const dest = [...new Set([...(v.conducteurs || []).filter((id) => { const u = utilisateurs.find((x) => x.id === id); return u && u.actif && u.profil !== P_GERANT; }), ...qui(P_PROD)])];
          if (dest.length) ajout(dest, `Relevé km et tickets de la semaine — ${v.nom}`, `vendredi ${formatDate(F)}`, { kind: "releveVehicule", id: v.id });
        });
        // Échéances (assurance, vignette, visite technique, leasing, GPS) : tâche Sawsan 30 jours avant.
        vehiculesFlotte().filter((v) => v.actif !== false).forEach((v) => TYPES_ECHEANCE_VEHICULE.forEach(([k, lib]) => {
          const e = (v.echeances || {})[k];
          if (!e || !e.date || e.date > decalerJours(auj, 30)) return;
          ajout(qui(P_ADMIN), `Échéance ${lib.toLowerCase()} — ${v.nom} le ${formatDate(e.date)}`, e.date < auj ? "dépassée" : "à renouveler", { kind: "vehicule", id: v.id });
        }));
      }
      // ERP step 15 (Nils 08/10) : en décembre, avoirs des tranches en exposition encore à demander.
      if (auj.slice(5, 7) === "12") {
        const aDem = (expositions || []).filter((e) => e.statutAvoir === "a_demander");
        if (aDem.length) {
          const fs = [...new Set(aDem.map((e) => e.fournisseur).filter(Boolean))];
          ajout(qui(P_GERANT), `Demander les avoirs des tranches en exposition (${aDem.length} ligne${aDem.length > 1 ? "s" : ""})`, fs.join(", "), { kind: "expo" });
        }
      }
      // ERP step 14 (aj16) : taux de l'apporteur à fixer sur chaque devis.
      (devisListe || []).filter((d) => d.apporteurAffaire && String(d.tauxApporteur ?? "").trim() === "" && !estHorsVueActive(d) && d.statut !== "Brouillon").forEach((d) => {
        ajout(qui(P_GERANT), `Fixer le taux de l'apporteur ${d.apporteurAffaire} — devis ${d.numero} (${(clientDe(d.clientId) || {}).nom || ""})`, "", { kind: "devis", id: d.id });
      });
    }
    return t;
  })();
  const mesTaches = tachesEquipe.filter((x) => x.qui.includes(user.id));
  const alertesNonVues = (alertes || []).filter((a) => !a.vu);
  const compteurAlertesTaches = mesTaches.length + (peut("taches.voirTout") ? alertesNonVues.length : 0);
  // ERP step 11 : pastille de l'onglet SAV = SAV non clôturés visibles (rouge si l'un est en retard).
  const savOuvertsVisibles = (savListe || []).filter((t) => t.statut !== "Clôturé" && (!user.commandesRestreintACommercial || pilotesSav(t).includes(user.id)));
  const savRetardVisible = savOuvertsVisibles.some(savEnRetard);
  function ouvrirLienAlerte(lien) {
    if (!lien) return;
    if (lien.kind === "commande") { setActiveTab("commandes"); fermerFiche(); ouvrirCommande(lien.id); }
    else if (lien.kind === "devis") { setActiveTab("devis"); ouvrirDevis(lien.id); }
    else if (lien.kind === "client") { const c = (clients || []).find((x) => x.id === lien.id); setActiveTab("clients"); fermerFiche(); if (c) openClientEdit(c); }
    else if (lien.kind === "article") { const a = (articles || []).find((x) => x.id === lien.id); setActiveTab("catalogue"); fermerFiche(); if (a) ouvrirArticle(a); }
    else if (lien.kind === "produit") { const p = (produits || []).find((x) => x.id === lien.id); setActiveTab("stock"); fermerFiche(); if (p && peutEcrireStock) openProduitEdit(p); }
    else if (lien.kind === "onglet") { setActiveTab(lien.id); fermerFiche(); }
    else if (lien.kind === "sav") { setActiveTab("sav"); fermerFiche(); ouvrirTicketSav(lien.id); }
    else if (lien.kind === "planning") { setActiveTab("planning"); fermerFiche(); if (lien.id) setPlanDossier(lien.id); }
    else if (lien.kind === "deplacement") { const d = (deplacements || []).find((x) => x.id === lien.id); setActiveTab("commandes"); fermerFiche(); if (d) { setShowDeplacements(true); setDeplMois(String(d.date).slice(0, 7)); setDeplEdit({ ...d, participants: (d.participants || []).map((x) => ({ ...x })), frais: { ...(d.frais || {}) }, vehicules: (d.vehicules || []).map((v) => ({ ...v })) }); } }
    else if (lien.kind === "releveVehicule") { const v = vehiculeParId(lien.id); if (v && peutReleverVehicule(v)) setReleveEdit(nouveauReleve(v.id)); else setNotice("Ce véhicule n'existe plus ou n'est pas le tien."); }
    else if (lien.kind === "vehicule") { setActiveTab("flotte"); fermerFiche(); const v = vehiculeParId(lien.id); if (v && peutGererVehicules) setVehEdit(JSON.parse(JSON.stringify(v))); }
    else if (lien.kind === "expo") { setActiveTab("commandes"); fermerFiche(); setExpoEdit(null); setShowExpo(true); }
    else if (lien.kind === "echantillons") { setActiveTab("stock"); fermerFiche(); setStockVue("echantillons"); }
    else if (lien.kind === "rapportCom") { setActiveTab("rapportCommercial"); fermerFiche(); setRcVue(lien.prospects ? "prospects" : "semaine"); if (lien.com) setRcCom(lien.com); if (lien.lundi) setRcLundi(lien.lundi); }
  }
  async function marquerAlerteVue(id) {
    await persistAlertes((alertes || []).map((a) => (a.id === id ? { ...a, vu: true, vuLe: new Date().toISOString() } : a)));
  }
  async function marquerToutesAlertesVues() {
    const maintenant = new Date().toISOString();
    await persistAlertes((alertes || []).map((a) => (a.vu ? a : { ...a, vu: true, vuLe: maintenant })));
  }

  return (
    <div style={{ display: "flex", fontFamily: "'DM Sans', sans-serif", background: PIERRE, minHeight: "100%", color: ENCRE }}>
      {storageOk === false && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999, background: ROUILLE, color: "#fff", padding: "10px 16px", fontSize: 13, fontWeight: 600, textAlign: "center" }}>
          ⚠️ Le stockage ne fonctionne pas dans cet artefact — rien de ce que tu saisis n'est réellement sauvegardé. Vérifie que l'artefact est bien publié (bouton « Publier »). Exporte tes données par précaution avant de continuer.
        </div>
      )}
      <aside style={{ width: 224, flexShrink: 0, background: "#fff", borderRight: `1px solid ${PIERRE}`, padding: "24px 16px", display: "flex", flexDirection: "column", boxSizing: "border-box" }}>
        <img src={LOGO_SRC} alt="Stone Concept" style={{ height: 40, width: "auto", display: "block", marginBottom: 28 }} />
        <nav style={{ display: "flex", flexDirection: "column", gap: 2, flex: 1 }}>
          {(() => {
            const ids = new Set(onglets.map((t) => t.id));
            const ranges = new Set(RUBRIQUES_NAV.flatMap(([, l]) => l));
            const rubriques = [...RUBRIQUES_NAV.map(([titre, l]) => [titre, l.filter((id) => ids.has(id))]), ["Autres", onglets.map((t) => t.id).filter((id) => !ranges.has(id))]].filter(([, l]) => l.length);
            // Nils 10/10 : rubriques bien distinctes des onglets (titre foncé + filet, onglets en retrait).
            const btn = (t, sousRubrique) => (
            <button key={t.id} type="button" className="sc-btn" onClick={() => { setActiveTab(t.id); fermerFiche(); }}
                style={{ textAlign: "left", padding: sousRubrique ? "7px 12px 7px 26px" : "10px 12px", borderRadius: 6, fontSize: sousRubrique ? 13 : 14, fontWeight: sousRubrique ? 500 : 700, background: estOngletActif(t.id) ? PIERRE : "transparent", color: estOngletActif(t.id) ? ENCRE : sousRubrique ? TAUPE : ENCRE, borderLeft: sousRubrique ? `2px solid ${estOngletActif(t.id) ? ENCRE : "transparent"}` : "none", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 6 }}>
                <span>{t.label}</span>
                {t.id === "alertes" && compteurAlertesTaches > 0 && (
                  <span style={{ background: ROUILLE, color: "#fff", borderRadius: 10, fontSize: 11, padding: "1px 7px", fontWeight: 700 }}>{compteurAlertesTaches}</span>
                )}
                {t.id === "commandes" && savOuvertsVisibles.length > 0 && (
                  <span title={savRetardVisible ? "SAV non clôturés — au moins un en retard" : "SAV non clôturés"} style={{ background: savRetardVisible ? ROUILLE : TAUPE, color: "#fff", borderRadius: 10, fontSize: 11, padding: "1px 7px", fontWeight: 700 }}>{savOuvertsVisibles.length}</span>
                )}
              </button>
            );
            return rubriques.map(([titre, l], i) => {
              // Nils 10/10 : une rubrique se replie même si l'onglet ouvert est dedans (son titre est alors surligné).
              const replie = !!titre && navReplie.includes(titre);
              const contientActif = l.some((id) => estOngletActif(id));
              return (
                <div key={titre || `_${i}`} style={{ marginBottom: titre ? 2 : 4, marginTop: i > 0 ? 6 : 0, paddingTop: i > 0 ? 6 : 0, borderTop: i > 0 ? `1px solid ${PIERRE}` : "none" }}>
                  {titre && (
                    <button type="button" className="sc-btn" onClick={() => basculerRubriqueNav(titre)} title={replie ? "Déplier" : "Replier"} style={{ display: "flex", alignItems: "center", gap: 8, width: "100%", background: replie && contientActif ? PIERRE : "transparent", borderRadius: 6, padding: "8px 12px", fontSize: 12, fontWeight: 700, color: ENCRE, textTransform: "uppercase", letterSpacing: 1, cursor: "pointer", textAlign: "left" }}>
                      <span style={{ width: 10, fontSize: 11 }}>{replie ? "▸" : "▾"}</span>
                      <span style={{ flex: 1 }}>{titre}</span>
                      {replie && <span style={{ fontSize: 10, fontWeight: 600, color: TAUPE, letterSpacing: 0 }}>{l.length}</span>}
                    </button>
                  )}
                  {!replie && l.map((id) => btn(onglets.find((t) => t.id === id), !!titre))}
                </div>
              );
            });
          })()}
          {ongletsAVenir.map((t) => (
            <div key={t.id} style={{ padding: "10px 12px", fontSize: 13, fontWeight: 600, color: `${TAUPE}88` }}>
              {t.label} <span style={{ fontSize: 10, fontWeight: 400 }}>· bientôt</span>
            </div>
          ))}
        </nav>
        {/* Nils 01/11 : onglet Communication, pastille ⚠ tant qu'il reste quelque chose à lire. */}
        <button type="button" className="sc-btn" onClick={() => { fermerFiche(); setActiveTab("communication"); }} style={{ display: "flex", alignItems: "center", gap: 8, width: "100%", marginTop: 12, padding: "10px 12px", borderRadius: 6, background: activeTab === "communication" ? PIERRE : "transparent", fontSize: 14, fontWeight: 600, color: ENCRE, textAlign: "left", cursor: "pointer" }}>
          <span style={{ flex: 1, whiteSpace: "nowrap" }}>📢 Communication</span>
          {comALire.length > 0 && <span title={`${comALire.length} communication(s) à lire`} style={{ background: ROUILLE, color: "#fff", borderRadius: 10, fontSize: 11, padding: "1px 7px", fontWeight: 700 }}>⚠ {comALire.length}</span>}
        </button>
        <div style={{ paddingTop: 16, marginTop: 16, borderTop: `1px solid ${PIERRE}` }}>
          {/* Étape d (Nils 16/10) : connexion réelle — « Je suis » remplacé par le compte connecté. */}
          <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Connecté</div>
          <div style={{ fontSize: 13, color: ENCRE, fontWeight: 600 }}>{user.nom} <span style={{ fontWeight: 400, color: TAUPE }}>— {user.role}</span></div>
          {session && (
            <button type="button" className="sc-btn" onClick={() => session.deconnecter()} style={{ ...ghostBtnStyle, marginTop: 6, fontSize: 12, padding: "6px 0" }}>
              ⎋ Se déconnecter
            </button>
          )}
          <button type="button" className="sc-btn" onClick={() => setBugEdit({ onglet: (onglets.find((t) => t.id === activeTab) || {}).label || activeTab || "", gravite: "Gênant", description: "" })} style={{ ...ghostBtnStyle, marginTop: 10, fontSize: 11, padding: "6px 0" }}>
            🐞 Signaler un bug
          </button>
          {/* Nils 08/10 (u) : signalement possible pour tous, même sans accès à Staff. */}
          <button type="button" className="sc-btn" onClick={() => setSignalementEdit({ date: todayISO(), personnes: [], type: "", gravite: "Moyenne", description: "", recherche: "" })} style={{ ...ghostBtnStyle, marginTop: 2, fontSize: 11, padding: "6px 0", display: "block" }}>
            📣 Signaler une personne
          </button>
          {(signalements || []).some((x) => x.auteurId === user.id) && (
            <button type="button" className="sc-btn" onClick={() => setMesSignalementsOuverts(true)} style={{ ...ghostBtnStyle, marginTop: 0, fontSize: 11, padding: "2px 0", display: "block" }}>
              Mes signalements ({(signalements || []).filter((x) => x.auteurId === user.id).length})
            </button>
          )}
          {bugEdit && (
            <Overlay onClose={() => setBugEdit(null)}>
              <div style={modalStyle(480)}>
                <div style={modalTitleStyle}>🐞 Signaler un bug</div>
                <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 12 }}>{user.nom} — {formatDate(todayISO())}</div>
                <Field label="Onglet concerné">
                  <select className="sc-select" value={bugEdit.onglet} onChange={(e) => setBugEdit({ ...bugEdit, onglet: e.target.value })} style={selectStyle}>
                    {[...new Set([bugEdit.onglet, ...onglets.map((t) => t.label)].filter(Boolean))].map((l) => (<option key={l} value={l}>{l}</option>))}
                  </select>
                </Field>
                <Field label="Gravité">
                  <div style={{ display: "flex", gap: 14, fontSize: 13 }}>
                    {GRAVITES_BUG.map((g) => (<label key={g} style={{ display: "flex", alignItems: "center", gap: 6 }}><input type="radio" checked={bugEdit.gravite === g} onChange={() => setBugEdit({ ...bugEdit, gravite: g })} />{g}</label>))}
                  </div>
                </Field>
                <Field label="Que s'est-il passé ? (ce que tu faisais, ce que tu attendais, ce qui s'est produit)">
                  <textarea className="sc-input" rows={5} value={bugEdit.description} onChange={(e) => setBugEdit({ ...bugEdit, description: e.target.value })} style={{ ...inputStyle(), width: "100%", boxSizing: "border-box", fontFamily: "inherit" }} />
                </Field>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 12 }}>
                  <button type="button" className="sc-btn" onClick={() => setBugEdit(null)} style={ghostBtnStyle}>Annuler</button>
                  <button type="button" className="sc-btn" onClick={signalerBug} style={primaryBtnStyle}>Envoyer</button>
                </div>
              </div>
            </Overlay>
          )}
          {tsEdit && (
            <Overlay onClose={() => setTsEdit(null)}>
              <div style={modalStyle(480)}>
                <div style={modalTitleStyle}>{tsEdit.id ? "Modifier la ligne" : "Nouvelle ligne"} — time sheet</div>
                <div style={{ display: "flex", gap: 10 }}>
                  <Field label="Date"><input type="date" className="sc-input" value={tsEdit.date} max={todayISO()} min={estGerant ? undefined : decalerJours(todayISO(), -JOURS_VERROU_TIMESHEET)} onChange={(e) => setTsEdit({ ...tsEdit, date: e.target.value })} style={inputStyle(160)} /></Field>
                  <Field label="Durée (heures)"><input className="sc-input" value={tsEdit.duree} onChange={(e) => setTsEdit({ ...tsEdit, duree: e.target.value })} placeholder="ex. 2,5" style={inputStyle(110)} /></Field>
                </div>
                <Field label="Type d'activité">
                  <select className="sc-select" value={tsEdit.type} onChange={(e) => setTsEdit({ ...tsEdit, type: e.target.value })} style={selectStyle}>
                    <option value="">— Choisir —</option>
                    {TYPES_ACTIVITE_MKT.map((t) => (<option key={t} value={t}>{t}</option>))}
                  </select>
                </Field>
                <Field label="Description"><textarea className="sc-input" rows={3} value={tsEdit.description} onChange={(e) => setTsEdit({ ...tsEdit, description: e.target.value })} style={{ ...inputStyle(), width: "100%", boxSizing: "border-box", fontFamily: "inherit" }} /></Field>
                <Field label="Lien (post Instagram…) — facultatif"><input className="sc-input" value={tsEdit.lien} onChange={(e) => setTsEdit({ ...tsEdit, lien: e.target.value })} style={{ ...inputStyle(), width: "100%", boxSizing: "border-box" }} /></Field>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 12 }}>
                  <button type="button" className="sc-btn" onClick={() => setTsEdit(null)} style={ghostBtnStyle}>Annuler</button>
                  <button type="button" className="sc-btn" onClick={enregistrerLigneTs} style={primaryBtnStyle}>Enregistrer</button>
                </div>
              </div>
            </Overlay>
          )}
          {boosterEdit && (
            <Overlay onClose={() => setBoosterEdit(null)}>
              <div style={modalStyle(460)}>
                <div style={modalTitleStyle}>Produit à booster</div>
                <Field label="Article du catalogue (tranche, évier, accessoire)">
                  <select className="sc-select" value={boosterEdit.articleId || ""} onChange={(e) => { const a = (articles || []).find((x) => x.id === e.target.value); setBoosterEdit({ ...boosterEdit, articleId: e.target.value, produit: a ? `${a.designation}${a.code ? ` (${a.code})` : ""}` : boosterEdit.produit }); }} style={selectStyle}>
                    <option value="">— Aucun (texte libre ci-dessous) —</option>
                    {["Tranche", "Éviers", "Accessoires"].map((cat) => {
                      const l = (articles || []).filter((a) => a.categorie === cat).sort((a, b) => (a.designation || "").localeCompare(b.designation || "", "fr"));
                      return l.length ? (<optgroup key={cat} label={cat}>{l.map((a) => (<option key={a.id} value={a.id}>{a.designation}{a.code ? ` (${a.code})` : ""}</option>))}</optgroup>) : null;
                    })}
                  </select>
                </Field>
                <Field label="Libellé affiché">
                  <input className="sc-input" value={boosterEdit.produit} onChange={(e) => setBoosterEdit({ ...boosterEdit, produit: e.target.value })} placeholder="ex. Calacatta Viola 12 mm, ou une couleur" style={{ ...inputStyle(), width: "100%", boxSizing: "border-box" }} />
                </Field>
                <div style={{ display: "flex", gap: 10 }}>
                  <Field label="Du"><input type="date" className="sc-input" value={boosterEdit.du} onChange={(e) => setBoosterEdit({ ...boosterEdit, du: e.target.value })} style={inputStyle(160)} /></Field>
                  <Field label="Au (facultatif)"><input type="date" className="sc-input" value={boosterEdit.au} onChange={(e) => setBoosterEdit({ ...boosterEdit, au: e.target.value })} style={inputStyle(160)} /></Field>
                </div>
                <Field label="Consigne (facultatif)"><textarea className="sc-input" rows={2} value={boosterEdit.consigne} onChange={(e) => setBoosterEdit({ ...boosterEdit, consigne: e.target.value })} style={{ ...inputStyle(), width: "100%", boxSizing: "border-box", fontFamily: "inherit" }} /></Field>
                <div style={{ fontSize: 11, color: TAUPE }}>Visible par le marketing (onglet Marketing) et les commerciaux (Rapport commercial).</div>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 12 }}>
                  <button type="button" className="sc-btn" onClick={() => setBoosterEdit(null)} style={ghostBtnStyle}>Annuler</button>
                  <button type="button" className="sc-btn" onClick={enregistrerBooster} style={primaryBtnStyle}>Enregistrer</button>
                </div>
              </div>
            </Overlay>
          )}
          {prospectMkt && (
            <Overlay onClose={() => setProspectMkt(null)}>
              <div style={modalStyle(500)}>
                <div style={modalTitleStyle}>{prospectMkt.id ? "Prospect" : "Nouveau prospect"}</div>
                {prospectMkt.creePar && <div style={{ fontSize: 12, color: TAUPE, marginTop: -6, marginBottom: 10 }}>Saisi par {prospectMkt.creePar}{prospectMkt.creeLe ? ` le ${formatDateHeure(prospectMkt.creeLe)}` : ""}</div>}
                <div style={{ display: "flex", gap: 10 }}>
                  <Field label="Source — comment il nous a connus" style={{ flex: 1 }}>
                    <select className="sc-select" value={prospectMkt.source || ""} onChange={(e) => setProspectMkt({ ...prospectMkt, source: e.target.value })} style={selectStyle}>
                      <option value="">— Choisir —</option>
                      {[...new Set([...sourcesClient(), ...(prospectMkt.source ? [prospectMkt.source] : [])])].map((x) => (<option key={x} value={x}>{x}</option>))}
                    </select>
                  </Field>
                  <Field label="Reçu par" style={{ flex: 1 }}>
                    <select className="sc-select" value={prospectMkt.recuPar || ""} onChange={(e) => setProspectMkt({ ...prospectMkt, recuPar: e.target.value })} style={selectStyle}>
                      <option value="">— Choisir —</option>
                      {RECU_PAR_PROSPECT.map((x) => (<option key={x} value={x}>{x}</option>))}
                    </select>
                  </Field>
                  <Field label="Date du contact" style={{ flex: 1 }}><input type="date" className="sc-input" value={prospectMkt.dateContact} max={todayISO()} onChange={(e) => setProspectMkt({ ...prospectMkt, dateContact: e.target.value })} style={{ ...inputStyle(), width: "100%", boxSizing: "border-box" }} /></Field>
                </div>
                <div style={{ display: "flex", gap: 10 }}>
                  <Field label="Nom" style={{ flex: 1.3 }}><input className="sc-input" value={prospectMkt.nom} onChange={(e) => setProspectMkt({ ...prospectMkt, nom: e.target.value })} style={{ ...inputStyle(), width: "100%", boxSizing: "border-box" }} /></Field>
                  {/* Nils 20/10 : type du prospect (même liste que la fiche client), repris à sa transformation en client. */}
                  <Field label="Type" style={{ flex: 1 }}>
                    <select className="sc-select" value={prospectMkt.type || TYPE_SANS_ICE} onChange={(e) => setProspectMkt({ ...prospectMkt, type: e.target.value })} style={selectStyle}>
                      {TYPES_CLIENT.map((t) => (<option key={t} value={t}>{t}</option>))}
                    </select>
                  </Field>
                </div>
                <div style={{ display: "flex", gap: 10 }}>
                  <Field label="Téléphone" style={{ flex: 1 }}><input className="sc-input" value={prospectMkt.telephone} onChange={(e) => setProspectMkt({ ...prospectMkt, telephone: e.target.value })} style={{ ...inputStyle(), width: "100%", boxSizing: "border-box" }} /></Field>
                  <Field label="Mail" style={{ flex: 1 }}><input className="sc-input" value={prospectMkt.email || ""} onChange={(e) => setProspectMkt({ ...prospectMkt, email: e.target.value })} style={{ ...inputStyle(), width: "100%", boxSizing: "border-box" }} /></Field>
                  <Field label="Ville" style={{ flex: 1 }}><input className="sc-input" value={prospectMkt.ville} onChange={(e) => setProspectMkt({ ...prospectMkt, ville: e.target.value })} style={{ ...inputStyle(), width: "100%", boxSizing: "border-box" }} /></Field>
                </div>
                <Field label="Projet"><textarea className="sc-input" rows={2} value={prospectMkt.projet} onChange={(e) => setProspectMkt({ ...prospectMkt, projet: e.target.value })} placeholder="ex. cuisine + îlot, villa en construction, livraison mars" style={{ ...inputStyle(), width: "100%", boxSizing: "border-box", fontFamily: "inherit" }} /></Field>
                <Field label="Produit qui l'intéresse"><input className="sc-input" value={prospectMkt.produitInteret} onChange={(e) => setProspectMkt({ ...prospectMkt, produitInteret: e.target.value })} style={{ ...inputStyle(), width: "100%", boxSizing: "border-box" }} /></Field>
                <Field label="Lien du message / du post (facultatif)"><input className="sc-input" value={prospectMkt.lien || ""} onChange={(e) => setProspectMkt({ ...prospectMkt, lien: e.target.value })} style={{ ...inputStyle(), width: "100%", boxSizing: "border-box" }} /></Field>
                <div style={{ fontSize: 11, color: TAUPE }}>Au moins un téléphone, un mail ou le lien du message. Le Gérant affecte ensuite le prospect à un commercial ; il le retrouve dans ses tâches et son rapport commercial.</div>
                {(prospectMkt.doublons || []).length > 0 && (
                  <div style={{ fontSize: 12, background: "#F6E3DC", color: ROUILLE, borderRadius: 8, padding: "8px 12px", marginTop: 10 }}>
                    <b>Doublon possible</b> (même téléphone ou même mail) : {(prospectMkt.doublons || []).map((id) => { const d = prospectDe(id) || {}; return `${d.nom || ""}${d.source ? ` (${d.source})` : ""} — saisi par ${d.creePar || "?"}${d.creeLe ? ` le ${formatDate(d.creeLe.slice(0, 10))}` : ""}${d.commercialId ? `, affecté à ${nomUtilisateur(d.commercialId)}` : ""}${d.statut && d.statut !== "actif" ? `, ${d.statut}` : ""}`; }).join(" · ")}.
                  </div>
                )}
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 12 }}>
                  <button type="button" className="sc-btn" onClick={() => setProspectMkt(null)} style={ghostBtnStyle}>Annuler</button>
                  {(prospectMkt.doublons || []).length > 0 ? <button type="button" className="sc-btn" onClick={() => enregistrerProspectMkt(true)} style={{ ...primaryBtnStyle, background: ROUILLE }}>Enregistrer quand même</button> : <button type="button" className="sc-btn" onClick={() => enregistrerProspectMkt(false)} style={primaryBtnStyle}>Enregistrer</button>}
                </div>
              </div>
            </Overlay>
          )}
          {(demandeEchEdit || entreeEch || inventaireEch) && (() => {
            // Tableau de saisie des échantillons (demande, entrée ou inventaire) — basé sur la checklist.
            const estDemande = !!demandeEchEdit;
            const estInventaire = !estDemande && !entreeEch;
            const f = demandeEchEdit || entreeEch || inventaireEch;
            const setF = (patch) => (estDemande ? setDemandeEchEdit({ ...f, ...patch }) : estInventaire ? setInventaireEch({ ...f, ...patch }) : setEntreeEch({ ...f, ...patch }));
            const q = echRechercheModal.trim().toLowerCase();
            // ERP step 15 (am) : échantillons ou matériel marketing (une boîte revendeur = échantillons seulement).
            const typeM = f && f.boite ? "ech" : echTypeModal;
            const refs = [...(echantillons || [])].filter((e) => (typeM === "mat" ? estMatEch(e) : !estMatEch(e)) && (echVoirHP || !e.horsProduction || (f.lignes || {})[e.id]) && (typeM === "mat" || !echGamme || (e.gamme || "Infinity") === echGamme) && (!q || `${e.couleur} ${e.finition} ${e.code || ""} ${e.designation || ""}`.toLowerCase().includes(q))).sort((a, b) => (a.gamme || "").localeCompare(b.gamme || "") || (a.ordre || 0) - (b.ordre || 0));
            const val = (id, fm) => ((f.lignes || {})[id] || {})[fm] || "";
            const setVal = (id, fm, v) => setF({ lignes: { ...(f.lignes || {}), [id]: { ...((f.lignes || {})[id] || {}), [fm]: v } } });
            const nbSaisis = Object.entries(f.lignes || {}).filter(([id, x]) => formatsRefEch(refEch(id)).some((fm) => Number(String((x || {})[fm.cle] || "").replace(",", ".")))).length;
            const comsDem = utilisateurs.filter((u) => u.actif && u.droits.has("echantillons.demander") && u.profil !== P_GERANT);
            const clientsDem = (clients || []).filter((c) => !c.archive && (estGerant || clientVisiblePourUser(c))).sort((a, b) => a.nom.localeCompare(b.nom, "fr"));
            const prospectsDem = (prospects || []).filter((p) => p.statut === "actif" && (estGerant || p.commercialId === user.id)).sort((a, b) => a.nom.localeCompare(b.nom, "fr"));
            const fermer = () => (estDemande ? setDemandeEchEdit(null) : estInventaire ? setInventaireEch(null) : setEntreeEch(null));
            return (
              <Overlay onClose={fermer}>
                <div style={{ ...modalStyle(820), maxHeight: "90vh", display: "flex", flexDirection: "column" }}>
                  <div style={modalTitleStyle}>{estDemande ? (f.boite ? "📦 Nouvelle boîte revendeur" : "🎁 Demande d'échantillons / matériel") : estInventaire ? (typeM === "mat" ? "Inventaire du matériel marketing" : "Inventaire des échantillons") : (f.arrivage ? (typeM === "mat" ? "📥 Arrivage — matériel marketing" : "📥 Arrivage — échantillons") : typeM === "mat" ? "Retour / ajustement de matériel marketing" : "Retour / ajustement d'échantillons")}</div>
                  {f.boite && <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 8 }}>Choisis le contenu de cette boîte : la production la prépare comme une demande ; le contenu est gardé pour les contrôles (checklist imprimable).</div>}
                  {!f.boite && (
                    <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
                      {[["ech", "Échantillons"], ["mat", "Matériel marketing"]].map(([k, lib]) => (
                        <button key={k} type="button" className="sc-btn" onClick={() => setEchTypeModal(k)} style={{ padding: "5px 12px", borderRadius: 16, fontSize: 12, fontWeight: 600, background: typeM === k ? ENCRE : PIERRE, color: typeM === k ? PIERRE : TAUPE }}>{lib}</button>
                      ))}
                    </div>
                  )}
                  {estInventaire && <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 8 }}>Saisis le nombre réel de pièces comptées (laisse vide ce que tu n'as pas compté). Les écarts avec le stock deviennent des ajustements.</div>}
                  {estDemande ? (
                    <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end" }}>
                      {estGerant && (
                        <Field label="Pour le commercial">
                          <select className="sc-select" value={f.commercialId} onChange={(e) => setF({ commercialId: e.target.value })} style={{ ...selectStyle, width: "auto" }}>
                            <option value={user.id}>{user.nom}</option>
                            {comsDem.map((u) => (<option key={u.id} value={u.id}>{u.nom}</option>))}
                          </select>
                        </Field>
                      )}
                      <Field label="Pour">
                        <select className="sc-select" value={f.compteType} onChange={(e) => setF({ compteType: e.target.value, compteId: "" })} style={{ ...selectStyle, width: "auto" }}>
                          <option value="client">un client</option><option value="prospect">un prospect</option><option value="libre">autre (revendeur, showroom…)</option>
                        </select>
                      </Field>
                      {f.compteType === "libre" ? (
                        <Field label="Nom"><input className="sc-input" value={f.compteLibre} onChange={(e) => setF({ compteLibre: e.target.value })} style={inputStyle(240)} /></Field>
                      ) : (
                        <Field label={f.compteType === "client" ? "Client" : "Prospect"}>
                          <select className="sc-select" value={f.compteId} onChange={(e) => setF({ compteId: e.target.value })} style={{ ...selectStyle, width: 260 }}>
                            <option value="">— Choisir —</option>
                            {(f.compteType === "client" ? clientsDem : prospectsDem).map((c) => (<option key={c.id} value={c.id}>{c.nom}</option>))}
                          </select>
                        </Field>
                      )}
                    </div>
                  ) : estInventaire ? null : (
                    <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end" }}>
                      <Field label="Motif">
                        <select className="sc-select" value={f.motif} onChange={(e) => setF({ motif: e.target.value })} style={{ ...selectStyle, width: "auto" }}>
                          {MOTIFS_ENTREE_ECH.filter((m) => (f.arrivage ? m === "Réception fournisseur" : m !== "Réception fournisseur")).map((m) => (<option key={m} value={m}>{m}</option>))}
                        </select>
                      </Field>
                      <Field label={f.arrivage ? "Fournisseur et n° de BL" : "Note"}><input className="sc-input" value={f.note} onChange={(e) => setF({ note: e.target.value })} style={inputStyle(260)} /></Field>
                      {f.motif === "Ajustement d'inventaire" && <div style={{ fontSize: 11, color: OCRE, paddingBottom: 8 }}>Quantité négative = retrait.</div>}
                    </div>
                  )}
                  <div style={{ display: "flex", gap: 10, alignItems: "center", margin: "6px 0" }}>
                    <input className="sc-input" value={echRechercheModal} onChange={(e) => setEchRechercheModal(e.target.value)} placeholder="Rechercher une couleur…" style={{ ...inputStyle(220), padding: "5px 8px", fontSize: 12 }} />
                    <label style={{ fontSize: 12, display: "flex", gap: 4, alignItems: "center" }}><input type="checkbox" checked={echVoirHP} onChange={(e) => setEchVoirHP(e.target.checked)} /> Afficher les hors production</label>
                    <span style={{ fontSize: 12, color: TAUPE, marginLeft: "auto" }}>{nbSaisis} référence(s) saisie(s)</span>
                  </div>
                  <div style={{ overflowY: "auto", flex: 1, border: `1px solid ${PIERRE}`, borderRadius: 8 }}>
                    {typeM === "mat" ? (
                      <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 12 }}>
                        <thead style={{ position: "sticky", top: 0, background: "#fff" }}><tr style={{ color: TAUPE, textAlign: "left" }}><th style={{ padding: 4 }}>Article</th><th style={{ padding: 4 }}>Prêté (récupéré ensuite)</th><th style={{ padding: 4, textAlign: "center" }}>Stock · quantité</th></tr></thead>
                        <tbody>
                          {refs.map((e) => { const st = stockEch(e.id, FORMAT_MAT.cle); return (
                            <tr key={e.id} style={{ borderTop: `1px solid ${PIERRE}`, background: val(e.id, FORMAT_MAT.cle) ? "#F5EFE0" : "transparent" }}>
                              <td style={{ padding: "3px 4px" }}>{libRefEch(e)}{e.horsProduction ? <span style={{ color: ROUILLE, fontSize: 10 }}> · inactif</span> : null}</td>
                              <td style={{ padding: "3px 4px", color: TAUPE }}>{e.pretable ? "oui" : ""}</td>
                              <td style={{ padding: "3px 4px", textAlign: "center", whiteSpace: "nowrap" }}>
                                <span style={{ color: st > 0 ? ENCRE : ROUILLE, display: "inline-block", width: 26 }}>{st}</span>
                                <input className="sc-input" value={val(e.id, FORMAT_MAT.cle)} onChange={(ev) => setVal(e.id, FORMAT_MAT.cle, ev.target.value)} style={{ ...inputStyle(48), padding: "2px 4px", fontSize: 12, textAlign: "center" }} />
                              </td>
                            </tr>
                          ); })}
                          {!refs.length && <tr><td colSpan={3} style={{ padding: 10, color: TAUPE }}>Aucun article de matériel marketing (le Production Manager ou le Gérant les crée dans Stock › Matériel marketing).</td></tr>}
                        </tbody>
                      </table>
                    ) : (
                    <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 12 }}>
                      <thead style={{ position: "sticky", top: 0, background: "#fff" }}><tr style={{ color: TAUPE, textAlign: "left" }}><th style={{ padding: 4 }}>Code</th><th style={{ padding: 4 }}>Couleur</th><th style={{ padding: 4 }}>Finition</th><th style={{ padding: 4 }}>Épaisseurs</th><th style={{ padding: 4 }}>Tranches</th>{FORMATS_ECH.map((fm) => (<th key={fm.cle} style={{ padding: 4, textAlign: "center" }}>{fm.lib}<div style={{ fontWeight: 400, fontSize: 10 }}>stock · {estDemande ? "demandé" : estInventaire ? "compté" : "quantité"}</div></th>))}</tr></thead>
                      <tbody>
                        {refs.map((e) => (
                          <tr key={e.id} style={{ borderTop: `1px solid ${PIERRE}`, background: (f.lignes || {})[e.id] && FORMATS_ECH.some((fm) => val(e.id, fm.cle)) ? "#F5EFE0" : "transparent" }}>
                            <td style={{ padding: "3px 4px", fontWeight: 600 }}>{e.code || <span style={{ color: OCRE, fontWeight: 400 }}>?</span>}</td>
                            <td style={{ padding: "3px 4px" }}>{e.couleur}{e.horsProduction ? <span style={{ color: ROUILLE, fontSize: 10 }}> · HP</span> : null}</td>
                            <td style={{ padding: "3px 4px" }}>{e.finition}</td>
                            <td style={{ padding: "3px 4px", color: TAUPE }}>{e.epaisseurs}</td>
                            <td style={{ padding: "3px 4px", whiteSpace: "nowrap" }}>{(() => { const t = tranchesEnStockEch(e); return t && t.reel > 0 ? <span style={{ color: VERT_OK, fontWeight: 600 }}>🟢 {t.reel}</span> : ""; })()}</td>
                            {FORMATS_ECH.map((fm) => { const st = stockEch(e.id, fm.cle); return (
                              <td key={fm.cle} style={{ padding: "3px 4px", textAlign: "center", whiteSpace: "nowrap" }}>
                                <span style={{ color: st > 0 ? ENCRE : ROUILLE, display: "inline-block", width: 26 }}>{st}</span>
                                <input className="sc-input" value={val(e.id, fm.cle)} onChange={(ev) => setVal(e.id, fm.cle, ev.target.value)} style={{ ...inputStyle(48), padding: "2px 4px", fontSize: 12, textAlign: "center" }} />
                              </td>
                            ); })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    )}
                  </div>
                  {estDemande && <Field label="Note pour la production (facultatif)" style={{ marginTop: 8 }}><input className="sc-input" value={f.note} onChange={(e) => setF({ note: e.target.value })} style={{ ...inputStyle(), width: "100%", boxSizing: "border-box" }} /></Field>}
                  <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 10 }}>
                    <button type="button" className="sc-btn" onClick={fermer} style={ghostBtnStyle}>Annuler</button>
                    <button type="button" className="sc-btn" onClick={estDemande ? enregistrerDemandeEch : estInventaire ? enregistrerInventaireEch : enregistrerEntreeEch} style={primaryBtnStyle}>{estDemande ? "Envoyer la demande" : estInventaire ? "Enregistrer l'inventaire" : "Enregistrer"}</button>
                  </div>
                </div>
              </Overlay>
            );
          })()}
          {remiseEch && (() => {
            const d = (demandesEch || []).find((x) => x.id === remiseEch.id);
            if (!d) return null;
            return (
              <Overlay onClose={() => setRemiseEch(null)}>
                <div style={modalStyle(560)}>
                  <div style={modalTitleStyle}>Remise des échantillons {d.numero}</div>
                  <div style={{ fontSize: 13, color: TAUPE, marginTop: -8, marginBottom: 10 }}>{nomUtilisateur(d.commercialId)} pour {compteDemandeEch(d)}</div>
                  <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 13 }}>
                    <thead><tr style={{ color: TAUPE, fontSize: 11, textAlign: "left" }}><th style={{ padding: 4 }}>Échantillon</th><th style={{ padding: 4 }}>Format</th><th style={{ padding: 4 }}>Demandé</th><th style={{ padding: 4 }}>Déjà donné</th><th style={{ padding: 4 }}>Reste</th><th style={{ padding: 4 }}>En stock</th><th style={{ padding: 4 }}>Donné maintenant</th></tr></thead>
                    <tbody>
                      {d.lignes.map((l, i) => (
                        <tr key={i} style={{ borderTop: `1px solid ${PIERRE}` }}>
                          <td style={{ padding: 4 }}>{libRefEch(refEch(l.refId))}</td>
                          <td style={{ padding: 4 }}>{libFormatEch(l.format)}</td>
                          <td style={{ padding: 4 }}>{l.qte}</td>
                          <td style={{ padding: 4 }}>{Number(l.donne ?? l.qteDonnee) || 0}</td>
                          <td style={{ padding: 4, fontWeight: 600 }}>{resteLigneEch(l)}</td>
                          <td style={{ padding: 4, color: stockEch(l.refId, l.format) < resteLigneEch(l) ? ROUILLE : ENCRE }}>{stockEch(l.refId, l.format)}</td>
                          <td style={{ padding: 4 }}>{resteLigneEch(l) > 0 ? <input className="sc-input" value={remiseEch.qtes[i] ?? String(Math.min(resteLigneEch(l), Math.max(0, stockEch(l.refId, l.format))))} onChange={(e) => setRemiseEch({ ...remiseEch, qtes: { ...remiseEch.qtes, [i]: e.target.value } })} style={{ ...inputStyle(56), padding: "2px 4px", textAlign: "center" }} /> : "—"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {d.note && <div style={{ fontSize: 12, marginTop: 8 }}>Note : {d.note}</div>}
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>En validant, les quantités données sortent du stock d'échantillons. S'il reste des échantillons à donner, la demande reste ouverte : tu recevras une tâche dès que la couleur sera en stock.</div>
                  <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 12 }}>
                    <button type="button" className="sc-btn" onClick={() => setRemiseEch(null)} style={ghostBtnStyle}>Annuler</button>
                    <button type="button" className="sc-btn" onClick={() => remettreDemandeEch()} style={primaryBtnStyle}>✓ Remis au commercial</button>
                  </div>
                </div>
              </Overlay>
            );
          })()}
          {refEchEdit && (
            <Overlay onClose={() => setRefEchEdit(null)}>
              <div style={modalStyle(460)}>
                <div style={modalTitleStyle}>{refEchEdit.id ? "Couleur d'échantillon" : "Nouvelle couleur d'échantillon"}</div>
                <div style={{ display: "flex", gap: 10 }}>
                  <Field label="Fournisseur / gamme" style={{ flex: 1 }}>
                    <input className="sc-input" list="liste-gammes-ech" value={refEchEdit.gamme} onChange={(e) => setRefEchEdit({ ...refEchEdit, gamme: e.target.value })} style={{ ...inputStyle(), width: "100%", boxSizing: "border-box" }} />
                    <datalist id="liste-gammes-ech">{[...new Set([...(echantillons || []).map((e) => e.gamme), ...(fournisseurs || []).map((x) => x.nom)])].filter(Boolean).sort().map((g) => (<option key={g} value={g} />))}</datalist>
                  </Field>
                  <Field label="Code couleur" style={{ flex: 1 }}><input className="sc-input" value={refEchEdit.code || ""} onChange={(e) => setRefEchEdit({ ...refEchEdit, code: e.target.value })} placeholder="code fournisseur" style={{ ...inputStyle(), width: "100%", boxSizing: "border-box" }} /></Field>
                  <Field label="Nom de la couleur" style={{ flex: 2 }}><input className="sc-input" value={refEchEdit.couleur} onChange={(e) => setRefEchEdit({ ...refEchEdit, couleur: e.target.value })} style={{ ...inputStyle(), width: "100%", boxSizing: "border-box" }} /></Field>
                </div>
                <div style={{ display: "flex", gap: 10 }}>
                  <Field label="Finition" style={{ flex: 1 }}><input className="sc-input" value={refEchEdit.finition} onChange={(e) => setRefEchEdit({ ...refEchEdit, finition: e.target.value })} style={{ ...inputStyle(), width: "100%", boxSizing: "border-box" }} /></Field>
                  <Field label="Lancement" style={{ flex: 1 }}><input className="sc-input" value={refEchEdit.lancement} onChange={(e) => setRefEchEdit({ ...refEchEdit, lancement: e.target.value })} placeholder="ex. 2025" style={{ ...inputStyle(), width: "100%", boxSizing: "border-box" }} /></Field>
                  <Field label="Épaisseurs" style={{ flex: 1 }}><input className="sc-input" value={refEchEdit.epaisseurs} onChange={(e) => setRefEchEdit({ ...refEchEdit, epaisseurs: e.target.value })} placeholder="ex. 6, 12 mm" style={{ ...inputStyle(), width: "100%", boxSizing: "border-box" }} /></Field>
                </div>
                <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}><input type="checkbox" checked={!!refEchEdit.horsProduction} onChange={(e) => setRefEchEdit({ ...refEchEdit, horsProduction: e.target.checked })} /> Hors production (référence discontinuée)</label>
                {(() => {
                  // Lien avec le stock de tranches : proposé automatiquement d'après le code couleur (articles Tranche du Catalogue).
                  const auto = produitsParCodeEch(refEchEdit.code);
                  const choisis = Array.isArray(refEchEdit.produitIds) ? refEchEdit.produitIds : auto;
                  const candidats = [...new Set([...auto, ...choisis])].map((id) => (produits || []).find((pp) => pp.id === id)).filter(Boolean);
                  const t = tranchesEnStockEch({ ...refEchEdit, produitIds: choisis });
                  return (
                    <div style={{ marginTop: 10, fontSize: 12 }}>
                      <div style={{ fontWeight: 600, marginBottom: 4 }}>Tranches en stock de cette couleur</div>
                      {!candidats.length ? <div style={{ color: TAUPE }}>{refEchEdit.code ? "Aucun article Tranche du Catalogue avec ce code fournisseur." : "Renseigne le code couleur : le lien avec le stock se fait par le code fournisseur des articles Tranche."}</div> : candidats.map((pp) => (
                        <label key={pp.id} style={{ display: "flex", gap: 6, alignItems: "center" }}>
                          <input type="checkbox" checked={choisis.includes(pp.id)} onChange={(e) => setRefEchEdit({ ...refEchEdit, produitIds: e.target.checked ? [...choisis, pp.id] : choisis.filter((x) => x !== pp.id) })} />
                          {pp.nom} <span style={{ color: TAUPE }}>({pp.categorie})</span>
                        </label>
                      ))}
                      {t && <div style={{ marginTop: 4, color: t.reel > 0 ? VERT_OK : TAUPE }}>{t.reel} tranche(s) en stock, dont {t.libre} libre(s).</div>}
                    </div>
                  );
                })()}
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 12 }}>
                  {refEchEdit.id && <button type="button" className="sc-btn" onClick={() => supprimerRefEch(refEchEdit)} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>Supprimer</button>}
                  <button type="button" className="sc-btn" onClick={() => setRefEchEdit(null)} style={ghostBtnStyle}>Annuler</button>
                  <button type="button" className="sc-btn" onClick={enregistrerRefEch} style={primaryBtnStyle}>Enregistrer</button>
                </div>
              </div>
            </Overlay>
          )}
          {apercuDoc && (
            <Overlay onClose={() => setApercuDoc(null)}>
              <div style={{ ...modalStyle(900), height: "88vh", display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                  <div style={modalTitleStyle}>{apercuDoc.titre} <span style={{ fontSize: 12, color: TAUPE, fontWeight: 400 }}>— aperçu, lecture seule</span></div>
                  <button type="button" className="sc-btn" onClick={() => setApercuDoc(null)} style={ghostBtnStyle}>Fermer</button>
                </div>
                <iframe title="aperçu" srcDoc={apercuDoc.html} sandbox="" style={{ flex: 1, border: `1px solid ${PIERRE}`, borderRadius: 8, background: "#fff" }} />
              </div>
            </Overlay>
          )}
          {relierProspect && (() => {
            const p = prospectDe(relierProspect.id);
            if (!p) return null;
            const choix = (clients || []).filter((c) => !c.archive && (estGerant || clientVisiblePourUser(c))).sort((a, b) => a.nom.localeCompare(b.nom, "fr"));
            return (
              <Overlay onClose={() => setRelierProspect(null)}>
                <div style={modalStyle(460)}>
                  <div style={modalTitleStyle}>Relier « {p.nom} » à un client existant</div>
                  <Field label="Client">
                    <select className="sc-select" value={relierProspect.clientId} onChange={(e) => setRelierProspect({ ...relierProspect, clientId: e.target.value })} style={selectStyle}>
                      <option value="">— Choisir —</option>
                      {choix.map((c) => (<option key={c.id} value={c.id}>{c.nom}</option>))}
                    </select>
                  </Field>
                  <div style={{ fontSize: 11, color: TAUPE }}>Le prospect passe en « devenu client » ; ses devis et dossiers (depuis le {formatDate((p.dateContact || p.creeLe || "").slice(0, 10))}) apparaissent dans son suivi.</div>
                  <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 12 }}>
                    <button type="button" className="sc-btn" onClick={() => setRelierProspect(null)} style={ghostBtnStyle}>Annuler</button>
                    <button type="button" className="sc-btn" onClick={relierProspectClient} style={primaryBtnStyle}>Relier</button>
                  </div>
                </div>
              </Overlay>
            );
          })()}
          {bugsTexte !== null && (
            <Overlay onClose={() => setBugsTexte(null)}>
              <div style={modalStyle(640)}>
                <div style={modalTitleStyle}>Bugs ouverts — à copier pour Claude</div>
                <textarea readOnly rows={14} value={bugsTexte} onFocus={(e) => e.target.select()} className="sc-input" style={{ ...inputStyle(), width: "100%", boxSizing: "border-box", fontFamily: "monospace", fontSize: 12 }} />
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
                  <button type="button" className="sc-btn" onClick={() => setBugsTexte(null)} style={primaryBtnStyle}>Fermer</button>
                </div>
              </div>
            </Overlay>
          )}
          {peut("admin.donnees") && (
            <>
              <button type="button" className="sc-btn" onClick={exporterToutesLesDonnees} style={{ ...ghostBtnStyle, marginTop: 12, fontSize: 11, padding: "6px 0" }}>
                ⬇ Exporter toutes les données
              </button>
              <input
                ref={importFileRef}
                type="file"
                accept=".json"
                style={{ display: "none" }}
                onChange={(e) => {
                  const fichier = e.target.files && e.target.files[0];
                  if (fichier) importerDonnees(fichier);
                  e.target.value = "";
                }}
              />
              {!EN_PRODUCTION && (
                <button type="button" className="sc-btn" onClick={() => importFileRef.current && importFileRef.current.click()} style={{ ...ghostBtnStyle, marginTop: 6, fontSize: 11, padding: "6px 0" }}>
                  ↑ Importer des données (fusion, sans écraser)
                </button>
              )}
              <button
                type="button"
                className="sc-btn"
                onClick={() => setShowJournalAcces(true)}
                style={{ ...ghostBtnStyle, marginTop: 6, fontSize: 11, padding: "6px 0" }}
              >
                🕐 Journal d'accès
              </button>
              {!EN_PRODUCTION && (
                <button
                  type="button"
                  className="sc-btn"
                  onClick={() => { setVidageConfirmationTexte(""); setVidageGroupes({}); setShowVidage(true); }}
                  style={{ ...ghostBtnStyle, marginTop: 6, fontSize: 11, padding: "6px 0", color: ROUILLE }}
                >
                  🗑 Vider des données
                </button>
              )}
            </>
          )}
        </div>
      </aside>
      <div style={{ flex: 1, minWidth: 0, padding: "32px 28px", boxSizing: "border-box" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600&family=DM+Sans:wght@400;500;600&display=swap');
        * { box-sizing: border-box; }
        .sc-row { transition: background 0.15s ease; }
        .sc-row:hover { background: rgba(140,130,130,0.08); }
        .sc-btn { cursor: pointer; border: none; font-family: 'DM Sans', sans-serif; }
        .sc-btn:focus-visible, .sc-input:focus-visible, .sc-select:focus-visible { outline: 2px solid ${ENCRE}; outline-offset: 1px; }
        .sc-input, .sc-select, textarea.sc-input { border-color: #CFC5BF !important; }
        input, select { font-family: 'DM Sans', sans-serif; }
      `}</style>

      {dialogue && (
        <Overlay onClose={() => fermerDialogue(false)} zIndex={3000}>
          <div style={modalStyle(440)}>
            <div style={{ fontSize: 14, lineHeight: 1.5, whiteSpace: "pre-line", marginBottom: 16 }}>{dialogue.message}</div>
            {dialogue.saisie && (
              <input className="sc-input" autoFocus value={dialogue.valeur} onChange={(e) => setDialogue({ ...dialogue, valeur: e.target.value })} onKeyDown={(e) => { if (e.key === "Enter" && dialogue.valeur.trim()) fermerDialogue(true); if (e.key === "Escape") fermerDialogue(false); }} style={{ ...inputStyle("100%"), background: "#fff", border: `1px solid ${TAUPE}`, marginBottom: 16 }} />
            )}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
              {!dialogue.info && <button type="button" className="sc-btn" onClick={() => fermerDialogue(false)} style={ghostBtnStyle}>Annuler</button>}
              <button type="button" className="sc-btn" autoFocus={!dialogue.saisie} disabled={dialogue.saisie && !dialogue.valeur.trim()} onClick={() => fermerDialogue(true)} style={primaryBtnStyle}>{dialogue.info ? "OK" : dialogue.saisie ? "Valider" : "Confirmer"}</button>
            </div>
          </div>
        </Overlay>
      )}

      {/* Message de blocage — au-dessus des fenêtres, car il en explique souvent le refus */}
      {notice && (
        <div
          style={{
            position: "fixed",
            top: 16,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 100,
            maxWidth: 560,
            width: "calc(100% - 32px)",
            background: "#F5E4DE",
            color: ROUILLE,
            border: `1px solid ${ROUILLE}44`,
            borderRadius: 8,
            padding: "12px 40px 12px 14px",
            fontSize: 13,
            lineHeight: 1.5,
            fontWeight: 500,
            boxShadow: "0 8px 24px rgba(40,30,30,0.18)",
          }}
        >
          {notice}
          <button
            type="button"
            className="sc-btn"
            onClick={() => setNotice("")}
            style={{
              position: "absolute",
              top: 8,
              right: 8,
              background: "transparent",
              color: ROUILLE,
              fontSize: 14,
              width: 24,
              height: 24,
              borderRadius: 4,
            }}
            title="Fermer"
          >
            ✕
          </button>
        </div>
      )}

      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 28, flexWrap: "wrap", gap: 16 }}>
        <div style={{ fontSize: 13, color: TAUPE, letterSpacing: 1.5, textTransform: "uppercase" }}>
          {({ communication: "Communication", alertes: "Alertes & tâches", rapportCommercial: "Rapport commercial", marketing: "Community management", statistiques: "Statistiques", parametrage: "Paramétrage", sav: "SAV — service après-vente", outillage: "Outillage et bureautique", stock: "Gestion du Stock", clients: "Clients", fournisseurs: "Fournisseurs", devis: "Devis", catalogue: "Catalogue d'articles", grilleTarifaire: "Prix et coûts", projets: "Projets immobiliers" })[activeTab] || ""}
        </div>
        <div style={{ display: "flex", gap: 24 }}>
          {activeTab === "stock" && (
            <>
              <KPI label="Produits" value={produits ? produits.length : "–"} />
              <KPI label="Sous le seuil" value={items ? alertCount : "–"} color={alertCount > 0 ? ROUILLE : VERT_OK} />
            </>
          )}
          {activeTab === "clients" && (
            <>
              <KPI label="Clients" value={clients ? clients.filter(clientVisiblePourUser).length : "–"} />
              <KPI label="Fiches à compléter" value={clients ? clientAlertCount : "–"} color={clientAlertCount > 0 ? ROUILLE : VERT_OK} />
            </>
          )}
          {activeTab === "fournisseurs" && (
            <>
              <KPI label="Fournisseurs" value={fournisseurs ? fournisseurs.length : "–"} />
              <KPI label="Fiches à compléter" value={fournisseurs ? certifAlertCount : "–"} color={certifAlertCount > 0 ? ROUILLE : VERT_OK} />
            </>
          )}
          {activeTab === "devis" && (
            <>
              <KPI label="Devis" value={devisListe ? devisListe.length : "–"} />
              <KPI label="Confirmés (TTC)" value={devisListe ? fmtMAD(kpiTotalConfirmes) : "–"} color={VERT_OK} />
              <KPI label="Confirmés sans BDC" value={devisListe ? devisConfirmesSansBDC.length : "–"} color={devisConfirmesSansBDC.length > 0 ? ROUILLE : VERT_OK} />
            </>
          )}
          {activeTab === "commandes" && (
            <>
              <KPI label="Dossiers en cours" value={commandesListe ? commandesListe.filter((c) => c.statut !== "Facture").length : "–"} />
              <KPI label="Facturés" value={commandesListe ? commandesListe.filter((c) => c.statut === "Facture").length : "–"} color={VERT_OK} />
            </>
          )}
          {activeTab === "catalogue" && (
            <KPI label="Articles" value={articles ? articles.length : "–"} />
          )}
        </div>
      </div>

      {onglets.length === 0 && (
        <div style={{ background: "#fff", borderRadius: 10, padding: 32, textAlign: "center", color: TAUPE, fontSize: 14 }}>
          <div style={{ fontWeight: 600, color: ENCRE, marginBottom: 6 }}>Aucun module accessible pour {user.nom}</div>
          Contacte le Gérant pour ajuster ses droits d'accès.
        </div>
      )}

      {activeTab === "projets" && (user.acces.devis || user.acces.commandes) && chantiers !== null && renderProjets()}
      {/* ERP step 11 (validé Nils du 29/09) : onglet Outillage */}
      {activeTab === "statistiques" && peut("stats.voir") && (() => {
        const sp = statsPer;
        const anneeCour = Number(todayISO().slice(0, 4));
        let du, au, nbMois, libPer;
        if (sp.type === "mois") { const ym = sp.ym || todayISO().slice(0, 7); du = `${ym}-01`; au = finDeMois(ym); nbMois = 1; libPer = libMois(ym); }
        else if (sp.type === "trimestre") { const a = sp.annee || anneeCour, t = sp.trim || Math.ceil(Number(todayISO().slice(5, 7)) / 3); const m1 = (t - 1) * 3 + 1; du = `${a}-${String(m1).padStart(2, "0")}-01`; au = finDeMois(`${a}-${String(m1 + 2).padStart(2, "0")}`); nbMois = 3; libPer = `T${t} ${a}`; }
        else if (sp.type === "annee") { const a = sp.annee || anneeCour; du = `${a}-01-01`; au = `${a}-12-31`; nbMois = 12; libPer = String(a); }
        else { du = sp.du || `${anneeCour}-01-01`; au = sp.au || todayISO(); nbMois = null; libPer = `du ${formatDate(du)} au ${formatDate(au)}`; }
        const moins1 = (d) => `${Number(d.slice(0, 4)) - 1}${d.slice(4)}`.replace(/-02-29$/, "-02-28");
        const anneeN1 = Number(du.slice(0, 4)) - 1;
        const delaiEC = Number((parametres || {}).statsDelaiEnCours) || 30;
        const S = statsPeriode(du, au, delaiEC);
        const N1 = statsPeriode(moins1(du), moins1(au), delaiEC);
        const A1 = statsPeriode(`${anneeN1}-01-01`, `${anneeN1}-12-31`, delaiEC);
        const fact = nbMois ? nbMois / 12 : Math.max(1, ecartJours(du, au) + 1) / 365;
        const moy = (v) => v * fact;
        const pct = (v, ref) => (!ref ? null : ((v - ref) / Math.abs(ref)) * 100);
        const ecart = (v, ref, lib) => { const p = pct(v, ref); return <span style={{ fontSize: 11, color: p === null ? TAUPE : p >= 0 ? VERT_OK : ROUILLE, marginRight: 8 }}>{lib} {p === null ? "—" : `${p >= 0 ? "+" : ""}${p.toFixed(0)} %`}</span>; };
        const taux = (o) => (o && o.fam ? (o.famTransfo / o.fam) * 100 : null);
        const tauxMt = (o) => (o && o.mtFam ? (o.mtTransfo / o.mtFam) * 100 : null);
        const fP = (x) => (x === null || x === undefined ? "—" : `${x.toFixed(0)} %`);
        const pts = (v, ref, lib) => <span style={{ fontSize: 11, color: v === null || ref === null ? TAUPE : v >= ref ? VERT_OK : ROUILLE, marginRight: 8 }}>{lib} {v === null || ref === null ? "—" : `${v - ref >= 0 ? "+" : ""}${(v - ref).toFixed(0)} pts`}</span>;
        const retards = retardsClients();
        const totEchu = retards.reduce((n, r) => n + r.echu, 0);
        const tuile = (lib, val, sous) => (
          <div style={{ flex: "1 1 200px", background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 10, padding: "12px 14px" }}>
            <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>{lib}</div>
            <div style={{ fontSize: 22, fontWeight: 600, marginTop: 2 }}>{val}</div>
            <div style={{ marginTop: 2 }}>{sous}</div>
          </div>
        );
        const exporter = async (nom, entetes, lignes) => {
          const q = (v) => (typeof v === "number" ? String(Math.round(v * 100) / 100).replace(".", ",") : `"${String(v === null || v === undefined ? "" : v).replace(/"/g, '""')}"`);
          await proposerTelechargement(`stats-${nom}-${du}-${au}.csv`, "﻿" + [entetes.map(q).join(";"), ...lignes.map((l) => l.map(q).join(";"))].join("\r\n"));
        };
        const tableau = (titre, nom, entetes, lignes, note) => (
          <div style={{ background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 14, marginBottom: 16 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, gap: 10 }}>
              <div style={{ fontSize: 12, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 }}>{titre}</div>
              {lignes.length > 0 && <button type="button" className="sc-btn" onClick={() => exporter(nom, entetes.map((e) => (typeof e === "string" ? e : e.lib)), lignes.map((l) => l.map((c) => (c && typeof c === "object" && "v" in c ? c.v : c))))} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 0" }}>⬇ Excel</button>}
            </div>
            {lignes.length === 0 ? <div style={{ fontSize: 13, color: TAUPE }}>Aucune donnée sur la période.</div> : (
              <div style={{ overflowX: "auto" }}>
                <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 13 }}>
                  <thead><tr style={{ color: TAUPE, fontSize: 11 }}>{entetes.map((e, i) => (<th key={i} style={{ padding: "4px 6px", textAlign: i === 0 ? "left" : "right", fontWeight: 500 }}>{typeof e === "string" ? e : e.lib}</th>))}</tr></thead>
                  <tbody>{lignes.map((l, i) => (<tr key={i} style={{ borderTop: `1px solid ${PIERRE}` }}>{l.map((c, j) => (<td key={j} style={{ padding: "4px 6px", textAlign: j === 0 ? "left" : "right", whiteSpace: j === 0 ? "normal" : "nowrap" }}>{c && typeof c === "object" && "aff" in c ? c.aff : typeof c === "number" ? (Math.abs(c) >= 100 ? formatDH(c).replace(" DH", "") : String(Math.round(c * 100) / 100).replace(".", ",")) : c}</td>))}</tr>))}</tbody>
                </table>
              </div>
            )}
            {note && <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>{note}</div>}
          </div>
        );
        const dh = (v) => ({ v: Math.round(v * 100) / 100, aff: formatDH(v) });
        const pc = (v) => ({ v: v === null ? "" : Math.round(v), aff: v === null ? "—" : `${v.toFixed(0)} %` });
        const tri = (m) => [...m.entries()].sort((a, b) => (b[1].ca + b[1].pc) - (a[1].ca + a[1].pc));
        // Graphique : 12 mois glissants jusqu'à la fin de la période, CA facturé N et N-1.
        const moisG = Array.from({ length: 12 }, (_, i) => ajouterMoisISO(`${au.slice(0, 7)}-01`, i - 11, 1).slice(0, 7));
        const serie = moisG.map((m) => ({ m, n: statsPeriode(`${m}-01`, finDeMois(m), delaiEC).caFact, n1: statsPeriode(`${Number(m.slice(0, 4)) - 1}${m.slice(4)}-01`, finDeMois(`${Number(m.slice(0, 4)) - 1}${m.slice(4)}`), delaiEC).caFact }));
        const maxG = Math.max(1, ...serie.map((x) => Math.max(x.n, x.n1)));
        return (
          <div>
            <div style={{ display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap", marginBottom: 16 }}>
              <FiltreChamp label="Période">
                <select className="sc-select" value={sp.type} onChange={(e) => setStatsPer({ ...sp, type: e.target.value })} style={{ ...selectStyle, width: "auto" }}>
                  <option value="mois">Mois</option><option value="trimestre">Trimestre</option><option value="annee">Année</option><option value="libre">Dates libres</option>
                </select>
              </FiltreChamp>
              {sp.type === "mois" && <input type="month" className="sc-input" value={sp.ym || todayISO().slice(0, 7)} onChange={(e) => setStatsPer({ ...sp, ym: e.target.value })} style={inputStyle(160)} />}
              {(sp.type === "trimestre" || sp.type === "annee") && <input type="number" className="sc-input" value={sp.annee || anneeCour} onChange={(e) => setStatsPer({ ...sp, annee: Number(e.target.value) })} style={inputStyle(90)} />}
              {sp.type === "trimestre" && <select className="sc-select" value={sp.trim || Math.ceil(Number(todayISO().slice(5, 7)) / 3)} onChange={(e) => setStatsPer({ ...sp, trim: Number(e.target.value) })} style={{ ...selectStyle, width: "auto" }}>{[1, 2, 3, 4].map((t) => (<option key={t} value={t}>T{t}</option>))}</select>}
              {sp.type === "libre" && (<><input type="date" className="sc-input" value={du} onChange={(e) => setStatsPer({ ...sp, du: e.target.value })} style={inputStyle(150)} /><input type="date" className="sc-input" value={au} onChange={(e) => setStatsPer({ ...sp, au: e.target.value })} style={inputStyle(150)} /></>)}
              <span style={{ fontSize: 13, fontWeight: 600, paddingBottom: 8 }}>{libPer}</span>
              <span style={{ fontSize: 11, color: TAUPE, paddingBottom: 8, marginLeft: "auto" }}>Comparaisons : même période {anneeN1} (N-1) · moyenne {anneeN1} ramenée à la même durée (moy.)</span>
            </div>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 16 }}>
              {tuile("CA facturé HT", formatDH(S.caFact), <>{ecart(S.caFact, N1.caFact, "N-1")}{ecart(S.caFact, moy(A1.caFact), "moy.")}</>)}
              {tuile("Prises de commande HT (BDC)", formatDH(S.pc), <>{ecart(S.pc, N1.pc, "N-1")}{ecart(S.pc, moy(A1.pc), "moy.")}</>)}
              {tuile("Taux de transformation", fP(taux(S)), <>{pts(taux(S), taux(N1), "N-1")}{pts(taux(S), taux(A1), `${anneeN1}`)}<span style={{ fontSize: 11, color: TAUPE }}>{S.famTransfo}/{S.fam} devis · en montant {fP(tauxMt(S))}</span></>)}
              {tuile("Retards clients (à ce jour)", formatDH(totEchu), <span style={{ fontSize: 11, color: TAUPE }}>{retards.filter((r) => r.echu > 0.01).length} client(s) en retard</span>)}
            </div>
            <div style={{ background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 14, marginBottom: 16 }}>
              <div style={{ fontSize: 12, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 8 }}>CA facturé HT — 12 mois glissants <span style={{ textTransform: "none", fontWeight: 400 }}>(foncé : N · clair : N-1)</span></div>
              <div style={{ display: "flex", alignItems: "flex-end", gap: 6, height: 140 }}>
                {serie.map((x) => (
                  <div key={x.m} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }} title={`${libMois(x.m)} : ${formatDH(x.n)} (N-1 ${formatDH(x.n1)})`}>
                    <div style={{ display: "flex", alignItems: "flex-end", gap: 2, height: 116 }}>
                      <div style={{ width: 9, height: `${(x.n1 / maxG) * 100}%`, background: "#D8CFC7", borderRadius: "3px 3px 0 0" }} />
                      <div style={{ width: 9, height: `${(x.n / maxG) * 100}%`, background: ENCRE, borderRadius: "3px 3px 0 0" }} />
                    </div>
                    <div style={{ fontSize: 10, color: TAUPE }}>{x.m.slice(5)}/{x.m.slice(2, 4)}</div>
                  </div>
                ))}
              </div>
            </div>
            {tableau("Par client", "clients", ["Client", "CA facturé HT", "Part", "Prises de commande HT", "Factures", "BDC", ""], tri(S.parClient).map(([id, o]) => { const cl = clientDe(id); return [cl ? cl.nom : "?", dh(o.ca), pc(S.caFact ? (o.ca / S.caFact) * 100 : null), dh(o.pc), o.nbF, o.nbB, { v: "", aff: cl ? <button type="button" className="sc-btn" onClick={() => setEtatClientModal({ clientId: cl.id, exo: false, au: todayISO(), avecSoldes: false })} style={{ ...ghostBtnStyle, fontSize: 11, padding: 0 }}>📄 État</button> : "" }]; }))}
            {tableau("Par commercial", "commerciaux", ["Commercial", "CA facturé HT", "Prises de commande HT", "Devis (familles)", "Transformés", "Taux", "Taux en montant"], [...new Set([...S.parCom.keys(), ...S.tauxCom.keys()])].map((id) => { const o = S.parCom.get(id) || { ca: 0, pc: 0 }; const t = S.tauxCom.get(id) || { n: 0, t: 0, mt: 0, mtT: 0 }; return [id === "—" ? "Sans commercial" : nomUtilisateur(id) || id, dh(o.ca), dh(o.pc), t.n, t.t, pc(t.n ? (t.t / t.n) * 100 : null), pc(t.mt ? (t.mtT / t.mt) * 100 : null)]; }).sort((a, b) => b[1].v - a[1].v))}
            {tableau("Par catégorie de client", "categories", ["Catégorie", "CA facturé HT", "Prises de commande HT", "Taux de transformation"], [...new Set([...S.parCat.keys(), ...S.tauxCat.keys()])].map((k) => { const o = S.parCat.get(k) || { ca: 0, pc: 0 }; const t = S.tauxCat.get(k); return [k, dh(o.ca), dh(o.pc), pc(t && t.n ? (t.t / t.n) * 100 : null)]; }).sort((a, b) => b[1].v - a[1].v))}
            {tableau("Par type de vente", "type-vente", ["Type", "CA facturé HT", "Prises de commande HT"], ["Fourniture seule", "Avec transformation", "Avec pose"].filter((k) => S.parType.has(k)).map((k) => [k, dh(S.parType.get(k).ca), dh(S.parType.get(k).pc)]), "Un dossier avec transformation et pose compte dans les deux lignes (d'après la base d'usure des articles du Catalogue).")}
            {tableau("Taux de transformation — détail", "transformation", ["", "Période", "N-1", `Moyenne ${anneeN1}`], [
              ["Devis émis (familles de versions, hors en cours)", S.fam, N1.fam, A1.fam],
              ["Transformés en BDC", S.famTransfo, N1.famTransfo, A1.famTransfo],
              ["Taux en nombre", pc(taux(S)), pc(taux(N1)), pc(taux(A1))],
              ["Taux en montant HT", pc(tauxMt(S)), pc(tauxMt(N1)), pc(tauxMt(A1))],
              ["Délai moyen devis → BDC (jours)", S.delaiMoyen === null ? "—" : Math.round(S.delaiMoyen), N1.delaiMoyen === null ? "—" : Math.round(N1.delaiMoyen), A1.delaiMoyen === null ? "—" : Math.round(A1.delaiMoyen)],
              [`Devis en cours (moins de ${delaiEC} jours, non comptés)`, S.enCours.length, "", ""],
            ], <span>Les versions d'un même devis (« Dupliquer » ou « Nouvelle version de… ») comptent pour un seul devis. Délai « en cours » : <input className="sc-input" defaultValue={delaiEC} onBlur={(e) => { const v = Number(e.target.value); if (v > 0 && v !== delaiEC) persistParametres({ ...(parametres || {}), statsDelaiEnCours: v }); }} style={{ ...inputStyle(50), padding: "1px 4px", fontSize: 11 }} /> jours.</span>)}
            {tableau("Nombre de documents", "documents", ["Document", "Période", "N-1", "Moy."], Object.keys(S.docs).map((k) => [k, S.docs[k], N1.docs[k], Math.round(moy(A1.docs[k]) * 10) / 10]))}
            {estGerant && (() => {
              const cache = {};
              const lignesM = (commandesListe || []).filter((c) => !c.anterieure && c.statut !== "BDC" && (() => { const dpl = datePLDossier(c); return dpl && dpl >= du && dpl <= au; })()).map((c) => ({ c, r: margeDossier(c, cache) })).filter((x) => x.r);
              const agg = (cle) => { const m = new Map(); lignesM.forEach(({ c, r }) => { const k = cle(c); const o = m.get(k) || { ca: 0, a: 0, b: 0, n: 0 }; o.ca += r.ca; o.a += r.margeA; o.b += r.margeB; o.n++; m.set(k, o); }); return [...m.entries()].sort((x, y) => y[1].a - x[1].a).map(([k, o]) => [k, o.n, Math.round(o.ca), Math.round(o.a), o.ca ? Math.round((o.a / o.ca) * 1000) / 10 : 0, Math.round(o.b), o.ca ? Math.round((o.b / o.ca) * 1000) / 10 : 0]); };
              const ent = ["", "Dossiers", "CA HT", "Marge A", "% A", "Marge B", "% B"];
              return (
                <>
                  {tableau("Marge par dossier (PL de la période — Gérant seul)", "marge-dossiers", ["Dossier", "Client", "CA HT", "Coût A", "Marge A", "% A", "Marge B", "% B", "Provisoire"], lignesM.sort((x, y) => x.r.pctA - y.r.pctA).map(({ c, r }) => [c.numeroFacture || c.numeroBL || c.numero, (clientDe(c.clientId) || {}).nom || "", Math.round(r.ca), Math.round(r.coutA), Math.round(r.margeA), Math.round(r.pctA * 10) / 10, Math.round(r.margeB), Math.round(r.pctB * 10) / 10, r.alertes.length ? "oui" : ""]), "A : taux atelier / pose du mois réel ; B : moyenne des 12 mois précédents. Coûts directs (matière, consommables, atelier, pose, transport, commissions estimées). Triés de la plus faible marge à la plus forte.")}
                  {tableau("Marge par commercial", "marge-commercial", ["Commercial", ...ent.slice(1)], agg((c) => (devisDuDossier(c) || {}).commercialSC || "—"))}
                  {tableau("Marge par client", "marge-client", ["Client", ...ent.slice(1)], agg((c) => (clientDe(c.clientId) || {}).nom || "—"))}
                  {tableau("Marge par type de vente", "marge-type", ["Type", ...ent.slice(1)], agg((c) => typeVenteDossier(c).join(" + ")))}
                  {(() => {
                    // Nils 08/10 (t) : marge par projet immo (tous les dossiers du projet, quelle que soit la période), figée à la clôture.
                    const projetsM = (chantiers || []).map((ch) => {
                      const m = ch.cloture && ch.cloture.marge ? ch.cloture.marge : margeProjet(ch.id, cache);
                      return m.n || (ch.cloture && ch.cloture.marge) ? { ch, m } : null;
                    }).filter(Boolean).sort((x, y) => (!!x.ch.cloture === !!y.ch.cloture ? x.ch.nom.localeCompare(y.ch.nom, "fr") : x.ch.cloture ? -1 : 1));
                    return tableau("Marge par projet immo (clôture dans la fiche projet — Gérant seul)", "marge-projets", ["Projet", "Client", "Dossiers", "CA HT", "Marge A", "% A", "Marge B", "% B", "Statut"], projetsM.map(({ ch, m }) => [
                      ch.nom,
                      (clientDe(ch.clientId) || {}).nom || "",
                      { v: m.n, aff: <span>{m.n}{m.nonFactures ? <span style={{ color: OCRE }}> ({m.nonFactures} non facturé{m.nonFactures > 1 ? "s" : ""})</span> : ""}</span> },
                      Math.round(m.ca), Math.round(m.margeA), Math.round(m.pctA * 10) / 10, Math.round(m.margeB), Math.round(m.pctB * 10) / 10,
                      { v: ch.cloture ? `clôturé le ${formatDate(ch.cloture.le.slice(0, 10))}` : "en cours", aff: <span>{ch.cloture ? <span style={{ color: VERT_OK }}>🔒 clôturé le {formatDate(ch.cloture.le.slice(0, 10))}</span> : "en cours"} <button type="button" className="sc-btn" onClick={() => { setActiveTab("projets"); setProjetOuvert(ch.id); }} style={{ ...ghostBtnStyle, fontSize: 11, padding: "1px 6px" }}>fiche →</button></span> },
                    ]), "En cours : marge provisoire recalculée à chaque ouverture. Clôturé : marge figée au jour de la clôture (« rouvrir » pour la recalculer). A : taux atelier / pose du mois réel ; B : moyenne des 12 mois précédents.");
                  })()}
                </>
              );
            })()}
            {tableau("Tranches vendues par matière (sorties de PL, hors chutes)", "tranches-matiere", ["Matière", "Tranches", "m²", "Tranches N-1"], [...S.tranchesMatiere.entries()].sort((a, b) => b[1].n - a[1].n).map(([k, o]) => [k, Math.round(o.n * 100) / 100, Math.round(o.m2 * 100) / 100, (N1.tranchesMatiere.get(k) || { n: 0 }).n]))}
            {tableau("Tranches vendues par couleur", "tranches-couleur", ["Couleur", "Tranches", "m²", "Tranches N-1"], [...S.tranchesCouleur.entries()].sort((a, b) => b[1].n - a[1].n).map(([k, o]) => [k, Math.round(o.n * 100) / 100, Math.round(o.m2 * 100) / 100, (N1.tranchesCouleur.get(k) || { n: 0 }).n]))}
            {tableau("Chutes vendues (factures de la période)", "chutes-vendues", ["Couleur", "Chutes", "m²", "CA HT"], [...S.chutesVendues.entries()].sort((a, b) => b[1].ht - a[1].ht).map(([k, o]) => [k, o.n, Math.round(o.m2 * 100) / 100, dh(o.ht)]))}
            {tableau("Consommables sortis", "consommables", ["Consommable", "Catégorie", "Quantité", "Unité", ...(estGerant ? ["Coût HT"] : [])], [...S.conso.entries()].sort((a, b) => b[1].cout - a[1].cout).map(([k, o]) => [k, o.categorie, Math.round(o.qte * 100) / 100, o.unite, ...(estGerant ? [dh(o.cout)] : [])]))}
            {tableau("Retards clients (à ce jour)", "retards", ["Client", "Échu non payé", "Retard max (jours)", "Total dû", "Délai moyen de paiement (jours)", ""], retards.map((r) => [r.client.nom, dh(r.echu), r.retardMax, dh(r.du), r.delaiMoyen === null ? "—" : Math.round(r.delaiMoyen), { v: "", aff: <button type="button" className="sc-btn" onClick={() => setEtatClientModal({ clientId: r.client.id, exo: false, au: todayISO(), avecSoldes: false })} style={{ ...ghostBtnStyle, fontSize: 11, padding: 0 }}>📄 État</button> }]), "D'après les états de compte (factures et BLS) ; le délai moyen de paiement porte sur les documents soldés. Les factures antérieures à l'ERP sont comprises ici.")}
          </div>
        );
      })()}
      {activeTab === "marketing" && (peut("marketing.acces") || peut("prospects.saisir")) && (() => {
        // Nils 12/10 : l'ADV (prospects.saisir) ne voit que la partie Prospects.
        const mktComplet = estGerant || peut("marketing.acces");
        const personnes = personnesMarketing();
        const pid = estGerant ? (mktPersonne && personnes.some((u) => u.id === mktPersonne) ? mktPersonne : (personnes[0] || {}).id || "") : user.id;
        const ym = mktMois || todayISO().slice(0, 7);
        const tot = pid ? totauxMoisMkt(pid, ym) : { heures: 0, montant: 0, lignes: [] };
        const valide = pid ? moisValideMkt(pid, ym) : null;
        const tauxActuel = pid ? tauxMktAu(pid, todayISO()) : 0;
        const hist = pid ? (reglagesMkt.taux || {})[pid] || [] : [];
        const carteM = (titre, contenu, extra) => (
          <div style={{ background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 14, marginBottom: 16 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 10 }}>
              <div style={{ fontSize: 12, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 }}>{titre}</div>
              {extra}
            </div>
            {contenu}
          </div>
        );
        const h = (x) => `${String(arrondiH(x)).replace(".", ",")} h`;
        const recap = [...new Set([...(timesheet || []).filter((l) => l.parId === pid).map((l) => l.date.slice(0, 7)), ym])].sort().reverse().slice(0, 6);
        const exporter = async () => {
          const q = (v) => `"${String(v === null || v === undefined ? "" : v).replace(/"/g, '""')}"`;
          const num = (n) => String(Number(n || 0).toFixed(2)).replace(".", ",");
          const rows = [["Date", "Durée (h)", "Type", "Description", "Lien", "Taux (DH/h)", "Montant (DH)"].map(q).join(";"), ...[...tot.lignes].sort((a, b) => (a.date < b.date ? -1 : 1)).map((l) => [formatDate(l.date), num(l.duree), l.type, l.description, l.lien, num(tauxMktAu(pid, l.date)), num(l.duree * tauxMktAu(pid, l.date))].map((v, i) => (i === 1 || i >= 5 ? v : q(v))).join(";")), ["", num(tot.heures), "", q("TOTAL"), "", "", num(tot.montant)].join(";")];
          await proposerTelechargement(`time-sheet-${(nomUtilisateur(pid) || pid).toLowerCase()}-${ym}.csv`, "﻿" + rows.join("\r\n"));
        };
        // Nils 12/10 : tout le monde voit tous les prospects (doublons) ; Salwa (marketing sans être Gérant) seulement les sources qui lui sont attribuées.
        const srcSalwa = sourcesSalwa();
        const voitTout = estGerant || peut("prospects.saisir");
        const prospectsMkt = (prospects || []).filter((p) => p.origineMkt && (voitTout || srcSalwa.includes(p.source || "Instagram"))).sort((a, b) => ((a.dateContact || "") < (b.dateContact || "") ? 1 : -1));
        const statutProspect = (p) => p.statut === "converti" ? ["Devenu client", VERT_OK] : p.statut === "perdu" ? ["Perdu", TAUPE] : !p.commercialId ? ["À affecter", ROUILLE] : p.contacteLe ? [`Contacté par ${nomUtilisateur(p.commercialId)}`, ENCRE] : [`Affecté à ${nomUtilisateur(p.commercialId)}`, OCRE];
        const affectables = utilisateurs.filter((u) => u.actif && u.profil !== P_MKT);
        return (
          <div>
            {estGerant && personnes.length > 1 && (
              <div style={{ marginBottom: 12 }}>
                <select className="sc-select" value={pid} onChange={(e) => setMktPersonne(e.target.value)} style={{ ...selectStyle, width: "auto" }}>
                  {personnes.map((u) => (<option key={u.id} value={u.id}>{u.nom}</option>))}
                </select>
              </div>
            )}
            {estGerant && !personnes.length && <div style={{ fontSize: 13, color: TAUPE, marginBottom: 12 }}>Aucun compte Marketing actif (Paramétrage › comptes d'accès).</div>}
            {mktComplet && renderBudgetCM(ym)}
            {mktComplet && (<>
            {carteM("Produits à booster", (
              <div>
                {(estGerant ? reglagesMkt.booster || [] : boostersActifs).length === 0 && <div style={{ fontSize: 13, color: TAUPE }}>Aucun produit à booster pour le moment.</div>}
                {(estGerant ? reglagesMkt.booster || [] : boostersActifs).map((b) => {
                  const actif = boostersActifs.some((x) => x.id === b.id);
                  return (
                    <div key={b.id} style={{ display: "flex", gap: 10, alignItems: "center", padding: "6px 0", borderBottom: `1px solid ${PIERRE}`, opacity: actif ? 1 : 0.5 }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 14, fontWeight: 600 }}>🔥 {b.produit}</div>
                        <div style={{ fontSize: 12, color: TAUPE }}>{b.du || b.au ? `${b.du ? `du ${formatDate(b.du)}` : ""}${b.au ? ` au ${formatDate(b.au)}` : ""}` : "sans date de fin"}{b.consigne ? ` — ${b.consigne}` : ""}</div>
                      </div>
                      {estGerant && <button type="button" className="sc-btn" onClick={() => setBoosterEdit({ ...b })} style={iconBtnStyle} title="Modifier">✎</button>}
                      {estGerant && <button type="button" className="sc-btn" onClick={() => supprimerBooster(b.id)} style={iconBtnStyle} title="Supprimer">✕</button>}
                    </div>
                  );
                })}
              </div>
            ), estGerant ? <button type="button" className="sc-btn" onClick={() => setBoosterEdit({ produit: "", du: todayISO(), au: "", consigne: "" })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0" }}>+ Produit à booster</button> : null)}
            {pid && carteM(`Time sheet — ${nomUtilisateur(pid)}`, (
              <div>
                <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
                  <input type="month" className="sc-input" value={ym} onChange={(e) => setMktMois(e.target.value)} style={{ ...inputStyle(160), padding: "5px 8px" }} />
                  <span style={{ fontSize: 13 }}><strong>{h(tot.heures)}</strong> · <strong>{formatDH(tot.montant)}</strong>{tauxActuel ? <span style={{ color: TAUPE }}> (taux {formatDH(tauxActuel)} / h)</span> : <span style={{ color: ROUILLE }}> · taux horaire non renseigné</span>}</span>
                  {valide ? <span style={{ fontSize: 12, fontWeight: 600, color: VERT_OK }}>✓ Mois validé le {formatDate(valide.le.slice(0, 10))} ({formatDH(valide.montant)})</span> : <span style={{ fontSize: 12, color: OCRE }}>Mois ouvert</span>}
                  {estGerant && !valide && tot.heures > 0 && <button type="button" className="sc-btn" onClick={() => validerMoisMkt(pid, ym, true)} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 12px" }}>✓ Valider le mois</button>}
                  {estGerant && valide && <button type="button" className="sc-btn" onClick={() => validerMoisMkt(pid, ym, false)} style={{ ...ghostBtnStyle, fontSize: 12 }}>↺ Rouvrir</button>}
                  <button type="button" className="sc-btn" onClick={exporter} disabled={!tot.lignes.length} style={{ ...ghostBtnStyle, fontSize: 12, marginLeft: "auto", opacity: tot.lignes.length ? 1 : 0.5 }}>⬇ Exporter (Excel)</button>
                  {(pid === user.id || estGerant) && <button type="button" className="sc-btn" onClick={() => setTsEdit({ date: todayISO(), duree: "", type: "", description: "", lien: "", parId: pid })} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 12px" }}>+ Ligne</button>}
                </div>
                {tot.lignes.length === 0 ? <div style={{ fontSize: 13, color: TAUPE }}>Aucune ligne ce mois-ci.</div> : (
                  <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 13 }}>
                    <thead><tr style={{ color: TAUPE, fontSize: 11, textAlign: "left" }}><th style={{ padding: 4 }}>Date</th><th style={{ padding: 4 }}>Durée</th><th style={{ padding: 4 }}>Type</th><th style={{ padding: 4 }}>Description</th><th style={{ padding: 4 }}>Montant</th><th></th></tr></thead>
                    <tbody>
                      {[...tot.lignes].sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : a.le < b.le ? 1 : -1)).map((l) => {
                        const verrou = ligneTsVerrouillee(l);
                        return (
                          <tr key={l.id} style={{ borderTop: `1px solid ${PIERRE}` }}>
                            <td style={{ padding: 4, whiteSpace: "nowrap" }}>{formatDate(l.date)}</td>
                            <td style={{ padding: 4, whiteSpace: "nowrap" }}>{h(l.duree)}</td>
                            <td style={{ padding: 4 }}>{l.type}</td>
                            <td style={{ padding: 4 }}>{l.description}{l.lien ? <> · <a href={l.lien} target="_blank" rel="noreferrer" style={{ color: ENCRE }}>lien</a></> : null}</td>
                            <td style={{ padding: 4, whiteSpace: "nowrap" }}>{formatDH(l.duree * tauxMktAu(pid, l.date))}</td>
                            <td style={{ padding: 4, whiteSpace: "nowrap", textAlign: "right" }}>
                              {verrou ? <span title="Verrouillée (plus de 7 jours ou mois validé)">🔒</span> : (
                                <>
                                  <button type="button" className="sc-btn" onClick={() => setTsEdit({ ...l, duree: String(l.duree).replace(".", ",") })} style={iconBtnStyle} title="Modifier">✎</button>
                                  <button type="button" className="sc-btn" onClick={() => supprimerLigneTs(l)} style={iconBtnStyle} title="Supprimer">✕</button>
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>Une ligne se modifie pendant {JOURS_VERROU_TIMESHEET} jours ; ensuite elle est verrouillée (seul le Gérant peut la corriger). Paiement prévu le {JOUR_PAIEMENT_MKT} du mois suivant (Caisse Nils).</div>
                <div style={{ marginTop: 12 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Récapitulatif</div>
                  {recap.map((m) => { const t = totauxMoisMkt(pid, m); const v = moisValideMkt(pid, m); return (
                    <div key={m} onClick={() => setMktMois(m)} style={{ display: "flex", gap: 12, fontSize: 12, padding: "3px 0", cursor: "pointer", fontWeight: m === ym ? 600 : 400 }}>
                      <span style={{ width: 120 }}>{libMois(m)}</span><span style={{ width: 70 }}>{h(v ? v.heures : t.heures)}</span><span style={{ width: 110 }}>{formatDH(v ? v.montant : t.montant)}</span>
                      <span style={{ color: v ? VERT_OK : OCRE }}>{v ? "validé" : "ouvert"} · payé le {formatDate(ajouterMoisISO(`${m}-01`, 1, JOUR_PAIEMENT_MKT))}</span>
                    </div>
                  ); })}
                </div>
                <div style={{ marginTop: 12, paddingTop: 10, borderTop: `1px solid ${PIERRE}`, fontSize: 12 }}>
                  <strong>Taux horaire :</strong> {tauxActuel ? `${formatDH(tauxActuel)} / h` : "non renseigné"}{hist.length > 1 ? <span style={{ color: TAUPE }}> — historique : {hist.map((t) => `${formatDH(t.taux)} dès le ${formatDate(t.dateEffet)}`).join(" · ")}</span> : null}
                  {estGerant && (
                    <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 6, flexWrap: "wrap" }}>
                      <input className="sc-input" value={mktTauxSaisi.taux} onChange={(e) => setMktTauxSaisi({ ...mktTauxSaisi, taux: e.target.value })} placeholder="Taux DH / h" style={{ ...inputStyle(110), padding: "4px 8px", fontSize: 12 }} />
                      <span>à partir du</span>
                      <input type="date" className="sc-input" value={mktTauxSaisi.dateEffet || `${todayISO().slice(0, 7)}-01`} onChange={(e) => setMktTauxSaisi({ ...mktTauxSaisi, dateEffet: e.target.value })} style={{ ...inputStyle(150), padding: "4px 8px", fontSize: 12 }} />
                      <button type="button" className="sc-btn" onClick={() => enregistrerTauxMkt(pid)} disabled={!mktTauxSaisi.taux} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0", opacity: mktTauxSaisi.taux ? 1 : 0.5 }}>Enregistrer le taux</button>
                    </div>
                  )}
                </div>
              </div>
            ))}
            </>)}
            {mktComplet && (() => {
              const st = (prospects || []).filter((p) => p.origineMkt && srcSalwa.includes(p.source || "Instagram"));
              const calc = (l) => ({ n: l.length, aff: l.filter((p) => p.commercialId).length, cont: l.filter((p) => p.contacteLe || p.statut === "converti").length, conv: l.filter((p) => p.statut === "converti").length, perdus: l.filter((p) => p.statut === "perdu").length, ca: l.reduce((n, p) => n + ((docsProspect(p) || {}).factureHT || 0), 0) });
              const mois = calc(st.filter((p) => String(p.dateContact || "").slice(0, 7) === ym));
              const annee = calc(st.filter((p) => String(p.dateContact || "").slice(0, 4) === ym.slice(0, 4)));
              const ligne = (lib, x) => <tr><td style={{ padding: "2px 10px" }}>{lib}</td>{[x.n, x.aff, x.cont, x.conv, x.perdus].map((v, i) => <td key={i} style={{ padding: "2px 10px", textAlign: "right" }}>{v}</td>)}<td style={{ padding: "2px 10px", textAlign: "right" }}>{x.n ? `${Math.round((x.conv / x.n) * 100)} %` : "—"}</td><td style={{ padding: "2px 10px", textAlign: "right", fontWeight: 600 }}>{formatDH(x.ca)}</td></tr>;
              return carteM("Statistiques prospects — community management", (
                <div>
                  <table style={{ borderCollapse: "collapse", fontSize: 12 }}>
                    <thead><tr>{["", "Prospects", "Affectés", "Contactés", "Convertis", "Perdus", "Taux de conversion", "Facturé HT"].map((x, i) => <th key={i} style={{ fontSize: 10, color: TAUPE, textAlign: i ? "right" : "left", padding: "3px 10px" }}>{x}</th>)}</tr></thead>
                    <tbody>{ligne(libPeriode(ym), mois)}{ligne(`Année ${ym.slice(0, 4)}`, annee)}</tbody>
                  </table>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Tous les prospects, quel que soit qui les a saisis, dont la source est attribuée au community management : {srcSalwa.join(", ") || "aucune"}{estGerant ? " (Paramétrage › Budget community management)" : ""}. Mois de la date du contact ; « facturé » = factures des dossiers du client issu du prospect.</div>
                </div>
              ));
            })()}
            {carteM(`Prospects — ${prospectsMkt.filter((p) => p.statut === "actif" && !p.commercialId).length} à affecter`, prospectsMkt.length === 0 ? <div style={{ fontSize: 13, color: TAUPE }}>Aucun prospect.</div> : (
              <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 13 }}>
                <thead><tr style={{ color: TAUPE, fontSize: 11, textAlign: "left" }}><th style={{ padding: 4 }}>Contact</th><th style={{ padding: 4 }}>Source · saisi par</th><th style={{ padding: 4 }}>Prospect</th><th style={{ padding: 4 }}>Projet / produit</th><th style={{ padding: 4 }}>Suivi</th><th></th></tr></thead>
                <tbody>
                  {prospectsMkt.map((p) => { const [lib, coul] = statutProspect(p); return (
                    <tr key={p.id} style={{ borderTop: `1px solid ${PIERRE}`, verticalAlign: "top" }}>
                      <td style={{ padding: 4, whiteSpace: "nowrap" }}>{formatDate(p.dateContact)}</td>
                      <td style={{ padding: 4, fontSize: 12 }}><b>{p.source || "Instagram"}</b>{p.recuPar ? <span style={{ color: TAUPE }}> · {p.recuPar}</span> : null}<div style={{ color: TAUPE }}>saisi par {p.creePar || "?"}{p.creeLe ? ` le ${formatDate(p.creeLe.slice(0, 10))}` : ""}</div></td>
                      <td style={{ padding: 4 }}><strong>{p.nom}</strong>{p.ville ? ` — ${p.ville}` : ""}<div style={{ fontSize: 12, color: TAUPE }}>{[p.telephone, p.email].filter(Boolean).join(" · ")}{p.lien ? <> · <a href={p.lien} target="_blank" rel="noreferrer" style={{ color: ENCRE }}>message</a></> : null}</div></td>
                      <td style={{ padding: 4 }}>{p.projet}{p.produitInteret ? <div style={{ fontSize: 12, color: TAUPE }}>{p.produitInteret}</div> : null}</td>
                      <td style={{ padding: 4 }}>
                        <span style={{ fontSize: 12, fontWeight: 600, color: coul }}>{lib}</span>
                        {(p.reports || []).length > 0 && p.statut === "actif" && !p.contacteLe && <span style={{ fontSize: 11, color: OCRE }}> · reporté {(p.reports || []).length} fois</span>}
                        {suiviProspect(p)}
                        {estGerant && p.statut === "actif" && (
                          <div><select className="sc-select" value={p.commercialId || ""} onChange={(e) => affecterProspectMkt(p, e.target.value)} style={{ ...selectStyle, fontSize: 12, padding: "3px 6px", width: "auto", marginTop: 4 }}>
                            <option value="">— Affecter à —</option>
                            {affectables.map((u) => (<option key={u.id} value={u.id}>{u.nom}</option>))}
                          </select></div>
                        )}
                      </td>
                      <td style={{ padding: 4, textAlign: "right", whiteSpace: "nowrap" }}>
                        {estGerant && p.statut === "actif" && <button type="button" className="sc-btn" onClick={() => setRelierProspect({ id: p.id, clientId: "" })} style={iconBtnStyle} title="Relier à un client existant">🔗</button>}
                        {(estGerant || !p.commercialId) && p.statut === "actif" && <button type="button" className="sc-btn" onClick={() => setProspectMkt({ ...p })} style={iconBtnStyle} title="Modifier">✎</button>}
                      </td>
                    </tr>
                  ); })}
                </tbody>
              </table>
            ), <button type="button" className="sc-btn" onClick={() => setProspectMkt({ nom: "", telephone: "", email: "", ville: "", projet: "", produitInteret: "", dateContact: todayISO(), lien: "", source: "", recuPar: "" })} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 12px" }}>+ Prospect</button>)}
          </div>
        );
      })()}
      {activeTab === "rapportCommercial" && peut("commercial.rapport") && (() => {
        const coms = commerciauxRapport();
        const comId = estGerant ? (rcCom && coms.some((u) => u.id === rcCom) ? rcCom : (coms.find((u) => u.profil !== P_GERANT) || coms[0] || user).id) : user.id;
        const lundi = rcLundi || lundiDe(todayISO());
        const r = rapportComDe(comId, lundi);
        const fige = rapportComFige(comId, lundi);
        const estLeMien = comId === user.id;
        const peutEditer = (estLeMien || estGerant) && !fige;
        const ind = r && r.indicateurs && fige ? r.indicateurs : indicateursRapportCom(comId, lundi);
        const vs = visitesSemaine(comId, lundi);
        const chantiersR = (r && r.chantiers) || [];
        const nbChantiers = chantiersR.filter((x) => (x.nom || "").trim()).length;
        const statutLib = !r || r.statut === "brouillon" ? (r && r.rouvertLe ? "Rouvert — à soumettre de nouveau" : "En cours — non soumis") : r.statut === "soumis" ? `Soumis le ${formatDateHeure(r.soumisLe)}` : `Lu par ${r.luPar} le ${formatDateHeure(r.luLe)}`;
        const statutCouleur = !r || r.statut === "brouillon" ? OCRE : r.statut === "soumis" ? ENCRE : VERT_OK;
        const tuile = (lib, val, sous) => (
          <div style={{ flex: "1 1 150px", background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "10px 12px" }}>
            <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>{lib}</div>
            <div style={{ fontSize: 20, fontWeight: 600, color: ENCRE, marginTop: 2 }}>{val}</div>
            {sous && <div style={{ fontSize: 11, color: TAUPE, marginTop: 2 }}>{sous}</div>}
          </div>
        );
        const sectionTitre = (t) => <div style={{ fontSize: 12, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5, color: "#fff", background: ENCRE, padding: "6px 10px", borderRadius: 6, margin: "20px 0 8px" }}>{t}</div>;
        const carteVisite = (v) => {
          const c = compteVisite(v) || {};
          const p = v.compteType === "prospect" ? c : null;
          const d = v.devisId ? (devisListe || []).find((x) => x.id === v.devisId) : null;
          return (
            <div key={v.id} style={{ background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 8, padding: 12, marginBottom: 8 }}>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 8, flexWrap: "wrap" }}>
                <div style={{ fontSize: 14, fontWeight: 600 }}>
                  {nomCompteVisite(v)}
                  <span style={{ fontSize: 12, color: TAUPE, fontWeight: 400 }}> · {c.type || ""}{c.ville ? ` · ${c.ville}` : ""}</span>
                  {p && p.statut === "converti" && <span style={{ fontSize: 11, color: VERT_OK, marginLeft: 6 }}>→ devenu client</span>}
                </div>
                <div style={{ fontSize: 12, color: TAUPE }}>
                  {formatDate(v.date)}{v.heure ? ` à ${v.heure}` : ""} · {v.typeVisite}{d ? ` · devis ${d.numero}` : ""}
                  {peut("echantillons.demander") && (v.commercialId === user.id || estGerant) && (v.compteType === "client" || v.compteType === "prospect") && <button type="button" className="sc-btn" onClick={() => { setEchRechercheModal(""); setDemandeEchEdit(nouvelleDemandeEch({ commercialId: v.commercialId, compteType: v.compteType, compteId: v.compteId, visiteId: v.id })); }} style={{ ...iconBtnStyle, marginLeft: 6 }} title="Demander des échantillons pour ce compte">🎁</button>}
                  {peutEditer && <button type="button" className="sc-btn" onClick={() => ouvrirVisite(v)} style={{ ...iconBtnStyle, marginLeft: 6 }} title="Modifier">✎</button>}
                </div>
              </div>
              {p && (
                <div style={{ fontSize: 12, marginTop: 4, display: "flex", gap: 12, flexWrap: "wrap" }}>
                  {v.temperature && <span style={{ color: COULEUR_TEMPERATURE[v.temperature] || ENCRE, fontWeight: 600 }}>● {v.temperature}</span>}
                  {v.caPotentiel !== "" && v.caPotentiel !== undefined && <span>CA potentiel {formatDH(v.caPotentiel)} HT</span>}
                  {v.remise !== "" && v.remise !== undefined && <span>remise envisagée {v.remise} %</span>}
                  {prospectParticulier(p) && <span style={{ color: TAUPE }}>source : {p.source || "?"}{p.source === "Apporteur" ? ` — ${p.apporteur}${p.commissionConvenue === true ? `, commission${voitTauxApporteur ? ` ${p.tauxCommission === "" || p.tauxCommission === undefined ? "(taux à définir par la direction)" : `${p.tauxCommission} %`}` : " convenue"}` : p.commissionConvenue === false ? ", sans commission" : ""}` : ""}</span>}
                </div>
              )}
              <div style={{ fontSize: 13, marginTop: 6, whiteSpace: "pre-wrap" }}>{v.synthese}</div>
              {(v.actions || []).length > 0 && (
                <div style={{ marginTop: 6 }}>
                  {(v.actions || []).map((a) => (
                    <label key={a.id} style={{ display: "flex", gap: 6, fontSize: 12, alignItems: "flex-start", cursor: estLeMien || estGerant ? "pointer" : "default" }}>
                      <input type="checkbox" checked={!!a.faite} disabled={!(estLeMien || estGerant)} onChange={(e) => cocherActionVisite(v.id, a.id, e.target.checked)} style={{ marginTop: 2 }} />
                      <span style={{ textDecoration: a.faite ? "line-through" : "none", color: a.faite ? TAUPE : a.echeance && a.echeance <= todayISO() ? ROUILLE : ENCRE }}>{a.texte}{a.echeance ? ` — pour le ${formatDate(a.echeance)}` : ""}</span>
                    </label>
                  ))}
                </div>
              )}
              {(v.compteType === "client" || !prospectParticulier(p)) && (
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Échantillons : {v.echantillonsControle ? "☑" : "☐"} contrôle avec la liste de référence · {v.echantillonsManquants ? "☑" : "☐"} manquants transmis à l'ADV</div>
              )}
            </div>
          );
        };
        const majChantiers = (liste) => majRapportCom(comId, lundi, { chantiers: liste });
        // Nils 04/10 : une visite chantier peut référencer un devis ou une commande en cours du commercial
        // (commandes non facturées, ou facturées depuis moins de 60 jours — la pose vient souvent de finir).
        const docsChantier = docsChantierRapportCom(comId);
        const nomsChantiers = [...new Set([...(chantiers || []).map((c) => c.nom), ...(commandesListe || []).filter((c) => c.reference).map((c) => `${c.reference} (${(clientDe(c.clientId) || {}).nom || "?"})`)].filter(Boolean))].sort((a, b) => a.localeCompare(b, "fr"));
        const mesProspects = (prospects || []).filter((p) => estGerant ? (rcFiltreProspects.com ? p.commercialId === rcFiltreProspects.com : true) : p.commercialId === user.id);
        const listeProspects = mesProspects.filter((p) => (rcFiltreProspects.statut === "tous" ? true : (p.statut || "actif") === rcFiltreProspects.statut)).sort((a, b) => a.nom.localeCompare(b.nom, "fr"));
        const derniereVisite = (pid) => (visites || []).filter((v) => v.compteId === pid).sort((a, b) => b.date.localeCompare(a.date))[0];
        return (
          <div>
            <div style={{ display: "flex", gap: 6, marginBottom: 14, flexWrap: "wrap", alignItems: "center" }}>
              {[["semaine", "📋 Rapport de la semaine"], ["prospects", `🎯 Prospects (${mesProspects.filter((p) => (p.statut || "actif") === "actif").length})`]].map(([id, lib]) => (
                <button key={id} type="button" className="sc-btn" onClick={() => setRcVue(id)} style={{ padding: "7px 16px", borderRadius: 8, fontSize: 13, fontWeight: 600, background: rcVue === id ? ENCRE : PIERRE, color: rcVue === id ? "#fff" : ENCRE }}>{lib}</button>
              ))}
            </div>

            {rcVue === "semaine" && (
              <div>
                <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 12 }}>
                  {estGerant && (
                    <select className="sc-select" value={comId} onChange={(e) => setRcCom(e.target.value)} style={{ ...selectStyle, width: 200 }}>
                      {coms.map((u) => <option key={u.id} value={u.id}>{u.nom}</option>)}
                    </select>
                  )}
                  <button type="button" className="sc-btn" onClick={() => setRcLundi(decalerJours(lundi, -7))} style={{ ...ghostBtnStyle, padding: "6px 10px" }}>←</button>
                  <div style={{ fontSize: 14, fontWeight: 600 }}>{libelleSemaine(lundi)}</div>
                  <button type="button" className="sc-btn" onClick={() => setRcLundi(decalerJours(lundi, 7))} disabled={lundi >= lundiDe(todayISO())} style={{ ...ghostBtnStyle, padding: "6px 10px", opacity: lundi >= lundiDe(todayISO()) ? 0.4 : 1 }}>→</button>
                  {lundi !== lundiDe(todayISO()) && <button type="button" className="sc-btn" onClick={() => setRcLundi(lundiDe(todayISO()))} style={{ ...ghostBtnStyle, fontSize: 12 }}>Cette semaine</button>}
                  <span style={{ fontSize: 12, fontWeight: 600, color: statutCouleur, marginLeft: "auto" }}>{statutLib}</span>
                </div>

                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
                  {peutEditer && <button type="button" className="sc-btn" onClick={() => ouvrirVisite(nouvelleVisite(comId, lundi))} style={primaryBtnStyle}>+ Visite</button>}
                  {peut("echantillons.demander") && (estLeMien || estGerant) && <button type="button" className="sc-btn" onClick={() => { setEchRechercheModal(""); setDemandeEchEdit(nouvelleDemandeEch({ commercialId: comId })); }} style={ghostBtnStyle}>🎁 Demande d'échantillons</button>}
                  {!fige && estLeMien && <button type="button" className="sc-btn" onClick={() => soumettreRapportCom(comId, lundi)} style={{ ...primaryBtnStyle, background: VERT_OK }}>✓ Soumettre le rapport</button>}
                  {!fige && estGerant && !estLeMien && <button type="button" className="sc-btn" onClick={() => soumettreRapportCom(comId, lundi)} style={ghostBtnStyle}>Soumettre à sa place</button>}
                  <button type="button" className="sc-btn" onClick={() => telechargerRapportCom(comId, lundi)} style={ghostBtnStyle}>⬇ Télécharger (PDF)</button>
                  {estGerant && fige && <button type="button" className="sc-btn" onClick={() => rouvrirRapportCom(comId, lundi)} style={ghostBtnStyle}>↺ Rouvrir</button>}
                </div>

                {estGerant && r && r.statut === "soumis" && (
                  <div style={{ background: "#F5EFE0", borderRadius: 8, padding: 12, marginBottom: 12 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>Rapport à lire</div>
                    <textarea className="sc-input" value={rcCommentaireLu} onChange={(e) => setRcCommentaireLu(e.target.value)} placeholder="Commentaire pour le commercial (facultatif)" rows={2} style={{ ...inputStyle("100%"), resize: "vertical", background: "#fff" }} />
                    <button type="button" className="sc-btn" onClick={async () => { await marquerRapportComLu(comId, lundi, rcCommentaireLu.trim()); setRcCommentaireLu(""); }} style={{ ...primaryBtnStyle, marginTop: 8 }}>✓ Marquer comme lu</button>
                  </div>
                )}
                {r && r.commentaireNils && (
                  <div style={{ background: "#E4EBE4", borderRadius: 8, padding: 12, marginBottom: 12, fontSize: 13 }}>
                    <strong>Commentaire du Gérant :</strong> <span style={{ whiteSpace: "pre-wrap" }}>{r.commentaireNils}</span>
                  </div>
                )}

                {boostersActifs.length > 0 && (
                  <div style={{ background: "#F5EFE0", borderRadius: 8, padding: "10px 12px", marginBottom: 12, fontSize: 13 }}>
                    <strong>🔥 Produits à booster :</strong> {boostersActifs.map((b) => `${b.produit}${b.au ? ` (jusqu'au ${formatDate(b.au)})` : ""}${b.consigne ? ` — ${b.consigne}` : ""}`).join(" · ")}
                  </div>
                )}
                {(() => {
                  const aT = prospectsATraiter(comId, lundi);
                  if (!aT.length) return null;
                  return (
                    <div>
                      {sectionTitre(`Prospects à traiter (${aT.length})`)}
                      {aT.map((p) => (
                        <div key={p.id} style={{ background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 8, padding: 12, marginBottom: 8, display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
                          <div style={{ flex: "1 1 260px" }}>
                            <div style={{ fontSize: 14, fontWeight: 600 }}>{p.nom}{p.ville ? <span style={{ fontWeight: 400, color: TAUPE }}> · {p.ville}</span> : null} <span style={{ fontSize: 11, color: TAUPE, fontWeight: 400 }}>· {p.source || "Instagram"}, saisi par {p.creePar || "?"}, affecté le {formatDate(p.affecteLe.slice(0, 10))}{(p.reports || []).length ? ` · reporté ${(p.reports || []).length} fois` : ""}{semaineProspect(p) < lundi ? " · en retard" : ""}</span></div>
                            <div style={{ fontSize: 12, color: TAUPE }}>{[p.telephone, p.email, p.produitInteret, p.projet].filter(Boolean).join(" — ")}{p.lien ? <> · <a href={p.lien} target="_blank" rel="noreferrer" style={{ color: ENCRE }}>message</a></> : null}</div>
                          </div>
                          {peutEditer && (
                            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                              <button type="button" className="sc-btn" onClick={() => ouvrirVisite({ ...nouvelleVisite(comId, lundi), compteType: "prospect", compteId: p.id })} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 10px" }}>📝 Saisir la visite / l'appel</button>
                              <button type="button" className="sc-btn" onClick={() => reporterProspect(p)} style={{ ...ghostBtnStyle, fontSize: 12 }}>⏭ Reporter à la semaine suivante</button>
                              <button type="button" className="sc-btn" onClick={() => marquerProspectPerdu(p, true)} style={{ ...ghostBtnStyle, fontSize: 12, color: ROUILLE }}>Perdu</button>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  );
                })()}
                {sectionTitre("Résumé · indicateurs clés de la semaine")}
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {tuile("Visites réalisées", ind.visites)}
                  {tuile("Devis émis *", ind.devisEmis, (ind.devisListe || []).join(", "))}
                  {tuile("Transformations en BDC", ind.bdc, `${formatDH(ind.bdcHT)} HT`)}
                  {tuile("CA facturé HT", formatDH(ind.caFactureHT), `${ind.factures} facture(s)`)}
                </div>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>* Nouveaux devis du commercial (date du devis) — une copie actualisée d'un devis du même client ne compte pas. BDC : dossiers créés dans la semaine sur ses devis. CA facturé : factures datées de la semaine sur ses devis.{fige ? " Chiffres figés à la soumission." : ""}</div>

                {RUBRIQUES_RC.map((rb) => {
                  const l = vs.filter((v) => rubriqueVisite(v) === rb.cle);
                  return (
                    <div key={rb.cle}>
                      {sectionTitre(`${rb.titre} (${l.length})`)}
                      {l.length ? l.map(carteVisite) : <div style={{ fontSize: 12, color: TAUPE, fontStyle: "italic" }}>Aucune visite.</div>}
                    </div>
                  );
                })}

                {sectionTitre(`4 · Visites chantier — contenu Instagram (${nbChantiers} / ${MIN_VISITES_CHANTIER})`)}
                <datalist id="rc-chantiers">{nomsChantiers.map((n) => <option key={n} value={n} />)}</datalist>
                {chantiersR.map((x, i) => (
                  <div key={x.id || i} style={{ display: "flex", gap: 8, marginBottom: 6, alignItems: "center", flexWrap: "wrap" }}>
                    <select className="sc-select" value={x.lien ? `${x.lien.kind}:${x.lien.id}` : ""} disabled={!peutEditer} onChange={(e) => { const d = docsChantier.find((y) => y.val === e.target.value); majChantiers(chantiersR.map((y, j) => (j === i ? { ...y, lien: d ? { kind: d.kind, id: d.id } : null, nom: d && !(y.nom || "").trim() ? d.nom : y.nom } : y))); }} style={{ ...selectStyle, width: 260 }}>
                      <option value="">Devis / commande lié(e) —</option>
                      {x.lien && !docsChantier.some((y) => y.val === `${x.lien.kind}:${x.lien.id}`) && <option value={`${x.lien.kind}:${x.lien.id}`}>{libDocChantier(x.lien)}</option>}
                      {docsChantier.map((d) => <option key={d.val} value={d.val}>{d.lib}</option>)}
                    </select>
                    <input key={`nom-${x.id}-${x.nom || ""}`} className="sc-input" list="rc-chantiers" defaultValue={x.nom || ""} disabled={!peutEditer} onBlur={(e) => { if (e.target.value !== (x.nom || "")) majChantiers(chantiersR.map((y, j) => (j === i ? { ...y, nom: e.target.value } : y))); }} placeholder="Chantier / client" style={{ ...inputStyle(240) }} />
                    <select className="sc-select" value={x.photos === true ? "oui" : x.photos === false ? "non" : ""} disabled={!peutEditer} onChange={(e) => majChantiers(chantiersR.map((y, j) => (j === i ? { ...y, photos: e.target.value === "oui" ? true : e.target.value === "non" ? false : null } : y)))} style={{ ...selectStyle, width: 130 }}>
                      <option value="">Photos ?</option>
                      <option value="oui">Photos : oui</option>
                      <option value="non">Photos : non</option>
                    </select>
                    <input className="sc-input" defaultValue={x.commentaire || ""} disabled={!peutEditer} onBlur={(e) => { if (e.target.value !== (x.commentaire || "")) majChantiers(chantiersR.map((y, j) => (j === i ? { ...y, commentaire: e.target.value } : y))); }} placeholder="Commentaire (matière, finition, ambiance, post prévu…)" style={{ ...inputStyle(320), flex: 1 }} />
                    {peutEditer && <button type="button" className="sc-btn" onClick={() => majChantiers(chantiersR.filter((y, j) => j !== i))} style={iconBtnStyle} title="Retirer">✕</button>}
                  </div>
                ))}
                {peutEditer && <button type="button" className="sc-btn" onClick={() => majChantiers([...chantiersR, { id: uid(), nom: "", photos: null, commentaire: "" }])} style={{ ...ghostBtnStyle, fontSize: 12 }}>+ Visite chantier</button>}
                <div style={{ fontSize: 11, color: nbChantiers < MIN_VISITES_CHANTIER ? ROUILLE : TAUPE, marginTop: 6 }}>{nbChantiers < MIN_VISITES_CHANTIER ? `⚠ ${nbChantiers} / ${MIN_VISITES_CHANTIER} minimum. ` : ""}{CONSIGNE_CHANTIER}</div>

                {sectionTitre("5 · Problématiques & remontées terrain")}
                <Field label="Difficultés rencontrées cette semaine (prix, délais, SAV, logistique, concurrence, organisation interne…)">
                  <textarea key={`dif-${comId}-${lundi}-${r ? r.statut : ""}`} className="sc-input" defaultValue={(r && r.difficultes) || ""} disabled={!peutEditer} onBlur={(e) => { if (e.target.value !== ((r && r.difficultes) || "")) majRapportCom(comId, lundi, { difficultes: e.target.value }); }} rows={3} style={{ ...inputStyle("100%"), resize: "vertical" }} />
                </Field>
                <Field label="Signaux marché / informations concurrentes">
                  <textarea key={`sig-${comId}-${lundi}-${r ? r.statut : ""}`} className="sc-input" defaultValue={(r && r.signaux) || ""} disabled={!peutEditer} onBlur={(e) => { if (e.target.value !== ((r && r.signaux) || "")) majRapportCom(comId, lundi, { signaux: e.target.value }); }} rows={3} style={{ ...inputStyle("100%"), resize: "vertical" }} />
                </Field>
                <div style={{ fontSize: 11, color: TAUPE }}>Le Gérant est alerté à la soumission si l'un de ces deux champs est rempli.</div>
                <div style={{ fontSize: 12, color: TAUPE, fontStyle: "italic", borderTop: `1px solid ${PIERRE}`, marginTop: 20, paddingTop: 10 }}>{NOTE_RAPPORT_COM}</div>
              </div>
            )}

            {rcVue === "prospects" && (
              <div>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12, alignItems: "center" }}>
                  <button type="button" className="sc-btn" onClick={() => { setProspectEdit(nouveauProspect(estGerant ? (rcFiltreProspects.com || comId) : user.id)); setProspectErreur(""); }} style={primaryBtnStyle}>+ Nouveau prospect</button>
                  <select className="sc-select" value={rcFiltreProspects.statut} onChange={(e) => setRcFiltreProspects({ ...rcFiltreProspects, statut: e.target.value })} style={{ ...selectStyle, width: 170 }}>
                    <option value="actif">Actifs</option>
                    <option value="converti">Devenus clients</option>
                    <option value="perdu">Perdus</option>
                    <option value="tous">Tous</option>
                  </select>
                  {estGerant && (
                    <select className="sc-select" value={rcFiltreProspects.com} onChange={(e) => setRcFiltreProspects({ ...rcFiltreProspects, com: e.target.value })} style={{ ...selectStyle, width: 200 }}>
                      <option value="">Tous les commerciaux</option>
                      {coms.map((u) => <option key={u.id} value={u.id}>{u.nom}</option>)}
                    </select>
                  )}
                </div>
                {listeProspects.length === 0 && <div style={{ fontSize: 13, color: TAUPE }}>Aucun prospect.</div>}
                {listeProspects.map((p) => {
                  const dv = derniereVisite(p.id);
                  const sansTaux = prospectParticulier(p) && p.source === "Apporteur" && p.commissionConvenue === true && (p.tauxCommission === "" || p.tauxCommission === undefined);
                  return (
                    <div key={p.id} style={{ background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 8, padding: 12, marginBottom: 8, display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
                      <div style={{ flex: "1 1 260px" }}>
                        <div style={{ fontSize: 14, fontWeight: 600 }}>{p.nom} <span style={{ fontSize: 12, fontWeight: 400, color: TAUPE }}>· {prospectParticulier(p) ? "B2C" : "B2B"} · {p.type}{p.ville ? ` · ${p.ville}` : ""}{estGerant ? ` · ${nomUtilisateur(p.commercialId)}` : ""}</span></div>
                        <div style={{ fontSize: 12, marginTop: 2, display: "flex", gap: 10, flexWrap: "wrap" }}>
                          {p.temperature && <span style={{ color: COULEUR_TEMPERATURE[p.temperature], fontWeight: 600 }}>● {p.temperature}</span>}
                          {p.caPotentiel !== "" && p.caPotentiel !== undefined && <span>CA potentiel {formatDH(p.caPotentiel)} HT</span>}
                          {p.remise !== "" && p.remise !== undefined && <span>remise {p.remise} %</span>}
                          {prospectParticulier(p) && p.source && <span style={{ color: TAUPE }}>source : {p.source}{p.source === "Apporteur" ? ` — ${p.apporteur}` : ""}</span>}
                          {sansTaux && <span style={{ color: ROUILLE, fontWeight: 600 }}>taux de commission à définir (Gérant)</span>}
                          <span style={{ color: TAUPE }}>{dv ? `dernière visite ${formatDate(dv.date)}` : "aucune visite"}</span>
                          {p.statut === "converti" && <span style={{ color: VERT_OK, fontWeight: 600 }}>devenu client</span>}
                          {p.statut === "perdu" && <span style={{ color: TAUPE, fontWeight: 600 }}>perdu</span>}
                          {p.origineMkt && <span style={{ color: TAUPE }}>{p.source || "Instagram"}{p.contacteLe ? " · contacté" : " · à contacter"}</span>}
                        </div>
                        {suiviProspect(p)}
                      </div>
                      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                        {(p.commercialId === user.id || estGerant) && <button type="button" className="sc-btn" onClick={() => { setProspectEdit({ ...p }); setProspectErreur(""); }} style={{ ...ghostBtnStyle, fontSize: 12 }}>✎ Fiche</button>}
                        {(p.statut || "actif") === "actif" && (p.commercialId === user.id || estGerant) && <button type="button" className="sc-btn" onClick={() => convertirProspectEnClient(p)} style={{ ...ghostBtnStyle, fontSize: 12, color: VERT_OK }}>→ Créer le client</button>}
                        {(p.statut || "actif") === "actif" && (p.commercialId === user.id || estGerant) && <button type="button" className="sc-btn" onClick={() => setRelierProspect({ id: p.id, clientId: "" })} style={{ ...ghostBtnStyle, fontSize: 12 }}>🔗 Relier à un client existant</button>}
                        {(p.statut || "actif") === "actif" && (p.commercialId === user.id || estGerant) && <button type="button" className="sc-btn" onClick={() => marquerProspectPerdu(p, true)} style={{ ...ghostBtnStyle, fontSize: 12, color: TAUPE }}>Perdu</button>}
                        {p.statut === "perdu" && (p.commercialId === user.id || estGerant) && <button type="button" className="sc-btn" onClick={() => marquerProspectPerdu(p, false)} style={{ ...ghostBtnStyle, fontSize: 12 }}>↺ Réactiver</button>}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {visiteEdit && (() => {
              const v = visiteEdit;
              const set = (patch) => setVisiteEdit({ ...v, ...patch });
              const clientsChoix = (clients || []).filter((c) => !c.archive && (estGerant ? (() => { const u = utilisateurs.find((x) => x.id === v.commercialId); return !u || u.profil === P_GERANT || c.commercialSC === u.nom; })() : clientVisiblePourUser(c))).sort((a, b) => a.nom.localeCompare(b.nom, "fr"));
              const prospectsChoix = (prospects || []).filter((p) => p.commercialId === v.commercialId && ((p.statut || "actif") === "actif" || p.id === v.compteId)).sort((a, b) => a.nom.localeCompare(b.nom, "fr"));
              const devisChoix = v.compteType === "client" && v.compteId ? (devisListe || []).filter((d) => d.clientId === v.compteId && d.numero).sort((a, b) => String(b.numero).localeCompare(String(a.numero))) : [];
              const pSel = v.compteType === "prospect" ? prospectDe(v.compteId) : null;
              return (
                <Overlay onClose={() => setVisiteEdit(null)}>
                  <div style={modalStyle(560)}>
                    <div style={modalTitleStyle}>{v.id ? "Visite" : "Nouvelle visite"}{estGerant && v.commercialId !== user.id ? ` — ${nomUtilisateur(v.commercialId)}` : ""}</div>
                    <div style={{ display: "flex", gap: 10 }}>
                      <Field label="Date" style={{ flex: 1 }}><input type="date" className="sc-input" value={v.date} max={todayISO()} onChange={(e) => set({ date: e.target.value })} style={inputStyle("100%")} /></Field>
                      <Field label="Heure" style={{ flex: 1 }}><input type="time" className="sc-input" value={v.heure || ""} onChange={(e) => set({ heure: e.target.value })} style={inputStyle("100%")} /></Field>
                      <Field label="Type de visite" style={{ flex: 1.3 }}>
                        <select className="sc-select" value={v.typeVisite} onChange={(e) => set({ typeVisite: e.target.value })} style={selectStyle}>{TYPES_VISITE.map((t) => <option key={t} value={t}>{t}</option>)}</select>
                      </Field>
                    </div>
                    <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
                      {[["client", "Client existant (élevage)"], ["prospect", "Prospect (chasse)"]].map(([t, lib]) => (
                        <button key={t} type="button" className="sc-btn" onClick={() => set({ compteType: t, compteId: "", devisId: "" })} style={{ padding: "6px 12px", borderRadius: 6, fontSize: 12, fontWeight: 600, background: v.compteType === t ? ENCRE : PIERRE, color: v.compteType === t ? "#fff" : ENCRE }}>{lib}</button>
                      ))}
                    </div>
                    {v.compteType === "client" ? (
                      <div style={{ display: "flex", gap: 10 }}>
                        <Field label="Client" style={{ flex: 1.4 }}>
                          <select className="sc-select" value={v.compteId} onChange={(e) => set({ compteId: e.target.value, devisId: "" })} style={selectStyle}>
                            <option value="">— Choisir —</option>
                            {clientsChoix.map((c) => <option key={c.id} value={c.id}>{c.nom}</option>)}
                          </select>
                        </Field>
                        <Field label="Devis concerné (facultatif)" style={{ flex: 1 }}>
                          <select className="sc-select" value={v.devisId || ""} onChange={(e) => set({ devisId: e.target.value })} disabled={!v.compteId} style={selectStyle}>
                            <option value="">—</option>
                            {devisChoix.map((d) => <option key={d.id} value={d.id}>{d.numero}{d.reference ? ` — ${d.reference}` : ""}</option>)}
                          </select>
                        </Field>
                      </div>
                    ) : (
                      <div>
                        <Field label="Prospect">
                          <div style={{ display: "flex", gap: 8 }}>
                            <select className="sc-select" value={v.compteId} onChange={(e) => { const p = prospectDe(e.target.value); set({ compteId: e.target.value, temperature: (p && p.temperature) || "", caPotentiel: p ? p.caPotentiel ?? "" : "", remise: p ? p.remise ?? "" : "" }); }} style={selectStyle}>
                              <option value="">— Choisir —</option>
                              {prospectsChoix.map((p) => <option key={p.id} value={p.id}>{p.nom} ({prospectParticulier(p) ? "B2C" : "B2B"})</option>)}
                            </select>
                            <button type="button" className="sc-btn" onClick={() => { setProspectEdit(nouveauProspect(v.commercialId)); setProspectErreur(""); }} style={{ ...ghostBtnStyle, fontSize: 12, whiteSpace: "nowrap" }}>+ Nouveau prospect</button>
                          </div>
                        </Field>
                        {pSel && (
                          <div style={{ display: "flex", gap: 10 }}>
                            <Field label="Température" style={{ flex: 1 }}>
                              <select className="sc-select" value={v.temperature || ""} onChange={(e) => set({ temperature: e.target.value })} style={selectStyle}>
                                <option value="">—</option>
                                {TEMPERATURES_PROSPECT.map((t) => <option key={t} value={t}>{t}</option>)}
                              </select>
                            </Field>
                            <Field label="CA potentiel (MAD HT)" style={{ flex: 1 }}><input className="sc-input" value={v.caPotentiel ?? ""} onChange={(e) => set({ caPotentiel: e.target.value })} style={inputStyle("100%")} /></Field>
                            <Field label="Remise envisagée (%)" style={{ flex: 0.8 }}><input className="sc-input" value={v.remise ?? ""} onChange={(e) => set({ remise: e.target.value })} style={inputStyle("100%")} /></Field>
                          </div>
                        )}
                      </div>
                    )}
                    <Field label="Synthèse de la visite">
                      <textarea className="sc-input" value={v.synthese} onChange={(e) => set({ synthese: e.target.value })} rows={4} style={{ ...inputStyle("100%"), resize: "vertical" }} />
                    </Field>
                    <div style={{ fontSize: 12, color: TAUPE, marginBottom: 4 }}>Actions à entreprendre / suivi — une action datée devient une tâche à cette date</div>
                    {(v.actions || []).map((a, i) => (
                      <div key={a.id || i} style={{ display: "flex", gap: 8, marginBottom: 6 }}>
                        <input className="sc-input" value={a.texte} onChange={(e) => set({ actions: v.actions.map((x, j) => (j === i ? { ...x, texte: e.target.value } : x)) })} placeholder="ex. envoyer le devis révisé" style={{ ...inputStyle("100%"), flex: 1 }} />
                        <input type="date" className="sc-input" value={a.echeance || ""} onChange={(e) => set({ actions: v.actions.map((x, j) => (j === i ? { ...x, echeance: e.target.value } : x)) })} style={inputStyle(150)} />
                        <button type="button" className="sc-btn" onClick={() => set({ actions: v.actions.filter((x, j) => j !== i) })} style={iconBtnStyle}>✕</button>
                      </div>
                    ))}
                    <button type="button" className="sc-btn" onClick={() => set({ actions: [...(v.actions || []), { id: uid(), texte: "", echeance: "", faite: false }] })} style={{ ...ghostBtnStyle, fontSize: 12, marginBottom: 10 }}>+ Action</button>
                    {(v.compteType === "client" || !prospectParticulier(pSel)) && (
                      <div style={{ marginBottom: 12 }}>
                        <div style={{ fontSize: 12, color: TAUPE, marginBottom: 4 }}>Échantillons</div>
                        <label style={{ display: "flex", gap: 6, fontSize: 13, cursor: "pointer" }}><input type="checkbox" checked={!!v.echantillonsControle} onChange={(e) => set({ echantillonsControle: e.target.checked })} /> Contrôle effectué avec la liste de référence</label>
                        <label style={{ display: "flex", gap: 6, fontSize: 13, cursor: "pointer" }}><input type="checkbox" checked={!!v.echantillonsManquants} onChange={(e) => set({ echantillonsManquants: e.target.checked })} /> Liste des manquants transmise à l'administration des ventes</label>
                      </div>
                    )}
                    {visiteErreur && <div style={errorTextStyle}>{visiteErreur}</div>}
                    <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 12 }}>
                      {v.id && <button type="button" className="sc-btn" onClick={() => supprimerVisite(v)} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>Supprimer</button>}
                      <button type="button" className="sc-btn" onClick={() => setVisiteEdit(null)} style={ghostBtnStyle}>Annuler</button>
                      <button type="button" className="sc-btn" onClick={enregistrerVisite} style={primaryBtnStyle}>Enregistrer</button>
                    </div>
                  </div>
                </Overlay>
              );
            })()}

            {prospectEdit && (() => {
              const p = prospectEdit;
              const set = (patch) => setProspectEdit({ ...p, ...patch });
              const particulier = prospectParticulier(p);
              const listeApp = [...(apporteursAffaire || [])].sort((a, b) => a.localeCompare(b, "fr"));
              const peutModifier = !p.id || p.commercialId === user.id || estGerant;
              return (
                <Overlay zIndex={200} onClose={() => setProspectEdit(null)}>
                  <div style={modalStyle(520)}>
                    <div style={modalTitleStyle}>{p.id ? `Prospect — ${p.nom}` : "Nouveau prospect"}</div>
                    <fieldset disabled={!peutModifier} style={{ border: "none", padding: 0, margin: 0 }}>
                      <div style={{ display: "flex", gap: 10 }}>
                        <Field label="Nom" style={{ flex: 1.5 }}><input className="sc-input" value={p.nom} onChange={(e) => set({ nom: e.target.value })} style={inputStyle("100%")} /></Field>
                        <Field label="Type de client" style={{ flex: 1 }}>
                          <select className="sc-select" value={p.type} onChange={(e) => set({ type: e.target.value })} style={selectStyle}>{TYPES_CLIENT.map((t) => <option key={t} value={t}>{t}</option>)}</select>
                        </Field>
                      </div>
                      {estGerant && (
                        <Field label="Commercial">
                          <select className="sc-select" value={p.commercialId} onChange={(e) => set({ commercialId: e.target.value })} style={selectStyle}>{commerciauxRapport().map((u) => <option key={u.id} value={u.id}>{u.nom}</option>)}</select>
                        </Field>
                      )}
                      <div style={{ display: "flex", gap: 10 }}>
                        <Field label="Ville" style={{ flex: 1 }}><input className="sc-input" value={p.ville} onChange={(e) => set({ ville: e.target.value })} style={inputStyle("100%")} /></Field>
                        <Field label="Contact" style={{ flex: 1 }}><input className="sc-input" value={p.contact} onChange={(e) => set({ contact: e.target.value })} style={inputStyle("100%")} /></Field>
                      </div>
                      <div style={{ display: "flex", gap: 10 }}>
                        <Field label="Téléphone" style={{ flex: 1 }}><input className="sc-input" value={p.telephone} onChange={(e) => set({ telephone: e.target.value })} style={inputStyle("100%")} /></Field>
                        <Field label="E-mail" style={{ flex: 1 }}><input className="sc-input" value={p.email} onChange={(e) => set({ email: e.target.value })} style={inputStyle("100%")} /></Field>
                      </div>
                      {particulier && (
                        <div style={{ background: PIERRE, borderRadius: 8, padding: 10, marginBottom: 12 }}>
                          <Field label="Source (particulier)">
                            <select className="sc-select" value={p.source || ""} onChange={(e) => set({ source: e.target.value })} style={{ ...selectStyle, background: "#fff" }}>
                              <option value="">— Choisir —</option>
                              {SOURCES_B2C.map((s) => <option key={s} value={s}>{s}</option>)}
                            </select>
                          </Field>
                          {p.source === "Apporteur" && (
                            <>
                              <Field label="Apporteur d'affaires">
                                {p.apporteurLibre ? (
                                  <div style={{ display: "flex", gap: 8 }}>
                                    <input className="sc-input" value={p.apporteur} onChange={(e) => set({ apporteur: e.target.value })} placeholder="Nom de l'apporteur" style={{ ...inputStyle("100%"), background: "#fff" }} />
                                    {listeApp.length > 0 && <button type="button" className="sc-btn" onClick={() => set({ apporteurLibre: false, apporteur: "" })} style={{ ...ghostBtnStyle, fontSize: 12, whiteSpace: "nowrap" }}>Choisir dans la liste</button>}
                                  </div>
                                ) : (
                                  <select className="sc-select" value={p.apporteur || ""} onChange={(e) => (e.target.value === "__libre" ? set({ apporteurLibre: true, apporteur: "" }) : set({ apporteur: e.target.value }))} style={{ ...selectStyle, background: "#fff" }}>
                                    <option value="">— Choisir —</option>
                                    {listeApp.map((a) => <option key={a} value={a}>{a}</option>)}
                                    <option value="__libre">Autre (saisie libre)…</option>
                                  </select>
                                )}
                              </Field>
                              <div style={{ display: "flex", gap: 14, alignItems: "center", fontSize: 13, flexWrap: "wrap" }}>
                                Commission convenue ?
                                <label style={{ cursor: "pointer" }}><input type="radio" checked={p.commissionConvenue === true} onChange={() => set({ commissionConvenue: true })} /> Oui</label>
                                <label style={{ cursor: "pointer" }}><input type="radio" checked={p.commissionConvenue === false} onChange={() => set({ commissionConvenue: false })} /> Non</label>
                                {p.commissionConvenue === true && (estGerant ? (
                                  <span>Taux : <input className="sc-input" value={p.tauxCommission ?? ""} onChange={(e) => set({ tauxCommission: e.target.value })} style={{ ...inputStyle(70), background: "#fff", padding: "4px 8px" }} /> %</span>
                                ) : (
                                  <span style={{ color: TAUPE }}>Taux : {!voitTauxApporteur || p.tauxCommission === "" || p.tauxCommission === undefined ? "défini par la direction" : `${p.tauxCommission} %`}</span>
                                ))}
                              </div>
                            </>
                          )}
                        </div>
                      )}
                      <div style={{ display: "flex", gap: 10 }}>
                        <Field label="Température" style={{ flex: 1 }}>
                          <select className="sc-select" value={p.temperature || ""} onChange={(e) => set({ temperature: e.target.value })} style={selectStyle}>
                            <option value="">—</option>
                            {TEMPERATURES_PROSPECT.map((t) => <option key={t} value={t}>{t}</option>)}
                          </select>
                        </Field>
                        <Field label="CA potentiel (MAD HT)" style={{ flex: 1 }}><input className="sc-input" value={p.caPotentiel ?? ""} onChange={(e) => set({ caPotentiel: e.target.value })} style={inputStyle("100%")} /></Field>
                        <Field label="Remise envisagée (%)" style={{ flex: 0.8 }}><input className="sc-input" value={p.remise ?? ""} onChange={(e) => set({ remise: e.target.value })} style={inputStyle("100%")} /></Field>
                      </div>
                      <Field label="Note"><textarea className="sc-input" value={p.note || ""} onChange={(e) => set({ note: e.target.value })} rows={2} style={{ ...inputStyle("100%"), resize: "vertical" }} /></Field>
                    </fieldset>
                    {(p.historique || []).length > 1 && (
                      <div style={{ fontSize: 11, color: TAUPE, marginBottom: 10 }}>
                        Historique : {(p.historique || []).slice().reverse().map((h, i) => <div key={i}>{formatDateHeure(h.le)} — {h.par} : {h.temperature || "—"}{h.caPotentiel !== "" && h.caPotentiel !== undefined ? ` · ${formatDH(h.caPotentiel)} HT` : ""}{h.remise !== "" && h.remise !== undefined ? ` · ${h.remise} %` : ""}</div>)}
                      </div>
                    )}
                    {prospectErreur && <div style={errorTextStyle}>{prospectErreur}</div>}
                    <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                      <button type="button" className="sc-btn" onClick={() => setProspectEdit(null)} style={ghostBtnStyle}>Annuler</button>
                      {peutModifier && <button type="button" className="sc-btn" onClick={enregistrerProspect} style={primaryBtnStyle}>Enregistrer</button>}
                    </div>
                  </div>
                </Overlay>
              );
            })()}
          </div>
        );
      })()}

      {activeTab === "flotte" && renderFlotte()}
      {activeTab === "planning" && (user.acces.devis || user.acces.commandes) && renderPlanning()}
      {activeTab === "outillage" && peutGererOutillage && (() => {
        const duFamille = (outils || []).filter((o) => familleOutil(o) === familleVue);
        const detenteurs = (affectations || []).filter((a) => (a.type !== "machine" && a.type !== "service" && !estBureautique) || duFamille.some((o) => o.detenteurId === a.id));
        const personnes = (affectations || []).filter((a) => a.type === "personne");
        const q = filtreOutils.q.trim().toLowerCase();
        const ctl = controleOuvert(familleVue);
        const liste = duFamille
          .filter((o) => (filtreOutils.etat === "tous" ? true : filtreOutils.etat === "actifs" ? outilActif(o) : o.etat === filtreOutils.etat))
          .filter((o) => !filtreOutils.detenteur || o.detenteurId === filtreOutils.detenteur)
          .filter((o) => !filtreOutils.categorie || o.categorie === filtreOutils.categorie)
          .filter((o) => !q || `${o.numero} ${o.designation} ${o.categorie} ${o.marque} ${o.modele} ${o.serie}`.toLowerCase().includes(q))
          .sort((a, b) => String(a.numero).localeCompare(String(b.numero)));
        const actifs = duFamille.filter(outilActif);
        const valeurParc = actifs.reduce((n, o) => n + (Number(o.prixAchatHT) || 0), 0);
        const coutRep = duFamille.reduce((n, o) => n + coutReparationsOutil(o), 0);
        const pertes = duFamille.filter((o) => o.etat === "Perdu / volé").reduce((n, o) => n + (Number(o.prixAchatHT) || 0), 0);
        const dernier = dernierControle(familleVue);
        const deuxFamilles = peut("outillage.gerer") && peut("outillage.bureautique");
        const sousOnglet = (id, label) => (
          <button type="button" className="sc-btn" onClick={() => setVueOutillage(id)} style={{ ...ghostBtnStyle, fontSize: 13, padding: "6px 12px", borderRadius: 6, background: vueOutillage === id ? PIERRE : "transparent", color: vueOutillage === id ? ENCRE : TAUPE }}>{label}</button>
        );
        const fp = personneFiche ? fichePersonne(personneFiche) : null;
        return (
          <div>
            {deuxFamilles && (
              <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
                {[["outillage", "🔧 Outillage"], ["bureautique", "💻 Bureautique"]].map(([f, lib]) => (
                  <button key={f} type="button" className="sc-btn" onClick={() => { setFamilleOutillage(f); setFiltreOutils({ ...filtreOutils, detenteur: "", categorie: "" }); }} style={{ padding: "7px 16px", borderRadius: 8, fontSize: 13, fontWeight: 600, background: familleVue === f ? ENCRE : PIERRE, color: familleVue === f ? "#fff" : ENCRE }}>{lib}</button>
                ))}
              </div>
            )}
            <div style={{ display: "flex", gap: 6, marginBottom: 16, flexWrap: "wrap", alignItems: "center" }}>
              {sousOnglet("registre", `Registre (${actifs.length})`)}
              {sousOnglet("personne", "Fiche personne")}
              {sousOnglet("controle", `${estBureautique ? "Inventaire semestriel" : "Contrôle mensuel"}${ctl ? " — en cours" : controleDu(familleVue) ? " — à faire" : ""}`)}
              {peutVoirCoutsOutillage && (
                <span style={{ fontSize: 12, color: TAUPE, marginLeft: "auto" }}>{estBureautique ? "Matériel actif" : "Parc actif"} : <strong style={{ color: ENCRE }}>{formatDH(valeurParc)}</strong> · réparations : <strong style={{ color: ENCRE }}>{formatDH(coutRep)}</strong> · pertes / vols : <strong style={{ color: ENCRE }}>{formatDH(pertes)}</strong></span>
              )}
            </div>

            {vueOutillage === "registre" && (
              <>
                <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 12 }}>
                  <input className="sc-input" value={filtreOutils.q} onChange={(e) => setFiltreOutils({ ...filtreOutils, q: e.target.value })} placeholder="Rechercher (n°, désignation, marque, série…)" style={{ ...inputStyle(280) }} />
                  <select className="sc-select" value={filtreOutils.detenteur} onChange={(e) => setFiltreOutils({ ...filtreOutils, detenteur: e.target.value })} style={{ ...selectStyle, width: "auto" }}>
                    <option value="">Tous les détenteurs</option>
                    {detenteurs.map((a) => (<option key={a.id} value={a.id}>{iconeAffectation(a)}{a.nom}</option>))}
                  </select>
                  <select className="sc-select" value={filtreOutils.categorie || ""} onChange={(e) => setFiltreOutils({ ...filtreOutils, categorie: e.target.value })} style={{ ...selectStyle, width: "auto" }}>
                    <option value="">Toutes les catégories</option>
                    {categoriesOutil().map((c) => (<option key={c} value={c}>{c}</option>))}
                  </select>
                  <select className="sc-select" value={filtreOutils.etat} onChange={(e) => setFiltreOutils({ ...filtreOutils, etat: e.target.value })} style={{ ...selectStyle, width: "auto" }}>
                    <option value="actifs">En service + en réparation</option>
                    {ETATS_OUTIL.map((x) => (<option key={x} value={x}>{x}</option>))}
                    <option value="tous">Tous</option>
                  </select>
                  {typesAffectationGerables().filter((t) => !estBureautique || t === "bureau").length > 0 && <button type="button" className="sc-btn" onClick={() => setShowDetenteursOutil(true)} style={{ ...ghostBtnStyle, marginLeft: "auto", fontSize: 12 }}>{estBureautique ? "Gérer les bureaux" : "Gérer les bureaux et machines"}</button>}
                  <button type="button" className="sc-btn" onClick={() => setShowCategoriesOutil(true)} style={{ ...ghostBtnStyle, marginLeft: typesAffectationGerables().filter((t) => !estBureautique || t === "bureau").length > 0 ? 0 : "auto", fontSize: 12 }}>Gérer les catégories</button>
                  <button type="button" className="sc-btn" onClick={() => setOutilEdit({ famille: familleVue, designation: "", categorie: categoriesOutil()[0] || "", marque: "", modele: "", serie: "", dateAchat: "", prixAchatHT: "", fournisseur: "", detenteurId: "", historique: [] })} style={primaryBtnStyle}>{estBureautique ? "+ Nouveau matériel" : "+ Nouvel outil"}</button>
                </div>
                <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden" }}>
                  <div style={{ display: "grid", gridTemplateColumns: "0.7fr 1.8fr 1.2fr 1.4fr 1fr 0.9fr", padding: "10px 16px", background: PIERRE, gap: 8 }}>
                    <Th>N°</Th><Th>Désignation</Th><Th>Catégorie</Th><Th>Détenteur</Th><Th>État</Th><Th>{peutVoirCoutsOutillage ? "Prix d'achat" : ""}</Th>
                  </div>
                  {liste.length === 0 && <div style={{ padding: 16, fontSize: 13, color: TAUPE }}>{estBureautique ? "Aucun matériel." : "Aucun outil."}</div>}
                  {liste.map((o) => (
                    <div key={o.id} className="sc-row" onClick={() => { setOutilAction(null); setOutilEdit(JSON.parse(JSON.stringify(o))); }} style={{ display: "grid", gridTemplateColumns: "0.7fr 1.8fr 1.2fr 1.4fr 1fr 0.9fr", padding: "10px 16px", gap: 8, alignItems: "center", borderBottom: `1px solid ${PIERRE}`, fontSize: 13, cursor: "pointer" }}>
                      <div style={{ fontWeight: 600 }}>{o.numero}</div>
                      <div>{o.designation}<div style={{ fontSize: 11, color: TAUPE }}>{[o.marque, o.modele, o.serie ? `S/N ${o.serie}` : ""].filter(Boolean).join(" · ")}</div></div>
                      <div>{o.categorie}</div>
                      <div>{o.detenteurId ? `${iconeAffectation((affectations || []).find((a) => a.id === o.detenteurId))}${nomAffectation(o.detenteurId)}` : "—"}</div>
                      <div style={{ color: o.etat === "En service" ? VERT_OK : o.etat === "En réparation" ? OCRE : ROUILLE }}>{o.etat}</div>
                      <div>{peutVoirCoutsOutillage && o.prixAchatHT !== "" && o.prixAchatHT !== undefined ? formatDH(Number(o.prixAchatHT) || 0) : ""}</div>
                    </div>
                  ))}
                </div>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>
                  Détenteurs = tout le personnel actif de l'onglet Staff, les bureaux (objet partagé entre plusieurs personnes){estBureautique ? "" : " et les machines"}, déclarés par le Gérant (Stock › Consommables en service › Machines et bureaux).
                </div>
              </>
            )}

            {vueOutillage === "personne" && (
              <>
                <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 14 }}>
                  <select className="sc-select" value={personneFiche} onChange={(e) => setPersonneFiche(e.target.value)} style={{ ...selectStyle, width: 280 }}>
                    <option value="">— Choisir une personne / un bureau —</option>
                    {(affectations || []).filter((a) => a.type !== "machine" && a.type !== "service").map((a) => (<option key={a.id} value={a.id}>{iconeAffectation(a)}{a.nom}</option>))}
                  </select>
                  {fp && <button type="button" className="sc-btn" onClick={() => imprimerRemiseOutils(fp.a.id)} style={ghostBtnStyle}>🖨 Fiche de remise {estBureautique ? "de matériel bureautique" : "d'outillage"}</button>}
                </div>
                {personnes.length === 0 && <div style={{ fontSize: 13, color: TAUPE }}>Aucune personne — les fiches se créent dans l'onglet Staff (Gérant, Administration).</div>}
                {fp && (
                  <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                    {fp.a.type === "personne" && (
                      <div style={{ fontSize: 13, display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                        Date d'embauche :
                        {peut("staff.gerer") ? (
                          <input type="date" className="sc-input" value={fp.a.dateEmbauche || ""} onChange={(e) => enregistrerDateEmbauche(fp.a.id, e.target.value)} style={{ ...inputStyle(160), padding: "4px 8px" }} />
                        ) : (<strong>{fp.a.dateEmbauche ? formatDate(fp.a.dateEmbauche) : "non renseignée"}</strong>)}
                        {fp.debut && <span style={{ color: TAUPE }}>— ancienneté : {(joursDepuis(fp.debut) / 365.25).toFixed(1).replace(".", ",")} an(s){fp.a.dateEmbauche ? "" : " (depuis la 1re mise en service, date d'embauche non renseignée)"}</span>}
                      </div>
                    )}
                    <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 12 }}>
                      <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>{estBureautique ? "Matériel détenu" : "Outils détenus"} ({fp.detenus.filter((o) => familleOutil(o) === familleVue).length})</div>
                      {fp.detenus.filter((o) => familleOutil(o) === familleVue).length === 0 ? <div style={{ fontSize: 13, color: TAUPE }}>Aucun.</div> : fp.detenus.filter((o) => familleOutil(o) === familleVue).map((o) => (
                        <div key={o.id} style={{ fontSize: 13, padding: "3px 0" }}>{o.numero} — {o.designation} <span style={{ color: TAUPE }}>({o.etat})</span></div>
                      ))}
                    </div>
                    {fp.a.type === "personne" && !estBureautique && (
                      <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 12 }}>
                        <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Consommables lents mis en service (meules, disques…)</div>
                        {fp.parProduit.length === 0 ? <div style={{ fontSize: 13, color: TAUPE }}>Aucun.</div> : fp.parProduit.map(([nom, v]) => (
                          <div key={nom} style={{ fontSize: 13, padding: "3px 0", display: "flex", justifyContent: "space-between", gap: 10 }}>
                            <span>{nom}</span>
                            <span><strong>{v.n}</strong> au total{fp.annees ? ` · ${(v.n / fp.annees).toFixed(1).replace(".", ",")} / an` : ""}{peutVoirCoutsOutillage ? ` · ${formatDH(v.cout)}${v.sansPrix ? ` (+${v.sansPrix} sans prix)` : ""}` : ""}</span>
                          </div>
                        ))}
                      </div>
                    )}
                    <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 12 }}>
                      <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Incidents ({fp.incidents.filter(({ o }) => familleOutil(o) === familleVue).length})</div>
                      {fp.incidents.filter(({ o }) => familleOutil(o) === familleVue).length === 0 ? <div style={{ fontSize: 13, color: TAUPE }}>Aucun.</div> : fp.incidents.filter(({ o }) => familleOutil(o) === familleVue).map(({ o, h }) => (
                        <div key={h.id} style={{ fontSize: 13, padding: "3px 0" }}>
                          {formatDate(h.date)} — <strong>{h.incident}</strong> — {o.numero} {o.designation}{h.imputeA === fp.a.id ? " — imputé" : ""}{peutVoirCoutsOutillage && (h.incident === "Perte" || h.incident === "Vol") && o.prixAchatHT ? ` — ${formatDH(Number(o.prixAchatHT))}` : ""}{h.note ? <span style={{ color: TAUPE }}> — {h.note}</span> : null}
                        </div>
                      ))}
                    </div>
                    <div style={{ fontSize: 11, color: TAUPE }}>Cette fiche sera reprise dans le futur onglet « Dossiers employés ».</div>
                  </div>
                )}
              </>
            )}

            {vueOutillage === "controle" && (
              <>
                <div style={{ fontSize: 13, marginBottom: 12, display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
                  <span>Dernier {estBureautique ? "inventaire clôturé" : "contrôle clôturé"} : <strong>{dernier ? `${formatDate(dernier.clotureLe.slice(0, 10))} (${dernier.nbManquants || 0} manquant(s))` : "aucun"}</strong> — {estBureautique ? "un inventaire tous les six mois" : `un contrôle tous les ${PERIODE_CONTROLE_OUTILLAGE_JOURS} jours`}.</span>
                  {!ctl && peutLancerControle(familleVue) && <button type="button" className="sc-btn" onClick={() => lancerControle(familleVue)} style={primaryBtnStyle}>{estBureautique ? "Lancer l'inventaire" : "Lancer le contrôle"}</button>}
                  {ctl && peutLancerControle(familleVue) && <button type="button" className="sc-btn" onClick={() => cloturerControle(familleVue)} style={primaryBtnStyle}>{estBureautique ? "Clôturer l'inventaire" : "Clôturer le contrôle"}</button>}
                </div>
                {ctl ? (
                  <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden" }}>
                    {Object.entries(ctl.lignes || {}).map(([id, l]) => {
                      const o = (outils || []).find((x) => x.id === id);
                      if (!o) return null;
                      return (
                        <div key={id} style={{ display: "grid", gridTemplateColumns: "0.7fr 2fr 1.5fr 1.6fr", gap: 8, padding: "8px 14px", borderBottom: `1px solid ${PIERRE}`, fontSize: 13, alignItems: "center" }}>
                          <div style={{ fontWeight: 600 }}>{o.numero}</div>
                          <div>{o.designation}</div>
                          <div>{nomAffectation(l.detenteurId)}</div>
                          <div style={{ display: "flex", gap: 6 }}>
                            {["present", "manquant"].map((r) => (
                              <button key={r} type="button" className="sc-btn" onClick={() => pointerOutil(familleVue, id, r)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 10px", borderRadius: 14, background: l.resultat === r ? (r === "present" ? "#E4EBE4" : "#F5E4DE") : "transparent", color: r === "present" ? VERT_OK : ROUILLE }}>{r === "present" ? "✓ Présent" : "✕ Manquant"}</button>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div style={{ fontSize: 13, color: TAUPE }}>{estBureautique ? "Aucun inventaire en cours." : "Aucun contrôle en cours."} {controleDu(familleVue) ? (estBureautique ? "Un inventaire est à faire (tâche à l'Administration)." : "Un contrôle est à faire.") : ""}</div>
                )}
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>{estBureautique ? "L'Administration (ou le Gérant) lance, pointe et clôture l'inventaire ; tâche à l'Administration tous les six mois. Matériel manquant → alerte au Gérant." : "Le Production Manager (ou le Gérant) lance et clôture ; le Production Manager, le bureau technique et le Gérant peuvent pointer. Outils manquants → alerte au Gérant."}</div>
              </>
            )}
          </div>
        );
      })()}

      {/* ERP step 12 (validé Nils du 30/09) : onglet Staff */}
      {activeTab === "staff" && peutVoirStaff && (() => {
        const visibles = (staff || []).filter(staffVisible);
        const q = normNomStaff(filtreStaff.q);
        const liste = visibles
          .filter((s) => (filtreStaff.statut === "tous" ? true : filtreStaff.statut === "sortis" ? !staffActif(s) : filtreStaff.statut === "incompletes" ? staffActif(s) && ficheStaffIncomplete(s).length > 0 : staffActif(s)))
          .filter((s) => !filtreStaff.service || s.service === filtreStaff.service)
          .filter((s) => !filtreStaff.contrat || s.contrat === filtreStaff.contrat)
          .filter((s) => !filtreStaff.role || !!s[filtreStaff.role])
          .filter((s) => !q || normNomStaff(`${s.nom} ${(s.anciensNoms || []).join(" ")} ${s.poste} ${s.service} ${s.contrat} ${s.telephonePro} ${s.telephonePerso}`).includes(q))
          .sort((a, b) => a.nom.localeCompare(b.nom, "fr", { sensitivity: "base" }));
        const nbActifs = visibles.filter(staffActif).length;
        const nbIncompletes = visibles.filter((s) => staffActif(s) && ficheStaffIncomplete(s).length > 0).length;
        const servicesListe = SERVICES_STAFF;
        const badge = (txt, couleur) => <span style={{ fontSize: 11, padding: "1px 7px", borderRadius: 10, background: PIERRE, color: couleur || ENCRE, marginRight: 4, whiteSpace: "nowrap" }}>{txt}</span>;
        const cols = "1.6fr 1fr 0.8fr 1fr 0.9fr 0.8fr 1.3fr 0.8fr";
        const anneeCourante = todayISO().slice(0, 4);
        const sousOnglet = (id, label) => (
          <button type="button" className="sc-btn" onClick={() => setVueStaff(id)} style={{ ...ghostBtnStyle, fontSize: 13, padding: "6px 12px", borderRadius: 6, background: vueStaff === id ? PIERRE : "transparent", color: vueStaff === id ? ENCRE : TAUPE }}>{label}</button>
        );
        const sigVisibles = (signalements || []).filter(signalementVisible);
        const nbSigOuverts = sigVisibles.filter((x) => x.statut !== "Clos").length;
        return (
          <div>
            <div style={{ display: "flex", gap: 6, marginBottom: 16, flexWrap: "wrap", alignItems: "center" }}>
              {sousOnglet("fiches", `Fiches (${nbActifs})`)}
              {sousOnglet("pointage", "Pointage")}
              {sousOnglet("signalements", `Signalements${nbSigOuverts ? ` — ${nbSigOuverts} ouvert(s)` : ""}`)}
              {sousOnglet("evaluations", "Évaluations")}
              {peut("staff.primes") && sousOnglet("primes", "Primes")}
              <button type="button" className="sc-btn" onClick={() => setSignalementEdit({ date: todayISO(), personnes: [], type: "", gravite: "Moyenne", description: "", recherche: "" })} style={{ ...ghostBtnStyle, marginLeft: "auto", fontSize: 12 }}>📣 Faire un signalement</button>
            </div>

            {vueStaff === "fiches" && (<>
            {peutGererStaff && (() => {
              const sem = semestreDe(todayISO());
              const c = controleBrutDuSemestre(sem);
              const sansBrut = visibles.filter((x) => staffActif(x) && salaireActuel(x) !== null && salaireBrutAu(x) === null).length;
              return (
                <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", background: c ? PIERRE : "#F5E4DE", borderRadius: 8, padding: "8px 12px", marginBottom: 12, fontSize: 12 }}>
                  <span>Contrôle des salaires bruts — {libSemestre(sem)} : {c ? <strong>fait le {formatDate(c.le.slice(0, 10))} par {c.par}</strong> : <strong style={{ color: ROUILLE }}>à faire</strong>}{sansBrut ? <span style={{ color: ROUILLE }}> · {sansBrut} fiche(s) active(s) sans brut</span> : null}</span>
                  {!c && <button type="button" className="sc-btn" onClick={validerControleBrut} style={{ ...primaryBtnStyle, padding: "5px 12px", fontSize: 12, marginLeft: "auto" }}>✓ Bruts vérifiés et ajustés</button>}
                </div>
              );
            })()}
            <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 12 }}>
              <input className="sc-input" value={filtreStaff.q} onChange={(e) => setFiltreStaff({ ...filtreStaff, q: e.target.value })} placeholder="Rechercher (prénom, nom, poste, téléphone…)" style={{ ...inputStyle(240) }} />
              <select className="sc-select" value={filtreStaff.service} onChange={(e) => setFiltreStaff({ ...filtreStaff, service: e.target.value })} style={{ ...selectStyle, width: "auto" }}>
                <option value="">Tous les services</option>
                {servicesListe.map((x) => (<option key={x} value={x}>{x}</option>))}
              </select>
              <select className="sc-select" value={filtreStaff.contrat} onChange={(e) => setFiltreStaff({ ...filtreStaff, contrat: e.target.value })} style={{ ...selectStyle, width: "auto" }}>
                <option value="">Tous les contrats</option>
                {typesContrat().map((x) => (<option key={x} value={x}>{x}</option>))}
              </select>
              <select className="sc-select" value={filtreStaff.role} onChange={(e) => setFiltreStaff({ ...filtreStaff, role: e.target.value })} style={{ ...selectStyle, width: "auto" }}>
                <option value="">Tous les rôles</option>
                <option value="poseur">Poseurs</option>
                <option value="usure">Usure des consommables</option>
              </select>
              <select className="sc-select" value={filtreStaff.statut} onChange={(e) => setFiltreStaff({ ...filtreStaff, statut: e.target.value })} style={{ ...selectStyle, width: "auto" }}>
                <option value="actifs">Actifs ({nbActifs})</option>
                <option value="incompletes">Fiches à compléter ({nbIncompletes})</option>
                <option value="sortis">Sortis ({visibles.length - nbActifs})</option>
                <option value="tous">Tous ({visibles.length})</option>
              </select>
              {peutGererStaff && (
                <>
                  <input ref={importStaffRef} type="file" accept=".xlsx,.xls" style={{ display: "none" }} onChange={(e) => { const fi = e.target.files && e.target.files[0]; e.target.value = ""; analyserImportStaff(fi); }} />
                  <button type="button" className="sc-btn" onClick={exporterFichierStaff} style={{ ...ghostBtnStyle, marginLeft: "auto", fontSize: 12 }}>⬇ Fichier à compléter (Administration)</button>
                  <button type="button" className="sc-btn" onClick={() => importStaffRef.current && importStaffRef.current.click()} style={{ ...ghostBtnStyle, fontSize: 12 }}>⬆ Importer le fichier Excel</button>
                </>
              )}
              {peutGererStaff && <button type="button" className="sc-btn" onClick={() => setShowTypesContrat(true)} style={{ ...ghostBtnStyle, fontSize: 12 }}>Gérer les types de contrat</button>}
              {peutGererStaff && <button type="button" className="sc-btn" onClick={() => { setConfirmSupprStaff(false); setOngletFicheStaff("identite"); setStaffEdit(ficheStaffVide()); }} style={primaryBtnStyle}>+ Nouvelle fiche</button>}
            </div>
            <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden" }}>
              <div style={{ display: "grid", gridTemplateColumns: cols, padding: "10px 16px", background: PIERRE, gap: 8 }}>
                <Th>Nom</Th><Th>Service</Th><Th>Contrat</Th><Th>Embauche</Th><Th>Salaire net</Th><Th>Congés {anneeCourante}</Th><Th>Rôles</Th><Th>Compte ERP</Th>
              </div>
              {liste.length === 0 && <div style={{ padding: 16, fontSize: 13, color: TAUPE }}>Aucune fiche.</div>}
              {liste.map((s) => {
                const manque = ficheStaffIncomplete(s);
                const compte = utilisateurs.find((u) => u.id === s.compte);
                return (
                  <div key={s.id} className="sc-row" onClick={() => { setConfirmSupprStaff(false); setOngletFicheStaff("identite"); setStaffEdit({ ...ficheStaffVide(), ...s }); }} style={{ display: "grid", gridTemplateColumns: cols, padding: "10px 16px", gap: 8, alignItems: "center", borderBottom: `1px solid ${PIERRE}`, fontSize: 13, cursor: "pointer", opacity: staffActif(s) ? 1 : 0.55 }}>
                    <div>
                      <div style={{ fontWeight: 600 }}>{s.nom}</div>
                      <div style={{ fontSize: 11, color: TAUPE }}>{[s.poste, s.responsableId ? `resp. ${nomStaff(s.responsableId)}` : "", s.telephonePro ? `pro ${s.telephonePro}` : "", s.telephonePerso ? `perso ${s.telephonePerso}` : ""].filter(Boolean).join(" · ")}</div>
                      {staffActif(s) && manque.length > 0 && <div style={{ fontSize: 11, color: OCRE }}>⚠ à compléter : {manque.join(", ")}</div>}
                    </div>
                    <div>{s.service || "—"}</div>
                    <div>{s.contrat || "—"}</div>
                    <div>{s.dateEmbauche ? formatDate(s.dateEmbauche) : "—"}{s.dateEmbauche && <div style={{ fontSize: 11, color: TAUPE }}>{anciennete(s.dateEmbauche, s.dateSortie)}</div>}{s.dateSortie && <div style={{ fontSize: 11, color: staffActif(s) ? OCRE : ROUILLE }}>{staffActif(s) ? "sortie prévue le" : "sorti le"} {formatDate(s.dateSortie)}</div>}</div>
                    <div>{salaireActuel(s) !== null ? formatDH(salaireActuel(s)) : <span style={{ color: TAUPE }}>—</span>}</div>
                    <div>{(() => { const c = soldeConges(s, anneeCourante); return <span title={`Report ${c.report} + acquis ${c.acquis} − pris ${c.pris}`} style={{ color: c.reliquat < 0 ? ROUILLE : ENCRE }}>{String(c.reliquat).replace(".", ",")} j</span>; })()}</div>
                    <div>{s.poseur && badge("Poseur")}{s.usure && badge(`Usure (${s.baseUsure === "pose" ? "pose" : "transfo."})`)}</div>
                    <div>{compte ? compte.nom : <span style={{ color: TAUPE }}>—</span>}</div>
                  </div>
                );
              })}
            </div>
            <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>
              Liste unique des personnes : elle alimente la fiche de pose (case « Poseur »), le registre d'outillage (tout le personnel actif) et la mise en service des consommables lents (« Usure des consommables »). Une personne n'est pas supprimée quand elle quitte l'entreprise : on indique sa date de sortie.
              {!peutGererStaff && " Tu vois les personnes dont tu es le responsable (directement ou via un chef d'équipe). Identité et salaires en lecture — fiches gérées par le Gérant et l'Administration ; évaluations possibles."}
            </div>
            </>)}

            {vueStaff === "primes" && peut("staff.primes") && (() => {
              const g = primesGroupees;
              const annee = todayISO().slice(0, 4);
              const personnes = (staff || []).filter((x) => staffActif(x) && !ficheStaffMasquee(x) && !estCommercialStaff(x)).sort((a, b) => a.nom.localeCompare(b.nom, "fr", { sensitivity: "base" }));
              const total = Object.values(g.montants || {}).reduce((n, v) => n + (Number(String(v).replace(",", ".")) || 0), 0);
              const nb = Object.values(g.montants || {}).filter((v) => Number(String(v).replace(",", ".")) > 0).length;
              const semaines = [...(primesProductivite || [])].sort((a, b) => (a.lundi < b.lundi ? 1 : -1));
              const carteSemaine = (w) => {
                const enAttente = w.statut === "à valider";
                const c = enAttente ? calculProductivite(w.lundi) : null;
                const ex = exceptionsProductivite[w.lundi] || {};
                const coche = (e) => (ex[e.id] !== undefined ? ex[e.id] : e.droit);
                const nb = c ? c.eligibles.filter(coche).length : (w.beneficiaires || []).length;
                const v = c || w;
                return (
                  <div key={w.lundi} style={{ border: `1px solid ${enAttente ? OCRE : PIERRE}`, borderRadius: 8, padding: 12, marginBottom: 10, background: enAttente ? "#FFFBF0" : "#fff" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap", fontSize: 13 }}>
                      <strong>Semaine du {formatDate(w.lundi)} au {formatDate(w.fin)}</strong>
                      <span style={{ color: enAttente ? OCRE : w.statut === "accordée" ? VERT_OK : TAUPE, fontWeight: 600 }}>{enAttente ? "À valider" : w.statut === "accordée" ? `Accordée — ${(w.beneficiaires || []).length} × ${formatDH(w.montant)}` : "Non accordée"}</span>
                    </div>
                    <div style={{ fontSize: 12, marginTop: 6, lineHeight: 1.6 }}>
                      CA production facturé : <strong>{formatDH(v.caProd)}</strong> · tranches facturées : <strong>{formatDH(v.caTranches)}</strong>
                      {v.caProd < v.target ? <> · retenu {formatDH(v.caProd)} + {v.partTranchesPct} % × {formatDH(v.caTranches)} = <strong>{formatDH(v.retenu)}</strong></> : null}
                      {" "}· target {formatDH(v.target)} → <strong style={{ color: v.retenu >= v.target ? VERT_OK : ROUILLE }}>{v.retenu >= v.target ? (v.caProd >= v.target ? "atteint" : "atteint grâce aux tranches") : `non atteint (il manque ${formatDH(v.target - v.retenu)})`}</strong>
                    </div>
                    {!enAttente && peut("staff.primes") && (
                      <div style={{ marginTop: 8 }}>
                        <button type="button" className="sc-btn" onClick={() => annulerDecisionPrime(w.lundi)} style={{ ...ghostBtnStyle, fontSize: 12, padding: 0, color: ROUILLE }}>Annuler la décision</button>
                        {w.valideePar && <span style={{ fontSize: 11, color: TAUPE, marginLeft: 10 }}>décidée par {w.valideePar}{w.valideeLe ? ` le ${formatDate(w.valideeLe.slice(0, 10))}` : ""}</span>}
                      </div>
                    )}
                    {c && (
                      <>
                        {c.dossiersProd.length > 0 && <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Factures production : {c.dossiersProd.map((d) => `${d.numero} (${formatDH(d.montant)})`).join(", ")}</div>}
                        {c.dossiersTranches.length > 0 && <div style={{ fontSize: 11, color: TAUPE }}>Factures tranches : {c.dossiersTranches.map((d) => `${d.numero} (${formatDH(d.montant)})`).join(", ")}</div>}
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px 16px", marginTop: 8 }}>
                          {c.eligibles.map((e) => (
                            <label key={e.id} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: e.droit ? ENCRE : ROUILLE }} title={e.raison}>
                              <input type="checkbox" checked={coche(e)} onChange={(ev) => setExceptionsProductivite({ ...exceptionsProductivite, [w.lundi]: { ...ex, [e.id]: ev.target.checked } })} />
                              {e.nom}{e.raison ? <span style={{ fontSize: 10, color: e.droit ? TAUPE : ROUILLE }}> ({e.raison})</span> : null}
                            </label>
                          ))}
                        </div>
                        <div style={{ display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" }}>
                          <button type="button" className="sc-btn" onClick={() => validerPrimeProductivite(w.lundi, true)} disabled={nb === 0} style={primaryBtnStyle}>{c.atteintAvecTranches ? "Accorder" : "Accorder quand même"} — {nb} × {formatDH(c.montant)} = {formatDH(nb * c.montant)}</button>
                          <button type="button" className="sc-btn" onClick={() => validerPrimeProductivite(w.lundi, false)} style={ghostBtnStyle}>Pas de prime cette semaine</button>
                        </div>
                        <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Chiffres recalculés en direct jusqu'à ta validation (une facture ajoutée après mardi est prise en compte). Décoche / coche pour une exception.</div>
                      </>
                    )}
                  </div>
                );
              };
              return (
                <>
                  {versementsPrimes.nonRattaches.length > 0 && (
                    <div style={{ background: "#FBEFEA", border: `1px solid ${ROUILLE}`, borderRadius: 8, padding: "10px 14px", marginBottom: 14, fontSize: 13 }}>
                      <b>{versementsPrimes.nonRattaches.length} prime(s) versée(s) sans fiche Staff</b> (nom inconnu, ou porté par plusieurs fiches) : {versementsPrimes.nonRattaches.map((v) => `${v.tiers || "?"} ${formatDH(v.montant)} le ${formatDate(v.date)} (${(compteDe(v.compteId) || {}).nom || ""})`).join(" · ")}. Corrige le nom du tiers dans la caisse.
                    </div>
                  )}
                  <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 8 }}>Prime de productivité</div>
                  {semaines.length === 0 ? <div style={{ fontSize: 13, color: TAUPE, marginBottom: 16 }}>Aucune semaine encore calculée — la semaine écoulée est proposée chaque mardi (alerte).</div> : <div style={{ marginBottom: 18, maxHeight: 520, overflowY: "auto" }}>{semaines.map(carteSemaine)}</div>}
                  <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 8 }}>Saisie groupée (Aïd, exceptionnelle…)</div>
                  <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 12 }}>
                    <select className="sc-select" value={g.type} onChange={(e) => preparerPrimesGroupees(e.target.value, g.date)} style={{ ...selectStyle, width: 200 }}>
                      <option value="">— Type de prime —</option>
                      {[...new Set([...typesPrimes(), TYPE_PRIME_PRODUCTIVITE])].map((t) => (<option key={t} value={t}>{t}</option>))}
                    </select>
                    <input type="date" className="sc-input" value={g.date} onChange={(e) => setPrimesGroupees({ ...g, date: e.target.value })} style={{ ...inputStyle(150), padding: "5px 8px" }} />
                    <input className="sc-input" value={g.commentaire} onChange={(e) => setPrimesGroupees({ ...g, commentaire: e.target.value })} placeholder="Commentaire (facultatif)" style={{ ...inputStyle(220), padding: "5px 8px" }} />
                    {g.type && <button type="button" className="sc-btn" onClick={enregistrerPrimesGroupees} style={{ ...primaryBtnStyle, marginLeft: "auto" }}>Enregistrer — {nb} personne(s), {formatDH(total)}</button>}
                  </div>
                  <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "1.6fr 1fr 1.4fr 1fr 1fr", padding: "10px 16px", background: PIERRE, gap: 8 }}>
                      <Th>Personne</Th><Th>Service</Th><Th>{g.type ? `Dernière prime « ${g.type} »` : "Dernière prime"}</Th><Th>Montant (DH)</Th><Th>{annee} : accordé / versé</Th>
                    </div>
                    {personnes.map((x) => {
                      const d = g.type ? dernierePrime(x, g.type) : null;
                      return (
                        <div key={x.id} style={{ display: "grid", gridTemplateColumns: "1.6fr 1fr 1.4fr 1fr 1fr", padding: "6px 16px", gap: 8, alignItems: "center", borderBottom: `1px solid ${PIERRE}`, fontSize: 13 }}>
                          <div style={{ fontWeight: 600 }}>{x.nom}</div>
                          <div style={{ color: TAUPE }}>{x.service || "—"}</div>
                          <div>{d ? <>{formatDH(Number(d.montant) || 0)} <span style={{ fontSize: 11, color: TAUPE }}>({formatDate(d.date)})</span></> : <span style={{ color: TAUPE }}>—</span>}</div>
                          <div><input type="number" min="0" className="sc-input" disabled={!g.type} value={(g.montants || {})[x.id] ?? ""} onChange={(e) => setPrimesGroupees({ ...g, montants: { ...(g.montants || {}), [x.id]: e.target.value } })} placeholder={g.type ? "0" : ""} style={{ ...inputStyle("100%"), padding: "4px 8px" }} /></div>
                          <div>{formatDH(totalPrimesAnnee(x, annee))} / {formatDH(totalVersesAnnee(x, annee))}{resteProductivite(x) > 0 && <div style={{ fontSize: 11, color: OCRE }}>productivité à verser {formatDH(resteProductivite(x))}</div>}</div>
                        </div>
                      );
                    })}
                  </div>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>Choisis le type : les montants sont pré-remplis avec la dernière prime du même type de chaque personne (à ajuster). Vide ou 0 = pas de prime. Les types se gèrent dans Paramétrage.</div>
                </>
              );
            })()}

            {vueStaff === "pointage" && (() => {
              const ym = moisPointage;
              const rec = recPointage(ym);
              const statut = rec ? rec.statut : "en cours";
              const jours = joursDuMois(ym);
              const speciaux = speciauxDuMois(ym, rec);
              const personnes = personnesPointage(ym);
              const codeInfo = (code) => CODES_POINTAGE.find((x) => x.code === code);
              const largeurJour = 28;
              const colonnesResume = ["Écart", "Solde fin", "Congés", "Fin de mois"];
              const badgeStatut = statut === "validé" ? (rec.decisionsValideesLe ? { t: "Validé", c: VERT_OK } : { t: "Validé — décisions à valider par le Gérant", c: OCRE }) : (() => { const u = partTransmise(rec, "usine"), b = partTransmise(rec, "bureau"); return u || b ? { t: `Usine : ${u ? `transmise par ${u.par}` : "en saisie"} · Bureau et commerciaux : ${b ? `transmis par ${b.par}` : "en saisie"} — à valider par le Gérant`, c: OCRE } : { t: "En cours de saisie", c: TAUPE }; })();
              return (
                <>
                  <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
                    <button type="button" className="sc-btn" onClick={() => setMoisPointage(moisDecale(ym, -1))} style={{ ...ghostBtnStyle, fontSize: 13 }}>‹</button>
                    <input type="month" className="sc-input" value={ym} onChange={(e) => e.target.value && setMoisPointage(e.target.value)} style={{ ...inputStyle(160), padding: "5px 8px" }} />
                    <button type="button" className="sc-btn" onClick={() => setMoisPointage(moisDecale(ym, 1))} style={{ ...ghostBtnStyle, fontSize: 13 }}>›</button>
                    <strong style={{ fontSize: 14, textTransform: "capitalize" }}>{libMois(ym)}</strong>
                    <span style={{ fontSize: 12, color: badgeStatut.c, fontWeight: 600 }}>● {badgeStatut.t}</span>
                    <div style={{ marginLeft: "auto", display: "flex", gap: 8, flexWrap: "wrap" }}>
                      <button type="button" className="sc-btn" onClick={imprimerPointage} style={ghostBtnStyle}>🖨 Imprimer</button>
                      {peut("pointage.transmettre") && statut !== "validé" && !partTransmise(rec, "usine") && <button type="button" className="sc-btn" onClick={() => transmettrePointage("usine")} style={primaryBtnStyle}>Transmettre l'usine au Gérant</button>}
                      {peut("pointage.saisir") && statut !== "validé" && partTransmise(rec, "usine") && <button type="button" className="sc-btn" onClick={rendreMainUsine} style={ghostBtnStyle} title="Annule la transmission de l'usine : le Production Manager peut de nouveau saisir">↺ Rendre la main à l'usine</button>}
                      {peut("pointage.saisir") && !peut("pointage.decisions") && statut !== "validé" && !partTransmise(rec, "bureau") && <button type="button" className="sc-btn" onClick={() => transmettrePointage("bureau")} style={primaryBtnStyle}>Transmettre bureau et commerciaux au Gérant</button>}
                      {peut("pointage.decisions") && statut !== "validé" && (() => {
                        const enEcart = personnes.filter((x) => ecartHoraire(x, rec));
                        return enEcart.length ? <button type="button" className="sc-btn" onClick={() => reprendreHorairesFiche(ym, enEcart.map((x) => x.id))} style={{ ...ghostBtnStyle, color: ROUILLE }} title={enEcart.map((x) => x.nom).join(", ")}>⚠ Reprendre l'horaire de la fiche ({enEcart.length})</button> : null;
                      })()}
                      {peut("pointage.decisions") && statut !== "validé" && <button type="button" className="sc-btn" onClick={validerPointage} style={primaryBtnStyle}>Valider le mois</button>}
                      {peut("pointage.decisions") && statut === "validé" && !rec.decisionsValideesLe && <button type="button" className="sc-btn" onClick={validerDecisionsHeures} style={primaryBtnStyle}>Valider les décisions</button>}
                      {peutGererStaff && statut === "validé" && <button type="button" className="sc-btn" onClick={exporterElementsPaie} disabled={!rec.decisionsValideesLe} title={rec.decisionsValideesLe ? (rec.paieExporteeLe ? `Déjà exporté par ${rec.paieExporteePar} le ${formatDate(rec.paieExporteeLe.slice(0, 10))}` : "Fichier Excel pour le comptable") : "Le Gérant doit d'abord valider les décisions d'heures"} style={{ ...ghostBtnStyle, opacity: rec.decisionsValideesLe ? 1 : 0.5 }}>⬇ Éléments de paie (Excel){rec.paieExporteeLe ? " ✓" : ""}</button>}
                      {peut("pointage.decisions") && statut === "validé" && <button type="button" className="sc-btn" onClick={rouvrirPointage} style={{ ...ghostBtnStyle, color: ROUILLE }}>Rouvrir le mois</button>}
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: 10, flexWrap: "wrap", fontSize: 11, color: TAUPE, marginBottom: 8 }}>
                    <span>Case vide = présent aux heures dues · chiffre = heures réellement faites · ½ = demi-journée · <span style={{ background: "#F3ECDD", borderRadius: 3, padding: "0 4px", fontWeight: 700 }}>D</span> déplacement (fiche de déplacement)</span>
                    {CODES_POINTAGE.map((c) => <span key={c.code}><span style={{ background: c.couleur, padding: "1px 5px", borderRadius: 4, color: ENCRE, fontWeight: 700 }}>{c.code}</span> {c.label}</span>)}
                    {typesCongesSpeciaux().map((t) => <span key={t.id}><span style={{ background: "#E3E0F0", padding: "1px 5px", borderRadius: 4, color: ENCRE, fontWeight: 700 }}>{t.code}</span> {t.libelle} (fiche Staff)</span>)}
                  </div>
                  <div style={{ overflowX: "auto", border: `1px solid ${PIERRE}`, borderRadius: 10 }}>
                    <table style={{ borderCollapse: "collapse", fontSize: 12, minWidth: "100%" }}>
                      <thead>
                        <tr style={{ background: PIERRE }}>
                          <th style={{ textAlign: "left", padding: "6px 10px", position: "sticky", left: 0, background: PIERRE, minWidth: 170, zIndex: 1 }}>Personne</th>
                          {jours.map((j) => {
                            const sp = speciaux[j.date];
                            const off = j.jourSemaine === 0 || j.jourSemaine === 6;
                            return (
                              <th key={j.cle} title={sp ? sp.libelle : JOURS_SEMAINE_LONGS[j.jourSemaine]} style={{ width: largeurJour, minWidth: largeurJour, padding: "4px 0", fontWeight: 600, color: off || sp ? TAUPE : ENCRE }}>
                                <div style={{ fontSize: 10 }}>{JOURS_SEMAINE_COURTS[j.jourSemaine]}</div>{j.d}
                              </th>
                            );
                          })}
                          {colonnesResume.map((t) => <th key={t} style={{ padding: "4px 8px", whiteSpace: "nowrap" }}>{t}</th>)}
                        </tr>
                      </thead>
                      <tbody>
                        {personnes.length === 0 && <tr><td colSpan={jours.length + 5} style={{ padding: 14, color: TAUPE }}>Personne en poste ce mois-là.</td></tr>}
                        {personnes.map((s) => {
                          const reg = regimePointage(s, rec);
                          const saisies = rec && rec.lignes && rec.lignes[s.id] ? rec.lignes[s.id].jours || {} : {};
                          const editable = peutEditerPointage(s, rec);
                          const sh = soldeHeuresMois(s, ym);
                          const c = calculPersonneMois(s, ym);
                          const decision = rec && rec.lignes && rec.lignes[s.id] ? rec.lignes[s.id].decision || "reporter" : "reporter";
                          return (
                            <tr key={s.id} style={{ borderTop: `1px solid ${PIERRE}` }}>
                              <td style={{ padding: "4px 10px", position: "sticky", left: 0, background: "#fff", zIndex: 1 }}>
                                <div style={{ fontWeight: 600 }}>{s.nom}</div>
                                <div style={{ fontSize: 10, color: ecartHoraire(s, rec) ? ROUILLE : TAUPE }}>{ecartHoraire(s, rec) ? <span title="L'horaire figé pour ce mois ne correspond plus à la fiche">⚠ {reg.label} — fiche : {ecartHoraire(s, rec).fiche}{peut("pointage.decisions") && <button type="button" className="sc-btn" onClick={() => reprendreHorairesFiche(ym, [s.id])} style={{ ...ghostBtnStyle, fontSize: 10, padding: "0 4px", color: ROUILLE }}>reprendre</button>}</span> : reg.label}{MODE_DEV && editable && <button type="button" className="sc-btn" onClick={() => remplirPresentDev(s)} title="Développement uniquement : remplit tous les jours ouvrables vides comme présent, heures normales" style={{ ...iconBtnStyle, width: 18, height: 18, fontSize: 10, marginLeft: 6, verticalAlign: "middle" }}>⚡</button>}</div>
                              </td>
                              {jours.map((j) => {
                                const hors = (s.dateEmbauche && j.date < s.dateEmbauche) || (s.dateSortie && j.date > s.dateSortie);
                                const sp = speciaux[j.date];
                                const csj = !hors ? congeSpecialDu(s, j.date, typesCongesSpeciaux()) : null;
                                if (csj) return <td key={j.cle} title={`${csj.type.libelle} du ${formatDate(csj.conge.debut)} au ${formatDate(csj.conge.fin)} (fiche Staff)`} style={{ textAlign: "center", padding: "6px 0", background: "#E3E0F0", borderLeft: `1px solid ${PIERRE}`, fontWeight: 700, fontSize: 10 }}>{csj.type.code}</td>;
                                const saisie = saisies[j.cle] || null;
                                const code = saisie && saisie.code !== undefined ? codeNorm(saisie.code) : sp ? (sp.type === "ferie" ? "F" : "C") : "";
                                const off = j.jourSemaine === 0 || j.jourSemaine === 6;
                                const info = codeInfo(code);
                                let texte = code ? (saisie && saisie.code ? texteCodeSaisie(saisie) : code) : "";
                                if (!code && saisie && saisie.heures !== "" && saisie.heures !== undefined && saisie.heures !== null) texte = String(saisie.heures).replace(".", ",");
                                if (code === "F" && saisie && Number(saisie.heures) > 0) texte = `F+${String(saisie.heures).replace(".", ",")}`;
                                // ERP step 15 (al) : jour de déplacement porté automatiquement (présent, journée normale).
                                if (!code && saisie && saisie.deplacementId) texte = `D ${texte}`.trim();
                                if (!code && saisie && saisie.deplManuel && !saisie.deplacementId) texte = `D* ${texte}`.trim();
                                const fond = hors ? "#F7F5F3" : info ? info.couleur : !code && saisie && (saisie.deplacementId || saisie.deplManuel) ? "#F3ECDD" : off ? "#E6E0DB" : "#fff";
                                const cliquable = editable && !hors;
                                return (
                                  <td key={j.cle} title={hors ? "Hors contrat" : [info ? info.label : saisie && saisie.deplacementId ? "Déplacement (présent, journée normale)" : saisie && saisie.deplManuel ? `Déplacement sans fiche — ${saisie.deplManuel.lieu}${saisie.deplManuel.dossier ? ` — ${saisie.deplManuel.dossier}` : ""} (prime ${saisie.deplManuel.jours === 0.5 ? "½" : "1"} j)` : off ? "Week-end" : "Présent", saisie && saisie.surConges ? "imputée sur les congés" : "", saisie && saisie.note ? saisie.note : ""].filter(Boolean).join(" — ")}
                                    onClick={() => cliquable && setCelluleEdit({ staffId: s.id, cle: j.cle, date: j.date, jourSemaine: j.jourSemaine, dues: duesDuJour(reg, j.date, j.jourSemaine).dues, ramadanOffert: duesDuJour(reg, j.date, j.jourSemaine).offert, pointageHeures: reg.pointageHeures, code: saisie && saisie.code !== undefined ? codeNorm(saisie.code) : sp ? (sp.type === "ferie" ? "F" : "C") : "", demi: !!(saisie && saisie.demi), code2: saisie && saisie.code2 ? codeNorm(saisie.code2) : "", heures: saisie && saisie.heures !== undefined && saisie.heures !== "" ? saisie.heures : (!saisie || !saisie.code) && !(sp && sp.type === "ferie") && reg.pointageHeures && duesDuJour(reg, j.date, j.jourSemaine).dues > 0 ? duesDuJour(reg, j.date, j.jourSemaine).dues : "", ferie: saisie ? saisie.ferie || "" : "", surConges: !!(saisie && saisie.surConges), note: saisie ? saisie.note || ((saisie.code === "MS" || saisie.code2 === "MS") ? "maladie sans certificat" : "") : "", deplManuel: saisie && saisie.deplManuel && !saisie.deplacementId ? { ...saisie.deplManuel } : null, deplacementId: saisie ? saisie.deplacementId || "" : "" })}
                                    style={{ textAlign: "center", padding: "6px 0", background: fond, cursor: cliquable ? "pointer" : "default", borderLeft: `1px solid ${PIERRE}`, fontWeight: 700, fontSize: 11, color: code === "A" || code === "MS" ? ROUILLE : ENCRE, outline: saisie && saisie.note ? `1px dashed ${OCRE}` : "none" }}>
                                    {hors ? "" : texte}
                                  </td>
                                );
                              })}
                              <td style={{ padding: "4px 8px", whiteSpace: "nowrap", color: sh.ecart < 0 ? ROUILLE : sh.ecart > 0 ? VERT_OK : TAUPE }}>{formatH(sh.ecart)}</td>
                              <td style={{ padding: "4px 8px", whiteSpace: "nowrap", fontWeight: 700, color: sh.fin < 0 ? ROUILLE : sh.fin > 0 ? VERT_OK : ENCRE }} title={`Solde début ${formatH(sh.debut)}`}>{formatH(sh.fin)}</td>
                              {(() => { const sc = soldeCongesAnnuel(s, ym.slice(0, 4)); return <td style={{ padding: "4px 8px", whiteSpace: "nowrap", color: sc.reste < 0 ? ROUILLE : ENCRE, fontWeight: sc.reste < 0 ? 700 : 400 }} title={`Année ${ym.slice(0, 4)} : droit ${sc.droit} j${sc.report ? ` + report ${sc.report} j` : ""}, pris ${sc.pris} j, reste ${sc.reste} j`}>{c.congesJ ? `${String(c.congesJ).replace(".", ",")} j` : "—"} <span style={{ fontSize: 10, color: sc.reste < 0 ? ROUILLE : TAUPE }}>(reste {String(sc.reste).replace(".", ",")})</span></td>; })()}
                              <td style={{ padding: "4px 8px", whiteSpace: "nowrap" }}>
                                {sh.rub ? (
                                  <button type="button" className="sc-btn" onClick={() => setFinMoisVue(s.id)} title="Détail et choix par rubrique" style={{ background: "transparent", border: `1px solid ${PIERRE}`, borderRadius: 6, padding: "2px 6px", fontSize: 10, textAlign: "left", cursor: "pointer", maxWidth: 230, whiteSpace: "normal", color: ENCRE }}>
                                    {resumeFinMois(sh) || "—"}{statut !== "validé" && sh.rub.lignes.length ? <span style={{ color: TAUPE }}> (à valider)</span> : null}
                                  </button>
                                ) : sh.fin !== 0 ? (<span style={{ color: decision === "regulariser" ? OCRE : TAUPE }}>{decision === "regulariser" ? (sh.fin > 0 ? "Payer" : "Déduire") : "Reporter"}</span>) : <span style={{ color: TAUPE }}>—</span>}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 8, lineHeight: 1.5 }}>
                    {rec && rec.figeLe ? `Horaires et jours fériés figés depuis le ${formatDate(rec.figeLe.slice(0, 10))} (transmission / validation) : un changement dans Paramétrage ne modifie plus ce mois. ` : ""}Chaque heure sup., absence ou maladie saisie est signalée au Gérant (alerte). Circuit (Nils 06/10) : le Production Manager pointe l'usine puis « Transmettre l'usine au Gérant » ; l'Administration pointe le bureau et les commerciaux puis « Transmettre bureau et commerciaux au Gérant » (chaque partie transmise est verrouillée) → le Gérant choisit pour chaque solde d'heures « Reporter » ou « Régulariser », valide le mois puis les décisions → l'Administration exporte les éléments de paie pour le comptable.
                    Compteur d'heures : heures faites − heures dues ; récupération, absences (justifiées ou non) et maladie sans certificat retirent les heures dues du jour ; une absence justifiée peut être imputée sur les congés. Maladie / accident avec certificat : jour retiré de la paie (CNSS), sans effet sur le compteur. Week-end et jours fériés : les heures travaillées s'ajoutent au compteur.
                    {regimesHoraires().commercial && " Commerciaux : pas de pointage d'heures ; une absence compte les heures dues théoriques (44 h / 5 j)."}
                    {" "}Export au format provisoire — à caler sur le fichier actuel du comptable.
                  </div>
                </>
              );
            })()}

            {vueStaff === "mensuel" && (() => {
              const lignesMois = staffDuMois(moisSaisie).filter(staffVisible);
              const lecture = !peutGererStaff;
              const colsM = `1.6fr ${COMPTEURS_MENSUELS.map(() => "0.8fr").join(" ")} 1.6fr 0.4fr`;
              return (
                <>
                  <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 12 }}>
                    <span style={{ fontSize: 13 }}>Mois :</span>
                    <input type="month" className="sc-input" value={moisSaisie} max={todayISO().slice(0, 7)} onChange={(e) => e.target.value && ouvrirSaisieMensuelle(e.target.value)} style={{ ...inputStyle(170), padding: "5px 8px" }} />
                    <button type="button" className="sc-btn" onClick={() => ouvrirSaisieMensuelle(moisDecale(moisSaisie, -1))} style={{ ...ghostBtnStyle, fontSize: 12 }}>‹ mois précédent</button>
                    <button type="button" className="sc-btn" onClick={() => moisSaisie < todayISO().slice(0, 7) && ouvrirSaisieMensuelle(moisDecale(moisSaisie, 1))} style={{ ...ghostBtnStyle, fontSize: 12 }}>mois suivant ›</button>
                    {!lecture && <button type="button" className="sc-btn" onClick={enregistrerSaisieMensuelle} style={{ ...primaryBtnStyle, marginLeft: "auto" }}>Enregistrer {libMois(moisSaisie)}</button>}
                  </div>
                  <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden" }}>
                    <div style={{ display: "grid", gridTemplateColumns: colsM, padding: "10px 16px", background: PIERRE, gap: 8 }}>
                      <Th>Personne</Th>{COMPTEURS_MENSUELS.map((c) => <Th key={c.cle}>{c.label} (j)</Th>)}<Th>Note</Th><Th></Th>
                    </div>
                    {lignesMois.length === 0 && <div style={{ padding: 16, fontSize: 13, color: TAUPE }}>Personne en poste ce mois-là.</div>}
                    {lignesMois.map((s) => {
                      const v = saisieMensuelle[s.id] || {};
                      const setV = (patch) => setSaisieMensuelle({ ...saisieMensuelle, [s.id]: { ...v, ...patch } });
                      return (
                        <div key={s.id} style={{ display: "grid", gridTemplateColumns: colsM, padding: "6px 16px", gap: 8, alignItems: "center", borderBottom: `1px solid ${PIERRE}`, fontSize: 13 }}>
                          <div style={{ fontWeight: 600 }}>{s.nom}<div style={{ fontSize: 11, color: TAUPE, fontWeight: 400 }}>{s.service || ""}</div></div>
                          {COMPTEURS_MENSUELS.map((c) => (
                            <input key={c.cle} type="number" min="0" max="31" step="0.5" className="sc-input" disabled={lecture} value={v[c.cle] ?? ""} placeholder="0" onChange={(e) => setV({ [c.cle]: e.target.value })} style={{ ...inputStyle("100%"), padding: "4px 8px" }} />
                          ))}
                          <input className="sc-input" disabled={lecture} value={v.note || ""} onChange={(e) => setV({ note: e.target.value })} style={{ ...inputStyle("100%"), padding: "4px 8px" }} />
                          <div style={{ fontSize: 12, color: moisSaisiPour(s.id, moisSaisie) ? VERT_OK : OCRE }}>{moisSaisiPour(s.id, moisSaisie) ? "✓" : "—"}</div>
                        </div>
                      );
                    })}
                  </div>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>Saisie par l'Administration (ou le Gérant) chaque mois ; une case vide compte 0. ✓ = mois déjà enregistré pour cette personne. Les fermetures collectives (Aïd, août) se saisissent en congés.</div>
                </>
              );
            })()}

            {vueStaff === "signalements" && (() => {
              const liste2 = sigVisibles
                .filter((x) => (filtreSignalements === "tous" ? true : filtreSignalements === "clos" ? x.statut === "Clos" : x.statut !== "Clos"))
                .sort((a, b) => ((a.date || "") + a.le < (b.date || "") + b.le ? 1 : -1));
              return (
                <>
                  <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 12 }}>
                    <select className="sc-select" value={filtreSignalements} onChange={(e) => setFiltreSignalements(e.target.value)} style={{ ...selectStyle, width: "auto" }}>
                      <option value="ouverts">Ouverts</option>
                      <option value="clos">Clos</option>
                      <option value="tous">Tous</option>
                    </select>
                    <span style={{ fontSize: 12, color: TAUPE }}>{liste2.length} signalement(s)</span>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    {liste2.length === 0 && <div style={{ fontSize: 13, color: TAUPE }}>Aucun signalement.</div>}
                    {liste2.map(renderSignalementLigne)}
                  </div>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>Tout le monde peut faire un signalement sur n'importe qui (bouton aussi dans « Alertes & tâches »). Chaque signalement est remonté au Gérant. Une personne ne voit jamais les signalements qui la concernent.</div>
                </>
              );
            })()}

            {vueStaff === "evaluations" && (() => {
              const semCourant = semestreDe(todayISO());
              const semestres = [semCourant, semestrePrecedent(semCourant), semestrePrecedent(semestrePrecedent(semCourant)), semestrePrecedent(semestrePrecedent(semestrePrecedent(semCourant)))];
              const personnes = staffAEvaluer(semestreEval).filter(staffVisible).filter((x) => x.compte !== user.id).sort((a, b) => a.nom.localeCompare(b.nom, "fr", { sensitivity: "base" }));
              const critE = criteresEvaluation();
              const colsE = `1.6fr 1fr ${critE.map(() => "0.5fr").join(" ")} 1.4fr`;
              return (
                <>
                  <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 12 }}>
                    <select className="sc-select" value={semestreEval} onChange={(e) => setSemestreEval(e.target.value)} style={{ ...selectStyle, width: "auto" }}>
                      {semestres.map((x) => (<option key={x} value={x}>{libSemestre(x)}{x === semCourant ? " (en cours)" : ""}</option>))}
                    </select>
                  </div>
                  <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden" }}>
                    <div style={{ display: "grid", gridTemplateColumns: colsE, padding: "10px 16px", background: PIERRE, gap: 8 }}>
                      <Th>Personne</Th><Th>Statut</Th>{critE.map((c) => <Th key={c.cle}><span title={c.label}>{c.label.split(" ")[0]}</span></Th>)}<Th></Th>
                    </div>
                    {personnes.length === 0 && <div style={{ padding: 16, fontSize: 13, color: TAUPE }}>Personne à évaluer sur cette période.</div>}
                    {personnes.map((s) => {
                      const ev = evaluationDe(s, semestreEval);
                      return (
                        <div key={s.id} style={{ display: "grid", gridTemplateColumns: colsE, padding: "8px 16px", gap: 8, alignItems: "center", borderBottom: `1px solid ${PIERRE}`, fontSize: 13 }}>
                          <div style={{ fontWeight: 600 }}>{s.nom}<div style={{ fontSize: 11, color: TAUPE, fontWeight: 400 }}>{s.service || ""}</div></div>
                          <div style={{ color: !ev ? OCRE : ev.validee ? VERT_OK : OCRE }}>{!ev ? "À faire" : ev.validee ? "Validée" : `À valider (${ev.par})`}{ev && (ev.lignesSup || []).length > 0 && <div style={{ fontSize: 11, color: TAUPE }}>+ {(ev.lignesSup || []).map((l) => `${l.libelle} : ${l.note}`).join(" · ")}</div>}</div>
                          {critE.map((c) => <div key={c.cle} style={{ fontWeight: 700 }}>{ev ? ev.notes[c.cle] || "" : ""}</div>)}
                          <div style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
                            {peutEvaluer(s) && (!ev || !ev.validee || peut("evaluations.valider")) && <button type="button" className="sc-btn" onClick={() => setEvaluationEdit({ staffId: s.id, periode: semestreEval, notes: ev ? { ...ev.notes } : {}, lignesSup: ev ? (ev.lignesSup || []).map((l) => ({ ...l })) : [], commentaire: ev ? ev.commentaire : "", objectifs: ev ? ev.objectifs : "" })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 8px" }}>{ev ? "Modifier" : "Évaluer"}</button>}
                            {peut("evaluations.valider") && ev && !ev.validee && <button type="button" className="sc-btn" onClick={() => validerEvaluation(s.id, semestreEval)} style={{ ...primaryBtnStyle, fontSize: 12, padding: "4px 10px" }}>Valider</button>}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>Une évaluation par personne et par semestre. Proposée par l'Administration ou le Production Manager (son périmètre), validée par le Gérant ; une évaluation faite par le Gérant est validée d'office. Personne n'évalue sa propre fiche.</div>
                </>
              );
            })()}
          </div>
        );
      })()}

      {staffEdit && peutVoirStaff && (() => {
        const f = staffEdit;
        const nouveau = !f.id;
        const lecture = !peutGererStaff;
        const set = (patch) => setStaffEdit({ ...f, ...patch });
        const existante = !nouveau ? (staff || []).find((s) => s.id === f.id) : null;
        const refs = existante ? referencesStaff(existante) : [];
        const comptesLibres = utilisateurs.filter((u) => u.id === f.compte || u.actif && !(staff || []).some((s) => s.id !== f.id && s.compte === u.id));
        const outilsDetenus = !nouveau ? (outils || []).filter((o) => o.detenteurId === f.id && outilActif(o)) : [];
        const consoEnCours = !nouveau ? (enService || []).filter((e) => e.affectationId === f.id && e.statut === "en service") : [];
        const contrats = f.contrat && !typesContrat().includes(f.contrat) ? [...typesContrat(), f.contrat] : typesContrat();
        // Responsable : toute fiche active sauf soi-même et ses propres subordonnés (pas de boucle).
        const sousF = (x) => { const vus = new Set(); let r = x.responsableId; while (r && !vus.has(r)) { if (r === f.id) return true; vus.add(r); const c = (staff || []).find((y) => y.id === r); r = c ? c.responsableId : ""; } return false; };
        const responsablesPossibles = (staff || []).filter((x) => x.id !== f.id && (staffActif(x) || x.id === f.responsableId) && (!f.id || !sousF(x))).sort((a, b) => a.nom.localeCompare(b.nom, "fr", { sensitivity: "base" }));
        return (
          <Overlay onClose={() => { setStaffEdit(null); setConfirmSupprStaff(false); }}>
            <div style={modalStyle(720)}>
              <div style={modalTitleStyle}>{nouveau ? "Nouvelle fiche" : nomCompletStaff(f.prenom, f.nomFamille) || f.nom}{!nouveau && !staffActif(existante || f) && <span style={{ fontSize: 13, color: ROUILLE, marginLeft: 10 }}>sorti le {formatDate(f.dateSortie)}</span>}</div>
              {!nouveau && (
                <div style={{ display: "flex", gap: 4, marginTop: -6, marginBottom: 14, borderBottom: `1px solid ${PIERRE}`, flexWrap: "wrap" }}>
                  {[["identite", "Identité"], ["salaire", "Salaire"], ...(peut("staff.primes") ? [["primes", `Primes (${(f.primes || []).length + versementsPrimesDe(f).length})`]] : []), ["conges", "Congés & absences"], ["signalements", `Signalements (${(signalements || []).filter((x) => (x.personnes || []).includes(f.id) && signalementVisible(x)).length})`], ["evaluations", `Évaluations (${(f.evaluations || []).length})`], ["outillage", `Outillage & bureautique (${(outils || []).filter((o) => o.detenteurId === f.id && outilActif(o)).length})`]].map(([id, label]) => (
                    <button key={id} type="button" className="sc-btn" onClick={() => setOngletFicheStaff(id)} style={{ ...ghostBtnStyle, fontSize: 13, padding: "6px 10px", borderRadius: 0, borderBottom: ongletFicheStaff === id ? `2px solid ${ROUILLE}` : "2px solid transparent", color: ongletFicheStaff === id ? ENCRE : TAUPE }}>{label}</button>
                  ))}
                </div>
              )}
              {(nouveau || ongletFicheStaff === "identite") && (<>
              <fieldset disabled={lecture} style={{ border: "none", padding: 0, margin: 0 }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1.2fr", gap: 12 }}>
                  <Field label="Prénom (obligatoire)"><input className="sc-input" value={f.prenom || ""} onChange={(e) => set({ prenom: e.target.value })} style={inputStyle("100%")} /></Field>
                  <Field label="Nom"><input className="sc-input" value={f.nomFamille || ""} onChange={(e) => set({ nomFamille: e.target.value })} style={inputStyle("100%")} /></Field>
                  <Field label="Poste"><input className="sc-input" value={f.poste || ""} onChange={(e) => set({ poste: e.target.value })} placeholder="ex. Poseur, Opérateur débiteuse" style={inputStyle("100%")} /></Field>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1.2fr", gap: 12 }}>
                  <Field label="Matricule (paie)"><input className="sc-input" value={f.matricule || ""} onChange={(e) => set({ matricule: e.target.value })} placeholder="n° chez le comptable" style={inputStyle("100%")} /></Field>
                  <Field label="N° CNSS"><input className="sc-input" value={f.cnss || ""} onChange={(e) => set({ cnss: e.target.value.replace(/\s/g, "") })} style={inputStyle("100%")} /></Field>
                  <Field label="CIN"><input className="sc-input" value={f.cin || ""} onChange={(e) => set({ cin: e.target.value.replace(/\s/g, "").toUpperCase() })} placeholder="ex. BK123456" style={inputStyle("100%")} /></Field>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                  <Field label="Service">
                    <select className="sc-select" value={f.service || ""} onChange={(e) => set({ service: e.target.value })} style={selectStyle}>
                      <option value="">— Choisir —</option>
                      {SERVICES_STAFF.map((x) => (<option key={x} value={x}>{x}</option>))}
                    </select>
                  </Field>
                  <Field label="Contrat">
                    <select className="sc-select" value={f.contrat || ""} onChange={(e) => set({ contrat: e.target.value })} style={selectStyle}>
                      <option value="">— Choisir —</option>
                      {contrats.map((x) => (<option key={x} value={x}>{x}</option>))}
                    </select>
                    <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, marginTop: 6 }}>
                      <input type="checkbox" checked={estExterneStaff(f)} onChange={(e) => set({ externe: e.target.checked })} /> Externe — hors pointage
                    </label>
                  </Field>
                  <Field label="Responsable (N+1)">
                    <select className="sc-select" value={f.responsableId || ""} onChange={(e) => set({ responsableId: e.target.value })} style={selectStyle}>
                      <option value="">— Aucun —</option>
                      {responsablesPossibles.map((x) => (<option key={x.id} value={x.id}>{x.nom}</option>))}
                    </select>
                  </Field>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                  <Field label="Téléphone pro"><input className="sc-input" value={f.telephonePro || ""} onChange={(e) => set({ telephonePro: e.target.value })} style={inputStyle("100%")} /></Field>
                  <Field label="Téléphone perso"><input className="sc-input" value={f.telephonePerso || ""} onChange={(e) => set({ telephonePerso: e.target.value })} style={inputStyle("100%")} /></Field>
                  <Field label="Horaire (pointage)">
                    <select className="sc-select" value={f.regime || ""} onChange={(e) => set({ regime: e.target.value })} style={selectStyle}>
                      <option value="">Selon le service ({regimesHoraires()[regimeDefautService(f.service)].label})</option>
                      {Object.entries(regimesHoraires()).map(([k, r]) => (<option key={k} value={k}>{r.label} — {r.heures.slice(1, 6).map((h) => String(h).replace(".", ",")).join("/")} h</option>))}
                    </select>
                  </Field>
                </div>
                <Field label="Adresse du domicile"><textarea className="sc-input" value={f.adresse || ""} onChange={(e) => set({ adresse: e.target.value })} rows={2} style={{ ...inputStyle("100%"), resize: "vertical" }} /></Field>
                <div style={{ display: "grid", gridTemplateColumns: "1.3fr 1fr 1fr", gap: 12 }}>
                  <Field label="Contact d'urgence (nom)"><input className="sc-input" value={f.urgenceNom || ""} onChange={(e) => set({ urgenceNom: e.target.value })} style={inputStyle("100%")} /></Field>
                  <Field label="Lien"><input className="sc-input" value={f.urgenceLien || ""} onChange={(e) => set({ urgenceLien: e.target.value })} placeholder="ex. épouse, frère" style={inputStyle("100%")} /></Field>
                  <Field label="Téléphone d'urgence"><input className="sc-input" value={f.urgenceTel || ""} onChange={(e) => set({ urgenceTel: e.target.value })} style={inputStyle("100%")} /></Field>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                  <Field label="Date d'embauche"><input type="date" className="sc-input" value={f.dateEmbauche || ""} onChange={(e) => set({ dateEmbauche: e.target.value })} style={inputStyle("100%")} /></Field>
                  <Field label="Date de sortie"><input type="date" className="sc-input" value={f.dateSortie || ""} min={f.dateEmbauche || undefined} onChange={(e) => set({ dateSortie: e.target.value })} style={inputStyle("100%")} /></Field>
                  <Field label="Compte ERP lié">
                    <select className="sc-select" value={f.compte || ""} onChange={(e) => set({ compte: e.target.value })} style={selectStyle}>
                      <option value="">— Aucun —</option>
                      {comptesLibres.map((u) => (<option key={u.id} value={u.id}>{u.nom} ({u.role})</option>))}
                    </select>
                  </Field>
                </div>
                {f.dateEmbauche && <div style={{ fontSize: 12, color: TAUPE, marginTop: -6, marginBottom: 10 }}>Ancienneté : {anciennete(f.dateEmbauche, f.dateSortie)}</div>}
                {(f.anciensNoms || []).length > 0 && <div style={{ fontSize: 12, color: TAUPE, marginTop: -6, marginBottom: 10 }}>Anciens noms (gardés pour l'historique) : {f.anciensNoms.join(", ")}</div>}
                <div style={{ background: PIERRE, borderRadius: 8, padding: 12, marginBottom: 12 }}>
                  <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Rôles dans l'ERP</div>
                  <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, marginBottom: 6 }}>
                    <input type="checkbox" checked={!!f.poseur} onChange={(e) => set({ poseur: e.target.checked })} /> Poseur <span style={{ color: TAUPE, fontSize: 12 }}>— proposé comme poseur / aide-poseur sur la fiche de pose</span>
                  </label>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, flexWrap: "wrap" }}>
                    <label style={{ display: "flex", gap: 8, alignItems: "center" }}>
                      <input type="checkbox" checked={!!f.usure} onChange={(e) => set({ usure: e.target.checked })} /> Usure des consommables
                    </label>
                    <select className="sc-select" value={f.baseUsure === "pose" ? "pose" : "transformation"} onChange={(e) => set({ baseUsure: e.target.value })} style={{ ...selectStyle, width: 230, background: "#fff" }} disabled={lecture || !f.usure}>
                      <option value="transformation">Base : transformation (atelier)</option>
                      <option value="pose">Base : pose (chantier)</option>
                    </select>
                    <span style={{ color: TAUPE, fontSize: 12 }}>— meules, disques… mis en service à son nom</span>
                  </div>
                </div>
                <Field label="Note"><textarea className="sc-input" value={f.note || ""} onChange={(e) => set({ note: e.target.value })} rows={2} style={{ ...inputStyle("100%"), resize: "vertical" }} /></Field>
              </fieldset>
              {!nouveau && (
                <div style={{ fontSize: 12, color: TAUPE, marginBottom: 10 }}>
                  Outils détenus : <strong style={{ color: ENCRE }}>{outilsDetenus.length}</strong> · consommables en service : <strong style={{ color: ENCRE }}>{consoEnCours.length}</strong>{refs.length > 0 ? ` · historique : ${refs.join(", ")}` : ""}
                  {(f.creePar || f.modifiePar) && <div>{f.creePar ? `Créée par ${f.creePar}${f.creeLe ? ` le ${formatDate(f.creeLe.slice(0, 10))}` : ""}` : ""}{f.modifiePar ? ` · modifiée par ${f.modifiePar}${f.modifieLe ? ` le ${formatDate(f.modifieLe.slice(0, 10))}` : ""}` : ""}</div>}
                </div>
              )}
              {!nouveau && !lecture && confirmSupprStaff && (
                <div style={{ background: "#F5E4DE", borderRadius: 8, padding: 10, marginBottom: 10, fontSize: 13, display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                  <span style={{ flex: 1 }}>Supprimer définitivement la fiche « {f.nom} » ? {refs.length > 0 ? "Elle est liée à l'historique : la suppression sera refusée — indique plutôt une date de sortie." : "Aucun historique lié."}</span>
                  <button type="button" className="sc-btn" onClick={supprimerFicheStaff} style={{ ...primaryBtnStyle, background: ROUILLE }}>Oui, supprimer</button>
                  <button type="button" className="sc-btn" onClick={() => setConfirmSupprStaff(false)} style={ghostBtnStyle}>Annuler</button>
                </div>
              )}
              </>)}
              {!nouveau && ongletFicheStaff === "salaire" && (() => {
                const hist = [...(f.salaires || [])].sort((a, b) => (a.dateEffet < b.dateEffet ? 1 : -1));
                const actuel = salaireActuel(f);
                return (
                  <div style={{ marginBottom: 10 }}>
                    <div style={{ fontSize: 13, marginBottom: 10 }}>Salaire net actuel : <strong style={{ fontSize: 16 }}>{actuel !== null ? formatDH(actuel) : "non renseigné"}</strong> · brut : <strong>{salaireBrutAu(f) !== null ? formatDH(salaireBrutAu(f)) : <span style={{ color: ROUILLE }}>non renseigné</span>}</strong>{f.dateEmbauche ? <span style={{ color: TAUPE }}> · ancienneté {anciennete(f.dateEmbauche, f.dateSortie)}</span> : null}</div>
                    <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, overflow: "hidden", marginBottom: 12 }}>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 2fr 1fr 0.3fr", padding: "8px 12px", background: PIERRE, gap: 8 }}><Th>Date d'effet</Th><Th>Net</Th><Th>Brut</Th><Th>Variation</Th><Th>Type / motif</Th><Th>Par</Th><Th></Th></div>
                      {hist.length === 0 && <div style={{ padding: 12, fontSize: 13, color: TAUPE }}>Aucun salaire enregistré.</div>}
                      {hist.map((l, i) => {
                        const prec = hist[i + 1];
                        const diff = prec ? (Number(l.net) || 0) - (Number(prec.net) || 0) : null;
                        return (
                          <div key={l.id} style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 2fr 1fr 0.3fr", padding: "7px 12px", gap: 8, borderBottom: `1px solid ${PIERRE}`, fontSize: 13, alignItems: "center", opacity: l.dateEffet > todayISO() ? 0.6 : 1 }}>
                            <div>{formatDate(l.dateEffet)}{l.dateEffet > todayISO() ? " (à venir)" : ""}</div>
                            <div style={{ fontWeight: 600 }}>{formatDH(Number(l.net) || 0)}</div>
                            <div>{peutGererStaff ? <input key={`${l.id}-${l.brut ?? ""}`} type="number" min="0" className="sc-input" defaultValue={l.brut ?? ""} placeholder="brut" onBlur={(e) => majBrutSalaire(f.id, l.id, e.target.value)} style={{ ...inputStyle(100), padding: "3px 6px", borderColor: l.brut ? undefined : ROUILLE }} /> : (l.brut ? formatDH(Number(l.brut)) : "—")}</div>
                            <div style={{ color: diff === null ? TAUPE : diff >= 0 ? VERT_OK : ROUILLE }}>{diff === null ? "—" : `${diff >= 0 ? "+" : ""}${formatDH(diff)}${prec && Number(prec.net) ? ` (${diff >= 0 ? "+" : ""}${((diff / Number(prec.net)) * 100).toFixed(1).replace(".", ",")} %)` : ""}`}</div>
                            <div>{l.type ? <><strong style={{ fontWeight: 600 }}>{l.type}</strong>{l.motif ? ` — ${l.motif}` : ""}</> : l.motif}</div>
                            <div style={{ fontSize: 11, color: TAUPE }}>{l.par}</div>
                            <div>{peutGererStaff && <button type="button" className="sc-btn" onClick={() => supprimerSalaire(l.id)} style={iconBtnStyle} title="Supprimer (erreur de saisie)">✕</button>}</div>
                          </div>
                        );
                      })}
                    </div>
                    {peutGererStaff && (
                      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", background: PIERRE, borderRadius: 8, padding: 10 }}>
                        <input type="date" className="sc-input" value={salaireSaisie.dateEffet} onChange={(e) => setSalaireSaisie({ ...salaireSaisie, dateEffet: e.target.value })} style={{ ...inputStyle(150), padding: "5px 8px", background: "#fff" }} />
                        <input type="number" min="0" className="sc-input" value={salaireSaisie.net} onChange={(e) => setSalaireSaisie({ ...salaireSaisie, net: e.target.value })} placeholder="Salaire net (DH)" style={{ ...inputStyle(150), padding: "5px 8px", background: "#fff" }} />
                        <input type="number" min="0" className="sc-input" value={salaireSaisie.brut} onChange={(e) => setSalaireSaisie({ ...salaireSaisie, brut: e.target.value })} placeholder="Salaire brut (DH)" title="Brut, CNSS et AMO compris" style={{ ...inputStyle(150), padding: "5px 8px", background: "#fff" }} />
                        <select className="sc-select" value={salaireSaisie.type} onChange={(e) => setSalaireSaisie({ ...salaireSaisie, type: e.target.value })} style={{ ...selectStyle, width: 150, background: "#fff" }}>
                          <option value="">Type (auto)</option>
                          {TYPES_SALAIRE.map((t) => (<option key={t} value={t}>{t}</option>))}
                        </select>
                        <input className="sc-input" value={salaireSaisie.motif} onChange={(e) => setSalaireSaisie({ ...salaireSaisie, motif: e.target.value })} placeholder="Commentaire (ex. promotion chef d'équipe)" style={{ ...inputStyle(260), padding: "5px 8px", background: "#fff", flex: 1 }} />
                        <button type="button" className="sc-btn" onClick={ajouterSalaire} style={primaryBtnStyle}>Ajouter</button>
                      </div>
                    )}
                    <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Brut = CNSS et AMO compris (base du coût de main-d'œuvre des dossiers) ; il se corrige directement dans la colonne Brut. Une ligne par changement de salaire : chaque ligne après la première est une augmentation datée. Visible par le Gérant, l'Administration et le Production Manager (son périmètre) ; saisie par le Gérant et l'Administration.</div>
                  </div>
                );
              })()}
              {!nouveau && ongletFicheStaff === "primes" && peut("staff.primes") && (() => {
                // Nils 23/10 (b) : primes accordées (fiche) et versées (caisses, lues en direct).
                const hist = [...(f.primes || []), ...versementsPrimesDe(f)].sort((a, b) => (a.date < b.date ? 1 : -1));
                const annees = [...new Set(hist.map((p) => (p.date || "").slice(0, 4)))].sort().reverse();
                const reste = resteProductivite(f);
                return (
                  <div style={{ marginBottom: 10 }}>
                    <div style={{ display: "flex", gap: 14, flexWrap: "wrap", fontSize: 13, marginBottom: 10 }}>
                      {[...new Set([...typesPrimes(), TYPE_PRIME_PRODUCTIVITE])].map((t) => { const d = dernierePrime(f, t); return <span key={t}>{t} : <strong>{d ? formatDH(Number(d.montant) || 0) : "—"}</strong>{d ? <span style={{ color: TAUPE, fontSize: 11 }}> ({formatDate(d.date)})</span> : null}</span>; })}
                    </div>
                    {annees.length > 0 && <div style={{ fontSize: 12, color: TAUPE, marginBottom: 8 }}>Par année : {annees.map((a) => `${a} : accordé ${formatDH(totalPrimesAnnee(f, a))}, versé ${formatDH(totalVersesAnnee(f, a))}`).join(" · ")}</div>}
                    {reste !== 0 && <div style={{ fontSize: 13, marginBottom: 8, color: reste > 0 ? OCRE : ROUILLE }}>Productivité : {reste > 0 ? `reste à verser ${formatDH(reste)}` : `versé ${formatDH(-reste)} de plus que l'accordé`}</div>}
                    <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, overflow: "hidden", marginBottom: 12 }}>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1.2fr 0.9fr 1fr 2fr 1fr 0.3fr", padding: "8px 12px", background: PIERRE, gap: 8 }}><Th>Date</Th><Th>Type</Th><Th>Accordé</Th><Th>Versé</Th><Th>Commentaire</Th><Th>Par</Th><Th></Th></div>
                      {hist.length === 0 && <div style={{ padding: 12, fontSize: 13, color: TAUPE }}>Aucune prime enregistrée.</div>}
                      {hist.map((p) => (
                        <div key={p.id} style={{ display: "grid", gridTemplateColumns: "1fr 1.2fr 0.9fr 1fr 2fr 1fr 0.3fr", padding: "7px 12px", gap: 8, borderBottom: `1px solid ${PIERRE}`, fontSize: 13, alignItems: "center" }}>
                          <div>{formatDate(p.date)}</div><div>{p.type || <span style={{ color: TAUPE }}>non précisé</span>}</div>
                          <div style={{ fontWeight: 600 }}>{p.verse ? "" : formatDH(Number(p.montant) || 0)}</div>
                          <div style={{ fontWeight: 600, color: VERT_OK }}>{p.verse ? formatDH(p.montant) : ""}</div>
                          <div style={{ color: TAUPE }}>{p.verse ? p.designation : p.commentaire}</div>
                          <div style={{ fontSize: 11, color: TAUPE }}>{p.verse ? (compteDe(p.compteId) || {}).nom || "" : p.par}</div>
                          <div>{!p.verse && peut("staff.primes") && <button type="button" className="sc-btn" onClick={() => supprimerPrime(p.id)} style={iconBtnStyle} title="Supprimer (erreur de saisie)">✕</button>}</div>
                        </div>
                      ))}
                    </div>
                    {peut("staff.primes") && (
                      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", background: PIERRE, borderRadius: 8, padding: 10 }}>
                        <input type="date" className="sc-input" value={primeSaisie.date} onChange={(e) => setPrimeSaisie({ ...primeSaisie, date: e.target.value })} style={{ ...inputStyle(150), padding: "5px 8px", background: "#fff" }} />
                        <select className="sc-select" value={primeSaisie.type} onChange={(e) => { const d = dernierePrime(f, e.target.value); setPrimeSaisie({ ...primeSaisie, type: e.target.value, montant: primeSaisie.montant || (d ? String(d.montant) : "") }); }} style={{ ...selectStyle, width: 170, background: "#fff" }}>
                          <option value="">— Type —</option>
                          {[...new Set([...typesPrimes(), TYPE_PRIME_PRODUCTIVITE])].map((t) => (<option key={t} value={t}>{t}</option>))}
                        </select>
                        <input type="number" min="0" className="sc-input" value={primeSaisie.montant} onChange={(e) => setPrimeSaisie({ ...primeSaisie, montant: e.target.value })} placeholder="Montant (DH)" style={{ ...inputStyle(130), padding: "5px 8px", background: "#fff" }} />
                        <input className="sc-input" value={primeSaisie.commentaire} onChange={(e) => setPrimeSaisie({ ...primeSaisie, commentaire: e.target.value })} placeholder="Commentaire" style={{ ...inputStyle(200), padding: "5px 8px", background: "#fff", flex: 1 }} />
                        <button type="button" className="sc-btn" onClick={ajouterPrime} style={primaryBtnStyle}>Ajouter</button>
                      </div>
                    )}
                    <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Versé = sorties de caisse « Primes » ou « Prime de productivité » à cette personne, lues en direct (elles se corrigent dans la caisse). Accordé = semaines de productivité validées et primes ajoutées ici (prime payée hors ERP, par exemple). Les primes ne sont visibles que par le Gérant.</div>
                  </div>
                );
              })()}
              {!nouveau && ongletFicheStaff === "conges" && (() => {
                const annee = todayISO().slice(0, 4);
                const c = soldeConges(f, annee);
                const tot = totauxAnnee(f.id, annee);
                const mois = lignesMensuelles(f.id, annee).filter((m) => !recPointage(m.mois)).sort((a, b) => (a.mois < b.mois ? 1 : -1));
                const carte = (label, val, couleur) => (
                  <div style={{ background: PIERRE, borderRadius: 8, padding: "8px 12px", minWidth: 110 }}>
                    <div style={{ fontSize: 10, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.4 }}>{label}</div>
                    <div style={{ fontSize: 16, fontWeight: 700, color: couleur || ENCRE }}>{String(val).replace(".", ",")} j</div>
                  </div>
                );
                return (
                  <div style={{ marginBottom: 10 }}>
                    <div style={{ fontSize: 12, color: TAUPE, marginBottom: 6 }}>Année {annee}{!f.dateEmbauche ? " — date d'embauche non renseignée : acquis compté depuis le 1er janvier, sans majoration d'ancienneté" : ""}</div>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
                      {carte("Report au 1er janvier", c.report)}
                      {carte(`Acquis à date (droit annuel ${String(c.plein).replace(".", ",")} j)`, c.acquis)}
                      {carte("Congés pris", c.pris)}
                      {carte("Reliquat", c.reliquat, c.reliquat < 0 ? ROUILLE : VERT_OK)}
                    </div>
                    {peutGererStaff && (
                      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 12, fontSize: 13 }}>
                        Report de l'année précédente sur {annee} :
                        <input type="number" min="0" step="0.5" className="sc-input" value={reportSaisi} onChange={(e) => setReportSaisi(e.target.value)} placeholder={String(c.report)} style={{ ...inputStyle(90), padding: "4px 8px" }} />
                        <button type="button" className="sc-btn" onClick={() => enregistrerReportConges(annee)} style={{ ...ghostBtnStyle, fontSize: 12 }}>Enregistrer</button>
                      </div>
                    )}
                    <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: 10, marginBottom: 12 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>Congés spéciaux (paternité, maternité…)</div>
                      {!(f.congesSpeciaux || []).length && <div style={{ fontSize: 12, color: TAUPE, marginBottom: 6 }}>Aucun.</div>}
                      {(f.congesSpeciaux || []).map((x) => { const t = typesCongesSpeciaux().find((y) => y.id === x.typeId) || { libelle: x.libelle, code: "CS", prise: "employeur" }; return (
                        <div key={x.id} style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 12, background: PIERRE, borderRadius: 6, padding: "4px 10px", marginBottom: 4 }}>
                          <span style={{ background: "#E3E0F0", padding: "0 5px", borderRadius: 4, fontWeight: 700, fontSize: 11 }}>{t.code}</span>
                          <span style={{ flex: 1 }}>{t.libelle} du {formatDate(x.debut)} au {formatDate(x.fin)} — {t.prise === "cnss" ? "CNSS (retiré de la paie)" : "payé par l'employeur"}{x.note ? ` — ${x.note}` : ""} <span style={{ color: TAUPE }}>({x.par})</span></span>
                          {peutGererStaff && <button type="button" className="sc-btn" onClick={() => supprimerCongeSpecial(x.id)} style={iconBtnStyle} title="Supprimer">✕</button>}
                        </div>
                      ); })}
                      {peutGererStaff && (
                        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center", marginTop: 6, fontSize: 12 }}>
                          <select className="sc-select" value={congeSpecialSaisie.typeId} onChange={(e) => { const t = typesCongesSpeciaux().find((y) => y.id === e.target.value); const d = congeSpecialSaisie.debut; setCongeSpecialSaisie({ ...congeSpecialSaisie, typeId: e.target.value, fin: d && t && nombreOuZero(t.jours) > 0 ? decalerJours(d, nombreOuZero(t.jours) - 1) : congeSpecialSaisie.fin }); }} style={{ ...selectStyle, width: 190, padding: "5px 8px" }}>
                            <option value="">— Type —</option>
                            {typesCongesSpeciaux().map((t) => (<option key={t.id} value={t.id}>{t.libelle}</option>))}
                          </select>
                          du <input type="date" className="sc-input" value={congeSpecialSaisie.debut} onChange={(e) => { const t = typesCongesSpeciaux().find((y) => y.id === congeSpecialSaisie.typeId); setCongeSpecialSaisie({ ...congeSpecialSaisie, debut: e.target.value, fin: e.target.value && t && nombreOuZero(t.jours) > 0 ? decalerJours(e.target.value, nombreOuZero(t.jours) - 1) : congeSpecialSaisie.fin }); }} style={{ ...inputStyle(145), padding: "5px 8px" }} />
                          au <input type="date" className="sc-input" value={congeSpecialSaisie.fin} onChange={(e) => setCongeSpecialSaisie({ ...congeSpecialSaisie, fin: e.target.value })} style={{ ...inputStyle(145), padding: "5px 8px" }} />
                          <input className="sc-input" value={congeSpecialSaisie.note} onChange={(e) => setCongeSpecialSaisie({ ...congeSpecialSaisie, note: e.target.value })} placeholder="Note (certificat…)" style={{ ...inputStyle(160), padding: "5px 8px", flex: 1 }} />
                          <button type="button" className="sc-btn" onClick={ajouterCongeSpecial} style={primaryBtnStyle}>Ajouter</button>
                        </div>
                      )}
                      <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Ces jours apparaissent tout seuls dans le pointage (non modifiables dans la grille), hors compteur d'heures et hors congés annuels. La date de fin se propose selon la durée du type (Paramétrage).</div>
                    </div>
                    {(() => {
                      const moisPointes = (pointage || []).filter((x) => x.mois.startsWith(`${annee}-`) && staffPresentSur(f, `${x.mois}-01`, finDeMois(x.mois))).sort((a, b) => (a.mois < b.mois ? 1 : -1));
                      const soldeAct = soldeHeuresActuel(f);
                      return (
                        <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: 10, marginBottom: 12 }}>
                          <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", fontSize: 13, marginBottom: 8 }}>
                            <span>Compteur d'heures : <strong style={{ fontSize: 15, color: soldeAct < 0 ? ROUILLE : soldeAct > 0 ? VERT_OK : ENCRE }}>{formatH(soldeAct)}</strong> <span style={{ fontSize: 11, color: TAUPE }}>(+ = heures à récupérer par l'employé · − = heures qu'il doit)</span></span>
                            {peutGererStaff && (
                              <span style={{ display: "flex", gap: 6, alignItems: "center", marginLeft: "auto", fontSize: 12 }}>
                                Solde de départ : {formatH(Number(f.soldeHeuresInitial) || 0)}
                                <input type="number" step="0.25" className="sc-input" value={soldeHeuresSaisi} onChange={(e) => setSoldeHeuresSaisi(e.target.value)} placeholder="ex. -6" style={{ ...inputStyle(80), padding: "3px 6px" }} />
                                <button type="button" className="sc-btn" onClick={enregistrerSoldeHeuresInitial} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 0" }}>Enregistrer</button>
                              </span>
                            )}
                          </div>
                          {moisPointes.length === 0 ? <div style={{ fontSize: 12, color: TAUPE }}>Aucun mois pointé cette année (Staff › Pointage).</div> : (
                            <div style={{ fontSize: 12 }}>
                              <div style={{ display: "grid", gridTemplateColumns: "1.2fr 0.7fr 0.7fr 0.8fr 0.8fr 0.8fr 0.8fr 0.9fr 0.9fr", gap: 6, color: TAUPE, fontSize: 10, textTransform: "uppercase", paddingBottom: 4 }}>
                                <span>Mois</span><span>Congés</span><span>Fériés</span><span>Récup.</span><span>Absences</span><span>Mise à pied</span><span>Mal. cert.</span><span>Écart</span><span>Solde fin</span>
                              </div>
                              {moisPointes.map((rec) => {
                                const sh = soldeHeuresMois(f, rec.mois);
                                const c = sh.calc || calculPersonneMois(f, rec.mois);
                                const d = rec.lignes && rec.lignes[f.id] ? rec.lignes[f.id].decision : "";
                                return (
                                  <div key={rec.mois} style={{ display: "grid", gridTemplateColumns: "1.2fr 0.7fr 0.7fr 0.8fr 0.8fr 0.8fr 0.8fr 0.9fr 0.9fr", gap: 6, padding: "3px 0", borderTop: `1px solid ${PIERRE}` }}>
                                    <span>{libMois(rec.mois)}{rec.statut !== "validé" ? " (en cours)" : ""}</span>
                                    <span>{String(c.congesJ).replace(".", ",")} j</span>
                                    <span>{c.feriesJ} j</span>
                                    <span>{String(c.recupH).replace(".", ",")} h</span>
                                    <span style={{ color: c.aH ? ROUILLE : ENCRE }}>{String(c.aH).replace(".", ",")} h</span>
                                    <span style={{ color: c.mpJ ? ROUILLE : ENCRE }}>{String(c.mpJ || 0).replace(".", ",")} j</span>
                                    <span>{String(c.mcJ).replace(".", ",")} j</span>
                                    <span>{formatH(c.ecart)}</span>
                                    <span style={{ fontWeight: 700 }}>{formatH(sh.fin)}{d === "regulariser" ? " → régul." : ""}</span>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      );
                    })()}
                    <div style={{ fontSize: 12, marginBottom: 6 }}>Anciennes saisies mensuelles (avant le pointage) — totaux {annee} : {COMPTEURS_MENSUELS.map((x) => `${x.label.toLowerCase()} ${String(tot[x.cle]).replace(".", ",")} j`).join(" · ")}</div>
                    <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, overflow: "hidden" }}>
                      <div style={{ display: "grid", gridTemplateColumns: `1.2fr ${COMPTEURS_MENSUELS.map(() => "0.8fr").join(" ")} 1.6fr`, padding: "8px 12px", background: PIERRE, gap: 8 }}><Th>Mois</Th>{COMPTEURS_MENSUELS.map((x) => <Th key={x.cle}>{x.label}</Th>)}<Th>Note</Th></div>
                      {mois.length === 0 && <div style={{ padding: 12, fontSize: 13, color: TAUPE }}>Aucune saisie mensuelle cette année (Staff › Saisie mensuelle).</div>}
                      {mois.map((m) => (
                        <div key={m.id} style={{ display: "grid", gridTemplateColumns: `1.2fr ${COMPTEURS_MENSUELS.map(() => "0.8fr").join(" ")} 1.6fr`, padding: "6px 12px", gap: 8, borderBottom: `1px solid ${PIERRE}`, fontSize: 13 }}>
                          <div>{libMois(m.mois)}</div>
                          {COMPTEURS_MENSUELS.map((x) => <div key={x.cle} style={{ color: Number(m[x.cle]) ? ENCRE : TAUPE }}>{String(Number(m[x.cle]) || 0).replace(".", ",")}</div>)}
                          <div style={{ fontSize: 12, color: TAUPE }}>{m.note}</div>
                        </div>
                      ))}
                    </div>
                    <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Acquis calculé selon les réglages de congés (Paramétrage, Gérant ; par défaut 1,5 j par mois de service, + 1,5 j par tranche de 5 ans d'ancienneté, 30 j maximum) — indicatif, à faire valider par le comptable. Congés pris = mois pointés (Staff › Pointage) + anciennes saisies mensuelles.</div>
                  </div>
                );
              })()}
              {!nouveau && ongletFicheStaff === "signalements" && (() => {
                const liste3 = (signalements || []).filter((x) => (x.personnes || []).includes(f.id) && signalementVisible(x)).sort((a, b) => ((a.date || "") + a.le < (b.date || "") + b.le ? 1 : -1));
                return (
                  <div style={{ marginBottom: 10 }}>
                    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
                      <button type="button" className="sc-btn" onClick={() => setSignalementEdit({ date: todayISO(), personnes: [f.id], type: "", gravite: "Moyenne", description: "", recherche: "" })} style={{ ...ghostBtnStyle, fontSize: 12 }}>📣 Nouveau signalement</button>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                      {liste3.length === 0 && <div style={{ fontSize: 13, color: TAUPE }}>Aucun signalement.</div>}
                      {liste3.map(renderSignalementLigne)}
                    </div>
                  </div>
                );
              })()}
              {!nouveau && ongletFicheStaff === "outillage" && (() => {
                // ERP step 12 (Nils 30/09) : outils en sa possession + historique.
                const detenus = (outils || []).filter((o) => o.detenteurId === f.id && outilActif(o)).sort((a, b) => String(a.numero).localeCompare(String(b.numero)));
                const depuis = (o) => { const h = [...(o.historique || [])].filter((x) => x.type === "affectation" && x.vers === f.id).sort((a, b) => ((a.date || "") < (b.date || "") ? 1 : -1))[0]; return h ? h.date : ""; };
                const evts = [];
                (outils || []).forEach((o) => (o.historique || []).forEach((h) => {
                  if (h.vers === f.id || h.de === f.id || h.detenteur === f.id || h.imputeA === f.id) evts.push({ o, h });
                }));
                evts.sort((a, b) => (((a.h.date || "") + (a.h.le || "")) < ((b.h.date || "") + (b.h.le || "")) ? 1 : -1));
                const libEvt = ({ o, h }) => {
                  if (h.type === "affectation") {
                    if (h.vers === f.id) return h.de ? `Reçu (remis par / depuis ${nomAffectation(h.de)})` : h.note === "Mise en service" ? "Reçu (outil neuf)" : "Reçu";
                    return `Rendu / transmis à ${nomAffectation(h.vers)}`;
                  }
                  if (h.type === "incident") return `${h.incident}${h.imputeA === f.id ? " — imputé à lui / elle" : h.detenteur === f.id ? " — alors qu'il / elle le détenait" : ""} → ${h.suite}`;
                  if (h.type === "retour réparation") return `Retour de réparation${peutVoirCoutsOutillage && h.cout !== "" && h.cout !== undefined ? ` (${formatDH(Number(h.cout) || 0)})` : ""}`;
                  if (h.type === "rebut") return "Mis hors service (irréparable)";
                  if (h.type === "sortie") return `Sorti du parc — ${h.motif}`;
                  return h.type;
                };
                return (
                  <div style={{ marginBottom: 10 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, gap: 10 }}>
                      <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>En sa possession — {detenus.length}</div>
                      {[["outillage", "d'outillage"], ["bureautique", "de matériel bureautique"]].map(([fam, lib]) => { const ids = detenus.filter((o) => familleOutil(o) === fam).map((o) => o.id); return ids.length > 0 ? <button key={fam} type="button" className="sc-btn" onClick={() => imprimerRemiseOutils(f.id, ids)} style={{ ...ghostBtnStyle, fontSize: 12 }}>🖨 Fiche de remise {lib}</button> : null; })}
                    </div>
                    <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, overflow: "hidden", marginBottom: 14 }}>
                      {detenus.length === 0 && <div style={{ padding: 12, fontSize: 13, color: TAUPE }}>Aucun outil.</div>}
                      {detenus.map((o) => (
                        <div key={o.id} style={{ display: "grid", gridTemplateColumns: "0.7fr 2fr 1.2fr 1fr 1fr", gap: 8, padding: "7px 12px", borderBottom: `1px solid ${PIERRE}`, fontSize: 13, alignItems: "center" }}>
                          <strong>{o.numero}</strong>
                          <span>{o.designation}<div style={{ fontSize: 11, color: TAUPE }}>{[o.marque, o.modele, o.serie ? `S/N ${o.serie}` : ""].filter(Boolean).join(" · ")}</div></span>
                          <span style={{ color: TAUPE }}>{o.categorie}</span>
                          <span style={{ color: o.etat === "En service" ? VERT_OK : OCRE }}>{o.etat}</span>
                          <span style={{ fontSize: 12, color: TAUPE }}>{depuis(o) ? `depuis le ${formatDate(depuis(o))}` : ""}</span>
                        </div>
                      ))}
                    </div>
                    <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Historique — {evts.length}</div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 4, maxHeight: 260, overflowY: "auto" }}>
                      {evts.length === 0 && <div style={{ fontSize: 13, color: TAUPE }}>Aucun mouvement.</div>}
                      {evts.map(({ o, h }) => (
                        <div key={`${o.id}-${h.id}`} style={{ fontSize: 13, padding: "4px 10px", borderRadius: 6, background: h.type === "incident" ? "#F5E4DE" : PIERRE }}>
                          <span style={{ color: TAUPE, marginRight: 8 }}>{h.date ? formatDate(h.date) : ""}</span>
                          <strong>{o.numero}</strong> {o.designation} — {libEvt({ o, h })}
                          {h.note && h.note !== "Mise en service" ? <span style={{ color: TAUPE }}> — {h.note}</span> : null}
                          <span style={{ fontSize: 11, color: TAUPE }}> · {h.par}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}
              {!nouveau && ongletFicheStaff === "evaluations" && (() => {
                const evs = [...(f.evaluations || [])].sort((a, b) => (a.periode < b.periode ? 1 : -1));
                const semPrec = semestrePrecedent(semestreDe(todayISO()));
                return (
                  <div style={{ marginBottom: 10 }}>
                    {peutEvaluer(f) && !evaluationDe(f, semPrec) && (
                      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
                        <button type="button" className="sc-btn" onClick={() => setEvaluationEdit({ staffId: f.id, periode: semPrec, notes: {}, lignesSup: [], commentaire: "", objectifs: "" })} style={{ ...ghostBtnStyle, fontSize: 12 }}>Évaluer le {libSemestre(semPrec)}</button>
                      </div>
                    )}
                    {evs.length === 0 && <div style={{ fontSize: 13, color: TAUPE }}>Aucune évaluation.</div>}
                    {evs.map((e) => (
                      <div key={e.id} style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "10px 12px", marginBottom: 8 }}>
                        <div style={{ display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap", fontSize: 13 }}>
                          <strong>{libSemestre(e.periode)}</strong>
                          <span style={{ fontSize: 11, color: e.validee ? VERT_OK : OCRE }}>{e.validee ? `Validée par ${e.valideePar}` : "À valider par le Gérant"} · par {e.par}, {formatDate(e.le.slice(0, 10))}</span>
                        </div>
                        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", fontSize: 12, marginTop: 6 }}>
                          {(e.criteres || CRITERES_EVALUATION).filter((c) => e.notes[c.cle]).map((c) => <span key={c.cle}>{c.label} : <strong>{e.notes[c.cle]}</strong></span>)}
                          {(e.lignesSup || []).map((l, i) => <span key={`sup${i}`}>{l.libelle} : <strong>{l.note}</strong></span>)}
                        </div>
                        {e.commentaire && <div style={{ fontSize: 13, marginTop: 6, whiteSpace: "pre-wrap" }}>{e.commentaire}</div>}
                        {e.objectifs && <div style={{ fontSize: 12, marginTop: 4, color: TAUPE, whiteSpace: "pre-wrap" }}>Objectifs : {e.objectifs}</div>}
                        <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
                          {peutEvaluer(f) && (!e.validee || peut("evaluations.valider")) && <button type="button" className="sc-btn" onClick={() => setEvaluationEdit({ staffId: f.id, periode: e.periode, notes: { ...e.notes }, lignesSup: (e.lignesSup || []).map((l) => ({ ...l })), commentaire: e.commentaire, objectifs: e.objectifs })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 0" }}>Modifier</button>}
                          {peut("evaluations.valider") && !e.validee && <button type="button" className="sc-btn" onClick={() => validerEvaluation(f.id, e.periode)} style={{ ...primaryBtnStyle, fontSize: 12, padding: "4px 10px" }}>Valider</button>}
                        </div>
                      </div>
                    ))}
                  </div>
                );
              })()}
              {!nouveau && ongletFicheStaff !== "identite" ? (
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
                  <button type="button" className="sc-btn" onClick={() => { setStaffEdit(null); setConfirmSupprStaff(false); }} style={ghostBtnStyle}>Fermer</button>
                </div>
              ) : (
              <div style={{ display: "flex", justifyContent: "space-between", gap: 8, marginTop: 8 }}>
                <div>{!nouveau && !lecture && !confirmSupprStaff && <button type="button" className="sc-btn" onClick={() => setConfirmSupprStaff(true)} style={{ ...ghostBtnStyle, color: ROUILLE }}>Supprimer la fiche</button>}</div>
                <div style={{ display: "flex", gap: 8 }}>
                  <button type="button" className="sc-btn" onClick={() => { setStaffEdit(null); setConfirmSupprStaff(false); }} style={ghostBtnStyle}>{lecture ? "Fermer" : "Annuler"}</button>
                  {!lecture && <button type="button" className="sc-btn" onClick={enregistrerFicheStaff} style={primaryBtnStyle}>Enregistrer</button>}
                </div>
              </div>
              )}
            </div>
          </Overlay>
        );
      })()}

      {mesSignalementsOuverts && (
        <Overlay onClose={() => setMesSignalementsOuverts(false)}>
          <div style={modalStyle(600)}>
            <div style={modalTitleStyle}>Mes signalements</div>
            {(signalements || []).filter((x) => x.auteurId === user.id).sort((a, b) => ((a.le || "") < (b.le || "") ? 1 : -1)).map((sg) => (
              <div key={sg.id} style={{ fontSize: 13, borderBottom: `1px solid ${PIERRE}`, padding: "8px 0" }}>
                <div><strong>{formatDate(sg.date)}</strong> — {sg.type} — {(sg.personnes || []).map(nomStaff).join(", ")} <span style={{ color: TAUPE, fontSize: 11 }}>(gravité {String(sg.gravite || "").toLowerCase()})</span></div>
                <div style={{ color: TAUPE, fontSize: 12, marginTop: 2 }}>{sg.description}</div>
                <div style={{ fontSize: 11, marginTop: 2, color: sg.statut === "Clos" ? VERT_OK : OCRE }}>{sg.statut === "Clos" ? "Traité" : "Transmis au Gérant"}</div>
              </div>
            ))}
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}>
              <button type="button" className="sc-btn" onClick={() => setMesSignalementsOuverts(false)} style={ghostBtnStyle}>Fermer</button>
            </div>
          </div>
        </Overlay>
      )}
      {signalementEdit && (() => {
        const f = signalementEdit;
        const set = (patch) => setSignalementEdit({ ...f, ...patch });
        const q = normNomStaff(f.recherche || "");
        const choix = (staff || []).filter(staffActif).filter((s) => !ficheStaffMasquee(s)).filter((s) => !q || normNomStaff(s.nom).includes(q)).sort((a, b) => a.nom.localeCompare(b.nom, "fr", { sensitivity: "base" }));
        const bascule = (id) => set({ personnes: f.personnes.includes(id) ? f.personnes.filter((x) => x !== id) : [...f.personnes, id] });
        return (
          <Overlay onClose={() => setSignalementEdit(null)}>
            <div style={modalStyle(620)}>
              <div style={modalTitleStyle}>📣 Faire un signalement</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 12 }}>Plainte, conflit, incident ou point positif : le signalement est transmis au Gérant et gardé dans l'historique. Les personnes concernées ne le voient pas.</div>
              <Field label="Personne(s) concernée(s)">
                <input className="sc-input" value={f.recherche || ""} onChange={(e) => set({ recherche: e.target.value })} placeholder="Rechercher un nom…" style={{ ...inputStyle("100%"), marginBottom: 6 }} />
                <div style={{ maxHeight: 150, overflowY: "auto", border: `1px solid ${PIERRE}`, borderRadius: 6, padding: 6, display: "flex", flexWrap: "wrap", gap: 10 }}>
                  {choix.map((s) => (
                    <label key={s.id} style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 13 }}>
                      <input type="checkbox" checked={f.personnes.includes(s.id)} onChange={() => bascule(s.id)} /> {s.nom}
                    </label>
                  ))}
                  {choix.length === 0 && <span style={{ fontSize: 12, color: TAUPE }}>Aucun nom trouvé.</span>}
                </div>
                {f.personnes.length > 0 && <div style={{ fontSize: 12, marginTop: 4 }}>Sélection : <strong>{f.personnes.map(nomStaff).join(", ")}</strong></div>}
              </Field>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                <Field label="Date des faits"><input type="date" className="sc-input" value={f.date} max={todayISO()} onChange={(e) => set({ date: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label="Type">
                  <select className="sc-select" value={f.type} onChange={(e) => set({ type: e.target.value })} style={selectStyle}>
                    <option value="">— Choisir —</option>
                    {TYPES_SIGNALEMENT.map((x) => (<option key={x} value={x}>{x}</option>))}
                  </select>
                </Field>
                <Field label="Gravité">
                  <select className="sc-select" value={f.gravite} onChange={(e) => set({ gravite: e.target.value })} style={selectStyle}>
                    {GRAVITES_SIGNALEMENT.map((x) => (<option key={x} value={x}>{x}</option>))}
                  </select>
                </Field>
              </div>
              <Field label="Ce qui s'est passé"><textarea className="sc-input" value={f.description} onChange={(e) => set({ description: e.target.value })} rows={4} placeholder="ex. dispute entre les deux finisseurs sur le partage du travail, ton qui monte devant l'équipe" style={{ ...inputStyle("100%"), resize: "vertical" }} /></Field>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 8 }}>
                <button type="button" className="sc-btn" onClick={() => setSignalementEdit(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={enregistrerSignalement} style={primaryBtnStyle}>Envoyer le signalement</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {finMoisVue && (() => {
        const s0 = (staff || []).find((x) => x.id === finMoisVue);
        if (!s0) return null;
        const rec = recPointage(moisPointage);
        const sh = soldeHeuresMois(s0, moisPointage);
        if (!sh.rub) return null;
        const modifiable = peut("pointage.decisions") && !(rec && rec.statut === "validé");
        const ligne = (lib, val, choixEl, couleur) => (
          <div style={{ display: "grid", gridTemplateColumns: "1.4fr 0.6fr 1.6fr", gap: 8, alignItems: "center", fontSize: 13, padding: "6px 0", borderBottom: `1px solid ${PIERRE}` }}>
            <span>{lib}</span><span style={{ fontWeight: 700, color: couleur || ENCRE }}>{val}</span><span>{choixEl}</span>
          </div>
        );
        return (
          <Overlay onClose={() => setFinMoisVue(null)}>
            <div style={modalStyle(560)}>
              <div style={modalTitleStyle}>{s0.nom} — fin de mois</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 10, textTransform: "capitalize" }}>{libMois(moisPointage)}{rec && rec.statut === "validé" ? " — validé" : modifiable ? " — tu choisis rubrique par rubrique" : " — décidé par le Gérant (lecture seule)"}</div>
              {!sh.rub.lignes.length && !sh.rub.auto.length && <div style={{ fontSize: 13, color: TAUPE, marginBottom: 10 }}>Rien à décider ce mois-ci.</div>}
              {sh.rub.lignes.map((l) => (
                <React.Fragment key={l.cle}>
                  {ligne(l.lib, l.cle === "mc" ? `${String(l.j).replace(".", ",")} j (${String(l.h).replace(".", ",")} h)` : formatH(["hs", "report", "ferie"].includes(l.cle) ? l.h : -l.h), modifiable ? (
                    <select className="sc-select" value={l.choix} onChange={(e) => changerChoixFinMois(s0.id, l.cle, e.target.value)} style={{ ...selectStyle, width: "100%", fontSize: 12 }}>
                      {l.options.map(([v, t]) => (<option key={v} value={v}>{t}</option>))}
                    </select>
                  ) : <span style={{ color: l.choix === "reporter" ? TAUPE : OCRE }}>{(l.options.find((o) => o[0] === l.choix) || [0, l.choix])[1]}</span>, l.cle === "hs" || l.cle === "ferie" || (l.cle === "report" && l.h > 0) ? VERT_OK : ROUILLE)}
                </React.Fragment>
              ))}
              {sh.rub.auto.map((a) => <React.Fragment key={a.lib}>{ligne(a.lib, formatH(a.h), <span style={{ color: TAUPE }}>automatique</span>)}</React.Fragment>)}
              <div style={{ display: "flex", gap: 16, flexWrap: "wrap", fontSize: 13, marginTop: 10 }}>
                <span>Compteur fin de mois : <b style={{ color: sh.fin < 0 ? ROUILLE : sh.fin > 0 ? VERT_OK : ENCRE }}>{formatH(sh.fin)}</b></span>
                {sh.rub.h25 > 0 && <span>HS payées à 25 % : <b>{formatH(sh.rub.h25)}</b></span>}
                {sh.rub.hNormal > 0 && <span>Compteur payé : <b>{formatH(sh.rub.hNormal)}</b></span>}
                {sh.rub.hDeduire > 0 && <span>À retrancher : <b style={{ color: ROUILLE }}>{formatH(sh.rub.hDeduire)}</b></span>}
                {sh.rub.cnssJ > 0 && <span>Jours CNSS : <b>{String(sh.rub.cnssJ).replace(".", ",")} j</b></span>}
              </div>
              <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>Heures sup. et heures manquantes des jours travaillés se compensent dans le mois ; les heures sup. reportées comptent ×1,25 au compteur. Mise à pied : toujours retirée de la paie.</div>
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}><button type="button" className="sc-btn" onClick={() => setFinMoisVue(null)} style={primaryBtnStyle}>Fermer</button></div>
            </div>
          </Overlay>
        );
      })()}
      {celluleEdit && (() => {
        const c = celluleEdit;
        const s = (staff || []).find((x) => x.id === c.staffId);
        if (!s) return null;
        const set = (patch) => setCelluleEdit({ ...c, ...patch });
        const off = c.jourSemaine === 0 || c.jourSemaine === 6;
        const choix = [{ code: "", label: off ? "Repos / travail le week-end" : "Présent" }, ...CODES_POINTAGE];
        const heuresPossibles = c.pointageHeures && (c.code === "" || c.code === "F");
        return (
          <Overlay onClose={() => setCelluleEdit(null)}>
            <div style={modalStyle(460)}>
              <div style={modalTitleStyle}>{s.nom}</div>
              <div style={{ fontSize: 13, color: TAUPE, marginTop: -8, marginBottom: 12 }}>{JOURS_SEMAINE_LONGS[c.jourSemaine]} {formatDate(c.date)} · heures dues : {String(c.dues).replace(".", ",")} h{c.ramadanOffert ? ` (ramadan : ${String(c.ramadanOffert).replace(".", ",")} h offerte(s) ; les heures faites jusqu'à l'horaire normal ne comptent pas en heures sup.)` : ""}</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 4, marginBottom: 10 }}>
                {choix.map((x) => (
                  <label key={x.code || "p"} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, padding: "4px 8px", borderRadius: 6, background: c.code === x.code ? PIERRE : "transparent", cursor: "pointer" }}>
                    <input type="radio" checked={c.code === x.code} onChange={() => set({ code: x.code, demi: x.code && x.code !== "F" ? c.demi : false, heures: x.code === "" ? (c.code === "" ? c.heures : c.pointageHeures && Number(c.dues) > 0 ? Number(c.dues) : "") : x.code === "F" ? (c.code === "F" ? c.heures : "") : "" })} />
                    {x.code && <span style={{ background: x.couleur, padding: "0 5px", borderRadius: 4, fontWeight: 700, fontSize: 11 }}>{x.code}</span>}
                    {x.label}
                  </label>
                ))}
              </div>
              {c.code && c.code !== "F" && (
                <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, marginBottom: 8 }}>
                  <input type="checkbox" checked={!!c.demi} onChange={(e) => set({ demi: e.target.checked, code2: e.target.checked ? c.code2 || "" : "" })} /> Demi-journée
                </label>
              )}
              {c.code && c.code !== "F" && c.demi && (
                <Field label="L'autre demi-journée">
                  <select className="sc-select" value={c.code2 || ""} onChange={(e) => set({ code2: e.target.value })} style={{ ...selectStyle, width: "100%" }}>
                    <option value="">Présent</option>
                    {CODES_POINTAGE.filter((x) => x.code !== "F" && x.code !== c.code).map((x) => (<option key={x.code} value={x.code}>{x.code} — {x.label}</option>))}
                  </select>
                </Field>
              )}
              {heuresPossibles && (
                <Field label={c.code === "F" ? "Heures travaillées ce jour férié" : off ? "Heures travaillées (s'ajoutent au compteur)" : "Heures réellement faites (pré-remplies avec les heures dues)"}>
                  <input type="number" min="0" max="24" step="any" className="sc-input" value={c.heures} onChange={(e) => set({ heures: e.target.value })} placeholder={off || c.code === "F" ? "0" : String(c.dues)} style={inputStyle(140)} />
                </Field>
              )}
              {heuresPossibles && !off && c.code === "" && (regimePointage((staff || []).find((x) => x.id === c.staffId) || {}, recPointage(moisPointage)).sansHS || regimePointage((staff || []).find((x) => x.id === c.staffId) || {}, recPointage(moisPointage)).cle === "bureau") && (
                <div style={{ fontSize: 11, color: TAUPE, marginTop: -8, marginBottom: 10 }}>Bureau (accord 40 h) : les heures en plus ne comptent pas ; seules les heures en moins vont au compteur.</div>
              )}
              {c.code === "" && !c.deplacementId && (
                <div style={{ background: c.deplManuel ? "#F3ECDD" : "transparent", border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "8px 10px", marginBottom: 10 }}>
                  <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, cursor: "pointer" }}>
                    <input type="checkbox" checked={!!c.deplManuel} onChange={(e) => set({ deplManuel: e.target.checked ? { lieu: "", dossier: "", jours: 1 } : null })} /> Déplacement sans fiche (avant l'ERP, ou fiche non saisie)
                  </label>
                  {c.deplManuel && (
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 8 }}>
                      <input className="sc-input" value={c.deplManuel.lieu} onChange={(e) => set({ deplManuel: { ...c.deplManuel, lieu: e.target.value } })} placeholder="Lieu ou zone (ex. Casablanca)" style={{ ...inputStyle("100%"), flex: 2, minWidth: 160 }} />
                      <input className="sc-input" value={c.deplManuel.dossier} onChange={(e) => set({ deplManuel: { ...c.deplManuel, dossier: e.target.value } })} placeholder="Dossier, ou « avant l'ERP »" style={{ ...inputStyle("100%"), flex: 2, minWidth: 160 }} />
                      <select className="sc-select" value={String(c.deplManuel.jours || 1)} onChange={(e) => set({ deplManuel: { ...c.deplManuel, jours: Number(e.target.value) } })} style={{ ...selectStyle, flex: 1, minWidth: 130 }}>
                        <option value="1">Prime : 1 jour</option>
                        <option value="0.5">Prime : ½ jour</option>
                      </select>
                    </div>
                  )}
                  {c.deplManuel && <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Compté dans les primes de déplacement du mois ({formatDH(tauxPrimeDeplacementAu(c.date))} / jour). Une fiche saisie plus tard pour ce jour le remplace.</div>}
                </div>
              )}
              {c.deplacementId && <div style={{ fontSize: 12, color: TAUPE, marginBottom: 10 }}>Jour de déplacement porté par une fiche de déplacement (Commandes › 🚚 Déplacements).</div>}
              <Field label="Note (facultatif)"><input className="sc-input" value={c.note || ""} onChange={(e) => set({ note: e.target.value })} placeholder="ex. certificat reçu le 12/10, rendez-vous administratif" style={inputStyle("100%")} /></Field>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 8, marginTop: 8 }}>
                <button type="button" className="sc-btn" onClick={() => enregistrerCellule(true)} style={{ ...ghostBtnStyle, fontSize: 12 }}>Réinitialiser la case</button>
                <div style={{ display: "flex", gap: 8 }}>
                  <button type="button" className="sc-btn" onClick={() => setCelluleEdit(null)} style={ghostBtnStyle}>Annuler</button>
                  <button type="button" className="sc-btn" onClick={() => enregistrerCellule(false)} style={primaryBtnStyle}>Enregistrer</button>
                </div>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {evaluationEdit && (() => {
        const f = evaluationEdit;
        const s = (staff || []).find((x) => x.id === f.staffId);
        if (!s) return null;
        const set = (patch) => setEvaluationEdit({ ...f, ...patch });
        return (
          <Overlay onClose={() => setEvaluationEdit(null)}>
            <div style={modalStyle(600)}>
              <div style={modalTitleStyle}>Évaluation — {s.nom}</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 12 }}>{libSemestre(f.periode)} · A = au-dessus des attentes, B = conforme, C = insuffisant</div>
              {criteresEvaluation().map((c) => (
                <div key={c.cle} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, padding: "6px 0", borderBottom: `1px solid ${PIERRE}` }}>
                  <span style={{ fontSize: 13 }}>{c.label}</span>
                  <div style={{ display: "flex", gap: 6 }}>
                    {NOTES_EVALUATION.map((n) => (
                      <button key={n} type="button" className="sc-btn" onClick={() => set({ notes: { ...(f.notes || {}), [c.cle]: n } })} style={{ ...ghostBtnStyle, width: 34, padding: "4px 0", borderRadius: 6, fontWeight: 700, background: (f.notes || {})[c.cle] === n ? (n === "A" ? "#E4EBE4" : n === "B" ? PIERRE : "#F5E4DE") : "transparent", color: n === "A" ? VERT_OK : n === "C" ? ROUILLE : ENCRE, border: `1px solid ${PIERRE}` }}>{n}</button>
                    ))}
                  </div>
                </div>
              ))}
              {(f.lignesSup || []).map((l, i) => {
                const setL = (patch) => set({ lignesSup: f.lignesSup.map((x, j) => (j === i ? { ...x, ...patch } : x)) });
                return (
                  <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, padding: "6px 0", borderBottom: `1px solid ${PIERRE}` }}>
                    <input className="sc-input" value={l.libelle || ""} onChange={(e) => setL({ libelle: e.target.value })} placeholder="Intitulé (ex. Polyvalence, Rangement de l'atelier)" style={{ ...inputStyle("100%"), padding: "4px 8px", fontSize: 13, flex: 1 }} />
                    <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                      {NOTES_EVALUATION.map((n) => (
                        <button key={n} type="button" className="sc-btn" onClick={() => setL({ note: n })} style={{ ...ghostBtnStyle, width: 34, padding: "4px 0", borderRadius: 6, fontWeight: 700, background: l.note === n ? (n === "A" ? "#E4EBE4" : n === "B" ? PIERRE : "#F5E4DE") : "transparent", color: n === "A" ? VERT_OK : n === "C" ? ROUILLE : ENCRE, border: `1px solid ${PIERRE}` }}>{n}</button>
                      ))}
                      <button type="button" className="sc-btn" onClick={() => set({ lignesSup: f.lignesSup.filter((_, j) => j !== i) })} style={iconBtnStyle} title="Retirer la ligne">✕</button>
                    </div>
                  </div>
                );
              })}
              <button type="button" className="sc-btn" onClick={() => set({ lignesSup: [...(f.lignesSup || []), { libelle: "", note: "" }] })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "6px 0" }}>+ Ajouter une ligne</button>
              <div style={{ marginTop: 12 }}>
                <Field label="Commentaire"><textarea className="sc-input" value={f.commentaire || ""} onChange={(e) => set({ commentaire: e.target.value })} rows={3} style={{ ...inputStyle("100%"), resize: "vertical" }} /></Field>
                <Field label="Objectifs pour le semestre suivant"><textarea className="sc-input" value={f.objectifs || ""} onChange={(e) => set({ objectifs: e.target.value })} rows={2} style={{ ...inputStyle("100%"), resize: "vertical" }} /></Field>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 8 }}>
                <button type="button" className="sc-btn" onClick={() => setEvaluationEdit(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={enregistrerEvaluation} style={primaryBtnStyle}>{peut("evaluations.valider") ? "Enregistrer (validée)" : "Enregistrer — à valider par le Gérant"}</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {importStaff && peutGererStaff && (() => {
        const im = importStaff;
        const bloc = (titre, items, rendu, couleur) => items.length === 0 ? null : (
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 11, color: couleur || TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 4 }}>{titre} ({items.length})</div>
            <div style={{ maxHeight: 180, overflowY: "auto", fontSize: 12, border: `1px solid ${PIERRE}`, borderRadius: 6, padding: "4px 8px" }}>{items.map((x, i) => <div key={i} style={{ padding: "2px 0" }}>{rendu(x)}</div>)}</div>
          </div>
        );
        return (
          <Overlay onClose={() => setImportStaff(null)}>
            <div style={modalStyle(720)}>
              <div style={modalTitleStyle}>Import du personnel — aperçu</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 12 }}>{im.fichier} · rien n'est enregistré avant « Confirmer l'import ». Les cases vides du fichier ne remplacent pas ce qui existe déjà dans l'ERP.</div>
              {bloc("Erreurs — lignes ignorées", im.erreurs, (x) => x, ROUILLE)}
              {bloc("Avertissements", im.avert, (x) => x, OCRE)}
              {bloc("Fiches", im.lignes, (l) => <><strong>{l.nom}</strong> — <span style={{ color: l.action === "création" ? VERT_OK : l.action === "inchangée" ? TAUPE : ENCRE }}>{l.action}</span>{l.detail ? <span style={{ color: TAUPE }}> : {l.detail}</span> : null}</>)}
              {bloc("Salaires", im.salaires, (x) => <>{x.nom} — {formatDate(x.d)} — {formatDH(x.net)}{x.brut ? ` (brut ${formatDH(x.brut)})` : ""} — {x.type}{x.brutMaj ? <span style={{ color: VERT_OK }}> (brut mis à jour)</span> : x.doublon ? <span style={{ color: TAUPE }}> (déjà enregistré, ignoré)</span> : null}</>)}
              {im.lignes.length === 0 && im.salaires.length === 0 && <div style={{ fontSize: 13, color: TAUPE }}>Rien à importer.</div>}
              <div style={{ fontSize: 11, color: TAUPE }}>Reliquat de congés importé comme report sur {im.anneeReliquat}.</div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 14 }}>
                <button type="button" className="sc-btn" onClick={() => setImportStaff(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={confirmerImportStaff} disabled={im.lignes.length === 0 && im.salaires.length === 0} style={primaryBtnStyle}>Confirmer l'import</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {showTypesContrat && peutGererStaff && (
        <Overlay onClose={() => setShowTypesContrat(false)}>
          <div style={modalStyle(420)}>
            <div style={modalTitleStyle}>Types de contrat</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 14, maxHeight: 320, overflowY: "auto" }}>
              {typesContrat().map((c) => {
                const nb = (staff || []).filter((s) => s.contrat === c).length;
                return (
                  <div key={c} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 10px", borderRadius: 6, background: PIERRE }}>
                    {typeContratEdition && typeContratEdition.ancien === c ? (
                      <>
                        <input className="sc-input" autoFocus value={typeContratEdition.valeur} onChange={(e) => setTypeContratEdition({ ...typeContratEdition, valeur: e.target.value })} onKeyDown={async (e) => { if (e.key === "Enter") { await renommerTypeContrat(c, typeContratEdition.valeur); setTypeContratEdition(null); } if (e.key === "Escape") setTypeContratEdition(null); }} style={{ ...inputStyle("100%"), padding: "4px 8px", fontSize: 13 }} />
                        <button type="button" className="sc-btn" onClick={async () => { await renommerTypeContrat(c, typeContratEdition.valeur); setTypeContratEdition(null); }} style={iconBtnStyle} title="Valider">✓</button>
                        <button type="button" className="sc-btn" onClick={() => setTypeContratEdition(null)} style={iconBtnStyle} title="Annuler">↩</button>
                      </>
                    ) : (
                      <>
                        <span style={{ flex: 1, fontSize: 13 }}>{c}</span>
                        <span style={{ fontSize: 11, color: TAUPE, whiteSpace: "nowrap" }}>{nb} fiche(s)</span>
                        <button type="button" className="sc-btn" onClick={() => setTypeContratEdition({ ancien: c, valeur: c })} style={iconBtnStyle} title="Modifier">✎</button>
                        <button type="button" className="sc-btn" onClick={() => supprimerTypeContrat(c)} style={iconBtnStyle} title="Supprimer">✕</button>
                      </>
                    )}
                  </div>
                );
              })}
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <input className="sc-input" value={nouveauTypeContrat} onChange={(e) => setNouveauTypeContrat(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") ajouterTypeContrat(); }} placeholder="Nouveau type de contrat" style={inputStyle("100%")} />
              <button type="button" className="sc-btn" onClick={ajouterTypeContrat} style={primaryBtnStyle}>Ajouter</button>
            </div>
            <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>✎ pour renommer : les fiches concernées sont mises à jour. Un type utilisé par une fiche ne peut pas être supprimé.</div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <button type="button" className="sc-btn" onClick={() => setShowTypesContrat(false)} style={ghostBtnStyle}>Fermer</button>
            </div>
          </div>
        </Overlay>
      )}

      {listeTechEdit && peut("devis.listesTechniques") && (() => {
        const champ = listeTechEdit;
        const l = listeReferencesTech(champ);
        const hors = referencesConnues(champ).filter((r) => !l.some((x) => normLib(x) === normLib(r)));
        return (
          <Overlay zIndex={200} onClose={() => setListeTechEdit(null)}>
            <div style={modalStyle(460)}>
              <div style={modalTitleStyle}>{champ === "eviers" ? "Liste des éviers" : "Liste des plaques de cuisson"}</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 12, maxHeight: 300, overflowY: "auto" }}>
                {l.length === 0 && <div style={{ fontSize: 13, color: TAUPE }}>Liste vide.</div>}
                {l.map((r) => (
                  <div key={r} style={{ display: "flex", alignItems: "center", gap: 8, padding: "5px 10px", borderRadius: 6, background: PIERRE, fontSize: 13 }}>
                    <span style={{ flex: 1 }}>{r}</span>
                    {champ === "eviers" && (
                      <select className="sc-select" aria-label={`Type de ${r}`} value={typeEvierRef(r)} onChange={(e) => setTypeEvierRef(r, e.target.value)} style={{ ...selectStyle, width: 130, padding: "3px 6px", fontSize: 12, background: "#fff", color: typeEvierRef(r) ? ENCRE : ROUILLE }}>
                        <option value="">Type ?</option>
                        {TYPES_EVIER.map((t) => <option key={t} value={t}>{t}</option>)}
                      </select>
                    )}
                    <button type="button" className="sc-btn" title="Retirer de la liste" onClick={() => majListeTech(champ, l.filter((x) => x !== r), `retirée : ${r}`)} style={iconBtnStyle}>✕</button>
                  </div>
                ))}
              </div>
              {champ === "eviers" && (
                <div style={{ display: "flex", gap: 16, fontSize: 13, marginBottom: 6 }}>
                  <span style={{ color: TAUPE }}>Type de la nouvelle référence :</span>
                  {TYPES_EVIER.map((t) => (<label key={t} style={{ display: "flex", alignItems: "center", gap: 5 }}><input type="radio" name="nouveauTypeEvier" checked={nouveauTypeEvier === t} onChange={() => setNouveauTypeEvier(t)} />{t}</label>))}
                </div>
              )}
              <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                <input className="sc-input" value={nouvelleRefTech} onChange={(e) => setNouvelleRefTech(e.target.value)} onKeyDown={async (e) => { if (e.key === "Enter") { if (await ajouterRefTech(champ, nouvelleRefTech)) setNouvelleRefTech(""); } }} placeholder="Nouvelle référence" style={inputStyle("100%")} />
                <button type="button" className="sc-btn" onClick={async () => { if (await ajouterRefTech(champ, nouvelleRefTech)) setNouvelleRefTech(""); }} style={primaryBtnStyle}>Ajouter</button>
              </div>
              {hors.length > 0 && (
                <div style={{ background: "#F4ECD8", borderRadius: 8, padding: 10, marginBottom: 12 }}>
                  <div style={{ fontSize: 11, color: OCRE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 6 }}>Saisies hors liste dans les devis / dossiers ({hors.length})</div>
                  {hors.map((r) => (
                    <div key={r} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, padding: "2px 0" }}>
                      <span style={{ flex: 1 }}>{r}</span>
                      <button type="button" className="sc-btn" onClick={() => ajouterRefTech(champ, r)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 10px" }}>+ Ajouter à la liste</button>
                    </div>
                  ))}
                </div>
              )}
              <div style={{ fontSize: 11, color: TAUPE, marginBottom: 10 }}>Retirer une référence de la liste ne change pas les devis et dossiers qui l'utilisent déjà.</div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <button type="button" className="sc-btn" onClick={() => setListeTechEdit(null)} style={ghostBtnStyle}>Fermer</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {showCategoriesOutil && peutGererOutillage && (
        <Overlay onClose={() => setShowCategoriesOutil(false)}>
          <div style={modalStyle(420)}>
            <div style={modalTitleStyle}>{estBureautique ? "Catégories de matériel bureautique" : "Catégories d'outils"}</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 14, maxHeight: 320, overflowY: "auto" }}>
              {categoriesOutil().map((c) => {
                const nb = (outils || []).filter((o) => familleOutil(o) === familleVue && o.categorie === c).length;
                return (
                  <div key={c} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 10px", borderRadius: 6, background: PIERRE }}>
                    {categorieOutilEdition && categorieOutilEdition.ancien === c ? (
                      <>
                        <input className="sc-input" autoFocus value={categorieOutilEdition.valeur} onChange={(e) => setCategorieOutilEdition({ ...categorieOutilEdition, valeur: e.target.value })} onKeyDown={async (e) => { if (e.key === "Enter") { await renommerCategorieOutil(c, categorieOutilEdition.valeur); setCategorieOutilEdition(null); } if (e.key === "Escape") setCategorieOutilEdition(null); }} style={{ ...inputStyle("100%"), padding: "4px 8px", fontSize: 13 }} />
                        <button type="button" className="sc-btn" onClick={async () => { await renommerCategorieOutil(c, categorieOutilEdition.valeur); setCategorieOutilEdition(null); }} style={iconBtnStyle} title="Valider">✓</button>
                        <button type="button" className="sc-btn" onClick={() => setCategorieOutilEdition(null)} style={iconBtnStyle} title="Annuler">↩</button>
                      </>
                    ) : (
                      <>
                        <span style={{ flex: 1, fontSize: 13 }}>{c}</span>
                        <span style={{ fontSize: 11, color: TAUPE, whiteSpace: "nowrap" }}>{nb} outil(s)</span>
                        {peutCategoriesFamille && <button type="button" className="sc-btn" onClick={() => setCategorieOutilEdition({ ancien: c, valeur: c })} style={iconBtnStyle} title="Modifier">✎</button>}
                        {peutCategoriesFamille && <button type="button" className="sc-btn" onClick={() => supprimerCategorieOutil(c)} style={iconBtnStyle} title="Supprimer">✕</button>}
                      </>
                    )}
                  </div>
                );
              })}
            </div>
            {(() => {
              const attente = demandesCategoriesOutil().filter((x) => x.statut === "en attente");
              const miennes = demandesCategoriesOutil().filter((x) => x.par === user.nom).slice(-5).reverse();
              return peutCategoriesFamille ? (
                <>
                  {attente.length > 0 && (
                    <div style={{ background: "#F4ECD8", borderRadius: 8, padding: 10, marginBottom: 12 }}>
                      <div style={{ fontSize: 11, color: OCRE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 6 }}>Demandes à valider ({attente.length})</div>
                      {attente.map((d) => (
                        <div key={d.id} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, padding: "3px 0" }}>
                          <span style={{ flex: 1 }}><strong>{d.nom}</strong> <span style={{ fontSize: 11, color: TAUPE }}>— {d.par}, {formatDate(d.le.slice(0, 10))}</span></span>
                          <button type="button" className="sc-btn" onClick={() => traiterDemandeCategorieOutil(d.id, true)} style={{ ...primaryBtnStyle, fontSize: 12, padding: "4px 10px" }}>Créer</button>
                          <button type="button" className="sc-btn" onClick={() => traiterDemandeCategorieOutil(d.id, false)} style={{ ...ghostBtnStyle, fontSize: 12 }}>Refuser</button>
                        </div>
                      ))}
                    </div>
                  )}
                  <div style={{ display: "flex", gap: 8 }}>
                    <input className="sc-input" value={nouvelleCategorieOutil} onChange={(e) => setNouvelleCategorieOutil(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") ajouterCategorieOutil(); }} placeholder="Nouvelle catégorie" style={inputStyle("100%")} />
                    <button type="button" className="sc-btn" onClick={ajouterCategorieOutil} style={primaryBtnStyle}>Ajouter</button>
                  </div>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>✎ pour renommer : les outils concernés sont mis à jour. Une catégorie utilisée par un outil ne peut pas être supprimée. Le Production Manager et le bureau technique demandent les nouvelles catégories, tu les valides.</div>
                </>
              ) : (
                <>
                  <div style={{ display: "flex", gap: 8 }}>
                    <input className="sc-input" value={nouvelleCategorieOutil} onChange={(e) => setNouvelleCategorieOutil(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") demanderCategorieOutil(); }} placeholder="Catégorie à demander" style={inputStyle("100%")} />
                    <button type="button" className="sc-btn" onClick={demanderCategorieOutil} style={primaryBtnStyle}>Demander</button>
                  </div>
                  {miennes.length > 0 && <div style={{ fontSize: 12, marginTop: 8 }}>{miennes.map((d) => <div key={d.id}>{d.nom} — <span style={{ color: d.statut === "créée" ? VERT_OK : d.statut === "refusée" ? ROUILLE : OCRE }}>{d.statut === "en attente" ? "en attente du Gérant" : d.statut}</span></div>)}</div>}
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>Les nouvelles catégories sont validées par le Gérant (en attendant, choisis la catégorie la plus proche ; tu pourras la changer ensuite).</div>
                </>
              );
            })()}
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <button type="button" className="sc-btn" onClick={() => setShowCategoriesOutil(false)} style={ghostBtnStyle}>Fermer</button>
            </div>
          </div>
        </Overlay>
      )}

      {showDetenteursOutil && (
        <Overlay onClose={() => setShowDetenteursOutil(false)}>
          <div style={modalStyle(620)}>
            <div style={modalTitleStyle}>{familleVue === "bureautique" ? "Bureaux" : "Bureaux et machines"}</div>
            {blocMachinesBureaux(familleVue === "bureautique" ? ["bureau"] : ["machine", "bureau"])}
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <button type="button" className="sc-btn" onClick={() => setShowDetenteursOutil(false)} style={ghostBtnStyle}>Fermer</button>
            </div>
          </div>
        </Overlay>
      )}

      {outilEdit && (() => {
        const o = outilEdit;
        const nouveau = !o.id;
        const set = (patch) => setOutilEdit({ ...o, ...patch });
        const act = outilAction;
        const setAct = (patch) => setOutilAction({ ...act, ...patch });
        // ERP step 12 (Nils 30/09) : « Remis à » = tout le personnel actif de l'onglet Staff, puis les lieux et machines.
        const staffActifsIds = new Set((staff || []).filter((x) => staffActif(x) && !ficheStaffMasquee(x)).map((x) => x.id));
        const detenteursPossibles = [
          ...(affectations || []).filter((a) => a.type === "personne" && staffActifsIds.has(a.id)).sort((a, b) => a.nom.localeCompare(b.nom, "fr", { sensitivity: "base" })),
          ...(affectations || []).filter((a) => a.type === "bureau" && a.actif),
          ...(familleOutil(o) === "bureautique" ? [] : (affectations || []).filter((a) => a.type === "machine" && a.actif)),
        ];
        const typesCreables = typesAffectationGerables().filter((t) => t !== "service" && (familleOutil(o) !== "bureautique" || t === "bureau"));
        const optionsDetenteurs = (liste) => [
          ...[["personne", "Personnel (Staff)"], ["bureau", "Bureaux"], ["machine", "Machines"]].map(([t, lib]) => {
            const l = liste.filter((a) => a.type === t);
            return l.length ? <optgroup key={t} label={lib}>{l.map((a) => (<option key={a.id} value={a.id}>{iconeAffectation(a)}{a.nom}</option>))}</optgroup> : null;
          }),
          typesCreables.length ? <option key="__nouveau" value="__nouveau">{typesCreables.length > 1 ? "+ Ajouter un bureau / une machine…" : "+ Ajouter un bureau…"}</option> : null,
        ];
        // Nils 04/10 : création d'un bureau / d'une machine sans quitter la fiche ; il est choisi aussitôt.
        const formDetenteurRapide = (cible) => detenteurRapide && detenteurRapide.cible === cible && (
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginTop: 6, background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 8, padding: 8 }}>
            <input className="sc-input" autoFocus value={detenteurRapide.nom} onChange={(e) => setDetenteurRapide({ ...detenteurRapide, nom: e.target.value })} placeholder={detenteurRapide.type === "machine" ? "ex. Débiteuse 2" : "ex. Bureau Marrakech (Sidi Ghanem)"} style={{ ...inputStyle(240), padding: "5px 8px" }} />
            {typesCreables.length > 1 && (
              <select className="sc-select" value={detenteurRapide.type} onChange={(e) => setDetenteurRapide({ ...detenteurRapide, type: e.target.value })} style={{ ...selectStyle, width: 120 }}>
                {typesCreables.map((t) => <option key={t} value={t}>{t === "machine" ? "Machine" : "Bureau"}</option>)}
              </select>
            )}
            <button type="button" className="sc-btn" onClick={async () => { const id = await creerDetenteurRapide(detenteurRapide.nom, detenteurRapide.type); if (!id) return; if (cible === "nouveau") set({ detenteurId: id }); else setAct({ vers: id }); setDetenteurRapide(null); }} style={{ ...primaryBtnStyle, fontSize: 12, padding: "6px 12px" }}>Créer et choisir</button>
            <button type="button" className="sc-btn" onClick={() => setDetenteurRapide(null)} style={{ ...ghostBtnStyle, fontSize: 12 }}>Annuler</button>
          </div>
        );
        return (
          <Overlay onClose={() => { setOutilEdit(null); setOutilAction(null); setDetenteurRapide(null); }}>
            <div style={modalStyle(720)}>
              <div style={modalTitleStyle}>{nouveau ? (familleOutil(o) === "bureautique" ? "Nouveau matériel bureautique" : "Nouvel outil") : `${o.numero} — ${o.designation}`}</div>
              {!nouveau && <div style={{ fontSize: 13, color: TAUPE, marginTop: -8, marginBottom: 12 }}>État : <strong style={{ color: ENCRE }}>{o.etat}</strong> · Détenteur : <strong style={{ color: ENCRE }}>{o.detenteurId ? nomAffectation(o.detenteurId) : "—"}</strong>{peutVoirCoutsOutillage && coutReparationsOutil(o) ? ` · réparations : ${formatDH(coutReparationsOutil(o))}` : ""}</div>}
              <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr", gap: 12 }}>
                <Field label="Désignation"><input className="sc-input" value={o.designation || ""} onChange={(e) => set({ designation: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label="Catégorie">
                  <select className="sc-select" value={o.categorie || ""} onChange={(e) => set({ categorie: e.target.value })} style={selectStyle}>
                    {(categoriesOutil(familleOutil(o)).includes(o.categorie) || !o.categorie ? categoriesOutil(familleOutil(o)) : [...categoriesOutil(familleOutil(o)), o.categorie]).map((c) => (<option key={c} value={c}>{c}</option>))}
                  </select>
                </Field>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                <Field label="Marque"><input className="sc-input" value={o.marque || ""} onChange={(e) => set({ marque: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label="Modèle"><input className="sc-input" value={o.modele || ""} onChange={(e) => set({ modele: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label="N° de série"><input className="sc-input" value={o.serie || ""} onChange={(e) => set({ serie: e.target.value })} style={inputStyle("100%")} /></Field>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                <Field label="Date d'achat"><input type="date" className="sc-input" value={o.dateAchat || ""} onChange={(e) => set({ dateAchat: e.target.value })} style={inputStyle("100%")} /></Field>
                {peutVoirCoutsOutillage && <Field label="Prix d'achat HT (DH)"><input type="number" min="0" className="sc-input" value={o.prixAchatHT ?? ""} onChange={(e) => set({ prixAchatHT: e.target.value })} style={inputStyle("100%")} /></Field>}
                <Field label="Fournisseur"><input className="sc-input" value={o.fournisseur || ""} onChange={(e) => set({ fournisseur: e.target.value })} style={inputStyle("100%")} /></Field>
              </div>
              {nouveau && (
                <Field label="Remis à (détenteur)">
                  <select className="sc-select" value={o.detenteurId || ""} onChange={(e) => (e.target.value === "__nouveau" ? setDetenteurRapide({ cible: "nouveau", nom: "", type: typesCreables.includes("bureau") ? "bureau" : typesCreables[0] }) : set({ detenteurId: e.target.value }))} style={selectStyle}>
                    <option value="">— Aucun pour l'instant —</option>
                    {optionsDetenteurs(detenteursPossibles)}
                  </select>
                  {formDetenteurRapide("nouveau")}
                </Field>
              )}

              {!nouveau && (
                <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 12, marginBottom: 14 }}>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: act ? 10 : 0 }}>
                    {outilActif(o) && o.etat === "En service" && <button type="button" className="sc-btn" onClick={() => setOutilAction({ type: "transfert", vers: "", date: todayISO(), note: "" })} style={{ ...ghostBtnStyle, fontSize: 12 }}>⇄ Remettre à…</button>}
                    {outilActif(o) && <button type="button" className="sc-btn" onClick={() => setOutilAction({ type: "incident", incident: "", suite: "reparation", reparateur: "", imputeA: "", date: todayISO(), note: "" })} style={{ ...ghostBtnStyle, fontSize: 12, color: ROUILLE }}>⚠ Déclarer un incident</button>}
                    {o.etat === "En réparation" && <button type="button" className="sc-btn" onClick={() => setOutilAction({ type: "retour", cout: "", date: todayISO(), note: "" })} style={{ ...ghostBtnStyle, fontSize: 12 }}>↩ Retour de réparation</button>}
                    {o.etat === "En réparation" && <button type="button" className="sc-btn" onClick={() => setOutilAction({ type: "rebut", date: todayISO(), note: "" })} style={{ ...ghostBtnStyle, fontSize: 12 }}>Irréparable → hors service</button>}
                    {o.etat !== ETAT_SORTI_PARC && <button type="button" className="sc-btn" onClick={() => setOutilAction({ type: "sortie", motif: "", date: todayISO(), note: "" })} style={{ ...ghostBtnStyle, fontSize: 12, color: TAUPE }}>⊘ Sortir du parc</button>}
                    {o.detenteurId && (staff || []).some((x) => x.id === o.detenteurId) && outilActif(o) && <button type="button" className="sc-btn" onClick={() => imprimerRemiseOutils(o.detenteurId, [o.id])} style={{ ...ghostBtnStyle, fontSize: 12, marginLeft: "auto" }}>🖨 Bon de remise à signer</button>}
                  </div>
                  {act && (
                    <div style={{ background: PIERRE, borderRadius: 8, padding: 10 }}>
                      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
                        <input type="date" className="sc-input" value={act.date || ""} onChange={(e) => setAct({ date: e.target.value })} style={{ ...inputStyle(150), padding: "5px 8px" }} />
                        {act.type === "transfert" && (
                          <select className="sc-select" value={act.vers} onChange={(e) => (e.target.value === "__nouveau" ? setDetenteurRapide({ cible: "transfert", nom: "", type: typesCreables.includes("bureau") ? "bureau" : typesCreables[0] }) : setAct({ vers: e.target.value }))} style={{ ...selectStyle, width: 240 }}>
                            <option value="">— Remis à —</option>
                            {optionsDetenteurs(detenteursPossibles.filter((a) => a.id !== o.detenteurId))}
                          </select>
                        )}
                        {act.type === "incident" && (
                          <>
                            <select className="sc-select" value={act.incident} onChange={(e) => setAct({ incident: e.target.value })} style={{ ...selectStyle, width: 130 }}>
                              <option value="">— Incident —</option>
                              {TYPES_INCIDENT_OUTIL.map((x) => (<option key={x} value={x}>{x}</option>))}
                            </select>
                            {(act.incident === "Casse" || act.incident === "Panne") && (
                              <select className="sc-select" value={act.suite} onChange={(e) => setAct({ suite: e.target.value })} style={{ ...selectStyle, width: 190 }}>
                                <option value="reparation">Envoyé en réparation</option>
                                <option value="horsservice">Hors service (irréparable)</option>
                              </select>
                            )}
                            {act.suite === "reparation" && (act.incident === "Casse" || act.incident === "Panne") && <input className="sc-input" value={act.reparateur} onChange={(e) => setAct({ reparateur: e.target.value })} placeholder="Réparateur" style={{ ...inputStyle(150), padding: "5px 8px" }} />}
                            <select className="sc-select" value={act.imputeA} onChange={(e) => setAct({ imputeA: e.target.value })} style={{ ...selectStyle, width: 190 }} title="Facultatif : responsabilité d'une personne (négligence)">
                              <option value="">Imputé à : personne</option>
                              {(affectations || []).filter((a) => a.type === "personne").map((a) => (<option key={a.id} value={a.id}>{a.nom}</option>))}
                            </select>
                          </>
                        )}
                        {act.type === "transfert" && detenteurRapide && detenteurRapide.cible === "transfert" && <div style={{ width: "100%" }}>{formDetenteurRapide("transfert")}</div>}
                        {act.type === "sortie" && (
                          <select className="sc-select" value={act.motif} onChange={(e) => setAct({ motif: e.target.value })} style={{ ...selectStyle, width: 190 }}>
                            <option value="">— Motif —</option>
                            {MOTIFS_SORTIE_PARC.map((x) => (<option key={x} value={x}>{x}</option>))}
                          </select>
                        )}
                        {act.type === "sortie" && <span style={{ fontSize: 11, color: TAUPE }}>Définitif : l'objet quitte le registre actif{o.detenteurId ? ` et est retiré à ${nomAffectation(o.detenteurId)}` : ""}, son historique reste.</span>}
                        {act.type === "retour" && peutVoirCoutsOutillage && <input type="number" min="0" className="sc-input" value={act.cout} onChange={(e) => setAct({ cout: e.target.value })} placeholder="Coût réparation (DH)" style={{ ...inputStyle(170), padding: "5px 8px" }} />}
                      </div>
                      <input className="sc-input" value={act.note || ""} onChange={(e) => setAct({ note: e.target.value })} placeholder="Commentaire" style={{ ...inputStyle("100%"), padding: "5px 8px", marginTop: 8 }} />
                      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 8 }}>
                        <button type="button" className="sc-btn" onClick={() => setOutilAction(null)} style={{ ...ghostBtnStyle, fontSize: 12 }}>Annuler</button>
                        <button type="button" className="sc-btn" onClick={appliquerActionOutil} style={{ ...primaryBtnStyle, fontSize: 12, padding: "6px 14px" }}>Valider</button>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {!nouveau && (o.historique || []).length > 0 && (
                <div style={{ marginBottom: 12 }}>
                  <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Historique</div>
                  <div style={{ maxHeight: 180, overflowY: "auto" }}>
                    {(o.historique || []).slice().reverse().map((h) => (
                      <div key={h.id} style={{ fontSize: 12, padding: "3px 0", borderBottom: `1px solid ${PIERRE}` }}>
                        {formatDate(h.date)} — {h.type === "affectation" ? `remis à ${nomAffectation(h.vers)}${h.de ? ` (par ${nomAffectation(h.de)})` : ""}` : h.type === "incident" ? `${h.incident} (détenteur : ${nomAffectation(h.detenteur)}) → ${h.suite}${h.reparateur ? ` chez ${h.reparateur}` : ""}${h.imputeA ? ` — imputé à ${nomAffectation(h.imputeA)}` : ""}` : h.type === "retour réparation" ? `retour de réparation${peutVoirCoutsOutillage && h.cout !== "" && h.cout !== undefined ? ` — ${formatDH(Number(h.cout) || 0)}` : ""}` : h.type === "sortie" ? `sorti du parc — ${h.motif}${h.detenteur ? ` (repris à ${nomAffectation(h.detenteur)})` : ""}` : "mis hors service"}
                        {h.note ? <span style={{ color: TAUPE }}> — {h.note}</span> : null}<span style={{ color: TAUPE }}> · {h.par}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                {!nouveau && outilSupprimable(o) && <button type="button" className="sc-btn" onClick={() => supprimerOutil(o)} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }} title="Erreur de saisie : jamais remis ni réparé">✕ Supprimer</button>}
                <button type="button" className="sc-btn" onClick={() => { setOutilEdit(null); setOutilAction(null); setDetenteurRapide(null); }} style={ghostBtnStyle}>Fermer</button>
                <button type="button" className="sc-btn" onClick={enregistrerOutil} style={primaryBtnStyle}>{nouveau ? (familleOutil(o) === "bureautique" ? "Créer le matériel" : "Créer l'outil") : "Enregistrer"}</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {/* ERP step 12 (validé Nils du 30/09) : onglet Comptabilité — trésorerie */}
      {questionOp && activeTab === "compta" && (() => {
        const o = (operations || []).find((x) => x.id === questionOp.opId);
        if (!o) return null;
        const c = compteDe(o.compteId) || {};
        const estResp = (c.responsables || []).includes(user.id);
        const fermer = () => setQuestionOp(null);
        const titre = questionOp.mode === "question" ? "Demander une précision" : questionOp.mode === "signal" ? "Signaler une dépense" : "Précisions et signalement";
        return (
          <Overlay onClose={fermer}>
            <div style={modalStyle(560)}>
              <div style={modalTitleStyle}>{titre}</div>
              <div style={{ fontSize: 13, background: PIERRE, borderRadius: 8, padding: "8px 12px", marginBottom: 12 }}>
                <strong>{c.nom}</strong> — {formatDate(o.date)} — {o.designation} — <strong>{formatDH(Number(o.montant) || 0)}</strong> ({o.sens === "entree" ? "entrée" : "sortie"}){o.poste ? ` · ${o.poste}${o.sousPoste ? " › " + o.sousPoste : ""}` : ""}
              </div>
              {o.signale && (
                <div style={{ fontSize: 13, border: `1px solid ${o.signale.leve ? PIERRE : ROUILLE}`, borderRadius: 8, padding: "8px 12px", marginBottom: 10 }}>
                  ⚑ Signalée par {o.signale.par} le {formatDate(o.signale.le.slice(0, 10))} : « {o.signale.motif} »{o.signale.leve ? ` — levé par ${o.signale.levePar} le ${formatDate(o.signale.leve.slice(0, 10))}` : ""}
                  {!o.signale.leve && peut("compta.questionner") && <button type="button" className="sc-btn" onClick={() => leverSignalementOp(o.id)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 10px", marginLeft: 8 }}>Lever le signalement</button>}
                </div>
              )}
              {(o.questions || []).map((q) => (
                <div key={q.id} style={{ fontSize: 13, borderLeft: `3px solid ${q.reponse ? VERT_OK : OCRE}`, padding: "4px 10px", marginBottom: 10 }}>
                  <div><strong>{q.parNom}</strong> <span style={{ color: TAUPE, fontSize: 11 }}>{formatDate(q.le.slice(0, 10))}</span> : {q.texte}</div>
                  {q.reponse ? (
                    <div style={{ marginTop: 4 }}><strong>{q.reponduPar}</strong> <span style={{ color: TAUPE, fontSize: 11 }}>{formatDate(q.reponduLe.slice(0, 10))}</span> : {q.reponse}
                      {q.par === user.id && !q.lu && <button type="button" className="sc-btn" onClick={() => marquerLuQuestionOp(o.id, q.id)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 10px", marginLeft: 8 }}>✓ Lu</button>}
                    </div>
                  ) : (estResp || estGerant) && q.par !== user.id ? (
                    <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
                      <input className="sc-input" value={(questionOp.rep || {})[q.id] || ""} onChange={(e) => setQuestionOp({ ...questionOp, rep: { ...(questionOp.rep || {}), [q.id]: e.target.value } })} placeholder="Ta réponse" style={inputStyle("100%")} />
                      <button type="button" className="sc-btn" onClick={async () => { if (await repondreQuestionOp(o.id, q.id, (questionOp.rep || {})[q.id])) setQuestionOp({ ...questionOp, rep: { ...(questionOp.rep || {}), [q.id]: "" } }); }} style={primaryBtnStyle}>Répondre</button>
                    </div>
                  ) : <div style={{ fontSize: 12, color: OCRE, marginTop: 2 }}>En attente de réponse de {(c.responsables || []).map((id) => nomUtilisateur(id)).filter(Boolean).join(", ") || "Administration"}</div>}
                </div>
              ))}
              {(questionOp.mode === "question" || questionOp.mode === "signal") && (
                <Field label={questionOp.mode === "question" ? "Ta question (envoyée en tâche au responsable de la caisse)" : "Ce qui te semble anormal"}>
                  <textarea className="sc-input" rows={3} value={questionOp.texte} onChange={(e) => setQuestionOp({ ...questionOp, texte: e.target.value })} style={{ ...inputStyle("100%"), resize: "vertical" }} />
                </Field>
              )}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                <button type="button" className="sc-btn" onClick={fermer} style={ghostBtnStyle}>Fermer</button>
                {questionOp.mode === "question" && <button type="button" className="sc-btn" onClick={async () => { if (await poserQuestionOp(o.id, questionOp.texte)) fermer(); }} style={primaryBtnStyle}>Envoyer la question</button>}
                {questionOp.mode === "signal" && <button type="button" className="sc-btn" onClick={async () => { if (await signalerOp(o.id, questionOp.texte)) fermer(); }} style={{ ...primaryBtnStyle, background: ROUILLE }}>⚑ Signaler</button>}
              </div>
            </div>
          </Overlay>
        );
      })()}
      {activeTab === "commissions" && estGerant && renderCommissions(true)}
      {activeTab === "transportIntl" && peut("achats.transportIntl") && rendreTransportIntl()}
      {activeTab === "transportIntl" && peut("achats.transportIntl") && rendreModaleTransport()}
      {activeTab === "facturesF" && peutSaisirFactureF && (
        <div>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, fontWeight: 600, marginBottom: 14 }}>Factures fournisseurs & échéancier</div>
          {rendreEcheancier()}
        </div>
      )}
      {activeTab === "compta" && (() => {
        const compte = comptesVisibles.find((c) => c.id === compteActif) || comptesVisibles[0];
        if (!compte) return peutSaisirFactureF ? rendreEcheancier() : <div style={{ fontSize: 13, color: TAUPE }}>Aucun compte de trésorerie ne t'est attribué.</div>;
        const saisie = peutSaisirCompte(compte);
        const debutMois = `${moisTreso}-01`;
        const ordre = (a, b) => (a.date === b.date ? ((a.le || "") < (b.le || "") ? -1 : 1) : a.date < b.date ? -1 : 1);
        const aTraiter = (o) => !o.miroirDe && (o.poste === POSTE_A_DEFINIR || (o.poste === POSTE_ENCAISSEMENT && !o.dossierId)) || (o.type === "transfert" && o.sens === "entree" && o.statutTransfert === "en attente") || aRapprocher(o);
        const mouvementsARapprocher = peut("compta.rapprochementCaisses") ? (operations || []).filter(aRapprocher).slice().sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0)) : [];
        const modeRapprochement = filtreTreso === "rapprocher" && peut("compta.rapprochementCaisses");
        const peutTVA = peut("compta.tva");
        const modeTVA = filtreTreso === "tva" && peutTVA;
        const modeEch = filtreTreso === "echeancier" && peutSaisirFactureF;
        const modeRappro = filtreTreso === "rapprochement" && compte.type === "banque" && saisie;
        let blocRappro = null;
        if (modeRappro) {
          // Nils 03/10 : pointage du relevé CFG — chaque opération saisie est confirmée (date, montant) ;
          // celles qui ne sont pas encore passées restent en attente et se reportent au relevé suivant.
          const rp = rappro && rappro.compteId === compte.id ? rappro : { compteId: compte.id, du: `${moisTreso}-01`, au: (() => { const fin = new Date(Date.UTC(Number(moisTreso.slice(0, 4)), Number(moisTreso.slice(5, 7)), 0)).toISOString().slice(0, 10); return fin > todayISO() ? todayISO() : fin; })(), solde: null };
          const setRp = (patch) => setRappro({ ...rp, ...patch });
          const r = calculRapprochement(compte.id, rp.du, rp.au);
          const sb = soldeBanqueAu(compte.id, rp.au);
          const ecartReleve = r.releve ? arrondiH(Number(r.releve.solde) - sb) : null;
          const tri = (a, b) => (a.date === b.date ? ((a.le || "") < (b.le || "") ? -1 : 1) : a.date < b.date ? -1 : 1);
          const attente = (operations || []).filter((o) => o.compteId === compte.id && opCompte(o) && o.date <= rp.au && (!o.releveLe || o.releveLe > rp.au)).sort(tri);
          const passees = (operations || []).filter((o) => o.compteId === compte.id && opCompte(o) && o.releveLe && o.releveLe >= rp.du && o.releveLe <= rp.au).sort((a, b) => (a.releveLe < b.releveLe ? -1 : a.releveLe > b.releveLe ? 1 : tri(a, b)));
          const net = (l) => arrondiH(l.reduce((n, o) => n + montantEffectif(o), 0));
          const ps = (o) => pointSaisie[o.id] || { date: o.date < rp.du ? rp.du : o.date > rp.au ? rp.au : o.date, montant: "" };
          const setPs = (o, patch) => setPointSaisie({ ...pointSaisie, [o.id]: { ...ps(o), ...patch } });
          const tag = (o) => [o.extourneDe ? "extourne" : "", o.rejete ? `rejeté${o.rejete.motif ? " : " + o.rejete.motif : ""}` : ""].filter(Boolean).join(" · ");
          const g = "0.75fr 0.45fr 2fr 0.9fr 0.9fr 1.1fr 1fr 1.3fr";
          const ligneRes = (lib, val, gras, couleur) => (<div style={{ display: "flex", justifyContent: "space-between", gap: 10, padding: "4px 0", borderBottom: `1px solid ${PIERRE}`, fontWeight: gras ? 600 : 400, color: couleur || ENCRE }}><span>{lib}</span><span style={{ whiteSpace: "nowrap" }}>{val}</span></div>);
          blocRappro = (
            <div>
              <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 12, fontSize: 13 }}>
                <span>Relevé du</span><input type="date" className="sc-input" value={rp.du} onChange={(e) => e.target.value && setRp({ du: e.target.value })} style={{ ...inputStyle(150), padding: "5px 8px" }} />
                <span>au</span><input type="date" className="sc-input" max={todayISO()} value={rp.au} onChange={(e) => e.target.value && setRp({ au: e.target.value, solde: null })} style={{ ...inputStyle(150), padding: "5px 8px" }} />
                <span style={{ marginLeft: 10 }}>Solde du relevé au {formatDate(rp.au)}</span>
                <input type="text" inputMode="decimal" className="sc-input" value={rp.solde != null ? rp.solde : r.releve ? String(r.releve.solde).replace(".", ",") : ""} onChange={(e) => setRp({ solde: e.target.value })} onKeyDown={async (e) => { if (e.key === "Enter") { const ok = await enregistrerSoldeReleve(compte.id, rp.au, rp.solde != null ? rp.solde : r.releve ? r.releve.solde : ""); if (ok !== false) setRp({ solde: null }); } }} placeholder="solde du relevé" style={{ ...inputStyle(150), padding: "5px 8px", background: "#fff", border: `1px solid ${TAUPE}` }} />
                <button type="button" className="sc-btn" onClick={async () => { const ok = await enregistrerSoldeReleve(compte.id, rp.au, rp.solde != null ? rp.solde : r.releve ? r.releve.solde : ""); if (ok !== false) setRp({ solde: null }); }} style={{ ...ghostBtnStyle, fontSize: 12 }}>Enregistrer le solde</button>
                <button type="button" className="sc-btn" onClick={() => setOpEdit({ ...nouvelleOperation(compte.id, "sortie"), date: rp.au, releveLe: rp.au, pointePar: user.nom, tiersType: "banque", tiers: compte.nom, poste: "Frais de fonctionnement", sousPoste: "Frais bancaires", mode: "Prélèvement", designation: "Frais bancaires" })} style={{ ...ghostBtnStyle, fontSize: 12 }}>+ Opération du relevé (frais, agios…)</button>
                <button type="button" className="sc-btn" onClick={() => imprimerRapprochement(compte.id, rp.du, rp.au)} style={{ ...primaryBtnStyle, fontSize: 12, padding: "6px 14px", marginLeft: "auto" }}>🖨 Imprimer</button>
              </div>
              <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 14 }}>
                <div style={{ border: `1px solid ${ecartReleve !== null && Math.abs(ecartReleve) > 0.01 ? ROUILLE : PIERRE}`, borderRadius: 10, padding: "10px 16px", fontSize: 13, minWidth: 340 }}>
                  {ligneRes(`Solde banque d'après l'ERP au ${formatDate(rp.au)} (opérations pointées)`, formatDH(sb), true)}
                  {ligneRes("Solde du relevé", r.releve ? formatDH(Number(r.releve.solde)) : "non saisi")}
                  {ligneRes("Écart", ecartReleve === null ? "—" : formatDH(ecartReleve), true, ecartReleve === null ? TAUPE : Math.abs(ecartReleve) <= 0.01 ? VERT_OK : ROUILLE)}
                </div>
                <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: "10px 16px", fontSize: 13, minWidth: 300 }}>
                  {ligneRes(`En attente de passage (${attente.length})`, formatDH(net(attente)))}
                  {ligneRes("Solde prévisionnel (tout ce qui est saisi)", formatDH(soldeCompteAu(compte.id, decalerJours(rp.au, 1))), true)}
                </div>
              </div>
              <div style={{ fontSize: 12, fontWeight: 600, margin: "4px 0 6px" }}>En attente de passage — à pointer quand l'opération figure sur le relevé ({attente.length})</div>
              <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden", marginBottom: 16 }}>
                <div style={{ display: "grid", gridTemplateColumns: g, padding: "8px 14px", background: PIERRE, gap: 8 }}>
                  <Th>Saisie le</Th><Th>Âge</Th><Th>Désignation</Th><Th>Débit</Th><Th>Crédit</Th><Th>Passée le</Th><Th>Montant relevé</Th><Th></Th>
                </div>
                {attente.length === 0 && <div style={{ padding: 14, fontSize: 13, color: TAUPE }}>Rien en attente.</div>}
                {attente.map((o) => {
                  const age = Math.round(ecartJours(todayISO(), o.date));
                  const x = ps(o);
                  return (
                    <div key={o.id} style={{ display: "grid", gridTemplateColumns: g, padding: "6px 14px", gap: 8, alignItems: "center", borderBottom: `1px solid ${PIERRE}`, fontSize: 13, background: age > JOURS_ALERTE_NON_PASSEE ? "#FBEDE7" : "#FBF6EC" }}>
                      <div>{formatDate(o.date)}</div>
                      <div style={{ color: age > JOURS_ALERTE_NON_PASSEE ? ROUILLE : TAUPE, fontWeight: age > JOURS_ALERTE_NON_PASSEE ? 600 : 400 }}>{age} j</div>
                      <div>{o.designation}<div style={{ fontSize: 11, color: TAUPE }}>{[o.tiers, o.mode, o.piece ? `réf. ${o.piece}` : "", tag(o)].filter(Boolean).join(" · ")}</div></div>
                      <div style={{ color: ROUILLE }}>{o.sens === "sortie" ? formatDH(Math.abs(montantEffectif(o))) : ""}</div>
                      <div style={{ color: VERT_OK }}>{o.sens === "entree" ? formatDH(Math.abs(montantEffectif(o))) : ""}</div>
                      <div><input type="date" className="sc-input" value={x.date} onChange={(e) => setPs(o, { date: e.target.value })} style={{ ...inputStyle(140), padding: "3px 6px", fontSize: 12, background: "#fff" }} /></div>
                      <div><input className="sc-input" inputMode="decimal" value={x.montant} placeholder={String(o.montant).replace(".", ",")} onChange={(e) => setPs(o, { montant: e.target.value })} style={{ ...inputStyle(110), padding: "3px 6px", fontSize: 12, background: "#fff" }} title="À remplir seulement si le relevé montre un autre montant" /></div>
                      <div style={{ display: "flex", gap: 6 }}>
                        {saisie && <button type="button" className="sc-btn" onClick={async () => { if (!x.date) return; const ok = await pointerOperation(o.id, x.date, x.montant); if (ok) { const n = { ...pointSaisie }; delete n[o.id]; setPointSaisie(n); } }} style={{ ...primaryBtnStyle, fontSize: 12, padding: "4px 10px" }} title="Figure sur le relevé">✓ Passée</button>}
                        {saisie && !o.rejete && !o.extourneDe && <button type="button" className="sc-btn" onClick={() => rejeterOperation(o.id)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 6px", color: ROUILLE }}>Rejeté</button>}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div style={{ fontSize: 12, fontWeight: 600, margin: "4px 0 6px" }}>Passées sur ce relevé ({passees.length})</div>
              <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden", marginBottom: 10 }}>
                {passees.length === 0 && <div style={{ padding: 14, fontSize: 13, color: TAUPE }}>Aucune opération pointée sur cette période.</div>}
                {passees.map((o) => (
                  <div key={o.id} style={{ display: "grid", gridTemplateColumns: "0.75fr 0.75fr 2.4fr 0.9fr 0.9fr 1.3fr", padding: "6px 14px", gap: 8, alignItems: "center", borderBottom: `1px solid ${PIERRE}`, fontSize: 13 }}>
                    <div>{formatDate(o.releveLe)}</div>
                    <div style={{ color: TAUPE, fontSize: 12 }}>saisie {formatDate(o.date)}</div>
                    <div>{o.designation}<div style={{ fontSize: 11, color: TAUPE }}>{[o.tiers, o.mode, o.piece ? `réf. ${o.piece}` : "", o.montantSaisi !== undefined ? `montant saisi ${formatDH(o.montantSaisi)}, corrigé au pointage` : "", tag(o), o.pointePar ? `pointé par ${o.pointePar}` : ""].filter(Boolean).join(" · ")}</div></div>
                    <div style={{ color: ROUILLE }}>{o.sens === "sortie" ? formatDH(Math.abs(montantEffectif(o))) : ""}</div>
                    <div style={{ color: VERT_OK }}>{o.sens === "entree" ? formatDH(Math.abs(montantEffectif(o))) : ""}</div>
                    <div style={{ display: "flex", gap: 6 }}>
                      {saisie && <button type="button" className="sc-btn" onClick={() => pointerOperation(o.id, "")} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 6px" }} title="Annuler le pointage">↺</button>}
                      {saisie && o.sens === "entree" && !o.rejete && !o.extourneDe && <button type="button" className="sc-btn" onClick={() => rejeterOperation(o.id)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 6px", color: ROUILLE }}>Rejeté</button>}
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ fontSize: 11, color: TAUPE, lineHeight: 1.6 }}>À réception du relevé : « ✓ Passée » pour chaque opération qui y figure (date de passage, et montant seulement s'il diffère — le Gérant est alerté). Ce qui n'y figure pas encore (prélèvement pas fait, effet reporté, virement pas arrivé) reste en attente et passe au relevé suivant ; au-delà de {JOURS_ALERTE_NON_PASSEE} jours, alerte et tâche. Frais et opérations découverts sur le relevé : « + Opération du relevé ». Un chèque ou effet impayé : « Rejeté » crée l'extourne (la facture redevient due). Seules les opérations pointées entrent dans le fichier TVA.</div>
            </div>
          );
        }
        let blocTVA = null;
        if (modeTVA) {
          const opsMois = opsPourTVA().filter((o) => (o.date || "").slice(0, 7) === moisTreso);
          const achats = opsMois.filter((o) => o.sens === "sortie" && (o.factureFournisseur || (o.reglements || []).length)).flatMap(lignesTVAAchat);
          const encs = opsMois.filter((o) => o.poste === POSTE_ENCAISSEMENT).flatMap(lignesTVAEncaissement);
          const nbExo = opsMois.filter((o) => o.poste === POSTE_ENCAISSEMENT).flatMap(partsDossiers).filter((x) => { const c = dossierParId(x.dossierId); return c && tvaDossier(c).exo; }).length;
          const controles = [];
          opsMois.forEach((o) => {
            const cpt = (compteDe(o.compteId) || {}).nom;
            const lib = `${cpt} — ${formatDate(o.date)} — ${formatDH(Number(o.montant))} — ${o.designation}`;
            if (o.sens === "sortie" && o.type === "normal" && !o.factureFournisseur && !(o.reglements || []).length && !POSTES_SANS_FACTURE.includes(o.poste)) controles.push({ o, niveau: "info", texte: `Sortie sans facture fournisseur : ${lib}` });
            (o.reglements || []).forEach((r) => {
              const fa = (facturesF || []).find((x) => x.id === r.factureId);
              if (!fa) return;
              if (fa.type === "devis") controles.push({ o, niveau: "info", texte: `Acompte sur devis / proforma (pas encore de facture, non repris) : ${fa.fournisseur} — ${lib}` });
              else {
                if (fa.controle === "à contrôler") controles.push({ o, niveau: "alerte", texte: `Facture pas encore contrôlée par l'Administration : ${fa.fournisseur} ${fa.numero}` });
                const fo = fournisseurParNom(fa.fournisseur);
                if (!fa.douane && fa.tiersType === "fournisseur" && (!fo || !fo.ice)) controles.push({ o, niveau: "alerte", texte: `ICE manquant : ${fa.fournisseur}` });
                else if (!fa.douane && fo && fo.ice && !iceValide(fo.ice)) controles.push({ o, niveau: "alerte", texte: `ICE à vérifier (pas 15 chiffres) : ${fa.fournisseur} — ${fo.ice}` });
              }
            });
            if (o.factureFournisseur) {
              const ff = o.factureFournisseur;
              if (!ff.date) controles.push({ o, niveau: "alerte", texte: `Facture sans date : ${ff.fournisseur} — ${lib}` });
              if (!ff.numero) controles.push({ o, niveau: "alerte", texte: `Facture sans numéro : ${ff.fournisseur} — ${lib}` });
              const fo = fournisseurParNom(ff.fournisseur);
              if (ff.douane) { /* pas d'ICE pour une quittance de douane */ } else if (!fo || !fo.ice) controles.push({ o, niveau: "alerte", texte: `ICE manquant : ${ff.fournisseur}` });
              else if (!iceValide(fo.ice)) controles.push({ o, niveau: "alerte", texte: `ICE à vérifier (pas 15 chiffres) : ${ff.fournisseur} — ${fo.ice}` });
              const lg = lignesTVAAchat(o), tot = lg.reduce((n, l) => n + l.ttc, 0);
              if (tot && Math.abs(tot - Number(o.montant)) > 0.01) controles.push({ o, niveau: "info", texte: `Paiement partiel ou différent de la facture (${formatDH(Number(o.montant))} pour ${formatDH(tot)}) : ${ff.fournisseur}` });
            }
            if (o.poste === POSTE_ENCAISSEMENT && !o.dossierId) controles.push({ o, niveau: "alerte", texte: `Encaissement non relié à une facture : ${lib}` });
            if (o.poste === POSTE_A_DEFINIR) controles.push({ o, niveau: "alerte", texte: `Opération « À définir » : ${lib}` });
          });
          const vus = new Set();
          const ctrl = controles.filter((c) => { const k = c.texte; if (vus.has(k)) return false; vus.add(k); return true; }).sort((a, b) => (a.niveau === b.niveau ? 0 : a.niveau === "alerte" ? -1 : 1));
          const tvaDed = achats.reduce((n, l) => n + l.tva, 0), tvaCol = encs.reduce((n, l) => n + l.tva, 0);
          const tableau = (titre, entetes, lignes, grilleT) => (
            <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden", marginBottom: 14 }}>
              <div style={{ padding: "8px 16px", background: PIERRE, fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>{titre}</div>
              <div style={{ display: "grid", gridTemplateColumns: grilleT, gap: 8, padding: "6px 16px", fontSize: 11, color: TAUPE, borderBottom: `1px solid ${PIERRE}` }}>{entetes.map((e) => (<div key={e}>{e}</div>))}</div>
              {lignes.length === 0 && <div style={{ padding: "10px 16px", fontSize: 12, color: TAUPE }}>Aucune ligne.</div>}
              {lignes.map((cells, i) => (
                <div key={i} className="sc-row" onClick={() => { const o = (operations || []).find((x) => x.id === cells.opId); if (o && peutSaisirCompte(compteDe(o.compteId))) setOpEdit({ ...o }); }} style={{ display: "grid", gridTemplateColumns: grilleT, gap: 8, padding: "6px 16px", fontSize: 12, borderBottom: `1px solid ${PIERRE}`, cursor: "pointer" }}>{cells.v.map((c, j) => (<div key={j}>{c}</div>))}</div>
              ))}
            </div>
          );
          blocTVA = (
            <div>
              <div style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "center", marginBottom: 14, fontSize: 13 }}>
                <span>TVA déductible (achats payés) : <strong>{formatDH(tvaDed)}</strong></span>
                <span>TVA collectée (encaissements) : <strong>{formatDH(tvaCol)}</strong></span>
                <span>Écart : <strong style={{ color: tvaCol - tvaDed > 0 ? ROUILLE : VERT_OK }}>{formatDH(tvaCol - tvaDed)}</strong></span>
                <span style={{ fontSize: 11, color: TAUPE }}>indicatif — le calcul officiel reste celui du comptable</span>
                <button type="button" className="sc-btn" onClick={() => exporterFichierTVA(moisTreso)} style={{ ...primaryBtnStyle, fontSize: 12, padding: "6px 14px", marginLeft: "auto" }}>⬇ Fichier du comptable (Excel)</button>
                {peutEcrireFour && (
                  <>
                    <input ref={importFournisseursRef} type="file" accept=".xlsx,.xls,.ods" style={{ display: "none" }} onChange={(e) => { const fi = e.target.files && e.target.files[0]; e.target.value = ""; importerFournisseursComptable(fi); }} />
                    <button type="button" className="sc-btn" onClick={() => importFournisseursRef.current && importFournisseursRef.current.click()} style={{ ...ghostBtnStyle, fontSize: 12 }}>⬆ Liste fournisseurs du comptable</button>
                  </>
                )}
              </div>
              <div style={{ border: `1px solid ${ctrl.some((c) => c.niveau === "alerte") ? OCRE : PIERRE}`, borderRadius: 10, padding: "10px 16px", marginBottom: 14 }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Contrôle avant envoi ({ctrl.length})</div>
                {ctrl.length === 0 && <div style={{ fontSize: 12, color: VERT_OK }}>Rien à signaler.</div>}
                {ctrl.map((c, i) => (
                  <div key={i} className="sc-row" onClick={() => { if (peutSaisirCompte(compteDe(c.o.compteId))) setOpEdit({ ...c.o }); }} style={{ fontSize: 12, padding: "3px 0", cursor: "pointer", color: c.niveau === "alerte" ? ROUILLE : TAUPE }}>{c.niveau === "alerte" ? "⚠ " : "· "}{c.texte}</div>
                ))}
                {nbExo > 0 && <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>{nbExo} encaissement(s) de ventes exo (BLS) non repris dans le fichier.</div>}
              </div>
              {tableau(`Achats — ${MOIS_COMPTABLE[Number(moisTreso.slice(5, 7)) - 1]}-${moisTreso.slice(0, 4)} (mois du paiement)`, ["Date fact.", "Fournisseur", "N°", "Désignation", "Taux", "HT", "TVA", "TTC", "Réglé", "Mode"], achats.map((l) => ({ opId: l.opId, v: [l.date ? formatDate(l.date) : <span style={{ color: ROUILLE }}>—</span>, l.fournisseur, l.numero || <span style={{ color: ROUILLE }}>—</span>, l.designation, `${Math.round(l.taux * 100)} %`, formatDH(l.ht), formatDH(l.tva), formatDH(l.ttc), formatDH(l.regle), l.mode] })), "0.8fr 1.4fr 1fr 1.2fr 0.5fr 0.9fr 0.8fr 0.9fr 0.9fr 0.8fr")}
              {tableau("Encaissements", ["Date", "Client", "N° facture", "Relevé", "TTC", "TVA", "HT", "Mode"], encs.map((l) => ({ opId: l.opId, v: [formatDate(l.date), l.client, l.numero, l.releve === "" ? "" : formatDH(l.releve), formatDH(l.ttc), formatDH(l.tva), formatDH(l.ht), l.mode] })), "0.8fr 1.5fr 1.2fr 1fr 1fr 0.9fr 1fr 0.8fr")}
              <div style={{ fontSize: 11, color: TAUPE, lineHeight: 1.6 }}>Tous les comptes (caisses + CFG). Achats : chaque sortie avec « Facture fournisseur », une ligne par taux, au mois du paiement ; douane : la TVA de la quittance telle quelle (ligne à 20 % dont la TVA est exactement ce montant), le reste du paiement en droits à 0 %. Encaissements : TVA réelle de chaque facture (0 pour les ventes exo, exclues) ; une avance sur BC apparaît « Avance BC-… ». Onglet « LISTE FOURNISSEUR » : fournisseurs des factures de l'année avec leur ICE.</div>
            </div>
          );
        }
        const estPF = compte.id === PORTEFEUILLE_ID;
        const opsCompte = (operations || []).filter((o) => o.compteId === compte.id && (!estPF || estGerant || user.profil === P_ADMIN || detenteurCheque(o) === user.id || (o.detenteurPropose && o.detenteurPropose.id === user.id)));
        // Nils 26/10 : filtres (a à g).
        const FC = filtresCaisse && filtresCaisse.compteId === compte.id ? filtresCaisse : { compteId: compte.id, q: "", poste: "", sousPoste: "", sens: "", periode: "mois", du: "", au: "", annee: moisTreso.slice(0, 4) };
        const setFC = (patch) => setFiltresCaisse({ ...FC, ...patch });
        const parMois = FC.periode === "mois";
        const [debutP, finP] = parMois ? [debutMois, `${moisTreso}-31`] : FC.periode === "annee" ? [`${FC.annee}-01-01`, `${FC.annee}-12-31`] : [FC.du || "0000-00-00", FC.au || "9999-12-31"];
        const filtreContenu = !!(FC.q.trim() || FC.poste || FC.sens);
        const filtreActif = filtreContenu || !parMois;
        const qN = normLib(FC.q.trim());
        const texteOp = (o) => normLib([o.designation, o.tiers, o.piece, o.poste, o.sousPoste, o.typePrime, String(o.montant ?? ""), ...partsDossiers(o).map((x) => { const d = dossierParId(x.dossierId); return d ? libDossierTreso(d) : ""; })].filter(Boolean).join(" "));
        const passeFiltre = (o) => (!qN || texteOp(o).includes(qN)) && (!FC.poste || o.poste === FC.poste) && (!FC.sousPoste || o.sousPoste === FC.sousPoste) && (!FC.sens || o.sens === FC.sens);
        // Portefeuille : tous les chèques encore en main (quelle que soit leur date) + ceux du mois.
        const liste = (filtreTreso === "atraiter" ? opsCompte.filter(aTraiter) : opsCompte.filter((o) => ((o.date || "") >= debutP && (o.date || "") <= finP) || (parMois && estPF && !o.chequeRemisLe && !o.impaye && !o.extourneDe))).filter(passeFiltre).slice().sort(ordre);
        // Solde courant seulement sans filtre de contenu (une liste filtrée n'a pas de solde qui ait un sens).
        const soldeDebut = filtreTreso === "atraiter" || estPF || filtreContenu ? null : soldeCompteVue(compte.id, debutP);
        let courant = soldeDebut;
        const lignes = liste.map((o) => {
          const compteDansSolde = opCompte(o);
          if (courant !== null && compteDansSolde) courant += montantVue(o, compte);
          return { o, solde: courant, compteDansSolde };
        });
        const entrees = liste.filter((o) => o.sens === "entree" && opCompte(o)).reduce((n, o) => n + Math.abs(montantVue(o, compte)), 0);
        const sorties = liste.filter((o) => o.sens === "sortie").reduce((n, o) => n + Math.abs(montantVue(o, compte)), 0);
        const receptions = opsCompte.filter((o) => o.type === "transfert" && o.sens === "entree" && o.statutTransfert === "en attente");
        const envoisEnAttente = (operations || []).filter((o) => o.type === "transfert" && o.sens === "entree" && o.statutTransfert === "en attente" && o.contrepartieId === compte.id);
        const nbATraiter = opsCompte.filter(aTraiter).length;
        const soldeActuel = soldeCompteVue(compte.id);
        const exporterTreso = async () => {
          const c = (x) => `"${String(x ?? "").replace(/"/g, '""')}"`;
          const n2 = (x) => (x ? String(Number(x).toFixed(2)).replace(".", ",") : "");
          const rows = [["Date", "Tiers", "Désignation", "Poste", "Sous-poste", "Dossier", "Mode", "Pièce", "Entrée", "Sortie", "Solde", "Saisi par"].map(c).join(";")];
          lignes.forEach(({ o, solde, compteDansSolde }) => {
            const d = o.dossierId ? dossierParId(o.dossierId) : null;
            rows.push([o.date, o.tiers, o.designation, o.poste, o.sousPoste, d ? libDossierTreso(d) : "", o.mode, o.piece, o.sens === "entree" ? n2(Math.abs(montantEffectif(o)) || o.montant) : "", o.sens === "sortie" ? n2(o.montant) : "", compteDansSolde && solde !== null ? n2(solde) : "", o.par].map(c).join(";"));
          });
          await proposerTelechargement(`${compte.id}-${filtreTreso === "atraiter" ? "a-traiter" : parMois ? moisTreso : FC.periode === "annee" ? FC.annee : `${FC.du || "debut"}_${FC.au || "fin"}`}${filtreContenu ? "-filtre" : ""}.csv`, "﻿" + rows.join("\r\n"));
        };
        const grille = "0.8fr 2.2fr 1.6fr 1.3fr 0.9fr 0.9fr 1fr";
        // ---- Modes du bas de page (Nils 01/10) ----
        const modeCloture = filtreTreso === "cloture" && saisie;
        const modeDash = filtreTreso === "dashboard" && peut("compta.tableauBord");
        const modePrev = filtreTreso === "previsions" && peut("compta.previsions");
        const modeRec = filtreTreso === "recurrentes" && peut("compta.previsions");
        const modeSpecial = modeTVA || modeEch || modeRappro || modeCloture || modeDash || modePrev || modeRec;
        const titreModeSpecial = modeTVA ? "TVA du mois — fichier du comptable" : modeEch ? "Factures fournisseurs & échéancier" : modeRappro ? `Pointage du relevé — ${compte.nom}` : modeCloture ? `Clôture du mois — ${compte.nom}` : modeDash ? "Tableau de bord trésorerie" : modePrev ? "Prévisions de trésorerie" : modeRec ? "Échéances récurrentes" : "";
        const boutonBas = (actif) => ({ ...(actif ? primaryBtnStyle : ghostBtnStyle), fontSize: 12, padding: "6px 14px", border: `1px solid ${actif ? ENCRE : TAUPE}` });
        const nbCloturesAFaire = moisACloturer(compte).filter((m) => { const cl = clotureDe(compte.id, m); return !cl || cl.statut === "refusée" || cl.statut === "rouverte"; }).length;
        let blocCloture = null;
        if (modeCloture) {
          const mois = moisACloturer(compte).slice().reverse();
          const aValider = peut("compta.cloture.valider") ? (comptesTreso || []).flatMap((c) => ((c.clotures || []).filter((x) => x.statut === "demandée").map((x) => ({ c, x })))) : [];
          blocCloture = (
            <div>
              {aValider.length > 0 && (
                <div style={{ border: `1px solid ${OCRE}`, borderRadius: 10, padding: "10px 16px", marginBottom: 16 }}>
                  <div style={{ fontSize: 11, color: OCRE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 8 }}>Clôtures à valider — tous comptes</div>
                  {aValider.map(({ c, x }) => {
                    const soldeNow = arrondiH(soldeCompteVue(c.id, decalerJours(finDeMois(x.mois), 1)));
                    const propre = x.demandeParId === user.id && !estGerant;
                    return (
                      <div key={c.id + x.mois} style={{ padding: "6px 0", borderBottom: `1px solid ${PIERRE}`, fontSize: 13 }}>
                        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                          <strong>{c.nom} — {libMois(x.mois)}</strong>
                          <span>{c.type === "banque" ? "relevé" : "compté"} {formatDH(x.soldeReel)} · ERP {formatDH(soldeNow)}{Math.abs(soldeNow - x.soldeERP) > 0.01 ? <span style={{ color: ROUILLE }}> (modifié depuis la demande : {formatDH(x.soldeERP)})</span> : null}</span>
                          <span style={{ color: Math.abs(x.soldeReel - soldeNow) > 0.01 ? ROUILLE : VERT_OK }}>écart {formatDH(arrondiH(x.soldeReel - soldeNow))}</span>
                          <span style={{ color: TAUPE, fontSize: 12 }}>par {x.demandePar}{x.explication ? ` — « ${x.explication} »` : ""}</span>
                          {propre ? <span style={{ fontSize: 12, color: TAUPE, marginLeft: "auto" }}>ta demande : Le Gérant valide</span> : (
                            <span style={{ marginLeft: "auto", display: "flex", gap: 6 }}>
                              <button type="button" className="sc-btn" onClick={() => setRefusCloture({ compteId: c.id, mois: x.mois, motif: "" })} style={{ ...ghostBtnStyle, fontSize: 12, color: ROUILLE }}>Refuser</button>
                              <button type="button" className="sc-btn" onClick={() => validerCloture(c.id, x.mois)} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 12px" }}>Valider et verrouiller</button>
                            </span>
                          )}
                        </div>
                        {refusCloture && refusCloture.compteId === c.id && refusCloture.mois === x.mois && (
                          <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
                            <input className="sc-input" autoFocus value={refusCloture.motif} onChange={(e) => setRefusCloture({ ...refusCloture, motif: e.target.value })} placeholder="Motif du refus (ex. recompter, opération manquante)" style={{ ...inputStyle("100%"), padding: "4px 8px" }} />
                            <button type="button" className="sc-btn" onClick={refuserCloture} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 12px" }}>Envoyer</button>
                            <button type="button" className="sc-btn" onClick={() => setRefusCloture(null)} style={ghostBtnStyle}>Annuler</button>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
              <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden", marginBottom: 10 }}>
                {mois.length === 0 && <div style={{ padding: 16, fontSize: 13, color: TAUPE }}>Aucun mois terminé à clôturer.</div>}
                {mois.map((m) => {
                  const cl = clotureDe(compte.id, m);
                  const fin = finDeMois(m);
                  const soldeERP = arrondiH(soldeCompteVue(compte.id, decalerJours(fin, 1)));
                  const k = `${compte.id}|${m}`;
                  const form = clotureForm[k] || {};
                  const reel = Number(String(form.reel ?? "").replace(",", "."));
                  const ecart = form.reel !== undefined && form.reel !== "" && isFinite(reel) ? arrondiH(reel - soldeERP) : null;
                  const r = compte.type === "banque" ? calculRapprochement(compte.id, `${m}-01`, fin) : null;
                  const statut = cl ? cl.statut : "à faire";
                  const ouvert = !cl || cl.statut === "refusée" || cl.statut === "rouverte";
                  return (
                    <div key={m} style={{ padding: "10px 16px", borderBottom: `1px solid ${PIERRE}`, fontSize: 13 }}>
                      <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
                        <strong style={{ width: 130 }}>{libMois(m)}</strong>
                        <span>Solde ERP au {formatDate(fin)} : <strong>{fmtCompte(compte, soldeERP)}</strong></span>
                        <span style={{ color: statut === "validée" ? VERT_OK : statut === "demandée" ? OCRE : statut === "refusée" ? ROUILLE : TAUPE }}>{statut === "validée" ? `🔒 clôturé — validé par ${cl.validePar}${Math.abs(cl.ecart) > 0.01 ? `, écart ${formatDH(cl.ecart)} passé en écart de caisse` : ""}` : statut === "demandée" ? `demandée par ${cl.demandePar} — en attente de validation` : statut === "refusée" ? `refusée par ${cl.refusePar} : ${cl.motifRefus}` : statut === "rouverte" ? `rouverte par ${cl.rouvertPar} : ${cl.motifReouverture}` : "à clôturer"}</span>
                        {statut === "validée" && peut("compta.cloture.rouvrir") && <button type="button" className="sc-btn" onClick={() => rouvrirCloture(compte.id, m)} style={{ ...ghostBtnStyle, fontSize: 12, marginLeft: "auto" }}>Rouvrir le mois</button>}
                      </div>
                      {ouvert && (
                        compte.type === "banque" ? (
                          <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginTop: 8 }}>
                            <span style={{ color: r.releve ? (Math.abs(r.ecart) <= 0.01 ? VERT_OK : ROUILLE) : OCRE }}>{r.releve ? `Rapprochement au ${formatDate(fin)} : relevé ${formatDH(Number(r.releve.solde))}, écart ${formatDH(r.ecart)}` : `Solde du relevé au ${formatDate(fin)} pas encore saisi`}</span>
                            <button type="button" className="sc-btn" onClick={() => { setRappro({ compteId: compte.id, du: `${m}-01`, au: fin, solde: null }); setFiltreTreso("rapprochement"); }} style={{ ...ghostBtnStyle, fontSize: 12 }}>🏦 Ouvrir le rapprochement</button>
                            <button type="button" className="sc-btn" disabled={!r.releve || Math.abs(r.ecart) > 0.01} onClick={() => demanderCloture(compte.id, m)} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 12px", marginLeft: "auto", opacity: r.releve && Math.abs(r.ecart) <= 0.01 ? 1 : 0.5 }}>Demander la clôture</button>
                          </div>
                        ) : (
                          <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginTop: 8, background: "#fff", border: `1px solid ${OCRE}`, borderRadius: 8, padding: "10px 12px" }}>
                            <span style={{ fontWeight: 600 }}>{estCompteDevises(compte) ? `Solde du relevé (${compte.devise === "EUR" ? "€" : compte.devise}) au` : "Argent compté au"} {formatDate(fin)}</span>
                            <input type="number" step="0.01" className="sc-input" value={form.reel ?? ""} onChange={(e) => setClotureForm({ ...clotureForm, [k]: { ...form, reel: e.target.value } })} placeholder="Montant compté" style={{ ...inputStyle(150), padding: "6px 8px", background: "#fff", border: `1px solid ${TAUPE}` }} />
                            {ecart !== null && <span style={{ color: Math.abs(ecart) <= 0.01 ? VERT_OK : ROUILLE }}>écart {fmtCompte(compte, ecart)}</span>}
                            {ecart !== null && Math.abs(ecart) > 0.01 && <input className="sc-input" value={form.explication || ""} onChange={(e) => setClotureForm({ ...clotureForm, [k]: { ...form, explication: e.target.value } })} placeholder="Explication de l'écart (obligatoire)" style={{ ...inputStyle(280), padding: "4px 8px", flex: 1 }} />}
                            <button type="button" className="sc-btn" onClick={() => demanderCloture(compte.id, m)} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 12px", marginLeft: "auto" }}>Demander la clôture</button>
                          </div>
                        )
                      )}
                    </div>
                  );
                })}
              </div>
              <div style={{ fontSize: 11, color: TAUPE, lineHeight: 1.6 }}>Caisse : compte l'argent le dernier jour du mois et saisis le total ; un écart doit être expliqué (alerte au Gérant). Banque : rapprochement bancaire sans écart au dernier jour du mois. L'Administration valide (le Gérant valide les demandes de l'Administration) ; l'écart éventuel est passé en « Opérations exceptionnelles › {SOUS_POSTE_ECART_CAISSE} » et le mois est verrouillé : plus aucune opération ne peut y être ajoutée, modifiée ou supprimée. Seul le Gérant peut rouvrir un mois. Clôture en retard (plus de {JOURS_ALERTE_CLOTURE} jours après la fin du mois) : alerte au Gérant. Suivi depuis {libMois(clotureDepuis())}.</div>
            </div>
          );
        }
        let blocDash = null;
        if (modeDash) {
          const auj = todayISO();
          // Nils 03/10 : la CFG seule ; le mois dernier (réalisé) puis les 3 mois qui viennent (prévu).
          const cfg = "banque-cfg";
          const total = soldeCompteAu(cfg);
          const releveAuj = soldeBanqueAu(cfg, auj);
          const nbAttente = opsNonPassees(cfg).length;
          const portef = chequesEnPortefeuille();
          const totPortef = portef.reduce((n, o) => n + Number(o.montant), 0);
          const attendus = encaissementsAttendus();
          const echeancesF = (facturesF || []).filter((fa) => fa.type !== "devis" && !fa.remplaceePar).flatMap((fa) => echeancesRestantesF(fa).map((e) => ({ fa, reste: e.reste, ech: e.date }))).filter((y) => y.reste > 0.01);
          const moisApres = (m) => { const [y, mm] = m.split("-").map(Number); return mm === 12 ? `${y + 1}-01` : `${y}-${String(mm + 1).padStart(2, "0")}`; };
          const m0 = auj.slice(0, 7), mPrec = moisAvant(m0);
          const moisP = [m0, moisApres(m0), moisApres(moisApres(m0))];
          // Dans le mois m ; le mois en cours prend aussi tout ce qui est en retard.
          const dans = (d, m, i) => !!d && (i === 0 ? d.slice(0, 7) <= m : d.slice(0, 7) === m);
          const opsHorsCopies = (operations || []).filter((o) => !o.miroirDe && o.type === "normal");
          const sortiesSousPostes = (liste, m) => opsHorsCopies.filter((o) => o.sens === "sortie" && liste.includes(o.sousPoste) && (o.date || "").slice(0, 7) === m).reduce((n, o) => n + (Number(o.montant) || 0), 0);
          const moyenne3 = (liste) => arrondiH([mPrec, moisAvant(mPrec), moisAvant(moisAvant(mPrec))].reduce((n, m) => n + sortiesSousPostes(liste, m), 0) / 3);
          const salaries = (staff || []).filter((x) => staffActif(x) && x.contrat !== "Agent commercial" && salaireActuel(x) !== null);
          const masse = arrondiH(salaries.reduce((n, x) => n + salaireActuel(x), 0));
          // Nils 04/10 (x, g) : un sous-poste couvert par une échéance récurrente sort de la moyenne ; la TVA vient du fichier TVA.
          const recActives = (recurrentes || []).filter((r) => r.active !== false);
          const sousPostesRec = new Set(recActives.filter((r) => r.sens !== "entree" && r.sousPoste).map((r) => r.sousPoste));
          const spImpots = ["IR", "IS & taxes"].filter((x) => !sousPostesRec.has(x));
          const cnss = sousPostesRec.has("CNSS") ? 0 : moyenne3(["CNSS"]);
          const impots = spImpots.length ? moyenne3(spImpots) : 0;
          const tvaEnCours = Math.max(0, tvaNetteMois(m0));
          const prevActives = (previsions || []).filter((x) => !x.realiseeLe && (!x.compteId || x.compteId === cfg));
          const somme = (l, f) => arrondiH(l.reduce((n, x) => n + f(x), 0));
          // Nils 03/10 : le mois en cours part du solde au 1er (= fin du mois dernier) ; ce qui est déjà passé ce mois-ci est en « réalisé ».
          const opsCfgMois = (m) => (operations || []).filter((o) => o.compteId === cfg && opCompte(o) && (o.date || "").slice(0, 7) === m);
          let debut = soldeCompteAu(cfg, `${m0}-01`);
          const colonnes = moisP.map((m, i) => {
            const opsM = opsCfgMois(m);
            const ent = somme(opsM.filter((o) => o.sens === "entree"), (o) => montantEffectif(o));
            const sor = somme(opsM.filter((o) => o.sens === "sortie"), (o) => -montantEffectif(o));
            const enc = somme(attendus.filter((a) => dans(a.prevu, m, i)), (a) => a.reste);
            const ch = somme(portef.filter((o) => dans(dateEncaissementCheque(o), m, i)), (o) => Number(o.montant));
            const four = somme(echeancesF.filter((y) => dans(y.ech || auj, m, i)), (y) => y.reste);
            const sal = i === 0 ? Math.max(0, arrondiH(masse - sortiesSousPostes(["Salaires"], m0))) : masse;
            const cn = i === 0 ? Math.max(0, arrondiH(cnss - (sousPostesRec.has("CNSS") ? cnss : sortiesSousPostes(["CNSS"], m0)))) : cnss;
            const imp = i === 0 ? Math.max(0, arrondiH(impots - sortiesSousPostes(spImpots, m0))) : impots;
            const tva = sousPostesRec.has("TVA") ? 0 : i === 0 ? Math.max(0, arrondiH(Math.max(0, tvaNetteMois(mPrec)) - sortiesSousPostes(["TVA"], m0))) : tvaEnCours;
            const recOcc = recActives.flatMap((r) => occurrencesDues(r, `${m}-31`).filter((o) => dans(o.date, m, i)).map((o) => ({ r, o })));
            const recE = somme(recOcc.filter((x) => x.r.sens === "entree"), (x) => x.o.montant);
            const recS = somme(recOcc.filter((x) => x.r.sens !== "entree"), (x) => x.o.montant);
            const pv = prevActives.filter((x) => dans(x.date, m, i));
            const pvE = somme(pv.filter((x) => x.sens === "entree"), (x) => Number(x.montant));
            const pvS = somme(pv.filter((x) => x.sens !== "entree"), (x) => Number(x.montant));
            const fin = arrondiH(debut + ent - sor + enc + ch + pvE + recE - four - sal - cn - imp - tva - recS - pvS);
            const c = { m, debut, ent, sor, enc, ch, four, sal, cn, imp, tva, recE, recS, recOcc, pvE, pvS, pv, fin };
            debut = fin;
            return c;
          });
          const opsCfgPrec = opsCfgMois(mPrec);
          const realise = { debut: soldeCompteAu(cfg, `${mPrec}-01`), ent: somme(opsCfgPrec.filter((o) => o.sens === "entree"), (o) => montantEffectif(o)), sor: somme(opsCfgPrec.filter((o) => o.sens === "sortie"), (o) => -montantEffectif(o)), fin: soldeCompteAu(cfg, `${m0}-01`) };
          const moisCourant = auj.slice(0, 7), moisPrec = moisAvant(moisCourant);
          const parPoste = (m) => { const r = {}; (operations || []).filter((o) => !o.miroirDe && o.compteId !== CAISSE_GENERALE_ID && ((o.date || "").slice(0, 7) === m && o.type === "normal" || ((o.date || "").slice(0, 7) === m && o.type === "ecart-cloture"))).forEach((o) => { const k = `${o.sens === "entree" ? "+" : "−"} ${o.poste}`; r[k] = (r[k] || 0) + Number(o.montant || 0); }); return r; };
          const pc = parPoste(moisCourant), pp = parPoste(moisPrec);
          const cles = [...new Set([...Object.keys(pc), ...Object.keys(pp)])].sort((a, b) => (pc[b] || 0) - (pc[a] || 0));
          const tuile = (titre, val, sous, couleur) => (<div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: "8px 14px", minWidth: 170 }}><div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>{titre}</div><div style={{ fontSize: 17, fontWeight: 600, color: couleur || ENCRE }}>{val}</div>{sous && <div style={{ fontSize: 11, color: TAUPE }}>{sous}</div>}</div>);
          blocDash = (
            <div>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 16 }}>
                {tuile("Solde CFG", formatDH(total), `tout ce qui est saisi — relevé ${formatDH(releveAuj)}${nbAttente ? `, ${nbAttente} en attente de passage` : ""}`, total < 0 ? ROUILLE : ENCRE)}
                {tuile("Chèques / effets en portefeuille", formatDH(totPortef), `${portef.length} pas encore déposé(s)`)}
                {tuile("Prévisions à venir", formatDH(somme(prevActives, (x) => (x.sens === "entree" ? 1 : -1) * Number(x.montant))), `${prevActives.length} prévision(s) non réalisée(s)`)}
              </div>
              <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: "10px 16px", marginBottom: 16, maxWidth: 900, overflowX: "auto" }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Trésorerie CFG — mois dernier et 3 mois à venir</div>
                {(() => {
                  const g = "2.6fr 1.1fr 1.1fr 1.1fr 1.1fr";
                  const cell = (v, couleur, gras) => (<div style={{ textAlign: "right", color: couleur || ENCRE, fontWeight: gras ? 600 : 400 }}>{v === null ? "" : formatDH(v)}</div>);
                  const row = (lib, prec, vals, couleur, gras, aide) => (
                    <div style={{ display: "grid", gridTemplateColumns: g, gap: 6, padding: "4px 0", borderBottom: `1px solid ${PIERRE}`, fontSize: 13 }}>
                      <div style={{ fontWeight: gras ? 600 : 400 }}>{lib}{aide ? <div style={{ fontSize: 11, color: TAUPE, fontWeight: 400 }}>{aide}</div> : null}</div>
                      <div style={{ textAlign: "right", color: TAUPE, fontWeight: gras ? 600 : 400 }}>{prec === null ? "" : formatDH(prec)}</div>
                      {vals.map((v, k) => (<React.Fragment key={k}>{cell(v, typeof couleur === "function" ? couleur(v) : couleur, gras)}</React.Fragment>))}
                    </div>
                  );
                  return (
                    <div style={{ minWidth: 640 }}>
                      <div style={{ display: "grid", gridTemplateColumns: g, gap: 6, padding: "4px 0", fontSize: 12, color: TAUPE, fontWeight: 600 }}>
                        <div />
                        <div style={{ textAlign: "right" }}>{libMois(mPrec)}<div style={{ fontWeight: 400 }}>réalisé</div></div>
                        {colonnes.map((c, k) => (<div key={c.m} style={{ textAlign: "right", color: ENCRE }}>{libMois(c.m)}<div style={{ fontWeight: 400, color: TAUPE }}>{k === 0 ? "en cours (retards compris)" : "prévu"}</div></div>))}
                      </div>
                      {row("Solde CFG début de mois", realise.debut, colonnes.map((c) => c.debut), null, true, "au 1er du mois = solde de fin du mois précédent")}
                      {row("+ Entrées réalisées", realise.ent, colonnes.map((c) => (c.m === m0 || c.ent ? c.ent : null)), VERT_OK, false, `mois en cours : saisies du 1er au ${formatDate(auj)}`)}
                      {row("− Sorties réalisées", realise.sor, colonnes.map((c) => (c.m === m0 || c.sor ? c.sor : null)), ROUILLE)}
                      {row("+ Encaissements clients attendus", null, colonnes.map((c) => c.enc), VERT_OK, false, "reste à encaisser sur factures et BL, à la date des conditions du client")}
                      {row("+ Chèques / effets à déposer", null, colonnes.map((c) => c.ch), VERT_OK, false, "portefeuille, à la date prévue d'encaissement (sinon date du chèque) ; hors « pas de visibilité »")}
                      {colonnes.some((c) => c.recE) && row("+ Rentrées récurrentes", null, colonnes.map((c) => c.recE), VERT_OK, false, colonnes.map((c) => c.recOcc.filter((x) => x.r.sens === "entree").map((x) => x.r.libelle).join(", ")).filter(Boolean).join(" · "))}
                      {row("+ Rentrées prévues", null, colonnes.map((c) => c.pvE), VERT_OK, false, colonnes.some((c) => c.pv.some((x) => x.sens === "entree")) ? colonnes.map((c) => c.pv.filter((x) => x.sens === "entree").map((x) => x.libelle).join(", ")).filter(Boolean).join(" · ") : null)}
                      {row("− Échéances fournisseurs", null, colonnes.map((c) => c.four), ROUILLE, false, "tranches des conditions de paiement, retards compris")}
                      {row("− Salaires", null, colonnes.map((c) => c.sal), ROUILLE, false, `salaire en vigueur des fiches Staff (${salaries.length} personne(s), agents commerciaux exclus) ; mois en cours : moins ce qui est déjà payé`)}
                      {row("− CNSS", null, colonnes.map((c) => c.cn), ROUILLE, false, "moyenne des 3 derniers mois")}
                      {row(`− Impôts (${spImpots.length ? spImpots.join(", ") : "—"})`, null, colonnes.map((c) => c.imp), ROUILLE, false, `moyenne des 3 derniers mois${sousPostesRec.size ? ` — hors sous-postes en échéances récurrentes (${[...sousPostesRec].join(", ")})` : ""}`)}
                      {row("− TVA à payer", null, colonnes.map((c) => c.tva), ROUILLE, false, sousPostesRec.has("TVA") ? "suivie en échéance récurrente" : `fichier TVA : collectée − déductible du mois précédent (mois en cours : TVA de ${libMois(mPrec)} moins ce qui est déjà payé ; ${libMois(moisApres(m0))} et ${libMois(moisApres(moisApres(m0)))} : estimation = TVA de ${libMois(m0)} à ce jour)`)}
                      {row("− Échéances récurrentes", null, colonnes.map((c) => c.recS), ROUILLE, false, colonnes.some((c) => c.recS) ? colonnes.map((c) => c.recOcc.filter((x) => x.r.sens !== "entree").map((x) => `${x.r.libelle}${x.o.date < auj ? " (en retard)" : ""}`).join(", ")).filter(Boolean).join(" · ") : "aucune — 🔁 Échéances récurrentes")}
                      {row("− Dépenses prévues", null, colonnes.map((c) => c.pvS), ROUILLE, false, colonnes.some((c) => c.pv.some((x) => x.sens !== "entree")) ? colonnes.map((c) => c.pv.filter((x) => x.sens !== "entree").map((x) => x.libelle).join(", ")).filter(Boolean).join(" · ") : "aucune — 📅 Prévisions")}
                      {row("= Solde CFG fin de mois", realise.fin, colonnes.map((c) => c.fin), (v) => (v < 0 ? ROUILLE : ENCRE), true)}
                    </div>
                  );
                })()}
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Seule la CFG est comptée (caisses exclues). Soldes = tout ce qui est saisi, y compris ce qui n'est pas encore passé sur le relevé ; solde de départ = solde d'ouverture de la CFG (Paramétrage){(Number((compteDe(cfg) || {}).soldeOuverture) || 0) === 0 ? " — pas encore saisi : les soldes sont faux tant qu'il manque" : ""}. Leasings, IS, taxe professionnelle et autres dépenses régulières : 🔁 Échéances récurrentes ; dépenses ponctuelles : 📅 Prévisions.</div>
              </div>
              <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: "10px 16px", marginBottom: 16, maxWidth: 760 }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Entrées et sorties par poste — {libMois(moisCourant)} (en cours) / {libMois(moisPrec)}</div>
                <div style={{ display: "grid", gridTemplateColumns: "2.4fr 1fr 1fr 1fr", gap: 4, fontSize: 12 }}>
                  <div style={{ color: TAUPE }}>Poste</div><div style={{ textAlign: "right", color: TAUPE }}>{libMois(moisCourant)}</div><div style={{ textAlign: "right", color: TAUPE }}>{libMois(moisPrec)}</div><div style={{ textAlign: "right", color: TAUPE }}>Écart</div>
                  {cles.length === 0 && <div style={{ gridColumn: "1 / 5", color: TAUPE }}>Aucune opération.</div>}
                  {cles.map((k) => (<React.Fragment key={k}><div>{k}</div><div style={{ textAlign: "right" }}>{formatDH(pc[k] || 0)}</div><div style={{ textAlign: "right" }}>{formatDH(pp[k] || 0)}</div><div style={{ textAlign: "right", color: TAUPE }}>{formatDH((pc[k] || 0) - (pp[k] || 0))}</div></React.Fragment>))}
                </div>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Transferts entre comptes exclus.</div>
              </div>
              <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: "10px 16px", marginBottom: 16, maxWidth: 760 }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Chèques et effets en portefeuille ({portef.length})</div>
                {portef.length === 0 && <div style={{ fontSize: 12, color: TAUPE }}>Aucun chèque à échéance en portefeuille.</div>}
                {portef.length > 0 && <div style={{ display: "flex", gap: 10, fontSize: 11, color: TAUPE, padding: "2px 0" }}><span style={{ width: 90 }}>Date du chèque</span><span style={{ width: 140 }}>Encaissement prévu</span><span style={{ flex: 1 }} /></div>}
                {portef.map((o) => (<div key={o.id} style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 12, padding: "3px 0", borderBottom: `1px solid ${PIERRE}` }}><span style={{ width: 90 }}>{formatDate(o.echeanceCheque)}</span><span style={{ width: 140 }}>{(estGerant || user.profil === P_ADMIN || detenteurCheque(o) === user.id) ? <input type="date" className="sc-input" aria-label="Encaissement prévu le" min={o.echeanceCheque || undefined} value={o.encaissementPrevu || ""} onChange={(e) => majEncaissementPrevu(o.id, e.target.value)} style={{ ...inputStyle(135), padding: "2px 6px", fontSize: 12, background: "#fff" }} /> : (o.encaissementPrevu ? formatDate(o.encaissementPrevu) : "—")}</span><span style={{ flex: 1 }}>{o.mode} {o.piece || ""} — {o.tiers || "?"} <span style={{ color: TAUPE }}>({(compteDe(o.compteId) || {}).nom}, reçu le {formatDate(o.date)}{(compteDe(o.compteId) || {}).type !== "banque" ? ` — détenu par ${nomUtilisateur(detenteurCheque(o)) || "?"}` : ""})</span></span><strong>{formatDH(Number(o.montant))}</strong></div>))}
                {(() => { const sv = chequesEnMain().filter((o) => o.sansVisibilite); return sv.length ? (
                  <div style={{ marginTop: 8, fontSize: 12 }}>
                    <div style={{ color: OCRE, fontWeight: 600, marginBottom: 2 }}>Sans visibilité sur l'encaissement (hors prévisionnel) : {sv.length} — {formatDH(sv.reduce((n, o) => n + Number(o.montant), 0))}</div>
                    {sv.map((o) => (<div key={o.id} style={{ display: "flex", gap: 10, padding: "2px 0", borderBottom: `1px solid ${PIERRE}` }}><span style={{ width: 90 }}>{formatDate(o.echeanceCheque)}</span><span style={{ flex: 1 }}>{o.mode} {o.piece || ""} — {o.tiers || "?"} <span style={{ color: TAUPE }}>(détenu par {nomUtilisateur(detenteurCheque(o)) || "?"}, valable jusqu'au {formatDate(expirationCheque(o.echeanceCheque))})</span></span><strong>{formatDH(Number(o.montant))}</strong></div>))}
                  </div>
                ) : null; })()}
              </div>
            </div>
          );
        }
        return (
          <div>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 16 }}>
              {comptesVisibles.map((c) => {
                const s = soldeCompteVue(c.id);
                const actif = c.id === compte.id;
                const nbRec = (operations || []).filter((o) => o.compteId === c.id && o.type === "transfert" && o.sens === "entree" && o.statutTransfert === "en attente").length;
                return (
                  <div key={c.id} className="sc-row" onClick={() => setCompteActif(c.id)} style={{ cursor: "pointer", border: `1px solid ${actif ? ENCRE : PIERRE}`, background: actif ? PIERRE : "transparent", borderRadius: 10, padding: "10px 14px", minWidth: 150 }}>
                    <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>{c.nom}</div>
                    <div style={{ fontSize: 16, fontWeight: 600, color: s < 0 || (c.id === CAISSE_GENERALE_ID && s < SEUIL_CAISSE_GENERALE) ? ROUILLE : ENCRE, marginTop: 2 }}>{fmtCompte(c, s)}</div>
                    {estCompteDevises(c) && <div style={{ fontSize: 11, color: TAUPE }}>≈ {formatDH(soldeCompteAu(c.id))}{(() => { const t = tauxMoyenDevises(c.id); return t ? ` · taux moyen ${t.toFixed(4).replace(".", ",")}` : ""; })()}</div>}
                    {c.id === CAISSE_GENERALE_ID && s < SEUIL_CAISSE_GENERALE && <div style={{ fontSize: 11, color: ROUILLE }}>sous {formatDH(SEUIL_CAISSE_GENERALE)}</div>}
                    {c.type === "caisse" && c.id !== CAISSE_GENERALE_ID && (() => {
                      // Nils 04/10 (w) : dépense moyenne mensuelle (6 derniers mois complets) et mois en cours.
                      const d = depensesCaisse(c.id);
                      if (!d.nbMois && !d.enCours) return null;
                      return (
                        <div style={{ fontSize: 11, color: TAUPE }} onClick={(e) => { e.stopPropagation(); setDetailDepensesCaisse(c.id); }} title="Détail par poste">
                          dépenses : moy. {formatDH(d.moyenne)}/mois{d.nbMois < 6 ? ` (${d.nbMois} mois)` : ""} · ce mois <span style={{ color: d.nbMois && d.enCours > d.moyenne ? ROUILLE : ENCRE, fontWeight: 600 }}>{formatDH(d.enCours)}</span> <span style={{ textDecoration: "underline" }}>détail</span>
                        </div>
                      );
                    })()}
                    {c.type === "banque" && (() => { const nb = opsNonPassees(c.id).length; return <div style={{ fontSize: 11, color: TAUPE }}>relevé {formatDH(soldeBanqueAu(c.id, todayISO()))}{nb ? <span style={{ color: OCRE }}> · {nb} en attente</span> : null}</div>; })()}
                    {(() => {
                      // Nils 04/10 (ad) : sorties prévues sur ce compte (honoraires marketing…).
                      const pv = (previsions || []).filter((x) => x.compteId === c.id && !x.realiseeLe);
                      if (!pv.length || !peut("compta.previsions")) return null;
                      return <div style={{ fontSize: 11, color: OCRE }} title={pv.map((x) => `${formatDate(x.date)} ${x.libelle} ${formatDH(x.montant)}`).join("\n")}>prévu : −{formatDH(pv.reduce((n, x) => n + (x.sens === "entree" ? -1 : 1) * Number(x.montant), 0))} ({pv.length})</div>;
                    })()}
                    <div style={{ fontSize: 11, color: TAUPE }}>{nomsUtilisateurs(c.responsables || [])}{nbRec ? <span style={{ color: OCRE }}> · {nbRec} à confirmer</span> : null}</div>
                  </div>
                );
              })}
              {peut("compta.tableauBord") && comptesVisibles.length > 1 && (
                <div style={{ borderRadius: 10, padding: "10px 14px", minWidth: 150, border: `1px dashed ${PIERRE}` }}>
                  <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>Total trésorerie</div>
                  <div style={{ fontSize: 16, fontWeight: 600, marginTop: 2 }}>{formatDH(comptesVisibles.filter((c) => c.id !== CAISSE_GENERALE_ID && c.id !== PORTEFEUILLE_ID && !estCompteDevises(c)).reduce((n, c) => n + soldeCompteAu(c.id), 0))}</div>
                  <div style={{ fontSize: 11, color: TAUPE }}>transferts en attente, caisse générale, chèques et dotation devises exclus</div>
                </div>
              )}
            </div>

            {detailDepensesCaisse && (() => {
              const c = compteDe(detailDepensesCaisse);
              const d = depensesCaisse(detailDepensesCaisse);
              const lignes = Object.entries(d.parPoste).sort((a, b) => b[1].moy - a[1].moy);
              return (
                <Overlay onClose={() => setDetailDepensesCaisse(null)}>
                  <div style={modalStyle(520)}>
                    <div style={modalTitleStyle}>Dépenses — {c ? c.nom : ""}</div>
                    <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 12 }}>Moyenne mensuelle sur {d.nbMois} mois complet(s) (6 au plus) et mois en cours ; transferts, copies, extournes et écarts de clôture exclus.</div>
                    <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr", gap: 6, fontSize: 13 }}>
                      <div style={{ color: TAUPE, fontSize: 11 }}>POSTE</div><div style={{ color: TAUPE, fontSize: 11, textAlign: "right" }}>MOY. / MOIS</div><div style={{ color: TAUPE, fontSize: 11, textAlign: "right" }}>CE MOIS</div>
                      {lignes.map(([k, v]) => (<React.Fragment key={k}><div>{k}</div><div style={{ textAlign: "right" }}>{formatDH(arrondiH(v.moy))}</div><div style={{ textAlign: "right", color: v.cours > v.moy + 0.01 ? ROUILLE : ENCRE, fontWeight: v.cours > v.moy + 0.01 ? 600 : 400 }}>{formatDH(arrondiH(v.cours))}</div></React.Fragment>))}
                      <div style={{ fontWeight: 600, borderTop: `1px solid ${PIERRE}` }}>Total</div><div style={{ textAlign: "right", fontWeight: 600, borderTop: `1px solid ${PIERRE}` }}>{formatDH(d.moyenne)}</div><div style={{ textAlign: "right", fontWeight: 600, borderTop: `1px solid ${PIERRE}`, color: d.enCours > d.moyenne ? ROUILLE : ENCRE }}>{formatDH(d.enCours)}</div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 14 }}><button type="button" className="sc-btn" onClick={() => setDetailDepensesCaisse(null)} style={ghostBtnStyle}>Fermer</button></div>
                  </div>
                </Overlay>
              );
            })()}
            {modeSpecial && (
              <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 14 }}>
                <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontWeight: 600 }}>{titreModeSpecial}</div>
                <button type="button" className="sc-btn" onClick={() => setFiltreTreso("mois")} style={{ ...ghostBtnStyle, fontSize: 12, marginLeft: "auto" }}>← Retour aux comptes</button>
              </div>
            )}
            {modeEch ? rendreEcheancier() : modeCloture ? blocCloture : modeDash ? blocDash : modePrev ? rendrePrevisions() : modeRec ? rendreRecurrentes() : (<>
            {receptions.length > 0 && saisie && (
              <div style={{ border: `1px solid ${OCRE}`, borderRadius: 10, padding: "10px 14px", marginBottom: 14 }}>
                <div style={{ fontSize: 11, color: OCRE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, fontWeight: 600 }}>Transferts à confirmer — {compte.nom}</div>
                {receptions.map((o) => (
                  <div key={o.id} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 13, padding: "4px 0" }}>
                    <span style={{ flex: 1 }}>{formatDate(o.date)} — <strong>{formatDH(Number(o.montant))}</strong> depuis {(compteDe(o.contrepartieId) || {}).nom || "?"}{o.designation && !o.designation.startsWith("Transfert depuis") ? ` — ${o.designation}` : ""} <span style={{ color: TAUPE }}>(envoyé par {o.par})</span></span>
                    <button type="button" className="sc-btn" onClick={() => setReceptionEdit({ id: o.id, montant: String(o.montant), note: "" })} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 12px" }}>Confirmer la réception</button>
                  </div>
                ))}
              </div>
            )}

            <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 12 }}>
              {!modeTVA && !modeRappro && <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontWeight: 600, marginRight: 6 }}>{compte.nom}{filtreTreso === "mois" && moisVerrouille(compte.id, `${moisTreso}-01`) ? <span title="Mois clôturé et verrouillé" style={{ fontSize: 14, color: TAUPE, marginLeft: 8 }}>🔒 clôturé</span> : null}</div>}
              {!modeTVA && !modeRappro && <select className="sc-select" value={filtreTreso} onChange={(e) => setFiltreTreso(e.target.value)} style={{ ...selectStyle, width: "auto" }}>
                <option value="mois">Mois</option>
                <option value="atraiter">À traiter — tous mois ({nbATraiter})</option>
                {peut("compta.rapprochementCaisses") && <option value="rapprocher">Mouvements de caisse à rapprocher — tous comptes ({mouvementsARapprocher.length})</option>}
              </select>}
              {((filtreTreso === "mois" && parMois) || filtreTreso === "tva") && <input type="month" className="sc-input" value={moisTreso} onChange={(e) => e.target.value && setMoisTreso(e.target.value)} style={{ ...inputStyle(160), padding: "6px 8px" }} />}
              {saisie && !modeTVA && !modeRappro && (
                <>
                  <button type="button" className="sc-btn" onClick={() => setOpEdit(nouvelleOperation(compte.id, "entree"))} style={{ ...ghostBtnStyle, fontSize: 12, color: VERT_OK }}>{compte.id === PORTEFEUILLE_ID ? "+ Chèque / effet reçu" : "+ Entrée"}</button>
                  {compte.id !== PORTEFEUILLE_ID && <button type="button" className="sc-btn" onClick={() => setOpEdit(nouvelleOperation(compte.id, "sortie"))} style={{ ...ghostBtnStyle, fontSize: 12, color: ROUILLE }}>− Sortie</button>}
                  {compte.id !== CAISSE_GENERALE_ID && compte.id !== PORTEFEUILLE_ID && !estCompteDevises(compte) && <button type="button" className="sc-btn" onClick={() => setTransfertEdit({ source: compte.id, destination: "", montant: "", date: todayISO(), mode: "Espèces", note: "" })} style={{ ...ghostBtnStyle, fontSize: 12 }}>⇄ Transfert</button>}
                </>
              )}
            </div>

            {(filtreTreso === "mois" || filtreTreso === "atraiter") && !modeSpecial && (() => {
              const postes = [...new Set(opsCompte.map((o) => o.poste).filter(Boolean))].sort((a, b) => a.localeCompare(b, "fr"));
              const sous = FC.poste ? [...new Set(opsCompte.filter((o) => o.poste === FC.poste).map((o) => o.sousPoste).filter(Boolean))].sort((a, b) => a.localeCompare(b, "fr")) : [];
              const annees = [...new Set([...opsCompte.map((o) => String(o.date || "").slice(0, 4)), todayISO().slice(0, 4)].filter((a) => /^\d{4}$/.test(a)))].sort().reverse();
              const petit = { ...selectStyle, width: "auto", fontSize: 12, padding: "5px 8px" };
              return (
                <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 12 }}>
                  <input className="sc-input" value={FC.q} onChange={(e) => setFC({ q: e.target.value })} placeholder="Rechercher : désignation, tiers, réf., dossier, montant…" style={{ ...inputStyle(280), padding: "5px 8px", fontSize: 12 }} />
                  <select className="sc-select" value={FC.poste} onChange={(e) => setFC({ poste: e.target.value, sousPoste: "" })} style={petit}>
                    <option value="">Tous les postes</option>
                    {postes.map((x) => (<option key={x} value={x}>{x}</option>))}
                  </select>
                  {FC.poste && sous.length > 1 && (
                    <select className="sc-select" value={FC.sousPoste} onChange={(e) => setFC({ sousPoste: e.target.value })} style={petit}>
                      <option value="">Tous les sous-postes</option>
                      {sous.map((x) => (<option key={x} value={x}>{x}</option>))}
                    </select>
                  )}
                  <select className="sc-select" value={FC.sens} onChange={(e) => setFC({ sens: e.target.value })} style={petit}>
                    <option value="">Entrées et sorties</option>
                    <option value="entree">Entrées</option>
                    <option value="sortie">Sorties</option>
                  </select>
                  {filtreTreso === "mois" && (
                    <select className="sc-select" value={FC.periode} onChange={(e) => setFC({ periode: e.target.value })} style={petit}>
                      <option value="mois">Par mois</option>
                      <option value="annee">Année entière</option>
                      <option value="plage">Du … au …</option>
                    </select>
                  )}
                  {filtreTreso === "mois" && FC.periode === "annee" && (
                    <select className="sc-select" value={FC.annee} onChange={(e) => setFC({ annee: e.target.value })} style={petit}>
                      {annees.map((a) => (<option key={a} value={a}>{a}</option>))}
                    </select>
                  )}
                  {filtreTreso === "mois" && FC.periode === "plage" && (
                    <>
                      <input type="date" className="sc-input" value={FC.du} onChange={(e) => setFC({ du: e.target.value })} style={{ ...inputStyle(140), padding: "4px 8px", fontSize: 12 }} />
                      <span style={{ fontSize: 12, color: TAUPE }}>au</span>
                      <input type="date" className="sc-input" value={FC.au} onChange={(e) => setFC({ au: e.target.value })} style={{ ...inputStyle(140), padding: "4px 8px", fontSize: 12 }} />
                    </>
                  )}
                  {filtreActif && <button type="button" className="sc-btn" onClick={() => setFiltresCaisse(null)} style={{ ...ghostBtnStyle, fontSize: 12 }}>✕ Effacer les filtres</button>}
                </div>
              );
            })()}

            {modeRappro ? blocRappro : modeTVA ? blocTVA : modeRapprochement ? (
              <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden", marginBottom: 10 }}>
                <div style={{ padding: "10px 16px", background: PIERRE, fontSize: 12, color: TAUPE }}>Mouvements de caisse importés sans contrepartie : lie chacun à la ligne correspondante de l'autre compte (sens opposé, 7 jours autour, montant le plus proche en premier), ou clique « Pas de contrepartie » pour le reclasser dans un poste (retrait bancaire, apport extérieur…). Un écart de montant déclenche une alerte.</div>
                {mouvementsARapprocher.length === 0 && <div style={{ padding: 16, fontSize: 13, color: TAUPE }}>Tout est rapproché.</div>}
                {mouvementsARapprocher.map((o) => {
                  const cands = candidatsRapprochement(o, 7);
                  const choix = rapprochementChoix[o.id] !== undefined ? rapprochementChoix[o.id] : cands.length && Number(cands[0].montant) === Number(o.montant) ? cands[0].id : "";
                  return (
                    <div key={o.id} style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", padding: "9px 16px", borderBottom: `1px solid ${PIERRE}`, fontSize: 13 }}>
                      <span style={{ width: 110 }}>{(compteDe(o.compteId) || {}).nom}</span>
                      <span style={{ width: 85 }}>{formatDate(o.date)}</span>
                      <span style={{ width: 120, color: o.sens === "entree" ? VERT_OK : ROUILLE }}>{o.sens === "entree" ? "+" : "−"} {formatDH(Number(o.montant))}</span>
                      <span style={{ flex: 1, minWidth: 160 }}>{o.designation}<span style={{ fontSize: 11, color: TAUPE }}>{o.tiers ? ` · ${o.tiers}` : ""}{o.importe && o.importe.origine ? ` · ${o.importe.origine}` : ""}</span></span>
                      <select className="sc-select" value={choix} onChange={(e) => setRapprochementChoix({ ...rapprochementChoix, [o.id]: e.target.value })} style={{ ...selectStyle, width: 330, fontSize: 12 }}>
                        <option value="">{cands.length ? "— Choisir la contrepartie —" : "Aucune ligne candidate"}</option>
                        {cands.map((x) => (<option key={x.id} value={x.id}>{(compteDe(x.compteId) || {}).nom} — {formatDate(x.date)} — {x.sens === "entree" ? "+" : "−"}{formatDH(Number(x.montant))}{Number(x.montant) !== Number(o.montant) ? " (écart)" : ""} — {x.designation}</option>))}
                      </select>
                      <button type="button" className="sc-btn" disabled={!choix} onClick={() => lierMouvements(o.id, choix)} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 12px", opacity: choix ? 1 : 0.5 }}>Lier</button>
                      <button type="button" className="sc-btn" onClick={() => setOpEdit({ ...o, _contrepartie: { compteId: "", date: o.date } })} style={{ ...ghostBtnStyle, fontSize: 12 }}>➕ Créer la contrepartie</button>
                      <button type="button" className="sc-btn" onClick={() => setOpEdit({ ...o, type: "normal", poste: "", sousPoste: "", sansContrepartie: true })} style={{ ...ghostBtnStyle, fontSize: 12 }}>Pas de contrepartie</button>
                    </div>
                  );
                })}
              </div>
            ) : (
            <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden", marginBottom: 10 }}>
              <div style={{ display: "grid", gridTemplateColumns: grille, padding: "10px 16px", background: PIERRE, gap: 8 }}>
                <Th>Date</Th><Th>Désignation</Th><Th>Poste</Th><Th>Dossier</Th><Th>Entrée</Th><Th>Sortie</Th><Th>Solde</Th>
              </div>
              {soldeDebut !== null && (
                <div style={{ display: "grid", gridTemplateColumns: grille, padding: "8px 16px", gap: 8, fontSize: 12, color: TAUPE, borderBottom: `1px solid ${PIERRE}` }}>
                  <div>{debutP === "0000-00-00" ? "" : formatDate(debutP)}</div><div style={{ gridColumn: "2 / 7" }}>{parMois ? "Solde au début du mois" : "Solde au début de la période"}</div><div style={{ fontWeight: 600, color: soldeDebut < 0 ? ROUILLE : ENCRE }}>{estCompteDevises(compte) ? fmtCompte(compte, soldeDebut) : formatDH(soldeDebut)}</div>
                </div>
              )}
              {lignes.length === 0 && <div style={{ padding: 16, fontSize: 13, color: TAUPE }}>{filtreActif ? "Aucune opération pour ces filtres." : filtreTreso === "atraiter" ? "Rien à traiter sur ce compte." : "Aucune opération ce mois-ci."}</div>}
              {lignes.map(({ o, solde, compteDansSolde }) => {
                const d = o.dossierId ? dossierParId(o.dossierId) : null;
                const estTransfert = o.type === "transfert" || o.type === "transfert-importé";
                const enAttente = o.type === "transfert" && o.sens === "entree" && o.statutTransfert !== "confirmé";
                const m = estCompteDevises(compte) ? Math.abs(montantVue(o, compte)) : o.sens === "entree" ? Math.abs(montantEffectif(o)) || Number(o.montant) : Number(o.montant);
                const fmtM = (v) => (estCompteDevises(compte) ? <>{fmtCompte(compte, v)}<div style={{ fontSize: 10, color: TAUPE }}>{formatDH(Math.abs(montantEffectif(o)) || Number(o.montant))}</div></> : formatDH(v));
                return (
                  <div key={o.id} className="sc-row" onClick={() => { if (o.miroirDe) { const src = (operations || []).find((x) => x.id === o.miroirDe); setNotice(`Copie automatique d'une opération de ${src ? (compteDe(src.compteId) || {}).nom : "?"} : elle se modifie ou se supprime depuis l'opération d'origine.`); return; } if (saisie || (o.poste === POSTE_ENCAISSEMENT && peutRelierEncaissement(compteDe(o.compteId)))) setOpEdit({ ...o }); }} style={{ display: "grid", gridTemplateColumns: grille, padding: "9px 16px", gap: 8, alignItems: "center", borderBottom: `1px solid ${PIERRE}`, fontSize: 13, cursor: saisie || (o.poste === POSTE_ENCAISSEMENT && peutRelierEncaissement(compteDe(o.compteId))) ? "pointer" : "default", opacity: enAttente ? 0.6 : 1 }}>
                    <div>{formatDate(o.date)}</div>
                    <div>
                      {o.designation}
                      {(() => {
                        // Nils 08/10 (i/j) : ❓ précision / ⚑ signalement.
                        const src = opSource(o);
                        const ouvertes = questionsOuvertesOp(src);
                        const sig = src.signale && !src.signale.leve;
                        const estResp = ((compteDe(src.compteId) || {}).responsables || []).includes(user.id);
                        const peutQ = peut("compta.questionner");
                        if (!peutQ && !(estResp && (src.questions || []).length) && !sig) return null;
                        const stop = (e) => e.stopPropagation();
                        const pastille = { fontSize: 11, padding: "1px 7px", borderRadius: 10, marginLeft: 6, cursor: "pointer", border: "none" };
                        return (
                          <span onClick={stop}>
                            {sig && <button type="button" className="sc-btn" title={`Signalé par ${src.signale.par} : ${src.signale.motif}`} onClick={() => setQuestionOp({ opId: src.id, mode: "fil", texte: "" })} style={{ ...pastille, background: "#F3E3DC", color: ROUILLE }}>⚑ signalée</button>}
                            {(src.questions || []).length > 0 && <button type="button" className="sc-btn" onClick={() => setQuestionOp({ opId: src.id, mode: "fil", texte: "" })} style={{ ...pastille, background: ouvertes.length ? "#F4ECD8" : "#E4EBE4", color: ouvertes.length ? OCRE : VERT_OK }}>❓ {ouvertes.length ? `${ouvertes.length} question(s) en attente` : "répondu"}</button>}
                            {peutQ && <button type="button" className="sc-btn" title="Demander une précision au responsable de la caisse" onClick={() => setQuestionOp({ opId: src.id, mode: "question", texte: "" })} style={{ ...pastille, background: "transparent", color: TAUPE }}>❓</button>}
                            {peutQ && !sig && <button type="button" className="sc-btn" title="Signaler une dépense anormale" onClick={() => setQuestionOp({ opId: src.id, mode: "signal", texte: "" })} style={{ ...pastille, background: "transparent", color: TAUPE }}>⚑</button>}
                          </span>
                        );
                      })()}
                      <div style={{ fontSize: 11, color: TAUPE }}>{[o.tiers, o.mode, o.piece ? `réf. ${o.piece}` : "", o.echeanceCheque ? `date ${formatDate(o.echeanceCheque)}${o.encaissementPrevu && !o.chequeRemisLe ? ` — encaissement prévu le ${formatDate(o.encaissementPrevu)}` : ""}${o.chequeRemisLe ? " — remis" : ""}` : "", o.importe ? "importé" : ""].filter(Boolean).join(" · ")}</div>
                    </div>
                    <div style={{ fontSize: 12, color: o.poste === POSTE_A_DEFINIR ? ROUILLE : ENCRE }}>
                      {estTransfert ? "Transfert" : o.poste}
                      <div style={{ fontSize: 11, color: TAUPE }}>{o.poste === POSTE_A_DEFINIR && o.importe && o.importe.origine ? `fichier : ${o.importe.origine}` : o.sousPoste}</div>
                      {enAttente && <div style={{ fontSize: 11, color: OCRE }}>{o.statutTransfert === "refusé" ? "refusé" : "en attente de confirmation"}</div>}
                      {o.type === "transfert-importé" && (o.rapprocheAvec ? <div style={{ fontSize: 11, color: VERT_OK }}>rapproché — {(compteDe(o.contrepartieId) || {}).nom || "?"}</div> : <div style={{ fontSize: 11, color: OCRE }}>à rapprocher</div>)}
                      {o.type === "transfert" && o.statutTransfert === "confirmé" && o.montantRecu !== undefined && o.montantRecu !== "" && Number(o.montantRecu) !== Number(o.montant) && <div style={{ fontSize: 11, color: ROUILLE }}>envoyé {formatDH(Number(o.montant))}</div>}
                    </div>
                    <div style={{ fontSize: 12 }}>{o.repartition && o.repartition.length > 1 ? `${o.repartition.length} factures : ${o.repartition.map((x) => { const c = dossierParId(x.dossierId) || {}; return c.numeroFacture || c.numeroBL || c.numero; }).join(", ")}` : o.avoirId ? `remboursement ${((avoirs || []).find((x) => x.id === o.avoirId) || {}).numero || "avoir"}` : d ? libDossierTreso(d) : o.poste === POSTE_ENCAISSEMENT ? <span style={{ color: ROUILLE }}>à relier</span> : o.factureFournisseur ? <span style={{ color: TAUPE }}>fact. {o.factureFournisseur.numero || "sans n°"}</span> : "—"}</div>
                    <div style={{ color: VERT_OK }}>{o.sens === "entree" ? fmtM(m) : ""}</div>
                    <div style={{ color: ROUILLE }}>{o.sens === "sortie" ? fmtM(m) : ""}</div>
                    <div style={{ color: solde !== null && solde < 0 ? ROUILLE : ENCRE }}>{compteDansSolde && solde !== null ? fmtCompte(compte, solde) : "—"}</div>
                  </div>
                );
              })}
              {soldeDebut === null && filtreActif && lignes.length > 0 && (
                <div style={{ display: "grid", gridTemplateColumns: grille, padding: "10px 16px", gap: 8, fontSize: 13, background: PIERRE, fontWeight: 600 }}>
                  <div /><div style={{ gridColumn: "2 / 5" }}>Total du filtre — {lignes.length} ligne(s)</div><div style={{ color: VERT_OK }}>{fmtCompte(compte, entrees)}</div><div style={{ color: ROUILLE }}>{fmtCompte(compte, sorties)}</div><div />
                </div>
              )}
              {soldeDebut !== null && (
                <div style={{ display: "grid", gridTemplateColumns: grille, padding: "10px 16px", gap: 8, fontSize: 13, background: PIERRE, fontWeight: 600 }}>
                  <div /><div style={{ gridColumn: "2 / 5" }}>{parMois ? "Total du mois" : `Total de la période — ${lignes.length} ligne(s)`}</div><div style={{ color: VERT_OK }}>{fmtCompte(compte, entrees)}</div><div style={{ color: ROUILLE }}>{fmtCompte(compte, sorties)}</div><div>{fmtCompte(compte, soldeDebut + entrees - sorties)}</div>
                </div>
              )}
            </div>
            )}
            <div style={{ fontSize: 11, color: TAUPE, lineHeight: 1.6 }}>
              Solde actuel {compte.nom} : <strong style={{ color: soldeActuel < 0 ? ROUILLE : ENCRE }}>{fmtCompte(compte, soldeActuel)}</strong>{estCompteDevises(compte) ? ` (≈ ${formatDH(soldeCompteAu(compte.id))})` : ""} (ouverture {estCompteDevises(compte) ? fmtCompte(compte, Number(compte.soldeOuvertureDevise) || 0) : formatDH(Number(compte.soldeOuverture) || 0)} au {formatDate(compte.dateOuverture)}).
              {envoisEnAttente.length > 0 && <> {envoisEnAttente.length} transfert(s) envoyé(s) pas encore confirmé(s) par le receveur.</>}
              {" "}Un encaissement client est toujours lié à un dossier : facture, BLS pour une vente exo, ou BC pour une avance (elle suit le dossier jusqu'à la facture) ; si la facture n'est pas encore dans l'ERP, coche « à relier plus tard » et relie-le ensuite. Un transfert ne compte chez le receveur qu'une fois confirmé. Plan de postes et comptes : Paramétrage (Gérant).
            </div>
            </>)}
            {/* Nils 01/10 : tout ce qui n'est pas la saisie de la caisse, en bas de page. */}
            <div style={{ borderTop: `1px solid ${PIERRE}`, marginTop: 22, paddingTop: 14, display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
              {saisie && (
                <>
                  {compte.id !== PORTEFEUILLE_ID && <button type="button" className="sc-btn" onClick={() => setFiltreTreso(modeCloture ? "mois" : "cloture")} style={boutonBas(modeCloture)}>🔒 Clôture du mois{nbCloturesAFaire ? ` (${nbCloturesAFaire})` : ""}</button>}
                  {compte.type === "banque" && <button type="button" className="sc-btn" onClick={() => setFiltreTreso(modeRappro ? "mois" : "rapprochement")} style={boutonBas(modeRappro)}>🏦 Pointage du relevé</button>}
                </>
              )}
              {peutSaisirFactureF && <button type="button" className="sc-btn" onClick={() => setActiveTab("facturesF")} style={boutonBas(false)}>📑 Factures fournisseurs & échéancier (Achats)</button>}
              {peutTVA && <button type="button" className="sc-btn" onClick={() => setFiltreTreso(modeTVA ? "mois" : "tva")} style={boutonBas(modeTVA)}>🧾 TVA du mois — fichier du comptable</button>}
              {peut("compta.tableauBord") && <button type="button" className="sc-btn" onClick={() => setFiltreTreso(modeDash ? "mois" : "dashboard")} style={boutonBas(modeDash)}>📊 Tableau de bord trésorerie</button>}
              {peut("compta.previsions") && <button type="button" className="sc-btn" onClick={() => setFiltreTreso(modePrev ? "mois" : "previsions")} style={boutonBas(modePrev)}>📅 Prévisions</button>}
              {peut("compta.previsions") && <button type="button" className="sc-btn" onClick={() => setFiltreTreso(modeRec ? "mois" : "recurrentes")} style={boutonBas(modeRec)}>🔁 Échéances récurrentes</button>}
              {saisie && compte.id !== CAISSE_GENERALE_ID && (
                <>
                  <input ref={importTresoRef} type="file" accept=".xlsx,.xls,.ods" style={{ display: "none" }} onChange={(e) => { const fi = e.target.files && e.target.files[0]; e.target.value = ""; analyserImportTreso(fi, compte.id); }} />
                  <button type="button" className="sc-btn" onClick={() => importTresoRef.current && importTresoRef.current.click()} style={{ ...ghostBtnStyle, fontSize: 12 }}>⬆ Importer un fichier ({compte.nom})</button>
                  {importsDuCompte(compte.id).length > 0 && <button type="button" className="sc-btn" onClick={() => setImportsTresoCompte(compte.id)} style={{ ...ghostBtnStyle, fontSize: 12 }}>↺ Imports ({importsDuCompte(compte.id).length})</button>}
                  {compte.id !== PORTEFEUILLE_ID && !estCompteDevises(compte) && <button type="button" className="sc-btn" onClick={() => ouvrirVersementPrimes(compte.id)} style={{ ...ghostBtnStyle, fontSize: 12 }}>💰 Verser des primes</button>}
                </>
              )}
              {!modeSpecial && <button type="button" className="sc-btn" onClick={exporterTreso} disabled={!liste.length} style={{ ...ghostBtnStyle, fontSize: 12, opacity: liste.length ? 1 : 0.5 }}>⬇ Exporter (CSV)</button>}
            </div>
          </div>
        );
      })()}

      {opEdit && (activeTab === "compta" || activeTab === "facturesF") && (() => {
        const f = opEdit;
        const compte = compteDe(f.compteId);
        const nouveau = !f.id;
        const set = (patch) => setOpEdit({ ...f, ...patch });
        const estTransfert = f.type === "transfert" || f.type === "transfert-importé";
        const postes = postesPourSens(f.sens);
        const posteSel = planPostes().find((p) => p.poste === f.poste);
        const choisirPoste = (poste) => {
          const p = planPostes().find((x) => x.poste === poste);
          set({ poste, sousPoste: p && p.sous.length === 1 ? p.sous[0] : "", dossierId: poste === POSTE_ENCAISSEMENT ? f.dossierId : "", ...(poste === POSTE_ENCAISSEMENT ? {} : { repartition: undefined }), ...(POSTES_SANS_FACTURE.includes(poste) ? { factureFournisseur: undefined } : {}) });
        };
        const q = normLib(f._q || "");
        const candidats = f.poste === POSTE_ENCAISSEMENT ? tousDossiers()
          .filter((c) => {
            if (!user.commandesRestreintACommercial) return true;
            if (c.anterieure) return (clientDe(c.clientId) || {}).commercialSC === user.nom;
            const dv = (devisListe || []).find((x) => x.id === c.devisId);
            return dv && dv.commercialSC === user.nom;
          })
          .filter((c) => !(f.tiersType === "client" && f.tiers && nomsTiers("client").some((n) => normLib(n) === normLib(f.tiers))) || normLib((clientDe(c.clientId) || {}).nom) === normLib(f.tiers))
          .filter((c) => !q || normLib([c.numero, c.numeroBL, c.numeroFacture, c.reference, (clientDe(c.clientId) || {}).nom].filter(Boolean).join(" ")).includes(q))
          .sort((a, b) => ((a.creeLe || "") < (b.creeLe || "") ? 1 : -1))
          .slice(0, 12) : [];
        const avant = f.id ? (operations || []).find((o) => o.id === f.id) : null;
        const resteDe = (c) => totalDossierTTC(c) - encaisseDossier(c.id) + (avant && avant.poste === POSTE_ENCAISSEMENT ? partsDossiers(avant).filter((x) => x.dossierId === c.id).reduce((n, x) => n + x.montant, 0) : 0);
        const parts = Array.isArray(f.repartition) && f.repartition.length ? f.repartition : f.dossierId ? [{ dossierId: f.dossierId, montant: f.montant }] : [];
        const choisirDossier = (c) => {
          const base = { tiersType: "client", tiers: f.tiers || (clientDe(c.clientId) || {}).nom || "", _q: "", _ajout: false };
          // Nils 17/10 : facture groupée — répartition proposée sur tous ses dossiers (reste dû de chacun), modifiable.
          const groupeEnc = !parts.length && c.factureGroupeeId ? dossiersDuGroupe(c) : [];
          if (groupeEnc.length > 1) {
            const rep = groupeEnc.map((x) => ({ dossierId: x.id, montant: String(arrondiH(Math.max(0, resteDe(x)))) }));
            const total = arrondiH(rep.reduce((n, x) => n + Number(x.montant), 0));
            set({ ...base, dossierId: groupeEnc[0].id, repartition: rep, ...(Number(f.montant) > 0 ? {} : { montant: String(total) }), designation: f.designation || `Encaissement ${c.numeroFacture} (${c.refFactureGroupee || "facture groupée"})` });
            return;
          }
          if (!parts.length) { set({ ...base, dossierId: c.id, designation: f.designation || `Encaissement ${c.numeroFacture || c.numeroBL || c.numero}` }); return; }
          if (parts.some((x) => x.dossierId === c.id)) return;
          const tot = Number(f.montant) || 0;
          const d0 = dossierParId(parts[0].dossierId) || {};
          const p0 = parts.length === 1 ? [{ dossierId: parts[0].dossierId, montant: String(arrondiH(Math.min(tot, Math.max(0, resteDe(d0))))) }] : parts;
          const reste = Math.max(0, arrondiH(tot - p0.reduce((n, x) => n + (Number(String(x.montant).replace(",", ".")) || 0), 0)));
          set({ ...base, repartition: [...p0, { dossierId: c.id, montant: String(reste) }], designation: f.designation && !/^Encaissement /.test(f.designation) ? f.designation : `Encaissement ${[...p0.map((x) => x.dossierId), c.id].map((id) => { const d = dossierParId(id) || {}; return d.numeroFacture || d.numeroBL || d.numero; }).join(" + ")}` });
        };
        const retirerPart = (i) => {
          const r = parts.filter((_, j) => j !== i);
          set(r.length >= 2 ? { repartition: r, dossierId: r[0].dossierId } : { repartition: undefined, dossierId: r.length ? r[0].dossierId : "" });
        };
        const sommeParts = parts.length >= 2 ? parts.reduce((n, x) => n + (Number(String(x.montant).replace(",", ".")) || 0), 0) : 0;
        const ff = f.factureFournisseur;
        const setFF = (patch) => set({ factureFournisseur: { ...ff, ...patch } });
        const fourF = ff ? fournisseurParNom(f.tiers) : null;
        const totalFact = ff && !ff.douane ? (ff.lignes || []).reduce((n, l) => n + (Number(l.ttc) || 0), 0) : 0;
        const tvaFact = ff && !ff.douane ? (ff.lignes || []).reduce((n, l) => n + ((Number(l.ttc) || 0) * Number(l.taux)) / (1 + Number(l.taux)), 0) : ff ? Number(ff.tvaQuittance) || 0 : 0;
        const natureDossier = (c) => {
          if (c.remplacement) return "facture de remplacement (client comptoir)";
          if (c.anterieure) return c.exoAnt ? "BLS antérieur à l'ERP (exo)" : "facture antérieure à l'ERP";
          return c.statut === "Facture" ? "facture" : c.statut === "BL" ? (exoDossier(c) ? "BLS (exo)" : "BL — avant facture") : `${c.statut} — avance`;
        };
        return (
          <Overlay onClose={() => setOpEdit(null)}>
            <div style={modalStyle(620)}>
              <div style={modalTitleStyle}>{estTransfert ? "Transfert" : nouveau ? (f.sens === "entree" ? "Nouvelle entrée" : "Nouvelle sortie") : "Opération"} — {compte ? compte.nom : ""}</div>
              {!estTransfert && !peutSaisirCompte(compte) && <div style={{ background: "#F5EFE0", color: OCRE, fontSize: 12, padding: "8px 12px", borderRadius: 6, marginTop: -6, marginBottom: 12 }}>Caisse en consultation : tu peux seulement relier cet encaissement à un dossier (facture, BLS, BC ou facture antérieure à l'ERP), en bas de la fiche.</div>}
              {estTransfert ? (
                <div style={{ fontSize: 13, lineHeight: 1.7 }}>
                  <div>{formatDate(f.date)} — <strong>{f.sens === "entree" ? "reçu" : "envoyé"} {formatDH(Number(f.montant))}</strong> — {f.designation}</div>
                  {f.type === "transfert" && f.sens === "entree" && <div>Statut : {f.statutTransfert}{f.confirmePar ? ` par ${f.confirmePar} le ${formatDate((f.confirmeLe || "").slice(0, 10))}` : ""}{f.montantRecu !== undefined && f.montantRecu !== "" ? ` — reçu ${formatDH(Number(f.montantRecu))}` : ""}{f.receptionNote ? ` — ${f.receptionNote}` : ""}</div>}
                  {f.type === "transfert-importé" && (() => {
                    const autre = f.rapprocheAvec ? (operations || []).find((x) => x.id === f.rapprocheAvec) : null;
                    return <div style={{ color: TAUPE }}>{f.contrepartieCreee ? `Contrepartie créée par ${f.par}` : `Mouvement de caisse importé (${f.importe ? f.importe.fichier : ""})`} — {autre ? <span style={{ color: VERT_OK }}>rapproché avec {(compteDe(autre.compteId) || {}).nom} : {formatDate(autre.date)}, {formatDH(Number(autre.montant))}, « {autre.designation} » (par {f.rapprochePar})</span> : <span style={{ color: OCRE }}>pas encore rapproché{peut("compta.rapprochementCaisses") ? " (Comptabilité › Mouvements de caisse à rapprocher)" : " — le Gérant s'en charge"}</span>}</div>;
                  })()}
                  <div style={{ color: TAUPE }}>Saisi par {f.par}</div>
                  {f.type === "transfert-importé" && !f.rapprocheAvec && peutSaisirCompte(compte) && (() => {
                    const avant = (operations || []).find((x) => x.id === f.id) || f;
                    const dateFichier = f.importe && f.importe.dateFichier;
                    return (
                      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginTop: 10 }}>
                        <span>Date :</span>
                        <input type="date" className="sc-input" max={todayISO()} value={f.date || ""} onChange={(e) => set({ date: e.target.value })} style={{ ...inputStyle(160), padding: "4px 8px" }} />
                        {f.date !== avant.date && <button type="button" className="sc-btn" onClick={() => changerDateMouvementImporte(f.id, f.date)} style={{ ...primaryBtnStyle, padding: "5px 12px", fontSize: 12 }}>Enregistrer la date</button>}
                        {dateFichier && <span style={{ fontSize: 11, color: TAUPE }}>date du fichier : {formatDate(dateFichier)}</span>}
                      </div>
                    );
                  })()}
                  {peut("compta.rapprochementCaisses") && f._contrepartie && aRapprocher((operations || []).find((x) => x.id === f.id) || {}) && (() => {
                    const cp = f._contrepartie;
                    const comptes = comptesPourContrepartie(f);
                    return (
                      <div style={{ background: PIERRE, borderRadius: 8, padding: 12, marginTop: 12 }}>
                        <div style={{ fontWeight: 600, marginBottom: 6 }}>Créer la contrepartie</div>
                        <div style={{ fontSize: 12, color: TAUPE, marginBottom: 8 }}>{f.sens === "sortie" ? "Entrée" : "Sortie"} de {formatDH(Number(f.montant))} — « {f.designation} » — créée dans le compte choisi et rapprochée tout de suite avec cette ligne.</div>
                        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                          <select className="sc-select" value={cp.compteId} onChange={(e) => set({ _contrepartie: { ...cp, compteId: e.target.value } })} style={{ ...selectStyle, width: 220 }}>
                            <option value="">— Compte d'en face —</option>
                            {comptes.map((c) => (<option key={c.id} value={c.id}>{c.nom}</option>))}
                          </select>
                          <input type="date" className="sc-input" max={todayISO()} value={cp.date} onChange={(e) => set({ _contrepartie: { ...cp, date: e.target.value } })} style={{ ...inputStyle(160), padding: "4px 8px" }} />
                          <button type="button" className="sc-btn" disabled={!cp.compteId} onClick={() => creerContrepartie(f.id, cp.compteId, cp.date)} style={{ ...primaryBtnStyle, padding: "5px 12px", fontSize: 12, opacity: cp.compteId ? 1 : 0.5 }}>Créer</button>
                          <button type="button" className="sc-btn" onClick={() => set({ _contrepartie: undefined })} style={{ ...ghostBtnStyle, fontSize: 12 }}>Annuler</button>
                        </div>
                      </div>
                    );
                  })()}
                  <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 14, flexWrap: "wrap" }}>
                    {(peut("compta.supprimerTransfert") || f.type === "transfert-importé") && <button type="button" className="sc-btn" onClick={async () => { if (await demander(f.type === "transfert" ? "Supprimer ce transfert (les deux côtés) ?" : "Supprimer cette opération ?")) supprimerOperation(f.id); }} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>Supprimer</button>}
                    {peut("compta.rapprochementCaisses") && f.type === "transfert-importé" && f.rapprocheAvec && <button type="button" className="sc-btn" onClick={() => delierMouvement(f.id)} style={ghostBtnStyle}>Annuler le rapprochement</button>}
                    {peut("compta.rapprochementCaisses") && f.type === "transfert-importé" && !f.rapprocheAvec && !f._contrepartie && <button type="button" className="sc-btn" onClick={() => set({ _contrepartie: { compteId: "", date: ((operations || []).find((x) => x.id === f.id) || f).date } })} style={ghostBtnStyle}>➕ Créer la contrepartie</button>}
                    {peut("compta.rapprochementCaisses") && f.type === "transfert-importé" && !f.rapprocheAvec && <button type="button" className="sc-btn" onClick={() => setOpEdit({ ...f, type: "normal", poste: "", sousPoste: "", sansContrepartie: true })} style={ghostBtnStyle}>Pas de contrepartie → classer</button>}
                    <button type="button" className="sc-btn" onClick={() => setOpEdit(null)} style={ghostBtnStyle}>Fermer</button>
                  </div>
                </div>
              ) : (
                <>
                  <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
                    {[["entree", "Entrée", VERT_OK], ["sortie", "Sortie", ROUILLE]].map(([s, l, coul]) => (
                      <button key={s} type="button" className="sc-btn" onClick={() => { if (f.sens !== s) set({ sens: s, ...(postesPourSens(s).some((p) => p.poste === f.poste) ? {} : { poste: "", sousPoste: "", dossierId: "" }), ...(typesTiersPour(s).includes(f.tiersType) ? {} : { tiersType: "", tiers: "" }), ...(s === "entree" ? { factureFournisseur: undefined } : { repartition: undefined }) }); }} style={{ ...(f.sens === s ? primaryBtnStyle : ghostBtnStyle), ...(f.sens === s ? { background: coul, borderColor: coul } : { color: coul }), fontSize: 13, padding: "6px 16px" }}>{l}</button>
                    ))}
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                    <Field label="Date"><input type="date" className="sc-input" max={todayISO()} value={f.date || ""} onChange={(e) => set({ date: e.target.value })} style={inputStyle("100%")} /></Field>
                    {estCompteDevises(compte) ? (
                      <Field label={`${f.sens === "sortie" ? "Montant payé" : "Montant reçu"} (${compte.devise === "EUR" ? "€" : compte.devise})`}><input type="number" min="0" step="0.01" className="sc-input" value={f.montantDevise ?? ""} onChange={(e) => set({ montantDevise: e.target.value })} style={inputStyle("100%")} /></Field>
                    ) : (
                    <Field label={f.sens === "sortie" ? "Montant payé (DH)" : "Montant reçu (DH)"}><input type="number" min="0" step="0.01" className="sc-input" value={f.montant} onChange={(e) => { const v = e.target.value; const ff0 = f.factureFournisseur; const synchro = ff0 && !ff0.douane && (ff0.lignes || []).length === 1 && String(ff0.lignes[0].ttc) === ""; set({ montant: v, ...(synchro ? { factureFournisseur: { ...ff0, lignes: [{ ...ff0.lignes[0], ttc: v }] } } : {}) }); }} style={inputStyle("100%")} /></Field>
                    )}
                    {estCompteDevises(compte) && (() => {
                      const t = tauxMoyenDevises(compte.id, f.date, f.id);
                      const auto = t ? Math.round(nombreOuZero(f.montantDevise) * t * 100) / 100 : null;
                      const val = f._mad !== undefined ? f._mad : f.madManuel ? String(f.montant) : "";
                      return (
                        <Field label="Contre-valeur (DH)">
                          <input type="number" min="0" step="0.01" className="sc-input" value={val} placeholder={auto !== null ? String(auto) : "à saisir"} onChange={(e) => set({ _mad: e.target.value })} style={inputStyle("100%")} />
                          <div style={{ fontSize: 10, color: TAUPE }}>{t ? `vide = taux moyen ${t.toFixed(4).replace(".", ",")}` : "aucun taux connu : saisis les dirhams"}</div>
                        </Field>
                      );
                    })()}
                    <Field label="Mode">
                      <select className="sc-select" value={f.mode || ""} onChange={(e) => set({ mode: e.target.value })} style={{ ...selectStyle, width: "100%" }}>
                        {(f.compteId === PORTEFEUILLE_ID ? ["Chèque", "Effet / LCN"] : MODES_PAIEMENT).map((m) => (<option key={m} value={m}>{m}</option>))}
                      </select>
                    </Field>
                  </div>
                  <datalist id="tiers-compta">{nomsTiers(f.tiersType).map((n) => (<option key={n} value={n} />))}</datalist>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 12 }}>
                    <Field label={f.sens === "entree" ? "Reçu de" : "Payé à"}>
                      <select className="sc-select" value={f.tiersType || ""} onChange={(e) => { const t = e.target.value; const pst = POSTE_PAR_TIERS[t]; const okPoste = pst && !f.poste && postesPourSens(f.sens).some((x) => x.poste === pst); const pl = okPoste ? planPostes().find((x) => x.poste === pst) : null; set({ tiersType: t, tiers: "", dossierId: "", repartition: undefined, reglements: undefined, ...(okPoste ? { poste: pst, sousPoste: pl && pl.sous.length === 1 ? pl.sous[0] : "" } : {}) }); }} style={{ ...selectStyle, width: "100%" }}>
                        <option value="">— Type de tiers —</option>
                        {typesTiersPour(f.sens).map((t) => (<option key={t} value={t}>{libelleTypeTiers(t)}{f.sens === "entree" && t === "fournisseur" ? " (remboursement)" : f.sens === "entree" && t === "associe" ? " (apport)" : f.sens === "entree" && t === "employe" ? " (remboursement d'avance)" : f.sens === "entree" && t === "etat" ? " (remboursement)" : ""}</option>))}
                        {f.importe && !f.tiersType && <option value="">Non classé (importé)</option>}
                      </select>
                      {peut("compta.parametrer") && <button type="button" className="sc-btn" onClick={() => setGestionCompta({ type: "typesTiers" })} style={{ ...ghostBtnStyle, padding: "3px 0", fontSize: 12 }}>Gérer les types de tiers</button>}
                    </Field>
                    <Field label={f.tiersType ? libelleTypeTiers(f.tiersType) : "Tiers"}>
                      {f.tiersType ? (
                        <select className="sc-select" value={nomsTiers(f.tiersType).find((n) => normLib(n) === normLib(f.tiers)) || ""} onChange={(e) => set({ tiers: e.target.value, reglements: undefined, ...(f.factureFournisseur ? { factureFournisseur: { ...f.factureFournisseur, douane: f.tiersType === "etat" && /douane/i.test(e.target.value) } } : {}) })} style={{ ...selectStyle, width: "100%" }}>
                          <option value="">— Choisir —</option>
                          {nomsTiers(f.tiersType).map((n) => (<option key={n} value={n}>{n}</option>))}
                        </select>
                      ) : (
                        <input className="sc-input" disabled value={f.importe ? f.tiers || "" : ""} placeholder="Choisis d'abord le type" style={inputStyle("100%")} />
                      )}
                      {f.importe && f.tiers && f.tiersType && !nomsTiers(f.tiersType).some((n) => normLib(n) === normLib(f.tiers)) && <div style={{ fontSize: 11, color: TAUPE, marginTop: 3 }}>Tiers du fichier importé : « {f.tiers} »</div>}
                      {f.tiersType === "fournisseur" && peutEcrireFour && <button type="button" className="sc-btn" onClick={() => { setActiveTab("fournisseurs"); openFourNew(); }} style={{ ...ghostBtnStyle, padding: "3px 0", fontSize: 12 }} title="Ouvre la fiche de création dans l'onglet Fournisseurs ; ta saisie en cours t'attend dans Comptabilité">+ Nouveau fournisseur</button>}
                      {f.tiersType === "client" && peutCreerClient && <button type="button" className="sc-btn" onClick={() => { setActiveTab("clients"); openClientNew(); }} style={{ ...ghostBtnStyle, padding: "3px 0", fontSize: 12 }} title="Ouvre la fiche de création dans l'onglet Clients ; ta saisie en cours t'attend dans Comptabilité">+ Nouveau client</button>}
                      {f.tiersType === "employe" && peutGererStaff && <button type="button" className="sc-btn" onClick={() => { setActiveTab("staff"); setConfirmSupprStaff(false); setOngletFicheStaff("identite"); setStaffEdit(ficheStaffVide()); }} style={{ ...ghostBtnStyle, padding: "3px 0", fontSize: 12 }} title="Ouvre la fiche de création dans l'onglet Staff ; ta saisie en cours t'attend dans Comptabilité">+ Nouvel employé</button>}
                      {peut("compta.parametrer") && (f.tiersType === "etat" || f.tiersType === "associe" || String(f.tiersType || "").startsWith("perso:")) && <button type="button" className="sc-btn" onClick={() => setGestionCompta({ type: String(f.tiersType).startsWith("perso:") ? "typesTiers" : f.tiersType })} style={{ ...ghostBtnStyle, padding: "3px 0", fontSize: 12 }}>Gérer la liste</button>}
                    </Field>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                    <Field label="Poste">
                      <select className="sc-select" value={f.poste || ""} onChange={(e) => choisirPoste(e.target.value)} style={{ ...selectStyle, width: "100%" }}>
                        <option value="">— Poste —</option>
                        {postes.map((p) => (<option key={p.poste} value={p.poste}>{p.poste}</option>))}
                      </select>
                      {peut("compta.parametrer") && <button type="button" className="sc-btn" onClick={() => setGestionCompta({ type: "postes" })} style={{ ...ghostBtnStyle, padding: "3px 0", fontSize: 12 }}>Gérer les postes et sous-postes</button>}
                    </Field>
                    <Field label="Sous-poste">
                      <select className="sc-select" value={f.sousPoste || ""} onChange={(e) => set({ sousPoste: e.target.value })} disabled={!posteSel} style={{ ...selectStyle, width: "100%" }}>
                        <option value="">— Sous-poste —</option>
                        {(posteSel ? posteSel.sous : []).filter((s) => !(s === SOUS_POSTE_AVANCES && f.sens === "sortie" && (compteDe(f.compteId) || {}).type !== "banque" && f.sousPoste !== s)).map((s) => (<option key={s} value={s}>{s}</option>))}
                      </select>
                    </Field>
                  </div>
                  {f.sens === "sortie" && f.tiersType === "employe" && f.sousPoste === SOUS_POSTE_PRIMES && (
                    <Field label="Type de prime (repris dans la fiche Staff)">
                      <select className="sc-select" value={f.typePrime || ""} onChange={(e) => set({ typePrime: e.target.value })} style={{ ...selectStyle, width: "100%" }}>
                        <option value="">— Type —</option>
                        {typesPrimesVersees().map((t) => (<option key={t} value={t}>{t}</option>))}
                      </select>
                    </Field>
                  )}
                  <Field label="Désignation (ex. Loyer octobre, Salaire novembre, Disques 350)"><input className="sc-input" value={f.designation || ""} onChange={(e) => set({ designation: e.target.value })} style={inputStyle("100%")} /></Field>
                  {f.importe && f.importe.origine && <div style={{ fontSize: 11, color: TAUPE, marginTop: -8, marginBottom: 10 }}>Libellé du fichier importé : « {f.importe.origine} » ({f.importe.fichier}, ligne {f.importe.ligne})</div>}
                  {f.poste === POSTE_ENCAISSEMENT && (
                    <Field label={parts.length >= 2 ? `Factures couvertes (${parts.length}) — répartis le montant` : f.aRelierPlusTard && !parts.length ? "Dossier — à relier plus tard" : "Dossier (obligatoire) — facture, BLS exo, ou BC pour une avance"}>
                      {!parts.length && !f.importe && f.sens === "entree" && (
                        <label style={{ fontSize: 12, display: "flex", gap: 6, alignItems: "center", marginBottom: 6, color: f.aRelierPlusTard ? OCRE : TAUPE }}>
                          <input type="checkbox" checked={!!f.aRelierPlusTard} onChange={(e) => set({ aRelierPlusTard: e.target.checked || undefined })} /> Facture pas encore dans l'ERP — à relier plus tard (l'encaissement restera dans la tâche « à relier à un dossier »)
                        </label>
                      )}
                      {parts.map((x, i) => {
                        const d = dossierParId(x.dossierId);
                        return (
                          <div key={x.dossierId} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 13, background: PIERRE, borderRadius: 6, padding: "6px 10px", marginBottom: 4 }}>
                            <span style={{ flex: 1 }}><strong>{d ? libDossierTreso(d) : "?"}</strong> {d && <span style={{ color: TAUPE }}>({natureDossier(d)})</span>}<br /><span style={{ fontSize: 12 }}>{d ? <>Total TTC {formatDH(totalDossierTTC(d))} · reste avant cette opération : <strong>{formatDH(resteDe(d))}</strong></> : null}</span></span>
                            {parts.length >= 2 && <input type="number" min="0" step="0.01" className="sc-input" value={x.montant} onChange={(e) => set({ repartition: parts.map((y, j) => (j === i ? { ...y, montant: e.target.value } : y)) })} style={{ ...inputStyle(120), padding: "4px 8px" }} />}
                            <button type="button" className="sc-btn" onClick={() => retirerPart(i)} style={iconBtnStyle} title="Retirer">✕</button>
                          </div>
                        );
                      })}
                      {parts.length >= 2 && <div style={{ fontSize: 12, color: Math.abs(sommeParts - (Number(f.montant) || 0)) > 0.01 ? ROUILLE : VERT_OK, marginBottom: 6 }}>Réparti : {formatDH(sommeParts)} sur {formatDH(Number(f.montant) || 0)}</div>}
                      {parts.length > 0 && !f._ajout && <button type="button" className="sc-btn" onClick={() => set({ _ajout: true, _q: "" })} style={{ ...ghostBtnStyle, fontSize: 12 }}>+ Une autre facture sur ce même paiement</button>}
                      {(!parts.length || f._ajout) && (
                        <>
                          <input className="sc-input" value={f._q || ""} onChange={(e) => set({ _q: e.target.value })} placeholder="Chercher : n° de facture, BL, BC, client, référence…" style={inputStyle("100%")} />
                          <div style={{ maxHeight: 200, overflowY: "auto", marginTop: 6, display: "flex", flexDirection: "column", gap: 3 }}>
                            {candidats.length === 0 && <div style={{ fontSize: 12, color: TAUPE }}>Aucun dossier.</div>}
                            {candidats.filter((c) => !parts.some((x) => x.dossierId === c.id)).map((c) => (
                              <div key={c.id} className="sc-row" onClick={() => choisirDossier(c)} style={{ cursor: "pointer", fontSize: 12, padding: "5px 8px", borderRadius: 6, background: PIERRE, display: "flex", gap: 8 }}>
                                <span style={{ flex: 1 }}>{libDossierTreso(c)}{c.reference ? <span style={{ color: TAUPE }}> — {c.reference}</span> : null}</span>
                                <span style={{ color: TAUPE, whiteSpace: "nowrap" }}>{natureDossier(c)} · reste {formatDH(resteDe(c))}</span>
                              </div>
                            ))}
                          </div>
                          {/* Nils 30/10 : facture client d'avant l'ERP ajoutée sans quitter l'encaissement, puis rattachée. */}
                          {peutGererFacturesAnt && f.tiersType === "client" && (() => {
                            const cl = (clients || []).find((c) => normLib(c.nom) === normLib(f.tiers || ""));
                            if (!cl) return null;
                            const dejaParts = parts.reduce((n, x) => n + (Number(String(x.montant).replace(",", ".")) || 0), 0);
                            const montant = Math.max(0, arrondiH((Number(String(f.montant || "").replace(",", ".")) || 0) - (parts.length >= 2 ? dejaParts : parts.length ? Number(String(parts[0].montant).replace(",", ".")) || 0 : 0)));
                            return <button type="button" className="sc-btn" onClick={() => setAntSaisie({ clientId: cl.id, numero: "", date: "", reference: "", ttc: montant ? String(montant) : "", exo: false, chantierId: "", dejaRegle: "", remarque: "", _pourOp: true })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0", marginTop: 4 }}>+ Ajouter une facture antérieure à l'ERP de {cl.nom}</button>;
                          })()}
                        </>
                      )}
                    </Field>
                  )}
                  {f.sens === "sortie" && f.sousPoste === "Prime de déplacement" && (() => {
                    // Nils 05/10 : choix du ou des mois de déplacement à indemniser (montant = fiches).
                    const choisis = f.primesDeplMois || [];
                    const dispo = [...new Set([...moisPrimesAIndemniser(f.id), ...choisis])].sort();
                    const total = (l) => l.reduce((n, ym) => n + primesDeplacementDues(ym).total, 0);
                    const basculer = (ym) => { const l = choisis.includes(ym) ? choisis.filter((x) => x !== ym) : [...choisis, ym].sort(); set({ primesDeplMois: l, montant: l.length ? String(Math.round(total(l) * 100) / 100) : f.montant, designation: l.length ? `Primes de déplacement — ${l.map(libPeriode).join(" + ")}` : f.designation }); };
                    const detail = {};
                    choisis.forEach((ym) => Object.values(primesDeplacementDues(ym).parPers).forEach((p) => { detail[p.nom] = (detail[p.nom] || 0) + p.montant; }));
                    return (
                      <div style={{ background: PIERRE, borderRadius: 8, padding: 10, marginBottom: 12 }}>
                        <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>Mois de déplacement indemnisés</div>
                        {estGerant && !choisis.length && (
                          <label style={{ fontSize: 12, display: "flex", gap: 6, alignItems: "center", marginBottom: 6, color: f.primeDeplAnterieure ? OCRE : TAUPE }}>
                            <input type="checkbox" checked={!!f.primeDeplAnterieure} onChange={(e) => set({ primeDeplAnterieure: e.target.checked || undefined })} /> Paiement antérieur aux fiches de déplacement (sans mois) — au nom de l'employé, montant libre
                          </label>
                        )}
                        {f.primeDeplAnterieure ? null : <>
                        {f.compteId !== "caisse-nils" && <div style={{ fontSize: 12, color: ROUILLE, marginBottom: 6 }}>Les primes de déplacement se versent depuis la Caisse Nils.</div>}
                        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                          {dispo.map((ym) => (
                            <label key={ym} style={{ fontSize: 12, background: "#fff", borderRadius: 6, padding: "4px 8px", display: "inline-flex", gap: 6, alignItems: "center", cursor: "pointer" }}>
                              <input type="checkbox" checked={choisis.includes(ym)} onChange={() => basculer(ym)} /> {libPeriode(ym)} — {formatDH(primesDeplacementDues(ym).total)}
                            </label>
                          ))}
                        </div>
                        {!dispo.length && <div style={{ fontSize: 12, color: TAUPE }}>Aucun mois de déplacement à indemniser.</div>}
                        {!!choisis.length && <div style={{ fontSize: 12, marginTop: 6 }}>Détail : {Object.entries(detail).map(([n, m]) => `${n} ${formatDH(m)}`).join(" · ")} — <b>total {formatDH(total(choisis))}</b></div>}
                        </>}
                      </div>
                    );
                  })()}
                  {f.sens === "sortie" && SOUS_POSTES_VEHICULE.includes(f.sousPoste) && (() => {
                    // ERP step 15 (ak) : répartition par véhicule (une recharge Total peut couvrir plusieurs cartes).
                    const lignes = f.vehicules && f.vehicules.length ? f.vehicules : [{ vehiculeId: "", montant: "" }];
                    const setL = (i, patch) => set({ vehicules: lignes.map((x, j) => (j === i ? { ...x, ...patch } : x)) });
                    const somme = lignes.reduce((n, x) => n + nombreOuZero(x.montant), 0);
                    const total = nombreOuZero(f.montant);
                    const vehs = vehiculesFlotte();
                    return (
                      <div style={{ background: PIERRE, borderRadius: 8, padding: 10, marginBottom: 12 }}>
                        <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>Véhicule(s) concerné(s)</div>
                        {lignes.map((x, i) => (
                          <div key={i} style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 6 }}>
                            <select className="sc-select" value={x.vehiculeId} onChange={(e) => setL(i, { vehiculeId: e.target.value })} style={{ ...selectStyle, width: 220, background: "#fff" }}>
                              <option value="">— Véhicule —</option>
                              {vehs.filter((v) => v.actif !== false || v.id === x.vehiculeId).map((v) => (<option key={v.id} value={v.id}>{v.nom}{v.immat ? ` (${v.immat})` : ""}</option>))}
                              <option value="hors">Hors flotte (autre véhicule)</option>
                            </select>
                            {lignes.length > 1 && <input type="number" min="0" step="0.01" className="sc-input" placeholder="montant" value={x.montant} onChange={(e) => setL(i, { montant: e.target.value })} style={{ ...inputStyle(120), padding: "5px 6px" }} />}
                            {lignes.length > 1 && <button type="button" className="sc-btn" onClick={() => set({ vehicules: lignes.filter((_, j) => j !== i) })} style={iconBtnStyle}>✕</button>}
                          </div>
                        ))}
                        <button type="button" className="sc-btn" onClick={() => set({ vehicules: [...lignes.map((x) => (lignes.length === 1 ? { ...x, montant: x.montant || f.montant || "" } : x)), { vehiculeId: "", montant: "" }] })} style={{ ...ghostBtnStyle, padding: "2px 0", fontSize: 12 }}>+ Répartir sur un autre véhicule</button>
                        {lignes.length > 1 && <div style={{ fontSize: 12, marginTop: 4, color: Math.abs(somme - total) > 0.01 ? ROUILLE : VERT_OK }}>Réparti {formatDH(somme)} sur {formatDH(total)}{Math.abs(somme - total) > 0.01 ? ` — reste ${formatDH(total - somme)}` : " ✓"}</div>}
                        <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Une recharge Total ou Jawaz qui couvre plusieurs cartes : une ligne par véhicule, comme dans la demande à Total.</div>
                      </div>
                    );
                  })()}
                  {f.sens === "sortie" && f.poste === "Commissions" && f.sousPoste === "Commissions versées" && (() => {
                    // Nils 05/10 : versement d'une commission maturée (validée, pas entièrement versée) depuis cette caisse.
                    const dispo = commissionsMaturees(f.compteId, f.id);
                    const actuelle = f.commissionCle ? commissionsMaturees("", f.id).find((x) => x.cle === f.commissionCle) : null;
                    const liste = actuelle && !dispo.some((x) => x.cle === actuelle.cle) ? [actuelle, ...dispo] : dispo;
                    return (
                      <div style={{ background: PIERRE, borderRadius: 8, padding: 10, marginBottom: 12 }}>
                        {estGerant && !f.commissionCle && (
                          <label style={{ fontSize: 12, display: "flex", gap: 6, alignItems: "center", marginBottom: 6, color: f.commissionAnterieure ? OCRE : TAUPE }}>
                            <input type="checkbox" checked={!!f.commissionAnterieure} onChange={(e) => set({ commissionAnterieure: e.target.checked || undefined })} /> Commission antérieure à l'ERP (sans commission validée) — tiers et montant libres
                          </label>
                        )}
                        {f.commissionAnterieure ? null : <>
                        <Field label="Commission versée" style={{ marginBottom: 4 }}>
                          <select className="sc-select" value={f.commissionCle || ""} onChange={(e) => { const c = liste.find((x) => x.cle === e.target.value); set(c ? { commissionCle: c.cle, tiers: c.nom, tiersType: (staff || []).some((x) => normLib(x.nom) === normLib(c.nom)) ? "employe" : f.tiersType, montant: f.montant || String(c.reste), designation: f.designation || `Commission ${c.libelle} — ${libPeriode(c.per)} — ${c.nom}` } : { commissionCle: undefined }); }} style={{ ...selectStyle, width: "100%", background: "#fff" }}>
                            <option value="">— Choisir une commission validée —</option>
                            {liste.map((c) => (<option key={c.cle} value={c.cle}>{c.nom} — {c.libelle} — {libPeriode(c.per)} — reste {formatDH(c.reste)}</option>))}
                          </select>
                        </Field>
                        <div style={{ fontSize: 11, color: TAUPE }}>{liste.length ? "Seules les commissions validées par le Gérant et payables depuis ce compte sont proposées." : "Aucune commission validée à verser depuis ce compte (Taha : caisse Taha ou le Gérant ; Soufiane : caisse Chraa ou le Gérant ; apporteurs : caisse Nils)."}</div>
                        </>}
                      </div>
                    );
                  })()}
                  {f.sens === "sortie" && ["fournisseur", "etat"].includes(f.tiersType) && f.tiers && (() => {
                    const parts = f.reglements || [];
                    const obligatoire = compte && compte.type === "banque" && f.tiersType === "fournisseur" && !f.factureFournisseur;
                    const dispo = (facturesF || []).filter((x) => normLib(x.fournisseur) === normLib(f.tiers) && !x.remplaceePar && !parts.some((r) => r.factureId === x.id)).map((x) => ({ x, reste: resteFactureF(x) + (avant ? (avant.reglements || []).filter((r) => r.factureId === x.id).reduce((n, r) => n + (Number(r.montant) || 0), 0) : 0) })).filter((y) => y.reste > 0.01).sort((a, b) => ((echeanceFactureF(a.x) || a.x.date) < (echeanceFactureF(b.x) || b.x.date) ? -1 : 1));
                    const somme = parts.reduce((n, r) => n + (Number(String(r.montant).replace(",", ".")) || 0), 0);
                    return (
                      <div style={{ border: `1px solid ${obligatoire && !parts.length ? OCRE : PIERRE}`, borderRadius: 8, padding: "8px 12px", marginBottom: 14 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>Factures réglées{obligatoire ? " (obligatoire sur la banque)" : " (facultatif)"}</div>
                        {parts.map((r, i) => {
                          const fa = (facturesF || []).find((x) => x.id === r.factureId);
                          return (
                            <div key={r.factureId} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12, background: PIERRE, borderRadius: 6, padding: "5px 10px", marginBottom: 4 }}>
                              <span style={{ flex: 1 }}>{fa ? <><strong>{fa.type === "devis" ? "Devis / proforma" : "Facture"} {fa.numero || "sans n°"}</strong> du {formatDate(fa.date)} — TTC {formatDH(ttcFactureF(fa))} — reste avant ce paiement {formatDH(resteFactureF(fa) + (avant ? (avant.reglements || []).filter((y) => y.factureId === fa.id).reduce((n, y) => n + (Number(y.montant) || 0), 0) : 0))}{fa.controle === "à contrôler" ? <span style={{ color: OCRE }}> — à contrôler</span> : null}</> : "?"}</span>
                              {parts.length > 1 && <input type="number" min="0" step="0.01" className="sc-input" value={r.montant} onChange={(e) => set({ reglements: parts.map((y, j) => (j === i ? { ...y, montant: e.target.value } : y)) })} style={{ ...inputStyle(120), padding: "3px 8px" }} />}
                              <button type="button" className="sc-btn" onClick={() => set({ reglements: parts.filter((_, j) => j !== i) })} style={iconBtnStyle} title="Retirer">✕</button>
                            </div>
                          );
                        })}
                        {parts.length > 1 && <div style={{ fontSize: 12, color: Math.abs(somme - (Number(f.montant) || 0)) > 0.01 ? ROUILLE : VERT_OK, marginBottom: 4 }}>Réparti : {formatDH(somme)} sur {formatDH(Number(f.montant) || 0)}</div>}
                        {dispo.length > 0 && (
                          <select className="sc-select" value="" onChange={(e) => { const y = dispo.find((d) => d.x.id === e.target.value); if (!y) return; const vide = String(f.montant) === "" && !parts.length; set({ reglements: [...parts, { factureId: y.x.id, montant: String(parts.length ? y.reste : arrondiH(Math.min(y.reste, Number(f.montant) || y.reste))) }], ...(vide ? { montant: String(y.reste) } : {}) }); }} style={{ ...selectStyle, width: "100%", fontSize: 12, marginTop: 4 }}>
                            <option value="">+ Rattacher une facture de {f.tiers} ({dispo.length} à payer)</option>
                            {dispo.map((y) => (<option key={y.x.id} value={y.x.id}>{y.x.type === "devis" ? "Devis" : "Fact."} {y.x.numero || "sans n°"} du {formatDate(y.x.date)} — reste {formatDH(y.reste)}{echeanceFactureF(y.x) ? ` — échéance ${formatDate(echeanceFactureF(y.x))}` : ""}</option>))}
                          </select>
                        )}
                        {!dispo.length && !parts.length && <div style={{ fontSize: 12, color: TAUPE }}>Aucune facture à payer enregistrée pour {f.tiers}.</div>}
                        {peutSaisirFactureF && <button type="button" className="sc-btn" onClick={() => setFactFEdit({ ...nouvelleFactureF(f.tiersType, f.tiers), _pourOp: true })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0" }}>+ Saisir une facture / un devis de {f.tiers}</button>}
                      </div>
                    );
                  })()}
                  {f.factureFournisseur && f.sens === "sortie" && ["fournisseur", "etat"].includes(f.tiersType) && f.tiers && (
                    <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "8px 12px", marginBottom: 14 }}>
                      <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                        <input type="checkbox" checked={!!ff} onChange={(e) => set({ factureFournisseur: e.target.checked ? { ...factureVide(f), douane: f.tiersType === "etat" && /douane/i.test(f.tiers || "") } : undefined })} />
                        {f.tiersType === "etat" && /douane/i.test(f.tiers) ? "Quittance de douane (TVA — fichier du comptable)" : "Facture fournisseur (TVA — fichier du comptable)"}
                      </label>
                      {ff && (
                        <div style={{ marginTop: 10 }}>
                          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                            <Field label="N° de facture / quittance"><input className="sc-input" value={ff.numero} onChange={(e) => setFF({ numero: e.target.value })} style={inputStyle("100%")} /></Field>
                            <Field label="Date de facture"><input type="date" className="sc-input" value={ff.date || ""} onChange={(e) => setFF({ date: e.target.value })} style={inputStyle("100%")} /></Field>
                          </div>
                          <div style={{ fontSize: 12, marginTop: -8, marginBottom: 10 }}>
                            {f.tiersType !== "fournisseur" ? null : fourF ? (fourF.ice ? <span style={{ color: iceValide(fourF.ice) ? TAUPE : ROUILLE }}>ICE {fourF.ice}{iceValide(fourF.ice) ? "" : " — pas 15 chiffres, à vérifier"}</span> : <span style={{ color: OCRE }}>ICE manquant : <input className="sc-input" value={ff.ice || ""} onChange={(e) => setFF({ ice: e.target.value })} placeholder="ICE (15 chiffres)" style={{ ...inputStyle(170), padding: "3px 8px", fontSize: 12 }} /></span>) : null}
                          </div>
                          <div style={{ display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap", fontSize: 12, marginBottom: 8 }}>
                            <label style={{ display: "flex", alignItems: "center", gap: 4 }}><input type="checkbox" checked={!!ff.douane} onChange={(e) => setFF({ douane: e.target.checked })} />Quittance de douane</label>
                          </div>
                          {ff.douane ? (
                            <div style={{ display: "flex", gap: 10, alignItems: "center", fontSize: 12, flexWrap: "wrap" }}>
                              <span>TVA inscrite sur la quittance</span>
                              <input type="number" min="0" step="0.01" className="sc-input" value={ff.tvaQuittance} onChange={(e) => setFF({ tvaQuittance: e.target.value })} style={{ ...inputStyle(130), padding: "4px 8px" }} />
                              {Number(ff.tvaQuittance) > 0 && <span style={{ color: TAUPE }}>→ fichier du comptable : TVA {formatDH(Number(ff.tvaQuittance))} ; le reste du paiement ({formatDH(Math.max(0, (Number(f.montant) || 0) - Number(ff.tvaQuittance) * 6))}) en droits sans TVA</span>}
                            </div>
                          ) : (
                            <>
                              {(ff.lignes || []).map((l, i) => (
                                <div key={i} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, marginBottom: 4 }}>
                                  <span style={{ width: 70 }}>{i === 0 ? "TTC facture" : ""}</span>
                                  <input type="number" min="0" step="0.01" className="sc-input" value={l.ttc} onChange={(e) => { const lignes = ff.lignes.map((y, j) => (j === i ? { ...y, ttc: e.target.value } : y)); const ancien = ff.lignes.reduce((n, y) => n + (Number(y.ttc) || 0), 0); const nouveau = lignes.reduce((n, y) => n + (Number(y.ttc) || 0), 0); const synchro = String(f.montant) === "" || Number(f.montant) === ancien; set({ factureFournisseur: { ...ff, lignes }, ...(synchro ? { montant: nouveau ? String(arrondiH(nouveau)) : "" } : {}) }); }} style={{ ...inputStyle(130), padding: "4px 8px" }} />
                                  <span>à</span>
                                  <select className="sc-select" value={l.taux} onChange={(e) => setFF({ lignes: ff.lignes.map((y, j) => (j === i ? { ...y, taux: Number(e.target.value) } : y)) })} style={{ ...selectStyle, width: 80, fontSize: 12 }}>{TAUX_TVA.map((t) => (<option key={t} value={t}>{Math.round(t * 100)} %</option>))}</select>
                                  <span style={{ color: TAUPE }}>TVA {formatDH(((Number(l.ttc) || 0) * Number(l.taux)) / (1 + Number(l.taux)))}</span>
                                  {ff.lignes.length > 1 && <button type="button" className="sc-btn" onClick={() => setFF({ lignes: ff.lignes.filter((_, j) => j !== i) })} style={iconBtnStyle} title="Retirer">✕</button>}
                                </div>
                              ))}
                              <div style={{ display: "flex", gap: 12, alignItems: "center", fontSize: 12 }}>
                                <button type="button" className="sc-btn" onClick={() => setFF({ lignes: [...ff.lignes, { taux: 0, ttc: "" }] })} style={{ ...ghostBtnStyle, fontSize: 12 }}>+ Autre taux sur la même facture</button>
                                <span style={{ color: TAUPE }}>Facture {formatDH(totalFact)} · TVA {formatDH(tvaFact)}{totalFact ? ` · réglé ${Math.round(((Number(f.montant) || 0) / totalFact) * 100)} %` : ""}</span>
                              </div>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                  <div style={{ display: "grid", gridTemplateColumns: f.sens === "entree" && ["Chèque", "Effet / LCN"].includes(f.mode) ? "1.6fr 1fr 1fr" : "1fr", gap: 12 }}>
                    <Field label="Réf. du paiement (n° de chèque, d'effet, de virement…)"><input className="sc-input" value={f.piece || ""} onChange={(e) => set({ piece: e.target.value })} style={inputStyle("100%")} /></Field>
                    {f.sens === "entree" && ["Chèque", "Effet / LCN"].includes(f.mode) && (
                      <Field label="Date du chèque (obligatoire)"><input type="date" className="sc-input" value={f.echeanceCheque || ""} onChange={(e) => set({ echeanceCheque: e.target.value })} style={inputStyle("100%")} /></Field>
                    )}
                    {f.sens === "entree" && ["Chèque", "Effet / LCN"].includes(f.mode) && (
                      <Field label="Encaissement prévu le (facultatif)"><input type="date" className="sc-input" min={f.echeanceCheque || undefined} value={f.encaissementPrevu || ""} onChange={(e) => set({ encaissementPrevu: e.target.value || undefined, ...(e.target.value ? { sansVisibilite: false } : {}) })} style={inputStyle("100%")} /></Field>
                    )}
                  </div>
                  {f.sens === "entree" && ["Chèque", "Effet / LCN"].includes(f.mode) && (() => {
                    const det = f.detenteur || (nouveau ? user.id : "");
                    const peutPasser = !nouveau && !f.chequeRemisLe && (estGerant || det === user.id || peutSaisirCompte(compte));
                    return (
                      <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "8px 12px", marginBottom: 12, fontSize: 13 }}>
                        <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", marginBottom: 6 }}>
                          <input type="checkbox" checked={!!f.sansVisibilite} onChange={(e) => set({ sansVisibilite: e.target.checked, ...(e.target.checked ? { encaissementPrevu: undefined } : {}) })} />
                          Pas de visibilité sur l'encaissement <span style={{ fontSize: 11, color: TAUPE }}>(hors prévisionnel, pas de tâche « remettre en banque »)</span>
                        </label>
                        {f.echeanceCheque && <div style={{ fontSize: 11, color: TAUPE, marginBottom: 6 }}>Valable jusqu'au {formatDate(expirationCheque(f.echeanceCheque))} (un an) — alerte {JOURS_ALERTE_EXPIRATION_CHEQUE} jours avant.</div>}
                        {f.compteId === PORTEFEUILLE_ID && f.chequeRemisLe && <div style={{ color: VERT_OK, marginBottom: 4 }}>Déposé à la CFG le {formatDate(f.chequeRemisLe)}{f.chequeRemisPar ? ` par ${f.chequeRemisPar}` : ""}</div>}
                        {f.compteId === PORTEFEUILLE_ID && f.impaye && <div style={{ color: ROUILLE, marginBottom: 4 }}>Impayé (rejeté le {formatDate(f.impaye.le.slice(0, 10))}{f.impaye.motif ? ` : ${f.impaye.motif}` : ""}) — à représenter ou à récupérer auprès du client</div>}
                        {f.compteId === PORTEFEUILLE_ID && f.id && !f.chequeRemisLe && !f.impaye && (estGerant || user.profil === P_ADMIN || det === user.id) && (
                          <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 6, flexWrap: "wrap" }}>
                            <span>Déposé à la CFG le</span>
                            <input type="date" className="sc-input" max={todayISO()} value={f._depotLe || todayISO()} onChange={(e) => set({ _depotLe: e.target.value })} style={{ ...inputStyle(150), padding: "3px 8px", background: "#fff" }} />
                            <button type="button" className="sc-btn" onClick={() => deposerCheque(f.id, f._depotLe || todayISO())} style={{ ...primaryBtnStyle, fontSize: 12, padding: "4px 10px" }}>Déposer à la CFG</button>
                          </div>
                        )}
                        <div>Détenu par : <strong>{nomUtilisateur(det) || "—"}</strong>{f.detenteurPropose ? <span style={{ color: OCRE }}> · passage à {nomUtilisateur(f.detenteurPropose.id)} en attente de sa confirmation</span> : null}</div>
                        {peutPasser && (
                          <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 6, flexWrap: "wrap" }}>
                            <select className="sc-select" value={f._passerA || ""} onChange={(e) => set({ _passerA: e.target.value })} style={{ ...selectStyle, width: 200, background: "#fff" }}>
                              <option value="">— Passer le chèque à —</option>
                              {utilisateurs.filter((u) => u.id !== det).map((u) => (<option key={u.id} value={u.id}>{u.nom}</option>))}
                            </select>
                            <button type="button" className="sc-btn" disabled={!f._passerA} onClick={() => passerCheque(f.id, f._passerA)} style={{ ...ghostBtnStyle, fontSize: 12, opacity: f._passerA ? 1 : 0.5 }}>Passer</button>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                  {f.sens === "entree" && ["Chèque", "Effet / LCN"].includes(f.mode) && dateEncaissementCheque(f) && dateEncaissementCheque(f) > todayISO() && !f.sansVisibilite && <div style={{ fontSize: 11, color: TAUPE, marginTop: -8, marginBottom: 10 }}>En portefeuille jusqu'au {formatDate(dateEncaissementCheque(f))}{f.encaissementPrevu ? " (date prévue d'encaissement)" : " (date du chèque)"} : compté dans le tableau de bord à cette date ; tâche « Déposer à la CFG » ce jour-là.</div>}
                  {!nouveau && <div style={{ fontSize: 11, color: TAUPE, marginBottom: 10 }}>Saisi par {f.par}{f.modifiePar ? ` · modifié par ${f.modifiePar} le ${formatDate((f.modifieLe || "").slice(0, 10))}` : ""}</div>}
                  <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                    {!nouveau && peutSaisirCompte(compte) && <button type="button" className="sc-btn" onClick={async () => { if (await demander("Supprimer cette opération ?")) supprimerOperation(f.id); }} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>Supprimer</button>}
                    <button type="button" className="sc-btn" onClick={() => setOpEdit(null)} style={ghostBtnStyle}>Annuler</button>
                    <button type="button" className="sc-btn" onClick={() => enregistrerOperation()} style={primaryBtnStyle}>{nouveau ? "Enregistrer" : "Enregistrer les modifications"}</button>
                  </div>
                </>
              )}
            </div>
          </Overlay>
        );
      })()}

      {(opEdit || factFEdit) && activeTab !== "compta" && activeTab !== "facturesF" && (
        <button type="button" className="sc-btn" onClick={() => setActiveTab(factFEdit && !opEdit && onglets.some((o) => o.id === "facturesF") ? "facturesF" : "compta")} style={{ position: "fixed", right: 24, bottom: 24, zIndex: 40, ...primaryBtnStyle, fontSize: 13, padding: "10px 16px", boxShadow: "0 4px 14px rgba(40,30,30,0.25)" }}>↩ Revenir à {opEdit ? "l'opération" : "la facture"} en cours (Comptabilité)</button>
      )}
      {gestionCompta && peut("compta.parametrer") && (
        <Overlay zIndex={80} onClose={() => setGestionCompta(null)}>
          <div style={{ ...modalStyle(gestionCompta.type === "postes" || gestionCompta.type === "typesTiers" ? 760 : 460), maxHeight: "85vh", overflowY: "auto" }}>
            <div style={modalTitleStyle}>{gestionCompta.type === "postes" ? "Postes et sous-postes" : gestionCompta.type === "typesTiers" ? "Types de tiers" : gestionCompta.type === "fournisseur" ? "Nouveau fournisseur" : gestionCompta.type === "etat" ? "Organismes de l'État" : "Associés"}</div>
            {gestionCompta.type === "postes" && blocPlanPostes()}
            {gestionCompta.type === "typesTiers" && blocTypesTiers()}
            {(gestionCompta.type === "etat" || gestionCompta.type === "associe") && blocTiersEtatAssocies([gestionCompta.type === "etat" ? "organismesEtat" : "associes"])}
            {gestionCompta.type === "fournisseur" && (
              <>
                <Field label="Nom du fournisseur"><input className="sc-input" autoFocus value={gestionCompta.nom} onChange={(e) => setGestionCompta({ ...gestionCompta, nom: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label="ICE (15 chiffres — facultatif, requis pour le fichier TVA)"><input className="sc-input" value={gestionCompta.ice} onChange={(e) => setGestionCompta({ ...gestionCompta, ice: e.target.value })} style={inputStyle("100%")} /></Field>
                <div style={{ fontSize: 11, color: TAUPE, marginBottom: 12 }}>Le fournisseur rejoint la liste de l'onglet Fournisseurs (où compléter contacts et conditions).</div>
              </>
            )}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 12 }}>
              <button type="button" className="sc-btn" onClick={() => setGestionCompta(null)} style={ghostBtnStyle}>{gestionCompta.type === "fournisseur" ? "Annuler" : "Fermer"}</button>
              {gestionCompta.type === "fournisseur" && <button type="button" className="sc-btn" onClick={creerFournisseurRapide} style={primaryBtnStyle}>Créer et choisir</button>}
            </div>
          </div>
        </Overlay>
      )}

      {factFEdit && (activeTab === "compta" || activeTab === "facturesF") && (() => {
        const fa = factFEdit;
        const existante = fa.id ? (facturesF || []).find((x) => x.id === fa.id) : null;
        const nouveau = !existante;
        const modifiable = peutSaisirFactureF && (nouveau || peutControlerFactureF || (existante.parId === user.id && existante.controle !== "contrôlée"));
        const set = (patch) => setFactFEdit({ ...fa, ...patch });
        const dl = fa.tiersType === "fournisseur" && fa.fournisseur ? delaiFournisseur(fa.fournisseur) : null;
        const regs = existante ? reglementsDeFacture(existante.id) : [];
        const st = existante ? statutFactureF(existante) : null;
        const tot = fa.douane ? Number(fa.montantQuittance) || 0 : (fa.lignes || []).reduce((n, l) => n + (Number(l.ttc) || 0), 0);
        const tva = fa.douane ? Number(fa.tvaQuittance) || 0 : (fa.lignes || []).reduce((n, l) => n + ((Number(l.ttc) || 0) * Number(l.taux)) / (1 + Number(l.taux)), 0);
        const devisRemplace = fa.remplace ? (facturesF || []).find((x) => x.id === fa.remplace) : null;
        return (
          <Overlay zIndex={opEdit ? 90 : 50} onClose={() => setFactFEdit(null)}>
            <div style={{ ...modalStyle(620), maxHeight: "88vh", overflowY: "auto" }}>
              <div style={modalTitleStyle}>{nouveau ? (fa.type === "devis" ? "Nouveau devis / proforma fournisseur" : "Nouvelle facture fournisseur") : `${fa.type === "devis" ? "Devis / proforma" : "Facture"} ${fa.numero || ""} — ${fa.fournisseur}`}</div>
              {bandeauBlacklist(fa.fournisseur)}
              {devisRemplace && <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 10 }}>Remplace le devis {devisRemplace.numero || "sans n°"} du {formatDate(devisRemplace.date)} — ses acomptes seront reportés sur cette facture.</div>}
              {existante && existante.controle === "à contrôler" && <div style={{ fontSize: 12, color: OCRE, marginBottom: 10 }}>Saisie par {existante.par} — à contrôler par l'Administration.</div>}
              <fieldset disabled={!modifiable} style={{ border: "none", padding: 0, margin: 0 }}>
                {nouveau && !fa.remplace && (
                  <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                    {[["facture", "Facture"], ["devis", "Devis / proforma (acompte)"]].map(([t, l]) => (
                      <button key={t} type="button" className="sc-btn" onClick={() => set({ type: t })} style={{ ...(fa.type === t ? primaryBtnStyle : ghostBtnStyle), fontSize: 12, padding: "5px 14px" }}>{l}</button>
                    ))}
                  </div>
                )}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 12 }}>
                  <Field label="Émise par">
                    <select className="sc-select" value={fa.tiersType} onChange={(e) => set({ tiersType: e.target.value, fournisseur: "", douane: false })} disabled={!nouveau} style={{ ...selectStyle, width: "100%" }}>
                      <option value="fournisseur">Fournisseur</option>
                      <option value="etat">État / organisme</option>
                    </select>
                  </Field>
                  <Field label={fa.tiersType === "etat" ? "Organisme" : "Fournisseur"}>
                    <select className="sc-select" value={nomsTiers(fa.tiersType).find((n) => normLib(n) === normLib(fa.fournisseur)) || ""} onChange={(e) => set({ fournisseur: e.target.value, douane: fa.tiersType === "etat" && /douane/i.test(e.target.value) })} disabled={!nouveau && regs.length > 0} style={{ ...selectStyle, width: "100%" }}>
                      <option value="">— Choisir —</option>
                      {nomsTiers(fa.tiersType).map((n) => (<option key={n} value={n}>{n}</option>))}
                    </select>
                    {fa.tiersType === "fournisseur" && nouveau && peutEcrireFour && <button type="button" className="sc-btn" onClick={openFourNew} style={{ ...ghostBtnStyle, padding: "3px 0", fontSize: 12 }}>+ Nouveau fournisseur</button>}
                    {fa.tiersType === "fournisseur" && nouveau && !peutEcrireFour && user.demandeCreationFournisseur && <button type="button" className="sc-btn" onClick={ouvrirDemandeFour} style={{ ...ghostBtnStyle, padding: "3px 0", fontSize: 12 }} title="Le Gérant ou l'Administration crée le fournisseur ; tu pourras ensuite saisir la facture">+ Demander la création d'un fournisseur</button>}
                  </Field>
                </div>
                {dl && fa.type !== "devis" && (
                  <div style={{ fontSize: 12, marginTop: -6, marginBottom: 10, color: dl.depasse ? ROUILLE : TAUPE }}>
                    Conditions : {dl.condition || "non renseignées (délai légal appliqué)"}{dl.joursCondition !== null ? ` (${dl.joursCondition} j)` : ""} → échéance à <strong>{dl.jours} j</strong>{dl.etranger ? " — fournisseur étranger (loi 69-21 non applicable)" : dl.convention ? ` — convention de paiement (${dl.max} j max)` : ` — maximum légal ${dl.max} j`}{dl.depasse ? " — ⚠ les conditions du fournisseur dépassent la loi : échéance ramenée au maximum" : ""}{fa.date ? ` · échéance le ${formatDate(ajouterJours(fa.date, dl.jours))}` : ""}
                  </div>
                )}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                  <Field label={fa.type === "devis" ? "N° du devis (facultatif)" : fa.douane ? "N° de quittance" : "N° de facture"}><input className="sc-input" value={fa.numero || ""} onChange={(e) => set({ numero: e.target.value })} style={inputStyle("100%")} /></Field>
                  <Field label="Date"><input type="date" className="sc-input" max={todayISO()} value={fa.date || ""} onChange={(e) => set({ date: e.target.value })} style={inputStyle("100%")} /></Field>
                </div>
                {fa.tiersType === "etat" && /douane/i.test(fa.fournisseur || "") ? (
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                    <Field label="Montant total de la quittance"><input type="number" min="0" step="0.01" className="sc-input" value={fa.montantQuittance} onChange={(e) => set({ montantQuittance: e.target.value, douane: true })} style={inputStyle("100%")} /></Field>
                    <Field label="TVA inscrite sur la quittance"><input type="number" min="0" step="0.01" className="sc-input" value={fa.tvaQuittance} onChange={(e) => set({ tvaQuittance: e.target.value, douane: true })} style={inputStyle("100%")} /></Field>
                  </div>
                ) : (
                  <div style={{ marginBottom: 12 }}>
                    {(fa.lignes || []).map((l, i) => (
                      <div key={i} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, marginBottom: 4 }}>
                        <span style={{ width: 70 }}>{i === 0 ? "TTC" : ""}</span>
                        <input type="number" min="0" step="0.01" className="sc-input" value={l.ttc} onChange={(e) => set({ lignes: fa.lignes.map((y, j) => (j === i ? { ...y, ttc: e.target.value } : y)) })} style={{ ...inputStyle(140), padding: "4px 8px" }} />
                        <span>à</span>
                        <select className="sc-select" value={l.taux} onChange={(e) => set({ lignes: fa.lignes.map((y, j) => (j === i ? { ...y, taux: Number(e.target.value) } : y)) })} style={{ ...selectStyle, width: 80, fontSize: 12 }}>{TAUX_TVA.map((t) => (<option key={t} value={t}>{Math.round(t * 100)} %</option>))}</select>
                        <span style={{ color: TAUPE }}>TVA {formatDH(((Number(l.ttc) || 0) * Number(l.taux)) / (1 + Number(l.taux)))}</span>
                        {fa.lignes.length > 1 && <button type="button" className="sc-btn" onClick={() => set({ lignes: fa.lignes.filter((_, j) => j !== i) })} style={iconBtnStyle} title="Retirer">✕</button>}
                      </div>
                    ))}
                    <button type="button" className="sc-btn" onClick={() => set({ lignes: [...(fa.lignes || []), { taux: 0, ttc: "" }] })} style={{ ...ghostBtnStyle, fontSize: 12 }}>+ Autre taux sur la même facture</button>
                  </div>
                )}
                <div style={{ fontSize: 12, marginBottom: 10 }}>Total TTC <strong>{formatDH(tot)}</strong> · TVA {formatDH(tva)}</div>
                <Field label="Note"><input className="sc-input" value={fa.note || ""} onChange={(e) => set({ note: e.target.value })} style={inputStyle("100%")} /></Field>
                {fa.type === "facture" && fa.tiersType === "fournisseur" && (
                  <label style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: 13, marginBottom: 12, padding: "8px 10px", borderRadius: 6, background: fa.confirmeBL ? "#E4EBE4" : PIERRE, cursor: "pointer" }}>
                    <input type="checkbox" checked={!!fa.confirmeBL} onChange={(e) => set({ confirmeBL: e.target.checked })} style={{ marginTop: 2 }} />
                    <span>Je confirme que cette facture correspond bien au bon de livraison (articles, quantités et prix vérifiés).{existante && existante.confirmeBLPar ? <span style={{ color: TAUPE }}> — confirmé par {existante.confirmeBLPar} le {formatDate((existante.confirmeBLLe || "").slice(0, 10))}</span> : null}</span>
                  </label>
                )}
              </fieldset>
              {/* Nils 30/10 : pièces jointes (factures et BL du fournisseur), facultatives. */}
              {(() => {
                const pieces = fa.piecesJointes || [];
                const avantIds = new Set(((existante && existante.piecesJointes) || []).map((x) => x.id));
                const retirable = (x) => modifiable && (!avantIds.has(x.id) || estGerant || existante.controle !== "contrôlée");
                const lien = (x) => (window.storage && window.storage.lienFichier ? window.storage.lienFichier(x.id) : null);
                const groupe = (nature, titre) => {
                  const l = pieces.filter((x) => (x.nature === "bl" ? "bl" : "facture") === nature);
                  return (
                    <div style={{ flex: 1, minWidth: 220 }}>
                      <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>{titre}</div>
                      {l.length === 0 && <div style={{ fontSize: 12, color: TAUPE }}>Aucune.</div>}
                      {l.map((x) => (
                        <div key={x.id} style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 12, padding: "2px 0" }}>
                          {lien(x) && avantIds.has(x.id) ? <a href={lien(x)} target="_blank" rel="noopener noreferrer" style={{ color: ENCRE }}>📎 {x.nom}</a> : <span>📎 {x.nom}</span>}
                          <span style={{ color: TAUPE }}>({formatTaille(x.taille)})</span>
                          {retirable(x) && <span title="Retirer" onClick={() => set({ piecesJointes: pieces.filter((y) => y.id !== x.id) })} style={{ cursor: "pointer", color: ROUILLE }}>✕</span>}
                        </div>
                      ))}
                      {modifiable && (
                        <label className="sc-btn" style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 0", cursor: "pointer", display: "inline-block", marginTop: 4 }}>
                          {depotPieceF === nature ? "Envoi en cours…" : nature === "bl" ? "📎 Joindre un BL" : "📎 Joindre la facture"}
                          <input type="file" multiple accept={EXTENSIONS_FICHIERS.map((e) => `.${e}`).join(",")} style={{ display: "none" }} disabled={!!depotPieceF} onChange={(e) => { const fs = [...(e.target.files || [])]; e.target.value = ""; if (fs.length) joindrePiecesFactureF(nature, fs); }} />
                        </label>
                      )}
                    </div>
                  );
                };
                if (!modifiable && !pieces.length) return null;
                return (
                  <div style={{ marginBottom: 12 }}>
                    <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Pièces jointes</div>
                    <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                      {groupe("facture", fa.type === "devis" ? "Devis / proforma du fournisseur" : "Facture du fournisseur")}
                      {groupe("bl", "Bons de livraison")}
                    </div>
                    {pieces.some((x) => !avantIds.has(x.id)) && <div style={{ fontSize: 11, color: OCRE, marginTop: 6 }}>Pièces ajoutées : elles ne sont rattachées qu'en enregistrant la facture.</div>}
                    {existante && existante.controle === "contrôlée" && !estGerant && modifiable && <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Facture contrôlée : on peut ajouter des pièces, plus en retirer.</div>}
                  </div>
                );
              })()}
              {existante && (
                <div style={{ marginBottom: 12 }}>
                  <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>Paiements — <span style={{ color: st.couleur }}>{st.libelle}</span>{existante.type !== "devis" ? ` · reste ${formatDH(resteFactureF(existante))}` : ""}{amendeFactureF(existante) > 0 ? ` · amende estimée ${formatDH(amendeFactureF(existante))}` : ""}</div>
                  {regs.length === 0 && <div style={{ fontSize: 12, color: TAUPE }}>Aucun paiement rattaché.</div>}
                  {regs.map((r, i) => (<div key={i} style={{ fontSize: 12, padding: "2px 0" }}>{formatDate(r.op.date)} — {formatDH(r.montant)} — {(compteDe(r.op.compteId) || {}).nom} — {r.op.mode}{r.op.piece ? ` (${r.op.piece})` : ""}</div>))}
                </div>
              )}
              {existante && <div style={{ fontSize: 11, color: TAUPE, marginBottom: 10 }}>Saisie par {existante.par} le {formatDate((existante.le || "").slice(0, 10))}{existante.controlePar && existante.controle === "contrôlée" ? ` · contrôlée par ${existante.controlePar}` : ""}{existante.modifiePar ? ` · modifiée par ${existante.modifiePar}` : ""}</div>}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, flexWrap: "wrap" }}>
                {existante && modifiable && <button type="button" className="sc-btn" onClick={() => supprimerFactureF(existante.id)} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>Supprimer</button>}
                {existante && existante.type === "devis" && !existante.remplaceePar && peutSaisirFactureF && <button type="button" className="sc-btn" onClick={() => setFactFEdit({ ...nouvelleFactureF(existante.tiersType, existante.fournisseur, "facture"), lignes: (existante.lignes || []).map((l) => ({ ...l })), remplace: existante.id })} style={ghostBtnStyle}>Saisir la facture de ce devis</button>}
                {existante && existante.controle === "à contrôler" && peutControlerFactureF && <button type="button" className="sc-btn" onClick={() => controlerFactureF(existante.id)} style={{ ...ghostBtnStyle, color: VERT_OK }}>✓ Contrôlée</button>}
                <button type="button" className="sc-btn" onClick={() => setFactFEdit(null)} style={ghostBtnStyle}>{modifiable ? "Annuler" : "Fermer"}</button>
                {modifiable && <button type="button" className="sc-btn" onClick={enregistrerFactureF} style={primaryBtnStyle}>{nouveau ? (fa._pourOp ? "Enregistrer et rattacher" : "Enregistrer") : "Enregistrer les modifications"}</button>}
              </div>
            </div>
          </Overlay>
        );
      })()}

      {transfertEdit && activeTab === "compta" && (() => {
        const t = transfertEdit;
        const set = (patch) => setTransfertEdit({ ...t, ...patch });
        const src = compteDe(t.source);
        return (
          <Overlay onClose={() => setTransfertEdit(null)}>
            <div style={modalStyle(480)}>
              <div style={modalTitleStyle}>Transfert depuis {src ? src.nom : ""}</div>
              <Field label="Vers">
                <select className="sc-select" value={t.destination} onChange={(e) => set({ destination: e.target.value, ...(estCompteDevises(compteDe(e.target.value)) ? { mode: "Virement" } : {}) })} style={{ ...selectStyle, width: "100%" }}>
                  <option value="">— Compte qui reçoit —</option>
                  {src && src.type === "banque" ? (
                    <>
                      {/* Nils 03/10 : depuis la CFG, seulement la caisse générale (espèces remises à Nils) ou la caisse Nils. */}
                      {compteDe(CAISSE_GENERALE_ID) && compteDe("caisse-nils") && <option value="__cg">Caisse générale — retrait d'espèces (remises au Gérant)</option>}
                      {compteDe("caisse-nils") && <option value="caisse-nils">Caisse Nils (Gérant)</option>}
                      {(comptesTreso || []).filter((c) => estCompteDevises(c) && c.parentId === t.source).map((c) => (<option key={c.id} value={c.id}>{c.nom} — alimentation en {c.devise}</option>))}
                    </>
                  ) : [...(comptesTreso || []), ...comptesNomSeulRef.current].filter((c) => c.id !== t.source && c.id !== CAISSE_GENERALE_ID).map((c) => (<option key={c.id} value={c.id}>{c.nom}</option>))}
                </select>
              </Field>
              {t.destination === "__cg" && (
                <div style={{ fontSize: 12, color: TAUPE, marginBottom: 12, lineHeight: 1.5 }}>Crée une entrée dans la caisse générale (tout de suite) et une entrée dans la Caisse Nils (à confirmer par le Gérant à réception des espèces). Mode : espèces.</div>
              )}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                <Field label="Date"><input type="date" className="sc-input" max={todayISO()} value={t.date} onChange={(e) => set({ date: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label={estCompteDevises(compteDe(t.destination)) ? "Débité de la CFG (DH)" : "Montant (DH)"}><input type="number" min="0" step="0.01" className="sc-input" value={t.montant} onChange={(e) => set({ montant: e.target.value })} style={inputStyle("100%")} /></Field>
                {estCompteDevises(compteDe(t.destination)) && <Field label={`Crédité (${compteDe(t.destination).devise === "EUR" ? "€" : compteDe(t.destination).devise})`}><input type="number" min="0" step="0.01" className="sc-input" value={t.montantDevise || ""} onChange={(e) => set({ montantDevise: e.target.value })} style={inputStyle("100%")} /></Field>}
                <Field label="Mode">
                  <select className="sc-select" value={t.mode} onChange={(e) => set({ mode: e.target.value })} style={{ ...selectStyle, width: "100%" }}>
                    {MODES_PAIEMENT.map((m) => (<option key={m} value={m}>{m}</option>))}
                  </select>
                </Field>
              </div>
              <Field label="Commentaire"><input className="sc-input" value={t.note} onChange={(e) => set({ note: e.target.value })} placeholder="ex. alimentation caisse usine" style={inputStyle("100%")} /></Field>
              <div style={{ fontSize: 11, color: TAUPE, marginBottom: 12 }}>La sortie est enregistrée tout de suite ; l'entrée n'est comptée chez le receveur qu'après sa confirmation (montant reçu). Un écart ou un refus déclenche une alerte au Gérant.</div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                <button type="button" className="sc-btn" onClick={() => setTransfertEdit(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={enregistrerTransfert} style={primaryBtnStyle}>Enregistrer le transfert</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {receptionEdit && activeTab === "compta" && (() => {
        const r = receptionEdit;
        const o = (operations || []).find((x) => x.id === r.id);
        if (!o) return null;
        const src = compteDe(o.contrepartieId), dst = compteDe(o.compteId);
        return (
          <Overlay onClose={() => setReceptionEdit(null)}>
            <div style={modalStyle(460)}>
              <div style={modalTitleStyle}>Réception d'un transfert</div>
              <div style={{ fontSize: 13, marginBottom: 12, lineHeight: 1.6 }}>{src ? src.nom : "?"} → {dst ? dst.nom : "?"} le {formatDate(o.date)} — envoyé <strong>{formatDH(Number(o.montant))}</strong> par {o.par}{o.designation ? <><br /><span style={{ color: TAUPE }}>{o.designation}</span></> : null}</div>
              <Field label="Montant réellement reçu (DH)"><input type="number" min="0" step="0.01" className="sc-input" value={r.montant} onChange={(e) => setReceptionEdit({ ...r, montant: e.target.value })} style={inputStyle("100%")} /></Field>
              <Field label="Commentaire"><input className="sc-input" value={r.note} onChange={(e) => setReceptionEdit({ ...r, note: e.target.value })} style={inputStyle("100%")} /></Field>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                <button type="button" className="sc-btn" onClick={async () => { if (await demander("Refuser ce transfert (non reçu) ? Le Gérant sera alerté.")) confirmerReceptionTransfert(true); }} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>Pas reçu</button>
                <button type="button" className="sc-btn" onClick={() => setReceptionEdit(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={() => confirmerReceptionTransfert(false)} style={primaryBtnStyle}>Confirmer la réception</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {versementPrimes && activeTab === "compta" && (() => {
        const v = versementPrimes;
        const compte = compteDe(v.compteId);
        const personnes = personnesVersementPrimes();
        const montant = (id) => { const n = Number(String((v.montants || {})[id] ?? "").replace(/\s/g, "").replace(",", ".")); return isFinite(n) && n > 0 ? n : 0; };
        const nb = personnes.filter((x) => montant(x.id) > 0).length;
        const total = personnes.reduce((n, x) => n + montant(x.id), 0);
        const changer = (patch) => { const w = { ...v, ...patch }; setVersementPrimes({ ...w, montants: montantsVersementPrimes(w.typePrime) }); };
        const prod = v.typePrime === TYPE_PRIME_PRODUCTIVITE;
        return (
          <Overlay onClose={() => setVersementPrimes(null)}>
            <div style={modalStyle(760)}>
              <div style={modalTitleStyle}>Verser des primes — {compte ? compte.nom : ""}</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 14 }}>Une sortie par personne, reprise automatiquement dans sa fiche Staff. Vide ou 0 = pas de prime.{prod && peut("staff.primes") ? " Montants pré-remplis avec le reste à verser (semaines accordées − déjà versé)." : " Montants pré-remplis avec la dernière prime du même type."}</div>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", marginBottom: 12 }}>
                <input type="date" className="sc-input" value={v.date} onChange={(e) => setVersementPrimes({ ...v, date: e.target.value })} style={{ ...inputStyle(150), padding: "5px 8px" }} />
                <select className="sc-select" value={v.typePrime} onChange={(e) => changer({ typePrime: e.target.value })} style={{ ...selectStyle, width: 200 }}>
                  <option value="">— Type de prime —</option>
                  {typesPrimesVersees().map((t) => (<option key={t} value={t}>{t}</option>))}
                </select>
                <input className="sc-input" value={v.designation} onChange={(e) => setVersementPrimes({ ...v, designation: e.target.value })} placeholder="Désignation (ex. S2 et S3 septembre)" style={{ ...inputStyle(240), padding: "5px 8px", flex: 1 }} />
              </div>
              <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, overflow: "hidden", maxHeight: 420, overflowY: "auto", marginBottom: 14 }}>
                {personnes.map((x) => {
                  const d = v.typePrime ? dernierePrime(x, v.typePrime) : null;
                  return (
                    <div key={x.id} style={{ display: "grid", gridTemplateColumns: "1.6fr 1fr 1.6fr 1fr", gap: 8, padding: "6px 12px", borderBottom: `1px solid ${PIERRE}`, fontSize: 13, alignItems: "center" }}>
                      <div style={{ fontWeight: 600 }}>{x.nom}</div>
                      <div style={{ color: TAUPE }}>{x.service || "—"}</div>
                      <div style={{ fontSize: 12, color: TAUPE }}>{prod && peut("staff.primes") ? `reste à verser ${formatDH(Math.max(0, resteProductivite(x)))}` : d ? `dernière : ${formatDH(Number(d.montant) || 0)} (${formatDate(d.date)})` : "—"}</div>
                      <input type="number" min="0" className="sc-input" value={(v.montants || {})[x.id] ?? ""} onChange={(e) => setVersementPrimes({ ...v, montants: { ...(v.montants || {}), [x.id]: e.target.value } })} placeholder="0" style={{ ...inputStyle("100%"), padding: "4px 8px" }} />
                    </div>
                  );
                })}
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                <button type="button" className="sc-btn" onClick={() => setVersementPrimes(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={enregistrerVersementPrimes} disabled={!nb} style={{ ...primaryBtnStyle, opacity: nb ? 1 : 0.5 }}>Verser — {nb} personne(s), {formatDH(total)}</button>
              </div>
            </div>
          </Overlay>
        );
      })()}
      {importsTresoCompte && activeTab === "compta" && (() => {
        const compte = compteDe(importsTresoCompte);
        const liste = importsDuCompte(importsTresoCompte);
        const peutAnnuler = !!compte && peutSaisirCompte(compte);
        const fermer = () => setImportsTresoCompte(null);
        return (
          <Overlay onClose={fermer}>
            <div style={modalStyle(640)}>
              <div style={modalTitleStyle}>Imports — {compte ? compte.nom : ""}</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 14 }}>Annuler un import supprime toutes les opérations encore présentes qui viennent de ce fichier, tous mois confondus. Les opérations saisies à la main ne sont jamais touchées. Refusé si l'un des mois est clôturé.</div>
              {!liste.length && <div style={{ fontSize: 13, color: TAUPE, marginBottom: 14 }}>Aucune opération importée sur ce compte.</div>}
              <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16, maxHeight: 360, overflowY: "auto" }}>
                {liste.map((im) => {
                  const mois = moisDesOps(im.ops);
                  return (
                    <div key={im.cle} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 6, background: PIERRE }}>
                      <div style={{ flex: 1, fontSize: 13 }}>
                        <div style={{ fontWeight: 600 }}>{im.fichier}</div>
                        <div style={{ fontSize: 12, color: TAUPE }}>importé le {im.le ? new Date(im.le).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "?"}{im.par ? ` par ${im.par}` : ""} · {im.ops.length} opération(s) · {mois.length > 1 ? `${libMois(mois[0])} → ${libMois(mois[mois.length - 1])}` : libMois(mois[0])}</div>
                      </div>
                      {peutAnnuler && <button type="button" className="sc-btn" onClick={() => annulerImportsTreso(compte.id, [im])} style={{ ...ghostBtnStyle, fontSize: 12, color: ROUILLE }}>Annuler cet import</button>}
                    </div>
                  );
                })}
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                {peutAnnuler && liste.length > 1 ? <button type="button" className="sc-btn" onClick={() => annulerImportsTreso(compte.id, liste)} style={{ ...ghostBtnStyle, color: ROUILLE }}>Annuler tous les imports de ce compte</button> : <span />}
                <button type="button" className="sc-btn" onClick={fermer} style={ghostBtnStyle}>Fermer</button>
              </div>
            </div>
          </Overlay>
        );
      })()}
      {importTreso && activeTab === "compta" && (() => {
        const im = importTreso;
        const compte = compteDe(im.compteId);
        const nouvelles = im.lignes.filter((l) => !l.doublon && !l.apresDemarrage && (!l.doublonProbable || l.importerQuandMeme));
        const nbApres = im.lignes.filter((l) => l.apresDemarrage).length;
        const nbProb = im.lignes.filter((l) => l.doublonProbable).length;
        const nbDef = nouvelles.filter((l) => l.poste === POSTE_A_DEFINIR).length;
        const nbEnc = nouvelles.filter((l) => l.poste === POSTE_ENCAISSEMENT).length;
        const nbTr = nouvelles.filter((l) => l.transfertImporte).length;
        const tot = (s) => nouvelles.filter((l) => l.sens === s).reduce((n, l) => n + l.montant, 0);
        return (
          <Overlay onClose={() => setImportTreso(null)}>
            <div style={modalStyle(860)}>
              <div style={modalTitleStyle}>Import — {compte ? compte.nom : ""}</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 12 }}>{im.fichier} · rien n'est enregistré avant « Confirmer l'import ». Sens du fichier : {compte && compte.debitEstEntree ? "Débit = entrée, Crédit = sortie" : "Débit = sortie, Crédit = entrée"} (colonnes Entrée / Sortie reconnues directement) — réglable dans Paramétrage › Comptes de trésorerie.</div>
              <div style={{ fontSize: 13, marginBottom: 10 }}>
                <strong>{nouvelles.length}</strong> opération(s) à importer — entrées {formatDH(tot("entree"))}, sorties {formatDH(tot("sortie"))}
                {im.lignes.filter((l) => l.doublon).length > 0 && <span style={{ color: TAUPE }}> · {im.lignes.filter((l) => l.doublon).length} déjà présente(s), ignorée(s)</span>}
                {nbApres > 0 && <span style={{ color: ROUILLE }}> · {nbApres} datée(s) à partir du {formatDate(compte.dateDemarrageERP)} (saisie dans l'ERP), refusée(s)</span>}
                {nbProb > 0 && <span style={{ color: OCRE }}> · {nbProb} doublon(s) probable(s), non importé(s) sauf si tu les coches</span>}
                {nbDef > 0 && <span style={{ color: ROUILLE }}> · {nbDef} « À définir » (libellé non reconnu, à classer ensuite)</span>}
                {nbEnc > 0 && <span style={{ color: OCRE }}> · {nbEnc} encaissement(s) à relier à un dossier</span>}
                {nbTr > 0 && <span style={{ color: TAUPE }}> · {nbTr} mouvement(s) de caisse, dont {nouvelles.filter((l) => l.transfertImporte && l.rapprocherAvec && l.rapprocher).length} rapproché(s) automatiquement (les autres : liste « à rapprocher » du Gérant)</span>}
              </div>
              {im.soldeOuvertureFichier !== null && (
                <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, marginBottom: 10 }}>
                  <input type="checkbox" checked={!!im.utiliserSolde} onChange={(e) => setImportTreso({ ...im, utiliserSolde: e.target.checked })} />
                  Prendre le solde de départ du fichier comme solde d'ouverture du compte : <strong>{formatDH(im.soldeOuvertureFichier)}</strong>
                </label>
              )}
              <div style={{ maxHeight: 380, overflowY: "auto", border: `1px solid ${PIERRE}`, borderRadius: 8 }}>
                {im.lignes.length === 0 && <div style={{ padding: 12, fontSize: 13, color: TAUPE }}>Aucune ligne reconnue (il faut une ligne d'en-tête avec « Date » et « Débit / Crédit » ou « Entrée / Sortie »).</div>}
                {im.lignes.map((l, i) => (
                  <div key={i} style={{ display: "grid", gridTemplateColumns: "0.8fr 0.9fr 2fr 2fr", gap: 8, padding: "5px 10px", fontSize: 12, borderBottom: `1px solid ${PIERRE}`, opacity: l.doublon || l.apresDemarrage || (l.doublonProbable && !l.importerQuandMeme) ? 0.45 : 1 }}>
                    <span>{formatDate(l.date)}</span>
                    <span style={{ color: l.sens === "entree" ? VERT_OK : ROUILLE }}>{l.sens === "entree" ? "+" : "−"} {formatDH(l.montant)}</span>
                    <span>{l.designation || "—"}{l.tiers ? <span style={{ color: TAUPE }}> · {l.tiers}</span> : null}</span>
                    <span style={{ color: l.poste === POSTE_A_DEFINIR ? ROUILLE : ENCRE }}>{l.poste} › {l.sousPoste}{l.origine && l.poste === POSTE_A_DEFINIR ? <span style={{ color: TAUPE }}> (« {l.origine} »)</span> : null}{l.doublon ? <span style={{ color: TAUPE }}> — déjà présente</span> : null}
                      {l.apresDemarrage && <div style={{ fontSize: 11, color: ROUILLE }}>refusée : saisie dans l'ERP à partir du {formatDate(compte.dateDemarrageERP)}</div>}
                      {l.doublonProbable && (
                        <label style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 11, color: OCRE }}>
                          <input type="checkbox" checked={!!l.importerQuandMeme} onChange={(e) => setImportTreso({ ...im, lignes: im.lignes.map((y, j) => (j === i ? { ...y, importerQuandMeme: e.target.checked } : y)) })} />
                          doublon probable de « {l.doublonProbable.designation || "—"} » du {formatDate(l.doublonProbable.date)} — importer quand même
                        </label>
                      )}
                      {l.rapprocherAvec && !l.doublon && (() => {
                        const x = (operations || []).find((y) => y.id === l.rapprocherAvec);
                        return x ? (
                          <label style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 11, color: VERT_OK }}>
                            <input type="checkbox" checked={!!l.rapprocher} onChange={(e) => setImportTreso({ ...im, lignes: im.lignes.map((y, j) => (j === i ? { ...y, rapprocher: e.target.checked } : y)) })} />
                            rapprocher avec {(compteDe(x.compteId) || {}).nom} du {formatDate(x.date)} (« {x.designation} »)
                          </label>
                        ) : null;
                      })()}
                    </span>
                  </div>
                ))}
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 14 }}>
                <button type="button" className="sc-btn" onClick={() => setImportTreso(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={confirmerImportTreso} disabled={!nouvelles.length} style={{ ...primaryBtnStyle, opacity: nouvelles.length ? 1 : 0.5 }}>Confirmer l'import</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {/* ERP step 11 (validé Nils du 29/09) : onglet SAV */}
      {(activeTab === "commandes" || activeTab === "sav") && user.acces.commandes && !commandeEditing && (
        <div style={{ display: "flex", gap: 6, marginBottom: 14, borderBottom: `1px solid ${PIERRE}`, paddingBottom: 8 }}>
          {[["commandes", "Dossiers"], ["sav", "SAV"]].map(([id, lib]) => (
            <button key={id} type="button" className="sc-btn" onClick={() => setActiveTab(id)} style={{ padding: "7px 16px", borderRadius: 8, fontSize: 13, fontWeight: 600, background: activeTab === id ? ENCRE : "transparent", color: activeTab === id ? PIERRE : TAUPE, display: "inline-flex", gap: 6, alignItems: "center" }}>
              {lib}
              {id === "sav" && savOuvertsVisibles.length > 0 && <span style={{ background: savRetardVisible ? ROUILLE : TAUPE, color: "#fff", borderRadius: 10, fontSize: 11, padding: "1px 7px", fontWeight: 700 }}>{savOuvertsVisibles.length}</span>}
            </button>
          ))}
        </div>
      )}
      {activeTab === "sav" && user.acces.commandes && (() => {
        const visibles = (savListe || []).filter((t) => !user.commandesRestreintACommercial || pilotesSav(t).includes(user.id));
        const liste = visibles
          .filter((t) => savFiltre === "tous" || (savFiltre === "ouverts" && t.statut !== "Clôturé") || (savFiltre === "retard" && savEnRetard(t)) || (savFiltre === "clotures" && t.statut === "Clôturé"))
          .sort((a, b) => (a.dateReclamation < b.dateReclamation ? 1 : -1));
        const dossiersPossibles = (commandesListe || []).filter((c) => ["BL", "Facture"].includes(c.statut) && peutOuvrirSav(c));
        const nbRetard = visibles.filter(savEnRetard).length;
        // Statistiques (Nils) : période sur la date de réclamation.
        const periode = visibles.filter((t) => (!savStats.du || t.dateReclamation >= savStats.du) && (!savStats.au || t.dateReclamation <= savStats.au));
        const grouper = (cleDe) => {
          const m = new Map();
          periode.forEach((t) => {
            const cles = cleDe(t);
            (Array.isArray(cles) ? cles : [cles]).forEach((k) => {
              const cle = k || "—";
              const x = m.get(cle) || { n: 0, cout: 0, facture: 0 };
              x.n += 1;
              x.cout += coutTotalSav(t).total;
              x.facture += montantFactureSav(t);
              m.set(cle, x);
            });
          });
          return [...m.entries()].sort((a, b) => b[1].n - a[1].n);
        };
        const matieresOrigine = (t) => {
          const co = commandeOrigineSav(t);
          const noms = co ? lignesDuDossier(co).map((l) => (articles || []).find((a) => a.id === l.articleId)).filter((a) => a && a.categorie === "Tranche").map((a) => a.designation || a.nom) : [];
          return noms.length ? [...new Set(noms)] : ["—"];
        };
        const poseursOrigine = (t) => {
          const co = commandeOrigineSav(t);
          const p = co && co.fichePose && Array.isArray(co.fichePose.poseurs) ? co.fichePose.poseurs.filter(Boolean) : [];
          return p.length ? p : ["—"];
        };
        const tableStats = (titre, lignes) => (
          <div style={{ flex: "1 1 300px" }}>
            <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>{titre}</div>
            {lignes.length === 0 ? <div style={{ fontSize: 12, color: TAUPE }}>—</div> : lignes.map(([k, x]) => (
              <div key={k} style={{ display: "flex", justifyContent: "space-between", gap: 8, fontSize: 12, padding: "3px 0", borderBottom: `1px solid ${PIERRE}` }}>
                <span>{k}</span>
                <span style={{ whiteSpace: "nowrap" }}><strong>{x.n}</strong> · {formatDH(x.cout)}{x.facture ? ` (facturé ${formatDH(x.facture)})` : ""}</span>
              </div>
            ))}
          </div>
        );
        const exporterSav = async () => {
          const c = (x) => `"${String(x ?? "").replace(/"/g, '""')}"`;
          const entetes = ["N°", "Date réclamation", "Client", "Dossier d'origine", "Motif", "Description", "Pilote", "Statut", "Jours", "Intervention", "Intervenant", "Devis SAV", "Dossier SAV", "Clôturé le", ...(peut("sav.couts") ? ["Coût matière", "Main-d'œuvre", "Déplacement", "Autre", "Coût total", "Facturé HT"] : [])];
          const rows = [entetes.map(c).join(";")];
          periode.forEach((t) => {
            const co = commandeOrigineSav(t);
            const k = coutTotalSav(t);
            const cs = commandeSavDe(t);
            rows.push([t.numero, t.dateReclamation, (clientDe(t.clientId) || {}).nom, co ? [co.numero, co.numeroBL, co.numeroFacture].filter(Boolean).join(" / ") : libOrigineSav(t), t.motif, t.description, nomsUtilisateurs(pilotesSav(t)), statutAfficheSav(t), joursDepuis(t.dateReclamation), (t.intervention || {}).date, (t.intervention || {}).intervenant, (devisSavDe(t) || {}).numero, cs ? cs.numero : "", t.clotureLe ? t.clotureLe.slice(0, 10) : "",
              ...(peut("sav.couts") ? [String(k.matiere.toFixed(2)).replace(".", ","), (t.couts || {}).mainOeuvre, (t.couts || {}).deplacement, (t.couts || {}).autre, String(k.total.toFixed(2)).replace(".", ","), String(montantFactureSav(t).toFixed(2)).replace(".", ",")] : [])].map(c).join(";"));
          });
          await proposerTelechargement(`sav-${todayISO()}.csv`, "\ufeff" + rows.join("\r\n"));
        };
        return (
          <div>
            <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 14 }}>
              <select className="sc-select" value={savFiltre} onChange={(e) => setSavFiltre(e.target.value)} style={{ ...selectStyle, width: "auto" }}>
                <option value="ouverts">Non clôturés</option>
                <option value="retard">En retard ({nbRetard})</option>
                <option value="clotures">Clôturés</option>
                <option value="tous">Tous</option>
              </select>
              {dossiersPossibles.length > 0 && (
                <select className="sc-select" value="" onChange={(e) => { const c = (commandesListe || []).find((x) => x.id === e.target.value); if (c) nouveauTicketSav(c); }} style={{ ...selectStyle, width: "auto" }}>
                  <option value="">+ Nouveau SAV — choisir le dossier d'origine…</option>
                  {dossiersPossibles.map((c) => (<option key={c.id} value={c.id}>{[c.numeroFacture || c.numeroBL, c.numero].filter(Boolean).join(" / ")} — {(clientDe(c.clientId) || {}).nom || "?"}{c.reference ? ` — ${c.reference}` : ""}</option>))}
                </select>
              )}
              {(peut("sav.gerer") || (clients || []).some((cl) => idCommercialDuClient(cl.id) === user.id)) && (
                <button type="button" className="sc-btn" onClick={nouveauTicketSavAnterieur} style={{ ...ghostBtnStyle, fontSize: 12 }}>+ SAV — commande d'avant l'ERP</button>
              )}
              <span style={{ fontSize: 12, color: nbRetard ? ROUILLE : TAUPE }}>{nbRetard} en retard (délai {delaiSavJours()} j)</span>
            </div>
            <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden", marginBottom: 24 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 0.9fr 1.3fr 1.2fr 1.6fr 1fr 1.5fr", padding: "10px 16px", background: PIERRE, gap: 8 }}>
                <Th>N°</Th><Th>Réclamation</Th><Th>Client</Th><Th>Origine</Th><Th>Motif</Th><Th>Pilote</Th><Th>Statut</Th>
              </div>
              {liste.length === 0 && <div style={{ padding: 16, fontSize: 13, color: TAUPE }}>Aucun SAV.</div>}
              {liste.map((t) => {
                const co = commandeOrigineSav(t);
                const retard = savEnRetard(t);
                return (
                  <div key={t.id} className="sc-row" onClick={() => ouvrirTicketSav(t.id)} style={{ display: "grid", gridTemplateColumns: "1fr 0.9fr 1.3fr 1.2fr 1.6fr 1fr 1.5fr", padding: "11px 16px", gap: 8, alignItems: "center", borderBottom: `1px solid ${PIERRE}`, fontSize: 13, cursor: "pointer" }}>
                    <div style={{ fontWeight: 600 }}>{t.numero}</div>
                    <div>{formatDate(t.dateReclamation)}<div style={{ fontSize: 11, color: retard ? ROUILLE : TAUPE }}>{t.statut === "Clôturé" ? "" : `${joursDepuis(t.dateReclamation)} j${retard ? " — en retard" : ""}`}</div></div>
                    <div>{(clientDe(t.clientId) || {}).nom || "—"}</div>
                    <div>{co ? co.numeroFacture || co.numeroBL || co.numero : libOrigineSav(t, true) || "—"}</div>
                    <div>{t.motif}</div>
                    <div>{nomsUtilisateurs(pilotesSav(t))}</div>
                    <div style={{ color: t.statut === "Clôturé" ? VERT_OK : retard ? ROUILLE : ENCRE }}>{statutAfficheSav(t)}</div>
                  </div>
                );
              })}
            </div>
            <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 16 }}>
              <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 12 }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginRight: 8 }}>Statistiques SAV</div>
                <span style={{ fontSize: 12, color: TAUPE }}>Réclamations du</span>
                <input type="date" className="sc-input" value={savStats.du} onChange={(e) => setSavStats({ ...savStats, du: e.target.value })} style={{ ...inputStyle(150), padding: "4px 8px", fontSize: 12 }} />
                <span style={{ fontSize: 12, color: TAUPE }}>au</span>
                <input type="date" className="sc-input" value={savStats.au} onChange={(e) => setSavStats({ ...savStats, au: e.target.value })} style={{ ...inputStyle(150), padding: "4px 8px", fontSize: 12 }} />
                <span style={{ fontSize: 12 }}><strong>{periode.length}</strong> SAV{peut("sav.couts") ? ` · coût ${formatDH(periode.reduce((n, t) => n + coutTotalSav(t).total, 0))}` : ""}</span>
                <button type="button" className="sc-btn" onClick={exporterSav} disabled={periode.length === 0} style={{ ...ghostBtnStyle, fontSize: 12, marginLeft: "auto", opacity: periode.length ? 1 : 0.5 }}>⬇ Exporter (CSV)</button>
              </div>
              <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
                {tableStats("Par motif", grouper((t) => t.motif))}
                {tableStats("Par commercial (pilote)", grouper((t) => nomsUtilisateurs(pilotesSav(t))))}
                {tableStats("Par poseur (dossier d'origine)", grouper(poseursOrigine))}
                {tableStats("Par matière (dossier d'origine)", grouper(matieresOrigine))}
              </div>
              {!peut("sav.couts") && <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>Les coûts ne sont visibles que par le Gérant.</div>}
            </div>
          </div>
        );
      })()}

      {savEdit && (() => {
        const t = savEdit;
        const co = commandeOrigineSav(t);
        const nouveau = !t.id;
        const ant = origineAnterieureSav(t);
        const gere = nouveau ? (ant ? !t.clientId || peutOuvrirSavClient(t.clientId) : peutOuvrirSav(co)) : peutGererSav(t);
        const clos = t.statut === "Clôturé";
        const ro = !gere || clos;
        const set = (patch) => setSavEdit({ ...t, ...patch });
        const dSav = devisSavDe(t);
        const cSav = commandeSavDe(t);
        const k = coutTotalSav(t);
        const mat = coutMatiereSav(t);
        const motifs = motifsSav().includes(t.motif) || !t.motif ? motifsSav() : [...motifsSav(), t.motif];
        return (
          <Overlay onClose={() => setSavEdit(null)}>
            <div style={modalStyle(760)}>
              <div style={modalTitleStyle}>{nouveau ? "Nouveau SAV" : `${t.numero} — ${statutAfficheSav(t)}`}</div>
              <div style={{ fontSize: 13, color: TAUPE, marginTop: -8, marginBottom: 14 }}>
                Client : <strong style={{ color: ENCRE }}>{(clientDe(t.clientId) || {}).nom || "—"}</strong> · Dossier d'origine : <strong style={{ color: ENCRE }}>{libOrigineSav(t) || "—"}</strong>{co && co.reference ? ` (${co.reference})` : ant && ant.description ? ` (${ant.description})` : ""} · Pilote : <strong style={{ color: ENCRE }}>{nomsUtilisateurs(pilotesSav(t))}</strong>
                {!nouveau && savEnRetard(t) && <span style={{ color: ROUILLE }}> · en retard ({joursDepuis(t.dateReclamation)} j)</span>}
              </div>
              {ant && !clos && gere && (() => {
                // Nils 02/11 : commande d'avant l'ERP — client, puis facture antérieure enregistrée ou n° saisi.
                const setAnt = (patch) => set({ origineAnterieure: { ...ant, ...patch } });
                const clientsPossibles = (clients || []).filter((cl) => peutOuvrirSavClient(cl.id)).sort((a, b) => String(a.nom || "").localeCompare(String(b.nom || "")));
                const factAnt = (facturesAnt || []).filter((x) => x.type !== "avoir" && x.clientId === t.clientId);
                return (
                  <div style={{ background: PIERRE, borderRadius: 8, padding: "10px 12px", marginBottom: 12 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>Commande d'avant l'ERP</div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                      <Field label="Client *">
                        <select className="sc-select" value={t.clientId || ""} disabled={!nouveau} onChange={(e) => set({ clientId: e.target.value, origineAnterieure: { ...ant, factureAntId: "" } })} style={selectStyle}>
                          <option value="">— Choisir —</option>
                          {clientsPossibles.map((cl) => (<option key={cl.id} value={cl.id}>{cl.nom}</option>))}
                        </select>
                      </Field>
                      <Field label="Facture antérieure enregistrée (facultatif)">
                        <select className="sc-select" value={ant.factureAntId || ""} disabled={!t.clientId} onChange={(e) => { const f = factAnt.find((x) => x.id === e.target.value); setAnt(f ? { factureAntId: f.id, numero: f.numero || "", date: f.date || "", description: ant.description || f.reference || "" } : { factureAntId: "" }); }} style={selectStyle}>
                          <option value="">{factAnt.length ? "— Aucune / saisir le n° —" : "Aucune facture antérieure pour ce client"}</option>
                          {factAnt.map((f) => (<option key={f.id} value={f.id}>{f.numero} — {formatDate(f.date)}{f.reference ? ` — ${f.reference}` : ""}</option>))}
                        </select>
                      </Field>
                      <Field label="N° de facture ou de BL d'origine *">
                        <input className="sc-input" value={ant.numero || ""} onChange={(e) => setAnt({ numero: e.target.value })} placeholder="ex. FA-2025-0412" style={inputStyle("100%")} />
                      </Field>
                      <Field label="Date du document">
                        <input type="date" className="sc-input" value={ant.date || ""} onChange={(e) => setAnt({ date: e.target.value })} style={inputStyle("100%")} />
                      </Field>
                    </div>
                    <Field label="Ce qui avait été livré (courte description)">
                      <input className="sc-input" value={ant.description || ""} onChange={(e) => setAnt({ description: e.target.value })} placeholder="ex. Plan de travail + îlot Calacatta, villa Palmeraie" style={inputStyle("100%")} />
                    </Field>
                    <div style={{ fontSize: 11, color: TAUPE }}>Tu peux joindre une photo de l'ancienne facture dans « Photos / documents ».</div>
                  </div>
                );
              })()}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <Field label="Date de la réclamation">
                  <input type="date" className="sc-input" value={t.dateReclamation || ""} disabled={ro} onChange={(e) => set({ dateReclamation: e.target.value })} style={inputStyle("100%")} />
                </Field>
                <Field label="Motif (un seul par ticket)">
                  <select className="sc-select" value={t.motif || ""} disabled={ro} onChange={(e) => set({ motif: e.target.value })} style={selectStyle}>
                    <option value="">— Choisir —</option>
                    {motifs.map((m) => (<option key={m} value={m}>{m}</option>))}
                  </select>
                </Field>
              </div>
              <Field label="Description de la réclamation">
                <textarea className="sc-input" value={t.description || ""} disabled={ro} onChange={(e) => set({ description: e.target.value })} rows={3} style={{ ...inputStyle("100%"), resize: "vertical" }} />
              </Field>
              <Field label="Photos / documents">
                {/* Nils 01/11 : fichiers déposés sur le serveur ; les anciens liens restent affichés. */}
                {(t.liens || []).map((l) => (
                  <div key={l.id} style={{ fontSize: 12, display: "flex", gap: 8, alignItems: "center", padding: "2px 0" }}>
                    <span style={{ fontWeight: 600 }}>{l.label || "Lien"}</span>
                    {/^https?:\/\//i.test(l.lien) ? <a href={l.lien} target="_blank" rel="noopener noreferrer" style={{ color: ENCRE }}>{l.lien}</a> : <span>{l.lien}</span>}
                    <span style={{ color: TAUPE }}>— {l.par}</span>
                  </div>
                ))}
                {(t.fichiers || []).map((x) => {
                  const enregistre = ((savListe || []).find((y) => y.id === t.id) || {}).fichiers || [];
                  const href = enregistre.some((y) => y.id === x.id) && window.storage && window.storage.lienFichier ? window.storage.lienFichier(x.id) : null;
                  return (
                    <div key={x.id} style={{ fontSize: 12, display: "flex", gap: 8, alignItems: "center", padding: "2px 0" }}>
                      {href ? <a href={href} target="_blank" rel="noopener noreferrer" style={{ color: ENCRE }}>📎 {x.nom}</a> : <span>📎 {x.nom}</span>}
                      <span style={{ color: TAUPE }}>({formatTaille(x.taille)}) — {x.par}</span>
                      {!ro && <span title="Retirer" onClick={() => set({ fichiers: (t.fichiers || []).filter((y) => y.id !== x.id) })} style={{ cursor: "pointer", color: ROUILLE }}>✕</span>}
                    </div>
                  );
                })}
                {!(t.liens || []).length && !(t.fichiers || []).length && <div style={{ fontSize: 12, color: OCRE }}>Aucune photo : joins au moins une photo de la casse.</div>}
                {!ro && (
                  <label className="sc-btn" style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 0", cursor: "pointer", display: "inline-block", marginTop: 4 }}>
                    {depotSav ? "Envoi en cours…" : "📎 Joindre des photos / documents"}
                    <input type="file" multiple accept={EXTENSIONS_FICHIERS.map((e) => `.${e}`).join(",")} style={{ display: "none" }} disabled={depotSav} onChange={(e) => { const fs = [...(e.target.files || [])]; e.target.value = ""; if (fs.length) joindreFichiersSav(fs); }} />
                  </label>
                )}
                {(t.fichiers || []).some((x) => !(((savListe || []).find((y) => y.id === t.id) || {}).fichiers || []).some((y) => y.id === x.id)) && <div style={{ fontSize: 11, color: OCRE, marginTop: 4 }}>Fichiers ajoutés : ils ne sont rattachés qu'en enregistrant le ticket.</div>}
              </Field>

              {!nouveau && (
                <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 12, marginBottom: 14 }}>
                  <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Traitement</div>
                  <div style={{ fontSize: 13, marginBottom: 10 }}>
                    {dSav ? (
                      <span>Devis SAV <strong>{dSav.numero}</strong> ({dSav.statut}){cSav ? <> → dossier <strong>{[cSav.numero, cSav.numeroPL, cSav.numeroBL, cSav.numeroFacture].filter(Boolean).join(" / ")}</strong> ({cSav.statut})</> : null}
                        {" "}<button type="button" className="sc-btn" onClick={() => { setSavEdit(null); if (cSav) { setActiveTab("commandes"); ouvrirCommande(cSav.id); } else { setActiveTab("devis"); ouvrirDevis(dSav.id); } }} style={{ ...ghostBtnStyle, fontSize: 12, padding: 0 }}>Ouvrir ›</button>
                      </span>
                    ) : (
                      <span style={{ color: TAUPE }}>Travail de production, matière ou pose à prévoir ? Crée un devis SAV : il suit le circuit normal (à 0 DH ou facturé au client).{" "}
                        {/* Nils 02/11 : bouton bien visible (il se confondait avec la phrase grise). */}
                        {gere && !clos && <div style={{ marginTop: 8 }}><button type="button" className="sc-btn" onClick={creerDevisSav} style={{ ...primaryBtnStyle, fontSize: 12, padding: "7px 14px" }}>+ Créer le devis SAV</button></div>}
                      </span>
                    )}
                  </div>
                  <div style={{ fontSize: 12, color: TAUPE, marginBottom: 6 }}>Petite intervention (réglage, silicone…) sans dossier : note-la ici. Consommables : saisis-les en « Atelier (hors dossier) » en citant « {t.numero} » dans le motif — ils seront comptés dans le coût.</div>
                  <div style={{ display: "grid", gridTemplateColumns: "150px 1fr", gap: 10 }}>
                    <input type="date" className="sc-input" value={(t.intervention || {}).date || ""} disabled={ro} onChange={(e) => set({ intervention: { ...(t.intervention || {}), date: e.target.value } })} title="Date d'intervention" style={inputStyle("100%")} />
                    <input className="sc-input" value={(t.intervention || {}).intervenant || ""} disabled={ro} onChange={(e) => set({ intervention: { ...(t.intervention || {}), intervenant: e.target.value } })} placeholder="Intervenant(s)" style={inputStyle("100%")} />
                  </div>
                  <textarea className="sc-input" value={(t.intervention || {}).compteRendu || ""} disabled={ro} onChange={(e) => set({ intervention: { ...(t.intervention || {}), compteRendu: e.target.value } })} rows={2} placeholder="Compte rendu d'intervention" style={{ ...inputStyle("100%"), marginTop: 8, resize: "vertical" }} />
                </div>
              )}

              {!nouveau && peut("sav.couts") && (
                <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 12, marginBottom: 14 }}>
                  <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Coût (visible par toi seul)</div>
                  <div style={{ fontSize: 13, marginBottom: 8 }}>
                    Matière et consommables : <strong>{formatDH(mat.montant)}</strong> <span style={{ color: TAUPE }}>({mat.nbMouvements} sortie(s){mat.nonValorises ? `, dont ${mat.nonValorises} sans prix d'achat` : ""})</span>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
                    {[["mainOeuvre", "Main-d'œuvre (DH)"], ["deplacement", "Déplacement (DH)"], ["autre", "Autre (DH)"]].map(([cle, lib]) => (
                      <Field key={cle} label={lib}>
                        <input type="number" min="0" className="sc-input" value={(t.couts || {})[cle] ?? ""} onChange={(e) => set({ couts: { ...(t.couts || {}), [cle]: e.target.value } })} style={inputStyle("100%")} />
                      </Field>
                    ))}
                  </div>
                  <div style={{ fontSize: 14, fontWeight: 600 }}>Coût total : {formatDH(k.total)}{montantFactureSav(t) ? <span style={{ fontWeight: 400, color: TAUPE }}> · facturé au client {formatDH(montantFactureSav(t))} HT</span> : null}</div>
                </div>
              )}

              {/* Nils 01/11 : pièce cassée rapportée → registre des plans récupérés. */}
              {!nouveau && (() => {
                const plans = (plansRecuperes || []).filter((p) => p.origineType === "SAV" && p.origineRef === t.numero);
                if (!plans.length && !peutGererPlans) return null;
                return (
                  <div style={{ fontSize: 12, marginBottom: 12 }}>
                    <span style={{ color: TAUPE }}>Pièce cassée rapportée à l'atelier : </span>
                    {plans.map((p) => (<span key={p.id} style={{ marginRight: 10 }}>♻ {nomProduit(p.produitId)} {p.dimensions} ({statutPlan(p).lib})</span>))}
                    {!plans.length && <span style={{ color: TAUPE }}>pas encore inscrite. </span>}
                    {peutGererPlans && <button type="button" className="sc-btn" onClick={() => { setSavEdit(null); nouveauPlanRecupere({ origineType: "SAV", origineRef: t.numero, dossierNumero: co ? co.numero : "", etat: "Cassé" }); }} style={{ ...ghostBtnStyle, fontSize: 12, padding: 0 }}>♻ Inscrire au registre des plans récupérés</button>}
                  </div>
                );
              })()}
              {!nouveau && !clos && gere && (
                <Field label="Clôture — ce qui a été fait / cause retenue">
                  <textarea className="sc-input" value={t.clotureNote || ""} onChange={(e) => set({ clotureNote: e.target.value })} rows={2} style={{ ...inputStyle("100%"), resize: "vertical" }} />
                  {clotureSavBloquee(t) && <div style={{ fontSize: 11, color: OCRE, marginTop: 4 }}>{clotureSavBloquee(t)}</div>}
                </Field>
              )}
              {clos && (
                <div style={{ fontSize: 13, background: PIERRE, borderRadius: 8, padding: 10, marginBottom: 14 }}>
                  Clôturé le {formatDateHeure(t.clotureLe)} par {t.cloturePar} — {t.clotureNote}
                  {cSav && cSav.statut === "BL" && <div style={{ color: TAUPE, marginTop: 4 }}>Dossier SAV {cSav.numero} : {dossierArchive(cSav) ? "archivé" : cSav.enAttenteDe === EA_SAV_CLOTURE ? "à archiver par le Gérant" : cSav.enAttenteDe || ""}.</div>}
                </div>
              )}

              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, flexWrap: "wrap", marginTop: 8 }}>
                {clos && peut("sav.couts") && <button type="button" className="sc-btn" onClick={rouvrirSav} style={{ ...ghostBtnStyle, marginRight: "auto" }}>Rouvrir</button>}
                {!nouveau && !clos && gere && t.statut !== "Intervenu" && !cSav && <button type="button" className="sc-btn" onClick={marquerSavIntervenu} style={ghostBtnStyle}>✓ Intervention faite</button>}
                {!nouveau && !clos && gere && <button type="button" className="sc-btn" onClick={cloturerSav} disabled={!!clotureSavBloquee(t)} title={clotureSavBloquee(t) || undefined} style={{ ...ghostBtnStyle, opacity: clotureSavBloquee(t) ? 0.5 : 1 }}>Clôturer le SAV</button>}
                <button type="button" className="sc-btn" onClick={() => setSavEdit(null)} style={ghostBtnStyle}>Fermer</button>
                {(gere && !clos) || (clos && peut("sav.couts")) ? <button type="button" className="sc-btn" onClick={() => enregistrerTicketSav()} style={primaryBtnStyle}>{nouveau ? "Ouvrir le SAV" : "Enregistrer"}</button> : null}
              </div>
            </div>
          </Overlay>
        );
      })()}

      {/* ERP step 11 (demande Nils du 29/09) : onglet Paramétrage — Nils seul */}
      {activeTab === "parametrage" && peut("admin.parametrage") && (() => {
        // ERP step 12 (Nils 30/09) : chaque catégorie se replie / se déplie (fermées par défaut).
        const carte = (titre, contenu, note) => {
          const ouverte = !!cartesParamOuvertes[titre];
          return (
            <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: "12px 16px", marginBottom: 12 }}>
              <div onClick={() => setCartesParamOuvertes({ ...cartesParamOuvertes, [titre]: !ouverte })} style={{ fontSize: 12, color: ouverte ? ENCRE : TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, cursor: "pointer", userSelect: "none", display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ width: 12 }}>{ouverte ? "▾" : "▸"}</span>{titre}
              </div>
              {ouverte && <div style={{ marginTop: 12 }}>{contenu}</div>}
              {ouverte && note && <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>{note}</div>}
            </div>
          );
        };
        const ligneReglage = (libelle, valeur, saisi, setSaisi, enregistrer, props) => (
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", fontSize: 13, padding: "6px 0", borderBottom: `1px solid ${PIERRE}` }}>
            <span style={{ flex: 1, minWidth: 260 }}>{libelle} : <strong>{valeur}</strong></span>
            <input type="number" className="sc-input" value={saisi} onChange={(e) => setSaisi(e.target.value)} placeholder="Nouvelle valeur" style={{ ...inputStyle(120), padding: "5px 8px", fontSize: 12 }} {...props} />
            <button type="button" className="sc-btn" onClick={enregistrer} disabled={saisi === ""} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0", opacity: saisi === "" ? 0.5 : 1 }}>Enregistrer</button>
          </div>
        );
        const colonnes = [
          ...profilsListe().filter((x) => x.id !== P_GERANT).map((x) => ({ jeton: `p:${x.id}`, label: x.label })),
          { jeton: "@commercial", label: "Commercial du dossier" },
          { jeton: "*", label: "Tout le monde" },
        ];
        return (
          <div>
            {estGerant && carte("Numéros de départ des séries", (
              <div>
                {departsSeries === null ? (
                  <button type="button" className="sc-btn" onClick={async () => setDepartsSeries((await (window.storage.departs ? window.storage.departs() : null)) || [])} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0" }}>Afficher les séries</button>
                ) : departsSeries.map((x) => (
                  <div key={x.serie} style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", fontSize: 13, padding: "5px 0", borderBottom: `1px solid ${PIERRE}` }}>
                    <strong style={{ minWidth: 60 }}>{x.serie}</strong>
                    <span style={{ flex: 1, color: TAUPE }}>
                      {x.depart ? `Départ saisi : ${x.depart.dernier ? x.depart.numero : "aucun numéro avant l'ERP"} (le ${formatDate(String(x.depart.saisiLe).slice(0, 10))})` : x.documents ? "Documents déjà présents dans l'ERP" : "À saisir au premier document de la série"}
                    </span>
                    {!x.depart && !x.documents && (
                      <button type="button" className="sc-btn" onClick={async () => { if (await saisirNumeroDepart(x.serie, x.annuelle ? new Date().getFullYear() : undefined)) setDepartsSeries((await window.storage.departs()) || []); }} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 10px" }}>Saisir maintenant</button>
                    )}
                  </div>
                ))}
              </div>
            ), "Au premier document de chaque série, l'ERP te demande le dernier numéro émis avant l'ERP (les autres attendent que tu l'aies saisi). Tu peux aussi le saisir ici à l'avance. Il ne se change plus ensuite.")}
            {estGerant && carte("Fichiers retirés (30 jours)", (
              <div>
                {fichiersRetires === null ? (
                  <button type="button" className="sc-btn" onClick={chargerFichiersRetires} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0" }}>Afficher la liste</button>
                ) : fichiersRetires.length === 0 ? (
                  <div style={{ fontSize: 13, color: TAUPE }}>Aucun fichier retiré ces 30 derniers jours.</div>
                ) : (
                  fichiersRetires.map((f) => (
                    <div key={f.id} style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", fontSize: 13, padding: "6px 0", borderBottom: `1px solid ${PIERRE}` }}>
                      <span style={{ flex: 1, minWidth: 240 }}>
                        <strong>{f.nom}</strong> ({formatTaille(f.taille)}) — {f.libelle ? f.libelle : f.dossierNumero ? `dossier ${f.dossierNumero}` : f.devisNumero !== null ? `devis ${f.devisNumero}` : "devis supprimé"}
                        <div style={{ fontSize: 11, color: TAUPE }}>Retiré par {f.retirePar} le {formatDateHeure(f.retireLe)} · effacé définitivement le {formatDate(f.effaceLe.slice(0, 10))}</div>
                      </span>
                      {(f.restaurable ?? f.devisNumero !== null) && <button type="button" className="sc-btn" onClick={() => restaurerFichier(f)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 10px" }}>Restaurer</button>}
                    </div>
                  ))
                )}
                {fichiersRetires !== null && <button type="button" className="sc-btn" onClick={chargerFichiersRetires} style={{ ...ghostBtnStyle, fontSize: 11, padding: "6px 0", marginTop: 6 }}>↻ Actualiser</button>}
              </div>
            ), "Un fichier retiré d'un document reste récupérable 30 jours, puis il est effacé définitivement. Restauré, il revient dans « Autres documents » de son devis (ou dans les pièces jointes de sa facture fournisseur).")}
            {estGerant && carte("Alertes et tâches par personne", (() => {
              const actifs = utilisateurs.filter((u) => u.actif);
              const nomsDe = (ids) => ids.map((id) => nomUtilisateur(id) || id).join(", ");
              const lignes = CATALOGUE_NOTIFS.map((n) => {
                const parJeton = n.dest.map((j) => ({ j, ids: destinatairesNotif(j), selon: ["@choisis", "@declarant", "@document"].includes(j) }));
                return { ...n, parJeton, ids: new Set(parJeton.flatMap((x) => x.ids)) };
              }).filter((n) => !notifPersonne || n.ids.has(notifPersonne));
              const libDest = (x) => x.j.startsWith("p:") ? `${(profilsListe().find((pp) => pp.id === x.j.slice(2)) || {}).label || x.j.slice(2)} : ${nomsDe(x.ids) || "personne"}` : x.selon ? LIB_JETON_NOTIF[x.j] : `${LIB_JETON_NOTIF[x.j]} : ${nomsDe(x.ids) || "personne"}`;
              const exporter = async () => {
                const q = (v) => `"${String(v === null || v === undefined ? "" : v).replace(/"/g, '""')}"`;
                const rows = [["Genre", "Domaine", "Alerte / tâche", "Déclencheur", "Destinataires"].map(q).join(";"), ...lignes.map((n) => [n.genre, n.domaine, n.nom, n.declencheur, n.parJeton.map(libDest).join(" | ")].map(q).join(";"))];
                await proposerTelechargement(`alertes-taches${notifPersonne ? "-" + notifPersonne : ""}-${todayISO()}.csv`, "\ufeff" + rows.join("\r\n"));
              };
              const th = { padding: "4px 6px", color: TAUPE, fontWeight: 500, fontSize: 11, textAlign: "left" };
              return (
                <div>
                  <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 10, flexWrap: "wrap" }}>
                    <select className="sc-select" value={notifPersonne} onChange={(e) => setNotifPersonne(e.target.value)} style={{ ...selectStyle, width: "auto", fontSize: 12 }}>
                      <option value="">Tout le monde</option>
                      {actifs.map((u) => (<option key={u.id} value={u.id}>{u.nom} — {u.role}</option>))}
                    </select>
                    <span style={{ fontSize: 12, color: TAUPE }}>{lignes.filter((n) => n.genre === "Alerte").length} alerte(s), {lignes.filter((n) => n.genre === "Tâche").length} tâche(s)</span>
                    <button type="button" className="sc-btn" onClick={exporter} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0", marginLeft: "auto" }}>⬇ Exporter (CSV)</button>
                  </div>
                  <div style={{ overflowX: "auto" }}>
                    <table style={{ borderCollapse: "collapse", fontSize: 12, width: "100%" }}>
                      <thead><tr><th style={th}>Genre</th><th style={th}>Domaine</th><th style={th}>Alerte / tâche</th><th style={th}>Déclencheur</th><th style={th}>Destinataires</th></tr></thead>
                      <tbody>
                        {lignes.map((n, i) => (
                          <tr key={i} style={{ borderTop: `1px solid ${PIERRE}` }}>
                            <td style={{ padding: "4px 6px", color: n.genre === "Alerte" ? ROUILLE : ENCRE, fontWeight: 600 }}>{n.genre}</td>
                            <td style={{ padding: "4px 6px", color: TAUPE }}>{n.domaine}</td>
                            <td style={{ padding: "4px 6px" }}>{n.nom}</td>
                            <td style={{ padding: "4px 6px", color: TAUPE }}>{n.declencheur}</td>
                            <td style={{ padding: "4px 6px" }}>{n.parJeton.map((x) => (<div key={x.j}>{libDest(x)}</div>))}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })(), "Consultation seulement. Les alertes vont à ceux qui voient les alertes (droit « Voir les alertes et les tâches de tout le monde »). Les destinataires « selon le cas » dépendent du dossier ou de la tâche. Les noms suivent les profils actuels des comptes.")}
            {peut("admin.comptes") && carte("Profils d'accès", (() => {
              const profils = profilsListe();
              const groupes = [...new Set(DROITS.map((d) => d.groupe))];
              const th = { padding: "4px 6px", color: TAUPE, fontWeight: 500, fontSize: 11, textAlign: "center", verticalAlign: "bottom" };
              return (
                <div style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", fontSize: 12, width: "100%" }}>
                    <thead>
                      <tr>
                        <th style={{ ...th, textAlign: "left", minWidth: 260 }}>Onglet / action</th>
                        {profils.map((x) => (<th key={x.id} style={{ ...th, minWidth: 74 }}>{x.label}{x.id !== P_GERANT && acces && acces.profils && acces.profils[x.id] ? <div><button type="button" className="sc-btn" onClick={() => reinitialiserProfil(x.id)} style={{ ...ghostBtnStyle, fontSize: 10, padding: 0 }} title="Revenir aux droits d'origine">↺ origine</button></div> : null}</th>))}
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td colSpan={profils.length + 1} style={{ padding: "8px 6px 2px", fontWeight: 600, color: ENCRE }}>Onglets</td></tr>
                      {ONGLETS_ACCES.map((o) => (
                        <tr key={o.cle} style={{ borderTop: `1px solid ${PIERRE}` }}>
                          <td style={{ padding: "4px 6px" }}>{o.label}</td>
                          {profils.map((x) => (
                            <td key={x.id} style={{ textAlign: "center", padding: "2px" }}>
                              {x.id === P_GERANT ? <span style={{ color: TAUPE }}>{LIB_NIVEAU_ACCES[(x.onglets || {})[o.cle] || ""]}</span> : (
                                <select className="sc-select" value={(x.onglets || {})[o.cle] || ""} onChange={(e) => changerOngletProfil(x.id, o.cle, e.target.value)} style={{ ...selectStyle, fontSize: 11, padding: "2px 4px", background: "#fff" }}>
                                  {o.niveaux.map((n) => (<option key={n} value={n}>{LIB_NIVEAU_ACCES[n]}</option>))}
                                </select>
                              )}
                            </td>
                          ))}
                        </tr>
                      ))}
                      {groupes.map((g) => (
                        <React.Fragment key={g}>
                          <tr><td colSpan={profils.length + 1} style={{ padding: "10px 6px 2px", fontWeight: 600, color: ENCRE }}>{g}</td></tr>
                          {DROITS.filter((d) => d.groupe === g).map((d) => (
                            <tr key={d.cle} style={{ borderTop: `1px solid ${PIERRE}` }}>
                              <td style={{ padding: "4px 6px" }}>{d.label}</td>
                              {profils.map((x) => (
                                <td key={x.id} style={{ textAlign: "center" }}>
                                  <input type="checkbox" checked={(x.droits || []).includes(d.cle)} disabled={x.id === P_GERANT} onChange={() => basculerDroitProfil(x.id, d.cle)} />
                                </td>
                              ))}
                            </tr>
                          ))}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
              );
            })(), "Le profil Gérant a toujours tout. Une case changée s'applique tout de suite à tous les comptes du profil (sauf exception individuelle, carte « Comptes utilisateurs »). Chaque changement est tracé au Journal d'accès. Ce sont des réglages d'ergonomie tant que l'ERP n'a pas de vraie connexion (OVH).")}
            {peut("admin.comptes") && carte("Comptes utilisateurs", (
              <>
                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                  {comptesAcces.map((c) => {
                    const fiche = (staff || []).find((s) => s.compte === c.id);
                    const ouvert = compteEdit === c.id;
                    const dansProfil = new Set(c.profil === P_GERANT ? [] : profilsAcces[c.profil].droits || []);
                    return (
                      <div key={c.id} style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "8px 10px", background: c.actif === false ? "#F5F3F1" : "#fff", opacity: c.actif === false ? 0.7 : 1 }}>
                        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", fontSize: 13 }}>
                          <strong style={{ minWidth: 150 }}>{c.nom}</strong>
                          <select className="sc-select" value={c.profil} onChange={(e) => modifierCompte(c.id, { profil: e.target.value })} style={{ ...selectStyle, fontSize: 12, padding: "3px 6px", width: 190, background: "#fff" }}>
                            {profilsListe().map((x) => (<option key={x.id} value={x.id}>{x.label}</option>))}
                          </select>
                          <span style={{ fontSize: 11, color: TAUPE }}>{fiche ? `fiche Staff : ${fiche.nom}` : "aucune fiche Staff liée"}</span>
                          {((c.ajouts || []).length + (c.retraits || []).length + Object.keys(c.onglets || {}).length) > 0 && <span style={{ fontSize: 11, color: OCRE }}>exceptions : +{(c.ajouts || []).length} / −{(c.retraits || []).length}{Object.keys(c.onglets || {}).length ? ` · ${Object.keys(c.onglets).length} onglet(s)` : ""}</span>}
                          <span style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
                            {c.profil !== P_GERANT && <button type="button" className="sc-btn" onClick={() => setCompteEdit(ouvert ? null : c.id)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 6px" }}>{ouvert ? "Fermer" : "Exceptions…"}</button>}
                            {session && c.actif !== false && <button type="button" className="sc-btn" onClick={() => donnerCodeConnexion(c)} title="Code valable 72 h pour choisir son mot de passe (nouveau compte ou mot de passe oublié)" style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 6px" }}>🔑 Code de connexion</button>}
                            {c.id !== user.id && <button type="button" className="sc-btn" onClick={() => modifierCompte(c.id, { actif: c.actif === false })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 6px", color: c.actif === false ? VERT_OK : ROUILLE }}>{c.actif === false ? "Réactiver" : "Désactiver"}</button>}
                          </span>
                        </div>
                        {ouvert && (
                          <div style={{ marginTop: 8, fontSize: 12, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                            <div>
                              <div style={{ color: TAUPE, marginBottom: 4 }}>Droits en plus de son profil</div>
                              {(c.ajouts || []).map((k) => (<div key={k} style={{ display: "flex", gap: 6, alignItems: "center" }}><span style={{ flex: 1 }}>+ {(DROITS.find((d) => d.cle === k) || {}).label || k}</span><button type="button" className="sc-btn" onClick={() => modifierCompte(c.id, { ajouts: (c.ajouts || []).filter((x) => x !== k) })} style={iconBtnStyle}>✕</button></div>))}
                              <select className="sc-select" value="" onChange={(e) => e.target.value && modifierCompte(c.id, { ajouts: [...(c.ajouts || []), e.target.value] })} style={{ ...selectStyle, fontSize: 11, marginTop: 4, background: "#fff" }}>
                                <option value="">+ Ajouter un droit…</option>
                                {DROITS.filter((d) => !dansProfil.has(d.cle) && !(c.ajouts || []).includes(d.cle)).map((d) => (<option key={d.cle} value={d.cle}>{d.groupe} — {d.label}</option>))}
                              </select>
                            </div>
                            <div>
                              <div style={{ color: TAUPE, marginBottom: 4 }}>Droits de son profil qu'il / elle n'a pas</div>
                              {(c.retraits || []).map((k) => (<div key={k} style={{ display: "flex", gap: 6, alignItems: "center" }}><span style={{ flex: 1 }}>− {(DROITS.find((d) => d.cle === k) || {}).label || k}</span><button type="button" className="sc-btn" onClick={() => modifierCompte(c.id, { retraits: (c.retraits || []).filter((x) => x !== k) })} style={iconBtnStyle}>✕</button></div>))}
                              <select className="sc-select" value="" onChange={(e) => e.target.value && modifierCompte(c.id, { retraits: [...(c.retraits || []), e.target.value] })} style={{ ...selectStyle, fontSize: 11, marginTop: 4, background: "#fff" }}>
                                <option value="">− Retirer un droit…</option>
                                {[...dansProfil].filter((k) => !(c.retraits || []).includes(k)).map((k) => (<option key={k} value={k}>{(DROITS.find((d) => d.cle === k) || {}).groupe} — {(DROITS.find((d) => d.cle === k) || {}).label || k}</option>))}
                              </select>
                            </div>
                            <div style={{ gridColumn: "1 / -1" }}>
                              <div style={{ color: TAUPE, marginBottom: 4 }}>Accès aux onglets pour cette personne (« comme son profil » = pas d'exception)</div>
                              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(230px, 1fr))", gap: 6 }}>
                                {ONGLETS_ACCES.map((o) => {
                                  const duProfil = ((profilsAcces[c.profil] || {}).onglets || {})[o.cle] || "";
                                  const perso = (c.onglets || {})[o.cle];
                                  return (
                                    <label key={o.cle} style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                      <span style={{ width: 90, color: perso !== undefined ? OCRE : ENCRE, fontWeight: perso !== undefined ? 600 : 400 }}>{o.label}</span>
                                      <select className="sc-select" value={perso === undefined ? "__profil" : perso} onChange={(e) => { const v = e.target.value; const next = { ...(c.onglets || {}) }; if (v === "__profil") delete next[o.cle]; else next[o.cle] = v; modifierCompte(c.id, { onglets: next }); }} style={{ ...selectStyle, fontSize: 11, padding: "2px 4px", background: "#fff", flex: 1 }}>
                                        <option value="__profil">comme son profil ({LIB_NIVEAU_ACCES[duProfil].toLowerCase()})</option>
                                        {o.niveaux.map((n) => (<option key={n} value={n}>{LIB_NIVEAU_ACCES[n]}</option>))}
                                      </select>
                                    </label>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
                <div style={{ display: "flex", gap: 8, marginTop: 12, alignItems: "center", flexWrap: "wrap" }}>
                  <input className="sc-input" value={nouveauCompte.nom} onChange={(e) => setNouveauCompte({ ...nouveauCompte, nom: e.target.value })} onKeyDown={(e) => { if (e.key === "Enter") creerCompte(); }} placeholder="Prénom (et nom) du nouveau compte" style={{ ...inputStyle(260), padding: "5px 8px", fontSize: 12, background: "#fff", border: `1px solid ${TAUPE}` }} />
                  <select className="sc-select" value={nouveauCompte.profil} onChange={(e) => setNouveauCompte({ ...nouveauCompte, profil: e.target.value })} style={{ ...selectStyle, fontSize: 12, padding: "4px 6px", width: 190, background: "#fff" }}>
                    {profilsListe().map((x) => (<option key={x.id} value={x.id}>{x.label}</option>))}
                  </select>
                  <button type="button" className="sc-btn" onClick={creerCompte} style={{ ...primaryBtnStyle, fontSize: 12, padding: "6px 12px" }}>+ Créer le compte</button>
                </div>
              </>
            ), "Pour un nouveau compte, ou un mot de passe oublié : « Code de connexion » donne un code valable 72 h, à transmettre à la personne ; à sa connexion, elle choisit son mot de passe et installe la double authentification. Relie ensuite le compte à sa fiche dans Staff (champ « Compte ERP lié »). Un compte désactivé est déconnecté tout de suite, ne peut plus se connecter et ne reçoit plus de tâches ; son historique reste. Le nom d'un compte ne se change pas (il sert à retrouver les clients d'un commercial).")}
            {carte("Délais et seuils", (
              <>
                {ligneReglage("Relance des devis envoyés après", `${delaiRelanceDevisJours()} j`, delaiRelanceSaisi, setDelaiRelanceSaisi, enregistrerDelaiRelance, { min: 0, step: 1 })}
                {ligneReglage("Alerte prix d'achat : lot au-dessus du target price de plus de", `${seuilEcartPrixPct().toString().replace(".", ",")} %`, seuilPrixSaisi, setSeuilPrixSaisi, enregistrerSeuilPrix, { min: 0, step: 0.5 })}
                {ligneReglage("Usure anormale : durée inférieure à ce % de la moyenne", `${seuilUsureAnormalePct()} %`, seuilUsureSaisi, setSeuilUsureSaisi, enregistrerSeuilUsure, { min: 0, step: 5 })}
              </>
            ))}
            {carte("Congés payés (Staff)", (
              <>
                {[["joursParMois", "Jours acquis par mois de service", " j", 0.5], ["bonusParTranche", "Jours en plus par tranche d'ancienneté", " j", 0.5], ["trancheAnnees", "Durée d'une tranche d'ancienneté", " an(s)", 1], ["plafond", "Plafond annuel", " j", 1]].map(([cle, libelle, unite, pas]) => (
                  <React.Fragment key={cle}>
                    {ligneReglage(libelle, `${String(paramsConges()[cle]).replace(".", ",")}${unite}`, congesSaisis[cle], (v) => setCongesSaisis({ ...congesSaisis, [cle]: v }), async () => {
                      const v = Number(String(congesSaisis[cle]).replace(",", "."));
                      if (!isFinite(v) || v < 0) { setNotice("Indique une valeur valide (0 ou plus)."); return; }
                      const avant = paramsConges()[cle];
                      await persistParametres({ ...(parametres || {}), conges: { ...paramsConges(), [cle]: v } });
                      await tracerAcces("réglage congés", `${libelle} : ${avant} → ${v}`);
                      setCongesSaisis({ ...congesSaisis, [cle]: "" });
                    }, { min: 0, step: pas })}
                  </React.Fragment>
                ))}
                <div style={{ fontSize: 13, marginTop: 8 }}>Droit annuel actuel : <strong>{String(paramsConges().joursParMois * 12).replace(".", ",")} j</strong> + {String(paramsConges().bonusParTranche).replace(".", ",")} j tous les {paramsConges().trancheAnnees} ans d'ancienneté, plafonné à {paramsConges().plafond} j.</div>
              </>
            ), "Par défaut : règle du Code du travail marocain (1,5 j ouvrable par mois, + 1,5 j par tranche de 5 ans, 30 j maximum) — à faire confirmer par le comptable. Le report de l'année précédente se saisit sur chaque fiche (onglet Congés & absences).")}
            {carte("Horaires de travail (pointage)", (() => {
              const reg = regimesHoraires();
              const saisis = regimesSaisis || Object.fromEntries(Object.entries(reg).map(([k, r]) => [k, r.heures.map(String)]));
              const ordre = [1, 2, 3, 4, 5, 6, 0];
              return (
                <>
                  <table style={{ borderCollapse: "collapse", fontSize: 13 }}>
                    <thead><tr><th style={{ textAlign: "left", padding: "4px 8px" }}></th>{ordre.map((i) => <th key={i} style={{ padding: "4px 6px", fontSize: 11, color: TAUPE }}>{JOURS_SEMAINE_LONGS[i].slice(0, 3)}</th>)}<th style={{ padding: "4px 8px", fontSize: 11, color: TAUPE }}>Semaine</th></tr></thead>
                    <tbody>
                      {Object.entries(reg).map(([k, r]) => (
                        <tr key={k}>
                          <td style={{ padding: "4px 8px", whiteSpace: "nowrap" }}>{r.label}{!r.pointageHeures && <div style={{ fontSize: 10, color: TAUPE }}>pas de pointage d'heures (base des absences)</div>}</td>
                          {ordre.map((i) => (
                            <td key={i} style={{ padding: "2px 3px" }}>
                              <input type="number" min="0" max="24" step="any" className="sc-input" value={saisis[k][i]} onChange={(e) => { const n = { ...saisis, [k]: saisis[k].map((v, j) => (j === i ? e.target.value : v)) }; setRegimesSaisis(n); }} style={{ ...inputStyle(56), padding: "3px 5px", fontSize: 12 }} />
                            </td>
                          ))}
                          <td style={{ padding: "4px 8px", fontWeight: 600 }}>{String(arrondiH(saisis[k].reduce((a, v) => a + (Number(String(v).replace(",", ".")) || 0), 0))).replace(".", ",")} h</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {regimesSaisis && (
                    <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                      <button type="button" className="sc-btn" onClick={enregistrerRegimes} style={primaryBtnStyle}>Enregistrer les horaires</button>
                      <button type="button" className="sc-btn" onClick={() => setRegimesSaisis(null)} style={ghostBtnStyle}>Annuler</button>
                    </div>
                  )}
                </>
              );
            })(), "Heures dues par jour. Samedi et dimanche à 0 : les heures travaillées ces jours-là s'ajoutent au compteur. L'horaire de chaque personne se choisit sur sa fiche Staff (par défaut : ADV et secrétariat → Bureau, commerciaux → Commercial, les autres → Usine). Un mois déjà validé garde ses jours fériés, mais un changement d'horaire recalcule les mois passés.")}
            {carte("Jours fériés et congés collectifs", (() => {
              const annee = todayISO().slice(0, 4);
              const liste = joursSpeciaux().filter((x) => x.date >= `${Number(annee) - 1}-01-01`);
              return (
                <>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
                    <input type="date" className="sc-input" value={nouveauJourSpecial.date} onChange={(e) => setNouveauJourSpecial({ ...nouveauJourSpecial, date: e.target.value })} style={{ ...inputStyle(150), padding: "5px 8px" }} />
                    <input className="sc-input" value={nouveauJourSpecial.libelle} onChange={(e) => setNouveauJourSpecial({ ...nouveauJourSpecial, libelle: e.target.value })} placeholder="Libellé (ex. Aïd al-Fitr, fermeture août)" style={{ ...inputStyle(260), padding: "5px 8px" }} />
                    <select className="sc-select" value={nouveauJourSpecial.type} onChange={(e) => setNouveauJourSpecial({ ...nouveauJourSpecial, type: e.target.value })} style={{ ...selectStyle, width: "auto" }}>
                      <option value="ferie">Jour férié (non déduit)</option>
                      <option value="conge">Congé collectif (déduit des congés)</option>
                    </select>
                    <button type="button" className="sc-btn" onClick={ajouterJourSpecial} style={primaryBtnStyle}>Ajouter</button>
                    <button type="button" className="sc-btn" onClick={() => ajouterFeriesFixes(annee)} style={{ ...ghostBtnStyle, fontSize: 12 }}>+ Fériés fixes {annee}</button>
                    <button type="button" className="sc-btn" onClick={() => ajouterFeriesFixes(String(Number(annee) + 1))} style={{ ...ghostBtnStyle, fontSize: 12 }}>+ Fériés fixes {Number(annee) + 1}</button>
                  </div>
                  <div style={{ maxHeight: 260, overflowY: "auto", display: "flex", flexDirection: "column", gap: 4 }}>
                    {liste.length === 0 && <div style={{ fontSize: 13, color: TAUPE }}>Aucun jour déclaré.</div>}
                    {liste.map((x) => (
                      <div key={x.date} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 13, padding: "4px 10px", borderRadius: 6, background: PIERRE }}>
                        <span style={{ width: 110 }}>{JOURS_SEMAINE_LONGS[new Date(`${x.date}T12:00:00Z`).getUTCDay()].slice(0, 3)} {formatDate(x.date)}</span>
                        <span style={{ flex: 1 }}>{x.libelle}</span>
                        <span style={{ fontSize: 11, color: x.type === "ferie" ? TAUPE : OCRE }}>{x.type === "ferie" ? "férié" : "congé collectif"}</span>
                        <button type="button" className="sc-btn" onClick={() => supprimerJourSpecial(x.date)} style={iconBtnStyle} title="Supprimer">✕</button>
                      </div>
                    ))}
                  </div>
                </>
              );
            })(), "Pré-remplis dans le pointage de tout le monde (modifiables case par case). Jours fériés : non déduits des congés. Congés collectifs (jours de fermeture autour de l'Aïd, fermeture d'août) : déduits des congés. Les fêtes religieuses changent de date chaque année : à ajouter à la main. « Fériés fixes » ajoute les 10 jours fériés civils — à vérifier (le calendrier officiel peut évoluer).")}
            {estGerant && carte("Budget community management", (() => {
              const bm = budgetMarketing();
              const sources = sourcesClient();
              const majBM = async (patch, trace) => { await persistParametres({ ...(parametres || {}), budgetMarketing: { ...bm, ...patch } }); await tracerAcces("réglage budget marketing", trace); };
              return (
                <>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, marginBottom: 10 }}>
                    Budget = <input type="number" min="0" max="100" step="0.5" className="sc-input" defaultValue={bm.taux} key={`bm-${bm.taux}`} onBlur={(e) => { const v = Number(String(e.target.value).replace(",", ".")); if (!isFinite(v) || v < 0 || v === Number(bm.taux)) return; majBM({ taux: v }, `taux ${bm.taux} % → ${v} %`); }} style={{ ...inputStyle(70), padding: "5px 8px" }} /> % du CA HT payé (commandes entièrement encaissées) des clients venus par :
                  </div>
                  <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 12 }}>
                    {sources.map((x) => (
                      <label key={x} style={{ fontSize: 12, display: "flex", gap: 4, alignItems: "center", cursor: "pointer" }}>
                        <input type="checkbox" checked={bm.sources.includes(x)} onChange={(e) => majBM({ sources: e.target.checked ? [...bm.sources, x] : bm.sources.filter((y) => y !== x) }, `source ${x} ${e.target.checked ? "ajoutée" : "retirée"}`)} /> {x}
                      </label>
                    ))}
                  </div>
                  <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>Sources attribuées au marketing (statistiques prospects + prospects qu'il voit)</div>
                  <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 12 }}>
                    {sources.map((x) => { const ss = sourcesSalwa(); return (
                      <label key={x} style={{ fontSize: 12, display: "flex", gap: 4, alignItems: "center", cursor: "pointer" }}>
                        <input type="checkbox" checked={ss.includes(x)} onChange={(e) => majBM({ sourcesSalwa: e.target.checked ? [...ss, x] : ss.filter((y) => y !== x) }, `source ${x} ${e.target.checked ? "attribuée à" : "retirée de"} Salwa`)} /> {x}
                      </label>
                    ); })}
                  </div>
                  <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>Liste des sources (fiche client)</div>
                  <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
                    {sources.map((x) => (
                      <span key={x} style={{ fontSize: 12, background: PIERRE, borderRadius: 12, padding: "2px 4px 2px 10px", display: "inline-flex", gap: 4, alignItems: "center" }}>{x}
                        <button type="button" className="sc-btn" onClick={async () => { await persistParametres({ ...(parametres || {}), sourcesClient: sources.filter((y) => y !== x), budgetMarketing: { ...bm, sources: bm.sources.filter((y) => y !== x) } }); await tracerAcces("sources client", `${x} retirée`); }} style={{ ...iconBtnStyle, width: 18, height: 18, fontSize: 11 }} title="Retirer">✕</button>
                      </span>
                    ))}
                  </div>
                  <input className="sc-input" placeholder="Nouvelle source + Entrée" onKeyDown={async (e) => { if (e.key !== "Enter") return; const v = e.target.value.trim(); if (!v || sources.some((y) => normLib(y) === normLib(v))) return; await persistParametres({ ...(parametres || {}), sourcesClient: [...sources, v] }); await tracerAcces("sources client", `${v} ajoutée`); e.target.value = ""; }} style={{ ...inputStyle(240), padding: "5px 8px" }} />
                </>
              );
            })(), "Uniquement pour le community management (pas le marketing). Le budget s'affiche dans Prix et coûts › Commissions ; il est consommé par les sorties de trésorerie au sous-poste Marketing › Community management. Tout le CA futur d'un client compte. La source se règle sur la fiche client (reprise automatiquement du prospect à la conversion).")}
            {carte("Congés spéciaux (Staff)", (() => {
              const l = typesCongesSpeciaux();
              const setT = (id, patch) => majTypesCongesSpeciaux(l.map((t) => (t.id === id ? { ...t, ...patch } : t)));
              return (
                <>
                  {l.map((t) => {
                    const utilise = (staff || []).some((x) => (x.congesSpeciaux || []).some((c) => c.typeId === t.id));
                    return (
                      <div key={t.id} style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", fontSize: 12, marginBottom: 6 }}>
                        <input className="sc-input" defaultValue={t.libelle} key={`l-${t.id}-${t.libelle}`} onBlur={(e) => e.target.value.trim() && e.target.value.trim() !== t.libelle && setT(t.id, { libelle: e.target.value.trim() })} style={{ ...inputStyle(190), padding: "5px 8px" }} />
                        code <input className="sc-input" defaultValue={t.code} key={`c-${t.id}-${t.code}`} onBlur={(e) => { const v = e.target.value.trim().toUpperCase().slice(0, 4); if (!v || v === t.code) return; if (CODES_POINTAGE.some((x) => x.code === v) || l.some((x) => x.id !== t.id && x.code === v)) { setNotice(`Le code « ${v} » est déjà utilisé.`); e.target.value = t.code; return; } setT(t.id, { code: v }); }} style={{ ...inputStyle(60), padding: "5px 8px" }} />
                        <select className="sc-select" value={t.prise} onChange={(e) => setT(t.id, { prise: e.target.value })} style={{ ...selectStyle, width: 230, padding: "5px 8px" }}>
                          <option value="employeur">payé par l'employeur</option>
                          <option value="cnss">CNSS — retiré de la paie</option>
                        </select>
                        durée <input type="number" min="0" className="sc-input" defaultValue={t.jours ?? ""} key={`j-${t.id}-${t.jours}`} onBlur={(e) => setT(t.id, { jours: Number(e.target.value) || 0 })} style={{ ...inputStyle(70), padding: "5px 8px" }} /> j (calendaires)
                        {!utilise && <button type="button" className="sc-btn" onClick={() => majTypesCongesSpeciaux(l.filter((x) => x.id !== t.id), `type « ${t.libelle} » supprimé`)} style={iconBtnStyle} title="Supprimer">✕</button>}
                      </div>
                    );
                  })}
                  <button type="button" className="sc-btn" onClick={() => { const n = l.length + 1; majTypesCongesSpeciaux([...l, { id: uid(), libelle: "Nouveau congé", code: `S${n}`, prise: "employeur", jours: 1 }], "type de congé spécial ajouté"); }} style={{ ...ghostBtnStyle, padding: "2px 0", fontSize: 12 }}>+ Ajouter un type</button>
                </>
              );
            })(), "Saisis sur la fiche Staff (onglet Congés & absences) par l'Administration ou le Gérant ; affichés tout seuls dans le pointage, hors compteur d'heures et hors congés annuels. « CNSS » : jours ajoutés à la colonne « Jours CNSS » des éléments de paie. Valeurs par défaut (paternité 3 j, maternité 14 semaines) à confirmer avec le comptable. Un type déjà utilisé ne peut pas être supprimé.")}
            {carte("Ramadan (Staff)", (() => {
              const rp = ramadanParams();
              const reg = regimesHoraires();
              return (
                <>
                  <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>Heures dues par jour pendant le ramadan (vendredi inclus), selon l'horaire</div>
                  <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 12 }}>
                    {Object.keys(reg).map((k) => (
                      <label key={k} style={{ fontSize: 12, display: "flex", gap: 6, alignItems: "center" }}>{reg[k].label}
                        <input type="number" min="0" max="12" step="any" className="sc-input" defaultValue={rp.dues[k] ?? 7} key={`${k}-${rp.dues[k]}`} onBlur={(e) => { const v = Number(String(e.target.value).replace(",", ".")); if (!isFinite(v) || v < 0 || v === Number(rp.dues[k])) return; majRamadan({ dues: { ...rp.dues, [k]: v } }, `${reg[k].label} : ${rp.dues[k]} h → ${v} h dues par jour pendant le ramadan`); }} style={{ ...inputStyle(70), padding: "5px 8px" }} /> h
                      </label>
                    ))}
                  </div>
                  <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>Dates du ramadan (à saisir chaque année)</div>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 8 }}>
                    du <input type="date" className="sc-input" value={ramadanSaisie.debut} onChange={(e) => setRamadanSaisie({ ...ramadanSaisie, debut: e.target.value })} style={{ ...inputStyle(150), padding: "5px 8px" }} />
                    au <input type="date" className="sc-input" value={ramadanSaisie.fin} onChange={(e) => setRamadanSaisie({ ...ramadanSaisie, fin: e.target.value })} style={{ ...inputStyle(150), padding: "5px 8px" }} />
                    <button type="button" className="sc-btn" onClick={async () => {
                      const { debut, fin } = ramadanSaisie;
                      if (!debut || !fin || fin < debut) { setNotice("Indique la date de début et de fin du ramadan."); return; }
                      if (rp.periodes.some((x) => !(fin < x.debut || debut > x.fin))) { setNotice("Ces dates chevauchent un ramadan déjà saisi."); return; }
                      await majRamadan({ periodes: [...rp.periodes, { id: uid(), debut, fin }].sort((a, b) => (a.debut < b.debut ? -1 : 1)) }, `ramadan du ${formatDate(debut)} au ${formatDate(fin)}`);
                      setRamadanSaisie({ debut: "", fin: "" });
                    }} style={primaryBtnStyle}>Ajouter</button>
                  </div>
                  {!rp.periodes.length && <div style={{ fontSize: 13, color: TAUPE }}>Aucune période saisie.</div>}
                  {rp.periodes.map((x) => (
                    <div key={x.id} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 13, padding: "4px 10px", borderRadius: 6, background: PIERRE, marginBottom: 4 }}>
                      <span style={{ flex: 1 }}>Du {formatDate(x.debut)} au {formatDate(x.fin)}</span>
                      <button type="button" className="sc-btn" onClick={() => majRamadan({ periodes: rp.periodes.filter((y) => y.id !== x.id) }, `ramadan du ${formatDate(x.debut)} au ${formatDate(x.fin)} supprimé`)} style={iconBtnStyle} title="Supprimer">✕</button>
                    </div>
                  ))}
                </>
              );
            })(), "Pendant ces dates, chaque jour travaillé est dû à ce nombre d'heures (ex. 7 h, vendredi inclus) ; la différence avec l'horaire normal est offerte (payée, sans effet sur le compteur). Si quelqu'un travaille plus, les heures jusqu'à l'horaire normal ne comptent ni en heures sup. ni au compteur ; seules celles au-delà de l'horaire normal comptent comme d'habitude. Les absences pendant le ramadan valent ce nombre d'heures. Les dates et heures s'appliquent tant que le mois n'est pas validé.")}
            {carte("Prime de productivité (Staff)", (
              <>
                {[["target", "Target hebdomadaire — CA production facturé HT", " DH", 1000], ["montant", "Prime par personne et par semaine", " DH", 10], ["partTranchesPct", "Si le target n'est pas atteint : part du CA tranches facturées ajoutée", " %", 5]].map(([cle, libelle, unite, pas]) => (
                  <React.Fragment key={cle}>
                    {ligneReglage(libelle, `${Number(paramsProductivite()[cle]).toLocaleString("fr-FR")}${unite}`, paramsProdSaisis[cle], (v) => setParamsProdSaisis({ ...paramsProdSaisis, [cle]: v }), async () => {
                      const v = Number(String(paramsProdSaisis[cle]).replace(",", "."));
                      if (!isFinite(v) || v < 0) { setNotice("Indique une valeur valide."); return; }
                      const avant = paramsProductivite()[cle];
                      await persistParametres({ ...(parametres || {}), primeProductivite: { ...paramsProductivite(), [cle]: v } });
                      await tracerAcces("réglage prime de productivité", `${libelle} : ${avant} → ${v}`);
                      setParamsProdSaisis({ ...paramsProdSaisis, [cle]: "" });
                    }, { min: 0, step: pas })}
                  </React.Fragment>
                ))}
              </>
            ), "CA production = factures de la semaine (lundi → dimanche, date de facture) des dossiers qui contiennent au moins un article de nature « Façonnage » (case cochée sur la fiche article du Catalogue), lignes Tranche exclues. CA tranches = lignes Tranche de toutes les factures de la semaine (les BL ne comptent pas). Proposée chaque mardi pour la semaine écoulée ; tout le monde sauf le Gérant et les commerciaux ; une absence pointée (justifiée, injustifiée, maladie) supprime le droit, sauf exception cochée par le Gérant.")}
            {carte("Types de primes (Staff)", (
              <>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 10 }}>
                  <span style={{ fontSize: 12, background: PIERRE, borderRadius: 14, padding: "3px 10px", color: TAUPE }} title="Type fixe : prime de productivité automatique">{TYPE_PRIME_PRODUCTIVITE} (fixe)</span>
                  {typesPrimes().filter((t) => normLib(t) !== normLib(TYPE_PRIME_PRODUCTIVITE)).map((t) => (
                    <span key={t} style={{ fontSize: 12, background: PIERRE, borderRadius: 14, padding: "3px 6px 3px 10px", display: "flex", alignItems: "center", gap: 4 }}>
                      {t}
                      <button type="button" className="sc-btn" onClick={() => supprimerTypePrime(t)} style={{ ...iconBtnStyle, fontSize: 11 }} title="Retirer">✕</button>
                    </span>
                  ))}
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <input className="sc-input" value={nouveauTypePrime} onChange={(e) => setNouveauTypePrime(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") ajouterTypePrime(); }} placeholder="Nouveau type de prime" style={inputStyle("100%")} />
                  <button type="button" className="sc-btn" onClick={ajouterTypePrime} style={primaryBtnStyle}>Ajouter</button>
                </div>
              </>
            ), "Un type utilisé par une prime déjà enregistrée ne peut pas être supprimé.")}
            {carte("Critères d'évaluation (Staff)", (
              <>
                <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 10 }}>
                  {criteresEvaluation().map((c) => (
                    <div key={c.cle} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 10px", borderRadius: 6, background: PIERRE }}>
                      {critereEdition && critereEdition.cle === c.cle ? (
                        <>
                          <input className="sc-input" autoFocus value={critereEdition.valeur} onChange={(e) => setCritereEdition({ ...critereEdition, valeur: e.target.value })} onKeyDown={async (e) => { if (e.key === "Enter") { await renommerCritereEvaluation(c.cle, critereEdition.valeur); setCritereEdition(null); } if (e.key === "Escape") setCritereEdition(null); }} style={{ ...inputStyle("100%"), padding: "4px 8px", fontSize: 13 }} />
                          <button type="button" className="sc-btn" onClick={async () => { await renommerCritereEvaluation(c.cle, critereEdition.valeur); setCritereEdition(null); }} style={iconBtnStyle} title="Valider">✓</button>
                          <button type="button" className="sc-btn" onClick={() => setCritereEdition(null)} style={iconBtnStyle} title="Annuler">↩</button>
                        </>
                      ) : (
                        <>
                          <span style={{ flex: 1, fontSize: 13 }}>{c.label}</span>
                          <button type="button" className="sc-btn" onClick={() => setCritereEdition({ cle: c.cle, valeur: c.label })} style={iconBtnStyle} title="Modifier">✎</button>
                          <button type="button" className="sc-btn" onClick={() => supprimerCritereEvaluation(c.cle)} style={iconBtnStyle} title="Supprimer">✕</button>
                        </>
                      )}
                    </div>
                  ))}
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <input className="sc-input" value={nouveauCritere} onChange={(e) => setNouveauCritere(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") ajouterCritereEvaluation(); }} placeholder="Nouveau critère (ex. Polyvalence)" style={inputStyle("100%")} />
                  <button type="button" className="sc-btn" onClick={ajouterCritereEvaluation} style={primaryBtnStyle}>Ajouter</button>
                </div>
              </>
            ), "Critères notés A / B / C sur chaque évaluation semestrielle. Les évaluations déjà faites gardent les critères (et les intitulés) de leur date ; les lignes libres ajoutées sur une évaluation restent possibles.")}
            {carte("Plan de postes (Comptabilité)", (
              blocPlanPostes()
            ), "Plan unifié des 6 comptes (validé le 30/09). Renommer un sous-poste met à jour les opérations déjà saisies ; un sous-poste utilisé ne peut pas être supprimé. « Encaissements clients » (toujours lié à un dossier) et « À définir » (opérations à classer par le Gérant) sont fixes.")}
            {carte("Comptes de trésorerie (Comptabilité)", (
              <>
                {(comptesTreso || []).map((c) => (
                  <div key={c.id} style={{ padding: "10px 0", borderBottom: `1px solid ${PIERRE}` }}>
                    <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>{c.nom} <span style={{ fontSize: 11, color: TAUPE, fontWeight: 400 }}>— {c.type === "banque" ? "banque" : "caisse"} · solde actuel {formatDH(soldeCompteAu(c.id))}</span></div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center", fontSize: 12 }}>
                      <span>Responsable(s) :</span>
                      {utilisateurs.filter((u) => u.actif).map((u) => (
                        <label key={u.id} style={{ display: "flex", alignItems: "center", gap: 3 }}>
                          <input type="checkbox" checked={(c.responsables || []).includes(u.id)} onChange={(e) => modifierCompteTreso(c.id, { responsables: e.target.checked ? [...(c.responsables || []), u.id] : (c.responsables || []).filter((x) => x !== u.id) })} />{u.nom}
                        </label>
                      ))}
                    </div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center", fontSize: 12, marginTop: 6 }}>
                      <span>Consultation seule :</span>
                      {utilisateurs.filter((u) => u.actif && !u.droits.has("compta.voirToutesCaisses") && !(c.responsables || []).includes(u.id)).map((u) => (
                        <label key={u.id} style={{ display: "flex", alignItems: "center", gap: 3 }}>
                          <input type="checkbox" checked={lecteursCompte(c).includes(u.id)} onChange={(e) => modifierCompteTreso(c.id, { lecteurs: e.target.checked ? [...lecteursCompte(c), u.id] : lecteursCompte(c).filter((x) => x !== u.id) })} />{u.nom}
                        </label>
                      ))}
                    </div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center", fontSize: 12, marginTop: 6 }}>
                      <span>Solde d'ouverture</span>
                      <input key={`so-${c.id}-${c.soldeOuverture}`} type="number" step="0.01" className="sc-input" defaultValue={c.soldeOuverture} onBlur={(e) => { const v = Number(e.target.value); if (isFinite(v) && v !== Number(c.soldeOuverture)) modifierCompteTreso(c.id, { soldeOuverture: v }); }} style={{ ...inputStyle(130), padding: "4px 8px", fontSize: 12 }} />
                      <span>au</span>
                      <input type="date" className="sc-input" value={c.dateOuverture || ""} onChange={(e) => e.target.value && modifierCompteTreso(c.id, { dateOuverture: e.target.value })} style={{ ...inputStyle(150), padding: "4px 8px", fontSize: 12 }} />
                      {/* Step 17 (Nils 15/10) : à partir de cette date, tout se saisit dans l'ERP — l'import de fichiers refuse ces lignes. */}
                      {c.id !== CAISSE_GENERALE_ID && c.id !== PORTEFEUILLE_ID && (
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }} title="Les fichiers Excel importés ne peuvent contenir que des opérations antérieures à cette date.">
                          Saisie dans l'ERP à partir du
                          <input type="date" className="sc-input" value={c.dateDemarrageERP || ""} onChange={(e) => modifierCompteTreso(c.id, { dateDemarrageERP: e.target.value || "" })} style={{ ...inputStyle(150), padding: "4px 8px", fontSize: 12 }} />
                        </span>
                      )}
                      <label style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        <input type="checkbox" checked={!!c.negatifAutorise} onChange={(e) => modifierCompteTreso(c.id, { negatifAutorise: e.target.checked })} />Solde négatif autorisé (sinon alerte)
                      </label>
                      <select className="sc-select" value={c.debitEstEntree ? "entree" : "sortie"} onChange={(e) => modifierCompteTreso(c.id, { debitEstEntree: e.target.value === "entree" })} style={{ ...selectStyle, width: "auto", fontSize: 12 }} title="Sens des colonnes Débit / Crédit dans le fichier importé">
                        <option value="sortie">Import : Débit = sortie</option>
                        <option value="entree">Import : Débit = entrée</option>
                      </select>
                    </div>
                  </div>
                ))}
              </>
            ), "Chaque responsable voit et saisit son compte ; « consultation seule » = voit le compte sans pouvoir saisir (par défaut, l'Administration sur toutes les caisses sauf Caisse Nils) ; le Gérant voit tout. Le solde d'ouverture est celui du jour d'ouverture (1er janvier 2026 par défaut) — l'import d'un fichier peut le reprendre. Le sens Débit / Crédit ne sert qu'à l'import (les fichiers 2026 n'ont pas tous la même convention).")}
            {carte("Tiers : État et associés (Comptabilité)", (
              <>{blocTiersEtatAssocies(["organismesEtat", "associes"])}<div style={{ fontSize: 13, fontWeight: 600, margin: "14px 0 6px" }}>Autres types de tiers</div>{blocTypesTiers()}</>
            ), "Proposés dans « Payé à » d'une sortie. Clients, fournisseurs et employés viennent de leurs onglets (Clients, Fournisseurs, Staff). Un nom utilisé par une opération ne peut pas être retiré.")}
            {carte("SAV", (
              <>
                {ligneReglage("Délai d'intervention avant alerte « SAV en retard »", `${delaiSavJours()} j`, delaiSavSaisi, setDelaiSavSaisi, async () => {
                  const v = Number(delaiSavSaisi);
                  if (!(v >= 0)) return;
                  await persistParametres({ ...(parametres || {}), delaiSAVJours: v });
                  setDelaiSavSaisi("");
                }, { min: 0, step: 1 })}
                <div style={{ fontSize: 13, margin: "10px 0 6px" }}>Motifs de SAV (un seul par ticket) :</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                  {motifsSav().map((m) => (
                    <span key={m} style={{ fontSize: 12, background: PIERRE, borderRadius: 14, padding: "3px 6px 3px 10px", display: "flex", alignItems: "center", gap: 4 }}>
                      {m}
                      <button type="button" className="sc-btn" onClick={async () => {
                        if ((savListe || []).some((t) => t.motif === m && t.statut !== "Clôturé")) { setNotice(`« ${m} » est utilisé par un SAV non clôturé — impossible de le retirer pour l'instant.`); return; }
                        await persistParametres({ ...(parametres || {}), motifsSAV: motifsSav().filter((x) => x !== m) });
                      }} style={{ ...iconBtnStyle, fontSize: 11 }} title="Retirer">✕</button>
                    </span>
                  ))}
                </div>
                <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                  <input className="sc-input" value={nouveauMotifSav} onChange={(e) => setNouveauMotifSav(e.target.value)} placeholder="Nouveau motif" style={{ ...inputStyle(260), padding: "5px 8px", fontSize: 12 }} />
                  <button type="button" className="sc-btn" onClick={async () => {
                    const v = nouveauMotifSav.trim();
                    if (!v || motifsSav().includes(v)) return;
                    await persistParametres({ ...(parametres || {}), motifsSAV: [...motifsSav(), v] });
                    setNouveauMotifSav("");
                  }} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0" }}>+ Ajouter</button>
                </div>
              </>
            ), "Un motif retiré reste affiché sur les SAV clôturés qui l'utilisent (statistiques conservées).")}
            {carte("« En attente de » — options et droits", (
              <>
                {STATUTS_COMMANDE.map((st) => {
                  const options = (enAttenteParStatut || DEFAULT_EN_ATTENTE_PAR_STATUT)[st] || [];
                  return (
                    <div key={st} style={{ marginBottom: 18 }}>
                      <div style={{ display: "inline-block", fontSize: 12, padding: "3px 10px", borderRadius: 20, background: STATUT_COMMANDE_BG[st], color: STATUT_COMMANDE_FG[st], fontWeight: 600, marginBottom: 6 }}>{st}</div>
                      <div style={{ overflowX: "auto" }}>
                        <table style={{ borderCollapse: "collapse", fontSize: 12, width: "100%" }}>
                          <thead>
                            <tr>
                              <th style={{ textAlign: "left", padding: "4px 6px", color: TAUPE, fontWeight: 500, minWidth: 190 }}>Valeur — qui peut la choisir</th>
                              {colonnes.map((c) => (<th key={c.jeton} style={{ padding: "4px 4px", color: TAUPE, fontWeight: 500, fontSize: 11, textAlign: "center" }}>{c.label}</th>))}
                              <th />
                            </tr>
                          </thead>
                          <tbody>
                            {options.map((o) => {
                              const jetons = droitsEnAttentePour(st, o);
                              const tous = jetons.includes("*");
                              return (
                                <tr key={o} style={{ borderTop: `1px solid ${PIERRE}` }}>
                                  <td style={{ padding: "5px 6px" }}>{o}{o === "Autorisation direction" ? <span style={{ color: TAUPE }}> (sortie : Gérant seul)</span> : null}</td>
                                  {colonnes.map((c) => (
                                    <td key={c.jeton} style={{ textAlign: "center" }}>
                                      <input type="checkbox" checked={c.jeton === "*" ? tous : tous || jetons.includes(c.jeton)} disabled={c.jeton !== "*" && tous} onChange={() => basculerDroitEnAttente(st, o, c.jeton)} />
                                    </td>
                                  ))}
                                  <td style={{ textAlign: "right" }}>
                                    <button type="button" className="sc-btn" onClick={() => supprimerOptionEnAttente(st, o)} style={iconBtnStyle} title="Supprimer cette option">✕</button>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
                        <input className="sc-input" value={nouvellesOptionsEA[st] || ""} onChange={(e) => setNouvellesOptionsEA({ ...nouvellesOptionsEA, [st]: e.target.value })} onKeyDown={(e) => { if (e.key === "Enter" && ajouterOptionEnAttente(st, nouvellesOptionsEA[st] || "") !== false) setNouvellesOptionsEA({ ...nouvellesOptionsEA, [st]: "" }); }} placeholder={`Nouvelle option pour ${st}`} style={{ ...inputStyle(260), padding: "5px 8px", fontSize: 12, background: "#fff", border: `1px solid ${TAUPE}` }} />
                        <button type="button" className="sc-btn" onClick={() => { if (ajouterOptionEnAttente(st, nouvellesOptionsEA[st] || "") !== false) setNouvellesOptionsEA({ ...nouvellesOptionsEA, [st]: "" }); }} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 8px" }}>+ Ajouter</button>
                      </div>
                    </div>
                  );
                })}
              </>
            ), "Toi, tu peux toujours tout choisir. Une option nouvellement ajoutée est ouverte à tout le monde tant que tu ne l'as pas réglée. Les passages automatiques (à chaque transformation, après une réservation, après le dépôt du dessin technique) ne sont pas soumis à ces droits. Tout changement est tracé au Journal d'accès.")}
          </div>
        );
      })()}

      {/* ERP step 11 : onglet Alertes & tâches */}
      {activeTab === "communication" && renderCommunication()}
      {activeTab === "alertes" && comALire.length > 0 && (
        <div onClick={() => setActiveTab("communication")} style={{ background: "#F7EEEA", border: `1px solid ${ROUILLE}`, borderRadius: 10, padding: "10px 14px", marginBottom: 14, cursor: "pointer", fontSize: 14 }}>
          <strong style={{ color: ROUILLE }}>⚠ {comALire.length} communication{comALire.length > 1 ? "s" : ""} à lire</strong>
          <span style={{ color: TAUPE }}> — {comALire.slice(0, 3).map((c) => `${c.titre}${c.minutesLecture ? ` (${c.minutesLecture} min)` : ""}`).join(", ")}{comALire.length > 3 ? "…" : ""} ›</span>
        </div>
      )}
      {activeTab === "alertes" && (() => {
        const ligneTache = (x, i) => (
          <div key={i} style={{ background: "#fff", borderRadius: 6, padding: "9px 12px" }}>
            <div onClick={() => ouvrirLienAlerte(x.lien)} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, cursor: x.lien ? "pointer" : "default" }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{x.texte}</div>
                {x.bloque && <div style={{ fontSize: 11, color: /^en attente|^envoyé/.test(x.bloque) ? OCRE : ROUILLE, marginTop: 2 }}>{x.bloque}</div>}
              </div>
              <div style={{ display: "flex", gap: 10, alignItems: "center", flexShrink: 0 }}>
                {x.prospectContacteId && (x.qui.includes(user.id) || estGerant) && (
                  <button type="button" className="sc-btn" onClick={(e) => { e.stopPropagation(); marquerProspectContacte(x.prospectContacteId); }} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 8px" }}>✓ Contacté</button>
                )}
                {x.planNotifId && x.qui.includes(user.id) && (
                  <button type="button" className="sc-btn" onClick={(e) => { e.stopPropagation(); marquerNotifPlanVue(x.planNotifId); }} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 8px" }}>Vu</button>
                )}
                {x.bugVuId && x.qui.includes(user.id) && (
                  <button type="button" className="sc-btn" onClick={(e) => { e.stopPropagation(); majBug(x.bugVuId, { declarantVu: true }); }} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 8px" }}>Vu</button>
                )}
                {x.tacheManuelleId && (x.qui.includes(user.id) || estGerant) && (
                  <button type="button" className="sc-btn" onClick={(e) => { e.stopPropagation(); setTacheFaite({ id: x.tacheManuelleId, commentaire: "" }); }} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 8px" }}>✓ Fait</button>
                )}
                {x.tacheManuelleId && estGerant && (
                  <button type="button" className="sc-btn" onClick={(e) => { e.stopPropagation(); const t = (tachesManuelles || []).find((y) => y.id === x.tacheManuelleId); if (t) setTacheEdit({ ...t }); }} style={{ ...iconBtnStyle }} title="Modifier">✎</button>
                )}
                {x.relanceDevisId && (peut("taches.voirTout") || x.qui.includes(user.id)) && (
                  <button type="button" className="sc-btn" onClick={(e) => { e.stopPropagation(); setReportEdit({ devisId: x.relanceDevisId, jours: "7", note: "" }); }} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 8px" }}>⏰ Reporter…</button>
                )}
                {x.rejetTraiteId && (peut("taches.voirTout") || x.qui.includes(user.id)) && (
                  <button type="button" className="sc-btn" onClick={(e) => { e.stopPropagation(); marquerRejetTraite(x.rejetTraiteId); }} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 8px" }}>✓ Traité</button>
                )}
                {x.chequeConfirmId && x.qui.includes(user.id) && (
                  <button type="button" className="sc-btn" onClick={(e) => { e.stopPropagation(); confirmerReceptionCheque(x.chequeConfirmId); }} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 8px" }}>✓ Reçu</button>
                )}
                {x.chequeOpId && (peut("taches.voirTout") || x.qui.includes(user.id)) && (
                  <button type="button" className="sc-btn" onClick={(e) => { e.stopPropagation(); marquerChequeRemis(x.chequeOpId); }} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 8px" }}>✓ Déposé à la CFG</button>
                )}
                {x.reportReservationId && (peut("taches.voirTout") || x.qui.includes(user.id)) && (
                  <button type="button" className="sc-btn" onClick={(e) => { e.stopPropagation(); setReportReservation({ commandeId: x.reportReservationId, date: "", note: "" }); }} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 8px" }}>⏰ Reporter…</button>
                )}
                {x.lien && <span style={{ color: TAUPE, fontSize: 12 }}>Ouvrir ›</span>}
              </div>
            </div>
            {reportReservation && x.reportReservationId && reportReservation.commandeId === x.reportReservationId && (
              <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginTop: 8 }}>
                <span style={{ fontSize: 12, color: TAUPE }}>Nouvelle date de pose prévue</span>
                <input type="date" className="sc-input" min={todayISO()} value={reportReservation.date} onChange={(e) => setReportReservation({ ...reportReservation, date: e.target.value })} style={{ ...inputStyle(160), padding: "4px 8px" }} />
                <input className="sc-input" value={reportReservation.note} onChange={(e) => setReportReservation({ ...reportReservation, note: e.target.value })} placeholder="Note (ex. chantier pas prêt, client en voyage)" style={{ ...inputStyle(300), padding: "4px 8px", flex: 1 }} />
                <button type="button" className="sc-btn" onClick={reporterReservation} style={{ ...primaryBtnStyle, padding: "6px 12px" }}>Reporter</button>
                <button type="button" className="sc-btn" onClick={() => setReportReservation(null)} style={ghostBtnStyle}>Annuler</button>
              </div>
            )}
            {tacheFaite && x.tacheManuelleId && tacheFaite.id === x.tacheManuelleId && (
              <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginTop: 8 }}>
                <input className="sc-input" autoFocus value={tacheFaite.commentaire} onChange={(e) => setTacheFaite({ ...tacheFaite, commentaire: e.target.value })} placeholder="Commentaire (facultatif)" style={{ ...inputStyle(320), padding: "5px 8px" }} />
                <button type="button" className="sc-btn" onClick={() => marquerTacheManuelleFaite(tacheFaite.id, tacheFaite.commentaire)} style={{ ...primaryBtnStyle, padding: "6px 12px" }}>Confirmer</button>
                <button type="button" className="sc-btn" onClick={() => setTacheFaite(null)} style={ghostBtnStyle}>Annuler</button>
              </div>
            )}
            {reportEdit && reportEdit.devisId === x.relanceDevisId && x.relanceDevisId && (
              <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginTop: 8 }}>
                <span style={{ fontSize: 12, color: TAUPE }}>Relancer dans</span>
                <input type="number" min="1" className="sc-input" value={reportEdit.jours} onChange={(e) => setReportEdit({ ...reportEdit, jours: e.target.value })} style={{ ...inputStyle(70), padding: "4px 8px" }} />
                <span style={{ fontSize: 12, color: TAUPE }}>jours</span>
                <input className="sc-input" value={reportEdit.note} onChange={(e) => setReportEdit({ ...reportEdit, note: e.target.value })} placeholder="Note (ex. décision du client final dans 2 semaines)" style={{ ...inputStyle(300), padding: "4px 8px", flex: 1 }} />
                <button type="button" className="sc-btn" onClick={reporterRelanceDevis} style={{ ...primaryBtnStyle, padding: "6px 12px" }}>Programmer</button>
                <button type="button" className="sc-btn" onClick={() => setReportEdit(null)} style={ghostBtnStyle}>Annuler</button>
              </div>
            )}
          </div>
        );
        const bloc = (titre, contenu, extra) => (
          <div style={{ background: PIERRE, border: `1px solid #E5DFDB`, borderRadius: 10, padding: 14, marginBottom: 18 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, gap: 10, flexWrap: "wrap" }}>
              <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 }}>{titre}</div>
              {extra}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>{contenu}</div>
          </div>
        );
        const vide = (txt) => <div style={{ fontSize: 13, color: TAUPE, padding: "4px 2px" }}>{txt}</div>;
        const aValider = tachesEquipe.filter((x) => x.qui.includes(user.id));
        const listeAlertes = [...(alertes || [])].filter((a) => alertesFiltre === "toutes" || !a.vu).sort((a, b) => (a.le < b.le ? 1 : -1));
        return (
          <div>
            {estGerant && (() => {
              const toutes = [...(tachesManuelles || [])].sort((a, b) => (!!a.faiteLe === !!b.faiteLe ? ((a.echeance || "9") < (b.echeance || "9") ? -1 : 1) : a.faiteLe ? 1 : -1));
              return bloc(
                `Tâches manuelles — ${toutes.filter((t) => !t.faiteLe).length} en cours`,
                toutes.length === 0 ? vide("Aucune tâche créée à la main.") : toutes.slice(0, 40).map((t) => (
                  <div key={t.id} className="sc-row" onClick={() => setTacheEdit({ ...t })} style={{ display: "flex", justifyContent: "space-between", gap: 10, background: "#fff", borderRadius: 6, padding: "8px 12px", cursor: "pointer", opacity: t.faiteLe ? 0.6 : 1 }}>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 600 }}>{t.faiteLe ? "✓ " : ""}{t.titre}</div>
                      <div style={{ fontSize: 11, color: TAUPE }}>{(t.qui || []).map(nomUtilisateur).join(", ")}{t.echeance ? ` · pour le ${formatDate(t.echeance)}` : ""}{t.faiteLe ? ` · faite par ${t.faitePar} le ${formatDate(t.faiteLe.slice(0, 10))}${t.commentaireFait ? ` — ${t.commentaireFait}` : ""}` : t.echeance && t.echeance < todayISO() ? " · en retard" : ""}</div>
                    </div>
                  </div>
                )),
                <button type="button" className="sc-btn" onClick={() => setTacheEdit({ titre: "", detail: "", qui: [], echeance: "", lien: null })} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 12px" }}>+ Tâche</button>
              );
            })()}
            {tacheEdit && (() => {
              const f = tacheEdit;
              const set = (patch) => setTacheEdit({ ...f, ...patch });
              const comptes = utilisateurs.filter((u) => u.actif);
              const liens = [
                ...(devisListe || []).filter((d) => d.numero && !estHorsVueActive(d)).map((d) => ({ v: `devis:${d.id}`, l: `Devis ${d.numero}${d.reference ? ` — ${d.reference}` : ""}`, lien: { kind: "devis", id: d.id } })),
                ...(commandesListe || []).filter((c) => c.statut !== "Facture").map((c) => ({ v: `commande:${c.id}`, l: `Dossier ${c.numero}${c.reference ? ` — ${c.reference}` : ""} (${c.statut})`, lien: { kind: "commande", id: c.id } })),
                ...(clients || []).map((c) => ({ v: `client:${c.id}`, l: `Client ${c.nom}`, lien: { kind: "client", id: c.id } })),
              ];
              const lienVal = f.lien ? `${f.lien.kind}:${f.lien.id}` : "";
              return (
                <Overlay onClose={() => setTacheEdit(null)}>
                  <div style={modalStyle(540)}>
                    <div style={modalTitleStyle}>{f.id ? "Tâche" : "Nouvelle tâche"}</div>
                    <Field label="Titre"><input className="sc-input" value={f.titre} onChange={(e) => set({ titre: e.target.value })} placeholder="ex. Appeler le client Atlas pour la date de pose" style={inputStyle("100%")} /></Field>
                    <Field label="Détail (facultatif)"><textarea className="sc-input" value={f.detail || ""} onChange={(e) => set({ detail: e.target.value })} rows={3} style={{ ...inputStyle("100%"), resize: "vertical" }} /></Field>
                    <Field label="Pour">
                      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", fontSize: 13 }}>
                        {comptes.map((u) => (
                          <label key={u.id} style={{ display: "flex", gap: 4, alignItems: "center", cursor: "pointer" }}>
                            <input type="checkbox" checked={(f.qui || []).includes(u.id)} onChange={(e) => set({ qui: e.target.checked ? [...(f.qui || []), u.id] : (f.qui || []).filter((x) => x !== u.id) })} />
                            {u.nom}
                          </label>
                        ))}
                      </div>
                    </Field>
                    <div style={{ display: "flex", gap: 10 }}>
                      <Field label="Échéance (facultatif)" style={{ flex: 1 }}><input type="date" className="sc-input" value={f.echeance || ""} onChange={(e) => set({ echeance: e.target.value })} style={inputStyle("100%")} /></Field>
                      <Field label="Lié à (facultatif)" style={{ flex: 2 }}>
                        <select className="sc-select" value={lienVal} onChange={(e) => { const l = liens.find((x) => x.v === e.target.value); set({ lien: l ? l.lien : null }); }} style={selectStyle}>
                          <option value="">—</option>
                          {lienVal && !liens.some((x) => x.v === lienVal) && <option value={lienVal}>(lien existant)</option>}
                          {liens.map((x) => (<option key={x.v} value={x.v}>{x.l}</option>))}
                        </select>
                      </Field>
                    </div>
                    {f.faiteLe && <div style={{ fontSize: 12, color: VERT_OK, marginBottom: 10 }}>✓ Faite par {f.faitePar} le {formatDateHeure(f.faiteLe)}{f.commentaireFait ? ` — ${f.commentaireFait}` : ""}</div>}
                    <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                      {f.id && <button type="button" className="sc-btn" onClick={() => supprimerTacheManuelle(f)} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>Supprimer</button>}
                      {f.id && f.faiteLe && <button type="button" className="sc-btn" onClick={async () => { await persistTachesManuelles((tachesManuelles || []).map((x) => (x.id === f.id ? { ...x, faiteLe: "", faitePar: "", commentaireFait: "" } : x))); setTacheEdit(null); }} style={ghostBtnStyle}>↺ Rouvrir</button>}
                      <button type="button" className="sc-btn" onClick={() => setTacheEdit(null)} style={ghostBtnStyle}>Annuler</button>
                      <button type="button" className="sc-btn" onClick={enregistrerTacheManuelle} style={primaryBtnStyle}>Enregistrer</button>
                    </div>
                  </div>
                </Overlay>
              );
            })()}
            {estGerant && (() => {
              const ouverts = (bugs || []).filter((b) => !["corrigé", "rejeté"].includes(b.statut));
              const liste = [...(bugsTous ? bugs || [] : ouverts)].sort((a, b) => (a.le < b.le ? 1 : -1));
              const couleurG = { Bloquant: ROUILLE, "Gênant": OCRE, Suggestion: TAUPE };
              return bloc(
                `Bugs signalés — ${ouverts.length} ouvert(s)`,
                liste.length === 0 ? vide(bugsTous ? "Aucun bug signalé." : "Aucun bug ouvert.") : liste.map((b) => (
                  <div key={b.id} style={{ background: "#fff", borderRadius: 8, padding: "8px 12px", opacity: ["corrigé", "rejeté"].includes(b.statut) ? 0.6 : 1 }}>
                    <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                      <strong style={{ fontSize: 13 }}>{b.numero}</strong>
                      <span style={{ fontSize: 11, fontWeight: 700, color: "#fff", background: couleurG[b.gravite] || TAUPE, borderRadius: 4, padding: "1px 6px" }}>{b.gravite}</span>
                      <span style={{ fontSize: 12, color: TAUPE }}>{b.onglet} · {b.par} · {formatDateHeure(b.le)}</span>
                      <select className="sc-select" value={b.statut} onChange={(e) => majBug(b.id, { statut: e.target.value })} style={{ ...selectStyle, fontSize: 12, padding: "3px 6px", width: "auto", marginLeft: "auto" }}>
                        {STATUTS_BUG.map((x) => (<option key={x} value={x}>{x}</option>))}
                      </select>
                    </div>
                    <div style={{ fontSize: 13, margin: "4px 0", whiteSpace: "pre-wrap" }}>{b.description}</div>
                    <input className="sc-input" defaultValue={b.reponse || ""} key={`${b.id}-${b.majLe || ""}`} placeholder="Réponse / note (envoyée à la personne si corrigé ou rejeté)" onBlur={(e) => { if (e.target.value.trim() !== (b.reponse || "")) majBug(b.id, { reponse: e.target.value.trim() }); }} style={{ ...inputStyle(), width: "100%", boxSizing: "border-box", fontSize: 12, padding: "4px 8px" }} />
                  </div>
                )),
                <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                  <label style={{ fontSize: 12, display: "flex", gap: 4, alignItems: "center" }}><input type="checkbox" checked={bugsTous} onChange={(e) => setBugsTous(e.target.checked)} /> Afficher aussi les corrigés / rejetés</label>
                  <button type="button" className="sc-btn" onClick={copierBugsPourClaude} disabled={!ouverts.length} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0", opacity: ouverts.length ? 1 : 0.5 }}>📋 Copier pour Claude</button>
                </div>
              );
            })()}
            {peut("taches.voirTout") && bloc(
              `Alertes${alertesNonVues.length ? ` — ${alertesNonVues.length} non vue(s)` : ""}`,
              listeAlertes.length === 0 ? vide(alertesFiltre === "toutes" ? "Aucune alerte." : "Aucune alerte non vue.") : listeAlertes.map((a) => (
                <div key={a.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, background: "#fff", borderRadius: 6, padding: "9px 12px", opacity: a.vu ? 0.6 : 1 }}>
                  <div style={{ cursor: a.lien ? "pointer" : "default" }} onClick={() => ouvrirLienAlerte(a.lien)}>
                    <div style={{ fontSize: 11, color: ROUILLE, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.4 }}>{a.type}</div>
                    <div style={{ fontSize: 13 }}>{a.message}</div>
                    <div style={{ fontSize: 11, color: TAUPE }}>{a.par} · {formatDateHeure(a.le)}{a.vu ? " · vu" : ""}</div>
                  </div>
                  {!a.vu && <button type="button" className="sc-btn" onClick={() => marquerAlerteVue(a.id)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "5px 10px", flexShrink: 0 }}>Vu</button>}
                </div>
              )),
              <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                <select className="sc-select" value={alertesFiltre} onChange={(e) => setAlertesFiltre(e.target.value)} style={{ ...selectStyle, fontSize: 12, padding: "4px 8px", width: "auto" }}>
                  <option value="nonvues">Non vues</option>
                  <option value="toutes">Toutes</option>
                </select>
                {alertesNonVues.length > 0 && <button type="button" className="sc-btn" onClick={marquerToutesAlertesVues} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0" }}>Tout marquer comme vu</button>}
              </div>
            )}
            {peut("taches.voirTout") && bloc(`À valider / à traiter par toi — ${aValider.length}`, aValider.length === 0 ? vide("Rien à valider.") : aValider.map(ligneTache))}
            {!peut("taches.voirTout") && bloc(`Mes tâches — ${mesTaches.length}`, mesTaches.length === 0 ? vide("Aucune tâche en attente.") : mesTaches.map(ligneTache))}
            {/* ERP step 12 : signalements — ouverts à tous. */}
            {!peut("taches.voirTout") && (() => {
              const mes = (signalements || []).filter((x) => x.auteurId === user.id).sort((a, b) => (a.le < b.le ? 1 : -1));
              return bloc(
                `Mes signalements — ${mes.length}`,
                mes.length === 0 ? vide("Un problème avec un collègue, une plainte, un incident ? Fais un signalement : il est transmis au Gérant.") : mes.slice(0, 20).map(renderSignalementLigne),
                <button type="button" className="sc-btn" onClick={() => setSignalementEdit({ date: todayISO(), personnes: [], type: "", gravite: "Moyenne", description: "", recherche: "" })} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 12px" }}>📣 Faire un signalement</button>
              );
            })()}
            {peut("taches.voirTout") && utilisateurs.filter((u) => u.id !== user.id && (u.actif || tachesEquipe.some((x) => x.qui.includes(u.id)))).map((u) => {
              const lst = tachesEquipe.filter((x) => x.qui.includes(u.id));
              if (lst.length === 0) return null;
              return <React.Fragment key={u.id}>{bloc(`Tâches de ${u.nom} — ${lst.length}`, lst.map(ligneTache))}</React.Fragment>;
            })}
          </div>
        );
      })()}

      {activeTab === "stock" && user.acces.stock && stockVue === "echantillons" && (() => {
        const q = echRecherche.trim().toLowerCase();
        const gammes = [...new Set((echantillons || []).filter((e) => !estMatEch(e)).map((e) => e.gamme || "Infinity"))].sort();
        const refs = [...(echantillons || [])].filter((e) => !estMatEch(e) && (echVoirHP || !e.horsProduction) && (!echGamme || (e.gamme || "Infinity") === echGamme) && (!q || `${e.couleur} ${e.finition} ${e.code || ""}`.toLowerCase().includes(q)) && (!echAvecTranches || ((tranchesEnStockEch(e) || {}).reel || 0) > 0)).sort((a, b) => (a.gamme || "").localeCompare(b.gamme || "") || (a.ordre || 0) - (b.ordre || 0));
        const gere = estGerant || peut("echantillons.preparer");
        const visibles = (demandesEch || []).filter((d) => gere || d.commercialId === user.id);
        const enCours = visibles.filter(demandeEchOuverte).sort((a, b) => (a.demandeLe < b.demandeLe ? -1 : 1));
        const passees = visibles.filter((d) => d.statut === "remise" || d.statut === "annulée").sort((a, b) => ((a.remiseLe || a.annuleeLe || "") < (b.remiseLe || b.annuleeLe || "") ? 1 : -1)).slice(0, 15);
        const ligneDemande = (d) => (
          <div key={d.id} style={{ background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "8px 12px", marginBottom: 6, opacity: d.statut === "annulée" ? 0.55 : 1 }}>
            <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
              <strong style={{ fontSize: 13 }}>{d.numero}</strong>
              <span style={{ fontSize: 13 }}>{nomUtilisateur(d.commercialId)} pour <strong>{compteDemandeEch(d)}</strong></span>
              <span style={{ fontSize: 12, color: TAUPE }}>demandée le {formatDateHeure(d.demandeLe)}</span>
              <span style={{ fontSize: 12, fontWeight: 600, color: d.statut === "demandée" ? ROUILLE : d.statut === "prête" || d.statut === "partielle" ? OCRE : d.statut === "remise" ? VERT_OK : TAUPE }}>{d.statut === "remise" ? (d.clotureSansReste ? `clôturée sans le reste le ${formatDate((d.clotureLe || "").slice(0, 10))} (${d.cloturePar})` : `remise le ${formatDate((d.remiseLe || "").slice(0, 10))} par ${d.remisePar}${d.partielle ? " (en plusieurs fois)" : ""}`) : d.statut === "partielle" ? "partiellement remise — reste à donner" : d.statut}</span>
              <span style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
                {peut("echantillons.preparer") && d.statut === "demandée" && <button type="button" className="sc-btn" onClick={() => marquerDemandeEchPrete(d)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 8px" }}>Prête</button>}
                {peut("echantillons.preparer") && demandeEchOuverte(d) && <button type="button" className="sc-btn" onClick={() => setRemiseEch({ id: d.id, qtes: {} })} style={{ ...primaryBtnStyle, fontSize: 12, padding: "4px 10px" }}>✓ Donnés au commercial…</button>}
                {(estGerant || d.commercialId === user.id) && d.statut === "partielle" && <button type="button" className="sc-btn" onClick={() => cloturerDemandeEchSansReste(d)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 8px" }}>Clôturer sans le reste</button>}
                {(estGerant || d.commercialId === user.id) && (d.statut === "demandée" || d.statut === "prête") && <button type="button" className="sc-btn" onClick={() => annulerDemandeEch(d)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "3px 8px", color: ROUILLE }}>Annuler</button>}
              </span>
            </div>
            <div style={{ fontSize: 12, color: TAUPE, marginTop: 4 }}>{d.lignes.map((l, i) => { const donne = Number(l.donne ?? l.qteDonnee) || 0; const reste = resteLigneEch(l); const dispo = stockEch(l.refId, l.format); return (<span key={i} style={{ marginRight: 10, color: demandeEchOuverte(d) && reste > 0 ? (dispo > 0 ? ENCRE : ROUILLE) : TAUPE }}>{libRefEch(refEch(l.refId))} {libFormatEch(l.format).toLowerCase()} ×{l.qte}{donne ? ` (donné ${donne}${reste && demandeEchOuverte(d) ? `, reste ${reste}${dispo > 0 ? "" : " — pas en stock"}` : ""})` : demandeEchOuverte(d) && dispo < reste ? ` — ${dispo > 0 ? `${dispo} en stock` : "pas en stock"}` : ""}</span>); })}{d.note ? ` — ${d.note}` : ""}</div>
          </div>
        );
        return (
          <div>
            <div style={{ display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap", marginBottom: 12 }}>
              <FiltreChamp label="Rechercher">
                <input className="sc-input" value={echRecherche} onChange={(e) => setEchRecherche(e.target.value)} placeholder="Couleur, code, finition…" style={inputStyle(230)} />
              </FiltreChamp>
              <FiltreChamp label="Fournisseur / gamme">
                <select className="sc-select" value={echGamme} onChange={(e) => setEchGamme(e.target.value)} style={{ ...selectStyle, width: "auto", minWidth: 120 }}>
                  <option value="">Toutes</option>
                  {gammes.map((g) => (<option key={g} value={g}>{g}</option>))}
                </select>
              </FiltreChamp>
              <label style={{ fontSize: 12, display: "flex", gap: 4, alignItems: "center", paddingBottom: 8 }}><input type="checkbox" checked={echAvecTranches} onChange={(e) => setEchAvecTranches(e.target.checked)} /> Avec tranches en stock</label>
              <FiltreChamp label="Catégorie">
                {selecteurVueStock("__ech")}
              </FiltreChamp>
              <label style={{ fontSize: 12, display: "flex", gap: 4, alignItems: "center", paddingBottom: 8 }}><input type="checkbox" checked={echVoirHP} onChange={(e) => setEchVoirHP(e.target.checked)} /> Hors production</label>
              <span style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
                {peut("echantillons.demander") && <button type="button" className="sc-btn" onClick={() => { setEchTypeModal("ech"); setDemandeEchEdit(nouvelleDemandeEch()); }} style={primaryBtnStyle}>🎁 Demande d'échantillons</button>}
                {peut("echantillons.preparer") && <button type="button" className="sc-btn" onClick={() => ouvrirTypeArrivage("ech")} style={ghostBtnStyle}>📥 Arrivage</button>}
                {peut("echantillons.preparer") && <button type="button" className="sc-btn" onClick={() => { setEchTypeModal("ech"); setEchRechercheModal(""); setEntreeEch({ motif: "Retour", note: "", lignes: {} }); }} style={ghostBtnStyle}>Retour / ajustement</button>}
                {peut("echantillons.preparer") && <button type="button" className="sc-btn" onClick={() => { setEchTypeModal("ech"); setEchRechercheModal(""); setInventaireEch({ note: "", lignes: {} }); }} style={ghostBtnStyle}>Inventaire</button>}
                {peut("echantillons.demander") && <button type="button" className="sc-btn" onClick={() => { setEchTypeModal("ech"); setDemandeEchEdit({ ...nouvelleDemandeEch(), compteType: "libre", boite: true }); }} style={ghostBtnStyle}>📦 Nouvelle boîte revendeur</button>}
                {gere && <button type="button" className="sc-btn" onClick={() => setRefEchEdit({ gamme: echGamme || "Infinity", code: "", couleur: "", finition: "", lancement: "", epaisseurs: "", horsProduction: false })} style={ghostBtnStyle}>+ Couleur</button>}
              </span>
            </div>
            {(enCours.length > 0 || passees.length > 0) && (
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 12, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 6 }}>Demandes en cours — {enCours.length}</div>
                {enCours.length === 0 ? <div style={{ fontSize: 13, color: TAUPE, marginBottom: 6 }}>Aucune demande en cours.</div> : enCours.map(ligneDemande)}
                {passees.length > 0 && (
                  <details style={{ marginTop: 6 }}>
                    <summary style={{ fontSize: 12, color: TAUPE, cursor: "pointer" }}>Dernières demandes traitées ({passees.length})</summary>
                    <div style={{ marginTop: 6 }}>{passees.map(ligneDemande)}</div>
                  </details>
                )}
              </div>
            )}
            {(() => {
              const auj = todayISO();
              const boites = ((echSuivi && echSuivi.boites) || []).filter((b) => gere || b.commercialId === user.id).sort((a, b) => (a.active === false) - (b.active === false) || (prochainControleBoite(a) || "9") .localeCompare(prochainControleBoite(b) || "9"));
              if (!boites.length) return null;
              const actives = boites.filter((b) => b.active !== false);
              return (
                <div style={{ marginBottom: 16 }}>
                  <div style={{ fontSize: 12, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 6 }}>Boîtes revendeurs — {actives.length}{estGerant && <span style={{ textTransform: "none", letterSpacing: 0, fontWeight: 400, marginLeft: 10 }}>contrôle tous les <input type="number" min="1" className="sc-input" value={echSuivi.delaiControleMois ?? 6} onChange={(e) => setEchSuivi({ ...echSuivi, delaiControleMois: e.target.value })} onBlur={(e) => persistEchSuivi({ ...(echSuiviRef.current || echSuivi), delaiControleMois: Math.max(1, Math.round(nombreOuZero(e.target.value))) || 6 })} style={{ ...inputStyle(50), padding: "2px 4px", fontSize: 12 }} /> mois</span>}</div>
                  {boites.map((b) => {
                    const pc = prochainControleBoite(b);
                    const nb = (b.contenu || []).reduce((n, l) => n + l.qte, 0);
                    const remise = dateRemiseBoite(b);
                    return (
                      <div key={b.id} onClick={() => setBoiteVue(b.id)} style={{ background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "8px 12px", marginBottom: 6, cursor: "pointer", display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", opacity: b.active === false ? 0.55 : 1 }}>
                        <strong style={{ fontSize: 13 }}>{b.numero}</strong>
                        <span style={{ fontSize: 13 }}>{compteDemandeEch(b)}</span>
                        <span style={{ fontSize: 12, color: TAUPE }}>{nomUtilisateur(b.commercialId)} · {nb} pièce(s) · {remise ? `remise le ${formatDate(remise)}` : "en préparation"}</span>
                        <span style={{ marginLeft: "auto", fontSize: 12, fontWeight: 600, color: b.active === false ? TAUPE : pc && pc <= auj ? ROUILLE : TAUPE }}>{b.active === false ? `récupérée le ${formatDate(b.retireeLe)}` : pc ? `contrôle ${pc <= auj ? "à faire" : "prévu"} le ${formatDate(pc)}` : ""}</span>
                      </div>
                    );
                  })}
                </div>
              );
            })()}
            <div style={{ background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 10, overflow: "hidden" }}>
              <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 13 }}>
                <thead><tr style={{ color: TAUPE, fontSize: 11, textAlign: "left", background: PIERRE }}><th style={{ padding: 6 }}>Gamme</th><th style={{ padding: 6 }}>Code</th><th style={{ padding: 6 }}>Couleur</th><th style={{ padding: 6 }}>Finition</th><th style={{ padding: 6 }}>Lancement</th><th style={{ padding: 6 }}>Épaisseurs</th>{FORMATS_ECH.map((fm) => (<th key={fm.cle} style={{ padding: 6, textAlign: "center" }}>{fm.lib}s</th>))}<th style={{ padding: 6 }}>Tranches</th><th></th></tr></thead>
                <tbody>
                  {refs.map((e) => (
                    <tr key={e.id} style={{ borderTop: `1px solid ${PIERRE}`, opacity: e.horsProduction ? 0.6 : 1 }}>
                      <td style={{ padding: "4px 6px", color: TAUPE }}>{e.gamme}</td>
                      <td style={{ padding: "4px 6px", fontWeight: 600 }}>{e.code || <span style={{ color: OCRE, fontWeight: 400, fontSize: 11 }}>code manquant</span>}</td>
                      <td style={{ padding: "4px 6px" }}>{e.couleur}{e.horsProduction ? <span style={{ color: ROUILLE, fontSize: 11 }}> · hors production</span> : null}</td>
                      <td style={{ padding: "4px 6px" }}>{e.finition}</td>
                      <td style={{ padding: "4px 6px", color: TAUPE }}>{e.lancement || "nc"}</td>
                      <td style={{ padding: "4px 6px", color: TAUPE }}>{e.epaisseurs}</td>
                      {FORMATS_ECH.map((fm) => { const st = stockEch(e.id, fm.cle); return (<td key={fm.cle} style={{ padding: "4px 6px", textAlign: "center", fontWeight: 600, color: st > 0 ? ENCRE : ROUILLE }}>{st}</td>); })}
                      <td style={{ padding: "4px 6px", whiteSpace: "nowrap" }}>{(() => { const t = tranchesEnStockEch(e); return t && t.reel > 0 ? <span style={{ fontSize: 12, color: VERT_OK, fontWeight: 600 }} title={`${t.libre} libre(s), ${t.reel - t.libre} réservée(s)`}>🟢 {t.reel} en stock</span> : t ? <span style={{ fontSize: 11, color: TAUPE }}>0</span> : <span style={{ fontSize: 11, color: TAUPE }}>—</span>; })()}</td>
                      <td style={{ padding: "4px 6px", textAlign: "right" }}>{gere && <button type="button" className="sc-btn" onClick={() => setRefEchEdit({ ...e })} style={iconBtnStyle} title="Modifier">✎</button>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>{refs.length} référence(s). Le commercial fait la demande, la production prépare ; les échantillons sortent du stock quand la production coche « donnés au commercial ».</div>
          </div>
        );
      })()}
      {activeTab === "stock" && user.acces.stock && stockVue === "materiel" && renderMaterielMkt()}
      {activeTab === "stock" && user.acces.stock && stockVue === "plans" && renderPlansRecuperes()}
      {activeTab === "stock" && user.acces.stock && stockVue === "incidents" && renderIncidents()}
      {activeTab === "stock" && user.acces.stock && !["echantillons", "materiel", "plans", "incidents"].includes(stockVue) && (
        <>
      {/* Filtres */}
      <div style={{ display: "flex", gap: 14, flexWrap: "wrap", alignItems: "flex-end", marginBottom: 12 }}>
        <FiltreChamp label="Rechercher">
          <input
            className="sc-input"
            placeholder="Produit, nom fournisseur…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            style={inputStyle(230)}
          />
        </FiltreChamp>

        <FiltreChamp label="Catégorie">
          <select
            className="sc-select"
            value={filterCat}
            onChange={(e) => { if (e.target.value === "__ech") { setStockVue("echantillons"); return; } if (e.target.value === "__mat") { setStockVue("materiel"); return; } if (e.target.value === "__plans") { setStockVue("plans"); return; } if (e.target.value === "__incidents") { setStockVue("incidents"); return; } setFilterCat(e.target.value); }}
            style={{ ...selectStyle, width: "auto", minWidth: 130 }}
          >
            <option>Toutes</option>
            {categoriesStockDisponibles.map((nom) => (
              <option key={nom}>{nom}</option>
            ))}
            <option value="__plans">Plans récupérés</option>
            <option value="__incidents">Incidents de production</option>
            <option value="__ech">Échantillons</option>
            <option value="__mat">Matériel marketing</option>
          </select>
        </FiltreChamp>

        <FiltreChamp label="Épaisseur">
          <select
            className="sc-select"
            value={filterEpaisseur}
            onChange={(e) => setFilterEpaisseur(e.target.value)}
            style={{ ...selectStyle, width: "auto", minWidth: 100 }}
          >
            <option>Toutes</option>
            {trierAlpha(epaisseursList).map((ep) => (
              <option key={ep}>{ep}</option>
            ))}
          </select>
        </FiltreChamp>

        <FiltreChamp label="Groupe de couleur">
          <select
            className="sc-select"
            value={filterGroupeCouleur}
            onChange={(e) => setFilterGroupeCouleur(e.target.value)}
            style={{ ...selectStyle, width: "auto", minWidth: 140 }}
          >
            <option>Toutes</option>
            {trierAlpha(groupesCouleurArticles || DEFAULT_GROUPES_COULEUR_ARTICLE).map((g) => (
              <option key={g}>{g}</option>
            ))}
          </select>
        </FiltreChamp>

        <FiltreChamp label="Autre">
          <select
            className="sc-select"
            value={filterAutre}
            onChange={(e) => setFilterAutre(e.target.value)}
            style={{ ...selectStyle, width: "auto", minWidth: 150 }}
          >
            <option>Toutes</option>
            <option>Alerte seulement</option>
            <option>2e choix seulement</option>
            <option>Consommable</option>
          </select>
        </FiltreChamp>

        <button
          type="button"
          className="sc-btn"
          onClick={() => setAfficherChutes(!afficherChutes)}
          style={{
            padding: "9px 12px",
            borderRadius: 6,
            fontSize: 12,
            fontWeight: 600,
            background: afficherChutes ? ENCRE : "transparent",
            color: afficherChutes ? PIERRE : TAUPE,
            border: `1px solid ${afficherChutes ? ENCRE : TAUPE}`,
          }}
        >
          {afficherChutes ? "Masquer les chutes" : "Afficher les chutes"}
        </button>
      </div>

      {/* Actions */}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", marginBottom: 18 }}>
        {peutGererConsommablesEtCategories && (
        <button
          type="button"
          className="sc-btn"
          onClick={() => {
            resetCatForm();
            setCatSuccess("");
            setShowCatManager(true);
          }}
          style={linkBtnStyle}
        >
          Gérer les catégories
        </button>
        )}
        {peutGererConsommablesEtCategories && (
          <button type="button" className="sc-btn" onClick={openProduitNew} disabled={!categories || !fournisseurs} style={linkBtnStyle}>
            + Nouvelle sous-catégorie
          </button>
        )}
        {((peutEcrireStock && (produits || []).length > 0) || peutEnregistrerConso) && (
          <button
            type="button"
            className="sc-btn"
            onClick={() => setChoixEnregPL(true)}
            style={{ ...linkBtnStyle, color: ROUILLE, fontWeight: 600 }}
          >
            ▼ Enregistrer une consommation
          </button>
        )}
        {(peutEcrireStock || peut("stock.annulerPL")) && (
          <button
            type="button"
            className="sc-btn"
            onClick={() => { if (!bloqueParInventaire()) setShowAnnulerPL(true); }}
            style={linkBtnStyle}
          >
            ↺ Annuler une consommation
          </button>
        )}
        {peutVoirRegistreCredit && (
          <button
            type="button"
            className="sc-btn"
            onClick={() => setShowRegistreCredit(true)}
            style={linkBtnStyle}
          >
            📗 Registre de crédit{(creditsTranches || []).length > 0 ? ` (${(creditsTranches || []).length})` : ""}
          </button>
        )}


        {peutDemanderSousCat && (
        <button
          type="button"
          className="sc-btn"
          onClick={ouvrirDemandeSousCat}
          style={linkBtnStyle}
        >
          Demander une sous-catégorie
        </button>
        )}
        {(peutCreerLot || typesArrivagePermis().length > 0) && (
        <button
          type="button"
          className="sc-btn"
          onClick={() => setChoixArrivage(true)}
          disabled={!categories || !fournisseurs}
          style={{ marginLeft: "auto", background: ENCRE, color: PIERRE, padding: "10px 18px", borderRadius: 6, fontSize: 13, fontWeight: 600, letterSpacing: 0.3, opacity: categories && fournisseurs ? 1 : 0.5 }}
        >
          📥 Arrivage
        </button>
        )}
      </div>

      {/* ERP step 11 : inventaire */}
      {campagneOuverte && (
        <div style={{ background: "#F5E4DE", color: ROUILLE, borderRadius: 10, padding: "10px 14px", marginBottom: 14, fontSize: 13, fontWeight: 600, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
          <span>🔒 Inventaire en cours depuis le {formatDateHeure(campagneOuverte.ouverteLe)} — tous les mouvements de stock sont bloqués.</span>
          {peut("stock.inventaireVoir") && <button type="button" className="sc-btn" onClick={() => setShowInventaire("campagne")} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 10px", color: ROUILLE }}>Ouvrir l'inventaire</button>}
        </div>
      )}
      {(peutVoirPrixConso || peutSaisirComptage) && (
        <div style={{ display: "flex", gap: 14, marginBottom: 12, marginTop: -6 }}>
          {peutVoirPrixConso && <button type="button" className="sc-btn" onClick={() => setShowInventaire("valorise")} style={linkBtnStyle}>📊 Inventaire valorisé</button>}
          {peut("stock.inventaireVoir") && <button type="button" className="sc-btn" onClick={() => setShowInventaire("campagne")} style={linkBtnStyle}>📋 Campagne d'inventaire</button>}
          {peutVoirPrixConso && <button type="button" className="sc-btn" onClick={() => setShowEnService(true)} style={linkBtnStyle}>🔧 Consommables en service ({(enService || []).filter((e) => e.statut === "en service").length})</button>}
        </div>
      )}

      {/* ERP step 11 : demandes de sous-catégorie en attente (Nils crée / ignore). */}
      {(peutGererConsommablesEtCategories || peutDemanderSousCat) && (demandesSousCat || []).filter((d) => !d.traite).length > 0 && (
        <div style={{ background: "#F5EFE0", border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 14, marginBottom: 16 }}>
          <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Demandes de sous-catégorie en attente</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {(demandesSousCat || []).filter((d) => !d.traite).map((d) => (
              <div key={d.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, background: "#fff", borderRadius: 6, padding: "8px 12px" }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 13 }}>{d.categorie} › {d.nom}{d.nouvelleCategorie ? <span style={{ color: OCRE, fontWeight: 600 }}> (nouvelle catégorie)</span> : null}</div>
                  <div style={{ fontSize: 11, color: TAUPE }}>
                    Demandé par {d.demandePar}{d.fournisseur ? ` — fournisseur : ${d.fournisseur}` : ""}{peutVoirPrixConso && d.targetPrice ? ` — target : ${formatHTTTC(d.targetPrice)}` : ""}{d.vitesse ? ` — ${d.vitesse}` : ""}{d.note ? ` — ${d.note}` : ""}
                  </div>
                </div>
                {peutGererConsommablesEtCategories ? (
                  <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                    <button type="button" className="sc-btn" onClick={() => convertirDemandeSousCat(d)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "5px 10px" }}>Créer cette sous-catégorie</button>
                    <button type="button" className="sc-btn" onClick={() => ignorerDemandeSousCat(d.id)} style={iconBtnStyle} title="Ignorer">✕</button>
                  </div>
                ) : (
                  <div style={{ fontSize: 11, color: TAUPE, fontStyle: "italic", flexShrink: 0 }}>En attente du Gérant</div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Tableau */}
      <div style={{ background: "#fff", borderRadius: 10, overflow: "hidden", boxShadow: "0 1px 3px rgba(40,30,30,0.08)" }}>
        <div style={rowGridStyle(true)}>
          <div />
          <div>Produit / Lot</div>
          <div>Fournisseur</div>
          <div style={{ textAlign: "center" }}>Stock réel</div>
          <div style={{ textAlign: "center" }}>Réservé</div>
          <div style={{ textAlign: "center" }}>Stock théorique</div>
          <div style={{ textAlign: "center" }}>Arrivages</div>
          <div>Seuil</div>
          <div />
        </div>

        {loading && <div style={{ padding: 24, color: TAUPE, fontSize: 14 }}>Chargement du stock…</div>}
        {!loading && groupes.length === 0 && (
          <div style={{ padding: 32, color: TAUPE, fontSize: 14, textAlign: "center" }}>
            Aucun produit ne correspond à ces filtres.
          </div>
        )}

        {!loading &&
          groupes.map((g) => {
            const p = g.produit;
            const isLow = estEnAlerte(g);
            const ouvert = !!ouverts[p.id];
            const multiLots = g.tranches.length > 1;
            const sensible = categorieNuances(p.categorie);
            const unite = g.lots[0]?.unite || categorieUnite(p.categorie) || "";
            return (
              <div key={p.id}>
                {/* Ligne produit */}
                <div
                  className="sc-row"
                  style={{
                    ...rowGridStyle(false),
                    background: multiLots ? "#F5EFE0" : PIERRE + "80",
                    borderLeft: multiLots ? `3px solid ${OCRE}` : "3px solid transparent",
                  }}
                >
                  <div style={{ width: 6, height: 28, borderRadius: 3, background: CAT_TONES[p.categorie] || TAUPE }} />
                  <div>
                    <div
                      style={{ fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}
                      onClick={() => setOuverts({ ...ouverts, [p.id]: !ouvert })}
                    >
                      <span style={{ fontSize: 10, color: TAUPE }}>{ouvert ? "▾" : "▸"}</span>
                      {p.nom}
                      {multiLots && (
                        <span style={{ ...tagStyle, background: OCRE, color: "#fff", fontWeight: 600 }}>
                          {g.tranches.length} lots
                        </span>
                      )}
                      {g.nbChutes > 0 && (
                        <span style={{ ...tagStyle, background: "#F5EFE0", color: OCRE, fontWeight: 600, border: `1px solid ${OCRE}55` }}>
                          {g.nbChutes} chute(s)
                        </span>
                      )}
                    </div>
                    <div style={{ fontSize: 11, color: TAUPE, marginTop: 2 }}>{p.categorie}</div>
                    {produitBookMatch(p.id) && (() => {
                      const pn = pairesParNuance(p.id);
                      if (!pn.length) return null;
                      return <div style={{ fontSize: 11, color: ENCRE, marginTop: 2 }}>Book-match : {pn.map((x) => `${x.nuance ? `n${x.nuance}` : "sans nuance"} A ${x.a} / B ${x.b} (${Math.min(x.a, x.b)} paire${Math.min(x.a, x.b) > 1 ? "s" : ""})`).join(" · ")}</div>;
                    })()}
                    {isLow && (
                      <div style={{ fontSize: 11, color: ROUILLE, marginTop: 2, fontWeight: 600 }}>● Sous le seuil d'alerte</div>
                    )}
                    {multiLots && (
                      <div style={{ fontSize: 11, color: OCRE, marginTop: 3, fontWeight: 600 }}>
                        {sensible ? "▲ Plusieurs nuances" : "▲ Plusieurs lots"}
                      </div>
                    )}
                  </div>
                  <div style={{ color: TAUPE, fontSize: 12 }}>
                    {[...new Set(g.lots.map((l) => l.fournisseur))].join(", ") || "—"}
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontWeight: 600 }}>
                      {g.reel} {unite}
                    </div>
                    {multiLots && (
                      <div style={{ fontSize: 11, color: OCRE, fontWeight: 600, marginTop: 1 }}>
                        {g.tranches.map((l) => l.stockReel).join(" + ")}
                      </div>
                    )}
                  </div>
                  <div style={{ textAlign: "center", color: OCRE, fontWeight: 600 }}>
                    {g.reserve} {unite}
                    {(() => {
                      const nonAffectees = reservationsNonAffectees(p.id);
                      if (nonAffectees.length === 0) return null;
                      const qteNonAffectee = nonAffectees.reduce((s, r) => s + (Number(r.quantite) || 0), 0);
                      return (
                        <div>
                          {peutEcrireStock ? (
                            <button
                              type="button"
                              className="sc-btn"
                              onClick={() => ouvrirAffectationReservations(p)}
                              style={{ fontSize: 10, fontWeight: 600, color: ROUILLE, background: "#F5E4DE", padding: "2px 8px", borderRadius: 10, marginTop: 3 }}
                              title="Affecter cette réservation à un lot précis"
                            >
                              {qteNonAffectee} {unite} à affecter
                            </button>
                          ) : (
                            <div style={{ fontSize: 10, fontWeight: 600, color: ROUILLE, marginTop: 3 }}>{qteNonAffectee} {unite} à affecter</div>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                  <div style={{ textAlign: "center", fontWeight: 700, color: isLow ? ROUILLE : ENCRE }}>
                    {g.theorique} {unite}

                  </div>
                  <div style={{ textAlign: "center", color: g.arrivages > 0 ? ENCRE : TAUPE, fontSize: 13 }}>
                    {g.arrivages > 0 ? `+${g.arrivages}` : "—"}
                  </div>
                  <div style={{ color: TAUPE, fontSize: 13 }}>
                    {p.seuil} {unite}
                  </div>
                  <div style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
                    {peutEcrireStock && (
                      <button className="sc-btn" onClick={() => openProduitEdit(p)} style={iconBtnStyle} title="Fiche produit">
                        ✎
                      </button>
                    )}
                  </div>
                </div>

                {/* Lots du produit */}
                {ouvert &&
                  g.lots.map((it) => {
                    const reserve = reservedFor(it.id);
                    const nbRes = (reservations || []).filter((r) => r.itemId === it.id && r.statut === "active").length;
                    const nbDepassees = reservationsDepassees(it.id);
                    const theo = it.stockReel - reserve;
                    const surReserve = reserve > it.stockReel;
                    const alias = nomChezFournisseur(it.produitId, it.fournisseur);
                    return (
                      <div key={it.id} className="sc-row" style={{ ...rowGridStyle(false), fontSize: 13 }}>
                        <div />
                        <div style={{ paddingLeft: 18 }}>
                          <div style={{ color: TAUPE, fontSize: 12, display: "flex", alignItems: "center", gap: 6 }}>
                            {it.type === TYPE_CHUTE && (
                              <span style={{ ...tagStyle, background: "#F5EFE0", color: OCRE, fontWeight: 600 }}>Chute</span>
                            )}
                            {estCategorieConsommable(produitDe(it.produitId)?.categorie) ? (
                              <span style={{ fontStyle: "italic" }}>Lot{it.blFournisseur ? ` — BL ${it.blFournisseur}` : ""}</span>
                            ) : categorieEstPiece(produitDe(it.produitId)?.categorie) ? (
                              <span style={{ fontStyle: "italic" }}>Article à la pièce</span>
                            ) : (
                              <span>
                                {it.dimensions || "dimension à définir"}
                                {it.epaisseur ? ` — ${it.epaisseur}` : ""}
                              </span>
                            )}
                          </div>
                          {sensible && (it.nuance || it.choix || it.bm) && (
                            <div style={{ fontSize: 11, color: OCRE, marginTop: 2 }}>
                              {[it.nuance ? `Nuance ${it.nuance}` : "", it.bm ? `Book-match ${it.bm}` : "", it.choix].filter(Boolean).join(" · ")}
                            </div>
                          )}
                          {surReserve && (
                            <div style={{ fontSize: 11, color: ROUILLE, marginTop: 2, fontWeight: 600 }}>● Sur-réservé</div>
                          )}
                        </div>
                        <div style={{ color: TAUPE, fontSize: 12 }}>
                          <div>{it.fournisseur || "—"}</div>
                          {alias && alias !== p.nom && <div style={{ fontSize: 11 }}>« {alias} »</div>}
                          {peutVoirPrixCategorie(p.categorie) && it.prixAchatHT !== undefined && it.prixAchatHT !== null && it.prixAchatHT !== "" && (() => {
                            const t = estCategorieConsommable(p.categorie) ? targetPriceDe(p, it.fournisseur) : null;
                            const ec = t !== null ? Number(it.prixAchatHT) - t : null;
                            return (
                              <div style={{ fontSize: 11 }}>
                                {formatHTTTC(it.prixAchatHT)}
                                {ec !== null && ec !== 0 && (
                                  <span style={{ color: ec > 0 ? ROUILLE : VERT_OK, fontWeight: 600 }}> ({ec > 0 ? "+" : ""}{((ec / t) * 100).toFixed(1).replace(".", ",")} %)</span>
                                )}
                              </div>
                            );
                          })()}
                        </div>
                        <div style={{ textAlign: "center" }}>
                          <span style={{ fontWeight: 600 }}>
                            {it.stockReel} {it.unite}
                          </span>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                          <span style={{ color: OCRE, fontWeight: 600 }}>
                            {reserve} {it.unite}
                          </span>
                          {/* ERP step 9 : ce bouton n'ouvre jamais qu'une consultation (les
                              réservations se créent uniquement depuis "Réserver la matière"
                              d'un dossier) — sans réservation active à consulter, il n'a plus
                              lieu d'être affiché. */}
                          {peutEcrireStock && nbRes > 0 && (
                            <button
                              className="sc-btn"
                              onClick={() => openReservation(it)}
                              style={
                                nbDepassees > 0
                                  ? { ...movBtnStyle, background: "#F5E4DE", color: ROUILLE }
                                  : movBtnStyle
                              }
                              title={nbDepassees > 0 ? `${nbDepassees} réservation(s) dont la livraison est dépassée` : "Réservations (BC)"}
                            >
                              {nbRes} BC ▸
                            </button>
                          )}
                          {nbDepassees > 0 && (
                            <div style={{ fontSize: 10, color: ROUILLE, fontWeight: 600 }}>{nbDepassees} à revoir</div>
                          )}
                        </div>
                        <div style={{ textAlign: "center", fontWeight: 600 }}>
                          {theo} {it.unite}
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                          <span style={{ color: it.arrivages > 0 ? ENCRE : TAUPE }}>
                            {it.arrivages > 0 ? `+${it.arrivages}` : "—"}
                          </span>
                          {peutEcrireStock && it.arrivages > 0 && (
                            <button className="sc-btn" onClick={() => openReception(it)} style={movBtnStyle} title="Réceptionner tout ou partie de cet arrivage">
                              Réceptionner
                            </button>
                          )}
                        </div>
                        <div />
                        <div style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
                          <button className="sc-btn" onClick={() => openHistory(it)} style={iconBtnStyle} title="Historique">
                            🕘
                          </button>
                          {!peutEcrireStock && peut("stock.annulerPL") && (
                            <button className="sc-btn" onClick={() => openAjustement(it)} style={iconBtnStyle} title="Ajustement d'inventaire lié à un PL">
                              ⚖
                            </button>
                          )}
                          {!peutEcrireStock && peut("stock.modifierLotConso") && estCategorieConsommable(p.categorie) && (
                            <button className="sc-btn" onClick={() => openEdit(it)} style={iconBtnStyle} title="Modifier le lot">
                              ✎
                            </button>
                          )}
                          {peutEcrireStock && it.type !== TYPE_CHUTE && produitBookMatch(it.produitId) && (Number(it.stockReel) || 0) > 0 && (
                            <button className="sc-btn" onClick={() => setRepartitionBM({ lot: it, a: "", b: "", s: "", err: "" })} style={{ ...iconBtnStyle, width: "auto", padding: "0 6px", fontSize: 11, fontWeight: 700 }} title={it.bm ? "Corriger le marquage book-match" : "Répartir en A / B"}>
                              A/B
                            </button>
                          )}
                          {peutEcrireStock && (
                            <>
                              <button className="sc-btn" onClick={() => openAjustement(it)} style={iconBtnStyle} title="Ajustement d'inventaire">
                                ⚖
                              </button>
                              <button className="sc-btn" onClick={() => openEdit(it)} style={iconBtnStyle} title="Modifier le lot">
                                ✎
                              </button>
                              <button className="sc-btn" onClick={() => removeItem(it.id)} style={iconBtnStyle} title="Supprimer le lot">
                                ✕
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })}
              </div>
            );
          })}
      </div>
        </>
      )}

      {activeTab === "fournisseurs" && user.acces.fournisseurs && (
        <>
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap", alignItems: "flex-end", marginBottom: 18 }}>
            <FiltreChamp label="Rechercher">
              <input
                className="sc-input"
                placeholder="Nom du fournisseur…"
                value={fourQuery}
                onChange={(e) => setFourQuery(e.target.value)}
                style={inputStyle(240)}
              />
            </FiltreChamp>
            {peutEcrireFour && (
            <button
              className="sc-btn"
              onClick={openFourNew}
              style={{
                marginLeft: "auto",
                background: ENCRE,
                color: PIERRE,
                padding: "10px 18px",
                borderRadius: 6,
                fontSize: 13,
                fontWeight: 600,
                letterSpacing: 0.3,
              }}
            >
              + Nouveau fournisseur
            </button>
            )}
            {!peutEcrireFour && user.demandeCreationFournisseur && (
            <button
              className="sc-btn"
              onClick={ouvrirDemandeFour}
              style={{
                marginLeft: "auto",
                background: ENCRE,
                color: PIERRE,
                padding: "10px 18px",
                borderRadius: 6,
                fontSize: 13,
                fontWeight: 600,
                letterSpacing: 0.3,
              }}
            >
              + Demande de création fournisseur
            </button>
            )}
          </div>

          {/* ERP step 10 (accord Nils du 24/09) : les demandes en attente sont visibles par
              tous ceux qui ont accès aux Fournisseurs ; seuls le Gérant et l'Administration (écriture)
              peuvent créer le fournisseur ou ignorer la demande. */}
          {(demandesFournisseurs || []).filter((d) => !d.traite).length > 0 && (
            <div style={{ background: "#F5EFE0", border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 14, marginBottom: 16 }}>
              <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>
                Demandes de création fournisseur en attente
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {(demandesFournisseurs || []).filter((d) => !d.traite).map((d) => (
                  <div key={d.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, background: "#fff", borderRadius: 6, padding: "8px 12px" }}>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 13 }}>{d.nom}</div>
                      <div style={{ fontSize: 11, color: TAUPE }}>
                        Demandé par {d.demandePar}{d.paiement ? ` — paiement : ${d.paiement}` : ""}{d.notes ? ` — ${d.notes}` : (d.note ? ` — ${d.note}` : "")}
                      </div>
                    </div>
                    {peutEcrireFour ? (
                      <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                        <button type="button" className="sc-btn" onClick={() => convertirDemandeFour(d)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "5px 10px" }}>Créer ce fournisseur</button>
                        <button type="button" className="sc-btn" onClick={() => ignorerDemandeFour(d.id)} style={iconBtnStyle} title="Ignorer">✕</button>
                      </div>
                    ) : (
                      <div style={{ fontSize: 11, color: TAUPE, fontStyle: "italic", flexShrink: 0 }}>En attente de validation (le Gérant ou l'Administration)</div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {loading && <div style={{ padding: 24, color: TAUPE, fontSize: 14 }}>Chargement de l'annuaire…</div>}
            {!loading && fournisseursFiltres.length === 0 && (
              <div style={{ padding: 32, color: TAUPE, fontSize: 14, textAlign: "center", background: "#fff", borderRadius: 10 }}>
                Aucun fournisseur ne correspond.
              </div>
            )}
            {!loading &&
              fournisseursFiltres.map((f) => {
                const alertes = fournisseurAlertes(f);
                const matieres = matieresFournies(f.nom);
                const alerte = alertes.length > 0;
                return (
                  <div
                    key={f.id}
                    style={{
                      background: "#fff",
                      borderRadius: 10,
                      padding: "14px 16px",
                      boxShadow: "0 1px 3px rgba(40,30,30,0.08)",
                      borderLeft: alerte ? `3px solid ${ROUILLE}` : `3px solid transparent`,
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                          <span
                            style={{ fontWeight: 600, fontSize: 15, cursor: peutEcrireFour ? "pointer" : "default" }}
                            onClick={() => peutEcrireFour && openFourEdit(f)}
                          >
                            {f.nom}
                          </span>
                          <span style={{ ...tagStyle, background: PIERRE, color: TAUPE }}>{f.origine}</span>
                          <span style={{ ...tagStyle, background: fiabiliteBg(f.fiabilite), color: fiabiliteFg(f.fiabilite) }}>
                            Fiabilité {f.fiabilite}
                          </span>
                          {f.blacklist && <span style={{ ...tagStyle, background: ROUILLE, color: "#fff", fontWeight: 700 }} title={`par ${f.blacklist.par} le ${formatDate(String(f.blacklist.le).slice(0, 10))}`}>⛔ Blacklisté{f.blacklist.motif ? ` — ${f.blacklist.motif}` : ""}</span>}
                          {alertes.map((a) => (
                            <span key={a} style={{ ...tagStyle, background: "#F5E4DE", color: ROUILLE, fontWeight: 600 }}>
                              {a}
                            </span>
                          ))}
                        </div>

                        <div style={{ fontSize: 12, color: TAUPE, marginTop: 6 }}>
                          {matieres.length > 0 ? `Fournit : ${matieres.join(", ")}` : "Aucune matière rattachée"}
                          {f.paiement ? ` · ${f.paiement}` : ""}
                          {f.origine === "Maroc" && f.ice ? ` · ICE ${f.ice}` : ""}
                        </div>

                        {(f.contacts || []).length > 0 && (
                          <div style={{ fontSize: 12, color: TAUPE, marginTop: 4 }}>
                            {f.contacts.map((c) => `${c.nom}${c.fonction ? ` (${c.fonction})` : ""}${c.tel ? ` — ${c.tel}` : ""}`).join(" · ")}
                          </div>
                        )}
                      </div>

                      {(peutEcrireFour || estGerant) && (
                        <div style={{ display: "flex", gap: 6 }}>
                          {estGerant && <button className="sc-btn" onClick={() => basculerBlacklist(f)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 8px", color: f.blacklist ? TAUPE : ROUILLE }} title={f.blacklist ? "Retirer de la blacklist" : "Blacklister ce fournisseur"}>{f.blacklist ? "Retirer de la blacklist" : "⛔ Blacklister"}</button>}
                          {peutEcrireFour && <>
                          <button className="sc-btn" onClick={() => openFourEdit(f)} style={iconBtnStyle} title="Modifier la fiche">
                            ✎
                          </button>
                          <button className="sc-btn" onClick={() => removeFournisseur(f)} style={iconBtnStyle} title="Supprimer">
                            ✕
                          </button>
                          </>}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        </>
      )}

      {activeTab === "clients" && user.acces.clients && (
        <>
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap", alignItems: "flex-end", marginBottom: 18 }}>
            <FiltreChamp label="Rechercher">
              <input
                className="sc-input"
                placeholder="Nom du client…"
                value={clientQuery}
                onChange={(e) => setClientQuery(e.target.value)}
                style={inputStyle(240)}
              />
            </FiltreChamp>
            {peutGererFacturesAnt && <button type="button" className="sc-btn" onClick={() => setAntOuvert(true)} style={{ ...ghostBtnStyle, marginLeft: "auto", fontSize: 12 }} title="Factures émises avant l'ERP, pour l'état client">📂 Factures antérieures à l'ERP ({(facturesAnt || []).length})</button>}
            <button type="button" className="sc-btn" onClick={() => imprimerFicheOuvertureCompte(null)} style={{ ...ghostBtnStyle, marginLeft: peutGererFacturesAnt ? 0 : "auto", fontSize: 12 }} title="Fiche vierge à remettre à un nouveau client">
              🖨 Fiche d'ouverture de compte (vierge)
            </button>
            {peutCreerClient && (
              <button
                className="sc-btn"
                onClick={openClientNew}
                style={{
                  background: ENCRE,
                  color: PIERRE,
                  padding: "10px 18px",
                  borderRadius: 6,
                  fontSize: 13,
                  fontWeight: 600,
                  letterSpacing: 0.3,
                }}
              >
                + Nouveau client
              </button>
            )}
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {loading && <div style={{ padding: 24, color: TAUPE, fontSize: 14 }}>Chargement des clients…</div>}
            {!loading && clientsFiltres.length === 0 && (
              <div style={{ padding: 32, color: TAUPE, fontSize: 14, textAlign: "center", background: "#fff", borderRadius: 10 }}>
                {(clients || []).length === 0 ? "Aucun client enregistré pour l'instant." : "Aucun client ne correspond."}
              </div>
            )}
            {!loading &&
              clientsFiltres.map((c) => {
                const alertes = clientAlertes(c);
                const contacts = c.contacts || [];
                return (
                  <div
                    key={c.id}
                    style={{
                      background: "#fff",
                      borderRadius: 10,
                      padding: "14px 16px",
                      boxShadow: "0 1px 3px rgba(40,30,30,0.08)",
                      borderLeft: alertes.length > 0 ? `3px solid ${ROUILLE}` : "3px solid transparent",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                          <span
                            style={{ fontWeight: 600, fontSize: 15, cursor: peutEcrireClient ? "pointer" : "default" }}
                            onClick={() => peutEcrireClient && openClientEdit(c)}
                          >
                            {c.nom}
                          </span>
                          <span style={{ ...tagStyle, background: PIERRE, color: TAUPE }}>{c.type}</span>
                          {c.aValider && (
                            <span style={{ ...tagStyle, background: "#F5EFE0", color: OCRE, fontWeight: 700 }} title={`${c.creePar ? `Créé par ${c.creePar}` : ""}${c.validePar ? ` · validé par ${c.validePar}` : ""}`}>
                              {etapeValidationClient(c) === "etape2" ? "Validé par l'Administration — à valider par le Gérant — bloque le BDC" : "À valider par l'Administration (puis le Gérant) — bloque le BDC"}
                            </span>
                          )}
                          <span style={{ display: "inline-flex", gap: 4, alignItems: "center" }}>
                            {AXES_CLIENT.map((axe) => {
                              const l = c[`notes_${axe.cle}`] || "–";
                              return (
                                <span
                                  key={axe.cle}
                                  title={`${axe.label} : ${l}`}
                                  style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: 1 }}
                                >
                                  <span style={{ fontSize: 8, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.3 }}>{axe.label}</span>
                                  <span
                                    style={{
                                      ...tagStyle,
                                      padding: "1px 8px",
                                      background: noteLettreBg(l),
                                      color: noteLettreFg(l),
                                      fontWeight: 700,
                                      fontFamily: "monospace",
                                    }}
                                  >
                                    {l}
                                  </span>
                                </span>
                              );
                            })}
                          </span>
                          <span
                            title={`Paiement : ${paiementLabel(c.paiement_niveau)}`}
                            style={{ ...tagStyle, background: paiementBg(c.paiement_niveau), color: paiementFg(c.paiement_niveau), fontWeight: 600 }}
                          >
                            {paiementLabel(c.paiement_niveau)}
                          </span>
                          {alertes.map((a) => (
                            <span key={a} style={{ ...tagStyle, background: "#F5E4DE", color: ROUILLE, fontWeight: 600 }}>
                              {a}
                            </span>
                          ))}
                        </div>
                        {c.raisonSociale && c.raisonSociale !== c.nom && (
                          <div style={{ fontSize: 12, color: TAUPE, marginTop: 3 }}>
                            Facturé sous <strong style={{ color: ENCRE }}>{c.raisonSociale}</strong>
                          </div>
                        )}
                        <div style={{ fontSize: 12, color: TAUPE, marginTop: 4 }}>
                          {c.type === TYPE_SANS_ICE ? "Particulier — sans ICE" : c.ice ? `ICE ${c.ice}` : "ICE manquant"}
                          {c.paiement ? ` · ${c.paiement}` : ""}
                          {c.remise && Number(c.remise) > 0 ? ` · remise ${c.remise}%` : ""}
                          {c.commercialSC ? ` · suivi par ${c.commercialSC}` : ""}
                        </div>
                        {contacts.length > 0 && (
                          <div style={{ fontSize: 12, color: TAUPE, marginTop: 4 }}>
                            {contacts
                              .map((x) => `${x.nom}${x.fonction ? ` (${x.fonction})` : ""}${x.tel ? ` — ${x.tel}` : ""}`)
                              .join(" · ")}
                          </div>
                        )}
                      </div>
                      {c.aValider && peutValiderClient(c) && (
                        <button className="sc-btn" onClick={() => validerClient(c)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "5px 10px", flexShrink: 0 }}>
                          {peut("clients.validerEtape2") ? (etapeValidationClient(c) === "etape2" ? "✓ Valider (Gérant)" : "✓ Valider (Gérant, à la place de l'Administration)") : "✓ Valider (Administration)"}
                        </button>
                      )}
                      {peutVoirEtatClient(c) && (
                        <button type="button" className="sc-btn" onClick={() => setEtatClientModal({ clientId: c.id, exo: false, au: todayISO(), avecSoldes: false })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "5px 10px", flexShrink: 0 }} title="État de compte (non exo / exo)">📄 État de compte</button>
                      )}
                      {peutEcrireClient && (
                        <div style={{ display: "flex", gap: 6 }}>
                          <button className="sc-btn" onClick={() => openClientEdit(c)} style={iconBtnStyle} title="Modifier la fiche">
                            ✎
                          </button>
                          <button className="sc-btn" onClick={() => removeClient(c)} style={iconBtnStyle} title="Supprimer">
                            ✕
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        </>
      )}

      {/* Formulaire lot */}
      {activeTab === "devis" && user.acces.devis && devisListe === null && (
        <div style={{ padding: 24, color: TAUPE, fontSize: 14 }}>Chargement des devis…</div>
      )}

      {activeTab === "devis" && user.acces.devis && devisListe !== null && openId === null && (
        <>
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap", alignItems: "flex-end", marginBottom: 16, justifyContent: "space-between" }}>
            <div style={{ display: "flex", gap: 14, flexWrap: "wrap", alignItems: "flex-end" }}>
              <FiltreChamp label="Rechercher">
                <input className="sc-input" placeholder="N°, référence, client…" value={devisQuery} onChange={(e) => setDevisQuery(e.target.value)} style={inputStyle(230)} />
              </FiltreChamp>
              <FiltreChamp label="Statut">
                <select className="sc-select" value={filterStatut} onChange={(e) => setFilterStatut(e.target.value)} style={{ ...selectStyle, width: 160 }}>
                  <option value="Tous">Tous (actifs)</option>
                  {STATUTS_DEVIS.filter((s) => s !== "Archivé").map((s) => (<option key={s} value={s}>{s}</option>))}
                  <option value="Archivés">Archivé</option>
                </select>
              </FiltreChamp>
            </div>
            <button type="button" className="sc-btn" onClick={nouveauDevis} style={primaryBtnStyle}>+ Nouveau devis</button>
          </div>

          {devisFiltres.length === 0 ? (
            <div style={{ background: "#fff", borderRadius: 10, padding: 32, textAlign: "center", color: TAUPE, fontSize: 14 }}>Aucun devis ne correspond.</div>
          ) : (
            <div style={{ background: "#fff", borderRadius: 10, overflow: "hidden", border: `1px solid ${PIERRE}` }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1.4fr 1.4fr 1fr 1.1fr 1.1fr 40px", padding: "12px 16px", borderBottom: `1px solid ${PIERRE}` }}>
                <Th>N°</Th><Th>Référence</Th><Th>Client</Th><Th>Date</Th><Th>Statut</Th><Th>Total TTC</Th><Th></Th>
              </div>
              {devisFiltres.map((d) => {
                const client = clientsActifs.find((c) => c.id === d.clientId);
                const t = calcTotaux(d);
                return (
                  <div key={d.id} className="sc-row" style={{ display: "grid", gridTemplateColumns: "1fr 1.4fr 1.4fr 1fr 1.1fr 1.1fr 70px", padding: "13px 16px", alignItems: "center", borderBottom: `1px solid ${PIERRE}`, fontSize: 14, cursor: "pointer" }} onClick={() => ouvrirDevis(d.id)}>
                    <div style={{ fontWeight: 600, display: "flex", alignItems: "center", gap: 6 }}>
                      {d.numero}
                      <BadgeExo exonere={d.exonereTVA} />
                      {d.savId && <BadgeSav />}
                    </div>
                    <div>{d.reference || "—"}</div>
                    <div>{client ? client.nom : "—"}</div>
                    <div>{formatDate(d.date)}</div>
                    <div onClick={(e) => e.stopPropagation()} style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <select value={d.statut} onChange={(e) => changerStatutRapide(d.id, e.target.value)} className="sc-select"
                        style={{ fontSize: 11, borderRadius: 20, padding: "4px 10px", border: "none", background: STATUT_BG[d.statut], color: STATUT_FG[d.statut], fontWeight: 600, width: "auto" }}>
                        {STATUTS_DEVIS.filter((s) => s !== "Transformé en BDC" || d.statut === "Transformé en BDC").map((s) => (<option key={s} value={s}>{s}</option>))}
                      </select>
                      {estConfirmeSansBDC(d) && (
                        <span title="Confirmé mais aucun BDC généré" style={{ fontSize: 14, color: ROUILLE }}>⚠</span>
                      )}
                    </div>
                    <div style={{ fontWeight: 600 }}>{fmtMAD(t.totalTTC)}</div>
                    <div onClick={(e) => e.stopPropagation()} style={{ display: "flex", gap: 2 }}>
                      <button type="button" className="sc-btn" onClick={() => dupliquerDevis(d.id)} style={iconBtnStyle} title="Dupliquer">⧉</button>
                      <button type="button" className="sc-btn" onClick={() => supprimerDevis(d.id)} style={iconBtnStyle} title="Supprimer">✕</button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
      {activeTab === "devis" && user.acces.devis && devisListe !== null && openId !== null && draft && (
        <div style={{ background: "#fff", borderRadius: 10, border: `1px solid ${PIERRE}`, padding: 24 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20, flexWrap: "wrap", gap: 12 }}>
            <div>
              <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, fontSize: 26 }}>{draft.numero || "Nouveau devis (numéro à l'enregistrement)"}</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: 4 }}>
                Créé par {draft.creePar} le {formatDate(draft.creeLe.slice(0, 10))} · modifié par {draft.modifiePar} le {formatDate(draft.modifieLe.slice(0, 10))}
              </div>
              {commandeLieeAuDevis && (
                <div style={{ fontSize: 12, color: TAUPE, marginTop: 4 }}>
                  BC généré :{" "}
                  <button type="button" className="sc-btn" onClick={() => { fermerFiche(); setActiveTab("commandes"); ouvrirCommande(commandeLieeAuDevis.id); }} style={{ ...linkBtnStyle, fontSize: 12, padding: 0 }}>
                    {commandeLieeAuDevis.numero}
                  </button>
                  {" "}— {commandeLieeAuDevis.statut}
                </div>
              )}
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button type="button" className="sc-btn" onClick={fermerFiche} style={ghostBtnStyle}>← Retour à la liste</button>
            </div>
          </div>

          {estConfirmeSansBDC(draft) && (
            <div style={{ background: "#F5E4DE", color: ROUILLE, fontSize: 13, fontWeight: 600, padding: "10px 14px", borderRadius: 6, marginBottom: 16 }}>
              ⚠ Ce devis est confirmé mais aucun BDC n'a encore été généré — pense à cliquer sur « Transformer en BDC ».
            </div>
          )}

          {commandeLieeAuDevis && (
            <div style={{ background: "#EFEAE3", color: ENCRE, fontSize: 13, fontWeight: 600, padding: "10px 14px", borderRadius: 6, marginBottom: 16 }}>
              🔒 Devis figé — transformé en {commandeLieeAuDevis.numero} ({commandeLieeAuDevis.statut}). Les lignes, quantités et le contenu se modifient désormais depuis le dossier, indépendamment de ce devis d'origine.
              {peut("devis.modifierEnteteFige") && enteteNilsDevisId !== draft.id && (
                <div style={{ marginTop: 8 }}>
                  <button type="button" className="sc-btn" onClick={ouvrirEnteteNilsDevis} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 13 }}>✎ Modifier l'en-tête (Gérant)</button>
                </div>
              )}
              {peut("devis.modifierEnteteFige") && enteteNilsDevisId === draft.id && (
                <div style={{ marginTop: 8, fontWeight: 400, fontSize: 12 }}>
                  En-tête déverrouillé : les changements seront repris sur tous les documents du dossier et tracés au Journal d'accès. Statut et exonération de TVA restent figés{commandeLieeAuDevis.statut === "Facture" ? " ; client et remise aussi (dossier facturé)" : ""}.
                </div>
              )}
            </div>
          )}

          {draftError && <div style={errorTextStyle}>{draftError}</div>}

          <fieldset disabled={!!commandeLieeAuDevis && enteteNilsDevisId !== draft.id} style={{ border: "none", padding: 0, margin: 0 }}>
          {/* En-tête du devis */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16 }}>
            <Field label="Réf. contremarque (obligatoire)">
              <input className="sc-input" value={draft.reference || ""} onChange={(e) => setDraft({ ...draft, reference: e.target.value })} style={inputStyle("100%")} placeholder="ex. Villa Dassouli" />
            </Field>
            {draft.clientId && (() => {
              // Nils 04/10 (j1) : rattacher un devis refait à la main à son devis d'origine (une seule famille pour le taux de transformation).
              const autres = (devisListe || []).filter((d) => d.id !== draft.id && d.numero && d.clientId === draft.clientId && (!d.versionDe || d.versionDe !== draft.id)).sort((a, b) => String(b.numero).localeCompare(String(a.numero)));
              if (!autres.length && !draft.dupliqueDe) return null;
              return (
                <Field label="Nouvelle version de… (facultatif)">
                  {draft.dupliqueDe && draft.dupliqueDeClient === draft.clientId && !draft.versionDe ? <div style={{ fontSize: 12, color: TAUPE, padding: "8px 0" }}>Copie de {draft.dupliqueDe} — déjà rattachée</div> : (
                    <select className="sc-select" value={draft.versionDe || ""} onChange={(e) => setDraft({ ...draft, versionDe: e.target.value })} style={selectStyle}>
                      <option value="">— Nouveau devis —</option>
                      {autres.map((d) => (<option key={d.id} value={d.id}>{d.numero}{d.reference ? ` — ${d.reference}` : ""}</option>))}
                    </select>
                  )}
                </Field>
              );
            })()}
            <Field label={lignesContiennentPose(draft.lignes, articles) ? "Étage (obligatoire pour le BDC — devis avec pose)" : "Étage (facultatif sans pose)"}>
              <input className="sc-input" value={draft.etage || ""} onChange={(e) => setDraft({ ...draft, etage: e.target.value })} style={inputStyle("100%")} placeholder="ex. RDC, 1er, 3e…" />
            </Field>
            <Field label="Date">
              <input type="date" className="sc-input" value={draft.date} onChange={(e) => setDraft({ ...draft, date: e.target.value })} style={inputStyle("100%")} />
            </Field>
            <Field label="Statut">
              <select className="sc-select" value={draft.statut} onChange={(e) => setDraft({ ...draft, statut: e.target.value })} style={selectStyle} disabled={!!commandeLieeAuDevis}>
                {STATUTS_DEVIS.filter((s) => s !== "Transformé en BDC" || draft.statut === "Transformé en BDC").map((s) => (<option key={s} value={s}>{s}</option>))}
              </select>
            </Field>

            <Field label="Client">
              <select className="sc-select" value={draft.clientId} disabled={!!commandeLieeAuDevis && commandeLieeAuDevis.statut === "Facture"} onChange={(e) => {
                const c = clientsActifs.find((x) => x.id === e.target.value);
                setDraft({
                  ...draft,
                  clientId: e.target.value,
                  chantierId: "",
                  remiseGlobale: c && c.remise !== "" && c.remise != null ? c.remise : draft.remiseGlobale,
                  conditionsPaiement: c && c.paiement ? c.paiement : draft.conditionsPaiement,
                  commercialSC: c && c.commercialSC ? c.commercialSC : draft.commercialSC,
                  apporteurAffaire: c && c.apporteurAffaire ? c.apporteurAffaire : draft.apporteurAffaire,
                  // Nils 08/10 : un seul contact commercial sur la fiche client → repris d'office.
                  commercialClient: contactsVendeurs(c).length === 1 ? contactsVendeurs(c)[0].nom : "",
                });
              }} style={selectStyle}>
                <option value="">— Sélectionner —</option>
                {clientsActifs.filter((c) => clientVisiblePourUser(c) || c.id === draft.clientId).map((c) => (<option key={c.id} value={c.id}>{c.nom}{c.aValider ? " (à valider)" : ""}</option>))}
              </select>
              <button type="button" className="sc-btn" onClick={() => setActiveTab("clients")} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>Client absent de la liste ? Ouvrir l'onglet Clients</button>
            </Field>

            {/* ERP step 16 (Nils 12/10, lot 2) : projets immobiliers créés par Nils seul (onglet Projets immo). */}
            <Field label="Projet immobilier (vide = commande particulier)">
              <select className="sc-select" value={draft.chantierId} onChange={(e) => setDraft({ ...draft, chantierId: e.target.value })} style={selectStyle} disabled={!draft.clientId}>
                <option value="">— Commande particulier —</option>
                {chantiersDuClient.filter((c) => c.statut !== "terminé" || c.id === draft.chantierId).map((c) => (<option key={c.id} value={c.id}>{c.nom}{c.statut === "terminé" ? " (terminé)" : ""}</option>))}
              </select>
              {draft.clientId && !chantiersDuClient.length && (
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Aucun projet immobilier pour ce client. Les projets sont créés par le Gérant dans l'onglet « Projets immo ».</div>
              )}
              {draft.logementId && (() => {
                const ch = (chantiers || []).find((x) => x.id === draft.chantierId);
                const l = ch && (ch.logements || []).find((x) => x.id === draft.logementId);
                const v = ch && derniereVersionDP(ch);
                const t = v && (v.typologies || []).find((x) => x.id === draft.projetTypologieId);
                return (
                  <div style={{ fontSize: 11, marginTop: 4, color: TAUPE }}>
                    Cuisine du projet : {l ? libLogement(l) : "logement supprimé"}{t ? ` — typologie ${t.nom}` : ""}{draft.devisProjetVersion ? ` (devis projet V${draft.devisProjetVersion})` : ""}
                    {devisModifieTypologie(draft) && <span style={{ color: OCRE, fontWeight: 600 }}> — modifié par rapport à la typologie</span>}
                  </div>
                );
              })()}
            </Field>

            <Field label="Commercial Stone Concept">
              <select className="sc-select" value={draft.commercialSC || ""} onChange={(e) => setDraft({ ...draft, commercialSC: e.target.value })} style={selectStyle}>
                <option value="">— Non attribué —</option>
                {trierAlpha(utilisateurs.filter((u) => u.commercial && u.actif), "nom").map((u) => (
                  <option key={u.id} value={u.nom}>{u.nom} — {u.role}</option>
                ))}
              </select>
              <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                Pré-rempli depuis la fiche client, modifiable ici — utile quand un client a plusieurs commerciaux Stone Concept.
              </div>
            </Field>

            <Field label="Apporteur d'affaire (facultatif)">
              <select className="sc-select" value={draft.apporteurAffaire || ""} onChange={(e) => setDraft({ ...draft, apporteurAffaire: e.target.value })} style={selectStyle}>
                <option value="">— Aucun (commercial Stone Concept par défaut) —</option>
                {trierAlpha(apporteursAffaire).map((ap) => (<option key={ap} value={ap}>{ap}</option>))}
              </select>
              <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                Pré-rempli depuis la fiche client, modifiable ici. Si vide, le commercial Stone Concept ci-dessus fait office d'apporteur.
              </div>
              {draft.apporteurAffaire && (
                <div style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, marginTop: 6 }}>
                  Commission de l'apporteur :
                  {estGerant ? (<><input type="number" min="0" max="100" step="0.1" className="sc-input" value={draft.tauxApporteur ?? ""} onChange={(e) => setDraft({ ...draft, tauxApporteur: e.target.value })} style={{ ...inputStyle(80), padding: "4px 6px" }} /> %</>)
                    : <span style={{ color: TAUPE }}>{!voitTauxApporteur || String(draft.tauxApporteur ?? "").trim() === "" ? "taux fixé par la direction" : `${draft.tauxApporteur} %`}</span>}
                </div>
              )}
              <button type="button" className="sc-btn" onClick={() => setShowApporteurManager(true)} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>Gérer les apporteurs d'affaire</button>
            </Field>

            <Field label="Commercial du client">
              <select className="sc-select" value={draft.commercialClient || ""} onChange={(e) => setDraft({ ...draft, commercialClient: e.target.value })} style={selectStyle} disabled={!draft.clientId}>
                <option value="">— Non renseigné —</option>
                {trierAlpha(contactsVendeurs(draftClient), "nom").map((c) => (
                  <option key={c.id || c.nom} value={c.nom}>{c.nom}{c.fonction === "Direction" ? " (Direction)" : ""}</option>
                ))}
              </select>
              <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                Tiré des contacts marqués « Commercial » ou « Direction » sur la fiche client. Si absent de la liste, ajoute-le d'abord dans la fiche client.
              </div>
            </Field>

            <Field label="Conditions de paiement">
              <select className="sc-select" value={draft.conditionsPaiement} onChange={(e) => setDraft({ ...draft, conditionsPaiement: e.target.value })} style={selectStyle}>
                <option value="">— Sélectionner —</option>
                {trierAlpha(paiements, "label").map((p) => (<option key={p.label} value={p.label}>{p.label}</option>))}
              </select>
              <button type="button" className="sc-btn" onClick={() => setShowPaiementManager(true)} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>Gérer la liste</button>
            </Field>

            <Field label="Adresse de livraison">
              <input className="sc-input" value={draft.adresseLivraison} onChange={(e) => setDraft({ ...draft, adresseLivraison: e.target.value })} style={inputStyle("100%")} />
            </Field>

            <Field label={dossierAvecLogistique(draft) ? "Contact sur place — nom et fonction (obligatoire pour le BPRDM)" : "Contact sur place — nom et fonction (facultatif sans livraison)"}>
              <input className="sc-input" placeholder="Nom et fonction — ex. M. Alaoui, architecte" value={draft.contactSurPlace || ""} onChange={(e) => setDraft({ ...draft, contactSurPlace: e.target.value })} style={inputStyle("100%")} />
              {choixContactProjet(draft.chantierId, (c) => setDraft({ ...draft, contactSurPlace: c.nom, telephoneSurPlace: c.tel }))}
            </Field>

            <Field label={dossierAvecLogistique(draft) ? "Téléphone sur place (obligatoire pour le BPRDM)" : "Téléphone sur place (facultatif sans livraison)"}>
              <input className="sc-input" value={draft.telephoneSurPlace || ""} onChange={(e) => setDraft({ ...draft, telephoneSurPlace: e.target.value })} style={inputStyle("100%")} placeholder="ex. 06 12 34 56 78" />
            </Field>

            <Field label="Remise (%) — pré-remplie depuis la fiche client, modifiable">
              <input type="number" className="sc-input" value={draft.remiseGlobale} disabled={!!commandeLieeAuDevis && commandeLieeAuDevis.statut === "Facture"} onChange={(e) => setDraft({ ...draft, remiseGlobale: e.target.value })} style={inputStyle(120)} />
            </Field>

            <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, cursor: "pointer", marginBottom: 8 }}>
              <input
                type="checkbox"
                checked={!!draft.exonereTVA}
                disabled={!!commandeLieeAuDevis}
                onChange={(e) => {
                  const coche = e.target.checked;
                  if (coche) {
                    const verif = verifierExonerationLignes(draft.lignes);
                    if (!verif.ok) {
                      setNotice(messageRefusExoneration(verif));
                      return;
                    }
                  }
                  setDraft({ ...draft, exonereTVA: coche });
                }}
              />
              Commande exonérée de TVA
              <span style={{ fontSize: 11, color: TAUPE }}>(TVA à 0% sur tous les documents, mention légale affichée à la place)</span>
            </label>
            {draft.exonereTVA && (
              <Field label="Mention légale à afficher (à toi de la formuler selon ta situation — je ne suis pas expert-comptable)">
                <input
                  className="sc-input"
                  value={draft.mentionExonerationTVA || ""}
                  disabled={!!commandeLieeAuDevis}
                  onChange={(e) => setDraft({ ...draft, mentionExonerationTVA: e.target.value })}
                  placeholder="ex. Exonération de la TVA en vertu de l'article ... du CGI"
                  style={inputStyle("100%")}
                />
              </Field>
            )}
          </div>

          {/* ERP step 11 : lignes, éléments techniques et pièces jointes restent
              figés sur un devis transformé, même quand le Gérant déverrouille l'en-tête. */}
          <fieldset disabled={!!commandeLieeAuDevis} style={{ border: "none", padding: 0, margin: 0 }}>
          {renderContenuLignesDevis()}

          {renderElementsTechniques(draft, setDraft, "Repris automatiquement sur le dossier lors de la transformation en BDC — modifiable ensuite indépendamment.", true)}

          {/* ERP step 11 (Nils 29/09) : bloc « Pièces jointes » retiré — remplacé par les documents libres (liens) sous « Documents importants ». */}
          </fieldset>

          {/* Notes de page */}
          <div style={{ marginTop: 10, marginBottom: 10, fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, fontSize: 18 }}>Notes de page</div>
          {(draft.notes || []).map((n, i) => (
            <div key={i} style={{ display: "flex", gap: 8, marginBottom: 8 }}>
              <input className="sc-input" value={n} onChange={(e) => updateNote(i, e.target.value)} style={inputStyle("100%")} placeholder="Mention à afficher en bas du devis" />
              <button type="button" className="sc-btn" onClick={() => supprimerNote(i)} style={iconBtnStyle}>✕</button>
            </div>
          ))}
          <button type="button" className="sc-btn" onClick={ajouterNote} style={{ ...ghostBtnStyle, marginBottom: 20 }}>+ Ajouter une note</button>

          <fieldset disabled={!!commandeLieeAuDevis} style={{ border: "none", padding: 0, margin: 0 }}>
          {renderTotauxDevis()}
          </fieldset>
          </fieldset>

          {/* ERP step 11 : documents importants déclarables dès le devis */}
          <div style={{ marginTop: 16 }}>{renderDocumentsImportants(draft, commandeLieeAuDevis)}</div>

          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 20, paddingTop: 20, borderTop: `1px solid ${PIERRE}` }}>
            <button type="button" className="sc-btn" onClick={fermerFiche} style={ghostBtnStyle}>Annuler</button>
            <button type="button" className="sc-btn" onClick={imprimerDevis} style={ghostBtnStyle}>⬇ Télécharger le devis (PDF)</button>
            {!commandeLieeAuDevis && !user.devisSansTransformerBDC && (
              <button type="button" className="sc-btn" onClick={() => demanderConfirmationTransformation("BDC", transformerEnBDC)} style={primaryBtnStyle}>→ Transformer en BDC</button>
            )}
            {!commandeLieeAuDevis && (
              <button type="button" className="sc-btn" onClick={enregistrerDevis} style={primaryBtnStyle}>Enregistrer le devis</button>
            )}
            {commandeLieeAuDevis && peut("devis.modifierEnteteFige") && enteteNilsDevisId === draft.id && (
              <>
                <button type="button" className="sc-btn" onClick={annulerEnteteNils} style={ghostBtnStyle}>Annuler les changements d'en-tête</button>
                <button type="button" className="sc-btn" onClick={enregistrerEnteteNils} style={primaryBtnStyle}>Enregistrer l'en-tête</button>
              </>
            )}
          </div>

        </div>
      )}

      {activeTab === "commandes" && user.acces.commandes && commandesListe === null && (
        <div style={{ padding: 24, color: TAUPE, fontSize: 14 }}>Chargement des commandes…</div>
      )}
      {activeTab === "commandes" && user.acces.commandes && commandesListe !== null && (
        <>
          {(peut("deplacements.saisir") || peut("expo.gerer")) && (
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 16, marginBottom: 8 }}>
              {peut("expo.gerer") && <button type="button" className="sc-btn" onClick={() => setShowExpo(true)} style={linkBtnStyle}>🖼 Tranches en exposition</button>}
              {peut("deplacements.saisir") && <button type="button" className="sc-btn" onClick={() => setShowDeplacements(true)} style={linkBtnStyle}>🚚 Déplacements (livraison, RDM, pose, SAV)</button>}
            </div>
          )}
          <div style={{ display: "flex", gap: 4, marginBottom: 16, flexWrap: "wrap", alignItems: "center" }}>
            <input className="sc-input" value={commandeRecherche} onChange={(e) => setCommandeRecherche(e.target.value)} placeholder="Rechercher : n°, client, projet, référence, couleur…" style={{ ...inputStyle(300), padding: "6px 10px", fontSize: 12, marginRight: 8 }} />
            {["Toutes", ...STATUTS_COMMANDE, EA_ARCHIVE]
              .filter((s) => !(user.commandesSansBDCFacture && (s === "BDC" || s === "Facture")))
              .filter((s) => s !== EA_ARCHIVE || (commandesListe || []).some(dossierArchive))
              .map((s) => (
              <button key={s} type="button" className="sc-btn" onClick={() => setCommandeFiltreStatut(s)}
                style={{ padding: "7px 14px", borderRadius: 20, fontSize: 12, fontWeight: 600, background: commandeFiltreStatut === s ? ENCRE : PIERRE, color: commandeFiltreStatut === s ? PIERRE : TAUPE }}>
                {s}
              </button>
            ))}
          </div>

          {commandesFiltrees.length === 0 && remplacementsFiltres.length === 0 ? (
            <div style={{ background: "#fff", borderRadius: 10, padding: 32, textAlign: "center", color: TAUPE, fontSize: 14 }}>
              {commandeRecherche.trim() ? `Aucun dossier ne correspond à « ${commandeRecherche.trim()} »${commandeFiltreStatut !== "Toutes" ? ` au statut « ${commandeFiltreStatut} »` : ""}.` : <>Aucun dossier {commandeFiltreStatut !== "Toutes" ? `au statut « ${commandeFiltreStatut} »` : ""}. Un dossier se crée automatiquement dès qu'un devis passe au statut Confirmé.</>}
            </div>
          ) : (
            <div style={{ background: "#fff", borderRadius: 10, overflow: "hidden", border: `1px solid ${PIERRE}` }}>
              <div style={{ display: "grid", gridTemplateColumns: "0.9fr 1.3fr 1.1fr 1.3fr 1.5fr 1.5fr 70px", padding: "12px 16px", borderBottom: `1px solid ${PIERRE}` }}>
                <Th>N°</Th><Th>Référence</Th><Th>Devis</Th><Th>Client</Th><Th>Statut</Th><Th>En attente de</Th><Th></Th>
              </div>
              {[...commandesFiltrees.map((c) => ({ c, t: c.creeLe || "" })), ...remplacementsFiltres.map((r) => ({ r, t: r.le || r.date || "" }))].sort((x, y) => (x.t < y.t ? 1 : -1)).map(({ c, r }) => {
                if (r) return (
                  <div key={`rep-${r.id}`} className="sc-row" onClick={() => setRempFiche(r.id)} style={{ display: "grid", gridTemplateColumns: "0.9fr 1.3fr 1.1fr 1.3fr 1.5fr 1.5fr 70px", padding: "13px 16px", alignItems: "center", borderBottom: `1px solid ${PIERRE}`, fontSize: 14, cursor: "pointer" }}>
                    <div style={{ fontWeight: 600 }}>{r.numero}</div>
                    <div style={{ fontWeight: 600 }}>{r.designation || "—"}</div>
                    <div>—</div>
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      {(clientDe(r.clientId) || {}).nom || NOM_CLIENT_COMPTOIR}
                      <PastilleRemplacement />
                    </div>
                    <div>
                      <span style={{ fontSize: 11, padding: "4px 10px", borderRadius: 20, background: STATUT_COMMANDE_BG[r.type === "Facture" ? "Facture" : "BL"], color: STATUT_COMMANDE_FG[r.type === "Facture" ? "Facture" : "BL"], fontWeight: 600 }}>
                        {r.type === "Facture" ? "Facture" : "BL"}
                      </span>
                    </div>
                    <div style={{ fontSize: 13, color: TAUPE }}>{r.type === "Facture" ? (r.remiseClientLe ? "Circuit fermé" : r.envoyeeClientLe ? "Remise original" : "Envoi client par mail") : r.blSigne ? "—" : "Signature du BL"}</div>
                    <div onClick={(e) => e.stopPropagation()} style={{ display: "flex", gap: 2 }}>
                      <button type="button" className="sc-btn" onClick={() => setRempFiche(r.id)} style={iconBtnStyle} title="Ouvrir">✎</button>
                    </div>
                  </div>
                );
                const devis = (devisListe || []).find((d) => d.id === c.devisId);
                const client = clientsActifs.find((x) => x.id === c.clientId);
                const etapeActuelle = ETAPES_COMMANDE.find((e) => e.statut === c.statut);
                const numeroAffiche = (etapeActuelle && c[etapeActuelle.champ]) || c.numero;
                return (
                  <div key={c.id} className="sc-row" style={{ display: "grid", gridTemplateColumns: "0.9fr 1.3fr 1.1fr 1.3fr 1.5fr 1.5fr 70px", padding: "13px 16px", alignItems: "center", borderBottom: `1px solid ${PIERRE}`, fontSize: 14, cursor: "pointer" }} onClick={() => ouvrirCommande(c.id)}>
                    <div style={{ fontWeight: 600, display: "flex", alignItems: "center", gap: 6 }}>
                      {numeroAffiche}
                      <BadgeExo exonere={devis && devis.exonereTVA} />
                      {devis && devis.savId && <BadgeSav />}
                    </div>
                    <div style={{ fontWeight: 600 }}>{c.reference || "—"}</div>
                    <div>{devis ? devis.numero : "—"}</div>
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      {client ? client.nom : "—"}
                      {client && <PastillePaiement niveau={client.paiement_niveau} toujoursAfficher />}
                    </div>
                    <div>
                      <span style={{ fontSize: 11, padding: "4px 10px", borderRadius: 20, background: STATUT_COMMANDE_BG[c.statut], color: STATUT_COMMANDE_FG[c.statut], fontWeight: 600 }}>
                        {c.statut}
                      </span>
                    </div>
                    <div style={{ fontSize: 13, color: TAUPE }}>{c.enAttenteDe || "—"}</div>
                    {/* Step 11 (accord Nils du 21/09) : le bouton de
                        suppression directe est retiré — il appelait
                        supprimerCommande() sans jamais restituer le crédit
                        d'exonération ni lever les réservations actives,
                        contrairement à "← Revenir à l'étape précédente" sur
                        la fiche dossier (demanderAnnulerBDC), seul chemin
                        sûr désormais pour annuler un BDC. */}
                    <div onClick={(e) => e.stopPropagation()} style={{ display: "flex", gap: 2 }}>
                      <button type="button" className="sc-btn" onClick={() => ouvrirCommande(c.id)} style={iconBtnStyle} title="Ouvrir">✎</button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

        </>
      )}

      {activeTab === "catalogue" && user.acces.catalogue && articles === null && (
        <div style={{ padding: 24, color: TAUPE, fontSize: 14 }}>Chargement du catalogue…</div>
      )}

      {activeTab === "catalogue" && user.acces.catalogue && articles !== null && (() => {
        // Descriptifs juste après "Toutes", Logistique tout à la fin — le
        // reste garde l'ordre où l'utilisateur l'a rangé (catégories
        // personnalisées comprises).
        const baseCategories = categoriesArticles || DEFAULT_CATEGORIES_ARTICLES;
        const categoriesOrdonnees = [
          ...(baseCategories.includes("Descriptifs") ? ["Descriptifs"] : []),
          ...baseCategories.filter((c) => c !== "Descriptifs" && c !== "Logistique"),
          ...(baseCategories.includes("Logistique") ? ["Logistique"] : []),
        ];
        return (
        <>
          <div style={{ display: "flex", gap: 4, marginBottom: 16, flexWrap: "wrap" }}>
            {["Toutes", ...categoriesOrdonnees].map((cat) => (
              <button key={cat} type="button" className="sc-btn" onClick={() => setCatalogueFiltreCat(cat)}
                style={{ padding: "7px 14px", borderRadius: 20, fontSize: 12, fontWeight: 600, background: catalogueFiltreCat === cat ? ENCRE : PIERRE, color: catalogueFiltreCat === cat ? PIERRE : TAUPE }}>
                {cat}
              </button>
            ))}
          </div>

          <div style={{ display: "flex", gap: 14, alignItems: "flex-end", marginBottom: 16, justifyContent: "space-between" }}>
            <div style={{ display: "flex", gap: 14, alignItems: "flex-end" }}>
              <FiltreChamp label="Rechercher">
                <input className="sc-input" placeholder="Code, désignation…" value={catQuery} onChange={(e) => setCatQuery(e.target.value)} style={inputStyle(260)} />
              </FiltreChamp>
              <FiltreChamp label="TVA exonérable">
                <select className="sc-select" value={catalogueFiltreExo} onChange={(e) => setCatalogueFiltreExo(e.target.value)} style={selectStyle}>
                  <option value="Tous">Tous</option>
                  <option value="Exo">Exo</option>
                  <option value="Non exo">Non exo</option>
                </select>
              </FiltreChamp>
              <FiltreChamp label="Nature">
                <select className="sc-select" value={catalogueFiltreNature} onChange={(e) => setCatalogueFiltreNature(e.target.value)} style={selectStyle}>
                  <option value="Toutes">Toutes</option>
                  {NATURES_ARTICLE.map((n) => (<option key={n.cle} value={n.cle}>{n.court}</option>))}
                  <option value="aucune">Aucune nature</option>
                  <option value="averifier">Pré-cochées à vérifier ({(articles || []).filter((a) => a.naturesAVerifier).length})</option>
                </select>
              </FiltreChamp>
              {peut("catalogue.reglagesArticle") && (articles || []).some((a) => a.naturesAVerifier) && (
                <button type="button" className="sc-btn" onClick={marquerNaturesVerifiees} style={{ ...ghostBtnStyle, fontSize: 12 }} title="Les articles listés ont été vérifiés">✓ Natures vérifiées ({(articles || []).filter((a) => a.naturesAVerifier).length})</button>
              )}
            </div>
            {peutEcrireCatalogue && (
            <button type="button" className="sc-btn" onClick={ouvrirNouvelArticle} style={primaryBtnStyle}>+ Nouvel article</button>
            )}
          </div>

          {catalogueFiltreCat === "Tranche" && (() => {
            const tr = (articles || []).filter((a) => a.categorie === "Tranche");
            const actifs = FILTRES_TRANCHE_CATALOGUE.filter(([k]) => catFiltresTranche[k]).length;
            return (
              <div style={{ display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap", marginTop: -6, marginBottom: 16 }}>
                {FILTRES_TRANCHE_CATALOGUE.map(([k, lib]) => {
                  // Options compatibles avec les autres filtres déjà choisis.
                  const base = tr.filter((a) => FILTRES_TRANCHE_CATALOGUE.every(([k2]) => k2 === k || !catFiltresTranche[k2] || String(a[k2] || "") === catFiltresTranche[k2]));
                  const opts = [...new Set(base.map((a) => String(a[k] || "")).filter(Boolean))].sort((x, y) => x.localeCompare(y, "fr", { numeric: true }));
                  return (
                    <FiltreChamp key={k} label={lib}>
                      <select className="sc-select" value={catFiltresTranche[k] || ""} onChange={(e) => setCatFiltresTranche({ ...catFiltresTranche, [k]: e.target.value })} style={{ ...selectStyle, minWidth: 110 }}>
                        <option value="">{lib === "Matière" || lib === "Finition" || lib === "Épaisseur" || lib === "Dimension" ? "Toutes" : "Tous"}</option>
                        {opts.map((o) => (<option key={o} value={o}>{o}</option>))}
                      </select>
                    </FiltreChamp>
                  );
                })}
                {actifs > 0 && <button type="button" className="sc-btn" onClick={() => setCatFiltresTranche({})} style={{ ...ghostBtnStyle, fontSize: 12 }}>Réinitialiser ({catalogueFiltre.length} article{catalogueFiltre.length > 1 ? "s" : ""})</button>}
              </div>
            );
          })()}
          <div style={{ background: "#fff", borderRadius: 10, overflow: "hidden", border: `1px solid ${PIERRE}` }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr 1fr 0.8fr 1fr 0.7fr 70px", padding: "12px 16px", borderBottom: `1px solid ${PIERRE}` }}>
              <Th>Code</Th><Th>Désignation</Th><Th>Catégorie</Th><Th>Unité</Th><Th>Prix public</Th><Th>Actif</Th><Th></Th>
            </div>
            {catalogueFiltre.map((a) => (
              <div key={a.id} className="sc-row" style={{ display: "grid", gridTemplateColumns: "1fr 2fr 1fr 0.8fr 1fr 0.7fr 70px", padding: "12px 16px", alignItems: "center", borderBottom: `1px solid ${PIERRE}`, fontSize: 13, opacity: a.actif ? 1 : 0.5 }}>
                <div>{a.categorie === "Descriptifs" ? "—" : a.code}</div>
                <div>
                  {a.designation}
                  {NATURES_ARTICLE.filter((n) => natureArticle(a, n.cle)).map((n) => (
                    <span key={n.cle} style={{ marginLeft: 6, fontSize: 10, padding: "1px 7px", borderRadius: 10, background: PIERRE, color: ENCRE, fontWeight: 600 }}>{n.court}</span>
                  ))}
                  {a.naturesAVerifier && <span title="Nature pré-cochée automatiquement — à vérifier par le Gérant" style={{ marginLeft: 6, fontSize: 10, color: OCRE, fontWeight: 600 }}>à vérifier</span>}
                  {articleAValider(a) && (
                    peut("catalogue.validerArticles") ? (
                      <button
                        type="button"
                        className="sc-btn"
                        onClick={() => validerArticleParNils(a.id)}
                        title={`Créé par ${nomUtilisateur(a.creePar) || "?"} — cliquer pour valider`}
                        style={{ marginLeft: 8, fontSize: 10, padding: "2px 8px", borderRadius: 10, background: "#F5EFE0", color: "#8C6D1F", fontWeight: 600 }}
                      >
                        À valider ({nomUtilisateur(a.creePar) || "?"})
                      </button>
                    ) : (
                      <span
                        title={`Créé par ${nomUtilisateur(a.creePar) || "?"}, en attente de validation par le Gérant`}
                        style={{ marginLeft: 8, fontSize: 10, padding: "2px 8px", borderRadius: 10, background: "#F5EFE0", color: "#8C6D1F", fontWeight: 600 }}
                      >
                        À valider ({nomUtilisateur(a.creePar) || "?"})
                      </span>
                    )
                  )}
                </div>
                <div>{a.categorie}</div>
                <div>{a.categorie === "Descriptifs" ? "—" : a.unite}</div>
                <div style={{ fontWeight: 600, fontSize: a.structurel ? 12 : 13 }}>
                  {a.categorie === "Descriptifs"
                    ? "—"
                    : a.categorie === "Tranche"
                    ? (a.groupe && prixGroupeArticle(a, a.groupe) != null ? `Groupe ${a.groupe} — ${fmtMAD(prixGroupeArticle(a, a.groupe))} / tranche` : "—")
                    : a.structurel
                    ? (() => {
                        const vals = GROUPES.map((g) => a.prixParGroupe[g]).filter((v) => v != null);
                        return vals.length ? `${fmtMAD(Math.min(...vals))} – ${fmtMAD(Math.max(...vals))} (selon groupe)` : "—";
                      })()
                    : fmtMAD(a.prixPublic)}
                </div>
                <div>
                  {peutEcrireCatalogue ? (
                    <button type="button" className="sc-btn" onClick={() => toggleArticleActif(a.id)} style={{ fontSize: 11, padding: "3px 8px", borderRadius: 12, background: a.actif ? "#E4EBE4" : PIERRE, color: a.actif ? VERT_OK : TAUPE, fontWeight: 600 }}>
                      {a.actif ? "Actif" : "Inactif"}
                    </button>
                  ) : (
                    <span style={{ fontSize: 11, padding: "3px 8px", borderRadius: 12, background: a.actif ? "#E4EBE4" : PIERRE, color: a.actif ? VERT_OK : TAUPE, fontWeight: 600 }}>
                      {a.actif ? "Actif" : "Inactif"}
                    </span>
                  )}
                </div>
                <div style={{ display: "flex", gap: 4 }}>
                  {peutEcrireCatalogue && (
                    <>
                      <button type="button" className="sc-btn" onClick={() => ouvrirArticle(a)} style={iconBtnStyle} title="Modifier">✎</button>
                      <button type="button" className="sc-btn" onClick={() => copierArticle(a)} style={iconBtnStyle} title="Copier : nouvel article prérempli avec celui-ci">⧉</button>
                      <button type="button" className="sc-btn" onClick={() => supprimerArticle(a.id)} style={iconBtnStyle} title="Supprimer">✕</button>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </>
        );
      })()}

      {activeTab === "grilleTarifaire" && estGerant && (prixGroupesTranche === null || prixGroupesTranche2eChoix === null) && (
        <div style={{ color: TAUPE, fontSize: 14 }}>Chargement…</div>
      )}

      {activeTab === "grilleTarifaire" && estGerant && prixGroupesTranche !== null && prixGroupesTranche2eChoix !== null && (
        <>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 14 }}>
            <button type="button" className="sc-btn" onClick={ouvrirExportGrille} style={primaryBtnStyle}>⬇ Exporter la grille tarifaire (PDF)…</button>
            <button type="button" className="sc-btn" onClick={chargerGrilleOfficielle2026} style={ghostBtnStyle}>
              Charger la grille tarifaire officielle 2026 (Grès Cérame 6mm/12mm)
            </button>
          </div>

          <div style={{ background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 16, marginBottom: 20 }}>
            <div style={{ marginBottom: pcOuverts.g1 ? 10 : 0 }}>{titrePC("g1", "Grille de vente — 1er choix", "prix publics HT au m² par groupe tarifaire")}</div>
            {pcOuverts.g1 && (<>
            <div style={{ display: "grid", gridTemplateColumns: "160px repeat(5, 1fr)", gap: 10, alignItems: "center" }}>
              <div />
              {GROUPES.map((g) => (
                <div key={g} style={{ fontSize: 10, color: TAUPE, textAlign: "center" }}>Groupe {g}</div>
              ))}
              {COMBINAISONS_PRIX_TRANCHE.map(({ matiere, epaisseur, cle }) => (
                <React.Fragment key={cle}>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>{matiere} {epaisseur}</div>
                  {GROUPES.map((g) => (
                    <input
                      key={g}
                      type="number"
                      className="sc-input"
                      value={prixGroupesTranche[cle] && prixGroupesTranche[cle][g] != null ? prixGroupesTranche[cle][g] : ""}
                      onChange={(e) => {
                        const v = e.target.value;
                        const ligne = prixGroupesTranche[cle] || { 1: null, 2: null, 3: null, 4: null, 5: null };
                        persistPrixGroupesTranche({ ...prixGroupesTranche, [cle]: { ...ligne, [g]: v === "" ? null : v } });
                      }}
                      style={{ ...inputStyle("100%"), padding: "6px 6px", textAlign: "center" }}
                    />
                  ))}
                </React.Fragment>
              ))}
            </div>
            <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>
              Prix HT au m², par groupe et par combinaison Matière + Épaisseur. Une ligne laissée vide n'a pas de prix disponible dans ce groupe.
            </div>
            </>)}
          </div>

          <div style={{ background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 16, marginBottom: 20 }}>
            <div style={{ marginBottom: pcOuverts.g2 ? 10 : 0 }}>{titrePC("g2", "Grille de vente — 2e choix", "prix publics HT au m² par groupe tarifaire")}</div>
            {pcOuverts.g2 && (<>
            <div style={{ display: "grid", gridTemplateColumns: "160px repeat(5, 1fr)", gap: 10, alignItems: "center" }}>
              <div />
              {GROUPES.map((g) => (
                <div key={g} style={{ fontSize: 10, color: TAUPE, textAlign: "center" }}>Groupe {g}</div>
              ))}
              {COMBINAISONS_PRIX_TRANCHE.map(({ matiere, epaisseur, cle }) => (
                <React.Fragment key={cle}>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>{matiere} {epaisseur}</div>
                  {GROUPES.map((g) => (
                    <input
                      key={g}
                      type="number"
                      className="sc-input"
                      value={prixGroupesTranche2eChoix && prixGroupesTranche2eChoix[cle] && prixGroupesTranche2eChoix[cle][g] != null ? prixGroupesTranche2eChoix[cle][g] : ""}
                      onChange={(e) => {
                        const v = e.target.value;
                        const ligne = (prixGroupesTranche2eChoix && prixGroupesTranche2eChoix[cle]) || { 1: null, 2: null, 3: null, 4: null, 5: null };
                        persistPrixGroupesTranche2eChoix({ ...(prixGroupesTranche2eChoix || {}), [cle]: { ...ligne, [g]: v === "" ? null : v } });
                      }}
                      style={{ ...inputStyle("100%"), padding: "6px 6px", textAlign: "center" }}
                    />
                  ))}
                </React.Fragment>
              ))}
            </div>
            <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>
              Prix HT au m² du 2e choix (déclassé), même logique que la grille 1er choix ci-dessus — généralement inférieurs. Une ligne laissée vide n'a pas de prix disponible dans ce groupe pour le 2e choix.
            </div>
            </>)}
          </div>
          {estGerant && renderCalculRevient()}
          {estGerant && renderForfaitsTransport()}
          {estGerant && (() => {
            const ym = todayISO().slice(0, 7);
            const t = tauxMarge(ym, {});
            const est = (coutsRevient && coutsRevient.estimations) || {};
            const majEst = (k, v) => persistCoutsRevient({ ...coutsRevient, estimations: { ...est, [k]: v } });
            return (
              <div style={{ background: "#fff", border: `1px solid ${OCRE}`, borderRadius: 10, padding: 16, marginBottom: 20 }}>
                <div style={{ marginBottom: pcOuverts.taux ? 10 : 0 }}>{titrePC("taux", "Taux atelier et pose (marge)", `${libPeriode(ym)} : atelier ${fmtMAD(t.atelierA)} DH/m² · pose ${fmtMAD(t.poseA)} DH/m²·poseur`)}</div>
                {pcOuverts.taux && (
                  <div style={{ fontSize: 12, lineHeight: 1.8 }}>
                    <div>Atelier (masse salariale brute du service Atelier sans le Production Manager ni le bureau technique + consommables lents et hors dossier) ÷ m² transformés du mois — mois en cours : <b>{fmtMAD(t.atelierA)}</b> DH/m²{t.estimeA ? " (estimé)" : ""} · moyenne 12 mois : <b>{fmtMAD(t.atelierB)}</b>{t.estimeB ? " (estimé)" : ""}</div>
                    <div>Pose (masse salariale brute des poseurs) ÷ (m² posés × poseurs présents) — mois en cours : <b>{fmtMAD(t.poseA)}</b> DH/m²·poseur · moyenne 12 mois : <b>{fmtMAD(t.poseB)}</b></div>
                    <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", marginTop: 6 }}>Taux estimés (tant qu'il n'y a pas de mois mesuré) : atelier
                      <input type="number" min="0" className="sc-input" value={est.atelierM2 ?? ""} onChange={(e) => majEst("atelierM2", e.target.value)} style={{ ...inputStyle(90), padding: "4px 6px" }} /> DH/m² · pose
                      <input type="number" min="0" className="sc-input" value={est.poseM2 ?? ""} onChange={(e) => majEst("poseM2", e.target.value)} style={{ ...inputStyle(90), padding: "4px 6px" }} /> DH/m²·poseur</div>
                    {t.manquants > 0 && <div style={{ color: ROUILLE }}>{t.manquants} salaire(s) brut(s) manquant(s) ce mois : le net est utilisé à la place.</div>}
                  </div>
                )}
              </div>
            );
          })()}
          {estGerant && (() => {
            // Nils 28/10 : suivi mensuel des listellos (renforts des plans de 4 cm), 12 derniers mois.
            const ym = todayISO().slice(0, 7);
            const cache = {};
            const mois = Array.from({ length: 12 }, (_, i) => moisDecale(ym, -i));
            const lignes = mois.map((m) => ({ m, d: donneesTauxMois(m, cache), t: tauxMarge(m, cache) }));
            const enStock = (items || []).filter((it) => Number(it.stockReel) > 0 && lotListello(it));
            const tranchesStock = enStock.filter((it) => it.type !== TYPE_CHUTE).reduce((n, it) => n + (Number(it.stockReel) || 0), 0);
            const chutesStock = enStock.filter((it) => it.type === TYPE_CHUTE).reduce((n, it) => n + (Number(it.stockReel) || 0), 0);
            const nb = (x) => String(Math.round(x * 100) / 100).replace(".", ",");
            const th = { textAlign: "right", fontSize: 10, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.4, padding: "6px 8px", borderBottom: `1px solid ${PIERRE}` };
            const td = { textAlign: "right", fontSize: 12, padding: "5px 8px", borderBottom: `1px solid ${PIERRE}` };
            return (
              <div style={{ background: "#fff", border: `1px solid ${OCRE}`, borderRadius: 10, padding: 16, marginBottom: 20 }}>
                <div style={{ marginBottom: pcOuverts.listello ? 10 : 0 }}>{titrePC("listello", "Listellos (renforts des plans de 4 cm)", `en stock : ${nb(tranchesStock)} tranche(s) utilisable(s) en listello · ${nb(chutesStock)} chute(s) < 1 m²`)}</div>
                {pcOuverts.listello && (
                  <div>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead><tr><th style={{ ...th, textAlign: "left" }}>Mois</th><th style={th}>Tranches</th><th style={th}>Chutes (pièces)</th><th style={th}>Chutes (m²)</th><th style={th}>Valeur</th><th style={th}>Tranches façonnées 45°</th><th style={th}>Coût / tranche façonnée (mois)</th><th style={th}>Moyenne 12 mois</th></tr></thead>
                      <tbody>
                        {lignes.map(({ m, d, t }) => (
                          <tr key={m}>
                            <td style={{ ...td, textAlign: "left" }}>{libPeriode(m)}</td>
                            <td style={td}>{d.listelloTranches ? nb(d.listelloTranches) : "—"}</td>
                            <td style={td}>{d.listelloChutes ? nb(d.listelloChutes) : "—"}</td>
                            <td style={td}>{d.listelloChutesM2 ? nb(d.listelloChutesM2) : "—"}</td>
                            <td style={td}>{d.listelloValeur ? formatDH(d.listelloValeur) : "—"}{d.listelloSansPrix ? <div style={{ fontSize: 10, color: ROUILLE }}>{d.listelloSansPrix} sortie(s) sans prix</div> : null}</td>
                            <td style={td}>{d.qteMajListello ? nb(d.qteMajListello) : "—"}</td>
                            <td style={td}>{d.qteMajListello ? `${fmtMAD(t.listelloA)} DH` : "—"}</td>
                            <td style={td}>{t.listelloB ? `${fmtMAD(t.listelloB)} DH` : "—"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div style={{ fontSize: 11, color: TAUPE, marginTop: 8, lineHeight: 1.6 }}>
                      Listellos = sorties « Consommation atelier » de tranches cochées « Utilisable en listello » au Catalogue et de chutes de moins de 1 m², valorisées au coût de revient. Elles ne comptent plus dans le coût atelier : leur valeur est répartie sur la marge des dossiers selon la quantité des majorations cochées « Demande des listellos » (dossiers dont le PL est du mois). Un mois avec des listellos sortis sans dossier façonné à 45° n'est réparti que par la moyenne 12 mois.
                    </div>
                  </div>
                )}
              </div>
            );
          })()}
        </>
      )}

      {listeArrivages && !arrivageEdit && !arrivageLots && (estGerant || peut("stock.creerArrivage")) && (() => {
        const L = listeArrivages;
        const setL = (patch) => setListeArrivages({ ...L, ...patch });
        const tous = [
          ...(estGerant ? (arrivagesImport || []).map((a) => ({ type: "import", a, ref: a.numeroFacture || "" })) : []),
          ...(arrivagesLocaux || []).map((a) => ({ type: "local", a, ref: a.bl || "" })),
        ].map((x) => ({ ...x, etat: etatArrivage(x.a, x.type) }));
        const annees = [...new Set(tous.map((x) => String(x.a.date || "").slice(0, 4)).filter(Boolean))].sort().reverse();
        const q = normLib(L.recherche || "");
        const liste = tous
          .filter((x) => (L.onglet === "traiter" ? !x.etat.termine : L.onglet === "termines" ? x.etat.termine : true))
          .filter((x) => !L.annee || String(x.a.date || "").startsWith(L.annee))
          .filter((x) => !q || [x.a.numero, x.a.fournisseur, x.ref].some((v) => normLib(v || "").includes(q)))
          .sort((a, b) => String(b.a.date).localeCompare(String(a.a.date)) || String(b.a.numero).localeCompare(String(a.a.numero)));
        const nbTraiter = tous.filter((x) => !x.etat.termine).length;
        const th = { textAlign: "left", fontSize: 10, color: TAUPE, padding: "6px 8px", borderBottom: `1px solid ${PIERRE}` };
        const td = { padding: "6px 8px" };
        const ong = (k, lib) => <button key={k} type="button" className="sc-btn" onClick={() => setL({ onglet: k })} style={{ ...(L.onglet === k ? primaryBtnStyle : ghostBtnStyle), fontSize: 12, padding: "5px 12px" }}>{lib}</button>;
        return (
          <Overlay onClose={() => setListeArrivages(null)}>
            <div style={{ ...modalStyle(900), maxHeight: "90vh", overflowY: "auto" }}>
              <div style={modalTitleStyle}>Arrivages</div>
              <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 12 }}>
                {ong("traiter", `À traiter (${nbTraiter})`)}{ong("termines", "Terminés")}{ong("tous", "Tous")}
                <input className="sc-input" placeholder="N°, fournisseur, facture / BL…" value={L.recherche} onChange={(e) => setL({ recherche: e.target.value })} style={{ ...inputStyle(220), marginLeft: "auto" }} />
                <select className="sc-select" value={L.annee} onChange={(e) => setL({ annee: e.target.value })} style={{ ...selectStyle, width: 110 }}>
                  <option value="">Toutes années</option>
                  {annees.map((y) => (<option key={y} value={y}>{y}</option>))}
                </select>
              </div>
              {!liste.length ? <div style={{ fontSize: 13, color: TAUPE, marginBottom: 12 }}>{tous.length ? "Aucun arrivage pour ces filtres." : "Aucun arrivage."}</div> : (
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, marginBottom: 14 }}>
                  <thead><tr>{["N°", "Type", "Date", "Fournisseur", "Facture / BL", "Lignes", "Réception", ...(estGerant ? ["Coûts"] : [])].map((h) => <th key={h} style={th}>{h}</th>)}</tr></thead>
                  <tbody>
                    {liste.map(({ type, a, ref, etat }) => (
                      <tr key={a.id} onClick={() => ouvrirFicheArrivage(type, a)} style={{ cursor: "pointer", borderBottom: `1px solid ${PIERRE}` }}>
                        <td style={{ ...td, fontWeight: 600 }}>{a.numero}</td>
                        <td style={td}>{type === "import" ? "Import" : "Local"}</td>
                        <td style={td}>{formatDate(a.date)}</td>
                        <td style={td}>{a.fournisseur}</td>
                        <td style={td}>{ref || "—"}</td>
                        <td style={td}>{(a.lignes || []).length}</td>
                        <td style={{ ...td, color: etat.recu ? VERT_OK : TAUPE }}>{etat.recu ? "reçu" : "en route"}</td>
                        {estGerant && <td style={{ ...td, color: type !== "import" ? TAUPE : a.calculeLe ? VERT_OK : OCRE }}>{type !== "import" ? "—" : a.calculeLe ? `appliqués le ${formatDate(a.calculeLe)}` : "à appliquer"}</td>}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {estGerant && <button type="button" className="sc-btn" onClick={nouvelArrivageImport} style={primaryBtnStyle}>+ Arrivage import</button>}
                {peut("stock.creerArrivage") && <button type="button" className="sc-btn" onClick={() => ouvrirTypeArrivage("local")} style={primaryBtnStyle}>+ Arrivage local</button>}
                <button type="button" className="sc-btn" onClick={() => setListeArrivages(null)} style={{ ...ghostBtnStyle, marginLeft: "auto" }}>Fermer</button>
              </div>
            </div>
          </Overlay>
        );
      })()}
      {estGerant && arrivageEdit && (() => {
        const a = arrivageEdit;
        const set = (patch) => setArrivageEdit({ ...a, ...patch });
        const setFrais = (k, v) => set({ frais: { ...(a.frais || {}), [k]: v } });
        const setLigne = (id, patch) => set({ lignes: a.lignes.map((l) => (l.id === id ? { ...l, ...patch } : l)) });
        const calc = calculArrivage(a);
        const choixArticles = articlesPourArrivage(a.fournisseur);
        const nb = (v, onCh, w, dis) => <input type="number" min="0" className="sc-input" disabled={!!dis} value={v ?? ""} onChange={(e) => onCh(e.target.value)} style={{ ...inputStyle(w || 130), padding: "6px 8px", opacity: dis ? 0.6 : 1 }} />;
        const td = { padding: "5px 6px", fontSize: 12, textAlign: "right", whiteSpace: "nowrap", borderBottom: `1px solid ${PIERRE}`, verticalAlign: "middle" };
        const thS = { ...td, fontSize: 10, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.3 };
        const brutAttendu = calc.attenduDevise;
        const ecartFacture = brutAttendu !== null && nombreOuZero(a.factureDevise) > 0 ? nombreOuZero(a.factureDevise) - brutAttendu : null;
        return (
          <Overlay onClose={() => setArrivageEdit(null)} zIndex={1400}>
            <div style={modalStyle(1080)}>
              <div style={modalTitleStyle}>Arrivage {a.numero} <span style={{ fontSize: 12, fontWeight: 400, color: statutArrivage(a).couleur }}>{a.id ? statutArrivage(a).lib : "nouveau"}</span></div>
              {bandeauBlacklist(a.fournisseur)}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 10 }}>
                <Field label="Date"><input type="date" className="sc-input" value={String(a.date || "").slice(0, 10)} onChange={(e) => set({ date: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label="Fournisseur">
                  <select className="sc-select" value={a.fournisseur} disabled={(a.lignes || []).some((l) => l.lotId)} onChange={(e) => set({ fournisseur: e.target.value, lignes: (a.lignes || []).map((l) => ({ ...l, articleId: "" })) })} style={selectStyle}>
                    <option value="">— Choisir —</option>
                    {trierAlpha(fournisseurs || [], "nom").map((f) => (<option key={f.id} value={f.nom}>{f.nom}</option>))}
                  </select>
                </Field>
                <Field label="N° facture / colisage"><input className="sc-input" value={a.numeroFacture || ""} onChange={(e) => set({ numeroFacture: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label="Devise">
                  <select className="sc-select" value={a.devise} onChange={(e) => set({ devise: e.target.value })} style={selectStyle}>{DEVISES_IMPORT.map((d) => (<option key={d} value={d}>{d}</option>))}</select>
                </Field>
                {a.devise !== "MAD" && <Field label={`Taux réel : 1 ${a.devise} =`}>{nb(a.taux, (v) => set({ taux: v }), 110)}</Field>}
              </div>

              <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, margin: "8px 0 6px" }}>Lignes (liste de colisage)</div>
              {!a.fournisseur ? <div style={{ fontSize: 12, color: TAUPE, marginBottom: 8 }}>Choisis d'abord le fournisseur.</div> : (
                <div style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", width: "100%", minWidth: 860 }}>
                    <thead><tr>
                      <th style={{ ...thS, textAlign: "left" }}>Article</th><th style={thS}>Qté</th><th style={{ ...thS, textAlign: "left" }}>Tonalité</th><th style={thS}>A prévus</th><th style={thS}>B prévus</th><th style={thS}>Remise extra %</th><th style={thS}>Standard net</th><th style={thS} />
                    </tr></thead>
                    <tbody>
                      {(a.lignes || []).map((l) => {
                        const art = (articles || []).find((x) => x.id === l.articleId);
                        const lot = l.lotId ? (items || []).find((it) => it.id === l.lotId) : null;
                        const verrou = !!(lot && lotRecu(lot));
                        const rsL = lot ? reservationsActivesLot(lot.id) : [];
                        const bm = art ? bookMatchSepare(art.produitStockId) : false;
                        const c = calc.lignes.find((x) => x.ligne.id === l.id);
                        const min = qteMinImport(art, a.fournisseur);
                        return (
                          <tr key={l.id}>
                            <td style={{ ...td, textAlign: "left" }}>
                              <select className="sc-select" value={l.articleId} disabled={verrou} onChange={(e) => setLigne(l.id, { articleId: e.target.value })} style={{ ...selectStyle, minWidth: 240, padding: "5px 6px" }}>
                                <option value="">— Article —</option>
                                {choixArticles.map((x) => (<option key={x.id} value={x.id}>{x.designation}</option>))}
                              </select>
                              {verrou && <div style={{ fontSize: 10, color: TAUPE }}>reçu — verrouillé{receptionAnnulable(lot).ok && <> · <span onClick={() => annulerReception(lot)} style={{ color: ROUILLE, textDecoration: "underline", cursor: "pointer" }}>↶ Annuler la réception</span></>}</div>}
                              {!!rsL.length && <div style={{ fontSize: 10, color: OCRE }}>réservé : {libReservations(rsL)}</div>}
                              {min !== null && nombreOuZero(l.qte) > 0 && nombreOuZero(l.qte) < min && <div style={{ fontSize: 10, color: ROUILLE }}>⚠ sous la quantité minimum d'import ({min})</div>}
                            </td>
                            <td style={td}>{nb(l.qte, (v) => setLigne(l.id, { qte: v }), 70, verrou)}</td>
                            <td style={{ ...td, textAlign: "left" }}><input className="sc-input" disabled={verrou} value={l.nuance || ""} onChange={(e) => setLigne(l.id, { nuance: e.target.value })} style={{ ...inputStyle(90), padding: "6px 8px" }} /></td>
                            <td style={td}>{bm ? nb(l.arrivageA, (v) => setLigne(l.id, { arrivageA: v }), 60, verrou) : <span style={{ color: TAUPE }}>—</span>}</td>
                            <td style={td}>{bm ? nb(l.arrivageB, (v) => setLigne(l.id, { arrivageB: v }), 60, verrou) : <span style={{ color: TAUPE }}>—</span>}</td>
                            <td style={td}>{nb(l.remisePct, (v) => setLigne(l.id, { remisePct: v }), 60)}</td>
                            <td style={td}>{c && c.standardNet !== null ? fmtMAD(c.standardNet) : "—"}</td>
                            <td style={td}>{!verrou && <button type="button" className="sc-btn" onClick={() => set({ lignes: a.lignes.filter((x) => x.id !== l.id) })} style={iconBtnStyle}>✕</button>}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  {(() => {
                    // Nils 09/10 : les chevalets sont facturés par le fournisseur → ligne de l'arrivage (pas de lot en stock).
                    const ch = a.chevalets || {};
                    const prDef = profilsRevient().find((p) => p.type === "tranches" && p.fournisseur && normLib(p.fournisseur) === normLib(a.fournisseur));
                    const setCh = (patch) => set({ chevalets: { ...ch, ...patch } });
                    const totCh = nombreOuZero(ch.qte) * nombreOuZero(ch.prixDevise);
                    return (
                      <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", fontSize: 12, padding: "6px 6px", borderBottom: `1px solid ${PIERRE}`, background: "#FAF8F6" }}>
                        <strong style={{ minWidth: 240 }}>Chevalets <span style={{ fontWeight: 400, color: TAUPE }}>(sur la facture — pas de lot en stock)</span></strong>
                        Qté {nb(ch.qte, (v) => setCh({ qte: v, ...(ch.prixDevise === undefined || ch.prixDevise === "" ? { prixDevise: prDef && prDef.coutChevalet ? prDef.coutChevalet : "" } : {}) }), 70)}
                        × prix unitaire ({a.devise}) {nb(ch.prixDevise, (v) => setCh({ prixDevise: v }), 90)}
                        {totCh > 0 && <span>= <strong>{fmtMAD(totCh)} {a.devise}</strong></span>}
                      </div>
                    );
                  })()}
                  <button type="button" className="sc-btn" onClick={() => set({ lignes: [...(a.lignes || []), nouvelleLigneArrivage()] })} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>+ Ajouter une ligne</button>
                  {!choixArticles.length && <div style={{ fontSize: 11, color: ROUILLE }}>Aucun article importé de {a.fournisseur} dans le Catalogue (provenance « Importé », lié au Stock).</div>}
                </div>
              )}

              <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, margin: "12px 0 6px" }}>Facture et frais</div>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end" }}>
                <Field label={`Facture brute (${a.devise}, chevalets compris) — facultatif`} style={{ marginBottom: 0 }}>{nb(a.factureDevise, (v) => set({ factureDevise: v }))}</Field>
                <Field label="Conteneur" style={{ marginBottom: 0 }}>
                  <select className="sc-select" aria-label="Taille du conteneur" value={a.conteneur || ""} onChange={(e) => set({ conteneur: e.target.value ? Number(e.target.value) : "" })} style={{ ...selectStyle, width: 130 }}>
                    <option value="">— Taille —</option>
                    <option value={20}>20 pieds</option>
                    <option value={40}>40 pieds</option>
                  </select>
                </Field>
                <Field label="Nombre" style={{ marginBottom: 0 }}>{nb(a.nbConteneurs ?? 1, (v) => set({ nbConteneurs: v }), 70)}</Field>
                <Field label="Transport + dédouanement + déchargement (MAD)" style={{ marginBottom: 0 }}>
                  <div style={{ ...inputStyle(200), padding: "6px 8px", background: "#fff", fontWeight: 600 }}>{formatDH(calc.logi.montant)}</div>
                </Field>
                <Field label="Autres frais (MAD)" style={{ marginBottom: 0 }}>{nb((a.frais || {}).autres, (v) => setFrais("autres", v), 120)}</Field>
              </div>
              <div style={{ fontSize: 11, color: calc.logi.source === "aucun" ? ROUILLE : calc.logi.source === "reel" ? VERT_OK : TAUPE, marginTop: 4 }}>
                Logistique : {calc.logi.lib}.{calc.logi.source !== "reel" ? " Les frais réels prendront le relais quand l'Administration rattachera ce conteneur à l'arrivage dans le registre Transport international." : ""}
                {nombreOuZero((a.frais || {}).emballage) > 0 ? ` Ancien champ emballage : ${formatDH(nombreOuZero(a.frais.emballage))} (compté).` : ""}
              </div>
              <div style={{ fontSize: 11, color: TAUPE, margin: "6px 0 10px" }}>
                Facture attendue d'après la grille et les remises : {brutAttendu !== null ? `${fmtMAD(brutAttendu)} ${a.devise}` : "non calculable (coût standard manquant sur une ligne)"}
                {ecartFacture !== null && Math.abs(ecartFacture) > 0.5 && <span style={{ color: ROUILLE, fontWeight: 600 }}> — écart avec la facture saisie : {ecartFacture > 0 ? "+" : ""}{fmtMAD(ecartFacture)} {a.devise}</span>}
                {" "}· Facture nette (avoirs déduits) : {formatDH(calc.factureMAD)}
                {calc.factureEstimee && <span style={{ color: OCRE, fontWeight: 600 }}> — facture brute non saisie : coûts calculés sur la facture attendue (à saisir dès réception de la vraie facture, puis réappliquer les coûts)</span>}
              </div>

              <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, margin: "6px 0" }}>Avoirs fournisseur reçus après coup ({a.devise})</div>
              {(a.avoirs || []).map((av, i) => (
                <div key={i} style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 6 }}>
                  <input type="date" className="sc-input" value={av.date || ""} onChange={(e) => set({ avoirs: a.avoirs.map((x, j) => (j === i ? { ...x, date: e.target.value } : x)) })} style={inputStyle(150)} />
                  <input className="sc-input" value={av.ref || ""} placeholder="référence de l'avoir" onChange={(e) => set({ avoirs: a.avoirs.map((x, j) => (j === i ? { ...x, ref: e.target.value } : x)) })} style={inputStyle(200)} />
                  {nb(av.montantDevise, (v) => set({ avoirs: a.avoirs.map((x, j) => (j === i ? { ...x, montantDevise: v } : x)) }), 120)}
                  <button type="button" className="sc-btn" onClick={() => set({ avoirs: a.avoirs.filter((_, j) => j !== i) })} style={iconBtnStyle}>✕</button>
                </div>
              ))}
              <button type="button" className="sc-btn" onClick={() => set({ avoirs: [...(a.avoirs || []), { date: todayISO(), ref: "", montantDevise: "" }] })} style={{ ...ghostBtnStyle, padding: "2px 0", fontSize: 12 }}>+ Ajouter un avoir</button>

              {!!calc.lignes.length && calc.total > 0 && (
                <div style={{ overflowX: "auto", marginTop: 10 }}>
                  <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, margin: "6px 0" }}>Répartition — prix de revient réel</div>
                  <table style={{ borderCollapse: "collapse", width: "100%", minWidth: 760 }}>
                    <thead><tr>{["Ligne", "Qté", "Part facture", "Part frais", "Revient unitaire", "Standard", "Écart"].map((h, i) => <th key={h} style={{ ...thS, textAlign: i === 0 ? "left" : "right" }}>{h}</th>)}</tr></thead>
                    <tbody>
                      {calc.lignes.map((l) => (
                        <tr key={l.ligne.id}>
                          <td style={{ ...td, textAlign: "left" }}>{l.art ? l.art.designation : "—"}{l.ligne.nuance ? ` · ton. ${l.ligne.nuance}` : ""}{l.r ? ` · remise ${Math.round(l.r * 1000) / 10} %` : ""}</td>
                          <td style={td}>{l.qte}</td>
                          <td style={td}>{fmtMAD(l.partFacture)}</td>
                          <td style={td}>{fmtMAD(l.partFrais)}</td>
                          <td style={{ ...td, fontWeight: 700 }}>{l.coutUnitaire !== null ? fmtMAD(l.coutUnitaire) : "—"}</td>
                          <td style={td}>{l.standard !== null ? fmtMAD(l.standard) : "—"}</td>
                          <td style={{ ...td, color: l.ecart === null ? TAUPE : l.ecart > 0 ? ROUILLE : VERT_OK }}>{l.ecart === null ? "—" : `${l.ecart > 0 ? "+" : ""}${fmtMAD(l.ecart)} (${l.standard ? `${l.ecart > 0 ? "+" : ""}${((l.ecart / l.standard) * 100).toFixed(1).replace(".", ",")} %` : "—"})`}</td>
                        </tr>
                      ))}
                      <tr>
                        <td style={{ ...td, textAlign: "left", fontWeight: 700 }}>Total</td>
                        <td style={td} />
                        <td style={{ ...td, fontWeight: 700 }}>{fmtMAD(calc.factureMAD)}</td>
                        <td style={{ ...td, fontWeight: 700 }}>{fmtMAD(calc.fraisMAD)}</td>
                        <td style={{ ...td, fontWeight: 700 }} colSpan={3}>{formatDH(calc.total)}</td>
                      </tr>
                    </tbody>
                  </table>
                  {calc.mixte && <div style={{ fontSize: 11, color: OCRE, marginTop: 6 }}>Arrivage mixte (tranches et éviers / accessoires) : les frais sont répartis à la valeur pour toutes les lignes.</div>}
                  {calc.sansStandard && <div style={{ fontSize: 11, color: OCRE, marginTop: 6 }}>Une ligne n'a pas de coût standard (profil, groupe fournisseur ou prix manquant) : la facture est répartie au m² / à la quantité pour tout l'arrivage.</div>}
                </div>
              )}
              <Field label="Notes" style={{ marginTop: 10 }}><input className="sc-input" value={a.notes || ""} onChange={(e) => set({ notes: e.target.value })} style={inputStyle("100%")} /></Field>
              <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", flexWrap: "wrap", marginTop: 6 }}>
                {a.id && <button type="button" className="sc-btn" onClick={() => supprimerArrivageImport(a)} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>Supprimer</button>}
                <button type="button" className="sc-btn" onClick={() => setArrivageEdit(null)} style={ghostBtnStyle}>Fermer</button>
                <button type="button" className="sc-btn" onClick={() => enregistrerArrivageImport(false)} style={ghostBtnStyle}>Enregistrer{a.id ? "" : " et créer les lots"}</button>
                <button type="button" className="sc-btn" onClick={() => enregistrerArrivageImport(true)} style={primaryBtnStyle}>Enregistrer et appliquer les coûts aux lots</button>
              </div>
            </div>
          </Overlay>
        );
      })()}
      {deplAvance && (() => {
        const f = deplAvance;
        const d = (deplacements || []).find((x) => x.id === f.depId);
        if (!d) return null;
        return (
          <Overlay onClose={() => setDeplAvance(null)} zIndex={1470}>
            <div style={modalStyle(460)}>
              <div style={modalTitleStyle}>Avance de frais</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 10 }}>Déplacement du {formatDate(d.date)}{d.dateFin && d.dateFin > d.date ? ` au ${formatDate(d.dateFin)}` : ""} — {(zoneDe(d.zoneId) || {}).nom || ""}. Sortie en caisse usine (Pose & Production › Caisse poseurs).</div>
              <Field label="Montant (DH)"><input type="number" min="0" className="sc-input" value={f.montant} onChange={(e) => setDeplAvance({ ...f, montant: e.target.value })} style={inputStyle(140)} /></Field>
              <Field label="Remise à">
                <select className="sc-select" value={f.beneficiaireId} onChange={(e) => setDeplAvance({ ...f, beneficiaireId: e.target.value })} style={{ ...selectStyle, width: 240 }}>
                  <option value="">— Poseur du déplacement —</option>
                  {(d.participants || []).filter((x) => x.staffId).map((x) => (<option key={x.staffId} value={x.staffId}>{((staff || []).find((y) => y.id === x.staffId) || {}).nom || "?"}</option>))}
                </select>
              </Field>
              <Field label="Date"><input type="date" className="sc-input" value={f.date} onChange={(e) => setDeplAvance({ ...f, date: e.target.value })} style={inputStyle(150)} /></Field>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                <button type="button" className="sc-btn" onClick={() => setDeplAvance(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={remettreAvanceDepl} style={primaryBtnStyle}>Remettre l'avance</button>
              </div>
            </div>
          </Overlay>
        );
      })()}
      {choixArrivage && (
        <Overlay onClose={() => setChoixArrivage(false)}>
          <div style={modalStyle(520)}>
            <div style={modalTitleStyle}>📥 Arrivage</div>
            {(estGerant || peut("stock.creerArrivage")) && (() => {
              const n = [...(estGerant ? (arrivagesImport || []).map((a) => etatArrivage(a, "import")) : []), ...(arrivagesLocaux || []).map((a) => etatArrivage(a, "local"))].filter((e) => !e.termine).length;
              return (
                <button type="button" className="sc-btn" onClick={() => { setChoixArrivage(false); setListeArrivages({ onglet: "traiter", recherche: "", annee: "" }); }} style={{ display: "block", width: "100%", textAlign: "left", background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "10px 14px", marginBottom: 12, cursor: "pointer", color: ENCRE }}>
                  <div style={{ fontSize: 14, fontWeight: 600 }}>📋 Liste des arrivages <span style={{ fontSize: 12, color: TAUPE, fontWeight: 400 }}>· {n} à traiter</span></div>
                  <div style={{ fontSize: 12, color: TAUPE }}>import et local — ouvrir, modifier, ajouter une ligne</div>
                </button>
              );
            })()}
            {typesArrivagePermis().map(([k, lib, sous]) => (
              <button key={k} type="button" className="sc-btn" onClick={() => ouvrirTypeArrivage(k)} style={{ display: "block", width: "100%", textAlign: "left", background: PIERRE, borderRadius: 8, padding: "10px 14px", marginBottom: 8, cursor: "pointer", color: ENCRE }}>
                <div style={{ fontSize: 14, fontWeight: 600 }}>{lib}</div>
                <div style={{ fontSize: 12, color: TAUPE }}>{sous}</div>
              </button>
            ))}
            {peutCreerLot && (<>
              <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, margin: "12px 0 6px" }}>Autre entrée (pas un arrivage)</div>
              {peut("stock.stockDepart") && <button type="button" className="sc-btn" onClick={ouvrirStockDepart} style={{ display: "block", width: "100%", textAlign: "left", background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "8px 14px", cursor: "pointer", marginBottom: 8 }}><div style={{ fontSize: 14, fontWeight: 600 }}>➕ Stock de départ</div><div style={{ fontSize: 12, color: TAUPE }}>lots déjà présents avant l'ERP : directement en stock, sans arrivage ni réception</div></button>}
              <button type="button" className="sc-btn" onClick={() => ouvrirTypeArrivage("chute")} style={{ display: "block", width: "100%", textAlign: "left", background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "8px 14px", cursor: "pointer", color: ENCRE, fontSize: 13 }}>Chute hors PL</button>
            </>)}
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}><button type="button" className="sc-btn" onClick={() => setChoixArrivage(false)} style={ghostBtnStyle}>Fermer</button></div>
          </div>
        </Overlay>
      )}
      {stockDepart && peut("stock.stockDepart") && (() => {
        const f = stockDepart;
        const setL = (i, patch) => setStockDepart({ ...f, erreur: "", lignes: f.lignes.map((l, j) => (j === i ? { ...l, ...patch } : l)) });
        const cats = [...new Set((produits || []).map((p) => p.categorie).filter((c) => c && (estCategorieStockReservee(c) || estCategorieConsommable(c))))].sort((a, b) => a.localeCompare(b, "fr"));
        const deja = lotsStockDepart();
        const cell = { padding: 3, verticalAlign: "top" };
        return (
          <Overlay onClose={() => setStockDepart(null)}>
            <div style={{ ...modalStyle(1100), maxWidth: "96vw" }}>
              <div style={modalTitleStyle}>➕ Stock de départ</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 12 }}>Lots déjà présents avant l'ERP : chaque ligne crée un lot directement en stock réel (ni arrivage, ni réception), avec une entrée « Stock de départ » à la date choisie. Tu peux saisir en plusieurs fois. {estGerant ? "Sans prix, un article importé prend son coût standard." : "Sans prix : le Gérant les complète (il est prévenu)."}</div>
              <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 10 }}>
                <span style={{ fontSize: 13 }}>Date du stock de départ</span>
                <input type="date" className="sc-input" max={todayISO()} value={f.date} onChange={(e) => setStockDepart({ ...f, date: e.target.value, erreur: "" })} style={{ ...inputStyle(160), padding: "5px 8px" }} />
              </div>
              <div style={{ overflowX: "auto", marginBottom: 8 }}>
                <table style={{ borderCollapse: "collapse", fontSize: 12, width: "100%" }}>
                  <thead><tr style={{ color: TAUPE, textAlign: "left" }}>{["Catégorie", "Article", "Quantité", "Nuance", "A / B", "Chute (dimensions cm)", "Fournisseur", ...(estGerant ? ["Prix de revient HT"] : []), ""].map((h) => <th key={h} style={{ padding: 4, fontWeight: 600 }}>{h}</th>)}</tr></thead>
                  <tbody>
                    {f.lignes.map((l, i) => {
                      const p = produitDe(l.produitId);
                      const tranche = p && !estCategorieConsommable(p.categorie) && !categorieEstPiece(p.categorie);
                      return (
                        <tr key={l.id}>
                          <td style={cell}><select className="sc-select" value={l.categorie} onChange={(e) => setL(i, { categorie: e.target.value, produitId: "" })} style={{ ...selectStyle, width: 130, padding: "4px 6px" }}><option value="">Toutes</option>{cats.map((c) => <option key={c} value={c}>{c}</option>)}</select></td>
                          <td style={cell}><select className="sc-select" value={l.produitId} onChange={(e) => setL(i, { produitId: e.target.value, bm: "", chute: false, dimensions: "" })} style={{ ...selectStyle, width: 240, padding: "4px 6px" }}><option value="">— Article —</option>{produitsStockDepart(l.categorie).map((x) => <option key={x.id} value={x.id}>{x.nom}{l.categorie ? "" : ` · ${x.categorie}`}</option>)}</select></td>
                          <td style={cell}><input type="number" min="0" className="sc-input" value={l.quantite} onChange={(e) => setL(i, { quantite: e.target.value })} style={{ ...inputStyle(70), padding: "4px 6px" }} />{p ? <span style={{ color: TAUPE, marginLeft: 4 }}>{categorieUnite(p.categorie) || "pièce(s)"}</span> : null}</td>
                          <td style={cell}>{p && categorieNuances(p.categorie) ? <input className="sc-input" value={l.nuance} onChange={(e) => setL(i, { nuance: e.target.value })} style={{ ...inputStyle(70), padding: "4px 6px" }} /> : "—"}</td>
                          <td style={cell}>{p && tranche && !l.chute && produitBookMatch(p.id) ? <select className="sc-select" value={l.bm} onChange={(e) => setL(i, { bm: e.target.value })} style={{ ...selectStyle, width: 70, padding: "4px 6px" }}><option value="">—</option><option value="A">A</option><option value="B">B</option></select> : "—"}</td>
                          <td style={cell}>{tranche ? (<><label style={{ display: "inline-flex", gap: 4, alignItems: "center", marginRight: 6 }}><input type="checkbox" checked={!!l.chute} onChange={(e) => setL(i, { chute: e.target.checked, dimensions: "", bm: "" })} />chute</label>{l.chute && <input className="sc-input" value={l.dimensions} placeholder="160 × 90" onChange={(e) => setL(i, { dimensions: e.target.value })} style={{ ...inputStyle(90), padding: "4px 6px" }} />}</>) : "—"}</td>
                          <td style={cell}><input className="sc-input" value={l.fournisseur} placeholder={(p && articleDuProduit(p.id) && articleDuProduit(p.id).fournisseur) || "fournisseur"} onChange={(e) => setL(i, { fournisseur: e.target.value })} style={{ ...inputStyle(120), padding: "4px 6px" }} /></td>
                          {estGerant && <td style={cell}><input type="number" min="0" className="sc-input" value={l.prix} onChange={(e) => setL(i, { prix: e.target.value })} placeholder="facultatif" style={{ ...inputStyle(100), padding: "4px 6px" }} /></td>}
                          <td style={cell}>{f.lignes.length > 1 && <button type="button" className="sc-btn" onClick={() => setStockDepart({ ...f, lignes: f.lignes.filter((_, j) => j !== i) })} style={iconBtnStyle}>✕</button>}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <button type="button" className="sc-btn" onClick={() => setStockDepart({ ...f, lignes: [...f.lignes, ligneStockDepartVide()] })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0" }}>+ Ajouter une ligne</button>
              {f.erreur && <div style={{ color: ROUILLE, fontSize: 12, marginTop: 8 }}>{f.erreur}</div>}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 12 }}>
                <button type="button" className="sc-btn" onClick={() => setStockDepart(null)} style={ghostBtnStyle}>Fermer</button>
                <button type="button" className="sc-btn" onClick={enregistrerStockDepart} style={primaryBtnStyle}>Enregistrer en stock</button>
              </div>
              <div style={{ borderTop: `1px solid ${PIERRE}`, marginTop: 14, paddingTop: 10 }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, marginBottom: 6 }}>Déjà saisi en stock de départ ({deja.length})</div>
                {!deja.length ? <div style={{ fontSize: 12, color: TAUPE }}>Rien pour l'instant.</div> : (
                  <div style={{ maxHeight: 200, overflowY: "auto", fontSize: 12 }}>
                    {deja.map((it) => (<div key={it.id} style={{ padding: "3px 0", borderBottom: `1px solid ${PIERRE}` }}>{nomProduit(it.produitId)} — {it.qteBase ?? it.stockReel} {it.unite}{it.type === TYPE_CHUTE ? ` · chute ${it.dimensions}` : ""}{it.nuance ? ` · n${it.nuance}` : ""}{it.bm ? ` · ${it.bm}` : ""}{it.fournisseur ? ` · ${it.fournisseur}` : ""} <span style={{ color: TAUPE }}>(au {formatDate(it.stockDepartLe)})</span></div>))}
                  </div>
                )}
              </div>
            </div>
          </Overlay>
        );
      })()}
      {arrivageLots && (() => {
        const f = arrivageLots;
        const local = f.type === "local";
        const set = (patch) => setArrivageLots({ ...f, ...patch, erreur: "" });
        const setL = (i, patch) => set({ lignes: f.lignes.map((l, j) => (j === i ? { ...l, ...patch } : l)) });
        const nomsF = local
          ? [...new Set((fournisseurs || []).map((x) => x.nom).filter(Boolean))].sort((a, b) => a.localeCompare(b, "fr"))
          : [...new Set((produits || []).filter((p) => estCategorieConsommable(p.categorie)).flatMap((p) => fournisseursAutorises(p).map((c) => c.fournisseur)))].sort((a, b) => a.localeCompare(b, "fr"));
        const cats = categoriesArrivage(f.type);
        const total = f.lignes.reduce((n, l) => n + nombreOuZero(l.prix) * nombreOuZero(l.qte), 0);
        const bl = f.fournisseur && fournisseurBlackliste(f.fournisseur);
        return (
          <Overlay onClose={() => setArrivageLots(null)} zIndex={1450}>
            <div style={{ ...modalStyle(900), maxHeight: "90vh", overflowY: "auto" }}>
              <div style={modalTitleStyle}>📥 {f.id ? `Arrivage ${f.numero}` : "Arrivage"} — {local ? "tranches, éviers, accessoires (achat local)" : "consommables"}{f.id && <span style={{ fontSize: 12, fontWeight: 400, color: TAUPE }}> · {(() => { const fi = (arrivagesLocaux || []).find((x) => x.id === f.id); return fi && etatArrivage(fi, "local").recu ? "reçu" : "en route"; })()}</span>}</div>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                <Field label="Fournisseur">
                  <select className="sc-select" value={f.fournisseur} disabled={!!f.id} onChange={(e) => set({ fournisseur: e.target.value, lignes: f.lignes.map((l) => ({ ...l, produitId: "" })) })} style={{ ...selectStyle, width: 240 }}>
                    <option value="">— Fournisseur —</option>
                    {nomsF.map((n) => (<option key={n} value={n}>{n}</option>))}
                  </select>
                </Field>
                <Field label="Date"><input type="date" className="sc-input" value={f.date} max={todayISO()} onChange={(e) => set({ date: e.target.value })} style={inputStyle(150)} /></Field>
                <Field label="N° BL / facture fournisseur"><input className="sc-input" value={f.bl} onChange={(e) => set({ bl: e.target.value })} style={inputStyle(170)} /></Field>
                {local && estGerant && <Field label="Transport d'approche HT (total)"><input type="number" min="0" className="sc-input" value={f.transport} onChange={(e) => set({ transport: e.target.value })} style={inputStyle(130)} /></Field>}
              </div>
              {bl && <div style={{ fontSize: 12, color: ROUILLE, marginBottom: 8 }}>⛔ {bl.nom} est blacklisté{bl.blacklist.motif ? ` (${bl.blacklist.motif})` : ""}.</div>}
              {!local && <div style={{ fontSize: 11, color: TAUPE, marginTop: -4, marginBottom: 8 }}>Seuls les fournisseurs autorisés d'au moins une sous-catégorie de consommables sont proposés.</div>}
              <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 12, marginBottom: 6 }}>
                <thead><tr style={{ color: TAUPE, textAlign: "left" }}>{["Catégorie", "Article", "Quantité", ...(local ? ["Nuance", "A / B prévus"] : []), ...((local ? estGerant : peutVoirPrixConso) ? ["Prix unitaire HT"] : []), ""].map((h, i) => <th key={i} style={{ padding: "4px 4px", fontSize: 10, textTransform: "uppercase" }}>{h}</th>)}</tr></thead>
                <tbody>
                  {f.lignes.map((l, i) => {
                    const p = produitDe(l.produitId);
                    const lotL = l.lotId ? (items || []).find((it) => it.id === l.lotId) : null;
                    const recuL = !!(lotL && lotRecu(lotL));
                    const rsL = lotL ? reservationsActivesLot(lotL.id) : [];
                    const prods = produitsArrivage(f.type, f.fournisseur, l.categorie);
                    const prodsAff = p && !prods.some((x) => x.id === p.id) ? [p, ...prods] : prods;
                    const t = !local && p && f.fournisseur ? targetPriceDe(p, f.fournisseur) : null;
                    return (
                      <React.Fragment key={l.id || i}>
                      <tr style={{ borderTop: `1px solid ${PIERRE}` }}>
                        <td style={{ padding: 3 }}><select className="sc-select" value={l.categorie} disabled={recuL} onChange={(e) => setL(i, { categorie: e.target.value, produitId: "" })} style={{ ...selectStyle, width: 150, padding: "4px 6px" }}><option value="">Toutes</option>{cats.map((c) => (<option key={c} value={c}>{c}</option>))}</select></td>
                        <td style={{ padding: 3 }}><select className="sc-select" value={l.produitId} disabled={!f.fournisseur || recuL} onChange={(e) => setL(i, { produitId: e.target.value })} style={{ ...selectStyle, width: 260, padding: "4px 6px" }}><option value="">{f.fournisseur ? "— Article —" : "Choisis d'abord le fournisseur"}</option>{prodsAff.map((x) => (<option key={x.id} value={x.id}>{x.nom}{l.categorie ? "" : ` · ${x.categorie}`}</option>))}</select></td>
                        <td style={{ padding: 3, whiteSpace: "nowrap" }}><input type="number" min="0" className="sc-input" value={l.qte} disabled={recuL} onChange={(e) => setL(i, { qte: e.target.value })} style={{ ...inputStyle(70), padding: "4px 6px" }} /> <span style={{ color: TAUPE }}>{p ? categorieUnite(p.categorie) || "pièce(s)" : ""}</span></td>
                        {local && <td style={{ padding: 3 }}>{p && categorieNuances(p.categorie) ? <input className="sc-input" value={l.nuance} disabled={recuL} onChange={(e) => setL(i, { nuance: e.target.value })} style={{ ...inputStyle(80), padding: "4px 6px" }} /> : <span style={{ color: TAUPE }}>—</span>}</td>}
                        {local && <td style={{ padding: 3, whiteSpace: "nowrap" }}>{p && produitBookMatch(p.id) ? <><input type="number" min="0" className="sc-input" placeholder="A" value={l.a} disabled={recuL} onChange={(e) => setL(i, { a: e.target.value })} style={{ ...inputStyle(44), padding: "4px 4px" }} /> <input type="number" min="0" className="sc-input" placeholder="B" value={l.b} disabled={recuL} onChange={(e) => setL(i, { b: e.target.value })} style={{ ...inputStyle(44), padding: "4px 4px" }} /></> : <span style={{ color: TAUPE }}>—</span>}</td>}
                        {(local ? estGerant : peutVoirPrixConso) && <td style={{ padding: 3, whiteSpace: "nowrap" }}><input type="number" min="0" step="0.01" className="sc-input" value={l.prix} disabled={recuL} onChange={(e) => setL(i, { prix: e.target.value })} style={{ ...inputStyle(90), padding: "4px 6px", borderColor: t !== null && nombreOuZero(l.prix) > t * (1 + seuilEcartPrixPct() / 100) ? ROUILLE : undefined }} />{t !== null && <span style={{ fontSize: 10, color: TAUPE }}> target {String(t).replace(".", ",")}</span>}</td>}
                        <td style={{ padding: 3 }}>{f.lignes.length > 1 && !recuL && <button type="button" className="sc-btn" onClick={() => set({ lignes: f.lignes.filter((_, j) => j !== i) })} style={iconBtnStyle}>✕</button>}</td>
                      </tr>
                      {(recuL || rsL.length > 0) && (
                        <tr><td colSpan={8} style={{ padding: "0 4px 4px", fontSize: 10 }}>
                          {recuL && <span style={{ color: TAUPE }}>reçu — verrouillé{estGerant && receptionAnnulable(lotL).ok && <> · <span onClick={() => annulerReception(lotL)} style={{ color: ROUILLE, textDecoration: "underline", cursor: "pointer" }}>↶ Annuler la réception</span></>}</span>}
                          {recuL && rsL.length > 0 && " · "}
                          {rsL.length > 0 && <span style={{ color: OCRE }}>réservé : {libReservations(rsL)}</span>}
                        </td></tr>
                      )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
              <button type="button" className="sc-btn" onClick={() => set({ lignes: [...f.lignes, { categorie: (f.lignes[f.lignes.length - 1] || {}).categorie || "", produitId: "", qte: "", prix: "", nuance: "", a: "", b: "" }] })} style={{ ...ghostBtnStyle, padding: "2px 0", fontSize: 12 }}>+ Ajouter une ligne</button>
              {total > 0 && <div style={{ fontSize: 12, marginTop: 6 }}>Total HT des lignes : <b>{formatDH(total)}</b></div>}
              <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>{local ? (f.id ? "Lignes en route : article, quantité, nuance, A/B et prix modifiables, même si le lot est réservé (les réservations restent sur le lot). Une ligne reçue est verrouillée." : "Chaque ligne crée un lot « en arrivage » ; la production le réceptionne (stock réel). Les articles importés passent par l'arrivage import.") : "Chaque ligne entre directement en stock (un lot identique, même fournisseur et même prix, est complété)."}</div>
              {f.erreur && <div style={{ fontSize: 12, color: ROUILLE, marginTop: 8 }}>{f.erreur}</div>}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 12 }}>
                <button type="button" className="sc-btn" onClick={() => setArrivageLots(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={enregistrerArrivageLots} style={primaryBtnStyle}>{f.id ? "Enregistrer les modifications" : "Enregistrer l'arrivage"}</button>
              </div>
            </div>
          </Overlay>
        );
      })()}
      {renderModalesFlotte()}
      {renderModalesEch()}
      {renderModalesPlanning()}
      {showExpo && !expoEdit && peut("expo.gerer") && (() => {
        const tous = (expositions || []);
        const fournisseursExpo = [...new Set(tous.map((e) => e.fournisseur).filter(Boolean))].sort((a, b) => a.localeCompare(b, "fr"));
        const liste = tous.filter((e) => (!expoFiltreF || e.fournisseur === expoFiltreF) && (!expoFiltreStatut || e.statutAvoir === expoFiltreStatut)).sort((a, b) => (a.date < b.date ? 1 : -1));
        const cochables = liste.filter((e) => e.statutAvoir === "a_demander");
        const toutCoche = cochables.length > 0 && cochables.every((e) => expoSel.includes(e.id));
        const totalAttendu = liste.reduce((n, e) => n + avoirAttenduExpo(e).mad, 0);
        const th = { textAlign: "left", fontSize: 10, color: TAUPE, padding: "5px 6px", borderBottom: `1px solid ${PIERRE}` };
        const td = { padding: "5px 6px", verticalAlign: "top" };
        return (
          <Overlay onClose={() => setShowExpo(false)}>
            <div style={modalStyle(960)}>
              <div style={modalTitleStyle}>Tranches en exposition</div>
              <div style={{ fontSize: 12, color: TAUPE, marginBottom: 10 }}>Tranches posées en exposition chez un client : le fournisseur fait un avoir du montant de la tranche. Avoir attendu = prix d'achat fournisseur au coût standard (hors emballage, logistique et frais d'import).</div>
              <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
                <select className="sc-select" value={expoFiltreF} onChange={(e) => { setExpoFiltreF(e.target.value); setExpoSel([]); }} style={{ ...selectStyle, width: 200 }}>
                  <option value="">Tous les fournisseurs</option>
                  {fournisseursExpo.map((f) => (<option key={f} value={f}>{f}</option>))}
                </select>
                <select className="sc-select" value={expoFiltreStatut} onChange={(e) => { setExpoFiltreStatut(e.target.value); setExpoSel([]); }} style={{ ...selectStyle, width: 170 }}>
                  <option value="">Tous les statuts</option>
                  {STATUTS_AVOIR_EXPO.map(([k, lib]) => (<option key={k} value={k}>{lib}</option>))}
                </select>
                <button type="button" className="sc-btn" onClick={() => setExpoEdit(nouvelleExpo())} style={{ ...primaryBtnStyle, marginLeft: "auto" }}>+ Nouvelle exposition</button>
              </div>
              {!liste.length && <div style={{ fontSize: 13, color: TAUPE, marginBottom: 10 }}>{tous.length ? "Aucune ligne pour ces filtres." : "Aucune tranche en exposition enregistrée."}</div>}
              {!!liste.length && (
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12, marginBottom: 10 }}>
                  <thead><tr>
                    <th style={{ ...th, width: 24 }}><input type="checkbox" disabled={!cochables.length} checked={toutCoche} onChange={(e) => setExpoSel(e.target.checked ? cochables.map((x) => x.id) : [])} title="Tout cocher (lignes à demander)" /></th>
                    {["Date", "Commande", "Client", "Fournisseur", "Tranches", "Avoir attendu", "Avoir"].map((h) => <th key={h} style={th}>{h}</th>)}
                  </tr></thead>
                  <tbody>
                    {liste.map((e) => {
                      const c = dossierParId(e.dossierId);
                      const av = avoirAttenduExpo(e);
                      return (
                        <tr key={e.id} onClick={() => setExpoEdit({ ...e, lignes: (e.lignes || []).map((l) => ({ ...l })) })} style={{ cursor: "pointer", borderBottom: `1px solid ${PIERRE}` }}>
                          <td style={td} onClick={(ev) => ev.stopPropagation()}>{e.statutAvoir === "a_demander" && <input type="checkbox" checked={expoSel.includes(e.id)} onChange={(ev) => setExpoSel(ev.target.checked ? [...expoSel, e.id] : expoSel.filter((x) => x !== e.id))} />}</td>
                          <td style={td}>{formatDate(e.date)}</td>
                          <td style={td}>{c ? c.numeroFacture || c.numeroBL || c.numero : "?"}</td>
                          <td style={td}>{(clientDe(e.clientId || (c && c.clientId)) || {}).nom || "—"}</td>
                          <td style={td}>{e.fournisseur}</td>
                          <td style={td}>{(e.lignes || []).map((l, i) => { const a = (articles || []).find((x) => x.id === l.articleId); return <div key={i}>{String(l.qte).replace(".", ",")} × {a ? a.designation || a.nom : "article supprimé"}</div>; })}</td>
                          <td style={{ ...td, whiteSpace: "nowrap" }}>{av.mad > 0 ? formatDH(av.mad) : "—"}{av.devise && av.devise !== "MAD" && av.devise !== "mixte" && av.dev > 0 && <div style={{ color: TAUPE }}>{av.dev.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {av.devise}</div>}{av.manquants > 0 && <div style={{ color: OCRE, fontSize: 11 }}>coût standard manquant ({av.manquants})</div>}</td>
                          <td style={{ ...td, whiteSpace: "nowrap", color: e.statutAvoir === "recu" ? VERT_OK : e.statutAvoir === "demande" ? OCRE : ROUILLE, fontWeight: 600 }}>{libStatutAvoirExpo(e)}{e.statutAvoir === "recu" && <div style={{ fontWeight: 400, color: ENCRE }}>{formatDH(nombreOuZero(e.montantRecu))}</div>}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
              {!!liste.length && <div style={{ fontSize: 12, marginBottom: 10 }}>Total des avoirs attendus (lignes affichées) : <b>{formatDH(totalAttendu)}</b></div>}
              {!!cochables.length && (
                <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", background: PIERRE, borderRadius: 6, padding: "6px 10px", marginBottom: 10, fontSize: 12 }}>
                  <span>{expoSel.length} ligne(s) cochée(s) — marquer comme demandé le</span>
                  <input type="date" className="sc-input" value={expoDateDemande} onChange={(e) => setExpoDateDemande(e.target.value)} style={{ ...inputStyle(150), padding: "4px 6px" }} />
                  <button type="button" className="sc-btn" disabled={!expoSel.length} onClick={() => imprimerDemandeAvoirExpo(expoSel)} style={{ ...ghostBtnStyle, background: "#fff", opacity: expoSel.length ? 1 : 0.5 }}>🖨 Demande d'avoir</button>
                  <button type="button" className="sc-btn" disabled={!expoSel.length} onClick={marquerExposDemandees} style={{ ...primaryBtnStyle, opacity: expoSel.length ? 1 : 0.5 }}>Marquer comme demandé</button>
                </div>
              )}
              <div style={{ display: "flex", justifyContent: "flex-end" }}><button type="button" className="sc-btn" onClick={() => setShowExpo(false)} style={ghostBtnStyle}>Fermer</button></div>
            </div>
          </Overlay>
        );
      })()}
      {expoEdit && peut("expo.gerer") && (() => {
        const e = expoEdit;
        const set = (patch) => setExpoEdit({ ...e, ...patch });
        const dossiersDispo = (commandesListe || []).filter((x) => !x.anterieure).sort((a, b) => String(b.numero).localeCompare(String(a.numero)));
        const nomsF = [...new Set([...(fournisseurs || []).map((f) => f.nom), ...(articles || []).filter((a) => a.categorie === "Tranche" && a.fournisseur).map((a) => a.fournisseur)].filter(Boolean))].sort((a, b) => a.localeCompare(b, "fr"));
        const tranches = tranchesExpoDispo(e.fournisseur);
        const av = avoirAttenduExpo(e);
        return (
          <Overlay onClose={() => setExpoEdit(null)} zIndex={1450}>
            <div style={modalStyle(720)}>
              <div style={modalTitleStyle}>{e.id ? "Tranches en exposition" : "Nouvelle exposition"}</div>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                <Field label="Date de pose"><input type="date" className="sc-input" value={e.date} onChange={(ev) => set({ date: ev.target.value })} style={inputStyle(150)} /></Field>
                <Field label="Commande" style={{ flex: 1, minWidth: 260 }}>
                  <select className="sc-select" value={e.dossierId} onChange={(ev) => set({ dossierId: ev.target.value })} style={{ ...selectStyle, width: "100%" }}>
                    <option value="">— Commande —</option>
                    {dossiersDispo.map((x) => (<option key={x.id} value={x.id}>{x.numeroFacture || x.numeroBL || x.numero} — {(clientDe(x.clientId) || {}).nom || ""} ({x.statut})</option>))}
                  </select>
                </Field>
              </div>
              {(() => {
                const ci = clientExpo(e);
                return (
                  <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                    <Field label="Client exposant (pour la demande d'avoir)" style={{ flex: 1, minWidth: 200 }}><input className="sc-input" value={e.clientNom !== undefined && e.clientNom !== "" ? e.clientNom : ci.nom} onChange={(ev) => set({ clientNom: ev.target.value })} style={inputStyle("100%")} /></Field>
                    <Field label="Adresse de l'exposition" style={{ flex: 2, minWidth: 260 }}><input className="sc-input" value={e.clientAdresse !== undefined && e.clientAdresse !== "" ? e.clientAdresse : ci.adresse} onChange={(ev) => set({ clientAdresse: ev.target.value })} placeholder="adresse du client / du showroom" style={inputStyle("100%")} /></Field>
                  </div>
                );
              })()}
              <Field label="Fournisseur">
                <select className="sc-select" value={e.fournisseur} onChange={(ev) => set({ fournisseur: ev.target.value, lignes: (e.lignes || []).map((l) => { const a = (articles || []).find((x) => x.id === l.articleId); return a && normLib(a.fournisseur || "") !== normLib(ev.target.value) ? { ...l, articleId: "" } : l; }) })} style={{ ...selectStyle, width: 260 }}>
                  <option value="">— Fournisseur —</option>
                  {nomsF.map((f) => (<option key={f} value={f}>{f}</option>))}
                </select>
              </Field>
              <div style={{ fontSize: 12, fontWeight: 600, margin: "6px 0" }}>Tranches</div>
              {(e.lignes || []).map((l, i) => (
                <div key={i} style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 6 }}>
                  <input type="number" min="0" step="1" className="sc-input" value={l.qte} onChange={(ev) => set({ lignes: e.lignes.map((x, j) => (j === i ? { ...x, qte: ev.target.value } : x)) })} style={{ ...inputStyle(60), padding: "5px 6px" }} /> ×
                  <select className="sc-select" value={l.articleId} disabled={!e.fournisseur} onChange={(ev) => set({ lignes: e.lignes.map((x, j) => (j === i ? { ...x, articleId: ev.target.value } : x)) })} style={{ ...selectStyle, flex: 1 }}>
                    <option value="">{e.fournisseur ? "— Tranche —" : "Choisis d'abord le fournisseur"}</option>
                    {tranches.map((a) => (<option key={a.id} value={a.id}>{a.designation || a.nom}</option>))}
                  </select>
                  <button type="button" className="sc-btn" onClick={() => set({ lignes: e.lignes.filter((_, j) => j !== i) })} style={iconBtnStyle}>✕</button>
                </div>
              ))}
              <button type="button" className="sc-btn" onClick={() => set({ lignes: [...(e.lignes || []), { articleId: "", qte: 1 }] })} style={{ ...ghostBtnStyle, padding: "2px 0", fontSize: 12 }}>+ Ajouter une tranche</button>
              <div style={{ fontSize: 12, background: PIERRE, borderRadius: 6, padding: "6px 10px", margin: "8px 0 10px" }}>
                Avoir attendu : <b>{av.mad > 0 ? formatDH(av.mad) : "—"}</b>{av.devise && av.devise !== "MAD" && av.devise !== "mixte" && av.dev > 0 ? ` (${av.dev.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${av.devise})` : ""}
                {av.manquants > 0 && <div style={{ color: OCRE }}>{av.manquants} tranche(s) sans coût standard (Prix et coûts › Calcul de revient, ou provenance / groupe fournisseur de l'article).</div>}
              </div>
              <div style={{ fontSize: 12, fontWeight: 600, margin: "6px 0" }}>Photos de l'exposition</div>
              <div style={{ fontSize: 12, color: TAUPE, border: `1px dashed ${TAUPE}`, borderRadius: 8, padding: "10px 12px", marginBottom: 10 }}>📷 Ajout de photos disponible après la mise en ligne (OVH). En attendant, l'Administration joint les photos à l'envoi de la demande d'avoir.</div>
              <div style={{ fontSize: 12, fontWeight: 600, margin: "6px 0" }}>Avoir fournisseur</div>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end" }}>
                <Field label="Statut" style={{ marginBottom: 0 }}>
                  <select className="sc-select" value={e.statutAvoir} onChange={(ev) => set({ statutAvoir: ev.target.value, ...(ev.target.value === "demande" && !e.dateDemande ? { dateDemande: todayISO() } : {}), ...(ev.target.value === "recu" && !e.dateRecu ? { dateRecu: todayISO() } : {}), ...(ev.target.value === "recu" && String(e.montantRecu ?? "").trim() === "" && av.mad > 0 ? { montantRecu: Math.round(av.mad * 100) / 100 } : {}) })} style={{ ...selectStyle, width: 150 }}>
                    {STATUTS_AVOIR_EXPO.map(([k, lib]) => (<option key={k} value={k}>{lib}</option>))}
                  </select>
                </Field>
                {e.statutAvoir !== "a_demander" && <Field label="Demandé le" style={{ marginBottom: 0 }}><input type="date" className="sc-input" value={e.dateDemande || ""} onChange={(ev) => set({ dateDemande: ev.target.value })} style={inputStyle(150)} /></Field>}
                {e.statutAvoir === "recu" && <Field label="Reçu le" style={{ marginBottom: 0 }}><input type="date" className="sc-input" value={e.dateRecu || ""} onChange={(ev) => set({ dateRecu: ev.target.value })} style={inputStyle(150)} /></Field>}
                {e.statutAvoir === "recu" && <Field label="Montant reçu (DH)" style={{ marginBottom: 0 }}><input type="number" min="0" className="sc-input" value={e.montantRecu ?? ""} onChange={(ev) => set({ montantRecu: ev.target.value })} style={inputStyle(130)} /></Field>}
              </div>
              {e.statutAvoir === "recu" && av.mad > 0 && String(e.montantRecu ?? "").trim() !== "" && Math.abs(nombreOuZero(e.montantRecu) - av.mad) > 0.01 && <div style={{ fontSize: 12, color: OCRE, marginTop: 4 }}>Écart avec l'avoir attendu : {formatDH(nombreOuZero(e.montantRecu) - av.mad)}</div>}
              <Field label="Note" style={{ marginTop: 8 }}><input className="sc-input" value={e.note || ""} onChange={(ev) => set({ note: ev.target.value })} style={inputStyle("100%")} /></Field>
              <div style={{ fontSize: 11, color: TAUPE, marginBottom: 10 }}>Photos de l'exposition : ajoutées à la mise en ligne de l'ERP.</div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                {e.id && <button type="button" className="sc-btn" onClick={() => supprimerExpo(e)} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>Supprimer</button>}
                <button type="button" className="sc-btn" onClick={() => setExpoEdit(null)} style={ghostBtnStyle}>Fermer</button>
                <button type="button" className="sc-btn" onClick={enregistrerExpo} style={primaryBtnStyle}>Enregistrer</button>
              </div>
            </div>
          </Overlay>
        );
      })()}
      {showDeplacements && !deplEdit && (
        <Overlay onClose={() => setShowDeplacements(false)}>
          <div style={modalStyle(860)}>
            <div style={modalTitleStyle}>Déplacements</div>
            <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 10 }}>
              <input type="month" className="sc-input" value={deplMois} onChange={(e) => e.target.value && setDeplMois(e.target.value)} style={{ ...inputStyle(160), padding: "5px 8px" }} />
              <button type="button" className="sc-btn" onClick={() => setDeplEdit(nouveauDeplacement(""))} style={{ ...primaryBtnStyle, marginLeft: "auto" }}>+ Nouveau déplacement</button>
            </div>
            {(() => {
              const liste = (deplacements || []).filter((d) => String(d.date).startsWith(deplMois)).sort((a, b) => (a.date < b.date ? -1 : 1));
              const dues = primesDeplacementDues(deplMois);
              const nonValidees = liste.filter((d) => statutDepl(d) !== "validée").length;
              const verses = versementsPrimesDepl(deplMois);
              const ops1mois = verses.filter((o) => (o.primesDeplMois || []).length === 1);
              const verseMois = ops1mois.reduce((n, o) => n + (Number(o.montant) || 0), 0);
              return (
                <>
                  {!liste.length && <div style={{ fontSize: 13, color: TAUPE, marginBottom: 10 }}>Aucun déplacement en {libPeriode(deplMois)}.</div>}
                  {!!liste.length && (
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12, marginBottom: 10 }}>
                      <thead><tr>{["Dates", "Type", "Zone", "Véhicules", "Dossiers", "Personnes", "Statut", ...(estGerant ? ["Coût"] : [])].map((h) => <th key={h} style={{ textAlign: "left", fontSize: 10, color: TAUPE, padding: "5px 6px", borderBottom: `1px solid ${PIERRE}` }}>{h}</th>)}</tr></thead>
                      <tbody>
                        {liste.map((d) => (
                          <tr key={d.id} onClick={() => setDeplEdit({ ...d })} style={{ cursor: "pointer", borderBottom: `1px solid ${PIERRE}` }}>
                            <td style={{ padding: "5px 6px", whiteSpace: "nowrap" }}>{formatDate(d.date)}{d.dateFin && d.dateFin > d.date ? ` → ${formatDate(d.dateFin)}` : ""}</td>
                            <td style={{ padding: "5px 6px" }}>{d.type}</td>
                            <td style={{ padding: "5px 6px" }}>{(zoneDe(d.zoneId) || {}).nom || "?"}</td>
                            <td style={{ padding: "5px 6px" }}>{(d.vehicules || []).map((v) => (v.vehiculeId ? (vehiculeParId(v.vehiculeId) || {}).nom || "?" : `${nombreOuZero(v.nb) || 1} × ${v.type === "rdm" ? "léger" : "livraison"}`)).join(", ")}</td>
                            <td style={{ padding: "5px 6px" }}>{(d.dossiers || []).map((id) => { const c = dossierParId(id); return c ? c.numeroFacture || c.numeroBL || c.numero : "?"; }).join(", ")}</td>
                            <td style={{ padding: "5px 6px" }}>{(d.participants || []).map((x) => ((staff || []).find((y) => y.id === x.staffId) || {}).nom || "?").join(", ")}</td>
                            <td style={{ padding: "5px 6px", color: statutDepl(d) === "validée" ? VERT_OK : statutDepl(d) === "à valider" ? OCRE : TAUPE, whiteSpace: "nowrap" }}>{statutDepl(d)}{avanceDepl(d) && !reglementDepl(d) ? " · avance à solder" : ""}</td>
                            {estGerant && <td style={{ padding: "5px 6px", fontWeight: 600 }}>{formatDH(coutDeplacement(d).total)}</td>}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                  {nonValidees > 0 && <div style={{ fontSize: 12, color: OCRE, marginBottom: 6 }}>{nonValidees} fiche(s) pas encore validée(s) par le Gérant : leurs primes ne sont pas encore comptées.</div>}
                  {!!Object.keys(dues.parPers).length && (
                    <div style={{ fontSize: 12, background: PIERRE, borderRadius: 6, padding: "6px 10px", marginBottom: 10 }}>
                      <b>Primes de déplacement de {libPeriode(deplMois)}</b> : {Object.values(dues.parPers).map((p) => `${p.nom} ${p.jours} j${estGerant ? ` (${formatDH(p.montant)})` : ""}`).join(" · ")}
                      {estGerant && <> — total <b>{formatDH(dues.total)}</b></>}
                      <div style={{ marginTop: 4, color: verses.length ? TAUPE : OCRE }}>
                        {verses.length ? `Versées : ${verses.map((o) => `${formatDate(o.date)}${estGerant ? ` ${formatDH(Number(o.montant) || 0)}` : ""}${(o.primesDeplMois || []).length > 1 ? ` (versement groupé ${o.primesDeplMois.map(libPeriode).join(" + ")})` : ""}`).join(", ")}` : "À verser (Trésorerie › Caisse Nils › Frais salariaux › Prime de déplacement)."}
                      </div>
                      {estGerant && ops1mois.length === verses.length && verses.length > 0 && Math.abs(verseMois - dues.total) > 0.01 && <div style={{ color: ROUILLE, marginTop: 2 }}>Écart : versé {formatDH(verseMois)} pour {formatDH(dues.total)} dû — une fiche a été modifiée après le versement.</div>}
                    </div>
                  )}
                </>
              );
            })()}
            <div style={{ display: "flex", justifyContent: "flex-end" }}><button type="button" className="sc-btn" onClick={() => setShowDeplacements(false)} style={ghostBtnStyle}>Fermer</button></div>
          </div>
        </Overlay>
      )}
      {deplEdit && (() => {
        const d = deplEdit;
        const set = (patch) => setDeplEdit({ ...d, ...patch });
        const zones = transportCouts().zones || [];
        const z = zoneDe(d.zoneId);
        const cout = coutDeplacement(d);
        const dossiersDispo = (commandesListe || []).filter((c) => !c.anterieure && (!["Facture"].includes(c.statut) || (d.dossiers || []).includes(c.id) || d.type === "SAV")).sort((a, b) => String(b.numero).localeCompare(String(a.numero)));
        const staffDispo = (staff || []).filter((x) => staffActif(x) && !ficheStaffMasquee(x)).sort((a, b) => a.nom.localeCompare(b.nom, "fr"));
        // ERP step 15 (al) : départ / retour → jours de prime (sauf personne corrigée à la main), nuits.
        const nbJ = nbJoursPeriode(d.date, d.dateFin || d.date);
        const majDates = (deb, fin) => { const n = nbJoursPeriode(deb, fin); set({ date: deb, dateFin: fin, participants: (d.participants || []).map((x) => (x.joursAuto === false || x.sansPrime ? x : { ...x, jours: n })) }); };
        const sauvee = d.id ? (deplacements || []).find((x) => x.id === d.id) : null;
        const statut = sauvee ? statutDepl(sauvee) : "en cours";
        const verrou = statut === "validée" && !estGerant;
        const av = sauvee ? avanceDepl(sauvee) : null;
        const reg = sauvee ? reglementDepl(sauvee) : null;
        const depenses = totalFraisDepl(d);
        const fraisModifies = sauvee && totalFraisDepl(sauvee) !== depenses;
        const conflits = (d.participants || []).some((x) => x.staffId) ? conflitsPointageDepl(d) : [];
        return (
          <Overlay onClose={() => setDeplEdit(null)} zIndex={1450}>
            <div style={modalStyle(720)}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={modalTitleStyle}>{d.id ? "Déplacement" : "Nouveau déplacement"}</div>
                {sauvee && <span style={{ fontSize: 11, fontWeight: 700, borderRadius: 10, padding: "2px 8px", background: statut === "validée" ? "#E4EBE4" : statut === "à valider" ? "#F3ECDD" : PIERRE, color: statut === "validée" ? VERT_OK : statut === "à valider" ? OCRE : TAUPE, marginBottom: 14 }}>{statut === "validée" ? `validée${sauvee.validePar ? ` par ${sauvee.validePar}` : ""}` : statut}</span>}
              </div>
              {verrou && <div style={{ fontSize: 12, color: OCRE, marginBottom: 8 }}>Fiche validée par le Gérant : lecture seule.</div>}
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                <Field label="Départ"><input type="date" className="sc-input" value={d.date} disabled={verrou} onChange={(e) => majDates(e.target.value, d.dateFin && d.dateFin >= e.target.value ? d.dateFin : e.target.value)} style={inputStyle(150)} /></Field>
                <Field label="Retour"><input type="date" className="sc-input" value={d.dateFin || d.date} min={d.date} disabled={verrou} onChange={(e) => majDates(d.date, e.target.value)} style={inputStyle(150)} /></Field>
                <Field label="Type">
                  <select className="sc-select" value={d.type} onChange={(e) => set({ type: e.target.value })} style={{ ...selectStyle, width: 140 }}>{TYPES_DEPLACEMENT.map((t) => (<option key={t} value={t}>{t}</option>))}</select>
                </Field>
                <Field label="Zone">
                  <select className="sc-select" value={d.zoneId} onChange={(e) => set({ zoneId: e.target.value })} style={{ ...selectStyle, width: 180 }}>
                    <option value="">— Zone —</option>
                    {zones.map((x) => (<option key={x.id} value={x.id}>{x.nom}</option>))}
                  </select>
                </Field>
              </div>
              <div style={{ fontSize: 12, fontWeight: 600, margin: "6px 0" }}>Véhicules</div>
              {(d.vehicules || []).map((v, i) => (v.vehiculeId !== undefined || !v.type ? (
                <div key={i} style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 6 }}>
                  <select className="sc-select" value={v.vehiculeId || ""} onChange={(e) => set({ vehicules: d.vehicules.map((x, j) => (j === i ? { vehiculeId: e.target.value } : x)) })} style={{ ...selectStyle, width: 260 }}>
                    <option value="">— Véhicule —</option>
                    {vehiculesFlotte().filter((x) => x.actif !== false || x.id === v.vehiculeId).map((x) => (<option key={x.id} value={x.id}>{x.nom}{x.immat ? ` (${x.immat})` : ""} — {x.type === "livraison" ? "livraison" : "léger"}</option>))}
                  </select>
                  {v.vehiculeId && <input type="number" min="0" className="sc-input" aria-label="km parcourus" placeholder="km parcourus" value={v.km ?? ""} onChange={(e) => set({ vehicules: d.vehicules.map((x, j) => (j === i ? { ...x, km: e.target.value } : x)) })} style={{ ...inputStyle(110), padding: "5px 6px" }} />}
                  {estGerant && v.vehiculeId && (() => { const cv = coutVehiculeDepl(d, z || { km: 0, peage: 0 }, v); return <span style={{ fontSize: 11, color: TAUPE }}>{formatDH(cv.total)} {cv.km ? `(${cv.km} km × ${fmtMAD(cv.parKm)} DH${cv.peage ? ` + péage ${formatDH(cv.peage)}` : ""}${cv.source === "theorique" ? ", coût théorique" : cv.source === "reel12" ? ", coût réel 12 mois" : ", paramètres du type"})` : `(forfait de la zone${cv.source === "theorique" ? ", coût théorique" : cv.source === "reel12" ? ", coût réel 12 mois" : ", paramètres du type"} — saisis les km pour le coût réel)`}</span>; })()}
                  <button type="button" className="sc-btn" onClick={() => set({ vehicules: d.vehicules.filter((_, j) => j !== i) })} style={iconBtnStyle}>✕</button>
                </div>
              ) : (
                <div key={i} style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 6 }}>
                  <input type="number" min="1" className="sc-input" value={v.nb} onChange={(e) => set({ vehicules: d.vehicules.map((x, j) => (j === i ? { ...x, nb: e.target.value } : x)) })} style={{ ...inputStyle(60), padding: "5px 6px" }} /> ×
                  <select className="sc-select" value={v.type} onChange={(e) => set({ vehicules: d.vehicules.map((x, j) => (j === i ? { ...x, type: e.target.value } : x)) })} style={{ ...selectStyle, width: 220 }}>
                    <option value="livraison">{(transportCouts().vehicules.livraison || {}).nom || "Camion de livraison"}</option>
                    <option value="rdm">{(transportCouts().vehicules.rdm || {}).nom || "Véhicule léger"}</option>
                  </select>
                  <span style={{ fontSize: 11, color: TAUPE }}>ancienne saisie</span>
                  <button type="button" className="sc-btn" onClick={() => set({ vehicules: d.vehicules.filter((_, j) => j !== i) })} style={iconBtnStyle}>✕</button>
                </div>
              )))}
              <button type="button" className="sc-btn" onClick={() => set({ vehicules: [...(d.vehicules || []), vehiculesFlotte().length ? { vehiculeId: "" } : { type: "rdm", nb: 1 }] })} style={{ ...ghostBtnStyle, padding: "2px 0", fontSize: 12 }}>+ Ajouter un véhicule</button>

              <div style={{ fontSize: 12, fontWeight: 600, margin: "10px 0 6px" }}>Dossiers servis {d.dossiers && d.dossiers.length > 1 ? "(coût partagé à parts égales)" : ""}</div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 6 }}>
                {(d.dossiers || []).map((id) => { const c = dossierParId(id); return (
                  <span key={id} style={{ fontSize: 12, background: PIERRE, borderRadius: 12, padding: "2px 4px 2px 10px", display: "inline-flex", gap: 4, alignItems: "center" }}>{c ? `${c.numeroFacture || c.numeroBL || c.numero} — ${(clientDe(c.clientId) || {}).nom || ""}` : "?"}
                    <button type="button" className="sc-btn" onClick={() => set({ dossiers: d.dossiers.filter((x) => x !== id) })} style={{ ...iconBtnStyle, width: 18, height: 18, fontSize: 11 }}>✕</button></span>
                ); })}
              </div>
              <select className="sc-select" value="" onChange={(e) => e.target.value && set({ dossiers: [...new Set([...(d.dossiers || []), e.target.value])] })} style={{ ...selectStyle, width: "100%", marginBottom: 8 }}>
                <option value="">+ Ajouter un dossier…</option>
                {dossiersDispo.filter((c) => !(d.dossiers || []).includes(c.id)).map((c) => (<option key={c.id} value={c.id}>{c.numeroFacture || c.numeroBL || c.numero} — {(clientDe(c.clientId) || {}).nom || ""} ({c.statut})</option>))}
              </select>

              <div style={{ fontSize: 12, fontWeight: 600, margin: "6px 0" }}>Personnes et primes de déplacement</div>
              {(d.participants || []).map((x, i) => (
                <div key={i} style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 6 }}>
                  <select className="sc-select" value={x.staffId} onChange={(e) => set({ participants: d.participants.map((y, j) => (j === i ? { ...y, staffId: e.target.value } : y)) })} style={{ ...selectStyle, width: 240 }}>
                    <option value="">— Personne —</option>
                    {staffDispo.map((p) => (<option key={p.id} value={p.id}>{p.nom}</option>))}
                  </select>
                  <input type="number" min="0.5" step="0.5" disabled={!!x.sansPrime} className="sc-input" value={x.sansPrime ? "" : x.jours ?? 1} onChange={(e) => set({ participants: d.participants.map((y, j) => (j === i ? { ...y, jours: e.target.value, joursAuto: false } : y)) })} style={{ ...inputStyle(60), padding: "5px 6px", opacity: x.sansPrime ? 0.4 : 1 }} /> jour(s)
                  <label style={{ fontSize: 12, display: "inline-flex", gap: 4, alignItems: "center", cursor: "pointer" }}><input type="checkbox" checked={!!x.sansPrime} onChange={(e) => set({ participants: d.participants.map((y, j) => (j === i ? { ...y, sansPrime: e.target.checked } : y)) })} /> sans prime</label>
                  {estGerant && <span style={{ fontSize: 12, color: TAUPE, minWidth: 70 }}>{formatDH(primeParticipant(d, x))}</span>}
                  <button type="button" className="sc-btn" onClick={() => set({ participants: d.participants.filter((_, j) => j !== i) })} style={iconBtnStyle}>✕</button>
                </div>
              ))}
              <button type="button" className="sc-btn" onClick={() => set({ participants: [...(d.participants || []), { staffId: "", jours: nbJ, sansPrime: true }] })} style={{ ...ghostBtnStyle, padding: "2px 0", fontSize: 12 }}>+ Ajouter une personne</button>
              <div style={{ fontSize: 11, color: TAUPE }}>Une prime par jour de déplacement{estGerant ? ` (${formatDH(tauxPrimeDeplacementAu(d.date))} / jour)` : ""}, à partir de la date du déplacement. « Sans prime » pour les villes qui n'y donnent pas droit. Une seule prime par personne et par jour.</div>

              {nbJ > 1 && <div style={{ fontSize: 11, color: TAUPE, marginTop: 2 }}>{nbJ} jours, {nbJ - 1} nuit(s). Les jours de prime suivent les dates, sauf pour une personne corrigée à la main.</div>}
              {!!conflits.length && <div style={{ fontSize: 12, color: ROUILLE, marginTop: 4 }}>Pointage déjà saisi sur des jours du déplacement : {conflits.slice(0, 6).map((c) => `${c.nom} ${c.lib.toLowerCase()} le ${formatDate(c.date)}`).join(" ; ")}{conflits.length > 6 ? "…" : ""}</div>}
              <div style={{ fontSize: 11, color: TAUPE, marginTop: 2 }}>Les jours ouvrés du déplacement s'ajoutent au pointage des participants (code D, journée normale), sauf les cases déjà saisies. Jours de prime par demi-journée (0,5 ; 1 ; 1,5…).</div>
              <div style={{ fontSize: 12, color: OCRE, fontWeight: 600, marginTop: 4 }}>Rappel : un retour de chantier après 22 h donne droit à une demi-journée de récupération (code « RT » au pointage).</div>
              <div style={{ fontSize: 12, fontWeight: 600, margin: "10px 0 6px" }}>Dépenses réelles {av ? "(justifiées au retour, payées avec l'avance)" : "(hors forfait véhicule)"}</div>
              {(() => {
                const deps = depensesDepl(d);
                const majDeps = (liste) => set({ depenses: liste, frais: undefined });
                return (
                  <div>
                    {deps.map((x, k) => (
                      <div key={x.id || k} style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 6, flexWrap: "wrap" }}>
                        <select className="sc-select" aria-label="Type de dépense" value={x.type || "Autre"} onChange={(e) => majDeps(deps.map((y, m) => (m === k ? { ...y, type: e.target.value } : y)))} style={{ ...selectStyle, width: 190 }}>
                          {TYPES_DEPENSE_DEPL.map((t) => <option key={t} value={t}>{t}</option>)}
                        </select>
                        <input className="sc-input" placeholder="libellé (facultatif)" value={x.libelle || ""} onChange={(e) => majDeps(deps.map((y, m) => (m === k ? { ...y, libelle: e.target.value } : y)))} style={{ ...inputStyle(200), padding: "6px 8px" }} />
                        <input type="number" min="0" className="sc-input" aria-label="Montant (DH)" placeholder="montant (DH)" value={x.montant ?? ""} onChange={(e) => majDeps(deps.map((y, m) => (m === k ? { ...y, montant: e.target.value } : y)))} style={{ ...inputStyle(120), padding: "6px 8px" }} />
                        <button type="button" className="sc-btn" onClick={() => majDeps(deps.filter((_, m) => m !== k))} style={iconBtnStyle}>✕</button>
                      </div>
                    ))}
                    <button type="button" className="sc-btn" onClick={() => majDeps([...deps, { id: uid(), type: "Parking", libelle: "", montant: "" }])} style={{ ...ghostBtnStyle, padding: "2px 0", fontSize: 12 }}>+ Ajouter une dépense</button>
                    {deps.some((x) => x.type === "Carburant hors carte" && nombreOuZero(x.montant) > 0) && <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Carburant payé en espèces : saisis aussi le ticket au relevé du vendredi (« payé hors carte ») pour la consommation du véhicule.</div>}
                  </div>
                );
              })()}
              <Field label="Note" style={{ marginTop: 8 }}><input className="sc-input" value={d.note || ""} onChange={(e) => set({ note: e.target.value })} style={inputStyle("100%")} /></Field>
              {sauvee && (
                <div style={{ fontSize: 12, border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "8px 10px", marginBottom: 10 }}>
                  <div style={{ fontWeight: 600, marginBottom: 4 }}>Avance de frais (caisse usine)</div>
                  {!av && <div style={{ color: TAUPE }}>Aucune avance remise.{peutCaisseAvance() && statut !== "validée" && <button type="button" className="sc-btn" onClick={() => setDeplAvance({ depId: sauvee.id, montant: "", beneficiaireId: ((sauvee.participants || [])[0] || {}).staffId || "", date: todayISO() })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 8px", marginLeft: 8 }}>Remettre une avance…</button>}</div>}
                  {av && (<>
                    <div>{formatDH(nombreOuZero(av.montant))} remis à <b>{av.tiers}</b> le {formatDate(av.date)}. Dépenses justifiées : {formatDH(depenses)} → {nombreOuZero(av.montant) - depenses > 0.004 ? `${av.tiers} rend ${formatDH(nombreOuZero(av.montant) - depenses)}` : nombreOuZero(av.montant) - depenses < -0.004 ? `on lui doit ${formatDH(depenses - nombreOuZero(av.montant))}` : "rien à rendre"}.</div>
                    {reg ? <div style={{ color: VERT_OK, marginTop: 2 }}>✓ Soldée le {formatDate(reg.date)}{nombreOuZero(reg.montant) ? ` (${reg.sens === "entree" ? "rendu" : "remboursé"} ${formatDH(nombreOuZero(reg.montant))})` : ""}.</div>
                      : peutCaisseAvance() && (fraisModifies ? <div style={{ color: OCRE, marginTop: 2 }}>Enregistre la fiche avant de solder l'avance.</div> : <button type="button" className="sc-btn" onClick={() => solderAvanceDepl(sauvee)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 8px", marginTop: 4 }}>Solder l'avance</button>)}
                  </>)}
                </div>
              )}
              {estGerant && <div style={{ fontSize: 12, background: PIERRE, borderRadius: 6, padding: "6px 10px", marginBottom: 10 }}>Coût : véhicules {formatDH(cout.veh)} + primes {formatDH(cout.primes)} + frais {formatDH(cout.frais)} = <b>{formatDH(cout.total)}</b>{(d.dossiers || []).length > 1 ? ` (${formatDH(cout.total / d.dossiers.length)} par dossier)` : ""}</div>}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                {d.id && peut("deplacements.saisir") && !verrou && <button type="button" className="sc-btn" onClick={() => supprimerDeplacement(d)} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>Supprimer</button>}
                <button type="button" className="sc-btn" onClick={() => setDeplEdit(null)} style={ghostBtnStyle}>Fermer</button>
                {sauvee && statut === "en cours" && peut("deplacements.saisir") && <button type="button" className="sc-btn" onClick={() => changerStatutDepl(sauvee, "à valider")} style={ghostBtnStyle} title="Après le retour : dépenses saisies et avance soldée">Retour terminé — envoyer au Gérant</button>}
                {sauvee && estGerant && statut !== "validée" && <button type="button" className="sc-btn" onClick={() => changerStatutDepl(sauvee, "validée")} style={{ ...ghostBtnStyle, color: VERT_OK }}>✓ Valider</button>}
                {sauvee && estGerant && statut === "validée" && <button type="button" className="sc-btn" onClick={() => changerStatutDepl(sauvee, "en cours")} style={ghostBtnStyle}>Rouvrir</button>}
                {peut("deplacements.saisir") && !verrou && <button type="button" className="sc-btn" onClick={enregistrerDeplacement} style={primaryBtnStyle}>Enregistrer</button>}
              </div>
            </div>
          </Overlay>
        );
      })()}
      {paiementCom && (
        <Overlay onClose={() => setPaiementCom(null)} zIndex={1500}>
          <div style={modalStyle(440)}>
            <div style={modalTitleStyle}>Verser la commission</div>
            <div style={{ fontSize: 13, marginBottom: 12 }}>{paiementCom.nom} — {paiementCom.libelle} — {libPeriode(paiementCom.per)}</div>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <Field label="Montant (DH)"><input type="number" className="sc-input" value={paiementCom.montant} onChange={(e) => setPaiementCom({ ...paiementCom, montant: e.target.value })} style={inputStyle(130)} /></Field>
              <Field label="Date"><input type="date" className="sc-input" value={paiementCom.date} onChange={(e) => setPaiementCom({ ...paiementCom, date: e.target.value })} style={inputStyle(150)} /></Field>
            </div>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <Field label="Payé depuis">
                <select className="sc-select" value={paiementCom.compteId} onChange={(e) => setPaiementCom({ ...paiementCom, compteId: e.target.value })} style={{ ...selectStyle, width: 200 }}>
                  <option value="">— Choisir —</option>
                  {(comptesTreso || []).filter((c) => caissesCommission(paiementCom.personneId).includes(c.id)).map((c) => (<option key={c.id} value={c.id}>{c.nom}</option>))}
                </select>
              </Field>
              <Field label="Mode">
                <select className="sc-select" value={paiementCom.mode} onChange={(e) => setPaiementCom({ ...paiementCom, mode: e.target.value })} style={{ ...selectStyle, width: 150 }}>
                  {["Virement", "Espèces", "Chèque"].map((m) => (<option key={m} value={m}>{m}</option>))}
                </select>
              </Field>
            </div>
            <div style={{ fontSize: 11, color: TAUPE, marginBottom: 12 }}>Crée une sortie en trésorerie, poste Commissions › Commissions versées, reliée à cette commission. Un versement partiel est possible.</div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
              <button type="button" className="sc-btn" onClick={() => setPaiementCom(null)} style={ghostBtnStyle}>Annuler</button>
              <button type="button" className="sc-btn" onClick={payerCommission} style={primaryBtnStyle}>Enregistrer le versement</button>
            </div>
          </div>
        </Overlay>
      )}
      {exportGrille && (
        <Overlay onClose={() => setExportGrille(null)} zIndex={1500}>
          <div style={modalStyle(460)}>
            <div style={modalTitleStyle}>Exporter la grille tarifaire</div>
            <Field label="Matière">
              <select className="sc-select" value={exportGrille.matiere} onChange={(e) => { const m = e.target.value; const pr = profilsRevient().find((p) => p.type === "tranches" && p.matiere === m); setExportGrille({ ...exportGrille, matiere: m, surfaces: Object.fromEntries((EPAISSEURS_PAR_MATIERE[m] || []).map((ep) => [ep, pr && nombreOuZero((pr.surfaces || {})[ep]) ? String(pr.surfaces[ep]) : exportGrille.surfaces[ep] || "5.25"])) }); }} style={selectStyle}>
                {MATIERES.map((m) => (<option key={m} value={m}>{m}</option>))}
              </select>
            </Field>
            <div style={{ display: "flex", gap: 12 }}>
              <Field label="Remise (%) — 0 = tarif public"><input type="number" min="0" max="99" className="sc-input" value={exportGrille.remise} onChange={(e) => setExportGrille({ ...exportGrille, remise: e.target.value })} style={inputStyle(120)} /></Field>
              <Field label="Émise le"><input type="date" className="sc-input" value={exportGrille.date} onChange={(e) => setExportGrille({ ...exportGrille, date: e.target.value })} style={inputStyle(160)} /></Field>
            </div>
            <Field label="Surface d'une tranche (m²) — pour les colonnes « par tranche »">
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                {Object.keys(exportGrille.surfaces || {}).map((ep) => (
                  <label key={ep} style={{ fontSize: 12, display: "flex", gap: 4, alignItems: "center" }}>{ep}<input type="number" step="0.01" className="sc-input" value={exportGrille.surfaces[ep]} onChange={(e) => setExportGrille({ ...exportGrille, surfaces: { ...exportGrille.surfaces, [ep]: e.target.value } })} style={{ ...inputStyle(80), padding: "5px 6px" }} /></label>
                ))}
              </div>
            </Field>
            <div style={{ fontSize: 11, color: TAUPE, marginBottom: 12 }}>Prix tirés de la grille ci-dessus (prix publics HT au m²), remise appliquée, TVA {Math.round(TVA_TAUX * 100)} %. Seules les lignes qui ont un prix sont imprimées.</div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
              <button type="button" className="sc-btn" onClick={() => setExportGrille(null)} style={ghostBtnStyle}>Annuler</button>
              <button type="button" className="sc-btn" onClick={exporterGrille} style={primaryBtnStyle}>Exporter</button>
            </div>
          </div>
        </Overlay>
      )}
      {apercuGrille && (
        <Overlay onClose={() => setApercuGrille(null)} zIndex={1500}>
          <div style={modalStyle(640)}>
            <div style={modalTitleStyle}>Appliquer à la Grille tarifaire</div>
            {!apercuGrille.lignes.length ? (
              <div style={{ fontSize: 13, color: TAUPE, marginBottom: 14 }}>Rien à appliquer : vérifie les groupes tarifaires cibles et que les épaisseurs existent pour cette matière.</div>
            ) : (
              <div style={{ maxHeight: 420, overflowY: "auto", marginBottom: 14 }}>
                <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 12 }}>
                  <thead><tr>{["Matière", "Choix", "Groupe", "Actuel / m²", "Nouveau / m²", "Écart"].map((h, i) => <th key={h} style={{ textAlign: i < 3 ? "left" : "right", fontSize: 10, color: TAUPE, padding: "4px 6px", borderBottom: `1px solid ${PIERRE}` }}>{h}</th>)}</tr></thead>
                  <tbody>
                    {apercuGrille.lignes.map((l, i) => (
                      <tr key={i} style={{ background: l.doublon ? "#F5E4DE" : "transparent" }}>
                        <td style={{ padding: "4px 6px" }}>{l.matiere} {l.ep}</td>
                        <td style={{ padding: "4px 6px" }}>{l.ch === 2 ? "2e" : "1er"}</td>
                        <td style={{ padding: "4px 6px" }}>Groupe {l.gERP}{l.doublon ? " ⚠ doublon" : ""}</td>
                        <td style={{ padding: "4px 6px", textAlign: "right" }}>{l.actuel === null ? "—" : fmtMAD(l.actuel)}</td>
                        <td style={{ padding: "4px 6px", textAlign: "right", fontWeight: 700 }}>{fmtMAD(l.nouveau)}</td>
                        <td style={{ padding: "4px 6px", textAlign: "right", color: l.actuel === null ? TAUPE : l.nouveau >= l.actuel ? VERT_OK : ROUILLE }}>{l.actuel === null ? "—" : `${l.nouveau >= l.actuel ? "+" : ""}${(((l.nouveau - l.actuel) / (l.actuel || 1)) * 100).toFixed(1).replace(".", ",")} %`}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {apercuGrille.lignes.some((l) => l.doublon) && <div style={{ fontSize: 11, color: ROUILLE, marginTop: 6 }}>⚠ Plusieurs groupes fournisseur vont vers le même groupe tarifaire : c'est la dernière ligne qui l'emporte.</div>}
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
              <button type="button" className="sc-btn" onClick={() => setApercuGrille(null)} style={ghostBtnStyle}>Annuler</button>
              {!!apercuGrille.lignes.length && <button type="button" className="sc-btn" onClick={appliquerApercuGrille} style={primaryBtnStyle}>Appliquer {apercuGrille.lignes.length} prix</button>}
            </div>
          </div>
        </Overlay>
      )}

      {confirmationTransformation && (
        // z-index relevé : cette confirmation se déclenche par-dessus une
        // fiche déjà ouverte (devis ou dossier), qui est elle-même un
        // Overlay défini plus loin dans ce fichier — sans ça, l'ordre
        // d'apparition dans le JSX la ferait passer derrière.
        <Overlay onClose={() => setConfirmationTransformation(null)} zIndex={60}>
          <div style={modalStyle(380)}>
            <div style={modalTitleStyle}>Confirmation</div>
            {(() => {
              // Le cas « mauvais payeur » (et les autres vérifications de paiement)
              // s'affiche dans la liste casPaiement ci-dessous.
              if (confirmationTransformation.irreversible) {
                return (
                  <div style={{ fontSize: 14, marginBottom: 20, lineHeight: 1.5 }}>
                    ⚠ Action irréversible : une fois transformé en <strong>{confirmationTransformation.label}</strong>, il ne sera plus possible de revenir à l'étape précédente (la numérotation devient définitive). Es-tu sûr de vouloir transformer ?
                    {confirmationTransformation.label === "Facture" && (
                      <div style={{ marginTop: 12, fontSize: 13, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                        Date de la facture :
                        <input type="date" className="sc-input" value={dateFactureChoisie} max={todayISO()} min={minDateFacture(commandeEditing)} onChange={(e) => { const v = e.target.value; const ok = v && v <= todayISO() && v >= minDateFacture(commandeEditing); const d = ok ? v : todayISO(); setDateFactureChoisie(d); dateFactureRef.current = d; }} style={{ ...inputStyle(150), padding: "4px 8px" }} />
                        <span style={{ fontSize: 11, color: TAUPE, width: "100%" }}>Aujourd'hui par défaut ; jusqu'à {JOURS_ANTIDATE_FACTURE} jours en arrière, jamais dans le futur, ni avant la dernière facture émise ni avant le BL. C'est la date imprimée sur la facture.</span>
                      </div>
                    )}
                  </div>
                );
              }
              const nCas = (confirmationTransformation.casPaiement || []).filter((c) => c.cle !== "logistique").length;
              const nLog = (confirmationTransformation.casPaiement || []).length - nCas;
              return (
                <div style={{ fontSize: 14, marginBottom: 16, lineHeight: 1.5 }}>
                  {nCas ? <>⚠ Vérification{nLog ? "s" : " du paiement"} avant le passage en <strong>{confirmationTransformation.label}</strong> :</> : nLog ? <>⚠ Vérification avant le passage en <strong>{confirmationTransformation.label}</strong> :</> : null}
                  {nCas || nLog ? null : <>Transformer ce dossier en <strong>{confirmationTransformation.label}</strong> ?</>}
                </div>
              );
            })()}
            {confirmationTransformation.exigeVerifPaiement && (() => {
              const cas = confirmationTransformation.casPaiement || [];
              const coches = confirmationVerifPaiement && typeof confirmationVerifPaiement === "object" ? confirmationVerifPaiement : {};
              const cl = clientDe(confirmationTransformation.clientId);
              return (
                <div style={{ marginBottom: 16 }}>
                  {cas.map((c) => (
                    <div key={c.cle} style={{ background: c.cle === "nonrenseigne" ? "#F5EFE0" : "#F5E4DE", borderRadius: 8, padding: 12, marginBottom: 8 }}>
                      <div style={{ fontSize: 13, color: c.cle === "nonrenseigne" ? OCRE : ROUILLE, fontWeight: 700, marginBottom: 4 }}>⚠ {c.titre}</div>
                      <div style={{ fontSize: 12, color: ENCRE, marginBottom: 8 }}>{c.detail}</div>
                      <label style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: 13, cursor: "pointer" }}>
                        <input type="checkbox" checked={!!coches[c.cle]} onChange={(e) => setConfirmationVerifPaiement({ ...coches, [c.cle]: e.target.checked })} style={{ marginTop: 2 }} />
                        {c.coche}
                      </label>
                    </div>
                  ))}
                  {cl && peutVoirEtatClient(cl) && cas.some((c) => c.cle !== "nonrenseigne" && c.cle !== "logistique") && (
                    <button type="button" className="sc-btn" onClick={() => setEtatClientModal({ clientId: cl.id, exo: false, au: todayISO(), avecSoldes: false })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0" }}>📄 Voir l'état de compte de {cl.nom}</button>
                  )}
                  {cas.some((c) => c.cle !== "nonrenseigne") && !estGerant && <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Le Gérant sera alerté si tu confirmes.</div>}
                </div>
              );
            })()}
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button type="button" className="sc-btn" onClick={() => setConfirmationTransformation(null)} style={ghostBtnStyle}>Annuler</button>
              <button
                type="button"
                className="sc-btn"
                onClick={confirmerTransformation}
                disabled={confirmationTransformation.exigeVerifPaiement && !(confirmationTransformation.casPaiement || []).every((c) => confirmationVerifPaiement && confirmationVerifPaiement[c.cle])}
                style={confirmationTransformation.exigeVerifPaiement && !(confirmationTransformation.casPaiement || []).every((c) => confirmationVerifPaiement && confirmationVerifPaiement[c.cle]) ? { ...primaryBtnStyle, opacity: 0.5, cursor: "not-allowed" } : primaryBtnStyle}
              >
                Confirmer la transformation
              </button>
            </div>
          </div>
        </Overlay>
      )}

      {showCommandeFiche && commandeEditing && (
        <Overlay onClose={fermerCommandeFiche}>
          {/* ERP step 7 : élargie de 460 à 640px. Les sections les plus
              chargées (lignes, éléments techniques, fiche de pose, pièces
              jointes) ont chacune leur propre fenêtre plus large, ouverte par
              bouton — la fiche dossier elle-même reste volontairement simple
              (demande le Gérant), donc pas besoin d'une largeur de type devis ici. */}
          <div style={modalStyle(640)}>
            {(() => {
              const etapeActuelle = ETAPES_COMMANDE.find((e) => e.statut === commandeEditing.statut);
              const numeroAffiche = (etapeActuelle && commandeEditing[etapeActuelle.champ]) || commandeEditing.numero;
              return (
                <div style={modalTitleStyle}>Dossier {numeroAffiche}{commandeEditing.reference ? ` — ${commandeEditing.reference}` : ""}</div>
              );
            })()}

            {(() => {
              const devis = (devisListe || []).find((d) => d.id === commandeEditing.devisId);
              const client = clientsActifs.find((x) => x.id === commandeEditing.clientId);
              const indexActuel = ETAPES_COMMANDE.findIndex((e) => e.statut === commandeEditing.statut);
              const etapesPrecedentes = ETAPES_COMMANDE.filter((e, i) => i < indexActuel && commandeEditing[e.champ]);
              return (
                <div style={{ fontSize: 13, color: TAUPE, marginBottom: 16 }}>
                  Client : <strong style={{ color: ENCRE }}>{client ? client.nom : "—"}</strong>
                  {" · "}Devis :{" "}
                  {devis ? (
                    <button type="button" className="sc-btn" onClick={() => { fermerCommandeFiche(); setActiveTab("devis"); ouvrirDevis(devis.id); }} style={{ ...linkBtnStyle, fontSize: 13 }}>
                      {devis.numero}
                    </button>
                  ) : "—"}
                  {etapesPrecedentes.map((e) => (
                    <span key={e.statut}>
                      {" · "}{e.statut === "BL" && devis && devis.exonereTVA ? "BLS" : e.label} : <strong style={{ color: ENCRE }}>{commandeEditing[e.champ]}</strong>
                    </span>
                  ))}
                </div>
              );
            })()}

            {(() => {
              const indexActuel2 = ETAPES_COMMANDE.findIndex((e) => e.statut === commandeEditing.statut);
              const etapesAvecAuteur = AUTEURS_ETAPES_COMMANDE.filter((e, i) => i <= indexActuel2 && commandeEditing[e.champPar]);
              if (etapesAvecAuteur.length === 0) return null;
              return (
                <div style={{ fontSize: 12, color: TAUPE, marginBottom: 16 }}>
                  {etapesAvecAuteur.map((e, i) => (
                    <span key={e.statut}>
                      {i > 0 && " · "}
                      {e.label} par <strong style={{ color: ENCRE }}>{commandeEditing[e.champPar]}</strong> le {formatDate((commandeEditing[e.champDate] || "").slice(0, 10))}
                    </span>
                  ))}
                </div>
              );
            })()}

            <Field label="Statut">
              <span style={{ display: "inline-block", fontSize: 12, padding: "5px 12px", borderRadius: 20, background: STATUT_COMMANDE_BG[commandeEditing.statut], color: STATUT_COMMANDE_FG[commandeEditing.statut], fontWeight: 600 }}>
                {commandeEditing.statut}
              </span>
              <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                Avance uniquement via les boutons « Transformer en... » ci-dessous.
              </div>
            </Field>

            <Field label="En attente de">
              {(() => {
                const enBaseEA = (commandesListe || []).find((c) => c.id === commandeEditing.id) || commandeEditing;
                const optionsBase = (enAttenteParStatut || DEFAULT_EN_ATTENTE_PAR_STATUT)[commandeEditing.statut] || [];
                // Nils 02/11 : gratuité archivée au PL — « Archivé » affiché même hors de la liste du statut.
                const optionsEA = dossierArchive(enBaseEA) && !optionsBase.includes(EA_ARCHIVE) ? [...optionsBase, EA_ARCHIVE] : optionsBase;
                const autorisees = optionsEA.filter((o) => peutChoisirEnAttente(enBaseEA, o));
                const verrouille = autorisees.length <= 1;
                return (
                  <>
                    <select className="sc-select" value={commandeEditing.enAttenteDe || ""} disabled={verrouille} onChange={(e) => setCommandeEditing({ ...commandeEditing, enAttenteDe: e.target.value })} style={{ ...selectStyle, opacity: verrouille ? 0.7 : 1 }}>
                      {optionsEA.map((o) => (<option key={o} value={o} disabled={!peutChoisirEnAttente(enBaseEA, o)}>{o}</option>))}
                    </select>
                    {/* Nils 01/11 : dossier SAV gratuit — pas de facture, clôture du ticket puis archivage. */}
                    {ticketSavDuDossier(commandeEditing) && dossierSavGratuit(commandeEditing) && (
                      <div style={{ fontSize: 11, color: OCRE, marginTop: 4 }}>
                        Remplacement gratuit ({ticketSavDuDossier(commandeEditing).numero}) : pas de facture. {enBaseEA.enAttenteDe === EA_ARCHIVE ? "Dossier archivé." : enBaseEA.enAttenteDe === EA_SAV_CLOTURE ? (estGerant ? "SAV clôturé : saisis les coûts du ticket, puis choisis « Archivé »." : "SAV clôturé : en attente d'archivage par le Gérant.") : "Après le BL, le pilote clôture le ticket SAV."}
                      </div>
                    )}
                    {/* Nils 02/11 : gratuité — archivage au PL / BL sans contrepartie, Gérant seul. */}
                    {dossierGratuite(enBaseEA) && (
                      <div style={{ fontSize: 12, color: OCRE, marginTop: 6 }}>
                        Gratuité « {motifGratuite(enBaseEA.gratuite)} » — archivée le {formatDate(enBaseEA.gratuite.le)} par {enBaseEA.gratuite.par} : rien à demander au client, pas de facture{enBaseEA.statut === "PL" ? " ni de BL" : ""}.
                        {estGerant && <button type="button" className="sc-btn" onClick={() => desarchiverGratuite(enBaseEA)} style={{ ...ghostBtnStyle, padding: "2px 8px", fontSize: 12 }}>Désarchiver</button>}
                      </div>
                    )}
                    {estGerant && ["PL", "BL"].includes(enBaseEA.statut) && !dossierArchive(enBaseEA) && !ticketSavDuDossier(enBaseEA) && (
                      gratuiteForm && gratuiteForm.id === enBaseEA.id ? (
                        <div style={{ marginTop: 8, padding: "8px 10px", background: PIERRE, borderRadius: 8, fontSize: 12 }}>
                          <div style={{ fontWeight: 600, marginBottom: 6 }}>Archiver — gratuité (rien à demander au client)</div>
                          <select className="sc-select" value={gratuiteForm.motif} onChange={(e) => setGratuiteForm({ ...gratuiteForm, motif: e.target.value })} style={selectStyle}>
                            <option value="">Motif…</option>
                            {MOTIFS_GRATUITE.map((m) => (<option key={m} value={m}>{m === "Autre" ? "Autre (préciser)" : m}</option>))}
                          </select>
                          {gratuiteForm.motif === "Autre" && <input className="sc-input" value={gratuiteForm.precision} onChange={(e) => setGratuiteForm({ ...gratuiteForm, precision: e.target.value })} placeholder="Précise le motif" style={{ ...inputStyle("100%"), marginTop: 6 }} />}
                          <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                            <button type="button" className="sc-btn" onClick={archiverGratuite} style={primaryBtnStyle}>Archiver</button>
                            <button type="button" className="sc-btn" onClick={() => setGratuiteForm(null)} style={ghostBtnStyle}>Annuler</button>
                          </div>
                        </div>
                      ) : (
                        <button type="button" className="sc-btn" onClick={() => setGratuiteForm({ id: enBaseEA.id, motif: "", precision: "" })} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12, display: "block" }}>Archiver — gratuité…</button>
                      )
                    )}
                    {!peut("admin.parametrage") && (
                      <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                        {enBaseEA.enAttenteDe === "Autorisation direction" ? "En attente d'autorisation : seul le Gérant peut changer cette valeur." : verrouille ? "Tu ne peux pas changer cette valeur à ce stade." : "Seules les valeurs que tu as le droit de choisir sont actives."}
                      </div>
                    )}
                    {peut("admin.parametrage") && (
                      <button type="button" className="sc-btn" onClick={() => { fermerCommandeFiche(); setActiveTab("parametrage"); }} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>Options et droits : onglet Paramétrage</button>
                    )}
                  </>
                );
              })()}
            </Field>

            <div style={{ borderTop: `1px solid ${PIERRE}`, paddingTop: 14, marginBottom: 14 }}>
              <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Réservation matière</div>
              {(() => {
                const resActives = (reservations || []).filter((r) => r.bc === commandeEditing.numero && r.statut === "active");
                if (resActives.length === 0) {
                  return <div style={{ fontSize: 13, color: TAUPE, marginBottom: 8 }}>Aucune réservation encore faite pour ce BC.</div>;
                }
                const auteurs = [...new Set(resActives.map((r) => r.auteur).filter(Boolean))];
                return (
                  <div style={{ fontSize: 13, marginBottom: 8 }}>
                    {resActives.length} article(s) réservé(s) sous ce BC dans le Stock
                    {auteurs.length > 0 && <> — par <strong style={{ color: ENCRE }}>{auteurs.join(", ")}</strong></>}.
                  </div>
                );
              })()}
              {(() => {
                const levees = (reservations || [])
                  .filter((r) => r.bc === commandeEditing.numero && r.statut === "levee")
                  .sort((a, b) => (a.leveeLe < b.leveeLe ? 1 : -1));
                if (levees.length === 0) return null;
                return (
                  <div style={{ marginBottom: 8 }}>
                    <div
                      style={{ fontSize: 12, color: TAUPE, cursor: "pointer", textDecoration: "underline" }}
                      onClick={() => setAfficherReservationsLevees(!afficherReservationsLevees)}
                    >
                      {afficherReservationsLevees ? "Masquer" : "Voir"} les réservations levées sur ce BC ({levees.length})
                    </div>
                    {afficherReservationsLevees && (
                      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 8, maxHeight: 160, overflowY: "auto" }}>
                        {levees.map((r) => (
                          <div key={r.id} style={{ fontSize: 12, color: TAUPE, background: PIERRE, borderRadius: 6, padding: "6px 10px" }}>
                            {r.quantite} — {r.note || nomProduit(r.produitId)}
                            <br />
                            Levée le {formatDate(r.leveeLe)}{r.leveePar ? ` par ${r.leveePar}` : ""}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })()}
              {/* ERP step 10 (retour Nils du 24/09) : plus de réservation de matière en BL / Facture. */}
              {!["BL", "Facture"].includes(commandeEditing.statut) && (
                <>
                  <button type="button" className="sc-btn" onClick={() => demarrerReservationDepuisCommande(commandeEditing)} style={ghostBtnStyle}>
                    📦 Réserver la matière
                  </button>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                    Toujours manuel — jamais réservé automatiquement à la confirmation. Une fenêtre te propose chaque article du devis relié au Stock, à toi de choisir le lot.
                  </div>
                </>
              )}
            </div>

            <Field label="Commentaire">
              <textarea
                className="sc-input"
                value={commandeEditing.commentaireDessin || ""}
                disabled={dossierFacture(commandeEditing)}
                onChange={(e) => setCommandeEditing({ ...commandeEditing, commentaireDessin: e.target.value })}
                style={{ ...inputStyle("100%"), minHeight: 70, resize: "vertical", fontFamily: "'DM Sans', sans-serif" }}
                placeholder="ex. consommation de tranches conforme au BPRDM"
              />
            </Field>

            {/* ERP step 10 : contact + téléphone sur place, modifiables pendant
                toute la procédure, obligatoires pour passer en BPRDM. */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <Field label={commandeEditing.statut === "Facture" ? "Contact sur place — nom et fonction (non modifiable en Facture)" : dossierAvecLogistique(commandeEditing) ? "Contact sur place — nom et fonction (obligatoire pour le BPRDM)" : "Contact sur place — nom et fonction (facultatif sans livraison)"}>
                <input
                  className="sc-input"
                  placeholder="Nom et fonction — ex. M. Alaoui, architecte"
                  disabled={commandeEditing.statut === "Facture"}
                  value={contactSurPlaceDuDossier(commandeEditing).nom}
                  onChange={(e) => setCommandeEditing({ ...commandeEditing, contactSurPlace: e.target.value, telephoneSurPlace: contactSurPlaceDuDossier(commandeEditing).tel })}
                  style={inputStyle("100%")}
                />
                {commandeEditing.statut !== "Facture" && choixContactProjet((devisDeCommande(commandeEditing) || {}).chantierId, (c) => setCommandeEditing({ ...commandeEditing, contactSurPlace: c.nom, telephoneSurPlace: c.tel }))}
              </Field>
              <Field label={commandeEditing.statut === "Facture" ? "Téléphone sur place (non modifiable en Facture)" : dossierAvecLogistique(commandeEditing) ? "Téléphone sur place (obligatoire pour le BPRDM)" : "Téléphone sur place (facultatif sans livraison)"}>
                <input
                  className="sc-input"
                  disabled={commandeEditing.statut === "Facture"}
                  value={contactSurPlaceDuDossier(commandeEditing).tel}
                  onChange={(e) => setCommandeEditing({ ...commandeEditing, telephoneSurPlace: e.target.value, contactSurPlace: contactSurPlaceDuDossier(commandeEditing).nom })}
                  style={inputStyle("100%")}
                />
              </Field>
            </div>

            {/* ERP step 11 (accord Nils du 29/09) : encadré Consommables —
                production (bloque le BL) et pose (bloque la Facture si la
                commande contient une pose). Visible dès le statut PL. */}
            {["PL", "BL", "Facture"].includes(commandeEditing.statut) && (() => {
              const fige = commandeEditing.statut === "Facture";
              const blocs = [
                ...(consoProductionRequise(commandeEditing) || consommablesDuDossier(commandeEditing, "production").length ? [{ usage: "production", titre: "Production", cle: "aucunConsoProduction", bloque: "le BL" }] : []),
                ...(fichePoseRequise(commandeEditing) ? [{ usage: "pose", titre: "Pose", cle: "aucunConsoPose", bloque: "la Facture" }] : []),
              ];
              return (
                <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 12, marginBottom: 16 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                    <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>Consommables</div>
                    {commandeEditing.numeroPL && <span style={{ display: "flex", gap: 6 }}>
                      <button type="button" className="sc-btn" onClick={() => imprimerFicheConsommables(commandeEditing, "production")} style={{ ...ghostBtnStyle, padding: "3px 10px", fontSize: 12 }}>🖨 Fiche atelier</button>
                      {fichePoseRequise(commandeEditing) && <button type="button" className="sc-btn" onClick={() => imprimerFicheConsommables(commandeEditing, "pose")} style={{ ...ghostBtnStyle, padding: "3px 10px", fontSize: 12 }}>🖨 Fiche pose</button>}
                    </span>}
                  </div>
                  {blocs.map((b) => {
                    const liste = consommablesDuDossier(commandeEditing, b.usage);
                    const aucun = commandeEditing[b.cle];
                    const ok = liste.length > 0 || !!aucun;
                    return (
                      <div key={b.usage} style={{ marginBottom: 10 }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                          <div style={{ fontSize: 13, fontWeight: 600 }}>{b.titre} <span style={{ fontSize: 11, color: TAUPE, fontWeight: 400 }}>— bloque {b.bloque}</span></div>
                          <span style={{ fontSize: 10, fontWeight: 600, padding: "2px 8px", borderRadius: 10, color: ok ? VERT_OK : ROUILLE, background: ok ? "#E4EBE4" : "#F3E3DC" }}>{ok ? "OK" : "Manquant"}</span>
                        </div>
                        {liste.length > 0 ? (
                          <div style={{ fontSize: 12, color: ENCRE, display: "flex", flexDirection: "column", gap: 2 }}>
                            {liste.map((m) => {
                              const lot = (items || []).find((it) => it.id === m.itemId);
                              return (
                                <div key={m.id}>{m.quantite} {m.unite || ""} {lot ? libelleLot(lot) : "(lot supprimé)"} <span style={{ color: TAUPE }}>· {formatDate(m.date)}</span></div>
                              );
                            })}
                          </div>
                        ) : (
                          <div style={{ fontSize: 12, color: aucun ? ENCRE : TAUPE }}>
                            {aucun ? <>Aucun consommable de {b.usage} — déclaré par {aucun.par}{aucun.le ? ` le ${formatDate(aucun.le.slice(0, 10))}` : ""}</> : `À saisir par le bureau technique : Stock → Enregistrer une consommation › consommables de ${b.usage} (consommables ou « aucun »).`}
                            {/* Nils 19/10 (e) : le Production Manager déclare « aucun consommable » depuis le dossier (il n'ouvre pas la saisie des consommables). */}
                            {!aucun && !fige && commandeEditing.numeroPL && peutCocherAucunConso && (
                              <button type="button" className="sc-btn" onClick={() => declarerAucunConsoPL(commandeEditing.numeroPL, b.usage, true)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 10px", marginTop: 6, background: "#fff", display: "block" }}>Déclarer « aucun consommable de {b.usage} »</button>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                  <div style={{ fontSize: 11, color: TAUPE }}>
                    {fige
                      ? "Dossier facturé : figé."
                      : `Saisie par le bureau technique (Stock → Enregistrer une consommation › consommables de production / de pose), « aucun consommable » déclaré au même endroit ou ici, dans le dossier (Gérant, Production Manager ou bureau technique).`}
                    {!consoProductionRequise(commandeEditing) ? " Pas de façonnage dans la commande : consommables de production non exigés." : ""}
                    {!fichePoseRequise(commandeEditing) ? " Pas de pose dans la commande : consommables de pose non exigés." : ""}
                  </div>
                </div>
              );
            })()}

            {/* Nils 01/11 (étape c) : incidents de production du PL (avant livraison). */}
            {(() => {
              const lies = incidentsDuDossier(commandeEditing);
              const peutDeclarer = peutDeclarerIncident && commandeEditing.statut === "PL" && commandeEditing.numeroPL;
              if (!lies.length && !peutDeclarer) return null;
              return (
                <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 12, marginBottom: 16 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: lies.length ? 8 : 0 }}>
                    <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>Incidents de production {lies.length ? `(${lies.length})` : ""}</div>
                    {peutDeclarer && <button type="button" className="sc-btn" onClick={() => nouvelIncident(commandeEditing)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 0" }}>⚠ Déclarer un incident</button>}
                  </div>
                  {lies.map((i) => (
                    <div key={i.id} onClick={() => peutDeclarerIncident && setIncidentEdit(JSON.parse(JSON.stringify(i)))} style={{ display: "flex", justifyContent: "space-between", gap: 8, fontSize: 13, padding: "4px 0", borderTop: `1px solid ${PIERRE}`, cursor: peutDeclarerIncident ? "pointer" : "default" }}>
                      <span><strong>{i.numero}</strong> — {formatDate(i.date)} — {i.motif}{i.annuleLe ? <span style={{ color: ROUILLE }}> — annulé</span> : null}</span>
                      <span style={{ color: TAUPE }}>{sortiesIncident(i).reduce((n, m) => n + (Number(m.quantite) || 0), 0) || "aucune"} sortie(s){estGerant ? ` · ${formatDH(coutIncident(i))}` : ""}</span>
                    </div>
                  ))}
                </div>
              );
            })()}
            {/* ERP step 11 : SAV liés au dossier (d'origine) + ouverture d'un SAV */}
            {(() => {
              const lies = (savListe || []).filter((t) => t.commandeOrigineId === commandeEditing.id);
              const devisCE = devisDeCommande(commandeEditing);
              const ticketDeCeDossier = devisCE && devisCE.savId ? (savListe || []).find((t) => t.id === devisCE.savId) : null;
              const peutOuvrir = ["BL", "Facture"].includes(commandeEditing.statut) && peutOuvrirSav(commandeEditing);
              if (lies.length === 0 && !peutOuvrir && !ticketDeCeDossier) return null;
              return (
                <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 12, marginBottom: 16 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: lies.length || ticketDeCeDossier ? 8 : 0 }}>
                    <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>SAV {lies.length > 0 ? `(${lies.length})` : ""}</div>
                    {peutOuvrir && <button type="button" className="sc-btn" onClick={() => { fermerCommandeFiche(); setActiveTab("sav"); nouveauTicketSav(commandeEditing); }} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 0" }}>+ Ouvrir un SAV</button>}
                  </div>
                  {ticketDeCeDossier && (
                    <div style={{ fontSize: 12, color: ROUILLE, marginBottom: 6 }}>Ce dossier est le traitement du {ticketDeCeDossier.numero} ({ticketDeCeDossier.motif}).</div>
                  )}
                  {lies.map((t) => (
                    <div key={t.id} onClick={() => { fermerCommandeFiche(); setActiveTab("sav"); ouvrirTicketSav(t.id); }} style={{ display: "flex", justifyContent: "space-between", gap: 8, fontSize: 13, padding: "4px 0", borderTop: `1px solid ${PIERRE}`, cursor: "pointer" }}>
                      <span><strong>{t.numero}</strong> — {t.motif}</span>
                      <span style={{ color: savEnRetard(t) ? ROUILLE : TAUPE }}>{statutAfficheSav(t)}{savEnRetard(t) ? " · en retard" : ""}</span>
                    </div>
                  ))}
                </div>
              );
            })()}

            {/* ERP step 11 (demande Nils du 29/09) : éléments techniques toujours visibles, repliables. */}
            {(() => {
              const lignesET = elementsDescriptifsTechniques(commandeEditing);
              return (
                <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 12, marginBottom: 16 }}>
                  <div onClick={() => setElemTechOuvert(!elemTechOuvert)} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer" }}>
                    <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>{elemTechOuvert ? "▾" : "▸"} Éléments techniques ({lignesET.length})</div>
                    {commandeEditing.statut !== "BL" && commandeEditing.statut !== "Facture" && (
                      <button type="button" className="sc-btn" onClick={(e) => { e.stopPropagation(); ouvrirElementsTechniquesModal(); }} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 0" }}>Modifier</button>
                    )}
                  </div>
                  {elemTechOuvert && (
                    lignesET.length === 0 ? (
                      <div style={{ fontSize: 13, color: TAUPE, marginTop: 6 }}>Aucun élément technique renseigné.</div>
                    ) : (
                      <ul style={{ margin: "8px 0 0", paddingLeft: 18, fontSize: 13, lineHeight: 1.7 }}>
                        {lignesET.map((l, i) => (<li key={i}>{l}</li>))}
                      </ul>
                    )
                  )}
                </div>
              );
            })()}

            {/* ERP step 11 (accord Nils du 29/09) : documents importants — liens, non bloquant. */}
            {renderDocumentsImportants((devisListe || []).find((d) => d.id === commandeEditing.devisId), commandeEditing)}

            {/* ERP step 10 (accord Nils du 24/09) : rappel de chargement pour
                le Production Manager — ce qu'il remet aux poseurs au départ. Simple rappel,
                NON bloquant. Visible à partir du statut PL ; cochable par
                le Production Manager et le Gérant (enregistré avec le bouton Enregistrer du dossier). */}
            {["PL", "BL"].includes(commandeEditing.statut) && (() => {
              const ch = commandeEditing.chargement || {};
              const peutCocher = peut("commandes.chargement");
              const itemsCh = itemsChargement(commandeEditing);
              const nbCoches = itemsCh.filter((it) => ch[it.cle]).length;
              return (
                <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 10, padding: 12, marginBottom: 16 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                    <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>Chargement — à remettre aux poseurs</div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: nbCoches === itemsCh.length ? VERT_OK : OCRE }}>{nbCoches}/{itemsCh.length}</div>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
                    {itemsCh.map((it) => (
                      <label key={it.cle} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, cursor: peutCocher ? "pointer" : "default" }}>
                        <input
                          type="checkbox"
                          disabled={!peutCocher}
                          checked={!!ch[it.cle]}
                          onChange={(e) => setCommandeEditing({ ...commandeEditing, chargement: { ...ch, [it.cle]: e.target.checked, modifiePar: user.nom, modifieLe: new Date().toISOString() } })}
                        />
                        {it.label}
                      </label>
                    ))}
                  </div>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>
                    Rappel non bloquant{peutCocher ? " — pense à enregistrer le dossier." : " — coché par le Production Manager ou le Gérant."}
                    {ch.modifiePar ? ` Dernière mise à jour : ${ch.modifiePar}.` : ""}
                  </div>
                </div>
              );
            })()}

            {/* ERP step 10 (retour Nils du 24/09) : nombre de colis masqué en BDC / RDM / PL. */}
            {["BL", "Facture"].includes(commandeEditing.statut) && (
              <Field label="Nombre de colis (pour le BL, facultatif)">
                <input
                  type="number"
                  min="0"
                  className="sc-input"
                  value={commandeEditing.nombreColis || ""}
                  disabled={dossierFacture(commandeEditing)}
                  onChange={(e) => setCommandeEditing({ ...commandeEditing, nombreColis: e.target.value })}
                  style={inputStyle(120)}
                />
              </Field>
            )}

            {/* Nils 03/10 (l) : suivi de la facture — envoi, remise de l'original, transmission au comptable. */}
            {commandeEditing.statut === "Facture" && commandeEditing.numeroFacture && (() => {
              const c = commandeEditing;
              const peutSuivi = peut("commandes.suiviFacture");
              const peutRemise = peutSuivi || estCommercialDuDossier(c);
              const ligne = (champ, label, coche, le, par, actif, aide) => (
                <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, padding: "4px 0", cursor: actif ? "pointer" : "default", opacity: actif || coche ? 1 : 0.6 }}>
                  <input type="checkbox" checked={!!coche} disabled={!actif} onChange={(e) => cocherSuiviFacture(champ, e.target.checked)} />
                  <span>{label}</span>
                  {coche ? <span style={{ fontSize: 11, color: TAUPE }}>— le {formatDate(le)} par {par}</span> : aide ? <span style={{ fontSize: 11, color: TAUPE }}>— {aide}</span> : null}
                </label>
              );
              return (
                <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "10px 14px", marginBottom: 14 }}>
                  <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>Suivi de la facture {c.numeroFacture}</div>
                  {c.factureGroupeeId && dossiersDuGroupe(c).length > 1 && (
                    <div style={{ fontSize: 12, color: TAUPE, marginBottom: 6 }}>Facture groupée « {c.refFactureGroupee} » : {dossiersDuGroupe(c).map((x) => x.numeroBL).join(", ")}. Le suivi, l'annulation et le document valent pour toute la facture.</div>
                  )}
                  {ligne("envoyee", "Envoyée au client par mail", c.envoyeeClientLe, c.envoyeeClientLe, c.envoyeeClientPar, peutSuivi, "passe ensuite en attente de « Remise original »")}
                  {ligne("remise", "Original remis au client (deux exemplaires : le client signe et rend l'accusé)", c.remiseClientLe, c.remiseClientLe, c.remiseClientPar, peutRemise, "passe ensuite en « Circuit fermé »")}
                  {ligne("comptable", "Transmise au comptable", c.transmiseComptableLe, c.transmiseComptableLe, c.transmiseComptablePar, peutSuivi && !c.transmiseComptableLe, "définitif une fois coché")}
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Enregistré tout de suite. En attente de : <strong>{c.enAttenteDe || "—"}</strong>.</div>
                </div>
              );
            })()}

            {commandeEditing.statut === "Facture" && commandeEditing.numeroFacture && renderAvoirsFacture(commandeEditing)}

            {/* Nils 03/10 (n) : signature du BL. */}
            {["BL", "Facture"].includes(commandeEditing.statut) && commandeEditing.numeroBL && (() => {
              const c = commandeEditing;
              const actif = peutSignerBL(c);
              const sig = c.blSigne;
              const choix = nouveauSignataire && nouveauSignataire.dossierId === c.id ? nouveauSignataire : { dossierId: c.id, choix: "", ajout: "" };
              const setChoix = (patch) => setNouveauSignataire({ ...choix, ...patch });
              return (
                <div style={{ border: `1px solid ${sig ? PIERRE : OCRE}`, borderRadius: 8, padding: "10px 14px", marginBottom: 14 }}>
                  <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>Signature du {c.numeroBL}</div>
                  {sig ? (
                    <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, cursor: actif ? "pointer" : "default" }}>
                      <input type="checkbox" checked disabled={!actif} onChange={() => cocherBLSigne(false)} />
                      <span>BL signé par <strong>{sig.signataire}</strong></span>
                      <span style={{ fontSize: 11, color: TAUPE }}>— coché le {formatDate(sig.le)} par {sig.par}</span>
                    </label>
                  ) : actif ? (
                    <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, flexWrap: "wrap" }}>
                      <select className="sc-select" value={choix.choix} onChange={(e) => setChoix({ choix: e.target.value })} style={{ ...selectStyle, width: 200, background: "#fff" }}>
                        <option value="">— Signé par —</option>
                        {(signatairesBL || DEFAULT_SIGNATAIRES_BL).map((x) => (<option key={x} value={x}>{x}</option>))}
                        <option value="__ajout">+ Ajouter…</option>
                      </select>
                      {choix.choix === "__ajout" && (
                        <input className="sc-input" autoFocus value={choix.ajout} onChange={(e) => setChoix({ ajout: e.target.value })} placeholder="ex. Gardien, Architecte" style={{ ...inputStyle(180), padding: "6px 8px", background: "#fff", border: `1px solid ${TAUPE}` }} />
                      )}
                      <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
                        <input type="checkbox" checked={false} onChange={async () => {
                          const nom = choix.choix === "__ajout" ? await ajouterSignataireBL(choix.ajout) : choix.choix;
                          if (!nom) { setNotice("Choisis qui a signé le BL."); return; }
                          await cocherBLSigne(true, nom);
                          setNouveauSignataire(null);
                        }} />
                        BL signé
                      </label>
                    </div>
                  ) : (
                    <div style={{ fontSize: 13, color: OCRE }}>Pas encore signé (à cocher par le Production Manager, le commercial ou l'ADV).</div>
                  )}
                </div>
              );
            })()}

            {/* Nils 03/10 (m) : historique des annulations de facture / BL. */}
            {(commandeEditing.annulations || []).length > 0 && (
              <div style={{ border: `1px solid ${ROUILLE}44`, borderRadius: 8, padding: "10px 14px", marginBottom: 14, fontSize: 12 }}>
                <div style={{ fontSize: 11, color: ROUILLE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>Documents annulés</div>
                {commandeEditing.annulations.map((x, i) => {
                  const r = x.remplacementId ? (remplacements || []).find((y) => y.id === x.remplacementId) : null;
                  return (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", padding: "3px 0" }}>
                      <span><strong>{x.numero}</strong> du {formatDate(x.date)} — annulé(e) le {formatDate(x.le)} par {x.par}{x.motif ? ` : ${x.motif}` : ""}</span>
                      {r ? <span style={{ color: TAUPE }}>· remplacé(e) par « {r.designation} » ({(clientDe(r.clientId) || {}).nom || NOM_CLIENT_COMPTOIR}{r.ttc ? `, ${formatDH(r.ttc)} TTC` : ""})</span> : <span style={{ color: TAUPE }}>· numéro libéré (dernier de la série)</span>}
                      {r && <button type="button" className="sc-btn" onClick={() => imprimerRemplacement(r)} style={{ ...ghostBtnStyle, fontSize: 11, padding: "2px 6px" }}>⬇ Document de remplacement</button>}
                    </div>
                  );
                })}
              </div>
            )}

            {/* Accord Nils du 21/09 (Step 10) : seule brèche dans le gel du
                devis d'origine une fois transformé en BDC — la bascule
                exonération, verrouillée dès BL/Facture comme les lignes. */}
            {(() => {
              if (!peut("commandes.exoneration")) return null;
              if (!["BDC", "RDM", "PL"].includes(commandeEditing.statut)) return null;
              const devisOrigine = (devisListe || []).find((d) => d.id === commandeEditing.devisId);
              return (
                <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, marginBottom: 14, cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={!!(devisOrigine && devisOrigine.exonereTVA)}
                    onChange={(e) => toggleExonerationDossier(e.target.checked)}
                  />
                  Commande exonérée de TVA
                  <span style={{ fontSize: 11, color: TAUPE }}>
                    (bascule immédiate — consomme ou restitue aussitôt le crédit du registre des tranches exonérables)
                  </span>
                </label>
              );
            })()}

            {/* ERP step 7 : chaque section modifiable s'ouvre dans son propre
                formulaire séparé, plutôt que d'être empilée directement ici —
                pour garder la fiche dossier lisible (demande le Gérant). */}
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 20, paddingBottom: 20, borderBottom: `1px solid ${PIERRE}` }}>
              {commandeLignesEditables(commandeEditing.statut) && peut("commandes.modifierLignesBC") && draft && draft.id === commandeEditing.devisId && (
                <button type="button" className="sc-btn" onClick={ouvrirModifierLignesModal} style={ghostBtnStyle}>✎ Modifier le bon de commande</button>
              )}
              {commandeEditing.statut !== "BL" && commandeEditing.statut !== "Facture" && (
                <button type="button" className="sc-btn" onClick={ouvrirElementsTechniquesModal} style={ghostBtnStyle}>🔧 Éléments techniques</button>
              )}
              {/* Nils 04/10 (i) : fiche de pose masquée quand le dossier n'a aucun article de pose. */}
              {["PL", "BL", "Facture"].includes(commandeEditing.statut) && fichePoseRequise(commandeEditing) && (
                <button type="button" className="sc-btn" onClick={ouvrirFichePoseModal} style={ghostBtnStyle}>
                  📋 Fiche de pose {fichePoseRemplie(commandeEditing.fichePose) ? "✓" : "⚠"}
                </button>
              )}
              {["PL", "BL", "Facture"].includes(commandeEditing.statut) && fichePoseRequise(commandeEditing) && (() => {
                const partielles = ((commandeEditing.fichePose && commandeEditing.fichePose.interventions) || []).filter((it) => it.etat === "Partiellement").map((it) => it.label);
                return partielles.length ? <div style={{ width: "100%", fontSize: 12, color: OCRE, fontWeight: 600 }}>⚠ Pose partielle : {partielles.join(", ")}</div> : null;
              })()}

              {peut("devis.modifierEnteteFige") && (
                <button type="button" className="sc-btn" onClick={ouvrirEnteteNilsDossier} style={ghostBtnStyle}>✎ Modifier l'en-tête (Gérant)</button>
              )}
            </div>

            {commandeEditing.id && (() => {
              // ERP step 15 (ar) : dates prévues du planning, engagement client.
              const its = itemsPlan(commandeEditing.id).sort((a, b) => (a.date < b.date ? -1 : 1));
              const eng = (planning.engagements || {})[commandeEditing.id];
              const pt = (planning.prodTerminee || {})[commandeEditing.id];
              return (
                <div style={{ fontSize: 12, marginTop: 10 }}>
                  <span style={{ fontWeight: 600 }}>Planning : </span>
                  {its.length ? its.map((x) => <span key={x.id} style={{ display: "inline-block", background: TYPES_PLAN[x.type].coul, borderRadius: 5, padding: "1px 6px", margin: "0 4px 4px 0" }}>{formatDate(x.date)} · {texteElementPlan(x)}</span>) : <span style={{ color: TAUPE }}>rien de planifié</span>}
                  {eng && <span style={{ color: ROUILLE, fontWeight: 700, marginLeft: 6 }}>🤝 engagement client le {formatDate(eng.date)}</span>}
                  {pt && <span style={{ color: VERT_OK, marginLeft: 6 }}>✓ production terminée</span>}
                  <button type="button" className="sc-btn" onClick={() => { setActiveTab("planning"); setPlanDossier(commandeEditing.id); }} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 6px" }}>Voir dans le planning</button>
                </div>
              );
            })()}
            {(peut("deplacements.saisir") || estGerant) && commandeEditing.id && (() => {
              const deps = deplacementsDuDossier(commandeEditing.id);
              return (
                <div style={{ fontSize: 12, marginTop: 10 }}>
                  <span style={{ fontWeight: 600 }}>Déplacements : </span>
                  {deps.length ? deps.map((d) => (
                    <button key={d.id} type="button" className="sc-btn" onClick={() => setDeplEdit({ ...d })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 6px" }}>{formatDate(d.date)} {d.type}{(zoneDe(d.zoneId) || {}).nom ? ` — ${zoneDe(d.zoneId).nom}` : ""}</button>
                  )) : <span style={{ color: TAUPE }}>aucun</span>}
                  {peut("deplacements.saisir") && <button type="button" className="sc-btn" onClick={() => setDeplEdit(nouveauDeplacement(commandeEditing.id))} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 6px" }}>+ Déplacement</button>}
                </div>
              );
            })()}
            {commandeEditing.id && montantsProjetVisibles && renderDeductionsDossier(commandeEditing)}
            {estGerant && commandeEditing.id && renderMargeDossier(commandeEditing)}

            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 10, flexWrap: "wrap" }}>
              {commandeEditing.statut === "Facture" && commandeEditing.numeroFacture && !commandeEditing.transmiseComptableLe && peut("commandes.annulerFactureBL") && (
                <button type="button" className="sc-btn" onClick={() => demanderAnnulationDocument("Facture")} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>⊘ Annuler la facture</button>
              )}
              {commandeEditing.statut === "BL" && commandeEditing.numeroBL && (String(commandeEditing.numeroBL).startsWith("BLS") ? estGerant : peut("commandes.annulerFactureBL")) && (
                <button type="button" className="sc-btn" onClick={() => demanderAnnulationDocument("BL")} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>⊘ Annuler le {String(commandeEditing.numeroBL).startsWith("BLS") ? "BLS" : "BL"}</button>
              )}
              {commandeEditing.statut === "BDC" && !user.commandesRestreintACommercial && peut("devis.transformerBDC") && (
                <button type="button" className="sc-btn" onClick={() => demanderAnnulerBDC(commandeEditing)} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>← Revenir à l'étape précédente</button>
              )}
              {commandeEditing.statut !== "BDC" && commandeEditing.statut !== "BL" && commandeEditing.statut !== "Facture" && !user.commandesRestreintACommercial && peutTransformerRDMPL && (
                <button type="button" className="sc-btn" onClick={retournerEtapePrecedente} style={{ ...ghostBtnStyle, color: ROUILLE }}>← Revenir à l'étape précédente</button>
              )}
              {/* ERP step 16 (Nils 12/10) : BPRDM seulement s'il y a un article de RDM (obligatoire dans ce cas). */}
              {commandeEditing.statut === "BDC" && dossierAvecRDM(commandeEditing) && !commandeEditing.numeroRDM && !user.commandesRestreintACommercial && peutTransformerRDMPL && (
                <button type="button" className="sc-btn" onClick={() => demanderConfirmationTransformation("BPRDM", transformerEnBPRDM)} style={primaryBtnStyle}>→ Transformer en BPRDM</button>
              )}
              {/* Raccourci (accord Nils du 21/09) : un dossier déjà passé par
                  RDM (numeroRDM déjà émis) qui redescend en BDC pour corriger
                  une ligne n'a pas besoin de repasser par BPRDM — le relevé,
                  le calepinage et le dessin ne sont pas à refaire. On saute
                  directement en PL en réutilisant le numéro RDM déjà émis. */}
              {commandeEditing.statut === "BDC" && (!!commandeEditing.numeroRDM || !dossierAvecRDM(commandeEditing)) && !user.commandesRestreintACommercial && peutTransformerRDMPL && (
                <button type="button" className="sc-btn" onClick={() => demanderConfirmationTransformation("PL", transformerEnPL)} style={primaryBtnStyle} title={commandeEditing.numeroRDM ? "RDM déjà fait : pas besoin de repasser par le BPRDM" : "Aucun article de RDM dans le dossier : pas de relevé de mesures"}>→ {commandeEditing.numeroRDM ? "Passer directement en PL" : "Transformer en PL"}</button>
              )}
              {commandeEditing.statut === "RDM" && !user.commandesRestreintACommercial && peutTransformerRDMPL && (
                <button type="button" className="sc-btn" onClick={() => demanderConfirmationTransformation("PL", transformerEnPL)} style={primaryBtnStyle}>→ Transformer en PL</button>
              )}
              {commandeEditing.statut === "PL" && !user.commandesSansTransformBLFacture && !user.commandesRestreintACommercial && (() => {
                const devisOrigine = (devisListe || []).find((d) => d.id === commandeEditing.devisId);
                const label = devisOrigine && devisOrigine.exonereTVA ? "BLS" : "BL";
                const bloque = commandeADesArticlesStock(commandeEditing) && !plEstEnregistre(commandeEditing);
                if (bloque) {
                  return (
                    <div style={{ background: "#F5E4DE", color: ROUILLE, fontSize: 12, fontWeight: 600, padding: "10px 14px", borderRadius: 8, width: "100%" }}>
                      ⚠ Ce dossier contient des articles liés au Stock, mais son PL n'a pas encore été enregistré ("Enregistrer une consommation › Articles du catalogue d'un PL" dans le Stock). Enregistre-le d'abord — sinon les tranches ne seront jamais déduites, même une fois passé en {label}/Facture.
                    </div>
                  );
                }
                return (
                  <button type="button" className="sc-btn" onClick={() => demanderConfirmationTransformation(label, transformerEnBL)} style={primaryBtnStyle}>→ Transformer en {label}</button>
                );
              })()}
              {commandeEditing.statut === "BL" && !user.commandesSansTransformBLFacture && !user.commandesSansBDCFacture && !user.commandesRestreintACommercial && (() => {
                const devisOrigine = (devisListe || []).find((d) => d.id === commandeEditing.devisId);
                // Facturer une commande exonérée (BLS) est une procédure à
                // vérifier à chaque fois — Nils préfère s'en charger
                // lui-même, personne d'autre ne voit ce bouton dans ce cas.
                if (devisOrigine && devisOrigine.exonereTVA && !peut("commandes.facturerExo")) return null;
                return (
                  <button type="button" className="sc-btn" onClick={() => demanderConfirmationTransformation("Facture", transformerEnFacture)} style={primaryBtnStyle}>→ Transformer en Facture</button>
                );
              })()}
              {!user.commandesSansBDCFacture && (
                <button type="button" className="sc-btn" onClick={() => imprimerCommande(commandeEditing)} style={ghostBtnStyle}>⬇ Télécharger le BC</button>
              )}
              {commandeEditing.statut === "RDM" && (
                <button type="button" className="sc-btn" onClick={() => imprimerBPRDM(commandeEditing)} style={ghostBtnStyle}>⬇ Télécharger le BPRDM</button>
              )}
              {/* Nils 03/11 : PL et BL se réimpriment aussi aux stades suivants (même numéro, même date), réimpression tracée. */}
              {(commandeEditing.statut === "PL" || (["BL", "Facture"].includes(commandeEditing.statut) && commandeEditing.numeroPL)) && (
                <button type="button" className="sc-btn" onClick={() => { if (commandeEditing.statut !== "PL") tracerAcces("document réimprimé", `Dossier ${commandeEditing.numero} : PL ${commandeEditing.numeroPL}`); imprimerPL(commandeEditing); }} style={ghostBtnStyle}>⬇ Télécharger le PL</button>
              )}
              {/* Nils 30/10 : BLS / FAS réservés au Gérant et à l'Administration (numéros non reçus). */}
              {(commandeEditing.statut === "BL" || (commandeEditing.statut === "Facture" && commandeEditing.numeroBL)) && !commandeEditing.blsMasque && (() => {
                const devisOrigine = (devisListe || []).find((d) => d.id === commandeEditing.devisId);
                const label = (devisOrigine && devisOrigine.exonereTVA) || String(commandeEditing.numeroBL || "").startsWith("BLS") ? "BLS" : "BL";
                return (
                  <button type="button" className="sc-btn" onClick={() => { if (commandeEditing.statut !== "BL") tracerAcces("document réimprimé", `Dossier ${commandeEditing.numero} : ${label} ${commandeEditing.numeroBL}`); imprimerBL(commandeEditing); }} style={ghostBtnStyle}>⬇ Télécharger le {label}</button>
                );
              })()}
              {commandeEditing.statut === "Facture" && !user.commandesSansBDCFacture && !commandeEditing.fasMasque && (
                <button type="button" className="sc-btn" onClick={() => imprimerFacture(commandeEditing)} style={ghostBtnStyle}>⬇ Télécharger la facture</button>
              )}
              <button type="button" className="sc-btn" onClick={fermerCommandeFiche} style={ghostBtnStyle}>Annuler</button>
              <button type="button" className="sc-btn" onClick={enregistrerCommande} style={primaryBtnStyle}>Enregistrer</button>
            </div>
            {commandeFicheMessage && (
              <div style={{ background: "#E4EBE4", color: VERT_OK, fontSize: 13, fontWeight: 600, padding: "10px 14px", borderRadius: 8, marginTop: 14 }}>
                ✓ {commandeFicheMessage}
              </div>
            )}
          </div>
        </Overlay>
      )}

      {rempFiche && (() => {
        const r = (remplacements || []).find((x) => x.id === rempFiche);
        if (!r) return null;
        const estFact = r.type === "Facture";
        const enc = estFact ? encaisseDossier(`rep:${r.id}`) : 0;
        const maintenant = () => new Date().toISOString();
        const peutSuivi = peut("commandes.suiviFacture");
        const caseSuivi = (cleLe, clePar, label, actif) => (
          <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, padding: "4px 0", cursor: actif ? "pointer" : "default" }}>
            <input type="checkbox" checked={!!r[cleLe]} disabled={!actif || (cleLe === "transmiseComptableLe" && !!r[cleLe])} onChange={async (e) => cleLe === "transmiseComptableLe" && !(await demander("Marquer ce document comme transmis au comptable ?\n\nC'est définitif : la case ne pourra plus être décochée.")) ? null : majRemplacement(r.id, e.target.checked ? { [cleLe]: maintenant(), [clePar]: user.nom } : { [cleLe]: "", [clePar]: "" }, "suivi facture", `${e.target.checked ? "" : "décoché : "}${label}`)} />
            <span>{label}</span>
            {r[cleLe] ? <span style={{ fontSize: 11, color: TAUPE }}>— le {formatDate(r[cleLe])} par {r[clePar]}</span> : null}
          </label>
        );
        const lib = (l, v) => (<div style={{ display: "flex", gap: 10, fontSize: 13, padding: "4px 0", borderBottom: `1px solid ${PIERRE}` }}><span style={{ color: TAUPE, minWidth: 150 }}>{l}</span><span>{v}</span></div>);
        return (
          <Overlay onClose={() => setRempFiche(null)}>
            <div style={modalStyle(560)}>
              <div style={{ ...modalTitleStyle, display: "flex", alignItems: "center", gap: 10 }}>{estFact ? "Facture" : "BL"} {r.numero} <PastilleRemplacement /></div>
              <div style={{ fontSize: 12, color: VIOLET_REMPLACEMENT, marginTop: -8, marginBottom: 14 }}>Document de remplacement : reprend le numéro du document annulé du dossier {(r.remplace && r.remplace.dossier) || "?"}.</div>
              {lib("Client", (clientDe(r.clientId) || {}).nom || NOM_CLIENT_COMPTOIR)}
              {lib("Date", formatDate(r.date))}
              {lib("Désignation", r.designation)}
              {estFact && lib("Montant", `${formatDH(r.ht)} HT — ${formatDH(r.ttc)} TTC`)}
              {estFact && lib("Encaissé", enc >= r.ttc - 0.01 ? "✓ encaissée" : `${formatDH(enc)} — reste ${formatDH(r.ttc - enc)}`)}
              {lib("Remplace", <span>dossier <span className="sc-row" onClick={() => { setRempFiche(null); if (r.remplace) ouvrirCommande(r.remplace.dossierId); }} style={{ textDecoration: "underline", cursor: "pointer" }}>{(r.remplace && r.remplace.dossier) || "?"}</span>{r.remplace && r.remplace.motif ? ` — ${r.remplace.motif}` : ""}</span>)}
              {lib("Créé par", `${r.par} le ${formatDate(r.le)}`)}
              {estFact ? (
                <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "10px 14px", margin: "14px 0" }}>
                  <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>Suivi de la facture</div>
                  {caseSuivi("envoyeeClientLe", "envoyeeClientPar", "Envoyée au client par mail", peutSuivi)}
                  {caseSuivi("remiseClientLe", "remiseClientPar", "Original remis au client", peutSuivi)}
                  {caseSuivi("transmiseComptableLe", "transmiseComptablePar", "Transmise au comptable", peutSuivi)}
                </div>
              ) : (
                <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "10px 14px", margin: "14px 0", fontSize: 13 }}>
                  <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>Signature du BL</div>
                  {r.blSigne ? (
                    <label style={{ display: "flex", alignItems: "center", gap: 8 }}><input type="checkbox" checked disabled={!peut("commandes.signatureBL")} onChange={() => majRemplacement(r.id, { blSigne: null }, "BL signé", "décoché")} /> BL signé par <strong>{r.blSigne.signataire}</strong> <span style={{ fontSize: 11, color: TAUPE }}>— le {formatDate(r.blSigne.le)} par {r.blSigne.par}</span></label>
                  ) : peut("commandes.signatureBL") ? (
                    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                      <select className="sc-select" defaultValue="" id={`sig-${r.id}`} style={{ ...selectStyle, width: 200, background: "#fff" }}>
                        <option value="">— Signé par —</option>
                        {(signatairesBL || DEFAULT_SIGNATAIRES_BL).map((x) => (<option key={x} value={x}>{x}</option>))}
                      </select>
                      <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
                        <input type="checkbox" checked={false} onChange={() => { const v = (document.getElementById(`sig-${r.id}`) || {}).value; if (!v) { setNotice("Choisis qui a signé le BL."); return; } majRemplacement(r.id, { blSigne: { le: maintenant(), par: user.nom, signataire: v } }, "BL signé", `signé par : ${v}`); }} /> BL signé
                      </label>
                    </div>
                  ) : <span style={{ color: OCRE }}>Pas encore signé.</span>}
                </div>
              )}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                <button type="button" className="sc-btn" onClick={() => imprimerRemplacement(r)} style={ghostBtnStyle}>⬇ Télécharger {estFact ? "la facture" : "le BL"}</button>
                <button type="button" className="sc-btn" onClick={() => setRempFiche(null)} style={primaryBtnStyle}>Fermer</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {annulationDoc && (() => {
        const a = annulationDoc;
        const set = (patch) => setAnnulationDoc({ ...a, ...patch, erreur: "" });
        const estFact = a.type === "Facture";
        return (
          <Overlay onClose={() => setAnnulationDoc(null)} zIndex={1500}>
            <div style={modalStyle(520)}>
              <div style={modalTitleStyle}>Annuler {estFact ? "la facture" : a.bls ? "le BLS" : "le BL"} {a.numero}</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 14, lineHeight: 1.5 }}>
                Le dossier revient au statut {estFact ? "BL" : "PL"} ; {estFact ? "il pourra être refacturé plus tard sous un nouveau numéro. Les encaissements reliés restent sur le dossier." : "il pourra repasser en BL plus tard sous un nouveau numéro. Le stock n'est pas touché (la matière est sortie au PL)."}
              </div>
              <Field label="Motif (facultatif)">
                <input className="sc-input" autoFocus value={a.motif} onChange={(e) => set({ motif: e.target.value })} placeholder="ex. erreur de client, prix à corriger" style={{ ...inputStyle("100%"), background: "#fff", border: `1px solid ${TAUPE}` }} />
              </Field>
              {a.bls ? (
                <div style={{ fontSize: 12, background: PIERRE, borderRadius: 6, padding: "8px 12px", marginBottom: 14 }}>
                  BLS : pas de document de remplacement. Le numéro {a.numero} est libéré, même si des numéros plus récents existent (trou de numérotation accepté).
                </div>
              ) : a.dernier ? (
                <div style={{ fontSize: 12, background: PIERRE, borderRadius: 6, padding: "8px 12px", marginBottom: 14 }}>
                  {a.numero} est le dernier de la série : le numéro est simplement libéré, pas de document de remplacement.
                </div>
              ) : (
                <div style={{ border: `1px solid ${OCRE}`, borderRadius: 8, padding: "10px 14px", marginBottom: 14 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>Document de remplacement obligatoire</div>
                  <div style={{ fontSize: 11, color: TAUPE, marginBottom: 10, lineHeight: 1.5 }}>
                    {a.dejaEnvoyee ? "Cette facture a déjà été envoyée au client : son numéro ne peut pas être réutilisé" : "Des numéros plus récents existent déjà"} : pour ne pas interrompre la séquence, {a.numero} est repris, à la même date ({formatDate(a.date)}), par {estFact ? "une facture" : "un BL"} au nom du client ci-dessous, avec une seule ligne « {DESIGNATION_REMPLACEMENT} » : {estFact ? `${formatDH(HT_REMPLACEMENT)} HT, soit ${formatDH(Math.round(HT_REMPLACEMENT * (1 + TVA_TAUX) * 100) / 100)} TTC, encaissés d'office en caisse générale à la date du ${formatDate(a.date)}.` : "sans prix, comme tous les BL ; pas d'encaissement."}
                  </div>
                  <Field label="Client">
                    <input className="sc-input" list="clients-remplacement" value={a.clientNom} onChange={(e) => set({ clientNom: e.target.value })} style={{ ...inputStyle("100%"), background: "#fff", border: `1px solid ${TAUPE}` }} />
                    <datalist id="clients-remplacement">{(clients || []).map((c) => (<option key={c.id} value={c.nom} />))}</datalist>
                  </Field>
                </div>
              )}
              {a.erreur && <div style={{ color: ROUILLE, fontSize: 12, marginBottom: 10 }}>{a.erreur}</div>}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                <button type="button" className="sc-btn" onClick={() => setAnnulationDoc(null)} style={ghostBtnStyle}>Fermer</button>
                <button type="button" className="sc-btn" onClick={confirmerAnnulationDocument} style={{ ...primaryBtnStyle, background: ROUILLE }}>Annuler {estFact ? "la facture" : a.bls ? "le BLS" : "le BL"}</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {showModifierLignesModal && commandeEditing && draft && draft.id === commandeEditing.devisId && (() => {
        const enregistrerEtFermer = async () => {
          const s = await sauvegarderCommandeEnCours();
          if (!s) return;
          setNotice(`Lignes du dossier ${s.numero} enregistrées.`);
          draftLignesSnapshotRef.current = null;
          setShowModifierLignesModal(false);
        };
        return (
          <Overlay onClose={fermerModifierLignesModal}>
            <div style={modalStyle(1100)}>
              <div style={modalTitleStyle}>Modifier le bon de commande {commandeEditing.numero} ({commandeEditing.statut})</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -10, marginBottom: 14 }}>
                Modifiable jusqu'au BL, indépendamment du devis d'origine (figé dès la transformation en BDC). Un clic en dehors de cette fenêtre abandonne les modifications — seul "Enregistrer" les valide.
              </div>
              {renderContenuLignesDevis()}
              {renderTotauxDevis()}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 16, marginBottom: -28, marginLeft: -28, marginRight: -28, padding: "14px 28px", position: "sticky", bottom: -28, background: "#fff", borderTop: `1px solid ${PIERRE}`, borderRadius: "0 0 12px 12px" }}>
                <button type="button" className="sc-btn" onClick={enregistrerEtFermer} style={primaryBtnStyle}>Enregistrer</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {showElementsTechniquesModal && commandeEditing && (() => {
        const enregistrerEtFermer = async () => {
          const s = await sauvegarderCommandeEnCours();
          if (!s) return;
          setNotice(`Éléments techniques du dossier ${s.numero} enregistrés.`);
          commandeEditingSnapshotRef.current = null;
          setShowElementsTechniquesModal(false);
        };
        return (
          <Overlay onClose={fermerElementsTechniquesModal}>
            <div style={modalStyle(700)}>
              <div style={modalTitleStyle}>Éléments techniques — Dossier {commandeEditing.numero}</div>
              {renderElementsTechniques(commandeEditing, setCommandeEditing)}
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -6, marginBottom: 10 }}>
                Un clic en dehors de cette fenêtre abandonne les modifications — seul "Enregistrer" les valide.
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 16, marginBottom: -28, marginLeft: -28, marginRight: -28, padding: "14px 28px", position: "sticky", bottom: -28, background: "#fff", borderTop: `1px solid ${PIERRE}`, borderRadius: "0 0 12px 12px" }}>
                <button type="button" className="sc-btn" onClick={enregistrerEtFermer} style={primaryBtnStyle}>Enregistrer</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {showFichePoseModal && commandeEditing && (() => {
        const enregistrerEtFermer = async () => {
          const s = await sauvegarderCommandeEnCours();
          if (!s) return;
          setNotice(`Fiche de pose du dossier ${s.numero} enregistrée.`);
          commandeEditingSnapshotRef.current = null;
          setShowFichePoseModal(false);
        };
        return (
          <Overlay onClose={fermerFichePoseModal}>
            <div style={modalStyle(900)}>
              <div style={modalTitleStyle}>Fiche de pose — Dossier {commandeEditing.numero}</div>
              {renderFichePose()}
              {!dossierFacture(commandeEditing) && (
                <div style={{ fontSize: 12, color: TAUPE, marginTop: -6, marginBottom: 10 }}>
                  Un clic en dehors de cette fenêtre abandonne les modifications — seul "Enregistrer" les valide.
                </div>
              )}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 16, marginBottom: -28, marginLeft: -28, marginRight: -28, padding: "14px 28px", position: "sticky", bottom: -28, background: "#fff", borderTop: `1px solid ${PIERRE}`, borderRadius: "0 0 12px 12px" }}>
                {dossierFacture(commandeEditing) ? (
                  <button type="button" className="sc-btn" onClick={fermerFichePoseModal} style={primaryBtnStyle}>Fermer</button>
                ) : (
                  <button type="button" className="sc-btn" onClick={enregistrerEtFermer} style={primaryBtnStyle}>Enregistrer</button>
                )}
              </div>
            </div>
          </Overlay>
        );
      })()}

      {rappelTechnique && (
        <Overlay onClose={() => setRappelTechnique(null)}>
          <div style={modalStyle(480)}>
            <div style={modalTitleStyle}>Éléments techniques à vérifier</div>
            <div style={{ fontSize: 13, color: TAUPE, marginTop: -8, marginBottom: 12 }}>
              Avant de passer en PL, ces éléments ne sont pas renseignés sur le dossier. Ce n'est qu'un rappel : tu peux continuer.
            </div>
            <ul style={{ margin: "0 0 16px", paddingLeft: 20, fontSize: 13, lineHeight: 1.7 }}>
              {rappelTechnique.manquants.map((m) => (<li key={m}>{m}</li>))}
            </ul>
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", flexWrap: "wrap" }}>
              <button type="button" className="sc-btn" onClick={() => { setRappelTechnique(null); ouvrirElementsTechniquesModal(); }} style={ghostBtnStyle}>🔧 Compléter les éléments techniques</button>
              <button type="button" className="sc-btn" onClick={() => { const suite = rappelTechnique.continuer; setRappelTechnique(null); suite(); }} style={primaryBtnStyle}>Continuer vers le PL</button>
            </div>
          </div>
        </Overlay>
      )}

      {enteteDossierModal && commandeEditing && (() => {
        const v = enteteDossierModal.valeurs;
        const setV = (patch) => setEnteteDossierModal({ ...enteteDossierModal, valeurs: { ...v, ...patch }, erreur: "" });
        const fige = commandeEditing.statut === "Facture";
        const clientSel = clientsActifs.find((c) => c.id === v.clientId);
        const chantiersClient = (chantiers || []).filter((c) => c.clientId === v.clientId);
        return (
          <Overlay onClose={() => setEnteteDossierModal(null)}>
            <div style={modalStyle(760)}>
              <div style={modalTitleStyle}>Modifier l'en-tête — {commandeEditing.numero} ({commandeEditing.statut})</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 14 }}>
                Repris sur tous les documents du dossier (BC, BPRDM, PL, BL, facture) et sur le devis d'origine. Tracé au Journal d'accès. Statut, lignes et exonération de TVA ne se modifient pas ici{fige ? " ; client et remise sont figés (dossier facturé)" : ""}.
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <Field label="Réf. contremarque"><input className="sc-input" value={v.reference || ""} onChange={(e) => setV({ reference: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label="Étage"><input className="sc-input" value={v.etage || ""} onChange={(e) => setV({ etage: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label="Date du devis"><input type="date" className="sc-input" value={v.date || ""} onChange={(e) => setV({ date: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label={fige ? "Client (figé en Facture)" : "Client"}>
                  <select className="sc-select" value={v.clientId || ""} disabled={fige} onChange={(e) => {
                    const c = clientsActifs.find((x) => x.id === e.target.value);
                    setV({
                      clientId: e.target.value,
                      chantierId: "",
                      remiseGlobale: c && c.remise !== "" && c.remise != null ? c.remise : v.remiseGlobale,
                      conditionsPaiement: c && c.paiement ? c.paiement : v.conditionsPaiement,
                      commercialSC: c && c.commercialSC ? c.commercialSC : v.commercialSC,
                      apporteurAffaire: c && c.apporteurAffaire ? c.apporteurAffaire : v.apporteurAffaire,
                      commercialClient: contactsVendeurs(c).length === 1 ? contactsVendeurs(c)[0].nom : "",
                    });
                  }} style={selectStyle}>
                    <option value="">— Sélectionner —</option>
                    {clientsActifs.map((c) => (<option key={c.id} value={c.id}>{c.nom}{c.aValider ? " (à valider)" : ""}</option>))}
                  </select>
                </Field>
                <Field label="Projet immobilier">
                  <select className="sc-select" value={v.chantierId || ""} onChange={(e) => setV({ chantierId: e.target.value })} style={selectStyle} disabled={!v.clientId}>
                    <option value="">— Commande particulier —</option>
                    {chantiersClient.map((c) => (<option key={c.id} value={c.id}>{c.nom}</option>))}
                  </select>
                </Field>
                <Field label="Commercial Stone Concept">
                  <select className="sc-select" value={v.commercialSC || ""} onChange={(e) => setV({ commercialSC: e.target.value })} style={selectStyle}>
                    <option value="">— Non attribué —</option>
                    {trierAlpha(utilisateurs.filter((u) => u.commercial && u.actif), "nom").map((u) => (<option key={u.id} value={u.nom}>{u.nom} — {u.role}</option>))}
                  </select>
                </Field>
                <Field label="Apporteur d'affaire">
                  <select className="sc-select" value={v.apporteurAffaire || ""} onChange={(e) => setV({ apporteurAffaire: e.target.value })} style={selectStyle}>
                    <option value="">— Aucun —</option>
                    {trierAlpha(apporteursAffaire).map((ap) => (<option key={ap} value={ap}>{ap}</option>))}
                  </select>
                </Field>
                <Field label="Commercial du client">
                  <select className="sc-select" value={v.commercialClient || ""} onChange={(e) => setV({ commercialClient: e.target.value })} style={selectStyle} disabled={!v.clientId}>
                    <option value="">— Non renseigné —</option>
                    {trierAlpha(contactsVendeurs(clientSel), "nom").map((c) => (<option key={c.id || c.nom} value={c.nom}>{c.nom}{c.fonction === "Direction" ? " (Direction)" : ""}</option>))}
                  </select>
                </Field>
                <Field label="Conditions de paiement">
                  <select className="sc-select" value={v.conditionsPaiement || ""} onChange={(e) => setV({ conditionsPaiement: e.target.value })} style={selectStyle}>
                    <option value="">— Sélectionner —</option>
                    {trierAlpha(paiements, "label").map((p) => (<option key={p.label} value={p.label}>{p.label}</option>))}
                  </select>
                </Field>
                <Field label="Adresse de livraison"><input className="sc-input" value={v.adresseLivraison || ""} onChange={(e) => setV({ adresseLivraison: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label="Contact sur place — nom et fonction"><input className="sc-input" placeholder="Nom et fonction — ex. M. Alaoui, architecte" value={v.contactSurPlace || ""} onChange={(e) => setV({ contactSurPlace: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label="Téléphone sur place"><input className="sc-input" value={v.telephoneSurPlace || ""} onChange={(e) => setV({ telephoneSurPlace: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label={fige ? "Remise (%) — figée en Facture" : "Remise (%)"}><input type="number" className="sc-input" value={v.remiseGlobale ?? ""} disabled={fige} onChange={(e) => setV({ remiseGlobale: e.target.value })} style={inputStyle(120)} /></Field>
              </div>
              <Field label="Notes de page">
                {(v.notes || []).map((n, i) => (
                  <div key={i} style={{ display: "flex", gap: 8, marginBottom: 6 }}>
                    <input className="sc-input" value={n} onChange={(e) => setV({ notes: v.notes.map((x, j) => (j === i ? e.target.value : x)) })} style={inputStyle("100%")} />
                    <button type="button" className="sc-btn" onClick={() => setV({ notes: v.notes.filter((_, j) => j !== i) })} style={iconBtnStyle}>✕</button>
                  </div>
                ))}
                <button type="button" className="sc-btn" onClick={() => setV({ notes: [...(v.notes || []), ""] })} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>+ Ajouter une note</button>
              </Field>
              {enteteDossierModal.erreur && <div style={errorTextStyle}>{enteteDossierModal.erreur}</div>}
              <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 10 }}>
                <button type="button" className="sc-btn" onClick={() => setEnteteDossierModal(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={enregistrerEnteteNilsDossier} style={primaryBtnStyle}>Enregistrer l'en-tête</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {showArticleForm && articleEditing && (
        <Overlay onClose={() => setShowArticleForm(false)}>
          <div style={modalStyle(440)}>
            <div style={modalTitleStyle}>{articleEditing.id ? "Modifier l'article" : articleCopieDe ? `Nouvel article — copie de ${articleCopieDe}` : "Nouvel article"}</div>
            {!articleEditing.id && articleCopieDe && (
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 14 }}>
                Tout est repris de l'article copié, sauf le code et le lien au Stock (la copie aura sa propre fiche Stock). Modifie ce qui change{articleEditing.categorie === "Tranche" ? " (par exemple le Choix), puis « Générer la nomenclature et la désignation »" : ", puis le code et la désignation"}.
              </div>
            )}
            {articleEditing.categorie !== "Descriptifs" && (
              <Field label="Code (nomenclature)">
                <input className="sc-input" value={articleEditing.code} onChange={(e) => setArticleEditing({ ...articleEditing, code: e.target.value })} style={inputStyle("100%")} />
              </Field>
            )}
            <Field label="Désignation">
              <input className="sc-input" value={articleEditing.designation} onChange={(e) => { setArticleEditing({ ...articleEditing, designation: e.target.value }); if (articleFormError) setArticleFormError(""); }} style={inputStyle("100%")} />
            </Field>
            <div style={{ display: "grid", gridTemplateColumns: articleEditing.categorie === "Descriptifs" ? "1fr" : "1fr 1fr", gap: 12 }}>
              {articleEditing.categorie !== "Descriptifs" && (
                <Field label="Unité">
                  <select className="sc-select" value={articleEditing.unite} onChange={(e) => setArticleEditing({ ...articleEditing, unite: e.target.value })} style={selectStyle}>
                    {(unitesArticles || DEFAULT_UNITES_ARTICLE).map((u) => (<option key={u} value={u}>{u}</option>))}
                  </select>
                  <button type="button" className="sc-btn" onClick={() => setShowUniteManager(true)} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>Gérer les unités</button>
                </Field>
              )}
              <Field label="Catégorie">
                <select className="sc-select" value={articleEditing.categorie} onChange={(e) => {
                  const cat = e.target.value;
                  const natures = { ...(articleEditing.natures || {}) };
                  if (!articleEditing.id) natures.livraison = cat === "Logistique";
                  setArticleEditing({ ...articleEditing, categorie: cat, structurel: cat === "Tranche", natures });
                  if (articleFormError) setArticleFormError("");
                }} style={selectStyle}>
                  <option value="">— Choisir —</option>
                  {trierAlpha(categoriesArticles || DEFAULT_CATEGORIES_ARTICLES).map((f) => (<option key={f} value={f}>{f}</option>))}
                </select>
                <button type="button" className="sc-btn" onClick={() => setShowCategorieManager(true)} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>Gérer les catégories</button>
              </Field>
            </div>
            {categorieStockPourArticle(articleEditing) && (
              <label style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: 13, cursor: "pointer", marginBottom: 14 }}>
                <input
                  type="checkbox"
                  checked={articleEditing.lierAuStock !== false}
                  onChange={(e) => setArticleEditing({ ...articleEditing, lierAuStock: e.target.checked })}
                  style={{ marginTop: 3 }}
                />
                <span>
                  Lier cet article au Stock
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 2 }}>
                    Génère automatiquement sa fiche Produit dans le Stock (sans lot ni quantité — juste la fiche, prête à recevoir du stock réel). Décoche si cet article ne doit pas être suivi en stock.
                  </div>
                </span>
              </label>
            )}
            {articleEditing.categorie !== "Tranche" && articleEditing.categorie !== "Descriptifs" && (
              <label style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: 13, cursor: "pointer", marginBottom: 14 }}>
                <input
                  type="checkbox"
                  checked={!!articleEditing.exonerable}
                  onChange={(e) => setArticleEditing({ ...articleEditing, exonerable: e.target.checked })}
                  style={{ marginTop: 3 }}
                />
                <span>
                  TVA exonérable
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 2 }}>
                    Coche si cet article peut figurer sur un devis/BDC exonéré de TVA. Un devis marqué « exonéré » refusera toute ligne dont l'article n'est pas coché ici.
                  </div>
                </span>
              </label>
            )}
            {articleEditing.categorie === "Tranche" && (
              <div style={{ fontSize: 11, color: TAUPE, marginTop: -6, marginBottom: 14 }}>
                Les Tranches ne se marquent pas exonérables ici : elles suivent le registre des tranches exonérables (à venir), pas cette case à cocher.
              </div>
            )}
            {articleEditing.categorie !== "Tranche" && articleEditing.categorie !== "Descriptifs" && (
              <Field label={`Document important appelé par cet article${peut("catalogue.reglagesArticle") ? "" : " (réglé par le Gérant)"}`}>
                <select className="sc-select" value={articleEditing.documentRequis || ""} disabled={!peut("catalogue.reglagesArticle")} onChange={(e) => setArticleEditing({ ...articleEditing, documentRequis: e.target.value })} style={selectStyle}>
                  {DOCUMENTS_REQUIS_ARTICLE.map((d) => (<option key={d.id} value={d.id}>{d.label}</option>))}
                </select>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                  Ex. découpe évier sous plan / encastrable → Fiche technique évier : une fiche attendue par unité de la ligne.
                </div>
              </Field>
            )}
            {articleEditing.categorie === "Tranche" && (
              <Field label={`Vente au quart de tranche${estGerant ? "" : " (réglée par le Gérant)"}`}>
                <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, cursor: estGerant ? "pointer" : "default", color: estGerant ? ENCRE : TAUPE }}>
                  <input type="checkbox" disabled={!estGerant} checked={!!articleEditing.vendableQuartTranche} onChange={(e) => setArticleEditing({ ...articleEditing, vendableQuartTranche: e.target.checked })} />
                  Vendable au quart de tranche
                </label>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Coché : devis au quart de tranche (1,25 ; 1,5…) et consommation réelle déclarée au quart sur le PL. Décoché : tranches entières. Le changement vaut pour les saisies suivantes, pas pour les devis et PL déjà enregistrés.</div>
              </Field>
            )}
            {articleEditing.categorie === "Tranche" && (
              <Field label={`Listello${estGerant ? "" : " (réglé par le Gérant)"}`}>
                <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, cursor: estGerant ? "pointer" : "default", color: estGerant ? ENCRE : TAUPE }}>
                  <input type="checkbox" disabled={!estGerant} checked={!!articleEditing.utilisableListello} onChange={(e) => setArticleEditing({ ...articleEditing, utilisableListello: e.target.checked })} />
                  Utilisable en listello
                </label>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Coché : ses tranches peuvent sortir en listello (renforts des plans de 4 cm) par « Consommation atelier », au quart de tranche. Les chutes de moins de 1 m² le peuvent toujours.</div>
              </Field>
            )}
            {articleEditing.categorie === "Majorations" && (
              <Field label={`Listellos${estGerant ? "" : " (réglé par le Gérant)"}`}>
                <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, cursor: estGerant ? "pointer" : "default", color: estGerant ? ENCRE : TAUPE }}>
                  <input type="checkbox" disabled={!estGerant} checked={!!articleEditing.demandeListello} onChange={(e) => setArticleEditing({ ...articleEditing, demandeListello: e.target.checked })} />
                  Demande des listellos
                </label>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Coché (ex. façonnage à 45°) : le coût des listellos du mois est réparti sur les dossiers selon la quantité de cette majoration (Prix et coûts).</div>
              </Field>
            )}
            {articleEditing.categorie === "Tranche" && articleEditing.matiere && modeMatiere(articleEditing.matiere) === "famille" && (
              <Field label="Book-match">
                <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, cursor: peut("catalogue.reglagesArticle") ? "pointer" : "default" }}>
                  <input type="checkbox" disabled={!peut("catalogue.reglagesArticle")} checked={!!articleEditing.bookmatch} onChange={(e) => setArticleEditing({ ...articleEditing, bookmatch: e.target.checked })} />
                  Existe en book-match (tranches A et B en miroir)
                </label>
                {articleEditing.bookmatch && (
                  <div style={{ display: "flex", gap: 16, fontSize: 13, marginTop: 6, paddingLeft: 24 }}>
                    {[["aleatoire", "Aléatoire (on découvre A / B à la réception)"], ["separe", "A et B vendus séparément (quantités connues à la commande)"]].map(([v, lib]) => (
                      <label key={v} style={{ display: "flex", gap: 6, alignItems: "center", cursor: peut("catalogue.reglagesArticle") ? "pointer" : "default" }}>
                        <input type="radio" name="bookmatchMode" disabled={!peut("catalogue.reglagesArticle")} checked={(articleEditing.bookmatchMode || "aleatoire") === v} onChange={() => setArticleEditing({ ...articleEditing, bookmatchMode: v })} />{lib}
                      </label>
                    ))}
                  </div>
                )}
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>À la réception, le Production Manager répartit les tranches en A / B / sans marquage ; au devis, case « Book-match demandé » sur la ligne.</div>
              </Field>
            )}
            {articleEditing.categorie !== "Descriptifs" && (
              <Field label={`Nature de l'article${peut("catalogue.reglagesArticle") ? "" : " (réglée par le Gérant)"}`}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px 18px", fontSize: 13 }}>
                  {NATURES_ARTICLE.map((n) => (
                    <label key={n.cle} style={{ display: "flex", gap: 6, alignItems: "center", cursor: peut("catalogue.reglagesArticle") ? "pointer" : "default", color: peut("catalogue.reglagesArticle") ? ENCRE : TAUPE }}>
                      <input type="checkbox" disabled={!peut("catalogue.reglagesArticle")} checked={natureArticle(articleEditing, n.cle)}
                        onChange={(e) => setArticleEditing({ ...articleEditing, natures: { ...(articleEditing.natures || {}), [n.cle]: e.target.checked, ...(n.cle === "decoupe" && e.target.checked ? { faconnage: true } : {}) }, naturesAVerifier: false })} />
                      {n.label}
                    </label>
                  ))}
                </div>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                  Pose : étage, fiche de pose, consommables et photos de pose, coût de pose, planning de pose. Façonnage : dessin technique validé par le client avant le PL, coût atelier, planning de production. Livraison : contact sur place, forfait livraison. RDM : BPRDM obligatoire (sans article de RDM, passage direct en PL), forfait RDM. Découpe unitaire : compte pour l'usure des consommables réglés « à la découpe » (fraises, forets…) ; la cocher coche aussi Façonnage (décochable). Une ligne libre (sans article) n'a aucun de ces effets.
                </div>
                {natureArticle(articleEditing, "livraison") && (
                  <div style={{ marginTop: 8 }}>
                    <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>Zone de livraison (coût : Prix et coûts › Forfaits transport)</div>
                    <select className="sc-select" value={articleEditing.zoneLivraison || ""} disabled={!peut("catalogue.reglagesArticle")} onChange={(e) => setArticleEditing({ ...articleEditing, zoneLivraison: e.target.value })} style={selectStyle}>
                      <option value="">— Choisir —</option>
                      {(transportCouts().zones || []).map((z) => (<option key={z.id} value={z.id}>{z.nom}</option>))}
                    </select>
                  </div>
                )}
                {articleEditing.naturesAVerifier && (
                  <div style={{ fontSize: 11, color: OCRE, fontWeight: 600, marginTop: 4 }}>Cases pré-cochées automatiquement le 12/10 d'après les anciens réglages — à vérifier{peut("catalogue.reglagesArticle") ? " (enregistrer l'article vaut vérification)" : " par le Gérant"}.</div>
                )}
              </Field>
            )}
            {articleEditing.categorie !== "Descriptifs" && (
              <label style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: 13, cursor: "pointer", marginBottom: 14 }}>
                <input
                  type="checkbox"
                  checked={!!articleEditing.exclureCommission}
                  onChange={(e) => setArticleEditing({ ...articleEditing, exclureCommission: e.target.checked })}
                  style={{ marginTop: 3 }}
                />
                <span>
                  Exclure des commissions
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 2 }}>
                    Coche si cet article ne doit jamais entrer dans le calcul des commissions commerciales.
                  </div>
                </span>
              </label>
            )}
            {articleEditing.id && articleEditing.creePar && !droitsDe(articleEditing.creePar).has("catalogue.validerArticles") && (
              peut("catalogue.validerArticles") ? (
                <label style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: 13, cursor: "pointer", marginBottom: 14 }}>
                  <input
                    type="checkbox"
                    checked={!!articleEditing.valideParNils}
                    onChange={(e) => setArticleEditing({ ...articleEditing, valideParNils: e.target.checked })}
                    style={{ marginTop: 3 }}
                  />
                  <span>
                    Validé par le Gérant
                    <div style={{ fontSize: 11, color: TAUPE, marginTop: 2 }}>
                      Article créé par {(utilisateurs.find((u) => u.id === articleEditing.creePar) || {}).nom || articleEditing.creePar} — reste utilisable tel quel, mais cette case signale s'il a déjà été vérifié.
                    </div>
                  </span>
                </label>
              ) : (
                <div style={{ fontSize: 13, marginBottom: 14 }}>
                  Statut&nbsp;: {articleEditing.valideParNils ? "Validé par le Gérant" : "Non validé par le Gérant"}
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 2 }}>
                    Article créé par {nomUtilisateur(articleEditing.creePar) || "?"} — seul le Gérant peut valider cet article.
                  </div>
                </div>
              )
            )}
            {articleEditing.categorie === "Tranche" ? (
              <>
                <Field label="Matière">
                  <select className="sc-select" value={articleEditing.matiere} onChange={(e) => {
                    const m = e.target.value;
                    const epaisseursValides = EPAISSEURS_PAR_MATIERE[m] || EPAISSEURS_MATIERE;
                    const epaisseur = epaisseursValides.includes(articleEditing.epaisseurMatiere) ? articleEditing.epaisseurMatiere : (epaisseursValides.length === 1 ? epaisseursValides[0] : "");
                    setArticleEditing({ ...articleEditing, matiere: m, epaisseurMatiere: epaisseur });
                    if (articleFormError) setArticleFormError("");
                  }} style={selectStyle}>
                    {MATIERES.map((m) => (<option key={m} value={m}>{m}</option>))}
                  </select>
                  {peutGererMatieres && <button type="button" className="sc-btn" onClick={() => { setMatiereError(""); setShowMatiereManager(true); }} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>Gérer les matières</button>}
                </Field>
                <Field label="Épaisseur de la matière brute (sert à filtrer les couleurs disponibles)">
                  <select className="sc-select" value={articleEditing.epaisseurMatiere || ""} onChange={(e) => { setArticleEditing({ ...articleEditing, epaisseurMatiere: e.target.value }); if (articleFormError) setArticleFormError(""); }} style={selectStyle}>
                    <option value="">— Sélectionner —</option>
                    {(EPAISSEURS_PAR_MATIERE[articleEditing.matiere] || EPAISSEURS_MATIERE).map((ep) => (<option key={ep} value={ep}>{ep}</option>))}
                  </select>
                </Field>
                <Field label="Finition">
                  <select className="sc-select" value={articleEditing.finition || ""} onChange={(e) => { setArticleEditing({ ...articleEditing, finition: e.target.value }); if (articleFormError) setArticleFormError(""); }} style={selectStyle}>
                    <option value="">— Sélectionner —</option>
                    {trierAlpha(finitionsListe.map((f) => f.nom)).map((f) => (<option key={f} value={f}>{f}</option>))}
                  </select>
                  <button type="button" className="sc-btn" onClick={() => setShowFinitionManager(true)} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>Gérer les finitions</button>
                </Field>
                <Field label="Dimension">
                  <select className="sc-select" value={articleEditing.dimension || ""} onChange={(e) => { setArticleEditing({ ...articleEditing, dimension: e.target.value }); if (articleFormError) setArticleFormError(""); }} style={selectStyle}>
                    <option value="">— Sélectionner —</option>
                    {trierAlpha(dimensionsList || DEFAULT_DIMENSIONS).map((d) => (<option key={d} value={d}>{d}</option>))}
                  </select>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Cette liste sert aussi aux filtres du Stock.</div>
                  <button type="button" className="sc-btn" onClick={() => { setFormatError(""); setShowFormatManager(true); }} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>Gérer les formats</button>
                </Field>
                <Field label="Choix">
                  <select className="sc-select" value={articleEditing.choix || ""} onChange={(e) => setArticleEditing({ ...articleEditing, choix: e.target.value })} style={selectStyle}>
                    <option value="">—</option>
                    {CHOIX.map((c) => (<option key={c} value={c}>{c}</option>))}
                  </select>
                </Field>
                {modeMatiere(articleEditing.matiere) === "famille" && (
                  <div style={{ fontSize: 12, color: TAUPE, background: PIERRE, borderRadius: 6, padding: "8px 12px", marginBottom: 14 }}>
                    Cette matière est codifiée en nuances dans le Stock — la nuance précise se renseigne au moment de la réservation ou de la production, jamais ici. Le code de cet article reste le même quelle que soit la nuance du lot utilisé.
                  </div>
                )}
                <Field label="Fournisseur">
                  <select className="sc-select" value={articleEditing.fournisseur || ""} onChange={(e) => setArticleEditing({ ...articleEditing, fournisseur: e.target.value })} style={selectStyle}>
                    <option value="">— Choisir —</option>
                    {trierAlpha(fournisseurs, "nom").map((f) => (<option key={f.id}>{f.nom}</option>))}
                  </select>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                    Une couleur vient toujours du même fournisseur — se reprend automatiquement à l'ajout d'un lot en Stock, pas la peine de le resaisir.
                  </div>
                </Field>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                  <Field label={modeMatiere(articleEditing.matiere) === "couleur" ? "Couleur Fournisseur" : "Couleur Fournisseur (facultatif)"}>
                    <input className="sc-input" value={articleEditing.couleurFournisseur || ""} onChange={(e) => { setArticleEditing({ ...articleEditing, couleurFournisseur: e.target.value }); if (articleFormError) setArticleFormError(""); }} style={inputStyle("100%")} placeholder="ex. nom chez le fournisseur" />
                    {modeMatiere(articleEditing.matiere) === "couleur" && (
                      <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                        Obligatoire pour le {articleEditing.matiere} — sert de clé au registre des tranches exonérables (fournisseur + couleur fournisseur). Saisie libre : une faute de frappe créerait un second registre pour la même couleur.
                      </div>
                    )}
                  </Field>
                  <Field label="Code Fournisseur (facultatif)">
                    <input className="sc-input" value={articleEditing.codeFournisseur || ""} onChange={(e) => setArticleEditing({ ...articleEditing, codeFournisseur: e.target.value })} style={inputStyle("100%")} placeholder="ex. réf. catalogue fournisseur" />
                  </Field>
                </div>
                <Field label="Groupe de couleur (facultatif)">
                  <select className="sc-select" value={articleEditing.groupeCouleur || ""} onChange={(e) => setArticleEditing({ ...articleEditing, groupeCouleur: e.target.value })} style={selectStyle}>
                    <option value="">— Sélectionner —</option>
                    {trierAlpha(groupesCouleurArticles || DEFAULT_GROUPES_COULEUR_ARTICLE).map((g) => (<option key={g} value={g}>{g}</option>))}
                  </select>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Classement large (Blancs, Gris, Noirs…) utilisé pour filtrer le Stock.</div>
                  <button type="button" className="sc-btn" onClick={() => setShowGroupeCouleurManager(true)} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>Gérer les groupes de couleur</button>
                </Field>
                <Field label="Groupe de couleur secondaire (facultatif)">
                  <select className="sc-select" value={articleEditing.groupeCouleur2 || ""} onChange={(e) => setArticleEditing({ ...articleEditing, groupeCouleur2: e.target.value })} style={selectStyle}>
                    <option value="">— Sélectionner —</option>
                    {trierAlpha(groupesCouleurArticles || DEFAULT_GROUPES_COULEUR_ARTICLE).map((g) => (<option key={g} value={g}>{g}</option>))}
                  </select>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Pour les couleurs ambiguës (ex. un blanc presque beige, ou une couleur avec du noir et du rouge) : la tranche apparaîtra sous les deux filtres Stock.</div>
                </Field>
                <div style={{ marginBottom: 14 }}>
                  <button
                    type="button"
                    className="sc-btn"
                    onClick={() => {
                      setArticleEditing({
                        ...articleEditing,
                        code: calculerNomenclatureTranche(articleEditing),
                        designation: calculerDesignationTranche(articleEditing),
                      });
                      if (articleFormError) setArticleFormError("");
                    }}
                    style={ghostBtnStyle}
                  >
                    🔄 Générer la nomenclature et la désignation
                  </button>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                    À partir de Matière, Épaisseur, Finition, Choix, Couleur et Code Fournisseur. Écrase le contenu actuel de Code et Désignation — tu peux les retoucher à la main ensuite.
                  </div>
                </div>
                <Field label="Groupe tarifaire">
                  <select className="sc-select" value={articleEditing.groupe || ""} onChange={(e) => { setArticleEditing({ ...articleEditing, groupe: Number(e.target.value) || null }); if (articleFormError) setArticleFormError(""); }} style={selectStyle}>
                    <option value="">— Sélectionner —</option>
                    {GROUPES.map((g) => {
                      const est2eChoixApercu = (articleEditing.choix || "").startsWith("2");
                      const tableApercu = est2eChoixApercu ? prixGroupesTranche2eChoix : prixGroupesTranche;
                      const ligne = tableApercu && articleEditing.matiere && articleEditing.epaisseurMatiere
                        ? tableApercu[cleCombinaisonTranche(articleEditing.matiere, articleEditing.epaisseurMatiere)]
                        : null;
                      const prixM2 = ligne ? ligne[g] : null;
                      let label = `Groupe ${g}`;
                      if (prixM2 == null) {
                        label += " — prix au m² non défini";
                      } else if (!articleEditing.dimension) {
                        label += ` — ${fmtMAD(prixM2)}/m² (choisis une Dimension pour voir le prix à la tranche)`;
                      } else {
                        const prixTranche = prixGroupeArticle(articleEditing, g);
                        label += ` — ${fmtMAD(prixTranche)} / tranche (${fmtMAD(prixM2)}/m²)`;
                      }
                      return <option key={g} value={g}>{label}</option>;
                    })}
                  </select>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                    Le prix au m² de chaque groupe se gère dans l'onglet Prix et coûts, tableau « Grille de vente — {(articleEditing.choix || "").startsWith("2") ? "2e" : "1er"} choix », pour la ligne {articleEditing.matiere || "…"} {articleEditing.epaisseurMatiere || "…"}. Le prix à la tranche affiché ci-dessus est calculé automatiquement à partir de la Dimension choisie.
                  </div>
                </Field>
              </>
            ) : articleEditing.categorie === "Descriptifs" ? null : (
              <>
                {categorieStockPourArticle(articleEditing) && (
                  <Field label="Fournisseur">
                    <select className="sc-select" value={articleEditing.fournisseur || ""} onChange={(e) => setArticleEditing({ ...articleEditing, fournisseur: e.target.value })} style={selectStyle}>
                      <option value="">— Sélectionner —</option>
                      {trierAlpha(fournisseurs, "nom").map((f) => (<option key={f.id} value={f.nom}>{f.nom}</option>))}
                    </select>
                    <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                      Fixé une fois pour toutes ici — contrairement à un consommable, cet article ne s'achète pas chez plusieurs fournisseurs.
                    </div>
                  </Field>
                )}
                <Field label="Prix public HT (jamais modifié à la volée — se gère ici uniquement)">
                  <input type="number" className="sc-input" value={articleEditing.prixPublic} onChange={(e) => setArticleEditing({ ...articleEditing, prixPublic: e.target.value })} style={inputStyle("100%")} />
                </Field>
              </>
            )}

            {CATEGORIES_AVEC_PROVENANCE.includes(articleEditing.categorie) && (
              <Field label={articleEditing.id ? "Provenance" : "Provenance *"}>
                <div style={{ display: "flex", gap: 8 }}>
                  {PROVENANCES.map((pv) => (
                    <button key={pv} type="button" className="sc-btn" onClick={() => { setArticleEditing({ ...articleEditing, provenance: pv }); if (articleFormError) setArticleFormError(""); }} style={{ ...ghostBtnStyle, padding: "6px 14px", border: `1px solid ${articleEditing.provenance === pv ? ENCRE : TAUPE}`, background: articleEditing.provenance === pv ? ENCRE : "transparent", color: articleEditing.provenance === pv ? PIERRE : ENCRE }}>{pv === "Local" ? "Acheté localement" : "Importé"}</button>
                  ))}
                </div>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Importé : coût de revient par profil d'import et arrivages. Local : prix d'achat du lot (+ transport d'approche éventuel).</div>
              </Field>
            )}
            {estGerant && articleEditing.categorie === "Tranche" && articleEditing.provenance === "Importé" && (() => {
              const profil = profilTranchesPour(articleEditing.fournisseur, articleEditing.matiere);
              return (
                <Field label="Groupe fournisseur (visible par le Gérant seul)">
                  {profil ? (
                    <select className="sc-select" value={articleEditing.groupeFournisseur ?? ""} onChange={(e) => setArticleEditing({ ...articleEditing, groupeFournisseur: e.target.value === "" ? "" : Number(e.target.value) })} style={selectStyle}>
                      <option value="">— Sélectionner —</option>
                      {(profil.groupes || []).map((g, i) => {
                        const c = coutTrancheProfil(profil, i, articleEditing.epaisseurMatiere, choixNum(articleEditing.choix));
                        return <option key={i} value={i}>{g.nom}{c ? ` — coût standard ${fmtMAD(c.total)} / tranche` : ""}</option>;
                      })}
                    </select>
                  ) : (
                    <div style={{ fontSize: 12, color: ROUILLE }}>Aucun profil d'import pour {articleEditing.fournisseur || "ce fournisseur"} / {articleEditing.matiere} : crée-le dans Prix et coûts › Calcul de revient.</div>
                  )}
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Groupe budgétaire du fournisseur (prix d'achat), indépendant du groupe tarifaire de vente.</div>
                </Field>
              );
            })()}

            {articleFormError && (
              <div style={{ background: "#F5E4DE", color: ROUILLE, fontSize: 13, fontWeight: 600, padding: "10px 12px", borderRadius: 6, marginTop: 14 }}>
                {articleFormError}
              </div>
            )}

            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 10 }}>
              <button type="button" className="sc-btn" onClick={() => setShowArticleForm(false)} style={ghostBtnStyle}>Annuler</button>
              <button type="button" className="sc-btn" onClick={enregistrerArticle} style={primaryBtnStyle}>Enregistrer</button>
            </div>
          </div>
        </Overlay>
      )}
      {showCategorieManager && (
        <Overlay onClose={() => setShowCategorieManager(false)}>
          <div style={modalStyle(380)}>
            <div style={modalTitleStyle}>Catégories d'articles</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16, maxHeight: 220, overflowY: "auto" }}>
              {(categoriesArticles || DEFAULT_CATEGORIES_ARTICLES).map((cat) => (
                <div key={cat} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 10px", borderRadius: 6, background: PIERRE }}>
                  <span style={{ fontSize: 13 }}>{cat}</span>
                  <button type="button" className="sc-btn" onClick={() => supprimerCategorie(cat)} style={iconBtnStyle}>✕</button>
                </div>
              ))}
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <input className="sc-input" value={newCategorie} onChange={(e) => setNewCategorie(e.target.value)} style={inputStyle("100%")} placeholder="Nouvelle catégorie" />
              <button type="button" className="sc-btn" onClick={ajouterCategorie} style={primaryBtnStyle}>Ajouter</button>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <button type="button" className="sc-btn" onClick={() => setShowCategorieManager(false)} style={ghostBtnStyle}>Fermer</button>
            </div>
          </div>
        </Overlay>
      )}

      {showUniteManager && (
        <Overlay onClose={() => setShowUniteManager(false)}>
          <div style={modalStyle(380)}>
            <div style={modalTitleStyle}>Unités d'articles</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16, maxHeight: 220, overflowY: "auto" }}>
              {(unitesArticles || DEFAULT_UNITES_ARTICLE).map((u) => (
                <div key={u} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 10px", borderRadius: 6, background: PIERRE }}>
                  <span style={{ fontSize: 13 }}>{u}</span>
                  <button type="button" className="sc-btn" onClick={() => supprimerUnite(u)} style={iconBtnStyle}>✕</button>
                </div>
              ))}
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <input className="sc-input" value={newUnite} onChange={(e) => setNewUnite(e.target.value)} style={inputStyle("100%")} placeholder="Nouvelle unité (ex. ML, Kg, m²…)" />
              <button type="button" className="sc-btn" onClick={ajouterUnite} style={primaryBtnStyle}>Ajouter</button>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <button type="button" className="sc-btn" onClick={() => setShowUniteManager(false)} style={ghostBtnStyle}>Fermer</button>
            </div>
          </div>
        </Overlay>
      )}

      {showFinitionManager && (
        <Overlay onClose={() => setShowFinitionManager(false)}>
          <div style={modalStyle(380)}>
            <div style={modalTitleStyle}>Finitions</div>
            <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 12 }}>
              La lettre (1 ou 2) entre dans le code article : T + matière + épaisseur + code fournisseur + <b>finition</b> + choix. Changer une lettre ne modifie pas les articles déjà créés (seulement une nouvelle génération de la nomenclature).
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16, maxHeight: 220, overflowY: "auto" }}>
              {finitionsListe.map((f) => (
                <div key={f.nom} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", borderRadius: 6, background: PIERRE }}>
                  <span style={{ fontSize: 13, flex: 1 }}>{f.nom}</span>
                  <input className="sc-input" value={lettresFinitionsSaisies[f.nom] ?? f.lettre} maxLength={2} title="Lettre de nomenclature" onChange={(e) => setLettresFinitionsSaisies({ ...lettresFinitionsSaisies, [f.nom]: e.target.value.toUpperCase() })} onBlur={() => changerLettreFinition(f.nom)} onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); }} style={{ ...inputStyle(52), textAlign: "center" }} />
                  <button type="button" className="sc-btn" onClick={() => supprimerFinition(f.nom)} style={iconBtnStyle}>✕</button>
                </div>
              ))}
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <input className="sc-input" value={newFinition} onChange={(e) => { setNewFinition(e.target.value); if (finitionError) setFinitionError(""); }} style={inputStyle("100%")} placeholder="Nouvelle finition (ex. Satiné)" />
              <input className="sc-input" value={newFinitionLettre} maxLength={2} onChange={(e) => { setNewFinitionLettre(e.target.value.toUpperCase()); if (finitionError) setFinitionError(""); }} style={{ ...inputStyle(52), textAlign: "center" }} placeholder={lettreParDefautFinition(newFinition) || "Lettre"} title="Lettre de nomenclature (1 ou 2) — par défaut la 1re lettre du nom" />
              <button type="button" className="sc-btn" onClick={ajouterFinition} style={primaryBtnStyle}>Ajouter</button>
            </div>
            {finitionError && <div style={{ color: ROUILLE, fontSize: 12, marginTop: 8 }}>{finitionError}</div>}
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <button type="button" className="sc-btn" onClick={() => setShowFinitionManager(false)} style={ghostBtnStyle}>Fermer</button>
            </div>
          </div>
        </Overlay>
      )}

      {showMatiereManager && (
        <Overlay onClose={() => setShowMatiereManager(false)} zIndex={1200}>
          <div style={modalStyle(520)}>
            <div style={modalTitleStyle}>Matières des tranches</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 14, maxHeight: 220, overflowY: "auto" }}>
              {[...MATIERES_DE_BASE.map((m) => ({ ...m, base: true })), ...(matieresPerso || [])].map((m) => (
                <div key={m.nom} style={{ display: "flex", alignItems: "center", gap: 10, padding: "7px 10px", borderRadius: 6, background: PIERRE, fontSize: 13 }}>
                  <strong style={{ minWidth: 110 }}>{m.nom}</strong>
                  <span style={{ color: TAUPE, fontSize: 12, flex: 1 }}>lettre {m.lettre} · {(m.epaisseurs || []).join(", ")} · {m.mode === "famille" ? "familles + nuances" : "chaque couleur à part"}</span>
                  {m.base ? <span style={{ fontSize: 11, color: TAUPE }}>de base</span> : <button type="button" className="sc-btn" onClick={() => supprimerMatiere(m.nom)} style={iconBtnStyle} title="Supprimer (seulement si aucun article ne l'utilise)">✕</button>}
                </div>
              ))}
            </div>
            <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 8 }}>Nouvelle matière</div>
            <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 10 }}>
              <Field label="Nom">
                <input className="sc-input" value={nouvelleMatiere.nom} onChange={(e) => setNouvelleMatiere({ ...nouvelleMatiere, nom: e.target.value, lettre: nouvelleMatiere.lettre || e.target.value.trim().charAt(0).toUpperCase() })} style={{ ...inputStyle("100%"), background: "#fff", border: `1px solid ${TAUPE}` }} placeholder="ex. Marbre, Granit, Dekton" />
              </Field>
              <Field label="Lettre (code)">
                <input className="sc-input" value={nouvelleMatiere.lettre} maxLength={1} onChange={(e) => setNouvelleMatiere({ ...nouvelleMatiere, lettre: e.target.value.toUpperCase() })} style={{ ...inputStyle("100%"), background: "#fff", border: `1px solid ${TAUPE}` }} placeholder="M" />
              </Field>
            </div>
            <div style={{ fontSize: 11, color: TAUPE, marginTop: -8, marginBottom: 10 }}>
              La lettre entre dans le code article : T + lettre + épaisseur + code fournisseur + finition + choix (ex. TM20…). Déjà prises : {Object.values(MATIERE_CODE_NOMENCLATURE).join(", ")}.
            </div>
            <Field label="Mot utilisé dans la désignation (facultatif, sinon le nom)">
              <input className="sc-input" value={nouvelleMatiere.libelle} onChange={(e) => setNouvelleMatiere({ ...nouvelleMatiere, libelle: e.target.value })} style={{ ...inputStyle("100%"), background: "#fff", border: `1px solid ${TAUPE}` }} placeholder={nouvelleMatiere.nom ? `Tranche ${nouvelleMatiere.nom} …` : "ex. Marbre"} />
            </Field>
            <Field label="Épaisseurs vendues">
              <div style={{ display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap", fontSize: 13 }}>
                {EPAISSEURS_MATIERE.map((ep) => (
                  <label key={ep} style={{ display: "flex", gap: 4, alignItems: "center" }}>
                    <input type="checkbox" checked={nouvelleMatiere.epaisseurs.includes(ep)} onChange={() => setNouvelleMatiere({ ...nouvelleMatiere, epaisseurs: nouvelleMatiere.epaisseurs.includes(ep) ? nouvelleMatiere.epaisseurs.filter((x) => x !== ep) : [...nouvelleMatiere.epaisseurs, ep] })} />{ep}
                  </label>
                ))}
                <input className="sc-input" value={nouvelleMatiere.autre} onChange={(e) => setNouvelleMatiere({ ...nouvelleMatiere, autre: e.target.value })} style={{ ...inputStyle(150), background: "#fff", border: `1px solid ${TAUPE}`, padding: "4px 8px" }} placeholder="autre(s) : 30, 8…" />
              </div>
            </Field>
            <Field label="Suivi des couleurs">
              <div style={{ display: "flex", flexDirection: "column", gap: 6, fontSize: 13 }}>
                <label style={{ display: "flex", gap: 6, alignItems: "flex-start" }}>
                  <input type="radio" name="modeMatiere" checked={nouvelleMatiere.mode !== "famille"} onChange={() => setNouvelleMatiere({ ...nouvelleMatiere, mode: "couleur" })} />
                  <span>Comme le Quartz : chaque couleur à part, couleur fournisseur obligatoire, pas de nuances.</span>
                </label>
                <label style={{ display: "flex", gap: 6, alignItems: "flex-start" }}>
                  <input type="radio" name="modeMatiere" checked={nouvelleMatiere.mode === "famille"} onChange={() => setNouvelleMatiere({ ...nouvelleMatiere, mode: "famille" })} />
                  <span>Comme le Grès Cérame : couleurs regroupées en familles (fournisseur + code + finition), nuances suivies au Stock, une couleur peut en remplacer une autre de la même famille à la réservation.</span>
                </label>
              </div>
            </Field>
            {matiereError && <div style={{ color: ROUILLE, fontSize: 12, marginBottom: 8 }}>{matiereError}</div>}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 6 }}>
              <button type="button" className="sc-btn" onClick={() => setShowMatiereManager(false)} style={ghostBtnStyle}>Fermer</button>
              <button type="button" className="sc-btn" onClick={ajouterMatiere} style={primaryBtnStyle}>Ajouter la matière</button>
            </div>
          </div>
        </Overlay>
      )}

      {showGroupeCouleurManager && (
        <Overlay onClose={() => setShowGroupeCouleurManager(false)}>
          <div style={modalStyle(380)}>
            <div style={modalTitleStyle}>Groupes de couleur</div>
            <div style={{ fontSize: 11, color: TAUPE, marginTop: -6, marginBottom: 14 }}>
              Classement large par teinte (Blancs, Gris, Noirs…), utilisé pour filtrer le Stock. Distinct de la « famille couleur » automatique (fournisseur + code + finition) utilisée pour les réservations.
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16, maxHeight: 220, overflowY: "auto" }}>
              {(groupesCouleurArticles || DEFAULT_GROUPES_COULEUR_ARTICLE).map((g) => (
                <div key={g} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 10px", borderRadius: 6, background: PIERRE }}>
                  <span style={{ fontSize: 13 }}>{g}</span>
                  <button type="button" className="sc-btn" onClick={() => supprimerGroupeCouleur(g)} style={iconBtnStyle}>✕</button>
                </div>
              ))}
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <input className="sc-input" value={newGroupeCouleur} onChange={(e) => setNewGroupeCouleur(e.target.value)} style={inputStyle("100%")} placeholder="Nouveau groupe (ex. Blancs)" />
              <button type="button" className="sc-btn" onClick={ajouterGroupeCouleur} style={primaryBtnStyle}>Ajouter</button>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <button type="button" className="sc-btn" onClick={() => setShowGroupeCouleurManager(false)} style={ghostBtnStyle}>Fermer</button>
            </div>
          </div>
        </Overlay>
      )}

      {showApporteurManager && (
        <Overlay onClose={() => setShowApporteurManager(false)}>
          <div style={modalStyle(380)}>
            <div style={modalTitleStyle}>Apporteurs d'affaire</div>
            <div style={{ fontSize: 12, color: TAUPE, marginBottom: 12 }}>
              Liste libre, indépendante des comptes de l'app — un apporteur peut être externe à Stone Concept. Jamais imprimé sur les documents client.
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16, maxHeight: 220, overflowY: "auto" }}>
              {(apporteursAffaire || []).length === 0 && <div style={{ fontSize: 12, color: TAUPE }}>Aucun apporteur enregistré.</div>}
              {(apporteursAffaire || []).map((ap) =>
                apporteurEdition && apporteurEdition.ancien === ap ? (
                  <div key={ap} style={{ display: "flex", alignItems: "center", gap: 6, padding: "8px 10px", borderRadius: 6, background: PIERRE }}>
                    <input
                      className="sc-input"
                      autoFocus
                      value={apporteurEdition.valeur}
                      onChange={(e) => setApporteurEdition({ ...apporteurEdition, valeur: e.target.value })}
                      onKeyDown={(e) => { if (e.key === "Enter") validerEditionApporteur(); if (e.key === "Escape") annulerEditionApporteur(); }}
                      style={{ ...inputStyle("100%"), flex: 1 }}
                    />
                    <button type="button" className="sc-btn" onClick={validerEditionApporteur} style={iconBtnStyle} title="Enregistrer">✓</button>
                    <button type="button" className="sc-btn" onClick={annulerEditionApporteur} style={iconBtnStyle} title="Annuler">✕</button>
                  </div>
                ) : (
                  <div key={ap} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 10px", borderRadius: 6, background: PIERRE }}>
                    <span style={{ fontSize: 13 }}>{ap}</span>
                    <div style={{ display: "flex", gap: 4 }}>
                      <button type="button" className="sc-btn" onClick={() => commencerEditionApporteur(ap)} style={iconBtnStyle} title="Modifier">✎</button>
                      <button type="button" className="sc-btn" onClick={() => supprimerApporteur(ap)} style={iconBtnStyle} title="Supprimer">✕</button>
                    </div>
                  </div>
                )
              )}
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <input className="sc-input" value={newApporteur} onChange={(e) => setNewApporteur(e.target.value)} style={inputStyle("100%")} placeholder="Nom de l'apporteur" />
              <button type="button" className="sc-btn" onClick={ajouterApporteur} style={primaryBtnStyle}>Ajouter</button>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <button type="button" className="sc-btn" onClick={() => { setShowApporteurManager(false); setApporteurEdition(null); }} style={ghostBtnStyle}>Fermer</button>
            </div>
          </div>
        </Overlay>
      )}

      {showEnAttenteManager && commandeEditing && (
        <Overlay onClose={() => setShowEnAttenteManager(false)}>
          <div style={modalStyle(380)}>
            <div style={modalTitleStyle}>Options « En attente de » — {commandeEditing.statut}</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16, maxHeight: 220, overflowY: "auto" }}>
              {((enAttenteParStatut || DEFAULT_EN_ATTENTE_PAR_STATUT)[commandeEditing.statut] || []).map((o) => (
                <div key={o} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 10px", borderRadius: 6, background: PIERRE }}>
                  <span style={{ fontSize: 13 }}>{o}</span>
                  <button type="button" className="sc-btn" onClick={() => supprimerOptionEnAttente(commandeEditing.statut, o)} style={iconBtnStyle}>✕</button>
                </div>
              ))}
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <input className="sc-input" value={newOptionEnAttente} onChange={(e) => setNewOptionEnAttente(e.target.value)} style={inputStyle("100%")} placeholder="Nouvelle option" />
              <button type="button" className="sc-btn" onClick={() => { ajouterOptionEnAttente(commandeEditing.statut, newOptionEnAttente); setNewOptionEnAttente(""); }} style={primaryBtnStyle}>Ajouter</button>
            </div>
            <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>
              Propre à l'étape {commandeEditing.statut} — les autres étapes ont leur propre liste.
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <button type="button" className="sc-btn" onClick={() => setShowEnAttenteManager(false)} style={ghostBtnStyle}>Fermer</button>
            </div>
          </div>
        </Overlay>
      )}

      {showReception && receptionLot && (
        <Overlay onClose={() => setShowReception(false)}>
          <div style={modalStyle(380)}>
            <div style={modalTitleStyle}>Réceptionner un arrivage</div>
            <div style={{ fontSize: 13, color: TAUPE, marginBottom: 16 }}>
              {nomProduit(receptionLot.produitId)}{receptionLot.fournisseur ? ` — ${receptionLot.fournisseur}` : ""} · arrivage prévu : <strong>{receptionLot.arrivages} {receptionLot.unite}</strong>
            </div>
            {produitBookMatch(receptionLot.produitId) && receptionLot.type !== TYPE_CHUTE && !receptionLot.bm ? (
              <Field label={`Book-match — contrôle au déchargement (sur ${receptionLot.arrivages} prévus${receptionLot.arrivageA !== undefined || receptionLot.arrivageB !== undefined ? ` : A ${receptionLot.arrivageA || 0} · B ${receptionLot.arrivageB || 0}` : ""})`}>
                <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", fontSize: 13 }}>
                  {[["a", "A"], ["b", "B"], ["s", "Sans marquage"]].map(([k, lib]) => (
                    <span key={k} style={{ display: "flex", gap: 6, alignItems: "center" }}>
                      {lib}
                      <input type="number" min="0" className="sc-input" value={receptionBM[k]} onChange={(e) => { const nx = { ...receptionBM, [k]: e.target.value }; setReceptionBM(nx); setReceptionQuantite(String((Number(nx.a) || 0) + (Number(nx.b) || 0) + (Number(nx.s) || 0))); if (receptionError) setReceptionError(""); }} style={{ ...inputStyle(70), padding: "6px 8px" }} />
                    </span>
                  ))}
                </div>
                <div style={{ fontSize: 12, marginTop: 6 }}>Total reçu : <strong>{receptionQuantite || 0}</strong> {receptionLot.unite}</div>
              </Field>
            ) : (
            <Field label={`Quantité réellement reçue (sur ${receptionLot.arrivages} prévus)`}>
              <input
                type="number"
                min="0"

                className="sc-input"
                value={receptionQuantite}
                onChange={(e) => {
                  setReceptionQuantite(e.target.value);
                  if (receptionError) setReceptionError("");
                }}
                style={inputStyle("100%")}
              />
            </Field>
            )}
            {Number(receptionQuantite) > 0 && Number(receptionQuantite) !== Number(receptionLot.arrivages) && !estGerant && (
              <div style={{ fontSize: 12, color: OCRE, marginTop: -8, marginBottom: 10 }}>Quantité différente de l'arrivage prévu : Le Gérant sera alerté.</div>
            )}
            {Number(receptionQuantite) > 0 && Number(receptionQuantite) !== Number(receptionLot.arrivages) && (
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -6, marginBottom: 10 }}>L'arrivage arrive en entier : il prendra la quantité reçue ({receptionQuantite} au lieu de {receptionLot.arrivages}).</div>
            )}
            {receptionError && <div style={errorTextStyle}>{receptionError}</div>}
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 10 }}>
              <button type="button" className="sc-btn" onClick={supprimerArrivage} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>Supprimer l'arrivage</button>
              <button type="button" className="sc-btn" onClick={() => setShowReception(false)} style={ghostBtnStyle}>Annuler</button>
              <button type="button" className="sc-btn" onClick={confirmerReception} style={primaryBtnStyle}>Confirmer la réception</button>
            </div>
          </div>
        </Overlay>
      )}

      {showForm && editing && (
        <Overlay onClose={() => setShowForm(false)}>
          {(() => {
            const articleLieAuProduit = editing.produitId ? (articles || []).find((a) => a.produitStockId === editing.produitId) : null;
            const faLot = editing.id ? ficheArrivageDuLot((items || []).find((it) => it.id === editing.id)) : null;
            const lotVerrouille = !!editing.id && (lotADeLActivite(editing.id) || !!faLot);
            return (
          <div style={modalStyle(440)}>
            <div style={modalTitleStyle}>
              {editing.id
                ? "Modifier le lot"
                : estCategorieConsommable(lotCategorie)
                ? "Nouveau lot de consommable"
                : categorieEstPiece(lotCategorie)
                ? "Nouvel article"
                : editing.type === TYPE_CHUTE
                ? "Nouvelle chute"
                : "Nouveau lot"}
            </div>

            {faLot && (
              <div style={{ background: "#F5EFE0", borderRadius: 8, padding: "10px 12px", marginBottom: 14, fontSize: 12, color: ENCRE, lineHeight: 1.5 }}>
                Lot de l'arrivage <b>{faLot.a.numero}</b> ({faLot.type === "import" ? "import" : "achat local"}) : l'article, le fournisseur et les quantités se changent dans la fiche de l'arrivage, pour que l'arrivage et le stock restent identiques.
                {(faLot.type === "import" ? estGerant : peut("stock.creerArrivage")) && <div style={{ marginTop: 6 }}><button type="button" className="sc-btn" onClick={() => { setShowForm(false); setEditing(null); setListeArrivages({ onglet: "tous", recherche: "", annee: "" }); ouvrirFicheArrivage(faLot.type, faLot.a); }} style={{ ...primaryBtnStyle, fontSize: 12, padding: "5px 12px" }}>Ouvrir l'arrivage {faLot.a.numero}</button></div>}
              </div>
            )}
            {lotVerrouille && !faLot && (
              <div style={{ background: PIERRE, borderRadius: 8, padding: "10px 12px", marginBottom: 14, fontSize: 12, color: TAUPE }}>
                {estCategorieConsommable(lotCategorie)
                  ? "Ce lot a déjà des mouvements ou des réservations : catégorie, sous-catégorie et unité sont verrouillées. Le fournisseur reste modifiable (fournisseurs autorisés uniquement)."
                  : "Ce lot a déjà des mouvements ou des réservations : catégorie, produit, type de lot, fournisseur et unité sont verrouillés. Seuls les champs descriptifs restent modifiables."}
              </div>
            )}

            <Field label="Catégorie">
              <select
                className="sc-select"
                value={lotCategorie}
                onChange={(e) => {
                  onChangeCategorieDuLot(e.target.value);
                  if (formError) setFormError("");
                }}
                style={{ ...selectStyle, opacity: lotVerrouille ? 0.6 : 1 }}
                disabled={lotVerrouille}
              >
                <option value="">— Choisir —</option>
                {categoriesStockDisponibles
                  .filter((nom) => peutEcrireStock || estCategorieConsommable(nom) || nom === lotCategorie)
                  .map((nom) => (
                    <option key={nom}>{nom}</option>
                  ))}
              </select>
            </Field>

            {lotCategorie && !editing.id && !lotVerrouille && !categorieEstPiece(lotCategorie) && !estCategorieConsommable(lotCategorie) && (
              <div style={{ background: PIERRE, borderRadius: 8, padding: 12, marginBottom: 14 }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>
                  Trouver le produit
                </div>
                <Field label="Désignation" style={{ marginBottom: 10 }}>
                  <input
                    className="sc-input"
                    placeholder="Taper pour filtrer…"
                    value={lotRechercheDesignation}
                    onChange={(e) => setLotRechercheDesignation(e.target.value)}
                    style={{ ...inputStyle("100%"), background: "#fff" }}
                  />
                </Field>
                <div style={{ display: "flex", gap: 10 }}>
                  <Field label="Dimensions" style={{ flex: 1.4, marginBottom: 0 }}>
                    <select className="sc-select" value={lotFiltreDimension} onChange={(e) => setLotFiltreDimension(e.target.value)} style={{ ...selectStyle, background: "#fff" }}>
                      <option value="">— Toutes —</option>
                      {trierAlpha(dimensionsList).map((d) => (
                        <option key={d}>{d}</option>
                      ))}
                    </select>
                  </Field>
                  <Field label="Épaisseur" style={{ flex: 1, marginBottom: 0 }}>
                    <select className="sc-select" value={lotFiltreEpaisseur} onChange={(e) => setLotFiltreEpaisseur(e.target.value)} style={{ ...selectStyle, background: "#fff" }}>
                      <option value="">— Toutes —</option>
                      {trierAlpha(epaisseursList).map((ep) => (
                        <option key={ep}>{ep}</option>
                      ))}
                    </select>
                  </Field>
                  <Field label="Groupe de couleur" style={{ flex: 1.2, marginBottom: 0 }}>
                    <select className="sc-select" value={lotFiltreGroupeCouleur} onChange={(e) => setLotFiltreGroupeCouleur(e.target.value)} style={{ ...selectStyle, background: "#fff" }}>
                      <option value="">— Tous —</option>
                      {trierAlpha(groupesCouleurArticles).map((g) => (
                        <option key={g}>{g}</option>
                      ))}
                    </select>
                  </Field>
                </div>
              </div>
            )}

            <Field label={estCategorieConsommable(lotCategorie) ? "Sous-catégorie" : categorieEstPiece(lotCategorie) ? "Produit" : "Produit (couleur Stone Concept)"}>
              <select
                className="sc-select"
                value={editing.produitId}
                onChange={(e) => {
                  onChangeProduitDuLot(e.target.value);
                  if (formError) setFormError("");
                }}
                style={{ ...selectStyle, opacity: lotCategorie && !lotVerrouille ? 1 : 0.5 }}
                disabled={!lotCategorie || lotVerrouille}
              >
                <option value="">{lotCategorie ? "— Choisir —" : "— Choisis d'abord une catégorie —"}</option>
                {produitsDeCategorie.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.nom}
                  </option>
                ))}
              </select>
              {lotCategorie && produitsDeCategorie.length === 0 && (
                <div style={{ fontSize: 11, color: ROUILLE, marginTop: 4, fontWeight: 600 }}>
                  Aucun produit dans « {lotCategorie} ».
                </div>
              )}
              {lotCategorie && !lotVerrouille && estCategorieConsommable(lotCategorie) && (
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                  Sous-catégorie absente ?{" "}
                  <span
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => {
                      setShowForm(false);
                      if (peutGererConsommablesEtCategories) openProduitNew();
                      else ouvrirDemandeSousCat();
                    }}
                  >
                    {peutGererConsommablesEtCategories ? "Crée-la d'abord" : "Demande-la au Gérant"}
                  </span>
                  .
                </div>
              )}
            </Field>

            {!categorieEstPiece(lotCategorie) && !estCategorieConsommable(lotCategorie) && (
              <Field label="Type de lot">
                <div style={{ display: "flex", gap: 8 }}>
                  {[
                    { id: TYPE_TRANCHE, label: "Tranche entière" },
                    { id: TYPE_CHUTE, label: "Chute" },
                  ].map((t) => (
                    <button
                      key={t.id}
                      type="button"
                      className="sc-btn"
                      disabled={lotVerrouille}
                      onClick={() => { if (!lotVerrouille) setEditing({ ...editing, type: t.id, dimensions: "" }); }}
                      style={{
                        opacity: lotVerrouille && editing.type !== t.id ? 0.4 : 1,
                        cursor: lotVerrouille ? "default" : "pointer",
                        flex: 1,
                        padding: "8px 0",
                        borderRadius: 6,
                        fontSize: 13,
                        fontWeight: 600,
                        background: editing.type === t.id ? ENCRE : PIERRE,
                        color: editing.type === t.id ? PIERRE : TAUPE,
                      }}
                    >
                      {t.label}
                    </button>
                  ))}
                </div>
                {editing.type === TYPE_CHUTE && (
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                    Dimension libre, et comptée à part : une chute n'entre pas dans le stock théorique ni dans le seuil.
                  </div>
                )}
              </Field>
            )}

            {articleLieAuProduit && articleLieAuProduit.fournisseur ? (
              <div style={{ background: PIERRE, borderRadius: 8, padding: "10px 12px", marginBottom: 14, fontSize: 13 }}>
                Fournisseur : <strong>{articleLieAuProduit.fournisseur}</strong> — fixé sur l'article Catalogue.
              </div>
            ) : (
              <Field label={estCategorieConsommable(lotCategorie) ? "Fournisseur (autorisés pour cette sous-catégorie)" : "Fournisseur"}>
                <select
                  className="sc-select"
                  value={editing.fournisseur}
                  onChange={(e) => {
                    setEditing({ ...editing, fournisseur: e.target.value });
                    if (formError) setFormError("");
                  }}
                  style={{ ...selectStyle, opacity: lotVerrouille && !estCategorieConsommable(lotCategorie) ? 0.6 : 1 }}
                  disabled={lotVerrouille && !estCategorieConsommable(lotCategorie)}
                >
                  <option value="">— Choisir —</option>
                  {estCategorieConsommable(lotCategorie) && editing.produitId
                    ? fournisseursAutorises(produitDe(editing.produitId))
                        .map((c) => (<option key={c.fournisseur} value={c.fournisseur}>{c.fournisseur}</option>))
                        .concat(
                          editing.fournisseur && !fournisseursAutorises(produitDe(editing.produitId)).some((c) => c.fournisseur === editing.fournisseur)
                            ? [<option key="__actuel" value={editing.fournisseur}>{editing.fournisseur} (non autorisé)</option>]
                            : []
                        )
                    : trierAlpha(fournisseurs, "nom").map((f) => (
                        <option key={f.id}>{f.nom}</option>
                      ))}
                </select>
                {estCategorieConsommable(lotCategorie) && editing.produitId && fournisseursAutorises(produitDe(editing.produitId)).length === 0 && (
                  <div style={{ fontSize: 11, color: ROUILLE, marginTop: 4, fontWeight: 600 }}>
                    Aucun fournisseur autorisé sur cette sous-catégorie — {peutGererConsommablesEtCategories ? "complète la fiche." : "demande au Gérant de compléter la fiche."}
                  </div>
                )}
                {editing.produitId && editing.fournisseur && (!estCategorieConsommable(lotCategorie) || nomChezFournisseur(editing.produitId, editing.fournisseur)) && (
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                    {nomChezFournisseur(editing.produitId, editing.fournisseur)
                      ? `Vendu sous le nom « ${nomChezFournisseur(editing.produitId, editing.fournisseur)} ».`
                      : "Aucune correspondance de nom pour ce fournisseur — à renseigner sur la fiche produit."}
                  </div>
                )}
              </Field>
            )}

            {!categorieEstPiece(lotCategorie) && !estCategorieConsommable(lotCategorie) && articleLieAuProduit && (
              <div style={{ background: PIERRE, borderRadius: 8, padding: "10px 12px", marginBottom: 14, fontSize: 13 }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>
                  Repris de l'article Catalogue « {articleLieAuProduit.designation} »
                </div>
                {editing.type === TYPE_CHUTE ? (
                  <>Épaisseur : <strong>{articleLieAuProduit.epaisseurMatiere || "—"}</strong>{articleLieAuProduit.choix ? <> · Choix : <strong>{articleLieAuProduit.choix}</strong></> : null} — une chute vient forcément de la même matière brute, seule sa dimension varie.</>
                ) : (
                  <>Dimensions : <strong>{articleLieAuProduit.dimension || "—"}</strong> · Épaisseur : <strong>{articleLieAuProduit.epaisseurMatiere || "—"}</strong>{articleLieAuProduit.choix ? <> · Choix : <strong>{articleLieAuProduit.choix}</strong></> : null}</>
                )}
              </div>
            )}
            {!categorieEstPiece(lotCategorie) && !estCategorieConsommable(lotCategorie) && editing.type === TYPE_CHUTE && (
              <Field label="Dimension du morceau">
                <input
                  className="sc-input"
                  placeholder="ex. 140 × 80 cm"
                  value={editing.dimensions}
                  onChange={(e) => setEditing({ ...editing, dimensions: e.target.value })}
                  style={inputStyle("100%")}
                />
              </Field>
            )}

            {editing.produitId && !estCategorieConsommable(lotCategorie) && categorieNuances(produitDe(editing.produitId)?.categorie) && (
              <div style={{ background: PIERRE, borderRadius: 8, padding: 12, marginBottom: 14 }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>
                  Céramique — nuance codifiée
                </div>
                <div style={{ display: "flex", gap: 10 }}>
                  <Field label="Nuance" style={{ flex: 1, marginBottom: 0 }}>
                    <select
                      className="sc-select"
                      value={editing.nuance}
                      onChange={(e) => setEditing({ ...editing, nuance: e.target.value })}
                      style={{ ...selectStyle, background: "#fff" }}
                    >
                      <option value="">—</option>
                      {NUANCES.map((n) => (
                        <option key={n}>{n}</option>
                      ))}
                    </select>
                  </Field>
                  {!articleLieAuProduit && (
                    <Field label="Choix" style={{ flex: 1, marginBottom: 0 }}>
                      <select
                        className="sc-select"
                        value={editing.choix}
                        onChange={(e) => setEditing({ ...editing, choix: e.target.value })}
                        style={{ ...selectStyle, background: "#fff" }}
                      >
                        <option value="">—</option>
                        {CHOIX.map((c) => (
                          <option key={c}>{c}</option>
                        ))}
                      </select>
                    </Field>
                  )}
                </div>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>
                  Une livraison d'une autre nuance doit former un lot distinct.
                </div>
              </div>
            )}

            {/* ERP step 11 (accord Nils du 29/09) : prix d'achat des lots de
                consommables — target price de la sous-catégorie / du
                fournisseur et écart affichés. Jamais pour les Tranches (prix
                confidentiel). */}
            {!estCategorieConsommable(lotCategorie) && lotCategorie && peutVoirPrixCategorie(lotCategorie) && (
              <Field label={`Prix d'achat unitaire (facultatif${familleInventaire(lotCategorie) === "Accessoires" ? "" : " — visible par le Gérant seul"})`}>
                <ChampHTTTC ht={editing.prixAchatHT ?? ""} onChange={(v) => setEditing({ ...editing, prixAchatHT: v })} style={{ maxWidth: 340 }} />
                {estGerant && (() => {
                  const artL = articleDuProduit(editing.produitId);
                  if (!artL || !artL.provenance) return null;
                  if (artL.provenance === "Local") return <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Achat local : prix d'achat réel du lot.</div>;
                  const std = coutStandardLot({ ...editing, produitId: editing.produitId });
                  return (
                    <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                      Importé — coût standard : {std !== null ? <b>{formatDH(std)} HT</b> : "non calculable (profil d'import, groupe fournisseur ou prix manquant)"}

                      {std !== null && <button type="button" className="sc-btn" onClick={() => setEditing({ ...editing, prixAchatHT: std })} style={{ ...ghostBtnStyle, padding: "0 6px", fontSize: 11 }}>Utiliser</button>}
                      {editing.arrivageImportId && <div>Lot rattaché à l'arrivage {((arrivagesImport || []).find((a) => a.id === editing.arrivageImportId) || {}).numero || ""} : son prix est recalculé par l'arrivage.</div>}
                    </div>
                  );
                })()}
              </Field>
            )}
            {estGerant && !estCategorieConsommable(lotCategorie) && (articleDuProduit(editing.produitId) || {}).provenance === "Local" && (
              <Field label="Transport d'approche HT — total du lot (facultatif, visible par le Gérant seul)">
                <input type="number" min="0" className="sc-input" value={editing.transportApprocheHT ?? ""} onChange={(e) => setEditing({ ...editing, transportApprocheHT: e.target.value })} style={inputStyle(200)} />
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Réparti sur la quantité reçue pour le coût de revient du lot.</div>
              </Field>
            )}
            {estCategorieConsommable(lotCategorie) && peutVoirPrixConso && (() => {
              const prod = produitDe(editing.produitId);
              const target = prod ? targetPriceDe(prod, editing.fournisseur) : null;
              const prix = editing.prixAchatHT === "" || editing.prixAchatHT === undefined || editing.prixAchatHT === null ? null : Number(editing.prixAchatHT);
              const ecart = target !== null && prix !== null && isFinite(prix) ? prix - target : null;
              const pct = ecart !== null && target ? (ecart / target) * 100 : null;
              return (
                <div style={{ background: PIERRE, borderRadius: 8, padding: 12, marginBottom: 14 }}>
                  <div style={{ display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap" }}>
                    <Field label={`Prix d'achat unitaire${editing.id ? "" : " (obligatoire)"}`} style={{ flex: "1 1 100%", marginBottom: 4 }}>
                      <ChampHTTTC ht={editing.prixAchatHT ?? ""} fond="#fff" onChange={(v) => { setEditing({ ...editing, prixAchatHT: v }); if (formError) setFormError(""); }} />
                    </Field>
                    <div style={{ flex: 1, fontSize: 13, paddingBottom: 10 }}>
                      <div style={{ color: TAUPE, fontSize: 11, textTransform: "uppercase", letterSpacing: 0.5 }}>Target price</div>
                      <div style={{ fontWeight: 600 }}>{target !== null ? <>{formatDH(target)} HT<div style={{ fontWeight: 400, fontSize: 12 }}>{formatDH(htVersTTC(target))} TTC</div></> : "non renseigné"}</div>
                    </div>
                    <div style={{ flex: 1, fontSize: 13, paddingBottom: 10 }}>
                      <div style={{ color: TAUPE, fontSize: 11, textTransform: "uppercase", letterSpacing: 0.5 }}>Écart</div>
                      <div style={{ fontWeight: 700, color: ecart === null ? TAUPE : ecart > 0 ? ROUILLE : VERT_OK }}>
                        {ecart === null ? "—" : `${ecart > 0 ? "+" : ""}${formatDH(ecart)} HT (${pct > 0 ? "+" : ""}${pct.toFixed(1).replace(".", ",")} %)`}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })()}

            {/* Nils 03/10 (p) : consommable ou chute = une seule case « Qté » (entre en stock) ;
                tranche / pièce = « Qté en arrivage » (commande), le Production Manager réceptionne ensuite. */}
            {(() => { const modeQte = !editing.id ? (estCategorieConsommable(lotCategorie) || editing.type === TYPE_CHUTE ? "stock" : "arrivage") : null; return (
            <div style={{ display: "flex", gap: 10 }}>
              {modeQte !== "arrivage" && (
              <Field label={modeQte === "stock" ? "Qté" : "Stock réel"} style={{ flex: 1 }}>
                <input
                  type="number"
                  step="0.01"
                  className="sc-input"
                  value={editing.stockReel}
                  onChange={(e) => setEditing({ ...editing, stockReel: e.target.value })}
                  disabled={!!editing.id}
                  style={{ ...inputStyle("100%"), opacity: editing.id ? 0.6 : 1 }}
                />
              </Field>
              )}
              <Field label="Unité" style={{ flex: 1 }}>
                <select className="sc-select" value={editing.unite} onChange={(e) => setEditing({ ...editing, unite: e.target.value })} disabled={lotVerrouille} style={{ ...selectStyle, opacity: lotVerrouille ? 0.6 : 1 }}>
                  {UNITES.map((u) => (
                    <option key={u}>{u}</option>
                  ))}
                </select>
              </Field>
              {modeQte !== "stock" && (
              <Field label={modeQte === "arrivage" ? "Qté en arrivage (commandée)" : "Arrivages"} style={{ flex: 1 }}>
                <input
                  type="number"
                  step="0.01"
                  className="sc-input"
                  value={editing.arrivages}
                  onChange={(e) => setEditing({ ...editing, arrivages: e.target.value })}
                  disabled={!!editing.id}
                  style={{ ...inputStyle("100%"), opacity: editing.id ? 0.6 : 1 }}
                />
              </Field>
              )}
              {modeQte === "arrivage" && !editing.id && editing.type !== TYPE_CHUTE && produitBookMatch(editing.produitId) && (
                <Field label="Book-match — dont A / B prévus (facultatif)" style={{ flex: 1 }}>
                  <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                    A <input type="number" min="0" className="sc-input" value={editing.arrivageA ?? ""} onChange={(e) => setEditing({ ...editing, arrivageA: e.target.value })} style={{ ...inputStyle(70), padding: "6px 8px" }} />
                    B <input type="number" min="0" className="sc-input" value={editing.arrivageB ?? ""} onChange={(e) => setEditing({ ...editing, arrivageB: e.target.value })} style={{ ...inputStyle(70), padding: "6px 8px" }} />
                  </div>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Le contrôle A / B se fait au déchargement (réception).</div>
                </Field>
              )}
            </div>
            ); })()}
            {!editing.id && !estCategorieConsommable(lotCategorie) && editing.type !== TYPE_CHUTE && (
              <div style={{ fontSize: 11, color: TAUPE, marginTop: -8, marginBottom: 8 }}>La quantité entre en arrivage : Le Production Manager la contrôle à la livraison et la passe en stock (« Réceptionner »).</div>
            )}
            <div style={{ fontSize: 11, color: TAUPE, marginTop: -8, marginBottom: 4 }}>
              {editing.id ? "Quantités non modifiables ici : ⚖ Ajustement d'inventaire pour le stock réel (justification obligatoire), Réceptionner pour les arrivages. " : ""}Le seuil d'alerte se règle sur la fiche produit, tous lots confondus.
            </div>

            <Field label="N° BL fournisseur (optionnel)">
              <input
                className="sc-input"
                value={editing.blFournisseur || ""}
                onChange={(e) => setEditing({ ...editing, blFournisseur: e.target.value })}
                placeholder="ex. BL-2026-0451"
                style={inputStyle("100%")}
              />
            </Field>

            {formError && (
              <div style={{ background: "#F5E4DE", color: ROUILLE, fontSize: 13, fontWeight: 600, padding: "10px 12px", borderRadius: 6, marginTop: 14 }}>
                {formError}
              </div>
            )}

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 20 }}>
              <button type="button" className="sc-btn" onClick={() => setShowForm(false)} style={ghostBtnStyle}>
                Annuler
              </button>
              <button type="button" className="sc-btn" onClick={saveEditing} style={primaryBtnStyle}>
                Enregistrer
              </button>
            </div>
          </div>
            );
          })()}
        </Overlay>
      )}

      {/* Fiche produit */}
      {showProduit && prodEditing && (
        <Overlay onClose={() => setShowProduit(false)}>
          <div style={modalStyle(460)}>
            <div style={modalTitleStyle}>{estCategorieConsommable(prodEditing.categorie) ? (prodEditing.id ? "Sous-catégorie de consommable" : "Nouvelle sous-catégorie") : prodEditing.id ? "Fiche produit" : "Nouvelle sous-catégorie"}</div>

            {!prodEditing.id && (
              <div style={{ background: PIERRE, borderRadius: 8, padding: "10px 12px", marginBottom: 16, fontSize: 12, color: TAUPE }}>
                Une sous-catégorie de consommable (ex. « Disque céramique 350 » dans la catégorie « Disque céramique »). Les Tranches, Éviers et Accessoires se créent depuis le Catalogue, qui génère automatiquement leur fiche Stock — inutile de les recréer ici.
              </div>
            )}
            {estCategorieConsommable(prodEditing.categorie) && !peutGererConsommablesEtCategories && (
              <div style={{ background: PIERRE, borderRadius: 8, padding: "10px 12px", marginBottom: 16, fontSize: 12, color: TAUPE }}>
                Lecture seule — seul le Gérant modifie les sous-catégories de consommables.
              </div>
            )}
            <fieldset disabled={estCategorieConsommable(prodEditing.categorie) && !peutGererConsommablesEtCategories} style={{ border: "none", padding: 0, margin: 0 }}>

            <div style={{ display: "flex", gap: 10 }}>
              <Field label={estCategorieConsommable(prodEditing.categorie) ? "Sous-catégorie" : "Nom Stone Concept"} style={{ flex: 1.4 }}>
                <input
                  autoFocus
                  className="sc-input"
                  value={prodEditing.nom}
                  onChange={(e) => {
                    setProdEditing({ ...prodEditing, nom: e.target.value });
                    if (prodError) setProdError("");
                  }}
                  placeholder={estCategorieConsommable(prodEditing.categorie) ? "ex. Disque céramique 350" : "ex. Easy Grey"}
                  style={inputStyle("100%")}
                />
              </Field>
              <Field label="Catégorie" style={{ flex: 1 }}>
                <select
                  className="sc-select"
                  value={prodEditing.categorie}
                  onChange={(e) => { setProdEditing({ ...prodEditing, categorie: e.target.value }); if (prodError) setProdError(""); }}
                  style={selectStyle}
                >
                  <option value="">— Choisir —</option>
                  {/* Nils 30/10 : seulement les vraies catégories (Gérer les catégories) — un nom porté par une
                      sous-catégorie sans catégorie n'est plus proposé (il ne se propage plus). */}
                  {(categories || []).map((c) => c.name).filter(Boolean).sort((a, b) => a.localeCompare(b, "fr"))
                    .filter((nom) => prodEditing.id || !estCategorieStockReservee(nom))
                    .map((nom) => (
                      <option key={nom}>{nom}</option>
                    ))}
                  {prodEditing.categorie && !(categories || []).some((c) => c.name === prodEditing.categorie) && <option value={prodEditing.categorie}>{prodEditing.categorie} (à régulariser : pas dans Gérer les catégories)</option>}
                </select>
                {!prodEditing.id && peutGererConsommablesEtCategories && (
                  <button type="button" className="sc-btn" onClick={() => setShowCatManager(true)} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>Gérer les catégories</button>
                )}
              </Field>
            </div>

            {estCategorieConsommable(prodEditing.categorie) && (
              <>
                <div style={{ display: "flex", gap: 10 }}>
                  <Field label="Vitesse de consommation" style={{ flex: 1 }}>
                    <select className="sc-select" value={normaliserVitesse(prodEditing.vitesse)} onChange={(e) => setProdEditing({ ...prodEditing, vitesse: e.target.value })} style={selectStyle}>
                      <option value="">— Non précisée —</option>
                      {VITESSES_CONSO.map((v) => (<option key={v} value={v}>{v}</option>))}
                    </select>
                    <RappelVitesse vitesse={prodEditing.vitesse} />
                  </Field>
                  {peutVoirPrixConso && (
                    <Field label="Target price par défaut (par unité)" style={{ flex: 1.4 }}>
                      <ChampHTTTC ht={prodEditing.targetPrice ?? ""} onChange={(v) => setProdEditing({ ...prodEditing, targetPrice: v })} />
                    </Field>
                  )}
                </div>
                {normaliserVitesse(prodEditing.vitesse) === "Lente" && (
                  <Field label="Usure comptée">
                    <div style={{ display: "flex", gap: 16, fontSize: 13 }}>
                      {[["tranche", "À la tranche (disques, abrasifs…)"], ["decoupe", "À la découpe (fraises, forets…)"]].map(([v, lib]) => (
                        <label key={v} style={{ display: "flex", gap: 6, alignItems: "center", cursor: "pointer" }}>
                          <input type="radio" name="usureComptee" checked={(prodEditing.usureComptee === "decoupe" ? "decoupe" : "tranche") === v} onChange={() => setProdEditing({ ...prodEditing, usureComptee: v })} />{lib}
                        </label>
                      ))}
                    </div>
                    {prodEditing.usureComptee === "decoupe" ? (
                      <div style={{ marginTop: 8 }}>
                        <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Découpes qui usent ce consommable</div>
                        {(() => {
                          const decoupes = trierAlpha((articles || []).filter((a) => natureArticle(a, "decoupe")), "designation");
                          const sel = Array.isArray(prodEditing.articlesDecoupe) ? prodEditing.articlesDecoupe : [];
                          return decoupes.length ? (
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px 14px", fontSize: 13 }}>
                              {decoupes.map((a) => (
                                <label key={a.id} style={{ display: "flex", gap: 6, alignItems: "center", cursor: "pointer" }}>
                                  <input type="checkbox" checked={sel.includes(a.id)} onChange={(e) => setProdEditing({ ...prodEditing, articlesDecoupe: e.target.checked ? [...sel, a.id] : sel.filter((x) => x !== a.id) })} />
                                  {a.designation}
                                </label>
                              ))}
                            </div>
                          ) : <div style={{ fontSize: 12, color: OCRE }}>Aucun article coché « Article de découpe unitaire » dans le Catalogue.</div>;
                        })()}
                        <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Usure = nombre de ces découpes sur les PL pendant la mise en service (coût par découpe).</div>
                      </div>
                    ) : (
                      <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Usure = tranches réellement sorties sur les PL : dossiers avec façonnage pour une machine, avec pose pour un poseur (coût par tranche).</div>
                    )}
                  </Field>
                )}
                {normaliserVitesse(prodEditing.vitesse) === "Lente" && prodEditing.usureComptee !== "decoupe" && (
                  <Field label="Matières traitées (pour le calcul d'usure)">
                    <div style={{ display: "flex", gap: 14, flexWrap: "wrap", fontSize: 13 }}>
                      {MATIERES.map((m) => {
                        const sel = Array.isArray(prodEditing.matieresTraitees) ? prodEditing.matieresTraitees : [];
                        return (
                          <label key={m} style={{ display: "flex", gap: 6, alignItems: "center", cursor: "pointer" }}>
                            <input type="checkbox" checked={sel.includes(m)} onChange={(e) => setProdEditing({ ...prodEditing, matieresTraitees: e.target.checked ? [...sel, m] : sel.filter((x) => x !== m) })} />
                            {m}
                          </label>
                        );
                      })}
                    </div>
                    <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Aucune case cochée = toutes les matières. Seules les tranches sorties de ces matières comptent dans l'usure.</div>
                  </Field>
                )}
                <Field label="Fournisseurs autorisés (obligatoire)">
                  {(prodEditing.correspondances || []).map((c, i) => (
                    <div key={i} style={{ display: "flex", gap: 6, marginBottom: 10, flexWrap: "wrap", paddingBottom: 8, borderBottom: `1px solid ${PIERRE}` }}>
                      <select className="sc-select" value={c.fournisseur || ""} onChange={(e) => setProdEditing({ ...prodEditing, correspondances: prodEditing.correspondances.map((x, j) => (j === i ? { ...x, fournisseur: e.target.value } : x)) })} style={{ ...selectStyle, flex: 1.3 }}>
                        <option value="">— Fournisseur —</option>
                        {trierAlpha(fournisseurs, "nom").map((f) => (<option key={f.id} value={f.nom}>{f.nom}</option>))}
                      </select>
                      <input className="sc-input" value={c.nomFournisseur || ""} onChange={(e) => setProdEditing({ ...prodEditing, correspondances: prodEditing.correspondances.map((x, j) => (j === i ? { ...x, nomFournisseur: e.target.value } : x)) })} placeholder="Nom chez lui (facult.)" style={{ ...inputStyle("100%"), flex: 1.3 }} />
                      {peutVoirPrixConso && (
                        <ChampHTTTC ht={c.targetPrice ?? ""} onChange={(v) => setProdEditing({ ...prodEditing, correspondances: prodEditing.correspondances.map((x, j) => (j === i ? { ...x, targetPrice: v } : x)) })} placeholderHT="Target HT (vide = défaut)" placeholderTTC="Target TTC" style={{ flex: "1 1 100%", order: 3 }} />
                      )}
                      <button type="button" className="sc-btn" onClick={() => setProdEditing({ ...prodEditing, correspondances: prodEditing.correspondances.filter((_, j) => j !== i) })} style={iconBtnStyle}>✕</button>
                    </div>
                  ))}
                  <button type="button" className="sc-btn" onClick={() => setProdEditing({ ...prodEditing, correspondances: [...(prodEditing.correspondances || []), { fournisseur: "", nomFournisseur: "", targetPrice: "" }] })} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>+ Ajouter un fournisseur autorisé</button>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                    Seuls ces fournisseurs seront proposés à l'enregistrement d'un lot. Target price vide = target par défaut.
                  </div>
                </Field>
              </>
            )}

            {!estCategorieConsommable(prodEditing.categorie) && (
            <Field label="Fournisseur habituel (facultatif)">
              <select
                className="sc-select"
                value={prodEditing.fournisseur || ""}
                onChange={(e) => setProdEditing({ ...prodEditing, fournisseur: e.target.value })}
                style={selectStyle}
              >
                <option value="">— Non précisé —</option>
                {trierAlpha(fournisseurs, "nom").map((f) => (<option key={f.id} value={f.nom}>{f.nom}</option>))}
              </select>
              <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                Juste indicatif — à préciser sur chaque lot.
              </div>
            </Field>
            )}

            <Field label="Seuil d'alerte (tous lots confondus)">
              <input
                type="number"
                step="0.01"
                className="sc-input"
                value={prodEditing.seuil}
                onChange={(e) => setProdEditing({ ...prodEditing, seuil: e.target.value })}
                style={inputStyle("100%")}
              />
            </Field>

            </fieldset>

            {prodError && (
              <div style={{ background: "#F5E4DE", color: ROUILLE, fontSize: 13, fontWeight: 600, padding: "10px 12px", borderRadius: 6, marginBottom: 14 }}>
                {prodError}
              </div>
            )}

            <div style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
              <div>
                {prodEditing.id && !(estCategorieConsommable(prodEditing.categorie) && !peutGererConsommablesEtCategories) && (
                  <button
                    type="button"
                    className="sc-btn"
                    onClick={async () => {
                      if (!(await demander(`Supprimer « ${prodEditing.nom} » ?`))) return;
                      removeProduit(prodEditing);
                      setShowProduit(false);
                    }}
                    style={{ ...ghostBtnStyle, color: ROUILLE }}
                  >
                    Supprimer
                  </button>
                )}
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <button type="button" className="sc-btn" onClick={() => setShowProduit(false)} style={ghostBtnStyle}>
                  Annuler
                </button>
                {!(estCategorieConsommable(prodEditing.categorie) && !peutGererConsommablesEtCategories) && (
                  <button type="button" className="sc-btn" onClick={saveProduit} style={primaryBtnStyle}>
                    Enregistrer
                  </button>
                )}
              </div>
            </div>
          </div>
        </Overlay>
      )}

      {/* ERP step 11 : consommables lents en service */}
      {showEnService && (() => {
        const lents = (produits || []).filter(estConsoLent).sort((a, b) => a.nom.localeCompare(b.nom, "fr"));
        const lotsDispo = (items || []).filter((it) => it.produitId === miseEnService.produitId && (Number(it.stockReel) || 0) > 0);
        const affActives = (affectations || []).filter((a) => a.actif && a.type !== "lieu" && a.type !== "bureau" && (a.type !== "personne" || a.usure !== false));
        const enCours = (enService || []).filter((e) => e.statut === "en service").sort((a, b) => (a.misEnServiceLe < b.misEnServiceLe ? 1 : -1));
        const hist = (enService || []).filter((e) => e.statut === "hors service").sort((a, b) => (a.finLe < b.finLe ? 1 : -1));
        const parAff = {};
        hist.filter((e) => e.motif === "Usure normale").forEach((e) => {
          const k = `${e.affectationNom} | ${nomProduit(e.produitId)}`;
          const st = statsArticleEnService(e);
          parAff[k] = parAff[k] || { n: 0, jours: 0, tranches: 0, unite: st.unite };
          parAff[k].n += 1; parAff[k].jours += st.jours; parAff[k].tranches += st.tranches;
        });
        const cellule = { fontSize: 13, padding: "5px 0" };
        const titre = (t) => <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600, margin: "16px 0 6px" }}>{t}</div>;
        return (
          <Overlay onClose={() => { setShowEnService(false); setHorsServiceEdit(null); }}>
            <div style={modalStyle(940)}>
              <div style={modalTitleStyle}>Consommables en service</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 10 }}>
                Consommables à consommation lente (disques, abrasifs diamantés, meules…) : ils ne se saisissent pas par dossier mais se mettent en service (machine, service ou personne) puis hors service. Usure mesurée en jours et en tranches transformées / posées pendant la période.
              </div>

              {peutGererEnService && (
                <div style={{ background: PIERRE, borderRadius: 8, padding: 12 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>Mettre en service</div>
                  <div style={{ display: "grid", gridTemplateColumns: "1.5fr 1.5fr 0.6fr 1.4fr 1fr", gap: 8 }}>
                    <select className="sc-select" value={miseEnService.produitId} onChange={(e) => setMiseEnService({ ...miseEnService, produitId: e.target.value, lotId: "" })} style={{ ...selectStyle, background: "#fff" }}>
                      <option value="">— Sous-catégorie (lente) —</option>
                      {lents.map((p) => (<option key={p.id} value={p.id}>{p.nom}</option>))}
                    </select>
                    <select className="sc-select" value={miseEnService.lotId} onChange={(e) => setMiseEnService({ ...miseEnService, lotId: e.target.value })} style={{ ...selectStyle, background: "#fff" }} disabled={!miseEnService.produitId}>
                      <option value="">— Lot —</option>
                      {lotsDispo.map((it) => (<option key={it.id} value={it.id}>{it.fournisseur}{it.blFournisseur ? ` · BL ${it.blFournisseur}` : ""} — stock {it.stockReel}</option>))}
                    </select>
                    <input type="number" min="1" step="1" className="sc-input" value={miseEnService.quantite} onChange={(e) => setMiseEnService({ ...miseEnService, quantite: e.target.value })} style={{ ...inputStyle("100%"), background: "#fff" }} />
                    <select className="sc-select" value={miseEnService.affectationId} onChange={(e) => setMiseEnService({ ...miseEnService, affectationId: e.target.value })} style={{ ...selectStyle, background: "#fff" }}>
                      <option value="">— Machine, service ou personne —</option>
                      {affActives.map((a) => (<option key={a.id} value={a.id}>{iconeAffectation(a)}{a.nom}</option>))}
                    </select>
                    <input type="date" className="sc-input" value={miseEnService.date || todayISO()} onChange={(e) => setMiseEnService({ ...miseEnService, date: e.target.value })} style={{ ...inputStyle("100%"), background: "#fff" }} />
                  </div>
                  {lents.length === 0 && <div style={{ fontSize: 11, color: OCRE, marginTop: 6 }}>Aucune sous-catégorie réglée sur la vitesse « Lente » (fiche sous-catégorie, Gérant).</div>}
                  {affActives.length === 0 && <div style={{ fontSize: 11, color: OCRE, marginTop: 6 }}>Aucune machine / personne disponible — machines : {peut("stock.parametrer") ? "ci-dessous" : "Gérant"} ; personnes : onglet Staff, case « Usure des consommables » (Gérant, Administration).</div>}
                  <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
                    <button type="button" className="sc-btn" onClick={enregistrerMiseEnService} style={primaryBtnStyle}>Mettre en service</button>
                  </div>
                </div>
              )}

              {titre(`En service — ${enCours.length}`)}
              {enCours.length === 0 ? <div style={{ fontSize: 13, color: TAUPE }}>Aucun.</div> : enCours.map((e) => {
                const st = statsArticleEnService(e);
                return (
                  <div key={e.id} style={{ borderBottom: `1px solid ${PIERRE}` }}>
                    <div style={{ display: "grid", gridTemplateColumns: "1.8fr 1.4fr 1fr 0.8fr 1fr 1.1fr", gap: 8, alignItems: "center", ...cellule }}>
                      <span style={{ fontWeight: 600 }}>{nomProduit(e.produitId)}</span>
                      <span>{iconeAffectation({ type: e.affectationType })}{e.affectationNom}</span>
                      <span style={{ color: TAUPE }}>depuis le {formatDate(e.misEnServiceLe)}</span>
                      <span>{st.jours} j</span>
                      <span>{st.tranches} {st.unite} ({e.base === "pose" ? "pose" : "transfo."})</span>
                      {peutGererEnService && <button type="button" className="sc-btn" onClick={() => setHorsServiceEdit({ id: e.id, date: todayISO(), motif: "" })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 8px" }}>Hors service…</button>}
                    </div>
                    {horsServiceEdit && horsServiceEdit.id === e.id && (
                      <div style={{ display: "flex", gap: 8, alignItems: "center", padding: "6px 0 10px", flexWrap: "wrap" }}>
                        <input type="date" className="sc-input" value={horsServiceEdit.date} onChange={(ev) => setHorsServiceEdit({ ...horsServiceEdit, date: ev.target.value })} style={inputStyle(160)} />
                        <select className="sc-select" value={horsServiceEdit.motif} onChange={(ev) => setHorsServiceEdit({ ...horsServiceEdit, motif: ev.target.value })} style={{ ...selectStyle, width: 180 }}>
                          <option value="">— Motif —</option>
                          {MOTIFS_HORS_SERVICE.map((m) => (<option key={m} value={m}>{m}</option>))}
                        </select>
                        <button type="button" className="sc-btn" onClick={confirmerHorsService} style={primaryBtnStyle}>Confirmer</button>
                        <button type="button" className="sc-btn" onClick={() => setHorsServiceEdit(null)} style={ghostBtnStyle}>Annuler</button>
                      </div>
                    )}
                  </div>
                );
              })}

              {titre(`Historique — ${hist.length}`)}
              <div style={{ maxHeight: 220, overflowY: "auto" }}>
                {hist.length === 0 ? <div style={{ fontSize: 13, color: TAUPE }}>Aucun.</div> : hist.map((e) => {
                  const st = statsArticleEnService(e);
                  return (
                    <div key={e.id} style={{ display: "grid", gridTemplateColumns: "1.8fr 1.4fr 1.6fr 0.7fr 0.9fr 1fr 1.1fr", gap: 8, borderBottom: `1px solid ${PIERRE}`, ...cellule }}>
                      <span>{nomProduit(e.produitId)}</span>
                      <span>{iconeAffectation({ type: e.affectationType })}{e.affectationNom}</span>
                      <span style={{ color: TAUPE }}>{formatDate(e.misEnServiceLe)} → {formatDate(e.finLe)}</span>
                      <span>{st.jours} j</span>
                      <span>{st.tranches} {st.unite}</span>
                      <span style={{ color: e.motif === "Usure normale" ? TAUPE : ROUILLE, fontWeight: e.motif === "Usure normale" ? 400 : 700 }}>{e.motif}</span>
                      <span style={{ color: TAUPE }}>{st.coutParTranche !== null ? `${formatDH(st.coutParTranche)}/${st.unite}` : ""}</span>
                    </div>
                  );
                })}
              </div>

              {titre("Durée de vie moyenne par machine / service / personne (usure normale)")}
              {Object.keys(parAff).length === 0 ? <div style={{ fontSize: 13, color: TAUPE }}>Pas encore d'historique.</div> : Object.entries(parAff).map(([k, v]) => (
                <div key={k} style={{ display: "grid", gridTemplateColumns: "3fr 1fr 1fr 1fr", gap: 8, ...cellule }}>
                  <span>{k}</span><span>{v.n} article(s)</span><span>{Math.round(v.jours / v.n)} j en moy.</span><span>{Math.round(v.tranches / v.n)} {v.unite || "tr."} en moy.</span>
                </div>
              ))}

              {(peut("stock.parametrer") || typesAffectationGerables().length > 0) && (
                <>
                  {titre("Machines, services et bureaux (affectations)")}
                  {blocMachinesBureaux()}
                  <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", fontSize: 13, marginTop: 14, color: TAUPE }}>
                    <span>Alerte d'usure anormale si durée &lt; <strong style={{ color: ENCRE }}>{seuilUsureAnormalePct()} %</strong> de la moyenne (à partir de 2 articles d'historique){peut("stock.parametrer") ? " — réglable dans l'onglet Paramétrage." : ""}</span>
                  </div>
                </>
              )}
            </div>
          </Overlay>
        );
      })()}

      {/* ERP step 11 : inventaire valorisé + campagne d'inventaire */}
      {repartitionBM && (() => {
        const it = (items || []).find((x) => x.id === repartitionBM.lot.id) || repartitionBM.lot;
        const dispo = (Number(it.stockReel) || 0) - reservedFor(it.id);
        const autre = it.bm === "A" ? "B" : "A";
        const champ = (k, lib) => (
          <span style={{ display: "flex", gap: 6, alignItems: "center" }}>
            {lib}
            <input type="number" min="0" className="sc-input" value={repartitionBM[k]} onChange={(e) => setRepartitionBM({ ...repartitionBM, [k]: e.target.value, err: "" })} style={{ ...inputStyle(70), padding: "6px 8px" }} />
          </span>
        );
        return (
          <Overlay onClose={() => setRepartitionBM(null)}>
            <div style={modalStyle(440)}>
              <div style={modalTitleStyle}>{it.bm ? "Corriger le marquage book-match" : "Répartir en A / B"}</div>
              <div style={{ fontSize: 13, color: TAUPE, marginBottom: 12 }}>
                {nomProduit(it.produitId)}{it.nuance ? ` · nuance ${it.nuance}` : ""}{it.epaisseur ? ` · ${it.epaisseur}` : ""} · <strong style={{ color: ENCRE }}>{it.bm ? `lot ${it.bm}` : "sans marquage"}</strong> — stock {it.stockReel}, disponible {dispo} {it.unite}
              </div>
              <Field label={it.bm ? `Déplacer vers…` : "Combien de tranches de ce lot sont des…"}>
                <div style={{ display: "flex", gap: 14, flexWrap: "wrap", fontSize: 13 }}>
                  {it.bm ? <>{champ("a", autre)}{champ("s", "Sans marquage")}</> : <>{champ("a", "A")}{champ("b", "B")}</>}
                </div>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 6 }}>Les tranches passent dans le lot {it.bm ? "correspondant" : "A ou B"} de même nuance, épaisseur, fournisseur et prix (créé au besoin). Le stock total ne change pas ; seul le disponible (non réservé) peut être déplacé.</div>
              </Field>
              {repartitionBM.err && <div style={errorTextStyle}>{repartitionBM.err}</div>}
              <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                <button type="button" className="sc-btn" onClick={() => setRepartitionBM(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={appliquerRepartitionBM} style={primaryBtnStyle}>Enregistrer</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {showInventaire && (
        <Overlay onClose={() => { setShowInventaire(null); setValidationInventaire(null); }}>
          <div style={modalStyle(920)}>
            <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
              {peutVoirPrixConso && (
                <button type="button" className="sc-btn" onClick={() => setShowInventaire("valorise")} style={{ padding: "7px 14px", borderRadius: 6, fontSize: 13, fontWeight: 600, background: showInventaire === "valorise" ? ENCRE : PIERRE, color: showInventaire === "valorise" ? PIERRE : TAUPE }}>Inventaire valorisé</button>
              )}
              <button type="button" className="sc-btn" onClick={() => setShowInventaire("campagne")} style={{ padding: "7px 14px", borderRadius: 6, fontSize: 13, fontWeight: 600, background: showInventaire === "campagne" ? ENCRE : PIERRE, color: showInventaire === "campagne" ? PIERRE : TAUPE }}>Campagne d'inventaire</button>
            </div>

            {showInventaire === "valorise" && peutVoirPrixConso && (() => {
              const lignes = lignesInventaireValorise(inventaireDate);
              const passe = inventaireDate && inventaireDate < todayISO();
              const parCat = {};
              lignes.forEach((l) => { const k = `${l.famille} › ${l.p.categorie || "—"}`; (parCat[k] = parCat[k] || []).push(l); });
              const total = lignes.reduce((s2, l) => s2 + (l.valeur || 0), 0);
              const nonVal = lignes.filter((l) => l.valeur === null).length;
              const totauxFamille = ORDRE_FAMILLES.map((f) => ({ f, v: lignes.filter((l) => l.famille === f).reduce((s2, l) => s2 + (l.valeur || 0), 0), n: lignes.filter((l) => l.famille === f).length })).filter((x) => x.n > 0);
              return (
                <>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 10, flexWrap: "wrap" }}>
                    <div style={modalTitleStyle}>Inventaire valorisé{passe ? ` au ${formatDate(inventaireDate)}` : ""}</div>
                    <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: TAUPE }}>
                      Au
                      <input type="date" className="sc-input" max={todayISO()} value={inventaireDate || todayISO()} onChange={(e) => setInventaireDate(e.target.value)} style={inputStyle(160)} />
                    </label>
                  </div>
                  {passe && (
                    <div style={{ fontSize: 12, color: OCRE, marginTop: -6, marginBottom: 8 }}>
                      Stock reconstitué au {formatDate(inventaireDate)} en annulant les mouvements datés après cette date (lots supprimés depuis compris). Valorisé au prix d'achat de chaque lot.
                    </div>
                  )}
                  {totauxFamille.length > 1 && (
                    <div style={{ display: "flex", gap: 18, flexWrap: "wrap", fontSize: 13, marginTop: -6, marginBottom: 8 }}>
                      {totauxFamille.map((x) => (<span key={x.f}>{x.f} : <strong>{formatDH(x.v)}</strong></span>))}
                    </div>
                  )}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: -8, marginBottom: 12, gap: 10, flexWrap: "wrap" }}>
                    <div style={{ fontSize: 13 }}>Total : <strong>{formatDH(total)} HT</strong>{nonVal > 0 && <span style={{ color: ROUILLE, fontWeight: 600 }}> — {nonVal} lot(s) non valorisé(s) (sans prix)</span>}</div>
                    <button type="button" className="sc-btn" onClick={exporterInventaireValoriseCSV} style={{ ...ghostBtnStyle, fontSize: 12 }}>⬇ Exporter en CSV</button>
                  </div>
                  <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
                    {Object.keys(parCat).length === 0 && <div style={{ fontSize: 13, color: TAUPE }}>Rien en stock.</div>}
                    {Object.entries(parCat).map(([cat, ls]) => {
                      const st = ls.reduce((s2, l) => s2 + (l.valeur || 0), 0);
                      return (
                        <div key={cat} style={{ marginBottom: 14 }}>
                          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.4, color: TAUPE, borderBottom: `1px solid ${PIERRE}`, paddingBottom: 4, marginBottom: 4 }}>
                            <span>{cat}</span><span>{formatDH(st)} HT</span>
                          </div>
                          {ls.map(({ it, qte, p, valeur, m2 }) => (
                            <div key={it.id} style={{ display: "grid", gridTemplateColumns: "2fr 1.4fr 1fr 1fr 1.1fr", gap: 8, fontSize: 13, padding: "4px 0" }}>
                              <span>{p.nom}{it.type === TYPE_CHUTE ? " (chute)" : ""}{it.dimensions ? <span style={{ color: TAUPE }}> · {it.dimensions}{it.epaisseur ? ` · ${it.epaisseur}` : ""}</span> : null}</span>
                              <span style={{ color: TAUPE }}>{it.fournisseur}{it.blFournisseur ? ` · BL ${it.blFournisseur}` : ""}</span>
                              <span style={{ textAlign: "right" }}>{qte} {it.unite}{m2 ? <span style={{ color: TAUPE }}> · {m2.toFixed(2).replace(".", ",")} m²</span> : null}</span>
                              <span style={{ textAlign: "right", color: TAUPE }}>{it.prixAchatHT !== undefined && it.prixAchatHT !== null && it.prixAchatHT !== "" ? formatDH(it.prixAchatHT) : "—"}</span>
                              <span style={{ textAlign: "right", fontWeight: 600, color: valeur === null ? ROUILLE : ENCRE }}>{valeur === null ? "non valorisé" : formatDH(valeur)}</span>
                            </div>
                          ))}
                        </div>
                      );
                    })}
                  </div>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>{peut("stock.prixTranches") ? "Consommables, accessoires, éviers et tranches." : "Consommables et accessoires."} Valeur = stock réel × prix d'achat HT du lot ; un lot sans prix est « non valorisé ».</div>
                </>
              );
            })()}

            {showInventaire === "campagne" && (() => {
              const lots = lotsInventaire();
              const lignesC = (campagneOuverte && campagneOuverte.lignes) || {};
              const historique = (campagnesInventaire || []).filter((c) => c.statut !== "ouverte").sort((a, b) => (a.ouverteLe < b.ouverteLe ? 1 : -1));
              if (!campagneOuverte) {
                return (
                  <>
                    <div style={modalTitleStyle}>Campagne d'inventaire</div>
                    <div style={{ fontSize: 13, color: TAUPE, marginTop: -8, marginBottom: 14 }}>
                      Aucune campagne en cours. Une campagne porte sur tout ce qui est en stock ; pendant qu'elle est ouverte, <strong>tous les mouvements de stock sont bloqués</strong> (PL, consommables, réceptions, nouveaux lots, ajustements, suppressions, annulation de PL). Le Production Manager saisit le comptage, le Gérant valide.
                    </div>
                    {peut("stock.inventaireLancer") && <button type="button" className="sc-btn" onClick={lancerCampagneInventaire} style={{ ...primaryBtnStyle, marginBottom: 16 }}>Lancer une campagne d'inventaire</button>}
                    <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Historique</div>
                    {historique.length === 0 ? <div style={{ fontSize: 13, color: TAUPE }}>Aucune campagne passée.</div> : historique.map((c) => (
                      <div key={c.id} style={{ fontSize: 13, padding: "6px 0", borderBottom: `1px solid ${PIERRE}` }}>
                        {formatDateHeure(c.ouverteLe)} — {c.statut === "annulee" ? <span style={{ color: TAUPE }}>annulée par {c.annuleePar}</span> : <>clôturée par {c.clotureePar} : {c.nbComptes} lot(s) compté(s), {c.nbAjustements} ajustement(s){peutVoirPrixConso && c.ecartValeurHT ? `, écart valorisé ${c.ecartValeurHT >= 0 ? "+" : ""}${formatDH(c.ecartValeurHT)} HT` : ""}</>}
                      </div>
                    ))}
                  </>
                );
              }
              if (validationInventaire && peut("stock.inventaireLancer")) {
                const comptes = lots.filter((it) => lignesC[it.id]);
                const nonComptes = lots.filter((it) => !lignesC[it.id]);
                let totalV = 0;
                return (
                  <>
                    <div style={modalTitleStyle}>Valider l'inventaire</div>
                    <div style={{ fontSize: 13, color: TAUPE, marginTop: -8, marginBottom: 10 }}>Décoche les lignes à ne pas appliquer. Les lots non comptés restent inchangés.</div>
                    <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
                      <div style={{ display: "grid", gridTemplateColumns: "30px 2.6fr 1fr 1fr 1fr 1.2fr", gap: 8, fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.4, paddingBottom: 4 }}>
                        <span /><span>Lot</span><span style={{ textAlign: "right" }}>Théorique</span><span style={{ textAlign: "right" }}>Compté</span><span style={{ textAlign: "right" }}>Écart</span><span style={{ textAlign: "right" }}>{peutVoirPrixConso ? "Valeur écart" : ""}</span>
                      </div>
                      {comptes.map((it) => {
                        const l = lignesC[it.id];
                        const ec = Number((l.compte - (Number(l.stockAuComptage) || 0)).toFixed(2));
                        const v = peutVoirPrixConso ? valeurLotHT(it, ec) : null;
                        if (validationInventaire.retenus[it.id] && v !== null) totalV += v;
                        return (
                          <label key={it.id} style={{ display: "grid", gridTemplateColumns: "30px 2.6fr 1fr 1fr 1fr 1.2fr", gap: 8, fontSize: 13, padding: "4px 0", alignItems: "center", opacity: ec === 0 ? 0.55 : 1 }}>
                            <input type="checkbox" disabled={ec === 0} checked={ec !== 0 && !!validationInventaire.retenus[it.id]} onChange={(e) => setValidationInventaire({ retenus: { ...validationInventaire.retenus, [it.id]: e.target.checked } })} />
                            <span>{libelleLot(it).replace(/ — stock .*$/, "")}</span>
                            <span style={{ textAlign: "right" }}>{l.stockAuComptage}</span>
                            <span style={{ textAlign: "right" }}>{l.compte}</span>
                            <span style={{ textAlign: "right", fontWeight: 700, color: ec === 0 ? TAUPE : ec > 0 ? VERT_OK : ROUILLE }}>{ec > 0 ? "+" : ""}{ec} {it.unite}</span>
                            <span style={{ textAlign: "right", color: TAUPE }}>{v === null ? "" : formatDH(v)}</span>
                          </label>
                        );
                      })}
                      {nonComptes.length > 0 && (
                        <div style={{ marginTop: 10, fontSize: 12, color: OCRE }}>
                          Non comptés ({nonComptes.length}) — inchangés : {nonComptes.map((it) => libelleLot(it).replace(/ — stock .*$/, "")).join(" ; ")}
                        </div>
                      )}
                    </div>
                    {peutVoirPrixConso && <div style={{ fontSize: 13, marginTop: 10 }}>Écart valorisé retenu (consommables) : <strong style={{ color: totalV < 0 ? ROUILLE : VERT_OK }}>{totalV >= 0 ? "+" : ""}{formatDH(totalV)} HT</strong></div>}
                    <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 14 }}>
                      <button type="button" className="sc-btn" onClick={() => setValidationInventaire(null)} style={ghostBtnStyle}>Retour au comptage</button>
                      <button type="button" className="sc-btn" onClick={validerCampagneInventaire} style={primaryBtnStyle}>Valider et clôturer l'inventaire</button>
                    </div>
                  </>
                );
              }
              const nbComptes = lots.filter((it) => lignesC[it.id]).length;
              return (
                <>
                  <div style={modalTitleStyle}>Campagne d'inventaire en cours</div>
                  <div style={{ fontSize: 13, color: TAUPE, marginTop: -8, marginBottom: 10 }}>
                    Ouverte le {formatDateHeure(campagneOuverte.ouverteLe)} par {campagneOuverte.ouvertePar} — {nbComptes}/{lots.length} lot(s) compté(s). {peutSaisirComptage ? "Saisis les quantités comptées puis enregistre (tu peux le faire en plusieurs fois)." : "Saisie du comptage : Le Production Manager."}
                  </div>
                  <div style={{ display: "flex", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
                    <button type="button" className="sc-btn" onClick={imprimerFicheComptage} style={{ ...ghostBtnStyle, fontSize: 12 }}>🖨 Fiche de comptage</button>
                  </div>
                  <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "1.2fr 2.6fr 1fr 1.1fr 1.4fr", gap: 8, fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.4, paddingBottom: 4 }}>
                      <span>Catégorie</span><span>Lot</span><span style={{ textAlign: "right" }}>Théorique</span><span>Compté</span><span>Saisi</span>
                    </div>
                    {lots.map((it) => {
                      const p = produitDe(it.produitId) || {};
                      const l = lignesC[it.id];
                      return (
                        <div key={it.id} style={{ display: "grid", gridTemplateColumns: "1.2fr 2.6fr 1fr 1.1fr 1.4fr", gap: 8, fontSize: 13, padding: "3px 0", alignItems: "center" }}>
                          <span style={{ color: TAUPE, fontSize: 12 }}>{p.categorie}</span>
                          <span>{libelleLot(it).replace(/ — stock .*$/, "")}</span>
                          <span style={{ textAlign: "right" }}>{it.stockReel} {it.unite}</span>
                          <input type="number" min="0" step="0.01" className="sc-input" disabled={!peutSaisirComptage} value={comptagesSaisis[it.id] ?? ""} onChange={(e) => setComptagesSaisis({ ...comptagesSaisis, [it.id]: e.target.value })} placeholder={l ? String(l.compte) : ""} style={{ ...inputStyle("100%"), padding: "4px 8px" }} />
                          <span style={{ fontSize: 11, color: l ? VERT_OK : TAUPE }}>{l ? `✓ ${l.compte} — ${l.saisiPar}` : "non compté"}</span>
                        </div>
                      );
                    })}
                  </div>
                  <div style={{ display: "flex", gap: 10, justifyContent: "space-between", marginTop: 14, flexWrap: "wrap" }}>
                    <div>
                      {peut("stock.inventaireLancer") && <button type="button" className="sc-btn" onClick={annulerCampagneInventaire} style={{ ...ghostBtnStyle, color: ROUILLE }}>Annuler la campagne</button>}
                    </div>
                    <div style={{ display: "flex", gap: 10 }}>
                      {peutSaisirComptage && <button type="button" className="sc-btn" onClick={enregistrerComptages} style={ghostBtnStyle}>Enregistrer les comptages</button>}
                      {peut("stock.inventaireLancer") && (
                        <button type="button" className="sc-btn" disabled={nbComptes === 0} onClick={() => setValidationInventaire({ retenus: Object.fromEntries(Object.entries(lignesC).map(([k, l]) => [k, Number(l.compte) !== Number(l.stockAuComptage)])) })} style={{ ...primaryBtnStyle, opacity: nbComptes === 0 ? 0.5 : 1 }}>Passer à la validation</button>
                      )}
                    </div>
                  </div>
                </>
              );
            })()}
          </div>
        </Overlay>
      )}

      {/* ERP step 11 : demande de sous-catégorie (Nils la crée ensuite) */}
      {demandeSousCat && (
        <Overlay onClose={() => setDemandeSousCat(null)}>
          <div style={modalStyle(460)}>
            <div style={modalTitleStyle}>Demander une sous-catégorie</div>
            <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 14 }}>
              Seul le Gérant crée les catégories et sous-catégories de consommables. Ta demande apparaîtra dans le Stock jusqu'à ce qu'il la traite.
            </div>
            <Field label="Catégorie">
              <select className="sc-select" value={demandeSousCat.categorie} onChange={(e) => setDemandeSousCat({ ...demandeSousCat, categorie: e.target.value, erreur: "" })} style={selectStyle}>
                {categoriesStockDisponibles.filter((n) => estCategorieConsommable(n)).map((n) => (<option key={n} value={n}>{n}</option>))}
                <option value="__nouvelle__">+ Nouvelle catégorie…</option>
              </select>
              {demandeSousCat.categorie === "__nouvelle__" && (
                <input className="sc-input" value={demandeSousCat.nouvelleCategorie} onChange={(e) => setDemandeSousCat({ ...demandeSousCat, nouvelleCategorie: e.target.value, erreur: "" })} placeholder="ex. Disque céramique" style={{ ...inputStyle("100%"), marginTop: 6 }} />
              )}
            </Field>
            <Field label="Sous-catégorie demandée">
              <input className="sc-input" value={demandeSousCat.nom} onChange={(e) => setDemandeSousCat({ ...demandeSousCat, nom: e.target.value, erreur: "" })} placeholder="ex. Disque céramique 350" style={inputStyle("100%")} />
            </Field>
            <div style={{ display: "flex", gap: 10 }}>
              <Field label="Fournisseur (facultatif)" style={{ flex: 1.3 }}>
                <select className="sc-select" value={demandeSousCat.fournisseur} onChange={(e) => setDemandeSousCat({ ...demandeSousCat, fournisseur: e.target.value })} style={selectStyle}>
                  <option value="">—</option>
                  {trierAlpha(fournisseurs, "nom").map((f) => (<option key={f.id} value={f.nom}>{f.nom}</option>))}
                </select>
              </Field>
              {peutVoirPrixConso && (
                <Field label="Prix constaté (facult.)" style={{ flex: 1.4 }}>
                  <ChampHTTTC ht={demandeSousCat.targetPrice} onChange={(v) => setDemandeSousCat({ ...demandeSousCat, targetPrice: v })} />
                </Field>
              )}
            </div>
            <Field label="Vitesse de consommation (facultatif)">
              <select className="sc-select" value={demandeSousCat.vitesse} onChange={(e) => setDemandeSousCat({ ...demandeSousCat, vitesse: e.target.value })} style={selectStyle}>
                <option value="">—</option>
                {VITESSES_CONSO.map((v) => (<option key={v} value={v}>{v}</option>))}
              </select>
              <RappelVitesse vitesse={demandeSousCat.vitesse} />
            </Field>
            <Field label="Note (facultatif)">
              <input className="sc-input" value={demandeSousCat.note} onChange={(e) => setDemandeSousCat({ ...demandeSousCat, note: e.target.value })} style={inputStyle("100%")} />
            </Field>
            {demandeSousCat.erreur && <div style={errorTextStyle}>{demandeSousCat.erreur}</div>}
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button type="button" className="sc-btn" onClick={() => setDemandeSousCat(null)} style={ghostBtnStyle}>Annuler</button>
              <button type="button" className="sc-btn" onClick={envoyerDemandeSousCat} style={primaryBtnStyle}>Envoyer la demande</button>
            </div>
          </div>
        </Overlay>
      )}

      {/* Gestion des catégories */}
      {showCatManager && (
        <Overlay onClose={() => setShowCatManager(false)}>
          <div style={modalStyle(420)}>
            <div style={modalTitleStyle}>Catégories de stock</div>
            <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 16 }}>
              Clique sur une catégorie pour la modifier. Le fournisseur ne se règle plus ici : il se choisit sur chaque lot, puisqu'un même produit peut venir de plusieurs fournisseurs.
            </div>

            <button type="button" className="sc-btn" onClick={realignerCatalogueEtStock} style={{ ...ghostBtnStyle, marginBottom: 14 }}>
              Réaligner sur le Catalogue
            </button>

            <div ref={catListRef} style={listBoxStyle}>
              {(() => {
                const renderCat = (c) => {
                  const estReservee = estCategorieStockReservee(c.name);
                  return (
                    <div
                      key={c.name}
                      style={{
                        ...listItemStyle,
                        flexWrap: "wrap",
                        background: catEditingId === c.name ? "#E8E0D8" : PIERRE,
                        outline: catEditingId === c.name ? `1px solid ${TAUPE}` : "none",
                      }}
                    >
                      <div style={{ cursor: estReservee ? "default" : "pointer" }} onClick={() => { if (!estReservee) openCatEdit(c); }}>
                        <div style={{ fontWeight: 600, fontSize: 14 }}>{c.name}</div>
                        <div style={{ fontSize: 11, color: TAUPE }}>
                          {c.unite}
                          {(c.gestion || GESTION_TRANCHE) === GESTION_PIECE ? " · à la pièce" : " · en tranches"}
                          {c.nuances ? " · nuances codifiées" : ""}
                          {estReservee ? " · générée par le Catalogue" : ""}
                        </div>
                      </div>
                      {!estReservee && (
                        <div style={{ display: "flex", gap: 4 }}>
                          <button type="button" className="sc-btn" onClick={() => openCatEdit(c)} style={{ ...iconBtnStyle, background: "transparent" }} title="Modifier">
                            ✎
                          </button>
                          <button type="button" className="sc-btn" onClick={() => removeCategory(c.name)} style={{ ...iconBtnStyle, background: "transparent" }} title="Supprimer">
                            ✕
                          </button>
                        </div>
                      )}
                      {/* Nils 03/10 : sous-catégories modifiables / supprimables d'ici aussi. */}
                      {!estReservee && peutGererConsommablesEtCategories && (produits || []).some((x) => x.categorie === c.name) && (
                        <div style={{ flexBasis: "100%", marginTop: 6, paddingLeft: 10, borderLeft: `2px solid ${TAUPE}55` }}>
                          {trierAlpha((produits || []).filter((x) => x.categorie === c.name), "nom").map((sc) => (
                            <div key={sc.id} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, padding: "2px 0" }}>
                              <span style={{ flex: 1 }}>› {sc.nom}</span>
                              <button type="button" className="sc-btn" onClick={() => { setShowCatManager(false); openProduitEdit(sc); }} style={{ ...iconBtnStyle, background: "transparent", fontSize: 11 }} title="Modifier la sous-catégorie">✎</button>
                              <button type="button" className="sc-btn" onClick={async () => { if (await demander(`Supprimer la sous-catégorie « ${sc.nom} » ?`)) removeProduit(sc); }} style={{ ...iconBtnStyle, background: "transparent", fontSize: 11 }} title="Supprimer la sous-catégorie">✕</button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                };
                const toutes = categories || [];
                const duCatalogue = toutes.filter((c) => estCategorieStockReservee(c.name));
                const libres = toutes.filter((c) => !estCategorieStockReservee(c.name));
                return (
                  <>
                    {duCatalogue.length > 0 && (
                      <>
                        <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, margin: "2px 0 6px" }}>
                          Générées par le Catalogue
                        </div>
                        {duCatalogue.map(renderCat)}
                      </>
                    )}
                    {libres.length > 0 && (
                      <>
                        <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, margin: duCatalogue.length > 0 ? "14px 0 6px" : "2px 0 6px" }}>
                          Consommables / Outillage
                        </div>
                        {libres.map(renderCat)}
                      </>
                    )}
                  </>
                );
              })()}
            </div>

            <div style={{ borderTop: `1px solid ${PIERRE}`, paddingTop: 16 }}>
              <Field label={catEditingId ? "Modifier la catégorie" : "Nouvelle catégorie"}>
                <input
                  className="sc-input"
                  value={newCatName}
                  onChange={(e) => {
                    setNewCatName(e.target.value);
                    if (catError) setCatError("");
                  }}
                  placeholder="ex. Disque"
                  style={inputStyle("100%")}
                />
              </Field>
              <Field label="Unité de mesure">
                <select
                  className="sc-select"
                  value={newCatUnite}
                  onChange={(e) => {
                    setNewCatUnite(e.target.value);
                    if (catError) setCatError("");
                  }}
                  style={selectStyle}
                >
                  {(unitesCategorie || DEFAULT_UNITES_CATEGORIE).map((u) => (
                    <option key={u} value={u}>
                      {u}
                    </option>
                  ))}
                </select>
                <button type="button" className="sc-btn" onClick={() => setShowUniteCategorieManager(true)} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>Gérer les unités</button>
              </Field>
              <div style={{ fontSize: 11, color: TAUPE, marginTop: -8, marginBottom: 14 }}>
                Article compté à l'unité (consommable, outillage) : ni dimensions, ni épaisseur, ni chutes — les Tranches, Éviers et Accessoires se créent depuis le Catalogue.
              </div>
              {catError && <div style={errorTextStyle}>{catError}</div>}
              {catSuccess && <div style={successTextStyle}>✓ {catSuccess}</div>}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                {catEditingId ? (
                  <button type="button" className="sc-btn" onClick={resetCatForm} style={ghostBtnStyle}>
                    Annuler la modification
                  </button>
                ) : (
                  <button type="button" className="sc-btn" onClick={() => setShowCatManager(false)} style={ghostBtnStyle}>
                    Fermer
                  </button>
                )}
                <button type="button" className="sc-btn" onClick={addCategory} style={primaryBtnStyle}>
                  Enregistrer
                </button>
              </div>
            </div>
          </div>
        </Overlay>
      )}

      {showUniteCategorieManager && (
        <Overlay onClose={() => setShowUniteCategorieManager(false)}>
          <div style={modalStyle(360)}>
            <div style={modalTitleStyle}>Unités de mesure (catégories Stock)</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16, maxHeight: 220, overflowY: "auto" }}>
              {(unitesCategorie || DEFAULT_UNITES_CATEGORIE).map((u) => (
                <div key={u} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 10px", borderRadius: 6, background: PIERRE }}>
                  <span style={{ fontSize: 13 }}>{u}</span>
                  <button type="button" className="sc-btn" onClick={() => supprimerUniteCategorie(u)} style={iconBtnStyle}>✕</button>
                </div>
              ))}
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <input className="sc-input" value={newUniteCategorieInput} onChange={(e) => setNewUniteCategorieInput(e.target.value)} style={inputStyle("100%")} placeholder="ex. kg, L, boîte(s)" />
              <button type="button" className="sc-btn" onClick={() => { ajouterUniteCategorie(newUniteCategorieInput); setNewUniteCategorieInput(""); }} style={primaryBtnStyle}>Ajouter</button>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <button type="button" className="sc-btn" onClick={() => setShowUniteCategorieManager(false)} style={ghostBtnStyle}>Fermer</button>
            </div>
          </div>
        </Overlay>
      )}

      {/* Mouvement de stock (entrée / sortie) */}
      {/* Historique des mouvements */}
      {showHistory && historyItem && (
        <Overlay onClose={() => setShowHistory(false)}>
          <div style={modalStyle(440)}>
            <div style={modalTitleStyle}>Historique — {nomProduit(historyItem.produitId)}</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, maxHeight: 360, overflowY: "auto" }}>
              {[...((((items || []).find((it) => it.id === historyItem.id) || historyItem).journal) || [])].reverse().map((j, k) => (
                <div key={`j${k}`} style={{ ...listItemStyle, alignItems: "flex-start" }}>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 13, color: OCRE }}>✎ {j.texte}</div>
                    <div style={{ fontSize: 11, color: TAUPE, marginTop: 2 }}>{formatDate(String(j.le).slice(0, 10))} — {j.par}</div>
                  </div>
                </div>
              ))}
              {(mouvements || [])
                .filter((m) => m.itemId === historyItem.id)
                .sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : (a.creeLe < b.creeLe ? 1 : -1)))
                .map((m) => (
                  <div key={m.id} style={{ ...listItemStyle, alignItems: "flex-start" }}>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 13, color: m.type === "entree" ? VERT_OK : ROUILLE }}>
                        {m.type === "entree" ? "▲ Entrée" : "▼ Sortie"} — {m.quantite} {m.unite}
                      </div>
                      <div style={{ fontSize: 12, color: ENCRE, marginTop: 2 }}>
                        {m.pl
                          ? `PL ${m.pl} — ${m.date}`
                          : m.doc
                          ? `${m.type === "entree" ? "BL" : "PL"} ${m.doc} — ${m.date}`
                          : m.date}
                      </div>
                      {m.note && <div style={{ fontSize: 11, color: TAUPE, marginTop: 2 }}>{m.note}</div>}
                    </div>
                  </div>
                ))}
              {(mouvements || []).filter((m) => m.itemId === historyItem.id).length === 0 && (
                <div style={{ fontSize: 13, color: TAUPE, padding: 8 }}>Aucun mouvement enregistré pour cette référence.</div>
              )}
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 18 }}>
              <button type="button" className="sc-btn" onClick={() => setShowHistory(false)} style={ghostBtnStyle}>
                Fermer
              </button>
            </div>
          </div>
        </Overlay>
      )}

      {/* Réservations (BC) */}
      {showReservation && reservationItem && (
        <Overlay onClose={() => { setShowReservation(false); resetResForm(); }}>
          <div style={modalStyle(460)}>
            <div style={modalTitleStyle}>Réservations — {nomProduit(reservationItem.produitId)}</div>
            <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 8 }}>
              {reservationItem.fournisseur}
              {reservationItem.epaisseur ? ` · ${reservationItem.epaisseur}` : ""}
              {reservationItem.nuance ? ` · nuance ${reservationItem.nuance}` : ""}
              {reservationItem.choix ? ` · ${reservationItem.choix}` : ""}
            </div>
            <div style={{ fontSize: 12, color: TAUPE, marginBottom: 16 }}>
              Stock réel {reservationItem.stockReel} {reservationItem.unite} · Réservé {reservedFor(reservationItem.id)} {reservationItem.unite} · Disponible{" "}
              <strong>{reservationItem.stockReel - reservedFor(reservationItem.id)}</strong> {reservationItem.unite}
            </div>
            {melangeBc && (
              <div style={{ background: "#F5EFE0", color: OCRE, fontSize: 12, fontWeight: 600, padding: "10px 12px", borderRadius: 6, marginBottom: 14, lineHeight: 1.5 }}>
                Le BC {melangeBc} réserve déjà un autre lot de ce produit. Deux nuances dans la même commande — à vérifier avant de confirmer.
              </div>
            )}

            <div style={{ display: "flex", flexDirection: "column", gap: 8, maxHeight: 240, overflowY: "auto", marginBottom: 18 }}>
              {(reservations || [])
                .filter((r) => r.itemId === reservationItem.id && r.statut === "active")
                .sort((a, b) => (a.creeLe < b.creeLe ? 1 : -1))
                .map((r) => {
                  const depassee = livraisonDepassee(r.livraison);
                  return (
                  <div
                    key={r.id}
                    style={{
                      ...listItemStyle,
                      alignItems: "flex-start",
                      borderLeft: depassee ? `3px solid ${ROUILLE}` : "3px solid transparent",
                    }}
                  >
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 13, display: "flex", alignItems: "center", gap: 6 }}>
                        <span>{r.quantite} {reservationItem.unite} — {r.client}</span>
                        {r.clientId && <PastillePaiement niveau={clientDe(r.clientId)?.paiement_niveau} />}
                      </div>
                      {(() => { const c = (commandesListe || []).find((x) => x.numero === r.bc); const p = c ? nomProjetDe(chantierDuDossier(c)) : ""; const ref = (c && c.reference) || r.chantier || ""; return p || ref ? <div style={{ fontSize: 12, color: ENCRE, marginTop: 1 }}>{p ? `Projet ${p}` : ""}{p && ref ? " · " : ""}{ref}</div> : null; })()}
                      {r.contact && <div style={{ fontSize: 11, color: TAUPE, marginTop: 1 }}>Contact : {r.contact}</div>}
                      <div style={{ fontSize: 12, color: OCRE, marginTop: 2 }}>BC {r.bc}</div>
                      <div style={{ fontSize: 11, color: TAUPE, marginTop: 3 }}>
                        Réservée le {formatDate(r.creeLe)} · {ancienneteTexte(r.creeLe)}
                        {r.auteur ? ` · par ${r.auteur}` : ""}
                      </div>
                      {r.modifiePar && r.modifieLe && r.modifieLe !== r.creeLe && (
                        <div style={{ fontSize: 11, color: TAUPE, marginTop: 1 }}>
                          Modifiée le {formatDate(r.modifieLe)} · par {r.modifiePar}
                        </div>
                      )}
                      <div style={{ fontSize: 11, marginTop: 1, color: depassee ? ROUILLE : TAUPE, fontWeight: depassee ? 600 : 400 }}>
                        {r.livraison
                          ? `Livraison prévue le ${formatDate(r.livraison)}${depassee ? " — dépassée" : ""}`
                          : "Livraison non datée"}
                      </div>
                      {r.note && <div style={{ fontSize: 11, color: TAUPE, marginTop: 2 }}>{r.note}</div>}
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                      <button
                        type="button"
                        className="sc-btn"
                        onClick={() => openResEdit(r)}
                        style={{
                          padding: "4px 10px",
                          borderRadius: 5,
                          background: resEditingId === r.id ? ENCRE : PIERRE,
                          color: resEditingId === r.id ? PIERRE : ENCRE,
                          fontSize: 11,
                          fontWeight: 600,
                        }}
                        title="Modifier cette réservation"
                      >
                        Modifier
                      </button>
                      <button
                        type="button"
                        className="sc-btn"
                        onClick={() => leverReservationProduction(r.id)}
                        style={{ padding: "4px 10px", borderRadius: 5, background: PIERRE, color: ENCRE, fontSize: 11, fontWeight: 600 }}
                        title="La tranche a réellement été produite/livrée"
                      >
                        Production lancée
                      </button>
                      <button
                        type="button"
                        className="sc-btn"
                        onClick={() => annulerReservation(r.id)}
                        style={{ padding: "4px 10px", borderRadius: 5, background: "#F5E4DE", color: ROUILLE, fontSize: 11, fontWeight: 600 }}
                        title="Aucune production n'a eu lieu, la réservation ne sert plus"
                      >
                        Annuler
                      </button>
                    </div>
                  </div>
                  );
                })}
              {(reservations || []).filter((r) => r.itemId === reservationItem.id && r.statut === "active").length === 0 && (
                <div style={{ fontSize: 13, color: TAUPE, padding: 8 }}>Aucune réservation active pour cette référence.</div>
              )}
            </div>

            <div style={{ borderTop: `1px solid ${PIERRE}`, paddingTop: 16 }}>
              {!resEditingId ? (
                <div>
                  <div style={{ fontSize: 13, color: TAUPE, marginBottom: 12 }}>
                    Les réservations se créent depuis un dossier (Commandes → Réserver la matière). Clique sur « Modifier » ci-dessus pour ajuster une réservation existante, ou la déplacer vers un autre lot.
                  </div>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button type="button" className="sc-btn" onClick={() => { setShowReservation(false); resetResForm(); }} style={ghostBtnStyle}>
                      Fermer
                    </button>
                  </div>
                </div>
              ) : (
              <>
              <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12 }}>
                Modifier la réservation
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                <Field label="N° BC" style={{ flex: 1 }}>
                  <input
                    className="sc-input"
                    value={resBc}
                    onChange={(e) => {
                      setResBc(e.target.value);
                      if (resError) setResError("");
                    }}
                    placeholder="ex. BC-2026-0102"
                    style={inputStyle("100%")}
                  />
                </Field>
                <Field label={`Quantité (${reservationItem.unite})`} style={{ flex: 1 }}>
                  <input
                    type="number"
                    step="0.01"
                    className="sc-input"
                    value={resQty}
                    onChange={(e) => {
                      setResQty(e.target.value);
                      if (resError) setResError("");
                    }}
                    style={inputStyle("100%")}
                  />
                </Field>
              </div>
              <div style={{ fontSize: 11, color: TAUPE, marginBottom: 12 }}>
                Réservation enregistrée au nom de <strong style={{ color: ENCRE }}>{user.nom}</strong> (compte connecté).
              </div>

              <Field label="Lot">
                <select
                  className="sc-select"
                  value={resNouveauLotId}
                  onChange={(e) => setResNouveauLotId(e.target.value)}
                  style={selectStyle}
                >
                  {lotsDeLaFamille(reservationItem.produitId).map((it) => {
                    const dispo = (Number(it.stockReel) || 0) - reservedFor(it.id) + (it.id === resNouveauLotId ? Number(resQty) || 0 : 0);
                    const autreProduit = it.produitId !== reservationItem.produitId;
                    return (
                      <option key={it.id} value={it.id}>
                        {autreProduit ? `${nomProduit(it.produitId)} · ` : ""}{it.fournisseur}{it.dimensions ? ` · ${it.dimensions}` : ""}{it.epaisseur ? ` · ${it.epaisseur}` : ""}{it.choix ? ` · ${it.choix}` : ""}{it.nuance ? ` · nuance ${it.nuance}` : ""} — {dispo} {it.unite} disponible(s){it.id === reservationItem.id ? " (lot actuel)" : ""}
                      </option>
                    );
                  })}
                </select>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                  Change ce champ pour déplacer la réservation vers un autre lot — de la même famille couleur, épaisseur et choix indifférents.
                </div>
              </Field>

              <Field label="Date prévue de livraison">
                <input
                  type="date"
                  className="sc-input"
                  value={resLivraison}
                  onChange={(e) => setResLivraison(e.target.value)}
                  style={inputStyle("100%")}
                />
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                  Permet de savoir si tu peux prêter ces tranches à un autre chantier et réapprovisionner à temps.
                </div>
              </Field>

              {(() => { const c = (commandesListe || []).find((x) => x.numero === resBc.trim()); const p = c ? nomProjetDe(chantierDuDossier(c)) : ""; return p ? <div style={{ fontSize: 12, color: TAUPE, marginBottom: 10 }}>Projet immobilier : <strong style={{ color: ENCRE }}>{p}</strong> (repris du dossier)</div> : null; })()}

              <Field label="Client">
                <select
                  className="sc-select"
                  value={resClientId}
                  onChange={(e) => {
                    setResClientId(e.target.value);
                    setResContact("");
                    if (resError) setResError("");
                  }}
                  style={selectStyle}
                >
                  <option value="">— Choisir —</option>
                  {(clients || []).map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.nom}
                    </option>
                  ))}
                </select>
                {(clients || []).length === 0 && (
                  <div style={{ fontSize: 11, color: ROUILLE, marginTop: 4, fontWeight: 600 }}>
                    Aucun client enregistré — crée-le dans l'onglet Clients.
                  </div>
                )}
                {resClientId && clientDe(resClientId)?.paiement_niveau && (
                  <div style={{ marginTop: 6 }}>
                    <PastillePaiement niveau={clientDe(resClientId).paiement_niveau} avecTexte />
                  </div>
                )}
              </Field>

              <Field label="Contact chez le client">
                <select
                  className="sc-select"
                  value={resContact}
                  onChange={(e) => setResContact(e.target.value)}
                  style={{ ...selectStyle, opacity: resClientId ? 1 : 0.5 }}
                  disabled={!resClientId}
                >
                  <option value="">{resClientId ? "— Aucun —" : "— Choisis d'abord un client —"}</option>
                  {contactsDuClient(resClientId).map((c) => (
                    <option key={c.id} value={c.nom}>
                      {c.nom}
                      {c.fonction ? ` (${c.fonction})` : ""}
                      {c.tel ? ` — ${c.tel}` : ""}
                    </option>
                  ))}
                </select>
                {resClientId && contactsDuClient(resClientId).length === 0 && (
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                    Aucun contact sur cette fiche client. Ajoute-le dans l'onglet Clients.
                  </div>
                )}
              </Field>
              <Field label="Note (optionnel)">
                <input className="sc-input" value={resNote} onChange={(e) => setResNote(e.target.value)} style={inputStyle("100%")} />
              </Field>
              {resError && <div style={errorTextStyle}>{resError}</div>}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                <button type="button" className="sc-btn" onClick={resetResForm} style={ghostBtnStyle}>
                  Annuler la modification
                </button>
                <button type="button" className="sc-btn" onClick={addReservation} style={primaryBtnStyle}>
                  Enregistrer les modifications
                </button>
              </div>
              </>
              )}
            </div>
          </div>
        </Overlay>
      )}

      {/* Step 17 (Nils 15/10) : création d'une facture d'avoir */}
      {avoirEdit && (() => {
        const e = avoirEdit;
        const c = dossierParId(e.factureId);
        if (!c) return null;
        const set = (p) => setAvoirEdit({ ...e, ...p, erreur: "" });
        const calc = calculAvoir(e, c);
        const serie = serieAvoir(calc.exo);
        const ttcFacture = arrondiH(totalDossierTTC(c));
        const dejaTTC = arrondiH(avoirsDeFacture(c.id).reduce((n, a) => n + (Number(a.ttc) || 0), 0));
        const lignes = lignesAvoirables(c);
        return (
          <Overlay onClose={() => setAvoirEdit(null)} zIndex={85}>
            <div style={modalStyle(720)}>
              <div style={modalTitleStyle}>Facture d'avoir — sur {c.numeroFacture}</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 12 }}>
                {(clientDe(c.clientId) || {}).nom || ""} · facture du {formatDate(String(c.dateFacture || "").slice(0, 10))} · {formatDH(ttcFacture)} TTC{dejaTTC ? ` · déjà repris en avoir : ${formatDH(dejaTTC)}` : ""} · série {serie}{calc.exo ? " (exo, sans TVA)" : ""}
              </div>
              {!c.anterieure && (
                <div style={{ display: "flex", border: `1px solid ${PIERRE}`, borderRadius: 6, overflow: "hidden", marginBottom: 12, width: "fit-content" }}>
                  {[["lignes", "Lignes de la facture"], ["montant", "Montant libre"]].map(([v, l]) => (
                    <button key={v} type="button" className="sc-btn" onClick={() => set({ mode: v })} style={{ padding: "6px 14px", fontSize: 13, border: "none", background: e.mode === v ? ENCRE : "#fff", color: e.mode === v ? PIERRE : ENCRE }}>{l}</button>
                  ))}
                </div>
              )}
              {e.mode === "lignes" ? (
                <div style={{ maxHeight: 280, overflowY: "auto", border: `1px solid ${PIERRE}`, borderRadius: 8, marginBottom: 12 }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                    <thead><tr style={{ background: PIERRE }}>{["Désignation", "Facturé", "Déjà en avoir", "P.U. HT net", "Qté de l'avoir"].map((h) => <th key={h} style={{ textAlign: "left", padding: "6px 8px" }}>{h}</th>)}</tr></thead>
                    <tbody>
                      {lignes.map(({ l, prixHT, deja, reste }) => (
                        <tr key={l.id} style={{ borderTop: `1px solid ${PIERRE}`, opacity: reste > 0 ? 1 : 0.5 }}>
                          <td style={{ padding: "5px 8px" }}>{l.designation}</td>
                          <td style={{ padding: "5px 8px", whiteSpace: "nowrap" }}>{String(l.qte).replace(".", ",")} {l.unite}</td>
                          <td style={{ padding: "5px 8px" }}>{deja ? String(deja).replace(".", ",") : "—"}</td>
                          <td style={{ padding: "5px 8px", whiteSpace: "nowrap" }}>{formatDH(prixHT)}</td>
                          <td style={{ padding: "5px 8px" }}>{reste > 0 ? <input className="sc-input" inputMode="decimal" value={(e.qtes || {})[l.id] ?? ""} placeholder={`max ${String(reste).replace(".", ",")}`} onChange={(ev) => set({ qtes: { ...(e.qtes || {}), [l.id]: ev.target.value } })} style={{ ...inputStyle(90), padding: "4px 6px", background: "#fff", border: `1px solid ${TAUPE}` }} /> : "—"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <Field label="Montant HT de l'avoir"><input className="sc-input" inputMode="decimal" value={e.montantHT} onChange={(ev) => set({ montantHT: ev.target.value })} style={{ ...inputStyle(180), background: "#fff", border: `1px solid ${TAUPE}` }} /></Field>
              )}
              <Field label="Motif (imprimé sur l'avoir)"><input className="sc-input" value={e.motif} onChange={(ev) => set({ motif: ev.target.value })} placeholder="ex. geste commercial, erreur de prix, élément non posé…" style={{ ...inputStyle("100%"), background: "#fff", border: `1px solid ${TAUPE}` }} /></Field>
              <div style={{ display: "flex", gap: 14, alignItems: "flex-end", flexWrap: "wrap", marginBottom: 10 }}>
                <Field label="Date de l'avoir"><input type="date" className="sc-input" value={e.date} max={todayISO()} min={minDateAvoir(serie)} onChange={(ev) => set({ date: ev.target.value || todayISO() })} style={{ ...inputStyle(160), background: "#fff" }} /></Field>
                <div style={{ fontSize: 13, paddingBottom: 14 }}>HT {formatDH(calc.ht)} · TVA {formatDH(calc.tva)} · <strong>TTC {formatDH(calc.ttc)}</strong></div>
              </div>
              <div style={{ fontSize: 11, color: TAUPE, marginBottom: 12, lineHeight: 1.5 }}>Le montant TTC devient un crédit sur le compte du client ; il s'affecte ensuite à une facture (État de compte › Affecter). Numéro attribué à l'enregistrement, sans trou ; l'avoir ne s'annule plus une fois envoyé, transmis au comptable ou s'il n'est plus le dernier de sa série.</div>
              {e.erreur && <div style={{ color: ROUILLE, fontSize: 13, marginBottom: 10 }}>{e.erreur}</div>}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                <button type="button" className="sc-btn" onClick={() => setAvoirEdit(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={enregistrerAvoir} style={primaryBtnStyle}>Créer l'avoir</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {/* Step 17 (Nils 15/10) : remboursement d'un avoir */}
      {rembAvoir && (() => {
        const r = rembAvoir;
        const a = (avoirs || []).find((x) => x.id === r.avoirId);
        if (!a) return null;
        const set = (p) => setRembAvoir({ ...r, ...p, erreur: "" });
        return (
          <Overlay onClose={() => setRembAvoir(null)} zIndex={85}>
            <div style={modalStyle(480)}>
              <div style={modalTitleStyle}>Rembourser l'avoir {a.numero}</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 12 }}>{(clientDe(a.clientId) || {}).nom || ""} · avoir de {formatDH(a.ttc)} TTC · crédit restant {formatDH(creditRestantAvoir(a))}</div>
              <Field label="Compte qui rembourse">
                <select className="sc-select" value={r.compteId} onChange={(e) => set({ compteId: e.target.value })} style={{ ...selectStyle, background: "#fff" }}>
                  {comptesRemboursement().map((c) => (<option key={c.id} value={c.id}>{c.nom}</option>))}
                </select>
              </Field>
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                <Field label="Date"><input type="date" className="sc-input" value={r.date} max={todayISO()} onChange={(e) => set({ date: e.target.value })} style={{ ...inputStyle(160), background: "#fff" }} /></Field>
                <Field label="Mode">
                  <select className="sc-select" value={r.mode} onChange={(e) => set({ mode: e.target.value })} style={{ ...selectStyle, width: "auto", background: "#fff" }}>
                    {MODES_PAIEMENT.map((m) => (<option key={m} value={m}>{m}</option>))}
                  </select>
                </Field>
              </div>
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                <Field label="Montant remboursé (TTC)"><input className="sc-input" inputMode="decimal" value={r.montant} onChange={(e) => set({ montant: e.target.value })} style={{ ...inputStyle(160), background: "#fff", border: `1px solid ${TAUPE}` }} /></Field>
                <Field label="Pièce (n° de chèque, virement…)"><input className="sc-input" value={r.piece} onChange={(e) => set({ piece: e.target.value })} style={{ ...inputStyle(200), background: "#fff", border: `1px solid ${TAUPE}` }} /></Field>
              </div>
              <div style={{ fontSize: 11, color: TAUPE, marginBottom: 12, lineHeight: 1.5 }}>Enregistre la sortie dans le compte choisi ; le crédit de l'avoir diminue d'autant. {a.exo ? "Avoir exo : pas de ligne dans le fichier TVA." : "Apparaît en encaissement négatif dans le fichier TVA du comptable."}</div>
              {r.erreur && <div style={{ color: ROUILLE, fontSize: 13, marginBottom: 10 }}>{r.erreur}</div>}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                <button type="button" className="sc-btn" onClick={() => setRembAvoir(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={enregistrerRemboursementAvoir} style={primaryBtnStyle}>Enregistrer le remboursement</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {/* Fiche client */}
      {affectCredit && (() => {
        const a = affectCredit;
        const set = (p) => setAffectCredit({ ...a, ...p });
        const cr = creditsClient(a.clientId);
        const srcAv = (cr.find((x) => x.c.id === a.de) || {}).c;
        const cibles = tousDossiers().filter((c) => c.clientId === a.clientId && c.id !== a.de && totalDossierTTC(c) - encaisseDossier(c.id) > 0.01 && (!srcAv || !srcAv.avoir || !!srcAv.avoir.exo === !!exoDossier(c)));
        const lib = (c) => c.numeroFacture || c.numeroBL || c.numero;
        return (
          <Overlay onClose={() => setAffectCredit(null)} zIndex={80}>
            <div style={modalStyle(480)}>
              <div style={modalTitleStyle}>Affecter un crédit client — {(clientDe(a.clientId) || {}).nom}</div>
              <Field label="Crédit (trop-perçu ou avoir)">
                <select className="sc-select" value={a.de} onChange={(e) => set({ de: e.target.value })} style={{ ...selectStyle, background: "#fff" }}>
                  {cr.map((x) => (<option key={x.c.id} value={x.c.id}>{lib(x.c)} — {formatDH(x.excedent)}</option>))}
                </select>
              </Field>
              <Field label="Facture à régler">
                <select className="sc-select" value={a.vers} onChange={(e) => { const c = dossierParId(e.target.value); const src = cr.find((x) => x.c.id === a.de); set({ vers: e.target.value, montant: c && src ? String(arrondiH(Math.min(src.excedent, totalDossierTTC(c) - encaisseDossier(c.id)))).replace(".", ",") : "" }); }} style={{ ...selectStyle, background: "#fff" }}>
                  <option value="">— Choisir —</option>
                  {cibles.map((c) => (<option key={c.id} value={c.id}>{lib(c)}{c.reference ? ` · ${c.reference}` : ""} — reste {formatDH(totalDossierTTC(c) - encaisseDossier(c.id))}</option>))}
                </select>
              </Field>
              <Field label="Montant"><input className="sc-input" inputMode="decimal" value={a.montant} onChange={(e) => set({ montant: e.target.value })} style={{ ...inputStyle(160), background: "#fff", border: `1px solid ${TAUPE}` }} /></Field>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                <button type="button" className="sc-btn" onClick={() => setAffectCredit(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={enregistrerAffectationCredit} style={primaryBtnStyle}>Affecter</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {/* ERP step 12 (Nils 01/10) : état client (non exo / exo) */}
      {etatClientModal && (() => {
        const cl = clientDe(etatClientModal.clientId);
        if (!cl || !peutVoirEtatClient(cl)) return null;
        const { exo, au, avecSoldes } = etatClientModal;
        const exoPossible = aVentesExo(cl.id);
        const et = etatCompteClient(cl.id, exo, au, avecSoldes);
        const set = (p) => setEtatClientModal({ ...etatClientModal, ...p });
        const ligne = (lib, val, fort, couleur) => (<div style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", borderBottom: `1px solid ${PIERRE}`, fontWeight: fort ? 600 : 400, color: couleur || ENCRE }}><span>{lib}</span><span>{formatDH(val)}</span></div>);
        return (
          <Overlay onClose={() => setEtatClientModal(null)} zIndex={70}>
            <div style={modalStyle(640)}>
              <div style={modalTitleStyle}>État de compte — {cl.nom}</div>
              <div style={{ display: "flex", gap: 12, alignItems: "flex-end", flexWrap: "wrap", marginBottom: 12 }}>
                <div style={{ display: "flex", border: `1px solid ${PIERRE}`, borderRadius: 6, overflow: "hidden" }}>
                  {[[false, "Non exo"], [true, "Exo"]].map(([v, l]) => (
                    <button key={l} type="button" className="sc-btn" disabled={v && !exoPossible} onClick={() => set({ exo: v })} title={v && !exoPossible ? "Aucune vente exo pour ce client" : ""} style={{ padding: "6px 14px", fontSize: 13, border: "none", background: exo === v ? ENCRE : "#fff", color: exo === v ? PIERRE : v && !exoPossible ? "#ccc" : ENCRE }}>{l}</button>
                  ))}
                </div>
                <Field label="Arrêté au"><input type="date" className="sc-input" value={au} max={todayISO()} onChange={(e) => e.target.value && set({ au: e.target.value })} style={inputStyle(160)} /></Field>
                <label style={{ fontSize: 13, display: "flex", gap: 6, alignItems: "center", paddingBottom: 8 }}><input type="checkbox" checked={avecSoldes} onChange={(e) => set({ avecSoldes: e.target.checked })} /> inclure les {exo ? "BLS" : "factures"} soldé(e)s</label>
              </div>
              <div style={{ fontSize: 12, color: TAUPE, marginBottom: 10 }}>Conditions de paiement : {et.conditions || "non renseignées sur la fiche client (échéance = date du document)"}</div>
              {(() => {
                const plafond = Number(String(cl.plafondExposition || "").replace(/\s/g, "").replace(",", "."));
                if (!(plafond > 0)) return null;
                const enc = encoursClient(cl.id);
                return <div style={{ fontSize: 12, marginBottom: 10, color: enc > plafond ? ROUILLE : TAUPE, fontWeight: enc > plafond ? 600 : 400 }}>Encours total (exo + non exo, commandes en cours comprises) : {formatDH(enc)} — plafond d'exposition {formatDH(plafond)}{enc > plafond ? ` — dépassé de ${formatDH(arrondiH(enc - plafond))}` : ""}</div>;
              })()}
              {et.nonRelies.length > 0 && <div style={{ background: "#F5E4DE", color: ROUILLE, fontSize: 12, padding: "8px 12px", borderRadius: 6, marginBottom: 10 }}>⚠ {et.nonRelies.length} encaissement(s) de ce client ne sont pas encore reliés à une facture / un BLS ({formatDH(et.nonRelies.reduce((n, o) => n + (Number(o.montant) || 0), 0))}) : l'état est incomplet tant qu'ils ne sont pas reliés (Comptabilité › À traiter).</div>}
              <div style={{ fontSize: 13, marginBottom: 12 }}>
                {et.blocs.map((b) => <div key={b.projetId || "particulier"}>{ligne(`${b.titre} — ${b.docs.length} ${exo ? "BLS" : "facture(s)"}${b.echu ? ` · échu ${formatDH(b.echu)}` : ""}`, b.reste)}</div>)}
                {!et.blocs.length && <div style={{ color: TAUPE, padding: "4px 0" }}>Aucun{exo ? " BLS" : "e facture"} {avecSoldes ? "" : "non soldé(e) "}à cette date.</div>}
                {ligne(`Total dû${et.totalEchu ? ` (dont échu ${formatDH(et.totalEchu)})` : ""}`, et.totalDu, true, et.totalEchu ? ROUILLE : ENCRE)}
                {(() => { const cr = creditsClient(cl.id); const tot = arrondiH(cr.reduce((n, x) => n + x.excedent, 0)); return cr.length ? (
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: `1px solid ${PIERRE}`, color: VERT_OK, fontWeight: 600 }}>
                    <span>Crédit client à affecter ({cr.map((x) => `${x.c.avoir ? "avoir " : "trop-perçu sur "}${x.c.numeroFacture || x.c.numeroBL || x.c.numero}`).join(", ")})</span>
                    <span style={{ display: "flex", gap: 8, alignItems: "center" }}>{formatDH(tot)}{peut("clients.affecterCredit") && <button type="button" className="sc-btn" onClick={() => setAffectCredit({ clientId: cl.id, de: cr[0].c.id, vers: "", montant: "" })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 8px" }}>Affecter…</button>}</span>
                  </div>
                ) : null; })()}
                {et.enCours.length > 0 && ligne(`Commandes en cours${exo ? "" : " / en instance de facturation"} — ${et.enCours.length} (TTC ${formatDH(et.enCoursTTC)}, acomptes ${formatDH(et.enCoursRegle)})`, et.enCoursReste, false, TAUPE)}
              </div>
              <div style={{ fontSize: 11, color: TAUPE, marginBottom: 12 }}>{exo ? "État exo : document sans en-tête, ne contient que les BLS et les règlements des ventes exonérées." : "État non exo : factures uniquement, avec l'en-tête Stone Concept. Les ventes exo sont sur l'état exo."}</div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                <button type="button" className="sc-btn" onClick={() => setEtatClientModal(null)} style={ghostBtnStyle}>Fermer</button>
                <button type="button" className="sc-btn" onClick={() => exporterEtatClient(cl.id, exo, au, avecSoldes)} style={ghostBtnStyle}>⬇ Excel</button>
                <button type="button" className="sc-btn" onClick={() => imprimerEtatClient(cl.id, exo, au, avecSoldes)} style={primaryBtnStyle}>🖨 Imprimer l'état {exo ? "exo" : "non exo"}</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {/* ERP step 12 (Nils 01/10) : factures clients antérieures à l'ERP */}
      {antOuvert && peutGererFacturesAnt && (() => {
        const liste = [...(facturesAnt || [])].sort((a, b) => ((clientDe(a.clientId) || {}).nom || "").localeCompare((clientDe(b.clientId) || {}).nom || "", "fr") || (a.date < b.date ? -1 : 1));
        return (
          <Overlay onClose={() => setAntOuvert(false)}>
            <div style={modalStyle(820)}>
              <div style={modalTitleStyle}>Factures clients antérieures à l'ERP ({liste.length})</div>
              <div style={{ fontSize: 12, color: TAUPE, marginBottom: 12, lineHeight: 1.6 }}>
                Factures (et BLS exo) émises avant l'ERP, sans description : elles alimentent l'état client et se relient aux encaissements des caisses comme une facture. Un avoir d'avant l'ERP se saisit avec « + Ajouter un avoir » (montant positif, rattaché à sa facture) : il réduit le reste dû de la facture.
                « Déjà réglé » = payé avant le {formatDate(DATE_REPRISE_CAISSES)} (reprise des caisses) ; les paiements suivants se relient dans Comptabilité.
              </div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
                <button type="button" className="sc-btn" onClick={telechargerModeleFacturesAnt} style={ghostBtnStyle}>⬇ Modèle Excel à remplir</button>
                <label className="sc-btn" style={{ ...ghostBtnStyle, cursor: "pointer" }}>⬆ Importer le fichier rempli<input type="file" accept=".xlsx,.xls" style={{ display: "none" }} onChange={(e) => { const fi = e.target.files && e.target.files[0]; e.target.value = ""; importerFacturesAnt(fi); }} /></label>
                <button type="button" className="sc-btn" onClick={() => setAntSaisie({ type: "avoir", clientId: "", factureAntId: "", numero: "", date: "", reference: "", ttc: "", remarque: "" })} style={{ ...ghostBtnStyle, marginLeft: "auto" }}>+ Ajouter un avoir</button>
                <button type="button" className="sc-btn" onClick={() => setAntSaisie({ clientId: "", numero: "", date: "", reference: "", ttc: "", exo: false, chantierId: "", dejaRegle: "", remarque: "" })} style={primaryBtnStyle}>+ Ajouter une facture</button>
              </div>
              <div style={{ maxHeight: 420, overflowY: "auto", border: `1px solid ${PIERRE}`, borderRadius: 8 }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                  <thead><tr style={{ background: PIERRE }}>{["Client", "N°", "Date", "Réf. contremarque", "TTC", "Déjà réglé", "Reste", "Projet", ""].map((h) => <th key={h} style={{ textAlign: "left", padding: "6px 8px" }}>{h}</th>)}</tr></thead>
                  <tbody>
                    {liste.map((x) => {
                      if (x.type === "avoir") {
                        const fa = (facturesAnt || []).find((y) => y.id === x.factureAntId);
                        return (
                          <tr key={x.id} style={{ borderTop: `1px solid ${PIERRE}`, color: OCRE }}>
                            <td style={{ padding: "5px 8px" }}>{(clientDe(x.clientId) || {}).nom || "?"}</td>
                            <td style={{ padding: "5px 8px" }}>Avoir {x.numero}{x.exo ? " (exo)" : ""}<div style={{ fontSize: 11, color: TAUPE }}>sur {fa ? fa.numero : "?"}</div></td>
                            <td style={{ padding: "5px 8px" }}>{formatDate(x.date)}</td>
                            <td style={{ padding: "5px 8px" }}>{x.reference}</td>
                            <td style={{ padding: "5px 8px", whiteSpace: "nowrap" }}>− {formatDH(Number(x.ttc))}</td>
                            <td style={{ padding: "5px 8px" }}>—</td>
                            <td style={{ padding: "5px 8px" }}>—</td>
                            <td style={{ padding: "5px 8px" }}>{((chantiers || []).find((c) => c.id === x.chantierId) || {}).nom || ""}</td>
                            <td style={{ padding: "5px 8px", whiteSpace: "nowrap" }}>
                              <button type="button" className="sc-btn" onClick={() => setAntSaisie({ ...x })} style={iconBtnStyle} title="Modifier">✎</button>
                              <button type="button" className="sc-btn" onClick={async () => { if (await demander(`Supprimer l'avoir ${x.numero} ?`)) supprimerFactureAnt(x.id); }} style={iconBtnStyle} title="Supprimer">✕</button>
                            </td>
                          </tr>
                        );
                      }
                      const reste = arrondiH((Number(x.ttc) || 0) - encaisseDossier(`ant:${x.id}`));
                      return (
                        <tr key={x.id} style={{ borderTop: `1px solid ${PIERRE}` }}>
                          <td style={{ padding: "5px 8px" }}>{(clientDe(x.clientId) || {}).nom || "?"}</td>
                          <td style={{ padding: "5px 8px" }}>{x.numero}{x.exo ? <span style={{ color: OCRE }}> (exo)</span> : ""}</td>
                          <td style={{ padding: "5px 8px" }}>{formatDate(x.date)}</td>
                          <td style={{ padding: "5px 8px", color: x.reference ? ENCRE : ROUILLE }}>{x.reference || "à compléter"}</td>
                          <td style={{ padding: "5px 8px", whiteSpace: "nowrap" }}>{formatDH(Number(x.ttc))}</td>
                          <td style={{ padding: "5px 8px", whiteSpace: "nowrap" }}>{formatDH(Number(x.dejaRegle) || 0)}</td>
                          <td style={{ padding: "5px 8px", whiteSpace: "nowrap", color: reste > 0.01 ? ROUILLE : VERT_OK }}>{formatDH(reste)}</td>
                          <td style={{ padding: "5px 8px" }}>{((chantiers || []).find((c) => c.id === x.chantierId) || {}).nom || ""}</td>
                          <td style={{ padding: "5px 8px", whiteSpace: "nowrap" }}>
                            {peut("commandes.avoirs") && <button type="button" className="sc-btn" onClick={() => ouvrirNouvelAvoir(dossierParId(`ant:${x.id}`))} style={{ ...iconBtnStyle, width: "auto", padding: "0 6px", fontSize: 11 }} title="Créer un NOUVEL avoir dans l'ERP (numéro AV / AVS de l'ERP) — pour un avoir d'avant l'ERP, utilise « + Ajouter un avoir »">Avoir ERP{avoirsDeFacture(`ant:${x.id}`).length ? ` (${avoirsDeFacture(`ant:${x.id}`).length})` : ""}</button>}
                            {avoirsDeFacture(`ant:${x.id}`).map((a) => <button key={a.id} type="button" className="sc-btn" onClick={() => imprimerAvoir(a)} style={{ ...iconBtnStyle, width: "auto", padding: "0 6px", fontSize: 11 }} title={`${a.motif} — ${formatDH(a.ttc)} TTC`}>🖨 {a.numero}</button>)}
                            <button type="button" className="sc-btn" onClick={() => setAntSaisie({ ...x })} style={iconBtnStyle} title="Modifier">✎</button>
                            <button type="button" className="sc-btn" onClick={async () => { if (await demander(`Supprimer ${x.numero} ?`)) supprimerFactureAnt(x.id); }} style={iconBtnStyle} title="Supprimer">✕</button>
                          </td>
                        </tr>
                      );
                    })}
                    {!liste.length && <tr><td colSpan={9} style={{ padding: 14, color: TAUPE }}>Aucune facture antérieure pour l'instant — télécharge le modèle, fais-le remplir par l'Administration puis importe-le.</td></tr>}
                  </tbody>
                </table>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}><button type="button" className="sc-btn" onClick={() => setAntOuvert(false)} style={ghostBtnStyle}>Fermer</button></div>
            </div>
          </Overlay>
        );
      })()}
      {antSaisie && peutGererFacturesAnt && antSaisie.type === "avoir" && (() => {
        const f = antSaisie;
        const set = (p) => setAntSaisie({ ...f, ...p });
        const facturesClient = (facturesAnt || []).filter((x) => x.type !== "avoir" && x.clientId === f.clientId).sort((a, b) => (a.date < b.date ? -1 : 1));
        const fa = facturesClient.find((x) => x.id === f.factureAntId);
        return (
          <Overlay onClose={() => setAntSaisie(null)} zIndex={110}>
            <div style={modalStyle(520)}>
              <div style={modalTitleStyle}>{f.id ? `Avoir antérieur ${f.numero}` : "Nouvel avoir antérieur à l'ERP"}</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 12 }}>Montant en positif : il réduit le reste dû de la facture d'origine. Exo, projet et référence sont ceux de la facture. N'utilise pas les séries AV / AVS de l'ERP.</div>
              <Field label="Client">
                <select className="sc-select" value={f.clientId} onChange={(e) => set({ clientId: e.target.value, factureAntId: "" })} style={selectStyle}>
                  <option value="">— Choisir —</option>
                  {trierAlpha((clients || []).filter((c) => !c.archive && (facturesAnt || []).some((x) => x.type !== "avoir" && x.clientId === c.id)), "nom").map((c) => (<option key={c.id} value={c.id}>{c.nom}</option>))}
                </select>
              </Field>
              <Field label="Facture d'origine (facture antérieure)">
                <select className="sc-select" value={f.factureAntId} onChange={(e) => set({ factureAntId: e.target.value })} disabled={!f.clientId} style={selectStyle}>
                  <option value="">— Choisir —</option>
                  {facturesClient.map((x) => (<option key={x.id} value={x.id}>{x.numero} — {formatDate(x.date)} — {formatDH(Number(x.ttc))}{x.exo ? " (exo)" : ""} — {x.reference}</option>))}
                </select>
                {f.clientId && !facturesClient.length && <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Aucune facture antérieure pour ce client : saisis d'abord la facture.</div>}
              </Field>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <Field label="N° de l'avoir"><input className="sc-input" value={f.numero} onChange={(e) => set({ numero: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label="Date"><input type="date" className="sc-input" value={f.date} onChange={(e) => set({ date: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label="Montant TTC (positif)"><input className="sc-input" value={f.ttc} onChange={(e) => set({ ttc: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label="Réf. contremarque"><input className="sc-input" value={f.reference || ""} onChange={(e) => set({ reference: e.target.value })} placeholder={fa ? fa.reference : "celle de la facture"} style={inputStyle("100%")} /></Field>
              </div>
              <Field label="Remarque"><input className="sc-input" value={f.remarque || ""} onChange={(e) => set({ remarque: e.target.value })} style={inputStyle("100%")} /></Field>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 12 }}>
                <button type="button" className="sc-btn" onClick={() => setAntSaisie(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={enregistrerFactureAnt} style={primaryBtnStyle}>Enregistrer</button>
              </div>
            </div>
          </Overlay>
        );
      })()}
      {antSaisie && peutGererFacturesAnt && antSaisie.type !== "avoir" && (() => {
        const f = antSaisie;
        const set = (p) => setAntSaisie({ ...f, ...p });
        const projets = (chantiers || []).filter((c) => c.clientId === f.clientId);
        const reliee = f.id && antReliee(f.id);
        return (
          <Overlay onClose={() => setAntSaisie(null)} zIndex={110}>
            <div style={modalStyle(520)}>
              <div style={modalTitleStyle}>{f.id ? `Facture antérieure ${f.numero}` : "Nouvelle facture antérieure à l'ERP"}</div>
              <Field label="Client">
                <select className="sc-select" value={f.clientId} onChange={(e) => set({ clientId: e.target.value, chantierId: "" })} disabled={!!reliee} style={selectStyle}>
                  <option value="">— Choisir —</option>
                  {trierAlpha((clients || []).filter((c) => !c.archive), "nom").map((c) => (<option key={c.id} value={c.id}>{c.nom}</option>))}
                </select>
              </Field>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <Field label="N° facture / BLS"><input className="sc-input" value={f.numero} onChange={(e) => set({ numero: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label="Date"><input type="date" className="sc-input" value={f.date} onChange={(e) => set({ date: e.target.value })} style={inputStyle("100%")} /></Field>
                <Field label="Réf. contremarque (obligatoire)"><input className="sc-input" value={f.reference || ""} onChange={(e) => set({ reference: e.target.value })} placeholder="ex. Villa Dassouli" style={inputStyle("100%")} /></Field>
                <div />
                <Field label="Montant TTC"><input className="sc-input" value={f.ttc} onChange={(e) => set({ ttc: e.target.value })} disabled={!!reliee} style={inputStyle("100%")} /></Field>
                <Field label={`Déjà réglé avant le ${formatDate(DATE_REPRISE_CAISSES)}`}><input className="sc-input" value={f.dejaRegle} onChange={(e) => set({ dejaRegle: e.target.value })} placeholder="0" style={inputStyle("100%")} /></Field>
              </div>
              <label style={{ fontSize: 13, display: "flex", gap: 6, alignItems: "center", margin: "4px 0 10px" }}><input type="checkbox" checked={!!f.exo} disabled={!!reliee} onChange={(e) => set({ exo: e.target.checked })} /> Vente exo (BLS) — n'apparaît que sur l'état exo</label>
              <Field label="Projet immobilier (facultatif — vide = commande particulier)">
                <select className="sc-select" value={f.chantierId || ""} onChange={(e) => set({ chantierId: e.target.value })} disabled={!f.clientId} style={selectStyle}>
                  <option value="">— Commande particulier —</option>
                  {projets.map((c) => (<option key={c.id} value={c.id}>{c.nom}</option>))}
                  {estGerant && <option value="__nouveau">+ Nouveau projet…</option>}
                </select>
                {f.chantierId === "__nouveau" && <input className="sc-input" value={f.nouveauProjet || ""} onChange={(e) => set({ nouveauProjet: e.target.value })} placeholder="Nom du projet" style={{ ...inputStyle("100%"), marginTop: 6 }} />}
                {/* Nils 29/10 : retenue de garantie retenue sur cette facture d'avant l'ERP, à facturer en fin de projet. */}
                {f.chantierId && <div style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, marginTop: 6 }}>Retenue de garantie (HT, à facturer en fin de projet) <input className="sc-input" inputMode="decimal" value={f.retenueHT ?? ""} onChange={(e) => set({ retenueHT: e.target.value })} placeholder="0" style={{ ...inputStyle(120), padding: "4px 8px" }} /></div>}
              </Field>
              <Field label="Remarque"><input className="sc-input" value={f.remarque || ""} onChange={(e) => set({ remarque: e.target.value })} style={inputStyle("100%")} /></Field>
              {reliee && <div style={{ fontSize: 11, color: TAUPE }}>Reliée à des encaissements : client, montant et exo ne sont plus modifiables.</div>}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 12 }}>
                <button type="button" className="sc-btn" onClick={() => setAntSaisie(null)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={enregistrerFactureAnt} style={primaryBtnStyle}>Enregistrer</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {showClientFiche && clientEditing && (
        <Overlay onClose={() => setShowClientFiche(false)}>
          <div style={modalStyle(480)}>
            <div style={modalTitleStyle}>{clientEditing.id ? "Modifier le client" : "Nouveau client"}</div>
            {!clientEditing.id && !peut("clients.validerEtape2") && (
              <div style={{ background: "#F5EFE0", color: OCRE, fontSize: 12, padding: "8px 12px", borderRadius: 6, marginTop: -6, marginBottom: 14 }}>
                {peut("clients.validerEtape1") ? "Ce client sera créé « à valider » : Le Gérant doit le valider avant que ses devis puissent passer en BDC." : "Ce client sera créé « à valider » : l'Administration puis le Gérant doivent le valider avant que ses devis puissent passer en BDC."}
                {user.clientsRestreintACommercial ? " Il te sera automatiquement rattaché comme commercial." : ""}
              </div>
            )}

            <div style={{ display: "flex", gap: 10 }}>
              <Field label="Nom commercial" style={{ flex: 1.5 }}>
                <input
                  autoFocus
                  className="sc-input"
                  value={clientEditing.nom}
                  onChange={(e) => {
                    setClientEditing({ ...clientEditing, nom: e.target.value });
                    if (clientError) setClientError("");
                  }}
                  placeholder="ex. Carrera"
                  style={inputStyle("100%")}
                />
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Le nom qu'emploie l'équipe au quotidien.</div>
              </Field>
              <Field label="Type" style={{ flex: 1 }}>
                <select
                  className="sc-select"
                  value={clientEditing.type}
                  onChange={(e) => setClientEditing({ ...clientEditing, type: e.target.value })}
                  style={selectStyle}
                >
                  {TYPES_CLIENT.map((t) => (
                    <option key={t}>{t}</option>
                  ))}
                </select>
              </Field>
            </div>

            <div style={{ background: PIERRE, borderRadius: 8, padding: 12, marginBottom: 14 }}>
              <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 10 }}>
                Notation relationnelle
              </div>
              <div style={{ display: "flex", gap: 10, marginBottom: 12 }}>
                {AXES_CLIENT.map((axe) => (
                  <Field key={axe.cle} label={axe.label} style={{ flex: 1, marginBottom: 0 }}>
                    <select
                      className="sc-select"
                      value={clientEditing[`notes_${axe.cle}`]}
                      onChange={(e) => setClientEditing({ ...clientEditing, [`notes_${axe.cle}`]: e.target.value })}
                      style={{ ...selectStyle, background: "#fff" }}
                      title={axe.critere}
                    >
                      {NOTES_LETTRES.map((l) => (
                        <option key={l}>{l}</option>
                      ))}
                    </select>
                  </Field>
                ))}
              </div>
              <div style={{ fontSize: 11, color: TAUPE, lineHeight: 1.5 }}>
                Chaque service note son axe (A bon · B moyen · C problématique · – non noté). Survole un champ pour son critère. Le détail se met en notes.
              </div>
            </div>

            <Field label="Paiement (comptabilité)">
              <select
                className="sc-select"
                value={clientEditing.paiement_niveau}
                onChange={(e) => setClientEditing({ ...clientEditing, paiement_niveau: e.target.value })}
                style={{
                  ...selectStyle,
                  borderLeft: `4px solid ${paiementFg(clientEditing.paiement_niveau)}`,
                }}
              >
                {PAIEMENTS_NIVEAUX.map((p) => (
                  <option key={p.cle} value={p.cle}>
                    {p.label}
                  </option>
                ))}
              </select>
              <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                Séparé du relationnel : un souci de paiement ne se compense pas.
              </div>
            </Field>

            {clientEditing.type !== TYPE_SANS_ICE && (
              <Field label="Raison sociale (facturation)">
                <input
                  className="sc-input"
                  value={clientEditing.raisonSociale}
                  onChange={(e) => setClientEditing({ ...clientEditing, raisonSociale: e.target.value })}
                  placeholder="ex. Mao Sarl"
                  style={inputStyle("100%")}
                />
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                  Nom qui figurera sur les devis et factures. Laisse vide s'il est identique au nom commercial.
                </div>
              </Field>
            )}

            {clientEditing.type !== TYPE_SANS_ICE && (
              <Field label="ICE">
                <input
                  className="sc-input"
                  value={clientEditing.ice}
                  onChange={(e) => {
                    setClientEditing({ ...clientEditing, ice: e.target.value });
                    if (clientError) setClientError("");
                  }}
                  placeholder="ex. 000073605000001"
                  style={inputStyle("100%")}
                />
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Obligatoire, sauf pour un particulier.</div>
              </Field>
            )}

            <div style={{ display: "flex", gap: 10 }}>
              <Field label="Conditions de paiement" style={{ flex: 1.5 }}>
                <select
                  className="sc-select"
                  value={clientEditing.paiement}
                  onChange={(e) => setClientEditing({ ...clientEditing, paiement: e.target.value })}
                  style={selectStyle}
                >
                  <option value="">— Choisir —</option>
                  {trierAlpha(paiements, "label").map((p) => (
                    <option key={p.label} value={p.label}>{p.label}</option>
                  ))}
                </select>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                  Condition manquante ?{" "}
                  <span
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => {
                      setPaiementError("");
                      setPaiementSuccess("");
                      setShowPaiementManager(true);
                    }}
                  >
                    Gérer la liste
                  </span>
                  .
                </div>
              </Field>
              <Field label="Remise habituelle (%)" style={{ flex: 1 }}>
                <input
                  type="number"
                  step="0.5"
                  min="0"
                  max="100"
                  className="sc-input"
                  value={clientEditing.remise}
                  onChange={(e) => {
                    setClientEditing({ ...clientEditing, remise: e.target.value });
                    if (clientError) setClientError("");
                  }}
                  placeholder="0"
                  style={inputStyle("100%")}
                />
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Pré-remplira ses devis.</div>
              </Field>
            </div>

            <Field label="Plafond d'exposition (facultatif)">
              <input
                type="number"
                min="0"
                className="sc-input"
                value={clientEditing.plafondExposition}
                onChange={(e) => {
                  setClientEditing({ ...clientEditing, plafondExposition: e.target.value });
                  if (clientError) setClientError("");
                }}
                placeholder="ex. 150000"
                style={inputStyle("100%")}
              />
              <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                Encours maximal toléré pour ce client (factures et BLS non soldés + reste des commandes en cours, exo et non exo). Dépassé au BDC ou au BL : case à cocher obligatoire et alerte au Gérant.
              </div>
            </Field>

            <Field label={clientEditing.id ? "Commercial Stone Concept" : "Commercial Stone Concept *"}>
              <select
                className="sc-select"
                value={clientEditing.commercialSC}
                onChange={(e) => setClientEditing({ ...clientEditing, commercialSC: e.target.value })}
                style={selectStyle}
              >
                <option value="">— Choisir —</option>
                {trierAlpha(utilisateurs.filter((u) => u.commercial && u.actif), "nom").map((u) => (
                  <option key={u.id} value={u.nom}>
                    {u.nom} — {u.role}
                  </option>
                ))}
              </select>
              <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Qui suit ce client chez nous.</div>
            </Field>
            {(estGerant || user.profil === P_ADV_SR) && (
              <Field label="Client directionnel">
                <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, cursor: "pointer" }}>
                  <input type="checkbox" checked={!!clientEditing.clientDirectionnel} onChange={(e) => setClientEditing({ ...clientEditing, clientDirectionnel: e.target.checked })} />
                  Client directionnel
                </label>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Commission Com1 au taux « client directionnel », quel que soit le commercial (un client suivi par le Gérant l'est d'office). Visible par le Gérant et l'ADV senior seulement.</div>
              </Field>
            )}

            <Field label="Apporteur d'affaire (facultatif)">
              <select
                className="sc-select"
                value={clientEditing.apporteurAffaire || ""}
                onChange={(e) => setClientEditing({ ...clientEditing, apporteurAffaire: e.target.value })}
                style={selectStyle}
              >
                <option value="">— Aucun (commercial Stone Concept par défaut) —</option>
                {trierAlpha(apporteursAffaire).map((ap) => (
                  <option key={ap} value={ap}>{ap}</option>
                ))}
              </select>
              <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                Si vide, le commercial Stone Concept ci-dessus fait office d'apporteur. Jamais imprimé sur les documents client.
              </div>
              <button type="button" className="sc-btn" onClick={() => setShowApporteurManager(true)} style={{ ...ghostBtnStyle, padding: "4px 0", fontSize: 12 }}>Gérer les apporteurs d'affaire</button>
            </Field>

            <Field label="Source — comment le client nous a connus">
              <select className="sc-select" value={clientEditing.source || ""} onChange={(e) => setClientEditing({ ...clientEditing, source: e.target.value })} style={selectStyle}>
                <option value="">— Non renseignée —</option>
                {[...new Set([...sourcesClient(), ...(clientEditing.source ? [clientEditing.source] : [])])].map((x) => (<option key={x} value={x}>{x}</option>))}
              </select>
              {estGerant && budgetMarketing().sources.includes(clientEditing.source) && <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Source suivie : tout le CA payé de ce client entre dans le budget community management.</div>}
            </Field>

            <Field label="Adresse">
              <input
                className="sc-input"
                value={clientEditing.adresse || ""}
                onChange={(e) => setClientEditing({ ...clientEditing, adresse: e.target.value })}
                placeholder="ex. 12 rue des Fleurs"
                style={inputStyle("100%")}
              />
            </Field>
            <div style={{ display: "flex", gap: 10 }}>
              <Field label="Code postal" style={{ flex: 0.6 }}>
                <input
                  className="sc-input"
                  value={clientEditing.codePostal || ""}
                  onChange={(e) => setClientEditing({ ...clientEditing, codePostal: e.target.value })}
                  placeholder="ex. 20000"
                  style={inputStyle("100%")}
                />
              </Field>
              <Field label="Ville" style={{ flex: 1 }}>
                <input
                  className="sc-input"
                  value={clientEditing.ville || ""}
                  onChange={(e) => setClientEditing({ ...clientEditing, ville: e.target.value })}
                  placeholder="ex. Casablanca"
                  style={inputStyle("100%")}
                />
              </Field>
            </div>

            <div style={{ borderTop: `1px solid ${PIERRE}`, paddingTop: 14, marginBottom: 14 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>Adresses supplémentaires</div>
                <button type="button" className="sc-btn" onClick={addClientAdresse} style={movBtnStyle}>
                  + Ajouter une adresse
                </button>
              </div>
              <div style={{ fontSize: 11, color: TAUPE, marginBottom: 10 }}>
                Utile si le client a un showroom, un chantier ou un siège social distinct de l'adresse ci-dessus.
              </div>
              {(clientEditing.adressesSupp || []).length === 0 && (
                <div style={{ fontSize: 12, color: TAUPE }}>Aucune adresse supplémentaire.</div>
              )}
              {(clientEditing.adressesSupp || []).map((a) => (
                <div key={a.id} style={{ background: PIERRE, borderRadius: 8, padding: 10, marginBottom: 8 }}>
                  <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                    <input
                      className="sc-input"
                      value={a.libelle}
                      onChange={(e) => updateClientAdresse(a.id, "libelle", e.target.value)}
                      placeholder="Libellé (ex. Showroom)"
                      style={{ ...inputStyle("100%"), background: "#fff", flex: 0.8 }}
                    />
                    <input
                      className="sc-input"
                      value={a.adresse}
                      onChange={(e) => updateClientAdresse(a.id, "adresse", e.target.value)}
                      placeholder="Adresse"
                      style={{ ...inputStyle("100%"), background: "#fff", flex: 1.5 }}
                    />
                    <button
                      type="button"
                      className="sc-btn"
                      onClick={() => removeClientAdresse(a.id)}
                      style={{ ...iconBtnStyle, background: "transparent" }}
                      title="Retirer"
                    >
                      ✕
                    </button>
                  </div>
                  <div style={{ display: "flex", gap: 8 }}>
                    <input
                      className="sc-input"
                      value={a.codePostal || ""}
                      onChange={(e) => updateClientAdresse(a.id, "codePostal", e.target.value)}
                      placeholder="Code postal"
                      style={{ ...inputStyle("100%"), background: "#fff", flex: 0.6 }}
                    />
                    <input
                      className="sc-input"
                      value={a.ville || ""}
                      onChange={(e) => updateClientAdresse(a.id, "ville", e.target.value)}
                      placeholder="Ville"
                      style={{ ...inputStyle("100%"), background: "#fff", flex: 1 }}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div style={{ borderTop: `1px solid ${PIERRE}`, paddingTop: 14, marginBottom: 14 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>Contacts chez le client</div>
                <button type="button" className="sc-btn" onClick={addClientContact} style={movBtnStyle}>
                  + Ajouter
                </button>
              </div>
              <div style={{ fontSize: 11, color: TAUPE, marginBottom: 10 }}>
                Tous ces contacts seront proposés au moment de réserver, pour faciliter les relances.
              </div>
              {(clientEditing.contacts || []).length === 0 && (
                <div style={{ fontSize: 12, color: TAUPE }}>Aucun contact renseigné.</div>
              )}
              {(clientEditing.contacts || []).map((c) => (
                <div key={c.id} style={{ background: PIERRE, borderRadius: 8, padding: 10, marginBottom: 8 }}>
                  <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                    <input
                      className="sc-input"
                      value={c.nom}
                      onChange={(e) => updateClientContact(c.id, "nom", e.target.value)}
                      placeholder="Nom"
                      style={{ ...inputStyle("100%"), background: "#fff", flex: 1.2 }}
                    />
                    <select
                      className="sc-select"
                      value={c.fonction}
                      onChange={(e) => updateClientContact(c.id, "fonction", e.target.value)}
                      style={{ ...selectStyle, background: "#fff", flex: 1 }}
                    >
                      {FONCTIONS.map((fn) => (
                        <option key={fn}>{fn}</option>
                      ))}
                    </select>
                    <button
                      type="button"
                      className="sc-btn"
                      onClick={() => removeClientContact(c.id)}
                      style={{ ...iconBtnStyle, background: "transparent" }}
                      title="Retirer"
                    >
                      ✕
                    </button>
                  </div>
                  <div style={{ display: "flex", gap: 8 }}>
                    <input
                      className="sc-input"
                      value={c.tel}
                      onChange={(e) => updateClientContact(c.id, "tel", e.target.value)}
                      placeholder="Téléphone"
                      style={{ ...inputStyle("100%"), background: "#fff", flex: 1 }}
                    />
                    <input
                      className="sc-input"
                      value={c.email}
                      onChange={(e) => updateClientContact(c.id, "email", e.target.value)}
                      placeholder="Email"
                      style={{ ...inputStyle("100%"), background: "#fff", flex: 1.3 }}
                    />
                  </div>
                </div>
              ))}
            </div>

            <Field label="Notes">
              <textarea
                className="sc-input"
                value={clientEditing.notes}
                onChange={(e) => setClientEditing({ ...clientEditing, notes: e.target.value })}
                rows={2}
                placeholder="Conditions particulières, motif de la fiabilité (paiement, contestations, SAV…)…"
                style={{ ...inputStyle("100%"), resize: "vertical", fontFamily: "'DM Sans', sans-serif" }}
              />
            </Field>

            {clientEditing.id && estGerant && (() => {
              // Nils 02/11 : gratuités du client (Gérant seul).
              const gl = gratuitesDe(clientEditing.id);
              if (!gl.length) return null;
              const tot = gl.reduce((n, x) => n + x.valeurTTC, 0);
              const totCout = gl.reduce((n, x) => n + (x.coutMatiere || 0), 0);
              return (
                <details style={{ marginBottom: 14, background: PIERRE, borderRadius: 8, padding: "8px 12px" }}>
                  <summary style={{ cursor: "pointer", fontSize: 13, fontWeight: 600 }}>Gratuités ({gl.length}) — {formatDH(tot)} TTC offerts · coût matière {formatDH(totCout)}</summary>
                  {gl.map((x) => (
                    <div key={x.c.id} style={{ borderTop: "1px solid #e2dcd8", padding: "6px 0", fontSize: 12 }}>
                      <strong>{formatDate(x.date)}</strong> · {x.c.numero}{x.c.numeroBL ? ` / BL ${x.c.numeroBL}` : x.c.numeroPL ? ` / PL ${x.c.numeroPL}` : ""} · {x.motif} · valeur {formatDH(x.valeurTTC)} TTC · coût matière {x.coutMatiere === null ? "—" : formatDH(x.coutMatiere)}{x.c.reference ? ` · ${x.c.reference}` : ""}
                    </div>
                  ))}
                </details>
              );
            })()}

            {clientEditing.id && peut("commercial.rapport") && (() => {
              // ERP step 13 (ah9) : historique des visites de tous les commerciaux (y compris quand c'était un prospect).
              const vc = visitesDuClient(clientEditing.id);
              return (
                <details style={{ marginBottom: 14, background: PIERRE, borderRadius: 8, padding: "8px 12px" }}>
                  <summary style={{ cursor: "pointer", fontSize: 13, fontWeight: 600 }}>Visites ({vc.length})</summary>
                  {vc.length === 0 && <div style={{ fontSize: 12, color: TAUPE, marginTop: 6 }}>Aucune visite enregistrée.</div>}
                  {vc.map((v) => (
                    <div key={v.id} style={{ borderTop: "1px solid #e2dcd8", padding: "6px 0", fontSize: 12 }}>
                      <div><strong>{formatDate(v.date)}{v.heure ? ` ${v.heure}` : ""}</strong> · {nomUtilisateur(v.commercialId) || "?"} · {v.typeVisite}{v.compteType === "prospect" ? " · (prospect)" : ""}</div>
                      <div style={{ whiteSpace: "pre-wrap" }}>{v.synthese}</div>
                      {(v.actions || []).length > 0 && <div style={{ color: TAUPE }}>{(v.actions || []).map((a) => `${a.faite ? "☑" : "☐"} ${a.texte}${a.echeance ? ` (${formatDate(a.echeance)})` : ""}`).join(" · ")}</div>}
                    </div>
                  ))}
                </details>
              );
            })()}
            {clientError && (
              <div style={{ background: "#F5E4DE", color: ROUILLE, fontSize: 13, fontWeight: 600, padding: "10px 12px", borderRadius: 6, marginBottom: 14 }}>
                {clientError}
              </div>
            )}

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
              {peut("clients.ficheOuverturePreRemplie") ? (
                <button type="button" className="sc-btn" onClick={() => imprimerFicheOuvertureCompte(clientEditing)} style={{ ...ghostBtnStyle, marginRight: "auto", fontSize: 12 }}>
                  🖨 Imprimer la fiche
                </button>
              ) : <span style={{ marginRight: "auto" }} />}
              <button type="button" className="sc-btn" onClick={() => setShowClientFiche(false)} style={ghostBtnStyle}>
                Annuler
              </button>
              <button type="button" className="sc-btn" onClick={saveClient} style={primaryBtnStyle}>
                Enregistrer
              </button>
            </div>
          </div>
        </Overlay>
      )}

      {/* Fiche fournisseur — aussi utilisée en mode "demande" (ERP step 12, pt.6) */}
      {showFourFiche && fourEditing && (
        <Overlay zIndex={100} onClose={() => setShowFourFiche(false)}>
          <div style={modalStyle(480)}>
            <div style={modalTitleStyle}>{fourEstDemande ? "Demande de création fournisseur" : demandeFourEnCours ? "Traiter la demande de fournisseur" : fourEditing.id ? "Modifier le fournisseur" : "Nouveau fournisseur"}</div>
            {fourEstDemande && (
              <div style={{ fontSize: 11, color: TAUPE, marginTop: -6, marginBottom: 14 }}>
                Cette demande est transmise à le Gérant et l'Administration, seuls habilités à créer un fournisseur. Ils la convertiront ou l'ignoreront depuis cet onglet.
              </div>
            )}
            {demandeFourEnCours && !fourEstDemande && (
              <div style={{ fontSize: 11, color: TAUPE, marginTop: -6, marginBottom: 14 }}>
                Corrige si besoin les informations saisies par le demandeur, puis crée le fournisseur — ou enregistre les corrections sans encore créer le fournisseur.
              </div>
            )}

            <Field label="Nom">
              <input
                autoFocus
                className="sc-input"
                value={fourEditing.nom}
                onChange={(e) => {
                  setFourEditing({ ...fourEditing, nom: e.target.value });
                  if (fourError) setFourError("");
                }}
                placeholder="ex. Artinox"
                style={inputStyle("100%")}
              />
            </Field>

            <div style={{ display: "flex", gap: 10 }}>
              <Field label="Origine" style={{ flex: 1 }}>
                <select
                  className="sc-select"
                  value={fourEditing.origine}
                  onChange={(e) => {
                    setFourEditing({ ...fourEditing, origine: e.target.value });
                    if (fourError) setFourError("");
                  }}
                  style={selectStyle}
                >
                  {ORIGINES.map((o) => (
                    <option key={o}>{o}</option>
                  ))}
                </select>
              </Field>
              <Field label="Fiabilité" style={{ flex: 1 }}>
                <select
                  className="sc-select"
                  value={fourEditing.fiabilite}
                  onChange={(e) => setFourEditing({ ...fourEditing, fiabilite: e.target.value })}
                  style={selectStyle}
                >
                  {FIABILITES.map((f) => (
                    <option key={f}>{f}</option>
                  ))}
                </select>
              </Field>
            </div>
            {fourEditing.origine === "Étranger" && (
              <div style={{ display: "flex", gap: 10 }}>
                <Field label="Pays d'import" style={{ flex: 1 }}>
                  <input className="sc-input" list="pays-fournisseurs" value={fourEditing.pays || ""} onChange={(e) => setFourEditing({ ...fourEditing, pays: e.target.value })} placeholder="ex. Espagne" style={inputStyle("100%")} />
                  <datalist id="pays-fournisseurs">{[...new Set((fournisseurs || []).map((x) => x.pays).filter(Boolean))].map((x) => <option key={x} value={x} />)}</datalist>
                </Field>
                <Field label="Incoterm habituel" style={{ flex: 1 }}>
                  <select className="sc-select" value={fourEditing.incoterm || ""} onChange={(e) => setFourEditing({ ...fourEditing, incoterm: e.target.value })} style={selectStyle}>
                    <option value="">— Choisir —</option>
                    {INCOTERMS.map((x) => <option key={x} value={x}>{x}</option>)}
                  </select>
                </Field>
              </div>
            )}

            {fourEditing.id && (
              <div style={{ fontSize: 11, color: TAUPE, marginTop: -6, marginBottom: 14 }}>
                Matières fournies (déduites des catégories) :{" "}
                <strong style={{ color: ENCRE }}>
                  {matieresFournies(fourEditing.nom).join(", ") || "aucune"}
                </strong>
              </div>
            )}

            <Field label="Conditions de paiement">
              <select
                className="sc-select"
                value={fourEditing.paiement}
                onChange={(e) => {
                  setFourEditing({ ...fourEditing, paiement: e.target.value });
                  if (fourError) setFourError("");
                }}
                style={selectStyle}
              >
                <option value="">— Choisir —</option>
                {trierAlpha(paiements, "label").map((p) => (
                  <option key={p.label} value={p.label}>{p.label}</option>
                ))}
              </select>
              <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                Condition manquante ?{" "}
                <span
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                  onClick={() => {
                    setPaiementError("");
                    setPaiementSuccess("");
                    setShowPaiementManager(true);
                  }}
                >
                  Gérer la liste
                </span>
                . Liste commune aux fournisseurs et aux clients.
              </div>
            </Field>

            {/* ERP step 12 (Nils 30/09) : délai de paiement et convention (loi 69-21) */}
            {fourEditing.origine === "Étranger" && (
              <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "8px 12px", marginBottom: 14, fontSize: 12, color: TAUPE }}>
                Fournisseur étranger : la loi 69-21 sur les délais de paiement ne s'applique pas — pas de limite légale ni d'amende ; l'échéancier suit ses conditions de paiement.
              </div>
            )}
            {fourEditing.origine !== "Étranger" && (() => {
              const conv = fourEditing.convention || { active: false, jours: "", date: "" };
              const jc = joursCondition(fourEditing.paiement);
              const max = conv.active ? Math.min(Number(conv.jours) || DELAI_CONVENTION_MAX, DELAI_CONVENTION_MAX) : DELAI_LEGAL_JOURS;
              return (
                <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "8px 12px", marginBottom: 14, fontSize: 12 }}>
                  <div style={{ marginBottom: 6, color: jc !== null && jc > max ? ROUILLE : TAUPE }}>Délai de paiement : {jc === null ? "non déterminé par la condition (indique un nombre de jours dans « Gérer la liste »)" : `${jc} j`} — maximum {conv.active ? `${max} j (convention)` : `${DELAI_LEGAL_JOURS} j date de facture (loi 69-21)`}{jc !== null && jc > max ? ` — ⚠ dépasse la loi : l'échéancier appliquera ${max} j` : ""}</div>
                  <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
                    <input type="checkbox" checked={!!conv.active} onChange={(e) => setFourEditing({ ...fourEditing, convention: { ...conv, active: e.target.checked } })} />
                    Convention de paiement signée (délai jusqu'à {DELAI_CONVENTION_MAX} j)
                  </label>
                  {conv.active && (
                    <div style={{ display: "flex", gap: 10, alignItems: "center", marginTop: 6, flexWrap: "wrap" }}>
                      <span>Délai convenu</span>
                      <input type="number" min="1" max={DELAI_CONVENTION_MAX} className="sc-input" value={conv.jours} onChange={(e) => setFourEditing({ ...fourEditing, convention: { ...conv, jours: e.target.value } })} style={{ ...inputStyle(90), padding: "3px 8px" }} />
                      <span>jours · signée le</span>
                      <input type="date" className="sc-input" value={conv.date || ""} onChange={(e) => setFourEditing({ ...fourEditing, convention: { ...conv, date: e.target.value } })} style={{ ...inputStyle(150), padding: "3px 8px" }} />
                    </div>
                  )}
                </div>
              );
            })()}

            {fourEditing.origine === "Maroc" && (
              <>
                <Field label="ICE">
                  <input
                    className="sc-input"
                    value={fourEditing.ice}
                    onChange={(e) => {
                      setFourEditing({ ...fourEditing, ice: e.target.value });
                      if (fourError) setFourError("");
                    }}
                    placeholder="ex. 000073605000001"
                    style={inputStyle("100%")}
                  />
                </Field>

                <div style={{ background: PIERRE, borderRadius: 8, padding: 12, marginBottom: 14 }}>
                  <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>
                    Certificat de régularité fiscale
                  </div>
                  <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer", marginBottom: 10 }}>
                    <input
                      type="checkbox"
                      checked={fourEditing.certifFourni}
                      onChange={(e) => {
                        setFourEditing({ ...fourEditing, certifFourni: e.target.checked });
                        if (fourError) setFourError("");
                      }}
                    />
                    Certificat fourni
                  </label>
                  {fourEditing.certifFourni && (
                    <Field label="Date d'émission" style={{ marginBottom: 0 }}>
                      <input
                        type="date"
                        className="sc-input"
                        value={fourEditing.certifDate}
                        onChange={(e) => {
                          setFourEditing({ ...fourEditing, certifDate: e.target.value });
                          if (fourError) setFourError("");
                        }}
                        style={inputStyle("100%")}
                      />
                    </Field>
                  )}
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 8 }}>
                    Signalé comme périmé au-delà de {CERTIF_VALIDITE_MOIS} mois.
                  </div>
                </div>
              </>
            )}

            <div style={{ borderTop: `1px solid ${PIERRE}`, paddingTop: 14, marginBottom: 14 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5 }}>Contacts (facultatif)</div>
                <button type="button" className="sc-btn" onClick={addContact} style={movBtnStyle}>
                  + Ajouter
                </button>
              </div>
              {(fourEditing.contacts || []).length === 0 && (
                <div style={{ fontSize: 12, color: TAUPE }}>Aucun contact renseigné.</div>
              )}
              {(fourEditing.contacts || []).map((c) => (
                <div key={c.id} style={{ background: PIERRE, borderRadius: 8, padding: 10, marginBottom: 8 }}>
                  <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                    <input
                      className="sc-input"
                      value={c.nom}
                      onChange={(e) => updateContact(c.id, "nom", e.target.value)}
                      placeholder="Nom"
                      style={{ ...inputStyle("100%"), background: "#fff", flex: 1.2 }}
                    />
                    <select
                      className="sc-select"
                      value={c.fonction}
                      onChange={(e) => updateContact(c.id, "fonction", e.target.value)}
                      style={{ ...selectStyle, background: "#fff", flex: 1 }}
                    >
                      {FONCTIONS.map((fn) => (
                        <option key={fn}>{fn}</option>
                      ))}
                    </select>
                    <button
                      type="button"
                      className="sc-btn"
                      onClick={() => removeContact(c.id)}
                      style={{ ...iconBtnStyle, background: "transparent" }}
                      title="Retirer ce contact"
                    >
                      ✕
                    </button>
                  </div>
                  <div style={{ display: "flex", gap: 8 }}>
                    <input
                      className="sc-input"
                      value={c.tel}
                      onChange={(e) => updateContact(c.id, "tel", e.target.value)}
                      placeholder="Téléphone"
                      style={{ ...inputStyle("100%"), background: "#fff", flex: 1 }}
                    />
                    <input
                      className="sc-input"
                      value={c.email}
                      onChange={(e) => updateContact(c.id, "email", e.target.value)}
                      placeholder="Email"
                      style={{ ...inputStyle("100%"), background: "#fff", flex: 1.3 }}
                    />
                  </div>
                </div>
              ))}
            </div>

            <Field label="Notes">
              <textarea
                className="sc-input"
                value={fourEditing.notes}
                onChange={(e) => setFourEditing({ ...fourEditing, notes: e.target.value })}
                rows={3}
                placeholder="Délais, conditions particulières, historique…"
                style={{ ...inputStyle("100%"), resize: "vertical", fontFamily: "'DM Sans', sans-serif" }}
              />
            </Field>

            {fourError && (
              <div
                style={{
                  background: "#F5E4DE",
                  color: ROUILLE,
                  fontSize: 13,
                  fontWeight: 600,
                  padding: "10px 12px",
                  borderRadius: 6,
                  marginBottom: 14,
                }}
              >
                {fourError}
              </div>
            )}

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, flexWrap: "wrap" }}>
              <button type="button" className="sc-btn" onClick={() => { setShowFourFiche(false); setDemandeFourEnCours(null); }} style={ghostBtnStyle}>
                Annuler
              </button>
              {demandeFourEnCours && (
                <button type="button" className="sc-btn" onClick={enregistrerModifsDemande} style={ghostBtnStyle}>
                  Enregistrer les modifications (sans créer)
                </button>
              )}
              <button type="button" className="sc-btn" onClick={saveFournisseur} style={primaryBtnStyle}>
                {fourEstDemande ? "Envoyer la demande" : demandeFourEnCours ? "Créer le fournisseur" : "Enregistrer"}
              </button>
            </div>
          </div>
        </Overlay>
      )}

      {choixEnregPL && (() => {
        const opts = [
          peutEcrireStock && (produits || []).length > 0 && { id: "matiere", titre: "Articles du catalogue d'un PL", detail: "Matière : tranches, éviers, accessoires, chutes", go: () => openPL() },
          peutEnregistrerConso && { id: "production", titre: "Consommables de production", detail: "Colle, mastic, disques… utilisés à l'atelier pour ce PL", go: () => ouvrirConsommation("production") },
          peutEnregistrerConso && { id: "pose", titre: "Consommables de pose", detail: "Utilisés sur le chantier pour ce PL", go: () => ouvrirConsommation("pose") },
          peutEnregistrerConso && { id: "atelier", titre: "Consommation atelier (hors dossier)", detail: "Ce qui ne se rattache à aucun PL", go: () => ouvrirConsommation("", CONSO_ATELIER) },
          peutDeclarerIncident && { id: "incident", titre: "⚠ Incident de production", detail: "Erreur ou casse avant livraison : tranches refaites sur le PL, pièce ratée au registre", go: () => nouvelIncident() },
        ].filter(Boolean);
        return (
          <Overlay onClose={() => setChoixEnregPL(false)}>
            <div style={modalStyle(480)}>
              <div style={modalTitleStyle}>Enregistrer une consommation</div>
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 14 }}>Qu'est-ce que tu enregistres ?</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {opts.map((o) => (
                  <button key={o.id} type="button" className="sc-btn" onClick={() => { setChoixEnregPL(false); o.go(); }} style={{ textAlign: "left", background: "#fff", border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "10px 14px", cursor: "pointer" }}>
                    <div style={{ fontSize: 14, fontWeight: 600, color: ENCRE }}>{o.titre}</div>
                    <div style={{ fontSize: 12, color: TAUPE }}>{o.detail}</div>
                  </button>
                ))}
              </div>
              {peutEnregistrerConso && (
                <div style={{ borderTop: `1px solid ${PIERRE}`, marginTop: 14, paddingTop: 12 }}>
                  <div style={{ fontSize: 12, color: TAUPE, marginBottom: 6 }}>🖨 Fiches consommables à remplir — atelier ou pose (puis saisie par le bureau technique)</div>
                  <div style={{ display: "flex", gap: 8 }}>
                    <select className="sc-select" aria-label="PL de la fiche consommables" value={plFicheConso} onChange={(e) => setPlFicheConso(e.target.value)} style={{ ...selectStyle, flex: 1, background: "#fff" }}>
                      <option value="">Fiche vierge (sans PL)</option>
                      {(commandesListe || []).filter((c) => c.numeroPL && c.statut !== "Facture").sort((a, b) => (a.numeroPL < b.numeroPL ? 1 : -1)).map((c) => (<option key={c.id} value={c.id}>{c.numeroPL} — {(clientDe(c.clientId) || {}).nom || ""}{c.reference ? ` (${c.reference})` : ""}</option>))}
                    </select>
                    <button type="button" className="sc-btn" onClick={() => imprimerFicheConsommables((commandesListe || []).find((c) => c.id === plFicheConso) || null, "production")} style={ghostBtnStyle}>Atelier</button>
                    <button type="button" className="sc-btn" onClick={() => imprimerFicheConsommables((commandesListe || []).find((c) => c.id === plFicheConso) || null, "pose")} style={ghostBtnStyle}>Pose</button>
                  </div>
                </div>
              )}
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 14 }}>
                <button type="button" className="sc-btn" onClick={() => setChoixEnregPL(false)} style={ghostBtnStyle}>Annuler</button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {showConsommation && (
        <Overlay onClose={() => setShowConsommation(false)}>
          <div style={modalStyle(560)}>
            <div style={modalTitleStyle}>{consommationPL === CONSO_ATELIER ? "Consommation atelier (hors dossier)" : consommationUsage === "pose" ? "Consommables de pose d'un PL" : consommationUsage === "production" ? "Consommables de production d'un PL" : "Enregistrer des consommables"}</div>
            <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 16 }}>
              Pour ce qui ne vient pas du Catalogue (colle, visserie...) et n'est donc pas lié à une commande — contrairement aux Tranches (sauf tranches listello), Éviers et Accessoires, toujours couverts par un BC même en cas de casse.
            </div>

            <div style={{ display: "flex", gap: 10 }}>
              <Field label="Date" style={{ flex: 1 }}>
                <input type="date" className="sc-input" value={consommationDate} onChange={(e) => setConsommationDate(e.target.value)} style={inputStyle(200)} />
              </Field>
              <Field label="N° PL" style={{ flex: 1 }}>
                <select className="sc-select" value={consommationPL} onChange={(e) => { setConsommationPL(e.target.value); if (consommationError) setConsommationError(""); }} style={selectStyle}>
                  <option value="">— Sélectionner un PL —</option>
                  <option value={CONSO_ATELIER}>Atelier (hors dossier)</option>
                  {(commandesListe || [])
                    .filter((c) => c.numeroPL && c.statut !== "Facture")
                    .sort((a, b) => (a.numeroPL < b.numeroPL ? 1 : -1))
                    .map((c) => {
                      const client = clientsActifs.find((x) => x.id === c.clientId);
                      return (
                        <option key={c.id} value={c.numeroPL}>
                          {c.numeroPL}{client ? ` — ${client.nom}` : ""}{c.reference ? ` (${c.reference})` : ""}
                        </option>
                      );
                    })}
                </select>
              </Field>
            </div>

            {consommationPL && consommationPL !== CONSO_ATELIER && (
              <Field label="Type de consommables (obligatoire)">
                <div style={{ display: "flex", gap: 8 }}>
                  {[
                    { id: "production", label: "Production (atelier)" },
                    { id: "pose", label: "Pose (chantier)" },
                  ].map((t) => (
                    <button
                      key={t.id}
                      type="button"
                      className="sc-btn"
                      onClick={() => { setConsommationUsage(t.id); if (consommationError) setConsommationError(""); }}
                      style={{
                        flex: 1,
                        padding: "8px 0",
                        borderRadius: 6,
                        fontSize: 13,
                        fontWeight: 600,
                        background: consommationUsage === t.id ? ENCRE : PIERRE,
                        color: consommationUsage === t.id ? PIERRE : TAUPE,
                      }}
                    >
                      {t.label}
                    </button>
                  ))}
                </div>
              </Field>
            )}
            {consommationPL === CONSO_ATELIER && (
              <div style={{ fontSize: 12, color: TAUPE, marginTop: -6, marginBottom: 12 }}>
                Consommation atelier : comptée en consommables de production.
              </div>
            )}

            {consommationPL && consommationPL !== CONSO_ATELIER && (
              <Field label="Client / réf (repris du PL, non modifiable)">
                <div style={{ ...inputStyle("100%"), background: PIERRE, color: ENCRE, display: "flex", alignItems: "center", minHeight: 38, boxSizing: "border-box" }}>
                  {libelleClientDuPL(consommationPL) || "—"}
                </div>
              </Field>
            )}
            {consommationPL && consommationPL !== CONSO_ATELIER && (consommationUsage === "production" || consommationUsage === "pose") && (() => {
              const c = (commandesListe || []).find((x) => x.numeroPL === consommationPL);
              if (!c) return null;
              const u = consommationUsage;
              const deja = consommablesDuDossier(c, u).length > 0;
              const aucun = u === "pose" ? c.aucunConsoPose : c.aucunConsoProduction;
              if (deja && !aucun) return null;
              return (
                <div style={{ background: aucun ? "#E4EBE4" : PIERRE, borderRadius: 8, padding: 10, marginBottom: 12, fontSize: 13 }}>
                  {aucun ? (
                    <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                      <span>✓ Aucun consommable de {u} déclaré pour ce PL par {aucun.par}.</span>
                      {peutCocherAucunConso && <button type="button" className="sc-btn" onClick={() => declarerAucunConsoPL(consommationPL, u, false)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "2px 0" }}>↺ Annuler</button>}
                    </div>
                  ) : peutCocherAucunConso ? (
                    <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                      <span style={{ color: TAUPE }}>Rien à saisir pour ce PL ?</span>
                      <button type="button" className="sc-btn" onClick={() => declarerAucunConsoPL(consommationPL, u, true)} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 10px", background: "#fff" }}>Déclarer « aucun consommable de {u} »</button>
                    </div>
                  ) : null}
                </div>
              );
            })()}
            {consommationPL === CONSO_ATELIER && (
              <Field label="Motif (obligatoire)">
                <input
                  className="sc-input"
                  value={consommationMotif}
                  onChange={(e) => { setConsommationMotif(e.target.value); if (consommationError) setConsommationError(""); }}
                  placeholder="ex. entretien machine, préparation atelier…"
                  style={inputStyle("100%")}
                />
                <div style={{ fontSize: 11, color: OCRE, marginTop: 4 }}>
                  Consommation sans dossier : elle sera tracée et signalée au Gérant.
                </div>
              </Field>
            )}

            <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 12 }}>
              {consommationLignes.map((l) => (
                <div key={l.id} style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
                  <select
                    className="sc-select"
                    value={l.lotId}
                    onChange={(e) => modifierLigneConsommation(l.id, "lotId", e.target.value)}
                    style={{ ...selectStyle, flex: 1.6 }}
                  >
                    <option value="">— Lot consommé —</option>
                    {(items || [])
                      .filter((it) => {
                        const p = (produits || []).find((pp) => pp.id === it.produitId);
                        if (p && estCategorieStockReservee(p.categorie)) return false;
                        if (it.id === l.lotId) return true;
                        // ERP step 11 : les consommables lents passent par « Mise en service ».
                        return p && !estConsoLent(p);
                      })
                      .map((it) => (
                        <option key={it.id} value={it.id}>{libelleLot(it)}</option>
                      ))}
                    {/* Nils 28/10 : listellos, en atelier seulement (tranches cochées au Catalogue, chutes < 1 m²). */}
                    {consommationPL === CONSO_ATELIER && (() => {
                      const ls = (items || []).filter((it) => lotListello(it) && (Number(it.stockReel) > 0 || it.id === l.lotId));
                      return ls.length ? (
                        <optgroup label="Tranches pour listello">
                          {ls.map((it) => (<option key={it.id} value={it.id}>{it.type === TYPE_CHUTE ? "Chute — " : ""}{libelleLot(it)}</option>))}
                        </optgroup>
                      ) : null;
                    })()}
                  </select>
                  <input
                    type="number"
                    step="0.01"
                    className="sc-input"
                    placeholder={(() => { const lot = (items || []).find((it) => it.id === l.lotId); return lot && lotListello(lot) ? (lot.type === TYPE_CHUTE ? "Pièces" : "Tranches (¼)") : "Qté"; })()}
                    value={l.quantite}
                    onChange={(e) => modifierLigneConsommation(l.id, "quantite", e.target.value)}
                    style={{ ...inputStyle("100%"), flex: 0.7 }}
                  />
                  <input
                    className="sc-input"
                    placeholder="Demandé par (ex. Adil)"
                    value={l.demandePar}
                    onChange={(e) => modifierLigneConsommation(l.id, "demandePar", e.target.value)}
                    style={{ ...inputStyle("100%"), flex: 1.3 }}
                  />
                  <button type="button" className="sc-btn" onClick={() => retirerLigneConsommation(l.id)} style={iconBtnStyle}>✕</button>
                </div>
              ))}
            </div>
            <button type="button" className="sc-btn" onClick={ajouterLigneConsommation} style={{ ...ghostBtnStyle, marginBottom: 14 }}>+ Ligne</button>

            {consommationError && <div style={errorTextStyle}>{consommationError}</div>}

            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 10 }}>
              <button type="button" className="sc-btn" onClick={() => setShowConsommation(false)} style={ghostBtnStyle}>Annuler</button>
              <button type="button" className="sc-btn" onClick={submitConsommation} style={primaryBtnStyle}>Enregistrer</button>
            </div>
          </div>
        </Overlay>
      )}

      {showReservationCommande && reservationCommandeCible && (
        <Overlay onClose={() => setShowReservationCommande(false)}>
          <div style={modalStyle(560)}>
            <div style={modalTitleStyle}>Réserver la matière — {reservationCommandeCible.numero}</div>
            <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 16 }}>
              Coche les articles à réserver et ajuste la quantité si besoin. La réservation porte sur le produit — l'affectation à un lot précis se fait ensuite depuis le Stock, dès que la matière est reçue.
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 16 }}>
              {reservationLignes.map((l, i) => (
                <div key={`${l.ligneId}-${l.bm || ""}`} style={{ background: PIERRE, borderRadius: 8, padding: 12 }}>
                  <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      checked={l.reserver}
                      onChange={(e) => {
                        const v = e.target.checked;
                        setReservationLignes((prev) => prev.map((x, j) => (j === i ? { ...x, reserver: v } : x)));
                        if (reservationError) setReservationError("");
                      }}
                    />
                    <span style={{ fontSize: 13, fontWeight: 600, flex: 1 }}>{l.designation}</span>
                    {l.reservationId && (
                      <span style={{ fontSize: 10, fontWeight: 600, color: VERT_OK, background: "#E4EBE4", padding: "2px 8px", borderRadius: 10 }}>
                        Déjà réservée
                      </span>
                    )}
                    <input
                      type="number"
                      step="0.01"
                      className="sc-input"
                      value={l.qte}
                      disabled={!l.reserver}
                      onChange={(e) => {
                        const v = e.target.value;
                        setReservationLignes((prev) => prev.map((x, j) => (j === i ? { ...x, qte: v } : x)));
                        if (reservationError) setReservationError("");
                      }}
                      style={{ ...inputStyle(90), opacity: l.reserver ? 1 : 0.5 }}
                    />
                  </label>
                </div>
              ))}
            </div>
            <Field label="Réservation pour le — date approximative de pose (obligatoire)">
              <input type="date" className="sc-input" min={todayISO()} value={reservationPourLe} onChange={(e) => { setReservationPourLe(e.target.value); if (reservationError) setReservationError(""); }} style={inputStyle(200)} />
              <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Une fois cette date dépassée, une alerte est envoyée ; elle peut être reportée à une nouvelle date depuis « Alertes & tâches ».</div>
            </Field>
            {reservationError && <div style={errorTextStyle}>{reservationError}</div>}
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button type="button" className="sc-btn" onClick={() => setShowReservationCommande(false)} style={ghostBtnStyle}>Annuler</button>
              <button type="button" className="sc-btn" onClick={validerReservationCommande} style={primaryBtnStyle}>Enregistrer</button>
            </div>
          </div>
        </Overlay>
      )}

      {showAffectation && affectationProduit && (
        <Overlay onClose={() => setShowAffectation(false)}>
          <div style={modalStyle(500)}>
            <div style={modalTitleStyle}>Affecter à un lot — {affectationProduit.nom}</div>
            <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 16 }}>
              Ces réservations portent sur le produit sans lot précis. Choisis le lot sur lequel chacune doit s'imputer — tous les lots de la même famille couleur sont proposés (épaisseur et choix indifférents), pas seulement ceux de « {affectationProduit.nom} ».
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 16 }}>
              {reservationsNonAffectees(affectationProduit.id).map((r) => {
                // Nils 04/10 (o) : une part A / B se met sur un lot A / B ; une réservation normale prend d'abord le surplus (paires préservées).
                const lots = lotsDeLaFamille(affectationProduit.id).filter((it) => (r.chute ? it.type === TYPE_CHUTE && it.produitId === r.produitId : it.type !== TYPE_CHUTE) && (!r.bm || it.bm === r.bm)).sort((x, y) => (r.bm ? 0 : Number(casseUnePaire(x)) - Number(casseUnePaire(y))));
                return (
                  <div key={r.id} style={{ background: PIERRE, borderRadius: 8, padding: 12 }}>
                    <div style={{ fontSize: 13, fontWeight: 600 }}>{r.quantite} — BC {r.bc} — {r.client}{r.bm ? ` — book-match ${r.bm}` : ""}</div>
                    {r.bm && <div style={{ fontSize: 11, color: OCRE }}>Les parts A et B de cette ligne doivent être dans la même nuance.</div>}
                    <div style={{ fontSize: 11, color: TAUPE, marginBottom: 6 }}>
                      Réservée le {formatDate(r.creeLe)}{r.auteur ? ` · par ${r.auteur}` : ""}
                    </div>
                    <select
                      className="sc-select"
                      value={affectationChoix[r.id] || ""}
                      onChange={(e) => setAffectationChoix({ ...affectationChoix, [r.id]: e.target.value })}
                      style={{ ...selectStyle, background: "#fff" }}
                    >
                      <option value="">— Choisir un lot —</option>
                      {lots.map((it) => {
                        const dispo = (Number(it.stockReel) || 0) - reservedFor(it.id);
                        const autreProduit = it.produitId !== affectationProduit.id;
                        return (
                          <option key={it.id} value={it.id}>
                            {autreProduit ? `${nomProduit(it.produitId)} · ` : ""}{it.fournisseur}{it.dimensions ? ` · ${it.dimensions}` : ""}{it.epaisseur ? ` · ${it.epaisseur}` : ""}{it.choix ? ` · ${it.choix}` : ""}{it.nuance ? ` · nuance ${it.nuance}` : ""}{it.bm ? ` · ${it.bm}` : ""} — {dispo} {it.unite} disponible(s){!r.bm && casseUnePaire(it) ? " ⚠ casse une paire" : ""}
                          </option>
                        );
                      })}
                    </select>
                    {lots.length === 0 && (
                      <div style={{ fontSize: 11, color: ROUILLE, marginTop: 4 }}>Aucun lot en Stock pour cette famille pour l'instant.</div>
                    )}
                  </div>
                );
              })}
            </div>
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button type="button" className="sc-btn" onClick={() => setShowAffectation(false)} style={ghostBtnStyle}>Fermer</button>
              <button type="button" className="sc-btn" onClick={validerAffectationReservations} style={primaryBtnStyle}>Affecter</button>
            </div>
          </div>
        </Overlay>
      )}

      {confirmationAnnulerBDC && (
        <Overlay onClose={() => setConfirmationAnnulerBDC(null)}>
          <div style={modalStyle(400)}>
            <div style={modalTitleStyle}>Revenir à l'étape précédente</div>
            <div style={{ fontSize: 14, marginBottom: 16, lineHeight: 1.5 }}>
              Le dossier <strong>{confirmationAnnulerBDC.numero}</strong> sera supprimé, et le devis d'origine repassera au statut "Confirmé".
            </div>
            {(() => {
              const resActives = (reservations || []).filter((r) => r.bc === confirmationAnnulerBDC.numero && r.statut === "active");
              if (resActives.length === 0) return null;
              return (
                <div style={{ background: "#F5E4DE", color: ROUILLE, fontSize: 13, fontWeight: 600, padding: "10px 12px", borderRadius: 6, marginBottom: 16 }}>
                  ⚠ {resActives.length} réservation(s) de matière encore active(s) sous ce BC dans le Stock — elles seront automatiquement libérées.
                </div>
              );
            })()}
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button type="button" className="sc-btn" onClick={() => setConfirmationAnnulerBDC(null)} style={ghostBtnStyle}>Annuler</button>
              <button type="button" className="sc-btn" onClick={confirmerAnnulerBDC} style={{ ...primaryBtnStyle, background: ROUILLE }}>Confirmer</button>
            </div>
          </div>
        </Overlay>
      )}

      {popupEtage && draft && (
        <Overlay onClose={() => setPopupEtage(false)} zIndex={2000}>
          <div style={modalStyle(420)}>
            <div style={modalTitleStyle}>⚠ Étage manquant</div>
            <div style={{ fontSize: 14, marginBottom: 14, lineHeight: 1.5 }}>
              Ce devis contient de la pose : l'étage est obligatoire pour le transformer en BDC. Indique-le ci-dessous, puis relance « Transformer en BDC ».
            </div>
            <Field label="Étage">
              <input
                autoFocus
                className="sc-input"
                value={popupEtageValeur}
                onChange={(e) => setPopupEtageValeur(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter" && popupEtageValeur.trim()) { setDraft({ ...draft, etage: popupEtageValeur.trim() }); setPopupEtage(false); } }}
                placeholder="ex. RDC, 1er, 3e…"
                style={inputStyle("100%")}
              />
            </Field>
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 6 }}>
              <button type="button" className="sc-btn" onClick={() => setPopupEtage(false)} style={ghostBtnStyle}>Fermer</button>
              <button
                type="button"
                className="sc-btn"
                disabled={!popupEtageValeur.trim()}
                onClick={() => { setDraft({ ...draft, etage: popupEtageValeur.trim() }); setPopupEtage(false); }}
                style={{ ...primaryBtnStyle, opacity: popupEtageValeur.trim() ? 1 : 0.5 }}
              >
                Renseigner l'étage
              </button>
            </div>
          </div>
        </Overlay>
      )}

      {confirmationSupprimerDevis && (
        <Overlay onClose={() => setConfirmationSupprimerDevis(null)}>
          <div style={modalStyle(400)}>
            <div style={modalTitleStyle}>Supprimer le devis</div>
            <div style={{ fontSize: 14, marginBottom: 16, lineHeight: 1.5 }}>
              Le devis <strong>{confirmationSupprimerDevis.numero || "(sans numéro)"}</strong>
              {" "}(statut {confirmationSupprimerDevis.statut}) sera définitivement supprimé. Cette action est irréversible.
            </div>
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button type="button" className="sc-btn" onClick={() => setConfirmationSupprimerDevis(null)} style={ghostBtnStyle}>Annuler</button>
              <button type="button" className="sc-btn" onClick={confirmerSupprimerDevis} style={{ ...primaryBtnStyle, background: ROUILLE }}>Supprimer</button>
            </div>
          </div>
        </Overlay>
      )}

      {ajustementLot && (
        <Overlay onClose={() => setAjustementLot(null)}>
          <div style={modalStyle(400)}>
            <div style={modalTitleStyle}>Ajustement d'inventaire</div>
            <div style={{ fontSize: 13, color: TAUPE, marginBottom: 16, marginTop: -8 }}>
              {nomProduit(ajustementLot.produitId)} · {ajustementLot.fournisseur}
              {ajustementLot.epaisseur ? ` · ${ajustementLot.epaisseur}` : ""}
            </div>
            <div style={{ background: "#F5EFE0", borderRadius: 8, padding: 12, marginBottom: 16, fontSize: 12, color: OCRE }}>
              À réserver aux vrais écarts d'inventaire (comptage, casse constatée...) — pas une alternative au PL pour une sortie normale.
            </div>
            <Field label={`Stock réel actuel : ${ajustementLot.stockReel} ${ajustementLot.unite}`}>
              <input
                type="number"
                step="0.01"
                className="sc-input"
                value={ajustementNouvelleQte}
                onChange={(e) => {
                  setAjustementNouvelleQte(e.target.value);
                  if (ajustementError) setAjustementError("");
                }}
                style={inputStyle("100%")}
                autoFocus
              />
            </Field>
            <Field label={peutEcrireStock ? "PL concerné (facultatif — PL mal enregistré, dossier déjà en BL)" : "PL concerné (obligatoire)"}>
              <select className="sc-select" value={ajustementPL} onChange={(e) => setAjustementPL(e.target.value)} style={{ ...selectStyle, background: "#fff" }}>
                <option value="">— Aucun —</option>
                {[...new Set((mouvements || []).filter((m) => m.pl).map((m) => m.pl))].sort().reverse().map((pl) => (<option key={pl} value={pl}>{pl}</option>))}
              </select>
            </Field>
            <Field label="Raison de l'ajustement (obligatoire)">
              <input
                className="sc-input"
                value={ajustementRaison}
                onChange={(e) => {
                  setAjustementRaison(e.target.value);
                  if (ajustementError) setAjustementError("");
                }}
                placeholder="ex. inventaire physique du 15/09, écart constaté"
                style={inputStyle("100%")}
              />
            </Field>
            {ajustementError && <div style={errorTextStyle}>{ajustementError}</div>}
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 10 }}>
              <button type="button" className="sc-btn" onClick={() => setAjustementLot(null)} style={ghostBtnStyle}>Annuler</button>
              <button type="button" className="sc-btn" onClick={submitAjustement} style={primaryBtnStyle}>Enregistrer l'ajustement</button>
            </div>
          </div>
        </Overlay>
      )}

      {showVidage && (() => {
        const coches = vidageGroupes || {};
        const manquants = manquantsVidage(coches);
        const nb = GROUPES_VIDAGE.filter((x) => coches[x.cle]).length;
        const ok = nb > 0 && manquants.length === 0 && vidageConfirmationTexte === "SUPPRIMER";
        const ligne = (x) => {
          const pb = manquants.find((m) => m.g.cle === x.cle);
          return (
            <div key={x.cle} style={{ padding: "6px 0", borderBottom: `1px solid ${PIERRE}` }}>
              <label style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: 13, cursor: "pointer" }}>
                <input type="checkbox" checked={!!coches[x.cle]} onChange={(e) => setVidageGroupes({ ...coches, [x.cle]: e.target.checked })} style={{ marginTop: 3 }} />
                <span>
                  <strong>{x.titre}</strong>
                  <span style={{ display: "block", fontSize: 11, color: TAUPE }}>{x.detail}</span>
                  {x.requiert && x.requiert.length > 0 && <span style={{ display: "block", fontSize: 11, color: TAUPE }}>Exige aussi : {x.requiert.map((r) => GROUPES_VIDAGE.find((y) => y.cle === r).titre).join(", ")}</span>}
                  {pb && <span style={{ display: "block", fontSize: 11, color: ROUILLE, fontWeight: 600 }}>⚠ Coche aussi : {pb.manque.map((m) => m.titre).join(", ")}</span>}
                </span>
              </label>
            </div>
          );
        };
        return (
          <Overlay onClose={() => setShowVidage(false)}>
            <div style={modalStyle(560)}>
              <div style={modalTitleStyle}>Vider des données</div>
              <div style={{ background: "#F5E4DE", borderRadius: 8, padding: 12, marginBottom: 12, fontSize: 13, color: ROUILLE, fontWeight: 600 }}>
                ⚠ Action irréversible. Seuls les groupes cochés seront supprimés. Exporte une sauvegarde avant de continuer. Le journal d'accès n'est jamais vidé.
              </div>
              <div style={{ display: "flex", gap: 12, marginBottom: 8 }}>
                <button type="button" className="sc-btn" onClick={() => setVidageGroupes(Object.fromEntries(GROUPES_VIDAGE.map((x) => [x.cle, true])))} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0" }}>Tout cocher</button>
                <button type="button" className="sc-btn" onClick={() => setVidageGroupes({})} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0" }}>Tout décocher</button>
              </div>
              <div style={{ maxHeight: 420, overflowY: "auto", marginBottom: 12 }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, margin: "4px 0" }}>Données courantes</div>
                {GROUPES_VIDAGE.filter((x) => !x.ref).map(ligne)}
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, margin: "12px 0 4px" }}>Référentiels</div>
                {GROUPES_VIDAGE.filter((x) => x.ref).map(ligne)}
              </div>
              <Field label='Tape "SUPPRIMER" pour confirmer'>
                <input className="sc-input" value={vidageConfirmationTexte} onChange={(e) => setVidageConfirmationTexte(e.target.value)} style={inputStyle("100%")} />
              </Field>
              {nb === 0 && <div style={{ fontSize: 12, color: TAUPE }}>Coche au moins un groupe.</div>}
              {manquants.length > 0 && <div style={errorTextStyle}>Des groupes dépendants ne sont pas cochés (voir ⚠ ci-dessus).</div>}
              <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 10 }}>
                <button type="button" className="sc-btn" onClick={() => setShowVidage(false)} style={ghostBtnStyle}>Annuler</button>
                <button type="button" className="sc-btn" onClick={viderToutesLesDonnees} disabled={!ok} style={ok ? { ...primaryBtnStyle, background: ROUILLE } : { ...primaryBtnStyle, background: ROUILLE, opacity: 0.5, cursor: "not-allowed" }}>
                  Supprimer {nb ? `(${nb} groupe${nb > 1 ? "s" : ""})` : ""}
                </button>
              </div>
            </div>
          </Overlay>
        );
      })()}

      {showRegistreCredit && (
        <Overlay onClose={() => setShowRegistreCredit(false)}>
          <div style={modalStyle(620)}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <div style={modalTitleStyle}>Registre de crédit</div>
              {peutEcrireRegistreCredit && (
                <button type="button" className="sc-btn" onClick={ouvrirAjoutCreditManuel} style={{ ...ghostBtnStyle, padding: "6px 12px", fontSize: 12 }}>
                  + Ajouter manuellement
                </button>
              )}
            </div>
            <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 16 }}>
              Crédit disponible par produit exact — alimenté par l'enregistrement d'un PL non-exo sous-consommé, consommé uniquement à la création d'un BC exo pour ce même produit.
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, maxHeight: 480, overflowY: "auto" }}>
              {(creditsTranches || []).length === 0 && (
                <div style={{ fontSize: 13, color: TAUPE, padding: 8 }}>Aucun crédit disponible.</div>
              )}
              {Object.values(
                (creditsTranches || []).reduce((acc, c) => {
                  const k = c.produitId || c.cle;
                  if (!acc[k]) acc[k] = { produitId: k, libelle: c.libelle || nomProduit(k), total: 0, entrees: [] };
                  acc[k].total = Number((acc[k].total + (Number(c.quantite) || 0)).toFixed(2));
                  acc[k].entrees.push(c);
                  return acc;
                }, {})
              )
                .sort((a, b) => (a.libelle || "").localeCompare(b.libelle || "", "fr"))
                .map((g) => (
                  <div key={g.produitId} style={{ background: "#EFEAE3", borderRadius: 8, padding: 12 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
                      <div style={{ fontSize: 13, fontWeight: 600 }}>{g.libelle}</div>
                      <div style={{ fontSize: 13, fontWeight: 700, color: ENCRE }}>{g.total}</div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 4, marginTop: 6 }}>
                      {g.entrees
                        .slice()
                        .sort((a, b) => (a.creeLe < b.creeLe ? 1 : -1))
                        .map((e) => (
                          <div key={e.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 11, color: TAUPE, gap: 8 }}>
                            <span>{e.origine}{e.creePar ? ` · ${e.creePar}` : ""}</span>
                            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                              {e.quantite}
                              {peutEcrireRegistreCredit && (
                                <button
                                  type="button"
                                  className="sc-btn"
                                  onClick={async () => {
                                    await persistCreditsTranches((creditsTranches || []).filter((x) => x.id !== e.id));
                                    await journaliserMouvementsCredit([
                                      { produitId: e.produitId || e.cle, libelle: e.libelle, sens: "debit", quantite: e.quantite, origine: "Entrée supprimée manuellement du registre" },
                                    ]);
                                  }}
                                  style={{ ...iconBtnStyle, background: "transparent", padding: 2 }}
                                  title="Supprimer cette entrée"
                                >
                                  ✕
                                </button>
                              )}
                            </span>
                          </div>
                        ))}
                    </div>
                  </div>
                ))}
            </div>

            {/* Step 11 (accord Nils du 21/09) : historique des mouvements —
                journal séparé du solde, qui ne garde lui-même aucune trace
                de ses consommations/restitutions. Nettoyage ligne par
                ligne uniquement (jamais un "vider tout"), réservé au Gérant. */}
            <div style={{ fontSize: 13, fontWeight: 700, marginTop: 20, marginBottom: 8 }}>Historique des mouvements</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6, maxHeight: 260, overflowY: "auto" }}>
              {(creditsHistorique || []).length === 0 && (
                <div style={{ fontSize: 13, color: TAUPE, padding: 8 }}>Aucun mouvement enregistré pour l'instant.</div>
              )}
              {(creditsHistorique || [])
                .slice()
                .sort((a, b) => (a.creeLe < b.creeLe ? 1 : -1))
                .map((h) => (
                  <div key={h.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12, background: "#EFEAE3", borderRadius: 6, padding: "6px 10px", gap: 8 }}>
                    <span>
                      <strong>{h.libelle}</strong> — {h.sens === "credit" ? "+" : "-"}{h.quantite} · {h.origine}
                      {h.creePar ? ` · ${h.creePar}` : ""}{h.creeLe ? ` · ${new Date(h.creeLe).toLocaleDateString("fr-FR")}` : ""}
                    </span>
                    {peutEcrireRegistreCredit && (
                      <button
                        type="button"
                        className="sc-btn"
                        onClick={() => persistCreditsHistorique((creditsHistorique || []).filter((x) => x.id !== h.id))}
                        style={{ ...iconBtnStyle, background: "transparent", padding: 2, flexShrink: 0 }}
                        title="Nettoyer cette ligne de l'historique"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                ))}
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <button type="button" className="sc-btn" onClick={() => setShowRegistreCredit(false)} style={ghostBtnStyle}>Fermer</button>
            </div>
          </div>
        </Overlay>
      )}

      {showAjoutCreditManuel && creditManuelForm && peutEcrireRegistreCredit && (
        <Overlay onClose={() => setShowAjoutCreditManuel(false)}>
          <div style={modalStyle(420)}>
            <div style={modalTitleStyle}>Ajouter un crédit manuellement</div>
            <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 16 }}>
              Réservé au Gérant — pour ajouter un crédit au registre sans référence à un PL.
            </div>
            <Field label="Produit">
              <select
                className="sc-select"
                value={creditManuelForm.produitId}
                onChange={(e) => setCreditManuelForm({ ...creditManuelForm, produitId: e.target.value })}
                style={selectStyle}
              >
                <option value="">— Sélectionner —</option>
                {trierAlpha(produits, "nom").map((p) => (
                  <option key={p.id} value={p.id}>{p.nom}</option>
                ))}
              </select>
            </Field>
            <Field label="Quantité">
              <input
                type="number"
                step="0.01"
                className="sc-input"
                value={creditManuelForm.quantite}
                onChange={(e) => setCreditManuelForm({ ...creditManuelForm, quantite: e.target.value })}
                style={inputStyle("100%")}
              />
            </Field>
            <Field label="Note (optionnel)">
              <input
                className="sc-input"
                value={creditManuelForm.note}
                onChange={(e) => setCreditManuelForm({ ...creditManuelForm, note: e.target.value })}
                placeholder="ex. correction suite contrôle physique"
                style={inputStyle("100%")}
              />
            </Field>
            {creditManuelError && <div style={errorTextStyle}>{creditManuelError}</div>}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 10 }}>
              <button type="button" className="sc-btn" onClick={() => setShowAjoutCreditManuel(false)} style={ghostBtnStyle}>Annuler</button>
              <button type="button" className="sc-btn" onClick={submitCreditManuel} style={primaryBtnStyle}>Ajouter</button>
            </div>
          </div>
        </Overlay>
      )}

      {showJournalAcces && peut("admin.donnees") && (
        <Overlay onClose={() => setShowJournalAcces(false)}>
          <div style={modalStyle(900)}>
            <div style={modalTitleStyle}>Journal d'accès</div>
            <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 16 }}>
              Connexions (réussies et refusées), déconnexions et actions tracées — transformations, validations, stock, consommables, inventaire, documents, réglages, suppressions… Visible uniquement par toi. Écrit par le serveur avec l'identité de la personne connectée ; une modification n'y apparaît que si elle a bien été enregistrée.
            </div>
            {(() => {
              const f = journalFiltre;
              const setF = (patch) => setJournalFiltre({ ...f, ...patch });
              const tous = (journalAcces || []).slice().sort((a, b) => (a.date < b.date ? 1 : -1));
              const utilisateursJ = [...new Set(tous.map((e) => e.utilisateur).filter(Boolean))].sort((a, b) => a.localeCompare(b, "fr"));
              const typesJ = [...new Set(tous.map((e) => e.type).filter(Boolean))].sort((a, b) => a.localeCompare(b, "fr"));
              const q = (f.q || "").trim().toLowerCase();
              // Filtre « document » : un n° de devis, BC, RDM, PL, BL/BLS ou
              // facture retrouve toute la chaîne du dossier ; tirets / espaces
              // et casse ignorés à la saisie (PL20260001 = PL-2026-0001).
              const norm = (x) => String(x || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
              const docSaisi = norm(f.doc);
              let chaine = null;
              if (docSaisi) {
                const numsDe = (c) => [c.numero, c.numeroRDM, c.numeroPL, c.numeroBL, c.numeroFacture];
                let cmd = (commandesListe || []).find((c) => numsDe(c).some((n) => n && norm(n) === docSaisi)) || null;
                let dv = cmd ? (devisListe || []).find((d) => d.id === cmd.devisId) || null : (devisListe || []).find((d) => d.numero && norm(d.numero) === docSaisi) || null;
                if (!cmd && dv) cmd = (commandesListe || []).find((c) => c.devisId === dv.id) || null;
                const nums = [dv && dv.numero, ...(cmd ? numsDe(cmd) : [])].filter(Boolean);
                chaine = { trouve: nums.length > 0, nums: nums.length > 0 ? nums : [f.doc.trim()] };
              }
              const echap = (x) => x.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
              const reDoc = chaine ? new RegExp(`(^|[^A-Za-z0-9-])(${chaine.nums.map(echap).join("|")})(?![A-Za-z0-9])`, "i") : null;
              const filtres = tous.filter((e) => {
                if (reDoc && !reDoc.test(`${e.type} ${e.detail}`)) return false;
                if (f.utilisateur && e.utilisateur !== f.utilisateur) return false;
                if (f.type && e.type !== f.type) return false;
                if (f.sansConnexions && e.type === "connexion") return false;
                if (f.sansDetail && e.auto) return false;
                const dj = new Date(e.date);
                const jour = isNaN(dj) ? "" : `${dj.getFullYear()}-${String(dj.getMonth() + 1).padStart(2, "0")}-${String(dj.getDate()).padStart(2, "0")}`;
                if (f.du && jour < f.du) return false;
                if (f.au && jour > f.au) return false;
                if (q && !`${e.utilisateur} ${e.role} ${e.type} ${e.detail}`.toLowerCase().includes(q)) return false;
                return true;
              });
              const MAX = 500;
              const exporter = async () => {
                const c = (x) => `"${String(x ?? "").replace(/"/g, '""')}"`;
                const rows = [["Date", "Heure", "Utilisateur", "Rôle", "Action", "Détail"].map(c).join(";")];
                filtres.forEach((e) => {
                  const d = new Date(e.date);
                  rows.push([c(d.toLocaleDateString("fr-FR")), c(d.toLocaleTimeString("fr-FR")), c(e.utilisateur), c(e.role), c(e.type), c(e.detail)].join(";"));
                });
                const ok = await proposerTelechargement(`journal-acces-${todayISO()}.csv`, "\ufeff" + rows.join("\r\n"));
                if (ok) setNotice(`Journal exporté (${filtres.length} ligne(s), CSV pour Excel).`);
              };
              const filtreActif = f.utilisateur || f.type || f.du || f.au || q || f.sansConnexions || docSaisi || f.sansDetail;
              return (
                <>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1.3fr 0.9fr 0.9fr", gap: 8, marginBottom: 8 }}>
                    <select className="sc-select" value={f.utilisateur} onChange={(e) => setF({ utilisateur: e.target.value })} style={selectStyle}>
                      <option value="">Toutes les personnes</option>
                      {utilisateursJ.map((u) => (<option key={u} value={u}>{u}</option>))}
                    </select>
                    <select className="sc-select" value={f.type} onChange={(e) => setF({ type: e.target.value })} style={selectStyle}>
                      <option value="">Toutes les actions</option>
                      {typesJ.map((t) => (<option key={t} value={t}>{t}</option>))}
                    </select>
                    <input type="date" className="sc-input" value={f.du} onChange={(e) => setF({ du: e.target.value })} title="Du" style={inputStyle("100%")} />
                    <input type="date" className="sc-input" value={f.au} onChange={(e) => setF({ au: e.target.value })} title="Au" style={inputStyle("100%")} />
                  </div>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8, flexWrap: "wrap" }}>
                    <input className="sc-input" value={f.doc} onChange={(e) => setF({ doc: e.target.value })} placeholder="Tout un dossier : n° de devis, BC, RDM, PL, BL ou facture" style={{ ...inputStyle(360), flex: 1 }} />
                  </div>
                  {chaine && (
                    <div style={{ fontSize: 12, marginBottom: 8, color: chaine.trouve ? ENCRE : OCRE }}>
                      {chaine.trouve ? `Dossier complet : ${chaine.nums.join(" · ")}` : "Aucun devis ni dossier ne porte ce numéro — recherche du texte tel quel."}
                    </div>
                  )}
                  <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 10, flexWrap: "wrap" }}>
                    <input className="sc-input" value={f.q} onChange={(e) => setF({ q: e.target.value })} placeholder="Rechercher (n° de dossier, client, produit…)" style={{ ...inputStyle(320), flex: 1 }} />
                    <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: TAUPE }}>
                      <input type="checkbox" checked={f.sansConnexions} onChange={(e) => setF({ sansConnexions: e.target.checked })} /> Masquer les connexions
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: TAUPE }} title="Lignes « données · … » : le détail avant → après de chaque enregistrement">
                      <input type="checkbox" checked={f.sansDetail} onChange={(e) => setF({ sansDetail: e.target.checked })} /> Masquer le détail des modifications
                    </label>
                    {filtreActif && <button type="button" className="sc-btn" onClick={() => setJournalFiltre({ utilisateur: "", type: "", du: "", au: "", q: "", sansConnexions: false, doc: "", sansDetail: false })} style={{ ...ghostBtnStyle, fontSize: 12, padding: "4px 0" }}>Effacer les filtres</button>}
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, fontSize: 12, color: TAUPE }}>
                    <span>{filtres.length} événement(s){filtres.length > MAX ? ` — ${MAX} premiers affichés (tous dans l'export)` : ""}</span>
                    <button type="button" className="sc-btn" onClick={exporter} disabled={filtres.length === 0} style={{ ...ghostBtnStyle, fontSize: 12, opacity: filtres.length === 0 ? 0.5 : 1 }}>⬇ Exporter la sélection (CSV)</button>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 8, maxHeight: 460, overflowY: "auto" }}>
                    {filtres.length === 0 && (
                      <div style={{ fontSize: 13, color: TAUPE, padding: 8 }}>{tous.length === 0 ? "Aucun événement enregistré pour l'instant." : "Aucun événement ne correspond aux filtres."}</div>
                    )}
                    {filtres.slice(0, MAX).map((e) => (
                      <div key={e.id} style={{ background: e.type === "connexion" || e.auto ? PIERRE : "#F5E4DE", borderRadius: 8, padding: "8px 12px", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
                        <div>
                          <div style={{ fontSize: 13, fontWeight: 600, color: e.type === "connexion" ? ENCRE : ROUILLE }}>
                            {e.utilisateur} <span style={{ fontWeight: 400, color: TAUPE }}>— {e.role}</span>
                          </div>
                          <div style={{ fontSize: 12, color: ENCRE, marginTop: 2, wordBreak: "break-word" }}>
                            {e.type}{e.detail ? ` · ${e.detail}` : ""}
                          </div>
                        </div>
                        <div style={{ fontSize: 11, color: TAUPE, whiteSpace: "nowrap" }}>{formatDateHeure(e.date)}</div>
                      </div>
                    ))}
                  </div>
                </>
              );
            })()}
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 10, marginTop: 16 }}>
              {!confirmViderJournal ? (
                EN_PRODUCTION ? <span style={{ marginRight: "auto" }} /> : <button type="button" className="sc-btn" onClick={() => setConfirmViderJournal(true)} disabled={(journalAcces || []).length === 0} style={{ ...ghostBtnStyle, color: ROUILLE, marginRight: "auto" }}>🗑 Vider le journal (phase de développement)</button>
              ) : (
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginRight: "auto", fontSize: 12, color: ROUILLE }}>
                  Effacer définitivement les {(journalAcces || []).length} entrée(s) ? Pense à exporter avant si besoin.
                  <button type="button" className="sc-btn" onClick={viderJournal} style={{ ...ghostBtnStyle, color: ROUILLE, fontWeight: 600 }}>Oui, vider</button>
                  <button type="button" className="sc-btn" onClick={() => setConfirmViderJournal(false)} style={ghostBtnStyle}>Annuler</button>
                </div>
              )}
              <button type="button" className="sc-btn" onClick={() => { setConfirmViderJournal(false); setShowJournalAcces(false); }} style={ghostBtnStyle}>Fermer</button>
            </div>
          </div>
        </Overlay>
      )}

      {showAnnulerPL && (() => {
        // Nils 01/11 : les sorties d'un incident de production ne s'annulent pas comme un PL.
        const pls = [...new Set((mouvements || []).filter((m) => m.pl && !m.incidentId).map((m) => m.pl))]
          .map((pl) => ({ pl, d: dossierDuPL(pl), t: (mouvements || []).filter((m) => m.pl === pl).reduce((x, m) => (m.creeLe > x ? m.creeLe : x), "") }))
          .filter((x) => !x.d || x.d.statut !== "Facture")
          // Nils 08/10 (g) : seulement les PL enregistrés depuis 15 jours, le plus récent en haut.
          .filter((x) => String(x.t || "").slice(0, 10) >= decalerJours(todayISO(), -15))
          .sort((a, b) => (a.t < b.t ? 1 : -1));
        // Nils 10/10 (b) : consommations atelier (hors dossier) des 15 derniers jours, une entrée par saisie.
        const atelierGroupes = [...new Set((mouvements || []).filter((m) => m.atelier && m.type === "sortie" && m.creeLe && String(m.creeLe).slice(0, 10) >= decalerJours(todayISO(), -15)).map((m) => m.creeLe))]
          .sort((a, b) => (a < b ? 1 : -1))
          .map((t) => { const ms = (mouvements || []).filter((m) => m.atelier && m.creeLe === t && m.type === "sortie"); return { t, ms, motif: String((ms[0] || {}).note || "").replace(/^Consommable atelier \(hors dossier\) — motif : /, "").split(" — demandé par")[0] }; });
        const ch = annulPLChoix || { pl: "", matiere: false, prod: false, pose: false };
        const setCh = (patch) => setAnnulPLChoix({ ...ch, ...patch });
        const atelierSel = String(ch.pl || "").startsWith("atelier:") ? atelierGroupes.find((g) => `atelier:${g.t}` === ch.pl) : null;
        const sel = pls.find((x) => x.pl === ch.pl);
        const st = sel && sel.d ? sel.d.statut : "";
        const mvsM = sel ? (mouvements || []).filter((m) => m.pl === sel.pl && !estMouvementConsommable(m)) : [];
        const cProd = sel ? (mouvements || []).filter((m) => m.pl === sel.pl && estMouvementConsommable(m) && usageConsommable(m) === "production") : [];
        const cPose = sel ? (mouvements || []).filter((m) => m.pl === sel.pl && estMouvementConsommable(m) && usageConsommable(m) === "pose") : [];
        const apresBL = st === "BL";
        const lot = (m) => nomProduit(((items || []).find((it) => it.id === m.itemId) || {}).produitId);
        const bloc = (cle, titre, liste, interdit, aide) => (
          <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "8px 12px", marginBottom: 8, opacity: liste.length && !interdit ? 1 : 0.55 }}>
            <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, fontWeight: 600, cursor: liste.length && !interdit ? "pointer" : "default" }}>
              <input type="checkbox" checked={!!ch[cle] && !!liste.length && !interdit} disabled={!liste.length || interdit} onChange={(e) => setCh({ [cle]: e.target.checked })} />
              {titre} <span style={{ fontWeight: 400, color: TAUPE, fontSize: 12 }}>({liste.length ? `${liste.length} ligne(s)` : "rien d'enregistré"}){interdit ? ` — ${aide}` : ""}</span>
            </label>
            {!!ch[cle] && !interdit && liste.map((m) => (<div key={m.id} style={{ fontSize: 12, paddingLeft: 26 }}>{m.type === "entree" ? "−" : "+"} {m.quantite} {m.unite} — {lot(m)}{m.type === "entree" ? " (chute créée, retirée)" : ""}</div>))}
          </div>
        );
        const aucun = !(ch.matiere && mvsM.length && !apresBL) && !(ch.prod && cProd.length && !apresBL) && !(ch.pose && cPose.length);
        return (
          <Overlay onClose={() => { setShowAnnulerPL(false); setAnnulPLChoix(null); }}>
            <div style={modalStyle(520)}>
              <div style={modalTitleStyle}>Annuler une consommation</div>
              {pls.length === 0 && atelierGroupes.length === 0 ? <div style={{ fontSize: 13, color: TAUPE }}>Aucune consommation enregistrée ces 15 derniers jours. Au-delà, passe par un ajustement d'inventaire (⚖).</div> : (
                <>
                  <Field label="Consommations des 15 derniers jours (la plus récente en haut)">
                    <select className="sc-select" value={ch.pl} onChange={(e) => setAnnulPLChoix({ pl: e.target.value, matiere: false, prod: false, pose: false })} style={{ ...selectStyle, background: "#fff" }}>
                      <option value="">— Choisir —</option>
                      {atelierGroupes.length > 0 && <optgroup label="Consommation atelier (hors dossier)">{atelierGroupes.map((g) => (<option key={g.t} value={`atelier:${g.t}`}>{formatDate(String(g.t).slice(0, 10))} — Atelier — {g.motif || "sans motif"} ({g.ms.length} ligne(s))</option>))}</optgroup>}
                      {pls.map((x) => (<option key={x.pl} value={x.pl}>{x.t ? `${formatDate(String(x.t).slice(0, 10))} — ` : ""}{x.pl}{x.d ? ` — ${(clientDe(x.d.clientId) || {}).nom || ""}${x.d.reference ? " · " + x.d.reference : ""} (${x.d.statut})` : ""}</option>))}
                    </select>
                  </Field>
                  {atelierSel && (
                    <div style={{ border: `1px solid ${PIERRE}`, borderRadius: 8, padding: "8px 12px", marginBottom: 8, fontSize: 12 }}>
                      <div style={{ fontWeight: 600, marginBottom: 4 }}>Consommation atelier — {atelierSel.motif || "sans motif"}</div>
                      {atelierSel.ms.map((m) => (<div key={m.id}>+ {m.quantite} {m.unite} — {lot(m)}</div>))}
                      <div style={{ color: TAUPE, marginTop: 4 }}>Tout est rendu au stock et la saisie est effacée.</div>
                    </div>
                  )}
                  {sel && (
                    <>
                      <div style={{ fontSize: 12, color: TAUPE, marginBottom: 8 }}>Coche ce que tu annules : tout est rendu au stock et effacé du PL.</div>
                      {bloc("matiere", "Articles du catalogue (matière, chutes)", mvsM, apresBL, "dossier en BL : ajustement d'inventaire (⚖) qui cite le PL")}
                      {bloc("prod", "Consommables de production", cProd, apresBL, "dossier en BL : ajustement d'inventaire (⚖) qui cite le PL")}
                      {bloc("pose", "Consommables de pose", cPose, false, "")}
                      {ch.matiere && !apresBL && mvsM.length > 0 && <div style={{ fontSize: 11, color: TAUPE, marginBottom: 8 }}>Annuler la matière : le PL pourra être ré-enregistré (« Enregistrer une consommation »).</div>}
                    </>
                  )}
                </>
              )}
              <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
                <button type="button" className="sc-btn" onClick={() => { setShowAnnulerPL(false); setAnnulPLChoix(null); }} style={ghostBtnStyle}>Fermer</button>
                {atelierSel && (
                  <button type="button" className="sc-btn" onClick={async () => { if (await annulerConsoAtelier(atelierSel.t)) { setShowAnnulerPL(false); setAnnulPLChoix(null); } }} style={{ ...primaryBtnStyle, background: ROUILLE }}>Annuler cette consommation</button>
                )}
                {sel && (
                  <button type="button" className="sc-btn" disabled={aucun} onClick={async () => {
                    const ok = await annulerPL(sel.pl, { matiere: !!ch.matiere && !apresBL && mvsM.length > 0, prod: !!ch.prod && !apresBL, pose: !!ch.pose });
                    if (ok) { setShowAnnulerPL(false); setAnnulPLChoix(null); }
                  }} style={{ ...primaryBtnStyle, background: ROUILLE, opacity: aucun ? 0.5 : 1 }}>Annuler la sélection</button>
                )}
              </div>
            </div>
          </Overlay>
        );
      })()}

      {/* Bon de production (PL) : consomme plusieurs lots, génère des chutes */}
      {renderModalesPlans()}
      {renderModaleCom()}
      {renderComObligatoire()}
      {renderModaleIncident()}
      {showPL && (
        <Overlay onClose={() => setShowPL(false)}>
          <div style={modalStyle(560)}>
            <div style={modalTitleStyle}>Articles du catalogue d'un PL</div>
            <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 16 }}>
              Déclare ce que l'atelier a réellement consommé (tranches, chutes) et les chutes générées. Le stock est mis à jour d'après ces déclarations.
            </div>
            {(() => {
              const machines = (affectations || []).filter((a) => a.type === "machine" && a.actif);
              if (!machines.length) return null;
              return (
                <Field label="Machines utilisées pour ce PL">
                  <div style={{ display: "flex", gap: 14, flexWrap: "wrap", fontSize: 13 }}>
                    {machines.map((m) => (
                      <label key={m.id} style={{ display: "flex", gap: 6, alignItems: "center", cursor: "pointer" }}>
                        <input type="checkbox" checked={(plMachines || []).includes(m.id)} onChange={(e) => setPlMachines(e.target.checked ? [...(plMachines || []), m.id] : (plMachines || []).filter((x) => x !== m.id))} />
                        ⚙ {m.nom}
                      </label>
                    ))}
                  </div>
                  <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>Sert au calcul d'usure des disques et abrasifs. Rien de coché : le PL est partagé à parts égales entre les machines qui ont ce consommable en service.</div>
                </Field>
              );
            })()}

            <div style={{ display: "flex", gap: 10 }}>
              <Field label="N° PL" style={{ flex: 1 }}>
                <select
                  className="sc-select"
                  value={plDoc}
                  onChange={(e) => {
                    const numero = e.target.value;
                    setPlDoc(numero);
                    if (plError) setPlError("");
                    setPlClient(libelleClientDuPL(numero));
                  }}
                  style={selectStyle}
                >
                  <option value="">— Sélectionner un PL —</option>
                  {/* Nils 03/10 (g) : seulement les PL qui ont encore de la matière à enregistrer, le plus récent en haut. */}
                  {(commandesListe || [])
                    .filter((c) => c.numeroPL && (c.numeroPL === plDoc || (!plEstEnregistre(c) && !plExistant(c.numeroPL) && commandeADesArticlesStock(c))))
                    .sort((a, b) => ((a.datePL || "") === (b.datePL || "") ? (a.numeroPL < b.numeroPL ? 1 : -1) : (a.datePL || "") < (b.datePL || "") ? 1 : -1))
                    .map((c) => {
                      const client = clientsActifs.find((x) => x.id === c.clientId);
                      return (
                        <option key={c.id} value={c.numeroPL}>
                          {c.numeroPL}{client ? ` — ${client.nom}` : ""}{c.reference ? ` (${c.reference})` : ""}
                        </option>
                      );
                    })}
                </select>
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 4 }}>
                  Seuls les PL qui ont encore de la matière à enregistrer apparaissent ici, le plus récent en haut. Un PL déjà enregistré se corrige par « ↺ Annuler une consommation ».
                </div>
                {(() => {
                  const ex = plExistant(plDoc);
                  if (!ex) return null;
                  return (
                    <div style={{ fontSize: 11, color: OCRE, marginTop: 4, fontWeight: 600 }}>
                      ⚠ Ce n° de PL a déjà été enregistré{ex.client ? ` (${ex.client})` : ""} — l'enregistrement est bloqué. Pour le corriger, utilise d'abord "↺ Annuler une consommation" dans le Stock.
                    </div>
                  );
                })()}
              </Field>
              <Field label="Date" style={{ flex: 1 }}>
                <input type="date" className="sc-input" value={plDate} onChange={(e) => setPlDate(e.target.value)} style={inputStyle("100%")} />
              </Field>
            </div>

            <Field label="Client / réf (repris du dossier, non modifiable)">
              <div style={{ ...inputStyle("100%"), background: PIERRE, color: plClient ? ENCRE : TAUPE, display: "flex", alignItems: "center", minHeight: 38, boxSizing: "border-box" }}>
                {plClient || "— sélectionne un PL —"}
              </div>
            </Field>
            {/* Nils 01/11 : plans récupérés de la même matière, à réutiliser avant d'entamer une tranche. */}
            {(() => {
              const dispo = plansDisponiblesPourDossier(commandePLSelectionnee);
              if (!dispo.length) return null;
              return (
                <div style={{ background: "#E4EBE4", borderRadius: 8, padding: "8px 12px", marginBottom: 12, fontSize: 12 }}>
                  <div style={{ fontWeight: 600, marginBottom: 4 }}>♻ {dispo.length} plan(s) récupéré(s) de cette matière en stock</div>
                  {dispo.map((pl) => (
                    <div key={pl.id}>{nomProduit(pl.produitId)} · {pl.dimensions}{pl.epaisseur ? ` · ${pl.epaisseur}` : ""} · {pl.etat}{pl.emplacement ? ` · ${pl.emplacement}` : ""}{(pl.fichiers || []).some((f) => f.nature === "dessin") && window.storage && window.storage.lienFichier ? <> · <a href={window.storage.lienFichier((pl.fichiers || []).find((f) => f.nature === "dessin").id)} target="_blank" rel="noopener noreferrer" style={{ color: ENCRE }}>dessin</a></> : null}</div>
                  ))}
                  <div style={{ color: TAUPE, marginTop: 4 }}>S'il sert, choisis-le comme lot consommé (« plan récupéré ») ci-dessous.</div>
                </div>
              );
            })()}

            {/* Consommations */}
            <div style={{ background: "#F7EEEA", borderRadius: 8, padding: 12, marginBottom: 12 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                <div style={{ fontSize: 11, color: ROUILLE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 }}>
                  Matière consommée (sort du stock)
                </div>
                <button type="button" className="sc-btn" onClick={addPlConso} style={movBtnStyle}>
                  + Ligne
                </button>
              </div>
              {plConsos.length === 0 && <div style={{ fontSize: 12, color: TAUPE }}>Aucune consommation déclarée.</div>}
              {plConsos.some((c) => pasConsommationLot((items || []).find((it) => it.id === c.lotId)) !== null) && (
                <div style={{ fontSize: 11, color: TAUPE, marginBottom: 8 }}>
                  Les tranches sortent du stock en entier. Article vendable au quart de tranche : indique aussi ce qui a réellement été consommé (ex. 1,75) — c'est ce qui compte dans le coût de revient du dossier ; la chute éventuelle se déclare ci-dessous.
                </div>
              )}
              {plConsos.map((c) => {
                const lot = (items || []).find((it) => it.id === c.lotId);
                return (
                  <div key={c.id} style={{ display: "flex", gap: 8, marginBottom: 8, alignItems: "flex-start" }}>
                    <select
                      className="sc-select"
                      value={c.lotId}
                      onChange={(e) => {
                        updatePlConso(c.id, "lotId", e.target.value);
                        if (plError) setPlError("");
                      }}
                      style={{ ...selectStyle, background: "#fff", flex: 2 }}
                    >
                      <option value="">— Lot consommé —</option>
                      {(items || [])
                        .filter((it) => it.id === c.lotId || lotAutorisePourPL(it, commandePLSelectionnee))
                        .map((it) => (
                          <option key={it.id} value={it.id}>
                            {libelleLot(it)}
                          </option>
                        ))}
                    </select>
                    <input
                      type="number"
                      step={pasConsommationLot(lot) !== null ? "1" : "0.01"}
                      className="sc-input"
                      value={c.quantite}
                      onChange={(e) => {
                        updatePlConso(c.id, "quantite", e.target.value);
                        if (plError) setPlError("");
                      }}
                      placeholder={pasConsommationLot(lot) !== null ? "Sorties" : "Qté"}
                      title={pasConsommationLot(lot) !== null ? "Tranches sorties du stock (entières)" : undefined}
                      style={{ ...inputStyle("100%"), background: "#fff", flex: 0.8 }}
                    />
                    <span style={{ fontSize: 11, color: TAUPE, paddingTop: 10, minWidth: 54 }}>{lot ? lot.unite : ""}</span>
                    {pasConsommationLot(lot) === 0.25 && (
                      <input
                        type="number"
                        step="0.25"
                        min="0.25"
                        className="sc-input"
                        value={c.consomme ?? ""}
                        onChange={(e) => {
                          updatePlConso(c.id, "consomme", e.target.value);
                          if (plError) setPlError("");
                        }}
                        placeholder={`Réellement consommé : ${c.quantite || "—"}`}
                        title="Réellement consommé, au quart de tranche (ex. 1,75) — sert au coût de revient du dossier. Vide : les tranches sorties."
                        style={{ ...inputStyle("100%"), background: "#fff", flex: 1.2 }}
                      />
                    )}
                    <button
                      type="button"
                      className="sc-btn"
                      onClick={() => removePlConso(c.id)}
                      style={{ ...iconBtnStyle, background: "transparent" }}
                      title="Retirer"
                    >
                      ✕
                    </button>
                  </div>
                );
              })}
            </div>

            {/* Chutes générées */}
            <div style={{ background: "#F5EFE0", borderRadius: 8, padding: 12, marginBottom: 12 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                <div style={{ fontSize: 11, color: OCRE, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 }}>
                  Chutes générées (entrent en stock)
                </div>
                <button type="button" className="sc-btn" onClick={addPlChute} style={movBtnStyle}>
                  + Chute
                </button>
              </div>
              {plChutes.length === 0 && <div style={{ fontSize: 12, color: TAUPE }}>Aucune chute générée.</div>}
              {plChutes.map((ch) => (
                <div key={ch.id} style={{ display: "flex", gap: 8, marginBottom: 8, alignItems: "center" }}>
                  <select
                    className="sc-select"
                    value={ch.lotSource}
                    onChange={(e) => updatePlChute(ch.id, "lotSource", e.target.value)}
                    style={{ ...selectStyle, background: "#fff", flex: 2 }}
                  >
                    <option value="">— Provient de… —</option>
                    {/* Step 11 (accord Nils du 21/09) : une chute ne peut
                        provenir que d'un lot déjà déclaré en "Matière
                        consommée" sur ce même PL — pas de n'importe quel lot
                        du stock. */}
                    {(items || [])
                      .filter((it) => it.id === ch.lotSource || (plConsos || []).some((c) => c.lotId === it.id))
                      .map((it) => (
                        <option key={it.id} value={it.id}>
                          {libelleLot(it)}
                        </option>
                      ))}
                  </select>
                  <input
                    className="sc-input"
                    value={ch.dimensions}
                    onChange={(e) => updatePlChute(ch.id, "dimensions", e.target.value)}
                    placeholder="Dimension, ex. 160 × 90 cm (obligatoire)"
                    style={{ ...inputStyle("100%"), background: "#fff", flex: 1.3 }}
                  />
                  <input
                    type="number"
                    step="1"
                    className="sc-input"
                    value={ch.quantite}
                    onChange={(e) => updatePlChute(ch.id, "quantite", e.target.value)}
                    style={{ ...inputStyle("100%"), background: "#fff", flex: 0.5 }}
                  />
                  <button
                    type="button"
                    className="sc-btn"
                    onClick={() => removePlChute(ch.id)}
                    style={{ ...iconBtnStyle, background: "transparent" }}
                    title="Retirer"
                  >
                    ✕
                  </button>
                </div>
              ))}
              {plChutes.length > 0 && (
                <div style={{ fontSize: 11, color: TAUPE, marginTop: 2 }}>
                  La chute hérite du produit, de la nuance et de l'épaisseur du lot d'origine. Seule sa dimension change.
                </div>
              )}
            </div>

            {plError && (
              <div style={{ background: "#F5E4DE", color: ROUILLE, fontSize: 13, fontWeight: 600, padding: "10px 12px", borderRadius: 6, marginBottom: 14 }}>
                {plError}
              </div>
            )}

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
              <button type="button" className="sc-btn" onClick={() => setShowPL(false)} style={ghostBtnStyle}>
                Annuler
              </button>
              <button type="button" className="sc-btn" onClick={submitPL} disabled={!!plExistant(plDoc)} style={{ ...primaryBtnStyle, ...(plExistant(plDoc) ? { opacity: 0.5, cursor: "not-allowed" } : {}) }}>
                Enregistrer le PL
              </button>
            </div>
          </div>
        </Overlay>
      )}

      {/* Formats : dimensions des tranches + épaisseurs */}
      {showFormatManager && (
        <Overlay onClose={() => setShowFormatManager(false)}>
          <div style={modalStyle(440)}>
            <div style={modalTitleStyle}>Formats</div>
            <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 16 }}>
              Dimensions standards des tranches et épaisseurs disponibles. Les chutes ne puisent pas dans cette liste : leur dimension se saisit librement.
            </div>

            <div style={{ display: "flex", gap: 14 }}>
              <div style={{ flex: 1.3 }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Dimensions</div>
                <div style={{ display: "flex", flexDirection: "column", gap: 6, maxHeight: 180, overflowY: "auto", marginBottom: 10 }}>
                  {(dimensionsList || []).map((d) => (
                    <div key={d} style={{ ...listItemStyle, padding: "6px 8px" }}>
                      <span style={{ fontSize: 13 }}>{d}</span>
                      <button type="button" className="sc-btn" onClick={() => removeDim(d)} style={{ ...iconBtnStyle, background: "transparent" }} title="Supprimer">
                        ✕
                      </button>
                    </div>
                  ))}
                  {(dimensionsList || []).length === 0 && <div style={{ fontSize: 12, color: TAUPE }}>Aucune dimension.</div>}
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  <input
                    className="sc-input"
                    value={newDim}
                    onChange={(e) => {
                      setNewDim(e.target.value);
                      if (formatError) setFormatError("");
                    }}
                    placeholder="ex. 340 × 165 cm"
                    style={{ ...inputStyle("100%"), flex: 1 }}
                  />
                  <button type="button" className="sc-btn" onClick={addDim} style={movBtnStyle}>
                    +
                  </button>
                </div>
              </div>

              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Épaisseurs</div>
                <div style={{ display: "flex", flexDirection: "column", gap: 6, maxHeight: 180, overflowY: "auto", marginBottom: 10 }}>
                  {(epaisseursList || []).map((ep) => (
                    <div key={ep} style={{ ...listItemStyle, padding: "6px 8px" }}>
                      <span style={{ fontSize: 13 }}>{ep}</span>
                      <button type="button" className="sc-btn" onClick={() => removeEp(ep)} style={{ ...iconBtnStyle, background: "transparent" }} title="Supprimer">
                        ✕
                      </button>
                    </div>
                  ))}
                  {(epaisseursList || []).length === 0 && <div style={{ fontSize: 12, color: TAUPE }}>Aucune épaisseur.</div>}
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  <input
                    className="sc-input"
                    value={newEp}
                    onChange={(e) => {
                      setNewEp(e.target.value);
                      if (formatError) setFormatError("");
                    }}
                    placeholder="ex. 8mm"
                    style={{ ...inputStyle("100%"), flex: 1 }}
                  />
                  <button type="button" className="sc-btn" onClick={addEp} style={movBtnStyle}>
                    +
                  </button>
                </div>
              </div>
            </div>

            {formatError && (
              <div style={{ background: "#F5E4DE", color: ROUILLE, fontSize: 13, fontWeight: 600, padding: "10px 12px", borderRadius: 6, marginTop: 14 }}>
                {formatError}
              </div>
            )}

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 18 }}>
              <button type="button" className="sc-btn" onClick={() => setShowFormatManager(false)} style={ghostBtnStyle}>
                Fermer
              </button>
            </div>
          </div>
        </Overlay>
      )}

      {/* Conditions de paiement (liste partagée fournisseurs / clients) */}
      {showPaiementManager && (
        <Overlay zIndex={110} onClose={() => setShowPaiementManager(false)}>
          <div style={modalStyle(400)}>
            <div style={modalTitleStyle}>Conditions de paiement</div>
            <div style={{ fontSize: 12, color: TAUPE, marginTop: -8, marginBottom: 16 }}>
              Liste commune aux fournisseurs et aux clients.
            </div>

            <div style={listBoxStyle}>
              {(paiements || []).map((p) => (
                <div key={p.label} style={{ ...listItemStyle, alignItems: "flex-start" }}>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>{p.label}</div>
                    <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: TAUPE, marginTop: 4 }}>
                      Délai (jours date de facture)
                      <input type="number" min="0" className="sc-input" key={`j-${p.label}-${p.jours}`} defaultValue={p.jours ?? (joursCondition(p.label) ?? "")} onBlur={(e) => { const v = e.target.value === "" ? "" : Number(e.target.value); if (v !== (p.jours ?? "")) persistPaiements((paiements || []).map((x) => (x.label === p.label ? { ...x, jours: v } : x))); }} style={{ ...inputStyle(70), padding: "2px 6px", fontSize: 11 }} />
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: TAUPE, marginTop: 4, cursor: "pointer" }}>
                      <input type="checkbox" checked={!!p.verifierAvantBL} onChange={() => toggleVerifierAvantBL(p.label)} />
                      Vérifier paiement avant création BL
                    </label>
                  </div>
                  <button
                    type="button"
                    className="sc-btn"
                    onClick={() => removePaiement(p.label)}
                    style={{ ...iconBtnStyle, background: "transparent" }}
                    title="Supprimer"
                  >
                    ✕
                  </button>
                </div>
              ))}
              {(paiements || []).length === 0 && (
                <div style={{ fontSize: 13, color: TAUPE, padding: 8 }}>Aucune condition pour l'instant.</div>
              )}
            </div>

            <div style={{ borderTop: `1px solid ${PIERRE}`, paddingTop: 16 }}>
              <Field label="Nouvelle condition">
                <input
                  className="sc-input"
                  value={newPaiement}
                  onChange={(e) => {
                    setNewPaiement(e.target.value);
                    if (paiementError) setPaiementError("");
                  }}
                  placeholder="ex. 60 jours date de facture"
                  style={inputStyle("100%")}
                />
              </Field>
              <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, cursor: "pointer", marginBottom: 14 }}>
                <input type="checkbox" checked={newPaiementVerifierAvantBL} onChange={(e) => setNewPaiementVerifierAvantBL(e.target.checked)} />
                Vérifier paiement avant création BL
                <span style={{ fontSize: 11, color: TAUPE }}>(bloque la transformation en BL tant que le paiement n'a pas été confirmé)</span>
              </label>
              {paiementError && <div style={errorTextStyle}>{paiementError}</div>}
              {paiementSuccess && <div style={successTextStyle}>✓ {paiementSuccess}</div>}
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                <button type="button" className="sc-btn" onClick={() => setShowPaiementManager(false)} style={ghostBtnStyle}>
                  Fermer
                </button>
                <button type="button" className="sc-btn" onClick={addPaiement} style={primaryBtnStyle}>
                  Enregistrer
                </button>
              </div>
            </div>
          </div>
        </Overlay>
      )}

      <div style={{ marginTop: 16, fontSize: 11, color: TAUPE }}>
        Données partagées avec toute l'équipe — chaque modification est visible par tous.
        <br />
        Chacun ne reçoit que les données autorisées pour son profil.
      </div>
      </div>
    </div>
  );
}

function Overlay({ children, onClose, zIndex }) {
  return (
    <div
      data-fenetre=""
      style={{ position: "fixed", inset: 0, background: "rgba(40,30,30,0.35)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: zIndex || 50 }}
      onClick={onClose}
    >
      <div onClick={(e) => e.stopPropagation()}>{children}</div>
    </div>
  );
}

function rowGridStyle(isHeader) {
  return {
    display: "grid",
    gridTemplateColumns: "6px 1.7fr 1fr 1.25fr 0.7fr 0.9fr 0.8fr 0.7fr 95px",
    padding: isHeader ? "12px 16px" : "13px 16px",
    alignItems: "center",
    borderBottom: `1px solid ${PIERRE}`,
    fontSize: isHeader ? 11 : 14,
    letterSpacing: isHeader ? 0.8 : "normal",
    textTransform: isHeader ? "uppercase" : "none",
    color: isHeader ? TAUPE : ENCRE,
  };
}

function modalStyle(width) {
  return {
    background: "#fff",
    borderRadius: 12,
    padding: 28,
    width,
    maxWidth: "90vw",
    maxHeight: "85vh",
    overflowY: "auto",
    boxShadow: "0 12px 40px rgba(40,30,30,0.25)",
  };
}

const modalTitleStyle = { fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, fontSize: 22, marginBottom: 16 };
const listBoxStyle = { display: "flex", flexDirection: "column", gap: 8, marginBottom: 18, maxHeight: 220, overflowY: "auto" };
const listItemStyle = { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 10px", borderRadius: 6, background: PIERRE };
const errorTextStyle = { fontSize: 12, color: ROUILLE, marginTop: -10, marginBottom: 16, fontWeight: 600 };
const successTextStyle = { fontSize: 12, color: VERT_OK, marginTop: -10, marginBottom: 16, fontWeight: 600 };
const linkBtnStyle = { background: "transparent", color: TAUPE, fontSize: 12, textDecoration: "underline", padding: "6px 4px" };
const ghostBtnStyle = { padding: "9px 16px", borderRadius: 6, background: "transparent", color: TAUPE, fontSize: 13 };
const primaryBtnStyle = { padding: "9px 18px", borderRadius: 6, background: ENCRE, color: PIERRE, fontSize: 13, fontWeight: 600 };

// Pastille de paiement : signal de risque réutilisable, à afficher à côté d'un
// nom de client partout où l'on engage matière ou production (résa, PL, sorties).
// Volontairement discrète, mais le rouge doit déclencher une vérification.
// Nils 03/10 : pastille des documents de remplacement (couleur réservée).
const VIOLET_REMPLACEMENT = "#7B5EA7";
function PastilleRemplacement() {
  return (
    <span title="Document de remplacement (reprend le numéro d'un document annulé)" style={{ display: "inline-flex", alignItems: "center", verticalAlign: "middle" }}>
      <span style={{ width: 9, height: 9, borderRadius: "50%", background: VIOLET_REMPLACEMENT, display: "inline-block", flexShrink: 0 }} />
    </span>
  );
}
function PastillePaiement({ niveau, avecTexte, toujoursAfficher }) {
  if (!niveau && !toujoursAfficher) return null; // non évalué : rien par défaut, pour ne pas surcharger
  const couleur = paiementFg(niveau);
  const fond = paiementBg(niveau);
  return (
    <span
      title={`Paiement : ${paiementLabel(niveau)}`}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        padding: avecTexte ? "1px 8px" : 0,
        borderRadius: 10,
        background: avecTexte ? fond : "transparent",
        verticalAlign: "middle",
      }}
    >
      <span style={{ width: 9, height: 9, borderRadius: "50%", background: couleur, display: "inline-block", flexShrink: 0 }} />
      {avecTexte && <span style={{ fontSize: 11, color: couleur, fontWeight: 600 }}>{paiementLabel(niveau)}</span>}
    </span>
  );
}

function BadgeSav() {
  return (
    <span title="Devis / dossier de SAV" style={{ fontSize: 10, padding: "2px 7px", borderRadius: 10, background: "#F5E4DE", color: "#9C4A2F", fontWeight: 600 }}>SAV</span>
  );
}

function BadgeExo({ exonere }) {
  if (!exonere) return null;
  return (
    <span
      title="Exonéré de TVA"
      style={{
        fontSize: 10,
        padding: "2px 7px",
        borderRadius: 10,
        background: "#EFEAE3",
        color: ENCRE,
        fontWeight: 700,
        letterSpacing: 0.4,
      }}
    >
      EXO
    </span>
  );
}

function KPI({ label, value, color }) {
  return (
    <div style={{ textAlign: "right" }}>
      <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 30, fontWeight: 600, color: color || ENCRE, lineHeight: 1 }}>{value}</div>
      <div style={{ fontSize: 11, color: TAUPE, textTransform: "uppercase", letterSpacing: 0.8, marginTop: 2 }}>{label}</div>
    </div>
  );
}

function FiltreChamp({ label, children }) {
  return (
    <div>
      <div style={{ fontSize: 11, color: TAUPE, marginBottom: 5, textTransform: "uppercase", letterSpacing: 0.5 }}>{label}</div>
      {children}
    </div>
  );
}

// Nils 03/10 (e) : prix des consommables (target price, prix d'achat) en HT et TTC
// côte à côte — on saisit l'un, l'autre est calculé (TVA 20 %). La valeur
// enregistrée reste le HT (4 décimales pour que le TTC saisi retombe juste).
const TVA_CONSO = 0.2;
function htVersTTC(ht) {
  const n = Number(ht);
  return ht === "" || ht === null || ht === undefined || !isFinite(n) ? null : Math.round(n * (1 + TVA_CONSO) * 100) / 100;
}
function formatHTTTC(ht) {
  const t = htVersTTC(ht);
  return t === null ? "—" : `${formatDH(ht)} HT · ${formatDH(t)} TTC`;
}
function ChampHTTTC({ ht, onChange, style, fond, placeholderHT, placeholderTTC }) {
  const [enCours, setEnCours] = React.useState(null); // { champ, texte } pendant la saisie
  const vide = ht === "" || ht === null || ht === undefined;
  const aff2 = (v) => (v === null || !isFinite(v) ? "" : String(Math.round(v * 100) / 100).replace(".", ","));
  const valHT = enCours && enCours.champ === "ht" ? enCours.texte : vide ? "" : aff2(Number(ht));
  const valTTC = enCours && enCours.champ === "ttc" ? enCours.texte : vide ? "" : aff2(htVersTTC(ht));
  const saisir = (champ, texte) => {
    setEnCours({ champ, texte });
    if (texte === "") { onChange(""); return; }
    const n = Number(String(texte).replace(/\s/g, "").replace(",", "."));
    if (!isFinite(n) || n < 0) return;
    onChange(champ === "ht" ? String(n) : String(Math.round((n / (1 + TVA_CONSO)) * 10000) / 10000));
  };
  const st = { ...inputStyle("100%"), ...(fond ? { background: fond } : {}), paddingRight: 34 };
  const suffixe = { position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", fontSize: 11, color: TAUPE, pointerEvents: "none" };
  return (
    <div style={{ display: "flex", gap: 6, ...style }}>
      <div style={{ position: "relative", flex: 1 }}>
        <input inputMode="decimal" className="sc-input" aria-label="HT" value={valHT} onFocus={() => setEnCours({ champ: "ht", texte: valHT })} onBlur={() => setEnCours(null)} onChange={(e) => saisir("ht", e.target.value)} placeholder={placeholderHT || "HT"} style={st} />
        <span style={suffixe}>HT</span>
      </div>
      <div style={{ position: "relative", flex: 1 }}>
        <input inputMode="decimal" className="sc-input" aria-label="TTC" value={valTTC} onFocus={() => setEnCours({ champ: "ttc", texte: valTTC })} onBlur={() => setEnCours(null)} onChange={(e) => saisir("ttc", e.target.value)} placeholder={placeholderTTC || "TTC"} style={st} />
        <span style={suffixe}>TTC</span>
      </div>
    </div>
  );
}

function Field({ label, children, style }) {
  return (
    <div style={{ marginBottom: 14, ...style }}>
      <div style={{ fontSize: 11, color: TAUPE, marginBottom: 5, textTransform: "uppercase", letterSpacing: 0.5 }}>{label}</div>
      {children}
    </div>
  );
}

function inputStyle(width) {
  return { width, padding: "9px 12px", borderRadius: 6, border: `1px solid ${PIERRE}`, background: PIERRE, fontSize: 14, color: ENCRE };
}

const selectStyle = { padding: "9px 10px", borderRadius: 6, border: `1px solid ${PIERRE}`, background: PIERRE, fontSize: 13, color: ENCRE, width: "100%" };
const movBtnStyle = { padding: "3px 7px", borderRadius: 5, background: PIERRE, color: ENCRE, fontSize: 10, fontWeight: 600 };
const tagStyle = { fontSize: 11, padding: "2px 8px", borderRadius: 4, whiteSpace: "nowrap" };

function noteLettreBg(l) {
  if (l === "A") return "#E4EBE4";
  if (l === "B") return "#F5EFE0";
  if (l === "C") return "#F5E4DE";
  return "#F5E4DE"; // "–" non évalué : rouge, pour attirer l'attention
}
function noteLettreFg(l) {
  if (l === "A") return VERT_OK;
  if (l === "B") return OCRE;
  if (l === "C") return ROUILLE;
  return ROUILLE; // "–" non évalué : rouge
}
function paiementBg(p) {
  if (p === "bon") return "#E4EBE4";
  if (p === "lent") return "#F5EFE0";
  if (p === "mauvais") return "#F5E4DE";
  return "#F5E4DE"; // non évalué : rouge, pour attirer l'attention
}
function paiementFg(p) {
  if (p === "bon") return VERT_OK;
  if (p === "lent") return OCRE;
  if (p === "mauvais") return ROUILLE;
  return ROUILLE; // non évalué : rouge
}
function paiementLabel(p) {
  const n = PAIEMENTS_NIVEAUX.find((x) => x.cle === (p || ""));
  return n ? n.label : "Non évalué";
}

function fiabiliteBg(f) {
  if (f === "bonne") return "#E4EBE4";
  if (f === "moyenne") return "#F5EFE0";
  return "#F5E4DE";
}
function fiabiliteFg(f) {
  if (f === "bonne") return VERT_OK;
  if (f === "moyenne") return OCRE;
  return ROUILLE;
}
const iconBtnStyle = { width: 26, height: 26, borderRadius: 5, background: "transparent", color: TAUPE, fontSize: 13 };

export default ERP;

// Fonctions de calcul exposées aux tests métier (tests/metier.test.js).
export {
  LOGO_SRC,
  DEFAULT_COMPTES, DEFAULT_PROFILS, P_GERANT, P_COM, P_PROD,
  construireUtilisateur, calcLigne, calcTotaux, surfaceM2, dimensionCourte,
  calculerNomenclatureTranche, appliquerFinitions, epaisseurDecimaleDesignation, formatDH,
  lundiDe, decalerJours, semestreDe, semestrePrecedent, moisDecale, finDeMois, sansZeroTete,
};
